export const USA_Substations = [
    [ "Snowden River Substation",[-76.81648126805369, 39.17466704792963]],
    [ "Vienna Substation",[-75.82299462235386, 38.48733098217126]],
    [ "Des Moines Water Works",[-93.64627845466684, 41.578945947391624]],
    [ "Bennett Substation",[-81.33492931917564, 28.55678989108185]],
    [ "Studio Substation",[-81.56031616604596, 28.361140627684044]],
    [ "Epcot Central Energy Plant",[-81.54376971886761, 28.373389506740818]],
    [ "Blacksburg Substation",[-80.42169002812537, 37.23263037751471]],
    [ "Imperial Irrigation District",[-116.23925087104998, 33.630407169874154]],
    [ "Imperial Irrigation District",[-116.21723697082984, 33.68458906101946]],
    [ "Coachella City Substation",[-116.1724097752455, 33.676403363436684]],
    [ "Coachella Valley Substation",[-116.11554031383827, 33.67283513575594]],
    [ "Thermal Substation",[-116.13629583708688, 33.63868127029153]],
    [ "52nd Avenue Substation",[-116.15719757519666, 33.66993960033139]],
    [ "K Street Substation",[-71.0384842817358, 42.33966459846714]],
    [ "5895967",[-81.66267933949742, 35.7208973469885]],
    [ "6058359",[-81.69294685267604, 35.72013308171579]],
    [ "6553870",[-101.32553233355463, 48.41077025034111]],
    [ "6619015",[-116.18900002862294, 43.54747069430716]],
    [ "Eiland Substation",[-101.48220765370073, 31.995057642907717]],
    [ "Middlebury Substation",[-73.1336633492276, 44.01428684448475]],
    [ "6814232",[-81.19305352466154, 28.611078675666906]],
    [ "Vicksburg Substation",[-101.91826406011535, 33.567475469700284]],
    [ "San Diego Gas & Electric",[-117.12007481063449, 32.681507868323465]],
    [ "Rinaldi Receiving Station",[-118.47854107503855, 34.28053008421016]],
    [ "Riverhead Substation",[-72.6883229372121, 40.91168437551315]],
    [ "V. B. Shaw Substation",[-95.28561473258563, 32.74192855465499]],
    [ "Victory Way Substation",[-81.55443285893168, 28.350112471518592]],
    [ "Timken Richville Substation",[-81.43442881930324, 40.758061578898385]],
    [ "Ledbeder Substation",[-119.34861286759909, 46.27164265089193]],
    [ "Hummelstown Substation",[-76.72375652436735, 40.25948508774083]],
    [ "Quarry Substation",[-94.27435975506945, 45.54282326662313]],
    [ "Alexandria Switching Substation",[-95.40566894972099, 45.847433210335176]],
    [ "Cannon Falls Substation",[-92.9393986409276, 44.51230253085383]],
    [ "Barnegat Substation",[-73.93720027216206, 41.64872210119335]],
    [ "Snyder Substation",[-119.29387606795622, 46.31533541365427]],
    [ "La Cienega Substation",[-118.37845406435174, 34.00068803299285]],
    [ "Lafayette Substation",[-71.49542045945863, 41.58202884646352]],
    [ "Picketville Substation JEA",[-81.751368, 30.380403049999998]],
    [ "Northside Substation",[-77.36152484302195, 35.65127272671581]],
    [ "Live Oak Substation",[-87.10946393656086, 30.383066958101924]],
    [ "12804757",[-119.77694564793305, 46.20510948901931]],
    [ "Chuckatuck Substation",[-76.58658419345987, 36.89569805426525]],
    [ "13182845",[-78.81266419935487, 36.06383939497507]],
    [ "13294680",[-79.01597359041908, 36.04324647641487]],
    [ "Eno Substation",[-79.01645421925767, 36.04458400558042]],
    [ "13324732",[-78.94337560024405, 36.124712267005144]],
    [ "13328561",[-78.98693690373837, 36.164161203367094]],
    [ "Northwest Jax Substation",[-81.68529380745308, 30.367681395488063]],
    [ "Soutel Dr Substation JEA",[-81.71454398658021, 30.404666644071842]],
    [ "Jacksonville Electric Authority",[-81.65900700300358, 30.371048727207466]],
    [ "Garden City Substation JEA",[-81.69832907692272, 30.454402618389647]],
    [ "Elza Substation",[-84.25836037632935, 36.00104497973533]],
    [ "Douglas Dam Substation",[-83.53973606271589, 35.96263323475036]],
    [ "Strawberry Plains Substation",[-83.68100144963142, 36.062306181671076]],
    [ "Dinsmore Substation",[-81.7753053015869, 30.453925018643947]],
    [ "Kearny Substation",[-117.13400118307162, 32.83308762185578]],
    [ "Powell Substation",[-84.0311273042441, 36.018042352842706]],
    [ "Rockford Substation",[-83.95314037709242, 35.830785171815194]],
    [ "Hardin Valley Substation",[-84.16016435938863, 35.94896838542855]],
    [ "West Hills Substation",[-84.02829707583734, 35.944112319659155]],
    [ "Sea Breeze Substation",[-81.65860378472846, 30.494817792426375]],
    [ "Lincoln Electric System",[-96.66439438907891, 40.76494452854603]],
    [ "Delaware Substation",[-85.40762554998985, 40.23804592987702]],
    [ "14046352",[-117.35353391686898, 34.102033489506695]],
    [ "West Warsaw",[-85.88667904519129, 41.23799460419947]],
    [ "14229354",[-84.00194419690979, 35.75294615275511]],
    [ "Gardner Park Substation",[-89.65609944999999, 44.84721509999999]],
    [ "Boundary Substation",[-117.35800722584571, 48.98118623857434]],
    [ "Westchase Substation",[-95.55873280331028, 29.718754077259508]],
    [ "Georgia Substation",[-81.63982568106456, 30.329169475147093]],
    [ "Bells Mill Substation",[-77.14525524866174, 39.03165271219501]],
    [ "Jacksonville Electric Authority",[-81.65207949355806, 30.357376892625968]],
    [ "McGhee Tyson Subtation",[-84.01561934851614, 35.79676906785153]],
    [ "14595317",[-88.26327986226389, 39.812919224127484]],
    [ "Blueridge Substation",[-95.49681232530705, 29.628629472332506]],
    [ "Elk Meadows Substation",[-112.38173737273888, 38.322758655027194]],
    [ "Hills Substation",[-91.5357255012048, 41.57072704876152]],
    [ "14978981",[-100.90507861141296, 37.07537417558783]],
    [ "Overton Power District Number 5",[-114.11733879717522, 36.8209634032658]],
    [ "15533690",[-87.69369197121789, 39.61480973948485]],
    [ "15534061",[-87.68500662569879, 39.61669959547204]],
    [ "Kelso Substation",[-121.60320633004252, 37.797426250786714]],
    [ "Curtisville Substation",[-71.49523174081948, 43.232538669568804]],
    [ "Kansas West Substation",[-87.9713692358808, 39.54438771643293]],
    [ "15999386",[-87.97427984601694, 39.54454102471403]],
    [ "Orchard Substation",[-104.79232080968106, 39.60930391369195]],
    [ "Capac Substation",[-82.93238586423968, 43.010830372918434]],
    [ "American Electric Power",[-86.30104193683553, 41.660916095952466]],
    [ "16143384",[-111.78416229392361, 41.76714451423447]],
    [ "16225032",[-111.93716537090388, 40.429409521025555]],
    [ "Station 104",[-77.76054880751923, 43.10055845135245]],
    [ "Station 82",[-77.64724947711605, 43.09915227615295]],
    [ "Mortimer Station",[-77.64847485956953, 43.09817201170923]],
    [ "North Cape Substation",[-80.58347367256775, 28.496008627147933]],
    [ "17056793",[-77.04665097906496, 40.22907536118045]],
    [ "Duke Substation",[-76.71789869958971, 40.26752884408427]],
    [ "West Hershey Substation",[-76.67306207375951, 40.27536790225365]],
    [ "Reese Substation",[-76.67237322005404, 40.275776689127675]],
    [ "17243500",[-86.67943923521736, 40.59649380372022]],
    [ "Liberty Street Substation",[-74.74263994772475, 40.202756681597926]],
    [ "Station 722",[-77.6671468609862, 43.12787819525657]],
    [ "Station 102",[-77.63399368289743, 43.26319585678261]],
    [ "Station 421",[-77.69235195139856, 43.2056596415458]],
    [ "Station 40",[-77.5658757830609, 43.20188712007132]],
    [ "Station 36",[-77.61095595815658, 43.25353130935246]],
    [ "Station 38",[-77.60017610657363, 43.15796857240276]],
    [ "Station 41",[-77.56791573918113, 43.12880434246103]],
    [ "Station 49",[-77.57530079443235, 43.17816561242211]],
    [ "Station 53",[-77.52077639848005, 43.07418478739604]],
    [ "Station 62",[-77.48801371979066, 43.11774862872281]],
    [ "Station 66",[-77.61529108708767, 43.1086101212734]],
    [ "Station 68",[-77.59993836305043, 43.20986826719484]],
    [ "Station 72",[-77.64603935860049, 43.24165627680454]],
    [ "Station 81",[-77.57634912542831, 43.19826247521179]],
    [ "Station 153",[-77.26664397407376, 42.89529788298514]],
    [ "Bristol Mountain",[-77.40434094604443, 42.74663902051894]],
    [ "17390859",[-78.06796146876346, 42.502515673463314]],
    [ "North Lakeville Station",[-77.71630651889465, 42.83872619210309]],
    [ "Sonora Way Station",[-77.71641066390552, 42.83900461757564]],
    [ "Station 178",[-78.14732436244323, 42.19513978141183]],
    [ "Nile Station",[-78.14733136768739, 42.194732558127384]],
    [ "Station 779",[-76.98533398270109, 43.20404845614752]],
    [ "Station 207",[-77.18745062944792, 43.22328925754818]],
    [ "Station 420",[-77.51046391757977, 43.11724174930511]],
    [ "Lemaster Substation",[-82.18201148785484, 39.38146896894347]],
    [ "Harris Lake",[-74.18569140263907, 43.97210375618434]],
    [ "Moshier",[-75.1360466991411, 43.87194861995268]],
    [ "Brookfield Renewable US",[-75.05936948430306, 44.21104120683839]],
    [ "Five Falls",[-74.84903733841698, 44.52723278024134]],
    [ "South Colton",[-74.88241525103881, 44.51327064819866]],
    [ "Rainbow",[-74.82257006561517, 44.51788683786731]],
    [ "Tupper Lake Station",[-74.46130761867401, 44.23575183422629]],
    [ "Union Falls Station",[-73.91305636518597, 44.5104527274622]],
    [ "Union",[-73.91297061459957, 44.51058565123534]],
    [ "17758748",[-110.2604687484741, 47.60040246625262]],
    [ "17764225",[-109.88976392479194, 48.2950399953463]],
    [ "Kents Falls",[-73.59617132565484, 44.70375460480748]],
    [ "Saranac",[-73.59544846946574, 44.70310905538208]],
    [ "17809063",[-109.78904005000001, 48.260327350000004]],
    [ "Vista Substation",[-119.23069645956775, 46.22886228121344]],
    [ "Climax Manufacturing Company",[-75.61892825994508, 43.97864552879683]],
    [ "18000243",[-75.77156178625066, 44.03615335311983]],
    [ "Lighthouse Hill Station",[-75.97153339077418, 43.52329217242525]],
    [ "East Pulaski Station",[-76.10396843622327, 43.54661103988333]],
    [ "Nine Mile Point #2",[-76.40805915951942, 43.520645769505045]],
    [ "Raymour & Flanigan",[-76.20202750000001, 43.1228566]],
    [ "Ohio Substation",[-87.63887074670255, 41.89209000563341]],
    [ "Crosby Substation",[-87.64622370817938, 41.90230209586445]],
    [ "Dewitt Station",[-76.04338164491239, 43.0478727164678]],
    [ "Carr Street Station",[-76.08209425197792, 43.06078220069342]],
    [ "18080765",[-113.42385398983215, 37.150013788751444]],
    [ "Madbush-38 Substation",[-72.87912689196492, 44.15398826708245]],
    [ "Brighton Avenue Station",[-76.13770700035089, 43.01628686407518]],
    [ "18211098",[-76.52281283438772, 43.429287572901686]],
    [ "18215900",[-76.16050763577493, 43.08863357740021]],
    [ "18239479",[-76.10080248015869, 43.0860922223986]],
    [ "18239481",[-76.09925671820787, 43.08476771319422]],
    [ "18241189",[-74.8730268526973, 43.0323226257969]],
    [ "Ames Substation",[-122.06714307280922, 37.41787030975397]],
    [ "Selma Substation",[-87.06803779046066, 32.422428310633585]],
    [ "7731825",[-86.79994391464325, 33.49967528572887]],
    [ "Bremen Primary Substation",[-85.14250701223975, 33.70909736973074]],
    [ "Siegfried Substation",[-75.518120242972, 40.71312784894455]],
    [ "9820217",[-104.37576641108092, 48.15857230741654]],
    [ "Pickstown Substation",[-98.53437643489181, 43.07167612986336]],
    [ "Tyndall Substation",[-97.8904017976429, 43.00348147756373]],
    [ "9848985",[-96.88589717321128, 42.90218595443164]],
    [ "9861863",[-102.04322285, 45.0017163]],
    [ "Rushville Substation",[-102.46503749586697, 42.722552348907406]],
    [ "Arlington Substation",[-97.01710973410225, 44.49969913740657]],
    [ "Western Area Power Administration",[-103.19442404201467, 44.228229804497275]],
    [ "9906807",[-103.08792184305469, 44.15531487494255]],
    [ "Wall Substation",[-102.22744817506093, 44.082790740091454]],
    [ "West River Electric Cooperative",[-103.23064539798155, 44.22839104356402]],
    [ "Midland Substation",[-101.13467390609259, 44.082376971597434]],
    [ "West River Electric Association",[-103.07012494745163, 44.02322951947105]],
    [ "9919316",[-98.3284264481504, 44.907579826840724]],
    [ "Scull Substation",[-74.64864075441845, 39.3232731180064]],
    [ "11775318",[-96.68943779916813, 44.291800544107616]],
    [ "Aurora Substation",[-96.65714199805278, 44.296010022897846]],
    [ "12330415",[-80.05238689732973, 34.37217308862243]],
    [ "Rouse Substation",[-94.68466397108176, 37.44063140271692]],
    [ "Marathon Pipe Line LLC",[-89.81289065000001, 34.4648639]],
    [ "Harmony Substation",[-100.51526077709596, 42.95394584984532]],
    [ "14073872",[-96.50690975642063, 41.465108858036714]],
    [ "14108444",[-97.65472674787972, 41.29825495119524]],
    [ "14197241",[-96.60183465382151, 41.22619437660771]],
    [ "San Ysidro",[-106.78986334999998, 35.52027530000001]],
    [ "14702837",[-95.51490697610892, 34.015200573248855]],
    [ "Luling Magnolia Substation",[-97.72564492829174, 29.72101924435148]],
    [ "Freestone Tap",[-96.24170605, 31.549172249999994]],
    [ "Waelder Substation",[-97.30089575000001, 29.678983299999995]],
    [ "Darst Creek Substation",[-97.77847233899419, 29.585052369471743]],
    [ "Galena Park Substation",[-95.23090119235788, 29.745797730220126]],
    [ "Drouet Substation",[-95.28300028936242, 29.667136636635608]],
    [ "Camp Wood Substation",[-100.02259418247127, 29.66420921268693]],
    [ "Utopia Substation",[-99.52178102623847, 29.64620577286048]],
    [ "Leakey Substation",[-99.76190872593115, 29.681075409697954]],
    [ "Tarpley Substation",[-99.2747117022381, 29.66530763588344]],
    [ "15578851",[-82.05818484338269, 37.78128342208005]],
    [ "15681485",[-105.58888387251481, 41.336052107772154]],
    [ "15682023",[-105.76567055, 41.48429865]],
    [ "15690418",[-106.22119186039866, 41.8989967241122]],
    [ "15701946",[-106.22116864999998, 41.89760885]],
    [ "15719720",[-104.37369931609385, 42.11145416464427]],
    [ "Sibley Substation",[-95.75009684897908, 43.396594417035324]],
    [ "17073904",[-102.2408967, 39.56863265]],
    [ "17074258",[-102.24024976373016, 39.50201465858107]],
    [ "Akron Substation",[-103.2108895903889, 40.14735235940852]],
    [ "Otis Substation",[-102.88977372398507, 40.14848171164641]],
    [ "17153448",[-102.54749134626347, 40.13239159724679]],
    [ "17155182",[-102.2611925009744, 39.93496862386687]],
    [ "Cromwell Substation",[-92.88761, 46.588349550000004]],
    [ "18107233",[-92.74435431943884, 47.0588808872236]],
    [ "18137932",[-91.7038470466812, 47.02493108561173]],
    [ "18235773",[-92.93909595110202, 46.9390689539511]],
    [ "Woonsocket Substation",[-71.52288313508747, 41.97949664517886]],
    [ "Olsen Substation",[-97.56434561594405, 31.776698910914615]],
    [ "Wellington Substation",[-100.21129095, 34.8632709]],
    [ "Shamrock Substation",[-100.20963284999999, 34.853864]],
    [ "Friend Ranch Substation",[-101.14313753583677, 30.70803951346657]],
    [ "Jim Payne Substation",[-102.03998118030168, 32.65406531526579]],
    [ "Fort Lancaster",[-101.77866986213517, 30.663535633439594]],
    [ "Rosita Creek Substation",[-100.40516968016566, 28.69915842120041]],
    [ "Cotulla Substation",[-99.2549959, 28.4481734]],
    [ "Big Wells Substation",[-99.53584105749586, 28.56531900237188]],
    [ "W. A. Parish Station (345 kV)",[-95.62411850977175, 29.480796836581952]],
    [ "Paint Creek Substation",[-99.58066833882826, 33.08004815590608]],
    [ "Chalk Substation",[-101.27643269332764, 32.11123070714153]],
    [ "Runge Substation",[-97.70154374999998, 28.87065485]],
    [ "Nixon Substation",[-97.74079034484755, 29.30813659303573]],
    [ "Holcomb Substation",[-99.36163497066146, 28.03325455561963]],
    [ "Cotulla Substation",[-99.25125488673393, 28.460819451707273]],
    [ "Eagle Hydro Substation",[-100.55205563518113, 28.829748180108687]],
    [ "Eagle Pass Substation",[-100.49041552418531, 28.71604168602675]],
    [ "Conoco-Chittam Ranch Substation",[-100.19722925759771, 28.696427724903263]],
    [ "Escondido Substation",[-100.47445252510636, 28.728473857075333]],
    [ "Maverick Substation",[-100.5505902164685, 28.866760933153998]],
    [ "Wildorado Substation",[-102.20284444193456, 35.21089227502354]],
    [ "Sterling City Substation",[-101.01120143869429, 31.839814286073274]],
    [ "Parker Ranch Substation",[-101.53556365, 30.55341235]],
    [ "Encinal Substation",[-99.35744783645758, 28.046645201163948]],
    [ "La Quinta Substation",[-99.0066386, 27.487472050000004]],
    [ "Zapata Substation",[-99.23374740754761, 26.9328372973962]],
    [ "Mustang Substation",[-102.37044799672837, 32.45299413727345]],
    [ "Avondale Substation",[-94.54925114588363, 39.15115722651819]],
    [ "Metcalf Substation",[-121.74416849832198, 37.22557345292798]],
    [ "Edenvale",[-121.79588243306543, 37.24467002922386]],
    [ "Tesla Substation",[-121.56501849772478, 37.71217996300712]],
    [ "Tesla Substation",[-121.56690893383153, 37.715485989251356]],
    [ "Los Banos Substation",[-121.02076945624837, 37.053259708682745]],
    [ "Bunker Lake Substation",[-93.30696090310688, 45.220872262076746]],
    [ "Coon Creek Substation",[-93.28461407970497, 45.137328873902526]],
    [ "24038625",[-93.31500243401926, 45.14151329831347]],
    [ "Tracy Substation",[-121.58022039998158, 37.79782899497857]],
    [ "Birds Landing Substation",[-121.83015474611152, 38.12470529758864]],
    [ "24064449",[-121.8291623, 38.12348899999999]],
    [ "Eight Mile Substation",[-121.37684419351292, 38.058752951729595]],
    [ "San Jose Substation B",[-121.90152606698985, 37.34094373329507]],
    [ "24263002",[-121.66093161113412, 37.821211742400195]],
    [ "Livermore Substation",[-121.69518967121996, 37.69343462377532]],
    [ "San Mateo Substation",[-122.31897228570557, 37.58281239348959]],
    [ "Sneath Lane Substation",[-122.44671172432307, 37.62197655532521]],
    [ "Midway Substation",[-119.4523397289221, 35.403147495911625]],
    [ "Cortina Substation",[-122.22333152781914, 39.12062585584424]],
    [ "24396970",[-121.73474648694226, 36.76312658150844]],
    [ "Salinas Substation",[-121.65142685228936, 36.68198072577335]],
    [ "Green Valley Substation",[-121.76039446205017, 36.95206194687016]],
    [ "24400771",[-117.5542116181923, 33.3696976290677]],
    [ "Diablo Canyon",[-120.84730395767848, 35.216257551078]],
    [ "Diablo Canyon",[-120.85127318346451, 35.21602000262316]],
    [ "Concordia Substation",[-97.69440273065197, 39.574456993130354]],
    [ "Millbrae Substation",[-122.39151313838912, 37.605627427080464]],
    [ "Ralston Substation",[-122.34016155235244, 37.51132912910394]],
    [ "ComEd Devon 138kV Substation",[-87.73908798719879, 41.99936635975322]],
    [ "ComEd Skokie 345kV Substation",[-87.75650314639985, 42.05030997985927]],
    [ "ComEd Skokie 138kV Substation",[-87.75472574886734, 42.05015730137724]],
    [ "ComEd Elmwood Substation",[-87.7651462927214, 42.08188496156002]],
    [ "ComEd Golf Mill 138kV-345kV Substation",[-87.83271105635566, 42.05593935179433]],
    [ "ComEd Niles 138kV Substation",[-87.775977498204, 42.02190712236379]],
    [ "ComEd Skokie Substation",[-87.71377460344732, 42.02349873603382]],
    [ "25037288",[-84.27211140919091, 39.33687815699093]],
    [ "25052353",[-88.76750203402985, 30.417388339025823]],
    [ "Range Line SW",[-87.94615940209852, 43.131721312001055]],
    [ "Sidney Term",[-87.9444719567729, 43.12485344505749]],
    [ "Cornell-Milwaukee",[-87.93621008659372, 43.09861370918208]],
    [ "FireBsntz",[-87.93643859560622, 43.092009033215454]],
    [ "Fontainebleau Substation",[-88.69820255940716, 30.39827761447161]],
    [ "Glendale",[-87.92008706689015, 43.11755880481787]],
    [ "Peñasquitos Substation",[-117.21914022647138, 32.91803376602837]],
    [ "Estero Substation",[-81.83396995051093, 26.442473874019132]],
    [ "Washington Street Substation",[-82.45365316297855, 27.947876203699476]],
    [ "Singing River Electric Cooperative",[-88.77773410748131, 30.414124208350852]],
    [ "25720675",[-117.0161993571998, 32.63785224830576]],
    [ "Proctor Valley Substation",[-116.98675408636325, 32.66500955665508]],
    [ "Ravenswood Substation",[-122.1379646342491, 37.49296200700799]],
    [ "East Grand Substation",[-122.40309124637072, 37.653414278233484]],
    [ "Bay Side Plant Substation",[-82.40878327113366, 27.908376516726047]],
    [ "Harbour Island Substation",[-82.4495087823967, 27.9352358436683]],
    [ "Arkansas Nuclear One Substation",[-93.22740144952971, 35.31131502300607]],
    [ "ComEd Tonne 138kV Substation",[-87.97763498644008, 41.9960761994745]],
    [ "Beaver Valley Substation",[-80.43165241205631, 40.620464723563614]],
    [ "ComEd Busse 138kV Substation",[-87.96215480289693, 42.037601244553194]],
    [ "26206319",[-88.22537889617222, 41.24474898442251]],
    [ "Brunswick Substation",[-78.01105058192614, 33.959704439625]],
    [ "ComEd Des Plaines 138kV-345kV Substation",[-87.89690885991585, 42.0505405234247]],
    [ "North City West Substation",[-117.22071408523567, 32.958747341862136]],
    [ "26587777",[-117.33254925419837, 33.137279721687634]],
    [ "Peach Bottom North Substation",[-76.27826137125541, 39.76133492737599]],
    [ "26787794",[-122.4035141171755, 37.62626188404349]],
    [ "Sioux City Substation",[-96.30626481807178, 42.60298511725146]],
    [ "Western Area Power Administration",[-96.30505091268685, 42.6003162466762]],
    [ "Raun Substation",[-96.36550818246336, 42.329366463764885]],
    [ "Pacific Gas and Electric Company",[-122.36330884154897, 37.589969629298615]],
    [ "Southern California Edison",[-118.10023064829826, 33.771939729102485]],
    [ "Moorpark Substation",[-118.9030067027977, 34.280924780772764]],
    [ "Florida Avenue Substation",[-82.45913593391403, 27.957858546787403]],
    [ "27500831",[-115.27623061045819, 36.115356157809444]],
    [ "Decatur substation",[-115.21343584685067, 36.11400058641735]],
    [ "Lucas Substation (electricity)",[-118.12049440000001, 33.842326199999995]],
    [ "27620991",[-115.27924949745957, 36.18659898037761]],
    [ "27631478",[-115.25193648402332, 36.199306742304756]],
    [ "Port Union Substation",[-84.44937740484518, 39.32752640818665]],
    [ "Duke Energy",[-84.43728240632932, 39.24390704144163]],
    [ "27668230",[-84.32574125713134, 39.275300581451106]],
    [ "Jefferson Substation",[-122.28620014823865, 37.45714771893839]],
    [ "Warm Springs Substation",[-115.04253997392834, 36.05324088532178]],
    [ "27738392",[-115.08155173984147, 36.06893217038753]],
    [ "Central Tie Substation",[-82.7918495076774, 34.71445196744266]],
    [ "27786664",[-115.08614121807302, 36.085064754342056]],
    [ "Tennessee Valley Authority",[-86.3986404076043, 36.31455081563544]],
    [ "27831034",[-115.21342552897889, 36.09063910408892]],
    [ "Woodside Substation",[-122.24216359129876, 37.437067231958025]],
    [ "27886952",[-115.31292303864868, 36.08646786022145]],
    [ "Monta Vista Substation",[-122.07559595622482, 37.32626512658826]],
    [ "Monta Vista Substation (lower yard)",[-122.07320958155482, 37.323960311418396]],
    [ "Foster Substation",[-84.24944143625845, 39.30601754073679]],
    [ "Duke Energy",[-84.3199784672952, 39.22767759318333]],
    [ "Greene Substation",[-84.00154348929227, 39.70862419743223]],
    [ "Stuart Substation",[-83.69248221817638, 38.63942967776515]],
    [ "Timberlane Substation",[-94.80751883624085, 38.89852048313974]],
    [ "Northwest Substation",[-87.69701918888741, 41.945119186023106]],
    [ "28161833",[-84.47776955729786, 39.20494799370488]],
    [ "West Levee Substation",[-96.82598888045472, 32.77763395035196]],
    [ "East Levee Substation",[-96.819714230811, 32.783923017979724]],
    [ "800/900 Network Substation",[-96.81370712082253, 32.787167136679855]],
    [ "28174717",[-97.02539784297377, 32.814789949893886]],
    [ "28265124",[-78.92289899293782, 36.01108279369194]],
    [ "28267083",[-97.21667424808228, 32.72819773318115]],
    [ "Rocky Run Substation",[-89.60527317095674, 44.50007871719166]],
    [ "Whiting Ave",[-89.57218682573532, 44.49607000334192]],
    [ "28358003",[-84.40517158346375, 39.152859342309974]],
    [ "Newtown Substation",[-84.36648329313941, 39.11791437668846]],
    [ "28358513",[-84.37670026486241, 39.02503466214787]],
    [ "28396412",[-84.26959816370479, 39.18096864036]],
    [ "Pierce Substation",[-84.290766758743, 38.990419097379466]],
    [ "Lick Substation",[-82.60918109666999, 39.0437284030717]],
    [ "28469952",[-96.65324947222918, 32.85750525062465]],
    [ "28476204",[-82.81002488975773, 34.691242201927366]],
    [ "ComEd Evanston 138kV Substation",[-87.69593405103495, 42.05113082199575]],
    [ "ComEd Happ Substation",[-87.76676215367279, 42.087366469032176]],
    [ "ComEd Northbrook 138kV-345kV Substation",[-87.78568962030144, 42.12673702941273]],
    [ "Highland Park Substation",[-87.82529281329005, 42.18736541629768]],
    [ "Hurley Substation",[-121.41799644785213, 38.58728588521017]],
    [ "Ameren",[-90.29384395767512, 38.914937534723826]],
    [ "Cahokia Substation",[-90.1786883905534, 38.6002496717229]],
    [ "Northwest Carrollton Substation",[-96.9385021721852, 32.984461406083405]],
    [ "SRP Browning Substation",[-111.59777372901303, 33.35541327655393]],
    [ "28831425",[-78.9021721096155, 36.008279501970506]],
    [ "Newark Substation",[-121.98661930520196, 37.50090466464664]],
    [ "Newark Substation",[-121.98156050406227, 37.50276671976314]],
    [ "28893616",[-82.6976606, 34.678299]],
    [ "28893750",[-82.78821412327305, 34.71681594931973]],
    [ "Duke University",[-78.94542475873838, 36.004615029913026]],
    [ "29054076",[-112.00151112713283, 41.159919951090075]],
    [ "Dickinson Station",[-93.81009805988447, 45.11073444780307]],
    [ "Whitestone Substation",[-97.83049723894625, 30.52005674935265]],
    [ "Santiago Substation",[-117.76847903564948, 33.66481484206262]],
    [ "Gannon Substation",[-82.44020543446138, 27.938039487676466]],
    [ "University Substation",[-149.79441774935952, 61.17959958023628]],
    [ "substation 20",[-149.74240386827705, 61.23063977626857]],
    [ "Martin Substation",[-122.409428128963, 37.70386478705945]],
    [ "Balcones Substation",[-97.8301995043914, 30.46104063272277]],
    [ "Buttercup Substation",[-97.82387564360327, 30.486911706500976]],
    [ "Avery Ranch Substation",[-97.78782390401433, 30.49135488543124]],
    [ "Blockhouse Substation",[-97.83824140348743, 30.54837261856177]],
    [ "Lakeville Substation",[-122.5812240701265, 38.2508080326703]],
    [ "High Street Substation",[-71.05519213875598, 42.353854590722634]],
    [ "Chatham Street Substation",[-71.05493761394068, 42.35949207194056]],
    [ "Kingston Street Substation",[-71.05987709701239, 42.35303167207483]],
    [ "Putnam Avenue Substation",[-71.11382000325061, 42.36044744202763]],
    [ "Andrew Square Substation",[-71.05853730517954, 42.329086269382294]],
    [ "Scotia Street Substation",[-71.08559893725008, 42.346550354272615]],
    [ "Southport Substation",[-90.13734249529946, 29.955394630066408]],
    [ "Carver Street Substation",[-71.06628167350209, 42.350178506614974]],
    [ "Hampshire Station",[-71.0915886, 42.36591179999999]],
    [ "Berry Street Receiving Station",[-121.26429892615545, 38.76170300862292]],
    [ "Borrego Substation",[-117.7489735188719, 33.59765045459461]],
    [ "Phillippi Substation",[-82.52895183969162, 27.286234620174547]],
    [ "SRP Tenney Substation",[-111.77488788877261, 33.32058463627941]],
    [ "30140734",[-111.7049032902456, 33.32938496543877]],
    [ "Moody Substation",[-111.70283563594424, 33.29078737949544]],
    [ "LeBaron Substation",[-83.2210289902725, 42.651952036767604]],
    [ "30371205",[-117.91964784497081, 34.50901729455398]],
    [ "Atlantic Substation",[-121.26389197108698, 38.76345334962504]],
    [ "Wayne Substation",[-83.46516011754076, 42.310098153144125]],
    [ "Newburgh Substation",[-83.41394037964541, 42.30802722253709]],
    [ "Schrader Substation",[-111.8334180169609, 33.24530143215199]],
    [ "Vincent Substation",[-118.11929006853111, 34.48625778392495]],
    [ "SRP Brandow Substation",[-111.91235046639746, 33.43906382426719]],
    [ "Adelanto Converter Station",[-117.43802426466601, 34.551404373429705]],
    [ "Daly City Substation",[-122.45590633401461, 37.691745255423044]],
    [ "30637312",[-122.21310192901585, 37.49039107627256]],
    [ "Pacific Gas and Electric Company",[-122.21414153843507, 37.49763514377053]],
    [ "30637353",[-122.20758168673056, 37.51141781908972]],
    [ "Corbell Substation",[-111.82970765919353, 33.357884717309794]],
    [ "Jocassee Switching Station",[-82.91004889796625, 34.95800537444517]],
    [ "Lake Hubbard Station",[-96.54769962211195, 32.83697961512869]],
    [ "Table Mountain Substation",[-121.64482723741433, 39.555024598409965]],
    [ "Solano Substation",[-122.29222436539824, 37.890886884607916]],
    [ "Hilltop Substation",[-97.94148921256351, 29.898601839141342]],
    [ "Strahan Substation",[-97.93242595705254, 29.88966313788931]],
    [ "Zorn Substation",[-97.94956232390592, 29.77266343476722]],
    [ "Tri-Corner Substation",[-96.53752794692404, 32.55366520659568]],
    [ "Industrial Boulevard Substation",[-96.78914105133323, 32.759114999795685]],
    [ "Margarita Substation",[-117.62807587289943, 33.54973495631338]],
    [ "Spicewood Substation",[-97.79692313334661, 30.420292101705826]],
    [ "12th Avenue Substation",[-82.40326565448696, 27.937334140656354]],
    [ "San Marcos Substation",[-97.91797047029999, 29.877431305215957]],
    [ "Redwood Substation",[-97.94475575132671, 29.850531004395446]],
    [ "Gould Substation",[-118.18709233625756, 34.22149129709981]],
    [ "Marshall Ford Lower Switchyard",[-97.90755033343771, 30.389976741481096]],
    [ "Saratoga Substation",[-122.01525425584137, 37.28098623558016]],
    [ "Beverly Substation",[-118.39737679999999, 34.073108649999995]],
    [ "Timp Substation",[-111.73348687595391, 40.31637922563953]],
    [ "Rancho Carmel Substation",[-117.0777695983195, 32.9936917439588]],
    [ "31871976",[-118.39188582647418, 34.243079912189934]],
    [ "Airway Substation",[-118.28023557443737, 34.15782537429718]],
    [ "Hollywood Way Distributing Station",[-118.33947564492634, 34.15408530744326]],
    [ "Distributing Station 72",[-118.32131227345668, 34.259284008573346]],
    [ "Pedernales Electric Cooperative",[-98.00335646543611, 29.822985707999262]],
    [ "Gold Hill Substation",[-121.13683286290943, 38.65755743127904]],
    [ "Brighton Substation",[-121.40778014697214, 38.548186266936575]],
    [ "Del Amo Substation",[-118.09727205930074, 33.8482127410751]],
    [ "32248243",[-78.8125034049423, 35.72493031772703]],
    [ "Duke Enery Progress",[-78.95194053194123, 35.63222790181757]],
    [ "32249209",[-78.74528175773932, 35.75830335993185]],
    [ "Durham Substation",[-78.74979087564473, 35.95060482588629]],
    [ "32249735",[-78.76575011662435, 35.889275159534314]],
    [ "32249773",[-78.70766396048391, 35.817973022439745]],
    [ "32252610",[-84.22774510437105, 39.4034996903713]],
    [ "Duke Energy",[-78.78985801373047, 35.78917522611417]],
    [ "Cape Fear Substation",[-79.04903151413917, 35.59193491609847]],
    [ "Parkwood Substation",[-78.9306873772129, 35.87140191836004]],
    [ "32334805",[-78.81706659820232, 35.92684899085944]],
    [ "32447285",[-78.68243024373709, 35.790911077421356]],
    [ "Wimberley Substation",[-98.10269849794979, 29.99968271625994]],
    [ "Sargent Road Substation",[-96.77416919735724, 32.727861233989444]],
    [ "Parkdale Substation",[-96.72408837165194, 32.77571246086548]],
    [ "32505549",[-78.6941951537548, 35.82903920204706]],
    [ "32505640",[-78.70005732296606, 35.87269227429491]],
    [ "Plant Avenue Substation",[-82.46311237409013, 27.943738425797047]],
    [ "Natomas Substation",[-121.48638583885851, 38.6503019160126]],
    [ "Elverta Substation",[-121.47921963396296, 38.71377807895946]],
    [ "Davis Substation",[-121.7341146298299, 38.54519855530029]],
    [ "32574917",[-78.29545528305941, 35.52344474553846]],
    [ "Receiving Station U",[-118.54372818441068, 34.17932844232244]],
    [ "LADWP Distributing Station No. 127",[-118.51901296394458, 34.193442017234496]],
    [ "DISTRIBUTING STATION 78",[-118.52562787838075, 34.16543648467005]],
    [ "Westley Substation",[-121.23090470236632, 37.516016221868824]],
    [ "Parker Substation",[-120.91728131529261, 37.66825623126298]],
    [ "Elk Grove Substation",[-121.35329022021207, 38.372986335733785]],
    [ "Pocket Substation",[-121.47008440774717, 38.489528270440914]],
    [ "LADWP Distributing Station No. 92",[-118.49317219024654, 34.25797632427409]],
    [ "32777636",[-84.69317278947015, 39.08047174363098]],
    [ "32778603",[-84.62613099743452, 39.06023242713802]],
    [ "32778616",[-84.62545959403737, 39.05899196406438]],
    [ "Hebron Substation",[-84.72938545990367, 39.08993945070364]],
    [ "East Kentucky Power Cooperative",[-84.72964369318015, 39.090744801089286]],
    [ "Clarksville Substation",[-121.05945070644387, 38.65572738121767]],
    [ "32798600",[-82.45584979190562, 27.47611382495021]],
    [ "LADWP Distributing Station No. 60",[-118.4841199701185, 34.19359376131492]],
    [ "LADWP Distributing Station No. 142",[-118.4852022717468, 34.27161583693228]],
    [ "Pacific Gas and Electric Company",[-122.2485347301355, 38.0909307421092]],
    [ "Rancho Seco Substation",[-121.12381269438389, 38.344194651056036]],
    [ "O'Banion Substation",[-121.72312100999814, 39.02393299715665]],
    [ "Hayden Substation",[-83.19322193463245, 40.06167247289513]],
    [ "Dysart Substation",[-112.34253571742653, 33.59505007216881]],
    [ "Ignacio Substation",[-122.54036291768706, 38.076773750867886]],
    [ "Skaggs Island",[-122.38098627506636, 38.1613082907146]],
    [ "33061940",[-111.96422677357974, 41.14647659255284]],
    [ "Bahia Substation",[-122.1373821772843, 38.08089745995795]],
    [ "Sobrante Substation",[-122.20819297672394, 37.90550693258038]],
    [ "Moraga Substation",[-122.16108044852449, 37.84790230551536]],
    [ "Grant Substation",[-122.15958989497177, 37.67143168479392]],
    [ "Eastshore Substation",[-122.11715069955508, 37.62481993159744]],
    [ "Mount Eden Substation",[-122.10191765255499, 37.6321416398835]],
    [ "ComEd Lockport 345kV Substation",[-88.09526485391211, 41.63027781379322]],
    [ "33159984",[-84.47998986245064, 39.09339808704182]],
    [ "West Millersport Substation",[-82.56887409591637, 39.88765114392228]],
    [ "Kammer Substation 765kv",[-80.8059399063125, 39.833565204675445]],
    [ "Maliszewski Substation",[-83.01138166194488, 40.18159041508501]],
    [ "Marysville Substation",[-83.43021161626086, 40.33283999088445]],
    [ "Todhunter Substation",[-84.37632260847239, 39.454995988414]],
    [ "Tulucay Substation",[-122.26796116231147, 38.24782428165599]],
    [ "33292238",[-122.26925305243013, 38.263132266865206]],
    [ "Maximo Substation",[-82.67585251003683, 27.727432685562793]],
    [ "90th South Substation",[-111.91618839904778, 40.58953282904462]],
    [ "Mid-Valley Substation",[-111.92889528652675, 40.70719745788989]],
    [ "Vista Substation",[-117.32028994458639, 34.040974162809434]],
    [ "Chino Substation",[-117.6784233369278, 33.998553682135224]],
    [ "Parkway Substation",[-111.93398225, 40.7072031]],
    [ "Decker Lake Substation",[-111.95082721996994, 40.70610788381572]],
    [ "33655568",[-111.90553987733284, 40.52722653898068]],
    [ "Camp Williams Substation",[-111.94853559166476, 40.467669804053095]],
    [ "33656043",[-112.02950854087204, 40.60901227510404]],
    [ "33656051",[-112.02964487478407, 40.66683446666939]],
    [ "33656088",[-112.02888843904827, 40.71642187496698]],
    [ "Terminal substation",[-112.00667207536898, 40.75771505549335]],
    [ "33657998",[-111.9138228159664, 40.42467356902528]],
    [ "33658188",[-111.63316685013227, 40.145130286230554]],
    [ "Spanish Fork Substation",[-111.58636283987397, 40.09187001243636]],
    [ "33677754",[-111.92486783061528, 40.76865105714378]],
    [ "Gadsby Substation",[-111.93054715935229, 40.7677366579438]],
    [ "Canyon Substation",[-97.90009591475565, 29.911482821770548]],
    [ "North Boyertown Substation",[-75.62961665101346, 40.355247820213975]],
    [ "Syracuse Substation",[-112.04339986253152, 41.0949828867333]],
    [ "33724818",[-112.05544041370013, 41.30439584981459]],
    [ "Ben Lomond substation",[-112.04744289031213, 41.339887399121515]],
    [ "North Ogden Substation",[-111.93353628279002, 41.307013677395794]],
    [ "33725404",[-112.01574377642748, 41.2988847870235]],
    [ "33725579",[-112.02492609941862, 41.218420050097805]],
    [ "Michoud Station",[-89.9375857656942, 30.009679073900145]],
    [ "33728165",[-112.0572830566775, 41.190147133765215]],
    [ "33728343",[-112.05763661589738, 41.14112101174336]],
    [ "Parrish Substation",[-111.90366929877112, 40.91894293380913]],
    [ "Carlyle substation",[-111.91928055, 40.6946056]],
    [ "Meadowbrook substation",[-111.92488157499888, 40.673238306175485]],
    [ "Cottonwood Heights Substation",[-111.86105673641772, 40.68886802739185]],
    [ "Grow substation",[-112.00514554998391, 40.7835080502067]],
    [ "Saugus Substation",[-118.5750041559747, 34.42215094459521]],
    [ "Pacific Gas and Electric Company",[-122.21442474701252, 38.508632241450236]],
    [ "Oquirrh Substation",[-112.02748791894024, 40.56460673054734]],
    [ "Mona Substation",[-111.90405038702639, 39.82394657940523]],
    [ "33835781",[-111.89604155, 39.8217267]],
    [ "33838389",[-89.93555690041894, 29.936541731284596]],
    [ "Entergy Louisiana",[-89.9809619311627, 29.922789328160103]],
    [ "Bangerter Substation",[-111.97571867794571, 40.501045075016194]],
    [ "Sunrise Substation",[-112.01808248472759, 40.53739695002364]],
    [ "Lark Substation",[-112.09851408466639, 40.52832523333333]],
    [ "33869564",[-112.10509578702562, 40.56060448259377]],
    [ "Granger Substation",[-111.9584383324058, 40.692700252497055]],
    [ "Ridgeland Substation",[-111.98728977504787, 40.72230610468305]],
    [ "Centennial Substation",[-111.989654797143, 40.73277625035313]],
    [ "33904308",[-112.08060818741443, 40.719731863595975]],
    [ "Sno-King Substation",[-122.18649459615347, 47.81283521828667]],
    [ "Monroe Substation",[-121.89012744934269, 47.89732102114993]],
    [ "Fort Randall Substation",[-98.55469672818455, 43.062958246422625]],
    [ "34185877",[-111.88257767621404, 40.63324598278849]],
    [ "34196820",[-111.9873697375107, 41.06762032519939]],
    [ "34196834",[-111.98875241022301, 41.06781001404055]],
    [ "34227900",[-84.28083630420521, 39.30599338884745]],
    [ "Putah Creek Substation",[-121.99442569440572, 38.52305755967254]],
    [ "34364857",[-112.04471545, 41.10500845000001]],
    [ "Georgia Power",[-83.5061670238338, 34.01733525232357]],
    [ "Pleasant View Substation",[-77.529509469999, 39.07717146677926]],
    [ "34638672",[-92.59617279747309, 37.11409707709503]],
    [ "34682053",[-111.89122473963506, 40.981822624380996]],
    [ "Georgia Power",[-85.09377438384475, 33.56155878599848]],
    [ "Georgia Power",[-84.27168011784221, 33.79095519904338]],
    [ "Grand Coulee 230 kV Switchyard",[-118.9982954579552, 47.95504195317605]],
    [ "Georgia Power",[-84.37251068627943, 34.01294804249773]],
    [ "Johnson Substation",[-82.4684037, 27.4607096]],
    [ "Kentucky Utilities Company",[-84.4929148221336, 38.00047724267901]],
    [ "Florida Power & Light",[-82.63314472483508, 27.500303761747734]],
    [ "Buckeye Substation",[-82.5406002, 27.622803750000003]],
    [ "Anclote Power Plant Substation",[-82.78413138847661, 28.18429129762805]],
    [ "Mission Substation",[-122.41385774999999, 37.7773801]],
    [ "Talbot Substation",[-122.19135817561525, 47.46814651013976]],
    [ "Maple Valley Substation",[-122.18708543517833, 47.46910301025545]],
    [ "Covington Substation",[-122.12161454168606, 47.347496236745705]],
    [ "Tacoma Substation",[-122.36995262583311, 47.256817001650134]],
    [ "Massachusetts Substation",[-122.33591799942582, 47.588726829557075]],
    [ "Badger Canyon Substation",[-119.25688951749416, 46.20728278834973]],
    [ "South Tacoma Substation",[-122.37192938324796, 47.09197089055884]],
    [ "Raver Substation",[-121.93440875101867, 47.336500678686484]],
    [ "Fort Walton Substation",[-86.61771403690011, 30.413069153106367]],
    [ "Gunpowder Substation",[-76.49881347645659, 39.41910548193889]],
    [ "Windy Edge Substation",[-76.49713175640451, 39.41205776626349]],
    [ "Fullerton Substation",[-76.50231790805886, 39.37520750903576]],
    [ "Standard Oil 5 Substation",[-122.38113347002118, 37.945465144599524]],
    [ "Trumbull Creek",[-114.23401736090183, 48.38553696636147]],
    [ "Ringling Switchyard",[-82.48228883740614, 27.358423494623803]],
    [ "Ringling Substation",[-82.4835621788168, 27.357487520578246]],
    [ "Duwamish Substation",[-122.30717518898612, 47.51441767605129]],
    [ "Christie Substation",[-122.20828254343365, 38.002731632794266]],
    [ "Martinez Substation",[-122.13012237274198, 37.99389210045125]],
    [ "Pacific Gas and Electric Company",[-122.06177232709535, 38.01970057365512]],
    [ "San Leandro U Substation",[-122.14860474616573, 37.710543706656246]],
    [ "East Portal Substation",[-122.18703321223062, 37.87597702011271]],
    [ "Pittsburg Substation",[-121.89582663519369, 38.036782621612446]],
    [ "35735111",[-121.90591497989598, 38.020836376291385]],
    [ "Clayton Substation",[-121.96932568291388, 37.944317121021236]],
    [ "Lakewood Substation",[-122.05736029976238, 37.908650395112765]],
    [ "Contra Costa Substation",[-121.78245899018381, 37.99920743254909]],
    [ "Clybourn Substation",[-87.65610481290832, 41.91393651384261]],
    [ "Contra Costa Power Plant Substation",[-121.76209279460227, 38.01516446123904]],
    [ "Tacoma Power",[-122.56088075697879, 47.28928025416645]],
    [ "35912398",[-121.8323428, 38.12527915]],
    [ "Jameson Substation",[-122.14792040570795, 38.20544653154339]],
    [ "Rocky Mountain Power",[-111.88422113445138, 40.753484381845496]],
    [ "36140354",[-121.87401561049178, 38.03024538946395]],
    [ "Peabody Substation",[-121.97050490922977, 38.28543622745843]],
    [ "Lodi Energy Center",[-121.38834713980626, 38.08781900408684]],
    [ "Delta Switching Station",[-121.62013450651912, 37.798848360246446]],
    [ "JRWG Substation",[-121.61445527799155, 37.764317909625014]],
    [ "11th Avenue Substation",[-82.42732915977382, 27.96353579207762]],
    [ "Randolph Substation",[-94.49450023244819, 39.15323035933366]],
    [ "Woodland Substation",[-121.76004945708489, 38.67849265386564]],
    [ "36806769",[-111.94522112416976, 40.842561209342676]],
    [ "Bixby Substation",[-82.90011954324203, 39.871264613601625]],
    [ "Parkers Lake Substation",[-93.45704039304798, 44.99285210783084]],
    [ "Edina",[-93.35923307914781, 44.87458195874233]],
    [ "36870225",[-84.46434080565695, 39.035858225713774]],
    [ "36870265",[-84.4877829833343, 39.059657693424946]],
    [ "Bassett Creek Substation",[-93.40775909089172, 44.99388034736344]],
    [ "Medicine Lake Substation",[-93.3840309003183, 44.98951459134652]],
    [ "36906933",[-112.05766496772353, 41.832944394324386]],
    [ "Clinton Substation",[-83.85468424354937, 39.39746458255633]],
    [ "Bath Substation",[-83.97844225042954, 39.76672588159544]],
    [ "Miami Substation",[-84.16977443115266, 39.94175621859291]],
    [ "36953570",[-111.94509463171474, 41.10396225843057]],
    [ "Deepwater Substation",[-121.55991494687285, 38.55156653666965]],
    [ "Harrison Substation",[-82.98943135499026, 39.800201311582384]],
    [ "East Pine Substation",[-122.30314132297946, 47.61467673299859]],
    [ "Creston-Nelson Substation",[-122.26709123601746, 47.506463435421466]],
    [ "Bothell Substation",[-122.17942005160766, 47.85471381141887]],
    [ "Foothill Substation",[-121.34735455237067, 38.693385166645335]],
    [ "Orangevale Substation",[-121.26628834507301, 38.68485481612748]],
    [ "Bradenton Substation",[-82.56676564386092, 27.49638440437174]],
    [ "37352222",[-109.42557216892837, 40.912804362265305]],
    [ "37354053",[-111.46068693245732, 40.68714244534362]],
    [ "37354447",[-83.06891902386727, 40.50877646289864]],
    [ "Fishhawk Substation TECO",[-82.20130650584684, 27.855967597836013]],
    [ "37394125",[-82.60300234662573, 27.86133802300867]],
    [ "37416219",[-111.69959244817171, 40.30301696837523]],
    [ "Sacramento Municipal Utility District",[-121.44512671097358, 38.539000338733054]],
    [ "Navy Substation",[-94.58337192760868, 39.11167804753239]],
    [ "Grand Avenue West Substation",[-94.581584363415, 39.11151631854209]],
    [ "46th Street Substation",[-82.4104051750831, 28.05216114187405]],
    [ "Northeast Ankeny Substation",[-93.56162326462349, 41.75411383810252]],
    [ "Stadium Substation",[-111.84707510896469, 40.75924897496215]],
    [ "South City Substation",[-121.46394061333206, 38.50857227211941]],
    [ "Mandalay Switchyard",[-119.24682337740009, 34.207770726657195]],
    [ "Southern California Edison",[-119.16690776232663, 34.13100950899054]],
    [ "Ankeny Substation",[-93.59007871691594, 41.71320516362664]],
    [ "Camp Evers Substation",[-122.02521285375265, 37.041837664184655]],
    [ "100th & 54th Substation",[-93.75475251227833, 41.66125520109802]],
    [ "Weber State  Unversity",[-111.93903914017893, 41.1906034796828]],
    [ "Metropolitan Substation",[-94.79376767438049, 39.07171736439778]],
    [ "Taylor Substation",[-82.76791950617248, 39.976261746097535]],
    [ "38022186",[-83.00373333886792, 39.953988038773815]],
    [ "Fair Oaks Substation",[-122.010253380934, 37.397158642914434]],
    [ "38151873",[-122.24401163618747, 37.499736896171854]],
    [ "Serramonte Substation",[-122.45415577964998, 37.65088668935296]],
    [ "Stagg Substation",[-121.34845639356669, 37.992206390277715]],
    [ "Lower Granite Substation",[-117.41997010822921, 46.65182446884543]],
    [ "Lower Monumental Substation",[-118.54495507943463, 46.550204202775895]],
    [ "Mabelvale Substation",[-92.41061037639673, 34.63442942683276]],
    [ "Wrightsville Substation",[-92.21670759896094, 34.59399799982047]],
    [ "Keo Substation",[-92.04831648740507, 34.64046387562203]],
    [ "White Bluff Substation",[-92.14415844258862, 34.424094615862025]],
    [ "Ironton Substation",[-92.2732351589973, 34.63349357135256]],
    [ "Southwest Lima Substation",[-84.18316032717648, 40.677451012157945]],
    [ "Shawnee Road Substation",[-84.15198802241733, 40.694072694861596]],
    [ "East Lima Substation",[-84.02903463922995, 40.80076045928533]],
    [ "Sterling Substation",[-84.10753305000001, 40.70116215]],
    [ "Midway Substation",[-83.91849636389034, 41.47525497431648]],
    [ "38453626",[-112.02818323825684, 40.6658491754808]],
    [ "Dixie Substation",[-83.51523794247245, 41.71554007406636]],
    [ "38477721",[-84.85820861102039, 39.11620949559744]],
    [ "Rosemead Substation",[-118.08266225907335, 34.09214439924324]],
    [ "Shingletown Substation",[-77.83683235956359, 40.75987543038217]],
    [ "38608818",[-111.95909609110188, 40.655793693617454]],
    [ "Nevada Power",[-115.16847014520465, 36.057437386519226]],
    [ "Fayetteville Public Works",[-78.95375364472024, 35.07986952814878]],
    [ "38653255",[-121.84095513018191, 37.30307095434369]],
    [ "38696458",[-112.00257894480842, 40.652139900369654]],
    [ "Southtown Substation",[-94.81185253193448, 38.86961450404651]],
    [ "Olathe Substation",[-94.75803950111924, 38.88523646614758]],
    [ "Los Esteros Substation",[-121.93282125334837, 37.4272285592368]],
    [ "Murlen Substation",[-94.77208466455043, 38.840825572258275]],
    [ "39158724",[-111.61316293525061, 40.09562502944689]],
    [ "Scobie Pond 115kV Substation",[-71.33905814999999, 42.90158319999999]],
    [ "Scobie Pond 115kV Substation",[-71.34028638285703, 42.90263920247094]],
    [ "Scobie Pond 345kV Substation",[-71.34225927083187, 42.90456941137283]],
    [ "39200108",[-111.89505939764189, 40.665440978134654]],
    [ "Cedar Crest Substation",[-96.80232048156648, 32.72174393803447]],
    [ "Cedar Crest Switching Station",[-96.8042672110756, 32.72183727098996]],
    [ "39241828",[-115.11953890161169, 36.08308251184257]],
    [ "Mayflower Substation",[-92.43852615207487, 34.937030184432]],
    [ "Horse Ranch Substation",[-122.11302663059627, 47.97169170002093]],
    [ "Watermill Substation",[-96.7261784096957, 32.558540448028445]],
    [ "Sewickley Substation",[-79.66887804867712, 40.267446246426154]],
    [ "Eagle Rock Switchyard",[-118.18433471053334, 34.15083194759702]],
    [ "Summit Substation",[-97.0541131495956, 45.325362625094876]],
    [ "Wilmer Substation",[-96.6859887775712, 32.58199229275812]],
    [ "39590485",[-90.04709309680278, 30.41353836106561]],
    [ "Entergy Arkansas",[-92.27664886238364, 34.750476881405866]],
    [ "Prairie Creek Substation",[-96.66281243860753, 32.7772356982858]],
    [ "W. A. Parish Station (138 kV)",[-95.63042054642267, 29.48278017510261]],
    [ "39610474",[-95.62284978261972, 29.47425125850088]],
    [ "Knott Substation",[-122.66509342665557, 45.54145162846684]],
    [ "39664651",[-111.92997842714774, 41.24024759441721]],
    [ "Entergy Arkansas",[-92.39877100494716, 34.753297238228875]],
    [ "Entergy Arkansas",[-92.45605420102967, 34.759928112065346]],
    [ "Comanche Peak Station",[-97.78986113466468, 32.297773192414354]],
    [ "39701516",[-122.66873249999999, 48.3261397]],
    [ "Desoto Substation",[-85.30572507044016, 40.23676238255301]],
    [ "39829302",[-111.91582855708668, 40.64715937983393]],
    [ "South Texas Project Switchyard",[-96.05017106859903, 28.79955927552637]],
    [ "Kearny Substation",[-74.0984254179452, 40.737890080945775]],
    [ "39900123",[-111.9228599821756, 40.6221904260557]],
    [ "East Mesquite Substation",[-96.57248748460124, 32.775291666080015]],
    [ "Forney Substation",[-96.48688650281558, 32.75787765236176]],
    [ "Trinity Bay Substation",[-94.91163354271714, 29.68922952439209]],
    [ "39962322",[-94.90272245647917, 29.77397589442801]],
    [ "Cedar Bayou Plant Substation",[-94.92489554146442, 29.748056665892285]],
    [ "Dumas Substation",[-111.86414611484219, 40.52844959175177]],
    [ "39992224",[-111.8966086696787, 40.53943570739437]],
    [ "40048851",[-111.86136771923819, 40.6192586729215]],
    [ "Sacramento Municipal Utility District",[-121.17140689740084, 38.682382319666274]],
    [ "Oahe Substation",[-100.39041920509001, 44.44918403018693]],
    [ "40171275",[-106.66505879999998, 35.273729599999996]],
    [ "40235906",[-111.94624405805666, 41.24329432979495]],
    [ "Columbia Substation",[-76.82744353554635, 39.19412591395634]],
    [ "Hollofield Substation",[-76.80361093768937, 39.309452644105114]],
    [ "Granite Substation",[-76.83948305736598, 39.33921498179193]],
    [ "Santa Clara Substation",[-119.18545117106642, 34.30222943214085]],
    [ "Mickleton Peaking Plant Substation",[-75.24930245591341, 39.8117142829293]],
    [ "Rocky Mountain Power",[-111.8613942598095, 40.75104672208672]],
    [ "40397417",[-87.89552500448595, 42.46922702526722]],
    [ "Grand Coulee 500kV Switchyard",[-119.01989383462528, 47.966295614182506]],
    [ "Corridor Substation",[-82.84503144146412, 40.12409105809556]],
    [ "Morse Road Substation",[-82.90715131411812, 40.0611806095331]],
    [ "Snohomish Substation",[-122.10398080918982, 47.92396735789999]],
    [ "Sedro-Woolley Substation",[-122.20400232436083, 48.50536263875716]],
    [ "Silverhill Substation",[-87.76411700479328, 30.554006270662377]],
    [ "Schultz Substation",[-120.51108760338663, 47.12093120944717]],
    [ "St. Louis Park Substation",[-93.36335392724004, 44.93741840847774]],
    [ "Bell Substation",[-117.37350001819918, 47.749294706155084]],
    [ "Midway Substation",[-119.78264699466946, 46.62049945092616]],
    [ "Hanford Substation",[-119.57144227301883, 46.66942644362792]],
    [ "Oak Creek Station",[-87.83479315371163, 42.84258691798686]],
    [ "Bain",[-87.90081914767158, 42.55287616231322]],
    [ "Novelty Hill Substation",[-122.01115322411003, 47.68792881361286]],
    [ "Benbrook Substation",[-97.47139291864016, 32.684944725816166]],
    [ "40810727",[-97.41751470050384, 32.67350308516715]],
    [ "40811240",[-97.40281052195544, 32.657967687904204]],
    [ "Kenosha Substation",[-87.87422695584291, 42.56420362997366]],
    [ "Arcadian Substation",[-88.1733055483977, 43.00862864253262]],
    [ "40836896",[-88.12074695875108, 43.00897842588458]],
    [ "Bluemound Substation",[-88.05379094465536, 43.0287523097336]],
    [ "96th Street Substation",[-88.03108279002042, 43.02996491941825]],
    [ "Calmont Substation",[-97.4497208, 32.73614945]],
    [ "40910567",[-97.47833312027952, 32.74907149332033]],
    [ "Faron Street Substation",[-97.40513321937961, 32.70970928514355]],
    [ "41013192",[-111.9551638086412, 41.18781187147258]],
    [ "Baytown Substation",[-95.00483324633804, 29.733431490080758]],
    [ "Warvue Substation",[-94.89751911433399, 29.838100607726606]],
    [ "McRae Substation TECO",[-82.36363409908031, 28.044139289022468]],
    [ "41232157",[-111.96642999283897, 40.62322896400653]],
    [ "S.R. Bertron Plant",[-95.06048534683616, 29.725080694199487]],
    [ "Lynch Substation",[-95.07247072823387, 29.767576309324543]],
    [ "41376380",[-111.92140999771765, 40.61489971842022]],
    [ "41378006",[-95.07235927667993, 29.712721757685323]],
    [ "Tredyffrin Substation",[-75.47286377893388, 40.05486073071441]],
    [ "PEMEX Substation",[-95.1238958709801, 29.721985756596453]],
    [ "Columbia Substation",[-120.07704390562846, 47.29484498930998]],
    [ "McKinley Substation",[-82.41958099999998, 28.044020386205016]],
    [ "Vantage Substation",[-119.93892614671036, 46.87688476990655]],
    [ "Chief Joseph Substation",[-119.65178241844896, 47.9859756285174]],
    [ "41527368",[-95.1114915, 29.720109949999998]],
    [ "Collinsville Substation",[-84.6670807533235, 39.515004182782846]],
    [ "41702264",[-95.11302757439297, 29.72721012099706]],
    [ "Plymouth Meeting Substation",[-75.29934221862902, 40.10391573674456]],
    [ "Whitpain Substation",[-75.31001344277607, 40.17154426688554]],
    [ "Shelton Substation",[-123.12355093039119, 47.227802092862234]],
    [ "Kitsap Substation",[-122.70394553163186, 47.53181159837763]],
    [ "Puget Sound Energy",[-122.6935022251342, 47.711099596345825]],
    [ "41772669",[-123.46220035083087, 46.969172668450156]],
    [ "Satsop Substation",[-123.46392974820509, 46.96801707971618]],
    [ "Aberdeen Substation",[-123.85141938526047, 46.97938241256927]],
    [ "Hopewell Switching Station",[-74.78601661145396, 40.30023124451229]],
    [ "Channelview Substation",[-95.1509275603565, 29.775611122446186]],
    [ "Crown Substation",[-117.8651744034388, 33.60816679575456]],
    [ "42000190",[-84.64515069256834, 38.990767230543206]],
    [ "Stanley Parker Substation",[-84.57968326949153, 38.895714639372926]],
    [ "42001543",[-84.56365875657984, 38.913415963550584]],
    [ "Mountaineer Substation",[-81.94227198028008, 38.97581961023158]],
    [ "Sporn Substation",[-81.9296509565058, 38.96179161343973]],
    [ "Branchburg Switching Station",[-74.74274098935535, 40.54428863192422]],
    [ "Wilsonville Substation",[-122.76678818580014, 45.317803202880434]],
    [ "Waterton Substation",[-105.07151216403284, 39.49690980722154]],
    [ "42391155",[-122.06855249746354, 37.4049963770363]],
    [ "42429302",[-111.95728945970092, 41.07414363877528]],
    [ "Paul Sweet Substation",[-121.98220505181307, 36.99233709915851]],
    [ "Bridge Street Lower Substation",[-71.45437221906778, 42.764989310206495]],
    [ "Bridge Street Upper Substation",[-71.45388803137351, 42.76432486734337]],
    [ "Larrabee Substation",[-74.19208515335065, 40.113686800907765]],
    [ "Smithburg Substation",[-74.3606363414155, 40.20141629515998]],
    [ "East Windsor Substation",[-74.51849757083652, 40.24047916724108]],
    [ "Brunswick Substation",[-74.46115872545428, 40.44635935737324]],
    [ "East Rockford Substation",[-88.96929019054065, 42.294026512257744]],
    [ "Cherry Valley Substation",[-88.9759287148477, 42.216282991886686]],
    [ "Pleasant Valley Substation",[-88.43971992309768, 42.25679108803263]],
    [ "Industrial Substation",[-95.18585332584523, 29.752124123421392]],
    [ "Depot Substation",[-95.12684544999999, 29.752083750000004]],
    [ "Millstone Substation",[-72.16537152361418, 41.31481413486864]],
    [ "Silver Lake Substation",[-88.25097587131744, 42.25488214339309]],
    [ "Libertyville Substation",[-87.9755480419054, 42.31375314946516]],
    [ "Commonwealth Edison",[-88.12020966135736, 42.33144806195059]],
    [ "43098958",[-87.98573457007276, 42.24478475636897]],
    [ "Aptakisic Substation",[-87.96201412465031, 42.181120554298246]],
    [ "Commonwealth Edison",[-87.93116913114324, 42.14340521281914]],
    [ "Commonwealth Edison",[-87.91770344906159, 42.11670595631416]],
    [ "Arlington Heights Substation",[-87.98473792174016, 42.11781743316145]],
    [ "Palatine Substation",[-88.05752437559285, 42.11941346138235]],
    [ "North Cambridge Substation",[-71.14313705839577, 42.39151972576711]],
    [ "Wempletown Substation",[-89.19271900701807, 42.342651481054126]],
    [ "43439628",[-97.3893023256323, 32.66886088811915]],
    [ "43520011",[-89.11194721100766, 42.53627394196684]],
    [ "43541420",[-84.45351162016597, 39.19526819814636]],
    [ "Sabrooke Substation",[-89.09593440562682, 42.23327106589671]],
    [ "43619684",[-84.29027880799877, 39.11772290455885]],
    [ "TECO",[-82.41416734850735, 28.068361625152452]],
    [ "Commonwealth Edison",[-88.41977748881393, 42.19642342540777]],
    [ "43705092",[-95.2269433562819, 29.720380272901657]],
    [ "Collins",[-88.34768327492853, 41.34951361147852]],
    [ "ComEd Wilton Center 765kV Substation",[-87.95259927952151, 41.39829379413617]],
    [ "ComEd Wilton Center 345kV Substation",[-87.9490167509722, 41.39930019853093]],
    [ "Channel Island Substation",[-119.22215427958982, 34.18177456066363]],
    [ "Dresden Station",[-88.27496695599365, 41.391046617879944]],
    [ "El Cerrito G Substation",[-122.30280178355784, 37.916362794551844]],
    [ "Commonwealth Edison",[-88.12241993571718, 41.63100595925126]],
    [ "Plymouth Substation",[-82.46650489182939, 27.97305479500069]],
    [ "ComEd McCook 138kV-345kV Substation",[-87.82313138166158, 41.80218169696817]],
    [ "Clinton Substation",[-95.3011662852143, 29.75554143993844]],
    [ "Steel City Substation",[-75.3087297590961, 40.61974977107768]],
    [ "Pillsbury Substation Duke",[-82.63335419630839, 27.82044569196277]],
    [ "Quarry Substation",[-75.34919821083635, 40.62275335465682]],
    [ "Minsi Trail Substation",[-75.35817821395335, 40.62043773254381]],
    [ "TECO",[-82.4479298738834, 27.94850653670367]],
    [ "Belvidere Substation",[-88.86695258529544, 42.276020945404184]],
    [ "University Substation",[-95.33150258305771, 29.716791125775234]],
    [ "Southern California Edison",[-117.97771705707426, 33.64617792446557]],
    [ "SRP Rogers Substation",[-111.79988499444394, 33.42491634749571]],
    [ "Powell Substation",[-95.03884824260707, 29.62646447580035]],
    [ "Himont Substation",[-95.05593301990616, 29.634305852989055]],
    [ "Lomax Substation",[-95.08420818662354, 29.63385566902374]],
    [ "Rosslyn Substation",[-77.07192875670353, 38.896854741110694]],
    [ "Charles Substation",[-89.05182939801077, 42.25932141578209]],
    [ "45589711",[-82.45772965754011, 27.55185989329789]],
    [ "Garden Villas Substation",[-95.3145245683327, 29.650899350154077]],
    [ "45773652",[-77.51394819941152, 38.802765736785055]],
    [ "Gainesville Substation",[-77.56517958092903, 38.79082009303357]],
    [ "45784372",[-112.06977630147875, 41.637031337972495]],
    [ "Bondurant Substation",[-93.49779809851545, 41.67498523194987]],
    [ "Tacoma Power",[-122.53603771289207, 47.2138783749532]],
    [ "Goodwin Delivery Point",[-77.51240716428842, 38.757366008787166]],
    [ "Dominion Delivery Point",[-77.50938293232039, 38.74652727326516]],
    [ "Catharpin Delivery Point",[-77.5681934723428, 38.854281759161005]],
    [ "Loudoun Substation",[-77.5682256393267, 38.89491305597804]],
    [ "NOVEC Johnson Delivery Point",[-77.46576200747836, 38.832028501907715]],
    [ "Bull Run Substation",[-77.44490930046607, 38.8178720190261]],
    [ "Brambleton Substation",[-77.54914130410204, 38.96383591429049]],
    [ "Pleasant View Substation",[-77.52877295126545, 39.07587806435529]],
    [ "Ox Substation",[-77.28874301368197, 38.7236183984915]],
    [ "Occoquan Substation",[-77.26912412162257, 38.71312819353643]],
    [ "Woodbridge Substation",[-77.28252202466346, 38.65471977308269]],
    [ "Lakeridge Substation",[-77.29483148314691, 38.69237136635476]],
    [ "Clifton Substation",[-77.39886521306151, 38.781049550549454]],
    [ "Possum Point Substation",[-77.27944290320416, 38.540512455526255]],
    [ "Possum Point Substation",[-77.27820941658955, 38.551745922980594]],
    [ "Aquia Substation",[-77.36483789584597, 38.50079309164615]],
    [ "Smoketown Substation",[-77.30234924964216, 38.64150997683983]],
    [ "Arcola Delivery Point",[-77.56985147156696, 38.896664510737445]],
    [ "Minnieville Delivery Point",[-77.3482879, 38.65266580000001]],
    [ "Cub Run Delivery Point",[-77.47039339558545, 38.875077218372]],
    [ "Keene Mill Substation",[-77.26347041105736, 38.77393453780944]],
    [ "45965877",[-77.50711142977921, 38.78254894615217]],
    [ "45968566",[-77.52296154297515, 38.77573633280069]],
    [ "Wellington Delivery Point",[-77.52916487653046, 38.76684400709195]],
    [ "Huxley Industrial Substation",[-93.60927984228942, 41.88913037048064]],
    [ "Airport Substation",[-77.50922194348455, 38.73997294041974]],
    [ "16th & Wabash Substation",[-93.63687704442626, 41.580360902605925]],
    [ "MLK Substation",[-93.6236330004506, 41.5823095113482]],
    [ "46257142",[-77.53445806348773, 38.79283221407237]],
    [ "Lomar Substation",[-77.50296036425621, 38.749295242632435]],
    [ "Prince William Substation",[-77.47440443608188, 38.74969807800259]],
    [ "46263826",[-77.51519308676205, 38.79922774872653]],
    [ "46341550",[-77.47363319700035, 38.79585551888956]],
    [ "Dulles Substation",[-77.43128432278188, 38.94534430469793]],
    [ "Walney Substation",[-77.45768760935721, 38.88703801426877]],
    [ "Sully Substation",[-77.41160929818756, 38.89359399534029]],
    [ "Busch Substation",[-95.26785125238473, 29.774898669363274]],
    [ "White River Substation",[-122.21034777528604, 47.238975961188004]],
    [ "Atlantic Substation",[-77.58007046513207, 38.78434147364573]],
    [ "Granger Substation",[-93.81986587980288, 41.75156551178703]],
    [ "Bismarck Substation",[-100.72892701930918, 46.81363187741863]],
    [ "South Houston Substation",[-95.22515236707628, 29.628973460707677]],
    [ "Forest & Vermont Substation",[-93.61422095345226, 41.60352604603196]],
    [ "Newton Eighth Street Substation",[-93.06220225367434, 41.70247946537123]],
    [ "Linton Hall Substation",[-77.59386533584839, 38.779269755918584]],
    [ "Story County Substation",[-93.27177265000002, 42.08581100000001]],
    [ "Story County I Wind Energy Center",[-93.27207106670551, 42.087251983378636]],
    [ "Century Wind Project",[-93.63590389451359, 42.56424783993645]],
    [ "Franklin Substation",[-93.29104015064048, 42.55828624645199]],
    [ "Boone Quartz Substation",[-93.84514213711427, 42.0662921528329]],
    [ "Holbrook Substation",[-70.99843199062587, 42.16719438327745]],
    [ "Edgar Substation",[-70.96483673046478, 42.24052713710408]],
    [ "MidAmerican Energy",[-93.49891376449122, 41.643249350215555]],
    [ "Nelson Substation",[-89.60915179872966, 41.760609088286316]],
    [ "MidAmerican Energy",[-93.50197929467492, 41.60462188256397]],
    [ "North Aurora Substation",[-88.30873877497942, 41.78420714375572]],
    [ "Darlington",[-74.17049523011381, 41.064894466318876]],
    [ "MidAmerican Energy",[-93.66718202674551, 41.57125614985866]],
    [ "47276594",[-84.300677760953, 39.07070917052932]],
    [ "Oakland C Substation",[-122.28075208499767, 37.7973673443505]],
    [ "Oakland C Substation",[-122.28214155343382, 37.79790309895653]],
    [ "Bonnet Creek Substation",[-81.52931265000001, 28.335361100000004]],
    [ "Lake Bryan Substation",[-81.49679450152487, 28.360135771502648]],
    [ "International Drive Substation",[-81.4736248, 28.38479635]],
    [ "Convention Center Substation",[-81.45279341983314, 28.437443546672434]],
    [ "Windermere Substation",[-81.45480192280299, 28.483756936852703]],
    [ "Southwood Substation",[-81.4408881265999, 28.47098873456628]],
    [ "Wewahootee Substation DUKE",[-81.21477435802136, 28.415630099784345]],
    [ "Magnolia Ranch North Substation OUC",[-81.21392762249233, 28.416484739533924]],
    [ "Stanton Plant Substation",[-81.1600692750264, 28.493092153920028]],
    [ "Lake Nona Substation OUC",[-81.28308450805483, 28.379555168305586]],
    [ "Curry Ford Substation DUKE",[-81.25329302354183, 28.504449234107376]],
    [ "Narcoossee Substation",[-81.2861553381368, 28.503305819661765]],
    [ "Pershing Substation",[-81.30114806678075, 28.501524062591823]],
    [ "Vineland Substation",[-81.50392187468347, 28.406625653041473]],
    [ "Clermont East Substation",[-81.71255481669454, 28.547386743125564]],
    [ "Camp Lake Substation",[-81.73445831410791, 28.60943514901096]],
    [ "Central Florida Substation",[-81.95525682160974, 28.81662482522193]],
    [ "MetroWest Substation",[-81.46695963517874, 28.4914085954909]],
    [ "Avalon Substation",[-81.63499678852756, 28.484329508356996]],
    [ "Lake Agnes Substation",[-81.82700861238683, 28.15503011302857]],
    [ "Osceola Substation",[-81.57482822379099, 28.302977031252823]],
    [ "MDU",[-100.88524732841074, 46.86555626803196]],
    [ "Gulfgate Substation",[-95.30010057919215, 29.69310953015244]],
    [ "47784816",[-100.72695603973915, 46.813793368192]],
    [ "Northwest Mandan Switching Station",[-100.92571448952415, 46.85492115779481]],
    [ "North Bismarck Substation",[-100.75893363915958, 46.83763105270669]],
    [ "Cooley Landing Substation",[-122.12793435991364, 37.47374451493432]],
    [ "Belle Haven Substation",[-122.16855594782675, 37.477675154898925]],
    [ "Sterling Park Substation",[-77.42079228914226, 38.99466144757935]],
    [ "Majestic Substation",[-83.98085831920773, 42.377939311225]],
    [ "Ranch Substation",[-80.21947309285545, 26.67496482023919]],
    [ "Acme Substation",[-80.22077777455549, 26.67519690540628]],
    [ "Corbett Substation FPL",[-80.37673191982951, 26.709596963028]],
    [ "Jog Substation",[-80.14632216739129, 26.67584388529201]],
    [ "Cedar Substation FPL",[-80.12565541297818, 26.53788965945854]],
    [ "Laudania Substation",[-80.14264799344485, 26.060203586885834]],
    [ "Port Everglades Substation",[-80.12593953666529, 26.08356425396249]],
    [ "48515426",[-87.89891031094932, 42.505724339853074]],
    [ "Lincoln Substation",[-122.67448509184628, 45.50619680848723]],
    [ "Kohlman Lake",[-93.03878916810488, 45.03450844383511]],
    [ "48719854",[-100.88520569333483, 46.866534901340486]],
    [ "Reeder Substation",[-94.71204202005352, 38.9919175758619]],
    [ "Broward Substation",[-80.15537790017885, 26.27904785574422]],
    [ "College Substation",[-94.77474944634156, 38.92944858376155]],
    [ "Switzer Substation",[-94.69977010947456, 38.899183714478475]],
    [ "Brookridge Substation",[-94.70057834639015, 38.9412957995134]],
    [ "Overland Park Substation",[-94.69734740040347, 38.96910213299549]],
    [ "Woodlands Substation FPL",[-80.22258779999999, 26.17871995]],
    [ "McArthur Substation",[-80.2186393951553, 26.150997126524747]],
    [ "Plantation Substation",[-80.2174591, 26.120345350000004]],
    [ "Flagami Substation",[-80.34325904070924, 25.768308037261562]],
    [ "Olympia Heights Substation",[-80.35288559214273, 25.735795493681685]],
    [ "Florida Power & Light",[-80.36578067586991, 25.71331834156722]],
    [ "Mitchell Substation",[-80.34041799135873, 25.642921900123834]],
    [ "Electric Substation FPL",[-80.29886079989356, 25.633017933281696]],
    [ "Southern California Edison",[-118.39407123235196, 33.99030923583602]],
    [ "Lauderdale Plant Substation",[-80.19860552748663, 26.071721243059432]],
    [ "Playland Substation",[-80.20154362540345, 26.063721556418816]],
    [ "Miami Lakes Substation",[-80.32230779256452, 25.905629839168547]],
    [ "Gratigny Substation",[-80.31440545, 25.8848736]],
    [ "Yamato Substation FPL",[-80.09984328970795, 26.410883981694944]],
    [ "Sellwood Substation",[-122.65175893320678, 45.45884551046248]],
    [ "Beaver Channel Substation",[-90.23436971882687, 41.810215487936254]],
    [ "48967801",[-90.19012717500604, 41.793968537906984]],
    [ "MidAmerican Energy",[-90.46924747084928, 41.5347824272263]],
    [ "49037367",[-90.45725249007188, 41.541087413917474]],
    [ "Receiving Station B",[-118.25533679499381, 33.94798010470111]],
    [ "Craig Substation",[-94.81009714946535, 38.93249056508963]],
    [ "Pflumm Substation",[-94.74391465734435, 38.94699958146654]],
    [ "Madrid North Substation",[-93.82153752701409, 41.882357827002934]],
    [ "49551533",[-79.7845321530183, 36.04929621721552]],
    [ "Urban Substation",[-122.67728061621165, 45.497253608081934]],
    [ "Germantown Substation",[-80.08867490282009, 26.44629530678136]],
    [ "49715848",[-118.42308196697923, 33.90842006770887]],
    [ "Scattergood Substation",[-118.42531989385229, 33.91901605197203]],
    [ "Haddam Neck Substation 14B",[-72.49270439244347, 41.48828457679048]],
    [ "Scovill Rock Substation",[-72.56970860170944, 41.510368750324204]],
    [ "6th Street Substation",[-95.23765800010662, 38.97366616569073]],
    [ "Chehalis Substation",[-122.94698995424531, 46.59956261158927]],
    [ "Paul Substation",[-122.8755943644588, 46.75479284400545]],
    [ "50102903",[-122.86490768213184, 46.75565588845105]],
    [ "Memphis Light, Gas and Water",[-89.86968661622977, 35.12202759680139]],
    [ "Lawrence Road Substation",[-71.37770580681757, 42.79071421634552]],
    [ "Lawrence Road Substation",[-71.3768712612851, 42.79147254828843]],
    [ "Mammoth Road Substation",[-71.38350321980771, 42.87855889519366]],
    [ "North Litchfield Substation",[-71.43916566063177, 42.87389765975146]],
    [ "Watts Brook Substation",[-71.43194614167409, 42.891362340173146]],
    [ "Hudson Substation",[-71.42890016856616, 42.77467899638785]],
    [ "Thornton Substation",[-71.48718157062025, 42.828678296261025]],
    [ "Reeds Ferry Substation",[-71.48776733501786, 42.87135515533049]],
    [ "Granite Ridge Substation",[-71.42395916664641, 42.904744867006535]],
    [ "Maywood South",[-94.80498861169828, 39.12926367556322]],
    [ "Maywood North",[-94.80524079110468, 39.13124998419072]],
    [ "Franks Substation",[-92.03016692771713, 37.95181079531266]],
    [ "50876004",[-122.70659065284737, 48.84852844243945]],
    [ "Port Angeles Substation",[-123.41756011213346, 48.10046328871382]],
    [ "Fairmount Substation",[-122.88479975285945, 47.9752823180228]],
    [ "50889104",[-122.81508459808451, 48.04720013802281]],
    [ "Dyer Substation",[-106.44258117567114, 31.8012135949116]],
    [ "Custer Substation",[-122.62595054219666, 48.90420189383346]],
    [ "Riverside Substation",[-94.62203386088726, 39.168525357715176]],
    [ "Leeds Substation",[-94.49740111374398, 39.04867460218901]],
    [ "51075087",[-121.14192095299447, 48.715503347728145]],
    [ "500kV Spreader Yard",[-118.99500660900934, 47.9592132296506]],
    [ " Grand Coulee 115 kV Switchyard",[-118.99375169681586, 47.95454027321608]],
    [ "Huse Road Substation",[-71.43141543437933, 42.95317868162392]],
    [ "51128270",[-112.01810566067428, 41.175832826691696]],
    [ "Tacoma Power",[-122.5609835773591, 47.105788844514706]],
    [ "51228643",[-93.72170650569606, 41.59830008911657]],
    [ "Tacoma Power",[-122.61017096258136, 47.08232336486867]],
    [ "Hanna Substation",[-86.05245918742493, 39.71391907047734]],
    [ "51318630",[-79.00087536698008, 33.79094824841546]],
    [ "Tech Center Substation",[-104.90209863409207, 39.63335982553399]],
    [ "51445934",[-95.03949062324524, 29.694840738349047]],
    [ "Great Falls Substation",[-111.22203711933948, 47.54231910511632]],
    [ "Murrayhill Substation",[-122.83091239780524, 45.43801036045732]],
    [ "Richland Substation",[-75.36592346213367, 40.446443772456725]],
    [ "Commonwealth Edison",[-87.85551132287853, 42.466828897796674]],
    [ "Cowlitz Substation",[-122.3704490175812, 47.18263239431542]],
    [ "Canal Substation",[-97.31114411461898, 37.66142681786962]],
    [ "Fremont Substation",[-121.96199945, 37.54137235]],
    [ "51715260",[-95.07267637442472, 29.700951087249177]],
    [ "51715264",[-95.07441265, 29.705999100000003]],
    [ "51754696",[-78.96208940950682, 33.765649709532504]],
    [ "Keeler Substation",[-122.89529507885374, 45.54979249192956]],
    [ "Saint Johns Substation",[-122.7648427479209, 45.613843030326194]],
    [ "Rivergate North Substation",[-122.7676709725395, 45.61432472571782]],
    [ "Saint Mary's Substation",[-122.84403377338639, 45.50743624982385]],
    [ "51783889",[-121.64177704818029, 48.27296842107787]],
    [ "51791890",[-121.24237498956192, 48.67442096036942]],
    [ "Ross Substation",[-122.65905133970897, 45.661258475950646]],
    [ "Bonneville Power Adminstration",[-122.6556801760715, 45.65980395120964]],
    [ "51799689",[-93.61943388283792, 41.64491344815295]],
    [ "Alcoa Substation",[-122.72747825740721, 45.65186738501844]],
    [ "Caples Substation",[-122.62196547153238, 45.635150379801146]],
    [ "Grant Substation",[-95.40150041426847, 29.70339790741293]],
    [ "Garrott Substation",[-95.38586823155326, 29.732847401739185]],
    [ "51916168",[-95.0220148, 29.75897145]],
    [ "Ramsey Substation",[-110.25469431867525, 31.511750833517866]],
    [ "San Rafael Substation",[-110.23126324825185, 31.524730076619267]],
    [ "ComEd Bedford 138kV-345kV Substation",[-87.76571403847652, 41.76151227072464]],
    [ "Goodings Grove Substation",[-87.93263066692484, 41.62485226149966]],
    [ "Marvin Griffin Road Substation",[-81.99503442702827, 33.394716051398056]],
    [ "Mcbean Road Substation",[-81.99235336495909, 33.35984336815123]],
    [ "Goshen Substation",[-81.99532419869234, 33.31976549873543]],
    [ "Peach Orchard Substation",[-82.05654627521152, 33.32760032272947]],
    [ "Camp Jose V Substation",[-82.14966942140632, 33.34159086776029]],
    [ "Archer Substation",[-88.00042621965927, 41.645444174593315]],
    [ "South Augusta Substation",[-81.99531765157619, 33.43383927690776]],
    [ "Cardiff Substation",[-95.15470761841152, 29.653639011776256]],
    [ "Duval Substation FPL",[-81.95295402990976, 30.2723835453224]],
    [ "Thalmann Substation",[-81.68082183810498, 31.293544340426475]],
    [ "Offerman Substation",[-82.14367291959304, 31.423038037612656]],
    [ "Waycross Primary Substation",[-82.39920840727305, 31.2233313818503]],
    [ "52070906",[-82.39651422984338, 31.223910705489917]],
    [ "Spencer Substation",[-95.19076889358607, 29.657841156600913]],
    [ "Georgia Power",[-82.37774340827481, 31.246245741540623]],
    [ "Georgia Power",[-82.27105174830027, 31.200618449596337]],
    [ "52098545",[-122.0163621007825, 37.37450214011828]],
    [ "Thurmond Substation",[-82.19595002526454, 33.660114073211986]],
    [ "52102613",[-82.19553099046607, 33.58929462943237]],
    [ "Stevens Creek Dam Substation",[-82.05325374143635, 33.561647710990044]],
    [ "Evans Primary Substation",[-82.16863621163566, 33.54398244420021]],
    [ "Grovetown Primary Substation",[-82.17855534821955, 33.46323466665159]],
    [ "Georgia Power",[-82.08853366669743, 33.54893396804299]],
    [ "Ropers Corner Substation",[-82.13816057624231, 33.506836103465936]],
    [ "Double Branches Road Substation",[-82.40256351040969, 33.7737096348046]],
    [ "Georgia Power",[-83.07875685, 34.24535395]],
    [ "52161346",[-97.35279199702644, 37.76404054011566]],
    [ "Hartwell Lake Dam Substation",[-82.82067273772678, 34.35521259974518]],
    [ "Imperial Valley Substation",[-115.71569927446097, 32.717701013590336]],
    [ "Revere Substation",[-71.00767078971411, 42.40287208364711]],
    [ "52313897",[-82.36830021907316, 28.065910887632587]],
    [ "52407184",[-82.9546667487195, 34.295403140321376]],
    [ "Hartwell Energy Facility Substation",[-82.82117295839917, 34.34115676177969]],
    [ "Toccoa Primary Substation",[-83.35278229189254, 34.58093789333407]],
    [ "52442038",[-83.029424548749, 34.35233824793169]],
    [ "52442071",[-83.22331123989592, 34.48329241703189]],
    [ "52442075",[-83.2708051, 34.51611995]],
    [ "52460256",[-83.40057903162668, 34.420518094757256]],
    [ "Merion Substation",[-74.61423440893464, 39.25176956039257]],
    [ "52475779",[-83.26655506916543, 34.44282604089259]],
    [ "Burnsville Substation",[-93.2519054829674, 44.75586257547401]],
    [ "52566657",[-83.53993159774365, 34.53129110796278]],
    [ "52566666",[-83.56865804111636, 34.5000717330742]],
    [ "52566672",[-83.64274789675021, 34.44460712340862]],
    [ "Hollywood Substation",[-83.45467705024318, 34.647481230321674]],
    [ "Talulah Falls Substation",[-83.37836411444994, 34.7284935117424]],
    [ "Northern Receiving Station",[-121.96623962017466, 37.40204079407184]],
    [ "52822145",[-83.33559528423405, 32.42668762540872]],
    [ "52907101",[-94.92142868679383, 29.82899447017584]],
    [ "Monocacy SVC Substation",[-77.40111044709434, 39.43957567890237]],
    [ "Mont Belvieu Substation",[-94.89400905538744, 29.840150589490303]],
    [ "Warvue Substation",[-94.89316291262789, 29.836924970378725]],
    [ "Young Harris Substation",[-83.84588236994836, 34.94698289270401]],
    [ "53100364",[-122.65323304103983, 47.55581411628602]],
    [ "53130300",[-116.05845661951108, 43.528042139496726]],
    [ "53140902",[-116.3335180167102, 43.50661738830096]],
    [ "Channelview Cogen Substation",[-95.12347157325057, 29.83664789309992]],
    [ "Entergy Arkansas",[-92.00843012257717, 34.60845881364574]],
    [ "England Substation",[-91.99202567526231, 34.58414413909306]],
    [ "Epworth Substation",[-84.37026158799405, 34.94823784626436]],
    [ "North Tifton Substation (500kV)",[-83.54902471406845, 31.478407725047095]],
    [ "North Tifton Substation (115kV)",[-83.54459149425941, 31.47497518273128]],
    [ "Oglethorpe Substation",[-85.26458766958307, 34.95545765857255]],
    [ "Crawfish Creek Substation",[-85.53557482061292, 34.81848244394928]],
    [ "Tunnel Hill Substation",[-85.01377858706846, 34.85704624600755]],
    [ "Rock Spring Substation",[-85.27994104999999, 34.83920680000001]],
    [ "53165310",[-85.28042366444672, 34.83795887817288]],
    [ "53200676",[-85.49105980921156, 34.865608564933105]],
    [ "Rising Fawn Substation",[-85.5340128709137, 34.76723754007788]],
    [ "Cummings Substation",[-85.38923229999999, 35.016016799999996]],
    [ "53257515",[-112.0075445385971, 41.27423722882221]],
    [ "53265941",[-84.89971056710588, 34.75993220206524]],
    [ "Chatsworth Substation",[-84.77979605, 34.761647849999996]],
    [ "53270541",[-84.68114486203967, 34.61567404684012]],
    [ "Carters Dam Substation",[-84.67379749172959, 34.61236779531988]],
    [ "Conasauga Substation",[-84.90815798370491, 34.703079001094565]],
    [ "53271643",[-84.95947547410232, 34.74606494102708]],
    [ "Dug Gap Substation",[-85.00170013066788, 34.7448149507822]],
    [ "Thomas A Energy Switching Station",[-84.92277922494172, 34.708844493503385]],
    [ "53276800",[-84.853116136045, 34.812985359421845]],
    [ "53276806",[-84.75985343858689, 34.8371647708526]],
    [ "NASA Substation",[-95.08525021258075, 29.563127388685878]],
    [ "Polaris Substation",[-95.09882019903546, 29.57842082775617]],
    [ "Mount Zion Substation",[-77.10354012105729, 39.19029141532801]],
    [ "Norbeck Substation",[-77.07906183114385, 39.13189966977439]],
    [ "Quince Orchard Substation",[-77.29281050030212, 39.13653361371714]],
    [ "53345314",[-84.94997595097169, 34.812169659263745]],
    [ "53345353",[-84.95152359823955, 34.896698814943214]],
    [ "Summerville Substation",[-85.33752601680273, 34.47188728569921]],
    [ "LaFayette Primary Substation",[-85.2726632473364, 34.703085853915205]],
    [ "Mohawk Substation",[-84.98523493296355, 34.694410946042396]],
    [ "Armand Substation",[-95.08808395531399, 29.624016628064805]],
    [ "Southeast Substation",[-95.1511252609794, 29.629665374585333]],
    [ "Doubs Substation",[-77.51480430993095, 39.29640124946116]],
    [ "Dickerson H Substation",[-77.45277981890298, 39.20769645970396]],
    [ "Dickerson D Substation",[-77.46259922366895, 39.208889543355646]],
    [ "High Ridge Substation",[-76.87282878886774, 39.141099654846364]],
    [ "Howard Substation",[-76.78182836040749, 39.231435567840194]],
    [ "53545266",[-76.8229252267407, 39.378060122716775]],
    [ "Frederick Road Substation",[-76.78341473067951, 39.262007976182424]],
    [ "Pumphrey Substation",[-76.63524817498211, 39.227609578561925]],
    [ "Omaha Public Power District",[-96.02332093072698, 41.24500307359172]],
    [ "North Nashville Substation",[-86.71315069218237, 36.2776890610178]],
    [ "Lime Kiln Substation",[-77.43605793776709, 39.36244226145806]],
    [ "53757048",[-85.0697122714673, 34.90525594059417]],
    [ "IX Center Substation",[-81.85574222784251, 41.39618502710101]],
    [ "P. H. Robinson Switching Station",[-94.98242183963077, 29.487515802346564]],
    [ "Battlefield Substation",[-85.17887665, 34.934712600000005]],
    [ "Northwest Substation",[-76.84056999637855, 39.46363227437413]],
    [ "Constatone Substation",[-76.54046303752953, 39.68741343936315]],
    [ "Brighton Substation",[-77.03662372851085, 39.18553030156918]],
    [ "Waugh Chapel Substation",[-76.67690330291913, 39.04595022456051]],
    [ "Bowie Substation",[-76.7720338528067, 39.01526742030699]],
    [ "Chickamauga Substation",[-85.27968879938297, 34.88228647955562]],
    [ "Burtonsville Substation",[-76.90572755968643, 39.09011378391748]],
    [ "Takoma Substation",[-76.99754231571494, 38.96971341328427]],
    [ "Metzerott Road Substation",[-76.95716226087336, 39.00549721968205]],
    [ "53833660",[-86.59142777634705, 34.72306562146122]],
    [ "Ellington Substation",[-95.18056717164625, 29.58815505220718]],
    [ "East Side Substation",[-95.35311982752827, 29.747041995444924]],
    [ "Damascus Substation",[-77.22196696249434, 39.2716473106131]],
    [ "Clarksburg Substation",[-77.28935935780231, 39.24078081265945]],
    [ "North Camas Substation",[-122.36975765815042, 45.60438950995714]],
    [ "Oak Park Substation",[-122.38043161395645, 45.582200321743755]],
    [ "Troutdale Substation",[-122.40875148039366, 45.55947193533764]],
    [ "Troutdale Substation",[-122.40383878129914, 45.55886153576649]],
    [ "North Bonneville Substation",[-121.96013857710139, 45.648487445518995]],
    [ "Graceton Substation",[-76.3860820116191, 39.69905001713455]],
    [ "Raphael Road Switching Station",[-76.4011984303606, 39.4158386853764]],
    [ "Pasadena Substation",[-95.22331253354338, 29.689968861990952]],
    [ "Erdman Substation",[-76.56274658824873, 39.308271061292544]],
    [ "Westport Substation",[-76.63066420127929, 39.265558811663745]],
    [ "Magnolia Park Substation",[-95.31093974139843, 29.74371291963599]],
    [ "Downtown Substation",[-95.37372040172185, 29.75526647642496]],
    [ "Eastpoint Substation",[-76.5068611848687, 39.29919424254173]],
    [ "Lipins Corner Substation",[-76.58694493128557, 39.146414798874865]],
    [ "Turnpike Substation",[-74.11710925081026, 40.760623423084034]],
    [ "Pearl Substation",[-122.77729160127257, 45.329112623779764]],
    [ "Oregon City Substation",[-122.77903899035836, 45.332718059022135]],
    [ "Sherwood Substation",[-122.83629328388953, 45.37173029746233]],
    [ "Marion Substation",[-122.69854543372067, 44.79964891058074]],
    [ "Bingen Substation",[-75.34350226992892, 40.565338249618605]],
    [ "54928159",[-94.42291911393312, 37.09835368850897]],
    [ "55137701",[-93.30842075803871, 45.17080729328889]],
    [ "Alston Substation",[-123.03428993250299, 46.10791504181325]],
    [ "Eden Prairie Substation",[-93.43533141312672, 44.86286100014936]],
    [ "Puget Sound Energy",[-122.95493725070465, 47.02484740870288]],
    [ "Pacific Gas and Electric Company",[-121.73332066815604, 37.742491216024675]],
    [ "Long Hill Substation",[-71.45242815361473, 42.732440741355695]],
    [ "55600415",[-123.37296472473216, 46.98661759315435]],
    [ "55616710",[-116.73462999418385, 33.91713757507102]],
    [ "55668907",[-103.0149327, 46.1205068]],
    [ "Northeast Substation",[-76.42803054949088, 39.3652171774127]],
    [ "Frederick Substation",[-77.40284006976582, 39.419589030326996]],
    [ "55896489",[-87.01330838757852, 39.07190650127886]],
    [ "Franklin Substation",[-119.0411565521847, 46.231196540109956]],
    [ "Little Goose Substation",[-118.05310548080361, 46.58225987976454]],
    [ "Dworshak Substation",[-116.36733901505201, 46.528411068007294]],
    [ "John Day Substation",[-120.73787834200793, 45.677896074642106]],
    [ "Harvalum Substation",[-120.70579511992939, 45.728794527262046]],
    [ "Celilo Converter Station",[-121.11334950384487, 45.595695397600245]],
    [ "Big Eddy Substation",[-121.10788219596911, 45.603663317209474]],
    [ "Big Eddy Substation",[-121.1157723651183, 45.60639154672577]],
    [ "McNary Substation",[-119.31345131962554, 45.924002865163914]],
    [ "Buckley Substation",[-120.90042775693405, 45.2309036700927]],
    [ "56134251",[-120.5322541565615, 45.783667874770856]],
    [ "Manitou Hydro Substation",[-104.93335973355983, 38.855771823868075]],
    [ "Railyard Substation",[-70.89691468754089, 42.51330359238252]],
    [ "56271524",[-119.673629745068, 45.847125978900394]],
    [ "88th St. Substation",[-93.82709378898198, 41.58955418176052]],
    [ "Ashe Substation",[-119.33585621916292, 46.48031157881975]],
    [ "Ashawa Substation",[-93.75528693251105, 41.569407203216244]],
    [ "MidAmerican Energy",[-94.01677298536758, 41.61560557504831]],
    [ "Cape Horn Substation",[-122.17697667353232, 45.592828624153896]],
    [ "Wilde Lake Substation",[-76.87381032413664, 39.21331672025015]],
    [ "57706738",[-119.58824904776016, 46.58032920596847]],
    [ "57766453",[-119.60084590000001, 46.6467192]],
    [ "57766454",[-119.59373731656214, 46.649160800092424]],
    [ "Farmington Substation",[-72.7936560740058, 41.74183661678361]],
    [ "Carrington Substation",[-99.11109053625529, 47.45802583262314]],
    [ "Kingswood Substation",[-76.90665855400042, 38.83861127788667]],
    [ "Ritchie Substation",[-76.87750585330018, 38.880119679753975]],
    [ "Palmers Corner Substation",[-76.95894875359542, 38.773327356600106]],
    [ "North Greenville Tie Substation",[-82.43761260773891, 34.890237927453214]],
    [ "Valmont Substation",[-105.20352991880281, 40.0174445716858]],
    [ "Beulah Substation",[-101.76101475, 47.269657599999995]],
    [ "Cedar Creek Substation",[-94.86313914343481, 38.94282448721943]],
    [ "Antelope Valley Substation",[-101.84233486261644, 47.37099449252454]],
    [ "Spring Creek Substation",[-120.3843162221279, 45.980179543153]],
    [ "Leland Olds 345 kV Substation",[-101.31534219266305, 47.28239750633777]],
    [ "58745573",[-101.31876041856151, 47.28306270793729]],
    [ "58755531",[-101.33358741182107, 47.28659160964164]],
    [ "58756169",[-119.80708021585696, 39.55395229259763]],
    [ "NV Energy",[-119.80654422636529, 39.558285118511726]],
    [ "Wautoma Substation",[-119.83405081666204, 46.51537919766126]],
    [ "Crestwood Substation",[-83.19631657132857, 42.32737982091043]],
    [ "Coyote Substation",[-101.80245271544034, 47.228981425303424]],
    [ "59139114",[-98.34762513820203, 40.856457630568464]],
    [ "UC Davis Substation",[-121.75138239850003, 38.52909674890067]],
    [ "Viejo Substation",[-117.64243351132204, 33.66691082270926]],
    [ "Vacaville Substation",[-121.98057285059336, 38.35643477230199]],
    [ "Ashburn Substation",[-77.4982456517319, 39.05140604258748]],
    [ "Beaumeade Substation",[-77.45633882849025, 39.02605783956745]],
    [ "59338421",[-100.88490415961452, 48.021449463751594]],
    [ "59338422",[-100.88386158137976, 48.02390757216592]],
    [ "Reston Substation",[-77.34565504448547, 38.952946590832234]],
    [ "Clark Substation",[-77.27130164369186, 38.90712010878212]],
    [ "Hunter Substation",[-77.30377796500656, 38.931667779381954]],
    [ "ComEd Rolling Meadows 138kV Substation",[-88.003693892423, 42.05058561037048]],
    [ "59432768",[-101.3315125724572, 47.277028720857444]],
    [ "59433498",[-101.1959506085797, 47.071797488520566]],
    [ "Center 345kV Switchyard",[-101.19931380612736, 47.07607079957381]],
    [ "59433504",[-101.19908251379226, 47.07182622611887]],
    [ "59434249",[-101.21349685277376, 47.067584037869096]],
    [ "Tidd Substation",[-80.65059989323778, 40.25321622584453]],
    [ "South East Canton Substation",[-81.32922432986166, 40.77327075259788]],
    [ "North Tower Substation",[-122.19638424580364, 38.06622139316984]],
    [ "Dumbarton Substation",[-122.05787299102948, 37.5570682323891]],
    [ "Stanton Tap Substation",[-101.50556330499231, 47.350507817558864]],
    [ "Limestone Substation",[-117.68859158803515, 33.65022648723018]],
    [ "Passyunk Substation",[-75.18831337269349, 39.92113810976513]],
    [ "Limerick 500 kV Substation",[-75.58276913704226, 40.220730531528304]],
    [ "Underwood Substation",[-101.15628853621145, 47.37360630017542]],
    [ "Washburn Substation",[-101.03697776270506, 47.304803256598234]],
    [ "Jamestown Substation",[-98.6839512, 46.876013900000004]],
    [ "Greenwood Substation",[-94.75989553125768, 39.010452878013645]],
    [ "Lenexa Substation",[-94.76907256814182, 38.957466583652284]],
    [ "Callaway Substation",[-91.78444829374494, 38.75878098073048]],
    [ "Southern California Edison",[-117.6317839165344, 33.62960111951611]],
    [ "LG&E",[-85.60557465734804, 38.1705346983967]],
    [ "60140171",[-85.56881149748529, 38.11687740039445]],
    [ "Subestación Aguirre",[-66.23074119908068, 17.95193952398446]],
    [ "Louisville Gas & Electric Company",[-85.51242581272442, 38.22474959795932]],
    [ "60143511",[-85.68398129054124, 38.13918095252515]],
    [ "Brill Substation",[-75.22413807424259, 39.92924247147763]],
    [ "Excelsior Substation",[-93.5653075151277, 44.90005644034581]],
    [ "Hettinger Substation",[-102.61986689577337, 46.03276456160093]],
    [ "LG&E",[-85.73618332527164, 38.13181257417706]],
    [ "Puerto Rico Electric Power Authority",[-66.1618278, 18.174855]],
    [ "Salisbury Substation",[-92.85080920128098, 39.40731673918946]],
    [ "Chip Substation",[-117.86062269999998, 33.66059715000001]],
    [ "60551577",[-102.68377840000001, 46.249618]],
    [ "Dickinson Substation",[-102.7500088600275, 46.838617943714375]],
    [ "Thomas Hill 345kV Substation",[-92.6409285691032, 39.54481688888573]],
    [ "Thomas Hill 161kV Substation",[-92.63918466141234, 39.54803441115389]],
    [ "60711123",[-102.83169464824199, 46.55653809251178]],
    [ "Katonah Substation",[-73.68703559020547, 41.276567613815715]],
    [ "Road Runner Substation",[-112.01459079383227, 33.581056692698375]],
    [ "60959698",[-87.17076687813014, 39.033929534848305]],
    [ "60965511",[-92.4094365817062, 39.51180283183903]],
    [ "61165896",[-119.52131925115253, 36.60752664604958]],
    [ "61192783",[-103.73222509700064, 48.141677948215566]],
    [ "Florida Power & Light",[-80.38007687884517, 25.818277291186224]],
    [ "Florida Power & Light",[-80.33088998125363, 25.830175668998386]],
    [ "61240408",[-80.35362284526663, 25.83117007558755]],
    [ "Elwood Substation",[-73.33957983363871, 40.876965070929444]],
    [ "61261912",[-119.80334656893709, 36.849883426260774]],
    [ "61267868",[-84.3711561928682, 39.48164181474495]],
    [ "Reach Substation",[-111.99372183560074, 33.669121423649045]],
    [ "Duke Energy",[-84.42215678307393, 39.15699185357458]],
    [ "Cima Substation",[-115.51559675723696, 35.252187448349396]],
    [ "61430457",[-116.36742476099371, 33.81774658964401]],
    [ "61430458",[-116.36966327178524, 33.818331585949664]],
    [ "Devers Substation",[-116.57733400550615, 33.93856789083259]],
    [ "Entergy Arkansas",[-90.22159176342953, 35.175054318981765]],
    [ "61473019",[-119.82767853069113, 36.792798246454254]],
    [ "Entergy Arkansas",[-90.22872252524996, 35.20592479408089]],
    [ "Gilmore Substation",[-90.27402180917147, 35.402587425665864]],
    [ "61531590",[-119.78775200790896, 36.788094976416055]],
    [ "Morgan Hill Substation",[-121.65923368830116, 37.126796593776575]],
    [ "Mays Chapel Substation",[-76.6680910253847, 39.45495025083164]],
    [ "Valley Substation",[-117.15629374836887, 33.73943047019726]],
    [ "61699292",[-119.09332555456798, 46.109860162170875]],
    [ "Beco Substation",[-77.43738815180448, 39.02451666432083]],
    [ "61726953",[-76.99501909132805, 39.40940197108004]],
    [ "61811029",[-119.88000505000002, 36.70680375]],
    [ "Erie West Substation",[-80.38443686877201, 41.93437345165961]],
    [ "61870709",[-119.68123081282572, 36.82622725823796]],
    [ "Cabrillo Substation",[-117.84759867641415, 33.67182684870725]],
    [ "Moulton Substation",[-117.69764023800128, 33.60913821125003]],
    [ "Southern California Edison",[-117.8498677459657, 33.73319462973552]],
    [ "Villa Park Substation",[-117.83460378668467, 33.81518688331222]],
    [ "Modena Substation",[-117.80272405000002, 33.78825145]],
    [ "Estrella Substation",[-117.82859640000001, 33.68751345]],
    [ "Johanna Substation",[-117.8524929245684, 33.713329017839584]],
    [ "Rock Ridge Substation",[-76.45992805954513, 39.6137379048671]],
    [ "Five Forks Substation",[-76.41157994751542, 39.695551870464556]],
    [ "Glenarm Substation",[-76.50215407464856, 39.45333363618913]],
    [ "Chalk Point Switching Station",[-76.68876374023644, 38.56037748408369]],
    [ "Viaduct Avenue Substation",[-76.71414547253549, 39.22631662798492]],
    [ "Hazelwood Substation",[-76.52615633826241, 39.3403857166304]],
    [ "Highlandtown Substation",[-76.56373566821046, 39.29559355787383]],
    [ "Middle River Substation",[-76.43902680647453, 39.32811054971164]],
    [ "62067610",[-76.48931275545375, 39.236816187045655]],
    [ "Glory Substation",[-78.89697454776376, 40.64079145783649]],
    [ "Pender Substation",[-77.37217455881752, 38.87445503567886]],
    [ "Baltimore Gas & Electric",[-76.5357479788816, 39.182025229100084]],
    [ "Baltimore Gas & Electric",[-76.53015853130196, 39.17744494832811]],
    [ "62151568",[-76.67441498496804, 39.04186954327456]],
    [ "62152908",[-76.59288435927526, 39.0393279025539]],
    [ "62152912",[-76.53658539999999, 38.9929774]],
    [ "62152915",[-76.5324460031507, 38.98952391648394]],
    [ "Baltimore Gas and Electric",[-76.69588687403161, 39.08878878833271]],
    [ "Crystal Springs Substation",[-76.78385425086478, 39.13243320743439]],
    [ "Jericho Park Substation",[-76.76924520518949, 39.01560837713883]],
    [ "Sandy Spring Substation",[-76.90320869840092, 39.09407066604234]],
    [ "Cardiff Substation",[-117.27782781326219, 34.10218643644072]],
    [ "South Cape Substation",[-80.60142963464071, 28.420500226963007]],
    [ "Pisgah Switchyard",[-116.38468093426592, 34.781665043233104]],
    [ "Central Electric Power Co-Op",[-94.05884953036991, 38.93862105582219]],
    [ "Central Electric Power Co-Op",[-94.08682481329997, 38.995900309892114]],
    [ "Central Electric Power Co-Op",[-94.12931342138891, 39.0617106022007]],
    [ "Sibley Substation",[-94.1643711787974, 39.1692281864693]],
    [ "Pleasant Hill Substation",[-94.30053522332769, 38.79639692561908]],
    [ "North Substation",[-80.58665712368325, 28.55536517518563]],
    [ "Eldorado Substation",[-115.00848008950052, 35.797323805794115]],
    [ "Ellis Substation",[-117.94317728143669, 33.68524813682443]],
    [ "Southern California Edison",[-117.95268815103925, 33.65452887807381]],
    [ "62343814",[-76.9930700019971, 39.58116656703491]],
    [ "Baltimore Gas and Electric",[-76.88390326810405, 39.49789365292804]],
    [ "Morgantown Substation",[-76.96397726296317, 38.35943924948308]],
    [ "Mount Airy Substation",[-77.17217593423213, 39.39803408789516]],
    [ "Catoctin Substation",[-77.40979415751909, 39.61340519011022]],
    [ "Carrol Substation",[-77.18236400370698, 39.56558487651459]],
    [ "62483229",[-77.17473857144273, 39.65278321687724]],
    [ "Sabinsville Substation",[-77.5354014007737, 41.86494783495088]],
    [ "Gold Substation",[-77.76652801859493, 41.86558953492276]],
    [ "Farmers Valley Substation",[-78.44738018198373, 41.855026000839224]],
    [ "Benette",[-77.65725099296121, 42.307293118337235]],
    [ "Ringgold Substation",[-77.56620862552089, 39.67176271038217]],
    [ "Walkersville Substation",[-77.35103355297797, 39.49131931592224]],
    [ "63043579",[-77.25573360052692, 39.39699546750693]],
    [ "63043608",[-77.31014991727751, 39.42304159848197]],
    [ "Reid Substation",[-77.68974826388917, 39.71407443266719]],
    [ "East Hagerstown Substation",[-77.6607981, 39.6224002]],
    [ "Antietam Substation",[-77.69261183203552, 39.64755276435243]],
    [ "63058390",[-77.7801796227056, 39.635786968037614]],
    [ "63058407",[-77.83465490730458, 39.593166706860515]],
    [ "Boonsboro Substation",[-77.63986292807385, 39.5126463976818]],
    [ "63588136",[-77.42535336822787, 39.4439138535524]],
    [ "McCain Substation",[-77.44702548668697, 39.403047346872995]],
    [ "Aqueduct Substation",[-77.44145045035877, 39.22537764380262]],
    [ "64083268",[-114.96675762260806, 34.84488970697286]],
    [ "Bailey Substation",[-118.77470376095923, 34.77648445622943]],
    [ "Serrano Substation",[-117.78964466770485, 33.82892063816497]],
    [ "Lookout Substation",[-105.20287983373429, 39.734156777551846]],
    [ "Quaker Substation",[-105.182243818685, 39.77362782748815]],
    [ "Ridge Substation",[-105.12267804297507, 39.78906620235235]],
    [ "Matters Corner Substation",[-96.57681908182336, 39.21670025281217]],
    [ "Leggett Substation",[-105.20606328085496, 40.01882197754178]],
    [ "64614627",[-80.80501244794473, 35.156078469296986]],
    [ "Otter Point Substation",[-76.28348958879455, 39.45176873934598]],
    [ "Buena Vista Substation",[-76.82027873677985, 38.96006641983008]],
    [ "Butler Substation",[-79.8796183730969, 40.857795258424794]],
    [ "Evergy",[-94.11870025348321, 39.20366294697589]],
    [ "Oak Grove Switching Station",[-76.80134567390058, 38.85677730180493]],
    [ "Livingston Road Substation",[-76.98826927094397, 38.79111791240948]],
    [ "Niwot Substation",[-105.17915457593743, 40.069911354214]],
    [ "Fort Saint Vrain Switching Station",[-104.87397882107193, 40.243254115974835]],
    [ "Burches Hill Substation",[-76.87094567621415, 38.73838710867783]],
    [ "Discovery Substation",[-77.42839600449976, 38.91978645062621]],
    [ "Talbert Switching Station",[-76.80574025394343, 38.713867449503326]],
    [ "Indian Bend Substation",[-111.9839729997585, 33.5974466864339]],
    [ "Keystone Substation",[-79.33853000697019, 40.65772677971603]],
    [ "Eldorado Substation",[-105.26194481636007, 39.93630754384298]],
    [ "Ralston Substation",[-105.13093508352661, 39.811481723722935]],
    [ "Sibley Plant Substation",[-94.18468321148937, 39.17684081170857]],
    [ "Hinson Substation",[-118.22248146240428, 33.819055283626966]],
    [ "65481169",[-118.24383671558473, 33.81745448189616]],
    [ "Meadow Lane Substation",[-122.05226254539973, 37.96320360415136]],
    [ "Blue Springs West Substation",[-94.32318698455073, 39.01487546157792]],
    [ "Wright-Hennepin Electric Cooperative Association",[-93.72923372953619, 45.02169797525228]],
    [ "Greenfield Substation",[-93.68636182620432, 45.08719031079832]],
    [ "Barre Substation",[-117.98245677667003, 33.808929163601206]],
    [ "Bowie Substation",[-76.78128008730472, 39.0059679786517]],
    [ "Ridgeview Substation",[-76.69856550251322, 39.15687893708326]],
    [ "Lanham Substation",[-76.87407677856044, 38.94735069267936]],
    [ "Tuxedo Substation",[-76.91095278576137, 38.91747627311633]],
    [ "Severn Substation",[-76.69698152485317, 39.13894335305731]],
    [ "Lone Peak Substation",[-112.05583848539928, 33.65580721901141]],
    [ "Bunker Ridge Substation",[-94.52757995116319, 38.94556109599407]],
    [ "Hogback Switching Station",[-105.19314370950543, 39.69774820300283]],
    [ "Trask Substation",[-117.97956595, 33.7661247]],
    [ "Lakewood Substation",[-105.10732438049106, 39.74693505869393]],
    [ "Lighthipe Substation",[-118.1751969688052, 33.88027962264934]],
    [ "Center Substation",[-118.10546965359677, 33.92879977446185]],
    [ "Gray Street Substation",[-105.06086763871865, 39.73455130781255]],
    [ "Mesa Substation",[-118.11141540617798, 34.03624240429379]],
    [ "Steed Road Substation",[-76.92309699039141, 38.755216033473005]],
    [ "Gallahan Road Substation",[-76.9734926753758, 38.721968842052085]],
    [ "Burches Hill Substation",[-76.89450600993233, 38.72356764460236]],
    [ "Cherokee Switchyard",[-104.96671167580901, 39.808286880821356]],
    [ "Mapleton Substation",[-104.9652810186965, 39.802647940443535]],
    [ "Arapahoe Switchyard",[-105.00365221732574, 39.66875633695554]],
    [ "Tassajara Substation",[-121.9076919608773, 37.80001671315713]],
    [ "San Ramon Substation",[-121.93641578706172, 37.74471740564536]],
    [ "Vineyard Substation",[-121.85442559998403, 37.669711080399374]],
    [ "66496295",[-78.92501679777988, 36.05673042995669]],
    [ "66543928",[-78.879887775485, 36.004032092224946]],
    [ "66555722",[-78.90439062134638, 36.00820666319477]],
    [ "66560983",[-78.86771010000001, 35.944539850000005]],
    [ "66560986",[-78.89605049968488, 35.903110746932704]],
    [ "Sheridan Substation",[-105.01280779804621, 39.65615262194989]],
    [ "66762814",[-79.01779064270501, 36.045787254522324]],
    [ "Roxboro Plant Substation",[-79.07224789182459, 36.48093074267277]],
    [ "Sandown Substation",[-104.90054606260229, 39.772992971442456]],
    [ "Riva Road Substation",[-76.60648518244895, 38.93989823409235]],
    [ "Marriott Hill Substation",[-76.61411249999999, 38.8831454]],
    [ "66794233",[-76.44424669529621, 38.43276197737731]],
    [ "Missouri City Substation",[-94.3092053521828, 39.231962464273124]],
    [ "Eckles Road Substation",[-94.24149224528145, 39.171255269865945]],
    [ "Bryan Substation",[-117.80234366720275, 33.73454542616303]],
    [ "Irvine Substation",[-117.74228808561345, 33.68305765414315]],
    [ "Rose Canyon Substation",[-117.23705857274973, 32.84446579484429]],
    [ "Wilkins Substation",[-111.97900949656109, 33.3932980678039]],
    [ "Sunset Substataion",[-94.725848250304, 39.13908836912437]],
    [ "PEPCO",[-76.94128539926125, 38.825838696379904]],
    [ "Pleasant Garden Tie Substation",[-79.75426258589785, 35.94148266690856]],
    [ "Planebrook Substation",[-75.58536117390852, 40.03634259979553]],
    [ "Lake Buena Vista Substation",[-81.51642720204516, 28.37993239267289]],
    [ "67870244",[-79.65655742873362, 35.96698629714737]],
    [ "Cecil Substation",[-75.84325056284872, 39.608592922383885]],
    [ "Colora Substation",[-76.0964501065435, 39.68152192451093]],
    [ "Steele Substation",[-75.81639656378151, 38.892309707314766]],
    [ "OG&E",[-96.22153990432327, 36.003763176703416]],
    [ "Boulevard Substation",[-111.96407893494022, 33.66482507462253]],
    [ "Arkansas Electric Cooperative Corporation",[-90.58820265029303, 35.708284966660436]],
    [ "68277236",[-84.86277570544229, 39.085139266502935]],
    [ "68279214",[-84.6349266, 38.9720421]],
    [ "68280285",[-84.62113762123788, 38.97910788104782]],
    [ "68282824",[-84.60899083238745, 38.983909520804026]],
    [ "Turkey Foot Substation",[-84.59000305707887, 38.97285503724203]],
    [ "Mount Pleasant Substation",[-75.74274488346087, 39.48962364112986]],
    [ "68294325",[-78.93880306920177, 36.01232862048105]],
    [ "Townsend Substation",[-75.75334938024528, 39.39499001337869]],
    [ "Church Substation",[-75.84855726997822, 39.24269195892875]],
    [ "I.B. Corners Substation",[-75.94912028322221, 39.18690581551935]],
    [ "Riley Substation",[-94.67108318552842, 38.90877491366916]],
    [ "Oil City Substation",[-75.81257219918153, 38.90042170076024]],
    [ "Substation 3",[-76.0796053958936, 38.81209002062047]],
    [ "Easton Substation",[-76.08837106745786, 38.77221174375594]],
    [ "Longwood Substation",[-76.06174988906692, 38.86035497334033]],
    [ "Oxford Substation",[-94.68923921052944, 38.86636288274727]],
    [ "Omaha Public Power District",[-96.02801422179886, 41.21933028429916]],
    [ "UNMC Substation",[-95.98340014479979, 41.25396054816572]],
    [ "Omaha Public Power District",[-95.96194227281491, 41.25304916537604]],
    [ "Omaha Public Power District",[-95.94126327567803, 41.25116930214387]],
    [ "Omaha Public Power District",[-95.92249224421383, 41.250970082626054]],
    [ "Wye Mills Substation",[-76.06262622647778, 38.9465074902029]],
    [ "Vienna Substation",[-75.82178115862447, 38.49011078374855]],
    [ "Loretto Substation",[-75.66171801711488, 38.261785333206134]],
    [ "Nelson Substation",[-75.58308237240489, 38.46550831191656]],
    [ "Edgewood Substation",[-75.57960887159004, 38.43062871065864]],
    [ "Mardela Substation",[-75.7269232650883, 38.441799587410515]],
    [ "Hebron Substation",[-75.69695112204329, 38.42414439507742]],
    [ "Sharptown Substation",[-75.75152053162483, 38.492094841852776]],
    [ "Laurel Substation",[-75.5780273545786, 38.56300796835746]],
    [ "Kings Creek Substation",[-75.68734409592018, 38.16289624619296]],
    [ "Costen Substation",[-75.6081553602722, 38.09750596781733]],
    [ "Pecomboke Substation",[-75.57719739792304, 38.06650853132668]],
    [ "Pinery Grove Substation",[-75.50165699684509, 38.29495019216815]],
    [ "North Salisbury Substation",[-75.6078397061409, 38.38487099248837]],
    [ "Mount Hermon Substation",[-75.56245787627036, 38.363307515605904]],
    [ "Virginia Hills Substation",[-77.10849174682073, 38.784859074090754]],
    [ "Kenney Substation",[-75.36854830268673, 38.171839194514675]],
    [ "Mt. Olive Substation",[-75.4442931511443, 38.251958701190624]],
    [ "Stockton Substation",[-75.41769162473526, 38.05720881658495]],
    [ "Amsterdam Substation",[-83.07371716418628, 42.364995225618486]],
    [ "Magic Kingdom Substation",[-81.58025723748777, 28.426797713044635]],
    [ "Northwest Substation",[-81.58461618550893, 28.42757328269755]],
    [ "Martin City East Substation",[-94.5807593896403, 38.87830370595622]],
    [ "University of South Florida Substation",[-82.43004440896352, 28.066924537926486]],
    [ "Indian River South Substation",[-75.24060360367127, 38.583765970573616]],
    [ "Indian River Generation Substation",[-75.23941911452903, 38.58575214126754]],
    [ "Indian River North Substation",[-75.24360048236029, 38.58567384365362]],
    [ "69546923",[-119.8979860672102, 47.159774318229495]],
    [ "100th & Douglas Substation",[-93.75502194666956, 41.6266168401912]],
    [ "Ocean Bay Substation",[-75.06205634170882, 38.40332465471219]],
    [ "Omar Substation",[-75.17424658367999, 38.53529190876805]],
    [ "Delmarva Power",[-75.06282728698446, 38.523844910544966]],
    [ "Bayard Substation",[-75.12642140944345, 38.527912563244]],
    [ "Delmarva Power",[-75.06464387062219, 38.52402993927932]],
    [ "Robinsonville Substation",[-75.19158898278634, 38.7135467090007]],
    [ "Angola Substation",[-75.16712621975581, 38.676075263264764]],
    [ "Renhoboth Substation",[-75.09669967603355, 38.70873256669783]],
    [ "Azalea Substation OUC",[-81.29792607758857, 28.553030054630046]],
    [ "Substation No. 18 Robinson",[-81.38154901989675, 28.54607322242213]],
    [ "Reedy Creek Improvement District",[-81.58845494518897, 28.375697370789933]],
    [ "Milford Substation",[-75.39991948149171, 38.88096898365087]],
    [ "Main Substation",[-75.39866442181544, 38.882179299869485]],
    [ "North Seaford Substation",[-75.61763203552782, 38.66586956527251]],
    [ "Bridgeville Substation",[-75.60694237404928, 38.73518274338716]],
    [ "Taylor Substation",[-75.61770412136653, 38.68378724214678]],
    [ "South Harrington Substation",[-75.57921295025143, 38.89396938896965]],
    [ "Admin Substation",[-81.53338669945582, 28.396493197928717]],
    [ "Taft Substation OUC",[-81.37536327497551, 28.373999943171505]],
    [ "Employee Substation",[-81.33662393959523, 28.32131887396213]],
    [ "Isleworth Substation",[-81.54974217465121, 28.465059840726717]],
    [ "Taft Substation DUKE",[-81.37476362924012, 28.375509247269214]],
    [ "Duke Energy",[-81.54608409212595, 28.26249768694791]],
    [ "Cane Island Substation",[-81.53164281166366, 28.27695768493704]],
    [ "Town of Middletown",[-75.72496453528635, 39.435679278171854]],
    [ "Felton Substation",[-75.57482195183083, 39.01544459170247]],
    [ "Cheswold Substation",[-75.5710644043883, 39.204113147273965]],
    [ "Dundee Substation",[-81.59378883145118, 28.00558896665319]],
    [ "69970772",[-81.63151483404033, 28.442218180242822]],
    [ "Hemple Substation",[-81.52569506948579, 28.534208694106965]],
    [ "Bay Hill Substation",[-81.5058312704837, 28.477779695637558]],
    [ "Orangewood Substation",[-81.45464046299996, 28.417940435855837]],
    [ "Shingle Creek Substation",[-81.42091190772592, 28.41245991649071]],
    [ "Hickman Substation",[-94.5339975797052, 38.91607361349533]],
    [ "Duke Energy",[-81.42053147793092, 28.451258682726507]],
    [ "Parkway Substation",[-81.41646596355957, 28.438032818585757]],
    [ "Duke Energy",[-81.39174112507541, 28.422380257308028]],
    [ "70079375",[-81.44222903497844, 28.498207743414408]],
    [ "Turkey Lake Substation",[-81.44184045, 28.51270695]],
    [ "Indian River Plant Substation OUC",[-80.78067765725264, 28.492017869347666]],
    [ "Kissimmee Utility Authority",[-81.39263778778422, 28.334620290568232]],
    [ "Kissimmee Utility Authority",[-81.37577444859265, 28.332993841641706]],
    [ "Kaley Substation",[-81.37770672756301, 28.519759120005578]],
    [ "America Substation",[-81.38229587095441, 28.53465241555316]],
    [ "Michigan Substation OUC",[-81.35115037185926, 28.512574711718937]],
    [ "Grant Substation OUC",[-81.31920758962524, 28.516463625197893]],
    [ "Holden Substation",[-81.40867934144279, 28.493849725230678]],
    [ "Sky Lake Substation",[-81.3766505562662, 28.44919558815798]],
    [ "Car Care Substation",[-81.5746426190105, 28.391301915920184]],
    [ "Hoover Substation",[-97.40823877001901, 37.6865733205162]],
    [ "Four Corners Substation",[-81.59131773772948, 28.34751430579077]],
    [ "ComEd Itasca 138kV-345kV Substation",[-87.99574239289501, 41.9795501807802]],
    [ "Pleasant Hill Substation",[-88.13511758249736, 41.900235022961546]],
    [ "Harrison Substation",[-122.65824380000001, 45.50900955]],
    [ "Harrison Substation",[-122.65726126195695, 45.509006725010686]],
    [ "Delco Tap Substation",[-75.38803491463237, 39.829363204218865]],
    [ "Perryman Substation",[-76.21755820148614, 39.441040699689395]],
    [ "Larkin Substation",[-122.41704870318031, 37.78367293347944]],
    [ "Ferndale Substation",[-76.62764432679221, 39.18078017829226]],
    [ "Desert Springs Substation",[-111.95978055024091, 33.6228624613587]],
    [ "Lake Wilson Substation",[-81.5826944945605, 28.30011117089605]],
    [ "71338072",[-94.30525921035917, 37.13923992336128]],
    [ "Hunter's Creek Substation",[-81.42347046756706, 28.375699915644486]],
    [ "Claymont Substation",[-75.44711841079898, 39.80119327626226]],
    [ "Pine Hills Substation",[-81.4421516, 28.554399200000006]],
    [ "Glasgow Substation",[-75.77151693742785, 39.61280953631063]],
    [ "Delmarva Power",[-75.72651704285664, 39.63391066712996]],
    [ "Keeney Substation",[-75.73068333678873, 39.6332035000008]],
    [ "Harmony Substation",[-75.6939170838221, 39.69300995352368]],
    [ "Valley Road Switch",[-75.71332445382107, 39.7751181290918]],
    [ "Kershaw Substation",[-75.75016610046683, 39.68810832175641]],
    [ "Milltown Substation",[-75.66898360019503, 39.73041712371382]],
    [ "Kiamensi Substation",[-75.6300592493841, 39.72572066536999]],
    [ "Receiving Station E - Toluca",[-118.35973277346888, 34.17605856908407]],
    [ "Crystal Substation",[-114.8303390071504, 36.482200708449945]],
    [ "Harry Allen Substation",[-114.90704041012562, 36.427582638412716]],
    [ "ComEd Lisle 138kV-345kV Substation",[-88.05875090786402, 41.799654862811245]],
    [ "Blue Ridge Mall",[-94.44824984023339, 39.04451315798471]],
    [ "AEP Lane Substation",[-80.41986462858014, 37.210200585332004]],
    [ "Pioneer Substation",[-112.12767305568629, 33.797668309962376]],
    [ "Entergy Arkansas",[-92.27933719035653, 34.756539518357]],
    [ "L.R. Dixie Substation",[-92.23333437163794, 34.759979381439614]],
    [ "Durant Substation",[-83.67417002553063, 42.57602580989667]],
    [ "72650135",[-112.12549062315918, 33.745684976065604]],
    [ "Kearneyville Substation",[-77.90915522497146, 39.39727468675731]],
    [ "Glen Ellyn Substation",[-88.04330209589874, 41.85996988766243]],
    [ "Chirsty Substation",[-112.18700057261712, 33.476531672054996]],
    [ "Bald Mountain Substation",[-121.52974781195407, 45.756580697335174]],
    [ "Gravel Ridge South Substation",[-92.19578813464597, 34.85877907086492]],
    [ "Eastview Substation",[-73.83197014310133, 41.077124865172145]],
    [ "Millwood Substation",[-73.80044088495544, 41.192726152208536]],
    [ "Sprainbrook Substation",[-73.85632764126012, 40.95723023874977]],
    [ "Riverview Substation",[-122.67204856086651, 45.46931392064788]],
    [ "Dunwoodie Substation",[-73.85807049925695, 40.93941424550435]],
    [ "Pine Hill Substation",[-71.44415544048213, 43.05658208960714]],
    [ "Kissimmee Utility Authority",[-81.32328374999999, 28.362670000000005]],
    [ "Barber Substation",[-94.64725927251575, 39.069086009876976]],
    [ "Shawnee Substation",[-94.73194329626219, 39.03617003402496]],
    [ "Black Oak Substation",[-78.91647059994668, 39.499415212081175]],
    [ "Frostburg Substation",[-78.93111209525068, 39.639174006385666]],
    [ "Lakehurst Substation",[-87.8763073531196, 42.3535208869196]],
    [ "South Carlyle Substation",[-77.06026895435842, 38.79915197774931]],
    [ "Potomac River Substation",[-77.04215069178869, 38.820848749700865]],
    [ "Mid Weymouth Substation",[-70.9535091402783, 42.20191939571756]],
    [ "North Kansas City Substation",[-94.57705923069136, 39.12558183267758]],
    [ "Stagg Hill Substation",[-96.60827056849632, 39.16116726448379]],
    [ "Pleasantville Substation",[-73.78213608818376, 41.14205507269091]],
    [ "Airport Industrial Park Substation OUC",[-81.35423959289932, 28.402624675042524]],
    [ "Danebo Substation",[-123.17728486983486, 44.07400566658368]],
    [ "Jessen Substation",[-123.17180250791847, 44.09107046402466]],
    [ "Jacksonville North Substation",[-92.12389329999999, 34.88699855]],
    [ "Bismark Substation",[-95.19652811127703, 38.9872956543538]],
    [ "Los Angeles Department of Water and Power",[-118.30344985093306, 33.84773360792884]],
    [ "La Fresa Substation",[-118.33321565868265, 33.86915236681386]],
    [ "Santa Clara Substation",[-123.1213497612306, 44.09822078736996]],
    [ "74951883",[-122.14012568520947, 37.44431117479115]],
    [ "TECO",[-82.39187898398245, 28.052689393255132]],
    [ "66kV Switching Station",[-118.39510499999996, 33.851664549999995]],
    [ "Southern California Edison",[-118.37277300462142, 33.895934239420434]],
    [ "230kV Switching Station",[-118.39379960000001, 33.85253645]],
    [ "75355423",[-114.636176017844, 35.126686806110804]],
    [ "75355478",[-114.56552266226741, 35.19476172150317]],
    [ "75467319",[-78.55788273441954, 35.93838220680724]],
    [ "East Towson Substation",[-76.59561511299643, 39.39890151774609]],
    [ "75490150",[-114.54808367572693, 35.15364882032169]],
    [ "75563698",[-84.04871906943139, 39.77900588819788]],
    [ "Richland Substation",[-119.28978097765827, 46.26198564555469]],
    [ "Rice Substation",[-81.76486581433456, 29.72307952875382]],
    [ "Winter Park East Substation",[-81.28472384094545, 28.619366233457594]],
    [ "Winter Springs Substation",[-81.28526625326188, 28.684723778644674]],
    [ "Econlockhatchee Substation",[-81.260040468367, 28.59550245496985]],
    [ "North Longwood Substation",[-81.33707256696465, 28.718132944977576]],
    [ "Trout Lake Substation",[-81.41204000318879, 28.655867626174135]],
    [ "Altamonte Springs Substation",[-81.35914597529549, 28.67528772590305]],
    [ "Lake Emma Substation DUKE",[-81.36903244254891, 28.732759925060773]],
    [ "Rinehart Substation",[-81.34619077484324, 28.7611946917464]],
    [ "Sanford Plant Substation",[-81.32888626147084, 28.84341825344938]],
    [ "Westlover Substation",[-75.693041148417, 38.15230951907967]],
    [ "Duke Energy",[-81.19452937493405, 28.590901912318955]],
    [ "Duke Energy",[-81.1501817, 28.567289850000005]],
    [ "East Orange Substation",[-81.2109653, 28.545920599999995]],
    [ "Rock Creek Substation",[-90.29537635228026, 41.79102106872948]],
    [ "ITC",[-90.25705550105252, 41.78304646698834]],
    [ "MidAmerican Energy",[-90.25673226742963, 41.803297199878465]],
    [ "East Manhattan Substation",[-96.54251030615248, 39.18864608291286]],
    [ "Duke Energy",[-81.36450159709376, 28.599937890453372]],
    [ "75717988",[-81.39907134573775, 28.642783574999214]],
    [ "Duke Energy",[-81.38539410535365, 28.625245800887992]],
    [ "Duke Energy",[-81.41753417853462, 28.615224886684505]],
    [ "Ironside Substation",[-75.2532442604824, 38.291102329737214]],
    [ "75776191",[-114.45498176215096, 34.90820157318225]],
    [ "75776195",[-114.34586837406937, 34.56176585315394]],
    [ "Black Mesa Substation",[-114.21138754063081, 34.41711947390618]],
    [ "Rock Springs Substation",[-81.50818789987355, 28.70432181935794]],
    [ "Piedmont Substation",[-81.45520785804916, 28.672882128733328]],
    [ "Sabal Point Substation DUKE",[-81.41695907719343, 28.702444248843335]],
    [ "North Clinton Substation",[-90.18534435653513, 41.895759037312814]],
    [ "Foothills Substation",[-121.31959692096427, 38.78135595404531]],
    [ "Apopka South Substation",[-81.51620150000001, 28.66266385]],
    [ "Lockhart Substation",[-81.45468197680883, 28.622990430506764]],
    [ "Woodsmere Substation",[-81.45594478891948, 28.578470124009243]],
    [ "Ocoee Substation",[-81.51672361357934, 28.563237674800476]],
    [ "76185169",[-81.33938179442565, 28.502010798062557]],
    [ "Duke Energy",[-81.3406482366404, 28.45158207512489]],
    [ "LADWP Receiving Station J",[-118.54354632243843, 34.229345143615895]],
    [ "Newington Substation",[-72.75098595415787, 41.717778323814024]],
    [ "Dillard Substation",[-123.07750451283358, 44.0052147005406]],
    [ "Hideaway Substation",[-123.06383738635398, 43.99336903635528]],
    [ "Clarcona Substation",[-81.49921280960459, 28.61145197447922]],
    [ "Winter Garden Substation",[-81.583225, 28.558090850000003]],
    [ "Duke Energy",[-81.68587445189287, 28.54731929066589]],
    [ "Boggy Marsh Substation",[-81.6773584858282, 28.352492868585998]],
    [ "Duke Energy",[-81.75508799042835, 28.598076809798087]],
    [ "76750054",[-112.15949755733877, 33.46364634285189]],
    [ "Sorrento Springs Substation DUKE",[-81.55249212353458, 28.830487137462633]],
    [ "Round Lake Substation",[-81.59195218758153, 28.764147575149384]],
    [ "Zellwood Substation",[-81.6007301640036, 28.727835968788767]],
    [ "Duke Energy",[-81.54792997824968, 28.60227405826103]],
    [ "Winter Park East Substation",[-81.31883602839324, 28.603307231597412]],
    [ "76793308",[-81.31886838877374, 28.603900169959473]],
    [ "Lone Palm Rd Substation DUKE",[-81.17789900000002, 28.566026350000005]],
    [ "Duke Energy",[-81.58780874999998, 28.51821945]],
    [ "Duke Energy",[-80.94284538714194, 28.389310026099373]],
    [ "Weber Substation",[-81.37543105489588, 28.557988621554227]],
    [ "MidAmerican Energy",[-93.7025908098074, 41.55869879086774]],
    [ "Norwalk Substation",[-93.68048801754128, 41.45880626276278]],
    [ "DISTRIBUTING STATION 85",[-118.37961659518568, 34.19123297689124]],
    [ "Entergy Arkansas",[-92.28274164441785, 34.798352023177934]],
    [ "Arleta Substation",[-122.6076168263987, 45.488707926557694]],
    [ "Gene Substation",[-114.1712904853628, 34.29113273104752]],
    [ "77275161",[-114.17207164999999, 34.29262445]],
    [ "77275237",[-114.17130895175781, 34.292123498714666]],
    [ "Havasu Tap",[-114.14140366765879, 34.2909680948938]],
    [ "Headgate Rock Substation",[-114.27770640303063, 34.16136484721875]],
    [ "77338036",[-117.00739606048657, 33.7335600960728]],
    [ "Mira Loma Substation",[-117.56425733223983, 34.00804785049613]],
    [ "77452154",[-117.52720474981051, 34.08881618933857]],
    [ "Rancho Vista Substation",[-117.53366700153246, 34.0879925094779]],
    [ "77593908",[-117.69541035205394, 33.96398638266257]],
    [ "Mayo Substation",[-78.88850497383127, 36.52486758015648]],
    [ "Florida Power & Light",[-80.51991705091545, 25.452584711019487]],
    [ "Florida Power & Light",[-80.33799296885537, 25.434667778290574]],
    [ "Wake Substation",[-78.45203458164619, 35.78198343403362]],
    [ "77822644",[-92.28251792505928, 34.80401671322802]],
    [ "Suntree Substation",[-80.70113161129083, 28.23011674425973]],
    [ "Country Club Substation",[-81.40222690000002, 28.564408299999997]],
    [ "Entergy Arkansas",[-92.25680346070551, 34.71389708485837]],
    [ "L.R. East Substation",[-92.25296849078397, 34.73284072456779]],
    [ "L.R. South Substation",[-92.30517894007673, 34.72104738460762]],
    [ "Entergy Arkansas",[-92.35228549681679, 34.73583429833234]],
    [ "78156250",[-92.35176874487156, 34.71768332559702]],
    [ "Gifford Substation",[-81.61982011419325, 28.388274336016632]],
    [ "Llanerch Substation",[-75.29620612580386, 39.96700314927422]],
    [ "Westgate",[-93.47067692494947, 44.8642739909719]],
    [ "78331820",[-79.07560846710506, 35.96732552150213]],
    [ "78331823",[-79.09435106986683, 35.920865356097615]],
    [ "Whispering Willows Substation",[-93.23285545268993, 42.62871489937201]],
    [ "Hillard Substation",[-83.16108677756117, 40.02555023238062]],
    [ "Bedford Substation",[-71.4630099663585, 42.94455361098941]],
    [ "Corn Belt Power Cooperative",[-93.23215701690127, 42.6874419184732]],
    [ "Southern California Edison",[-117.98755471564967, 33.71637004706641]],
    [ "Gisler Substation",[-117.91288892718673, 33.68729896936921]],
    [ "Spring Creek Substation",[-92.59529122365865, 44.57526740161377]],
    [ "Cabot Substation",[-79.79608078186432, 40.80165604215075]],
    [ "Clipper Substation",[-95.32736249245471, 42.55341256380456]],
    [ "Sac County Substation",[-95.26884325970899, 42.55476084417721]],
    [ "MidAmerican Energy",[-95.25968265297729, 42.686804499342095]],
    [ "Laguna Bell Substation",[-118.14783695834983, 33.97574930571568]],
    [ "Southern California Edison",[-118.1956888424029, 33.881761981562036]],
    [ "MidAmerican Energy",[-94.66158513672933, 41.4650819039034]],
    [ "78880446",[-95.16390121907116, 41.47661652571561]],
    [ "Teakwood Rd Substation",[-95.22604476966276, 41.466113235861144]],
    [ "Anita Substation",[-94.77840586033525, 41.49066740002992]],
    [ "79123590",[-118.65738837864089, 34.58751468176926]],
    [ "Wilson Substation",[-120.4073942880358, 37.292828535898806]],
    [ "Rock Tavern Substation (115kV)",[-74.19450494220636, 41.46742034141098]],
    [ "Red Rock",[-93.01164512523351, 44.88740095190046]],
    [ "Stockyards Substation",[-93.0214495951988, 44.887018269832524]],
    [ "Warnerville Substation",[-120.80236647020078, 37.74170308414286]],
    [ "Cottle Substation",[-120.82635818333738, 37.77257111058031]],
    [ "Modesto Irrigation District",[-121.0211026724655, 37.69043064715526]],
    [ "Moses Switching Station",[-74.80473998849183, 45.00400884544127]],
    [ "Southern California Edison",[-117.73327252105146, 33.99626430019879]],
    [ "Olinda Substation",[-117.9222430893081, 33.94609136092417]],
    [ "Floyd Substation",[-92.6641094469703, 43.03759672623595]],
    [ "Dranesville Substation",[-77.36155180320468, 38.979444110875285]],
    [ "Southern California Edison",[-118.12772489653814, 34.00676653156028]],
    [ "Marketplace Substation",[-115.0112671629586, 35.81923478450773]],
    [ "McCullough Substation",[-115.01294112102241, 35.803924386024335]],
    [ "Merchant Substation",[-114.99423931100777, 35.790005860187165]],
    [ "Orlando Utilities Commission",[-81.19381066174611, 28.291903224880492]],
    [ "Auburn Street Substation",[-70.97400041121408, 42.078051921319805]],
    [ "Mead Substation",[-114.83468652073275, 35.92780663984068]],
    [ "79788129",[-79.36699384995565, 39.567308050044105]],
    [ "79788131",[-78.95053548174508, 39.60541867717481]],
    [ "79792334",[-114.91842558562642, 36.02207602837085]],
    [ "79792336",[-114.96907345999091, 36.02228462503965]],
    [ "Western Area Power Administration",[-114.79606432763433, 35.97929358021589]],
    [ "79792356",[-114.95964527920782, 36.0385917758657]],
    [ "79792360",[-114.7432803374281, 36.01599874437343]],
    [ "79792364",[-114.92001761650101, 36.025775576911855]],
    [ "79792367",[-114.74303660479737, 36.01832435310531]],
    [ "79801819",[-114.9758428047775, 35.986675335531096]],
    [ "79875883",[-115.35679246580274, 35.6148798327994]],
    [ "Glencullen Substation",[-122.72468069354767, 45.48672687501953]],
    [ "79948895",[-79.36796674699988, 39.42110914884259]],
    [ "Los Angeles Department of Water and Power",[-118.26493896983446, 33.770344247911375]],
    [ "Receiving Station C",[-118.25808859287491, 33.797819176076665]],
    [ "80214885",[-84.53424432633818, 38.99268877620802]],
    [ "80254990",[-79.17516499999999, 39.44138235]],
    [ "80257357",[-79.0592107492241, 39.47202751929473]],
    [ "Crystal Substation",[-77.05656295, 38.8577533]],
    [ "Ridgeley Substation",[-78.78352850668665, 39.63013989185924]],
    [ "Cumberland Substation",[-78.7791043493573, 39.64347186205239]],
    [ "Kerr Substation",[-78.30122728208491, 36.60085632746374]],
    [ "Southern California Edison",[-118.10713234588671, 33.79572392234817]],
    [ "Lehigh Portland Cement",[-77.17718682650921, 39.56405696464852]],
    [ "Airey Substation",[-75.99330894923969, 38.52123080037836]],
    [ "80395490",[-76.19913798147935, 38.38793386667918]],
    [ "80397545",[-84.38734892423855, 38.856117564774614]],
    [ "80399075",[-84.69815346147656, 38.989138403866995]],
    [ "Boone Substation",[-84.71890252458832, 38.97473064761814]],
    [ "Boone Co Distribution Substation",[-84.71929208375465, 38.97580266715576]],
    [ "Cumberland Substation",[-78.78205187845552, 34.879166038109894]],
    [ "Sequoyah Substation",[-85.09419778877579, 35.22706034005792]],
    [ "Tennessee Valley Authority",[-85.094418724766, 35.224769109865655]],
    [ "Beaver Substation",[-82.26201172246395, 41.42777523826934]],
    [ "Idaho Springs Substation",[-105.47957534047791, 39.742630664815614]],
    [ "Horseshoe Tap Station",[-105.14999714255097, 40.501447457020014]],
    [ "Scott County Substation",[-93.56997061520401, 44.77513755919562]],
    [ "Bluff Creek",[-93.57394596322726, 44.842349429319626]],
    [ "Virginia Electric and Power Company",[-76.25812188504814, 36.90005204521233]],
    [ "Virginia Electric and Power Company",[-76.23738620781057, 36.90974153272243]],
    [ "80760351",[-76.2526433, 36.8099494]],
    [ "Ruritan Substation",[-76.258272, 36.8193698]],
    [ "Thrasher Substation",[-76.24024175827518, 36.759197715424165]],
    [ "Stumpy Lake Substation",[-76.1575604677212, 36.77945843862967]],
    [ "Chesterfield Substation",[-77.38715373947753, 37.38104764700817]],
    [ "Iron Bridge Substation",[-77.50464810633916, 37.40863818966161]],
    [ "River Road Substation",[-77.57520957776997, 37.574432067909385]],
    [ "Yadkin Substation",[-76.3548509062758, 36.76303630642804]],
    [ "Southwest Substation",[-77.5323248589042, 37.5021094124527]],
    [ "Kleeman Substation",[-84.60194528938031, 39.17836096827591]],
    [ "Virginia Electric and Power Company",[-77.54451303915857, 37.527816467241685]],
    [ "Hopewell Substation",[-77.28265923616677, 37.28994014043037]],
    [ "Virginia Electric and Power Company",[-77.29036398273372, 37.150291303319015]],
    [ "Suffolk Substation",[-76.58031715068913, 36.710461000306616]],
    [ "Whealton Substation",[-76.4313355905566, 37.03071784717276]],
    [ "Birchwood Substation",[-77.31784716771816, 38.26778740503441]],
    [ "Comorn Substation",[-77.23105630796601, 38.28666598200073]],
    [ "Riverside Substation",[-93.27578656029391, 45.022582805299145]],
    [ "Prospect Street Substation",[-71.09529475482886, 42.377931103623204]],
    [ "Fredericksburg Substation",[-77.48326686177323, 38.304446213568966]],
    [ "Mine Road Substation",[-77.47590075793808, 38.250142624309305]],
    [ "Dennison Station",[-74.86199865362198, 44.95467342752327]],
    [ "81232560",[-116.85414153733926, 34.86318488947979]],
    [ "81232561",[-116.85488720000001, 34.8604205]],
    [ "Story Substation",[-103.5873552212405, 40.25453290670641]],
    [ "Beaver Creek Substation",[-103.59850346626952, 40.25553852355467]],
    [ "Reynolds Substation",[-73.68748949255493, 42.67273137726008]],
    [ "Virginia Electric and Power Company",[-76.41839653511808, 37.00005927438599]],
    [ "Shellbank Substation",[-76.36705025, 37.02992700000001]],
    [ "Virginia Electric and Power Company",[-76.38873817799102, 37.09138233254028]],
    [ "Magruder Substation",[-76.40098019214504, 37.057990453159796]],
    [ "Fentress Substation",[-76.18987481777778, 36.69009789306517]],
    [ "Newport News Substation",[-76.43038552167987, 36.986611630932785]],
    [ "Upper Merion Substation",[-75.39688365990185, 40.07946353413699]],
    [ "81528843",[-76.62213050303967, 36.72467011012452]],
    [ "Deerfield Substation",[-71.18480380102655, 43.14174448218011]],
    [ "Virginia Electric and Power Company",[-76.4210721588004, 36.87536798489398]],
    [ "Crittenden Substation",[-76.52491290436342, 36.883392634304684]],
    [ "Poe Substation",[-77.35912213486867, 37.20000850417024]],
    [ "Locks Substation",[-77.44315406397185, 37.22197090184285]],
    [ "Carson Substation",[-77.40595368058213, 37.08542876962729]],
    [ "Gerdau Ameristeel US Inc.",[-77.44481309978315, 37.18012786530617]],
    [ "Shockoe Substation",[-77.43961397341054, 37.53353705827357]],
    [ "Tyler Substation",[-77.3952565, 37.3510865]],
    [ "Chickahominy Substation",[-77.15865523438154, 37.437156216263034]],
    [ "Turner Road Substation",[-77.30136067169094, 37.44741525487359]],
    [ "Elmont Substation",[-77.48463656517602, 37.69752869710059]],
    [ "Churchland Substation",[-76.37696459626443, 36.87108221521211]],
    [ "Virginia Electric and Power Company",[-76.31207059590267, 36.7949136557099]],
    [ "81603852",[-76.30365294699483, 36.80967132468852]],
    [ "Reeves Avenue Substation",[-76.27335871381834, 36.84177726322544]],
    [ "Robison Park Substation",[-85.09522257195042, 41.171338064113144]],
    [ "81604253",[-85.07114988964251, 41.13411607563622]],
    [ "Golden Hills Substation",[-71.04537418994191, 42.47181503702427]],
    [ "Melrose Substation",[-71.0504468348187, 42.46961837132374]],
    [ "Wakefield Substation",[-71.0478066716264, 42.4878529548894]],
    [ "Southern California Edison",[-117.03089101776168, 34.86319238108711]],
    [ "Wakefield Junction Substation",[-71.04165491855619, 42.5052618250938]],
    [ "Chester Substation",[-71.23715839200631, 42.93641757362471]],
    [ "Great Bay Substation",[-70.88683024597063, 43.00885705443732]],
    [ "West Salem Substation",[-70.92726544340422, 42.50510098897951]],
    [ "Canal Street Transiton Station",[-70.8957473937686, 42.51492586556876]],
    [ "North Reading Substation",[-71.09848906943948, 42.56704130466939]],
    [ "East Tewksbury Substation",[-71.18973611824313, 42.61554056376635]],
    [ "Burtt Road Substation",[-71.16877411809114, 42.602871354418355]],
    [ "Tewksbury Substation No. 22A",[-71.24249531225641, 42.62296080509536]],
    [ "Tewksbury Substation No. 22",[-71.24665933032273, 42.62386132261529]],
    [ "Harrowgate Substation",[-77.41908791369299, 37.29183659690581]],
    [ "Woburn Substation",[-71.15404681131714, 42.462321439327745]],
    [ "Big Bend Substation",[-114.58165787566998, 35.15818900430458]],
    [ "Pinehurst Substation",[-71.21658035727951, 42.53911961893363]],
    [ "Manchester Substation",[-77.43387513800518, 37.52543612897153]],
    [ "81757616",[-114.42820713460117, 34.996150938994596]],
    [ "81757624",[-114.5544196630558, 34.96818515966801]],
    [ "Lincoln Substation",[-85.06244822730369, 41.07027610548534]],
    [ "AEP State Street Substation",[-85.065348393788, 41.09793912940665]],
    [ "Harper Substation",[-84.98895674999036, 41.085637766667205]],
    [ "Trier Substation",[-85.07012359470757, 41.11342123733007]],
    [ "Tigard Substation",[-122.77706630255551, 45.43041535295009]],
    [ "Billerica Substation",[-71.27472277342311, 42.57463633196224]],
    [ "Meadowbrook Substation",[-71.3261210297946, 42.61211620052635]],
    [ "Kingston Unitil Substation",[-71.08365310177061, 42.893433485953054]],
    [ "Kingston Eversource Substation",[-71.08441948143529, 42.89400394871003]],
    [ "Septa Substation",[-76.73862170029345, 37.01459781375701]],
    [ "Surry Substation",[-76.69501989899106, 37.16190138981449]],
    [ "Seabrook Transition Station",[-70.85388317781127, 42.90071891229225]],
    [ "Madbury Substation",[-70.93128987050993, 43.160261104944155]],
    [ "Hickory Substation",[-76.23693435387914, 36.64363568621999]],
    [ "Ocean Road Substation",[-70.81503313242516, 43.04267464908479]],
    [ "Ocean Road Substation",[-70.8132156730578, 43.042253596910236]],
    [ "Virginia Electric and Power Company",[-76.42035181718916, 36.828307452872245]],
    [ "Virginia Electric and Power Company",[-76.39714845347885, 36.79448973858926]],
    [ "81945604",[-114.3765730526162, 35.04600435606636]],
    [ "Burlington Substation",[-71.2143345622584, 42.47553119408486]],
    [ "Lexington Substation",[-71.26634755140878, 42.44511971815562]],
    [ "Surowiec Substation",[-70.2032703628548, 43.93182620559364]],
    [ "82005353",[-114.08681270102466, 35.14395535005351]],
    [ "82005359",[-114.08630289787243, 35.13835846407211]],
    [ "82005360",[-114.18450035000001, 35.092289199999996]],
    [ "82008875",[-113.98025630281298, 35.17777893248786]],
    [ "Waltham Substation",[-71.26315658313946, 42.37789285948489]],
    [ "Trapelo Road Substation",[-71.25197950544123, 42.4144159268884]],
    [ "Denbigh Substation",[-76.546240384711, 37.16224809916798]],
    [ "Virginia Electric and Power Company",[-76.44037531367216, 37.12661166620686]],
    [ "82101644",[-84.86801876236918, 39.09173351036311]],
    [ "82103175",[-85.38392296479363, 38.80218728616509]],
    [ "Jefferson Substation",[-85.43808922119396, 38.74173063693837]],
    [ "82104542",[-85.21620975119227, 39.26721554538645]],
    [ "Speen Street Substation",[-71.3879296934637, 42.31164206612868]],
    [ "Sudbury Substation",[-71.39704516234953, 42.35995789337607]],
    [ "Batesville",[-85.21901347451801, 39.266854868187835]],
    [ "Fall Creek Substation",[-85.5932030443842, 39.99182340423183]],
    [ "82106612",[-85.53328409433057, 39.972553640288886]],
    [ "82109375",[-85.64394024422273, 40.079733385547094]],
    [ "Madison",[-85.64471442499304, 40.08697162465604]],
    [ "Gwynneville Substation",[-85.65374546839323, 39.61319962591175]],
    [ "Harmony Village Substation",[-76.4851948750267, 37.58207937529828]],
    [ "Lanexa Substation",[-76.9119525094019, 37.42013807575668]],
    [ "Pelham Substation",[-71.30997534108391, 42.73666646600539]],
    [ "Kings Fork Substation",[-76.60231317576486, 36.78420868913183]],
    [ "Chelsea Substation",[-71.02485499274343, 42.39486595301986]],
    [ "Everett Substation",[-71.07168755254754, 42.41435489250398]],
    [ "Hull Street Road Substation",[-77.5765314209898, 37.44444115567741]],
    [ "Lakeside Substation",[-77.46011507892865, 37.61686282697844]],
    [ "Northwest Substation",[-77.54156669822783, 37.63061149106217]],
    [ "Mountain Road Substation",[-77.52189371687632, 37.670411304699364]],
    [ "82224113",[-78.99552848123258, 35.95929974263149]],
    [ "82224127",[-79.01121578079507, 35.957068488541616]],
    [ "ACCA Substation",[-77.47754600976434, 37.57994276290214]],
    [ "North Dracut Substation",[-71.30995072937905, 42.68828871066928]],
    [ "Maplewood Substation",[-71.03869279820643, 42.43159188994785]],
    [ "82254663",[-114.20438474526325, 35.31895578231352]],
    [ "82254669",[-114.356185083989, 35.53210595612188]],
    [ "82255126",[-85.46475833887816, 39.368223109912115]],
    [ "Duke Energy",[-85.73401782982906, 39.52841412070295]],
    [ "82261057",[-78.95111473310081, 35.91771124911812]],
    [ "82261250",[-78.91496088392361, 35.96817714294033]],
    [ "82289653",[-85.79285352516834, 39.540344254245376]],
    [ "82290996",[-85.79322595567977, 39.51608297546824]],
    [ "82291732",[-86.00326377698615, 39.680383079292454]],
    [ "82292178",[-86.06524458885781, 39.50950467599082]],
    [ "82292180",[-86.06759530658007, 39.50856547966737]],
    [ "82295502",[-85.86800075332566, 39.244531104710305]],
    [ "82336214",[-78.87661377514448, 35.87695921772503]],
    [ "82336228",[-78.85226737858804, 35.87451673008103]],
    [ "82360286",[-114.4878165, 35.72190695]],
    [ "Nelson Substation",[-114.82485849999999, 35.70775035]],
    [ "82360302",[-114.80727504999999, 36.00853119999999]],
    [ "82360305",[-114.82849516598594, 35.99469128504449]],
    [ "82360317",[-114.84670226061591, 35.97807371626399]],
    [ "Rocky Mountain Power",[-111.7892215026528, 40.349667648637876]],
    [ "Faulkner Substation",[-115.03128313217695, 36.035504333218775]],
    [ "Cactus Substation",[-115.17126218509661, 36.00233477243979]],
    [ "Centralia Substation",[-77.45346232438698, 37.379471304910815]],
    [ "Hanover Substation",[-77.46277439102468, 37.7406690463531]],
    [ "Allied Substation",[-77.28107701350771, 37.336331304603426]],
    [ "Cartersville Substation",[-78.1278380963288, 37.657085374016944]],
    [ "Midlothian Substation",[-77.70401246330246, 37.50267433147952]],
    [ "Virginia Electric and Power Company",[-78.85220528741766, 38.10598362618668]],
    [ "Dooms Substation",[-78.84878322406405, 38.106927782811276]],
    [ "Grottoes Substation",[-78.81280536258821, 38.26605701355805]],
    [ "Lexington 500kV Substation",[-79.4206943170196, 37.86776786065092]],
    [ "Lexington Substation",[-79.41934755984138, 37.86724253421804]],
    [ "Cloverdale North Substation",[-79.8977746155168, 37.38106049191497]],
    [ "Hazel Dell Switching Substation",[-122.67117710012374, 45.687546874011964]],
    [ "Altavista Substation",[-79.27849995924232, 37.130024782035505]],
    [ "Sherwood Substation",[-78.52602679380729, 38.02121161042357]],
    [ "Charlottesville Substation",[-78.45786009352676, 38.041549045771774]],
    [ "North Anna Substation",[-77.79719650354004, 38.06116871878216]],
    [ "Limestone Substation",[-86.84690482646016, 34.71830455535523]],
    [ "North Huntsville Substation",[-86.65956637684336, 34.8166387488037]],
    [ "82567840",[-86.52793248846795, 34.80085003480487]],
    [ "Madison Substation",[-86.521801628245, 34.795682029687725]],
    [ "Virginia Electric and Power Company",[-78.40460543655526, 37.968438361042594]],
    [ "Trinity Substation",[-87.0550622121399, 34.608725798423535]],
    [ "Mountain Gap Substation",[-86.54056960736737, 34.623677628948904]],
    [ "Huntsville Utilities",[-86.54927384999999, 34.60210095]],
    [ "Lake of the Woods Substation",[-77.78116424076227, 38.31354853014844]],
    [ "Bellefonte Substation",[-85.92908494793375, 34.71010718827609]],
    [ "Paradise Substation",[-112.0088992705858, 33.625231685336125]],
    [ "Charleston Primary Substation",[-84.78316532742538, 35.30240322953335]],
    [ "Hummel Substation",[-81.78477651160647, 41.408247428245964]],
    [ "Harrisonburg Substation",[-78.88229160550286, 38.41129184150003]],
    [ "Dayton Substation",[-78.93297201197375, 38.41129299251163]],
    [ "Illuminating Comapny",[-81.4476833734097, 41.62709982714223]],
    [ "Lark Substation",[-81.44701435983599, 41.53960796509494]],
    [ "Eddy Substation",[-71.47317582299203, 43.003148046660264]],
    [ "Crewe Substation",[-78.13068784565827, 37.16501886859417]],
    [ "Scottsville Substation",[-78.50935895345222, 37.79542943070564]],
    [ "Tasley Substation",[-75.70248269986752, 37.7060013345472]],
    [ "Jomax Substation",[-111.96225215219309, 33.7260965277941]],
    [ "Hollymeade Substation",[-78.43380310000002, 38.12723885]],
    [ "Proffit Substation",[-78.41536995435804, 38.11856998924762]],
    [ "Crozet Substation",[-78.69855145504314, 38.08468368156786]],
    [ "Midway Substation",[-78.70714565, 38.0265853]],
    [ "Cunningham Substation",[-78.37414589588269, 37.868621052579165]],
    [ "82965772",[-76.28030038612981, 36.92152271319188]],
    [ "Picadilly Substation",[-104.73220035617447, 39.751568208680446]],
    [ "82985192",[-76.18621089391321, 36.88907758558968]],
    [ "Lynnhaven Substation",[-76.0753978974894, 36.83839352591328]],
    [ "83014818",[-76.49305630615427, 37.42647148611525]],
    [ "Yorktown Substation",[-76.4610953673914, 37.21309803161784]],
    [ "Nance Substation",[-87.2989528956734, 34.70667771133426]],
    [ "Courtland Substation",[-87.30947654813798, 34.66292483056157]],
    [ "83042143",[-87.66001653310312, 34.70169426991982]],
    [ "City of Sheffield",[-87.67828267705032, 34.70896987051672]],
    [ "Tennessee Valley Authority",[-87.59178950841796, 34.75637535115748]],
    [ "Jasper Substation",[-122.96158509474179, 44.03966596352637]],
    [ "Muscle Shoals Electric Board",[-87.63366598969517, 34.737708929849326]],
    [ "Watts Bar Substation",[-84.78565833348318, 35.619260646911314]],
    [ "Watts Bar Power Station",[-84.7891144, 35.600325]],
    [ "Chickamauga Substation",[-85.22947260279221, 35.101144024005954]],
    [ "Gavilan Peak Substation",[-112.05520005693994, 33.83798042218397]],
    [ "83117056",[-85.16109028786055, 34.99679790041463]],
    [ "Electric Power Board of Chattanooga",[-85.14172504288418, 35.10906589416334]],
    [ "Tiana Substation",[-72.53136984206286, 40.87336571384852]],
    [ "Southampton Substation",[-72.39763466201882, 40.892598875524214]],
    [ "Grays Ferry Substation",[-75.18917455165736, 39.941390956092306]],
    [ "Wildwood Substation",[-72.86408931058656, 40.94632957263175]],
    [ "East Hampton Substation",[-72.2060399739796, 40.962431328614855]],
    [ "6U Ruland Road Substation",[-73.41857010569348, 40.76243990670588]],
    [ "Shore Road Substation",[-73.6458399481204, 40.83267631353325]],
    [ "Shore Road Substation",[-73.64483243075486, 40.832620331408066]],
    [ "4B Roslyn Substation",[-73.64400007520831, 40.78377722193813]],
    [ "Newbridge Road Substation",[-73.54075478088909, 40.73280232619077]],
    [ "Bridgehampton Substation",[-72.30173179406403, 40.972102819702435]],
    [ "Carle Place Substation",[-73.62289714518157, 40.746821461194195]],
    [ "East Garden City Substation",[-73.61133746611374, 40.730238357396445]],
    [ "Butler Substation BES",[-81.39484111305924, 30.25363071442287]],
    [ "83334582",[-122.84757210000001, 47.420823500000004]],
    [ "Pilgrim Substation",[-73.28743889592079, 40.82929123173878]],
    [ "Pines Substation",[-73.24688721433938, 40.798894043304]],
    [ "83394044",[-118.23787456274671, 33.75946007366819]],
    [ "Shoreham Power Station",[-72.86646649985143, 40.95832157034077]],
    [ "Wading River Gas Turbines",[-72.87745383066971, 40.95616726658856]],
    [ "Eastport Substation",[-72.73336963459167, 40.82580518915189]],
    [ "TECO",[-82.61130529592371, 28.018760380270336]],
    [ "Entergy Arkansas",[-92.25702677172045, 34.79631353169471]],
    [ "Prices Fork Substation",[-80.44461495, 37.22961275]],
    [ "Greenlawn Substation",[-73.38739346611642, 40.85976432783052]],
    [ "Oakwood Substation",[-73.4257310225591, 40.84121638193654]],
    [ "Syosset Substation",[-73.47969458081191, 40.82649825209653]],
    [ "Weyerhaeuser Substation #2",[-122.94409477496235, 44.05318955729289]],
    [ "White Street Substation",[-81.79671406962562, 24.56271025088044]],
    [ "Locust Grove Substation",[-73.51477642415715, 40.79679495382544]],
    [ "Duffy Avenue Converter Station",[-73.55112730061128, 40.76070444521834]],
    [ "Reading Substation",[-71.13069285718316, 42.53398465045]],
    [ "North Woburn Substation",[-71.1263723546908, 42.50892805510763]],
    [ "KEYS",[-81.34893047470378, 24.67486688500141]],
    [ "2K Valley Stream Substation",[-73.68517851202928, 40.66505643353214]],
    [ "2K Valley Stream Substation",[-73.68571373207979, 40.66553014965002]],
    [ "East Bloomington Substation",[-93.23036660917113, 44.85791526180299]],
    [ "West Milton Substation",[-84.33222709563555, 39.93733572438278]],
    [ "Monroe Substation",[-123.10453338240723, 44.02750341016147]],
    [ "Hayden Bridge Substation",[-122.96692366765782, 44.071546250553496]],
    [ "Hayden Bridge Switching Station North",[-122.97232935092212, 44.07126127926279]],
    [ "Peconic Substation",[-72.46952818143934, 41.04885698890429]],
    [ "Greggs Substation",[-71.56902223181316, 43.015868478630324]],
    [ "83892825",[-73.64795681495714, 40.618572577575506]],
    [ "Boyles Substation",[-86.80391024330679, 33.56632483172363]],
    [ "83918622",[-111.80296880000002, 40.44876380000001]],
    [ "Blackstone Junction",[-71.33063413949303, 41.868340141347204]],
    [ "Pawtucket North #107 Substation",[-71.38166325922285, 41.86732798645245]],
    [ "83990353",[-111.79185903302961, 40.430189400997776]],
    [ "Subestación Manatí",[-66.4558040770488, 18.43321577621479]],
    [ "Aguas Buenas TC",[-66.10607712091048, 18.247060868540114]],
    [ "Thompson Street Substation",[-81.7850766543548, 24.555565224301283]],
    [ "84240681",[-84.55993433457151, 39.31215622731414]],
    [ "84240835",[-84.53167771275403, 39.30834297618033]],
    [ "Lake Tarpon Substation",[-82.65456790403498, 28.05859216998495]],
    [ "Subestación Caguas",[-66.0368535487762, 18.239331948335725]],
    [ "Jefferson Substation",[-83.18246923265106, 42.157138904095845]],
    [ "Riverview Substation",[-83.1693554341125, 42.18402271567104]],
    [ "Subestación Monacillos",[-66.07300851047675, 18.372921810448577]],
    [ "Puerto Rico Electric Power Authority",[-66.3053326158844, 18.338367715358142]],
    [ "White Bluffs Substation",[-119.36181855249977, 46.362364034536824]],
    [ "84514157",[-119.36504819999998, 46.4367939]],
    [ "84525930",[-119.36187512957689, 46.43602568987757]],
    [ "Subestación Candelaria Arenas",[-66.22623857716307, 18.41329474446134]],
    [ "Entergy Arkansas",[-92.12030082736497, 34.84497848049829]],
    [ "Newington 345kV Substation",[-70.79242106073232, 43.098105401732184]],
    [ "Wilson Substation",[-93.27965238714272, 44.860458061944556]],
    [ "Chapman Substation TECO",[-82.4295682185155, 28.11465030484262]],
    [ "Roscoe Substation BES",[-81.40355577074564, 30.19474041005981]],
    [ "Raceland Substation",[-90.57135218844084, 29.747994310487083]],
    [ "North Broadway Substation",[-96.79514599999999, 46.90506419999999]],
    [ "Brunswick Substation",[-121.03499590556629, 39.23100847738215]],
    [ "Kathleen Substation DUKE",[-82.02670738165433, 28.22682966966119]],
    [ "Alexander Substation",[-112.10894217556994, 33.571633573184805]],
    [ "Orangewood Substation",[-112.06249935022252, 33.53510350335274]],
    [ "Mount View Substation",[-80.44556251707242, 37.259304579376156]],
    [ "Croom Substation",[-82.22665305, 28.593128749999998]],
    [ "85345358",[-83.93629565126406, 38.87318170643426]],
    [ "85345620",[-84.01936909822051, 39.044437386124194]],
    [ "Subestación Piñas",[-66.23086317507224, 18.346870060039283]],
    [ "Subestación Toa Baja",[-66.2654971721262, 18.41756301143943]],
    [ "Orient Substation",[-100.32687675004404, 31.653940399573866]],
    [ "Northwest Energy",[-112.45809087603966, 45.92011019558304]],
    [ "Point Loma Substation",[-117.23343591686857, 32.74145693532065]],
    [ "Sacramento Municipal Utility District",[-121.19236984849366, 38.6424618572495]],
    [ "Sacramento Municipal Utility District",[-121.18072772944379, 38.65313137783086]],
    [ "Center Park Substation",[-81.48682136704502, 30.296828999051723]],
    [ "Neptune Substation JEA",[-81.42002720663454, 30.316512148963152]],
    [ "85900473",[-117.50629400881367, 34.011247625279836]],
    [ "Sioux Falls Substation",[-96.6489793232198, 43.59915718358026]],
    [ "86092401",[-118.06678305129678, 34.00499333830571]],
    [ "Carver Substation",[-122.52689438455369, 45.402725367880166]],
    [ "Rio Hondo Substation",[-117.98050420143186, 34.10516957751308]],
    [ "Split Rock Substation",[-96.63184736135476, 43.600515187724795]],
    [ "Subestación Canóvanas",[-65.90962232975322, 18.374750816832282]],
    [ "Webster Distribution Substation",[-95.10749926405859, 29.538767691049376]],
    [ "Webster Substation",[-95.10484781034054, 29.5284753448025]],
    [ "Franklin Park Substation",[-87.8884676898295, 41.935381296509824]],
    [ "Citrus Substation",[-117.87208320384144, 34.11902271407762]],
    [ "North Chelsea Substation",[-73.93786504165635, 41.56435066781031]],
    [ "86220649",[-73.95458740000001, 41.5635787]],
    [ "East Fishkill Substation",[-73.83486742327409, 41.568105807058394]],
    [ "Wood Street Substation",[-73.79366993460226, 41.353349447661664]],
    [ "Pleasant Valley Substation",[-73.83427430163464, 41.7396280733718]],
    [ "Live Oak Substation",[-117.73193495, 34.121121]],
    [ "Southern California Edison",[-117.63941326860609, 34.12021475689123]],
    [ "Deer Valley Substation",[-112.13331466210951, 33.66307346440378]],
    [ "Webster Street Substation",[-71.83196740584386, 42.24387421259978]],
    [ "Fishkill Plains Substation",[-73.84177290841475, 41.59721029573371]],
    [ "Buchanan Substation",[-73.94729759895773, 41.26436782106781]],
    [ "Cortland Station",[-76.15183370629825, 42.59506646000795]],
    [ "Etna Substation",[-76.40577993795542, 42.47218326895986]],
    [ "86353195",[-105.00752014596716, 39.627210343686464]],
    [ "Hyatt Substation",[-83.08938142848461, 40.21530918048842]],
    [ "Hyatt Substation",[-83.09212431920267, 40.21117833540966]],
    [ "86355790",[-83.08181164117264, 40.2713070566845]],
    [ "McKownville Substation",[-73.84291385, 42.68397865]],
    [ "Tangy Substation",[-83.08695705449493, 40.259208795841026]],
    [ "Lugo Substation",[-117.36884386915014, 34.36593510323436]],
    [ "Orme Substation",[-112.18786408864185, 33.420115046135585]],
    [ "Greenbrier Substation",[-112.18713661281883, 33.64299675355222]],
    [ "Skunk Creek Substation",[-112.17891864528785, 33.66685009494869]],
    [ "Elverta - Cherry Brook Substation",[-121.4200508, 38.71405480000001]],
    [ "10th Street Substation",[-123.01246414766587, 44.04521984982489]],
    [ "Springfield Substation",[-123.00086476065006, 44.04395460647882]],
    [ "APS Del Rio Substation",[-112.25339331172744, 33.609281593273]],
    [ "Black Eagle Crystal Ridge Substation",[-121.38290956798377, 38.7234982191502]],
    [ "Receiving Station A",[-118.2261596456229, 34.0670853942185]],
    [ "East Nicolaus Substation",[-121.54248350358786, 38.90973397360335]],
    [ "Rio Oso Substation",[-121.46679247553313, 38.935199670718745]],
    [ "Forts Ferry Station",[-73.76788295299266, 42.76366659268587]],
    [ "Greenleaf Substation",[-121.69194005315182, 39.05250110237438]],
    [ "Elroy Substation PECO",[-75.32626389524738, 40.27833493774438]],
    [ "Elroy Substation PPL",[-75.32737760237389, 40.27969671386995]],
    [ "Sugar Creek Substation",[-84.09550915447721, 39.60046107736835]],
    [ "American Transmission Company",[-87.90629447138392, 43.02451477982611]],
    [ "Juniper Substation",[-81.57144720622884, 41.36115056665585]],
    [ "Galaxie Substation",[-81.73026307230668, 41.3046879569344]],
    [ "Fowles Substation",[-81.83433983468137, 41.3533204299987]],
    [ "Star Substation",[-81.69748135154326, 41.01106405780385]],
    [ "Star Substation",[-81.69928279010597, 41.01232928442144]],
    [ "Granger Substation",[-81.73701523048642, 41.157969309541606]],
    [ "86882469",[-97.13843530739285, 43.71649646733887]],
    [ "Storla Substation",[-98.32974310795313, 43.90279313438195]],
    [ "Fort Thompson Substation",[-99.43462411143416, 44.130508723800645]],
    [ "Watertown Substation #2",[-97.04103724605856, 44.8837377275216]],
    [ "Watertown Static Var System",[-97.04265670664299, 44.881154242351634]],
    [ "Watertown Substation",[-97.04500206935089, 44.88257089957841]],
    [ "Groton Substation",[-98.10216694032972, 45.37408934096955]],
    [ "87075550",[-98.10313354366413, 45.37195021952985]],
    [ "87177785",[-117.16792050026207, 33.738800427715816]],
    [ "Georgia Power",[-84.29161548523024, 33.77085845581247]],
    [ "TECO",[-82.3909290099542, 28.104345655890516]],
    [ "Nashua Street Substation",[-71.79925757868357, 42.284252858000755]],
    [ "Dale Mabry Substation",[-82.51052809189684, 28.112327644520487]],
    [ "West Boylston Substation",[-71.76780201511001, 42.3511494657949]],
    [ "87368889",[-86.74233842594987, 39.351729955664474]],
    [ "Grant Substation",[-81.65549145340277, 41.44036288877421]],
    [ "Harding Substation",[-81.65993301131694, 41.43170589244165]],
    [ "87762418",[-114.93940210406852, 36.08466194913465]],
    [ "87783485",[-81.6827646, 41.465358]],
    [ "Jennings Substation",[-81.68548045453026, 41.46613396170757]],
    [ "87783498",[-81.6692464026604, 41.4749067323788]],
    [ "Clark Substation",[-81.68455968177764, 41.46854956848456]],
    [ "Imperial/Pleasant Valley Substation",[-81.64939389698428, 41.366023844296535]],
    [ "Malverne Substation",[-73.6664070589981, 40.6772432691942]],
    [ "Lakeview Substation",[-73.65059052652605, 40.68916449617483]],
    [ "West Hempstead Substation",[-73.64121948619817, 40.701336419949456]],
    [ "Chuck Lenzie Substation",[-114.92171668133541, 36.38194696811167]],
    [ "Irwin Substation",[-81.59846180977988, 41.39402576925753]],
    [ "Hewlett Substation",[-73.7058515328033, 40.63715905522381]],
    [ "87886519",[-114.5789485615222, 36.66402118993196]],
    [ "87886522",[-114.61039099032291, 36.680386936052685]],
    [ "87886532",[-114.60802767812264, 36.681240972683206]],
    [ "87886534",[-114.63559126721884, 36.657182638568976]],
    [ "Northfield Substation",[-81.52447932180404, 41.362401871785266]],
    [ "Longfield Substation",[-81.4676671404948, 41.365700776679546]],
    [ "Dunkirk Substation",[-81.8568983131287, 41.35353916054926]],
    [ "Fox Substation",[-81.75599548878347, 41.42376597265305]],
    [ "Elden Substation",[-81.81675246142585, 41.372567516246725]],
    [ "Plain Dealer Brooklyn Substation",[-81.76911359277777, 41.426131831480056]],
    [ "Clinton/Graham/Grovewood Substation",[-81.74819489726038, 41.45489683588357]],
    [ "Eaton Substation",[-81.8410654909211, 41.390036908487815]],
    [ "Ford Brookpark Substation",[-81.82614669852613, 41.41186526288818]],
    [ "88017941",[-82.05054505775313, 41.478164150609665]],
    [ "88017945",[-82.05056751663666, 41.439359418015165]],
    [ "88043324",[-82.05131869102567, 41.50347378130103]],
    [ "88043334",[-82.05431710117175, 41.501929963311866]],
    [ "Delta Static Inverter",[-112.5809419844678, 39.499458352071976]],
    [ "88144346",[-112.58090995084251, 39.50129867221669]],
    [ "Red Butte Substation",[-113.64622458742978, 37.41381862984352]],
    [ "88272851",[-113.53400687833907, 37.671071949027]],
    [ "88272858",[-113.65987925235478, 37.6116803047455]],
    [ "Parowan Substation",[-112.90748136536872, 37.88413575723239]],
    [ "88315373",[-112.93827120281816, 38.5622752645145]],
    [ "North Wales Substation",[-75.2909591824742, 40.213497498939404]],
    [ "Inland Substation",[-81.62612887116394, 41.47834122519104]],
    [ "Resistance Substation",[-70.77868136954038, 43.09290934032529]],
    [ "McKenzie Substation",[-123.04371678228874, 44.095713439913425]],
    [ "City of Key West",[-81.65339620367364, 24.598140818187062]],
    [ "Bertelsen Substation",[-123.1655230923055, 44.05587376898929]],
    [ "Hickory Substation",[-81.64768698032874, 41.309685612799555]],
    [ "88742934",[-72.87082884695212, 40.868264867715105]],
    [ "Antelope Substation",[-118.29792951649831, 34.68604824982742]],
    [ "Southern California Edison",[-118.28886273007625, 34.71803424097234]],
    [ "Alexandria Utility System",[-92.46101352135109, 31.321127997798428]],
    [ "Garfield Substation",[-81.70106760149771, 41.44592029869794]],
    [ "Franklin Substation",[-76.9434189049317, 36.659704621190734]],
    [ "88867239",[-76.98354586846567, 36.657746498041654]],
    [ "Virginia Electric and Power Company",[-76.99550573653728, 36.653113065250665]],
    [ "Boykins Substation",[-77.19378715672893, 36.60057052655242]],
    [ "88887091",[-77.65908985822574, 36.44599651439926]],
    [ "Lakeview Substation",[-77.67082614242352, 36.474630992396875]],
    [ "Lake Gaston Substation",[-77.812032481947, 36.4913258936729]],
    [ "Clubhouse Substation",[-77.58506888298487, 36.718213933577836]],
    [ "88894645",[-77.83319177376734, 35.95176999757844]],
    [ "TECO",[-82.46050999665333, 28.094925439766417]],
    [ "Franklin Electric Cooperative",[-88.12399554271606, 34.443429960433136]],
    [ "Tennessee Valley Authority",[-88.17949799863055, 34.32523815180952]],
    [ "89151460",[-88.36128691409792, 33.48285504912696]],
    [ "89152415",[-82.28472739642856, 28.14750533340095]],
    [ "89163175",[-88.36436909999999, 33.4696117]],
    [ "89172552",[-86.96550623356657, 33.35033544257044]],
    [ "South Christiansburg Substation",[-80.39792444334589, 37.11917911657826]],
    [ "Edgemont Substation",[-80.46709413729124, 37.102262074906754]],
    [ "Claytor Substation",[-80.58243365140385, 37.07230032003009]],
    [ "Cloverdale West Substation",[-79.90047781160997, 37.37425104146124]],
    [ "Matt Funk 138KV Substation",[-80.16758415000001, 37.23143675000001]],
    [ "Matt Funk 345kV Substation",[-80.17015331225127, 37.23710418048736]],
    [ "89203070",[-84.52810970542902, 39.03558999119665]],
    [ "Cave Spring Substation",[-80.00859486139305, 37.22843422564919]],
    [ "Jacksons Ferry Substation",[-80.82258509867626, 36.879114912203505]],
    [ "CenterPoint Energy",[-87.47597224614042, 38.12272421316275]],
    [ "CenterPoint Energy",[-87.51589745775777, 38.021547817384295]],
    [ "CenterPoint Energy",[-87.63013961229096, 37.98690086141921]],
    [ "Burlington Heights Substation",[-79.96997106336697, 37.36121452850632]],
    [ "Flandreau Substation",[-96.63693121322667, 44.051798206044325]],
    [ "Ovando Substation",[-113.09916005116456, 46.931816275040305]],
    [ "89283599",[-82.58457206634563, 35.599994301600105]],
    [ "Babcock Substation",[-87.10211732853486, 41.53427696441336]],
    [ "89370350",[-87.09885876111098, 41.63484082694087]],
    [ "Stillwell Substation",[-86.5784255875158, 41.53710411181598]],
    [ "Twin Branch Substation",[-86.13636459858675, 41.66889812109867]],
    [ "89375722",[-85.86422810220012, 41.456055280004605]],
    [ "89383689",[-122.23652388008034, 47.1533052450278]],
    [ "Progress Substation",[-122.78407732836992, 45.44631281746152]],
    [ "Shelby Substation",[-84.08613209393553, 40.28846055381722]],
    [ "McKinley Substation",[-85.17234963588689, 41.06086880089195]],
    [ "Wayne Trace Substation",[-85.07420570000001, 41.02494339999999]],
    [ "Hillcrest Substation",[-85.12570085000002, 41.02529605]],
    [ "89400234",[-85.1738641017057, 41.06081767820611]],
    [ "Allen IM Substation",[-84.97735104226552, 41.014128989680444]],
    [ "Olive Substation",[-86.48371886981005, 41.70670537075221]],
    [ "Leesburg Substation",[-85.90103576640776, 41.33652751520492]],
    [ "Dumont Substation",[-86.3609059430987, 41.52288829173271]],
    [ "89409223",[-87.17088847748907, 41.618443159857755]],
    [ "89414476",[-87.17236956957541, 41.6289381298183]],
    [ "Tilden Substation",[-86.88690497570666, 41.701052706624296]],
    [ "American Electric Power",[-86.82670591997618, 41.71493534474678]],
    [ "American Electric Power",[-86.8378156041402, 41.71328097372165]],
    [ "89447016",[-86.91123046542901, 41.71941814564966]],
    [ "Tower Road Substation",[-87.11781558726942, 41.48434922508015]],
    [ "89455862",[-86.92856354999999, 41.65100705]],
    [ "89455863",[-87.02565861968851, 41.49362356070701]],
    [ "Schahfer Station",[-87.02338144151533, 41.22040869104256]],
    [ "89455868",[-87.36902931557395, 41.429099107895276]],
    [ "89455872",[-87.11516072482193, 41.48384294484244]],
    [ "89455876",[-87.27301687471488, 41.46245375866521]],
    [ "ComEd East Frankfort Substation",[-87.82551673169517, 41.49464333987147]],
    [ "Hosensack Substation",[-75.50827479867708, 40.45716311713329]],
    [ "Plymouth Sub",[-86.31479970358366, 41.33723844848576]],
    [ "Burr Oak Substation",[-86.42226667312539, 41.25780149049118]],
    [ "Huntington Substation",[-85.45106450000002, 40.88350134999999]],
    [ "89527910",[-85.38371979097431, 40.883331529847425]],
    [ "Sorenson Substation",[-85.341345225635, 40.98340191298352]],
    [ "Orenco Substation",[-122.89891304716171, 45.524038398535495]],
    [ "89547612",[-86.128502774891, 41.75682749176466]],
    [ "Kline Substation",[-86.13120754559314, 41.65905763649787]],
    [ "89547616",[-86.10149217533515, 41.79491829387183]],
    [ "Pokagon Substation",[-86.17613295420465, 41.875998198935356]],
    [ "89550655",[-86.18942133658976, 41.885888317915764]],
    [ "89554499",[-85.30342249219444, 40.966920906946484]],
    [ "Cook Substation",[-86.55532151116147, 41.97484434186559]],
    [ "Chichester Substation",[-75.41746642514987, 39.82926915613559]],
    [ "Concord Substation",[-75.53910488926684, 39.87220132269705]],
    [ "Bradford Substation",[-75.66765701108983, 39.96917673050579]],
    [ "Foulk Substation",[-75.47084027292044, 39.86637127485701]],
    [ "Bradford Substation",[-75.66490017534066, 39.96869403186251]],
    [ "Lenape Substation",[-75.63227963554655, 39.90962866135821]],
    [ "Faber Substation",[-81.75814099761726, 41.352323512236936]],
    [ "New Carlisle Substation",[-86.50676835468835, 41.723289591138894]],
    [ "Barbadoes Substation",[-75.35845091578665, 40.11441230965261]],
    [ "89597458",[-86.29477897472484, 41.715305445913835]],
    [ "American Electric Power",[-86.2368708384676, 41.7120320676616]],
    [ "AEP Beech Road Substation",[-86.08284108706185, 41.704420138241744]],
    [ "AEP Cleveland Substation",[-86.03902851706111, 41.725785049165836]],
    [ "89607431",[-85.91475305888358, 41.713604720381724]],
    [ "Hiple Substation",[-85.59649857725142, 41.55757903326099]],
    [ "Crystal Valley Sub",[-85.7152814108117, 41.62989427922435]],
    [ "East Elkhart Substation",[-85.8630002296417, 41.7064987411685]],
    [ "AEP",[-85.93075282503926, 41.64698894644547]],
    [ "89615673",[-85.96053752506542, 41.728994407063745]],
    [ "89615678",[-85.95883299822879, 41.714224195870905]],
    [ "89620961",[-85.99019913508718, 41.65897602489387]],
    [ "Maple Substation",[-86.70804560313798, 41.63785701367834]],
    [ "89632564",[-87.29669637574999, 41.59378414404414]],
    [ "89637077",[-118.46541724958367, 37.349734666651266]],
    [ "89637083",[-118.5573350771153, 37.43782311706516]],
    [ "89637089",[-118.4409830506102, 37.3420288432026]],
    [ "89637090",[-118.46306794999651, 37.35008343867895]],
    [ "Lake George Substation",[-87.28252543715223, 41.53776623705996]],
    [ "89699639",[-87.27170416069411, 41.48605002513923]],
    [ "Crete Substation",[-87.61914670512311, 41.4310601811967]],
    [ "Woodhill Substation",[-87.74109696983709, 41.4336295542793]],
    [ "St. John Substation",[-87.39892703005678, 41.450918934373234]],
    [ "89716647",[-87.47451539524559, 41.612309347199115]],
    [ "Liable Road Substation",[-87.44152362337404, 41.55991234890267]],
    [ "89716655",[-87.37428014618175, 41.56131361695266]],
    [ "89716659",[-87.50712779773478, 41.635148507053586]],
    [ "Highland Substation",[-87.46504746423722, 41.560285340258325]],
    [ "89716664",[-87.46616142491607, 41.58547474268761]],
    [ "Sheffield Substation",[-87.5106239156734, 41.658884945523525]],
    [ "Collier Substation",[-80.12156162722002, 40.40437970672077]],
    [ "Brunot Island Substation",[-80.04673097725022, 40.46488206575149]],
    [ "Brunot Island Substation",[-80.04478099549561, 40.463677727548266]],
    [ "Pearl Substation",[-122.51727205679819, 47.269697551817046]],
    [ "Cushman Substation",[-122.48644229159319, 47.26689494355126]],
    [ "Duke Energy",[-82.73419890635586, 27.955422438750407]],
    [ "89827202",[-86.57461113504235, 39.172859274938595]],
    [ "Betzwood Substation",[-75.42018174087579, 40.114695561943655]],
    [ "Price Hill Substation",[-79.98233038221574, 39.603227797564514]],
    [ "Lynn Lake Switchyard Substation",[-79.85523583129542, 39.72128720910509]],
    [ "Smithton Substation",[-79.72718507549276, 40.171499440740284]],
    [ "Youngwood Substation",[-79.58116551050153, 40.23184925070554]],
    [ "Fort Martin Substation",[-79.9335547623592, 39.71802029241177]],
    [ "89878419",[-80.8193555, 39.839837]],
    [ "Lynn Substation",[-70.95134522878107, 42.45448153028756]],
    [ "Destin Substation",[-86.48266674571506, 30.393664328893102]],
    [ "Woodville Substation",[-80.09408697896836, 40.384045051121035]],
    [ "West Bellaire Substation",[-80.8063458665911, 40.022265850362245]],
    [ "90070414",[-80.70523969999999, 40.165707749999996]],
    [ "Chatfield Substation",[-105.11103680419126, 39.594632063751305]],
    [ "NV Energy",[-119.51886426743995, 39.563112586995146]],
    [ "NV Energy",[-119.51336339999999, 39.55998769999999]],
    [ "90091940",[-119.51535834709516, 39.55741905226115]],
    [ "90091941",[-119.5400784052602, 39.556831436771105]],
    [ "NV Energy",[-119.52247408112387, 39.56403469626211]],
    [ "East Akron Substation",[-81.46007089674504, 41.05914094304532]],
    [ "Northwest Energy",[-110.17153730296856, 45.78232981506405]],
    [ "90217900",[-80.65282410926113, 40.027879740895564]],
    [ "Hanna Substation",[-81.22694962038261, 41.119716555015074]],
    [ "90243499",[-80.16460760352251, 40.299906310003436]],
    [ "Charleroi Substation",[-79.91300901408286, 40.139254128700536]],
    [ "Yukon Substation",[-79.72438333368548, 40.21002417064096]],
    [ "90282297",[-113.52222723350704, 37.13196940332869]],
    [ "90282401",[-78.62063492537627, 42.91885630893697]],
    [ "Denny Substation",[-122.78713538624794, 45.470015022171516]],
    [ "90315091",[-84.5928488309169, 38.94850963127012]],
    [ "Luxor Substation",[-79.49185345000001, 40.325448800000004]],
    [ "Highland Substation",[-80.8243815415209, 41.177585328093244]],
    [ "Belmon Substation",[-79.861075, 40.143696]],
    [ "Hatfield Substation",[-79.93330183442043, 39.85801990922726]],
    [ "Draper Lake Substation",[-97.32906553582652, 35.33198069974433]],
    [ "West Ravenna Substation",[-81.30442603654011, 41.14124646948551]],
    [ "Darrow/Terrex Substation",[-81.43395110262911, 41.210006407976216]],
    [ "Faircrest Substation",[-81.33778044308053, 40.74302169506394]],
    [ "Wagenhals Substation",[-81.3253152341878, 40.799039856212985]],
    [ "90523754",[-107.68749992072486, 45.762905049656574]],
    [ "Republic Steel Substation",[-81.33619931469093, 40.80133514706795]],
    [ "Torrey Substation",[-81.41324548531006, 40.76300685058361]],
    [ "Canton Central Substation",[-81.35636103723279, 40.78022312848223]],
    [ "Negley Substation",[-81.438365294847, 40.77090356842863]],
    [ "Reedurban Substation",[-81.43594690565446, 40.786558796872]],
    [ "Bolivar Substation",[-81.45992703692417, 40.63498563579038]],
    [ "Roanridge Substation",[-94.64736021172563, 39.277226753500294]],
    [ "Tiffany Substation",[-94.66656620112394, 39.26051815944752]],
    [ "Weatherby Substation",[-94.68984464338234, 39.212698175206256]],
    [ "Ross Substation",[-81.8971363772836, 40.83593760010314]],
    [ "90744992",[-115.49078384612754, 32.68706754398946]],
    [ "90745011",[-115.77842474880747, 32.79373960890535]],
    [ "90745030",[-115.57798302510936, 32.81786260677582]],
    [ "90745032",[-115.6804109, 32.81141135]],
    [ "Pine Lake Substation",[-82.47929315162432, 28.057978465564577]],
    [ "Milan Substation",[-83.6532061453723, 42.111264554580686]],
    [ "Allen Junction Substation",[-83.77915221312811, 41.722108259620796]],
    [ "90776897",[-82.29207168910492, 40.87184938793346]],
    [ "90777341",[-82.68125150561401, 40.850821140042356]],
    [ "90779117",[-82.55951575558947, 40.69724820166637]],
    [ "Tompkins Substation",[-84.48551527825497, 42.415456140625686]],
    [ "Grodi Road Substation",[-83.46825541648747, 41.80259296752616]],
    [ "Argenta Substation",[-85.60836623496553, 42.43619496392146]],
    [ "El Centro Substation",[-115.53731140820031, 32.80217865864138]],
    [ "Drop 4",[-115.21789555, 32.70607075]],
    [ "90961064",[-114.71457233316703, 32.73661142120179]],
    [ "Knob Substation",[-114.74864311321957, 32.760361344496125]],
    [ "Pilot Knob Substation",[-114.71264210431472, 32.736477294826365]],
    [ "Yucca Substation",[-114.70967879717799, 32.72001067915704]],
    [ "90961476",[-114.71077357694043, 32.719858709049674]],
    [ "90961477",[-114.70506722951797, 32.727749747431545]],
    [ "90962691",[-90.03997899749149, 34.99369164399143]],
    [ "Memphis Light, Gas and Water",[-90.05118863127501, 35.00516327110528]],
    [ "Freeport Substation",[-90.04844790876399, 34.9964735076418]],
    [ "Memphis Light, Gas and Water",[-90.03004660906346, 35.143838771123335]],
    [ "North Gila Substation",[-114.49131415002503, 32.74570063144804]],
    [ "Vrooman Substation",[-84.46638481815295, 42.200998266966245]],
    [ "Blackstone Substation",[-84.4114577539042, 42.270205978950685]],
    [ "Page Avenue Substation",[-84.3570551997437, 42.24048314743062]],
    [ "Leoni Substation",[-84.35766056935998, 42.24700955065482]],
    [ "Battle Creek Substation",[-85.1584140409636, 42.36868025060986]],
    [ "Verona Substation",[-85.14365017687804, 42.336066279589566]],
    [ "Dome Tap Substation",[-114.39684622079601, 32.76850797747812]],
    [ "Wellton-Mohawk Ligurta Substation",[-114.26491660639546, 32.666497161344275]],
    [ "Gila Substation",[-114.47020038452449, 32.68508620443672]],
    [ "Southern California Edison",[-113.74344743979023, 33.51746457599785]],
    [ "91092312",[-85.63853841797182, 41.961557551612536]],
    [ "91092313",[-85.68411251432072, 41.916732652323]],
    [ "Benton Harbor Substation",[-86.33449407771867, 42.18906753904845]],
    [ "Hassayampa Switch Yard",[-112.85213225541769, 33.34585275180988]],
    [ "Palo Verde Generating Switchyard",[-112.85926598336836, 33.38494947948607]],
    [ "91154346",[-112.84350105171518, 33.33473273019903]],
    [ "91154350",[-112.86210430364748, 33.34534421248733]],
    [ "91154378",[-112.8597842912807, 33.34631580111595]],
    [ "Palisades Substation",[-86.30647250122594, 42.321232738740264]],
    [ "Oakland L Substation",[-122.27155311186263, 37.810322436547466]],
    [ "Harquahala Substation",[-113.11350485, 33.47741955]],
    [ "91189239",[-112.71777853161267, 33.59201091830575]],
    [ "Mayfield/Nelson Substation",[-81.32970029019926, 41.522837113136056]],
    [ "Lincoln Substation",[-121.29414383804176, 38.90053539726131]],
    [ "Fostoria Central Substation",[-83.46082239614776, 41.139097268991584]],
    [ "Fostoria Substation",[-83.43448696230716, 41.1513616099954]],
    [ "Kirby Substation",[-98.3923872213387, 29.465320862265234]],
    [ "91375240",[-83.21962014057382, 41.56319817849781]],
    [ "Lemoyne Substation",[-83.45145133464791, 41.47479357750662]],
    [ "Perry Switching Station",[-81.14742703986553, 41.79961954042484]],
    [ "Nursery/Queen Substation",[-81.22604857388684, 41.75068677475674]],
    [ "91377315",[-81.2620680662653, 41.729976023023276]],
    [ "Ashtabula Substation",[-80.76778331682353, 41.90681964118106]],
    [ "Leroy Center Substation",[-81.14136162722666, 41.687925296014946]],
    [ "Newport Substation",[-81.3430000823872, 41.59668729450468]],
    [ "Eastlake Substation",[-81.43999719416828, 41.67217520770462]],
    [ "Marble Substation",[-81.40829362858199, 41.651265889181495]],
    [ "Llyod Substation",[-81.47747687304849, 41.61300732740791]],
    [ "Judi Substation",[-81.54188317250002, 41.568675051117886]],
    [ "Jordan Substation",[-81.57292024277415, 41.541816959374124]],
    [ "Kipling Substation",[-81.50970984926684, 41.588998303151094]],
    [ "Illuminating Comapny",[-81.44990798488347, 41.626532409887425]],
    [ "91529150",[-84.11395305882375, 39.06811127978423]],
    [ "91547102",[-81.55985430717094, 39.279513772014724]],
    [ "91558101",[-83.4584197, 41.64509105]],
    [ "Frey Substation",[-83.44972492505552, 41.59011895430028]],
    [ "Bay Shore Substation",[-83.43504410291222, 41.6908419595173]],
    [ "Ironville Substation",[-83.47141987900063, 41.67314982673961]],
    [ "Decant Substation",[-83.33298055372329, 41.63723315099349]],
    [ "Libby",[-115.30707906786665, 48.39475488676039]],
    [ "Seamless East Substation",[-84.35571865694884, 42.20111548566344]],
    [ "Spruce Substation",[-81.05007482111189, 41.71665262022055]],
    [ "91592557",[-80.82060691498599, 41.82258057380973]],
    [ "Calumet Substation",[-87.54626362587906, 41.71527897209326]],
    [ "Beecher Substation",[-84.01042032139333, 41.89050928768666]],
    [ "Cooley Substation",[-85.58902859685362, 42.29538472380975]],
    [ "Riverview Substation",[-85.56713645375477, 42.31484492015968]],
    [ "Ampersee Substation",[-85.57010156153981, 42.29532236104906]],
    [ "Jackman Substation",[-83.58399450523441, 41.705954780091744]],
    [ "Dixie Substation",[-83.54552432900549, 41.70721114327072]],
    [ "Pardee Substation",[-118.58261968738918, 34.439789913211705]],
    [ "Hillcrest Substation",[-88.13101366928848, 41.55194528982247]],
    [ "Martinez Substation",[-122.11621882827357, 38.01535397357105]],
    [ "92216603",[-88.12568679245503, 41.49541510526268]],
    [ "Gibbons Creek Station",[-96.08147074109421, 30.622542576933654]],
    [ "Keith Switching Station",[-96.0913737745956, 30.651084536413254]],
    [ "Jack Creek Substation",[-96.2589024372747, 30.85888117620723]],
    [ "Oleum Substation",[-122.25728577259137, 38.044574572559]],
    [ "92513856",[-122.1158314801562, 38.01416689178141]],
    [ "Brentwood Substation",[-121.67677187928082, 37.91900223631244]],
    [ "92633626",[-121.84641970614513, 38.17130344591246]],
    [ "Mercerwood",[-122.22007075334744, 47.56683887770373]],
    [ "Hyatt Switchyard",[-121.48622407779567, 39.53269125234103]],
    [ "Yankee Doodle Substation",[-93.13621649474439, 44.83306438944484]],
    [ "Lone Oak Substation",[-93.13065234190725, 44.84672467354159]],
    [ "Rogers Lake Substation",[-93.1308111050354, 44.87680315200075]],
    [ "Blue Lake Substation",[-93.42693411994019, 44.7867871445556]],
    [ "Dean Lake Substation",[-93.473224330277, 44.78053908621735]],
    [ "92966586",[-123.19640363219136, 39.250556263232404]],
    [ "Maxwell Capacitor Station",[-122.27629175448129, 39.237345201448754]],
    [ "Stolle Road Substation",[-78.58107241816991, 42.832657238211716]],
    [ "Nine Mile Creek Substation",[-93.33709474238532, 44.85975143822459]],
    [ "Round Lake Substation",[-88.10569328180848, 42.362951855879345]],
    [ "Ivy Substation",[-81.62225357371787, 41.47611087802784]],
    [ "Newburgh Substation",[-81.63192474780048, 41.464127672077765]],
    [ "Round Mountain Substation",[-121.93577635291938, 40.807894080851035]],
    [ "Cottonwood Substation",[-122.26488017144023, 40.397711151898015]],
    [ "Olinda Substation",[-122.38171889466541, 40.383191224888314]],
    [ "Mandarin Substation JEA",[-81.61966582810811, 30.158931637869394]],
    [ "Robinwood Substation JEA",[-81.5270565021332, 30.30175424870128]],
    [ "Bayard Substation JEA",[-81.52912126843327, 30.146529116758856]],
    [ "Deercreek Substation JEA",[-81.52149482496456, 30.192458894943478]],
    [ "Surrey Ridge Substation",[-104.84784711736268, 39.521235512293146]],
    [ "McLoughlin Substation",[-122.5589879241296, 45.33856786908315]],
    [ "93204543",[-88.11486745270432, 41.49250787836901]],
    [ "Dos Amigos Substation",[-120.82982590225348, 36.925228559564594]],
    [ "Gates Substation",[-120.12619345589364, 36.141619854684684]],
    [ "Panoche Substation",[-120.58156995070996, 36.65234613691638]],
    [ "Atlanta Substation",[-83.17625599572366, 39.56009711085409]],
    [ "93361403",[-88.25484306214976, 41.47842745424967]],
    [ "KCI Substation",[-94.71145664298436, 39.31253695246157]],
    [ "American Air Substation",[-94.69314449347796, 39.29763868064308]],
    [ "Alvey Substation",[-123.016228261631, 43.99699570942874]],
    [ "Gateway Substation",[-123.03136734035526, 44.08216424303651]],
    [ "Willakenzie Substation",[-123.04936315549789, 44.08219172500955]],
    [ "Ferrelview Substation",[-94.66798566312929, 39.31251909431517]],
    [ "Templeton",[-120.68036888961625, 35.55504368591068]],
    [ "Plainfield Substation",[-88.20818810297973, 41.62202327385551]],
    [ "93581423",[-115.12191286016169, 34.149180193727155]],
    [ "93581443",[-115.12149255389642, 34.150373606756624]],
    [ "Sealy Substation",[-96.17082977226148, 29.7791376468468]],
    [ "93678748",[-121.74662002703661, 37.22139724815363]],
    [ "Fayette Plant #1 Substation",[-96.75517081182818, 29.918296494958117]],
    [ "Fayette Plant 138 kV Substation",[-96.75511745724441, 29.912299592142567]],
    [ "Superior Substation",[-83.64273892363752, 42.264407455621956]],
    [ "93712009",[-117.70502269819242, 46.35386509283893]],
    [ "93744182",[-117.70406843942602, 46.35077178635283]],
    [ "Turkey Ford Substation",[-82.54225168684923, 28.126980212456758]],
    [ "93749974",[-120.6821202968142, 45.76022950643419]],
    [ "93750113",[-87.41664379999999, 39.4054516]],
    [ "Holman Substation",[-96.87838355056684, 29.795554750203642]],
    [ "93828921",[-121.71508545112201, 40.877967338468764]],
    [ "Sulphur substation",[-104.78268809415728, 39.50946670737274]],
    [ "Daniels Park Substation",[-104.90501142553708, 39.49417730000488]],
    [ "Lemon Gulch Substation",[-104.81514178949327, 39.48146974899682]],
    [ "McAuley Substation",[-83.65193278229701, 42.2699326451904]],
    [ "Elverta Substation",[-121.47747018488255, 38.71342901944889]],
    [ "Captain Jack Substation",[-121.38988471915616, 42.079685192907]],
    [ "Summer Lake Substation",[-120.95589810653163, 43.01396918288849]],
    [ "Sycan Capacitor Station",[-120.98746793181935, 42.85347149585362]],
    [ "94020790",[-91.49153970984307, 44.81456524228916]],
    [ "Bakeoven Capacitor Station",[-120.90224473429693, 45.16147998795709]],
    [ "Grizzly Substation",[-121.02040261667989, 44.48191863465105]],
    [ "Ponderosa Substation",[-120.93289987427968, 44.22607930118939]],
    [ "West Akron Substation",[-81.63135543309912, 41.14576802477001]],
    [ "Babb Substation",[-81.52709581026726, 41.11570338315152]],
    [ "South Akron Substation",[-81.51609463482889, 41.02809588028579]],
    [ "Puget Sound Energy",[-122.91531070679365, 47.01912315011618]],
    [ "Boulder Park Substation",[-117.14141770531374, 47.696805218255214]],
    [ "Noxon Substation",[-115.73813939157368, 47.95944907688292]],
    [ "Transmission Substation",[-122.73576211200317, 47.03553960838782]],
    [ "Pacific Power",[-122.74508819824882, 45.60231971703866]],
    [ "Bloss Substation",[-122.72757991986408, 45.600563108783284]],
    [ "94398296",[-122.72432736524507, 45.650656958031796]],
    [ "94405126",[-80.85127143112831, 35.22808792922839]],
    [ "Wallis Substation",[-96.0762112982646, 29.630962729213053]],
    [ "94446414",[-119.04783030058218, 43.66760550308791]],
    [ "94448396",[-111.67529395607265, 40.28195297113708]],
    [ "National Grid",[-78.93394377523008, 42.97254124528576]],
    [ "94571465",[-121.586157641664, 37.81661882276587]],
    [ "Cookstown Substation",[-74.54905514431543, 40.06238668125008]],
    [ "Salado Substation",[-121.14743817379888, 37.42175139093826]],
    [ "Danville Substation",[-79.39637467994838, 36.61508866638753]],
    [ "Deans Switching Station",[-74.4852884991072, 40.40552819248888]],
    [ "Roseland Substation",[-74.33083840150547, 40.81988016214178]],
    [ "Readington Substation",[-74.67341768413227, 40.59294927982433]],
    [ "Somerville Substation",[-74.61530721299094, 40.55897637043724]],
    [ "Somerset Substation",[-74.6284187615288, 40.62293026544166]],
    [ "Bennetts Lane Substation",[-74.5300280939128, 40.4854679622481]],
    [ "Sunnymeade Road Substation",[-74.61636905572992, 40.512251047482685]],
    [ "Whippany Substation",[-74.37825562860837, 40.81942686483439]],
    [ "Traynor Substation",[-74.37891779171977, 40.73305406928817]],
    [ "Laurel Ave Substation",[-74.2913484895291, 40.80331353091445]],
    [ "Marion Drive Substation",[-74.25823886234024, 40.79197586670407]],
    [ "Murphy Creek Substation",[-104.70301299877197, 39.60902717035338]],
    [ "Parker Substation",[-104.7603364687825, 39.51048347500343]],
    [ "94854640",[-122.95583450662454, 47.43718861433263]],
    [ "94876022",[-122.83844658510989, 47.4498755676001]],
    [ "Ostrander Substation",[-122.4075088742702, 45.36088056912984]],
    [ "Chenoweth Substation",[-121.20407517256696, 45.6355714111766]],
    [ "Redland Substation",[-122.50638227465312, 45.33019929370283]],
    [ "Navasota Substation",[-96.02734183744663, 30.37520231848007]],
    [ "95055441",[-109.44802084964871, 45.4995143532618]],
    [ "Hayford Substation",[-87.71338666329741, 41.75642374830727]],
    [ "Salem Substation",[-75.53257821019827, 39.46317204995671]],
    [ "Hope Creek Substation",[-75.53385183831168, 39.46792442997569]],
    [ "New Freedom Switching Station",[-74.96274107222553, 39.74100467509331]],
    [ "Red Lion Substation",[-75.62610723800357, 39.60810736285183]],
    [ "Crosswicks Substation",[-74.67506720647675, 40.14160588457563]],
    [ "Ward Ave Substation",[-74.66153154724083, 40.15187997075514]],
    [ "East Bernard Substation",[-96.07025389607615, 29.52356705644735]],
    [ "Coxs Corner Substation",[-74.87047106723878, 39.91603321580948]],
    [ "Marlton Substation",[-74.93200448843636, 39.90111638034843]],
    [ "Lumberton Substation",[-74.81017847915335, 39.950575749966504]],
    [ "Silver Lake Substation",[-74.95295241994353, 39.81033680557188]],
    [ "Peters Substation",[-96.20057453392144, 29.84784089862299]],
    [ "Trenton Substation",[-74.70085412998738, 40.225449144702125]],
    [ "Windsor Substation",[-74.56500929933422, 40.248906971180425]],
    [ "Fayetteville Substation",[-96.68772375890528, 29.962796363649062]],
    [ "West Nyack Substation",[-73.96344962121229, 41.09293008020676]],
    [ "Harings Corner Substation",[-73.96803984939677, 41.0228887522458]],
    [ "West Orange Substation",[-74.25710682321966, 40.78995001891917]],
    [ "West Caldwell Substation",[-74.2905470376692, 40.85418798521944]],
    [ "Cedar Substation",[-74.2175859798691, 40.86723824919665]],
    [ "Athenia Switching Station",[-74.15829554004446, 40.861588997829294]],
    [ "Clifton Substation",[-74.16396368963517, 40.85602375723283]],
    [ "Plainsboro Substation",[-74.56873201489174, 40.33596846521111]],
    [ "Upper Pittsgrove Substation",[-75.22558438411318, 39.57196066501876]],
    [ "Monroe Substation",[-75.02473449064803, 39.67652478893965]],
    [ "Landis Substation",[-75.05127829196923, 39.534381081988386]],
    [ "Sickler Substation",[-74.9730109919536, 39.73403304318769]],
    [ "Cardiff Substation",[-74.6206391624529, 39.428011194266205]],
    [ "Thorofare Substation",[-75.18922366165229, 39.837127338123075]],
    [ "Deptford Substation",[-75.13707587029351, 39.858881448127526]],
    [ "Gladstone Substation",[-94.55478200313304, 39.222791500571766]],
    [ "Big Bend Substation",[-82.39576573387876, 27.797046835467825]],
    [ "Hilltop Substation",[-75.06857611661584, 39.82767691650917]],
    [ "Beaver Brook Substation",[-75.0799052771046, 39.86131186646204]],
    [ "Dorothy Substation",[-74.76853172278776, 39.43005665008549]],
    [ "Mill Substation",[-74.61659656112481, 39.39716351581923]],
    [ "Lewis Substation",[-74.52934730358585, 39.41698695249007]],
    [ "ComEd Taylor 138kV-345kV Substation",[-87.63659863844917, 41.870907825154084]],
    [ "Lawrence Substation",[-74.75640163721275, 40.28239249083996]],
    [ "Clarksville Substation",[-74.69228681512091, 40.28202877778619]],
    [ "Shoal Creek Substation",[-94.51954450270007, 39.247280077919456]],
    [ "Neshaminy Substation",[-74.92551481986077, 40.13014907866819]],
    [ "Alburtis Substation",[-75.5830933306582, 40.481875660609425]],
    [ "Duke Energy",[-82.79963337608584, 27.91299563260092]],
    [ "Buckley Substation",[-104.77133498103538, 39.668340391645366]],
    [ "Tollgate Substation",[-104.82759597429191, 39.68327722583976]],
    [ "Wescosville Substation",[-75.56181870915255, 40.574310568760026]],
    [ "Atlantic Substation",[-80.10481414598651, 26.36621995055412]],
    [ "East Bay Substation",[-82.3682609, 27.7927805]],
    [ "Border City",[-76.95329654685897, 42.87935833878453]],
    [ "Glendon Substation",[-75.23012044268998, 40.66634995441298]],
    [ "Byberry Substation",[-75.00283629291869, 40.11829364069654]],
    [ "Levittown Substation",[-74.88023798231058, 40.02800697200943]],
    [ "Burlington Substation",[-74.87434473127612, 40.074653252581484]],
    [ "Mount Laurel Substation",[-74.88036564700863, 39.94744966349056]],
    [ "Arsenal Substation",[-104.85589117905853, 39.82550594274661]],
    [ "Havana Substation",[-104.86302127406378, 39.79802926021144]],
    [ "Sullivan Substation",[-104.8935759422974, 39.652240196148355]],
    [ "Derby Substation",[-104.92496386408334, 39.82098373944761]],
    [ "Homestead substation",[-104.7175680234627, 39.525348038599816]],
    [ "Camden Substation",[-75.0450342307729, 39.965655128503876]],
    [ "Cinnaminson Substation",[-74.96843228581261, 39.997657598587466]],
    [ "Eagle Point Substation",[-75.13722150444512, 39.869698768019596]],
    [ "Gloucester Substation",[-75.09812295773906, 39.8890371880039]],
    [ "Buxmont Substation",[-75.34122484124542, 40.34842399315435]],
    [ "Morris Park Substation",[-75.16573426145783, 40.70675761155761]],
    [ "Gilbert Substation",[-75.16213553856491, 40.56847011663308]],
    [ "95652389",[-79.03369905660826, 36.001579344284536]],
    [ "Martins Creek Substation",[-75.1085655994918, 40.80033283636395]],
    [ "Station E West Substation",[-122.69591904178773, 45.54067731871182]],
    [ "Station E Substation",[-122.69525144868801, 45.541495678406356]],
    [ "Greenwood Substation",[-104.92220054975166, 39.6014428268731]],
    [ "Praire Substation",[-104.90495779674626, 39.5502398420645]],
    [ "Belfast Substation",[-75.270796839583, 40.76531707267538]],
    [ "Northwood Substation",[-75.25582364562918, 40.71033044600858]],
    [ "Bustleton Substation",[-74.78320697682739, 40.079169836084375]],
    [ "Bellville Substation",[-96.26344731134469, 29.959250506345445]],
    [ "Bellville South Substation",[-96.25590075889241, 29.92424498968207]],
    [ "Yardville Substation",[-74.65674229215685, 40.16875385164714]],
    [ "Belleville Substation",[-74.14222259183879, 40.80284352621623]],
    [ "Harvey Future",[-74.16940279540849, 40.826902702336554]],
    [ "Cook Road Substation",[-74.17830962754961, 40.81179345925459]],
    [ "Kingsland Landfill Substation",[-74.11705484999999, 40.791922]],
    [ "Telford Substation",[-75.35099225, 40.3261951]],
    [ "Eddington Substation",[-74.94591910376201, 40.07381092898965]],
    [ "Corson Substation",[-74.7396451671044, 39.191649181447985]],
    [ "Denver Terminal/Zuni Switchyard",[-105.01907203940044, 39.73735023237291]],
    [ "Currin Substation",[-123.05701187570025, 44.06208640531237]],
    [ "49th Street Substation",[-74.03584482865298, 40.78875263520845]],
    [ "Homestead Substation",[-74.04225133781864, 40.778846234599285]],
    [ "Penhorn Substation",[-74.05531432659376, 40.763293284116415]],
    [ "North Bergen Substation",[-74.02557252743078, 40.80431942165678]],
    [ "Merck Substation",[-74.7760874483215, 40.645849493051884]],
    [ "Jersey Central Power and Light",[-74.90449444800105, 40.5723738131989]],
    [ "West Wharton Substation",[-74.59664024555121, 40.90691062941334]],
    [ "Chester Substation",[-74.69927140295681, 40.79422825122147]],
    [ "Glen Gardner Substation",[-74.9205200835851, 40.68150174793371]],
    [ "Freneau Substation",[-74.24289775197137, 40.397639685399554]],
    [ "Tallman Substation",[-74.114292, 41.11519894999999]],
    [ "Trojan Substation",[-122.88914123578537, 46.03966531357739]],
    [ "Ringwood Substation",[-74.26946055053509, 41.136421135609545]],
    [ "Ramapo Substation",[-74.15514936339773, 41.149791341504326]],
    [ "Pleasant Valley Switching Station",[-74.92956677556185, 40.33722990887224]],
    [ "Sherman Avenue Peaking Generation Substation",[-75.05803513354073, 39.44979150496995]],
    [ "Franklin Substation",[-74.578440903997, 41.099801802492344]],
    [ "Yucca Substation",[-116.42350788333611, 34.11083466666941]],
    [ "Minue Street Substation",[-74.23794940410217, 40.59099251042215]],
    [ "Sewaren Substation",[-74.25210019206038, 40.56080103652938]],
    [ "Woodbridge Substation",[-74.29480034042268, 40.56399580899975]],
    [ "Lafayette Road Station",[-74.32359398788188, 40.548587765785825]],
    [ "Linden Substation",[-74.22666625046479, 40.61228867673994]],
    [ "Fanwood Substation",[-74.39009261081091, 40.635973515795555]],
    [ "New Dover Substation",[-74.34926582070021, 40.5868208178609]],
    [ "Adams Substation",[-74.48013670002736, 40.45830122315811]],
    [ "McKee Substation",[-121.84352643942711, 37.36623214339389]],
    [ "Middlesex Switch Tap",[-74.46217063195002, 40.56080257134544]],
    [ "Lake Nelson Substation",[-74.45230266297678, 40.55276949054768]],
    [ "Gillette Substation",[-74.46266612940752, 40.67810322530164]],
    [ "Greenbrook Substation",[-74.48641022977272, 40.59706033784715]],
    [ "Kilmer Substation",[-74.42528676715166, 40.53357917000524]],
    [ "NJT Aberdeen Substation",[-74.21544541106991, 40.419201746046944]],
    [ "Manitou Substation",[-74.21999953599288, 39.95249459068773]],
    [ "Oyster Creek Substation",[-74.20924013439097, 39.8137020671767]],
    [ "Leisure Village Substation",[-74.18582814214703, 40.03000039798702]],
    [ "Lakewood Substation",[-74.16722874391675, 40.0610221229494]],
    [ "Hawthorne Substation",[-74.15061263374967, 40.96632680673645]],
    [ "Waldwick Substation",[-74.12538894309752, 41.01685653399931]],
    [ "Meadow Road Substation",[-74.39125869383257, 40.49698819997585]],
    [ "Churchtown Substation",[-75.50150794142685, 39.6746897555368]],
    [ "Peach Bottom South Substation",[-76.26721536056517, 39.752817868214244]],
    [ "95967137",[-75.81988663511869, 39.96554004253964]],
    [ "South Reading Substation",[-75.91378213141374, 40.30743140926262]],
    [ "95976029",[-82.37627749021534, 34.82497291344945]],
    [ "South Akron Substation",[-76.20674245829936, 40.142081794753544]],
    [ "ComEd Gilberts 138kV Substation",[-88.34463587512833, 42.08234164106179]],
    [ "ComEd Tollway 138kV-345kV Substation",[-88.24013607865187, 42.06367171829321]],
    [ "Safe Harbor Substation",[-76.38920818734432, 39.92754600856897]],
    [ "Manor Substation",[-76.38855060902625, 39.9282997804407]],
    [ "Engleside Substation",[-76.30699277679341, 40.021876170034496]],
    [ "West Willow Substation",[-76.29162523790312, 39.986492467871585]],
    [ "Deep Run Substation",[-74.34150777542891, 40.397717377274375]],
    [ "Englishtown Substation",[-74.37691423194087, 40.3003922406171]],
    [ "West Hempfield Substation",[-76.46665819061054, 40.025963905688364]],
    [ "Hempfield Substation",[-76.46923002457228, 40.031258454111736]],
    [ "Brunner Island Substation",[-76.69425449999999, 40.097942849999995]],
    [ "South Manheim Substation",[-76.37283768766488, 40.14301476724895]],
    [ "Milford Substation",[-75.423145473992, 40.429521854179946]],
    [ "Sugarloaf Substation",[-74.25999357257714, 41.311549272864724]],
    [ "Sugarloaf Substation",[-74.26006604969089, 41.31065600991858]],
    [ "Middletown Junction Substation",[-76.70469916834648, 40.16828241602169]],
    [ "Otter Creek Substation",[-76.45382955, 39.864428700000005]],
    [ "Yorkana Substation",[-76.58832532432994, 39.95878841360595]],
    [ "96166867",[-94.10426533679679, 37.13715225082623]],
    [ "Charles City Road Substation",[-77.36597342020328, 37.51560256456102]],
    [ "96175557",[-77.3891275, 37.58822965]],
    [ "Northeast Substation",[-77.36214620980775, 37.55065945559546]],
    [ "Buck Substation",[-76.21766073561415, 39.86593047975157]],
    [ "Face Rock Substation",[-76.3258682241252, 39.82762361597244]],
    [ "Pearsons Substation",[-77.37922730187053, 37.67114401155108]],
    [ "TUSC Substation",[-81.59904213754228, 41.04763624224837]],
    [ "Old Church Substation",[-77.25058, 37.63456495]],
    [ "B&W Substation",[-81.61338081196783, 41.011357142993816]],
    [ "Barberton Substation",[-81.61582101418001, 41.0173286399692]],
    [ "Saint Johns Substation",[-77.42766089510373, 38.03111260337106]],
    [ "Saint Johns Substation",[-77.43125526250304, 38.02924146708938]],
    [ "Ladysmith Substation",[-77.55018171996907, 38.046661195242834]],
    [ "96284749",[-77.55189505888244, 37.77820767041581]],
    [ "Chancellor Substation",[-77.58925359330175, 38.262339587187896]],
    [ "96290431",[-77.59920317040724, 38.146775505429815]],
    [ "Morrisville Substation",[-77.7088712303585, 38.50087559106844]],
    [ "Sterling Forest Substation",[-74.22976896429824, 41.213187391376685]],
    [ "Peaceable Substation",[-73.42974496232551, 41.268248668615456]],
    [ "Walker",[-87.95110458929449, 43.0319080020733]],
    [ "Rocklin Substation",[-121.23170789538877, 38.78796174258078]],
    [ "96358518",[-77.33553626565778, 38.07049674879508]],
    [ "Four Rivers Substation",[-77.44357406175587, 37.82152055397369]],
    [ "Bear Island Substation",[-77.43721756977995, 37.81880698417212]],
    [ "Kings Dominion Substation",[-77.4416731494369, 37.846221852294924]],
    [ "96368737",[-77.4324028, 37.90896135]],
    [ "Short Pump Substation",[-77.62363029999999, 37.6596069]],
    [ "North Pole Substation",[-77.79392133358644, 37.63622540106547]],
    [ "Trabue Substation",[-77.62893766764583, 37.50719780342625]],
    [ "Winterpock Substation",[-77.67193654468387, 37.39322725582117]],
    [ "Fishersville Substation",[-78.95567713856313, 38.09569786727582]],
    [ "Griswold Substation",[-112.05617588365615, 33.556571553941765]],
    [ "Gomingo Substation",[-79.0845914, 37.426596700000005]],
    [ "Joshua Falls Substation",[-79.03628055, 37.425531649999996]],
    [ "96565621",[-79.81219914999998, 37.503710600000005]],
    [ "Valley Substation",[-78.97082526624732, 38.31421806235541]],
    [ "Del Mar Substation",[-121.22129607064394, 38.79874901956535]],
    [ "Mount Storm Substation",[-79.27177274912306, 39.20311867992047]],
    [ "Commonwealth Edison",[-88.45652827716019, 42.12671059573694]],
    [ "Pruntytown Substation",[-80.06466012681742, 39.35095281887329]],
    [ "South Farmersville Substation",[-75.30999595048328, 40.64610815023487]],
    [ "Farmersville Substation",[-75.3178886450824, 40.66562474008059]],
    [ "96675292",[-94.3605371629662, 37.15109406451612]],
    [ "Ruthbelle Substation",[-79.64137934362627, 39.50793037875637]],
    [ "Smith Mountain Substation",[-79.53241243303232, 37.04027812422991]],
    [ "East Danville Substation",[-79.34820394804161, 36.60347617723571]],
    [ "Bearskin Substation",[-79.46210907198558, 36.846687592080016]],
    [ "Penhook Substation",[-79.61667177900937, 36.978808903618244]],
    [ "Moneta Substation",[-79.61749436810075, 37.19522800465188]],
    [ "Rockcastle Substation",[-79.57146320000001, 37.13208620000001]],
    [ "Osage Substation",[-80.02089400008713, 39.65274427249109]],
    [ "Westover Substation",[-80.00705113781264, 39.63149417876994]],
    [ "Cagnon Road Substation",[-98.71819355897256, 29.416134504605235]],
    [ "28th Street Substation",[-87.94887366332102, 43.03432066578378]],
    [ "Maclean Substation",[-83.49466937731138, 41.59499420969316]],
    [ "96837187",[-83.50743235, 41.6516913]],
    [ "Oakdale Substation",[-83.49652025, 41.62181665000001]],
    [ "96837239",[-83.66918082523513, 41.59403164373427]],
    [ "96837243",[-83.6936913, 41.56650075]],
    [ "Sylvania Substation",[-83.70410957769438, 41.71447979391389]],
    [ "Reynolds Substation",[-83.67620482339048, 41.67736089620834]],
    [ "Bellevue Substation",[-83.60510737862568, 41.67705434367814]],
    [ "Gould Substation",[-83.61183474652209, 41.60138403489717]],
    [ "Tracy Substation",[-83.52743987022484, 41.5936641335236]],
    [ "Ford Road Substation",[-83.59795064715759, 41.57739320979596]],
    [ "Maumee Substation",[-83.66468880263604, 41.56335541822907]],
    [ "Whitehouse Substation",[-83.79379411861902, 41.52073289500674]],
    [ "96999699",[-83.72329618152673, 41.5459367350385]],
    [ "97001886",[-111.90949664149869, 40.35521037930584]],
    [ "Waterville Substation",[-83.71991635572779, 41.522883625323345]],
    [ "Anderson Substation",[-98.71839312265524, 29.483820162119812]],
    [ "Helotes Substation",[-98.68187369288012, 29.548170785055625]],
    [ "97052833",[-94.47050248773182, 37.115540189882736]],
    [ "97052834",[-94.494491056476, 37.11402911175472]],
    [ "Asbury Substation",[-94.59178507600664, 37.361008102962415]],
    [ "97053792",[-94.44656392248527, 37.23949851356978]],
    [ "Virginia Electric and Power Company",[-76.42968634794592, 37.02836144838586]],
    [ "Virginia Electric and Power Company",[-76.3850837000848, 37.0932934072476]],
    [ "Warwick Substation",[-76.46036288363021, 37.0834425727545]],
    [ "Grafton Substation",[-76.49848658963609, 37.149132149054246]],
    [ "Toano Substation",[-76.80492480670407, 37.36322851297073]],
    [ "Providence Forge Substation",[-77.03768210000001, 37.434014000000005]],
    [ "Sligo Substation",[-76.09000954999998, 36.43622465]],
    [ "Shawboro Substation",[-76.07980703055051, 36.384757535248106]],
    [ "Angola Substation",[-83.66372249999999, 41.625681400000005]],
    [ "Alkali Creek Substation",[-108.59098270308695, 45.85762817515037]],
    [ "97171699",[-108.59201019223647, 45.85610620101542]],
    [ "Virginia Electric and Power Company",[-79.43678524846025, 37.621348414513896]],
    [ "Broadview Substation",[-108.85211402516369, 46.0513788695607]],
    [ "Meadow Brook Substation",[-78.25406080039639, 39.05781512772795]],
    [ "Double Toll Gate Substation",[-78.13717292241861, 39.061352580631606]],
    [ "Greenwood Substation",[-78.13152043077972, 39.152349516687195]],
    [ "Redbud Substation",[-78.13508581249225, 39.21202447496953]],
    [ "Marsh Run Substation",[-77.76967383978717, 38.52777106766443]],
    [ "Remington Substation",[-77.77723439724222, 38.53964479002448]],
    [ "Warrenton Substation",[-77.7674934, 38.69742865]],
    [ "Riverton Substation",[-78.1772396664035, 38.9654783262761]],
    [ "97279315",[-108.92671106959685, 46.216618257696766]],
    [ "West Winchester Substation",[-78.2075846078831, 39.12947539036265]],
    [ "97351797",[-77.92418405000001, 39.20486605]],
    [ "Old Chapel Substation",[-78.00787987185284, 39.15988176089773]],
    [ "Feagan's Mill Substation",[-77.8728003828518, 39.256247078982184]],
    [ "Judith Gap Substation",[-109.80279577921999, 46.67331476860812]],
    [ "Lovettsville Substation",[-77.6326448550751, 39.29539121628289]],
    [ "97366577",[-78.36452511064505, 39.2762102801888]],
    [ "Stonewall Substation",[-78.08303758667401, 39.27301970158269]],
    [ "Grandview East Substation",[-94.50439687344168, 38.878109202815345]],
    [ "Longview Substation",[-94.40373420518138, 38.90368747368684]],
    [ "Loma Vista Substation",[-94.5114591252965, 38.9634491952411]],
    [ "Opequon Substation",[-77.95635984274976, 39.43852233727679]],
    [ "Fairview Substation",[-76.95846863316369, 39.76391613616242]],
    [ "Nipetown Substation",[-77.92339019568372, 39.53272149405029]],
    [ "Cherry Run Substation",[-78.07542229412435, 39.61779695909405]],
    [ "Sacramento Municipal Utility District",[-121.3835840728903, 38.63729212220336]],
    [ "Shepherdstown Substation",[-77.8231656723982, 39.433702555403954]],
    [ "Sleepy Hollow Substation",[-77.8133399252131, 39.32681305940679]],
    [ "Greenland Gap Substation",[-79.22185092700889, 39.20203872695392]],
    [ "Great Southwest Substation",[-97.0738049787556, 32.74619807173815]],
    [ "Jamacha Substation",[-116.95733368323557, 32.74409394652213]],
    [ "Barry Substation",[-94.6340498993609, 39.26207109151047]],
    [ "Strasburg Substation",[-78.35830827261522, 39.001637150279656]],
    [ "Meadow Brook Substation",[-78.25503220771564, 39.05407784278645]],
    [ "Ravenswood Substation",[-80.17171284970085, 26.048412005211663]],
    [ "97668999",[-78.2239807173794, 38.942828069845035]],
    [ "Blue Plains Substation",[-77.02557544367157, 38.81679128799089]],
    [ "Gordonsville Substation",[-78.22144779853747, 38.12661517494798]],
    [ "West Staunton Substation",[-79.11384226826533, 38.19376369676827]],
    [ "97754667",[-109.42441097350766, 47.07051063961231]],
    [ "Memphis Light, Gas and Water",[-89.95775030808305, 35.220072816252326]],
    [ "North Primary Substation",[-90.02531811605202, 35.180119129422145]],
    [ "97813057",[-84.23684980564748, 39.345773849493725]],
    [ "Memphis Light, Gas and Water",[-89.89947875989603, 35.22068518512858]],
    [ "Electric Substation #46",[-89.99661170696844, 35.24638774435659]],
    [ "Memphis Light, Gas and Water",[-89.8156624244334, 35.04983555507978]],
    [ "97823888",[-89.79896009999999, 35.037872549999996]],
    [ "Memphis Light, Gas and Water",[-89.82937346932304, 35.09847568302738]],
    [ "Collierville Gate Substation",[-89.74115995, 35.04631665]],
    [ "Memphis Light, Gas and Water",[-89.73553446374258, 35.10210045959994]],
    [ "97824719",[-90.15448159146344, 35.05078232479677]],
    [ "West Memphis Substation",[-90.18768093947295, 35.11776349176637]],
    [ "Allen Substation",[-90.14878671988588, 35.072533596355036]],
    [ "Memphis Light, Gas and Water",[-90.00978115359617, 35.071241504112045]],
    [ "Memphis Light, Gas and Water",[-89.79403662375462, 35.183870675527515]],
    [ "Memphis Light, Gas and Water",[-89.85841155000001, 35.18650205]],
    [ "Chappel Hill Substation",[-96.32541594895383, 30.13850668861868]],
    [ "Highway 36 Substation",[-96.37388658479524, 30.122613165682957]],
    [ "Waller Substation",[-96.08320995648691, 30.076622351560935]],
    [ "Memphis Light, Gas and Water",[-89.77135965530398, 35.14332711749077]],
    [ "Salem Substation",[-96.42557741148674, 30.11116611911831]],
    [ "Millington Substation",[-89.89126065957183, 35.340546257056445]],
    [ "Shelby Substation",[-89.80341777093913, 35.38605864069058]],
    [ "Dell Substation",[-90.02046266449089, 35.86108310519716]],
    [ "97863127",[-89.8937808, 35.46866465]],
    [ "97863128",[-89.83346145000247, 35.41113201666672]],
    [ "Memphis Light, Gas and Water",[-89.9342873827016, 35.01969854852482]],
    [ "Memphis Light, Gas and Water",[-89.91647704999998, 35.050704599999996]],
    [ "Memphis Light, Gas and Water",[-90.02694279912498, 35.17950988102528]],
    [ "Brenham Substation",[-96.39454075479959, 30.15060835523901]],
    [ "Jackson Energy Authority",[-88.85195606124559, 35.69992842506411]],
    [ "Glidden Substation",[-96.57189853329514, 29.696886874331554]],
    [ "98032873",[-89.95256052480569, 35.07676205443339]],
    [ "Southgate Substation",[-90.0077948187303, 35.0988837210813]],
    [ "Getwell Substation",[-89.9319922, 35.0849527]],
    [ "Covington Substation",[-89.64737753645856, 35.546357358233294]],
    [ "South Jackson Substation",[-88.8063401231653, 35.580021272991594]],
    [ "Miller Substation",[-89.74038011441942, 34.94865914112671]],
    [ "Raleigh Hills Substation",[-122.74861317119884, 45.48501561284671]],
    [ "Southeast Gate Substation",[-89.87691058797142, 35.07606321748441]],
    [ "Benton Substation",[-89.20041120877555, 34.8287922648789]],
    [ "Tennessee Valley Authority",[-88.26010793337363, 35.048464825577945]],
    [ "Pickwick Landing Substation",[-88.25204024580701, 35.07316165716929]],
    [ "Pickwick Electric Cooperative",[-88.25897685909125, 35.04842492457507]],
    [ "Tuscumbia Substation",[-87.67998890000001, 34.72386385000001]],
    [ "Wilson Dam Substation",[-87.62428840937405, 34.793135906667096]],
    [ "98206864",[-93.68721658327715, 41.637143159838345]],
    [ "Tulu Substation",[-88.38133968219654, 35.083796969327366]],
    [ "Joe Wheeler EMC",[-86.98114801518663, 34.55773855660867]],
    [ "Decatur Substation",[-86.95892141582587, 34.598253061623154]],
    [ "Athens Substation",[-86.95168424268009, 34.82156015983836]],
    [ "Redstone #3 Substation",[-86.62436521390134, 34.657674480097384]],
    [ "City of Athens Electric Department",[-86.84301741718592, 34.66157879537454]],
    [ "Decatur Utilities",[-86.94312341722039, 34.5868848057344]],
    [ "City of Athens Electric Department",[-86.88029879804868, 34.64138487902422]],
    [ "Addison Substation",[-87.17696552854034, 34.20158227046032]],
    [ "Red River Substation",[-96.808145, 46.880461499999996]],
    [ "Shelton Road Substation",[-89.6542981331291, 35.07517697223619]],
    [ "Memphis Light, Gas and Water",[-89.87658300356469, 35.04169416986606]],
    [ "Klinke Avenue Substation",[-90.05073009188678, 35.21018624144657]],
    [ "Moccassin Substation",[-85.33339910107301, 35.062256657930995]],
    [ "Claycomo Substation",[-94.48372070486832, 39.202627751616916]],
    [ "Liberty West Substation",[-94.47411202664306, 39.28187210573331]],
    [ "Huron Substation",[-74.43553624402318, 39.37294943135456]],
    [ "98411479",[-84.2930070644348, 39.43945346194936]],
    [ "98411632",[-84.28354485202836, 39.376803358797346]],
    [ "Quindaro Power Station",[-94.63828068284539, 39.15048395986068]],
    [ "Hogan South Substation",[-122.4170461665417, 45.50076863066306]],
    [ "Hogan North Substation",[-122.41440933959841, 45.50095838440755]],
    [ "Midtown Substation",[-94.5714994008097, 39.03932202545281]],
    [ "Mason Substation",[-90.47382036436926, 38.68653247917562]],
    [ "98670474",[-90.40260612784857, 38.68655544548728]],
    [ "Hesperus Substation",[-108.01559178257253, 37.18440307691314]],
    [ "Union Substation",[-88.85889715549399, 34.37763082120393]],
    [ "Tupelo Substation",[-88.69648653702885, 34.256081193077655]],
    [ "Montour Substation",[-80.13614938874106, 40.49855936086934]],
    [ "Clinton Substation",[-80.3048457366109, 40.50747244187735]],
    [ "Crescent Substation",[-80.23567774624911, 40.566261195967584]],
    [ "Raccoon Substation",[-80.33302019179803, 40.640077417871666]],
    [ "Mansfield Substation",[-80.40821844955316, 40.63404730242138]],
    [ "98796474",[-109.36514223272806, 47.25003229929346]],
    [ "98811178",[-118.88696083152324, 46.239317321022426]],
    [ "Wylie Ridge Substation",[-80.57006070705457, 40.454250502999166]],
    [ "North Lewiston Substation",[-117.02602740099815, 46.431041139002375]],
    [ "Hatwai Substation",[-116.91038017572959, 46.46906864370035]],
    [ "98838316",[-88.71430381561228, 34.245993474339684]],
    [ "98838318",[-88.78967636150686, 34.24105667395627]],
    [ "Holly Springs Substation",[-89.43419630363351, 34.76161001436712]],
    [ "Cusick Substation",[-117.37311336679066, 48.3287171910455]],
    [ "Sacheen Substation",[-117.27716567700634, 48.17592594053183]],
    [ "Selmer Substation",[-88.57879112836366, 35.13922893166375]],
    [ "East Liverpool Substation",[-80.5246069598064, 40.639289233479865]],
    [ "Gobain Substation",[-79.76775439060903, 40.58478166779001]],
    [ "Pittsburgh Mills Substation",[-79.79226088180815, 40.57602368508489]],
    [ "Pine Creek Substation",[-79.89849010364155, 40.55676969694473]],
    [ "Malabar Substation",[-80.70674166649572, 28.043659921373624]],
    [ "Florida Power & Light",[-80.52499306670056, 27.638474914989686]],
    [ "Puget Sound Energy",[-122.91867735, 47.33276589999999]],
    [ "Puget Sound Energy",[-122.71677943953267, 47.65763763260125]],
    [ "98932772",[-89.20997723159599, 33.38593858540812]],
    [ "Wolf Creek Substation",[-89.42078489284837, 33.290877697624005]],
    [ "French Camp Substation",[-89.41271403958838, 33.29832862398592]],
    [ "McAdams Substation",[-89.68158008462265, 33.01457186337182]],
    [ "Harwick Substation",[-79.81492054386746, 40.55160110096634]],
    [ "Lowndes Substation",[-88.31661312139933, 33.64766430013176]],
    [ "West Vernon Substation",[-88.25796350596315, 33.65156481223451]],
    [ "Nearman Substation",[-94.69628064456413, 39.16841207108234]],
    [ "Carrollwood Village Substation",[-82.52543485714993, 28.06971722523125]],
    [ "Public Service Company of Oklahoma",[-95.87780775, 36.0748315]],
    [ "Ehrlich Road Substation",[-82.51976535, 28.0850959]],
    [ "Lane Substation",[-123.23179319404886, 44.050863837269254]],
    [ "Thurston Substation",[-122.9290999015396, 44.06351717145281]],
    [ "Taft Substation",[-115.58945034593609, 47.456051592007604]],
    [ "99062633",[-109.76799947814935, 46.83813382456381]],
    [ "Skyway Substation",[-82.55019446615704, 27.977121407289737]],
    [ "99257775",[-111.63005627515801, 40.21166480679749]],
    [ "99278149",[-91.47622955000001, 46.0177366]],
    [ "99278925",[-120.34750515122776, 45.8122626700399]],
    [ "99278926",[-120.30265104554246, 45.898776607112]],
    [ "Ray Braswell Substation",[-90.32928749257984, 32.31115561350144]],
    [ "North Point Substation",[-76.51733631763462, 39.30289794907037]],
    [ "Waters Substation",[-82.51794699999999, 28.0250334]],
    [ "Round Butte Substation",[-121.26827037893416, 44.601592871859495]],
    [ "99446847",[-122.25379499160233, 44.724823154245485]],
    [ "Toledo Substation",[-123.92314427730201, 44.621225900538256]],
    [ "Albany Substation",[-123.12714993622637, 44.62125109158985]],
    [ "Hazelwood Substation",[-123.12539690128992, 44.622702007129426]],
    [ "Lancaster",[-116.91957481365124, 47.78538960128459]],
    [ "Franklin Substation",[-90.64411440512954, 31.52439404617843]],
    [ "San Diego Gas & Electric",[-117.2504357, 33.101125249999996]],
    [ "99522733",[-104.52450122996463, 48.15728324680305]],
    [ "Smithville Substation",[-94.5863528696805, 39.36203117537272]],
    [ "99599957",[-118.378153643471, 35.099428854976715]],
    [ "Windhub Substation",[-118.28086405393232, 35.034986963399895]],
    [ "99618924",[-120.31060438046691, 45.67465751591433]],
    [ "99624752",[-120.60180566144865, 45.584698456109436]],
    [ "99625445",[-116.54366006088587, 33.90139974398349]],
    [ "Sycamore Canyon Substation",[-117.03097245000137, 32.91719555480676]],
    [ "99646776",[-97.53626105053094, 35.595375364038105]],
    [ "Escondido Substation",[-117.1167280790815, 33.12575858357381]],
    [ "Germantown Substation",[-77.12597305032853, 39.75844329429346]],
    [ "Roeland Park Substation",[-94.64132990270929, 39.04368220127901]],
    [ "Merriam Substation",[-94.69835160648428, 39.01181951530027]],
    [ "99826816",[-105.13629319942564, 48.11683597025651]],
    [ "Brenham North Substation",[-96.38181860045209, 30.18183061454671]],
    [ "Crabb River Road Substation",[-95.6985156962039, 29.562798045412418]],
    [ "Franz Substation",[-95.75385718866511, 29.802967721734223]],
    [ "Mason Road Substation",[-95.73901055322166, 29.745539279595498]],
    [ "O'Brien Substation",[-95.71610191078476, 29.670697324807964]],
    [ "O'Brien Substation",[-95.7175743178451, 29.67320989009023]],
    [ "Jewett Substation",[-96.13330357531888, 31.371109674277363]],
    [ "Wharton Substation",[-96.10767739119471, 29.313623629246067]],
    [ "Florida Power & Light",[-80.6498468739493, 27.933557507305842]],
    [ "South Texas Project Tap",[-96.10722434225814, 28.87592725236987]],
    [ "Pocket Substation",[-83.0446236080428, 36.78158446587926]],
    [ "Hillje Substation",[-96.23681280207245, 29.029810159601123]],
    [ "Ball Park Substation",[-98.48891067334968, 29.396712244262815]],
    [ "Navasota Substation",[-96.09101033750396, 30.383016054541603]],
    [ "East Substation",[-96.29895712862738, 30.659449990205264]],
    [ "College Station Switching Station",[-96.29429146295715, 30.627726166170763]],
    [ "Tabor Substation",[-96.36463074058625, 30.71599995704555]],
    [ "Poncha Substation",[-106.09181510463212, 38.50942577849276]],
    [ "Gunpowder Substation",[-76.35533350158934, 39.377786415968295]],
    [ "Twin Oaks Substation",[-96.48437134003478, 31.185543685734803]],
    [ "Lewis Creek Substation",[-95.52150469608948, 30.437306060116306]],
    [ "Perryman Substation",[-76.20280523867407, 39.46268345882986]],
    [ "Dansby Substation",[-96.45884992753662, 30.7221963150263]],
    [ "Limestone Station",[-96.24704071756722, 31.424369624948618]],
    [ "100550203",[-84.05657497923917, 39.671288961169765]],
    [ "100584055",[-122.86790887600127, 47.828895753250606]],
    [ "Wendson Substation",[-124.01077308541576, 44.007467227827156]],
    [ "E. E. Clouse Substation",[-120.83463859202057, 45.812078431046864]],
    [ "Benewah Substation",[-117.0324954159789, 47.34643874737199]],
    [ "Wolf Point",[-105.71306642560079, 48.0899604135736]],
    [ "Station 129",[-78.83787908596094, 43.00184243756997]],
    [ "Sacramento Municipal Utility District",[-121.36416470653917, 38.67719656483739]],
    [ "Bacon Hill Substation",[-75.8937892461116, 39.6035559624246]],
    [ "100902295",[-114.74362568587347, 36.020231799941385]],
    [ "Sacramento Municipal Utility District",[-121.38478854637567, 38.65825916796408]],
    [ "Sacramento Municipal Utility District",[-121.30878875087949, 38.72258255867752]],
    [ "Turner Substation",[-94.71408763287927, 39.0726962727439]],
    [ "Kaw West Substation",[-94.73491504532674, 39.08016042060543]],
    [ "101108285",[-117.86361877282958, 45.06701293759813]],
    [ "Oxbow Substation",[-116.85020920230578, 44.97043813809286]],
    [ "101121560",[-116.85879208825986, 44.98590265322287]],
    [ "101122982",[-122.55352422010675, 45.954914869206185]],
    [ "101122984",[-122.56643254816797, 45.95341177181952]],
    [ "101158822",[-84.5484461918737, 38.97164146912606]],
    [ "Marion Substation",[-91.60469079056458, 42.023247599362314]],
    [ "Dry Creek Substation",[-91.65282163282939, 42.040204724799246]],
    [ "101243099",[-119.31836000779025, 45.908544475278276]],
    [ "Klamath Substation",[-121.81353799658802, 42.173978367525656]],
    [ "Meridian Substation",[-122.75432707361772, 42.36392198469074]],
    [ "Grimes Substation",[-95.90937170839342, 30.62398523172021]],
    [ "101289578",[-123.1733985785456, 46.17820146835514]],
    [ "101289581",[-123.17304572329635, 46.17347626762506]],
    [ "101301000",[-78.82137187726293, 42.867569755073944]],
    [ "Dixonville Substation",[-123.2382045143371, 43.206166057182074]],
    [ "Dixonville Substation",[-123.22503608905416, 43.21815076591198]],
    [ "101569954",[-108.79013133560817, 41.73429526910717]],
    [ "Elmwood Substation",[-75.22583741295105, 39.92995458537364]],
    [ "Willow Springs Substation",[-96.61393127862515, 29.950199873755935]],
    [ "New Bremen Substation",[-96.39940159507746, 29.919743930891446]],
    [ "Oakbrook Substation",[-84.68207060872531, 39.017314509857925]],
    [ "Yellow Creek Substation",[-103.7531715131477, 44.32292682314926]],
    [ "Amherst Substation",[-71.5928288907678, 42.80902728052483]],
    [ "101818123",[-110.83202775584941, 41.31195200034968]],
    [ "101822435",[-106.04677203119027, 41.67102070200865]],
    [ "101828299",[-105.83593786260671, 43.02170975486427]],
    [ "Freezeout Substation",[-106.39459503808472, 41.96005122553438]],
    [ "101830557",[-106.39489835223944, 41.96116990082582]],
    [ "Colstrip Substation",[-106.61357350165171, 45.89107425059574]],
    [ "34th Street Substation DUKE",[-82.67910984888339, 27.88221754736445]],
    [ "Canton Substation",[-72.92659804798588, 41.83848411388381]],
    [ "Usk Substation",[-117.27124747992461, 48.2891595867804]],
    [ "101941556",[-122.64535790882351, 45.94071546913806]],
    [ "Lakeview Substation",[-82.91479988092294, 41.51370357342348]],
    [ "Davis-Besse Substation",[-83.08955902351985, 41.59696169079868]],
    [ "Bridgeport Co Generation Substation",[-75.4052444939278, 39.79316941525141]],
    [ "102061795",[-119.9027438554434, 46.69408457673309]],
    [ "102118056",[-116.57987224459308, 33.90730274197156]],
    [ "102118057",[-116.57934823679952, 33.90718218108654]],
    [ "Garrison Substation",[-112.88810913210014, 46.51569222145385]],
    [ "Pedricktown Co Generation Substation",[-75.42430412376784, 39.767648596172975]],
    [ "Nortonville Substation",[-75.40152835891766, 39.78633022197613]],
    [ "Big Pine Tap Station",[-79.5407111395181, 40.71360374428987]],
    [ "West Penn Power",[-79.69743386963087, 40.576393475797985]],
    [ "Wine Country Substation",[-119.95066241675151, 46.29360561051521]],
    [ "Cheswick Substation",[-79.79373289318431, 40.537378892087595]],
    [ "102151058",[-120.5780499, 45.517958099999994]],
    [ "John Day Substation",[-120.73576126960404, 45.67579504900953]],
    [ "South Bend Generation Station",[-79.35059019922272, 40.638572751244965]],
    [ "South Bend Switching Station",[-79.34600470689178, 40.64159001430661]],
    [ "Spring Canyon Substation",[-103.03689763269699, 40.96500566874214]],
    [ "Spring Canyon II Substation",[-103.03351971544765, 40.962659662512344]],
    [ "Archer Substation",[-104.64897724902404, 41.145069648731784]],
    [ "Tri-State Generation and Transmission Association",[-102.99120094100142, 41.16168668310435]],
    [ "Virginia Smith Converter Station",[-102.98764088862039, 41.164151159107284]],
    [ "Houseville Substation",[-79.84169414086605, 40.73089981471066]],
    [ "Fawn Substation",[-79.7559078816327, 40.61864497670105]],
    [ "Georgia Power",[-84.37980681327703, 33.75663593444939]],
    [ "102309311",[-80.70785022670817, 28.04313751464686]],
    [ "102309312",[-80.64276905734147, 28.043296186056917]],
    [ "Harris Substation",[-80.60455687418167, 28.04159041761448]],
    [ "Somerville Substation",[-96.5217482841534, 30.33856070892363]],
    [ "Mill Plain Substation",[-122.62404360240149, 45.629216944158955]],
    [ "King Substation",[-95.21631879686747, 29.91534224723237]],
    [ "Chanarambie Substation",[-96.05235918920796, 44.02172603972482]],
    [ "102371985",[-78.87915002366987, 36.091791172019505]],
    [ "102371986",[-78.84962895270701, 36.09788094347614]],
    [ "102371987",[-78.85592998206207, 36.13191301061897]],
    [ "American Electric Power",[-95.90311840126184, 36.1132098446801]],
    [ "North Charlotte Substation",[-80.81428272236194, 35.244372715929984]],
    [ "Sideburn Substation",[-77.29638326075846, 38.79823062318864]],
    [ "102510382",[-78.85117599081072, 36.0651857031215]],
    [ "102510383",[-78.77803979963531, 36.12520386659317]],
    [ "102510384",[-78.84653425563484, 36.02736477987113]],
    [ "102510385",[-78.76859756350015, 36.131786805977136]],
    [ "Hot Springs Substation",[-114.62872794869538, 47.57591321913615]],
    [ "Wolfs Crossing Substation",[-88.23252077986061, 41.70754613141397]],
    [ "Route 59 Substation",[-88.20964847711095, 41.70338685425924]],
    [ "Royce Substation",[-88.11806002448813, 41.71511424490817]],
    [ "Oswego Substation",[-88.2983799254351, 41.70771405252648]],
    [ "Plano Substation",[-88.47916971634668, 41.683523669168395]],
    [ "ComEd Lombard Substation",[-88.04680600737903, 41.895369233751765]],
    [ "Placid Substation",[-83.45672355823585, 42.7107128923929]],
    [ "Pontiac Substation",[-83.28336756198192, 42.731682665560314]],
    [ "Poinsett Substation FPL",[-80.91548330152092, 28.383982911250172]],
    [ "102630293",[-89.586067182802, 40.68029856090284]],
    [ "Midway Substation",[-80.4159982722945, 27.37206339922569]],
    [ "Martin Plant Substation",[-80.56051505514158, 27.056950288227274]],
    [ "Murray Substation",[-122.08342022346916, 48.154366755426025]],
    [ "Apache Substation",[-109.89316499556446, 32.05995573954679]],
    [ "Raceway Substation",[-112.27346795379032, 33.80233024305644]],
    [ "Mountain Home",[-115.62481148239512, 43.17506233250715]],
    [ "102891399",[-112.91452262495918, 42.768250413034366]],
    [ "Borah Substation",[-112.93032830232215, 42.75017575326309]],
    [ "ELLINWOOD",[-88.58397090605943, 44.003658275194205]],
    [ "Black Creek Substation #99 CLAY",[-81.83934057296702, 30.104480303863955]],
    [ "Seminole Plant Substation",[-81.63218958006948, 29.729134214948157]],
    [ "Gerald Eagle Substation",[-82.07841074376621, 29.229345484955243]],
    [ "Gerald Eagle Substation",[-82.07889230432802, 29.230933448725743]],
    [ "Three Mile Knoll Substation",[-111.59628125160897, 42.71043332240762]],
    [ "Populus Substation",[-112.15541246542365, 42.42461921289157]],
    [ "Dorchester Substation",[-81.49981375574377, 31.812239372225505]],
    [ "Cedar Lake Substation",[-93.36076213833331, 44.963096610486105]],
    [ "Jesup Substation",[-81.92494738277064, 31.6031063006961]],
    [ "Jones Canyon Substation",[-120.21561706953445, 45.67465118056697]],
    [ "103038482",[-120.21441975735323, 45.67478755281529]],
    [ "103038485",[-120.21370663045387, 45.675124597739405]],
    [ "103038488",[-120.2162884597425, 45.673729347536685]],
    [ "Florida Power & Light",[-80.40875470000002, 26.034823550000002]],
    [ "Florida Power & Light",[-80.35900711304711, 26.03446622511966]],
    [ "Stonebridge Substation",[-80.3118945302126, 26.03646380601483]],
    [ "FPL Conservation Substation",[-80.43962165659076, 26.035357738405]],
    [ "Driftwood Substation",[-80.24938682410534, 26.030530794383846]],
    [ "Timberlake Substation",[-80.25086674480751, 26.055185070589143]],
    [ "Levee Substation FPL",[-80.43552401370906, 25.813354537219627]],
    [ "Brady Substation",[-112.87026228344362, 42.77293791500693]],
    [ "103077418",[-112.87326817928435, 42.77531499560399]],
    [ "Brandy Branch Substation",[-81.9474481410493, 30.318835529280005]],
    [ "Bradford Substation FPL",[-82.08418277799483, 29.924935722124786]],
    [ "Roundup Substation",[-118.7468504814315, 45.63803174702051]],
    [ "Bell Substation",[-121.0916795565946, 38.94677798897133]],
    [ "Acreage Pines Substation FPL",[-80.262813279462, 26.782311449986548]],
    [ "La Grande Substation",[-118.07174298352494, 45.31229549219669]],
    [ "Douglas Substation",[-82.87789426505843, 31.530809048495488]],
    [ "Mossyrock Substation",[-122.4312355821355, 46.53291017279274]],
    [ "Indiantown Substation FPL",[-80.40887611090369, 27.033925941580264]],
    [ "103187947",[-80.50310471123349, 27.039172020086372]],
    [ "Pratt Whitney Substation",[-80.3850626410939, 26.911387625016022]],
    [ "103187953",[-80.51220990529166, 27.04047900548294]],
    [ "Gatlin Substation",[-80.41470057515104, 27.260113799872833]],
    [ "Saint Lucie West Substation FPL",[-80.41152253698773, 27.32073262473165]],
    [ "Saint Lucie Nuclear Plant Substation",[-80.24912093035397, 27.34658467167529]],
    [ "Hutchinson Island Substation",[-80.24961287776067, 27.345971864546687]],
    [ "Primavista Substation",[-80.32649199689048, 27.349057800150387]],
    [ "Cottondale Substation",[-87.46642595577546, 33.18015320111547]],
    [ "Hargrove Road Substation",[-87.48979854680236, 33.1722028363215]],
    [ "103221596",[-87.50811777044376, 33.23326031631931]],
    [ "Crescent Ridge D.S.",[-87.48729148986263, 33.21295037401466]],
    [ "Holt Substation",[-87.47229552915445, 33.23410061562599]],
    [ "Kinport Substation",[-112.55874295749524, 42.89269039957829]],
    [ "103258733",[-87.6054225243094, 33.18760778413858]],
    [ "Tuscaloosa Substation",[-87.56141633966656, 33.23544346334691]],
    [ "Yacht Club Substation",[-87.50057885, 33.31423114999999]],
    [ "Castro Valley Substation",[-122.06113014832906, 37.69141396017819]],
    [ "Duncanville Substation",[-87.44744636489261, 33.044322518131096]],
    [ "Bradley Road Substation",[-87.48429295000001, 33.128047800000004]],
    [ "Harrison Substation",[-80.33187462374453, 39.38016471689402]],
    [ "Whiting Substation",[-83.45030801353113, 41.7919618324443]],
    [ "Hemingway Substation",[-116.66279956014314, 43.35022166997712]],
    [ "103403739",[-113.48185320841448, 42.67039083583986]],
    [ "Adelaide Substation",[-113.66870715927261, 42.705539296006805]],
    [ "Todd Substation",[-75.85393568026058, 38.61930663368247]],
    [ "Colville Substation",[-117.85294065069711, 48.55372850190849]],
    [ "Point of Rocks Substation",[-108.7606511197086, 41.6295768767322]],
    [ "Mustang Substation",[-107.93066174238412, 42.20489537388734]],
    [ "Treasureton Substation",[-111.84986725618558, 42.22264632864404]],
    [ "103513352",[-85.0012486759624, 38.760029175831164]],
    [ "103513356",[-84.68060067344776, 38.96710600009925]],
    [ "Duke Energy",[-85.07843233245073, 38.86865391567312]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.00696660160851, 38.750783426759206]],
    [ "Hegewisch Substation",[-87.55074855252933, 41.66350794058604]],
    [ "103532281",[-87.46591044457013, 41.6616087205046]],
    [ "103532283",[-87.47665355, 41.6727588]],
    [ "Tower Automotive Substation",[-87.53981457207436, 41.66923324691408]],
    [ "State Line Substation",[-87.5160760400409, 41.70435058877716]],
    [ "Stateline Substation",[-87.52348837361389, 41.69068022632223]],
    [ "Burnham Substation",[-87.5457653656123, 41.633600565860725]],
    [ "Wildwood Substation",[-87.61818356742975, 41.662982319469066]],
    [ "Blue Island Substation",[-87.66648820925525, 41.6368699600879]],
    [ "Crestwood Substation",[-87.73311613854759, 41.64012512396499]],
    [ "103541283",[-87.69964225000001, 41.650648200000006]],
    [ "TSS60 Alsip Substation",[-87.74215820999076, 41.68881978765231]],
    [ "Tinley Park Substation",[-87.8187894300152, 41.6008061159937]],
    [ "Hayden Substation",[-107.18562356092278, 40.48058060032762]],
    [ "103564307",[-107.1770236423642, 40.478299450652486]],
    [ "ComEd Davis Creek Substation",[-87.91086339028062, 41.20982234619682]],
    [ "LaSalle Substation",[-88.66511262464523, 41.24444615968177]],
    [ "Monticello Substation",[-94.84915130262578, 38.97918417308129]],
    [ "Georgia Power",[-84.16813475246872, 33.805519890239026]],
    [ "Elwood Substation",[-88.11547485531314, 41.43865210666851]],
    [ "103594039",[-112.47042749595843, 42.85797518220516]],
    [ "103601145",[-112.53931543668189, 42.9048240825013]],
    [ "North Park Substation",[-106.29079666642511, 40.812199488235585]],
    [ "Pawnee Substation",[-103.67855113012638, 40.21650705583133]],
    [ "Pentagon Substation",[-94.86396133791953, 39.011604783329624]],
    [ "Ault substation",[-104.8131822194704, 40.60719699596422]],
    [ "Rawhide Substation",[-105.0209990190287, 40.86100542840114]],
    [ "103650652",[-84.07933753630677, 40.70493449760835]],
    [ "East Side Lima Substation",[-84.08100999258852, 40.74317985255014]],
    [ "Ordnance Junction Substation",[-84.12942866677396, 40.70770244026324]],
    [ "Ford Lima Substation",[-84.08284766696957, 40.78036044249349]],
    [ "Thayer Road Substation",[-84.01286252005764, 40.7452530339163]],
    [ "Northwest Lima Substation",[-84.15001206173712, 40.77110908903836]],
    [ "North Delphos Substation",[-84.30937511109275, 40.89619326544139]],
    [ "Station 060",[-78.75455393773419, 43.01985727005294]],
    [ "West Lima Substation",[-84.12969449832853, 40.721336359039455]],
    [ "103695025",[-84.14166092165505, 40.72707860022851]],
    [ "Eastown Road Substation",[-84.16052199725189, 40.74964549944713]],
    [ "Quincy Substation",[-104.57734585572763, 39.638798780531495]],
    [ "Colorado Green Substation",[-102.60973642670045, 37.704373800082124]],
    [ "North Yuma Substation",[-102.73810909848366, 40.262613521218256]],
    [ "Rockhill Substation",[-84.08760118361181, 40.76260945649255]],
    [ "Cambell Road Switching Station",[-84.01634345862496, 40.8756680889251]],
    [ "Ghent Station",[-85.03480528513117, 38.74584922038249]],
    [ "Haviland Substation",[-84.59314948373985, 41.01624367187977]],
    [ "R.P. Mone Substation",[-84.73922136761472, 40.92853021783593]],
    [ "Saint Marys Substation",[-84.01328410640875, 40.87571291708347]],
    [ "Mill Street Substation",[-94.63078576326357, 39.077485707229485]],
    [ "Waynedale Substation",[-85.17994177418755, 41.02505677073599]],
    [ "Woodburn Substation",[-84.8926196737297, 41.12514267259649]],
    [ "Tillman Substation",[-84.86986766593736, 41.02017426524079]],
    [ "Marion Substation",[-82.97161407136569, 39.92234476743023]],
    [ "Johnstown Substation",[-104.88751009057763, 40.33353360410126]],
    [ "103895850",[-104.86595672316497, 40.45755292983077]],
    [ "Weld Substation",[-104.80753767180312, 40.42705663859723]],
    [ "103895860",[-104.87030885000001, 40.420830200000005]],
    [ "103900006",[-84.98464064999999, 38.872479850000005]],
    [ "Fairview Substation",[-85.14088600000001, 38.8662042]],
    [ "103902382",[-104.84821905, 40.46484064999999]],
    [ "Windsor Substation",[-104.88545513230164, 40.475380065493496]],
    [ "Duke Energy",[-85.0728675, 38.746204150000004]],
    [ "Hoosier Energy",[-85.2124614652758, 39.193570173250976]],
    [ "Duke Energy",[-85.42556621352124, 38.795082161537465]],
    [ "Western Area Power Administration",[-104.88838546215835, 42.11048133857752]],
    [ "Larimer River Station Substation",[-104.88731886190406, 42.10733561530876]],
    [ "Sidney Substation",[-103.04877196896797, 41.191363666993595]],
    [ "Stegal Substation",[-103.94252809928425, 41.81951260661574]],
    [ "David A. Hamil DC Tie",[-103.94222282892858, 41.82087063069452]],
    [ "104027880",[-103.96198945825164, 41.79832108278742]],
    [ "Comanche Substation",[-104.5759191137998, 38.21126189027863]],
    [ "Sowego DP",[-77.57783345776106, 38.591220350269325]],
    [ "Duke Energy",[-85.47399715093982, 38.73890859962396]],
    [ "Rockport Station",[-87.02957336939899, 37.92976238759544]],
    [ "Fountain Valley Substation",[-104.68735966986958, 38.55773904563478]],
    [ "Midway Substation",[-104.68974299247269, 38.56091168136091]],
    [ "Nixon Substation",[-104.70243177950617, 38.63211093295526]],
    [ "Front Range Substation",[-104.70676176869664, 38.628810457381135]],
    [ "Plains End switching station",[-105.22279166682623, 39.85772263349128]],
    [ "Lindendale Delivery Point",[-77.36956169994068, 38.646832850532505]],
    [ "Independent Hill D.P.",[-77.46077399652609, 38.6324634285732]],
    [ "Lorton Substation",[-77.2607402322219, 38.694983970026435]],
    [ "Millersport Substation",[-82.56566610651434, 39.88956914884122]],
    [ "West Hebron Substation",[-82.50681134276252, 39.96496961251605]],
    [ "Heath Substation",[-82.47058446367075, 40.03631485499432]],
    [ "Kirk Substation",[-82.64816801930968, 39.99124951249394]],
    [ "East Broad Street Substation",[-82.83959561432668, 39.97881969168846]],
    [ "Lucent Substation",[-82.83135521882387, 39.98836552539725]],
    [ "Kennedyville Substation",[-76.03544900084927, 39.304631199738694]],
    [ "Craig Substation",[-107.59177212633992, 40.47228169398788]],
    [ "Steamboat Substation",[-106.85125614359166, 40.48794386824261]],
    [ "104199782",[-107.58033590867849, 40.471371156524725]],
    [ "Bears Ears Switching Station",[-107.5935865136705, 40.48029173464647]],
    [ "North Woodcock Substation",[-83.88091237938605, 40.912664910311456]],
    [ "North Findlay Substation",[-83.64224976053798, 41.08894219107835]],
    [ "Streich Road Substation",[-98.37398480807765, 29.27580550967114]],
    [ "New Liberty Substation",[-83.6966034368937, 41.06645584955294]],
    [ "Grissom Road Substation",[-98.64893243597493, 29.47645813130202]],
    [ "Woodville Substation",[-83.38447870336131, 41.44910531466114]],
    [ "Bonanza Substation",[-109.29030760594269, 40.08609864970208]],
    [ "Lansing Substation",[-87.56766555, 41.569657899999996]],
    [ "ComEd Sand Ridge Substation",[-87.5546178024368, 41.58800235080602]],
    [ "Fisher Substation",[-87.5186584, 41.55163975]],
    [ "Munster Substation",[-87.5160034089175, 41.54581914861069]],
    [ "ComEd Park Forest Substation",[-87.6696364728202, 41.485545699622044]],
    [ "ComEd Matteson Substation",[-87.70897656836293, 41.49200934388805]],
    [ "Country Club Hills Substation",[-87.73736629325279, 41.55645032517941]],
    [ "Kewanee Substation",[-89.87546495479609, 41.26427575665469]],
    [ "Tower Substation",[-104.76669049561094, 39.768318301502454]],
    [ "Spruce Substation",[-104.68343551619634, 39.74171886586334]],
    [ "NCAR Substation",[-105.26841279234223, 39.9763398405075]],
    [ "Sky Ranch Substation",[-104.67636716347158, 39.79236345169968]],
    [ "Alabama Substation",[-94.88088556211567, 39.711258584390066]],
    [ "Quad Cities Substation",[-90.30627046336078, 41.72651907081585]],
    [ "Sub 91",[-90.52759691257408, 41.68130861654543]],
    [ "Barr Lake Substation",[-104.67963402784521, 39.94417153956484]],
    [ "Green Valley Substation",[-104.54444675465196, 39.91661190080991]],
    [ "Sub 56",[-90.6903746457474, 41.574846972959904]],
    [ "Interstate",[-89.59123657350956, 39.8232256470082]],
    [ "Tiffin Substation",[-91.68238081446343, 41.70711934155147]],
    [ "Birch Creek Substation",[-111.10947940472263, 41.53521112002214]],
    [ "Naughton Substation",[-110.60046164082009, 41.758475432781935]],
    [ "104410321",[-94.89194612824647, 39.48326449749541]],
    [ "104414127",[-94.69065881039681, 39.375683022210666]],
    [ "Highland Hills Substation",[-98.40910020723713, 29.359010705646504]],
    [ "Montezuma Switching Station",[-92.56350781983863, 41.61053405964702]],
    [ "Ottumwa Generation Station",[-92.55399974072658, 41.0927857874286]],
    [ "104473729",[-111.96505680817482, 40.369838374687525]],
    [ "Duane Arnold Substation",[-91.78122861718182, 42.100013939525304]],
    [ "St. Joseph Substation",[-94.79467559610828, 39.844072515734226]],
    [ "Hazleton Substation",[-91.90181712796898, 42.58592821745797]],
    [ "Iron Bridge Substation",[-79.55038413537979, 40.114502095683356]],
    [ "Bethelboro Substation",[-79.67347317262335, 39.939392011557175]],
    [ "Connellsville Substation",[-79.59582006626661, 39.994926968731896]],
    [ "Brandonville Substation",[-79.61575319229584, 39.66541011333306]],
    [ "Donegal Substation",[-79.39243627555034, 40.088170817690845]],
    [ "Mitchell County Substation",[-92.61210434850253, 43.481554928589375]],
    [ "Adams Substation",[-92.68027303857468, 43.55713103083603]],
    [ "Sigurd Substation",[-111.99297263366071, 38.84451545366825]],
    [ "Grandview Substation",[-98.4441709317113, 29.40494490179738]],
    [ "OPPD Blondo Street Substation",[-96.08005308981724, 41.27912239966938]],
    [ "104569738",[-96.1060825275163, 41.24788429991657]],
    [ "104574515",[-96.19860002232629, 41.16831207291083]],
    [ "104582826",[-96.19869613487792, 41.17021063645382]],
    [ "104634066",[-96.10433041357877, 41.5248904282276]],
    [ "Fort Calhoun Substation",[-96.081037075434, 41.518732283632104]],
    [ "Henry Lake Substation",[-104.75495730642872, 40.016330065626704]],
    [ "104647516",[-112.05967110614985, 41.81507757325874]],
    [ "104652792",[-94.64602227546251, 39.66363510345815]],
    [ "Line Creek Substation",[-94.62682520026375, 39.21186762134095]],
    [ "Navajo Generating Station Unit",[-111.39465067554534, 36.90256398569488]],
    [ "Springerville Substation",[-109.16096951459623, 34.31186888123527]],
    [ "104746708",[-96.75996766984632, 32.9265993790195]],
    [ "Coronado Substation",[-109.27743125916746, 34.57694149118839]],
    [ "104762747",[-108.44384853171147, 36.80572465938339]],
    [ "San Juan Substation",[-108.44234557415915, 36.80199481113793]],
    [ "104762761",[-108.44543766856417, 36.805570774826315]],
    [ "Waterflow Substation",[-108.44214286083839, 36.816862635857845]],
    [ "Shiprock Substation",[-108.47734397076317, 36.797147165686]],
    [ "104770998",[-108.48447917732508, 36.686548105534136]],
    [ "104771005",[-108.48398640684509, 36.68899126172355]],
    [ "Rogers Street Substation",[-86.53970921282385, 39.148424136664666]],
    [ "Baker Substation",[-96.65370444999999, 46.6954609]],
    [ "Jefferson Substation",[-117.588348847462, 33.85781112102189]],
    [ "Hubbard Substation",[-95.0111141923366, 46.8277223968025]],
    [ "Moenkopi Substation",[-111.44669755463754, 35.83267701789372]],
    [ "105005673",[-91.5056236916081, 44.816778234373324]],
    [ "Menands Substation",[-73.73103120237901, 42.685454816172545]],
    [ "Liberty Substation",[-112.50028494998413, 33.41222809769725]],
    [ "White Tanks Substation",[-112.31302165182781, 33.467153315623015]],
    [ "Buckeye Substation",[-112.59247155455908, 33.43679431251525]],
    [ "Rudd Substation",[-112.31706874032838, 33.410144561859816]],
    [ "White Tanks Substation",[-112.31303257602555, 33.46617225558029]],
    [ "105035946",[-91.50119018324001, 44.8389846262082]],
    [ "105035948",[-91.49953317611916, 44.83715358658774]],
    [ "Dale Substation",[-111.8862705572711, 33.744419237343514]],
    [ "TECO",[-82.36244958122747, 28.026700859215087]],
    [ "Sugarloaf Substation",[-110.13455062516768, 34.636129117587195]],
    [ "RMEC Substation",[-104.59519851700394, 40.089564800486464]],
    [ "Monnaco Substation",[-104.90919103810855, 39.62880590574699]],
    [ "Windover Substation",[-80.67038382487438, 28.18456524863729]],
    [ "Southern California Edison",[-115.55911786875554, 33.671418925777154]],
    [ "Westwing Substation",[-112.32155621908241, 33.707043080600506]],
    [ "Perkins Substation",[-112.32630057016, 33.70565076609342]],
    [ "Pinto Substation",[-109.31596526202752, 37.86849334701061]],
    [ "Riverdale Substation",[-104.9183718804607, 39.881456009884786]],
    [ "Miramar Substation",[-117.13560440066932, 32.894068682747886]],
    [ "Harcuvar Substation",[-113.53801043206344, 33.94254039554534]],
    [ "105245904",[-113.28631537108559, 33.90594998101493]],
    [ "Toyota Substation",[-98.53724610551122, 29.268979048656245]],
    [ "Howard Substation",[-98.57234335145318, 29.280640901218202]],
    [ "TECO",[-82.58183896536036, 28.071212332150665]],
    [ "Black Squirrel substation",[-104.62809547498199, 39.01244905636938]],
    [ "105443769",[-104.83652565812018, 39.40666733594173]],
    [ "105540904",[-107.54543770000001, 38.452219549999995]],
    [ "West Canon Substation 230",[-105.3196010756201, 38.50447837665958]],
    [ "Curecanti Substation",[-107.53537166655262, 38.429481423843]],
    [ "SR 60 Substation TECO",[-82.34175239726376, 27.943326539426774]],
    [ "105557947",[-107.79373355516805, 38.404874735466485]],
    [ "Montrose Substation",[-107.9525423427375, 38.43847237078134]],
    [ "Montrose Substation",[-107.95030763455705, 38.438121454348426]],
    [ "Meeker Substation",[-107.98046426405513, 40.00653896083363]],
    [ "Yampa Valley Electric Association",[-107.60882804658118, 40.36249048976676]],
    [ "105565108",[-107.79172779992136, 40.294105240156355]],
    [ "Meeker Switching Station",[-107.980336762699, 40.00849352968656]],
    [ "105565112",[-107.81280095901487, 40.26515922947011]],
    [ "Yampa Valley Electric",[-107.78763558565727, 40.29072348375431]],
    [ "Marcy Substation",[-104.96996124738459, 39.5250229026155]],
    [ "Soda Lakes Substation",[-105.1580389908414, 39.63254209091007]],
    [ "Deer Creek Substation",[-105.12266359639247, 39.55400483656428]],
    [ "Arvada Substation",[-105.03016793813951, 39.79747725333035]],
    [ "Russell Substation",[-105.08970152174972, 39.78954786938003]],
    [ "Calderwood Substation",[-112.30634490159973, 33.740735345187666]],
    [ "Hambug Substation",[-112.25922290714999, 33.8289765164987]],
    [ "Morgan Substation (TS-9)",[-112.26243102377968, 33.81639919747002]],
    [ "Yavapai Substation",[-112.22944463909582, 34.75650083977494]],
    [ "Waddell Substation",[-112.27122910492751, 33.84526813838368]],
    [ "San Luis Rey Substation",[-117.33448894448924, 33.21129961466589]],
    [ "Fairport Substation",[-94.34240460385234, 40.006473584349074]],
    [ "NW Electric Power Cooperative",[-94.34232085228068, 40.008365500196426]],
    [ "NW Electric Power Cooperative",[-94.34227905, 40.0093296]],
    [ "105903680",[-111.12255252892339, 33.29402964162024]],
    [ "Silverking Substation",[-111.03733097570611, 33.339173726965484]],
    [ "SRP Carrel Substation",[-111.49250329271368, 33.38661556220389]],
    [ "Goldfield Substation",[-111.50955067230214, 33.45269193665298]],
    [ "Spurlock Substation",[-111.45302825154164, 33.35370331117003]],
    [ "Tortolita Substation",[-111.28580055579434, 32.54425464200978]],
    [ "105925787",[-111.30094511979377, 32.55081555666045]],
    [ "105925804",[-111.30194006914715, 32.55408577396412]],
    [ "Saguaro Substation",[-111.29643301182762, 32.55678994899331]],
    [ "105925824",[-111.29962513617659, 32.55128953677419]],
    [ "Evergy",[-93.57501780203827, 38.758188357466715]],
    [ "180th St & I-80 Substation",[-96.19891028516807, 41.12564811054004]],
    [ "106010187",[-96.13806195000001, 41.1768193]],
    [ "OPPD",[-96.13805545734112, 41.2198307971556]],
    [ "Hoffman Estates Substation",[-88.14364167682756, 42.06460636017887]],
    [ "106016830",[-95.96946192816574, 41.169635397466635]],
    [ "Prairie Stone Substation",[-88.2129987186412, 42.06741789994771]],
    [ "Rifle Substation UTE",[-107.74221568983786, 39.52100501986145]],
    [ "Rifle Switching Station",[-107.6797920800878, 39.52075109093867]],
    [ "Santan Substation",[-111.74829887274987, 33.33007184231711]],
    [ "SRP Thunderstone Substation II",[-111.66807845536978, 33.42540672563166]],
    [ "SRP Thunderstone Substation",[-111.67487876924804, 33.426816427998986]],
    [ "Russellville South Substation",[-93.14304928722034, 35.24790542461414]],
    [ "Watershed Substation",[-122.31117865193674, 37.48724199531685]],
    [ "Seneca Substation",[-82.45179874102232, 28.045675824612676]],
    [ "TECO",[-82.51957257510485, 27.959109392966315]],
    [ "106207090",[-91.50320783734936, 44.793750274777615]],
    [ "Pipe Creek Substation",[-98.89881609229049, 29.71537173945009]],
    [ "Boone Substation",[-104.22403905688782, 38.25579859784504]],
    [ "San Luis Valley Substation",[-105.99405602370162, 37.692111835531655]],
    [ "Happy Valley Substaton",[-123.1060601179987, 48.042378146180944]],
    [ "Sedalia West Substation",[-93.28184802727601, 38.702525801181906]],
    [ "Hodgin",[-84.81796542540033, 39.814615844312975]],
    [ "106327372",[-78.89031415365483, 35.87543680495783]],
    [ "106345242",[-91.52061402110216, 44.856636003311344]],
    [ "106366370",[-84.83634402504637, 40.19650000819401]],
    [ "106367844",[-84.98292796150014, 40.32412852487876]],
    [ "AEP Jay Station",[-85.19162984960705, 40.37866905292939]],
    [ "Stuard Substation",[-99.10779051124194, 42.54397603017697]],
    [ "Ainsworth Substation",[-99.86286262181791, 42.53931156089939]],
    [ "Atkinson Substation",[-98.9313585, 42.54463880000001]],
    [ "Ainsworth Wind Substation",[-99.89161366374431, 42.44868254409223]],
    [ "Valentine Substation",[-100.5301862422455, 42.86712150695635]],
    [ "Cedar City Substation",[-113.1462460436679, 37.66381634531986]],
    [ "SRP Kyrene Substation",[-111.94198406222772, 33.35181681284509]],
    [ "SRP Kyrene Substation II",[-111.93603521501993, 33.354005359055286]],
    [ "Jojoba Switchyard",[-112.62047552767335, 33.23060213080449]],
    [ "Estrellita Substation",[-112.42318085690718, 33.349911489394785]],
    [ "Knox Substation",[-111.96529186012137, 33.29186909595175]],
    [ "Franklin Substation",[-122.26431399999998, 38.01211775]],
    [ "106522436",[-114.99885248889822, 36.03838671704716]],
    [ "106529346",[-114.9612978794592, 36.41159592349437]],
    [ "106529349",[-114.95902054361748, 36.415901353172146]],
    [ "Mayfield Primary Substation",[-88.5629198923399, 36.69887020317891]],
    [ "106530873",[-88.38603785000001, 36.646075249999996]],
    [ "106547615",[-88.3942478156984, 37.024676395990944]],
    [ "106562625",[-112.31857737834478, 33.45209366410169]],
    [ "El Sol Substation",[-112.30594334483051, 33.567880789769404]],
    [ "Rio Vista Substation",[-112.30323368278707, 33.65195835232883]],
    [ "106573771",[-85.83986160271512, 38.26430400995125]],
    [ "106573772",[-85.84009880930492, 38.26335908286664]],
    [ "106573774",[-85.85653914425119, 38.22792188263608]],
    [ "NW Electric Power Cooperative",[-94.84336499514342, 40.34606131191135]],
    [ "Duke Energy",[-85.77714352745103, 38.30131676602818]],
    [ "106607496",[-85.8482911562935, 38.3111560553846]],
    [ "Suisun Substation",[-122.04127615055761, 38.24511490859172]],
    [ "United States Department of Energy",[-88.80592261184414, 37.10742512231575]],
    [ "United States Department of Energy",[-88.80351619625202, 37.11868325379843]],
    [ "Bessemer Substation",[-86.9627264965319, 33.42242991873713]],
    [ "Tennessee Valley Authority",[-88.84599321758621, 36.31306162581746]],
    [ "Woodbine Substation",[-94.7937657456639, 39.80925540730336]],
    [ "East Side Substation",[-94.79476017213359, 39.77219042030472]],
    [ "106735173",[-88.33060534999998, 37.045052749999996]],
    [ "Union City Substation",[-89.03442119277553, 36.412133834650405]],
    [ "106747540",[-108.07860613116176, 36.91177043780982]],
    [ "106747542",[-108.03708235, 37.0113832]],
    [ "Gleason Substation",[-88.61149775975522, 36.244810321093134]],
    [ "Weakley County Municipal Electric System",[-88.67813405817213, 36.26112132567389]],
    [ "Cooperative Energy",[-89.33771037020995, 31.194112232180437]],
    [ "Hattiesburg Southwest Substation",[-89.35368795622081, 31.281520646939622]],
    [ "Johnsonville 500kV Substation",[-87.98157707829705, 36.02381170296925]],
    [ "Iatan 345kV Substation",[-94.97661297675853, 39.44982735200742]],
    [ "Jackson Switching Station",[-88.79026204518489, 35.7023869906796]],
    [ "Drake Substation",[-105.08072092885115, 40.552986765495596]],
    [ "106897176",[-87.9491001, 36.073647949999994]],
    [ "Monticello Substation",[-93.84622492693676, 45.330967811264415]],
    [ "Cumberland 500kV Substation",[-87.65747958728929, 36.39213314874669]],
    [ "Elm Creek Substation",[-93.46396153307039, 45.13925379697909]],
    [ "TECO",[-82.54529261930823, 28.025264798073845]],
    [ "Davidson Substation",[-86.98392182158229, 36.06751311482591]],
    [ "Sherburne County Substation",[-93.89761317807144, 45.374914383394945]],
    [ "Oxford Substation",[-77.07565311682704, 39.855033297297474]],
    [ "Himes Substation",[-82.50156012086293, 27.88380310677075]],
    [ "Roe Transition Substation",[-94.6378632680159, 39.04374217371997]],
    [ "Prairie Island Substation",[-92.6342809317649, 44.62500850794369]],
    [ "106985671",[-93.1092807285226, 44.93177882561472]],
    [ "Nolensville Road Substation",[-86.70844958666143, 36.04906325427755]],
    [ "Cane Ridge Substation",[-86.6539426845898, 36.03290315664036]],
    [ "Wilson Substation",[-86.46505777929995, 36.20524171600188]],
    [ "Gladeville Substation",[-86.46650954850509, 36.148394256310866]],
    [ "Radnor Substation",[-86.7706960316073, 36.056789071022145]],
    [ "Maury Substation",[-87.0186126708066, 35.67286403922477]],
    [ "Lindgren Substation",[-80.4133049, 25.6909542]],
    [ "Nissan North America, Inc.",[-90.06559053448134, 32.57005972774873]],
    [ "Monsanto Switching Station",[-87.10413157263115, 35.668343563250254]],
    [ "Columbia Substation",[-87.03331282261422, 35.663678123325404]],
    [ "Sweetwater Substation",[-80.41625754667814, 25.7731709733657]],
    [ "Batesville Substation",[-89.93512018894727, 34.33203797951431]],
    [ "Battlefield Substation",[-86.77160801451632, 36.11883517717874]],
    [ "107105339",[-87.01938895554116, 35.61924863696835]],
    [ "East Franklin Substation",[-86.81875960024084, 35.92170358432855]],
    [ "East Franklin Substation",[-86.80917047623969, 35.92139914529999]],
    [ "Aspen Grove Substation",[-86.84043529255852, 35.942499489448764]],
    [ "East Cool Springs Substation",[-86.79448247779919, 35.93964095842922]],
    [ "Franklin Substation",[-86.85520963984544, 35.92628158389904]],
    [ "Westhaven Substation",[-86.91564259065595, 35.926643275205244]],
    [ "Brentwood Substation",[-86.7512422694863, 36.01814935886723]],
    [ "107134356",[-86.77243911806517, 35.96806935584452]],
    [ "Jingo Substation",[-87.13919168136347, 35.958331587996284]],
    [ "Black Dog Substation",[-93.2516440775627, 44.809603549523985]],
    [ "107193377",[-93.35197886990564, 44.80396104022066]],
    [ "107203619",[-86.86245505000001, 36.1720546]],
    [ "South Nashville Substation",[-86.7462724164762, 36.155508684075116]],
    [ "Nashville Electric Service",[-86.73432742240838, 36.20780595810958]],
    [ "107221356",[-85.34726984967968, 41.119350635449145]],
    [ "Nashville Electric Service",[-86.7449995520785, 36.15382768315806]],
    [ "Murfreesboro Road Substation",[-86.62478024385469, 36.0642677837051]],
    [ "Craighead Substation",[-86.7589756025716, 36.13023693647649]],
    [ "Springfield Substation",[-86.84679210503053, 36.492631581016454]],
    [ "West Nashville Substation",[-86.86627591169166, 36.16584662271331]],
    [ "Western Area Power Administration",[-95.40735075903747, 41.96617685597161]],
    [ "MidAmerican Energy",[-93.86368769999999, 42.5614335]],
    [ "107257237",[-85.12644035582355, 41.110859105314596]],
    [ "Crow River Substation",[-93.80562333789388, 45.057168789116226]],
    [ "Airport Substation",[-86.6488689140149, 36.12391734145656]],
    [ "Blair Road Substation",[-86.57842655678141, 35.97209938597568]],
    [ "Hurricane Creek Substation",[-86.5926062424094, 36.0249949907141]],
    [ "Smyrna Substation",[-86.52661974601924, 35.96657803790832]],
    [ "Wilmarth Substation",[-94.0083383888612, 44.19856638753548]],
    [ "Front Street Substation",[-73.94138243241935, 42.82133478210641]],
    [ "Franklin Substation",[-94.88567562256014, 44.53579234654406]],
    [ "Murfreesboro 161kV Substation",[-86.40240664011162, 35.840272432227096]],
    [ "Murfreesboro Substation",[-86.40375609023077, 35.84114568443637]],
    [ "107418388",[-86.88551523858723, 36.469970031962596]],
    [ "Three Mile Island 500kV Substation",[-76.71296918578668, 40.15009519375003]],
    [ "TMI 230 kV Substation",[-76.72314738009882, 40.15366009628827]],
    [ "Adairville Substation",[-86.87483911552118, 36.668884625201144]],
    [ "Goodlettsville Substation",[-86.71700288907478, 36.3171121766093]],
    [ "Cross Plains Substation",[-86.75854059548881, 36.5464025158474]],
    [ "Greene Street Station",[-76.6241146750936, 39.28564499296225]],
    [ "Hernando Substation",[-89.96993414562064, 34.812199635713]],
    [ "Aurora Substation",[-80.67128071540448, 28.137124108959632]],
    [ "King Plant Substation",[-92.78121615156833, 45.03026499719032]],
    [ "Triune Substation",[-86.6604430659073, 35.853851292226445]],
    [ "Patroon Substation",[-73.80887714674401, 42.688958778826525]],
    [ "Summit Substation",[-97.72378545201195, 30.39812938422806]],
    [ "Wildcat Creek Substation",[-96.62856844342842, 39.18417536001964]],
    [ "Clarksville Primary Substation",[-87.33644486354508, 36.533572851860335]],
    [ "107526555",[-87.31925866636398, 36.555610351228395]],
    [ "107526560",[-87.34920233060649, 36.6289265053174]],
    [ "Rotary Park Substation",[-87.2734152833339, 36.504653899937296]],
    [ "Oak Plains Substation",[-87.16826884999999, 36.4291046]],
    [ "Round Pond Substation",[-87.37491734670225, 36.45502283344737]],
    [ "Sycamore Substation",[-89.31338802619972, 43.11319551235677]],
    [ "New Providence Substation",[-87.39954208537652, 36.5512830718495]],
    [ "Montgomery 500kV Substation",[-87.25423547769252, 36.592055645297805]],
    [ "West Andover Substation",[-71.18833719635198, 42.68555241281679]],
    [ "Indiana Substation",[-93.33244096124841, 45.016130838503024]],
    [ "Pacific Gas and Electric",[-123.78030213809278, 40.47962760176853]],
    [ "Parrish Substation",[-75.20122151658909, 39.96922390404417]],
    [ "Clay Station",[-76.17129975366127, 43.19791858464042]],
    [ "Station 122",[-77.38383446675827, 43.05513593907253]],
    [ "Edic Station",[-75.22726154552808, 43.15746839596119]],
    [ "Aldrich Substation",[-93.29057554082024, 44.97752291157935]],
    [ "Elk River Substation",[-93.55463367994722, 45.298025376168724]],
    [ "Russellville North Substation",[-86.90633979270997, 36.86006597699207]],
    [ "Bearwallow Substation",[-86.98632419999998, 36.30196255]],
    [ "Ashland City Substation",[-87.06383055000002, 36.2623723]],
    [ "Tomahawk Substation",[-94.60254995277867, 38.94221068851467]],
    [ "Blue Valley Substation",[-94.490788051664, 39.10487506193072]],
    [ "Southtown Substation",[-94.57512756487905, 38.97026652607433]],
    [ "Plaza Substation",[-77.47827106712874, 37.49803117519011]],
    [ "Carver Substation",[-77.4483560015907, 37.555699732932204]],
    [ "Marlboro Substation",[-77.43490449999999, 37.4740574]],
    [ "Kevlar Substation",[-77.43752535000002, 37.45008545]],
    [ "Basin Substation",[-77.43074829910361, 37.49204609707818]],
    [ "Bellwood Substation",[-77.43269100901095, 37.41738732071942]],
    [ "Northeast Substation DUKE",[-82.65980198985827, 27.85809070480732]],
    [ "Northeast Substation DUKE",[-82.65917679596154, 27.856449763373785]],
    [ "Southwestern Electric Power Company",[-94.16227306063645, 36.19612246089573]],
    [ "Hamilton Substation",[-85.15084683216763, 35.02924208907028]],
    [ "Midtown Substation",[-93.26706772494336, 44.95072304662242]],
    [ "107940692",[-82.81972303409425, 39.02249523773596]],
    [ "Waverly Substation",[-83.00124623921585, 39.13015921350914]],
    [ "Ravensworth Substation",[-77.2437471950237, 38.79675176272873]],
    [ "Braddock Substation",[-77.22367146515718, 38.821849804960905]],
    [ "Gallows Road Substation",[-77.21910862608193, 38.85441170966989]],
    [ "Idylwood Substation",[-77.20981021084381, 38.88576895815194]],
    [ "Potomac Yard Substation",[-77.05083959922675, 38.840273050085564]],
    [ "Glebe Substation",[-77.05462636854256, 38.84165937368302]],
    [ "CIA Substation",[-77.1478565395101, 38.95054605564418]],
    [ "New Road Delivery Point",[-77.625408, 38.93389795]],
    [ "Middleburg Substation",[-77.72155873326875, 38.9592189494356]],
    [ "Spruance Substation",[-77.42937136651092, 37.4545691529516]],
    [ "Benns Church Substation",[-76.57570757597092, 36.91335086181752]],
    [ "Smithfield Substation",[-76.66954516942631, 36.959680934653534]],
    [ "Glencarlyn Substation",[-77.12928243333334, 38.8695461]],
    [ "Arlington Substation",[-77.09777668875451, 38.84766917139365]],
    [ "Davis Substation",[-77.04859889163804, 38.86941958313383]],
    [ "Pentagon Substation",[-77.04947627478865, 38.868380545441774]],
    [ "Jefferson Street Substation",[-77.05485591555787, 38.79709189477373]],
    [ "REP 60 kV Switchyard",[-121.38347222647897, 38.79216483448743]],
    [ "Yoe Substation",[-76.62002609487641, 39.921216045491306]],
    [ "108069460",[-84.5734479983551, 39.01913020264042]],
    [ "Pineville Substation",[-83.75578641189728, 36.795255896223885]],
    [ "Bull Run Substation",[-84.15794543541294, 36.018862461063186]],
    [ "108138758",[-93.58096737348924, 44.79536594152528]],
    [ "Chaska SW Station",[-93.57300002902441, 44.80352103170882]],
    [ "108140485",[-93.86765065113119, 44.809214952929665]],
    [ "108145086",[-94.77358444999997, 35.344390049999994]],
    [ "108145118",[-94.75860341597446, 35.25441000458075]],
    [ "108148143",[-94.7996060588279, 35.447430431636064]],
    [ "Cross Park Substation",[-84.08584717925707, 35.923261593669]],
    [ "Elmendorf Substation",[-98.32216944315365, 29.270216049484514]],
    [ "Ebenezer Substation",[-84.07581028971354, 35.90518148243086]],
    [ "Alcoa Switching Station",[-84.00348777211286, 35.75044504634558]],
    [ "Solway Substation",[-84.135336776091, 35.97166949672762]],
    [ "Duncan Substation",[-83.96512587542927, 35.79656491755344]],
    [ "Nixon Road Substation",[-83.85159200208102, 35.914365974755405]],
    [ "Stock Creek Substation",[-83.9424102059028, 35.86784784263511]],
    [ "City of Alcoa",[-83.99180182171332, 35.841938705616286]],
    [ "Nissan North America, Inc.",[-86.48538354547816, 35.96151876802292]],
    [ "Rainey Substation",[-73.94304639581478, 40.7632060947778]],
    [ "Peters Mountain Substation",[-80.79816594590568, 37.37207046531504]],
    [ "Kimballton Substation",[-80.66699375298278, 37.3533411721139]],
    [ "108318934",[-73.9092013020783, 40.78773501104317]],
    [ "Vernon Substation",[-73.94690949287144, 40.758017599851016]],
    [ "North Queens Substation",[-73.90683347330463, 40.78167349255101]],
    [ "Antioch Substation",[-81.0363445676262, 36.176404997204244]],
    [ "McGuire Substation",[-80.94575754119619, 35.42218036149406]],
    [ "108405261",[-80.90336966663634, 35.431705249891664]],
    [ "108405262",[-80.89420318416194, 35.47536182827018]],
    [ "108405263",[-80.91197186611186, 35.427301459498274]],
    [ "108405267",[-80.87866355, 35.457484699999995]],
    [ "Lincoln Substation",[-81.03347579197676, 35.43279703361221]],
    [ "108430005",[-80.83149460036435, 35.3840917873609]],
    [ "Point MacKenzie Substation",[-150.03175466280632, 61.248744744610704]],
    [ "John Sevier Substation",[-82.96123105000001, 36.37699315000001]],
    [ "108630668",[-111.19234577732797, 45.67041728126782]],
    [ "108631463",[-75.24349665, 40.04020485]],
    [ "Phipps Bend Substation",[-82.80789149094461, 36.4607004458706]],
    [ "Cherokee Dam Substation",[-83.49920221609658, 36.17147330963487]],
    [ "Cherokee Dam Substation",[-83.4974847019484, 36.168154549292815]],
    [ "Orebank Substation",[-82.46325044189813, 36.5636545708436]],
    [ "Nagel Substation",[-82.69605176795325, 36.5915506696564]],
    [ "Sullivan Substation",[-82.27951388797455, 36.44218489270348]],
    [ "Greeneville Substation",[-82.87908423948139, 36.15873027823704]],
    [ "Saltville Substation",[-81.75335369619462, 36.89523166902261]],
    [ "Abingdon Substation",[-82.00819565152324, 36.72015429771449]],
    [ "Windsor Substation",[-76.57165756946272, 39.90433024408626]],
    [ "Coliseum Substation",[-98.4443275253364, 29.43262416922863]],
    [ "Carrcroft Substation",[-75.50776341557142, 39.78121170740594]],
    [ "Darley Substation",[-75.47357692864199, 39.81162215434808]],
    [ "Silver Side Road Substation",[-75.49879264394005, 39.7970670654673]],
    [ "Holbrook Substation",[-98.41659835201285, 29.46347319933711]],
    [ "109034635",[-84.22855149225853, 30.384178923268337]],
    [ "Upper Providence Substation",[-75.52085240915312, 40.172352676187174]],
    [ "Perkiomen Substation",[-75.45202519308872, 40.21480624266559]],
    [ "Public Service Company of Oklahoma",[-95.92204593403355, 36.16236609343956]],
    [ "Hyatt Rd",[-76.76994920089979, 42.93622042143076]],
    [ "State Street Substation",[-76.57771099265841, 42.951970675512214]],
    [ "Lonsdale Substation",[-83.9526166680653, 35.960773824625385]],
    [ "Knoxville Primary Substation",[-83.86420649974248, 36.03334094225743]],
    [ "East Knoxville Substation",[-83.86352307811757, 36.000540165602345]],
    [ "Arlington Substation",[-83.92999741088185, 36.00820802099877]],
    [ "Washington Ave Substation",[-83.91403752136871, 35.98400837853716]],
    [ "109609240",[-117.14041039159424, 33.50370794547843]],
    [ "Norris Switching Station",[-84.09053824804548, 36.22382401953894]],
    [ "Lafollette Substation",[-84.0904015195298, 36.40005088559448]],
    [ "South Knoxville Substation",[-83.91242741730397, 35.94334774135004]],
    [ "UT Substation",[-83.92746658016486, 35.94897359454783]],
    [ "109722791",[-79.05691603645629, 35.892109043263545]],
    [ "Fillmore Substation",[-112.0781199748086, 33.453989182846556]],
    [ "Garfield Substation",[-112.07165257328947, 33.45801788699316]],
    [ "109826655",[-82.65104141134472, 28.059525567696717]],
    [ "Cameron Substation",[-79.06184185953914, 35.90753578858899]],
    [ "West Salem Substation",[-80.1258109890224, 37.299859270844436]],
    [ "Flint Creek Substation",[-94.52764523381639, 36.25405619098073]],
    [ "109917475",[-94.51025450000002, 36.256071999999996]],
    [ "Poages Mill Substation",[-80.03466199999998, 37.199476450000006]],
    [ "109971727",[-91.39891715000002, 44.83699265]],
    [ "Roanoke Substation",[-79.92108553017069, 37.25052346141852]],
    [ "Glen Lyn Substation",[-80.86116338239877, 37.36977567905325]],
    [ "City of Salem",[-80.03940122123261, 37.27493490342359]],
    [ "South Substation",[-110.96728976958894, 31.997752875667153]],
    [ "Roxbury Substation",[-77.66064606511537, 40.109697684208555]],
    [ "Saint Hedwig Substation",[-98.3967320406483, 29.427124403671808]],
    [ "Lawrence Avenue Station",[-74.97072400199453, 44.678646059894184]],
    [ "SRI Substation",[-122.17831563320884, 37.455356491130615]],
    [ "Brooks Field Substation",[-98.44980150329076, 29.33457742676357]],
    [ "Olmos Substation",[-98.49110899998786, 29.484189093518037]],
    [ "110450140",[-85.14440598338648, 41.11463759560838]],
    [ "Tenth Street Substation",[-98.47983830090786, 29.43266067685314]],
    [ "Skyline Substation",[-98.40877840393847, 29.58055910632256]],
    [ "110568202",[-96.95368075783989, 35.24692260506838]],
    [ "110573544",[-117.20340371518101, 33.55787644688646]],
    [ "110768560",[-91.35969481616418, 44.9654233761107]],
    [ "110852389",[-96.93906678349946, 35.32355656903487]],
    [ "111291076",[-82.66171026981112, 28.00463944666214]],
    [ "East Clearwater Substation DUKE",[-82.73190827679451, 28.000530646387368]],
    [ "111294907",[-96.89383050960234, 35.34022847772005]],
    [ "Weiderstein Substation",[-98.26526569156158, 29.599087874541354]],
    [ "111367863",[-115.16478185147058, 36.12280583255497]],
    [ "Raymond Drive Substation",[-88.1892546932197, 41.8064097870592]],
    [ "Westside Substation",[-98.56090950732442, 29.439781071070755]],
    [ "111770740",[-96.90957906597802, 35.36932997392758]],
    [ "Pacific Gas and Electric Company",[-120.95299352417103, 39.11536839838635]],
    [ "North Bloomfield Substation",[-72.75828305196495, 41.89090302574097]],
    [ "Belmont Substation",[-122.26530076309837, 37.52343842472166]],
    [ "O'Connor Substation",[-87.9982363950667, 43.03098996177167]],
    [ "Palo Alto Switching Station",[-122.11513966786107, 37.439732437891756]],
    [ "112297084",[-122.11435195837166, 37.439001874755824]],
    [ "Oakland X Substation",[-122.23127548966185, 37.805374372113285]],
    [ "30th Street Substation",[-82.42693049847873, 28.0037319684009]],
    [ "Gardenville Substation",[-78.76823526636981, 42.851832419545914]],
    [ "Clinton",[-113.70908780319469, 46.75453458931048]],
    [ "Pinn Road Substation",[-98.62344638847127, 29.413259989717314]],
    [ "112438365",[-96.96450203738156, 35.369551542035715]],
    [ "Oakland K (Claremont) Substation",[-122.22876721265261, 37.84755819756534]],
    [ "Decoto Substation",[-122.01758579207043, 37.59532177849304]],
    [ "Westover Hills Substation",[-98.69434293658378, 29.481124573508424]],
    [ "VLSI Substation",[-98.67852117682439, 29.473575197840606]],
    [ "Hicks Substation",[-121.90088326919839, 37.233686028805536]],
    [ "112715790",[-96.91432563609641, 35.3902713983435]],
    [ "112747029",[-96.89405526643351, 35.40590708174995]],
    [ "Florida Power & Light",[-80.38357455, 25.7529461]],
    [ "Habana Substation",[-82.48893481310888, 27.99557920779561]],
    [ "113519290",[-84.22141743123962, 39.32168360922789]],
    [ "Sheldon Road Substation",[-82.58249925500006, 28.00085303419598]],
    [ "Sheldon Road Substation",[-82.58231455568367, 28.025267623599618]],
    [ "De Zavala Road Substation",[-98.56636076485408, 29.571523614497362]],
    [ "Medical Center Substation",[-98.57571602152545, 29.52076715856377]],
    [ "Castle Hills Substation",[-98.5258404625644, 29.538524739133884]],
    [ "113566619",[-149.71240580070145, 61.23027262243092]],
    [ "JC Edwards Substation",[-85.22616580973941, 34.96523887502442]],
    [ "Byllesby",[-92.89220555387409, 44.543086997729]],
    [ "St. Clair Substation",[-80.08751587047385, 40.35366836741551]],
    [ "Logans Ferry Substation",[-79.79686711374447, 40.529644069929326]],
    [ "Wilmerding Substation",[-79.81301923385135, 40.402177228776985]],
    [ "La Sierra Substation",[-98.6080671229292, 29.61718051427345]],
    [ "UTSA Substation",[-98.62593480451085, 29.586508768127523]],
    [ "Highland Substation",[-79.90539585873971, 40.472614408083814]],
    [ "113768808",[-96.915940603865, 35.422652600597495]],
    [ "113768837",[-96.9986889438776, 35.44858889182726]],
    [ "Flamingo Substation",[-115.16285440719227, 36.11486025826892]],
    [ "113819423",[-97.08296158572008, 35.376215279956256]],
    [ "New London Substation",[-86.28666269536151, 40.45026090166676]],
    [ "Center Substation",[-76.62132629865873, 39.314176863789214]],
    [ "Delta Substation",[-90.06395580630428, 29.950510677271588]],
    [ "Glenwood Substation",[-122.18693054653995, 37.45716509558183]],
    [ "114649330",[-84.50751931319768, 39.06583559969104]],
    [ "Sacramento Municipal Utility District",[-121.11823654999999, 38.65221535]],
    [ "114751052",[-76.95096025716103, 42.67955921721206]],
    [ "114751058",[-77.02873855, 42.82852955]],
    [ "National Grid",[-78.86361359457426, 43.03612245749973]],
    [ "Dover Substation",[-70.8634746915729, 43.19816654287633]],
    [ "Vasona Substation",[-121.96619793694603, 37.253835775915164]],
    [ "Silver Creek Substation",[-89.9868987024044, 31.600563864690297]],
    [ "Somerset Substation",[-78.60869638957116, 43.352367074205716]],
    [ "Parachute Substation",[-108.04382630880541, 39.46615785830766]],
    [ "Osborne Substation",[-80.11288038196854, 26.58765366505427]],
    [ "Flying Cow Substation",[-80.29767673884638, 26.676793698858198]],
    [ "Hilyard Substation",[-123.08118448159986, 44.026030935611715]],
    [ "Evans Churchill Substation",[-112.06575912233421, 33.45811257342319]],
    [ "115924033",[-88.97134694045597, 39.8099964784401]],
    [ "116011313",[-81.267059864476, 35.58728363227686]],
    [ "116032669",[-88.89675755906556, 39.87540072718908]],
    [ "Jefferson Substation",[-123.10240601133474, 44.04354749134016]],
    [ "First Electric Cooperatice",[-92.5614593254054, 34.63916613579184]],
    [ "Willow Creek Substation",[-123.16544835289669, 44.04112522679159]],
    [ "Talega Substation",[-117.57147437552362, 33.45317832099737]],
    [ "Bartlett Substation",[-88.15144219999999, 41.9796599]],
    [ "Oaks Substation",[-98.59059435366272, 29.130858085656048]],
    [ "PPL",[-75.84379785145117, 41.2434488410671]],
    [ "116790727",[-117.25981197428115, 33.90876274657686]],
    [ "Key West Substation",[-81.73418864598271, 24.57567098157422]],
    [ "Spaulding Substation",[-88.24054241960161, 42.00447213723223]],
    [ "ComEd Wayne 138kV-345kV Substation",[-88.24017076409177, 41.98274840782982]],
    [ "116869274",[-112.12832639999998, 38.6275392]],
    [ "116873549",[-115.17030148551397, 36.10453140218467]],
    [ "Carthage Water & Electric Plant",[-94.31216020455527, 37.15322939706781]],
    [ "Oklahoma Gas & Electric",[-95.28711515508067, 35.75519349713888]],
    [ "Texas Research Substation",[-98.7877590104404, 29.420523730465533]],
    [ "117109320",[-91.99434958791385, 44.40948899448518]],
    [ "117148434",[-82.03170953488858, 29.12415743391897]],
    [ "WINGRA",[-89.39968690021215, 43.04477089930949]],
    [ "117162743",[-103.66267033393831, 41.8312668397771]],
    [ "Lents Substation",[-122.55800333833393, 45.4765130501634]],
    [ "Swoyersville Substation",[-75.8846354540011, 41.295465132534204]],
    [ "Mountain Substation",[-75.96550134519408, 41.26469587247819]],
    [ "117322712",[-76.06878836108227, 41.202386575857574]],
    [ "Salem Substation",[-76.20160020114834, 41.0659504998609]],
    [ "Susquehanna Junction Substation",[-76.11550215854521, 41.08900341906419]],
    [ "Susquehanna Substation",[-76.14957293197028, 41.08779763319771]],
    [ "Susquehana T10 Yard",[-76.1543738856806, 41.090980367874316]],
    [ "Stanton Substation",[-75.79971336531487, 41.37655980916593]],
    [ "El Patio Substation",[-121.93572331925085, 37.29173756291951]],
    [ "Vienna Substation",[-77.26465755, 38.9008258]],
    [ "Blytheburn Substation",[-75.93665174455462, 41.121458372139614]],
    [ "UGI",[-75.92784465000001, 41.21156630000001]],
    [ "St. Johns Substation",[-76.00067668635778, 41.02937443378184]],
    [ "117588016",[-75.7965301, 41.25431725]],
    [ "PPL",[-75.83612860341955, 41.263596611016325]],
    [ "117588021",[-75.98582350851169, 41.049262226224194]],
    [ "Jenkins Substation",[-75.81718378970767, 41.281330053789084]],
    [ "Wilkes-Barre Substation",[-75.90006283679286, 41.20280469606091]],
    [ "Dupont Substation",[-75.73314078539124, 41.32008573592192]],
    [ "Yatesville Substation",[-75.78541458250646, 41.297341351157534]],
    [ "Montage Substation",[-75.70461933771506, 41.34472516976612]],
    [ "Keyser Avenue Substation",[-75.70975859999999, 41.409210200000004]],
    [ "Lincoln Substation",[-76.00231845756838, 41.19113816014808]],
    [ "Cimarron Substation",[-97.79213986901449, 35.511112524172205]],
    [ "Quintana Road Substation",[-98.55651874923363, 29.372974974827095]],
    [ "South San Antonio Substation",[-98.53974794057747, 29.367676240673877]],
    [ "Merida Street Substation",[-98.53977692589926, 29.40948522414473]],
    [ "Hortontown Substation",[-98.09814402438252, 29.71334187245192]],
    [ "GPI Substation",[-98.17796611794567, 29.677061822471344]],
    [ "Comal Substation",[-98.13500546731021, 29.70682939264357]],
    [ "Morris County Substation",[-96.46307113226118, 38.6457499069137]],
    [ "Setab Substation",[-100.96887286314733, 38.485982211209596]],
    [ "Robert Moses Substation",[-79.02766537967389, 43.139985524981405]],
    [ "TXI Substation",[-98.04057119355863, 29.803478454181043]],
    [ "Henne Substation",[-98.05106470887111, 29.77360586720465]],
    [ "Highway 46 Substation",[-98.24521058692093, 29.75877464795691]],
    [ "118176070",[-78.9840911186407, 43.05041123777608]],
    [ "Yukon Substation",[-82.44326387371264, 28.029240389484023]],
    [ "Station 206",[-78.80125935604605, 43.05614867452805]],
    [ "118400846",[-117.3235439676659, 34.30742969462071]],
    [ "118672048",[-78.71458766764567, 43.147630164668655]],
    [ "Hinman",[-78.71959867537305, 43.14881595659667]],
    [ "Lockport",[-78.71929253347109, 43.14739258206877]],
    [ "Lakeview Substation FPL",[-80.15357543215647, 26.306058215674458]],
    [ "118726999",[-107.31883204293446, 32.95394324270314]],
    [ "Stetson Substation",[-104.68795322746244, 38.89991995002734]],
    [ "Clinton Substation",[-72.60095435229726, 42.10473126126013]],
    [ "Tualatin Substation",[-122.78602578128245, 45.371025862632614]],
    [ "West Chicago Substation",[-88.22430055378481, 41.89334721553829]],
    [ "Morgan Substation",[-75.72218078030461, 41.4885279932363]],
    [ "Ballinger Substation",[-99.94455610931922, 31.741188559966194]],
    [ "Tuscola Substation",[-99.79001747924245, 32.20325569657996]],
    [ "Pacific Gas and Electric Company",[-121.79701443861454, 37.32247274639342]],
    [ "Piercy Substation",[-121.78732515320418, 37.26895736407686]],
    [ "Fannin Substation",[-95.40847432386693, 29.689591458342093]],
    [ "Stadium Substation",[-95.40650761656146, 29.685277764384743]],
    [ "Old Town Substation",[-117.19239144384683, 32.766075747032886]],
    [ "Eastgate Substation",[-117.20083712316207, 32.884828039386186]],
    [ "Mission Substation",[-117.13722135433069, 32.78385448524051]],
    [ "Power Street Substation",[-71.42929784180158, 42.77666964939922]],
    [ "Madison Gas & Electric",[-89.39973900047384, 43.0699350512588]],
    [ "119960949",[-84.60703577727112, 38.76343659485187]],
    [ "119961013",[-84.62335851811324, 38.86963309443197]],
    [ "McHenry Substation",[-88.28018869391565, 42.33520011155923]],
    [ "120310413",[-78.77883328725346, 33.81451935735674]],
    [ "Fontana Substation",[-83.80524905257005, 35.45094534637103]],
    [ "Milpitas Substation",[-121.92132297640643, 37.45756158586134]],
    [ "Scott Receiving Station",[-121.95463469704777, 37.37709435563313]],
    [ "Montague Substation",[-121.88846984058468, 37.41540385940709]],
    [ "Trimble Substation",[-121.92714047693609, 37.38198560708766]],
    [ "FMC Substation",[-121.92199318416363, 37.347319504591034]],
    [ "120402576",[-82.77683713843119, 38.57079334069551]],
    [ "Hanging Rock Substation",[-82.77454467487047, 38.56926033540281]],
    [ "Burns Substation",[-97.73433145000001, 26.219096200000003]],
    [ "Blue Grass Substation",[-75.02697737002234, 40.07241693331804]],
    [ "Woodlawn Substation",[-80.88392168840083, 35.17446828836653]],
    [ "120654566",[-80.8789318720091, 35.24957928715559]],
    [ "Lakewood Substation",[-80.87615608612359, 35.25004555207159]],
    [ "120654570",[-80.88431738437866, 35.2191388119667]],
    [ "120656063",[-80.82544819562386, 35.255127232046576]],
    [ "Allen Substation",[-81.0110593731286, 35.190172322264736]],
    [ "120718189",[-80.89881807334554, 35.281964055824034]],
    [ "North Madison Substation",[-89.41639208255911, 43.25654270139017]],
    [ "120780854",[-80.75458844525556, 35.294288324729536]],
    [ "120780856",[-80.76822304506183, 35.303927130470896]],
    [ "Harrisburg Substation",[-80.69248713237481, 35.31293292170922]],
    [ "Woodleaf Switching Station",[-80.600973040739, 35.722829964178615]],
    [ "Newport Tie Substation",[-81.12156851889755, 34.99763859400753]],
    [ "Catawba 230kV Switching Station",[-81.07460315, 35.05172399999999]],
    [ "Peacock Substation",[-81.19020953046677, 35.22407752556813]],
    [ "Berks Substation",[-76.03195062991483, 40.31181160047851]],
    [ "Ripp Switching Station",[-81.43362795, 35.1573633]],
    [ "Pacolet Tie Substation",[-81.74959530991626, 34.89580782243884]],
    [ "Shady Grove Tap",[-82.52349911246198, 34.82806004721718]],
    [ "120951832",[-81.10446173078573, 35.21224290566437]],
    [ "120953420",[-81.17453877237942, 35.21008359482599]],
    [ "Cliffside Substation",[-81.76709747771721, 35.21977308743702]],
    [ "Brownstown Substation",[-83.24887817564637, 42.11607078846359]],
    [ "Granada Substation",[-82.4931531186886, 27.92057913402671]],
    [ "Duke Energy",[-81.01086418312728, 35.052303490113324]],
    [ "121020970",[-80.98662885, 35.03724004999999]],
    [ "121020971",[-81.012382315801, 35.05297437212071]],
    [ "Duke Energy",[-80.98087003615869, 35.13508358092452]],
    [ "121023058",[-80.99326115951162, 35.141842389963635]],
    [ "121023066",[-80.99100010651952, 35.14809665581316]],
    [ "121023070",[-81.01316016630457, 35.135796087850856]],
    [ "121070382",[-80.7665351376207, 35.063791533948354]],
    [ "121070383",[-80.93649599866171, 35.05830780027674]],
    [ "121070397",[-80.94975171615748, 35.05683850093202]],
    [ "121070404",[-80.95004081756701, 35.057202011875724]],
    [ "Shelby Tie Substation",[-81.54413181867575, 35.25780320913097]],
    [ "Cook Substation",[-112.17153681392467, 33.59679118585313]],
    [ "121192145",[-112.19950443916663, 33.596757081182886]],
    [ "Olive Substation",[-112.20778663693831, 33.566619773786826]],
    [ "Arroyo Substation",[-112.15323419414693, 33.59589738130252]],
    [ "121213941",[-80.98570799999999, 35.33453425]],
    [ "McAdenville Substation",[-81.08749015382205, 35.26854161035861]],
    [ "121218588",[-81.17799105, 35.24191354999999]],
    [ "121218589",[-81.11123542988196, 35.25133477012692]],
    [ "121218591",[-81.14070213671384, 35.24736460372678]],
    [ "121219460",[-81.1690847113536, 35.29752803124899]],
    [ "121219461",[-81.13992321010205, 35.30239057508505]],
    [ "121231025",[-81.15523625, 35.2676929]],
    [ "121231026",[-81.16599391668393, 35.267175866221734]],
    [ "121235281",[-81.06677049999999, 35.11296095]],
    [ "121235282",[-81.1341526, 35.06850985]],
    [ "121235284",[-81.14721215, 35.102893300000005]],
    [ "Hilltop Substation",[-81.3195237957645, 35.26764955396029]],
    [ "121254167",[-81.46065082303164, 35.246207242177555]],
    [ "121254694",[-81.40530395, 35.25541695]],
    [ "121254696",[-81.41537915405542, 35.251766964544906]],
    [ "121258040",[-81.255559, 35.2702898]],
    [ "Rankin Lake Substation",[-81.20468120000002, 35.2960242]],
    [ "121263065",[-81.1895674455048, 35.27656227153637]],
    [ "121265999",[-81.23349479931018, 35.28143236655847]],
    [ "121266000",[-81.21855015191456, 35.26027215314509]],
    [ "Riverview Switching Station",[-81.57428131087053, 35.07629644640315]],
    [ "Blacksburg Substation",[-81.51329334067411, 35.1349579636781]],
    [ "121336781",[-81.51628705, 35.153631]],
    [ "121336786",[-81.53391122940262, 35.21054425419329]],
    [ "121336787",[-81.52724026196239, 35.20707048150079]],
    [ "Cherryville Tie Substation",[-81.39074188302108, 35.37207656680393]],
    [ "Canal Substation",[-112.12911776479424, 33.57150399746615]],
    [ "Prospect Street Substation",[-71.73819724259602, 42.5387407267069]],
    [ "Oak Ridge Substation",[-95.4389325543999, 30.1699248314535]],
    [ "Shiloh Switching Station",[-82.51531601345994, 34.98347305371246]],
    [ "121517568",[-82.45467600007008, 34.925641731717235]],
    [ "Tiger Tie Substation",[-82.15549619310237, 34.95275856162167]],
    [ "121524976",[-82.42604513913722, 34.89276198323181]],
    [ "121542902",[-82.25736696776332, 34.72417392168902]],
    [ "121542905",[-82.2265479920766, 34.69460116022536]],
    [ "McIntosh Substation",[-81.17511914803066, 32.352128456247016]],
    [ "Blandford Substation 230",[-81.28109859842091, 32.27906345634493]],
    [ "Meldrim Substation",[-81.36832036581008, 32.1552707544347]],
    [ "Blandford Substation",[-81.2822753047162, 32.27437932582473]],
    [ "West McIntosh Substation",[-81.18227679657109, 32.3544090628889]],
    [ "Dean Forest Substation",[-81.18868505408317, 32.08349923894237]],
    [ "Grove Point Road Substation",[-81.24484363146965, 32.00189272355358]],
    [ "Little Ogeechee Substation",[-81.25315129999998, 32.0067859]],
    [ "White Bluff Substation",[-81.14426815985912, 31.951639822171508]],
    [ "Dutchtown Substation",[-81.22318385000001, 31.981298299999995]],
    [ "Grove Point Road Substation",[-81.10694084636773, 31.949653102330515]],
    [ "Georgia Power",[-81.15273840361277, 32.14769295467673]],
    [ "Fowler Substation",[-97.31197535116105, 37.68480952448855]],
    [ "Vogtle Substation (500KV/230KV)",[-81.76319715905768, 33.145686733476715]],
    [ "Bloomfield Substation",[-83.27543663089843, 42.61855962605014]],
    [ "121855218",[-80.700714, 32.20550155]],
    [ "Magnolia Substation",[-81.0862104182046, 32.02266022692088]],
    [ "Brock Substation",[-83.2868851592679, 42.293790371069484]],
    [ "Georgia Power",[-81.06296441156357, 32.03804157464474]],
    [ "Skidaway Substation",[-81.03090535000001, 31.95855035]],
    [ "Grange Road Substation",[-81.151139, 32.13983765]],
    [ "Simpson Lumber Substation",[-81.12710195, 32.1018724]],
    [ "Georgia Ports Authority Substation",[-81.15027197803003, 32.13905330192975]],
    [ "121986373",[-81.12974648994765, 32.10374656587027]],
    [ "Kraft Substation",[-81.14603086558883, 32.14812975278943]],
    [ "Hutchinson Island Substation",[-81.09072713377141, 32.09450340139544]],
    [ "52nd Street Substation",[-81.11065892910328, 32.046887562787454]],
    [ "Deptford Substation",[-81.04836975747014, 32.066857509368766]],
    [ "Daniel Siding Substation",[-81.37949504482458, 31.93044787987122]],
    [ "Distributing Station No. 82",[-118.55616074177486, 34.271286150768915]],
    [ "Washtenaw Substation",[-84.03280928296753, 42.312531886117824]],
    [ "APS Bell Substation",[-112.2195822981616, 33.636462906289495]],
    [ "Roche Harbor Substation",[-123.13093948344594, 48.598229577086244]],
    [ "Atlantic City Substation",[-108.76240740871371, 42.524990602044774]],
    [ "Wasser Substation",[-112.23832923219943, 33.601351877691236]],
    [ "Lehigh Substation",[-97.8659592085695, 30.029031400093952]],
    [ "122879061",[-85.13618549938036, 35.09058275553937]],
    [ "Jacksonville Beach Substation BES",[-81.40050972119083, 30.2826803896089]],
    [ "Desert Ridge Substation",[-111.98116173104454, 33.68096182324803]],
    [ "122924059",[-81.56779507485905, 35.2445912051261]],
    [ "122957183",[-81.55181769134046, 35.27734512206957]],
    [ "Georgetown Substation",[-97.6870814252709, 30.632522865590158]],
    [ "Gabriel Substation",[-97.66078022684395, 30.66728714405934]],
    [ "123002081",[-81.09088955765593, 34.01957240431779]],
    [ "Tyco Electronics",[-122.1677281258693, 37.48035310468278]],
    [ "Grove Street Substation",[-79.95557226749148, 32.802399038161724]],
    [ "West Towne",[-89.50951216127716, 43.05438478103014]],
    [ "Rockdale Substation",[-89.0426223584744, 42.97705297713574]],
    [ "JEFFERSON",[-88.8634195459151, 43.01299292850759]],
    [ "123222999",[-77.03748916859251, 39.36249473315196]],
    [ "123247823",[-89.62956521423003, 39.72802510862084]],
    [ "Baltimore Gas & Electric",[-76.4783460662557, 39.564027051298396]],
    [ "Peoria Substation",[-112.23298957613642, 33.5950897446949]],
    [ "Naperville Substation",[-88.20670846344008, 41.777283804793456]],
    [ "City Water, Light & Power",[-89.61380491386409, 39.79787663672369]],
    [ "Platte City Substation",[-94.72430899079565, 39.36466021041157]],
    [ "Cypress Substation",[-82.53168414015995, 27.951996938533842]],
    [ "N.W. Leavenworth Substation",[-94.98290040124874, 39.33724762690629]],
    [ "Stranger Creek Substation",[-95.0321309694974, 39.26217984556559]],
    [ "Anderson Substation",[-112.08465371927987, 33.37672401533406]],
    [ "Spruce Street Substation",[-94.9262008678862, 39.31006677277446]],
    [ "Spruce Street Substation",[-94.92642783685639, 39.309745002595854]],
    [ "Apple Valley Substation",[-93.18766045016915, 44.74587892047031]],
    [ "Johnson Street",[-84.90075117712564, 39.830428969664226]],
    [ "Kereford Junction",[-95.11822681661043, 39.52600489094555]],
    [ "Arnold substation",[-95.17443653573994, 39.53843058932707]],
    [ "Johnnycake Substation",[-93.184272514009, 44.73115648484725]],
    [ "Jarbalo Junction Switching Station",[-95.05826534080548, 39.182474151339264]],
    [ "Warrensburg Station",[-73.77580201063927, 43.48796827146855]],
    [ "Litchfield Substation",[-112.36027429806308, 33.485191973372324]],
    [ "124196516",[-112.28490235376924, 33.43630931604892]],
    [ "Ballston Station 12",[-73.85882984211867, 42.99887583278265]],
    [ "Carlisle Pike Substation",[-77.5026612606505, 40.064520024856115]],
    [ "124693313",[-117.25157590000002, 34.14995265]],
    [ "Duncan Substation",[-94.22784129337997, 39.0342836261092]],
    [ "ComEd Dearborn St Substation",[-87.6291659940954, 41.883770285531156]],
    [ "Fort Hill Substation",[-88.19546932506286, 41.74805244258558]],
    [ "Dillsburg Substation",[-77.03482407070794, 40.099283888484614]],
    [ "Shade Gap Substation",[-77.88594142251088, 40.19380025660814]],
    [ "124955100",[-117.18683605953223, 34.10783926185094]],
    [ "Hays Energy Station",[-97.99010165584937, 29.783048276935926]],
    [ "Church Street Substation",[-74.17520186055532, 42.937500049507875]],
    [ "Juniata Substation",[-77.17092904164194, 40.429128482318184]],
    [ "Country Club Substation",[-112.06637509052496, 33.47534345039485]],
    [ "125136404",[-109.72489525968342, 32.71997820598441]],
    [ "Somerset Substation",[-98.64943545532861, 29.24210705133797]],
    [ "Saunders Substation",[-96.80515467225013, 46.80282903581443]],
    [ "Sheyenne Substation",[-96.86026473185836, 46.83176967485909]],
    [ "Heartland Substation",[-97.22227099999999, 46.8755399]],
    [ "Smeltertown Substation",[-106.0213557174076, 38.552315567131956]],
    [ "Poncha Junction Substation",[-106.08483828158246, 38.52055941347866]],
    [ "125553597",[-109.60741066404411, 38.60842313194366]],
    [ "125626533",[-97.26260947505953, 46.90029414059379]],
    [ "125639358",[-119.19302799960597, 46.19638746577658]],
    [ "Orchard View Substation",[-119.22150901893465, 46.204363535712154]],
    [ "SRP Intel Substation",[-111.93456280688758, 33.3076636871387]],
    [ "Timberline Substation",[-105.04120393479653, 40.564550172046005]],
    [ "Oakland D Substation",[-122.26354237160945, 37.837450823268526]],
    [ "Moore Substation",[-99.04847991167765, 29.079430255070093]],
    [ "Pearsall Switchyard",[-99.09261716591242, 28.927386370694606]],
    [ "Upthegrove Substation",[-80.10667754999999, 26.763887099999994]],
    [ "Beeline Substation",[-80.11467621528523, 26.787928983203912]],
    [ "Casselton Substation",[-97.21042268149166, 46.89936603489183]],
    [ "125858480",[-84.9407070257049, 39.83154650133385]],
    [ "Robinson Northwest Substation",[-97.1411724273746, 31.473240554561404]],
    [ "Groesbeck Substation",[-96.67740571791742, 31.43759038825611]],
    [ "Business Park Substation",[-96.42250475995543, 30.709176084540186]],
    [ "Farrar Substation",[-96.28191522055295, 31.384087041069563]],
    [ "Rattlesnake Road Substation",[-96.96046746428799, 31.473527151383138]],
    [ "Lincoln Street South Substation",[-112.07705884057988, 33.44167406056948]],
    [ "Lincoln Street West Substation",[-112.07830378080436, 33.441673114343686]],
    [ "Lincoln Street North Station",[-112.07705568867385, 33.442479255339556]],
    [ "Fargo Substation",[-96.94862252480426, 46.834765272996044]],
    [ "West Fargo Substation",[-96.94852556274988, 46.836603494220725]],
    [ "Brookdale Substation",[-96.7776622420701, 46.846847138905105]],
    [ "Mapleton 115kV Substation",[-97.0523129546621, 46.87460415036462]],
    [ "Horace Substation",[-96.90405397532214, 46.77463259288542]],
    [ "Stanley Substation",[-96.88305927479114, 46.7747585570874]],
    [ "Frontier 230 kV Substation",[-96.8731283262206, 46.77362894686206]],
    [ "Warren Substation",[-97.01050421807152, 46.77586042516434]],
    [ "Wahpeton 230kV Substation",[-96.60190918854154, 46.288741318634635]],
    [ "Buffalo Substation",[-97.51646627899444, 46.95907100226022]],
    [ "Prairie Lee Substation",[-94.30432071541115, 38.94410747028814]],
    [ "Lewis Substation",[-117.89895201951794, 33.80954083834487]],
    [ "Buffalo Substation",[-97.5549837, 46.91863935]],
    [ "Barlow Substation",[-99.11368146376964, 47.646273371203996]],
    [ "Station 100",[-77.61676923930646, 43.08902252627619]],
    [ "126310356",[-98.68084292162914, 47.02863008142497]],
    [ "Penman Substation BES",[-81.40695661427083, 30.29995694752098]],
    [ "Campbell Substation",[-95.52467150000001, 29.818241949999997]],
    [ "Addicks Substation",[-95.57308218104336, 29.822794051095553]],
    [ "Brittmoore Substation",[-95.57259277576904, 29.79438194800006]],
    [ "Satsuma Substation",[-95.5763761052783, 29.881388274785053]],
    [ "Willow Substation",[-95.56645857515684, 29.99676126504701]],
    [ "Linden Substation",[-105.07156797083596, 40.59472833422576]],
    [ "Moorhead Substation",[-96.74830975, 46.76823715]],
    [ "Southgate Substation",[-90.00772113813895, 35.100724074287704]],
    [ "Dixon Creek Substation",[-105.13501996488215, 40.552543459430034]],
    [ "126773359",[-96.13501217381373, 41.07494947624236]],
    [ "126817109",[-96.25243190688633, 41.12553992022683]],
    [ "Poudre Substation",[-105.06683428402884, 40.60414563524758]],
    [ "San Felipe Substation",[-95.4478756495314, 29.75060599613684]],
    [ "Eureka Substation",[-95.43343780144863, 29.794751326181416]],
    [ "Sauer Substation",[-95.55285829080384, 29.788730653026942]],
    [ "Greenway subsation",[-112.17762589571548, 33.62462606511889]],
    [ "Tonga Tap Substation",[-95.1253023122206, 39.129548775391896]],
    [ "Midland Junction Substation",[-95.2414742376636, 39.033182948683724]],
    [ "Wagener Substation",[-96.54721983991661, 40.84003015358356]],
    [ "127108901",[-90.05024118678486, 36.27194907999548]],
    [ "Gray Road Substation",[-85.69202934771494, 44.77859541136109]],
    [ "Klein Substation",[-95.57031493369581, 30.023827186619457]],
    [ "Minerva Substation",[-96.95458433313338, 30.745866063026483]],
    [ "Webberville Substation",[-97.48797523515499, 30.24882395273746]],
    [ "Austrop Substation",[-97.48729153517019, 30.2513014316889]],
    [ "Sim Gideon Station",[-97.26880031149017, 30.146048279143056]],
    [ "Trinity Substation",[-73.75764384376178, 42.6434041977403]],
    [ "Tomball Substation",[-95.60599501883887, 30.090156019498203]],
    [ "Rothwood Substation",[-95.48995394310465, 30.090760277639593]],
    [ "Kuykendahl Substation",[-95.5270287452611, 30.08915872274975]],
    [ "Cameron Substation",[-95.64997000173987, 29.918715292942768]],
    [ "Stover Substation",[-85.12370954528237, 44.93714787368237]],
    [ "Consumers Energy",[-85.12299842646303, 44.9372550788339]],
    [ "Stover Substation",[-85.122681253051, 44.93704110014769]],
    [ "Schuss Mountain Substation",[-85.12257394899713, 44.93663280483341]],
    [ "Memphis Light, Gas and Water",[-90.03095555760471, 35.151694827033005]],
    [ "Buena Vista Substation",[-106.13848630000003, 38.85359725000001]],
    [ "127489041",[-106.19207669999999, 38.9589275]],
    [ "Otero Pump Substation",[-106.29182200844329, 39.07927004650025]],
    [ "Mayflower Substation",[-106.16507470680261, 39.43978711467273]],
    [ "Summit Substation",[-106.09197355394163, 39.58234096764843]],
    [ "Westfield Substation",[-95.42212028447305, 30.020632518828815]],
    [ "Pinehurst Substation",[-95.67295807920608, 30.161362889355992]],
    [ "Louetta Substation",[-95.48049188153423, 30.045462589985178]],
    [ "Entergy Arkansas",[-92.30609740775812, 34.74409383492415]],
    [ "127586951",[-108.04415150133704, 35.796439866877016]],
    [ "Flewellen Substation",[-95.82088977827051, 29.695403368396136]],
    [ "Fort Bend Substation",[-95.80047377899918, 29.563211711264493]],
    [ "Brazos Valley Substation",[-95.81246074071382, 29.627046475046892]],
    [ "Orchard Substation",[-95.95376001463164, 29.539258819233417]],
    [ "Treaschwig Substation",[-95.35080874000484, 30.043928026008896]],
    [ "City Water, Light & Power",[-89.68709875212048, 39.7614787832522]],
    [ "Red Wing",[-92.51660557635255, 44.56844236405609]],
    [ "127670173",[-87.42942970134271, 41.63181180757171]],
    [ "Rosemount Substation",[-93.02600210120077, 44.74696519162136]],
    [ "Empire Substation",[-93.04594383206175, 44.64631857391772]],
    [ "Cottage Grove",[-92.94846251107239, 44.84735983967123]],
    [ "Sanibel Substation",[-82.1491561702074, 26.463691816295523]],
    [ "Monticello Substation",[-83.85606218592439, 30.548473363832855]],
    [ "Meadowbrook Substation",[-112.05803937254171, 33.50149686708357]],
    [ "Castle Rock Substation",[-104.82614186222698, 39.37374694181565]],
    [ "127735576",[-105.01618062992657, 39.86218759634685]],
    [ "Barton Lake Substation",[-85.04969552539035, 41.74640905681994]],
    [ "Cass County Substation",[-96.849875852574, 46.87530202659488]],
    [ "Moderow Substation",[-96.85175135703841, 46.84840138118358]],
    [ "Weber Substation",[-99.76468907367817, 46.853376763257565]],
    [ "127930858",[-96.35342994219087, 41.040517376944194]],
    [ "City of Tallahassee",[-84.26038187309969, 30.433775671870848]],
    [ "Ellendale Substation",[-98.56753362509289, 46.009228739018866]],
    [ "Oakes Substation",[-98.09009518997385, 46.044254942389664]],
    [ "Forman Substation",[-97.63472638843703, 46.095655075041364]],
    [ "Forman Substation",[-97.6324103639418, 46.09604658115086]],
    [ "Forman Substation",[-97.63455774312442, 46.09651997504937]],
    [ "Groton Substation",[-98.300775775193, 45.51738943558398]],
    [ "Omaha Public Power District",[-96.05834687071446, 41.19118351491433]],
    [ "128011818",[-92.0748849, 44.59051540000001]],
    [ "Enderlin Substation",[-97.6829358, 46.638726150000004]],
    [ "128073540",[-97.97691243382981, 46.906605753878566]],
    [ "Valley City Substation",[-97.97698341382088, 46.907620357852075]],
    [ "Hankinson 230kV Substation",[-96.8881530493234, 46.11721294666699]],
    [ "Omaha Public Power District",[-95.95236100938033, 41.20739415945402]],
    [ "128092950",[-97.65711675305664, 46.611954092327224]],
    [ "128105946",[-97.905996024806, 45.95351949259086]],
    [ "Florida Power & Light",[-80.16884690913885, 27.109709610210047]],
    [ "Florida Power & Light",[-80.28749382152562, 27.279130391248387]],
    [ "Florida Power & Light",[-80.22115408008699, 27.152559802761985]],
    [ "Stuart Substation",[-80.25352263893862, 27.183757875119156]],
    [ "Bridge Substation",[-80.26475757457914, 27.04787269380005]],
    [ "Savannah Substation",[-80.30698989541855, 27.301116086105992]],
    [ "Crane Substation",[-80.30788187164517, 27.16767838096863]],
    [ "Hobe Substation",[-80.16557334137177, 27.047414438829527]],
    [ "Sandpiper Substation",[-80.27612054866685, 27.249815517471706]],
    [ "128196834",[-101.09831932323972, 47.37268151948589]],
    [ "Harvey Substation",[-100.00709497305782, 47.79421619432776]],
    [ "128215953",[-101.6324543, 47.35644669999999]],
    [ "128231352",[-101.38162869164692, 46.61630070127428]],
    [ "Tesoro Substation",[-80.34299623545385, 27.23692892943343]],
    [ "Rio Substation",[-80.24341025, 27.22168165]],
    [ "Allapattah Substation",[-80.4805530453189, 27.285449504530114]],
    [ "White City Substation",[-80.33278289439978, 27.381810375031577]],
    [ "Florida Power & Light",[-80.08901908537513, 26.971200987822012]],
    [ "Turnpike Substation",[-80.35632519005323, 27.27305364085728]],
    [ "128289816",[-112.02198668912095, 33.50639121439128]],
    [ "Hardy Substation",[-95.35339099670753, 29.81872672307702]],
    [ "North Side Substation",[-95.34966552675934, 29.784128493434647]],
    [ "Cabin Creek Substation",[-105.70810522169289, 39.653612534673194]],
    [ "128367130",[-111.9905756291803, 33.48725391003596]],
    [ "Military Road Station 210",[-78.97152886265508, 43.09277269233365]],
    [ "128367241",[-78.92600834340935, 43.08828414084522]],
    [ "Calapooya Substation",[-123.00971965468966, 44.388203629354344]],
    [ "Caterpillar Substation",[-97.99719353307435, 29.57927246820167]],
    [ "Seguin West Substation",[-97.98758282571927, 29.58622908198417]],
    [ "Breckenridge Substation",[-106.03348965036888, 39.48509952072435]],
    [ "Kelly Plant Substation GRU",[-82.3205248979133, 29.644171888126575]],
    [ "Harmony Substation",[-105.04451974963574, 40.52446742335323]],
    [ "MidAmerican Energy",[-95.86519071224876, 41.27782770275343]],
    [ "Airline Substation",[-95.38937619999999, 29.818677299999997]],
    [ "Todd Substation",[-95.48302296218208, 29.81600577393224]],
    [ "White Oak Substation",[-95.43482721617049, 29.815178197330177]],
    [ "Hockley Substation",[-95.84609188968507, 30.02128392536553]],
    [ "Keystone Substation",[-85.61633593439373, 44.695638292243245]],
    [ "129017896",[-96.60654792608052, 40.83477885253889]],
    [ "129017904",[-96.60478560891606, 40.87345106043758]],
    [ "Lincoln Electric System",[-96.60766945575796, 40.909194765562354]],
    [ "129038214",[-83.78833017565846, 40.07079679352217]],
    [ "Hillcroft Substation",[-95.49769092591235, 29.722092281027557]],
    [ "Jeanetta Substation",[-95.53669263308352, 29.71871901470685]],
    [ "Westwood Substation",[-95.53668045, 29.689947249999996]],
    [ "Missouri City Substation",[-95.52998954008395, 29.612644948442643]],
    [ "Roark Substation",[-95.56132253667539, 29.66604173893311]],
    [ "Knight Substation",[-95.41309058937333, 29.672251360162207]],
    [ "Stafford Substation",[-95.58918950458559, 29.633726724846596]],
    [ "Alief Substation",[-95.58180836946262, 29.700432042051137]],
    [ "Hayes Substation",[-95.57437449999999, 29.746347999999994]],
    [ "Deihl Substation",[-95.47605629121587, 29.85469726483882]],
    [ "Fairbanks Substation",[-95.5019191807206, 29.89997161359337]],
    [ "129223485",[-88.9748008, 40.14818415]],
    [ "Lake Silver Substation",[-81.73071063522744, 28.03433066778284]],
    [ "City of Lakeland",[-81.97508999611584, 28.153498374233113]],
    [ "Humble Substation",[-95.23506430836832, 30.000072513093563]],
    [ "Crosby Substation",[-95.0202289912816, 29.87269098317029]],
    [ "Haney Substation",[-94.99073998705214, 29.82106805375894]],
    [ "Brays Substation",[-95.44783569403005, 29.68375358210407]],
    [ "City Water, Light & Power",[-89.70570689468057, 39.771505821465695]],
    [ "Oakes Substation",[-80.07339663561494, 26.911317968456995]],
    [ "Lincoln Electric System",[-96.6236656024197, 40.90695182335092]],
    [ "129559299",[-122.1699291230436, 37.44117020396628]],
    [ "129584743",[-96.69711683264046, 40.82671255192875]],
    [ "129631847",[-96.54108079457697, 40.906764101381775]],
    [ "Moore Substation",[-96.78859970188206, 40.563507274542644]],
    [ "West Methuen Substation",[-71.20155253537112, 42.728331913465176]],
    [ "Conovaloff Substation",[-112.246293301586, 33.46433953737572]],
    [ "129860660",[-115.13017730798022, 36.11613215132433]],
    [ "Lincoln Electric System",[-96.7291009320771, 40.74925294814187]],
    [ "Bancroft Substation",[-81.84808186150377, 38.50065469583074]],
    [ "Kincaid Station",[-89.49627007182119, 39.593465042516044]],
    [ "129960563",[-115.33865908927044, 36.15604290154895]],
    [ "129995135",[-96.71954450870524, 40.81199935938512]],
    [ "Gulf Island Substation",[-70.20856764999999, 44.15126229999999]],
    [ "130003631",[-112.11000716600756, 33.4819766038099]],
    [ "Westwood Substation",[-112.108834280414, 33.51098434928103]],
    [ "Northwest 68th & West Holdrege",[-96.81276744444577, 40.83029648118473]],
    [ "130068470",[-96.9097541319443, 40.83552719415121]],
    [ "Lincoln Electric System",[-96.75829544084134, 40.80360994413281]],
    [ "130068476",[-97.1007578684974, 40.880016896722836]],
    [ "130216396",[-112.21246985819056, 33.48890104410033]],
    [ "130299386",[-96.73166418429584, 40.73274253883131]],
    [ "130299394",[-96.69293013431134, 40.767997673146695]],
    [ "130301572",[-96.71855721652507, 40.78406551505301]],
    [ "Venida Substation",[-119.13441252413594, 36.32555017598891]],
    [ "Rovey Substation",[-112.26075057847015, 33.530681611822004]],
    [ "130398553",[-96.62577856276765, 40.774421687285624]],
    [ "130398568",[-96.59581570571305, 40.814402282896275]],
    [ "Lincoln Electric System",[-96.59709018065807, 40.798317244174456]],
    [ "Lincoln Electric System",[-96.61038062699005, 40.75450498601504]],
    [ "Lincoln Electric System",[-96.59941973994924, 40.72953789051432]],
    [ "Lincoln Electric System",[-96.6453455015888, 40.736175161476645]],
    [ "Hillcrest Substation",[-80.06878984493372, 26.672786529976722]],
    [ "Lake Worth Main Substation",[-80.06667758169512, 26.613158637139218]],
    [ "AEP South Side Station",[-86.25084652030736, 41.64897907772762]],
    [ "Big Tree",[-78.7833530901836, 42.76286813799335]],
    [ "Meridian Way 1 Substation",[-97.54424564271436, 39.427651202122206]],
    [ "130585551",[-115.19186442623051, 36.16700118389894]],
    [ "130591882",[-115.14216477275566, 36.13034399006201]],
    [ "Colter Substation",[-112.32318747036389, 33.4961612726578]],
    [ "Yah-Ta-Hey Substation",[-108.8153911552578, 35.59330540935682]],
    [ "McKinley Substation",[-108.81747634197323, 35.59286208265951]],
    [ "Salt River Project",[-112.29498245366446, 33.49273551985443]],
    [ "Pecos Substation",[-115.09628014596213, 36.27467634889604]],
    [ "Dranefield Substation",[-82.0071478493596, 27.97772662611874]],
    [ "131041953",[-115.31746947505135, 36.19122511370924]],
    [ "Grove Substation",[-81.922322408653, 27.952367861009638]],
    [ "131068913",[-115.21569113335057, 36.18496090981468]],
    [ "131068922",[-115.23820648792058, 36.17446451588262]],
    [ "Como Substation",[-105.88606690826468, 39.31219740793449]],
    [ "Williams Hydro Substation",[-69.87106148374797, 44.95903888072429]],
    [ "Station 128",[-77.88781886310375, 42.7612464460112]],
    [ "McCool Substation",[-97.61958306361042, 40.72187491900103]],
    [ "Los Angeles Department of Water and Power",[-118.23785494474157, 34.03887479476501]],
    [ "Durango Substation",[-112.11771957816146, 33.43283371707369]],
    [ "Sherman Street Substation",[-112.09523115185968, 33.44090031301694]],
    [ "Laconte Substation",[-83.45107519999999, 31.204278150000004]],
    [ "Flint Substation",[-75.34240695153613, 40.093412309174504]],
    [ "Delaware Substation",[-93.59160051543003, 41.67260621910156]],
    [ "131661138",[-81.86336493031287, 27.872391904789783]],
    [ "131661139",[-81.85841871630542, 27.904570667025688]],
    [ "131661140",[-81.84208885, 27.898223850000004]],
    [ "MidAmerican Energy",[-93.86776291558765, 41.60626921556719]],
    [ "City Water, Light & Power",[-89.70825926465912, 39.7555765054391]],
    [ "Georgetown Substation",[-105.69523361525988, 39.70550557098686]],
    [ "Dillon Substation",[-105.99168700658163, 39.60897837080228]],
    [ "Duke Energy",[-81.63225560000001, 28.18723165]],
    [ "Jacinto Substation",[-95.06385704415781, 30.37043204878085]],
    [ "131833647",[-112.15311924896452, 33.42019463854996]],
    [ "West Phoenix Substation",[-112.16125162344997, 33.442302086159806]],
    [ "Five Points Substation",[-98.50672354183033, 29.437260800328527]],
    [ "Laredo Street Substation",[-98.50164082342305, 29.415354980853163]],
    [ "131945974",[-112.19773395888603, 33.44483956914849]],
    [ "Fern Street Substation",[-98.47948014249808, 29.404779383755596]],
    [ "Lake Wales Substation",[-81.59778398181116, 27.905495991994336]],
    [ "Sycamore Creek Substation",[-121.82410594122996, 39.76869729750579]],
    [ "132309268",[-102.25499383052937, 39.71732741731056]],
    [ "Joes Switching Station",[-102.70779812473522, 39.65528544102287]],
    [ "Garden Home Substation",[-122.74839155000002, 45.46687945]],
    [ "Lakeport Substation",[-81.09624178272018, 26.983517971314782]],
    [ "Stetson Substation",[-67.99364565582543, 45.48359127394753]],
    [ "Belle Glade Substation",[-80.67534035000001, 26.697086500000005]],
    [ "Bunnell Substation FPL",[-81.19931682307747, 29.495829775464223]],
    [ "Town Center Substation FPL",[-81.19285684999998, 29.476186849999994]],
    [ "Bartram Substation JEA",[-81.537643980884, 30.107370153418756]],
    [ "Fort Caroline Substation JEA",[-81.48892988597375, 30.36051553259573]],
    [ "Mayport Substation JEA",[-81.41123868798255, 30.371251661033995]],
    [ "Jacksonville Electric Authority",[-81.5413411262638, 30.344763669701873]],
    [ "Sawgrass Substation BES",[-81.3834235093701, 30.18828157167713]],
    [ "Deltona Substation FPL",[-81.18262590658784, 28.91954292498468]],
    [ "MacDill Substation",[-82.49338681578786, 27.864913883647343]],
    [ "Broadview substation",[-83.7696604883352, 40.011784973736916]],
    [ "Brentwood Substation",[-87.25789467751784, 30.46580446324051]],
    [ "Bellview Substation",[-87.28962093987818, 30.467862989104496]],
    [ "Bayou Chico Substation",[-87.24676015035028, 30.41390493653825]],
    [ "Florida Power & Light",[-87.25812295098187, 30.440784778566762]],
    [ "Cordova Substation",[-87.20556242799996, 30.49790403088854]],
    [ "Blue River Substation",[-106.13743243222835, 39.79196688056934]],
    [ "Mountain Parks Electric",[-106.36552779188575, 40.006419824829706]],
    [ "Rollins Substation",[-68.36473401831996, 45.4040897558884]],
    [ "Oklahoma Gas & Electric",[-97.5661741002556, 35.4914943365579]],
    [ "Groton Muni Substation",[-71.53842580215077, 42.60895072231091]],
    [ "133440598",[-84.18994206613857, 40.264408204278524]],
    [ "Eldean Substation",[-84.23720894800435, 40.082985689346]],
    [ "133440633",[-84.19237160914223, 40.27987305269017]],
    [ "Goleta Substation",[-119.88429463654434, 34.46862461184556]],
    [ "Encino Park Substation",[-98.46965390784365, 29.615636926207607]],
    [ "Argo Substation",[-104.9988159993985, 39.77602791483097]],
    [ "Malta Substation",[-106.32554288418623, 39.18871720039071]],
    [ "Basalt Substation",[-107.05063082411155, 39.37127161701202]],
    [ "Terryall Substation",[-105.41897700783271, 39.0728909359694]],
    [ "Forest Substation JEA",[-81.5374023592253, 30.266332525442316]],
    [ "Philips Substation JEA",[-81.59075962350873, 30.234504055113376]],
    [ "Davis Substation JEA",[-81.45441339999999, 30.2627488]],
    [ "Warrior Run Substation",[-78.74504874129025, 39.59609795086]],
    [ "O'Brien Road",[-77.08112132422596, 43.049199956326845]],
    [ "Sistrunk Substation",[-80.14919501536477, 26.127041833500936]],
    [ "Bankert Road Station",[-77.1171432427021, 42.96731092728422]],
    [ "Byron Substation",[-92.66965695979685, 44.03458189805964]],
    [ "Gunbarrel Substation",[-105.20260714315128, 40.08336265149002]],
    [ "Rattlesnake Substation",[-113.96821461480114, 46.91107497265874]],
    [ "134152074",[-105.06050096542593, 40.16282476773493]],
    [ "134152075",[-105.10452363273755, 40.160780795243674]],
    [ "Longs Peak Substation",[-105.03460860478758, 40.23438483989796]],
    [ "Tysons Substation",[-77.23687605877703, 38.93200728230854]],
    [ "Rumford Substation",[-70.54460995907311, 44.5372642498917]],
    [ "134368168",[-84.21181686415493, 40.16566368169189]],
    [ "Northwestern Energy",[-113.99487002531065, 46.86874632350571]],
    [ "Timoteo Substation",[-117.24428906826502, 34.06211532348145]],
    [ "Hathaway Substation",[-118.14209219063069, 33.7909906254391]],
    [ "Cocoa Substation",[-80.72740206215074, 28.35284641570022]],
    [ "134791982",[-108.66053759037091, 36.81011671722148]],
    [ "Pratts Junction Substation",[-71.73762571809897, 42.47139308499132]],
    [ "Sandy Pond Substation",[-71.53040481127044, 42.56843842421506]],
    [ "Wachusett Substation",[-71.77590630077586, 42.3603069627853]],
    [ "Sterling Substation",[-71.73742287025688, 42.451927147083985]],
    [ "Sandy Pond Converter Substation",[-71.52429993732653, 42.57055593303518]],
    [ "Bullard Street Substation",[-71.82037684761627, 42.34699557224996]],
    [ "Lake Asbury Substation #15 CLAY",[-81.82568933794701, 30.03221219524608]],
    [ "Millbury Substation No. 2",[-71.74270217679697, 42.19169859439245]],
    [ "Millbury Substation No. 5",[-71.7458912536582, 42.190169505757346]],
    [ "Fitch Road Substation",[-71.70030040479668, 42.41997862105922]],
    [ "Millbury Substation No. 4",[-71.74422705136121, 42.19183173553153]],
    [ "Millbury Substation No. 3",[-71.73746958923344, 42.18796603571748]],
    [ "Northboro Road Substation",[-71.57148509022488, 42.31521965305443]],
    [ "West Framingham Substation",[-71.48144853682759, 42.29820550006206]],
    [ "Rolfe Avenue Substation",[-71.7355375951164, 42.27405254371561]],
    [ "Westboro Substation",[-71.62124726140758, 42.27293964533626]],
    [ "Wyman-Gordon Substation",[-71.72997043396505, 42.232954683305856]],
    [ "North Grafton Substation",[-71.70387458938156, 42.2402483101978]],
    [ "North Oxford Substation",[-71.88161734250362, 42.15297524377754]],
    [ "Littleton Substation",[-71.48180501051793, 42.56368392347734]],
    [ "Westford Substation",[-71.46080256536835, 42.567068851711944]],
    [ "River Street Substation",[-71.82853514176456, 42.57882582687307]],
    [ "Canton Street Substation",[-71.78985145073867, 42.56415700691397]],
    [ "Princeton Road Substation",[-71.8472179830142, 42.561854285264744]],
    [ "Flagg Pond Substation",[-71.8437197219136, 42.550589050005094]],
    [ "Summer Street Substation",[-71.78272766408242, 42.57178859065707]],
    [ "Bell Shoals Substation",[-82.26966088420474, 27.893252409179812]],
    [ "South Broadway Substation",[-71.1617058, 42.69520235]],
    [ "South Danvers Substation",[-70.95342013337503, 42.553731333079966]],
    [ "Ward Hill Substation",[-71.1136983997222, 42.74423944057004]],
    [ "Woodchuck Hill Substation",[-71.05770598244101, 42.673298178346435]],
    [ "Middleton Substation",[-71.0486764283256, 42.62947790173833]],
    [ "East Methuen Substation",[-71.16703441688408, 42.74453251156477]],
    [ "Meadow Road Substation",[-72.00989278836458, 42.23862523010174]],
    [ "Shutesbury Substation",[-72.46585609999998, 42.42604199999999]],
    [ "Ware Substation",[-72.21487234303045, 42.27452829579891]],
    [ "Pondville Substation",[-71.82101528515636, 42.196955983483214]],
    [ "Leicester Substation",[-71.906689278233, 42.22533606263791]],
    [ "Northfield Substation",[-72.46835107362675, 42.6110270910743]],
    [ "Ludlow Substation",[-72.44661858514016, 42.19498707638377]],
    [ "Santa Paula Substation",[-122.39110582471976, 37.60808360723472]],
    [ "Arrowhead Substation",[-112.22745917850612, 33.66768758371837]],
    [ "Courtenay Substation",[-80.70497165230745, 28.416780960280917]],
    [ "Joppatowne Substation",[-76.3562341736296, 39.41515349375048]],
    [ "Lost Nation Substation",[-71.49439061671345, 44.594107750917246]],
    [ "Whitefield Substation",[-71.6085327761214, 44.37910489660076]],
    [ "Nacogdoches Road Substation",[-98.42431246611157, 29.53155271395341]],
    [ "135378677",[-83.81960905541348, 39.448884181923766]],
    [ "Delhi Substation",[-84.52928311532874, 42.67924634003801]],
    [ "Deer Island Substation",[-70.96124492318113, 42.349888116973794]],
    [ "Hoosier Energy",[-87.4706149872492, 39.10406667504227]],
    [ "Berkshire Substation",[-73.09360783181504, 42.46867949515687]],
    [ "Stephentown Substation",[-73.37659935264062, 42.55726148512254]],
    [ "Gilboa Substation",[-74.4478295417501, 42.43991287530764]],
    [ "135673024",[-77.19353047614788, 38.74733825111184]],
    [ "Quinnipiac Substation",[-72.87751940959902, 41.3178991227792]],
    [ "Berlin Substation",[-72.60333440070701, 44.24986167241783]],
    [ "Greenfield Plaza Substation",[-93.62738450328634, 41.50131636765252]],
    [ "Laurel Circle Substation",[-71.67034933064828, 42.53092526285479]],
    [ "Griffin Substation",[-84.24044491718207, 33.24885690273918]],
    [ "Entergy Louisiana",[-90.02459524365936, 30.016470275742755]],
    [ "Sherwood Forest Substation",[-89.95847055580266, 30.02781769985918]],
    [ "135920011",[-106.78944183316565, 32.35644220655033]],
    [ "Groton Street Substation",[-71.57525712030606, 42.66897519078439]],
    [ "Dunstable Substation",[-71.52205977904309, 42.6716291489921]],
    [ "Ayer Substation",[-71.59322838410898, 42.56595743414528]],
    [ "Hobe Substation",[-80.16344401368958, 27.041919719433952]],
    [ "Riverton 115/34 KV Substation",[-94.06142288586305, 46.4606687819663]],
    [ "Riverton 230/115 KV Substation",[-94.06648457585761, 46.45208276251962]],
    [ "Greenland Plant Substation JEA",[-81.5185689268516, 30.15855355475026]],
    [ "Craven Substation JEA",[-81.60188862520775, 30.20494591026549]],
    [ "Hartley Substation JEA",[-81.61197262815335, 30.18552265093574]],
    [ "Churchmans Substation",[-75.6625054405896, 39.68928214464854]],
    [ "West Mesa Switching Station",[-106.72355276919231, 35.11403644672977]],
    [ "136334405",[-106.6971671401398, 35.15361775271399]],
    [ "All Saints Sub",[-106.67164306684926, 35.18000715289488]],
    [ "136334407",[-106.66075355287339, 35.105450822394225]],
    [ "Sandia Substation",[-106.53050316994998, 35.051445735723334]],
    [ "Substation 41",[-106.5342810754034, 35.051354409967885]],
    [ "Kirtland Substation",[-106.54522581096255, 35.031752706760315]],
    [ "Public Service Company of New Mexico",[-106.53368655000001, 35.094062650000005]],
    [ "Zenith Substation",[-95.77738077571694, 29.910055728829388]],
    [ "Rio Puerco Substation",[-106.85524409639912, 35.32741545334332]],
    [ "Valley View Substation",[-115.18947263951074, 36.11502310037473]],
    [ "BA Sub",[-106.4829456, 35.34862534999999]],
    [ "Wilpett Sub",[-106.70932310000002, 35.3269052]],
    [ "Pachmann Substation",[-106.6159733013106, 35.31064083283426]],
    [ "Libra Sub",[-106.62740712779491, 35.30380530893824]],
    [ "Volcan Sub",[-106.58356314686058, 35.3374199440607]],
    [ "Universe Sub",[-106.72817904045873, 35.21530827510641]],
    [ "Don Julio Sub",[-106.62691661135298, 35.26593832598351]],
    [ "136396609",[-106.62913273030813, 35.178837047532994]],
    [ "Irving Sub",[-106.66268771032392, 35.188395287722834]],
    [ "Intel Substation",[-106.65355198175399, 35.22552593538843]],
    [ "Sawyer Passway Substation",[-71.78906076379175, 42.57741598256514]],
    [ "Norton Substation",[-106.10875412361344, 35.76418658109306]],
    [ "Reeves Substation",[-106.60270112052773, 35.1714488630077]],
    [ "Juno Beach Substation",[-80.0566476, 26.860778699999997]],
    [ "136552952",[-97.38028889926741, 42.01780212342281]],
    [ "Needham Substation",[-71.23936046523144, 42.27150875876774]],
    [ "Baker Street Substation",[-71.16892268172491, 42.28003688327195]],
    [ "Framingham Substation",[-71.39839261621745, 42.268274061774015]],
    [ "Florida Power & Light",[-81.22300829546403, 29.562117253161702]],
    [ "SRP Tovrea Substation",[-111.95955814697562, 33.44854941470251]],
    [ "136636202",[-111.9630692654616, 33.440316509240596]],
    [ "Florida Power & Light",[-80.06177818688816, 26.837721648358624]],
    [ "Madison Electric Works",[-69.89886553608521, 44.78671036046639]],
    [ "Madison Substation",[-69.88671124985851, 44.79680745817402]],
    [ "Madison Substation",[-69.88772613332259, 44.78888935231848]],
    [ "136759056",[-111.97774562193092, 33.453336118283445]],
    [ "136759070",[-112.00717123146535, 33.47273908150505]],
    [ "UGI",[-75.91206739630046, 41.27707107366538]],
    [ "Dry Mill South Terminal Station",[-77.59838862574466, 39.11397152521384]],
    [ "Breezy Knoll Terminal Station",[-77.61614916730832, 39.13973188159978]],
    [ "Canton Substation",[-71.15495255670503, 42.15690303942219]],
    [ "Sharon Amtrak Substation",[-71.16414133361565, 42.14419003031345]],
    [ "Ryder Substation",[-80.16436374351592, 26.840669821614473]],
    [ "136815641",[-84.32139268247629, 39.42669025757804]],
    [ "Walpole Substation",[-71.25609343964949, 42.130312366335104]],
    [ "East Holbrook Substation",[-70.97954567513098, 42.16476883458596]],
    [ "Stoughton Substation",[-71.10094958799628, 42.14161303272403]],
    [ "Plumosus Substation",[-80.10961763417001, 26.913544061048277]],
    [ "Ross Substation",[-80.11103089680513, 26.882217462242227]],
    [ "Oklahoma Gas & Electric",[-97.53040489844183, 35.50113279348401]],
    [ "40th Place Substation",[-111.99412262704647, 33.4499052455517]],
    [ "West Walpole Substation",[-71.26833823123481, 42.1313697824101]],
    [ "Sherborn Substation",[-71.41096550836795, 42.25673291161262]],
    [ "Medway Substation No. 446",[-71.4483250230216, 42.13913352963643]],
    [ "Rocky Hill Substation",[-71.4883681334739, 42.15754828284924]],
    [ "Pecan Bayou Substation",[-99.52656813015965, 32.366456625123455]],
    [ "South Wrentham Substation",[-71.34899703285814, 42.03078187007021]],
    [ "Beaver Pond Substation",[-71.42412895, 42.0742803]],
    [ "South Wrentham Substation",[-71.34921370029507, 42.02996026354849]],
    [ "Union Street Substation",[-71.39821846556838, 42.059632472343395]],
    [ "137151347",[-78.86199653812196, 35.98114577164663]],
    [ "Southpoint Substation JEA",[-81.54279692475589, 30.23639469264118]],
    [ "137188600",[-97.40329603947859, 35.146718984986904]],
    [ "137188602",[-97.39824790969163, 35.13205776816709]],
    [ "137225623",[-97.5112400891643, 35.27440897977211]],
    [ "137225640",[-97.47830264431376, 35.2787701464049]],
    [ "137230689",[-87.24047260266903, 39.7711772500435]],
    [ "Hayden Substation",[-110.77957266150825, 33.00484222137798]],
    [ "Winona Substation",[-89.74966413802663, 33.44524637032934]],
    [ "Highland City Substation",[-81.88601877473204, 27.965960547492177]],
    [ "Glendale Substation",[-81.9260703, 28.00729465]],
    [ "137367482",[-97.45834707611617, 35.271336328723585]],
    [ "City of Lakeland",[-81.9724075380323, 27.95417117505031]],
    [ "137369931",[-97.70749413897113, 35.40303242911829]],
    [ "137371537",[-97.51142828936318, 35.301222351701895]],
    [ "137372447",[-97.5171022292831, 35.33485146342984]],
    [ "137372895",[-97.47748847810874, 35.334874810496245]],
    [ "137405659",[-97.49509615773553, 35.229545541122555]],
    [ "Eskota Switching Station",[-100.24256130603946, 32.49218580451483]],
    [ "Vernon Hill Substation",[-71.795244025157, 42.238521028179115]],
    [ "137555106",[-111.96912939548247, 33.478620562996674]],
    [ "TECO",[-82.42673738821836, 27.986017680268255]],
    [ "SRP Papago Buttes Substation",[-111.94111777728695, 33.483730444676326]],
    [ "137623969",[-75.54222585432622, 43.75881612297952]],
    [ "Lake Juliana Substation",[-81.79477283184005, 28.109788211629876]],
    [ "Andover Substation",[-97.13585731017004, 37.7089735251265]],
    [ "Luther Forest Station",[-73.747974838654, 42.96381732179713]],
    [ "Valencia Substation",[-112.13484869159336, 33.503867744189286]],
    [ "137771649",[-97.45493633205497, 35.24671715969783]],
    [ "Lowville Station",[-75.47633343707777, 43.785677816856285]],
    [ "137804331",[-92.51842447894742, 44.123141292203826]],
    [ "Dawson County Substation",[-104.76960614229301, 47.10624683920787]],
    [ "Custer Substation",[-107.50476831459639, 46.1239915547099]],
    [ "137835349",[-105.79370520930976, 46.40822579986375]],
    [ "Alhambra Substation",[-112.1361537477925, 33.52338884964188]],
    [ "Bridgewater Substation",[-71.01699114341838, 41.97210061201369]],
    [ "Easton Substation",[-71.1153501125936, 42.03022171905199]],
    [ "137844489",[-106.48646564406455, 46.25979135076047]],
    [ "137846557",[-75.80129700136753, 41.37549932321065]],
    [ "Belfield Substation",[-103.0700741828444, 46.84177222615626]],
    [ "Miles City Substation",[-105.7917820078626, 46.41257466138008]],
    [ "Maple Leaf Substation",[-92.58758779660543, 44.02971455057871]],
    [ "Niguel Substation",[-117.71482485000003, 33.5638693]],
    [ "Granite Falls Substation",[-95.55327219565817, 44.82772780995505]],
    [ "McLeod Substation",[-94.33809392477997, 44.814501348491405]],
    [ "Morris Substation",[-96.01643353113847, 45.584533052057125]],
    [ "Norwood Substation",[-71.18801140726202, 42.17773710653061]],
    [ "Chestnut Hill Substation",[-72.2206637155626, 42.595488677702264]],
    [ "North Chelmsford Substation",[-71.37743304150132, 42.636413740244805]],
    [ "Rugby Substation",[-99.99688262491702, 48.35299566011759]],
    [ "Belmont Substation",[-81.30867115392344, 39.34470240256847]],
    [ "Substation 9",[-83.15502803194602, 42.21762508386843]],
    [ "F.L. Blair Substation",[-96.4782213745441, 44.849910858726346]],
    [ "Browns Valley Substation",[-96.86369334999999, 45.645615]],
    [ "Big Stone Substation",[-96.50843447075184, 45.30197276999722]],
    [ "Highway 12 Substation",[-96.48759836688829, 45.28010506643213]],
    [ "Marietta 115kV Substation",[-96.38409833805476, 45.00728352497958]],
    [ "Broadacre Substation",[-80.78785983365641, 40.36369303417709]],
    [ "Pactola Substation",[-103.48353933494468, 44.07325218477336]],
    [ "Minnesota Valley Substation",[-95.5294919754955, 44.80340140228752]],
    [ "Panther Substation",[-94.91609885646534, 44.81138173742588]],
    [ "Northeast Substation",[-97.25892995685625, 37.71622893022438]],
    [ "138279030",[-97.93389219231115, 46.58682812471265]],
    [ "Mulberry Substation",[-73.68302345, 42.92391]],
    [ "Waterford Substation",[-81.66276691502574, 39.52538980239106]],
    [ "Glenham Substation",[-100.22573256141924, 45.53458739427491]],
    [ "Huron Substation",[-98.34138219902086, 44.47072164790445]],
    [ "Poston Substation",[-82.17934570982031, 39.38263835659684]],
    [ "West Lancaster Substation",[-82.6373876695709, 39.7002544223993]],
    [ "Lake Constance Substation",[-93.82263855130647, 45.219439674867395]],
    [ "Lake Pulaski Substation",[-93.80588204289066, 45.18639671814914]],
    [ "Florida Power & Light",[-87.22827725000002, 30.466724200000005]],
    [ "Goulding Substation",[-87.22083738188621, 30.4400540071497]],
    [ "Oakfield Substation",[-87.24535500666535, 30.497800157053362]],
    [ "138324969",[-97.90437424999999, 45.2204817]],
    [ "138330241",[-97.92154395, 44.62402185]],
    [ "138331823",[-97.9243207213497, 44.600597137190434]],
    [ "Beach Haven Substation",[-87.30983245831064, 30.384430685578867]],
    [ "Eastbay Substation",[-86.88480666475313, 30.40245071815812]],
    [ "Innerarity Substation",[-87.4148499589469, 30.324036725099973]],
    [ "Navare Substation",[-86.9905778100224, 30.401780647224605]],
    [ "138344989",[-97.48001014999998, 43.29321535]],
    [ "138344996",[-97.69221074999999, 43.965686500000004]],
    [ "138350710",[-97.96854614999998, 43.84921380000001]],
    [ "Shipyard Substation",[-85.72614310691569, 30.1810481951891]],
    [ "Long Beach Substation",[-85.81539571323374, 30.186959533999122]],
    [ "138361687",[-85.94077155000001, 30.255389349999998]],
    [ "Utica Junction Substation",[-97.5787348, 43.05519780000001]],
    [ "138383819",[-98.39289414999998, 45.53098405]],
    [ "138388027",[-73.74611423701384, 43.09424961743994]],
    [ "Limaburg Substation",[-84.69465054098376, 39.03737323907216]],
    [ "Laporte Substation",[-105.15127890013193, 40.663566469911316]],
    [ "Armour Substation",[-98.32668549297061, 43.25711873406482]],
    [ "Harrison Substation",[-98.56786930900465, 43.42706372503677]],
    [ "Armour Substation",[-98.35505707243601, 43.28275182817184]],
    [ "Geddes Substation",[-98.70778605000001, 43.2270799]],
    [ "Avery Substation",[-82.6358904481026, 41.33634224271959]],
    [ "ATSI",[-82.4949901, 41.3373872]],
    [ "Soft Maple Station 768",[-75.2473487269086, 43.91964814053424]],
    [ "138527134",[-75.34924185000001, 43.7652972]],
    [ "138545579",[-92.48438048639466, 43.848939757373145]],
    [ "Dover Substation",[-71.25342094300262, 42.20381112712709]],
    [ "138595329",[-97.51117665843208, 35.2162351842054]],
    [ "Clinton Substation",[-90.30773740000001, 32.33117645]],
    [ "Spring Ridge Road Substation",[-90.32430833611677, 32.31233552530045]],
    [ "Northside Drive Substation",[-90.27905981296676, 32.35853147512531]],
    [ "Northwest Jackson Substation",[-90.24750624999999, 32.3397254]],
    [ "South Jackson Substation",[-90.18781487355497, 32.280730525581234]],
    [ "Robinson Road Substation",[-90.25849715227525, 32.283097939535104]],
    [ "West Jackson Substation",[-90.24810286499061, 32.30239569282137]],
    [ "Rex Brown 230kV Substation",[-90.21653083336005, 32.36036384986129]],
    [ "Rex Brown 115kV Substation",[-90.21372138829263, 32.35827975219832]],
    [ "138618812",[-90.15661658515899, 32.38608572470789]],
    [ "East Jackson Substation",[-90.17724765695742, 32.29521481513884]],
    [ "Flowood Substation",[-90.14325860340188, 32.28275503812691]],
    [ "Entergy Mississippi",[-90.16419785936789, 32.2616083794774]],
    [ "Florence Substation",[-90.14250987147138, 32.194410247436146]],
    [ "Medical Center Substation",[-90.16813708736971, 32.33001302492157]],
    [ "Larson Street Substation",[-90.16807994999999, 32.3075417]],
    [ "Miami Substation",[-90.20845595749937, 32.341095138694925]],
    [ "Gallatin Substation",[-90.19181830281723, 32.29756063178074]],
    [ "Monument Street Substation",[-90.19254975952296, 32.30822064396667]],
    [ "Southwest Jackson Substation",[-90.24754311797082, 32.253105415271015]],
    [ "Forest Hill Substation",[-90.2858834822226, 32.25610748384759]],
    [ "Bogalusa Substation",[-89.90529744055526, 30.78124242076915]],
    [ "Bogalusa Substation",[-89.90630488682753, 30.78277153085593]],
    [ "Tylertown Substation",[-90.11479909867798, 31.119066108886102]],
    [ "Kingswood Substation",[-90.21112868104774, 32.26681486365475]],
    [ "Hamilton Substation",[-77.68044587063571, 39.14655102041447]],
    [ "138661507",[-83.85314758805582, 39.92304439671205]],
    [ "Airport Substation",[-90.09086592509584, 32.282716857769785]],
    [ "Brandon Substation",[-90.01449873651875, 32.28286513099118]],
    [ "Rankin Substation",[-89.96446082636835, 32.288445657999134]],
    [ "Whitfield Substation",[-90.0819045701238, 32.24862302023504]],
    [ "Dumont Substation",[-103.79902380441123, 44.23897785604551]],
    [ "138669756",[-92.38977507266081, 43.84163425354478]],
    [ "Bear Creek Wind Farm Substation",[-75.78140778196145, 41.23124506689973]],
    [ "Palmer Substation",[-72.30292814001061, 42.14513309276968]],
    [ "Thorndike Substation",[-72.3445907, 42.1989258]],
    [ "West Charlton Substation",[-72.02786911978689, 42.13712150590135]],
    [ "Little Rest Road Substation",[-72.19276378314771, 42.16393163356013]],
    [ "138839835",[-94.26206938262571, 45.794346734107016]],
    [ "Tech Drive Substation",[-80.38402701693286, 37.12250190166957]],
    [ "138889949",[-75.2948790349164, 41.96059135003721]],
    [ "Granite Substation",[-72.49891231082397, 44.1187661134297]],
    [ "Monroe Converter Station",[-71.99335834578379, 44.319242567215554]],
    [ "Chestnut Hill Substation",[-72.48294560516838, 42.79783663536715]],
    [ "Vernon VT Substation",[-72.51858564224256, 42.78300798373761]],
    [ "Cold River Substation",[-72.94570544946265, 43.565201169752655]],
    [ "West Rutland Substation",[-73.05773203290286, 43.63371752351973]],
    [ "Ascutney Substation",[-72.41938497891043, 43.40109698759455]],
    [ "North Battleboro Substation",[-72.55579894786777, 42.86544419982743]],
    [ "Newfane Substation",[-72.65234164246021, 42.96811023630305]],
    [ "139011622",[-96.88250415, 45.3408526]],
    [ "East River Electric Power Cooperative",[-97.01051315000002, 45.79001105]],
    [ "City of Tallahassee",[-84.27731134846985, 30.43273448619817]],
    [ "139186267",[-88.76927739453266, 34.241339818940254]],
    [ "South Oswego Station",[-76.5186548886059, 43.43959040367509]],
    [ "Wynantskill Substation",[-73.6288252995435, 42.68664668985149]],
    [ "Barbour Hill Substation",[-72.52857269149105, 41.85445975540567]],
    [ "Manchester Substation",[-72.55755666426913, 41.77021170756831]],
    [ "Cavendish Substation",[-72.59928999425051, 43.38453965805662]],
    [ "Harriman Substation",[-72.92872480367775, 42.75735073057825]],
    [ "Searsburg Substation",[-72.92514575, 42.87084489999999]],
    [ "Agawam Substation",[-72.63488197716896, 42.090680532544496]],
    [ "East Springfield Substation",[-72.55133665539194, 42.1430932811616]],
    [ "Piper Substation",[-72.64078144546966, 42.13864295206586]],
    [ "Chicopee Substation",[-72.59335143756377, 42.16702318011705]],
    [ "Silver Substation",[-72.64105045, 42.0610019]],
    [ "South Agawam Switching Station",[-72.6478555272277, 42.04939146729321]],
    [ "Green Mountain Power",[-73.17250147667704, 42.88162600068903]],
    [ "Bear Swamp Substation",[-72.94961143191071, 42.683863309568835]],
    [ "Boyntonville Substation",[-73.4462011, 42.8414174]],
    [ "Hoosick Substation",[-73.35741328535198, 42.91210058463005]],
    [ "North Troy Station",[-73.63718227173682, 42.78701156562748]],
    [ "139309209",[-97.51171720895798, 35.178938575534175]],
    [ "139317655",[-97.47558169384622, 35.21193868153643]],
    [ "Metro Substation",[-112.06767815167817, 33.48501235759574]],
    [ "139322774",[-77.42114778898677, 43.07042942179034]],
    [ "Tarpon Springs Substation",[-82.73966712333984, 28.148629254210572]],
    [ "Boca Teeca Substation",[-80.09125445000001, 26.4090888]],
    [ "Florida Power & Light",[-80.26473683654898, 25.959215980822893]],
    [ "Baxter Wilson Substation",[-90.92880724541001, 32.28138939612722]],
    [ "Willow Glen Substation (500kV)",[-91.11279056495424, 30.27851383673906]],
    [ "Willow Glen Substation (230kV)",[-91.11038652361097, 30.276842911542133]],
    [ "Ninemile Point Substation",[-90.14781727219298, 29.946953628496168]],
    [ "Coly Substation",[-90.8963110346887, 30.487607484138522]],
    [ "McKnight Substation",[-90.8794642, 30.749830050000003]],
    [ "Sterlington Substation",[-92.0696975370484, 32.70572928645855]],
    [ "Sterlington Substation",[-92.01698798943386, 32.69304869404549]],
    [ "Sterlington Substation",[-92.0780452641023, 32.70383011044194]],
    [ "Sterlington Substation",[-92.0745749445017, 32.70405992358767]],
    [ "Grosse Tete Substation",[-91.43414935516506, 30.426476741850216]],
    [ "Webre Substation",[-91.4757313009458, 30.4423934167292]],
    [ "Waterford 230kV Substation",[-90.4738091275943, 29.98575123389215]],
    [ "Entergy Louisiana",[-90.4720054923787, 29.993513175407237]],
    [ "Waterford 500kV Substation",[-90.47858158733777, 29.98582846986194]],
    [ "Little Gypsy Substation",[-90.46021741804894, 30.00596859541231]],
    [ "Union Carbide Substation",[-90.44967113067959, 29.972609148761304]],
    [ "Hooker Substation",[-90.45428958609463, 29.988835420686183]],
    [ "Wesco Substation",[-90.40299561226355, 29.997284315371893]],
    [ "139527881",[-90.44261236456369, 30.035606937888204]],
    [ "Claytonia Substation",[-90.40716516677779, 30.01925775125445]],
    [ "Norco Substation",[-90.39788174736655, 30.006753999327586]],
    [ "139530060",[-90.22381880555716, 30.018248319988253]],
    [ "Snakefarm Substation",[-90.2095957142771, 29.97862998142684]],
    [ "Hopewell Substation",[-72.55499535943028, 41.6810079022455]],
    [ "Card Substation",[-72.2345221529179, 41.70218045687939]],
    [ "Avondale Substation",[-90.17818804815363, 29.927500021709086]],
    [ "Harahan Substation",[-90.19304440320958, 29.940922867660067]],
    [ "Cleary Substation",[-90.17224407709753, 29.99190870901649]],
    [ "Rotterdam Substation",[-73.99758875262019, 42.828766876100254]],
    [ "Labarre Substation",[-90.1526871156243, 29.972950789035973]],
    [ "North Rutland Substation",[-72.9727052927359, 43.63428539454774]],
    [ "Kenner Substation",[-90.27697647321483, 29.97708315627453]],
    [ "Hoskins Substation",[-97.35456167132291, 42.07818840463433]],
    [ "Alps Substation",[-73.49703335, 42.59612625]],
    [ "Battenkill Substation",[-73.55013318317043, 43.1006077523633]],
    [ "Wilder Substation",[-72.30438163965275, 43.66919484113107]],
    [ "Hanover Substation",[-72.29069754603286, 43.69413353560386]],
    [ "Mount Support Substation",[-72.27420588134761, 43.68403827931541]],
    [ "Adams Substation",[-73.1059259149616, 42.65463489057519]],
    [ "Doreen Substation",[-73.20575483278549, 42.443127946253334]],
    [ "Elm Substation",[-72.74442836220375, 42.12747012438843]],
    [ "Buck Pond Substation",[-72.7345555738858, 42.175485181990275]],
    [ "Sebastian Substation",[-80.4776773, 27.81192135]],
    [ "West Springfield Substation",[-72.59513683176031, 42.094801093588224]],
    [ "Entergy Louisiana",[-91.36801670000001, 30.724477050000004]],
    [ "Fancy Point Substation",[-91.33107750800261, 30.745253916235452]],
    [ "Francis Substation",[-91.38284015904661, 30.788815633333392]],
    [ "139667957",[-91.18161388390534, 30.245650116733973]],
    [ "Plaquemine Substation",[-91.2544507707374, 30.26153108210787]],
    [ "Taminco US LLC",[-91.09383380548435, 30.25259160742251]],
    [ "Luling Substation",[-90.35043200387749, 29.914232043976806]],
    [ "American Cyanamid Substation",[-90.26778444446538, 29.954738335040815]],
    [ "Waggaman Subsation",[-90.2372854468121, 29.93208738716073]],
    [ "Barataria Substation",[-90.1144116607671, 29.83179320407827]],
    [ "139709277",[-97.40806401055967, 42.06495669221895]],
    [ "139709279",[-97.81543211028753, 42.08276170724914]],
    [ "139709280",[-97.60209258753459, 42.08326833403329]],
    [ "Kleen Substation",[-72.59689404713892, 41.55415832187029]],
    [ "Middletown Substation",[-72.57806007442582, 41.55448711601395]],
    [ "Killingly Substation",[-71.89120488141114, 41.88135173827821]],
    [ "139759347",[-97.89778896186932, 46.90633722513544]],
    [ "Arlington Substation",[-90.58673744158195, 31.422448075026367]],
    [ "Lakeover Substation",[-90.2145991963916, 32.38164273746121]],
    [ "West Point Substation",[-88.6532775644401, 33.63569343706653]],
    [ "Smithdale Substation",[-90.6905795, 31.3617249]],
    [ "Johnson Road Station",[-73.74331096809438, 42.764724276166966]],
    [ "Maplewood Substation",[-73.70845343064568, 42.74541913581903]],
    [ "Richard Substation",[-92.40719879515649, 30.430246537688955]],
    [ "139809010",[-73.45901597011033, 44.71260267365349]],
    [ "139809047",[-73.45675801351909, 44.7147387020645]],
    [ "Brook Road Station 369",[-73.8333852528914, 43.082463472069456]],
    [ "Fort Junction Substation",[-96.82870294283136, 39.01217122162388]],
    [ "Halfmoon Substation",[-73.68818582151475, 42.905752395929234]],
    [ "Sunchase Substation",[-97.16530632711485, 26.09031445398494]],
    [ "Anselm Substaiton",[-97.49104087609025, 46.52960382692183]],
    [ "Carpenter Hill Substation",[-71.9971334875564, 42.12861761297489]],
    [ "Reed Substation",[-96.88214322976852, 46.89748247857529]],
    [ "Maple River Substation",[-96.87408792692815, 46.91751490350292]],
    [ "Beseck Substation",[-72.7550151127197, 41.48922023791152]],
    [ "East Meriden Substation",[-72.75190040054625, 41.51011898797358]],
    [ "Southington Substation",[-72.86645639022129, 41.58843311376392]],
    [ "Frost Bridge Substation",[-73.06068333369355, 41.61250889989516]],
    [ "139893291",[-88.51693954999999, 30.390592050000006]],
    [ "Long Mountain Substation",[-73.44224157343912, 41.62041723891329]],
    [ "Athens Substation",[-73.85029147029206, 42.27105454458374]],
    [ "Leeds Substation",[-73.8472098789053, 42.264652126003064]],
    [ "Malta Station 443",[-73.79924010891992, 42.964341023358564]],
    [ "139959465",[-99.08485836860825, 40.67287322724002]],
    [ "Gum Springs Substation",[-77.08930414556826, 38.74870029939354]],
    [ "Mansfield Substation",[-72.2644750552762, 41.80892559083437]],
    [ "Skungamauk Substation",[-72.34805806788864, 41.80404655467716]],
    [ "Willimantic Substation",[-72.2289352004363, 41.712996314006816]],
    [ "Sherman Road Substation",[-71.67370194515804, 42.0101634208269]],
    [ "Bristol Substation",[-72.94036549540918, 41.671187827920726]],
    [ "Chippen Hill Substation",[-72.98687098556086, 41.68203617068118]],
    [ "Forestville Substation",[-72.89599343501155, 41.6633125254737]],
    [ "Thomaston Substation",[-73.06973372124129, 41.67540057703176]],
    [ "Rockville Substation",[-72.46369298534972, 41.86654672303486]],
    [ "South Windsor Substation",[-72.60044048011159, 41.84021903387645]],
    [ "Windsor Locks Substation",[-72.62623482386954, 41.91896208385722]],
    [ "West Farnum #17 Substation",[-71.53915501391371, 41.969474742047524]],
    [ "Ocean State Substation",[-71.6695289579927, 42.0095033421517]],
    [ "Kent County Substation",[-71.47942263527392, 41.68329337019]],
    [ "Drumrock Substation",[-71.47291962283707, 41.69670631795042]],
    [ "Hartford Avenue #35 Substation",[-71.51932218500112, 41.82773414304998]],
    [ "Greendale Substation",[-71.79429879299961, 42.31828669700651]],
    [ "Orchard Substation",[-72.50859176314154, 42.1604105365172]],
    [ "Shawinigan Switching Station",[-72.53713864184883, 42.158353432097954]],
    [ "Firehouse Road Station",[-73.75158744618926, 42.823170152212015]],
    [ "Blackburn Switching Station",[-71.44308832676646, 41.732866022090136]],
    [ "Kilvert Street #87 Substation",[-71.4497739015703, 41.72955352194725]],
    [ "Lincoln Avenue #72 Substation",[-71.43912181152616, 41.75031593929955]],
    [ "Sockanosset #24 Substation",[-71.44037060919375, 41.75423203739449]],
    [ "Franklin Square Substation",[-71.40564688636579, 41.816334492798696]],
    [ "Mink Street Substation",[-71.33032360000001, 41.7904301]],
    [ "Wampanoug Substation",[-71.3484874321395, 41.80220874074737]],
    [ "140102686",[-73.67487801572561, 42.814992342483336]],
    [ "New Scotland Substation",[-73.90427171491443, 42.60912729678683]],
    [ "Inwood Avenue Substation",[-73.91796105126161, 41.72803807308551]],
    [ "Davis Substation",[-80.39658203859987, 25.640138772311644]],
    [ "140133870",[-88.49317849835371, 30.355266527908515]],
    [ "Downie Substation",[-99.69954899338947, 29.22699152047618]],
    [ "Montville Substation",[-72.10427540004824, 41.42871235393273]],
    [ "Uncasville Substation",[-72.11609598136316, 41.42905328282058]],
    [ "Branford Railroad Substation",[-72.85377712439633, 41.284055471154595]],
    [ "East Shore Substation",[-72.90435324002941, 41.28798141180216]],
    [ "Bunker Hill Substation",[-73.08620530727981, 41.56367965350437]],
    [ "Canal Substation",[-72.90195141377478, 41.573541585515684]],
    [ "Shaws Hill Substation",[-73.06833022768468, 41.591377275045744]],
    [ "Todd Substation",[-72.97530063164272, 41.572479765612485]],
    [ "Carmel Hill Substation",[-73.24118390505281, 41.60109199142812]],
    [ "Campville Substation",[-73.08610852093562, 41.73773415705309]],
    [ "Franklin Drive Substation",[-73.11658369057984, 41.79960299634362]],
    [ "Torrington Terminal Substation",[-73.12102435197156, 41.77605828907862]],
    [ "Florida Power & Light",[-80.31279221564608, 25.83100114776926]],
    [ "Dade Substation",[-80.31115089701314, 25.831033859065148]],
    [ "Hurley Avenue Substation",[-74.04765904302585, 41.93673229887222]],
    [ "Ohioville Substation",[-74.0498106738413, 41.74028255703404]],
    [ "Roseton Substation",[-73.97876598708154, 41.57477801352833]],
    [ "140291167",[-73.96874943872764, 41.2053104477183]],
    [ "Rocky River Substation",[-73.43376367516898, 41.58253639901035]],
    [ "Plumtree Substation",[-73.40217133055953, 41.39172551178668]],
    [ "Newtown Substation",[-73.28983851535348, 41.39119954461822]],
    [ "Sandy Hook Substation",[-73.22006288303459, 41.383295264590906]],
    [ "Stevenson Substation",[-73.17080114569117, 41.38217464222789]],
    [ "Triangle Substation",[-73.43520287897861, 41.39361981981265]],
    [ "National Grid",[-73.90125740288134, 43.664198666814265]],
    [ "Riparius Station",[-73.90151726655132, 43.6638940004279]],
    [ "National Grid",[-73.89776532771165, 43.66451669407445]],
    [ "Falls Village Substation",[-73.36837354999999, 41.95591894999999]],
    [ "Salisbury Substation",[-73.46457758208932, 41.921793574323004]],
    [ "Wilton Substation",[-73.43216953254264, 41.20012529135214]],
    [ "Kosciusko Substation",[-89.55064419578832, 33.07120882222724]],
    [ "June Street Substation",[-72.98263895325752, 41.338125184081214]],
    [ "Mix Avenue Substation",[-72.92426683363637, 41.37229416428885]],
    [ "Pacific Power",[-118.37961092676025, 46.070147396307306]],
    [ "Dallam County Substation",[-102.53173312498785, 36.08034220581497]],
    [ "Dalhart Substation",[-102.52881062513691, 36.064853953957716]],
    [ "Greenbush Substation",[-73.71483825481737, 42.60579640130451]],
    [ "Inman Road Substation",[-73.86514519999999, 42.789352199999996]],
    [ "General Electric Research & Development Substation",[-73.87850218298622, 42.83463355621588]],
    [ "Montague/Cabot Substation",[-72.57787391288731, 42.58769359203054]],
    [ "Dooley Substation",[-72.67230862634678, 41.511421588485575]],
    [ "Haddam Substation",[-72.47724754458523, 41.46084816787124]],
    [ "Berlin Substation",[-72.7231105052068, 41.63182567492756]],
    [ "West Side Substation",[-72.66291568604889, 41.562969804222924]],
    [ "Brooklyn Substation",[-71.91462905, 41.81668]],
    [ "Frybrook Substation",[-71.92120323046497, 41.67096566937599]],
    [ "Lake Road Substation",[-71.89598276478193, 41.87476211008245]],
    [ "Tracy Substation",[-71.89047278075971, 41.88389829287839]],
    [ "Tunnel Substation",[-72.0428997285076, 41.554616285543]],
    [ "Mystic Substation",[-71.9596067127917, 41.3663647790087]],
    [ "Shunock Substation",[-71.84668417921303, 41.41274955100317]],
    [ "Bean Hill Substation",[-72.11857829999998, 41.55894455]],
    [ "Dudley Street Substation",[-72.10235386685387, 41.53601415584098]],
    [ "Fort Hill Farms Substation",[-72.1124814068551, 41.470856489593785]],
    [ "Gales Ferry Substation",[-72.07952106272079, 41.434057797107734]],
    [ "Stockhouse Road Substation",[-72.14410650406978, 41.57178854066537]],
    [ "Waterford Substation",[-72.18944344327645, 41.37644077830849]],
    [ "Williams Substation",[-72.10399958641439, 41.368020871622576]],
    [ "North Beach Substation",[-80.3769815412016, 27.690012807639896]],
    [ "Meyer Substation",[-77.70937989865227, 42.55675419653538]],
    [ "Meridian Way 2 Substation",[-97.73526439204664, 39.42455839284982]],
    [ "Blissville Substation",[-73.23310942896813, 43.57616840328611]],
    [ "Whitehall Substation",[-73.38021947098055, 43.550274485282024]],
    [ "140649634",[-73.86156642365805, 42.57513668456878]],
    [ "Quarry Substation",[-94.86112444260353, 38.83221557093586]],
    [ "Popes Head Substation",[-77.38663870965435, 38.811198582749824]],
    [ "Atwater Substation",[-72.75270234210622, 42.134182487422784]],
    [ "Midway Substation",[-72.61819915522354, 42.287331378361685]],
    [ "Baldwin Substation",[-73.03990655955565, 41.52421168585338]],
    [ "Beacon Falls Substation",[-73.0687959112426, 41.44380148498953]],
    [ "Devon Substation",[-73.10721843330532, 41.20890818275471]],
    [ "Freight Street Substation",[-73.05323202043716, 41.55488591466486]],
    [ "South Naugatuck Substation",[-73.05631480740462, 41.47472855012785]],
    [ "Trap Falls Substation",[-73.11815128321953, 41.26732563089738]],
    [ "Oxford Substation",[-73.13252611215066, 41.4672142047803]],
    [ "Hoyts Hill Transition Station",[-73.39002878144028, 41.366793955627]],
    [ "Archers Lane Transition Station",[-73.41344795, 41.299309449999996]],
    [ "East Devon Substation",[-73.09852327996965, 41.22775351317123]],
    [ "Branford Substation",[-72.79373336670255, 41.29272210224847]],
    [ "North Haven Substation",[-72.84301033715028, 41.41458187858352]],
    [ "Sackett Substation",[-72.88698875354126, 41.36360677318967]],
    [ "Mill River Substation",[-72.90863978972263, 41.30819592905075]],
    [ "Bokum Substation",[-72.389966732365, 41.31861947956768]],
    [ "Green Hill Substation",[-72.59605000334967, 41.31951555522988]],
    [ "Stepstone Substation",[-72.69761263874672, 41.320727079495065]],
    [ "Busch Substation",[-95.27273277743183, 29.77625029443006]],
    [ "Black Rock Substation",[-72.80557890890184, 41.66178287452499]],
    [ "Rocky Hill Substation",[-72.66891637650939, 41.652759008829136]],
    [ "East New Britain Substation",[-72.75370863231021, 41.67015417504225]],
    [ "East Hartford Substation",[-72.6163911719021, 41.769606039628336]],
    [ "Riverside Drive Substation",[-72.64282545108856, 41.747489832743696]],
    [ "Hawthorne Substation",[-73.2515909561852, 41.21376220198937]],
    [ "Weston Substation",[-73.37160705191205, 41.18938644748818]],
    [ "Trumbull Substation",[-73.16065686131766, 41.23244596377857]],
    [ "Pequonnock Transition Station",[-73.17058173997764, 41.18609855696153]],
    [ "Kenyon Substation",[-71.63232560421343, 41.43846997565997]],
    [ "West Kingston Substation",[-71.57424320032025, 41.47266479926706]],
    [ "Wood River #87 Substation",[-71.7041191, 41.42745675]],
    [ "Tower Hill Substation",[-71.47213904387165, 41.54864722793802]],
    [ "141003605",[-88.53846916166064, 30.378900332347214]],
    [ "141022378",[-111.82071071628, 34.8691950763761]],
    [ "Admiral Street Substation",[-71.42115909194396, 41.84241431425838]],
    [ "Clarkson Street Substation",[-71.42089442606814, 41.84327000674134]],
    [ "Johnston #18 Substation",[-71.47482470063173, 41.814399525952894]],
    [ "Butler Station",[-73.66122716320095, 43.258291823098084]],
    [ "Comstock Substation",[-73.41197678477717, 43.460735441687724]],
    [ "Mohican Station",[-73.60586363186299, 43.29012482466981]],
    [ "Fitzwilliam Substation",[-72.14828901187494, 42.8003698822762]],
    [ "Swanzey Substation",[-72.31771906345841, 42.87341649834827]],
    [ "Vermont Yankee Substation",[-72.51592575763543, 42.780120483245454]],
    [ "Westport Substation",[-72.38458634027225, 42.79303562620348]],
    [ "Emerald Street Substation",[-72.28613386086593, 42.92961218279061]],
    [ "Monadnock Substation",[-72.16728271750746, 42.8298855729742]],
    [ "Weare Substation",[-71.66014760629125, 43.03244111967422]],
    [ "Jackman Substation",[-71.92601720333175, 43.11196597939925]],
    [ "Indian Well Substation",[-73.09995108349968, 41.32553356706463]],
    [ "Neora Street Substation",[-73.02520697818387, 41.56613013923008]],
    [ "North Canaan Substation",[-73.31756210143408, 42.02102521669021]],
    [ "Portland Substation",[-72.57581718556098, 41.56359515323789]],
    [ "Pratt & Whitney Substation",[-72.56358432961846, 41.540364622206795]],
    [ "Smithfield Substation",[-73.5832576429962, 41.898578545710954]],
    [ "Flax Hill Substation",[-73.4421151599572, 41.093825656522505]],
    [ "Norwalk Harbor Transition Station",[-73.42886485714413, 41.080686451395344]],
    [ "Norwalk Substation",[-73.4287071925455, 41.12788704494353]],
    [ "Norwalk Junction Transition Station",[-73.41706982298645, 41.17672377019215]],
    [ "Cos Cob Substation",[-73.59783310181467, 41.0290282678926]],
    [ "Glenbrook Substation",[-73.52045800777282, 41.06186815081624]],
    [ "South End Substation",[-73.53759654148651, 41.04789099344432]],
    [ "Tomac Substation",[-73.56337626839318, 41.034001348833506]],
    [ "Waterside Substation",[-73.55536399117402, 41.037569213621936]],
    [ "141160510",[-73.4177688076581, 44.9808291714296]],
    [ "141161322",[-73.37317385603681, 44.99060877693792]],
    [ "Cedar Station",[-73.60302386490355, 43.321380024722885]],
    [ "Queensbury Substation",[-73.6644366355358, 43.3348188613966]],
    [ "Darien Substation",[-73.48052895024941, 41.07554384969001]],
    [ "Compo Substation",[-73.3608238740461, 41.12112515362467]],
    [ "Buddington Substation",[-72.04533684521384, 41.373972278226304]],
    [ "Florida Power & Light",[-80.25736536778778, 25.79947465074712]],
    [ "Bates Rock Substation",[-73.23650085, 41.50324455]],
    [ "Shepaug Substation",[-73.29457239646439, 41.44875478159639]],
    [ "Stony Hill Substation",[-73.38675152583444, 41.43424919134199]],
    [ "Columbus West Substation",[-97.40995612430441, 41.45627846820135]],
    [ "Pequonnock Substation",[-73.18491414155129, 41.17244937174708]],
    [ "Baird Substation",[-73.14392926002684, 41.18536892478405]],
    [ "Columbus East Substation",[-97.28045385393453, 41.425363098975744]],
    [ "Southwick Substation",[-72.79436329417652, 42.015110567658496]],
    [ "Franconia Substation",[-72.53567003532034, 42.05498790734614]],
    [ "NYSEG",[-73.74548874999999, 42.92237210000001]],
    [ "Elnora Station",[-73.8379642406037, 42.891524124717506]],
    [ "Vicker Substation",[-80.44414040097271, 37.16518745338725]],
    [ "Merrimac Substation",[-80.41890118381754, 37.19255141957577]],
    [ "Enfield Substation",[-72.61484903596097, 41.93632341095342]],
    [ "Barnum Substation",[-73.12631509835508, 41.19828075591019]],
    [ "Congress Street Substation",[-73.18695315859976, 41.182421075189275]],
    [ "Devon Tie Switching Station",[-73.1055683087787, 41.20688876197527]],
    [ "Milvon Substation",[-73.08091868031768, 41.212326214932055]],
    [ "Augusta East Side Substation",[-69.7462186846872, 44.329423501925476]],
    [ "Bowman Street Substation",[-69.8034483772704, 44.25440600891556]],
    [ "North Augusta Substation",[-69.79753042335673, 44.363610279535564]],
    [ "Puddledock Road Substation",[-69.85413491039691, 44.33139933081388]],
    [ "Browns Crossing Substation",[-69.7750297757325, 44.252863608516606]],
    [ "Orrington Substation",[-68.75386286001188, 44.74025917167531]],
    [ "Substation No. 26 Merriott South Termination Site",[-81.45316298605321, 28.391720125091425]],
    [ "141423927",[-81.45327809204063, 28.40119877518158]],
    [ "Old Baptist Road Substation",[-71.4773661, 41.60970625]],
    [ "Davisville #84 Substation",[-71.43522885, 41.5925555]],
    [ "141579737",[-75.89503028936635, 41.13352507547407]],
    [ "South Street Station 297",[-73.79313149999999, 43.073442299999996]],
    [ "Smith Bridge Station 464",[-73.77132292671199, 43.11457698430155]],
    [ "Wolf Road Substation",[-73.80266645769522, 42.7194567579504]],
    [ "141692014",[-98.0176411027628, 41.85001827402895]],
    [ "141692016",[-98.01712927763822, 41.85130219826827]],
    [ "Oklahoma Gas Electric",[-97.52830751799799, 35.471272764722364]],
    [ "Grooms Road Substation",[-73.8286816876173, 42.83509067619459]],
    [ "Lewisville Substation",[-97.00970990964774, 33.06602471580217]],
    [ "Kramer Substation",[-117.54239578355946, 34.98950043215192]],
    [ "Ogdenbrook Station",[-73.6814357637104, 43.30808703410433]],
    [ "Bancroft Substation",[-105.08035595126125, 39.70045710624288]],
    [ "Neligh Substation",[-98.03249681237385, 42.11799417471278]],
    [ "O'Neill Substation",[-98.65041966327837, 42.46567535944976]],
    [ "Putnam Pike Substation",[-71.52219907810753, 41.866838216089555]],
    [ "Wolf Hill Substation",[-71.52692876592326, 41.8814427625385]],
    [ "Pellicer Substation FPL",[-81.30019380219241, 29.65647191724464]],
    [ "142174089",[-96.86249490000002, 46.471631800000004]],
    [ "Public Service Company of Oklahoma",[-96.00304436586582, 36.11195491301939]],
    [ "Public Service Company of Oklahoma",[-95.8674766634966, 36.16976502333713]],
    [ "Public Service Company of Oklahoma",[-95.97639129940546, 36.17616522314921]],
    [ "National Grid",[-73.78567513258444, 43.48581260260431]],
    [ "National Grid",[-73.78767234391582, 43.487896335899315]],
    [ "Bolton Station",[-73.66657544951188, 43.55379977495182]],
    [ "142289688",[-98.00090370000001, 46.9137949]],
    [ "142320733",[-88.68988716243761, 34.35037274489374]],
    [ "Burdeck Street Substation",[-74.00591560587027, 42.79171918278641]],
    [ "Trowbridge Substation",[-76.7687236302928, 35.851026943428835]],
    [ "142348466",[-83.62727475000001, 39.4854592]],
    [ "Keene Road 345kV Substation",[-68.52924954848902, 45.39742562690117]],
    [ "Chester Static VAR Compensator",[-68.52584663505431, 45.397405776790336]],
    [ "Buxton Substation",[-70.55336709512896, 43.663321507103426]],
    [ "South Gorham Substation",[-70.43237403767704, 43.644216245596304]],
    [ "Allings Crossing Substation",[-72.97392523027663, 41.26706812666076]],
    [ "Elmwest Substation",[-72.95451848701995, 41.275865649039815]],
    [ "West River Substation",[-72.93802541126763, 41.288471157117485]],
    [ "Woodmont Substation",[-73.01311851181521, 41.237315233034494]],
    [ "Dennison Substation",[-74.83516044722262, 44.91980897434438]],
    [ "142435958",[-123.73983369428467, 46.712147300724]],
    [ "Sand Creek Substation",[-73.82492262162425, 42.73123230324191]],
    [ "Wilton Station 329",[-73.7509503364151, 43.18212267661425]],
    [ "Glens Falls Station",[-73.6267686, 43.306706199999994]],
    [ "142493853",[-98.26285942403912, 40.90574641946807]],
    [ "142493855",[-98.46181305016825, 41.19989331039051]],
    [ "Grand Island Substation",[-98.26235791774445, 40.912066213408316]],
    [ "Nebraska Public Power District",[-98.26170359959463, 40.90735411115146]],
    [ "Horse Hollow 1 & 2 Substation",[-100.0235080800038, 32.1990507831846]],
    [ "Horse Hollow Kendall Tie",[-100.01711344628475, 32.19025911338762]],
    [ "Bluff Creek Substation",[-100.02305655, 32.196514500000006]],
    [ "Horse Hollow 2 & 3 Switching Station",[-100.02816135077632, 32.19352377110055]],
    [ "Hemstreet Station",[-73.61053962843545, 42.907792370439815]],
    [ "Bath Substation",[-69.83484357955717, 43.90319632996541]],
    [ "Elm Street Substation",[-70.1991596381788, 43.78676715611725]],
    [ "Moshers Substation",[-70.39971215505054, 43.68426519441377]],
    [ "Yarmouth Substation",[-70.15537961442769, 43.75118533391007]],
    [ "Prides Corner Substation",[-70.33878673993296, 43.71022291105114]],
    [ "Woodfield Park Substation",[-80.9318562282467, 34.058321048171535]],
    [ "Mason Substation",[-69.67153949579536, 43.9910754386146]],
    [ "Highland Substation",[-69.20428349580345, 44.136491929736586]],
    [ "Newcastle Substation",[-69.55801574170765, 44.0827166259121]],
    [ "Everett Substation",[-73.76915594261196, 42.69525873784779]],
    [ "Riverside Substation",[-73.73988751649281, 42.66172399621236]],
    [ "Raymond Substation",[-70.49470863107007, 43.944157103905546]],
    [ "Maine Yankee 345kV Substation",[-69.69545330599114, 43.95359060121355]],
    [ "Topsham Substation",[-69.97082904215299, 43.94005290465342]],
    [ "Crowleys Substation",[-70.15508115, 44.0594901]],
    [ "142856223",[-73.80893723597417, 43.24941506232687]],
    [ "Chisago Substation",[-92.91273338069644, 45.46146640844725]],
    [ "142933379",[-89.79218532149383, 33.72859048888981]],
    [ "142973370",[-89.5142732008357, 34.34853961646871]],
    [ "142993760",[-73.64966379999998, 42.7406125]],
    [ "Eufaula",[-95.35586705602304, 35.306854733843466]],
    [ "Chemolite Substation",[-92.91311680059081, 44.79599729870565]],
    [ "Lower Valley Energy",[-110.77714060449414, 43.471935919156316]],
    [ "Kendrick Substation",[-105.12884379354374, 39.68285960428568]],
    [ "Tods Substation",[-112.50529448704529, 37.498836177991656]],
    [ "Oxford Substation",[-89.53418072711045, 34.3502854284186]],
    [ "Market Hill Station",[-74.18502255, 42.955900899999996]],
    [ "143357096",[-110.26715202964894, 35.832437655589146]],
    [ "Montvale Substation",[-74.02601393794313, 41.05007315065484]],
    [ "143525670",[-123.7270987598778, 46.68080466860403]],
    [ "143582454",[-73.80441071864828, 42.69151011563999]],
    [ "143731625",[-105.08647323325575, 40.38236480848027]],
    [ "Boyd Substation",[-105.04532022191958, 40.38939647258657]],
    [ "143731643",[-104.96318941709, 40.41832681777188]],
    [ "East Substation",[-105.04539888797541, 40.40056791068402]],
    [ "143764955",[-99.12120493935116, 40.714902097687094]],
    [ "Prospect Hill Station",[-73.67986354399707, 42.803507671526596]],
    [ "Newton Substation",[-80.45322014999999, 25.7291475]],
    [ "Table Rock Dam Power Station",[-93.30844837376202, 36.59688351765623]],
    [ "East Wooster Substation",[-81.89784799810069, 40.82773486238434]],
    [ "144313374",[-110.6900373800536, 35.02273055096803]],
    [ "144336960",[-96.50836625463471, 41.465412720244984]],
    [ "Maricamp Substation",[-82.08573407452279, 29.15914596952118]],
    [ "Berkley Road Substation",[-81.82023792248718, 28.11351391551554]],
    [ "144371406",[-82.05461362462172, 29.19647035875788]],
    [ "Avon Park Plant Substation DUKE",[-81.49322177007235, 27.578931407426296]],
    [ "144454786",[-81.49723628219066, 27.529703265316794]],
    [ "Pilgrim Substation",[-70.57960410000001, 41.943301149999996]],
    [ "Bourne Switching Station",[-70.55818569251177, 41.76639362052733]],
    [ "Jordan Tap",[-70.62931117598652, 41.90673480449234]],
    [ "Snake Hill Road Tap",[-70.65624137871573, 41.88207949160445]],
    [ "Canal Substation",[-70.51066976198214, 41.76909009650722]],
    [ "West Lebanon Substation",[-73.44493780196053, 42.48727458226582]],
    [ "Ives Substation",[-80.1830314, 25.9674788]],
    [ "144594678",[-97.33701198032519, 41.5309065160563]],
    [ "144660080",[-97.33086555, 41.46917270000001]],
    [ "144660090",[-97.31932144769864, 41.40855990840315]],
    [ "144660092",[-97.32704579464078, 41.46312028926443]],
    [ "144660093",[-97.28639005714898, 41.4137853378412]],
    [ "144660105",[-97.37755996315977, 41.816194829165894]],
    [ "144660109",[-97.29456778273916, 41.42154712549662]],
    [ "144660114",[-97.37835977098786, 41.71357958439718]],
    [ "144796991",[-97.99044211594301, 41.68434760379262]],
    [ "144797002",[-97.69719554927268, 41.56387427061782]],
    [ "Carver Substation",[-70.78840475501839, 41.89816470428245]],
    [ "North Meshoppen Substation",[-76.05178993240241, 41.65812585833791]],
    [ "North Meshoppen Substation",[-76.05043134809944, 41.658642283453865]],
    [ "East Towanda Substation",[-76.43094438460376, 41.75941849571406]],
    [ "South Troy Substation",[-76.78898691209648, 41.7712719426452]],
    [ "Grover Substation",[-76.84436275907984, 41.615506768064556]],
    [ "South Troy Switching Station",[-76.78910514473044, 41.77177368896552]],
    [ "North Meshoppen Substation",[-76.04958872788964, 41.658704160797306]],
    [ "Meshoppen Substation",[-76.04876962698513, 41.658777593667146]],
    [ "Everts Drive Switching Station",[-76.84298854821073, 41.78607368146169]],
    [ "14th Street Substation",[-82.4444928, 27.9736543]],
    [ "Butte des Morts Substation",[-88.48430303861862, 44.23589636510768]],
    [ "Coffeeville Substation",[-89.65824418191868, 33.992211451005375]],
    [ "144944751",[-111.74144904966485, 45.35033122093132]],
    [ "144944752",[-111.73335275207523, 45.379501468562424]],
    [ "144947281",[-92.19876382336797, 43.98303826444944]],
    [ "144947722",[-92.13948376783651, 43.97864700725605]],
    [ "144948887",[-92.09726379769802, 43.98402741182498]],
    [ "Tennessee Gas Pipeline Substation",[-76.79659985432416, 41.73836007806975]],
    [ "Chartley Pond Substation",[-71.23699458028145, 41.94487323479945]],
    [ "Berry Street Substation",[-71.33536254999999, 42.01997219999999]],
    [ "Brayton Point 115kV Substation",[-71.1904051782231, 41.71287141710229]],
    [ "North Attleboro Substation",[-71.29665438731553, 41.98920812104113]],
    [ "EMI Tiverton Substation",[-71.17082355, 41.6431944]],
    [ "Tiverton Substation",[-71.18416920690292, 41.643748626224166]],
    [ "Rush City/CAPS",[-92.92134705299779, 45.671551955960304]],
    [ "Wrenshall Substation",[-92.3320832219889, 46.65577904373979]],
    [ "Fond-Du-Lac Hydro Electric Station",[-92.29388916116672, 46.66676507023435]],
    [ "Bell Rock Road Substation",[-71.08674563562568, 41.73749913220067]],
    [ "City of Tallahassee",[-84.2566011447708, 30.50806389301101]],
    [ "City of Tallahassee",[-84.29352301258831, 30.485214568711374]],
    [ "145078399",[-84.23198728445956, 30.583384526783185]],
    [ "Rosemont Substation",[-122.68876295976082, 45.39107948402969]],
    [ "Korona Substation FPL",[-81.16955304613921, 29.40639834215327]],
    [ "Little Tomoka Substation FPL",[-81.15563505, 29.2530893]],
    [ "Eagle Substation FPL",[-81.15846595, 29.354387950000007]],
    [ "Volusia Substation",[-81.08685838520563, 29.209552752664813]],
    [ "145206135",[-92.21990854103332, 46.66564476120845]],
    [ "145214859",[-84.37614478631241, 30.52840257501486]],
    [ "145225081",[-84.26114036889676, 30.46007925565922]],
    [ "Milan Substation",[-76.57532409419888, 41.89441056752968]],
    [ "Milan Substation",[-76.52566387482518, 41.90736934009839]],
    [ "East Sayre Substation",[-76.51212313097017, 41.99921417996894]],
    [ "145387781",[-92.17442670000001, 43.837538249999994]],
    [ "145389412",[-92.17861064949203, 43.84872686429483]],
    [ "Burke Substation",[-77.3074101665936, 38.82233326789896]],
    [ "Pontiac #27 Substation",[-71.45539915, 41.73584955]],
    [ "Westchase Substation",[-82.5913326160013, 28.040219841944147]],
    [ "145633657",[-92.168613654003, 43.897832977241116]],
    [ "145866502",[-111.9535138960961, 45.2987847816126]],
    [ "St. Albans Substation",[-73.09890446485812, 44.80440881881266]],
    [ "Welden Street Substation",[-73.09046999350558, 44.807849107753505]],
    [ "Jim Branch Substation",[-81.67170926990984, 37.389382271963626]],
    [ "Wyoming Substation",[-81.67741085415223, 37.65812020649554]],
    [ "Tams Mountain Substation",[-81.30004648511851, 37.70058930269099]],
    [ "145894846",[-81.27029845, 37.703461850000004]],
    [ "El Paso Substation",[-97.24534630829933, 37.56683632520741]],
    [ "146022229",[-97.34608142055004, 46.890714377250525]],
    [ "Talley Road Substation",[-98.8099031022171, 29.523546690874127]],
    [ "Arrowhead Substation 230/115 kV",[-92.29454283725045, 46.77364323493793]],
    [ "Midway Substation",[-92.28050471082085, 46.76791169952921]],
    [ "146331132",[-112.11620188577531, 45.35031730095499]],
    [ "Wing River Substation",[-95.0242493935565, 46.387528947148176]],
    [ "146425544",[-101.54212283719252, 46.979700901138195]],
    [ "146430232",[-78.7555362244618, 43.08617014380915]],
    [ "146432374",[-78.90341691657753, 42.922634043528646]],
    [ "146432388",[-78.89355129931106, 42.95404815412549]],
    [ "146432448",[-78.91777043330832, 42.96647660055664]],
    [ "146432467",[-78.91033670955844, 42.965920542471025]],
    [ "146490482",[-78.8925863, 42.96500635]],
    [ "146491556",[-78.92090974063278, 42.97243867867106]],
    [ "146499389",[-97.97093717496772, 46.58691478222253]],
    [ "146539762",[-78.80215381387585, 43.024790644419724]],
    [ "146579816",[-78.8160896764657, 42.91871773740973]],
    [ "146579819",[-78.81906478696997, 42.9180840326882]],
    [ "Bergheim Substation",[-98.5263185447081, 29.788738655412082]],
    [ "Fair Oaks Substation",[-98.59318594509276, 29.794944981282693]],
    [ "Antler Substation",[-98.41340055134874, 29.7767857897942]],
    [ "146641912",[-78.60811269311482, 42.81275832422505]],
    [ "High Sheldon Substation",[-78.41998864476437, 42.764394045650675]],
    [ "Wethersfield Substation",[-78.1916635977812, 42.726360976763026]],
    [ "146647696",[-78.22795472989291, 42.669842242536674]],
    [ "Summit Avenue Substation",[-94.00621334984628, 44.19555043122667]],
    [ "146664496",[-78.71769578914693, 43.158930883196895]],
    [ "Robinson Road Substation",[-78.71595840706846, 43.1380822460455]],
    [ "146666098",[-78.71450967609006, 43.159113174058014]],
    [ "146666493",[-78.73854710928963, 43.16179083222024]],
    [ "Dighton Substation",[-71.1360782968384, 41.81622686723485]],
    [ "Sykes Road Substation",[-71.11586122151903, 41.74062319528446]],
    [ "Canonicus Switchyard",[-71.17991510800113, 41.66834104271471]],
    [ "Substation 8",[-83.1567765289799, 42.19030839411632]],
    [ "146689493",[-78.91809554105514, 42.97819646487221]],
    [ "146689528",[-78.92668461615348, 42.97431060739161]],
    [ "Kendall Substation",[-98.8866871845838, 29.985016722930254]],
    [ "Boerne Substation",[-98.72576107544711, 29.80420081407236]],
    [ "Comfort Substation",[-98.90316969619418, 29.97795752648084]],
    [ "Welfare Substation",[-98.7606052308217, 29.886833000305895]],
    [ "Horse Hollow Generation Tie",[-98.88764882641371, 29.987966087568925]],
    [ "Clear Springs Substation",[-98.0170592767188, 29.651184749826992]],
    [ "Lackawanna Substation",[-75.61014017495158, 41.497961570921554]],
    [ "Oxbow Substation",[-75.86948355910944, 41.606956700816376]],
    [ "Lockhart Substation",[-97.66125788710573, 29.87081307841099]],
    [ "146820608",[-112.13453895251585, 45.377745237281935]],
    [ "146837025",[-112.20533479092713, 45.45577185691664]],
    [ "146837644",[-74.3648534574971, 41.4600142264724]],
    [ "Black River Station",[-75.81625249492585, 44.003031676550385]],
    [ "Miami Shores Substation",[-80.20657542066398, 25.85963148626082]],
    [ "Lemon City Substation",[-80.18913801397863, 25.84589092504988]],
    [ "Little River Substation",[-80.20476637723762, 25.840842912477438]],
    [ "146908447",[-123.77659426954398, 46.66407929794372]],
    [ "Florida Power & Light",[-80.25784145877653, 25.847985125551038]],
    [ "146962946",[-112.31510188426648, 45.54429887131182]],
    [ "SE Polk Substation",[-93.52721403814647, 41.541727071521585]],
    [ "146967440",[-93.52395384713572, 41.55367987572535]],
    [ "146989016",[-112.28756067537694, 45.68662574239463]],
    [ "Mansfield Substation",[-71.26412827162468, 41.98846628992023]],
    [ "Read Street Substation",[-71.34218003251881, 41.91427912503407]],
    [ "Robinson Avenue Substation",[-71.37425182468264, 41.91654126502938]],
    [ "Staples Substation",[-71.44578541004078, 41.98071245100691]],
    [ "Warren Substation",[-71.2808251049288, 41.73361029043086]],
    [ "Washington Substation",[-71.46198896862097, 41.937128197487745]],
    [ "Division Street #61 Substation",[-71.49207107701457, 41.66459400530265]],
    [ "Jackson Road",[-86.25591844393956, 41.623049313879626]],
    [ "AEP Dragoon Station",[-86.19216757504661, 41.651063055687175]],
    [ "Eynon Substation",[-75.58109213618324, 41.48980276947148]],
    [ "Starkey Substation",[-79.98725235149321, 37.21167084693331]],
    [ "Venus Substation",[-97.07274279081244, 32.44397408823364]],
    [ "147131475",[-97.08079345957773, 32.60510828925625]],
    [ "147135004",[-97.07054631758012, 32.71389336582726]],
    [ "147193868",[-115.57784130200132, 32.78108079454765]],
    [ "Betka Substation",[-95.86120005, 30.01774995]],
    [ "Porter Substation",[-95.34220873712572, 30.18640384860466]],
    [ "Parkway Substation",[-95.10636260558617, 30.090626394208474]],
    [ "Tamina Substation",[-95.34666585000002, 30.187044150000002]],
    [ "New Caney Substation",[-95.21961257165057, 30.134929709016642]],
    [ "147219403",[-111.92888538463764, 32.87974493246738]],
    [ "Axton Substation",[-79.70715112484415, 36.63502361163322]],
    [ "Axton Substation",[-79.70498829540857, 36.634799995169246]],
    [ "Kumis Substation",[-80.17761430233405, 37.23693427328035]],
    [ "147225908",[-79.29099575000001, 37.42579145]],
    [ "Moseley Substation",[-79.56584140318367, 37.35225746742779]],
    [ "147225910",[-79.36441416937045, 37.406672845626716]],
    [ "Centerville Substation",[-79.50204399533416, 37.374560593989905]],
    [ "Nasonville Substation",[-71.6098968030777, 41.974266395318665]],
    [ "Riverside Substation",[-71.50777669688527, 42.00409498743687]],
    [ "Hathaway Street Substation",[-71.15664613745912, 41.71629551641199]],
    [ "East Substation",[-95.02488909860892, 45.12731204673985]],
    [ "Willmar Substation",[-95.05373758958181, 45.08237974942809]],
    [ "South Substation",[-95.0529278749994, 45.102526143510644]],
    [ "Southwest Substation",[-95.08455966710447, 45.10519697499517]],
    [ "Aldine Substation",[-95.37038462770586, 29.901725783718998]],
    [ "Berry Substation",[-95.3536726335036, 29.83953401871405]],
    [ "Liberty Substation",[-95.28552239999999, 29.807004349999996]],
    [ "147297238",[-78.498916295205, 43.023976724694954]],
    [ "147300041",[-78.47079230350593, 43.01242033332717]],
    [ "147300042",[-78.4706252927943, 43.01363950133729]],
    [ "147380637",[-78.93642366810109, 43.14153430952928]],
    [ "147381638",[-79.00730927513182, 43.098867697854054]],
    [ "147390550",[-92.05927950970424, 43.97468654977442]],
    [ "Florida Power & Light",[-80.28782865, 25.940338699999998]],
    [ "Hitchland Substation",[-101.39170282729113, 36.49650748797634]],
    [ "Murray Gill Substation",[-97.41397342975581, 37.594413007903015]],
    [ "Clearwater Substation",[-97.53291861927782, 37.53239563334666]],
    [ "Alabama Switch",[-78.49368686822206, 43.14754299863903]],
    [ "147499297",[-78.27835378289323, 43.0628307010527]],
    [ "147499299",[-78.27756718348178, 43.06314347527855]],
    [ "Huntington Court Substation",[-79.93012068517986, 37.30857005078459]],
    [ "Niagara Mohawk Power Corp",[-78.19381160626824, 42.99614944106346]],
    [ "Falling Branch Substation",[-80.3311012971851, 37.13840660328224]],
    [ "Hans Meadow Substation",[-80.41158156238912, 37.152576131146745]],
    [ "Midway Substation",[-80.42271384015139, 37.17074607831232]],
    [ "Cambria Substation",[-80.41473656078487, 37.142446141914284]],
    [ "Hastings Substation",[-92.85198035702597, 44.7450543891229]],
    [ "West Hastings Substation",[-92.89494064098753, 44.73722142197388]],
    [ "Telegraph Rd",[-78.46644720911654, 43.2051678579272]],
    [ "Sweden Switches",[-77.96780983805313, 43.16531973485212]],
    [ "Regis Substation FPL",[-81.26819020850857, 29.49755337155805]],
    [ "Station 113",[-77.8047884823584, 43.154522324781425]],
    [ "Station 418",[-77.74237451750501, 43.14598525035373]],
    [ "Jepson Substation",[-71.28082462613166, 41.54623702236672]],
    [ "Dexter Substation",[-71.2553213408364, 41.601810060708544]],
    [ "Station 67",[-77.68600153862765, 43.1176657081985]],
    [ "147565306",[-78.98893294424339, 43.199683177401496]],
    [ "147569609",[-96.59381095634201, 33.315846999302984]],
    [ "147579270",[-88.30484558763345, 37.00155153710569]],
    [ "147598111",[-77.79952337730553, 43.19183594242882]],
    [ "Station 70",[-77.7518093360111, 43.21943287864236]],
    [ "Station 71",[-77.75074740923654, 43.27843049185681]],
    [ "Station 69",[-77.6957793, 43.26515944999999]],
    [ "Station 93",[-77.65848432880024, 43.259889840876546]],
    [ "Station 7",[-77.63537132485622, 43.26696155770655]],
    [ "Station 48",[-77.65315019204132, 43.17876175567782]],
    [ "147611457",[-112.428455, 45.3927781]],
    [ "Hotel Road Substation",[-70.26695895, 44.068120300000004]],
    [ "Kimball Road Substation",[-70.63371855295821, 44.151802816026034]],
    [ "Lewiston Lower Substation",[-70.21170821586608, 44.08693723646064]],
    [ "Norway Substation",[-70.52810504020069, 44.207267040003686]],
    [ "147639607",[-112.1119467809369, 45.814621105000825]],
    [ "Spring Street Substation",[-70.36027013569681, 43.651627094746324]],
    [ "Westbrook Substation",[-70.37611915, 43.6568152]],
    [ "Sewall Substation",[-70.29253856712984, 43.65440995397393]],
    [ "147668889",[-98.95356809592863, 41.5815472442705]],
    [ "147668897",[-97.98534150498905, 41.45294373377231]],
    [ "147668904",[-98.75765029430714, 41.488408135310245]],
    [ "147668909",[-98.36910545639549, 41.575119189527605]],
    [ "South Sheboygan Falls",[-87.83833628856324, 43.71102602526865]],
    [ "National Grid",[-78.85561506679699, 43.0001649495728]],
    [ "Bent Mountain Substation",[-80.11951118810951, 37.178264689515665]],
    [ "Clearbrook Substation",[-79.95323629609769, 37.21968987405447]],
    [ "Vinton Substation",[-79.86302106828968, 37.26829044679087]],
    [ "Bonsack Substation",[-79.87013432053962, 37.33310156416658]],
    [ "Biddeford IP Substation",[-70.4928802853858, 43.467867784408924]],
    [ "West Kennebunk Substation",[-70.6068550610119, 43.41864755924807]],
    [ "Three Rivers Substation",[-70.82086955357923, 43.16824133868295]],
    [ "Louden Substation",[-70.50327379067423, 43.529132656956186]],
    [ "Branch Brook Substation",[-70.55838322143259, 43.36556867101875]],
    [ "Quaker Hill Substation",[-70.7427528185308, 43.28821559532343]],
    [ "Stearman Substation",[-97.28862492409577, 37.60691641708058]],
    [ "Pony Meadows Substation",[-97.13644160502444, 37.6284967248711]],
    [ "Farber Substation",[-97.23919262475994, 37.53300595132665]],
    [ "59th Street Substation",[-97.33309480946998, 37.585919426689394]],
    [ "Interstate Substation",[-97.39776411254147, 37.65077006147126]],
    [ "Harper Substation",[-98.03890733448772, 37.28802787505584]],
    [ "Boeing Substation",[-97.28655880616375, 37.627002835456864]],
    [ "Puget Sound Energy",[-122.62438392490112, 47.70084119529802]],
    [ "148014504",[-92.43011777500139, 44.10882334456051]],
    [ "148015225",[-80.61450989813345, 37.11416893366384]],
    [ "City of Radford",[-80.62625364649277, 37.13013003296974]],
    [ "Alum Ridge Substation",[-80.39845580128276, 36.97528043159142]],
    [ "Floyd Substation",[-80.30860043739243, 36.925881830517376]],
    [ "West Bassett Substation",[-80.01750788614302, 36.76974655133847]],
    [ "Philpott Substation",[-80.0271192, 36.776104849999996]],
    [ "Fieldale Substation",[-79.93414631982697, 36.70805442802535]],
    [ "Martinsville Substation",[-79.85114641634706, 36.70187712639049]],
    [ "Blaine Substation",[-79.86577197382367, 37.05063951297551]],
    [ "Baker Substation",[-82.6100650505419, 38.18163940914692]],
    [ "148019013",[-78.95039237537402, 43.0228399065642]],
    [ "148035060",[-111.82357551235472, 45.67717867170815]],
    [ "148090646",[-78.7888902, 42.983032849999994]],
    [ "Paynesville Substation",[-94.71299674915807, 45.39169887919897]],
    [ "Echo Substation",[-95.52068586502195, 29.785420175614437]],
    [ "Clinch River Substation",[-82.19808568688602, 36.930432143620315]],
    [ "Elk Garden Substation",[-81.9969714571438, 36.91471837721134]],
    [ "Lebanon Substation",[-82.07051225, 36.922618299999996]],
    [ "Hansonville Substation",[-82.12132784978701, 36.84776528326123]],
    [ "Switchback Substation",[-81.37439225014387, 37.37104143945177]],
    [ "South Princeton Substation",[-81.10022054507557, 37.351955123814825]],
    [ "148164199",[-81.28644777043077, 37.36446160648041]],
    [ "148164200",[-81.15221754324891, 37.35370531465047]],
    [ "Hatcher Substation",[-81.00162605000001, 37.35816855]],
    [ "Cordova Substation",[-121.20795418235016, 38.55313987478947]],
    [ "Procter Substation",[-121.40002708352247, 38.53168657188817]],
    [ "East City Substation",[-121.43063001817234, 38.55380591887508]],
    [ "Franklin Substation",[-79.8980312799242, 37.00200583074737]],
    [ "148282565",[-79.91828682260132, 36.98347949481085]],
    [ "Oak Level Substation",[-79.93031184960044, 36.821502883298244]],
    [ "Perham Substation",[-95.60549958234415, 46.62819588484405]],
    [ "Leesville Substation",[-79.40332452097799, 37.09397633669808]],
    [ "Medina Substation",[-93.58321375233258, 45.01591256727227]],
    [ "148347710",[-77.95633974075608, 43.212496131291616]],
    [ "148347711",[-77.95804515726708, 43.210390771814964]],
    [ "148348862",[-77.95561624999999, 43.2947269]],
    [ "Lakeridge Substation",[-97.43782048071424, 37.73820121667587]],
    [ "Wichita 138kV Substation",[-97.52036265228575, 37.79085847019398]],
    [ "Cowskin Substation",[-97.49794056688967, 37.70692240853804]],
    [ "Gordon Evans Gen Substation",[-97.52003786996897, 37.787877006551916]],
    [ "Wichita 345kV Substation",[-97.5195808623641, 37.792931012263026]],
    [ "Mumford Station",[-77.85770295125262, 42.98820656202813]],
    [ "Golah Station",[-77.7148114640258, 42.970879679939856]],
    [ "Otter Substation",[-79.28039370000002, 37.14294530000001]],
    [ "Station 80",[-77.67260857641504, 43.05380123927573]],
    [ "148407028",[-79.28950306081089, 37.224315220401635]],
    [ "Johnson Substation",[-79.30204995000001, 37.2401662]],
    [ "Station 419",[-77.68384534578271, 43.05457212122167]],
    [ "Edgetown Substation",[-96.10181479999999, 46.3008435]],
    [ "Fergus Falls Substation",[-96.0391082889914, 46.3158565754349]],
    [ "148409888",[-95.4131255133989, 46.35545333467971]],
    [ "Ryan Substation",[-73.98567018352193, 44.890846029961246]],
    [ "Lyon Mountain",[-73.89737934535029, 44.73360665137909]],
    [ "Tremont Substation",[-70.76436098663847, 41.80135854571621]],
    [ "West Pond Substation",[-70.70303736867515, 41.92744957714315]],
    [ "Valley NB Substation",[-70.60130740000001, 41.78286289999999]],
    [ "Wareham Substation",[-70.69192227159753, 41.78826245638705]],
    [ "Dupont Substation",[-71.0043729613365, 42.0754614227237]],
    [ "Wing Lane Substation",[-70.89706345775548, 41.67742096530194]],
    [ "Brook Street Substation",[-70.76672409740821, 41.96566481537618]],
    [ "National Grid",[-77.87099408526097, 42.87179127500598]],
    [ "Retsof Switching Station",[-77.88550271204369, 42.829669650060644]],
    [ "Station 162",[-77.99675529999999, 42.70036029999999]],
    [ "148499456",[-78.07708292521075, 42.65379970540242]],
    [ "148500372",[-97.4258507027544, 35.18597666896584]],
    [ "148500375",[-97.44692720783057, 35.17446010090075]],
    [ "148501189",[-78.08135401638924, 42.497114992108486]],
    [ "Station 180",[-78.16153391114173, 42.41775687685016]],
    [ "Bentley West Substation",[-97.5273071998632, 37.91170813682645]],
    [ "Maize Substation",[-97.44379829701622, 37.77412035039366]],
    [ "Colwich",[-97.52229607133474, 37.82441313353761]],
    [ "East Golah Station",[-77.69368346370084, 42.94846310010335]],
    [ "148530707",[-92.91608177995792, 44.53685321180043]],
    [ "Colville Substation",[-92.91830193342591, 44.536930884067935]],
    [ "148530800",[-78.49032939096095, 42.52363657119819]],
    [ "Burlington Substation",[-95.77243345410848, 46.760206926160016]],
    [ "St. Cloud Substation",[-94.14990168817467, 45.54594295090562]],
    [ "OEC",[-97.39729369221995, 35.225259422733814]],
    [ "Elizabeth Substation",[-96.03209577900327, 46.36998906575802]],
    [ "148611138",[-78.45747975248257, 42.089352819549035]],
    [ "148616165",[-77.95764356425877, 42.11398714627014]],
    [ "Fergus Falls Division Rural Substation",[-96.03073942383044, 46.325738336057164]],
    [ "148616796",[-77.80147495888798, 42.15531678733722]],
    [ "APS Tempe Substation",[-111.94504083192464, 33.428720723689565]],
    [ "Solvay Station",[-76.216234430331, 43.06468893394658]],
    [ "Bridge St.",[-76.21556349004398, 43.064047429596506]],
    [ "148650675",[-76.21693218182588, 43.06786972328148]],
    [ "Tuckasegee Tie Substation",[-83.10872552681842, 35.2656004368581]],
    [ "Merchandise Substation",[-80.3141869, 25.77753695]],
    [ "Pelican Rapids Substation",[-96.11564158734645, 46.55763046050778]],
    [ "Bluffs Substation",[-100.5072125277307, 31.435506276074168]],
    [ "148773522",[-111.67699828952632, 45.52074182818965]],
    [ "Lucy Substation",[-80.45173278455185, 25.46370234213643]],
    [ "LaSalle Substation",[-87.6313759342738, 41.872851959135055]],
    [ "148860381",[-107.3093362919398, 38.02466082068396]],
    [ "DeKoven Substation",[-87.64267679372837, 41.868890355946796]],
    [ "Kings Bay Base Switching Station",[-81.56297728468147, 30.782563130020552]],
    [ "Centennial Substation",[-96.74659784999999, 46.8655041]],
    [ "149065249",[-97.43557413231238, 35.2069795583741]],
    [ "149080676",[-79.01402959480407, 36.044337775570824]],
    [ "149085167",[-79.33898119163246, 42.47077162456271]],
    [ "149085604",[-79.32240396317835, 42.47457842506092]],
    [ "149086473",[-79.31644975998319, 42.4848870963491]],
    [ "Faraday Plant Substation",[-122.3189060101875, 45.269604712723805]],
    [ "149224254",[-79.33164472684797, 36.095339331330656]],
    [ "149224259",[-79.46778691341086, 36.11286758452455]],
    [ "149224296",[-79.41313247913152, 36.105287444784004]],
    [ "149224301",[-79.40602825, 36.1267115]],
    [ "Virginia Electric and Power Company",[-78.90588303301014, 38.282888498625695]],
    [ "Verona Substation",[-78.98582192678309, 38.18988531687815]],
    [ "Bristers Substation",[-77.59549719017382, 38.56307442666493]],
    [ "Falconer Substation",[-79.20463231043999, 42.11207276740072]],
    [ "149329465",[-79.19963439957577, 42.10687499799623]],
    [ "NYSEG",[-78.97248801739852, 42.152503744379274]],
    [ "Moon Switches",[-79.29940012501451, 42.28413580163148]],
    [ "149488713",[-88.32763733500492, 39.48990053461412]],
    [ "Bradley Substation",[-81.18756350166207, 37.869326516279685]],
    [ "Ronceverte Substation",[-80.47799104934555, 37.74228728591053]],
    [ "149506261",[-80.00807883285788, 37.78001779901525]],
    [ "149506262",[-79.87690828021591, 37.78734948650638]],
    [ "Virginia Electric and Power Company",[-79.82418563455705, 37.812399447353435]],
    [ "Manhattan Substation",[-82.51794739035624, 27.890390093311012]],
    [ "King's Mill Substation",[-76.63095548285469, 37.23363174607302]],
    [ "Lightfoot Substation",[-76.75711343808157, 37.328268663130665]],
    [ "White Lake Substation",[-71.20664518994883, 43.84791940480098]],
    [ "149621819",[-97.41548527035368, 35.24805495138744]],
    [ "149690975",[-78.7546428801914, 42.99201768423596]],
    [ "Bear Garden Substation",[-78.2843207014854, 37.69710490757531]],
    [ "Kidds Store Substation",[-78.36834938953149, 37.79951710836086]],
    [ "Red Hill Substation",[-78.62685214597913, 37.96683921574838]],
    [ "Cunningham Substation",[-78.32047670223483, 37.88679114829213]],
    [ "Goshen Junction Sub",[-85.84379990972624, 41.565049815354456]],
    [ "149700535",[-85.32610263799516, 41.22541757006878]],
    [ "Union Valley Substation",[-120.44282527812987, 38.86349249628976]],
    [ "149760560",[-78.39011336263387, 42.073198671351996]],
    [ "149760657",[-78.38921205520973, 42.07629062678096]],
    [ "149768761",[-77.77473844772621, 42.266436710216425]],
    [ "149769687",[-116.04908803199822, 47.524552781728545]],
    [ "Station 89",[-77.58329156190813, 43.0931057499005]],
    [ "Substation 56",[-77.53762069438702, 43.08850612268404]],
    [ "Fairport Electric",[-77.43269988261721, 43.08727727212646]],
    [ "Station 121",[-77.33388298092954, 43.08241295610738]],
    [ "Placerville Substation",[-120.783599128696, 38.73087776590679]],
    [ "Brookridge Substation",[-82.49837181482653, 28.575125282676822]],
    [ "Diamond Springs Substation",[-120.82586816802761, 38.69335642052105]],
    [ "Brooksville Substation",[-82.41686976842053, 28.527395418653768]],
    [ "Duke Energy",[-82.56394937337626, 28.453398653649387]],
    [ "Hudson Substation",[-82.56799731184493, 28.365630309412307]],
    [ "TECO",[-82.5492980615192, 28.064017992340435]],
    [ "Waynesboro Substation",[-78.8799765065817, 38.06023274814369]],
    [ "Dupont Waynesboro Substation",[-78.8808768342884, 38.06117995077254]],
    [ "Louisa Substation",[-78.02686845837418, 38.00745484257059]],
    [ "CPC Louisa Substation",[-78.02847029438182, 38.00970511784448]],
    [ "Rappahannock Electric Cooperative",[-78.4114516616176, 38.170803103612016]],
    [ "Pratts Substation",[-78.26848777255572, 38.34855716308765]],
    [ "Columbia Substation",[-78.17339409957836, 37.7609373832225]],
    [ "Ferncliff Substation",[-78.10537991913824, 37.931517791065204]],
    [ "Shannon Hill Substation",[-78.04591888263506, 37.88255552149267]],
    [ "CPC James River Substation",[-78.17413988319862, 37.759326249125266]],
    [ "Trices Lake Substation",[-78.2383365466546, 37.662933193801955]],
    [ "North Doswell Substation",[-77.46127970000002, 37.88326395]],
    [ "149952022",[-77.51760209235238, 38.066819283581026]],
    [ "Arnold's Corner Substation",[-77.20439147350471, 38.2799024571206]],
    [ "Westmoreland Substation",[-76.74358483118236, 38.00836786139181]],
    [ "Dunnsville Substation",[-76.81263595335572, 37.85280116713609]],
    [ "149961198",[-76.39366448680764, 37.70801378988419]],
    [ "Conifer Substation",[-105.30204607826693, 39.53697098059675]],
    [ "Casey Road Substation",[-82.51658405016077, 28.05145287738024]],
    [ "Aquia Harbour Substation",[-77.38764864892131, 38.45112530888619]],
    [ "Garrisonville Substation",[-77.48982293544915, 38.45571629546223]],
    [ "Quantico Substation",[-77.30372032572475, 38.516354031871586]],
    [ "Stafford Substation",[-77.38925842667369, 38.44610611665387]],
    [ "Station 168",[-77.24666662785025, 42.96632887200823]],
    [ "Station 156",[-77.22327076446123, 42.963324968929896]],
    [ "Sapony Substation",[-77.4766428456173, 36.944766927620265]],
    [ "149986601",[-77.42519092656319, 37.0891743446655]],
    [ "Thelma Substation",[-77.81013853913501, 36.49689477095081]],
    [ "Clover Substation",[-78.70632924784962, 36.86622424041586]],
    [ "150155124",[-77.57684347293934, 36.96366856354139]],
    [ "Chase City Substation",[-78.46533854332927, 36.80892933176706]],
    [ "150155126",[-78.20374506590595, 36.883539359331856]],
    [ "150155536",[-78.7360115, 36.82002950000001]],
    [ "Reusens Substation",[-79.18922713687374, 37.46226825265213]],
    [ "Brush Tavern Substation",[-79.25861685477126, 37.32303631163204]],
    [ "Forest Substation",[-79.29321909536898, 37.363459311417714]],
    [ "New London Substation",[-79.30867337002798, 37.3291622558452]],
    [ "Monel Substation",[-79.12428458187547, 37.45643324556883]],
    [ "Candlers Mountain Substation",[-79.15554569976761, 37.326507466725445]],
    [ "Peaks View Substation",[-79.12223221305322, 37.38939082611211]],
    [ "150157389",[-79.2292296681224, 37.432912242769305]],
    [ "Opossum Creek Substation",[-79.10732637991867, 37.372953363382784]],
    [ "South Lynchburg Substation",[-79.1797648024318, 37.3619277212584]],
    [ "East Lynchburg Substation",[-79.07704071221234, 37.4063542944683]],
    [ "Wright Avenue Substation",[-76.59061010642964, 42.92621226406256]],
    [ "Elbridge",[-76.38803493444273, 43.04046795146916]],
    [ "Station 199",[-76.83045287552306, 43.052915548520666]],
    [ "150255958",[-77.07290650492219, 43.06315560954183]],
    [ "Macedon Station",[-77.28989945000001, 43.0727877]],
    [ "Station 13A",[-77.31101287374808, 43.27061615610134]],
    [ "Farmville Substation",[-78.39313021529681, 37.31133117852755]],
    [ "150287362",[-78.60003419469986, 36.80956782101586]],
    [ "150287366",[-78.49984303021878, 36.81874935833745]],
    [ "150287368",[-78.53931409987744, 36.72771753934256]],
    [ "150287369",[-78.56459484730354, 36.626186620968205]],
    [ "Sooner Substation",[-97.05657480155863, 36.4474306872546]],
    [ "Georgia Transmission Corporation",[-83.331993212082, 30.84362237484241]],
    [ "150402955",[-115.16754707428025, 36.14299190358919]],
    [ "Flanagan Substation",[-122.42512038630505, 40.67898743582372]],
    [ "Keswick Substation",[-122.44413037092342, 40.60978941955199]],
    [ "150431992",[-78.9464818, 37.71050770000001]],
    [ "Boxwood Substation",[-79.0322692, 37.5934518]],
    [ "Appalachian Power Company",[-79.0119419725893, 37.69475294891311]],
    [ "150436992",[-82.2935041712981, 28.258472907825027]],
    [ "Station 135",[-77.32277399753033, 43.228564425078936]],
    [ "Station 204",[-77.33050493974991, 43.22628526523388]],
    [ "Station 124",[-77.40782169021341, 43.16709596670947]],
    [ "Station 230",[-77.32602717626645, 43.16342785188131]],
    [ "Station 120",[-77.34425386704785, 43.063729584993155]],
    [ "Geres Lock Switching Station",[-76.23396847019828, 43.062164635604155]],
    [ "Dorsey Run Substation",[-76.77899210550767, 39.15287046271376]],
    [ "Palermo Substation",[-121.51782535920452, 39.45420643186667]],
    [ "Goldsboro Substation",[-77.91392195, 35.36836134999999]],
    [ "New Hope Substation",[-77.9229253362566, 35.37665414689545]],
    [ "Seymour Johnson Substation",[-77.96551935530763, 35.365657113064316]],
    [ "150575958",[-77.9829887817279, 35.42335425216578]],
    [ "Enka Substation",[-82.63759619999999, 35.53796145]],
    [ "Harris Road Station",[-76.23037285976523, 43.01725121647844]],
    [ "Lafayette Station",[-76.11850865651483, 42.97263961579458]],
    [ "Tilden Station",[-76.12127962163444, 42.97407317972023]],
    [ "Rock Cut Station",[-76.13461595230889, 43.011066180943224]],
    [ "Lejeune Substation",[-80.26568879890768, 25.793516573142185]],
    [ "West Substation",[-80.44622820969542, 27.634935468253367]],
    [ "150703565",[-80.76116029796546, 34.144290828624335]],
    [ "Danville Utilities",[-79.45779408177118, 36.60669011722135]],
    [ "Danville Utilities",[-79.41524092406303, 36.60268861552524]],
    [ "150814742",[-115.60124668754038, 47.41834490562475]],
    [ "150858752",[-79.66960067434906, 36.545729643207835]],
    [ "Sheffield Substation",[-79.88636386839684, 36.62355278286091]],
    [ "150858754",[-79.71818755371163, 36.505679155554645]],
    [ "Ridgeway Substation",[-79.83879978721069, 36.58643001358761]],
    [ "Jacksons Ferry Substation",[-80.825778, 36.877047250000004]],
    [ "Huffman Substation",[-80.71933755, 36.77728025]],
    [ "Pipers Gap Substation",[-80.74849706340356, 36.75857876589937]],
    [ "Jubalear Substation",[-80.95863382264056, 36.68459072945168]],
    [ "Appalachian Power Company",[-80.60907861363188, 36.634527742401445]],
    [ "Appalachian Power Company",[-80.71743861100111, 37.07467980299636]],
    [ "Peak Creek Substation",[-80.74783236140394, 37.04850443787467]],
    [ "Fern Street Substation",[-82.4535038, 28.0050484]],
    [ "Austinville Substation",[-80.93126374999999, 36.825137299999994]],
    [ "Wythe Substation",[-81.0606381176895, 36.94839308445159]],
    [ "Culloden Substation",[-82.08025124999999, 38.4146425]],
    [ "Amos Substation",[-81.82942130840422, 38.47371096773289]],
    [ "Big Sandy Substation",[-82.61933502911798, 38.172728276451075]],
    [ "North Proctorville Substation",[-82.3952378312679, 38.477524967712014]],
    [ "151008921",[-82.59533205, 38.178708150000006]],
    [ "151017662",[-82.99281078815831, 38.95001113573485]],
    [ "Kanawha River Substation",[-81.42055140428144, 38.20489228814108]],
    [ "151081740",[-81.17750325460403, 37.80919275347665]],
    [ "Boone Dam Substation",[-82.43622984999999, 36.44199545000001]],
    [ "Pocket Substation",[-83.04325352116071, 36.78388193693114]],
    [ "Kentucky Utilities Company",[-83.7567165, 36.79719874999999]],
    [ "151115373",[-83.71712726688239, 36.79706365262762]],
    [ "Cawood Substation",[-83.21654187032364, 36.78048461270811]],
    [ "Keywood Substation",[-81.76632095515663, 36.8567202058913]],
    [ "Kentucky Utilities Company",[-83.4805832975415, 36.769053918996946]],
    [ "Wyandotte Substation",[-121.54096821668644, 39.49160900938746]],
    [ "151174040",[-93.40973854944619, 43.71714590080216]],
    [ "Imboden - Big Stone Gap Substation",[-82.81261567800996, 36.881529163843965]],
    [ "151176866",[-82.89642499997784, 36.863080198325974]],
    [ "151176868",[-82.9420939127394, 36.84483279554005]],
    [ "Dorchester - Norton Substation",[-82.64681235243185, 36.93290439243208]],
    [ "North Bristol Substation",[-82.1888539942598, 36.62419700182511]],
    [ "Copper Ridge Substation",[-82.46473795, 36.79432979999999]],
    [ "Hill Substation",[-82.63477266662927, 36.72233440569538]],
    [ "APS Cactus Substation",[-111.88517248323423, 33.5834972487534]],
    [ "Lockeford Substation",[-121.16036042787249, 38.11782200713827]],
    [ "Glenville Substation",[-93.2693787227264, 43.55953570558992]],
    [ "APS Chaparral Substation",[-111.92000669503662, 33.58164740296272]],
    [ "Tazewell Substation",[-81.5447360033727, 37.147206142015996]],
    [ "Tazewell Substation",[-81.54582757994045, 37.14889838669434]],
    [ "151306533",[-92.95416820000001, 43.49899925]],
    [ "151367835",[-82.46149242508088, 28.142641692690024]],
    [ "SRP Buckhorn Substation",[-111.73248532980243, 33.43783852609775]],
    [ "151426397",[-97.90671009999997, 47.25549929999999]],
    [ "Hudson Station",[-71.55647984533391, 42.38731013959217]],
    [ "North Marlboro Substation",[-71.60061461220039, 42.36280398971031]],
    [ "Pillsbury Substation",[-97.83136500658745, 47.21276639430778]],
    [ "151524407",[-116.40018190786971, 48.329758015334804]],
    [ "Buckingham Substation",[-78.35046133164532, 37.49170006857553]],
    [ "Glover & Watrous Substation",[-93.62906125742754, 41.5478539463524]],
    [ "Falconer Substation",[-97.06343603148079, 47.983412738433934]],
    [ "Pickert Substation",[-97.81838335, 47.50042785000001]],
    [ "Grand Forks Substation",[-97.06490508429056, 47.981706883404236]],
    [ "151629388",[-112.48774950411361, 45.98217672729504]],
    [ "Brownwood South Substation",[-98.98189624999999, 31.676045249999998]],
    [ "Winger Substation",[-96.01408243784329, 47.55783225284234]],
    [ "Caledonia Substation",[-96.95355202146189, 47.4550611251893]],
    [ "Industrial Park Substation",[-96.98584255000002, 47.93771975]],
    [ "Crookston Substation",[-96.65410819517552, 47.768117656123856]],
    [ "Rindal Substation",[-96.13134170000001, 47.52781589999999]],
    [ "151717652",[-96.65367124999999, 47.7373532]],
    [ "Cooperstown Substation",[-98.17667587320477, 47.500810387550274]],
    [ "Grundy Substation",[-82.12461293369091, 37.301215172689254]],
    [ "151801691",[-121.8538122324628, 36.59883171698778]],
    [ "PG & E Substation",[-121.85313537487538, 36.598276937553834]],
    [ "Marlette Substation",[-112.09499989359264, 33.53037485501211]],
    [ "Colgate Substation",[-97.65387530000001, 47.2399525]],
    [ "Waukon Substation",[-96.13037635000002, 47.368502199999995]],
    [ "151963295",[-68.8386189043949, 45.7320670933382]],
    [ "152034856",[-97.70650284999999, 47.3245748]],
    [ "Gavin Substation",[-82.12073493692873, 38.9414267820528]],
    [ "Williston Substation",[-73.11160752013718, 44.44024666730516]],
    [ "152163874",[-111.67514008184108, 33.30409519369063]],
    [ "152164320",[-82.1683136, 29.183007350000004]],
    [ "Avista",[-116.8065647551806, 47.71213992717728]],
    [ "Avista",[-116.76564130617709, 47.691011765208216]],
    [ "Mullens Substation",[-81.35369958166717, 37.575158392345664]],
    [ "Itmann Substation",[-81.43472639854099, 37.577884418207134]],
    [ "Pinnacle Creek Substation",[-81.49042459292761, 37.54568991849628]],
    [ "South Beaumont Substation",[-94.07583196877299, 30.033344032355554]],
    [ "Lawrence Substation",[-96.66179970876625, 43.589660999634106]],
    [ "Valley Home Substation",[-120.94422361746707, 37.856345639473226]],
    [ "152342152",[-78.65071285, 35.83536149999999]],
    [ "Avena Substation",[-121.05419612602041, 37.84225084625383]],
    [ "Manteca Substation",[-121.22408021209455, 37.80111136138708]],
    [ "Kasson Substation",[-121.3413820291937, 37.74578641253078]],
    [ "Lammers Substation",[-121.47780995938108, 37.71310300352492]],
    [ "Amos Substation",[-81.8269152957494, 38.468603081461076]],
    [ "152420734",[-111.77874986867923, 33.46591738163671]],
    [ "Acushnet Tap Substation",[-70.91373686085583, 41.670788486891105]],
    [ "Kingston Substation",[-70.75635572766197, 42.005240884562326]],
    [ "SEMASS Tap Substation",[-70.78211516981487, 41.8056999654362]],
    [ "Arsene Substation",[-70.87523516991472, 41.639909145596995]],
    [ "Dartmouth Substation",[-71.00530604999999, 41.68038855]],
    [ "Industrial Park Substation",[-70.94916340029143, 41.71940622888229]],
    [ "Cross Road Substation",[-71.00742881744738, 41.64944228467476]],
    [ "152484322",[-95.32907641904521, 48.83324528017116]],
    [ "152504174",[-96.83372075, 45.885165150000006]],
    [ "152541637",[-106.53872240862403, 31.813163091391154]],
    [ "Former Killen Substation",[-83.47814608843629, 38.693811750542814]],
    [ "Zimmer Substation",[-84.2251849791544, 38.86568116864193]],
    [ "152586743",[-83.6799331, 38.6410744]],
    [ "Norris Substation",[-101.19795274999998, 43.4612715]],
    [ "Goddard Substation",[-83.6034337961336, 38.36864861217196]],
    [ "152763577",[-83.76940613138927, 38.64952324941604]],
    [ "152763578",[-83.82954823821792, 38.647149723609324]],
    [ "152763579",[-83.69394143426182, 38.59694785459731]],
    [ "152763581",[-83.80040069120713, 38.63664595472215]],
    [ "East Bridgewater Substation",[-70.96657329362655, 42.023793316409275]],
    [ "Nucor Steel Memphis, Inc.",[-90.16458490000001, 35.05082684999999]],
    [ "Yampa Valley Electric",[-106.88338839095886, 40.270450712105614]],
    [ "152903712",[-89.77884028382128, 43.62566853800438]],
    [ "Covert Substation",[-86.29398078912239, 42.32152730466829]],
    [ "Greentown Substation",[-85.91532803327749, 40.47346945002416]],
    [ "Greentown Substation",[-85.91633900710838, 40.476490441836894]],
    [ "Royerton Substation",[-85.36527151342786, 40.27336285568986]],
    [ "152946532",[-85.4311815583442, 40.26220385706585]],
    [ "152946533",[-86.13334920075546, 41.666959431424196]],
    [ "Bavarian Substation",[-84.651812467202, 38.86483664909819]],
    [ "Merom Station",[-87.51161135442244, 39.06565420952452]],
    [ "Booneville Substation",[-87.25811045000002, 38.04047885]],
    [ "Trimble County Station",[-85.408538108587, 38.58242338041434]],
    [ "Tri-State Substation",[-82.53193042179325, 38.35189505601312]],
    [ "Stuart Substation",[-80.26240692591358, 36.63711989461276]],
    [ "AEP Grant Substation",[-85.71306530000001, 40.5611477]],
    [ "Kokomo Highland Park Substation",[-86.14951065387568, 40.466306445959205]],
    [ "Wabash Substation",[-85.81764768250767, 40.78831511618884]],
    [ "153129477",[-85.63905989999999, 40.62079165]],
    [ "153129478",[-85.95744615, 40.46615695]],
    [ "Dequine Substation",[-87.01458493728109, 40.46908229808692]],
    [ "Reynolds Substation",[-86.86733447310365, 40.7712510959357]],
    [ "Duke Energy Attica Substation",[-87.2207598751415, 40.281931753177915]],
    [ "Eugene Substation",[-87.5009546, 39.94246585]],
    [ "PSI Energy Inc",[-86.99677374999999, 40.44315965]],
    [ "Monticello Substation",[-86.76817119999998, 40.752703849999996]],
    [ "Kokomo Webster Street Substation",[-86.13695643312876, 40.52088738906872]],
    [ "153230200",[-86.07837168844165, 40.499739330232586]],
    [ "153282228",[-79.71588074780436, 36.517362284560924]],
    [ "Motley Tie Substation",[-79.71953761455835, 36.49580593583145]],
    [ "Lycoming Substation",[-77.01739223414867, 41.22167154247195]],
    [ "Williamsport Substation",[-77.00681545713947, 41.23626997784935]],
    [ "Collier Substation",[-112.29055498541557, 33.46262716089858]],
    [ "Mariosa Delta Substation",[-92.03590447847203, 38.5500271539265]],
    [ "SRP",[-112.28417533088977, 33.405832547638916]],
    [ "Centerville Substation",[-76.02310317739193, 39.02722870700319]],
    [ "Sayreville Converter Station",[-74.3531589078744, 40.473938527085686]],
    [ "Pinal West Substation",[-112.19644786619759, 32.997341430427795]],
    [ "Oakdale Substation",[-120.84488589671453, 37.73490347755548]],
    [ "Cemetery Substation",[-103.26163463410516, 44.06060737341321]],
    [ "Tat Momoli Substation",[-111.79474601275248, 32.62530147621721]],
    [ "Walnut Substation",[-120.90632512811911, 37.489896626091486]],
    [ "SRP Dinosaur Substation",[-111.51633313025673, 33.27685294337905]],
    [ "SRP Abel Substation",[-111.46877610132086, 33.150056730090434]],
    [ "Westmoreland Substation",[-123.1298491224034, 44.0398173397632]],
    [ "McReynolds Substation",[-112.12439886902874, 33.39278254635258]],
    [ "Blue Ridge Substation",[-79.79839216880028, 37.38548011419343]],
    [ "Ingersoll Rand Substation",[-79.9203279615968, 37.344433780271835]],
    [ "Lake Forest Substation",[-79.84737813230187, 37.37838164685301]],
    [ "Monterey Substation",[-79.92794727118216, 37.31601085577108]],
    [ "Progress Park Substation",[-81.00357344999999, 36.96099350000001]],
    [ "Appalachian Power Company",[-81.32529086600424, 36.873618119685446]],
    [ "Appalachian Power Company",[-81.52341752526274, 36.82355548839411]],
    [ "Celanese Substation",[-80.7680701, 37.3466]],
    [ "East River Mountain Substation",[-81.12648336339649, 37.28184093928488]],
    [ "154078221",[-80.59277292490577, 37.11702870261293]],
    [ "City of Radford",[-80.62753810000002, 37.089528599999994]],
    [ "City of Radford",[-80.58653549546251, 37.07840468258324]],
    [ "154078224",[-80.67972943303401, 37.361381748258566]],
    [ "154078227",[-80.66452395, 37.380002749999996]],
    [ "154078232",[-81.00840936786237, 37.458812191453795]],
    [ "South Bluefield Substation",[-81.22864625898717, 37.244542018143854]],
    [ "Hopkinton Substation",[-71.53747230971308, 42.17463972940934]],
    [ "Stevensonville Substation",[-76.32309441605817, 38.977706596921884]],
    [ "Goodrich Substation",[-94.96799677591315, 30.620331459593537]],
    [ "Shepherd Substation",[-94.964913971141, 30.53759757680154]],
    [ "Marathon Substation",[-81.09280072392168, 24.711148865969193]],
    [ "Capitol Hill Substation",[-104.9792263297399, 39.737318886085944]],
    [ "Hiatus Substation",[-80.29654715000001, 26.14505665]],
    [ "Springtree Substation",[-80.26724900574759, 26.179826465848492]],
    [ "Tiki Island Substation",[-94.90099936197714, 29.30424568310897]],
    [ "154645384",[-79.35322091810629, 37.524022351498274]],
    [ "Brookville Substation",[-79.20453603299164, 37.37369080523301]],
    [ "154645386",[-79.22825318531345, 37.510252545830646]],
    [ "Graves Mill Substation",[-79.23620299482108, 37.3956586398754]],
    [ "154645389",[-79.35167968116171, 37.52011512006916]],
    [ "Aberdeen Substation FPL",[-80.14492110986298, 26.564136376047085]],
    [ "154746736",[-112.6662383760822, 33.04327399668848]],
    [ "154820434",[-79.19230152446153, 36.94260799704798]],
    [ "Virginia Electric and Power Company",[-79.27594018277793, 37.117736829135936]],
    [ "154820437",[-79.38764946240119, 36.84946907684858]],
    [ "Gretna Substation",[-79.36244659796623, 36.93686901494102]],
    [ "154820441",[-79.47062834247428, 36.84789015034573]],
    [ "Parsons Street Substation",[-98.47948910233283, 29.41213777444331]],
    [ "Bath",[-77.27163460377021, 42.31612040661013]],
    [ "Cypress Substation",[-94.25720251691962, 30.30363408140458]],
    [ "154936769",[-121.46996716710407, 39.72351408718355]],
    [ "154936774",[-121.40965760000002, 39.8264384]],
    [ "Danville Utilities",[-79.31369432615966, 36.60464401113367]],
    [ "Danville Utilities",[-79.3475933620808, 36.603964979537025]],
    [ "Banister Substation",[-79.4062217578883, 36.75049025913741]],
    [ "154959112",[-79.33829779718954, 36.602539171836696]],
    [ "154959498",[-79.3639299, 36.61019745000001]],
    [ "44 Substation",[-73.13601580535337, 44.458930307079484]],
    [ "Court Substation",[-74.82911348908361, 39.08881421286223]],
    [ "City of Salem",[-80.05657265959867, 37.28126347392117]],
    [ "City of Salem",[-80.07034714999998, 37.289755299999996]],
    [ "City of Salem",[-80.09827900141464, 37.28249002634606]],
    [ "Sunscape Substation",[-79.9848674433555, 37.229621476105365]],
    [ "Grand Terminal Substation",[-112.10604464996617, 33.47351510253108]],
    [ "Eagle Creek Substation",[-98.2538650014985, 29.224816047051732]],
    [ "Woodring Substation",[-97.78974763073855, 36.330715008722976]],
    [ "155236055",[-78.4449017445497, 36.57214545086671]],
    [ "155236056",[-78.55127902379083, 36.59872901709816]],
    [ "Virginia Electric and Power Company",[-78.5287068, 36.6008001]],
    [ "155236058",[-78.54710461982121, 36.600861843344525]],
    [ "155363632",[-78.37659554382333, 36.68080210795516]],
    [ "155374128",[-112.67692437495577, 33.378724540832636]],
    [ "155375377",[-77.98112618519635, 36.49279465115228]],
    [ "155375378",[-77.98173144985617, 36.49225096998442]],
    [ "155375380",[-78.0447905343593, 36.512326263336575]],
    [ "155375381",[-78.19167519210185, 36.62634662212297]],
    [ "155375382",[-77.66680734129932, 36.398912136725]],
    [ "Littleton Substation",[-77.92971445, 36.43351400000001]],
    [ "Whitakers Substation",[-77.73120646068821, 36.11530140758676]],
    [ "Woodland Substation",[-77.21589795145775, 36.337979083742034]],
    [ "155438116",[-77.6371813, 36.60111025]],
    [ "Earleys Substation",[-77.07919386525687, 36.25638620181458]],
    [ "155438124",[-77.10471737786466, 36.27416126096538]],
    [ "155457580",[-112.91557904007081, 33.49410047505978]],
    [ "Myrtle Substation",[-76.69661825000001, 36.77127875]],
    [ "Ivor Substation",[-76.89783596675046, 36.8979039009819]],
    [ "155476222",[-77.48379768816775, 36.82025912251122]],
    [ "155476228",[-77.14110908445056, 37.05831799224569]],
    [ "Waverly Substation",[-77.11458161417664, 37.02964711945651]],
    [ "Wakefield Substation",[-76.9918232181267, 36.9643871733867]],
    [ "Virginia Electric and Power Company",[-76.78182454059389, 36.82263183120019]],
    [ "Deep Creek Substation",[-76.3434534, 36.764271150000006]],
    [ "Virginia Electric and Power Company",[-76.31175309999999, 36.773722]],
    [ "155532875",[-76.29955054474777, 36.8092650135411]],
    [ "155557047",[-97.58699979590408, 36.31876152391825]],
    [ "155612406",[-79.5426839695513, 37.74971959053237]],
    [ "155612407",[-79.80867196343627, 37.65689504150837]],
    [ "Glasgow Substation",[-79.48073915000002, 37.624830599999996]],
    [ "Eagle Rock Substation",[-79.80867332304109, 37.65617747635088]],
    [ "Winfall Substation",[-76.46118852755755, 36.22266109426971]],
    [ "Tunis Substation",[-76.89342746337746, 36.37094933016599]],
    [ "155722762",[-112.16218580434362, 33.36352562895944]],
    [ "Harlan Substation",[-83.3263703078016, 36.84319541953814]],
    [ "155747577",[-84.39583205952013, 36.998247878486175]],
    [ "155747578",[-83.08855044615062, 36.837412267701254]],
    [ "155747582",[-83.11047127054256, 36.76481636508336]],
    [ "West Garrard Substation",[-84.62631472083041, 37.63670813183989]],
    [ "Cooper Substation",[-84.53804833714068, 37.04628704506946]],
    [ "155763224",[-83.40396327130416, 39.52751072339014]],
    [ "155765652",[-83.47167176106764, 39.529337378443266]],
    [ "Northeastern (345kv)",[-95.70419184725336, 36.4265869700732]],
    [ "Northeastern (138kv)",[-95.7037087721496, 36.43143663673188]],
    [ "Delaware Substation",[-95.62825548982906, 36.813154248804864]],
    [ "Rocky Creek Substation",[-97.43995890337924, 32.59566441277693]],
    [ "Dix Dam Substation",[-84.7036536, 37.7871498]],
    [ "155925561",[-84.71664096609815, 37.79344764722867]],
    [ "155925562",[-84.7074952834121, 37.78638375695921]],
    [ "Kentucky Utilities Company",[-84.64700317472152, 38.043207885811604]],
    [ "155925589",[-84.78842254999998, 37.6431965]],
    [ "Kentucky Utilities Company",[-84.787882355895, 37.6439676691844]],
    [ "155925591",[-84.720749595268, 37.79399242304425]],
    [ "Lebanon Substation",[-85.24994834999998, 37.60488349999999]],
    [ "Marion Substation",[-85.24822485000001, 37.605119200000004]],
    [ "155925595",[-84.71360121479219, 37.78732606818642]],
    [ "155925597",[-84.61092641701629, 37.98198080361539]],
    [ "East Kentucky Power Cooperative, Inc.",[-84.86167597125801, 37.7320956907539]],
    [ "155925605",[-84.57091102459394, 37.976049464747334]],
    [ "Waveland Substation",[-84.54146425399018, 37.971053497224936]],
    [ "Hardin Substation",[-85.90239887746678, 37.66865255903665]],
    [ "Kentucky Utilities Company",[-84.62080751652451, 38.07402189475409]],
    [ "155927644",[-84.59131784626072, 37.00159861908705]],
    [ "Cooper Substation",[-84.59163431329534, 36.999380565776214]],
    [ "Dobbin Substation",[-95.7816478352278, 30.351166634209665]],
    [ "156024755",[-93.16234182183337, 44.4588427963441]],
    [ "156027452",[-94.20629783881272, 36.979236815346226]],
    [ "Singleton Substation",[-95.97327955617243, 30.661312235218517]],
    [ "156072974",[-93.91582812234161, 36.975160652760835]],
    [ "156125692",[-84.62690436754755, 37.189008700859354]],
    [ "156125695",[-84.88780120000001, 36.99384115]],
    [ "Tennessee Valley Authority",[-85.14584356666354, 36.870892008448955]],
    [ "156125697",[-84.6634217913591, 37.02077182880575]],
    [ "Kentucky Utilities Company",[-84.62576756540989, 37.190711682575504]],
    [ "Kentucky Utilities Company",[-84.07245390744337, 37.136925273944875]],
    [ "156131711",[-84.04442215, 37.1753558]],
    [ "156131712",[-84.1245612, 37.1804897]],
    [ "Kentucky Utilities Company",[-84.12069635774456, 37.176881082672594]],
    [ "156131714",[-83.83763559999998, 37.418523199999996]],
    [ "156131715",[-83.91034242910713, 37.34163681066243]],
    [ "156131716",[-84.12378935000001, 37.1795601]],
    [ "156131717",[-83.78880844749746, 37.5068370650137]],
    [ "156131718",[-83.9099218703728, 37.342494231034706]],
    [ "156131720",[-83.90978897195882, 37.342185858098574]],
    [ "156131721",[-84.16696033208987, 37.13868538391892]],
    [ "Beattyville Substation",[-83.72506818350365, 37.587497420440606]],
    [ "156131726",[-83.87067082694915, 37.847849624767456]],
    [ "156131728",[-83.86967083482784, 37.8485392770914]],
    [ "156131729",[-84.15807873309542, 36.9967121533172]],
    [ "156131730",[-84.12348005439264, 37.179995769606194]],
    [ "156254442",[-95.64860400192515, 36.70240874132421]],
    [ "156254464",[-95.6762978871078, 36.627045775224516]],
    [ "Dessau Substation",[-97.64304389226999, 30.373491339421367]],
    [ "Gilleland Creek Substation",[-97.5740888867538, 30.409970408637104]],
    [ "156269240",[-83.9467212, 37.8783891]],
    [ "East Kentucky Power Cooperative, Inc.",[-84.05264958972046, 37.88848503385109]],
    [ "156269242",[-84.08779849999999, 37.888791399999995]],
    [ "East Kentucky Power Cooperative, Inc.",[-84.1588774408481, 37.8938079066833]],
    [ "156269250",[-84.10310270961061, 37.88309983404015]],
    [ "156269253",[-83.92363772198523, 37.824543009568146]],
    [ "156269257",[-84.10526807169545, 37.88515722909209]],
    [ "156269261",[-84.26320809814744, 37.88061076856161]],
    [ "Marshalltown Substation",[-92.8617617905154, 42.04509538611027]],
    [ "Kentucky Utilities Company",[-84.55744084162627, 37.636724391398374]],
    [ "156275731",[-84.2272746740584, 37.781501256393994]],
    [ "East Kentucky Power Cooperative, Inc.",[-84.29783741856468, 37.813831837838634]],
    [ "156275737",[-84.33105650745333, 37.77563300281095]],
    [ "156275738",[-84.24952952215078, 37.74383784987138]],
    [ "Kentucky Utilities Company",[-84.40490645532911, 37.76980249412814]],
    [ "156275744",[-84.3306982553845, 37.77663248225241]],
    [ "Sandpoint",[-116.57492980713634, 48.27333782006529]],
    [ "Sumner County Substation",[-97.21278096486203, 37.30488916929854]],
    [ "Oxford Substation",[-97.21329353879482, 37.27495038084444]],
    [ "Belle Plaine Substation",[-97.20659995014638, 37.406839153716945]],
    [ "Timber Junction Substation",[-97.07657468933525, 37.359746981704525]],
    [ "156332428",[-95.93864320000002, 36.814059750000006]],
    [ "Rock Springs Substation",[-109.24310829269926, 41.630722654010135]],
    [ "Rose Hill Substation",[-97.10523249444384, 37.589431707801396]],
    [ "Weaver Substation",[-97.08106558829667, 37.675301891992504]],
    [ "Benton Substation",[-97.16896607293697, 37.791136610022136]],
    [ "29th Street Substation",[-97.19851937807697, 37.73843259587023]],
    [ "Comotara Substation",[-97.25412924844494, 37.75164219571228]],
    [ "156410859",[-83.98651717970758, 38.70126380120578]],
    [ "156410860",[-84.24210085425969, 38.834018684923834]],
    [ "156410862",[-84.35932669724527, 38.80368436728856]],
    [ "East Kentucky Power Cooperative, Inc.",[-83.86196303150216, 38.56719128443026]],
    [ "156410866",[-84.1125728273982, 37.988727204471914]],
    [ "Augusta Substation",[-83.99721598818452, 38.771984134373135]],
    [ "156419217",[-109.49057589513802, 41.53385444351966]],
    [ "Granville Substation",[-88.00813607890717, 43.13028032695136]],
    [ "Tamarack Substation",[-88.1329690750682, 43.12770789322306]],
    [ "Waukesha Substation",[-88.22430556944168, 43.02782596735319]],
    [ "Racine Substation",[-87.86823960214295, 42.70606790879247]],
    [ "Midian Substation",[-96.9239630470318, 37.82388797177133]],
    [ "Butler Substation",[-96.87711699610924, 37.808086516288185]],
    [ "Skelly Substation",[-96.86715762523468, 37.80259500636935]],
    [ "Vaughn Substation",[-96.1761657002338, 38.13469753728334]],
    [ "Enid Substation",[-97.87500487802747, 36.37023370742764]],
    [ "156523819",[-97.7568795622427, 36.37548012069603]],
    [ "156544846",[-97.70459835885158, 36.16026266611753]],
    [ "Duke Energy",[-86.50624847307621, 38.869696897151776]],
    [ "Bedford Substation (345kV)",[-86.50996196995304, 38.87079129893753]],
    [ "City of Tallahassee",[-84.23987764602467, 30.463032942605253]],
    [ "Electric Junction Substation",[-88.23349472401279, 41.79788827031564]],
    [ "156641425",[-97.90724473991382, 36.278677112383264]],
    [ "156642313",[-97.9519451090248, 36.37693128699268]],
    [ "156653038",[-86.49123139999999, 38.8515411]],
    [ "Saukville Substation",[-87.9589895077238, 43.37218954338985]],
    [ "Derby Substation",[-81.32757445808491, 28.792515116162054]],
    [ "156728624",[-109.47817518129946, 41.533282529879564]],
    [ "156796164",[-97.9072357762807, 36.10691362920404]],
    [ "156796166",[-97.90005853015172, 36.34697333122434]],
    [ "156796460",[-97.95381302011995, 36.05833192852104]],
    [ "156799007",[-97.92576999422742, 36.05868952464945]],
    [ "156799012",[-97.92662103832747, 36.05188782491479]],
    [ "156911296",[-111.99694631534233, 33.51093825423163]],
    [ "Centennial Substation",[-97.49811823511591, 37.658540664183164]],
    [ "Lin Substation",[-97.49871823745241, 37.5962699251061]],
    [ "Waco Substation",[-97.42653091660478, 37.57996215767495]],
    [ "IPL Substation",[-86.3116924581672, 39.72593722078894]],
    [ "Flat Ridge Wind Farm Substation",[-98.4592160719208, 37.36895700209029]],
    [ "Flat Ridge Substation",[-98.46059558147812, 37.31114204531251]],
    [ "156974360",[-99.32266556275228, 37.58019485976967]],
    [ "Sawyer Substation",[-98.72334259915898, 37.544108655637295]],
    [ "156979197",[-97.58889244478793, 37.61301102481632]],
    [ "156979419",[-97.7544478066092, 37.57595949857704]],
    [ "156980325",[-97.71673297665092, 37.62314293862708]],
    [ "Bentley East Substation",[-97.48757239357427, 37.89330096492252]],
    [ "Halstead South Substation",[-97.52252260025027, 38.00070775931023]],
    [ "Moundridge Substation",[-97.52997684550917, 38.16178796861546]],
    [ "Tennessee Gas Pipeline Company, L.L.C.",[-83.40120602190855, 38.28683398979168]],
    [ "Sandy Hook Substation",[-83.12508582357209, 38.08516622693838]],
    [ "157032968",[-83.29910990000002, 38.194149200000005]],
    [ "157032969",[-83.27435994999999, 38.25581125]],
    [ "157032970",[-83.7308693, 38.427046600000004]],
    [ "157032972",[-83.75515269999998, 38.49522105]],
    [ "Rodburn Substation",[-83.40964630845659, 38.20084311664927]],
    [ "157032976",[-83.75813969226331, 38.41907334561765]],
    [ "Skaggs Substation",[-82.96838483015324, 37.99749750851683]],
    [ "East Kentucky Power Cooperative, Inc.",[-83.39596105400994, 38.1906214049019]],
    [ "Florence Junction Substation",[-97.0058759345505, 38.24555533203178]],
    [ "Marathon Pipe Line LLC",[-83.75997680403357, 38.07142930714778]],
    [ "157181270",[-83.56807192496146, 38.316237643898255]],
    [ "157181272",[-83.6583938, 38.29084065]],
    [ "East Kentucky Power Cooperative, Inc.",[-83.80711803838744, 37.94746202428817]],
    [ "157181277",[-83.7623779, 38.14350085000001]],
    [ "157181280",[-83.73507597038245, 38.0628700262535]],
    [ "157181281",[-83.71183478302021, 38.14977698187352]],
    [ "East Kentucky Power Cooperative, Inc.",[-83.61243536897713, 37.96770681338434]],
    [ "Lake Reba Substation",[-84.23538102361951, 37.76581650441156]],
    [ "157188374",[-84.14340019834195, 37.74160934171555]],
    [ "157188375",[-84.01601011707758, 37.700750946557676]],
    [ "East Kentucky Power Cooperative, Inc.",[-84.85385476461275, 37.298447403835006]],
    [ "157189880",[-85.00909260912631, 37.42756443646433]],
    [ "Palm Aire Substation",[-80.18842640327661, 26.201444519534324]],
    [ "Rock Island Substation",[-80.18643797393264, 26.162022863366765]],
    [ "Reno County Substation",[-97.79069617522377, 38.11347248821547]],
    [ "Circle Substation",[-97.87131177135024, 38.09486338463314]],
    [ "Hutchinson Energy Center",[-97.87515362097201, 38.09034448661145]],
    [ "157258933",[-80.39003819999999, 37.206419049999994]],
    [ "Sandhill Substation",[-97.92140841790143, 38.14558768031111]],
    [ "Stout Substation",[-112.10814959999998, 33.7079317]],
    [ "Buffalo Substation",[-112.04122363894085, 33.65442918692416]],
    [ "North Valley Substation",[-112.08657004685367, 33.679791895889366]],
    [ "157468283",[-111.60194688531307, 33.24932231969945]],
    [ "157480015",[-88.89103721540395, 39.9166404575484]],
    [ "157488558",[-82.3380470305886, 36.91802088459764]],
    [ "ICI Substation",[-77.29209875, 37.3494739]],
    [ "Alpine Substation",[-77.28517568971843, 37.342230126430074]],
    [ "157488561",[-80.55864345, 37.181497]],
    [ "157488567",[-82.33707459187572, 36.913511982626204]],
    [ "Subestación Bayamón",[-66.14074084010556, 18.39874704770747]],
    [ "157558686",[-71.45497485, 41.701755250000005]],
    [ "Crow Creek Substation",[-104.76612808248585, 41.11809518622683]],
    [ "Subestación Aguirre",[-66.23115104630041, 17.95325156645245]],
    [ "Jobos T.C.",[-66.13948934564394, 17.96142772868834]],
    [ "Bridge Street Station",[-76.07128720623481, 43.055514049334654]],
    [ "Headson Station",[-76.07530355186391, 43.056455461064594]],
    [ "Reasnor Substation",[-93.09595905279238, 41.57229095541428]],
    [ "Angus Substation",[-119.17166950281904, 46.211079756574826]],
    [ "Kennewick Substation",[-119.119162053733, 46.197763558501876]],
    [ "Puerto Rico Electric Power Authority",[-66.05695563968763, 17.979080170648192]],
    [ "Puerto Rico Electric Power Authority",[-67.00921918255784, 18.075061216609438]],
    [ "157842495",[-88.86089430101552, 37.21331217495898]],
    [ "Green River Substation",[-87.12245664184877, 37.36408758530054]],
    [ "Shawnee Station",[-88.77679937835384, 37.148906704686205]],
    [ "Sebree Substation",[-87.50355170865336, 37.64554053508413]],
    [ "157842575",[-86.79018815921438, 37.94644484777045]],
    [ "157842576",[-86.79149645, 37.960140300000006]],
    [ "Kentucky Utilities Company",[-87.50797455944304, 37.64247382015519]],
    [ "157842578",[-86.7785405, 37.934190550000004]],
    [ "157842579",[-84.85172166688835, 38.90903190268849]],
    [ "157842580",[-87.02163870000001, 37.8083621]],
    [ "157842581",[-87.08855452124885, 37.44929221765219]],
    [ "157842583",[-86.81892300297635, 37.95394038612678]],
    [ "157842584",[-86.84355772143567, 37.948827433939464]],
    [ "Ameren",[-88.85923120980443, 37.215287070666555]],
    [ "Kentucky Utilities Company",[-86.85555350517811, 37.94593249313297]],
    [ "Tennessee Valley Authority",[-86.97670191128026, 37.25966761503235]],
    [ "West Mount Vernon Substation",[-88.96842886538293, 38.33353704769798]],
    [ "Green River Steel Substation",[-87.05422754904293, 37.79633783202221]],
    [ "Daviess County Substation",[-86.93631671962886, 37.75631125252736]],
    [ "West Frankfort East Substation",[-88.84926221504658, 37.878576621930996]],
    [ "Joppa Station",[-88.86021121468183, 37.21005687641533]],
    [ "157842610",[-87.50349618758203, 37.65610187180637]],
    [ "Elmer Smith Substation",[-87.05863385047049, 37.79352431282851]],
    [ "Butler Substation",[-92.78193253952172, 42.56357557708829]],
    [ "157962135",[-118.38603470080325, 47.132484116457206]],
    [ "157962136",[-118.38658035, 47.13303005]],
    [ "Charleston Distributing Substation",[-84.75649737028725, 35.29352792544077]],
    [ "157968772",[-118.8495739894377, 46.65877840827545]],
    [ "Skyline Substation",[-104.79811027428543, 41.188666297824675]],
    [ "Warren AFB Substation",[-104.88531011288123, 41.13604096149182]],
    [ "Twin Lakes Substation",[-93.33014127725039, 45.04520907866144]],
    [ "Happy Jack Substation",[-104.91169119120288, 41.12884296719213]],
    [ "Happy Jack Wind Substation",[-104.9954085082283, 41.14003751334286]],
    [ "Corlett Substation",[-104.91718224846721, 41.0961952115611]],
    [ "158112591",[-76.13444875, 36.83945395]],
    [ "Wilton Substation",[-94.95173217313406, 47.48643650727247]],
    [ "Cheatham Substation",[-112.18179050135738, 33.376745986422]],
    [ "Georgia Power",[-83.6563780498333, 32.77481990160827]],
    [ "Public Service Company of Oklahoma",[-95.86570480985402, 36.11144397583403]],
    [ "South Substation",[-122.33016811943278, 47.56816129987937]],
    [ "Terminal Substation",[-80.06382583611055, 26.73515922046427]],
    [ "TECO",[-82.3541478510025, 28.152776199747656]],
    [ "158454816",[-89.3394007105664, 43.0980062776331]],
    [ "Royster Substation",[-89.32080502569332, 43.08463077592008]],
    [ "158465993",[-92.48408889999999, 42.715709849999996]],
    [ "Butts Substation FPL",[-80.15292484352818, 26.358078425386317]],
    [ "158586539",[-118.33781993353861, 34.12416944892863]],
    [ "158620336",[-91.39245831826565, 42.864771387964595]],
    [ "Ontario Street Substation",[-87.63000869999998, 41.893006799999995]],
    [ "158627607",[-112.04532090538231, 33.38032664796204]],
    [ "CIPCO",[-94.75795964731118, 41.09389719864827]],
    [ "Rolling Hills Substation",[-94.77488723088882, 41.17866170569512]],
    [ "158748495",[-78.74949093603689, 43.168847781435815]],
    [ "Tennessee Valley Authority",[-89.19655007148901, 35.543091535425724]],
    [ "Tennessee Valley Authority",[-87.98369772324635, 36.02855439178741]],
    [ "Tennessee Valley Authority",[-87.98485476694019, 36.02821442177427]],
    [ "Tennessee Valley Authority",[-87.98308444540517, 36.028491983067894]],
    [ "158794218",[-87.98044150983137, 36.03702472330849]],
    [ "Military Trail Substation",[-80.11191992232467, 26.669679948773986]],
    [ "158908907",[-112.02045835049812, 33.40930076943125]],
    [ "158908908",[-112.04986576498816, 33.40533768900338]],
    [ "SRP Shannon Substation",[-111.57043439234799, 33.42288982146847]],
    [ "Tennessee Valley Authority",[-84.51658225, 35.897129050000004]],
    [ "158980793",[-84.52946912460673, 35.941741469782954]],
    [ "158980797",[-84.38966211182353, 35.94803822224164]],
    [ "Roane Substation",[-84.3885643756763, 35.94503291906648]],
    [ "159022647",[-80.83183907983647, 35.219153585036054]],
    [ "159022649",[-80.84330799019615, 35.238899811383064]],
    [ "159059036",[-81.68110014310834, 30.77498361665604]],
    [ "Kingsland Primary Substation",[-81.67249275370696, 30.795497017927417]],
    [ "OCRRA",[-76.1144436224112, 43.00485288725819]],
    [ "Rye Substation",[-94.76563956102078, 30.452467577732065]],
    [ "PG&E Substation",[-120.63489464724972, 35.261695656657366]],
    [ "159098866",[-80.72826625769477, 35.029521099079886]],
    [ "159098869",[-80.72897985734248, 35.02963521296262]],
    [ "159098876",[-80.70175563541855, 35.09759399076406]],
    [ "159098877",[-80.71029751314335, 35.12940573243576]],
    [ "159115881",[-109.5204144569897, 41.59055216203501]],
    [ "Hurricane Substation",[-117.28489253249198, 45.437371675146935]],
    [ "159201607",[-80.95209932130021, 35.42941646010116]],
    [ "159201610",[-80.986459583047, 35.35716712104303]],
    [ "Hill Country Substation",[-98.57167791595887, 29.619386231122828]],
    [ "Springfield Station",[-76.08107118380337, 43.051402269984756]],
    [ "Minoa Station",[-76.01139947538113, 43.0703078455079]],
    [ "Pebble Hill Station",[-76.06717935190456, 43.02352579783625]],
    [ "159455246",[-78.97574773453056, 34.58806819617525]],
    [ "Lee Steam Substation",[-78.08881658699454, 35.37973394407295]],
    [ "Battleboro Substation",[-77.76269699329335, 36.05216490866015]],
    [ "Richmond Substation",[-79.74641057427944, 34.84308888749548]],
    [ "Lee Substation",[-78.0949069397469, 35.377065647161125]],
    [ "159455263",[-80.16899248984315, 36.113464692300795]],
    [ "159455322",[-79.03846245, 35.591882]],
    [ "159455323",[-77.72461263342879, 36.01560145249149]],
    [ "159455324",[-79.05597755132223, 36.45336485109773]],
    [ "Edgecombe Substation",[-77.75217562223585, 36.03692757254143]],
    [ "159455327",[-78.00796230881835, 33.9445605672961]],
    [ "159455330",[-78.97629350000001, 34.59166185]],
    [ "159455332",[-81.01622274236352, 35.21669353151477]],
    [ "159455333",[-79.78244879165644, 36.176882458572514]],
    [ "159455335",[-77.5741985913275, 35.89745087515608]],
    [ "159455337",[-78.01211845, 34.332013800000006]],
    [ "Weatherspoon Plant Substation",[-78.97442843164166, 34.58945972157938]],
    [ "Pfizer",[-77.75910718132508, 36.03175244432788]],
    [ "159455340",[-79.78000073543343, 36.12487600196481]],
    [ "159455341",[-80.94441459178056, 35.237289965537485]],
    [ "159455344",[-78.99692730000001, 34.59027065]],
    [ "Marshall Steam Substation",[-80.96729239822372, 35.59658148443534]],
    [ "159455348",[-78.9606042460932, 36.4340498166999]],
    [ "Weyerhaeuser Substation",[-76.76900932199251, 35.862341405035586]],
    [ "159455351",[-78.0106335920234, 33.944328774850256]],
    [ "159455352",[-78.64189508341524, 34.64741179863431]],
    [ "159455354",[-77.98393207548949, 34.28181665781866]],
    [ "159455355",[-80.16283029999998, 36.171919]],
    [ "Dan River Steam Station Substation",[-79.71960282949678, 36.48665332929343]],
    [ "159455360",[-80.79198455544848, 35.489172238509305]],
    [ "159455366",[-81.01170007883135, 35.19146644675398]],
    [ "159455367",[-79.0132055895042, 34.617431406760225]],
    [ "Walkertown Retail Substation",[-80.1637842946113, 36.17161793264417]],
    [ "159455370",[-78.00148654820305, 33.94269637595099]],
    [ "159455373",[-79.74998066002338, 34.84206758800778]],
    [ "159455376",[-80.97641878422105, 35.35722627232708]],
    [ "159455377",[-77.53891311921353, 35.891110513971576]],
    [ "Greensboro Tie Substation",[-79.78079326332212, 36.12242134635789]],
    [ "159455381",[-79.76694171880516, 36.27961157870348]],
    [ "Grifton Substation",[-77.4418464912396, 35.3625350222824]],
    [ "159455383",[-80.985851408929, 35.23511003881492]],
    [ "Belews Creek Steam Substation",[-80.06244231436186, 36.27931377160511]],
    [ "159455386",[-79.78643974806039, 36.17985551809724]],
    [ "159455389",[-81.7470724128513, 35.22707923576526]],
    [ "Duke Energy",[-80.37554934502627, 35.70969724864109]],
    [ "159455398",[-77.98453600905462, 34.28334484067324]],
    [ "159455402",[-77.47417388109331, 35.330291143677535]],
    [ "Delco Substation",[-78.22753371911759, 34.32580428443382]],
    [ "159529040",[-78.04348927900797, 33.97373340808792]],
    [ "159529050",[-78.32881792684942, 34.038945684103574]],
    [ "159529052",[-78.04769449837491, 33.953291569939864]],
    [ "159559232",[-78.55443385918159, 35.780585217275906]],
    [ "Asheboro Substation",[-79.75516220280953, 35.72385820204232]],
    [ "159559286",[-78.94705965178728, 35.65735905532391]],
    [ "159559289",[-79.4395913918182, 35.73683035483693]],
    [ "159559296",[-78.70578170000002, 35.64567645]],
    [ "159559300",[-78.74236431352843, 35.65192211788284]],
    [ "159559304",[-79.16557949296187, 35.69950400489142]],
    [ "159559334",[-78.56964113782226, 35.73006332526413]],
    [ "159559335",[-78.91755757338372, 35.67292659887386]],
    [ "Siler City Substation",[-79.40467650539497, 35.70202585320114]],
    [ "159559347",[-78.47630590622398, 35.772577515683395]],
    [ "159559382",[-78.5777774288928, 35.66902622348742]],
    [ "159578066",[-86.96559113287381, 34.790532860920685]],
    [ "159583124",[-86.97438739675853, 34.76851599772433]],
    [ "Robinson Substation",[-80.15758002881176, 34.40162137275172]],
    [ "Darlington Substation",[-80.1675808, 34.417644900000006]],
    [ "159607198",[-80.16682875, 34.43043325]],
    [ "Rockingham 115kV Substation",[-79.75594922876478, 34.90483831605033]],
    [ "159607200",[-80.06558408605456, 34.442952124194704]],
    [ "159607201",[-79.87276455, 34.28174275]],
    [ "159607202",[-80.0644119497714, 34.440288483136705]],
    [ "Darlington Substation",[-79.91071783431758, 34.31856298661231]],
    [ "159607208",[-80.19860164142449, 34.41027651048211]],
    [ "159607210",[-80.1460219183639, 34.38202311725452]],
    [ "Rockingham Substation",[-79.75855237194767, 34.90389069438776]],
    [ "South Hall Substation",[-83.80262963130873, 34.21873986130229]],
    [ "159608149",[-83.71344374999998, 34.260508349999995]],
    [ "Duke Energy",[-85.49781455350985, 39.3378974284505]],
    [ "Sugar Hills Substation",[-97.01151926194116, 47.933233074873336]],
    [ "Canter A-B",[-85.4614069133706, 39.35182311862959]],
    [ "159688303",[-100.43865036405846, 48.81951777438938]],
    [ "159693328",[-99.9630790677988, 47.78174775736236]],
    [ "Rainberry Substation",[-80.19939780828197, 26.363814223825788]],
    [ "159710483",[-112.12893254483669, 33.36367303998321]],
    [ "McGrau Ford Substation",[-84.33709784905348, 34.32684257874191]],
    [ "Bull Sluice Substation",[-84.3789622255441, 33.966670745870054]],
    [ "Villa Rica Substation",[-84.85539296943081, 33.741048573749744]],
    [ "Union Substation",[-84.50947106881382, 33.55336763224911]],
    [ "Norcross Substation",[-84.2135787000544, 33.93264182777142]],
    [ "Bradley Substation",[-84.95932809556705, 35.04217422600698]],
    [ "Georgia Power",[-84.34384373777243, 33.96364342679071]],
    [ "Georgia Power",[-84.2444729, 33.9362548]],
    [ "159758314",[-84.88301196343626, 34.4849853309059]],
    [ "Georgia Power",[-84.39509790654971, 33.9661047488509]],
    [ "Mostellar Springs Substation",[-84.88243593638806, 34.38460045063675]],
    [ "Bowen Substation",[-84.92229957880969, 34.12159138439305]],
    [ "Big Shanty Substation",[-84.569134556165, 33.994423578307526]],
    [ "Morgan Falls Substation",[-84.38180181519168, 33.96776427018945]],
    [ "Georgia Power",[-84.27427002974532, 33.945428500758446]],
    [ "Georgia Power",[-84.30832851854068, 33.95328306498904]],
    [ "Los Angeles Department of Water and Power",[-118.35934089483399, 33.98916584185714]],
    [ "Windsor Hills Substation",[-118.35908597266973, 33.9960539897602]],
    [ "159760146",[-101.18887784831152, 48.21792505643621]],
    [ "South Minot Substation",[-101.31705009999999, 48.196125450000004]],
    [ "West Minot Substation",[-101.33851431381547, 48.21071357495968]],
    [ "159760154",[-101.24661692547839, 48.200681669449345]],
    [ "Mustang Substation (75)",[-120.6580680970372, 35.30402191928006]],
    [ "159762990",[-99.99798553712117, 48.352312274929595]],
    [ "Washington Substation",[-111.98855820126256, 43.46106023574027]],
    [ "159783922",[-101.2113550085759, 48.117267229287]],
    [ "159783923",[-101.2485843, 47.71725215]],
    [ "159783924",[-101.24736203001139, 47.93455341529881]],
    [ "159783928",[-81.58700321130529, 30.790161128029812]],
    [ "Klondike Substation",[-84.1245465640061, 33.63685721790206]],
    [ "O'Hara Substation",[-84.36659357408463, 33.48202079376472]],
    [ "Georgia Power",[-84.46060495, 33.484005599999996]],
    [ "159784551",[-84.52623363697793, 33.6143585686035]],
    [ "Flippen Substation",[-84.17910154713441, 33.49337645833216]],
    [ "159784553",[-84.7572824148008, 33.69827463175353]],
    [ "Georgia Power",[-83.96803879716137, 33.465934482732806]],
    [ "Singleton Substation",[-84.16717280385407, 33.9102398544655]],
    [ "Corinth Road Substation",[-84.40730869999999, 33.484229649999996]],
    [ "Chapel Hill Substation",[-84.71693416004646, 33.697881795401685]],
    [ "159784560",[-84.52379597595338, 33.58577564325955]],
    [ "Wansley Pump Station Substation",[-85.016969564448, 33.426662665522876]],
    [ "159784563",[-84.75733523316195, 33.69881116647809]],
    [ "New Georgia Substation",[-84.88348892124401, 33.80516583725525]],
    [ "159784565",[-85.0454179570892, 33.40690953925071]],
    [ "Scherer Substation",[-83.81265592216823, 33.060808707600415]],
    [ "Georgia Power",[-84.61720268790951, 33.686633846530825]],
    [ "Wansley Substation",[-85.03076826585789, 33.410951861348664]],
    [ "159784572",[-84.80540471330242, 33.70112081796619]],
    [ "Tontitown Substation",[-94.28185721245232, 36.1853122303775]],
    [ "Myers Substation",[-104.71384232997067, 41.168387850563015]],
    [ "159843958",[-102.40719840000001, 48.41105595]],
    [ "Public Service Company of Oklahoma",[-95.77858443578911, 35.99033823605048]],
    [ "159922293",[-102.91297635721652, 48.40216915197766]],
    [ "159923551",[-100.79829806737843, 47.11450431587962]],
    [ "Georgia Power",[-84.14976109176001, 33.94776617931548]],
    [ "Spout Springs Road Substation",[-83.87413910000001, 34.122423149999996]],
    [ "Georgia Power",[-84.08126650807985, 33.9666178093965]],
    [ "Georgia Power",[-84.17800004733743, 33.94073460959177]],
    [ "159933512",[-102.10436418648771, 48.67608733075446]],
    [ "Butternut Station",[-76.04411129206349, 43.04952669384349]],
    [ "159935645",[-101.8595844, 46.40332215]],
    [ "159935646",[-101.86019339209552, 46.40335608853101]],
    [ "Bison Substation",[-102.66190879999998, 45.5299733]],
    [ "Bison Substation",[-102.66301927213064, 45.53136707518889]],
    [ "159992497",[-97.50545326042257, 35.59555227163075]],
    [ "159993327",[-102.6828542608329, 46.905618188962734]],
    [ "Charlie Creek",[-103.15958224885864, 47.3420434200916]],
    [ "160010450",[-102.74148159569322, 47.35681993530675]],
    [ "160037550",[-102.84321544586872, 47.47686405956314]],
    [ "Churchill Substation",[-84.4453462995862, 42.50399404778909]],
    [ "160057276",[-82.6475029, 32.947829199999994]],
    [ "Warthen Substation",[-82.85948401373012, 33.12011725337468]],
    [ "160063147",[-95.29581862350297, 43.809499740037644]],
    [ "160065686",[-120.21283649238819, 45.675368985725044]],
    [ "Thomson Primary Substation",[-82.41422603579544, 33.45424109618579]],
    [ "Wahpeton 115kV Substation",[-96.61602722503157, 46.2964775423437]],
    [ "160100195",[-81.55808898662042, 33.238642086145504]],
    [ "Rise Substation",[-71.51691955073977, 41.80256591888017]],
    [ "Orange River Substation FPL",[-81.76897490191709, 26.672975459142194]],
    [ "Carnestown Substation",[-81.3590051, 25.907858750000003]],
    [ "160184279",[-116.37260229043744, 43.64761436296988]],
    [ "Glendale Road Substation",[-86.11360336027248, 30.73520106487038]],
    [ "Shoal River Substation",[-86.55897766471382, 30.714325243408403]],
    [ "Glendale Substation",[-86.13389215000001, 30.907900700000003]],
    [ "Coffee Springs Substation",[-86.01352436462227, 31.020693366334385]],
    [ "Brewton Switching Station",[-87.10224682482455, 31.087321358141875]],
    [ "DeFuniak Springs Switching Station",[-86.11321136106383, 30.736005425152804]],
    [ "Wye Junction Switching Station",[-87.09332490000001, 30.895448800000004]],
    [ "Shaky Joe Swamp Tap",[-85.87710075, 30.618671649999996]],
    [ "Laurel Hill Substation",[-86.51904482520352, 30.92508093510249]],
    [ "Chumuckla Substation",[-87.19011129489374, 30.779728524632986]],
    [ "Beda Substation",[-86.58232583465991, 31.05032065455271]],
    [ "Baker Switching Station",[-86.68848105823191, 30.798659700827862]],
    [ "Munson Substation",[-86.91358790037931, 30.86630401956328]],
    [ "Pittman Substation",[-85.8656189532825, 30.952351061168077]],
    [ "South Crestview Substation",[-86.56253723287391, 30.742210160534754]],
    [ "Paxton Substation",[-86.2372342723421, 30.946116659713994]],
    [ "Opp Substation",[-86.28538660254179, 31.237834051364366]],
    [ "Laguna Beach Substation",[-85.89356222579437, 30.24902775002759]],
    [ "SRP Superstition Substation",[-111.53356079327881, 33.414626669700176]],
    [ "160226896",[-158.12811815, 21.35663565]],
    [ "Deltrail Substation FPL",[-80.14645540653181, 26.476917674804643]],
    [ "Kiesters Substation",[-80.03266405422261, 41.059419873553665]],
    [ "160279387",[-95.7690396573243, 45.54316380011001]],
    [ "Morris South 115kV Substation",[-95.91186180000001, 45.576010600000004]],
    [ "Crawfordville Substation",[-84.3996407656948, 30.18516837683565]],
    [ "Duke Energy",[-82.95170216402953, 29.613302606570954]],
    [ "Fort White Substation",[-82.77961146696218, 29.953276031837397]],
    [ "160286856",[-84.43995947881979, 30.604159241982988]],
    [ "160286857",[-82.98426230000001, 29.612363649999995]],
    [ "High Springs Substation DUKE",[-82.6049743601852, 29.814348452125838]],
    [ "Perry Substation",[-83.55947505194723, 30.11875103414101]],
    [ "Vidalia Substation",[-82.40653456577401, 32.23189160804502]],
    [ "Thomaston Primary Substation",[-84.3125781713039, 32.899889167266394]],
    [ "Bonaire Primary Substation",[-83.5998013475482, 32.565285515895184]],
    [ "Rumble Road Substation",[-83.84776222492994, 32.98393585634752]],
    [ "East Vidalia Substation",[-82.38517013469608, 32.2082408200625]],
    [ "Georgia Power",[-83.57096644409195, 32.582427853090714]],
    [ "Spring Branch Substation",[-82.34086202504434, 31.873288745247503]],
    [ "Site B Substation",[-81.73957105, 33.204123]],
    [ "160308085",[-81.72710846681372, 33.2360065458482]],
    [ "160308086",[-81.64905228722724, 33.170982568280806]],
    [ "Smarr Substation",[-83.85253759999999, 32.95217795]],
    [ "Edward L. Addison Switchyard",[-84.30721262707173, 32.911207737008525]],
    [ "Union School Substation",[-82.24689586735137, 31.64502664885405]],
    [ "Robins Substation",[-83.58293200000001, 32.57922005]],
    [ "160308093",[-83.5942890816754, 32.606332144781845]],
    [ "Clark Road Substation",[-81.98175555, 33.2782112]],
    [ "160308095",[-83.85450954511413, 32.82906322087852]],
    [ "Peach Blossom",[-83.65805165000002, 32.5634738]],
    [ "Georgia Power",[-82.34949405265297, 31.935619932250155]],
    [ "160308105",[-83.77277994672949, 32.69535455539382]],
    [ "160308107",[-84.31127299375677, 32.89969043499299]],
    [ "Anchor Glass Substation",[-83.59342857917247, 32.58479413401376]],
    [ "Bonaire",[-83.59841742660672, 32.56311212261757]],
    [ "160308110",[-83.70314443778376, 32.60301290803483]],
    [ "160308113",[-83.99061692783746, 32.62481673457188]],
    [ "Pump House #1 Substation",[-81.76844887232289, 33.22432653635478]],
    [ "160308117",[-83.6220221099708, 32.554015279214155]],
    [ "Georgia Power",[-83.59265635134932, 32.60002712898746]],
    [ "160308120",[-83.61431168578412, 32.60877015316397]],
    [ "Baxley Substation",[-82.33377512739042, 31.78923308817932]],
    [ "Hatch Nuclear Plant Substation",[-82.3475833262851, 31.934466984433424]],
    [ "White Rock Substation",[-112.03567110936531, 41.455007958793004]],
    [ "160363992",[-91.62585792466709, 44.05260257668832]],
    [ "Sacramento Municipal Utility District",[-121.1682848664381, 38.65552386935916]],
    [ "160412861",[-91.28129869907539, 43.93187397502797]],
    [ "Cedar Creek II Substation",[-103.78214229707994, 40.94862550203391]],
    [ "Notrees Substation",[-102.83351316122226, 31.997621549049587]],
    [ "160420722",[-91.53170897409044, 44.06696115041272]],
    [ "Panther Creek Wind 3 Substation",[-101.13587649026951, 31.982551797155846]],
    [ "Lake Ida Substation",[-80.09088684984792, 26.46979318212907]],
    [ "Clintmoore Substation FPL",[-80.14445205, 26.40865675]],
    [ "Maxwell Substation",[-80.12363531293072, 26.408910924859757]],
    [ "Hamlet Substation FPL",[-80.13086750643309, 26.434902825026857]],
    [ "160511826",[-91.91093378241128, 44.309465708782554]],
    [ "Receiving Station G",[-118.25438280908644, 34.10943956878483]],
    [ "160550799",[-96.03412399560162, 41.1561516492779]],
    [ "Omaha Public Power District",[-96.0419299442462, 41.12583115428586]],
    [ "Wyman Hydro Substation",[-69.90293382746522, 45.07099248520009]],
    [ "Omaha Public Power District",[-95.97596248293813, 41.12241645573333]],
    [ "160564126",[-121.90335975000002, 37.341942949999996]],
    [ "Gatlinburg Substation",[-83.50780182679033, 35.723033050115035]],
    [ "Rotherwood Substation",[-82.6231625078732, 36.5530124785793]],
    [ "160599813",[-114.98201030000001, 35.79675055]],
    [ "160625568",[-91.2677970966626, 47.29069793443391]],
    [ "160643685",[-114.9018722467284, 42.84207258668144]],
    [ "160643691",[-115.01643268655579, 42.87834501734822]],
    [ "160643693",[-114.90077042421525, 42.84042206433104]],
    [ "160662136",[-104.03684195406659, 34.58847263428995]],
    [ "160662140",[-104.03574535517647, 34.58729386972765]],
    [ "Aragonne Wind Substation",[-105.00106147145418, 34.82911710106371]],
    [ "40th Street Substation DUKE",[-82.6886437444181, 27.7855329504753]],
    [ "40th Street Substation",[-82.6887529838669, 27.786910984658455]],
    [ "160668869",[-112.23410006480499, 48.50215063364367]],
    [ "160668872",[-112.23353907530905, 48.5042069778458]],
    [ "Glacier Electric Cooperative",[-112.18588390379006, 48.51129756393204]],
    [ "Bonita Springs Substation",[-81.79565548608348, 26.330422225249524]],
    [ "160691115",[-90.91231688824713, 47.53136540353412]],
    [ "Kings Bay Base Substation #1",[-81.55794417075751, 30.797376896398006]],
    [ "Kings Bay Base Substation #2",[-81.55653426367847, 30.791433144825298]],
    [ "Jacaranda Substation",[-80.25128995, 26.125029799999997]],
    [ "160765285",[-99.22908355963335, 36.43645385168699]],
    [ "Moreland",[-99.2260790055299, 36.43646432681016]],
    [ "160779059",[-77.0408136510765, 38.800563702663894]],
    [ "16th Street Substation",[-82.65448803117685, 27.772658102922566]],
    [ "Oglala Substation",[-102.72820670958566, 43.1836013810676]],
    [ "161069009",[-87.51333917859502, 39.392635993190055]],
    [ "161069027",[-87.50915193658656, 39.39491692962527]],
    [ "161134438",[-99.91963887513931, 47.862885146250655]],
    [ "161238892",[-87.3824726516888, 35.85115818283953]],
    [ "Wycliffe Substation",[-80.2229337, 26.607815499999997]],
    [ "161326680",[-100.42567012486379, 48.80781959202596]],
    [ "De Moss Substation",[-120.68625185366082, 45.51531359483575]],
    [ "161344069",[-120.5106706235199, 45.51970928726815]],
    [ "Kings Bay Base Substation #3",[-81.52571258675172, 30.801916505159337]],
    [ "Kings Bay Base Substation #4",[-81.54109566944187, 30.776109757419675]],
    [ "Duke Energy",[-82.63571208235295, 27.758150599346852]],
    [ "Canal Substation",[-80.09823901305371, 26.60942649314432]],
    [ "South Marlboro Substation",[-71.54770185704344, 42.33380409720625]],
    [ "Marlboro Substation",[-71.54728041756668, 42.343070147543955]],
    [ "161619816",[-73.69841070648347, 42.67581801365476]],
    [ "Heaton Substation",[-75.11771870860626, 40.15972875780148]],
    [ "West Landing Substation",[-76.03648126306082, 36.68958437117266]],
    [ "London Bridge Substation",[-76.01967431249906, 36.77192426890586]],
    [ "161721871",[-77.94841325769252, 35.81189224951021]],
    [ "161721876",[-78.377048, 35.7716217]],
    [ "161721877",[-77.99419696052749, 35.773667025395255]],
    [ "161721878",[-78.89415322092074, 36.484199782012766]],
    [ "161721879",[-77.99747701804004, 35.74667135227985]],
    [ "Firehole Substation",[-109.27280502589086, 41.53688592158745]],
    [ "161731203",[-78.54589527155274, 35.39581879202013]],
    [ "161731204",[-78.65623607909535, 35.33472994554528]],
    [ "161731205",[-78.30420621015575, 35.53925929484351]],
    [ "161731206",[-78.343712, 35.567205099999995]],
    [ "161731207",[-78.77279750684842, 35.570624626622305]],
    [ "161731210",[-78.71151755675682, 35.41150859824204]],
    [ "161731211",[-78.3390389105149, 35.477286761582555]],
    [ "161731214",[-78.74716370265574, 35.50718038825015]],
    [ "Erwin Substation",[-78.65839308482806, 35.33700432916077]],
    [ "161731219",[-78.83779123617921, 35.57632752604135]],
    [ "161761243",[-78.10965853683797, 35.43618908308137]],
    [ "Fraser Substation",[-74.99830952186946, 42.2557818197658]],
    [ "161923369",[-77.72560940237759, 35.399895918638165]],
    [ "161923370",[-81.09036069999998, 34.925811949999996]],
    [ "161923371",[-77.53776905, 35.3760302]],
    [ "161923372",[-80.38105704643158, 35.21938593149594]],
    [ "161923374",[-80.95090770908669, 34.97987893148406]],
    [ "161923375",[-77.92512735, 35.41880429999999]],
    [ "161923376",[-77.62045997299481, 35.3899202355852]],
    [ "161923378",[-80.57568693269079, 35.107303301765164]],
    [ "161923390",[-81.06247626962087, 34.91348717444482]],
    [ "161923391",[-81.07678728707882, 34.945716363501475]],
    [ "Oakboro Tie Substation",[-80.33822287785861, 35.21905698244324]],
    [ "Greenacres Substation",[-80.11396997449103, 26.61689006061122]],
    [ "MRES Alexandria Substation",[-95.36724049060193, 45.839984659170156]],
    [ "Nokomis Substation",[-95.36645216137651, 45.87580290446188]],
    [ "162018353",[-97.26608508882093, 35.31915946003112]],
    [ "162035401",[-97.37003552575896, 35.32851003076568]],
    [ "Sammamish Substation",[-122.14977312839697, 47.68525654722905]],
    [ "162044499",[-80.99256925, 35.52249185000001]],
    [ "162044500",[-80.99231922666246, 35.52164008343743]],
    [ "Meridian Substation",[-122.74129397532087, 45.375913118251674]],
    [ "162093317",[-92.09009352711675, 43.68503305900024]],
    [ "162096439",[-97.13217497598757, 35.24867977500093]],
    [ "Elwyn Substation",[-79.9999576676104, 40.3748152064782]],
    [ "162152535",[-80.8312718772026, 35.53225494788242]],
    [ "162152536",[-80.75267889301412, 35.411928491547044]],
    [ "162152539",[-80.73728647102806, 35.48386594389594]],
    [ "162152540",[-80.73849874999999, 35.514030500000004]],
    [ "162152541",[-80.73932447434181, 35.51393924525892]],
    [ "162152548",[-80.82274184117496, 35.561651378305385]],
    [ "162152549",[-80.84077885418091, 35.567523579695795]],
    [ "162152550",[-80.7052328026149, 35.42216758354007]],
    [ "Karlstad Substation",[-96.51690883021011, 48.58720574315506]],
    [ "162165725",[-80.58107602558472, 35.49241901552037]],
    [ "162165726",[-80.4693322167694, 35.55022014891367]],
    [ "162165727",[-80.46890644999999, 35.54925780000001]],
    [ "162165728",[-80.5742667, 35.4658896]],
    [ "162173984",[-80.49434633336368, 35.6872638002207]],
    [ "162173985",[-80.45905130907413, 35.66139878614893]],
    [ "Salisbury Substation",[-80.45837700400307, 35.661794634037776]],
    [ "162173987",[-80.4722666, 35.65367325]],
    [ "162173988",[-80.50902985830636, 35.66336627854416]],
    [ "162173989",[-80.49012615, 35.6553475]],
    [ "162173990",[-80.39798459211231, 35.69520535741468]],
    [ "Products (SE) Pipe Line Corporation",[-80.50751940766949, 35.68211746629872]],
    [ "162173999",[-80.5247996202579, 35.66584759841197]],
    [ "162215842",[-80.35726782371091, 35.81492845338508]],
    [ "162215843",[-80.30037925411145, 35.924439973583084]],
    [ "162215844",[-80.32843114710052, 35.805851423306855]],
    [ "162215845",[-80.27518555, 35.962836300000006]],
    [ "162215846",[-80.32883141815117, 35.7820680484197]],
    [ "162215847",[-80.31249195824947, 35.97092732699129]],
    [ "162215848",[-80.3564263762207, 35.815034171242665]],
    [ "162215849",[-80.35799600253912, 35.80524793938137]],
    [ "162215850",[-80.30288585, 35.936079050000004]],
    [ "Duke Energy",[-80.30327765, 35.9365636]],
    [ "CPC Lexington Substation",[-80.33179018027266, 35.80679835607685]],
    [ "City of Lexington",[-80.3001956557081, 35.95448102737133]],
    [ "162215855",[-80.21919180046253, 36.01194179927959]],
    [ "Beckerdite Tie Substation",[-80.22223872556718, 36.01143338165873]],
    [ "King Street Substation",[-71.01219913210187, 42.736458900058786]],
    [ "West Amesbury Substation",[-70.97242300362346, 42.83294935001576]],
    [ "Global Foundries Station",[-73.75709209999998, 42.97337689999999]],
    [ "162320148",[-73.78039099092426, 42.960661287124815]],
    [ "162320150",[-80.29248999119616, 36.02937472650693]],
    [ "162320151",[-80.36474997753072, 36.276601209270865]],
    [ "162320152",[-80.55654694507038, 36.432937863666055]],
    [ "162320154",[-80.43965763244601, 36.33053982102457]],
    [ "Winston Tie Substation",[-80.24503895105802, 36.078454968457756]],
    [ "162320162",[-80.59827927580943, 36.48065968445515]],
    [ "Mitchell River Tie Substation",[-80.7829277725115, 36.261475155648306]],
    [ "162320169",[-80.30132439762694, 36.16860357349412]],
    [ "162320178",[-80.63693669816145, 36.14320303351871]],
    [ "162320179",[-80.30287915000001, 36.248694650000004]],
    [ "162320180",[-80.18447627525646, 36.28982023551209]],
    [ "162320181",[-80.65178529999999, 36.14311345]],
    [ "162320182",[-80.29909758827442, 36.181002473394464]],
    [ "162320183",[-80.65658113491652, 36.14081301817625]],
    [ "162320184",[-80.39787424999999, 35.98104085]],
    [ "162320185",[-80.69214434999999, 36.205178200000006]],
    [ "RJ Reynolds Tobacco Company",[-80.18609050157944, 36.2875260814594]],
    [ "162320187",[-80.64990390000001, 36.1387093]],
    [ "Key Street Substation",[-80.4756083074851, 36.38044236218573]],
    [ "162320190",[-80.78472360243323, 36.26202968252183]],
    [ "162320191",[-80.52385963274111, 36.41410209739846]],
    [ "162320192",[-80.32656135, 36.23713155000001]],
    [ "162320194",[-80.63318158452282, 36.1259883323767]],
    [ "Duke Energy",[-80.36985034711233, 36.00200909953173]],
    [ "162320196",[-80.3628192, 36.246882799999995]],
    [ "162320203",[-80.64519286970477, 36.495535201812075]],
    [ "162320207",[-80.25586305998783, 36.03887049910869]],
    [ "162320209",[-80.55452801959467, 36.43130631104482]],
    [ "Walnut Cove Tie Substation",[-80.14045872255167, 36.29331314176825]],
    [ "162320214",[-80.33437558439546, 36.03383405611579]],
    [ "162320216",[-80.60337795695884, 36.50716836972587]],
    [ "162320219",[-80.63002836151304, 36.44947553693101]],
    [ "162320221",[-80.29512772484993, 36.20795442679008]],
    [ "Madison Tie Substation",[-79.95343854999999, 36.405867099999995]],
    [ "162324595",[-80.02411105, 36.333954950000006]],
    [ "Dan Valley Retail Substation",[-79.93155447848287, 36.41482984658875]],
    [ "Unifi Madison Substation",[-79.99005695895089, 36.40832087720713]],
    [ "162324599",[-79.95655143041756, 36.37719720646261]],
    [ "Kobe Copper Products, Inc.",[-80.04507385060812, 36.341173740516076]],
    [ "Madison Retail Substation",[-79.95839961807111, 36.38306247697915]],
    [ "162324605",[-79.79261800832205, 36.476185587215824]],
    [ "162324606",[-80.05424993551588, 36.31217975618331]],
    [ "Steel Tap Switching Station",[-74.761734596779, 40.182991513975416]],
    [ "162329408",[-74.76087442121104, 40.180936403249135]],
    [ "162329410",[-74.74573672929387, 40.15265555810064]],
    [ "Shenango Substation",[-80.44808232022129, 41.135343725197956]],
    [ "Bithlo Substation DUKE",[-81.15108560647388, 28.567958023345525]],
    [ "Donkey Creek Substation",[-105.37176598499572, 44.28580146064517]],
    [ "Duke Energy",[-79.83298960136987, 36.330791956533886]],
    [ "Air Products & Chemicals",[-79.65433357847988, 36.33133169272469]],
    [ "162493061",[-79.6120899, 36.35320335]],
    [ "162493063",[-79.75264905, 36.3660142]],
    [ "162493066",[-79.70284235975208, 36.434707772047624]],
    [ "Sadler Tie Substation",[-79.63546114482794, 36.39029128275498]],
    [ "162493070",[-79.63317668106085, 36.38974355440088]],
    [ "162493090",[-79.5426520556019, 36.25360767894006]],
    [ "162493091",[-79.57014538814855, 36.292696468048206]],
    [ "162493092",[-79.6599564360678, 36.34665911530561]],
    [ "162493093",[-79.74907303434087, 36.39024350687265]],
    [ "162511252",[-79.80234915633977, 36.08337501695863]],
    [ "162511258",[-79.76911524999998, 36.10564895]],
    [ "162511259",[-79.76739200061276, 36.105750790240734]],
    [ "162511260",[-79.73346939289868, 36.089490319075914]],
    [ "162511261",[-79.73366805994682, 36.10746982328833]],
    [ "162511263",[-79.8448037299745, 36.06521675600484]],
    [ "162511264",[-79.85399415814976, 36.06294346146258]],
    [ "162511265",[-79.72187977578095, 36.15834126820783]],
    [ "162511266",[-79.54676093796922, 36.11664723596008]],
    [ "162511267",[-78.9312537068405, 35.874799999967344]],
    [ "High Point Tie Substation",[-79.99915427149635, 35.93493181373487]],
    [ "162530031",[-79.81288630000002, 35.893395600000005]],
    [ "162530032",[-79.93428192768276, 35.946073907895105]],
    [ "162530036",[-79.80034661115886, 35.834967251743834]],
    [ "162530037",[-79.99995392068686, 35.936592313402805]],
    [ "162530038",[-79.90260232683292, 35.92533223607201]],
    [ "Duke Energy",[-79.93323760266158, 35.86996868085119]],
    [ "162530040",[-79.82092428046496, 35.79152985707815]],
    [ "162530041",[-79.93541320924197, 35.9487908661388]],
    [ "Grand Junction Substation",[-108.41471371486372, 39.046972847897834]],
    [ "162596098",[-97.18439857151537, 35.51282923089077]],
    [ "162596104",[-97.1802211429791, 35.50769247946855]],
    [ "162596110",[-97.18461090343844, 35.51168518702736]],
    [ "162601936",[-88.27460551444048, 39.49022835695211]],
    [ "Holopaw Substation",[-81.08667287618586, 28.146095438524117]],
    [ "162603371",[-81.17823575, 28.2241762]],
    [ "162620755",[-80.1378255, 36.0006386]],
    [ "162620756",[-80.0138397, 36.01823765]],
    [ "162620758",[-79.9609438632517, 35.967483229230396]],
    [ "162620760",[-79.83501914350481, 35.99233766219162]],
    [ "162622723",[-81.12955312038659, 36.161507757673384]],
    [ "162622724",[-81.11044945772944, 36.17725217914931]],
    [ "Blue Ridge Energy",[-81.36752180532088, 36.308597212906925]],
    [ "162622729",[-81.05085635728848, 36.17320867166376]],
    [ "162622730",[-81.03472147296468, 36.19992147700818]],
    [ "Blue Ridge Energy",[-81.36919544550648, 36.30800656868966]],
    [ "Teckla Substation",[-105.36554677386766, 43.56238515587726]],
    [ "Alma Substation",[-106.04749013320574, 39.26788647384062]],
    [ "162639724",[-80.81847403808676, 36.22108561351082]],
    [ "Hopkins Substation",[-107.19180162613645, 39.48569103274206]],
    [ "Old Settlers Substation",[-91.60976782667859, 42.04080985706283]],
    [ "MidAmerican Energy",[-91.55815317964407, 41.66180238636577]],
    [ "Adirondack Substation",[-75.31990278630747, 43.922010464907835]],
    [ "Yampa Valley Electric",[-106.96315644926426, 40.30254664495249]],
    [ "Yampa Valley Electric",[-106.96257145941715, 40.30250592824582]],
    [ "Yampa Valley Electric",[-106.96310172789333, 40.30303469480481]],
    [ "Foidel Creek substation",[-107.04231727311837, 40.370266067041364]],
    [ "162810632",[-78.98254678176434, 35.156995965425324]],
    [ "162810640",[-78.99437203905828, 35.214819024318345]],
    [ "162810641",[-78.4313690433161, 34.73858771666038]],
    [ "Fayetteville Public Works",[-79.02982058689149, 35.03882019684539]],
    [ "162810643",[-78.99561827732008, 35.19673095773482]],
    [ "162810644",[-79.02213264496147, 35.06828120358236]],
    [ "162810646",[-78.43233639999998, 34.73768514999999]],
    [ "162810647",[-79.01459663404422, 35.41514015610501]],
    [ "162810648",[-78.99443935, 35.213696]],
    [ "162810651",[-78.99735559154081, 35.32417495691916]],
    [ "162810652",[-78.26387617443466, 34.42344960951631]],
    [ "ThermoFisher Substation",[-79.59693979438018, 34.216133897006785]],
    [ "Raynham Substation",[-71.05404536395727, 41.90764407462053]],
    [ "EMI Dighton Power Substation",[-71.12687968041529, 41.83139325024078]],
    [ "Taunton Tap",[-71.09716622157698, 41.85794298837969]],
    [ "West Haverstraw Substation",[-73.99424207357859, 41.20151502916485]],
    [ "Gore Pass Substation",[-106.43688955073162, 40.11128566658647]],
    [ "Yampa Valley Electric",[-106.95516257507634, 40.2841823414077]],
    [ "162904958",[-80.3094308, 25.966908399999998]],
    [ "Whittenton Junction Substation",[-71.11586441728835, 41.91869252516207]],
    [ "Collbran Substation",[-108.04837233352099, 39.19598384137508]],
    [ "Walsenburg Substation",[-104.80009333954361, 37.61844381653045]],
    [ "Central Maine Power",[-69.62408316320747, 44.53839507321835]],
    [ "Winslow Substation",[-69.60323274210343, 44.569555724072934]],
    [ "Heywood Substation",[-69.58336317876712, 44.57447000585676]],
    [ "162931981",[-69.66900576835637, 44.52376151594606]],
    [ "UNKNOWN133029",[-69.7106281835824, 44.54882159902717]],
    [ "UNKNOWN133030",[-69.68511235230277, 44.56829915070209]],
    [ "Hunt Substation",[-114.23251594605493, 42.63273812252862]],
    [ "162935508",[-80.07962332862706, 26.530544852218846]],
    [ "162938642",[-115.09093298583116, 36.00296994597548]],
    [ "Lone Tree Substation",[-117.2309008, 40.81964115]],
    [ "Grager Substation",[-96.8837800686936, 46.85771930125834]],
    [ "Whiteville Substation",[-78.68619474178527, 34.32678846243687]],
    [ "163041619",[-78.26400285000001, 34.030167549999994]],
    [ "163041622",[-78.49419875, 33.96681785]],
    [ "163041627",[-78.80631281434202, 34.74184931623113]],
    [ "Four County EMC",[-78.80745020315025, 34.74551327891359]],
    [ "163041635",[-78.43660033518621, 33.989823936551396]],
    [ "Gonder Substation",[-114.80732376704242, 39.336550665840385]],
    [ "Beaumont Substation",[-88.920851321722, 31.177462033057566]],
    [ "Lucedale Substation",[-88.61235191779016, 30.936243279905494]],
    [ "Fort Sage Substation",[-119.97414347068081, 40.074888050528536]],
    [ "Hilltop Substation",[-120.6346949550582, 41.51283984096214]],
    [ "163145505",[-120.0042035000979, 39.65605843600161]],
    [ "Broadview Substation",[-98.58631933440778, 29.479035852790137]],
    [ "Greenlee Substation",[-109.172376086523, 32.96680157964788]],
    [ "Greenlee Substation",[-109.16919316915381, 32.97074008486104]],
    [ "163340513",[-112.78401733138173, 33.96315369244568]],
    [ "Hathaway Street Substation",[-71.15718814258153, 41.716010576974085]],
    [ "Hathaway Street Substation",[-71.15620662550026, 41.715836551729936]],
    [ "Hathaway Street Substation",[-71.15758266480508, 41.71602221559]],
    [ "163355191",[-112.60435806580307, 33.83445505547734]],
    [ "Cove Road Substation",[-79.9853570846074, 37.30390188819734]],
    [ "Public Service Company of Oklahoma",[-95.95739940634147, 36.11188162998164]],
    [ "Statesboro Primary Substation",[-81.79792160632167, 32.41306340217481]],
    [ "Treutlen Substation",[-81.3489561243785, 32.35283126414754]],
    [ "Stillmore Substation",[-82.1714404949279, 32.48660141623734]],
    [ "Addlestone Substation",[-82.04959337440046, 32.40554725114626]],
    [ "Register Substation",[-81.87945332184908, 32.41969581247351]],
    [ "Georgia Power",[-82.04812826119867, 32.4053870350339]],
    [ "Hidalgo Substation",[-108.59931987061053, 32.40363001344172]],
    [ "Vail Substation",[-110.81313460627808, 32.06998333139894]],
    [ "Winchester Substation",[-110.20403500292433, 32.19058874374978]],
    [ "Cienega Substation",[-110.72190029991647, 32.03511102558539]],
    [ "Bicknell Substation",[-111.06050231001186, 31.922120824487582]],
    [ "163670763",[-109.30799566279684, 38.16008368051463]],
    [ "163670977",[-76.81059135525385, 42.19547684905091]],
    [ "BARK RIVER",[-88.34465946023822, 43.15862281317941]],
    [ "163683054",[-112.02888569333764, 40.567424181758845]],
    [ "Luna Substation",[-107.77897822599611, 32.3028990558103]],
    [ "Deming Substation",[-107.76164403766697, 32.279172830820265]],
    [ "163732851",[-107.76182572023701, 32.28114160281098]],
    [ "Temple Station",[-76.15239716541565, 43.03958723578868]],
    [ "163759786",[-96.35207557477106, 35.82762135302772]],
    [ "Americus Primary Substation",[-84.23164743025941, 32.07995296433955]],
    [ "Fortson Substation",[-84.91566116672541, 32.6104157350653]],
    [ "Georgia Power",[-84.8212705, 32.61385945000001]],
    [ "Georgia Power",[-84.81802952380063, 32.61237685298822]],
    [ "Tazeville Substation",[-84.47691095, 32.36295835000001]],
    [ "Talbot County Energy Substation",[-84.69317529377781, 32.58885114419308]],
    [ "Warwick Substation",[-83.93879075634408, 31.820814807295058]],
    [ "163762722",[-84.33016325239595, 32.22037384655098]],
    [ "North Americus Substation",[-84.21170071323962, 32.09766966530899]],
    [ "Ashburn Substation",[-83.65270484254506, 31.694007419577513]],
    [ "163762726",[-84.1988192761307, 32.05486094289078]],
    [ "163763150",[-70.63822478375187, 44.96206789796763]],
    [ "Diablo Substation",[-106.5874506943122, 31.804857269933247]],
    [ "Newman Substation",[-106.4348108583527, 31.984161564101665]],
    [ "163831543",[-108.15513388116251, 36.52172586637256]],
    [ "Remer Substation",[-82.49056026328046, 42.772033191129125]],
    [ "163860984",[-85.99966062506742, 41.441328458227964]],
    [ "Saint Clair Substation",[-82.47462890261947, 42.76428119729958]],
    [ "Mulberry Grove Substation",[-84.9493075, 32.6712759]],
    [ "Georgia Power",[-84.06118275000001, 33.245317400000005]],
    [ "163891150",[-84.97449115472094, 32.82314828706609]],
    [ "Pine Mountain Substation",[-84.8894383, 32.88220425000001]],
    [ "Dresden Substation",[-84.90581974453728, 33.35132000332226]],
    [ "South Coweta Substation",[-84.53382605777784, 33.325681329069944]],
    [ "Tenaska Georgia Substation",[-84.99807734913573, 33.35163754738962]],
    [ "Pine Mountain Switching Station",[-84.8896146, 32.8815936]],
    [ "Transco 115 Substation",[-84.90972930000001, 33.37027035]],
    [ "Georgia Power",[-84.06085137623302, 33.22434550300109]],
    [ "Heard County Substation",[-84.99418114160957, 33.35894967790528]],
    [ "Hughstown Substation",[-75.77624760782996, 41.333128729601746]],
    [ "Calmont Substation",[-97.44932302282582, 32.734571591206105]],
    [ "Lamar HVDC Tie",[-102.528816203815, 38.20670837574441]],
    [ "Lamar Substation",[-102.52499591224917, 38.20698824154873]],
    [ "Finney Substation",[-100.97528055106035, 37.915017467002166]],
    [ "Holcomb Substation",[-100.97189297525554, 37.926391202881284]],
    [ "163982866",[-101.02936377069612, 37.95291337437309]],
    [ "163982867",[-101.02955132686269, 37.97395742042606]],
    [ "Spearville Substation",[-99.75575210774346, 37.86417771970045]],
    [ "Evergy",[-99.75339714963566, 37.86781209020386]],
    [ "Ojo Substation",[-106.15855198902273, 36.11168628731259]],
    [ "Franklin Substation",[-86.11727274268428, 35.335076892605215]],
    [ "Wartrace Substation",[-86.33560608795946, 35.52128579931219]],
    [ "AEDC Substation",[-86.05245966859263, 35.37835395114742]],
    [ "Coalmont Substation",[-85.6975732418387, 35.34561487962819]],
    [ "Wartrace Substation",[-86.33567129220675, 35.518021222174376]],
    [ "Walnut Creek Substation #5",[-83.63760055000002, 32.91526455]],
    [ "Pelham Substation",[-85.87627224933965, 35.303541125033654]],
    [ "164024557",[-86.48242790147374, 35.49326575632559]],
    [ "Palmer Substation",[-85.56516143133635, 35.33114798615615]],
    [ "Arkwight Substation",[-83.69886469244778, 32.9271308190416]],
    [ "164024560",[-86.17858402593906, 35.331634548129955]],
    [ "Arkwight Substation",[-83.72603104283542, 32.922170362769684]],
    [ "164026155",[-120.8854297712061, 44.297053003334256]],
    [ "164026156",[-120.88566848196797, 44.2976202749716]],
    [ "Puerto Rico Electric Power Authority",[-66.61211817428297, 18.000689144618526]],
    [ "Puerto Rico Electric Power Authority",[-66.59323479298496, 18.00553584934383]],
    [ "Subestación Sabana Llana II",[-65.98101465515157, 18.395253263644396]],
    [ "Arroyo Substation",[-106.7123598340771, 32.3326644932555]],
    [ "Cox Substation",[-106.71025789046807, 32.33201478273014]],
    [ "Caliente Substation",[-106.25054875526331, 31.82609251463255]],
    [ "Almaville Substation",[-86.56162201104148, 35.900442776431746]],
    [ "Christiana Substation",[-86.41265740000001, 35.7174292]],
    [ "Rutherford Substation",[-86.59841528365897, 35.82791499345539]],
    [ "164138734",[-86.33140850584577, 35.904484920574596]],
    [ "164138736",[-86.44683880590415, 35.80847189571199]],
    [ "Graham Substation",[-68.70546917322851, 44.8241844286513]],
    [ "Boggy Brook Substation",[-68.45401207012662, 44.577125982722926]],
    [ "Overton 345kV Substation",[-92.57484369571846, 38.924426361165125]],
    [ "Overton 161kV Substation",[-92.57368500112437, 38.92306565946104]],
    [ "Crossville Substation",[-85.00044495785224, 35.955154394096176]],
    [ "Peavine Switching Station",[-84.98392199266812, 35.98874292028162]],
    [ "Campbell Junction Substation",[-85.13993579695565, 36.05582256578063]],
    [ "Ellsworth Substation",[-68.45871500237554, 44.57013663782493]],
    [ "Enfield Tap",[-68.6017537756838, 45.24575284562963]],
    [ "Guadalupe Substation",[-105.01914639158588, 35.10075754996123]],
    [ "Tolk Substation",[-102.57111303987685, 34.181227913369206]],
    [ "164252422",[-103.17100646473449, 34.301735012116914]],
    [ "164252436",[-103.33800555644517, 34.30285562481737]],
    [ "Amrad Substation",[-106.13816804436809, 32.519386560518896]],
    [ "Eddy HVDC Tie",[-104.23985079661992, 32.81441376651437]],
    [ "Herndon Substation",[-119.92262247109237, 36.84477512615378]],
    [ "George Street Substation",[-79.18306750717842, 37.327307731266615]],
    [ "Substation #2",[-94.9107461832453, 38.81030774327443]],
    [ "Gentleman Substation",[-101.14724879357838, 41.081050236938786]],
    [ "Mingo Substation",[-100.92036937895509, 39.30895896875873]],
    [ "Red Willow Substation",[-100.70992638086736, 40.30337176263574]],
    [ "North Platte 115kV Substation",[-100.75850281130259, 41.08610913718961]],
    [ "164413926",[-100.81151081701444, 41.089742615217006]],
    [ "164413928",[-101.1003456, 41.08997385000001]],
    [ "North Platte 230kV Substation",[-100.75822247498157, 41.084710768837205]],
    [ "West Dover Substation",[-81.56309985493614, 40.50832227449666]],
    [ "Strasburg Substation",[-81.5390361296776, 40.59485865529807]],
    [ "Nickajack Substation",[-85.62162198947546, 35.001838168430965]],
    [ "Miller Substation",[-87.05566640432014, 33.630529640635714]],
    [ "164419157",[-87.59744920000001, 33.62961525]],
    [ "164419158",[-88.31477269999999, 33.6443371]],
    [ "Caledonia Substation",[-88.27259158748522, 33.649494258454176]],
    [ "Caledonia 500 kv Switching Yard",[-88.27196810755774, 33.648327867329904]],
    [ "Potter County Interchange",[-101.92290985000001, 35.31027865]],
    [ "Charlotte Substation",[-81.9768387641041, 26.953486437765854]],
    [ "Stonegate Substation",[-98.45491699168974, 29.679228686099602]],
    [ "Sheridan Substation",[-92.42635326046576, 34.34634346892721]],
    [ "Union Power Project Switchyard",[-92.58941886119139, 33.29695324953427]],
    [ "164475676",[-92.5952013306987, 33.28898882571078]],
    [ "El Dorado Substation",[-92.59194232043285, 33.28886515006687]],
    [ "Entergy Arkansas",[-92.33659589009777, 33.011441424716146]],
    [ "Entergy Arkansas",[-92.44303256626748, 33.096751248464116]],
    [ "164491906",[-92.21356651087892, 32.901029329022684]],
    [ "Walnut Grove Substation",[-92.07777871631748, 32.69974696005418]],
    [ "Grand Gulf Substation",[-91.04197238254578, 32.00399429523809]],
    [ "Grand Gulf Substation",[-91.04414860427705, 32.00518092026259]],
    [ "Mount Olive Substation",[-92.68746668210783, 32.57706627933196]],
    [ "McNeil Substation",[-93.22458800000001, 33.33671375]],
    [ "164551435",[-92.87692855739618, 34.435205021846436]],
    [ "Entergy Arkansas",[-92.88915348006061, 34.44074583883074]],
    [ "Entergy Arkansas",[-92.87055326669324, 34.29805356918224]],
    [ "Entergy Arkansas",[-92.82995291904147, 34.43085793575505]],
    [ "164556145",[-91.1719432771063, 30.247881503328628]],
    [ "164556150",[-92.41060605, 30.42852665]],
    [ "Wells Substation",[-92.13657681346592, 30.4480876201379]],
    [ "East Cullman Substation",[-86.74811256182997, 34.19440179479684]],
    [ "Palmerdale Substation",[-86.65686105141533, 33.72436101845715]],
    [ "164559276",[-86.90012946933601, 33.69741588715279]],
    [ "164559279",[-87.01762428948277, 33.649763373237505]],
    [ "Clay Substation",[-86.55796910395877, 33.74023657295686]],
    [ "South Bessemer Substation",[-87.06302374815928, 33.219774291096584]],
    [ "164559936",[-87.03235049999999, 33.3133519]],
    [ "164559937",[-87.05515545000002, 33.298092]],
    [ "164559938",[-86.88901531774147, 33.29218774725653]],
    [ "164559939",[-86.85877325235576, 33.33313331371022]],
    [ "Wolf Creek Substation",[-95.68747049439506, 38.243181059125206]],
    [ "Downtown Industrial Substation",[-91.66780166275687, 41.98257597493669]],
    [ "Sixth Street Substation",[-91.66714245913644, 41.986798863567074]],
    [ "Shawtown Substation",[-87.15694571889897, 33.14297087179207]],
    [ "Emporia Energy Center Substation",[-96.06506768828721, 38.444978076139826]],
    [ "La Cygne Substation",[-94.64119999841498, 38.34786245313229]],
    [ "Billingsley Substation",[-86.73265884415393, 32.6512412486709]],
    [ "Snowdoun Substation",[-86.2606169388255, 32.22915971227601]],
    [ "164658797",[-86.5266674224657, 32.30915345656893]],
    [ "Autaugaville Substation",[-86.58367947313039, 32.377791530926025]],
    [ "Autaugaville 230kV Substation",[-86.57535324862683, 32.38328002216876]],
    [ "Hyundai Substation",[-86.33034889999999, 32.28593015]],
    [ "164658818",[-86.57549143264208, 32.381017965747525]],
    [ "Farley Substation",[-85.11622520985597, 31.223758529976926]],
    [ "Raccoon Creek Substation",[-84.10698945105912, 31.36781735728717]],
    [ "Baconton Substation",[-84.08165605471233, 31.38744739019518]],
    [ "South Venice Substation",[-82.4070570312721, 27.05165565869864]],
    [ "Murdock Substation",[-82.12805441004564, 27.002590003579957]],
    [ "Coast Substation",[-82.13810740141663, 27.016758882216564]],
    [ "Jeffrey Substation",[-96.11700310966452, 39.28251209998688]],
    [ "West Emporia Substation",[-96.21137208120783, 38.38901354249716]],
    [ "West Gardner Substation",[-94.98860316081492, 38.787921916023734]],
    [ "Stilwell Substation",[-94.65343628283303, 38.78328025137738]],
    [ "Inyokern Substation",[-117.79585859668965, 35.65256601769872]],
    [ "164758880",[-117.39878380626905, 35.70003992260694]],
    [ "164758882",[-117.64727237503106, 35.36527240246851]],
    [ "Swissvale Substation",[-95.59051548257469, 38.84219302289747]],
    [ "Hoyt Substation",[-95.6791841136197, 39.27543759907611]],
    [ "A.E.S., Guayama",[-66.14940770000001, 17.9473942]],
    [ "Maunabo T.C.",[-65.90432913922089, 18.01149091454274]],
    [ "Yabucoa T.C.",[-65.85157327498219, 18.04842075539732]],
    [ "164774108",[-85.93281729798584, 34.71004131685692]],
    [ "Hanceville Switching Station",[-86.780648724808, 34.06076269483556]],
    [ "Hanceville Substation",[-86.78026615, 34.0598447]],
    [ "Albertville North Substation",[-86.23933704549097, 34.293874078641416]],
    [ "Goose Pond Substation",[-86.05922016762543, 34.59398396429686]],
    [ "Summit Substation",[-97.5407711947337, 38.72770615855609]],
    [ "Neosho 345kV Substation",[-95.11707434954347, 37.3045217655562]],
    [ "Latham Substation",[-96.56116762160731, 37.50019092732732]],
    [ "Neosho 161kV Substation",[-95.11089004287426, 37.306125204051185]],
    [ "164828352",[-97.15985971412266, 35.228728309846666]],
    [ "Bandera Road Substation",[-98.60984800215688, 29.498744735682063]],
    [ "164873481",[-97.4598129173759, 35.291435610778734]],
    [ "Georgia Power",[-82.37184912772977, 31.545933472644084]],
    [ "Georgia Power",[-82.64318755331526, 31.55255666640758]],
    [ "Georgia Power",[-82.80780881242912, 31.5389433508578]],
    [ "Eastman Primary Substation",[-83.16141729753905, 32.2133352386309]],
    [ "164880660",[-83.04518885, 32.41625665]],
    [ "Basscreek Substation",[-80.3768086, 25.991035549999996]],
    [ "164881304",[-80.36246096617297, 25.977234167125385]],
    [ "Keystone Substation",[-101.65641720464998, 41.157903462050555]],
    [ "Ogallala Substation",[-101.70942145618525, 41.10197870003199]],
    [ "164883165",[-101.7098936648154, 41.10313375451207]],
    [ "164883168",[-101.42392617504214, 41.09830534227671]],
    [ "164883169",[-101.48062295000001, 41.09822165]],
    [ "164883170",[-101.29033989170249, 41.09823502891076]],
    [ "East Webster Substation",[-71.86399435786613, 42.06636134957711]],
    [ "Lashaway Substation",[-72.07648444139289, 42.25131182059937]],
    [ "165141192",[-90.90095779790181, 46.586570151793275]],
    [ "Bayfront Substation",[-90.90154903701496, 46.58580437380128]],
    [ "Florida Power & Light",[-82.4825143112977, 27.196676264016872]],
    [ "Fredericksburg Road Substation",[-98.5598734976648, 29.502933942159213]],
    [ "Distributing Station 58",[-118.38505070000002, 33.96605615]],
    [ "Barre Substation",[-72.09899744601357, 42.391305503445494]],
    [ "Treasure Valley Substation",[-71.98496220418573, 42.32028433401805]],
    [ "165359004",[-90.2042641422437, 32.4069291288379]],
    [ "165359005",[-89.21715845000001, 33.374982700000004]],
    [ "Ackerman Substation",[-89.17724772804225, 33.32790692888838]],
    [ "165359711",[-90.460485, 32.312035]],
    [ "165359712",[-90.37137455000001, 32.3605789]],
    [ "Marathon Pipe Line LLC",[-90.40081898985613, 32.26837735800177]],
    [ "Raymond Substation",[-90.40557079999999, 32.25568695]],
    [ "165362659",[-91.35520801977442, 30.674002945044993]],
    [ "Entergy Louisiana",[-91.31329227711196, 30.454718553892153]],
    [ "165362664",[-91.37399856228576, 30.68301421730271]],
    [ "Entergy Louisiana",[-91.37125780407644, 30.673004890128492]],
    [ "Chulie Substation",[-98.47709358931012, 29.511311512358297]],
    [ "Atchison Substation",[-95.39453582093913, 40.52536262010152]],
    [ "Cooper 345kV Substation",[-95.64536553924975, 40.36048139523825]],
    [ "Nebraska City Substation",[-95.7806872207924, 40.61817172441232]],
    [ "Sheldon Substation",[-96.78623361435402, 40.559537668494215]],
    [ "Cooper 161kV Substation",[-95.64262748994577, 40.35981540711217]],
    [ "165477516",[-93.28782395126392, 30.28285020923141]],
    [ "Colonial Pipeline Company",[-92.2912293, 30.444075950000002]],
    [ "Moss Bluff Substation",[-93.23390599999998, 30.329539999999998]],
    [ "165477520",[-90.45834596967383, 29.98846084379473]],
    [ "165477521",[-93.29600566887297, 30.281889694421473]],
    [ "165477523",[-93.29046817090523, 30.282401530440495]],
    [ "103rd & Rokeby Substation",[-96.5829396837684, 40.713282607854005]],
    [ "165502301",[-117.14591768493187, 33.68753248200901]],
    [ "165502975",[-117.13748956571355, 33.597256067428965]],
    [ "Roseau County Substation",[-95.43895676740198, 48.889121204115526]],
    [ "165512222",[-95.43563897808224, 48.88996089851266]],
    [ "Ludington Substation",[-86.44142653173166, 43.88992299183517]],
    [ "MTU",[-88.55159178753607, 47.121191553643776]],
    [ "165556231",[-97.4641496547228, 35.40750875124963]],
    [ "165556237",[-97.47618823997942, 35.381208059806355]],
    [ "Pleasant Hill Substation",[-92.71377024484042, 35.24322482784389]],
    [ "Fort Smith Substation",[-94.43048082420825, 35.299919387790794]],
    [ "Massard Substation",[-94.33471984948552, 35.35786546733459]],
    [ "Alma Substation",[-94.22976406247585, 35.482587673385424]],
    [ "Twin Bridges Substation",[-94.28968576694153, 35.46076304818223]],
    [ "Simmons Substation",[-94.15064009322326, 35.49332335913217]],
    [ "Chambers Springs Substation",[-94.4342365822094, 36.10840803889821]],
    [ "Fayetteville Substation",[-94.1675238032205, 36.06536225090615]],
    [ "165617709",[-95.550563751837, 42.77103601777166]],
    [ "State Line Substation",[-94.4334964151121, 35.32247439320566]],
    [ "Battlefield Substation",[-94.3927420364515, 35.31571506920455]],
    [ "Arkoma Substation",[-94.42885091122588, 35.3641197609659]],
    [ "Oak Park Substation",[-94.38798900900704, 35.428848925501796]],
    [ "Park View Substation",[-94.37509375, 35.3791651]],
    [ "Third Street Substation",[-94.42656766284445, 35.39135740674741]],
    [ "Carnal Substation",[-94.38249075, 35.326835900000006]],
    [ "Cavanaugh Substation",[-94.41924319823869, 35.32320719520639]],
    [ "Belle Ave Substation",[-94.40492519856848, 35.381386133682746]],
    [ "Colony Substation",[-94.40557969999999, 35.3149629]],
    [ "South Side Substation",[-94.40873357354621, 35.342683522007675]],
    [ "Pauline Substation",[-98.35559067476112, 40.40632568091719]],
    [ "North DC-Tie",[-99.18338573681798, 34.085103553858566]],
    [ "Lawton Eastside",[-98.31459217019687, 34.603796501334315]],
    [ "Riley Substation",[-99.14533490000002, 34.08526155]],
    [ "Comanche",[-98.32242362497944, 34.54362939428378]],
    [ "Oklaunion North Substation",[-99.18070786393525, 34.086174365581016]],
    [ "Oklaunion South Substation",[-99.1807520187168, 34.082302207966094]],
    [ "East DC-Tie",[-94.84405260128662, 33.05830324512227]],
    [ "165669468",[-94.55103386972166, 32.84931970613346]],
    [ "165669469",[-94.54936236369417, 32.84863663567073]],
    [ "Northwest Texarkana Substation",[-94.17606951145042, 33.48833261065635]],
    [ "Lime Substation",[-82.53299634923113, 27.34994827899305]],
    [ "Park Substation",[-82.46758182473714, 27.392743258921918]],
    [ "Sarasota Substation",[-82.53905368826439, 27.345627238724628]],
    [ "Booneville Substation",[-93.92071790968781, 41.50860089377812]],
    [ "165744508",[-96.4271744090545, 42.54072127066624]],
    [ "165770977",[-95.92835894999999, 42.22678289999999]],
    [ "165770987",[-96.24941967356105, 42.72850865421087]],
    [ "Distributing Station 56",[-118.36585610302217, 34.0254491903181]],
    [ "Corkscrew Substation",[-81.75432302785207, 26.450432170509096]],
    [ "Longwood Substation",[-93.99381941254728, 32.58537542636379]],
    [ "Diana Substation",[-94.69829034167918, 32.74432791190367]],
    [ "165784107",[-94.70021314663981, 32.74437528386894]],
    [ "Southwest Shreveport Substation",[-93.86462570770308, 32.404781693733234]],
    [ "165784372",[-94.984866, 42.86538099999999]],
    [ "165784377",[-95.4882106, 42.36290145]],
    [ "165784378",[-95.6543965, 43.17849795]],
    [ "165784385",[-95.17086896655998, 43.14647422077432]],
    [ "Blanchard Substation",[-93.91783631320003, 32.62455832211149]],
    [ "Oak Substation",[-93.98863528191339, 32.55873478533348]],
    [ "165788673",[-93.57248577173849, 31.142307530805034]],
    [ "165797602",[-88.20359011035968, 30.49522645901498]],
    [ "Plant Daniel Substation",[-88.55328859774951, 30.531466332693828]],
    [ "Theodore Substation",[-88.19665502354536, 30.52685310955105]],
    [ "165797605",[-88.55430541345956, 30.530397468974712]],
    [ "165797606",[-88.23640089999999, 30.57926965]],
    [ "165797607",[-88.27348820000002, 30.666030300000003]],
    [ "Entergy Louisiana",[-89.9067403646201, 30.785235839701386]],
    [ "Big Creek Substation",[-88.29443881237395, 30.69545159932876]],
    [ "Kushla Switching Station",[-88.18586984366864, 30.813792775338044]],
    [ "Nouryon Chemical Substation",[-88.01720480000002, 30.97021825]],
    [ "SSAB Substation",[-88.01019803683141, 30.940786992899362]],
    [ "Legionville Substation",[-80.22454526110579, 40.613818759697544]],
    [ "South Bainbridge Substation",[-84.48891344298143, 30.839615927993407]],
    [ "Hopewell Substation",[-80.24505573889061, 40.602650598994245]],
    [ "165844041",[-84.86126609854871, 30.70915761849529]],
    [ "Sinai Substation",[-84.9007988697781, 30.663831575703473]],
    [ "165844043",[-84.83853025, 30.69847845]],
    [ "Leander Substation",[-97.84161734749844, 30.585723060649464]],
    [ "Liberty Hill Substation",[-86.63882594999997, 34.8327835]],
    [ "Hazel Green Substation",[-86.56937010481849, 34.9412578428453]],
    [ "Cooper Marine & Timberlands Corporation",[-88.32380845251924, 34.49102646752884]],
    [ "165914380",[-88.86650375, 34.4106528]],
    [ "Pavant Substation",[-112.36257134930537, 39.15407229367082]],
    [ "NV Energy",[-119.73768429454556, 39.57160954650923]],
    [ "Florida Power & Light",[-82.35123819587272, 27.052744848502517]],
    [ "165926152",[-111.02944302762434, 39.17738826869473]],
    [ "Pont des Mouton Substation",[-92.03347431753863, 30.27309206197365]],
    [ "165928103",[-92.46488935, 30.4511117]],
    [ "Mouton Substation",[-92.10012640690124, 30.1573558114305]],
    [ "Scott Substation",[-92.11289998662171, 30.2550124661721]],
    [ "Delcambre Substation",[-91.99364597689352, 29.964382320932128]],
    [ "SLEMCO",[-91.97875089473217, 30.132817020692904]],
    [ "New Iberia Substation",[-91.8440111, 30.0324967]],
    [ "Judice Substation",[-92.1280106, 30.1565016]],
    [ "Segura Substation",[-91.88862233122396, 30.00053222207308]],
    [ "166010103",[-92.39610028784058, 30.275211152632235]],
    [ "Le Blanc Substation",[-92.0203210866995, 29.96425252679214]],
    [ "166010106",[-92.2010819, 30.1947876]],
    [ "SLEMCO",[-92.0203315, 30.06515855]],
    [ "Vatican Substation",[-92.10652178409661, 30.301244905370208]],
    [ "Morbihan Substation",[-91.77499743512182, 30.02870699127544]],
    [ "Habetz Substation",[-92.35443626000566, 30.274784510161737]],
    [ "Meaux Substation",[-92.14001539954465, 30.02024316846184]],
    [ "Erath Substation",[-92.02112222424734, 29.963274245394555]],
    [ "166010148",[-92.02765916519365, 30.14146601845766]],
    [ "166020018",[-115.01145326516833, 39.265182645078745]],
    [ "Mountain",[-88.4788119576686, 45.19169379648003]],
    [ "South Ripley Switching Station",[-79.76000431235083, 42.1965806891199]],
    [ "Omaha Public Power District",[-96.00401838604012, 41.31717698821081]],
    [ "Sweetwater Substation",[-99.28124912666975, 41.05251251099472]],
    [ "Axtell Substation",[-99.12135860726404, 40.54534275964636]],
    [ "Mississippi Power",[-89.09735199021092, 30.426993596335016]],
    [ "VBI Substation",[-94.33831362254361, 35.47207997033649]],
    [ "Arkansas Electric Cooperative Cooperation",[-94.33786427922821, 35.473116183468925]],
    [ "Van Buren Substation",[-94.33435864104102, 35.473327974608125]],
    [ "Oklahoma Gas & Electric",[-94.35178455, 35.460288950000006]],
    [ "Oklahoma Gas & Electric",[-94.4016233742369, 35.45685790624824]],
    [ "Adabell Substation",[-94.35916003944318, 35.453493626004715]],
    [ "Arkansas Valley Electric Cooperative",[-94.3512205, 35.520056149999995]],
    [ "166142995",[-79.46897048382294, 42.26156767645801]],
    [ "166149449",[-96.08801882980794, 41.169153139154105]],
    [ "Cass County Substation",[-95.96647134159475, 40.947938441527505]],
    [ "166149465",[-95.95990617103296, 41.045262078007354]],
    [ "166149469",[-96.09174169360683, 41.1256189693671]],
    [ "River Bend Substation",[-95.83152178818662, 41.172673365714004]],
    [ "MidAmerican Energy",[-95.83403170677248, 41.17624586102961]],
    [ "MidAmerican Energy",[-95.83589887402161, 41.175658094455024]],
    [ "MidAmerican Energy",[-95.83959354846066, 41.17872567137201]],
    [ "MidAmerican Energy",[-95.8374193327165, 41.176031581910735]],
    [ "166195684",[-118.57122016518727, 39.29480400060821]],
    [ "Anaconda Moly Substation",[-117.33580389790022, 38.323879071937306]],
    [ "166273600",[-117.10543454141154, 38.70708839247001]],
    [ "166364788",[-97.4267203169166, 36.524218387508824]],
    [ "Leesburg Substation",[-77.5567967844305, 39.108316842549364]],
    [ "166438808",[-97.13629170000002, 36.6351231]],
    [ "166438809",[-97.33621940026002, 36.62233407105258]],
    [ "Osage Power Plant Substation",[-97.06637824289368, 36.65478767805724]],
    [ "Highway 15 Substation",[-88.91617991841301, 30.499419795295115]],
    [ "166510328",[-116.28448633468065, 33.77347215290227]],
    [ "166510331",[-116.1965955316435, 33.742904953109715]],
    [ "166510336",[-116.25506324047817, 33.74285621732706]],
    [ "Northeast Parsons Substation",[-95.2499490224531, 37.36812359393479]],
    [ "Omaha Public Power District",[-95.96169138347499, 41.343250287439034]],
    [ "166535818",[-95.94442112904086, 41.3276158449873]],
    [ "166547988",[-96.0034728615077, 41.34300607902632]],
    [ "166549841",[-116.28705309078481, 33.797686653617674]],
    [ "Arden Substation",[-115.2133558443512, 36.00844663353817]],
    [ "Iron Mountain Substation",[-115.20823301574083, 36.322580970133195]],
    [ "Northwest Substation",[-115.33000513010063, 36.334469993502566]],
    [ "166551124",[-115.18780286698569, 36.30712301864484]],
    [ "Anthem Substation",[-115.08418724886019, 35.98230868044557]],
    [ "166551145",[-114.91631421900875, 36.34748728391856]],
    [ "Jupiter Substation",[-80.11836500000001, 26.933694199999998]],
    [ "166558495",[-94.37905205682998, 35.30510187553465]],
    [ "Oklahoma Gas & Electric",[-94.37861807528422, 35.28150679375503]],
    [ "Peculiar 345kV Substation",[-94.49490563230914, 38.74901683005312]],
    [ "George Neal South Substation",[-96.3613632716129, 42.301931645817724]],
    [ "Turf Substation",[-112.10036150716162, 33.62779613248404]],
    [ "Riverton Substation",[-94.70214386234922, 37.07304764793919]],
    [ "166622053",[-94.99596940796066, 37.237293479359195]],
    [ "166622054",[-94.81295975026849, 37.12142012067761]],
    [ "166628344",[-91.58263095157803, 40.97572489683517]],
    [ "166628346",[-91.56442262497075, 40.95947162841814]],
    [ "166649166",[-114.68038001186274, 33.61135264762497]],
    [ "166649170",[-115.43452575000002, 33.192293799999995]],
    [ "166649172",[-114.68463474837712, 33.61620769171433]],
    [ "166649174",[-115.50018112523736, 33.243181562557176]],
    [ "166649175",[-115.5011465344657, 33.24225933853298]],
    [ "166658928",[-114.88423125133723, 33.046962573754456]],
    [ "J Street Substation",[-94.42133574793066, 35.396755466862615]],
    [ "Barling Substation",[-94.32421610091652, 35.32635895422666]],
    [ "Anderson Substation",[-82.12074879203657, 28.89846473247736]],
    [ "Griffin Substation DUKE",[-82.03929402576885, 28.083221585405806]],
    [ "Holder Substation",[-82.42967265221738, 28.964768263824094]],
    [ "Belleview Substation",[-82.02375634999999, 29.0590542]],
    [ "Ross Prairie Substation",[-82.26199455665909, 29.005339308338865]],
    [ "North Zephyhills Substation",[-82.18111950814112, 28.25867166510197]],
    [ "Springdale Substation",[-82.00083994958266, 28.96854055279053]],
    [ "Crystal River Plant Substation",[-82.6988972524134, 28.960432107673814]],
    [ "Lake Ella Substation",[-81.95190006996843, 28.885989131144918]],
    [ "Maricamp Substation",[-82.08405298397847, 29.161337836118626]],
    [ "Brooksville West Substation",[-82.50061084577614, 28.527853117224943]],
    [ "Brooker Creek Substation",[-82.69484666978086, 28.14384430416483]],
    [ "Orange City Substation DUKE",[-81.29081342783905, 28.91178473978327]],
    [ "166725784",[-82.61972724502257, 28.36169511669475]],
    [ "S. L. A. C. Substation",[-122.20575975031329, 37.41576327190039]],
    [ "Bunce Creek Substation",[-82.46286735850234, 42.928693529297924]],
    [ "Smokey Hills Substation",[-98.2190349844438, 38.85886827090394]],
    [ "166736656",[-98.17061102260901, 38.89156727892395]],
    [ "West McPherson Substation",[-97.69432264478928, 38.37076870011443]],
    [ "166736659",[-98.26370285222923, 38.87588812214333]],
    [ "166740378",[-94.37792748797366, 35.431266570040385]],
    [ "Gerber Products Company",[-94.38130907546112, 35.43342414418045]],
    [ "166754939",[-119.29239957215782, 47.19789751484938]],
    [ "Whiteside Substation",[-94.33024557465029, 35.42238835655076]],
    [ "Chisholm Substation",[-97.34444531192912, 37.79221171278403]],
    [ "Callahan Substation",[-81.83935420392999, 30.571200024540005]],
    [ "West Nassau Substation",[-81.85030127232308, 30.560548389653444]],
    [ "Normandy Substation JEA",[-81.81977212642306, 30.30667337436049]],
    [ "West Lake Substation",[-81.81661708937473, 30.384148997369437]],
    [ "Firestone Substation JEA",[-81.76540922094205, 30.22328602536929]],
    [ "Northside Plant Substation",[-81.54977849780774, 30.418261960170696]],
    [ "166791288",[-81.69979000033702, 30.223277771016807]],
    [ "NAS Jacksonville Substation JEA",[-81.70027837508354, 30.22254409375632]],
    [ "Ritter Park Substation",[-81.63421512481492, 30.454800094781657]],
    [ "Biltmore Substation JEA",[-81.7634512793149, 30.347215105209763]],
    [ "Saint Johns Substation",[-81.55448926635641, 30.434352500701337]],
    [ "JAX Heights Substation JEA",[-81.81863696956052, 30.224481514275716]],
    [ "Northside Peaking Substation JEA",[-81.55484087280128, 30.421781955132086]],
    [ "Arcadia Substation",[-97.3156211402332, 35.68981876715678]],
    [ "Northwest Substation",[-97.64547102542632, 35.636385045859605]],
    [ "Spring Creek Substation",[-97.65358686147702, 35.742914447064926]],
    [ "166794403",[-97.51341056610015, 35.68856341853616]],
    [ "Seminole substation",[-96.73163631625783, 34.96606125335034]],
    [ "166800358",[-95.8489814529252, 36.418378144386416]],
    [ "Sunnyside Substation",[-97.24130621992985, 34.18557649159925]],
    [ "Pecan Creek Substation",[-95.46804537598888, 35.716732323293364]],
    [ "Bayard South Substation JEA",[-81.52811807907344, 30.145152824663327]],
    [ "Sampson Substation BES",[-81.5289462143669, 30.058155535606087]],
    [ "Appalachian Power Company",[-79.85765605, 36.73054470000001]],
    [ "Tatonga Substation",[-98.75381259631693, 35.932017710846104]],
    [ "Woodward District Substation",[-99.3685487750597, 36.31142759403233]],
    [ "Vici",[-99.18560259110743, 36.14619897942684]],
    [ "166899023",[-97.25076396580745, 35.613345479668205]],
    [ "Memorial Substation",[-97.25176735592575, 35.613990093869084]],
    [ "Warner Rd Substation CLAY",[-81.70189096977629, 29.867685205665747]],
    [ "Riverview Substation CLAY",[-81.66326586933829, 29.715255469532252]],
    [ "Putnam Plant 230KV Substation",[-81.58580772047166, 29.62998542269927]],
    [ "Georgia Pacific Corp (GPC) Substation",[-81.67661691152803, 29.676979432392436]],
    [ "Putnam Plant Substation",[-81.58669926218192, 29.631906120062784]],
    [ "Boulevard Substation CLAY",[-81.72263495441639, 29.93992144832658]],
    [ "Springbank Substation FPL",[-81.74501218519372, 29.972767900977498]],
    [ "Florahome Substation #31 CLAY",[-81.88895844649264, 29.747507478421443]],
    [ "Putnam Substation",[-81.58935337299495, 29.629826084465524]],
    [ "166902891",[-96.92299219323004, 35.13058059787813]],
    [ "Orange Camp Substation",[-81.27576625313262, 28.985173635292472]],
    [ "Virginia Electric and Power Company",[-78.46320275000001, 37.322075250000005]],
    [ "166905100",[-78.92512542942956, 36.83209104486528]],
    [ "Perth Substation",[-79.00378361027526, 37.01324772080831]],
    [ "166905104",[-78.64458264999999, 37.194044149999996]],
    [ "166905105",[-78.4485536, 37.42603630000001]],
    [ "Colonial Pipeline Company",[-78.47893303331126, 37.448567200926384]],
    [ "166905107",[-78.86264517694052, 36.47868883879927]],
    [ "166905108",[-78.5824461, 36.9914819]],
    [ "166905111",[-78.89102637218598, 36.26028691935891]],
    [ "166905113",[-78.42274874131526, 36.308312676526434]],
    [ "Crystal Hill Substation",[-78.9384898063313, 36.84108511744244]],
    [ "166905119",[-78.5809335637908, 36.99030963338032]],
    [ "Henderson Substation",[-78.42522316465254, 36.309636906801956]],
    [ "166905128",[-78.91337327407537, 36.490303210625335]],
    [ "Blue Lake Substation",[-81.27188922301477, 29.058310497021747]],
    [ "Mississippi Power",[-89.01135532553818, 30.406918101220295]],
    [ "Los Coches Substation",[-116.89921038745426, 32.85972274973045]],
    [ "Mission Substation",[-117.13835166221307, 32.78607421833098]],
    [ "167014165",[-78.81169239008818, 35.909524925806394]],
    [ "Dave Johnston Substation",[-105.77858791121368, 42.83717165988739]],
    [ "Windstar Substation",[-105.7794298908695, 42.861633041242015]],
    [ "Clairemont Substation",[-117.1838642000595, 32.825843911733095]],
    [ "Genesee Substation",[-117.21359128442158, 32.879621393137406]],
    [ "167141499",[-78.84742835000002, 35.84796279999999]],
    [ "167141502",[-78.84743786856436, 35.84697316959211]],
    [ "Sacramento Municipal Utility District",[-121.5060346680278, 38.481611319826406]],
    [ "Palomar Airport Substation",[-117.28790076563082, 33.12284031777178]],
    [ "Spence Substation",[-106.91851182490534, 42.62431402967128]],
    [ "Casper Substation",[-106.35976046491777, 42.87223821190247]],
    [ "Bowmont Substation",[-116.53492076034243, 43.43848930824439]],
    [ "Thermopolis Substation",[-108.22938539686443, 43.65003701555536]],
    [ "167146834",[-108.22633724973612, 43.6489070776934]],
    [ "167147530",[-78.8114414456283, 35.72520692242598]],
    [ "167147532",[-78.83997637655285, 35.71182603051081]],
    [ "167147540",[-78.82562455, 35.76202975]],
    [ "167147541",[-78.84112609999998, 35.710895]],
    [ "167147544",[-78.84164356922908, 35.819496725630096]],
    [ "167147545",[-78.89404555000002, 35.820016249999995]],
    [ "167147549",[-78.80578361218811, 35.799245971899154]],
    [ "167147550",[-78.82771340693041, 35.7504596834165]],
    [ "Stallings Road Ret",[-78.7975261491123, 35.98661800689537]],
    [ "SUMMIT",[-88.45376107584421, 43.07993014593408]],
    [ "Blue Lagoon Substation",[-80.2859745457547, 25.777199225598395]],
    [ "Lawrence Substation",[-80.22716177900418, 25.78386647833135]],
    [ "Riverside Substation",[-80.27138747586343, 25.77584052712221]],
    [ "167241712",[-116.15481834881133, 43.559212254860434]],
    [ "Pico Substation",[-117.5891940309884, 33.456803595949985]],
    [ "167272846",[-78.65423790373544, 35.90865605380328]],
    [ "167272850",[-78.57812640007784, 35.92464141950135]],
    [ "167272852",[-78.62386001069406, 35.901161877016186]],
    [ "River Rouge Substation",[-83.11305695962295, 42.27224193072745]],
    [ "167284390",[-78.31696893813043, 35.816819635996076]],
    [ "167284407",[-78.56178120000001, 35.82827275]],
    [ "167284411",[-78.56207249972702, 35.88671071134264]],
    [ "167284413",[-78.5712016582206, 35.85960500325274]],
    [ "167284671",[-115.60414943712522, 43.177282154473644]],
    [ "167285176",[-78.50456310000001, 35.7161617]],
    [ "167291893",[-116.14099316270594, 43.5255007417554]],
    [ "Brownlee Substation",[-116.89661583299609, 44.8401470353348]],
    [ "167378061",[-116.12701603722209, 43.56939352564498]],
    [ "167396769",[-102.6248356, 47.638284649999996]],
    [ "167396903",[-102.85496531437747, 47.80464312898924]],
    [ "167411211",[-78.63870471696691, 35.52887956645394]],
    [ "Fayetteville East Substation",[-78.8278264697181, 35.09889500540995]],
    [ "Southern California Edison",[-118.78470644964136, 34.1861991857312]],
    [ "Potrero Substation",[-118.83478295926382, 34.161614341620684]],
    [ "Malibu Substation",[-118.76146863792904, 34.147492460599416]],
    [ "Thousand Oaks Substation",[-118.8717323226435, 34.187484507146486]],
    [ "Clarksville Substation",[-95.54940431590626, 35.81538868277735]],
    [ "Oneta Substation",[-95.70293654348028, 36.011511892817786]],
    [ "Kiamichi Station",[-95.93217724806462, 34.68342354381833]],
    [ "Kiowa Switch",[-95.92225556145235, 34.69265565908429]],
    [ "Riverside Substation",[-95.96026702956875, 35.99674069990409]],
    [ "Riverside (345kV) Substation",[-95.94742425651123, 35.98901588005912]],
    [ "167482588",[-88.42452692436949, 39.47382904846725]],
    [ "Catoosa Substation",[-95.75374284117173, 36.17165709584022]],
    [ "Oklahoma Gas & Electric",[-95.92289021332722, 35.913465636006656]],
    [ "KSU Campus Substation",[-96.58291307229418, 39.20361522372]],
    [ "Tulsa North (138kV)",[-95.9805560656265, 36.27994316396306]],
    [ "Tulsa North (345kV)",[-95.98101141048659, 36.28247314669032]],
    [ "88th & Mingo Substation",[-95.86559319417901, 36.28206478386263]],
    [ "Mayagüez TC",[-67.14715460307976, 18.237292094229993]],
    [ "167534410",[-96.10922858865206, 34.76042806444788]],
    [ "167541166",[-93.72228528986783, 41.62903908209648]],
    [ "Cascade Substation",[-120.96904382778969, 47.20145106464106]],
    [ "Wray substation",[-102.25948393790465, 40.086159142060204]],
    [ "Guánica TC",[-66.89750336539747, 17.965947996195847]],
    [ "Añasco TC",[-67.15255268290004, 18.29847575361073]],
    [ "Bartholomew Street Substation",[-70.97447717953125, 42.50914290630736]],
    [ "Hartland Substation",[-69.47640695, 44.835916700000006]],
    [ "Colbyville Substation",[-92.04707514497547, 46.857615656416264]],
    [ "Hartburg Substation",[-93.73840120311232, 30.266105858021913]],
    [ "Gillis Substation",[-93.20084085033984, 30.330824321627723]],
    [ "Belfast Substation",[-69.03908695753782, 44.456995684486444]],
    [ "Dragon Cement Substation",[-69.15783492224301, 44.0833317591029]],
    [ "Lincolnville Substation",[-69.1141317, 44.30712175]],
    [ "Meadow Road Substation",[-69.1212853469435, 44.17545611085032]],
    [ "Park Street Substation",[-69.1226304, 44.102214149999995]],
    [ "Guilford Substation",[-69.38918145536498, 45.160222129401134]],
    [ "167678714",[-69.02086050046128, 44.429714048275194]],
    [ "Omaha Public Power District",[-96.0820349547523, 41.30621439311406]],
    [ "Livermore Falls Substation",[-70.17158246037181, 44.477968282815944]],
    [ "Oklahoma Gas & Electric",[-95.65780760165632, 35.777094403340584]],
    [ "167692511",[-106.49535170660516, 35.12638764094093]],
    [ "167698812",[-97.01671120242901, 35.710543495850935]],
    [ "Elk City Substation",[-99.39838370728609, 35.38830668455636]],
    [ "Sapulpa Road Substation",[-96.07031636443175, 36.05471835678821]],
    [ "Chaffins Substation",[-71.83890313318645, 42.33867635653824]],
    [ "Wekiwa Substation",[-96.22383910896714, 36.1599980178229]],
    [ "Pilot Knob Substation",[-93.1658038343738, 44.79773305939609]],
    [ "Minco Substation",[-98.02689364919569, 35.3006856066841]],
    [ "167709375",[-98.02865761668619, 35.30070059164672]],
    [ "Sleeping Bear",[-99.50373049603408, 36.63661633242514]],
    [ "167718161",[-98.73898432011846, 35.56548773890917]],
    [ "167718163",[-98.76933858917965, 35.48705801372042]],
    [ "Oklahoma Gas & Electric",[-94.31999672554484, 35.42213914356699]],
    [ "Oklahoma Gas & Electric",[-94.28758810000001, 35.42033515000001]],
    [ "167721805",[-98.60543985483446, 34.86591755053808]],
    [ "167721806",[-98.43270331623445, 34.81275900635131]],
    [ "167721807",[-98.44737855972073, 34.782243142494806]],
    [ "167721808",[-98.46215274358453, 34.8199063467737]],
    [ "167797293",[-106.67304298025796, 35.10428221314947]],
    [ "167823020",[-91.53764837206131, 45.98378912067317]],
    [ "Galloway Substation",[-80.33767195428408, 25.705421755150056]],
    [ "Campbell Substation",[-121.47505410931231, 38.51105100199336]],
    [ "Craven Creek Substation",[-110.32883493046752, 41.82365695289078]],
    [ "Monument Substation",[-110.03303254689861, 41.694610221963764]],
    [ "West Vaco Substation",[-109.7043648326293, 41.66673392638769]],
    [ "167925229",[-109.90335823209902, 41.68370714017108]],
    [ "167925300",[-110.34082778630025, 41.77879692554474]],
    [ "167925303",[-109.71333994058288, 41.66706644731074]],
    [ "167925304",[-110.32839712195555, 41.79373938550748]],
    [ "Fayetteville Substation",[-78.9166564344738, 35.02102441532975]],
    [ "167930690",[-78.79065077952743, 35.113588614655114]],
    [ "167930693",[-78.8705623, 35.12825085]],
    [ "Fayetteville Public Works",[-78.8918957558866, 35.131115708408316]],
    [ "167930707",[-78.91188960537158, 35.14032699350757]],
    [ "CMP Substation",[-69.77534278807563, 44.321915497278994]],
    [ "167959197",[-69.75530121440977, 44.281870429775836]],
    [ "167982881",[-93.66423312917122, 45.324248707022484]],
    [ "167998574",[-69.71211015, 44.366575]],
    [ "Central Maine Power",[-69.71516623598569, 44.45264926104581]],
    [ "167998576",[-69.64062576437742, 44.43669209600501]],
    [ "Washington County Substation",[-67.5462340849837, 44.67550127190011]],
    [ "Graham 46kV Substation",[-68.70864138918569, 44.82249434531903]],
    [ "168012291",[-68.7430443, 44.82960995]],
    [ "Emera Maine",[-68.80743958783434, 44.86254224328706]],
    [ "Graham Substation",[-68.70582866684163, 44.82293315768245]],
    [ "Emera Maine",[-68.77485842869382, 44.820912602797186]],
    [ "Bangor Hydro-Electric Company",[-68.84873745110563, 44.790778627680226]],
    [ "TUCO Interchange",[-101.8426309452394, 33.86866657144961]],
    [ "Antelope Station Switchyard",[-101.84260865, 33.86547695]],
    [ "168080402",[-81.73949819999999, 34.89909825]],
    [ "168083029",[-93.46383164999999, 44.904839249999995]],
    [ "168083839",[-81.96950145688798, 34.85222805271587]],
    [ "168083840",[-82.10967777160609, 34.90303379275944]],
    [ "Anderson Substation",[-82.66592901136401, 34.43809758363401]],
    [ "Plant X Substation",[-102.40968673159513, 34.16504134986741]],
    [ "Saticoy Substation",[-119.16667521219206, 34.30052632160325]],
    [ "Casitas Substation",[-119.3093084940449, 34.36255377210968]],
    [ "Deaf Smith Interchange",[-102.36076740162592, 34.82078979747762]],
    [ "Independence Substation",[-91.41263059392942, 35.679981253393464]],
    [ "Newark Substation",[-91.44335092330694, 35.692062613249234]],
    [ "109th & Clark Substation",[-93.76937006961839, 41.60258144468212]],
    [ "168229991",[-118.65847790451338, 34.58818822716173]],
    [ "Omaha Public Power District",[-96.17827988441319, 41.314487266057625]],
    [ "Newport Substation",[-91.2779839855356, 35.61604398189483]],
    [ "168232413",[-91.21971313689879, 35.64625998104524]],
    [ "168232415",[-90.01722286698231, 35.868648847231704]],
    [ "Arkansas Steel Substation",[-91.24383492529495, 35.64960659169746]],
    [ "168232432",[-90.02272179224192, 35.861177712907285]],
    [ "Willow Lake Substation",[-112.4544321222158, 34.60261252018692]],
    [ "Keene Road 115kV Substation",[-68.52956360755017, 45.39483797958554]],
    [ "Powersville Road Substation",[-68.578370563717, 45.61804594167207]],
    [ "Flowerfield Substation",[-73.14494450225055, 40.89385806641833]],
    [ "Stony Brook Substation",[-73.12988093889332, 40.917950390346554]],
    [ "Smithtown Substation",[-73.18723459277786, 40.86202413660411]],
    [ "Indian Head Substation",[-73.25621945206053, 40.869971515404984]],
    [ "Patchogue Substation",[-73.02031391271443, 40.761282779741144]],
    [ "Valliant Substation",[-95.05098723731413, 33.987428015007964]],
    [ "Circleville Station",[-82.95149159290112, 39.60042289537577]],
    [ "Valley Switching Station (345 kV)",[-96.37033207988833, 33.62746885772139]],
    [ "Kiowa Switching Station",[-96.35766837323213, 33.63247330590251]],
    [ "Valley Switching Station (138 kV)",[-96.36813756174847, 33.62893364720434]],
    [ "168399099",[-96.13794122900565, 41.2770195487488]],
    [ "168459088",[-112.2484936748844, 34.550178907592546]],
    [ "Chouteau Substation",[-95.25330993782408, 36.22289589758355]],
    [ "AECI",[-95.27909382473005, 36.21333000000056]],
    [ "168486278",[-95.27774455978279, 36.21316321322387]],
    [ "168486290",[-95.27491407111732, 36.22067347514941]],
    [ "168486295",[-95.27716421549506, 36.22067140229836]],
    [ "Puerto Rico Electric Power Authority",[-66.63910273968145, 18.01287995057493]],
    [ "Subestación Playa",[-66.63442302652257, 17.99480608972353]],
    [ "Cleveland (GRDA) substation",[-96.47370902847216, 36.3618695886634]],
    [ "Cleveland (AECI) substation",[-96.47281170984874, 36.3603301459718]],
    [ "168517646",[-94.94607030483651, 35.89355947920962]],
    [ "McMinn Substation",[-80.46853207509454, 25.474257342776312]],
    [ "Renaissance Substation",[-80.42865976912735, 25.457574787076314]],
    [ "168524702",[-82.95558930586063, 39.56661124818955]],
    [ "Magunden Substation",[-118.92218566574162, 35.361268094504176]],
    [ "Pastoria Substation",[-118.84297613315552, 34.93518358873976]],
    [ "Coconino Substation",[-111.65394153484941, 35.175653443702366]],
    [ "168635260",[-122.3672508805364, 47.091806887090726]],
    [ "Quartz Substation",[-117.7754393340048, 44.7174605867982]],
    [ "Ontario Substation",[-116.97803548835802, 44.05251319938561]],
    [ "Bellmore Substation",[-73.53837487015261, 40.66744227212161]],
    [ "Meadowbrook Hospital Substation",[-73.55267467439958, 40.73363775308738]],
    [ "LIRR Port Washington Substation",[-73.68627987293509, 40.82608574133506]],
    [ "Mora Substation",[-116.33549161908282, 43.506887819288465]],
    [ "168698727",[-80.7140780777787, 41.13455587914267]],
    [ "168698729",[-80.51700670277799, 41.207701100764375]],
    [ "Evergreen Substation",[-80.8150467844442, 41.210045625637505]],
    [ "168720812",[-82.9991942, 34.99819709999999]],
    [ "Thorpe Hydro Substation",[-83.12445277343734, 35.233702150896434]],
    [ "Forbes Substation",[-92.69075018746389, 47.364193121316085]],
    [ "Woodbury Substation",[-73.4826055523036, 40.8016929611329]],
    [ "Bangor Hydro-Electric Company",[-68.7891772, 44.773877]],
    [ "Marcy Substation",[-75.22262840441971, 43.17923503587094]],
    [ "Porter Station",[-75.22479100149882, 43.152989492806796]],
    [ "168765123",[-111.68850258007674, 35.10824941251095]],
    [ "168802804",[-79.47385647990919, 40.502295166936335]],
    [ "168813855",[-89.98530573344595, 40.462251224891794]],
    [ "168814137",[-78.93340761025128, 37.9156170331544]],
    [ "Cambria NUG Substation",[-78.70185619701348, 40.47436137228868]],
    [ "Conemaugh Switching Station",[-79.05904708777717, 40.389521927927674]],
    [ "Clover NUG Substation",[-78.79820075797441, 40.55129572940946]],
    [ "Cambria Slope Substation",[-78.69397041139777, 40.459597636603974]],
    [ "SRP Lewis Substation",[-111.82948158403953, 33.422701561161006]],
    [ "Seward Substation",[-79.0310818349048, 40.40663577211739]],
    [ "Hunterstown Substation",[-77.16455345542533, 39.86817959833935]],
    [ "Johnstown Substation",[-78.91608155689012, 40.403750599437835]],
    [ "Hunterstown Substation",[-77.16769079829677, 39.86876557965089]],
    [ "Homer City Station",[-79.19324130497306, 40.51717664545991]],
    [ "168903232",[-95.18185470433671, 36.22805156596368]],
    [ "Allen Substation",[-77.0549065125159, 40.1498772676791]],
    [ "Cumberland Substation",[-77.09980336036975, 40.238296241043486]],
    [ "Cly Substation",[-76.72787144846383, 40.111168991094885]],
    [ "Delta Plant Substation",[-76.30484985726011, 39.73945178291139]],
    [ "Cooper Substation",[-76.30050148834472, 39.75206758039767]],
    [ "168937751",[-118.98395870571555, 35.4514240303818]],
    [ "Arizona Public Service",[-112.13448049739326, 33.70887717054871]],
    [ "Limerick 230 kV Substation",[-75.59010912006964, 40.22555848601593]],
    [ "168946627",[-91.74331414738458, 45.410885262530186]],
    [ "Morgan Substation",[-93.62071200723754, 37.48989202304409]],
    [ "Brookline substation",[-93.37458092946659, 37.17114938620456]],
    [ "Benndale Substation",[-88.79468324868029, 30.875880866569595]],
    [ "Benndale Substation",[-88.79541610421413, 30.874318260898118]],
    [ "Cooperative Energy",[-88.80558578155838, 30.889176043139063]],
    [ "Jordan Dam Substation",[-86.26138622675589, 32.61683223702687]],
    [ "169002830",[-103.28459739136383, 47.77651104934401]],
    [ "Cielo Grande Substation",[-112.02416007047643, 33.69146248694926]],
    [ "Southwest Substation",[-93.38590337277668, 37.15228684588099]],
    [ "Dry Gulch Substation",[-117.11640515500187, 46.38083906078524]],
    [ "Wallula Substation",[-118.84588449636104, 46.06380504512879]],
    [ "169137874",[-119.22693857296925, 45.889204382947504]],
    [ "169137877",[-119.11156880588231, 45.92014197275073]],
    [ "169137879",[-118.80828015091328, 46.037399042759105]],
    [ "169137888",[-118.80638676791946, 46.037472179891544]],
    [ "Railroad Substation",[-110.98652314377689, 41.299664869869794]],
    [ "169167761",[-102.93956549999999, 47.90478615]],
    [ "169167762",[-102.89930499748753, 47.99158889510676]],
    [ "Bernardsville Substation",[-74.57424182284122, 40.71099732088717]],
    [ "Fayetteville South Substation",[-94.18747606168867, 36.04927191925016]],
    [ "Southwestern Electric Power Company",[-94.1694651095716, 36.12039515600585]],
    [ "Southwestern Electric Power Company",[-94.12671602550701, 36.073180541004724]],
    [ "Southwestern Electric Power Company",[-94.14071140928286, 36.04239977672722]],
    [ "Southwestern Electric Power Company",[-94.16387545013961, 36.09129367631798]],
    [ "Carley Road Substation",[-94.16722413300592, 36.137981212592365]],
    [ "Omaha Public Power District",[-96.02659385417947, 41.27736470049099]],
    [ "Forest Substation",[-89.46856750578361, 32.37005376583842]],
    [ "169277675",[-119.11850231737624, 46.32909827970533]],
    [ "Florida City Substation",[-80.45183281007571, 25.44709476349614]],
    [ "169286802",[-119.09755828060761, 35.37982234673198]],
    [ "169298064",[-96.17769892359271, 41.24902971274431]],
    [ "169303427",[-117.38313510680628, 48.86741943445251]],
    [ "169303430",[-117.41524617457878, 48.779591236745965]],
    [ "169312610",[-96.23593416230935, 41.305552413082786]],
    [ "169315565",[-96.23322211234418, 41.24925072515164]],
    [ "169326813",[-119.24297421111174, 37.20399233051986]],
    [ "Addy Substation",[-117.85007038188053, 48.358208701430364]],
    [ "Loon Substation",[-117.62940902625982, 48.09034070932771]],
    [ "169384600",[-117.36621595, 47.775693749999995]],
    [ "Halfmoon Substation",[-117.41022917258888, 47.838700673361075]],
    [ "Clayton Substation",[-117.56569212159363, 48.01266481522304]],
    [ "Deer Park Substation",[-117.49637960460844, 47.9596813241559]],
    [ "Rector Substation",[-119.24454176048815, 36.303840286990976]],
    [ "Vestal Substation",[-119.08499228957682, 35.84130706933588]],
    [ "Eagle Lake Substation",[-119.1906310233205, 46.68298727969831]],
    [ "Killian Substation",[-80.35444331427628, 25.660504573768215]],
    [ "Coral Reef Substation",[-80.36579682945772, 25.628440765715883]],
    [ "Shawnee Substation",[-117.26891277210746, 46.823268807072516]],
    [ "Moscow Substation",[-116.93723867695975, 46.722343935563146]],
    [ "Lolo Substation",[-116.91537667105224, 46.356899547890606]],
    [ "169507766",[-119.08822406082737, 36.90877660174421]],
    [ "Tramway Substation",[-106.49777612341316, 35.152954559156036]],
    [ "Springville Substation",[-118.93811667928567, 36.107913361704874]],
    [ "Huben Substation",[-92.7628931585192, 37.582611092750135]],
    [ "Coppermine Substation",[-119.66460103293423, 36.89578276721098]],
    [ "Milligan Substation",[-111.5669079761349, 32.732862154086774]],
    [ "Electrical District No. 4 Substation",[-111.56761320199301, 32.734612502592434]],
    [ "169671123",[-84.32793579038044, 39.46408044717414]],
    [ "169674285",[-119.48867325686395, 37.13892029646452]],
    [ "169674286",[-119.25664291594371, 37.148044808279124]],
    [ "169674289",[-119.30692882658192, 37.200152908601474]],
    [ "169674290",[-119.38854319010433, 37.14825180104351]],
    [ "169674293",[-119.55802711071979, 37.071847791510244]],
    [ "Rathdrum",[-116.87068729141244, 47.804002129581285]],
    [ "Moxee Substation",[-120.38747033414528, 46.5927251419464]],
    [ "Middletown Substation",[-75.40784390715733, 39.918124606310656]],
    [ "Pomona Heights Substation",[-120.4902167404868, 46.65050888360384]],
    [ "169789074",[-101.91225311941838, 39.23444832517614]],
    [ "Union Gap Substation",[-120.48994080886825, 46.559568288567256]],
    [ "169800229",[-119.13129227505132, 46.505355646770205]],
    [ "169806817",[-119.28590782063233, 46.349331540934344]],
    [ "169806818",[-119.28527686743301, 46.333205625110594]],
    [ "Stevens Drive Substation",[-119.28547906944907, 46.29539188913343]],
    [ "Eaton Substation",[-118.08575606890531, 34.16222827716062]],
    [ "Randolph Substation",[-118.20539156487389, 33.98268297858529]],
    [ "River Switching Station",[-118.22987886536204, 34.03762474418705]],
    [ "T. M. Goodrich Substation",[-118.08801669984538, 34.151153192887676]],
    [ "Receiving Station F",[-118.20387322337835, 34.0152031579612]],
    [ "Southern California Edison",[-118.12911459896142, 34.04569654317315]],
    [ "FPL Trace Substation",[-80.38699798878423, 26.116050468783648]],
    [ "Florida Power & Light",[-80.40247359160584, 26.059307351140806]],
    [ "169917398",[-80.20356926570486, 26.06970626755992]],
    [ "John Day Substation",[-118.98453763650926, 44.42133133118802]],
    [ "169923014",[-92.66390645, 37.592187]],
    [ "169951164",[-91.51729460721292, 37.69114329295716]],
    [ "169951186",[-91.08931694412047, 37.46975097373572]],
    [ "169951188",[-90.5628953269241, 36.66284030474115]],
    [ "169951189",[-91.0879392824934, 37.46890423596807]],
    [ "169951190",[-90.17947447730933, 36.58722573936531]],
    [ "Subestación San Sebastián",[-66.98889682159803, 18.3407011071594]],
    [ "Puerto Rico Electric Power Authority",[-66.5507871814625, 18.036526971386788]],
    [ "Brookings County Substation",[-96.52931039032293, 44.38943710056387]],
    [ "White Substation",[-96.5368475420824, 44.38671718378499]],
    [ "170005797",[-96.62693109400159, 44.49853868188646]],
    [ "170017166",[-95.14055594038894, 43.671202134650336]],
    [ "170017167",[-95.99838419860126, 42.67754524143544]],
    [ "Lakefield Junction Substation",[-95.14358923061357, 43.669991900245435]],
    [ "Greater Des Moines Energy Center Substation",[-93.52598592084702, 41.556250024147204]],
    [ "Grimes Substation",[-93.81196356306431, 41.66008487027359]],
    [ "Madison County Switching Station",[-93.90864658130589, 41.33624682374707]],
    [ "Fallow Ave Substation",[-94.60652986453022, 41.46526613331471]],
    [ "Avoca Substation",[-95.34928938737524, 41.46876487944848]],
    [ "Quick Substation",[-95.66634876446543, 41.282063632223554]],
    [ "Earlham Substation",[-94.18613900181238, 41.47607738867435]],
    [ "Yellow Cake Substation",[-105.61580408981293, 43.06974829148321]],
    [ "Antelope Mine Substation",[-105.33002528003368, 43.46221816792467]],
    [ "Duke Energy",[-105.77772055788807, 42.94653438198688]],
    [ "Pumpkin Buttes Substation",[-105.77993503600983, 43.77252275063544]],
    [ "Hollybrook Substation",[-80.2869891534245, 26.001557333835898]],
    [ "Florida Power & Light",[-80.28838722642264, 25.88325209500813]],
    [ "Florida Power & Light",[-80.3293291, 25.900675999999997]],
    [ "Perry Substation",[-80.2669594245707, 25.990913044200667]],
    [ "Country Club Substation",[-80.31960410391427, 25.942065455436577]],
    [ "170097894",[-82.96735944883216, 39.56359044229109]],
    [ "Appalachian Power Company",[-79.90217420394934, 37.454882882822154]],
    [ "170115329",[-79.9926241133768, 37.46116702371854]],
    [ "170115330",[-79.99110790909653, 37.46035382456318]],
    [ "170115331",[-79.9937842, 37.459482799999996]],
    [ "170115332",[-80.0151745, 37.4600904]],
    [ "170115333",[-80.10428586286156, 37.48732057767798]],
    [ "170115337",[-79.97212875945733, 37.44990298538033]],
    [ "170115339",[-80.11844628303163, 37.48975509046561]],
    [ "Reno Substation",[-105.40430110795236, 43.8478328661071]],
    [ "Lehigh Substation",[-94.1164604824277, 42.37134264684934]],
    [ "Webster Substation",[-94.09210118903901, 42.566265561252926]],
    [ "O'Brien Substation",[-123.68132777521717, 42.09667709167092]],
    [ "Greens Cut Substation",[-81.96840812891597, 33.19450689603155]],
    [ "Georgia Power",[-81.9540579221258, 33.3359459083694]],
    [ "Ampco Performance Products Substation",[-82.00841217632247, 33.3689681425278]],
    [ "Georgia Power",[-81.96354948744882, 33.335379792103474]],
    [ "Louisville Primary Substation",[-82.40193119822523, 33.01501808320268]],
    [ "Georgia Power",[-81.96095066812558, 33.34810780176185]],
    [ "Georgia Power",[-81.96049185604674, 33.33037441826938]],
    [ "Georgia Power",[-81.95002410000001, 33.34620315]],
    [ "Louisville Substation",[-82.4056231969986, 33.014224265801985]],
    [ "Gough Substation #9",[-82.05017638368238, 33.08901713503574]],
    [ "170166790",[-82.03004127739078, 33.41926914357867]],
    [ "Boykin Road Substation",[-82.07841475, 33.36682369999999]],
    [ "Nutrasweet Co. Substation",[-81.93829339596955, 33.42569310496272]],
    [ "Georgia Power",[-81.93504486926265, 33.44251365463313]],
    [ "South Richmond Substation",[-82.16333165, 33.33309700000001]],
    [ "Peach Orchard Switching Station",[-82.05463355328914, 33.327582807586765]],
    [ "Monsanto Peachtree Substation",[-81.94053695000001, 33.42217205]],
    [ "Georgia Power",[-82.16376949999999, 33.333380000000005]],
    [ "Meridian Brick Substation",[-81.9609096, 33.4504413]],
    [ "Georgia Power",[-81.93201335020628, 33.44250305005973]],
    [ "Rosipr Road Substation",[-82.05432825973571, 33.39942471635264]],
    [ "Tobacco Road Substation",[-82.10914559999999, 33.394946000000004]],
    [ "Georgia Power",[-81.96474842838373, 33.46077046090918]],
    [ "Barton Chapel Substation",[-82.08616691804305, 33.42449925992536]],
    [ "Georgia Power",[-81.93311259797242, 33.442630652046596]],
    [ "PCS Nitrogen Substation",[-81.93601249851753, 33.43607503966234]],
    [ "170176753",[-118.93105567006168, 46.13897688875085]],
    [ "170180122",[-107.61989838994967, 43.31080259199906]],
    [ "Riverton Substation",[-108.41116119897535, 43.01829420002021]],
    [ "170202394",[-84.16839754858562, 39.96365271370886]],
    [ "Antelope Substation",[-112.9263591275344, 43.53369083107945]],
    [ "Scoville Substation",[-112.93673677448893, 43.5374423756209]],
    [ "Anaconda Mill Creek Substation",[-112.87633209691253, 46.10451641027044]],
    [ "170263869",[-112.61441073730747, 44.0899987559184]],
    [ "170263870",[-112.97753130921448, 44.98823343140657]],
    [ "170277332",[-102.35255587514644, 48.066994003721014]],
    [ "California",[-120.00868974769827, 39.521236280574506]],
    [ "West Side Substation",[-117.50439505391121, 47.72795981961332]],
    [ "Creston Substation",[-118.50580151611186, 47.77096046912021]],
    [ "Latigo Substation",[-105.94922381848157, 42.882242725089306]],
    [ "NV Energy",[-119.86566309286434, 39.541517452276636]],
    [ "Mira Loma Substation",[-119.71746459343433, 39.45564162029313]],
    [ "Sandersville Substation #1",[-82.80190216349017, 32.998503804997775]],
    [ "Wrens Primary Substation",[-82.38065697221315, 33.23380194438981]],
    [ "Tiger Creek Substation",[-82.98158459807918, 33.09450579938893]],
    [ "Warrenton Primary Substation",[-82.68736209460222, 33.38050743967742]],
    [ "Georgia Power",[-83.07748534814124, 33.19308927691555]],
    [ "Harlee Branch Substation",[-83.29793513632211, 33.19579588940322]],
    [ "Georgia Power",[-82.94866007092199, 33.256348766296036]],
    [ "Claim Jumper Substation",[-106.3226501673997, 43.38977562681083]],
    [ "170296540",[-106.32256364999999, 43.390402650000006]],
    [ "Midwest Substation",[-106.33187020408523, 43.45003827128994]],
    [ "Kaycee Substation",[-106.55858963784505, 43.703583434819116]],
    [ "Buffalo Substation",[-106.65323294388149, 44.35456487962434]],
    [ "Carr Draw Substation",[-105.89660103598072, 44.31990197911918]],
    [ "Barber Creek Substation",[-105.89140061905717, 44.167731180869325]],
    [ "170347831",[-97.61902721257579, 35.31996152487189]],
    [ "170347839",[-97.58994682504638, 35.299324083360624]],
    [ "Wyodak Substation",[-105.38541794612587, 44.291019481005975]],
    [ "170362858",[-119.69619808122997, 39.04255592951098]],
    [ "Incline Substation",[-119.92419177309539, 39.23945710727207]],
    [ "170362865",[-119.71039221836837, 38.96341996592644]],
    [ "Wyopo Substation",[-108.68853541763856, 42.85373804199236]],
    [ "170363874",[-108.76010874223913, 42.5319478129305]],
    [ "Belden Substation",[-102.35217314999998, 48.15431125]],
    [ "Sheridan Substation",[-106.94185398665196, 44.827845101738454]],
    [ "Anaconda Substation",[-112.87550478988754, 46.099597747472856]],
    [ "170402289",[-116.43528676452806, 40.990664573839695]],
    [ "170405635",[-107.95257167974356, 45.308713189653204]],
    [ "170405637",[-107.94684928144825, 45.321019912561134]],
    [ "170405653",[-107.94524444325046, 45.321474124848734]],
    [ "Sub 39",[-90.35394165886487, 41.52570736716997]],
    [ "170481328",[-89.71268843898429, 41.784806980088874]],
    [ "170481578",[-90.2789389403108, 41.71516998229224]],
    [ "170481597",[-90.2695869004769, 41.566198950074075]],
    [ "Commonwealth Edison",[-89.40889178082308, 41.8261490296859]],
    [ "Beaver Rock Substation",[-90.29351426347704, 41.7918946249635]],
    [ "170481624",[-90.27496539604334, 41.71415706569336]],
    [ "170481626",[-90.27978051929709, 41.71389400606797]],
    [ "Lee County Energy Center Station",[-89.4072597059811, 41.82769818871207]],
    [ "170481688",[-89.71062462819155, 41.78720404350495]],
    [ "Fulton Substation",[-122.76069374809298, 38.49766911847958]],
    [ "Dubuque Eighth Street",[-90.65859959343939, 42.503856765107656]],
    [ "Mosalem Substation",[-90.61848445, 42.411970100000005]],
    [ "Bellevue Switch Station",[-90.49581251216408, 42.25663610813643]],
    [ "South Grandview Substation",[-90.66600483208593, 42.47727016011447]],
    [ "170504492",[-83.06322071651836, 39.82907897351209]],
    [ "Buckeye Steel Substation",[-82.9878430268178, 39.920593228981986]],
    [ "White Road Substation",[-83.0506345223692, 39.87297898012154]],
    [ "Medicine Lodge Substation",[-98.59298267708317, 37.28466584209662]],
    [ "Seward Substation",[-98.840626500075, 38.158979740319886]],
    [ "170512111",[-98.76741872489879, 37.630985342415485]],
    [ "Heizer Substation",[-98.87313822952382, 38.40650559379983]],
    [ "170512115",[-98.78495732525786, 37.675745955229985]],
    [ "170512118",[-98.7110491674555, 37.68221572692235]],
    [ "Great Bend Substation",[-98.87077084492422, 38.40673677955795]],
    [ "170512128",[-98.76618276793877, 37.6301307873715]],
    [ "170512137",[-98.78733888611413, 37.948618951834256]],
    [ "170512138",[-98.87042754291261, 38.41032520451417]],
    [ "McComb Substation",[-83.06250618625623, 39.90311509852174]],
    [ "Sawmill Substation",[-83.09286897326298, 40.13857687607852]],
    [ "Highgate Substation",[-73.05152871146242, 44.94034384605224]],
    [ "Highgate 200MW HVDC Converter Station",[-73.05429076890242, 44.93822311723427]],
    [ "Grass Creek Substation",[-108.48612654667618, 43.916333970056705]],
    [ "Duke Energy",[-106.00777435282475, 43.013247477637854]],
    [ "Segrave Substation FPL",[-81.02598332465703, 29.212430023076614]],
    [ "Bellevue Substation FPL",[-81.03024265212322, 29.188723119019]],
    [ "South Daytona Substation",[-81.00636625438017, 29.18411551852951]],
    [ "Loose Creek Substation",[-91.88282514516486, 38.47306343173109]],
    [ "170537586",[-91.88145109384806, 38.471782177319966]],
    [ "170607674",[-102.95198424922107, 48.50494536363294]],
    [ "Montgomery Substation",[-91.4601601712764, 38.921693395689054]],
    [ "McCredie Substation",[-91.98024246881201, 38.97982783988816]],
    [ "170618762",[-92.32711416602021, 39.02725370718701]],
    [ "170631957",[-91.47209849999999, 30.7043376]],
    [ "Bland Substation",[-91.49363395776477, 38.38520969526156]],
    [ "Labadie Substation",[-90.83472207472714, 38.56363889349895]],
    [ "170650574",[-90.99090442010892, 38.48970836937962]],
    [ "170650577",[-91.1333655957324, 38.475086727629225]],
    [ "Denmark Substation",[-91.35207593464347, 40.78384233770414]],
    [ "Viele Substation",[-91.4391249903025, 40.61394650709914]],
    [ "Spencer Creek Substation",[-91.53455103038995, 39.31059291026005]],
    [ "Sub T",[-91.55514510004299, 41.334778750290546]],
    [ "Palmyra Substation",[-91.55137562868941, 39.83651687818027]],
    [ "Oregon Basin Substation",[-108.91903064960373, 44.4093571055448]],
    [ "Garland Substation",[-108.58419797773516, 44.796923999804555]],
    [ "170679598",[-108.91735072177879, 44.40947097811997]],
    [ "170683367",[-84.73246119999999, 39.01277485]],
    [ "Forstmann & Co Substation",[-82.45859048377066, 33.006452933066676]],
    [ "Essex Substation",[-89.83994285262268, 36.8675865279814]],
    [ "Lutesville Substation",[-89.83562187098899, 37.258331615810896]],
    [ "Idalia Substation",[-89.85462607262899, 36.87145481204372]],
    [ "Wrightsville Substation",[-82.73818865000001, 32.738453]],
    [ "170685416",[-82.89826164341905, 32.56848111478712]],
    [ "Georgia Power",[-82.72950300000001, 32.73303385]],
    [ "Georgia Power",[-82.79189589908914, 32.66916110126181]],
    [ "170685419",[-82.9001892662673, 32.56893563395455]],
    [ "Kelso Substation",[-89.53363082062889, 37.17935964839296]],
    [ "170685883",[-82.98360696657144, 32.50834794893112]],
    [ "170685885",[-82.9620912511536, 32.54337109316932]],
    [ "Bitter Creek Substation",[-108.52425815000001, 41.61606345]],
    [ "170686986",[-108.52338223354177, 41.57534297395406]],
    [ "Bar X Substation",[-108.40583698685958, 41.61670141095141]],
    [ "Echo Springs Substation",[-107.82464312331514, 41.650054646787844]],
    [ "Latham Substation",[-107.74066846802711, 41.66593578384608]],
    [ "Platte Substation",[-107.11125821924257, 41.790923995393136]],
    [ "170763997",[-107.11125082580527, 41.79301886671647]],
    [ "170766967",[-116.38516068486945, 41.00366007439756]],
    [ "170766968",[-116.39927689155203, 40.98217005397207]],
    [ "Ramsey Substation",[-110.25819921705143, 31.465640300645607]],
    [ "Oak Grove Substation",[-90.58602014104682, 41.39769687506418]],
    [ "Sub 92",[-91.22368668628697, 41.55489686607459]],
    [ "170776706",[-102.21953973595035, 48.327858086651624]],
    [ "170786861",[-89.30983946886367, 43.48499029314333]],
    [ "170788901",[-89.46809515892515, 43.671028175373166]],
    [ "Big Sandy Substation",[-103.64146490832992, 39.30097725318568]],
    [ "Limon Substation",[-103.67372392979102, 39.26109184826595]],
    [ "Lincoln Substation",[-103.70207166064684, 39.20376812332017]],
    [ "Omak Substation",[-119.50105643701106, 48.429470502800314]],
    [ "Wadley #4 Substation",[-82.397442859028, 32.808557564764556]],
    [ "170827920",[-78.74143003109012, 35.81402825439312]],
    [ "170829403",[-97.26301608535604, 41.22092962524934]],
    [ "170831062",[-111.63117117919106, 40.23460423144867]],
    [ "170831063",[-111.65337882549026, 40.307613543596304]],
    [ "170831064",[-111.59064142615641, 40.14441558023634]],
    [ "Paso Robles",[-120.67950151077576, 35.61563574063082]],
    [ "McGregor Substation",[-82.53548470111124, 32.19115569645855]],
    [ "Georgia Power",[-82.89048145000001, 32.1159325]],
    [ "170833681",[-82.95313968335132, 32.120936000463466]],
    [ "South McRae Substation",[-82.91010356208372, 32.050327890399416]],
    [ "Ailey Substation",[-82.58057735859363, 32.18500472089536]],
    [ "McRae Substation",[-82.91083274748718, 32.049926917357006]],
    [ "Lincoln Electric System",[-96.73831720278302, 40.89178242846118]],
    [ "170835879",[-96.71456329782745, 40.86513525014592]],
    [ "170835886",[-96.72628369713503, 40.850926459672955]],
    [ "170835889",[-96.64111772706643, 40.89896859130873]],
    [ "170835893",[-96.69335048402623, 40.88602352939034]],
    [ "Frannie Substation",[-108.67318902951082, 44.95783195459524]],
    [ "170930726",[-97.39507614583854, 35.3980645289378]],
    [ "170930729",[-97.43992370000001, 35.38151785]],
    [ "170934705",[-97.35248792467061, 35.420056370690276]],
    [ "Foote Creek Substation",[-106.19077097408791, 41.652691629805894]],
    [ "Miners Substation",[-106.55187285828316, 41.85722263108802]],
    [ "170937044",[-106.20307710764034, 41.60661086595649]],
    [ "Summit Substation",[-78.56988961962823, 40.459715679759235]],
    [ "170960017",[-106.2298665514894, 42.179931346231086]],
    [ "170975634",[-102.15157138656467, 47.97861891506827]],
    [ "Gordon Substation",[-83.31691687183941, 32.882530202363974]],
    [ "South Macon Substation",[-83.62626773385578, 32.82041802150674]],
    [ "Riggins Mill Road Substation",[-83.51253128368491, 32.788460853777764]],
    [ "170991657",[-83.52272994999998, 32.71529545]],
    [ "Shoreline Chemical Substation",[-83.40387472112651, 32.89804065517677]],
    [ "Reids Primary Substation",[-83.56205433406522, 32.727960947340634]],
    [ "J.M. Huber Substation",[-83.52254735000002, 32.715062599999996]],
    [ "West Milledgeville Substation",[-83.31601105, 33.1290734]],
    [ "Reids Substation",[-83.56136085, 32.72824905]],
    [ "170991675",[-96.25462173892736, 41.20386957417895]],
    [ "Emma Park Substation",[-110.77045699999998, 39.79186475]],
    [ "170993164",[-110.84877748579837, 39.73539035780426]],
    [ "170993166",[-110.86243010396169, 39.72749223535326]],
    [ "Parsons Substation",[-82.99075512712548, 39.85922011412575]],
    [ "SRP Seaton Substation",[-111.60603779549395, 33.39273064718965]],
    [ "Miracle Mile Substation",[-106.84627132278688, 42.231547264432656]],
    [ "170999703",[-84.33084661508616, 32.87492420557334]],
    [ "Butler Primary Substation",[-84.28973502255778, 32.57103212629856]],
    [ "Gray Summit Substation",[-90.87976287449085, 38.499174491284634]],
    [ "Gray Summit Substation",[-90.8799527591741, 38.50030292760407]],
    [ "LaGrange Primary Substation",[-85.01566903121937, 33.024081762816785]],
    [ "North LaGrange Substation",[-84.9839163, 33.086214600000005]],
    [ "171039369",[-84.96646893718606, 33.02436668218326]],
    [ "Morgan Primary Substation",[-84.58451699999999, 31.528071749999995]],
    [ "Hogansville Substation",[-84.9241261057661, 33.186655160620965]],
    [ "Williams Substation",[-85.83476778941007, 42.514875920561046]],
    [ "171051393",[-90.52461187522229, 38.64771296411042]],
    [ "Wildwood Substation",[-90.64766975258573, 38.60672371424403]],
    [ "171090399",[-120.60401919083219, 47.583042207270545]],
    [ "UPALCO Substation",[-110.14396027768758, 40.25389294380909]],
    [ "171146722",[-85.03797001516719, 33.402920745733404]],
    [ "Yates Switchyard",[-84.89652749059638, 33.46118602946659]],
    [ "AEP Illinois Road Substation",[-85.29483481929472, 41.07302495444659]],
    [ "Gaston Substation",[-86.45905506525162, 33.24481716961482]],
    [ "Childersburg Substation",[-86.40647485006804, 33.22794629850043]],
    [ "Roopville Substation",[-85.13153293419063, 33.44295456813656]],
    [ "171170614",[-84.95061181831444, 33.70658747600056]],
    [ "Osage Substation",[-104.41110016726986, 43.97186733444405]],
    [ "Florida Power & Light",[-80.42919297567967, 25.60225794749249]],
    [ "Georgia Power",[-84.62354134425495, 33.51777060163277]],
    [ "Georgia Power",[-84.61918649500352, 33.518767540032165]],
    [ "Georgia Power",[-84.54150756882555, 33.5436102417502]],
    [ "East Point 12kV Switching Station",[-84.46222734249002, 33.67546200280693]],
    [ "Georgia Power",[-84.55896979409415, 33.538916736916384]],
    [ "Dry Fork Substation",[-105.46478372065597, 44.39193392400499]],
    [ "Hughes Substation",[-105.20412203373691, 44.3072980072505]],
    [ "Tongue River Substation",[-106.86115594119295, 44.971906277729]],
    [ "171194875",[-102.33558749220555, 39.36231299003442]],
    [ "Birch Lake Substation",[-94.51059766292273, 46.928659390568406]],
    [ "Wyomont Substation",[-106.87070645360673, 45.11053117150299]],
    [ "171239039",[-107.00255702211079, 44.7346956031557]],
    [ "Lookout Substation",[-103.85228842825458, 44.53681632917627]],
    [ "Fronton Substation",[-80.25826469444245, 25.810166192614336]],
    [ "Airport Substation",[-80.269214803956, 25.80895736310632]],
    [ "Willow River Substation",[-92.70211881640343, 44.99408995086397]],
    [ "Beauregard Substation",[-91.18811362132571, 30.441265974535234]],
    [ "Stoney Point Substation",[-91.73624552066592, 41.9858668427686]],
    [ "Fisher Road Substation",[-98.42937975861177, 33.88649840029886]],
    [ "Bowman Substation",[-98.60086012232463, 33.81037597053875]],
    [ "Graham Substation",[-98.60945252503262, 33.13841848497936]],
    [ "171410632",[-98.43146926249526, 33.8868636804993]],
    [ "171413955",[-82.8870348257069, 39.98444299456153]],
    [ "Jacksboro Substation",[-98.10680136698551, 33.27719369732938]],
    [ "171417802",[-98.37270175720738, 33.20304911261634]],
    [ "171422152",[-97.4228162463203, 35.42483540343533]],
    [ "171422158",[-97.44073154855506, 35.42953990088131]],
    [ "Henderson Substation",[-97.95293681567297, 33.10268503236214]],
    [ "171423698",[-97.95499330217122, 33.10211809083246]],
    [ "Parker Substation",[-97.67629234159372, 32.80624469830868]],
    [ "Willow Creek Substation",[-97.91031860128152, 33.05617898026314]],
    [ "171435063",[-97.90980208326846, 33.058934432493906]],
    [ "171440973",[-82.83497510932, 39.946454424415684]],
    [ "Ashley Substation",[-109.57562709803888, 40.508379459236544]],
    [ "171450816",[-110.01967801003902, 40.31336377055278]],
    [ "171450822",[-109.39788795216973, 40.28411736287294]],
    [ "171450823",[-108.87920348349705, 40.09866339868209]],
    [ "171450824",[-108.88385493613606, 40.12485277507905]],
    [ "171450844",[-109.46430295181503, 40.3969051152867]],
    [ "Rangley Substation",[-108.821570868723, 40.07458855615365]],
    [ "171451771",[-98.33967638753644, 33.04436232887343]],
    [ "171451889",[-109.41990105126638, 40.03892605527259]],
    [ "171453616",[-97.51392931625284, 35.38468806093366]],
    [ "Knoll Substation",[-99.3534388892117, 38.92870385628298]],
    [ "171474670",[-94.40589469489213, 46.70638144926961]],
    [ "Eagle Mountain Substation (138kV)",[-97.47846356231678, 32.90688314375554]],
    [ "Eagle Mountain Substation",[-97.47707368149821, 32.90827466738008]],
    [ "171476958",[-97.42540604518986, 32.84201440324657]],
    [ "Azle Substation",[-97.51204732903408, 32.85782963672823]],
    [ "171477443",[-97.3744920514754, 32.89701403322527]],
    [ "Alliance Substation",[-97.30596702964313, 32.95664152372645]],
    [ "Florida Power & Light",[-80.36835679337307, 25.854499074971134]],
    [ "Roanoke Substation",[-97.26156489431274, 32.991933392429246]],
    [ "Highlands Substation",[-97.03524488811338, 33.07216974814963]],
    [ "Jonesboro Substation",[-84.31206784497442, 33.53491553303844]],
    [ "Morrow Substation",[-84.33339027677516, 33.60594009517898]],
    [ "Georgia Power",[-84.37260284700585, 33.72666033191766]],
    [ "Twilight Substation",[-84.3270418, 33.58537805]],
    [ "Blacksville Substation",[-84.1546688, 33.42666019999999]],
    [ "Spivey Lake Substation",[-84.274053, 33.531995099999996]],
    [ "Georgia Power",[-84.46603377045297, 33.561934794304]],
    [ "171479143",[-84.23472145000001, 33.6509264]],
    [ "Riverdale Substation",[-84.41782945, 33.5850471]],
    [ "Georgia Power",[-84.35044884203128, 33.71061103401528]],
    [ "Stockbridge Substation",[-84.22440966901115, 33.53175357118544]],
    [ "Fort Gillem Substation",[-84.32652058956401, 33.62731147727207]],
    [ "Texas-New Mexico Power",[-97.0094632425143, 33.063708256748676]],
    [ "Jones Street Substation",[-97.00399785893946, 33.0641846357584]],
    [ "171482968",[-119.7684973793444, 36.82389070029809]],
    [ "Minnekahta Substation",[-103.68420521599224, 43.44475268694362]],
    [ "171487997",[-84.84282120029023, 39.09868981666555]],
    [ "Covington Substation",[-83.90416476993958, 33.58573196786668]],
    [ "171523275",[-83.95437388052692, 33.59493499756122]],
    [ "171523283",[-83.88496425, 33.66194410000001]],
    [ "171523286",[-83.8873682, 33.662675050000004]],
    [ "171523288",[-84.0113468, 33.6136456]],
    [ "Georgia Power",[-84.08723503220102, 33.62842916391832]],
    [ "171523316",[-84.01070354221729, 33.61325909616209]],
    [ "Eatonton Substation",[-83.40249175137674, 33.30441937656906]],
    [ "171527960",[-83.30571999072744, 33.21158476501418]],
    [ "Little Mountain Substation",[-109.34710301634155, 41.064385247827666]],
    [ "East Social Circle Substation",[-83.67931649197746, 33.67412526287675]],
    [ "Russell Dam Substation",[-82.59799115650723, 34.02418462669512]],
    [ "Anthony Shoals Substation",[-82.63627875, 34.001832349999994]],
    [ "Louisiana Pacific Substation",[-83.40609648986313, 34.043185581764575]],
    [ "171540509",[-83.40029361814437, 33.98848739557338]],
    [ "East Watkinsville Substation",[-83.3847648422601, 33.860546326555514]],
    [ "Lexington Substation",[-83.10950145, 33.91458395]],
    [ "Center Primary Substation",[-83.39810021656909, 34.05342644539537]],
    [ "Athens Substation",[-83.39298238718368, 33.971173929902854]],
    [ "Cherokee Road Substation",[-83.30133597861538, 33.9526001755683]],
    [ "Barnett Shoals Substation",[-83.31668357502924, 33.88671762899097]],
    [ "Athena Substation",[-83.34613289038246, 33.976462731509905]],
    [ "Bonneville Power Administration",[-121.20364353209659, 45.63219182371318]],
    [ "Cypress Tie Substation Abbeville",[-82.42059403220064, 34.183718395760955]],
    [ "171542429",[-82.29325511398655, 34.30419499824911]],
    [ "171548803",[-122.86603310330642, 46.75392574103389]],
    [ "171548812",[-122.86460051301245, 46.75406697314191]],
    [ "171556332",[-82.26772358842906, 34.30462277413222]],
    [ "171556333",[-82.66369275944673, 34.43768143658052]],
    [ "Colonial Pipeline Substation",[-82.68815910000001, 34.4213411]],
    [ "171556340",[-82.27111254303803, 34.30493571355653]],
    [ "John S Rainey Substation",[-82.77449976594993, 34.34785716421193]],
    [ "171556847",[-82.89408246319623, 34.317651352683924]],
    [ "Southeast Toyota Substation",[-83.43171575, 34.17042274999999]],
    [ "171571428",[-83.55166100000002, 34.38780715]],
    [ "171571429",[-83.24087284293536, 34.162870279410264]],
    [ "J.M. Huber Substation",[-83.43303418812589, 34.163931623987125]],
    [ "171571431",[-83.70074765060457, 34.401503349286315]],
    [ "North Commerce Substation (Jackson)",[-83.44219957053785, 34.22231864964414]],
    [ "Winder Primary Substation",[-83.75316131153676, 33.995485272327265]],
    [ "Braselton Substation",[-83.77029943474389, 34.10631531706298]],
    [ "Sharps Church Substation",[-83.80712159999997, 34.096719949999994]],
    [ "Jim Moore Road Substation",[-83.90734398022161, 34.034678254525105]],
    [ "171583082",[-83.75561625, 33.9972019]],
    [ "Winder Substation",[-83.75783077201008, 34.02351599458844]],
    [ "171583084",[-83.794137, 34.2049191]],
    [ "North Jackson Substation",[-83.66469429204588, 34.182409045930584]],
    [ "171583088",[-83.63570626648546, 34.16505787258007]],
    [ "171583091",[-83.5255415677703, 34.04293569991273]],
    [ "171583253",[-97.60096586760848, 32.71972756106514]],
    [ "Rice Creek Substation",[-84.75783314707648, 42.28236588791856]],
    [ "Calhoun Substation",[-84.76861731505457, 42.24609592334426]],
    [ "West Denton Substation",[-97.21917913618707, 33.17576666753145]],
    [ "Lombard Substation",[-84.73859206178243, 42.250700103695266]],
    [ "Foundry Substation",[-84.76421674999999, 42.2523027]],
    [ "Chauncey Substation",[-84.76065179999999, 42.2525207]],
    [ "Consumers Energy",[-84.73879688816167, 42.26754221934326]],
    [ "171591231",[-99.3260651344979, 38.90931050763016]],
    [ "South Hays Substation",[-99.30090365085277, 38.82850166117534]],
    [ "Consumers Energy",[-84.73818187987828, 42.25247738303103]],
    [ "Cumming Substation",[-84.12987001325425, 34.19971539161598]],
    [ "Georgia Power",[-84.04299541800624, 34.14407279766799]],
    [ "171642655",[-84.01356580100556, 34.12103963329208]],
    [ "Buford Substation",[-84.00642035000001, 34.13089745]],
    [ "Georgia Power",[-84.06998411822565, 34.25416228558411]],
    [ "Lake Lanier Substation",[-84.0320596271293, 34.14721141229539]],
    [ "Thompson Mill Road Substation",[-83.94980775067644, 34.11232085085789]],
    [ "Haw Creek Substation",[-84.11346443097908, 34.16326754071963]],
    [ "Rest Haven Substation",[-83.97634205571002, 34.13741173144109]],
    [ "Buford Dam Substation",[-84.07742396458934, 34.16215301488633]],
    [ "Buford Substation#4",[-83.96877433213987, 34.13456195951933]],
    [ "Kirk Switchyard",[-103.76156269117861, 44.342439601664516]],
    [ "Anna Substation",[-96.63942534168949, 33.317786714485464]],
    [ "171694070",[-93.64811173920457, 47.261680106111335]],
    [ "Farmersville Substation",[-96.33793826686961, 33.190711846615265]],
    [ "Valley South Substation",[-96.37331972516353, 33.61394530693481]],
    [ "171694620",[-96.52712772644537, 33.32156753030903]],
    [ "Paris Substation",[-95.58104118121071, 33.639047427808904]],
    [ "171704785",[-95.69829659999998, 33.63253735]],
    [ "171704787",[-96.15885332889572, 33.63366034373467]],
    [ "171713849",[-84.44681422688288, 34.45791537072734]],
    [ "Ellijay Primary Substation",[-84.48843762805485, 34.684629097479]],
    [ "171713852",[-84.37109305872278, 34.371323374869576]],
    [ "Nelson Substation",[-84.3788414021485, 34.38655589312889]],
    [ "Georgia Power",[-84.52891238622024, 34.59581988469683]],
    [ "Colony Substation",[-96.88381006749557, 33.08482808912222]],
    [ "Bridges Substation",[-96.85976845739758, 33.12321867517494]],
    [ "Hebron Substation",[-96.90397330526643, 33.04828666646854]],
    [ "Carrollton Frankford Road Substation",[-96.93052008813154, 32.99865161688219]],
    [ "Roman Juarez Substation",[-96.84128925174156, 33.15827750459129]],
    [ "Bowen Pumping Substation",[-84.9222168, 34.1336025]],
    [ "Georgia Power",[-84.92589475778973, 34.13470156775625]],
    [ "Bowen NDPES Substation",[-84.92187075, 34.1158211]],
    [ "171722547",[-96.77928418297093, 33.01160230189144]],
    [ "Brazos Electric",[-96.85968057385, 33.06025430750507]],
    [ "171722567",[-96.8063990489587, 33.06128784418637]],
    [ "171722569",[-96.77951462433414, 33.0132404852022]],
    [ "West Plano Substation",[-96.7773203577775, 33.01276885694781]],
    [ "171725287",[-111.62783557101473, 35.21369446050455]],
    [ "Julia Substation",[-91.1734550432214, 30.43722936610113]],
    [ "171730464",[-84.18699225690143, 31.76089942142596]],
    [ "171730466",[-84.21273442277662, 31.635188927409803]],
    [ "171730740",[-84.25210287230276, 32.26129564174698]],
    [ "Rapid City South Substation",[-103.22793871199913, 44.02492510889281]],
    [ "West Hill Substation",[-103.50193783305998, 43.43455076610751]],
    [ "Mulberry Creek Substation",[-99.82259436564361, 32.523890239912866]],
    [ "Long Creek Substation",[-99.54140971638917, 32.62926280580152]],
    [ "Hackberry Wind Substation",[-99.42282495, 32.76842585]],
    [ "Cook Field Road Substation",[-99.32804825618464, 32.749979462136416]],
    [ "171791435",[-97.54696512615801, 35.3452853304433]],
    [ "Tonkawa Substation",[-100.6842024868628, 32.530732142050425]],
    [ "Radium Substation",[-99.99351631650416, 32.826817799475464]],
    [ "Champion Wind Farm Substation",[-100.64802298391199, 32.39873533187871]],
    [ "Pyron Wind Farm Substation",[-100.69251065000002, 32.57969115000001]],
    [ "171793193",[-98.90575660452916, 33.10326100830449]],
    [ "Inadale Wind Farm Substation",[-100.59673002892292, 32.49778268536233]],
    [ "Roscoe Wind Farm Substation",[-100.66604143983797, 32.4699675284851]],
    [ "Sweetwater East Substation",[-100.21692958068803, 32.46400401183112]],
    [ "Morgan Creek Substation",[-100.91610728877339, 32.33412682897815]],
    [ "Cole substation",[-100.84619403532542, 36.61693729692303]],
    [ "Scurry County South Substation",[-100.8617781526022, 32.59840545373135]],
    [ "San Angelo Red Creek Substation",[-100.32112736494277, 31.528975694942698]],
    [ "Callahan Divide Wind Substation",[-99.97407734739512, 32.30055261548584]],
    [ "Comanche Switching Station",[-98.5532897245601, 31.8689600253831]],
    [ "171843873",[-110.04557357561846, 41.877276916920245]],
    [ "171843875",[-109.38655864026885, 40.56650836830537]],
    [ "171843877",[-110.09445298355884, 41.88344593821997]],
    [ "171843881",[-110.09078334429569, 41.88120272578002]],
    [ "171849698",[-116.45315956070542, 43.605193992366786]],
    [ "171849700",[-116.43430153339526, 43.6368311167015]],
    [ "171849701",[-116.64184373859675, 43.7214505251184]],
    [ "171849702",[-116.68612281587878, 43.679070266426514]],
    [ "Coconut Grove Substation",[-80.25455295318707, 25.735560894296697]],
    [ "171853242",[-97.72675856103172, 32.3787169050338]],
    [ "Wolf Hollow Substation",[-97.73213134382331, 32.3355137925003]],
    [ "Monticello substation",[-95.04203582226337, 33.09167406546502]],
    [ "171874687",[-84.25964093338017, 30.371226222189975]],
    [ "Carthage Substation",[-89.57435559583183, 32.719385306211606]],
    [ "171900306",[-95.58788710000002, 33.6313744]],
    [ "Everman Substation",[-97.25154797951143, 32.64017139557992]],
    [ "171925092",[-97.54895532052556, 35.38515647693803]],
    [ "Sweetwater Wind 1 Substation",[-100.35113652198349, 32.437935893433135]],
    [ "Loraine Substation",[-100.7271692890856, 32.378503519583575]],
    [ "Bitter Creek Substation",[-100.3521402997934, 32.43783181105397]],
    [ "Sweetwater Wind 3 Substation",[-100.41993549999998, 32.337948350000005]],
    [ "Sweetwater Wind 4 Substation",[-100.49521001089808, 32.28587327332549]],
    [ "Loraine Wind Farm Substation",[-100.74595712147365, 32.445104444827315]],
    [ "Sweetwater Wind 5 Substation",[-100.48761701090389, 32.24204022216435]],
    [ "171941219",[-97.26004827943406, 33.219406255206685]],
    [ "171947463",[-87.49713233861382, 38.69175858944504]],
    [ "Goat Rock Dam Substation",[-85.08250272188803, 32.608270025467625]],
    [ "171967076",[-85.0827928, 32.6105455]],
    [ "171967077",[-84.97958809999999, 32.61522495]],
    [ "Plant Franklin Substation",[-85.09340678732902, 32.60863993703884]],
    [ "Harmony Hills Substation",[-98.50600377522842, 29.554008883734955]],
    [ "Atlantic Substation",[-74.11846466650485, 40.2541667894264]],
    [ "172027675",[-96.96105961729492, 32.66553342142148]],
    [ "172027706",[-97.07752810343686, 32.55103746288405]],
    [ "172027711",[-97.21408394844751, 32.63682275502782]],
    [ "Royse Substation",[-96.35077424650665, 32.9692516508899]],
    [ "Allen Switching Station",[-96.70032799771508, 33.06009458150625]],
    [ "Sulphur Springs Switching Station",[-95.6164958192505, 33.085737857413925]],
    [ "Georgia Power",[-84.17515439317019, 31.260706527178225]],
    [ "172096001",[-84.14276721752739, 31.189852392871952]],
    [ "Municipal Electric Authority of Georgia",[-84.04332081699198, 30.932110246266912]],
    [ "172096004",[-84.13134071468707, 31.172352969014153]],
    [ "Thomasville Substation",[-84.00506141612257, 30.90849505819258]],
    [ "Tyson Foods Substation",[-84.1813669728029, 31.278201058643955]],
    [ "Cass Lake Substation",[-94.63891221090383, 47.379042186982986]],
    [ "Austin Road Substation",[-98.4080110722869, 29.503904829474763]],
    [ "Fratt Substation",[-98.34311177384518, 29.54853312164672]],
    [ "Parkway Substation",[-98.28991109816918, 29.58270337974505]],
    [ "Iona Substation",[-81.9436450588833, 26.486572697853738]],
    [ "Lange Substation",[-103.2606405427259, 44.11981617021305]],
    [ "Twin Buttes Substation",[-100.59802196115338, 31.513799143282856]],
    [ "NextEra Energy",[-100.8344754945266, 31.87043542360427]],
    [ "Divide Substation",[-100.77706986656517, 31.869521088307604]],
    [ "NextEra Energy",[-100.77926859084117, 31.870217499405868]],
    [ "Gasconades Creek Substation",[-100.83018435, 31.9393262]],
    [ "Goat Wind Substation",[-100.8270287760154, 31.94075818032092]],
    [ "Oceanview Substation",[-74.0458748530454, 40.22102112209771]],
    [ "Panther Creek Wind 1 Substation",[-101.45085780000001, 32.1004401]],
    [ "Quail Substation",[-102.31627455365175, 31.840003845700465]],
    [ "Elbow Creek Wind Farm",[-101.39608965000001, 32.124034349999995]],
    [ "172212642",[-102.32740203610877, 31.83863265090382]],
    [ "Longshore Substation",[-101.45233624163893, 32.100303252073694]],
    [ "172215202",[-82.89002242972906, 39.93173062598808]],
    [ "172232682",[-115.74636534999999, 42.94183505]],
    [ "172232683",[-115.97761289999998, 42.9448989]],
    [ "172232684",[-116.2991697243675, 43.606130222406]],
    [ "172232686",[-115.9587344758585, 43.367843869030864]],
    [ "172232688",[-115.71652442702174, 43.17767753859953]],
    [ "172232693",[-115.9818267, 42.9435444]],
    [ "172232695",[-115.38352698113871, 42.97134242500503]],
    [ "172232696",[-116.25562519325125, 43.60308350751183]],
    [ "172232699",[-115.6544792152246, 43.1514204169704]],
    [ "172232705",[-115.6659922430913, 43.14765999442378]],
    [ "172232707",[-115.38112570744629, 42.94467089798504]],
    [ "172232712",[-116.2048883314317, 43.58593793211769]],
    [ "172232725",[-114.90606010132363, 42.86529858476119]],
    [ "172232728",[-115.1812667830073, 42.908458219671985]],
    [ "172232729",[-114.90898424059975, 42.76605584611755]],
    [ "172232730",[-115.47134287909252, 43.060641764611084]],
    [ "172232735",[-114.92465733661886, 42.76696776630107]],
    [ "172232742",[-115.73372094682657, 43.178457613226925]],
    [ "Forrestal Substation",[-74.60279193258835, 40.34782007052085]],
    [ "City of Tallahassee",[-84.39814192188767, 30.453104421343244]],
    [ "Grady EMC",[-84.36743113646386, 30.867573325150243]],
    [ "172236816",[-84.37767627511235, 30.468141285139232]],
    [ "City of Tallahassee",[-84.34604780588629, 30.476669721320377]],
    [ "Moss Substation",[-102.49572571235848, 31.813199515542262]],
    [ "Ector Hillmont Substation",[-102.43329966346738, 31.92354467225523]],
    [ "Adobe Meadows Substation",[-102.07316065, 32.06254810000001]],
    [ "Gardendale Substation",[-102.25175629057743, 32.0361085143927]],
    [ "Ben Davis Substation",[-96.61207568358272, 32.957765770121945]],
    [ "McCree Substation",[-96.66343235923087, 32.8724014921624]],
    [ "Martin Lake Substation",[-94.57464818768452, 32.25700877659406]],
    [ "Shamburger Substation",[-95.25346100296707, 32.419892187939]],
    [ "Seagoville Switching Station",[-96.54625235825263, 32.673455132011036]],
    [ "Seagoville Substation",[-96.54890991398247, 32.67386672644741]],
    [ "Tyler Substation",[-95.34645669439232, 32.27984929374787]],
    [ "172356198",[-95.40641858082896, 32.31792884432967]],
    [ "172356202",[-96.31411742836524, 32.53960600757763]],
    [ "172356203",[-95.57918754086458, 32.44651289313976]],
    [ "172359348",[-95.30735600628873, 32.27966390256207]],
    [ "172359353",[-95.25771559649519, 32.27751340974301]],
    [ "Minooka Substation",[-75.68749760591685, 41.37997777782338]],
    [ "Tabor Substation",[-122.60181962082198, 45.51999215090633]],
    [ "North Cleburne Substation",[-97.38943372463551, 32.38867735432032]],
    [ "172362136",[-97.4557008, 32.411325]],
    [ "172362138",[-97.40810290105605, 32.397348961411836]],
    [ "Southwestern Electric Power Company",[-94.62107765, 32.024613450000004]],
    [ "Oncor",[-94.62430247603935, 32.014698787603535]],
    [ "Tenaska Gateway Station",[-94.62123977090813, 32.01777177172749]],
    [ "Florida Power & Light",[-80.18520115, 26.098545650000002]],
    [ "Florida Power & Light",[-80.18594807895309, 26.12826472779625]],
    [ "172365913",[-94.99325646854535, 31.937776173180254]],
    [ "Crockett Substation",[-95.39546962569763, 31.364387360923022]],
    [ "172375006",[-96.95957006050935, 32.6490360092868]],
    [ "TXU Cedar Hill Substation",[-96.92458182925022, 32.6149568568848]],
    [ "Helena",[-112.00299885, 46.591993650000006]],
    [ "172402164",[-107.89907889870422, 37.243398697295454]],
    [ "172426122",[-112.69369315, 45.95163175]],
    [ "Oncor",[-96.91865452885686, 32.815167985420295]],
    [ "Irving Belt Line Substation",[-96.99380605000002, 32.784800249999996]],
    [ "172433991",[-96.8353319799321, 32.78473400717745]],
    [ "172433993",[-96.94331602747458, 32.9078388774082]],
    [ "172433995",[-96.99219600247893, 32.90806975992739]],
    [ "172433996",[-96.9338927363875, 32.887481057979954]],
    [ "172438800",[-112.74247237263326, 45.236006161384395]],
    [ "172438803",[-112.69032211618214, 44.702602201607114]],
    [ "Pine Creek Substation",[-116.23028476957474, 47.53962134648033]],
    [ "Valley Road Substation",[-98.42958932971784, 29.23868040916495]],
    [ "Triton Substation",[-117.11476713972748, 33.54210836872517]],
    [ "Cabinet Gorge Substation",[-116.05745441193079, 48.08730448029093]],
    [ "172460412",[-112.64270115538798, 45.21809503338473]],
    [ "Wapello County Substation",[-92.37292395778776, 41.00435053303942]],
    [ "Lufkin Switching Station",[-94.76860916930912, 31.370148708209353]],
    [ "Tradinghouse Substation",[-96.96447271200995, 31.57474543473563]],
    [ "Big Brown Station",[-96.057452754283, 31.819531219978813]],
    [ "172518839",[-93.58071412468927, 45.31662379770595]],
    [ "McPherson Refinery Substation",[-97.66481005735972, 38.34840629225755]],
    [ "Johns Manville Substation",[-97.6109705787263, 38.38866331619534]],
    [ "East McPherson Substation",[-97.63129600126467, 38.321135881381224]],
    [ "Union Ridge Substation",[-97.04037491424195, 38.70524241628104]],
    [ "McDowell Creek Substation",[-96.63306379192346, 39.014348767267826]],
    [ "Florida Power & Light",[-81.80116813188329, 27.315926064892853]],
    [ "Lawrence Hill Substation",[-95.27091782882276, 39.00287005242851]],
    [ "Tecumseh Hill Substation",[-95.56480543024458, 39.05346749294292]],
    [ "172577356",[-95.81603627518568, 38.993176375508526]],
    [ "Richland Chambers Substation",[-96.11335000589007, 31.890152456823742]],
    [ "Forest Grove Substation",[-95.94928124965115, 32.234710416826736]],
    [ "Hypoluxo Substation",[-80.06595512754372, 26.572922783270783]],
    [ "Tenaska Frontier Station",[-95.91913325123443, 30.593908962736233]],
    [ "Pirkey Substation",[-94.4786051262551, 32.463445611211014]],
    [ "172601852",[-94.43448100128799, 32.39543168298277]],
    [ "172601859",[-94.42779312790478, 32.300709458812804]],
    [ "172604399",[-94.5076925346159, 44.337564891290164]],
    [ "172665479",[-83.01717257829888, 39.95420895591511]],
    [ "Fisher Substation",[-83.12334533428931, 39.96477787779422]],
    [ "Wilson Road Substation",[-83.0938855646138, 39.962743939185046]],
    [ "172672200",[-83.13737803580366, 39.97890555494054]],
    [ "172674013",[-83.13056937358925, 40.050969313011755]],
    [ "172674403",[-83.09411887539778, 40.067775151299585]],
    [ "Northwest Energy",[-112.68668273123738, 45.97213151429478]],
    [ "172708325",[-99.5891149622765, 36.578571158401395]],
    [ "Temple Pecan Creek Substation",[-97.26106452989485, 31.129639242523584]],
    [ "Temple Switching Station",[-97.30777685415539, 31.079104009983855]],
    [ "172713108",[-111.25655842946895, 47.480051075065646]],
    [ "Bosque Switching Station",[-97.35929826598385, 31.857889197866506]],
    [ "Whitney Switching Station",[-97.36531948278214, 31.860631451086164]],
    [ "Rogers Hill Substation",[-97.17731828569397, 31.746115801845473]],
    [ "Lake Whitney Substation",[-97.3672526748434, 31.859626449700112]],
    [ "Oak Grove Substation",[-96.48437354581002, 31.183574677059408]],
    [ "Bear Grass Substation",[-96.20628440616197, 31.37698715348999]],
    [ "Addis Substation",[-91.25508527901826, 30.381903053283413]],
    [ "Nucor Substation",[-96.16330781808045, 31.35244743374577]],
    [ "Yankton Substation",[-97.47739829999999, 42.90421325]],
    [ "SRP Cameron Substation",[-111.63850964909045, 33.44468641505744]],
    [ "SRP Signal Butte Substation",[-111.6104669665401, 33.42275533514127]],
    [ "172750391",[-98.35394392479999, 40.655786438035854]],
    [ "172750392",[-98.35327552488143, 40.590242054746014]],
    [ "172750397",[-98.35511983933148, 40.58322751028042]],
    [ "172763723",[-99.08324375933526, 40.85076226753087]],
    [ "172763724",[-99.70929896995601, 40.886538570240255]],
    [ "172763791",[-99.70298054244103, 40.69527260852928]],
    [ "172763807",[-99.70266167717958, 40.69446241731119]],
    [ "172818830",[-111.70613375952763, 35.18567751712199]],
    [ "New Underwood Substation",[-102.82687818661556, 44.07193863882343]],
    [ "Philip Substation",[-101.68639109087431, 44.083329315574616]],
    [ "Philip Tap",[-101.69602655000003, 44.304252000000005]],
    [ "NV Energy",[-114.84459136950588, 35.94874667431062]],
    [ "Billings Steam Plant Substation",[-108.48006157949794, 45.773998430637675]],
    [ "Rimrock",[-108.49609912412953, 45.7995564074721]],
    [ "172868482",[-108.51674126896732, 45.826774883817954]],
    [ "Roebuck Substation FPL",[-80.10199279278812, 26.73648437149734]],
    [ "172875124",[-94.91313490596562, 47.46920156999433]],
    [ "172876860",[-88.51568511081422, 43.29801244807274]],
    [ "Littlefork Substation",[-93.60646923772286, 48.38728177963851]],
    [ "Wayside Substation",[-103.21381574945511, 42.99728082062152]],
    [ "Maurine Substation",[-102.59216304914776, 45.00766884142692]],
    [ "Lake Platte Substation",[-98.95666290000001, 43.60096719999999]],
    [ "Hall Substation",[-83.13573142157928, 39.92997616784031]],
    [ "172983659",[-114.13371226972426, 35.05548972307604]],
    [ "172985964",[-113.20474201810667, 35.23932854688445]],
    [ "Junction City Substation",[-96.76951677000685, 42.774462300154404]],
    [ "172986026",[-97.5870771, 43.09719630000001]],
    [ "172996602",[-93.8709939, 45.372022199999996]],
    [ "Salida Crossing Substation",[-93.88108835004368, 45.38066385285562]],
    [ "172996700",[-82.4319868, 27.4385744]],
    [ "Woonsocket Substation",[-98.33271292733774, 44.06641688595572]],
    [ "172999777",[-113.19715712884548, 34.56175288621511]],
    [ "172999778",[-113.17551184855141, 34.56582584286213]],
    [ "Cortez Substation",[-82.61192668329794, 27.46176567373716]],
    [ "Broadland Substation",[-98.39261699464109, 44.47366543710246]],
    [ "Virgil Fodness Substation",[-96.83459388988449, 43.41869144919676]],
    [ "Subestación de Jayuya",[-66.60410317939707, 18.217819641826832]],
    [ "Puget Sound Energy",[-122.56035133195842, 47.77155174435094]],
    [ "Puget Sound Energy",[-122.5422282741424, 47.8155139851158]],
    [ "Inver Grove Substation",[-93.0643232726686, 44.79802811691024]],
    [ "Rich Valley Substation",[-93.03860540646292, 44.78266703709726]],
    [ "Guardian Glass",[-76.97262354767918, 42.88884745094032]],
    [ "173095695",[-90.70856505349448, 47.64327527358374]],
    [ "173108424",[-94.08841687504562, 43.73862150783918]],
    [ "Black Peak Substation",[-114.21706587505999, 33.99778605806187]],
    [ "173111503",[-94.06489958546155, 44.102171837071374]],
    [ "Puget Sound Energy",[-122.60678004999998, 47.854841]],
    [ "Puget Sound Energy",[-122.6181234686769, 47.745541998335206]],
    [ "Puget Sound Energy",[-122.58654825, 47.795877700000005]],
    [ "Puget Sound Energy",[-122.60749347909226, 47.769393759112575]],
    [ "Pahoja Substation",[-96.4499655956074, 43.37602333884107]],
    [ "Northwest Iowa Power Cooperative",[-96.40135982111482, 43.06787962148238]],
    [ "Sandow Station",[-97.07680662152443, 30.57766501225303]],
    [ "Rogers Substation",[-97.20127719550614, 30.91924763032003]],
    [ "Cedar Hill Substation",[-97.37942075354536, 30.313981271163364]],
    [ "Scranton Substation",[-75.66446576094789, 41.404632597955185]],
    [ "173188633",[-120.53089845000001, 46.582158099999994]],
    [ "Zebra Substation",[-83.53098854978006, 42.29428598987563]],
    [ "APS Altadena Substation",[-111.83910039826775, 33.591121903041305]],
    [ "Thompson Peak Substation",[-111.86484413596814, 33.636280111674736]],
    [ "Downing Substation",[-111.8927511768964, 33.65208197191095]],
    [ "Rawhide Substation",[-111.92091995152765, 33.68463720612769]],
    [ "173216571",[-111.96037335927673, 48.15027675205025]],
    [ "Conrad Substation",[-111.93866182630624, 48.129481564319036]],
    [ "Shelby Substation",[-111.86233296521203, 48.466354924382976]],
    [ "173219312",[-112.04671050369221, 33.38013676293778]],
    [ "173219318",[-111.99609821960968, 33.381495088938586]],
    [ "173219320",[-111.99681343987743, 33.24922399383454]],
    [ "173219321",[-111.99495078302996, 33.306277241030166]],
    [ "TNP One Substation",[-96.69355594999999, 31.091272499999995]],
    [ "Gibbons Creek Station",[-96.0866633, 30.6211755]],
    [ "Lost Pines Station",[-97.27278856639943, 30.14775176215054]],
    [ "173264465",[-112.09467952582051, 48.27912288887718]],
    [ "Garfield Substation",[-97.54537121612435, 30.142619105722694]],
    [ "Bluebonnet Substation",[-97.43435224947909, 30.1219725401445]],
    [ "Bastrop West Substation",[-97.33516622892151, 30.10169521779459]],
    [ "Tahitian Village Substation",[-97.3059158836383, 30.09123560166056]],
    [ "Bastrop Energy Switchyard",[-97.54853788512517, 30.145480171150744]],
    [ "Winchester Substation",[-96.98653869701249, 30.04441534675284]],
    [ "McMicken Substation",[-112.42416430712296, 33.694077859573916]],
    [ "St. Francois Substation",[-90.4550297014361, 37.94697753037225]],
    [ "Pere Marquette Substation",[-86.36308271387477, 43.94647474166623]],
    [ "Bushland Interchange",[-102.09853684999999, 35.14788795]],
    [ "Rush Island Station",[-90.26568438308392, 38.13282769565071]],
    [ "Green Mountain Substation",[-98.3328807566279, 29.620436075471837]],
    [ "Joachim Substation",[-90.45135704776338, 38.21375415409291]],
    [ "Tyson Substation",[-90.5089692317864, 38.49524730295503]],
    [ "173548418",[-90.25766176483273, 38.11214348023289]],
    [ "173549244",[-96.23519313993079, 43.39699669518717]],
    [ "Hollywood Park Substation",[-98.47156573442297, 29.594885120612307]],
    [ "Hedgpwth Hills subsation",[-112.20139425149831, 33.70720243945714]],
    [ "Bowman Substation",[-103.32988971436585, 46.11974679068812]],
    [ "Rhame Substation",[-103.66284565000001, 46.166247399999996]],
    [ "Little Missouri Substation",[-104.04451045786443, 46.32227776933979]],
    [ "Asarco Substation",[-111.82979601324236, 32.955135853911464]],
    [ "SRP",[-111.79091707110075, 32.90366936552768]],
    [ "Empire Tap Substation",[-111.63815898384351, 32.67326443615927]],
    [ "Casa Grande Substation",[-111.77502728129404, 32.88547431375129]],
    [ "Santa Rosa Substation",[-111.99491403272133, 32.960351584474495]],
    [ "173711182",[-84.20164304745022, 30.163431827820332]],
    [ "173711189",[-84.3084912, 30.192334899999995]],
    [ "173711191",[-83.60377942694454, 30.16157400380534]],
    [ "Marana Substation",[-111.3036746369042, 32.44593128215086]],
    [ "Electrical District No. 5 Substation",[-111.56973487319279, 32.60363503906591]],
    [ "Electrical District No. 5 Substation",[-111.56784047511799, 32.603157260943114]],
    [ "Rattlesnake Substation",[-111.19773175387397, 32.38678694595919]],
    [ "Twin Peaks Substation",[-111.19444774424919, 32.38170781135995]],
    [ "173719527",[-120.39840214999998, 46.58767515]],
    [ "SRP",[-112.24585780834755, 33.522807861964466]],
    [ "Maryvale Substation",[-112.21975401084296, 33.50941321657808]],
    [ "Jornada Substation",[-106.75948614833959, 32.38743695162074]],
    [ "Fort Peck Station",[-106.41205757332385, 48.013412593201394]],
    [ "173805006",[-92.2713154, 47.793233650000005]],
    [ "Todd-Wadena Electric Cooperative",[-94.70726906214294, 47.011377360814116]],
    [ "Akeley Substation",[-94.75520591251293, 47.00040810551724]],
    [ "Nevis Substation",[-94.83112778972523, 46.96854332525415]],
    [ "Ridgeview Substation",[-92.11261920142269, 46.83548019841065]],
    [ "Volney Substation",[-76.34778169969017, 43.40006884259367]],
    [ "Nine Mile Point #1",[-76.40994577425151, 43.51959478251729]],
    [ "FitzPatrick",[-76.39989087785668, 43.52233312125015]],
    [ "Scriba Station",[-76.4072268816807, 43.51318387362175]],
    [ "Federal Street Station",[-78.00827762481445, 42.715570153351145]],
    [ "173871303",[-114.9485226250172, 42.62212080600074]],
    [ "173871304",[-114.67451371274271, 42.01653766949354]],
    [ "173871307",[-114.35620687595198, 42.58871817267135]],
    [ "173871308",[-114.77616684649603, 42.74007314132932]],
    [ "Independence Substation",[-76.44717223956378, 43.499102695532066]],
    [ "Las Cruces Substation",[-106.76811005365506, 32.310731461959115]],
    [ "Sunburst",[-111.90612997477557, 48.882252545605546]],
    [ "173900577",[-113.56333121575288, 37.138747313662414]],
    [ "173900578",[-113.56354909250845, 37.14229096556922]],
    [ "173981259",[-94.6377031743097, 45.903317293646296]],
    [ "Lytton Springs Substation",[-97.67422223109676, 30.00537837981503]],
    [ "Mendoza Substation",[-97.66762745548041, 30.003539249620815]],
    [ "174002068",[-113.87205030634725, 42.69113250252931]],
    [ "174002072",[-114.17439452479248, 42.62927985947166]],
    [ "174002073",[-114.06728419286834, 42.587037874970534]],
    [ "174002081",[-113.75226708589312, 42.61208572513131]],
    [ "174002086",[-113.75168327490816, 42.60450039111093]],
    [ "174002091",[-114.01405288512974, 42.51945576277584]],
    [ "McCarty Lane Substation",[-97.96474671789213, 29.826510400200593]],
    [ "174019121",[-114.0412207885703, 41.33453968675117]],
    [ "174019123",[-113.9032851, 41.6376156]],
    [ "174019124",[-113.39393149456455, 42.28516457840079]],
    [ "174019125",[-114.07559065775177, 40.73724765352877]],
    [ "174019126",[-113.58554605922788, 42.54095400715302]],
    [ "174019128",[-113.62764054425926, 42.48133300218774]],
    [ "174019129",[-113.35679887703486, 42.12995243749727]],
    [ "Killeen Substation",[-97.72295185449225, 31.03898377485173]],
    [ "Salado Switching Station",[-97.51111939999998, 30.972125950000002]],
    [ "Salado Substation",[-97.51303591551365, 30.971238180653323]],
    [ "Bell County Switching Station",[-97.39358596817556, 31.010029510993135]],
    [ "Blanchard Substation",[-94.35829886435187, 45.86157530298634]],
    [ "Hutto Switching Station",[-97.56134300585191, 30.551166927827566]],
    [ "SRP Mountain View Substation",[-111.84665162384934, 33.43709218574275]],
    [ "Marias River Electric Cooperative",[-111.97309634525104, 48.986499628287916]],
    [ "174041881",[-106.56146573724905, 35.1596507940222]],
    [ "174044326",[-112.35335896132396, 48.62392997005145]],
    [ "174044327",[-112.34402433830095, 48.616133307230385]],
    [ "174044330",[-112.32116194312871, 48.624060162968846]],
    [ "Kendall CTEC Substation",[-98.88477554128612, 29.986266547714084]],
    [ "River Oaks Substation",[-98.10582777154755, 29.77775775578525]],
    [ "174128301",[-82.9942228042957, 39.98063342724748]],
    [ "174128305",[-82.9786682641193, 39.98472775868085]],
    [ "Paulden Substation",[-112.47055900476745, 34.88793971933129]],
    [ "174139884",[-93.14081272885242, 45.80944318190008]],
    [ "Horse Hollow 2 Substation",[-100.17697869999999, 32.26955795]],
    [ "Horse Hollow 3 Substation",[-100.2843617879902, 32.2654226340587]],
    [ "174196834",[-92.62231950000002, 44.877283899999995]],
    [ "174197058",[-114.97762874982925, 41.11306448164492]],
    [ "174197062",[-114.97873338584445, 41.112091415172706]],
    [ "Rio Nogales Switchyard",[-97.97493153638538, 29.59310753931389]],
    [ "174200585",[-106.59477446109572, 35.15975027500361]],
    [ "174202818",[-97.65838502564394, 35.27587497730125]],
    [ "Boerne Cico Substation",[-98.77608138546057, 29.771151136450985]],
    [ "174245128",[-116.82118135069678, 43.905657042836594]],
    [ "Marion Substation",[-98.14869083930958, 29.620922469083037]],
    [ "Guadalupe Generating Station",[-98.14105510582358, 29.623169480681984]],
    [ "Elm Creek Substation",[-97.99987960559332, 29.467299385799734]],
    [ "Cedar Creek Wind Farm Substation",[-104.0662560839976, 40.86337096133719]],
    [ "Kersey Tap Substation",[-104.54416186240594, 40.377191521457]],
    [ "Rosedale Substation",[-104.67936189384797, 40.385517675775375]],
    [ "Cedar Creek Wind Farm Substation",[-104.06727024077503, 40.86270107315944]],
    [ "Arrowhead Lake Substation",[-104.75790685509689, 40.38423901629416]],
    [ "Hamilton Substation",[-106.5287005344876, 35.15953687516035]],
    [ "Lolita Substation",[-96.5574016051286, 28.85316645053834]],
    [ "Newgulf Substation",[-95.9193927328002, 29.230159387500095]],
    [ "Karsten Substation",[-95.43005922183575, 29.49070759607318]],
    [ "Oasis Substation",[-95.30831257167098, 29.456208094498855]],
    [ "Cibolo Substation",[-98.20772524168153, 29.57818171144918]],
    [ "174338796",[-117.42430010000004, 44.532856800000005]],
    [ "Weiser Substation",[-116.98606230359435, 44.247515543592094]],
    [ "174342509",[-97.67703089575625, 35.46812302398268]],
    [ "174342513",[-97.67484472396153, 35.46856762623185]],
    [ "174342524",[-97.64913947867704, 35.44282606357014]],
    [ "174342527",[-97.65483520000002, 35.516734549999995]],
    [ "174343664",[-97.65378054934092, 35.46880340139014]],
    [ "174343666",[-97.59848540063884, 35.47928183579885]],
    [ "174343667",[-97.63272716952704, 35.479330523741005]],
    [ "174360077",[-97.61946383227378, 35.42747577337745]],
    [ "174360079",[-97.62677249419026, 35.398514551433415]],
    [ "174360102",[-97.6302511968506, 35.434695190054626]],
    [ "Dow Substation",[-95.35808867376612, 28.98627890804709]],
    [ "Cavern Substation",[-95.33904736081791, 29.032383796902014]],
    [ "Biport Substation",[-95.33851291993304, 28.986064920664866]],
    [ "174381632",[-97.5747635037152, 35.40280303930253]],
    [ "Bishop Substation",[-75.23170460386616, 38.42335046210655]],
    [ "174398667",[-83.18073076479756, 30.37544132506848]],
    [ "Dasher Substation",[-83.24127405365721, 30.713865318824674]],
    [ "South Lowndes Substation",[-83.30603194999999, 30.705739549999997]],
    [ "Twin Lakes Substation",[-83.21798342326927, 30.72836365844175]],
    [ "Pine Grove Primary Substation",[-83.22796312227706, 30.881725651785327]],
    [ "Hickory Grove Substation",[-83.21023323994346, 30.76469572725507]],
    [ "ERCO Worldwide Substation",[-83.22432212624585, 30.834132604085948]],
    [ "Blessing Substation",[-96.19087063919379, 28.886564294209325]],
    [ "Magnolia Substation",[-95.13398619137725, 29.48835407458821]],
    [ "North Alvin Substation",[-95.25754645250807, 29.458976195584768]],
    [ "Georgia Transmission Corporation",[-83.57102108750799, 30.855847231614128]],
    [ "Hahira Substation",[-83.37675779397273, 30.89507962060373]],
    [ "San Miguel Switchyard",[-98.47430697486298, 28.70400566073503]],
    [ "Berlin Substation",[-83.59369459999999, 31.0670863]],
    [ "Cool Springs Substation",[-83.5662893, 31.264069999999997]],
    [ "Georgia Transmission Corporation",[-83.36823475, 30.96637495000001]],
    [ "174466529",[-83.30165407707831, 31.200449006295187]],
    [ "East Moultrie Substation",[-83.74347415759125, 31.242177489461113]],
    [ "Hahira Substation",[-83.36747815, 30.995113649999997]],
    [ "Nashville Substation",[-83.26020855, 31.2078454]],
    [ "South Tifton Substation",[-83.50918352428383, 31.43783045881903]],
    [ "Georgia Power",[-83.56667025107149, 31.264289016523193]],
    [ "Georgia Transmission Corporation",[-83.22149390000001, 30.987343350000003]],
    [ "Magnolia Park Substation",[-83.49069165662333, 31.41303545215718]],
    [ "174466540",[-83.35226525279577, 31.067964769376108]],
    [ "174466541",[-83.41920776352488, 31.107842594462834]],
    [ "Tifton Primary Substation",[-83.51531819334518, 31.455671696879328]],
    [ "Behrman Substation",[-90.02051723376997, 29.88478641234955]],
    [ "174502051",[-90.6807799897792, 44.01128964515678]],
    [ "174506722",[-90.8034729544529, 43.943120945363034]],
    [ "Monroe",[-90.79197791183415, 43.93050243478802]],
    [ "O. W. Sommers Switchyard",[-98.3236230985315, 29.310242248436346]],
    [ "Walzem Road Substation",[-98.36927128234885, 29.509693726186523]],
    [ "Beck Road Substation",[-98.31848402967825, 29.38198156695736]],
    [ "174525929",[-97.03398672078895, 32.75762485556186]],
    [ "174525936",[-97.0349035104887, 32.690593603168054]],
    [ "174525954",[-97.03508479348234, 32.74433535572422]],
    [ "Irving Grant Street Substation",[-96.94533952003214, 32.81718557765495]],
    [ "Oncor",[-96.97451921277738, 32.81591886144521]],
    [ "Lake Beatrice Switching Station",[-83.256438183946, 31.664997272871535]],
    [ "174534089",[-83.18081259523599, 31.536663974837484]],
    [ "Ocilla Substation",[-83.25175519226036, 31.609897324611122]],
    [ "Monk Road Substation",[-83.4851169, 31.4756556]],
    [ "West Salem Substation",[-91.08590945357152, 43.89378818608448]],
    [ "174549540",[-106.54944975, 35.131443749999995]],
    [ "Karns Substation",[-84.05991435009685, 35.985424001446425]],
    [ "Pawnee Substation",[-98.02379785278599, 28.73984366343541]],
    [ "Wilsonville Substation",[-82.6817087099302, 31.412076275099878]],
    [ "174575938",[-82.42742552847838, 31.247231806581887]],
    [ "Georgia Transmission Corporation",[-82.41523013333331, 31.171314619041883]],
    [ "Folkston Primary Substation",[-82.03237148368784, 30.87991830136484]],
    [ "Georgia Power",[-82.33778475, 31.203988799999998]],
    [ "Cypress Creek Substation",[-98.91333510324824, 29.959201798626527]],
    [ "Offerman Chips Substation",[-82.09821495, 31.414786250000002]],
    [ "Georgia Power",[-81.68158620236483, 31.289901432456983]],
    [ "Coleto Creek Substation",[-97.21257967814556, 28.71682195326534]],
    [ "Lon Hill Substation",[-97.61561257611005, 27.843655486153608]],
    [ "Four Corners Substation",[-97.1644699667614, 28.87161254676184]],
    [ "Calallen Substation",[-97.6462278441242, 27.849226716268806]],
    [ "174693653",[-97.3497848774486, 35.44899661406453]],
    [ "Fannin Substation",[-97.23372229100048, 28.691647278519145]],
    [ "174695768",[-97.24605901556792, 35.47927889743477]],
    [ "Southern Natural Gas Substation",[-81.70118255, 31.21087395]],
    [ "174697780",[-81.70859934999999, 31.100886649999996]],
    [ "Woodbine Substation",[-81.70800174607359, 30.957139728638357]],
    [ "West Brunswick Substation",[-81.55867852139707, 31.279968834958442]],
    [ "174697783",[-81.68005070773907, 30.826084175332017]],
    [ "174697784",[-81.68273046123538, 30.838294194856207]],
    [ "174698342",[-102.07589465778305, 48.351191390723116]],
    [ "174698394",[-102.07471668243419, 48.342970197408334]],
    [ "174701026",[-93.63612690000001, 42.6729647]],
    [ "174701029",[-93.7248049249509, 42.73905719093076]],
    [ "Gohlke Substation",[-96.73319774789489, 28.746453216894007]],
    [ "Whitepoint Substation",[-97.36084027493482, 27.93580575920082]],
    [ "174704415",[-97.44056713102094, 35.4625110972936]],
    [ "174704417",[-97.32191015740436, 35.50683201715097]],
    [ "McKenzie Substation",[-97.57148810000001, 27.80572825]],
    [ "Nelson Sharpe Substation",[-97.6688623217887, 27.56051011409933]],
    [ "Oxy Petro Substation",[-97.58727993910163, 27.81327549149767]],
    [ "174708398",[-97.44681383072404, 35.50088517517537]],
    [ "174709245",[-97.48507475000001, 35.53292655]],
    [ "174709247",[-97.48146903374042, 35.531492213870884]],
    [ "Yulee Substation FPL",[-81.60658341819777, 30.622943249240564]],
    [ "Lobo Substation",[-99.27570768786248, 27.579015997160504]],
    [ "Ajo Switching Station",[-97.77439180269559, 27.092030473578145]],
    [ "Zorillo Substation",[-97.58347305002751, 27.003445895730515]],
    [ "Gulf Wind Substation",[-97.58416265677455, 27.0025438161901]],
    [ "Penascal Substation",[-97.52880737369304, 27.103253209116424]],
    [ "F. Yturria Substation",[-97.76560094999999, 26.640982899999997]],
    [ "Rio Hondo Substation",[-97.61339997028034, 26.27748751185738]],
    [ "174787496",[-113.22165668379343, 37.48493495237124]],
    [ "La Palma 138 kV Substation",[-97.64270960094426, 26.143466828093985]],
    [ "North Edinburg Substation",[-98.18929735758958, 26.344069236758667]],
    [ "La Palma 345 kV Substation",[-97.64277254120252, 26.146585780875792]],
    [ "Moore County Substation",[-101.86303261275175, 35.966739287903266]],
    [ "Valero McKee Substation",[-101.87948908297422, 35.96103909011166]],
    [ "Dumas 19th Street Substation",[-101.96058609998634, 35.84191688657841]],
    [ "Harrington Switchyard",[-101.74725845000003, 35.296447099999995]],
    [ "Cherry Street Substation",[-101.83943710804142, 35.29477782506896]],
    [ "Nichols Switchyard",[-101.74530655000686, 35.28352510361874]],
    [ "174868348",[-101.7952458797991, 34.39909954700592]],
    [ "Arrowhead Substation",[-101.81347370000002, 35.105527050000006]],
    [ "Randall County Interchange",[-101.77574038252655, 35.148467881105404]],
    [ "Livingston Substation",[-84.73279909172913, 45.029504150952334]],
    [ "Audubon Substation",[-95.9913090968234, 46.86090522531936]],
    [ "Christensen Substation",[-96.13474213672822, 46.836771142911395]],
    [ "Gallagher Substation",[-84.13603638304443, 44.27391113685951]],
    [ "Tittabawassee Substation",[-84.18140644357307, 43.5738507086069]],
    [ "Greenwood Substation",[-84.14010308955928, 44.17959327595224]],
    [ "175000622",[-84.60525050000001, 33.98089275]],
    [ "Woodlore Substation",[-84.74025024999999, 33.971769699999996]],
    [ "John Ward Road Substation",[-84.61064284999999, 33.93255995]],
    [ "Huntsville Substation",[-84.86417364971699, 34.01221540645838]],
    [ "175000628",[-84.86367995447142, 34.01285763256329]],
    [ "Portland Substation",[-85.04635669403586, 34.044616779215154]],
    [ "Milford Switching Station",[-84.59794057452044, 33.88712080620142]],
    [ "175000632",[-84.785657895934, 34.00412801579074]],
    [ "Cedarcrest Substation",[-84.7689097, 34.0185953]],
    [ "McConnell Road Substation",[-84.70955430000001, 33.93512129999999]],
    [ "Battlefield Substation",[-84.78572620418092, 33.96142492150682]],
    [ "Milford Substation",[-84.59813598718465, 33.88603757219669]],
    [ "Pegamore Switching Station",[-84.89153589419169, 34.01521943688233]],
    [ "Aragon Primary Substation",[-85.05002349422945, 34.04390851384915]],
    [ "Lost Mountain Substation",[-84.70950544331608, 33.93806417674878]],
    [ "Hampton Substation",[-83.82512363852213, 43.63117157342185]],
    [ "Karn Substation",[-83.83763754766427, 43.64574908182375]],
    [ "Bullock Substation",[-84.2573513136944, 43.57511875848844]],
    [ "Midland Cogeneration Venture Substation",[-84.22494419825802, 43.584157234042756]],
    [ "Murphy Substation",[-84.21659525012689, 43.433010887725864]],
    [ "Nelson Road Substation",[-84.83010880106293, 43.2108297975388]],
    [ "Puget Sound Energy",[-122.92884116196524, 47.044055244886735]],
    [ "Goss Substation",[-83.94331006536056, 43.024026256982324]],
    [ "175144704",[-111.40593030038781, 45.292995432962066]],
    [ "Hunters Creek Substation",[-83.29987022782531, 42.98823967234487]],
    [ "Robin Substation",[-83.1453029989542, 42.939772400257255]],
    [ "Belle River Substation",[-82.49524801583935, 42.77204487759797]],
    [ "Blackfoot Substation",[-83.45335356108436, 42.92344897697771]],
    [ "Crimson Substation",[-83.00554774058622, 42.79873152765575]],
    [ "Acworth Primary Substation",[-84.64967877775541, 34.06160935582873]],
    [ "Marietta Primary Substation",[-84.53565326351888, 33.96152060959219]],
    [ "Cartersville Primary Substation",[-84.810634219603, 34.17997175069388]],
    [ "Allatoona Switching Station",[-84.7185534593302, 34.086270072153845]],
    [ "175158204",[-84.581263, 34.00602009999999]],
    [ "Cobb Place Substation",[-84.56167945000001, 34.0280335]],
    [ "175158206",[-84.55525296602144, 33.98157619535421]],
    [ "175158207",[-84.74228485, 34.140152500000006]],
    [ "Allatoona Substation",[-84.7187927, 34.086671749999994]],
    [ "175158210",[-84.54975351360883, 33.97316165149838]],
    [ "175158211",[-84.66307947510101, 34.06829453767442]],
    [ "175158212",[-84.60724045760243, 34.03100854659115]],
    [ "Georgia Power",[-84.53378507661809, 33.95808243780302]],
    [ "Wikes Substation",[-82.70685473529947, 43.104391998661434]],
    [ "Greenwood Substation",[-82.70193035992945, 43.10311986374032]],
    [ "Kenowa Substation",[-85.82128030414232, 43.179469730485046]],
    [ "Tallmadge Substation",[-85.80883287066338, 42.96955607524745]],
    [ "Brickyard Substation",[-86.05029928194422, 43.421035962636424]],
    [ "Leesburg East Substation",[-81.87072293887968, 28.813518724970486]],
    [ "Puget Sound Energy",[-122.93512120050023, 46.984318369157734]],
    [ "Renaissance Substation",[-84.84303096950767, 43.18709116209662]],
    [ "175344851",[-97.5117245353355, 35.44491207771059]],
    [ "Port Sheldon Substation",[-86.19632744354942, 42.91052842815226]],
    [ "Roosevelt Substation",[-85.97686477546615, 42.83247581769042]],
    [ "Campbell 345kV Substation",[-86.19088338005163, 42.91516592696702]],
    [ "Campbell 138kV Substation",[-86.20015417599188, 42.909927965054926]],
    [ "175354452",[-97.38549726608508, 35.449105291182256]],
    [ "Gaines Substation",[-85.55361378464572, 42.817761397805306]],
    [ "Vergennes Substation",[-85.41540713822228, 43.000030355805315]],
    [ "Manlius Substation",[-86.06611299574848, 42.652913610842404]],
    [ "Zeeland Substation",[-85.99695586119329, 42.82073457239378]],
    [ "Wasco Substation",[-119.326187593843, 35.60194021581158]],
    [ "Oneida Substation",[-84.78512420120848, 42.68562128303194]],
    [ "Leppek Substation",[-82.91341070164052, 43.723381926560016]],
    [ "175481586",[-91.08606899565824, 30.385636917379998]],
    [ "Coventry Substation",[-83.62308382591293, 42.353152004956065]],
    [ "Madrid Substation",[-84.02509575818618, 42.55498843065659]],
    [ "175515669",[-96.19511844254349, 41.204376064939254]],
    [ "Akron Substation",[-83.4672527072087, 42.48760307222796]],
    [ "Quaker Substation",[-83.44229793817834, 42.49021758571609]],
    [ "Wixom Substation",[-83.52823134049558, 42.51286957267556]],
    [ "Alamo Substation",[-83.38592222785171, 42.12640391921518]],
    [ "Sumpter Substation",[-83.44678204984329, 42.13989945302563]],
    [ "Shoal Substation",[-83.35899662900832, 41.93924238172161]],
    [ "Zachary Substation",[-83.4544915977469, 42.23743868120616]],
    [ "Jewell Substation",[-83.00849957615618, 42.71805117254679]],
    [ "Lenox Substation",[-82.84843755183219, 42.72487280734044]],
    [ "175530974",[-96.23273242798071, 43.647082057514034]],
    [ "175541579",[-96.62660071470034, 33.61467024200211]],
    [ "175541594",[-96.61474968310883, 33.67268179222709]],
    [ "175541596",[-96.5920261907374, 33.75892650107277]],
    [ "Southwood Station",[-76.08392173026215, 42.99181943936567]],
    [ "175620362",[-74.84987733120136, 41.928146833997666]],
    [ "Coopers Corners Substation",[-74.76132477305117, 41.66962689690783]],
    [ "Marshville Station 299",[-74.59840491875407, 42.881313108636554]],
    [ "175659729",[-97.66838948000193, 35.55173791658423]],
    [ "Oakdale Substation",[-75.98235159385656, 42.13693871958708]],
    [ "Tully Center Station",[-76.11086228855928, 42.79057552185701]],
    [ "Clarks Corners Substation",[-76.12474270429078, 42.44433089962008]],
    [ "Omaha Public Power District",[-96.0592993782942, 41.25011450621388]],
    [ "Duley Substation",[-73.63660612716728, 44.83147416678601]],
    [ "Plattsburgh Substation",[-73.4934218601517, 44.75929820874573]],
    [ "Willis Substation",[-74.11864694367486, 44.88911450481372]],
    [ "Halvarsson Substation",[-72.9025763681407, 41.28673059349976]],
    [ "175773282",[-72.86790132301772, 40.95925568682711]],
    [ "175775908",[-111.63660547438643, 33.39392154514976]],
    [ "Watercure Substation",[-76.77128513013665, 42.108369926614095]],
    [ "Sorrell Hill Station",[-76.35426256460117, 43.154304721850195]],
    [ "Chapman Substation",[-77.76319860000001, 41.34089405]],
    [ "Lobo Substation",[-77.54105956580618, 41.36992010983303]],
    [ "175826906",[-84.07871854352612, 33.66245671708071]],
    [ "Georgia Power",[-84.00062258129532, 33.74905544704552]],
    [ "Bay Creek Substation",[-83.882373681486, 33.86816614140335]],
    [ "175826910",[-84.04407431890185, 33.6981313568055]],
    [ "Georgia Power",[-84.04274728037724, 33.697658285076294]],
    [ "175846056",[-113.56657246274403, 37.11353437931468]],
    [ "Badoura 115/34 KV Substation",[-94.7222920432942, 46.875500088557764]],
    [ "Badoura 230/115 KV Substation",[-94.7195163364317, 46.87580144922358]],
    [ "Pequot Lakes Substation",[-94.30875711367311, 46.61649675337949]],
    [ "Donaldson Substation",[-96.93398558841722, 48.57177815127893]],
    [ "175905525",[-96.80498759082396, 48.354326729299444]],
    [ "South Mahwah",[-74.14609071687492, 41.086624093536415]],
    [ "South Mahwah",[-74.14611319739274, 41.0845129147527]],
    [ "175921881",[-74.15645361328359, 41.107273571156874]],
    [ "West Haverstraw Substation",[-73.99340225088353, 41.20317578686133]],
    [ "Ladentown Substation",[-74.07595333896342, 41.18392344822553]],
    [ "Glacier Electric Cooperative",[-113.007655974976, 48.55533854265661]],
    [ "175946406",[-97.56690515857815, 35.45972264301141]],
    [ "175951288",[-79.21791325, 40.5324]],
    [ "Handsome Lake Substation",[-79.80821720419374, 41.29145802802518]],
    [ "Shelocta Substation",[-79.3129732252646, 40.63153477001811]],
    [ "Wayne Substation",[-80.0097879341325, 41.515815376425664]],
    [ "Erie South Substation",[-80.04811185657171, 42.069615180221874]],
    [ "176026598",[-97.46027935398318, 35.44109140741975]],
    [ "176026601",[-97.46299521068642, 35.4286354251225]],
    [ "Nashwauk Substation",[-93.14853402360015, 47.37260693203334]],
    [ "176046712",[-79.98128872197157, 42.102606404732214]],
    [ "Erie South Substation",[-79.83572321004519, 42.16568033120981]],
    [ "Forest Substation",[-78.74231340665253, 41.449908226951294]],
    [ "Glade Substation",[-79.0166449456626, 41.834576539094535]],
    [ "Lewis Run Substation",[-78.65944076530786, 41.88092621839913]],
    [ "Warren Substation",[-79.19078766510344, 41.836114840877464]],
    [ "176086924",[-98.11365473786591, 35.48591121242696]],
    [ "176086927",[-97.96319497841219, 35.49285826204717]],
    [ "176086930",[-97.99093409137166, 35.485881649432756]],
    [ "176091653",[-98.3512027395063, 35.48559176827176]],
    [ "176091656",[-98.41323946827701, 35.363486042161085]],
    [ "North Appleton Substation",[-88.35458791107966, 44.368416572218905]],
    [ "Fox River Station",[-88.2076028063813, 44.3216685032876]],
    [ "176106541",[-88.24619982880746, 44.30565399349973]],
    [ "Hintz Substation",[-88.71833883223412, 44.417642511752334]],
    [ "Werner Substation",[-88.71837202508533, 44.41874294193419]],
    [ "Werner West Substation",[-88.71913327498129, 44.42015889559871]],
    [ "176110962",[-88.55840565, 44.387466]],
    [ "Dairyland Power Cooperative",[-91.86796946187152, 45.386802545957714]],
    [ "Kewaunee Station",[-87.53961480000001, 44.342869500000006]],
    [ "Point Beach Station",[-87.53837039388672, 44.280496097640984]],
    [ "Lost Dauphin Substation",[-88.12311623905407, 44.383492599887546]],
    [ "Forest Junction Substation",[-88.13184810000001, 44.220740899999996]],
    [ "SRP Apache Substation",[-111.68509185447297, 33.41377384473547]],
    [ "Edgewater Station",[-87.70794610242518, 43.715050199504994]],
    [ "Howards Grove Substation",[-87.8277338750996, 43.84549001121921]],
    [ "Plymouth Substation 4",[-87.90724818708325, 43.796907824922286]],
    [ "Sheboygan Falls Station",[-87.87638114184439, 43.7519155745186]],
    [ "South Fond du Lac Station",[-88.4944063433893, 43.73492585897319]],
    [ "Cedar Ridge Wind Generation",[-88.32004160257031, 43.73901509706005]],
    [ "Holland",[-87.896039243253, 43.600949396134304]],
    [ "MULLET RIVER",[-87.98146726124467, 43.7377929701315]],
    [ "NORTH MULLET RIVER",[-87.98150375075964, 43.73906046796825]],
    [ "176238753",[-89.6541105633286, 44.86057835829389]],
    [ "176238754",[-89.6551464988381, 44.8585896034472]],
    [ "176238802",[-89.64831563020867, 44.859084798242066]],
    [ "Arpin Substation",[-89.94450415, 44.5579891]],
    [ "Highway 22 Substation",[-88.67474768664518, 44.71994277479146]],
    [ "Badger Substation",[-88.67646423148997, 44.71941661928092]],
    [ "176264953",[-88.43136251280848, 44.78138219333459]],
    [ "Morgan Substation",[-88.19421122138836, 44.8384254171368]],
    [ "176265441",[-111.7938775948411, 42.53611976714649]],
    [ "176265443",[-111.59011081712784, 42.687451059369835]],
    [ "176265448",[-111.69689981669488, 42.64489844651378]],
    [ "Plains Substation",[-87.97341107914951, 45.802184613703176]],
    [ "Thunder",[-88.17783152582057, 45.28422878197487]],
    [ "176273563",[-89.14850264526416, 44.78241811994307]],
    [ "176273565",[-88.83771590832978, 44.72237465358627]],
    [ "Wien Substation",[-90.0783467493735, 44.93478690121647]],
    [ "176276053",[-81.24279715784292, 28.641466145670492]],
    [ "Fitzgerald Substation",[-88.63299902489427, 43.97983281058988]],
    [ "Forward Energy Center",[-88.46188058264906, 43.646554466796296]],
    [ "Barton Substation",[-88.1721765389814, 43.43817738216148]],
    [ "St Lawrence",[-88.31770559360253, 43.35685726710545]],
    [ "176359869",[-88.31950876405642, 43.357046685290015]],
    [ "Dead River Substation",[-87.40720240007356, 46.5771185027125]],
    [ "Presque Isle Station",[-87.39732838048856, 46.57913574215049]],
    [ "Forsyth",[-87.43360515772837, 46.26737908868694]],
    [ "Gwinn",[-87.4376521092949, 46.27555095230917]],
    [ "176408743",[-111.36870833127857, 43.4555844012965]],
    [ "176408757",[-111.84896778362962, 43.37577405496413]],
    [ "176408758",[-110.77096482498698, 43.25157744502917]],
    [ "176408759",[-111.02399716895944, 43.160528955363844]],
    [ "176408764",[-111.91269429396822, 43.683731089148594]],
    [ "176408765",[-111.20344396167862, 43.33555628081255]],
    [ "176411934",[-111.74945780813927, 42.26689927931274]],
    [ "176412334",[-87.99531256097016, 43.16231084690227]],
    [ "Glacier Electric Cooperative",[-113.01979681456636, 48.59588672464556]],
    [ "Columbia Station",[-89.41704626119734, 43.48639144356228]],
    [ "North Randolph",[-89.03698524124923, 43.56399177070529]],
    [ "176434189",[-89.15075324648251, 43.56411511628283]],
    [ "ROCKDALE",[-89.04869853014088, 42.97748667458526]],
    [ "176434192",[-89.03903179874017, 43.36039334184703]],
    [ "176434194",[-89.1580237, 43.570535050000004]],
    [ "176434202",[-89.05996752888822, 43.56764522044595]],
    [ "176434204",[-89.1508665017127, 43.564894144655796]],
    [ "Shannon Substation",[-93.03294790656807, 47.49967265737926]],
    [ "American Transmission Company",[-88.03456906015646, 43.01083095690135]],
    [ "176515494",[-88.06103047289143, 43.073767396621705]],
    [ "176515496",[-88.06097555996288, 43.09920475282104]],
    [ "176515510",[-88.06008329041376, 42.90230459533379]],
    [ "SHEEPSKIN",[-89.11162165, 42.833004100000004]],
    [ "Sheepskin Substation",[-89.11169747474509, 42.83235179626645]],
    [ "176562385",[-89.41957213148447, 43.25572009264207]],
    [ "Stone Lake Substation",[-91.5209739382959, 45.89841333334266]],
    [ "Webster Road Substation",[-84.55918584840816, 38.977859733871405]],
    [ "Stinson Avenue Substation",[-92.05870745171622, 46.69541414459629]],
    [ "176671892",[-92.0596782332908, 46.68479535024196]],
    [ "176671900",[-91.7352039310115, 46.152761896044666]],
    [ "176671928",[-91.7869494055992, 46.23691599929396]],
    [ "Glacier Electric Cooperative",[-113.39522328917637, 48.84340067802566]],
    [ "176676766",[-97.49153040449795, 35.5045869527687]],
    [ "176696219",[-74.07780937809547, 41.57540999502305]],
    [ "East Walden Substation",[-74.15476057794407, 41.57165321016331]],
    [ "Marlboro Substation",[-73.98637604536542, 41.591542631907444]],
    [ "176696227",[-73.96540545104581, 41.57327050610274]],
    [ "176702521",[-73.83280043645115, 41.74097953131983]],
    [ "Whippany Substation",[-74.38007120482698, 40.81949068031577]],
    [ "Charca Substation",[-119.32524748815584, 35.60819667502896]],
    [ "Chamberlin Substation",[-81.47424174434931, 41.30345202636299]],
    [ "Glenhaven Substation",[-102.30841977012801, 31.89038311732053]],
    [ "Byron Station",[-89.28666692105617, 42.07404968219357]],
    [ "Dupont Substation",[-86.39811450276035, 43.39816289958557]],
    [ "Club Substation",[-86.26748815, 43.3683083]],
    [ "Nugent Sand Substation",[-86.23224156718035, 43.34642199300979]],
    [ "176741840",[-88.58749627357528, 41.14349792189759]],
    [ "176741843",[-88.58890720331804, 41.14247508915307]],
    [ "176741844",[-88.58505555693787, 41.14519242127021]],
    [ "Omaha Public Power District",[-95.95749580383888, 41.296314541658624]],
    [ "United States Department of Energy",[-88.80454970931017, 37.11043885707483]],
    [ "Tennessee Valley Authority",[-88.77842988694383, 37.14725146699394]],
    [ "176841715",[-88.6141560598179, 37.03346908515884]],
    [ "176849656",[-88.82325416002456, 37.73150454359381]],
    [ "Norris City North Substation",[-88.277176827087, 38.03142620047107]],
    [ "West Frankfort Substation",[-88.93332385255826, 37.88947069465072]],
    [ "Prairie State Station",[-89.66678258104044, 38.27389104406586]],
    [ "Monroe #2 Substation",[-83.7168266274751, 33.79356445541586]],
    [ "Monroe Switch Station",[-83.69486321856502, 33.81364788338485]],
    [ "Monroe #3 (Old Athens Hwy) Substation",[-83.69629364685025, 33.81727191724847]],
    [ "MPC Substation",[-83.69491649588606, 33.81096833171812]],
    [ "Georgia Power",[-83.80098080980844, 33.82648930278374]],
    [ "Split Silk Substation",[-83.84137610745023, 33.83001166441077]],
    [ "Baldwin Station",[-89.85168774759175, 38.20388079290973]],
    [ "176900440",[-89.8466475678626, 38.197809382920966]],
    [ "Campton Substation",[-83.69928461678484, 33.84703317261775]],
    [ "Walnut Grove Substation",[-83.84895900000001, 33.75997695]],
    [ "Little Ten Substation",[-84.00848438162042, 33.82780626183015]],
    [ "176906112",[-83.68401320000002, 33.78522635]],
    [ "Transco 125 Substation",[-83.68988825000001, 33.83120785]],
    [ "Georgia Power",[-84.06083286817494, 33.84073829310556]],
    [ "Snellville Substation",[-84.04814108926035, 33.83886730360727]],
    [ "176906117",[-83.68501722251634, 33.78598419089763]],
    [ "Doyle Substation",[-83.69879494040984, 33.837912403646925]],
    [ "176907971",[-89.99410367591064, 38.48267833037931]],
    [ "Pinckneyville Station",[-89.34846109844734, 38.111630774100966]],
    [ "Ameren",[-89.34729817513093, 38.11162707678375]],
    [ "176911664",[-89.21835895842753, 38.05296365127092]],
    [ "Ameren",[-89.34667638700284, 38.11424948117656]],
    [ "176915613",[-90.04391021569847, 38.735704744937415]],
    [ "176915614",[-90.09718533920993, 38.824976006803944]],
    [ "Raccoon Creek Station",[-88.53789901227266, 38.69931107843974]],
    [ "Noack Substation",[-111.6560976122562, 33.422978856668735]],
    [ "SRP Spook Hill Substation",[-111.66672708243087, 33.44600809529078]],
    [ "Lemay Lake Substation",[-93.16003747868133, 44.83475307311807]],
    [ "Point Prairie Substation",[-90.89668652132023, 38.869949194412]],
    [ "Warrenton Substation",[-91.136445, 38.89552345]],
    [ "Ameren",[-90.68380126433374, 38.82657756994725]],
    [ "Mid Rivers Substation",[-90.70117727540233, 38.83185874171223]],
    [ "Belleau Substation",[-90.6807390222584, 38.82648946156387]],
    [ "176994165",[-90.2863530321345, 38.91697770763491]],
    [ "Ameren",[-90.1554873087322, 38.8815387243102]],
    [ "White Lake Substation",[-86.34289647687233, 43.43352694564722]],
    [ "177015962",[-111.35989683298706, 42.30841917657409]],
    [ "177018614",[-111.82157732480344, 42.08867377078125]],
    [ "Jefferson Substation",[-112.22079301337156, 43.714765204635704]],
    [ "177038568",[-112.22041484982424, 43.55491965030357]],
    [ "177038570",[-112.16221158419148, 43.467974999472055]],
    [ "Big Grassy Substation",[-112.17036748673486, 44.00111050534906]],
    [ "177038572",[-112.16178682497076, 43.43909310548078]],
    [ "Kingdom Substation",[-91.94947622076829, 38.925642626885725]],
    [ "Holland Station",[-88.75919704999998, 39.22142415]],
    [ "Neoga Substation",[-88.47430398997125, 39.27710285260797]],
    [ "Newton Station",[-88.27472326873843, 38.93877435563123]],
    [ "Ramsey Substation",[-89.02876311477031, 39.18491603259762]],
    [ "177059137",[-88.47675304999999, 39.27756004999999]],
    [ "177059142",[-88.75927809118743, 39.22265850114955]],
    [ "177066210",[-119.08652760047701, 43.5498586831804]],
    [ "177067934",[-111.99710131980595, 32.87888213672666]],
    [ "Coffeen Station",[-89.40028383639702, 39.06324048524796]],
    [ "177068521",[-90.13329060149803, 38.864634680697634]],
    [ "177075520",[-123.04682234172975, 44.57131880717065]],
    [ "Fry Substation",[-123.03675355798939, 44.58956098673491]],
    [ "Pawnee Substation",[-89.59426666313827, 39.59135540995119]],
    [ "Pana",[-89.0800506887126, 39.40858164732065]],
    [ "Lanesville Substation",[-89.33534028436783, 39.85122536213634]],
    [ "Pontiac Midpoint Substation",[-88.59893392237356, 40.84200248324922]],
    [ "Brokaw Substation",[-88.90439406805284, 40.45265977455744]],
    [ "Corn Belt Energy Corporation",[-88.90258730000001, 40.45323470000001]],
    [ "Tazewell",[-89.53745655323665, 40.562182127492726]],
    [ "177084172",[-95.92852212500979, 41.31001749376406]],
    [ "North Loop Substation",[-111.12464937660795, 32.39985902440878]],
    [ "Thornydale Substation",[-111.12370039098302, 32.425832548246994]],
    [ "Lakeshore Substation",[-111.88463790267106, 32.51692932489301]],
    [ "Blue Mound Substation",[-88.79739966242687, 40.47884066639943]],
    [ "177188601",[-88.59281659999999, 40.4637308]],
    [ "177188602",[-88.70143219670994, 40.45849092670793]],
    [ "Clinton Station",[-88.83158037742857, 40.17417245874081]],
    [ "Fairfax Substation",[-91.772845496404, 41.91520360901417]],
    [ "Yaak",[-115.98772508578341, 48.59959426632761]],
    [ "Beverly Substation",[-91.70185639809891, 41.9307691990022]],
    [ "PMX Casting House",[-91.69978531541064, 41.926849485696266]],
    [ "177236153",[-110.98958296713292, 32.25313208618411]],
    [ "Del Cerro Substation",[-111.04291829630976, 32.29707255153106]],
    [ "Del Bac Substation",[-110.98840234251229, 32.13540283573638]],
    [ "Tucson Substation",[-110.97593061467305, 32.22970335794776]],
    [ "West Ina Substation",[-111.06144010452826, 32.3361988909591]],
    [ "DeMoss Petrie Substation",[-110.99328743035723, 32.25401588296051]],
    [ "Ameren",[-88.60129117100128, 40.107173566196145]],
    [ "Pyramid Peak Substation",[-112.19411239803497, 33.74133707392951]],
    [ "Sidney Substation",[-88.05501827068936, 40.023669475544935]],
    [ "Bunsenville Substation",[-87.69935019959075, 39.99276336916337]],
    [ "Argyle Substation",[-88.94606832912243, 42.36320325348584]],
    [ "Lookout Substation",[-121.13812515, 41.207611050000004]],
    [ "177431183",[-104.41353332177867, 32.58067980755896]],
    [ "Katella Substation",[-117.90072188673668, 33.804393131164325]],
    [ "177515078",[-82.62796333047383, 28.46179084729461]],
    [ "Eaton Park Substation",[-81.90620068802932, 28.011936287824252]],
    [ "ComEd Lombard Substation",[-88.04338391378145, 41.89447789125819]],
    [ "Commonwealth Edison",[-88.26750754447318, 41.858955116112824]],
    [ "Commonwealth Edison",[-88.26374374063572, 41.82006440994502]],
    [ "Fermilab Master Substation",[-88.2554424405773, 41.844609214230495]],
    [ "Fermilab Kautz Road Substation",[-88.25978211150432, 41.82333479475301]],
    [ "Ultra Power Substation",[-121.64085399999998, 40.90970634999999]],
    [ "Hat Creek 2 Substation",[-121.54862077849754, 40.96109258566206]],
    [ "Zion Substation",[-87.8053876439624, 42.44672989726257]],
    [ "North Chicago Substation",[-87.87647245340153, 42.32111474001991]],
    [ "Carter Hill Substation",[-83.75262834313862, 33.95072516969473]],
    [ "Bold Springs Substation",[-83.81523472684626, 33.927977141986204]],
    [ "Canby 1 Substation",[-120.88104530488464, 41.4448230773581]],
    [ "Canby 2 Substation",[-120.8801638, 41.44402675]],
    [ "Lake Bluff Substation",[-87.86663105000002, 42.2785672]],
    [ "Colonial Substation",[-84.63012479776182, 33.85643215874089]],
    [ "Georgia Power",[-83.99197198258587, 33.90329735567243]],
    [ "Cobb Hospital Substation",[-84.60831631720579, 33.8576721666732]],
    [ "177843295",[-83.79829125, 31.993068749999996]],
    [ "177843296",[-83.77233292495858, 31.9511066585506]],
    [ "177843297",[-83.74179102450937, 31.965060757143164]],
    [ "177843298",[-83.73088861226566, 31.96182912664073]],
    [ "177843299",[-83.56279781160859, 31.986590500328568]],
    [ "177843300",[-83.74074327765922, 31.9650569824634]],
    [ "177844295",[-89.7779777218116, 43.62615211802754]],
    [ "177850732",[-83.47862934999999, 32.30483495000001]],
    [ "Waterford",[-83.58347355000002, 32.5445256]],
    [ "Georgia Power",[-83.64521676045794, 32.42406922456508]],
    [ "Perdue Substation",[-83.62699525000001, 32.441358449999996]],
    [ "177850738",[-83.59642122459648, 32.48608365706995]],
    [ "Perry Primary Substation",[-83.70202078828873, 32.45538142014389]],
    [ "Georgia Power",[-83.58331780000002, 32.4845687]],
    [ "Mid-Georgia Cogeneration Substation",[-83.60269805478801, 32.48513556428039]],
    [ "Medusa Portland Cement Substation",[-83.63087558068196, 32.41714672952308]],
    [ "Dawson Crossing Substation",[-84.13357534916621, 34.378118491929044]],
    [ "Palmer Creek Substation",[-84.08229915, 34.39286145]],
    [ "Matt Substation",[-84.15576981703316, 34.2958989381593]],
    [ "Dawson Forest Substation",[-84.12056093401091, 34.37578757564883]],
    [ "177914130",[-89.64458558290103, 43.58071653535795]],
    [ "Portage",[-89.4667914662154, 43.54798230235227]],
    [ "Butterfield Substation",[-88.04592600000002, 41.833309150000005]],
    [ "Romeoville Substation",[-88.09483006998977, 41.63820943563352]],
    [ "Kimball Bridge Substation",[-84.27601224166798, 34.05785257469792]],
    [ "Deerfield / US Highway 9 Substation",[-84.2666528922645, 34.09863932390954]],
    [ "Alpharetta Substation",[-84.31103862463117, 34.06395135549863]],
    [ "Busbee Parkway Substation",[-84.58528529878598, 34.05011205082313]],
    [ "Windward Substation",[-84.2430937460041, 34.097418279319534]],
    [ "Arnold Mill Road Substation",[-84.37853906624113, 34.10558738289209]],
    [ "Woodstock Switch Station",[-84.51309319487706, 34.08661291362203]],
    [ "Woodstock Substation",[-84.51345276890717, 34.0852785509804]],
    [ "Hawkins Store Road Substation",[-84.55458823047067, 34.05714317500167]],
    [ "Milton Substation",[-84.27612878180821, 34.15593077443504]],
    [ "Georgia Power",[-84.2298793599703, 34.129279814833666]],
    [ "Mountain Park Substation",[-84.42421087531335, 34.06720787249577]],
    [ "Georgia Power",[-84.46722788452179, 34.09864931348944]],
    [ "Ocee Substation",[-84.22913762840801, 34.057453972168794]],
    [ "Hopewell Substation",[-84.28344867370843, 34.17427803349063]],
    [ "177935035",[-89.09515623712473, 43.40297331180683]],
    [ "Red Bank Substation",[-74.07088491991479, 40.339045662542624]],
    [ "NJT Red Bank Substation",[-74.0713371035973, 40.34466581029874]],
    [ "Maybreeze Substation",[-84.51645445, 34.0534549]],
    [ "Georgia Power",[-84.22400048462202, 34.01533012230791]],
    [ "Georgia Power",[-84.2252350258426, 34.018337457371864]],
    [ "Georgia Power",[-84.20573562338762, 33.96982659436163]],
    [ "178028242",[-115.87095260283706, 48.44196858258575]],
    [ "Troy",[-115.87028444999999, 48.44185989999999]],
    [ "178059641",[-85.89593797421652, 39.72470320532547]],
    [ "178083909",[-87.2568268637903, 40.569051600640336]],
    [ "178083911",[-87.01720432460867, 40.6271019585735]],
    [ "178083913",[-87.41738942478081, 40.56424159049592]],
    [ "178083914",[-87.38087715000002, 40.57896475]],
    [ "178083915",[-87.26689960882422, 40.60681797400042]],
    [ "Meadow Lake Substation",[-86.93447813446193, 40.653123287151345]],
    [ "178083917",[-87.33401561730201, 40.57787226473029]],
    [ "178083918",[-87.41775943909633, 40.56480642150301]],
    [ "South Prairie Sub",[-86.93574158888657, 40.6476486250677]],
    [ "178087554",[-86.99590067622009, 40.705926936420596]],
    [ "Bass Lake Sub",[-86.62164145, 41.22279905]],
    [ "Garkane Energy Cooperative",[-112.97428350489095, 36.97040781528851]],
    [ "178163386",[-86.49095655261779, 41.97402799935862]],
    [ "Prairie Creek Generating Station",[-91.63889327354616, 41.944745744432524]],
    [ "Prairie Creek Industrial Substation",[-91.64983104129809, 41.9385401753027]],
    [ "178211446",[-87.0447360955086, 41.565081007241055]],
    [ "Crosstown Substation",[-94.5761064445122, 39.09084882279082]],
    [ "Georgia Power",[-84.50870985, 34.18348535]],
    [ "Birmingham Substation",[-84.33071912546498, 34.165172259231575]],
    [ "Blankets Creek Substation",[-84.50801226535135, 34.18575676777136]],
    [ "Canton Substation",[-84.49510876720343, 34.23943580869537]],
    [ "Orange Substation",[-84.40536696207226, 34.24248200532002]],
    [ "Georgia Power",[-84.43271400265677, 34.2905510214455]],
    [ "178252140",[-88.68826935838096, 43.16662506303846]],
    [ "Pucket Substation",[-101.93597592235066, 35.177542871883155]],
    [ "Gleason Lake Substation",[-93.50289966952985, 44.98125625293359]],
    [ "Consolidated Gold Mine Substation",[-83.97458134170095, 34.53718861860804]],
    [ "178383458",[-88.23868327344503, 42.09373914971562]],
    [ "Erie Road Substation",[-95.78971115, 44.470676499999996]],
    [ "178419484",[-97.54863546454939, 35.442904707383256]],
    [ "178423711",[-97.54395207858146, 35.41173385298004]],
    [ "Saratoga Substation",[-95.79201136139419, 44.4465640076495]],
    [ "Marshall 115/69 Substation",[-95.7364512789362, 44.487546810184035]],
    [ "Southwest Substation",[-95.80404002490567, 44.42580246111168]],
    [ "Lyon County Substation",[-95.67391560134097, 44.47355216985236]],
    [ "Switching Substation",[-95.75700561965553, 44.47155844000359]],
    [ "Williston",[-103.73224975599034, 48.14401580173752]],
    [ "178533720",[-84.57190761636913, 38.65135748052229]],
    [ "178560634",[-85.4885293569556, 32.599928292078786]],
    [ "178560635",[-85.49958675829136, 32.60132437342945]],
    [ "Ghent Substation",[-95.90053589635271, 44.51625056739918]],
    [ "Francisco Substation",[-87.42374418573294, 38.322099556218504]],
    [ "Gibson Station",[-87.7638508324255, 38.37449691977155]],
    [ "Duff Substation",[-87.02405276736529, 38.31168581676884]],
    [ "Eugene Substation",[-123.14646073652465, 44.075531615648174]],
    [ "Bethel Substation",[-123.14497261938395, 44.07579100837306]],
    [ "Enid Substation",[-123.1774996960955, 44.11679415716371]],
    [ "Petersburg Station",[-87.24945873359594, 38.52735300300919]],
    [ "Wheatland Station",[-87.29176165545658, 38.67222499018373]],
    [ "178686299",[-87.71794794402983, 37.906315898162944]],
    [ "178686304",[-88.07453773835967, 38.36379235710828]],
    [ "178686308",[-87.7248155, 37.90807015]],
    [ "178686309",[-87.72178847672876, 37.90746920980917]],
    [ "178686313",[-87.86297594621453, 38.35911382544059]],
    [ "Staley Road Substation",[-94.55564357784604, 39.2816685099834]],
    [ "178722864",[-87.42686171513925, 39.92523836162484]],
    [ "178722902",[-87.43861584540771, 39.92003512152886]],
    [ "178722910",[-87.25018045683895, 38.79537100865526]],
    [ "178722914",[-86.45052337558187, 38.6895791398689]],
    [ "178722916",[-87.44634201725943, 39.925047634234225]],
    [ "Georgia Power",[-84.6730627500227, 34.243563416682846]],
    [ "Georgia Power",[-84.785834, 34.23627075]],
    [ "Georgia Power",[-84.79519459999999, 34.2319088]],
    [ "Georgia Power",[-84.79862885, 34.2204778]],
    [ "Georgia Power",[-84.51039231664805, 34.32811510008754]],
    [ "Georgia Power",[-84.74014851340445, 34.220896123763296]],
    [ "Anheuser-Busch Substation",[-84.77915043630672, 34.26066397066182]],
    [ "Gerdau Ameristeel Substation",[-84.79612440332771, 34.24419768299779]],
    [ "178742274",[-84.57931615, 34.27484465]],
    [ "178742281",[-84.77906389410623, 34.209904560667596]],
    [ "Shalimar Substation",[-86.55862353767641, 30.465709274896142]],
    [ "Columbus Substation (345kV)",[-85.86967075326154, 39.17398139935403]],
    [ "178827444",[-113.11005315000001, 37.66266045000001]],
    [ "Bloomington Substation (230kV)",[-86.52037058000617, 39.29610577243835]],
    [ "Columbus Denois Creek Substation",[-85.95978828046044, 39.165436516152894]],
    [ "178843573",[-85.93890869752548, 39.16586949211819]],
    [ "178863890",[-87.4243725093821, 39.5264933258264]],
    [ "178863902",[-87.14366574289971, 39.47639264408307]],
    [ "178863927",[-87.39181581344843, 39.532344774831316]],
    [ "178863929",[-87.42456221596258, 39.52863297220851]],
    [ "178883952",[-86.11232228678004, 39.642729674879995]],
    [ "178883954",[-86.07113925, 39.67913059999999]],
    [ "Frances Creek Substation",[-86.17241873870618, 39.604355469220195]],
    [ "178883974",[-86.18547990693396, 39.59529314787673]],
    [ "178902775",[-87.24606670206934, 38.80538247524132]],
    [ "178902779",[-87.24527731972246, 38.804463413171405]],
    [ "Amo Substation",[-86.62831574197834, 39.709006278018485]],
    [ "Nucor Substation",[-86.83172810350746, 39.97176122885839]],
    [ "Qualitech Substation",[-86.48340964836038, 39.878287511367226]],
    [ "Whitestown Substation",[-86.30647805421593, 39.982462101186364]],
    [ "178910781",[-86.4831028604712, 39.87757992125163]],
    [ "178910784",[-86.83174457815872, 39.972482384871114]],
    [ "Guion Substation",[-86.2282434504312, 39.855917669918234]],
    [ "Rockville Substation",[-86.30466645811666, 39.78408118110692]],
    [ "178915009",[-86.3142957792091, 39.74877546520528]],
    [ "178915020",[-86.2733128, 39.845441199999996]],
    [ "178915021",[-86.29774055101234, 39.805738085205974]],
    [ "Coulter Substation",[-101.91939396964156, 35.16107486485371]],
    [ "Batesburg Substation",[-81.56442820736346, 33.91349080243373]],
    [ "178966493",[-79.56320175370743, 33.47135974236315]],
    [ "Hortonville Substation",[-86.16640091502362, 40.09410123013533]],
    [ "Noblesville Substation",[-85.97274099716151, 40.098446295422875]],
    [ "Noblesville Substation (69kV)",[-85.97246593883293, 40.09587498966319]],
    [ "179005751",[-85.91528279999999, 39.793510100000006]],
    [ "German Church Rd. Substation",[-85.9698269229188, 39.819887460789175]],
    [ "Anderson",[-85.73954854818756, 40.05344294858636]],
    [ "Prescott Substation",[-85.72539661930901, 39.49174306847409]],
    [ "179069954",[-81.28641045351446, 33.99602542300544]],
    [ "179069955",[-81.36606854999998, 33.99202499999999]],
    [ "Mayfield",[-85.3215759004275, 40.19248275162639]],
    [ "Soncy Substation",[-101.92112482505725, 35.18779464143178]],
    [ "Speed Substation",[-85.75485693951886, 38.440557324741256]],
    [ "179127837",[-86.96168205, 38.32193135]],
    [ "179127844",[-86.28242877057224, 38.35906024385701]],
    [ "Grant Line Substation",[-85.80932417717537, 38.38248838612132]],
    [ "Duke Energy",[-85.9749764600961, 38.3086999752643]],
    [ "Hoosier Energy",[-86.1717503345384, 38.32996081314355]],
    [ "St. Joe Substation",[-85.78536484163833, 38.40251715477854]],
    [ "179127856",[-85.97239859848084, 38.30843988346618]],
    [ "Duke Energy Peru Southeast Substation",[-86.03808931588323, 40.72848706131841]],
    [ "Walton Substation",[-86.2604303256789, 40.67772568029972]],
    [ "179214750",[-86.10028202355352, 40.92649978409209]],
    [ "Bloomingdale Substation",[-71.76395276368582, 42.270357470076576]],
    [ "Sunset Substation",[-101.94030602498998, 35.20661239308339]],
    [ "Station 37",[-77.66043610586574, 43.150999012592976]],
    [ "179302123",[-77.45750480004196, 42.57618595045673]],
    [ "Meridian",[-85.46727128199099, 41.06386840345302]],
    [ "Montour Falls Substation",[-76.84228939564143, 42.327782947239434]],
    [ "179362310",[-76.9102499862344, 42.35999579431309]],
    [ "Hickling",[-76.98302485376044, 42.12359378844713]],
    [ "179385271",[-82.69648725, 28.0494661]],
    [ "South Butler Substation",[-84.92135266937835, 41.36903084350848]],
    [ "179395052",[-93.40624957067621, 45.1153833973171]],
    [ "Woodward Substation",[-119.75101778860953, 36.8962787237581]],
    [ "179523700",[-84.06497535606773, 40.26033253250673]],
    [ "179559744",[-82.90995815275468, 40.26144692366514]],
    [ "Georgia Power",[-84.92546030000001, 34.125691350000004]],
    [ "179562474",[-80.21282188628406, 26.076654531012924]],
    [ "Big Swan Substation",[-94.2807192609318, 45.09258112586211]],
    [ "179652719",[-94.29419680879406, 45.14200614891427]],
    [ "Otsego Substation",[-93.58059717161592, 45.281305048702144]],
    [ "179714709",[-84.86459876990914, 34.129576941771575]],
    [ "Gainesville Substation #2",[-83.80967281686584, 34.26302200225279]],
    [ "Frankfort Substation",[-86.57584994604527, 40.299870530836095]],
    [ "Lafayette 230 Substation",[-86.85323789859297, 40.43100467953394]],
    [ "Thorntown Substation",[-86.61303686413656, 40.113378781568485]],
    [ "Brownsville Substation",[-123.01467091632628, 44.38920251698578]],
    [ "Tipton West Substation",[-86.09175119775085, 40.27617904717617]],
    [ "Whitesville Substation",[-86.80404670787513, 39.96392956857142]],
    [ "Greensboro Substation",[-85.45907069751019, 39.881962070723944]],
    [ "East Point Water Works Substation",[-84.45220133391364, 33.69049268700319]],
    [ "Georgia Power",[-84.46815383096461, 33.81763205464885]],
    [ "Cascade Heights Substation",[-84.4654317045313, 33.72320589555879]],
    [ "West Frankfort Substation",[-84.96202277847102, 38.16358126287473]],
    [ "Duke Energy",[-85.45274966058602, 38.578582163858485]],
    [ "Vesta Substation",[-85.56166142895367, 38.49669230183307]],
    [ "179907675",[-85.00593015673356, 38.44455639774244]],
    [ "179907676",[-85.48548511824679, 38.70232817987834]],
    [ "179908048",[-85.07058916640882, 38.72583986106399]],
    [ "179941423",[-109.27744554999998, 34.06373265]],
    [ "179941424",[-109.27910229087966, 34.0632455754494]],
    [ "Galion Substation",[-82.79966461658172, 40.69422867684595]],
    [ "South Berwick Substation",[-83.29922776146418, 41.020881343701376]],
    [ "Ohio Central Substation",[-82.01842396497257, 40.096390518180584]],
    [ "Georgia Power",[-84.49854107183897, 33.74917880154314]],
    [ "Georgia Power",[-84.4918896641548, 33.81625278609493]],
    [ "Georgia Power",[-84.49062661480657, 33.693200218085586]],
    [ "Georgia Power",[-84.484245782313, 33.821734390183266]],
    [ "Conesville Station",[-81.87841334077258, 40.18353003131247]],
    [ "Granite Falls Public Utilities",[-95.5344959993194, 44.81172434516618]],
    [ "Vinoy Substation DUKE",[-82.63448005000001, 27.7768159]],
    [ "Omaha Public Power District",[-96.04110120048624, 41.307285737313165]],
    [ "180120063",[-101.19940939869863, 47.070075989865785]],
    [ "Georgia Power",[-84.615624707534, 33.68564252562629]],
    [ "Georgia Power",[-84.62108703039179, 33.62938741482168]],
    [ "180131606",[-84.2714294888019, 33.38271644081775]],
    [ "Woolsey Substation",[-84.364253, 33.404223300000005]],
    [ "Georgia Power",[-84.51939263276792, 33.44902861602979]],
    [ "180131626",[-84.33115415000002, 33.4765965]],
    [ "180131628",[-84.2599920646209, 33.31996737496517]],
    [ "180188818",[-84.8394021288904, 33.7011473609933]],
    [ "Hoytdale Substation",[-80.33467098992146, 40.850633103023654]],
    [ "180200942",[-84.32094142853849, 38.03012196847868]],
    [ "180200943",[-84.08414631653473, 38.11201983357782]],
    [ "Gay - Lamar EMC Substation #4",[-84.5893482442118, 33.136806334140196]],
    [ "Molena Primary Substation",[-84.4829321, 33.03876030000001]],
    [ "180202046",[-84.50260402997888, 33.05762758610909]],
    [ "Moreland Substation",[-84.77802678166002, 33.308932252748775]],
    [ "W.L. Bonnell Substation",[-84.81411539999999, 33.3791624]],
    [ "Georgia Power",[-84.83746823810985, 33.383514568748936]],
    [ "Grandview Substation",[-102.3549628706326, 31.90288114542399]],
    [ "Odessa Substation",[-102.35422078947771, 31.848359603985987]],
    [ "Central Hardin Substation",[-85.9322994692607, 37.66889072991543]],
    [ "180206192",[-85.99593366340305, 37.910210896930984]],
    [ "Enon Grove Substation",[-85.01446505795813, 33.325359629725725]],
    [ "Chattahoochee Energy Facility Switchyard",[-85.03765958444275, 33.40826776983779]],
    [ "Wansley Combined Cycle Switchyard",[-85.03605624055673, 33.40710886824271]],
    [ "Wansley Unit #9 Switchyard",[-85.03849457658278, 33.40926555498438]],
    [ "Moultrie Primary Substation",[-83.77569748666174, 31.216769272980276]],
    [ "Moultrie Switching Station",[-83.7757184, 31.21594165]],
    [ "180260212",[-80.56407146523034, 35.80669516068138]],
    [ "180260214",[-80.88599496149901, 35.65992477753168]],
    [ "180260215",[-80.15679166341111, 36.07174579159484]],
    [ "180287250",[-76.47281324413098, 42.404200723460804]],
    [ "180288848",[-85.41323784036186, 38.390879566276745]],
    [ "Louisville Gas & Electric",[-85.70344033234166, 38.039384519807335]],
    [ "180288851",[-85.41158506545291, 38.58148535588232]],
    [ "180288858",[-85.41228972961434, 38.39141595925564]],
    [ "Wallace Substation (115kV)",[-77.98043949094911, 34.72284086570005]],
    [ "180344448",[-77.89280671250525, 34.385872222326284]],
    [ "Wallace Substation",[-77.96275774063383, 34.72448745813561]],
    [ "Junction City Substation",[-123.22127726039913, 44.214758375356766]],
    [ "180346026",[-82.27347395, 41.42346074999999]],
    [ "Ector Harper Substation",[-102.52815550241152, 31.798425213437163]],
    [ "180464804",[-93.90292774793483, 45.590185923199066]],
    [ "Granite City Substation",[-94.14164536760254, 45.575852823826544]],
    [ "Benton County Substation",[-94.0387814917227, 45.56910623098111]],
    [ "Midland West Substation",[-102.12479187248404, 31.996434538291535]],
    [ "Armstrong Substation",[-94.16180602266103, 44.76962542087817]],
    [ "180583937",[-79.79149684565532, 33.884259862564285]],
    [ "180622018",[-114.7141783067488, 32.73818688680093]],
    [ "Blooming Grove Substation",[-75.14934277506157, 41.37742775987909]],
    [ "Bushkill Substation",[-75.02426211630872, 41.0785554766006]],
    [ "Shawnee Substation",[-75.05979664086422, 41.060438441475995]],
    [ "Newton Substation",[-74.74035263505026, 41.05572714065791]],
    [ "180632308",[-82.66529115000002, 28.313149400000004]],
    [ "Hartwell Avenue Substation",[-71.25727440746118, 42.470539909855745]],
    [ "I-94 Substation",[-94.1178304968638, 45.471326203390845]],
    [ "180762505",[-116.25432602970629, 33.7259223699592]],
    [ "180772855",[-77.51520335904787, 34.76259611153558]],
    [ "Jacksonville Substation",[-77.44701518073101, 34.80333504317532]],
    [ "Four County EMC",[-77.83029394808547, 34.474766155873795]],
    [ "CPM Substation",[-121.07057113831955, 38.64679453305253]],
    [ "Shingle Springs Substation",[-120.94727985411951, 38.65930390557815]],
    [ "Western Area Power Administration",[-121.18981950114232, 38.65631536614849]],
    [ "State Line Substation",[-80.52530002994389, 40.638950705839974]],
    [ "180922096",[-79.5353199, 39.18446125]],
    [ "180922102",[-79.29537090750128, 39.40277363886532]],
    [ "180922118",[-79.45338043768847, 39.26867327707587]],
    [ "502 Junction Substation",[-80.0327893276596, 39.74054293142436]],
    [ "North Longview",[-79.96041755434179, 39.727842891149464]],
    [ "Titusville Substation FPL",[-80.81423154035234, 28.610506089668323]],
    [ "Clearway Energy Operating LLC",[-79.2219177731875, 39.20106583878833]],
    [ "181002530",[-80.97934559999999, 34.9498265]],
    [ "181002531",[-80.97957875753275, 34.950204394077]],
    [ "Montevideo Substation",[-95.72208495160983, 44.940334927372874]],
    [ "Tollway Electrical Substation",[-88.14773703708993, 41.80531790139435]],
    [ "Havelock Substation",[-76.9442314352363, 34.9136280515005]],
    [ "Jacksonville City Substation",[-77.4278093002259, 34.75740781204543]],
    [ "181043726",[-76.94442664923235, 34.9145018464783]],
    [ "181043728",[-77.22471089999999, 34.81279745]],
    [ "181043729",[-77.38437435005197, 34.75943402426427]],
    [ "181043730",[-77.3528631730308, 34.73123384498287]],
    [ "Jones-Onslow EMC",[-77.25271588697746, 34.78427691379839]],
    [ "Carteret-Craven Electric Cooperative",[-77.18147182554571, 34.85176683082479]],
    [ "181043734",[-77.25217107924682, 34.78465859889327]],
    [ "181043735",[-77.44261503891953, 34.8038183370435]],
    [ "181043736",[-77.32838696826907, 34.74182702814368]],
    [ "181043737",[-77.33601973715803, 34.675672788399844]],
    [ "181043738",[-77.42287490970173, 34.77762342729071]],
    [ "181043740",[-77.35240745432813, 34.73051658915651]],
    [ "Moshannon Switching Station",[-78.25169902659384, 41.19374045275169]],
    [ "Shawville Substation",[-78.36687711109342, 41.06656525738222]],
    [ "Elko Substation",[-78.59869379511697, 41.36507637176788]],
    [ "Carbon Center Substation",[-78.52052757136607, 41.41375926728583]],
    [ "Quehanna Substation",[-78.3054978, 41.22031215]],
    [ "Lewistown Substation",[-77.59022637213411, 40.580312549333456]],
    [ "Milesburg Substation",[-77.78691013621808, 40.94061615145299]],
    [ "Yeagertown Substation",[-77.57724588698053, 40.63344698280074]],
    [ "Dale Summit Substation",[-77.79326552962131, 40.82639699195982]],
    [ "Steelton Substation",[-76.82253113087408, 40.223471275183705]],
    [ "Steelton Substation",[-76.82125335255806, 40.22454299703145]],
    [ "Dauphin Substation",[-76.90674102879646, 40.38402841407414]],
    [ "Altoona Substation",[-78.3254347747729, 40.466263325700645]],
    [ "Hooversville Substation",[-78.9218075742341, 40.15647208701205]],
    [ "Raystown Substation",[-78.0360962, 40.4557667]],
    [ "Quemahoning Substation",[-78.93040683716251, 40.19311978609302]],
    [ "Tower 51 Substation",[-78.97922351418887, 40.296482798238365]],
    [ "Bearrock Switching Station",[-78.56626749976131, 40.40222862114096]],
    [ "Bearrock Substation",[-78.56650047798564, 40.401688548395896]],
    [ "Duke Energy Progress",[-76.89738475389221, 34.88335912538347]],
    [ "181211144",[-76.89766174999998, 34.8800636]],
    [ "181211145",[-76.85098144999999, 34.781025099999994]],
    [ "181211148",[-76.80431438462827, 34.7484622166485]],
    [ "Morehead Wildwood Substation",[-76.80309325166297, 34.748530098083215]],
    [ "181211151",[-76.90893316271034, 34.858900652530345]],
    [ "181211153",[-76.75043096446696, 34.73171708967021]],
    [ "New Bern West Substation",[-77.12355116823053, 35.141324915312914]],
    [ "Basin Road Substation",[-75.60333484579988, 39.696536854610336]],
    [ "181212738",[-100.6455546447311, 39.11840594391409]],
    [ "181228469",[-83.79828348121823, 41.5193893021765]],
    [ "181301312",[-77.16843415974618, 35.1284777231041]],
    [ "Wommack Substation",[-77.66462842949986, 35.2222869866791]],
    [ "181307180",[-78.09011764636524, 35.33560698476182]],
    [ "181307181",[-78.06021545, 35.303815]],
    [ "181307182",[-78.03035177572399, 35.26011128903017]],
    [ "Grants Pass Substation",[-123.2781439647203, 42.44707411242442]],
    [ "Nickel Mountain Substation",[-123.41028511294105, 42.93117761305748]],
    [ "Fairview Substation",[-123.564828467817, 43.17769849345577]],
    [ "Martin Creek Substation",[-123.11341386536546, 43.7418424189625]],
    [ "Edes Substation",[-122.19378028765334, 37.73861002549261]],
    [ "Tahkenitch Substation",[-124.08292676088918, 43.74300574761024]],
    [ "Pacific Power",[-124.19094096562809, 43.34141805834007]],
    [ "181457829",[-120.38140530764026, 38.14454834997422]],
    [ "181492749",[-117.238988, 34.08225989999999]],
    [ "Calectric Substation",[-117.3171684424656, 34.09339706950279]],
    [ "San Bernardino Substation",[-117.23893736774644, 34.07992646254832]],
    [ "Dakota Electric",[-92.91320004191815, 44.739126630787034]],
    [ "Diamond Hill Substation",[-123.0478968526023, 44.24771150233705]],
    [ "181528983",[-77.762254594594, 35.7476540161371]],
    [ "181528987",[-77.76335426045266, 35.7494356504748]],
    [ "181528989",[-77.7104575, 35.706093100000004]],
    [ "181528991",[-77.86265071290124, 35.78033667955488]],
    [ "Elm City Substation",[-77.86170806900613, 35.78114731102556]],
    [ "Greenville Substation",[-77.3655115501119, 35.625823680042096]],
    [ "181529004",[-77.4324081001348, 35.61377096463813]],
    [ "181554505",[-123.41092926494001, 46.154680725210504]],
    [ "181554548",[-123.37091102611626, 46.195567270298845]],
    [ "Bonneville Power Administration",[-123.84067329725686, 46.142333342259484]],
    [ "N-225B",[-122.06352330240183, 37.41819823995342]],
    [ "Melones Substation",[-120.52764856762444, 37.94624704078851]],
    [ "181655705",[-93.44018066743371, 44.75311404443988]],
    [ "181655706",[-93.52104826372172, 44.752604059997566]],
    [ "Georgia Power",[-84.24495844994512, 33.8850311502482]],
    [ "Glenn Substation",[-122.14275550901117, 39.7778127340254]],
    [ "Lomas Sub",[-106.6472233999618, 35.09035304065181]],
    [ "181864309",[-120.58416193735066, 36.65174445362844]],
    [ "181914725",[-120.13856278012959, 36.40207597078657]],
    [ "181932958",[-119.10557490150194, 47.39908511281856]],
    [ "Golden Rock Substation",[-71.20357054278466, 42.742623606812955]],
    [ "181967040",[-110.20385890378492, 32.189715624390494]],
    [ "Hackberry Substation",[-109.60456745000002, 32.87507010000001]],
    [ "181967050",[-109.31311796051646, 33.02943313496383]],
    [ "Morenci Substation",[-109.27513695223062, 32.98853781891867]],
    [ "181967062",[-109.62350849047195, 32.7742343724392]],
    [ "181967063",[-109.76153661925453, 32.341118289586625]],
    [ "181967064",[-109.33749938932735, 33.05449557659105]],
    [ "Sahuarita",[-110.92842025980733, 31.971659803303552]],
    [ "Pantano Substation",[-110.57044668495647, 31.964638781145535]],
    [ "Butterfield Substation",[-110.13056153259923, 32.00095416591364]],
    [ "Los Reales Substation",[-110.75682046571045, 32.11657587970588]],
    [ "181983115",[-90.70987992513746, 38.483664840162746]],
    [ "Ryan Substation",[-112.3490682699838, 36.68759440434406]],
    [ "Gila River Substation",[-112.6922372113532, 32.97558629323858]],
    [ "182041947",[-112.68997035540191, 32.973310593140496]],
    [ "Edmonston Substation",[-118.82620766278983, 34.941290195895185]],
    [ "Mesa Substation",[-120.45319751053593, 35.00841345844787]],
    [ "182108228",[-121.14581778676022, 36.26518782291399]],
    [ "Verde Substation",[-112.02999362127423, 34.84661594907661]],
    [ "Cornell Substation",[-83.63099940537198, 42.25588810433765]],
    [ "182228748",[-121.59537201558719, 37.72023382978653]],
    [ "182236677",[-105.55963664300543, 41.33409370081777]],
    [ "182236678",[-105.90047199839103, 41.39657263321689]],
    [ "182239374",[-94.59372433482709, 48.71836974847638]],
    [ "182251249",[-87.1719744120877, 36.88934204352097]],
    [ "CFEC",[-82.86623775612308, 29.795584324726043]],
    [ "182271283",[-119.53743072521547, 43.56874165374796]],
    [ "Pawling Substation",[-73.59894366831942, 41.57169925050558]],
    [ "182285390",[-92.01206923987749, 43.55821194197059]],
    [ "182285391",[-91.950165, 43.528155850000005]],
    [ "182285398",[-91.9904964934164, 43.55416032836074]],
    [ "Dove Valley Substation",[-111.9963212229451, 33.77186374181455]],
    [ "Olympia Pumping Facility",[-122.72440755, 47.02625895]],
    [ "Pinckard Substation",[-85.57954560492075, 31.293882698770645]],
    [ "Webb Substation",[-85.28877556545248, 31.250903562660337]],
    [ "Orion Substation",[-85.9896790250993, 31.97430135642587]],
    [ "182399541",[-92.3488865286604, 43.55871275406873]],
    [ "Puget Sound Energy",[-122.74097534409648, 47.072631087891864]],
    [ "182410020",[-92.72946579165358, 43.54329975063731]],
    [ "182410021",[-92.62933432954381, 43.558957161400826]],
    [ "182410023",[-92.72868483142497, 43.55755666428337]],
    [ "182431426",[-86.73352817460055, 33.58364215750064]],
    [ "American Cast Iron Pipe Company",[-86.84300472401057, 33.54714210232998]],
    [ "182433017",[-86.86174355, 33.54406540000001]],
    [ "182439331",[-86.7112161672818, 33.4886030692255]],
    [ "Valley Substation",[-86.78404654999997, 33.4618124]],
    [ "182439334",[-86.71556167241569, 33.52755801907434]],
    [ "182439335",[-86.7422415122897, 33.53539977467132]],
    [ "182451288",[-108.15489927098491, 36.52261699953235]],
    [ "182451290",[-108.27288351991582, 36.48524031930718]],
    [ "Ambrosia Sub",[-107.84826910806422, 35.40271619661785]],
    [ "182451293",[-108.25262908017376, 36.520911375902465]],
    [ "182451299",[-108.15498666916294, 36.52353295289871]],
    [ "182462923",[-92.97100541569556, 43.6518740981057]],
    [ "182464431",[-92.96425020462496, 43.67485957274564]],
    [ "Yelm Substation",[-122.59606719021015, 46.946052506171974]],
    [ "182470337",[-97.40222798285798, 32.32032773108593]],
    [ "Pipestone Substation",[-96.31980388188248, 44.00314508719621]],
    [ "Slayton Substation",[-95.75636679236386, 43.97840072510517]],
    [ "Moraine II Interconnection Station",[-96.05199529812894, 44.023041129189515]],
    [ "Slayton West Substation",[-95.7655085, 43.9779249]],
    [ "Northern Wind Rock Aetna Switching Substation",[-96.05265661137757, 44.02307841355833]],
    [ "182487470",[-114.13305895113514, 44.44492963873465]],
    [ "182487477",[-114.02849601692397, 44.2951352330423]],
    [ "182487479",[-114.47085661665797, 44.28455742430824]],
    [ "182487484",[-113.33626202614049, 43.782944704166816]],
    [ "182488436",[-96.3237248757361, 41.30590625180912]],
    [ "Hutchinson County Interchange",[-101.43993063111395, 35.63163093619479]],
    [ "Wildorado Wind Substation",[-102.31633024111309, 35.28201572026658]],
    [ "182499603",[-84.5737602936178, 41.58267564048001]],
    [ "East Birmingham Substation",[-86.77971489029899, 33.537731664144644]],
    [ "182521776",[-86.92174046669749, 33.457636835356915]],
    [ "Tennessee Valley Authority",[-88.2994649076373, 36.60011326230259]],
    [ "Cadiz Primary Substation",[-87.80990386622052, 36.8666076400515]],
    [ "182572349",[-88.30100109957452, 36.60561158056064]],
    [ "Central Florida Electric Coop",[-82.83301249724838, 29.6203648446567]],
    [ "Duke Energy",[-82.83242401485896, 29.620493751955163]],
    [ "Henrietta Substation",[-119.90282242441948, 36.2421308657052]],
    [ "McCall Substation",[-119.63931641321902, 36.61086256600733]],
    [ "182604564",[-119.90443094798164, 36.24047680842759]],
    [ "182605062",[-88.35079571426397, 37.05584748090947]],
    [ "182605080",[-88.34102524988519, 37.0437861666881]],
    [ "182605087",[-88.29414737666701, 36.85388676909284]],
    [ "182605099",[-88.3430074390556, 37.05186103780011]],
    [ "182615236",[-96.36725073578015, 41.32147608083007]],
    [ "182619786",[-119.91700523820408, 36.853306064352616]],
    [ "Sanger Substation",[-119.61116476652799, 36.70824797858071]],
    [ "Pacific Gas and Electric Company",[-119.984503104748, 36.922149387375036]],
    [ "182627500",[-120.03355016639321, 36.98310424219055]],
    [ "182627574",[-96.23310255848585, 43.76175929443526]],
    [ "Deephaven Substation",[-93.52275427180562, 44.92390230554524]],
    [ "182648956",[-115.27630308743129, 36.05615282734737]],
    [ "182648957",[-115.34463052824754, 36.18265280146317]],
    [ "182648990",[-115.31436233585825, 36.110149664299804]],
    [ "182649012",[-115.2826053518414, 36.086183800527856]],
    [ "182649013",[-115.24246184067125, 36.05160587810461]],
    [ "Pratt City Substation",[-86.88183556064786, 33.517275772223044]],
    [ "182692515",[-96.68021335967812, 40.83481617731082]],
    [ "182723892",[-88.35910145, 37.05515824999999]],
    [ "182786753",[-115.54883117126269, 48.40306016797109]],
    [ "182791482",[-120.76490388238385, 38.21660422534865]],
    [ "182808825",[-92.87971325, 46.4882342]],
    [ "Florence Substation",[-124.08315393588772, 43.98260717872893]],
    [ "182829862",[-86.96541545000001, 33.4542063]],
    [ "United States Steel Corp",[-86.93249116744508, 33.490924936087815]],
    [ "Taylors Ferry Substation",[-87.17982750000003, 33.52691000000001]],
    [ "182880649",[-86.81630727277283, 33.33098459398462]],
    [ "South Park Substation",[-86.87911399782374, 33.48666266623685]],
    [ "CFEC",[-82.71837132689686, 29.78251063330674]],
    [ "High Springs Substation",[-82.67651480105235, 29.812239507939]],
    [ "182934666",[-93.01152982071696, 47.44990138593466]],
    [ "Glendale Heights Substation",[-88.07962473666203, 41.928739811137554]],
    [ "Big Timber Auto Substation",[-109.9386119926255, 45.87126370639393]],
    [ "Columbus-Rapelje Auto Substation",[-109.25732672547437, 45.85251472755086]],
    [ "Shorey Road Substation",[-108.71574655908711, 45.848975767181436]],
    [ "Wilsall Substation",[-110.66586736767029, 45.95495281558277]],
    [ "Northwest Energy",[-110.56223427991367, 45.822081511571156]],
    [ "182953247",[-108.71588817701259, 45.78508708706674]],
    [ "Three Rivers Substation",[-111.51309472021309, 45.93552452647929]],
    [ "Northwest Energy",[-112.0110099424683, 45.88190157743673]],
    [ "Northwest Energy",[-112.51901985978617, 45.93026991637107]],
    [ "183011923",[-84.89643194485268, 41.31666077330977]],
    [ "Collins NW Substation",[-91.64665332483862, 42.03386013600225]],
    [ "Dixon Substation",[-114.30052524055961, 47.30961250256045]],
    [ "Duke Energy",[-82.67864420051694, 29.63690938854706]],
    [ "Mission Valley Power",[-114.16026633365952, 47.385044229738156]],
    [ "Hiawatha Substation",[-91.67154958493329, 42.06198106565516]],
    [ "Marion",[-114.64298852683528, 48.1109396211129]],
    [ "183090850",[-96.0971982, 41.31119399999999]],
    [ "Stillwater",[-114.30934916539522, 48.24560920334307]],
    [ "Flathead",[-114.31259997192238, 48.24535425909831]],
    [ "Elmo",[-114.35368727120832, 47.833513504595125]],
    [ "Lion Mountain",[-114.25239190772427, 48.102087293802995]],
    [ "183094633",[-92.68686346076798, 47.429167124584545]],
    [ "183094782",[-124.12439458557965, 43.69595213032733]],
    [ "Eveleth Taconite Company Substation",[-92.57433311582112, 47.354124598185216]],
    [ "WTP",[-106.6134841008541, 35.140999273588605]],
    [ "183106621",[-86.82840265000002, 33.44764425]],
    [ "Magella Substation",[-86.84201153855733, 33.4722395769832]],
    [ "183108679",[-109.38205909999999, 46.27947205]],
    [ "Northwest Energy",[-111.9652055869652, 47.713724260261614]],
    [ "Northwest Energy",[-111.22040336011767, 47.54297108003144]],
    [ "183163874",[-95.82982862799064, 36.36511939226418]],
    [ "Grand River Dam Authority",[-95.8285903278033, 36.36501083642631]],
    [ "183178947",[-107.60097572331323, 45.76738734920941]],
    [ "183178948",[-108.175168719685, 45.7827569677158]],
    [ "183182039",[-92.60813080140326, 47.565922185604215]],
    [ "183185651",[-92.62677631314364, 47.56584178499863]],
    [ "183185657",[-92.62243809714825, 47.56531886606205]],
    [ "Haber Road Substation",[-93.63923476107146, 42.028875127660136]],
    [ "183192613",[-92.52284455860853, 47.56014255821673]],
    [ "183255039",[-102.80219757363318, 33.16796721201641]],
    [ "183255040",[-102.4557601376266, 33.446382124804664]],
    [ "183255042",[-102.8017532893908, 33.16810343211782]],
    [ "183255047",[-102.45478795, 33.44624484999999]],
    [ "183255055",[-102.45409646672279, 33.520447471016496]],
    [ "183255823",[-86.722961375104, 33.55103500830039]],
    [ "183334378",[-104.46109365000001, 33.36587955]],
    [ "183349093",[-103.85838527842621, 33.990722371103494]],
    [ "183349100",[-103.82958191469812, 33.96125696038581]],
    [ "Cunningham substation",[-103.35310516302854, 32.713350133636396]],
    [ "Carlsbad Sub",[-104.20034404172397, 32.44526891220118]],
    [ "183383429",[-102.55753775, 33.45846454999999]],
    [ "183383430",[-102.5587833, 33.45925365000001]],
    [ "Wolfforth Interchange",[-102.0556725190764, 33.491511618998715]],
    [ "Kiowa 2 Sub",[-103.96554824071983, 32.50585442161677]],
    [ "183387718",[-103.80382419968426, 32.56072202752643]],
    [ "Hobbs Substation",[-103.31168934649614, 32.731808005015935]],
    [ "183390099",[-102.7841627286549, 32.96532717932175]],
    [ "Leeds Substation",[-86.57976511010487, 33.52421370931036]],
    [ "South Jefferson Substation",[-86.69338973936365, 33.460838067028334]],
    [ "183394249",[-86.47793080000001, 33.50153325]],
    [ "183398274",[-88.36539598523557, 36.95806108851538]],
    [ "183398275",[-88.39187881759237, 37.000966885067626]],
    [ "183405784",[-86.88266377708607, 33.43269169246604]],
    [ "183405785",[-86.85011774999997, 33.4965035]],
    [ "183405786",[-86.81760195000004, 33.49650355000001]],
    [ "Birmingham Water Works",[-86.71581225000001, 33.4519566]],
    [ "183405794",[-86.7115853907904, 33.43202538099289]],
    [ "183412668",[-88.29110597833979, 36.76774261564625]],
    [ "CFEC",[-82.92192622528454, 29.498943103601068]],
    [ "CFEC",[-82.85562612487742, 29.503401988985036]],
    [ "183459668",[-86.65505845, 33.5831357]],
    [ "Heidelberg Materials",[-86.54297410282368, 33.53866333279518]],
    [ "Lovick Substation",[-86.61989369985089, 33.558457116680266]],
    [ "183459671",[-86.29057051272146, 33.57506417257305]],
    [ "183459672",[-86.25898882734157, 33.5795050561421]],
    [ "East Pelham Substation",[-86.6950804143277, 33.279757317026906]],
    [ "Carlisle Interchange",[-101.96711718660114, 33.5912644985061]],
    [ "Allen Substation",[-101.8794663275912, 33.52726909303775]],
    [ "Oliver Substation",[-101.88880343243895, 33.49839643863786]],
    [ "Frankford Substation",[-101.94022550000001, 33.49838305000001]],
    [ "McDonald Substation",[-101.95795069999998, 33.58575570000001]],
    [ "Jones Station",[-101.73909769664202, 33.52253482442184]],
    [ "Lubbock South Interchange",[-101.82626636989121, 33.51171233367173]],
    [ "Lubbock East Interchange",[-101.79145371239737, 33.57117185126622]],
    [ "Mercedes Substation",[-87.25567447498763, 33.177564856152166]],
    [ "Vance Substation",[-87.21348799659634, 33.17694806659051]],
    [ "Grassland Interchange",[-101.68501224933634, 33.17998129933744]],
    [ "Holly Substation",[-101.79244198253842, 33.52081049619529]],
    [ "Southeast Substation",[-101.85489260000001, 33.518608549999996]],
    [ "183476166",[-93.63453419999999, 45.32177684999999]],
    [ "183476167",[-93.7243577253853, 45.32989223796214]],
    [ "183476173",[-93.63475256958291, 45.321091735450935]],
    [ "183476177",[-93.55865925988789, 45.297375185384574]],
    [ "183478056",[-86.71819314999999, 33.5913138]],
    [ "Grapevine Interchange",[-100.89096643971456, 35.401933973053964]],
    [ "183502012",[-100.24378093868268, 35.3728479748463]],
    [ "183502013",[-99.91324574999999, 35.38334985000001]],
    [ "Amarillo South Interchange",[-101.86391381408431, 35.0996965044127]],
    [ "East Plant Substation",[-101.80410983946531, 35.214559460864024]],
    [ "Whitaker Substation",[-101.75922659999999, 35.2504321]],
    [ "Drayton 230kV Substation",[-97.27702340916461, 48.585159606017655]],
    [ "Harwood Substation",[-76.03032122220348, 40.93538499805391]],
    [ "Columbia Substation",[-76.5069261683007, 41.002327549416485]],
    [ "Frackville Substation",[-76.24541472864824, 40.77743152115111]],
    [ "Sunbury Substation",[-76.82786348899431, 40.83609425761905]],
    [ "183642366",[-76.24215523082827, 40.828533554642455]],
    [ "Locust Ridge Park #1 Substation",[-76.12605998973588, 40.854622730389195]],
    [ "Montour Station",[-76.66384308256117, 41.072630491953085]],
    [ "Elimsport Substation",[-76.99195218466265, 41.168605380592545]],
    [ "Clinton Substation",[-76.86068854342194, 41.196420388323695]],
    [ "Portland Substation",[-75.08136621239751, 40.90921586365299]],
    [ "Foxhill Substation",[-75.17020992030471, 40.98193350481761]],
    [ "Monroe Substation",[-75.17148320608536, 40.98031649141253]],
    [ "South Lebanon Substation",[-76.39730136911906, 40.33127728081311]],
    [ "New Kingstown Substation",[-77.0983126692775, 40.23763639347724]],
    [ "Harwood Substation",[-76.02791212107458, 40.93543619153614]],
    [ "East Palmerton Substation",[-75.56897322523784, 40.81297177587037]],
    [ "183745931",[-93.21911604927104, 44.69240520034768]],
    [ "Ross Bridge Substation",[-86.90068094153256, 33.385010224324205]],
    [ "Alabaster Switching Station",[-86.79591735, 33.211109900000004]],
    [ "183747502",[-86.56643388628535, 33.339448865515905]],
    [ "Alabama Power",[-86.56914786778253, 33.35118146897918]],
    [ "Calera Substation",[-86.7551067255624, 33.12718045653688]],
    [ "Valleydale Substation",[-86.79450763591942, 33.33934901104274]],
    [ "Nucor Steel",[-86.80382541115242, 33.54568590170769]],
    [ "City of Ames",[-93.65030862500043, 42.04600375626902]],
    [ "North Temple Substation",[-75.9272959821541, 40.41630393315771]],
    [ "183785832",[-75.76470978867377, 40.47137028426047]],
    [ "Ontelaunee Substation",[-75.93701070294175, 40.42154397612708]],
    [ "Tuscarora Substation",[-76.03859108902769, 40.76228656668374]],
    [ "AES Ironwood Substation",[-76.36699595608398, 40.351100841481376]],
    [ "North Lebanon Substation",[-76.4357634223432, 40.37574822747947]],
    [ "North Hershey Substation",[-76.63980618205456, 40.346806006997255]],
    [ "Lyons Substation",[-75.76387945638658, 40.47694205854489]],
    [ "Eldred Substation",[-76.44153152442695, 40.7286737858714]],
    [ "CFEC",[-82.98244995, 29.604009750000007]],
    [ "Bandon Substation",[-124.3965718061969, 43.10667637969298]],
    [ "Rogue",[-124.40733273213378, 42.48360903772536]],
    [ "183846466",[-86.78121433225712, 33.51400645551856]],
    [ "City of Ames",[-93.64905588490467, 42.045801841980655]],
    [ "183879407",[-99.95796045287406, 48.35165565040608]],
    [ "City of Ames",[-93.60389962115643, 42.026047415590774]],
    [ "City of Ames",[-93.6054030413431, 42.026306272649805]],
    [ "183946506",[-87.10034789999999, 33.93336105]],
    [ "183946507",[-86.88099506564645, 33.67720372033227]],
    [ "183946509",[-86.98512052400002, 33.81199206790321]],
    [ "183946516",[-87.19660729544489, 33.64609274098869]],
    [ "Blackberry 230/115 kV Substation",[-93.3136375568026, 47.22985953978165]],
    [ "Mud Lake Substation",[-94.07593721050476, 46.33197609250507]],
    [ "184166910",[-116.54582449457082, 48.33948335688994]],
    [ "184177957",[-116.29600662478664, 48.73463720097265]],
    [ "Cobb Substation",[-86.24184267712717, 43.25531888796512]],
    [ "184221421",[-94.55911965011994, 48.65770082241601]],
    [ "184248762",[-92.84325097395676, 45.77656863867595]],
    [ "184248764",[-92.82065408140792, 46.12550914766923]],
    [ "Virginia Substation",[-92.56481836007005, 47.52521691436155]],
    [ "184253424",[-92.56135977057237, 47.48549704439542]],
    [ "184258038",[-93.63853350361633, 45.75527269286951]],
    [ "Johnsville Substation",[-93.23564932492357, 45.20094304371182]],
    [ "184336322",[-93.03670052900353, 45.3511624828761]],
    [ "184343055",[-93.2862684695207, 44.68675251853868]],
    [ "Elm Creek 230kV Substation",[-97.54635098335615, 39.50338596217181]],
    [ "Madison Park Substation",[-86.20164468355618, 32.42368624998577]],
    [ "184369592",[-92.2935038158605, 47.6071045879111]],
    [ "184378553",[-86.34690680784972, 40.72119947288572]],
    [ "Veedersburg Substation",[-87.29905729734736, 40.12860078456115]],
    [ "184390011",[-86.85804678335349, 40.39592807500672]],
    [ "184390012",[-86.8481561758452, 40.37429617620693]],
    [ "184390015",[-86.84651803263068, 40.37626794588807]],
    [ "184390016",[-86.83129114163803, 40.36286703342759]],
    [ "Clinton Substation",[-87.43388668379754, 39.725065898824354]],
    [ "184393177",[-85.90741136156042, 38.183496715751886]],
    [ "184393182",[-85.72730545248753, 38.35968443363905]],
    [ "184454530",[-78.69985617972704, 34.318913096335244]],
    [ "184454559",[-78.7621139131578, 34.563380430965736]],
    [ "184454560",[-78.69954695928631, 34.318443134435675]],
    [ "CFEC",[-82.98765855000002, 29.70333695]],
    [ "184465906",[-78.794809069996, 34.29621463268448]],
    [ "Fayetteville Public Works",[-78.89068016729311, 34.94989690112147]],
    [ "184502720",[-78.97072420700839, 35.12690060635214]],
    [ "184502722",[-78.97123071776817, 35.12645518288187]],
    [ "184502723",[-78.97169321536549, 35.1265981599873]],
    [ "184502724",[-78.9819962404861, 35.154032432757674]],
    [ "184503831",[-78.99166519328709, 35.06046559538128]],
    [ "Mapleton Substation",[-123.86300526191972, 44.0224798788563]],
    [ "184509745",[-77.98603035000001, 34.31740615]],
    [ "South Elgin Substation",[-88.32818265996244, 41.98435922887767]],
    [ "Double Tree Substation",[-111.97834910877727, 33.568057336994265]],
    [ "184521717",[-77.87728744178506, 34.3283500922443]],
    [ "184521739",[-77.8268402579129, 34.26887932110051]],
    [ "184521740",[-77.87640675000002, 34.32860250000001]],
    [ "184521741",[-77.89382968301793, 34.15974659439469]],
    [ "184521742",[-77.82821195318228, 34.22555928137937]],
    [ "184521743",[-77.87243322394573, 34.28624737458498]],
    [ "184521746",[-77.88647710407812, 34.25077349739092]],
    [ "184521748",[-77.87337021517679, 34.25442300341494]],
    [ "184521750",[-77.86043570698813, 34.20012150248981]],
    [ "184536663",[-77.63704216525954, 34.78424881818794]],
    [ "184536664",[-77.45724584999999, 34.72499355]],
    [ "184536665",[-77.69018088284197, 34.39127614868843]],
    [ "184536668",[-77.50353435472698, 34.79884031877316]],
    [ "184536673",[-77.45754764813842, 34.72463537651349]],
    [ "184540665",[-79.38976431949457, 34.203533188437284]],
    [ "184540667",[-79.14360538770256, 34.24609748937598]],
    [ "184540669",[-78.9948208, 34.27047205]],
    [ "184540670",[-79.36898684200614, 34.19526049321133]],
    [ "184542907",[-79.66909726453437, 34.58541510777993]],
    [ "Laurinburg Substation",[-79.43844368743139, 34.760214688628736]],
    [ "184544538",[-79.67448296018716, 34.59996523924212]],
    [ "184544539",[-79.5416005037722, 34.67943388451991]],
    [ "184547598",[-79.29333825, 34.5556558]],
    [ "184547600",[-79.09541195087122, 34.59228135613681]],
    [ "Laurinburg Substation",[-79.40630402069621, 34.748077054021444]],
    [ "184547602",[-79.03452937923205, 34.56463145633689]],
    [ "184547604",[-79.3981081474495, 34.744364979702134]],
    [ "184551847",[-79.41203444872328, 34.31831425803434]],
    [ "184551848",[-79.38976511227591, 34.407402434569285]],
    [ "184554524",[-79.77212379684569, 34.21527641813933]],
    [ "184554526",[-79.74892510032053, 34.23998856415456]],
    [ "184554527",[-79.77127945875365, 34.21708366769437]],
    [ "184560368",[-79.4351000647673, 33.717444247406426]],
    [ "Kegan Lake Substation",[-93.11479555014162, 44.755881566602966]],
    [ "Dakota Electric Association",[-93.11560996972233, 44.81955624054204]],
    [ "184593459",[-77.70639975, 37.5031089]],
    [ "Lookout Substation",[-112.06066814292032, 33.64367852763549]],
    [ "184611894",[-77.92514925873463, 36.002190632190555]],
    [ "184611897",[-78.01688539898775, 36.07461571674841]],
    [ "184611899",[-78.39214805968112, 36.28057903700086]],
    [ "184611900",[-77.83400913097077, 35.95052895584164]],
    [ "184672065",[-76.85182541767304, 35.297257612135645]],
    [ "184672066",[-76.87841442783153, 35.29342893643326]],
    [ "184672067",[-76.85099120000001, 35.29779320000001]],
    [ "184672072",[-76.8528637, 35.29756030000001]],
    [ "MacGregor Downs Substation",[-77.43188687962744, 35.61279574757491]],
    [ "PCS Phosphate Substation",[-76.78143346638022, 35.37324740415042]],
    [ "Westside Substation",[-77.42175402785657, 35.61727913957148]],
    [ "184672089",[-76.83987136961957, 35.146682143416456]],
    [ "184672091",[-77.11433958967235, 35.153635478754346]],
    [ "184672101",[-77.11921800738806, 35.474735638662715]],
    [ "184685369",[-77.69780956185001, 35.2422675939242]],
    [ "Clinton Substation",[-78.27990744807924, 35.05836456369488]],
    [ "184689411",[-77.97525197836312, 34.821986459079746]],
    [ "184689412",[-78.09130914302925, 35.00874645574229]],
    [ "184689414",[-77.98756549727399, 34.88548203584914]],
    [ "Rose Hill Substation",[-77.97875714954752, 34.817028838978985]],
    [ "Castle Rock Substation",[-93.15374490574516, 44.544039174793674]],
    [ "Mt. Olive Substation",[-78.10944258204134, 35.18700857375095]],
    [ "184696367",[-78.36850217722893, 35.251252977372154]],
    [ "184696368",[-78.36842653792395, 35.251798219470075]],
    [ "184696370",[-78.6036519156095, 35.31957217174507]],
    [ "Kingstree Substation",[-79.80043743772595, 33.668162758634324]],
    [ "184709536",[-79.53326215618219, 34.80228701714088]],
    [ "184709537",[-79.60693722401258, 33.68732041329115]],
    [ "184709538",[-79.43839995009229, 33.716267049325694]],
    [ "184709540",[-79.47468386018711, 34.766091685697354]],
    [ "184709544",[-79.47435498077907, 34.76572048000731]],
    [ "184709545",[-79.75320027271425, 33.84483167568722]],
    [ "184709546",[-79.79910107854509, 33.66959737748223]],
    [ "184713339",[-79.03777107134438, 35.14196889018482]],
    [ "184713340",[-79.0384587978026, 35.14177520704209]],
    [ "184721717",[-78.9688430504893, 34.97854194461142]],
    [ "184721718",[-79.68480608589937, 34.91053623083815]],
    [ "Saints Run Substation",[-91.6635543153647, 42.00742229681122]],
    [ "Georgia Power",[-84.36506024999998, 33.78008875]],
    [ "Cross Substation",[-80.11499081444616, 33.36666045341033]],
    [ "41-Siding Substation",[-79.94019471850793, 33.346810939932126]],
    [ "184789491",[-79.81546641527729, 33.66471370125212]],
    [ "184825959",[-79.81375932602194, 33.73058582068143]],
    [ "184839155",[-80.06018918276217, 33.20116503213537]],
    [ "Needham Transition Station",[-71.23211329415258, 42.255670074865016]],
    [ "Little River Substation",[-97.36661898029624, 30.985939013431945]],
    [ "Winyah Substation",[-79.35738705169437, 33.331917560954466]],
    [ "184856181",[-78.91560766980135, 33.775320814329525]],
    [ "184856192",[-78.96259679225938, 33.91050638700648]],
    [ "Conway Substation",[-79.08054916126903, 33.81465445085891]],
    [ "184856195",[-79.35457453685282, 33.40498921083077]],
    [ "184856196",[-79.04429051142148, 33.91453726021865]],
    [ "Red Bluff Substation",[-78.85273748622197, 33.9299354488175]],
    [ "184856200",[-79.21528315027722, 33.536090830273736]],
    [ "184856203",[-78.98971342559429, 33.74815027247352]],
    [ "Campfield Substation",[-79.24578497581095, 33.483140582230185]],
    [ "184856205",[-79.1174147933786, 33.693632109200195]],
    [ "184856206",[-79.0595511623415, 33.86002703680279]],
    [ "184858750",[-79.8936744668807, 33.27330102345151]],
    [ "Williams Substation",[-79.93212354933257, 33.017656829268084]],
    [ "Nucor Steel Foundry Substation",[-79.88364209095565, 33.01019913182448]],
    [ "184867936",[-79.85512836172154, 33.004177002692316]],
    [ "184867937",[-80.04774394480224, 32.955884832167456]],
    [ "184867938",[-80.09298934534237, 32.95804000357501]],
    [ "Pepperhill Substation",[-80.0852537029415, 32.938047483108676]],
    [ "INEOS Aromatics Substation",[-79.87269574273944, 32.97628431914178]],
    [ "184867942",[-80.07876246801793, 32.92652098653192]],
    [ "DAK Americas Substation",[-79.93888067015386, 33.058443825410066]],
    [ "184867948",[-80.00903001652419, 33.013373767868515]],
    [ "184869176",[-80.0282145683455, 32.932484098577426]],
    [ "Naval Nuclear Power Training Command Substation",[-79.96820855444477, 32.962628596444524]],
    [ "Kenter Canyon",[-118.48835915629837, 34.06818087773342]],
    [ "Hancock Station",[-76.1204801088021, 43.09925202169086]],
    [ "Dalzell Substation",[-80.42193970085164, 34.01639775246247]],
    [ "184966098",[-80.27321168225934, 33.59731859409368]],
    [ "184966100",[-80.0326179, 33.200241999999996]],
    [ "Berkeley Electric Cooperative",[-80.12529716313328, 33.42337345396302]],
    [ "184966111",[-80.07306001258632, 33.054386457709334]],
    [ "184966112",[-80.4463744707318, 33.78059198613822]],
    [ "184966115",[-80.42837162306856, 33.95862096264626]],
    [ "184966117",[-80.43956277033234, 34.04271712115784]],
    [ "184990309",[-79.96583763325255, 34.433915653665466]],
    [ "Society Hill Substation",[-79.843658603932, 34.522735319678766]],
    [ "184990311",[-79.68816463682408, 34.58937684912965]],
    [ "184990316",[-79.68725337698032, 34.590647720657586]],
    [ "185004119",[-80.36447235000001, 33.966088150000004]],
    [ "Rutgers Substation",[-74.4619689336891, 40.527291806304]],
    [ "185012269",[-80.31937147201606, 34.38859749173229]],
    [ "185012273",[-80.4021027720699, 34.576911588604894]],
    [ "185012275",[-80.43936293213292, 34.63093130997139]],
    [ "185012276",[-80.34828765, 34.4530766]],
    [ "185012277",[-80.47719851058343, 34.67175169419549]],
    [ "Fairfield Electric",[-80.70501841789466, 34.27479234892607]],
    [ "185019905",[-80.5398703327465, 34.30333759961015]],
    [ "185019907",[-80.70375734860156, 34.275093229698705]],
    [ "Camden Substation",[-80.54112793103207, 34.3022713659784]],
    [ "185019909",[-79.92442698244386, 34.268308567726315]],
    [ "185023311",[-80.52113043705076, 34.21188189498154]],
    [ "185025101",[-91.92397840704137, 47.64087047831433]],
    [ "Sumter Substation",[-80.32401612058027, 33.89765407566192]],
    [ "Canadys Substation",[-80.62068704312811, 33.06414905286578]],
    [ "185032955",[-80.14399284578757, 34.12032163369626]],
    [ "185032958",[-80.41803490000002, 33.933168450000004]],
    [ "185032961",[-80.5895446903957, 33.19378422087529]],
    [ "185032967",[-80.39046073011173, 33.953097953281684]],
    [ "185032968",[-80.35954468989735, 33.618104834584855]],
    [ "185032971",[-80.4681724500578, 33.46279394869608]],
    [ "185032972",[-80.3930659859706, 33.912496799609315]],
    [ "185032973",[-80.62550356644937, 33.83285227069765]],
    [ "185032975",[-80.62083801722343, 33.06525672302626]],
    [ "185032978",[-80.58914666557392, 33.19469354196596]],
    [ "Mount Holly Smeltery Substation",[-80.05879816631051, 33.052070669298644]],
    [ "185036387",[-80.64768659516345, 34.228434234109216]],
    [ "185036390",[-80.64626123487182, 34.228785713992714]],
    [ "Virgil C. Summer Nuclear #1 Substation",[-81.31510309645176, 34.295919399188044]],
    [ "185039628",[-80.78493636959382, 34.26495748806538]],
    [ "185039629",[-81.03747957159791, 34.18452739191295]],
    [ "Rochester Substation",[-70.85010025472805, 41.73832589441926]],
    [ "Denny Terrace Substation",[-81.06151875359163, 34.05760594359887]],
    [ "185130617",[-80.98328238438674, 34.10381734559521]],
    [ "185144896",[-81.31575796640648, 34.289246075015384]],
    [ "Lake Murray Substation",[-81.2146461288717, 34.05483701552536]],
    [ "185149203",[-81.21666606011905, 34.05536775142311]],
    [ "185149204",[-81.20934154541497, 34.05304137392651]],
    [ "185168619",[-81.64905956978177, 34.25231962324072]],
    [ "Ward Substation",[-81.6977203852059, 33.87217614103431]],
    [ "185197507",[-81.58894173705323, 34.24687188743443]],
    [ "185201666",[-80.9417323217872, 34.12270474388902]],
    [ "185201667",[-81.57654607642677, 33.88760204441968]],
    [ "185201669",[-81.58878072776758, 34.030904301722934]],
    [ "185201670",[-80.9440243492838, 34.122246422748795]],
    [ "185220694",[-91.70525882544577, 47.055049506030066]],
    [ "185220696",[-91.70329371998646, 47.05501160161561]],
    [ "Cola Industrial Park Substation",[-80.98407384410926, 33.943172851454754]],
    [ "185225320",[-81.05014794323536, 33.958873922154986]],
    [ "185227970",[-80.92082053008772, 33.888685423850625]],
    [ "Columbia Energy Center Substation",[-81.01830435567821, 33.87131127691671]],
    [ "185227986",[-81.01808370543174, 33.87582674223089]],
    [ "Cromer Road Substation",[-81.15611642292468, 34.00402183370839]],
    [ "185230438",[-81.08632905, 33.969334700000005]],
    [ "Springdale Substation",[-81.11790878264402, 33.98202181986169]],
    [ "CMC Steel Substation",[-81.0540818947886, 33.96281795717229]],
    [ "185230443",[-81.0603471203903, 34.021624747256745]],
    [ "185236315",[-80.58684854683713, 33.18867967041901]],
    [ "185236317",[-80.1399957582288, 33.02057229161469]],
    [ "185236361",[-80.1623261224992, 33.03297020085582]],
    [ "185236364",[-80.14483312747079, 33.023700603302295]],
    [ "185247012",[-81.58578792397334, 33.602462739254634]],
    [ "185247015",[-81.59254883794641, 33.685110690022675]],
    [ "185260813",[-81.66348708280405, 33.33160660122587]],
    [ "185260815",[-81.79198581697979, 33.54860985844544]],
    [ "185260816",[-81.39928696405828, 33.21861524314125]],
    [ "Yemassee Substation",[-80.86387146638779, 32.6974609897041]],
    [ "Church Creek Substation",[-80.0702809040245, 32.83031324386781]],
    [ "185330727",[-80.19025926694286, 32.89725355943581]],
    [ "Burton Substation",[-80.72102034848331, 32.43636772331826]],
    [ "185362040",[-80.75782635450349, 32.475988118210246]],
    [ "Jasper Substation",[-81.1241557785429, 32.360699272139584]],
    [ "185380609",[-81.12243499947141, 32.36886796338881]],
    [ "South Carolina Electric & Gas",[-80.9686466704173, 32.27755417331402]],
    [ "185381112",[-80.842232701743, 32.24889442223704]],
    [ "185390957",[-80.9436111128974, 32.32868732140156]],
    [ "185390958",[-80.87614491202078, 32.27679517487056]],
    [ "185390959",[-80.87880155543382, 32.728519109002654]],
    [ "185397978",[-80.62065364255099, 32.8232219706902]],
    [ "185397988",[-80.08881812417529, 32.73188828551435]],
    [ "185397991",[-80.08920736433576, 32.73043616376551]],
    [ "185399955",[-80.08773365037494, 33.01024114576704]],
    [ "185399956",[-80.08547261840899, 33.02527980943675]],
    [ "185399957",[-80.07846522046165, 33.04743627952118]],
    [ "185400289",[-81.00795811538285, 32.80233531769236]],
    [ "Dunbar Road Substation",[-81.08549271054103, 33.941778249770174]],
    [ "185404031",[-81.18421375, 33.862493199999996]],
    [ "185404032",[-81.1554492557782, 33.8756893793142]],
    [ "185407360",[-77.8479178824619, 35.803370167483415]],
    [ "Jonesboro Substation",[-79.1347478910672, 35.466598104335425]],
    [ "West End Substation",[-79.53025257509105, 35.2196161152827]],
    [ "185505673",[-79.45866134080953, 35.279832347779546]],
    [ "185505676",[-79.18309360210392, 35.462262104545445]],
    [ "185505678",[-79.53079901728279, 35.22043136482152]],
    [ "185505679",[-79.40201830000001, 35.32571585]],
    [ "185505680",[-79.4011907, 35.325383249999994]],
    [ "185505681",[-79.19345432272007, 35.49328598417579]],
    [ "185505682",[-79.3109296368269, 35.39961725010046]],
    [ "185505683",[-79.79677714575291, 34.93063599072333]],
    [ "185505684",[-79.79705717007626, 34.93086589440365]],
    [ "185505685",[-79.76136574577478, 35.062881726036]],
    [ "185505687",[-79.19519562933156, 35.492717421715795]],
    [ "185505689",[-79.76165666485501, 35.063106961803804]],
    [ "185522142",[-79.40571665000002, 35.70212395]],
    [ "185522144",[-79.08642395016352, 35.81680602452908]],
    [ "185522145",[-79.16658608370439, 35.69970383265129]],
    [ "Biscoe 230kV Substation",[-79.82657498918469, 35.3626015689037]],
    [ "185549279",[-79.7340711313618, 34.95647188408745]],
    [ "185549280",[-79.7342848149106, 34.955722502283365]],
    [ "Longview Substation",[-81.41003003834457, 35.7212864943832]],
    [ "185561089",[-81.32176419702034, 35.632727180905654]],
    [ "Stamey Substation",[-80.9891140240344, 35.77993185048055]],
    [ "185561799",[-80.98030405, 35.621804700000006]],
    [ "185561800",[-80.99270982034018, 35.771544811129075]],
    [ "185561801",[-80.98004568882098, 35.62192826126463]],
    [ "Energy United",[-80.99230216149047, 35.772018541049995]],
    [ "185567531",[-81.94874805, 35.64299655]],
    [ "McDowell Substation",[-81.95545160737679, 35.64365463834925]],
    [ "185568715",[-80.83295437819318, 36.12985854303746]],
    [ "Husqvarna Substation",[-80.80896203162732, 33.50379696576025]],
    [ "North Substation",[-80.78632159490411, 33.46837523146763]],
    [ "185577980",[-80.80767704652922, 33.50331460736861]],
    [ "Orangeburg East Substation",[-80.80645208492835, 33.50220103390258]],
    [ "185577986",[-81.02831756425618, 33.36531822186307]],
    [ "Pisgah Tie Substation",[-82.68299948626988, 35.25855199242336]],
    [ "185582607",[-82.53109024987029, 35.02522104750448]],
    [ "185582625",[-82.6825871092886, 35.25366186957003]],
    [ "Shady Grove Substation",[-82.42482409211901, 34.76062052444995]],
    [ "185591284",[-82.6092770939811, 34.878678016199366]],
    [ "South Fifth Street Substation",[-89.06403365906958, 36.416776603196716]],
    [ "COTTONWOOD",[-88.35345950562917, 43.09927983661176]],
    [ "Everetts Substation",[-77.10592414040796, 35.838449774232814]],
    [ "Lee-Leggettts Substation #5",[-77.15860982244457, 35.681475758980795]],
    [ "Bagatelle Road Substation",[-73.36853836184697, 40.771589490837506]],
    [ "185685767",[-77.29241426296048, 35.81160757052084]],
    [ "185685769",[-77.3179529915146, 35.806805968685275]],
    [ "185685770",[-77.3838837870871, 35.7956787781396]],
    [ "Cheraw Cash Road Substation",[-79.886157267066, 34.680157016120376]],
    [ "Cheraw Reid Park Substation",[-79.9197708971562, 34.684457198116036]],
    [ "Nucor Steel Substation",[-79.89289744648741, 34.37326683012257]],
    [ "Cross City Substation",[-83.1297579318724, 29.62553978958857]],
    [ "185730066",[-79.83251318175212, 34.21576572684363]],
    [ "185730067",[-79.86124055825528, 34.17433510328304]],
    [ "Olanta Substation",[-79.91614962184227, 33.93443621710281]],
    [ "185730073",[-79.80178045161378, 34.157854671210075]],
    [ "185730074",[-79.89442318949858, 34.04062038962489]],
    [ "185735803",[-76.90934216815258, 35.993896382425994]],
    [ "185735804",[-76.9088383136581, 35.9940211918931]],
    [ "185738602",[-77.40016017492215, 36.41123385523045]],
    [ "Johnson Substation",[-94.3708091, 35.40776555000001]],
    [ "185745115",[-78.98322701486744, 35.156167950490904]],
    [ "Blackman Substation",[-84.48140238909681, 42.283469753484866]],
    [ "185805495",[-80.16359874999999, 35.089414250000004]],
    [ "185805496",[-79.92110830180648, 34.96845101099725]],
    [ "185805498",[-80.0850157, 34.99204964999999]],
    [ "185805499",[-79.91847439999998, 34.9686791]],
    [ "185848169",[-77.69530001854962, 36.19135156956902]],
    [ "Virginia Electric & Power Company",[-77.66068405968954, 36.45163240507292]],
    [ "East Thomas Substation",[-86.85465679999999, 33.52131835]],
    [ "Indian Springs Substation",[-86.72837732599663, 33.361944555743854]],
    [ "Helena Substation (DS)",[-86.83805256025094, 33.29090564731114]],
    [ "185884445",[-79.31949712237703, 36.40812863578674]],
    [ "Jenkintown Substation",[-75.139497174965, 40.096780085109955]],
    [ "185898625",[-86.62103039612798, 31.801242735842834]],
    [ "Belleville Substation",[-87.10808977722375, 31.422461130299308]],
    [ "185904501",[-87.1084079388336, 31.421276769779265]],
    [ "185908182",[-86.87939705, 31.419723499999996]],
    [ "McWilliams Substation",[-86.47235349604976, 31.400007175709074]],
    [ "Gantt Substation",[-86.47725110021499, 31.40098044807768]],
    [ "Opp Switching Station",[-86.27448442951493, 31.28608632751159]],
    [ "Andalusia Industrial Substation",[-86.46261240974299, 31.329921425441132]],
    [ "185918535",[-86.44596944929526, 31.28576531743771]],
    [ "North Brewton Substation",[-87.12759808214028, 31.197131009085663]],
    [ "185943263",[-88.03651954080465, 31.019449528209716]],
    [ "Liberty Switching Station",[-86.05963449901402, 30.99405059434581]],
    [ "Barry Substation",[-88.01058545117307, 31.00543380111416]],
    [ "185949232",[-87.9827609, 31.1475586]],
    [ "Calvert Substation",[-88.04860635621947, 31.101560374915298]],
    [ "185949242",[-87.99618857199867, 31.135879618454116]],
    [ "186000345",[-86.83212846265202, 33.21568641137309]],
    [ "West McIntosh Substation",[-88.05062519380232, 31.258560831746625]],
    [ "Warminster Substation",[-75.09216652562692, 40.19376105961142]],
    [ "Lowman 230/115 Switching Station",[-87.91181336893013, 31.48646442621938]],
    [ "Monroeville Substation",[-87.32584032515761, 31.501908367333236]],
    [ "Alabama River Newsprint Substation",[-87.49762251726803, 31.58600782792118]],
    [ "186030004",[-86.40822854449573, 32.527652719375645]],
    [ "Spring Creek Substation",[-86.54176877586205, 33.08519225745875]],
    [ "186030007",[-86.41907535169425, 32.51665193314925]],
    [ "Western Area Power Administration",[-122.7674473474921, 40.79214538882744]],
    [ "Mitchell Dam Substation",[-86.4478574, 32.80451495]],
    [ "Montgomery Switching Station",[-86.37295337999883, 32.35676912388677]],
    [ "186049739",[-88.28015969675376, 30.84599608643868]],
    [ "186049740",[-86.43602565964962, 31.327221474500565]],
    [ "Chickasaw Substation",[-88.05934188737301, 30.76341052574929]],
    [ "186074261",[-87.8442436416537, 30.67480397298139]],
    [ "Ecua Substation",[-87.27119913049198, 30.600368323827666]],
    [ "Florida Power & Light",[-87.38866103009379, 30.52566150227951]],
    [ "186081666",[-87.50818117497816, 30.52709454283937]],
    [ "Elsanor Substation",[-87.55693820470164, 30.526985456920272]],
    [ "Liberty Substation",[-93.87976777755605, 45.38677741166474]],
    [ "186082084",[-93.81253748740399, 45.353201595979655]],
    [ "186112592",[-86.21965240000002, 32.42119565]],
    [ "186112594",[-86.29346988249323, 32.4195536993001]],
    [ "186112597",[-86.21472793533847, 32.389803923021425]],
    [ "West Montgomery Substation",[-86.34579411537653, 32.36484880690625]],
    [ "Springville Substation",[-86.47992565, 33.76555095]],
    [ "Clay Substation",[-86.58537125, 33.70945090000001]],
    [ "Oneonta Substation",[-86.49178847152692, 33.90471185882105]],
    [ "East Trussville Substation",[-86.58041469792751, 33.638778245852045]],
    [ "Alabama Power",[-86.09477846445854, 33.54669741304164]],
    [ "Odenville Substation",[-86.41364600000001, 33.683311]],
    [ "186143678",[-86.60793920048148, 33.6470772926583]],
    [ "Trussville Substation",[-86.6233367, 33.63949125]],
    [ "186143680",[-86.17769538889854, 33.57134984197976]],
    [ "Bertram Substation",[-91.55706750175702, 41.958264766337074]],
    [ "North Selma Substation",[-86.99331585805416, 32.51306677260505]],
    [ "Inverness Substation",[-86.70110394442746, 33.410993768836065]],
    [ "Bayou Marcus Substation",[-87.30997360167865, 30.437063759012663]],
    [ "186171459",[-86.82581117471968, 33.68541490669928]],
    [ "Morris Substation",[-86.8177847, 33.7558651]],
    [ "186177513",[-112.47186886052233, 34.54617915318486]],
    [ "186239009",[-92.36275549761788, 45.93720701560711]],
    [ "186239010",[-92.3702539110649, 46.00268921697713]],
    [ "Fort Gordon Substation #2",[-82.16977510000001, 33.41566785]],
    [ "Kitty Hawk Substation",[-75.70012720218942, 36.06654689769809]],
    [ "Elizabeth City Substation",[-76.22630519316112, 36.314014777684484]],
    [ "Point Harbor Substation",[-75.80452653722256, 36.08421581284629]],
    [ "Tanglewood Substation",[-76.30139361501278, 36.272118608386165]],
    [ "Aydlett Substation",[-75.91046360499904, 36.33104401134084]],
    [ "Cane River Substation",[-82.33918562080474, 35.90500685442648]],
    [ "Craggy Substation",[-82.60787393370849, 35.64280581965171]],
    [ "186254497",[-85.89832873695295, 31.914433016896417]],
    [ "Clio Switching Station",[-85.59275822496379, 31.704580045960537]],
    [ "Chatom Substation",[-88.23647807713895, 31.496456627594302]],
    [ "186258680",[-88.69540923648377, 31.67823328591114]],
    [ "186258681",[-88.69586260367737, 31.67656905022635]],
    [ "186258688",[-88.69440066831638, 31.678381015910272]],
    [ "186329863",[-92.56840982648897, 47.37404886922839]],
    [ "Calera Substation",[-86.74808825, 33.106759499999995]],
    [ "Bessemer Electric Service",[-86.9563859751983, 33.39435356671826]],
    [ "Omya Alabama, Inc.",[-86.30324142490042, 33.15410253819426]],
    [ "Sungard Systems International",[-86.91054228413286, 33.403977547972055]],
    [ "Birmingham Rail & Locomotive",[-86.96970127050126, 33.37769863737543]],
    [ "North Mobile Substation",[-88.12871657554979, 30.77237218642091]],
    [ "Mississippi Power",[-88.51380489727599, 30.41257420930006]],
    [ "Haines Road Substation",[-92.17694404509476, 46.81213815092548]],
    [ "Cooperative Energy",[-88.51501237559368, 31.021773519913367]],
    [ "Singing River Electric Cooperative",[-88.61101814959288, 30.95893757650702]],
    [ "186403435",[-88.03631759120896, 31.225105358594387]],
    [ "186406383",[-85.14739059640252, 32.520853532731294]],
    [ "186406805",[-85.03798150154952, 32.54148479441016]],
    [ "Georgia Power",[-84.99226858315947, 32.481851722944086]],
    [ "Opelika Substation",[-85.4488345942236, 32.663562199959514]],
    [ "186411647",[-85.34174727728583, 32.74356025792595]],
    [ "186411651",[-85.42472691222015, 32.786251268899555]],
    [ "Hillabee Substation",[-85.90273726404756, 33.00166378374089]],
    [ "Rock Island Substation",[-104.75705941011594, 38.85827751649945]],
    [ "Coosa Pines Substation",[-86.35968439087023, 33.33862494108289]],
    [ "186427701",[-85.85873531826121, 33.65203036109773]],
    [ "186427711",[-85.97221842829225, 33.58655910303781]],
    [ "Anniston Substation",[-85.85837240620737, 33.65046966749596]],
    [ "Hammod Substation",[-85.34562667296696, 34.251223194964425]],
    [ "Rocky Mountain Switch Station",[-85.32856868073668, 34.32590851409283]],
    [ "186429834",[-85.29328018030373, 34.01262463318062]],
    [ "Cedartown Substation",[-85.28883761944557, 33.9962367323222]],
    [ "186433602",[-85.65193281584716, 33.98481429653784]],
    [ "Mississippi Power",[-88.56587593251348, 30.647970601862532]],
    [ "186441123",[-86.87812634999999, 33.15616255]],
    [ "Omaha Public Power District",[-95.96532239469263, 41.21922479820083]],
    [ "186511171",[-81.66725363589006, 33.543386223034425]],
    [ "186511172",[-81.7071149887483, 33.505662873184285]],
    [ "186511173",[-81.65279462608125, 33.546703878145614]],
    [ "Plant Watson Substation",[-89.0276884838477, 30.44030892062473]],
    [ "Coast Electric Power Association",[-88.99290209999998, 30.477718349999996]],
    [ "D'Iberville Northwest Substation",[-88.92122745495776, 30.49740110668453]],
    [ "Mississippi Power",[-89.33587913776178, 30.91270887714945]],
    [ "186527708",[-87.1309416516462, 30.610850356364033]],
    [ "Florida Power & Light",[-87.11871178703808, 30.572897854996768]],
    [ "Mississippi Power",[-89.59088359313047, 30.310496538462083]],
    [ "186539097",[-89.4274383750987, 30.339789309393872]],
    [ "Mississippi Power",[-89.59272297814023, 30.3099470876341]],
    [ "Evergreen Substation",[-104.79647925296719, 38.820388680662276]],
    [ "Alligator Swamp Substation",[-87.20074898664927, 30.61434287617241]],
    [ "Highway 11 Substation",[-89.32438409999999, 31.285566899999996]],
    [ "Laurel East Substation",[-89.10167774971217, 31.690808941004555]],
    [ "186573893",[-89.72864270148779, 30.266826134800056]],
    [ "Scenic Hills Substation",[-87.23883499274238, 30.526540097121455]],
    [ "186576152",[-89.7716602175488, 30.926792096856143]],
    [ "Mississippi Power",[-88.6096215482478, 32.10456179089066]],
    [ "Greene County Station",[-87.78167016281336, 32.60288175024669]],
    [ "186580327",[-93.2912490714286, 44.335025474864246]],
    [ "186580328",[-93.29525611361044, 44.326061418887534]],
    [ "Mississippi Power",[-88.83477515805912, 32.163446149170326]],
    [ "186582736",[-88.74484649435585, 32.292803129668414]],
    [ "Products (SE) Pipe Line Corporation",[-88.76076653248693, 32.3644696969635]],
    [ "Meridian Northeast Substation",[-88.67684499199177, 32.41462413034694]],
    [ "Washington-St. Tammany Electric Cooperative",[-89.88950710000002, 30.53468105]],
    [ "Entergy Louisiana",[-89.90899847425088, 30.790295575265564]],
    [ "186589480",[-89.88947918699074, 30.53391641874475]],
    [ "186591255",[-89.78101715770602, 30.31468512483691]],
    [ "186591260",[-89.73457462449714, 30.26495073643574]],
    [ "186595238",[-90.11430019159639, 30.492038994909166]],
    [ "Madisonville Substation",[-90.1921311018568, 30.42726063859628]],
    [ "186596511",[-89.78867783607369, 30.270150648875514]],
    [ "186600582",[-89.92172244195802, 30.362232967627815]],
    [ "186600585",[-90.00528425932346, 30.351149150479515]],
    [ "Hammond Substation",[-90.51713930035359, 30.504980855991175]],
    [ "Ponchatoula Substation",[-90.46430207517685, 30.437689455781666]],
    [ "Independence Substation",[-90.54073145343604, 30.641592290280165]],
    [ "Sorrento Substation",[-90.8491277657921, 30.185147718253145]],
    [ "Amite Substation",[-90.50851789473889, 30.75416165799573]],
    [ "Springfield Substation",[-90.57354995680568, 30.45046115440164]],
    [ "186670182",[-90.78613048973651, 30.28663983662713]],
    [ "186690212",[-90.89694360823621, 30.11653038666713]],
    [ "Burnside Substation",[-90.91473944018956, 30.15060777650204]],
    [ "Entergy Louisiana",[-90.96602207918131, 30.173811631947398]],
    [ "Entergy Louisiana",[-90.86488672071391, 30.121866053984224]],
    [ "Air Products & Chemicals, Inc.",[-90.86988636236804, 30.120022716901612]],
    [ "186690218",[-90.89719433534178, 30.11706859038391]],
    [ "Occidental Chemical Corporation",[-90.82861900442994, 30.058795040361318]],
    [ "186706069",[-90.59327452472091, 30.060103335400477]],
    [ "Marathon Petroleum Company LP",[-90.59526748719493, 30.068591735316915]],
    [ "Marathon Petroleum Company LP",[-90.588972942168, 30.061965772288083]],
    [ "186706080",[-90.53430313827309, 30.070082901556816]],
    [ "186706081",[-90.61633617005126, 30.075419992008484]],
    [ "186706082",[-90.79392857958992, 30.0558255056842]],
    [ "Entergy Louisiana",[-90.58895173349202, 30.061222258206325]],
    [ "Carson Substation",[-121.80418228592283, 45.72026709305462]],
    [ "Mountain View Substation",[-112.2726133652684, 33.63882046448947]],
    [ "Vacherie Substation",[-90.7211620272239, 29.981413299318152]],
    [ "186723001",[-90.4548120639098, 29.988238794789453]],
    [ "186723003",[-90.4757398514435, 29.99849598893248]],
    [ "Donaldsonville Substation",[-90.99521312112488, 30.08544331755437]],
    [ "186732578",[-90.95300405811473, 30.08373966398615]],
    [ "Entergy Louisiana",[-90.89363697487774, 30.00093181597254]],
    [ "Mosaic Fertilizer LLC",[-90.92220758220239, 30.081856927804957]],
    [ "McCall Substation",[-91.08879697888266, 30.10444238579365]],
    [ "186792692",[-81.30752109592879, 39.35409586056731]],
    [ "186792695",[-81.30348835362558, 39.35683897655593]],
    [ "186792696",[-81.31027069699529, 39.34697082295275]],
    [ "186792700",[-80.82069160011379, 39.843037626936386]],
    [ "Thibodaux Substation",[-90.8170303526159, 29.81942352576427]],
    [ "Terrebonne Substation",[-90.75634201766395, 29.658776896398784]],
    [ "186814970",[-92.38487017483926, 45.87069510532548]],
    [ "186814971",[-92.36985603316162, 45.881097824823684]],
    [ "186823756",[-90.74530892110405, 29.655160893860483]],
    [ "Entergy Louisiana",[-90.69346655504759, 29.62387888574242]],
    [ "Houma Substation",[-90.69229386828404, 29.588199673962]],
    [ "Entergy Louisiana",[-90.43774697630602, 29.587458727736784]],
    [ "186840935",[-81.73365228400019, 33.33757715580615]],
    [ "Invista Substation",[-80.65625740000002, 34.232846550000005]],
    [ "Lee Substation",[-82.4343674, 34.6016465]],
    [ "WestRock Substation",[-79.55925292486509, 34.1528165351921]],
    [ "Port Hudson Substation",[-91.24512748658032, 30.63876872059671]],
    [ "Entergy Louisiana",[-91.0036401648197, 30.567345527344962]],
    [ "186844753",[-91.17736417230186, 30.553246959055063]],
    [ "Entergy Louisiana",[-90.89485926117703, 30.564473729552777]],
    [ "Airline Substation",[-90.95840513515124, 30.300910502019235]],
    [ "DEMCO",[-91.00616470948297, 30.591358633396755]],
    [ "Gonzales Substation",[-90.90440948735244, 30.230998759718354]],
    [ "Duplessis Substation",[-90.93799390276969, 30.273011386824006]],
    [ "Oak Grove Substation",[-90.9677247078706, 30.320851974114635]],
    [ "DEMCO",[-90.89787950150789, 30.487657989561395]],
    [ "186844767",[-90.97623760117813, 30.371663486723975]],
    [ "Entergy Louisiana",[-91.03238782946045, 30.474897242533345]],
    [ "Occidental Chemical Corporation",[-90.9764316652517, 30.18304551280938]],
    [ "Shell Chemical LP",[-90.98589389726664, 30.18673909217974]],
    [ "186845578",[-91.0666886824627, 30.2299776265473]],
    [ "Cosmar Substation",[-91.0683249797527, 30.227682997986637]],
    [ "BASF Corporation",[-90.99213406847882, 30.197349762098476]],
    [ "Rubicon, LLC",[-91.0119532728367, 30.198933200795214]],
    [ "BASF Corporation",[-90.99159290418922, 30.19791893465491]],
    [ "186846412",[-92.38604839765229, 45.788231821595126]],
    [ "186846419",[-92.3860183311404, 45.78874584516541]],
    [ "The Dow Chemical Company",[-91.23802149746395, 30.32162722988424]],
    [ "Shintech Louisiana, LLC",[-91.26389491235591, 30.325469988573573]],
    [ "Entergy Louisiana",[-91.26560944732051, 30.32781918549587]],
    [ "Argos Cement Substation",[-84.46898189999999, 33.824240599999996]],
    [ "Georgia Power",[-84.45976289250379, 33.829904780558515]],
    [ "Georgia Power",[-83.79199056319914, 33.0621954281867]],
    [ "Georgia Power",[-84.47468774999999, 33.8263788]],
    [ "Georgia Power",[-83.55724798152491, 32.81285419735726]],
    [ "Crisp Substation",[-83.94037400636725, 31.843928008579816]],
    [ "Georgia Power",[-84.47300169736778, 33.82548984366427]],
    [ "Georgia Power",[-84.47688368942731, 33.82264502351917]],
    [ "186847462",[-84.60822814847111, 30.048257094406953]],
    [ "Georgia Transmission Cooperative",[-84.69676705252662, 30.740682214268965]],
    [ "Grady EMC",[-84.69732495, 30.741330650000002]],
    [ "Winkler Substation",[-81.84816367565242, 26.604180356792224]],
    [ "East Jackson Substation",[-84.3337916590765, 42.26322040625189]],
    [ "Parr Road Substation",[-84.02452394982423, 42.1586791492407]],
    [ "Dorset Substation",[-83.8297592596608, 42.1546264537624]],
    [ "Parnall Substation",[-84.41829621838384, 42.288536846505686]],
    [ "Ingham Substation",[-84.40982624739495, 42.249628529477796]],
    [ "Oak Street Substation",[-84.4052319246733, 42.25207944320403]],
    [ "Entergy Mississippi",[-90.13374746539816, 32.40630932488259]],
    [ "Luckney Substation",[-90.05500845935703, 32.34980649656211]],
    [ "186933833",[-90.09816623055951, 32.41187822670868]],
    [ "Entergy Mississippi",[-90.11580113412283, 32.4073738862282]],
    [ "186935043",[-90.18914525, 32.4539435]],
    [ "186935398",[-92.39533619999999, 45.70899669999999]],
    [ "Pioneer Substation",[-83.72734681024654, 42.212241022301605]],
    [ "186935880",[-90.07936966012096, 32.46778861307844]],
    [ "Dayton Substation",[-83.5332394549094, 42.17568254883432]],
    [ "Collins Substation",[-83.61560605703534, 42.20698077764234]],
    [ "186940708",[-90.0166203807236, 32.35873833643451]],
    [ "Bozeman Road Substation",[-90.13734909949507, 32.51550454156892]],
    [ "Yandell Road Substation",[-90.08370610790519, 32.51136168433661]],
    [ "Canton South Substation",[-90.05412553889042, 32.5856994491721]],
    [ "Canton Substation",[-89.99953606825045, 32.617668318182275]],
    [ "Pickens Substation",[-89.9363033291561, 32.93193923543406]],
    [ "186951652",[-89.6677955749921, 33.012105575861355]],
    [ "Elm Substation",[-83.25443831627133, 42.25749077944755]],
    [ "Gerald Andrus Station",[-91.12167392227919, 33.34902610824857]],
    [ "186962403",[-91.12672825036742, 33.33389652097851]],
    [ "186962405",[-90.62321533669378, 32.913350292771476]],
    [ "186962829",[-92.48385884002433, 45.6123443251846]],
    [ "186962832",[-92.48075985839718, 45.57910978529629]],
    [ "Jupiter Substation",[-83.20995634814624, 42.22880538854196]],
    [ "Berlin Substation",[-83.28445496729829, 42.05132451322057]],
    [ "Trenton Channel Substation",[-83.18506580065358, 42.12256694295849]],
    [ "Lake Village Bagby Substation",[-91.2908751338442, 33.34667112425007]],
    [ "Horn Substation",[-83.19559649142225, 42.12731249304919]],
    [ "Indianola 230 Substation",[-90.6338259625678, 33.43909919864558]],
    [ "186974647",[-83.22365030683659, 42.1332262607311]],
    [ "MidAmerican Energy",[-90.82146119785827, 41.48029174117062]],
    [ "Nameless Substation",[-97.92833097810491, 30.528144827298153]],
    [ "186981707",[-93.39240717506975, 48.59374532210333]],
    [ "Tillatoba Substation",[-89.90128076872958, 33.965596144661816]],
    [ "Amory Water & Electric",[-88.50361710000001, 33.990149200000005]],
    [ "186986190",[-90.46260388817551, 34.4816231707568]],
    [ "North Oakland Substation",[-89.90893131313567, 34.079371480605765]],
    [ "Entergy Mississippi",[-90.47008477501295, 34.480030408141744]],
    [ "186986195",[-89.92426111453462, 34.189767078792926]],
    [ "186986197",[-89.92775516464116, 34.33296509100995]],
    [ "Lula Substation",[-90.46289146640314, 34.48184554539789]],
    [ "Ritchie Substation",[-90.59942135733749, 34.464573068570665]],
    [ "Tunica 230/115 Substation",[-90.38381841315373, 34.67136887402938]],
    [ "186994186",[-90.16907509568706, 34.939084484391906]],
    [ "186994190",[-90.26301530010403, 34.86154696666666]],
    [ "186994196",[-90.32455478222074, 34.787710449485886]],
    [ "186994207",[-90.26221315249535, 34.86113906961166]],
    [ "186994945",[-90.04566404759902, 34.93424986200756]],
    [ "Horn Lake Substation",[-90.01809347442111, 34.967633474544556]],
    [ "Brinkley East Substation",[-91.14466432104868, 34.900689104300106]],
    [ "Woodward Substation",[-92.05968348904747, 34.23262438083895]],
    [ "Entergy Arkansas",[-90.88530181249953, 34.65968217489106]],
    [ "Omaha Public Power District",[-95.97580353060887, 41.27640136397698]],
    [ "Bessemer Electric Service",[-86.96101585986462, 33.40818143765984]],
    [ "187018390",[-86.69323676564612, 33.279287377587146]],
    [ "187031281",[-77.8367591916385, 42.753125824543815]],
    [ "Fair Park Substation",[-93.27929726277414, 44.31200681108993]],
    [ "Forestdale Substation",[-86.88668572458572, 33.57393260429169]],
    [ "187105448",[-86.91738279750221, 33.58253916235464]],
    [ "Curran Substation",[-89.96316672039733, 30.055971054076597]],
    [ "Peters Road Substation",[-90.05985808954978, 29.856771725114438]],
    [ "Barataria Substation",[-90.12881275852513, 29.75987144386887]],
    [ "Holiday Substation",[-90.01601417685113, 29.920916454028788]],
    [ "187141541",[-89.97672516789368, 29.938788460589986]],
    [ "Chalmette Refining, L.L.C.",[-89.97481193761557, 29.938721576257716]],
    [ "Poydras Substation",[-89.86809962573581, 29.86849521564088]],
    [ "Gretna Substation",[-90.05130862025268, 29.921497409911087]],
    [ "Harvey Substation",[-90.07891155953376, 29.883209840273214]],
    [ "187141550",[-89.9764875599313, 29.939496163098674]],
    [ "Westwego Substation",[-90.14022844283457, 29.894364149164772]],
    [ "Golden Meadow Substation",[-90.25816124039223, 29.381677704984334]],
    [ "Fourchon Substation",[-90.21713255571335, 29.212748747786666]],
    [ "Tennessee Gas Pipeline Company",[-89.72829444654664, 29.515525548859802]],
    [ "Entergy Louisiana",[-89.72802668169388, 29.515067647915856]],
    [ "Entergy Louisiana",[-90.30132443388801, 29.463893298212476]],
    [ "West Fork Substation",[-92.14253613046597, 30.536835304870035]],
    [ "187149310",[-92.14283051106807, 30.535731067004303]],
    [ "AP11",[-87.89961176757058, 42.306090297879905]],
    [ "Airport Lane Substation",[-86.98550725000003, 33.35991655]],
    [ "McAdory Substation",[-87.00484772492014, 33.32357289158678]],
    [ "Linde",[-86.78666605000001, 33.53399015]],
    [ "Southside Substation",[-86.8089393925911, 33.49888483755587]],
    [ "Cantonment Substation",[-87.326283241039, 30.596630861686435]],
    [ "Pine Forest Substation",[-87.31263147154391, 30.532533956486294]],
    [ "Champion Substation",[-87.3266609086735, 30.600942535624952]],
    [ "Brackenridge Substation",[-97.73292035763227, 30.27273124743364]],
    [ "East Montevallo Substation",[-86.84233406309302, 33.10298078186884]],
    [ "Jemison Substation",[-86.75149619424876, 32.98140438207759]],
    [ "Alabama Power",[-86.589735267791, 32.72484514770099]],
    [ "CRH North America, Inc.",[-86.5642937, 32.790719599999996]],
    [ "187410295",[-86.23038969363708, 32.416125725127955]],
    [ "South Montgomery Substation",[-86.29267470533794, 32.32564100986605]],
    [ "187426095",[-86.23865638337561, 32.30387766765537]],
    [ "187430371",[-92.04458216271583, 30.2550608685966]],
    [ "187432265",[-92.04605562534299, 30.238932472434982]],
    [ "Acadiana Mall Substation",[-92.07355254925716, 30.175060816400233]],
    [ "Beadle Substation",[-92.01753319984321, 30.175117660344327]],
    [ "Elks Substation",[-91.99294400704467, 30.18380434092698]],
    [ "Flanders Substation",[-92.05025649888351, 30.15553764164622]],
    [ "187463805",[-86.21490444999998, 32.35714125]],
    [ "187470448",[-86.24158852470926, 32.36664979112447]],
    [ "Cocodrie Substation",[-92.26353042906423, 30.845182850900716]],
    [ "Ville Platte Substation",[-92.27025007818489, 30.696531467937238]],
    [ "Forest Hill Substation",[-92.45608006967139, 31.06087436989244]],
    [ "Maxwell Field Substation",[-86.34298023477943, 32.37600336251375]],
    [ "Washington Park Substation",[-86.34069061075311, 32.33619694115061]],
    [ "North Montgomery Substation",[-86.30318486806263, 32.3930213355922]],
    [ "Rapides Substation",[-92.58382385672385, 31.362639179896174]],
    [ "Hot Wells Substation",[-92.56905766076859, 31.311197573928713]],
    [ "CLECO",[-92.51347146450644, 31.26843241675693]],
    [ "Rodemacher Substation",[-92.71364888442645, 31.395877366559688]],
    [ "Haleyville Substation",[-87.60351009203846, 34.23642482153757]],
    [ "Parkland Switching Station",[-87.34668245305701, 33.88866461322903]],
    [ "Best Coal, Inc.",[-87.26401915000001, 33.701668600000005]],
    [ "Pineville Substation",[-92.44668469525375, 31.319342095952067]],
    [ "Colfax Substation",[-92.71782889372365, 31.530794974611748]],
    [ "Miller Bayou Substation",[-86.9146691411691, 30.472244242782327]],
    [ "187582592",[-117.15902519001885, 33.51779379844304]],
    [ "Sullivan Street Substation",[-86.64852557726194, 30.422164537782788]],
    [ "187593174",[-95.94744935618645, 41.26724545025153]],
    [ "Pacific Gas and Electric Company",[-120.83027115998142, 39.019324978009394]],
    [ "Miramar Substation",[-86.35919724738031, 30.378946659537235]],
    [ "East Leesville Substation",[-93.25377348560755, 31.13993061361137]],
    [ "Leesville Substation",[-93.25256882561736, 31.055989910272743]],
    [ "Entergy Louisiana",[-92.63600780144043, 31.946562674074414]],
    [ "Clarence Substation",[-93.02112413700536, 31.841847871208525]],
    [ "187617950",[-92.78452676131793, 31.864036803130567]],
    [ "Montgomery Substation",[-92.87202852769562, 31.714243408951198]],
    [ "Entergy Louisiana",[-92.63572258223962, 31.94516916366657]],
    [ "Carroll Substation",[-93.3822567692974, 32.078286396876365]],
    [ "Western Kraft Substation",[-93.17236549278839, 31.905892492563343]],
    [ "Dolet Hills Substation",[-93.56923909931011, 32.03505099095877]],
    [ "Red River Substation",[-93.41742490719685, 32.05643609636982]],
    [ "187625962",[-93.41773002399454, 32.05620588711453]],
    [ "Fisher Substation",[-93.41388143730221, 31.50586258300641]],
    [ "Mansfield Substation",[-93.43089955553098, 31.87374663297403]],
    [ "Fairview Substation",[-86.6956249960024, 34.26551110475415]],
    [ "Guntersville Dam Substation",[-86.39381665042997, 34.42085946615827]],
    [ "Ironman Substation",[-86.98706589999999, 34.44204764999999]],
    [ "Neel Substation",[-87.0288906650676, 34.49293302819243]],
    [ "187663713",[-86.82468940000001, 34.183803600000005]],
    [ "Hartselle Substation",[-86.94285621652027, 34.42647289432741]],
    [ "Moulton Substation",[-87.29329898943406, 34.49219367561292]],
    [ "Priceville Substation",[-86.89121935000001, 34.523330550000004]],
    [ "Cullman Electric Cooperative",[-86.94186499560594, 34.254394215512704]],
    [ "Joe Wheeler EMC",[-87.4451913097488, 34.47125335846017]],
    [ "Colorado Springs Utilities",[-104.87387907206802, 38.84467136449974]],
    [ "187763935",[-87.2251481573263, 33.837417722936976]],
    [ "Burrows Crossing Road Substation",[-87.1585425, 33.9346965]],
    [ "Curry Substation",[-87.21265785000001, 33.9530611]],
    [ "187888467",[-106.5870034, 35.0725933]],
    [ "Berlin Substation",[-86.74296067328844, 34.17789351251118]],
    [ "Holly Pond Substation",[-86.63724412071109, 34.17530758282045]],
    [ "Jones Chapel Substation",[-87.0536276008531, 34.198849057209145]],
    [ "Arab Substation",[-86.50740494423187, 34.3876587233661]],
    [ "Trimble Substation",[-86.92797386655418, 34.10475104907294]],
    [ "187900629",[-112.35662327011032, 34.57777726169487]],
    [ "South Milford Substation",[-71.64428156190979, 42.82018314370399]],
    [ "Marshfield Substation",[-70.69518191845378, 42.08037265788464]],
    [ "Far Rockaway Substation",[-73.76002126284118, 40.61032918727004]],
    [ "Whiteside Substation",[-73.68555073702164, 40.709762494615056]],
    [ "Glendale Substation",[-112.18535416055185, 33.53603451683051]],
    [ "Jamaica Substation",[-73.81390755000001, 40.699185250000006]],
    [ "Salt River Project",[-111.93950771791013, 33.46323540606548]],
    [ "Sundance Substation",[-111.59032430452565, 32.92990087906012]],
    [ "Sundance Substation",[-111.5916837083949, 32.92616047776372]],
    [ "Electrical District No. 2 Substation",[-111.5666987974789, 32.87075020837244]],
    [ "Signal Substation",[-111.56289686199993, 32.93013541193831]],
    [ "Coolidge Substation",[-111.5255445418248, 33.00818595558992]],
    [ "Arizona Public Service",[-112.15368538462633, 33.441527846429466]],
    [ "Randolph Substation",[-111.5087096931605, 32.91623266387363]],
    [ "Taos Substation",[-105.63356984759893, 36.39488740948255]],
    [ "Baldwin Substation",[-73.6161754971766, 40.65687983259987]],
    [ "Freeport Substation",[-73.59577726795567, 40.65633527750053]],
    [ "Lynbrook Substation",[-73.67091214426144, 40.65536667642618]],
    [ "Ocean Avenue Substation",[-73.65621530636768, 40.65835669559056]],
    [ "Rockville Centre Substation",[-73.63376135, 40.6579054]],
    [ "Pima Substation",[-112.42588372147483, 33.479190225267864]],
    [ "Middletown Tap 2",[-74.40388866084056, 41.42290020989407]],
    [ "188168963",[-92.55620263857638, 47.44247837796165]],
    [ "HVDC B2B Station Hudson",[-74.01256690462246, 40.832062777031965]],
    [ "Savannah Substation",[-88.24978112179367, 35.2226001006089]],
    [ "City of Sheffield",[-87.40509551626727, 34.66055914771451]],
    [ "188255352",[-108.18474106023541, 36.77373426830595]],
    [ "Pahrump Substation",[-115.96875590904583, 36.19703980254777]],
    [ "188301764",[-115.28903615975166, 36.24041987605441]],
    [ "188301767",[-115.21106523813945, 36.05641733509589]],
    [ "188303069",[-114.99575295134525, 36.04108185038508]],
    [ "188303070",[-115.0034116529103, 36.040113487216416]],
    [ "188303072",[-114.99805512526618, 36.04044610067945]],
    [ "Magnolia Substation",[-115.17484162536523, 35.92704541539586]],
    [ "188340129",[-103.14873421682927, 32.725978672570584]],
    [ "188354290",[-89.74980734197318, 39.0422379363511]],
    [ "West 49th Street Substation",[-73.99588397843888, 40.76600299543504]],
    [ "Pedernales Substation",[-97.72111212370108, 30.249988924930424]],
    [ "North Knox Substation",[-83.98697966396762, 36.02609931928906]],
    [ "Eastbridge Substation",[-83.73138580432327, 36.06359801842299]],
    [ "Trentville Substation",[-83.7357734125007, 36.023749721658625]],
    [ "Ellistown Substation",[-83.8026135593725, 36.050379812242]],
    [ "Dry Gap Substation",[-83.97462523407678, 36.05937236510124]],
    [ "Dumplin Valley Switching Station",[-83.56831358529621, 36.03304987618725]],
    [ "House Mountain Substation",[-83.72172491816598, 36.117654074341964]],
    [ "Andersonville Pike Substation",[-83.93376816747768, 36.086467484403286]],
    [ "City of Tallahassee",[-84.31586318219077, 30.42410806528494]],
    [ "Harrisburg Substation",[-76.85705267948846, 40.257915365318446]],
    [ "Knoxville Utilities Board",[-84.02267714206978, 35.98522391974086]],
    [ "Emory Road Substation",[-83.80077461211778, 36.13890797734715]],
    [ "Whittle Springs",[-83.9041694943475, 36.01832265262806]],
    [ "Luttrell Substation",[-83.74622395000002, 36.208012]],
    [ "Mohawk Substation",[-83.8888836278972, 35.96668550535493]],
    [ "Volunteer 69kV Substation",[-83.81242646260154, 36.12113116130423]],
    [ "Park City Substation",[-83.8834613897319, 35.992359702237536]],
    [ "Knoxville Utilities Board",[-83.97351085, 35.97362705]],
    [ "Fair Drive Substation",[-83.94924596394783, 36.0263744935214]],
    [ "Fountain City Substation",[-83.9241491468809, 36.03755337948257]],
    [ "Middlebrook Substation",[-83.9884652811424, 35.96909183548207]],
    [ "Tennessee Ave Substation",[-83.95365415, 35.979540899999996]],
    [ "Tennessee Ave Substation",[-83.94743863057978, 35.983048438974535]],
    [ "188542519",[-106.7254036001584, 35.12460870284243]],
    [ "Coal Sub",[-106.63009054556557, 35.07806117954869]],
    [ "Omaha Public Power District",[-95.95823900405236, 41.18395624942437]],
    [ "188549729",[-97.89843313057901, 34.55022686201532]],
    [ "Alpine Substation",[-89.01896589459594, 42.260349025762885]],
    [ "188551965",[-89.09950326049147, 42.231769427032496]],
    [ "Kaheawa Pastures Wind Farm Hybrid Substation",[-156.5513074575157, 20.81377294515244]],
    [ "Escarpment Substation",[-97.89461979567882, 30.179978323283617]],
    [ "Asbury Substation",[-83.82471774906688, 35.94902620230433]],
    [ "Colonial Village Substation",[-83.87223195020609, 35.92074683418857]],
    [ "Hendron Substation",[-83.82215076894404, 35.90000333065692]],
    [ "Kodak Road Substation",[-83.6696357688259, 35.96305018749297]],
    [ "Knoxville Utilities Board",[-83.80656456531507, 35.97492406007821]],
    [ "Seymour Substation",[-83.7274718490356, 35.898061053998056]],
    [ "Shooks Gap Substation",[-83.78804487340231, 35.883634508198405]],
    [ "Lakeshore Substation",[-83.99529103837894, 35.91794936273502]],
    [ "Rocky Hill Substation",[-84.02155883541597, 35.903659443118606]],
    [ "188696965",[-104.21832776530843, 32.42302024756375]],
    [ "Morris Owen Substation",[-96.17465035000001, 48.10734599999999]],
    [ "Thief River Falls Highway 1 Substation",[-96.10965766103337, 48.12038402235335]],
    [ "Thief River Falls Municipal Substation",[-96.17971037250105, 48.11496623867636]],
    [ "Cosby Substation",[-83.24842463152531, 35.808955198774505]],
    [ "Pigeon Forge Substation",[-83.54686704119048, 35.78666222233365]],
    [ "Sevierville Substation",[-83.55878700876443, 35.85770333167864]],
    [ "Maynardville Substation",[-83.77666854331864, 36.25827680477226]],
    [ "Walker Springs Substation",[-84.05741725179834, 35.926468795989244]],
    [ "Center City Substation",[-83.91680216436684, 35.96637964662695]],
    [ "Bearden Substation",[-83.98039636302704, 35.94260949395407]],
    [ "John Hall Substation",[-83.93699159676491, 35.91611017752176]],
    [ "Murray Substation",[-83.99956691579642, 36.01016682200427]],
    [ "University Hospital Substation",[-83.9410688604297, 35.94164661268021]],
    [ "Braytown Substation",[-84.36924568168187, 36.160184449512315]],
    [ "Caryville Substation",[-84.192425555985, 36.320882653265215]],
    [ "Eaton Crossroads Substation",[-84.27246713419814, 35.84221858668362]],
    [ "Fort Loudoun Dam Substation",[-84.2446437727288, 35.792823081578945]],
    [ "Wartburg Substation",[-84.60453490497248, 36.114339183413186]],
    [ "Y-12 Substation",[-84.24787976213896, 35.99236907443849]],
    [ "Consolidated Nuclear Security, LLC",[-84.26324368641679, 35.98041061155853]],
    [ "188755862",[-84.34034639202787, 36.1233049596908]],
    [ "Athens Substation",[-84.5866128777065, 35.467538319025664]],
    [ "Tellico Substation",[-84.30104071307738, 35.37263658212156]],
    [ "Wellsville Substation",[-84.07199895712345, 35.63056007730293]],
    [ "Ulmerton Substation DUKE",[-82.70670533129444, 27.89285145470886]],
    [ "Ulmerton Substation DUKE",[-82.7067945869352, 27.891346927452727]],
    [ "St. Johnsville Station",[-74.68648557307317, 42.99674364450954]],
    [ "188839533",[-73.8295119754734, 41.53978437566199]],
    [ "Elmsford Substation",[-73.80902637692435, 41.04998490167333]],
    [ "Stoner Station 358",[-74.3222891293707, 42.98628856902866]],
    [ "Clinton Station 366",[-74.58974484829126, 42.90082662526193]],
    [ "Lacombe Substation",[-105.00012777926494, 39.758021227987086]],
    [ "Eagle Bend Substation",[-84.10787462990156, 36.09366798162807]],
    [ "Jena Substation",[-84.15241862282748, 35.65411654366766]],
    [ "Clinton Utilities Board",[-84.07640418552128, 36.159382229316805]],
    [ "Clinton Substation",[-84.12011962019744, 36.11411834263445]],
    [ "Englewood Substation",[-84.49631134075197, 35.42483894924249]],
    [ "Etowah Substation",[-84.51472093825784, 35.37439659898791]],
    [ "Apalachia Substation",[-84.43593000964596, 35.182816140997765]],
    [ "Northeast Benton Substation",[-84.58891885542607, 35.21852805623143]],
    [ "Madisonville Substation",[-84.37498255903095, 35.51588181044122]],
    [ "Vonore Substation II",[-84.26045118183436, 35.58425918469411]],
    [ "South Cleveland Substation",[-84.93688385, 35.144648450000005]],
    [ "Sugar Grove Substation",[-84.84027426853632, 35.07566830492246]],
    [ "Jasper Substation",[-85.60980371559839, 35.07472838291184]],
    [ "188958317",[-85.95226365628645, 34.71696063340937]],
    [ "Santeetlah Substation",[-83.86635025, 35.44719559999999]],
    [ "Marble Tie Substation",[-83.9148903421037, 35.189761759674674]],
    [ "Nantahala Substation",[-83.67686302080902, 35.271747450778605]],
    [ "Robbinsville Retail Substation",[-83.79598969525955, 35.32258035225605]],
    [ "Webster Tie Substation",[-83.2453250034712, 35.34189768253544]],
    [ "Hamilton Wolfe Road Substation",[-98.58822752253676, 29.515267985349283]],
    [ "189017841",[-95.89101669681483, 41.118042142473136]],
    [ "Dawson Creek Substation",[-91.0986288871538, 30.39125073462818]],
    [ "189018147",[-91.18531398462741, 30.491016362985988]],
    [ "Exxon Substation",[-91.18881128451356, 30.481699646432595]],
    [ "Delmont Substation",[-91.16267804281667, 30.49464644774267]],
    [ "189018154",[-91.13926191684367, 30.416022778597434]],
    [ "189018155",[-91.18586000234953, 30.498883030786384]],
    [ "189018159",[-91.21076771308522, 30.47526092384142]],
    [ "Esso Substation",[-91.17730102985534, 30.48920280414394]],
    [ "Entergy Louisiana",[-91.04797434188772, 30.36167339299477]],
    [ "Greenwell Springs Substation",[-91.10688527682564, 30.47906308847891]],
    [ "Hazel Substation",[-91.13484969447558, 30.492604548194542]],
    [ "Downtown Substation",[-91.17782283142134, 30.4523602883539]],
    [ "Oak Villa Substation",[-91.08695947576636, 30.457601887388282]],
    [ "189018171",[-91.27148920343387, 30.358037241498774]],
    [ "189018172",[-91.22416719649354, 30.459524347594467]],
    [ "Harelson Substation",[-91.05913888230808, 30.435748484795674]],
    [ "Bulls Gap Substation",[-83.1144128550156, 36.27082711234479]],
    [ "Bluff City Substation",[-82.23473988409584, 36.49989526013599]],
    [ "Kyles Ford Substation",[-83.03268176557279, 36.5750263493957]],
    [ "Rogersville Substation",[-83.0213965995446, 36.39662333317942]],
    [ "Murphy Substation",[-84.02188173754533, 35.09565769763294]],
    [ "189089690",[-84.01955892623403, 35.07608680258455]],
    [ "General Electric Substation",[-73.96541912842467, 42.80779728900386]],
    [ "189151694",[-74.20033246823559, 42.760680711036244]],
    [ "Schoharie Substation",[-74.30413670000002, 42.673245249999994]],
    [ "Middleburgh Substation",[-74.33192946489109, 42.60217585428806]],
    [ "Omaha Public Power District",[-96.023224425075, 41.18325419390013]],
    [ "Eaton Crossroads Substation",[-84.32521168777393, 35.85109504040467]],
    [ "Loudon Substation",[-84.35159686450825, 35.73137529748635]],
    [ "Melton Hill Dam Substation",[-84.30079888994116, 35.88478076947585]],
    [ "Boyd Station Substation",[-84.1837415759095, 35.84325596566314]],
    [ "189192105",[-84.39509075000002, 35.742036750000004]],
    [ "Cranberry Substation",[-81.96614067480992, 36.15204421325928]],
    [ "Watauga Dam Substation",[-82.12468024766227, 36.32971252045532]],
    [ "West Johnson City Substation",[-82.39201271393736, 36.31288776170215]],
    [ "189217854",[-82.38158686652874, 36.279115803698936]],
    [ "Fish Springs Substation",[-82.05214494368786, 36.316240615091516]],
    [ "Pandora Substation",[-81.94015555000001, 36.4404742]],
    [ "South Holston Dam Substation",[-82.09071747180913, 36.523043636408595]],
    [ "Tennessee Valley Authority",[-82.26119592747384, 36.496569817236725]],
    [ "Weaver Substation",[-83.97351500374184, 34.88559763982576]],
    [ "Hayesville Substation",[-83.82322195, 35.03009265]],
    [ "J M Huber Substation",[-84.54013289588569, 35.277907915488434]],
    [ "Ocoee Dam Number One Substation",[-84.64932209936175, 35.095777513133484]],
    [ "Ocoee Village Substation",[-84.7193299831838, 35.12687073135198]],
    [ "189265825",[-84.82862948079892, 35.15733884711843]],
    [ "189299017",[-79.55210086307036, 33.80267970519252]],
    [ "Spring City Substation",[-84.87436354541173, 35.6752419921083]],
    [ "189432311",[-88.41454652122817, 33.49405673445668]],
    [ "Schuyler Station",[-75.17133860867278, 43.08911038611579]],
    [ "Terminal Station",[-75.22634618272183, 43.111702638545175]],
    [ "Santa Rosa Beach Substation",[-86.229377115316, 30.378083667790666]],
    [ "Santa Rosa Substation",[-86.18784110208952, 30.37258369364999]],
    [ "Cavanaugh Road Station",[-75.27092948772824, 43.141294915525485]],
    [ "Stittville Station",[-75.25883474720587, 43.21072387392539]],
    [ "Henderson Park Substation",[-86.41365584999998, 30.385647399999993]],
    [ "Oneida Station",[-75.6314231877217, 43.102099960267964]],
    [ "Turning Stone Station",[-75.58819842758524, 43.118116903846506]],
    [ "Greenwood Substation",[-85.68299996484082, 30.184656313068427]],
    [ "Wewa Road Substation",[-85.60729185, 30.1545782]],
    [ "Ocoee Number Three Dam Substation",[-84.48229852944469, 35.07437388060037]],
    [ "Basin Substation",[-84.38689202383013, 35.004016281205004]],
    [ "East Murfreesboro Substation",[-86.3527142074572, 35.83629102083723]],
    [ "Great Falls Substation",[-85.63573536166197, 35.8066844705852]],
    [ "189483047",[-86.3344778794846, 35.93694298420486]],
    [ "Morrison Substation",[-85.89433415869836, 35.61632733516533]],
    [ "Pikeville Substation",[-85.19426799999998, 35.6088159]],
    [ "Lawrenceburg Primary Substation",[-87.3209959732593, 35.27958557877801]],
    [ "West Columbia Substation",[-87.09317515054586, 35.61760050833068]],
    [ "Fenner Sub",[-75.76484391698808, 42.95283020837589]],
    [ "Delphi Station",[-75.89128599360814, 42.8463279531479]],
    [ "Fenner Wind Farm Station",[-75.74319597727198, 42.98084861518248]],
    [ "Whitman Station",[-75.71610879146009, 43.01372475234477]],
    [ "Labrador Station",[-76.025930641082, 42.72324224746644]],
    [ "Sienna Hills Substation",[-113.4817589075527, 37.1314673863294]],
    [ "Elgin Substation",[-87.38444457047397, 34.86985699805862]],
    [ "Sharon Substation",[-74.54811907588955, 42.76763334466887]],
    [ "Gate II Substation",[-71.31963917177856, 41.51100863315721]],
    [ "Navy Substation",[-71.31026831345177, 41.5286457393719]],
    [ "Judd Brook Substation",[-72.33147905826749, 41.595174947788465]],
    [ "Arlington Substation",[-73.14884483303945, 43.05812134886126]],
    [ "Dover Substation",[-72.8775658571838, 42.945252620405945]],
    [ "Essex Substation",[-73.11287846466637, 44.48109425295737]],
    [ "Sandbar Substation",[-73.20596195664243, 44.60914571423571]],
    [ "Vernon Substation",[-72.51531415, 42.7715476]],
    [ "Broughwell Substation",[-84.47360875062724, 42.39661904683607]],
    [ "Roberts Street Substation",[-84.37298585, 42.25044085]],
    [ "Vevay Substation",[-84.47333379401002, 42.57331007820363]],
    [ "Parma Substation",[-84.60690242878165, 42.25617234455149]],
    [ "189879512",[-107.62342989476333, 36.797712769544106]],
    [ "Albertville Substation",[-86.18531567182372, 34.23591139161981]],
    [ "Fort Payne Substation",[-85.68865473166338, 34.47810293790488]],
    [ "Georgia Mountain Substation",[-86.38693213682934, 34.366680950347224]],
    [ "Guntersville Substation",[-86.31557653077793, 34.317069793843665]],
    [ "Henagar Substation",[-85.75294822025867, 34.627195184321614]],
    [ "Pointe North Substation",[-75.3698188, 40.674510999999995]],
    [ "Westgate Substation",[-75.40483119374221, 40.65208495760088]],
    [ "North Bethlehem Substation",[-75.40750111517447, 40.67323835031155]],
    [ "East Avenue Substation",[-73.188665343799, 44.48063315213004]],
    [ "Georgia Switching Station",[-73.15526223451552, 44.71419392619955]],
    [ "Milton Substation",[-73.12016908811066, 44.63548346923076]],
    [ "Lime Kiln Substation",[-73.16965108721412, 44.48797407958764]],
    [ "IBM Substation",[-73.09557836153613, 44.4793147925047]],
    [ "190022308",[-115.04771238845261, 48.875889314344285]],
    [ "Orchard Substation",[-73.62301120322078, 40.85660342004778]],
    [ "Deer Park Substation",[-73.3199829507805, 40.76309291793804]],
    [ "Nazareth Substation",[-75.3260585680448, 40.75457726308369]],
    [ "Commack Substation",[-73.32171657198523, 40.84154379493303]],
    [ "State School Substation",[-73.40005220365055, 40.79734031206413]],
    [ "Wolf Hill Substation",[-73.3816822, 40.81185085]],
    [ "Northampton Energy Substation",[-75.47913541138797, 40.692837717534715]],
    [ "Catasauqua Substation",[-75.46471391212914, 40.65156749512541]],
    [ "Allentown Substation",[-75.455992432933, 40.609481948011094]],
    [ "East Allentown Substation",[-75.43355662568041, 40.63249872105269]],
    [ "AT&T Substation",[-75.44933058642808, 40.6293975438029]],
    [ "190096554",[-75.48734789502127, 40.69074484901109]],
    [ "190118640",[-87.17013789999999, 30.641399700000004]],
    [ "Mount Sinai Substation",[-73.01557846201064, 40.937010358955035]],
    [ "190127914",[-75.35756782716875, 40.62274015360843]],
    [ "Seidersville Substation",[-75.37453921828178, 40.58782275062872]],
    [ "190127919",[-75.35662158976461, 40.61699071212352]],
    [ "Lanark Substation",[-75.42246346696209, 40.54500900519912]],
    [ "190127925",[-75.33183314999998, 40.61887159999999]],
    [ "Sandestin Substation",[-86.31148029233958, 30.380640724606515]],
    [ "Bloomfield Substation",[-72.7286015421166, 41.828721129910214]],
    [ "Rood Avenue Substation",[-72.66898431466934, 41.82874204861746]],
    [ "190133138",[-75.62670663422156, 40.591565523299664]],
    [ "190133141",[-75.62698797681715, 40.59130584437619]],
    [ "South Whitehall Substation",[-75.52220951733354, 40.624975822456705]],
    [ "Airport Substation",[-86.53360813387864, 30.795272532862505]],
    [ "Dorneyville Substation",[-75.53072748966574, 40.581778816655564]],
    [ "Egypt Substation",[-75.53912854999999, 40.680247449999996]],
    [ "Sacramento Municipal Utility District",[-121.43406196171213, 38.60231971419088]],
    [ "Penn Substation",[-75.19379820697358, 39.94500018494903]],
    [ "Ashfield Substation",[-75.7373368452644, 40.772737647539664]],
    [ "South Slatington Substation",[-75.61421501523675, 40.737989356340144]],
    [ "Cobleskill Substtaion",[-74.48532942661356, 42.68799298371597]],
    [ "Tuthill Substation",[-72.61145450000001, 40.95917944999999]],
    [ "Quogue Substation",[-72.60681619057921, 40.83447089124911]],
    [ "North Bellport Substation",[-72.93843912373546, 40.77403649441036]],
    [ "Ridge Substation",[-72.9043558911769, 40.91096443012718]],
    [ "190522757",[-75.39668658086839, 40.71711248930735]],
    [ "190528204",[-82.99694178676886, 40.49854209074061]],
    [ "190528210",[-82.91329654970794, 40.47608480493621]],
    [ "Mickleys Substation",[-75.4987732117323, 40.639994325218915]],
    [ "Sumner Substation",[-75.49020434489982, 40.60941967198098]],
    [ "Sacramento Municipal Utility District",[-121.44710668528971, 38.60565042271243]],
    [ "Sheriff's Posse Substation",[-98.1625974298888, 29.664657693056448]],
    [ "Fort Deposit TS Substation",[-86.57716911711391, 31.92470878730869]],
    [ "Gulf Breeze Substation",[-87.15568681279757, 30.360737900915538]],
    [ "Hurlburt Substation",[-86.74846009999999, 30.41215224999999]],
    [ "Clifton Substation",[-87.98346463094775, 35.3727320551186]],
    [ "Vernon Main Street Substation",[-99.28541873304724, 34.16349221373091]],
    [ "190984370",[-90.0098907333203, 32.22680474487125]],
    [ "East Norwich Substation",[-75.50984209975189, 42.521387035071555]],
    [ "Briargate Substation",[-104.72134348166634, 38.94638262392957]],
    [ "Hermosa Substation",[-103.2084991, 43.84024185]],
    [ "Fairburn Substation",[-103.21904430000001, 43.71228095]],
    [ "Pasadena Substation DUKE",[-82.73408245730698, 27.771441244776298]],
    [ "191158708",[-81.651993434592, 28.25474993098688]],
    [ "191161146",[-78.6150965079874, 36.29678424522384]],
    [ "PPL",[-75.53098910943152, 40.5630860777664]],
    [ "Schnecksville Substation",[-75.60409685421602, 40.6656630978432]],
    [ "Emmaus Substation",[-75.49675955000001, 40.52558915]],
    [ "West Allentown Substation",[-75.4735267261708, 40.56850353129159]],
    [ "PPL",[-75.47268196028169, 40.575824306218074]],
    [ "MidAmerican Energy",[-95.86803419943831, 41.25392530209763]],
    [ "MidAmerican Energy",[-95.86703430121781, 41.223033599248716]],
    [ "MidAmerican Energy",[-95.86698395509008, 41.22543870120667]],
    [ "MidAmerican Energy",[-95.88895244479924, 41.23976864774751]],
    [ "MidAmerican Energy",[-95.88761902856677, 41.25423152217243]],
    [ "Javelina Substation",[-112.41009521865318, 33.62574525983861]],
    [ "South Hero Substation",[-73.33862966791318, 44.66698942216793]],
    [ "Hancock Substation",[-104.78252911948401, 38.798125782205474]],
    [ "Southgate Substation",[-104.82282508697425, 38.79769086121448]],
    [ "Consumers Energy",[-84.38565978628057, 42.29466966956873]],
    [ "Louisville Substation",[-89.05914011442117, 33.11681239682765]],
    [ "Peat Street Station",[-76.11811899729692, 43.051639082119586]],
    [ "Evant Substation",[-98.15933016970577, 31.229762423808644]],
    [ "Cragmor Substation",[-104.80781036462872, 38.896664708730974]],
    [ "191913140",[-82.34957177859236, 40.82198248739003]],
    [ "191913141",[-82.34986960304056, 40.82148707219859]],
    [ "Lafayette Primary Substation",[-86.07298375763035, 36.569097494933125]],
    [ "Mountain EMC",[-81.88242130248891, 36.066484404993716]],
    [ "West Cookeville Substation",[-85.5356417813145, 36.16227677053701]],
    [ "Double Springs Substation",[-85.59962658936418, 36.148639273787545]],
    [ "Baxter Substation",[-85.64730786677217, 36.14878519858564]],
    [ "South Cookeville Substation",[-85.51662726353489, 36.14157204721984]],
    [ "191960466",[-85.51961182805323, 36.168629513871466]],
    [ "Cookeville Electric Department",[-85.4813483983473, 36.15160071280422]],
    [ "Algood Substation",[-85.44290219999998, 36.190036549999995]],
    [ "Turin Station",[-75.47290578111567, 43.29042472550432]],
    [ "192108923",[-110.60924347618584, 41.75959919178209]],
    [ "Dane",[-89.5015263846993, 43.251719860702686]],
    [ "192168820",[-89.7295491843299, 43.31019258642333]],
    [ "Westport",[-89.48158757382154, 43.14799896048746]],
    [ "Pheasant Branch",[-89.50111919513496, 43.107923368019875]],
    [ "Florida Power & Light",[-81.07637346186384, 29.23984696981007]],
    [ "192264528",[-82.7732839, 27.91609695]],
    [ "Largo Substation DUKE",[-82.77280021898554, 27.91356060601236]],
    [ "Duke Energy",[-82.7796282, 27.8932752]],
    [ "NextEra Energy",[-100.99361934999997, 31.91104295]],
    [ "NextEra Energy",[-100.95226057473054, 31.97087654581786]],
    [ "NextEra Energy",[-100.89861663889417, 31.90241749881149]],
    [ "Oklahoma Gas & Electric",[-97.43531245309816, 35.85536052033609]],
    [ "Seward Junction Substation",[-97.85092519042723, 30.634519807923176]],
    [ "Livingston Substation",[-85.32790376565187, 36.39633667501909]],
    [ "Monroe Substation",[-85.24817140480668, 36.43929450307993]],
    [ "192384193",[-85.11728773807134, 36.56576577947892]],
    [ "Tennessee Valley Authority",[-85.00360295, 36.7366801]],
    [ "192387309",[-104.26520380000001, 32.4289816]],
    [ "Willow Substation FPL",[-81.03598832477914, 29.129130038964664]],
    [ "Frankfort Substation",[-86.23104545000001, 44.632727550000006]],
    [ "North Lehmberg Substation",[-88.36293664999998, 33.502262400000006]],
    [ "Calexico Substation",[-115.50029976888912, 32.66906543595163]],
    [ "Upper Cumberland Electric Membership Corporation",[-85.53799264999999, 36.189557300000004]],
    [ "Celina Substation",[-85.45767935, 36.539528849999996]],
    [ "Dale Hollow Hydro Plant Substation",[-85.45185710381806, 36.53855130215345]],
    [ "192466367",[-91.48411769999998, 45.0990852]],
    [ "Ameren",[-90.77600020000001, 38.76556565]],
    [ "192483606",[-90.8264721289998, 38.75339813189578]],
    [ "192483607",[-90.99249245000001, 38.73824989999999]],
    [ "Carlsbad Substation",[-100.57352862464079, 31.56754020488859]],
    [ "Chincoteague Substation",[-75.37817010601226, 37.93419743159739]],
    [ "51st Street Substation DUKE",[-82.70194418729702, 27.770462594370123]],
    [ "San Angelo College Hills Substation",[-100.49528192363282, 31.432805592994754]],
    [ "San Angelo Southland Hills Substation",[-100.49180560493777, 31.403249001803395]],
    [ "San Angelo Power Station",[-100.49294369546853, 31.395143919281285]],
    [ "Pruett Substation",[-115.50855822371236, 32.685971726041835]],
    [ "Ben Ficklin Substation",[-100.438287511445, 31.402353694486617]],
    [ "192562655",[-78.17339895916838, 38.46064657248793]],
    [ "Erie Substation",[-104.95678777568257, 40.02720584441115]],
    [ "192573383",[-78.61878080000001, 36.1857066]],
    [ "Dahlonega Substation",[-83.97703208083487, 34.51965410473221]],
    [ "Woodmen Substation",[-104.81345378685435, 38.91906144127922]],
    [ "San Angelo South Substation",[-100.45727173977991, 31.423293002097473]],
    [ "San Angelo Highland Street Substation",[-100.4259624, 31.45107045]],
    [ "American Electric Power",[-100.42791452464986, 31.449872557105973]],
    [ "San Angelo Concho Substation",[-100.42716420439446, 31.450111985192954]],
    [ "192653254",[-115.52430357642652, 32.72910746502772]],
    [ "192656364",[-86.3805420023119, 39.77843860434737]],
    [ "Yellowjacket Substation",[-99.78481894653663, 30.931630004411026]],
    [ "Mason Substation",[-99.23444886329763, 30.738116625481467]],
    [ "Fort Mason Substation",[-99.23176056983559, 30.737731159434002]],
    [ "Mason Substation",[-99.18533115862415, 30.748169473971632]],
    [ "192681942",[-88.16536745863706, 40.0845897278126]],
    [ "192699990",[-90.82543565800435, 38.81548627481245]],
    [ "NJT Meadowlands Substaion",[-74.10280372009066, 40.745611516721816]],
    [ "Hext Substation",[-99.53821820000002, 30.872308999999998]],
    [ "Mason Switching Station",[-99.38003235, 30.82056989999999]],
    [ "Gillespie Substation",[-98.90406960112338, 30.30543428393433]],
    [ "Horseshoe Bay Substation",[-98.39252881482463, 30.532800664632926]],
    [ "Nimitz Substation",[-98.86583268565184, 30.30685398197356]],
    [ "Ferguson Substation",[-98.3715284909567, 30.555537834109064]],
    [ "Wirtz Substation",[-98.3373968189814, 30.559691919342065]],
    [ "Sandy Creek Substation",[-98.47751372100849, 30.569166615968903]],
    [ "Maple substation",[-80.15089173774342, 40.78437543142716]],
    [ "Wooster Substation",[-81.94136045116862, 40.77811826824709]],
    [ "Apple Creek Substation",[-81.84446504075494, 40.74465671991088]],
    [ "Canal Road Substation",[-81.89180391298385, 40.80942432241866]],
    [ "Inez Substation",[-82.47321487678612, 37.76696747478162]],
    [ "Spring Creek Substation",[-96.26651921768735, 30.57261253796734]],
    [ "Embarcadero Substation",[-122.39346224999998, 37.787518]],
    [ "North Plant Substation",[-104.81750817861604, 38.88275648607595]],
    [ "Florida Power & Light",[-80.15203403443506, 26.242643018138764]],
    [ "MidAmerican Energy",[-95.79587834920746, 41.23352248649965]],
    [ "Hartsville Substation",[-86.17294316908827, 36.3942462235736]],
    [ "Georgia Power",[-81.43437862867303, 32.11596981286203]],
    [ "Tennessee Valley Authority",[-86.44425121907875, 36.358396250446354]],
    [ "192968238",[-86.07402589757957, 36.35630970911403]],
    [ "East Eureka Substation",[-96.27786446311237, 37.82883680894618]],
    [ "Homer Substation",[-84.80177300000001, 42.1454081]],
    [ "Tennessee Valley Authority",[-85.94521008824803, 36.288458972236434]],
    [ "Concord Substation",[-84.64967709999999, 42.17650755]],
    [ "Tru-Turn Substation",[-84.71394572398904, 42.16404834354536]],
    [ "Kearney Sub",[-74.11857735250761, 40.744940769093]],
    [ "Santa Fe Substation",[-104.81489898465485, 38.819303825526184]],
    [ "193122266",[-149.61156497160707, 61.52403180155347]],
    [ "Mississippi Power",[-89.33600346992773, 31.33520184337837]],
    [ "Callam County Public Utility District",[-124.61138330882875, 48.36424399328108]],
    [ "193180302",[-89.3358600749051, 31.328758459069064]],
    [ "Middle Tennessee Electric",[-86.28706547331727, 36.23209158656887]],
    [ "Altoona Substation",[-95.65277777956608, 37.50225485552139]],
    [ "193355658",[-86.442402007217, 36.38257327773641]],
    [ "193357755",[-83.15390863337967, 40.60118728265543]],
    [ "City of Gallatin",[-86.41984116671301, 36.378642776640476]],
    [ "Power Plant Substation",[-93.09534859352507, 31.770342364005277]],
    [ "CIty of Natchitoches",[-93.10644948173659, 31.755675734349577]],
    [ "Iron Sub",[-106.65400679837278, 35.08012887033056]],
    [ "San Pedro Sub",[-106.57711598594766, 35.10270612469864]],
    [ "Kelker Substation",[-104.75598368601047, 38.79238151064272]],
    [ "Godley Tract Substation",[-81.24044158749123, 32.16212347523685]],
    [ "193460759",[-114.01385066496641, 36.82720815176557]],
    [ "Summer Shade Substation",[-85.68859759934081, 36.88211404832064]],
    [ "East Kentucky",[-85.68877051035315, 36.883481629896494]],
    [ "ITC",[-90.31607020531332, 41.85872005366044]],
    [ "Getwell Substation",[-89.96437829999999, 34.8616755]],
    [ "Dixie Street Substation",[-93.09583409790018, 31.7716090020334]],
    [ "Honey Substation",[-94.44594433810255, 30.39847181354749]],
    [ "193691510",[-113.933043691977, 36.89526182531342]],
    [ "Montgomery Substation",[-95.74157560158125, 37.21048288647175]],
    [ "Taylor Junction Substation",[-95.7431341104651, 37.23599797978767]],
    [ "Dearing Substation",[-95.69327739445758, 37.049515185359084]],
    [ "Mound Valley Substation",[-95.44954908825767, 37.15677717697119]],
    [ "Liberty Substation",[-95.60094239629416, 37.160304150708136]],
    [ "193736650",[-95.86765223931332, 36.82900865018999]],
    [ "North Padre Island Substation",[-97.22148250000002, 27.6000678]],
    [ "Naval Base Substation",[-97.27214945366566, 27.679015378863326]],
    [ "Mustang Island Substation",[-97.14216911866106, 27.72532993831181]],
    [ "Hoover Substation",[-83.74650492812381, 42.27000151189358]],
    [ "MidAmerican Energy",[-95.79232567057373, 41.264198024275494]],
    [ "193839484",[-114.07674088502344, 36.82138956928417]],
    [ "193839485",[-114.08375819339318, 36.82522057350982]],
    [ "Westlake Substation",[-79.71654874686314, 37.10283221535013]],
    [ "Amherst Substation",[-79.0124248, 37.5613785]],
    [ "Riverville Substation",[-78.9119732, 37.51116585]],
    [ "Rustburg Substation",[-79.10627410759021, 37.27717036127372]],
    [ "Hanson Substation",[-81.84839408267469, 26.622182926468646]],
    [ "193980234",[-104.57689320671061, 33.4530222748452]],
    [ "Public Service Company of New Mexico",[-106.55999587593459, 35.094400016409956]],
    [ "194086304",[-96.65616022523626, 36.76415343808389]],
    [ "194086305",[-96.18089865, 36.77124445]],
    [ "194086308",[-96.39120924374008, 36.76869638047663]],
    [ "Dexter",[-104.37453180761626, 33.19847417495189]],
    [ "Trego",[-114.8582083758821, 48.70769585326334]],
    [ "194224747",[-81.12169489534584, 36.16780418241542]],
    [ "194224750",[-81.13588238251053, 36.165529867669406]],
    [ "Colorado Springs Utilities",[-104.7215927250641, 38.86813947168333]],
    [ "Como Substation",[-89.93856020000001, 34.502030950000005]],
    [ "Palm Valley Substation",[-112.42573486258681, 33.505465382966065]],
    [ "194373289",[-96.68958640000001, 36.692725200000005]],
    [ "194373290",[-96.69583390000001, 36.79097500000001]],
    [ "194373296",[-96.74345401501823, 36.89742606798543]],
    [ "194375431",[-96.70012299659922, 36.57376581889033]],
    [ "194375433",[-96.70159975357754, 36.57428947785476]],
    [ "LaCreek Electric Association",[-101.72825639999998, 43.17928585]],
    [ "Arizona Public Service",[-112.40269041099371, 33.45062390224878]],
    [ "Sarival Substation",[-112.40862775257219, 33.410588354757635]],
    [ "194470898",[-109.34411485010317, 34.1095004978154]],
    [ "Mount Tom Substation",[-72.60471059810153, 42.281728276447964]],
    [ "Perry",[-121.05542645212806, 35.570880971009245]],
    [ "Huiskamp",[-89.41162040599845, 43.157962073352486]],
    [ "Dupont Switching Station",[-97.24679197803839, 27.900268546623742]],
    [ "Taft Substation",[-97.39856698392808, 27.96976345239124]],
    [ "Rincon Substation",[-97.32986186485326, 27.98680619409645]],
    [ "194778886",[-95.25272090205627, 29.76047560946916]],
    [ "194872929",[-103.09400496837299, 32.7332543906641]],
    [ "194872932",[-103.14307579614409, 32.68239518443035]],
    [ "Engle Substation",[-97.01310441987383, 29.674530212132446]],
    [ "Flatonia Substation",[-97.10585115582758, 29.678049944365938]],
    [ "Rosenberg Substation",[-95.80867138622759, 29.560081119208437]],
    [ "4th & Van Buren Substation",[-95.67506231213495, 39.056088731248025]],
    [ "Gainesboro Substation",[-85.63254247853791, 36.32864967753651]],
    [ "Copans Substation",[-80.18704216046528, 26.25645500308288]],
    [ "Winter St. Substation",[-92.1079283737523, 46.73047375530974]],
    [ "Macon Substation",[-83.87070480285146, 42.06602509756895]],
    [ "Cedar Point Wind Farm Elbert County Substation",[-103.7348857573405, 39.401242399477084]],
    [ "Roberts Substation",[-99.75940792376743, 32.29972725575371]],
    [ "Argo Substation",[-83.73996729549984, 42.28920057073563]],
    [ "Cedar Point Wind Farm Lincoln County Substation",[-103.67938635151445, 39.44863683661238]],
    [ "Petaluma A Substation",[-122.63626268181393, 38.234194194658535]],
    [ "National Enrichment Facility Substation",[-103.08148233793624, 32.431492897668754]],
    [ "195500832",[-103.19347048071766, 32.44295831307888]],
    [ "Northland Substation",[-95.69126650735974, 39.1382994978924]],
    [ "Lincoln Electric System",[-96.64476250029776, 40.796147760301515]],
    [ "195644749",[-95.32582126749223, 36.24162853937631]],
    [ "Lincoln Electric System",[-96.643260595679, 40.81546812802856]],
    [ "195718036",[-114.13308470000001, 36.7644914]],
    [ "6th & Golden Substation",[-95.64306611649448, 39.043827405566056]],
    [ "Timber Creek Substation",[-92.93588753218702, 42.005608224798316]],
    [ "196026520",[-96.67752931508963, 40.79834715518897]],
    [ "196065294",[-114.45270999948454, 36.615651692774854]],
    [ "196078329",[-114.46509603725501, 36.60777759236144]],
    [ "La Vernia Substation",[-98.05432898188882, 29.3239071380472]],
    [ "Olmos Substation",[-98.07177846375082, 29.400614484410138]],
    [ "Capote Substation",[-97.87825451275886, 29.56836937477031]],
    [ "Seguin Substation",[-97.95637894877261, 29.594252817825346]],
    [ "12th & Clay Substation",[-95.69133910895609, 39.0453379562148]],
    [ "196190815",[-98.04830170000002, 29.589021700000004]],
    [ "McQueeney Substation",[-98.04960397629601, 29.58854238458795]],
    [ "York Creek Substation",[-97.95005615223444, 29.737508740747703]],
    [ "Elliot Heights Substation",[-75.40567705, 40.61496064999999]],
    [ "Duke Energy Progress",[-79.70760894146031, 35.789454643519726]],
    [ "Duke Energy Progress",[-79.59658227768533, 35.790684374421225]],
    [ "Snow Camp Substation",[-79.45164159433737, 35.86394092285236]],
    [ "Lincoln Electric System",[-96.64345538682228, 40.83426398135162]],
    [ "Old Alabama Road Substation",[-84.31098120167682, 34.03595659670877]],
    [ "Jackson Energy Authority",[-88.80243168662999, 35.68854663612416]],
    [ "196330111",[-114.45821969999999, 36.48112845]],
    [ "196333961",[-114.45263787930195, 36.5484034753477]],
    [ "Alumax Substation",[-88.77693325576975, 35.65820097527322]],
    [ "Jackson Energy Authority",[-88.77524327942729, 35.64105407806312]],
    [ "196363696",[-85.61438973312688, 36.955108673748995]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.68164940765314, 36.997240421001756]],
    [ "Rochester Substation",[-70.99784622952394, 43.30794155039693]],
    [ "196494368",[-83.64581133558364, 41.7059467921963]],
    [ "196508108",[-115.19099493249124, 36.03780240756738]],
    [ "196549888",[-88.38875676447698, 35.85551132007879]],
    [ "196615248",[-95.93042274524416, 36.57702519385749]],
    [ "Shellbank Substation",[-87.83100163218069, 30.246730916550224]],
    [ "Romar Beach Substation",[-87.62303305783566, 30.262385175091065]],
    [ "Water Tower Substation",[-87.58471169159874, 30.27417432255619]],
    [ "Terrell Hills Substation",[-98.44676374488664, 29.4866461291482]],
    [ "196814395",[-96.68175835720649, 40.73534977094877]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.60575092823356, 36.9991634777509]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.70011646134292, 37.07772786986799]],
    [ "196859957",[-85.89272663326588, 37.12042385006011]],
    [ "Kettle Creek Substation",[-104.78510131923903, 38.987272541926416]],
    [ "Forbes Field Substation",[-95.68664343960779, 38.95001055090929]],
    [ "Marshall Substation",[-84.97163507528117, 42.26483069138444]],
    [ "197099520",[-88.03113729265733, 30.69211103034066]],
    [ "197104633",[-88.07173758577203, 30.668622002128703]],
    [ "197104637",[-88.1156906934767, 30.7197596502723]],
    [ "197117720",[-96.68270175662937, 40.87521405132978]],
    [ "Rhoades Substation",[-99.8906436019687, 39.80351250441859]],
    [ "North Tyler Substation",[-95.6726594836837, 39.075528553102636]],
    [ "Deer Creek Substation",[-95.6325103569053, 39.05117044915829]],
    [ "Port Saint Joe Substation",[-85.28694616221715, 29.811326734094134]],
    [ "Duke Energy",[-84.6908735, 29.8590526]],
    [ "Dehi",[-74.92666261345055, 42.26382230853423]],
    [ "Tennessee Valley Authority",[-86.52711940678621, 36.36121060440962]],
    [ "197406517",[-86.62297466272081, 36.30663554804309]],
    [ "197423516",[-85.69857410661545, 36.71292813807596]],
    [ "Wolcott Substation",[-94.79442481570408, 39.17742932808999]],
    [ "197465267",[-96.67206499768226, 40.85829507617503]],
    [ "Phillipsburg Substation",[-99.32419479038572, 39.77451560967824]],
    [ "54th & Meriden",[-95.6180814403097, 39.143333404672035]],
    [ "Platte Substation",[-104.81339742019458, 38.838266530153085]],
    [ "Bayview Substation",[-79.8872229129199, 32.80112558881378]],
    [ "197747181",[-96.64033362136709, 40.85897575052287]],
    [ "Custer Substation",[-83.38577445495326, 41.91937588692981]],
    [ "Gallaway Substation",[-89.61652662368017, 35.32376209400323]],
    [ "Hickory White Substation",[-89.58811331413102, 35.25219506899352]],
    [ "Dancyville Substation",[-89.3048630543612, 35.37422912617068]],
    [ "197853370",[-89.27546364999999, 35.5785923]],
    [ "197857631",[-110.91218241899169, 41.570458544187105]],
    [ "197857633",[-110.88021462857287, 41.454459706041376]],
    [ "197863251",[-122.5689529, 47.1551277]],
    [ "197876432",[-96.71074930336634, 40.812854444167236]],
    [ "Milan Substation",[-88.77254692587799, 35.94565605667428]],
    [ "198033492",[-112.03163000837083, 33.30575397662743]],
    [ "Ruppers Substation",[-112.06580407587231, 33.29327764180287]],
    [ "Tacoma Power",[-122.57899885000002, 47.1700747]],
    [ "Jefferson Switching Station",[-94.39208556006066, 32.77303876510924]],
    [ "Crossley Substation FPL",[-81.99007462522755, 29.58978553756981]],
    [ "Fort McCoy Substation OCB CLAY",[-81.98947996190023, 29.58972044965805]],
    [ "Phifer Substation #36 CLAY",[-82.2124996706477, 29.603383830152755]],
    [ "Rampart Substation",[-104.85794479603221, 38.90134772218725]],
    [ "Colorado Springs Utilities",[-104.73904183790286, 38.833724024550484]],
    [ "198446550",[-111.98959701108575, 33.32751604656418]],
    [ "198469131",[-75.60287478594493, 40.577442267290394]],
    [ "Trexlertown Substation",[-75.60485609265208, 40.556658902380605]],
    [ "198495898",[-75.64891623540716, 40.54370953207487]],
    [ "198510910",[-75.62906975832304, 40.56974752313894]],
    [ "Orange Blossom Electric Substation",[-81.96462614999999, 28.9606474]],
    [ "198636296",[-92.23456215468926, 30.349599038725817]],
    [ "Eunice Substation",[-92.38448213246026, 30.488143184335335]],
    [ "198636305",[-92.2623403142443, 30.36337329936359]],
    [ "198636323",[-92.38694265435745, 30.647815090602318]],
    [ "Entergy Louisiana",[-93.12139761085659, 30.260113475201738]],
    [ "198702822",[-92.60050595, 30.2794172]],
    [ "198702823",[-92.5984382, 30.28274975]],
    [ "Ellis Substation",[-92.43023132079355, 30.27428015918904]],
    [ "Honokaa Substation",[-155.47329806101996, 20.07165202321704]],
    [ "Brookville Substation",[-85.018246117189, 39.422285567187735]],
    [ "Quinton Heights Substation",[-95.69083170930892, 39.02915358405734]],
    [ "29th & Gage Substation",[-95.7238187314256, 39.0151261357282]],
    [ "Mississippi Power",[-89.14475186661728, 31.6664749774331]],
    [ "Mississippi Power",[-89.11825132639113, 31.707327767522198]],
    [ "198952431",[-86.59567077479623, 33.67906984359391]],
    [ "Luzon Substation",[-83.6538543344747, 41.98361702719972]],
    [ "Radka Substation",[-83.65642820000001, 41.9834362]],
    [ "Kentucky Substation",[-83.66595512591313, 42.08406245459485]],
    [ "Enrico Fermi 120kV Substation",[-83.257638006375, 41.95907752293992]],
    [ "Maui Electric Company",[-156.45277738264195, 20.884758039069034]],
    [ "Tulare Substation",[-119.33037296994307, 36.2133683115882]],
    [ "Champangne Substation",[-91.96998976379278, 30.540808312908975]],
    [ "199091545",[-92.04422216666545, 30.496342717659655]],
    [ "Laurel Industrial Substation",[-89.17825281898757, 31.660433999795085]],
    [ "Ellisville Highway 590 Substation",[-89.21594024839547, 31.59466391636896]],
    [ "41st & California Substation",[-95.652282458839, 38.9936325270608]],
    [ "Mississippi Power",[-89.12563439038915, 31.68245802432016]],
    [ "Masonite Corporation",[-89.12997174725936, 31.679741066293513]],
    [ "Wolverine Substation",[-83.67056311686461, 42.26962628196822]],
    [ "Willow Run Substation",[-83.55424569821042, 42.23860014353939]],
    [ "Douglass Substation",[-83.44970978118387, 42.23855444298648]],
    [ "Cody Substation",[-83.62922758531779, 42.44804147934413]],
    [ "Lark Substation",[-83.82396891777911, 42.31100045255079]],
    [ "Spruce Substation",[-83.82323442570474, 42.28384038556841]],
    [ "Sidney Substation",[-83.52328408109088, 42.365194795165166]],
    [ "Baltic Substation",[-83.5419457158279, 42.3605293228177]],
    [ "Duvall Substation",[-83.51377100111289, 42.40772546031478]],
    [ "Ranger Substation",[-83.20172351350726, 42.28699134771916]],
    [ "Romulus Substation",[-83.41099029085187, 42.207614977871486]],
    [ "Allison Substation",[-83.4062364499086, 42.258256599440685]],
    [ "Hines Substation",[-83.40794534433643, 42.375679293990345]],
    [ "Colorado Springs Utilities",[-104.72852855417837, 38.91125836511226]],
    [ "Rison Substation",[-92.19724423054572, 33.96862182037249]],
    [ "199382535",[-86.96555207454982, 33.33303200655373]],
    [ "Sylvan Substation",[-84.02985179122432, 42.31225623370025]],
    [ "Hood Substation",[-83.30495229960826, 42.61756978748746]],
    [ "Halsted Substation",[-83.40942569606185, 42.56523611649638]],
    [ "Hancock Substation",[-83.44227095926834, 42.54968848770886]],
    [ "Cheesman Substation",[-84.67127940723448, 43.396809684241326]],
    [ "Regal Substation",[-84.64592698702282, 43.41442706896927]],
    [ "Alma Substation",[-84.66865277335202, 43.374811768834746]],
    [ "Entergy Arkansas",[-91.31742723088382, 33.985711605034034]],
    [ "Entergy Arkansas",[-92.79153755, 35.128781950000004]],
    [ "Ozark Substation",[-93.81754181016618, 35.469327845275764]],
    [ "Dardanelle Substation",[-93.1727198660658, 35.24652400727492]],
    [ "West Sacramento Substation",[-121.54494225273895, 38.589480319039794]],
    [ "199477629",[-124.11236035482816, 40.78249532388037]],
    [ "Oakridge",[-122.48465713079953, 43.75101062940735]],
    [ "Harvey Lynn Substation",[-117.48665910522125, 33.914720454667275]],
    [ "199586195",[-96.66462459698721, 40.709129805233275]],
    [ "Templeton Substation",[-104.77910307830038, 38.88882443281669]],
    [ "Candlewood Substation",[-104.76070883026897, 38.884529819281475]],
    [ "Lookout Point",[-122.75769078591075, 43.91549214911019]],
    [ "Hoyt HTI Switching Station",[-95.69745125, 39.2820245]],
    [ "Circleville Substation",[-95.79028505309783, 39.491721916990066]],
    [ "Hawaiian Electric Company",[-155.47104391276895, 20.095546978404283]],
    [ "27th & Croco Substation",[-95.61463484417186, 39.01927562201791]],
    [ "Marley Substation",[-112.09983532860204, 33.294074307413474]],
    [ "2nd & Madison Substation",[-95.66603311579448, 39.05650350914673]],
    [ "Devilliers Substation",[-87.22317590106839, 30.418858071137482]],
    [ "North Mildred Substation",[-122.5260128, 47.25616085]],
    [ "South Gage Substation",[-95.73094595799823, 38.99342672518782]],
    [ "Smith Center Substation",[-98.7804959855515, 39.77024820310273]],
    [ "West Substation",[-81.99960401548823, 28.03186132774834]],
    [ "200061676",[-103.3176239, 34.36607935]],
    [ "Puget Sound Energy",[-122.91625096399547, 46.95238120069742]],
    [ "Puget Sound Energy",[-122.91560943781798, 47.00107743123855]],
    [ "South Eloise Substation TECO",[-81.74406696744876, 27.9872408304194]],
    [ "Southern California Edison",[-117.87954154108718, 33.91009505358653]],
    [ "Monroe County Electric Power Association",[-88.4639378753756, 33.97699735495558]],
    [ "Southwest Substation",[-122.4922718412842, 47.187655058122665]],
    [ "200243195",[-103.33650002405699, 34.188816762041455]],
    [ "Fort Gage Station",[-73.71121302712528, 43.40855530665743]],
    [ "200371852",[-83.02166555, 29.1803361]],
    [ "Helberg Substation",[-93.84666779855046, 35.49652141022537]],
    [ "Puddin Ridge Substation",[-93.8673434371049, 35.506136922059184]],
    [ "Branch Substation",[-93.91109128735157, 35.30688124722187]],
    [ "Short Mountain Substation",[-93.73660919791429, 35.28858504040892]],
    [ "Razorback Substation",[-93.56131705, 35.33531825]],
    [ "Igo Substation",[-93.57496875000001, 35.430272]],
    [ "Subiaco Substation",[-93.64676047672766, 35.308418185504785]],
    [ "Arkansas Valley Electric Cooperative",[-93.96995145939512, 35.34645527543959]],
    [ "Alexander Substation",[-80.2861230840391, 26.910824304734636]],
    [ "Florida Power & Light",[-80.09623831933294, 26.670195861138197]],
    [ "Gilbert Substation",[-75.44623821748833, 40.91495608674585]],
    [ "Little Gap Substation",[-75.5192491, 40.81614125000001]],
    [ "Elbow Lake Municipal Power",[-95.957002368267, 45.988801474911185]],
    [ "Olympic Substation",[-122.98446089440571, 44.05990505875874]],
    [ "200676698",[-75.35968221785333, 40.5993116150953]],
    [ "Elbow Lake Municipal Power",[-95.98250100000001, 45.99008094999999]],
    [ "Colorado Springs Utilities",[-104.85562170828663, 38.91126734217167]],
    [ "Tacoma Power",[-122.4569153796505, 47.25110635278966]],
    [ "Tacoma Power",[-122.49947308402712, 47.289281374975104]],
    [ "200700627",[-93.84460163425624, 35.39783571778589]],
    [ "Grant County Substation",[-96.01878147491793, 45.9625913923825]],
    [ "SW College Substation",[-95.7614392964655, 44.45758253582402]],
    [ "Elbow Lake 115kV Substation",[-95.94380894999999, 45.962596950000005]],
    [ "200859573",[-93.71672374643366, 35.134409084560346]],
    [ "Southwestern Electric Power Company",[-93.80121903384939, 35.216176952238214]],
    [ "Danville Substation",[-93.39783726711163, 35.06802420022777]],
    [ "Co-op Substation",[-101.82821034103468, 33.56719037389507]],
    [ "Tacoma Power",[-122.50424548469041, 47.25474180460149]],
    [ "West Substation",[-95.12905575324251, 44.54203290690091]],
    [ "201042139",[-89.58945574199505, 41.27064854316148]],
    [ "Murphy Substation",[-101.96534555000001, 33.533881]],
    [ "201054169",[-87.44757057506396, 30.410521594199558]],
    [ "201055183",[-102.53313002130282, 32.964461366471994]],
    [ "Florida Avenue Substation",[-87.5777986323289, 30.29119701502484]],
    [ "201060931",[-102.42997613971313, 33.046735275153516]],
    [ "Arno Sub",[-106.64233960772974, 35.087354054021674]],
    [ "PPL",[-75.60248020688115, 40.52023705604404]],
    [ "201132229",[-75.57775640000001, 40.51864975000001]],
    [ "201132231",[-75.60390695000001, 40.5547708]],
    [ "PPL",[-75.53952881591862, 40.51193377863429]],
    [ "East Texas Substation",[-75.56614490000001, 40.546133499999996]],
    [ "Riverside Station",[-86.43578903565498, 42.142992683705735]],
    [ "Little Spadra Creek Substation",[-93.51096263310765, 35.477603070360416]],
    [ "Southwestern Power Administration",[-93.44668429225457, 35.521722374813834]],
    [ "Treichlers Substation",[-75.54462407142213, 40.729794087050884]],
    [ "201351960",[-73.9558127486733, 41.710478099779166]],
    [ "Ransom Substation",[-85.79164500865713, 42.847238269950424]],
    [ "Whispering Pines Substation",[-80.33037015, 25.584190999999997]],
    [ "Washington Avenue Substation",[-86.11726723594145, 42.754871829270726]],
    [ "Entergy Arkansas",[-92.73601481801235, 35.97274841740245]],
    [ "201518364",[-96.9634521500869, 37.23657270889254]],
    [ "201518370",[-97.00440309161222, 37.23465223672591]],
    [ "201718730",[-96.97085286009354, 37.259787024900945]],
    [ "Winterwood Substation",[-115.0485327666423, 36.14356801473523]],
    [ "Crackersport Substation",[-75.5655485601104, 40.60474146705028]],
    [ "201855066",[-93.35830547646759, 44.754827461310164]],
    [ "201855067",[-93.32556170356638, 44.7786157936609]],
    [ "Akron Substation",[-96.88459867375798, 37.360374958871226]],
    [ "201933962",[-87.89634732453491, 42.47785181172872]],
    [ "Huebner",[-87.74816745000001, 43.71113625000001]],
    [ "North Gate Riverside",[-87.73368787173322, 43.75728713767161]],
    [ "Cross Country",[-89.53221850565473, 43.01550678352607]],
    [ "Reiner Rd",[-89.26426318912876, 43.14092473019645]],
    [ "201982523",[-89.28192359633496, 43.05099957694584]],
    [ "201982526",[-89.28105757516751, 43.05069649170522]],
    [ "201982531",[-89.33968418658138, 43.1957639249807]],
    [ "West Middleton",[-89.56943829107253, 43.09387843113328]],
    [ "201982550",[-89.36492024872157, 43.220718710773816]],
    [ "201982552",[-89.30766232771643, 43.15466250414176]],
    [ "201982557",[-89.34070797405757, 43.19640363074246]],
    [ "201982558",[-89.23234445263405, 42.98431866256096]],
    [ "Clarksville Connected Utilities",[-93.52063668235417, 35.46935431544791]],
    [ "201994252",[-93.77946788982497, 35.451138624489765]],
    [ "201998564",[-89.03199282580019, 43.15983959238593]],
    [ "201998566",[-88.96987405, 43.16532814999999]],
    [ "201998567",[-89.03114356130627, 43.15879867980383]],
    [ "201998568",[-88.94748349013192, 43.00730081261336]],
    [ "201998569",[-88.89355880506152, 43.085409481929084]],
    [ "COONEY",[-88.50254771893206, 43.101104386715676]],
    [ "202054534",[-88.4164889678776, 43.33603710807306]],
    [ "202054538",[-88.46046254871288, 43.32003313516149]],
    [ "202129694",[-87.99285619273373, 43.195383387823924]],
    [ "202129712",[-87.98350510860071, 43.27499572969214]],
    [ "202129714",[-87.99300192542962, 43.2603729664106]],
    [ "202150186",[-87.45950832621216, 41.5273272415892]],
    [ "ComEd Chicago Heights Substation",[-87.60576230748349, 41.52352440369214]],
    [ "202167481",[-106.65598685, 35.0890719]],
    [ "Wheless Lane Substation",[-97.68501918207757, 30.31304984681741]],
    [ "Flomaton Substation",[-87.28823752928976, 31.011168654149994]],
    [ "Pine Barren Substation",[-87.33129011630041, 30.794828355972523]],
    [ "Century Substation",[-87.25689425826243, 30.987370199625396]],
    [ "202289395",[-85.69251877806037, 32.42901937282034]],
    [ "202346296",[-93.88747559766139, 44.757906165613555]],
    [ "202359794",[-85.69503416752666, 32.45980487224739]],
    [ "202359795",[-85.67369995981456, 32.51082044692919]],
    [ "202501861",[-91.45243088184176, 44.85966186488327]],
    [ "202501866",[-91.45780441918241, 44.86814110640724]],
    [ "Imperial Substation",[-81.8055180330615, 26.37783239242404]],
    [ "Lebanon Substation",[-122.91068849055432, 44.534151458806775]],
    [ "202565197",[-89.7594309407814, 31.880518632916164]],
    [ "202593883",[-78.5345542103379, 35.959965674942076]],
    [ "202593886",[-78.53651330421661, 35.964095434579605]],
    [ "Munson Substation",[-87.01344599866515, 30.654675627116553]],
    [ "Florida Power & Light",[-86.96831865161894, 30.637023480777447]],
    [ "Jay Road Substation",[-87.04390752392827, 30.64049490345469]],
    [ "202624078",[-97.0240375263292, 37.20100227251675]],
    [ "23rd Street Substation",[-112.03220372039507, 33.45263717526381]],
    [ "South Holland Substation",[-86.05729139305355, 42.733673683547956]],
    [ "Liberty Substation",[-84.92823353107211, 39.638900190280864]],
    [ "Vinton Substation",[-92.08596532526427, 42.15146578233734]],
    [ "Mossy Head Substation",[-86.3126143, 30.74432935]],
    [ "Alaquoa Substation",[-86.14330281572101, 30.686944462528636]],
    [ "Freeport Switching Station",[-86.13093211232217, 30.53158321374564]],
    [ "202909049",[-91.50908879902151, 44.82951011655192]],
    [ "Colorado Springs Utilities",[-104.83110537278537, 38.86526553262336]],
    [ "202965491",[-91.52229142019324, 35.724366260657455]],
    [ "Batesville Substation",[-91.64430251718306, 35.77995600224945]],
    [ "Cedar Grove Substation",[-91.72856979999999, 35.57825015]],
    [ "Entergy Arkansas",[-91.6488356, 35.69903935]],
    [ "Cave City Substation",[-91.57780761277306, 35.94285707506906]],
    [ "202965514",[-91.80062205807917, 35.98951511732488]],
    [ "Southwestern Power Administration",[-92.24003725458985, 36.249266645920244]],
    [ "202965519",[-92.24117443198985, 36.24870834803949]],
    [ "Cushman Substation",[-91.73147106303585, 35.891848361834285]],
    [ "Oakman Substation",[-87.41607631003832, 33.73983272437309]],
    [ "Snapper Creek Substation",[-80.28536545120635, 25.671142847851726]],
    [ "203064650",[-84.94770273898648, 39.50517862474963]],
    [ "Jackson Road Substation",[-83.79902985000001, 42.28666594999999]],
    [ "203157801",[-91.44738951068781, 44.80752412469882]],
    [ "203162422",[-93.2943983984469, 44.64908012653357]],
    [ "Vermillion River Substation",[-93.1657230940227, 44.645644202905714]],
    [ "Lake Marion Substation",[-93.29602132491569, 44.59861359653068]],
    [ "Airlake Substation",[-93.22855600207689, 44.6456385547442]],
    [ "Lakeville Substation",[-93.17968588961224, 44.71685727639891]],
    [ "203170517",[-93.4408615, 44.58688595]],
    [ "203170518",[-93.33782602511097, 44.591738892628335]],
    [ "203173190",[-91.37310203407449, 44.80119396016463]],
    [ "203184023",[-84.79645688559634, 39.30483963159218]],
    [ "203188327",[-91.12235589404436, 44.67457068317451]],
    [ "203188329",[-91.1866188149987, 44.71974342458169]],
    [ "203193549",[-91.02410773150817, 44.64793167295077]],
    [ "203195609",[-90.96406360000002, 44.510336650000006]],
    [ "203207278",[-97.0224325800566, 37.085178907738474]],
    [ "203214461",[-97.04554510691321, 37.061864239651804]],
    [ "203256532",[-86.25583808698798, 36.55315763425821]],
    [ "Buck Creek Substation",[-85.66585537286316, 42.85035188365466]],
    [ "Medical Park Substation",[-85.71288777484146, 42.855539606887476]],
    [ "Jamestown Substation",[-85.85499974514246, 42.84670976902521]],
    [ "Ottawa Avenue Substation",[-86.12774239999999, 42.7741464]],
    [ "48th Street Substation",[-86.08518486773264, 42.75537945805446]],
    [ "Macatawa Substation",[-86.12103716703655, 42.80007084944246]],
    [ "Trillium Substation",[-84.4419374, 42.5621063]],
    [ "Arlington Substation",[-122.27295268064273, 37.88892740828273]],
    [ "203367150",[-89.06352834775174, 33.347891852421995]],
    [ "203375340",[-112.5095351911718, 36.9654338990865]],
    [ "203375341",[-112.51024361027407, 36.965288075437776]],
    [ "203377758",[-96.80147968253189, 31.00826887721089]],
    [ "Starkville Switching Station",[-88.80275964715632, 33.505196486303866]],
    [ "203540361",[-97.04442092511059, 37.107415305389786]],
    [ "Holly Substation",[-97.39734895377897, 27.708438141787035]],
    [ "Airline Substation",[-97.3733969862589, 27.695790912118945]],
    [ "Haines Creek Substation",[-81.80010646332015, 28.85776601755807]],
    [ "203868057",[-83.19536915216551, 42.51327149956951]],
    [ "Ash Creek Substation",[-73.23419739187247, 41.15641812714609]],
    [ "Rodd Field Substation",[-97.3824731086065, 27.659188231133292]],
    [ "Wooldridge Substation",[-97.35242305, 27.68176010000001]],
    [ "Old Town Substation",[-73.2167306481146, 41.22444508971571]],
    [ "Cabaniss Substation",[-97.43773144999999, 27.720418949999996]],
    [ "Indianola Substation",[-112.07690040032817, 33.492121807149715]],
    [ "Dickson Substation",[-87.40700068819241, 36.09407341751336]],
    [ "McEwen Substation",[-87.63709809430188, 36.107097747304444]],
    [ "Kingston Springs Substation",[-87.07892110715075, 36.109035343917235]],
    [ "White Bluff Substation",[-87.20553729210351, 36.10726543439706]],
    [ "Randall Street Substation JEA",[-81.70746420000002, 30.310876150000002]],
    [ "Cunningham Substation",[-87.38232513709112, 36.38569970641842]],
    [ "East Bowling Green Substation",[-86.36224249126579, 37.015206727928245]],
    [ "Tennessee Valley Authority",[-86.92007864219876, 36.96323235205684]],
    [ "Tennessee Valley Authority",[-86.68132732288835, 37.26432615942553]],
    [ "204268611",[-85.85729183229195, 36.89723335148813]],
    [ "Sacramento Municipal Utility District",[-121.41964497271576, 38.47020446706565]],
    [ "First Electric Cooperative Corporation",[-91.8142473877871, 35.18166042462434]],
    [ "Oak Hall Substation",[-75.57046398487412, 37.94330885993874]],
    [ "Emporia Substation",[-77.55963966727656, 36.69586839917503]],
    [ "Colorado Springs Utilities",[-104.8745847042612, 38.94652541113009]],
    [ "204493886",[-90.82204764999999, 44.385877550000004]],
    [ "Field Street Substation",[-70.99202782589977, 42.25442571350072]],
    [ "Canon City Substation 115",[-105.2516091273043, 38.4347725102223]],
    [ "Dunmor Substation",[-86.99222058709225, 37.08029700822589]],
    [ "204521168",[-87.08634355, 37.0542937]],
    [ "204521171",[-86.68991622119698, 37.219334102849935]],
    [ "Casky Substation",[-87.41851042677428, 36.84288398101644]],
    [ "204544360",[-87.88024650846413, 37.041894716386544]],
    [ "204544362",[-87.42535076591562, 36.84207368502033]],
    [ "Searcy Prince Substation",[-91.68719798293886, 35.23972512492003]],
    [ "Searcy South Substation",[-91.743140113444, 35.24294792475877]],
    [ "Entergy Arkansas",[-91.7847694, 35.151842300000006]],
    [ "204622348",[-90.81171585000001, 44.306919300000004]],
    [ "204622349",[-90.81924491396748, 44.305250080595485]],
    [ "Walker Substation",[-84.85397578982108, 39.091835894386016]],
    [ "Ridge Avenue Substation",[-84.86273658639954, 39.100823081670626]],
    [ "Dresden Substation",[-88.71163899461104, 36.251899559555866]],
    [ "Gleason Substation",[-88.62865234010486, 36.18965772780915]],
    [ "Huntingdon District Substation",[-88.43718549414662, 36.017719379051954]],
    [ "Huntingdon Substation",[-88.37880326150905, 36.02057540785357]],
    [ "McKenzie Substation",[-88.54017448518299, 36.13895804134822]],
    [ "Carroll County Electric Department",[-88.47068666370367, 36.08235453007239]],
    [ "Cumberland Substation",[-87.65808607723102, 36.38991101165323]],
    [ "Erin Substation",[-87.67333999125802, 36.32604337861756]],
    [ "Riley Substation",[-70.24814005264874, 44.50752936599946]],
    [ "Rumford Industrial Park Substation",[-70.52299822769365, 44.53165328181449]],
    [ "Woodstock Substation",[-70.62934375211839, 44.389433675373006]],
    [ "Hallandale Substation",[-80.15970023588022, 25.974500843451413]],
    [ "Bastrop Substation",[-91.91139206240098, 32.77062219269999]],
    [ "Randolph Sub",[-106.62471320338311, 35.053286162692196]],
    [ "Ojus Substation",[-80.14221423880552, 25.946343898834964]],
    [ "Tennessee Valley Authority",[-88.11594290037162, 36.05460452862514]],
    [ "Florence Substation",[-87.62399596002818, 34.82744203253441]],
    [ "SRP Rittenhouse Substation",[-111.63844430559917, 33.24918818905424]],
    [ "204795440",[-111.66866271649101, 33.27108723532217]],
    [ "Entergy Louisiana",[-92.16190248319623, 32.48665514204398]],
    [ "Lamkin Substation",[-92.07870439999999, 32.58382339999999]],
    [ "West Monroe Substation",[-92.14722457467856, 32.5168285920948]],
    [ "Entergy Louisiana",[-92.12857907330097, 32.528474758833966]],
    [ "RS-28",[-111.88512440675773, 33.24656295067116]],
    [ "Ashburnham Substation",[-71.92678340894884, 42.61679409468183]],
    [ "East Winchendon Substation",[-72.02156184357881, 42.67268347881226]],
    [ "Lunenburg Substation",[-71.72730674334807, 42.59278199495251]],
    [ "Pleasant Street Substation",[-71.77036038523633, 42.5829859839693]],
    [ "Townsend Substation",[-71.6967183278584, 42.66092412612408]],
    [ "West Townsend Substation",[-71.75925150467965, 42.67496387302655]],
    [ "204857193",[-87.9830502215366, 31.16032654072103]],
    [ "Dixie Electric Power Association",[-89.09999953996099, 31.765469457618213]],
    [ "Dixie Electric Power Association",[-89.16762516439495, 31.763958023974986]],
    [ "Friendship",[-89.81674761573179, 43.97474504712135]],
    [ "ACEC Friendship",[-89.79729634261854, 43.97430412516607]],
    [ "Arch Creek Substation",[-80.17010688558558, 25.892785531182202]],
    [ "MCKENNA",[-89.79774752504521, 43.91293730552005]],
    [ "Electric Substation-Citrus Springs Number 3",[-82.48468530000001, 29.00860945]],
    [ "205013590",[-90.57044489251572, 44.94388302507421]],
    [ "205090828",[-86.11317838794707, 39.88040966063101]],
    [ "205090835",[-86.13741735298477, 39.918678540714446]],
    [ "Magnolia Anderson Substation",[-96.00203494999998, 30.436084999999995]],
    [ "Bentwater Substation",[-95.64675336540115, 30.426500067731123]],
    [ "Deepcreek Substation",[-82.03529979302641, 27.018204324955338]],
    [ "DTE Energy",[-83.55261746320339, 42.234746159222354]],
    [ "Arizona Substation",[-83.55918284999998, 42.22509049999999]],
    [ "Bronson Substation",[-82.65325282930357, 29.460674768832337]],
    [ "Williston Substation",[-82.45018656242561, 29.403062098938907]],
    [ "Carrabelle Substation",[-84.66544549999999, 29.864584049999994]],
    [ "Duke Energy",[-84.3873731169833, 29.944280675003785]],
    [ "205176417",[-85.51888195000001, 30.265427099999997]],
    [ "Wewahitchka Substation",[-85.21002637484783, 30.11012358962505]],
    [ "Gaskin Substation",[-85.46817120687344, 30.24237803076194]],
    [ "Bayou George North Substation",[-85.48556192027357, 30.315152894199816]],
    [ "Old Hickory Substation",[-86.65148208874534, 36.25797657497425]],
    [ "205226934",[-86.66234693688088, 36.278417279564934]],
    [ "205226935",[-86.69699017225075, 36.29348526769206]],
    [ "Finn Street Substation",[-86.75278112468622, 36.1788153120658]],
    [ "Brick Church Substation",[-86.78141274263797, 36.24322238327148]],
    [ "Watkins Park Substation",[-86.802657954194, 36.16090075294594]],
    [ "Sharondale Substation",[-86.81624200574264, 36.12747170303932]],
    [ "Nashville Electric Service",[-86.83649404211415, 36.159343825544425]],
    [ "Metro Center Substation",[-86.80274357413654, 36.18752681901266]],
    [ "Nashville Electric Service",[-86.73633222674385, 36.240622810039014]],
    [ "Galloway Substation",[-86.81197350098067, 36.15721350686107]],
    [ "205255869",[-86.83209283069941, 36.24638894487556]],
    [ "Nashville Electric Service",[-86.84332062730485, 36.19988927639201]],
    [ "Nashville Electric Service",[-86.7102512476777, 36.190181335460586]],
    [ "Madison Substation",[-86.71465837026739, 36.26117075365018]],
    [ "Nashville Electric Service",[-86.73477360088773, 36.21026545121995]],
    [ "Ames Transmission Substation",[-93.56128715857804, 42.084378166083205]],
    [ "Fernald Substation",[-93.44557771426224, 42.08560243372618]],
    [ "Boone Junction Substation",[-93.80963024672769, 42.08614065683635]],
    [ "Gosling Substation",[-95.49125738820828, 30.183663441209507]],
    [ "Barna Substation FPL",[-80.84493030161883, 28.558824805873975]],
    [ "Chemours Substation",[-89.30977187430905, 30.38359676421702]],
    [ "Commission Road Substation",[-89.15404600034981, 30.36801043638298]],
    [ "205421340",[-89.10227377532236, 43.537467903894424]],
    [ "205430237",[-86.19759233909735, 39.7737067460674]],
    [ "M.L. Hibbard S.E. Station",[-92.1537235317492, 46.73576157330342]],
    [ "Hilltop 230/115KV Substation",[-92.19955185231431, 46.75110465489416]],
    [ "Aircadia Substation",[-104.77153975179513, 38.83714676450077]],
    [ "Port Edwards",[-89.8834386836288, 44.340827391970166]],
    [ "Coldwater Substation",[-88.48917339681913, 36.65973568505336]],
    [ "Rutherford Substation",[-88.98826938770422, 36.11574132367782]],
    [ "Trezevant Substation",[-88.6152721037569, 36.002276773299755]],
    [ "Humboldt Substation",[-88.88013403910186, 35.819883851418076]],
    [ "New Tiptonville Substation",[-89.46478783217718, 36.37598172443396]],
    [ "Troy Substation",[-89.1571654531188, 36.33410482097768]],
    [ "Ridgely Substation",[-89.46870799557676, 36.26352540609514]],
    [ "Union City Energy Authority",[-89.06013745, 36.43772140000001]],
    [ "Sigel",[-89.94645161209958, 44.48206748036602]],
    [ "205783710",[-89.96055363919783, 44.48163801279366]],
    [ "Union City Energy Authority",[-89.05348998023614, 36.46659351293612]],
    [ "Ardmore Substation",[-86.8714253239639, 34.947441964411055]],
    [ "Fayetteville Primary Substation",[-86.47596600099901, 35.13154405596286]],
    [ "McBurg Substation",[-86.83354285, 35.1874612]],
    [ "Poplar Creek Substation",[-87.12424640590004, 34.79773493121089]],
    [ "Pulaski District Substation",[-87.03205924023784, 35.18903280050696]],
    [ "Rogersville Substation",[-87.29314430192926, 34.84531799611789]],
    [ "Walter Anderson Substation",[-87.06079935857986, 35.20932138294634]],
    [ "NORTHERN STEEL CASTING",[-89.78041164871955, 44.4020723390566]],
    [ "Smithville Substation",[-85.84573141423002, 35.96598010361158]],
    [ "Watertown Substation",[-86.11712012968931, 36.09889948223275]],
    [ "West Sparta Substation",[-85.48986674219402, 35.93109408526715]],
    [ "Plover",[-89.59794233652272, 44.44667959841293]],
    [ "205978423",[-92.30004830937428, 44.95986477736178]],
    [ "Blanche Substation",[-86.7563119787274, 35.03540173205078]],
    [ "Park City Substation",[-86.5703928281498, 35.06179509472393]],
    [ "Fairmount Substation",[-86.88054211487452, 34.797454960232386]],
    [ "Hemlock Substation",[-83.77965287251828, 42.275339431201274]],
    [ "Plymouth Station",[-84.37635954223055, 42.24786791983319]],
    [ "Copperweld Corporate Substation",[-86.56654364999999, 35.1677691]],
    [ "Fayetteville District Substation",[-86.5896596648708, 35.1516362068934]],
    [ "Lynchburg Substation",[-86.38593730513936, 35.269374081102924]],
    [ "Sumpter Generating Facility Substation",[-83.53218375363322, 42.16740650933374]],
    [ "Wateree Dam Substation",[-80.7023024756054, 34.334636157336504]],
    [ "Milham Substation",[-85.58327488637096, 42.220998902871735]],
    [ "Upjohn Substation",[-85.5526909, 42.211588250000005]],
    [ "Elm Street",[-85.17133522756308, 42.31670357123923]],
    [ "Elm Street Substation",[-85.17200705039672, 42.317552690588656]],
    [ "206015842",[-84.37683883961796, 39.46455968188735]],
    [ "Moore Road Substation",[-84.645493468829, 41.95713466241827]],
    [ "Dowling Substation",[-84.2888045, 41.8548836]],
    [ "Roman Nose",[-98.32994429645231, 35.84196546663465]],
    [ "Romana Substation",[-87.2225871985059, 30.410468364518607]],
    [ "SUSSEX",[-88.20516494813414, 43.13583367935261]],
    [ "Hughes Road Substation",[-84.99511749999999, 42.26193805]],
    [ "Fifteen Mile Road Substation",[-84.9946937, 42.2629961]],
    [ "Holt Substation",[-86.74596232815546, 30.72195004866564]],
    [ "Convis Substation",[-85.02517330000002, 42.33677505]],
    [ "Wright Substation",[-86.65446308385735, 30.44348763289407]],
    [ "Princeton Substation",[-85.13125111244945, 42.314102044737446]],
    [ "Whitney Rd Substation DUKE",[-82.72354333854861, 27.92193965438066]],
    [ "12TH AVE",[-88.56674547484072, 44.007865906348016]],
    [ "Valparaiso Substation",[-86.50986881356735, 30.515134964103638]],
    [ "Bluewater Bay Substation",[-86.41163702459846, 30.473890557286786]],
    [ "206063382",[-86.51413226082708, 30.515378069734]],
    [ "Keith Substation",[-96.10149004151766, 30.649155075356944]],
    [ "Seaholm Substation",[-97.75135892109198, 30.266824482289152]],
    [ "Marshall Ford Upper Switchyard",[-97.90905489999999, 30.389202099999995]],
    [ "Angus Valley Substation",[-97.77756988463635, 30.400563178718148]],
    [ "Riverplace Substation",[-97.842263, 30.398688450000005]],
    [ "North Belt Substation",[-95.36973193995448, 29.940638696075787]],
    [ "206138040",[-89.85824579999999, 44.31582855]],
    [ "Baker St",[-89.78112529851947, 44.36807070189832]],
    [ "Saratoga",[-89.80056813138505, 44.31465861051092]],
    [ "Cowan Substation",[-86.00539890986492, 35.16010862546792]],
    [ "North Tullahoma Substation",[-86.22429685280166, 35.380845981306244]],
    [ "Sewanee Substation",[-85.9179719243004, 35.19708999330223]],
    [ "Summerfield Substation",[-85.78441357650249, 35.248661194435115]],
    [ "206162997",[-86.08049184896541, 35.19189430810653]],
    [ "Duck River Electric Membership Corporation",[-86.12183219103345, 35.28128835267455]],
    [ "Hidden Valley Substation",[-97.90027978975499, 30.384021616295758]],
    [ "Commons Ford Substation",[-97.8547498533044, 30.315278759090496]],
    [ "Paleface Substation",[-98.10881994927661, 30.42676600193536]],
    [ "Lakeway Substation",[-97.97878617642704, 30.358700213312993]],
    [ "Barton Substation",[-97.81947301876899, 30.266117949261783]],
    [ "Salem Walk Substation",[-97.7900278631634, 30.215785598443073]],
    [ "Ocean City Substation",[-86.61695234999999, 30.438611349999995]],
    [ "Turner Substation",[-86.62586272530926, 30.463082341054882]],
    [ "Highview Substation",[-92.51918119999999, 45.111869199999994]],
    [ "East McMinnville Substation",[-85.74423829134936, 35.704992867416955]],
    [ "McMinnville Substation",[-85.80952286182574, 35.69436289962123]],
    [ "206445086",[-106.59126704769201, 35.20186491864515]],
    [ "206466956",[-106.58587618106327, 31.879845851475267]],
    [ "New Brookfield Substation",[-89.87225108936518, 35.10079555577015]],
    [ "Northeast Gate Substation",[-89.89975086546738, 35.19087133324771]],
    [ "Poplar Avenue Substation",[-89.96461856396846, 35.13524083190918]],
    [ "University Substation",[-89.92865710557435, 35.116548046348534]],
    [ "Willett Street Substation",[-90.01183428656348, 35.12515234536014]],
    [ "206505822",[-81.20366528348052, 28.634559142777707]],
    [ "San Mateo Sub",[-106.5860566956355, 35.191251445500804]],
    [ "Clinton Substation",[-95.29967440635679, 29.7609552597837]],
    [ "Public Service Company of Oklahoma",[-95.99530341727912, 36.15475507305767]],
    [ "Morrilton East Substation",[-92.70508267520319, 35.17600374521181]],
    [ "Dardanelle Substation",[-93.16830264999999, 35.2330664]],
    [ "Russellville North Substation",[-93.12320346077608, 35.305553424901944]],
    [ "Moreland Substation",[-93.00053696149004, 35.36309252508048]],
    [ "Entergy Arkansas",[-92.7316499, 35.271507299999996]],
    [ "Atkins Substation",[-92.99987487317283, 35.243354357651945]],
    [ "Alder Creek Substation",[-85.12708998960234, 42.160343004198126]],
    [ "Batavia Substation",[-85.12148737443363, 41.93435674518863]],
    [ "Cement City Substation",[-84.33487274645037, 42.07397074476378]],
    [ "Erickson Substation",[-84.65994540618887, 42.69214023757528]],
    [ "Canal Substation",[-84.67294275, 42.675831900000006]],
    [ "Wise Substation",[-84.5842480434169, 42.677305881783035]],
    [ "Clinton Substation",[-84.9008344366135, 42.65047485484111]],
    [ "206961850",[-113.4890477887846, 32.956323273054515]],
    [ "Hoodoo Wash Switchyard",[-113.48920348671153, 32.95407277211004]],
    [ "206968721",[-95.84854514999999, 40.68157605]],
    [ "Keating Substation",[-86.22312543100313, 43.21562010636051]],
    [ "Muskegon Heights Substation",[-86.2432741239183, 43.21567244019593]],
    [ "Willard Substation",[-83.7858666, 43.24393580000001]],
    [ "Claremont Substation",[-83.9176150586046, 43.39193704421937]],
    [ "207053666",[-95.1079915561645, 43.127424556357575]],
    [ "LADWP Distributing Station No. 144",[-118.23666422171215, 34.039762132332626]],
    [ "207086463",[-109.87611767772574, 31.429474961245784]],
    [ "Avalon Substation",[-87.07391319180877, 30.59989602450501]],
    [ "207125991",[-95.89654949021269, 40.676028906063394]],
    [ "Centerville Substation",[-95.04159717311555, 38.21860682603283]],
    [ "Marmaton Substation",[-95.16111868226677, 37.83394497493787]],
    [ "Patton Lane Substation",[-97.87048554918196, 30.23827271394877]],
    [ "Cedar Valley Substation",[-97.95250213721812, 30.227011777164975]],
    [ "Mill Branch Substation",[-90.00675979625517, 35.03266021354125]],
    [ "Pontotoc Substation",[-89.01691570330192, 34.254584393030115]],
    [ "Chipola Substation",[-85.2024202039292, 30.776967324884755]],
    [ "207429641",[-87.3406827, 44.83581035000001]],
    [ "Fraser Substation",[-105.84755957443453, 39.95862430167949]],
    [ "207452130",[-86.6181404, 36.19611505]],
    [ "207452131",[-86.68473661123248, 36.15309547145555]],
    [ "Nashville Electric Service",[-86.69521965592146, 36.22667947795391]],
    [ "Donelson Substation",[-86.64983596871146, 36.16464070583453]],
    [ "Crown Substation",[-83.66649136112447, 42.21592924549176]],
    [ "Visteon Substation",[-83.42807338401697, 42.246483256497754]],
    [ "Filmore Substation",[-83.20707682708955, 42.27031084431688]],
    [ "DTE Energy",[-83.11453769999999, 42.2836404]],
    [ "Maxwell Substation",[-83.1342010560234, 42.29151462420583]],
    [ "Waterman Substation",[-83.10260541488125, 42.29619486026236]],
    [ "Great Lakes Substation",[-83.12982252502964, 42.26322882372813]],
    [ "Nashville Electric Service",[-86.66513877590748, 36.19059103899615]],
    [ "Guinotte Transition Substation",[-94.55746835486742, 39.11779279961771]],
    [ "Chouteau Substation",[-94.52690399354648, 39.13424840706041]],
    [ "Wyoming Substation",[-92.98588450427316, 45.31182269957286]],
    [ "Spencer Substation",[-85.45212344802857, 35.733118839956376]],
    [ "Whitwell Substation",[-85.47367848680184, 35.18657092830489]],
    [ "Brush Creek Capacitor",[-85.38475208056562, 35.41249564986021]],
    [ "Dunn Rd",[-87.34726220594801, 44.89236594976451]],
    [ "207630737",[-115.14806650800456, 36.1684236010411]],
    [ "Grand Haven Substation",[-86.23380352487095, 43.07103120839843]],
    [ "207635868",[-84.2590562229883, 30.589746097554567]],
    [ "Tyler Substation",[-86.12299226141386, 42.91716072620634]],
    [ "Four Mile Substation",[-85.70779792670703, 43.02856328635896]],
    [ "White Road Substation",[-86.04048704058087, 43.263230556126175]],
    [ "Pingree Substation",[-85.90222665025144, 42.98339544457916]],
    [ "Belfast Substation",[-86.68638061950261, 35.37948092473667]],
    [ "Cornersville Substation",[-86.84167431860719, 35.347418765044615]],
    [ "Elysian Fields Substation",[-86.74632275913672, 36.097067899211225]],
    [ "Peabody Substation",[-86.77729571099475, 36.15527027777707]],
    [ "High Bridge",[-90.70531692549835, 46.38520924314662]],
    [ "Williamsport Substation",[-87.20927612617211, 35.69482161569888]],
    [ "207716756",[-87.07343663772362, 35.63167132664832]],
    [ "East Shelbyville Substation",[-86.42722659728443, 35.49612710037703]],
    [ "Henpeck Substation",[-86.86732196276257, 35.87109266481341]],
    [ "Unionville Substation",[-86.58639250722842, 35.621433808259326]],
    [ "207739721",[-86.98897355268714, 35.72365323575832]],
    [ "207790409",[-92.1165898747719, 46.77224852020772]],
    [ "207797150",[-87.47451949999999, 41.6597807]],
    [ "207804018",[-88.67699045, 41.245864450000006]],
    [ "AEP West Side Substation",[-86.28882328279266, 41.67771848001398]],
    [ "Van Buren Substation",[-86.7867679378288, 36.18088276333925]],
    [ "Nashville Electric Service",[-86.84925964532623, 36.12756541846282]],
    [ "Green Hills Substation",[-86.81834032712933, 36.104482690407046]],
    [ "Nashville Electric Service",[-86.83716723138254, 36.08591762589089]],
    [ "Forest Hills Substation",[-86.85931237853053, 36.04822393803639]],
    [ "Nashville Electric Service",[-86.90969558452299, 36.118708612971794]],
    [ "Cleveland Public Power",[-81.62604942924864, 41.48058973565483]],
    [ "207913793",[-112.75933302348, 32.94038626678585]],
    [ "Nashville Electric Service",[-86.92587328803432, 36.07244959066605]],
    [ "Lakeview Substation",[-86.53679036550277, 36.25940960591851]],
    [ "Middle Tennessee Electric",[-86.38586205000001, 36.280647099999996]],
    [ "Middle Tennessee Electric",[-86.43844149908983, 36.1840315994289]],
    [ "Bridgestone Americas Tire Operations, LLC",[-86.60115535, 36.008950000000006]],
    [ "Nashville Electric Service",[-86.69034384344184, 36.09655081208708]],
    [ "207995610",[-95.90543460001986, 40.59592539956916]],
    [ "207995613",[-95.9055923814103, 40.47995752396369]],
    [ "Orange & Rockland",[-74.25975930913111, 41.30919756983367]],
    [ "Elm Hill Substation",[-86.71095288310293, 36.14868309866133]],
    [ "Edgehill Substation",[-86.79011739999999, 36.140984749999994]],
    [ "Nashville Electric Service",[-86.69619274747657, 36.121334160093646]],
    [ "Nashville Electric Service",[-86.71034845510658, 36.12475943841999]],
    [ "TVA",[-87.0637954382336, 35.597821815273974]],
    [ "Hickory Star Substation",[-83.84559314123712, 36.22767364576554]],
    [ "Westland Substation",[-84.05151985081113, 35.900107354205964]],
    [ "Omaha Public Power District",[-96.06047105362788, 41.21934074962631]],
    [ "Central Substation",[-86.77905561049155, 36.16896894670514]],
    [ "208090079",[-86.40140153416642, 35.87903301964288]],
    [ "Port Huron Substation",[-82.46143120183592, 42.97553069613523]],
    [ "208116910",[-95.92373506857778, 35.96969351832274]],
    [ "Public Service Company of Oklahoma",[-95.89477598200334, 36.003340916410934]],
    [ "Lee Substation",[-82.58997207069356, 43.16480357718715]],
    [ "208124156",[-83.0097802563079, 43.06629769972117]],
    [ "City of Salem",[-80.02986543449295, 37.2894103691087]],
    [ "Mason Creek Substation",[-80.02717707030455, 37.293887050380434]],
    [ "208126403",[-82.66444444999999, 43.85326764999999]],
    [ "Harbor Beach Substation",[-82.64556286508316, 43.85177357942295]],
    [ "208126409",[-82.6561700337809, 43.85263557805498]],
    [ "Wyatt Substation",[-82.94327849787103, 43.81555412498053]],
    [ "MIcor Substation",[-84.37477300797913, 42.23151455732612]],
    [ "Public Service Company of Oklahoma",[-95.97657231480942, 35.9960318398095]],
    [ "Summit Substation",[-84.40168613121995, 42.22321081484302]],
    [ "Ferguson Substation",[-84.43543464965565, 42.203229233351884]],
    [ "208149503",[-96.38828861738084, 36.07530347359234]],
    [ "Reynolds Substation",[-84.48839795909727, 42.16593967502069]],
    [ "Spring Arbor Substation",[-84.5357010246421, 42.20984194237112]],
    [ "Silver City",[-96.49667069308342, 36.07631627524307]],
    [ "208150177",[-96.4954721998143, 36.07652176567579]],
    [ "208150178",[-96.49807233753776, 36.077400675146336]],
    [ "Boone Substation",[-81.65796302427262, 36.23514926386206]],
    [ "Nashville Electric Service",[-86.70543500000001, 36.28894089999999]],
    [ "208290752",[-86.7129383543375, 36.33324805664182]],
    [ "Carlex Glass America, LLC",[-86.87154530000001, 36.181893099999996]],
    [ "Nashville Electric Service",[-86.72880651936725, 36.21936655453711]],
    [ "Nashville Electric Service",[-86.6552796, 36.2981658]],
    [ "Cumberland Electric Membership Corporation",[-86.70317370552549, 36.381574665865074]],
    [ "208456838",[-86.65957334999999, 36.270844950000004]],
    [ "208456839",[-86.65401151345534, 36.327012978702975]],
    [ "Springfield Electric",[-86.89031299299343, 36.48741083851736]],
    [ "Saundersville Substation",[-86.56233302289972, 36.33531885673387]],
    [ "208468652",[-86.49172957937752, 35.92821859172635]],
    [ "Nashville Electric Service",[-86.47729551912641, 36.2303384851161]],
    [ "MidAmerican Energy",[-91.48384492630686, 41.63692417329989]],
    [ "Northeast Simsbury Substation",[-72.79267230369163, 41.908710317488854]],
    [ "Simpson Substation",[-85.4480892274444, 41.99127586172431]],
    [ "Nashville Electric Service",[-86.82224857163854, 36.0405045367359]],
    [ "208608294",[-86.71924324059209, 36.109637623183964]],
    [ "208608298",[-86.70871575159072, 36.12580624308432]],
    [ "Nashville Electric Service",[-86.79394225463001, 36.12172606025411]],
    [ "Springfield Electric",[-86.85733188127233, 36.49035134332555]],
    [ "10th Avenue Substation",[-86.78626349999999, 36.161395049999996]],
    [ "Cottonwood Substation",[-104.78280407669148, 38.94150243894748]],
    [ "Kirby Substation",[-95.42291565465375, 29.72974737344828]],
    [ "Spokane Substation",[-83.12092021120104, 42.66147582485321]],
    [ "Washington Substation",[-83.04374995442825, 42.724099790125166]],
    [ "Hamlin Substation",[-83.20482232364863, 42.63917634541818]],
    [ "Walton Substation",[-83.29480724581303, 42.678100168578595]],
    [ "DTE Energy",[-83.29132836582905, 42.70074233700964]],
    [ "Giddings Substation",[-83.26609644167942, 42.703701850248635]],
    [ "Stratford Substation",[-83.30046777119927, 42.84113012082835]],
    [ "Hemphill Substation",[-83.66524228563195, 42.9809670622128]],
    [ "Halsey Substation",[-83.6530197974488, 42.857718892353454]],
    [ "Blinton Substation",[-83.65090594793129, 42.88507650021107]],
    [ "Garfield Substation",[-83.6787427013826, 43.038522764436706]],
    [ "Delaney Substation",[-83.62937450518287, 43.026774527280104]],
    [ "Manning Substation",[-83.78454911339168, 43.45659842606011]],
    [ "Dort Substation",[-83.67933693556009, 43.1078250722268]],
    [ "Intermountain Rural Electric Associaton/CORE",[-105.67261790605671, 39.45965369570041]],
    [ "Nashville Electric Service",[-86.77473137440892, 36.16877325813568]],
    [ "Nashville Electric Service",[-86.76301954999998, 36.226835900000005]],
    [ "Nashville Electric Service",[-86.78092658662321, 36.233025131356534]],
    [ "Nashville Electric Service",[-86.73378494964521, 36.191974420429844]],
    [ "208774125",[-95.18488018701575, 35.627522730689954]],
    [ "208774126",[-95.13835744801477, 35.55266699385789]],
    [ "208834831",[-95.92335266322193, 40.36422442504579]],
    [ "Falls Church Substation",[-77.15775630507149, 38.88568884450861]],
    [ "208924763",[-95.73845094757641, 40.46569592567787]],
    [ "208926109",[-95.9249569328434, 40.48056987177911]],
    [ "208944208",[-96.18119304999999, 40.653185699999995]],
    [ "208944228",[-96.19625483276252, 40.660436675008626]],
    [ "208964332",[-86.61880120281724, 36.15669983367917]],
    [ "Clinton Primary Substation",[-88.97998697513096, 36.634195430345315]],
    [ "Moscow Substation",[-89.04722962425181, 36.62242529481962]],
    [ "208976818",[-88.85776623760867, 36.503335500885214]],
    [ "Bergstrom Substation",[-97.67253903075988, 30.219032689964013]],
    [ "Poasttown Substation",[-84.3814811, 39.5649868]],
    [ "209130773",[-95.17367262509049, 35.50729250442532]],
    [ "Southern California Edison",[-118.14824926825382, 33.911885085100906]],
    [ "Congress Substation",[-87.69090099013677, 41.87439835296797]],
    [ "Humboldt Park Substation",[-87.68733996726921, 41.900864646504935]],
    [ "Duke Energy",[-82.75188835194261, 27.874790001128687]],
    [ "209548366",[-91.44897939999998, 46.61827995000001]],
    [ "209548367",[-91.44898806827464, 46.618783614622004]],
    [ "209716123",[-85.63136085485382, 41.93371863655078]],
    [ "ComEd Diversey Substation",[-87.67591389958518, 41.930763564577106]],
    [ "Universal Substation",[-79.80092789446375, 40.44686992894033]],
    [ "Evergreen Substation",[-79.78071691495298, 40.44479005504429]],
    [ "Entergy Arkansas",[-92.5173697, 35.11034275]],
    [ "209962002",[-92.4534445505336, 35.05251658006434]],
    [ "Greenbrier Substation",[-92.38860335, 35.24266005]],
    [ "209962004",[-92.41308715607754, 35.07158707507734]],
    [ "Quitman Substation",[-92.26756743518779, 35.33021349765872]],
    [ "209962006",[-92.49141376341142, 35.08503280853688]],
    [ "Conway Corporation",[-92.50699618536659, 35.10078407112468]],
    [ "209962008",[-92.42875469720228, 35.068082023091264]],
    [ "210001692",[-92.38437971677115, 43.689105254230064]],
    [ "Greystone Substation",[-74.51027744488111, 40.85266522776494]],
    [ "Oklahoma Gas & Electric",[-95.29589747139028, 35.76366338735759]],
    [ "Oklahoma Gas & Electric",[-95.28935626933743, 35.76218930560165]],
    [ "210233771",[-95.25059254955701, 35.771619908220664]],
    [ "Lakeview Substation",[-87.65661606371874, 41.93196885681928]],
    [ "210335463",[-95.4709535854067, 41.47738879521313]],
    [ "Monterey Substation",[-85.24864588398286, 36.12636290502817]],
    [ "Smithville Substation",[-85.537957338297, 36.028846935660674]],
    [ "Tennessee Valley Authority",[-85.28173332470529, 35.96343666614375]],
    [ "Shawsville Substation",[-80.26551772399625, 37.14747442007281]],
    [ "Shoemaker Substation",[-74.41772372167699, 41.428382323096955]],
    [ "Westtown Substation",[-74.53949985641023, 41.34013614709929]],
    [ "Morrilton East Substation",[-92.75861640881011, 35.15404587546806]],
    [ "Arkansas Electric Cooperative Cooperation",[-92.79903384999999, 35.10112405]],
    [ "Commonwealth Edison",[-87.6269113761816, 41.86291548603938]],
    [ "Consumers Energy",[-83.83413806927837, 41.81626380117439]],
    [ "Consumers Energy",[-83.83360160000001, 41.8188335]],
    [ "210632702",[-78.64335070335567, 42.25883217082154]],
    [ "Bismarck Substation",[-82.99670006118805, 42.59455573294943]],
    [ "Stephens Substation",[-82.99664796947194, 42.473974220164216]],
    [ "Victor Substation",[-82.8202150687129, 42.725924974249374]],
    [ "Bethuy Substation",[-82.71005222756392, 42.72858328615244]],
    [ "Rattle Run Substation",[-82.91259938880897, 42.636352572384446]],
    [ "DTE Energy",[-82.62939024025465, 42.71257281106524]],
    [ "Clinton Substation",[-82.95045042114387, 42.59209680548266]],
    [ "Jefferson Street Substation",[-87.64304864328594, 41.870833346280236]],
    [ "Commonwealth Edison",[-87.64157149241333, 41.870909731889846]],
    [ "Kingsbury Substation",[-87.63843309448762, 41.891774327326516]],
    [ "Roseland Substation",[-87.62050448481331, 41.69670535638674]],
    [ "The Potomac Edison Company",[-78.2066720000786, 39.18802689990769]],
    [ "Harrisonville Substation",[-94.3213574153829, 38.61926163995082]],
    [ "Archie Substation",[-94.35602430239415, 38.557992845075795]],
    [ "Lawnwood Substation",[-80.34978674259087, 27.429745609875173]],
    [ "Hartman Substation",[-80.36564183315944, 27.43003582299188]],
    [ "Pleasant Hill Switching Station",[-94.27685446751319, 38.78648565199883]],
    [ "Harrisonville Switching Station",[-94.30187600186751, 38.63087917919769]],
    [ "Georgia Power",[-84.32749093244915, 33.78896202250138]],
    [ "Little Falls Substation",[-94.29919586160767, 45.962199574448476]],
    [ "Brainerd Substation",[-94.16692268533448, 46.33101057978429]],
    [ "Dewing Substation",[-94.17647102399269, 46.200772903208744]],
    [ "Oak Lawn Substation",[-94.06456637685103, 46.35146614383742]],
    [ "210862584",[-89.40753156908981, 40.34588702691801]],
    [ "Quincy Street Substation",[-86.11037462558001, 42.84192830984909]],
    [ "James Street Substation",[-86.10709131265361, 42.81129758732306]],
    [ "Dow Corning Substation",[-84.19492974456827, 43.58412778709315]],
    [ "University Substation",[-87.60696218348498, 41.80362373419955]],
    [ "210924162",[-91.4485261, 46.633918599999994]],
    [ "Arkansas Valley Electric Cooperative",[-94.3732646595299, 35.59844187931942]],
    [ "Ozarks Electric Cooperative Corporation",[-94.20380765, 35.9951165]],
    [ "Arkansas Valley Electric Cooperative",[-94.2026960503024, 35.99670501175958]],
    [ "Plainview Substation",[-73.46881394502996, 40.77334302804228]],
    [ "Herbster (DPC)",[-91.25820500000002, 46.79664805]],
    [ "Herbster",[-91.25666567506708, 46.832867244969336]],
    [ "Halesite Substation",[-73.41551329999999, 40.887948249999994]],
    [ "211135824",[-73.65081129388959, 40.621385985269654]],
    [ "211151173",[-73.5315846982042, 40.766773479834384]],
    [ "Jericho Substation",[-73.54035525878226, 40.7758921260663]],
    [ "Arverne Substation",[-73.78324025397029, 40.592511433561285]],
    [ "Central Avenue Substation",[-73.70969453074005, 40.677067863145815]],
    [ "Rockaway Beach Substation",[-73.83379068779345, 40.58275779875885]],
    [ "Cherrydale Substation",[-77.10441479439228, 38.89571111563605]],
    [ "Ozarks Electric Cooperative Corporation",[-94.09479401635615, 36.133426375667426]],
    [ "Ozarks Electric Cooperative",[-94.01368147550247, 35.97399234290585]],
    [ "Gulley Road Substation",[-94.09078202901472, 36.110073617328446]],
    [ "211265340",[-115.27370029394743, 32.77035354700423]],
    [ "211338385",[-80.27976982269169, 40.18016991337281]],
    [ "ITC",[-90.3152818401958, 41.800793933896735]],
    [ "Ozarks Electric Cooperative Corporation",[-94.22952994999997, 36.079384049999994]],
    [ "Ozarks Electric Cooperative Corporation",[-94.19293692403366, 36.13966275966372]],
    [ "Ozarks Electric Cooperative Corporation",[-94.28142719378977, 36.02951478145426]],
    [ "Arkansas Electric Cooperative Corporation",[-94.27914072528598, 36.051768742953804]],
    [ "Ozarks Electric Cooperative Corporation",[-94.1355491288297, 36.127659657997164]],
    [ "Abilene Power Plant Substation",[-99.72133471344799, 32.44995247595793]],
    [ "County Line Substation",[-95.5950188908656, 39.10775315844428]],
    [ "Bagley Substation",[-95.420356541216, 47.57315341509769]],
    [ "Northwoods Substation",[-95.20651817338442, 47.52839381365737]],
    [ "Northeast Power",[-91.5397328048181, 40.923954906143585]],
    [ "Henry Substation",[-91.53891418688029, 40.92371676080183]],
    [ "Southwestern Electric Power Company",[-94.13667484999996, 36.164304099999995]],
    [ "Kartchner Substation",[-110.30896444024592, 31.566092490750265]],
    [ "211635390",[-114.52120712511162, 42.59301304296377]],
    [ "Cedarhurst Substation",[-73.72904785575628, 40.620275509110044]],
    [ "Prospect Substation",[-73.68979705077916, 40.647681405346276]],
    [ "Roosevelt Substation",[-73.60604102239525, 40.68075154452008]],
    [ "211777302",[-91.34921501033948, 39.906378693537675]],
    [ "211781965",[-78.18790444999999, 39.1261293]],
    [ "TECO",[-82.49338862520074, 27.907534739104623]],
    [ "Dunedin Substation DUKE",[-82.77628300876705, 28.022773325244792]],
    [ "Ozarks Electric Cooperative Corporation",[-93.88970787493774, 36.15517655452071]],
    [ "Wyola Substation",[-94.05818158693636, 35.86041852474349]],
    [ "Ozarks Electric Cooperative Corporation",[-93.84283627990833, 35.82669783565939]],
    [ "Ozarks Electric Cooperative Corporation",[-94.0683505875058, 36.15885513352866]],
    [ "Wesley Post Office",[-93.92372340453133, 36.028068706923584]],
    [ "Burnett 115/14 KV Substation",[-92.5453769036561, 46.89699706643598]],
    [ "212393401",[-95.9271881113471, 40.00141572263674]],
    [ "Cloquet 115/14 KV Substation",[-92.44965146496864, 46.730207881177755]],
    [ "212394615",[-111.98739079203573, 33.41780349773252]],
    [ "SRP Hurley Substation",[-112.00611240146418, 33.41418957772816]],
    [ "Potlatch 115KV Substation",[-92.42744936011898, 46.72615903461921]],
    [ "Southwestern Electric Power Company",[-94.1409464903311, 36.26014472484288]],
    [ "Arkansas Electric Cooperative Corporation",[-94.25282185175757, 36.19314737478089]],
    [ "212498257",[-94.11676249561296, 36.31621006768854]],
    [ "Kelly Substation",[-95.93499764918089, 39.75372710616639]],
    [ "Lawnside Substation",[-75.01814856571649, 39.860730887062076]],
    [ "Arkansas Electric Cooperative Corporation",[-94.00971273122144, 36.397565355022714]],
    [ "East Rogers Substation",[-94.09008575826053, 36.34813606745035]],
    [ "213026736",[-81.09943246630306, 29.31911344755195]],
    [ "Cornucopia",[-91.10115460123824, 46.857617416776456]],
    [ "Sonterra Substation",[-97.60763321221228, 30.802329683416254]],
    [ "Jarrell Substation",[-97.56182670396979, 30.796453086041968]],
    [ "Jarrell East Substation",[-97.61063503541477, 30.796228365695047]],
    [ "Green Substation",[-82.49704433104667, 43.07767523724029]],
    [ "Aaron Substation",[-82.49372085444493, 43.07077414987416]],
    [ "Mitchell Substation",[-82.59488275797538, 36.35551784843959]],
    [ "Lamar Substation",[-82.46893787578011, 36.239395289477834]],
    [ "Appalachian Electric Cooperative",[-82.8331722, 36.31931765]],
    [ "Telford Substation",[-82.52622448158661, 36.254621054344305]],
    [ "Edens Ridge Substation",[-82.5286968917516, 36.51906073502437]],
    [ "Jonesboro Substation",[-82.483463433162, 36.28299811101441]],
    [ "Jonesborough Substation",[-82.43136829238928, 36.25072650921405]],
    [ "213367068",[-82.76150585285195, 36.30301342415818]],
    [ "Greeneville Light and Power System",[-82.82707669318502, 36.155616814815076]],
    [ "Erwin Substation",[-82.41935099844679, 36.15319969932681]],
    [ "Bristol Tennessee Essential Services",[-82.2875595, 36.440166700000006]],
    [ "Johnson City Energy Authority",[-82.31468720109416, 36.276755416385505]],
    [ "Unicoi Substation",[-82.35429709067374, 36.190830752416645]],
    [ "Johnson City Energy Authority",[-82.30558123900319, 36.306100533603285]],
    [ "Nolichucky Substation",[-82.86678247186104, 36.06628478024464]],
    [ "Greeneville Light and Power System",[-82.94238041113024, 36.12174226176037]],
    [ "213489487",[-83.01061265644861, 36.19697873065347]],
    [ "Indian Springs Substation",[-82.44828118144618, 36.52680222894193]],
    [ "Short Hills Substation",[-82.51514645786652, 36.55992045075497]],
    [ "Sullivan Gardens Substation",[-82.5888805095453, 36.468212174213114]],
    [ "213528720",[-82.2226198981487, 36.60207401809551]],
    [ "Kingsport Power Company",[-82.5950219194294, 36.5810207918481]],
    [ "Reedy Creek Substation",[-82.53675779647712, 36.56952642341917]],
    [ "213537508",[-82.6484596758442, 35.559341231817974]],
    [ "Canton Substation",[-82.84454816419914, 35.522865972314975]],
    [ "Enka Substation",[-82.63576438979754, 35.537340126957]],
    [ "West Asheville Substation",[-82.56809929575566, 35.57255869036056]],
    [ "Oteen Substation",[-82.5019012238451, 35.56899271212074]],
    [ "213557874",[-82.57436293375882, 35.48809039393268]],
    [ "Jefferson County Substation",[-91.97120835665419, 41.035407924271524]],
    [ "Clarendon Substation",[-77.10461840358028, 38.88493724105057]],
    [ "Inglis Substation",[-82.6775623729514, 29.031497659092082]],
    [ "213676327",[-82.67154649217497, 29.03372313936404]],
    [ "Hazelwood Substation",[-83.00686209363028, 35.48431411608448]],
    [ "Walters Hydroelectric Plant Substation",[-83.09938419134367, 35.77417550474159]],
    [ "213772850",[-82.9855259, 35.50665795]],
    [ "213772853",[-82.57200281688738, 35.706641368616]],
    [ "213772856",[-82.30302080914645, 35.620914226577334]],
    [ "213772858",[-82.66102738408064, 35.634283628602475]],
    [ "Weaverville Substation",[-82.57670088387924, 35.70322259418414]],
    [ "Campobello Substation",[-82.16261630394213, 35.12114000193161]],
    [ "Henderson Substation",[-82.46880623528844, 35.341750393052784]],
    [ "Horsehoe Tie Substation",[-82.53721770139337, 35.35426276460671]],
    [ "213877612",[-81.97822381371704, 34.955682913559755]],
    [ "213877616",[-81.98289735, 34.9733456]],
    [ "213877617",[-82.22734585, 34.961965750000005]],
    [ "213877619",[-82.71305427442056, 35.79293497339748]],
    [ "213877620",[-82.44809376236242, 35.31030364114553]],
    [ "213877621",[-82.69266799345682, 35.81295301503108]],
    [ "213877624",[-82.02300318459675, 34.96544379198368]],
    [ "213877640",[-82.41646910530909, 35.29494257671325]],
    [ "Hendersonville Tie Substation",[-82.40665044122788, 35.269804402058476]],
    [ "213877643",[-82.33369139023776, 34.94174258093896]],
    [ "213877644",[-82.53858698105932, 35.40506260180062]],
    [ "213877645",[-82.62830059745598, 35.30875123831352]],
    [ "Lysander Station",[-76.3222401148984, 43.17465947985346]],
    [ "East Spartanburg Substation",[-81.91340810897262, 34.96466822442544]],
    [ "Gaffney Tie Substation",[-81.62183472978644, 35.07304327162864]],
    [ "Inman Substation",[-82.04022299033686, 35.02803987505175]],
    [ "213923202",[-82.00273153515202, 35.0635235308958]],
    [ "Fairview Tie Substation",[-81.89507801435288, 35.34941971155812]],
    [ "213923215",[-81.87323731236208, 35.16318012325412]],
    [ "213923217",[-82.2157311, 34.6957431]],
    [ "213923223",[-81.7902187, 35.0739657]],
    [ "Chesnee Tie Substation",[-81.87223802936786, 35.141255284600746]],
    [ "213923230",[-82.52693547543818, 34.8402150993015]],
    [ "213923243",[-82.18669853187093, 34.746994691553894]],
    [ "213923252",[-81.9570422893736, 35.01990868056274]],
    [ "213923266",[-81.98598133180346, 34.923389314707315]],
    [ "213930834",[-80.91343972222383, 35.12538124145671]],
    [ "Holgate Substation",[-122.64108621411145, 45.491097050591755]],
    [ "213950653",[-91.94154671875678, 46.60406468605314]],
    [ "213950654",[-91.90825140000001, 46.5750609]],
    [ "214078903",[-81.52424699365963, 35.30457042840193]],
    [ "214078907",[-80.94938988350496, 35.009196958968985]],
    [ "214078914",[-81.53128279155378, 35.27866148188319]],
    [ "Bellwood Substation",[-87.87157862258928, 41.884895033770654]],
    [ "Elmhurst Substation",[-87.92269961411958, 41.92275622146645]],
    [ "ComEd Garfield 345kV Substation",[-87.62814060124379, 41.79578650161121]],
    [ "Northlake Substation",[-87.91218020000001, 41.921258949999995]],
    [ "Trillium Substation",[-83.13335409599864, 42.254302293865656]],
    [ "Tecumseh Substation",[-83.13088516003836, 42.25649794327188]],
    [ "Ecorse Substation",[-83.1312842503177, 42.24765360073625]],
    [ "Adams Substation",[-83.12144473232995, 42.26148910381584]],
    [ "Baxter Substation",[-83.16901273129459, 42.2924956993608]],
    [ "Warren Station",[-83.18028235831608, 42.34232572958995]],
    [ "214485553",[-102.21003664999999, 42.800566950000004]],
    [ "Gordon Substation",[-102.24204199211785, 42.78778975392372]],
    [ "214500468",[-91.82305258303947, 46.35854133282946]],
    [ "Phoenix Substation",[-83.72344506975769, 42.31775984902298]],
    [ "State Substation",[-83.73833905751323, 42.25056920643394]],
    [ "Parkway Substation",[-95.16355544848018, 29.817955568148964]],
    [ "CenterPoint Energy",[-95.1540834, 29.8200214]],
    [ "Wallisville Substation",[-95.29123574235656, 29.78743533745914]],
    [ "Almonaster Substation",[-90.04384150270879, 29.99195751194648]],
    [ "Avenue C Substation",[-90.11789655, 30.011855250000004]],
    [ "Duguid Station",[-75.97644637607456, 43.03192835613798]],
    [ "Derbigny Substation",[-90.08593637288403, 29.95296394811295]],
    [ "Market Street 230 kV Substation",[-90.06590322903914, 29.929277394838838]],
    [ "Midtown Substation",[-90.10237548197962, 29.965015356465887]],
    [ "214941083",[-91.78844758392765, 46.172656475435275]],
    [ "214941089",[-91.8114291319279, 46.150509336652185]],
    [ "214966759",[-91.52122267528011, 45.98763034366041]],
    [ "Bayfield Substation",[-90.81553121643007, 46.808774075149415]],
    [ "Arabi Substation",[-89.99154305624407, 29.972263582400014]],
    [ "Gentilly Road Substation",[-89.89747203731429, 30.038899822809935]],
    [ "NASA Substation",[-89.90793812258151, 30.035890188856136]],
    [ "Pauger Substation",[-90.06224521446426, 30.0005642237494]],
    [ "Pontchartrain Park Substation",[-90.04575189285062, 30.01399838013818]],
    [ "Tricou Substation",[-90.00230777472765, 29.974589930258748]],
    [ "215048743",[-90.05575720677794, 29.962241383848664]],
    [ "215048763",[-89.95758055, 29.953466149999997]],
    [ "Lakeshore Substation",[-90.16097601851332, 30.013847624057433]],
    [ "215080163",[-93.18680075036528, 44.437410965602794]],
    [ "Sanilac Substation",[-83.05853402395786, 43.291134394885674]],
    [ "University City Substation",[-90.27339455183476, 30.042063589207938]],
    [ "215140314",[-91.64297228791966, 45.95740037497851]],
    [ "DSM Substation",[-95.3697035158732, 29.010340487550756]],
    [ "Velasco Substation",[-95.36265065542838, 28.98011688690485]],
    [ "April Substation",[-95.6146984632931, 30.369079875011053]],
    [ "Walden Substation",[-95.62046783750972, 30.39557182284182]],
    [ "Weadock Substation",[-83.8432363598783, 43.64005539121485]],
    [ "Monitor Substation",[-83.9390512366107, 43.595937994375774]],
    [ "Bangor Substation",[-83.8548850672837, 43.63645940451843]],
    [ "Cottage Grove Substation",[-83.99070719216155, 43.73746963240154]],
    [ "Troy Substation",[-83.18227594125008, 42.53705912620682]],
    [ "Holly Substation",[-83.18025800698365, 42.52968931537314]],
    [ "Wheeler Substation",[-83.25603266616112, 42.615501934200665]],
    [ "Washburn",[-90.8971724664199, 46.66980246689186]],
    [ "Northeast Substation",[-96.74546357498052, 46.89761839396534]],
    [ "215717911",[-93.74686393606706, 35.402002274613615]],
    [ "Rudy Substation",[-94.25191349033769, 35.52593142473721]],
    [ "Gingles",[-90.88214911733169, 46.558614808406865]],
    [ "216261719",[-84.32821654283293, 33.79111698302635]],
    [ "Norris Substation FPL",[-80.89001645340257, 28.667297702867543]],
    [ "Indian River Substation",[-80.8140376752905, 28.5579718959735]],
    [ "Harrison East Substation",[-93.07251845545373, 36.22124484259606]],
    [ "St. Joe Substation",[-92.78297100000002, 36.0151062]],
    [ "Everton Road Substation",[-92.97101610882379, 36.12950484734117]],
    [ "Bibon Substation",[-91.0293811, 46.413405850000004]],
    [ "White River Substation",[-90.90442809933332, 46.4986464]],
    [ "Bayfield Electric Cooperative",[-90.865376925129, 46.544725196135225]],
    [ "216491401",[-87.688617923096, 38.71596553942563]],
    [ "216566730",[-91.4217044304983, 44.900005549649066]],
    [ "216571538",[-91.34314378808561, 44.936919795323625]],
    [ "Entergy Louisiana",[-90.14972945572597, 29.946287293801387]],
    [ "McDonnell Substation FPL",[-80.80724491615311, 28.531539352907647]],
    [ "Greenway Substation",[-77.4795866881522, 39.0040246371503]],
    [ "Highway 59 Substation",[-94.35951462801789, 35.47146573163947]],
    [ "Agua Fria Substation",[-112.21858506877105, 33.55697349759272]],
    [ "Vint Hill Substation",[-77.59206365, 38.731553049999995]],
    [ "216945248",[-91.10528551871242, 46.36369733484544]],
    [ "ComEd Beverly Substation",[-87.65409031701176, 41.703535820744094]],
    [ "Wheeler Substation",[-77.65414332776862, 38.75304824482826]],
    [ "Wolf Lane Substation",[-97.56140145378143, 30.139423185365466]],
    [ "Pilot Knob Substation",[-97.68163296287113, 30.162488101970048]],
    [ "Colton Substation",[-97.67901454883628, 30.139128511678305]],
    [ "Frontenac Substation",[-80.76694161146595, 28.470369423600616]],
    [ "Cape Canaveral Plant Substation",[-80.76705726257748, 28.468216787057667]],
    [ "NOVEC Moore Delivery Point",[-77.3750015817651, 38.767520948090166]],
    [ "217380323",[-77.45285497495239, 38.76915053584057]],
    [ "Harrison Delivery Point",[-77.45130353514027, 38.81152701480038]],
    [ "217382431",[-77.45278484280527, 38.81058248313873]],
    [ "217382447",[-77.46158651537534, 38.805596331964736]],
    [ "Battery Heights Substation",[-77.45780185440088, 38.75271416456453]],
    [ "217422354",[-91.0450835, 44.95136515]],
    [ "217439463",[-79.93708844999999, 32.72911609999999]],
    [ "Folly Beach Substation",[-79.94244937133088, 32.65625494316235]],
    [ "Crossroads Substation",[-79.96051067383513, 37.31422353451231]],
    [ "Charleston International Airport Substation",[-80.03760957709842, 32.8692869487767]],
    [ "217501717",[-80.04101482878357, 32.86674556512637]],
    [ "217507512",[-77.77800699099932, 35.96204978399628]],
    [ "Faber Place Substation",[-80.01462988715987, 32.850025320510085]],
    [ "San Germán",[-67.02847823640666, 18.076021244801655]],
    [ "217550137",[-106.23292284639737, 31.768604910878178]],
    [ "Puerto Rico Electric Power Authority",[-66.5513970661369, 18.05983407786261]],
    [ "217603434",[-90.31187304999999, 45.53849880000001]],
    [ "217611089",[-77.10902737362969, 38.81863693349706]],
    [ "Glenn Substation",[-112.2124144451828, 33.541250606175204]],
    [ "Dave's Creek",[-149.6444662186039, 60.52524586576315]],
    [ "217657091",[-77.7824592005112, 35.952155307194104]],
    [ "Black River Substation",[-86.0555229639016, 42.80720730228022]],
    [ "217703854",[-90.13481742968962, 44.63458482211528]],
    [ "Norridge Substation",[-87.83394265, 41.95975075]],
    [ "SRP Parker Substation",[-111.99657949865937, 33.40316265598722]],
    [ "ComEd Natoma Substation",[-87.7909011681298, 41.92515824424808]],
    [ "City Point Substation",[-80.75688688292924, 28.402478295749475]],
    [ "West Substation",[-97.09655014337741, 31.794848854848343]],
    [ "Walsingham Substation",[-82.81228379605805, 27.87975526481367]],
    [ "217977277",[-77.81898586509995, 35.95223493200381]],
    [ "217998035",[-77.82926324642754, 35.93389721811355]],
    [ "Markesan",[-88.99612727408486, 43.70292419578496]],
    [ "218123373",[-91.2192046758007, 39.343241072210155]],
    [ "Dominion Energy",[-77.08756194303807, 38.88654772630278]],
    [ "Allendale",[-74.13543499930422, 41.042885304402844]],
    [ "218269359",[-77.79447245, 35.97280315]],
    [ "DEWEY",[-87.68420047505658, 44.07432295314706]],
    [ "CUSTER",[-87.726790244724, 44.0852148494709]],
    [ "North Quincy Substation",[-71.03308216800671, 42.27862403263312]],
    [ "Hobart Junction",[-99.05945607586659, 35.03192619518672]],
    [ "Wisconsin Public Service",[-88.07201683481527, 44.17981980685594]],
    [ "Melissa",[-88.42476814999999, 44.206963900000005]],
    [ "218400579",[-88.36655575000002, 44.2352597]],
    [ "Murrycrest Substation",[-79.6602889906574, 40.44944354887206]],
    [ "Iatan 161kV Substation",[-94.97582950145733, 39.45110770778093]],
    [ "Clark Substation",[-104.87102963473629, 39.593892939364764]],
    [ "219052405",[-115.08635042955996, 36.03302020925259]],
    [ "Iola",[-89.12991802743502, 44.50457380400398]],
    [ "WE Energies",[-88.88010100000001, 44.37058565000001]],
    [ "219111968",[-88.72791823940021, 44.37761939363064]],
    [ "219115027",[-88.73967215000002, 44.39834255]],
    [ "219115028",[-88.73271425000001, 44.3736364]],
    [ "219115030",[-88.73421863470284, 44.391225845834136]],
    [ "Beech Bluff Substation",[-88.64052441508889, 35.58815344886335]],
    [ "Fitzsimmons Substation",[-104.83213066562246, 39.750596389475895]],
    [ "Chambers Substation",[-104.8127444478195, 39.76184794484295]],
    [ "Southwest Lawrence",[-95.28007145940416, 38.925615500663824]],
    [ "Wren Substation",[-95.27970774810052, 38.95774860023909]],
    [ "Hinchmans Ave Substation",[-74.22276791349417, 40.95559716343545]],
    [ "Reedsburg",[-90.01031317875831, 43.530393583559295]],
    [ "Artesian",[-89.99513740667342, 43.52141087813503]],
    [ "Dock Street Substation",[-75.21576099030445, 40.685744666898145]],
    [ "Kirkwood",[-89.78811283141545, 43.46926132183861]],
    [ "219503317",[-91.28482134499592, 46.237542965719754]],
    [ "KU West Substation",[-95.2694987066784, 38.94972792523867]],
    [ "219606604",[-105.09605526224517, 38.36724619239751]],
    [ "Leonard Street Substation",[-74.00648305517566, 40.718393817235565]],
    [ "19th Street Substation",[-95.25688048961688, 38.949615756327624]],
    [ "219735094",[-113.15554071506098, 37.69375363386025]],
    [ "219773161",[-85.1391436964157, 39.67213190479641]],
    [ "Starkville Electric Department",[-88.80227414999999, 33.451124]],
    [ "Starkville Electric Department",[-88.79940325, 33.46799575000001]],
    [ "Moore Substation",[-112.25445587469547, 33.559495860665635]],
    [ "219943525",[-76.4577397233894, 43.48797564430128]],
    [ "Henderson Substation",[-88.65762278800858, 35.430818720789496]],
    [ "220094873",[-112.15719750940842, 33.53559708365453]],
    [ "SRP Binary Substation",[-111.9690304954498, 33.41185782753347]],
    [ "220139506",[-116.21959492784339, 43.61856350180955]],
    [ "Piper Substation",[-94.86019498483793, 39.14718595719107]],
    [ "Georgia Power",[-84.22999588629125, 33.7882206264723]],
    [ "Cortland Substation",[-83.09162175308818, 42.396213250055155]],
    [ "South Brady Substation",[-99.32948278431064, 31.11807997512652]],
    [ "Dutton Substation",[-99.32304885, 31.1456513]],
    [ "Van Dorn Substation",[-77.1490272189131, 38.79501194036568]],
    [ "220417664",[-77.187186, 38.7983318]],
    [ "220534808",[-78.46681205949177, 35.64685555097507]],
    [ "220700402",[-91.28406999189704, 46.208988636140035]],
    [ "Stull Substation",[-95.42867167519849, 38.97797130496657]],
    [ "220823014",[-94.455342383859, 36.31682207273684]],
    [ "220823015",[-94.51789385365343, 36.54344081565804]],
    [ "Yale Substation",[-112.04632215974462, 33.47662510057727]],
    [ "Sport Substation",[-83.41073694160391, 42.27346614420341]],
    [ "Topaz Substation",[-83.40543151069633, 42.275509199337016]],
    [ "Teall Avenue Station",[-76.12301371939525, 43.088847609131584]],
    [ "220947889",[-76.12123734603755, 43.088435350162634]],
    [ "Matthews Ave.",[-76.2252862333937, 43.06313768887149]],
    [ "Mason Public Ulility District",[-123.10003847538123, 47.209905145338595]],
    [ "Ozarks Electric Cooperative Corporation",[-94.16232091077092, 36.195621507606006]],
    [ "221128651",[-111.96489785656921, 33.35596259139058]],
    [ "221140223",[-123.59746835492682, 46.978800753663336]],
    [ "221149551",[-96.76864517019384, 32.91455664222185]],
    [ "Muncie Substation",[-94.63941635390722, 39.09293723211937]],
    [ "221299984",[-123.88377702543791, 46.983389489118125]],
    [ "221425840",[-123.76640564843557, 46.94933772734443]],
    [ "Paradise Substation",[-77.53058580989767, 38.778122179612424]],
    [ "221846564",[-110.8701795367858, 39.70266642705365]],
    [ "221926811",[-124.10058003774533, 46.85925537267754]],
    [ "221995508",[-78.21966505230749, 39.60699391888896]],
    [ "222004155",[-111.94507488495199, 33.329953226952824]],
    [ "222247134",[-123.27064068380682, 47.05635692828521]],
    [ "Pittsfield Substation",[-83.68567935506837, 42.245731952749395]],
    [ "222420733",[-94.52707533409345, 36.159239486036796]],
    [ "Southwestern Electric Power Company",[-94.4714703687864, 36.20969372847883]],
    [ "Clarksville Connected Utilities",[-93.47221185, 35.461890000000004]],
    [ "Clarksville Connected Utilities",[-93.45574572518741, 35.47413470117087]],
    [ "Arkansas Valley Electric Cooperative",[-93.31073532287733, 35.38331240481847]],
    [ "Arkansas Valley Electric Cooperative",[-93.17454936285863, 35.46483460771442]],
    [ "Arkansas Valley Electric Cooperative",[-93.32145884819961, 35.480768231432975]],
    [ "222437763",[-93.483082728306, 35.49206092808942]],
    [ "Huntsville Utilities",[-86.5696526901159, 34.87973722151776]],
    [ "222584520",[-94.64722845854011, 35.19513032072286]],
    [ "Southwestern Electric Power Company",[-94.42952522426319, 35.28284985620541]],
    [ "Arkansas Valley Electric Cooperative",[-94.37245370048097, 35.20953250455313]],
    [ "222584526",[-94.39421530830704, 35.238223406266286]],
    [ "USAA #2 Substation",[-98.5713421560307, 29.53049694499933]],
    [ "USAA #1 Substation",[-98.5762953356995, 29.53327781506695]],
    [ "Buckeye Substation",[-98.52459231250097, 29.49368260711173]],
    [ "223091960",[-112.16954381882766, 33.570779443281985]],
    [ "Noble Substation",[-83.76876985000001, 42.1765283]],
    [ "Wisner Substation",[-84.4255559467409, 42.265684134449906]],
    [ "Wildwood Substation",[-84.44329015, 42.252807950000005]],
    [ "Westwood Substation",[-84.4336020066863, 42.25214189730034]],
    [ "Hayfield Substation",[-77.15042983865197, 38.76310239280421]],
    [ "Belvoir Substation",[-77.13448320373578, 38.741433734089085]],
    [ "Nortonville Substation",[-95.35177653367536, 39.4066951546243]],
    [ "223328683",[-80.22901941021347, 40.18948352664507]],
    [ "Lagonda Substation",[-80.31484894103272, 40.12639698454961]],
    [ "223357766",[-112.05903395, 40.59474505]],
    [ "Beauregard Electric Cooperative",[-93.23183769999999, 30.521938750000004]],
    [ "Beauregard Electric Cooperative",[-93.23369640000001, 30.664644299999996]],
    [ "Sans Souci Substation",[-89.96702508015419, 35.65272946117141]],
    [ "Mississippi County Electric Cooperative",[-89.78427217538818, 35.9057294124474]],
    [ "Hickman South Substation",[-89.76786141381389, 35.920528133339644]],
    [ "Mississippi County Electric Cooperative",[-89.75771810895961, 35.92809175638477]],
    [ "Arkansas Electric Cooperative Corporation",[-89.85705517850525, 35.97294340738084]],
    [ "Mississippi County Electric Cooperative",[-89.7249451095159, 35.94721442676673]],
    [ "Mississippi Electric Cooperative",[-89.7971116304535, 35.89299306218359]],
    [ "Mississippi County Electric Cooperative",[-89.78403056501698, 35.91355878342646]],
    [ "Mississippi County Electric Cooperative",[-89.73348183488757, 35.93193253224087]],
    [ "Pompey Station",[-76.03018049999999, 42.922486799999994]],
    [ "Northern Substation",[-112.14557162146693, 33.55363239480079]],
    [ "Maryvale",[-112.1771121382039, 33.50991565698385]],
    [ "223783930",[-91.10025655992489, 45.44869596248908]],
    [ "223783931",[-91.1134189209286, 45.4714283681503]],
    [ "223784613",[-111.91939230992607, 33.34957633918217]],
    [ "Harrison Substation",[-104.94238778309, 39.73719221147565]],
    [ "DTE Energy",[-83.24867319999998, 42.101507049999995]],
    [ "223871013",[-96.65173176589998, 34.75189793142045]],
    [ "223919722",[-96.61912646117533, 34.71938102144439]],
    [ "Hospital Road Substation",[-71.62807350000001, 42.541755050000006]],
    [ "Austin Dam Substation",[-97.78440365370147, 30.29327791340285]],
    [ "Bee Creek Substation",[-97.78951716538914, 30.29385930505815]],
    [ "Juneau Substation",[-82.48101541459057, 28.022842790891943]],
    [ "Pebbledale Substation TECO",[-81.94094373707442, 27.835005228516014]],
    [ "Winston Substation",[-82.01538362151004, 28.02797792913151]],
    [ "224009482",[-111.96024681719308, 33.400547359279045]],
    [ "Florida Power & Light",[-81.7792333, 26.69686845]],
    [ "Fort Myers Switchyard",[-81.78025213405202, 26.699088126670993]],
    [ "Calusa Substation",[-81.77828791823872, 26.719110559799077]],
    [ "Slater Substation",[-81.8551478, 26.709673150000004]],
    [ "Lee County Electric Cooperative",[-81.78408360671231, 26.711760290699974]],
    [ "Cleveland Substation",[-81.97792489387109, 26.95528078559243]],
    [ "224045340",[-87.25479194567775, 45.054891461646264]],
    [ "Lake George Substation",[-71.6329874, 42.53296025]],
    [ "Peachland Substation",[-82.06385585037192, 27.042449583337955]],
    [ "224059713",[-82.43066314999999, 27.357966800000003]],
    [ "Hobart Substation",[-83.75913497118155, 42.31010445389791]],
    [ "224110935",[-87.13337442883304, 45.167691196977884]],
    [ "224115118",[-82.45767661512902, 27.580575770705128]],
    [ "Manatee Substation",[-82.34544636783205, 27.603949993118196]],
    [ "Ruskin Substation",[-82.4056708026682, 27.71768761279889]],
    [ "224240600",[-111.96173981528278, 33.33869029908186]],
    [ "224315018",[-91.25643272074042, 45.762041824857626]],
    [ "224445351",[-81.92441475000001, 28.080456399999992]],
    [ "Deerhaven Plant Substation GRU",[-82.38794267507966, 29.757039045961992]],
    [ "224445354",[-81.98839878978717, 27.731961675125866]],
    [ "Eastport Substation JEA",[-81.5982303517138, 30.41895821686658]],
    [ "224445357",[-81.92383755801703, 28.08119595780339]],
    [ "224445359",[-82.43117763734449, 28.581177720619593]],
    [ "McIntosh Substation",[-81.92990133187757, 28.086701346189777]],
    [ "Stanton North Substation",[-81.15923002496861, 28.494981079659983]],
    [ "Bristol Hill Station",[-76.39652813976194, 43.3290516424909]],
    [ "224697043",[-79.64477406869425, 36.04266549140904]],
    [ "224697045",[-79.77952795, 36.010393349999994]],
    [ "224697046",[-79.64841220000001, 36.0545471]],
    [ "224697049",[-79.60336292111661, 36.049418421313256]],
    [ "224697050",[-79.6101120569523, 36.04834726468756]],
    [ "224697053",[-79.77839767857228, 36.010556881502694]],
    [ "224697055",[-79.58618504368609, 36.053290950511084]],
    [ "224697264",[-79.50339307286228, 36.07483088916667]],
    [ "224699293",[-90.30682477523932, 44.78602439501629]],
    [ "224699787",[-79.4972253466924, 36.079111216807235]],
    [ "224699791",[-79.44238009262243, 36.08542025291895]],
    [ "Kentucky Utilities Company",[-84.58312955000001, 37.88521345000001]],
    [ "Loomis Substation",[-98.1049115031122, 43.79996049713209]],
    [ "224798780",[-96.83442198279009, 34.86854008324723]],
    [ "224798782",[-96.8200220326011, 34.77863828689672]],
    [ "Kingsbery Substation",[-97.6872139888945, 30.265292640786274]],
    [ "Carson Creek Substation",[-97.68710033986902, 30.203234658992475]],
    [ "Sunset Substation",[-83.4282431013632, 42.4690840908792]],
    [ "Drake Substation",[-83.39643314658653, 42.46031264709704]],
    [ "Northwest Substation",[-83.23065952935208, 42.44306894527599]],
    [ "Florida Power & Light",[-80.35704779999999, 25.92721705]],
    [ "Lincoln Substation",[-83.14095794082809, 42.48408734692032]],
    [ "Erin Substation",[-82.93592909118027, 42.45366400704714]],
    [ "Packard Substation",[-83.04762461928988, 42.66636827465397]],
    [ "Sterling Substation",[-83.03963316581329, 42.59381591760987]],
    [ "Merrill Substation",[-83.04079244115695, 42.61082064948657]],
    [ "Sloan Substation",[-83.03984071343744, 42.56218302231246]],
    [ "Enterprise Substation",[-83.04091960479812, 42.57639924932348]],
    [ "224880212",[-83.0376784996768, 42.57112354665892]],
    [ "Red Run Substation",[-83.03625763162471, 42.52173238463587]],
    [ "Skylark",[-83.0388724789197, 42.51840194900906]],
    [ "Mustang Substation",[-83.04625164188589, 42.586837850208674]],
    [ "Pluto Substation",[-83.03676813548375, 42.50241841021847]],
    [ "224880911",[-77.94404361157196, 37.54895942063304]],
    [ "SRP Kirk Substation",[-111.66771729534234, 33.467127977212165]],
    [ "Proud Substation",[-83.56597974258071, 42.554448236021635]],
    [ "Kern Substation",[-83.25891301068269, 42.64856395949563]],
    [ "Catalina Substation",[-83.28925960351962, 42.65566630294491]],
    [ "Montcalm Substation",[-83.29435568326372, 42.65856619221668]],
    [ "224950762",[-83.29695015, 42.660143850000004]],
    [ "Tempest Substation",[-83.29422661344242, 42.67054442550078]],
    [ "Lapeer Substation",[-83.30080956015118, 43.05051088790439]],
    [ "Fawn Substation",[-83.30171129546333, 43.08355775644163]],
    [ "Fostoria Substation",[-83.37920557840984, 43.26264362694242]],
    [ "Tuscola Substation",[-83.38867094052092, 43.47375409369374]],
    [ "224955239",[-83.40899285370583, 43.47331653536914]],
    [ "Atlanta Substation",[-83.65911354236759, 43.471865898889405]],
    [ "224957405",[-83.2332933195085, 43.63506865495878]],
    [ "Bad Axe Substation",[-82.99015554736371, 43.8106296196904]],
    [ "Sandusky Substation",[-82.82094239754097, 43.42198462101798]],
    [ "224960345",[-82.49538755, 43.11603124999999]],
    [ "224960347",[-82.51448519867475, 43.19611198127702]],
    [ "Wealthy Street Substation",[-85.6913993591392, 42.955216011515354]],
    [ "Alpine Substation",[-85.6947171, 43.0620539]],
    [ "Englishville Substation",[-85.65973445, 43.11730165]],
    [ "Michigan Substation",[-85.65988725, 42.975855499999994]],
    [ "Baraga Substation",[-85.65844793768149, 42.97404507878003]],
    [ "Race Street Substation",[-85.6422379831823, 42.971412716516674]],
    [ "Beals Substation",[-85.67416627451726, 42.9117333783211]],
    [ "Mullins Substation",[-85.75765270161963, 43.01629428480527]],
    [ "East Grant Substation",[-85.7031143784513, 43.33742516772369]],
    [ "Wealthy Substation",[-85.68959943464631, 42.95637185462944]],
    [ "225013610",[-77.81996589908795, 37.58711864883521]],
    [ "Kentucky Utilities Company",[-84.57718480000001, 37.916930650000005]],
    [ "225121072",[-96.63555708470068, 34.65501779321122]],
    [ "Spring Green",[-90.05160165297445, 43.177565978879535]],
    [ "Georgia Power",[-83.19054957512375, 34.04088524319532]],
    [ "225348299",[-89.65110507503931, 43.09675520558492]],
    [ "225353679",[-89.5194515, 43.09524485000001]],
    [ "225410767",[-84.6284313, 38.9269223]],
    [ "225415641",[-84.91870864997713, 39.85168395752352]],
    [ "Black Forest Substation",[-104.6814329500504, 38.998120929329815]],
    [ "Flying Horse Substation",[-104.78383216220229, 39.034155995128785]],
    [ "Twin Lakes Substation",[-106.34684191999236, 39.10614763861711]],
    [ "City of New Castle",[-75.58116854886867, 39.65837551893165]],
    [ "Cornell-UP",[-87.22329583886027, 45.90540922520614]],
    [ "225622160",[-104.69289915000002, 39.07046475]],
    [ "Georgia Power",[-84.12416025, 33.05082095]],
    [ "Clear Lake",[-89.64446219236633, 45.853365593851166]],
    [ "225638595",[-96.70701416708448, 34.77025238243149]],
    [ "225638719",[-91.86482433349335, 45.7684040878862]],
    [ "225638792",[-85.40022596197747, 41.799848262860806]],
    [ "Levan Substation",[-83.39457902957598, 42.36992282337926]],
    [ "Evergreen Substation",[-83.23608343689308, 42.38469943779517]],
    [ "Diesel Substation",[-83.27475712810813, 42.378069365669326]],
    [ "Polaris substation",[-83.32635792551176, 42.37609119501381]],
    [ "Yost Substation",[-83.3444130429375, 42.37702241987255]],
    [ "Okemos Substation",[-84.43528795, 42.69038245]],
    [ "Hagadorn Substation",[-84.46460862281089, 42.69034150548212]],
    [ "Jones-Onslow EMC",[-77.43682036343228, 34.516957860970436]],
    [ "Tihart Substation",[-84.38969061010633, 42.731727786346106]],
    [ "Meridian Substation",[-84.4280286, 42.74105665]],
    [ "Red Cedar Substation",[-84.4302923, 42.71208484999999]],
    [ "Grand River Substation",[-84.41725013506574, 42.72740250372029]],
    [ "University Substation",[-84.50351756356646, 42.712071287485934]],
    [ "Spartan Substation",[-84.48643534046509, 42.716782559350385]],
    [ "Oakland Substation",[-83.6810015268882, 42.79420643335932]],
    [ "Cornell Substation",[-84.14447804027041, 42.98193623880931]],
    [ "Owosso Substation",[-84.16479404686596, 42.99103339693886]],
    [ "North Corunna Substation",[-84.12042978207403, 43.011417565675806]],
    [ "Saginaw River Substation",[-83.91452106117818, 43.48560438629516]],
    [ "Laundra Substation",[-84.03005835284331, 43.48805374958918]],
    [ "HSC Substation",[-84.16457805, 43.43943149999999]],
    [ "Orr Road Substation",[-84.16914159737519, 43.43914021079299]],
    [ "Gleaner Substation",[-84.151295, 43.49990925]],
    [ "Geddes Substation",[-84.0762135, 43.4181458]],
    [ "Thayer Substation",[-83.95542145668732, 43.40100995137797]],
    [ "Lawndale Substation",[-84.0113309357668, 43.44871476360578]],
    [ "225859044",[-96.47621950091884, 34.680554465830355]],
    [ "225860813",[-96.6357603013174, 34.79316500556052]],
    [ "Seminole Substation",[-82.7941907267259, 27.82915872690421]],
    [ "Satellite Substation",[-80.60534428628365, 28.17177256750624]],
    [ "Duffield Substation",[-83.91195870000001, 43.02261855000001]],
    [ "Stacey Substation",[-83.80807439503907, 43.017470531166296]],
    [ "Beveridge Creek Substation",[-83.75909353699119, 42.99346094119274]],
    [ "Bennington Substation",[-84.2243917911514, 42.91444920810497]],
    [ "Neff Road Substation",[-83.71787070064251, 43.15048075136306]],
    [ "Tinsman Substation",[-83.6822138578496, 42.81910038306994]],
    [ "Portsmouth Substation",[-83.78753560935515, 43.454785874730206]],
    [ "225989046",[-83.83532820313792, 43.63277148996416]],
    [ "Grey Iron Substation",[-83.92176706454214, 43.45088278348999]],
    [ "Twining Substation",[-83.80536334024396, 44.11266396861869]],
    [ "Alameda Substation",[-83.95651710000001, 43.82056145]],
    [ "Consumers Energy",[-83.9068373385216, 43.464076624740734]],
    [ "Lindbergh Substation",[-85.6598316101379, 42.27726221010713]],
    [ "Drake Road Substation",[-85.6606916, 42.29477445]],
    [ "Consumers Energy",[-85.54545340000001, 42.19989510000001]],
    [ "Sprinkle Substation",[-85.54090012512889, 42.22722811116964]],
    [ "226013491",[-87.65686402492402, 44.082445406632196]],
    [ "226020676",[-91.8796556, 32.8324939]],
    [ "North Bastrop Substation",[-91.90479805570183, 32.798952057519145]],
    [ "226068265",[-92.71226625, 43.47208609999999]],
    [ "Chelsea Electric Department",[-84.03636672945073, 42.29968743124499]],
    [ "226187910",[-92.17741966476785, 44.162422777833086]],
    [ "Pioneer Prairie Phase II Substation",[-92.65204968396678, 43.473043806550315]],
    [ "226247068",[-79.9065032602124, 40.900975974055285]],
    [ "Georgia Power",[-84.36632076834414, 33.791035178919614]],
    [ "Jackson Substation",[-76.8483370672841, 39.941296496944226]],
    [ "Hamilton Substation",[-76.98875679999999, 39.9086741]],
    [ "226332143",[-92.19503635, 44.179393950000005]],
    [ "Consumers Energy",[-85.15835447330564, 42.31529981978033]],
    [ "Aqualinda Substation",[-82.01670991507704, 26.563303123143964]],
    [ "226828098",[-103.69072069779455, 35.158041383844086]],
    [ "227069518",[-84.39946997306416, 38.44003865115029]],
    [ "227069539",[-84.40010505128, 38.43913776701953]],
    [ "227135245",[-77.82873646063634, 35.99439556675511]],
    [ "Stratford Substation",[-102.07069219999998, 36.328469500000004]],
    [ "227715148",[-103.34782591510758, 34.18214263198863]],
    [ "228018569",[-97.11451637239036, 33.62692579157715]],
    [ "228018571",[-97.14397614260521, 33.6357046960086]],
    [ "Beloit Substation",[-98.09695945188446, 39.546137199441645]],
    [ "228140749",[-97.16019312899451, 33.94812488112269]],
    [ "228185402",[-83.13762620587057, 41.3239151663601]],
    [ "Bloom Road Substation",[-83.09525935230441, 41.36130591216814]],
    [ "Freemont Substation",[-83.15093926281483, 41.367534840893434]],
    [ "228195121",[-83.16313425336443, 41.377250184865154]],
    [ "228195126",[-83.16472935450676, 41.37806882673147]],
    [ "Swinks Mill Substation",[-77.19947142469802, 38.950187160133446]],
    [ "228462059",[-92.52888984999998, 42.818796799999994]],
    [ "Corn Belt Power Cooperative",[-92.47678316726739, 42.82604009424127]],
    [ "228462063",[-92.44527128725893, 42.758841375879385]],
    [ "Brusbay Substation",[-87.51896946551814, 44.76836318232669]],
    [ "228615207",[-111.83278439460378, 40.44194488385932]],
    [ "228627894",[-82.5177608, 28.8707764]],
    [ "West Cambridge Substation",[-81.67009738614992, 40.053857913653545]],
    [ "228767017",[-81.71906595283895, 39.99566469705389]],
    [ "228768364",[-77.7931219827331, 36.00018666277751]],
    [ "228842258",[-112.81665515837793, 34.05736770184064]],
    [ "Cedar Valley Substation",[-92.93346562270617, 47.03316051646435]],
    [ "Brandt Substation",[-80.07398578579068, 40.59177093891138]],
    [ "229031769",[-79.9993595011856, 32.86994661098845]],
    [ "WestRock Substation",[-79.96840860930664, 32.89820564335287]],
    [ "229031773",[-79.97412362583789, 32.84531725405863]],
    [ "229031775",[-79.98191862558356, 32.89729295474184]],
    [ "Accabee Substation",[-79.97606298437644, 32.85291915324452]],
    [ "229031778",[-80.02466183988955, 32.98011515394013]],
    [ "229057131",[-80.05057838083904, 33.03090612253653]],
    [ "229057137",[-80.0651101842929, 32.89237471112504]],
    [ "LaCreek Electric Association",[-102.21906126690332, 43.37578167494404]],
    [ "MERRILL HILLS",[-88.32403549307631, 42.995990241321024]],
    [ "Mount Pleasant Substation",[-79.84887928962074, 32.82728355823753]],
    [ "Cainhoy Substation",[-79.84227560472925, 32.941401991963744]],
    [ "Hobcaw Substation",[-79.8752593195542, 32.842980678201464]],
    [ "Hamlin Substation",[-79.78846004707245, 32.859929320474706]],
    [ "229118266",[-83.95473671435066, 40.27043505407018]],
    [ "229132881",[-84.87447415494923, 39.872852984590985]],
    [ "229190481",[-97.94320739999999, 36.41220584999999]],
    [ "229240191",[-79.35112226768914, 33.296887546593396]],
    [ "Maryville Substation",[-79.29798385000001, 33.34775439999999]],
    [ "229240193",[-79.33085118079616, 33.39551127381885]],
    [ "229240194",[-79.34256279523115, 33.332303640503405]],
    [ "229240196",[-79.3474240031049, 33.2928905155337]],
    [ "Beckett Substation",[-75.35060090535673, 39.743953407050284]],
    [ "229353713",[-83.20129118853984, 42.3150999478381]],
    [ "Wharncliffe Switching Station",[-81.94176248145911, 37.559843345917045]],
    [ "Honeywell Substation",[-94.55594987056287, 38.865611060159175]],
    [ "Crawford Substation",[-87.726355871025, 41.82717639922757]],
    [ "Crawford 138kV-345kV Substation",[-87.72693706410035, 41.82918909745732]],
    [ "Fairplay Substation",[-105.98955448818018, 39.22087409487439]],
    [ "Claremont Substation",[-104.67096845820917, 38.85782545529803]],
    [ "Quartzsite Substation",[-114.21754472922596, 33.68203793124354]],
    [ "Scalp Level Substation",[-78.8638763933901, 40.23383234734538]],
    [ "229615351",[-113.63511810804168, 33.60062375843437]],
    [ "229616854",[-113.12770855000001, 33.52232005]],
    [ "229626310",[-77.8174633389286, 36.04926577333167]],
    [ "Deforest",[-89.34109503903792, 43.25308618400252]],
    [ "Hartford Substation",[-83.4486012051716, 32.281001930758755]],
    [ "229781402",[-104.65395168493447, 37.132394030876554]],
    [ "229783146",[-104.8340574343481, 37.13522594458739]],
    [ "229783201",[-87.6138486996263, 44.668486265651076]],
    [ "Marion Substation",[-83.58607089282141, 41.05903169836089]],
    [ "Colorado Springs Utilities",[-104.78838753783081, 38.76706288447917]],
    [ "229907786",[-87.79066274519892, 44.63247187277864]],
    [ "Birch Avenue Station",[-73.72050446331097, 43.41301514515955]],
    [ "Bradley Substation",[-104.76247283332698, 38.7558842226067]],
    [ "Fountain Substation",[-104.7223628782307, 38.70892566975492]],
    [ "CDF Fountain North Substation",[-104.70474402132932, 38.706209836570544]],
    [ "Pine Bend Substation",[-93.0330877879597, 44.76082845251834]],
    [ "Koch Substation",[-93.03634036380564, 44.76541867274303]],
    [ "Honcut Substation",[-121.59533082036695, 39.32056755097887]],
    [ "Findlay Substation",[-83.65544375945223, 41.038555957498964]],
    [ "230171778",[-108.65379908652835, 39.117226776675466]],
    [ "Xcel Energy",[-108.58085562700043, 39.09851365446653]],
    [ "Dewalt Substation",[-95.56372340721204, 29.604513202330583]],
    [ "230264959",[-81.92783862028321, 35.72193262984316]],
    [ "230277862",[-82.13151087502841, 27.503615404621755]],
    [ "Keentown Substation",[-82.12965465, 27.51527455]],
    [ "Whidden Substation",[-81.80905317488781, 27.224525406186196]],
    [ "Florida Power & Light",[-81.81050351603061, 27.151344972123987]],
    [ "Florida Power & Light",[-81.95099790000002, 27.0442781]],
    [ "230300564",[-108.56362894609073, 39.06263293619253]],
    [ "Pine substation",[-80.04691680264132, 40.65101645430822]],
    [ "230381777",[-107.87656755512735, 37.948619799164234]],
    [ "East Krok",[-87.57268652004157, 44.42862242331085]],
    [ "Georgia Power",[-84.64558904739405, 33.50405933377134]],
    [ "Mobley Bridge Road Substation",[-84.93794713205519, 33.16511609882085]],
    [ "Georgia Power",[-85.05322439999999, 32.982799449999995]],
    [ "Kia Substation",[-85.12402215000002, 32.9198144]],
    [ "230515952",[-85.12500535000001, 32.93090110000001]],
    [ "Georgia Power",[-85.04337491684898, 32.993469251066635]],
    [ "Georgia Power",[-85.00579069739541, 33.03992041787707]],
    [ "230516932",[-85.16318100900126, 32.87033164047921]],
    [ "230521602",[-85.05383629999999, 33.01979804999999]],
    [ "Georgia Power",[-85.04342286349862, 33.01249384621104]],
    [ "Collier Substation",[-81.75312227452022, 26.175750590265373]],
    [ "Golden Gate Substation",[-81.68806107443692, 26.20260120611893]],
    [ "Livingston Substation",[-81.75183940000001, 26.176178800000002]],
    [ "Vanderbilt Substation",[-81.7563696352381, 26.274069690083873]],
    [ "Rattlesnake Substation",[-81.68220138185518, 26.113058864807147]],
    [ "Alligator Substation",[-81.7430167440057, 26.14046320829365]],
    [ "Belle Meade Substation",[-81.70386272479215, 26.035976105672432]],
    [ "Capri Substation",[-81.70142739100282, 26.036803993741195]],
    [ "Alabama Power",[-85.37918036498478, 32.93715578199032]],
    [ "230567499",[-85.51437795000001, 32.663499800000004]],
    [ "230568058",[-85.48046639999998, 32.662685749999994]],
    [ "230569016",[-85.39004614447076, 32.878994396134566]],
    [ "230569791",[-85.35715464848293, 33.11356549155748]],
    [ "230570446",[-85.31048735612691, 33.160797455835414]],
    [ "Franklin Substation",[-85.08324955479316, 33.26657327798822]],
    [ "230573495",[-85.35708039041067, 33.132251122433345]],
    [ "Puget Sound Energy",[-122.86724985555959, 47.0342071581715]],
    [ "Princeton Substation",[-80.40366864340372, 25.537296619368515]],
    [ "Florida Power & Light",[-80.3727723757494, 25.872268061171866]],
    [ "Florida Power & Light",[-80.37030558804659, 25.7929962696663]],
    [ "Pennsuco Substation",[-80.37188393381395, 25.872296231055053]],
    [ "Bertram Substation",[-98.05376724999999, 30.75487865]],
    [ "Floresville Substation",[-98.15423615086694, 29.14118030089777]],
    [ "Silverlakes Substation",[-80.40870136442928, 25.992337722837593]],
    [ "Brevard Substation",[-80.79490270477204, 28.368973425159716]],
    [ "Florida Power & Light",[-80.56338059999999, 27.763737749999997]],
    [ "Brevard Substation",[-80.79374279999999, 28.368761149999997]],
    [ "Viera Substation",[-80.75577660790114, 28.251205575035108]],
    [ "Sarno Substation",[-80.70354863071535, 28.128438033606358]],
    [ "Florida Power & Light",[-80.45082763129265, 27.44461583183173]],
    [ "Oleander Plant Substation SPC",[-80.79476037997227, 28.366817512369504]],
    [ "Mira Sorrento Substation",[-117.20596203280243, 32.89270243651064]],
    [ "Warrendale Substation",[-80.09336456477205, 40.64998761414006]],
    [ "230819142",[-87.92692085473165, 44.476608356841325]],
    [ "Highway V",[-87.97769179207327, 44.47770025760504]],
    [ "Southwick Substation",[-122.80675088503664, 46.99581427499886]],
    [ "Crestwood Substation",[-83.61768250608407, 41.06175174638707]],
    [ "Tower Dr",[-87.9970297239963, 44.531179084185666]],
    [ "DANZ AVE SW STA",[-87.96781674102273, 44.52065582828385]],
    [ "Preble",[-87.97015402021984, 44.505704858895974]],
    [ "Henry St",[-87.97744628536573, 44.5062908415462]],
    [ "Lake Pauline Substation",[-99.68474833876284, 34.252268657417396]],
    [ "Eastman",[-88.00037996500429, 44.52045293266857]],
    [ "Finger Rd SW STA",[-87.97144910794941, 44.488674981756674]],
    [ "Mystery Hills",[-88.0205315993261, 44.4352593385579]],
    [ "BLUESTONE",[-87.96891084907395, 44.4656363152263]],
    [ "Brush Creek/Epworth Substation",[-80.09495951916837, 40.68007190789364]],
    [ "231139810",[-122.6900353, 48.500528700000004]],
    [ "231199184",[-119.73478685450176, 36.764261120272124]],
    [ "ROCKLAND",[-88.06690756832882, 44.401560034041545]],
    [ "231320240",[-94.93150017418456, 40.30854256032819]],
    [ "231342214",[-82.780907476149, 35.34598948999514]],
    [ "231360059",[-92.794032905701, 44.74489687978122]],
    [ "Akwesasne Station",[-74.72451498750495, 44.97381007620381]],
    [ "231371142",[-74.7304564645951, 44.98714610562386]],
    [ "AEP Ohio",[-83.65655513815153, 41.02278774412461]],
    [ "231404598",[-108.17657667680771, 43.41716171810215]],
    [ "Pacific Gas and Electric",[-121.96751283536538, 37.78213354681271]],
    [ "231455133",[-111.41651400000002, 32.81663485]],
    [ "231489810",[-104.49181696252317, 38.2765401392271]],
    [ "231507000",[-122.11455798483938, 37.42346890172704]],
    [ "231507432",[-91.5410979251307, 39.9182172907991]],
    [ "Valley Substation",[-80.29648503320648, 40.71742632206599]],
    [ "Penn Power",[-80.09930101588115, 40.58975809051562]],
    [ "Eastgate Substation",[-87.17469364952635, 30.478107682651046]],
    [ "Hartsel Substation",[-105.86527025267677, 39.077182419594436]],
    [ "Trojan Substation",[-103.83322263241422, 44.351714747377905]],
    [ "231654220",[-85.06015185, 38.73529685]],
    [ "231654936",[-85.07866733526197, 38.719713346483736]],
    [ "231655438",[-85.10056053598127, 38.70587666876203]],
    [ "231655440",[-85.10921820143294, 38.698297616921224]],
    [ "231655483",[-85.10579776291748, 38.70370756940143]],
    [ "231655494",[-85.0958724, 38.709564349999994]],
    [ "Blumaer Substation",[-122.85178625, 46.860028150000005]],
    [ "Wesmark",[-87.89644380728413, 44.34295476441488]],
    [ "231707866",[-79.0177828217614, 35.94385577552326]],
    [ "Riverside Substation",[-112.09010415837717, 33.39560504760931]],
    [ "Hedrick Substation",[-110.93983664923472, 32.263328644020476]],
    [ "Greenleaf",[-88.08663554999998, 44.340281]],
    [ "231829853",[-86.20217006933532, 39.919931343588715]],
    [ "231837735",[-87.57327026253046, 44.24093441658561]],
    [ "231933310",[-112.0658821365408, 32.99951471238188]],
    [ "Pebble Creek Substation",[-112.39181046827485, 33.4786692527131]],
    [ "Queensbridge Substation",[-73.93823062272315, 40.756290769023174]],
    [ "Merrifield Substation",[-77.26294742635689, 38.87305710534874]],
    [ "Yampa Substation",[-104.83006936352214, 38.847690492088084]],
    [ "Bulk Mail Fac Substation",[-80.11078663895348, 40.66351688007571]],
    [ "Arizona Public Service",[-111.53173921578852, 32.80762490801076]],
    [ "Franconia Substation",[-77.19378449311003, 38.739092342658985]],
    [ "Mountain Substation",[-110.9527483700803, 32.271044751106984]],
    [ "Camp Gary Substation",[-97.8663747951435, 29.881301548144133]],
    [ "Reedville Substation",[-97.85135582111432, 29.875407801243085]],
    [ "Beback Substation",[-97.95559320409289, 29.79709953634791]],
    [ "Colorado Springs Utilities",[-104.84959668396115, 38.889076546978984]],
    [ "Brandon Substation",[-95.60464422770681, 45.961678052971926]],
    [ "Hudson Substation",[-95.28581577535257, 45.83711820671861]],
    [ "232650975",[-96.96767194214522, 34.52420413224928]],
    [ "232656616",[-112.25379218262832, 33.39272312393183]],
    [ "232835638",[-93.26660400000257, 45.171542599564035]],
    [ "232842713",[-116.46420983642263, 43.694128874930264]],
    [ "232842714",[-116.34991564039738, 43.69481338199695]],
    [ "Lodi Industrial Park",[-89.54619727230141, 43.326911300027064]],
    [ "Mason Public Utility District #3",[-123.09817320414163, 47.134732365503794]],
    [ "233062771",[-110.32479297231136, 34.49924655125046]],
    [ "Landmark Substation",[-83.59606749470164, 41.06924812524323]],
    [ "Little Falls Substation",[-94.25017039588298, 45.969968667249695]],
    [ "Prosper Substation",[-96.88336345, 46.9636223]],
    [ "Carrollton Substation",[-85.17287535, 38.6679086]],
    [ "Atmel Substation",[-104.80457722586553, 38.79146223103235]],
    [ "Coffee Creek Substation",[-122.78154190000001, 45.3417574]],
    [ "Coyote Substation",[-106.17840199999999, 31.81340555]],
    [ "Dunlavy Substation",[-95.40185493562157, 29.752642622734236]],
    [ "233647392",[-94.54847588853953, 36.00150478147419]],
    [ "233647393",[-94.78057777358207, 35.9004348429532]],
    [ "233647394",[-94.64786453390282, 35.81940973521435]],
    [ "233647396",[-94.58434285461854, 36.04651404979369]],
    [ "233647398",[-94.65472195245614, 36.08517402801796]],
    [ "233647399",[-94.62676377033065, 35.81281279433902]],
    [ "233696715",[-112.22906205846003, 33.44725941085497]],
    [ "233743733",[-94.56361851172205, 36.16311128688293]],
    [ "233757370",[-94.65224653734748, 35.74372452503207]],
    [ "Yampa Valley Electric",[-106.8604876667364, 40.520100700087184]],
    [ "Puget Sound Energy",[-122.92402738553238, 47.0330271453966]],
    [ "Ivanpah Substation",[-115.46875204626654, 35.5444447223039]],
    [ "Tavernier Substation",[-80.52090985045754, 25.00648574054786]],
    [ "234007732",[-83.61445088538301, 41.02102434715763]],
    [ "Puget Sound Energy",[-122.87041700302304, 47.06924940918593]],
    [ "234076339",[-85.89284095436516, 39.956684570823384]],
    [ "234110798",[-114.32781032899304, 43.66836762223287]],
    [ "Indianapolis Power & Light",[-86.04844787978976, 39.82854563296422]],
    [ "Midway Switching Station",[-88.83850567299878, 33.09660433787882]],
    [ "234342225",[-123.9489037217206, 47.19431350878153]],
    [ "Cellasto Substation",[-84.97377021415245, 42.26849391858834]],
    [ "Ethanol Substation",[-84.78937521937613, 42.25758498848799]],
    [ "Public Service Company of Oklahoma",[-95.78324263988937, 36.06805792185283]],
    [ "Public Service Company of Oklahoma",[-95.71090102517978, 36.06142444337738]],
    [ "Public Service Company of Oklahoma",[-95.78911607609821, 36.10498943360262]],
    [ "Public Service Company of Oklahoma",[-95.83494957343012, 36.11138869409546]],
    [ "Georgia Power",[-84.40699417685829, 33.788117750698525]],
    [ "234738027",[-114.35849139458314, 43.685179620172626]],
    [ "234852455",[-116.19721800935116, 43.61113170576757]],
    [ "234856354",[-115.03457805, 36.108570949999994]],
    [ "Burr Ridge Substation",[-87.93090395951056, 41.759716003101666]],
    [ "234947437",[-92.16981665, 44.13035455]],
    [ "Genoa Substation",[-91.23043501471659, 43.561427778784136]],
    [ "234969376",[-93.44619264280654, 44.22545835013298]],
    [ "234973509",[-93.34297537484812, 44.226006646196716]],
    [ "Lansing Substation",[-91.16786550828546, 43.335680468671036]],
    [ "Waukon Substation",[-91.48757294536995, 43.27875103627809]],
    [ "235017795",[-86.13385246119726, 39.7655109510064]],
    [ "Monona Substation",[-91.40444554494908, 43.06100424693253]],
    [ "235063374",[-93.56673375000001, 44.21517625]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.8877208, 37.71509255]],
    [ "Elizabethtown Substation",[-85.88714021529742, 37.715491636205634]],
    [ "235192502",[-78.93776573432886, 35.99687605438084]],
    [ "235377934",[-112.47291636847062, 34.52954241725815]],
    [ "Nantly-Glo Substation",[-78.83154900433529, 40.47226574441586]],
    [ "235553056",[-93.30456105000002, 44.37113300000001]],
    [ "235740897",[-90.21084276895633, 33.52446930492072]],
    [ "Gadsden Substation",[-85.97325269892946, 34.013971586831566]],
    [ "City of Radford",[-80.53765699023691, 37.145503692796375]],
    [ "City of Radford",[-80.53024594029792, 37.123232809121745]],
    [ "Arcadia Substation",[-110.88864475168126, 32.22918336739787]],
    [ "Bucksnort Substation",[-96.81630998085129, 43.4672756375924]],
    [ "Louise Substation",[-96.76632468404317, 43.46856214527242]],
    [ "Lincoln County Substation",[-96.7088665982444, 43.468444638881984]],
    [ "236106777",[-88.36904772563396, 44.528951094040536]],
    [ "236130427",[-74.59323590226579, 41.4572331134651]],
    [ "Sherwood",[-87.74307045769693, 45.04838201631294]],
    [ "236155906",[-96.69130696978887, 40.81279162066821]],
    [ "236164298",[-83.75829085808206, 40.38206533724718]],
    [ "Sioux Falls Substation",[-96.79783562523292, 43.490430644617604]],
    [ "236174821",[-96.82693370126165, 43.41781900587245]],
    [ "Cherry Creek Substation",[-96.8148900249366, 43.53595959523343]],
    [ "236308134",[-88.23542060392225, 40.131465813398655]],
    [ "236340055",[-80.02437190745856, 36.05584173423122]],
    [ "236340058",[-79.94175168293486, 36.064389956866926]],
    [ "236340192",[-80.07132649387636, 35.980089985636525]],
    [ "236340197",[-80.22490842505891, 36.03455339178787]],
    [ "236340203",[-80.22597400000001, 36.03244055]],
    [ "Colonial Substation",[-79.93759795000001, 36.0714171]],
    [ "236340210",[-80.02755742996659, 35.95035750848995]],
    [ "236340211",[-80.23183500507099, 36.020039969204475]],
    [ "236340213",[-80.22530945820105, 36.07655192996053]],
    [ "236340218",[-80.0154813, 35.9452327]],
    [ "236340221",[-79.9151719820033, 36.07012283395546]],
    [ "236340227",[-80.21218015660891, 36.087310727781784]],
    [ "236340231",[-79.94362720000001, 36.06102954999999]],
    [ "236340232",[-80.22190047494065, 36.02848079243414]],
    [ "236340241",[-79.98255379886646, 36.054792154333484]],
    [ "236340243",[-80.22695150315708, 36.12542636907262]],
    [ "236340245",[-79.92518254612916, 35.996220496758596]],
    [ "236340259",[-80.2300322558998, 36.05372417499837]],
    [ "PowerSouth Energy Cooperative",[-87.54799341177176, 30.37052662518173]],
    [ "Elsanor Substation",[-87.581127211615, 30.56014702468459]],
    [ "Brady Substation",[-81.32635145706801, 41.15231036852635]],
    [ "236357099",[-79.98428447475452, 36.105239993967146]],
    [ "236357147",[-79.96076852367023, 36.1383826929583]],
    [ "236357148",[-80.18209415000001, 36.054309249999996]],
    [ "236357149",[-80.03031302947824, 36.12550840611394]],
    [ "236357152",[-80.04190579371996, 36.14610648011329]],
    [ "236357153",[-79.89483251815919, 36.138877545863465]],
    [ "236357154",[-79.95140736455426, 36.200224221843854]],
    [ "236357155",[-80.16409910395689, 36.0693918497482]],
    [ "Transcontinental Gas Pipeline Company",[-79.9694101569606, 36.21402479540163]],
    [ "236357157",[-80.10366134228111, 36.10521150926188]],
    [ "236357158",[-80.06103496799942, 36.11477940783355]],
    [ "Duke Energy",[-84.15399256026556, 39.18643894600888]],
    [ "236510457",[-96.95991428918099, 43.37344555514376]],
    [ "Fullerton Substation",[-117.92128877032415, 33.86810529076367]],
    [ "236661453",[-77.87762480399978, 34.330100368032944]],
    [ "236661455",[-76.65559029464416, 34.717577667534975]],
    [ "College Lake Substation",[-105.14428463106056, 40.582317200060004]],
    [ "236739194",[-87.79328426479685, 30.88183985604896]],
    [ "236739198",[-87.86252946299795, 30.837134863136573]],
    [ "236739199",[-87.8011400390188, 30.84574392986016]],
    [ "West Sioux Falls Substation",[-96.76024256239201, 43.54687716237285]],
    [ "236798871",[-76.85178807727686, 34.77444188806412]],
    [ "Perditio Substation",[-87.62019505, 31.02677475]],
    [ "236798974",[-87.48421002021098, 31.002174251845993]],
    [ "Oak Grove Switching Station",[-87.45412815558169, 30.92331426771891]],
    [ "Atmore Switching Station",[-87.5419561252913, 30.999590155101913]],
    [ "Freemanville Substation",[-87.51657589999999, 31.069621749999996]],
    [ "Vega Substation",[-97.8682554285809, 30.242253395329286]],
    [ "Mio Dam Substation",[-84.13096728969855, 44.66234088172441]],
    [ "Whittemore Substation",[-83.75575582056044, 44.27592638348836]],
    [ "Iosco Substation",[-83.51914244236255, 44.446129131053205]],
    [ "Loud Dam Substation",[-83.72150635215431, 44.46261265868078]],
    [ "East Tawas Substation",[-83.50617166658316, 44.27967618986342]],
    [ "Abajo Substation",[-109.54832513435144, 37.304198323412194]],
    [ "236944661",[-76.90929656179746, 34.91710268760518]],
    [ "Burnside Substation",[-92.59672596791124, 44.5758208523794]],
    [ "236994470",[-77.08315564447155, 35.097242311162695]],
    [ "Voice of America Substation",[-77.19972520241116, 35.46822424814624]],
    [ "236994474",[-77.1105666710444, 35.13667031235068]],
    [ "237045341",[-77.66497251683644, 35.392841369994876]],
    [ "237045342",[-77.46337079301672, 35.36625640942631]],
    [ "237045343",[-77.46416520000001, 35.36579295]],
    [ "237045344",[-77.66494525, 35.393373849999996]],
    [ "237045345",[-77.73060709492474, 35.41748381660444]],
    [ "West Brandon Substation",[-96.59470352742146, 43.59426740240919]],
    [ "Brandon Substation",[-96.5729165352605, 43.60150007491014]],
    [ "237101553",[-78.63231918389558, 35.76903807824417]],
    [ "237101563",[-78.41558139775654, 35.61279235379834]],
    [ "237101570",[-78.5984139661512, 35.76448037262217]],
    [ "237104426",[-98.00159547319848, 41.06686384029599]],
    [ "237105828",[-78.1760375357323, 35.87862759812059]],
    [ "237105829",[-78.28855839296989, 35.79503007907434]],
    [ "237105832",[-78.08724133792397, 35.9595023962422]],
    [ "237119380",[-78.0994601, 35.95322255000001]],
    [ "West Canton Substation",[-81.42536548807989, 40.8400869710129]],
    [ "South Sioux Falls Substation",[-96.73418367960629, 43.52176538217519]],
    [ "237170254",[-98.31427295791447, 40.5804057262358]],
    [ "South Athens Substation",[-83.39210490045446, 33.93179125044295]],
    [ "237172577",[-78.63375235993841, 35.721352275498454]],
    [ "237172579",[-78.67832798245784, 35.77553364598688]],
    [ "237172581",[-78.60577209785612, 35.70059316935493]],
    [ "237172582",[-78.56998763089427, 35.68800459215681]],
    [ "237172584",[-78.6454375902105, 35.758668581887655]],
    [ "237172587",[-78.68183713343616, 35.78877228179223]],
    [ "237195161",[-96.50619333504248, 43.491374718062296]],
    [ "Split Rock Substation",[-96.62999369951842, 43.538074977284204]],
    [ "237205027",[-96.6297433045202, 43.51997050009616]],
    [ "Jersey Central Power and Light",[-74.6718434807544, 40.90935934249303]],
    [ "Chambers Substation",[-122.86334183732433, 47.003334874742734]],
    [ "Distribution Substation",[-122.75495845506751, 47.003562165862256]],
    [ "237465920",[-78.7037684, 35.80130595]],
    [ "Morrell Substation",[-96.72338390000002, 43.56534824999999]],
    [ "Algonquin Substation",[-96.72868418077819, 43.569137603283416]],
    [ "237522654",[-87.87961476078353, 34.74161927519391]],
    [ "Annandale Substation",[-77.16925849500771, 38.82338698263408]],
    [ "Center Substation",[-86.16594022324843, 39.74911248527553]],
    [ "Redwood Substation",[-85.63707409213782, 30.159017615311207]],
    [ "Cliff Avenue (CLF) Substation",[-96.71172382492698, 43.53868809540452]],
    [ "SRP Baseline Substation",[-111.69144864947323, 33.365527512720405]],
    [ "Villa Tasso Substation",[-86.36840367162854, 30.467616445322836]],
    [ "Black Creek Substation",[-86.0837968748539, 30.46050115621733]],
    [ "Eastern Lake Substation",[-86.08772034026963, 30.31222713913575]],
    [ "238260964",[-86.01550604751338, 30.291025133118485]],
    [ "Columbus St",[-87.59052545762735, 44.15302307455779]],
    [ "Shoto",[-87.62529033142506, 44.15393176222583]],
    [ "238364684",[-86.69655690420255, 31.640431225407923]],
    [ "238364686",[-86.72985214437395, 31.654279267345714]],
    [ "City of Lakeland",[-81.98110926525753, 28.072821798663828]],
    [ "238457781",[-87.65720970830719, 44.119429526240786]],
    [ "Falmouth Substation",[-70.61141238325888, 41.56374486036951]],
    [ "Oak Street Substation",[-70.34985374548589, 41.68709809755785]],
    [ "Secrec Substation",[-72.03347278338198, 41.48899109973953]],
    [ "Falmouth Tap Substation",[-70.58780112034323, 41.630516254590006]],
    [ "Harwich Substation",[-70.10068847022018, 41.68706980318984]],
    [ "Tenth Street Substation",[-72.05244909341143, 41.5366429046109]],
    [ "Hatchville Substation",[-70.55429861391953, 41.61833300121628]],
    [ "Duxbury Substation",[-70.72265331673923, 42.05388346661239]],
    [ "Orleans Substation",[-69.99905912297599, 41.7803292410335]],
    [ "Lothrop Avenue Substation",[-70.10070071351383, 41.68758501533892]],
    [ "Barnstable Switching Station",[-70.28462246014078, 41.6860528973371]],
    [ "Lothrop Avenue Substation",[-70.10101030597048, 41.68822274090853]],
    [ "Hyannis Junction Substation",[-70.28123010983367, 41.67350130870156]],
    [ "Mashpee Substation",[-70.47258226553836, 41.626380288216595]],
    [ "Hudson East/East Side Substation",[-81.41036029183174, 41.25347326108364]],
    [ "238535131",[-96.55050012491013, 43.54417050570718]],
    [ "Sanford Substation",[-70.73465836401955, 43.42910113332734]],
    [ "Bigelow Substation",[-70.35366450000001, 45.101627349999994]],
    [ "Mussey Road Substation",[-70.33008866393158, 43.62111196605583]],
    [ "West Buxton Substation",[-70.5965556303181, 43.665936800370204]],
    [ "Red Brook Substation",[-70.33940910206117, 43.63120733182779]],
    [ "Kibby Wind Farm Substation",[-70.54154105093409, 45.35533976484538]],
    [ "Pleasant Hill Substation",[-70.29400080149976, 43.5983530144338]],
    [ "Sturtevant Substation",[-70.12749497869986, 44.655003780046435]],
    [ "238681413",[-96.65302275870303, 43.416605772220315]],
    [ "Stony Brook Substation",[-72.50833968532146, 42.19795504948497]],
    [ "Oswald Substation",[-73.28762577567298, 42.43727476248972]],
    [ "Amherst Substation",[-72.50699789679265, 42.373616292395155]],
    [ "Dilworth Substation",[-96.6943923056813, 46.89158387502512]],
    [ "238910538",[-96.58832617164491, 43.31505684040751]],
    [ "238910542",[-96.62833939999999, 43.303085800000005]],
    [ "Belleair Substation",[-82.7869621, 27.933841849999997]],
    [ "239025358",[-96.87020877329435, 43.57613174969098]],
    [ "239030727",[-96.8303333, 43.607829149999986]],
    [ "Blandford Substation",[-72.965428085123, 42.20031302200616]],
    [ "Harriman 115kV Substation",[-72.93025169525778, 42.758091076039584]],
    [ "Lower Deerfield Substation",[-72.73622907759376, 42.6205291552599]],
    [ "EPRI Substation",[-73.23566337635768, 42.40237496758382]],
    [ "Woodland Substation",[-73.23490359558419, 42.336235668869406]],
    [ "239076868",[-73.0501907, 43.17185025]],
    [ "Maywood Substation",[-86.21066935743329, 39.736275758053004]],
    [ "Flying Hills Substation",[-75.92506973960877, 40.27910354336707]],
    [ "239137902",[-122.35156591506292, 48.24356654448653]],
    [ "239139099",[-122.45382958440636, 48.243285633407254]],
    [ "239139731",[-122.47784695, 48.16212735]],
    [ "Promway Substation",[-81.42634771243175, 40.87538958120412]],
    [ "239207432",[-106.4647317248123, 35.38573882691824]],
    [ "239265210",[-78.74112699778408, 35.7783979605585]],
    [ "Ameren",[-89.4887307593685, 40.60246357229394]],
    [ "Spring Substation",[-76.02078416720174, 40.32226040837323]],
    [ "Croton Substation",[-85.66605411220823, 43.43791413021124]],
    [ "239383338",[-96.23356737505483, 43.558598553655074]],
    [ "Kellnersville",[-87.81766106627205, 44.22588362530837]],
    [ "Bowling Green Substation",[-86.44628078680994, 37.01433762875415]],
    [ "Puget Sound Energy",[-122.84406276543665, 47.04208244827181]],
    [ "Fair Oaks Ranch Substation",[-98.61239079193886, 29.732803621787536]],
    [ "239692740",[-96.09238279523295, 43.68181327502959]],
    [ "239699756",[-96.39180972394097, 43.638605588060365]],
    [ "239699767",[-96.39028656180294, 43.638312615134645]],
    [ "239712091",[-96.22259172738646, 43.649652084295354]],
    [ "Northville Station",[-74.18788941286729, 43.228369018965964]],
    [ "Mayfield Station",[-74.26712769398367, 43.10782007720744]],
    [ "239882192",[-77.92666095, 38.6516369]],
    [ "Elk Run Substation",[-77.70970174346051, 38.55633532125715]],
    [ "Ni River Substation",[-77.586165740271, 38.24325104387589]],
    [ "239953801",[-123.10655290000001, 48.074402600000006]],
    [ "240078195",[-123.06739706989796, 48.069154124472796]],
    [ "Georgetown East Substation",[-97.64489074504903, 30.62372347922275]],
    [ "Puget Sound Energy",[-122.63152846295655, 47.570529321506434]],
    [ "Puget Sound Energy",[-122.66056130000003, 47.56954600000001]],
    [ "240081428",[-75.93160163847706, 42.13269909506195]],
    [ "Puget Sound Energy",[-122.6503561055649, 47.61345612897301]],
    [ "Westbrook Substation",[-112.25858694216832, 33.66688084947838]],
    [ "240358595",[-84.59462946477677, 38.684212477563456]],
    [ "West Substation",[-95.60918434256476, 43.63348443329451]],
    [ "Las Pulgas Substation",[-122.22786523783667, 37.46289476183648]],
    [ "Stark Substation",[-83.37255773195682, 42.383516805100044]],
    [ "Puget Sound Energy",[-122.89354212575753, 47.03397715988087]],
    [ "Springer",[-104.59670389510634, 36.39768125720092]],
    [ "Lexington Electric System",[-88.38725396537933, 35.644226796948104]],
    [ "Puget Sound Energy",[-122.62919493627885, 47.52953586897239]],
    [ "240983807",[-122.11519715880684, 47.768367624882515]],
    [ "Faber Substation",[-122.6535900012753, 48.302982753002546]],
    [ "241064590",[-122.67235486496864, 48.28379837108182]],
    [ "Manrap",[-87.7015305966666, 44.10180657846244]],
    [ "Revere Dr",[-87.67256075426013, 44.09712407017132]],
    [ "Puget Sound Energy",[-122.89925846981893, 47.04790365096077]],
    [ "Pipestone Substation",[-96.28466051302622, 44.00827918089216]],
    [ "Holland Substation",[-96.28600032706166, 44.109931062543744]],
    [ "Itasca Substation",[-95.18792312956676, 47.30416474249521]],
    [ "241335703",[-95.22416653609368, 47.38398050691781]],
    [ "South Substation",[-97.06952817246837, 47.52667949994442]],
    [ "241405136",[-96.4270736, 43.98060645]],
    [ "241405151",[-96.4276818, 43.98057635]],
    [ "241410579",[-122.65039677034966, 48.5067121360779]],
    [ "ComEd Rockwell 138kV Substation",[-87.69218157116457, 41.89187700250424]],
    [ "LADWP Distributing Station No. 122",[-118.47948825936729, 34.12974179345357]],
    [ "Southeast Substation",[-96.75130439813643, 46.84629830720374]],
    [ "241539392",[-97.05099031304904, 36.132320142515624]],
    [ "241686309",[-86.45108698785909, 33.64740218695354]],
    [ "241741110",[-122.33111993372813, 48.476558362711145]],
    [ "241741119",[-122.33284584601569, 48.460505327433474]],
    [ "241745355",[-95.71669090079934, 43.71196283922143]],
    [ "Nobles County Substation",[-95.71958360698238, 43.71185557508987]],
    [ "Sandwich Substation",[-70.46635157751084, 41.717470249727306]],
    [ "241789611",[-96.60897589358774, 45.223396977160434]],
    [ "Woodrow Substation",[-74.215258020864, 40.55476547193599]],
    [ "Plymouth Substation",[-93.45433878135226, 45.04613229344034]],
    [ "241884327",[-122.24173897495139, 48.504809905254234]],
    [ "Brewster Substation",[-95.45267844120019, 43.70914933054446]],
    [ "Elk Substation",[-95.59250980003425, 43.71045626881908]],
    [ "Acoma Substation",[-111.92774467963302, 33.61831544312787]],
    [ "Poway Substation",[-117.03132198430565, 32.97870495469767]],
    [ "Garfield Substation",[-116.99679938117582, 32.795268246900896]],
    [ "Evergreen Substation",[-86.93587169065503, 31.4244409011368]],
    [ "Puget Sound Energy",[-122.63094802420589, 47.698060778826644]],
    [ "Drafter",[-84.40236138003782, 46.3739203186355]],
    [ "Southeast Substation",[-95.75503510000001, 44.448391400000006]],
    [ "St Nazianz",[-87.92172484999999, 44.03665185]],
    [ "Pulliam SW YD",[-88.00997302074644, 44.540623943046505]],
    [ "Malone Station",[-74.29240063663308, 44.82912153177595]],
    [ "242628268",[-73.48235246106476, 44.78831522489464]],
    [ "Fiesta City Substation",[-95.70735054999999, 44.952393449999995]],
    [ "Brookings Muncipal Utilities",[-96.7490599661057, 44.31859212509594]],
    [ "Brookings Municipal Utilities",[-96.78783277481438, 44.28056579718875]],
    [ "242745821",[-78.88259631858558, 38.41225909604258]],
    [ "BARC Electric Cooperative",[-79.62706346894142, 38.01241622413971]],
    [ "Goshen Substation",[-79.5092804428627, 37.96831058137105]],
    [ "East Hazleton Substation",[-75.94321353199877, 40.94004358972126]],
    [ "Sunnyview Substation",[-96.77953427535444, 44.3555259976228]],
    [ "242767764",[-96.6471208, 44.3549546]],
    [ "Brookings Substation",[-96.78623103906608, 44.36233378177426]],
    [ "Brookings Substation",[-96.78927302551067, 44.32830252179837]],
    [ "3M Substation",[-96.76457455, 44.29922625]],
    [ "Brookings Municipal Utilities",[-96.79475317221804, 44.305596197908876]],
    [ "West Substation",[-96.80826960804535, 44.31031073826577]],
    [ "Banyan Substation",[-80.06313762535532, 26.719090044636356]],
    [ "242866233",[-86.38520447272971, 39.71369191108024]],
    [ "242884367",[-85.62838171676204, 41.995957022165705]],
    [ "Todds Tavern Substation",[-77.66585913468114, 38.247863598206564]],
    [ "Wilderness Substation",[-77.7567626838431, 38.35442679405988]],
    [ "CPC Locust Grove Substation",[-77.86270737257085, 38.28887114860038]],
    [ "242897521",[-87.42183744351209, 46.575810730173195]],
    [ "NEW HOLSTEIN SW STA",[-88.08955807242386, 43.955770072521275]],
    [ "Velp Ave",[-88.04944804004506, 44.54815937395567]],
    [ "Howard",[-88.07069872004767, 44.54957989338942]],
    [ "James St",[-88.01466180000001, 44.524185100000004]],
    [ "243115686",[-96.82914665, 44.2543403]],
    [ "Scripps Substation",[-117.11263045709775, 32.911112720538405]],
    [ "243132911",[-84.22944396272226, 39.58747449061799]],
    [ "Eighth Street Substation",[-88.03023043659044, 44.50600385815629]],
    [ "243164376",[-88.03928399430777, 44.49796530936584]],
    [ "Montpelier-3 Substation",[-72.55584834999998, 44.24961319999999]],
    [ "243379117",[-115.78808476613116, 47.52836785827851]],
    [ "Drexel Substation",[-83.39905690391316, 42.49857204648128]],
    [ "Echo Lake Substation",[-121.87315460606474, 47.49309282977756]],
    [ "243603941",[-74.97774155, 41.67700935]],
    [ "Newberg Substation",[-122.97460175025194, 45.29825498692419]],
    [ "243644655",[-118.2959499, 35.0231581]],
    [ "Buffalo Gap 2 Substation",[-100.20759303541232, 32.32823507530921]],
    [ "South Trent Wind Farm Substation",[-100.19345599884996, 32.43306368319733]],
    [ "Buffalo Gap 1 & 3 Substation",[-100.11532349434039, 32.29935614340941]],
    [ "Distributing Station 66",[-118.47612525479741, 34.05106672392299]],
    [ "Loma Vista Substation",[-112.14647963833423, 33.610349712073464]],
    [ "East Substation",[-97.09183957582347, 44.89221731210136]],
    [ "Pelican Substation",[-97.12663155155995, 44.88900182626576]],
    [ "Suamico Substation",[-88.06853567548332, 44.648206545904365]],
    [ "243812792",[-120.70462585000001, 45.72326005000001]],
    [ "243812793",[-120.78365033394726, 45.74433106119121]],
    [ "243812795",[-120.79102302769624, 45.758006849892794]],
    [ "243812796",[-120.82500548245916, 45.72698519091161]],
    [ "32nd Street Substation DUKE",[-82.6771187764963, 27.833028885131835]],
    [ "Pineshed Substation",[-72.59010564027655, 42.247184604270174]],
    [ "Fairmont Switching Station",[-72.58923239015833, 42.19887268438067]],
    [ "East Findlay Substation",[-83.56375297391382, 41.00687807661914]],
    [ "Signal Mountain Wind Substation",[-101.38802034999999, 32.20724529999999]],
    [ "243942082",[-99.9980177, 48.1657269]],
    [ "243942083",[-99.99776267489192, 48.34063049647445]],
    [ "243942084",[-99.93400580000001, 48.035751749999996]],
    [ "243942087",[-99.92860036694096, 47.77702325011497]],
    [ "Warrior Ridge Substation",[-78.03442911681549, 40.54119654105285]],
    [ "Rillito Substation",[-110.98786007671794, 32.29457256128918]],
    [ "Northwestern Energy Services",[-97.24990764401706, 44.89126778624847]],
    [ "West Substation",[-97.1667975387613, 44.891917479407056]],
    [ "Angleton Substation",[-95.42881557379509, 29.22675939774384]],
    [ "Florence Substation",[-72.68309288544602, 42.33012522849145]],
    [ "244501855",[-111.8575097514254, 40.71878763613875]],
    [ "244578657",[-114.83128968999601, 36.06445276482691]],
    [ "Scitico Substation",[-72.51048248362551, 41.978704742722556]],
    [ "244897154",[-90.61190859046724, 41.442367677838014]],
    [ "Seargeant Substation",[-112.22048507332609, 33.427085959776555]],
    [ "Bayport SW STA",[-88.07921022481064, 44.573830112711214]],
    [ "Maplewood",[-88.1486243818294, 44.57435072470334]],
    [ "Royalston Switch Substation",[-72.15703389999999, 42.6621524]],
    [ "Otter River Substation",[-72.0714634197956, 42.6329164786517]],
    [ "Gardner Switch Substation",[-71.99562560825758, 42.60256787981058]],
    [ "Hedrick Substation",[-92.33563802220637, 41.17629084721776]],
    [ "Bell Substation",[-122.59722932240774, 45.45577382592454]],
    [ "245153676",[-88.09425667726698, 44.523398375088156]],
    [ "University of West GA Switching Station",[-85.12500959999998, 33.5761789]],
    [ "Locust Substation",[-83.52574080723768, 41.6555720481625]],
    [ "Northeast Loop Substation",[-110.91662773883252, 32.2698128211348]],
    [ "245297205",[-116.39501365, 43.20546614999999]],
    [ "El Cajon Substation",[-116.97232249113237, 32.79538474576301]],
    [ "Granite Hills Substation",[-116.92091985228124, 32.80436425646587]],
    [ "245359747",[-86.36938035193731, 39.69871944652066]],
    [ "245400626",[-96.49192054176818, 41.418278779128734]],
    [ "Alpine Substation",[-116.7899037372181, 32.82773738065464]],
    [ "Creelman Substation",[-116.85303067677539, 33.018059020884166]],
    [ "245436205",[-86.38376023348316, 39.66094854127501]],
    [ "245571613",[-87.48959651041595, 46.51696675125267]],
    [ "Magnesium Plant Substation",[-97.72261708311487, 30.37331350863301]],
    [ "Red Maple Substation",[-88.09977978594164, 44.41698109993154]],
    [ "Constellation Energy",[-84.49978608935078, 43.2570194985529]],
    [ "Slate Substation",[-84.52940068977064, 43.20961344449321]],
    [ "Somerset Substation",[-79.06978525954798, 40.0090273478602]],
    [ "245734224",[-98.01381823646975, 43.70303837184715]],
    [ "Loveland Substation",[-116.79224519999998, 32.79695209999999]],
    [ "Murray Substation",[-117.02313294214969, 32.79082856267563]],
    [ "Streamview Substation",[-117.0786264427623, 32.74563323828842]],
    [ "Roxborough Substation",[-75.24289047365791, 40.040630482710576]],
    [ "Chollas Substation",[-117.04656435900134, 32.743826684757835]],
    [ "Paradise Substation",[-117.04998118642536, 32.70437647519888]],
    [ "Spring Valley Substation",[-117.00273783824359, 32.73906443133321]],
    [ "245964664",[-88.06377419283469, 44.72043577036674]],
    [ "245981165",[-86.35123153555458, 39.681573175099984]],
    [ "Muscatine Power and Water",[-91.10131086790983, 41.35120861658833]],
    [ "246229430",[-80.92606010496277, 35.10625998198442]],
    [ "246229435",[-80.88478561954041, 35.12608766009463]],
    [ "246229437",[-80.92673428192361, 35.106722344821996]],
    [ "Public Service Enterprise Group",[-75.0858350912588, 39.892924847523425]],
    [ "246314378",[-75.04260366874318, 39.90384327194371]],
    [ "Redstone Substation",[-84.48015445496856, 43.48741537643285]],
    [ "DTE Energy",[-84.49755317948211, 43.433989939735014]],
    [ "Woodbourne Substation",[-74.88868694314716, 40.1944629380477]],
    [ "Buckingham Substation",[-75.06251649681305, 40.28136300201481]],
    [ "Linton Substation",[-74.92550154946157, 40.242925939170256]],
    [ "East Flemington Substation",[-74.84564321242519, 40.51555943519017]],
    [ "246457753",[-84.94807889247367, 34.51610231969081]],
    [ "Pacific Beach Substation",[-117.2402460254785, 32.79923788330335]],
    [ "Otay Substation",[-117.05770022473227, 32.59534145775036]],
    [ "Palm Bay Substation",[-80.6059379743572, 28.032133008366102]],
    [ "Rancho Bernardo Substation",[-117.09632907876892, 33.021441755998524]],
    [ "Whitins Pond Substation",[-71.67133391743322, 42.10560595432389]],
    [ "Dunnellon Substation",[-82.45799427269927, 29.03769562107294]],
    [ "246762264",[-88.21020076145761, 44.79090211921676]],
    [ "Oconto",[-87.8859142, 44.9027559]],
    [ "Indianapolis Power & Light",[-86.13531601316203, 39.70160739508999]],
    [ "246856607",[-86.1940485652684, 39.71065946438401]],
    [ "Stiles SW STA",[-88.00479957296609, 44.878808932120926]],
    [ "Ameren",[-89.40860942644242, 40.70490780080745]],
    [ "Harrison",[-89.09125379018364, 44.365132050345146]],
    [ "Harrison North",[-89.09084346514571, 44.36346313926752]],
    [ "Morton Substation",[-89.65642040000002, 32.355841600000005]],
    [ "Pioneer",[-88.04906081635886, 44.87276728245038]],
    [ "Oconto Falls Substation",[-88.13513929999999, 44.88647444999999]],
    [ "Falls",[-88.12542315, 44.867380749999995]],
    [ "Willowbrook Substation",[-74.14562510226614, 40.61077957983175]],
    [ "247304856",[-86.81411880342603, 39.55545183631456]],
    [ "Pompton Lakes Substation",[-74.28655348816346, 41.0101507703227]],
    [ "Excel Substation",[-92.39031614712873, 41.00182824106757]],
    [ "WAUPACA",[-89.0449045593785, 44.35841059571411]],
    [ "Scofield Road Station",[-73.83851325873327, 43.35353006114811]],
    [ "247500423",[-90.52980365629315, 38.75346215682201]],
    [ "247507113",[-89.50079124999999, 34.37047325]],
    [ "White Lake",[-88.93220024676988, 44.32900844461525]],
    [ "247730182",[-107.72480755519044, 38.786617133758]],
    [ "Martin City Substation",[-94.59774773178351, 38.879567568058356]],
    [ "Redel Substation",[-94.63591708394394, 38.83900377452945]],
    [ "Antioch Substataion",[-94.69689266551688, 38.82618408710298]],
    [ "Wilbraham Substation",[-72.4348294898065, 42.11091172697739]],
    [ "Mesa Heights Substation",[-117.1573154016927, 32.82954331039935]],
    [ "Sweetwater Substation",[-117.09172629498376, 32.65829458488346]],
    [ "National City Substation",[-117.10736130000001, 32.67307295]],
    [ "Waunakee SW STA",[-89.46125866639083, 43.18459310950766]],
    [ "Haslerud Substation",[-95.32249438219876, 48.9165551813708]],
    [ "Old Forge Substation",[-75.73936164800071, 41.370961167131846]],
    [ "Due West Substation",[-84.66741873622553, 33.965667997572154]],
    [ "247945528",[-98.49749128753989, 45.462705431314745]],
    [ "Kice Substation",[-89.45003314999998, 40.7053102]],
    [ "Eastern Substation",[-89.44973506632928, 40.71513167285373]],
    [ "248170302",[-95.31543417983089, 48.89703156052062]],
    [ "248199719",[-76.82411035457744, 34.69886727961527]],
    [ "Delaney Substation",[-91.73849771820093, 41.958018667420184]],
    [ "Northside Substation",[-88.44978403653491, 44.21740870316174]],
    [ "Uxbridge Substation",[-71.62238329242132, 42.074017638174716]],
    [ "Cabrillo Substation",[-117.24505509731318, 32.70738361464111]],
    [ "Pleasant Substation",[-73.24066589734429, 42.28502387784506]],
    [ "Eversource",[-73.2187339, 42.487558500000006]],
    [ "Partridge Substation",[-73.21664036678838, 42.48746249376075]],
    [ "Deerfield No. 5 Substation",[-72.95738740359583, 42.69291529438705]],
    [ "Lower Deerfield Substation",[-72.7358624, 42.62098699999999]],
    [ "Summersville Substation",[-80.84339111338487, 38.301695070019626]],
    [ "Kettner Substation",[-117.17379339626815, 32.73311127828654]],
    [ "San Diego Harbor Excursion",[-117.19254522132572, 32.74614306373693]],
    [ "Puget Sound Energy",[-122.37850625632382, 47.38978917865691]],
    [ "Puget Sound Energy",[-122.47071453006546, 47.43056094735434]],
    [ "Puget Sound Energy",[-122.53472999999998, 47.45445]],
    [ "Puget Sound Energy",[-122.50923704235719, 47.4541931368713]],
    [ "Fragraria Substation",[-122.55569006269577, 47.46127682506231]],
    [ "Manhattan Substation",[-105.58157216692928, 40.73582033644248]],
    [ "Livermoore Substation",[-105.28698277906173, 40.791548255664495]],
    [ "Rustic Substation",[-105.58767946036279, 40.70546202706318]],
    [ "Linden Substation",[-73.73363749556265, 40.69281634278105]],
    [ "Nunn Substation",[-104.809905217705, 40.724296495775086]],
    [ "Rockport Substation",[-104.81092141686703, 40.89904700528767]],
    [ "Kettner Substation",[-117.16952739276537, 32.71414532389503]],
    [ "Lena",[-88.04519341535823, 44.952928682050675]],
    [ "Hopkins Road Station",[-76.17311773271317, 43.109354123344644]],
    [ "Bensonhurst Substation",[-73.97592913193509, 40.621569656071586]],
    [ "249195242",[-88.1065953346154, 45.02346642428581]],
    [ "Iron Belt",[-90.34209540000002, 46.39623830000001]],
    [ "249490166",[-98.44329074022554, 45.46958956857765]],
    [ "249509516",[-88.24067882561535, 44.91387714604087]],
    [ "Brownsville Substation",[-73.89868895734388, 40.66966299878422]],
    [ "Public Service Company of Oklahoma",[-95.80688701227741, 36.04702763128485]],
    [ "249606084",[-80.21803778308623, 40.25403136235408]],
    [ "249620536",[-86.19628709238953, 39.71172458407778]],
    [ "249653352",[-98.42986377493811, 45.473131956947334]],
    [ "249654317",[-98.3907484531167, 45.4572997744836]],
    [ "249657286",[-90.44642311224109, 45.953107859228]],
    [ "249657296",[-90.4432913, 45.935757949999996]],
    [ "249678857",[-88.38342926465117, 44.904840925433916]],
    [ "WE Energies",[-88.30170802604975, 44.892008677609134]],
    [ "Inwood Substation",[-78.03758759652598, 39.352271026035545]],
    [ "South Monroe",[-89.65178225, 42.593204799999995]],
    [ "249898465",[-86.1927359780522, 39.71414113602744]],
    [ "East 64th Street Substation",[-73.91758471200937, 40.61975081956072]],
    [ "Muscatine Power and Water",[-91.06061263546387, 41.38799326886366]],
    [ "250013868",[-83.59603680000001, 41.68087795]],
    [ "250042873",[-92.29516714798656, 41.27887522904375]],
    [ "250073098",[-98.54638943183518, 45.4456774401702]],
    [ "250106982",[-88.15929587497303, 45.100967092430274]],
    [ "250119106",[-88.16021175, 45.11229470000001]],
    [ "Water Street Substation",[-73.9818832811602, 40.70337030448218]],
    [ "Hallandale Substation",[-80.13487576026624, 25.984399727299046]],
    [ "Cedar Niles Substation",[-94.89211411627718, 38.73019567151286]],
    [ "Pleasant Valley Substation",[-95.04590163255028, 38.63240685905315]],
    [ "NE Substation",[-95.25031336778088, 38.635785661274916]],
    [ "SE Substation",[-95.25345160579407, 38.587024449389055]],
    [ "South Ottawa Substation",[-95.28531393641465, 38.5743687748609]],
    [ "Paola Substation",[-94.90393449567978, 38.533340239954086]],
    [ "Wagstaff Substation",[-94.73733951901986, 38.68031798349476]],
    [ "Lackman Substation",[-94.75528554371529, 38.77529892373947]],
    [ "Bonita Substation",[-94.80525634993106, 38.80633934962931]],
    [ "Spring Hill Substation",[-94.81823695, 38.76090435]],
    [ "Centennial Substation",[-94.86565943729761, 38.56123280690725]],
    [ "Bucyrus Substation",[-94.68476645034796, 38.7304890644748]],
    [ "West Palm Beach Substation FPL",[-80.06372551176071, 26.705228655675356]],
    [ "251106132",[-78.63228803687969, 35.857944047174655]],
    [ "Eastom",[-89.69737367498446, 45.46978600703368]],
    [ "Tomahawk",[-89.73134642352353, 45.44006624190904]],
    [ "Palmer Substation",[-79.71727456716364, 34.659562393676815]],
    [ "AEP Ligonier Station",[-85.58965558411886, 41.4525328800554]],
    [ "AEP Guardian Station",[-85.60513310402645, 41.456207898102946]],
    [ "251390059",[-74.39734262871558, 40.68304149589216]],
    [ "New Providence Substation",[-74.40941788935696, 40.695062892097134]],
    [ "251434297",[-94.39572936232989, 36.820295775784935]],
    [ "251434298",[-94.43409504533226, 36.98637215867935]],
    [ "Pine",[-89.65256492184177, 45.17481278868464]],
    [ "Carroll Electric Cooperative Corporation",[-94.25560580589679, 36.43345422397588]],
    [ "251530145",[-122.22663287517939, 47.23745369528284]],
    [ "Public Service Company of Oklahoma",[-95.98141351666156, 36.155173115096325]],
    [ "251703844",[-90.50623928941435, 41.463708176523724]],
    [ "251719529",[-74.4740125225802, 40.84043657351622]],
    [ "North Road Substation",[-80.91095435316169, 33.544051084012445]],
    [ "Consolidated Edison",[-73.97416692199536, 40.72734150594531]],
    [ "251936313",[-68.37504965000001, 47.278518250000005]],
    [ "251936352",[-68.57448400045548, 47.234390150018044]],
    [ "Marine",[-89.67638312867425, 45.02546077207897]],
    [ "252074122",[-89.70882670922583, 44.95123780115762]],
    [ "252074123",[-89.68551182482206, 44.96684649382004]],
    [ "252074124",[-89.67465454533375, 44.95124379500069]],
    [ "Kelly",[-89.56662105816909, 44.90136339571531]],
    [ "Southside Substation",[-97.38341043929724, 27.73180290535185]],
    [ "Sisseton Downtown Substation",[-97.04786151638922, 45.66130321694676]],
    [ "Westside Substation",[-97.4521975555236, 27.73463046989133]],
    [ "Weil Tract Substation",[-97.48546687793743, 27.796766850732567]],
    [ "252397877",[-90.11420774999999, 44.30433015]],
    [ "252546430",[-84.13859096394573, 33.99835916566179]],
    [ "Florida Power & Light",[-81.32345904352505, 29.846194141311884]],
    [ "Lightsey Substation",[-81.34961055040105, 29.85767816657333]],
    [ "Matanzas Substation FPL",[-81.29122653807487, 29.75741695807396]],
    [ "Saint Johns Substation",[-81.35018080442865, 29.856149764515553]],
    [ "252592145",[-87.65949203689955, 45.08917187058039]],
    [ "Bammel Substation",[-95.5025968674533, 29.982660096696193]],
    [ "252665134",[-122.88419320432502, 47.998495969374076]],
    [ "252665135",[-122.99353151559437, 48.02377516250814]],
    [ "NorthWestern Energy",[-99.31744455040821, 43.79218974996535]],
    [ "252709604",[-99.32310710986738, 43.809357235488676]],
    [ "Schodack Substation",[-73.7145422161396, 42.548943140408326]],
    [ "252710679",[-99.29400677514597, 43.8467367618952]],
    [ "Stoughton Substation",[-71.09617745823243, 42.11742388010617]],
    [ "252880821",[-112.73499911338305, 40.907385710224894]],
    [ "252988272",[-112.73540707927049, 40.91390619953398]],
    [ "252988287",[-112.73181101731916, 40.87993292484648]],
    [ "Orange Park Substation JEA",[-81.71015668557584, 30.17686220472029]],
    [ "Yurok Substation",[-124.05045281727382, 41.54337174746761]],
    [ "Oacoma Substation",[-99.38329664586682, 43.803761659354734]],
    [ "Horseshoe Substation",[-112.6528155163129, 40.748253247363074]],
    [ "253155254",[-112.80421714602079, 40.83126938211541]],
    [ "253155256",[-112.54668632516515, 40.6716655436267]],
    [ "253155258",[-112.98348009999997, 40.7346439]],
    [ "253155259",[-112.89594840000001, 40.82576415]],
    [ "253155261",[-112.82692793220968, 40.85061825196947]],
    [ "DISTRIBUTING STATION 71",[-118.42314884999999, 34.1716085]],
    [ "Distributing Station No. 22",[-118.59628230268162, 34.201505105345866]],
    [ "Ridgewood Substation #07 CLAY",[-81.77331943560301, 30.139838834779663]],
    [ "Chimacum Substation",[-122.7701414, 48.014490949999995]],
    [ "Port Ludlow Substation",[-122.73256855715978, 47.934395419713354]],
    [ "Brickyard Substation #17 CLAY",[-81.77111457599572, 30.107473757055576]],
    [ "Russell Substation",[-81.74802213405536, 30.054724558972584]],
    [ "Fleming Island Substation",[-81.72476894969166, 30.08835985007052]],
    [ "253416044",[-82.47716350936174, 28.46726892486495]],
    [ "Belair West Substation #10 CLAY",[-81.76821697433788, 30.165221657867168]],
    [ "LADWP Distributing Station No. 135",[-118.46732076960289, 34.07188111852015]],
    [ "253561997",[-122.95011441836213, 47.66059665860501]],
    [ "Ronco Substation",[-79.91629431787518, 39.86077140677004]],
    [ "Florida Power & Light",[-81.23089449175754, 29.600722734767924]],
    [ "253855450",[-84.64427907810406, 38.90644493324882]],
    [ "West River Electric Association",[-103.09386675936976, 44.09727042983641]],
    [ "Park View Substation",[-71.07303210089087, 42.10255245097737]],
    [ "Mason Public Utility District",[-123.1900041834037, 47.3124196332594]],
    [ "254080468",[-103.10090696945676, 44.11532927609127]],
    [ "West River Electric Association",[-103.14841649074476, 44.082511224946536]],
    [ "Merillat Substation",[-103.19077182504832, 44.04181860577468]],
    [ "Century Substation",[-103.1892206249838, 44.096240795476426]],
    [ "West Rapid City Substation",[-103.18783865832545, 44.08147709068465]],
    [ "Highway Eight",[-89.42869017411566, 45.63139850074994]],
    [ "Hodag",[-89.36899416096881, 45.621023983905374]],
    [ "Venus",[-89.16511517033808, 45.56323270139231]],
    [ "West River Electric Association",[-103.18707158431414, 44.12612748247135]],
    [ "Mall Substation",[-103.20992824214424, 44.111619147426254]],
    [ "254442471",[-115.08397267487487, 36.14370912785863]],
    [ "Fourth Street Substation",[-103.22182478936018, 44.08323081884162]],
    [ "Blue Mountain Lake",[-74.43116627470786, 43.85265003595996]],
    [ "254581787",[-84.73537855000001, 39.06493615]],
    [ "Cross Street Substation",[-103.24543730858849, 44.082803049742914]],
    [ "West Boulevard Substation",[-103.23457404326129, 44.08499869833641]],
    [ "AMD Substation",[-98.64005073243294, 29.449451246771126]],
    [ "Texas Cryptologic Center Substation",[-98.63871300181533, 29.447997522551223]],
    [ "254743534",[-96.64083215, 46.34223575]],
    [ "Rainier View Substation",[-122.69130651316907, 46.89112381682843]],
    [ "254758018",[-122.1687639, 47.1508746]],
    [ "McCall",[-116.12490877575118, 44.912640354744305]],
    [ "Roney Substation",[-80.12105990513359, 25.853766950253686]],
    [ "Haulover Substation",[-80.12428706133447, 25.900929920501177]],
    [ "Concord Substation",[-71.4264299454785, 42.437618234249925]],
    [ "Fifth Street Substation",[-103.22601279999999, 44.0609306]],
    [ "Socorro Substation",[-106.92784905289707, 34.05293688960909]],
    [ "255358569",[-79.33610532160066, 38.652588246585914]],
    [ "255485072",[-92.92353685, 46.02321189999999]],
    [ "255485073",[-92.88860879345775, 46.017845624912724]],
    [ "255486000",[-80.91513048023701, 35.33319413141601]],
    [ "255487709",[-92.86389260976654, 46.10838587377756]],
    [ "Fairfield Station",[-74.89952962545695, 43.062467089836574]],
    [ "Memphis Light, Gas and Water",[-89.7941706884753, 35.266672112116446]],
    [ "255724591",[-79.16816481833247, 39.37495766875047]],
    [ "Black Hills Energy",[-103.26232004347777, 44.085881267774816]],
    [ "Thirty Eight Street Substation",[-103.28254506314899, 44.06292406443012]],
    [ "Monte Cristo Substation",[-112.13428368583327, 33.631014236265415]],
    [ "Jersey Central Power and Light",[-74.63209546819301, 40.89749736860996]],
    [ "Frazee Substation",[-95.69982915876054, 46.72277212445745]],
    [ "Frazee Substation",[-95.69991772008387, 46.71862128470822]],
    [ "255992091",[-111.66820982590242, 33.394658409732905]],
    [ "256028929",[-96.68059428613154, 33.098347563490115]],
    [ "Colonial Substation",[-87.65571465, 32.977373199999995]],
    [ "256124673",[-82.19193056142103, 28.374997185971104]],
    [ "Fort King Substation",[-82.20446654058422, 28.333646024908585]],
    [ "Edith Clarke Substation",[-99.77405918246721, 33.94427226565116]],
    [ "256156161",[-99.67517115982088, 34.05541229562365]],
    [ "Pound",[-88.02719689341797, 45.09390821642053]],
    [ "Ulen Substation",[-96.26332264441032, 47.07548742131487]],
    [ "Hitterdal Substation",[-96.25828345, 46.97962325]],
    [ "Price Substation",[-75.96398835018312, 39.11256410700592]],
    [ "256262334",[-82.23726532914888, 28.222810714287924]],
    [ "256262828",[-94.36169267455296, 44.53223013359498]],
    [ "256263267",[-111.59284551210192, 33.32026576324253]],
    [ "256264393",[-94.46585853831655, 44.355830655094344]],
    [ "256342219",[-94.35638826181173, 44.88191043535669]],
    [ "McCormick Substation",[-111.92319234357075, 33.552471848771646]],
    [ "256427347",[-111.89697860904798, 40.65652114130771]],
    [ "256491271",[-93.26002325, 43.143649749999994]],
    [ "256522043",[-91.90067618742785, 46.93632737434857]],
    [ "256522044",[-91.84843781519888, 46.95680072504897]],
    [ "256523762",[-93.2389183419628, 36.671490160369856]],
    [ "256523766",[-93.25379792374878, 36.67127090195729]],
    [ "256527119",[-93.25820142686665, 36.6327489960822]],
    [ "256527120",[-93.27380948948326, 36.64779975923661]],
    [ "256549297",[-93.36950323700844, 36.70585471627846]],
    [ "Arizona Falls",[-111.95880863200914, 33.49074978128683]],
    [ "SRP Indian Bend Substation",[-111.90647949861382, 33.516231515863325]],
    [ "256554414",[-93.33517054193965, 36.65927065700234]],
    [ "Belmond Diesel Substation",[-93.6173309413358, 42.837375925190734]],
    [ "MidAmerican Energy",[-94.1933169488615, 42.48756278413838]],
    [ "256657110",[-91.23503585564129, 47.411726278408274]],
    [ "Monette Junction Substation",[-90.26263890035241, 35.88902928608687]],
    [ "Batesville Substation",[-99.60796805999782, 28.86285877251559]],
    [ "San Antonio Substation",[-82.27135222883338, 28.33264346998473]],
    [ "256733590",[-85.50037137644107, 37.78669471432919]],
    [ "256737859",[-85.41924179517565, 37.82335614995552]],
    [ "256804892",[-87.62685195563026, 45.099961077126004]],
    [ "256852987",[-87.60292967866945, 45.094851428304715]],
    [ "256873287",[-77.70765176099866, 39.69255972345729]],
    [ "Brighton Substation",[-71.13174716296423, 42.35724181593543]],
    [ "257141376",[-84.49197119398195, 38.029365864611044]],
    [ "Southern California Edison",[-118.34737965758826, 33.94228132341418]],
    [ "257182441",[-93.2618080589846, 36.59941167681139]],
    [ "257189251",[-93.1931576830919, 36.624028450930105]],
    [ "257189253",[-93.17324478299125, 36.62268859473282]],
    [ "Longmire Substation",[-122.56567849397982, 46.91763926942817]],
    [ "Olympic Vail Pipeline Substation",[-122.69506970785673, 46.872940491094376]],
    [ "Appanoose County Substation",[-92.66268511429448, 40.70791685348804]],
    [ "257399413",[-122.54623665, 47.12660024999999]],
    [ "257409941",[-92.56786171594929, 40.42416097469776]],
    [ "Kalispell",[-114.21638568698408, 48.21662247639729]],
    [ "257415428",[-84.29023365590197, 37.581974124555]],
    [ "Maysville Substation",[-80.41966726516316, 41.3981522493796]],
    [ "257576109",[-84.30166766875625, 37.734396152835956]],
    [ "Ironwood",[-90.16693310352574, 46.44837967196559]],
    [ "Crivitz",[-87.9949104883205, 45.17671117454794]],
    [ "257711599",[-75.40036770764289, 40.71508977957541]],
    [ "257714687",[-88.19539707514595, 39.62363225910543]],
    [ "257814571",[-93.89717960874032, 42.67037847517146]],
    [ "Modaff Substation",[-88.14694175675741, 41.74757844741111]],
    [ "258071420",[-87.92970032578405, 38.12650779060741]],
    [ "East Kentucky Power Cooperative, Inc.",[-84.87191499973908, 37.934804766581536]],
    [ "East Kentucky Power Cooperative, Inc.",[-84.93540406667158, 37.9617170499345]],
    [ "Gravelly Lake Substation",[-122.54765596426797, 47.148161431483096]],
    [ "258204419",[-75.32762542584383, 40.732234350344854]],
    [ "258217663",[-122.31954526864796, 46.83289474186532]],
    [ "American Avenue",[-84.51526199096264, 38.031911379080064]],
    [ "258228519",[-120.49697450746676, 46.592092479082034]],
    [ "258366605",[-110.29057225972127, 31.540637601959464]],
    [ "Hugheston Substation",[-81.36741445914993, 38.195419434047196]],
    [ "PPL",[-75.4365588958118, 40.58144734493948]],
    [ "258429579",[-82.21863965507765, 37.697013001351834]],
    [ "Eureka Springs Substation",[-93.74343270809815, 36.41072395119197]],
    [ "Green Forest South Substation",[-93.43427565535139, 36.32031825139954]],
    [ "Berryville Substation",[-93.57183405014354, 36.37747234870756]],
    [ "Harrison South Substation",[-93.131328800605, 36.1969206254118]],
    [ "Harrison West Substation",[-93.13459629498135, 36.24986689969459]],
    [ "Seosage Creek Substation",[-93.63751082542537, 36.39118466544319]],
    [ "Green Forest Substation",[-93.46689733098263, 36.33677797727893]],
    [ "Barilla Substation",[-93.56998624931101, 42.02817637896071]],
    [ "258537432",[-93.55978742520736, 42.39089494254462]],
    [ "South Point Substation",[-82.57445155251489, 38.413656120730984]],
    [ "Hamilton Substation",[-97.74415299615409, 30.400827820209333]],
    [ "258578390",[-91.43900812501741, 44.34846770480443]],
    [ "258582474",[-91.22805109375122, 44.29621657497488]],
    [ "Tremval Substation",[-91.25493443932874, 44.29332145083299]],
    [ "258585442",[-90.92207160739672, 44.435524904093235]],
    [ "258586143",[-92.96219344096158, 43.70057330565184]],
    [ "258586146",[-92.96047560846007, 43.70029708117503]],
    [ "Malta",[-107.82798614566978, 48.36135028435963]],
    [ "258716930",[-87.92969665, 38.0543874]],
    [ "Messick Road Substation",[-78.73626025913292, 39.630093387320564]],
    [ "Cherry Creek Substation",[-81.10165710000001, 37.70056805]],
    [ "258795591",[-81.22653965218177, 37.72261888755424]],
    [ "258834840",[-75.30165810952737, 40.7677021266878]],
    [ "258834842",[-75.27015594999999, 40.7522143]],
    [ "258834845",[-75.27021952620699, 40.75401990495687]],
    [ "258849471",[-81.52324203452287, 39.735138129001996]],
    [ "258858197",[-83.46695475667575, 43.63787817899427]],
    [ "Bayshore Substation",[-122.40333297113305, 37.746003117535686]],
    [ "Buckhannon Substation",[-80.23306116128191, 39.00015272792538]],
    [ "Palmerton Substation",[-75.60747652013855, 40.797528973770014]],
    [ "259153452",[-84.82957719999999, 32.54602805]],
    [ "Long Lake Substation",[-122.58900383589874, 47.50461073273068]],
    [ "Union Hills Substation",[-112.08885653860732, 33.65326519494473]],
    [ "259317250",[-93.01916721152503, 43.66285134922392]],
    [ "Tacoma Power",[-122.6873561672869, 47.389363728936914]],
    [ "Tacoma Power",[-122.59945132283015, 47.34597841609318]],
    [ "PPL",[-75.12848239999998, 40.80090865]],
    [ "Lufkin Pershing Street Substation",[-94.73556029312196, 31.327492219728224]],
    [ "259670498",[-111.74444344960133, 40.36905111770374]],
    [ "McIntosh Substation",[-101.36006024999999, 45.91978115]],
    [ "McIntosh Substation",[-101.33605657510395, 45.93425664178522]],
    [ "Hammond Bay Substation",[-84.1014882256801, 45.49253163993271]],
    [ "Stroudsburg Substation",[-75.18674277752629, 40.990591181347526]],
    [ "Punxsutawney Substation",[-78.97085693694869, 40.93690909694451]],
    [ "259930616",[-99.37613572273607, 40.69217215912008]],
    [ "New Cities Service",[-97.97339824549267, 38.02753422655342]],
    [ "259963341",[-99.63672284128555, 40.780080398742925]],
    [ "259967015",[-99.732696211178, 40.739046172112154]],
    [ "Nebraska Public Power District",[-99.98665968289198, 40.841426998808835]],
    [ "259977563",[-100.16316269702328, 40.902402104388884]],
    [ "Davis Substation",[-97.88596092520412, 38.03565204250876]],
    [ "McGulpin Substation",[-84.77121260852705, 45.784322045775404]],
    [ "259980200",[-100.39720352054964, 40.959173390456954]],
    [ "259990852",[-99.81791074917442, 40.69411281644219]],
    [ "259990854",[-99.8124368782907, 40.68571021360892]],
    [ "Central Heights Substation",[-94.63771115053896, 31.7209889428033]],
    [ "Tacoma Power",[-122.46631541445014, 47.274485181576466]],
    [ "Tacoma Power",[-122.5216021, 47.282108599999994]],
    [ "West Traverse Substation",[-85.05313495, 45.50752529999999]],
    [ "Millers Point Substation",[-85.64174375829057, 42.276442847046724]],
    [ "Nanuet Substation",[-74.01667088171428, 41.09332795235124]],
    [ "Emmet Substation",[-84.91353801091314, 45.35095548798758]],
    [ "Odawa Substation",[-84.97725062507736, 45.34782434593456]],
    [ "Stadium Substation",[-122.45128069999998, 47.2624798]],
    [ "McNally Substation",[-85.16881808850373, 45.357372825330906]],
    [ "Hickory Substation",[-97.1617772995138, 33.21519930462252]],
    [ "Burrton Substation",[-97.6759308718878, 38.024081195120736]],
    [ "260360219",[-97.34916142087127, 38.04242229668981]],
    [ "260366076",[-79.42111540507277, 35.168473266765965]],
    [ "260401858",[-120.53597649177458, 45.78390199919557]],
    [ "260401859",[-120.55818440984469, 45.783083805059796]],
    [ "260405071",[-96.63292118613987, 40.97318914278474]],
    [ "Steele City Substation",[-96.99276595119619, 40.037018249650245]],
    [ "Tarrant City Substation",[-86.77189136656693, 33.586361750139744]],
    [ "Central Lake Substation",[-85.220372531786, 45.030810445638274]],
    [ "Eastport Substation",[-85.33508467505013, 45.11129240780386]],
    [ "Alden Substation",[-85.31336136432732, 44.8525629315214]],
    [ "260547652",[-96.99327683691425, 40.226632952395796]],
    [ "260581486",[-99.62388607900363, 41.394164776581874]],
    [ "Steck Substation",[-97.74159306179912, 30.367260694190335]],
    [ "260672352",[-76.17917428342481, 40.0845152449869]],
    [ "Callaway Substation",[-99.93016349271225, 41.31040045375213]],
    [ "260791233",[-75.08345208480968, 40.9123926680567]],
    [ "North Bangor Substation",[-75.19134329409438, 40.90444621495629]],
    [ "Pequest River Substation",[-75.07153375997424, 40.835899261152306]],
    [ "260868460",[-77.34492275722836, 38.627229345087116]],
    [ "Jersey Central Power and Light",[-75.14738197481051, 40.66554755268186]],
    [ "Blodgett Substation",[-95.36446705258527, 29.720982242895996]],
    [ "261166999",[-96.72680110126493, 40.227097082291046]],
    [ "Farr Road Substation",[-86.20197019881742, 44.343790747533546]],
    [ "Riverdale Substation",[-74.30167369046121, 40.990708172808475]],
    [ "Pequannock Substation",[-74.28583243891046, 40.94368973666936]],
    [ "Wabash",[-84.37143100796007, 33.76535179296801]],
    [ "Georgia Power",[-84.37830007417084, 33.745270785543056]],
    [ "Sub E",[-91.51132300486996, 41.64745446469186]],
    [ "261269293",[-85.94610522659676, 40.001808088745676]],
    [ "Tacoma Power",[-122.48285864999998, 47.24942515000001]],
    [ "Georgia Power",[-84.39484533235895, 33.81160787240942]],
    [ "Tacoma Power Cirque Substation",[-122.55773784886458, 47.21314709937074]],
    [ "Tacoma Power",[-122.57538197399633, 47.18107703784216]],
    [ "Tacoma Power",[-122.5167780247104, 47.18910734602543]],
    [ "Tacoma Power",[-122.50468825, 47.2105409]],
    [ "Tacoma Power",[-122.57917346555506, 47.16651603246321]],
    [ "Tacoma Power",[-122.59475526919019, 47.11354574429466]],
    [ "Tacoma Power",[-122.56251914870295, 47.11457565124732]],
    [ "261318595",[-96.76466471174902, 40.28927027389668]],
    [ "Tacoma Power",[-122.49873380964833, 47.14460032523351]],
    [ "Tacoma Power",[-122.51750520183352, 47.13974817938142]],
    [ "Tacoma Power",[-122.62206443233264, 47.2965955883235]],
    [ "261322906",[-88.31450528333619, 39.651938975596565]],
    [ "261345785",[-111.50832260797355, 33.45276428605922]],
    [ "Village Green Substation",[-85.59622839811418, 42.22272980708996]],
    [ "Spring Lake Substation",[-86.18059992505644, 43.078996191652266]],
    [ "Waterford Substation",[-81.71530895890831, 39.53299407308612]],
    [ "Phillipsburg Substation",[-75.18262350090059, 40.690446005067734]],
    [ "Tacoma Power",[-122.48731687119049, 47.169790030826]],
    [ "Colony Farm Substation",[-85.65048852481533, 42.26059924129541]],
    [ "261601485",[-81.65431722699263, 39.57994699043647]],
    [ "261612496",[-122.54938402485384, 47.1810744926576]],
    [ "Ravine Substation",[-83.36011565799313, 42.52068417656322]],
    [ "261650069",[-93.14630389807245, 36.71566698547999]],
    [ "261672126",[-93.27240796652521, 36.522772723464044]],
    [ "261672130",[-93.25917564846905, 36.56426261723784]],
    [ "261803731",[-93.54681970340026, 36.723245084969726]],
    [ "Farmington Substation",[-83.35742105728343, 42.462255705843305]],
    [ "California Substation",[-79.84835425277807, 40.51535480330555]],
    [ "262066765",[-115.17111457685318, 36.03051498509996]],
    [ "Drifton Substation",[-83.84297795784515, 30.49562731068247]],
    [ "Custer Term",[-87.92699685, 43.11540135]],
    [ "Mukonago",[-88.32731998668186, 42.85859863107664]],
    [ "Burlington",[-88.26770945158209, 42.683478038214204]],
    [ "Whitewater",[-88.73072580059008, 42.81946218661572]],
    [ "Polhemus/Bridgewater Substation",[-74.56449829065448, 40.560231664311715]],
    [ "North Nashville Substation",[-86.71265578031917, 36.27673385499746]],
    [ "Alabama Power",[-86.06701059906766, 34.02013716602521]],
    [ "PSE&G",[-74.25721908014623, 40.98027335732215]],
    [ "262288912",[-117.08602159797117, 47.2283708436917]],
    [ "262313437",[-93.33594815000001, 36.7608249]],
    [ "Portner Substation",[-105.06701244380126, 40.49587358143787]],
    [ "262320282",[-93.23018788924968, 36.71689345361929]],
    [ "262513827",[-115.16587904534889, 36.170123922748]],
    [ "Amberg Substation",[-87.97584687504968, 45.496446804476776]],
    [ "Daves Valls",[-87.9839707066712, 45.492741775364166]],
    [ "Tacoma Power",[-122.53532872600736, 47.227848675483926]],
    [ "262603830",[-88.33960181812424, 44.27492693128302]],
    [ "CLOVERLEAF",[-88.61140747138391, 44.70689424128533]],
    [ "262764742",[-79.1285953, 39.016259500000004]],
    [ "262766647",[-90.03173066066464, 30.015217370610806]],
    [ "262766648",[-89.97757488901576, 29.922696120596584]],
    [ "262793540",[-104.90865093656375, 39.610064374788735]],
    [ "262796392",[-77.90239831611377, 35.737811334078415]],
    [ "262798986",[-77.86570052472956, 35.756791354601965]],
    [ "262798987",[-77.8776751818152, 35.756482044074765]],
    [ "262803315",[-119.7665682847284, 46.21135000236876]],
    [ "Larkin Substation",[-84.24716620026271, 43.64513214929704]],
    [ "Ashman Circle Substation",[-84.224374, 43.62512705]],
    [ "Midland Substation",[-84.24927445574585, 43.61349138140377]],
    [ "Loudon Park Substation",[-76.67694903586339, 39.273117080422026]],
    [ "Belding Substation",[-85.23260287113177, 43.09940357744753]],
    [ "262940815",[-79.49082261103857, 39.17218190862629]],
    [ "Carroll Electric Cooperative Corporation",[-93.58748222529013, 36.579419095898814]],
    [ "Carroll Electric Cooperative Corporation",[-93.61235474779043, 36.60648257517541]],
    [ "Carroll Electric Cooperative Corporation",[-93.56206950509352, 36.509396370248744]],
    [ "263170424",[-96.38491712304165, 41.08941376619817]],
    [ "263175139",[-123.27961406886998, 44.57963359003845]],
    [ "263217007",[-114.56143655, 35.096549949999996]],
    [ "263217008",[-114.57208875711294, 35.11285292118192]],
    [ "Lyons Substation",[-93.62013404947167, 42.31099300000469]],
    [ "263263885",[-114.63440589578185, 35.01092737969911]],
    [ "Nixonville Substation",[-78.87617652129701, 33.83674119512766]],
    [ "Southern Substation",[-112.15894965954051, 33.39258857749988]],
    [ "Merrill Creek Substation",[-75.14535510632108, 40.77166422546121]],
    [ "North Pigeon Forge Substation",[-83.58126135101594, 35.8104428832525]],
    [ "South Carolina Gas & Electric",[-79.92924988419145, 32.790881964998]],
    [ "Charlotte Street Substation",[-79.92824115851262, 32.79063146992969]],
    [ "263457830",[-93.39894477741495, 36.72936887691582]],
    [ "263549109",[-90.20923915, 33.5154124]],
    [ "263567756",[-78.76432672985787, 33.92583135092794]],
    [ "Wautoma",[-89.28877508339725, 44.06394097357077]],
    [ "Ohmstead",[-88.40131267497999, 43.76286180897352]],
    [ "Sand Lake",[-89.48164889879197, 44.15015840975722]],
    [ "North Fond du Lac",[-88.4745147771145, 43.798716418495914]],
    [ "Eden Substation",[-90.42258909950303, 42.96794360445877]],
    [ "263624832",[-90.68358325136724, 42.834544084503115]],
    [ "263659293",[-93.94224337516232, 42.59118595485642]],
    [ "Chesterfield Substation",[-88.27125572468374, 35.63658611997394]],
    [ "Collinwood Substation",[-87.74504875264118, 35.163032555745616]],
    [ "Parsons Substation",[-88.13011278525074, 35.64848263724553]],
    [ "263741732",[-93.31250964574183, 36.64197135322919]],
    [ "263818689",[-114.99746414370323, 35.78978863928313]],
    [ "Limerick Tap Substation",[-75.58531351182671, 40.22071649525983]],
    [ "Hospital",[-97.0775703538219, 36.11421707029576]],
    [ "Double Bridges Substation",[-89.45799495675766, 35.91262085609122]],
    [ "Ripley Substation",[-88.93961824413446, 34.757501272526696]],
    [ "Tennessee Valley Authority",[-89.3357150411076, 36.0580189150415]],
    [ "Forked Deer Electric Cooperative",[-89.47389748869684, 35.80721422291331]],
    [ "Burnsville Substation",[-88.30572718403043, 34.83737163128772]],
    [ "Guntown Substation",[-88.65804410403338, 34.449789926415605]],
    [ "Flanders Substation",[-74.70656740816614, 40.866466830318195]],
    [ "Georgia Power",[-84.47758209999999, 33.95329945]],
    [ "Beebe Substation",[-71.64026652668535, 43.828147367416214]],
    [ "Surfside Substation",[-78.96326045783862, 33.63217961654375]],
    [ "264359628",[-76.2160123475048, 36.27839833790577]],
    [ "264534519",[-88.33863691944134, 40.11193465474262]],
    [ "West 19th Street",[-73.99733193671382, 40.74123932894075]],
    [ "South Highway 65 Substation",[-93.26189204199754, 37.158993050518006]],
    [ "264731098",[-93.29476075107293, 37.11717510341084]],
    [ "264806540",[-97.25329198918845, 40.88020870542288]],
    [ "Georgia Power",[-84.4894259766742, 33.900713054988984]],
    [ "264861421",[-93.19782163071602, 37.1177261350008]],
    [ "264912320",[-88.25124782270005, 35.221995505336785]],
    [ "264945132",[-124.15120896861977, 46.98432988316691]],
    [ "Georgia Power",[-84.43026255051356, 33.98338299872652]],
    [ "264982741",[-78.9965556077312, 34.653896246177446]],
    [ "264998815",[-112.2538374, 46.80593335]],
    [ "265024217",[-80.64616295, 34.523321700000004]],
    [ "265134163",[-80.77127772844123, 34.72905223582774]],
    [ "Lancaster Ret Substation",[-80.78560204812528, 34.70864849113579]],
    [ "Newtown Substation",[-73.9315486169967, 40.742984882374486]],
    [ "265160928",[-93.33636994456003, 37.12230499903595]],
    [ "265217339",[-83.85998736710405, 41.4192882237024]],
    [ "265281672",[-79.03354666443961, 33.73188765082034]],
    [ "Cooks Pond Substation",[-71.85335679102579, 42.282341628123255]],
    [ "265353112",[-93.77160962437704, 38.382673632647894]],
    [ "Warsaw Substation",[-93.36440615028555, 38.267299157376854]],
    [ "Truman Lake Substation",[-93.40693032006521, 38.2606865891587]],
    [ "Greenly Substation",[-86.07758006814763, 42.83172232418679]],
    [ "265389118",[-93.38795206300784, 37.139936424737456]],
    [ "265428181",[-83.75323957613125, 32.49787456784117]],
    [ "Slayton Hill Substation",[-72.28655060165124, 43.63257582068385]],
    [ "El Paso Electric",[-106.49854069751689, 31.769148813351432]],
    [ "El Paso Electric",[-106.49772820294083, 31.76851258461022]],
    [ "Eagle River",[-89.25828959860567, 45.91017197652995]],
    [ "DISTRIBUTING STATION 139",[-118.4045480943566, 33.93178581835864]],
    [ "Waddell Substation",[-112.4470575182195, 33.59588539113776]],
    [ "265892812",[-91.52500246021278, 40.973635625053454]],
    [ "Midway Substation",[-92.45416262645654, 36.36811970245902]],
    [ "Eber Substation",[-83.78535176259345, 41.60592837924079]],
    [ "Delta Substation",[-83.9939188656455, 41.57244013160554]],
    [ "266172062",[-91.58664576727244, 41.017404606900584]],
    [ "Platte Valley Substation",[-104.84508020103549, 39.988206457527895]],
    [ "266473569",[-93.44674655794272, 37.12640422966506]],
    [ "266536250",[-83.53183784024054, 40.43588132702866]],
    [ "266737198",[-91.85361276266475, 30.313223513268927]],
    [ "Cecilia Substation",[-91.84427316420243, 30.31464472267478]],
    [ "Elmwood Substation",[-85.70887605709402, 44.80246797140567]],
    [ "32 Street Substation",[-75.07613620460704, 39.94888322148112]],
    [ "O'Conner Substation",[-97.04322747449199, 28.519600993143243]],
    [ "Receiving Station K - Olympic",[-118.45999699276231, 34.033193468166154]],
    [ "267168838",[-122.63461576557482, 47.11465740958613]],
    [ "Walnut Creek Substation",[-97.65316780108004, 30.274024611697584]],
    [ "267180486",[-93.37345395787113, 37.1501928161431]],
    [ "267445382",[-93.17896675, 36.01366889999999]],
    [ "267574518",[-93.3316318674212, 37.16222451583398]],
    [ "267583308",[-93.340156, 37.16225885]],
    [ "Golden 69 Substation",[-93.34082838166594, 37.16311984083746]],
    [ "267611374",[-93.3083336947273, 37.17851406184207]],
    [ "267625272",[-96.85081026627162, 33.83050991073962]],
    [ "Simms Substation",[-105.14599671951171, 39.89953994112964]],
    [ "267864385",[-94.48119341681749, 41.344634035090074]],
    [ "Ship Bottom Substation",[-74.17877060368723, 39.651098385155436]],
    [ "267910471",[-93.3248883248291, 37.134976407085624]],
    [ "267930597",[-93.28664884947032, 37.16773599106891]],
    [ "Bristol Tennessee Essential Services",[-82.18491524999999, 36.5464252]],
    [ "268132873",[-87.49813510268888, 36.839985612747824]],
    [ "268132875",[-87.46101107000685, 36.819205785929896]],
    [ "268132876",[-87.47803424248303, 36.87201416456277]],
    [ "Rose Garden Substation",[-112.1151950127158, 33.67705558148089]],
    [ "Kickapoo Substation",[-93.28645156662385, 37.1530740553782]],
    [ "Holland",[-93.28656604954114, 37.168924340808715]],
    [ "Pompton Plains Substation",[-74.2943374984664, 40.96980215580792]],
    [ "268536457",[-123.31456590115982, 43.658124806255636]],
    [ "268650281",[-87.43343355508244, 36.821069283006835]],
    [ "268650282",[-87.43793456570494, 36.82638127047091]],
    [ "Brownsville Energy Authority",[-89.23880887068627, 35.59742237135161]],
    [ "Brownsville Substation",[-89.27362178542147, 35.587213967421725]],
    [ "268999604",[-87.39589426561881, 36.798736456322565]],
    [ "269020196",[-88.334114526707, 36.61520664504751]],
    [ "Ripley Substation",[-89.52721990575736, 35.72542862628715]],
    [ "West 65th Street Substation",[-73.98805320445479, 40.77589603399158]],
    [ "269352695",[-88.32337572240019, 36.61532020661706]],
    [ "DaimlerChrysler Substation",[-83.55496915502891, 41.55631781012004]],
    [ "269665010",[-88.30106574999999, 36.61288565]],
    [ "269674049",[-86.91863122742467, 35.690617992016634]],
    [ "269760222",[-93.3670983378435, 37.23678753103657]],
    [ "Intervale Substation",[-71.15250910791501, 44.092645247969614]],
    [ "Nichols",[-93.32603428918793, 37.21961102461283]],
    [ "Nichols",[-93.32502757852477, 37.21965296021667]],
    [ "Hohenwald Substation",[-87.54914114461047, 35.54408356970323]],
    [ "First Electric Cooperative Cooperation",[-92.13400915331295, 35.58358951718819]],
    [ "Hawkins Crossing Substation",[-88.66812108526747, 32.38274061816487]],
    [ "Macada Substation",[-75.36572015000002, 40.64563075]],
    [ "Toccoa River Substation",[-84.28367309920777, 34.88724595030925]],
    [ "Cibolo Creek Substation",[-98.38522725345345, 29.664872799384547]],
    [ "Blakely Primary Substation",[-84.90597145097061, 31.371530983342204]],
    [ "270984127",[-93.22153252465336, 42.74571924286492]],
    [ "271378518",[-116.55661549998432, 43.55873106524026]],
    [ "Green Valley Substation",[-110.97343621699572, 31.854298226499644]],
    [ "Parkview Substation",[-73.936556356361, 40.807746104177355]],
    [ "Gayville Substation",[-97.19991340000001, 42.88201325]],
    [ "271848153",[-82.59680302747785, 35.64190764929629]],
    [ "Sunrise",[-88.95681482458318, 42.66989150943153]],
    [ "Turtle",[-89.00187030432053, 42.576493728184225]],
    [ "272021562",[-114.93027982472866, 47.50991164683128]],
    [ "272031919",[-72.78545417511278, 43.202739443475906]],
    [ "Southwest Substation",[-81.96566645099828, 28.011532889899506]],
    [ "272567497",[-94.0496028425233, 42.73198868933779]],
    [ "Hawaiian Electric Company",[-158.0148096643219, 21.523849950255197]],
    [ "272761633",[-84.88394144020053, 39.11009573078234]],
    [ "MidAmerican Energy",[-90.45002596996764, 41.54125760586342]],
    [ "MidAmerican Energy",[-90.44894117568842, 41.54103842179923]],
    [ "272998076",[-85.91342789310727, 32.68045821358983]],
    [ "Bluff View",[-87.99769955991451, 45.78349577944642]],
    [ "Niagra Paper of Wisconsin",[-87.9887074, 45.77522215]],
    [ "Jarret Substation",[-75.16368658576968, 40.18900221615299]],
    [ "273392704",[-83.77493624504167, 34.59618748188357]],
    [ "Lebanon Industrial Substation",[-86.33089820357708, 36.21930798053617]],
    [ "273637351",[-122.4603140886102, 48.75972931104277]],
    [ "NorthWestern Energy",[-115.35829735126234, 47.59748489782974]],
    [ "Commonwealth Edison",[-88.44623196231083, 42.298128181992396]],
    [ "274144246",[-115.55049879105253, 47.53810765008784]],
    [ "274144247",[-115.59343326059034, 47.543246501885285]],
    [ "274204228",[-79.08185077742039, 35.88398430813743]],
    [ "Westbrook Substation",[-79.11587759999999, 35.89081855]],
    [ "274472002",[-109.24245160901003, 45.19056078963795]],
    [ "Westwood Substation",[-94.26464806356412, 45.56556291261983]],
    [ "M.E. International Substation",[-94.22611383833939, 45.56302607879693]],
    [ "Crossroads Substation",[-94.2028603477859, 45.55986212138984]],
    [ "Keweenaw",[-88.18013926087659, 47.3686980260645]],
    [ "Memphis Light, Gas and Water",[-89.99008397661414, 35.171371773562385]],
    [ "Bastrop Substation",[-97.32106139812791, 30.130302105252962]],
    [ "Mott Haven Substation",[-73.9066694747549, 40.80780314596231]],
    [ "Pajarito Sub",[-106.28049001296216, 35.85854822271016]],
    [ "North Lake",[-87.73035496544297, 46.50093313235186]],
    [ "275504225",[-106.6497733, 35.077525550000004]],
    [ "Helbig Substation",[-94.15723148341368, 30.156249003183177]],
    [ "Ace Substation",[-74.34308609499824, 41.00375086349844]],
    [ "275857882",[-84.5983476, 38.93033395]],
    [ "Claryville Substation",[-84.39638881203642, 38.91450530307108]],
    [ "275863603",[-84.39377890958447, 38.956820034722874]],
    [ "Giddings Substation",[-96.95109098752225, 30.18411279182273]],
    [ "East 179th Street Substation",[-73.89331465618729, 40.84944781943637]],
    [ "276137246",[-95.90667719702174, 33.23145282369599]],
    [ "Goodyear Seiberling Substation",[-81.47711828080041, 41.055658594473314]],
    [ "276404800",[-80.86701000591644, 34.1457991520598]],
    [ "Decker Switchyard",[-97.61415050000001, 30.3049807]],
    [ "276912381",[-85.46530224537644, 32.606944560509426]],
    [ "Moreau-Grand Electric Cooperative",[-100.87466000000002, 44.94962320000001]],
    [ "East Substation",[-81.6092791519125, 41.49630949153955]],
    [ "277198304",[-88.35223178934812, 44.32041105043456]],
    [ "277198424",[-115.09340753716761, 47.292499043488]],
    [ "Mission Valley Power",[-114.18531702346202, 47.27951689591933]],
    [ "Dakota Substation",[-104.99171509748481, 39.70802458818392]],
    [ "277629130",[-102.79602234999997, 38.778250750000005]],
    [ "Kindred Substation",[-97.01762475000001, 46.6447166]],
    [ "Oxbow Substation",[-96.7999503, 46.69534689999999]],
    [ "East 36th Street Substation",[-73.97133641305923, 40.74494706119334]],
    [ "Southwest Research Institute Substation",[-98.61270367333158, 29.437028721307748]],
    [ "East Bay Substation",[-85.5109494799769, 44.714662593071154]],
    [ "Potter Substation",[-85.5815904601598, 44.689381317081256]],
    [ "Four Corners",[-95.67915918244536, 38.78219376918728]],
    [ "NAS 115 Substation",[-87.27243331609598, 30.357638785991224]],
    [ "279156809",[-108.54511270000002, 43.25791625]],
    [ "Florida Power & Light",[-80.3131469353306, 25.789462577248514]],
    [ "Lake Ruby Substation",[-81.66118467511592, 27.981956657623723]],
    [ "279250835",[-108.4790418016988, 43.005290558335496]],
    [ "279258365",[-82.70174384631427, 28.331028926992676]],
    [ "Port Richey West Substation",[-82.7162026, 28.2745454]],
    [ "New Port Richey Substation",[-82.6809129994843, 28.281495554281047]],
    [ "Elfers Substation",[-82.72290059800933, 28.20653770048541]],
    [ "Motorola Substation",[-80.25180843786453, 26.149320197047448]],
    [ "Odessa Substation",[-82.59699065138803, 28.192687890510904]],
    [ "279401950",[-82.46339831233631, 28.19161470662012]],
    [ "Round Lake Beach TDC",[-88.0557441, 42.378634700000006]],
    [ "279809613",[-108.14724395143035, 43.38749864677606]],
    [ "Mission Valley Power",[-114.13905498818195, 47.529147625033104]],
    [ "Straits Substation",[-84.7359791993245, 45.85868719102706]],
    [ "Lawson Road Substation",[-96.56305885387164, 32.707735919225016]],
    [ "Mesquite Station",[-96.57547585797536, 32.760099817947356]],
    [ "279925289",[-75.58806628348005, 40.806678272328554]],
    [ "279934471",[-82.35561048951915, 28.20054417632308]],
    [ "279934472",[-82.3556834121276, 28.20089790286556]],
    [ "280037217",[-82.2112065746984, 28.171948184331782]],
    [ "280037221",[-82.2376156177178, 28.222290611170944]],
    [ "280037222",[-82.25757216517873, 28.172028433314132]],
    [ "Tennessee Valley Authority",[-86.42997622822827, 35.47583757246678]],
    [ "280068903",[-82.300720174846, 28.22899594248636]],
    [ "280068946",[-82.30091724168626, 28.226513225906906]],
    [ "Acme Substation",[-85.44585757476152, 44.775762144024434]],
    [ "Zephyhills Substation",[-82.19069185762298, 28.229462019574747]],
    [ "280166036",[-81.5355, 37.96575295000001]],
    [ "Davis Substation",[-122.31271584126848, 37.80901715503404]],
    [ "Dade City Substation",[-82.19660983624843, 28.370897173582502]],
    [ "280408645",[-91.88150822638553, 36.69605625181133]],
    [ "280560453",[-93.85491014539352, 46.339909152159905]],
    [ "280674942",[-106.64819063543824, 48.198686355586325]],
    [ "Port Covington Substation",[-76.60559421562238, 39.26603094777687]],
    [ "280778819",[-76.51221427473784, 39.238519680365]],
    [ "Breckwood Substation",[-72.52335935613058, 42.11540564438463]],
    [ "National",[-87.72048165602753, 46.44582457507429]],
    [ "Torrey Pines Substation",[-117.24004451505033, 32.8986795625129]],
    [ "280968368",[-84.84905365657325, 38.962344673125095]],
    [ "Mountain View Substation",[-92.12715764999999, 35.87441820000001]],
    [ "281297614",[-92.34644769814629, 47.45543472632615]],
    [ "PPL",[-76.22725804177871, 40.77526266764982]],
    [ "281819883",[-80.30854987563406, 36.06323431041389]],
    [ "281844209",[-80.25061863765256, 36.10248829831665]],
    [ "Crockett Substation",[-95.37988804715017, 29.776839033299837]],
    [ "Durham Substation",[-122.76359438817026, 45.39850109737508]],
    [ "Dothan Substation",[-85.40112789738862, 31.259954969377965]],
    [ "Nanak Substation",[-80.21247500037929, 26.528743772117004]],
    [ "282386930",[-86.3198338415568, 37.02809447701403]],
    [ "282386931",[-86.33394366864715, 37.034004867435]],
    [ "Wine Creek Station",[-76.48751700000001, 43.46712885]],
    [ "282626424",[-86.48589175000002, 45.90595535]],
    [ "282627756",[-84.40476935, 30.59395185]],
    [ "Coopersburg Substation",[-75.37650016937438, 40.518228866289036]],
    [ "Santa Monica Substation",[-118.48820897019651, 34.017225768477275]],
    [ "Petaluma C Substation",[-122.6367423614947, 38.23914142901788]],
    [ "282975971",[-116.00433709194509, 36.64682884351893]],
    [ "Clam Lake Substation",[-85.23209795, 44.902648449999994]],
    [ "283011260",[-95.9123193572064, 33.25504090874821]],
    [ "283011272",[-96.06634856716549, 33.373565952430475]],
    [ "283014653",[-83.33918135, 35.42420320000001]],
    [ "Brookwood Substation",[-122.93261654036137, 45.529045577538675]],
    [ "283140434",[-116.25131036135973, 36.76241750994119]],
    [ "283206530",[-88.76736840000001, 37.0897]],
    [ "Tennessee Valley Authority",[-88.29196124601451, 37.09818644559217]],
    [ "Purdue Northwest",[-86.92659088543483, 40.4311433391933]],
    [ "Eldorado Substation",[-78.42630323968693, 40.46895220119364]],
    [ "Miles Avenue Substation",[-81.43362491783063, 40.80975559032334]],
    [ "Pickwick Electric Cooperative",[-88.37738455177801, 35.23353725584145]],
    [ "283503719",[-91.94885138901297, 41.91997837505308]],
    [ "283545567",[-119.87435402380433, 47.2337412783247]],
    [ "283545597",[-119.8662201709676, 47.240300740751664]],
    [ "283608200",[-96.11353457167114, 33.15614430329916]],
    [ "283611932",[-96.12554437473953, 33.169167947722414]],
    [ "283611935",[-96.12583719240872, 33.17028840843123]],
    [ "283611938",[-96.17197710655299, 33.16661119788089]],
    [ "283611940",[-96.23460053036696, 33.1417200075545]],
    [ "283611943",[-96.45152854464277, 33.06812035514273]],
    [ "Kenneth Ford Substation",[-93.93800866862746, 33.949340092529155]],
    [ "Southwest Arkansas Electric Cooperative",[-93.88940405746301, 33.9120791314396]],
    [ "Nashville Substation",[-93.85538165, 33.95878815]],
    [ "Okay Substation",[-93.9269887245149, 33.77198450407503]],
    [ "Watson",[-87.41671935000001, 46.01882680000001]],
    [ "Sequachee Valley Electric Cooperative",[-85.37283545051714, 35.40277434548119]],
    [ "283693505",[-85.64179573829792, 35.050123046689166]],
    [ "283807319",[-90.22638105000001, 41.556550800000004]],
    [ "283807757",[-86.45472724366067, 38.7329644431366]],
    [ "Corona Substation",[-117.57173903120767, 33.88426053347803]],
    [ "Perez Substation",[-117.58847194793331, 33.88194855828273]],
    [ "283841600",[-85.53945960706366, 39.363254405321946]],
    [ "283874175",[-82.14024276478307, 39.030860453200006]],
    [ "Ingalls",[-87.6429369, 45.35316255]],
    [ "Grand Rapids Hy",[-87.64845476173899, 45.35444240138952]],
    [ "Urban Substation",[-81.53224851266903, 41.07424033897458]],
    [ "284008005",[-116.242117000138, 37.15192905835309]],
    [ "284008033",[-116.16999718067284, 37.18948666662724]],
    [ "284044008",[-84.48106988047226, 33.927676730632726]],
    [ "Santa Anna Substation",[-99.30483569999998, 31.739666900000003]],
    [ "284094255",[-99.42191015000002, 44.52050695]],
    [ "Wayview Substation",[-81.43023502243469, 40.88885620531782]],
    [ "Marietta Power & Georgia Transmission",[-84.46862871825383, 33.92083581308468]],
    [ "284272126",[-116.77917790367707, 37.88606598487362]],
    [ "Alico Substation",[-81.82911084247911, 26.495329614758287]],
    [ "San Carlos Substation",[-81.8287716645289, 26.493660191589385]],
    [ "Evans Substation",[-81.47383705383032, 41.09416165213882]],
    [ "284373557",[-82.36728327604915, 38.446340360355315]],
    [ "Bayside Substation",[-73.77080124211813, 40.759700423345926]],
    [ "Collinsville Substation",[-78.38716263738465, 40.50274970540404]],
    [ "Fresh Meadows Substation",[-73.79658081898057, 40.73931474551858]],
    [ "284514002",[-96.53253091301266, 32.96238946430844]],
    [ "Lakemore Substation",[-81.40356743951337, 40.99308613139946]],
    [ "Mission Valley Power",[-114.15728542929665, 47.68965263270439]],
    [ "Firewheel Substation",[-96.6403712611968, 32.98126344621558]],
    [ "Apollo Substation",[-96.67747938253294, 32.95381164838373]],
    [ "East Richardson Switching Station",[-96.70079187417959, 32.9567972525554]],
    [ "Richardson Spring Creek Substation",[-96.69627119999998, 32.9831709]],
    [ "Georgia Power",[-84.46918149629431, 33.90477498626579]],
    [ "Georgia Power",[-84.4700020542577, 33.90438232898287]],
    [ "Menges Mill Substation",[-76.88066290045802, 39.87454314867288]],
    [ "Brand Substation",[-96.63770716966934, 32.952258719034155]],
    [ "Fairdale Substation",[-96.66163015580084, 32.9138569887553]],
    [ "284692198",[-94.92842382521259, 36.68997863762727]],
    [ "Demopolis Substation",[-87.79383369954768, 32.515399079868125]],
    [ "Lynn County Interchange",[-101.78949463237488, 33.19658028442503]],
    [ "Woodrow Interchange",[-101.78913994999999, 33.46235335]],
    [ "Crystal Lake Substation",[-88.30225607013534, 42.254865872795065]],
    [ "Puget Sound Energy",[-122.95987627493405, 47.057190027026984]],
    [ "285335062",[-114.9942312, 36.07197515]],
    [ "Marengo Substation",[-88.62842707292576, 42.25367603882597]],
    [ "285377789",[-88.35672492483805, 42.155103009711425]],
    [ "Pierpont Substation",[-89.13639402639859, 42.26405970573316]],
    [ "285381572",[-89.3182960648822, 42.2928958750999]],
    [ "Lancaster Substation",[-89.61809062448786, 42.31841558633128]],
    [ "Lena Substation",[-89.82940575, 42.35882365]],
    [ "285599993",[-119.29171099324704, 47.115305592563786]],
    [ "285599998",[-119.27908542506124, 47.11338044353351]],
    [ "Yazoo City Substation",[-90.39040551466955, 32.88408707632583]],
    [ "Allenport Substation",[-79.84435160670581, 40.0912862687077]],
    [ "285934329",[-105.58920319999997, 41.33519835]],
    [ "Bass lake",[-88.06368395, 45.84046595000001]],
    [ "West Salem Substation",[-82.11156891745433, 40.973172016942634]],
    [ "Reedsburg Substation",[-82.09430810249003, 40.782372829076536]],
    [ "Sulphur Springs Substation",[-95.61349836233931, 33.1319450088984]],
    [ "286203183",[-77.06201821653049, 34.65976352879583]],
    [ "286203196",[-76.95897156535172, 34.67783751152761]],
    [ "286266008",[-95.65941182322429, 33.01685333004004]],
    [ "286266009",[-95.6940917260967, 32.96213398861547]],
    [ "286267504",[-85.03377046225316, 35.045366732832186]],
    [ "Owl Creek Substation",[-104.79921883157606, 40.9448392401473]],
    [ "Belle Plaine Junction Substation",[-92.26077859619552, 41.98564029510575]],
    [ "Luling City Substation",[-97.65433612893231, 29.697462710791886]],
    [ "Harwood Substation",[-97.50456411924448, 29.661074948273388]],
    [ "Waelder Substation",[-97.38778422298599, 29.670986053342457]],
    [ "Moulton Substation",[-97.1402473829379, 29.574259137050642]],
    [ "Yoakum Gaetner Road Substation",[-97.15657254999999, 29.279753199999995]],
    [ "Hallettsville Substation",[-96.98729111372461, 29.42882529914161]],
    [ "286473131",[-96.45711577758256, 32.929443423772405]],
    [ "286473134",[-96.51430643982033, 32.91964848276195]],
    [ "286473135",[-96.54997357346386, 32.90411360699189]],
    [ "286473137",[-96.61403526294727, 32.845285695776845]],
    [ "Pharoah Substation",[-97.35450834743702, 27.70477071582241]],
    [ "Big Bone Substation",[-84.73731225000002, 38.88582525]],
    [ "286685230",[-87.09070213296131, 45.749738983685624]],
    [ "60th St. Substation",[-93.79139583351116, 41.55599037158636]],
    [ "Grandin Substation",[-97.0022235, 47.23950979999999]],
    [ "Readfield",[-88.7702050250913, 44.2699541552283]],
    [ "Brunsdale Substation",[-97.06456229417442, 47.439304002095554]],
    [ "Hill Substation",[-76.72435267477904, 39.80301945454925]],
    [ "City of HIllsboro",[-97.06086964227613, 47.39686272526916]],
    [ "Lincoln Ave",[-88.6282044, 46.08766280000001]],
    [ "Crystal Falls",[-88.35583805, 46.0972148]],
    [ "City of Hillsboro",[-97.07119652478768, 47.403799790155595]],
    [ "Hawaiian Electric Company",[-155.69578962783146, 20.025121978294052]],
    [ "287206606",[-93.17872109476974, 33.06894130300782]],
    [ "Reynolds Substation",[-97.07030615, 47.67228455]],
    [ "287405139",[-83.38898356335562, 37.55047748338095]],
    [ "287413101",[-110.73034785296063, 45.04447845988993]],
    [ "Weakley Substation",[-88.83404486565, 36.27506307581052]],
    [ "Iron Grove",[-88.654202, 46.085460299999994]],
    [ "Strawberry Hill",[-88.65374638650907, 46.08760892508662]],
    [ "Green Acres",[-114.29935691448333, 48.18260972117247]],
    [ "287721445",[-104.75935159999997, 41.75502604999999]],
    [ "287748760",[-94.78980181373481, 36.99797277440444]],
    [ "Chelsea VT Substation",[-72.47051599650356, 43.96061514229069]],
    [ "La Jara Substation",[-107.1199467587816, 36.07587645895736]],
    [ "Agra",[-96.87636826376216, 35.884177029994305]],
    [ "M-38",[-88.60831395411658, 46.788090157304396]],
    [ "287982759",[-111.31851535, 33.05995610000001]],
    [ "287982760",[-111.42221915242014, 33.00769966120618]],
    [ "Seville Substation",[-81.88564825187665, 41.02529979067752]],
    [ "City of Seville",[-81.87637161293435, 41.02979584091763]],
    [ "Ryan Substation",[-81.86593759305285, 41.119938448647794]],
    [ "Valley Substation",[-81.5173989861733, 41.14228251528433]],
    [ "Theiss Substation",[-81.54779856583308, 41.14894407282958]],
    [ "Stadium Substation",[-111.91838501738347, 33.45063615881941]],
    [ "288007192",[-111.93535739940094, 33.44635519828305]],
    [ "Ridgefield Substation",[-73.48746895776061, 41.28316337176796]],
    [ "Carbide Substation",[-91.42479164131308, 40.42816765874215]],
    [ "Elevation St",[-88.59300744999999, 47.13427045]],
    [ "288134774",[-108.54266180756281, 48.84285412515241]],
    [ "Bellows Falls Substation",[-72.44190959425812, 43.13258022898327]],
    [ "Hatton Substation",[-97.45261127496222, 47.64337829676237]],
    [ "Hatton Substation",[-97.45282428177742, 47.642888575034284]],
    [ "288204634",[-91.34328382521822, 40.696974740980814]],
    [ "288234291",[-108.75591154823222, 48.484308895860174]],
    [ "APS Camelback Substation",[-111.9178029979467, 33.51181988916596]],
    [ "SRP Scottsdale Substation",[-111.92439661898406, 33.502806964621485]],
    [ "West Medina Substation",[-81.8790700147686, 41.14022681859612]],
    [ "Reading Substation",[-95.76246191715667, 29.563724422345953]],
    [ "288394171",[-95.40554792950115, 32.49025279927537]],
    [ "East Substation",[-104.82744839318275, 39.73822627569165]],
    [ "288581889",[-108.69118836053262, 47.99898598066925]],
    [ "Oncor",[-96.72416099159729, 33.001132597777755]],
    [ "Honor Substation",[-86.03937625694323, 44.668836899450405]],
    [ "289002784",[-113.56279955, 37.103239099999996]],
    [ "Menger Creek Substation",[-98.72030311478834, 29.76264546516057]],
    [ "Bay De Noc",[-87.61452008422272, 45.17376340388421]],
    [ "Raintree Substation",[-111.88773387077151, 33.62015880453015]],
    [ "Century Substation",[-111.94504904441246, 33.59194610686095]],
    [ "APS Shea Substation",[-111.79875333724127, 33.58105517805159]],
    [ "Station 416",[-77.66467856397364, 43.08175801875442]],
    [ "289481209",[-71.4898185231849, 43.55489755661916]],
    [ "Laconia Substation",[-71.45198155240892, 43.52518673330828]],
    [ "289654548",[-90.81302370775049, 34.980868325442316]],
    [ "Watersmeet",[-89.17540533668193, 46.26671697782219]],
    [ "Fisher Substation",[-90.97102981683699, 35.49390620424165]],
    [ "Tamarac Substation FPL",[-80.29677896992217, 26.19620206953603]],
    [ "North Medina Substation",[-81.88281758997041, 41.16900641030495]],
    [ "Brandon Substation",[-80.21232958500275, 25.913524041417407]],
    [ "289965797",[-80.14466582491671, 25.9543283929629]],
    [ "290035835",[-103.64408055484073, 41.92824344806024]],
    [ "Bsngor Station",[-86.11924843904015, 42.30840712524501]],
    [ "Queensborough Substation",[-79.96734091638119, 32.72279542619522]],
    [ "290264140",[-79.96827164591825, 32.69722622340583]],
    [ "Alcona Dam Substation",[-83.802994095655, 44.561500549422746]],
    [ "290607529",[-114.03947031865582, 47.72487802173241]],
    [ "290614708",[-102.85911235000002, 41.16259715]],
    [ "290614709",[-102.1315144359747, 41.103534769080355]],
    [ "290665241",[-90.56380742254007, 36.06073831542696]],
    [ "Lucas Substation",[-93.70794585916786, 32.40059028217136]],
    [ "291046892",[-111.97239941002732, 33.41633064781992]],
    [ "Weiler Substation",[-111.97068595825588, 33.41632949358091]],
    [ "Peck Road Substation",[-85.23839075000001, 43.2133484]],
    [ "Entergy Arkansas",[-91.54810175, 36.25465105000001]],
    [ "Iliff Substation",[-74.7266530239753, 41.02126349344198]],
    [ "291409820",[-89.62920384088825, 39.743640836342145]],
    [ "Midway Substation",[-93.79464732495794, 32.47128145396324]],
    [ "291652130",[-112.01226105094999, 33.487512902299315]],
    [ "Lawrence Park Substation",[-101.86899677501592, 35.18597300775661]],
    [ "Boyson Commercial",[-91.69915990000001, 42.04539619999999]],
    [ "291852292",[-99.12171786257116, 38.16067937814972]],
    [ "Stardust Substation",[-112.37161739945776, 33.67183368766413]],
    [ "Dysart Substation",[-92.24062056584604, 42.18923740628208]],
    [ "291973696",[-81.59325605627274, 34.71869288357194]],
    [ "291977859",[-83.16695543576823, 35.087931773675884]],
    [ "Murden Cove substation",[-122.52413577625651, 47.6499329756733]],
    [ "Port Madison substation",[-122.54048130311314, 47.679718726643515]],
    [ "Downtown Substation",[-80.19688327797725, 25.769866496723843]],
    [ "Carver Street Ret Substation",[-81.23100944738388, 35.11765468317866]],
    [ "292230184",[-93.43886916086512, 42.68109877474133]],
    [ "292235799",[-81.95069123718052, 39.98282393530112]],
    [ "292243671",[-93.3805223604805, 37.53890897000823]],
    [ "Cliquat Substation",[-93.48600139298122, 37.66859914762668]],
    [ "Duke Energy",[-81.57700035, 35.0901494]],
    [ "292258005",[-81.28920845695858, 35.28027024291757]],
    [ "Pluma Substation",[-103.73863390885097, 44.3589427215609]],
    [ "Pittsburg Converter Station",[-121.89654520000131, 38.030484466027474]],
    [ "292302626",[-111.71238318907949, 33.21867415159766]],
    [ "Texas Avenue Substation",[-89.04714355, 30.3848714]],
    [ "Socastee Substation",[-79.00148001447792, 33.67783310603007]],
    [ "MONROE CENTRAL",[-89.64184945000001, 42.60053020000001]],
    [ "Colorado Springs Utilities",[-104.6936376894405, 38.77987993056741]],
    [ "292653458",[-111.76640545663676, 33.3774975621686]],
    [ "Henry St Substation",[-88.57749981249584, 47.10969221313155]],
    [ "Atlantic Substation",[-88.62727806734301, 47.09842252232524]],
    [ "Georgia Power",[-84.4939893125588, 33.96440094081599]],
    [ "292815840",[-84.49350419572751, 33.96420833158861]],
    [ "North Bluff",[-87.03721765, 45.84881480000001]],
    [ "Hagensville Substation",[-83.75176334910938, 45.34882014153183]],
    [ "293264369",[-94.87817557696616, 42.05659095023068]],
    [ "293325249",[-82.36594648956914, 29.638782453886073]],
    [ "James Olson",[-90.38643752257437, 43.33074831918952]],
    [ "293335649",[-90.37705862663243, 43.31934065901289]],
    [ "293335651",[-90.37588777467188, 43.31923377640178]],
    [ "Sienna Substation",[-95.56129749096722, 29.53809935526684]],
    [ "Friendsville Substation",[-84.12784678686926, 35.75570104835924]],
    [ "Georgia Power",[-84.51509556664081, 33.85830945009081]],
    [ "Hillview Substation",[-123.31257792925844, 44.54603558743398]],
    [ "Georgia Power",[-84.31809539585416, 33.79132977643186]],
    [ "South Georgia Interchange",[-101.86573695, 35.1633533]],
    [ "293769783",[-85.36522796004448, 38.050190090633464]],
    [ "Locust Substation",[-97.13292012002745, 33.25480245508848]],
    [ "293804544",[-80.78675041954749, 35.12026998864766]],
    [ "294041314",[-87.0678241, 45.796812]],
    [ "Mountaindale Substation",[-74.54643834999999, 41.69722395]],
    [ "Bluebell Substation",[-81.0775626370975, 40.91967252425457]],
    [ "Georgia Power",[-84.35242116366406, 33.93579186121169]],
    [ "Mission Valley Power",[-114.06849607232837, 47.15314346300398]],
    [ "Pacific Gas and Electric Company",[-121.11545802469784, 35.60043232688882]],
    [ "Stratton Substation",[-97.8792436085084, 27.621815623941384]],
    [ "San Diego Substation",[-98.25118136626186, 27.743756848470706]],
    [ "Long Island Rail Road",[-73.77092001082062, 40.67903712722033]],
    [ "Centex Substation",[-97.8589175, 30.054033049999997]],
    [ "Lopez Substation",[-122.90005632543794, 48.49275050443921]],
    [ "Mathis Substation",[-97.82388427096409, 28.112171655618837]],
    [ "Sinton Substation",[-97.5126015601122, 28.030866812943394]],
    [ "Boardman Substation",[-80.65586586874214, 41.033021759183065]],
    [ "295149090",[-115.03905276233415, 36.14002677315032]],
    [ "Heights Substation",[-95.39850171551342, 29.782391396364225]],
    [ "Rocksprings Substation",[-100.19914931062847, 30.022909744323275]],
    [ "Rocksprings Substation",[-100.20181079704939, 30.021221418994045]],
    [ "Capitol Substation",[-91.18942618529334, 30.458335459162836]],
    [ "295250042",[-84.52318318703243, 38.099789340820514]],
    [ "295295836",[-93.0746996, 42.694412150000005]],
    [ "East Munday Substation",[-99.60310433876582, 33.453395534723946]],
    [ "Munday Substation",[-99.62074286844361, 33.45026601535736]],
    [ "Surprise Substation",[-112.34347971637268, 33.635520654388245]],
    [ "295549310",[-111.75828528623553, 40.336584218798755]],
    [ "295552544",[-111.78308489317993, 40.37506838603715]],
    [ "Rutledge Substation",[-92.42156161627298, 41.06204455362502]],
    [ "295678310",[-90.36596096654878, 39.1315800934675]],
    [ "Distributing Station 25",[-118.2677820535218, 34.11308598839698]],
    [ "Dunvale Substation",[-95.5189723, 29.733086800000002]],
    [ "Fairview East Substation",[-80.23175932432477, 42.052829179772374]],
    [ "Gore Junction Substation",[-80.1231218547799, 42.0700092699297]],
    [ "Eagle Substation",[-77.97250958765427, 39.49120546799211]],
    [ "Bedington Substation",[-77.91733450456192, 39.51559696923475]],
    [ "Nuthatch Substation",[-93.26108806186778, 42.55787965203003]],
    [ "296122332",[-84.5544432246803, 33.94767170550397]],
    [ "Estacada Substation",[-122.334890511845, 45.285508987216254]],
    [ "296198620",[-93.59689833942198, 42.67504417506241]],
    [ "SRP Cooper Electrical Substation",[-111.80624310877062, 33.25946484542644]],
    [ "296526466",[-111.28090570000002, 47.531734150000005]],
    [ "296526470",[-112.9484976586858, 46.13361252644878]],
    [ "296601804",[-84.09656055595465, 41.41097114907951]],
    [ "296601805",[-84.09641988684422, 41.411677480311894]],
    [ "Metonga",[-88.92001528812678, 45.563056324885814]],
    [ "Belmont Station",[-76.21596082918948, 43.126225374748635]],
    [ "Indianapolis Power & Light",[-86.07913431600575, 39.926392119999875]],
    [ "Harper Road Substation",[-99.15072420167975, 30.073379002869096]],
    [ "Northwestern Energy",[-114.04615231705927, 46.805121145402886]],
    [ "NorthWestern Energy",[-114.06516537060676, 46.797664492302395]],
    [ "Bonner",[-113.872876453995, 46.87517262088352]],
    [ "Lassiter Road Substation",[-84.43791525582078, 34.03103928653205]],
    [ "Dominion Energy",[-76.49780257899184, 37.06204280487934]],
    [ "Henderson Substation",[-105.84587248498896, 39.76886294954724]],
    [ "NW Electric Power Cooperative",[-94.30744547171582, 39.75633648719786]],
    [ "Portal Substation",[-106.02426687662731, 39.796084193081455]],
    [ "297132004",[-95.31835805, 41.63881125]],
    [ "Mill Substation",[-106.07777785522393, 39.846173464924675]],
    [ "297133283",[-118.12479877492956, 33.83021860631345]],
    [ "Kentucky Utilities Company",[-84.58477401005698, 37.89248095986201]],
    [ "297220740",[-80.27287555842058, 36.09372846214494]],
    [ "Guthrie Center Substation",[-94.48908877576197, 41.631214954220056]],
    [ "Scranton Substation",[-94.4746867, 41.98680674999999]],
    [ "Hiawatha West Substation",[-93.23960539224055, 44.95182387399887]],
    [ "297296945",[-93.52208760887191, 41.609391825204035]],
    [ "Parkwood Substation",[-117.9637471220046, 33.91550164911877]],
    [ "Delta Electric Power Association",[-90.31690487499905, 33.7437186905262]],
    [ "Marias River Electric Cooperative",[-111.28399022492823, 48.90715764153028]],
    [ "LADWP Distribution Station 54",[-118.28779802013389, 34.101402160596194]],
    [ "Maquoketa Substation",[-90.69981778581686, 42.05826093242148]],
    [ "Sub 78",[-90.6013384080608, 41.58927364944463]],
    [ "Meade Street substation",[-88.39595145102767, 44.28439395602735]],
    [ "297509890",[-111.77762495965578, 33.219880164075796]],
    [ "Hunt Substation",[-111.58163820510957, 33.201170891330925]],
    [ "Willis Substation",[-111.83612661388402, 33.21818905684533]],
    [ "Pinnacle Peak Substation",[-111.93889245271451, 33.70369403664398]],
    [ "297625028",[-84.02045201429434, 37.065008429608405]],
    [ "297733560",[-111.90077580311812, 40.55602327975993]],
    [ "Moorhead Substation",[-90.50768147788376, 33.45855736443908]],
    [ "297773046",[-113.1532410577582, 46.6643221997996]],
    [ "Franklin Substation",[-95.36776803652529, 29.76609777418982]],
    [ "Sugar Creek Substation",[-85.89574666943285, 39.6540199816206]],
    [ "Adams Ridge Substation",[-80.05116353789215, 40.6904120428818]],
    [ "298119429",[-111.86752483297987, 40.42006567419815]],
    [ "Delmarva Power",[-75.11159768215941, 38.41309874612821]],
    [ "298141733",[-75.18866466417269, 38.36705279449616]],
    [ "Sun River Electric Cooperative",[-111.956759824822, 48.129999804224745]],
    [ "298292709",[-111.62281533052405, 40.18962437200769]],
    [ "298343859",[-112.11277505000001, 48.094457000000006]],
    [ "Sun River Electric Cooperative",[-112.09114650000002, 48.068528750000006]],
    [ "298448254",[-111.9665627394677, 47.654527575043446]],
    [ "Georgia Power",[-84.76558772154809, 33.39248137768219]],
    [ "298596504",[-93.12454762412717, 42.52287194418177]],
    [ "Nags Head Substation",[-75.60801477591502, 35.92038893184615]],
    [ "298794274",[-111.63726102488796, 40.182228121809835]],
    [ "298794275",[-111.61644364070834, 40.15986820247023]],
    [ "Memorial Substation",[-95.61954365170824, 29.789766457965637]],
    [ "298828853",[-93.51882511397999, 42.85588881857519]],
    [ "298849687",[-93.4186664, 42.8554733]],
    [ "Corn Belt Power Cooperative",[-93.28279600583453, 42.855533593388834]],
    [ "298883024",[-84.5976974354242, 38.829256031282114]],
    [ "298893092",[-78.83257378221788, 33.76516800575035]],
    [ "298899934",[-96.78029863228674, 34.31266557419781]],
    [ "299028756",[-111.60722541065073, 40.14081738581322]],
    [ "299028757",[-111.63504315315168, 40.13041862195054]],
    [ "299041248",[-93.5781886250531, 42.487178856422]],
    [ "299126419",[-90.75457899999999, 33.73202535]],
    [ "Connersville",[-85.17576083596938, 39.656211153504444]],
    [ "299335573",[-80.246136677358, 38.93193394946865]],
    [ "299389738",[-110.67934162208182, 47.816737575842055]],
    [ "Iowa Junction Substation",[-91.54056455038709, 41.492835362402104]],
    [ "Paradis Substation",[-90.42949109776981, 29.859514892358604]],
    [ "299501667",[-85.68673262805925, 39.67356928937154]],
    [ "Dairyland Power Cooperative",[-91.50451232422088, 43.06071496797561]],
    [ "299667166",[-110.8219758, 47.808812950000004]],
    [ "Sundance Substation",[-103.8599782760452, 44.66309643714114]],
    [ "Sprigg Substation",[-82.1878060021947, 37.635007283275975]],
    [ "299745596",[-110.84305360000002, 48.55348095]],
    [ "Clearview Substation",[-82.50219085123211, 27.954782523936046]],
    [ "Milroy Substation",[-85.46067649091715, 39.52431197529274]],
    [ "299869059",[-85.28890242457038, 39.58357819450658]],
    [ "Canyon Rock Substation",[-99.74727110270844, 32.38654485856715]],
    [ "299956516",[-90.82438240936469, 43.286756097793294]],
    [ "299960523",[-90.76105001176025, 43.25613764340802]],
    [ "Guidon Substation",[-91.93384542463363, 35.928118693947035]],
    [ "Entergy Arkansas",[-91.82240097317512, 36.01783243104507]],
    [ "C&L Electric Cooperative Corporation",[-91.99275411096575, 33.8262426429232]],
    [ "NIVO Substation",[-77.46050154111032, 39.02341858765255]],
    [ "Vestavia Substation",[-86.55352675854043, 34.67189336103232]],
    [ "Elm Street Substation",[-85.9557829352049, 31.807922784256935]],
    [ "300558796",[-106.60196063766428, 32.0240852422513]],
    [ "Mueller Substation",[-97.68955664444395, 30.289950578297276]],
    [ "300593904",[-90.34689377248857, 29.94624395278877]],
    [ "Lamesa Substation",[-101.93777043970928, 32.71941269577617]],
    [ "Killeen Substation",[-97.73864755831859, 31.104127744387128]],
    [ "300709973",[-87.07520397516323, 31.137232958598897]],
    [ "Indian River Station",[-75.82284863466157, 44.074965397346254]],
    [ "Mount Vernon Substation",[-98.24615744999998, 43.6946908]],
    [ "Entergy Louisiana",[-92.0036263, 32.49535735]],
    [ "Carmel First Avenue Substation",[-86.12761052199596, 39.98623138420306]],
    [ "Bee Street Substation",[-79.95110282535569, 32.78646617031015]],
    [ "Briarwood Substation",[-91.03460915, 30.389108250000003]],
    [ "Hawaiian Electric Company",[-155.81899119292999, 19.97427416107108]],
    [ "Waikoloa Substation",[-155.78388332080397, 19.92063909308353]],
    [ "Hawaiian Electric Company",[-155.77407290848782, 19.927946959490367]],
    [ "Hawaiian Electric Company",[-155.79701776024473, 20.002847473637626]],
    [ "Portsmouth Substation",[-70.78723094487113, 43.09480933876597]],
    [ "301178989",[-81.68447761343509, 35.73770433065178]],
    [ "Hawaiian Electric Company",[-155.87661101853058, 19.90879120294785]],
    [ "301183748",[-81.75075967246575, 35.732311569348354]],
    [ "301183749",[-81.74995360000001, 35.732758000000004]],
    [ "301183750",[-81.7495339756131, 35.732632992448096]],
    [ "301183751",[-81.75040827931316, 35.733827775873436]],
    [ "301183789",[-81.7473789963385, 35.728823444927016]],
    [ "301313200",[-101.68363769663921, 41.567962022545]],
    [ "301313204",[-101.7104857, 41.105010750000005]],
    [ "301313205",[-101.62548583657599, 41.22339078110974]],
    [ "Palm Harbor Substation DUKE",[-82.76450679311843, 28.06895603922421]],
    [ "301390929",[-101.7865147, 42.0024716]],
    [ "301416889",[-79.39027932146236, 36.0623790565711]],
    [ "Cornell Sub",[-106.61997151005502, 35.079318574549674]],
    [ "Arizona Public Service",[-112.6252557705223, 33.673256553771786]],
    [ "NV Energy",[-115.16028470139179, 36.21447870377184]],
    [ "Georgia Power",[-82.00427131267352, 30.84770702492925]],
    [ "301494534",[-82.00413357634386, 30.84828577057464]],
    [ "301604791",[-79.1680847, 37.3753143]],
    [ "301672585",[-93.60790155000001, 42.98041795]],
    [ "301674597",[-90.12776197510958, 33.51193374484226]],
    [ "301677182",[-81.68456710810888, 35.73702843409074]],
    [ "Hancock Substation",[-93.60585136832341, 43.07486797486134]],
    [ "Palatka Substation",[-81.64755477543366, 29.63781265648693]],
    [ "301787610",[-93.43741976769779, 43.07441857639041]],
    [ "301829604",[-81.53685032797105, 28.37704364997201]],
    [ "301843582",[-85.43972889184161, 39.61088107884839]],
    [ "St. Andrews Substation",[-79.9888164005481, 32.78019996648294]],
    [ "Light Plant substation",[-103.54695956279565, 37.98744464321057]],
    [ "Osteen Substation FPL",[-81.16435845013062, 28.85364562431804]],
    [ "Gardner Substation",[-103.55147238126794, 37.983599703721254]],
    [ "Hunt Lane Substation",[-98.66708451731446, 29.414988902758317]],
    [ "Vista Substation",[-116.01077776473608, 36.31732172880419]],
    [ "302157141",[-111.09839495445947, 48.31928626735645]],
    [ "302180727",[-89.76583174999999, 30.2489241]],
    [ "302294228",[-82.29821532925509, 26.887640452780364]],
    [ "302320065",[-76.86791508581568, 39.87007726606242]],
    [ "Virginia Electric and Power Company",[-76.50408744242799, 37.10741247025414]],
    [ "302401523",[-108.77019238282206, 39.17271271046514]],
    [ "Air Base Substation",[-103.520314718765, 38.035682860196424]],
    [ "302439138",[-118.61313815764595, 46.97812637585195]],
    [ "302521641",[-110.12102618194338, 48.17679700543633]],
    [ "Polar",[-88.99067437476525, 45.16728798942604]],
    [ "McCully Substation",[-157.83344817542354, 21.290570897440702]],
    [ "Lakeside Substation",[-112.24019613517284, 33.8160105860337]],
    [ "Mohawk Substation",[-85.84058669480858, 39.810794128410535]],
    [ "Lee Substation",[-81.9169319413066, 26.698381010578768]],
    [ "Ena Substation",[-157.83476875000002, 21.28614335]],
    [ "Pearsall Road Substation",[-98.60155222904936, 29.356925737672633]],
    [ "Fisheating Creek Substation DUKE",[-81.4083568751934, 27.266351291686686]],
    [ "303217200",[-112.14021259642485, 33.84602410386101]],
    [ "Prineville Substation",[-120.85405772412317, 44.307676680069385]],
    [ "303256518",[-82.92082191593094, 40.145550637413834]],
    [ "Weber Substation",[-81.68659227525731, 26.23198715413758]],
    [ "West Substation",[-91.099483, 41.449687049999994]],
    [ "Bayfield Substation",[-91.09819869739998, 41.466407056930315]],
    [ "Madison Substation",[-112.03944705891242, 33.51076433835751]],
    [ "Evansville Muni",[-89.29242750061331, 42.777561536649735]],
    [ "303650610",[-93.59777362525934, 42.52871904396436]],
    [ "303658163",[-93.56060191184561, 42.45530772506819]],
    [ "303668786",[-90.45946783270416, 43.66724169796191]],
    [ "Greenfield Substation",[-82.72761242566743, 41.432774412209135]],
    [ "303690836",[-82.72903293138123, 41.4329318639104]],
    [ "New Departure Substation",[-82.72256430849147, 41.43170185760468]],
    [ "303833329",[-93.87017529999999, 43.14830084999999]],
    [ "Alvin Substation",[-95.25397740811286, 29.433716802507323]],
    [ "Duke Energy",[-80.20237467405568, 33.699171603540336]],
    [ "Kenilworth-35 Substation",[-73.71600266790102, 41.00789815250134]],
    [ "Lenoir City Utilities Board",[-84.2625882077727, 35.79806151739878]],
    [ "Wheeler Substation",[-108.09406636138785, 39.473907500013624]],
    [ "Crystal Lake Wind",[-93.8312502370958, 43.211865475083584]],
    [ "Entergy Mississippi",[-89.91949102313383, 33.498179459601715]],
    [ "Tavares Substation",[-81.75351951564608, 28.800743755303117]],
    [ "Hayden Substation",[-116.84909816364453, 47.756158075191735]],
    [ "Van Buren Substation",[-83.64901784292421, 41.15247880550604]],
    [ "Shaw Substation",[-112.09734894992266, 33.586221274648366]],
    [ "Cheryl Substation",[-112.1076388067503, 33.58051696787532]],
    [ "Plantation Road Substation",[-84.03139529537809, 33.91080816498568]],
    [ "Baldwin Creek Substation",[-95.33642233350037, 38.986706475136316]],
    [ "Mount Vernon Substation",[-91.37957967861064, 41.97165154511336]],
    [ "Alliant Energy",[-91.55221439028756, 41.96552296819438]],
    [ "Kittanning Substation",[-79.5166261280311, 40.79473652606922]],
    [ "Airport Substation",[-80.4163217304326, 27.644944454516267]],
    [ "304385958",[-87.85148235, 30.642294249999996]],
    [ "Wyoming Substation",[-91.07387158533447, 42.04716609540186]],
    [ "El Dorado Substation",[-95.1416275, 29.561908350000003]],
    [ "Holmes Substation",[-95.37211734044088, 29.67945277529843]],
    [ "County Line Substation",[-80.37427733682097, 27.558082274792998]],
    [ "Neversink Substation",[-75.91722111109223, 40.30989442839113]],
    [ "304622693",[-80.6606596197529, 41.104298451027006]],
    [ "Karns City Substation",[-79.71728332235969, 41.0057461988552]],
    [ "Alpha Substation",[-83.38511153421297, 36.18154623293012]],
    [ "Pearland Substation",[-95.32264298864241, 29.56019169075484]],
    [ "304817103",[-99.7439460525921, 40.68357944605141]],
    [ "304854616",[-93.51714323802457, 43.177110725076375]],
    [ "Clodine Substation",[-95.62076856853064, 29.674798317764743]],
    [ "Westheimer Substation",[-95.61730443044534, 29.736607437698208]],
    [ "Wyoming REC Substation",[-91.07376648829336, 42.04816609114753]],
    [ "Hohokam Substation",[-111.97790162035994, 33.44101457771368]],
    [ "Delmar Substation FPL",[-80.15293996965113, 26.335844087515483]],
    [ "MidAmerican Energy",[-94.84160334876273, 42.08651240991039]],
    [ "Mccomb Substation",[-83.7984611378705, 41.1135187064276]],
    [ "Grand Mound Substation",[-90.66454379526101, 41.84430870625144]],
    [ "305215181",[-100.36262760745609, 44.3790015911991]],
    [ "305215344",[-96.93442592793957, 42.79014402445743]],
    [ "Dakota Dome Substation",[-96.92879569999997, 42.79322020000001]],
    [ "Calamus East Substation",[-90.68564671191128, 41.82244367166366]],
    [ "305586937",[-85.3908261372694, 40.21930827506771]],
    [ "305658305",[-114.48173227508146, 42.695480354631385]],
    [ "Kent Substation",[-75.55872691370247, 39.1512216824151]],
    [ "Scuse Substation",[-75.55947562008801, 39.150659208838995]],
    [ "305803863",[-80.97067135549462, 35.0630021934256]],
    [ "Orange Substation",[-78.10920164353975, 38.240515734443235]],
    [ "305808850",[-91.32726464999999, 44.14812125]],
    [ "305880040",[-99.03687027523951, 40.72772893813829]],
    [ "305933600",[-91.83385445142683, 44.22664814948844]],
    [ "305935041",[-91.7727028492568, 44.18764573928776]],
    [ "Marshalltown West Main Substation",[-92.96191870088943, 42.04792903642557]],
    [ "306163604",[-106.30450466529233, 31.72204777867404]],
    [ "Belmont Substation",[-71.05471427993132, 42.06582715335062]],
    [ "Maxwell Substation",[-100.52330499602259, 41.13673645180896]],
    [ "306188997",[-91.00661939851237, 43.28779272602515]],
    [ "Hillside",[-91.12187458429959, 43.03536882436166]],
    [ "Gran Grae",[-91.00420849105984, 43.05918105996216]],
    [ "306192991",[-91.17061065, 43.74663635]],
    [ "306193110",[-91.23877962140409, 43.8277953540076]],
    [ "French Island Substation",[-91.25944239655321, 43.8286243551539]],
    [ "Mill Street Substation",[-70.93787944232773, 41.995461441978954]],
    [ "Sand Road Substation",[-91.50562743282852, 41.598095630931134]],
    [ "Krumkill Substation",[-73.82562201245182, 42.661150625729576]],
    [ "SRP Griswold Substation",[-111.86141567157591, 33.36480015296746]],
    [ "SRP Clemans Substation",[-111.89490525573166, 33.34867531544079]],
    [ "Arizona Public Service",[-111.97979739796969, 33.64201339862482]],
    [ "Wauzeka",[-90.88034693397823, 43.089743316085965]],
    [ "306436144",[-90.99012035, 43.125339600000004]],
    [ "Glacier Electric Cooperative",[-112.30376219999998, 48.95704289999999]],
    [ "306453114",[-111.84778979735624, 33.335663950565205]],
    [ "306453860",[-122.84445919999999, 46.04564144999999]],
    [ "306461515",[-111.93797235000001, 40.555956550000005]],
    [ "Willow Pass Substation",[-121.96115152701339, 38.02474011223021]],
    [ "306471352",[-84.71499170832327, 38.78476592878232]],
    [ "306512348",[-87.5004980501897, 41.62978967977777]],
    [ "306704685",[-98.95870171339388, 41.259794624661154]],
    [ "306706027",[-93.20183779964637, 42.91466005132631]],
    [ "Trenton Substation",[-68.37453274346737, 44.438882732850495]],
    [ "306742088",[-102.88914521945668, 42.09595342469435]],
    [ "306742089",[-102.90078352928263, 42.10430661536318]],
    [ "306744225",[-110.77200489999998, 48.81257065]],
    [ "306766162",[-115.81437078849358, 47.522151567755834]],
    [ "Alliance Substation",[-102.90716164299228, 42.10318573291379]],
    [ "306781102",[-90.98456996583961, 42.70907397435052]],
    [ "Turkey River Substation",[-91.03238936462412, 42.701322781475895]],
    [ "306781286",[-91.00742147463845, 42.72314217919273]],
    [ "306782613",[-115.98127042815833, 47.496009448620015]],
    [ "Chocolate Bayou Substation",[-95.35269018723952, 29.627877924834724]],
    [ "Cedar Heights Substation",[-73.5554100897903, 41.106738726530374]],
    [ "307081281",[-115.78549572693218, 47.47147818634423]],
    [ "307083779",[-98.38775128393956, 40.944867330061065]],
    [ "307083780",[-98.38767338362459, 40.9239392669425]],
    [ "307083782",[-98.3593456, 40.883664100000004]],
    [ "Westfall Substation",[-78.41927022376728, 40.512895663888116]],
    [ "Mountain Parks Electric",[-106.30076224674046, 40.046497394801065]],
    [ "Lamar",[-88.96469869072541, 42.773163645361706]],
    [ "307210004",[-89.00480091494796, 42.7248176748446]],
    [ "HARMONY",[-88.99037462242954, 42.73979507269083]],
    [ "Wisconsin Power & Power",[-89.00538001831289, 42.72389605453355]],
    [ "Isleta Sub",[-106.65896815973846, 34.937966127828545]],
    [ "307249172",[-94.34889811958645, 44.89167181995283]],
    [ "Windy Gap Substation",[-105.98673589299295, 40.11190091121661]],
    [ "Snake Creek Substation",[-103.17100261632595, 42.04600805154385]],
    [ "307358082",[-89.00325766481274, 42.63882592498523]],
    [ "307374171",[-110.0060806, 47.34617095000001]],
    [ "Water Plant Substation",[-96.58894993415024, 46.267798799483266]],
    [ "North Plains Substation",[-122.99237738492937, 45.60043750711586]],
    [ "307514581",[-110.06425137503886, 47.27189919238707]],
    [ "307516394",[-89.02673010255214, 42.582449369531425]],
    [ "Boc Gasses",[-89.03570660878559, 42.58152156709256]],
    [ "Forge 2",[-88.87251162640118, 42.549453841213015]],
    [ "Laprairie",[-88.9629044011675, 42.605135738910676]],
    [ "307611294",[-78.34333965161093, 35.01048280071441]],
    [ "307640888",[-93.6755267, 42.62252445]],
    [ "307647843",[-115.89831711651003, 47.48798301746402]],
    [ "Kewalo Substation",[-157.84925703019832, 21.294552425131183]],
    [ "307662303",[-89.01826218179474, 42.52758051115916]],
    [ "Cranston",[-88.9807279560166, 42.5179254083344]],
    [ "Hawaiian Electric Company",[-157.85627520194848, 21.29919150228951]],
    [ "Wahpeton Northwest Substation",[-96.61525171453741, 46.27593334591147]],
    [ "307671056",[-87.46977285007745, 41.6003822459464]],
    [ "307736727",[-102.88827717380121, 42.29642584597865]],
    [ "307736730",[-102.93567622973437, 42.511253067856]],
    [ "Chadron Substation",[-102.99917637746915, 42.84759675889445]],
    [ "307736733",[-102.88837425716675, 42.29727659746537]],
    [ "Emery 161 Substation",[-93.29314010461604, 43.09588131947292]],
    [ "Emery 69 Substation",[-93.29001370537202, 43.09826795047324]],
    [ "307814805",[-88.95330044999999, 42.70656195]],
    [ "West Darien",[-88.72689316052097, 42.59589634485849]],
    [ "Delavan",[-88.64034775312871, 42.62962504498484]],
    [ "307816580",[-88.54186983937048, 42.66174773103256]],
    [ "Bristol",[-88.61441542596269, 42.64062990871169]],
    [ "Southwest Delavan",[-88.67543685782724, 42.614457267982864]],
    [ "Walworth",[-88.59910449647577, 42.53762268531232]],
    [ "Cumberland Substation",[-72.61736409806261, 42.57161600244978]],
    [ "American Transmission Company",[-89.05262576417222, 42.68617817488868]],
    [ "Duke Energy",[-82.32344795235744, 34.89763861787432]],
    [ "Nine Springs Substation",[-89.35869213720056, 43.03842637249462]],
    [ "308315661",[-115.05654727183047, 36.114462618085746]],
    [ "Sylvan Lake Substation",[-73.72198765514119, 41.594974319875824]],
    [ "MONTICELLO",[-89.59359764957667, 42.746823805644944]],
    [ "Aurora St",[-89.14085028969066, 45.14552505252643]],
    [ "Martin Road Substation",[-88.43115597465982, 43.7400400913738]],
    [ "308446280",[-103.39411307741995, 42.68258737502033]],
    [ "Briarcliffe Substation",[-78.77159954897901, 33.79184569347467]],
    [ "Dunes Substation",[-78.82226441688357, 33.75541318318634]],
    [ "Morganfield Substation",[-87.9184344473463, 37.68931244568358]],
    [ "West Barnstable Substation",[-70.35032282181577, 41.68585676609204]],
    [ "Merchant's Way Substation",[-70.29832577926207, 41.68519307509307]],
    [ "308688949",[-89.17148522836276, 45.15663830430781]],
    [ "308820226",[-76.30969279234442, 36.83262482578211]],
    [ "Bell Substation",[-80.32684631596148, 25.77521977475241]],
    [ "308983459",[-94.7917314687565, 35.464054548534094]],
    [ "308983470",[-94.78961688155033, 35.47285175632795]],
    [ "Mountain Parks Electric",[-105.89419038660859, 40.1416177747075]],
    [ "309074379",[-102.27944601707279, 40.950184385788255]],
    [ "Rochester Gas & Electric",[-78.07331704999999, 42.2962965]],
    [ "Antonio Substation",[-106.0064053601521, 37.070799995189645]],
    [ "309442905",[-85.50400287893764, 39.95357473163373]],
    [ "Perch Lake",[-87.96255834123887, 46.40241022759111]],
    [ "309477273",[-111.15534989999999, 47.36300925]],
    [ "309478250",[-93.12338530000001, 43.14041855]],
    [ "Fair Lawn Substation",[-74.12844368601947, 40.94952324135498]],
    [ "309506080",[-91.21883743544119, 43.86921551299874]],
    [ "Cedar Creek Substation",[-91.2355751467768, 43.910980790834884]],
    [ "69",[-105.90644960585338, 37.991989752223866]],
    [ "309756025",[-82.62111160268637, 34.81984637034075]],
    [ "309806113",[-102.81161248680552, 41.71331923105632]],
    [ "Bighorse Substation",[-102.30971412261053, 41.51068260617002]],
    [ "Blue Creek Substation",[-102.2120329997737, 41.40961203557829]],
    [ "309806116",[-103.03643378806616, 41.84445805069954]],
    [ "Colorado Substation",[-118.47221186713283, 34.0256002663523]],
    [ "309836893",[-110.80984118386314, 47.587387951272845]],
    [ "Sugarcreek Substation",[-81.63666327606413, 40.50492636140356]],
    [ "309855606",[-90.35491805154167, 42.40027296674921]],
    [ "309857785",[-90.11365291430421, 42.095009099531126]],
    [ "309858919",[-90.07017295000001, 42.089673700000006]],
    [ "309863101",[-89.7918195, 41.114916050000005]],
    [ "Kerber Creek",[-106.01113908847397, 38.32930461022486]],
    [ "310099976",[-82.38177665889174, 34.85504942280367]],
    [ "Story County II Wind Energy Center",[-93.37399651964601, 42.224582103679516]],
    [ "310108234",[-82.31513842912801, 34.87903254024461]],
    [ "310108236",[-82.31405894096994, 34.844087660736115]],
    [ "310108243",[-82.32368236267622, 34.8312793098551]],
    [ "310108245",[-82.40140291687315, 34.7846365295982]],
    [ "310108250",[-82.42292442280949, 34.71730995762321]],
    [ "310110596",[-98.93230926691191, 40.525361659125416]],
    [ "310110597",[-98.87617333207588, 40.65571005951304]],
    [ "310113724",[-85.39313955000001, 39.930373700000004]],
    [ "310140692",[-84.69556011584214, 33.80797785594403]],
    [ "310140693",[-84.69489144957707, 33.80853301282725]],
    [ "North Campus Sub",[-106.62371089999999, 35.0922001]],
    [ "310165303",[-106.62390191865272, 35.092002036108326]],
    [ "310174545",[-82.35948655725367, 34.887914526992525]],
    [ "310244795",[-93.13643195016913, 44.80541375000867]],
    [ "310269772",[-89.69959930794684, 40.78276032506852]],
    [ "310314337",[-95.40789756022149, 45.85273023009946]],
    [ "Quabbin Tower Substation",[-72.39599053920288, 42.27946508956235]],
    [ "310321256",[-95.383354505416, 45.89297103010511]],
    [ "310328725",[-88.32943650000001, 44.73134919999999]],
    [ "310377236",[-82.34221832489999, 34.816103812650304]],
    [ "Bridgestone Substation",[-85.88386119748586, 35.62994061579904]],
    [ "Duck River Electric Membership Corporation",[-86.1349811763185, 35.54158725529483]],
    [ "Douglas County Substation",[-95.14988501056307, 45.85365076288665]],
    [ "310469788",[-88.316982, 44.61297725]],
    [ "Douglas Substation",[-80.25375544335914, 25.747558525641686]],
    [ "Thedford Substation",[-100.51083955292238, 41.97983437019285]],
    [ "310554940",[-79.42854779837535, 36.5741602915129]],
    [ "Jackson Substation",[-75.37978240043374, 41.034613796697855]],
    [ "Arrowhead Substation",[-75.5864443343965, 41.15612087191054]],
    [ "Churchtown Substation",[-73.74241676893348, 42.193177264975475]],
    [ "310750185",[-85.77416257465283, 39.668741246054324]],
    [ "310751154",[-82.3323388689098, 34.8077410027303]],
    [ "310752313",[-108.59198891339594, 37.35750044215519]],
    [ "SRP Jackrabit Substation",[-111.88639236319158, 33.517315814506084]],
    [ "Maryville Substation",[-79.99372348612923, 32.79590430759385]],
    [ "East Gate Substation",[-111.714715097123, 32.88287614865242]],
    [ "310954521",[-82.2877964634324, 34.89744669041184]],
    [ "310954534",[-82.14272481103576, 34.95228717539752]],
    [ "310960242",[-82.24108453860708, 34.91967230164659]],
    [ "310960245",[-82.26611721123201, 34.91229384902718]],
    [ "310960256",[-82.25337242562868, 34.902124833942516]],
    [ "Northwestern Energy",[-112.02210784631635, 46.70388570003306]],
    [ "311016611",[-89.0692979815204, 34.26259712036434]],
    [ "Barlow Substation",[-85.60505369595934, 44.758063257993584]],
    [ "Georgia Power",[-83.41105293450836, 33.951129838435634]],
    [ "311062011",[-85.77113267305255, 39.82366381323225]],
    [ "311064059",[-85.79241670093974, 39.827603856074695]],
    [ "311132650",[-91.40645671004104, 44.752322220777835]],
    [ "Dahlberg",[-91.82018986715347, 46.11064701222867]],
    [ "Caledonia",[-89.51763196936878, 43.46870008269574]],
    [ "Calarnus Substation",[-99.98097055709042, 42.24994155178855]],
    [ "311342823",[-112.03094565, 46.604566]],
    [ "Sterling TDC",[-89.64966726401529, 41.80816999934124]],
    [ "311374816",[-87.61236207404126, 45.102108328409486]],
    [ "Parnell Substation",[-92.06444522951183, 41.56436004347169]],
    [ "311488989",[-83.44106268966159, 42.64480276973114]],
    [ "Orchard Road Substation",[-84.2612812, 43.63736485000001]],
    [ "South Hamburg Substation",[-75.97995583356729, 40.5456278460229]],
    [ "311510458",[-82.44810576267004, 34.8201137193172]],
    [ "Middleboro Substation",[-70.90400212403532, 41.89127290953168]],
    [ "Porter Rockwell Substation",[-111.90814323172928, 40.48662476668324]],
    [ "311825153",[-111.94035111063948, 46.591868004334806]],
    [ "Moody AFB Substation",[-83.21217648750127, 30.967709043165986]],
    [ "TSS 169",[-89.02730940000001, 41.8251156]],
    [ "311851590",[-88.99945376751144, 41.82608305133252]],
    [ "Consumers Energy",[-84.1990536, 43.60893825]],
    [ "311852912",[-91.82324552670234, 46.35950155506171]],
    [ "Dixon Substation",[-89.49546722992497, 41.84236295969941]],
    [ "West DeKalb Substation",[-88.79193109054037, 41.950222857090246]],
    [ "Glidden Substation",[-88.72826030424649, 41.93621340921764]],
    [ "312016260",[-80.14174850777168, 33.03620050360737]],
    [ "312018738",[-111.94584212735761, 33.53164693842927]],
    [ "312098599",[-88.46467219778528, 43.75467916298758]],
    [ "312109131",[-78.92936993543955, 36.00267223186434]],
    [ "312154550",[-96.67499475052752, 33.14823581702523]],
    [ "312174904",[-96.65530659766642, 33.155280692786654]],
    [ "312193349",[-84.29044760086673, 39.22129397107455]],
    [ "312334982",[-85.53733875992985, 39.793961215453955]],
    [ "Virginia Electric and Power Company",[-76.30603562566226, 36.726179779078194]],
    [ "WE Energies",[-88.42599889044193, 44.61053210067266]],
    [ "312573743",[-88.57056130829926, 44.824933925279986]],
    [ "Emmet Substation",[-98.77579422527914, 42.54334811972694]],
    [ "Sharpstown Substation",[-95.48726774092641, 29.701381960924596]],
    [ "312877818",[-111.73536276512905, 33.46751673826834]],
    [ "312877821",[-111.71906538075383, 33.47344009327841]],
    [ "312962686",[-112.7393653, 34.2277269]],
    [ "313033400",[-109.94460295, 32.45666655000001]],
    [ "313033401",[-109.94479242479817, 32.46437169701035]],
    [ "313033402",[-110.01560035, 32.5141771]],
    [ "Spencer Substation",[-98.63000618074481, 42.84784233351692]],
    [ "313174982",[-100.58295335, 42.84028099999999]],
    [ "313174983",[-101.36767280000001, 42.84332535]],
    [ "313196156",[-111.55958135932686, 33.39390641854571]],
    [ "313200516",[-90.33563851802207, 38.75845122768385]],
    [ "Woolworth Road Substation",[-93.90259207210731, 32.399785337673485]],
    [ "313202107",[-90.32884215000001, 38.72901445]],
    [ "313251425",[-88.52711269999999, 44.761241749999996]],
    [ "EAST SHAWANO",[-88.58258309254138, 44.77165607742296]],
    [ "313428196",[-85.1651638449141, 39.81151146743219]],
    [ "313511295",[-80.71383665711483, 41.100385211848014]],
    [ "Riverview Substation",[-101.41117074489793, 35.71368926704436]],
    [ "313520432",[-88.58697699926878, 44.774442681661704]],
    [ "313535622",[-88.62391373518723, 44.83511727731521]],
    [ "313538514",[-112.25615928500994, 33.426178081869544]],
    [ "SRP Bassham Substation",[-111.70945885763065, 33.48142473934863]],
    [ "313550083",[-98.83695520369727, 40.872486890606694]],
    [ "313550088",[-98.47326571547829, 40.87224046619109]],
    [ "WEST SHAWANO",[-88.63031918476129, 44.77298424383082]],
    [ "313604214",[-98.34044697934021, 40.77033605945153]],
    [ "313604217",[-98.36353496627981, 40.61113216666876]],
    [ "Ed Bluestein Substation",[-97.66209784240544, 30.27053655983241]],
    [ "313720401",[-98.40285495, 40.55401609999999]],
    [ "313720405",[-98.38910381753506, 40.600326574351705]],
    [ "313725013",[-81.5513687385145, 35.890486596188474]],
    [ "313725015",[-81.55220261949879, 35.89008195369572]],
    [ "Multnomah Substation",[-122.71178405456452, 45.466504953137004]],
    [ "Harvey Substation",[-87.64243125867004, 41.596881558277566]],
    [ "313775771",[-112.54235412321049, 33.436165383470666]],
    [ "Tuthill Substation",[-112.49844867652452, 33.46718311040228]],
    [ "East Carbondale Substation",[-75.48334789358604, 41.56243576634981]],
    [ "43rd & Lorraine Substation",[-97.90314359450974, 38.10039007121173]],
    [ "Bondual Substation",[-88.44645006443571, 44.73485094748244]],
    [ "Meadowlark Substation",[-97.94917733892134, 38.08687493639886]],
    [ "3rd & Van Buren Substation",[-97.94660779381033, 38.055988250788076]],
    [ "Huntsville Substation",[-98.32543333299726, 38.05229320664824]],
    [ "Midtown Substation",[-95.37146489999999, 29.7414929]],
    [ "314012484",[-78.98132505, 39.0452408]],
    [ "314048981",[-99.36001033519281, 40.39463813780552]],
    [ "314054634",[-112.21333436493788, 33.62549924517301]],
    [ "314055062",[-87.46676162467728, 41.491100697209205]],
    [ "Armawalk Substation",[-73.77173322545083, 41.28538274884997]],
    [ "314063051",[-87.49145534207892, 41.53718678040044]],
    [ "314075077",[-112.8597842912807, 33.34631580111595]],
    [ "314075085",[-112.72829633853688, 33.36382841407286]],
    [ "314090757",[-97.31814493858984, 37.747564562936155]],
    [ "314090762",[-97.29850586267733, 37.735950775215244]],
    [ "17th Street Substation",[-97.33243016964015, 37.7149477356002]],
    [ "314108168",[-84.9301307700586, 39.92553634037767]],
    [ "Pomona Park Substation",[-81.59775928943053, 29.491400379096614]],
    [ "Crescent City Substation FPL",[-81.51490964999999, 29.444474250000003]],
    [ "314211116",[-112.84215088960214, 33.407034509747476]],
    [ "Appalachian Power Company",[-82.59015563629409, 38.402416334391106]],
    [ "314393013",[-82.75855871523802, 38.3633559038967]],
    [ "314393028",[-82.68564515000001, 38.345148050000006]],
    [ "314394288",[-82.61969624976446, 38.36048415022096]],
    [ "314394289",[-82.7156748, 38.50334134999999]],
    [ "Bellefonte Substation",[-82.67251837732633, 38.49665331955403]],
    [ "Appalachian Power Company",[-82.12753103811433, 38.42660750292947]],
    [ "314531266",[-109.37488214999999, 47.562125400000006]],
    [ "314548198",[-94.44857069103118, 32.70164524589271]],
    [ "314568544",[-99.48550903626531, 40.15514420469877]],
    [ "Six Mile Substation",[-85.20924424259745, 34.180249822277695]],
    [ "Georgia Power",[-85.2870752761056, 34.22581814925063]],
    [ "314681113",[-115.14306887285255, 36.11513026503527]],
    [ "314684177",[-111.83460278054672, 33.276258883835666]],
    [ "314697383",[-88.69774333858638, 44.70852538367586]],
    [ "Crimora Substation",[-78.83356304946881, 38.14851451654528]],
    [ "Hagerstown Substation",[-85.16009218130155, 39.903648165008875]],
    [ "314777721",[-109.86616351789982, 47.90017267488587]],
    [ "Jones Substation",[-111.88108528013446, 33.276782764872216]],
    [ "314809624",[-84.88786115249965, 38.78778012314986]],
    [ "Bulow Substation FPL",[-81.11941212326366, 29.41148823697227]],
    [ "Georgia Power",[-85.22504847372959, 34.27965429908949]],
    [ "SRP Lehi Substation",[-111.76272944059984, 33.43775951319681]],
    [ "Grace Street Substation",[-76.22775020167174, 38.7822711886864]],
    [ "Bozeman Substation",[-76.24788614220424, 38.81060274258086]],
    [ "SRP Wortman Substation",[-111.74065686574758, 33.26388310904092]],
    [ "Killeen Park Street Substation",[-97.72945530395909, 31.125689979971952]],
    [ "Castroville Substation",[-98.81590737063448, 29.358770420121093]],
    [ "Lytle Substation",[-98.80417292125796, 29.25070262903332]],
    [ "PROGRESS",[-88.59367840288556, 43.99073179725938]],
    [ "Georgia Power",[-85.32542416711867, 34.26532544695939]],
    [ "315575876",[-82.1190860464723, 39.311803543754564]],
    [ "315636006",[-85.30107831466826, 39.62877037377556]],
    [ "315647255",[-85.16325819999999, 39.6496161]],
    [ "315711485",[-88.76095184150122, 44.937685722485874]],
    [ "Coast Electric Power Association",[-89.36403184782984, 30.302358397052615]],
    [ "Hillsview Substation",[-103.88093849873323, 44.50269635948768]],
    [ "315995715",[-110.84821994999999, 43.50583855]],
    [ "315996072",[-110.83630601729759, 43.53768745125185]],
    [ "316009257",[-85.16549482065479, 34.31782389405702]],
    [ "316037989",[-88.99064693321846, 44.884301743373804]],
    [ "316142101",[-109.41324772215945, 47.05857949828975]],
    [ "316157866",[-88.3804834675576, 36.01928889879445]],
    [ "Tigerton",[-89.06248104253305, 44.74578727489713]],
    [ "Georgia Power",[-85.17687056608044, 34.26430345549793]],
    [ "Georgia Power",[-85.2114943983297, 34.28630727731321]],
    [ "Cass Road Substation",[-85.6218028133601, 44.73489457386671]],
    [ "316440953",[-80.73898683454549, 32.87752608456483]],
    [ "316455231",[-85.17349461853121, 34.240347062990615]],
    [ "316464696",[-84.29753234479479, 38.37697092957081]],
    [ "316464698",[-84.28982175305738, 38.37860783643167]],
    [ "Forward",[-89.77006523589904, 42.89735131417576]],
    [ "Blanchardville",[-89.86257470000001, 42.8168754]],
    [ "316623057",[-84.57053054184432, 38.03605723009469]],
    [ "316623300",[-85.16658628033062, 34.276554314740146]],
    [ "Kentucky Utilities Company",[-84.54961847113583, 38.008474928278524]],
    [ "316631250",[-85.1691906706858, 34.259620832548926]],
    [ "Wackerly Substation",[-84.18872010806923, 43.65763084434776]],
    [ "Blue Lake Substation",[-74.25058008077836, 41.15965328037767]],
    [ "Lakes Road Substation",[-74.25681463984546, 41.16519243034875]],
    [ "316827669",[-78.58872993853578, 36.35233382504636]],
    [ "316827670",[-78.58901887286058, 36.351945896981064]],
    [ "CWEC WHITTENBERG",[-89.1437388100147, 44.83490564290678]],
    [ "WITTENBERG",[-89.15819710374629, 44.84013952902447]],
    [ "316965692",[-98.33875046391229, 40.11705383197697]],
    [ "316965693",[-98.06030029306683, 40.03057554980823]],
    [ "316965694",[-97.59299695030086, 40.177036348007285]],
    [ "City of Maryville Electric Department",[-83.93215670013656, 35.75429686662197]],
    [ "Blockhouse Substation",[-83.94180693544892, 35.70537810717084]],
    [ "Boardman Substation",[-85.61978337800433, 44.69728591107261]],
    [ "316993631",[-116.91137923725776, 32.57383128045937]],
    [ "La Grave Substation",[-85.66500092904394, 42.961331458265775]],
    [ "Washington Substation",[-74.98670003972713, 40.76580361691244]],
    [ "317084454",[-97.57774287245167, 40.18715187494038]],
    [ "317084455",[-97.1804642085787, 40.22695440392634]],
    [ "Collinsville Substation",[-85.84589675926254, 34.280478324099626]],
    [ "317135695",[-81.8656187026463, 37.728576661858995]],
    [ "317152973",[-109.25288398430422, 46.300687474485315]],
    [ "317288695",[-84.88162815582906, 38.18489385955299]],
    [ "Newcomerstown Substation",[-81.60209752597049, 40.25858445420496]],
    [ "317313621",[-84.28145722516187, 31.585045289686917]],
    [ "317340177",[-112.27320094393681, 33.52213459025048]],
    [ "317407834",[-96.38696545999589, 40.5379236852007]],
    [ "Mississippi Power",[-88.89640826734858, 30.432398244400723]],
    [ "Evergy",[-97.34684902478658, 37.73304808882388]],
    [ "Montville Substation",[-74.36461536237678, 40.9130942533383]],
    [ "Brooks Corners",[-89.04224572477871, 44.9211723055323]],
    [ "Rhodhiss Hydro Substation",[-81.43744556287095, 35.774606585919074]],
    [ "317758299",[-77.55478143423342, 35.87646141509659]],
    [ "Otter Creek Substation",[-93.11029451228954, 42.37448463791546]],
    [ "317808100",[-106.60096353941506, 35.05591287505656]],
    [ "BRIAMWOOD",[-89.22005896910379, 44.928238374723854]],
    [ "Friendly Lane Substation",[-122.8525963375253, 45.425251668869166]],
    [ "Leon Creek Switchyard",[-98.57513000253, 29.35029676948589]],
    [ "Medina Base Substation",[-98.63472674448825, 29.380688311194522]],
    [ "Carmel Substation",[-106.03859519499576, 37.385629399590115]],
    [ "Cave Junction Substation",[-123.63761746616026, 42.165932857787276]],
    [ "Cumberland Electric Membership Corporation",[-86.55535318453204, 36.38159406910947]],
    [ "318000441",[-77.07090077157012, 35.55251945981019]],
    [ "Jonesboro City Water and Light",[-90.7305014379323, 35.828981224837925]],
    [ "New River Substation",[-82.20519895394278, 29.96997787583065]],
    [ "Water Oak Sub #12",[-82.18833142296168, 30.059425058631373]],
    [ "Union Correctional Institution CLAY",[-82.1875698279745, 30.06137359464116]],
    [ "318151818",[-97.06276900784505, 41.263219002874585]],
    [ "318162472",[-78.64491065376214, 35.77352018779592]],
    [ "318168458",[-81.83657673618684, 27.90274976871219]],
    [ "North Bartow Substation DUKE",[-81.83491480706886, 27.908555236661385]],
    [ "318212434",[-111.8343842681621, 33.30294118557344]],
    [ "318270210",[-75.68721479758331, 35.215852971771696]],
    [ "Cameron Substation",[-80.70899590009047, 33.56366636667997]],
    [ "St. Vincent Substation",[-86.19932008756552, 39.905034321518855]],
    [ "318398287",[-82.161909, 32.00675365]],
    [ "Ohoopee River Substation",[-82.16191895125905, 32.0060995053983]],
    [ "OCI Alamo 1",[-98.45566704699812, 29.27143252931907]],
    [ "Duke Energy",[-86.04822225265208, 39.9436367382645]],
    [ "318505763",[-94.66944859999998, 40.23411959999999]],
    [ "Miller Substation",[-111.8757099868544, 33.30379790278705]],
    [ "318513856",[-111.91058835856991, 33.303190205365595]],
    [ "318528838",[-89.27533194567064, 31.252727629318507]],
    [ "318590977",[-85.89088720376334, 39.88445401625086]],
    [ "318638245",[-96.2882858718609, 41.83393592516115]],
    [ "Redford Substation",[-83.25471955930821, 42.416379120752175]],
    [ "Station 46",[-77.6473208081048, 43.20428828961581]],
    [ "Panther Springs Substation",[-98.51764049999998, 29.6655355]],
    [ "RS-27",[-111.88534180093411, 33.274125548453696]],
    [ "318676416",[-111.88098508203171, 33.2686213247057]],
    [ "Gardner's Lane Substation",[-90.69118398750966, 42.54342419246221]],
    [ "Rittenhouse Substation",[-95.37941734651619, 29.863630128325173]],
    [ "318772500",[-81.57587452454614, 34.39452834565194]],
    [ "318774841",[-84.71084895, 38.207851500000004]],
    [ "318893592",[-81.84039117312629, 37.90781842976806]],
    [ "318895345",[-110.23625390565543, 31.97215633555615]],
    [ "Cardinal Lane Substation",[-97.76880879999999, 30.2337676]],
    [ "Elbridge Substation",[-76.46178275724688, 43.02348937397145]],
    [ "Martin West Substation",[-82.19622966366578, 29.302334935290173]],
    [ "Batesland Substation",[-102.10062965, 43.1128011]],
    [ "Mountain Parks Electric",[-106.57772434153127, 40.379929551912625]],
    [ "Hobart Street Substation",[-70.90596902549798, 42.22142218257984]],
    [ "Langdon",[-75.8159178801549, 42.08451635704928]],
    [ "319056085",[-81.63137720000002, 35.754119900000006]],
    [ "Braunig Switchyard",[-98.38270104061614, 29.2580203255645]],
    [ "Arthur Von Rosenberg Switchyard",[-98.38427406386808, 29.25822351759209]],
    [ "319170070",[-106.4784811852615, 48.635448040343455]],
    [ "Tri-County Substation",[-98.27085567575011, 29.6100304198925]],
    [ "319242523",[-86.5846104191498, 41.6898607104611]],
    [ "319265069",[-111.87519859178092, 33.22123078840764]],
    [ "319265420",[-111.88530896144161, 33.23821421510043]],
    [ "319267333",[-111.88717863578117, 33.30187615982664]],
    [ "First Electric Cooperative Cooperation",[-92.0671244292653, 35.01224910810063]],
    [ "Entergy Arkansas",[-92.2203080045413, 34.8812281834313]],
    [ "319290328",[-86.37889043334293, 39.837539341204206]],
    [ "The University of Texas at San Antonio",[-98.62525122225148, 29.58629439058717]],
    [ "319388646",[-111.94971769845664, 33.30481818238832]],
    [ "Poteet Substation",[-98.60995419710939, 29.0382492479545]],
    [ "Rossville Substation",[-98.68173675785376, 29.164328781846187]],
    [ "319416601",[-92.63513233872905, 44.85585799425911]],
    [ "Harlandale Substation",[-98.49584291700606, 29.36334104942051]],
    [ "319829139",[-84.3890222396387, 39.03797167131908]],
    [ "Hamilton Substation JEA",[-81.72163324246411, 30.28361041815153]],
    [ "Los Angeles Heights Substation",[-98.52643293743387, 29.466824968435247]],
    [ "Dresden Drive Substation",[-98.50827151684388, 29.498672181572154]],
    [ "Hot Wells Substation",[-98.45467868945643, 29.37006609672206]],
    [ "319958616",[-103.94499072521054, 32.41434629179981]],
    [ "319958617",[-103.93473424999999, 32.419053899999994]],
    [ "319958621",[-103.93678043202277, 32.34956834685523]],
    [ "319960888",[-103.93959093664843, 32.483534680221986]],
    [ "319960891",[-103.9413295507507, 32.487897813702446]],
    [ "Linden Substation",[-87.83420310081293, 35.62169278453858]],
    [ "319973823",[-103.77173337513574, 32.47316929340179]],
    [ "36th Street Substation",[-98.5689133505418, 29.39819481925647]],
    [ "Fort Sam Substation",[-98.43794553221116, 29.45537959782782]],
    [ "Waterboro Substation",[-70.69575265000002, 43.57678535]],
    [ "Rock Hill Substation",[-74.59858996613097, 41.62377291600307]],
    [ "Hondo Substation",[-99.10397130119712, 29.315554694839477]],
    [ "Hondo Creek Substation",[-99.08438337294349, 29.27239243200055]],
    [ "Devine Substation",[-98.8974348198098, 29.133964280997713]],
    [ "Pearson Substation",[-98.92424539587644, 29.2629574978255]],
    [ "Hondo Substation",[-99.15099362515404, 29.34523765517523]],
    [ "Lytle Substation",[-98.8447026268588, 29.21667015283802]],
    [ "320128477",[-108.78104818650048, 48.524841375022824]],
    [ "320128478",[-108.76054329979131, 48.59748714382586]],
    [ "320135774",[-108.75998812273616, 48.524643070470894]],
    [ "320141816",[-81.6831681448083, 35.739503075443125]],
    [ "Mountain Parks Electric",[-106.29204797162912, 40.72290833393995]],
    [ "320331802",[-110.53182150618338, 33.17468514647981]],
    [ "SRP Manor Substation",[-111.8758395, 33.3314423]],
    [ "Capitol Cement Substation",[-98.41967259531725, 29.54799869781848]],
    [ "320448592",[-107.45767923000783, 48.470791002431376]],
    [ "320448594",[-107.56180841243982, 48.43825887502768]],
    [ "320448596",[-107.3798281, 48.46907935000001]],
    [ "320455660",[-98.64900508321972, 36.783570683874196]],
    [ "Oklahoma Gas & Electric",[-98.66427312037808, 36.808727747791714]],
    [ "Mauermann Road Substation",[-98.50753994130851, 29.28452440843311]],
    [ "Palo Alto Substation",[-98.54970897888923, 29.318257741131045]],
    [ "Consumers Energy",[-85.47738531604668, 43.613019605935776]],
    [ "Consumers Energy",[-85.47787129328735, 43.61319059927499]],
    [ "Trumbo Substation",[-98.50460146738486, 29.21015040326791]],
    [ "Schertz Substation",[-98.26150336150177, 29.56361051547903]],
    [ "Delhi Substation",[-91.5148809910704, 32.459557580854785]],
    [ "Spanish Gardens Substation",[-112.35213789576359, 33.653591045729236]],
    [ "320710940",[-89.37287867589077, 31.328166486918203]],
    [ "Reidsville Substation",[-82.1348954330699, 32.06069874678966]],
    [ "Canyon Substation",[-122.69120900619056, 45.51672232245407]],
    [ "Medina Lake Substation",[-98.93314660322199, 29.612534281489264]],
    [ "Hodenpyl Substation",[-85.82011621510695, 44.36371705897546]],
    [ "Five Channels Hydro",[-83.67570315, 44.45579075]],
    [ "Cooke Dam Substation",[-83.57123771358883, 44.47246305327816]],
    [ "Foote Hydro Substation",[-83.4401836418899, 44.434931121627585]],
    [ "Raymond F. Barker Substation",[-99.04617483425145, 29.958329903702392]],
    [ "Verde Creek Substation",[-99.05508540030819, 29.933146450154137]],
    [ "Mason Creek Substation",[-99.02232962142033, 29.76057666570978]],
    [ "Bandera Substation",[-99.11152702708627, 29.736429721214545]],
    [ "Clear Lake Substation",[-96.67704736948366, 44.75390460344276]],
    [ "320789375",[-74.37812400000313, 40.44373826708793]],
    [ "320897967",[-81.70314055, 35.75345695]],
    [ "320897968",[-81.70346345815274, 35.7537322771649]],
    [ "320898666",[-81.67633525000001, 35.741975249999996]],
    [ "Lincoln Park Substation",[-75.98336503848523, 40.30949600871216]],
    [ "321021418",[-75.60712860101351, 40.394250559583]],
    [ "Georgia Power",[-84.06254964869589, 33.88192353281076]],
    [ "Tuttle Switchyard",[-98.41870266794814, 29.52917872115678]],
    [ "Levely Substation",[-84.3847769, 43.81344115]],
    [ "Consumers Energy",[-84.38520587487994, 43.81337964057955]],
    [ "Smallwood Dam Substation",[-84.33588759999999, 43.9593202]],
    [ "Mio Dam Generating Substation",[-84.13138741292767, 44.661379137584795]],
    [ "Silverville Substation",[-79.71828092623228, 40.68523897812395]],
    [ "AEP South Decatur Substation",[-84.93268962423629, 40.80368418364452]],
    [ "321238348",[-85.88019710415696, 39.83265835000554]],
    [ "321241717",[-104.37980404025981, 32.17362662485461]],
    [ "Tallulah Substation",[-91.1794469, 32.41896645]],
    [ "Darnell Substation",[-91.44900155719311, 32.67800744994999]],
    [ "Zenon Substation",[-83.11284163977977, 42.31422863997795]],
    [ "Moon Valley Substation",[-112.06358692292692, 33.61216197679055]],
    [ "Eastlawn Substation",[-84.1868265168971, 43.62519059918146]],
    [ "Bowling Green Electric Substation No 4",[-83.61109676000456, 41.3820251332066]],
    [ "Tennessee Valley Authority",[-82.29668113450604, 36.54216117820297]],
    [ "321389365",[-82.31442940000001, 36.53179645]],
    [ "321575026",[-80.02708453316968, 38.43740809574115]],
    [ "321578479",[-112.86899395278144, 43.54504771246843]],
    [ "321593811",[-80.1330604, 38.55926935]],
    [ "SUNY Cortland",[-76.20643960085744, 42.589957665813934]],
    [ "Liberty South",[-94.43158454337684, 39.21451751390659]],
    [ "321743228",[-122.77203285, 48.112032899999996]],
    [ "321750602",[-81.40718018445163, 35.72273006800128]],
    [ "321758796",[-108.69814241745223, 32.34919275239445]],
    [ "321840920",[-111.80587074148119, 33.22223855325853]],
    [ "Krugerville Substation",[-96.99331961092531, 33.278153587036705]],
    [ "321946686",[-109.74945576804777, 32.80936281334985]],
    [ "322007715",[-76.22317748415489, 43.1829050172604]],
    [ "Hudson Substation",[-73.76739316407968, 42.251691239922316]],
    [ "322051868",[-82.72779447124786, 27.80712779831388]],
    [ "Del Norte Substation",[-124.13918407780223, 41.86761394356153]],
    [ "Topsail Substation",[-77.5572669052855, 34.43882642531736]],
    [ "Remsburg Substation FPL",[-80.23583709882085, 26.288137252460523]],
    [ "Masspower Substation",[-72.53183172940498, 42.156880018217805]],
    [ "Cadwell Switching Station",[-72.5470428294289, 42.149189293629306]],
    [ "Parsons Substation",[-85.56929845, 44.747506400000006]],
    [ "322378887",[-112.30680808448052, 34.61759480656539]],
    [ "Middlebelt Substation",[-83.33326875038594, 42.362241048551674]],
    [ "Mallard Substation",[-83.33132569496814, 42.35035984164435]],
    [ "322409727",[-106.86249578814447, 34.437761086187486]],
    [ "Hastings Park Substation",[-85.79238683957358, 39.81871530679085]],
    [ "Rivertown Substation",[-85.76525159707091, 42.88342143251601]],
    [ "Jones Road Substation",[-79.01596545000002, 33.6971814]],
    [ "322604434",[-111.33477773911359, 34.239696475016885]],
    [ "322646505",[-86.10358178019173, 40.67831189937342]],
    [ "322659503",[-108.0819513, 48.3690181]],
    [ "322659504",[-108.08248632805186, 48.36897954366852]],
    [ "322659505",[-107.8630520748227, 48.35906984642264]],
    [ "Florida Substation",[-83.41958958403978, 42.35305832496816]],
    [ "Konig Substation",[-78.92259532285567, 33.70917138507484]],
    [ "322697447",[-96.2560416733132, 40.189194700312335]],
    [ "Devens Substation",[-71.60979563860575, 42.55306649631705]],
    [ "Westinghouse Substation",[-80.28782526607965, 26.286965703345917]],
    [ "322890659",[-69.60839722337988, 44.576622539294625]],
    [ "Butterfly Substation",[-80.2006496250603, 26.303095039866683]],
    [ "Hammond Road Substation",[-85.59480024999999, 44.713099799999995]],
    [ "322994571",[-80.8233818134444, 35.144815074527585]],
    [ "Besicorp Empire Substation",[-73.74858138083242, 42.62412722077851]],
    [ "323098111",[-80.10900162067816, 26.38484498258937]],
    [ "323167009",[-81.71629385, 35.7510748]],
    [ "Airport Substation",[-97.44743820704964, 25.906239555121104]],
    [ "Toney Substation",[-86.71940265674124, 34.89996610992319]],
    [ "Creston Substation",[-94.35959599813232, 41.05764721328447]],
    [ "Tiny Town Substation",[-105.22058568219688, 39.58737686654391]],
    [ "Goodyear Substation",[-95.25697031730412, 29.706194127495618]],
    [ "323488554",[-93.97406994531094, 40.235259265348375]],
    [ "323542200",[-83.6642558492509, 41.38571772069283]],
    [ "323564292",[-85.38124167038958, 39.97573289468395]],
    [ "323565547",[-85.37786019728676, 39.885508595168965]],
    [ "New Castle Substation",[-85.35309554380895, 39.91603177194623]],
    [ "New Castle I Avenue Sub.",[-85.35457389999999, 39.9173046]],
    [ "Spiceland Substation",[-85.40363418292283, 39.860324291205636]],
    [ "Martin Co Substation",[-105.10419140050558, 39.4933726594819]],
    [ "Newport Utilities",[-83.20383604248123, 35.97056899887288]],
    [ "Lamey Substation",[-88.94621114999998, 30.471892800000006]],
    [ "Glennville Substation",[-81.91324763058505, 31.92985309430104]],
    [ "Georgia Power",[-84.15899870520988, 33.997454717672]],
    [ "323755640",[-113.62326914975009, 37.11734017808383]],
    [ "Findlay Substation",[-80.22328298154846, 40.45990051904794]],
    [ "Cass Road Substation",[-85.62370207210581, 44.7265514077982]],
    [ "Rainbow City Substation",[-86.06560928187052, 33.93711940396027]],
    [ "Bell Creek Substation",[-83.35442344755465, 42.416795391888215]],
    [ "323997043",[-122.56154679229243, 48.457631118845555]],
    [ "Essex Hilltop-19 Substation",[-73.11610260170781, 44.48262795367847]],
    [ "IBM Substation",[-73.10709590065018, 44.483865224705525]],
    [ "LaCreek Electric Association",[-101.70570201225698, 43.227677833955525]],
    [ "LaCreek Electric Association",[-102.33583934999997, 43.047394049999994]],
    [ "Davis Substation",[-83.36244614668622, 42.54342396760396]],
    [ "Alamo Cement Substation",[-98.37442288736563, 29.611782977912046]],
    [ "Western Area Power Administration",[-101.3759864, 43.228078700000005]],
    [ "Madison Substation",[-100.65365612505201, 43.32546228770874]],
    [ "324345439",[-101.37609780000001, 43.22209335000001]],
    [ "324365705",[-84.35286424657593, 33.80951263479095]],
    [ "Depot Street Substation",[-71.5172437661271, 42.130024837654744]],
    [ "324429901",[-116.11531751073537, 33.100502175102044]],
    [ "324513179",[-83.06665588923963, 39.99074451740383]],
    [ "324621642",[-86.59943332838034, 38.32410276899946]],
    [ "324952728",[-83.69275180526577, 39.0130154019589]],
    [ "324981741",[-83.57014982561525, 38.94291397213781]],
    [ "Winner Substation",[-99.84780248555337, 43.35795578861513]],
    [ "Wharten Substation",[-100.08661685, 43.360974450000015]],
    [ "Raybrook Station",[-74.0827157, 44.301280999999996]],
    [ "Brickyard Tap Substation",[-84.43673881263722, 30.48861619170097]],
    [ "Jett Substation",[-97.80647593660692, 30.374718336205635]],
    [ "Johnson Substation",[-72.67037799999999, 44.639303399999996]],
    [ "Lake Colby",[-74.12809932104832, 44.35260121099483]],
    [ "Paul Smiths Station",[-74.24120942093542, 44.429986695214374]],
    [ "Rosebud Electric Cooperative",[-99.29589544999999, 43.187457050000006]],
    [ "325315216",[-99.41619852507428, 43.244599145458814]],
    [ "325315217",[-99.67189446419185, 43.24397315939191]],
    [ "Middlesex-2 Substation",[-72.6861243335286, 44.291660544832034]],
    [ "Middlesex Substation",[-72.6794599713956, 44.289163472301745]],
    [ "Irasville-39 Substation",[-72.8359955682431, 44.18887420501299]],
    [ "Huntwoods Substation",[-91.17964689696001, 40.796526061706686]],
    [ "325334335",[-91.21903052376736, 40.833756496439115]],
    [ "McCullough Substation",[-101.87857036044635, 33.56710987498648]],
    [ "325358381",[-81.6614210054744, 35.721569251770966]],
    [ "325358384",[-81.66182924983701, 35.72121249570717]],
    [ "Le Grand Substation",[-92.78563383486552, 42.004451068265084]],
    [ "Bonesteel Substation",[-98.94400297497761, 43.05379804784908]],
    [ "Rosebud Electric Cooperative",[-98.94277013438668, 43.05356237503513]],
    [ "Rinehart Substation",[-81.33007821070764, 28.810263224833275]],
    [ "Iwilei Substation",[-157.86734199762677, 21.317798412048166]],
    [ "Iwilei Substation",[-157.86773335151415, 21.317166674353942]],
    [ "Hager Substation",[-83.43381784682582, 42.41751247273177]],
    [ "Monument Substation",[-104.78575134746318, 39.07882652197759]],
    [ "Milford Depot Substation",[-71.51167889965777, 42.129881385172936]],
    [ "325803617",[-112.5243300095721, 46.0273710091106]],
    [ "326024662",[-88.20138572397956, 30.678865146692974]],
    [ "326025234",[-88.20922873124103, 30.640006552134846]],
    [ "326049169",[-84.66479803340398, 30.606800079443065]],
    [ "Pandora Substation",[-83.95688606475018, 40.94620096042994]],
    [ "Florida Power & Light",[-81.29786784999999, 28.811842399999996]],
    [ "Richland Substation",[-85.29868504066437, 44.18931160979995]],
    [ "326205977",[-86.5014057755279, 34.33884428581883]],
    [ "Indian River Substation",[-84.60893497507018, 45.42143945856085]],
    [ "Joe Wheeler EMC",[-87.15660998890628, 34.53108517505563]],
    [ "Higgins Substation",[-84.61316793421383, 44.42175577759158]],
    [ "California Substation",[-104.98324057873533, 39.752629972195045]],
    [ "Columbus Grove Substation",[-84.05940827833433, 40.923678522831125]],
    [ "326391982",[-86.80112563204979, 33.37463820725248]],
    [ "326391984",[-86.80011555616069, 33.420745213823494]],
    [ "Hoover Substation",[-86.80719264497176, 33.390458185459124]],
    [ "326398483",[-100.38089025000001, 44.3677622]],
    [ "326398486",[-100.31246955000002, 44.38882340000001]],
    [ "326398489",[-100.40887815, 44.37073325000001]],
    [ "326398495",[-100.34600265282677, 44.382144998818454]],
    [ "326398496",[-100.3319101639585, 44.37230573406303]],
    [ "326477189",[-147.724621561711, 64.81606542669591]],
    [ "326645147",[-90.85806266749881, 46.602909597447805]],
    [ "Vernon Substation",[-84.76414227501208, 43.81226984211635]],
    [ "Varney Substation",[-112.343397023769, 33.58682816038374]],
    [ "Hall Street Substation",[-85.62730491704879, 44.76496843915869]],
    [ "326840696",[-109.3732900530248, 37.281096254786824]],
    [ "Waldo Substation",[-84.19186370000001, 43.64071425000001]],
    [ "326877554",[-73.59687546978418, 40.656961725247584]],
    [ "Colby Substation",[-86.0911260247441, 41.997310658377614]],
    [ "NJT Summit Substation",[-74.38846950802876, 40.72481161857925]],
    [ "326918889",[-85.96885302489788, 42.10193655630249]],
    [ "Midwest Energy & Communication",[-86.05568920000002, 42.03458365000001]],
    [ "326955716",[-88.14669558211042, 30.66604909665227]],
    [ "Niles Board of Public Works",[-86.23920981327124, 41.81705148086767]],
    [ "327001093",[-86.73830217349007, 41.79020003639852]],
    [ "327016016",[-88.04759313990274, 30.664276885427935]],
    [ "Richards Substation",[-105.99944744295122, 35.63229275124291]],
    [ "Titus Lake Substation",[-85.64665059999999, 42.635615249999994]],
    [ "Eagle Butte Substation",[-101.28162550542908, 44.98992010061881]],
    [ "Manchester Substation",[-73.87979734999999, 41.68908284999999]],
    [ "Genoa Substation",[-83.90482522138434, 42.57597759700333]],
    [ "Former UNC Tap Point Station",[-104.68380739540872, 40.40673991640549]],
    [ "Monfort Substation",[-104.6859181822477, 40.44058831938262]],
    [ "327359543",[-88.06577564785384, 30.747288980536535]],
    [ "Bridgeport Harbor Substation",[-73.1842141175816, 41.17225476694067]],
    [ "Bridgeport Energy Substation",[-73.18536359435605, 41.16996086364173]],
    [ "327528545",[-88.16685600000001, 30.712526750000006]],
    [ "Greely Substation",[-104.71711267272406, 40.42195480037353]],
    [ "Devil's Hill Substation",[-98.4123566511025, 29.9223457468026]],
    [ "327712145",[-88.23782930000002, 30.66530295]],
    [ "SRP Alameda Substation",[-111.91973657130895, 33.39340690228126]],
    [ "Wicksville Substation",[-102.58787109999997, 44.0829102]],
    [ "Leprino Substation",[-104.67412105264663, 40.41599067076019]],
    [ "Cayucos",[-120.87034266015499, 35.448737738451015]],
    [ "Atascadero Substation",[-120.67146123719685, 35.465503800100805]],
    [ "Baywood",[-120.81143555930171, 35.3611869258654]],
    [ "Foothill",[-120.70591575209843, 35.286684549190014]],
    [ "Goldtree",[-120.69310147679195, 35.31997639722815]],
    [ "Goldtree",[-120.69310613891808, 35.32053542263003]],
    [ "Oceano",[-120.58106259883976, 35.101569223348235]],
    [ "PG&E - San Miguel Substation",[-120.68403349902904, 35.7523565637463]],
    [ "Lizella Substation",[-83.82120638539418, 32.822703919490536]],
    [ "Summerton Substation",[-84.72629122359608, 43.57502230894286]],
    [ "SRP Hughes Substation",[-111.81141156712542, 33.45819914438814]],
    [ "Evergreen Substation",[-111.83258988842928, 33.49475337403709]],
    [ "328119627",[-82.58371520200315, 34.62997145076955]],
    [ "328119689",[-82.53032674432303, 34.60516292526928]],
    [ "328269318",[-111.70582119772948, 33.3922886553607]],
    [ "SRP Lacy Substation",[-111.75493760537886, 33.34715468971339]],
    [ "Fergus Electiric Cooperative",[-108.35608203511721, 46.99434833208523]],
    [ "Winnett",[-108.3566934836795, 46.99813447466433]],
    [ "328478742",[-82.26515657850392, 34.83099554511843]],
    [ "328478743",[-82.26421643234279, 34.83080357067882]],
    [ "328478745",[-82.23492292432131, 34.86954910296722]],
    [ "Western Area Power Administration",[-103.24937068597949, 44.589510587517346]],
    [ "Mack Station",[-82.973548822427, 42.385707892210135]],
    [ "328840045",[-82.23330754947835, 34.802259216489645]],
    [ "328840047",[-82.3041162869704, 34.82020616143484]],
    [ "328845120",[-82.28903952209859, 34.828931452932714]],
    [ "328845121",[-82.28369554999999, 34.8277533]],
    [ "Dobbins Substation",[-80.56747855271198, 41.003575727238484]],
    [ "328908786",[-82.6279787462485, 34.50649394774232]],
    [ "328908788",[-82.64503191676259, 34.513564862226005]],
    [ "328972638",[-85.4711654741488, 32.58640801190969]],
    [ "Network Substation",[-81.03893876291575, 34.00150214498786]],
    [ "Electricity Substation",[-69.81618944778205, 43.90420347220229]],
    [ "Masonville",[-86.98852557440203, 45.90502675380316]],
    [ "Delta",[-87.14290532535304, 45.78040474472257]],
    [ "Perkins",[-87.10307116116635, 45.975819032947385]],
    [ "329056287",[-82.70323977474332, 34.46827421285438]],
    [ "329057262",[-82.67366147753741, 34.487280644912]],
    [ "329064517",[-82.69485089999999, 34.449738249999996]],
    [ "329064861",[-82.69102918453827, 34.451953188476224]],
    [ "Owens Corning Switching Station",[-82.65838272671768, 34.43847181413734]],
    [ "Owens Corning Substation #2",[-82.65689735000001, 34.43604545]],
    [ "Owens Corning Substation",[-82.65894739184814, 34.437359445283754]],
    [ "329102047",[-81.04861160291465, 34.00040301586147]],
    [ "329139919",[-93.89220482512529, 45.411782753333156]],
    [ "329149464",[-82.21024209394203, 34.81620380958817]],
    [ "329154082",[-92.78747065, 42.214609800000005]],
    [ "Haviland-45 Substation",[-73.72782261501699, 41.019025112945386]],
    [ "White Plains Substation",[-73.7721595411279, 41.033737804305964]],
    [ "Ethelridge-90 Substation",[-73.74535074398571, 40.99265945871354]],
    [ "329242130",[-82.68568069999999, 34.374320850000004]],
    [ "329243479",[-82.65533917468042, 34.47358572700329]],
    [ "329251343",[-82.65636426987062, 34.50757377065179]],
    [ "329251349",[-82.65096273656766, 34.56024949575973]],
    [ "Plum Substation",[-79.72386446824876, 40.47227085243874]],
    [ "Wildwood Substation",[-79.97399736927152, 40.59451474922621]],
    [ "Arsenal Substation",[-79.96155240995974, 40.46270000432306]],
    [ "329292575",[-91.85069402913543, 37.34055920869306]],
    [ "329374600",[-85.79770152464243, 39.773231651374914]],
    [ "329476968",[-84.39538316074305, 41.09258797476029]],
    [ "Vanderbilt Substatoin",[-84.68322931128857, 45.14228865728374]],
    [ "Plantation Pipeline Substation",[-82.60486890000001, 34.4834431]],
    [ "329707909",[-93.70376517487296, 41.57289296004417]],
    [ "Valdese Retail Substation",[-81.52678025040652, 35.7371665832662]],
    [ "Sperryville Substation",[-78.22053152425383, 38.65847753953178]],
    [ "329780140",[-82.70096336609483, 34.53862282306205]],
    [ "329780905",[-82.70472241194796, 34.55244298839233]],
    [ "329780906",[-82.74203292445976, 34.59816169840601]],
    [ "329814138",[-82.70294179999998, 34.5427406]],
    [ "329814144",[-82.7037973092879, 34.54001550932492]],
    [ "329814147",[-82.71025450647282, 34.54247090743437]],
    [ "329819419",[-82.69234943205583, 34.53257412640865]],
    [ "329819420",[-82.62719486708342, 34.57997580849712]],
    [ "Dexter Substation",[-82.20203467035064, 39.11423533515522]],
    [ "329839153",[-81.6324250754704, 39.28298879399885]],
    [ "Porterfield Substation",[-81.6337036673816, 39.28466645923869]],
    [ "329847475",[-85.80133595889956, 39.77923194828286]],
    [ "329918105",[-104.8013634909126, 40.09588811136412]],
    [ "Kimberly Substation FPL",[-80.22084226648397, 26.391872690876216]],
    [ "329980744",[-91.82371882394591, 46.643745456388466]],
    [ "329984418",[-82.61127624978428, 34.62523559995067]],
    [ "Michelin Substation",[-82.76006021595597, 34.592886148129324]],
    [ "330126243",[-82.90430563301567, 40.11943331386498]],
    [ "330149466",[-82.80324428533498, 34.58460529240641]],
    [ "Winners Substation",[-80.20534767474695, 26.428271190085656]],
    [ "Sandalfoot Substation FPL",[-80.21974656479664, 26.336761624836257]],
    [ "330277764",[-90.26740785121028, 43.739240560222555]],
    [ "Margate Substation",[-80.21728562014991, 26.259242672709007]],
    [ "330370682",[-106.52550204150491, 35.13015489000421]],
    [ "Miner Substation",[-90.29459787512498, 42.562164555983436]],
    [ "Georgia Power",[-84.47037592676985, 33.86427023482754]],
    [ "330587419",[-106.3851288174815, 31.780138601301488]],
    [ "Queen City Substation",[-73.21860633438362, 44.44570666088932]],
    [ "Nevada Substation",[-94.37943472703985, 37.85646505856101]],
    [ "Buffalo Road Substation",[-80.0125799147789, 42.14450964724246]],
    [ "Downing Avenue Substation",[-80.04206113851897, 42.13675826664724]],
    [ "Benton Substation",[-90.40672472488784, 42.57301840351873]],
    [ "331040411",[-90.42823285, 42.6090936]],
    [ "North Intertie Substation",[-81.49835516468238, 40.54198625437118]],
    [ "Mohawk Substation",[-81.19735984657572, 40.67887484882114]],
    [ "331106445",[-78.8444874324104, 35.87092691257688]],
    [ "331116649",[-92.8745195, 42.275260249999995]],
    [ "Mount Vernon Substation",[-98.32488612472515, 43.687480404477796]],
    [ "331153032",[-108.80174787690932, 47.05457445746083]],
    [ "Garfield Substation",[-85.6939021, 44.76615640000001]],
    [ "331292125",[-92.77062862497363, 42.470377392198806]],
    [ "331306850",[-92.91586484999999, 42.433704999999996]],
    [ "Short Gap Substation",[-78.79912546257876, 39.52594143646905]],
    [ "Nashville Electric Service",[-86.75220338360168, 36.134209519425504]],
    [ "331593332",[-97.96930476536905, 43.13974119364749]],
    [ "331943160",[-82.52728337081982, 34.839981258433674]],
    [ "Consumers Energy",[-85.66021466484001, 44.97885112485957]],
    [ "Randall Substation",[-117.45419411845482, 34.11364656349066]],
    [ "North Strasburg Substation",[-81.52734265415718, 40.64335948983244]],
    [ "Hillview Substation",[-81.57452846448706, 40.281912010559545]],
    [ "West New Philadelphia Substation",[-81.48279854833321, 40.48438543649223]],
    [ "332340512",[-96.99110474999999, 42.8976943]],
    [ "332340518",[-96.99206092522033, 42.89822275175927]],
    [ "332340521",[-96.99206518147072, 42.89761141001335]],
    [ "Picadome Substation",[-84.52615410918679, 38.031054903219314]],
    [ "Dresden Substation",[-82.02694631016782, 40.09417523468214]],
    [ "Elati Substation",[-104.99378942889412, 39.73633683942898]],
    [ "332412411",[-80.33923700000001, 26.13032245]],
    [ "332536395",[-82.28254548292517, 34.79444248732431]],
    [ "332536398",[-82.269207142165, 34.74685278359778]],
    [ "332537072",[-82.2685834, 34.74860714999999]],
    [ "332537075",[-82.2682821, 34.74991335000001]],
    [ "332560397",[-106.68331612482585, 31.85281333100715]],
    [ "332618554",[-84.35778199568844, 30.197678531981804]],
    [ "332619937",[-82.38882779764906, 34.73747387070768]],
    [ "332619939",[-82.38246382992332, 34.73369620541345]],
    [ "332619943",[-82.33696561101212, 34.706288918243224]],
    [ "Trilby Substation",[-105.09484954792357, 40.494002931095984]],
    [ "332668701",[-108.15329202477058, 47.012161556224896]],
    [ "332753120",[-107.90463158115426, 46.99505987542405]],
    [ "Chandlersville Substation",[-81.87383925472882, 39.88949532364901]],
    [ "Philo Substation",[-81.90390919420298, 39.86497212817875]],
    [ "Bridgeville Substation",[-81.85404937695978, 39.96890510229447]],
    [ "Bethel Church Substation",[-81.77816228480897, 40.033774800570896]],
    [ "Dixie Power",[-113.49050515, 37.106821350000004]],
    [ "East Amsterdam Substation",[-80.8901595652016, 40.47887230321677]],
    [ "South Cadiz Substation",[-80.9674371101969, 40.24269508848249]],
    [ "Marquam Substation",[-122.67646980439714, 45.50474945344541]],
    [ "Knox Substation",[-81.03653158102016, 40.80756951848587]],
    [ "Pidgeon Substation",[-80.84701633076502, 40.87809071931309]],
    [ "333178013",[-83.59157569994139, 41.361543091589695]],
    [ "333292354",[-83.65673576576879, 41.35715603194021]],
    [ "Jourdanton Substation",[-98.55202337052415, 28.924267764192006]],
    [ "333309469",[-82.51629025, 34.809661150000004]],
    [ "Arsenal Substation",[-75.19236355161762, 39.945512864735306]],
    [ "Appleway Substation",[-116.79586812466891, 47.704208967946514]],
    [ "Washington Substation",[-81.01829499269068, 40.619295061063525]],
    [ "333429073",[-83.63993640000001, 41.38792795]],
    [ "Old Forge Substation",[-81.37783719999146, 41.08267945075809]],
    [ "Alliance Castings Substation",[-81.09189969711437, 40.919404796147624]],
    [ "333488929",[-82.46379453727818, 34.86968358923454]],
    [ "Faircrest Substation",[-81.37622678921792, 40.74943990128663]],
    [ "AEP Ohio",[-81.36357118537472, 40.77585564194757]],
    [ "Timken Substation",[-81.39968119607043, 40.77930398609079]],
    [ "Horseshoe Substation",[-105.09506750462597, 40.45943506593817]],
    [ "Lexington Substation",[-97.00328989588124, 30.415874945953032]],
    [ "Glenbrook Power Facility",[-111.71742319471167, 33.62520162739264]],
    [ "Federal Center Substation",[-105.12060989506354, 39.72428753688444]],
    [ "Boring Substation",[-122.37733612512758, 45.435572655701634]],
    [ "334236131",[-113.1625635654076, 33.37709933704507]],
    [ "Grawn Distribution Substation",[-85.6969708587495, 44.6545471750178]],
    [ "Grawn Substation",[-85.69707940172758, 44.655390186168745]],
    [ "334263977",[-112.81000081750106, 33.49432775630285]],
    [ "Strum Substation",[-83.22026958220783, 43.824511365494004]],
    [ "Iva Substation",[-82.66511844299167, 34.309284012532466]],
    [ "334269500",[-82.60168350000001, 34.3243143]],
    [ "334273316",[-82.37756759999999, 34.17851075]],
    [ "334571417",[-83.29384677783717, 40.21800679745039]],
    [ "West Substation",[-105.15110664847519, 39.733194327975774]],
    [ "334645876",[-111.95341805, 33.28030965]],
    [ "State Street Substation",[-75.12640776046086, 39.95444777785473]],
    [ "Phoenix Substation",[-80.2643269179046, 26.22919182414347]],
    [ "Biscoe 115kV Substation",[-79.78116349999999, 35.36742095]],
    [ "334789368",[-79.7674366728587, 35.360149441732005]],
    [ "Scanlon Substation",[-92.42298871501119, 46.7089298582907]],
    [ "Park Hill Substation",[-87.9646252598443, 43.032015586214435]],
    [ "Golf Run Substation",[-81.316239499991, 38.79208506887295]],
    [ "Drexel Substation",[-110.94493126262184, 32.14935269837739]],
    [ "335055309",[-98.6888041746155, 33.807005923500235]],
    [ "335174595",[-103.85322008119907, 41.95506013209756]],
    [ "335517858",[-97.53870115880815, 35.528651018047384]],
    [ "Lester Substation",[-81.45510844832127, 41.3951056315294]],
    [ "Nottingham Substation",[-81.53766637056646, 41.5734863448374]],
    [ "Nottingham CPP Substation",[-81.53708388867553, 41.57364551298522]],
    [ "Collinwood Substation",[-81.58750019704678, 41.5571972779584]],
    [ "Septon Substation",[-95.03671588933048, 29.61623902758568]],
    [ "Bypark Substation",[-95.05942662472822, 29.64230454472555]],
    [ "Fairmont Substation",[-95.10276065000001, 29.649527750000004]],
    [ "Sylvan Substation",[-95.04023822396626, 29.654623032716927]],
    [ "Luzbay Substation",[-95.05536753946602, 29.639685779977285]],
    [ "Bayou Cogen Substation",[-95.04661702309608, 29.62623093759647]],
    [ "Bayway Substation",[-95.04954940739516, 29.609417828100074]],
    [ "Rayford Substation",[-95.44505007996001, 30.12858100717372]],
    [ "335812681",[-96.78679919840128, 43.08897695339386]],
    [ "335812682",[-96.79552841957432, 43.119678622687985]],
    [ "Mallard Substation",[-80.23927921891377, 26.228932746509624]],
    [ "Bellevue Substation",[-75.48396541638265, 39.7676555633222]],
    [ "335995393",[-92.534281, 42.36687035]],
    [ "Gertie Substation",[-95.68393524999999, 29.863579800000004]],
    [ "336061352",[-95.19716207548664, 29.932726494780947]],
    [ "Atascocita Substation",[-95.0970252511336, 30.004896353326167]],
    [ "Drilco Substation",[-95.38299974650374, 29.964392918152576]],
    [ "Kluge Substation",[-95.61840161148494, 29.98952531015226]],
    [ "336061360",[-94.928222267017, 29.850455599148844]],
    [ "Kingwood Substation",[-95.18928698868562, 30.054489383541302]],
    [ "Cedar Bayou Substation",[-94.9501426, 29.757894650000004]],
    [ "Fredericksburg Substation",[-98.88514479991633, 30.2597203564944]],
    [ "Wolf Creek Substation",[-99.08808995782836, 30.123347786884562]],
    [ "Miller Creek Substation",[-98.29839688291676, 30.2620136878225]],
    [ "Mountain Top Substation",[-98.3703292964186, 30.22997216750639]],
    [ "Castell Substation",[-98.9632074367698, 30.738390202262103]],
    [ "Kerrville Stadium Substation",[-99.13384245492512, 30.05784993215458]],
    [ "336133086",[-92.76788524999999, 42.3871527]],
    [ "Progressive Substation",[-81.44668060448672, 41.56284725942806]],
    [ "Ninemile Substation",[-81.59242772233846, 41.55676451084298]],
    [ "Liverpool Substation",[-95.29485894999999, 29.279127949999996]],
    [ "Riwood Substation",[-95.34748005, 29.055759550000005]],
    [ "Stratt Substation",[-95.35475674000004, 29.049992109443]],
    [ "Petson Substation",[-95.22033210905279, 29.253015404894327]],
    [ "Surfside Substation",[-95.33916830819847, 28.9587956640979]],
    [ "Polk Substation",[-95.36167625000002, 29.75223805]],
    [ "Katy Substation",[-95.83935221843755, 29.786955385585344]],
    [ "Monument Street Substation",[-76.6083301064772, 39.29712135795823]],
    [ "Grand Traverse Substation",[-85.61852211454179, 44.69274044277803]],
    [ "Intercontinental Substation",[-95.36742999009465, 29.98689436231731]],
    [ "Greens Road Substation",[-95.33322756780825, 29.95084423122586]],
    [ "Plaza Substation",[-95.3895714086384, 29.689427061314195]],
    [ "Hyde Park Substation",[-95.3844158, 29.7479018]],
    [ "Kennedy Drive Substation",[-81.76736816225532, 24.566196546581892]],
    [ "Oates Substation",[-95.25214606848806, 29.778661438360604]],
    [ "Cleveland Public Power",[-81.62381014151033, 41.45323122851167]],
    [ "Cleveland Public Power",[-81.56958847715129, 41.43997391442953]],
    [ "Inca Substation",[-81.63949063176555, 41.439249225366126]],
    [ "Hazel Substation",[-81.68597934237283, 41.49159635043664]],
    [ "Freeway Park Substation",[-94.99515065638674, 29.40397120641663]],
    [ "Dickinson Substation",[-95.05691733633962, 29.461136308803237]],
    [ "Friendswood Substation",[-95.15336926722178, 29.522642392681053]],
    [ "Galveston 26th Street Substation",[-94.79740953158402, 29.30285420124079]],
    [ "West Galveston Substation",[-94.82685873108859, 29.29624028559195]],
    [ "Deer Park Substation",[-95.12901913237658, 29.692381773036374]],
    [ "Fondren Substation",[-95.50936319261685, 29.66789034588255]],
    [ "Imperial Substation",[-95.63014775782051, 29.59462331198539]],
    [ "Quail Valley Substation",[-95.5341146, 29.586875850000002]],
    [ "Telview Substation",[-95.48748934999999, 29.579431849999995]],
    [ "Little York Substation",[-95.42991148124017, 29.864100728653575]],
    [ "Gilchrist Substation",[-81.40094104451536, 41.05681033177247]],
    [ "Underwood Substation",[-95.08905557938384, 29.691999925384287]],
    [ "336721437",[-86.6350458, 38.499985]],
    [ "Exxon Substation",[-95.01951945414363, 29.74967838471052]],
    [ "Hall Substation",[-95.24020315178751, 29.58935235096985]],
    [ "La Porte Substation",[-95.01612628452986, 29.664838894355892]],
    [ "Mary's Creek Substation",[-95.25730523050775, 29.554066563009336]],
    [ "Normandy Substation",[-95.20560565, 29.76955465]],
    [ "Greens Bayou 345kV Substation",[-95.21825901466143, 29.818459181814113]],
    [ "Greens Bayou 69kV Substation",[-95.2208513354926, 29.820096666504]],
    [ "CenterPoint Energy",[-95.12624865102875, 29.820154677743908]],
    [ "Nixon Substation",[-83.38694305, 42.6536984]],
    [ "Guy Burks Substation",[-96.42287919140098, 30.148131601343742]],
    [ "Big Creek Substation",[-95.75086412475667, 29.471160489071103]],
    [ "Damon Substation",[-95.72931505214798, 29.291765204729277]],
    [ "Needville Substation",[-95.8408987, 29.396122850000005]],
    [ "West Columbia Substation",[-95.65736818292643, 29.15672397753443]],
    [ "West Columbia Local Substation",[-95.6501211, 29.1492563]],
    [ "Lake Jackson Substation",[-95.42397790000001, 29.052934400000005]],
    [ "South Lane City Substation",[-96.0155456404808, 29.194916170152]],
    [ "Pledger Substation",[-95.91157260846549, 29.18846307991384]],
    [ "337039078",[-82.40489486034716, 34.81999462516786]],
    [ "Wellsburg Substation",[-92.91609046115997, 42.383155390396475]],
    [ "Wirt Substation",[-95.47962268136139, 29.78523312320997]],
    [ "Harrisburg Substation",[-95.2653107477057, 29.714925640874107]],
    [ "Telephone Substation",[-95.28742390564118, 29.59913515305591]],
    [ "Davson Substation",[-95.1892412, 29.716418749999995]],
    [ "337201531",[-82.26882810061083, 27.8720113683208]],
    [ "Moody Substation",[-94.85340754551099, 29.260626695976548]],
    [ "Alta Loma Substation",[-95.09097851459133, 29.391559934942556]],
    [ "Hitchcock Substation",[-95.0159021619435, 29.347500737351737]],
    [ "Westbay Substation",[-95.09061993331962, 29.112681600580235]],
    [ "Stewart Substation",[-94.91065570696647, 29.22777122853258]],
    [ "Eastlake Substation",[-104.98105426513607, 39.95627126985849]],
    [ "Green Substation",[-104.97942240197996, 39.97838317757157]],
    [ "337269562",[-81.92516201650689, 28.938720166820705]],
    [ "Dupont Switching Station",[-96.945582804695, 28.69293501689962]],
    [ "Edna Substation",[-96.64612082572687, 28.956582792084813]],
    [ "El Campo Substation",[-96.2674232266726, 29.1869899998161]],
    [ "Ganado Substation",[-96.50271790000001, 29.013171149999998]],
    [ "Cy-Fair Substation",[-95.67258178162038, 29.94800635549336]],
    [ "Cuero Hydro Substation",[-97.30800042183431, 29.129450495977512]],
    [ "Cheapside Substation",[-97.39532211686931, 29.30898625356227]],
    [ "Thomaston Substation",[-97.14855134999999, 28.997465]],
    [ "Cuero Substation",[-97.27241819566945, 29.107413206523326]],
    [ "Gonzales Substation",[-97.46806078058042, 29.517895554947135]],
    [ "Sam Rayburn Switchyard",[-97.13304973313157, 28.89311925235078]],
    [ "Vanderbilt Substation",[-96.645839642948, 28.805848286199957]],
    [ "Loop 463 Substation",[-97.07498777757478, 28.816395428519503]],
    [ "337413848",[-75.9232378276258, 40.323970520287766]],
    [ "Constituiton Street Substation",[-76.60926944181648, 39.297264075203586]],
    [ "Santa Cruz Substation",[-110.9807459496377, 32.21464326352215]],
    [ "Florida Gas Transmission Co Substation",[-82.30222405047277, 28.043852527040013]],
    [ "Joslin Substation",[-96.5464256387652, 28.64874343127506]],
    [ "Greenlake Substation",[-96.79628765, 28.53488605]],
    [ "Vistron Substation",[-96.83302416093606, 28.574570766933654]],
    [ "Black Bayou Substation",[-96.91965904999999, 28.6424013]],
    [ "Port Lavaca Substation",[-96.6582921412087, 28.61072681135084]],
    [ "Brookhollow Substation",[-96.63383520068636, 28.630406543026513]],
    [ "337697782",[-107.24570735753073, 35.22803883091175]],
    [ "Oak Hill Substation",[-97.85949077583957, 30.23384359856775]],
    [ "Hearne Substation",[-96.62591756891003, 30.88413980265598]],
    [ "Formosa Substation",[-96.55112213886838, 28.683586301401004]],
    [ "Formosa Plastics Switching Station",[-96.55118505000002, 28.686262500000005]],
    [ "Alcoa Substation",[-96.55763862676625, 28.6575413690202]],
    [ "Bay City Substation",[-95.9693318750014, 28.98771508375657]],
    [ "Markham Substation",[-96.06963480134647, 28.966744417152714]],
    [ "337799043",[-92.90585638759097, 42.368056675187646]],
    [ "Kenedy Switching Station",[-97.83745905187591, 28.84256960234134]],
    [ "Charlotte Substation",[-98.70210035413294, 28.856041336357904]],
    [ "Carancahua Substation",[-96.42232528730553, 28.744184489765267]],
    [ "Palacios Substation",[-96.21212735, 28.757009049999997]],
    [ "337935569",[-94.05210878224034, 30.014034219012643]],
    [ "Mid County Substation",[-93.95835630404424, 29.941406130550437]],
    [ "Stonegate Substation",[-93.9717869306718, 29.953772711736228]],
    [ "Cheek Substation",[-94.18432589851956, 30.00086684856848]],
    [ "Dayton Bulk Substation",[-94.89252236355546, 30.03710095749772]],
    [ "Huntsville Substation",[-95.54699564999999, 30.71867875]],
    [ "Entergy",[-93.87923470564138, 30.02442911227792]],
    [ "Cargill Wire Substation",[-94.1105863276295, 30.076271642183638]],
    [ "Yankee Doodle Substation",[-94.09369257170229, 30.051014753225363]],
    [ "Crockett Substation",[-94.10965935, 30.074165649999998]],
    [ "Lincoln Substation",[-94.12229268292515, 30.055542716268167]],
    [ "Burt Street 138kV Substation",[-94.07787982170682, 30.066607574619866]],
    [ "Carrol Street Park 138kV Substation",[-94.07888022388371, 30.06656656991911]],
    [ "Entergy",[-94.1905176120167, 30.07791807509529]],
    [ "Amelia Bulk Substation",[-94.23417810544687, 30.077167797427723]],
    [ "Bevil Substation",[-94.23607145645667, 30.159541924822708]],
    [ "Briarcliff Substation",[-94.14276415, 30.104135249999995]],
    [ "Lindbergh Substation",[-94.15507475, 30.0706432]],
    [ "McHale Substation",[-94.13871928358145, 30.1274711036554]],
    [ "Tanglewood Substation",[-94.16868069949915, 30.09530279914593]],
    [ "West End Substation",[-94.13394220741795, 30.082151074689214]],
    [ "Parkdale Substation",[-94.1694455419774, 30.12570337535294]],
    [ "Tyrrell Substation",[-94.13315104796618, 30.036994115552655]],
    [ "Virginia Substation",[-94.10795795, 30.0424051]],
    [ "Lovell Lake Substation",[-94.15537523323657, 29.916472049812732]],
    [ "Jirou Substation",[-94.10807260658329, 30.09129317473976]],
    [ "North End Substation",[-94.11923015, 30.10686115]],
    [ "Travis Substation",[-94.09663207671866, 30.08546187709592]],
    [ "Rosedale Substation",[-94.17137762750484, 30.138317176054393]],
    [ "Fort Worth Substation",[-93.94182894822569, 29.87442676683356]],
    [ "Groves Substation",[-93.92092502524561, 29.945329074726555]],
    [ "Kolbs Substation",[-93.94010200264131, 29.9247246419389]],
    [ "Lakeview Substation",[-93.90111373574886, 29.913282381619208]],
    [ "Port Arthur Water Works Substation",[-93.94440646444662, 29.887782407710528]],
    [ "Texaco Substation",[-93.94539669999999, 29.888905599999998]],
    [ "Raywood Substation",[-94.67285795065096, 30.027456533171208]],
    [ "Seventy Second Substation",[-91.16047547242371, 30.514975142742095]],
    [ "Receiving Station N - Airport",[-118.37631919996545, 33.96189787496133]],
    [ "SGL Carbon, LLC",[-81.72358535724328, 35.73170488888688]],
    [ "338086189",[-93.973652, 29.850229400000003]],
    [ "Entergy",[-93.97209649999999, 29.87393295]],
    [ "Port Acres Bulk Substation",[-93.99878875288088, 29.88717248729842]],
    [ "Westside Substation",[-93.95033744605445, 29.868322196450567]],
    [ "Dorsey Substation",[-94.01000356680312, 29.90737410218488]],
    [ "Explorer Substation",[-94.00527176486455, 29.900405788762292]],
    [ "Federal Substation",[-94.04947478440127, 29.965042466627526]],
    [ "Gallier Co Substation",[-94.22525023836623, 30.068435625048004]],
    [ "Meeker Substation",[-94.23234754999999, 30.066311300000002]],
    [ "Mobil Hebert Substation",[-94.0547607, 29.97275485]],
    [ "Orange Bulk Substation",[-93.79044128649497, 30.095206648771693]],
    [ "Poly Substation",[-94.23174005000001, 30.069751699999998]],
    [ "Port Acres Substation",[-94.00902885049425, 29.900442736497446]],
    [ "Sour Lake Substation",[-94.41202960433569, 30.13474725976878]],
    [ "Spurlock Substation",[-94.02908975, 29.965808550000002]],
    [ "Cordrey Substation",[-93.74219546698797, 30.110916774693308]],
    [ "Bertwood Substation",[-95.31415957266938, 29.843965372329425]],
    [ "Gears Substation",[-95.44007449071519, 29.964720528948533]],
    [ "Glenwood Substation",[-95.2659799837688, 29.850619973114146]],
    [ "Lauder Substation",[-95.32153535000002, 29.9112446]],
    [ "Lockwood Substation",[-95.28840195108413, 29.935077355203326]],
    [ "Scenic Woods Substation",[-95.28526468807526, 29.88372277520766]],
    [ "Monsanto Substation",[-95.21166376830807, 29.256272333983016]],
    [ "Alvin Substation",[-95.24944086148236, 29.433312724660055]],
    [ "Mustang Bayou Substation",[-95.20354747759032, 29.36282444657767]],
    [ "Southwyck Substation",[-95.38929147724456, 29.552231479619618]],
    [ "Pisek Substation",[-96.57189935, 29.921139200000002]],
    [ "Welcome Substation",[-96.47851206360896, 30.032737130569046]],
    [ "Almeda Substation",[-95.40362396742208, 29.630098245698324]],
    [ "College Substation",[-95.24484670000001, 29.659717749999995]],
    [ "Hidden Valley Substation",[-95.42288925631505, 29.91125206608174]],
    [ "Upper Darby Substation",[-75.26384012891597, 39.95131124536865]],
    [ "Reno Substation",[-84.28667250049423, 30.776516770062912]],
    [ "DuPont Dee Substation",[-94.02849574999999, 30.010021049999995]],
    [ "Magnolia Substation",[-93.9524233071426, 29.97813992728903]],
    [ "Gulfway Substation",[-93.88992779628845, 29.945671984648875]],
    [ "Hanks Substation",[-93.9253402342189, 29.907455524588784]],
    [ "Pansy Substation",[-94.22516890786005, 29.895145120490678]],
    [ "Pine Street Substation",[-93.93416112776363, 29.976149186648538]],
    [ "Port Neches Bulk Substation",[-93.93870735922918, 29.963240877374847]],
    [ "VFW Park Substation",[-93.89722474999999, 29.9617857]],
    [ "Central Substation",[-94.0109483538473, 29.985672115342506]],
    [ "Crowder Substation",[-93.9786958332544, 29.97159049952764]],
    [ "Goodrich Substation",[-93.94686357268974, 29.988070207196778]],
    [ "Linde Substation",[-93.92206996499276, 29.963355720406756]],
    [ "Port Neches Substation",[-93.96099108942165, 29.987362051587137]],
    [ "Union Substation",[-93.98427190135418, 29.995091033256525]],
    [ "Manchester Substation",[-93.90366119999997, 29.933782100000002]],
    [ "338519270",[-95.15030280000002, 29.728997199999995]],
    [ "338519275",[-95.17034994235034, 29.737978075314793]],
    [ "South Channel Substation",[-95.16442921707227, 29.721737248479844]],
    [ "Strawberry Belt Substation",[-95.17203156532, 29.699146474553814]],
    [ "Witter Substation",[-95.20040223858916, 29.716356709800117]],
    [ "338520339",[-107.61921757377783, 37.224448593325434]],
    [ "CenterPoint Energy",[-95.34149091192062, 29.74609873221232]],
    [ "338552656",[-95.01481015, 29.753522450000002]],
    [ "338552658",[-94.98035889999998, 29.858967699999997]],
    [ "338552661",[-94.92787085, 29.828039200000003]],
    [ "338552664",[-95.01999334018122, 29.742296061631638]],
    [ "Highlands Substation",[-95.03134278327813, 29.800751016613425]],
    [ "PSArco Substation",[-95.12110132531907, 29.81326670595321]],
    [ "Georgia Power",[-84.3709682054485, 33.94395329876402]],
    [ "Dyann Substation",[-96.07032919591803, 29.289233889270655]],
    [ "Freeman Substation",[-95.84134831569061, 29.875212767554544]],
    [ "Freeport Substation",[-95.34845624144586, 28.940345370286344]],
    [ "338733191",[-93.70800091876255, 46.53779085458165]],
    [ "League City Main Substation",[-95.08199034787175, 29.500890030875006]],
    [ "Amoco Substation",[-95.18702253491024, 29.233779204091196]],
    [ "Friendswood Substation",[-95.20133650000001, 29.499148749999996]],
    [ "Hastings Substation",[-95.25257404338858, 29.483244625409572]],
    [ "Nash Substation",[-95.59401586328474, 29.243485952554963]],
    [ "Seminole Substation",[-95.17917009583807, 29.468452406064134]],
    [ "Kemah Substation",[-95.02631187439736, 29.53827208176651]],
    [ "Parkland Substation",[-80.27434062474693, 26.333588989326532]],
    [ "Greenbelt Substation",[-94.93458212473632, 29.379626505900944]],
    [ "Apache Substation",[-94.94757567579994, 29.378682304973868]],
    [ "Heights Substation",[-94.94995961750956, 29.38954471234326]],
    [ "Tejas Substation",[-94.92298207643223, 29.38015271925023]],
    [ "Caddo Substation",[-94.94412808199567, 29.379565425146247]],
    [ "La Marque Substation",[-94.96500879675294, 29.367124965644177]],
    [ "Amoco Substation",[-94.9245278749648, 29.363622498196364]],
    [ "Comanche Switching Station",[-94.91486245, 29.373260450000004]],
    [ "Cherokee Switching Station",[-94.91582576622393, 29.367131252568715]],
    [ "Northside Substation",[-94.91358665, 29.40902845]],
    [ "338819909",[-94.94381279999999, 29.378932450000004]],
    [ "338853912",[-97.57469730071766, 35.409871834422546]],
    [ "338858081",[-94.90186139894423, 29.376744632988537]],
    [ "Terminal Substation",[-94.91128232704307, 29.37058800499507]],
    [ "Choctaw Substation",[-94.90772924128918, 29.376446125183048]],
    [ "ISP Switching Station",[-94.96381483518891, 29.4256314502904]],
    [ "338858213",[-94.8926781319653, 29.383041660501817]],
    [ "Texas City Main Substation",[-94.90152969117045, 29.381484621023972]],
    [ "Clemons Substation",[-95.57344375000001, 28.988761550000003]],
    [ "Clemons Switching Station",[-95.58542130000002, 29.056894050000004]],
    [ "Angleton Substation",[-95.44063741276216, 29.166977524283773]],
    [ "Brazoria Substation",[-95.57758864454696, 29.062365036065245]],
    [ "Sweeny Substation",[-95.68713135331141, 29.055408583687555]],
    [ "West Columbia Main Substation",[-95.65710501006853, 29.154580722246322]],
    [ "Spring Creek Substation",[-123.13940470540257, 44.118640426410046]],
    [ "Prairie Substation",[-123.15792634618661, 44.10370041485137]],
    [ "Alden Substation",[-95.51525053137392, 30.232063952572595]],
    [ "Plantation Substation",[-95.4333099092762, 30.25164344502197]],
    [ "Conair Substation",[-95.44718872712144, 30.338003308664852]],
    [ "Conroe Bulk Substation",[-95.45525783255303, 30.28902941225071]],
    [ "Fish Creek Substation",[-95.54778738892654, 30.29732414696457]],
    [ "Metro Substation",[-95.46224575076963, 30.174779579359782]],
    [ "Kerrville Legion Substation",[-99.10036132524503, 30.000341898811378]],
    [ "Kerrville Travis Substation",[-99.12454899735228, 30.04262396578395]],
    [ "Goat Creek Substation",[-99.2102282488761, 30.079737337631]],
    [ "Rim Rock Substation",[-99.17313680298305, 30.030130057271098]],
    [ "338951879",[-93.75868448337378, 30.050501964069348]],
    [ "Adams Bayou Substation",[-93.7516059789908, 30.059839994580393]],
    [ "Bunch Gully Substation",[-93.77454685000002, 30.05034055]],
    [ "Cow Substation",[-93.74972117754655, 30.041195865005726]],
    [ "Front Street Substation",[-93.72933248298718, 30.090963677686215]],
    [ "West Orange Substation",[-93.75845164163765, 30.07595709571831]],
    [ "Carlyss Substation",[-93.3483217788248, 30.19223535357335]],
    [ "Himex Substation",[-94.39557070000001, 29.559350199999994]],
    [ "Stowell Substation",[-94.40101250873559, 29.791971874807725]],
    [ "LUS",[-91.99297518786977, 30.242091222568536]],
    [ "LUS",[-92.02638609336526, 30.19372655971946]],
    [ "Guilbeau Electric Substation",[-92.06422259333809, 30.196284437137503]],
    [ "Lafayette Substation",[-92.04910572984643, 30.232069467192733]],
    [ "Luke Street Substation",[-92.06116534819517, 30.222194615640177]],
    [ "Perard Electric Substation",[-92.04994059999999, 30.20242105]],
    [ "Pinhook Substation",[-92.00892586326606, 30.21145886530149]],
    [ "Saint Landry Substation",[-92.03100757930669, 30.212103775051958]],
    [ "Warehouse Electric Substation",[-92.0463242, 30.235765300000004]],
    [ "West Gilman Road Substation",[-92.01924348430376, 30.241758189031295]],
    [ "Turtle Creek Substation",[-99.20725125043619, 29.96897786388231]],
    [ "Hunt Substation",[-99.3360440645505, 30.076141182308305]],
    [ "Ingram Substation",[-99.24522156755359, 30.08450781497588]],
    [ "Menominee",[-87.61481656500877, 45.143778537186265]],
    [ "Medina Substation",[-99.2538585865745, 29.80634053980235]],
    [ "339095453",[-84.63543042322961, 38.96861813131409]],
    [ "Met Center Substation",[-97.69314727392471, 30.211019048324005]],
    [ "AMD Substation",[-97.72370735165082, 30.214718777177875]],
    [ "Grove Substation",[-97.71100147428966, 30.216452085614893]],
    [ "Burleson Substation",[-97.73670076591856, 30.214663935477454]],
    [ "Hi Cross Substation",[-97.76906448593662, 30.18623422994886]],
    [ "Jollyville Substation",[-97.78156329949509, 30.479543323037454]],
    [ "Howard Lane Substation",[-97.68868962152185, 30.43317262140908]],
    [ "Tech Ridge Substation",[-97.6658943451942, 30.419643927823486]],
    [ "Longview Substation",[-82.50193547129979, 40.77639891607164]],
    [ "339129223",[-82.46593280126295, 40.777911608022876]],
    [ "Williamson Substation",[-97.75024243782742, 30.437188393967993]],
    [ "Northwest Substation",[-97.75730990369327, 30.4645990036312]],
    [ "Round Rock South Substation",[-97.6941709125389, 30.47424081612512]],
    [ "Round Rock Substation",[-97.70216590567706, 30.521243678476093]],
    [ "Fiskville Substation",[-97.68310827308902, 30.362150008577554]],
    [ "Justin Lane Substation",[-97.71614056338055, 30.343543354117827]],
    [ "Wells Branch Substation",[-97.68905166546678, 30.446141488147518]],
    [ "Harris Branch Substation",[-97.58090554644326, 30.371277215119996]],
    [ "Sprinkle Substation",[-97.64554277049103, 30.353124312763182]],
    [ "Fabius Station",[-75.9934131, 42.84004794999999]],
    [ "Celnec Substation",[-95.06481615, 29.628314500000002]],
    [ "Bimont Substation",[-95.05540841017145, 29.64766249631144]],
    [ "Pilgrim Substation",[-95.17498671629173, 29.552306448053358]],
    [ "Thompsons Substation",[-95.5863788, 29.4812446]],
    [ "Trinity Bay Substation",[-94.91441483004674, 29.71931676535955]],
    [ "Ulrich Substation",[-95.48381089817558, 29.735880599515966]],
    [ "Rosharon Substation",[-95.42965488654986, 29.353742134726716]],
    [ "339237010",[-94.92821979999998, 29.850457999999996]],
    [ "339237011",[-94.94055492041436, 29.86071978885349]],
    [ "339237012",[-94.92151636525523, 29.838655707277134]],
    [ "Manslick Substation",[-85.79477345234294, 38.12410984295042]],
    [ "Geronimo Substation",[-97.97061108429709, 29.627437583266293]],
    [ "New Berlin Substation",[-98.0439514, 29.487606899999996]],
    [ "Schumansville Substation",[-98.09707258800087, 29.653871123449434]],
    [ "CLECO",[-91.81745064931346, 30.04038231669936]],
    [ "CLECO",[-91.78973187650718, 30.02948044675731]],
    [ "339348157",[-92.33487221082511, 30.018723572502832]],
    [ "Hopkins Substation",[-91.85451438624601, 29.99930688727996]],
    [ "Jennings Substation",[-92.64710052225813, 30.235205463355715]],
    [ "339407945",[-84.61969104496845, 38.959655743174764]],
    [ "Key West Diesel Substation",[-81.80478841362672, 24.55113591486697]],
    [ "Georgia Power",[-82.25124630000002, 33.433388550000004]],
    [ "Lacassine Substation",[-92.92357352087201, 30.231288754818138]],
    [ "339441792",[-92.2102067, 30.227780750000008]],
    [ "Lawtag Substation",[-92.72409606712779, 30.232092629044043]],
    [ "Egan Substation",[-92.5035124335927, 30.23504043307397]],
    [ "Mermentau Substation",[-92.60126841066759, 30.191434903909407]],
    [ "Welsh Substation",[-92.81719525667354, 30.23622695526224]],
    [ "Keansburg Substation",[-74.1297403698813, 40.43943253273036]],
    [ "Merriman Substation",[-101.69923926248752, 42.938005919194644]],
    [ "Harlem Substation",[-82.3128289, 33.4211861]],
    [ "339518739",[-90.9001074, 32.2950565]],
    [ "Entergy Mississippi",[-90.80892970113513, 32.312110862501136]],
    [ "339518745",[-90.86210324159003, 32.31185170418621]],
    [ "Port Gibson Substation",[-90.97654993307184, 31.972665835602342]],
    [ "North Vicksburg Substation",[-90.86176718548924, 32.38385622768593]],
    [ "South Vicksburg Substation",[-90.91841533481283, 32.27051607172988]],
    [ "Vicksburg Substation",[-90.89257700059036, 32.315567363055976]],
    [ "West Vicksburg Substation",[-90.88381131670646, 32.348797150367005]],
    [ "Valley Station",[-74.98228816771157, 43.03280406625798]],
    [ "Randolph Field Substation",[-98.29064582010845, 29.54354393828232]],
    [ "Haining Road Substation",[-90.88457815562286, 32.39001478025943]],
    [ "339574285",[-91.34720857791807, 31.59876718081956]],
    [ "339582792",[-91.3664756, 31.53717]],
    [ "Natchez Substation",[-91.3694173, 31.568064000000007]],
    [ "CLECO",[-92.3874947, 30.221580100000004]],
    [ "339604853",[-92.27201010572117, 30.227101674585796]],
    [ "Pecan Grove Substation",[-93.3345983749718, 30.173694890407646]],
    [ "Boudoin Substation",[-93.36290274999999, 30.16949075]],
    [ "Entergy Louisiana",[-92.33542366492166, 30.0938247277354]],
    [ "Entergy",[-93.20524681059659, 30.175866125841083]],
    [ "Chalkley Bulk Substation",[-93.11298813588539, 30.172419393260444]],
    [ "Chlomal Substation",[-93.12794511865081, 30.231574635773804]],
    [ "Contraband Substation",[-93.23207986239827, 30.1837542195339]],
    [ "Derouen Substation",[-92.98003359619781, 30.231151561157972]],
    [ "Smith Substation",[-93.17951659478655, 30.16856327506001]],
    [ "Solac Substation",[-93.22833414821852, 30.15477514292305]],
    [ "Greinwich Substation",[-93.177741939735, 30.19854652511812]],
    [ "Barrington Substation",[-88.1422961923768, 42.156561445094525]],
    [ "Louisville Gas and Electric",[-85.54373094756694, 38.18616049983481]],
    [ "West Reading Substation",[-75.94066576377128, 40.33116687161392]],
    [ "Edison Substation",[-99.57621574026668, 30.333065559494166]],
    [ "Segovia Substation",[-99.65183132249594, 30.409877653517945]],
    [ "Old Ocean Substation",[-95.73726555387955, 29.065778183847893]],
    [ "Sweeny Cogeneration Substation",[-95.7438603573442, 29.07210612216903]],
    [ "Phillips Tank Farm Substation",[-95.74461249248988, 29.07615256338178]],
    [ "339697778",[-116.33536506663414, 43.60563954653564]],
    [ "Flint River Primary Substation",[-84.14700787510817, 31.60357874330905]],
    [ "Big Hill Substation",[-100.54329057696388, 31.047375688807975]],
    [ "Orsted Substation",[-100.19485176729273, 30.695973883527415]],
    [ "Entergy",[-92.11257191715545, 29.9777413718334]],
    [ "Abbeville Substation",[-92.1022295249236, 29.984117941833333]],
    [ "Maurice Substation",[-92.14205873075917, 30.108815473364107]],
    [ "Farragut Substation",[-73.98447616820263, 40.704958090889576]],
    [ "College Station Junction",[-96.29245405169637, 30.62908879954798]],
    [ "Lake Forest Substation",[-95.61453914291634, 30.340392007406653]],
    [ "Entergy",[-93.17891700000003, 30.2205111]],
    [ "Ann Substation",[-93.21859532491081, 30.231932458765304]],
    [ "East Broad Substation",[-93.20110165000001, 30.2266546]],
    [ "Ford Substation",[-93.2109259252035, 30.213419656350123]],
    [ "Goosport Substation",[-93.17948084999999, 30.263976550000002]],
    [ "Oak Park Substation",[-93.2024901, 30.202833700000003]],
    [ "Arizona Substation",[-93.3556919, 30.18278085]],
    [ "Westlake Substation",[-93.2498830562509, 30.242657674729188]],
    [ "339760452",[-93.27198261431819, 30.245026007646146]],
    [ "339760453",[-93.28317085, 30.238439699999997]],
    [ "339760454",[-93.27174115096072, 30.23662754392489]],
    [ "339760455",[-93.2809675596725, 30.252870924887603]],
    [ "Walnut Substation",[-76.87976515133555, 40.266859985523716]],
    [ "North Columbia Substation",[-76.51260305000001, 40.03852285]],
    [ "Decorah Substation",[-91.77296920192032, 43.300679622857366]],
    [ "339820211",[-91.81962240988118, 30.222198907077217]],
    [ "Entergy",[-91.80637454080863, 30.195038144617197]],
    [ "Bayou Vista Substation",[-91.28018213398015, 29.675563866982813]],
    [ "Billeaud Substation",[-91.94694197394928, 30.13643821149327]],
    [ "Gibson Substation",[-91.03847342504075, 29.666085627099932]],
    [ "Holiday Substation",[-91.9874322044473, 30.183388041724218]],
    [ "Ramos Substation",[-91.1367616249565, 29.677313519486383]],
    [ "Robertson Substation",[-96.5693178595557, 30.945135620549795]],
    [ "Elliot Substation",[-96.57588158708592, 30.951427127530433]],
    [ "Franklin Substation",[-96.49205155, 31.042072999999995]],
    [ "Distributing Station 64",[-118.45734806325434, 34.15195420267959]],
    [ "Central Austin Substation",[-97.733894, 30.3107185]],
    [ "Balcones Substation",[-97.73020364073845, 30.391032163515064]],
    [ "Koenig Lane Substation",[-97.72702830653344, 30.328349627550736]],
    [ "Northland Substation",[-97.75472532663511, 30.335371273927063]],
    [ "Lakeshore Substation",[-97.78048962769729, 30.31517284164549]],
    [ "Glasscock Substation",[-97.69407770000002, 30.73959685]],
    [ "Rivery Substation",[-97.68955085864752, 30.648531346190197]],
    [ "Chief Brady Substation",[-97.69594864097888, 30.591816032762296]],
    [ "Kent Substation",[-97.80831064171821, 30.495274869847087]],
    [ "Elgin Switching Station",[-97.3591055525658, 30.417023716760017]],
    [ "Taylor Substation",[-97.39734007956348, 30.567149169648076]],
    [ "Bee Creek Substation",[-98.00432542520886, 30.347045407424353]],
    [ "Stockdale Road Substation",[-98.14486235589217, 29.147319054190696]],
    [ "Cushman Substation",[-97.94567561979531, 29.57422445579605]],
    [ "Hickory Forest Substation",[-97.86417215023057, 29.468391067262765]],
    [ "Highway 123 Substation",[-97.95848508588254, 29.494025255065996]],
    [ "Sutherland Springs Substation",[-98.06397248937083, 29.266929449613485]],
    [ "Wilson Substation",[-98.17283204402634, 29.337662206117148]],
    [ "Rutherford Substation",[-97.9856322000108, 30.117727044711483]],
    [ "Phillips Johnson City Substation",[-98.23933862030921, 30.281901492849634]],
    [ "Dripping Springs Substation",[-98.08373293853256, 30.17375782266691]],
    [ "Lago Vista Substation",[-97.97868763744783, 30.46056966516338]],
    [ "Manchaca Substation",[-97.85043462961644, 30.135281938947273]],
    [ "Henly Substation",[-98.15683361436093, 30.20281316395688]],
    [ "Brodie Lane Substation",[-97.84823522847664, 30.187698769257484]],
    [ "Slaughter Lane Substation",[-97.81150099062805, 30.172195072709]],
    [ "Turnersville Substation",[-97.7829593300726, 30.073837477070654]],
    [ "Warren Substation",[-97.75828709545938, 30.310661519424524]],
    [ "340037449",[-92.96529172642289, 45.82492874961507]],
    [ "Caldwell Substation",[-80.08811904491503, 26.370777101319437]],
    [ "Mula Substation",[-95.56197565000001, 29.633244050000002]],
    [ "Haden Substation",[-95.17300669999999, 29.7596738]],
    [ "Port Substation",[-95.18462617439064, 29.753136871273963]],
    [ "Exxon",[-95.02106546646604, 29.74888856114702]],
    [ "Jacintoport Substation",[-95.1251929975685, 29.751809782144086]],
    [ "Taylor Substation",[-95.1942955017667, 29.75107428278545]],
    [ "340139626",[-83.57359287765267, 36.44274941102956]],
    [ "340151341",[-95.15424085, 29.727033950000003]],
    [ "Muddy",[-88.5234833654527, 37.76595328760789]],
    [ "Bader Substation",[-98.94249685293663, 29.370576990590468]],
    [ "Big Foot Substation",[-98.95038243140306, 29.05971829577932]],
    [ "Castroville Substation",[-98.88694170013561, 29.37656588199207]],
    [ "Devine Substation",[-98.92432724272022, 29.125302997611996]],
    [ "Moore Substation",[-99.02247229728223, 29.066875194411743]],
    [ "Natalia Substation",[-98.90522140071681, 29.207200752674705]],
    [ "340172403",[-88.65778136787125, 37.73941851516679]],
    [ "Barclay Substation",[-97.11498915, 31.0759216]],
    [ "Temple Taylor Valley Substation",[-97.40421314999999, 31.034761600000003]],
    [ "Lake Belton Substation",[-97.43411624999999, 31.141439400000007]],
    [ "Temple Southeast Substation",[-97.35496764999999, 31.0712045]],
    [ "Scott and White Substation",[-97.36008439017672, 31.075781252884603]],
    [ "Temple Substation",[-97.33148519526462, 31.088058097944646]],
    [ "Seaton Substation",[-97.28242430541972, 31.080949535831216]],
    [ "Bartlett Substation",[-97.4267401, 30.791420950000006]],
    [ "Granger Substation",[-97.44662111105829, 30.7233672119527]],
    [ "Holland Substation",[-97.4033010318425, 30.87547973885161]],
    [ "Temple Elm Creek Substation",[-97.32999087580839, 31.13087013905169]],
    [ "Whitney Dam Substation",[-97.37152928179859, 31.864588096511696]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.68538588483642, 37.97639046778874]],
    [ "340229203",[-79.99787944186205, 37.80067447900799]],
    [ "340233635",[-79.99894317082419, 37.7870257007299]],
    [ "340244775",[-93.3980416397425, 30.447513952505364]],
    [ "Phillips 66 Company",[-93.28259339724394, 30.243335443456814]],
    [ "Mossville Substation",[-93.29257274999999, 30.24346045]],
    [ "340312891",[-99.3431239, 34.667077649999996]],
    [ "340312892",[-99.33994270310501, 34.62267570978037]],
    [ "Cherry Substation",[-85.70316732521198, 44.663213794375224]],
    [ "340335123",[-92.2753573373732, 30.016774075036913]],
    [ "Lockhart Substation",[-90.92197350431653, 30.48232913255499]],
    [ "Alchem Substation",[-91.05218612017298, 30.229466205831276]],
    [ "Campbell Substation",[-92.51299249677051, 30.01342732750696]],
    [ "Choupique Substation",[-93.37573767520244, 30.16031950723971]],
    [ "Geigy Substation",[-91.10123373906988, 30.246510697524926]],
    [ "Geismar Substation",[-90.99525982100837, 30.229597487691517]],
    [ "Klondike Substation",[-92.63815922488742, 30.04149773955188]],
    [ "Monochem Substation",[-91.00871870474731, 30.208696279491885]],
    [ "Potter Substation",[-92.75844378445817, 30.09358637798492]],
    [ "Robbie Substation",[-92.72406573846779, 30.149239275039605]],
    [ "Stauffer Substation",[-91.1040988083204, 30.242806081107037]],
    [ "Sulphur Substation",[-93.3738586, 30.217925549999997]],
    [ "Sutan Substation",[-91.09566826406487, 30.237037995862337]],
    [ "Texlake Substation",[-92.72698967943049, 30.07166185895891]],
    [ "Thornwell Substation",[-92.80846319211044, 30.098828823741865]],
    [ "Winn Substation",[-92.7246374204282, 30.09658361180065]],
    [ "Arkansas Valley Electric Cooperative",[-94.34021361770634, 35.965704975499634]],
    [ "Entergy Louisiana",[-90.9180678027205, 30.459972905286076]],
    [ "Lockhart Substation",[-90.91788796466595, 30.49968741619156]],
    [ "Gloria Substation",[-91.01827568801768, 30.456289096638454]],
    [ "Jones Creek Substation",[-91.0223237812408, 30.42333832358901]],
    [ "Sharp Substation",[-91.0606156498786, 30.471941996595255]],
    [ "340385854",[-91.14140332578005, 30.345660990017464]],
    [ "Weiner Substation",[-91.02895749780981, 30.409898998981333]],
    [ "Entergy Louisiana",[-91.00485490248458, 30.38781801259083]],
    [ "Tiger Substation",[-91.17593249680672, 30.384983710386376]],
    [ "Joliet Substation",[-90.1185853492041, 29.964466316694025]],
    [ "Round Rock Northeast Substation",[-97.64892450205136, 30.54145232694025]],
    [ "Taylor West Substation",[-97.48663206317137, 30.556999723305804]],
    [ "Georgetown South Substation",[-97.6832025265973, 30.588512918538253]],
    [ "Round Rock Westinghouse Substation",[-97.698535170219, 30.567044289933058]],
    [ "Broussard Substation",[-91.15351735164273, 30.436411529947602]],
    [ "Westdale Substation",[-91.13700438158573, 30.42778753596267]],
    [ "LSU Substation",[-91.18151762133077, 30.409663762369966]],
    [ "Highland Substation",[-91.1589506, 30.395380099999993]],
    [ "Alaska Substation",[-91.18404133595614, 30.422691690244335]],
    [ "Ely Substation",[-80.12629105611902, 26.23646433165382]],
    [ "Swan Substation",[-91.18788065, 30.5303082]],
    [ "340468638",[-91.18843973965012, 30.492944256674527]],
    [ "Drusilla Substation",[-91.08592276030122, 30.430642290363213]],
    [ "Goudchaux Substation",[-91.1773994504729, 30.51087875561295]],
    [ "Jaguar Substation",[-91.18300200237827, 30.519186626279946]],
    [ "Jefferson Substation",[-91.10891569014186, 30.429792229243358]],
    [ "Mickens Substation",[-91.1236126126757, 30.520759505586454]],
    [ "Oncor",[-99.19780923664793, 31.536375178820332]],
    [ "Goldthwaite Substation",[-98.56638310672528, 31.430975776898507]],
    [ "Brown Substation",[-99.19521279428984, 31.53798864399355]],
    [ "340489067",[-79.98587485, 37.7697915]],
    [ "340489068",[-79.98611608202745, 37.76911382285908]],
    [ "Blount Substation",[-91.19302598194405, 30.54030174537115]],
    [ "Denham Springs Substation",[-90.95989947527795, 30.481142896913568]],
    [ "Georgia Power",[-82.23721704999998, 33.522881049999995]],
    [ "Trading Post Substation",[-97.97131438552647, 30.312883308818297]],
    [ "340593713",[-96.80133907768753, 32.80775482039407]],
    [ "Kirkland Park Substation",[-96.76396689055504, 32.89290842902784]],
    [ "Greenville Avenue Substation",[-96.76877019679429, 32.841153987990566]],
    [ "Haskell Substation",[-96.74596020021352, 32.782142280786914]],
    [ "340631516",[-96.81880705, 32.76448145]],
    [ "Calumet Substation",[-96.89454140000001, 32.742144700000004]],
    [ "Wall Street Substation",[-96.78510895643139, 32.76232067663779]],
    [ "340641132",[-97.15634449864275, 32.711017284634146]],
    [ "340641133",[-97.18511618571793, 32.71701863094872]],
    [ "340641135",[-97.07864435, 32.763987500000006]],
    [ "340641147",[-97.06662728988736, 32.77826581510367]],
    [ "340641160",[-97.1155999654207, 32.71368583644205]],
    [ "340663534",[-97.25440285, 32.6749586]],
    [ "340663535",[-97.27002456254424, 32.73341252505733]],
    [ "Hemphill Substation",[-97.33238305, 32.73938585]],
    [ "Mistletoe Heights Substation",[-97.35370565, 32.734544299999996]],
    [ "340699622",[-96.75395555, 33.003930499999996]],
    [ "Armstrong Substation",[-96.79217390815447, 32.822856263335865]],
    [ "Blackwell Street Substation",[-96.76582884598676, 32.86744297081865]],
    [ "Mesquite Solar 1",[-112.90401947502812, 33.34337648907548]],
    [ "Brim Substaiton",[-83.6656620494818, 41.40857611615154]],
    [ "Price Road Substation",[-84.36036267474812, 43.67798928426727]],
    [ "340879661",[-97.18697168077976, 32.85089652661607]],
    [ "Oncor",[-97.2265100054261, 32.84601265882939]],
    [ "340879728",[-97.32513136463298, 32.79906365116021]],
    [ "340879729",[-97.30567026151633, 32.463994826609664]],
    [ "340879731",[-97.3351358646754, 32.76274312693184]],
    [ "340879737",[-97.17395205000001, 32.5842764]],
    [ "340879757",[-97.38274036591028, 32.813522002894054]],
    [ "340879762",[-97.05940692503252, 32.870000992830946]],
    [ "Euless South Substation",[-97.12213577473351, 32.81508315815582]],
    [ "340879786",[-97.30785167575264, 32.875692324948616]],
    [ "340879792",[-97.01166687070338, 32.86551500351635]],
    [ "Oncor",[-97.33644275, 32.742122099999996]],
    [ "340879805",[-97.34764599999998, 32.64782459999999]],
    [ "340879839",[-97.42501421381, 32.495047136840405]],
    [ "340879844",[-97.2232464641205, 32.805538222384506]],
    [ "340879847",[-97.30268153464151, 32.82066066614059]],
    [ "340879848",[-97.38387762657544, 32.46186744835869]],
    [ "340879853",[-97.06364249601361, 32.818364033180906]],
    [ "Bedford Substation",[-97.14731474538955, 32.852673421312105]],
    [ "Bryan Avenue Substation",[-97.32501189999999, 32.704357300000005]],
    [ "Forest Hill Substation",[-97.28616696956735, 32.64490271440698]],
    [ "Forest Hill Switching Station",[-97.28710247711697, 32.64482471615639]],
    [ "Duval Substation",[-97.29522370647311, 32.72536757522808]],
    [ "340991843",[-97.35785517044596, 32.75862044659686]],
    [ "Blackstone Substation",[-97.39171560117752, 32.76473669914926]],
    [ "General Dynamics Substation",[-97.4526988650849, 32.77296802416495]],
    [ "North Main Substation",[-97.33573280394441, 32.76206484216195]],
    [ "341012449",[-97.12185107521347, 32.844313192801295]],
    [ "341012455",[-97.45856743742097, 32.76741152473193]],
    [ "Colleyville Substation",[-97.16532208474187, 32.894518296480676]],
    [ "Keller Wall Price Substation",[-97.25657326874867, 32.920599834931906]],
    [ "341026559",[-83.60830686791626, 32.64860919086104]],
    [ "341030397",[-97.09108995, 32.900675150000005]],
    [ "Euless Substation",[-97.09931076499183, 32.86532491623057]],
    [ "Grapevine Ball Street",[-97.08495590759054, 32.92613352595727]],
    [ "341093644",[-98.19496617582857, 29.870521709477423]],
    [ "Crane's Mill Substation",[-98.28332787661257, 29.852456993803724]],
    [ "Sattler Substation",[-98.17121675617953, 29.849710318664375]],
    [ "341106997",[-83.69040520619184, 32.562283122879386]],
    [ "341119430",[-79.99289688869516, 37.803319582826056]],
    [ "341148266",[-79.11383495545549, 34.829228179917784]],
    [ "341162122",[-97.02024766532871, 32.92654386778255]],
    [ "Coppell Switching Station",[-97.00784974999998, 32.94908075]],
    [ "Custer Substation",[-96.75244431433342, 33.1598322252253]],
    [ "Collin Steam Electric Station",[-96.81315876833787, 33.19832344640533]],
    [ "Frisco Substation",[-96.83162706095288, 33.181827425076754]],
    [ "Lebanon Substation",[-96.77479134232273, 33.11113917523464]],
    [ "Lebanon Substation",[-96.77489260130585, 33.13695547572647]],
    [ "Navo Substation",[-96.91786180174114, 33.221109182167794]],
    [ "North Lake Substation",[-96.97571656466381, 32.95133748057758]],
    [ "Panther Creek Substation",[-96.87700450264698, 33.20318660897191]],
    [ "Rock Hill Substation",[-96.79329195909499, 33.20312396688164]],
    [ "U.S. Marine Corps Supply Depot Substation",[-84.055253319157, 31.55764111428611]],
    [ "Georgia Power",[-84.52118143874226, 33.90312238330984]],
    [ "341282090",[-96.84827439999998, 32.95609935]],
    [ "341282099",[-96.819564866867, 32.96238952293349]],
    [ "341282104",[-96.85677405536741, 33.012179721784484]],
    [ "Oncor",[-96.84905147741176, 32.97592695579446]],
    [ "Carrollton-Josey Lane Substation",[-96.88905402554107, 32.977436843171276]],
    [ "Carrollton-Tarpley Road Substation",[-96.85064297495444, 32.982078954171214]],
    [ "Carrollton-Upfield Substation",[-96.91275448932386, 32.95041760530321]],
    [ "341316593",[-96.99718581309935, 33.00305629870943]],
    [ "Highland Substation",[-97.05195156855224, 33.085989361660396]],
    [ "South Substation",[-97.01086768239065, 33.006291663916365]],
    [ "West Substation",[-97.03502502501952, 33.047907612321644]],
    [ "Fischer Substation",[-98.20578526252018, 29.93314549912652]],
    [ "Highway 32 Substation",[-98.09356166811506, 29.94576872390263]],
    [ "341365118",[-94.47782281805884, 44.33319748060952]],
    [ "341383339",[-93.32587065098855, 30.18403363688005]],
    [ "Citcon West Substation",[-93.3435268, 30.188382399999995]],
    [ "Rosebluff Substation",[-93.32451305, 30.1845118]],
    [ "Peterboro Station",[-75.75044179247497, 43.094942973306814]],
    [ "341571072",[-93.79753280434767, 32.46917752508468]],
    [ "Harts Island Substation",[-93.70298455, 32.4364154]],
    [ "Western Electric Substation",[-93.80857228457673, 32.38145061564084]],
    [ "Ellerbe Road Substation",[-93.74547256306356, 32.43075900281002]],
    [ "Linwood Substation",[-93.76247085, 32.4535331]],
    [ "Port Robson Substation",[-93.64259175, 32.3646737]],
    [ "Powell Substation",[-93.79701134193702, 32.45300281711265]],
    [ "South Shreveport Substation",[-93.76450029336982, 32.41957883265592]],
    [ "Wallace Lake Substation",[-93.69809304350812, 32.327818052371036]],
    [ "Kentucky Utilities Company",[-84.46537954008247, 38.04642258481546]],
    [ "Public Service Company of Oklahoma",[-95.85437243465002, 36.04728190048465]],
    [ "Cemex Substation",[-98.18080862258219, 29.675020030338878]],
    [ "EC Mornhinweg Substation",[-98.20290420205534, 29.658207099513756]],
    [ "Freiheit Road Substation",[-98.08592084006335, 29.703953800548618]],
    [ "Loop 337 Substation",[-98.15997181579935, 29.702245780520514]],
    [ "Seymour Substation",[-99.25457147269498, 33.59466245252336]],
    [ "Duke Energy",[-80.24000564865702, 36.095797330774396]],
    [ "341624931",[-91.20102215000001, 30.555007500000002]],
    [ "Entergy",[-91.21237749242178, 30.57759516877406]],
    [ "Brady Heights Substation",[-91.0477489810569, 30.857922484772928]],
    [ "Clinton Substation",[-91.02322378057038, 30.863688123705487]],
    [ "Jackson Substation",[-91.20768655261878, 30.83130636713126]],
    [ "Marydale Substation",[-91.3013578058296, 30.8472853709313]],
    [ "McManus Substation",[-91.12519079960036, 30.837102443098427]],
    [ "Sandy Creek Substation",[-91.26560447714874, 30.696017485433405]],
    [ "Zachary Substation",[-91.15751279409555, 30.649998411498167]],
    [ "Zachary Substation",[-91.1610798, 30.6421085]],
    [ "Hearne Southwest Substation",[-96.60725117538864, 30.861871718973685]],
    [ "Hearne Substation",[-96.60106130189573, 30.859892048870396]],
    [ "341673013",[-89.74026690000001, 35.0446039]],
    [ "Oncor",[-96.8716313, 32.77769225]],
    [ "341698284",[-96.87462936752311, 32.75521093892643]],
    [ "Belfair Substation",[-91.1442068039346, 30.47375290756206]],
    [ "East Substation",[-91.14326449933613, 30.449315979616962]],
    [ "Florida Substation",[-91.10810094056504, 30.45599886436062]],
    [ "Northdale Substation",[-91.1693202, 30.46781655]],
    [ "Sears Substation",[-91.12543569999998, 30.454434299999996]],
    [ "Arsenal Hill Substation",[-93.76193019645048, 32.51609580779083]],
    [ "Brownlee Road Substation",[-93.73086401839807, 32.57771848393376]],
    [ "Marshall Substation",[-94.39636426178133, 32.53888959761518]],
    [ "McWillie Substation",[-93.76539863625581, 32.480071235030415]],
    [ "North Market Substation",[-93.77309165, 32.540639950000006]],
    [ "Raines Road Substation",[-93.82819960984274, 32.564681724920405]],
    [ "Scottsville Substation",[-94.2543148720594, 32.54329909759956]],
    [ "Southeast Marshall Substation",[-94.3517138, 32.5223399]],
    [ "Bristol Substation",[-97.67454896811988, 45.37294427477238]],
    [ "Ottawa Substation",[-83.36520425978247, 42.37605917253589]],
    [ "341878775",[-83.68639141990182, 41.5582260506933]],
    [ "341884593",[-89.39857915975433, 31.331682324996248]],
    [ "Belcher Substation",[-93.8550383102361, 32.74575312504359]],
    [ "Brooks Street Substation",[-93.750819148284, 32.49929267806649]],
    [ "Edwards Street Substation",[-93.7395927215578, 32.50444094125194]],
    [ "Fort Humbug Substation",[-93.72303023300752, 32.49846202521113]],
    [ "Gilliam Substation",[-93.86688761162505, 32.81760551029374]],
    [ "Hosston Substation",[-93.88326759821538, 32.884007344790035]],
    [ "Lieberman 138kV Substation",[-93.96075589613086, 32.70625004282609]],
    [ "Pierremont Substation",[-93.70802249089866, 32.45559772243708]],
    [ "Trichel Street Substation",[-93.69770663190573, 32.499225002590705]],
    [ "Vivian Substation",[-93.98739164999999, 32.86565975]],
    [ "Barry Substation",[-85.28618635, 42.6128988]],
    [ "Hastings Substation",[-85.46517773758995, 42.57743058749543]],
    [ "Wayland Substation",[-85.56458363169365, 42.64427446011183]],
    [ "Gun Lake Substation",[-85.51494613441271, 42.577361251769425]],
    [ "Fowlkes Substation",[-89.37922021753097, 35.97648287871452]],
    [ "341942825",[-89.3803542871617, 35.97674953763861]],
    [ "341955840",[-83.6360244, 32.59177955]],
    [ "Midland Substation",[-80.46003394174596, 40.63348860339924]],
    [ "Red Point Substation",[-93.54914018152718, 32.556230138949935]],
    [ "Bodcau Road Substation",[-93.60461751677208, 32.552205739319106]],
    [ "Whitehurst Substation",[-93.65911865483224, 32.53887381611267]],
    [ "Fern Street Substation",[-93.73154851475815, 32.45158655241672]],
    [ "Flournoy Substation",[-93.92029775, 32.44889310000001]],
    [ "Ford Substation",[-93.88703705, 32.442648150000004]],
    [ "General Motors Substation",[-93.91770914999998, 32.432442699999996]],
    [ "Louisiana Avenue Substation",[-93.75514973325272, 32.514173900568224]],
    [ "Marshall Street Substation",[-93.75296564091225, 32.51558259403221]],
    [ "Pines Road Substation",[-93.86801860000003, 32.4806042]],
    [ "Waskom Substation",[-94.04639045, 32.47809155]],
    [ "Caropines Substation",[-78.98860186885615, 33.60841998373624]],
    [ "342088846",[-79.03860912048279, 33.55964920043879]],
    [ "342088848",[-79.10360971281085, 33.47612744662996]],
    [ "Hardy Substation",[-93.79762564999999, 32.48483585]],
    [ "Waterworks Substation",[-93.79131763717797, 32.50451163144149]],
    [ "Forbing Road Substation",[-93.75197937911652, 32.41683670013876]],
    [ "Georgia Pacific Substation",[-93.98402838924088, 32.0158228189977]],
    [ "Keatchie Co Op Substation",[-93.914434565168, 32.18810497462278]],
    [ "Logansport Substation",[-94.00421211857821, 31.979411152757393]],
    [ "Stonewall Substation",[-93.8645745, 32.270873249999994]],
    [ "342148469",[-79.01955444316403, 33.613472569699965]],
    [ "Garden City Beach Substation",[-79.0112541873947, 33.59173632987899]],
    [ "Pooley Road Substation",[-97.74711398425887, 29.695603016102964]],
    [ "Thompson Creek Substation",[-96.41744164654915, 30.595067238383265]],
    [ "Greens Prairie Substation",[-96.25780371913388, 30.554228427628114]],
    [ "Simmonsville Substation",[-79.18221032618051, 33.422335802346254]],
    [ "Pawley's Island Substation",[-79.15141824035636, 33.429621123739814]],
    [ "342296641",[-79.11825952892379, 33.455077192403095]],
    [ "342357908",[-97.36382971771697, 32.69058989126301]],
    [ "342357909",[-97.0259471912723, 32.466100946900745]],
    [ "342357910",[-97.03623788011932, 32.4565181615323]],
    [ "Alvarado Substation",[-97.22349670025254, 32.396295545161685]],
    [ "Cleburne Substation",[-97.37487429529024, 32.354097578427464]],
    [ "Keene Substation",[-97.33611482187432, 32.36740397108726]],
    [ "342411441",[-87.37943367148107, 46.33344519557954]],
    [ "342413856",[-79.20728500526798, 33.37552812958727]],
    [ "342436901",[-82.25743907094014, 33.473081064407]],
    [ "342455288",[-93.92730000000002, 30.930394200000002]],
    [ "Doucette Substation",[-94.43485125217258, 30.835733737624057]],
    [ "Fork Creek Substation",[-94.2936594954172, 30.883321873799442]],
    [ "Jasper Substation",[-94.00061851969994, 30.9508058949709]],
    [ "Kountze Bulk Substation",[-94.33117868770329, 30.359074002777234]],
    [ "Mill Creek Substation",[-94.10604565000001, 30.99427615]],
    [ "Newton Bulk Substtaion",[-93.7877478, 30.869912549999995]],
    [ "Sam Dam Substation",[-94.10482231772629, 31.059218912383084]],
    [ "Turkey Creek Substation",[-94.42413639040844, 30.83669022388253]],
    [ "Warren Substation",[-94.43506156716089, 30.619953896727885]],
    [ "342510266",[-82.29254907888935, 33.575980892918864]],
    [ "San Manuel Substation",[-110.62587102804558, 32.61856189491705]],
    [ "342598334",[-89.48506532824895, 34.359529645996915]],
    [ "342598336",[-89.66588615, 34.35508995]],
    [ "Arizona Public Service",[-112.15336839924012, 33.442940477068284]],
    [ "342640214",[-111.99483423008604, 33.28223465995362]],
    [ "342640215",[-112.01394628482528, 33.0592628717805]],
    [ "342654033",[-81.61326199957561, 34.679295758692234]],
    [ "MidAmerican Energy",[-90.55033913826077, 41.58853128498659]],
    [ "Ranch Road 12 Substation",[-97.99184263260152, 29.9005837509347]],
    [ "342687333",[-96.84596169329728, 32.44451606517291]],
    [ "342687353",[-96.90769119999999, 32.4679745]],
    [ "342687354",[-96.85788613597664, 32.6092307813301]],
    [ "342687361",[-96.74155991698188, 32.49439931026479]],
    [ "342687362",[-96.87729339835212, 32.45776903875291]],
    [ "342687363",[-96.80572313805776, 32.53436944429667]],
    [ "Hutchins Substation",[-96.7053337, 32.6303563]],
    [ "Midlothian South Substation",[-96.9907997005945, 32.4673437726657]],
    [ "342688360",[-111.44284829921195, 33.07094333991376]],
    [ "342688384",[-112.06273032490166, 33.06303129444695]],
    [ "Pinal Central Substation",[-111.56166367259993, 32.870177716946095]],
    [ "Hidden Valley Substation",[-112.12982002263936, 32.99981184066352]],
    [ "Northaven Switching Station",[-96.81005051917367, 32.90137727699204]],
    [ "342701078",[-96.8728433, 32.846812199999995]],
    [ "Morrison Lane Substation",[-96.8934412634273, 32.8831675500263]],
    [ "342724532",[-88.90160545000002, 34.72988765]],
    [ "342737799",[-96.99194215, 32.89492645]],
    [ "342757287",[-95.96170319384885, 36.74964112268891]],
    [ "342796975",[-76.04128030479785, 41.57478745812582]],
    [ "342796976",[-76.04208527159261, 41.57488900242687]],
    [ "JNEC",[-94.10493850000002, 30.8825291]],
    [ "JNEC",[-94.18727071726578, 31.006508568961042]],
    [ "Fletcher Substation",[-94.19029725, 30.262738500000005]],
    [ "Kirbyville Substation",[-93.89050164999999, 30.673097100000003]],
    [ "North Silsbee Substation",[-94.17598629999999, 30.376272600000004]],
    [ "Evadale Substation",[-94.0694034627814, 30.341360932781914]],
    [ "J. K. Spruce Switchyard",[-98.32037580078983, 29.312417364125842]],
    [ "Lake Mitchell Substation",[-85.4530737855867, 44.2362689703411]],
    [ "Uptown Substation",[-97.10789122911805, 44.90154820684777]],
    [ "342897831",[-96.84888638761788, 32.81295172146771]],
    [ "Record Crossing Substation",[-96.85588005, 32.81807445]],
    [ "342897833",[-96.83831213370424, 32.808062750320104]],
    [ "Lomo Alto Substation",[-96.81272899852823, 32.84995459987664]],
    [ "Reagan Street Substation",[-96.81920537878337, 32.803684080386674]],
    [ "342981199",[-76.19111467530482, 43.11010912002054]],
    [ "343001252",[-96.17514834914151, 33.5743125121814]],
    [ "Datto Substation",[-90.72998575437983, 36.40831319945253]],
    [ "Clay County Electric Cooperative Cooperation",[-90.60484125849885, 36.43396897530186]],
    [ "Clay County Electric Cooperative Corperation",[-90.93896797274176, 36.285605141857694]],
    [ "Poncahontas North Substation",[-90.96768339873636, 36.28250261670903]],
    [ "343130263",[-93.56515134159126, 44.442365857333286]],
    [ "Knippa Substation",[-99.64603365189225, 29.28864009444246]],
    [ "D'Hanis Substation",[-99.27757016254571, 29.321028375139555]],
    [ "Sabinal Substation",[-99.46359021314593, 29.298849958183574]],
    [ "Uvalde Substation",[-99.7985821489902, 29.213014943645756]],
    [ "Uvalde Substation",[-99.72988476333151, 29.222436115562285]],
    [ "343150314",[-96.70054895924589, 32.727396925249906]],
    [ "343150317",[-96.34968611395608, 32.915396217726794]],
    [ "Stagecoach Substation",[-111.87319759721086, 33.813336189998516]],
    [ "Via Doña Substation",[-111.82673638580208, 33.742260890674515]],
    [ "McGregor Substation",[-97.40295665000001, 31.43896675]],
    [ "Waco Sanger Avenue Substation",[-97.19695381749808, 31.52247979543692]],
    [ "Waco Woodway Substation",[-97.22215838496224, 31.512204275579272]],
    [ "Belton Substation",[-97.45864093960078, 31.08319136428077]],
    [ "Waco Atco Substation",[-97.25082231730524, 31.485288180542145]],
    [ "Asphalt Mines Substation",[-100.0241696736704, 29.188127284459775]],
    [ "Brackettville Substation",[-100.39228466948208, 29.324610951007138]],
    [ "Eclipse Substation",[-100.39203980000002, 29.32395135]],
    [ "Odlaw Substation",[-100.19805397345162, 29.268277999998645]],
    [ "West Batesville Substation",[-99.72873314402915, 28.94489845337306]],
    [ "West Uvalde Substation",[-99.8347882019522, 29.18353175415113]],
    [ "343387971",[-96.11667524295277, 32.90306768365473]],
    [ "343387972",[-96.63645807336215, 32.910147403961055]],
    [ "343387978",[-96.25369604877501, 32.732182154802906]],
    [ "Terrell Substation",[-96.28053647770815, 32.7714847028496]],
    [ "343409570",[-111.6668016186197, 33.54832232972518]],
    [ "SRP Boone Substation",[-111.70435190578326, 33.43787075844321]],
    [ "SRP Pima Substation",[-111.89236085522008, 33.49384764573997]],
    [ "343430386",[-94.75663022567997, 32.569932307109724]],
    [ "Longview Heights Substation",[-94.68738942260362, 32.506478457209575]],
    [ "343430410",[-94.70240848451293, 32.42827490028428]],
    [ "Greggton Substation",[-94.81580074708808, 32.51080736658349]],
    [ "Harrison Road Substation",[-94.80905708437028, 32.493650151788295]],
    [ "Knox Lee",[-94.64139655245849, 32.37741804338702]],
    [ "Lake Lamond Substation",[-94.77002789252316, 32.506656459930255]],
    [ "LeTourneau Substation",[-94.73178003007666, 32.458615543179526]],
    [ "Longview Substation",[-94.72989414419347, 32.49242449124923]],
    [ "Spring Hill Substation",[-94.81253237430153, 32.581854252793455]],
    [ "Whitney Substation",[-94.7151764479442, 32.46968111702969]],
    [ "Bakersfield Substation",[-102.28909180000002, 30.97585545]],
    [ "Castle Gap Substation",[-102.29505106869928, 31.11571551221227]],
    [ "McCamey Substation",[-102.20329504804293, 31.137250711337447]],
    [ "North McCamey Subsation",[-102.22321930437313, 31.153618848361543]],
    [ "North McCamey Substation",[-102.22679962559185, 31.15506331893457]],
    [ "Oxy Tap Substation",[-102.29791480312437, 31.119233075622006]],
    [ "Tippet Substation",[-102.13376039999999, 30.992163050000002]],
    [ "Big Sandy Substation",[-95.10574753792312, 32.58882840109674]],
    [ "Perdue Substation",[-94.99806184489455, 32.57301539617594]],
    [ "Antioch Substation",[-86.46057281114658, 31.32065034561911]],
    [ "Hotchkiss Substation",[-83.97405416084045, 43.577625734986086]],
    [ "Carter Substation",[-84.13023586835097, 43.579455394891916]],
    [ "Smith Creek Substation",[-84.26760185, 44.2722716]],
    [ "Anacacho Substation",[-100.1712142, 29.204646]],
    [ "343593575",[-83.59860085, 32.85942765]],
    [ "Central Bluff Substation",[-100.15481485000001, 32.117189249999996]],
    [ "Harbor Substation",[-112.04915829297616, 33.43854849538987]],
    [ "343779341",[-85.5663879487274, 39.741951469003666]],
    [ "Georgia Power",[-83.5677743, 32.804179350000005]],
    [ "Nordbeck Substation",[-85.98478950865209, 44.52024492516456]],
    [ "Copemish Substation",[-85.89865553922792, 44.42732280116746]],
    [ "343875020",[-65.64922876266594, 18.22096449598694]],
    [ "Ferris Substation",[-99.74521706666665, 29.323261666666664]],
    [ "Leona Substation",[-99.71146260630995, 29.08552496866338]],
    [ "North Batesville Substation",[-99.61682496255902, 28.963355007286527]],
    [ "Sabinal Substation",[-99.464664477728, 29.3153618542687]],
    [ "South Batesville Substation",[-99.60625682625424, 28.920792332724762]],
    [ "Entergy Louisiana",[-90.97271355353277, 30.415613592251834]],
    [ "DEMCO",[-90.89219270721219, 30.392277432826646]],
    [ "Hilltop Lakes Substation",[-96.22217908974947, 31.080041569539475]],
    [ "North Zulch Substation",[-96.0738158668653, 30.919755778580498]],
    [ "Bedias Substation",[-95.96571271963404, 30.785500427550964]],
    [ "Petteway Substation",[-96.52449417063782, 31.16660883142983]],
    [ "344024177",[-95.8138481152733, 31.63284781011264]],
    [ "344024179",[-95.76378767691747, 31.594426826777372]],
    [ "344025038",[-95.8306778761551, 31.74767043189096]],
    [ "344028187",[-95.70992863813797, 31.655378065509282]],
    [ "344028189",[-95.706572142654, 31.65208056612108]],
    [ "Ranchtown Substation",[-98.73599353030356, 29.617836123403862]],
    [ "Palo Duro Substation",[-99.19058265, 28.845922350000002]],
    [ "South Texas Electric Cooperative",[-99.091733415494, 28.93129959636296]],
    [ "Frio Town Substation",[-99.34344533448909, 29.022088545931364]],
    [ "344123745",[-93.00680597717654, 45.509686278436625]],
    [ "344126517",[-93.21579845853422, 45.56573700798802]],
    [ "Sunnyslope Substation",[-112.05991727329898, 33.5741315830125]],
    [ "Dames Ferry Substation",[-83.74188259045204, 33.0472900217781]],
    [ "Derby Substation",[-99.19392212877648, 28.79042400405039]],
    [ "Dilley Substation",[-99.20191137593541, 28.68051343718395]],
    [ "Dilley Substation",[-99.174124427879, 28.664596565620766]],
    [ "Dilley Switching Station",[-99.20512169297707, 28.668791620762782]],
    [ "Pearsall Substation",[-99.07932445, 28.8881174]],
    [ "Pleasanton Substation",[-98.43814582655843, 28.99033950968224]],
    [ "Gray Substation",[-83.56356419999999, 32.99532805]],
    [ "Peltz Substation",[-75.18965001572948, 39.94044602042384]],
    [ "SRP Beeline Substation",[-111.90939909153093, 33.47347797301615]],
    [ "Chambers Substation",[-111.9008713229473, 33.46353475841988]],
    [ "Noble Substation",[-111.9010321028661, 33.461832497848725]],
    [ "Rough Canyon Substation",[-100.89600540545098, 29.53745788084575]],
    [ "344546760",[-101.02738735000001, 29.460287250000004]],
    [ "Amistad Switchyard",[-101.05574974309162, 29.44949502498506]],
    [ "Amistad Switchyard",[-101.05468270387796, 29.448233266090067]],
    [ "Buena Vista Substation",[-100.91573021931285, 29.40107758913499]],
    [ "Del Rio Substation",[-100.89328152060229, 29.36703472265324]],
    [ "Picacho Substation",[-100.94093770329567, 29.432449327501864]],
    [ "Westland Sub",[-106.71731280000002, 35.075887]],
    [ "Las Lomas Substation",[-117.7385614074743, 33.71839197992529]],
    [ "Virginia Electric and Power Company",[-76.32585934318355, 37.030774325705636]],
    [ "Santa Rosa Substation",[-116.39202251864212, 33.7477732081643]],
    [ "Arizona Public Service",[-111.9111859733676, 33.426492313657505]],
    [ "Arizona Public Service",[-111.9167413714953, 33.42266845562735]],
    [ "Arizona Public Service",[-111.9110027236609, 33.42339632725971]],
    [ "344775796",[-76.41152625756595, 36.975383518231155]],
    [ "Comstock Substation",[-101.1394552, 29.747458249999994]],
    [ "Comstock Substation",[-101.13839533447828, 29.74803607440313]],
    [ "Illinnois #4 Substation",[-101.53549235324358, 30.554505034306104]],
    [ "344842934",[-78.49618726942678, 38.031416301985736]],
    [ "344845012",[-85.86686203548895, 41.58028266954443]],
    [ "MidAmerican Energy",[-91.57354284359567, 41.64735211269301]],
    [ "344865540",[-85.8311216478687, 41.589613709789994]],
    [ "SRP Tempe Substation",[-111.88352303722935, 33.41547218900368]],
    [ "344960172",[-111.87864078882399, 33.41080249540591]],
    [ "Robinson Substation",[-97.10760744999999, 31.445499350000006]],
    [ "Waco M&M Mars 1 Substation",[-97.19653339999999, 31.488107899999996]],
    [ "Waco East Substation",[-97.11965947033381, 31.559735628209875]],
    [ "345041930",[-95.34114771021316, 32.3469103909198]],
    [ "Waco Northwest Substation",[-97.20508294124603, 31.543901182946435]],
    [ "McGregor Substation",[-97.42576140000001, 31.442076649999997]],
    [ "Crawford Substation",[-97.40890033929198, 31.540210414046978]],
    [ "Bellmead Substation",[-97.11038067785813, 31.61185219341909]],
    [ "Waco North Substation",[-97.17930129198527, 31.577443476877626]],
    [ "Cauthorn Substation",[-100.67481554999999, 30.304782599999996]],
    [ "Sonora Substation",[-100.65577535252903, 30.567663752204947]],
    [ "Washburn Retail Substation",[-81.8133309, 35.39004779999999]],
    [ "345142711",[-81.81812962408172, 35.292425994812334]],
    [ "Georgia Power",[-83.64489945000001, 32.68285955000001]],
    [ "SRP Hanger Substation",[-111.89281085160344, 33.36440205593062]],
    [ "Clear Lake Substation",[-84.14996023826173, 42.3070070751963]],
    [ "Lawndale Substation",[-93.5014616, 45.079920599999994]],
    [ "SRP Neely Substation",[-111.80632847591647, 33.33132135187916]],
    [ "345472986",[-96.82201435048495, 32.9314404172252]],
    [ "345472990",[-96.84724547482348, 32.93313655660221]],
    [ "Oncor",[-96.80096927383107, 32.97646287484567]],
    [ "Richardson Collins Boulevard Substation",[-96.71538989709244, 32.967473727403515]],
    [ "Richardson Woodhaven Substation",[-96.71511428558284, 32.938212028853776]],
    [ "Hallsville Substation",[-94.5780630053099, 32.50603873468778]],
    [ "Marshall Substation",[-94.39458677661473, 32.53840093060151]],
    [ "North Marshall Substation",[-94.36867029999999, 32.56877915]],
    [ "Hillsboro Substation",[-97.13695728689912, 32.01480120095955]],
    [ "345547537",[-96.85113268578613, 32.37741524330524]],
    [ "345576845",[-97.26849634999999, 32.83022505]],
    [ "PAVE PAWS Substation",[-100.5512167, 30.979612300000003]],
    [ "Eldorado Live Oak Substation",[-100.57007836960082, 30.87803471765048]],
    [ "Sun Streams Project",[-112.84314941828089, 33.34625500450289]],
    [ "Sun Valley Substation (TS-5)",[-112.68944647043925, 33.66810130576035]],
    [ "345649427",[-92.98757366816739, 45.17437262705077]],
    [ "345691706",[-115.06148315, 36.1821952]],
    [ "Midtown Substation",[-112.0720264903013, 33.49176014257793]],
    [ "Wingate Substation",[-84.03295620000003, 42.22109625000001]],
    [ "Arizona Public Service",[-112.10276817385918, 33.57746943964873]],
    [ "East End Substation",[-111.88599740627818, 33.64413135789642]],
    [ "Langford Wind Substation",[-100.63074685000001, 31.1185543]],
    [ "Santiago Substation",[-100.5132428, 31.116265799999994]],
    [ "Schkade Substation",[-100.53169790000001, 31.40451405]],
    [ "San Angelo Avenue N Substation",[-100.47738528621944, 31.44512938594312]],
    [ "345986743",[-112.25573871491417, 33.49009891294173]],
    [ "Cambridge Substation",[-84.24713270000001, 42.07894904999999]],
    [ "Winchester Substation",[-84.98625811594988, 40.17670428265416]],
    [ "346051139",[-88.13214861791062, 30.678000367345863]],
    [ "Rusthill Substation",[-100.42482348002974, 31.45172565236849]],
    [ "San Angelo Coke Street Substation",[-100.40439852468636, 31.463937775266675]],
    [ "San Angelo Lake Drive Substation",[-100.46637104999999, 31.495977299999993]],
    [ "San Angelo North Substation",[-100.43520232095854, 31.494014298536907]],
    [ "San Angelo Paulann Substation",[-100.3853081320697, 31.48820311887944]],
    [ "346342355",[-75.97650660154189, 36.84570531749068]],
    [ "346364186",[-90.84156604270132, 33.80710722497255]],
    [ "Entergy Mississippi",[-90.77912540000001, 33.7983586]],
    [ "Rosedale Substation",[-90.97632242117822, 33.83490430733401]],
    [ "Entergy Mississippi",[-90.71362236590245, 33.79353692019945]],
    [ "Two Dot Substation",[-110.07247394915262, 46.42607945291071]],
    [ "Rainbow",[-111.1952063606788, 47.5373436810716]],
    [ "Northwest Energy",[-110.1017968459579, 45.66229980459888]],
    [ "Three Rivers Substation",[-111.48220763787317, 45.94471377888439]],
    [ "Newman Switching Station",[-96.62455223977915, 32.91362209769508]],
    [ "346508738",[-96.68001752475068, 32.93421207110384]],
    [ "Castle Substation",[-96.6141739655997, 32.92135248065217]],
    [ "Garland Substation",[-96.67762924231675, 32.90094095045099]],
    [ "Marquis Substation",[-96.67765626876779, 32.902192241849846]],
    [ "Naaman Substation",[-96.61138848592842, 32.93691318434606]],
    [ "Shiloh Substation",[-96.66687405859676, 32.900590959270346]],
    [ "Walnut Substation",[-96.63170076290403, 32.91642553475876]],
    [ "PacifiCorp",[-111.70178762942417, 40.31821424303291]],
    [ "Centerville Substation",[-96.63457251099022, 32.87090206791883]],
    [ "Miller Substation",[-96.60240490971097, 32.894579554318845]],
    [ "Wynn Joyce Substation",[-96.60159499836764, 32.865524254067715]],
    [ "Crist Road Substation",[-96.62481410160309, 32.93719636716849]],
    [ "Hulldale Substation",[-100.55537945000002, 31.0049199]],
    [ "Arrot Substation",[-100.50966395000002, 31.073597999999997]],
    [ "Christoval Substation",[-100.4907822, 31.191862750000006]],
    [ "San Angelo Emerson Street Substation",[-100.4259275, 31.473927499999995]],
    [ "San Angelo Jackson Street Substation",[-100.45573578871502, 31.45008032470732]],
    [ "San Angelo Lake Nasworthy Substation",[-100.4507583, 31.3623077]],
    [ "San Angelo Mathis Field Substation",[-100.4967651, 31.343775100000006]],
    [ "San Angelo Walnut Street Substation",[-100.45713503368886, 31.46449529953895]],
    [ "346832060",[-96.80024822369697, 31.856472265461704]],
    [ "346832061",[-97.07570418884613, 31.74223914109359]],
    [ "Lorena Substation",[-97.2129077, 31.355317499999998]],
    [ "Abbott Substation",[-97.07770564910943, 31.88499529956289]],
    [ "Eddy Substation",[-97.26045508153737, 31.291968396537726]],
    [ "Grandview TMPP Substation",[-97.2401708021363, 32.33663671763914]],
    [ "Lorena Substation",[-97.2115684323354, 31.376902213114153]],
    [ "Mertens Substation",[-96.89252024999999, 32.05815415]],
    [ "Ross Substation",[-97.11326503228, 31.749587954283303]],
    [ "346878504",[-97.21500645441968, 32.342503148549106]],
    [ "Lillian Substation",[-97.19503171827513, 32.49086183616365]],
    [ "346879478",[-80.93365744369999, 34.149448343007705]],
    [ "Fort Worth Substation",[-97.15853583433375, 33.16173235059046]],
    [ "346938537",[-97.12599670730502, 33.135381568996216]],
    [ "346938538",[-97.08859628017531, 33.158568830108834]],
    [ "Pockrus Substation",[-97.08460521765993, 33.171992237437166]],
    [ "Teasley Substation",[-97.10838087834121, 33.14491905298547]],
    [ "Sanger North Substation",[-97.18640842552226, 33.369539194347354]],
    [ "Rector Road Substation",[-97.1918294701731, 33.32234304672618]],
    [ "346943632",[-83.65133792649851, 41.40771258500783]],
    [ "American Cement Substation",[-82.02302986105299, 28.761864875012243]],
    [ "Nogales Tap Substation",[-110.858079476393, 32.05315902420872]],
    [ "Southeast Substation",[-85.42265728218572, 41.781027215659876]],
    [ "Langfords Crossroads",[-80.90167120000001, 34.206275649999995]],
    [ "347019224",[-112.10881079951666, 33.548424135099395]],
    [ "347019239",[-112.12655248258936, 33.569938873061375]],
    [ "El Paso Electric",[-106.39067888573348, 31.91427761529877]],
    [ "347284566",[-80.84042698157901, 34.177179935431305]],
    [ "347394368",[-86.49915773189058, 40.28834192653201]],
    [ "Public Service Company of Oklahoma",[-96.01580605586355, 36.16189903695577]],
    [ "347514350",[-109.67999280301711, 32.93949331179882]],
    [ "347514351",[-109.66605043384496, 32.96854742075568]],
    [ "347514356",[-109.68240791217482, 32.93954450385717]],
    [ "347514359",[-109.77033839827654, 32.83359491057157]],
    [ "Dalton Gardens Substation",[-116.78541107722033, 47.74399520574773]],
    [ "FIXME Substation",[-93.42567669555162, 37.845048335085224]],
    [ "FIXME Substation",[-93.27658745, 37.90573500000001]],
    [ "348021252",[-82.65602235, 34.7665633]],
    [ "348021254",[-82.68517282076833, 34.783043434126185]],
    [ "348170416",[-97.22444709166835, 32.905042845556586]],
    [ "348178407",[-97.20129447664758, 32.89365699905654]],
    [ "348206326",[-97.26316423221846, 32.964564274210574]],
    [ "348206335",[-97.2560553056986, 32.941777686543766]],
    [ "Arkansas Electric Cooperative Corporation",[-90.67130320000001, 35.7767506]],
    [ "Jonesboro City Water and Light",[-90.6234421602608, 35.80538893352137]],
    [ "Jonesboro City Water and Light",[-90.67832726811025, 35.78370142402751]],
    [ "Glenwillow Substation",[-81.4667736819537, 41.36420162581828]],
    [ "Twist Substation",[-90.49770135000001, 35.37538970000001]],
    [ "Cherry Valley Substation",[-90.77104115, 35.38734075]],
    [ "Osceola North Substation",[-93.76122429999998, 41.04551225]],
    [ "Honeywell Substation",[-112.12463053014646, 33.60835759398199]],
    [ "Cripple Creek Substation",[-105.17683518312721, 38.74464420174881]],
    [ "Veribest Substation",[-100.2524489, 31.419303000000003]],
    [ "348730919",[-105.13448540582968, 38.707650728129664]],
    [ "348763302",[-86.51007821914607, 40.26386378715799]],
    [ "Neville Substation",[-80.09086083024752, 40.498058697535654]],
    [ "North Ooltewah Substation",[-85.04686115650507, 35.120854858543794]],
    [ "Pleasant View",[-89.53802200878754, 43.07267202523598]],
    [ "Niceville Substation",[-86.46491542520675, 30.51307024325737]],
    [ "Choctaw North Substation",[-86.41499697028885, 30.4563261943476]],
    [ "Exit 44 Substation",[-84.04074536685117, 34.034333299484985]],
    [ "349650697",[-84.67072567601744, 34.04626300831288]],
    [ "IP&L Substation C",[-94.42005091636604, 39.062745604593616]],
    [ "Clarion Substaton",[-79.3725236665415, 41.20381123430323]],
    [ "350174744",[-81.331515478063, 35.76642622921213]],
    [ "Hickory Tie Substation",[-81.3414382069349, 35.71458104420702]],
    [ "350227248",[-81.28981079593694, 35.653965532646964]],
    [ "350227249",[-81.31220323276916, 35.629613104749275]],
    [ "350227252",[-81.36458479999999, 35.72833219999999]],
    [ "350227255",[-81.36556447607575, 35.7175355928613]],
    [ "350227258",[-81.27062905000001, 35.6110877]],
    [ "350227261",[-81.26018271090905, 35.730826359996236]],
    [ "350229090",[-81.24101378224914, 35.654425836701506]],
    [ "350229091",[-81.23779042230849, 35.65403091357882]],
    [ "350410621",[-101.77834516709828, 38.84378429422694]],
    [ "350494195",[-83.25442650000001, 30.4788414]],
    [ "Northeast Colorado Wind Energy Center Substation",[-102.88483037567383, 40.979417106224226]],
    [ "Manchief Substation",[-103.6845285221652, 40.217058017234734]],
    [ "350715901",[-81.08505807521185, 35.75826198793839]],
    [ "350715903",[-81.1918477904522, 35.82102308118282]],
    [ "350715906",[-81.05687000354578, 35.77017782681066]],
    [ "351038635",[-76.58442672886837, 37.213043288269866]],
    [ "351056180",[-111.97246971315143, 33.461131800498855]],
    [ "351060497",[-83.39364860960842, 30.52499251129569]],
    [ "Madison Substation",[-83.39323402506425, 30.475790215375326]],
    [ "Hwy 90 Substation",[-83.3943979563943, 30.470235943850884]],
    [ "351219713",[-83.7082448920644, 41.408755679314126]],
    [ "Puget Sound Energy",[-122.62963145690905, 47.62166222127333]],
    [ "351237120",[-94.95961345314649, 35.639348849994015]],
    [ "Puget Sound Energy",[-122.62641672497868, 47.59593040455684]],
    [ "351271585",[-80.80452485, 35.742714500000005]],
    [ "Statesville Substation",[-80.8936747701118, 35.76540674864584]],
    [ "351313506",[-95.5753236858358, 35.35535680268892]],
    [ "Westmoreland Substation",[-75.17267378146822, 40.00630079204721]],
    [ "351439556",[-121.90241156800259, 37.32824017880248]],
    [ "Harker Heights South Substation",[-97.63701547419763, 31.053837334490915]],
    [ "Avon Park Substation DUKE",[-81.49328976106169, 27.58111391000724]],
    [ "351458896",[-86.77087834004533, 39.29006589107644]],
    [ "351544421",[-80.62021365, 35.6914935]],
    [ "351544424",[-80.64122091438105, 35.69504927960105]],
    [ "Galeville Station",[-76.1912344, 43.09012105]],
    [ "Ortonville 115kV Substation",[-96.44946503399002, 45.30321434817659]],
    [ "Mocksville Substation",[-80.55736142415527, 35.88734798689285]],
    [ "351881051",[-80.42156133448172, 35.967658580466086]],
    [ "351881053",[-80.56329630566573, 35.88036131711935]],
    [ "351881055",[-80.55750193407874, 35.88622551911964]],
    [ "351881056",[-80.45740591672862, 35.94972639678836]],
    [ "351881058",[-80.80005524683635, 35.620967718162355]],
    [ "Compton Substation",[-118.22476224999998, 33.89741495]],
    [ "Stockwood Substation",[-96.50449324999998, 46.87456125]],
    [ "Homestead Substation",[-86.07954612137937, 44.59820080871664]],
    [ "Glenwood Retail Substation",[-81.98358845437542, 35.62025661549016]],
    [ "352065760",[-82.28189735000001, 34.9191417]],
    [ "352171128",[-81.9937519337171, 35.835352485215175]],
    [ "352171129",[-81.97178475375215, 35.50983541061288]],
    [ "FirstEnergy",[-83.0983380444574, 41.49680142615344]],
    [ "Belton Southwest Substation",[-97.47630527145591, 31.06134330959048]],
    [ "Elkin Substation",[-80.85671120180763, 36.247697465802894]],
    [ "352346670",[-122.20376344999998, 46.06248205]],
    [ "352362521",[-85.1804916, 40.7336481]],
    [ "352387308",[-80.84995379587505, 36.28082202582087]],
    [ "352402650",[-85.78177987484692, 39.70052954359203]],
    [ "MidAmerican Energy",[-93.63563582425694, 41.567374188919814]],
    [ "352421826",[-80.92402522943313, 36.229792864120995]],
    [ "352526950",[-93.6510976611146, 30.741995989819703]],
    [ "352526951",[-93.65027186048047, 30.723317086328223]],
    [ "Swaggertown Substation",[-73.95757457058329, 42.893551635225904]],
    [ "North Rochester Substation",[-92.6589601128621, 44.22309135142404]],
    [ "352705191",[-76.9367555236091, 34.72635002145345]],
    [ "352856780",[-79.91360141224361, 35.72426672049821]],
    [ "Riberia Street Substation",[-81.32010180762495, 29.889080537134802]],
    [ "Ellyson SUbstation",[-87.205312361327, 30.529439329461688]],
    [ "115",[-105.15958149602788, 38.709863868023284]],
    [ "352968113",[-73.53886931812067, 44.88820150386251]],
    [ "352999900",[-73.49886434999999, 44.709471050000005]],
    [ "Easton Substation",[-85.08200374766733, 43.012663700264135]],
    [ "Hubbardston Road Substation",[-84.84315504352857, 43.01315092403382]],
    [ "Marquette Substation",[-85.08361261288943, 43.012093507611304]],
    [ "Pettis Road Substation",[-85.52344575000001, 42.98512825000001]],
    [ "Spaulding Substation",[-85.53870063474878, 42.961466670451486]],
    [ "353035646",[-76.30091079225612, 36.93986515518811]],
    [ "Broadmoor Substation",[-85.5741756597477, 42.89183373003738]],
    [ "Kraft Avenue Substation",[-85.53862078650366, 42.910787090691755]],
    [ "Shalersville Substation",[-81.33728513758564, 41.255370203503105]],
    [ "Layton Substation",[-84.0398182560209, 43.17611435019101]],
    [ "Deaconess Substation",[-87.57290586215244, 37.98457967529619]],
    [ "353383090",[-119.31166455105846, 45.79356890356984]],
    [ "353433013",[-82.81006367564036, 42.58949663913148]],
    [ "353468602",[-116.5529138572124, 33.910602274760954]],
    [ "353468604",[-116.6428329247904, 33.917750063079694]],
    [ "353468608",[-116.61487990825945, 33.926248854603955]],
    [ "353468611",[-116.55570483398273, 33.902015628899505]],
    [ "353468612",[-116.58112792093796, 33.92067836466247]],
    [ "353502430",[-110.27288183179432, 46.50204393524384]],
    [ "Judith Gap South Substation",[-109.75275405114688, 46.57293503238694]],
    [ "South Substation",[-80.38942418353705, 27.60283263014062]],
    [ "Port Mayaca Substation",[-80.5800634, 26.9963289]],
    [ "353567622",[-111.43589333899256, 47.50333441213866]],
    [ "353643306",[-79.69143384913295, 36.21015046720062]],
    [ "353665071",[-109.82249672309251, 46.43618501039496]],
    [ "Troy Substation",[-79.89379821624301, 35.347972277808935]],
    [ "Liberty Hill Substation",[-79.99810666814057, 35.325118668781194]],
    [ "Tillery Substation",[-80.0622435902858, 35.20746882407138]],
    [ "353684183",[-80.1220881976616, 35.402745009431776]],
    [ "353693225",[-112.06257112513225, 48.83701992394583]],
    [ "353693226",[-112.20106317294861, 48.8145813239633]],
    [ "353693227",[-112.15877029341081, 48.813593975122664]],
    [ "353706235",[-77.67189615534419, 35.91949718329864]],
    [ "353728852",[-110.6408401, 47.333965750000004]],
    [ "353737523",[-111.80416121390203, 43.523287716757835]],
    [ "353737524",[-111.8351867909381, 43.46543983314515]],
    [ "Latham Substation",[-123.07289329925257, 43.7660094920569]],
    [ "Molino Substation",[-87.34901952585496, 30.71818419717214]],
    [ "Jay Substation",[-87.16636143122791, 30.939022067757087]],
    [ "PowerSouth Energy Cooperative",[-87.09340854999999, 30.894757300000002]],
    [ "354208600",[-105.1763915998203, 38.93623332374202]],
    [ "354208604",[-105.0683519657378, 39.02473156545418]],
    [ "354208852",[-104.86258310017544, 39.06457810056325]],
    [ "Air Products Substation",[-87.13214380409651, 30.58943093183685]],
    [ "Florida Power & Light",[-87.11599791548981, 30.566573629835325]],
    [ "354216449",[-84.77826568275124, 30.388975357408636]],
    [ "354216450",[-84.79152817891747, 30.394941014500567]],
    [ "Barnet-14 Substation",[-72.0642156211495, 44.30010017521116]],
    [ "Eden Substation",[-72.54904928437662, 44.71119304818371]],
    [ "Lowell Substation",[-72.44761130971638, 44.803452729251305]],
    [ "Irasburg Substation",[-72.28420533221633, 44.844670697926325]],
    [ "Lowell Substation",[-72.44732523958629, 44.803937521130145]],
    [ "354346190",[-104.68432941205553, 38.29305048329791]],
    [ "West Portland Substation",[-122.74479495313048, 45.44128392252939]],
    [ "354427685",[-104.65407990000001, 38.279648449999996]],
    [ "Fossum Substation",[-97.10158287508472, 47.904489805798526]],
    [ "Sterling County Substation",[-101.18234140905238, 31.828905869636753]],
    [ "McDonald Road Substation",[-101.27560710129856, 32.086251849753936]],
    [ "354636509",[-88.0521658528588, 30.705316070889456]],
    [ "354654756",[-94.98382346233458, 43.6318413758452]],
    [ "Ford Island Substation",[-157.95357068275067, 21.364310857355612]],
    [ "Summerdale Substation",[-87.67895859250768, 30.509459624913404]],
    [ "354928849",[-87.737459666984, 30.392770416341026]],
    [ "354933548",[-87.82314397322828, 30.602624456556555]],
    [ "354933553",[-87.90324009389498, 30.67203658627144]],
    [ "Richmond Station",[-84.96554227396922, 39.83893526366322]],
    [ "Modoc Station",[-85.1115586821835, 40.04764164008735]],
    [ "115",[-105.2348966817506, 38.42014259843682]],
    [ "McIntyre Station",[-75.47231345000002, 44.66214465000001]],
    [ "Little River Station",[-75.15464991657966, 44.582306647719676]],
    [ "McAdoo Station",[-75.30760205, 44.5702736]],
    [ "Millinocket Substation",[-68.70731989133839, 45.64350750964599]],
    [ "355377976",[-103.5727251713278, 37.9897197155197]],
    [ "355379075",[-103.57135330708496, 37.98371504742265]],
    [ "355386328",[-102.59546695835142, 38.03546667039842]],
    [ "Eufaula Substation",[-85.15652640204671, 31.873468787954813]],
    [ "355510513",[-85.17432213490046, 31.844714275271464]],
    [ "355579595",[-103.21576261037525, 38.06365866655995]],
    [ "Colorado Green Switching Station",[-102.60995244010792, 37.705121198380965]],
    [ "355681760",[-82.31303326781128, 40.42231500818033]],
    [ "355700868",[-82.46417695537787, 40.42764873157924]],
    [ "355702183",[-82.5175142448549, 40.36963944538418]],
    [ "Cullman Electric Cooperative",[-86.84681518155696, 34.1330804834471]],
    [ "Beaver Creek Substation",[-87.25596669158675, 30.587584885661073]],
    [ "Monsanto Substation",[-87.2486997722326, 30.597851681774166]],
    [ "355850644",[-87.30937525987292, 30.529437921831907]],
    [ "355860659",[-104.2288020146432, 32.45761428173836]],
    [ "East Melrose Substation",[-94.79783509334705, 45.672533309175726]],
    [ "Tenth Street Substation",[-114.63286861302166, 32.708984031698385]],
    [ "Riverside Substation",[-114.65302720635286, 32.72642669921999]],
    [ "356099422",[-102.16899155, 38.08576945]],
    [ "356101374",[-102.28710935000001, 38.0593702]],
    [ "356126598",[-104.41231498383945, 38.29386739440992]],
    [ "356126599",[-104.2751546, 38.267134600000006]],
    [ "City Water, Light & Power",[-89.72136404058612, 39.794803122694695]],
    [ "Foreman Cement Substation",[-94.4194568982113, 33.69800792716205]],
    [ "Krebs Station Road Substation",[-88.6744784, 36.993947199999994]],
    [ "356359544",[-101.62219051460696, 36.90623225134781]],
    [ "356392190",[-93.59302562473782, 45.444843152409995]],
    [ "Marinette Substation",[-112.28083463935832, 33.59517068274072]],
    [ "Crystal Lake Substation",[-85.6875239, 30.4385602]],
    [ "356741524",[-94.38081099999998, 33.72289435]],
    [ "356755605",[-86.35476115, 33.30336755000001]],
    [ "York Ret Substation",[-81.23786911308322, 34.99364833770805]],
    [ "356938406",[-80.65994425000001, 35.3569693]],
    [ "Concord Main Substation",[-80.59588623294555, 35.408815863765945]],
    [ "356938409",[-80.6267014, 35.38164355]],
    [ "356938411",[-80.67904957954006, 35.3443294404617]],
    [ "356938412",[-80.6611817259682, 35.357228055533504]],
    [ "356938413",[-80.74708593812929, 35.331038374160684]],
    [ "356939412",[-80.60879443145704, 35.42593361438353]],
    [ "356939413",[-80.60993823279026, 35.425526866438176]],
    [ "Jefferson City Zion Substation",[-92.23442052316346, 38.54816534195371]],
    [ "357006847",[-97.45237157206974, 35.639643033764514]],
    [ "357018065",[-80.62520289097313, 35.46376483782237]],
    [ "357018068",[-80.26803755231529, 35.79592137552308]],
    [ "357018069",[-80.2661479216153, 35.79871368949168]],
    [ "Duke Energy",[-80.09598667915579, 35.86282449158281]],
    [ "357018071",[-80.05803840459569, 35.890152867971075]],
    [ "357018072",[-80.31027008444414, 35.76850998300323]],
    [ "357018073",[-80.62864282478094, 35.48795469232877]],
    [ "357018074",[-80.31828952900467, 35.77010790852461]],
    [ "City of Lexington",[-80.22281418307873, 35.825154399371385]],
    [ "357018076",[-80.09201733446386, 35.874524394030644]],
    [ "357018077",[-80.22175393709703, 35.82492892953286]],
    [ "Rocky Mountain Power",[-111.82210020585248, 40.62447538342364]],
    [ "357289665",[-80.52216467633788, 35.21680370593148]],
    [ "357289666",[-80.5198207, 35.2190729]],
    [ "357289667",[-80.44386988977523, 35.25319803136967]],
    [ "357290124",[-81.12841409999999, 35.75995905]],
    [ "357290128",[-81.17313334873961, 35.758593716384574]],
    [ "357290734",[-80.56699697312683, 34.99472381441236]],
    [ "357290736",[-80.56755573217279, 34.99429170829774]],
    [ "357290737",[-80.5730785525046, 34.99172396471488]],
    [ "357290738",[-80.63287441874554, 35.04074558555754]],
    [ "357290740",[-80.56274054120975, 34.99288982700834]],
    [ "357304145",[-114.06835280752027, 35.138982829018545]],
    [ "Burgess Substation",[-79.0327105281067, 33.63012623034053]],
    [ "357813765",[-83.09890150622049, 34.45647133565242]],
    [ "Great Falls Substation",[-80.89322691810614, 34.559124406252295]],
    [ "357934498",[-81.0135463827234, 34.67162495629498]],
    [ "357934500",[-80.93243145000001, 34.8339018]],
    [ "357934506",[-80.95061796286313, 34.65721021536391]],
    [ "357934508",[-81.00018313540738, 34.707842210983564]],
    [ "Richburg Substation",[-80.97778485096299, 34.66494289338884]],
    [ "357934515",[-80.93196088242553, 34.83299244530298]],
    [ "357946747",[-104.41500675, 32.623224150000006]],
    [ "Duke Substation",[-86.54673040778178, 30.637790019475304]],
    [ "NAS South Substation",[-87.27171387848115, 30.368591490394945]],
    [ "358295822",[-114.05955188801882, 35.18900483305345]],
    [ "Shakerag Substation",[-84.13436459700795, 34.054863874988996]],
    [ "Chester Substation",[-84.90470899999998, 42.654966099999996]],
    [ "Puget Sound Energy",[-122.65532435000001, 47.485309199999996]],
    [ "Sauk River Substation",[-94.27637908095222, 45.544753958824685]],
    [ "Eckert Substation",[-84.55612108088181, 42.71838579807828]],
    [ "Old Atlanta Road Substation",[-84.13541661064612, 34.09862979981181]],
    [ "Renton Substation",[-85.27780006644659, 42.27217237481524]],
    [ "358724049",[-73.7653013238525, 42.62718250401927]],
    [ "Ludowici Primary Substation",[-81.74371522194137, 31.721614182340275]],
    [ "Horse Creek Substation",[-81.65859444807272, 31.812066516486066]],
    [ "Hinesville Primary Substation",[-81.60871310661155, 31.851835872701308]],
    [ "NAS North Substation",[-87.27581713735474, 30.37418841131267]],
    [ "359143131",[-100.72886196051444, 46.85187637742295]],
    [ "359176018",[-100.73137264999998, 46.8531342]],
    [ "359191441",[-92.80569218663344, 45.396441431814274]],
    [ "Waltertown Substation",[-82.36194675, 31.318784000000004]],
    [ "Blackshear Substation",[-82.23765233200912, 31.308229706062832]],
    [ "BROWNTOWN",[-89.79478403024855, 42.58016127126816]],
    [ "359245980",[-81.130864, 34.720638349999994]],
    [ "359245982",[-81.22173265, 34.702019650000004]],
    [ "359245983",[-81.22455901882698, 34.69401230619004]],
    [ "359245984",[-81.22415628494652, 34.69357503182726]],
    [ "359245985",[-81.27984445, 34.71557295]],
    [ "359245986",[-81.13814339194171, 34.72996533179414]],
    [ "359245987",[-81.17322416072348, 34.673716421909916]],
    [ "359245989",[-81.19098073896285, 34.692885587940665]],
    [ "359260859",[-81.0895277795153, 34.36935766299176]],
    [ "359260860",[-81.13924369522, 34.35713192323559]],
    [ "359260861",[-81.14190769829693, 34.35400432018989]],
    [ "359443064",[-81.61002494995674, 34.26907362579739]],
    [ "359625445",[-101.46618630000002, 36.491995450000005]],
    [ "Noble Power",[-101.39165557506982, 36.47559245552642]],
    [ "Meadowbrooke Substation",[-85.53876229880767, 42.847047722473846]],
    [ "Puget Sound Energy",[-122.56803719999999, 47.549872099999995]],
    [ "New Bethlehem Substation",[-79.34667850489214, 41.00783691615697]],
    [ "Burma Substation",[-79.42747733236779, 41.13052312339793]],
    [ "360096314",[-104.39013678526723, 32.85639451887562]],
    [ "360098851",[-104.46838881717807, 33.255539125211854]],
    [ "Lake Arthur",[-104.43905514999494, 33.00635299694328]],
    [ "Hagerman",[-104.44037022475315, 33.139649465062924]],
    [ "360180015",[-104.153561, 32.22759915]],
    [ "360180016",[-104.2206109, 32.40726275000001]],
    [ "360180018",[-104.34297485, 32.326834149999996]],
    [ "360195587",[-103.19596428571118, 32.725949349116966]],
    [ "360195588",[-103.19663045208587, 32.71873690958744]],
    [ "Loxley Substation",[-87.74476215000003, 30.61554890000001]],
    [ "360210342",[-87.70024992493359, 30.531566212632548]],
    [ "360211110",[-103.32274152007058, 32.97820829003691]],
    [ "360214910",[-81.8776453635862, 34.776744590728605]],
    [ "Woodruff Tie Substation",[-82.05224537939839, 34.734403505165226]],
    [ "360305810",[-122.76209282475502, 47.34130832789337]],
    [ "360411403",[-87.75870882491715, 30.632381960504084]],
    [ "South Foley Substation",[-87.68110415569737, 30.341404899023715]],
    [ "Hurlburt AFB Substation",[-86.69864150635298, 30.423963470876345]],
    [ "360429479",[-86.49799434433412, 30.490600781392782]],
    [ "Byrnville Substation",[-87.29977364999999, 30.9711577]],
    [ "360443541",[-121.83222786171761, 38.12784476276307]],
    [ "360443543",[-121.84691355000001, 38.16958949999999]],
    [ "360443548",[-121.83189651198008, 38.12484726202103]],
    [ "360447664",[-102.65836475, 32.7107611]],
    [ "360447666",[-102.75286184999999, 32.697340999999994]],
    [ "Hayti South",[-89.75584616617053, 36.21877691109337]],
    [ "Hayti North",[-89.75575323955592, 36.21968880473302]],
    [ "360591619",[-86.56110263970679, 30.482542284170165]],
    [ "360597475",[-86.50486663762135, 30.477906808489703]],
    [ "360597479",[-86.50790097418975, 30.47528609886114]],
    [ "360597503",[-86.49417503485503, 30.485513571114403]],
    [ "360610049",[-93.2080132, 39.1233545]],
    [ "360616620",[-86.56241159999999, 30.50402075]],
    [ "Volunteer Energy Cooperative",[-84.87617805000001, 36.005272100000006]],
    [ "Lewis Substation",[-81.32970740748587, 29.914933289058578]],
    [ "Georgia Power",[-84.18897633596538, 33.300094879768814]],
    [ "360800608",[-102.9319769924556, 32.88634107461247]],
    [ "360800609",[-102.9326289252646, 32.87149539853406]],
    [ "360804535",[-102.81768510332361, 32.96404842824583]],
    [ "360807522",[-102.7948402, 32.6822027]],
    [ "360807523",[-102.7295831311006, 32.60557474894154]],
    [ "Nemak Substation",[-86.2866827, 33.21006165]],
    [ "Tioga Substation",[-95.50672470703223, 37.70529235681141]],
    [ "Electric Power Board of Chattanooga",[-85.18713571314179, 35.03290208982628]],
    [ "361043147",[-90.99750016255811, 33.570829074620626]],
    [ "361078385",[-90.6738252, 33.44669535]],
    [ "Indianola Substation",[-90.63367932596223, 33.445040805359604]],
    [ "North Bay Substation",[-85.675999015212, 30.2445861421089]],
    [ "Northside Substation",[-85.66736854787831, 30.21284368705789]],
    [ "Highland City Substation",[-85.63128121233322, 30.19496400827922]],
    [ "Highland City Substation",[-85.6318885432405, 30.193863769865096]],
    [ "Callaway Substation",[-85.56313623543862, 30.194533930433547]],
    [ "Rotunda Substation",[-83.18874464567635, 42.30919340482326]],
    [ "361132556",[-82.01807275752184, 38.41562929568054]],
    [ "361140170",[-81.36302655507414, 39.33208872381479]],
    [ "361140179",[-81.44362830392662, 39.386132682530715]],
    [ "361140182",[-81.50449301558223, 39.26993278134619]],
    [ "361140184",[-81.4057007, 39.34028430000001]],
    [ "361140189",[-81.54559286344882, 39.360228795501236]],
    [ "Mill Creek Substation",[-81.44288223699202, 39.44314278686546]],
    [ "361140485",[-87.45297959999999, 31.133980499999996]],
    [ "Lullwater Substation",[-85.87816230888966, 30.227728069169316]],
    [ "Flatlick Substation",[-82.33081958688298, 39.08556640852108]],
    [ "Clinton Substaiton #2",[-83.97675251262817, 42.06753351477874]],
    [ "361248871",[-83.00183610128443, 40.10390712368308]],
    [ "Holiday Substation",[-85.78774088673528, 30.188017664674856]],
    [ "Choctaw South Substation",[-86.4060513, 30.399402899999995]],
    [ "Poweshiek County Substation",[-92.6984896890677, 41.57141260058408]],
    [ "City of Tallahassee",[-84.31505391044654, 30.429695894448248]],
    [ "361364443",[-86.1856204797563, 39.75266706345195]],
    [ "361364444",[-86.17114637452171, 39.762651005644365]],
    [ "361440072",[-88.17485085751035, 30.546796291470883]],
    [ "361455372",[-114.13612826641226, 43.05314795101967]],
    [ "361477662",[-75.82122385000001, 41.391663099999995]],
    [ "361492746",[-93.46118408991619, 46.57753095041362]],
    [ "361492747",[-93.29302820842302, 46.588147648495195]],
    [ "Vasquez Substation",[-104.77362281228423, 40.247206868580264]],
    [ "Gilcrest Substation",[-104.7726017553472, 40.319512207373016]],
    [ "Cromwell Substation",[-92.89505014999999, 46.68032015000001]],
    [ "361498209",[-85.34540295, 31.9013956]],
    [ "White Oak Substation",[-85.33737888322497, 31.90167495039663]],
    [ "361624798",[-87.80320528051573, 30.868998919764834]],
    [ "361646921",[-88.1469237457094, 30.403707782997067]],
    [ "Aneth Substation",[-109.26859037575707, 37.28710115300075]],
    [ "Allen City Substation",[-82.72868403821461, 37.60737025768691]],
    [ "West River Substation",[-72.93868609101222, 41.2890531409612]],
    [ "361819808",[-87.24812614999999, 30.598418299999995]],
    [ "361819809",[-87.24891265, 30.59973265]],
    [ "361826492",[-123.40262044643552, 47.00855153031922]],
    [ "361916668",[-79.80494565, 34.27192765]],
    [ "McIver Road Substation",[-79.81752318300708, 34.269611598964254]],
    [ "361969203",[-108.1523170848944, 32.765963528262965]],
    [ "361981046",[-87.41152298495741, 31.007917431870485]],
    [ "362113392",[-94.82903515000001, 35.58344125000001]],
    [ "362185841",[-87.76390535, 30.8874951]],
    [ "Pioneer Substation",[-122.98103781132359, 47.27328438985088]],
    [ "362304571",[-82.37928769999999, 37.107457149999995]],
    [ "Graysonville Substation",[-76.23274186231022, 38.96610596848276]],
    [ "McCracken Substation",[-86.29370927489194, 43.201351605857305]],
    [ "362322238",[-81.1777518216501, 35.88102745287594]],
    [ "Sprecher Substation",[-89.26742166631428, 43.08626868060947]],
    [ "Jordan Substation",[-104.81594308073615, 39.59560985461054]],
    [ "Edom Substation",[-116.38861915, 33.8094303]],
    [ "362649498",[-94.83152521583528, 33.90890452844658]],
    [ "362670673",[-94.77458864769861, 33.96770844553539]],
    [ "362670678",[-94.78285085691074, 33.91943057111056]],
    [ "Nevada Power Substation",[-115.68246287307224, 36.579757433166925]],
    [ "Lufkin South Substation",[-94.72504579274538, 31.291760730499053]],
    [ "362672382",[-94.72731698129806, 34.02546088575667]],
    [ "College Substation",[-81.6814145182708, 30.317262960649554]],
    [ "CPC Yorktown Substation",[-76.6051410703679, 37.20273110570491]],
    [ "Mount Vernon Substation",[-88.01448725907436, 31.087061082738078]],
    [ "Florida Gas Transmission Company",[-88.01541762552286, 31.117394621110112]],
    [ "MidAmerican Energy",[-92.35472216240011, 42.593431916346766]],
    [ "Brewton Substation",[-86.47459466609, 31.30244432460203]],
    [ "Ingomar Substation",[-80.0525743074511, 40.57120780064135]],
    [ "Jeffersonville Substation",[-85.75007637797914, 38.32385514589018]],
    [ "Kinston Substation",[-86.18564522144588, 31.239716289618507]],
    [ "Samson Substation",[-86.04925633840155, 31.116123296799163]],
    [ "363253726",[-103.19624084988085, 32.66725829756737]],
    [ "363262980",[-103.73030584113486, 35.1830007854076]],
    [ "363306963",[-85.44670908826151, 40.222773075565826]],
    [ "Arnold Hogan Substation",[-85.45722741632983, 40.18848471648989]],
    [ "363345785",[-85.70193569923832, 40.082739375867284]],
    [ "363403995",[-103.61787822373215, 34.983739210958056]],
    [ "363406313",[-113.5526227944018, 37.11664717285032]],
    [ "363406889",[-113.50939649663309, 37.13972007182843]],
    [ "Mill Pond Substation",[-70.77831478695974, 43.06821268309455]],
    [ "Hastings Substation",[-95.50020709782409, 40.99361632941017]],
    [ "Bunge Substation",[-95.80522014167137, 41.15660248726509]],
    [ "West County Energy Center Substation",[-80.37529909480385, 26.692784333984104]],
    [ "West County Energy Center Unit #2 FPL",[-80.37637514743075, 26.699263374385836]],
    [ "West County Energy Center Unit #3 FPL",[-80.37629379999998, 26.69600985]],
    [ "CIPCO",[-94.34879681091051, 41.11460407014357]],
    [ "CIPCO",[-94.34651111590472, 41.11392464982869]],
    [ "Western Area Power Administration",[-94.3488511847648, 41.115450195725444]],
    [ "Kewanee Substation",[-89.95449843372987, 41.22291767388388]],
    [ "363538912",[-86.08741266428757, 38.60107204851513]],
    [ "363603500",[-89.08819858846776, 41.55937078469736]],
    [ "363630605",[-88.85994972494767, 41.82622105644469]],
    [ "363630606",[-88.8600236816912, 41.82518621467982]],
    [ "363651140",[-92.96307847465077, 45.688349710820695]],
    [ "Crist Substation",[-87.22683595399725, 30.564145489931867]],
    [ "Court Street Substation",[-119.09388341234445, 46.24085408812844]],
    [ "Fayette Substation",[-84.30721670573182, 41.6736231590099]],
    [ "East Fayette Substation",[-84.30654436449484, 41.672190739590455]],
    [ "Ameren",[-90.67110874999997, 40.892778199999995]],
    [ "Plymouth Substation",[-83.46576821958462, 42.37721325157093]],
    [ "Pasco Substation",[-119.09690367471057, 46.22071184371411]],
    [ "363983829",[-93.89398130729505, 36.699567025247504]],
    [ "363983831",[-93.96307452444876, 36.55103155451616]],
    [ "364033834",[-94.0705666, 36.748330849999995]],
    [ "364033836",[-93.98239263732215, 36.53163857498358]],
    [ "364034635",[-93.89697446911555, 36.671640113355636]],
    [ "Williamsburg Substation",[-76.69658227988967, 37.27584719457441]],
    [ "Vandergrift Substation",[-79.58029232478384, 40.60342531463869]],
    [ "Mt Pleasant Substation",[-84.78186734999998, 43.60424785000001]],
    [ "Carroll Electric Cooperative Corporation",[-93.69451268291779, 36.492754466231254]],
    [ "Ebensburg Substation",[-78.72659595063473, 40.48194280832788]],
    [ "Snow Canyon Substation",[-113.62459678585901, 37.14336396849427]],
    [ "Howell-Oregon",[-92.10750408181325, 36.61002066441639]],
    [ "Albany Substation",[-94.5852873859514, 45.63030001134394]],
    [ "364633155",[-91.93616147495688, 36.969454691867206]],
    [ "364633157",[-91.93707585, 36.965434349999995]],
    [ "364650444",[-91.50328215, 36.9760017]],
    [ "Caprock Station",[-103.36783893607162, 34.9840960893111]],
    [ "364713826",[-91.3635691070019, 36.60413042551495]],
    [ "Smoky Hill Substation",[-104.71492531049495, 39.63074266341364]],
    [ "Kyle Substation",[-97.8842705770753, 29.94987542403185]],
    [ "Jewell Substation",[-104.877026752374, 39.682546793828486]],
    [ "Leetsdale Substation",[-104.91838040098804, 39.70665126142004]],
    [ "University Substation",[-104.9583889411983, 39.683182285239475]],
    [ "Meadow Hills Substation",[-104.79061317790494, 39.62459423860622]],
    [ "364836752",[-116.53401533157962, 48.35646594314746]],
    [ "364856298",[-103.33643678827302, 34.93771029993955]],
    [ "364951009",[-84.8739555055719, 34.211528783835114]],
    [ "364967742",[-92.12088072743362, 37.78695910790319]],
    [ "364967743",[-92.09861599999999, 37.838790100000004]],
    [ "364967745",[-92.30912545, 37.75852355]],
    [ "364967751",[-92.21768633476843, 37.81151655547363]],
    [ "L'anse",[-88.45638783819504, 46.75335964277766]],
    [ "365085051",[-91.73035849164903, 37.99715077916878]],
    [ "365107267",[-91.85030352857558, 37.69349732972083]],
    [ "365120619",[-91.79944394673606, 37.982556414757276]],
    [ "365120622",[-91.78209306784251, 38.06457805360584]],
    [ "365155530",[-91.42238081732447, 38.471772708290075]],
    [ "365155531",[-91.30925014999998, 38.43170284999999]],
    [ "365315852",[-112.49703827438304, 42.897645067346076]],
    [ "365315861",[-112.45017637065871, 42.87833911645193]],
    [ "365349042",[-91.9391096, 38.64184895]],
    [ "365349044",[-91.79751543288471, 38.77792389349012]],
    [ "Clinton Substation",[-82.99606356697677, 40.02981000672543]],
    [ "365393900",[-84.58049845810304, 30.597803975736724]],
    [ "365393901",[-84.58063613075076, 30.599621297890533]],
    [ "Mount Rose Substation",[-74.74195455980669, 40.369395407899326]],
    [ "365549048",[-90.09521196544134, 41.980621194210656]],
    [ "365567945",[-91.30921365, 38.77075835]],
    [ "365583014",[-91.53962707557803, 39.07208989458544]],
    [ "365634134",[-103.24992691064995, 34.41146843472871]],
    [ "365638112",[-103.3253921000866, 34.39324465900281]],
    [ "Riverside Substation",[-81.09704112533507, 32.084525494158946]],
    [ "365774664",[-91.76117913045951, 38.33981790477246]],
    [ "Southwest Cheese",[-103.21924442095505, 34.31712965117242]],
    [ "Ameren",[-88.37751115317062, 40.45302828075752]],
    [ "365783215",[-88.39976343529423, 40.47084824847699]],
    [ "Ameren",[-88.09242525336911, 40.46625620162822]],
    [ "Ameren",[-88.07797516676395, 40.4622174400016]],
    [ "365798582",[-88.58682814942144, 40.29286838135359]],
    [ "Curry County Substation",[-103.17052354215537, 34.39219744760704]],
    [ "365808337",[-103.1612160723058, 34.38948192070685]],
    [ "365811047",[-103.14374252190038, 34.44873400750179]],
    [ "365812734",[-103.24807331789418, 34.45631624202213]],
    [ "365813907",[-103.21361665000002, 34.440936400000005]],
    [ "365918100",[-103.17814720000001, 34.393843149999995]],
    [ "365927409",[-80.68167156655014, 35.17039634286678]],
    [ "365927411",[-80.77084538291487, 35.17913718914035]],
    [ "365927414",[-80.67770472743236, 35.2110197706003]],
    [ "365927415",[-80.68203093386575, 35.17015092476886]],
    [ "365927417",[-80.69793135365268, 35.27341946314539]],
    [ "365927594",[-80.6638042, 35.124796350000004]],
    [ "365927595",[-80.66319637060549, 35.12450980224913]],
    [ "Beaver Bay Substation",[-122.26216319702077, 46.0595503845549]],
    [ "365931205",[-103.3163004061941, 34.21474856867247]],
    [ "365931211",[-103.30138748528012, 34.20844433871433]],
    [ "Southside Substation",[-77.38632288501329, 35.575156220084445]],
    [ "Pine Street Substation",[-75.10225350203463, 39.93742955002128]],
    [ "Fairgrounds Substation",[-95.20556082234364, 38.94723262004424]],
    [ "Pflugerville Substation",[-97.59985830997506, 30.454050783190358]],
    [ "366053931",[-91.57040375983023, 30.940045875345522]],
    [ "Crenshaw Substation",[-90.196533, 34.511744750000005]],
    [ "Duke Energy",[-80.79940337493672, 35.2125850811039]],
    [ "Gilbert Substation",[-75.16189971399452, 40.56628409014447]],
    [ "Gilbert Substation",[-75.15954126433631, 40.56725615362158]],
    [ "Gilbert Substation",[-75.1647185307457, 40.56630808816566]],
    [ "AEP Spy Run Substation",[-85.13822271266217, 41.09356509244261]],
    [ "366282970",[-85.10939204630189, 41.12192146835391]],
    [ "Boulder Terminal Substation",[-105.25766720034136, 40.026111422609866]],
    [ "Sunshine Substation",[-105.29569814932906, 40.02104410004977]],
    [ "Tucson Electric Power",[-111.02831501241346, 32.222717869065725]],
    [ "Ameren",[-90.32863907114775, 40.977250452188876]],
    [ "366614736",[-104.52736784168292, 33.452080294796545]],
    [ "Stillman Valley Substation",[-89.21007430475989, 42.11729105917407]],
    [ "366748190",[-104.51996511568183, 33.39265863245877]],
    [ "366750587",[-104.50617489123454, 33.349863449504156]],
    [ "Duke Energy",[-80.77674325004082, 35.33329700912139]],
    [ "Southern California Edison",[-116.49395172189949, 33.80792123990906]],
    [ "366769471",[-104.52741880000002, 33.35056715]],
    [ "366780734",[-104.57790069740857, 33.38905831497381]],
    [ "Starkey Road Substation",[-82.75894270386615, 27.840742649646376]],
    [ "Caledonia Substation",[-85.52772958001948, 42.79787647587023]],
    [ "366899637",[-104.48847985, 33.32794715]],
    [ "366911821",[-122.847997935958, 46.018389555088454]],
    [ "Elgin Substation",[-88.2822462404731, 42.03121776137806]],
    [ "367132254",[-122.06977440017337, 37.382555364279455]],
    [ "Springboro Substation",[-80.36943473962562, 41.784950496309555]],
    [ "367148712",[-89.051355574671, 40.510888941416844]],
    [ "Alice Substation",[-97.55669204094038, 46.767453470537]],
    [ "South Bloomington Substation",[-88.98604018775748, 40.461758972852714]],
    [ "367152143",[-97.59573465000001, 46.61545825]],
    [ "Ameren",[-88.96130741390854, 40.45225466355209]],
    [ "367164674",[-88.2432211202698, 40.15573872121851]],
    [ "Snapdragon Sub",[-104.52062489206304, 33.505756136167825]],
    [ "Compressor Sub",[-104.51649806753854, 33.50783334271076]],
    [ "367182137",[-87.66886809416451, 40.086550307087556]],
    [ "367189997",[-111.2322971, 47.49467814999999]],
    [ "367191415",[-104.52007640718242, 33.58390620480053]],
    [ "367270574",[-89.90602197719804, 42.4321133564786]],
    [ "Paca/Orchard Street Substation",[-76.62180735848459, 39.29786772486684]],
    [ "Freeport Substation",[-89.61873250031513, 42.30237372872601]],
    [ "367338286",[-89.69442190185413, 42.28920760641962]],
    [ "Maryland Substation",[-89.50945036470891, 42.062418009778064]],
    [ "Fordham Substation",[-89.09280472707732, 42.26432495602216]],
    [ "Sand Park Substation",[-89.03869274888147, 42.318714749968585]],
    [ "Chess Substation",[-80.00641757088337, 40.420748881363615]],
    [ "367470828",[-88.18073694999998, 30.661587]],
    [ "Bard Road Substation",[-84.58760888668183, 44.036150734688]],
    [ "Wirtz Road Substation",[-84.3090631, 44.069768100000005]],
    [ "Sacramento Municipal Utility District",[-121.52413630586732, 38.607185765132535]],
    [ "FMC Substation",[-95.21394495622668, 38.97918605199506]],
    [ "Bartlett Substation",[-97.42836549495263, 30.801035405942127]],
    [ "368085221",[-81.18185990953654, 35.24371652901157]],
    [ "Geneva Substation",[-80.21638123557672, 41.53077550178284]],
    [ "Plant City Substation",[-82.12102920000001, 28.014359849999998]],
    [ "Beaverton Substation",[-122.79787824556263, 45.48388201166841]],
    [ "Unitil",[-70.86961983491602, 42.947309453866396]],
    [ "368308358",[-80.12748927303703, 26.083758194252464]],
    [ "Timber Swamp Substation",[-70.8689232237477, 42.94983965884704]],
    [ "368323097",[-96.5589331, 46.26106395]],
    [ "South Substation",[-96.57697770508157, 46.26129517513597]],
    [ "Ken Twito Substation",[-96.58843940000003, 46.2821188]],
    [ "Wahpeton Southeast Substation",[-96.59975012516055, 46.25363095515441]],
    [ "368327316",[-80.21740423781301, 26.045941725520365]],
    [ "Florida Power & Light",[-80.47680643748197, 25.63943607618923]],
    [ "Milam Substation",[-80.32652332483201, 25.805816355284346]],
    [ "TECO",[-82.27743546390978, 27.972858068764104]],
    [ "368408174",[-117.32355222375541, 33.9552322539434]],
    [ "368505929",[-88.25704666950112, 41.47927032249302]],
    [ "368509188",[-86.14212100901433, 32.36862022493485]],
    [ "Florida Power & Light",[-80.25862671321734, 25.877739986823187]],
    [ "Collins Substation",[-88.34715775898215, 41.35276107786598]],
    [ "Greenleaf Substation",[-97.05048828457622, 39.72503203565536]],
    [ "368851887",[-122.79785365000002, 48.09504565]],
    [ "368851894",[-122.80104176210567, 48.096017025796854]],
    [ "368852396",[-122.79077769145476, 48.114583065235756]],
    [ "Kingsley Substation",[-85.5422445249837, 44.58493569355271]],
    [ "Puget Sound Energy",[-122.69666694999998, 47.650955249999996]],
    [ "Puget Sound Energy",[-122.71351685, 47.5903565]],
    [ "368941734",[-82.56985369739941, 34.95821953136792]],
    [ "Resort Substation",[-85.02704413572492, 45.359992121531164]],
    [ "Mt. Joy Substation",[-76.48801342249577, 40.10827537590182]],
    [ "River Mill Substation",[-122.35031746706872, 45.300476199640975]],
    [ "Puget Sound Energy",[-122.70895833602185, 47.753764501766135]],
    [ "369029130",[-122.72616287267412, 47.71461070481598]],
    [ "Lake Mirror Substation",[-81.95187138488406, 28.0465258919487]],
    [ "369029779",[-81.92457152906597, 28.049105691701318]],
    [ "369032078",[-82.12605816856436, 28.03976416158765]],
    [ "Alexander Street Substation",[-82.13822279344772, 28.003387520121105]],
    [ "369032082",[-82.15973160015534, 28.025737149390416]],
    [ "Winslow substation",[-122.54824544003984, 47.62171582034397]],
    [ "Fairlane Substation",[-83.22457338323049, 42.32930225229711]],
    [ "Commonwealth Edison",[-88.65950478399405, 41.26240662594078]],
    [ "Streator Substation",[-88.84600517243315, 41.126193857948216]],
    [ "369302414",[-89.3212627751465, 41.26464669206626]],
    [ "369302419",[-89.3149738282221, 41.30185664070433]],
    [ "369313288",[-88.85654095000001, 41.31584825]],
    [ "369314609",[-88.84657985, 41.3536158]],
    [ "King City Substation",[-122.80106053147937, 45.39630532757634]],
    [ "369398629",[-82.3015417478952, 34.77554462479502]],
    [ "369413026",[-79.387230254964, 38.762086631290316]],
    [ "Terminal Substation",[-95.00757609151454, 29.602155975320688]],
    [ "369590661",[-107.33810259676085, 38.45137346267377]],
    [ "Purdue University",[-86.91124272499923, 40.417272443324954]],
    [ "Ahoskie Substation",[-76.99309235000001, 36.305657499999995]],
    [ "Holland Substation",[-83.88233936231023, 43.40763230663717]],
    [ "Whitestone Point Substation",[-83.56920798764024, 44.10515859921012]],
    [ "South Side Substation",[-85.604915, 44.726573900000005]],
    [ "Brooksville Substation",[-82.37476317493646, 28.546378310408603]],
    [ "Electric Power Board of Chattanooga",[-85.24186410558951, 35.02166833531117]],
    [ "Fruit Industries Substation",[-82.54955549026928, 27.486443856363707]],
    [ "Gaylord Substation",[-84.70334742820903, 45.03007506372809]],
    [ "Puget Sound Energy",[-122.71116859422798, 47.52335954379648]],
    [ "Tacoma Power",[-122.76399425863625, 47.258938675050615]],
    [ "Hemphill Substation",[-81.9429607893456, 28.128922375143087]],
    [ "Alpine Substation",[-103.66325351559796, 30.355622532615268]],
    [ "370120643",[-103.36747968325416, 34.168434475724716]],
    [ "Lake Zurich Substation",[-88.07339590082329, 42.21095700517806]],
    [ "370245561",[-80.53999288638006, 41.965160269511664]],
    [ "370264050",[-110.8540301605545, 32.5997268750334]],
    [ "Fitchburg Substation",[-89.4602743972915, 43.01408545166752]],
    [ "370279994",[-103.33808272845926, 34.163579374870054]],
    [ "Wheeler Substation",[-111.75686302619671, 33.58706966341985]],
    [ "370283016",[-103.38726345685184, 34.18529197509541]],
    [ "Tinsley Corssing Sub",[-103.42211805, 34.12760425000001]],
    [ "370351422",[-84.56028512977622, 39.01939851191198]],
    [ "370374622",[-122.39045363552732, 45.92481401194896]],
    [ "370422296",[-93.99495325428317, 30.92218956463473]],
    [ "370530162",[-112.03584712048219, 33.68370836840555]],
    [ "East 63rd Street Substation",[-73.9609864722259, 40.762891022493264]],
    [ "Union City Substation",[-74.04156957342819, 40.76952615865657]],
    [ "Mockingbird Hill Substation",[-95.32117983749325, 38.93976699981919]],
    [ "East 75th Street Substation",[-73.95045866692004, 40.7684361071314]],
    [ "Branch",[-87.92206917513843, 42.92068383422685]],
    [ "370766459",[-78.70137384425875, 42.157710119601646]],
    [ "370825000",[-92.26765591445945, 37.10126802558674]],
    [ "370954371",[-78.46405189608231, 35.808962981115506]],
    [ "Kenneth Substation",[-121.9543324894569, 37.37580403633381]],
    [ "Cadillac Substation",[-85.40550177172338, 44.25133721994857]],
    [ "Wexford Substation",[-85.42786380951779, 44.264149143021044]],
    [ "371222491",[-110.08665987252202, 31.718936419573954]],
    [ "Captain Junction Substation",[-95.00511465, 38.92112975]],
    [ "Eudora Substation",[-95.11075069395565, 38.92251342611721]],
    [ "95th & Waverly Substation",[-94.94682912155268, 38.95877625856548]],
    [ "Brentwood Substation",[-71.08382124286915, 42.983697813730906]],
    [ "371296023",[-115.09849346121037, 36.11669396995934]],
    [ "371300245",[-110.35590187292448, 31.6935494522325]],
    [ "371301324",[-81.15693640000002, 35.91701675]],
    [ "McMullin Substation",[-111.72360975562066, 33.56830325260776]],
    [ "Morris Substation",[-97.40559020147329, 27.784393262309685]],
    [ "Arcadia Substation",[-97.42168794602442, 27.745732747761508]],
    [ "371373781",[-89.72215933225507, 39.63747134009476]],
    [ "371599800",[-77.44265645009345, 38.65723983647963]],
    [ "Center City Substation",[-94.6374966920355, 39.12435076743975]],
    [ "Fiberglass Substation",[-94.61604895228893, 39.1436542949981]],
    [ "Melrose Substation #30 CLAY",[-82.0386224163369, 29.708662624900242]],
    [ "Battle Ground Substation",[-122.59961305000002, 45.79438635]],
    [ "Killeen Elms Road Substation",[-97.71944229999998, 31.076395249999997]],
    [ "Hawkins Substation FPL",[-80.21910165, 26.20783815]],
    [ "Ontario Substation",[-82.59758192667334, 40.77541947274533]],
    [ "Buckingham Substation",[-81.7662782515869, 26.64275615677557]],
    [ "Immokalee Substation No. 4",[-81.41762585235638, 26.39718146209238]],
    [ "LCEC Substation No. 25",[-81.6010322108833, 26.556605413094562]],
    [ "LCEC Substation No. 5",[-81.66366403997715, 26.613442802486357]],
    [ "Flint Substation",[-83.87061061972152, 42.58744692722157]],
    [ "372109966",[-106.30700031544156, 31.7501965671726]],
    [ "Haynesville South Substation",[-93.11424223332094, 32.9397481000692]],
    [ "C M C Steel Fabricators, Inc.",[-93.22610428837925, 33.208514874661034]],
    [ "Sewell's Point Substation",[-76.31861174427435, 36.9310167240191]],
    [ "372143488",[-76.31965227545108, 36.93864711014977]],
    [ "372143492",[-76.32335839999999, 36.95798555]],
    [ "Ave Maria South Substation",[-81.41727929197492, 26.308810782000503]],
    [ "372151147",[-93.5824868804759, 33.65838144182955]],
    [ "Entergy Arkansas",[-93.61403259999999, 33.6644291]],
    [ "Entergy Arkansas",[-93.63948766913144, 33.725434144297196]],
    [ "Elk River Substation",[-96.54473430342534, 37.54966602769595]],
    [ "372196945",[-100.75079473349659, 46.83261226282874]],
    [ "Georgia Power",[-85.18413655416421, 33.794057416376404]],
    [ "Georgia Power",[-85.1964973476719, 33.79870510590063]],
    [ "372520505",[-111.12388707303165, 33.66340221090634]],
    [ "Jenkins Branch Retail Substation",[-83.45375979241727, 35.41102788006134]],
    [ "Washington Substation",[-91.68992089039898, 41.30229422045975]],
    [ "Gateway Substation",[-81.76884441675818, 26.62601812209835]],
    [ "Orangetree Substation",[-81.62001202806333, 26.27434254160062]],
    [ "372791482",[-94.89640307386539, 32.22629632806136]],
    [ "North Valdosta Substation",[-83.29233007066941, 30.87915162093768]],
    [ "Koppernick Substation",[-83.44703112174258, 42.33654624027549]],
    [ "373094002",[-82.66416441110933, 40.89647337451522]],
    [ "Public Service Company of Colorado",[-106.0674787757344, 39.2908980220464]],
    [ "Station 111",[-77.4961088, 43.048835749999995]],
    [ "Station 154",[-77.41268819196561, 42.974606980706774]],
    [ "Glyndale Road Substation",[-81.5121396667382, 31.222256148091454]],
    [ "373215961",[-78.65094895, 38.387378999999996]],
    [ "Merck Substation",[-78.64709432607222, 38.382918305104866]],
    [ "137th Avenue Substation",[-80.41814132407357, 25.78730972966369]],
    [ "373361394",[-86.14408300079036, 39.78135337611277]],
    [ "373361395",[-85.97050048668389, 39.773934122722665]],
    [ "Clinic Substation",[-111.95159606242083, 33.65300215148112]],
    [ "Gloversville Station",[-74.34439663666505, 43.06180889794229]],
    [ "Meco Station",[-74.38055385, 43.04134385000001]],
    [ "Ephratah Station 18",[-74.53697263355895, 43.00961667608354]],
    [ "373754473",[-84.5224294668741, 38.91501300156669]],
    [ "Lake City Sub K",[-94.2586152605746, 39.082124272378266]],
    [ "James Savage Substation",[-84.21614464709795, 43.60975107506852]],
    [ "374062083",[-97.14025286520274, 32.5213812965132]],
    [ "374062084",[-97.0595671, 32.5029601]],
    [ "374062085",[-96.94154977586756, 32.50851424285358]],
    [ "Brazos Electric Coop",[-96.90642765000001, 32.4806963]],
    [ "374062088",[-97.21133246871915, 33.22020570896805]],
    [ "374065818",[-97.10477137488296, 33.196819868963445]],
    [ "Boon Road Substation",[-85.38989499240695, 44.273696616981]],
    [ "374224080",[-114.88952370659771, 36.22090716997017]],
    [ "Robinson Summit Substation",[-115.16959997791636, 39.35751550977462]],
    [ "374316017",[-113.15896473061366, 37.800574105139674]],
    [ "374316018",[-112.5787588104626, 39.50370848824492]],
    [ "Tustin Substatoin",[-85.50797930361291, 44.1165756077896]],
    [ "374356574",[-97.71696870637419, 33.064260374537305]],
    [ "Newark Substation",[-97.52290789999999, 33.03992045]],
    [ "Reno Substation",[-97.63275285000002, 32.949701499999996]],
    [ "374356579",[-97.82940472177054, 33.19844871810823]],
    [ "Aurora Substation",[-97.5482681889052, 33.051214699815354]],
    [ "374356582",[-97.5885389752866, 33.21447035418542]],
    [ "374356583",[-97.73315572171562, 33.21730457001272]],
    [ "Mystic Substation",[-83.33886352866544, 31.625033820246717]],
    [ "Leroy Substation",[-85.41527022493179, 44.0268743965008]],
    [ "374522424",[-114.01104445000003, 35.271125]],
    [ "374532535",[-110.97301089622613, 41.27167467302193]],
    [ "374575243",[-78.94309437100239, 36.01123772704358]],
    [ "374648381",[-106.76545524894834, 34.823925894651204]],
    [ "374695158",[-97.58724945407377, 33.21419838764196]],
    [ "374695160",[-97.4340898049745, 33.66224733363538]],
    [ "374695161",[-97.33253255341748, 33.63996433292462]],
    [ "374751524",[-123.28263344544258, 46.858657797515804]],
    [ "Beaver Creek Substation",[-84.69824699975334, 44.5972927093389]],
    [ "Weyerhaeuser Substation",[-84.69495236660417, 44.59257520484263]],
    [ "Markey Substation",[-84.70369824185072, 44.40597987513187]],
    [ "Pulaski State Prison Substation",[-83.45317423398939, 32.31197616687505]],
    [ "Morely Substation",[-85.43777877592304, 43.54154950521328]],
    [ "Morley #2 Substation",[-85.43716735835613, 43.54161092360587]],
    [ "Metro Substation",[-81.84795426480375, 26.57145021915224]],
    [ "Colonial Substation",[-81.87954120246413, 26.600962341349177]],
    [ "Greenwood Substation",[-73.99378151255685, 40.65929115089574]],
    [ "Voorheesville Substation",[-73.93569203477077, 42.64793328005326]],
    [ "374902936",[-117.28296455124332, 45.41831484948989]],
    [ "San Xavier Substation",[-111.13060707233956, 32.161985294464415]],
    [ "Shadow Glen Substation",[-97.53549219566054, 30.357077183139328]],
    [ "Sandario Substation",[-111.24041839857213, 32.2492778912588]],
    [ "374959969",[-96.66417852502065, 33.137206506724716]],
    [ "Fort Myers Substation",[-81.865440707339, 26.64200477092088]],
    [ "Owens Substation",[-90.18052201754492, 35.16026346563222]],
    [ "Craney Island Terminal Station",[-76.34502128402869, 36.89406944424103]],
    [ "Western Area Power Administration",[-103.61283200492385, 40.25585987671166]],
    [ "Hialeah Substation",[-80.2865034214011, 25.829326881624496]],
    [ "Tucson Electric Power",[-111.06902644025001, 32.331903907033166]],
    [ "Tropical Substation",[-80.34945117525146, 25.753951465585445]],
    [ "Florida Power & Light",[-80.20342558763875, 25.784640426706293]],
    [ "Miami Substation",[-80.19373439430643, 25.79674880734219]],
    [ "Biscayne Substation",[-80.2063986, 25.89093845]],
    [ "Alva Substation",[-81.60040254888837, 26.703733206473558]],
    [ "375108996",[-84.48003943150967, 34.70841758018742]],
    [ "Ozarks Electric Cooperative Corporation",[-94.23906422545632, 36.06586234315055]],
    [ "Ocala Airport Substation",[-82.20135269001958, 29.182320774875084]],
    [ "375163438",[-83.3842446926374, 42.344402325878804]],
    [ "375203672",[-110.99106284860316, 32.25106933483154]],
    [ "Davis Substation TECO",[-82.35908280703514, 28.048044311808464]],
    [ "East Winter Haven Substation",[-81.72887063572058, 28.017243833423834]],
    [ "Wheeler Road Substation",[-82.24807262515557, 27.972033213760643]],
    [ "TECO",[-82.3952408, 28.032216899999995]],
    [ "375256647",[-97.79805065, 33.27467035000001]],
    [ "375256648",[-97.88651780000001, 33.3714187]],
    [ "375256649",[-97.79417098157806, 33.2647569956002]],
    [ "Chase Substation",[-85.68122910031468, 43.89495345281382]],
    [ "Tippy Substation",[-85.94047777353414, 44.25644262286419]],
    [ "Sub 72",[-76.87374358823637, 40.25495400022613]],
    [ "TECO",[-82.37198365, 27.967866049999994]],
    [ "TECO",[-82.33758930275671, 27.972996013582673]],
    [ "56th Street Substation",[-82.39279626859133, 27.999605213391227]],
    [ "Star Lake Substation",[-85.97950874984862, 43.88774405944216]],
    [ "Lake County Substation",[-86.03931144609635, 43.98854981724525]],
    [ "Bass Lake Substatoin",[-85.98382374236233, 44.09468300591715]],
    [ "Clermont Substation",[-81.7442858, 28.550732100000005]],
    [ "Matanzas Substation",[-82.49513242486714, 27.939295922495536]],
    [ "Lois Substation",[-82.51364320584915, 27.923260189944756]],
    [ "Ohio Substation",[-82.49820414999999, 27.9770842]],
    [ "Stadium Substation",[-82.49955074981233, 27.97685400329226]],
    [ "Tampa Bay Substation",[-82.50903598633352, 27.973312232860952]],
    [ "375588476",[-84.50569303293904, 38.05061504106487]],
    [ "Odessa Substation",[-93.96740430604238, 38.988852147895095]],
    [ "Lexington 69 Substation",[-93.88576221833374, 39.18013771477702]],
    [ "Richmond Substation",[-93.96354817100696, 39.2716389057012]],
    [ "Lexington Substation",[-93.89377092824067, 39.15878774404743]],
    [ "IP&L Substation P",[-94.36844202116596, 39.076864291141476]],
    [ "IP&L Substation M",[-94.38800931013388, 39.095565367191334]],
    [ "Florida Power & Light",[-80.25762158395169, 25.828399767172254]],
    [ "Seminola Substation",[-80.29362369784333, 25.840268595022994]],
    [ "Strother Road Substation",[-94.36710517171721, 38.96635957220028]],
    [ "IP&L Substation R",[-94.3745847214945, 39.036014857362574]],
    [ "Blue Springs East Substation",[-94.25553652294896, 39.00933125105377]],
    [ "375858430",[-74.174542401779, 40.365151634459615]],
    [ "Frost Road Substation",[-94.43291121912802, 38.97724043198501]],
    [ "George Road Substation",[-82.5496460751286, 27.993122743861782]],
    [ "Gray Substation",[-82.51835727503676, 27.949017663610416]],
    [ "Cape Coral Substation",[-81.97498932499964, 26.577029106305886]],
    [ "Everest Substation",[-81.93468109760593, 26.606065174186195]],
    [ "Industrial Substation",[-81.94450423803687, 26.637600666122932]],
    [ "Pine Island Substation",[-82.09314886444987, 26.56314636692278]],
    [ "Piney Road Substation",[-81.88977969825429, 26.668598272274696]],
    [ "South Cape Substation",[-81.9555998874142, 26.564231469866122]],
    [ "Tropic Isle Substation",[-81.92346719833974, 26.654117619125856]],
    [ "West Cape Substation",[-82.01437206596438, 26.591318552991975]],
    [ "TECO",[-82.51693027939893, 28.000190837269443]],
    [ "Ivy Street Substation",[-82.4947948045955, 27.96988372029547]],
    [ "West Lake Wales Substation DUKE",[-81.66288294634955, 27.902892524299737]],
    [ "375971228",[-81.24245737128118, 28.05736198792619]],
    [ "375988318",[-81.72929880000001, 28.045207749999996]],
    [ "Lake Alfred Substation",[-81.73135005996346, 28.087723793335236]],
    [ "TECO",[-82.45338970771581, 28.0652564725075]],
    [ "376109324",[-111.6017419881912, 33.344094784601346]],
    [ "Belton South Substation",[-94.5112562094528, 38.80732095246457]],
    [ "Belton Substation",[-94.51209604916006, 38.80667752534257]],
    [ "Peculiar 161kV Substation",[-94.48324236854258, 38.724631916983284]],
    [ "FIXME Substation",[-94.25055314291996, 38.52918516958753]],
    [ "Oklahoma Substation",[-94.44703048343685, 38.69906870859198]],
    [ "Freeman Substation",[-94.50043652351982, 38.62066386207572]],
    [ "City of Harrisonville Electric Department",[-94.36179735116775, 38.63267009674398]],
    [ "South Harper Substation",[-94.48405444986494, 38.67967684784914]],
    [ "376175449",[-94.06968801479528, 38.52860127954114]],
    [ "Roseway Substation",[-122.92528926644604, 45.49922168872573]],
    [ "Langley Station",[-86.47420411714458, 42.103684565610415]],
    [ "376314785",[-106.57177349117518, 35.131076568749094]],
    [ "FIXME Substation",[-94.36461130559499, 38.25490643842028]],
    [ "376317273",[-94.32703635000001, 38.2705378]],
    [ "Sun City Substation",[-82.36789660176582, 27.71340685624183]],
    [ "376323446",[-82.40141209999999, 27.763169499999993]],
    [ "Sand Fork Substation",[-80.78089815010142, 38.91909883539857]],
    [ "Collins Substation",[-80.17921487513956, 26.077847339688315]],
    [ "Waverly Wind Farm substation",[-95.59186930892189, 38.33176081487014]],
    [ "TECO",[-82.4415944671294, 27.9252927583013]],
    [ "TECO",[-82.48749963449511, 28.084114842224327]],
    [ "3rd Avenue Substation",[-82.44394171746109, 27.95778313918778]],
    [ "Rome Avenue Substation",[-82.47624679830021, 27.952523150860983]],
    [ "78th Street Substation",[-82.36910298535108, 27.935126779000246]],
    [ "Cazenovia Station",[-75.84569343070484, 42.93711366477021]],
    [ "376687116",[-94.32569440000002, 37.72031940000001]],
    [ "Keystone Substation",[-82.59186538125941, 28.099623188522617]],
    [ "Patterson Road Substation",[-82.63851767907919, 28.11441061241639]],
    [ "Weston Substation",[-80.4532408574729, 39.04218881798216]],
    [ "Plains Junction",[-85.91285001524308, 43.81868310979263]],
    [ "Baldwin Substation",[-85.80022544999763, 43.85723738445215]],
    [ "Paris Substation",[-85.50757847500152, 43.81508244313112]],
    [ "Mecosta Substation",[-85.52677324863994, 43.74492454908526]],
    [ "Greynolds Substation",[-80.15118396306514, 25.927287540017378]],
    [ "Beverly Substation",[-80.21176293834729, 26.00299190566962]],
    [ "Florida Power & Light",[-80.18379347462626, 25.993412995467416]],
    [ "Aventura Substation",[-80.14903520000001, 25.96660885]],
    [ "County Line Substation",[-80.21381703217365, 25.972205557843004]],
    [ "Hollywood Substation",[-80.14851957818765, 26.017382600031542]],
    [ "Stirling Substation",[-80.18369729999999, 26.031207799999997]],
    [ "Weston Village Substation",[-80.20487445, 25.946560700000003]],
    [ "Uleta Substation",[-80.17159150683806, 25.924327467262053]],
    [ "Fulford Substation",[-80.20396804156277, 25.928243391268495]],
    [ "Gilbert Substation",[-81.86294447435357, 37.615471926451505]],
    [ "Wahpeton Substation",[-96.612087, 46.32556714999999]],
    [ "Florida Power & Light",[-80.32846046963385, 25.897039603443393]],
    [ "Roselawn Substation",[-80.31223488363321, 25.855760443123614]],
    [ "Florida Power & Light",[-80.2331742, 25.927647399999998]],
    [ "Garden Substation",[-80.26368894999997, 25.936938599999994]],
    [ "Opa Locka Substation",[-80.23600320506081, 25.89778889220963]],
    [ "TECO",[-82.36917640792859, 27.900615729013726]],
    [ "Riverview Substation",[-82.30124135000001, 27.85550965]],
    [ "FIXME Substation",[-94.18714368447355, 37.498778768812265]],
    [ "FIXME Substation",[-94.26798753518776, 37.50319772433196]],
    [ "TECO",[-82.3584846112925, 27.985027944811314]],
    [ "Trapnell Substation TECO",[-82.14687425000001, 27.96602925]],
    [ "TECO",[-82.1459905561309, 28.02533997742551]],
    [ "Coronet Substation",[-82.08394886321065, 27.985883187211858]],
    [ "Gallagher Road Substation",[-82.23648657156926, 27.990182828430758]],
    [ "Deerfield Beach Substation FPL",[-80.12503523353399, 26.31609377502794]],
    [ "377082951",[-81.83708502315534, 35.74232121048523]],
    [ "Tampa Electric Company",[-82.33086895000001, 27.711949949999998]],
    [ "TECO",[-82.33441227505533, 27.75719479299916]],
    [ "Gulf City Substation",[-82.4705405, 27.68435825]],
    [ "Sydney Road Substation",[-82.16286720259276, 27.991436742013114]],
    [ "LADWP Distributing Station No. 80",[-118.4028582, 34.279378449999996]],
    [ "Pinellas Park Substation DUKE",[-82.70382953298305, 27.829793401710486]],
    [ "Clearwater Substation",[-82.79125638303343, 27.972336075083284]],
    [ "Litchfield Substation",[-94.63239024850962, 37.44267160026445]],
    [ "377182762",[-94.33914777256422, 37.3257772637863]],
    [ "377243811",[-96.4054299392482, 42.43259555131152]],
    [ "Duke Energy",[-82.74702733393661, 28.094173307346285]],
    [ "Duke Energy",[-82.74010072400802, 27.864110688710415]],
    [ "Chavaneaux Road Substation",[-98.51036754127307, 29.335018933148707]],
    [ "377421223",[-96.11252375182403, 41.53550479613955]],
    [ "377427040",[-96.20406300063756, 41.54452539739792]],
    [ "Jewfish Creek Substation",[-80.37849923173685, 25.16506262821079]],
    [ "Key Largo Substation",[-80.45288230261988, 25.08228492504006]],
    [ "377477643",[-111.89629555251413, 33.35454817924393]],
    [ "Entergy Arkansas",[-90.18443126158867, 35.144429731708044]],
    [ "West Memphis Utility Commission",[-90.18362443325113, 35.144431175030384]],
    [ "377505293",[-94.61498885035999, 37.06581939066713]],
    [ "Islamorada Substation",[-80.64819444999999, 24.9056452]],
    [ "Brethren Substation",[-86.04522017490848, 44.32749537485983]],
    [ "Florida Power & Light",[-80.36484195, 25.597923949999995]],
    [ "Warfordsburg Substation",[-78.19040221344552, 39.76484514651851]],
    [ "377572385",[-96.10456445, 41.532712849999996]],
    [ "377574372",[-96.02280888121969, 41.450508269971635]],
    [ "South Miami Substation",[-80.28742214190007, 25.708765546201086]],
    [ "Bird Substation",[-80.29429590000001, 25.734070700000004]],
    [ "Dadeland Substation",[-80.3049242713433, 25.694907207314888]],
    [ "Dania Substation",[-80.13476280826637, 26.046656874523578]],
    [ "Village Green Substation",[-80.38532542564842, 25.728189206121563]],
    [ "University Substation",[-80.27573884629386, 25.716805462840536]],
    [ "Marion Substation",[-80.38155810061409, 25.69314944417618]],
    [ "62nd Avenue Substation",[-80.29599968458693, 25.755065124425297]],
    [ "Florida Power & Light",[-80.31234847073412, 25.78405158780044]],
    [ "Southside Substation",[-80.14564192616187, 26.112231575356233]],
    [ "Goulds Substation",[-80.37305141399483, 25.56943357468062]],
    [ "377633835",[-94.42723200731702, 36.84485185374562]],
    [ "PECO",[-75.26531563158471, 39.949344777150586]],
    [ "Lone Mountain Substation",[-115.30927352429758, 36.220231664241865]],
    [ "TECO",[-82.6492950749698, 28.04112579486258]],
    [ "Brandon Substation",[-82.27803813703319, 27.936057374376958]],
    [ "Lakewood Substation",[-82.30977732525815, 27.940744054058836]],
    [ "Pinecrest Substation",[-82.14499025, 27.8461102]],
    [ "Saint Cloud Substation",[-82.23694562455127, 27.939838554879454]],
    [ "Florida Power & Light",[-80.15436301285742, 26.21136788556751]],
    [ "Florida Power & Light",[-80.05764167570474, 26.778597545197808]],
    [ "Baldwin Substation FPL",[-81.98921199943706, 30.2747143839839]],
    [ "Belvedere Substation",[-80.06907665000001, 26.6881983]],
    [ "Key Biscayne Substation",[-80.16227915909023, 25.700702320971505]],
    [ "Lake Park Substation",[-80.05629013950978, 26.803460324117083]],
    [ "Laurelwood Substation",[-82.3732578890939, 27.135764942036694]],
    [ "Venice Substation",[-82.4339546260951, 27.10494740543245]],
    [ "Wabasso Substation",[-80.46240425, 27.740926450000003]],
    [ "Riviera Substation",[-80.05430499572869, 26.765029181998518]],
    [ "Florida Power & Light",[-80.0531145821948, 26.763667919249865]],
    [ "Datura Street Substation FPL",[-80.05603519831097, 26.71270049334253]],
    [ "377743945",[-94.41097295765421, 36.83925525703202]],
    [ "Golf Substation",[-80.07781244758613, 26.506272358694687]],
    [ "Quantum Substation",[-80.07553008627397, 26.540148440316482]],
    [ "377810580",[-86.68613087126697, 37.890931983780376]],
    [ "TECO",[-82.35286485468923, 28.17996217993871]],
    [ "TECO",[-81.78699762508703, 28.04694470307614]],
    [ "Clarkwild Substation",[-82.31961390255695, 28.05472277327341]],
    [ "Cypress Gardens Substation",[-81.69212762497993, 28.021994785845145]],
    [ "Gibsonton Substation",[-82.38527097474903, 27.86209531604263]],
    [ "Pearson Road Substation",[-82.22839201532543, 27.895301067800474]],
    [ "South Gibsonton Substation",[-82.36789497526485, 27.84637874582489]],
    [ "Duke Energy",[-82.67536442531768, 28.15251515783607]],
    [ "377840622",[-82.46344065, 28.526632250000002]],
    [ "377840641",[-82.49146249974929, 28.1528442420494]],
    [ "Train Substation",[-80.1309233, 26.2120378]],
    [ "Holy Cross Substation",[-80.12043670000001, 26.187590150000002]],
    [ "Crystal Substation",[-80.1528859, 26.279128599999996]],
    [ "Florida Power & Light",[-80.15323801264523, 26.2587050308148]],
    [ "Lyons Substation",[-80.10961315123929, 26.21112804315272]],
    [ "Oakland Park Substation",[-80.14002942455815, 26.173254339927315]],
    [ "377915399",[-94.42978153705423, 36.745327681072595]],
    [ "377915400",[-94.70591730057946, 36.66825824922243]],
    [ "Bremen Station",[-75.39030074219687, 43.88167100229271]],
    [ "Oldsmar Substation",[-82.6799661597434, 28.04569332488105]],
    [ "Tuttle Substation",[-82.51251639228826, 27.342590724986117]],
    [ "Beneva Substation",[-82.49816669980993, 27.295548197755107]],
    [ "Beneva Substation",[-82.49725765132771, 27.268874841107515]],
    [ "Howard Substation",[-82.44753333192934, 27.284866668633324]],
    [ "Hyde Park Substation",[-82.51298300758025, 27.31520597507804]],
    [ "Payne Substation",[-82.54807413021372, 27.34797911770425]],
    [ "Vamo Substation",[-82.4964176, 27.2288325]],
    [ "Interstate Substation",[-82.44754486450098, 27.26123159453288]],
    [ "Sawgrass Substation",[-82.4461192246792, 27.330941413791493]],
    [ "378001485",[-80.44521962518654, 27.624911994572436]],
    [ "City of Vero Beach",[-80.44277651845401, 27.672016414416095]],
    [ "Micco Substation",[-80.5069299863286, 27.880824732048197]],
    [ "Central Beach Substation",[-80.3568067280873, 27.633106812896838]],
    [ "North Substation",[-80.41717040000002, 27.667071150000005]],
    [ "Substation #3",[-80.44728167494124, 27.64564604397618]],
    [ "KEYS",[-81.47621480564294, 24.662630675150062]],
    [ "378068330",[-96.46440490234315, 41.45455888869447]],
    [ "378070986",[-94.53197064999999, 36.576513549999994]],
    [ "Carroll Electric Cooperative Corporation",[-94.61470182155313, 36.5344540736546]],
    [ "Tamiami Substation",[-80.2650186937225, 25.76395397558715]],
    [ "Market Substation",[-80.21869832699535, 25.796469685766276]],
    [ "Buena Vista Substation",[-80.20233579055187, 25.814389726131363]],
    [ "Gladeview Substation",[-80.23771544118436, 25.836691238566992]],
    [ "Miramar Substation",[-80.19753506872387, 25.798894135706416]],
    [ "Natoma Substation",[-80.23932274366842, 25.757070442712106]],
    [ "Railway Substation",[-80.20332356233772, 25.7840504700409]],
    [ "378099052",[-109.90339155000001, 47.051935650000004]],
    [ "Suniland Substation",[-80.32689106432922, 25.656513274365945]],
    [ "Florida Power & Light",[-80.42881655658911, 25.565243224698364]],
    [ "Kendall Substation",[-80.32664249709715, 25.675942508032687]],
    [ "Redland Substation",[-80.4932106989853, 25.47541289104485]],
    [ "8th Street Cable Terminal",[-80.30514360852368, 25.763354924418913]],
    [ "Venetian Substation",[-80.14223709999999, 25.7949163]],
    [ "Moffett Substation",[-80.15035903595894, 25.99781733119536]],
    [ "378214882",[-94.40068393652675, 36.64738922768243]],
    [ "378214884",[-94.71235899346185, 36.41370560904274]],
    [ "Florida Power & Light",[-80.07043429129942, 26.46454682536459]],
    [ "Carroll Electric Cooperative Corporation",[-94.53378775, 36.4385099]],
    [ "Carroll Electric Cooperative Corporation",[-94.48673539916336, 36.37820096634544]],
    [ "378271171",[-77.84489649999999, 35.05133550000001]],
    [ "LWU",[-80.07191462548752, 26.573626154059735]],
    [ "18th Avenue North Substation",[-80.05928696985328, 26.637252383916966]],
    [ "11th Avenue North Substation",[-80.05903687467877, 26.6285567241561]],
    [ "4th Avenue North Substation",[-80.05954859999999, 26.620180749999996]],
    [ "12th Avenue South Substation",[-80.06779357518283, 26.601420394193962]],
    [ "15th Avenue South Substation",[-80.05421997444886, 26.597432805743296]],
    [ "6th Avenue South Substation",[-80.0583281748715, 26.60804600621883]],
    [ "7th Avenue North Substation",[-80.07239790779224, 26.62457007555925]],
    [ "Duke Energy",[-80.80366696774018, 35.20300405321294]],
    [ "Grandview Substation",[-119.87419737984361, 46.303556432627815]],
    [ "Florida Power & Light",[-80.11212005, 26.6447408]],
    [ "Florida Power & Light",[-80.06606002532507, 26.752566084779268]],
    [ "Westward Substation FPL",[-80.10205286077702, 26.708504195688725]],
    [ "378436228",[-106.5477659, 35.05512220000001]],
    [ "Florida Power & Light",[-80.24003198515354, 27.167271626190836]],
    [ "General Motors",[-94.59805314391596, 39.145644038784795]],
    [ "378460830",[-80.32791710000001, 25.882661050000003]],
    [ "Florida Power & Light",[-80.35881148223514, 26.06400032693882]],
    [ "Davie Substation",[-80.23456904999999, 26.094551850000002]],
    [ "Davie Substation",[-80.23474361271707, 26.09391387960166]],
    [ "Three Points Substation",[-111.28562802581587, 32.09433040804498]],
    [ "Kendrick Substation",[-85.5378828, 42.870888699999995]],
    [ "Fashion Substation",[-80.10129239999999, 26.262786450000004]],
    [ "Hillsboro Substation",[-80.1033028, 26.330794400000002]],
    [ "Holly Hill Substation",[-81.04628994170103, 29.247587889513323]],
    [ "Deerfield Beach Substation",[-80.10409786652134, 26.304261718210064]],
    [ "Ormond Substation",[-81.07220622301578, 29.284012503008714]],
    [ "Sample Road Substation",[-80.10270970644645, 26.27591737479665]],
    [ "Terrace Substation",[-94.59972848199533, 39.09093400742063]],
    [ "378824834",[-87.49231010000001, 36.53750970000001]],
    [ "Tennessee Valley Authority",[-87.53880525902507, 36.52890723693906]],
    [ "40th Street Substation",[-80.12805900000001, 25.8131058]],
    [ "Miami Beach Substation",[-80.1488511641605, 25.77121871950708]],
    [ "Normandy Beach Substation",[-80.12249709161621, 25.872447477005167]],
    [ "Simpson Substation",[-80.19668452510874, 25.760804965402052]],
    [ "Sunny Isles Substation",[-80.13207517549235, 25.93040192630939]],
    [ "Virginia Key Substation",[-80.15351446722418, 25.74798482341057]],
    [ "Bonifay Substation",[-85.66157753652766, 30.79295292528759]],
    [ "Caverns Road Substation",[-85.17408740450887, 30.81252869032513]],
    [ "Marianna Substation",[-85.27278370022671, 30.78331180602545]],
    [ "Milligan Substation",[-86.643354790463, 30.747309090300995]],
    [ "Hinsons Crossroads Substation",[-85.843164, 30.676429100000004]],
    [ "378959849",[-83.6177258258352, 42.6521980034736]],
    [ "Hathaway Substation",[-85.75752642239009, 30.16046562038579]],
    [ "Florida Power & Light",[-85.6218101276572, 30.143285237644733]],
    [ "379007833",[-78.14821391852236, 33.9422153046403]],
    [ "379009849",[-106.54889799512112, 35.058266137220365]],
    [ "379021309",[-84.46485913400853, 38.01635940449552]],
    [ "379021310",[-84.45097156362137, 38.029264553168304]],
    [ "Kentucky Utilities Company",[-84.51323462618876, 37.953116043207665]],
    [ "Reynolds Substation",[-84.52931612575516, 37.99263860505644]],
    [ "379021318",[-84.5199364131234, 38.02238062551199]],
    [ "379021319",[-84.51299495, 38.033949099999994]],
    [ "379021325",[-84.5060073268105, 38.02834934833017]],
    [ "379026054",[-84.50711959576834, 38.041655830529585]],
    [ "Florida Power & Light",[-80.6719759749279, 28.09569269172407]],
    [ "Eau Gallie Substation",[-80.63253785639137, 28.13766903347861]],
    [ "Florida Power & Light",[-80.41388935453708, 27.57658902563255]],
    [ "Apollo Substation",[-80.63535011783259, 28.114469080559225]],
    [ "Emerson Substation",[-80.4158848249351, 27.532864859119176]],
    [ "Fort Pierce Substation",[-80.35845811403718, 27.446919397546107]],
    [ "Indrio Substation",[-80.4035429, 27.520436500000006]],
    [ "Melbourne Substation",[-80.60906546348565, 28.084600077587563]],
    [ "Patrick Substation",[-80.60726851015036, 28.213200543901866]],
    [ "Florida Power & Light",[-80.52744971567554, 27.924744221696777]],
    [ "Babcock Substation",[-80.62407055, 27.99171655]],
    [ "Florida Power & Light",[-80.62414243075611, 27.992401736745716]],
    [ "379183171",[-82.19377471620172, 28.455405318918128]],
    [ "379183176",[-82.55849585, 28.366671600000004]],
    [ "Duke Energy",[-82.20422762505689, 28.459173092573074]],
    [ "Duke Energy",[-82.32181169999998, 28.5156457]],
    [ "379183182",[-82.56059565000001, 28.369979650000005]],
    [ "379183185",[-82.23921075853573, 28.409398329150104]],
    [ "379183187",[-82.36282195, 28.325348449999996]],
    [ "379183222",[-82.48492079996198, 28.325653903702005]],
    [ "Bushnell East Substation",[-82.09919896626589, 28.671723511403925]],
    [ "Bushnell Substation SECO",[-82.15292496964996, 28.6693076378384]],
    [ "379246730",[-110.1185263, 31.3805969]],
    [ "Florida Power & Light",[-80.14509149999999, 26.08401745]],
    [ "Boca Raton Substation",[-80.09215419254562, 26.35083972553127]],
    [ "Pinehurst Substation",[-80.15340574364645, 26.094995922601147]],
    [ "Florida Power & Light",[-80.1150576, 26.81161065]],
    [ "Fountain Substation FPL",[-80.14773369058142, 26.615082474569135]],
    [ "Monet Substation",[-80.11278935, 26.83881605]],
    [ "Fort Pierce Utilities",[-80.34616625969672, 27.46794445159509]],
    [ "Savannah Substation",[-80.31740814642065, 27.417308451945967]],
    [ "Hayden Island Substation",[-122.69946319996602, 45.618407138048866]],
    [ "Hanson Substation",[-80.26397442505605, 27.08730199431418]],
    [ "Recway Substation",[-80.14221415931247, 26.771903525058015]],
    [ "Recway Substation",[-80.14262092505567, 26.775223092384948]],
    [ "Duke Energy",[-81.67483812310472, 35.72637319267568]],
    [ "Carmen Substation FPL",[-81.00107637351597, 29.162211112260305]],
    [ "General Electric Substation",[-81.07624075754752, 29.193722346629396]],
    [ "Madison Substation FPL",[-81.0453622, 29.21550285]],
    [ "Port Orange Substation FPL",[-80.9972167620504, 29.139672051468516]],
    [ "Taylor Substation",[-80.99260975, 29.11345335]],
    [ "Indian Harbour Substation",[-80.59799366292879, 28.142310980858436]],
    [ "Florida Power & Light",[-80.29666359999999, 26.121591250000005]],
    [ "Valencia Substation",[-80.3210783749666, 26.09437399457597]],
    [ "Casino Substation",[-80.19610276872301, 26.27904583601009]],
    [ "Sherman Substation",[-80.77787857496706, 27.23991681980089]],
    [ "Dillard Substation",[-80.1661569, 26.1594044]],
    [ "Orchid Substation",[-80.14578449999999, 26.113441700000003]],
    [ "Verena Substation",[-80.13120074069097, 26.144664982817492]],
    [ "Peace River Substation",[-82.53104096383179, 27.551566024964476]],
    [ "Rubonia Substation",[-82.55192275, 27.55721975]],
    [ "Florida Power & Light",[-82.567470656265, 27.4471935750967]],
    [ "Walker Substation",[-82.59664175, 27.491464800000003]],
    [ "Cocoplum Substation",[-82.24365875620322, 27.047852292328038]],
    [ "College Substation FPL",[-81.30203521941729, 28.75761900281418]],
    [ "Columbia Substation FPL",[-82.63340405478476, 30.19806664887494]],
    [ "Blountstown Substation",[-85.0333923, 30.428576700000004]],
    [ "Altha Substation",[-85.12225160025727, 30.51500664847774]],
    [ "Graceville Substation",[-85.53968845655884, 30.963358537418365]],
    [ "Chipley Substation",[-85.53276695, 30.786370849999997]],
    [ "Alford Substation",[-85.34393315963142, 30.698250478948594]],
    [ "Fountain Substation",[-85.48739210000001, 30.480867]],
    [ "Southport Substation",[-85.62514120000002, 30.282961399999998]],
    [ "Vernon Substation",[-85.74615362532963, 30.57449224404392]],
    [ "379743261",[-85.8101684768766, 33.628768093674196]],
    [ "Turner Road Substation",[-86.04004775, 33.5360529]],
    [ "379743301",[-85.80312655437938, 33.618882655998185]],
    [ "Friendship Substation",[-85.78612935, 33.5860669]],
    [ "Oxanna Substation",[-85.8329756360811, 33.630376765941215]],
    [ "Oxford Substation",[-85.85141262004863, 33.60453628517483]],
    [ "Traer Substation",[-92.51312226314104, 42.16617849725996]],
    [ "Daleville Substation",[-85.71553519999999, 31.30598504999999]],
    [ "Fort Rucker Substation",[-85.70784312535415, 31.32270784922797]],
    [ "379868165",[-110.2387195288874, 31.87890126728548]],
    [ "379868166",[-110.33322752880919, 31.946783303403397]],
    [ "Brush Creek Transition Substation",[-94.53744521864078, 39.03847071543258]],
    [ "Kennedy Power Plant Substation",[-81.62706499136273, 30.36455874548624]],
    [ "Merrill Substation",[-81.56679139815071, 30.35151008572611]],
    [ "Jacksonville Electric Authority",[-81.60064874693299, 30.366562996225046]],
    [ "Nassau Substation JEA",[-81.58458591043279, 30.589834521008672]],
    [ "Jacksonville Electric Authority",[-81.62024927254514, 30.29291960466733]],
    [ "Arlington Substation",[-81.59504879991188, 30.3355547104611]],
    [ "Jax Zoo Substation JEA",[-81.63527522965175, 30.40801254333625]],
    [ "Kennedy Plant Substation",[-81.62724302350207, 30.363993253691756]],
    [ "Powers Substation JEA",[-81.61961849041293, 30.258789549422293]],
    [ "Jacksonville Electric Authority",[-81.65255614982861, 30.31054589033138]],
    [ "Paxon Substation",[-81.75153270000001, 30.34361085]],
    [ "Grand Park Substation",[-81.7156009394435, 30.35579880511166]],
    [ "Herlong Substation",[-81.7690040593413, 30.27769213616187]],
    [ "Brooklyn Substation",[-81.68954657585029, 30.336435800245923]],
    [ "Church Substation",[-81.6692808951664, 30.333001085937752]],
    [ "Kennedy Plant Substation South",[-81.62619806209555, 30.362983053901658]],
    [ "Lane Substation JEA",[-81.75253329975348, 30.307410383196295]],
    [ "Main Substation",[-81.65456059648169, 30.3358501482962]],
    [ "Oakwood Villa Substation",[-81.56921559088356, 30.323301628883318]],
    [ "379989259",[-85.5542147446775, 40.56643463881929]],
    [ "379991766",[-81.64905152628329, 30.31394598678336]],
    [ "CHAFFEE CREEK",[-89.52168762769898, 43.98797617503942]],
    [ "Jacksonville Electric Authority",[-81.60806200382957, 30.36658857251546]],
    [ "Stepdown Substation",[-81.46936919889477, 30.630874163238047]],
    [ "Anheuser-Busch Substation JEA",[-81.64443895000001, 30.43437395]],
    [ "Blount Island Substation",[-81.52437661343052, 30.40651522005046]],
    [ "Cecil Field Substation JEA",[-81.83425480000001, 30.250238600000003]],
    [ "Durbin Substation FPL",[-81.45132996144694, 30.079155634391398]],
    [ "Stagecoach Substation FPL",[-81.41865235, 29.919556949999997]],
    [ "Sabate Substation FPL",[-81.36288185000001, 29.981532150000007]],
    [ "Mill Creek Substation FPL",[-81.52930704925858, 29.984939725253767]],
    [ "Tocoi Substation FPL",[-81.51919865461252, 29.869772774364613]],
    [ "Duke Energy",[-82.5544935, 28.492354149999997]],
    [ "Leesburg North Substation",[-81.91272879999998, 28.831549000000003]],
    [ "Duke Energy",[-82.30493485618068, 28.73608048069882]],
    [ "Okahumpka Substation",[-81.87573231134228, 28.74843393178429]],
    [ "Duke Energy",[-82.34273837903747, 28.585395277150102]],
    [ "Webster Substation SECO",[-82.06337527369779, 28.58857598501975]],
    [ "Leesburg Central Substation",[-81.88791595390654, 28.81498326939664]],
    [ "Leesburg Picciola Substation",[-81.89204297455173, 28.83937144325208]],
    [ "Boulevard Substation",[-80.17056090853652, 25.87933352425364]],
    [ "Ralls Substation",[-80.37820851232696, 27.383082719669087]],
    [ "South Beach Substation",[-80.34872064999999, 27.610117250000002]],
    [ "Yorke Substation",[-80.69457222493664, 28.270108744654866]],
    [ "Cocoa Beach Substation",[-80.60905634631641, 28.358999610611193]],
    [ "Merritt Substation",[-80.70159010283129, 28.35442210833255]],
    [ "Minuteman Substation",[-80.61086119999999, 28.3163546]],
    [ "Rockledge Substation",[-80.73552207416606, 28.32105125293075]],
    [ "Sykes Creek Substation",[-80.67761164680363, 28.359190313161164]],
    [ "Scottsmoor Substation",[-80.88075612465597, 28.795321544367706]],
    [ "Mims Substation",[-80.85331689315389, 28.6660666700917]],
    [ "Forked Deer Electric Cooperative",[-89.42495134280038, 36.10218097317159]],
    [ "Clearlake Substation",[-80.75020648125295, 28.359819764054365]],
    [ "Geneva Substation FPL",[-81.1151698190203, 28.758387463310243]],
    [ "Celery Substation FPL",[-81.21894985644012, 28.785411470890093]],
    [ "380321479",[-109.70377920550916, 31.729639813877366]],
    [ "Florida Power & Light",[-82.52807089999999, 27.378514349999996]],
    [ "Whitfield Substation",[-82.54085455, 27.418619900000003]],
    [ "Florida Power & Light",[-82.17603984302316, 27.01660832501458]],
    [ "Florida Power & Light",[-82.38882136413721, 27.097922425028823]],
    [ "Englewood Substation",[-82.33615973504753, 26.962806724985217]],
    [ "Harbor Substation",[-82.07404816551498, 26.967318817605324]],
    [ "Myakka Substation",[-82.30917062839272, 26.977119339922915]],
    [ "Woods Substation",[-82.5224848749431, 27.428303460246195]],
    [ "Lake Butler Substation FPL",[-82.34393720542528, 30.021208699808522]],
    [ "Cooper Substation",[-82.03844323885619, 26.91222842527651]],
    [ "McCall Substtaion",[-82.2241346250233, 26.92827473977237]],
    [ "Punta Gorda Substation",[-82.0469048, 26.934377899999998]],
    [ "Florida Power & Light",[-82.02437286307854, 26.859021475142413]],
    [ "Entergy Arkansas",[-92.27664053529355, 34.74961320257028]],
    [ "Trail Ridge Substation FPL",[-82.04579449046045, 29.9558912760395]],
    [ "Hampton Substation FPL",[-82.13405707790508, 29.879637694455152]],
    [ "Starke Substation FPL",[-82.10300848300595, 29.940532423603692]],
    [ "Archer Substation DUKE",[-82.50537217988966, 29.557971488078593]],
    [ "Kelly Plant Substation North GRU",[-82.3211908819446, 29.64672934868486]],
    [ "GE Alachua Substation CoA",[-82.45530042499182, 29.773810958629642]],
    [ "Fort Clarke Substation GRU",[-82.47288876774627, 29.664091012239393]],
    [ "Idylwild Substation DUKE",[-82.35599149635952, 29.60433644265275]],
    [ "Kanapaha Substation GRU",[-82.43680069999998, 29.5899284]],
    [ "McMichen Substation GRU",[-82.30715101302731, 29.702037765650186]],
    [ "Millhopper Substation GRU",[-82.38775257915604, 29.704250636346174]],
    [ "Parker Substation GRU",[-82.47435589439159, 29.565395322529866]],
    [ "Serenola Substation GRU",[-82.38234207053534, 29.613916461615084]],
    [ "Springhill Substation",[-82.46459175, 29.69612665]],
    [ "Sugarfoot Substation GRU",[-82.40166661452989, 29.640881100009345]],
    [ "AEP Studebaker Substation",[-86.25252200627114, 41.66647410550491]],
    [ "Duke Energy",[-83.55048540208247, 30.05295853241564]],
    [ "Newberry Substation",[-82.5942715, 29.669640549999997]],
    [ "Duke Energy",[-82.93542655000002, 29.998873950000004]],
    [ "Red Level Substation Number 1",[-82.57789239778562, 29.002026449988985]],
    [ "Newberry Cement Plant Substation",[-82.57967702216378, 29.690096493356112]],
    [ "Duke Energy",[-82.8793787090254, 30.11941651771633]],
    [ "Alachua Substation DUKE",[-82.49451292708476, 29.777651919382873]],
    [ "Live Oak Substation",[-82.97837169946047, 30.293058359209684]],
    [ "380659993",[-85.79676201684337, 33.73272285908363]],
    [ "380659999",[-85.698113, 33.691157649999994]],
    [ "Bonny Brook Substation",[-85.75705558818879, 33.778617674567585]],
    [ "Henry Road Substation",[-85.78699585, 33.6455092]],
    [ "380764407",[-88.02076480000001, 30.9617341]],
    [ "380764411",[-88.05384955152651, 30.860407934488727]],
    [ "North Saraland Substation",[-88.08150520000001, 30.82725545]],
    [ "380766975",[-88.20725232471275, 30.69089118615485]],
    [ "Clarinda Substation",[-95.00306692421668, 40.74289777093305]],
    [ "380785508",[-81.91154914965755, 33.43172215848123]],
    [ "380817892",[-81.68854167130621, 33.45517451176093]],
    [ "380856930",[-81.83645075000003, 33.385368650000004]],
    [ "380856948",[-81.72225752345635, 33.28840346784319]],
    [ "380865653",[-88.1376164, 30.6186728]],
    [ "380865656",[-88.1022237899169, 30.552985181595112]],
    [ "380865666",[-88.1440928824933, 30.69777072536616]],
    [ "380865672",[-88.04806427075026, 30.736530124670026]],
    [ "Kimberley-Clark Substation",[-81.89906470343549, 33.41840731208495]],
    [ "380911653",[-90.43677160560897, 38.77370915344687]],
    [ "380916502",[-93.64019459514286, 45.756007715803456]],
    [ "Florida Power & Light",[-81.02917895, 29.10309825]],
    [ "City of New Smyrna Beach",[-80.93234578017933, 29.015947204822577]],
    [ "City of New Smyrna Beach",[-80.95581920200732, 29.050567747059013]],
    [ "Sanford Plant North Substation FPL",[-81.32557440648327, 28.847249437052962]],
    [ "Laurel Substation FPL",[-81.27162062116176, 28.807434558734574]],
    [ "Chuluota Substation FPL",[-81.11681025000001, 28.646424]],
    [ "Edgewater Substation",[-80.90499288249467, 28.973273186933305]],
    [ "Smyrna Substation NSB",[-80.99819763553081, 29.01874280582165]],
    [ "380968835",[-80.61614714670617, 28.413506466558754]],
    [ "380968838",[-80.58498802668068, 28.497244479866282]],
    [ "Florida Power & Light",[-80.60611834466917, 28.40455681084448]],
    [ "Lighthouse Substation",[-80.59454722236329, 28.44842703766159]],
    [ "Orsino Substation",[-80.65294144286787, 28.515490072186378]],
    [ "Florida Power & Light",[-80.60871526207558, 28.259400442448662]],
    [ "Holland Park Substation",[-80.54862104025759, 28.04607857509026]],
    [ "Indialantic Substation",[-80.57005369999999, 28.09625935]],
    [ "Tomah Industrial Park",[-90.47276460936726, 43.987004124781656]],
    [ "Council Creek",[-90.49572530274529, 43.969519724148206]],
    [ "Homestead Substation",[-80.38842862531406, 25.50472200485368]],
    [ "Latin Quarter Substation",[-80.22296011907517, 25.76787053369899]],
    [ "DeLand Substation",[-81.24048340637118, 29.01697752469432]],
    [ "Wheeler Substation",[-80.66626380000001, 26.722157199999995]],
    [ "LaBelle Substation",[-81.43775796045058, 26.7037880512195]],
    [ "Norton Substation",[-80.05828970237592, 26.651551825818903]],
    [ "South Bay Substation FPL",[-80.71318516502073, 26.649877746405984]],
    [ "Florida Power & Light",[-82.45003088154957, 27.136802014410655]],
    [ "Okeechobee Substation",[-80.82478094411474, 27.24254384668387]],
    [ "Morris Substation",[-81.07004191482632, 27.236585031597226]],
    [ "Ameren Missouri",[-90.3767919934422, 38.16286352138831]],
    [ "Vandolah Substation",[-81.92583461122204, 27.523495554301586]],
    [ "Midulla Plant Substation",[-81.96214842487778, 27.63690099445105]],
    [ "Wauchula Substation",[-81.81800667480083, 27.568416442739636]],
    [ "Pahokee Substation",[-80.65236147630888, 26.813756537699344]],
    [ "Brighton Substation",[-81.09292070000001, 27.22935565]],
    [ "Jesse L Terry Substation",[-81.45921590233799, 30.65473951362411]],
    [ "Combee Road Substation",[-81.90824365841479, 28.05285382481292]],
    [ "Saddle Creek Substation",[-81.9092428, 28.076944550000007]],
    [ "Medulla Substation",[-81.96127863764526, 27.977425679574015]],
    [ "City of Lakeland",[-81.88883218340091, 27.932689620436815]],
    [ "Northwest Substation",[-81.9732402523363, 28.069223277303948]],
    [ "Barcola Substation DUKE",[-81.88789478491745, 27.82401812258174]],
    [ "Crews Lake Substation",[-81.9005174, 27.897191050000004]],
    [ "City of Lakeland",[-81.92154, 28.091616350000006]],
    [ "Gibsonia Substation",[-81.98650105, 28.1303557]],
    [ "City of Lakeland",[-82.01712176613992, 28.044778259286534]],
    [ "Galloway Substation",[-82.0104698201106, 28.094651740083027]],
    [ "Sutton Substation",[-82.01613885, 28.0688723]],
    [ "Orangedale Substation",[-81.88471442696083, 28.15346916332037]],
    [ "Polk City Substation",[-81.82842370675168, 28.17859591298662]],
    [ "TECO",[-81.81708685, 28.05821645]],
    [ "Jan Phyl Substation",[-81.776650831888, 28.02051834623639]],
    [ "TECO",[-81.79697335557604, 28.05490608901688]],
    [ "Lake Gum Substation",[-81.73056560848279, 28.114125214458983]],
    [ "Dairy Road Substation",[-81.77686529989731, 28.071324945083504]],
    [ "Lucerne Park Substation",[-81.68631676106298, 28.070272678062928]],
    [ "Cypress Gardens Substation",[-81.68593634999999, 27.993834399999994]],
    [ "Lake Winterset Substation",[-81.69725829645174, 27.96708029444895]],
    [ "Duke Energy",[-82.52611404047272, 28.583622775291598]],
    [ "Recker Switching Station",[-81.80614802401564, 28.052638706837364]],
    [ "Turner Power Plant Substation DUKE",[-81.27275060419615, 28.869977664787047]],
    [ "381791820",[-81.34252002052446, 28.698515555275534]],
    [ "Boulevard Substation",[-81.14456335039809, 32.041176471994866]],
    [ "Wrightsboro Road Substation",[-82.13827445185076, 33.47762264069838]],
    [ "Florida Power & Light",[-80.47701822455323, 25.682823142757286]],
    [ "Doctors Inlet Substation #16 CLAY",[-81.83246830000002, 30.10380235]],
    [ "Orange Park North Substation #14 CLAY",[-81.73015033398158, 30.182784396915192]],
    [ "Kingsley Lake Substation",[-81.96464006248951, 29.9818896307665]],
    [ "Dillaberry Substation CLAY",[-81.89836845, 30.06526445]],
    [ "Como Substation",[-81.58656031422606, 29.492214384775593]],
    [ "Elkton Substation",[-81.43987718891294, 29.783842006177608]],
    [ "Fruitland Substation",[-81.64349225000002, 29.43165815]],
    [ "Hammond Substation",[-81.51501005000001, 29.3821024]],
    [ "Hastings Substation",[-81.51361362731951, 29.71465789380925]],
    [ "Salt Springs Substation #62",[-81.74182512457158, 29.369927867023353]],
    [ "Satsuma Substation CLAY",[-81.65358248596208, 29.547260223939215]],
    [ "Sanderson Substation #13 CLAY",[-82.23374316392214, 30.215853218829135]],
    [ "Macclenny Substation FPL",[-82.12168165700909, 30.27398122941982]],
    [ "Wiremill Substation FPL",[-82.25966370423266, 30.251719281656417]],
    [ "Astor Substation #52 CLAY",[-81.51620688464712, 29.172598325419912]],
    [ "Hawthorne Substation OCB CLAY",[-82.0280205575668, 29.608118574762067]],
    [ "Hawthorne Substation #35 CLAY",[-82.08279779999998, 29.5729381]],
    [ "382143003",[-89.80904451794876, 44.20235674094391]],
    [ "Mountain Parks Electric",[-105.84562977481552, 40.247338456217115]],
    [ "Mountain Parls Electric",[-105.8012354, 40.241703900000005]],
    [ "Colburn Street Substation",[-71.11089716709895, 42.33161026042079]],
    [ "Dewar Street Substation",[-71.05509777051452, 42.308732677956996]],
    [ "Shaw Industries Substation",[-82.54269318431741, 33.44924035111992]],
    [ "Hawkins Street Substation",[-71.06064295000002, 42.3619741]],
    [ "Swift's Beach Tap",[-70.96261645869636, 42.22869708354017]],
    [ "Potter/Watson Substation",[-70.96762117979334, 42.23396793311518]],
    [ "East Weymouth Substation",[-70.92053867782575, 42.2201144467067]],
    [ "Grove Street Substation",[-70.97670081471391, 42.187812818738934]],
    [ "South Randolph Substation",[-71.04257059194761, 42.15451018246799]],
    [ "Eversource",[-71.11406028203898, 42.36375922219646]],
    [ "382351774",[-83.6411716048976, 41.39785538103872]],
    [ "Gibson Electric Membership Corporation",[-89.1492529339098, 36.28856101341725]],
    [ "Fatio Substation DUKE",[-81.32425633576477, 28.977256959948782]],
    [ "Duke Energy",[-81.3327846, 28.90574525]],
    [ "Debary Plant Substation",[-81.33443306872718, 28.904919171627068]],
    [ "382412269",[-81.25663572506019, 28.94435375792988]],
    [ "382412281",[-81.22015416765115, 28.956803327850995]],
    [ "DeLand Substation",[-81.32559420000001, 29.0327296]],
    [ "West Deland Substation DUKE",[-81.37218460482633, 29.014922107184557]],
    [ "Buffalo Power Substation",[-93.86850798759997, 45.1806377952969]],
    [ "East Beverly Substation",[-70.8497963143612, 42.56427418710146]],
    [ "Electric Avenue Substation",[-71.15477626949281, 42.357217969871115]],
    [ "Litchfield Street Substation",[-71.74549216029315, 42.508475315180036]],
    [ "Perry Street Substation",[-71.30201360211309, 42.638577114053135]],
    [ "Watertown Substation",[-71.17925675359184, 42.36514875283391]],
    [ "East Longmeadow Substation",[-72.50664084415948, 42.06265535229198]],
    [ "Norwell Substation",[-70.80226652968496, 42.17783606180396]],
    [ "Scituate Substation",[-70.7613975729518, 42.19795219955548]],
    [ "Water Street Substation",[-70.83141770753481, 42.10151718104142]],
    [ "East Dracut Substation",[-71.25250740000001, 42.669501450000006]],
    [ "East Cambridge Substation",[-71.0805187531618, 42.36288142327371]],
    [ "Fort Gaines Substation",[-85.04736871073592, 31.61512021944495]],
    [ "382630065",[-88.87142052450507, 36.5030551886298]],
    [ "Altamont Substation",[-73.99570709834883, 42.70991531196405]],
    [ "Curry Road Substation",[-73.93259586900844, 42.76144866868931]],
    [ "Ashfield Substation",[-72.79115808250745, 42.53763683952624]],
    [ "Plainfield Substation",[-72.91346180865806, 42.522130419726906]],
    [ "Silver Lake Substation",[-73.23922815097774, 42.453090966342494]],
    [ "382666388",[-73.65383495, 42.18523355]],
    [ "382666391",[-73.65318807434925, 42.18283525495891]],
    [ "Craryville Substation",[-73.59041980658643, 42.175071824549015]],
    [ "382685962",[-88.87914635, 36.523553150000005]],
    [ "382687509",[-73.72973597021489, 42.67720243160576]],
    [ "382687510",[-73.83566261220506, 42.69213649216765]],
    [ "382731253",[-96.0694550095462, 35.78138616888116]],
    [ "West Milton Substation",[-73.95459944999999, 43.037388150000005]],
    [ "382765262",[-80.41101248777983, 36.090051138569656]],
    [ "Bristow",[-96.38173141349169, 35.81544441974241]],
    [ "Quaker Oats Substation",[-81.49463725, 28.24905220000001]],
    [ "Kissimmee Utility Authority",[-81.4344112611967, 28.27817346365537]],
    [ "Duke Energy",[-81.59071519945584, 28.18487825433104]],
    [ "Kissimmee Utility Authority",[-81.4326097, 28.232002549999994]],
    [ "Kissimmee Utility Authority",[-81.44870528649327, 28.299607476259617]],
    [ "Kissimmee Utility Authority",[-81.41857746703849, 28.328593737157888]],
    [ "Kissimmee Utility Authority",[-81.3745414, 28.307490599999994]],
    [ "Colquitt Substation",[-84.73086378751127, 31.16577705556636]],
    [ "382897859",[-81.641457004438, 28.21453789101144]],
    [ "382908216",[-84.64601508456298, 30.387923496906254]],
    [ "Lake Talquin Tap Substation",[-84.61816801942612, 30.392268094922073]],
    [ "Tarver Substation",[-82.91850578045822, 30.699595986048653]],
    [ "Duke Energy",[-81.82581400000002, 27.870104250000004]],
    [ "382908224",[-84.37285637751678, 30.43515226143948]],
    [ "Fort Meade Substation DUKE",[-81.8184873505795, 27.748800778956483]],
    [ "Homeland Substation",[-81.82103162521636, 27.823316607229053]],
    [ "Homerville Substation",[-82.75592067413729, 31.042996412597127]],
    [ "Wrights Chapel Substation",[-83.0688269, 30.6660624]],
    [ "Hines Plant Substation",[-81.87030661167893, 27.79090332615884]],
    [ "382946795",[-81.59922215913906, 27.90998482936443]],
    [ "382946796",[-81.78419797507355, 27.912505545083825]],
    [ "Duke Energy",[-81.60757999765828, 27.961299466706432]],
    [ "East Lake Wales Substation",[-81.53793535378954, 27.925652639375496]],
    [ "382951249",[-81.61266277519442, 28.091955805776006]],
    [ "Cypresswood Substation",[-81.63248139999999, 28.012230600000002]],
    [ "Haines City Substation",[-81.62145291503305, 28.10624679709201]],
    [ "French Landing Substation",[-83.43976995201115, 42.21463007981781]],
    [ "383029744",[-71.39446710534796, 42.07735156772268]],
    [ "383029746",[-71.33344530007149, 41.998506809525985]],
    [ "Hyde Park Substation",[-71.12060228952993, 42.27353212306173]],
    [ "Cleary-Flood Substation",[-71.10549830197476, 41.8653163431072]],
    [ "Fisher Road Substation",[-71.03166259999999, 41.5921851]],
    [ "Swansea Substation",[-71.21045825, 41.749059550000005]],
    [ "Goethals Substation",[-74.19615879221973, 40.617053699438]],
    [ "Academy Substation",[-73.91914222546768, 40.86002019934832]],
    [ "Cherry Street Substation",[-73.99067788013525, 40.711363163429354]],
    [ "Fox Hill Substation",[-74.07760542758035, 40.610410956674905]],
    [ "Fresh Kills Substation",[-74.19696751706722, 40.58924547160744]],
    [ "Gowanus Substation",[-74.00268823757453, 40.66207809738683]],
    [ "Hudson Avenue Substation",[-73.98181828300761, 40.70392993679375]],
    [ "Tremont Substation",[-73.86374223246283, 40.84252148664434]],
    [ "Bruckner Substation",[-73.91117174437412, 40.79921240234848]],
    [ "Cedar Street Substation",[-73.78033738704485, 40.91505481003234]],
    [ "Corona Substation",[-73.86219637401362, 40.74021075530975]],
    [ "Harrison Substation",[-73.74022130856032, 40.98214137540355]],
    [ "Hell Gate Substation",[-73.90995210617666, 40.79911685806348]],
    [ "Plymouth Substation",[-73.98342903015262, 40.703986637997914]],
    [ "Newton Highlands Substation",[-71.21167458455467, 42.317248212471895]],
    [ "Enterprise Park Substation",[-93.41890827668503, 45.219220119952446]],
    [ "Everglades City Substation",[-81.38510488920477, 25.866066524182717]],
    [ "Fred H. Smith Substation",[-81.71293454599909, 25.926642872737187]],
    [ "Marco Substation",[-81.72357528867246, 25.95959606302182]],
    [ "Naples Substation",[-81.79154888926803, 26.15250951636768]],
    [ "Pine Ridge Substation",[-81.78699506724347, 26.24378143691997]],
    [ "Solana Substation",[-81.79273045457757, 26.19804860815563]],
    [ "Terry Substation",[-81.75578773796317, 26.355883421413687]],
    [ "Lebanon Substation",[-72.26661072203797, 43.63777374181375]],
    [ "Five Corners Substation",[-72.53577158004015, 42.24968454810083]],
    [ "Podick Substation",[-72.53689905575177, 42.42444528120113]],
    [ "383281305",[-87.17916668260361, 37.21265853382063]],
    [ "383281307",[-87.15251717036095, 37.24720495595245]],
    [ "Gordonville Substation",[-81.8025877461261, 27.943221367353893]],
    [ "383356867",[-81.85345678541461, 27.74877701832843]],
    [ "Duke Energy",[-81.57848276801946, 27.84343013493087]],
    [ "Dyersburg Electric System",[-89.34623680005566, 36.060790123987246]],
    [ "383386850",[-89.39819130434086, 36.031432657177696]],
    [ "Dyersburg Electric System",[-89.33723764930139, 36.05766501624319]],
    [ "Schiller Substation",[-70.7861662063725, 43.09732457800265]],
    [ "Closter Substation",[-73.9593346375887, 40.98144528879426]],
    [ "Cresskill Substation",[-73.96241573161734, 40.94928403537432]],
    [ "383474535",[-74.02965615, 41.13604065]],
    [ "New Hempstead Substation",[-74.0280858, 41.151212799999996]],
    [ "383474548",[-74.02813044999999, 41.14400355000001]],
    [ "Monsey Substation",[-74.07064091267844, 41.10582702323892]],
    [ "Hillburn Substation",[-74.16495270303471, 41.12693876863383]],
    [ "Carmel Substation",[-73.70181846270246, 41.39798777764132]],
    [ "Croton Falls Substation",[-73.66920116800085, 41.354208146477895]],
    [ "Ossining Substation",[-73.86774135082509, 41.160129574990314]],
    [ "Byram Substation",[-73.65354830000001, 41.014425450000005]],
    [ "Mianus Substation",[-73.59029089199178, 41.04294901665907]],
    [ "North Greenwich Substation",[-73.65553721459486, 41.09318429704143]],
    [ "Prospect Substation",[-73.63298845919721, 41.020983987205376]],
    [ "Floral Park Substation",[-73.70695178578858, 40.73733787778822]],
    [ "Flushing Substation",[-73.83610457405213, 40.76432030175257]],
    [ "Glen Oaks Substation",[-73.71714675224177, 40.7437634579963]],
    [ "Hillcrest Substation",[-73.8044052028153, 40.72426102459567]],
    [ "Hollis Substation",[-73.75487916467547, 40.713359265707616]],
    [ "Howard Beach Substation",[-73.84001460406013, 40.66286096790266]],
    [ "383557382",[-112.26753952892385, 33.436164556771494]],
    [ "Meckesville Substation",[-75.5471601156381, 41.00718576878158]],
    [ "Duke Energy",[-80.39836970166861, 36.04248076263552]],
    [ "146th Avenue Substation",[-73.75463207199081, 40.65992500062796]],
    [ "151st Avenue Substation",[-73.8550554163276, 40.66686022154312]],
    [ "160th Avenue Substation",[-73.8475984, 40.6565902]],
    [ "253rd Place Substation",[-73.73522805, 40.65670495]],
    [ "Alley Park Substation",[-73.7614847, 40.74372330000001]],
    [ "Aqueduct Substation",[-73.82035330000001, 40.67020320000001]],
    [ "Auburndale Substation",[-73.79932332880006, 40.776528922676995]],
    [ "Beechhurst Substation",[-73.79532702137571, 40.785512636317925]],
    [ "Brinkerhoff Substation",[-73.7880071, 40.694660850000005]],
    [ "Causeway Substation",[-73.84184228386343, 40.778872894657894]],
    [ "Cedar Manor Substation",[-73.78515475574724, 40.68897028730811]],
    [ "Centerville Substation",[-73.83642526033934, 40.67459517288365]],
    [ "Chisholm Substation",[-73.85090965000002, 40.7842067]],
    [ "Clearview Substation",[-73.78057746458143, 40.777060698658524]],
    [ "Creedmoor Substation",[-73.72519349961213, 40.734040748997366]],
    [ "Cunningham Substation",[-73.78404700000002, 40.7279568]],
    [ "Douglaston Substation",[-73.74229745, 40.765242099999995]],
    [ "Montefiore Substation",[-73.75084532165401, 40.68385015384643]],
    [ "North Hills Substation",[-73.73738491726304, 40.74865488061241]],
    [ "Coldwater Substation",[-112.36271815962823, 33.44939177435142]],
    [ "Consolidated Edison",[-73.79062065, 40.675857]],
    [ "Avenue N Substation",[-73.93035985, 40.61849815]],
    [ "Cambria Substation",[-73.74675339151035, 40.696533730007]],
    [ "Clifton Substation",[-74.07144475000001, 40.619703750000006]],
    [ "East 179th Street Substation",[-73.89416267312058, 40.84962337412812]],
    [ "East 83rd Street Substation",[-73.9023814705945, 40.62886797912504]],
    [ "Lefferts Substation",[-73.81910024176123, 40.67659911718784]],
    [ "Livonia Avenue Substation",[-73.88909827127375, 40.665730839581066]],
    [ "Mill Avenue Substation",[-73.91334025, 40.6145372]],
    [ "Oakland Substation",[-73.76205791914666, 40.74790310259336]],
    [ "Parkchester Substation",[-73.86337136686763, 40.84205320312339]],
    [ "Parkway Substation",[-73.72755653914855, 40.740315226636795]],
    [ "Rockaway Substation",[-73.8054379522459, 40.67532846806308]],
    [ "Rosedale Substation",[-73.7367947, 40.66798715000001]],
    [ "Springfield Substation",[-73.76087766720642, 40.67900470718269]],
    [ "Sutphin Substation",[-73.7954698821595, 40.68902315516172]],
    [ "Union Substation",[-73.75846187514797, 40.73351070074306]],
    [ "Whitestone Substation",[-73.81209841424949, 40.788769397996965]],
    [ "Woodhaven Substation",[-73.84395699999999, 40.689826249999996]],
    [ "Consolidated Edison",[-74.1523631, 40.6258112]],
    [ "Consolidated Edison",[-74.10930368667458, 40.644852755854366]],
    [ "Clove Lakes Substation",[-74.11751278700898, 40.61374507681242]],
    [ "Dongan Hills Substation",[-74.0852500159503, 40.58883575659218]],
    [ "Howland Hook Substation",[-74.18220745129263, 40.641255300904064]],
    [ "Naughton Substation",[-74.09449122804384, 40.58481179690839]],
    [ "Odin Substation",[-74.12058165, 40.57583015]],
    [ "Port Richmond Substation",[-74.13038878286423, 40.638959049368445]],
    [ "Seaside Substation",[-74.08242271473495, 40.58201854203029]],
    [ "Silver Lake Substation",[-74.08645763452596, 40.63214496387739]],
    [ "Wadsworth Substation",[-74.06649527951393, 40.60552069536874]],
    [ "Westerleigh Substation",[-74.1312517, 40.62794499999999]],
    [ "Cape North Substation",[-82.02308313328696, 26.639137960338935]],
    [ "Corbett Substation",[-81.9243184, 26.697413249999997]],
    [ "Southern California Edison",[-118.14299206762726, 33.87422639522582]],
    [ "Southern California Edison",[-118.23232549520597, 33.95652578600207]],
    [ "Southern California Edison",[-118.38460766495245, 33.89922201437844]],
    [ "Fruitland Substation",[-118.22668309536128, 33.99600157830163]],
    [ "Cudahy Substation",[-118.19423448993767, 33.963635982862705]],
    [ "383713485",[-81.81092425188251, 27.54544887303083]],
    [ "Lake Placid Substation",[-81.34718988507278, 27.267767252740157]],
    [ "Arcadia Substation",[-81.85950763090374, 27.21909231091639]],
    [ "Point Street Substation",[-71.40588672258406, 41.816746870072706]],
    [ "Southern California Edison",[-118.08224314071308, 33.96424198430635]],
    [ "Gallatin Substation",[-118.11137839701222, 33.96153931223081]],
    [ "Santa Fe Springs Substation",[-118.05862555, 33.94802455]],
    [ "Friendly Hills Substation",[-118.00667580440356, 33.94800358591104]],
    [ "Stewart Substation",[-118.14053515000002, 33.94004339999999]],
    [ "Proctor & Gamble Substation",[-82.00047859115756, 33.3906960284794]],
    [ "383831747",[-111.80613470397651, 33.391892450459046]],
    [ "Yorba Substation",[-117.80741423915299, 33.85817116262833]],
    [ "Southern California Edison",[-117.86969949563621, 33.81265972150902]],
    [ "La Veta Substation",[-117.85213725000003, 33.76675575]],
    [ "Southern California Edison",[-117.83208938455972, 33.88027122635384]],
    [ "383858075",[-81.98358212527918, 33.38498789305724]],
    [ "Seville Substation",[-83.39938488219569, 41.946767916247005]],
    [ "Kentucky Utilities Company",[-87.45112625, 37.2343484]],
    [ "Kentucky Utilities Company",[-87.44940343010286, 37.20299293576965]],
    [ "383896120",[-88.25162403099263, 37.263284952095674]],
    [ "383896121",[-88.25070969081098, 37.2630724801459]],
    [ "Tennessee Valley Authority",[-88.2199632310266, 37.022303288782844]],
    [ "383898426",[-88.26887129834641, 37.015714166033945]],
    [ "383898619",[-88.24013203500378, 37.106111121671155]],
    [ "383932654",[-78.1977564640106, 36.4838466765808]],
    [ "Bogle Substation",[-111.70403820228182, 33.259032956792666]],
    [ "Toledo Transmission Substation",[-92.56133119622467, 42.03641106126592]],
    [ "Southern California Edison",[-117.8836985320926, 33.71313756513053]],
    [ "Daniel Boone Substation",[-87.50771876078093, 37.17887462442202]],
    [ "Kentucky Utilities Company",[-88.13002256701428, 37.06550374865023]],
    [ "384079813",[-89.35851703031548, 36.02533459162039]],
    [ "Forked Deer Electric Cooperative",[-89.31064112526794, 35.937341697164705]],
    [ "Forked Deer Electric Cooperative",[-89.45046694999999, 35.92478995]],
    [ "384088268",[-89.403485, 35.858362]],
    [ "Covington Electric System",[-89.61389138740326, 35.61991901624136]],
    [ "Covington Electric System",[-89.6171084646439, 35.61858761618057]],
    [ "384124443",[-86.74442430158818, 34.650032910428834]],
    [ "Huntsville Utilities",[-86.72262440049064, 34.66202201630593]],
    [ "Huntsville Utilities",[-86.68053475, 34.70073620000001]],
    [ "Southern California Edison",[-118.03721863193405, 33.752465865064956]],
    [ "Southern California Edison",[-118.01218480000001, 33.7722358]],
    [ "Georgia Power",[-81.95727562789575, 33.32832688748054]],
    [ "Southern California Edison",[-117.90697867308305, 33.656971908361186]],
    [ "MacArthur Substation",[-117.86604923941026, 33.6386324578193]],
    [ "Tamanend Substation",[-76.02417436600385, 40.83735831943543]],
    [ "384271792",[-101.94555055, 34.981806649999996]],
    [ "Hanover Substation",[-72.82553701663402, 41.52667195536113]],
    [ "384283642",[-111.6416246307848, 45.82996678416502]],
    [ "Bullis Substation",[-118.20608947972715, 33.900117122789815]],
    [ "Fernwood Substation",[-118.21543992136431, 33.928276950991325]],
    [ "Lynwood Substation",[-118.21275730074504, 33.9271164666456]],
    [ "Madison Substation",[-86.74026286561543, 34.69026195969209]],
    [ "384611072",[-89.25635281472788, 36.12415920297122]],
    [ "384611073",[-89.2555086, 36.12348825]],
    [ "Marathon Pipe Line LLC",[-89.43037095000001, 35.552445750000004]],
    [ "Humboldt Utilities",[-88.88538355000001, 35.83859945000001]],
    [ "384653389",[-109.5197274, 46.34447239999999]],
    [ "384656970",[-110.70973183601411, 45.36177283240114]],
    [ "Sharp Substation",[-117.91072525437272, 33.84817257732855]],
    [ "Southwest Substation",[-117.9331030811523, 33.808181001951844]],
    [ "Vermont Substation",[-117.9024826, 33.826725950000004]],
    [ "384676804",[-86.75277846628032, 34.635679823394106]],
    [ "Slater Substation",[-118.01718881312622, 33.69230381951991]],
    [ "Wave Substation",[-117.99748467764496, 33.66548406699523]],
    [ "Southern California Edison",[-118.07252541593616, 33.80956192677576]],
    [ "384764667",[-108.62689977519747, 45.752022606354515]],
    [ "Walnut Substation",[-117.94990076720154, 34.0081629400299]],
    [ "Calhoun Creek Switching Station",[-89.29348877671877, 33.89626874376193]],
    [ "Paris Utility Authority",[-88.12943035000002, 36.42458445]],
    [ "384879691",[-86.74972044999998, 34.66073050000001]],
    [ "Huntsville Utilities",[-86.74765728729206, 34.66953325139834]],
    [ "384908568",[-81.66201061839594, 27.210583335430083]],
    [ "Edison Substation",[-81.90019544990163, 26.557686984735817]],
    [ "Gladiolus Substation",[-81.90147706211309, 26.510441929736196]],
    [ "Jetport Substation",[-81.73502903290273, 26.567358706514373]],
    [ "McCarthy Substation",[-80.94339579259747, 26.690085974654732]],
    [ "Poplar Substation",[-83.74309776108718, 42.376102532808325]],
    [ "Southern California Edison",[-117.9557109013616, 34.0474817664115]],
    [ "Southern California Edison",[-117.98732081169723, 34.133745233824115]],
    [ "Southern California Edison",[-117.93308509950644, 34.11377721867295]],
    [ "Cortez Substation",[-117.87969014259687, 34.09251492512269]],
    [ "Industry Substation",[-117.99082299999999, 34.0505447]],
    [ "Merced Substation",[-117.90727006046973, 34.0497237251536]],
    [ "Puente Substation",[-117.93029866473701, 34.0089834721922]],
    [ "Ballston Substation",[-77.09846864384691, 38.884997597387]],
    [ "385046756",[-89.65830785000001, 39.175281749999996]],
    [ "385046772",[-89.77052488512237, 39.479852241541]],
    [ "385053473",[-96.35036411541819, 43.396667752403935]],
    [ "385053474",[-96.44739412874712, 43.396842772853205]],
    [ "385053476",[-96.44751148650401, 43.46167130599274]],
    [ "Georgia Power",[-84.59234698993535, 33.742179837073266]],
    [ "Brazosport Substation",[-95.43263940132577, 29.009653452060668]],
    [ "Crossroads Substation",[-105.01962371431186, 40.446966946266095]],
    [ "Florida Power & Light",[-82.15834015000002, 27.09017165]],
    [ "385347872",[-95.39982515822126, 40.182596861400235]],
    [ "385364130",[-95.54756122448515, 40.52657670742196]],
    [ "385477904",[-103.78445270000003, 32.505008000000004]],
    [ "Dum Jon Substation",[-82.08166995541023, 33.45204799949345]],
    [ "385487194",[-116.87284313148692, 33.9224378734718]],
    [ "385490163",[-86.32335005000002, 33.597973550000006]],
    [ "385496493",[-94.40289943867936, 40.18423136788335]],
    [ "Associated Electric Cooperative",[-94.48266665352213, 40.09949685080845]],
    [ "Huntsville Utilities",[-86.57152712430785, 34.79916220070579]],
    [ "385588492",[-76.87969427609913, 35.8056977059253]],
    [ "385626158",[-93.77351264999999, 40.43183245000001]],
    [ "385626166",[-93.53284958362948, 40.52748678304412]],
    [ "385626180",[-93.6819258700172, 40.38277151505683]],
    [ "385653927",[-81.96128952160122, 33.53519153229026]],
    [ "Unionville Substation",[-93.02176491546494, 40.45901320985159]],
    [ "385655653",[-93.23493662456109, 40.36278253920323]],
    [ "385702794",[-82.02514593539897, 33.52283487304066]],
    [ "Wilson Substation",[-81.65118025961472, 41.49066164182103]],
    [ "Four County EMC",[-78.66240486749831, 34.583971850716296]],
    [ "385760845",[-96.63435847926613, 43.60295998404655]],
    [ "385775962",[-89.10709495, 32.79668355000001]],
    [ "Frisco Substation",[-80.2620703770794, 40.845102474476214]],
    [ "385795657",[-105.79529230528456, 46.41211957281828]],
    [ "Adair Substation",[-92.59817384710554, 40.14877253523392]],
    [ "Blue Springs South Substation",[-94.26130570955115, 38.97450577056131]],
    [ "385885844",[-93.56491597824851, 38.75626983000004]],
    [ "Warrensburg East Substation",[-93.7030460338059, 38.7662409833134]],
    [ "385932954",[-92.09043549999998, 40.453602350000004]],
    [ "Keokuk West Substation",[-91.42532096611808, 40.40503996869499]],
    [ "386103527",[-91.39664252783376, 39.87338142665855]],
    [ "386103530",[-91.44054652681814, 39.84209920739867]],
    [ "386190998",[-85.11940112635986, 33.290738331779366]],
    [ "386201299",[-110.5681911, 34.432386050000005]],
    [ "Buffalo Ridge Substation",[-96.25929701514, 44.23928460745192]],
    [ "Lake Yankton Substation",[-95.87732050303241, 44.251717346206945]],
    [ "West Mesa Switching Station",[-106.72668394024257, 35.113007050180116]],
    [ "386240541",[-91.8123791071853, 39.77379737530261]],
    [ "386274856",[-91.48140368941665, 39.62156094106263]],
    [ "Whirlwind Substation",[-118.43717697252822, 34.858030298119424]],
    [ "386385863",[-89.6559495513576, 38.19880341547186]],
    [ "Yankee Substation",[-96.4224597071515, 44.28205231964814]],
    [ "Ivanhoe 115/69 Substation",[-96.25244801456051, 44.38585487509967]],
    [ "PPM Energy MinnDakota Collector Switching Station",[-96.42220122600006, 44.28366084164536]],
    [ "Dobson Water - Power Facility",[-111.88079172203435, 33.39345723544543]],
    [ "386481710",[-91.12473702451537, 39.28567130569477]],
    [ "Ameren",[-91.22734905764739, 39.352751796364394]],
    [ "Anaconda Sub",[-107.93963845653987, 35.25775100644944]],
    [ "Penncoyd Substation",[-75.20771159407533, 40.01429681844704]],
    [ "386572501",[-90.84291237389452, 38.99131505336601]],
    [ "386572502",[-90.86575451778153, 39.067728548996065]],
    [ "386572506",[-90.89601179600737, 39.14232083406681]],
    [ "386638285",[-111.10399764673701, 33.303163255225165]],
    [ "McGregor Phillips Substation",[-97.39469205551752, 31.417520065237795]],
    [ "386707650",[-110.01462678934054, 34.17913021047986]],
    [ "Big Creek Substation",[-91.01133307324504, 38.87810927348883]],
    [ "386759877",[-111.49825487165737, 35.77924075216026]],
    [ "386759883",[-111.44221765, 35.806953199999995]],
    [ "Sam Switching Station",[-97.01807522611493, 31.89746496266379]],
    [ "Barry Substation",[-96.66586335380865, 32.14909942370793]],
    [ "386809437",[-96.59693992868202, 32.4090761592274]],
    [ "386811002",[-96.57935582462403, 32.39940124454708]],
    [ "386811004",[-96.53959826339735, 32.37465619483951]],
    [ "386811654",[-96.47744136520944, 32.336406811945984]],
    [ "386813038",[-96.736807961805, 32.456052373691165]],
    [ "Fenton Substation",[-95.9229641934126, 43.881738023535874]],
    [ "386836591",[-96.24132531973306, 32.40410165276498]],
    [ "386836603",[-96.33269834195079, 32.6693373385374]],
    [ "386836604",[-96.33159470726383, 32.670301805033894]],
    [ "386838369",[-96.39799631291119, 32.66730270593675]],
    [ "386839420",[-96.45234081641995, 32.64248581469446]],
    [ "386839422",[-96.46636027828126, 32.648000026315174]],
    [ "386866058",[-92.56675543202273, 39.50639614820241]],
    [ "386866063",[-92.47804162445279, 39.29040286489144]],
    [ "Moberly Substation",[-92.48354888133403, 39.42449131624175]],
    [ "386866070",[-92.45001743582314, 39.435839193324824]],
    [ "386871485",[-96.15987017260771, 32.81659396912741]],
    [ "386886303",[-92.1135929, 39.37071815]],
    [ "386886304",[-92.13328634999999, 39.28334825000001]],
    [ "386886306",[-92.29933994276946, 39.24679164086873]],
    [ "386887068",[-96.0856024997418, 32.90435455093381]],
    [ "386971363",[-87.57807529977221, 40.71699696374413]],
    [ "387016487",[-109.80377940000002, 48.51094050000001]],
    [ "387028773",[-92.26031197534336, 39.019038042173285]],
    [ "Country Club Delivery Point",[-77.31901651568296, 38.60889425869974]],
    [ "387252675",[-92.25576121165996, 38.865384516619535]],
    [ "Albion Substation",[-82.11869293178684, 33.31548295421656]],
    [ "Eastover Road Station",[-73.6292116215127, 42.79972240574191]],
    [ "15th Street Substation",[-81.98474565346916, 33.4800530239267]],
    [ "387287684",[-79.7683313248159, 40.54600836677637]],
    [ "387339368",[-106.53513168323816, 35.000322375546126]],
    [ "Fort Gordon Hospital Substation",[-82.12801288641121, 33.431242316189014]],
    [ "Fort Gordon Substation",[-82.14704624721712, 33.42739890062812]],
    [ "Buckley Road Substation",[-83.40701557364979, 41.174583681215225]],
    [ "387444420",[-82.81222844999998, 27.8519176]],
    [ "Rocky Mountain Power",[-111.90180455934097, 40.766326607020595]],
    [ "387463454",[-91.53761194417902, 38.808421024970514]],
    [ "FIXME Substation",[-91.92529882783789, 38.86252475337238]],
    [ "387463459",[-91.538611593934, 38.808038424509085]],
    [ "Alder Substation",[-79.71356246253968, 40.44862996098695]],
    [ "387599710",[-80.71717263204012, 35.363729064487195]],
    [ "387612075",[-78.33198207856638, 35.02007654854012]],
    [ "Hassan Substation",[-93.5481837, 45.218001300000005]],
    [ "387623442",[-94.15654270080536, 45.46081854722971]],
    [ "Round Rock Southeast Substation",[-97.64504505000002, 30.485315250000003]],
    [ "387941423",[-106.56042085000001, 35.0407706]],
    [ "387946574",[-78.06434542571266, 34.19231375764124]],
    [ "388096776",[-106.46210386514927, 34.98143328615029]],
    [ "Georgia Power",[-83.7975443162235, 34.28684481445211]],
    [ "SDC Containers Substation",[-83.14187493718214, 41.360607667279766]],
    [ "L.R. Pinnacle Substation",[-92.48785344049037, 34.81168220713205]],
    [ "Parkwood Substation",[-79.31061343638584, 40.61784373818483]],
    [ "388164874",[-92.17899679999998, 39.82342925]],
    [ "388249147",[-92.01374802506268, 39.71846099062291]],
    [ "388298465",[-91.69654478842942, 39.62060042518787]],
    [ "388298466",[-91.80978164999999, 39.673309350000004]],
    [ "Washington-St. Tammany Electric Cooperative",[-89.72863735729901, 30.262891934329915]],
    [ "Washington-St. Tammany Electric Cooperative",[-89.73726898581819, 30.285065481429914]],
    [ "388331038",[-92.17467014063563, 40.06213427522035]],
    [ "388331039",[-91.98930087770769, 39.98998614153013]],
    [ "388331040",[-92.17363750000001, 40.0608079]],
    [ "388331043",[-91.7948948751785, 40.09329014455571]],
    [ "388331044",[-91.79566919999998, 40.09345145]],
    [ "388339865",[-91.81107968651287, 39.77394677470706]],
    [ "388360826",[-92.49955029282123, 39.76632352491446]],
    [ "388360829",[-92.4249058, 39.584283049999996]],
    [ "Gahanna Substation",[-82.82875446805504, 40.045666844835104]],
    [ "388593837",[-115.04623840122213, 36.24577337448695]],
    [ "388593841",[-115.04466506827498, 36.24528308216056]],
    [ "Kiwanis Substation",[-111.71391971454428, 33.59866071878094]],
    [ "388719259",[-92.90444969999999, 39.6870204]],
    [ "388751972",[-93.04786566453912, 39.51048849572676]],
    [ "Bland Substation #22 CLAY",[-82.50649662866992, 29.9502367441991]],
    [ "Anna Street Substation",[-99.52078045000002, 27.5241906]],
    [ "Brunswick Substation",[-93.15561209139508, 39.433970273068944]],
    [ "388878296",[-86.04445825135075, 35.37721594163339]],
    [ "388925782",[-93.0444237703361, 40.03743011116247]],
    [ "388925783",[-92.9065470249014, 39.978717445956526]],
    [ "388925784",[-92.86793813282924, 39.84736882459141]],
    [ "388925786",[-93.1692057834016, 39.95828874989044]],
    [ "388925789",[-93.03174464445945, 40.23270337667932]],
    [ "388925790",[-92.93136758690507, 39.99006502460541]],
    [ "388925791",[-93.29153583521823, 40.12915987554169]],
    [ "388925792",[-93.15221963850445, 40.20534387522659]],
    [ "388925793",[-93.12729813031824, 40.216588327506635]],
    [ "Laird Substation",[-123.53766118498261, 48.10071251394834]],
    [ "388950768",[-93.3093822252194, 39.623130945214335]],
    [ "388950778",[-93.17448205000001, 39.77654705]],
    [ "388950853",[-78.94370101129502, 34.908912877402784]],
    [ "Silverado Substation",[-123.76778204999998, 48.13121255]],
    [ "388982494",[-78.91877206964313, 35.717522399122764]],
    [ "Lincoln Substation",[-77.20308918429404, 39.84565546483513]],
    [ "Canby 115kV Substation",[-96.22802274716834, 44.740259547099335]],
    [ "389113795",[-93.23117393232727, 39.11406608439726]],
    [ "Malta Bend Substation",[-93.38924179327051, 39.19763018183006]],
    [ "Norton Substation",[-93.13469326450975, 39.18468616771909]],
    [ "389126018",[-124.26936133656736, 48.0720780658888]],
    [ "389136581",[-93.59263565209898, 39.54387386600767]],
    [ "Bovine Substation",[-118.06410587464595, 33.85073121670174]],
    [ "Marion Substation",[-118.02721313727453, 33.81766159096271]],
    [ "Southern California Edison",[-118.16437663068442, 33.81921458718877]],
    [ "Southern California Edison",[-118.2251136006153, 33.76553531757759]],
    [ "389174034",[-118.23334315000001, 33.8213787]],
    [ "HarborGen Substation",[-118.22734795679766, 33.77882116522287]],
    [ "Carrollton Substation",[-93.47478189310024, 39.38863307856026]],
    [ "389218535",[-93.70291915848334, 39.42248672445053]],
    [ "Amador Substation",[-118.02656792613992, 34.07145801661777]],
    [ "Hoyt Substation",[-118.04885915716092, 34.052151374945325]],
    [ "Rush Substation",[-118.08117410819901, 34.05100936531749]],
    [ "389279005",[-111.72457891190788, 33.74075911517344]],
    [ "Maurer Lake Substation",[-94.2276600888581, 39.32562761693158]],
    [ "389292934",[-94.15075341159275, 39.29716891989298]],
    [ "Sekiu Substation",[-124.3080727269261, 48.26256975402468]],
    [ "Crest Substation",[-118.37317897298995, 33.7668912528249]],
    [ "Marymount Substation",[-118.38896746812202, 33.747024135558675]],
    [ "Walteria Substation",[-118.32346784999999, 33.79194945]],
    [ "389398664",[-97.20861338498975, 44.39796620198727]],
    [ "Willbridge Substation",[-122.75046359181987, 45.56638437249709]],
    [ "389449584",[-92.44327225, 38.9451293]],
    [ "389455598",[-92.34382534999999, 39.0646321]],
    [ "389460884",[-92.62841752584829, 39.311774696577125]],
    [ "Grand Point Substation",[-77.60547479274815, 39.938561068908285]],
    [ "389612188",[-93.65390114999998, 40.18430359999999]],
    [ "389612191",[-93.42276243302344, 40.16912749688539]],
    [ "389612196",[-93.65877419288982, 40.08209986525965]],
    [ "389612199",[-93.66247354649225, 40.00013504440628]],
    [ "389625736",[-84.62435656030516, 37.17288593835369]],
    [ "389641640",[-91.46079995000001, 39.45189105]],
    [ "Georgia Power",[-84.40892376965208, 33.74231818287214]],
    [ "Southern California Edison",[-117.76972450901705, 34.08995376789182]],
    [ "Marsh Lake Substation",[-96.19998185000003, 45.23886315]],
    [ "Odessa Substation",[-96.322769542771, 45.26150617128351]],
    [ "389792824",[-96.4068105, 45.2703249]],
    [ "Appleton Substation",[-96.04201519955652, 45.20927911630324]],
    [ "389825761",[-92.12455052841078, 38.655467160368296]],
    [ "389825762",[-92.10643332545044, 38.690603588599856]],
    [ "389825763",[-92.24807658468752, 38.79887587467106]],
    [ "389825765",[-92.23874002506763, 38.78599239235687]],
    [ "389825766",[-92.37295845909061, 38.869103875478075]],
    [ "389825772",[-92.10440688170529, 38.7298393909399]],
    [ "Carlisle Substation",[-77.17985027042688, 40.20192676933583]],
    [ "Narod Substation",[-117.67491915000002, 34.0468233]],
    [ "389936078",[-92.18566468404902, 38.612398648938964]],
    [ "389936079",[-92.09429560000001, 38.68329094999999]],
    [ "389953566",[-91.4390228237496, 38.99456640519475]],
    [ "Louisburg Junction Substation",[-96.0623348, 45.11023070000001]],
    [ "Canby Substation",[-96.19486421294513, 44.77640852522082]],
    [ "FIXME Substation",[-92.73506608441355, 38.95752722481972]],
    [ "390085622",[-93.04997780000001, 39.067748900000005]],
    [ "390085625",[-92.9359332871131, 38.86152980631814]],
    [ "North Huntsville Substation",[-86.59014226671883, 34.74888769056709]],
    [ "390144719",[-93.15040979999999, 38.69423995]],
    [ "390144724",[-92.96613183863421, 38.604530610734834]],
    [ "Nevada Nineteenth Street Substation",[-93.43342431553023, 42.01717452534045]],
    [ "FIXME Substation",[-93.26040184999998, 38.702276299999994]],
    [ "390341994",[-151.03679979189656, 61.186123717687295]],
    [ "390351838",[-92.6469321958471, 38.80466671994779]],
    [ "Port Angeles Light",[-123.41852121732707, 48.11126810121318]],
    [ "390434483",[-118.4382504724885, 33.95075186099247]],
    [ "Tahiti Substation",[-118.43713976836513, 33.97766103614191]],
    [ "Vergennes Substation",[-73.2493308974285, 44.17902910413159]],
    [ "Felton Substation",[-118.36205212564337, 33.915792037957026]],
    [ "Inglewood Substation",[-118.35806267434694, 33.965618926125515]],
    [ "Lawndale Substation",[-118.35790708914556, 33.8949227926812]],
    [ "Southern California Edison",[-118.42595642178722, 33.93163407696681]],
    [ "Sepulveda Substation",[-118.39680872508144, 33.91900842900063]],
    [ "390518564",[-80.59071545, 35.87317265]],
    [ "390518569",[-80.59129347324576, 35.87292311464217]],
    [ "Industrial Park Substation",[-94.77875954104016, 39.724667981728246]],
    [ "Industrial Park Substation",[-94.78089815967432, 39.725083502860116]],
    [ "Edgewater Substation",[-79.38409985937662, 40.306978186060746]],
    [ "390669118",[-85.44225145, 31.26962655]],
    [ "Four County EMC",[-78.01804590465792, 34.62145342972589]],
    [ "390747985",[-94.42026784953322, 39.9012604575674]],
    [ "Southern Natural Gas",[-86.25378762560395, 33.60291010886675]],
    [ "390836555",[-94.80821903622035, 39.44284978107788]],
    [ "Walnut Substation",[-95.12656593895392, 39.58805317839389]],
    [ "Hawley Substation",[-83.56683220603144, 41.63553625129707]],
    [ "Gluek Substation",[-95.49318779999996, 45.02069984999999]],
    [ "Maynard Distribution Substation",[-95.49335812491046, 44.94890316127665]],
    [ "Maynard Transmission Substation",[-95.49430261382435, 44.94766507532092]],
    [ "390918534",[-79.44630778770257, 39.26921005256386]],
    [ "390949774",[-77.98278153103276, 35.51673755532077]],
    [ "391023957",[-86.26263819132137, 39.916612247446956]],
    [ "391023959",[-86.30655667037999, 39.91046167496309]],
    [ "391028196",[-86.24483373204573, 39.90342536245161]],
    [ "391063456",[-87.49617127481993, 39.40407372282375]],
    [ "391064251",[-87.49601167956232, 39.40244167392074]],
    [ "DISTRIBUTING STATION 94",[-118.36848593928187, 34.0757901193005]],
    [ "NW Electric Power Cooperative",[-94.33806933826519, 39.52705477949092]],
    [ "391078996",[-94.31622870890614, 39.53597133352087]],
    [ "391078998",[-94.50165302496703, 39.4263007581821]],
    [ "391078999",[-94.33211720823144, 39.39226092549524]],
    [ "391079001",[-94.43313173027367, 39.54686629599043]],
    [ "NW Electric Power Cooperative",[-94.3224590365516, 39.60967156476538]],
    [ "391113709",[-81.66968148102669, 39.26604848104165]],
    [ "391114457",[-94.93350229203656, 40.09235902479216]],
    [ "Monongahela Power Company",[-81.62041165, 39.244684]],
    [ "Monongahela Power Company",[-81.68170921840563, 39.25075860222]],
    [ "Corner Substation",[-81.65685602507091, 39.30714782108197]],
    [ "391157539",[-88.73321347489774, 43.63659233918808]],
    [ "391157540",[-88.73297068211129, 43.63705634733001]],
    [ "391213343",[-87.22391909654411, 38.628258018686424]],
    [ "391224419",[-94.55461442460772, 40.03875494212606]],
    [ "391266256",[-94.80659413457978, 39.340111832231315]],
    [ "391272890",[-85.99218863300268, 39.671560385409286]],
    [ "391272891",[-86.0487482380868, 39.7281604271199]],
    [ "391277592",[-86.05058378531146, 39.76847840328415]],
    [ "Anita Substation",[-118.03851582188088, 34.105679183654296]],
    [ "Arcadia Substation",[-118.02578997138923, 34.1439803824318]],
    [ "Cranberry Substation",[-80.09839513072754, 40.72296668585411]],
    [ "College Substation",[-118.10862472489578, 33.78409310333531]],
    [ "Carmenita Substation",[-118.0471974256104, 33.90318814270548]],
    [ "Telegraph Substation",[-117.99202782388389, 33.93228784400363]],
    [ "Southern California Edison",[-117.93374863148198, 33.92516527414148]],
    [ "Cook Substation",[-94.83572805243304, 39.80699236138534]],
    [ "Fernway Substation",[-80.11900780150722, 40.69856796230882]],
    [ "391484102",[-95.2394381294028, 40.174852503392316]],
    [ "Evergy",[-95.23368008061509, 40.14652199070243]],
    [ "Southern California Edison",[-118.37660642729722, 33.827799969281095]],
    [ "391540192",[-118.35503906503469, 33.808364297402484]],
    [ "Ditmar Substation",[-118.37803568958859, 33.87225172319376]],
    [ "Victoria Substation",[-118.37422728614331, 33.85885474555651]],
    [ "391623143",[-96.04448810022146, 46.29025545359872]],
    [ "391623158",[-96.05099067454385, 46.26826897511204]],
    [ "Fergus Substation",[-96.13216558743453, 46.31164171700946]],
    [ "391632433",[-92.28513772908607, 38.568897093754444]],
    [ "Cornuta Substation",[-118.12040978818193, 33.883749867505024]],
    [ "Sweet Springs Substation",[-93.41894857499786, 38.97277720454686]],
    [ "Lafayette Substation",[-117.93567860433453, 33.63528768946262]],
    [ "Southern California Edison",[-117.95719097471765, 33.737161918912676]],
    [ "Southern California Edison",[-117.99995402286854, 33.74496927513827]],
    [ "Bolsa Substation",[-118.0333525897193, 33.7306095251633]],
    [ "391801656",[-77.08413036396931, 35.127512066493075]],
    [ "391817994",[-106.54969234981233, 35.03197550032211]],
    [ "E Ave Substation",[-91.71337195643028, 41.97780364867231]],
    [ "San Gabriel Substation",[-118.10011502382528, 34.09868043133868]],
    [ "Francis Substation",[-117.72308846255471, 34.04183528061127]],
    [ "Wallenpaupack Substation",[-75.13228649134527, 41.46846401355504]],
    [ "Cusetta Substation",[-84.77639335, 32.2966933]],
    [ "Windsor Substation",[-93.52104136060737, 38.51968395168641]],
    [ "392157460",[-93.67829739999998, 38.54426504999999]],
    [ "392158718",[-84.76232759617004, 41.2977727612081]],
    [ "392159305",[-84.7775791, 41.2850042]],
    [ "392182148",[-80.7025853409574, 38.65506923456188]],
    [ "West Tracy Substation",[-119.52911958731846, 39.561384495749195]],
    [ "FIXME Substation",[-93.03211615, 38.410707349999996]],
    [ "Marine Substation",[-118.46564835000001, 34.006907999999996]],
    [ "Portage Substation",[-78.66201961063933, 40.39664345650656]],
    [ "Barnett Substation",[-92.60648099999999, 38.37949704999999]],
    [ "Eldon Substation",[-92.60734053243156, 38.36624823927406]],
    [ "Logan Substation",[-81.99697041284324, 37.848135230942525]],
    [ "392521058",[-96.03743842316526, 46.73250102493494]],
    [ "Tamarac Substation",[-96.11626388433447, 46.65910195331368]],
    [ "392521060",[-96.00516214479092, 46.731831137385385]],
    [ "East Freemont Substation",[-83.1055743407872, 41.34144467674291]],
    [ "Pioneer Substation",[-118.08119495868907, 33.915518075072065]],
    [ "392616947",[-85.93825205000002, 39.24719565]],
    [ "392616948",[-85.96302483231834, 39.34409286135461]],
    [ "392616949",[-85.96337915404183, 39.344572105223634]],
    [ "392799745",[-90.18583389721785, 36.38730746626795]],
    [ "392854855",[-84.50904357589518, 38.041066323430755]],
    [ "Kentucky Utilities Company",[-84.50445385, 38.07442155]],
    [ "392889688",[-93.47412093596986, 46.13162882288151]],
    [ "392891434",[-81.7456867, 37.901105099999995]],
    [ "Sub 6/17",[-106.53818266896805, 34.99754965356014]],
    [ "393007567",[-92.66508091676502, 38.16154270276629]],
    [ "Brookfield Renewable US",[-74.97672019999997, 44.64190239999999]],
    [ "Union Correctional Institution North CLAY",[-82.18811362503084, 30.07328910596964]],
    [ "Fort Worth Pipe Substation",[-95.4118833928059, 30.31875387084619]],
    [ "Rose Hollow Substation",[-91.45769349999998, 41.68619854999999]],
    [ "393082626",[-92.68060477541574, 38.04896189604814]],
    [ "Southern California Edison",[-118.30725837498242, 33.9225984567416]],
    [ "Brighton Substation",[-118.3119293, 33.902486100000004]],
    [ "Torrance Substation",[-118.34434831347086, 33.8298499352488]],
    [ "Nola Substation",[-118.27639646166504, 33.85950380054869]],
    [ "Flat Rock Substation",[-97.59769942440369, 32.87051151750771]],
    [ "Ameren",[-92.61518713713205, 38.20322481386541]],
    [ "393276373",[-92.61337897312595, 38.18586918233534]],
    [ "393305955",[-92.3004882, 38.06836835]],
    [ "Rhodhiss Tie Substation",[-81.43590220680878, 35.77708893778981]],
    [ "Weyerhaeuser Substation #3",[-122.95890421598844, 44.05642135109532]],
    [ "Fremont Substation",[-118.26449364505964, 33.89457045214812]],
    [ "Distributing Station 95",[-118.42097268479638, 33.99031434110081]],
    [ "Receiving Station D - Fairfax",[-118.37105432647617, 34.038102540672426]],
    [ "Sony Substation",[-118.40238760231331, 34.014683547399855]],
    [ "Azusa Substation",[-117.91098406267194, 34.13599691923254]],
    [ "FirstEnergy",[-81.81031533546692, 41.307096242596494]],
    [ "FirstEnergy",[-81.85170131883228, 41.330668533580194]],
    [ "Lark Ellen Substation",[-117.9265091881632, 34.08708226316521]],
    [ "San Dimas Substation",[-117.80782883962286, 34.11713370924759]],
    [ "Dierdorff Rd",[-85.80400391124476, 41.552766124862714]],
    [ "Glades Electric Co-Op",[-81.11239744999999, 26.695464899999994]],
    [ "Florida Power & Light",[-80.64971042503524, 26.70638434125224]],
    [ "394249993",[-94.19572524610888, 37.88958197647166]],
    [ "394317689",[-119.56994334251638, 39.46445201907298]],
    [ "Barnard Substation",[-83.9677489255107, 43.44661704776668]],
    [ "Union Substation",[-81.6587324510374, 34.72386715553151]],
    [ "394517934",[-91.2178753, 38.1961102]],
    [ "394517938",[-91.39710579999999, 38.0854025]],
    [ "394517939",[-91.27314791655782, 38.166756243215524]],
    [ "394517940",[-91.39752447565735, 38.08640749470501]],
    [ "394524417",[-90.25695770000002, 35.93904214999999]],
    [ "394530258",[-112.85505075, 32.37122]],
    [ "394530260",[-112.74080710886322, 32.27468551939802]],
    [ "Gramercy Switching Station",[-118.31284640000001, 33.9464846]],
    [ "Yukon Substation",[-118.33457925043894, 33.91889289324853]],
    [ "Receiving Station H",[-118.34748899473202, 34.08814029425312]],
    [ "Sawtelle Substation",[-118.4521929573293, 34.0474408323989]],
    [ "394763282",[-93.70457097466314, 37.875265004751455]],
    [ "Osceola Substation",[-93.67471035755923, 38.03930620155837]],
    [ "KAMO Power",[-93.67410393959382, 38.03837651888401]],
    [ "Southern California Edison",[-118.3916120250915, 33.90163209751935]],
    [ "394895302",[-118.4019296567466, 33.902713231852786]],
    [ "Chevmain Substation",[-118.39789129291523, 33.903519425057]],
    [ "Fair Road Substation",[-81.7599498096466, 32.40125413086353]],
    [ "394947069",[-93.85532719999999, 38.31029105]],
    [ "394947071",[-94.01453732376955, 38.19021345388054]],
    [ "394947075",[-94.01312669999999, 38.356871500000004]],
    [ "Parkers Prairie Substation",[-95.37130703934982, 46.16627597006407]],
    [ "394986244",[-85.00661666407761, 41.63610403202616]],
    [ "395019806",[-116.988349, 33.77232195]],
    [ "Ameren",[-90.65272787362622, 38.75529730063368]],
    [ "395205416",[-117.17504177494673, 33.92320150757994]],
    [ "395206271",[-117.17251512336345, 33.94699290250407]],
    [ "395210776",[-82.73411826773199, 35.84947650912993]],
    [ "Ramona Substation",[-118.13008390000002, 34.069914100000005]],
    [ "395317989",[-93.32175354411744, 38.75220605207448]],
    [ "395317991",[-93.27083577772022, 38.75577412603142]],
    [ "Southern California Edison",[-117.83519928568936, 34.02223044026214]],
    [ "Southern California Edison",[-117.88769311017549, 33.99709347451626]],
    [ "395426253",[-94.47384357101755, 39.338230171029814]],
    [ "Archibald Substation",[-117.59272235, 33.997777799999994]],
    [ "395459406",[-93.99771803520797, 38.160510474451634]],
    [ "395476346",[-93.65058389999999, 38.21836139999999]],
    [ "Mt. Hulda Substation",[-93.15562395, 38.3380047]],
    [ "FIXME Substation",[-93.2621728699596, 38.29985057133193]],
    [ "Southern California Edison",[-117.5377708802354, 33.84501886247447]],
    [ "Pedley Substation",[-117.52269863131055, 33.95892106591355]],
    [ "Iconium Substation",[-93.54752207527501, 38.11098479266656]],
    [ "395637536",[-93.46167665, 38.238970300000005]],
    [ "Fountain Substation",[-83.4427297588854, 42.379007633782294]],
    [ "Rand Substation",[-83.44477407118305, 42.37554940790189]],
    [ "Sun River Electric Cooperative",[-111.57986020000001, 48.0303241]],
    [ "395692602",[-111.84329205682363, 48.03798950234169]],
    [ "FIXME Substation",[-92.95864475713506, 38.27475917529346]],
    [ "FIXME Substation",[-92.84593632943572, 38.24075255808066]],
    [ "395695686",[-92.80703448853656, 38.38710865979457]],
    [ "Corvallis",[-114.1036289040235, 46.312401567347685]],
    [ "395796189",[-91.20304443126776, 38.1796783633071]],
    [ "Halma Substation",[-96.69290717515825, 48.5867700579384]],
    [ "395848831",[-107.08179857962982, 45.82027157689028]],
    [ "Marfa Alamito Creek Substation",[-104.00884579999997, 30.316293049999995]],
    [ "Marfa Substation",[-104.01679938782273, 30.312318064165787]],
    [ "395916697",[-91.0509201098942, 38.13178416373866]],
    [ "395926767",[-80.78469654683495, 32.14081644770364]],
    [ "395927378",[-80.76210696462925, 32.15750661896684]],
    [ "McNeil Substation",[-118.34727929566469, 34.172137532442704]],
    [ "City of Burbank",[-118.34733289318426, 34.185971001063265]],
    [ "Anderson Substation",[-96.20304089540673, 48.10735205018267]],
    [ "396052059",[-96.7821484873483, 48.195569630853065]],
    [ "Andover Substation",[-70.69230610000001, 44.63876315]],
    [ "396225129",[-97.01989482509317, 48.195444296444514]],
    [ "Hauto Substation",[-75.89775928397775, 40.843984949198145]],
    [ "Greenwood Substation",[-75.96043328274577, 40.82081905541274]],
    [ "Ameren Missouri",[-90.44521528568299, 38.2160493894903]],
    [ "396489937",[-80.82884823281366, 35.7788183007466]],
    [ "396489940",[-80.82925030000001, 35.7791538]],
    [ "396490305",[-80.85297330000002, 35.799366400000004]],
    [ "396490306",[-80.87444074999999, 35.809067649999996]],
    [ "396490307",[-80.85436982761998, 35.79609129755319]],
    [ "396491757",[-80.77755801489765, 35.734848428320774]],
    [ "396491758",[-80.6880793200126, 35.73059680605293]],
    [ "396551416",[-109.63716450634732, 45.28173676699485]],
    [ "396551417",[-109.59990144830368, 45.34890752199645]],
    [ "396592952",[-80.3011651624257, 36.07708983457207]],
    [ "396592953",[-80.3300850306512, 36.11782674187145]],
    [ "396592954",[-80.33426781107782, 36.0737790743578]],
    [ "396595750",[-80.25199322079891, 36.155783775228535]],
    [ "396595759",[-80.26470922708435, 36.133662453849915]],
    [ "396595760",[-80.2576082584653, 36.13840861861713]],
    [ "396601396",[-80.36069697470134, 36.18029557815132]],
    [ "396601409",[-80.38915590052252, 36.13866882624928]],
    [ "396601410",[-80.32504316617, 36.23530221483267]],
    [ "396622097",[-79.7864871, 36.4584817]],
    [ "396623554",[-74.75168409571067, 44.97999945963259]],
    [ "396642037",[-79.99307415000001, 36.1343278]],
    [ "396642038",[-80.10170063841424, 36.09609737407731]],
    [ "Colington Substation",[-75.67392474359666, 36.006103624741556]],
    [ "396814989",[-79.258390452744, 36.086125862127986]],
    [ "396814991",[-79.10242639166242, 36.063849378593794]],
    [ "396814994",[-79.33191968925277, 36.09621664123953]],
    [ "396816163",[-79.06194338385522, 35.951738557146335]],
    [ "396816539",[-79.02957052196156, 35.900214154890236]],
    [ "396816540",[-79.00231293880314, 35.8909525843506]],
    [ "396818345",[-78.85226392497428, 35.90425991662551]],
    [ "396818346",[-78.83703067452953, 35.91043975500575]],
    [ "396818347",[-78.85200245, 35.917624599999996]],
    [ "IBM",[-78.8555636498997, 35.9143629833443]],
    [ "396818350",[-78.83166494995984, 35.91346094996441]],
    [ "396818354",[-78.87003199747164, 35.93076403489511]],
    [ "Limon Wind Energy Center I Substation",[-103.65641409501623, 39.37523986561514]],
    [ "Limon Wind Energy Center II Substation",[-103.59487053065114, 39.359485519046515]],
    [ "Firehouse Substation",[-117.62345185862549, 34.0418580635088]],
    [ "Ontario Substation",[-117.6456867291979, 34.05652331604924]],
    [ "North Farmington Substation",[-90.42337342008929, 37.803474709387146]],
    [ "Ivanhoe Substation",[-80.8129616371961, 41.25879455460276]],
    [ "396992712",[-121.79086468321813, 38.01445932913134]],
    [ "Georgia Power",[-83.88366040000001, 32.98826054999999]],
    [ "397005847",[-78.89046778923091, 35.86193498002698]],
    [ "Rivermines Substation",[-90.52372318210661, 37.84341123053639]],
    [ "397150731",[-85.664210019373, 38.419555754875795]],
    [ "397185121",[-74.81421848261601, 40.86464158966623]],
    [ "397185481",[-90.7052732, 37.682185]],
    [ "397185482",[-90.70699236765391, 37.682489945130364]],
    [ "397185483",[-90.63545495632992, 37.62359058180368]],
    [ "397396831",[-102.24021596122637, 39.128891995198366]],
    [ "397523764",[-91.11400002167301, 37.716130556890484]],
    [ "397537562",[-91.34166138766525, 37.94551227474702]],
    [ "Hatch Expansion Substation",[-112.42713196198507, 37.66359538427065]],
    [ "Hatch Substation",[-112.42678818150794, 37.66435506732324]],
    [ "397558044",[-91.59700912526385, 37.6371134093582]],
    [ "397558047",[-91.49542159999999, 37.609760849999994]],
    [ "397564147",[-91.09771076225194, 37.55127347294094]],
    [ "397565659",[-102.33570518780476, 39.36098815073755]],
    [ "397568076",[-91.03100531637621, 36.994477327644205]],
    [ "Cherry Grove Switching Substation",[-122.57941047786562, 45.80081681184156]],
    [ "397588059",[-102.76128561526934, 40.66072777868424]],
    [ "397632879",[-91.60742751297089, 37.49875714135529]],
    [ "397661571",[-92.78457114511077, 37.582959690200994]],
    [ "397661572",[-92.78469506792504, 37.58380300353374]],
    [ "McLean Wind Farm Step-Up Transformer",[-89.0467435767321, 40.59002104783905]],
    [ "397701287",[-89.04355371412466, 40.48286655734858]],
    [ "397727364",[-92.52984343516549, 37.66347123258902]],
    [ "397781226",[-92.52766697791806, 37.821198673899254]],
    [ "397807284",[-93.0152601160181, 37.743845526072796]],
    [ "397807285",[-92.75222640475718, 37.99495909043417]],
    [ "397850183",[-95.05772946966472, 46.877785325942604]],
    [ "Long Lake Substation",[-95.01806658371042, 46.91867559878946]],
    [ "397869956",[-93.0895339561083, 37.52578002347781]],
    [ "Grand River Dam Authority",[-95.31095824968033, 35.85615996622404]],
    [ "Lopez Bonneville Power Substation",[-122.86511245045338, 48.492407912919234]],
    [ "Sub 9",[-75.19916838632375, 39.9704054381625]],
    [ "398189249",[-111.41074094999999, 35.8730188]],
    [ "398202772",[-93.69098247352694, 37.127853058404725]],
    [ "FIXME Substation",[-93.79657674209916, 37.39098142493312]],
    [ "Monsca Junction",[-105.88196798883469, 37.69076336486312]],
    [ "Twin Oaks",[-93.28857065, 37.135298199999994]],
    [ "69",[-105.88244432522393, 37.7063208565476]],
    [ "398353828",[-93.22673894313719, 36.975907424686575]],
    [ "Ozark Sourh",[-93.21009514880453, 36.97941254442727]],
    [ "398375371",[-93.11825632551836, 37.09285509179383]],
    [ "398416430",[-93.26020204999999, 37.4390637]],
    [ "398443381",[-92.93416425598022, 37.176857975442594]],
    [ "San Luis Solar Substation",[-105.92745246006713, 37.69445933036292]],
    [ "398449563",[-85.0722878, 41.72558085]],
    [ "398454992",[-106.00287152506694, 37.63221679555102]],
    [ "Tanners Point Terminal Station",[-76.32258232699834, 36.90581093567855]],
    [ "Jersey Central Power and Light",[-74.21492473095812, 40.08868710521477]],
    [ "398580384",[-92.09579227154677, 37.098426121327705]],
    [ "398630405",[-92.7519035492926, 37.15493071857577]],
    [ "398649329",[-112.63915800950589, 37.271108092954755]],
    [ "Alamosa Solar Switching Station",[-105.95589886335694, 37.5985369686677]],
    [ "398706836",[-112.42564465, 37.72695145]],
    [ "398740970",[-91.93028375121608, 37.30313509785892]],
    [ "398740972",[-91.66665331678168, 37.18024386652934]],
    [ "Coryell County Substation",[-97.74167455000001, 31.461944499999998]],
    [ "Sycamore Substation",[-97.71997759999998, 31.475301849999997]],
    [ "398807151",[-76.83983680229501, 39.460027230245025]],
    [ "398808031",[-109.8762806984678, 45.39006936237724]],
    [ "398847129",[-91.14525733995185, 37.35951397505229]],
    [ "398847130",[-91.07971363399471, 37.406135321700646]],
    [ "398926835",[-90.68916472421161, 37.1436892587609]],
    [ "398926837",[-90.72099358056249, 37.08038581167277]],
    [ "398963018",[-90.67670878500277, 37.35866129444258]],
    [ "398986640",[-112.6303803385767, 38.279912410854045]],
    [ "Cameron Substation",[-112.5960195899518, 38.28038726031488]],
    [ "South Substation",[-96.31105719999998, 30.5915943]],
    [ "South Switching Station",[-96.31103328861181, 30.593724276100197]],
    [ "398996046",[-112.60111351274412, 38.549186369363525]],
    [ "398996047",[-112.92385827598801, 38.219724157499094]],
    [ "399004902",[-112.25440094324946, 38.58956133686169]],
    [ "Brooklawn Substation",[-112.63943722441492, 38.282580525275954]],
    [ "Alamosa Terminal",[-105.89498492746785, 37.45900452647407]],
    [ "Front Substation",[-83.37485085000002, 41.90595135]],
    [ "Moran Substation",[-89.66205219996415, 37.050306916091024]],
    [ "Oran Substation",[-89.63864593831255, 37.072198702896536]],
    [ "Cape Girardeau Substation",[-89.56577885687881, 37.25663711568631]],
    [ "Viaduct Substation",[-89.56389385758455, 37.25681265553683]],
    [ "Stoddard Substation",[-89.83045845351789, 36.864941615686604]],
    [ "Erie Substation",[-83.48935408118415, 41.80981551316468]],
    [ "399257489",[-90.79343666096966, 36.65771562528795]],
    [ "Village Green Substation",[-123.04008853669329, 43.798814524188565]],
    [ "399351486",[-93.02651779999998, 36.7547068]],
    [ "Enon Substation",[-80.40828207305807, 39.97106674126163]],
    [ "399440371",[-92.59349467908271, 36.91516343435682]],
    [ "399440373",[-92.66556642613376, 36.97602469599353]],
    [ "399468954",[-93.88952991162547, 36.74363762478744]],
    [ "Orlando Utilities Commission",[-81.2897298248836, 28.249299394223485]],
    [ "Eridu Substation",[-83.75900167153891, 30.323389122143208]],
    [ "Colorado Springs Utilities",[-104.83759867154167, 38.96842608171386]],
    [ "Colorado Springs Utilities",[-104.83791095211315, 38.96796912874066]],
    [ "South Waterfront Substation",[-74.05437885225005, 40.71620332540069]],
    [ "Center City Substation",[-76.88030062683367, 40.26755417863681]],
    [ "M105",[-99.8935371504775, 38.079772347139546]],
    [ "400189095",[-91.83088371465671, 39.147436341432396]],
    [ "400208389",[-92.2203784, 36.9865253]],
    [ "400238663",[-93.30727748619702, 37.21924730198473]],
    [ "Georgia Power",[-81.08215771342381, 32.07553970434482]],
    [ "Saline Substation",[-83.79081728223234, 42.17174369466565]],
    [ "SRP Greer Substation",[-111.72658657517694, 33.364224640077786]],
    [ "Village of Lake Placid",[-73.97584584582604, 44.27413092199677]],
    [ "400530991",[-104.8497369021976, 39.070970643905284]],
    [ "Maple Grove Substation",[-86.2628511612672, 43.199881678049735]],
    [ "TP8 Substation CLAY",[-82.17086113108739, 29.891326006112195]],
    [ "Mason Substation",[-84.44366858513472, 42.57445682753131]],
    [ "400849584",[-116.61571004596658, 33.93715273925298]],
    [ "400902560",[-104.5626591617704, 39.01223899571843]],
    [ "Peyton Substation",[-104.4779842879306, 39.02600340090379]],
    [ "Hazlehurst Primary Substation",[-82.57991167823617, 31.87195166239109]],
    [ "Monterey Substation",[-85.82542043741716, 42.696779401507705]],
    [ "Scott Lake Substation",[-86.08487970660364, 42.47468332339972]],
    [ "Hazelwood Substation",[-85.63684747821877, 42.45950838049979]],
    [ "South Substation",[-83.47852786095069, 45.034931018606784]],
    [ "Pohatcong Substation",[-74.87203228785198, 40.84026940885051]],
    [ "401322915",[-104.36636145556113, 39.01039269826029]],
    [ "401335904",[-104.60046891018843, 38.239004749040554]],
    [ "401335923",[-104.60191044224683, 38.22865430183254]],
    [ "401463939",[-92.332578739929, 38.2964075160503]],
    [ "401470847",[-91.89688764999998, 39.1519122]],
    [ "401478880",[-91.89907177534371, 39.116402840455244]],
    [ "Ameren",[-92.22078202270627, 38.59353875771314]],
    [ "Enon Substation",[-90.8150818915984, 38.86897128037863]],
    [ "Wolfe Run Substation",[-80.20922136539706, 40.680888005282384]],
    [ "Woodbury Substation",[-86.09198259418625, 35.82599535108064]],
    [ "401601999",[-90.87622407402495, 38.748221669810185]],
    [ "401602003",[-91.1421314, 38.72989615]],
    [ "401604120",[-91.1785357073237, 38.991618147993876]],
    [ "401607140",[-91.01125783937755, 38.98803048002918]],
    [ "Chamois",[-91.75515818537214, 38.68367376935309]],
    [ "Apache Substation",[-83.14848880835389, 42.56129338107607]],
    [ "401845968",[-93.76465370573011, 47.32451081185658]],
    [ "401845974",[-93.76169839477777, 47.324302224784695]],
    [ "401845977",[-93.76165664479716, 47.324143430815475]],
    [ "Georgia Power",[-84.50931627138748, 33.99179323945903]],
    [ "Blackwells Substation",[-84.5160517371251, 34.019568829763216]],
    [ "402015852",[-82.3648474836704, 29.61234839885708]],
    [ "Agency Street Substation",[-91.14659554697378, 40.81559851061716]],
    [ "South Padre Island Substation",[-97.17457071451449, 26.138336681595792]],
    [ "402186561",[-80.83989959596366, 35.41550677554936]],
    [ "402206303",[-80.67492618527889, 35.534425753839365]],
    [ "402206305",[-80.5831420488055, 35.559600596686174]],
    [ "402206465",[-80.5820521902423, 35.55911199707143]],
    [ "402216809",[-76.13020074563272, 36.91321385761475]],
    [ "Colorado River Substation",[-114.81722174002023, 33.580609469519175]],
    [ "Shiner Substation",[-97.19220225647139, 29.444407215875202]],
    [ "Virginia Electric and Power Company",[-76.13185328355164, 36.899759128533475]],
    [ "DISTRIBUTING STATION 38",[-118.30559395133616, 34.05304432650581]],
    [ "Virginia Electric and Power Company",[-76.04144658322033, 36.8804231003251]],
    [ "Virginia Electric and Power Company",[-76.07036480000001, 36.91009245]],
    [ "402492750",[-80.79394157753447, 35.570417889015]],
    [ "Princess Anne Substation",[-76.07693325768439, 36.770773940645576]],
    [ "402505425",[-80.6139965384906, 35.50765574567527]],
    [ "402535978",[-80.52452810199095, 35.60836656652506]],
    [ "Allens Falls",[-74.86045550709521, 44.660243997163334]],
    [ "Pendleton Substation",[-75.99843041831903, 36.79039825047331]],
    [ "Webberville Solar Substation",[-97.50233725439008, 30.24315553908013]],
    [ "Greenwich Substation",[-76.17500038515828, 36.8417174002004]],
    [ "Woodstock Substation",[-76.19386063035749, 36.81289002492083]],
    [ "Duke Power",[-80.58713061396097, 36.30189537957777]],
    [ "Green Run Substation",[-76.10725303878493, 36.797915454691044]],
    [ "Birdneck Substation",[-76.00161149432122, 36.82149222562048]],
    [ "403007298",[-83.17984469556502, 43.32543338186736]],
    [ "Watkins Substation",[-85.20280223625369, 42.2644104719879]],
    [ "Sonoma Substation",[-85.22734351061163, 42.26771558639495]],
    [ "PPL",[-76.77958575807644, 40.238509225154516]],
    [ "Oberlin Substation",[-76.81770195, 40.24301754999999]],
    [ "Shiner Substation",[-97.15465358712648, 29.432652244232415]],
    [ "Pacific Gas and Electric Company",[-122.0614112961262, 38.01815534823085]],
    [ "403213659",[-108.74923365544248, 45.66049998593451]],
    [ "403233212",[-84.59333913517322, 41.139279331751545]],
    [ "403395978",[-84.47588075119211, 38.04270232256618]],
    [ "403403472",[-84.5114822, 38.134006850000006]],
    [ "Billings City",[-108.50077855458836, 45.78165421090766]],
    [ "Kiesel Substation",[-83.91976611495406, 43.616322274944814]],
    [ "East Loop Substation",[-110.8385371334589, 32.229382965062015]],
    [ "American Electric Power",[-96.10851230806206, 36.13147338664355]],
    [ "403655317",[-76.00617987734685, 36.80003353162288]],
    [ "West Loop Substation",[-87.65381270840999, 41.90110394471114]],
    [ "403685445",[-80.84874232965286, 35.440922523084886]],
    [ "403685450",[-80.85670415860601, 35.483417312121]],
    [ "City Water, Light & Power",[-89.62588527682844, 39.84149468982042]],
    [ "403722880",[-80.84510703843014, 35.216850804623945]],
    [ "City Water, Light & Power",[-89.69436480000002, 39.787791000000006]],
    [ "403762726",[-84.50025411726334, 37.97420235355934]],
    [ "403810294",[-96.20411335168914, 41.276928011664076]],
    [ "403885728",[-76.02442581430891, 36.80839526721774]],
    [ "City Water, Light & Power",[-89.68581418060802, 39.82470041108734]],
    [ "Leon Substation",[-93.7508382950035, 40.740135950690444]],
    [ "Statenville Substation",[-83.02872328998012, 30.706517225641207]],
    [ "403899662",[-80.82080354999998, 35.34382459999999]],
    [ "403905973",[-112.00462050834811, 41.50309777113318]],
    [ "Saxonburg Substation",[-79.79178505072383, 40.76383680997297]],
    [ "Green Valley Substation",[-111.02950488254481, 31.871212881410003]],
    [ "Frank E Ratts Station",[-87.26985686932991, 38.51907907756473]],
    [ "Pierce Substation",[-101.8350041006376, 35.20184260753406]],
    [ "North Belding Substation",[-85.25374496090696, 43.118886750111486]],
    [ "Bricker Substation",[-85.2540429407581, 43.11815914939406]],
    [ "Rogue River Substation",[-85.57459849114139, 43.1076869203325]],
    [ "Osceola West Substation",[-93.78910728336949, 41.028740266703856]],
    [ "Derby Substation",[-86.48080136168942, 42.00087181546372]],
    [ "404792651",[-84.49563155000001, 38.0687664]],
    [ "404831928",[-87.84190837983634, 42.65239941378245]],
    [ "Bruce Crossing",[-89.12676044999999, 46.53407745]],
    [ "C.T.L. #5",[-83.12454056844517, 42.50250407408738]],
    [ "Chestnut Substation",[-83.11140256798936, 42.5103042939399]],
    [ "Keystone Heights Substation",[-82.4723011116309, 29.569045395606633]],
    [ "Kentucky Utilities Company",[-84.42106147722691, 38.01332832573191]],
    [ "405037682",[-109.23562416211325, 45.183246372768515]],
    [ "405037683",[-109.15522962523978, 45.34836970727938]],
    [ "Edison Substation",[-86.46633175410976, 41.699781329911225]],
    [ "North Andrews Switching Station",[-102.56083536236632, 32.35757430161682]],
    [ "East Leipsic Substation",[-83.96486270351149, 41.112026925654945]],
    [ "Yellow Creek Substation",[-83.96193303324836, 41.11728087525153]],
    [ "405280578",[-79.37371264665636, 36.025303356681626]],
    [ "405343528",[-109.55245337472905, 45.289884092186]],
    [ "Huntsville Utilities",[-86.58104200221872, 34.69387065507293]],
    [ "405352588",[-109.59813497440608, 45.29129920533881]],
    [ "405374381",[-80.8181803, 32.23818690000001]],
    [ "Tustenuggee Substation #?? CLAY",[-82.63179939950798, 30.10533011874579]],
    [ "Kentucky Utilities Company",[-84.52673799784819, 38.05211988502192]],
    [ "East End Fostoria Substation",[-83.40498168312644, 41.15836512672178]],
    [ "405490223",[-79.88835588537873, 39.00259055441586]],
    [ "405536518",[-83.12754812999592, 41.14415925660318]],
    [ "Grand Island Substation",[-121.59035581608975, 38.231571094374154]],
    [ "405727865",[-111.29430069350053, 47.48131247482838]],
    [ "405740482",[-86.35892629956318, 41.967102351339655]],
    [ "405852655",[-89.66719423038626, 39.744245815828656]],
    [ "405874590",[-81.28249410129864, 33.35250353333245]],
    [ "405921435",[-110.8787899, 32.2556229]],
    [ "McPherson Road Substation",[-84.41216236198761, 34.01916916672276]],
    [ "Billings Eastside",[-108.48960640000001, 45.792725399999995]],
    [ "Kentucky Utilities Company",[-84.43540308796469, 37.99019170521321]],
    [ "Fayette Substation",[-84.46405621243278, 37.962681830246446]],
    [ "Marathon Pipe Line LLC",[-84.49583826358327, 37.94707868773874]],
    [ "Washington Substation",[-80.239356618422, 40.166814779200095]],
    [ "Finkl Steel Substation",[-87.5883614752088, 41.724052549583426]],
    [ "406510102",[-85.63397251712736, 33.26370827739954]],
    [ "406510578",[-85.63476984842852, 33.26421179578738]],
    [ "406512040",[-85.62244292017085, 33.252744314271716]],
    [ "Locust Substation",[-75.12530117930477, 39.93367154646401]],
    [ "Loyalhanna Substation",[-79.37896298028751, 40.30112244582022]],
    [ "VASCO Substation",[-79.37165591934397, 40.333332927951524]],
    [ "Social Hall Substation",[-79.32190775597408, 40.44184477968132]],
    [ "Saginaw Street Substation",[-83.6926779328787, 43.019680929115566]],
    [ "Webberville Substation",[-84.17916663093887, 42.66251744745126]],
    [ "Suncrest Substation",[-116.68306626112211, 32.80876588197792]],
    [ "Swanton Substation",[-83.88635163095262, 41.5899105931963]],
    [ "Saint Rita Substation",[-87.81353314135464, 42.780583830917934]],
    [ "Missouri Flat Switching Station",[-120.82467966067546, 38.69463024486821]],
    [ "Apple Hill Substation",[-120.6771749184564, 38.739612747448064]],
    [ "Distributing Station 19",[-118.26510200733752, 34.01894834469708]],
    [ "DISTRIBUTING STATION 14",[-118.29074951336601, 33.95391039964537]],
    [ "DISTRIBUTING STATION 13",[-118.29993339391162, 34.0239468571807]],
    [ "Distributing Station 18",[-118.32994652926853, 33.98516764117935]],
    [ "407385684",[-94.3662290146619, 39.38674728175442]],
    [ "407408972",[-76.18336805898561, 36.886168822429205]],
    [ "Alpena Substation",[-83.50204314965748, 45.094450103959005]],
    [ "Northeast Substation",[-83.4317336, 45.133749900000005]],
    [ "Gennrich Substation",[-83.43282373402745, 45.08257101924767]],
    [ "407422000",[-76.17556211198318, 36.85183898690587]],
    [ "Lufkin East Substation",[-94.68892572995973, 31.332979098918543]],
    [ "407438753",[-87.77319025892659, 43.74154409429044]],
    [ "407438760",[-87.77383989161245, 43.74154785779322]],
    [ "Lufkin Pershing Tap",[-94.74565391974626, 31.29197390313602]],
    [ "Virginia Beach Substation",[-76.01739477147005, 36.849992798066566]],
    [ "Advance Distribution",[-85.07118620000001, 45.2052086]],
    [ "Cole Creek Substation",[-83.88134468084618, 43.047785559127924]],
    [ "DISTRIBUTING STATION 32",[-118.27247099473627, 34.0047133828496]],
    [ "Dean Road Substation",[-83.78283433600517, 42.72868939489146]],
    [ "Virginia Electric and Power Company",[-76.29849173577304, 36.87417506852151]],
    [ "Georgia Power",[-84.5275356917919, 33.97395145446111]],
    [ "408049913",[-85.79352584247515, 39.548654775218026]],
    [ "Central Substation",[-83.43899346386985, 45.07187811821027]],
    [ "Alger Substation",[-84.06811518336602, 44.152762125182065]],
    [ "408397233",[-85.77552240215397, 39.52914487057411]],
    [ "408441914",[-88.24728185000001, 30.643819899999997]],
    [ "408676102",[-78.9135710468506, 36.038913972695624]],
    [ "City Water, Light & Power",[-89.70559532497685, 39.79974275631164]],
    [ "Parishville",[-74.82531816542244, 44.630134072014854]],
    [ "Georgia Pacific Substation",[-81.49425350685875, 34.21807507102591]],
    [ "409118588",[-81.48725082660114, 34.23772938881521]],
    [ "409181809",[-82.27201635474262, 41.4069153491511]],
    [ "Blue Water Substation",[-84.53566815, 43.00782665]],
    [ "Bingham Substation",[-84.53699363990822, 43.00789158685133]],
    [ "Potterville Substation",[-84.73471002492127, 42.62681569218936]],
    [ "John C. Eisinger Substation",[-80.83133269211021, 27.288043025233854]],
    [ "DISTRIBUTING STATION 53",[-118.3346558870193, 34.01161916165704]],
    [ "Distributing Station 4",[-118.28225071303277, 33.989980263360536]],
    [ "Lake Leann Substation",[-84.4452693, 42.05209110000001]],
    [ "409708643",[-109.5452205665628, 45.703941651605746]],
    [ "409708644",[-109.54578438367871, 45.703858875908836]],
    [ "409744469",[-81.85252920146996, 38.40743179586567]],
    [ "410181948",[-83.90208974130708, 40.67371014862425]],
    [ "410402210",[-119.10321850412093, 46.28064414759068]],
    [ "410478608",[-84.9512193948753, 34.73400593167474]],
    [ "410503448",[-84.96380962520416, 34.71597830759515]],
    [ "410525499",[-84.96688959397763, 34.73483715530203]],
    [ "Grandville Substation",[-85.7817019, 42.90394255]],
    [ "Pendleton Muncipal Substation",[-85.73875975, 39.99619064999999]],
    [ "Northville Substation",[-83.47827333824401, 42.4293927513082]],
    [ "Fairland Substation",[-85.87972075246921, 39.5982169567863]],
    [ "DISTRIBUTING STATION 45",[-118.30864982500034, 33.99175418315781]],
    [ "Hurst Substation",[-83.75148743202632, 42.627531457493]],
    [ "Dexter Trail Substation",[-84.25496614999443, 42.50461681666497]],
    [ "Plains Road Substation",[-84.38944252423777, 42.509962628712636]],
    [ "Grand Haven North Substation",[-86.2147247859693, 43.09527381871318]],
    [ "Distributing Station 41",[-118.28305257522698, 33.968674853185064]],
    [ "Nacogdoches Stephen F. Austin Substation",[-94.64303489337576, 31.622357824983034]],
    [ "411506695",[-105.19583258230173, 40.271587455536746]],
    [ "Bellrock",[-108.57588422502398, 45.78346109251957]],
    [ "Tamarack Substation",[-83.61130839826217, 42.51129644952561]],
    [ "Junction City Substation",[-92.73679360831449, 33.02717432053537]],
    [ "412128860",[-104.97901958915746, 39.90036904709986]],
    [ "Cedar Grove Substation",[-74.2213760722514, 40.868361190101595]],
    [ "Landstown Substation",[-76.09243281033349, 36.77131715782772]],
    [ "412973780",[-106.2888997756117, 32.39863690806894]],
    [ "Virginia Electric and Power Company",[-76.28391123993376, 36.81453887935044]],
    [ "Lockhart Substation",[-82.42573378546888, 37.15387509944621]],
    [ "Tuckers Substation",[-81.74384047671286, 26.85826926577586]],
    [ "Hercules Substation",[-81.75780965183345, 26.80706207243426]],
    [ "Farnsworth Substation #25",[-82.49534243540147, 29.650261724729212]],
    [ "Timberlee Substation",[-85.69392800000001, 44.81961529999999]],
    [ "413445217",[-120.06044722505675, 35.38217009152384]],
    [ "413445218",[-120.06041127620954, 35.38374190287609]],
    [ "413449177",[-119.92498696833162, 35.33117900231587]],
    [ "413496244",[-76.25156044217046, 36.953757193876335]],
    [ "Three Oaks Substation",[-86.60642345, 41.800422450000006]],
    [ "413697781",[-82.11551257135987, 41.40160004419563]],
    [ "DISTRIBUTING STATION 5",[-118.23184072201738, 34.0270382892867]],
    [ "Hawkins Substation",[-123.13761732729644, 44.018847310753706]],
    [ "413937731",[-109.67904203823068, 32.95016021017743]],
    [ "414047644",[-111.60661697801743, 33.34866583712695]],
    [ "North Range Substation",[-104.90693835537799, 41.12745263864294]],
    [ "414114592",[-112.58996410003084, 33.38528883957649]],
    [ "Parker Substation",[-123.19059028864265, 44.12193136535518]],
    [ "414507428",[-106.60318415201513, 35.13937902895158]],
    [ "Virginia Electric and Power Company",[-76.24850817560771, 36.863824999144356]],
    [ "DISTRIBUTING STATION 99",[-118.55739078764776, 34.07612931221427]],
    [ "Distributing Station 44",[-118.4622172101329, 33.99818505576986]],
    [ "414703487",[-82.06904211777784, 37.11396030160057]],
    [ "Clyde Substation",[-82.92396467053143, 35.537110588719926]],
    [ "Georgia Power",[-84.50222186204036, 33.92377703662733]],
    [ "MidAmerican Energy",[-95.23153817492101, 41.00775849603417]],
    [ "414832509",[-87.38018623173762, 41.61286264172915]],
    [ "414848533",[-74.13194491199322, 41.828771333360955]],
    [ "Smoky Hill Substation",[-97.61184454626003, 38.784083885894134]],
    [ "414889705",[-78.15382115792268, 33.9261622427235]],
    [ "Haywood EMC",[-83.02268272491682, 35.56401950169784]],
    [ "415122773",[-82.24510093619615, 39.056833385021946]],
    [ "Jenney Substation",[-122.24294609562735, 37.77240215458877]],
    [ "415212791",[-79.79427226235381, 35.45038147254944]],
    [ "Wattsville Substation",[-75.50198226870496, 37.93475871682249]],
    [ "Treasure Substation FPL",[-80.43598597078018, 27.337104375982268]],
    [ "Braun Substation",[-83.22850861677111, 42.379787857608385]],
    [ "Post Oak Substation",[-96.30638638351623, 30.622307251293062]],
    [ "Texas A&M University Substation",[-96.35112261658182, 30.61656097133111]],
    [ "415931373",[-82.31074954167516, 27.891795274930796]],
    [ "415935795",[-76.28854914339475, 36.75802730380114]],
    [ "415938812",[-108.62335692490143, 45.786125644706296]],
    [ "McGehee Substation",[-91.41866228378734, 33.628719130171056]],
    [ "Waldron Substation",[-94.08931838768471, 34.907565735609424]],
    [ "Southwestern Electric Power Company",[-94.07742378665075, 34.881992919423745]],
    [ "Town of Bedford",[-79.52237640738362, 37.33561497964538]],
    [ "Flint Ridge Substation",[-91.14553531370908, 40.804449200274874]],
    [ "416462950",[-84.3249116376157, 38.07823677263554]],
    [ "Five Points Substation",[-83.64011660201486, 41.50702063830135]],
    [ "Cleveland Substation",[-86.15500490256929, 43.078385318743955]],
    [ "416486398",[-75.9338822604033, 41.24306281035171]],
    [ "Onion Creek Substation",[-97.61710931128786, 30.210435390898578]],
    [ "Sand Hill Switchyard",[-97.6140846441627, 30.209664284693208]],
    [ "Federal Sqaure Substation",[-74.17465085746656, 40.726568299248505]],
    [ "NorthWestern Energy",[-114.06839643028316, 46.85721050819209]],
    [ "Northwestern Energy",[-114.02836956667558, 46.892735310529574]],
    [ "Fairfield 7th Street Substation",[-91.97221553472912, 41.00603949082097]],
    [ "Fairfield Washington Substation",[-91.97173349938598, 41.00541510438701]],
    [ "Sam Rayburn Substation",[-96.33840062535242, 30.681870614980063]],
    [ "Nall Lane Substation",[-96.34762018718015, 30.671307676701502]],
    [ "Alliant Energy",[-91.96321610772493, 41.016089753819465]],
    [ "Eureka Substation",[-85.2070154456448, 43.191374210809606]],
    [ "Derby Substation",[-85.11298720846519, 43.29167095941878]],
    [ "IBM North Substation",[-84.48935118382607, 38.07635872399598]],
    [ "Walnut Grove Substation",[-89.46068730550543, 32.589573186107785]],
    [ "Alliant Energy",[-91.98167386287307, 41.01371324747794]],
    [ "Northwestern Energy",[-114.02170741113265, 46.854087474845]],
    [ "Clare Substation",[-84.76006365000002, 43.8150504]],
    [ "Green Street Substation",[-92.41082273333134, 41.015484599812396]],
    [ "Trammel Substation",[-82.26898209403042, 37.0070311343]],
    [ "Big Spring Switching Station",[-101.43712981289707, 32.26942439959044]],
    [ "Osceola",[-88.44986038424267, 47.23051760553999]],
    [ "417766785",[-81.14691796060556, 36.19132627287015]],
    [ "Georgia Power",[-84.5094706, 34.1734688]],
    [ "Georgia Power",[-84.50879508517792, 34.17356331559764]],
    [ "418557091",[-109.94096672762149, 45.844868904015186]],
    [ "418557093",[-109.94192105420272, 45.84451532184023]],
    [ "Colonels Island Substation",[-81.54524640743696, 31.12361329089626]],
    [ "Shady Lane Substation",[-96.33562323675983, 30.63047315193047]],
    [ "418970019",[-82.40171895, 29.761699800000002]],
    [ "419134297",[-113.51502001800148, 37.112712996812036]],
    [ "419134298",[-113.51438641814032, 37.11301974658799]],
    [ "419236743",[-93.30510991988248, 37.60497212222306]],
    [ "Yards Creek Substation",[-75.03222798474286, 41.0009399725994]],
    [ "Ameren",[-90.83370552480234, 37.521288647575965]],
    [ "Campbell Estate Industrial Park (CEIP) Substation",[-158.09683099306008, 21.327630309185015]],
    [ "Ewa Nui Substation",[-158.0458472970581, 21.3721496360835]],
    [ "AES Substation",[-158.10350290009563, 21.305075778813585]],
    [ "419557656",[-93.25481903972315, 47.35879182247176]],
    [ "419557663",[-93.26984551839683, 47.456583214212344]],
    [ "419557665",[-93.21459194411916, 47.386312195747166]],
    [ "Barker Substation",[-95.64324004099552, 29.711696641685027]],
    [ "Boca Negra Substation",[-106.72718623162709, 35.16699360333052]],
    [ "Powerline Substation",[-123.10081589021077, 44.17491196844987]],
    [ "Truxton Station",[-76.02551399999999, 42.7129728]],
    [ "North Union Substation",[-79.72421875887069, 39.91389703879996]],
    [ "419821119",[-89.25676032340482, 31.259558663163197]],
    [ "Hicpochee Substation",[-81.0817874993618, 26.767562292381104]],
    [ "John Drake Substation",[-81.12844065935313, 26.704200974896974]],
    [ "Morgan Henderson Substation",[-81.33360535, 27.208920449999997]],
    [ "Ortona Substation",[-81.24674475, 26.81285425]],
    [ "Glades Electric Co-Op",[-81.12274993489355, 26.737974132030782]],
    [ "Hensley Substation",[-81.08374322673639, 26.826155027502192]],
    [ "Highlands Park Substation",[-81.34482596446739, 27.336141957279853]],
    [ "Sweatt Substation",[-80.79319509999999, 27.448377599999993]],
    [ "Uniontown Substation",[-79.70340894386726, 39.90033222086344]],
    [ "419991501",[-91.48651423864345, 40.980678525238304]],
    [ "Cannon Muskegon Substation",[-86.30366255789966, 43.20230872227157]],
    [ "420104637",[-92.64065605710567, 47.563880454436124]],
    [ "420104638",[-92.63568293513195, 47.56470128341056]],
    [ "Distributing Station 15",[-118.28538216826156, 34.0820006490864]],
    [ "Krayn Substation",[-78.69051368126789, 40.303084255256884]],
    [ "Duke Energy",[-81.44107916819661, 27.325254985368044]],
    [ "Duke Energy",[-81.4826070248358, 27.483899906284734]],
    [ "Avon Park North Substation",[-81.50311182486155, 27.615215441706294]],
    [ "Basinger Substation",[-81.02967675, 27.38976095]],
    [ "City of Clewiston Substation",[-80.94247957972937, 26.740689434964164]],
    [ "Cowbone Substation",[-80.98260920799416, 26.62318116819181]],
    [ "Dinner Lake Substation",[-81.43760786944453, 27.507249802323297]],
    [ "Josephine Substation",[-81.46096569999999, 27.3828974]],
    [ "Rossmoyne Substation",[-76.96712331550592, 40.205295696645415]],
    [ "420887368",[-92.34526845529064, 47.45542271311254]],
    [ "420956211",[-76.994518, 40.2006878]],
    [ "Hershey Substation",[-76.64579985956429, 40.28912204238201]],
    [ "East Springfield Feeder Regulating Substation",[-122.88712018967146, 44.04652027710673]],
    [ "421376682",[-79.72086994997485, 36.492021712734825]],
    [ "421575982",[-81.9590939890783, 28.037205570091576]],
    [ "Vulcan Substation",[-83.61005727042313, 41.65337916510736]],
    [ "421889199",[-95.0251724646738, 40.42022456898262]],
    [ "Swatara Substation",[-76.78722967488892, 40.22941445262029]],
    [ "Borough of Middletown Mill Street Substation",[-76.72649018724161, 40.19276528218368]],
    [ "421913736",[-94.8787898298557, 41.92089807491547]],
    [ "421916440",[-76.38835526981197, 40.09077029507124]],
    [ "York Substation",[-83.6974770004862, 42.171652686416444]],
    [ "Potterfield Substation",[-83.48462013673279, 45.07371947677392]],
    [ "422128732",[-76.98348545108621, 40.22185149783874]],
    [ "Stephens Substation",[-93.05921359999999, 33.40814625]],
    [ "422135060",[-92.10790524385388, 32.40747655023881]],
    [ "422135061",[-92.1039197578517, 32.436287075059674]],
    [ "Distributing Station 52",[-118.3257702896521, 34.10425598230221]],
    [ "Waltz Mill Substation",[-79.66247991525306, 40.22069351698826]],
    [ "Distributing Station No. 59",[-118.42527137223375, 34.0088276197055]],
    [ "Flintside Substation",[-83.95419281171068, 31.952331425880402]],
    [ "Whittle Substation",[-83.45682617656419, 31.923440903748393]],
    [ "422317304",[-88.75682742288078, 30.40541770627997]],
    [ "US Army",[-88.91537242115784, 30.398930315770937]],
    [ "Aurora Heights Substation",[-93.01986717785736, 41.703378855454524]],
    [ "Eastman Chemical Company",[-82.54812576898482, 36.527833900882406]],
    [ "Pearl River Valley Electric Power Association",[-89.58069259999999, 31.37892835]],
    [ "422391146",[-89.39960267234906, 31.411244536085935]],
    [ "Green Circle Substation",[-85.3896844, 30.734431949999998]],
    [ "422501087",[-84.99925159826238, 29.719303240580704]],
    [ "Distributing Station 28",[-118.44376126774453, 34.04492006569216]],
    [ "422507156",[-91.97773341283941, 47.63961737476489]],
    [ "422507157",[-91.9265559, 47.6690003]],
    [ "422507158",[-91.97912584375091, 47.71657057114719]],
    [ "Distributing Station 46",[-118.42543197876262, 34.068399329180686]],
    [ "422533043",[-84.77054034387173, 30.442675239012104]],
    [ "422534289",[-84.73155601652074, 30.656722823479477]],
    [ "422534291",[-84.73337601713548, 30.657164025009298]],
    [ "Met-Ed",[-76.51812141567557, 40.3332042918245]],
    [ "Maytag #3 Substation",[-93.04452101439804, 41.71480759526412]],
    [ "Duke Substation",[-98.17391109199217, 26.34134107241687]],
    [ "Citgo North Oak Park Substation",[-97.42703787821029, 27.814274393483785]],
    [ "422780783",[-83.91862653550962, 35.18817578062244]],
    [ "422852279",[-79.7365808767627, 34.84174981272428]],
    [ "Lagoon Creek Substation",[-89.39460041087634, 35.65702786680295]],
    [ "Flynn Substation",[-85.42989813543406, 31.271722131727948]],
    [ "423001770",[-78.01314568529506, 33.958987245052256]],
    [ "423001796",[-78.01065344169993, 33.961232942096046]],
    [ "Distributing Station 6",[-118.32697105011722, 34.08914991756437]],
    [ "Bethlen Substation",[-79.23686195257423, 40.24914983647165]],
    [ "423051081",[-85.75143072518121, 30.332662108523603]],
    [ "Harrington Substation",[-75.58125498131325, 38.91647024312513]],
    [ "Cherokee Substation",[-81.18011351981933, 32.14920849588332]],
    [ "Georgia Power",[-81.17383729007042, 32.151626473673346]],
    [ "Bemis Substation",[-83.7541580576072, 42.17266974609433]],
    [ "River Falls Substation",[-86.53664415610652, 31.347510222431197]],
    [ "Wells Substation",[-75.5846206416392, 39.01867996534888]],
    [ "DISTRIBUTING STATION 10",[-118.33795968434848, 34.100332224432144]],
    [ "Kratz Substation",[-75.59664610918368, 38.80952315739885]],
    [ "423528696",[-76.84358218405991, 40.22169414458241]],
    [ "Rosemont Substation",[-76.86480655000001, 40.2222734]],
    [ "423625219",[-117.30320935000002, 34.9970854]],
    [ "423658362",[-96.83292673466164, 33.007366299620806]],
    [ "Georgia Pacific Substation",[-81.54432486288457, 31.276804546274928]],
    [ "Georgia Pacific Substation",[-81.5217241638065, 31.175431527591357]],
    [ "423730683",[-87.84275746023113, 42.59627480438614]],
    [ "Tesla Gigafactory",[-119.43706992509819, 39.53985100708952]],
    [ "New Haven Substation",[-73.1654660897135, 44.119136120625875]],
    [ "Williston Substation",[-73.12870313362616, 44.413878743011715]],
    [ "Wyeth City Substation",[-86.28304297686724, 34.34516889467963]],
    [ "Atlanta Substation",[-84.16595806655715, 45.00807028934958]],
    [ "Duke Energy",[-82.93721450000001, 30.27504555]],
    [ "Duke Energy",[-82.93950959517095, 30.276421273572474]],
    [ "424247073",[-79.19809545000003, 34.67332965000001]],
    [ "Agricola Substation",[-88.51740886823403, 30.819698882643724]],
    [ "424569197",[-92.05872238355185, 46.68541115177996]],
    [ "424569204",[-92.11529465461444, 46.70475230070685]],
    [ "424569226",[-92.06087833758487, 46.690030341261355]],
    [ "North Congress Substation",[-94.66691066498281, 39.289833882105874]],
    [ "Ocala Shaw Sub OEU",[-82.18372028458624, 29.14541326776685]],
    [ "Friess Ranch Substation",[-100.51391705, 30.400373300000002]],
    [ "Liberty MPS Substation",[-94.4304145170348, 39.237476783399735]],
    [ "American Petrofina Substation",[-100.05495785, 30.17140855]],
    [ "Montell Substation",[-100.00176460196042, 29.42795686790613]],
    [ "Onaway Substation",[-84.22813169999999, 45.324807449999994]],
    [ "Valdosta Substation",[-83.28762352042425, 30.824085784692524]],
    [ "Nyrstar Clarksville Inc.",[-87.40704990504766, 36.513505140871644]],
    [ "Distributing Station 20",[-118.39331185441564, 34.033598719051774]],
    [ "Weakley County Municipal Electric System",[-88.66297369860628, 36.26270171678352]],
    [ "Crockett Heights Substation",[-101.1175321, 30.702148749999996]],
    [ "Ozona Substation",[-101.19977232655319, 30.719189192806844]],
    [ "Sonora Atlantic Substation",[-100.81971988373719, 30.630316897430472]],
    [ "424980699",[-86.09602966521665, 41.45328576382236]],
    [ "425190332",[-91.26107937071815, 47.287051082272214]],
    [ "Weidman Substation",[-85.05546238905293, 43.66885846073393]],
    [ "Hersey Substation",[-85.42644824336449, 43.837802277473315]],
    [ "Ramos Substation",[-91.13753656065762, 29.676511197442796]],
    [ "425337536",[-82.07745994876979, 40.1472355343834]],
    [ "Falls City Substation",[-97.98582339438767, 29.0105495669341]],
    [ "Nixon Substation",[-97.76653234745187, 29.28926334212739]],
    [ "Interlochen Substation",[-85.77163557789306, 44.678555129332]],
    [ "Mesick Substation",[-85.714938, 44.4079353]],
    [ "University of Florida Substation",[-82.34867866933973, 29.64082761187784]],
    [ "Comal Street Substation",[-98.50859331256062, 29.42157988559643]],
    [ "Deer Creek Substation",[-97.78368835000339, 29.55528531070097]],
    [ "Helena Substation",[-97.7999986972749, 28.93792437605258]],
    [ "Magnolia Substation",[-97.8667935, 29.015058349999997]],
    [ "Malone Substation",[-97.72129770000001, 29.626555550000003]],
    [ "Milton Substation",[-97.78764697497824, 29.05644660623254]],
    [ "Nash Creek Substation",[-97.75734864075577, 29.544023878473705]],
    [ "Nixon Substation",[-97.74394475000001, 29.2797868]],
    [ "Nordheim Substation",[-97.59965630000002, 28.923560500000008]],
    [ "Nordheim West Substation",[-97.62425554999999, 28.911500599999993]],
    [ "Cost Substation",[-97.5277942043747, 29.438517520463147]],
    [ "Lakewood Substation",[-97.50079993475305, 29.48336942443265]],
    [ "Smiley Substation",[-97.6303070583678, 29.317008926135763]],
    [ "425896159",[-115.12807040497971, 36.14520090282739]],
    [ "Dale Substation",[-97.58523825, 29.93963225]],
    [ "Gonzales Substation",[-97.4552039932668, 29.519424930611095]],
    [ "Hochheim Substation",[-97.29923638112508, 29.27655999519211]],
    [ "Magnolia Mercer Substation",[-97.70563486699712, 29.759427306118276]],
    [ "Ottine Substation",[-97.47854601570873, 29.613719105690045]],
    [ "Red Rock Substation",[-97.45212653729425, 29.961988414267694]],
    [ "Laredo Plant Statcom Substation",[-99.50838196059699, 27.568733518657467]],
    [ "Laredo VFT South Yard",[-99.50947765000001, 27.570117800000006]],
    [ "Laredo VFT North Yard",[-99.5090266674867, 27.572559477248376]],
    [ "Intercession City Plant Substation",[-81.5489274923401, 28.264098854409248]],
    [ "426058585",[-80.06429893351948, 34.386356197609636]],
    [ "Darlington 115kV Substation",[-79.88419834999999, 34.308254350000006]],
    [ "Distributing Station 26",[-118.26262033438846, 34.06917102042829]],
    [ "426246192",[-97.6144774675736, 35.51085187378335]],
    [ "Los Angeles Department of Water and Power",[-118.25532052450411, 34.059188470086546]],
    [ "Plymouth Substation",[-76.74012939745914, 35.866135852169]],
    [ "Indian Wells Substation",[-116.34656330493728, 33.72942361980632]],
    [ "Razorback Substation",[-99.21792189999998, 29.321621349999994]],
    [ "Seco Substation",[-99.2383605, 29.436493799999997]],
    [ "426483199",[-92.93901900094255, 46.93812202764689]],
    [ "426483201",[-92.93364050580632, 46.941445499289706]],
    [ "Savanna Substation",[-92.89177411924783, 46.95129698125335]],
    [ "Laredo Heights Substation",[-99.49014659760881, 27.523680211292074]],
    [ "Dillon 115kV Substation",[-79.3546383, 34.43170985]],
    [ "426706318",[-79.6874001, 34.661614900000004]],
    [ "Hoosier Energy",[-84.91435345000001, 39.20336665000001]],
    [ "426807007",[-79.37373792905717, 34.83698707605124]],
    [ "Rocky Gap Substation",[-84.16041211010263, 36.22582574479035]],
    [ "Blanco Substation",[-98.4121316106268, 30.082612719458773]],
    [ "Blanco Tap",[-98.36006277513255, 30.284651557599894]],
    [ "Johnson City Substation",[-98.39841868146632, 30.30058498839201]],
    [ "Darwin Substation",[-81.9124217892974, 41.47665515368913]],
    [ "427119529",[-83.09823210014346, 40.10162582937484]],
    [ "427123661",[-84.61350966878742, 40.077255183630356]],
    [ "Julien REC",[-90.73979809330284, 42.486098990135545]],
    [ "Center Grove Substation",[-90.74034205644021, 42.4864418320953]],
    [ "Garvins Substation",[-71.50740362519117, 43.16275378387085]],
    [ "427272174",[-78.85119356405876, 34.014942499813294]],
    [ "427272177",[-78.92211786820437, 34.03793419806177]],
    [ "Deerhaven Renewable Plant Substation GRU",[-82.39658270000001, 29.768271450000007]],
    [ "Abilene Energy Center Substation",[-97.20274497286127, 38.88326925293495]],
    [ "427402704",[-92.62552171149267, 46.59194997531052]],
    [ "Kimberly Substation",[-93.65001417494283, 46.57612919131775]],
    [ "427402708",[-92.39149044941452, 46.6350154472387]],
    [ "Pueblo Substation",[-100.46375078281325, 28.678984498807377]],
    [ "Wolf Creek Substation",[-95.14560890000001, 30.6003034]],
    [ "Altona Substation",[-85.2340460495982, 43.54017467693865]],
    [ "North Newark Substation",[-82.41598114505344, 40.088573598086704]],
    [ "Cape May Substation",[-74.92501012492858, 38.936641483919054]],
    [ "Gowan Substation",[-92.84883988890783, 46.85939071996636]],
    [ "Gowan Substation",[-92.84776599950831, 46.854928673502286]],
    [ "Tabor City Substation",[-78.8801674, 34.157387850000006]],
    [ "428004777",[-79.0945042, 34.63618825]],
    [ "428004779",[-79.09412199998981, 34.63579173333809]],
    [ "Los Angeles Department of Water and Power",[-118.24681927204375, 34.04739062476351]],
    [ "Los Angeles Department of Water and Power",[-118.26489034068913, 34.046239224363624]],
    [ "Charlton Street Substation",[-74.65259988028633, 40.3492965487422]],
    [ "Fort Lee Substation",[-77.32191479999999, 37.244450500000006]],
    [ "Lawnton Substation",[-76.81545732965634, 40.267771898433935]],
    [ "Los Angeles Department of Water and Power",[-118.25602485069292, 34.03844639314528]],
    [ "Phillips Substation",[-81.30751558230048, 27.439750601787807]],
    [ "Duke Energy",[-81.3681899, 27.43528565]],
    [ "Lake Placid North Substation",[-81.3665527126303, 27.32235930581404]],
    [ "Lorida Substation",[-81.2407383256359, 27.438635196736197]],
    [ "Morgan Henderson Substation",[-81.33318389430373, 27.20880027520165]],
    [ "Sebring East Substation",[-81.36281405045426, 27.443509816992837]],
    [ "West Clewiston Substation",[-80.9771809078894, 26.765656869419658]],
    [ "DISTRIBUTING STATION 17",[-118.30077221082915, 34.05063791517642]],
    [ "DISTRIBUTING STATION 39",[-118.33044502667788, 34.0220194844598]],
    [ "DISTRIBUTING STATION 43",[-118.3638880293188, 34.05128231237218]],
    [ "Distributing Station 8",[-118.34228113484559, 34.04904716842764]],
    [ "Distributing Station 30",[-118.21134635507184, 34.13473236632814]],
    [ "Tracy Road A-B",[-86.13905562565517, 39.56330371367908]],
    [ "428660864",[-84.85010441142558, 39.1561660182727]],
    [ "Cemetery Substation",[-84.86707697484762, 39.11767620635396]],
    [ "428779559",[-79.03512517925063, 34.981011631363366]],
    [ "Lumbee River EMC",[-79.08916756318729, 35.02774532612004]],
    [ "428831914",[-82.89467500299614, 29.526210565507157]],
    [ "428889121",[-79.15017534999998, 34.94456205]],
    [ "428933688",[-79.21110600988192, 34.95894618451266]],
    [ "428933689",[-79.24080571777371, 34.98519815437512]],
    [ "428933691",[-79.18869595000001, 34.98339824999999]],
    [ "428933693",[-79.21150461675694, 34.960097450281815]],
    [ "Cedar Neck Substation",[-75.06911459144983, 38.55826500139394]],
    [ "428954771",[-82.84801399999999, 29.496271049999997]],
    [ "Sisisky Substation",[-77.3400659445874, 37.25618056161237]],
    [ "429015661",[-80.52766149000766, 35.615525035157276]],
    [ "429074466",[-114.4708956072049, 42.5710874177727]],
    [ "429077335",[-79.48724855, 35.20491565]],
    [ "429112136",[-79.36293785, 35.2034845]],
    [ "Newton Falls Substation",[-80.94303782742118, 41.2068617002712]],
    [ "Venoy Substation",[-83.36332390329733, 42.309111929032824]],
    [ "DISTRIBUTING STATION 23",[-118.19272494794447, 34.035318883843495]],
    [ "429324278",[-94.27989215, 45.58631375000001]],
    [ "429324280",[-94.26162425000001, 45.79439985]],
    [ "429324283",[-94.2941029212262, 45.62351010556596]],
    [ "Education Station (MacVicar)",[-95.71121318765216, 39.06830500490828]],
    [ "Georgia Power",[-84.28313226802678, 33.9003504469026]],
    [ "429393506",[-77.97343095000001, 37.06023104999999]],
    [ "Virginia National Guard",[-77.97239955000002, 37.0602794]],
    [ "Virginia National Guard",[-77.97228050832764, 37.060592225069435]],
    [ "Raytheon Aerospace LLC",[-89.40581704759792, 32.354793921433846]],
    [ "Fitch Substation",[-73.40368377211617, 41.10483868268022]],
    [ "University of Florida",[-82.35013710033097, 29.635329617027253]],
    [ "Berwick Substation",[-83.2964799513859, 41.02650190124987]],
    [ "Seneca Substation",[-83.24675810342237, 41.06967281788831]],
    [ "429549950",[-83.2368542026553, 41.077771383116385]],
    [ "429556554",[-79.05721637291356, 35.27043619781659]],
    [ "429689332",[-94.31067069027472, 45.5003697954472]],
    [ "429689336",[-94.15002262178076, 45.61773978104363]],
    [ "429723203",[-78.69019260460377, 35.223344432598175]],
    [ "429723204",[-78.7166930817096, 35.18794662914674]],
    [ "429760174",[-78.81520355, 35.0925843]],
    [ "Weakley County Municipal Electric System",[-88.82440673823207, 36.214822396954894]],
    [ "429788669",[-78.7993174000467, 35.42211671665235]],
    [ "LADWP Distributing Station No. 35",[-118.36197701697463, 34.15714636806064]],
    [ "429889395",[-94.42348446239895, 45.421718700028194]],
    [ "429921877",[-110.27355380322165, 31.55898555005816]],
    [ "429943221",[-78.69176599783152, 35.74770548460245]],
    [ "429982219",[-78.80350069037782, 35.66563606863326]],
    [ "Marlin Substation",[-76.23256261682789, 40.678997894635586]],
    [ "Port Carbon Substation",[-76.17079754553762, 40.70183090222048]],
    [ "Lank Substation",[-75.22377081326994, 38.73675572270247]],
    [ "Cool Spring Substation",[-75.26452080662418, 38.73389814555166]],
    [ "Five Points Substation",[-75.18037916807315, 38.74529964711785]],
    [ "430459441",[-77.83693850854274, 38.739216917242686]],
    [ "Rosedale Substation",[-75.91334959999999, 40.38765575]],
    [ "Sourek Substation",[-81.57314297418135, 41.14397240213305]],
    [ "Lincoln Park Substation",[-80.59572180803737, 41.10290043253374]],
    [ "Lowellville Substation",[-80.52403474308582, 41.031223548567496]],
    [ "Cornersburg Substation",[-80.70315490000002, 41.06565825]],
    [ "Suttons Bay Substation",[-85.63419932510227, 44.93902375413691]],
    [ "Rosinton Substation",[-87.66560605022981, 30.622549664620028]],
    [ "430675085",[-79.34946108573232, 36.07784922882373]],
    [ "430675094",[-79.36504776682466, 36.06175125045224]],
    [ "430895913",[-79.46470891447383, 36.08063576699136]],
    [ "Masury Substation",[-80.53329227274966, 41.20735205174935]],
    [ "Blacklick Substation",[-82.8290777448028, 39.99956577720019]],
    [ "431221147",[-78.85439180625232, 36.13138544210868]],
    [ "431441690",[-100.68817932498541, 36.61686314552648]],
    [ "431470251",[-78.96581518780971, 36.42468016677822]],
    [ "431476329",[-100.43594626971787, 36.61675494221052]],
    [ "431477706",[-100.24813739193199, 36.6157705891887]],
    [ "Whitmore Lake Substation",[-83.75633289179831, 42.51218939609698]],
    [ "431528292",[-78.94288028470898, 36.42061581931077]],
    [ "West Fenton Substation",[-83.73157435133285, 42.80721420354437]],
    [ "431571935",[-78.86651198413637, 36.31724390400121]],
    [ "431815411",[-89.08837456969655, 41.605046200355225]],
    [ "431969872",[-78.13404904105464, 36.420363005309845]],
    [ "431969879",[-78.13260391172531, 36.420469175932624]],
    [ "DISTRIBUTING STATION 49",[-118.41333202780018, 34.14743698203662]],
    [ "Kittrell Substation",[-78.44740875, 36.180931]],
    [ "432133854",[-82.26085033356463, 34.9208839962115]],
    [ "Swamp Fox Substation",[-91.55951788613847, 42.03662606739993]],
    [ "432240636",[-78.47491056954573, 36.09683759601244]],
    [ "432240668",[-78.48723831219543, 36.06154441008989]],
    [ "432240675",[-78.48981541038526, 36.04978970985933]],
    [ "Singing River Electric Cooperative",[-88.86280732404029, 30.45334496325226]],
    [ "432282271",[-84.72522168156927, 34.33914830440093]],
    [ "Biloxi Percy Street Substation",[-88.89349712493218, 30.406010039751266]],
    [ "432300933",[-78.51335832042534, 35.988614404539135]],
    [ "432300939",[-78.51369952420899, 35.98925027229936]],
    [ "432325864",[-82.21487526038774, 35.9054618395993]],
    [ "Jersey Central Power and Light",[-74.285588310534, 40.48680156081111]],
    [ "432465756",[-89.60835551944297, 30.349824212667695]],
    [ "La Canada Substation",[-110.9965968301181, 32.36891236023534]],
    [ "Grand River Dam Authority",[-95.22698602281977, 35.869307670225204]],
    [ "Mackeys Substation",[-76.61908154724001, 35.92705584706295]],
    [ "SRP Shultz Substation",[-111.80964058096868, 33.29964903370729]],
    [ "432753031",[-111.79883279523405, 33.353961029369884]],
    [ "432761191",[-85.04468184647872, 41.43266415020418]],
    [ "432808518",[-78.41371632274829, 35.43511004204744]],
    [ "432809217",[-85.49768178692567, 40.4727359751427]],
    [ "Overton-La Cholla Substation",[-111.0120943820349, 32.37397435694274]],
    [ "Oro Valley Substation",[-110.961796258874, 32.402451562011244]],
    [ "432887391",[-103.88058677810824, 48.867297114108815]],
    [ "Ranch Visitoso Substation",[-110.96984131244608, 32.425043285366044]],
    [ "Maxville Substation #04 CLAY",[-82.02294605833993, 30.182670324877186]],
    [ "Fayetteville Public Works",[-78.87324326767236, 35.031447106417914]],
    [ "Fayetteville Public Works",[-78.86314398892873, 35.10405129723265]],
    [ "Hawthorne Plywood Mill Substation FPL",[-82.03700117844072, 29.594442996527984]],
    [ "433285903",[-111.9601794286164, 33.38578740481084]],
    [ "433333450",[-75.42106136512238, 39.80734354072521]],
    [ "Christina Substation",[-75.53839696729182, 39.73165952848371]],
    [ "Asbury Substation",[-90.73982995981102, 42.51826224541504]],
    [ "Oden Substation",[-84.87769691173096, 45.43616113391625]],
    [ "Conway Substation",[-84.86957972505698, 45.415403144289485]],
    [ "434688174",[-79.57268504438412, 35.40942961225173]],
    [ "434693815",[-111.75933557218225, 33.4721698154525]],
    [ "434708864",[-84.24298382512318, 36.37945905649107]],
    [ "434715945",[-84.18424545917932, 36.31108044062961]],
    [ "434760812",[-110.18241452505819, 31.377825804573835]],
    [ "434838090",[-78.89032065133729, 35.20495338601093]],
    [ "Bridge Substation",[-80.83159361748987, 41.25858934949931]],
    [ "Burton Substation",[-80.80141598454291, 41.21846724803684]],
    [ "McGregor Hercules Substation",[-97.47113942206516, 31.39908954469051]],
    [ "Ironwood Substation GRU",[-82.30187040799595, 29.6827634750808]],
    [ "435057968",[-109.28601464152688, 45.64918227495901]],
    [ "Georgia Power",[-84.4293199130979, 33.84661243433816]],
    [ "Coles Substation",[-77.44224098642756, 38.68133793434364]],
    [ "435072896",[-86.05357609357817, 40.75671721471435]],
    [ "435075563",[-86.11887495000002, 40.53347144999999]],
    [ "435090268",[-80.37713611418854, 34.98884272292332]],
    [ "Dupont Edgemoor Substation",[-75.50485798051372, 39.74784802439914]],
    [ "Consumers Energy",[-83.71814065202993, 42.98299611452645]],
    [ "Ballenger Substation",[-83.73481599065987, 43.00319187506207]],
    [ "435219627",[-80.91139553697091, 35.124569785814344]],
    [ "Brandywine North Substation",[-75.53956554822139, 39.75033251830846]],
    [ "Brandywine South Substation",[-75.53896069492761, 39.749995102897635]],
    [ "435316859",[-84.30200200000002, 34.4395882]],
    [ "435318649",[-106.31301103645144, 31.776701927409203]],
    [ "435404875",[-80.92611949585886, 35.13244223239447]],
    [ "435487506",[-155.988038770447, 19.649361963114185]],
    [ "Edgemoor Substation",[-75.50958247209249, 39.74077546404985]],
    [ "Lewes Substation",[-75.13773437126028, 38.77178650181062]],
    [ "Harbeson Substation",[-75.28355739943923, 38.72581364307824]],
    [ "SRP Freestone Substation",[-111.76364716156839, 33.291537475420846]],
    [ "435977632",[-85.967405, 32.4054217]],
    [ "Andrews Substation",[-85.31094743162446, 32.7062927471345]],
    [ "Opelika Substation",[-85.26852095000001, 32.67913815]],
    [ "Spring Villa Substation",[-85.30025798465088, 32.609237434047216]],
    [ "Blairsville East Substation",[-79.24963551041607, 40.43867019652525]],
    [ "Clark’s Gap Substation",[-77.63025054886725, 39.11901086672377]],
    [ "Mesa Substation",[-106.51241535256715, 31.80643400052786]],
    [ "436313412",[-109.28363912700891, 45.667952790550494]],
    [ "436347948",[-94.31875652476711, 37.180893959958524]],
    [ "436422774",[-87.5586889, 38.29819859999999]],
    [ "Rio Pecos Substation",[-102.36520288491884, 31.084785300576563]],
    [ "Huntsville Utilities",[-86.68236577151481, 34.73147703286569]],
    [ "Gulf Shores Substation",[-87.68981901666365, 30.27640923722076]],
    [ "Swisher Substation",[-91.69427957480114, 41.865278994224724]],
    [ "Linn County REC",[-91.79395889999999, 41.92716015]],
    [ "436903528",[-122.07620593503995, 38.23129745730674]],
    [ "Beech-Nut Substation",[-86.07658964002974, 42.75442622927918]],
    [ "Pacific Gas and Electric Company",[-121.84414713297096, 38.22656409116617]],
    [ "Midway Substation",[-75.1526580153244, 38.74347625967273]],
    [ "East Crestview Substation",[-86.52599866824231, 30.75597741493637]],
    [ "437073413",[-80.81925048209824, 35.583805291443056]],
    [ "LaBarge Substation",[-85.48281370185109, 42.81132350898962]],
    [ "Metropolitan Substation",[-94.92266706239202, 39.32792120221785]],
    [ "Forest Grove Substation",[-123.08906405560772, 45.52456532414145]],
    [ "437250406",[-91.7579610747471, 37.96549204428689]],
    [ "Bolivar Energy Authority",[-89.15179994679745, 35.293769951618046]],
    [ "Appalachian Power Company",[-79.8579642421869, 36.628482540967624]],
    [ "437773476",[-110.57291239900033, 45.65678896322222]],
    [ "437894401",[-115.4925191446531, 33.16866712078607]],
    [ "Otter Creek Substation",[-82.77209501882439, 29.329947623786957]],
    [ "438027667",[-86.57265695106214, 39.118256587372024]],
    [ "Station D",[-121.500502, 38.5719998]],
    [ "Facebook Data Center",[-93.51209317088728, 41.666302326493316]],
    [ "Microsoft Project Mountain Data Center",[-93.8274277118565, 41.541863987281126]],
    [ "West Grand Substation",[-93.82611566739973, 41.542292816650864]],
    [ "Enola Substation",[-76.95234378612835, 40.27642806050806]],
    [ "Central Campus Sub",[-106.61918058854322, 35.08726717495099]],
    [ "Ragland Substation",[-82.12445222075934, 37.69920855525416]],
    [ "438222237",[-81.6342859625196, 35.24258627495466]],
    [ "438222806",[-86.5333818827311, 39.23691962437567]],
    [ "438224186",[-86.21354042451706, 39.599992989998356]],
    [ "438264539",[-83.28167494417545, 42.64131484604629]],
    [ "Indianapolis Power & Light",[-86.19418401391106, 39.671628850696095]],
    [ "Hawaiian Electric Company",[-155.7245599, 19.87262195]],
    [ "438325265",[-79.37111125000001, 38.060093599999995]],
    [ "438338536",[-81.6370822370919, 35.32223022560884]],
    [ "438338537",[-81.63069090833966, 35.32798337056694]],
    [ "Summerdale Substation",[-76.9437726825157, 40.2945700037704]],
    [ "438351104",[-83.67775337657446, 39.17354450780639]],
    [ "Oliver Springs Substation",[-84.3319254179876, 36.0312761697618]],
    [ "438428074",[-88.24019430221892, 35.161621913787116]],
    [ "438432485",[-93.4819647509798, 44.735926774072546]],
    [ "Mississippi Power",[-89.26766081618244, 31.329732386722096]],
    [ "438474750",[-89.26426804774518, 31.37113555517373]],
    [ "438474753",[-89.15329781547901, 31.267183382318294]],
    [ "West 7th Street Substation",[-89.26820503783637, 31.338982274937848]],
    [ "North Hattiesburg Substation",[-89.32322968627854, 31.349935757404747]],
    [ "438477603",[-89.36924439418401, 31.38409826456932]],
    [ "Millville Substation",[-76.5217266, 41.1217484]],
    [ "West Berwick Substation",[-76.27733691701323, 41.053649213146315]],
    [ "Berwick Substation",[-76.23347354999999, 41.05829769999999]],
    [ "438613672",[-81.36042449659523, 35.22502881778924]],
    [ "Whiting Field Substation",[-87.00640198794605, 30.71435439143224]],
    [ "438663405",[-95.38718413837032, 41.99603603927084]],
    [ "438694255",[-83.52249624999999, 42.2545401]],
    [ "438732086",[-81.49728306208007, 35.266097850056816]],
    [ "438867340",[-106.5759568571315, 31.83658376121936]],
    [ "Garber Delivery Point",[-77.31051065, 38.6270852]],
    [ "Kenmar Substation",[-76.96240794999999, 41.24780955]],
    [ "Gamebird Switchard",[-115.89946568146541, 36.16197574351483]],
    [ "Windsor Substation",[-76.94525215879133, 35.99294552023379]],
    [ "439230730",[-76.198912063323, 36.26901333338167]],
    [ "Friday Harbor Substation",[-123.013898680229, 48.53237386352991]],
    [ "439255109",[-82.42959066212697, 35.29276922620463]],
    [ "Pee Dee Substation",[-95.88573889706717, 30.93008773434723]],
    [ "Bishop Substation",[-95.80281789152188, 30.904501517213607]],
    [ "439432197",[-115.57054189999998, 36.53143575]],
    [ "Staley Substation",[-95.25859167733098, 30.847396192025947]],
    [ "Poco Substation",[-94.9087025652834, 30.73048871876093]],
    [ "Bold Springs Substation",[-94.95180152487147, 30.761599042743075]],
    [ "Israel Road Substation",[-94.90634855625862, 30.73006417039507]],
    [ "East Scott St",[-88.42534155, 43.792068050000005]],
    [ "Indian Substation",[-94.71349183577767, 30.718910127581346]],
    [ "Menard Substation",[-94.74773840267231, 30.583090559131787]],
    [ "Kahaluu Substation",[-155.95481035556298, 19.582221620107603]],
    [ "Montoursville Substation",[-76.92191720034496, 41.25858130208855]],
    [ "South Williamsport Substation",[-77.00337056734581, 41.23156019908583]],
    [ "Mars Substation",[-80.01029572954442, 40.6995841630656]],
    [ "Oklahoma Gas & Electric",[-97.08190633542932, 36.12979027543602]],
    [ "439634899",[-80.51344913362927, 34.969177151812474]],
    [ "439634904",[-80.54092930278081, 34.99216770920812]],
    [ "City of Elizabeth",[-76.22982162058952, 36.29337979481044]],
    [ "Kentucky Utilities Company",[-84.66632410000001, 37.8618774]],
    [ "439938739",[-85.29560450000001, 38.73085025]],
    [ "439967087",[-80.33381198982896, 35.22391216877688]],
    [ "439967091",[-80.2634463, 35.26886960000001]],
    [ "439967093",[-80.16677644988, 35.37267714163221]],
    [ "439967095",[-80.1229633583901, 35.401734578994095]],
    [ "439967096",[-80.16721479912196, 35.3726943318787]],
    [ "Powell Valley Electric Cooperative",[-83.76658665000001, 36.51686845]],
    [ "440132700",[-80.2429979433008, 35.41275218344053]],
    [ "Frost Substation",[-90.71074740158495, 30.431253403788283]],
    [ "Corrigan Bulk Substation",[-94.81680082815754, 30.994177013960446]],
    [ "440283814",[-96.42866990814183, 33.70808706109967]],
    [ "440284131",[-96.55850399256067, 33.78637664921036]],
    [ "440285219",[-96.54507512185229, 33.74163470963277]],
    [ "Wallace Substation",[-87.1830695880711, 30.706647274320066]],
    [ "440315642",[-119.42262121646435, 46.33315650036814]],
    [ "Whitesboro Station",[-75.28312602031362, 43.11747453662609]],
    [ "440458593",[-81.48959773269854, 33.125335437473915]],
    [ "440484495",[-80.47026858407382, 35.64163577291735]],
    [ "440484497",[-80.3871225732112, 35.581286228693614]],
    [ "Young Substation",[-85.27351719073798, 34.750733386981665]],
    [ "440657424",[-110.2916323, 31.56893435]],
    [ "Lower Valley Energy",[-110.75442497174673, 43.47568019648025]],
    [ "440710227",[-96.41120232017253, 33.601857581035425]],
    [ "440720673",[-96.45884553222976, 33.60161294471021]],
    [ "440877817",[-81.11923737480974, 36.01413386384647]],
    [ "Appalachian Power Company",[-82.31225031155876, 37.82926662057272]],
    [ "Dingess Substation",[-82.17073680000001, 37.8711972]],
    [ "441089187",[-85.29356798335984, 29.831691049529226]],
    [ "441099142",[-81.97558575501544, 37.920481719339215]],
    [ "Lovely Substation",[-82.40028652482432, 37.82019688824197]],
    [ "441102098",[-82.03252554497475, 37.99151028557639]],
    [ "441102100",[-81.74478694999999, 37.9156968]],
    [ "441104365",[-81.12335772705114, 36.131905806602425]],
    [ "441104369",[-81.11388346784442, 36.15317973406078]],
    [ "441348231",[-81.17114785, 35.44533895]],
    [ "441348232",[-81.17032683355309, 35.44554814425476]],
    [ "441360943",[-81.7922977185478, 37.90926744659612]],
    [ "441365765",[-122.61156384134304, 48.51057697497886]],
    [ "Appalachian Power Company",[-81.68480828300717, 37.92355425133746]],
    [ "Appalachian Power Company",[-81.68564525, 37.923655499999995]],
    [ "441384836",[-81.67891158961565, 37.91295908322069]],
    [ "441384844",[-81.81897105, 37.97458520000001]],
    [ "Linctonton City Substation",[-81.24621243901012, 35.471381830100206]],
    [ "441492678",[-81.24663553740288, 35.471196289435156]],
    [ "Linconton Substation",[-81.23744169762871, 35.47405739861437]],
    [ "441500381",[-81.25554462785207, 35.53291645449083]],
    [ "441500382",[-81.21679231473428, 35.54645522567557]],
    [ "441500383",[-81.25500039999999, 35.533033599999996]],
    [ "441500384",[-81.21899971548227, 35.536957205947495]],
    [ "441506865",[-81.2544961, 35.5848051]],
    [ "138 KV Delivery Point Station",[-81.71351085580565, 41.012491003051046]],
    [ "441554137",[-81.20588621874087, 35.57569045195337]],
    [ "441562712",[-81.86761276379042, 38.244243082185235]],
    [ "Hopkins Substation",[-81.84937411849546, 38.088874112818715]],
    [ "Tarentum Substation",[-79.745436165236, 40.6045170809845]],
    [ "West Penn Power",[-79.72947985137651, 40.606268416474165]],
    [ "Alleghany Ludhurn No. 5",[-79.71875921637418, 40.61933828186086]],
    [ "441574465",[-81.81001546149335, 38.35718710724071]],
    [ "Appalachian Power Company",[-81.74289353800795, 38.30390486402357]],
    [ "441580299",[-81.81083205515797, 38.439794002492235]],
    [ "441580308",[-81.76550850519565, 38.42609482481338]],
    [ "Appalachian Power Company",[-81.78677091302441, 38.38305823461407]],
    [ "441580335",[-81.78579270622534, 38.381422071244096]],
    [ "441656283",[-81.06872935090779, 35.40772011619599]],
    [ "441656284",[-81.06891562190174, 35.40834425702171]],
    [ "441702231",[-74.4283572019789, 40.47894531553591]],
    [ "Niles Valley Substation",[-77.2885018468526, 41.81975535381999]],
    [ "Holden Substation",[-90.67292022094038, 30.51649010494786]],
    [ "441714924",[-81.10667052107173, 35.36852485659321]],
    [ "Stanley Substation",[-81.10602183664042, 35.36853142946394]],
    [ "441726493",[-81.0617122408106, 35.33282812927535]],
    [ "441726498",[-80.99047696704457, 35.32594755180905]],
    [ "441726503",[-81.02560097413239, 35.293253856316696]],
    [ "441726988",[-80.94692027100007, 35.31932446251617]],
    [ "Gardiner Substation",[-124.11351719807895, 43.74190227016766]],
    [ "441984350",[-85.63832284800851, 38.96464063600658]],
    [ "Chalker Substation",[-101.91417192369717, 33.52653641228208]],
    [ "Batton Substation",[-101.91338858331977, 33.52729665382442]],
    [ "Osceola Substation",[-77.34075926202006, 41.97552087255941]],
    [ "Flanders Substation",[-72.21024990893385, 41.361766867528154]],
    [ "Jonesville Substation",[-84.66464415, 41.98420245]],
    [ "442315221",[-84.66045092517729, 41.93850069156981]],
    [ "Squires Substation",[-84.82109096943896, 41.94802961314867]],
    [ "Qunicy Substation",[-84.89186851264243, 41.93431689401631]],
    [ "Levitt Station",[-75.47143458907865, 43.224853777842206]],
    [ "442386088",[-75.47217768848998, 43.21098040995502]],
    [ "Duke Energy",[-86.15083150000001, 39.432453949999996]],
    [ "Trafalgar Stubstation",[-86.15087349999999, 39.43182165]],
    [ "Lehigh Station",[-75.74985982260087, 43.33101325256106]],
    [ "Parrish Substation",[-75.90236805000002, 41.2331556]],
    [ "Corn Belt Power Cooperative",[-95.25588025, 43.160817749999985]],
    [ "442786429",[-96.8994735510525, 33.628741018441104]],
    [ "Admiral Street Substation",[-71.42120313850891, 41.84151638876875]],
    [ "FirstEnergy",[-81.88500626272638, 41.4765866992072]],
    [ "Forest Avenue Switching Station",[-83.73361742805241, 42.27619097380781]],
    [ "442873685",[-83.13576113916328, 29.61674798128071]],
    [ "442929247",[-96.8636590116467, 33.62703210733093]],
    [ "442937255",[-96.69999253239953, 33.61561880069014]],
    [ "Berlin-40 Substation",[-72.55854063463019, 44.22169721021909]],
    [ "442983110",[-110.67151282102597, 44.72079405579904]],
    [ "442992582",[-78.32149943425372, 36.1015904805951]],
    [ "443095370",[-122.51940420000001, 48.0096017]],
    [ "Kentucky Utilities Company",[-87.57398735000001, 37.82222165]],
    [ "Angel Mounds Transmission Substation",[-87.47592683636678, 37.94861978156105]],
    [ "443393238",[-87.61416840665558, 37.79801252306047]],
    [ "443393241",[-87.63322553448691, 37.80481910629874]],
    [ "443395681",[-110.72516930000002, 47.27380599999999]],
    [ "443395682",[-110.89295114923078, 47.34746933660892]],
    [ "Kentucky Utilities Company",[-87.1122000164823, 37.66339691665896]],
    [ "443397834",[-87.3016051852186, 37.81678992142699]],
    [ "443433631",[-86.61983649158279, 37.83212271918601]],
    [ "New Hardinsburg Substation",[-86.48332264116044, 37.77532197670803]],
    [ "443439121",[-86.48800563976795, 37.77151838443306]],
    [ "443439123",[-86.26026944122096, 37.90988744532657]],
    [ "Irvington Substation",[-86.29058459545688, 37.88359547910547]],
    [ "Gateway Blvd. Substation",[-87.44541926218453, 37.97288957486587]],
    [ "443446500",[-87.46110542150447, 37.99210738528332]],
    [ "443450135",[-87.48700544283852, 38.11736446778041]],
    [ "443454620",[-87.3921622187461, 38.309886274850506]],
    [ "Cato Substation",[-87.17363962511617, 38.44421374191062]],
    [ "443469591",[-87.90744584192389, 37.94458252466912]],
    [ "443469592",[-87.9078289350363, 37.9405342561436]],
    [ "443497684",[-107.22206567754861, 39.41072541466949]],
    [ "443528345",[-110.51257742502644, 44.71804244658757]],
    [ "Fort Patrick Henry Dam Substation",[-82.50901257941489, 36.49898731415887]],
    [ "Saratoga Station 142",[-73.77451098294554, 43.08996677958258]],
    [ "444069336",[-102.29225665, 37.39859555]],
    [ "444147742",[-80.84738422645435, 35.43976189355036]],
    [ "444178547",[-82.44890534144403, 29.11584484822417]],
    [ "Baltimore Gas & Electric",[-76.47709205, 39.5618597]],
    [ "444226270",[-96.605566766599, 33.57530779450535]],
    [ "444227637",[-96.00112903353933, 33.58872704250603]],
    [ "444291221",[-110.82701861235726, 47.083587145344445]],
    [ "444317005",[-119.85365132131884, 46.899621880354026]],
    [ "DISTRIBUTING STATION 98",[-118.37321889740866, 34.14200863749306]],
    [ "Water Street Substation",[-88.41075895000002, 44.2559922]],
    [ "North Vernon Substation",[-99.331213380133, 34.20283005732203]],
    [ "E. J. West Station",[-73.91980800585813, 43.3181205953878]],
    [ "Hartwick Substation",[-85.22644482841403, 44.02987255635938]],
    [ "Fish River Substation",[-87.81898854793346, 30.47710330947913]],
    [ "445337105",[-117.59008824365496, 33.890703527557044]],
    [ "445794789",[-80.73081747784822, 32.21212931292878]],
    [ "445976178",[-78.00303896017084, 35.37851488036492]],
    [ "Lafayette Substation",[-85.23142266942487, 42.334277423749256]],
    [ "Springfield Substation",[-85.23267665975226, 42.333244229018405]],
    [ "Edisto Island Substation",[-80.29329075, 32.54274784999999]],
    [ "446476307",[-80.43246132769752, 35.39494815043834]],
    [ "Makakilo Substation",[-158.08891644356655, 21.35828248860072]],
    [ "446615746",[-85.61265637635026, 39.21046758129143]],
    [ "Station 106",[-77.5327122383523, 43.060587702172455]],
    [ "446673031",[-84.60150531950491, 37.869260056330276]],
    [ "Kamokilia Substation",[-158.0762631490466, 21.341630235617245]],
    [ "446742530",[-115.86673864426785, 43.05243957659559]],
    [ "Harney Substation",[-122.67996315644037, 45.64230276649957]],
    [ "Carlisle Substation",[-82.08805770542578, 41.288438073574724]],
    [ "447246434",[-83.18824593773654, 43.456540975722405]],
    [ "Hermitage Drive Substation",[-87.64723055767844, 34.843277959790825]],
    [ "447273575",[-96.41809843415163, 40.81360179146295]],
    [ "Mount Pinson Substation",[-86.67416035000001, 33.6950509]],
    [ "447724093",[-103.45410970761004, 39.13551578032009]],
    [ "Oxford Substation",[-122.5273732, 45.80310854999999]],
    [ "447985400",[-90.56617184664601, 35.97720304185973]],
    [ "Paragould Substation",[-90.47534816794521, 36.055596037884335]],
    [ "Entergy Arkansas",[-90.44027466780439, 36.08597490272901]],
    [ "Craighead Electric Cooperative Corporation",[-90.60457515, 36.07247065]],
    [ "Southwestern Power Administration",[-90.48896316771493, 36.079265038045584]],
    [ "448012063",[-90.36769468305651, 36.17124239880547]],
    [ "448016203",[-90.6475213, 35.91606905]],
    [ "448016599",[-90.73853539999999, 35.84918820000001]],
    [ "448016846",[-90.72433197525964, 35.84933244945284]],
    [ "Kihei Substation",[-156.44855930849033, 20.740998672522306]],
    [ "Rector Substation",[-90.2968413342975, 36.25749796758077]],
    [ "448023430",[-90.36673309081294, 36.17123072513916]],
    [ "448024124",[-90.22275092468523, 35.880779192416135]],
    [ "Ellabell Substation",[-81.5328103314064, 32.139613956441636]],
    [ "Interstate Center Substation",[-81.43754895, 32.165454999999994]],
    [ "Harrison Substation",[-74.15428934802337, 40.74502986906427]],
    [ "Florence Utilities",[-87.67008332435056, 34.829991408232516]],
    [ "Surrey Substation",[-84.87724330250576, 43.82725638265972]],
    [ "Stevenson Substation",[-84.92916545011026, 43.75521748547246]],
    [ "Rail Trail Substation",[-84.59860665, 43.761237099999995]],
    [ "Bluegrass Substation",[-84.72639047289056, 43.57444496554113]],
    [ "Looking Glass Substation",[-84.6434541739373, 42.804852928459006]],
    [ "448597240",[-87.13398095000001, 41.63217770000001]],
    [ "Fly Road Station",[-76.05746851031424, 43.0854537722996]],
    [ "448663852",[-83.18623626518567, 43.222636278582804]],
    [ "448670381",[-83.12589709868926, 43.99163156189145]],
    [ "Neeley Substation",[-85.55291072756654, 42.50372555614466]],
    [ "448706648",[-81.27312872522913, 28.181736707342548]],
    [ "Vermontville Substation",[-85.05451672513921, 42.57062903971349]],
    [ "Cochran Substation",[-84.82678075000001, 42.542585450000004]],
    [ "Bellevue Substation",[-85.03343234536868, 42.45057682900798]],
    [ "Whittum Substation",[-84.67951138058419, 42.516356286924605]],
    [ "City of Eaton Rapids Electric Department",[-84.651695858058, 42.520213587314224]],
    [ "City of Eaton Rapids Electric Department",[-84.65177607205699, 42.519786417381425]],
    [ "448751639",[-95.8963240767017, 40.98875126957798]],
    [ "448776005",[-83.81136614999998, 35.1996864]],
    [ "448868559",[-83.48206868463025, 43.367518567973804]],
    [ "448868562",[-83.32733543434064, 43.46706596144861]],
    [ "Birch Run Substation",[-83.7926154749416, 43.249843344224544]],
    [ "Busch Road Substation",[-83.80467499966984, 43.2923458488014]],
    [ "Miller Road Substation",[-83.74801921252978, 42.98823613122494]],
    [ "Taloga",[-98.91977140639496, 36.06555960329639]],
    [ "448897531",[-98.41546290585632, 36.057669740366855]],
    [ "Woodward",[-99.3870282820949, 36.417952751631894]],
    [ "448900262",[-99.3922141514293, 36.42589667298691]],
    [ "Woodward",[-99.37041802179844, 36.37486341577496]],
    [ "Red Hills",[-99.34585325, 35.513547700000004]],
    [ "Morewood",[-99.27708275169937, 35.736786654639836]],
    [ "448905201",[-97.719129285618, 35.63897687011236]],
    [ "448905202",[-97.68222385735129, 35.595520349784096]],
    [ "448905394",[-98.57120316194396, 35.40669946052608]],
    [ "448906435",[-98.96762530712988, 35.55271182291733]],
    [ "448906436",[-99.01288026222149, 35.55085521945841]],
    [ "West Crawford Substation",[-97.635848013149, 38.82937739086256]],
    [ "Indianapolis Power & Light",[-86.04492427547514, 39.91309876473187]],
    [ "Schilling Substation",[-97.63061318472009, 38.785551566342676]],
    [ "Southgate Substation",[-97.58923605724823, 38.80519542277623]],
    [ "Northview Switching Station",[-97.53981337880425, 38.827641746412326]],
    [ "North Street Substation",[-97.57518603535516, 38.848543259376534]],
    [ "Salina Main Substation",[-97.6049554636706, 38.84811005664843]],
    [ "Anadarko",[-98.22821277509098, 35.08341988800623]],
    [ "LADWP DIstributing Station No. 24",[-118.53294522996292, 34.200083673378714]],
    [ "448959518",[-97.9471013394736, 34.346596838673996]],
    [ "Comanche",[-97.97081536091368, 34.34819904530535]],
    [ "448961183",[-97.73788644917347, 34.348137808785495]],
    [ "448961187",[-97.5986313293116, 34.42009226931251]],
    [ "448963031",[-98.03431280000001, 34.493376600000005]],
    [ "448964137",[-98.38037289164222, 35.10943238589007]],
    [ "448966357",[-98.46727034528206, 34.738631099111046]],
    [ "448967408",[-98.633926407427, 34.62382986100231]],
    [ "448968418",[-98.95771692954348, 34.65741417921374]],
    [ "448968420",[-98.98268631659039, 34.61660067405772]],
    [ "448968925",[-99.0128082900616, 34.412837987965204]],
    [ "448974932",[-99.0800519023547, 34.2470524215996]],
    [ "White City Substation",[-99.32946774999999, 34.283077299999995]],
    [ "448977160",[-99.52614461393176, 34.65298179724659]],
    [ "448979344",[-82.69066467410924, 34.88841200628627]],
    [ "Electra Substation",[-98.92217757700806, 34.01431505726565]],
    [ "Vernon Substation",[-98.95697600000001, 34.022103099999995]],
    [ "Shamrock Substation",[-100.25427549951291, 35.215817737543766]],
    [ "449001912",[-98.10828344262102, 35.16758221369466]],
    [ "449003221",[-98.02067010057752, 35.20326212140014]],
    [ "449003740",[-98.15985899104582, 34.84196147165247]],
    [ "449017740",[-86.92389695829924, 40.461329001023095]],
    [ "449022128",[-96.12128396143996, 36.12956229354141]],
    [ "449023266",[-95.97998754290936, 35.442190289439885]],
    [ "449024693",[-96.05580885394832, 35.26304534079678]],
    [ "449024699",[-96.1174760668217, 35.35257221651016]],
    [ "449025501",[-96.38680189863251, 35.83609598605488]],
    [ "Public Service Company of Oklahoma",[-95.99418369186192, 36.03151283018096]],
    [ "449026657",[-96.19086876833568, 36.06970556587566]],
    [ "449026658",[-96.23246649170595, 36.10400060713276]],
    [ "Stillwater 138",[-96.99007275263395, 36.11728853201696]],
    [ "Stillwater 69",[-96.99176937460386, 36.11674971659849]],
    [ "449031460",[-96.58784535000001, 36.003448399999996]],
    [ "Oklahoma Gas & Electric",[-96.03449445, 35.988868588456775]],
    [ "449034553",[-96.01309783544052, 35.971381816839596]],
    [ "449034851",[-96.62212506399366, 35.97815026936137]],
    [ "449107751",[-95.98033347373652, 35.87174077401194]],
    [ "449107964",[-95.90404832701235, 35.91336374464814]],
    [ "449108563",[-96.10182005060416, 35.91512551159206]],
    [ "449108662",[-96.2802624833238, 35.94435840161684]],
    [ "449109315",[-96.33281724567243, 35.80785429615809]],
    [ "449112655",[-96.45829231478984, 35.71497283556295]],
    [ "Luther",[-97.19390165, 35.717361800000006]],
    [ "449113714",[-97.6048007897257, 35.912477825059995]],
    [ "449114056",[-97.45298653094272, 35.76953751463063]],
    [ "449114249",[-97.45143489497518, 35.72598716325835]],
    [ "449115398",[-97.40665886931205, 35.899314435992466]],
    [ "449115400",[-97.28314606386644, 35.964433360006005]],
    [ "19th Avenue Substation",[-97.11436806086593, 36.1008322750524]],
    [ "Kinzie",[-97.10395188612259, 36.119908610325936]],
    [ "Ramsey",[-97.12329710493673, 36.04034899135112]],
    [ "KAMO Power",[-97.2103621662588, 36.01543544968424]],
    [ "Langston",[-97.2464070550914, 35.926211964461515]],
    [ "East Coyle",[-97.17811566253056, 35.95697977489468]],
    [ "Perkins",[-97.07000244999999, 35.927164649999995]],
    [ "Colfax Substation",[-84.09440661517472, 42.65873918356385]],
    [ "Indianapolis Power & Light",[-86.09282669975354, 40.00099852878085]],
    [ "Southard",[-98.46672498104367, 36.05649923285565]],
    [ "449225867",[-99.38873413361127, 36.50567168049094]],
    [ "South Creyts Substation",[-84.64307892150623, 42.7134818720301]],
    [ "Olds 5 Substation",[-84.65281363729252, 42.70729650574566]],
    [ "449286859",[-98.89171176273403, 36.37622585746987]],
    [ "449287391",[-98.42736837185488, 36.375437670421135]],
    [ "449288153",[-98.68228670020216, 36.83338122526954]],
    [ "449289076",[-98.98870133404297, 36.812744620427274]],
    [ "449289078",[-99.63075013091681, 36.826706900887984]],
    [ "449289214",[-99.64140353682022, 36.695813605142604]],
    [ "449290178",[-97.81750778169791, 35.99987155113986]],
    [ "449290180",[-97.64806050583516, 35.89899481479486]],
    [ "449290773",[-98.99693688660523, 35.47866905294646]],
    [ "Plaster Creek Substation",[-85.57292247455021, 42.87574199317768]],
    [ "Cicero Substation",[-87.75461135832559, 41.85153502110451]],
    [ "Forest Park Substation",[-87.8169193143825, 41.87240353506076]],
    [ "ComEd Galewood Substation",[-87.78578949990076, 41.923196557881106]],
    [ "Hanson Park Substation",[-87.75390503448637, 41.91646530203006]],
    [ "Portage Substation",[-87.7413331415727, 41.94827716958137]],
    [ "Washington Park Substation",[-87.61940451132168, 41.78205328518816]],
    [ "Duke Energy",[-79.74069860269333, 36.08318123214113]],
    [ "Bradley Substation",[-87.85934362684033, 41.16425621344803]],
    [ "Higgins Substation",[-87.80767033655835, 41.97931395667605]],
    [ "American Electric Power",[-83.0567294758281, 40.105226401022634]],
    [ "449451184",[-86.87785470000001, 34.754845100000004]],
    [ "Georgia Power",[-84.74637689331828, 32.05346790800475]],
    [ "449464051",[-84.70112717762568, 32.069166748723084]],
    [ "Packard Substation",[-84.82330736608948, 42.58477805633235]],
    [ "Island Road Substation",[-84.82169501041999, 42.567043349181134]],
    [ "Charlotte Substation",[-84.83526817990891, 42.56818063349039]],
    [ "Georgia Tap",[-98.2405345926553, 35.06918883609397]],
    [ "Carnegie",[-98.60597264647073, 35.05859627494615]],
    [ "Red Hills Tap",[-99.38259214132711, 35.53538972493323]],
    [ "449482296",[-99.26640831605133, 35.70793889059773]],
    [ "449496083",[-114.10051272174655, 46.93872447136381]],
    [ "449580363",[-86.94302829799557, 40.44638932756054]],
    [ "449591478",[-88.32284142025166, 30.977950219124825]],
    [ "Ayersville Substation",[-84.34231716781585, 41.267465353948715]],
    [ "Jonesboro City Water and Light",[-90.68526360950018, 35.84080208029352]],
    [ "449617044",[-73.89485879624935, 41.65830952799425]],
    [ "Entergy Arkansas",[-90.66200664459744, 34.556552023155184]],
    [ "Hansford County Switching Station",[-101.38776635006056, 36.40009950006087]],
    [ "Gruver Substation",[-101.41050190391061, 36.264104942094654]],
    [ "Noble Power",[-101.35115453468936, 36.45542482501107]],
    [ "Lasley Switching Station",[-101.82527555623416, 36.35412202506416]],
    [ "Hilmar Cheese Substation",[-102.5017641087623, 36.08406577511272]],
    [ "Xcel Energy",[-102.53588775, 36.0682731]],
    [ "Valero Sunray Wind Farm Substation",[-101.89250592898195, 35.95297922730787]],
    [ "Etter Rural Substation",[-101.97568575000001, 36.0253479]],
    [ "Exum Substation",[-102.13711822492056, 36.069921384583296]],
    [ "Ford City Substation",[-87.73331592021773, 41.76199729682732]],
    [ "ComEd Rosehill Substation",[-87.67423070814162, 41.98709861187369]],
    [ "Commonwealth Edison",[-87.7403043065025, 41.8661304746683]],
    [ "Berwyn Substation",[-87.78473517714076, 41.835783607303995]],
    [ "Ridgeland Substation",[-87.78522294901798, 41.8112878544365]],
    [ "Beaver Substation",[-84.08721849999999, 43.71221685]],
    [ "ComEd Gurnee TDC",[-87.96552805386143, 42.378851656240364]],
    [ "Old Elm TDC",[-87.8416327330617, 42.21215650372127]],
    [ "Waukegan Substation",[-87.8169763811348, 42.38355760285464]],
    [ "Mt. Forest Substation",[-84.13374181177369, 43.89810862477935]],
    [ "Hawthorne Substation",[-87.74809129182324, 41.84243520288842]],
    [ "Michigan Gypsum",[-83.7609517, 44.17885050000001]],
    [ "Ogemaw Substation",[-84.18685302450834, 44.259404956714455]],
    [ "Prescott Substation",[-83.92455410802594, 44.19449072487588]],
    [ "Junction",[-93.36179631405226, 37.216922759631835]],
    [ "Sedalia",[-93.31270374150968, 37.332901193723636]],
    [ "Brighton East",[-93.30790866941798, 37.45754182348902]],
    [ "Sedalia",[-93.31270166575165, 37.33290341556198]],
    [ "Parsons Substation",[-95.27127243436533, 37.3254698751103]],
    [ "Labette Substation",[-95.12199589292224, 37.17573251127732]],
    [ "Mountain Rub Substation",[-77.97400287595097, 38.4628966686855]],
    [ "Normandy Substation",[-89.70718325236683, 41.56076603314167]],
    [ "Wallace Substation",[-87.63968649024346, 41.74667944065699]],
    [ "Waterman Substation",[-88.75478222518106, 41.82787280670853]],
    [ "Rich Mountain Electric Cooperative",[-94.19244662603948, 34.579936989211376]],
    [ "450130899",[-89.03899804999999, 41.70375279999999]],
    [ "Commonwealth Edison",[-87.62616370391711, 41.78271842452821]],
    [ "Garden Plain Substation",[-90.11060325, 41.792838499999995]],
    [ "LaGrange Park Substation",[-87.86600636461782, 41.83575000647563]],
    [ "Rock Falls Substation",[-89.66115468433655, 41.76579766850901]],
    [ "Pickens Substation",[-80.20210882514333, 38.65853527310474]],
    [ "450250703",[-86.34058420000001, 32.57827125]],
    [ "City Utilities of Springfield",[-93.34442757211839, 37.19793113711433]],
    [ "Consumers Energy",[-83.35460117931306, 44.447139371526156]],
    [ "Cedar Lake Substation",[-83.35190954981536, 44.493025026525466]],
    [ "450363418",[-111.30284042565069, 32.588157541505495]],
    [ "Blackhawk SW YD",[-89.03130637312144, 42.507393899384844]],
    [ "Verona",[-89.51499095349378, 42.97290301969593]],
    [ "Kentucky Utilities Company",[-87.65853816621059, 37.424772919807054]],
    [ "Milton Substation",[-85.46426039729616, 43.70603863007448]],
    [ "Murfreesboro Substation",[-93.70083295671043, 34.06528455678642]],
    [ "Germantown SW YD",[-88.1492469645934, 43.19496405605137]],
    [ "Fredonia",[-87.95258416627905, 43.48548710280097]],
    [ "Entergy Arkansas",[-93.25620865, 33.284039299999996]],
    [ "Prescott Substation",[-93.40107396249395, 33.8087203693743]],
    [ "Clayton Highway Substation",[-85.49028580906975, 31.889197521821156]],
    [ "El Dorado East Substation",[-92.69624956714532, 33.206530225049434]],
    [ "Arkadelphia West Substation",[-93.09175870959177, 34.1171429802262]],
    [ "450694924",[-82.31894102463612, 27.92394299408515]],
    [ "450743944",[-119.27579312500599, 47.19091184995731]],
    [ "450743945",[-119.27774810801571, 47.146232071885905]],
    [ "Heber Springs Substation",[-92.00988458633428, 35.50523067376898]],
    [ "Monticello East Substation",[-91.76760422482984, 33.62704855382795]],
    [ "Hoboken Substation",[-74.03020475000001, 40.75710035]],
    [ "Fordyce Substation",[-92.41815310272445, 33.80571669259023]],
    [ "Entergy Arkansas",[-92.05937515999466, 34.194424923779366]],
    [ "451113905",[-89.5770851743087, 39.734553143157086]],
    [ "Bull Shoals Substation",[-92.5781064830631, 36.37040394806027]],
    [ "North Arkansas Electric Cooperative",[-92.38742785, 36.36258375]],
    [ "Barnum Creek Substation",[-85.17465079769408, 42.25670326359293]],
    [ "Zylman Substation",[-85.56175555, 42.19420155]],
    [ "Kilgore Substation",[-85.58869886751431, 42.243867773195504]],
    [ "Edgewater Substation",[-81.82329970924978, 41.48693266170565]],
    [ "Bartell Road Station",[-76.13359426740085, 43.22296643359911]],
    [ "Stuttgart North Substation",[-91.57433923983969, 34.522690074537664]],
    [ "Ulm Substation",[-91.46634675, 34.5578487]],
    [ "451615888",[-91.69339745247936, 34.43406919376072]],
    [ "Haskell Substation",[-92.64769544972413, 34.50100368404337]],
    [ "451687388",[-112.53816480129066, 45.99387088894212]],
    [ "451687389",[-112.67614482425392, 46.008435209015836]],
    [ "Entergy Arkansas",[-92.37718809132865, 34.66105352481723]],
    [ "451824892",[-112.50479295000002, 45.93519175]],
    [ "Northeast Substation",[-81.59985885035016, 41.52067215273832]],
    [ "Jardin Substation",[-99.23790847560603, 28.51987996493352]],
    [ "Reveille Substation",[-99.2581053953243, 28.414759034315008]],
    [ "Gateway Substation",[-99.4442159668719, 27.513442944522993]],
    [ "Santo Nino Substation",[-99.46149403021299, 27.475588416811544]],
    [ "Zacate Creek Substation",[-99.50033420000001, 27.5405375]],
    [ "Washington Street Substation",[-99.49860845, 27.509102750000004]],
    [ "Del Mar Substation",[-99.46631162808751, 27.576150269016637]],
    [ "Laredo Plant Substation",[-99.50686358054504, 27.56745534540267]],
    [ "Mines Road Substation",[-99.53022210198102, 27.636025505804344]],
    [ "Botines Substation",[-99.48051067237311, 27.685429630915497]],
    [ "North Laredo Switching Station",[-99.47756469346261, 27.69213779212232]],
    [ "Milo Substation",[-99.49992825000001, 27.61103135]],
    [ "Bordas Substation",[-98.99811751855533, 27.321192226635834]],
    [ "Rio Brava Substation",[-99.41952355352515, 27.313841873195333]],
    [ "University Substation",[-99.42984466443959, 27.58818141564258]],
    [ "Sierra Vista Substation",[-99.44829390988787, 27.437983774644625]],
    [ "Wormser Road Substation",[-99.41747789591734, 27.45460256545176]],
    [ "Bruni Substation",[-98.83002599447872, 27.43554293828649]],
    [ "Bruni Substation",[-98.8359135302199, 27.43957245892384]],
    [ "Whitetail Substation",[-99.00910235, 27.48660905]],
    [ "Cedro Hill Substation",[-98.92009779142025, 27.563807126360413]],
    [ "Molina Substation",[-99.41441950000002, 27.327793200000006]],
    [ "Cenizo Substation",[-99.41155741329453, 27.327584724734162]],
    [ "451988631",[-85.49430740000001, 39.820360599999994]],
    [ "451994541",[-82.29651429932257, 28.00258563011292]],
    [ "South River Electric Membership Corporation",[-78.44033330936402, 34.98937191613624]],
    [ "452034410",[-89.60202535342727, 40.66844459913886]],
    [ "Paragould Light & Water Commission",[-90.52087634999998, 36.05690489999999]],
    [ "Bevo Substation",[-99.84010555358275, 28.49651196711704]],
    [ "Big Wells Substation",[-99.56925034999999, 28.544282199999994]],
    [ "Crystal City Substation",[-99.81214194255605, 28.690017438749983]],
    [ "Dimmit Substation",[-99.87366529695471, 28.509189182779785]],
    [ "Carrizo Springs Substation",[-99.88454358095733, 28.493284989732995]],
    [ "La Pyor Substation",[-99.83360739326733, 28.939633799331272]],
    [ "West Crystal City Substation",[-99.95558729999999, 28.66503975]],
    [ "Crystal City Substation",[-99.75446335000001, 28.69863955]],
    [ "Carrizo Springs Substation",[-99.83484668072512, 28.51635101054137]],
    [ "Turtle Creek Substation",[-99.82700004999998, 28.732833799999998]],
    [ "Osceola North Substation",[-89.98995568073754, 35.70807941682145]],
    [ "452227271",[-91.20727885, 35.2553639]],
    [ "Freer Substation",[-98.86831815617221, 27.940516231781093]],
    [ "Holland Substation",[-99.16583097529103, 28.260366257516925]],
    [ "Hindes Substation",[-98.90265644044871, 28.646329375075865]],
    [ "Wynne Substation",[-90.78973323836247, 35.21311101975431]],
    [ "452474818",[-83.36854793355818, 41.538164028453245]],
    [ "Stryker Substation",[-84.42944057636214, 41.502417239826606]],
    [ "Wentworth Substation",[-83.72090749588945, 41.616484000189836]],
    [ "452534090",[-83.5704528184514, 41.66696425330498]],
    [ "DaimlerChrysler Substation",[-83.54596638324362, 41.556594399908754]],
    [ "Genoa Substation",[-83.35463068981741, 41.51521506442677]],
    [ "Meadowlark Substation",[-83.61153059236874, 41.60810522510375]],
    [ "Cross Substation",[-98.54002263603036, 28.69522479210009]],
    [ "Appalachian Power Company",[-81.49599913320297, 37.135487139758176]],
    [ "452691256",[-86.97977363753343, 40.44138637257759]],
    [ "452717273",[-157.91038284626686, 21.380890304562868]],
    [ "Halawa Substation",[-157.883117590724, 21.379492306540488]],
    [ "Pukele Substation",[-157.78674274840543, 21.312920118037127]],
    [ "Wahiawa Substation",[-158.02452247611646, 21.49258958665705]],
    [ "452742485",[-93.79249684746176, 33.610608225055586]],
    [ "Entergy Arkansas",[-93.77761728564883, 33.65680088914266]],
    [ "Crutchfield Substation",[-95.93417667935407, 30.584507387290213]],
    [ "Iola Substation",[-96.04634227033463, 30.73149722046003]],
    [ "Carlos Switching Station",[-96.16184611752345, 30.616077297528317]],
    [ "Big Foot Substation",[-98.86280199410844, 28.915554869330045]],
    [ "Charlotte Substation",[-98.69088673399459, 28.86905170128487]],
    [ "Tordillo Substation",[-98.18306493682627, 28.835196790806712]],
    [ "South Texas Electric Cooperative",[-98.48190615408308, 28.68782978082834]],
    [ "Fashing Substation",[-98.184450233205, 28.837897301203245]],
    [ "San Miguel Switchyard",[-98.4698178151437, 28.70028107521865]],
    [ "De Paul Substation",[-94.69968489354937, 37.43910594822115]],
    [ "Fort White Substation #20",[-82.6643059, 29.922446000000008]],
    [ "452959575",[-82.76869482513638, 27.99966549056046]],
    [ "Waldo Substation #56",[-82.18888016572264, 29.773455263144346]],
    [ "Keystone Heights Substation #28",[-82.0374659065525, 29.787337021010085]],
    [ "LKHoward Substation",[-98.57683395000001, 26.410840399999998]],
    [ "JackieHoward Substation",[-98.69841677368368, 26.56494562881557]],
    [ "MigHoward Substation",[-98.59449994464275, 26.487494631084584]],
    [ "Del Sel Substation",[-98.73702093810252, 26.457694450707038]],
    [ "DTE Energy",[-83.5580227682941, 42.20731822968565]],
    [ "453082095",[-111.84724097004981, 40.75989396893658]],
    [ "453100171",[-92.78767292557455, 33.654369542222994]],
    [ "Camden Substation",[-92.82235406139534, 33.542235025860464]],
    [ "Entergy Arkansas",[-92.79224858712844, 33.56387565790213]],
    [ "Roma Switching Station",[-99.0192064204049, 26.522645856297594]],
    [ "Liston Substation",[-98.57639040000001, 26.411361200000005]],
    [ "Garza Substation",[-98.7410917591884, 26.452289975748794]],
    [ "Randado Substation",[-98.92856835, 27.084086799999998]],
    [ "Randado Substation",[-98.9285243, 27.08351605]],
    [ "Sendero Substation",[-98.95248645000002, 27.15954805]],
    [ "Falcon Switching Station",[-99.09551710793947, 26.543886642774726]],
    [ "San Ygnacio Substation",[-99.38446464915559, 27.068714082913086]],
    [ "Lopeno Substation",[-99.10947675, 26.687615599999997]],
    [ "Entergy Arkansas",[-91.93626984953028, 34.262936733448555]],
    [ "453258081",[-104.29373173551194, 38.44648138351755]],
    [ "Entergy Arkansas",[-91.98108111941187, 34.22267858786415]],
    [ "Tubular Substation",[-96.08953120111843, 30.368302459376917]],
    [ "Panther Creek Wind 2 Substation",[-101.30174810000001, 31.95667215]],
    [ "Grelton Substation",[-101.88148520000001, 32.16639650000001]],
    [ "Long Draw Substation",[-101.6329669886736, 32.72112016898287]],
    [ "Bearkat Substation",[-101.53149895, 31.766046000000003]],
    [ "Sand Bluff Substation",[-101.27317559536435, 32.00357600929903]],
    [ "Clear Crossing Substation",[-99.60549439999998, 33.001373799999996]],
    [ "West Shackleford Substation",[-99.5378380049022, 32.635813836766474]],
    [ "Willow Valley Substation",[-101.39611730000001, 32.6506667]],
    [ "Faraday Substation",[-101.39575983053024, 32.648072852092064]],
    [ "Cirrus Substation",[-101.68371185000001, 33.03293779999999]],
    [ "Mesquite Creek Wind Substation",[-101.73975326865511, 32.70626628027712]],
    [ "Stephens Ranch Wind Project I Substation",[-101.65792405, 32.89803385]],
    [ "453439014",[-109.7165624666423, 32.774805233308186]],
    [ "453551434",[-115.85781555000001, 32.79178645000001]],
    [ "Alibates Substation",[-101.35964490514681, 35.25495877852136]],
    [ "Spinning Spur 1 Substation",[-102.43468474255943, 35.283196822313066]],
    [ "Spinning Spur 2 Substation",[-102.58255560060245, 35.292166212743446]],
    [ "AJ Swope Substation",[-102.05018605000001, 35.31350915]],
    [ "Hereford Wind Substation",[-102.29809545912651, 34.773053721543135]],
    [ "Windmill Substation",[-102.3045497, 34.7733778]],
    [ "Ogallala Substation",[-102.03868651537138, 34.51973652528061]],
    [ "Longhorn Wind Substation",[-101.24078964414679, 34.31678931119785]],
    [ "Tule Canyon Substation",[-101.35958697486966, 34.432227546462705]],
    [ "Cottonwood Substation",[-100.87653745, 33.7782993]],
    [ "Dermott Substation",[-101.0088003, 32.86022104999999]],
    [ "453609557",[-87.30974824999998, 40.12782465]],
    [ "Wellington Substation",[-82.19463755442344, 41.148138070402595]],
    [ "Camden Substation",[-82.27236357647409, 41.26082588514312]],
    [ "Brighton Substation",[-82.27245286126394, 41.186720007523824]],
    [ "Troy Substation",[-82.27294325162664, 41.02891939579962]],
    [ "Georgia Pacific GPC Switch 115KV FPL",[-81.66783865960382, 29.642038668350963]],
    [ "Hinckley Pond Substation",[-70.25590739091332, 43.6276156366276]],
    [ "Wheatland Electric Power Cooperative",[-98.75522353445523, 38.375834630808264]],
    [ "Cross Substation",[-100.89386901696913, 34.34399237957278]],
    [ "Tesla Substation",[-100.08684144651897, 34.37339364955335]],
    [ "Miami Wind Substation",[-100.54135655, 35.62022695]],
    [ "Gray Substation",[-100.81997140247726, 35.40760453028033]],
    [ "Pattern Panhandle Wind 1 Substation",[-101.2563436029602, 35.41477990338206]],
    [ "Railhead Substation",[-101.1538371, 35.4022323]],
    [ "Pattern Panhandle Wind 2 Substation",[-101.37284414062664, 35.44302829862465]],
    [ "Route 66 Wind Substation",[-101.43496464999998, 35.20591099999999]],
    [ "Grandview Wind Farm 1 Substation",[-101.18578555, 35.25412215]],
    [ "Mannville Substation #63 CLAY",[-81.83489616749114, 29.627850160612983]],
    [ "Francis Substation #34 CLAY",[-81.7058851193337, 29.636480496335437]],
    [ "454014374",[-82.51815005000002, 35.460155150000006]],
    [ "Mulberry Creek Substation",[-99.82239352593538, 32.524736392823364]],
    [ "Kirchhef Substation",[-100.21677549999997, 32.92533135]],
    [ "Gauss Substation",[-99.6615509, 33.4789378]],
    [ "Sand Road Substation",[-99.3059497119311, 34.141989624152075]],
    [ "American Electric Power",[-99.28643794281571, 34.15880017512741]],
    [ "Vernon City Plant Substation",[-99.29630951732504, 34.162275131815306]],
    [ "Blue Summit Wind Substation",[-99.36927256489724, 34.29412927860932]],
    [ "Jim Treece Substation",[-99.43416366994225, 34.23416299675788]],
    [ "East Abilene Substation",[-97.19570450693801, 38.93034663583215]],
    [ "Hamburg Substation",[-83.82153530597188, 42.45605984809586]],
    [ "Mill Creek North Substation FPL",[-81.53083464939034, 29.988502083209205]],
    [ "Thompson Substation",[-101.92677479246031, 33.542230425007396]],
    [ "454436995",[-94.45606665290423, 44.31552000101744]],
    [ "Junction City Substation",[-96.82317327570304, 39.0293166969205]],
    [ "West Junction City",[-96.86124032231874, 39.0084836369604]],
    [ "West Krum Substation",[-97.31061953098933, 33.3246131663195]],
    [ "454571796",[-84.45248901941692, 39.034155446462144]],
    [ "454584115",[-80.83122585000001, 35.08748615]],
    [ "454589940",[-94.42927490916948, 44.33300553002992]],
    [ "FIXME Substation",[-94.7014337855888, 37.81502003154217]],
    [ "454600573",[-94.44790482254015, 44.29662850305114]],
    [ "Glen Saint Mary Substation GTC",[-82.18437205000001, 30.2603231]],
    [ "454685962",[-95.74817515000001, 38.190294300000005]],
    [ "Aubrey Substation",[-96.99991190935535, 33.305062553779344]],
    [ "454696070",[-97.00057996716706, 33.02716567441618]],
    [ "454696143",[-96.75712819819279, 33.289383735372596]],
    [ "454696147",[-96.75704236006051, 33.29028637495708]],
    [ "454696151",[-96.7105632, 33.40023885000001]],
    [ "454696160",[-96.72468290288055, 33.36460870330694]],
    [ "454696189",[-97.036220497872, 33.54691449990183]],
    [ "454696193",[-97.39850706628665, 33.4285183170209]],
    [ "454696219",[-97.30781323816883, 32.87665912512209]],
    [ "Hicks Substation",[-97.38395375544285, 32.90413749863517]],
    [ "454724767",[-119.38390989999999, 47.1313186]],
    [ "Peden Road Substation",[-97.45447902509763, 32.94101494065189]],
    [ "Center Point Substation",[-97.54844929120003, 32.93511696290447]],
    [ "Briar Substation",[-97.54968511912648, 32.979243156270606]],
    [ "454866381",[-97.45521772387, 33.076216262548655]],
    [ "Rhome Substation",[-97.47430233579276, 33.07654289857738]],
    [ "Boyd Substation",[-97.54912083681185, 33.02756869932322]],
    [ "East Bell County Substation",[-97.2596030204148, 31.00456531270615]],
    [ "Navarro Switching Station",[-96.51800387994857, 31.963975230820612]],
    [ "Koppril Substation",[-97.86717376156186, 31.952630570434334]],
    [ "Romney Substation",[-98.67387365563062, 32.2448613856233]],
    [ "Florence Utilities",[-87.65588517465201, 34.86690286027009]],
    [ "Industrial Park Substation",[-87.661033675248, 34.87588184403612]],
    [ "Lewiston Substation",[-84.2896144535395, 44.884747758745156]],
    [ "Jackson RCF Substation",[-84.38836699999999, 42.2905034]],
    [ "454992669",[-97.87548584079231, 36.39144264707238]],
    [ "455124680",[-83.28987879776732, 42.86273492505989]],
    [ "455133210",[-95.63047239999999, 29.480622549999996]],
    [ "455142590",[-96.39530318864674, 34.00800364375805]],
    [ "455310941",[-123.81452931521586, 46.95113637760354]],
    [ "Florence Utilities",[-87.67441168408567, 34.85723340094626]],
    [ "Rogersville Substation",[-87.29939959920821, 34.811649472782946]],
    [ "455340176",[-97.39291086226476, 32.39236088027758]],
    [ "Parker Substation",[-97.67593734001987, 32.80839731774892]],
    [ "Sutton Substation",[-96.5277575417118, 30.81529145310633]],
    [ "Elihu Substation",[-84.57913420859546, 37.056788977832774]],
    [ "Big Spring Gulf Substation",[-101.40719085, 32.224542400000004]],
    [ "Colorado River Municipal Water District #4 Substation",[-100.76268939994338, 31.606991154177813]],
    [ "Colorado River Municipal Water District #2 Substation",[-100.17736594999998, 31.5508658]],
    [ "Colorado River Municipal Water District #8 Substation",[-101.95018955670851, 31.864396920567117]],
    [ "Colorado River Municipal Water District #3 Substation",[-100.50015330000001, 31.549751850000003]],
    [ "San Angelo Grape Creek Substation",[-100.57280019434478, 31.574336524518664]],
    [ "Big Hill Substation",[-100.54144645000001, 31.046259550000006]],
    [ "Rollans Substation",[-100.91127521636957, 31.91085356692499]],
    [ "Colorado River Municipal Water District #5 Substation",[-101.17869126979818, 31.70278461275635]],
    [ "Amoco Substation",[-100.86534484066054, 31.649548424437654]],
    [ "455575773",[-83.44131622411317, 42.61616564046937]],
    [ "Niles Substation",[-83.67034031941736, 41.9054566336377]],
    [ "Ameren Missouri",[-90.64799344999999, 38.362109849999996]],
    [ "455746945",[-80.21883905630632, 26.312335424854314]],
    [ "455759181",[-95.74757680645298, 32.86832391992926]],
    [ "455785131",[-92.4408558786631, 44.96028392394691]],
    [ "Atoka",[-96.10983349303896, 34.410290766890526]],
    [ "Duke Energy",[-82.15393513233228, 29.29624030256511]],
    [ "456132912",[-82.23001739423579, 29.458331737093605]],
    [ "456132915",[-82.20620051318843, 29.36629811440337]],
    [ "Florida Power & Light",[-82.82078611317831, 30.29195477496745]],
    [ "456221955",[-83.28820427478877, 30.34871983945568]],
    [ "456241581",[-82.23817518607287, 40.104032390110085]],
    [ "Crooksville Substation",[-82.09786455684696, 39.7695929420352]],
    [ "New Lexington Substation",[-82.21104098075666, 39.71886186585421]],
    [ "Shawnee Substation",[-82.21567643201696, 39.6049179020318]],
    [ "Withey Lake Substation",[-84.00763076756382, 44.306838425574306]],
    [ "456296101",[-115.8191474440047, 37.243439201730254]],
    [ "Petersville Substation",[-87.6912006, 34.85475829999999]],
    [ "Big Spring Colorado River Municipal Water District Substation",[-101.46844111384146, 32.29060517130777]],
    [ "Elbow Substation",[-101.47835764999999, 32.168852]],
    [ "Saint Lawrence Substation",[-101.4943253, 31.712167200000007]],
    [ "E.ON",[-101.27888702528215, 32.02510429056088]],
    [ "Cosden Substation",[-101.42167862930715, 32.27101838633781]],
    [ "Salem Substation",[-101.34985815861289, 32.32065277113275]],
    [ "Fairview Substation",[-101.48663625, 32.363297800000005]],
    [ "Luther Substation",[-101.5157994, 32.459730400000005]],
    [ "Colorado City Substation",[-100.94376711966281, 32.41846463945781]],
    [ "Barber Lake Substation",[-100.91546299999999, 32.39983555]],
    [ "456423221",[-84.42952611864327, 39.01050261331466]],
    [ "456461753",[-97.96973135315872, 35.065017217420575]],
    [ "Stiles Substation",[-101.5861363529234, 31.434574532523563]],
    [ "East Stiles Substation",[-101.47972119309688, 31.559835824793943]],
    [ "456635349",[-95.39604967308136, 35.746388312861384]],
    [ "456635352",[-95.41196755, 35.7710693]],
    [ "456635354",[-95.36326195000001, 35.776270999999994]],
    [ "Oklahoma Gas & Electric",[-95.41517495000001, 35.77371615]],
    [ "Florence Utilities",[-87.69294619999998, 34.79240765]],
    [ "Florence Utilities",[-87.69247785, 34.792676549999996]],
    [ "Mount Rozell Substation",[-87.12208682625392, 34.92996452235401]],
    [ "456681036",[-82.13556734999999, 29.177957799999998]],
    [ "456688083",[-82.09484872060366, 29.162764746523383]],
    [ "Salt Flat Road Substation",[-101.94081486534684, 31.71886287004003]],
    [ "Skywest Substation",[-101.93009626236532, 31.71846102045081]],
    [ "Driver Substation",[-101.7994443410494, 31.73330914366886]],
    [ "Pembrook Substation",[-101.82126102858014, 31.567013908357726]],
    [ "South Midland Substation",[-102.01446246427724, 31.954430015627032]],
    [ "Midkiff Substation",[-101.75871554999999, 31.650533299999996]],
    [ "Virginia Electric and Power Company",[-76.33174207445438, 36.83990351742735]],
    [ "456864042",[-76.33125221668405, 36.838972071201084]],
    [ "456868050",[-86.0063937185493, 39.196994538632595]],
    [ "456868447",[-85.93319731812086, 39.27371728488175]],
    [ "456881962",[-122.66420585, 48.335658499999994]],
    [ "456905518",[-80.84953608273001, 41.26753115050595]],
    [ "East Midland Substation",[-101.99856818289713, 32.044256218439656]],
    [ "Koch Substation",[-101.6566572, 32.4861067]],
    [ "Sale Ranch Substation",[-101.89967157075236, 32.20766653521456]],
    [ "Buffalo Substation",[-101.86787112920689, 32.1074457084064]],
    [ "Triangle Substation",[-101.81886402062429, 32.12817246345729]],
    [ "Greenwood Substation",[-101.9118510294241, 32.02477240894756]],
    [ "Grady Substation",[-101.93237358830625, 32.3073644163779]],
    [ "Brown Substation",[-101.7454975, 32.454711350000004]],
    [ "Backus Substation",[-84.60021951096695, 44.30493162495628]],
    [ "457100699",[-82.05823980000001, 29.221484599999997]],
    [ "457100700",[-82.08796919166538, 29.206110975360534]],
    [ "457121836",[-83.32444611346769, 40.212587180237605]],
    [ "457242441",[-105.96370566960132, 32.90785001668312]],
    [ "457242442",[-105.96455518786306, 32.908008080745866]],
    [ "Alamogordo Sub",[-105.96409283709862, 32.909451546690086]],
    [ "Distributing Station 143",[-118.28482838107495, 33.89491675883118]],
    [ "Corn Belt Power Cooperative",[-94.18875723120735, 42.674558813521344]],
    [ "Burt Switching Station",[-94.15864911410594, 43.16994951134297]],
    [ "457354633",[-82.17192505, 29.184219449999997]],
    [ "457362577",[-94.52294307884955, 44.32986886432765]],
    [ "Cranbrook Substation",[-85.09804105, 42.29088290000001]],
    [ "MSI Substation",[-85.0977644, 42.290331450000004]],
    [ "Cannon Branch",[-77.50262720150508, 38.74377559973083]],
    [ "Water Street Substation",[-78.13770648286146, 40.571546032303594]],
    [ "Alexandria Substation",[-78.11895041129682, 40.562716792270045]],
    [ "Big 3 Substation",[-102.34515722082078, 31.819347744199863]],
    [ "Odessa Southwest Substation",[-102.39134164999997, 31.7988654]],
    [ "Amoco South Foster Substation",[-102.43881280070451, 31.838936671245587]],
    [ "Westover Substation",[-102.44350704239235, 31.835991683250754]],
    [ "Olefin Substation",[-102.32708965, 31.8273141]],
    [ "Rexene Nylon Substation",[-102.33479137200767, 31.819578142362346]],
    [ "Nylon Switching Station",[-102.3350181298752, 31.826002373602194]],
    [ "Liquid Air Substation",[-102.33518885996288, 31.83963697450721]],
    [ "Colorado River Municipal Water District #8 Substation",[-102.24681481125333, 31.948709482454262]],
    [ "Midland Airport",[-102.22965194711834, 31.935582281518666]],
    [ "Midessa Substation",[-102.17531149999999, 31.967051500000004]],
    [ "Midland Downtown Substation",[-102.07705775909133, 31.99295362461267]],
    [ "Midland County Northwest Substation",[-102.24625654999998, 32.03737915000001]],
    [ "Mockingbird Substation",[-102.17582992049093, 32.0385283788852]],
    [ "Windwood Substation",[-102.07648795000001, 32.019592300000006]],
    [ "Goddard Substation",[-102.12552025720704, 32.036028455347044]],
    [ "Tall City Substation",[-102.0900886, 32.074988450000006]],
    [ "Harris Hydro Substation",[-69.86514005684222, 45.45927049862964]],
    [ "Cleveland Public Power",[-81.66306939930294, 41.52590798052485]],
    [ "457769634",[-110.70700399171093, 46.37017271733813]],
    [ "457838993",[-115.3373413938142, 36.131463354327764]],
    [ "Stone Street Substation",[-83.13630459021394, 41.35539301544667]],
    [ "Amoco Midland Farms Substation",[-102.42488011216912, 32.14197742313613]],
    [ "Unocal Parker-Bakke Substation",[-102.59073694132432, 32.26154772424693]],
    [ "XTO University Substation",[-102.57005342065466, 32.19239434558919]],
    [ "Emma Substation",[-102.59258255800404, 32.15379662552626]],
    [ "Oncor",[-102.57726472926635, 31.988825108426795]],
    [ "OXY North Cowden Substation",[-102.51677327456385, 32.006051119967964]],
    [ "North Cowden Substation",[-102.49526245000001, 32.0068838]],
    [ "Ector North Substation",[-102.54917007059858, 31.994750845011463]],
    [ "Ector County Energy Center Substation",[-102.58603353602287, 32.069955267236466]],
    [ "Goldsmith Substation",[-102.63651310000002, 31.975004900000005]],
    [ "Goldsmith Gulf Substation",[-102.63603255, 31.9737185]],
    [ "Goldsmith South Substation",[-102.6148614598304, 31.929952570690094]],
    [ "Odessa Basin Substation",[-102.56685600071572, 31.89756449026907]],
    [ "Goldsmith Junction",[-102.55817992936652, 31.868993655780713]],
    [ "Holt Switching Station",[-102.58418531835189, 32.063752777110004]],
    [ "Texaco Mabee Substation",[-102.2289797208319, 32.20949294318378]],
    [ "Fasken C Ranch Substation",[-102.26886507932855, 32.17694045469445]],
    [ "Oncor",[-102.22604365392648, 32.19750690891853]],
    [ "Oncor",[-102.19124415000002, 32.179337600000004]],
    [ "Oxy South Curtis Ranch Substation",[-102.15961159999999, 32.1298452]],
    [ "Cadillac Substation",[-85.30017587019715, 44.25959367693884]],
    [ "South Boardman Substation",[-85.21091107737189, 44.641433676892476]],
    [ "Fountain Hill Substation",[-75.40490064999999, 40.606156299999995]],
    [ "Florence Utilities",[-87.6817522708353, 34.81910208221553]],
    [ "Spraberry Substation",[-101.97826922083165, 31.84316256356415]],
    [ "Spraberry Substation",[-101.97795923829138, 31.841368353928456]],
    [ "Rebel Substation",[-101.71541575778365, 31.90451440563523]],
    [ "458134469",[-101.28107506840105, 32.086611947228214]],
    [ "Morrison Sub",[-87.49063261821016, 40.76860259532125]],
    [ "458144515",[-87.4484155250485, 40.7675857016277]],
    [ "458174970",[-119.38889825229737, 46.27977430362385]],
    [ "Vestaburg Substation",[-84.9118637, 43.40049584999999]],
    [ "Wolverine Power Cooperative",[-84.91221077867867, 43.4011425253074]],
    [ "Vestaburg Substation",[-84.9141964466417, 43.40135391352886]],
    [ "Deerfield Substation",[-84.92709552624812, 43.590487390161805]],
    [ "458205234",[-122.61738593885792, 38.91067055835344]],
    [ "Pacific Gas and Electric Company",[-122.60895986770132, 38.93702204086168]],
    [ "Saranac Substation",[-85.21492813977534, 42.93883463258486]],
    [ "Consumers Energy",[-85.23623987976227, 42.95817148749028]],
    [ "Godfrey Substation",[-85.35110382540117, 42.94716479487656]],
    [ "Foreman Substation",[-85.41029286681383, 42.94549479000428]],
    [ "Thompson Road Substation",[-85.24547355117996, 42.80139041701177]],
    [ "Consumers Energy",[-85.14085130113693, 42.78703762064717]],
    [ "Superior Substation",[-85.07639723036257, 42.84262324199882]],
    [ "Odessa Substation",[-85.07670103474142, 42.843550834917416]],
    [ "Portland Substation",[-84.91784965937488, 42.872742374976795]],
    [ "Big Spring Air Park Substation",[-101.513797614713, 32.22784216354703]],
    [ "Big Spring West Substation",[-101.50084753733732, 32.24335276637945]],
    [ "Stanton Wind Energy Substation",[-101.81898294732136, 32.21120595427957]],
    [ "Stanton Substation",[-101.79657534999998, 32.138677200000004]],
    [ "Martin Cap Substation",[-101.79350405, 32.14018225]],
    [ "Stanton East Substation",[-101.75791000145519, 32.15872613808738]],
    [ "Emerson Substation",[-85.5309933, 42.86069125]],
    [ "East Paris Substation",[-85.55832464295356, 42.86163898442854]],
    [ "Cutlerville Substation",[-85.66646841392661, 42.838779687276045]],
    [ "Division Substation",[-85.66688955514884, 42.811308485233006]],
    [ "458420743",[-84.10895498792755, 41.407949632593834]],
    [ "458420746",[-84.096852868785, 41.37099778870576]],
    [ "458510553",[-80.20678175, 35.357780399999996]],
    [ "Wallen Substation",[-85.16480221069094, 41.16181401672756]],
    [ "458535482",[-84.61259692612106, 41.179007405967]],
    [ "Payne Station",[-84.72556870418602, 41.09235888842022]],
    [ "Getty Vealmoor Substation",[-101.36165545994524, 32.48512427569767]],
    [ "Knott Substation",[-101.58970443583216, 32.41463468658264]],
    [ "Ackerly Chevron Substation",[-101.65173375, 32.480405749999996]],
    [ "Buzzard Draw Switching Station",[-101.67716213980067, 32.49818543568908]],
    [ "China Grove Switching Station",[-100.87360723443598, 32.523387377054775]],
    [ "458594991",[-84.75283970499233, 41.28424794317172]],
    [ "458723562",[-106.60725740398229, 34.50389036702065]],
    [ "Belen Substation",[-106.81729460332835, 34.61801387724596]],
    [ "Willard",[-106.06138604985294, 34.61445070133887]],
    [ "La Luz Sub",[-106.817018, 34.616223]],
    [ "Willard SW",[-106.08593185470016, 34.60958684005234]],
    [ "458723567",[-106.08684138833128, 34.782430712086565]],
    [ "Ackerly Substation",[-101.7881449706503, 32.59480634661869]],
    [ "Sparenburg Substation",[-101.81642610000002, 32.6187575]],
    [ "South Lamesa Substation",[-101.90271111445007, 32.690162120400444]],
    [ "Ackerly Substation",[-101.71024725000001, 32.52919395]],
    [ "Gail Substation",[-101.45880195000001, 32.6583351]],
    [ "Key Substation",[-101.78933549999999, 32.69250234999999]],
    [ "458732735",[-85.04268859914735, 41.266875979902245]],
    [ "458732747",[-85.04810130245004, 41.36168189394046]],
    [ "458734780",[-85.03462094999999, 41.4062091]],
    [ "458734784",[-85.03187442033423, 41.42477733127255]],
    [ "Union Substation",[-85.34340344381093, 41.17282368912083]],
    [ "458766011",[-85.53050941809958, 40.85966884788928]],
    [ "458768000",[-85.16610118283407, 40.763888428057946]],
    [ "458768003",[-85.17622423851282, 40.84494453010953]],
    [ "458768762",[-85.04724719999999, 40.831912499999994]],
    [ "AEP Decatur Substation",[-84.93096950000002, 40.8351733]],
    [ "Fairfield Substation",[-76.23475890000002, 35.565474550000005]],
    [ "Swindell Fork Substation",[-76.28023421347157, 35.45883623270255]],
    [ "458949512",[-115.99746705655977, 36.66373097178877]],
    [ "458975866",[-92.4734597, 46.865527750000005]],
    [ "Andrews Substation",[-102.64568907038976, 32.29319534478535]],
    [ "Dollarhide Substation",[-102.87125478459727, 32.08192151538302]],
    [ "Notrees Switching Station",[-102.8762998991109, 32.07685068342346]],
    [ "Andrews Substation",[-103.06190162360659, 32.426242572940836]],
    [ "Phillips Andrews Substation",[-102.88661124999999, 32.40919665]],
    [ "Exxon Fullerton Substation",[-102.7974433295263, 32.42298955507926]],
    [ "459062025",[-102.6625086, 32.45154925]],
    [ "Frankel City Substation",[-102.78193582087627, 32.381448500252745]],
    [ "Whalen Lake Substation",[-102.73645890636223, 32.35154922041521]],
    [ "Arena Substation",[-102.67753746965407, 32.22366070664584]],
    [ "Andrews County South Switching Station",[-102.77732984999999, 32.164930399999996]],
    [ "Andrews County South Switching Station",[-102.7768715197471, 32.16350269333862]],
    [ "459062052",[-102.53101940073795, 32.437037755374895]],
    [ "Exxon Means Substation",[-102.54706211615083, 32.43279826735374]],
    [ "Bakke Substation",[-102.5383428356165, 32.291703579581636]],
    [ "Means Substation",[-102.55564679999999, 32.45725185]],
    [ "Oxy Welch Substation",[-102.13773045000002, 32.896391200000004]],
    [ "Welch Substation",[-102.10131734461456, 32.902305529782254]],
    [ "Golden Spread Electric Cooperative",[-102.0524972, 32.690798900000004]],
    [ "West Lamesa Substation",[-102.06022355, 32.71566365]],
    [ "Patricia Substation",[-102.00807291762261, 32.5498912702304]],
    [ "Midland Farms Substation",[-102.42579570000001, 32.145804000000005]],
    [ "San Andres Substation",[-102.49754577947779, 32.19175111022409]],
    [ "459229640",[-90.52807290000001, 42.60977760000001]],
    [ "Wink Substation",[-103.1446454808854, 31.762982142857783]],
    [ "Winkler County #6 Substation",[-103.07248397230367, 31.665726185952813]],
    [ "AA Pipeline Substation",[-103.17632295, 31.764229]],
    [ "Wink Substation",[-103.16284183173963, 31.763284014464123]],
    [ "Kermit #2 Substation",[-103.09602191820788, 31.852057635801366]],
    [ "Keystone Substation",[-103.08097786440354, 31.87918142226186]],
    [ "Kermit #1 Substation",[-103.08157775, 31.848372899999998]],
    [ "Wink Gulf Substation",[-103.13479014999999, 31.78823295]],
    [ "Wink Basin Substation",[-103.13232226337182, 31.790382676575256]],
    [ "Keystone Substation",[-103.1450364195342, 31.907258739594713]],
    [ "Midway Substation",[-102.72702027307797, 31.841508795965638]],
    [ "California Substation",[-103.13063009989531, 31.77471919677804]],
    [ "Vest Substation",[-103.03529254019455, 31.769744424550197]],
    [ "Sandridge Energy Substation",[-102.64813915, 31.857932749999996]],
    [ "Amoco Three-Bar Substation",[-102.80578234999999, 32.14505959999999]],
    [ "Unocal Dollarhide Substation",[-103.0422361, 32.14632735]],
    [ "Cheyenne Substation",[-103.04452535928367, 31.934694320210774]],
    [ "459259473",[-94.72527824978239, 44.298574507148025]],
    [ "Kapiolani Substation",[-157.81581736373994, 21.288181361139348]],
    [ "Florence Utilities",[-87.6577142, 34.8157195]],
    [ "Florence Utilities",[-87.68690073333988, 34.806072199959424]],
    [ "Manoa Substation",[-157.82237959417947, 21.299838765665694]],
    [ "Helios Substation",[-99.69974625000002, 29.22606495]],
    [ "459701375",[-122.73502158485843, 47.72342907803701]],
    [ "Quaker Substation",[-101.90563957121697, 33.49833955257081]],
    [ "Monahans Substation",[-102.89956564443884, 31.59421938011443]],
    [ "Oncor",[-103.02662138203998, 31.583426121492167]],
    [ "Wickett Substation",[-103.02376600896098, 31.575470232165316]],
    [ "459878011",[-102.99117546039042, 31.581094983517744]],
    [ "Northward Substation",[-103.07215239999998, 31.637342999999994]],
    [ "Goldsmith Amoco Substation",[-102.65312839038342, 31.990651271388487]],
    [ "Edwards Substation",[-102.50446174999999, 31.644141799999996]],
    [ "Southwestern Portland Cement Substation",[-102.54477231472845, 31.746951171180307]],
    [ "Judkins Substation",[-102.59715059999999, 31.71644835]],
    [ "Sandhills Substation",[-102.67196630000001, 31.52956065]],
    [ "Wickett Substation",[-103.02120342989869, 31.598044305897833]],
    [ "Permian Basin Station",[-102.95992251680521, 31.58390954272205]],
    [ "Jug Street Substation",[-82.74807207571014, 40.09556751393461]],
    [ "460070142",[-119.26698792515502, 45.91518785279318]],
    [ "460073770",[-103.47617025, 31.70421665]],
    [ "Mason Substation",[-103.81830017927254, 31.80243154487711]],
    [ "El Mar Substation",[-103.61986990000001, 31.78809345]],
    [ "Anderson Ranch Point of Interconnection",[-103.48231354999999, 31.779937550000003]],
    [ "Loving Substation",[-103.40556265904527, 31.7759762996425]],
    [ "Facebook",[-81.82715894999998, 35.31302185]],
    [ "460122019",[-95.62615656595801, 41.47023553268604]],
    [ "KAMO Power",[-96.409903995191, 36.29925266976044]],
    [ "Franklin Substation",[-74.54384399714435, 40.53598166095458]],
    [ "Sentinel Substation",[-74.54428261126617, 40.53886528083982]],
    [ "Cuthbert Boulevard",[-75.05358910188534, 39.933675179528606]],
    [ "East Waynesboro Substation",[-77.55689532580233, 39.74415204842654]],
    [ "460319410",[-83.5044433889572, 42.225997675306196]],
    [ "Spade Ranch Substation",[-100.84400828077574, 31.97289875575143]],
    [ "460593044",[-102.54014245, 36.07950565]],
    [ "Channing Substation",[-102.3269979005723, 35.68907558883419]],
    [ "Osage Switching Station",[-101.81228023291253, 35.14880331622589]],
    [ "Owens-Corning Substation",[-101.85930157024315, 35.11424745433084]],
    [ "Manhattan Substation",[-101.80462800000001, 35.18495325]],
    [ "Hillside Substation",[-101.9479586, 35.14637945]],
    [ "Vega Substation",[-102.41649819999999, 35.25347185]],
    [ "North Amarillo Substation",[-101.88372855, 35.250522]],
    [ "Hastings Substation",[-101.84994286725042, 35.25030011603053]],
    [ "Rolling Hills Interchange",[-101.84098485000001, 35.295661650000014]],
    [ "Northwest Substation",[-101.93721749999999, 35.2508256]],
    [ "Cliffside Substation",[-101.99086316698323, 35.35254313111195]],
    [ "Spinning Spur 3 Substation",[-102.71029645990681, 35.29717071655107]],
    [ "Omaha Substation",[-83.47486331323388, 42.35828332896256]],
    [ "460652024",[-88.88885487869109, 36.50423120550162]],
    [ "Fairmont Substation",[-75.21717295150914, 38.65407008685142]],
    [ "460785057",[-96.41938933659844, 33.62954528612173]],
    [ "460785059",[-96.23574645454826, 33.58878085074689]],
    [ "460785061",[-96.21500163590858, 33.58487033508886]],
    [ "460785062",[-96.19932546465597, 33.562615266191266]],
    [ "Horse Cave Substation",[-85.8974905, 37.17409705]],
    [ "460829614",[-85.09984621684379, 34.98433701881437]],
    [ "Avonlea Substation",[-84.05197327111352, 34.04318424946927]],
    [ "461033100",[-78.60847593826554, 35.82715292089898]],
    [ "Fain Substation",[-101.86643568330389, 35.54485344932662]],
    [ "461044981",[-101.65217448149265, 35.43028159591867]],
    [ "Canadian River Municipal Water Authority #3 Substation",[-101.60256182787805, 35.56983849471469]],
    [ "Exell Substation",[-101.97343202504949, 35.631082007934225]],
    [ "Duke Energy",[-82.70534928099725, 28.231174311629015]],
    [ "461233058",[-106.06826937578957, 32.91988735299356]],
    [ "West Orogrande Sub",[-106.14186387453601, 32.40552888870985]],
    [ "461233061",[-106.06769811046863, 32.83278011125461]],
    [ "Orogrande Substation",[-106.09908266519697, 32.37104220864381]],
    [ "461244568",[-84.06528316123251, 34.00150329062796]],
    [ "461341095",[-85.23616703505654, 38.20408209056972]],
    [ "MidAmerican Energy",[-91.04107608727338, 41.584319668179916]],
    [ "461446431",[-86.19444077052674, 32.338596415287086]],
    [ "Waterman Substation SECO",[-81.70847680777527, 28.825060726473016]],
    [ "Steep Hollow Substation",[-96.26946410542988, 30.68767413768225]],
    [ "Twin Buttes 1 Substation",[-102.82269406776938, 37.67341871521762]],
    [ "461595990",[-102.77202288294767, 38.47537156229703]],
    [ "461621896",[-94.7459675511129, 44.3256353522289]],
    [ "461624917",[-94.66396517906928, 44.3151147965531]],
    [ "461626533",[-94.6069704755912, 44.32626798653915]],
    [ "Spring Valley Substation",[-97.27863756595862, 31.38042492454327]],
    [ "Cotton Belt Substation",[-97.3175104, 31.427908950000003]],
    [ "Baylor Substation",[-97.10429589498659, 31.550806875835384]],
    [ "Troy Substation",[-97.30752948129353, 31.209694032739137]],
    [ "Temple Northwest Substation",[-97.40232869269896, 31.109405970149623]],
    [ "Temple North Substation",[-97.33616772606663, 31.134184910751724]],
    [ "Moffat Substation",[-97.43754719416987, 31.203958276348644]],
    [ "Moody Substation",[-97.37578811481197, 31.275282372149444]],
    [ "Bosque Substation",[-97.37505254094097, 31.685868817299216]],
    [ "China Spring Substation",[-97.3033750333857, 31.67166120759225]],
    [ "China Spring Substation",[-97.30424510361831, 31.67113458966642]],
    [ "Perry Substation",[-96.87622807924865, 31.440253914481794]],
    [ "Mexia Substation",[-96.48637182256392, 31.68298910445253]],
    [ "Groesbeck Main Substation",[-96.54108645506895, 31.5212080338784]],
    [ "Groesbeck Substation",[-96.4755130898827, 31.514122524210418]],
    [ "Ben Hur Substation",[-96.68681172268239, 31.50334684064247]],
    [ "Windsor Substation",[-97.30096630624898, 31.507830088391444]],
    [ "Cayote Substation",[-97.39644067825145, 31.814475089254167]],
    [ "Waco M&M Mars 2 Substation",[-97.19582005346, 31.487078719901554]],
    [ "Waco Lasalle Substation",[-97.071795, 31.543129950000004]],
    [ "Waco South Substation",[-97.1323189112641, 31.526002531696623]],
    [ "Waco Colonial Avenue Substation",[-97.16181804222282, 31.547396740358916]],
    [ "Northcrest Substation",[-97.09359715418955, 31.642539767744513]],
    [ "Waco Katy Substation",[-97.10004443293101, 31.584325893763992]],
    [ "Hallsburg Substation",[-97.00568314167919, 31.524276231302135]],
    [ "Navarro Mills Substation",[-96.68689697002671, 31.958810505683566]],
    [ "461754866",[-96.6723176, 31.951248249999992]],
    [ "Prairie Hill Substation",[-96.77494070245278, 31.652090145103447]],
    [ "Emmett Substation",[-96.81160616805488, 32.021298772332095]],
    [ "Purdon Substation",[-96.64196510358073, 31.978018508475376]],
    [ "Louisville Gas and Electric",[-85.66506345175205, 38.191283856380956]],
    [ "Pullman Substation",[-101.70620960000001, 35.200231050000006]],
    [ "Southeast Substation",[-101.75084855, 35.17812]],
    [ "Millsboro Substation",[-75.29051228665868, 38.59681265846159]],
    [ "East Substation",[-95.08282012187149, 44.53908645002584]],
    [ "461989796",[-82.51854302336174, 28.491588912958946]],
    [ "461989797",[-82.54510339999999, 28.529091300000005]],
    [ "461989798",[-82.54626524658723, 28.528388007240014]],
    [ "462176671",[-91.4517414040528, 31.556765366731533]],
    [ "Mount Mansfield Substation",[-72.7691591, 44.515209000000006]],
    [ "Titusville Substation",[-79.65948871603392, 41.622602908224735]],
    [ "Santa Fe Switching Station",[-97.62995478624669, 31.38644130911034]],
    [ "Santa Fe Substation",[-97.58376703019151, 31.437481246337676]],
    [ "Fort Gates Substation",[-97.70854542613492, 31.414614510432628]],
    [ "462426674",[-97.83065908091568, 31.130821907498085]],
    [ "Killeen Clarke Road Substation",[-97.84339398982716, 31.110383970611036]],
    [ "Killeen Clear Creek Substation",[-97.82110281706909, 31.110003251212397]],
    [ "Killeen Fort Hood West Substation",[-97.81278154527652, 31.109134627448693]],
    [ "Killeen South Substation",[-97.76843575000002, 31.0630382]],
    [ "Gatesville Switching Station",[-97.62178815, 31.378531950000003]],
    [ "Leon Junction Substation",[-97.58372145, 31.34181025]],
    [ "Gatesville Army Substation",[-97.6890244, 31.362646550000004]],
    [ "Cedar Valley Substation",[-97.68631742546539, 30.929264016833972]],
    [ "Ding Dong Substation",[-97.7666802006954, 30.987370833014076]],
    [ "Trimmer Substation",[-97.68147687613548, 31.007858145048733]],
    [ "Killeen Fort Hood Substation",[-97.76651467031883, 31.132506990908634]],
    [ "Nolanville Substation",[-97.54490455000001, 31.08710725]],
    [ "Harker Heights Substation",[-97.67180010924619, 31.09774095614651]],
    [ "Killeen Taft Street Substation",[-97.7075974691928, 31.10120285231282]],
    [ "Temple South Substation",[-97.37437213450019, 31.07669068268919]],
    [ "Cameron Substation",[-96.98952850296544, 30.84937052163031]],
    [ "Marak Substation",[-97.04909223561124, 30.8933671433811]],
    [ "Panda Temple 1 Substation",[-97.31508798067658, 31.057066347500644]],
    [ "Panda Temple 2 Substation",[-97.31653179555119, 31.057537904125045]],
    [ "Knob Creek Switching Station",[-97.31271425000001, 31.056312000000005]],
    [ "Silver City Substation",[-96.92757775261546, 30.916906220225822]],
    [ "462444169",[-88.7240864499899, 44.41646345003904]],
    [ "Elwood",[-82.58429626034084, 37.316935445694924]],
    [ "Slaton Substation",[-101.83814592323797, 33.53477851679917]],
    [ "Manor Substation",[-97.5092854618455, 30.349482718518253]],
    [ "Swiftex Substation",[-97.31264039580941, 30.20264460472942]],
    [ "Elgin Substation",[-97.34049522964517, 30.33465411736749]],
    [ "Hillbig Substation",[-97.40439078920151, 30.005560165453645]],
    [ "Wyldwood Substation",[-97.47365383619983, 30.131025729645888]],
    [ "Stoney Ridge Substation",[-97.63570945888226, 30.15883808397348]],
    [ "Elroy Substation",[-97.62435388734976, 30.14127386254158]],
    [ "Dunlap Substation",[-97.53973235000001, 30.275384100000004]],
    [ "Webberville Solar Substation",[-97.5026136920334, 30.242631749171878]],
    [ "East Substation",[-95.57145951242674, 43.63257036720436]],
    [ "Westside Substation",[-115.27883462261863, 36.1582115221966]],
    [ "463032443",[-110.45596201829244, 33.35440080697503]],
    [ "463040702",[-89.60598664999999, 39.720602549999995]],
    [ "463070935",[-91.46138654002367, 44.7701689251629]],
    [ "Fayetteville Public Works",[-78.86210898190518, 35.05607418769454]],
    [ "Perryville Substation",[-76.07683223871817, 39.556448650416876]],
    [ "AEP West Lincoln 69kv Station",[-83.0801905262748, 40.306461145796874]],
    [ "Stone Pool Substation",[-83.07089641198823, 42.35133370866418]],
    [ "463244193",[-86.30970835, 42.17605464999999]],
    [ "463280213",[-81.70208243539729, 41.362096531257414]],
    [ "463313333",[-80.73951181085461, 34.86659505994082]],
    [ "Findley Reservior #1 Substation",[-83.55987978320871, 41.01590166369474]],
    [ "463579322",[-82.29486584391589, 27.81880178337633]],
    [ "Utah Power and Light",[-111.7170127660448, 40.28316551230821]],
    [ "Industrial Substation",[-101.44348324726418, 35.66258616813293]],
    [ "Huber Cogeneration Station",[-101.43182455, 35.667631099999994]],
    [ "Adobe Creek Substation",[-101.01899703012808, 35.76008380270734]],
    [ "463732568",[-100.81548498602262, 35.75167253136696]],
    [ "Kite Substation",[-100.9813072, 35.57712155]],
    [ "463732611",[-101.44971735, 35.82839345]],
    [ "Highland Park Substation",[-101.65436981314848, 35.25242182427633]],
    [ "Gray County Interchange",[-101.04274605000002, 35.57669225]],
    [ "Damron Substation",[-101.18444021547438, 35.590012865473]],
    [ "Roxana Substation",[-101.12403535, 35.57225880000001]],
    [ "Pringle Interchange",[-101.39199289999999, 35.99481934999999]],
    [ "Phillips #1 Substation",[-101.36718454027601, 35.6982498001312]],
    [ "Burnett Substation",[-101.4106690750874, 35.58894163880321]],
    [ "Blackhawk Station",[-101.36079819238942, 35.69510856808647]],
    [ "Phillips #2 Substation",[-101.37527555, 35.695397449999994]],
    [ "Weatherly Substation",[-101.3988197, 35.63512990000001]],
    [ "Canadian River Municipal Water Authority #22 Substation",[-101.44124889999999, 35.62218585000001]],
    [ "Kingsmill Interchange",[-101.04235451473262, 35.495604560398434]],
    [ "Spring Creek Substation",[-101.31651375000001, 35.664395799999994]],
    [ "Rocky Point Substation",[-101.35757057111026, 35.712145307995016]],
    [ "Canadian River Municipal Water Authority #1 Substation",[-101.54634922181546, 35.7103096458433]],
    [ "Pantex South Substation",[-101.56868305623011, 35.30553312502809]],
    [ "Transpecto Substation",[-101.42747864009083, 35.64566233278924]],
    [ "Sid Richardson Cogeneration Station",[-101.4387338, 35.664776]],
    [ "Borger West Substation",[-101.40586542457798, 35.675780313439766]],
    [ "Sneed Substation",[-101.7016929, 35.810935900000004]],
    [ "463732671",[-101.55709870487871, 35.81630117516336]],
    [ "Herring Substation",[-101.54978394129219, 35.828892225124456]],
    [ "Fritch Rural Substation",[-101.5585251, 35.6453676]],
    [ "Canadian River Municipal Water Authority #2 Substation",[-101.54963839242082, 35.678057117995714]],
    [ "Midstream Energy Substation",[-101.4054302, 35.51337469999999]],
    [ "Midstream Energy Tap",[-101.40437994999998, 35.48661965]],
    [ "Canadian River Municipal Water Authority #4 Substation",[-101.68353950921001, 35.37572738189035]],
    [ "ASARCO Substation",[-101.73083400825908, 35.284902121995465]],
    [ "Llano Estacado Wind Substation",[-101.2392382722424, 35.486572642263596]],
    [ "Carson County Substation",[-101.5618908, 35.382794499999996]],
    [ "Majestic Wind Substation",[-101.5389081752324, 35.38186455693885]],
    [ "Martin Substation",[-101.54037253286695, 35.38209242526463]],
    [ "Pantex North Substation",[-101.55543700105255, 35.318587193315636]],
    [ "Conway Substation",[-101.3821803927371, 35.25115847492123]],
    [ "Yarnell Substation",[-101.6116243757325, 35.21422999035613]],
    [ "Spring Draw Substation",[-101.9256193474759, 35.050909549708784]],
    [ "Estacado Substation",[-101.9048623750773, 35.13221409499077]],
    [ "Crouse Hinds Substation",[-101.85650820886212, 35.13333022506739]],
    [ "34th Street Substation",[-101.89649787485347, 35.17734040834474]],
    [ "Farmers Substation",[-101.86521610000001, 35.13374985]],
    [ "Waterfield Substation",[-102.02873322476773, 35.117851761033286]],
    [ "Bush Substation",[-101.89828102494945, 35.21759694390463]],
    [ "Van Buren Substation",[-101.8386758, 35.2171109]],
    [ "Welch Substation",[-81.59186746733442, 37.44069277838857]],
    [ "463858302",[-109.80016750917073, 46.43044078304106]],
    [ "Georgia Power",[-84.25877513079183, 33.96964632869189]],
    [ "Georgia Power",[-84.24335006528051, 33.90962542721661]],
    [ "463973431",[-81.61307502469587, 38.329835847890784]],
    [ "464007248",[-81.56007366018135, 38.24649146303322]],
    [ "464156364",[-111.65652455285338, 40.31214678656138]],
    [ "OG&E",[-97.55186861511343, 35.57974919068563]],
    [ "Stanardsville Substation",[-78.43952843260395, 38.30419002359865]],
    [ "464288897",[-109.4381283, 46.22069075000001]],
    [ "464367645",[-81.86816723473683, 41.40719690641434]],
    [ "Ada Substation",[-83.8191714045328, 40.77079399239543]],
    [ "Memphis Light, Gas and Water",[-89.97324908700301, 35.2671549468388]],
    [ "464453360",[-84.61288568587747, 41.22461794685645]],
    [ "464453975",[-84.33429810478239, 41.304996133047005]],
    [ "464453977",[-84.33562929174994, 41.30387928881484]],
    [ "464518186",[-91.0475829585483, 30.85887852457257]],
    [ "Brevard Substation",[-82.73659854999998, 35.2397776]],
    [ "Gallatin Substation",[-79.90148281351205, 40.19749226950103]],
    [ "OG&E",[-97.58577556001421, 35.5900163535144]],
    [ "OG&E",[-97.63917404268223, 35.573420835329316]],
    [ "Noble Power",[-101.39153459999999, 36.49444815000001]],
    [ "Novus 2 Substation",[-101.47373299999998, 36.5587599]],
    [ "Balko Wind Substation",[-100.86521510000001, 36.5207595]],
    [ "Beaver County Substation",[-100.94987683468557, 36.52524766984472]],
    [ "Palo Duro Wind Substation",[-101.00424399999999, 36.4106027]],
    [ "464627732",[-101.25435055000001, 36.2553082]],
    [ "464627737",[-101.00059337510707, 36.24445190748038]],
    [ "464627743",[-101.00297405201762, 36.33166522800001]],
    [ "Spearman City Substation",[-101.19029659225734, 36.204444742008334]],
    [ "Texas Farms Substation",[-100.92781064999998, 36.33951635]],
    [ "Spearman Interchange",[-101.31930316103127, 36.21179831193636]],
    [ "Ochiltree Interchange",[-100.81708747490924, 36.40886045933466]],
    [ "DeWind",[-101.39340485, 36.502510799999996]],
    [ "Dumas South Substation",[-101.97423317482908, 35.85128291400339]],
    [ "Dumas Helium Substation",[-102.02636226331568, 35.819365925108386]],
    [ "464627847",[-101.78807230341135, 36.498902328143465]],
    [ "Frisco Wind Farm Substation",[-101.58653376599742, 36.49614622543373]],
    [ "464627862",[-102.05332625872158, 36.32846627067219]],
    [ "Sherman County Substation",[-102.026300788697, 36.35714127506234]],
    [ "Spurlock Substation",[-101.83040197496668, 36.139363555590165]],
    [ "Exelon Wind 4 Substation",[-101.38775638581893, 36.399601349108316]],
    [ "Stokes & Sheldon Substation",[-101.86372327484715, 35.90850675696644]],
    [ "Hogue Substation",[-102.370423774829, 36.026299106616804]],
    [ "464685930",[-78.9322427, 38.34592035]],
    [ "Thistle Substation",[-98.46530352092954, 37.2935452621946]],
    [ "Border Substation",[-99.92981522108147, 35.20120336136083]],
    [ "JENNINGS RD SW STA",[-89.90040921563653, 42.61091312604877]],
    [ "464752422",[-97.49661612249353, 35.57051892267121]],
    [ "464768313",[-115.2778667572508, 36.219142213560836]],
    [ "Wheelock Substation",[-101.87875235, 33.55525225]],
    [ "464841244",[-81.5502339, 35.894626349999996]],
    [ "464963129",[-97.59292933434874, 35.52729556563954]],
    [ "Oklahoma Gas & Electric",[-97.5927371654293, 35.544844187678144]],
    [ "465017789",[-80.33879507848667, 39.30540925513229]],
    [ "Casaloma Substation",[-88.4824108929769, 44.28043189362112]],
    [ "Indiana Substation",[-101.88726515, 33.613385050000005]],
    [ "Planters Substation",[-101.78327054999998, 33.5850498]],
    [ "Hettler Substation",[-101.76644966899045, 33.63481544826871]],
    [ "Shallowater Substation",[-101.95750725705486, 33.69349852522253]],
    [ "Whitehead Substation",[-101.87195052504998, 33.730463756645655]],
    [ "Monroe Substation",[-101.86212890000002, 33.73705470000001]],
    [ "New Deal Interchange",[-101.86228677494995, 33.78104225496747]],
    [ "465307391",[-80.7794392719037, 39.30771380821372]],
    [ "465314946",[-81.79090878641483, 41.48737594334293]],
    [ "465326091",[-82.89522554978818, 40.06261731438452]],
    [ "465397509",[-81.9582694657235, 41.477548375253825]],
    [ "Brewster Substation",[-81.59370077373691, 40.70636340931541]],
    [ "Northeast Substation",[-101.80224836143289, 33.62096523219135]],
    [ "Wadsworth Substation",[-101.79920465000001, 33.556693550000006]],
    [ "465517575",[-93.22861961511784, 30.20587193206646]],
    [ "465517591",[-93.25253857503976, 30.197537992691906]],
    [ "Energy United",[-80.54136437577857, 35.98367028941981]],
    [ "Princeville Substation",[-159.47494403346724, 22.211502949235637]],
    [ "Interlachen Substation",[-81.90060679154611, 29.62529682521857]],
    [ "Massengale Station",[-101.84205429444971, 33.6035998061325]],
    [ "Brandon Station",[-101.8865171, 33.5848937]],
    [ "Erskine Substation",[-101.87952276509179, 33.6065282359922]],
    [ "Denso Jackson Substation",[-84.54393674688836, 42.26449732794393]],
    [ "Northwest Substation",[-101.90674361517563, 33.62211924246045]],
    [ "Karl Road Substation",[-82.97591899712609, 40.06750781224574]],
    [ "Woodrow Interchange",[-101.78840804218981, 33.46236254924992]],
    [ "Posey Substation",[-101.70997524999999, 33.484097299999995]],
    [ "Union Substation",[-101.79674619999999, 33.44768295]],
    [ "Cooper Substation",[-101.85373463918285, 33.4614094298708]],
    [ "Frenship Substation",[-102.00920195, 33.4474079]],
    [ "Upland Substation",[-101.97343134928926, 33.520927154495254]],
    [ "Ivory Substation",[-101.82725772515226, 33.52770099167151]],
    [ "ACCO Substation",[-101.8066715202136, 33.5483962271558]],
    [ "Clutter Substation",[-101.83328199999998, 33.5594973]],
    [ "Woodward Substation",[-101.90466597525788, 33.44749558021368]],
    [ "Yuma Interchange",[-101.98548784795757, 33.534733557341575]],
    [ "Carlisle Substation",[-101.98761612502747, 33.56617994241244]],
    [ "Doud Substation",[-101.93754642996235, 33.556564928128864]],
    [ "Erskine Substation",[-101.95580903386195, 33.61451147491379]],
    [ "Briggsdale Substation",[-83.05585715860228, 39.92053278108633]],
    [ "Fife Lake Subsation",[-85.30826525, 44.5836639]],
    [ "Brunswick EMC",[-78.30372640000002, 34.005792549999995]],
    [ "Hillman Highway Substation",[-81.93644728109507, 36.72137439220865]],
    [ "Spring Creek Substation",[-82.05847765000001, 36.687260050000006]],
    [ "Meadowview Substation",[-81.87104055000002, 36.7614505]],
    [ "Twin Rivers Paper Company",[-92.02209796298479, 34.26597233691436]],
    [ "Sherrill Post Office",[-91.99209801292612, 34.38454586950798]],
    [ "East Tennessee Natural Gas, LLC",[-81.81559124999998, 37.1737017]],
    [ "Appalachian Power Company",[-81.80441594479764, 37.0936930220377]],
    [ "Richlands Substation",[-81.8065042825272, 37.092120424521795]],
    [ "Appalachian Power Company",[-81.77547570293429, 37.04522327876696]],
    [ "Glade Substation",[-81.70945516901574, 36.792786930432804]],
    [ "Spectra Substation",[-81.79375370000001, 36.794005850000005]],
    [ "Poyen Substation",[-92.63097033176825, 34.32317304588781]],
    [ "Gifford Substation",[-92.73075219808726, 34.38211061709431]],
    [ "Entergy Arkansas",[-92.19326660000002, 34.704316899999995]],
    [ "Entergy Arkansas",[-92.17411433049298, 34.74824514509166]],
    [ "Entergy Arkansas",[-92.3617972, 34.668266499999994]],
    [ "466540810",[-92.36910617704844, 34.58357759726616]],
    [ "Entergy Arkansas",[-92.32857564999999, 34.58284075]],
    [ "Entergy Arkansas",[-92.24008692506224, 34.613694442483315]],
    [ "466573517",[-77.91515305625013, 34.5561372656049]],
    [ "466806173",[-77.88876956841793, 35.70660360425539]],
    [ "Pacific Gas and Electric Company",[-122.27888748580048, 38.29550368069121]],
    [ "Dickinson Avenue Substation",[-77.39845891373189, 35.60023179157276]],
    [ "466854876",[-77.97710097155469, 35.600428149789586]],
    [ "466854877",[-77.97877304999999, 35.60076695]],
    [ "Trenton Substation",[-81.87966424194715, 33.75068362125154]],
    [ "466936027",[-81.85633838490695, 33.633637633825586]],
    [ "Penelec",[-78.92587452152885, 40.33392033156281]],
    [ "Stephens Ranch Wind Project II Substation",[-101.66754552431526, 32.982623484508295]],
    [ "467016555",[-111.67415622817614, 40.034164160748304]],
    [ "Scotland Neck Substation",[-77.41887480708658, 36.121668653798906]],
    [ "C&L Electric Cooperative Corporation",[-91.94216050714635, 33.92878419804486]],
    [ "467307106",[-95.82937087940272, 36.368309359271784]],
    [ "South Ottumwa Substation",[-92.43407977769353, 40.98776555462518]],
    [ "467500102",[-92.65680315279438, 42.784204668598576]],
    [ "467539532",[-82.14682960932036, 34.16785000714074]],
    [ "467539571",[-82.16979985000002, 34.1840206]],
    [ "467539586",[-82.15525921858269, 34.187760144766216]],
    [ "University of Toldeo",[-83.61100632607241, 41.653795403947036]],
    [ "Iron Substation",[-81.61998363859948, 41.407182069226124]],
    [ "Mecklenburg Electric Cooperative",[-78.21687253588848, 36.7580548958862]],
    [ "Moncks Corner Substation",[-80.00245248394815, 33.19679635345212]],
    [ "467834959",[-79.81747803475406, 33.663553243624875]],
    [ "Alum Creek Substation",[-97.23312862109704, 30.065852007388607]],
    [ "467861988",[-78.6316239128712, 33.87838177904226]],
    [ "467947665",[-101.71247292494597, 43.20165849044798]],
    [ "Camp Springs Wind 2 Substation",[-100.82356885000002, 32.75930525]],
    [ "Brand Tapping Station",[-100.9450899, 32.783624950000004]],
    [ "Cogdell Substation",[-100.88666231342515, 32.942254125418316]],
    [ "Union Substation",[-100.99894467458749, 32.706884009238216]],
    [ "Fluvanna Substation",[-101.11514304999997, 32.859327949999994]],
    [ "Oxy Cogdell Substation",[-100.88640931353761, 32.94234389928749]],
    [ "Ennis Creek Substation",[-100.92392245, 32.84104965000001]],
    [ "Snyder Wind Farm Substation",[-100.75742027875724, 32.74559365460086]],
    [ "Plainview Substation",[-100.8246298210685, 32.733291443670964]],
    [ "Enel",[-100.82437163119803, 32.73365801574928]],
    [ "SNTX Substation",[-100.86134690407711, 32.71212316799705]],
    [ "Kinder Morgan",[-100.95503539063374, 32.74705407582333]],
    [ "Sun Switching Station",[-100.96157565411208, 32.7484781254432]],
    [ "Golden Switching Station",[-100.94514997489902, 32.77640105961419]],
    [ "Camp Springs Wind 1 Substation",[-100.82366994009429, 32.75964517894806]],
    [ "Scurry Sante Fe Substation",[-100.9636467916852, 32.66168967520722]],
    [ "Scurry Substation",[-101.0503177, 32.627406699999995]],
    [ "Ira Substation",[-100.9754487, 32.58161525]],
    [ "Snyder Substation",[-100.90269816467726, 32.70400472647677]],
    [ "Lake Thomas Substation",[-101.1383527, 32.5535448]],
    [ "Colorado City Substation",[-100.84148745, 32.392242800000005]],
    [ "467959274",[-100.84532175000002, 32.52987665]],
    [ "Colorado Basin Substation",[-100.83642708786438, 32.530057075160656]],
    [ "Sacroc Substation",[-100.985654470392, 32.74232584171929]],
    [ "Knapp Substation",[-101.0523786, 32.6915811]],
    [ "Bluff Creek Substation",[-101.05435285, 32.62714535]],
    [ "Kinder Morgan",[-100.95785611411094, 32.7474706750261]],
    [ "Brand Substation",[-100.94433805, 32.78349865]],
    [ "Ennis Creek Switching Station",[-100.92499267878327, 32.84010582179686]],
    [ "Scurry Chevron Substation",[-100.9607921254432, 32.81275829442761]],
    [ "Scurry Switching Station",[-100.97484387533515, 32.87110004066893]],
    [ "467959346",[-101.00446083228613, 32.77415570798669]],
    [ "Red Canyon Wind Substation",[-101.18465704999998, 32.918845049999995]],
    [ "Brazos Wind 1 Substation",[-101.12959983312875, 32.952598854403654]],
    [ "Brazos Wind 2 Substation",[-101.31592798308975, 32.93890869939936]],
    [ "Exxon Sharon Ridge Substation",[-101.14949172470493, 32.62902096211738]],
    [ "Bull Creek Wind Substation",[-101.58426895, 32.92789905]],
    [ "Iatan Howard Substation",[-101.18704481800373, 32.2806092198098]],
    [ "Westbrook Substation",[-101.01440020000001, 32.36022365]],
    [ "Coahoma Substation",[-101.30834992952181, 32.3038899376277]],
    [ "Ocotillo Wind Substation",[-101.39384400218465, 32.132007487084834]],
    [ "Forsan Substation",[-101.41670271190338, 32.08035332072017]],
    [ "Drumright Switching Station",[-101.40855218733296, 32.06480417502103]],
    [ "Big Spring Carbon Substation",[-101.40887910781086, 32.28066660934559]],
    [ "Salt Creek #1 Substation",[-100.88028001858353, 33.2289989353883]],
    [ "Salt Creek #2 Substation",[-100.86992574942357, 33.23106028993512]],
    [ "Spur Substation",[-100.85723099999998, 33.4737594]],
    [ "McAdoo Wind Energy Substation",[-100.99155874101761, 33.7504179750415]],
    [ "468428753",[-86.9436056162025, 34.44215536954771]],
    [ "468507931",[-81.58977215115827, 34.27937040460374]],
    [ "Sacramento Municipal Utility District",[-121.24047230314726, 38.54588080392803]],
    [ "Atoka Substation",[-89.76596712153612, 35.4173879497313]],
    [ "468606175",[-106.33787617434781, 31.75076858613579]],
    [ "Milagro Substation",[-106.42294364231863, 31.901679965614587]],
    [ "Moser Substation",[-75.6183076701106, 40.23491849546891]],
    [ "Trimont Substation",[-94.84018056730557, 43.80086846125951]],
    [ "Martin County Substation",[-94.8414178003436, 43.79971902567348]],
    [ "468775099",[-91.88185018951559, 36.724115090917145]],
    [ "Green Oaks Substation",[-87.51537289999999, 37.9554445]],
    [ "Kalgary Substation",[-101.11375750845336, 33.40910352471913]],
    [ "SMS Substation",[-100.94778115450997, 33.28966742241354]],
    [ "Afton Substation",[-100.84186545, 33.7338394]],
    [ "Glenn Substation",[-100.84186645, 33.73393115]],
    [ "Espuela Substation",[-100.89707167512809, 33.54389040499185]],
    [ "Entergy Arkansas",[-91.53914674615623, 35.3430975663263]],
    [ "468799430",[-91.52614147519216, 35.32589224547061]],
    [ "Huntsville Utilities",[-86.58053517544175, 34.61481214304273]],
    [ "468889638",[-86.97545213658391, 34.80106261937257]],
    [ "Griffithville Substation",[-91.6323805376037, 35.12083541807598]],
    [ "Entergy Arkansas",[-90.60862478436361, 34.470585517588]],
    [ "468915617",[-92.92125046907083, 42.3750505132495]],
    [ "Entergy Arkansas",[-90.82674535, 34.804586449999995]],
    [ "Moro Substation",[-90.97880146661116, 34.78560615034189]],
    [ "Findley Reservior #2 Substation",[-83.57676644490651, 41.03287675346209]],
    [ "Hartman Substation",[-75.22835849179287, 40.22440788298677]],
    [ "469087797",[-84.10136973132575, 31.598874136541234]],
    [ "Mumford Substation",[-75.52135937500655, 38.6095175494997]],
    [ "469129661",[-94.40781240371972, 43.98419718841473]],
    [ "469144422",[-95.84663944385387, 32.328855417304105]],
    [ "Potrero Converter Station",[-122.38592860232225, 37.75486860968487]],
    [ "Paducah Power System",[-88.53291369431159, 37.006757526622934]],
    [ "Paducah Power System",[-88.59868806787621, 37.089458848245954]],
    [ "469289540",[-82.48854040933014, 34.61434607382272]],
    [ "AEP Deer Creek",[-85.64422634534667, 40.51603386010415]],
    [ "Beardsley Substation",[-112.37887754609028, 33.66056541764272]],
    [ "Gateway Substation",[-90.12786055, 35.14796309999999]],
    [ "Harrisburg Substation",[-90.74893315000001, 35.56357405]],
    [ "Willis Road Substation",[-84.22816483467085, 42.29013098842065]],
    [ "469802892",[-86.83335402517902, 34.20039764412611]],
    [ "Entergy Arkansas",[-92.02672889999998, 34.11799]],
    [ "Entergy Arkansas",[-92.00168506305812, 34.1939732746992]],
    [ "Entergy Arkansas",[-92.0655180241673, 34.25648655998843]],
    [ "Crab Orchard Substation",[-84.88939119271856, 35.91179205632541]],
    [ "West Substation",[-86.86692753643565, 34.16808670161926]],
    [ "470012855",[-102.46120224999997, 39.65830284999999]],
    [ "Hell Creek Substation",[-102.5918988382816, 39.53459090395922]],
    [ "470012888",[-102.63069349387422, 39.611911758658074]],
    [ "470014749",[-80.68220462304492, 37.101830765297805]],
    [ "El Dorado Chemical Substation",[-92.68793389500212, 33.26354090744272]],
    [ "North Benton Substation",[-93.73924541363282, 32.70926536105]],
    [ "Entergy Arkansas",[-93.73622951477725, 33.62176206531324]],
    [ "Southwest Arkansas Electric Cooperative",[-93.94646464152818, 33.331013329411974]],
    [ "Wharton/Conaway Substation",[-75.37861612265083, 38.56651009030454]],
    [ "470262227",[-97.35269036110594, 37.56781492488138]],
    [ "470311343",[-112.1605032003805, 41.726724589890054]],
    [ "Turkey Substation",[-100.88915947522135, 34.39165970380314]],
    [ "Turkey Substation",[-100.8980346746187, 34.3422878937933]],
    [ "Flomot Substation",[-100.98977869999997, 34.2524224]],
    [ "Muleta Substation",[-100.87280499237869, 34.10519492895993]],
    [ "Whirlwind Substation",[-101.09844092458853, 34.106130995189496]],
    [ "Matador Substation",[-100.83187320339334, 34.011286674804715]],
    [ "Roaring Springs Substation",[-100.84733485000002, 33.897369600000005]],
    [ "New Millennium Building Systems, LLC",[-93.62167516817067, 33.73150324824645]],
    [ "Entergy Arkansas",[-93.10062404994767, 34.04954348229393]],
    [ "470450233",[-93.08790519832557, 34.13983472793353]],
    [ "470453943",[-93.10977571454053, 34.212347370319655]],
    [ "Entergy Arkansas",[-92.97207437008927, 34.25969328678847]],
    [ "Butterfield Substation",[-92.81277529999998, 34.43142175]],
    [ "Sub 71",[-76.72589713889181, 40.18415035527822]],
    [ "Sub 70",[-76.56690936666652, 40.130747318851526]],
    [ "Sub 69",[-76.38355349327652, 40.08980693582942]],
    [ "Sub 68",[-76.21429453217763, 40.043096175983145]],
    [ "Sub 67",[-76.06897235997464, 39.998845518707824]],
    [ "Sub 66",[-75.91615572412692, 39.96035318031976]],
    [ "Sub 65",[-75.73417120871702, 39.99691429036273]],
    [ "Sub 64",[-75.57423819442268, 40.031255448686785]],
    [ "Sub 4",[-75.48949836695213, 40.043464049250105]],
    [ "470673817",[-95.76058871495873, 42.82221866799992]],
    [ "470884046",[-87.12916333932434, 41.609887021380295]],
    [ "470946570",[-80.76739505338321, 35.184941494463246]],
    [ "Colonial Park Substation",[-76.82270447191013, 40.315032907068634]],
    [ "Carpenter Substation",[-83.6710910875899, 42.08692441433821]],
    [ "Piedmont Substation",[-83.79990493768457, 42.242871474707485]],
    [ "Athens Utilities Electric Department",[-86.9727520840617, 34.795379482600595]],
    [ "Ridge Substation",[-122.25480495480436, 37.88513902138042]],
    [ "Duck Lake Substation",[-84.78332418334205, 42.37784195048905]],
    [ "472032351",[-84.40580953510431, 35.97437942096707]],
    [ "Tucson Electric Power",[-110.87458526775983, 32.17290935554284]],
    [ "Waves Substation",[-75.46822918551854, 35.57100669877493]],
    [ "Leal Substation",[-98.2688776, 47.0964157]],
    [ "Substation 7",[-83.16559577505004, 42.22541861208337]],
    [ "Hughes Substation",[-90.45179775, 34.96737064999999]],
    [ "Arkansas Electric Cooperative Corporation",[-90.78723757382788, 35.0397172440286]],
    [ "Entergy Arkansas",[-90.79905055, 35.023001449999995]],
    [ "Entergy Arkansas",[-90.87332896354067, 34.977989414541526]],
    [ "Arkansas Electric Cooperative Corporation",[-90.89493361869275, 34.96819834189793]],
    [ "Arkansas Electric Cooperative Corporation",[-90.89548381015064, 34.96932856949587]],
    [ "472439401",[-84.9263452, 34.44114435]],
    [ "Entergy Arkansas",[-92.0047336, 34.75718009999999]],
    [ "472678504",[-91.99944705000001, 34.79582795]],
    [ "North Shenandoah Substation",[-78.62031290671871, 38.5269310502893]],
    [ "Decatur Utilities",[-87.00877768169389, 34.560000814452245]],
    [ "Osipoff Substation",[-86.21300037914988, 43.04236086340237]],
    [ "Decatur Utilities",[-86.98088541863304, 34.61433811305925]],
    [ "Wapello City Substation",[-91.18248852427577, 41.172303644151754]],
    [ "473299930",[-92.94699365, 31.533934300000002]],
    [ "473423696",[-86.39392015599688, 40.41654530347505]],
    [ "473424083",[-86.28526965, 40.416865300000005]],
    [ "Decatur Utilities",[-86.95028337409659, 34.58222990484634]],
    [ "473449831",[-94.23663591114966, 36.051793525196516]],
    [ "473452299",[-112.02462982501558, 41.07290844432445]],
    [ "473606387",[-93.95820323881361, 44.22067928612041]],
    [ "Decatur Utilities",[-86.99080681734522, 34.58911168412846]],
    [ "Chester Substation",[-81.65938474021533, 41.50485466815032]],
    [ "473663546",[-96.1770605906209, 32.544970575193126]],
    [ "Georgia Pacific Substation",[-83.42004543350254, 33.61419315135145]],
    [ "Wellsboro Substation",[-77.28806561398744, 41.751672982500125]],
    [ "Huntsville Utilities",[-86.53949024032936, 34.64321812989824]],
    [ "Virginia Electric and Power Company",[-78.11174563651159, 37.28054866362333]],
    [ "474081128",[-82.19310767802888, 35.81577664349981]],
    [ "Tower Hill Substation",[-76.98461923190186, 41.94537570181169]],
    [ "Fort Payne Improvement Authority",[-85.64230837890082, 34.40172676795871]],
    [ "474089545",[-85.7540106186714, 34.444609653585324]],
    [ "474246869",[-109.5690578875225, 46.6905661100506]],
    [ "Nolan Substation",[-83.79483916639329, 42.562906156887756]],
    [ "474670668",[-106.7451906900302, 35.06880227699976]],
    [ "Decatur Utilities",[-86.97618173374785, 34.56448590861424]],
    [ "Highway 106 Substation",[-93.22025352627166, 43.133442994019134]],
    [ "Stockbridge Substation",[-84.19243612433124, 42.56267003642726]],
    [ "475296675",[-102.81179816770064, 46.918553247289225]],
    [ "475409891",[-76.8541661548405, 41.76200968225117]],
    [ "32nd Street Substation",[-114.63250237060967, 32.66896713883053]],
    [ "West Union Substation",[-91.81501889618846, 42.95571932585001]],
    [ "Aldora Mills Substation",[-84.1772536, 33.051965849999995]],
    [ "Ivalon Substation",[-114.5861639, 32.68378175]],
    [ "475564434",[-114.57293465741277, 32.6796983748836]],
    [ "Marine Air Base Substation",[-114.58059668216627, 32.66098562754482]],
    [ "Powell Mountain Substation",[-80.80013701721457, 38.39990587835051]],
    [ "475605967",[-80.71682592874464, 38.53736920585411]],
    [ "Florida Power & Light",[-80.22033863733263, 25.74704089307749]],
    [ "475691130",[-81.58586689569573, 35.54404116808038]],
    [ "Beauregard Electric Cooperative",[-93.30186564999998, 30.7952041]],
    [ "475909759",[-89.7040885237205, 39.673942410512595]],
    [ "C&L Electric Cooperative Corporation",[-91.4875363126256, 33.89966487574407]],
    [ "Dumas Substation",[-91.47650758725982, 33.88352387429492]],
    [ "Village of Chatham",[-89.70582535, 39.68971755]],
    [ "CLECO",[-92.36239057450932, 30.21921327112179]],
    [ "Piney River Substation",[-79.00637259999999, 37.720000999999996]],
    [ "Chauncey Substation",[-81.98760498528463, 37.764630304277205]],
    [ "Sacramento Municipal Utility District",[-121.37552269323474, 38.43764681680625]],
    [ "Carmel Guilford Road Substation",[-86.13914033184142, 39.95795923534319]],
    [ "476466762",[-86.12881075131106, 39.97474322675526]],
    [ "Araby Substation",[-114.49607624140131, 32.668019192780456]],
    [ "476681779",[-113.62834437655455, 37.084856430647534]],
    [ "476734057",[-91.65915401737564, 41.15593528406571]],
    [ "476734524",[-86.78228191071923, 34.68452870859383]],
    [ "Radium Springs Substation",[-84.12388352582587, 31.500514443890744]],
    [ "Albany Primary Substation",[-84.11126010023136, 31.563933743013063]],
    [ "U.S. Hwy 19 Substation",[-84.11174094276309, 31.518521434401812]],
    [ "Waverly Road Substation",[-86.0782796, 42.7782939]],
    [ "477191919",[-82.10439504018545, 29.94231063988929]],
    [ "Griffis Loop Substation #09 CLAY",[-82.08584503646902, 29.92662964576032]],
    [ "477203481",[-85.91508534999998, 39.98821984999999]],
    [ "Worthington Springs Substation #49 CLAY",[-82.42472120670638, 29.93879170756122]],
    [ "Brooker Substation #24",[-82.33181710069732, 29.89907867939609]],
    [ "477254000",[-86.04276275000001, 40.01741255]],
    [ "Consumers Energy",[-84.1871114250771, 44.2482325431371]],
    [ "477375510",[-83.65742204692631, 32.4937490883147]],
    [ "Silver Lake Substation",[-86.47405905919553, 43.67514385056875]],
    [ "Broadway Substation",[-118.15188945, 33.766976]],
    [ "Baum Street Substation",[-83.9379563565057, 43.42991138732977]],
    [ "477610760",[-92.79744720563119, 41.02603367778649]],
    [ "Centerville North",[-92.87386059916902, 40.74721781021337]],
    [ "477689837",[-82.37152180000001, 36.5146254]],
    [ "Dorothy Substation",[-81.46452067685038, 37.95635580943576]],
    [ "477810334",[-101.54071688328435, 37.98731081661998]],
    [ "477903313",[-81.13672874666666, 34.03410920666666]],
    [ "477903314",[-81.11521954999999, 34.02838835]],
    [ "477930913",[-98.48675912374617, 36.593875955439614]],
    [ "478136320",[-86.89781314999999, 40.04919895]],
    [ "Huntsville Utilities",[-86.71278154649887, 34.75215720428527]],
    [ "City of Harrisonburg",[-78.86317423331018, 38.438015478638455]],
    [ "478206815",[-111.6200856480303, 32.76246852453551]],
    [ "South O'Neill Substation",[-114.59472436801173, 32.64160539141592]],
    [ "478388243",[-86.11136146696825, 37.89594519892043]],
    [ "478412024",[-95.55576429100428, 33.69384059700706]],
    [ "Jersey Central Power and Light",[-74.45109650293766, 40.13971661689929]],
    [ "478534483",[-78.8768832, 38.43246825]],
    [ "478638585",[-95.7869188530412, 41.64038038461544]],
    [ "478709848",[-80.64463265352245, 33.9006764726223]],
    [ "Industrial Paper Substation",[-80.6418067973641, 33.88756173108934]],
    [ "Hunt Substation",[-74.28375828553992, 41.234076132874954]],
    [ "West Milford Substation",[-74.34888273487253, 41.13573549694533]],
    [ "Chelsea Substation",[-86.60961095, 34.68819535]],
    [ "Huntsville Utilities",[-86.56248980676132, 34.692215274068275]],
    [ "478971391",[-96.17988182537181, 43.07291999490649]],
    [ "478975291",[-96.13923835, 43.17897884999999]],
    [ "Industrial Park Substation",[-85.17279190966026, 41.12071244810785]],
    [ "479114517",[-106.857712265024, 35.053152643736816]],
    [ "Two Mile Substation",[-78.30069201863202, 41.83674210435844]],
    [ "Alabama Power",[-85.01750542497946, 32.31465054951611]],
    [ "LADWP Distributing Station No. 86",[-118.5005502302751, 34.30532935340388]],
    [ "Jim Hill",[-90.11628516038526, 36.4653291618789]],
    [ "479298680",[-95.44232, 42.70956925]],
    [ "479386653",[-78.6822306, 34.9990212]],
    [ "479386654",[-78.6812987616383, 34.99972957570796]],
    [ "Port Allen Switchyard",[-159.58442123222727, 21.900017498997634]],
    [ "Koloa Substation",[-159.4473983926036, 21.90088949875523]],
    [ "Kapaia Substation",[-159.3769012360157, 21.99563003643161]],
    [ "Kapaa Substation",[-159.32080022133417, 22.071761725666057]],
    [ "Warren Substation",[-84.59897954798889, 43.75639488931919]],
    [ "Coleman Substation",[-84.5927628, 43.759136749999996]],
    [ "479568723",[-82.14245212102423, 41.37165931163424]],
    [ "479568730",[-82.14479429720771, 41.40113594654489]],
    [ "Kentucky Utilities Company",[-84.09493890814528, 36.949161601363855]],
    [ "479650406",[-82.67438506032151, 27.76766887975031]],
    [ "479650407",[-82.67501110837897, 27.76804183491536]],
    [ "479746295",[-96.66586746918578, 33.01205828483659]],
    [ "479754139",[-95.17446717871206, 42.637539695344195]],
    [ "GMC Parma Substation",[-81.77596978522669, 41.41335557926554]],
    [ "479790959",[-94.9247403, 33.924284500000006]],
    [ "Livingston Heights Substation",[-77.12846801095903, 38.89802980995103]],
    [ "Snowy Creek Substation",[-79.54221913203172, 39.428998848078905]],
    [ "479878928",[-98.5324275011779, 33.84431224598679]],
    [ "Huntsville Utilities",[-86.448627065381, 34.67211761834378]],
    [ "479943733",[-93.23127951085227, 43.44463907556408]],
    [ "480066156",[-80.04013073884705, 34.98255664248947]],
    [ "480066157",[-80.04072399151384, 34.98339850444486]],
    [ "Isabelle Substation",[-105.05375625964822, 40.05521870748182]],
    [ "Pickerel Substation",[-85.48086495490786, 42.1959066217311]],
    [ "SRP Clark Substation",[-111.73197004887544, 33.29166421082735]],
    [ "Milledgeville Primary Substation",[-83.24113933913343, 33.07785119621448]],
    [ "480405218",[-80.96410811325107, 34.918352120064185]],
    [ "480405219",[-80.9658842, 34.91942865]],
    [ "Duke Energy",[-84.85895810389776, 29.66574861857093]],
    [ "480638456",[-95.13656801700174, 41.23139332511614]],
    [ "Pepper Substation",[-75.413555046152, 38.665275173169405]],
    [ "480697705",[-119.91683273625122, 35.379102181096584]],
    [ "480760281",[-95.44635395, 41.49111085]],
    [ "480760282",[-95.46035900000001, 41.52074389999999]],
    [ "Vandercook Lake Substation",[-84.39096526548754, 42.195363817735895]],
    [ "Seamless Substation",[-84.36228164707678, 42.20300755375816]],
    [ "Green Substation",[-84.47916810786819, 42.69061835403017]],
    [ "Decatur Utilities",[-86.97975608360697, 34.578424016940886]],
    [ "Decatur Utilities",[-86.99322645612753, 34.598360893131186]],
    [ "Zamora Substation",[-121.85811911405698, 38.77550567712284]],
    [ "480859867",[-80.89133915, 34.8476064]],
    [ "480859919",[-80.89608079690481, 34.840681517990525]],
    [ "Atlantic Municipal Utilities",[-95.00117100229396, 41.4093363379345]],
    [ "480884570",[-95.0097757, 41.38889505]],
    [ "Decatur Utilities",[-86.98525665000001, 34.61676524999999]],
    [ "Decatur Utilities",[-86.98743017489224, 34.60481387083946]],
    [ "Second Street Substation",[-75.0378696032453, 39.4100818821503]],
    [ "MidAmerican Energy",[-94.17990795829931, 41.59212732496596]],
    [ "Decatur Utilities",[-86.97442622467466, 34.538117120485396]],
    [ "481053967",[-85.37706362038224, 41.12379898792018]],
    [ "481083065",[-74.77822473029616, 44.97344825160321]],
    [ "481106546",[-79.7005987, 36.518057999999996]],
    [ "481128199",[-95.00037491355272, 35.51392183397998]],
    [ "481184735",[-89.52066252644045, 34.426626362414574]],
    [ "UF Substation #7",[-82.34116150650246, 29.649201668197307]],
    [ "UF Substation #3",[-82.34250964189812, 29.648770925033574]],
    [ "Substation #1",[-82.34905000196562, 29.648104485701563]],
    [ "Substation #9",[-82.34861764355803, 29.648192286714636]],
    [ "UF Substation #12",[-82.34531351559227, 29.645924884278063]],
    [ "481357068",[-85.69263884729513, 38.368999608849045]],
    [ "481376586",[-85.51859475, 38.2937478]],
    [ "Gurdon Substation",[-93.14165592557363, 33.92558749449255]],
    [ "481487870",[-95.43110990000001, 41.7768416]],
    [ "481532882",[-82.15666217605383, 41.44402218370689]],
    [ "481532885",[-82.16228493962376, 41.43752052221509]],
    [ "City of Harrisonburg",[-78.88777974439652, 38.45301633434512]],
    [ "City of Harrisonburg",[-78.88121190650345, 38.43759361336579]],
    [ "481574657",[-82.48934142367703, 42.8744542633352]],
    [ "Claxton Substation",[-81.89958664405465, 32.17403365212664]],
    [ "Georgia Power",[-81.8857204, 32.1743186]],
    [ "North Glennville Substation",[-81.91624046733124, 32.00078999967373]],
    [ "481632145",[-95.36375427319521, 42.021680128345565]],
    [ "Donald Substation",[-81.82800382504132, 31.792071382676287]],
    [ "County Hospital Substation",[-88.45586432476894, 44.27535034351785]],
    [ "Wright-Hennepin Electric Cooperative",[-93.67471327539722, 45.25164305365407]],
    [ "481713716",[-88.4143147357091, 44.26292597503802]],
    [ "Ardent Mills",[-86.96005532208966, 34.60058158654998]],
    [ "CenterPoint Energy",[-87.4878218655193, 37.95451899698788]],
    [ "Coldwater Substation",[-85.9282413, 33.600215850000005]],
    [ "Zions View Substation",[-76.7495597884292, 40.05458424771875]],
    [ "Violet Hill Substation",[-76.71705405975703, 39.94049818403104]],
    [ "482032143",[-85.88374868236966, 38.17935845832682]],
    [ "482039185",[-88.3484717062356, 37.03912805153222]],
    [ "Duke Energy",[-85.77512178189032, 38.698100937334395]],
    [ "482172467",[-81.2115237, 35.385089099999995]],
    [ "482172468",[-81.2106714, 35.385745650000004]],
    [ "482172469",[-81.21121369870426, 35.38545773322376]],
    [ "482224050",[-88.90586395, 39.8782468]],
    [ "482298827",[-86.480940275696, 42.07012061609538]],
    [ "482304963",[-86.43124808173357, 42.07476728870874]],
    [ "482306052",[-86.40650372205886, 42.10625296600868]],
    [ "482309149",[-83.69317656687369, 36.66724784835984]],
    [ "482316602",[-86.43844112518401, 39.430221595353885]],
    [ "482320628",[-82.06109812503252, 39.354569149739106]],
    [ "482321873",[-86.17258906045032, 42.211066106518864]],
    [ "482325969",[-86.23239712791586, 42.191103861333374]],
    [ "482332345",[-85.91713967469396, 42.207902293703555]],
    [ "482332354",[-85.86388305797998, 42.21300239431703]],
    [ "Decatur Utilities",[-87.0165008, 34.563217800000004]],
    [ "Cane Run Switching Substation",[-85.85090001305427, 38.17288497617609]],
    [ "Elkmont Substation",[-86.9631922572888, 34.935380504943716]],
    [ "Centerton Substation",[-86.41791725735804, 39.481226650728175]],
    [ "482716310",[-85.4855081047562, 32.61027242696022]],
    [ "482728756",[-86.36477340459733, 39.612188608594]],
    [ "482728775",[-86.38005010204495, 39.594777322310364]],
    [ "Hanover Substation",[-84.55733323783575, 42.10352387509097]],
    [ "Community Hospital Substation",[-86.07716407514826, 39.787323106441015]],
    [ "South Elwood Substation",[-85.82966975880505, 40.26221381584225]],
    [ "482879203",[-85.36794214660962, 32.66972808116155]],
    [ "482889663",[-81.43741010893986, 35.07490917922974]],
    [ "482951024",[-85.3638308551455, 32.624126432061914]],
    [ "483077798",[-108.43412313694229, 45.811797374798864]],
    [ "Nettleton Substation",[-88.6300683, 34.09170439999999]],
    [ "Oglethorpe Substation",[-84.0519708, 32.29281705]],
    [ "483293809",[-91.87780461738203, 43.99190476590039]],
    [ "Battle Mountain Substation",[-116.94515233269347, 40.64803628061138]],
    [ "483457836",[-94.15681125683433, 43.61377481941911]],
    [ "483480122",[-82.6060470622991, 35.51595047585077]],
    [ "Electric Power Board of Chattanooga",[-85.06971418004585, 35.07850286697326]],
    [ "483508816",[-84.61055275045189, 41.28200134364334]],
    [ "Huntsville Utilities",[-86.58732217500736, 34.77080299365167]],
    [ "Devereux Substation",[-83.00651994999998, 33.27780125]],
    [ "483752673",[-86.80547286795827, 33.51228065315923]],
    [ "Decatur Utilities",[-86.95870574914163, 34.578883729392956]],
    [ "484053425",[-86.92827710687963, 40.38536329450931]],
    [ "484139521",[-95.30898554565313, 35.78607284359985]],
    [ "Ramah Substation",[-108.4462807490832, 35.09632966672007]],
    [ "Tekonsha Substation",[-84.99014146265232, 42.09843296932777]],
    [ "Central State Hospital Substation",[-83.21781941726765, 33.04820247495045]],
    [ "Sandersville Substation #6",[-82.83272910630689, 33.001821376993426]],
    [ "Kaolin Substation",[-82.82547627043675, 32.97560626502882]],
    [ "Union City Substation",[-85.12875590860118, 42.081343549457806]],
    [ "Dutton Substation",[-85.61372821532306, 42.839762552963755]],
    [ "484709879",[-90.21233555253036, 38.6936842671606]],
    [ "484709883",[-90.22235261660562, 38.73931105512799]],
    [ "Oklahoma Gas & Electric",[-93.80535374799867, 35.46309058730533]],
    [ "Northern Fibre Substation",[-86.11167037087115, 42.870052059827124]],
    [ "484848370",[-122.29958726985382, 38.34505470871032]],
    [ "MidAmerican Energy",[-92.28031936315251, 42.427613435405725]],
    [ "485059397",[-93.21278715, 31.071322600000002]],
    [ "Wauseon Substation",[-84.15265277195834, 41.54644539298075]],
    [ "Northside Substation",[-84.11440237061016, 41.47396416147651]],
    [ "North Star Steel Substation",[-84.04785186969384, 41.567248734811955]],
    [ "Auraria Substation",[-84.02036304770978, 34.46635501621361]],
    [ "485226791",[-84.06604475000002, 41.5605628]],
    [ "485230337",[-84.14243178384314, 41.39957373303972]],
    [ "485365854",[-90.06556629142213, 29.944929796049824]],
    [ "Georgia Power",[-83.81362130427806, 34.28416600370394]],
    [ "Alachua Substation #26 CLAY",[-82.52760060000001, 29.78225585]],
    [ "485472513",[-85.53636039999999, 32.5524989]],
    [ "Talleyville Substation",[-75.54596880955185, 39.808597730047246]],
    [ "Hoye Avenue Substation",[-89.16411348914711, 32.326771720249965]],
    [ "Lockwood Rd",[-84.5356930636223, 41.310275231144544]],
    [ "Lorntz Substation",[-84.52531816351613, 41.45718356555565]],
    [ "485562212",[-115.02799723511389, 36.277340096239314]],
    [ "485573853",[-90.05727242501871, 32.25019199244166]],
    [ "Georgia Power",[-83.79522105000001, 34.31058395]],
    [ "485720021",[-87.56648946214368, 33.17805992432886]],
    [ "Kentucky Utilities Company",[-83.77624991917295, 37.17857021074837]],
    [ "Stillman Substation",[-87.57493963708866, 33.201178173994776]],
    [ "Oneida Substation",[-84.53213435707076, 36.502373345985156]],
    [ "485746790",[-85.43952361617234, 34.804229620288226]],
    [ "Mississippi Power",[-89.82100916982128, 31.234473926551335]],
    [ "485948665",[-80.85518905077525, 32.691106533160934]],
    [ "485977800",[-89.57417976308379, 31.650022575085753]],
    [ "486263009",[-94.87494653012088, 40.34953177604843]],
    [ "486373118",[-88.65923024489884, 32.77691252403732]],
    [ "DeKalb Substation",[-88.6772610968739, 32.78153470911654]],
    [ "Macon Substation",[-88.56715576939739, 33.116989332317495]],
    [ "Schaumburg Substation",[-88.05544611020717, 42.0596307220881]],
    [ "Eupora Substation",[-89.25934450915912, 33.52738662769457]],
    [ "Entergy Arkansas",[-89.78394778660677, 35.8994137307892]],
    [ "Commonwealth Edison",[-87.88733842697596, 42.01662461732323]],
    [ "Starkville Electric Department",[-88.83538116153986, 33.465351346588]],
    [ "486474420",[-88.7378154894685, 33.477617125278464]],
    [ "Aberdeen Substation",[-88.53890118709249, 33.81711618745958]],
    [ "486489473",[-83.5234029908096, 42.08726097350868]],
    [ "486489477",[-83.52251290487958, 42.0039282541023]],
    [ "Evergy",[-95.42729034937747, 37.78625079760061]],
    [ "Simsboro Magnolia Substation",[-96.31465475, 31.673412850000005]],
    [ "486542675",[-78.04695265, 35.22531095]],
    [ "Singing River Electric Cooperative",[-88.6086591, 30.89973905]],
    [ "486684258",[-89.01807865061913, 34.50151696339233]],
    [ "Rochelle Substation",[-89.05400478821963, 41.9479999940067]],
    [ "Rochelle Municipal Utilites Power Substation",[-89.04488878537153, 41.90688966620802]],
    [ "GFX Data Center Substation",[-88.24304088006451, 41.795243212155505]],
    [ "486752982",[-78.78335275, 34.986175]],
    [ "486752983",[-78.78502998570706, 34.986804293446305]],
    [ "486752986",[-78.78498729328506, 35.01978069725469]],
    [ "486752987",[-78.78400076391229, 35.02042001028176]],
    [ "486753417",[-119.32278931149419, 46.946742707212074]],
    [ "Gallagher Substation",[-81.40402115937691, 38.16712058200035]],
    [ "Senatobia Substation",[-89.95286797890041, 34.62222972036132]],
    [ "Sardis Substation",[-89.88911415, 34.43803555]],
    [ "Entergy Arkansas",[-92.23263953313304, 34.816092133504554]],
    [ "486953675",[-119.20323453186977, 46.877684146605006]],
    [ "Tallahatchie Valley Electric Power Association",[-89.9211625751387, 34.33512159238214]],
    [ "Strayhorn Substation",[-90.14397407507842, 34.62725809493468]],
    [ "487052216",[-89.98355164999998, 34.3094313]],
    [ "Palmito Substation",[-97.3798889, 25.98455735]],
    [ "Port of Charlston Substation",[-79.95142647069014, 32.84764415493607]],
    [ "American Electric Power",[-85.17774309586629, 41.221318225287796]],
    [ "Laotto Substation",[-85.22290894668859, 41.278654168628755]],
    [ "DUNTONLK",[-85.04198700035391, 41.28222013218278]],
    [ "Butler Center",[-85.13718535000001, 41.30733675]],
    [ "487132808",[-89.73722629623421, 33.50743396709026]],
    [ "487132809",[-89.55435564999999, 33.438790850000004]],
    [ "Vicksburg Substation",[-85.54165779934898, 42.12025740708238]],
    [ "487151219",[-89.81923112493105, 33.788645058433865]],
    [ "487207603",[-90.53519251019546, 34.21946117487107]],
    [ "Clarksdale Substation",[-90.5546704133628, 34.175009858513015]],
    [ "Jonestown Substation",[-90.49210556175807, 34.33947567972983]],
    [ "Laguna Substation",[-97.29197533225836, 27.648995043580157]],
    [ "Alazan Substation",[-97.50220985, 27.5598557]],
    [ "Barney Davis Substation",[-97.31307045137862, 27.607708401623803]],
    [ "487246369",[-90.72127821409839, 33.76278702111666]],
    [ "Greenville Substation",[-91.06193717896981, 33.390362729712706]],
    [ "Davis Substation",[-84.68060698138238, 42.6844670969774]],
    [ "487499629",[-85.04582452523498, 34.82091364458239]],
    [ "487545470",[-97.50572270458996, 35.66815381361552]],
    [ "487545471",[-97.54120492497623, 35.63793385602211]],
    [ "Piikoi Substation",[-157.84246237019502, 21.30458509511766]],
    [ "Bil-Mar Substation",[-86.02257925, 42.9171456]],
    [ "Riley Substation",[-86.0023200193461, 42.82826520206536]],
    [ "487571453",[-80.80251441429499, 32.131583348469505]],
    [ "Ramona Substation",[-85.6120361106232, 42.95773859370304]],
    [ "Huntsville Utilities",[-86.74568916703946, 34.7509731162384]],
    [ "Kinder Morgan Substation",[-79.94195964999999, 32.8248043]],
    [ "488377299",[-88.69635902883131, 43.41496674554993]],
    [ "Blackhawk Substation",[-89.06893574881695, 42.19368247599189]],
    [ "Roscoe Bert Substation",[-89.08780924326157, 42.31728665339747]],
    [ "Blue Ridge Substation",[-92.2900300369759, 38.98584736417124]],
    [ "Rebel Hill Substation",[-92.27891267522007, 38.95035879432299]],
    [ "488507818",[-97.49928911678194, 27.83638475348094]],
    [ "488507828",[-97.5050203015631, 27.817946657591914]],
    [ "Hearn Road Substation",[-97.6108201167936, 27.84992745371033]],
    [ "Mayo Substation",[-97.42469682523756, 27.909481890806678]],
    [ "Midway Substation",[-97.36539668240867, 27.943976746529856]],
    [ "Gila Substation",[-97.42126545315158, 27.81966446382382]],
    [ "Nueces Bay Substation",[-97.41837552414192, 27.820878520441866]],
    [ "Air Liquide Substation",[-97.47798115, 27.8148983]],
    [ "Kepler Substation",[-97.50485307304497, 27.818583810562227]],
    [ "488507982",[-97.46801645, 27.811832999999993]],
    [ "Cantwell Substation",[-97.44437418203741, 27.81139249831536]],
    [ "Citgo",[-97.42212726173574, 27.80484323962571]],
    [ "Citgo",[-97.42014421169702, 27.80790678417311]],
    [ "Industrial Substation",[-97.43138775447544, 27.80810152571556]],
    [ "Citgo",[-97.42704477594206, 27.812671053474624]],
    [ "Highway 9 Substation",[-97.4458659672385, 27.796450096289433]],
    [ "West Oso Substation",[-97.45212760000001, 27.76620465]],
    [ "Javelina Substation",[-97.45704046170957, 27.805139283199374]],
    [ "Clarkwood Substation",[-97.53548200569047, 27.820263021165523]],
    [ "Hearn's Ferry Substation",[-97.53766886492149, 27.832211257636374]],
    [ "Valero",[-97.47941250666646, 27.816443140954835]],
    [ "Valero East Substation",[-97.48059797203722, 27.8149393963017]],
    [ "Valero West Substation",[-97.48329314905189, 27.815108147887496]],
    [ "Koch Upriver Substation",[-97.52468752203978, 27.827453357785032]],
    [ "488508185",[-97.59603375, 27.811042900000004]],
    [ "Champlin - Citgo West Substation",[-97.496753, 27.809899350000002]],
    [ "488508422",[-80.77579769772505, 34.99035862798804]],
    [ "Springhill Substation",[-93.44841824999999, 33.00376034999999]],
    [ "Entergy Arkansas",[-92.83118528935807, 34.342873832408]],
    [ "488692394",[-76.19908344402916, 40.790572830303866]],
    [ "Orono Substation",[-93.62460659115946, 44.993095398504494]],
    [ "Sylvan Substation",[-122.7386109394873, 45.50944568052125]],
    [ "488801562",[-86.43163601543094, 36.94267040245376]],
    [ "488804514",[-86.47106386879325, 36.97864964922643]],
    [ "488817278",[-86.50573924215635, 36.93438059597415]],
    [ "488842559",[-86.46148290358663, 36.986330088732785]],
    [ "Subestación Potala Pastillo",[-66.49596080913003, 17.99588042745464]],
    [ "Kentucky Utilities Company",[-84.5885642214648, 37.88127152205613]],
    [ "488945294",[-90.32499632743678, 33.48748204425998]],
    [ "488953399",[-82.95204174979852, 40.14087703593282]],
    [ "488955081",[-92.40278609341298, 38.942908624293494]],
    [ "Cartwright Substation",[-122.29272180234815, 37.77933296845913]],
    [ "Felch Road Substation",[-85.82957049950922, 43.422640800076785]],
    [ "Spring Drive Substation",[-85.82862489560561, 43.42230123991283]],
    [ "Newaygo Substation",[-85.85042576065909, 43.404378549452986]],
    [ "Ferriday Substation",[-91.5539179, 31.64393085]],
    [ "489084233",[-92.01057815, 31.0242202]],
    [ "Johnson City Energy Authority",[-82.3109913415908, 36.42429546837049]],
    [ "St. Stephen Dam",[-79.92949206884865, 33.42647901552374]],
    [ "489253386",[-79.93724431978715, 33.40685833651989]],
    [ "489261008",[-79.9860314785543, 33.40626621215117]],
    [ "489304030",[-109.02516426251702, 35.66004814875229]],
    [ "Burton Subtation",[-83.7478234, 42.277242300000005]],
    [ "Skidmore Substation",[-97.67631008911087, 28.25521077958956]],
    [ "Chase Field Substation",[-97.6707732577357, 28.380588433364068]],
    [ "Clay West Substation",[-98.19877193747007, 28.25104586272602]],
    [ "West George West Substation",[-98.21270343915819, 28.287583804418837]],
    [ "Tynan Substation",[-97.77229931678464, 28.18319750204318]],
    [ "Bee Prison Substation",[-97.80611797136922, 28.334824715389903]],
    [ "Olmos Substation",[-97.79599405, 28.2438148]],
    [ "Mathis Substation",[-97.86158591646387, 28.160355745098194]],
    [ "George West Substation",[-98.07320431792188, 28.33091329636292]],
    [ "Los Angeles Substation",[-99.00110584999999, 28.390901050000004]],
    [ "Fowlerton Substation",[-98.80140534458542, 28.37145412513927]],
    [ "George West Switching Station",[-98.19400694520859, 28.40355138024051]],
    [ "Simmons City Substation",[-98.2058672556216, 28.408887823702013]],
    [ "Tilden Substation",[-98.51863710199659, 28.45937050547748]],
    [ "Choke Canyon Prison Substation",[-98.32001165, 28.441783999999995]],
    [ "Choke Canyon Substation",[-98.28027635000001, 28.453500000000002]],
    [ "North Calliham Substation",[-98.34119037486056, 28.5435999128687]],
    [ "Three Rivers Refinery Substation",[-98.19072004906138, 28.45850744463974]],
    [ "Sigmor Substation",[-98.1868327403127, 28.45536922803977]],
    [ "Choke Canyon Substation",[-98.21903397981609, 28.454896990013076]],
    [ "Choate Substation",[-97.74064010000001, 28.815513650000007]],
    [ "Kenedy Substation",[-97.83240623252753, 28.879930814344096]],
    [ "Coy City Substation",[-97.99395585145085, 28.871855983579845]],
    [ "Berclair Substation",[-97.59852049999999, 28.493301250000005]],
    [ "Beeville Substation",[-97.79789758304145, 28.42493641537105]],
    [ "Normanna Substation",[-97.77399261821093, 28.53353446561138]],
    [ "Tuleta Substation",[-97.7885434921324, 28.598227230619422]],
    [ "Pettus Substation",[-97.79539791931663, 28.620694907668618]],
    [ "Lyssy Substation",[-98.12005345, 28.894397700000003]],
    [ "Karnes City Substation",[-97.87860377579796, 28.85889494418115]],
    [ "Kenedy Substation",[-97.84392675000001, 28.817675050000002]],
    [ "Beeville Substation",[-97.74337204032774, 28.397023664568888]],
    [ "Three Rivers Substation",[-98.15760050000004, 28.480958450000006]],
    [ "Sunniland Substation",[-98.20013983752213, 28.581374929331822]],
    [ "Fashing Substation",[-98.1706636, 28.8245284]],
    [ "Orange Grove Substation",[-97.960163518277, 27.91996697643777]],
    [ "Sandia Substation",[-97.86670835515699, 28.034846031901854]],
    [ "Casa Blanca Substation",[-97.90799303626422, 27.998276785727267]],
    [ "Orange Grove Switching Station",[-97.96141306989071, 27.918953587784216]],
    [ "George West Substation",[-98.13836524999998, 28.302010149999994]],
    [ "489577607",[-80.22385123133618, 33.058777543821755]],
    [ "Belen Sub",[-106.7358201739989, 34.65977091429717]],
    [ "Corpus Christi Substation",[-97.50221667491262, 27.68856889515015]],
    [ "Robstown Substation",[-97.63610692488638, 27.768613353752425]],
    [ "Papalote Creek Wind Farm Substation",[-97.42581644432224, 27.951205875437683]],
    [ "Robstown City Substation",[-97.66174585, 27.8004448]],
    [ "Robstown Substation",[-97.65889852771028, 27.789999493753985]],
    [ "Riverside Substation",[-97.71903889007943, 27.847055872098373]],
    [ "Banquete Substation",[-97.79141815199613, 27.796893729317937]],
    [ "Odem Substation",[-97.57378460000001, 27.94253385]],
    [ "Water Works Substation",[-97.62512179591818, 27.8766214149221]],
    [ "Edroy Substation",[-97.68471035000002, 27.975431250000003]],
    [ "Taft Substation",[-97.3581169065938, 28.000651729066863]],
    [ "Sodville Substation",[-97.47287525, 27.969667349999995]],
    [ "Smith Substation",[-97.63215215117434, 27.867816583351193]],
    [ "Stevens Substation",[-97.6194418778107, 27.860122307624863]],
    [ "489689062",[-87.48662906625685, 37.505076849485754]],
    [ "Kentucky Utilities Company",[-87.52321801504416, 37.274831927107314]],
    [ "Earlington North Substation",[-87.5270829378398, 37.276216184165946]],
    [ "489697576",[-89.87542669069039, 30.78271501297938]],
    [ "489698383",[-87.48988180978922, 37.28930437878288]],
    [ "489701067",[-87.22307794999999, 37.346149849999996]],
    [ "Orland Substation",[-87.8531060169805, 41.64305149837715]],
    [ "Bernville Substation",[-76.14025470550388, 40.45117929666452]],
    [ "ComEd Roberts Road Substation",[-87.81218975230671, 41.705058247039354]],
    [ "Bridgeview Substation",[-87.80858521808918, 41.73851118487382]],
    [ "Sayre Substation",[-87.79314774489805, 41.753041848806646]],
    [ "Johannesburg Substation",[-84.40117394235428, 45.006047171398166]],
    [ "Providence Substation",[-75.66535584403232, 41.435785722578885]],
    [ "Clearing Substation",[-87.77639964821185, 41.77095180299544]],
    [ "Commonwealth Edison",[-87.82731127017027, 41.77034641156618]],
    [ "ComEd Sawyer Substation",[-87.71322719904352, 41.804679349635634]],
    [ "Commonwealth Edison",[-87.77515105936651, 41.81163005207349]],
    [ "Elk Station Switchyard",[-101.8389547807281, 33.86622942015891]],
    [ "South Plains Wind 2 Substation",[-101.38162540255773, 34.196040165604494]],
    [ "South Plains Wind 1 Substation",[-101.32385302694819, 34.08052004792976]],
    [ "White River Substation",[-101.17945756532274, 34.0590348745891]],
    [ "490186926",[-92.34665323073985, 45.29659477487363]],
    [ "Queensborough Switching Station",[-79.97332928585506, 32.72334464248534]],
    [ "Driscoll Substation",[-97.7409524516322, 27.62646682809207]],
    [ "Corpus Christi Switch",[-97.63586205, 27.710991999999997]],
    [ "Kleberg Substation",[-97.85511514999997, 27.492234399999997]],
    [ "South Texas Electric Cooperative",[-97.81932372186601, 27.75560729526875]],
    [ "Bunsen Substation",[-97.81840231100782, 27.761697391866498]],
    [ "Bishop Substation",[-97.84294826153496, 27.579487414899376]],
    [ "490190268",[-97.82081405043571, 27.5688073666766]],
    [ "Celanese Bishop Substation",[-97.83035615000001, 27.560572499999996]],
    [ "King Ranch Gas Plant Substation",[-98.0534067752695, 27.4692226541294]],
    [ "Kingsville Substation",[-97.8862267938018, 27.530704025293346]],
    [ "Central Substation",[-97.91048877504362, 27.67008524499619]],
    [ "Ben Bolt Substation",[-98.06891925, 27.68741835]],
    [ "Alice Substation",[-98.08745937501435, 27.72983520734327]],
    [ "Stadium Substation",[-98.05383969887093, 27.74608159359164]],
    [ "Government Wells Substation",[-98.60159198525601, 27.933149553431917]],
    [ "Freer Substation",[-98.61740764415715, 27.845283073513844]],
    [ "San Diego Substation",[-98.24815255, 27.740942099999998]],
    [ "490198582",[-81.41976311604094, 35.18056847425994]],
    [ "Bucks Creek Switchyard",[-121.32756187632113, 39.91106199920718]],
    [ "Boxelder Substation",[-105.50899627896224, 44.27675045724911]],
    [ "Harbor Substation",[-87.54522313977084, 41.72467186263073]],
    [ "Commonwealth Edison",[-87.61213263554124, 41.66766478823779]],
    [ "Green Lake Substation",[-87.5488012224685, 41.60206035282255]],
    [ "Gasland Substation",[-102.82738852939104, 32.24969210828722]],
    [ "Andrews County Northwest Substation",[-103.05862173480426, 32.427359775043875]],
    [ "North Trail Substation",[-81.91854527849986, 26.752428289623023]],
    [ "490398224",[-84.95350005655509, 34.51225569394454]],
    [ "490414044",[-77.9835525003562, 34.310916546670924]],
    [ "Ferrell Substation",[-80.49708752374492, 41.208956979294605]],
    [ "Lufkin Substation",[-94.73829542459805, 31.35788224060718]],
    [ "North Arkansas Electric Cooperative",[-92.11495835809677, 36.15052377520429]],
    [ "Commonwealth Edison",[-88.00318977751292, 41.91272377551299]],
    [ "Commonwealth Edison",[-87.99397219637936, 41.91290547779801]],
    [ "Commonwealth Edison",[-87.95489738624784, 41.92361987174724]],
    [ "Oak Park Substation",[-87.7916631085092, 41.88765594286486]],
    [ "Reymet Substation",[-77.40748680779794, 37.38894898889183]],
    [ "Kingsland Substation",[-77.4168579, 37.3858597]],
    [ "490681638",[-86.04929153268651, 35.37765107174974]],
    [ "Commonwealth Edison",[-87.71508673008607, 41.65312047672401]],
    [ "Commerce Primary Substation",[-83.46513452584593, 34.21198796844626]],
    [ "Royston Substation",[-83.11771253176494, 34.290045390006334]],
    [ "Savage Substation",[-80.03920328023642, 32.80238534116294]],
    [ "Stono Park Substation",[-80.02431392293882, 32.78630022763887]],
    [ "Riverland Terrace Substation",[-79.98944063310601, 32.76091147435591]],
    [ "Washington Substation #2 Stepup",[-82.7535734, 33.70558715]],
    [ "Washington Substation #2",[-82.75319578375158, 33.70650423306417]],
    [ "Washington Primary Substation",[-82.75126400920139, 33.731468293966984]],
    [ "490811868",[-80.35202018233184, 41.02064212997283]],
    [ "Grant Street Substation",[-80.3535957659785, 41.00355046916606]],
    [ "Georgia Power",[-81.64447735, 32.749400099999995]],
    [ "Sylvania Substation #2",[-81.64411360156141, 32.74916103361298]],
    [ "491035760",[-80.32291045702965, 40.98039985884749]],
    [ "491130467",[-86.44922004422592, 36.979329202236684]],
    [ "Cedar Gap Substation",[-99.75282652513988, 32.31361684437458]],
    [ "Maryneal Substation",[-99.92870595, 32.46013565]],
    [ "Moore Substation",[-99.8365898714313, 32.387401822793386]],
    [ "Merkel Substation",[-100.00511180000001, 32.4785045]],
    [ "Scott Substation",[-100.07478272830484, 32.449253556614934]],
    [ "Butman Substation",[-100.07393125755355, 32.44940102165051]],
    [ "Trent Substation",[-100.11797467087354, 32.492739546855596]],
    [ "Fort Chadbourne Substation",[-100.27452172168518, 32.017023776059574]],
    [ "Oak Creek Switching Station",[-100.2929732085688, 32.04673485778405]],
    [ "Nicole Switching Station",[-100.2903649820492, 32.02331640481463]],
    [ "Wylie Substation",[-99.77641291767169, 32.368182365175066]],
    [ "Abilene Rebecca Lane Substation",[-99.78269454021924, 32.39441416237231]],
    [ "Abilene Twilight Trails Substation",[-99.787209, 32.417383650000005]],
    [ "Moore Substation",[-99.8368149876778, 32.387040049080944]],
    [ "McElmurray Substation",[-100.1388056448453, 32.466008700333674]],
    [ "McElmurray Substation",[-100.13833123837802, 32.46584580549729]],
    [ "Oak Creek Substation",[-100.35714386130205, 32.24309249915169]],
    [ "Lonestar Cement Substation",[-100.45958980000003, 32.2465417]],
    [ "Flintkote Substation",[-100.3388919, 32.48151275]],
    [ "US Gypsum Substation",[-100.3630032838382, 32.49192585448261]],
    [ "US Gypsum South Substation",[-100.36057015, 32.4890175]],
    [ "Sweetwater Substation",[-100.44293355706456, 32.457176177792554]],
    [ "Maryneal Substation",[-100.4538247294279, 32.2350751563761]],
    [ "Sweetwater Creek Substation",[-100.45888395, 32.243634400000005]],
    [ "Lonestar Cement Substation",[-100.45712127198348, 32.24445365823639]],
    [ "Turkey Track Wind Substation",[-100.25645060000002, 32.211982750000004]],
    [ "Abilene Elm Creek Substation",[-99.78955225610038, 32.458026009556264]],
    [ "Abilene Industrial Park Substation",[-99.81135815, 32.465194499999996]],
    [ "Abilene Northwest Substation",[-99.78984840673405, 32.50283814098071]],
    [ "Sandusky Substation",[-99.75478985000002, 32.35999580000001]],
    [ "Walker Substation",[-99.70020859021422, 32.35838997505519]],
    [ "Abilene South Substation",[-99.75128440377762, 32.35916554996153]],
    [ "Trent Wind Farm Substation",[-100.23178225000001, 32.449597950000005]],
    [ "Sweetwater Wind 2 Substation",[-100.3797682487832, 32.33094955514416]],
    [ "Roscoe Substation",[-100.54100216506184, 32.4462357190482]],
    [ "Loraine Substation",[-100.71323145000001, 32.415882450000005]],
    [ "Sweetwater Downtown Substation",[-100.40972887099178, 32.46599326254061]],
    [ "Golden Spread Electric Cooperative",[-100.3973868124675, 32.44343172238355]],
    [ "Sharyland Utilities",[-100.71519092597921, 32.38250420968383]],
    [ "Georgia Power",[-81.80460612517965, 32.39936548880605]],
    [ "Georgia Power",[-81.78833198239094, 32.430313653085946]],
    [ "Vernon Substation",[-74.50023423862203, 41.194112462074486]],
    [ "Warlow Substation",[-105.51530279823756, 44.29890540128142]],
    [ "City of Gillette",[-105.51911389550813, 44.28562986568392]],
    [ "Georgia Power",[-81.15823116721015, 31.98523375340895]],
    [ "Ellsworth Substation",[-85.67317259241774, 42.962792639509246]],
    [ "Commonwealth Edison",[-88.07967887975711, 41.53941118996981]],
    [ "Citgo Substation",[-88.05556084565234, 41.64343653209514]],
    [ "Bronte Atlantic Substation",[-100.31101534999999, 31.8218762]],
    [ "Spence Pump Substation",[-100.59718475007013, 31.950586066683513]],
    [ "Bronte Substation",[-100.29330614999998, 31.891341]],
    [ "Bronte Ambassador Substation",[-100.3973224, 31.88512575]],
    [ "Robert Lee Substation",[-100.48483651549697, 31.892157272597107]],
    [ "Edith Substation",[-100.61110697421915, 31.91826365539239]],
    [ "Silver Substation",[-100.67814297535736, 32.07040659087739]],
    [ "Silver Substation",[-100.68008445564206, 32.050972306991596]],
    [ "Cedar Hill Switching Station",[-100.73896111138491, 32.014413430494926]],
    [ "Perkins Substation",[-100.76872336172703, 32.00614176989972]],
    [ "NIPSCO",[-85.73754728306587, 41.66846086898089]],
    [ "491440938",[-94.34454218959138, 34.02775073295651]],
    [ "491440940",[-94.34353123274161, 34.02816417010277]],
    [ "Petersburg Substation",[-83.70526741688941, 41.90515729762499]],
    [ "Elgin Energy Center Substation",[-88.24462606109812, 42.0007163735748]],
    [ "Downers Grove Substation",[-88.00369929942303, 41.74812738402842]],
    [ "Harris Road Substation",[-94.29180919691298, 38.83603033555446]],
    [ "Nordic Substation",[-88.03242930980275, 41.94698735271834]],
    [ "Georgia Power",[-81.48313040000001, 31.136322600000003]],
    [ "Southeast Chicago EC Substation",[-87.5455062375357, 41.71890894410521]],
    [ "Glenwood Substation",[-87.62354024539229, 41.53561629570457]],
    [ "Commonwealth Edison",[-87.59731400335804, 41.503244972409156]],
    [ "Bryn Mawr Substation",[-75.32122358431144, 40.01451536533349]],
    [ "University Park South EC Substation",[-87.75145453463769, 41.43988870023914]],
    [ "University Park North EC Substation",[-87.75127581259568, 41.44207614780499]],
    [ "491673255",[-88.3047422160674, 41.411990294958684]],
    [ "Huntsville Utilities",[-86.61273864830818, 34.76040572564954]],
    [ "491803246",[-95.8649520799771, 32.69789996893891]],
    [ "King Seeley Substation",[-83.8365995001038, 42.325384250155636]],
    [ "Hamilton Substation",[-81.68357274228778, 41.50886794862043]],
    [ "Meeting Street Substation",[-79.94531831411724, 32.805434918232685]],
    [ "Jesup City Substation",[-81.89079336493332, 31.603880931642284]],
    [ "Huntsville Utilities",[-86.5462996668423, 34.69800493353762]],
    [ "Subestación Yabucoa",[-65.85078230833881, 18.042901629283683]],
    [ "Subestación Candelero",[-65.8241549825331, 18.106163101870745]],
    [ "492221695",[-88.65252410852794, 41.682881775338]],
    [ "492221696",[-88.65259896814936, 41.68343371115018]],
    [ "492250687",[-89.35862054973286, 42.34011423643438]],
    [ "492256602",[-87.86641053217316, 41.49218201206218]],
    [ "East Bainbridge Substation",[-84.5488188146889, 30.911497098877216]],
    [ "Newton Substation",[-89.1183027584366, 32.33364666618907]],
    [ "Blue Creek Substation",[-84.56070627506654, 40.929557166665056]],
    [ "Blue Creek Wind Farm",[-84.58278568653628, 40.939786603475554]],
    [ "Osterburg East Substation",[-78.50574338085302, 40.149142780706505]],
    [ "Georgia Power",[-84.72618812108999, 31.457562841682275]],
    [ "Paulding Putnam Hessen Substation",[-85.0557674, 40.975573149999995]],
    [ "Georgia Power",[-83.78070245859125, 31.122261965916522]],
    [ "Commonwealth Edison",[-87.87727693478612, 41.09205212831845]],
    [ "Commonwealth Edison",[-87.87562355192205, 41.09221639555085]],
    [ "Wilmington Substation",[-88.17893821406736, 41.29246595924427]],
    [ "492484892",[-88.2591236626695, 41.36586890798126]],
    [ "492490058",[-115.43604455393063, 35.573334170899294]],
    [ "492603301",[-87.79607332572674, 32.32705017622077]],
    [ "492621387",[-88.18493445669131, 41.444828698723136]],
    [ "492682796",[-88.11014403897572, 41.49196424049134]],
    [ "492684302",[-85.57695399405338, 40.479351468582614]],
    [ "492717054",[-117.3629099639241, 34.5951012646397]],
    [ "Metter Substation",[-82.06636139999999, 32.405101200000004]],
    [ "Maryville Substation",[-94.84774203805468, 40.345931019779506]],
    [ "Convent Substation",[-74.45086411531909, 40.78556949718634]],
    [ "Convent Traction Tie Substation",[-74.44572036355083, 40.78036159549191]],
    [ "Eola Substation",[-100.089891592376, 31.414022774976967]],
    [ "Eden Substation",[-99.83622623377443, 31.21574062453014]],
    [ "Colorado River Municipal Water District #1 Substation",[-99.6982762, 31.49142345]],
    [ "Paint Rock Substation",[-99.91807864999998, 31.5062491]],
    [ "Happy Valley Substation",[-100.09938369257125, 32.14328076839725]],
    [ "Bradshaw/Climax Substation",[-99.87992880000002, 32.09587315]],
    [ "Bradshaw Substation",[-99.88256635808175, 32.09250047096723]],
    [ "Winters Substation",[-99.96215375455725, 31.97096172538187]],
    [ "Hatchell Substation",[-99.9563972, 31.820680649999996]],
    [ "Rowena Substation",[-100.0472679898602, 31.645725824964313]],
    [ "Harriett Substation",[-100.2581491335673, 31.55173195577737]],
    [ "Miles Substation",[-100.17810259999999, 31.593340050000002]],
    [ "Fort Valley Substation",[-83.87235216842873, 32.561385312179915]],
    [ "Georgia Power",[-84.96955324381022, 32.50647622534269]],
    [ "Fort McCoy Substation",[-81.96350386369662, 29.367078677378082]],
    [ "69",[-109.01194265676511, 40.23600845425302]],
    [ "493276955",[-82.49369742883633, 29.398056896324917]],
    [ "Subestación Villalba",[-66.48816060673158, 18.13161886631181]],
    [ "Greensboro Substation",[-83.1743581131081, 33.573131838507344]],
    [ "493376457",[-80.87520321558236, 41.14849897137182]],
    [ "493376459",[-80.85877840514519, 41.169769460942476]],
    [ "493420028",[-83.47518706659945, 33.59447735049029]],
    [ "Eldorado Shell Bailey Substation",[-100.623076, 30.83157415]],
    [ "Middle Valley Substation",[-100.31105651940226, 30.757902757813117]],
    [ "Page Field Substation",[-100.4642948392999, 30.79852352466631]],
    [ "Fort McKavett Substation",[-100.2642264455186, 30.747376271226585]],
    [ "Eldorado Substation",[-100.5966197, 30.86069835]],
    [ "Sonora City Substation",[-100.64422350000001, 30.570974900000003]],
    [ "493464163",[-83.85821930106695, 33.60032639876363]],
    [ "Letterkenny Substation",[-77.63206409120954, 39.98569983712906]],
    [ "493507449",[-82.64057129999999, 29.464274200000002]],
    [ "493521308",[-82.63817440733345, 29.16823832983445]],
    [ "493521310",[-82.8858878728259, 29.417272974776527]],
    [ "Fredonia Substation",[-99.1190717, 30.894662699999998]],
    [ "Puncher Substation",[-99.26179197060797, 30.56229780556671]],
    [ "Mason Phillips Substation",[-99.26911569237411, 30.546487418123924]],
    [ "Puncher Substation",[-99.26098096091908, 30.562673440507165]],
    [ "Streeter Substation",[-99.41112889176497, 30.763742988782116]],
    [ "Shell London Substation",[-99.59288318418055, 30.645720389922204]],
    [ "Hornet Substation",[-99.82381959999998, 30.687096100000005]],
    [ "Menard Phillips Substation",[-99.8237915, 30.68301175]],
    [ "Junction Substation",[-99.77064604999998, 30.492406850000002]],
    [ "Junction Substation",[-99.76951690635397, 30.515172003509857]],
    [ "493555139",[-87.4116261086325, 36.587714749378314]],
    [ "Rachel Hill Substation",[-78.84783349945445, 40.26703964762991]],
    [ "Camp San Saba Substation",[-99.28163575, 30.9602689]],
    [ "Katemcy Substation",[-99.28171641465808, 30.959666858349387]],
    [ "Brady Substation",[-99.34156241573001, 31.13522522537889]],
    [ "North Brady Substation",[-99.3362320843142, 31.155516625482996]],
    [ "Melvin Substation",[-99.58401101288901, 31.196338531057332]],
    [ "Schaffner Substation",[-99.75421995556415, 31.21495577527927]],
    [ "Cincinnati Substation",[-95.51911217336439, 30.849632055362214]],
    [ "East Kentucky Power Cooperative, Inc.",[-84.86909649335898, 37.78369294612218]],
    [ "493769011",[-84.82769773925105, 37.757185002123656]],
    [ "Kentucky Utilities Company",[-84.82764022694843, 37.75899544691985]],
    [ "River Energy Center Substation",[-87.55903591441489, 41.68721965194116]],
    [ "493796316",[-84.81848368822236, 33.90016759656986]],
    [ "493796318",[-84.84074079999998, 33.91450425]],
    [ "DeWitt Substation",[-90.53581554005135, 41.81098812490429]],
    [ "Van Ply Substation",[-93.45964920175838, 31.45138366170487]],
    [ "Toledo Bend Substation",[-93.56468549257755, 31.173850140780406]],
    [ "Provencal Substation",[-93.20277315599547, 31.66174234668352]],
    [ "Enterprise Products Operating, LLC",[-93.41778683856282, 31.504589562984265]],
    [ "Many Substation",[-93.41481917234552, 31.505516763641022]],
    [ "Robeline Substation",[-93.32861165404685, 31.666574638553307]],
    [ "Marthaville Substation",[-93.38774072465114, 31.738739514807797]],
    [ "Belmont Substation",[-93.50712631028547, 31.715718124710467]],
    [ "Noble Substation",[-93.69374984603401, 31.66902436719659]],
    [ "Negreet Substation",[-93.56424563158116, 31.47219399715658]],
    [ "Mansfield Substation",[-93.67203092430508, 32.014719153428906]],
    [ "Many Substation",[-93.46442612984684, 31.57915530114804]],
    [ "Many Substation",[-93.46542430719569, 31.578838636499455]],
    [ "Colonial Pipeline Substation",[-85.1715332583062, 33.740006770823214]],
    [ "North Mount Zion Substation",[-85.17404805582912, 33.642809384984204]],
    [ "494002179",[-90.46448885914343, 37.165563570809084]],
    [ "Gaylord OCB Substation",[-84.58636661092578, 44.98655982722349]],
    [ "Wolverine Power Supply Cooperative",[-84.58700026452233, 44.98658762481519]],
    [ "Bagely Substation",[-84.6502191, 44.9868063]],
    [ "Makaloa Substation",[-157.8408253989505, 21.293407667393836]],
    [ "Chrysler Corp. Substation",[-88.86606982163119, 42.23857239414997]],
    [ "Great Lakes Substation",[-87.87249767263134, 42.301558443370084]],
    [ "494075568",[-87.88569739231897, 42.306718720904456]],
    [ "494178199",[-100.67341219338446, 46.08155347003338]],
    [ "494178215",[-100.67591661851819, 46.08971979024513]],
    [ "494220323",[-97.3750660582656, 35.421293172826765]],
    [ "Georgia Power",[-84.75406210463521, 33.36351891139556]],
    [ "494253671",[-119.19753225000002, 47.13490945]],
    [ "494254315",[-119.19417907133135, 47.12951426565667]],
    [ "Price Substation",[-93.0790011342377, 31.82628830572708]],
    [ "CIty of Natchitoches",[-93.10151660970381, 31.72661172776057]],
    [ "Highway 1 South Substation",[-93.07338598930976, 31.72686480043861]],
    [ "Layfield Substation",[-93.18730815520429, 31.98218815259055]],
    [ "Layfield Substation",[-93.18766270252729, 31.98003200286607]],
    [ "Saint Muarice Substation",[-93.05941024999998, 31.765133199999994]],
    [ "494261710",[-119.19271834999999, 47.12570245]],
    [ "494266994",[-119.1145487376279, 46.307160027393216]],
    [ "MEDC Substation",[-81.6039710712252, 41.50291140903455]],
    [ "494301952",[-83.09121835, 29.609654750000004]],
    [ "Steinhatchee Substation",[-83.37111555, 29.6733154]],
    [ "Summer Grove Substation",[-84.6767262555766, 33.37808998199505]],
    [ "Georgia Power",[-84.81681975000001, 33.435861800000005]],
    [ "Madras Substation",[-84.76444752405665, 33.42224155756783]],
    [ "Yamaha Substation",[-84.72578829368824, 33.40261353144537]],
    [ "Georgia Power",[-84.45324539999999, 33.31327345]],
    [ "Georgia Power",[-84.3291806063833, 33.299197525396835]],
    [ "Vaughn Substation",[-84.38647878656977, 33.29797527232448]],
    [ "Marseilles Substation",[-88.714994072027, 41.327138080293196]],
    [ "494337233",[-88.66297898805057, 41.310793831172084]],
    [ "Bulverde Substation",[-98.44122025751803, 29.731898578816093]],
    [ "Blossom Substation",[-98.45934478111909, 29.54651409840636]],
    [ "494563857",[-116.61269729118763, 43.615829862479444]],
    [ "494568952",[-88.41860084787339, 41.29919136567835]],
    [ "Mansfield Substation",[-93.67267984999998, 32.01441675000001]],
    [ "494732444",[-93.39230367504946, 32.004297446600454]],
    [ "Carroll Substation",[-93.41734054809685, 32.05534258314677]],
    [ "Waycross Substation",[-78.18106454999999, 34.850324900000004]],
    [ "494833611",[-76.32754817585621, 40.058050995169495]],
    [ "Donnelley Substation",[-76.32142471676588, 40.05891927840544]],
    [ "Georgia Power",[-84.3359927642963, 33.91288746853651]],
    [ "Strawberry Substation",[-80.02803246256197, 33.0897523468148]],
    [ "Google Substation #1",[-80.04319357659391, 33.06594136102878]],
    [ "494913640",[-92.76258475, 37.72051520000001]],
    [ "494953944",[-80.12756969270431, 33.12142818372622]],
    [ "494976866",[-79.04386346732106, 35.62010528405407]],
    [ "494980255",[-79.81934140675685, 35.76845437482402]],
    [ "Giant Switching Station",[-80.45109654999997, 33.23865725]],
    [ "495010407",[-80.43424885590345, 33.23493596898941]],
    [ "495010422",[-80.25375844804249, 33.214073147823925]],
    [ "495015847",[-115.06131437752137, 36.2045355622036]],
    [ "495016960",[-80.44222948390588, 33.239440709293824]],
    [ "495021507",[-80.42906747581026, 33.27943036976871]],
    [ "495023388",[-82.27264726293383, 29.066788930431272]],
    [ "495023400",[-82.30684654350783, 29.053224524953016]],
    [ "495023407",[-82.35075508737643, 29.178468235379853]],
    [ "495046730",[-82.20327637516634, 29.076882496190443]],
    [ "495046732",[-82.20100791270758, 29.1062858249788]],
    [ "495046733",[-82.21960169599375, 29.13785007415556]],
    [ "Circle Square Substation",[-82.25573035, 29.07856795]],
    [ "Kingston Substation",[-93.70771094863666, 32.1924214931781]],
    [ "Bayou-Pierre Substation",[-93.63291919746182, 32.28867243693301]],
    [ "Southwestern Electric Power Company",[-93.66324934999999, 32.249293]],
    [ "International Paper Mansfield Substation",[-93.55646423365127, 32.1628209760091]],
    [ "495084139",[-79.85223520258562, 32.791104566486474]],
    [ "Isle of Palms Substation",[-79.78914638714195, 32.78860032128467]],
    [ "495155250",[-81.76762392743188, 34.915034107280285]],
    [ "495163358",[-81.04834058140806, 33.96112950755585]],
    [ "495169828",[-80.95480329999998, 34.17407424999999]],
    [ "SONY Substation",[-79.58118710000002, 40.184160299999995]],
    [ "Wamplers Substation",[-84.13046508881462, 42.05955682840789]],
    [ "Noggles Substation",[-84.11914247455542, 42.129851142553115]],
    [ "Loch Erin Substation",[-84.13586151527723, 42.027568024555734]],
    [ "Coldwater Substation",[-85.02057877954597, 41.926418830187906]],
    [ "Boise Bench Substation",[-116.15826288902687, 43.559123988588304]],
    [ "495247330",[-113.81548786106754, 42.5197482250021]],
    [ "Enable Gas Transmission, LLC",[-93.91966600099792, 32.57458651653704]],
    [ "Oil City Substation",[-93.97837922550563, 32.75056375830893]],
    [ "Superior Substation",[-93.98178545, 32.81889355]],
    [ "Plain Dealing Substation",[-93.70686014842941, 32.90060411344713]],
    [ "Linton Road Substation",[-93.70098253119416, 32.69713915237743]],
    [ "Deen Point Substation",[-93.68483771390746, 32.62925761885011]],
    [ "Haughton Substation",[-93.5160102, 32.5253778]],
    [ "Bean Substation",[-93.63883981127012, 32.37914398551313]],
    [ "Benteler Substation",[-93.60696909621949, 32.34081337923898]],
    [ "McDade Substation",[-93.50104882496726, 32.36607600394679]],
    [ "Caplis Substation",[-93.61057038510634, 32.39624465424949]],
    [ "Hanahan Water Treatment Plant Substation",[-80.01868828363381, 32.927160895946216]],
    [ "North Charleston Port Substation",[-79.97544627438229, 32.90304517831316]],
    [ "Thomas Island Substation",[-79.92669627219922, 32.874810522961155]],
    [ "495331195",[-79.99017300854005, 32.821815070970935]],
    [ "495432853",[-90.33095417053975, 40.34443111172208]],
    [ "495564972",[-71.99802993702116, 44.32276847051891]],
    [ "National Grid",[-71.99936493441184, 44.32329341894022]],
    [ "Comerford Substation",[-72.00310387836429, 44.32093100609114]],
    [ "St. Johnsbury Substation",[-71.98388056320775, 44.41792974038162]],
    [ "Littleton Substation",[-71.88468858764978, 44.32904715143179]],
    [ "495568522",[-86.49168829999999, 38.7363883]],
    [ "495589323",[-79.96631668611374, 32.73906293149372]],
    [ "495609326",[-93.4526037168032, 43.74488270565713]],
    [ "Public Service Company of Oklahoma",[-95.94954376376874, 36.04159140696006]],
    [ "Lake Sinclair Substation",[-83.20626276905135, 33.136671342217404]],
    [ "Polaris Substation",[-115.18494807563594, 36.108744983754654]],
    [ "Abydel Substation",[-86.56737306984657, 38.56905541288832]],
    [ "Lieberman 12 kV Substation",[-93.95954515, 32.70544454999999]],
    [ "Lieberman 69 kV Substation",[-93.96045370447426, 32.705214635622205]],
    [ "Cedar Grove Substation",[-93.7590985878511, 32.45097473048067]],
    [ "Summer Grove Substation",[-93.83151414999999, 32.39113824999999]],
    [ "Minden Road Substation",[-93.71357853014804, 32.51720855861584]],
    [ "Broadmoor Substation",[-93.71574938079424, 32.47992471472944]],
    [ "Bossier City Substation",[-93.72615481632836, 32.51797624430991]],
    [ "Shed Road Substation",[-93.72704779785943, 32.529908504288855]],
    [ "495777180",[-86.60110088441064, 38.10994750116388]],
    [ "495836432",[-88.39820279999998, 33.4241428]],
    [ "Lincroft Substation",[-74.12126545169521, 40.330285605364786]],
    [ "495972098",[-82.15724180000001, 29.2172397]],
    [ "495972100",[-82.12955004102899, 29.205739465258915]],
    [ "495972108",[-82.1048037749392, 29.211060260146457]],
    [ "495972131",[-82.08721287167604, 29.193321071874596]],
    [ "495987744",[-80.0057313, 33.1899624]],
    [ "Sellersville Substation",[-75.310193669622, 40.35200675679459]],
    [ "Hatfield Substation",[-75.30572656196757, 40.30132754854402]],
    [ "496006790",[-88.55312425, 33.80608899999999]],
    [ "United States Army",[-85.96765820230678, 33.68317720918072]],
    [ "Colonial Substation",[-84.4757101, 33.8819987]],
    [ "Tell City Substation",[-86.73349622362215, 37.97593883316686]],
    [ "496186633",[-86.77055943712959, 37.98465131918052]],
    [ "496186639",[-86.79413127818141, 38.017274464488445]],
    [ "496194895",[-86.73239135041935, 37.959864491949475]],
    [ "496232369",[-81.83053170000002, 35.25791]],
    [ "South Carolina Electric and Gas Company",[-79.92621203560886, 32.77917474344998]],
    [ "Abercrombie-McCauleyville Substation",[-96.73654330000001, 46.44601775]],
    [ "496239253",[-86.79290128031023, 38.00015367506008]],
    [ "Orvilla Substation",[-75.2925763232574, 40.26715593875363]],
    [ "Barney Substation",[-96.9981635901162, 46.26226562515673]],
    [ "Mooreton Substation",[-96.88577302493795, 46.269060057180674]],
    [ "Watkins Substation",[-111.51378280046387, 33.14500504752748]],
    [ "Absecon Substation",[-74.5189878403029, 39.43401889581484]],
    [ "Arkansas Electric Cooperative Corporation",[-90.73247531899254, 35.23274154655]],
    [ "Glass Ranch Substation",[-102.00874590000001, 32.187637699999996]],
    [ "Solara Substation",[-99.60543472512379, 33.00657180351009]],
    [ "496461035",[-90.23345500750095, 32.22290632764385]],
    [ "496461053",[-90.25200392770232, 32.18239042810708]],
    [ "Dwight Substation",[-96.69583807993463, 46.29672957498123]],
    [ "Dwight Substation",[-96.73667370000001, 46.3029553]],
    [ "Dakota Magic Substation",[-96.83081689999999, 45.93936415]],
    [ "Mooreton Substation",[-96.88661625, 46.24002375]],
    [ "Rankin Substation",[-101.93749794999998, 31.217913949999996]],
    [ "Discovery Canyon Substation",[-101.93496065000001, 30.895708650000003]],
    [ "Cactus Tapping Station",[-101.83204745, 30.787753649999996]],
    [ "Iraan Substation",[-101.89966017502745, 30.9104814893564]],
    [ "McCamey Shell Substation",[-102.19165985, 31.133319500000006]],
    [ "South Cross Substation",[-102.27661695, 31.048444500000002]],
    [ "Pecos River Substation",[-101.81823238840252, 30.787176032055278]],
    [ "Iraan Air Products Substation",[-101.94355209999999, 30.912984]],
    [ "Marathon Yates Substation",[-101.93245693896455, 30.922412521960727]],
    [ "Sheffield Substation",[-101.81545538235771, 30.72506591569897]],
    [ "West Yates Substation",[-101.96581853313324, 30.94925669911662]],
    [ "Mesa View Substation",[-101.99225934999998, 30.89774565]],
    [ "Mesa View Substation",[-102.03241538284041, 30.82461804822899]],
    [ "Desert Sky Wind Substation",[-102.10968197088066, 30.91595844157076]],
    [ "Indian Mesa Wind Substation",[-102.20174185, 30.931671100000003]],
    [ "Bobcat Hills Substation",[-102.29657388070012, 31.105003656614468]],
    [ "Indian Mesa Substation",[-102.27131446573036, 30.97912741925261]],
    [ "Tunas Creek Substation",[-102.27546775, 30.98182725]],
    [ "Pearl Substation",[-102.2745462, 30.982295649999994]],
    [ "Sirius Substation",[-102.2740698, 30.982105349999998]],
    [ "Bootleg Substation",[-102.29148625474254, 30.994456966845142]],
    [ "Onekama Substation",[-86.16253781714254, 44.35922131465734]],
    [ "Norge Machine Substation",[-86.31891825000001, 43.21352984999999]],
    [ "Western Avenue Substation",[-86.26995152531198, 43.22870219685866]],
    [ "Terrace Substation",[-86.24541950374717, 43.23978285053442]],
    [ "Consumers Energy",[-86.24247096735544, 43.240809051481264]],
    [ "496779254",[-97.48976, 35.47014135]],
    [ "Brownsville Energy Authority",[-89.24200060968174, 35.605727721717145]],
    [ "Allenhurst Substation",[-74.00719138202358, 40.235314975232235]],
    [ "Andalusia Bypass Substation",[-86.49909592477117, 31.310458192270513]],
    [ "Bolivar Energy Authority",[-88.92626435518619, 35.33394663053244]],
    [ "Bolivar Substation",[-89.01838539901472, 35.25795415938558]],
    [ "Substation L",[-157.81619123674682, 21.292013022918713]],
    [ "Greens Prairie Substation",[-96.25775599999999, 30.553654399999996]],
    [ "Dobbin Substation",[-95.78152397887885, 30.350710404710163]],
    [ "496987883",[-96.0939011, 30.36992825]],
    [ "Mockingbird Substation",[-96.09389595890622, 30.370340561294334]],
    [ "Spring Branch Substation",[-95.69860521319342, 30.33324698928085]],
    [ "Independence Substation",[-96.40576525000002, 30.31575585]],
    [ "Caldwell Industrial Substation",[-96.71375086990395, 30.52715735724051]],
    [ "496987939",[-96.44830138424157, 30.72604425308003]],
    [ "Triangle Park Substation",[-96.44917159473384, 30.725374615727766]],
    [ "Carlos Substation",[-96.10005999185562, 30.592942260881117]],
    [ "Kurten Substation",[-96.29283337825231, 30.799775750158414]],
    [ "Speedway Substation",[-96.21648900000001, 30.5419393]],
    [ "Bryan Substation",[-96.40966490195683, 30.744457616470388]],
    [ "Bedias Substation",[-95.98752367532366, 30.67067195361024]],
    [ "Eagles Nest Substation",[-81.90472270000001, 28.88647485]],
    [ "Lady Lake Substation",[-81.92562997725375, 28.926683456976317]],
    [ "497033844",[-81.92824064999999, 28.971336399999995]],
    [ "West Penn Power",[-79.7188157979331, 40.61516190400097]],
    [ "Tennessee Valley Electric Cooperative",[-87.75933872087467, 35.32496027513783]],
    [ "Dickson Electric System",[-87.35290228298523, 36.06097190513513]],
    [ "Bassville Park Substation",[-81.77401660990616, 28.8376969263498]],
    [ "Leesburg Airport Substation",[-81.81221143619139, 28.84716305034621]],
    [ "497314966",[-89.02246636923581, 42.235624545482196]],
    [ "Johnson City Energy Authority",[-82.38290537739923, 36.304387462818084]],
    [ "Subestación Morovis",[-66.40691823886465, 18.32282382527694]],
    [ "497493151",[-98.1661999, 46.65982739999998]],
    [ "Litchville Substation",[-98.18554201202008, 46.73201497509168]],
    [ "University of Georgia Substation",[-83.37123999743847, 33.940085287312584]],
    [ "Cedar Grove Substation",[-83.6932738923425, 36.39845217955449]],
    [ "Industrial Park Substation",[-96.40777480506098, 30.655934867207677]],
    [ "North Substation",[-96.39445178335178, 30.69120240033207]],
    [ "497740152",[-83.65295739999999, 32.71602055]],
    [ "497774633",[-103.95005205846519, 46.136333577306004]],
    [ "497774634",[-103.95028302575017, 46.13699100479978]],
    [ "Harriman Utility Board",[-84.55434603325477, 35.93629540065026]],
    [ "Bosch Substation",[-80.10202037839929, 32.90598336591164]],
    [ "Sweetwater Substation",[-84.46450708120267, 35.59197791024954]],
    [ "497889569",[-103.86713864999999, 46.149305649999995]],
    [ "Sweetwater Utilities Board",[-84.45181182499931, 35.607554757933556]],
    [ "Lisbon Substation",[-81.74248056406734, 28.88056516292511]],
    [ "497917097",[-112.03428894024192, 33.52780316676468]],
    [ "497934291",[-103.95317917660034, 46.22625357488379]],
    [ "497955051",[-104.1360971406926, 46.35785384530264]],
    [ "Charleston International Manufacturing Center Substation",[-79.9293462, 32.984244849999996]],
    [ "Naval Support Activity Charleston Substation",[-79.94311445, 32.9337503]],
    [ "497967494",[-80.01305714271291, 32.89299688828468]],
    [ "497970785",[-80.07469564895896, 32.97236553483273]],
    [ "497970792",[-80.18062981269505, 33.00665845042268]],
    [ "Summerville Wastewater Treatment Substation",[-80.22083170172503, 32.987370317222336]],
    [ "497970798",[-80.19661726442655, 32.97632378093546]],
    [ "497970800",[-80.1632529342349, 32.960272126511654]],
    [ "497970802",[-80.12817127379432, 32.98021971721713]],
    [ "497970822",[-80.1349988670597, 32.93199955253333]],
    [ "497972711",[-91.71013949555886, 44.06969356273124]],
    [ "Dorchester Substation",[-80.36564864937873, 33.139349502628434]],
    [ "498040762",[-80.30232240000001, 33.0961245]],
    [ "498040764",[-80.20172390192565, 33.08818453874099]],
    [ "498040766",[-80.2230412, 33.04828825]],
    [ "498040769",[-80.22092527994164, 33.019051553770915]],
    [ "498040775",[-80.20520989425437, 33.03745686734624]],
    [ "Pittsburg Substation",[-94.6997070992551, 37.410462798073375]],
    [ "Rattlesnake Den Wind Substation",[-101.46637208465636, 31.74926848170905]],
    [ "Bow Wood Substation",[-99.54852322505253, 31.463111107249794]],
    [ "Wake Wind Wind Energy Substation",[-101.06975970000002, 33.80291484999999]],
    [ "Sequachee Valley Electric Cooperative",[-85.69588708552618, 35.402987487923575]],
    [ "Briscoe Wind Farm Substation",[-101.31488699999998, 34.39250765]],
    [ "Mariah del Norte Wind Substation",[-102.66454582567651, 34.68611549270167]],
    [ "Hereford Wind Substation",[-102.25565425, 34.7192262]],
    [ "498137311",[-86.0868592676301, 39.95175176560329]],
    [ "Scatterwash Substation",[-112.0762903665052, 33.711753695104036]],
    [ "498171104",[-102.18488295, 46.1045426]],
    [ "Colbeck's Corner Wind Farm Substation",[-101.15117320899753, 35.33540417057524]],
    [ "Kirby Switching Station",[-100.93783155000001, 35.255652149999996]],
    [ "Jericho Substation",[-100.93974449364799, 35.18378970055947]],
    [ "Salt Fork Wind Substation",[-100.94015155083162, 35.16384458431687]],
    [ "498236284",[-100.9400828252985, 35.16680755739793]],
    [ "Childress Amoco Substation",[-100.28223442558368, 34.41071164306451]],
    [ "Carey Substation",[-100.36449179737583, 34.47002563339354]],
    [ "Estelline Substation",[-100.44985453398604, 34.54546911265901]],
    [ "Childress Airport Substation",[-100.27011291734794, 34.43288911599578]],
    [ "Red River Substation",[-100.51790861008247, 34.60021917241903]],
    [ "Memphis Substation",[-100.53371422530616, 34.7198005466859]],
    [ "Northwest Memphis Substation",[-100.54520245, 34.74001675]],
    [ "Memphis Substation",[-100.5683706531619, 34.76133786759084]],
    [ "Hedley Substation",[-100.6635709, 34.85634215]],
    [ "Clarendon Substation",[-100.8657240449608, 34.92575747526594]],
    [ "Clarendon Substation",[-100.88995137294596, 34.93980017624478]],
    [ "Howardwick Substation",[-100.90192195000002, 35.04808665]],
    [ "498295001",[-86.09399212248, 38.71302737621955]],
    [ "498295004",[-86.10185923589341, 38.784177568433876]],
    [ "498304780",[-86.08684156830448, 38.61307744731347]],
    [ "498304785",[-85.956543, 38.360254950000005]],
    [ "Greenville Substation",[-85.95042255, 38.374849850000004]],
    [ "Hoosier Energy",[-86.04320805795922, 38.3889367753317]],
    [ "Grand Electric Cooperative",[-102.13574490000002, 45.9342309]],
    [ "498317329",[-102.47593681470303, 46.001929031732054]],
    [ "498325293",[-86.40104561164351, 39.17200451591187]],
    [ "Needmore Substation",[-86.34196327440787, 39.254776246341876]],
    [ "Chillicothe Substation",[-99.50982965000001, 34.24849645]],
    [ "West Childress Substation",[-100.22704934999999, 34.4194449]],
    [ "Childress Substation",[-100.2101546992684, 34.42090611130814]],
    [ "Kirkland Substation",[-100.06643274999998, 34.37759499999999]],
    [ "Quanah Acme Mills Substation",[-99.8205818, 34.3225336]],
    [ "Quanah Substation",[-99.7405800323527, 34.30156891766001]],
    [ "Henry Substation",[-100.2274615976946, 34.43051474325008]],
    [ "Childress 20th Street Substation",[-100.22474199999999, 34.43599805]],
    [ "Harlingen Switching Station",[-97.69822845, 26.2221971]],
    [ "498389296",[-85.57453987467161, 39.014344741678904]],
    [ "498420131",[-80.67227175, 32.918930950000004]],
    [ "498420132",[-80.67134844211932, 32.94866527830965]],
    [ "498420133",[-80.61116759999999, 32.95019384999999]],
    [ "498420135",[-80.61946696142935, 32.90806459507239]],
    [ "498420138",[-80.62930276912847, 32.9494665450867]],
    [ "498420139",[-80.62313134361462, 32.95172082358748]],
    [ "Manchester Substation",[-86.076459215447, 35.50365660088893]],
    [ "McLean Rural Substation",[-100.57393652481917, 35.21215366093837]],
    [ "Hollis Substation",[-99.91190401610166, 34.68001747465652]],
    [ "Shamrock Substation",[-100.25414832486548, 35.18328976172623]],
    [ "Carthage Substation",[-85.96042194910558, 36.266266871221355]],
    [ "Grayback Substation",[-99.16745915, 33.994044900000006]],
    [ "Harrold Substation",[-99.0937443246854, 34.042709038519305]],
    [ "Lockett Substation",[-99.37532286046766, 34.05109116979568]],
    [ "Fountain Head Substation",[-86.47941355276872, 36.55150233329473]],
    [ "Tennessee Valley Authority",[-86.50631809999997, 36.5908934]],
    [ "Tennessee Valley Authority",[-86.5050537, 36.59053840000001]],
    [ "Finley Substation",[-97.86760012508448, 47.514684037317295]],
    [ "Georgia Power",[-83.38230537309805, 33.91325105064253]],
    [ "Baldock Substation",[-81.42320456666666, 33.089509099999994]],
    [ "Georgia Pacific Substation",[-81.2258213784679, 32.99526158589938]],
    [ "Hampton Substation",[-81.10702620575121, 32.89879114513524]],
    [ "498828322",[-81.014683590933, 32.80318532007582]],
    [ "Fairfax Substation",[-81.23359610470263, 32.989157378663286]],
    [ "498865370",[-86.42123723004275, 32.19199781200151]],
    [ "Muldoon Mill",[-85.05383754634748, 40.94638866427749]],
    [ "Bendix Substation",[-99.1126646, 34.103328250000004]],
    [ "Mt. Etna Substation",[-85.56229013331162, 40.710854975599695]],
    [ "498943410",[-85.52857801340066, 40.616195510260425]],
    [ "498951620",[-101.21135609999999, 48.48708740000001]],
    [ "Bluffton Substation",[-80.85338360253789, 32.23502718298957]],
    [ "498967269",[-80.93540422318486, 32.26997685685073]],
    [ "South Carolina Electric & Gas",[-81.06223591345287, 32.273190277910395]],
    [ "South Carolina Electric & Gas",[-81.0376082570793, 32.321131279043996]],
    [ "498967280",[-81.03144375, 32.3358023]],
    [ "499089356",[-82.03758692178077, 28.87709822414972]],
    [ "499089357",[-82.03994467874097, 28.970835142424928]],
    [ "Duke Energy",[-79.83864820368856, 36.11690321758049]],
    [ "499194364",[-101.20680328612349, 48.37015148092168]],
    [ "499194365",[-101.18868427055625, 48.36993439118668]],
    [ "Nashville Electric Service",[-86.85194745000001, 36.15274375]],
    [ "499322820",[-102.30764866876451, 31.85256503578471]],
    [ "Midessa South Substation",[-102.2159717027475, 31.85813707375254]],
    [ "Oncor",[-102.20457544999998, 31.907421200000005]],
    [ "499342661",[-101.01704977159771, 48.718714588121976]],
    [ "499407744",[-101.36534992506695, 48.63317214701277]],
    [ "499415048",[-116.69238784971459, 43.61933312373362]],
    [ "Allendale Substation",[-81.31675912110916, 33.018406529708024]],
    [ "Midland Basin Substation",[-102.00966582550583, 32.011276041003256]],
    [ "Midland Gulf Substation",[-102.0251874514989, 32.01848886720858]],
    [ "499552270",[-101.22244973373678, 48.51022092501963]],
    [ "East Street Substation",[-96.17008756088786, 38.395936449782226]],
    [ "499568289",[-100.81046205, 46.030780799999995]],
    [ "Burnettown Substation",[-81.84749815, 33.51702755]],
    [ "499573302",[-81.93595498714012, 33.568582873320054]],
    [ "499576286",[-81.99686290710707, 33.63358485641485]],
    [ "499576287",[-81.97860553939728, 33.6361552300266]],
    [ "Ledgeview",[-88.36215148579005, 43.782048148752864]],
    [ "499577247",[-81.80008581423105, 33.84188938073446]],
    [ "499577250",[-81.8401938361618, 33.81041919689398]],
    [ "499649703",[-81.2122034679339, 34.04328839279834]],
    [ "499649712",[-81.10883585, 34.01909785]],
    [ "499649714",[-81.19179993269829, 34.006182903538125]],
    [ "Lexington Substation",[-81.23385493274446, 33.988494159894074]],
    [ "499649723",[-81.52753203632288, 33.934952967635]],
    [ "Pleasant Farms Substation",[-102.3162418752019, 31.739794955932624]],
    [ "Pegasus Substation",[-102.21313112928458, 31.740817906074046]],
    [ "Pegasus South Substation",[-102.22506400690682, 31.662888920470586]],
    [ "Crane East Substation",[-102.13167995, 31.433112449999996]],
    [ "Upton Substation",[-101.88488632069469, 31.43843428534888]],
    [ "Reagan Shell Substation",[-101.70784760000001, 31.633553799999998]],
    [ "Midkiff Switching Station",[-101.80785447860508, 31.52086632974467]],
    [ "Glasscock Substation",[-101.64537267933906, 31.68918565783812]],
    [ "Garden City Substation",[-101.52619196357617, 31.813133172809923]],
    [ "Garden City East Substation",[-101.46897285, 31.86663485]],
    [ "Tex Harvey Substation",[-101.79148068916713, 31.854406029015756]],
    [ "Tex Harvey Substation",[-101.79139463901325, 31.85340847901191]],
    [ "Savage Rd Substation",[-83.51199925, 33.98586395]],
    [ "Barnsley Substation",[-102.59785606349932, 31.406267908421775]],
    [ "Exxon Juan Cordona Substation",[-102.56246078686011, 31.325473933461787]],
    [ "Crane County Airport Substation",[-102.3729417, 31.4256723]],
    [ "Dune Field Substation",[-102.43615785, 31.536227600000004]],
    [ "Crane Gulf Substation",[-102.34135595000002, 31.423166549999998]],
    [ "Crane Atlantic Substation",[-102.43770706233364, 31.431988820641216]],
    [ "Texas-New Mexico Pipeline Substation",[-102.38026415000002, 31.42903935]],
    [ "McElroy Substation",[-102.31567629949909, 31.422933300323844]],
    [ "Crane East Substation",[-102.13164707350775, 31.43277164549601]],
    [ "Crane Humble Substation",[-102.34721672984341, 31.428714108803465]],
    [ "Getty Substation",[-102.35177644999999, 31.461997150000002]],
    [ "Crane Substation",[-102.33849603229112, 31.41082414266675]],
    [ "Crane Substation",[-102.3385911429933, 31.409853084113227]],
    [ "Crane Substation",[-102.33729087109911, 31.410823088478498]],
    [ "Arco Substation",[-102.45914017934913, 31.440578058035015]],
    [ "Spudder Flat Substation",[-102.31251887457483, 31.221249345619107]],
    [ "King Mountain Southwest Substation",[-102.27733631657755, 31.2214464004967]],
    [ "King Mountain Northwest Substation",[-102.23838627096933, 31.252639754428234]],
    [ "King Mountain Northeast Substation",[-102.17959820625065, 31.274424171188482]],
    [ "King Mountain Southeast Substation",[-102.13303716847062, 31.227452702754604]],
    [ "499972683",[-100.90202597280255, 46.748557574631754]],
    [ "499975721",[-84.31679354999999, 35.73656235]],
    [ "499975722",[-84.31632051812095, 35.73444704448907]],
    [ "Georgia Power",[-83.75025591580263, 31.156280867302907]],
    [ "Terre Haute 25th St. Substation",[-87.37919366526188, 39.4772953496369]],
    [ "500131096",[-80.75908245, 35.29182565]],
    [ "500167293",[-97.51732325000002, 35.413741300000005]],
    [ "Verona Substation",[-110.14303348414313, 48.15541415197809]],
    [ "500261804",[-103.64836947907202, 47.8334130750285]],
    [ "500271685",[-86.9301378362215, 38.449276849305114]],
    [ "500285044",[-86.23793027512488, 39.96295350449192]],
    [ "500286506",[-79.06788762740268, 36.014761540297]],
    [ "500482454",[-111.27797792447217, 45.270115263797734]],
    [ "Ward Switching Station",[-102.82549559999998, 31.450316250000004]],
    [ "500515469",[-103.28409283908694, 47.77485789915208]],
    [ "Musquiz Substation",[-103.15829336842559, 31.238370685228343]],
    [ "Waha Substation",[-103.11321430000001, 31.293589599999997]],
    [ "County Road 101 Substation",[-103.10664047512945, 31.275539843427822]],
    [ "Wolf Bone Ranch Substation",[-103.216114, 31.238171950000005]],
    [ "Clovis Substation",[-103.29181177496216, 30.953489991050432]],
    [ "Barrilla Junction Substation",[-103.36536238678292, 30.94725937215809]],
    [ "Hovey Substation",[-103.3614053, 30.952627650000004]],
    [ "Solstice Substation",[-103.36152782916572, 30.948263191428747]],
    [ "Lakewood Substation",[-94.38816507255858, 39.01249145710571]],
    [ "500709032",[-111.51805225, 46.3281008]],
    [ "500728740",[-97.17788868309466, 48.59224577477253]],
    [ "Alcoa Substation",[-83.96842252670795, 35.8091021525051]],
    [ "Northern Natural Substation",[-102.92458215, 30.99518915]],
    [ "Wolfcamp Substation",[-103.03535298731963, 31.18466668710711]],
    [ "Coyanosa Substation",[-102.9618195, 31.26294755]],
    [ "Royalty Substation",[-102.86947159784286, 31.38849428640318]],
    [ "Saragosa Substation",[-103.65300550280993, 31.04202071733735]],
    [ "Cherry Creek Substation",[-103.66663734999997, 31.114424299999996]],
    [ "Verhalen Substation",[-103.59005155000001, 31.144555250000003]],
    [ "Trickem Substation",[-86.74846057993578, 32.2750550929871]],
    [ "501210799",[-97.25265795706494, 48.96644446885517]],
    [ "501210911",[-97.19497494365265, 48.97090550936019]],
    [ "Andover Substation",[-74.74136358622556, 40.982749552313415]],
    [ "Beechwood Substation",[-86.42471127518544, 38.20689714239628]],
    [ "Kunitz Substation",[-104.74904735, 31.73484749999999]],
    [ "Salt Creek West Substation",[-104.04775344284833, 31.809831724787486]],
    [ "Culberson Substation",[-104.304652565241, 31.75778031980629]],
    [ "Culberson Substation",[-104.30377385793666, 31.757832083695007]],
    [ "Black River Substation",[-104.28688722833823, 31.833734895536544]],
    [ "501477428",[-104.04774902521403, 31.81014169512195]],
    [ "501477433",[-104.02407835, 31.920771650000002]],
    [ "Screwbean Substation",[-104.04595277491975, 31.821976215349256]],
    [ "501477439",[-104.04648267612691, 31.817710643720705]],
    [ "Orla Southwest Substation",[-103.93081700773568, 31.807206906252002]],
    [ "501477456",[-103.93163442463741, 31.797723622966252]],
    [ "501477459",[-103.93201355000001, 31.800355449999998]],
    [ "Beanblossom Substation",[-86.23883634797058, 39.26427399644531]],
    [ "Worsham Field Substation",[-103.33443062168348, 31.35618770719544]],
    [ "Collie Field Tap",[-103.4620137328883, 31.382639774584064]],
    [ "Collie Field Substation",[-103.46929645904817, 31.414645049371547]],
    [ "Quito Draw Substation",[-103.33821085000001, 31.3246916]],
    [ "Birds of Prey Tap",[-103.42372932049906, 31.37800235592279]],
    [ "Birds of Prey Substation",[-103.42679504999998, 31.374102699999998]],
    [ "Pyote Substation",[-103.09800244581264, 31.450603782579634]],
    [ "Stafford Boulevard Substation",[-103.49415181831841, 31.399987815808693]],
    [ "Barrilla Draw Substation",[-103.4307953616967, 31.257454260952155]],
    [ "Flat Top Substation",[-103.35951850000001, 31.199547199999998]],
    [ "Faulkner Substation",[-103.79318474999998, 31.26103105]],
    [ "Pecos Substation",[-103.498707104634, 31.429514548264454]],
    [ "IH 20 Substation",[-103.49097549503911, 31.399778563609246]],
    [ "Reeves County #4 Substation",[-103.62564069989585, 31.396450640756854]],
    [ "Bone Springs Substation",[-103.35568634745066, 31.53125761671433]],
    [ "Mi Vida Substation",[-103.45103082868205, 31.51527795453145]],
    [ "501745965",[-103.4613511, 31.523475249999994]],
    [ "Barstow Northwest Substation",[-103.47191839712059, 31.497302625845986]],
    [ "Cochise Substation",[-103.45206945137699, 31.51395336643742]],
    [ "Bone Springs Tap",[-103.4108055, 31.5446204]],
    [ "Lonestar Substation",[-103.24841045000001, 31.594275549999995]],
    [ "501756742",[-85.01485539999999, 39.01889199999999]],
    [ "501756743",[-85.03879143899792, 39.37034698932497]],
    [ "Sunman Substation",[-85.1130941, 39.2215522]],
    [ "Subestación Barranquitas",[-66.31897068945864, 18.190078852256683]],
    [ "501848283",[-83.5310168141456, 34.54010807249554]],
    [ "East Harrison Substation",[-97.66507847500712, 26.191412736946944]],
    [ "Oleander Substation",[-97.66455790901591, 26.206661319440027]],
    [ "501857707",[-80.29959665794466, 40.992046796863086]],
    [ "501875446",[-66.76819845, 18.013953700000002]],
    [ "Puerto Rico Electric Power Authority",[-66.75486868058574, 18.003047224322636]],
    [ "Thornton Street Substation",[-94.92530303446335, 39.29630656171718]],
    [ "Sun Valley Substation",[-102.52323012669487, 31.095544140713706]],
    [ "Masterson Field Substation",[-102.64411908336021, 31.106515446139717]],
    [ "Pecos Valley Substation",[-102.79474445000001, 31.096867749999998]],
    [ "Gomez Substation",[-103.02457502567964, 31.0369869970871]],
    [ "Fort Stockton Switching Station",[-103.10291772424718, 31.016752644008665]],
    [ "Huntsville Utilities",[-86.64050095035542, 34.69727341386479]],
    [ "Arcadia Substation",[-86.21538064999999, 44.4929292]],
    [ "Dontz Road Substation",[-86.27990890000002, 44.291045]],
    [ "Fort Stockton Plant Substation",[-102.955182998848, 30.927301054535224]],
    [ "502440912",[-101.5613914, 48.77823245]],
    [ "Subestación Almácigo Alto",[-66.88403296999196, 18.053441547539418]],
    [ "Puerto Rico Electric Power Authority",[-66.73468886900545, 18.094087307263464]],
    [ "Subestación Hidroeléctrica Dos Bocas",[-66.66599770523939, 18.33589099519812]],
    [ "Subestación CEMEX",[-66.63986184291858, 18.020384815193164]],
    [ "502714282",[-95.60679404211396, 36.33573438216735]],
    [ "Alliant Energy",[-93.45449132228602, 42.02508908122476]],
    [ "North Shade Substation",[-84.7614844747129, 43.15490920584644]],
    [ "Carson City Substation",[-84.86437313723667, 43.162292968074745]],
    [ "Fort Stockton Substation",[-102.8841656353922, 30.88938071381798]],
    [ "Airport Substation",[-102.91943335, 30.90271995]],
    [ "16th Street Substation",[-102.87325989230666, 30.900418090702274]],
    [ "Woodward Wind 1 Substation",[-102.48099336413976, 30.951575671028625]],
    [ "Woodward Wind 2 Substation",[-102.41694245938811, 30.980071651299514]],
    [ "Tombstone Substation",[-102.67900788017407, 31.002386556192018]],
    [ "502972282",[-66.63953607637907, 18.021692446110205]],
    [ "Subestación CEMEX (Interior)",[-66.63828273552782, 18.01880490059296]],
    [ "Shenandoah Valley Electric Cooperative",[-78.83838128282265, 38.525248191072265]],
    [ "Virginia Electric and Power Company",[-78.98691769999999, 38.02111185]],
    [ "Strickland Substation",[-88.43084835000002, 34.868118]],
    [ "White Baker Substation",[-102.42338436505524, 30.88536782751562]],
    [ "Ligon Substation",[-102.3723321344839, 30.833014067610588]],
    [ "Patriot Substation",[-102.46909065, 30.755455100000002]],
    [ "Keo Substation",[-102.36591496943674, 30.818419395019493]],
    [ "White Baker Substation",[-102.42332477037988, 30.886009815276392]],
    [ "Century Plant Substation",[-102.58085689999999, 30.607472050000005]],
    [ "Century Plant Substation",[-102.58153015, 30.607275899999998]],
    [ "503120416",[-97.76335393622162, 46.42805171885048]],
    [ "Vermillon Substation",[-96.89076909986588, 42.79342880279047]],
    [ "USD Substation",[-96.92035995, 42.789380599999994]],
    [ "Hallmark Substation",[-94.90658777485554, 39.27377469524316]],
    [ "East Fairmount Substation",[-94.90771382795134, 39.1863646906014]],
    [ "503151363",[-102.95482344999999, 46.118305649999996]],
    [ "503186907",[-102.71372826826487, 30.70191201525117]],
    [ "Sanderson Substation",[-102.4028883, 30.142016950000002]],
    [ "Texas-New Mexico Power",[-102.43655100000001, 30.23151265]],
    [ "Texas-New Mexico Power",[-102.44110043347528, 30.312270716794377]],
    [ "Texas-New Mexico Power",[-102.43739255, 30.398934250000007]],
    [ "Armadillo Substation",[-102.49096754999053, 30.46177356666426]],
    [ "Puckett Tap",[-102.60287778344761, 30.59131035593666]],
    [ "Puckett Substation",[-102.54834513291568, 30.62966157156317]],
    [ "Northern Natural Gas Substation",[-102.49386324999999, 30.672656549999996]],
    [ "Texas-New Mexico Power",[-102.50412016181413, 30.772731374649574]],
    [ "503259620",[-102.94140452483666, 46.11276510576457]],
    [ "503259690",[-103.04614796232586, 46.12790032493102]],
    [ "503263339",[-112.13687363515344, 35.64482030382155]],
    [ "Belding Substation",[-103.06810039999999, 30.759643000000004]],
    [ "Bronco Substation",[-103.45375958726454, 30.49295318295389]],
    [ "Lasso Substation",[-103.47532925980217, 30.465004424762263]],
    [ "Subestación Mogote",[-66.17096515217845, 18.12063451508786]],
    [ "Subestación Monte Llano",[-66.1342778218932, 18.127651137776184]],
    [ "Rocky Branch Substation",[-82.59460950000002, 31.8856456]],
    [ "North Park Substation",[-85.63601973847744, 43.028433774176364]],
    [ "Knapp Substation",[-85.61083037688708, 42.99827658302553]],
    [ "Aberdeen Substation",[-85.63824709476694, 43.00661975574693]],
    [ "Altuda Substation",[-103.4380096, 30.2357894]],
    [ "Conoco Substation",[-102.9436870715301, 30.639260444657832]],
    [ "Persimmon Gap Substation",[-103.11742720000001, 29.7119088]],
    [ "Alpine Substation",[-103.52475380000001, 30.38946575]],
    [ "Paisano Camp Substation",[-103.80170097179322, 30.307008785139516]],
    [ "Fort Davis Substation",[-103.89855109999998, 30.5852055]],
    [ "Espy Wells Substation",[-103.92691955000001, 30.522414499999996]],
    [ "Kennedy Ponder Tap",[-103.9485785, 30.466998299999997]],
    [ "Valentine Tap",[-103.96379143783868, 30.414519324145644]],
    [ "Bryant Ranch Substation",[-104.19600636861549, 30.02520615926401]],
    [ "Acacia Substation",[-104.33445300000001, 29.592951350000003]],
    [ "Gonzales Substation",[-104.3557574, 29.566239500000002]],
    [ "Shafter Mine Substation",[-104.32500339251831, 29.821553922114006]],
    [ "Chinati Substation",[-104.27619793522082, 29.907415681564796]],
    [ "Cinega Substation",[-104.19666826844166, 30.024833397885]],
    [ "Long Loop Substation",[-101.99203008344864, 30.89558310383503]],
    [ "Santa Rita Substation",[-101.65607552791545, 31.228492892547933]],
    [ "503429810",[-85.71318425000001, 31.34502295]],
    [ "Hoefs Road Substation",[-103.45841756845134, 31.031806617361806]],
    [ "503447120",[-66.75682261523849, 17.97855322443832]],
    [ "503460999",[-85.70800309999998, 31.32820305]],
    [ "Harlingen #1 Substation",[-97.70895884999999, 26.20678405]],
    [ "Troost Substation",[-94.56953740225246, 39.07269514395729]],
    [ "503596246",[-81.93862467018599, 34.94160534525398]],
    [ "Big Lake Phillips Pump Substation",[-101.4680861751296, 31.092995394534878]],
    [ "Esmeralda Substation",[-101.30948067521692, 30.969601710643012]],
    [ "Yucca Substation",[-101.07732945000001, 30.9905365]],
    [ "Wolfberry Substation",[-101.38927835000003, 31.1094511]],
    [ "503607842",[-101.36629556703339, 31.108723847959876]],
    [ "Strauss Ranch Substation",[-101.46105484308579, 31.06008377113763]],
    [ "Midway Lane Substation",[-101.37878869999999, 30.908850499999996]],
    [ "Powell Field Substation",[-101.58495388791071, 31.022465825106835]],
    [ "Shell Powell Substation",[-101.57046466376119, 31.118183401010963]],
    [ "Humble Kemper Exxon Substation",[-101.53575252498833, 31.184994391766406]],
    [ "Thompson Substation",[-97.06735724999999, 47.773342899999996]],
    [ "Fisher Substation",[-96.86735800000001, 47.746524099999995]],
    [ "Reynolds Substation",[-97.02448507432139, 47.68683682486511]],
    [ "Minnkota Power Cooperative",[-97.04425350000001, 47.84654859999999]],
    [ "Coleman Substation",[-97.0441273, 47.84626895]],
    [ "503676546",[-96.46257656159658, 41.42881674991481]],
    [ "503677092",[-96.4504648730024, 41.429062779131236]],
    [ "Jerry Substation",[-101.29938884999999, 31.229996200000002]],
    [ "Hargrove Substation",[-100.93897104999998, 31.308310699999996]],
    [ "Pumpjack Substation",[-101.0361695, 31.297373400000005]],
    [ "Mertzon Substation",[-100.84507372518546, 31.25971115861824]],
    [ "Tankersley Substation",[-100.64043985, 31.3447399]],
    [ "Mertzon Substation",[-100.8164491, 31.2578807]],
    [ "Barnhart Substation",[-101.16234520000002, 31.298178450000005]],
    [ "Barnhart Substation",[-101.17226809583198, 31.128094834044163]],
    [ "Rock Hollow Substation",[-101.2993487033908, 31.229461830570084]],
    [ "Ketchum Mountain Substation",[-101.03600745, 31.296938599999997]],
    [ "Newton T. Busby Substation",[-100.93921289999999, 31.3078086]],
    [ "MidAmerican Energy",[-92.27164595, 42.517154899999994]],
    [ "Jersey Central Power and Light",[-74.2978406062854, 41.03001020406112]],
    [ "Dow Chemical",[-96.76696115674447, 28.51253426836075]],
    [ "Huntsville Utilities",[-86.64950050135562, 34.65253870518243]],
    [ "Virginia Electric and Power Company",[-78.66633537335447, 38.353002921370766]],
    [ "Doss Substation",[-99.13089435810032, 30.457878050742305]],
    [ "Harper Substation",[-99.24014446496167, 30.298966132564136]],
    [ "Goehmann Lane Substation",[-98.84334245, 30.261955649999997]],
    [ "Fredericksburg Phillips Substation",[-98.8472930684589, 30.471769457495956]],
    [ "Hollmig Substation",[-98.88203423433045, 30.252327802689848]],
    [ "Live Oak Substation",[-98.8881897249243, 30.265889494912987]],
    [ "Goose Creek Substation",[-77.53173042583705, 39.075089349989014]],
    [ "West Harlingen Substation",[-97.72331709502167, 26.181101907209918]],
    [ "504308810",[-96.37573007745168, 32.00131721300316]],
    [ "504328204",[-88.61525516410184, 36.958678112855864]],
    [ "504328207",[-88.58495249999999, 36.95517199999999]],
    [ "504367628",[-86.482271975181, 40.075300841654034]],
    [ "504453220",[-99.94317749999999, 48.791804899999995]],
    [ "504496758",[-100.8947555, 46.874726599999995]],
    [ "Kingsland 1 Substation",[-98.45185074966886, 30.653352327164033]],
    [ "Kingsland 2 Substation",[-98.45789685831528, 30.67915600176877]],
    [ "Bluffton Substation",[-98.4814222, 30.826091799999993]],
    [ "Buchanan Substation",[-98.44808524982119, 30.73549175390042]],
    [ "Sunrise Beach Substation",[-98.44361121685951, 30.59114534925826]],
    [ "Pitsburg Substation",[-98.67743231860013, 30.76634680007803]],
    [ "Sandstone Mountain Substation",[-98.6107019, 30.73633635]],
    [ "Nebo Substation",[-98.74731265000001, 30.438892150000004]],
    [ "Lakeway Tap",[-97.94239740407112, 30.377713567413124]],
    [ "Lakeway Substation",[-97.94487453843087, 30.37209398338056]],
    [ "Marble Falls Substation",[-98.25775648119382, 30.55517132417985]],
    [ "Starcke Substation",[-98.26127670058231, 30.552372588860152]],
    [ "Flatrock Substation",[-98.20600496498659, 30.50978199736807]],
    [ "Granite Mountain Substation",[-98.29379836310636, 30.58802581321163]],
    [ "504620976",[-81.99245646592043, 34.95147848167806]],
    [ "Buchanan Substation",[-98.41776181451927, 30.750777923742532]],
    [ "Lower Colorado River Authority",[-98.39254810657575, 30.688414424173793]],
    [ "Sherwood Shores Substation",[-98.38000118624855, 30.60975941015543]],
    [ "Inks Dam Substation",[-98.38565048973915, 30.73144686369541]],
    [ "Coronado Substation",[-98.41651896926136, 30.750037720896128]],
    [ "Fairland Substation",[-98.25818488037771, 30.645240478225983]],
    [ "Blewett Substation",[-100.0378963118378, 29.20023876300297]],
    [ "Andice Substation",[-97.87577190313063, 30.748966489483593]],
    [ "Burnet Substation",[-98.23738662786097, 30.759123507348235]],
    [ "504801417",[-97.19168834999999, 32.76339420000001]],
    [ "Copperas Cove East Substation",[-97.8751910106406, 31.111904975892045]],
    [ "Copperas Cove Substation",[-97.90695070183416, 31.113206079201696]],
    [ "Lampasas Substation",[-98.18371275, 31.08451425]],
    [ "Copperas Cove Substation",[-97.96091235, 31.109775299999995]],
    [ "Kempner Substation",[-98.0539779983065, 31.091351222643038]],
    [ "Naruna Substation",[-98.19082519226397, 31.047671610274026]],
    [ "E. Babe Smith Substation",[-98.19821161236486, 30.99158142066395]],
    [ "Dobbyville Substation",[-98.26263489624458, 30.952548315612127]],
    [ "Graphine Mine Substation",[-98.35328180926204, 30.80657739699074]],
    [ "504849831",[-88.01852210134082, 32.23120928296022]],
    [ "504932097",[-81.02486461516321, 34.0735984318221]],
    [ "Parr Substation",[-81.33087381735432, 34.26409264909596]],
    [ "505058605",[-80.97253904692147, 34.09604791712156]],
    [ "505058610",[-80.96544833785701, 34.07310241886576]],
    [ "505058616",[-80.98440975845512, 34.08070722607383]],
    [ "Whiting Substation",[-100.7956837, 29.839736499999997]],
    [ "Devils River Substation",[-100.7967421, 29.8394899]],
    [ "505063934",[-81.00573545, 34.291586]],
    [ "505063936",[-80.9595525, 34.17921180000001]],
    [ "505063938",[-80.9560465, 34.17635735]],
    [ "Duquesne Light",[-79.86520195043117, 40.4636795538078]],
    [ "Lometa Substation",[-98.39079951207789, 31.21533292774107]],
    [ "505126059",[-80.9547036019477, 34.133502216394675]],
    [ "505162115",[-80.89525625, 34.11270145]],
    [ "505162117",[-80.93117505000001, 34.092807500000006]],
    [ "New Jersey Transit",[-74.4787963243309, 40.807640980029994]],
    [ "Honesdale Substation",[-75.25965684685337, 41.5735586682096]],
    [ "505190929",[-80.51427125, 33.89872015000001]],
    [ "Sumter Industrial Substation",[-80.38180332096275, 33.863752258262004]],
    [ "Railroad Delivery Point",[-77.53600829912604, 38.77653698374045]],
    [ "San Saba Substation",[-98.69029666874309, 31.192002432983777]],
    [ "Goldthwaite Wind Substation",[-98.51189551842597, 31.414955280377008]],
    [ "Evant Substation",[-98.17315313995897, 31.43360237253303]],
    [ "Richland Springs Substation",[-98.93163702531504, 31.29539374537941]],
    [ "Terry Substation",[-98.67459505221775, 31.237343183546592]],
    [ "San Saba Switching Substation",[-98.67175340000001, 31.235923400000004]],
    [ "505381341",[-97.04532883798805, 36.47749141320752]],
    [ "505381342",[-97.11867849523473, 36.66005201291658]],
    [ "Sumner-Cowley Electric Cooperative",[-97.13469562917983, 37.08487805495722]],
    [ "Creswell Substation",[-97.13523285858972, 37.08435675169485]],
    [ "Belle Plaine Substation",[-97.20658608321796, 37.40719170509117]],
    [ "Zephyr Substation",[-98.86165708960662, 31.709453352545836]],
    [ "Mercers Gap Switching Station",[-98.66695225463754, 31.81772443514826]],
    [ "Camp Bowie Substation",[-98.96048475425874, 31.636183408723443]],
    [ "Brownwood Switching Station",[-98.92046652233361, 31.660781436841912]],
    [ "Logan's Gap Wind Substation",[-98.69434369999999, 31.803062699999998]],
    [ "505673552",[-103.04383885649537, 39.28267774209465]],
    [ "505702461",[-96.52316900313673, 41.43947582040771]],
    [ "Apex Clean Energy",[-101.18781640160435, 34.06060384992165]],
    [ "Lincoln Place Substation",[-79.90810049929217, 40.363779232748165]],
    [ "505929455",[-102.61705201019316, 39.1274629120845]],
    [ "505929456",[-102.59533236896779, 39.29982624345405]],
    [ "Homestead Substation",[-79.92479429287931, 40.39710546717006]],
    [ "South Seneca Substation",[-96.07298397278129, 39.83014842022029]],
    [ "506122740",[-84.62548878199053, 33.83530467317459]],
    [ "506138351",[-112.1054637568369, 46.28985013914483]],
    [ "Knob Hill Substation",[-96.64119874918828, 39.820391155894825]],
    [ "Baileyville Substation",[-96.18250214768317, 39.82427395242233]],
    [ "Bonneville Power Administration",[-120.70274754868572, 47.136698486317634]],
    [ "506152619",[-120.70421426253192, 47.137279515031004]],
    [ "Sussex Substation",[-75.37959212694929, 38.696364058649806]],
    [ "Sharon Substation",[-80.42925360261358, 41.249585121844625]],
    [ "West Middlesex Substation",[-80.43320369373512, 41.17992115306406]],
    [ "Clifton Substation",[-97.27695817414858, 39.61234111783015]],
    [ "506308560",[-88.90107897978784, 34.38158958804751]],
    [ "Manistee River Substation",[-84.83691309370609, 44.77161349407249]],
    [ "Westwood Substation",[-85.04941284181663, 44.81571832735388]],
    [ "Plum Substation",[-85.22300583652033, 44.8416700638991]],
    [ "Clearwater Substation",[-85.21253609870469, 44.84419616054484]],
    [ "Sanborn Substation",[-98.22671925, 46.9363046]],
    [ "ANR Substation",[-84.97003360264289, 44.8383361806577]],
    [ "Jewell Substation",[-98.15606564351899, 39.685688525648146]],
    [ "Ionia substation",[-98.41064928619727, 39.720285275291666]],
    [ "506581365",[-78.646105621535, 35.78247615942898]],
    [ "Koolau Substation",[-157.79398565834563, 21.383876167080853]],
    [ "Summit Ave",[-74.05585067359611, 41.054997733805884]],
    [ "Franklin Lakes",[-74.21285220541768, 41.02641692718968]],
    [ "New Milford Substation",[-74.02746029779141, 40.93024043964252]],
    [ "Orange & Rockland",[-74.0614865196672, 41.0531233166661]],
    [ "Maywood Substation",[-74.07024637131869, 40.899020370635135]],
    [ "Hudson Substation",[-94.77155326213195, 31.330932352736937]],
    [ "506882735",[-74.11858105268462, 40.98286945628576]],
    [ "Cominco Substation",[-98.28241345182406, 47.09244720800951]],
    [ "Ontario Substation",[-116.97803553240757, 44.05251294586926]],
    [ "Central Angelina Substation",[-94.77977447595791, 31.443097307334256]],
    [ "507125854",[-85.96186689435392, 38.24233132191522]],
    [ "507129357",[-78.92070885, 35.7504521]],
    [ "507166309",[-106.7690919594289, 34.65730065652118]],
    [ "South Paducah Substation",[-88.59284678367992, 37.058944949369526]],
    [ "Lovelaceville Substation",[-88.82818375000001, 36.9618179]],
    [ "507318072",[-88.73015609999999, 36.90810664999999]],
    [ "Plainville Substation",[-99.28809984890864, 39.24923189770103]],
    [ "Forked Deer Electric Cooperative",[-89.63459234259992, 35.742208540553264]],
    [ "507353643",[-98.70510400911917, 46.90840593684105]],
    [ "Proctor Substation",[-98.46717349999999, 31.95306895]],
    [ "Hasse Substation",[-98.50405951909384, 31.92445540558778]],
    [ "Comanche Substation",[-98.60547599007484, 31.89421103030286]],
    [ "Shiloh Substation",[-98.57288616157916, 31.89304127680142]],
    [ "Novice Substation",[-99.66929891901411, 31.98402841388252]],
    [ "Talpa Atlantic Substation",[-99.64222702921155, 31.73943005416777]],
    [ "Valera Substation",[-99.54746069999999, 31.758285700000002]],
    [ "Gouldbusk Substation",[-99.45796069999999, 31.558456399999997]],
    [ "Coleman Junction Substation",[-99.42688295330308, 31.74430025939915]],
    [ "Lake Ivie Booster Substation",[-99.78790275971419, 31.85541082108833]],
    [ "Lake Ivie Pump Substation",[-99.72146959999999, 31.57784415]],
    [ "Coleman Substation",[-99.40405483684042, 31.814542825095362]],
    [ "Lake Brownwood Substation",[-99.0910668557684, 31.766469962941088]],
    [ "Bangs Substation",[-99.127948929738, 31.73334992145115]],
    [ "Blanket Substation",[-98.79616895000001, 31.823759250000005]],
    [ "Brownwood Substation",[-98.97417272839724, 31.71860431268053]],
    [ "Lufkin Hill Street Substation",[-94.74639617475721, 31.349182890669276]],
    [ "Saline River Substation",[-99.33036774606117, 39.10221659950565]],
    [ "507415048",[-99.2491833114374, 39.1036804247203]],
    [ "Diboll Substation",[-94.79549601624561, 31.193806748845134]],
    [ "Red Bluff Substation",[-115.31286858057335, 33.69883363365343]],
    [ "Georgia Power",[-84.21184332244529, 33.91727399455596]],
    [ "Cascade Substation",[-85.49633577390257, 42.914573038264436]],
    [ "Fieldale Farms Substation",[-83.55623038961839, 34.484328235699635]],
    [ "Electric Power Board of Chattanooga",[-85.24489372722763, 35.08405946720018]],
    [ "507686105",[-80.8531229779837, 34.102634260920894]],
    [ "507759193",[-79.03877902526662, 38.02363879439951]],
    [ "PPGI Substation",[-77.1659756830209, 40.12447212396252]],
    [ "507772823",[-79.06277981220026, 37.411088673251605]],
    [ "Rising River Substation",[-121.54443193152719, 40.929049942706]],
    [ "Morgan Fork",[-82.6908842060445, 37.49855805054021]],
    [ "Hackett Substation",[-84.08891367365587, 43.488692374829085]],
    [ "Whitney Substation",[-97.31941369981827, 31.950530175133633]],
    [ "Meridian Substation",[-97.67532402324362, 31.94948496487709]],
    [ "Walnut Springs Switching Station",[-97.7476982, 32.06926275]],
    [ "Energy Substation",[-98.37458719816543, 31.74260995004284]],
    [ "Cranfills Gap Substation",[-97.81674858668649, 31.785021449208028]],
    [ "Powell Substation",[-97.52193288170577, 31.889972662769164]],
    [ "Hico Substation",[-98.02824733225623, 31.98019694122619]],
    [ "Hico Switching Station",[-97.86494051677785, 31.957468851189624]],
    [ "Walnut Springs Switching Station",[-97.74783457138169, 32.06880391147913]],
    [ "Hamilton Substation",[-98.1092953, 31.71372455]],
    [ "Meridian Substation",[-97.65865508247342, 31.930388355072555]],
    [ "Valley Mills Substation",[-97.47237917991836, 31.654479197054208]],
    [ "Handley Substation",[-97.5523469080198, 31.730638895620633]],
    [ "Cliffton 2 Substation",[-97.590878722284, 31.786764025432742]],
    [ "Clifton 1 Substation",[-97.57191121802323, 31.786063698595424]],
    [ "Gatesville #1 Substation",[-97.73426524999999, 31.438222000000007]],
    [ "Gatesville #2 Substation",[-97.74646754999999, 31.439203499999998]],
    [ "Gatesville Substation",[-97.76265799179028, 31.503767032996663]],
    [ "Pancake Substation",[-97.797683852934, 31.535577662570468]],
    [ "Jonesboro Substation",[-97.89417422375703, 31.61517245610502]],
    [ "Hamilton Substation",[-98.11858252635892, 31.682336110821026]],
    [ "Indian Gap Substation",[-98.41899487978124, 31.662496511291668]],
    [ "Energy Substation",[-98.37411406998048, 31.74304080569011]],
    [ "Gustine Substation",[-98.3443222719058, 31.81804043896283]],
    [ "Damascus Substation",[-81.80359275330567, 36.64091730162452]],
    [ "Frankford Substation",[-75.24609310756931, 38.52431419223652]],
    [ "Nottingham Substation",[-77.23941625000002, 40.1873529]],
    [ "508242039",[-81.15584397616044, 34.07249739440458]],
    [ "Lake Naomi Substation",[-75.42744030590117, 41.11528348176515]],
    [ "508280089",[-88.68976022934194, 37.346882023115214]],
    [ "Bayou Torture Substation",[-91.96353231598385, 30.16659503785922]],
    [ "508282333",[-91.99294555000002, 30.1699727]],
    [ "508288034",[-88.24825289395761, 37.50912986102352]],
    [ "508423766",[-98.48630462515978, 36.8404530429544]],
    [ "Rio Verde Substation",[-111.68312419711822, 33.72673137823239]],
    [ "Friendship Substation",[-97.94521009338999, 30.166840658991926]],
    [ "Buda Substation",[-97.85113933179181, 30.075395142071805]],
    [ "Goforth Substation",[-97.84155262843059, 29.992567100329833]],
    [ "Rohr Substation",[-97.87887509999999, 29.935561899999996]],
    [ "Puerto Rico Electric Power Authority",[-67.1513090563707, 18.23276913303837]],
    [ "Holly Plant Switchyard",[-97.71968882549508, 30.25089825873495]],
    [ "Harris Substation",[-97.73254847448803, 30.2882543848054]],
    [ "Fiesta Substation",[-97.71866142939847, 30.29497527742075]],
    [ "508582529",[-85.072019625651, 41.35360865511802]],
    [ "Bullick Hollow Substation",[-97.8569739503386, 30.40323104735791]],
    [ "McNeil Substation",[-97.68939031367697, 30.393132331640945]],
    [ "McNeil Substation",[-97.6891489941852, 30.39478372750937]],
    [ "Cameron Substation",[-97.68638842977245, 30.339642135812397]],
    [ "Beadle Substation",[-85.15405025, 42.275419400000004]],
    [ "Lyon Manor Substation",[-84.73032728273084, 44.46459892481403]],
    [ "509119054",[-87.17947226318879, 36.573683929413924]],
    [ "Daffan Gin Substation",[-97.61539899839715, 30.309642913148686]],
    [ "509438715",[-86.13336688012302, 39.94936392331734]],
    [ "Paige Substation",[-97.13472012937518, 30.21446183135103]],
    [ "Butler Substation",[-97.32471537098827, 30.389468669057887]],
    [ "Smithville Substation",[-97.15800019544334, 30.020538132390843]],
    [ "Rosanky Substation",[-97.3113138590729, 29.929266914144947]],
    [ "Potranco Substation",[-98.65743441187993, 29.446159061994297]],
    [ "509640573",[-97.06692799273432, 30.566818433684634]],
    [ "Buckholts Substation",[-97.19452704702177, 30.85050884388073]],
    [ "Talbert Ridge Substation",[-96.96799303625379, 30.684480179804364]],
    [ "Rockdale Substation",[-97.01888990000002, 30.671068050000002]],
    [ "Rockdale North Substation",[-97.01916935000001, 30.67290555]],
    [ "Salty Substation",[-97.1326174, 30.596278700000003]],
    [ "Thorndale North Substation",[-97.21109295, 30.620047399999997]],
    [ "509888536",[-84.14772500000002, 36.08205884999999]],
    [ "509973865",[-84.5965358429863, 38.28298386841484]],
    [ "Highgate Falls Substation",[-73.04965871870982, 44.93403912676742]],
    [ "Sheldon Substation",[-72.98159954999998, 44.906904600000004]],
    [ "Atkins Substation",[-96.3744342740371, 30.64656063823177]],
    [ "Briarcrest Substation",[-96.33732800435087, 30.65672006562317]],
    [ "Steele Store Substation",[-96.53273995, 30.63952425]],
    [ "Texas A&M Annex Substation",[-96.46477357007754, 30.65194798110233]],
    [ "Puerto Rico Electric Power Authority",[-66.36961569472233, 18.02198772367425]],
    [ "510045281",[-66.4687967, 18.45692275]],
    [ "Highway 6 Substation",[-96.13112105, 30.4404773]],
    [ "Wellborn Switching Station",[-96.25267149946991, 30.500803583745483]],
    [ "Millican Substation",[-96.21594214571284, 30.475612833012764]],
    [ "Millican Substation",[-96.20442952225218, 30.47284355694912]],
    [ "Koppe Bridge Substation",[-96.31119204999999, 30.5329126]],
    [ "Snook Substation",[-96.44977544017952, 30.53658438799326]],
    [ "Dowling Road Substation",[-96.33338988533774, 30.58574974225405]],
    [ "Southwood Valley Substation",[-96.31041091058256, 30.594014767970265]],
    [ "510156060",[-111.90924227845855, 40.862071054258145]],
    [ "Reardan Substation",[-117.93832827516597, 47.6459789542709]],
    [ "Lower Woodchuck",[-114.0362092937034, 46.64998186011994]],
    [ "510322297",[-96.50307758041323, 41.37880441980784]],
    [ "510466212",[-89.39128473612837, 35.654783419159415]],
    [ "Sinclair Hearne Substation",[-96.58553815167593, 30.939926716778103]],
    [ "Calvert Substation",[-96.80203535, 31.008492600000004]],
    [ "Tesco Tap",[-96.47507015664388, 30.788849065391684]],
    [ "Humble Hearne Substation",[-96.5701929172223, 30.85654520303894]],
    [ "APL Hearne Substation",[-96.52115955000001, 30.885893149999998]],
    [ "Texas Hearne Substation",[-96.57906687719777, 30.862918107059386]],
    [ "Calvert Substation",[-96.6728186, 30.974692199999996]],
    [ "Phillips Coal Substation",[-96.67275379650837, 31.096501112039256]],
    [ "Brazos Electric",[-96.68649713291425, 31.04433380062239]],
    [ "Branchville Substation",[-96.76975615249832, 30.873417682623266]],
    [ "Milano Substation",[-96.8635207876269, 30.76357414331785]],
    [ "510548228",[-87.0342158, 32.41632250000001]],
    [ "Puerto Rico Electric Power Authority",[-66.35964434354099, 18.329108902763956]],
    [ "Youngcane Substation",[-84.09998580441909, 34.85871792056918]],
    [ "510789203",[-87.53484866215409, 33.18849062821973]],
    [ "Fayette Plant #2 Substation",[-96.75614723114492, 29.91356619298677]],
    [ "La Grange Substation",[-96.8743391343879, 29.93277415568052]],
    [ "Riverside Substation",[-96.9199105285301, 29.927466435683144]],
    [ "Pilot Grove Substation",[-97.08812339827467, 29.3240497165377]],
    [ "Sweet Home Substation",[-97.0412718711186, 29.35804243261816]],
    [ "Mont Substation",[-97.00908217511954, 29.400989245706334]],
    [ "Hallettsville Substation",[-96.98760112487999, 29.429375804948776]],
    [ "Kokernut Substation",[-97.26920893561423, 29.46209949489455]],
    [ "Moulton Substation",[-97.13959512517343, 29.537302345838288]],
    [ "Weimar Substation",[-96.7836626781523, 29.683666718155358]],
    [ "Weimar Substation",[-96.90777192469024, 29.6723688923806]],
    [ "Plum Substation",[-97.01201659653728, 29.944068493142534]],
    [ "Winchester Power Park Substation",[-96.99492475000001, 30.0255218]],
    [ "Pellston Substation",[-84.78328705, 45.5514197]],
    [ "Dominion Energy South Carolina",[-81.03797749109933, 33.98809413541219]],
    [ "Westlake Chemical Corporation",[-93.297322996967, 30.22836458076827]],
    [ "510873416",[-88.14186195000002, 30.515915049999997]],
    [ "Alabama Power",[-88.12778323280948, 30.52523529758938]],
    [ "Puerto Rico Electric Power Authority",[-66.61548480925705, 18.021001978411245]],
    [ "Subestación Caguanas",[-66.762998584698, 18.282850493325075]],
    [ "510876839",[-86.07125514999998, 32.3982497]],
    [ "510877294",[-86.05403616966544, 34.00851199272]],
    [ "510877789",[-88.92477900414296, 35.83932569637628]],
    [ "Puerto Rico Electric Power Authority",[-66.99139492523257, 18.255080783955965]],
    [ "510925049",[-80.45655670000001, 33.4632299]],
    [ "Gillette Substation",[-97.72787342186889, 29.232743373673742]],
    [ "Lost Creek Substation",[-97.366214204571, 29.067893831311846]],
    [ "FM 237 Yorktown Substation",[-97.480950676334, 28.987976464705955]],
    [ "Yorktown Substation",[-97.49862059856544, 28.974789316432354]],
    [ "511118157",[-77.66700279999999, 39.91064125]],
    [ "166th Street Substation",[-94.96334451692003, 39.10834296483285]],
    [ "Gay Hill Substation",[-96.47165648197353, 30.271161694806906]],
    [ "Lyons Substation",[-96.5733238, 30.3942918]],
    [ "Deanville Substation",[-96.80120213716584, 30.427121120179514]],
    [ "Warda Substation",[-96.92083701537615, 30.050263736524386]],
    [ "Kenilworth Substation",[-94.63877299279385, 38.96452724160568]],
    [ "511176557",[-85.75254132562158, 40.13599931912785]],
    [ "511177984",[-81.02594361774702, 33.98714487852319]],
    [ "Dominion Energy South Carolina",[-81.04099559729883, 33.98026886911162]],
    [ "NorthWestern Energy",[-114.0526289, 46.87743054999999]],
    [ "Rebar Road Substation JEA",[-81.98076691459224, 30.280640648973947]],
    [ "511310761",[-84.88727175242862, 34.518043737394635]],
    [ "511310763",[-84.88412100601019, 34.48331101366043]],
    [ "Fayette River Pump Substation",[-96.77542400771354, 29.868447277181723]],
    [ "Frelsburg Substation",[-96.61589529424526, 29.8356957674492]],
    [ "Round Top Substation",[-96.71060217861807, 30.0778523527716]],
    [ "Sandy Hill Substation",[-96.32727525519435, 30.277990028699694]],
    [ "Mill Creek Substation",[-96.57974301153675, 30.1827727265007]],
    [ "Puerto Rico Electric Power Authority",[-66.87109667514612, 18.11055048911079]],
    [ "Duke Energy",[-80.82411584392256, 35.04527860642621]],
    [ "Electric Power Board of Chattanooga",[-85.27892454967252, 35.0292122668906]],
    [ "Union Springs Substation",[-85.70361144806988, 32.13256900335029]],
    [ "511411892",[-85.71822479160463, 32.11825637762323]],
    [ "Union Springs Substation",[-85.71819689376979, 32.118962770659046]],
    [ "511461911",[-96.49956440000001, 31.283766800000002]],
    [ "Kosse Substation",[-96.51120211318693, 31.30390100078616]],
    [ "Otto Junction Substation",[-96.78133639490288, 31.376948396435097]],
    [ "Marlin Substation",[-96.89449787823297, 31.314227412907194]],
    [ "Marlin South Substation",[-96.89051500000001, 31.294470999999998]],
    [ "Marlin South Tap",[-96.88008716785536, 31.28539389640535]],
    [ "Lott Substation",[-97.0316905, 31.198876249999998]],
    [ "Pleasant Grove Substation",[-96.90308453428521, 31.131446250358096]],
    [ "Midway Substation",[-96.99354165338391, 31.292882667907815]],
    [ "Chilesburg Substation",[-77.54460121266533, 38.002727620863915]],
    [ "511503609",[-80.47447959313973, 33.414542375033]],
    [ "511524136",[-85.0795546, 31.84069295]],
    [ "Ricardo Substation",[-97.77648248928521, 27.414054025283168]],
    [ "Riviera Substation",[-97.78921830000002, 27.332070550000005]],
    [ "Loyola Substation",[-97.81014584227879, 27.31853793120977]],
    [ "Marana Switchyard",[-97.529633831741, 27.10343771490135]],
    [ "Baffin Substation",[-97.59693591652807, 27.18400244871249]],
    [ "North Ella Substation",[-98.11244124315711, 27.528662472491533]],
    [ "Premont Substation",[-98.12602125000002, 27.383256900000003]],
    [ "Falfurrias Substation",[-98.14183923969331, 27.242300752491822]],
    [ "Crestonio Substation",[-98.59781775903109, 27.365385289192663]],
    [ "511553434",[-98.66220712492023, 46.90594879660892]],
    [ "Five Points Substation",[-81.01536386867342, 34.00028134543609]],
    [ "Rio Bravo Sub",[-106.64411349997604, 35.02789674931061]],
    [ "Southern Natural Gas",[-86.3191800812995, 32.523923264054375]],
    [ "Las Pulgas Substation",[-97.7505798751096, 26.460976007505224]],
    [ "ThePalm Substation",[-97.67060634999999, 26.344929649999994]],
    [ "Trees Substation",[-97.5993593428372, 26.321515524876403]],
    [ "Red Fish Substation",[-97.69112355, 26.476043899999997]],
    [ "511860479",[-89.84798330623128, 44.94374588043802]],
    [ "Central Avenue Substation",[-97.44552748701402, 25.953855719568125]],
    [ "San Roman Wind Substation",[-97.38646099865485, 26.093009943949117]],
    [ "East Rio Hondo Substation",[-97.53403530000001, 26.22752615]],
    [ "Cameron Wind Substation",[-97.46720446674153, 26.195641426442275]],
    [ "Paredes Switching Station",[-97.46618575657585, 26.19548722438657]],
    [ "Moore Field Substation",[-98.31531955653477, 26.359637877424916]],
    [ "Citrus City Substation",[-98.3512880904208, 26.32106484221293]],
    [ "Red Gate Substation",[-98.1771449, 26.449678400000003]],
    [ "Los Mirasoles Substation",[-98.44830929999999, 26.492620500000005]],
    [ "Willow Point Substation",[-85.97072927826162, 32.80794189228328]],
    [ "McCook 2 Substation",[-98.31239474942541, 26.620230032722414]],
    [ "McCook 1 Substation",[-98.16471241257864, 26.575605357498596]],
    [ "Faysville Substation",[-98.14027665, 26.406002050000005]],
    [ "Rachal Substation",[-98.16381305000002, 26.8901417]],
    [ "Aurora Substation",[-84.92221294857718, 39.052850331767814]],
    [ "512169791",[-84.98562624624029, 39.06270173490346]],
    [ "Folwer Substation",[-84.6811543004125, 43.05276523083919]],
    [ "Greenbush Substation",[-84.51344159796854, 43.07477303987796]],
    [ "Farmers Electric Cooperative",[-94.18553455, 41.10698905]],
    [ "Goodwin Substation",[-98.4515775740502, 26.24529324934778]],
    [ "La Grulla Substation",[-98.6348839256463, 26.306536132163636]],
    [ "Garceno Substation",[-98.93676399783095, 26.41104086880357]],
    [ "Roma Substation",[-99.02176702026094, 26.422704589079597]],
    [ "Rio Grande City Substation",[-98.81938100178243, 26.392602947984685]],
    [ "Rio Grande City Substation",[-98.7422734922113, 26.452793772336413]],
    [ "Continental Substation",[-98.6099155249662, 26.51501549363354]],
    [ "512388963",[-81.03298403823692, 33.997739848426605]],
    [ "Madison Station",[-75.44120501307098, 43.24011092772253]],
    [ "Murray Jct. Substation",[-93.92668397086064, 41.08430896582791]],
    [ "Opine Road Substation",[-86.2750592, 31.2931002]],
    [ "512612200",[-81.0529485, 34.0031552]],
    [ "512612201",[-81.0527864, 34.0032192]],
    [ "512642751",[-81.03041515, 34.028019500000006]],
    [ "North McAllen Substation",[-98.2387952094487, 26.24796519476784]],
    [ "McColl Road Substation",[-98.19403722238688, 26.309093406196517]],
    [ "Palmhurst Substation",[-98.23789516821631, 26.271971337560664]],
    [ "West Edinburg Substation",[-98.23411754667578, 26.317452458724894]],
    [ "Alton Substation",[-98.29280760000002, 26.26909225]],
    [ "Key Switching Station",[-98.29729374999998, 26.260856899999997]],
    [ "Palmhurst Substation",[-98.33386312749579, 26.261034491993243]],
    [ "Palmview Substation",[-98.36639767224364, 26.235191304881965]],
    [ "Bates Substation",[-98.39679155769183, 26.22108525985291]],
    [ "Frontera Substation",[-98.39713281027159, 26.217894477564545]],
    [ "512735330",[-88.21234762082018, 32.10230999782288]],
    [ "Mechanicsburg Substation",[-77.0271939449938, 40.20812970839916]],
    [ "512856699",[-87.75603134274232, 31.930623574977318]],
    [ "512890025",[-90.08147956565831, 35.08594197291446]],
    [ "Las Milpas Substation",[-98.19444015404787, 26.13928457016038]],
    [ "Stewart Road Substation",[-98.15495642757111, 26.125682094087946]],
    [ "Hi Line Substation",[-98.21398185000001, 26.1031852]],
    [ "Hidalgo Substation",[-98.25551733335325, 26.1117780405462]],
    [ "West McAllen Substation",[-98.25494438270103, 26.201370212722022]],
    [ "South McAllen Substation",[-98.2515199830352, 26.16053323349657]],
    [ "Bentsen Substation",[-98.29098847757719, 26.150788290652148]],
    [ "South Mission Substation",[-98.33355840075157, 26.209116858318204]],
    [ "Railroad DC Tie",[-98.32367248779907, 26.166898405193738]],
    [ "Taylor Road Substation",[-98.2808691, 26.176495049999996]],
    [ "Sharyland Substation",[-98.28433409302718, 26.203345772481864]],
    [ "Mayberry Substation",[-98.3214360911733, 26.188005672526398]],
    [ "Sporting Hill Substation",[-76.9659749062789, 40.23311596755822]],
    [ "North Milledgville Substation",[-83.23297925, 33.1101205]],
    [ "513087225",[-75.42714221669573, 41.19132615019766]],
    [ "El Gato Substation",[-98.09781125871109, 26.1676764749216]],
    [ "Doedyns Substation",[-98.14544184411702, 26.214650315523375]],
    [ "Sioux Substation",[-98.05777055565993, 26.208211975080335]],
    [ "Gandy Substation",[-98.00817110091951, 26.189517310781568]],
    [ "North Alamo Substation",[-98.1134081001872, 26.230990509159557]],
    [ "Alberta Switching Station",[-98.13573314484411, 26.250327872180485]],
    [ "Val Verde Substation",[-98.08043749999999, 26.234044100000006]],
    [ "Weslaco Switching Station",[-98.00879762039071, 26.229585314260706]],
    [ "Elsa Substation",[-98.01036347539603, 26.292696857510965]],
    [ "Aderhold Substation",[-98.08380432516452, 26.304189130638257]],
    [ "Southeast Edinburg Substation",[-98.14498974172977, 26.288121941807375]],
    [ "Azteca Substation",[-98.1618938, 26.322729050000007]],
    [ "Pharr Substation",[-98.17411985000001, 26.23735235]],
    [ "Polk Avenue Substation",[-98.19693954226415, 26.20611607251563]],
    [ "Hall Acres Road Substation",[-98.20518265200621, 26.16812704600759]],
    [ "Pharr Substation",[-98.14799604440594, 26.265408872107844]],
    [ "Merett Substation",[-98.17911127825491, 26.270689234436258]],
    [ "Electric Power Board of Chattanooga",[-85.26931152729158, 35.026570147864724]],
    [ "San Benito Substation",[-97.64300420816507, 26.143805215702496]],
    [ "Haine Drive Substation",[-97.6507811822631, 26.16719752410567]],
    [ "La Palma 69 kV Substation",[-97.64191411442094, 26.142237726046435]],
    [ "Rangerville Substation",[-97.78564275000001, 26.08718335]],
    [ "Rio Rico Substation",[-97.90048292175007, 26.091805157228773]],
    [ "Rangerville Substation",[-97.72317064070931, 26.119931757576524]],
    [ "Wesmer Substation",[-97.94227892542146, 26.137615334661792]],
    [ "Weslaco Unit Substation",[-98.00818211611403, 26.15483620147492]],
    [ "Heidelberg Substation",[-97.8875857752792, 26.22845388885608]],
    [ "Weslaco Substation",[-97.97546667913483, 26.23261412980704]],
    [ "South Santa Rosa Substation",[-97.82386182534982, 26.23128670641869]],
    [ "North Mercedes Substation",[-97.9118492, 26.23057505]],
    [ "North Weslaco Substation",[-97.99153254275953, 26.229652675269953]],
    [ "Jersey Central Power and Light",[-74.07924079273536, 40.290977494665675]],
    [ "Waterport Substation",[-97.41260207502467, 25.95325205670168]],
    [ "Union Carbide Substation",[-97.37553400000002, 25.964496750000002]],
    [ "Coffee Port Substation",[-97.42630562811806, 25.938042071676588]],
    [ "Highway 511 Substation",[-97.40818267494072, 25.937539045361156]],
    [ "Olmito Substation",[-97.51981535, 26.00152885]],
    [ "Palo Alto Substation",[-97.51407409211156, 26.002139726697695]],
    [ "Titan Tire Substation",[-97.47794047620445, 25.994602145395017]],
    [ "Loma Alta Substation",[-97.3844901394572, 25.97732400684645]],
    [ "Union Carbide Substation",[-97.37513232725996, 25.968194658361142]],
    [ "Causeway Substation",[-97.2035131124943, 26.072813700505257]],
    [ "Port Isabel Substation",[-97.29968197416346, 26.09470369171631]],
    [ "Laureles Substation",[-97.5472631, 26.122598049999997]],
    [ "Los Fresnos Substation",[-97.5232474659305, 26.07678036715411]],
    [ "Brownsville Switching Station",[-97.53279940704573, 25.941137486627234]],
    [ "Brownsville Substation",[-97.5049096517234, 25.938512439586464]],
    [ "Military Highway Substation",[-97.53569027540742, 25.936813173327547]],
    [ "Laredo Road Substation",[-97.53283272138658, 25.940972176504697]],
    [ "Villa Cavazos Substation",[-97.59771875, 26.0219992]],
    [ "513449472",[-81.03946254534961, 34.004750321227505]],
    [ "Buena Vista Substation",[-82.5533864069356, 39.582139849509964]],
    [ "Biers Run Station",[-83.10023684850209, 39.396812900043216]],
    [ "Sixth Street Substation",[-97.49766196540008, 25.909784646321175]],
    [ "Fort Brown Substation",[-97.46813782686903, 25.899352055048134]],
    [ "Filter Plant Substation",[-97.46535167056112, 25.925359645839272]],
    [ "Southmost Substation",[-97.42490643989537, 25.888434968692636]],
    [ "Midtown Substation",[-97.50557135000001, 25.938485000000004]],
    [ "Price Road Substation",[-97.47966803868793, 25.934529990472026]],
    [ "FM 802 Substation",[-97.49211435948823, 25.95094550197634]],
    [ "Power Plant Substation",[-97.52252290039725, 25.913597849773073]],
    [ "Raymondville #2 Substation",[-97.75214822286252, 26.481596670426104]],
    [ "Armstrong Substation",[-97.78965838195298, 26.927203821529616]],
    [ "513704385",[-86.62644915000001, 31.7953389]],
    [ "513704405",[-86.58132758544058, 31.902565307202014]],
    [ "513728914",[-82.90093812259855, 31.480634127000886]],
    [ "513931892",[-97.80924955, 36.415371300000004]],
    [ "Uptown 1300 Henderson Street",[-81.02665665739697, 34.0057831549726]],
    [ "East Raymondville Substation",[-97.71543039999999, 26.46710905]],
    [ "La Sara Substation",[-97.84683657477844, 26.451281692514634]],
    [ "Raymondville #1 Substation",[-97.7817735602057, 26.437568484365375]],
    [ "Brundidge City Substation",[-85.82092181977602, 31.737219406619968]],
    [ "Brundidge Substation",[-85.8343169, 31.719359500000003]],
    [ "Brundidge Substation",[-85.82633121467565, 31.727589900558183]],
    [ "Kyzar Substation",[-86.00289969840846, 31.811227379255705]],
    [ "Troy Substation",[-85.95327597452952, 31.78306371106238]],
    [ "Subestación Éolica de Naguabo",[-65.70264535997515, 18.209303733539347]],
    [ "Stockton Substation",[-79.74046619313778, 36.682531567471614]],
    [ "514307957",[-85.17766920708428, 32.803997220137155]],
    [ "514624358",[-85.85502283796212, 40.06604114884672]],
    [ "Fayette Substation",[-87.84123744832371, 33.667231204948045]],
    [ "514637901",[-87.85265693200068, 33.71209544145258]],
    [ "514637902",[-87.84373774999999, 33.809726999999995]],
    [ "514637903",[-87.91636533860934, 33.95882170956558]],
    [ "514658722",[-117.10405620999933, 34.20805014317091]],
    [ "Live Oak Substation",[-97.09368782447919, 28.032273588735684]],
    [ "Fulton Substation",[-97.06417077465746, 28.04670059116459]],
    [ "Rockport Substation",[-97.14208063182276, 27.977592138635742]],
    [ "Seawall Substation",[-97.14537665000002, 27.899933250000007]],
    [ "Port Aransas Substation",[-97.0719142457216, 27.820554224964596]],
    [ "Aransas Pass Substation",[-97.18175520577347, 27.926867180320844]],
    [ "Homeport Substation",[-97.20955000754947, 27.827873788733694]],
    [ "Ingleside Substation",[-97.21684574167693, 27.872111535515007]],
    [ "Ingleside Oxy Substation",[-97.2417822806047, 27.88056731020266]],
    [ "Air Liquide Substation",[-97.23991437520792, 27.879804693015412]],
    [ "voestalpine",[-97.28068143650198, 27.89095127792032]],
    [ "American Electric Power",[-97.27747604999999, 27.891667499999997]],
    [ "Hecker Substation",[-97.28290926404713, 27.904878349179523]],
    [ "Occidental Petroleum",[-97.24606487518092, 27.88575404453471]],
    [ "Ingleside Cogeneration Switchyard",[-97.24661394618454, 27.882027863535463]],
    [ "Reynolds Sherwin Substation",[-97.25741754999999, 27.8841671]],
    [ "Gregory Switchyard",[-97.25752869981147, 27.8889286078185]],
    [ "Dupont PP1 Substation",[-97.24746000000002, 27.88038535]],
    [ "McCampbell Substation",[-97.2686112896208, 27.915083831256492]],
    [ "Gregory Substation",[-97.3092544173512, 27.923299706019858]],
    [ "Portland Substation",[-97.32242756999652, 27.887727909950257]],
    [ "West Sinton Substation",[-97.64242420901246, 28.026522727683993]],
    [ "West Sinton Switching Station",[-97.64749072235657, 27.998391106994998]],
    [ "Bonnieview Substation",[-97.31358332587975, 28.184556341305232]],
    [ "Medio Creek Substation",[-97.33990671435437, 28.253422827142362]],
    [ "Haisley Substation",[-97.49359997490217, 28.09494340807194]],
    [ "Jay Tap Substation",[-72.4824504017813, 44.97839791722209]],
    [ "Jay Peak Substation",[-72.50370815000001, 44.942301300000004]],
    [ "Lancaster Substation",[-82.60695816830867, 39.712416141254906]],
    [ "Phil Campbell Substation",[-87.71910600000001, 34.36012734999999]],
    [ "MidAmerican Energy",[-96.36954262824966, 42.335503913492104]],
    [ "Refugio Substation",[-97.34493584999998, 28.349435049999997]],
    [ "Tatton Substation",[-96.98999384999999, 28.209544550000004]],
    [ "Refugio Substation",[-97.2664901653485, 28.301213639653227]],
    [ "Heard Substation",[-97.29659850634916, 28.279050716760562]],
    [ "Woodsboro Substation",[-97.2940298, 28.234888600000005]],
    [ "Bonnieview Substation",[-97.30304428948568, 28.155429045275074]],
    [ "Sunbury Substation",[-76.57561093642529, 36.44237562978218]],
    [ "Pasquotank Substation",[-76.30023559999998, 36.27131514999999]],
    [ "515037438",[-77.55668569448638, 36.69114109239437]],
    [ "Weser Substation",[-97.36760021471488, 28.83195424321777]],
    [ "Charco Substation",[-97.6164676978892, 28.753560029056537]],
    [ "Schroeder Substation",[-97.22400353802371, 28.822392570747077]],
    [ "Big Oak Substation",[-97.64188901669968, 28.558739199744494]],
    [ "Goliad Substation",[-97.3838348, 28.662183399999996]],
    [ "Brady Substation",[-85.45909888801623, 42.09288776953549]],
    [ "515107405",[-85.47885913834311, 41.79685960078954]],
    [ "515107407",[-85.43783373319579, 41.802136731388245]],
    [ "515107410",[-85.42508726264269, 41.80749791893924]],
    [ "Sturgis Substation",[-85.42529395959431, 41.79877051388578]],
    [ "Aloe Substation",[-97.07032222255675, 28.7803034888454]],
    [ "Airco Substation",[-96.79594975797384, 28.50990249724168]],
    [ "Greta Substation",[-97.19243535000001, 28.38209505]],
    [ "Warburton Substation",[-97.04744485598893, 28.59831347918109]],
    [ "McFadden Substation",[-97.05848967973674, 28.554995147373894]],
    [ "515378550",[-85.76743968465776, 40.000916571980994]],
    [ "515484742",[-111.80981390866066, 33.37496769450001]],
    [ "515520140",[-106.32932925, 31.8066205]],
    [ "Placedo Substation",[-96.859755, 28.668779699999998]],
    [ "515589081",[-96.95306294681373, 28.680550882964805]],
    [ "515589103",[-96.95865104424063, 28.675548920549033]],
    [ "515589134",[-96.95498475, 28.682310100000002]],
    [ "Formosa Plastics CFB Substation",[-96.53999896459565, 28.65124289588374]],
    [ "Placedo Substation",[-96.82154464999999, 28.7313127]],
    [ "Kamey Substation",[-96.75333385, 28.65629535]],
    [ "Point Comfort Substation",[-96.55815290000002, 28.6738099]],
    [ "Weaver Road Substation",[-96.94861610000001, 28.701595850000007]],
    [ "515589354",[-96.94848974721614, 28.68179963295112]],
    [ "Big Three Substation",[-96.91402656701146, 28.65138024672277]],
    [ "Port Lavaca Substation",[-96.68472778574842, 28.586824830047902]],
    [ "Chocolate Bayou Substation",[-96.91922436403662, 28.685527780535246]],
    [ "Dow Chemical",[-96.77084358116876, 28.506678386925252]],
    [ "Dow Chemical",[-96.76635316886282, 28.509693237041326]],
    [ "Dow Chemical",[-96.76544330508932, 28.51022483303115]],
    [ "Dow Chemical",[-96.76688356193685, 28.516122178284856]],
    [ "Port O'Connor Substation",[-96.46302649999998, 28.4311979]],
    [ "Seadrift Substation",[-96.66776205000001, 28.41669375]],
    [ "Union Carbide Substation",[-96.77414007069139, 28.514042578205107]],
    [ "Twin Pines Switching Station",[-96.97080105169726, 28.854760033354953]],
    [ "Sam Rayburn Switchyard",[-97.13518023375296, 28.894004254842436]],
    [ "Sam Rayburn Switchyard",[-97.13414318245675, 28.894355631667352]],
    [ "Highlands Substation",[-96.9954508, 28.893276500000002]],
    [ "Lone Tree Substation",[-96.88313463382023, 28.800595656818732]],
    [ "North Victoria Substation",[-96.98350068046032, 28.80706144613781]],
    [ "Leary Lane Substation",[-96.97919151271272, 28.84291168633006]],
    [ "Foster Field Substation",[-96.92968715, 28.819506199999996]],
    [ "Lone Tree Substation",[-96.9425218, 28.8204895]],
    [ "Twin Pines Substation",[-96.97319909999999, 28.846205799999993]],
    [ "Magruder Substation",[-97.00993575168694, 28.84129919462978]],
    [ "Victoria Switching Station",[-97.010447239058, 28.78674545809202]],
    [ "515727661",[-96.83585291932877, 32.41998601566276]],
    [ "Formosa Plastics",[-96.55334875, 28.793088299999997]],
    [ "Van Humble Substation",[-96.63067699999999, 28.803830599999998]],
    [ "Energy Transfer Partners",[-96.53717007545272, 29.10825410346745]],
    [ "ETP Substation",[-96.53602270319413, 29.10824244947233]],
    [ "Cordele Substation",[-96.55411022109601, 29.07803165692604]],
    [ "Vanderbilt Substation",[-96.64568630000001, 28.806508449999995]],
    [ "Louise Substation",[-96.45404001291328, 29.1045438730152]],
    [ "Ganado Substation",[-96.48803995, 29.043464800000006]],
    [ "Edna Substation",[-96.63793834878106, 29.004464692437445]],
    [ "El Toro Switching Station",[-96.72626710490474, 28.960804016997187]],
    [ "El Toro Substation",[-96.70847649999997, 28.960233750000004]],
    [ "Inez Substation",[-96.80394131355492, 28.90865053971003]],
    [ "Fordtran Substation",[-97.0221122335159, 29.105132133416774]],
    [ "Nusery Substation",[-97.09648815497756, 28.92261584449914]],
    [ "Celanese Bay City Substation",[-96.01552766279111, 28.86796268901592]],
    [ "Wadsworth Substation",[-95.93797343781507, 28.785068883464078]],
    [ "Conoco Substation",[-95.9386648048534, 28.784294096974442]],
    [ "515869179",[-95.94386265847326, 28.784098921249466]],
    [ "Bay City Substation",[-95.90375367397323, 28.978267612877968]],
    [ "Tin Top Substation",[-96.1254199441149, 28.772410444088123]],
    [ "Carancahua Substation",[-96.31347807746668, 28.757665774500968]],
    [ "Olivia Substation",[-96.45300615000001, 28.689074150000007]],
    [ "South Texas Project Pump Substation",[-95.9981796, 28.77531685]],
    [ "Palacios Substation",[-96.20139649999997, 28.756915399999997]],
    [ "Danevang Substation",[-96.19232477687746, 29.064735676618344]],
    [ "Midfield West Substation",[-96.25694595947033, 29.01309422472693]],
    [ "Danevang Substation",[-96.21518155, 29.0780219]],
    [ "Red Bluff Substation",[-96.52487844999999, 28.88639735]],
    [ "Tenaris Substation",[-95.9120064, 28.993088200000003]],
    [ "Bay City Pump Substation",[-96.01188979999999, 28.9797729]],
    [ "Magill Substation",[-95.96928056191942, 29.01234934272809]],
    [ "Delvo Substation",[-96.92560268004212, 46.88228939370454]],
    [ "Morgan Street Substation",[-80.1351443877956, 41.62632212588484]],
    [ "516039117",[-113.52182088545707, 37.08808323978612]],
    [ "Lane City Pump Substation",[-96.0716946, 29.193341249999996]],
    [ "Round Mott Substation",[-96.41719916441711, 29.23007602480316]],
    [ "Industrial Park Substation",[-96.25137825622556, 29.206025250101657]],
    [ "Painview Substation",[-96.22726303968508, 29.143909675325947]],
    [ "El Campo Substation",[-96.26880000972876, 29.23512328076939]],
    [ "Ricebird Substation",[-96.2784707829625, 29.233941551303083]],
    [ "Hillje Substation",[-96.35552325, 29.190966900000003]],
    [ "Van Vleck Substation",[-95.8975775665848, 29.01920464919961]],
    [ "Clemville Substation",[-96.15057281098964, 28.997804424794836]],
    [ "Clemville South Substation",[-96.14307722526893, 28.98340846471845]],
    [ "Salt Dome Substation",[-96.14170941497468, 28.993480954465124]],
    [ "Tres Palacious Substation",[-96.14090557324013, 29.001083416673126]],
    [ "Clemville North Substation",[-96.13315725000001, 29.010867400000002]],
    [ "Clemville Switching Station",[-96.13346132484497, 29.027942142419825]],
    [ "Hugo Substation",[-95.31246327087383, 34.019086926176726]],
    [ "516256785",[-95.31839377386981, 34.024123613734204]],
    [ "Cedar Bridge Substation",[-74.14213856224507, 40.055533683516614]],
    [ "516454254",[-87.32586124844318, 37.91078267703058]],
    [ "516454255",[-87.32297853938485, 37.912080081113075]],
    [ "Rainy Creek Substation",[-99.70084684550814, 32.502308466242916]],
    [ "Abilene Aileen Substation",[-99.70020035, 32.488663700000004]],
    [ "Walnut Street Substation",[-99.72956817245043, 32.473519124692665]],
    [ "Vogel Street Substation",[-99.75862474999998, 32.47905179999999]],
    [ "Maple Street Substation",[-99.72570682507099, 32.404160545443055]],
    [ "Elmdale Substation",[-99.63921694999999, 32.4348783]],
    [ "Abilene East Switching Station",[-99.69801852502627, 32.45331090735242]],
    [ "Abilene East Substation",[-99.69976626887703, 32.45279975693388]],
    [ "Country Club Substation",[-99.74304359997012, 32.4021549776888]],
    [ "Over Street Substation",[-99.75675321789237, 32.41801248483562]],
    [ "Abilene McMurry Substation",[-99.75293024999999, 32.432]],
    [ "Shelton Street Substation",[-99.75442290879593, 32.45272027520805]],
    [ "Hartford Street Substation",[-99.78530265000002, 32.43366335]],
    [ "Dyess Air Force Base #1 Substation",[-99.84484617137622, 32.437868288200804]],
    [ "Dyess Air Force Base #2 Substation",[-99.83504465, 32.414512949999995]],
    [ "Dyess Air Force Base #3 Substation",[-99.81898732503367, 32.41746793964743]],
    [ "Lawrenceville Primary Substation",[-84.00083081097843, 33.98597883112283]],
    [ "516460237",[-87.93221174852312, 37.90673588733189]],
    [ "516460238",[-87.93141067510143, 37.9106631615996]],
    [ "516460239",[-87.93155005329486, 37.91339584725825]],
    [ "516460241",[-87.93501166899381, 37.90307479382793]],
    [ "Abilene Oil Mill Substation",[-99.72803179999998, 32.439331499999994]],
    [ "Vinson Substation",[-99.7000027, 32.35952665]],
    [ "West Texas Gulf Substation",[-99.71742735, 32.38790805000001]],
    [ "Church Substation",[-99.52550875, 32.367143850000005]],
    [ "Estes Substation",[-99.52563726006893, 32.36586547386163]],
    [ "Potosi Substation",[-99.62308752487264, 32.32904684292301]],
    [ "Midtown Substation",[-83.06582491423777, 42.3711427074306]],
    [ "516653848",[-76.20598220253525, 36.872829267193204]],
    [ "Holder Substation",[-98.97846783979685, 31.913509883475903]],
    [ "Rising Star Substation",[-98.97270162508016, 32.09445305522806]],
    [ "Cross Plains Substation",[-99.16872763808155, 32.12180427460997]],
    [ "Dressey Substation",[-99.22792075, 32.10572465]],
    [ "Paducah South Substation",[-100.32695115, 33.980251200000005]],
    [ "Paducah City Substation",[-100.29937417516298, 34.01469618783368]],
    [ "Paducah Clare Street Substation",[-100.29927576259124, 34.00518852492835]],
    [ "Fishing Creek Substation",[-83.28031750332235, 33.08613775977486]],
    [ "516757304",[-80.59288968558214, 33.490470903960805]],
    [ "516860005",[-108.16405958720662, 36.761077232934284]],
    [ "516860009",[-108.14856103911872, 36.77716072482249]],
    [ "Kileville Substation",[-83.19608821049572, 40.10203782561681]],
    [ "516976205",[-111.90111263894877, 33.34880028676857]],
    [ "Subestación Fajardo",[-65.6459422197998, 18.329468495217604]],
    [ "517130646",[-78.92986621252541, 36.74302752541189]],
    [ "517437827",[-108.24676825010583, 36.74782311103843]],
    [ "Anson Substation",[-99.89127772003046, 32.75835216141797]],
    [ "Anson Substation",[-99.87674939251202, 32.7370824249507]],
    [ "Hawley Humble-Exxon Substation",[-99.80921708808432, 32.63168022924153]],
    [ "Whiteacre Substation",[-99.7667850791252, 32.58027135690805]],
    [ "Paint Creek Substation",[-99.57957216721601, 33.079730695032566]],
    [ "Nugent Substation",[-99.67484508512617, 32.69371577562329]],
    [ "California Creek Substation",[-99.55698289650773, 33.07210223274367]],
    [ "Abilene Onyx Substation",[-99.77087420000001, 32.54688835]],
    [ "Hubbard Booster #1 Substation",[-99.41175936756078, 32.65885028623969]],
    [ "Fort Phantom Clear Fork Pump Substation",[-99.69158503226673, 32.610580593705635]],
    [ "Fort Phantom East Pump Substation",[-99.68025321306081, 32.59650662401946]],
    [ "Roberts Prison Substation",[-99.63972360896598, 32.55456262492952]],
    [ "Fort Phantom Switchyard",[-99.68234397953923, 32.58259479411314]],
    [ "Neas Substation",[-99.68823585000001, 32.53223534999999]],
    [ "Horton Substation",[-99.68636695, 32.53258455]],
    [ "Post Oak Substation",[-99.53867845, 32.5418329]],
    [ "Mesquite Substation",[-99.54042002562035, 32.62877300375886]],
    [ "Bennington Substation",[-73.1714222051625, 42.89444729391589]],
    [ "Nimrod Substation",[-99.01055770768284, 32.27173844161529]],
    [ "Rising Star Substation",[-98.88324966661801, 32.09792448361914]],
    [ "Wright Substation",[-98.1911190651656, 32.26291244222513]],
    [ "Norfork Substation",[-98.22362620000001, 32.243128250000005]],
    [ "Carlton Substation",[-98.19021322213011, 31.98350887140552]],
    [ "Mountary Substation",[-98.4318283, 32.075523]],
    [ "Downing Substation",[-98.55175590858858, 32.020958223593034]],
    [ "Stephenville Substation",[-98.23284502954401, 32.205200212434825]],
    [ "Selden Substation",[-98.1572758614559, 32.186770466835924]],
    [ "Johnsville Substation",[-97.94551509766977, 32.12186259351]],
    [ "517740412",[-86.07165704052689, 32.395924165566164]],
    [ "Virginia Electric and Power Company",[-77.98925445315358, 38.469354267030084]],
    [ "517943887",[-100.79965911665427, 37.11003256667924]],
    [ "Hedge Substation",[-121.35531422091682, 38.50859136666403]],
    [ "Lake Substation",[-121.13208954797051, 38.65711989436463]],
    [ "518198118",[-111.89001975017835, 33.30019119864184]],
    [ "518402372",[-96.64976783015788, 33.208984980320785]],
    [ "518432626",[-96.63732534106883, 33.18898582435973]],
    [ "AEP Linwood Substation",[-85.75142406333379, 40.193703948967546]],
    [ "518592656",[-96.71005547124504, 33.036189659191336]],
    [ "Hubbard Booster #2 Substation",[-99.22464435, 32.712255899999995]],
    [ "Albany Substation",[-99.29264541213804, 32.72363997520214]],
    [ "Albany Foundry Substation",[-99.23481764727154, 32.665385816243045]],
    [ "Moran Substation",[-99.16337495, 32.54635235]],
    [ "Putnam Substation",[-99.20151851444415, 32.37192966916988]],
    [ "Baird City Substation",[-99.38662076773223, 32.40933671552421]],
    [ "Putnam Switching Station",[-99.19407121577095, 32.383660865793004]],
    [ "Clyde Substation",[-99.5044195363411, 32.415670824737106]],
    [ "Denton Valley Substation",[-99.53945187516366, 32.257552395233645]],
    [ "Clyde Magnolia Substation",[-99.5895703, 32.35795615000001]],
    [ "518658542",[-96.68689730308549, 33.0042726116113]],
    [ "518683420",[-89.22269709701851, 37.77161494166851]],
    [ "McAdams Substation",[-100.02578944339058, 33.98389367339591]],
    [ "Crowell Substation",[-99.72277636043182, 33.982294225162754]],
    [ "Copper Breaks Substation",[-99.73868174591404, 34.16166071767512]],
    [ "Throckmorton Woodson Oil Substation",[-99.23300950086731, 33.22085685540757]],
    [ "Truscott Humble Substation",[-100.04793140000001, 33.77014475000001]],
    [ "Benjamin Substation",[-99.80096890000002, 33.58457855]],
    [ "Truscott City Substation",[-99.8101996, 33.748730450000004]],
    [ "519105575",[-80.73315160850437, 33.4416728282572]],
    [ "Dell Substation",[-81.9021816691949, 41.40191332458595]],
    [ "Munday Substation",[-99.66038228668889, 33.448296225259995]],
    [ "Weinert Substation",[-99.67101683683926, 33.324540024616745]],
    [ "Bush Knob Substation",[-99.17865915, 33.10529879999999]],
    [ "Throckmorton Substation",[-99.17859837495723, 33.17842059026458]],
    [ "Vertigo Wind Substation",[-99.42139446687699, 33.64463568382114]],
    [ "Foxtail Switching Station",[-99.42079397815495, 33.646314396633194]],
    [ "Baker Ranch Substation",[-99.5891473331869, 33.369874319697864]],
    [ "519133812",[-119.84525551666307, 39.5604215501871]],
    [ "Jackson Substation",[-80.11210284948683, 40.7424327689271]],
    [ "Corinth Substation",[-99.8687297, 32.855097799999996]],
    [ "Stamford Substation",[-99.80951041334447, 32.94387653085797]],
    [ "Haskell Substation",[-99.74785984999998, 33.12309255]],
    [ "Haskell Substation",[-99.729046, 33.15531825]],
    [ "Josselett Substation",[-99.69597486986942, 33.25875230380561]],
    [ "Haskell Texas Pipeline Substation",[-99.60692809194694, 33.290172022631765]],
    [ "Aspermont Substation",[-100.22624348097098, 33.139569686383894]],
    [ "Swenson Substation",[-100.31170724191229, 33.18262387849542]],
    [ "Peacock Substation",[-100.39152169999997, 33.176361199999995]],
    [ "Jayton Substation",[-100.62640687521979, 33.270912844187286]],
    [ "Girard Substation",[-100.66480200000001, 33.359759000000004]],
    [ "Jayton Substation",[-100.5729501, 33.2459049]],
    [ "Clairemont Substation",[-100.86737165000001, 33.2065035]],
    [ "Clairemont Substation",[-100.76572099088261, 33.16045547492769]],
    [ "Wolfgang Switching Station",[-100.52604944602547, 33.00314713888494]],
    [ "Mozart Substation",[-100.53163815000002, 32.99423655]],
    [ "Rotan Substation",[-100.45380281936777, 32.839199064121146]],
    [ "Roby Substation",[-100.37783132903228, 32.748656404792776]],
    [ "Longworth Substation",[-100.35835795, 32.6718767]],
    [ "519701804",[-113.5427822998493, 37.097665864789974]],
    [ "519701805",[-113.54192666729539, 37.09815280609059]],
    [ "Hamlin Texas Pipeline Substation",[-100.22778181113227, 32.93513842521942]],
    [ "Aspermont Continental Oil Substation",[-100.19625839999999, 33.088656650000004]],
    [ "Hamlin Shell Pump Substation",[-100.1549071, 32.973239050000004]],
    [ "Hamlin Substation",[-100.09863268928174, 32.8923611167131]],
    [ "Hamlin Substation",[-100.12133116798068, 32.88926246995737]],
    [ "Hamlin Plasterco Substation",[-100.18402575, 32.837601250000006]],
    [ "Round Top Substation",[-100.26482562514457, 32.86616460627291]],
    [ "Rule Substation",[-99.88996391103359, 33.18926090788163]],
    [ "Gillespie Substation",[-99.75178441840606, 33.420316085295674]],
    [ "Knox City Substation",[-99.818760215894, 33.42231402497357]],
    [ "Pointer Switching Station",[-99.83339449999998, 33.40363885]],
    [ "Rochester Substation",[-99.85678267503287, 33.317102491704546]],
    [ "Aspermont Substation",[-100.23347347541515, 33.17797039040479]],
    [ "Bissett Substation",[-100.20994400881172, 33.351663506455935]],
    [ "King Substation",[-100.15739952912524, 33.51889126321695]],
    [ "Katz Substation",[-100.01040060090959, 33.39726751085899]],
    [ "Knox Substation",[-99.89146061351708, 33.388942175050566]],
    [ "519751929",[-89.88048922176364, 35.33175880180109]],
    [ "Alfred Substation",[-83.03649625691841, 42.350184973145275]],
    [ "C.T.L. #1",[-83.14949690479128, 42.490965222333244]],
    [ "Glidden Substation",[-96.57272485964442, 29.69641281969193]],
    [ "Bernardo Substation",[-96.39909719998955, 29.754103555662166]],
    [ "Sky Global Power One Substation",[-96.53847433254617, 29.550284707223778]],
    [ "Rock Island Substation",[-96.5378976144644, 29.550054159709457]],
    [ "Sheridan Substation",[-96.66656411050478, 29.49721557946537]],
    [ "Colorado Substation",[-96.61983943772353, 29.467175913120894]],
    [ "Garwood Ideal Substation",[-96.4533066223188, 29.494924761863416]],
    [ "Pioneer Substation",[-96.45962835, 29.50484685]],
    [ "Garwood Pump Substation",[-96.4090011623061, 29.5156831790842]],
    [ "B&B Gravel Substation",[-96.4161571, 29.520159999999997]],
    [ "Garwood Relift Substation",[-96.46521438154548, 29.514419006443134]],
    [ "Garwood Lone Star Substation",[-96.34649779200777, 29.419677069748015]],
    [ "Eagle Lake Substation",[-96.33274071055445, 29.58005449253597]],
    [ "Prairie Pump Substation",[-96.37849084415488, 29.602354060254754]],
    [ "Parker Substation",[-96.38411859901136, 29.571937389165477]],
    [ "Garwood City Substation",[-96.39192032522735, 29.44778625683169]],
    [ "Matthews Substation",[-96.33269565, 29.506844599999994]],
    [ "Lakeside Pump Substation",[-96.33472370845429, 29.55918191953024]],
    [ "Columbus Substation",[-96.54283017513211, 29.698376362082836]],
    [ "Stafford Hill Substation",[-96.5156714744155, 29.649850388678814]],
    [ "Riverside Pump Substation",[-96.40179640000001, 29.570193549999995]],
    [ "Altair Substation",[-96.46245916809077, 29.56426463623392]],
    [ "Nada Substation",[-96.38704007565478, 29.39206513620411]],
    [ "Mockingbird Substation",[-96.57369026240366, 29.701245940514585]],
    [ "520325525",[-83.61971447766904, 39.18794601469225]],
    [ "Great River Energy",[-93.82024595732797, 44.904022400598116]],
    [ "Bryan Substation",[-95.37604042185458, 28.919510976869926]],
    [ "Texas Gulf Sulfur Substation",[-95.90057615211775, 29.263812542946624]],
    [ "Caney Creek Substation",[-96.1186196708672, 29.3247024823182]],
    [ "Colorado Bend Substation",[-96.06890997381902, 29.28917819289411]],
    [ "Colorado Bend 2 Substation",[-96.06463820000002, 29.287628800000004]],
    [ "Bailey Substation",[-95.99218197492263, 29.185384377115284]],
    [ "AEP South Side Station",[-85.65335377943008, 40.53061113864838]],
    [ "Essex Substation",[-82.96168129541107, 42.36028814533373]],
    [ "Seadoc Substation",[-95.4346483, 28.952187799999997]],
    [ "Seaway Substation",[-95.43272623121369, 28.94882060220665]],
    [ "Franklins Camp Substation",[-95.56390781712587, 28.928173376058318]],
    [ "Sargent Substation",[-95.66777554979748, 28.87217212983194]],
    [ "520683877",[-122.07431825, 38.0327118]],
    [ "521065706",[-122.42760082182514, 48.03069851139168]],
    [ "521084736",[-111.98562167319089, 41.035382602824036]],
    [ "Camden Substation",[-95.35739165, 28.988132300000004]],
    [ "521418873",[-97.109167653904, 33.19936056733293]],
    [ "521426462",[-108.00057895650811, 36.7190637550215]],
    [ "Einstein Substation",[-101.52060696421931, 31.769594481681544]],
    [ "Dublin Substation",[-83.14240813777661, 40.09347481229744]],
    [ "Endeavor Substation",[-101.97555634049309, 31.817204575135328]],
    [ "Pronghorn Substation",[-101.97325967051465, 31.81772024593649]],
    [ "521837721",[-101.92315344784151, 31.959378632267818]],
    [ "Blue Acre Substation",[-101.92637910610847, 31.95799185777024]],
    [ "Pride Substation",[-78.97892095697841, 39.98797448146468]],
    [ "522476877",[-82.17227590793394, 35.06378999925725]],
    [ "McKinney Street Substation",[-97.10279125355468, 33.21362584128672]],
    [ "Retrieve Substation",[-95.49277315, 29.099848950000002]],
    [ "Dow Chemical",[-95.3941055741913, 28.987516614915]],
    [ "Dow Chemical",[-95.40744301865934, 28.99050340465812]],
    [ "Dow Chemical Company",[-95.35822392674507, 28.985146330701184]],
    [ "Copper Substation",[-95.40512724999999, 29.0067586]],
    [ "522624047",[-95.40596509999999, 29.003657]],
    [ "BASF Substation",[-95.396616131408, 29.001687615638517]],
    [ "Cortez Substation",[-95.32400587833803, 28.9248601664975]],
    [ "Quintana Substation",[-95.31783436519288, 28.93222497791326]],
    [ "Marine Substation",[-95.33971642541732, 28.933494558501703]],
    [ "Sintek Substation",[-95.3573375647033, 28.992280706218494]],
    [ "Dow Chemical Company",[-95.34161153328856, 28.97867645053179]],
    [ "Dow Chemical Company",[-95.31674679607889, 28.955663574091982]],
    [ "Dow Chemical Company",[-95.3499989076349, 28.975917440745835]],
    [ "Dow Chemical",[-95.39374787771943, 28.985600732258042]],
    [ "Booster Substation",[-95.39172769347532, 28.96285841305857]],
    [ "Jones Creek Substation",[-95.38111324337716, 28.957689064432405]],
    [ "522734115",[-78.44800845401168, 35.863588432749395]],
    [ "523306387",[-95.22946642134436, 42.698520389224896]],
    [ "Rogers Substation",[-98.1942997444696, 47.09542079269339]],
    [ "Waldron Substation",[-85.6671119853981, 39.43841555018699]],
    [ "523840947",[-98.49968435000001, 46.926450749999994]],
    [ "523840948",[-98.50102675, 46.9264535]],
    [ "Spiritwood Substation",[-98.50009605000001, 46.92731715]],
    [ "Hi-Liner Substation",[-98.04055017482949, 46.90672145379022]],
    [ "524002043",[-149.6273128580092, 61.28935637128391]],
    [ "Pillsbury Substation",[-97.7896416, 47.09440554999999]],
    [ "Montana-Dakota Utilities",[-102.63235395000001, 46.0098494]],
    [ "524281124",[-102.60724404999999, 46.032767250000006]],
    [ "524523810",[-97.38317883199377, 35.47904689395327]],
    [ "Reed Creek Substation",[-82.92348559999998, 34.4509411]],
    [ "Reed Creek Switching Station",[-82.9229762082146, 34.450609033111746]],
    [ "Hankinson Substation",[-96.86605440000001, 46.05110394999999]],
    [ "524697125",[-97.18168914273663, 33.20835262695506]],
    [ "Kelso Substation",[-97.00134427490804, 47.26816785503238]],
    [ "524729806",[-97.09269756192353, 33.225535066642514]],
    [ "524763074",[-82.97458005777298, 39.79828550263369]],
    [ "524763075",[-82.94615934941739, 39.844341551451215]],
    [ "Gardner Substation",[-96.98399031090149, 47.137007173371636]],
    [ "Bison Substation",[-97.07594133595342, 46.95074405068092]],
    [ "Eureka Way Substation",[-122.43771224916635, 40.58390300187289]],
    [ "Northport Substation",[-85.69761041755811, 38.347416462767356]],
    [ "525233505",[-85.67182644668367, 38.39936218291757]],
    [ "Hopatcong Switching Station",[-74.63535215538475, 40.99154603379274]],
    [ "Texas Eastern Substation",[-77.13032652089021, 39.94813331943445]],
    [ "525373001",[-79.34648482012564, 42.49004586722838]],
    [ "Buckler Substation",[-83.73774059647349, 42.28773187076024]],
    [ "Clark Substation",[-74.30693340875672, 40.62977713989803]],
    [ "Rock Springs Substation",[-112.14853709422721, 34.052150630532815]],
    [ "Edmond Street Substation",[-94.85857063960599, 39.76596117136286]],
    [ "Sneads Substation",[-84.95591327387002, 30.725241327564785]],
    [ "Cypress Substation",[-85.06758860000001, 30.7488632]],
    [ "Cedar Falls Utilities",[-92.45207636391672, 42.46995342220144]],
    [ "Vassell Substation",[-82.85270545541596, 40.22869835554379]],
    [ "Vassell Substation",[-82.84650846310679, 40.23070452321529]],
    [ "526490163",[-83.09726918927349, 40.01772090184213]],
    [ "Roberts Substation",[-83.11593402551499, 40.01024611576761]],
    [ "Orchard Switching Station",[-75.24738738094811, 39.58573319296614]],
    [ "Lauschtown Substation",[-76.01471917728004, 40.21663310802353]],
    [ "PPL",[-75.64623424999999, 40.55033435]],
    [ "Breinigsville Substation",[-75.64263047123417, 40.551607365646916]],
    [ "526866658",[-85.80557495000001, 40.3212707]],
    [ "Strawton Substation",[-85.7770371510715, 40.320063449926046]],
    [ "Warrington Substation",[-75.12535170677118, 40.24833683299119]],
    [ "Center Point Substation",[-75.34777184520058, 40.21279542580954]],
    [ "Burke Road Substation",[-80.88179352418459, 33.63474912638261]],
    [ "Seaford Substation.",[-75.61250805, 38.662655550000004]],
    [ "Gold Dale Substation",[-77.78275073795211, 38.249911242072415]],
    [ "Clara City Substation",[-95.37059205, 44.9488597]],
    [ "Cartanza Substation",[-75.46928848213335, 39.20217866694313]],
    [ "Cedar Creek Substation",[-75.56279860009377, 39.37402196822124]],
    [ "527408819",[-118.0803097221159, 40.72317154688726]],
    [ "527672350",[-77.23589457765183, 38.836802892806716]],
    [ "527707072",[-85.14783853627549, 41.0809006967174]],
    [ "527713248",[-106.58949986023296, 35.13418128917526]],
    [ "Tipton Substation",[-78.29524837272845, 40.63552275832802]],
    [ "Lake Lillian Substation",[-94.9004706, 44.93560630000001]],
    [ "Gorman Substation",[-98.66018595680062, 32.22165350194221]],
    [ "De Leon Substation",[-98.53508634587635, 32.117982826844816]],
    [ "De Leon Magnolia Substation",[-98.46986720000001, 32.072412299999996]],
    [ "Leon Switching Station",[-98.76883700040666, 32.37397325174614]],
    [ "Leon EBAA Substation",[-98.76909554999999, 32.37285275]],
    [ "Flat Creek Switching Station",[-98.47454518064876, 32.265233787847215]],
    [ "Silver Star Wind Substation",[-98.46577181846146, 32.3310758856611]],
    [ "Lingleville Substation",[-98.46836295850902, 32.260812840670816]],
    [ "527977191",[-86.0478170688315, 39.787980782604286]],
    [ "Hampton Substation",[-92.99663503416218, 44.638310196276976]],
    [ "Chub Lake Substation",[-93.29591839252156, 44.595918575683164]],
    [ "NV Energy",[-115.1443731178014, 36.2035944585776]],
    [ "528065329",[-115.08373364663306, 36.217154900349946]],
    [ "SRP Houston Substation",[-111.91178969917009, 33.32324191354434]],
    [ "528124236",[-65.64031605, 18.29528655]],
    [ "528218922",[-80.97017644808872, 34.008916973466526]],
    [ "Puerto Rico Electric Power Authority",[-65.6362420090826, 18.341955226532413]],
    [ "Georgia Power",[-84.9593031499448, 32.380551597238274]],
    [ "Puerto Rico Electric Power Authority",[-65.62983844111788, 18.360602824790075]],
    [ "528984176",[-67.14152015573134, 18.21450370287915]],
    [ "Subestación Acacias",[-67.13603689890897, 18.12882482317155]],
    [ "529198452",[-66.1531663, 17.980330800000004]],
    [ "Riley Substation",[-85.7735870411291, 39.78372640402895]],
    [ "Puerto Rico Electric Power Authority",[-66.79175037069689, 18.197572337652275]],
    [ "529676763",[-65.7987324796221, 18.14785895585359]],
    [ "529676765",[-65.80076895, 18.148136450000003]],
    [ "Puerto Rico Electric Power Authority",[-65.88375010788961, 18.049802020444456]],
    [ "529784015",[-80.99099615816326, 34.02045666907209]],
    [ "529797293",[-92.48576400793183, 42.72702622629102]],
    [ "529967432",[-66.14543825000001, 17.96341575]],
    [ "Subestación de Sabana Grande",[-66.95692076350554, 18.075622878070906]],
    [ "Puerto Rico Electric Power Authority",[-66.87024309329145, 18.023075712302038]],
    [ "Subestación Yauco Pueblo",[-66.85231580392826, 18.032101487326457]],
    [ "Vital Substation",[-83.6518224683876, 41.963204555568446]],
    [ "530354358",[-80.9567803056429, 34.063501641889765]],
    [ "530357877",[-66.63832455989541, 17.98425167316647]],
    [ "Puerto Rico Electric Power Authority",[-66.59149938138027, 18.032649035608863]],
    [ "530677131",[-116.40533541672582, 43.58697692488993]],
    [ "530771489",[-85.46375603722517, 32.62806179243177]],
    [ "530930409",[-66.54440819999999, 18.050471349999995]],
    [ "Puerto Rico Electric Power Authority",[-66.50832635009594, 18.058872026480618]],
    [ "531045953",[-85.73353485, 38.149679649999996]],
    [ "Monticello Substation",[-83.6833472130991, 33.30186161944641]],
    [ "Rossman Substation",[-82.82771590510394, 35.145536592316425]],
    [ "531301312",[-81.14870336891681, 34.070797325125795]],
    [ "Fairbanks Substation",[-85.67302328359493, 42.974372775232254]],
    [ "Kentucky Utilities Company",[-87.00690561198635, 37.402833402596706]],
    [ "Forest Substation",[-94.57406569378254, 39.015939131227384]],
    [ "531566621",[-83.78603037556418, 31.970958404122655]],
    [ "Puerto Rico Electric Power Authority",[-66.72247457143759, 18.25784710529285]],
    [ "Puerto Rico Electric Power Authority",[-66.88265764151326, 18.291504129138232]],
    [ "Cherry Hill Substation",[-75.02970962088993, 39.94203739179331]],
    [ "531716420",[-75.0284673802289, 39.94363790076949]],
    [ "Puerto Rico Electric Power Authority",[-66.99081235, 18.24228905]],
    [ "532094025",[-76.70345508409403, 37.08114396643384]],
    [ "532446490",[-85.17099607838357, 41.08790610705493]],
    [ "Puerto Rico Electric Power Authority",[-66.87589099448796, 18.013176979113187]],
    [ "Bellevue Substation",[-122.71259212501441, 38.37882724324292]],
    [ "532630731",[-113.52358915000002, 33.82607780000001]],
    [ "Grandview West Substation",[-94.55499174986271, 38.8769876935539]],
    [ "Livonia Substation",[-83.32563850777832, 42.37186682516213]],
    [ "Lake Mack Substation",[-81.4341809, 28.995055100000005]],
    [ "533178583",[-96.19777075199751, 32.32290018317825]],
    [ "533206674",[-90.92497805372479, 32.704309588257125]],
    [ "Paisley Substation",[-81.54000072373843, 28.97460001966258]],
    [ "Distributing Station No. 138",[-118.5685253296604, 34.241988191645554]],
    [ "Clarkdale Substation",[-86.78048827835731, 34.806355444191176]],
    [ "Puerto Rico Electric Power Authority",[-66.99467094710629, 18.230159382566654]],
    [ "McCall Substation",[-81.64877390014979, 28.908321153271615]],
    [ "69KV Umatilla",[-81.642299812928, 28.952868112759592]],
    [ "533766756",[-81.76332573334314, 34.324498400115004]],
    [ "Greater Crossroads Substation",[-74.68998044377335, 40.665539996254005]],
    [ "Cornwells Substation",[-74.95070689610799, 40.072096433038524]],
    [ "533856032",[-96.1046391009333, 32.35729324376384]],
    [ "533856034",[-96.05474260380521, 32.33496875890258]],
    [ "C.T.L. #8",[-83.12002326170327, 42.273893754299024]],
    [ "Eustis Moran Street Substation",[-81.68637772425886, 28.850465577048336]],
    [ "Sorrento Springs Substation",[-81.55235258426254, 28.83163222357224]],
    [ "Marion Substation",[-83.12085785286223, 42.27424595214668]],
    [ "Ellsworth Substation",[-98.24437136501687, 38.73959338665094]],
    [ "Doubleday Substation",[-78.13631760000001, 38.1818503]],
    [ "Somerset Substation",[-78.19323645, 38.14693405]],
    [ "Oak Green Substation",[-77.9473563, 38.333763649999995]],
    [ "Unionville Substation",[-77.95546540379098, 38.31574185280008]],
    [ "Paytes Substation",[-77.83504181646313, 38.22619312284077]],
    [ "Mitchell Substation",[-77.99378338033654, 38.36752740521698]],
    [ "Brandy Substation",[-77.84139600572419, 38.4913904185035]],
    [ "Virginia Electric and Power Company",[-77.9932589915119, 38.46944577058012]],
    [ "Madison Substation",[-74.03573349264539, 40.75177466100874]],
    [ "Swan Creek Substation",[-83.31707861233176, 42.006292255083814]],
    [ "Taylor Substation",[-83.25658519072374, 42.184276185761654]],
    [ "Lecompte Substation",[-92.39550234414925, 31.084878431469654]],
    [ "535135590",[-96.834387, 32.44141215]],
    [ "Puerto Rico Electric Power Authority",[-66.32131861941845, 17.978996354875324]],
    [ "Puerto Rico Electric Power Authority",[-66.3731498368754, 18.01692971150422]],
    [ "C.T.L. #9",[-83.11037398296267, 42.31807827685889]],
    [ "AEP Hartford City Station",[-85.36102757283756, 40.450042123125826]],
    [ "535330863",[-85.37933238288274, 40.4549316838292]],
    [ "Fairmount Substation",[-84.70665698993938, 34.44214139217767]],
    [ "Coldbrook Substation",[-85.67192482603257, 42.981911307820184]],
    [ "Barberville Substation",[-81.41033678867876, 29.180089224202845]],
    [ "535550671",[-95.711990964914, 32.334847898737685]],
    [ "Air Base Substation",[-92.43304155, 41.0976129]],
    [ "535902917",[-95.8366062397045, 32.231089721831246]],
    [ "Alapaha Substation",[-83.2175975812375, 31.382267178095113]],
    [ "Junction City Substation",[-84.45913829999999, 32.5989336]],
    [ "Cogswell Substation",[-83.41192086717457, 42.25522734184044]],
    [ "536754252",[-91.98342646490066, 30.10117393180573]],
    [ "Lafayette Utilities System",[-92.00844439890037, 30.144332702673495]],
    [ "536792668",[-86.68292111753986, 30.433139034173756]],
    [ "536792685",[-86.51724825000001, 30.515213350000003]],
    [ "Microsoft/Data Center Substation",[-104.9043975840727, 41.12736802084708]],
    [ "Second Street Substaiton",[-80.58011593759583, 40.61650410586384]],
    [ "537502106",[-96.5052233746629, 33.192416252933285]],
    [ "Cochran Mill Delivery Point",[-77.53993840135924, 39.06491394782937]],
    [ "Calla Substation",[-83.9722832375919, 42.39291382774613]],
    [ "Lima Substation",[-83.9591965337981, 42.324921324486525]],
    [ "Cheyenne Prairie Generation",[-104.72285704768164, 41.12238806034035]],
    [ "Colorado Springs Utilities",[-104.90024455605732, 39.00661034366743]],
    [ "538015956",[-86.22638333378714, 32.400506782969074]],
    [ "Dumfries Substation",[-77.3059197780579, 38.58730974041723]],
    [ "538117207",[-96.01496939632415, 32.184896421410286]],
    [ "Rappahannock Electric Cooperative",[-77.53972025, 37.7908274]],
    [ "Rappahannock Electric Cooperative",[-77.63490110447512, 37.78354481723505]],
    [ "Vontay Substation",[-77.73176720297558, 37.78848329778151]],
    [ "Buckner Substation",[-77.76354674191724, 37.96204858113467]],
    [ "Kalamazoo Metal Substation",[-85.56050214387157, 42.285728774778356]],
    [ "Parkville Substation",[-85.50859241719265, 42.03598675641192]],
    [ "Russell Substation",[-98.79594536086869, 38.89236156364468]],
    [ "Crown Point Substation",[-75.22104764761173, 39.839902589303264]],
    [ "Linwood Substation",[-75.43308376524531, 39.81805454038654]],
    [ "Red Lion Substation",[-75.62927821915054, 39.6085705545969]],
    [ "Delmarva Power",[-75.62656916509523, 39.6121183571184]],
    [ "MidAmerican Energy",[-92.36716070160826, 42.4438159936542]],
    [ "Trainer Substation",[-75.39949615, 39.8220059]],
    [ "Gulf Park Substation",[-87.67507882554746, 30.25272151303684]],
    [ "City of Tallahassee",[-84.16146019073888, 30.49178658362899]],
    [ "538644024",[-87.6816493250659, 30.403619490596903]],
    [ "538644028",[-87.68031415, 30.417013]],
    [ "Beach Express Substation",[-87.65435492518385, 30.363491756131918]],
    [ "538644045",[-87.64135265834723, 30.312387573166074]],
    [ "538798549",[-66.49635449923676, 18.126686882974422]],
    [ "PECO",[-75.32482257485924, 39.8604516457017]],
    [ "Eddystone Substation",[-75.32727641467864, 39.860079169551675]],
    [ "Printz Substation",[-75.3343905585094, 39.86137558374383]],
    [ "MacDade Substation",[-75.29619494973987, 39.90174846205692]],
    [ "Ridley Substation",[-75.31597038622783, 39.89233646981479]],
    [ "Nortech Substation",[-121.95993350101999, 37.420562705801515]],
    [ "539157166",[-88.09419520000002, 30.53091065]],
    [ "Suffolk Substation",[-80.00373252323335, 40.46432369550269]],
    [ "Beaverdam Substation",[-83.97685206719719, 40.83334697135383]],
    [ "Penrose Substation",[-75.20166908907021, 39.900624019799544]],
    [ "Island Road Substation",[-75.23741861361826, 39.90091197507824]],
    [ "Puerto Rico Electric Power Authority",[-66.49541085, 18.00579515]],
    [ "Seneca Substation",[-123.14010674079644, 44.05842787052989]],
    [ "539734109",[-84.91706172501954, 39.83580184228674]],
    [ "Bala Substation",[-75.22760124275428, 40.00175821319641]],
    [ "North Philadelphia Substation",[-75.14879192634709, 40.000073991734105]],
    [ "Whitemarsh Substation",[-75.21019447573745, 40.128153749145916]],
    [ "Plymouth Meeting 138 kV Substation",[-75.2997008744278, 40.10205137096295]],
    [ "539944559",[-104.58245542966463, 39.78724457196819]],
    [ "539954723",[-82.92933580396502, 38.7532595677422]],
    [ "539964394",[-82.9418564645251, 38.80049180183859]],
    [ "539964395",[-82.98873514772191, 38.865628907940234]],
    [ "539986766",[-82.8350045245123, 38.74472591725848]],
    [ "539986767",[-82.81423064139722, 38.725333990271885]],
    [ "539986786",[-82.53277275923806, 38.44028835149029]],
    [ "Jersey Central Power and Light",[-74.26036364999999, 40.12482615]],
    [ "Whitings Substation",[-74.37786006770726, 39.952119485527874]],
    [ "Manchester Substation",[-74.27993000524084, 40.03610139029438]],
    [ "Cedar Substation",[-74.26129000539258, 39.68998483588972]],
    [ "Barnegat Substation",[-74.27404769359697, 39.75794440445046]],
    [ "West Wharton MVAR SVC",[-74.59400736566319, 40.90689256979302]],
    [ "Albany Utilities",[-84.2159169744169, 31.614090091922964]],
    [ "IP&L Substation J",[-94.4114887439254, 39.09475547787225]],
    [ "Washington Substation",[-86.13017330632591, 30.338404269233706]],
    [ "Hewett Substation",[-86.27896151617945, 30.380015017096284]],
    [ "Oakland J Substation",[-122.21440848095935, 37.76299308997968]],
    [ "Junction City Substation",[-123.20018897560242, 44.16356635958304]],
    [ "Landsdale Substation",[-75.28875781393627, 40.25877457944105]],
    [ "540550314",[-82.14685358505898, 34.9016781327577]],
    [ "540805520",[-84.11765860995101, 30.42303517196933]],
    [ "540893983",[-85.75965508391646, 30.17742186714789]],
    [ "541000473",[-116.14463927507312, 43.52751233927529]],
    [ "541095863",[-87.5771655, 30.307709300000003]],
    [ "Miflin Substation",[-87.5681669, 30.37353267899714]],
    [ "East Hall Substation",[-98.39383666689218, 38.79110785215822]],
    [ "Mount Olive Substation #15",[-84.23315142482554, 31.122551786644678]],
    [ "541311542",[-82.67621642808245, 28.397666330641893]],
    [ "Briggs Road Substation",[-91.28269905680939, 43.95321012128206]],
    [ "Limestone Substation",[-85.40430507013487, 31.104999319610812]],
    [ "Grady EMC",[-84.14488656129338, 30.861813082483124]],
    [ "Georgia Power",[-84.21090208096656, 30.87746698426878]],
    [ "Georgia Power",[-84.17366242518602, 30.885414340718018]],
    [ "Municipal Electric Authority of Georgia",[-83.95144060000001, 30.88738455]],
    [ "Georgia Power",[-83.95109782091882, 30.855340982410628]],
    [ "Georgia Power",[-83.95801465395685, 30.833780756814875]],
    [ "Coolidge Substation",[-83.87207203870737, 31.004372077603307]],
    [ "Wildwood Substation",[-81.98871762569608, 28.82524513328462]],
    [ "Georgia Power",[-84.05935855, 30.9875626]],
    [ "Puerto Rico Electric Power Authority",[-66.87619075000002, 18.012447]],
    [ "Elrod Substation",[-85.15152059713571, 39.05225536969822]],
    [ "Blue Mills Substation",[-94.32482283130253, 39.16057433886115]],
    [ "Golden Gem Substation",[-81.67576384434017, 28.91693676141888]],
    [ "Umatilla Substation",[-81.67525064999998, 28.9096339]],
    [ "Bentonville Electrical Utility Department",[-94.2082592120851, 36.39360322460163]],
    [ "Deer Island Substation",[-81.72788614843196, 28.76498702562674]],
    [ "542438289",[-101.23018612504725, 37.957567082709154]],
    [ "542483934",[-101.76260346508138, 38.01640982631177]],
    [ "Monticello Mill Substation",[-90.07649257298587, 31.62737647908421]],
    [ "Brookhaven Substation",[-90.4227339422754, 31.593688546405943]],
    [ "Tavares Substation",[-81.73054415814377, 28.810718108935436]],
    [ "Eustis South Substation",[-81.68674556470971, 28.825255418339093]],
    [ "Lake Seneca Substation",[-81.60204866258319, 28.852119808208386]],
    [ "542602966",[-100.98277109999998, 38.484355099999995]],
    [ "542621769",[-96.61482115115817, 33.21825967412265]],
    [ "Laingsburg Substation",[-84.35959912441922, 42.896229493504514]],
    [ "542676683",[-101.47675406825333, 38.49590056468788]],
    [ "542676988",[-101.3579047958308, 38.495603509038084]],
    [ "Henderson Substation",[-83.4039867278596, 43.11675121142388]],
    [ "TS1 Substation",[-112.48890750310889, 33.676462632734946]],
    [ "Sun Valley Substation",[-112.68983411628051, 33.661039979117845]],
    [ "Delaney Substation",[-113.0343235158933, 33.48105837618232]],
    [ "542823436",[-85.20790544204391, 40.05169324308083]],
    [ "542831017",[-111.33696678676229, 33.059294900805384]],
    [ "SRP Quail Substation",[-111.49290531255205, 33.16246263069227]],
    [ "542843362",[-103.1618501495384, 32.75537919779058]],
    [ "542866027",[-111.61680615487306, 33.26638840241162]],
    [ "DISTRIBUTING STATION 102",[-118.36908723290911, 34.23301481319947]],
    [ "Copper Mountain Substation",[-114.9582032864638, 35.88471981173412]],
    [ "543001018",[-74.89455983043983, 44.96122742748364]],
    [ "543001019",[-74.89244865, 44.9611745]],
    [ "543004989",[-112.85656014999999, 33.339747349999996]],
    [ "Port Nickel Substation",[-89.97057996139819, 29.86015706195543]],
    [ "543108423",[-108.39492769963992, 45.84097792788202]],
    [ "Dawsonville Substation",[-84.0397318654124, 34.3704045543297]],
    [ "Minnkota Power Cooperative",[-98.1794530749775, 47.355929710683256]],
    [ "543344745",[-104.61623750526276, 38.26672125963252]],
    [ "543406575",[-94.92334902129323, 35.71051558071466]],
    [ "Beaver Road Substation",[-82.08126993564112, 33.471490713284155]],
    [ "543522120",[-104.61901531139739, 38.17655622522596]],
    [ "Elliot Substation",[-70.81780726527073, 43.16762652438326]],
    [ "Ameren",[-90.6348751975018, 38.75757986392448]],
    [ "543653584",[-90.69995495862183, 38.83896995827627]],
    [ "543676485",[-90.78950436975765, 38.80065227756181]],
    [ "Ameren",[-90.69138355000001, 38.751990850000006]],
    [ "IP&L Substation I",[-94.39290538735591, 39.0560043554313]],
    [ "IP&L Substation N",[-94.45368422195212, 39.053049214651416]],
    [ "Raven Farm Substation",[-70.20324874768397, 43.78161512647032]],
    [ "Highridge Substation FPL",[-81.1058640632688, 29.15713536608674]],
    [ "Foothills Substation",[-114.43066412494822, 32.668906807056686]],
    [ "Desert Sands Substation",[-114.42752028789366, 32.64799612360866]],
    [ "Frederick Street Substation",[-77.12572091861908, 38.87954789822474]],
    [ "543929700",[-80.94536045756088, 35.0775929012717]],
    [ "543970691",[-96.71571691605197, 33.021821675056025]],
    [ "PSE&G",[-74.30124574994484, 40.65527551301842]],
    [ "Keyport Substation",[-74.17988502586633, 40.44212009212525]],
    [ "544217903",[-81.12802615, 34.019686050000004]],
    [ "Hatci Substation",[-83.63098393718138, 42.274073278859184]],
    [ "Raytown #1 Substation",[-94.44421345890947, 39.01410434012204]],
    [ "544358428",[-96.42309130712425, 35.31063397360094]],
    [ "544358429",[-96.52872140000001, 35.222450450000004]],
    [ "544380840",[-80.58380675000001, 35.43014565]],
    [ "IP&L Substation E",[-94.45236676407723, 39.05966161024857]],
    [ "544414488",[-87.90114689531296, 30.589665539057744]],
    [ "New Horizon Electric Cooperative, Inc.",[-80.96519473349379, 35.01941791789265]],
    [ "Oklahoma Gas & Electric",[-98.75975469996422, 36.07479595000696]],
    [ "544430666",[-98.70809937472852, 35.98166076108469]],
    [ "Matthewson substation",[-97.79233708279496, 35.728109806199946]],
    [ "544433937",[-98.04868158974699, 35.63321632497645]],
    [ "544433938",[-97.94182786923427, 35.573883711868454]],
    [ "Tayco Substation",[-88.45265039437888, 44.20642277473347]],
    [ "Clark County Substation",[-99.87683876261246, 37.46740145810499]],
    [ "Duke Energy;Sumitomo Corporation",[-99.73693713915965, 37.85369908851105]],
    [ "Ironwood Substation",[-99.73839698842897, 37.85362188281411]],
    [ "Post Rock Substation",[-99.35993847773915, 38.93212872076107]],
    [ "Post Rock Substation",[-99.36254048536573, 38.93362974854813]],
    [ "Cliffdale Substation",[-79.06432785633272, 35.049436317391056]],
    [ "Highway 401 Substation",[-79.06832045894869, 35.03273062035676]],
    [ "544593409",[-95.86956115340516, 36.199352831458135]],
    [ "544616541",[-87.91098706328351, 30.65014229825473]],
    [ "544652698",[-96.14328717138221, 41.00103314626983]],
    [ "Reno Substation",[-83.95858268459385, 42.209513780328486]],
    [ "Freedom Substation",[-83.89441851643585, 42.20737867357953]],
    [ "Fletcher Substation",[-83.97293177136899, 42.22340455567648]],
    [ "544671022",[-85.86201970533764, 39.92711813749063]],
    [ "Cedar Falls Utilities",[-92.494106781726, 42.5345229805365]],
    [ "544849855",[-90.33184208402818, 38.53239854631339]],
    [ "544869722",[-102.61386335, 38.09212409999999]],
    [ "Herndon Park Substation",[-77.37907353178784, 38.9660730708722]],
    [ "544918952",[-103.06957842514821, 46.84599135545394]],
    [ "544927235",[-96.81422444956264, 40.849320103317545]],
    [ "545072177",[-111.45544555003913, 33.0489339577058]],
    [ "MidAmerican Energy",[-95.79705365000001, 41.177315]],
    [ "Southland Substation",[-95.7974220132661, 41.174834149989856]],
    [ "545133159",[-80.90877491014007, 35.06559515334543]],
    [ "Pioneer Prairie Phase I Substation",[-92.61222753573185, 43.48258050214179]],
    [ "Duke Energy",[-80.95934692943128, 35.17475669188314]],
    [ "Westland Substation",[-85.6891792, 39.77181099999999]],
    [ "Hothouse Substation",[-84.31767651920417, 34.934548645779365]],
    [ "Cookeville Electric Department",[-85.4769101175344, 36.1858942259011]],
    [ "Swope Substation",[-94.51088968858672, 39.01473853945144]],
    [ "NV Energy",[-115.13104114865061, 36.26833311722633]],
    [ "Consumers Energy",[-83.59984723048636, 41.80732179097175]],
    [ "Monarch Substation",[-83.73438406467366, 42.20698220101955]],
    [ "Jersey Central Power and Light",[-74.87462389703506, 40.51239935614098]],
    [ "Cabot Substation",[-92.02482011923396, 34.97986963400134]],
    [ "Terrebonne Substation",[-96.13760324888318, 47.831951643290175]],
    [ "545932809",[-90.69260901771209, 40.45430080113528]],
    [ "Seven Springs Substation",[-82.68311789758762, 28.203353710078737]],
    [ "East Bay Substation",[-85.5914762, 44.75388699999999]],
    [ "546236779",[-85.65740677504691, 40.049302042981545]],
    [ "546353351",[-88.1916690584886, 40.12799487494054]],
    [ "546419321",[-99.90055334999998, 38.49337155]],
    [ "546419325",[-99.89985094512026, 38.49329352561991]],
    [ "Red Lake Falls 41.6kV Substation",[-96.27757035000002, 47.874719500000005]],
    [ "Huot Substation",[-96.3737346, 47.8623957]],
    [ "Curlew Substation",[-82.7241485972203, 28.054025338740306]],
    [ "546489206",[-99.30671690000001, 38.48639035]],
    [ "546489211",[-99.43626028661438, 38.49426569919244]],
    [ "546489227",[-99.89713949482639, 38.71878527691914]],
    [ "546491688",[-80.98846230000002, 35.044447250000005]],
    [ "546706083",[-86.02094117475221, 39.81079350196704]],
    [ "Indianapolis Power & Light",[-86.0085625819052, 39.85108774276114]],
    [ "Georgia Power",[-82.32770739761233, 31.233126016293557]],
    [ "US 521 Substation",[-80.85436193933567, 34.96456576581171]],
    [ "Moscow Substation",[-69.85612622323546, 45.166854812204924]],
    [ "Higgins Plant Substation",[-82.66240418054625, 28.00381377125561]],
    [ "Safety Harbor Substation",[-82.69739585822457, 28.000590532126605]],
    [ "546884654",[-83.921317117895, 42.60577639864586]],
    [ "Price Substation",[-83.69243498863246, 42.3057100634498]],
    [ "546936340",[-87.7746142136728, 38.398365368754725]],
    [ "546936703",[-80.1557119, 26.182414650000002]],
    [ "547016913",[-84.97556429028052, 32.52649004252757]],
    [ "Holland Bottoms Substation",[-92.0488755350593, 34.956861886480446]],
    [ "547232679",[-80.92402846754577, 35.085686451063715]],
    [ "NV Energy",[-115.18575511947337, 36.2756061059365]],
    [ "Mandolin Substation",[-82.61888300815527, 28.062512697626683]],
    [ "547379642",[-108.25634650052898, 36.7657715967199]],
    [ "Knoxville Utilities Board",[-84.0953804483002, 35.92716025988255]],
    [ "Jonesboro City Water and Light",[-90.66013176958229, 35.82215809494627]],
    [ "547543252",[-80.95650729593237, 33.97207181891832]],
    [ "Florida Power & Light",[-82.38531300162295, 27.34238871661499]],
    [ "Briant Park Substation",[-74.33399514999999, 40.71674215]],
    [ "Ashton Substation",[-111.86494489757291, 40.37198497355992]],
    [ "548159224",[-83.72774640156113, 32.61803608300628]],
    [ "Thirtyfirst Street Substation",[-78.43056534696326, 40.50616916477115]],
    [ "Sixteenth Street Substation",[-117.30435828427491, 34.12889761094618]],
    [ "Evergy",[-94.3978065, 39.150475300000004]],
    [ "Evergy",[-94.38285442122144, 39.136001794307354]],
    [ "IP&L Substation F",[-94.4652168463535, 39.10767757345092]],
    [ "548300878",[-101.70170145, 39.34137245]],
    [ "548422891",[-81.17316623699968, 33.96846153000322]],
    [ "AEP Central Substation",[-82.9999111975849, 38.738107922269705]],
    [ "548429138",[-108.57672344870797, 45.75446481299629]],
    [ "548436481",[-81.00640476366637, 34.008670240550934]],
    [ "548451929",[-81.17089495239388, 34.140330622195926]],
    [ "548462777",[-88.27528811476441, 40.07607703183918]],
    [ "548474401",[-74.35442799982546, 40.74420294631963]],
    [ "548488480",[-74.39020707222015, 41.456530395145066]],
    [ "Tiger Bay Plant Substation",[-81.85345600937505, 27.74879148485345]],
    [ "548494670",[-109.86051695215897, 34.067279837779296]],
    [ "Marion Creek Substation",[-81.55208559353356, 28.1197194127341]],
    [ "Loughman Substation DUKE",[-81.55266229550125, 28.24916720812246]],
    [ "548744714",[-85.50240987097315, 40.348355969722206]],
    [ "548794881",[-88.42622245906873, 44.25698422827103]],
    [ "Sacramento Municipal Utility District",[-121.32728773940835, 38.57743490671805]],
    [ "Sacramento Municipal Utility District",[-121.26789622014022, 38.58922766561293]],
    [ "549065506",[-85.63407818212768, 39.98157135861463]],
    [ "Overhead to Underground",[-81.28766378007273, 28.463527107313976]],
    [ "549078137",[-81.28263395, 28.3989103]],
    [ "Plymouth Substation",[-96.32942198577736, 42.59492214993551]],
    [ "Dey Road Substation",[-74.5699123100191, 40.33579077167407]],
    [ "549564195",[-81.27295744999998, 34.168763199999994]],
    [ "549601378",[-89.98301370518023, 35.266409081559615]],
    [ "549740707",[-81.10175571540854, 34.053229293033304]],
    [ "Irmo Substation",[-81.18047599619189, 34.08392673173889]],
    [ "Morgan Substation",[-84.59712135000001, 31.5415208]],
    [ "Spring Garden Substation #50",[-81.31991742488859, 29.13566609336694]],
    [ "Astor Substation",[-81.40457694254833, 29.172979588691714]],
    [ "549848492",[-96.86318463166694, 32.26452050575802]],
    [ "549848494",[-96.7558754860013, 32.2978996624227]],
    [ "549998149",[-96.89273714999999, 32.260005150000005]],
    [ "550011188",[-87.68889103968205, 40.46824155003551]],
    [ "Plymouth-Sorrento Substation",[-81.55930149133616, 28.78650573956762]],
    [ "550155618",[-81.27141850699341, 34.15168443043837]],
    [ "550156480",[-96.82753049999998, 32.60169945]],
    [ "550172015",[-81.48234008435902, 34.218878348483116]],
    [ "550174108",[-96.78156521003713, 32.58588835867459]],
    [ "Pomoria Substation",[-81.39542588392946, 34.224285147308855]],
    [ "Washington Heights Substation",[-74.40622856638313, 41.465813453754194]],
    [ "550186234",[-96.13511416816449, 33.11279613459277]],
    [ "Putnam Plant Substation",[-81.58138551648986, 29.628053011604408]],
    [ "550262271",[-78.87168699164734, 35.91499171754965]],
    [ "West Columbia Substation",[-81.07085735567617, 33.988236014731065]],
    [ "Raymore North Substation",[-94.45571559270186, 38.844011376234555]],
    [ "Georgia Power",[-81.2318596, 32.1555121]],
    [ "Dudley Substation",[-83.06093016215924, 32.54179482838785]],
    [ "Dublin Primary Substation",[-82.89451081819654, 32.540596444395106]],
    [ "Catlin Substation",[-82.83500471918022, 32.51035202118294]],
    [ "Ontario Substation",[-74.44359985691608, 39.368827629621705]],
    [ "Higbee Substation",[-74.44230005660229, 39.36591452240371]],
    [ "Missouri Substation",[-74.44296978731624, 39.36563656704444]],
    [ "550944907",[-83.94433394113985, 42.60281110733599]],
    [ "550954576",[-83.15810389573281, 40.55618829946607]],
    [ "550955393",[-80.9353017930286, 34.008769915531936]],
    [ "Meadowlake Sub",[-106.67184365822685, 34.79685920584491]],
    [ "Coit Avenue Substation",[-85.64218941676008, 43.04393035029338]],
    [ "Fulton Substation",[-85.54002867489312, 42.95957975838188]],
    [ "Primm Substation",[-115.34931530612813, 35.6409749195299]],
    [ "Kittatinny Substation",[-75.03385360349347, 40.999287613569706]],
    [ "551512258",[-80.132164871994, 26.144746388954477]],
    [ "Mansfield Substation",[-77.0810457707185, 41.809943619329395]],
    [ "Woodbury Substation",[-75.14728127408021, 39.843014472171895]],
    [ "Gatewood Substation FPL",[-81.01345708964877, 29.130095280010202]],
    [ "Mason Substation",[-81.0642105852656, 29.214229044326167]],
    [ "El Cerro Sub",[-106.6783715, 34.7749701]],
    [ "Glenolden Substation",[-75.28164849002815, 39.89945276022443]],
    [ "Alice's Road Substation",[-93.85430023151297, 41.62132630674394]],
    [ "Blackwater HVDC Tie",[-103.17520717476218, 34.30081319966321]],
    [ "Highways 141 & 44 Substation",[-93.77297784218544, 41.69404514860026]],
    [ "Richmond Substation",[-75.07722190271524, 39.9848425098324]],
    [ "Quinto Substation",[-121.06896844322512, 37.11998472624849]],
    [ "552653456",[-121.06808165433607, 37.1190031683958]],
    [ "552670137",[-81.17660802125329, 33.927843443434554]],
    [ "552670202",[-81.03217752956628, 33.89783695956063]],
    [ "Edmund Substation",[-81.20407210000002, 33.855405850000004]],
    [ "552821181",[-81.11845729999999, 33.81342395]],
    [ "Sandy Run Substation",[-81.04966610000001, 33.809212849999994]],
    [ "Virgil C. Summer Nuclear #2/3 Switching Station",[-81.32870719033531, 34.29043110485218]],
    [ "Seneca Tie Substation",[-82.97083384152336, 34.68918452767076]],
    [ "553109902",[-88.4801821698803, 44.17772603632673]],
    [ "553128549",[-80.91728420109969, 35.18056448507301]],
    [ "South Van Wert Substation",[-84.59379638198821, 40.85914268918493]],
    [ "553393483",[-84.94093182439066, 40.730988991984376]],
    [ "553393485",[-84.960148, 40.66082455000001]],
    [ "Hawaii Sugar Substation",[-156.45401150000004, 20.868842850000004]],
    [ "553651312",[-83.1880146949039, 42.12325511894118]],
    [ "553685845",[-76.09791222641603, 36.811909931763175]],
    [ "Diamond Substation",[-83.87769691571079, 42.33715866698568]],
    [ "Cypress Street Substation",[-92.70625062478426, 31.518432864594573]],
    [ "Grenada Substation",[-83.66048265, 42.3110343]],
    [ "553897906",[-80.87647427328827, 35.064366942367286]],
    [ "Carmichael Substation",[-121.32909178617386, 38.64350708688019]],
    [ "Paterson Substation",[-74.17480977482735, 40.918637779107904]],
    [ "PPL",[-76.77895195, 40.856403650000004]],
    [ "Preston Substation",[-75.8954013352401, 38.690834680096906]],
    [ "Lake Avenue 2 Substation",[-82.12620693173707, 41.410873000985674]],
    [ "Cecil Commerce Ctr North Substation JEA",[-81.89475100862761, 30.276606977409305]],
    [ "Fieldstone Substation",[-82.06510104481634, 41.34322082951948]],
    [ "Ridgeway Substation",[-78.73295002444821, 41.43760865475377]],
    [ "Ridgeway Substation",[-78.73150540267417, 41.437577946624025]],
    [ "Earl Substation",[-76.06954201067258, 40.10746661548984]],
    [ "554571819",[-93.3115531746087, 36.98766618875162]],
    [ "Tallman Substation",[-84.74836169946883, 42.807212370142665]],
    [ "Tremaine Substation",[-85.06738085435447, 42.88546336044516]],
    [ "554591631",[-93.4462270261482, 37.037867917309846]],
    [ "554591635",[-93.31016445, 37.01484695]],
    [ "Muncie II Substation",[-94.6397408968386, 39.09446704615782]],
    [ "Colgate Substation",[-94.64802432490976, 39.08587900852558]],
    [ "FIXME Substation",[-94.27664021650604, 38.674452636379705]],
    [ "Turner Road Substation",[-94.52914086352341, 38.82354626668674]],
    [ "Evergy",[-94.4986083581526, 38.61721992394241]],
    [ "554644788",[-80.7242534, 33.94040210000001]],
    [ "554650082",[-80.98605902031056, 33.98727148062855]],
    [ "Swan Lake Road Substation",[-92.16613784967531, 46.82624343169203]],
    [ "Kelloggsville Substation",[-85.66492001887637, 42.87173744230315]],
    [ "Kentwood Substation",[-85.61512860040011, 42.87272044993676]],
    [ "Paramount Substation",[-85.58494326458043, 43.028475234397376]],
    [ "Stonegate Substation",[-85.73491899786943, 42.90342707816662]],
    [ "Millersville Substation",[-76.3506157, 39.99392985000001]],
    [ "554886395",[-76.3500860600042, 39.9944569706316]],
    [ "554934706",[-81.02934595441018, 34.02469743115855]],
    [ "Jonesboro City Water and Light",[-90.67653584999998, 35.830053]],
    [ "Mopar Substation",[-82.9774057, 42.38068594999999]],
    [ "555004737",[-115.11963470081066, 36.027156640460824]],
    [ "Don Pasqual Sub",[-106.740629051099, 34.81094597926517]],
    [ "555029765",[-93.30048004999998, 36.87081175]],
    [ "555029766",[-93.3103139747245, 36.85398944330516]],
    [ "555051856",[-93.71509754999998, 37.130765649999994]],
    [ "555051892",[-93.84701625575615, 36.90539664210265]],
    [ "Jasper County Substation",[-93.02317409054247, 41.75969533722093]],
    [ "Laurel Substation",[-92.94269008052412, 41.890014804857955]],
    [ "555340585",[-93.16073345000001, 37.152210800000006]],
    [ "Nixa North",[-93.29461097506609, 37.05425559307152]],
    [ "555341579",[-93.01381994396004, 37.11780964207313]],
    [ "555547552",[-81.01298028300454, 33.82066905675503]],
    [ "Fern Ridge Substation",[-123.35220532296569, 44.02902550342116]],
    [ "555814546",[-80.74328395795366, 33.869848869696405]],
    [ "555820082",[-81.01847950445463, 33.86020894234721]],
    [ "Green Cove Springs Substation #18 CLAY",[-81.69564947303432, 29.954200244332355]],
    [ "Georgia Power",[-84.60832656398046, 32.16115923730041]],
    [ "555850831",[-84.60798438332891, 32.161631493235575]],
    [ "Midwest Grain",[-95.13347135821422, 39.56166467292026]],
    [ "Northeast Substation",[-84.5338159272248, 42.75596982204266]],
    [ "North Ogdensburg Station",[-75.44021445426435, 44.71399176707026]],
    [ "Ogdensburg Station",[-75.49446393842888, 44.692324231672714]],
    [ "556203934",[-83.96170356871002, 39.295875881505125]],
    [ "556317992",[-89.09802278142459, 35.71290428038856]],
    [ "Hazel Substation",[-96.05452727494801, 48.022731903394934]],
    [ "556341572",[-78.2619819, 33.929757499999994]],
    [ "556509734",[-80.5204576, 38.078908500000004]],
    [ "Clay Center Public Utilities",[-97.1079009193199, 39.363576787429324]],
    [ "Florida Power & Light",[-81.73623493154157, 24.569577778729013]],
    [ "DTE Energy",[-83.16167462575899, 43.88299025681801]],
    [ "DTE Energy",[-83.11832263677385, 43.812515514931704]],
    [ "Grassmere Substation",[-83.11860627215232, 43.8116373569676]],
    [ "Rapson Substation",[-82.86906186586394, 43.82953223190206]],
    [ "Banner Substation",[-82.79932011151055, 43.38599034607536]],
    [ "Fitz Substation",[-82.70508433807123, 42.91920846660865]],
    [ "DTE Energy",[-82.75857741865137, 43.67017403566259]],
    [ "556879910",[-82.6986932359175, 43.67264722539761]],
    [ "Michigan Two Substation",[-82.78362318211994, 43.64272021062532]],
    [ "Bauer Substation",[-83.69161540908199, 43.369228902257966]],
    [ "Delhi Substation",[-83.49724625845967, 43.623035945244474]],
    [ "Union Substation",[-83.52764859856285, 43.621197891381584]],
    [ "556910768",[-83.56814174209086, 43.516759318713234]],
    [ "Gilford Junction Substation",[-83.56498481290883, 43.47391685910611]],
    [ "557017406",[-116.36594599400095, 36.67008350056663]],
    [ "557071286",[-86.53346192606395, 45.79571610324879]],
    [ "Mackinac Substation",[-84.77847478481321, 45.78750072563882]],
    [ "Lake Winds Substation",[-86.39675788191232, 43.88039308113072]],
    [ "Amber Substation",[-86.37994874631279, 43.95203251615846]],
    [ "Michigan Power Substation",[-86.42426936044244, 43.939636821791645]],
    [ "Riverton Substation",[-86.36436194611676, 43.905937245158]],
    [ "Donaldson Creek Substation",[-86.32190192049408, 43.688110710295454]],
    [ "Weare Substation",[-86.35812205, 43.764636]],
    [ "Eden Substation",[-86.26862683872417, 43.87595284204134]],
    [ "Stickney Substation",[-86.29379100080261, 43.95300484790469]],
    [ "Carroll Electric Cooperative Corporation",[-94.19426209996925, 36.47597636665283]],
    [ "North Carthage",[-75.58433808493709, 43.98947604212018]],
    [ "IP&L Substation B",[-94.42263975560194, 39.08044650095572]],
    [ "Riggsville Substation",[-84.60847876654755, 45.55509343895182]],
    [ "557486764",[-80.84906146504241, 33.883172245293466]],
    [ "557502152",[-80.93400994999999, 33.94390795]],
    [ "Sand Hill Substation",[-89.27093859059534, 31.61757472235584]],
    [ "557769140",[-80.91725396737966, 33.94363090174501]],
    [ "Pellston Distribution Substation",[-84.87257849865644, 45.59346316580836]],
    [ "Cross Village Substation",[-85.03754554229646, 45.61621910818719]],
    [ "Cheboygan Substation",[-84.50788389452377, 45.612315631036225]],
    [ "Posen Substation",[-83.64238437486677, 45.245096306365404]],
    [ "Utsey Road Switching Station",[-81.7812319125745, 30.394554409715145]],
    [ "Harbor Substation",[-84.92077320658741, 45.46370633178158]],
    [ "Boyne City Substation",[-84.95582317963914, 45.242533279148084]],
    [ "Wilson Substation",[-84.98004549999997, 45.204482399999996]],
    [ "Hayes Substation",[-85.12800655384834, 45.34998817687587]],
    [ "Petoskey Distribution Substation",[-84.88604914627383, 45.363298296337405]],
    [ "Greenville Substation",[-75.57162133296949, 41.633006404343774]],
    [ "Public Utility District 1",[-123.69675804999721, 46.97022571955781]],
    [ "Juno Substation",[-84.19487065717763, 34.473842981615086]],
    [ "Pecan Park Substation JEA",[-81.58289137121672, 30.505418334562904]],
    [ "Elmira Substation",[-84.83549524281193, 45.059892686001014]],
    [ "Salome Substation",[-113.59340093996005, 33.77178557203341]],
    [ "558696302",[-87.44312517228373, 41.51809379113782]],
    [ "Pigeon River Substation",[-84.55424452424337, 45.323002232151694]],
    [ "Rondo Substation",[-84.60758846103832, 45.31858357917052]],
    [ "Waterleaf Substation JEA",[-81.48820950000001, 30.336236749999998]],
    [ "558947932",[-80.9682588091987, 34.18992659165958]],
    [ "Matawan Substation",[-74.22557654410345, 40.412282691075276]],
    [ "Deerwood Substation JEA",[-81.52170079711489, 30.235264782754673]],
    [ "559195301",[-109.85585150968707, 40.27083492453002]],
    [ "Public Utility District #1",[-124.10868211559979, 46.899792256155116]],
    [ "Petoskey Substation",[-84.96418255, 45.3648078]],
    [ "Baymeadows Substation JEA",[-81.5770497778765, 30.235017999630674]],
    [ "559345516",[-111.9342921699227, 33.756222576640596]],
    [ "559584067",[-111.0525194226771, 45.67152916464237]],
    [ "Consumers Energy",[-84.03875772027561, 42.27224313689208]],
    [ "Sigel Substation",[-82.78419314582857, 43.850767722726026]],
    [ "Laurens Substation",[-82.00155110641515, 34.510640303866204]],
    [ "559640220",[-82.00382916350809, 34.50824414528182]],
    [ "San Luis Substation",[-114.76038840569721, 32.49744652479407]],
    [ "Consumers Energy",[-83.9156562, 43.4875547]],
    [ "559781504",[-78.94987821825401, 34.02440906839453]],
    [ "Coggins Substation",[-83.9662139254167, 43.816806994925045]],
    [ "Fraser Pumping Substation",[-83.96588613797385, 43.817961775199464]],
    [ "Pinconning Substation",[-83.96534017448688, 43.850007757299196]],
    [ "559843254",[-81.58157120000001, 35.032724699999996]],
    [ "559843255",[-81.58121112128956, 35.0324965710433]],
    [ "Leland Substation",[-83.70493614557128, 42.299133813369224]],
    [ "559916526",[-84.53899376256228, 32.36797733493217]],
    [ "559941373",[-85.10868075, 41.084557450000005]],
    [ "Seward Substation",[-83.71178765, 42.30457355000001]],
    [ "559987475",[-85.25430218899403, 41.027828074981436]],
    [ "Airport SW Substation",[-110.95795054945611, 32.111080532951654]],
    [ "Canisteo Substation",[-93.45187139601302, 47.30154717536142]],
    [ "South Rio del Oro Sub",[-106.70909716855186, 34.721845416081464]],
    [ "Carroll Electric Cooperative Corporation",[-94.30125580356312, 36.45105022906179]],
    [ "Black Lake Distribution Substation",[-84.2682080248936, 45.403947287059076]],
    [ "Hawks Substation",[-83.88654706054822, 45.29575277538158]],
    [ "Millersburg Substation",[-84.06903177382034, 45.32665471457224]],
    [ "White Hill Substation",[-76.93053259999999, 40.22657795]],
    [ "Fleming Substation",[-83.36276257795849, 42.085252547887784]],
    [ "560564466",[-102.4518637329225, 47.98203717504497]],
    [ "Redondo Substation",[-114.49505699956468, 32.6852634398312]],
    [ "Blackwater",[-79.14452180089063, 37.41941478162458]],
    [ "South Goshen Substation",[-74.33893091026555, 41.388890016027226]],
    [ "Lovells Substation",[-84.43213740000002, 44.71669165]],
    [ "Clear Lake Substation",[-95.12648454936017, 29.60836550055782]],
    [ "Fingerboard Substation",[-84.44728264334489, 45.37646176568395]],
    [ "Doerun Substation",[-83.91097744999999, 31.310095800000003]],
    [ "Fayetteville Public Works",[-78.92223258771301, 35.0905567367995]],
    [ "561030980",[-80.07941824031771, 41.15981346165476]],
    [ "South Bremerton Substation",[-122.69145836224793, 47.53740616864138]],
    [ "561094058",[-74.35339304999998, 40.71590369999999]],
    [ "Bates Substation",[-83.70229450000001, 42.2988028]],
    [ "561145769",[-84.0006612, 30.82730655]],
    [ "561171312",[-82.87097584517323, 40.259078611512535]],
    [ "EMU Coral Substation",[-83.63098585212504, 42.25555720842059]],
    [ "Paulding Putnam TR 14 Substation",[-84.92268430000001, 41.0727985]],
    [ "Johnston Substation",[-93.71469957849287, 41.66811217871228]],
    [ "561430079",[-124.15798459310874, 47.04498334824656]],
    [ "561577219",[-97.5466872313373, 33.17787634629455]],
    [ "Fuller Substation",[-83.7013963978229, 42.2778651171438]],
    [ "Entergy Arkansas",[-93.1125577, 34.4899506]],
    [ "Bagley Substation",[-84.68412956256883, 45.02112032671834]],
    [ "Peetz Table Wind Energy Center South Substation",[-103.24704161637159, 40.92086338634686]],
    [ "562243101",[-103.89809916083867, 40.84728845147029]],
    [ "Lyndonville Substation",[-71.99366166026226, 44.53469190611983]],
    [ "Paul Substation",[-83.56196099618364, 42.22500015164694]],
    [ "Seminole Electric Cooperative, Inc",[-81.958514275179, 27.64011776908542]],
    [ "Seminole Electric Cooperative, Inc",[-81.96090155239126, 27.64076868369697]],
    [ "Chapman Junction Switching Station",[-97.01645304616028, 39.0029119415471]],
    [ "North Canal Substation",[-72.59722240291559, 42.19972838258827]],
    [ "Champlin Substation",[-93.41154705000001, 45.187529100000006]],
    [ "Sheffield Substation",[-72.1228854485663, 44.66358551329183]],
    [ "562949233",[-80.85550117363023, 35.21494745249581]],
    [ "Yorkshire Substation",[-112.12618734962695, 33.66258374190142]],
    [ "Berlin Substation",[-74.93595769143985, 39.79739635651589]],
    [ "Atco Substation",[-74.9015235913161, 39.77930054340574]],
    [ "Buxton Substation",[-97.04727285576165, 47.59916101196815]],
    [ "Providence Canyon Substation",[-84.89507384699934, 32.06668768053034]],
    [ "Diekemper Substation",[-101.40779769999997, 33.218780249999995]],
    [ "Garza Substation",[-101.3904977612296, 33.1862720813783]],
    [ "Graham Interchange",[-101.40805969238116, 33.18667272746106]],
    [ "Stowe Substation",[-72.69819666913556, 44.45920185090458]],
    [ "564425902",[-95.56857351105536, 33.65500023031321]],
    [ "Randolph EMC",[-79.68199970072511, 35.63250610486054]],
    [ "Barnesville Primary Substation",[-84.20125818416608, 33.032069427069]],
    [ "564841008",[-90.59434326255656, 38.756347416300635]],
    [ "North Thomaston Substation",[-84.31090279123175, 32.92858727256365]],
    [ "Algoma Substation",[-85.66254069823903, 43.18761791952047]],
    [ "Gregory Substation",[-84.05419794860686, 42.64937821428978]],
    [ "564945376",[-114.40338249999998, 42.59752435]],
    [ "Gilbert Substation",[-83.36623335087967, 42.25195360392751]],
    [ "Keller Rd Substation",[-81.74913824975472, 27.7036822265078]],
    [ "Morocco Substation",[-83.77018953228732, 41.839975155183744]],
    [ "Holtec Substation",[-75.1185823127379, 39.91323031541888]],
    [ "565647198",[-111.59974476212079, 33.27833365981669]],
    [ "565647200",[-111.58414171945665, 33.29233864564432]],
    [ "565647202",[-111.58429965851944, 33.28424038311077]],
    [ "SRP Webber Substation",[-111.55868266139402, 33.16115191582628]],
    [ "SRP Queen Creek Substation",[-111.54920715697725, 33.24963889949482]],
    [ "565969275",[-83.69170851666571, 42.49204428075059]],
    [ "Everett Substation",[-94.6825541035776, 39.1196542373222]],
    [ "West County Energy Center Unit #1 FPL",[-80.37612520126191, 26.702895837964757]],
    [ "Singing River Electric Cooperative",[-88.51931712982329, 31.004777439041277]],
    [ "566854785",[-114.94639553619182, 35.99732370359281]],
    [ "Harriman Substation",[-74.14438484707607, 41.31648475883794]],
    [ "Sugarloaf Substation",[-74.25841841490306, 41.30809762218237]],
    [ "Middleville Substation",[-85.45601916335997, 42.71835117514653]],
    [ "00 Substation",[-88.3047614517395, 44.287544721303036]],
    [ "Sheldon Substation",[-83.486311850504, 42.26357360431416]],
    [ "567612415",[-115.11530538325133, 36.17443323963993]],
    [ "567915814",[-94.10610122448328, 33.644762688422105]],
    [ "Huntington Substation",[-94.5742707750347, 31.268900103927095]],
    [ "568403780",[-97.59136571688077, 35.639137795286075]],
    [ "Segreto Substation",[-86.29320792439347, 42.316878373742355]],
    [ "568558792",[-88.47412949677482, 44.156932443975904]],
    [ "Slabotwn Substation",[-77.47374264149585, 38.22454652596665]],
    [ "Cranes Corner Substation",[-77.455847529763, 38.35358350348378]],
    [ "Nacogdoches North Substation",[-94.65420832408566, 31.651657725152152]],
    [ "Salopek Substation",[-106.73118063581876, 32.24659559636831]],
    [ "568594069",[-94.17890109458665, 31.760348669006742]],
    [ "568601937",[-94.1710940461496, 31.802862517697392]],
    [ "568601938",[-94.17162092382364, 31.801737415505382]],
    [ "Doña Ana Substation",[-106.7786059165386, 32.34168787065391]],
    [ "569126451",[-114.23549195, 35.19116365]],
    [ "569126456",[-114.17307844784148, 35.35517623388643]],
    [ "569149510",[-114.16903617525931, 35.7063163947605]],
    [ "Lallendorf Substation",[-83.4422941513625, 41.668730900079886]],
    [ "569162458",[-83.4419526682715, 41.66721204356106]],
    [ "569162461",[-83.44192504373231, 41.66792291133578]],
    [ "Blackberry Substation",[-94.60954662068457, 37.33222649062145]],
    [ "569474703",[-95.24835598943346, 36.32106988004027]],
    [ "Consumers Energy",[-84.71368954999998, 42.169299599999995]],
    [ "Rockland Street Substation",[-70.8613916860475, 42.251771832363644]],
    [ "Plymouth Street",[-70.9260231876334, 42.10050873476699]],
    [ "North Abington Substation",[-70.93452805000001, 42.126258899999996]],
    [ "Plain Street Substation",[-70.9992603497905, 42.19704528292953]],
    [ "Church Hill Substation",[-71.019784287478, 42.22227330759657]],
    [ "Middle St Substation",[-70.99526232438575, 42.22383080084183]],
    [ "570021313",[-95.34703605643516, 35.72494080185751]],
    [ "570021314",[-95.47252550228038, 35.43430769458606]],
    [ "City Limits Substation",[-88.4030224424558, 44.23646658340708]],
    [ "570060559",[-86.69522563985092, 34.70569007539844]],
    [ "NV Energy",[-115.14046321222706, 36.229087987067984]],
    [ "570122979",[-84.75009071200053, 41.120703218285854]],
    [ "Timber Switching Station",[-84.75703947138445, 41.018166881400106]],
    [ "Logtown Switching Station",[-84.75941920283006, 41.0183935868832]],
    [ "Phillips Lane Substation",[-70.87095427668291, 42.11445609110432]],
    [ "Corporate Drive Substation",[-73.98774194550795, 41.03860755922476]],
    [ "Blue Hill Substation",[-74.00871438780852, 41.048531175773434]],
    [ "Sparkill Substation",[-73.92807461038522, 41.03170463852319]],
    [ "Orangeburg Substation",[-73.94854392913304, 41.04974662286579]],
    [ "Snake Hill Substation",[-73.96321588584897, 41.104076553039555]],
    [ "Stoney Point Substation",[-73.9941030549553, 41.22892796043566]],
    [ "Sloatsburg Substation",[-74.19048797949115, 41.15747891861103]],
    [ "Boyd Substation",[-80.16460340842356, 26.26890577480276]],
    [ "STOUGHTON EAST",[-89.2064369200907, 42.91545157685626]],
    [ "STOUGHTON",[-89.20578191408526, 42.91502123736794]],
    [ "Wallace Substation",[-71.04311093659867, 42.51255957636703]],
    [ "570566021",[-112.15140805500508, 33.88328375517021]],
    [ "Highlands Park Substation",[-85.56541025023822, 36.13411496330777]],
    [ "570716969",[-98.97917050694552, 32.39117503005316]],
    [ "570988655",[-97.12584680743153, 36.57986967502714]],
    [ "Peggy's Pinch Substation",[-78.91277865535258, 37.91903686857279]],
    [ "571341531",[-94.97309305000002, 42.894263349999996]],
    [ "Walton Substation",[-83.29630060761227, 42.677377420855514]],
    [ "Tienken Substation",[-83.15215586591705, 42.69575314442377]],
    [ "571682559",[-123.33891595, 40.3783515]],
    [ "Sacramento Municipal Utility District",[-121.33508922728127, 38.402092822021686]],
    [ "Sedge Hill Substation",[-78.92419605928443, 36.78404402484457]],
    [ "Cloverdale East Substation",[-79.89323838918233, 37.375523491077836]],
    [ "Otis Substation",[-70.5789041, 41.718903649999994]],
    [ "Pave Paws Substation",[-70.54578714396958, 41.751834002909135]],
    [ "Rolf Substation",[-80.17319148109569, 26.720120996935652]],
    [ "572482815",[-93.18212383949304, 39.098720429763205]],
    [ "572492285",[-78.87326832492302, 35.92945926451159]],
    [ "Walnut Avenue Substation",[-79.9385255825007, 37.25814721355622]],
    [ "Roanoke Electric Steel Substation",[-79.99914571438275, 37.27560324157301]],
    [ "572701842",[-79.9821847812065, 37.273196547725405]],
    [ "Mud Lick Substation",[-79.99873038688374, 37.264624126737026]],
    [ "Seventh Street Substation",[-79.95463591917951, 37.27258261912645]],
    [ "Wasena Substation",[-79.95747282816333, 37.262280595272]],
    [ "Melrose Substation",[-79.9756250053456, 37.28664753418724]],
    [ "Lukens Substation",[-79.94158966601357, 37.28587368310111]],
    [ "Campbell Avenue Substation",[-79.92907864661888, 37.27320788024799]],
    [ "Blairville Substation",[-84.2927769663377, 38.99327307227109]],
    [ "Roberts Substation",[-110.75162585948392, 32.25407299742934]],
    [ "Spanish Trail Substation",[-110.77181152612926, 32.18870315004115]],
    [ "Snyder Substation",[-110.83637790000002, 32.296090549999995]],
    [ "Pantano Substation",[-110.82296843398116, 32.18930684222751]],
    [ "572953728",[-110.90951649346421, 32.18103347517725]],
    [ "Security Substation",[-95.29483465754264, 30.322129232556918]],
    [ "Jayhawker Creek Company Substation",[-95.15877406460717, 30.3223271711689]],
    [ "Cedar Hill Substation",[-95.40490495, 30.226777950000006]],
    [ "Mallard Substation",[-95.35185154999999, 30.265976450000004]],
    [ "Forest Substation",[-95.4474475, 30.206132349999997]],
    [ "Crystal Substation",[-95.38712878458956, 30.321199625176423]],
    [ "Sheawill Substation",[-95.45386552752583, 30.425591749098654]],
    [ "Caney Creek Substation",[-95.45329691012617, 30.426782554918304]],
    [ "Peach Creek Substation",[-95.32811685, 30.41587485]],
    [ "LNG Substation",[-95.52213577031283, 30.444082953255712]],
    [ "Lewis Creek 230 kV Substation",[-95.52011525, 30.440082900000004]],
    [ "Lacon Substation",[-95.52246285548972, 30.437841718143908]],
    [ "Longmire Substation",[-95.50775795001626, 30.33699966719899]],
    [ "Woodhaven Substation",[-95.55620124070259, 30.31947593974422]],
    [ "Panorama Substation",[-95.51752660096228, 30.374674112598697]],
    [ "Egypt Substation",[-95.51507235, 30.39222105]],
    [ "Ponderosa Substation",[-95.4927416, 30.29927295]],
    [ "Deer Lake Substation",[-95.62534753668702, 30.311433276216842]],
    [ "Sandy Substation",[-95.72722569439362, 30.59747702320733]],
    [ "Springwood Substation",[-95.44038817571416, 30.086205764081246]],
    [ "Latson Substation",[-83.87802120928949, 42.725411601048535]],
    [ "Sedalia East Substation",[-93.20418804677813, 38.723645422864344]],
    [ "Town of Bedford",[-79.48972399881558, 37.34595516682053]],
    [ "Belton City Substation",[-94.5351330834266, 38.817578216110256]],
    [ "Caniff Station",[-83.04305645569757, 42.4044925057765]],
    [ "574226761",[-79.92415850000002, 36.9249806]],
    [ "Marconi Substation",[-97.39712211284119, 26.092120474964883]],
    [ "574916644",[-123.8125557134399, 46.99313040481885]],
    [ "Klemp Substation",[-94.90840834420577, 30.03369589061357]],
    [ "Exposaic Substation",[-94.90871105, 30.03650765]],
    [ "Rolke Road Substation",[-94.89802351369005, 30.03200450427411]],
    [ "Entergy",[-94.8905431253643, 30.03549613493358]],
    [ "Huffman Substation",[-94.99553823514003, 30.104094895049343]],
    [ "Eastgate Substation",[-95.01299186666665, 30.050553266666665]],
    [ "Apollo Substation",[-95.1447786237327, 30.180938611298732]],
    [ "Johnstown Substation",[-95.2870343, 30.214887399999995]],
    [ "Entergy",[-95.25300892945273, 30.201132143339464]],
    [ "575082645",[-86.25336428106043, 39.732611450062095]],
    [ "575102176",[-88.17623912206611, 30.690487737959813]],
    [ "575183650",[-111.57081922136635, 35.22644034999998]],
    [ "Central Virginia Electric Cooperative",[-78.25220490000002, 37.9842683]],
    [ "Regent Substation",[-83.71011964241637, 42.25765029139985]],
    [ "Gladstone Substation",[-81.7305931137576, 41.476940619553076]],
    [ "575662856",[-81.46014826086116, 31.228714575088965]],
    [ "Georgia Power",[-84.40907804999999, 33.64036254999999]],
    [ "Covanta Pinellas Plant Substation COVA",[-82.67364898533629, 27.872556955342816]],
    [ "Memphis Light, Gas and Water",[-90.06314027538099, 35.1154178464516]],
    [ "Georgia Power",[-84.40727607261407, 33.63865600095953]],
    [ "576093738",[-100.39071165781786, 38.83702435358757]],
    [ "576608785",[-102.9673923, 31.52340665]],
    [ "Airport Substation",[-123.48801549054433, 48.10506836337102]],
    [ "Brighton Substation",[-83.78320490633755, 42.5277950634225]],
    [ "22nd Street Substation",[-110.89876354735654, 32.20877512066198]],
    [ "Alvernon Substation",[-110.91056591431344, 32.20582844825335]],
    [ "Pueblo Gardens Substation",[-110.92730474073538, 32.191836091131]],
    [ "Fair Street Substation",[-110.96072779557733, 32.175984817613674]],
    [ "35th Street Substation",[-110.96361958085443, 32.19377360614079]],
    [ "21st Street Substation",[-110.95212514459303, 32.20791582503561]],
    [ "Warehouse Substation",[-110.94119144999998, 32.20972195]],
    [ "Country Club Substation",[-110.92625884188122, 32.23705273014544]],
    [ "El Con Substation",[-110.91725448773923, 32.22638752076681]],
    [ "Swan Substation",[-110.89284066950562, 32.220805005577695]],
    [ "577573224",[-80.6566326779565, 28.58235986017586]],
    [ "Craycroft-Helen Substation",[-110.87497799438626, 32.23693975221893]],
    [ "Tucson Electric Power",[-110.90741193908092, 32.159176852703624]],
    [ "Irvington Substation",[-110.90667336098079, 32.16015791064888]],
    [ "Provo City Power",[-111.69434232427835, 40.24186891656718]],
    [ "Tucson Electric Power",[-110.85879355096078, 32.182909901512]],
    [ "Maddox Creek Substation",[-84.56063215257818, 40.928343954217425]],
    [ "Tucson Electric Power",[-110.86337247310114, 32.217392581666786]],
    [ "North Alvernon Substation",[-110.90940790869, 32.238628382225116]],
    [ "Tucson Electric Power",[-110.94283657337726, 32.1031740787682]],
    [ "Kalarama Substation",[-85.61178972503936, 42.226167639281]],
    [ "Twelfth Street Substation",[-85.65834800519839, 42.22529733458735]],
    [ "Weeds Lake Substation",[-85.7680492980697, 42.26586998442631]],
    [ "Tucson Electric Power",[-110.97835023354351, 32.15613729858416]],
    [ "Carroll Electric Cooperative Corporation",[-94.37358185, 36.468897250000005]],
    [ "Tilden",[-87.65407730956623, 46.43955454326633]],
    [ "U. of A. Medical School Substation",[-110.94938645557471, 32.241870967544386]],
    [ "King Street Unit 18",[-70.82101217377361, 42.23141301882495]],
    [ "North Scituate Unit 65",[-70.79255632101389, 42.21691794401129]],
    [ "Metro Substation",[-88.40312662535932, 44.26339205292983]],
    [ "578213819",[-86.82876324076821, 35.86188503044389]],
    [ "Tucson Electric Power",[-110.96066963276073, 32.164815707380605]],
    [ "578258806",[-81.03153525148429, 35.23689899183649]],
    [ "Van Buren Substation",[-110.86911343492906, 32.246908868268406]],
    [ "Grant Substation",[-110.89994849586822, 32.250276839086]],
    [ "Facebook Data Center",[-97.26168235876392, 32.98572170772219]],
    [ "578393558",[-120.86790143705774, 44.284434749922404]],
    [ "578393559",[-120.8751391979942, 44.28399148518134]],
    [ "Morrow Flat Substation",[-119.62039282978597, 45.84846328095689]],
    [ "578399039",[-119.63294730560618, 45.85178757495858]],
    [ "Smith's Mill Substation",[-82.75001520221538, 40.09570877414019]],
    [ "578427828",[-77.23965265, 37.4980543]],
    [ "Elko Substation",[-77.23748367551923, 37.47722400570215]],
    [ "White Oak Substation",[-77.2471189345516, 37.48611001635578]],
    [ "Google Substation",[-84.58367086677144, 33.75114446611737]],
    [ "Kawailoa Mauka Substation",[-158.053480531164, 21.614000998326624]],
    [ "Tucson Electric Power",[-111.04805835963872, 32.238233060870876]],
    [ "Tucson Electric Power",[-110.95302394651529, 32.229665195916404]],
    [ "New Tucson",[-110.70794527238266, 31.991883124070014]],
    [ "579055969",[-88.45287185, 44.473342599999995]],
    [ "Kantor Substation",[-111.03549204778088, 31.697744986593197]],
    [ "Tucson Electric Power",[-111.01216110699119, 32.155456955823]],
    [ "Tucson Electric Power",[-110.99540345, 32.089919800000004]],
    [ "Tucson Electric Power",[-111.03653787808165, 32.14157657373186]],
    [ "Western Area Power Administration",[-111.0891014, 32.16588545000001]],
    [ "Sprint Substation",[-94.66246475350707, 38.91696379672717]],
    [ "Waverly Substation",[-74.31512082465584, 40.70401921883924]],
    [ "Greeneville Light and Power System",[-82.76303049999999, 36.170650300000005]],
    [ "Brawley Substation",[-111.22856986499312, 32.2532974306293]],
    [ "CAP Sandario Substation",[-111.24598830663562, 32.30232787040953]],
    [ "Tucson Electric Power",[-111.09463863742063, 32.17187507746846]],
    [ "Tucson Electric Power",[-111.09751451480322, 32.17786405728827]],
    [ "579494876",[-86.37413627697974, 32.30517005138108]],
    [ "Amelia North Substation",[-94.23464645, 30.079219600000005]],
    [ "New Long John Substation",[-94.9254239, 30.120014450000003]],
    [ "Tarkington Substation",[-94.97116727637871, 30.23904736333718]],
    [ "Splendora Substation",[-95.13886264163486, 30.2188476138933]],
    [ "Cleveland Substation",[-95.0862111635566, 30.329094185735308]],
    [ "Batiste Creek Substation",[-94.681619254222, 30.232893409485143]],
    [ "China Substation",[-94.3739304727433, 30.045397072102748]],
    [ "579500911",[-94.4901240248568, 29.935147955945343]],
    [ "Petry Woods Substation",[-94.48536895, 30.0103015]],
    [ "Devers Marsh Substation",[-94.58007748438426, 29.97275053676104]],
    [ "579532837",[-81.21570212209724, 34.12638745896876]],
    [ "Lamesa Solar Substation",[-101.93622993624577, 32.719500728235666]],
    [ "Riggins Substation",[-102.8510042067572, 31.054393674684643]],
    [ "Garver Substation",[-84.35333190051615, 39.46716356912762]],
    [ "Cañez Substation",[-111.00204313553411, 31.508400697441523]],
    [ "Sonoita Substation",[-110.97478315727636, 31.46756051524742]],
    [ "Valencia Substation",[-110.9313101822388, 31.36327411391739]],
    [ "Upton County Solar 2 Substation",[-102.29616273838433, 31.254195975250557]],
    [ "Upton County Solar 1 Substation",[-102.2888950117927, 31.248928074983993]],
    [ "Castillo Substation",[-102.30618150995747, 31.253741424960083]],
    [ "579833175",[-84.43811973680174, 39.24890375411219]],
    [ "579833176",[-84.4414809, 39.2434463]],
    [ "579839037",[-86.00771748516657, 41.73364351971452]],
    [ "Tucson Electric Power",[-110.97581697177428, 32.13005365297633]],
    [ "Avra Valley Substation",[-111.30311673435375, 32.31974393560001]],
    [ "Olsen Substation",[-110.94130269960898, 32.21846897810502]],
    [ "579959881",[-98.9976821, 38.87153489999999]],
    [ "579986229",[-83.17697798299427, 39.712268545115066]],
    [ "Dermott Wind Substation",[-101.00970322101628, 32.86385438125864]],
    [ "Fluvanna Wind 1 Substation",[-101.09463169133026, 32.88608387533839]],
    [ "Hillcrest Substation",[-83.90778397069082, 39.07671691205979]],
    [ "580150687",[-116.10962621592334, 37.16382882011038]],
    [ "Post Rock Wind",[-98.29945755, 38.84071265]],
    [ "Santa Cruz Substation",[-97.53476499249228, 27.58899352503534]],
    [ "Tucson Electric Power",[-110.92769680223856, 32.33330522990607]],
    [ "Tucson Electric Power",[-110.90585513270793, 32.323192815323196]],
    [ "580333360",[-122.50603730792766, 47.149462064049594]],
    [ "580608806",[-81.11214234999998, 33.28360125]],
    [ "Bruenning's Breeze Substation",[-97.6553738402326, 26.522161075223785]],
    [ "580835592",[-82.341456484707, 40.018117951448126]],
    [ "580848338",[-99.43745582506651, 38.471286958406125]],
    [ "Florida Power & Light",[-81.75904126466754, 26.959484374873032]],
    [ "Sanderson Substation",[-85.22167083646973, 43.17848735801962]],
    [ "Sheridan Substation",[-85.07393999148078, 43.2035124109585]],
    [ "Saugatuck Substation",[-86.19069449600987, 42.65291359946598]],
    [ "DTE Garfield Substation",[-83.0483143, 42.35943425]],
    [ "581017633",[-82.95682864999999, 43.622230349999995]],
    [ "Grissom Substation FPL",[-80.80312538675787, 28.49409614496054]],
    [ "Shelby Substation",[-83.00347895064967, 42.66924150158665]],
    [ "Tennessee Valley Authority",[-85.82920134999999, 36.097795700000006]],
    [ "581419027",[-80.80655408341536, 28.52986310042581]],
    [ "581419028",[-80.80653262577898, 28.528792456968237]],
    [ "Frost Substation",[-84.78445869143111, 44.13260477532784]],
    [ "581669230",[-77.9370503657427, 34.23313475118563]],
    [ "Station 83",[-77.59690835688271, 43.11873984428193]],
    [ "Arctic Substation",[-83.18999699876494, 42.28908162155158]],
    [ "City of Larned",[-99.10146975, 38.17608245000001]],
    [ "Green Pastures Wind Substation",[-99.42078730567411, 33.64455172799446]],
    [ "Macomb Substation",[-82.91489995066367, 42.63631579200625]],
    [ "Baylor Switching Station",[-99.04725140000001, 33.68904955]],
    [ "Seymour Basin Substation",[-99.03939390000001, 33.597378649999996]],
    [ "Brazos Electric",[-99.17971415000001, 33.5439038]],
    [ "Lake Kemp Substation",[-99.14335857662003, 33.74238637285675]],
    [ "Bomarton Substation",[-99.42851805000001, 33.5111099]],
    [ "Seymour Substation",[-99.26377227471319, 33.58871689323516]],
    [ "Adams Tap Substation",[-110.16656189205217, 31.99904512900228]],
    [ "Adams Substation",[-110.16652612447963, 31.99832569278329]],
    [ "New Barksdale Substation",[-100.07916210136624, 29.765505082673716]],
    [ "Macedonia Substation",[-95.80990038558727, 30.159704417240782]],
    [ "Seaway Substation",[-95.92629718877185, 30.156013867615847]],
    [ "Sunnyside Substation",[-96.05262619152383, 29.914679089139486]],
    [ "Waller Substation",[-95.92641606654212, 30.04826742633585]],
    [ "Quanex Substation",[-96.21247425, 29.902081649999996]],
    [ "Prairie View Substation",[-95.98239638872097, 30.084882281369378]],
    [ "582371370",[-110.35204305252425, 31.563877643979534]],
    [ "Tucson Electric Power",[-111.05825687232446, 32.000411064522744]],
    [ "Cyprus Sierrita Substation",[-111.09843027698791, 31.881138683617998]],
    [ "582421468",[-86.57657687458067, 39.16716479341173]],
    [ "Foster Substation",[-95.84650494367366, 29.70189953020055]],
    [ "582524840",[-99.95084032541568, 37.73194052534903]],
    [ "582524852",[-99.94965505, 37.7359169]],
    [ "Southeast Alaska Power Agency",[-131.35572471305596, 55.61540684235828]],
    [ "Tucson Electric Power",[-111.0035395760571, 31.80822872081055]],
    [ "Valencia Substation",[-111.13270020678867, 32.132561791630536]],
    [ "Arcola Substation",[-95.46653157768392, 29.489054817379742]],
    [ "582872147",[-99.70632435724728, 38.13088284440024]],
    [ "Dow Pump Substation",[-95.55199061871645, 29.0532189654588]],
    [ "Texas Pipeline Substation",[-95.67466160000001, 29.145795900000003]],
    [ "583051294",[-106.56909349705437, 35.09534986731705]],
    [ "FM 524 Substation",[-95.73519354999998, 29.0643135]],
    [ "583063491",[-111.06942917746376, 31.908136453692407]],
    [ "Black Oak Substation",[-94.88581444966573, 45.6651326768174]],
    [ "583366352",[-94.89057714331487, 45.66553907785964]],
    [ "583388759",[-95.74829924693, 29.07266781933786]],
    [ "583388812",[-95.74702675000002, 29.071324750000002]],
    [ "583388815",[-95.74526238395632, 29.07558174673213]],
    [ "583388818",[-95.74542515, 29.069991]],
    [ "583388824",[-95.76037376282622, 29.07572014544725]],
    [ "583388825",[-95.75792827137306, 29.078734355916456]],
    [ "Hilcorp Substation",[-95.74538287435418, 29.0456006393256]],
    [ "Tucson Electric Power",[-111.04747825365389, 32.39695236948003]],
    [ "Meadow Substation",[-95.2579737959509, 29.460296908603077]],
    [ "583417871",[-95.65382170898565, 29.920179409468428]],
    [ "583417872",[-95.6546592023905, 29.92103599366768]],
    [ "Fry Road Substation",[-95.72437314466313, 29.912672454902584]],
    [ "583505650",[-82.9488011050081, 39.552596119846434]],
    [ "583672333",[-99.11435289999999, 37.9446162]],
    [ "Seawall Substation",[-94.77154375455895, 29.310776532086322]],
    [ "Mackinac HVDC",[-84.73862954579663, 45.85905548971749]],
    [ "Woodlynne Substation",[-75.10065665839736, 39.91326351138457]],
    [ "South Shore Substation",[-95.04243986967063, 29.51532279420764]],
    [ "Butler Road Substation",[-95.10943080960188, 29.488907724482523]],
    [ "TECO",[-82.36849860000001, 27.837830050000004]],
    [ "Warren South Substation",[-79.1015252196786, 41.81574419724353]],
    [ "P. H. Robinson Peaker Substation",[-94.98445763096336, 29.49160484826872]],
    [ "Texas-New Mexico Power",[-94.93816724303426, 29.357499275027973]],
    [ "583928754",[-94.94027268822207, 29.355429625223437]],
    [ "Marathon Pipeline Substation",[-94.94109788872795, 29.368476925381508]],
    [ "Liquid Carbonics Substation",[-94.94058897995008, 29.366588746884297]],
    [ "Praxair Substation",[-94.9472084643791, 29.367869220592198]],
    [ "ARCO Substation",[-94.93941415094174, 29.348176252777687]],
    [ "Intercity Substation",[-94.9533182, 29.379417449999995]],
    [ "Carbide Substation",[-94.94944694207726, 29.37167617847138]],
    [ "Texas City Water Substation",[-94.95603660606494, 29.38653281915191]],
    [ "Grant Avenue Substation",[-94.9392402749563, 29.36267305474707]],
    [ "Boone Step-Down Station",[-81.65877488034877, 36.20463195088575]],
    [ "584045508",[-115.24434219480611, 36.007279022957015]],
    [ "Rawlings Substation",[-77.75901602379572, 36.936653803133815]],
    [ "584087509",[-77.71335495303663, 36.76318482104837]],
    [ "Brunswick Heritage Substation",[-77.71121137383392, 36.76113074076212]],
    [ "Rogers Road Substation",[-77.6553850251262, 36.723139241779464]],
    [ "584135186",[-94.91545412474228, 29.372944811297845]],
    [ "Marathon Oil Substation",[-94.90499725433708, 29.37568286676453]],
    [ "584135232",[-94.91122465000001, 29.371788050000003]],
    [ "584135253",[-94.8917683659771, 29.38205616729529]],
    [ "Bayview Substation",[-94.90125467476507, 29.36766480371897]],
    [ "584135265",[-94.89777667045863, 29.376855955493127]],
    [ "584135269",[-94.89400264999998, 29.379928300000007]],
    [ "584135279",[-94.9009710202017, 29.37659072206105]],
    [ "584135293",[-94.89991055, 29.38006545]],
    [ "584135294",[-94.89727234339634, 29.38014453202795]],
    [ "584135299",[-94.89474812480739, 29.38192809311218]],
    [ "Seneca Substation",[-83.13364053818239, 42.62339936333486]],
    [ "584258044",[-84.84223962972057, 38.204383696983264]],
    [ "Fluvanna Substation",[-78.3792803, 37.86744625]],
    [ "584286402",[-122.20279059634643, 37.43280117037281]],
    [ "Bushton Substation",[-98.35220511841457, 38.52448717261176]],
    [ "584370757",[-94.9345333227568, 29.378224476869697]],
    [ "584370794",[-94.93034061531738, 29.362106781424032]],
    [ "Murphy Substation",[-82.99848095, 42.80423315]],
    [ "Fargo",[-89.70056981569458, 40.78489053273256]],
    [ "Heritage Substation",[-89.63488832007188, 37.31066330208328]],
    [ "Maywood Substation",[-91.5951336467114, 39.836726302581965]],
    [ "584483240",[-91.35669755535409, 39.87855162735901]],
    [ "584485202",[-90.56348773665245, 39.82061551116377]],
    [ "Pawnee substation",[-89.58336058380478, 39.57723044490448]],
    [ "Front Royal Substation",[-78.18106655805425, 38.97071845095747]],
    [ "Jax Zoo Underground Transition #1 JEA 138KV",[-81.63699516586905, 30.395985946418623]],
    [ "584717589",[-96.95097778440031, 43.615696174910944]],
    [ "Cary Road Substation",[-84.33544590000001, 42.074297249999994]],
    [ "Electric Power Board of Chattanooga",[-85.1891041, 35.05809195]],
    [ "Eclipse Substation",[-79.80600253459586, 41.40374018776226]],
    [ "584960778",[-80.93552469042434, 35.275111606661554]],
    [ "Tri-County Substation",[-92.64104585, 41.1445815]],
    [ "584965857",[-112.48961115207857, 42.93528615684512]],
    [ "584986696",[-66.15584072498638, 17.949867754429434]],
    [ "Switzerland Substation JEA",[-81.60156476328044, 30.0740732456009]],
    [ "Genoa Substation",[-95.11776879161782, 29.622747325127804]],
    [ "585068028",[-66.1670483, 17.9619455]],
    [ "585068029",[-66.15115825829133, 17.959691125542584]],
    [ "585068030",[-66.15104824359341, 17.960013774734797]],
    [ "585069360",[-95.18435213637754, 29.60984025013794]],
    [ "McCabe Substation",[-95.04045262521818, 29.64322785502615]],
    [ "Shore Substation",[-95.04191291014297, 29.623151122159875]],
    [ "Mirage Substation",[-95.05364258732736, 29.645949615893112]],
    [ "Hanna Substation",[-95.0312974, 29.597668849999998]],
    [ "Hunter Substation",[-95.01444089581847, 29.60141857544887]],
    [ "585304959",[-106.68493147260598, 34.85002969277793]],
    [ "Columbus Michigan Avenue Substation",[-85.90955339041243, 39.20885682542959]],
    [ "585525280",[-94.28992468239636, 32.171069349521346]],
    [ "Nokesville Substation",[-77.5958662699033, 38.69126932810027]],
    [ "585560341",[-94.49612119999999, 32.46755055]],
    [ "Sandy Point Substation",[-95.01169346718396, 29.679886017417587]],
    [ "Alkane Substation",[-95.02144449281354, 29.68144357533867]],
    [ "Big Bay Substation",[-95.04540040231714, 29.623343679763813]],
    [ "Orion Substation",[-95.04507019734139, 29.62870374607152]],
    [ "Choate Substation",[-95.048509, 29.6268951]],
    [ "Soutel Dr Substation JEA 69KV",[-81.57651389514885, 30.284254318072154]],
    [ "Intermediate Substation",[-95.44688825, 29.6066748]],
    [ "585792970",[-95.41338253408927, 29.653101059025413]],
    [ "Brookdale",[-88.03236660760878, 42.965233222148406]],
    [ "Midvale Substation",[-111.01075137124923, 32.14908635088477]],
    [ "585989109",[-93.42303145849581, 45.09676054643613]],
    [ "585989114",[-93.46207440852614, 45.07605751195741]],
    [ "Duke Substation",[-111.99486616455883, 32.96241025565607]],
    [ "Georgia Power",[-84.51393229895355, 33.934502223334114]],
    [ "DTE Energy",[-82.6987162, 43.1029245]],
    [ "586130709",[-109.98233680882653, 31.73810837839197]],
    [ "Robert Bills-Wilmont Substation",[-110.85882085000001, 32.10018355]],
    [ "586158979",[-82.14344518639297, 40.10045939960628]],
    [ "Rivertown Substation FPL",[-81.59539918648127, 30.020469033063243]],
    [ "586397795",[-79.87837604945186, 38.92982424312657]],
    [ "586446873",[-85.89154847844956, 32.57435949685421]],
    [ "Apex Substation",[-83.70606764715004, 42.29446119367634]],
    [ "T. H. Wharton Substation",[-95.53313009955315, 29.93992840930826]],
    [ "Jester Substation",[-95.4576558, 29.990107499999997]],
    [ "Veteran Substation",[-95.48551244842268, 29.96812354635889]],
    [ "586740620",[-81.94101229798466, 39.939015939969536]],
    [ "586748788",[-110.89959091539949, 33.05351789974751]],
    [ "Hawaiian Electric Company",[-155.97624637309013, 19.74228611150852]],
    [ "Florida Power & Light",[-81.3038101055557, 29.800125854860035]],
    [ "586968251",[-86.57247396719447, 39.20598520065078]],
    [ "Peavy Substation",[-81.28929186749464, 29.593869632915126]],
    [ "587227065",[-107.87932755690028, 37.249983723756806]],
    [ "Willamette Substation",[-123.08257843480766, 44.05175609014401]],
    [ "587511189",[-82.94557169861473, 39.907626227330795]],
    [ "587541956",[-117.07722697049003, 33.96635360042265]],
    [ "Brickyard Switch CLAY",[-81.77070034999998, 30.107504000000002]],
    [ "Ridgewood Switch CLAY (S646)",[-81.77382467842516, 30.139782322550072]],
    [ "587595152",[-90.44504038157409, 42.43076165571616]],
    [ "Mosby Substation",[-77.56452200733247, 38.89387446504443]],
    [ "587776104",[-86.81067660000001, 40.389113050000006]],
    [ "587782104",[-84.97151112316098, 40.17348516895989]],
    [ "587849467",[-115.0433158703355, 36.18574962549831]],
    [ "American Transmission Company",[-88.38363374749927, 44.28690153647934]],
    [ "587895525",[-85.41571207396888, 41.643720590837795]],
    [ "587913544",[-87.39728645090135, 39.661147845288994]],
    [ "Bernard Substation",[-82.72644729772541, 42.91271476412894]],
    [ "City of Owensboro",[-87.15352455, 37.735808]],
    [ "Harmon Substation",[-81.54070817905861, 40.720851786549574]],
    [ "588164541",[-96.42852984868281, 32.06227906336463]],
    [ "588171471",[-96.45642756277564, 33.99865501605509]],
    [ "Taylorsville Substation",[-84.98869932472913, 34.083132989120394]],
    [ "Shickshinny Substation",[-76.15840317384934, 41.114947328401854]],
    [ "DTE Energy",[-83.55780190580424, 42.19933385219225]],
    [ "NV Energy",[-115.11745846167081, 36.243685138378005]],
    [ "Falls Substation",[-96.71584025468785, 43.56006442787223]],
    [ "Euclid Substation",[-96.65506905604494, 47.97725032460957]],
    [ "Barber Substation",[-98.59519350844504, 37.28793657125595]],
    [ "Nucor Steel Jackson, Inc.",[-90.1327364194531, 32.31333847453076]],
    [ "Astoria Annex",[-73.90345211135256, 40.78381364659197]],
    [ "588784506",[-89.59280045, 30.377056500000002]],
    [ "Zanesville Substation",[-82.03312989888106, 39.95100979071548]],
    [ "588833292",[-110.97574920548074, 33.146787903332516]],
    [ "588833295",[-110.99920908049613, 33.16488640551575]],
    [ "588833299",[-110.98314511769188, 33.156763218148654]],
    [ "589003062",[-85.89900330687972, 36.993054066381056]],
    [ "Kentucky Utilities Company",[-83.74367237269178, 36.60457773775217]],
    [ "Dallas Substation",[-84.85793392691401, 33.91874558822395]],
    [ "589085012",[-86.28515633192227, 37.4772420184627]],
    [ "589101719",[-84.08785820979364, 36.912595799192765]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.34205020000002, 37.36701095]],
    [ "Kentucky Utilities Company",[-88.08757873765964, 37.32175652469545]],
    [ "589109282",[-85.14035217991419, 36.70280509999366]],
    [ "Oakdale Substation",[-92.6772072874576, 30.799340568396744]],
    [ "CLECO",[-92.6398167, 30.800592050000002]],
    [ "Midway Substation",[-92.15399186475567, 31.692808231093057]],
    [ "Entergy Louisiana",[-92.27201098322581, 31.771382769884216]],
    [ "DeKalb Water Substation",[-84.27400644999999, 33.93439275]],
    [ "Georgia Power",[-84.21575081283086, 33.93090872560304]],
    [ "Columbus Grove Substation",[-84.05333650189716, 40.9627767157766]],
    [ "Pauding Putnam Baseline Substation",[-84.03395339999999, 41.0001805]],
    [ "Crawfis College Substation",[-83.9577050749416, 41.021596456264454]],
    [ "Kalida Substation",[-84.19110929515995, 40.98169315393678]],
    [ "Kalida Substation",[-84.20666146721862, 41.00624306938688]],
    [ "Miller City Substation",[-84.09263268488915, 41.09345289594458]],
    [ "Paulding Putnam Countinental Substation",[-84.27876299293776, 41.12222824389403]],
    [ "Raisin Substation",[-83.93921210134309, 41.98819879491148]],
    [ "Hendershot Substation",[-83.88645874977985, 41.989219727890294]],
    [ "North Bluffton Substation",[-83.87942482525023, 40.93773809284386]],
    [ "Simon Solar Substation",[-83.67992865, 33.676494850000005]],
    [ "Samaria Substation",[-83.63917940564593, 41.80737375552627]],
    [ "Paulding Putnam Seiler Substation",[-85.05302277427323, 41.04804554665514]],
    [ "Paulding Putnam Monroe Substation",[-84.96105339421568, 41.07406553436956]],
    [ "Paulding Putnam Convoy Station",[-84.74552117973532, 40.93179352017462]],
    [ "Creole Bulk Substation",[-93.15788400739203, 29.80925036300062]],
    [ "University Substation",[-83.73420885, 42.28105949999999]],
    [ "590078278",[-112.10494614635142, 33.46613784782551]],
    [ "Land O Lakes",[-89.2042724059278, 46.16376289885084]],
    [ "590581407",[-83.4611376790186, 39.08207648651734]],
    [ "Fayette Substation",[-91.08949923145421, 31.69556020609948]],
    [ "Pleasureville Substation",[-76.69753829990223, 39.979948404065446]],
    [ "590897560",[-90.46581095208848, 36.79178387706218]],
    [ "Canal Substation",[-84.6629446464542, 42.705248255740024]],
    [ "Ash Avenue Substation",[-83.64639433349414, 41.04943147268569]],
    [ "591053340",[-112.42030295, 42.86779004999999]],
    [ "591108058",[-91.46111727542632, 38.635441296632216]],
    [ "591108063",[-91.46204333418936, 38.532419041163074]],
    [ "591165566",[-95.45599870000001, 32.463769299999996]],
    [ "Hidden Valley Substation",[-105.54624897022659, 44.254374834506386]],
    [ "Jamesville Reclosing Station",[-76.07351689325156, 42.98557715652083]],
    [ "591369154",[-112.21296766430767, 35.41366782839196]],
    [ "591369155",[-112.21409291045042, 35.41193352764375]],
    [ "Hawaiian Electric Company",[-155.38570520000002, 19.35065105]],
    [ "Georgia Power",[-84.2844936121589, 34.00955817967505]],
    [ "Noyes Island Substation",[-75.9101101460102, 42.10667085444619]],
    [ "591455079",[-95.29544497679193, 32.305452717591855]],
    [ "591695525",[-95.14821065000001, 32.1128353]],
    [ "591948164",[-85.81912061553226, 33.66258608237707]],
    [ "592087430",[-78.10396113323844, 34.12833344989671]],
    [ "Sunset Park Substation",[-77.94039895134001, 34.19752759948172]],
    [ "Lafayette Substation",[-83.99368058670443, 40.764628491716614]],
    [ "592205749",[-121.59873394963002, 36.78029214112243]],
    [ "Brigatano Substation",[-121.60325879999998, 36.88171245]],
    [ "Washington Metropolitan Area Transit Authority",[-77.24535660790227, 38.932236105429894]],
    [ "North Newton Substation",[-74.75226746050691, 41.07106286376459]],
    [ "Oregon Substation",[-83.6888602422462, 42.07608240142127]],
    [ "592549456",[-114.96915612493122, 35.79213340961747]],
    [ "592549458",[-114.98917299999998, 35.792308]],
    [ "592580948",[-96.22043873258244, 40.43577260968619]],
    [ "592901916",[-115.36704988488549, 36.36578272928809]],
    [ "592903625",[-115.35434177064303, 36.35883566230314]],
    [ "593121335",[-114.77594983656104, 36.53409761912139]],
    [ "593232036",[-123.77238582304102, 46.955987293582744]],
    [ "593271071",[-85.66960463091013, 38.08718662309582]],
    [ "593276128",[-85.63020473328305, 38.12321992838031]],
    [ "LADWP Distributing Station No. 90",[-118.55604722516087, 34.201688511792725]],
    [ "Latimer Substation",[-86.1855238944602, 43.2126533575048]],
    [ "Casnovia Substation",[-85.86926662445852, 43.26476956146943]],
    [ "593550360",[-81.03503667309573, 34.93350562876489]],
    [ "593621059",[-95.56946730329152, 32.912414684530845]],
    [ "Sternberg Substation",[-86.14215314562742, 43.15489170970302]],
    [ "Peru Substation",[-83.33163787551392, 42.288121664049164]],
    [ "594269581",[-97.92777619116478, 35.857244079794334]],
    [ "Epping Tap Substation",[-67.77878030582922, 44.6728384250512]],
    [ "594341665",[-75.03675178224417, 39.89627438327997]],
    [ "594376394",[-84.93269215405367, 41.72360247135417]],
    [ "594379450",[-84.97194244908685, 41.70067560541497]],
    [ "Grand River Substation",[-83.11131083733227, 42.357050430676296]],
    [ "594585781",[-87.8347212923774, 34.843945770851256]],
    [ "594585784",[-87.89403248309722, 34.76958274755822]],
    [ "Harley-Davidson Substation",[-76.71302908987609, 39.988770252947845]],
    [ "Columbia Substation",[-67.79239796255214, 44.628315528893616]],
    [ "595203227",[-82.36593034999999, 34.73009935]],
    [ "595433463",[-97.06923452784999, 32.7418424719224]],
    [ "595436321",[-86.36502405184983, 37.01420072239697]],
    [ "595574125",[-83.04157232448348, 42.61666094073582]],
    [ "Shevlin Substation",[-83.05207520534316, 42.6833638501906]],
    [ "595880887",[-82.97172960428813, 42.53890716992916]],
    [ "Knox Substation",[-96.35497624999999, 42.351311249999995]],
    [ "Georgia Power",[-83.90759875801874, 34.20226298073087]],
    [ "Hawk Road Substation",[-84.99216979960083, 33.3583189926696]],
    [ "Fairchild Substation",[-82.86254331374664, 42.647686879000105]],
    [ "596085291",[-86.73896160054372, 32.65159837756666]],
    [ "596085292",[-86.73842915, 32.64848805]],
    [ "Hickory Substation",[-86.22021041312145, 43.129130419033274]],
    [ "Broadway Substation",[-86.20436029809306, 43.201676959734186]],
    [ "Fruitport Substation",[-86.1581447315727, 43.124696485513354]],
    [ "Norton Substation",[-86.26233988562193, 43.16144009315684]],
    [ "Mona Lake Substatoin",[-86.21958681859932, 43.17091916834231]],
    [ "Crittenden Substation",[-82.95290813051686, 42.66486437806515]],
    [ "Malta Substation",[-82.99395779074057, 42.621692036451634]],
    [ "Chester Substation",[-75.38561510341843, 39.830923232072436]],
    [ "596247703",[-88.76097702437905, 35.88957105701065]],
    [ "Laurel Substation",[-123.04995158815132, 44.03772772493086]],
    [ "596542639",[-85.86356398147537, 40.07400891436373]],
    [ "Beck Substation",[-82.95480659204117, 42.51781044669761]],
    [ "Harbor Substation",[-117.90772733850446, 33.80379690278616]],
    [ "597099672",[-79.32155010000001, 35.95272050000001]],
    [ "Big Sky Substation",[-118.30419943603643, 34.685896268912714]],
    [ "Marshall County Switching Station",[-96.3711664975892, 39.824643119866415]],
    [ "597532223",[-86.65830892523476, 40.7881799447549]],
    [ "597571138",[-79.20185582618308, 36.07789095215641]],
    [ "Oscoda Substation",[-83.344187312193, 44.4208982249024]],
    [ "597596889",[-83.03699110128359, 42.558119024606334]],
    [ "Enterprise Substation",[-77.4804159396566, 39.00209662867733]],
    [ "Pine Hill Substation",[-75.00034750261143, 39.79571346276609]],
    [ "Oncor",[-96.74402620000002, 32.96249065]],
    [ "Central Substation",[-97.02271265, 47.94579505]],
    [ "598366990",[-90.25835163015665, 38.685880696006066]],
    [ "598500448",[-94.85095040823605, 31.817408125082192]],
    [ "Fisher Substation",[-96.79787464999998, 47.80105234999999]],
    [ "Lawrence Substation",[-86.06178647509907, 42.218396945524155]],
    [ "Lamokin Frequency Converter Station",[-75.37652138868296, 39.84302467944974]],
    [ "599101233",[-111.79040588633512, 43.829718444080484]],
    [ "CIPCO",[-94.8561802581262, 41.46804055042957]],
    [ "Ellsworth Tap",[-98.79857047047791, 38.818767472882925]],
    [ "Western Area Power Administration",[-94.91989730377463, 41.51483592878973]],
    [ "Industrial Park Substation",[-83.48943741268272, 36.130774819017354]],
    [ "Ameren",[-88.94363745565188, 38.29747574136454]],
    [ "599512040",[-83.34300070302343, 42.13711500787883]],
    [ "599583403",[-111.68594773933816, 40.07705305704387]],
    [ "599601951",[-117.95971029348996, 33.86943013565338]],
    [ "599654271",[-121.0430999978839, 37.642442430634425]],
    [ "600001226",[-108.105755002312, 36.79157218306488]],
    [ "Wyntex Substation",[-95.55135149075454, 30.74232212523322]],
    [ "Mt. Vernon Substation",[-122.93295672344811, 44.03128037319201]],
    [ "600292565",[-106.58576803142793, 35.08149127647187]],
    [ "600294133",[-106.60877912562518, 35.17418194256071]],
    [ "600296175",[-107.73725621524093, 38.185773193569794]],
    [ "Dimmick Substation",[-84.386523504791, 39.30638577945922]],
    [ "Florida Power & Light",[-82.04180961906961, 30.15333277825283]],
    [ "Oak Grove Substation",[-83.92919507093696, 33.87801404212749]],
    [ "Deblois Substation",[-67.95701311469755, 44.70045368013504]],
    [ "Getty Substation",[-86.21926232584288, 43.23685048041138]],
    [ "600962191",[-88.44845922525388, 43.783186092598406]],
    [ "601090948",[-99.4204238395335, 39.00196017511125]],
    [ "Clayton Substation",[-83.3955705721564, 34.882143755955596]],
    [ "Baseline Substation",[-86.34834475493173, 43.644428271382836]],
    [ "Lemon Jct. Substation",[-86.37764135845929, 43.62232516045703]],
    [ "New Era Substation",[-86.39525831523513, 43.606489275595386]],
    [ "Shelby Substation",[-86.43693865, 43.5621551]],
    [ "Rodgers Substation",[-86.40745899357483, 43.49454827564808]],
    [ "Hesperia Substation",[-86.16828581498403, 43.55494606804224]],
    [ "601775425",[-82.487111456298, 42.88820674201687]],
    [ "South Cullowhee Substation",[-83.1703279, 35.29358584999999]],
    [ "Donaldson Substation",[-96.89669937064079, 48.57513922253623]],
    [ "601880997",[-82.90376480282346, 34.78460237919721]],
    [ "601880998",[-82.90384866467932, 34.783948680122464]],
    [ "601881002",[-82.90440623561942, 34.7939824532609]],
    [ "601881003",[-82.90418405927352, 34.7947148491643]],
    [ "602091963",[-80.96678985777466, 35.42195562329068]],
    [ "Kennedy Substation",[-96.90814140000002, 48.6454065]],
    [ "Long Lake Substation",[-83.23881112317068, 42.587394847196826]],
    [ "602192672",[-96.91287372472837, 48.70352544036508]],
    [ "Tennessee Valley Authority",[-86.98839150106572, 37.269324683936254]],
    [ "602324725",[-95.15622323931566, 33.39933575256169]],
    [ "602700984",[-90.23215115755559, 38.5109577528809]],
    [ "Veterans Substation",[-80.16090414882255, 41.136053110310506]],
    [ "603105449",[-97.28945782481648, 37.619991444319695]],
    [ "East Lake Substation",[-86.29417817342217, 44.248794673412554]],
    [ "Stronach Substation",[-86.27346345869232, 44.2013208263859]],
    [ "Driver Substation",[-89.97028075170952, 35.64484656371479]],
    [ "Price Substation FPL",[-82.56998481620691, 30.16037327122021]],
    [ "Worcester Substation",[-75.23157287274176, 38.34596145405473]],
    [ "Florida Power & Light",[-82.71034596559419, 30.217665823685902]],
    [ "Florida Power & Light",[-82.63754393284113, 30.220492784032633]],
    [ "Florida Power & Light",[-82.72756681411165, 30.293200331379445]],
    [ "SVEC Suwannee Valley Electric Cooperative",[-82.72830886570078, 30.293027725989244]],
    [ "Burroughs Road Substation",[-78.870619, 33.773035400000005]],
    [ "Clay Electric Cooperative",[-82.76305195904297, 30.058869509499907]],
    [ "Praxair, Inc.",[-90.16268705, 35.051222800000005]],
    [ "Ford Drive",[-88.10620919345784, 43.960092595456636]],
    [ "Meyer Rd",[-88.10064061997247, 43.90333921966458]],
    [ "Gravesville",[-88.14126729768118, 44.037414794998696]],
    [ "Elkhart Lake",[-88.04038398658685, 43.82484207353121]],
    [ "Tecumseh Road",[-88.13164029005115, 43.965143579066954]],
    [ "603747670",[-89.58428903957648, 36.51468329982786]],
    [ "603883090",[-85.69256414771104, 40.55709174993273]],
    [ "Clay Electric Cooperative",[-81.89175903211522, 29.184454691740534]],
    [ "603923580",[-81.89265101464473, 29.18466559151094]],
    [ "604008869",[-92.68401015, 32.5786652]],
    [ "Memphis Light, Gas and Water",[-90.05121033549094, 35.08735810061867]],
    [ "604028348",[-94.25355770000002, 30.30353395]],
    [ "Entergy Louisiana",[-92.40856011797224, 30.431649212751392]],
    [ "604083100",[-83.23562312370002, 42.15539792311062]],
    [ "604085161",[-83.23718498424414, 42.14849423517735]],
    [ "Bristol Tennessee Essential Services",[-82.1664694146543, 36.55740348002736]],
    [ "Terre Hill Substation",[-76.06663594272266, 40.16112786677223]],
    [ "West New Holland Substation",[-76.10343087552266, 40.09619229597981]],
    [ "Wick Substation",[-83.30854073113937, 42.24016272864014]],
    [ "Bishop Substation",[-83.7314389, 42.972965450000004]],
    [ "Wampee Substation",[-78.69657811281714, 33.83918729711333]],
    [ "Franklin Substation",[-94.6957474483944, 37.51249556160922]],
    [ "605083160",[-83.41220461846255, 42.25884764836131]],
    [ "Ranch Road Substation",[-97.12564834255689, 36.81718172544301]],
    [ "Bradley Beach Substation",[-74.01748036536353, 40.20628281581548]],
    [ "Airport Substation",[-83.3734231737894, 42.18092242927537]],
    [ "Marine Corps Solar Substation",[-84.0928507100372, 31.56071767635197]],
    [ "605386208",[-84.8765645, 38.20592225]],
    [ "Flag Substation",[-83.385791305623, 42.22082413831015]],
    [ "Rogell Substation",[-83.35174252707489, 42.212137910879875]],
    [ "Metro Substation",[-83.34603320874025, 42.22410292058523]],
    [ "Baja Substation",[-114.71711627819931, 32.49543250954555]],
    [ "Belair West Sw (S624) CLAY",[-81.76839739444699, 30.16476448647516]],
    [ "605669479",[-85.49003832481168, 41.146677894939465]],
    [ "605686077",[-83.86377841995066, 35.44752686047179]],
    [ "Memphis Light, Gas and Water",[-90.05324460473321, 35.132096859743655]],
    [ "Hesston Evergy Substation",[-97.42662759999999, 38.13000785000001]],
    [ "Texas Springs Substation",[-122.428128430742, 40.52578702906945]],
    [ "Auburn Substation",[-95.81267148926257, 38.99086746572216]],
    [ "Carolina Forest Substation",[-78.88696512701732, 33.78125106399031]],
    [ "Island Green Substation",[-79.05204194491002, 33.659231369371774]],
    [ "Hurl Rock Substation",[-78.90746457951953, 33.67653013298862]],
    [ "Withers Swash Substation",[-78.89356688538868, 33.69233236888382]],
    [ "Cane Patch Substation",[-78.84009556610032, 33.74141195265741]],
    [ "Windy Hill Substation",[-78.73916422485972, 33.80159544626004]],
    [ "Ocean Drive Substation",[-78.67024376035359, 33.83857404575212]],
    [ "Stephens Crossroads Substation",[-78.6822424533328, 33.87354503328886]],
    [ "Wesconnett Substation #06 CLAY",[-81.74225127057137, 30.16623765129186]],
    [ "Burcale Road Substation",[-78.9436220824715, 33.72143601612938]],
    [ "UNKNOWN 14-04-25-007938-003-47 Switch CLAY",[-81.7683152071764, 30.16012425733853]],
    [ "Northland Substation",[-96.15278906485219, 48.12603474585098]],
    [ "Rossmoor Substation",[-122.0804520861945, 37.8646628491918]],
    [ "Orinda Substation",[-122.19349780673312, 37.88359530713612]],
    [ "Bryant Substation",[-122.17969759837035, 37.87647281997052]],
    [ "138th Street Substation",[-75.05521179947269, 38.44305698200758]],
    [ "Cerberus Substation",[-122.10972082506342, 37.627059490122925]],
    [ "McCullers Road Substation",[-83.9346289, 33.798087200000005]],
    [ "606475282",[-86.30347207228344, 39.66868139535988]],
    [ "Innovation Substation",[-115.9473239465114, 36.582233787818836]],
    [ "Levee Substation",[-96.54799170405401, 39.19530025876115]],
    [ "Appleway",[-114.32523652882196, 48.20119395520738]],
    [ "Novelis Substation",[-83.20266645000001, 33.56011205]],
    [ "606815359",[-83.28246750000001, 33.584504450000004]],
    [ "Voyager Substation",[-82.9624317044153, 42.374262911319114]],
    [ "606880338",[-66.39813095, 17.98522855]],
    [ "Puerto Rico Electric Power Authority",[-66.41133099625264, 18.021019860579365]],
    [ "Colorado Springs Utilities",[-104.78003434080087, 38.72392162673306]],
    [ "Saturn Substation",[-83.04721759999998, 42.38543125000001]],
    [ "Frisbie Substation",[-83.05723716221854, 42.37357806432494]],
    [ "Eastowne Substation",[-94.7613841364502, 39.734751211599004]],
    [ "Adelaide Substation",[-83.16462006752103, 42.19640337658763]],
    [ "San Bruno Substation",[-122.42508407034427, 37.620979507181296]],
    [ "607660970",[-83.58829000000001, 33.62829980000001]],
    [ "Salem Substation",[-89.5970755725394, 30.54504299805618]],
    [ "Clay Electric Cooperative",[-81.8291889, 30.16289695]],
    [ "Wesconnett Switch #2 CLAY",[-81.74298687603392, 30.16642871537645]],
    [ "Wesconnett Switch #1 CLAY",[-81.74284083759593, 30.167161888583525]],
    [ "Orange Park North Switch #2 CLAY",[-81.73079015981045, 30.182495475296367]],
    [ "Orange Park North Switch #1 CLAY",[-81.73029825, 30.18327785]],
    [ "Resource Recovery Substation",[-83.05001079790368, 42.367809021001506]],
    [ "Pleasant Valley Substation",[-92.68245294581492, 43.800520298469266]],
    [ "607879746",[-82.92905508236554, 40.0327149663484]],
    [ "607879798",[-82.90889197643236, 40.03754084695689]],
    [ "Choctaw Substation",[-89.42188417969061, 33.28943402495333]],
    [ "DTE Temple Substation",[-83.05699726014143, 42.34335004183374]],
    [ "Bristol Substation",[-83.06392364970965, 42.38526190252549]],
    [ "New Albany Substation",[-88.99277970529033, 34.48285672082727]],
    [ "Valley View Substation",[-122.27866393251911, 37.96604533195464]],
    [ "Grand Meadow Wind Farm Substation",[-92.66853689999999, 43.7423844]],
    [ "Sargeant Substation",[-92.77026418890566, 43.79075437470021]],
    [ "608021608",[-92.77560182458436, 43.804210902067]],
    [ "Reading Lake Substation",[-95.89491684244568, 38.519567224926966]],
    [ "Osage City Junction",[-95.79382054530795, 38.622524444966544]],
    [ "Scranton Substation",[-95.74135305166168, 38.71806250577558]],
    [ "Carbondale Substation",[-95.64742849730636, 38.832843628133894]],
    [ "Shawnee Heights Substation",[-95.55747849027487, 38.98216932587439]],
    [ "Mount Carmel Substation",[-76.4108390216233, 40.792249730992594]],
    [ "McMillan Substatoin",[-86.25285999999998, 43.30206809999999]],
    [ "Twin Lake Substatoin",[-86.1678819, 43.360058249999994]],
    [ "Consumers Energy",[-86.33695889999998, 43.38881754999999]],
    [ "608256932",[-92.8897667386824, 43.73135640511899]],
    [ "608256934",[-92.88904192921201, 43.76102882540369]],
    [ "Coleman Substation",[-81.22691192219847, 32.10771995883663]],
    [ "Nestrom Substation",[-86.37594340000001, 43.356629]],
    [ "Hart Substation",[-86.29822764029056, 43.704953153260746]],
    [ "Walkerville Substation",[-86.11685606656066, 43.7172407183176]],
    [ "Colfax Substation",[-86.07761885775567, 43.73463988373166]],
    [ "Dona Vista Substation",[-81.69047498447962, 28.87625518642921]],
    [ "Salt Creek Substation",[-97.9585288397379, 38.03945035509368]],
    [ "Solvay Substation",[-84.07237632227778, 41.88581124942629]],
    [ "Colorado Springs Utilities",[-104.80042350974185, 38.74848142532225]],
    [ "Nucor Steel",[-76.808829, 36.352130949999996]],
    [ "608709694",[-77.11031885013416, 35.64137906666265]],
    [ "608753097",[-83.1435657309286, 42.281827791599966]],
    [ "Clifftop Substation",[-81.1083833574058, 37.7686978848263]],
    [ "Clifftop Substation",[-81.06504281724061, 37.782895203003875]],
    [ "San Francisco Bay Area Rapid Transit District",[-122.05783006062457, 37.63537125603422]],
    [ "608967856",[-118.91669702868673, 37.64898212880392]],
    [ "609019395",[-115.15084246743226, 36.16415415813497]],
    [ "609102957",[-111.97183695, 40.58473545]],
    [ "609103898",[-111.97069145617407, 40.58375491078704]],
    [ "Forks of Elkhorn Substation",[-84.81026492160467, 38.211888558820775]],
    [ "609324667",[-77.84833385, 34.37729795]],
    [ "Wheatland Substation",[-97.83182242935831, 38.369886544324444]],
    [ "Pennsbury Substation",[-76.92276785, 40.2580377]],
    [ "Pipeline Substation",[-106.36420050034532, 31.94471007242709]],
    [ "Windsor Substation",[-76.86301612662135, 40.316981672686566]],
    [ "Kingdom Community Wind Substation",[-72.43780749999999, 44.763457149999994]],
    [ "610073545",[-116.76786532580468, 36.902726682248705]],
    [ "Oak Island Substation",[-78.07484589999999, 33.911102199999995]],
    [ "Eight Mile Gap Substation",[-112.429535110831, 37.02127005654989]],
    [ "Johnson Substation",[-112.35291595116063, 37.03709929825027]],
    [ "610222825",[-92.0225157, 45.5332985]],
    [ "610222827",[-92.05064368743567, 45.523861245764586]],
    [ "610222829",[-92.30559960871906, 45.39527918741521]],
    [ "610251491",[-91.54491953762768, 39.70603883041877]],
    [ "Northeast Power",[-91.70865061825899, 39.917555276347464]],
    [ "Latham Substation",[-89.19372653841523, 39.970701904305095]],
    [ "Rising Substation",[-88.33997419007346, 40.15812169918724]],
    [ "610277547",[-88.9514075207527, 39.87330101665309]],
    [ "610277549",[-90.03008334522721, 40.53554877204482]],
    [ "610277551",[-90.2445142072863, 40.51486117509979]],
    [ "Sandburg",[-90.33023375147128, 40.97323270968891]],
    [ "610277555",[-91.34788253567838, 39.96665180112816]],
    [ "610277564",[-90.07814353319795, 40.27962877322781]],
    [ "610277565",[-89.01166630376822, 38.76154200227459]],
    [ "610277568",[-87.66063997764924, 39.13342592875824]],
    [ "Sullivan Substation",[-87.54641012958005, 39.2359268443568]],
    [ "610277576",[-89.10466083470229, 39.41151868753895]],
    [ "Ameren",[-89.71637794309791, 40.20099310661658]],
    [ "610277581",[-89.7620750338817, 40.59459691738318]],
    [ "610277584",[-90.31751993902643, 40.34273456969052]],
    [ "Lawtey Substation FPL",[-82.05216316080018, 30.05454477488639]],
    [ "610643629",[-81.99423039999998, 28.066473499999997]],
    [ "610844225",[-86.8769702043041, 39.63822129733717]],
    [ "610844227",[-86.86332210244116, 40.76429101056199]],
    [ "610931379",[-92.46439799895764, 39.72724679668994]],
    [ "Perry Substation",[-86.02776170783127, 42.796047574817294]],
    [ "Huntsville Utilities",[-86.67644798990635, 34.67993517513975]],
    [ "Huntsville Utilities",[-86.67503786071258, 34.6793379249858]],
    [ "611000784",[-85.10510264999998, 41.17707144999999]],
    [ "Bloom Wind Substation",[-99.93856153818598, 37.48678294240416]],
    [ "Cimarron Bend Substation #1",[-99.87108553556634, 37.369408732136954]],
    [ "Cimarron Bend Substation #2",[-99.99163527006658, 37.37106782076081]],
    [ "EDF Renewables",[-99.79635360003832, 37.869754872073116]],
    [ "Stringfield Substation",[-86.63700485, 34.77897385]],
    [ "611321456",[-84.21202733446225, 31.547896434240762]],
    [ "Victor",[-114.14404895000001, 46.4202297]],
    [ "611857945",[-84.45865140255499, 38.22153513655935]],
    [ "Davison Substation",[-83.52023617547893, 43.02714850763507]],
    [ "Oviedo Substation",[-81.21545502198789, 28.67427703770362]],
    [ "MN8 Energy LLC",[-86.6057764746605, 34.61139221603133]],
    [ "611925120",[-76.2870177075488, 36.84716127998609]],
    [ "Colorado Springs Utilities",[-104.77858414618022, 38.74647069731261]],
    [ "Huntsville Utilities",[-86.67425823965192, 34.65847767505114]],
    [ "Huntsville Utilities",[-86.63132250000001, 34.5875279]],
    [ "Middle Tennessee Electric Membership Corporation",[-86.86734271964914, 35.75200922974527]],
    [ "IPL Sunnyside Substation",[-85.9709235243945, 39.86793988842185]],
    [ "Peil Substation",[-96.61363409430409, 39.19712154451746]],
    [ "612453260",[-113.5854146008512, 37.07372467597834]],
    [ "612483751",[-113.574562548439, 37.09137186559928]],
    [ "Peck Substation",[-97.35127300971035, 37.5076145254605]],
    [ "612735003",[-97.34463930000001, 37.392109]],
    [ "612814778",[-81.66705478668057, 28.31237327499763]],
    [ "612840616",[-113.62336751826017, 37.12090518431314]],
    [ "612863438",[-113.59926794386601, 37.129353725430775]],
    [ "613055610",[-83.02764794999999, 34.35238515]],
    [ "South Alma Substation",[-96.28510699617912, 38.993724935569254]],
    [ "Halstad Municipal Substation",[-96.83187203383164, 47.350196879795675]],
    [ "Drenthe Substation",[-85.98532564879693, 42.81569917523404]],
    [ "North Manhattan Substation",[-96.58940836693084, 39.2333449665383]],
    [ "Hegins Substation",[-76.49483188972347, 40.64192896954895]],
    [ "Broadway Substation",[-72.93408865395962, 41.314273040379604]],
    [ "Rolling Hills Substation",[-98.70716859711413, 38.82040464940601]],
    [ "Waldo Substation",[-98.78674343444179, 39.11774994390043]],
    [ "Tracy Substation",[-121.4159503963881, 37.74882502062799]],
    [ "Methanex USA LLC",[-91.01972807148663, 30.213488378649767]],
    [ "Entergy Louisiana",[-91.00343200000002, 30.214873950000005]],
    [ "613948029",[-84.21122575, 31.549450599999997]],
    [ "Highbridge Substation",[-76.29362942313938, 40.7362703431028]],
    [ "Covert Substation",[-98.78381909852867, 39.234565061400744]],
    [ "Glen Elder Substation",[-98.33983427933403, 39.537840357009514]],
    [ "Cass Substation",[-76.25242600995566, 40.70375329820832]],
    [ "TC Seneca Substation",[-96.05295834138253, 39.867754656610856]],
    [ "Indianola Substation",[-95.70029169040575, 39.099482617238024]],
    [ "613998395",[-87.07300269999999, 34.653796099999994]],
    [ "Hoosier Energy",[-85.1252139575957, 39.85229002479648]],
    [ "Greenbank Substation",[-122.57390846689775, 48.098542997150105]],
    [ "Puget Sound Energy",[-122.83169665391522, 47.06980399570147]],
    [ "Puget Sound Energy",[-122.81585899916927, 47.03585417722976]],
    [ "Duck Creek Substation",[-112.66600291617723, 37.518581982885124]],
    [ "Gladstone",[-104.04247249958914, 36.322596873767075]],
    [ "614221579",[-80.82941303445973, 36.2709891603042]],
    [ "Tosco Substation",[-74.21448736896153, 40.6304427117981]],
    [ "614319621",[-114.07597105798713, 36.80293869664083]],
    [ "614326455",[-114.12129612495869, 36.80692300531454]],
    [ "614326457",[-114.0985931967825, 36.800489005444746]],
    [ "Girard Manor Substation",[-76.11749889303168, 40.868691763621236]],
    [ "614596099",[-106.41984344679743, 31.7842091503803]],
    [ "614597312",[-106.42057681018063, 31.808522827464973]],
    [ "Oncor",[-97.28231798564799, 32.93008956854324]],
    [ "Burnsville Substation",[-82.29580041982733, 35.91714034620237]],
    [ "614629600",[-82.27760255, 35.91714640000001]],
    [ "Delano Substation",[-76.07019693434565, 40.84635067832999]],
    [ "Post Substation",[-75.42534963869424, 39.81475752029235]],
    [ "North Allegan Substation",[-85.84907505636346, 42.53800441507846]],
    [ "Paper City Substation",[-78.67684423530515, 41.48660396588638]],
    [ "Midway Substation",[-85.6535164545244, 42.4517577635856]],
    [ "Eleventh Street Substation",[-85.65058292433447, 42.42067359157951]],
    [ "Duke Energy",[-86.31252693959948, 40.86622381554122]],
    [ "615576101",[-86.43497191637762, 40.71637023131997]],
    [ "615653953",[-86.4621397150441, 40.042555730517655]],
    [ "Crooked Falls",[-111.20401158397524, 47.540088873653254]],
    [ "616031505",[-85.20089061641403, 41.079581601996665]],
    [ "Puget Sound Energy",[-122.42079702311125, 48.00075438064991]],
    [ "Pugest Sound Energy",[-122.39779621688403, 47.99320567544922]],
    [ "Alberta City Substation",[-87.50404535701202, 33.20789645885309]],
    [ "DISTRIBUTING STATION 48",[-118.28997381182202, 34.25184034177547]],
    [ "616646832",[-93.59750311913587, 41.18815180392031]],
    [ "Heartland Substation",[-95.6855373693484, 38.92676107607986]],
    [ "North Stroudsburg Substation",[-75.20206906341696, 41.0249011079922]],
    [ "616930008",[-74.3817491423724, 40.72514694454007]],
    [ "Sebastopol Switching Station",[-89.32649633718476, 32.57816665959084]],
    [ "Sebastopol Substation",[-89.32533624999999, 32.57573515]],
    [ "616990488",[-88.3541372319831, 33.51956901604358]],
    [ "Sturgis Substation",[-89.08939599052361, 33.34676431868651]],
    [ "Winfield Substation",[-87.85402257904009, 33.91363728445528]],
    [ "Hamilton Substation",[-87.9635749605821, 34.147601352281036]],
    [ "Amory Substation",[-88.39625944004659, 34.02375782142789]],
    [ "616990511",[-88.53050293196861, 34.59836773019666]],
    [ "Okolona Substation",[-88.73482055040144, 33.98275993454386]],
    [ "Houston Substation",[-88.99546547758631, 33.922336647807704]],
    [ "Vardaman Substation",[-89.17942509999999, 33.904351350000006]],
    [ "616990518",[-89.98215979999999, 34.93154139999999]],
    [ "Hollandale Substation",[-90.85871960314854, 33.1421508554885]],
    [ "Durant Substation",[-89.86106899344345, 33.06174911286739]],
    [ "Pelahatchie Substation",[-89.74668044445856, 32.3216293519568]],
    [ "City Water, Light & Power",[-89.70596987225989, 39.718662596962716]],
    [ "Barefoot Bay Substation",[-80.5202734664571, 27.86456221738076]],
    [ "Dexter Substation",[-89.97232129999999, 31.078412800000002]],
    [ "Texas Eastern Transmission, LP",[-88.69325083476917, 33.869621913891784]],
    [ "Entergy Mississippi",[-90.28184569999999, 32.13559775]],
    [ "Crystal Springs Substation",[-90.36662324686617, 31.9709107602013]],
    [ "Wesson Substation",[-90.39970683732798, 31.685610277013566]],
    [ "Hazlehurst Substation",[-90.38173468019562, 31.868435714517624]],
    [ "Gallman Substation",[-90.39426194252918, 31.921524920776353]],
    [ "617087927",[-77.11535702054714, 35.21474883504703]],
    [ "617142342",[-79.01059514284528, 35.07955056236974]],
    [ "South Dakota Wind Energy Center",[-99.44059687486406, 44.38296450400693]],
    [ "617257809",[-85.13502059999999, 38.2215862]],
    [ "Schuylkill Haven Substation",[-76.17850005307072, 40.63095670223813]],
    [ "Anahola Substation",[-159.3030644436027, 22.12994867823788]],
    [ "617369078",[-82.60469707024777, 27.862319024370198]],
    [ "South Union Substation",[-79.7621623033393, 39.85820241032491]],
    [ "Gans Substation",[-79.83788358494068, 39.747360892168224]],
    [ "617488986",[-90.95810282280263, 44.11406557469168]],
    [ "Idaho Power",[-112.43974403588902, 42.91963948055562]],
    [ "617498869",[-90.59724779231973, 33.2521353249906]],
    [ "Texas Eastern 5 Substation",[-79.67058614848527, 39.930024793049306]],
    [ "617498889",[-80.81880091728236, 39.841828646013134]],
    [ "Saint Mary's Substation",[-81.2030999, 39.387094149999996]],
    [ "The Dow Chemical Company",[-91.24397135236013, 30.32517621597233]],
    [ "617511741",[-78.9493619245866, 34.861772052327076]],
    [ "617511745",[-78.83787401375187, 34.83895929996165]],
    [ "617511748",[-78.87018040000001, 34.842549250000005]],
    [ "617515011",[-83.12686845805814, 40.283807349584535]],
    [ "617525580",[-78.88012396318494, 35.937044779830316]],
    [ "617608888",[-83.28997135, 32.9985346]],
    [ "East Macon Substation",[-83.56113529999999, 32.8383671]],
    [ "Mississippi Power",[-89.59699007085193, 30.427923325057428]],
    [ "Carriere Southwest Substation",[-89.67827088828841, 30.600862817299024]],
    [ "CLECO",[-91.79851059999999, 30.00307825]],
    [ "Albany Green Energy Switching Station",[-84.10988241543888, 31.556702682227805]],
    [ "Coats & Clark Substation",[-84.12048853832611, 31.533828274635276]],
    [ "Douglas Switching Station",[-82.87668116278779, 31.53309842484644]],
    [ "617660018",[-83.29523839908325, 31.694087467384875]],
    [ "Fitzgerald Substation",[-83.29243423493065, 31.72933916552299]],
    [ "617664720",[-83.81373703919645, 32.64382031980185]],
    [ "Butler Solar Substation",[-84.285842, 32.5681644]],
    [ "Sand Hills Solar Substation",[-84.31020167488316, 32.59621244322043]],
    [ "Sandhills Solar Switching Station",[-84.3122571, 32.596653249999996]],
    [ "Porter Substation",[-80.33525788137256, 40.66012576363305]],
    [ "Roper Substation",[-85.3017452789953, 34.67790704083884]],
    [ "Surry-Yadkin EMC",[-80.33627016970435, 36.51471953799645]],
    [ "Surry-Yadkin EMC",[-80.38903498459665, 36.51831343357519]],
    [ "617719117",[-80.37861026024929, 36.54473857679788]],
    [ "Scotland Substation",[-86.9184830567073, 38.904201829180316]],
    [ "617724767",[-87.16853802859328, 38.85601114986964]],
    [ "Clendenin Substation",[-81.35816562360712, 38.4838895469382]],
    [ "617854113",[-92.23547429408877, 34.76344476514423]],
    [ "617900334",[-77.53665238622716, 34.4931870847209]],
    [ "617900335",[-77.53764991678749, 34.4928889754596]],
    [ "Wagners Substation",[-75.51991058797428, 41.11724652276179]],
    [ "618116111",[-116.24791180331384, 43.725933690390036]],
    [ "Canadensis Substation",[-75.26730906489784, 41.208987269321874]],
    [ "Pocono Farms Substation",[-75.35931850751655, 41.167781122016656]],
    [ "Tannersville Substation",[-75.32616144926301, 41.02712253308024]],
    [ "Mt. Pocono Substation",[-75.35339914979755, 41.12281804898105]],
    [ "Effort Mountain Substation",[-75.49085263382995, 40.98695053271196]],
    [ "Appenzell Substation",[-75.36911913187559, 40.9936523871362]],
    [ "Long Pond Substation",[-75.40848107466782, 41.10090310827275]],
    [ "McMichaels Substation",[-75.41076308586595, 40.9863551767554]],
    [ "North Coolbaugh Substation",[-75.36694469009511, 41.22824992467015]],
    [ "Camelback Substation",[-75.36119897625309, 41.05054860463789]],
    [ "618379127",[-81.5993736967838, 28.258719203340966]],
    [ "618593014",[-85.59270065, 40.842109199999996]],
    [ "618616747",[-85.82900555000002, 40.7923543]],
    [ "618638780",[-86.72352583249044, 40.50374015616675]],
    [ "Kabetogama Substation",[-93.0637053, 48.406439799999994]],
    [ "618704756",[-84.3925061166278, 36.68416325046959]],
    [ "618958595",[-86.82911342494837, 40.3541845546798]],
    [ "618965589",[-86.83261142230947, 40.301104100350905]],
    [ "618977723",[-86.91328461675677, 40.20029704143925]],
    [ "618980368",[-86.9051776322753, 40.11953877475313]],
    [ "AEP Peacock Substation",[-85.6906367883643, 40.37880707518637]],
    [ "Pine Grove Substation",[-76.37101965000001, 40.5622319]],
    [ "619213506",[-86.96178142616259, 40.08019721752875]],
    [ "Crawfordsville Substation",[-86.96071044210727, 40.079776195604516]],
    [ "619286558",[-112.97803084218405, 32.921549430935215]],
    [ "Frailey Substation",[-76.42472303179672, 40.622619707052905]],
    [ "Waimanalo Beach Substation",[-157.70366452024544, 21.337151414920527]],
    [ "Waiau Substation",[-157.9604020051064, 21.389276038681707]],
    [ "Waiau Substation",[-157.9611128343273, 21.38987475096924]],
    [ "Jones Creek Station",[-85.53864252506366, 40.22271950643145]],
    [ "Fuson Station",[-85.41511212501871, 40.15128759529254]],
    [ "619580216",[-86.50383204353365, 36.9356821561636]],
    [ "Twenty First St. Substation",[-85.37797785769527, 40.16952224012535]],
    [ "Utica Station",[-85.40955097486227, 40.18075780478544]],
    [ "AEP Armstrong Cork Station",[-85.1994513749396, 40.37326669456121]],
    [ "AEP Portland Station",[-84.97683917233225, 40.42766815866592]],
    [ "620200373",[-85.02230261797354, 40.41437320443125]],
    [ "620201190",[-85.02008676414559, 40.467935218708476]],
    [ "620207645",[-84.21185759311058, 31.548790728979213]],
    [ "620401072",[-82.05672253921445, 28.004246403520433]],
    [ "Appalachian Power Company",[-81.92251985029529, 37.17465505585181]],
    [ "620424102",[-81.90117885, 37.211876700000005]],
    [ "620424103",[-81.90375440521164, 37.21351150701594]],
    [ "Hales Branch Substation",[-81.9430962393272, 37.260514715787735]],
    [ "620427818",[-85.04489250936308, 40.65497717451592]],
    [ "620429075",[-84.96476223412654, 40.642588541849236]],
    [ "East Muskegon Substation",[-86.18472727754562, 43.230257074084584]],
    [ "Heidelberg Substation",[-76.29999512536926, 40.280290731426284]],
    [ "Huntingtown Station",[-76.61087408215396, 38.608270603227645]],
    [ "Hualapai Substation",[-115.31533607717351, 36.15840604521366]],
    [ "620930819",[-85.9942248679325, 39.956648250929916]],
    [ "Fishers North Substation",[-85.99247835557902, 39.97060272175356]],
    [ "Kanab City Substation",[-112.50760298341841, 37.03686948448754]],
    [ "Buckskin Substation",[-112.0650289235837, 37.142979109817965]],
    [ "620938665",[-112.58817292035971, 37.49357799688971]],
    [ "Tropic Substation",[-112.08296876574869, 37.65062710150591]],
    [ "620945040",[-75.63102347871994, 39.59363987272206]],
    [ "620991404",[-85.0047358, 38.6844259]],
    [ "620991408",[-84.88774969698913, 38.61041093146505]],
    [ "620991413",[-84.85186708373534, 38.61958757178702]],
    [ "620991414",[-84.8485787, 38.619342800000005]],
    [ "620991416",[-84.68945246340554, 38.72425132655521]],
    [ "620994977",[-85.36199389999999, 38.4146511]],
    [ "621016623",[-85.4113602, 38.3984426]],
    [ "Leitchfield Substation",[-86.31091371823466, 37.48072334037536]],
    [ "Kentucky Utilities Company",[-86.30903017343549, 37.47911682047067]],
    [ "Baltimore Gas & Electric",[-76.48246511332539, 39.56851607093161]],
    [ "621205836",[-90.09457709777669, 38.82505535480122]],
    [ "Weir Substation",[-89.27927449021851, 33.28159922152406]],
    [ "Evanston Substation",[-86.12187005247686, 43.212767254540935]],
    [ "Ravenna Substation",[-85.93740835000003, 43.184438899999996]],
    [ "Entergy Mississippi",[-90.50955512620926, 33.870528502866165]],
    [ "Webb Substation",[-90.34012971786618, 33.93521074871388]],
    [ "Interstate Paper Substation",[-81.40663985, 31.740733149999997]],
    [ "Union Carbide Corporation",[-90.44802366270358, 29.982676753102957]],
    [ "Union Carbide Corporation",[-90.44655224402388, 29.982294020130954]],
    [ "Flopam Inc.",[-91.15440045, 30.270270049999997]],
    [ "Entergy Louisiana",[-91.16055397540362, 30.252060439324108]],
    [ "Bayou LaButte Substation",[-91.16815164999998, 30.2567281]],
    [ "Florida Power & Light",[-80.37520500528667, 27.31886897506927]],
    [ "Station 65",[-77.6956061846917, 43.208047621024484]],
    [ "621733275",[-84.88767776747399, 32.50122600188926]],
    [ "Exxon Substation",[-87.18040401098682, 30.96533004596666]],
    [ "Lansford Substation",[-75.85485759113153, 40.839678077506896]],
    [ "APS Jackson Street Substation",[-112.00807739770556, 33.44472318475851]],
    [ "Entergy Arkansas",[-92.40966452708763, 34.79817710336121]],
    [ "Air Liquide Large Industries U.S. LP",[-90.99116211559814, 30.208519017470433]],
    [ "Westlake Chemical Corporation",[-91.00767344012888, 30.210472357951783]],
    [ "Texas Eastern Transmission, LP",[-89.54916424999999, 32.988374699999994]],
    [ "Eddyville Industrial Complex",[-92.64422510164464, 41.14358838606992]],
    [ "Pleasant Corner Substation",[-92.66020065000001, 41.135623550000005]],
    [ "Bridgeport North Substation",[-92.6496946, 41.138733349999995]],
    [ "621961349",[-93.30700851076426, 30.19779492508171]],
    [ "Entergy Louisiana",[-93.345523, 30.1595111]],
    [ "622010136",[-89.63056828329907, 34.980369116630655]],
    [ "Orwigsburg Substation",[-76.11241736605648, 40.66041075195037]],
    [ "Bluffview Substation",[-108.21407331036167, 36.716908600371276]],
    [ "622096088",[-89.99626916107218, 34.90491907474396]],
    [ "622100579",[-89.80053015240004, 34.97596956607485]],
    [ "622100583",[-89.80434334122654, 34.958937047489094]],
    [ "622179660",[-108.1930920997555, 36.72467070576655]],
    [ "622359620",[-92.32628644623414, 34.74704191299772]],
    [ "Holgate Substation",[-84.14016474289258, 41.25324768977674]],
    [ "Continental Tire Substation",[-80.31480960000002, 33.8800511]],
    [ "622705602",[-81.04175147464645, 34.72640505680656]],
    [ "Bridgestone Substation #1",[-81.8357171956495, 33.640037450415534]],
    [ "Bridgestone Substation #2",[-81.85671554999999, 33.6258289]],
    [ "Hunt Refining Company",[-87.60802074348805, 33.19787203113215]],
    [ "Gilmore A-B Substation",[-86.08101013691638, 39.58681915592484]],
    [ "622933994",[-90.33487028222756, 44.910248353384]],
    [ "Kersey South Substation",[-104.58600169666319, 40.351524450317186]],
    [ "Mercedes Substation",[-80.10361699680125, 32.96408351942688]],
    [ "623570858",[-90.131572, 32.31653465]],
    [ "Sylvarena Switching Station",[-89.38413357432782, 32.012344059265665]],
    [ "623829770",[-89.46917619941931, 31.84100646304857]],
    [ "623829772",[-89.46913312783734, 31.83464752197343]],
    [ "Cooperative Energy",[-89.51028423854731, 31.69563177125579]],
    [ "623886759",[-88.87136414303805, 31.692679741834507]],
    [ "Homewood Substation",[-89.51215189030907, 32.23900478308822]],
    [ "623897405",[-89.6375449900004, 32.33352212464764]],
    [ "Five Points Substation",[-89.35071314999998, 32.39169049999999]],
    [ "623908373",[-89.49238422646253, 32.74959819629254]],
    [ "623908950",[-89.51834805667391, 32.692994267642256]],
    [ "623915883",[-89.34450380690652, 32.31872246739545]],
    [ "Southern Pine Electric Power",[-89.13486904498482, 32.33348648039954]],
    [ "623922496",[-89.0055056421833, 32.142314673847935]],
    [ "623926354",[-89.13176115, 32.589562400000005]],
    [ "Marks Substation",[-90.27972013022102, 34.239069702220036]],
    [ "Mississippi Power",[-88.54700159971806, 32.37648936458446]],
    [ "Mississippi Power",[-88.75483462483604, 32.65220590235625]],
    [ "623966335",[-88.50335265162366, 32.43909379299664]],
    [ "623967498",[-88.12233687712788, 32.45268685151017]],
    [ "623967982",[-88.46385866704246, 31.93108683371657]],
    [ "624087219",[-88.12024286059534, 32.67913030991658]],
    [ "Georgia Tech Research Substation",[-84.52394344999998, 33.9102428]],
    [ "624113361",[-77.91372204999999, 34.13300985]],
    [ "East Fork Substation",[-84.30447061811047, 35.99747554263467]],
    [ "North Huntington Substation",[-94.26769930336022, 35.08518952107062]],
    [ "14th & Laurel Substation",[-123.44365778528903, 48.10752660014822]],
    [ "624791452",[-89.70064055, 32.19056325]],
    [ "Polkville Substation",[-89.70027085, 32.1865785]],
    [ "Cooperative Energy",[-89.67892046365834, 32.109668284720726]],
    [ "624793240",[-89.66173416764325, 32.31267471558344]],
    [ "Georgia Power",[-84.47722151630165, 33.40209657036106]],
    [ "624875654",[-87.39471802685853, 38.98066041889551]],
    [ "624894897",[-87.06396092897296, 34.63877518112016]],
    [ "624894898",[-87.05255235504863, 34.63663827541607]],
    [ "624894900",[-87.05791471003558, 34.63511685931227]],
    [ "624960428",[-77.84221512587554, 35.05106092024325]],
    [ "624965748",[-84.15446468421953, 31.559582455433233]],
    [ "625105094",[-84.35104081396241, 33.64279463585344]],
    [ "625115784",[-77.93739763346173, 34.32554581720284]],
    [ "625136724",[-78.80888689554047, 34.533380818127185]],
    [ "Four County EMC",[-78.21382746997728, 34.44474653867998]],
    [ "Four County EMC",[-78.28632416309215, 34.38010829704618]],
    [ "Frenchtown Substation",[-75.06283210190448, 40.537663288564005]],
    [ "Beltzville Substation",[-75.59090365718004, 40.85849387631339]],
    [ "Cooperative Energy",[-89.41264563925766, 31.98108017006241]],
    [ "Georgia Power",[-84.21009795000002, 33.22609635]],
    [ "Southern Pine Electric",[-89.4561365249567, 31.84422384119931]],
    [ "Soso Denbury Substation",[-89.28315280000001, 31.806889350000002]],
    [ "Mississippi Power",[-88.75222244999998, 32.402238749999995]],
    [ "Mississippi Power",[-88.58657242487477, 32.45435679634658]],
    [ "Pinewood Substation",[-77.45495488982831, 37.88433460723142]],
    [ "Mississippi Power",[-88.75743927184958, 32.6524101500737]],
    [ "Products (SE) Pipe Line Corporation",[-90.34449435222318, 31.054635383386994]],
    [ "625343545",[-90.3446055, 31.055251600000005]],
    [ "Chaves County Substation",[-104.45138331624078, 33.4521997948753]],
    [ "625482923",[-80.84031925000001, 35.64469825]],
    [ "Corunna Substation",[-84.1190274350104, 42.975932568077255]],
    [ "625562799",[-82.2328889140799, 34.30412366793663]],
    [ "625562801",[-82.1212627227058, 34.26882262113894]],
    [ "625562802",[-82.01731446556585, 34.19114285739021]],
    [ "625562803",[-82.04734681858437, 34.22430240308973]],
    [ "Ascend Substation",[-82.050252, 34.23098815000001]],
    [ "Hughesville Substation",[-76.7431378, 41.23352775]],
    [ "Muncy Substation",[-76.79157675256552, 41.21772601539602]],
    [ "Larrys Creek Substation",[-77.21362235000001, 41.221771149999995]],
    [ "Jersey Shore Substation",[-77.26621314792584, 41.205899033971264]],
    [ "Substation 20",[-80.84192329676094, 33.44039997112227]],
    [ "625597149",[-80.84971232296668, 33.439227641628364]],
    [ "625599243",[-84.3048364119199, 37.60170722672266]],
    [ "625664973",[-87.65167371912919, 37.810837808244855]],
    [ "Heidelbach",[-87.56066064999999, 37.97801259999999]],
    [ "625666093",[-87.56721095, 38.128124799999995]],
    [ "West River Substation",[-85.6504261, 43.05223225]],
    [ "REC East Rockton Substation",[-89.0133953386145, 42.45614402288305]],
    [ "Ringoes Substation",[-74.87180605394602, 40.43707055159706]],
    [ "Singing River Electric Cooperative",[-88.52600520855955, 31.419762424877216]],
    [ "Entergy Arkansas",[-92.379276024798, 34.69050575587772]],
    [ "Sabic Substation",[-89.5741036, 30.213984749999998]],
    [ "625837583",[-74.10092547983471, 40.655199052245905]],
    [ "625891542",[-98.55929422053244, 33.13316310393036]],
    [ "Flemington Substation",[-74.86296264726009, 40.501385625673265]],
    [ "Rocktown Substation",[-74.92956663852667, 40.36918547124333]],
    [ "North Macon Substation",[-83.61808650013054, 32.8364457332927]],
    [ "Armstrong Substation",[-83.65383361869347, 32.77532221289537]],
    [ "626009022",[-81.44557315000002, 31.2764728]],
    [ "Southern California Edison",[-117.8614973093835, 33.79028746092788]],
    [ "Coulee Avenue Substation",[-91.21619835517828, 43.7811277941419]],
    [ "626418186",[-115.24014805989044, 36.116029620384644]],
    [ "Entergy Arkansas",[-92.3322528409584, 34.78322356131564]],
    [ "Bolton Falls Substation",[-72.81621325880928, 44.35703164135929]],
    [ "626512256",[-93.42290661777216, 45.127532108159606]],
    [ "626548236",[-86.1779198549509, 39.61511154665815]],
    [ "626548243",[-86.1237892342947, 39.60509984398319]],
    [ "626639208",[-84.58698533195503, 38.256984504446095]],
    [ "Pavilion Substation",[-85.52625115894001, 42.24255609900659]],
    [ "626876139",[-107.79808359188152, 35.15024007425083]],
    [ "626897254",[-77.56280051622142, 35.00806351577088]],
    [ "626961606",[-80.67459919818197, 28.50833377379122]],
    [ "627056049",[-86.52983917795581, 38.90116243862551]],
    [ "627056051",[-86.53790497579237, 38.974098146718674]],
    [ "627056053",[-86.5436711, 39.014058]],
    [ "627056055",[-86.5451024466728, 39.09359499300971]],
    [ "627271767",[-93.68332484192734, 44.79119233332722]],
    [ "627271770",[-93.65242113440866, 44.83303735288997]],
    [ "627271775",[-93.64120217199805, 44.809631647588425]],
    [ "Valeen Substation",[-86.36490417487579, 38.44875879009075]],
    [ "Duke Energy",[-87.28297094999999, 38.484285400000005]],
    [ "Algiers Substation",[-87.18407286446768, 38.50182860302633]],
    [ "627311069",[-97.718209288592, 32.780196545921065]],
    [ "627314176",[-97.7026299633496, 32.78173284153438]],
    [ "627382258",[-87.48973689512617, 41.55182081386015]],
    [ "627416977",[-87.51212309265931, 41.64518005324933]],
    [ "Texas Substation",[-85.69155511647674, 42.2012787613521]],
    [ "627450587",[-93.4300290168711, 44.78592921270682]],
    [ "627450590",[-93.43197754081292, 44.78624415961126]],
    [ "627457429",[-111.80482649549099, 33.43351510563777]],
    [ "Gary-Chicago Airport Substation",[-87.42992182811443, 41.622602325690046]],
    [ "Parkway Substation",[-85.58011196897684, 42.28341882524657]],
    [ "Yorkville Substation",[-85.4069097, 42.375913499999996]],
    [ "627609655",[-88.9049309878687, 39.78183243653449]],
    [ "627609670",[-84.44694889395093, 39.482585568370226]],
    [ "627637628",[-93.64567560470066, 44.760931249930174]],
    [ "Duke Energy",[-87.01674430645303, 38.91544517530401]],
    [ "627640619",[-87.06518885, 38.8474671]],
    [ "TC Energy Corporation",[-97.04394658752918, 38.67353890465215]],
    [ "TC Hope Substation",[-97.04394182951542, 38.673876461531265]],
    [ "627805165",[-96.9989991638572, 40.038140175056064]],
    [ "627813007",[-91.424145584629, 39.08796043565433]],
    [ "627874137",[-80.43046580695898, 39.30472155682138]],
    [ "627892364",[-81.62466695478165, 35.32486079788992]],
    [ "627894197",[-101.82075127495324, 34.9854464569459]],
    [ "Valley View Substation",[-101.90087966244288, 34.984918125187306]],
    [ "Waldo Substation",[-80.65073667939275, 39.305714634814784]],
    [ "Glenville Substation",[-80.84852568121312, 38.94464879728592]],
    [ "627989093",[-84.31107674205572, 41.28663401489569]],
    [ "Ariton Substation",[-85.72498895975409, 31.586920573528293]],
    [ "City of Athens Electric Department",[-86.96044230000003, 34.657560700000005]],
    [ "628051613",[-97.08156560602814, 36.67800308440682]],
    [ "628167579",[-80.88124402665682, 35.07659306744618]],
    [ "628174623",[-81.03168450592406, 40.196448194449644]],
    [ "628175287",[-81.02497120000001, 40.25613475000001]],
    [ "628229874",[-85.94442226457996, 38.99342727434308]],
    [ "628359193",[-105.56388425389748, 44.4365197856917]],
    [ "628363113",[-80.85751301576093, 36.24753116461846]],
    [ "628403439",[-102.3461603166538, 34.84957463751598]],
    [ "628403442",[-102.31549663153872, 34.84795505181976]],
    [ "628410061",[-102.18763116756612, 34.9100335939703]],
    [ "628420031",[-118.36217952517565, 35.03902990721158]],
    [ "628444772",[-86.34350772358276, 39.421579789594]],
    [ "628447124",[-86.6618405277087, 39.030571753504596]],
    [ "North Industrial Substation",[-95.41785353158635, 37.945364589672614]],
    [ "628598104",[-81.22768700877398, 40.44925732259427]],
    [ "Iola Gen Substation",[-95.42484135000001, 37.92369865]],
    [ "Dowling Substation",[-83.63321646492177, 41.47364324667356]],
    [ "628849694",[-102.97288965000001, 34.453277400000005]],
    [ "Jerome Road Substation",[-84.62636405000002, 43.3885636]],
    [ "628891713",[-103.038674, 34.38893425]],
    [ "628891716",[-102.9733320587119, 34.391766429318416]],
    [ "628891717",[-102.90749271580746, 34.33135672549716]],
    [ "628897161",[-103.14624559999999, 34.488347149999996]],
    [ "628897168",[-103.16943604204675, 34.42637232481748]],
    [ "628906042",[-103.10046602663154, 34.74809833334234]],
    [ "628925687",[-87.76415016258322, 33.0381998106582]],
    [ "Orange & Rockland Utilities Inc",[-74.37157006429281, 41.41139216836832]],
    [ "Sunset Point Substation",[-88.57506935809329, 44.05561555343159]],
    [ "629165173",[-90.28255148846064, 38.90774360636744]],
    [ "Salt Draw Substation",[-103.50293770565547, 31.338146268312794]],
    [ "629291291",[-102.0490902838561, 33.195646337068766]],
    [ "629291292",[-102.03326268453112, 33.03694092493091]],
    [ "Signal Mountain Substation",[-85.3422627010097, 35.12328566718505]],
    [ "Draw Tap",[-101.6657625, 33.189101550000004]],
    [ "Ransom Canyon Substation",[-101.69700572504927, 33.527794257164466]],
    [ "Moulton South Substation",[-97.14021737074732, 29.531074537320002]],
    [ "Pomelo Substation",[-98.47722350000001, 26.4448907]],
    [ "Oak Grove Graham Substation",[-87.44587821449377, 30.90857059753451]],
    [ "Ridge Substation",[-96.29460745000002, 31.1047961]],
    [ "Limestone Substation",[-96.24628745000001, 31.421884050000003]],
    [ "Butler Substation",[-95.90609326937334, 31.665403224069426]],
    [ "Amerigas Substation",[-96.16035399796799, 31.35607563364915]],
    [ "Brown Magnolia Substation",[-96.13054410000001, 31.230308199999996]],
    [ "Olethea Substation",[-96.42648058358434, 31.4008491586772]],
    [ "Teague Main Substation",[-96.29675050536879, 31.647291775788254]],
    [ "Freestone Substation",[-96.24830910222003, 31.543770288748505]],
    [ "Pleasant Springs Substation",[-95.85247805405089, 31.174835565404134]],
    [ "Pleasant Springs Tap",[-95.88871251691295, 31.329229215085995]],
    [ "Centerville I-45 Substation",[-96.01662168226099, 31.352132593283095]],
    [ "Marshall Substation",[-92.65558892270951, 35.9085794159041]],
    [ "630097031",[-81.28195651972663, 32.27902837532112]],
    [ "Temple Inland Substation",[-94.86741914999999, 31.381907599999998]],
    [ "Mustang Prairie Substation",[-95.58251415, 31.2378272]],
    [ "Latexo Substation",[-95.42522270000002, 31.364377499999996]],
    [ "Berea Substation",[-95.31856432399411, 31.358316392913252]],
    [ "Grapeland Magnolia Substation",[-95.6874096169858, 31.46011274124134]],
    [ "Explorer Substation",[-95.66801962331877, 31.42221559297664]],
    [ "Crockett Substation",[-95.4772200732898, 31.370775209195994]],
    [ "Point Blank Substation",[-95.22531253649876, 30.75268403138116]],
    [ "Cedar Substation",[-95.66151166300224, 30.86873876444061]],
    [ "Walker Substation",[-95.4951780711475, 30.84337480447776]],
    [ "Dorrell Substation",[-95.3888242347501, 30.52442092890157]],
    [ "Evergreen Switching Station",[-95.46243934041625, 30.532207984364682]],
    [ "Temco Substation",[-95.46298082368473, 30.53216924281442]],
    [ "Georgia Substation",[-95.47324095, 30.5725883]],
    [ "Goree Substation",[-95.50063900203367, 30.680624258971267]],
    [ "Mount Zion Substation",[-95.66953114861651, 30.720917744632953]],
    [ "Cold Spring Substation",[-95.1037653955471, 30.568752118756922]],
    [ "630415514",[-95.01185620252694, 30.41847861221767]],
    [ "Coley Creek Substation",[-94.96674164999997, 30.495007249999993]],
    [ "Rivtrin Substation",[-95.40834708851868, 30.840248386649783]],
    [ "Houghton Heights Substation",[-84.7704077093018, 44.321461583780575]],
    [ "Fermi Substation",[-100.78752740000003, 29.769742050000005]],
    [ "Ogletree Substation",[-94.95257923847419, 30.70402477362014]],
    [ "Livingston Substation",[-94.91756077239027, 30.71425001742655]],
    [ "630722569",[-78.75664142380445, 36.09374524241501]],
    [ "630722594",[-78.97791314667437, 36.350227033250135]],
    [ "630754603",[-84.59667484028621, 33.54634732560234]],
    [ "630781489",[-82.10138394693436, 32.42898391775163]],
    [ "Georgia Power",[-82.10077915, 32.429734100000005]],
    [ "Bragg Substation",[-94.5833142, 30.433055799999995]],
    [ "Gulf Switching Station",[-94.81500570305901, 30.64608870094226]],
    [ "Gulf Livingston Substation",[-94.81487025, 30.6459232]],
    [ "Carlisle Substation",[-95.17239764441545, 30.837964613193652]],
    [ "Gulf Trinity Substation",[-95.1729137, 30.837754199999992]],
    [ "Onalaska Substation",[-95.10915657774261, 30.850288056678213]],
    [ "Blanchard Substation",[-95.04916791903074, 30.753289589010684]],
    [ "Hightower Substation",[-94.92690413794813, 30.4131670295569]],
    [ "630877435",[-86.23856076240133, 39.7756711198176]],
    [ "631022322",[-80.8396190278326, 35.0883966114733]],
    [ "Luray Hydro Substation",[-78.49895900910478, 38.67671017992526]],
    [ "Kalkaska Substation",[-85.16935149104594, 44.73577664455301]],
    [ "Herty North Switching Station",[-94.67848916120028, 31.419802398379083]],
    [ "Champion Paper Mill Substation",[-94.67937985000002, 31.358347900000005]],
    [ "Diboll Substation",[-94.71639717109846, 31.224485476287256]],
    [ "Biomass Substation",[-94.73896777391882, 31.369261953245406]],
    [ "Corrigan Substation",[-94.8036929965963, 30.992561059044853]],
    [ "Magnolia Groveton Substation",[-95.16380218428588, 30.975694862248726]],
    [ "Kickapoo Substation",[-94.9999681752124, 31.006207756975122]],
    [ "Niles Substation",[-80.74781563200685, 41.16376625969918]],
    [ "631392693",[-80.74806490803451, 41.166170685409206]],
    [ "Bartonsville Substation",[-75.25869023537811, 40.99906613166357]],
    [ "631695259",[-115.12909231129015, 36.00261246538507]],
    [ "Slocum Substation",[-95.48809303146308, 31.61799705742668]],
    [ "Grapeland Substation",[-95.45844925000002, 31.50850795000001]],
    [ "Broaddus Substation",[-94.26670140092816, 31.291451398486906]],
    [ "Etoile Substation",[-94.39774887666522, 31.336503913407096]],
    [ "Wetsel Substation",[-100.54696418754666, 32.62951112902255]],
    [ "Claytonville Substation",[-100.54563881956155, 32.62805318825113]],
    [ "Two Draw Substation",[-101.4086395900592, 33.21969267432409]],
    [ "Yancy Substation",[-101.3720167, 33.152422200000004]],
    [ "Golden Spread Electric Cooperative",[-101.38806669999998, 33.16973405]],
    [ "Central Substation",[-101.59520164999999, 33.18862609999999]],
    [ "Draw Substation",[-101.66646357482207, 33.00661466132851]],
    [ "Garza Substation",[-101.3580417, 32.97935095]],
    [ "Justiceberg Substation",[-101.1623632, 33.00352545]],
    [ "Slaton Substation",[-101.63484282709253, 33.4403296992569]],
    [ "Slaton Substation",[-101.61642965935772, 33.403315189374744]],
    [ "Southland Substation",[-101.55587539045959, 33.35783227479525]],
    [ "Hackberry Substation",[-101.55700614999999, 33.2867624]],
    [ "Chireno Substation",[-94.35210975, 31.519654600000003]],
    [ "Nacogdoches South Substation",[-94.63899685000001, 31.5789453]],
    [ "Nacogdoches Substation",[-94.67631093493243, 31.608352830231432]],
    [ "Nacogdoches Southwest Substation",[-94.67869860000002, 31.567535049999996]],
    [ "Ivanhoe Substation",[-91.73909286032381, 29.781428726310455]],
    [ "632171478",[-81.5698563, 39.302979300000004]],
    [ "Tater Hill Substation",[-98.60366355823727, 31.68435753009484]],
    [ "Corn Trail Switching Station",[-98.66364778357382, 31.81883299962389]],
    [ "632301973",[-90.91613110129619, 29.629528448897986]],
    [ "Gilmer Logistics Substation",[-83.76437969999999, 32.4597403]],
    [ "632372246",[-81.99362420918075, 27.922832675044543]],
    [ "632479079",[-90.14195977502756, 32.43720844319383]],
    [ "632537438",[-86.10839498946865, 39.754120425041606]],
    [ "632610010",[-85.38797935, 29.932132400000004]],
    [ "AEP Oliver Plow Substation",[-86.26554398605718, 41.66812356868495]],
    [ "Liberty Substation",[-85.19357179995647, 42.320796851996256]],
    [ "632892985",[-87.2942460038624, 41.600092157028676]],
    [ "632893009",[-86.9113010556427, 41.72134783633776]],
    [ "633034810",[-119.65333068131396, 45.849369539424714]],
    [ "633046141",[-82.41950385482072, 36.310567244880154]],
    [ "Niagara Substation",[-83.96748810126749, 43.41288126651751]],
    [ "633336492",[-111.87289281673876, 42.714725190787696]],
    [ "633521371",[-79.69212945, 37.2552535]],
    [ "633523967",[-86.61672170000001, 41.055498899999996]],
    [ "633523968",[-86.61327499312361, 41.05558048770709]],
    [ "633523969",[-86.61075191991964, 41.054731349565756]],
    [ "Public Service Company of Oklahoma",[-96.04208394780366, 36.08036687791849]],
    [ "Entergy Arkansas",[-92.6739505, 33.201702]],
    [ "633720250",[-79.6419828829921, 40.74867108391855]],
    [ "Galax Substation",[-80.91975993036827, 36.66614315508033]],
    [ "Manchester Industrial Substation",[-91.47049363471672, 42.46986742873485]],
    [ "Fries Substation",[-80.98800585, 36.71530859999999]],
    [ "633944113",[-78.63897579150053, 35.7911317856549]],
    [ "633984558",[-102.89717950969866, 48.05938260255705]],
    [ "633986587",[-102.72895745321033, 48.02454733616024]],
    [ "633995846",[-102.8530275414913, 47.747343324704396]],
    [ "633997158",[-103.28179550125415, 47.959093321205636]],
    [ "Bouse Switchyard",[-114.21651938223631, 33.99863365795225]],
    [ "Huntsville Utilities",[-86.53642230907927, 34.718032370085474]],
    [ "634130634",[-86.79648019999999, 33.105098000000005]],
    [ "Alabama Power",[-86.76183345000001, 33.16572525]],
    [ "634279834",[-103.60593177515207, 47.78311615925446]],
    [ "634279837",[-103.58103035, 47.795356049999995]],
    [ "Dixieland Substation",[-87.54141406585798, 37.999960856475646]],
    [ "Ohio River Substation",[-87.60425416587644, 37.970022829950146]],
    [ "Garvin Substation",[-87.55951107493026, 37.99232559310605]],
    [ "634394108",[-103.65375734772496, 47.9070501728171]],
    [ "Lynbrook Substation",[-79.21496563228405, 37.29989923723234]],
    [ "McConville Substation",[-79.2150179478607, 37.38401528790034]],
    [ "634959280",[-83.1811316591705, 39.95864760583507]],
    [ "Station 136",[-77.4543261487206, 43.22346562593707]],
    [ "635096889",[-79.00884114904811, 37.70978403472813]],
    [ "Gladstone Substation",[-78.85734100889881, 37.57262333453419]],
    [ "87th Street Substation",[-94.87955167637493, 38.97274201117156]],
    [ "Hook Road Substation",[-94.37787971979338, 38.865215555188165]],
    [ "Lake Winnebago Substation",[-94.3487948312797, 38.8326047184045]],
    [ "635420395",[-102.89756548831623, 47.805351774833994]],
    [ "635423108",[-103.00426457050091, 47.89856727508142]],
    [ "Lake Charles LNG Company, LLC",[-93.2815721, 30.11072305]],
    [ "Blue Ridge Energy",[-81.09819811783396, 36.48207549368739]],
    [ "Briery Substation",[-78.42502123496942, 37.164370070294694]],
    [ "Greenwood Substation",[-94.29659235053461, 38.859970148492565]],
    [ "Lee's Summit East Substation",[-94.31717132010094, 38.908254917719155]],
    [ "Beacon Substation",[-117.34485928548246, 47.67974380899807]],
    [ "Georgia Power",[-83.65328865, 33.33590735]],
    [ "Merck",[-78.84612150963284, 36.10943847695139]],
    [ "635854972",[-115.01096608108405, 36.042298873963134]],
    [ "Evergy",[-94.22944177928436, 38.587531267026684]],
    [ "635909861",[-93.98788307392093, 38.62427285308027]],
    [ "Evergy",[-94.02144836047992, 38.85259580810547]],
    [ "Dimondale Substation",[-84.64268620016495, 42.64716525043845]],
    [ "Eaton Rapids Substation",[-84.65578255187144, 42.5241584002228]],
    [ "Fairview Substation",[-76.56582467587789, 40.78211215498677]],
    [ "636220508",[-114.99292796864498, 36.06959532444624]],
    [ "636272001",[-111.31320566846476, 44.49228467211575]],
    [ "Oak Grove Substation",[-94.14875449328314, 38.99866135659952]],
    [ "Grain Valley Substation",[-94.19086791609655, 38.99675788588903]],
    [ "Western Electric Substation",[-94.3893413859771, 38.92982132427206]],
    [ "East Callaway Substation",[-85.47161845519994, 30.14789658090653]],
    [ "Sacramento Municipal Utility District",[-121.29796247509464, 38.573607346356624]],
    [ "636522641",[-102.91346919249749, 48.28564517902466]],
    [ "636643425",[-102.98642905823975, 47.97689977524988]],
    [ "Vernier Substation",[-82.90854852214159, 42.44349466687363]],
    [ "Grosse Pointe Substation",[-82.9115967659919, 42.41779970198168]],
    [ "St. Louis Substation",[-83.0395892056311, 42.42672026983859]],
    [ "Saint Antoine Substation",[-83.03956358647356, 42.33260562851999]],
    [ "Fairfax Substation",[-94.62815586638575, 39.14584217402564]],
    [ "Georgia Power",[-81.9890497, 32.81986]],
    [ "Millen Primary Substation",[-81.98887970000001, 32.81855095]],
    [ "636973033",[-98.01857814967968, 41.85099649366674]],
    [ "636973145",[-98.0149210814561, 41.85170526370488]],
    [ "636974368",[-84.16777218307723, 30.57056299090211]],
    [ "MidAmerican Energy",[-90.64529722446953, 41.497323008495144]],
    [ "Sub 85",[-90.66260640867044, 41.47095236463831]],
    [ "MidAmerican Energy",[-90.51049943615136, 41.58936580238234]],
    [ "West Branch Substation",[-91.38619083719367, 41.685950143807695]],
    [ "MidAmerican Energy",[-91.49190394741544, 41.68512709531709]],
    [ "Endless Caverns Substation",[-78.68567212545814, 38.619109157122594]],
    [ "637133295",[-87.456684587177, 41.65291060918153]],
    [ "637160420",[-83.82645803426853, 33.6269266187635]],
    [ "Covington Airport Substation",[-83.83597455, 33.627041899999995]],
    [ "Lake Lansing Substation",[-84.44898401826293, 42.75582851723186]],
    [ "Coral Ridge Substation",[-91.59878481615128, 41.68208052454485]],
    [ "Fayetteville Water Substation",[-78.86556841111265, 35.082490759634844]],
    [ "637404715",[-88.39819215915638, 42.791012225373784]],
    [ "637554807",[-90.26750646442976, 39.74415985450094]],
    [ "Memphis Light, Gas and Water",[-89.71100644694778, 35.20765052885959]],
    [ "Williamsburg Substation",[-92.06547530191177, 41.673310579074546]],
    [ "637656794",[-92.27806058873028, 41.70288407518006]],
    [ "637659508",[-88.72601525, 31.951953250000003]],
    [ "Timberville Substation",[-78.77842370602951, 38.62774246936658]],
    [ "Timberville Substation",[-78.77872940898925, 38.62737033461007]],
    [ "East Market Street Substation",[-78.83991747329247, 38.41732997764982]],
    [ "Barracks Road Substation",[-78.53053058632459, 38.071634237751184]],
    [ "Williams Street Substation",[-78.88639791297012, 35.049128973138025]],
    [ "Fayetteville Public Works",[-78.92221519756873, 35.010558277244435]],
    [ "Cumberland Road Substation",[-78.93412605299237, 35.01499572475728]],
    [ "637945837",[-82.4603844238206, 39.249420155463184]],
    [ "Browns Falls Station",[-75.05885520642327, 44.21080721757846]],
    [ "638052449",[-89.402951116489, 39.0606639630595]],
    [ "638083954",[-89.64033445000001, 41.0909227]],
    [ "Lumbee River EMC",[-78.99823672975111, 35.025689863610104]],
    [ "Farmers Electric Cooperative, Inc.",[-94.3765894850717, 41.50326073193709]],
    [ "Flint Hills Substation",[-94.37727852251456, 41.524937248895895]],
    [ "638101870",[-94.56648844636182, 41.45384519101517]],
    [ "Sinclair Substation",[-85.65864029456242, 42.971126820932135]],
    [ "Pine River Substation",[-84.66727469433306, 43.37530604679346]],
    [ "Coolidge Ventures Station",[-76.07090793753777, 43.09033505230921]],
    [ "638285330",[-76.08800748621942, 43.0811715307886]],
    [ "Eclipse Substation",[-94.66354955041753, 41.546655592547324]],
    [ "Embden Substation",[-69.88525821353464, 44.958267878948774]],
    [ "Virginia Electric and Power Company",[-78.21561345616713, 38.11746133384456]],
    [ "Fayetteville Public Works",[-78.93610534146214, 34.999665480890634]],
    [ "638432124",[-79.02344862616845, 35.12133118790735]],
    [ "638512367",[-79.10606112523651, 36.07192381325696]],
    [ "Rockville Substation",[-77.68355771880134, 37.68903092232022]],
    [ "Georgia Power",[-84.4333568248834, 33.78188999311176]],
    [ "Georgia Power",[-84.46784466260074, 33.82846930362507]],
    [ "Georgia Power",[-84.46935147143002, 33.828444473101726]],
    [ "Georgia Power",[-84.4550056, 33.825932800000004]],
    [ "East Burdeshaw Substation",[-85.36091992572972, 31.227105084641984]],
    [ "Monument Substation",[-85.38639548276319, 31.225727643125005]],
    [ "638560333",[-85.46479387491776, 31.29624390729401]],
    [ "MidAmerican Energy",[-92.3683567729841, 42.50900817877489]],
    [ "638608606",[-93.62158946803265, 41.64490087197364]],
    [ "638608610",[-93.59481487521116, 41.64587840305419]],
    [ "Fayetteville Public Works",[-78.91773379731802, 35.04205975348094]],
    [ "MidAmerican Energy",[-92.3525874869587, 42.50444996918567]],
    [ "638881921",[-85.10369069543606, 41.08138767827939]],
    [ "IBM Substation",[-73.08873862525975, 44.474530842358746]],
    [ "Synder Substation",[-85.93881630911912, 44.25592800086271]],
    [ "Rafter Substation",[-98.80621068299932, 29.41668820688846]],
    [ "Crawford County Substation",[-95.46002478454865, 42.15686906818237]],
    [ "Crystal Lake Wind II",[-93.83414149437229, 43.27949992532421]],
    [ "Cheltenham Substation",[-76.82780080025496, 38.70028251292204]],
    [ "Macksburg Substation",[-94.16970148544358, 41.20153406338198]],
    [ "Conifer Substation",[-105.30273852566188, 39.53636431291129]],
    [ "Lost Lakes Wind Farm",[-95.24183935157224, 43.34712427985943]],
    [ "Triboji Substation",[-95.23413836633519, 43.401466834738535]],
    [ "640046137",[-95.13398907121079, 43.34204858495819]],
    [ "Van Atta Substation",[-84.38975763078831, 42.73242852533893]],
    [ "640334822",[-84.65040293359058, 38.399830252194036]],
    [ "Corson Substation",[-96.58655879070221, 43.616096212700256]],
    [ "640372866",[-94.65823373216496, 42.56676066086742]],
    [ "Pocahontas Prairie Wind Farm",[-94.65830432525918, 42.56746115135318]],
    [ "Station 58",[-77.47688007515548, 43.14422284414115]],
    [ "Greenbrook Substation",[-89.9714986, 34.96419074999999]],
    [ "Brown Boveri Substation",[-77.40251789014873, 37.40657477802861]],
    [ "Station 424",[-77.4077406524861, 43.23106564707698]],
    [ "640707446",[-98.04573048941698, 41.93051766140127]],
    [ "640742786",[-80.31635816276186, 27.458344783869716]],
    [ "Barton Switching Station",[-93.10251405394816, 43.38689918941055]],
    [ "Worth County Substation",[-93.29090411101694, 43.35625654859848]],
    [ "Hawks Nest Lake Substation",[-96.1620322763264, 44.53122791842417]],
    [ "640865958",[-93.22276200190157, 37.15433223027145]],
    [ "Midway Substation",[-94.85964117756721, 40.12754908129787]],
    [ "640908498",[-116.73413807726678, 44.59118063324257]],
    [ "Chesterfield Substation",[-77.38518451252675, 37.38136249493247]],
    [ "Big Stone South Substation",[-96.50693878670205, 45.28150812554223]],
    [ "641037399",[-97.74463239052959, 42.01686745113369]],
    [ "641061594",[-91.56674088449014, 40.64324465193324]],
    [ "Marshall Solar Project Substation",[-95.67136879041843, 44.47323077942689]],
    [ "641094522",[-149.5721046106092, 61.32546304992893]],
    [ "641388924",[-83.6063856328401, 42.68410981915452]],
    [ "641547713",[-78.13264666009344, 33.976234424768016]],
    [ "641644875",[-86.55806268272308, 41.05701121604321]],
    [ "SAGAMORE PLANT COGENERATION",[-86.86194976986712, 40.442010035996724]],
    [ "Commonwealth Edison",[-88.03083897485045, 41.01482369220452]],
    [ "Cedar Mountain Substation",[-94.82848222911966, 44.51537989343214]],
    [ "641960625",[-84.28692903518842, 30.432338334908525]],
    [ "Helena Substation",[-93.65683184367232, 44.55506529048502]],
    [ "642031734",[-76.0797718, 40.21687845]],
    [ "642221669",[-79.3786253604698, 36.57649824853721]],
    [ "Danville Utilities",[-79.37887064962257, 36.57721097866664]],
    [ "Cartwright Substation",[-112.16069096331277, 33.48728719363484]],
    [ "Prince George Substation",[-77.29496843579116, 37.25629555053641]],
    [ "Oakland City Substation",[-87.33900452544296, 38.34926885804708]],
    [ "Hirsch Rd. Substation",[-87.48314292468027, 38.020135701978376]],
    [ "642666166",[-87.4201765628967, 37.98649142498884]],
    [ "Fuquay Substation",[-87.4603400557952, 37.955288174640174]],
    [ "642678575",[-87.52486009012823, 37.851661166966444]],
    [ "642707431",[-87.51714360536181, 37.65003498694698]],
    [ "642712230",[-87.63670490000001, 37.6839]],
    [ "642718793",[-87.58477184461, 37.61553178979455]],
    [ "642724330",[-87.71067689478494, 37.66446912144005]],
    [ "642744975",[-97.04786494999999, 32.71513255]],
    [ "642935057",[-87.27930242129372, 37.606135555132624]],
    [ "642936067",[-86.98610142047605, 37.595537108120965]],
    [ "643021041",[-86.45559875000001, 37.9384223]],
    [ "643027644",[-87.39149367271038, 37.42688269552888]],
    [ "Kentucky Utilities Company",[-87.73658593375305, 37.37993164759097]],
    [ "643028147",[-87.73515208106367, 37.37929478653166]],
    [ "643029735",[-87.48358351005997, 37.40385846838851]],
    [ "Kentucky Utilities Company",[-87.23858550574697, 37.27968870192017]],
    [ "643137161",[-87.18791493787522, 37.21980229809735]],
    [ "643142749",[-87.31566815, 37.297535950000004]],
    [ "643144279",[-105.63221844924027, 44.78208716608705]],
    [ "643185696",[-87.01472095, 37.4173465]],
    [ "Georgia Power",[-84.58199559465217, 34.106991521923476]],
    [ "Georgia Power",[-84.58280168590069, 34.106901091018784]],
    [ "643395212",[-85.92444341795928, 37.67220059482948]],
    [ "643446431",[-96.91573159999999, 35.417865]],
    [ "643538426",[-85.20703535, 38.214192100000005]],
    [ "643584280",[-118.26182063863752, 33.80790227539558]],
    [ "643857543",[-82.4407718407407, 34.71916238297481]],
    [ "643857545",[-82.49532710675828, 34.710448106648094]],
    [ "643908425",[-86.43640183879722, 37.61453955823105]],
    [ "643909342",[-86.51892488090338, 37.5939473535267]],
    [ "643924527",[-86.30885657821793, 37.63247261111198]],
    [ "Kentucky Utilities Company",[-87.64979563123798, 37.220715703694346]],
    [ "Blue Ridge Energy",[-81.47593377445477, 36.37672014536335]],
    [ "Hospital Substation",[-85.64500885506351, 44.760814795067546]],
    [ "Cambridge Pumping Station",[-93.56903780703922, 41.9164491467002]],
    [ "Greensburg Substation",[-85.51028341429915, 37.2770846232665]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.50943075406609, 37.27063002209283]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.5067204494736, 37.26613783320018]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.35959623018552, 37.336916237578286]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.36339818465709, 37.31619251816718]],
    [ "645011995",[-84.22511966752819, 39.258442491770865]],
    [ "Kentucky Utilities Company",[-88.16957773938951, 37.05436089982982]],
    [ "Kentucky Utilities Company",[-88.07693982594245, 37.3211081448129]],
    [ "645096097",[-88.07689219582628, 37.32832681332007]],
    [ "Kentucky Utilities Company",[-87.95316688373254, 37.457913296847885]],
    [ "645098768",[-122.673798924433, 48.307493903673844]],
    [ "Kentucky Utilities Company",[-87.75249600000001, 37.4105294]],
    [ "645100605",[-87.74090864999998, 37.40715545]],
    [ "645101420",[-87.76753229503619, 37.393458282152125]],
    [ "645131460",[-88.2614057910069, 37.043234931692986]],
    [ "645134621",[-88.33391845124972, 36.929528829625774]],
    [ "Benton Substation",[-88.33701190816676, 36.85578057008131]],
    [ "645156949",[-77.99760053611772, 34.23183317458285]],
    [ "645164338",[-149.59444209999995, 61.3258808]],
    [ "Copperstone Substation",[-76.74174580920018, 40.29564881959023]],
    [ "Paxton Substation",[-76.75514123924545, 40.29645111516916]],
    [ "645288727",[-88.65360802446419, 36.73836530901496]],
    [ "645290435",[-88.64949698664866, 36.73566084081783]],
    [ "Kentucky Utilities Company",[-87.502885092246, 37.728125366799404]],
    [ "645335559",[-84.60173718372364, 38.75167477129331]],
    [ "645429970",[-82.34242870350687, 39.245678153951104]],
    [ "645434287",[-91.1542392, 42.48722305]],
    [ "645439586",[-84.56405030118356, 38.302051830209635]],
    [ "645439588",[-84.55052048908625, 38.28615487453821]],
    [ "645439592",[-84.53927043040497, 38.25497554598805]],
    [ "645532112",[-84.07823325785311, 39.55317779719]],
    [ "Minneota Substation",[-95.91007205, 44.6890549]],
    [ "Rockton Mountain",[-78.52708350469902, 41.073020535224664]],
    [ "Kentucky Utilities Company",[-84.4982171372013, 37.945292167044826]],
    [ "645748503",[-84.28086482610537, 37.87350485543805]],
    [ "645750042",[-84.18993140082291, 37.97702111680797]],
    [ "645750044",[-84.18753178321316, 37.98680439882239]],
    [ "645777409",[-94.0435596829927, 44.792196001844864]],
    [ "Diamond Substation",[-94.10209679952831, 44.7748476981166]],
    [ "645781988",[-122.93709506335387, 46.11502515421026]],
    [ "645820816",[-89.3881890100724, 40.16463294012632]],
    [ "Ameren",[-90.04533743860873, 40.27545982324001]],
    [ "645861438",[-89.61191619999998, 40.3296684]],
    [ "645918466",[-83.98396233204436, 39.46936186455527]],
    [ "646004810",[-84.3131044400401, 37.734777353029045]],
    [ "646018404",[-87.84098445431675, 37.93547332189229]],
    [ "646018406",[-87.86087033703852, 37.945646601441226]],
    [ "Water St. Substation",[-87.90005935, 37.928142750000006]],
    [ "646018411",[-87.8746066850035, 37.93559397508903]],
    [ "East Kentucky Power Cooperative, Inc.",[-84.32390190480844, 37.59631263975699]],
    [ "646031663",[-88.9446798653491, 40.53292612547551]],
    [ "646044430",[-84.4072469837965, 37.61834362837154]],
    [ "646093529",[-84.25744516109378, 37.33179797578739]],
    [ "646095146",[-78.94040922092924, 34.96294175898787]],
    [ "Kentucky Utilities Company",[-84.0954488, 36.9919959]],
    [ "Kentucky Utilities Company",[-84.07371640000001, 36.98181664999999]],
    [ "646103743",[-122.28847360000002, 37.798514850000004]],
    [ "646105541",[-84.15985784398364, 37.00021585621253]],
    [ "646105904",[-84.10857684999999, 37.10616745]],
    [ "Kentucky Utilities Company",[-84.1069441129622, 36.82855952308265]],
    [ "646115093",[-84.14924007013325, 36.90809258827363]],
    [ "646115128",[-84.11786954621721, 36.91783393483659]],
    [ "646116897",[-84.27172311762372, 36.68202342569022]],
    [ "646118606",[-84.16529762143881, 36.78503884256771]],
    [ "646121629",[-84.11368310673895, 36.57919508431024]],
    [ "646141490",[-80.1311071010871, 40.95842573333301]],
    [ "Archer Substation",[-157.85309483357352, 21.30094388430943]],
    [ "Kamoku Substation",[-157.8233040224454, 21.286723513927168]],
    [ "School Street Substation",[-157.86039608835085, 21.322947176030993]],
    [ "Airport Substation",[-157.91918788571417, 21.336879139986703]],
    [ "Airport Transition Station",[-157.92427871217131, 21.338985725291906]],
    [ "Knoxville Utilities Board",[-84.15664950196906, 35.906302419977415]],
    [ "Clair Substation",[-117.97648834371907, 33.81699449267333]],
    [ "Hannum Substation",[-117.96833964442172, 33.83746930813556]],
    [ "Anaheim Substation",[-117.91143551346214, 33.831056066126436]],
    [ "Dowling Substation",[-117.8569305110186, 33.853420078639665]],
    [ "Fairmont Substation",[-117.76831590112083, 33.856414488975]],
    [ "Park Substation",[-117.74664520358573, 33.864419814220156]],
    [ "Carlisle Substation",[-84.31509639104098, 39.58444216206487]],
    [ "West Athens Substation",[-84.64630245429913, 35.47056125036186]],
    [ "Denso Substation",[-84.64184195747946, 35.47556287869118]],
    [ "Cleveland Utilities",[-84.8933077101341, 35.192266524626056]],
    [ "Makalapa Substation",[-157.9272727327108, 21.35750861971612]],
    [ "Egypt Substation",[-89.727463884971, 35.49232412022696]],
    [ "647024516",[-80.63677204498568, 34.24359914558531]],
    [ "Waikiki Substation",[-157.82844605038062, 21.282979980625413]],
    [ "Kuhio Substation",[-157.82019039307292, 21.272660217406226]],
    [ "Kapahulu Substation",[-157.8158257469205, 21.27339994672234]],
    [ "647248610",[-89.22713423569475, 32.77647873033658]],
    [ "Florence Utilities",[-87.68201592958465, 34.82759436207875]],
    [ "647529717",[-89.41451285665612, 36.03607832568581]],
    [ "Forked Deer Electric Cooperative",[-89.50616609758345, 36.00406121133321]],
    [ "647533373",[-92.99898235519368, 45.14320850799165]],
    [ "Dyersburg Electric System",[-89.40031685000002, 36.05890835000001]],
    [ "647578148",[-94.9028493, 31.835485699999996]],
    [ "Colonia Substation",[-119.0964010856134, 34.20466619166584]],
    [ "Camarillo Substation",[-119.00861152123693, 34.22074423422701]],
    [ "Somis Substation",[-119.01086824367032, 34.26421889916535]],
    [ "Estero Substation",[-119.09567677395239, 34.14597119942676]],
    [ "Levy Substation",[-119.15679265494371, 34.173811529333236]],
    [ "San Miguel Substation",[-119.241860666424, 34.25599689906411]],
    [ "Ojai Substation",[-119.24229603245088, 34.44554080227049]],
    [ "Gonzales Substation",[-119.1758686806956, 34.226155041353316]],
    [ "FEUS Substation",[-108.18435874902704, 36.75536846074601]],
    [ "647844249",[-89.27456497620052, 35.57767398898216]],
    [ "647858545",[-77.98671513558868, 35.390424142436025]],
    [ "Henning Substation",[-89.58758555155853, 35.661611076479424]],
    [ "647909943",[-78.03003012386046, 35.41778801217805]],
    [ "648227955",[-89.27072861411853, 36.13778052402562]],
    [ "648262225",[-88.16607563088213, 40.296949939260024]],
    [ "648280183",[-92.68363688136175, 45.399464903706296]],
    [ "648340316",[-94.54717036612016, 31.680241477111338]],
    [ "Phoenix Substation",[-83.27712625000001, 33.366589250000004]],
    [ "Smyrna Substation",[-83.39792111500115, 33.59491353196577]],
    [ "Station 73",[-77.46888065723743, 43.23017406410731]],
    [ "648612268",[-79.41799335745915, 36.096111326511114]],
    [ "Ponce De Leon Substation",[-85.94650054272462, 30.733293317255132]],
    [ "Honolulu Substation",[-157.8633273564022, 21.30536891777885]],
    [ "Mokuone Substation",[-157.87893919894404, 21.306388548722627]],
    [ "Kalihi Substation",[-157.87716388325643, 21.329769243118136]],
    [ "Lagoon Substation",[-157.9020769678594, 21.328361832437544]],
    [ "Keehi Substation",[-157.91536304193886, 21.33486999892079]],
    [ "Hawaiian Electric Company",[-157.90194810730313, 21.344911153057616]],
    [ "Moiliili Substation",[-157.82549593770634, 21.29178171869298]],
    [ "Kaimuki Substation",[-157.8026412679302, 21.282742006254487]],
    [ "Hawaiian Electric Company",[-157.79039381416874, 21.284667508112253]],
    [ "Hawaiian Electric Company",[-157.81410333133317, 21.297428080072827]],
    [ "Woodlawn Substation",[-157.8053989512814, 21.313636615437694]],
    [ "Kearny Station Sub",[-74.10316226843112, 40.73772462192599]],
    [ "Marion Substation",[-74.07229320547758, 40.74931851013116]],
    [ "Essex Substation",[-74.12094662559966, 40.73860233859743]],
    [ "Hudson 345 kV Substation",[-74.07046323527996, 40.74809837837494]],
    [ "Bergen Substation",[-74.01619714634379, 40.833931382133436]],
    [ "ECRRF",[-74.12549815831373, 40.73766054503769]],
    [ "Mamala Substation",[-157.96204937843498, 21.330757952799914]],
    [ "Hickam Substation",[-157.94825449572323, 21.343704940468204]],
    [ "648961573",[-157.95252075214663, 21.34875444855946]],
    [ "648961575",[-157.93972693632566, 21.35466946392677]],
    [ "Aiea Substation",[-157.9329489675292, 21.377287542217527]],
    [ "Kaonohi Substation",[-157.93611252514197, 21.381838264882322]],
    [ "Waimano Substation",[-157.9654656777628, 21.404459009429516]],
    [ "Hawaiian Electric Company",[-157.96936178262064, 21.39209843566202]],
    [ "Hawaiian Electric Company",[-157.97291844799074, 21.388818530926525]],
    [ "Hawaiian Electric Company",[-157.99296759063648, 21.399202082215993]],
    [ "649075209",[-83.8924928, 39.44654935]],
    [ "649100215",[-115.99967305, 36.84996225]],
    [ "649116348",[-80.52090304999999, 25.499634949999997]],
    [ "649290911",[-88.9401982601901, 35.916328851593384]],
    [ "Trenton Light & Water Department",[-88.9517791751305, 35.94810409202365]],
    [ "Hazel Creek Substation",[-95.60200276920897, 44.77347930914116]],
    [ "Distributing Station 103 and Franklin Power Plant",[-118.41333522523007, 34.1039042452213]],
    [ "Dover Substation",[-87.83137198752189, 36.484191623706636]],
    [ "Red Top Substation",[-87.66758383756454, 36.54548172103063]],
    [ "Mansion View Substation",[-87.73199139208387, 34.86192502461513]],
    [ "649811438",[-79.29696387527298, 36.07738719304213]],
    [ "Lukefield Substation",[-112.35940519219004, 33.537493225810124]],
    [ "Arkansas Electric Cooperatice Corporation",[-92.607231150614, 34.54934672382085]],
    [ "Harrison Substation",[-71.0512798964204, 42.11899405564925]],
    [ "Entergy Arkansas",[-92.58872480708067, 34.54634372583277]],
    [ "Arkansas Electric Cooperatice Corporation",[-92.54055688652642, 34.500957229972705]],
    [ "650378250",[-92.90999967493747, 45.47146261117894]],
    [ "650379103",[-92.53447478469451, 34.574574481050405]],
    [ "Entergy Arkansas",[-92.59340186865354, 34.636150622408564]],
    [ "First Electric Cooperative",[-92.58694627556201, 34.682279992749]],
    [ "650389295",[-94.92776592107495, 29.8547903831297]],
    [ "650660853",[-93.0274843373186, 32.79973311927813]],
    [ "Claiborne Electric Cooperative",[-93.13116255128129, 32.79701637771334]],
    [ "Northkill Substation",[-76.12923640335431, 40.4470727459753]],
    [ "Fort Peck",[-106.41253998238645, 48.01214929221901]],
    [ "650742595",[-102.86314753875281, 48.40063972517238]],
    [ "650742596",[-102.91361453028715, 48.40104700267075]],
    [ "650742597",[-103.98366004348757, 48.61833099786186]],
    [ "650742602",[-102.92130925042794, 48.28508050797749]],
    [ "650748711",[-102.92135015848378, 47.7989223250283]],
    [ "650748713",[-102.93030577213074, 47.79929647984075]],
    [ "650748715",[-103.47071617499326, 47.86543074243812]],
    [ "Southwest Arkansas Electric Cooperative",[-93.9489749399673, 33.49571435925016]],
    [ "650814415",[-94.4217402, 33.4797302]],
    [ "650834921",[-94.49575182189234, 33.19933507385464]],
    [ "Southwest Arkansas Electric Cooperative",[-93.85813056030494, 33.32714562532578]],
    [ "650855179",[-94.03909304999999, 33.3304253]],
    [ "Distributing Station No. 88",[-118.58790995232255, 34.256318271406485]],
    [ "Maybrook Substation",[-74.22576304950962, 41.486450100333606]],
    [ "651375216",[-116.0495018, 36.9774942]],
    [ "651452152",[-116.05142964495795, 37.02582497999679]],
    [ "Waipahu Substation",[-158.0007656893596, 21.385306226827524]],
    [ "West Loch Substation",[-157.97618518861307, 21.363498360694848]],
    [ "Hoaeae Substation",[-158.0176834908327, 21.377461784733285]],
    [ "Fort Weaver Substation",[-158.03445900594542, 21.337800498289038]],
    [ "Ocean Pointe Substation",[-158.02567195, 21.3222972]],
    [ "Ewa Beach Substation",[-158.01660593351815, 21.3233220116913]],
    [ "Fort Weaver Substation",[-157.98591620000002, 21.325173]],
    [ "651481254",[-158.00542504055815, 21.35232762122138]],
    [ "Lone Gum Substation",[-79.43108695, 37.17945484999999]],
    [ "Whitehouse Substation",[-79.59171092057166, 37.12849046286791]],
    [ "LADWP Distributing Station No. 130",[-118.5006491132866, 34.16034655812476]],
    [ "Rebel Hill Substation",[-68.46164885, 44.7529212]],
    [ "651592610",[-97.12400477618979, 32.7687798374339]],
    [ "DISTRIBUTING STATION 83",[-118.48079402624984, 34.1554864641071]],
    [ "651847342",[-158.06078392360303, 21.32728518630035]],
    [ "Sand Island Substation",[-157.8872162676006, 21.313573854762836]],
    [ "Hawaiian Electric Kahala Substation",[-157.7835065350664, 21.28024153948562]],
    [ "Hawaiian Electric Company",[-157.77304558582352, 21.27758549589475]],
    [ "Hawaiian Electric Company",[-157.76055161267433, 21.291394377295795]],
    [ "Ahi Substation",[-157.7140986267179, 21.28905623345879]],
    [ "Hawaiian Electric Company",[-157.70155958270811, 21.289355896788198]],
    [ "Kamiloiki Substation",[-157.684598496828, 21.293566804553848]],
    [ "Hawaiian Electric Company",[-157.6684332352998, 21.296625122992385]],
    [ "Hawaiian Electric Company",[-157.75082152543519, 21.378271039679937]],
    [ "Kailua Substation",[-157.7462049552676, 21.394460412531238]],
    [ "Kailua Substation",[-157.74565239851228, 21.39458163096]],
    [ "651856396",[-83.90152592999532, 34.81942165426594]],
    [ "651932995",[-90.14126363966022, 32.33338442980526]],
    [ "652087964",[-96.41647730700974, 32.70286925322332]],
    [ "652089551",[-96.34221078926285, 32.79253630493852]],
    [ "652253906",[-85.2105655899579, 39.319763624886484]],
    [ "Center Star Substation",[-87.45654596558417, 34.86180512340484]],
    [ "Monroe Generation Substation",[-83.3480748, 41.8912069]],
    [ "DTE Energy",[-83.35421089966586, 41.892650169333805]],
    [ "DISTRIBUTING STATION 123",[-118.30030451075696, 33.78785167038556]],
    [ "Hawaiian Electric Company",[-157.74950839183106, 21.419577749299908]],
    [ "Mokapu Substation",[-157.75758897401377, 21.43764950478738]],
    [ "Kalaheo Substation",[-157.7541595115425, 21.428289557349093]],
    [ "Hawaiian Electric Company",[-157.81671845000002, 21.377020749999996]],
    [ "DISTRIBUTING STATION 111",[-118.39360606396261, 33.948214165066254]],
    [ "652742117",[-85.20901403189545, 39.4046473472191]],
    [ "Nottely Substation",[-84.0840898, 34.960664099999995]],
    [ "Blue Ridge Dam Substation",[-84.28461225, 34.8838831]],
    [ "Tennessee Valley Authority",[-84.5341871, 35.09446195]],
    [ "Georgia Power",[-81.1876804, 32.330534199999995]],
    [ "Georgia Power",[-84.90545946721502, 33.45334604790897]],
    [ "Yates Common Substation",[-84.90420047939254, 33.4616559703056]],
    [ "Georgia Power",[-84.27235608966333, 33.26290522122799]],
    [ "Bartletts Ferry Dam Substation",[-85.09208015562204, 32.66112246182129]],
    [ "Georgia Power",[-83.49745140741774, 33.32195922496926]],
    [ "Georgia Power",[-83.87387580712877, 33.45635890420985]],
    [ "652954473",[-84.66047120327985, 32.80348211864523]],
    [ "652954474",[-84.69342919098123, 32.79204997495856]],
    [ "Georgia Power",[-83.8431745351221, 33.32084220896034]],
    [ "Georgia Power",[-84.73289399820486, 33.42098138377859]],
    [ "652954513",[-85.18790489811614, 32.84908597969676]],
    [ "Georgia Power",[-84.80347920000001, 33.34097055]],
    [ "Georgia Power",[-85.0579863, 33.54985735]],
    [ "Georgia Power",[-85.06704546262708, 33.55962223763654]],
    [ "Clem Substation",[-84.99453597133103, 33.51239832203845]],
    [ "652954546",[-83.73994542517637, 32.56338090310571]],
    [ "Montezuma Substation",[-84.00716001941807, 32.29075661559525]],
    [ "LADWP Distributing Station No. 792",[-118.5886796448855, 34.167305318204875]],
    [ "Distributing Station 136",[-118.61103965169649, 34.186789877589064]],
    [ "DISTRIBUTING STATION 129",[-118.62296868012983, 34.16653101803284]],
    [ "LADWP Distributing Station No. 115",[-118.37535023579444, 34.12403867311429]],
    [ "Distributing Station 77",[-118.64330704991754, 34.18796837949963]],
    [ "DISTRIBUTING STATION 81",[-118.45915269441592, 34.20180397666829]],
    [ "DISTRIBUTING STATION 140",[-118.4394467532075, 34.19445459365376]],
    [ "Distributing Station 133",[-118.45122268122998, 34.23498780466444]],
    [ "DISTRIBUTING STATION 124",[-118.43994229687206, 34.131845204984145]],
    [ "DISTRIBUTING STATION 57",[-118.39592190357413, 34.1706672197569]],
    [ "Sneedville Substation",[-83.21894111884663, 36.53567571030232]],
    [ "653441000",[-102.3108601, 33.5864075]],
    [ "653442108",[-102.34845071726133, 33.61576572525551]],
    [ "653448234",[-102.34718507528996, 33.6316734946833]],
    [ "653501743",[-80.53298300000002, 35.018493899999996]],
    [ "653513983",[-102.43061741742767, 33.587961026296966]],
    [ "Hawaiian Electric Company",[-157.79159240724826, 21.405595460518395]],
    [ "Hawaiian Electric Company",[-157.8042874572859, 21.412733469515537]],
    [ "Hawaiian Electric Company",[-157.84188783501435, 21.459631594641955]],
    [ "653518650",[-157.84225884228576, 21.459725592674268]],
    [ "653518651",[-157.89371776439648, 21.583786458912826]],
    [ "Hauula Substation",[-157.9146671683893, 21.612016591041836]],
    [ "Kahuku Substation",[-157.94791672008063, 21.676415690287065]],
    [ "Kahuku Wind Farm Substation",[-157.97148150652365, 21.6867420135207]],
    [ "Kuilima Substation",[-157.9943293100023, 21.69018803890173]],
    [ "Waimea Substation",[-158.05975583497315, 21.653069561732586]],
    [ "Waialua Substation",[-158.10669492852998, 21.57696087229535]],
    [ "Platt Springs Road",[-81.22770754999999, 33.90694585]],
    [ "Southwestern Power Administration",[-91.05308155176063, 36.24982955577945]],
    [ "Farmers Electrical Cooperative Cooperation",[-91.38933925, 35.512577699999994]],
    [ "Los Angeles Department of Water and Power",[-118.42807221359554, 34.027932278112644]],
    [ "Bald Knob Substation",[-91.5617663912529, 35.32841117434867]],
    [ "653793854",[-91.15638489627341, 36.138228711706894]],
    [ "653815791",[-91.51853926818193, 36.38860164616238]],
    [ "653815793",[-91.51581054786254, 36.50825739063304]],
    [ "653815797",[-91.51648526254309, 36.51172918025182]],
    [ "Craycroft Substation",[-110.87380697816378, 32.202763559659765]],
    [ "653845362",[-158.0428257329758, 21.526457032219987]],
    [ "Kawailoa Makai Substation",[-158.07618065668166, 21.620240464517543]],
    [ "First Electric Cooperative Cooperation",[-92.02708651135224, 35.32730312971223]],
    [ "First Electric Cooperative Cooperation",[-92.06541048609965, 35.193666668776686]],
    [ "Centralia",[-89.15392940230825, 38.50427620902117]],
    [ "Scotland Substation",[-92.60245544224811, 35.51954389326709]],
    [ "Petit Jean Electric Cooperative Corporation",[-92.45451127415417, 35.607353257917886]],
    [ "Cleveland Substation",[-92.70541200826804, 35.43720057544604]],
    [ "Marshall-DeKalb Electric Cooperative",[-85.825079, 34.240412199999994]],
    [ "Leesburg Substation",[-85.76571342844528, 34.190397468582745]],
    [ "654098478",[-85.76058395399238, 34.18713912972898]],
    [ "Kapalama Substation",[-157.8831777826756, 21.32347767180732]],
    [ "Hawaiian Electric Company",[-157.85341659051227, 21.31510354165566]],
    [ "Pauoa Substation",[-157.84229678434966, 21.319458592667512]],
    [ "Hawaiian Electric Company",[-157.85143447583985, 21.332497555055035]],
    [ "Hawaiian Electric Company",[-157.83499413709322, 21.340173827338155]],
    [ "Hawaiian Electric Company",[-157.86701213620535, 21.334535015956906]],
    [ "Hawaiian Electric Company",[-157.86353638526026, 21.34314741890992]],
    [ "Hawaiian Electric Company",[-157.85883042992873, 21.355353087263154]],
    [ "Mapunapuna Substation",[-157.89451621744587, 21.3403228164124]],
    [ "654133031",[-157.8972582245968, 21.360126803188475]],
    [ "Hila Substation",[-157.9018643441441, 21.36463534396781]],
    [ "Quarry Substation",[-157.90998167839885, 21.37463588452023]],
    [ "Keevil Substation",[-91.245333675078, 34.76580395559774]],
    [ "Des Arc Substation",[-91.5096245, 34.984746599999994]],
    [ "654152848",[-91.74968607488964, 32.24275230591779]],
    [ "Cooperative Energy",[-89.4717941620696, 31.314364191161907]],
    [ "Oak Ridge Substation",[-83.268489200381, 42.139052697646186]],
    [ "DuBois Substation",[-78.73102945968941, 41.11995737117341]],
    [ "Alabama Power",[-86.1165739122604, 34.10916030179925]],
    [ "654591605",[-108.53855380000002, 31.7634129]],
    [ "654820780",[-89.26711965000003, 31.2210106]],
    [ "LADWP Distributing Station No. 91",[-118.55251264956075, 34.160135029910776]],
    [ "DISTRIBUTING STATION 65",[-118.55289431789951, 34.17236005628125]],
    [ "DISTRIBUTING STATION 96",[-118.42425842408979, 34.312143875445464]],
    [ "Distributing Station 107",[-118.45056602223154, 34.30783683989111]],
    [ "655205756",[-81.48768993349653, 37.22764726129496]],
    [ "655270664",[-115.18291837394375, 36.08201150172407]],
    [ "Killen Substation",[-87.54423045000001, 34.8602226]],
    [ "Distributing Station 2",[-118.18945711793212, 34.11390994475847]],
    [ "655366965",[-85.79329399999999, 40.91289559999999]],
    [ "655366978",[-86.39142784358533, 40.576042395555305]],
    [ "DISTRIBUTING STATION 3",[-118.27937848766771, 33.74951017199344]],
    [ "Distributing Station 36",[-118.21447236387324, 34.08666662706975]],
    [ "DISTRIBUTING STATION 47",[-118.37622377085722, 33.9312437936079]],
    [ "DISTRIBUTING STATION 50",[-118.1783650673625, 34.083092534064264]],
    [ "DISTRIBUTING STATION 51",[-118.26582497764451, 33.77809373360561]],
    [ "Distributing Station 55",[-118.34657434661624, 34.06929868428507]],
    [ "Distributing Station 61",[-118.29999703500957, 34.06381647139483]],
    [ "DISTRIBUTING STATION 62",[-118.42282677663088, 34.20601042962051]],
    [ "DISTRIBUTING STATION 68",[-118.52876254881033, 34.25673720649446]],
    [ "LADWP Distributing Station No. 69",[-118.45920085225582, 34.264069045372224]],
    [ "DISTRIBUTING STATION 73",[-118.43967920142744, 34.157992776028145]],
    [ "Menoher Substation",[-158.07000606012602, 21.49766933071566]],
    [ "Castner Substation",[-158.04950026427275, 21.493496714168145]],
    [ "Wheeler Substation",[-158.04054887383643, 21.48671270989761]],
    [ "655494668",[-158.05470894941274, 21.471762192348802]],
    [ "Mililani Substation",[-158.006284, 21.46525045]],
    [ "655494670",[-157.9657318759339, 21.4776708832095]],
    [ "655494671",[-158.01578184371695, 21.427934270215257]],
    [ "Hawaiian Electric Company",[-158.03555907432454, 21.391708654537513]],
    [ "655498109",[-158.05338327749877, 21.386819007308596]],
    [ "655498110",[-158.06450851671065, 21.353462450678762]],
    [ "Ko Olina Substation",[-158.11515250909147, 21.333848195009598]],
    [ "655498112",[-158.10969799494399, 21.32320841893233]],
    [ "Hawaiian Electric Company",[-158.10450805, 21.30659935]],
    [ "655498115",[-158.10168251452373, 21.297109100383313]],
    [ "Hawaiian Electric Company",[-158.10210129145452, 21.304403045318907]],
    [ "655498117",[-158.1010804863349, 21.304514967460968]],
    [ "Kalaeloa Substation",[-158.09707340343002, 21.302187440399976]],
    [ "655498119",[-158.09346075549792, 21.305549169201825]],
    [ "Mikilua Substation",[-158.16346475238487, 21.421705476276998]],
    [ "655499001",[-158.1598450101927, 21.426179825292824]],
    [ "655499002",[-158.1513701348194, 21.440409378852877]],
    [ "Makaha Substation",[-158.20465889566938, 21.47066301103474]],
    [ "655507532",[-115.24168149528774, 36.236336751948436]],
    [ "DISTRIBUTING STATION 137",[-118.4337826749921, 33.95859476796226]],
    [ "LADWP Distributing Station No. 131",[-118.50112808164624, 34.23625407265589]],
    [ "Duke Energy",[-85.20849756118103, 39.29247295049878]],
    [ "Lakota Rd",[-89.17163735969727, 46.053253453311704]],
    [ "Twin Falls SW STA",[-88.06886237556141, 45.87186316383133]],
    [ "655674574",[-87.95367805000001, 45.79611365]],
    [ "655706666",[-78.7407071531431, 39.0448491107636]],
    [ "655706682",[-79.02067842019476, 39.40365036919591]],
    [ "Junction Substation",[-78.85370466320875, 39.31387967209641]],
    [ "655706690",[-78.64697167865386, 39.28986659613675]],
    [ "655706692",[-78.4825179435513, 39.27520784689128]],
    [ "Harrington Substation",[-67.79784240000001, 44.622173849999996]],
    [ "Tunk Substation",[-68.10877090860302, 44.54401632134379]],
    [ "655722523",[-83.34666098707036, 37.7620625346324]],
    [ "Los Angeles Department of Water and Power",[-118.2738288418707, 34.052806702222185]],
    [ "DISTRIBUTING STATION 87",[-118.30997298852802, 34.08000961975951]],
    [ "DISTRIBUTING STATION 89",[-118.29299047408747, 33.72763169636312]],
    [ "Distributing Station 93",[-118.22621621321183, 34.1206645116251]],
    [ "DISTRIBUTING STATION 121",[-118.26876120888377, 33.74010893032978]],
    [ "DISTRIBUTING STATION 100",[-118.38862303882239, 34.19420356991181]],
    [ "LADWP Distributing Station No. 101",[-118.42728203719587, 34.26280843851806]],
    [ "LADWP Distributing Station No. 105",[-118.29144842264286, 33.84716898884164]],
    [ "DISTRIBUTING STATION 67",[-118.3885658374139, 34.22272594836948]],
    [ "DISTRIBUTING STATION 74",[-118.5984433968203, 34.229139949934726]],
    [ "West Marinette SW YD",[-87.68890311114932, 45.08637832599958]],
    [ "Arnold Substation",[-87.50768348849526, 46.05798716627627]],
    [ "Cabin Creek Substation 46KV",[-81.4767293472788, 38.198942078710125]],
    [ "Cabin Creek Substation 138KV",[-81.48014104637959, 38.196688237276945]],
    [ "656101900",[-82.77444180909356, 31.034163653879098]],
    [ "656242453",[-83.76089586552257, 34.537616122419074]],
    [ "Birch Substation",[-93.122407735307, 45.108499891057434]],
    [ "Carroll Electric Cooperative Corporation",[-93.54343786508888, 36.37007357072755]],
    [ "International Falls Substation",[-93.38008824466237, 48.55415677251242]],
    [ "Running Substation",[-93.56676872371654, 48.398804717993805]],
    [ "Birchdale Substation",[-94.14616913590622, 48.62786769928531]],
    [ "Huntsville Substation",[-85.07191604912228, 40.07671975226716]],
    [ "656631465",[-85.01654886178177, 40.120701109030776]],
    [ "Mitchell Substation (230kV)",[-84.1338426, 31.447120849999997]],
    [ "Forest Industrial Substation",[-89.49808595, 32.3557252]],
    [ "Magnolia East Substation",[-93.19865849266327, 33.2825032744851]],
    [ "Asama Coldwater Manufacturing Substation",[-82.63935362614811, 33.41366000923587]],
    [ "Mountain EMC",[-81.92423829079416, 36.0681166971489]],
    [ "Bonneville Power Administration",[-123.41448952894925, 46.14890665290942]],
    [ "657088194",[-86.69874854871844, 37.89515676660545]],
    [ "657088660",[-79.77251069402847, 34.60289196926285]],
    [ "657093979",[-97.53105386336875, 32.76886173862801]],
    [ "Mississippi Power",[-88.85879163613428, 32.02678004995003]],
    [ "657113793",[-77.20902010000002, 35.05601995]],
    [ "Southwest Arkansas Electric Cooperative",[-93.9873289255217, 33.381374024408274]],
    [ "Quitman Northwest Substation",[-88.73475121452766, 32.042155719201595]],
    [ "657424281",[-79.57670049211194, 36.05870617744049]],
    [ "Rockwood Substation",[-83.25605546671167, 42.07359162976654]],
    [ "Tollette Substation",[-93.89697371581765, 33.81875476463036]],
    [ "657607071",[-96.63609388426119, 43.600340858469266]],
    [ "657749169",[-81.61823270899379, 34.72507836331582]],
    [ "657749170",[-81.64656426238012, 34.72247782499891]],
    [ "Hoosier Energy",[-85.3458586437503, 39.217746414050104]],
    [ "657848419",[-85.28481237511077, 39.125439804822705]],
    [ "Georgia Pacific",[-88.02394054999998, 32.225822799999996]],
    [ "658171805",[-88.0495897207981, 32.228689404829474]],
    [ "658187580",[-86.78697946670565, 32.32482600506729]],
    [ "658187592",[-86.87379535000001, 32.411739850000004]],
    [ "658194443",[-86.93412121077571, 40.39228396932152]],
    [ "Southwest Arkansas Electric Cooperative",[-93.70751570011423, 34.247085686687065]],
    [ "Entergy Arkansas",[-93.6268394989982, 34.07847566664354]],
    [ "Entergy Arkansas",[-93.62606331721847, 34.07923683728715]],
    [ "658333083",[-97.28446412225507, 31.98454294102885]],
    [ "658632962",[-97.51316109381146, 35.645101607581225]],
    [ "658674917",[-92.66631069016906, 36.961497433056714]],
    [ "Civic Substation",[-75.19873393521526, 39.94436437643196]],
    [ "Quinn Substation",[-82.89122469845324, 42.546862391314725]],
    [ "Hammonds Substation",[-80.85674185, 33.73184140000001]],
    [ "Mercury Substation",[-83.20645237747127, 42.32088299478254]],
    [ "659157324",[-98.42519013757587, 34.649247388586]],
    [ "659235740",[-98.52139710327657, 34.60713820056473]],
    [ "County Drive Substation",[-89.28911615, 31.30145605]],
    [ "659446613",[-90.8957207475305, 47.54729332186051]],
    [ "659457621",[-78.18826299557288, 35.12300838357582]],
    [ "659458102",[-78.22625094530706, 35.09429920678804]],
    [ "International Paper Company",[-90.77679621260971, 32.52806462783414]],
    [ "Tell City Substation",[-86.7740738, 37.95500295]],
    [ "Waupaca Substation",[-84.52353219309961, 35.362847166490425]],
    [ "659503315",[-84.5154743, 35.37127635]],
    [ "659518562",[-82.09150988768317, 36.66825102422449]],
    [ "Willamette Substation",[-78.67356726280107, 41.494857178972374]],
    [ "Lutsen Substation",[-90.47269733393487, 47.724834092256]],
    [ "659565189",[-75.58065296913752, 41.45828795567763]],
    [ "Claiborne Electric Cooperative",[-93.22050435991194, 32.65094937989159]],
    [ "State Line Substation",[-88.48326242478548, 31.4330229931498]],
    [ "659962304",[-82.80818224462726, 36.47173148163653]],
    [ "Wiggins Coastal Paper Company",[-89.13545461954128, 30.841334735085013]],
    [ "Water Street Substation",[-81.65643235, 30.325267150000006]],
    [ "Russellville Substation",[-83.55622761262336, 43.09170007471845]],
    [ "660401465",[-77.44581837791101, 34.80511488570348]],
    [ "Langboard Substation",[-83.48032352505724, 30.785318757109394]],
    [ "Spring Creek Switching Station",[-84.76008475, 31.153475250000003]],
    [ "Georgia Power",[-83.9809876520359, 30.83358932319236]],
    [ "660606053",[-84.88779779999999, 30.674872799999992]],
    [ "Georgia Power",[-84.80713439075123, 32.200339368425446]],
    [ "Georgia Power",[-84.80745323384447, 32.20001560736678]],
    [ "Cuthbert Primary Substation",[-84.76231443001437, 31.76647046142852]],
    [ "George Dam Substation",[-85.06514781583485, 31.62308984615061]],
    [ "Entergy Arkansas",[-92.98500688575058, 34.580905486676215]],
    [ "Entergy Arkansas",[-93.00318521055034, 34.61942062202184]],
    [ "Walnut Creek",[-97.37193695943695, 34.98684732509868]],
    [ "660651618",[-97.21405995466557, 34.808618775080156]],
    [ "Bagley Substation",[-76.40197999618889, 39.49851952442194]],
    [ "Millville Substation",[-77.7878141234355, 39.27380116684042]],
    [ "660809591",[-78.2041004, 38.929666499999996]],
    [ "High Point Substation",[-79.26099115626032, 39.793990042703804]],
    [ "660809598",[-80.7955537650221, 39.906725119262184]],
    [ "Necessity Substation",[-79.57646248350618, 39.7902198302821]],
    [ "Bedford North Substation",[-78.51640099557657, 40.07151785761026]],
    [ "Snake Spring Substation",[-78.40903158684472, 40.019797773514526]],
    [ "Claysburg Substation",[-78.4504206785105, 40.31390400712833]],
    [ "Saxton Substation",[-78.2426534138692, 40.227070475272114]],
    [ "Three Springs Substation",[-77.97835218249595, 40.20044172192364]],
    [ "Greene Substation",[-77.61580464999999, 39.99763845]],
    [ "York Haven Tap",[-76.71525240587484, 40.1142492524107]],
    [ "Roundtop Substation",[-76.95407568103586, 40.09072536092004]],
    [ "Hunterstown Generation",[-77.16883429474787, 39.8727896749092]],
    [ "Georgia Power",[-81.50131184393317, 31.190169165271712]],
    [ "Georgia Power",[-81.55309716740584, 31.27193519888702]],
    [ "661011036",[-101.42140725000002, 40.930684649999996]],
    [ "Sherwood Substation",[-73.31600345249879, 41.12157417422088]],
    [ "South Mountain Substation",[-111.88231028978863, 40.48968286362052]],
    [ "Sasco Creek Substation",[-73.30799578329753, 41.124248020295]],
    [ "Alpine Substation",[-83.28613396847751, 42.5592030941953]],
    [ "661339571",[-80.50906144697292, 34.98601563407191]],
    [ "661339572",[-80.50783350553708, 34.98669313622406]],
    [ "661387044",[-115.28279015144896, 36.02700254981791]],
    [ "661610744",[-93.04176669519336, 44.7829510014416]],
    [ "661640806",[-80.6118962, 35.01664275]],
    [ "Charlotte Substation",[-73.26141383448527, 44.31243966092649]],
    [ "Shelburne Substation",[-73.23861959697605, 44.38357239490172]],
    [ "White Oak Solar Substation",[-82.11623785876473, 33.03882607426184]],
    [ "White Oak Solar Switching Station",[-82.1154907183002, 33.03827076549053]],
    [ "662325279",[-83.32071491081544, 34.374096982027176]],
    [ "Jackson Substation",[-83.96593397390149, 33.28518440697763]],
    [ "Georgia Power",[-84.36018834538609, 32.96848142042818]],
    [ "Georgia Power",[-84.27756140000001, 33.187608999999995]],
    [ "662456049",[-80.62979788123107, 38.2814302870122]],
    [ "662472107",[-81.51978029411919, 39.36703875421853]],
    [ "662472113",[-81.25837069999999, 38.10901285]],
    [ "662728410",[-100.81405985588361, 37.14036993368099]],
    [ "662770453",[-91.73226771113055, 46.152664878316514]],
    [ "662770459",[-91.76687687070118, 46.20698553353852]],
    [ "662770465",[-91.76419294029681, 46.207530429121235]],
    [ "662770467",[-91.86355225, 46.393489800000005]],
    [ "662770468",[-91.86382455602464, 46.39397736909036]],
    [ "662820941",[-100.89678627446294, 37.05404024368546]],
    [ "Prospect Substation",[-83.61110797858386, 42.32444637643135]],
    [ "663206942",[-96.80382148277867, 32.65386116641061]],
    [ "663303808",[-91.25788704944505, 45.75744951996139]],
    [ "663303810",[-91.43105139431277, 45.800477940840494]],
    [ "663303817",[-91.5115563, 45.87065965]],
    [ "663303824",[-91.51120418910446, 45.89076416928891]],
    [ "663303825",[-91.51129129999998, 45.89047694999999]],
    [ "663303841",[-91.51861015, 45.899649350000004]],
    [ "663343499",[-90.42559647818712, 42.596982437270945]],
    [ "Jaggard Substation",[-94.91306542524929, 39.07290901243739]],
    [ "Nixon Substation #4",[-83.50441249231, 32.927789951713756]],
    [ "Parkway Substation",[-113.51617851639136, 37.151255270686256]],
    [ "Saddlebrooke Substation",[-110.87469500075387, 32.52168588435686]],
    [ "663667986",[-81.76866002335689, 33.151070455389245]],
    [ "663680217",[-95.2596615915524, 32.29475160480571]],
    [ "663687742",[-89.78530795000002, 35.9143626]],
    [ "Yokohama Tire Manufacturing Mississippi, LLC",[-88.60378885, 33.6464625]],
    [ "Navopache Electrical Co-Op",[-110.01839652654468, 34.260738971580444]],
    [ "Conover",[-89.17131797062059, 46.055006821027334]],
    [ "Jonesboro City Water and Light",[-90.57907481545661, 35.811781782340695]],
    [ "Georgia Power",[-83.66769645174108, 33.97601921349854]],
    [ "663986942",[-90.95697255603737, 45.5544460718194]],
    [ "663986945",[-90.95925056799992, 45.55523281514751]],
    [ "663986948",[-91.14717259999999, 45.461815]],
    [ "663986950",[-91.13270980000001, 45.439726549999996]],
    [ "663986961",[-91.25717628673895, 45.47524154814418]],
    [ "663992870",[-80.81675251125391, 35.37336257458827]],
    [ "664013719",[-90.11468480311481, 38.70550599750752]],
    [ "664013720",[-90.13744653812424, 38.686979095371605]],
    [ "664016530",[-114.06889935, 35.13844664999999]],
    [ "Entergy Louisiana",[-90.45806296194094, 30.03294677373598]],
    [ "Entergy Arkansas",[-92.66069365, 33.207098900000005]],
    [ "664032088",[-97.029138424773, 32.45597699401373]],
    [ "664034822",[-80.35339580313956, 40.991097874826664]],
    [ "Nejesco Substation",[-74.3221215804885, 40.47724933842627]],
    [ "Rosanna Substation",[-115.24572370891657, 36.14305055229927]],
    [ "664155631",[-80.60516851014503, 40.48288309334722]],
    [ "Dismal River Substation",[-82.03374072740871, 37.240577158520786]],
    [ "664185788",[-80.44417870862014, 40.62660731135192]],
    [ "Rising Sun Substation",[-93.41274381668393, 41.57679794139495]],
    [ "Walcott Substation",[-90.8117508, 41.565160649999996]],
    [ "664191654",[-87.52585641817643, 38.62344663029033]],
    [ "664270035",[-96.81540350578555, 32.66190433751196]],
    [ "664275615",[-83.00405949970664, 39.0162114330835]],
    [ "Peach Valley Tie Substation",[-81.89636423878113, 35.00644160760125]],
    [ "PECO Emilie Substation",[-74.84541309408179, 40.14468054871127]],
    [ "Bonneville Power Administration",[-121.21515471745634, 45.61209794725416]],
    [ "664312319",[-102.76532969460021, 47.410353467232795]],
    [ "Cork Street Substation",[-85.5213519452782, 42.25818029895272]],
    [ "664543577",[-115.18710973601503, 36.08742304763671]],
    [ "Hazel Park Substation",[-83.11345626723468, 42.4613539736275]],
    [ "664636839",[-102.86372556637336, 47.41476402514952]],
    [ "664723174",[-92.64656410086849, 45.411371907670535]],
    [ "664723184",[-92.5800532, 45.36758440000001]],
    [ "664723204",[-92.57927876560919, 45.36738033429818]],
    [ "664723212",[-92.30749765129485, 45.37259998590103]],
    [ "664743525",[-92.32531422561318, 44.85962427889916]],
    [ "664743533",[-92.34013657034104, 45.03475010901554]],
    [ "Glenmont",[-92.71156815080096, 44.87732415557511]],
    [ "Fenton Substation",[-83.70010099946576, 42.79694589985864]],
    [ "665192962",[-82.84266345880013, 35.537998449153775]],
    [ "Hopkinsville Substation",[-87.48012492689779, 36.944378305678]],
    [ "Paducah Power System",[-88.70569805535824, 37.09039866741642]],
    [ "Mullin Creek Substation",[-94.87170896784937, 40.22691736131113]],
    [ "Porter Substation",[-83.65632289439661, 42.93657392341987]],
    [ "Grand Blanc BOC Substation",[-83.64784362614748, 42.93075170565835]],
    [ "665412208",[-97.22244723442401, 32.79289901473946]],
    [ "665466595",[-95.22719228147031, 40.22738882657017]],
    [ "Spruce Pine Substation",[-82.09031794624444, 35.91111907038987]],
    [ "665482884",[-80.87914627504946, 35.7743967939057]],
    [ "665482885",[-80.88146793118423, 35.77637764786552]],
    [ "Orrington Substation",[-68.75233404449148, 44.73834243565591]],
    [ "Bucksport Substation",[-68.8061894492025, 44.574781135385194]],
    [ "Detroit Substation",[-69.36213431185732, 44.79297994338338]],
    [ "Dogtown Substation",[-69.3636699, 44.794201849999986]],
    [ "665640281",[-89.26343798933217, 34.30371332172514]],
    [ "Dairyland Power Cooperative",[-91.56798803526961, 44.90191491159319]],
    [ "Roseberry Creek Substation",[-86.03770652073021, 34.64762118213614]],
    [ "Asheboro East Substation",[-79.79906984885636, 35.70774550545903]],
    [ "665751101",[-115.97860162485915, 33.1253272929092]],
    [ "665898008",[-97.35042215511051, 33.030873351514416]],
    [ "665913463",[-119.31436697942458, 46.26090168935153]],
    [ "Center Road Substation",[-83.63020227093945, 43.02045249896305]],
    [ "Kings Row Substation",[-97.09869454228652, 33.24990043632691]],
    [ "666189417",[-97.13077875000002, 32.65614485]],
    [ "Rodenberg Substation",[-88.93943779146305, 30.40749642502742]],
    [ "Mississippi Power",[-88.97037300169868, 30.403631091491967]],
    [ "Zebulon Road Substation",[-83.77847335, 32.8804057]],
    [ "666518239",[-78.6801596056452, 36.06596907542779]],
    [ "666518814",[-83.40565603310863, 34.54939622592765]],
    [ "666551358",[-91.87414099859863, 44.90024394451843]],
    [ "666684916",[-76.74621045, 37.94038315]],
    [ "666764367",[-95.13051131338041, 43.14672943225523]],
    [ "Manchester Substation",[-76.72262195786998, 40.057735475131125]],
    [ "Stonewater Substation",[-77.54106283820332, 39.05736328005035]],
    [ "Belmont Substation",[-77.53995238811412, 39.05819856633845]],
    [ "666827322",[-77.91459038716276, 35.706504884353784]],
    [ "666827323",[-77.93111962065248, 35.758590104112194]],
    [ "666827329",[-77.95646010444709, 35.736285605365794]],
    [ "667045553",[-91.51473246704803, 44.8853842452015]],
    [ "667048849",[-97.01204263465397, 32.97371944696099]],
    [ "Bay Substation",[-74.1545258747678, 40.44315950413663]],
    [ "667275716",[-97.0833185353948, 32.68003556030069]],
    [ "667564333",[-84.43506252285798, 38.01467496112694]],
    [ "667568655",[-84.54646997897403, 38.19942977449454]],
    [ "667634313",[-79.04775141309682, 39.430247739242226]],
    [ "667634315",[-79.04112827959496, 39.44027215767151]],
    [ "AEP Kankakee Substation",[-86.27781689943815, 41.65960358907487]],
    [ "Haymond Station",[-85.3847424864128, 40.197395037682725]],
    [ "Scottsboro Electric Power Board",[-86.08060045765555, 34.61944602017384]],
    [ "667958241",[-86.08305883178843, 34.61787809780039]],
    [ "667962429",[-91.91235545586436, 44.30390323491788]],
    [ "668050941",[-88.95851869999998, 38.32841385]],
    [ "Ameren",[-88.90434689698556, 38.17100687573754]],
    [ "Virginia Electric and Power Company",[-79.35269297468315, 36.945507968679784]],
    [ "Dixiana Substation",[-81.08987877522132, 33.923047105503876]],
    [ "CLECO",[-91.35859473979869, 29.69287638232132]],
    [ "668167421",[-86.31739005238506, 40.759187726515684]],
    [ "668260118",[-85.9252629, 41.727704149999994]],
    [ "668349152",[-82.36163954377011, 35.60628792879126]],
    [ "668365476",[-91.62854939364587, 44.75387588632588]],
    [ "668489896",[-81.72448063253167, 39.62927318538911]],
    [ "Florence Substation",[-79.09413224930272, 40.44175519010706]],
    [ "668508318",[-85.00017351174382, 41.674142197207416]],
    [ "668514382",[-78.44186105068803, 42.09047521310389]],
    [ "Newington Energy Substation",[-70.80597929765962, 43.105299642982864]],
    [ "McConnellsburg Substation",[-78.00259927758081, 39.92540547341044]],
    [ "Guilford Substation",[-77.69092282992227, 39.86392353009414]],
    [ "668568077",[-77.68640655, 39.93472195]],
    [ "Water Co. Fall Creek Substation",[-86.12331828878706, 39.83550382510105]],
    [ "Northeast",[-86.11050542060639, 39.855762129461986]],
    [ "668775274",[-92.21684205584006, 44.72526370080921]],
    [ "Loop LLC",[-90.17586422392773, 29.15677853492496]],
    [ "668813150",[-80.81542776023674, 35.59491853082636]],
    [ "669034968",[-78.85152201989952, 35.88453533073738]],
    [ "669038273",[-84.08797683409418, 33.99936452383714]],
    [ "Suwanee Substation",[-84.06938023850796, 34.06599062555697]],
    [ "669040386",[-78.95836630097784, 35.92488343578842]],
    [ "Hillman Substation",[-90.46629492958323, 42.71873557679511]],
    [ "Carroll Electric",[-94.155901, 36.355381099999995]],
    [ "669354225",[-87.4046523164018, 34.5767682994469]],
    [ "Newark Electric",[-75.74177487259387, 39.67552737801726]],
    [ "City of Bentonville",[-94.18209095, 36.359372050000005]],
    [ "East Centerton Substation",[-94.2457604745652, 36.358347305456654]],
    [ "JEA Station",[-81.38654890000001, 30.2395888]],
    [ "Davis Substation",[-75.74340218412021, 39.67261857410957]],
    [ "City of Bentonville",[-94.20359783970156, 36.34492571320483]],
    [ "City of Bentonville",[-94.19859274043809, 36.361679200230896]],
    [ "669511656",[-84.13459662109611, 33.261926186664645]],
    [ "669525625",[-95.4191822700814, 35.670625947312644]],
    [ "669537704",[-89.96169333487296, 36.54202038755878]],
    [ "669542800",[-88.29105010590546, 44.38554537525202]],
    [ "AEP East Side Substation",[-86.2159071902314, 41.6711533625818]],
    [ "669547274",[-93.49762738049186, 36.69904946222914]],
    [ "Bryce Substation",[-112.1518576, 37.67515015]],
    [ "Newark Electric",[-75.74105838900607, 39.68532165513452]],
    [ "Electric Power Board of Chattanooga",[-85.30004695, 35.0701258]],
    [ "Larrabee Road Substation",[-70.1860590139686, 44.14098754148772]],
    [ "669603981",[-77.5400925, 35.898442450000005]],
    [ "669603982",[-77.53955638161571, 35.89857058489839]],
    [ "669603983",[-77.55143334164957, 35.8905491202965]],
    [ "Scotten Substation",[-83.10309345755228, 42.334415917944135]],
    [ "669610754",[-84.99110483106972, 39.389106440513274]],
    [ "North Beckley Substation",[-81.19277214999998, 37.79025385]],
    [ "669714084",[-86.13788765232505, 39.84919748607497]],
    [ "Austin Substation",[-106.42005632167174, 31.783060081554552]],
    [ "669858170",[-91.27916556573238, 43.952955004696435]],
    [ "669858175",[-91.90703845000002, 44.296035950000004]],
    [ "669858190",[-91.87787615, 44.28517285]],
    [ "669858192",[-91.85779759999998, 44.2411689]],
    [ "669884019",[-81.28435681720877, 35.7521565942676]],
    [ "669884020",[-81.31053832653232, 35.737178968554076]],
    [ "669884021",[-81.32075239037478, 35.734693474477076]],
    [ "669884023",[-81.33863561443327, 35.7128734313935]],
    [ "Florida Power & Light",[-80.51145865620491, 25.56420632500537]],
    [ "670153454",[-81.27998229177172, 35.69572541012014]],
    [ "Mana Substation",[-159.77617628134325, 22.035614733333077]],
    [ "Kekaha Substation",[-159.71076490555157, 21.966537765066803]],
    [ "Pine Street Switchyard",[-75.61893587944824, 38.65102541066941]],
    [ "670462007",[-87.5199606, 38.01842070000001]],
    [ "670478956",[-110.89234563921727, 32.49877965720251]],
    [ "670564609",[-97.15858884583773, 32.81110064910491]],
    [ "670691690",[-81.30044504291183, 28.445915861763762]],
    [ "Kentucky Utilities Company",[-87.57335197248103, 37.80394124151776]],
    [ "670717435",[-87.69678902533671, 37.81166924393455]],
    [ "Cotton Plant Substation",[-91.2564905, 34.99793450000001]],
    [ "Oil Engine Substation",[-78.8849863934645, 33.695545859857276]],
    [ "670762696",[-97.23871485000001, 32.8668109]],
    [ "670770649",[-86.4777995298116, 39.87117340371638]],
    [ "670844430",[-80.89792935559012, 35.80728557008238]],
    [ "670993751",[-82.169920618099, 29.162154300374656]],
    [ "671101831",[-82.77554940597967, 35.70989846658876]],
    [ "671122660",[-97.30981138062154, 36.622374275749706]],
    [ "Syene",[-89.4025145642807, 43.01698090232964]],
    [ "671169599",[-97.21077302165796, 35.735041214959175]],
    [ "NV Energy",[-115.22406009396362, 36.27073435530033]],
    [ "NV Energy",[-115.1903431031616, 36.25285219529653]],
    [ "East Malloy Road Station",[-76.09928012490178, 43.09695574378688]],
    [ "671312078",[-84.89523047631519, 39.8035972539835]],
    [ "671312081",[-84.90756551918031, 39.84976495536261]],
    [ "Tanners Creek",[-84.86024617943771, 39.083201184228905]],
    [ "Warinanco Substation",[-74.23405760185156, 40.641684520305326]],
    [ "North Statesboro Substation",[-81.79927, 32.47671150000001]],
    [ "671357316",[-76.30362419999999, 36.770104200000006]],
    [ "Chesapeake Substation",[-76.30333129226854, 36.7710156581623]],
    [ "671418253",[-82.50568067295127, 36.45190570306841]],
    [ "671421207",[-82.5098865310171, 36.49237531729826]],
    [ "671637258",[-96.65794846766322, 32.98364178303424]],
    [ "Bayberry Substation",[-85.71840149038141, 42.84946430286273]],
    [ "Virginia Electric and Power Company",[-76.18966261134479, 36.91346707187985]],
    [ "671832616",[-83.28761057175419, 40.44044194233503]],
    [ "671846029",[-83.1518194290028, 40.249091049577515]],
    [ "671854943",[-83.58052878643284, 40.62331539405673]],
    [ "671855936",[-83.45310168185512, 40.58597727365824]],
    [ "Rectorville Substation",[-83.64751476231477, 38.58314037712759]],
    [ "671912024",[-83.44022319356627, 38.57124912447313]],
    [ "671912025",[-83.4398918, 38.5710328]],
    [ "671913781",[-85.68777937495497, 38.322770387946726]],
    [ "671936731",[-82.8635902998635, 42.809031093909155]],
    [ "Grandview Ave Substation",[-86.30918576047061, 41.683786220480634]],
    [ "671952550",[-82.23928100246438, 40.33362026506799]],
    [ "Virginia Electric and Power Company",[-77.31163322455632, 37.185611155511765]],
    [ "Altheimer Substation",[-91.83327517435151, 34.30986860731432]],
    [ "672198722",[-94.86141131898391, 36.943927136599726]],
    [ "Virginia Electric and Power Company",[-79.4156198205658, 37.79834754416459]],
    [ "672213162",[-82.527169504784, 35.845526596035334]],
    [ "672262100",[-78.87417648064203, 39.75721252624766]],
    [ "672310014",[-82.00606094999999, 34.860252300000006]],
    [ "672337012",[-106.39793577837474, 31.76519294294969]],
    [ "672337013",[-106.39255642214847, 31.7650220356663]],
    [ "Gateway (GAT) Substation",[-97.04503639281351, 47.929798045954435]],
    [ "Timblin Substation",[-79.18447785364427, 40.965806878330724]],
    [ "672414429",[-82.57560945504595, 28.136446247872133]],
    [ "Raceway Mall Substation",[-74.30443423038064, 40.2551496134248]],
    [ "FEUS Substation",[-108.09628947466636, 36.75532020536524]],
    [ "North Arkansas Electric Cooperative",[-92.00541069020056, 36.39354857279036]],
    [ "672525153",[-97.28506902039437, 32.79290119527773]],
    [ "672532746",[-89.6089701249095, 30.389211244490994]],
    [ "Air Liquide Substation",[-80.6850738014022, 28.481495434683662]],
    [ "672580341",[-114.49256507028606, 35.00922639504903]],
    [ "Oak Ridge Substation",[-89.43064653437058, 42.98597352165932]],
    [ "Moyock Substation",[-76.1369191280207, 36.47592639392023]],
    [ "672717155",[-78.07447700585256, 35.19039576232224]],
    [ "672747843",[-79.76146606915417, 36.504897845663926]],
    [ "Granite Reef Substation",[-111.91997350256389, 33.66360515474928]],
    [ "Oregon Substation",[-75.54679934999999, 35.799509050000005]],
    [ "Greenland Substation",[-76.20847425000001, 40.042492300000006]],
    [ "673233155",[-76.38008170200368, 40.08707048275077]],
    [ "PPL",[-76.33582169908567, 40.07071533308969]],
    [ "East Lancaster Substation",[-76.2801954157542, 40.05146727850694]],
    [ "673233161",[-76.2803349717425, 40.052053605881135]],
    [ "MidAmerican Energy",[-96.36887031199451, 42.43976377695986]],
    [ "Church Street Substation",[-76.2483204, 36.29947775000001]],
    [ "Northwest Iowa Power Cooperative",[-96.30147178249577, 42.330990160241676]],
    [ "673354262",[-111.04492466348829, 43.019059213208465]],
    [ "673363386",[-111.75360410516943, 40.403299170943]],
    [ "673447710",[-81.67862647285068, 35.03437855959283]],
    [ "New Kensington Substation",[-79.77009768987715, 40.56813208501099]],
    [ "673526227",[-103.73040097122973, 35.18395510759183]],
    [ "673526362",[-102.8730459, 36.1415912]],
    [ "673531512",[-81.93595208269808, 35.314694459584736]],
    [ "Brookwood Substation",[-84.17532385598453, 34.093715325756506]],
    [ "Georgia Power",[-84.15231099959199, 34.084488347705246]],
    [ "673625873",[-82.10236989672278, 35.32321129568685]],
    [ "Brinkley West Substation",[-91.20242427505163, 34.89720219415128]],
    [ "673688123",[-76.50358810861611, 39.30645686514619]],
    [ "East Madison Substation",[-86.31632442753633, 39.61018203081816]],
    [ "673708326",[-86.37105522502098, 39.576582657578925]],
    [ "Caney River Substation",[-96.42365257923912, 37.45524337808395]],
    [ "Caney Substation",[-96.4190890984201, 37.47132840927972]],
    [ "673891950",[-88.79753447198078, 34.3088391363896]],
    [ "673904084",[-83.47606755, 42.7488374]],
    [ "Georgia Power",[-84.17332328446196, 34.127813208864275]],
    [ "City of Tupelo Water & Light Department",[-88.73065852386434, 34.26413402596209]],
    [ "Berry Substation",[-87.59718326403177, 33.67330514370368]],
    [ "673923451",[-86.77687399465684, 33.480856026318726]],
    [ "Green Station Substation",[-86.71753468575601, 33.65104968131208]],
    [ "673997358",[-81.91761619469496, 35.412272504473975]],
    [ "Bayonne Switching Station",[-74.1055962058133, 40.694084095807]],
    [ "674076092",[-81.95231129371639, 35.384650783855136]],
    [ "Pamplin Substation",[-78.67915064455138, 37.25447896529425]],
    [ "MidAmerican Energy",[-96.37548256052236, 42.42149371179825]],
    [ "674225373",[-96.29109110779751, 37.3450855752658]],
    [ "674334079",[-78.38510864595283, 36.350255847027626]],
    [ "674352519",[-105.31306889225954, 38.957249848663935]],
    [ "Newport Hydro Substation",[-78.59380482750092, 38.571798057519246]],
    [ "Bremo Substation",[-78.28859436126261, 37.70969694353209]],
    [ "674454632",[-81.25358956722292, 35.18806305075692]],
    [ "674457731",[-81.20234407422696, 35.17802824186489]],
    [ "Bordas II Substation",[-98.90667560849036, 27.43927749195569]],
    [ "Fox Chase Substation",[-75.07341431510322, 40.066010182308574]],
    [ "674647559",[-86.04272641682722, 39.484899749254346]],
    [ "674704092",[-80.84525202290939, 35.50401890679727]],
    [ "Bicentennial Substation",[-115.118637046144, 35.94039547737769]],
    [ "674982973",[-116.27974975361222, 43.66944139421169]],
    [ "Cochran Substation",[-83.3438801836793, 32.39660417868674]],
    [ "675049851",[-118.0963798015695, 33.76353427526285]],
    [ "675049852",[-118.0963657440091, 33.76744627489723]],
    [ "675053427",[-118.08913452505858, 33.75711839041592]],
    [ "Martinez Substation",[-98.32236738009212, 29.45069959692207]],
    [ "675061770",[-91.23129499999999, 43.5589889]],
    [ "North Vernon Road Subsation",[-85.65153804358218, 39.00675495034156]],
    [ "675170440",[-85.88040340080845, 38.972099244697354]],
    [ "Azoplate J T Substation",[-74.6984376745018, 40.59909985646783]],
    [ "675239149",[-110.86179800411757, 33.41448210568781]],
    [ "Moonshine Substation",[-110.87338797387959, 33.419726762725716]],
    [ "675340562",[-85.43388805000001, 32.59332105000001]],
    [ "675561440",[-95.60991829313073, 37.04408033101367]],
    [ "Donnelly Substation",[-96.01452595000002, 45.690905199999996]],
    [ "675647359",[-97.10050531490623, 34.19583592509454]],
    [ "69",[-105.55943286427441, 37.186653225064966]],
    [ "675808843",[-102.81799787932613, 46.87449280044128]],
    [ "Valero Refining-New Orleans, L.L.C.",[-90.39242054301839, 29.993586554522754]],
    [ "675888632",[-90.38459660000002, 29.99782445]],
    [ "Valero Refining-New Orleans, L.L.C.",[-90.39707084147463, 29.995240589536206]],
    [ "675889845",[-111.29445480392133, 47.52159899063884]],
    [ "675891882",[-82.34767546278266, 35.9049028145063]],
    [ "675891900",[-82.30838517877828, 35.90609147705235]],
    [ "676146360",[-115.11672772477341, 36.20262558973012]],
    [ "676196022",[-78.50880632090146, 38.054135156587726]],
    [ "Sharon Springs Substation",[-84.17220743392684, 34.128120278584404]],
    [ "676306293",[-95.99984875000001, 36.74783875000001]],
    [ "Alon Refining Krotz Springs, Inc.",[-91.75185932489684, 30.52532764608651]],
    [ "676357233",[-91.76201752395546, 30.570096494488777]],
    [ "Livonia Substation",[-91.54979952215879, 30.546813101053594]],
    [ "Linden 345kv Substation",[-74.21115535258714, 40.62392283662642]],
    [ "Covanta Substation",[-75.38975905617181, 39.82524289522042]],
    [ "Dodson Substation",[-92.64862240000001, 32.078903700000005]],
    [ "676436767",[-92.6402223730953, 32.042646646272004]],
    [ "676437458",[-79.04293815, 35.60372255]],
    [ "676437459",[-79.04948104999998, 35.593163499999996]],
    [ "676438146",[-90.98778065996979, 38.99449034652158]],
    [ "676580641",[-111.9048203701769, 40.78981737852779]],
    [ "676580642",[-111.90474922529621, 40.78937168368676]],
    [ "Smackover Industrial Substation",[-92.71343932476437, 33.35987508895687]],
    [ "676767068",[-97.15932211073185, 34.62947422014848]],
    [ "676807304",[-82.08141736805246, 33.50201281484411]],
    [ "677179001",[-80.84262447304378, 35.23914332648309]],
    [ "677235131",[-82.29609258524115, 36.03415501011716]],
    [ "FIXME Substation",[-94.6300610909222, 37.543035708659765]],
    [ "677526238",[-121.9676983469088, 37.39137160458831]],
    [ "677666133",[-83.26838047621658, 42.22075366231713]],
    [ "Stirling Substation",[-74.49165310386026, 40.674651022790954]],
    [ "Georgia Iron Works Substation",[-82.18843005, 33.45777029999999]],
    [ "678017055",[-111.96202820916687, 40.730775758615096]],
    [ "678017056",[-111.96213797385425, 40.73122104332319]],
    [ "IP&L Substation H",[-94.38030304961777, 39.10651497512945]],
    [ "678222311",[-84.97131323467592, 34.66673723214071]],
    [ "678291993",[-80.29026122926248, 35.74679580588112]],
    [ "678295865",[-77.05452701613085, 34.69608001877035]],
    [ "678309913",[-85.8206116751608, 41.65434190667466]],
    [ "678415049",[-78.11634599992412, 35.00372064530962]],
    [ "678512196",[-87.7469223, 43.71814989999999]],
    [ "Clark Summit Substation",[-79.7265741758016, 41.44853442805948]],
    [ "678552559",[-84.59134214869992, 39.035018145834094]],
    [ "Fourteenth Street Substation",[-83.67978936679668, 43.00432020955674]],
    [ "Electric Power Board of Chattanooga",[-85.30481190000002, 35.06320350000001]],
    [ "Carpenter Road Substation",[-83.65008466975154, 43.076987561217784]],
    [ "678935229",[-83.58630069901946, 41.39297688894795]],
    [ "Oakman Substation",[-83.14129454001406, 42.3905946105651]],
    [ "679145451",[-84.14466213702777, 36.359397941144294]],
    [ "679147158",[-85.35364821189818, 34.45808878010711]],
    [ "Huntsville Utilities",[-86.48287561938113, 34.656815354014306]],
    [ "City of Tallahassee",[-84.22013504967656, 30.46060927543391]],
    [ "Roedel Road Substation",[-83.83086759964885, 43.35198059509173]],
    [ "679510475",[-86.07866596656116, 39.71767481895245]],
    [ "Jersey Central Power and Light",[-74.93453236541205, 40.77123966909362]],
    [ "East Watertown Station",[-75.85451324107312, 43.93874258855074]],
    [ "Del Norte Substation",[-106.35181612352622, 37.68233504098657]],
    [ "Rosewood Substation",[-85.81488210774354, 42.90668653261674]],
    [ "680461289",[-108.31764485326119, 39.14836474360455]],
    [ "Fulton Substation",[-90.88021446184109, 41.59632977297151]],
    [ "680726141",[-97.34665732497817, 46.772905436506115]],
    [ "680730405",[-82.9118960530033, 43.49216815670507]],
    [ "Veterans Substation",[-96.8853650256578, 46.8300365565872]],
    [ "Georgia Power",[-84.47031479589272, 33.88571528988512]],
    [ "Georgia Power",[-84.32704094175047, 33.75932007518522]],
    [ "Walnut Creek Substation",[-122.06098137415339, 37.90476003456299]],
    [ "681759468",[-97.30153182457443, 36.8110395802434]],
    [ "681885481",[-82.51554123715538, 35.78249667851344]],
    [ "Huntsville Substation",[-96.9762497935544, 47.89923227847717]],
    [ "Argos Sub",[-86.23374541512813, 41.215697360907]],
    [ "Milford Solar Farm Substation",[-75.44703070796402, 38.9215090796687]],
    [ "682032668",[-119.15827235203389, 46.25726470161292]],
    [ "682032670",[-119.21198795000001, 46.26245339999999]],
    [ "Ruby Street Substation",[-119.13132627262813, 46.242027045353126]],
    [ "Franklin Public Utility District",[-119.19430192549868, 46.28599019541933]],
    [ "Arthur Substation",[-97.21902983635236, 47.15116704460995]],
    [ "Fayetteville Public Works",[-78.99418733260624, 35.076389868341]],
    [ "682273712",[-83.41636232809309, 43.04327804244928]],
    [ "Otsego Substation",[-83.06895850908651, 43.00645930667709]],
    [ "Cloverly substation",[-104.64074427985994, 40.46326743499984]],
    [ "Public Service Company of Colorado",[-104.68604718660106, 40.44117238285336]],
    [ "Godfrey Switching Station",[-104.77238034283874, 40.33661363045737]],
    [ "682291788",[-101.0261103696872, 37.99593481080836]],
    [ "682302527",[-98.35821323896825, 40.857749675780624]],
    [ "682314116",[-89.81687688045287, 33.83056676241526]],
    [ "682314118",[-89.81402704764358, 33.83631613086661]],
    [ "682323519",[-86.3890734251633, 40.73641594229185]],
    [ "682323931",[-89.52195859101954, 32.35803537492935]],
    [ "682328963",[-95.32321359392091, 34.64985072503095]],
    [ "682328966",[-94.63276886171045, 34.032300174058385]],
    [ "682328967",[-94.63951987522307, 34.041670410975485]],
    [ "682329297",[-89.53971404655424, 32.8265920628835]],
    [ "Lewis Creek Substation",[-85.81038382513665, 39.42311300467026]],
    [ "Dawson Substation",[-84.43039061520396, 31.75759835909963]],
    [ "682330141",[-84.4160290754207, 31.762292284965056]],
    [ "City of Levelland Substation",[-102.37630209999999, 33.59026075]],
    [ "Kentucky Utilities Company",[-84.14957090452776, 38.29449495717139]],
    [ "682425541",[-95.89789799120007, 41.42234192491923]],
    [ "682425545",[-95.3611401, 42.331221299999996]],
    [ "682425552",[-95.39175381014115, 42.003369594772735]],
    [ "Entergy Arkansas",[-92.04847100234896, 33.610679385478306]],
    [ "Entergy Arkansas",[-91.8427460079465, 33.791130724726266]],
    [ "Bearden Substation",[-92.61756375000002, 33.73546470000001]],
    [ "Entergy Arkansas",[-92.38713920000001, 33.816253499999995]],
    [ "Entergy Arkansas",[-92.41678635000001, 34.267032799999996]],
    [ "682443577",[-92.11120245000002, 34.3649258]],
    [ "682443578",[-92.11069865000002, 34.347532449999996]],
    [ "Entergy Arkansas",[-92.09576915000001, 34.299225]],
    [ "Entergy Arkansas",[-92.05763417490424, 34.23204368601525]],
    [ "682451814",[-85.1156727597337, 41.11256845346621]],
    [ "682519858",[-96.48835344999999, 32.596704100000004]],
    [ "682519859",[-96.49372619782321, 32.5939899526387]],
    [ "682519860",[-96.37358961516206, 32.521872857471244]],
    [ "South Gainesville Substation",[-83.82950539999999, 34.28245659999999]],
    [ "Oakwood Substation",[-83.87083990000002, 34.26548065]],
    [ "682566348",[-112.2845265761445, 33.44309434861023]],
    [ "Entergy Arkansas",[-91.17531785, 35.7696184]],
    [ "Entergy Arkansas",[-92.19792784006282, 34.75466280844768]],
    [ "Ozarks Electric Cooperative Corporation",[-94.11928901178035, 36.20843787548348]],
    [ "Southwestern Electric Power Company",[-94.12662399058813, 36.19217485013472]],
    [ "682721553",[-78.7493801, 43.169342349999994]],
    [ "682725314",[-86.32604372117729, 40.74251975911133]],
    [ "Modena Substation",[-74.12120252239976, 41.64910079434299]],
    [ "South Cairo Substation",[-73.98648646501766, 42.291238525238235]],
    [ "Westerlo Substation",[-74.06370384961544, 42.451702793259]],
    [ "Pearline Substation",[-85.92597534970513, 42.95645960079195]],
    [ "Fillmore Substation",[-85.94419088443532, 42.94213359686485]],
    [ "Blendon Substation",[-85.99994691791348, 42.91905647165106]],
    [ "Phoenix Road Station",[-86.2474716, 42.410578099999995]],
    [ "Wisner Substation",[-74.32345975000001, 41.272892049999996]],
    [ "Southwest Arkansas Electric Cooperative",[-93.80829761194003, 33.534710574842336]],
    [ "Sand Dock Substation",[-73.93818338667488, 41.64876168888918]],
    [ "682796147",[-115.44859649577343, 33.170216508259415]],
    [ "682796150",[-115.4679126920149, 33.13401183854676]],
    [ "682796152",[-115.51891835636896, 32.999041853460376]],
    [ "682799128",[-86.89016372459376, 41.21409734100028]],
    [ "AEP Notre Dame Substation",[-86.2377423963449, 41.71187841714788]],
    [ "Union Carbide (Praxair) Substation",[-75.30298894385473, 40.30167174265099]],
    [ "PPL",[-75.33723219999999, 40.2939168]],
    [ "Bethlehem Road Substation",[-74.09510406764178, 41.46182738186585]],
    [ "Monroe Substation",[-74.19324595973387, 41.34187227109742]],
    [ "Lawrenceville Substation",[-73.98616016300956, 42.22365788097037]],
    [ "TAP 135687",[-73.98029754823867, 42.22194370134721]],
    [ "682979398",[-81.38429064730008, 35.76305347591305]],
    [ "682979402",[-81.55222680233248, 35.89084449636616]],
    [ "682979411",[-81.54958907193611, 35.895514129027916]],
    [ "682979416",[-81.30850184367489, 35.71403953084337]],
    [ "Valdese Tie Substation",[-81.56902781944675, 35.74006075484134]],
    [ "682982186",[-81.96981154999999, 35.54987645]],
    [ "Marion Main Substation",[-81.99430180510674, 35.67580938086926]],
    [ "682982190",[-81.98171045000001, 35.688294899999995]],
    [ "682995561",[-80.87392096669265, 40.06843295018525]],
    [ "682995566",[-80.80493444968663, 39.964780044282996]],
    [ "682995567",[-80.80687683230794, 39.965813535143106]],
    [ "683001170",[-94.29727773447684, 37.17589871776932]],
    [ "Wadhams Substation",[-82.55503172534561, 42.99037580686153]],
    [ "Greenhouse Switching Station",[-94.25040711214463, 36.35596097509843]],
    [ "Arkansas Electric Cooperative Corporation",[-94.24739297458672, 36.358260405230965]],
    [ "Bentonville Electrical Utility Department",[-94.24528139146035, 36.35921212461821]],
    [ "Carroll Electric Cooperative Corporation",[-94.24879274999998, 36.356976249999995]],
    [ "Carroll Electric Cooperative Corporation",[-94.33458320000001, 36.25822735]],
    [ "683007771",[-94.25058379083748, 36.31956532476826]],
    [ "Southwestern Electric Power Company",[-94.52643438876132, 36.25477788500552]],
    [ "683009325",[-95.31160464999999, 36.24316725]],
    [ "City of Siloam Springs Electric Department",[-94.52567850011694, 36.167271997634735]],
    [ "683014919",[-80.07569957822525, 35.394108383135155]],
    [ "683017766",[-92.99223885, 43.69830735]],
    [ "Kansas Substation",[-87.88325864936462, 42.96903818243635]],
    [ "Pennsylvania",[-87.88824128892388, 42.873012900171375]],
    [ "Norwich Substation",[-87.87502055149767, 42.97235028664336]],
    [ "Newfoundland Substation",[-83.09853982070396, 38.12888549921448]],
    [ "City of Kinston",[-77.6650600375745, 35.272641958945854]],
    [ "683029051",[-83.53974, 34.505249199999994]],
    [ "Georgia Power",[-83.66929777985106, 34.15391064218604]],
    [ "Georgia Power",[-83.64688309999998, 34.17944535]],
    [ "Rivermont Substation",[-79.16532923966548, 37.434604518914014]],
    [ "Monongahela Power Company",[-81.14705246983411, 38.26082957589296]],
    [ "683232962",[-90.95975021452774, 37.89107689930333]],
    [ "Fredericktown M&A Substation",[-90.1168178172191, 37.47505030439576]],
    [ "IP&L Substation A",[-94.32734043296105, 39.09233099728522]],
    [ "Nashua Substation",[-94.58045086065053, 39.330442411815014]],
    [ "Alliant Energy",[-92.55452654551377, 41.09560045400759]],
    [ "683232993",[-94.3382206, 39.5278707]],
    [ "683232996",[-92.78522697536849, 39.640573138532396]],
    [ "683232999",[-92.78005162567611, 39.787045890541386]],
    [ "683236707",[-89.96514605, 36.74654089999999]],
    [ "Hitt Substation",[-89.63150150615911, 37.3093692251263]],
    [ "683239348",[-90.9045095183092, 40.763877431777765]],
    [ "683253256",[-90.57795038409778, 43.94277371081973]],
    [ "Timberwolf",[-90.50374895, 43.95131225]],
    [ "Sparta",[-90.77628082282116, 43.92785586472379]],
    [ "Pleasant Valley Delivery Point",[-77.50677776282855, 38.85873543137857]],
    [ "683257217",[-74.38331606104732, 41.74612236473414]],
    [ "683260035",[-76.3140875, 43.16903035]],
    [ "City of Concord",[-80.60537685000001, 35.42907825]],
    [ "Virginia Electric & Power Company",[-77.67190236943003, 36.47860579021304]],
    [ "Kelford Substation",[-77.2182494413119, 36.16488958080754]],
    [ "683270456",[-87.3188592, 37.91747325]],
    [ "683270466",[-87.18975156581423, 38.652170598941474]],
    [ "683273073",[-89.13537183623843, 32.352551625528484]],
    [ "COLORADO",[-89.2536872486697, 43.17972773794302]],
    [ "Bird St",[-89.2254840001075, 43.19342492559723]],
    [ "Wilmarth Substation",[-94.00860993021098, 44.19690694096873]],
    [ "683370245",[-87.05167861707676, 34.606628852830106]],
    [ "Joe Wheeler EMC",[-87.07196315000002, 34.64940695000001]],
    [ "Joe Wheeler EMC",[-87.08052059585738, 34.65282166644372]],
    [ "Joe Wheeler EMC",[-87.04271157652546, 34.61447984972556]],
    [ "683373423",[-87.92949540000001, 32.45529735]],
    [ "683375541",[-86.07593996732234, 33.960911925844286]],
    [ "Victoria Substation",[-85.90777775056685, 31.55408335474968]],
    [ "New Hope Substation",[-85.9062763, 31.4980586]],
    [ "683386389",[-87.30408489999999, 33.8533336]],
    [ "Morningside Substation",[-98.15330583238796, 44.36525822493605]],
    [ "683387810",[-87.62529285000001, 31.961900550000003]],
    [ "Southwestern Electric Power Company",[-94.02550375836972, 33.43475637502462]],
    [ "683412475",[-86.12326685, 40.48330259999999]],
    [ "683412479",[-86.20254155, 40.50505755]],
    [ "683412480",[-86.16042886380217, 40.469197225217364]],
    [ "683416440",[-80.61025441740037, 36.45565255302162]],
    [ "683419092",[-79.12858976948796, 34.850143563319314]],
    [ "683445729",[-95.74514958760659, 36.24811805276476]],
    [ "Lone Star Substation",[-89.74026325, 31.638056150000004]],
    [ "683465391",[-95.51189966367959, 40.400339222455706]],
    [ "683468636",[-95.59476524999998, 40.4019521]],
    [ "Tapteal Substation",[-119.27648148414723, 46.23646049610005]],
    [ "683569822",[-81.0152020066598, 35.53810059231312]],
    [ "Empire Substation",[-83.14498460232107, 42.36622722353292]],
    [ "683623096",[-80.41665252554408, 27.212153001707403]],
    [ "South Lebanon Substation",[-86.29628588259025, 36.18144018393078]],
    [ "683853235",[-80.19856465, 39.00421564999999]],
    [ "683968719",[-79.96554555, 36.410930300000004]],
    [ "Maple Corner Substation",[-72.49006522572928, 44.37182051628979]],
    [ "Georgia Power",[-84.39715881405624, 33.637596647510115]],
    [ "683983861",[-84.38537277501817, 33.614875042846855]],
    [ "Southwestern Electric Power Company",[-94.14468790164901, 33.68362234428019]],
    [ "684010863",[-82.01355434999999, 34.9849339]],
    [ "684010865",[-81.98245782828685, 34.9726185081038]],
    [ "684179571",[-85.1847136138877, 36.75670325047103]],
    [ "KC South Substation",[-94.45201724352879, 38.93088235154763]],
    [ "684278547",[-98.74427045167546, 37.63624078761147]],
    [ "Sailfish Substation",[-80.09483044618511, 26.766251380608406]],
    [ "Shenandoah Valley Electric Cooperative",[-78.78472488106944, 38.634561295644765]],
    [ "684285949",[-84.15961659999999, 31.171928400000002]],
    [ "TVA",[-84.1775570436612, 35.15008714617086]],
    [ "Nick Davis Substation",[-86.73994644996303, 34.80885198281675]],
    [ "684405603",[-85.07828057669998, 33.60430850472625]],
    [ "Georgia Power",[-85.10867996977501, 33.60318943936673]],
    [ "Buck Creek Substation",[-85.11123819412686, 33.61315621695317]],
    [ "Dayton Substation",[-78.92813776959679, 38.40983857277366]],
    [ "684453003",[-84.48911895684459, 30.06354850881413]],
    [ "Lock Haven Swiching Station",[-77.43375302220092, 41.12079744154136]],
    [ "Lock Haven 69/12 kV Substation",[-77.4350674531202, 41.12411268428673]],
    [ "Washington Street Substation",[-73.82669759109284, 40.90960363324406]],
    [ "First Quality Substation",[-77.35761924210675, 41.1582283781392]],
    [ "Georgia Power",[-82.82895094999998, 34.0991108]],
    [ "Georgia Power",[-82.90296278315896, 34.09793499735097]],
    [ "Lake Avenue Substation",[-73.88590815697455, 40.946107069115214]],
    [ "Wrexham-79 Substation",[-73.8483759096916, 40.932090832747704]],
    [ "Ardsley-1 Substation",[-73.84590601173886, 41.01186999346446]],
    [ "684598195",[-85.65710231043815, 38.17037505397514]],
    [ "Dobbs Ferry-7 Substation",[-73.8762751275691, 41.016569895035644]],
    [ "Collins Substation",[-89.5381404555073, 31.652119332045864]],
    [ "Cooperative Energy",[-88.99336062890517, 31.69410209136485]],
    [ "684619140",[-88.99313307455094, 31.69456727197293]],
    [ "Suwannee River Plant Substation",[-83.18245179624478, 30.37038648621296]],
    [ "Dupont Seafood Substation",[-75.62450488806337, 38.63066090699915]],
    [ "684669250",[-81.63082581401584, 34.300876676619815]],
    [ "Madison Substation",[-84.01133399856624, 41.889261299804815]],
    [ "Flat Rock Substation",[-85.83729915584536, 39.34942849008336]],
    [ "684712311",[-83.75146957731563, 38.64272049571904]],
    [ "Perry Willis Substation",[-94.12452677727768, 41.83684131654536]],
    [ "684792383",[-86.02544953265992, 40.721903081367934]],
    [ "684803906",[-79.64874972971359, 36.32678934471903]],
    [ "684830281",[-78.84299533432572, 34.83745353953666]],
    [ "Hope Substation",[-85.77920752455681, 39.29143944510976]],
    [ "684960130",[-80.84191261545195, 35.47071167919968]],
    [ "685013009",[-83.58257670619972, 43.363329611158434]],
    [ "685013011",[-83.57506658202082, 43.363973036309005]],
    [ "685031293",[-79.30591955, 36.09195895]],
    [ "685034332",[-96.11789630877831, 36.56496085281552]],
    [ "MTEMC",[-86.48411075967763, 35.808674104455356]],
    [ "685121301",[-80.47099964044985, 36.38234411086063]],
    [ "685236904",[-82.29988307332162, 38.44651653683826]],
    [ "Irvington-63 Substation",[-73.86549890626753, 41.03918839431389]],
    [ "Bowman Ave-66 Substation",[-73.69490937998427, 41.00416653749086]],
    [ "685260446",[-96.17015665000001, 43.0949778]],
    [ "685263561",[-94.71240644583929, 36.41299551635814]],
    [ "Enterprise Substation",[-84.53223381754931, 42.67976745700379]],
    [ "685346858",[-111.85255088126681, 40.43146759465793]],
    [ "685352412",[-77.0634222162205, 40.22458238968217]],
    [ "Forest Substation",[-84.47987007201952, 42.69064262242475]],
    [ "685517267",[-92.07804929529146, 33.619531458163216]],
    [ "685517270",[-92.0914547844893, 33.61658937480524]],
    [ "685517271",[-92.09034005000001, 33.6165863]],
    [ "685526742",[-87.50979103632075, 38.60938116842831]],
    [ "Mill St. Substation",[-86.16764470964421, 39.79150406127695]],
    [ "685527798",[-90.82352800856131, 32.27645253162876]],
    [ "Latty Substation",[-84.59290025, 41.07718779999999]],
    [ "REO Town Substation",[-84.54978262475734, 42.719831554334355]],
    [ "685597821",[-112.18543255, 41.72676545]],
    [ "685608204",[-80.3800159688491, 33.85002008989728]],
    [ "City of Siloam Springs Electric Department",[-94.52835534999998, 36.1881833]],
    [ "City of Siloam Springs Electric Department",[-94.52045558514034, 36.209745024609596]],
    [ "Robins AFB Substation",[-83.5896997356802, 32.622856294003036]],
    [ "685624350",[-83.59037390258284, 32.58492961904765]],
    [ "Lapier Substation",[-83.48594526640628, 41.68668314560773]],
    [ "685647610",[-90.92157556774879, 29.62438565179385]],
    [ "685713561",[-100.7609698907463, 37.160956540115734]],
    [ "685713562",[-100.76186693809278, 37.161228793925105]],
    [ "685713569",[-100.76145942591312, 37.16537790768443]],
    [ "EnLink Processing Services, LLC",[-91.34155215171592, 29.690596068322638]],
    [ "685753309",[-104.77089825, 40.0971955]],
    [ "685754151",[-81.34842316941743, 39.7962946885569]],
    [ "685755294",[-107.78087115, 37.156464]],
    [ "685833097",[-107.94659426927528, 36.73168822147522]],
    [ "685833101",[-107.96340835000001, 36.731684400000006]],
    [ "685833117",[-107.95749866567556, 36.73409232625771]],
    [ "685837377",[-96.06525074999999, 29.00695545]],
    [ "685847596",[-101.10367493765708, 37.56040549725354]],
    [ "685880703",[-80.25990935, 40.26127675]],
    [ "685920216",[-102.56397795000001, 33.45865435]],
    [ "685937336",[-103.90263966695437, 31.8329944030283]],
    [ "Amber Jack Substation",[-103.8827975328217, 31.848137501572516]],
    [ "685977405",[-102.67875391103212, 32.759107524853604]],
    [ "685977407",[-102.68343504999999, 32.75535239999999]],
    [ "Darlington Road",[-98.13796430000001, 35.58979525000001]],
    [ "685988523",[-110.86367950833107, 41.31191253458469]],
    [ "685988525",[-110.856274575192, 41.31673440512047]],
    [ "Kiowa 1 Sub",[-103.96825729931363, 32.50116591513498]],
    [ "685991341",[-91.27735945, 30.328852849999997]],
    [ "Entergy Louisiana",[-91.27081321511812, 30.33614552740899]],
    [ "Howard Substation",[-84.51287471154987, 42.735586371529344]],
    [ "686098857",[-101.36175707532067, 37.46128720938288]],
    [ "686115651",[-98.11268583886559, 35.508969080030276]],
    [ "Willow Substation",[-84.58245657380894, 42.74924192718904]],
    [ "686137453",[-101.9782124, 31.840527450000003]],
    [ "Lansing Board of Water and Light",[-84.58157716748885, 42.73904848997385]],
    [ "686200481",[-97.70296990871194, 34.801822315969225]],
    [ "North Creyts Substation",[-84.64278358090425, 42.751401008363224]],
    [ "Waverly Switching Station",[-95.58781535692482, 38.266172284383984]],
    [ "Yardley Ridge Substation",[-77.5183279399996, 38.95027684574522]],
    [ "Poland Road Substation",[-77.49146613256099, 38.917364951924256]],
    [ "Runway Delivery Point",[-77.49038525327907, 38.9764839805365]],
    [ "Pacific Substation",[-77.43839280187606, 38.996006012068456]],
    [ "Shellhorn Substation",[-77.47168827455887, 38.99883748077296]],
    [ "Homewood Substation",[-79.04978266615448, 33.88977710890431]],
    [ "686463956",[-119.5925213958852, 35.296053021395295]],
    [ "686463959",[-119.4732242836649, 35.28418586909571]],
    [ "686505923",[-102.80842678377869, 32.99576327485674]],
    [ "686507477",[-102.81751196239574, 32.99743502682762]],
    [ "686507481",[-102.82959008470995, 33.02756336786]],
    [ "Cardinal",[-89.56808051464905, 43.092164047562285]],
    [ "686639668",[-85.91052942204912, 41.68107192018241]],
    [ "Purcell",[-97.37713225873192, 35.01709467922532]],
    [ "686668105",[-97.50153319161308, 34.46247197947961]],
    [ "AEP Conant Substation",[-85.93883286128458, 41.686894474705966]],
    [ "686683637",[-99.22647057602154, 36.43379395405873]],
    [ "686692591",[-103.19693900770197, 32.72120754016073]],
    [ "686692604",[-85.9648429543544, 41.692249266789496]],
    [ "AEP Capital Ave/Currant Rd Substation",[-86.13306170496803, 41.68320565664539]],
    [ "686864757",[-103.52404134999999, 31.487794149999996]],
    [ "686868609",[-98.86326614063485, 35.49429487502523]],
    [ "686877579",[-99.45367032516948, 35.408195562690295]],
    [ "686928888",[-103.1827207, 47.854544450000006]],
    [ "686928892",[-103.18826345000002, 47.85750455]],
    [ "Sprindle NUG Substation",[-104.88785390529632, 40.09264771958568]],
    [ "686968822",[-91.0393363719831, 29.665793191046333]],
    [ "686972911",[-98.51107500587408, 33.495505475156506]],
    [ "686972912",[-98.51086010822245, 33.49652617588952]],
    [ "686972914",[-98.36111713735076, 33.49649020313442]],
    [ "686972917",[-97.79090317140232, 33.570061790900155]],
    [ "686972919",[-97.48195635000002, 33.67953434999999]],
    [ "Roadrunner Substation",[-103.53243509214768, 32.21235137670061]],
    [ "Rimmon Substation",[-71.5039347803483, 43.00567177078043]],
    [ "Merrimack Substation",[-71.47003027159649, 43.1405907319825]],
    [ "687062845",[-96.5514065, 35.5551784]],
    [ "687078216",[-102.74324557884903, 32.97290254136461]],
    [ "687078237",[-102.75764889988424, 33.01040285766012]],
    [ "Moretown-66 Substation",[-72.75706025, 44.25051265]],
    [ "687196239",[-103.73209752513948, 48.14266837395771]],
    [ "687196245",[-103.9443536735748, 48.23257734460009]],
    [ "687196247",[-103.95530240646224, 48.23056982303275]],
    [ "687247085",[-97.7963689, 34.8536835]],
    [ "Puget Sound Energy",[-122.78058062530405, 47.042475404243596]],
    [ "687323413",[-97.76375669696249, 36.780872566489236]],
    [ "687364607",[-103.30884574730423, 32.61173940293866]],
    [ "Kalkaska MPPA Substation",[-85.20067131382365, 44.6893176210021]],
    [ "687390658",[-88.8823774699623, 39.876295380363175]],
    [ "687390659",[-88.88112082599757, 39.876351590655624]],
    [ "687405418",[-84.28392761301781, 30.445527957758603]],
    [ "Ellicott Substation",[-88.03169870756426, 30.995546405892004]],
    [ "687429194",[-97.8691223529121, 32.41268682721986]],
    [ "687451461",[-96.00281395, 32.266747900000006]],
    [ "Appalachian Power Company",[-81.32552281651739, 38.4845382831478]],
    [ "687479667",[-101.12821132307648, 38.49681703481802]],
    [ "AVIATION",[-88.58160802531309, 43.95901304422592]],
    [ "Puueo Power Substation",[-155.0910318206648, 19.726841949770787]],
    [ "687545835",[-97.89406049810917, 35.02183928996921]],
    [ "687545856",[-97.61073722527571, 34.507697379806174]],
    [ "687554826",[-98.27985385000001, 35.115673650000005]],
    [ "687557184",[-98.56580414999999, 34.90640834999999]],
    [ "687558865",[-96.16716289280416, 35.14147559529065]],
    [ "687829298",[-82.2963110536639, 38.634207214824094]],
    [ "687829306",[-82.26766137055243, 38.6819486946462]],
    [ "687829307",[-82.36583684944884, 38.74774764837725]],
    [ "687829311",[-82.19104325565442, 38.908771737295176]],
    [ "Bonners Ferry",[-116.30285838592219, 48.67427028776994]],
    [ "687985285",[-78.93727576868963, 36.02014530845119]],
    [ "688024373",[-103.45968721733323, 32.80638990239972]],
    [ "688024376",[-103.50924725139059, 32.785830001136205]],
    [ "Mott Substation",[-83.5544076492125, 42.26188269075202]],
    [ "Pacific Gas and Electric Company",[-121.9059529018419, 37.403393948465]],
    [ "688434675",[-79.94993280365293, 33.59954025452186]],
    [ "City of High Point",[-80.01945932246593, 35.982357406975474]],
    [ "689010342",[-97.83595975795676, 36.44079790567207]],
    [ "689053065",[-95.89757253595819, 36.72724405654161]],
    [ "Berlin Eastside Substation",[-71.17929323320813, 44.463282790240584]],
    [ "Bergheim Substation",[-98.52767451771325, 29.790163095530865]],
    [ "Laguna Substation",[-114.7360548779473, 32.60052628316547]],
    [ "Carberry Switching Station",[-121.75295468348564, 40.85919328865393]],
    [ "Hatchet Ridge Collector Substation",[-121.79689807445146, 40.890261241744575]],
    [ "Chrysler Substation",[-84.03465557536511, 42.26583545823392]],
    [ "689467488",[-97.78879869093072, 46.89172132510561]],
    [ "689467505",[-97.8718097, 46.81816555]],
    [ "689489819",[-111.04061911722148, 41.065674445518596]],
    [ "689523701",[-100.70814271358576, 47.11283542449704]],
    [ "689523703",[-100.70812669999998, 47.1142058]],
    [ "689545188",[-81.50836873304634, 28.348751551858772]],
    [ "689550701",[-89.38499266529467, 43.668919024826764]],
    [ "Exxon Substation",[-87.3593981, 31.071446350000002]],
    [ "Rocky Mountain Power",[-112.27373716443131, 40.55931607468997]],
    [ "690048692",[-83.93635404259197, 38.52647507394892]],
    [ "Pulford Substation",[-83.01822248658308, 42.36418108240013]],
    [ "690325744",[-109.14386716492656, 38.149053175037416]],
    [ "690333136",[-103.88489210980838, 32.805991581323156]],
    [ "690333137",[-103.85708334280633, 32.652468158146974]],
    [ "690333142",[-103.97616702440097, 32.57338262647852]],
    [ "690442715",[-102.22676430954635, 32.19877567410639]],
    [ "Pontook Hydro Substation",[-71.23847318334354, 44.610699157227934]],
    [ "690514054",[-104.22012889437478, 32.34925657391392]],
    [ "690527405",[-102.79395862501667, 32.73262610436753]],
    [ "690527409",[-103.2952406881975, 32.66757237494871]],
    [ "690564790",[-103.31896549998226, 32.98088698686499]],
    [ "690564791",[-103.31971984394066, 32.981566322526234]],
    [ "690564792",[-103.31847064999998, 32.98156885]],
    [ "690564793",[-103.06509970832906, 32.99400256208677]],
    [ "690564796",[-102.90337765, 33.0096973]],
    [ "690564798",[-103.17238089853025, 33.043712262423306]],
    [ "Cape Hatteras Substation",[-75.50592570928576, 35.3526291935781]],
    [ "690679336",[-108.36800636724548, 36.76482779753947]],
    [ "690728727",[-97.76344142510533, 35.31025536131907]],
    [ "690728732",[-97.8620273564525, 35.262196349504705]],
    [ "Herman Norcross Substation",[-96.1306811, 45.8027917]],
    [ "690835156",[-100.80621069607287, 46.88424625520983]],
    [ "Lundgren Wind Project",[-94.11711757557256, 42.37262436757975]],
    [ "Doud Substation",[-93.80756232113731, 42.08633659652921]],
    [ "690970176",[-101.76560708758856, 46.98606071957886]],
    [ "691043779",[-102.84511910722495, 47.52991092912348]],
    [ "691091979",[-102.97171956981275, 47.76001682859508]],
    [ "691092012",[-103.19617986255784, 47.7644467832739]],
    [ "Roseburg Forest Products Co.",[-92.74184607424576, 33.17625926733752]],
    [ "El Dorado Newell Substation",[-92.73703068574599, 33.203432925012514]],
    [ "Entergy Arkansas",[-92.96613559233069, 33.18957502509254]],
    [ "Entergy Arkansas",[-92.72383623987778, 33.185609775019714]],
    [ "Lanxess Corporation",[-92.70916922488884, 33.18650710798745]],
    [ "691255396",[-123.1125392, 48.094637899999995]],
    [ "Buckatunna Substation",[-88.53585416172265, 31.54449988684558]],
    [ "691383404",[-96.6114902, 33.55659505]],
    [ "691383409",[-96.62918709927266, 33.61364008158444]],
    [ "Carney",[-97.01911079999999, 35.8121833]],
    [ "Cushing",[-96.80323525295394, 35.98360055185209]],
    [ "Warwick",[-96.98161707331157, 35.76677937940495]],
    [ "691454766",[-97.40437879999999, 35.4022507]],
    [ "Crookston American Sugar Subdivision",[-96.63166912713017, 47.76732429413408]],
    [ "Mesa del Sol Substation",[-106.61401415000002, 34.9929686]],
    [ "691694990",[-98.29644023995311, 35.296698087125286]],
    [ "Waxpool Substation",[-77.48026513244172, 39.01609182631467]],
    [ "691764072",[-90.99409191500517, 42.777985332103675]],
    [ "691764091",[-96.45682597454217, 34.61808618874144]],
    [ "Sterling Substation",[-77.23217067769632, 34.71213255814956]],
    [ "691840213",[-117.32995067022145, 35.01308146058048]],
    [ "Entergy Arkansas",[-93.21564507435878, 33.18115246090806]],
    [ "691960645",[-103.77274671128515, 47.67563511672689]],
    [ "691960647",[-103.5395338722071, 47.615759422555534]],
    [ "691985681",[-96.15084314617076, 36.60013172882506]],
    [ "Subset Hills Substation",[-77.32839854367509, 38.94813739043731]],
    [ "692052904",[-77.4977044713935, 38.78769943417629]],
    [ "Liberty Substation",[-77.53395314200256, 38.774406073363586]],
    [ "Woods Delivery Point",[-77.47859521963463, 38.767378240957186]],
    [ "Station 85",[-77.49800515, 43.135496350000004]],
    [ "NIPSCO",[-85.57745665878515, 41.52416642464525]],
    [ "692141842",[-117.35363919098955, 34.06060497409088]],
    [ "692256770",[-88.6070551, 32.7977434]],
    [ "692408032",[-82.03595740842924, 37.85643975965325]],
    [ "692430813",[-103.8592214, 44.66313955]],
    [ "Haring Substation",[-85.41374086560435, 44.26346793582816]],
    [ "Chelsea Substation",[-83.9484295502985, 42.32358165708328]],
    [ "Doan Creek Substation",[-84.23561745995504, 42.51133654904726]],
    [ "Parshallville Substation",[-83.77260814541754, 42.696848013107946]],
    [ "692480611",[-87.4418787, 41.5176821]],
    [ "692491396",[-86.2286703178244, 39.78089537046143]],
    [ "Southwest Substation",[-86.20532760447902, 39.74981034678889]],
    [ "Hoosier Energy",[-86.28960034999999, 39.6179309]],
    [ "692491427",[-86.17158329372839, 39.742774974782435]],
    [ "692491436",[-86.2117157, 39.73688815]],
    [ "692494853",[-86.22997891549532, 41.84854397266373]],
    [ "Niles Board of Public Works",[-86.23656204838494, 41.84307140531619]],
    [ "Buchanan Hydro Substation",[-86.35330298932686, 41.84046571128778]],
    [ "692503741",[-103.93261366245567, 40.78185587539106]],
    [ "City of Marshall Electric Department",[-84.96008469753744, 42.28931276054131]],
    [ "Hudsonville Substation",[-85.86474919999999, 42.86566945]],
    [ "692579673",[-87.42847874376123, 31.337757766521257]],
    [ "Repton Substation",[-87.27736346213959, 31.420971876909633]],
    [ "692579679",[-87.31780371859368, 31.499342464068913]],
    [ "Frisco City Substation",[-87.3986267165263, 31.43227319886264]],
    [ "REC Orfordville",[-89.26864359999998, 42.63049229999999]],
    [ "692636230",[-89.04399701628478, 42.58266141702138]],
    [ "ComEd Prospect Heights 138kV-345kV Substation",[-87.92024898596006, 42.115218706775394]],
    [ "692638546",[-82.02296685129575, 34.50009841720425]],
    [ "692638547",[-82.01691643144692, 34.503186644893574]],
    [ "692638550",[-82.05500006004328, 34.49632013780907]],
    [ "692638555",[-82.0041626, 34.546297800000005]],
    [ "692638557",[-82.04353171699567, 34.52371430199274]],
    [ "Clinton Substation",[-81.90054881772708, 34.45294993478218]],
    [ "692638563",[-81.89972418546019, 34.45321450297437]],
    [ "692638565",[-81.8507768, 34.44837880000001]],
    [ "Consumers Energy",[-86.28875737969159, 44.2243406207412]],
    [ "West Shore Substation",[-86.3396239028569, 44.009341149515535]],
    [ "Consumers Energy",[-85.6828103634519, 43.00108783762196]],
    [ "Holland Energy Park Substation",[-86.09290027990765, 42.793369494215014]],
    [ "Potter Substation",[-78.04804038566628, 41.83807992800676]],
    [ "Pierce Brook Substation",[-78.40924434560155, 41.84212601248355]],
    [ "Patriot Substation",[-76.83876627219021, 41.17933402666538]],
    [ "Saegers Substation",[-76.8257287102586, 41.19230623960929]],
    [ "Georgia Pacific Substation",[-87.3721902, 31.49485444999999]],
    [ "692770932",[-110.81168410496402, 41.45565354848562]],
    [ "692770935",[-110.90621130000001, 41.48210069999999]],
    [ "692770936",[-110.90886645884736, 41.471537041701254]],
    [ "692799390",[-102.3761583, 47.40169525]],
    [ "692799392",[-102.38115827128088, 47.43018643030237]],
    [ "McVay Substation",[-87.8701745, 31.597866550000006]],
    [ "Chastain Hill Switching Substation",[-87.83651143308661, 31.47796938591041]],
    [ "Lowman 115/46 Switching Station",[-87.9134516, 31.483884400000004]],
    [ "692817646",[-87.89783747487293, 31.492975591059672]],
    [ "692817650",[-87.08975897507014, 31.1307925892147]],
    [ "DTE Energy",[-83.22466235, 42.081988349999996]],
    [ "692844526",[-96.09328779999998, 46.877710349999994]],
    [ "Lake Park Substation",[-96.09280865, 46.877562299999994]],
    [ "Hunt Road Substation",[-84.04587101111674, 41.93067411275427]],
    [ "Bell Road Substation",[-83.90352815212196, 43.288069099753926]],
    [ "693314157",[-84.1712474, 38.698522800000006]],
    [ "693314158",[-84.1716481140649, 38.698062355799316]],
    [ "693367853",[-85.79013209507556, 38.68114802797021]],
    [ "Colonial Pipeline Company",[-85.1945652256043, 35.06642982936894]],
    [ "Donora Substation",[-79.85533741659668, 40.17579393105175]],
    [ "Pangburn Hill Substation",[-79.91569722164996, 40.21245956570676]],
    [ "Riverview Substation",[-75.94344778890161, 40.40280688216615]],
    [ "Cambridge-Lee Substation",[-75.94142454739044, 40.419951095019634]],
    [ "Van Reed Substation",[-75.94213453579168, 40.42030590366288]],
    [ "Maremont Exhaust Products Substation",[-84.35504635000001, 35.7269928]],
    [ "Tropicana Substation",[-80.39185340543938, 27.38111525558108]],
    [ "693426607",[-80.56432629999999, 27.056473799999996]],
    [ "693426616",[-80.19719692417908, 26.074022198444936]],
    [ "Parr Hydro Substation",[-81.32935235, 34.2615997]],
    [ "693429468",[-81.16247065115518, 33.889653866655586]],
    [ "Harrogate Substation",[-83.64505822976017, 36.578510329583295]],
    [ "Danville Utilities",[-79.29842219999999, 36.661101]],
    [ "William Savage Substation",[-75.20335078529433, 38.327685809310005]],
    [ "693780469",[-75.19842287090643, 38.3305064063772]],
    [ "Culver Substation",[-75.1058392971792, 38.331910793567324]],
    [ "Lovejoy Substation",[-83.92401602764288, 42.788383427295294]],
    [ "Entergy Louisiana",[-91.09157314921424, 30.004239327425722]],
    [ "Napoleonville Substation",[-91.03051824440753, 29.946720732936914]],
    [ "693840802",[-94.92839353051811, 41.74567687886092]],
    [ "Maines Road Substation",[-84.59231174933406, 42.32950171452885]],
    [ "693938293",[-102.50280799999997, 47.42949804999999]],
    [ "693938297",[-102.63196564294286, 47.431141524916]],
    [ "Michigan Avenue Substation",[-84.97943841017671, 41.955792184594145]],
    [ "Asama Substation",[-84.97976287739172, 41.95361323666082]],
    [ "693974061",[-102.75525690060508, 47.35703391130656]],
    [ "North Loving Sub",[-104.12870900469305, 32.29625546754615]],
    [ "China Draw Substation",[-104.11560679990441, 32.06239958960524]],
    [ "693993426",[-117.97187453512724, 33.877595198519465]],
    [ "Mercer Switching Station",[-74.73265256128282, 40.18027014454551]],
    [ "Dividend Road Substation",[-84.57531610000002, 33.37095870000001]],
    [ "Milford Sub",[-85.84414830981923, 41.41349507474336]],
    [ "Kalama Substation",[-157.74620075938623, 21.408415117484868]],
    [ "Kapolei Substation",[-158.0544415628558, 21.33070305690494]],
    [ "Kaloi Substation",[-158.05698152343865, 21.359549778786405]],
    [ "694274503",[-82.55114087315557, 35.633885609457366]],
    [ "694541826",[-75.15339693861122, 38.2882140462017]],
    [ "Ceresco Substation",[-85.06116375, 42.26890744999999]],
    [ "Metuchen/Pierson Ave",[-74.34687596934464, 40.53129029879066]],
    [ "694814348",[-81.0115768674099, 33.97226040007552]],
    [ "Curtis Street Station",[-76.41888514841703, 43.29808181678985]],
    [ "Middleville Substation",[-85.38745137499858, 42.71166065520177]],
    [ "695615756",[-76.93750855776857, 37.96720947196511]],
    [ "695634375",[-83.4765046, 45.0759458]],
    [ "695956555",[-102.84313974999999, 46.87129445000001]],
    [ "696267206",[-117.85565513962297, 39.96626570548853]],
    [ "Isabella Substation",[-84.74313249089475, 43.60319997506123]],
    [ "696675635",[-86.12772505784216, 39.67918887454237]],
    [ "Reddfield Substation",[-77.18925245025017, 38.90394986609126]],
    [ "Hoodsport Substation",[-123.1524121735555, 47.403347523243156]],
    [ "Gregory Mill Substation",[-84.78586183633537, 34.93754293365369]],
    [ "Bangham Substation",[-85.46765524390263, 36.28211993205953]],
    [ "697018265",[-79.35736987478573, 37.036789295152026]],
    [ "Shattuck Substation",[-84.0464734758945, 43.44028465730017]],
    [ "Bay Road Substation",[-83.96923944460852, 43.4864658950436]],
    [ "Hernandez Substation",[-106.11141635, 36.04567375]],
    [ "697342641",[-84.16629263091106, 43.43925388734343]],
    [ "697411777",[-122.13380830424816, 37.63557164594637]],
    [ "697417720",[-119.62444041764324, 45.8360303381382]],
    [ "Hile Road Substation",[-86.16446809970712, 43.16201244253191]],
    [ "Ellis Substation",[-86.16169059409985, 43.16212016993737]],
    [ "Adams Run Substation",[-80.3539396302156, 32.71528950342039]],
    [ "Entergy Arkansas",[-90.9958740737849, 34.8348812630696]],
    [ "697896983",[-81.26960414999999, 35.5912283]],
    [ "Lincoln Substation",[-85.54227534804377, 43.92530887493821]],
    [ "Farrington Substation",[-85.62191681849636, 43.889958994529245]],
    [ "Virginia Electric and Power Company",[-77.4632259345274, 37.564244510385336]],
    [ "Talpa Sub",[-105.5920136813263, 36.33350450703831]],
    [ "Penasco Substation",[-105.68106691863204, 36.17230390014279]],
    [ "Varner Substation",[-91.61824563151632, 34.04125629428878]],
    [ "698951149",[-111.88935040629518, 46.764390252677295]],
    [ "Eastsound Substation",[-122.91211676337261, 48.701555537693025]],
    [ "Decatur Substation",[-122.8045466630714, 48.50680337493607]],
    [ "Thatcher Substation",[-122.81175468496558, 48.55143934480001]],
    [ "Blakely Substation",[-122.80982493207158, 48.57701954376126]],
    [ "Olga Substation",[-122.82395518554236, 48.61786561502026]],
    [ "698972815",[-122.91539332512099, 48.547916440791454]],
    [ "698972817",[-122.86635690490222, 48.49265567571199]],
    [ "698987271",[-123.01193593652593, 48.52923511468005]],
    [ "Shaw Substation",[-122.94804523846189, 48.57308500113595]],
    [ "Orcas Village Substation",[-122.94503829999998, 48.59927389999999]],
    [ "Gravel Pit Substation",[-122.98178584500884, 48.51823495919959]],
    [ "Valley Substation",[-71.38490088476219, 41.912947607141845]],
    [ "Electric Power Board of Chattanooga",[-85.26660491659217, 35.08082322911018]],
    [ "Brooksville Substation",[-88.55688607287607, 33.2458168497191]],
    [ "699715355",[-88.4794766122337, 33.35578242518287]],
    [ "699731060",[-88.5626900238948, 33.05858755036544]],
    [ "South Macon Substation",[-88.56248437877787, 33.05781479687447]],
    [ "Shuqualak Substation",[-88.55749321011909, 32.98262892890842]],
    [ "Puerto Rico Electric Power Authority",[-66.39698848547698, 18.240131556243387]],
    [ "Puerto Rico Electric Power Authority",[-66.6763875634963, 18.131653886517896]],
    [ "Brink Substation",[-92.32982800556019, 30.363347430323923]],
    [ "700001745",[-119.30003284408261, 47.14521717508531]],
    [ "Avery Substation",[-84.38576425010389, 34.216988920228474]],
    [ "Puerto Rico Electric Power Authority",[-67.0529776720413, 18.08243695746125]],
    [ "Subestación Lajas",[-67.05824695609252, 18.053094216377268]],
    [ "Puerto Rico Electric Power Authority",[-67.13969100680524, 18.030105817296466]],
    [ "700235891",[-86.1240240391214, 40.956352110320324]],
    [ "Rosebush Substation",[-84.76307565, 43.6987071]],
    [ "700430534",[-66.68542231624299, 18.305944683043563]],
    [ "Puerto Rico Electric Power Authority",[-66.69760565569514, 18.26873713883903]],
    [ "700431554",[-121.20345978885123, 45.63469452849439]],
    [ "Fourth Street Substation",[-91.10509028923745, 40.80827171435404]],
    [ "700554262",[-83.00638751275486, 42.50782884360424]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.30577023527756, 38.15428569331185]],
    [ "700910987",[-85.26528507588043, 38.05573551501809]],
    [ "Gordonsville Substation",[-86.68283341944174, 32.14555194378814]],
    [ "Lacks Substation",[-85.56030438496659, 42.87112362534463]],
    [ "700963232",[-119.48095963352769, 39.51344621931321]],
    [ "700964338",[-115.2170619713041, 36.05619455809602]],
    [ "Newton Substation",[-119.53034321952518, 39.57512805664381]],
    [ "Apple Data Center",[-119.54015179580084, 39.56972828357303]],
    [ "Muskegon Prison Substation",[-86.17501760000002, 43.20836855000001]],
    [ "701079580",[-111.96901655723083, 40.7340772705394]],
    [ "Short Substation",[-75.5725912864299, 38.52338802708928]],
    [ "701396959",[-80.78359554249343, 33.369835623107484]],
    [ "701962123",[-83.77015742201421, 34.495331427316934]],
    [ "701973995",[-104.83220818781813, 31.030772964212755]],
    [ "Virginia Electric and Power Company",[-78.2059106, 37.01827015]],
    [ "Kenbridge Substation",[-78.13168193036161, 36.959592565331135]],
    [ "Howard City Substation",[-85.46554720298047, 43.41076710566092]],
    [ "Cedar Springs Substation",[-85.55519631787654, 43.22118040594704]],
    [ "702227243",[-113.01961408436634, 38.49274564330883]],
    [ "Hickory Substation",[-113.02011262320138, 38.491978644653734]],
    [ "Tushar Substation",[-112.5860785224441, 38.56375088284486]],
    [ "Billwood Substation",[-84.67685742591146, 42.669572447087965]],
    [ "Clover Substation",[-111.89499591590966, 39.78900387986703]],
    [ "Limestone Switching Station",[-67.83070352055809, 46.928961742252035]],
    [ "Carolina Beach Substation",[-77.9078061597504, 34.03589792965584]],
    [ "North Louisburg",[-94.6928033774661, 38.62776523909641]],
    [ "702521696",[-84.40185435, 31.128370499999992]],
    [ "702813465",[-84.9462935503387, 39.806934970112145]],
    [ "Pleasant Garden Retail Substation",[-79.75459610484104, 35.94447990536923]],
    [ "Clermont Substation",[-84.29097284154082, 38.99507452824776]],
    [ "703214337",[-84.08378757634154, 38.297196793356605]],
    [ "703214340",[-84.03114164740808, 38.311945221831486]],
    [ "703225429",[-82.11619745, 38.933582949999995]],
    [ "703225433",[-82.11508219999997, 38.938890400000005]],
    [ "703228518",[-82.99286060634189, 39.11326335489704]],
    [ "Flint Energies",[-83.62164411195403, 32.62666077886777]],
    [ "703260604",[-106.56906202494, 35.050772807338184]],
    [ "703267121",[-106.60756038440671, 35.05410959417189]],
    [ "703267122",[-106.60767599578884, 35.051483848080785]],
    [ "703267123",[-106.6071818, 35.049997450000006]],
    [ "703267127",[-106.6075037212709, 35.05796448765558]],
    [ "703325075",[-113.553158210054, 37.092526907661416]],
    [ "703325091",[-113.54103344802957, 37.104797784947905]],
    [ "703477664",[-98.40695115, 33.766959199999995]],
    [ "703477669",[-98.48472774999999, 33.7904347]],
    [ "703477673",[-98.51952750269658, 33.82888231654916]],
    [ "703485800",[-106.54567512347839, 35.036596302658374]],
    [ "703485803",[-106.5419707590265, 35.04469254334639]],
    [ "Dixie Pipeline Company LLC",[-89.58169662716102, 31.2594915407717]],
    [ "Babson Park Substation",[-81.52398310000002, 27.83229465]],
    [ "Chestertown Substation",[-76.05886833799515, 39.22555012656314]],
    [ "Frostproof Substation",[-81.52800277538876, 27.742076961210152]],
    [ "704158329",[-80.54123585, 35.6124693]],
    [ "West Columbus Switching Station",[-88.4886711062761, 33.47481451579717]],
    [ "Golden Triangle Substation",[-88.56602467503822, 33.45407559188679]],
    [ "Steel Dynamics Substation",[-88.5717901, 33.45067625]],
    [ "Steel Dynamics Switching Station",[-88.57073664478179, 33.45218627520368]],
    [ "Monroe County Electric Power Association",[-88.45015661026243, 33.72514777360008]],
    [ "Tronox Substation",[-88.45320261186163, 33.7291701252372]],
    [ "704220130",[-88.45301447253571, 33.72765800408414]],
    [ "704220132",[-88.45629620000001, 33.8323237]],
    [ "704220137",[-88.4155947, 34.2533279]],
    [ "704220140",[-88.68432956900953, 34.23805371378706]],
    [ "704226770",[-106.50763355000001, 34.9986617]],
    [ "704233028",[-95.79311320838389, 32.63025953751876]],
    [ "704233029",[-95.99716075575472, 32.6164100129551]],
    [ "704356960",[-85.37326501889557, 41.13295747449998]],
    [ "704357713",[-86.06735170293217, 39.521935289920854]],
    [ "704357714",[-86.06271364999999, 39.524458349999996]],
    [ "AEP Webster Substation",[-85.14164680292255, 41.06984297226703]],
    [ "AEP Melita Substation",[-85.1414377855557, 41.070577293084305]],
    [ "704396816",[-80.54930995000002, 35.57320725]],
    [ "704557912",[-77.51560122429156, 37.57398786632039]],
    [ "704711905",[-115.08529803375532, 36.24092960962433]],
    [ "Clayton Road Substation",[-84.90390441879302, 45.436436651278015]],
    [ "704873417",[-102.42474204583807, 34.51618568794566]],
    [ "704929105",[-97.0693316576784, 30.567470232651818]],
    [ "704929106",[-97.06965007443158, 30.56885513281103]],
    [ "704947801",[-95.61276642534159, 34.92718510397745]],
    [ "Lone Oak",[-95.5439438849064, 34.872021746677]],
    [ "704952402",[-95.75089250975755, 34.94756478198335]],
    [ "Phillipsdale Substation",[-71.36674725, 41.845140099999995]],
    [ "705014791",[-92.23715382218887, 40.9864780805055]],
    [ "705150773",[-95.32619467467259, 35.24681333984744]],
    [ "705150786",[-95.11377467513384, 35.28894707278428]],
    [ "705167880",[-95.31156540871395, 35.406575374920756]],
    [ "High Lonesome Mesa Wind Substation",[-105.96713685, 34.47266325]],
    [ "705173203",[-98.9342001615203, 35.861253069790195]],
    [ "Passadumkeag Windpark Substation",[-68.59014495749179, 45.036767975830344]],
    [ "Clear Lake Substation",[-96.68482440126779, 44.74622080001239]],
    [ "705545975",[-92.47283635000002, 44.73100465]],
    [ "Trimbelle Substation",[-92.55746847455416, 44.69551049350443]],
    [ "705657731",[-80.59561601663314, 33.32417685110524]],
    [ "Rockville Substation",[-76.90209972369892, 40.33751945475513]],
    [ "705820745",[-77.91122334322367, 35.13888126747319]],
    [ "REC Center",[-89.20053813590418, 42.70154141695463]],
    [ "Union Townline",[-89.27894662780375, 42.75886964721906]],
    [ "Dolphin Substation",[-83.25903908425892, 42.384716756011244]],
    [ "705836006",[-92.06355022500128, 44.63734620885698]],
    [ "705836019",[-92.37531314999998, 44.76136]],
    [ "Georgia Power",[-85.21735549257838, 33.70123347698651]],
    [ "Plantation Pipeline Substation",[-85.1413218796264, 33.702575109954445]],
    [ "706084737",[-122.56302507675639, 48.47020617474822]],
    [ "706096010",[-103.18222332566391, 36.42235461619753]],
    [ "706096015",[-103.02939054999999, 36.37736975000001]],
    [ "706096025",[-103.45269961857421, 36.156778291530586]],
    [ "706096026",[-103.29985119866284, 35.854027064880256]],
    [ "706096034",[-103.16145127355921, 35.857291230326794]],
    [ "706139916",[-94.36009334418256, 33.60191043146866]],
    [ "Stardust Sub",[-106.52519044549663, 35.31593435388874]],
    [ "706240944",[-106.55605945001031, 35.291747202081815]],
    [ "Athens Substation",[-85.23026513516841, 42.08873677566669]],
    [ "Craighead Electric Cooperative Cooperation",[-90.74675963524649, 36.06801253183686]],
    [ "Paupack Substation",[-75.26555035234635, 41.4679725642878]],
    [ "Pocono Substation",[-75.45054401695563, 41.28705061420659]],
    [ "Acahela Substation",[-75.63728868938477, 41.14652941988344]],
    [ "Georgia Transmission Corporation",[-83.58294215501876, 30.752697249202914]],
    [ "Creswell Substation",[-76.38315997506113, 35.876496401443134]],
    [ "706750421",[-121.20288080674295, 45.63702405316405]],
    [ "Cottonwood",[-119.37079380578764, 45.79871552217467]],
    [ "Delafoil Substaiton",[-83.6386404049929, 41.51500807508742]],
    [ "706965681",[-85.86748164599017, 41.27677725525447]],
    [ "707010828",[-86.33585079129479, 41.35112103088439]],
    [ "707081757",[-86.64572238054808, 34.715982704438936]],
    [ "707081759",[-86.65052779337037, 34.717168977167454]],
    [ "707085031",[-81.21275267241494, 35.63908850639432]],
    [ "707086219",[-81.14371563562578, 35.71451451710683]],
    [ "707086223",[-81.13459109102318, 35.72319307088729]],
    [ "707086224",[-81.15323412383823, 35.70425330854671]],
    [ "707086225",[-81.15076182391152, 35.70334774350767]],
    [ "707086229",[-81.18649818423094, 35.70886568844939]],
    [ "707087466",[-81.03051934999999, 35.65235145]],
    [ "Appalachian Power Company",[-81.42232094510352, 36.85803583348402]],
    [ "Harvey Couch Substation",[-93.46424658965425, 33.35915822132555]],
    [ "Huttig Substation",[-92.2025878, 33.04361245000001]],
    [ "Eurora Substation",[-91.28317179999999, 33.109479]],
    [ "Montrose East Substation",[-91.44165852753741, 33.30358471029265]],
    [ "Strong Substation",[-92.40265792704876, 33.127349325406335]],
    [ "Enterprise Products Operating LLC",[-92.60699336275538, 33.113721675367316]],
    [ "Entergy Arkansas",[-92.57728300350472, 33.19749153366881]],
    [ "Central Substation",[-84.55320841334502, 42.725073216781496]],
    [ "Pittsfield Generating LP Substation",[-73.21819577091247, 42.45588536648772]],
    [ "Woodpecker Substation",[-77.4454675571334, 38.09048422981136]],
    [ "Ladysmith CT Substation",[-77.51302226259745, 38.07305071672339]],
    [ "Fuller Road Substation",[-77.3276314789986, 38.53354266177245]],
    [ "707280719",[-77.28080767775431, 38.53752289904698]],
    [ "707291532",[-77.61347293590693, 35.82947819725789]],
    [ "Chinquapin Substation",[-77.47801781496108, 35.82874305603506]],
    [ "707395617",[-85.42685388181059, 40.80065185335085]],
    [ "707395632",[-85.1657377, 41.07072385]],
    [ "707445059",[-92.52260257814382, 44.07287415694065]],
    [ "Gaston Substation",[-77.81137293994135, 36.49874203475776]],
    [ "707490104",[-78.91300987922406, 36.70040817028586]],
    [ "Lawrenceville Substation",[-77.84644894245653, 36.749682654826955]],
    [ "707490108",[-77.92109892942642, 36.74132912200776]],
    [ "Virginia Electric and Power Company",[-78.3783853, 36.683270300000004]],
    [ "707490120",[-78.92002711282842, 36.67190749471511]],
    [ "707490121",[-78.90352292874974, 37.088728146678996]],
    [ "CPC Hancock Substation",[-78.83505885000001, 37.15785615]],
    [ "707490125",[-78.7576760839071, 37.222950782087764]],
    [ "707490129",[-78.87653744910247, 36.69835879367501]],
    [ "707490130",[-78.87643597767627, 36.69768385953907]],
    [ "707490134",[-78.81133732133156, 36.67049968083591]],
    [ "707528972",[-80.2351448245614, 36.12373223676537]],
    [ "707960044",[-117.53936647469621, 33.85542180299388]],
    [ "Wolftever Substation",[-85.07054830000001, 35.16980135]],
    [ "708137946",[-77.5593934430287, 38.4813463516944]],
    [ "Clover Hill Substation",[-77.49930030346674, 38.71950428630329]],
    [ "708151711",[-79.78685679897848, 32.85243421393019]],
    [ "708152212",[-77.60975231577882, 37.25366995323477]],
    [ "708153175",[-87.89620969698014, 33.9650650317912]],
    [ "Guin Substation",[-87.87517351814046, 33.95690209922403]],
    [ "708153355",[-85.73096567159438, 40.56472867172622]],
    [ "Georgia Power",[-83.58587306558856, 30.78308679359856]],
    [ "708322522",[-76.60098774115394, 36.0641732205145]],
    [ "Edenton Switching Station",[-76.60008105, 36.06417445]],
    [ "Edenton Substation",[-76.60140474999999, 36.06332234999999]],
    [ "Huntsville Utilities",[-86.6475014400611, 34.63322922515858]],
    [ "Huntsville Utilities",[-86.65344200000001, 34.634257299999994]],
    [ "708507837",[-81.61528054682144, 35.07206558058528]],
    [ "708507841",[-81.58328721065735, 35.0943260612182]],
    [ "708564361",[-74.48386457529904, 40.55841221409576]],
    [ "Concast Substation",[-80.03078782589499, 40.72491505009712]],
    [ "708669861",[-82.2042098, 27.689545399999997]],
    [ "708669863",[-82.14573759999999, 27.70483215]],
    [ "708669864",[-82.14675351934214, 27.70530501255194]],
    [ "708669867",[-82.0755422362115, 27.70324356421366]],
    [ "708669869",[-82.00265085208189, 27.7294378830957]],
    [ "708669877",[-81.8786771285767, 27.848378416304982]],
    [ "Entergy Louisiana",[-90.832728, 30.0859308]],
    [ "Nucor Steel Louisiana LLC",[-90.85640252906352, 30.076793790435154]],
    [ "708703828",[-111.54382402218938, 42.74057011807378]],
    [ "Babbitt Substation",[-82.74438838912164, 40.0745354487154]],
    [ "Letohatchee Substation",[-86.48055973428282, 32.12133608369076]],
    [ "708931351",[-87.26428590000002, 36.595586299999994]],
    [ "Montgomery Substation",[-87.25291768583756, 36.59478109057131]],
    [ "709227140",[-83.39284128308708, 42.19972254505739]],
    [ "Leakesville Substation",[-88.55897536521402, 31.157393517079424]],
    [ "709713207",[-95.46147509999999, 41.35385589999999]],
    [ "710319514",[-94.52239454004207, 46.939708748030334]],
    [ "Florida Power & Light",[-80.52128926242688, 27.86582822518881]],
    [ "Florida Power & Light",[-80.50386428356036, 27.58125124941301]],
    [ "Blue Cypress Substation",[-80.52694850480522, 27.60870412759639]],
    [ "710569734",[-87.19978519423567, 30.616225918662835]],
    [ "Greenville Substation",[-81.83021529533751, 30.81030077061152]],
    [ "710573555",[-106.47886935515945, 32.388829484807935]],
    [ "La Morada Substation",[-106.7264824101589, 35.1104305750734]],
    [ "710638001",[-95.68709451404672, 40.6376343520637]],
    [ "710709893",[-122.9096629521933, 42.43123270403268]],
    [ "711008201",[-83.3212895196346, 42.18053887447686]],
    [ "711143602",[-81.02319059074028, 35.19035527699044]],
    [ "Hempfield Substation",[-79.58819975669007, 40.29910481059613]],
    [ "Trinity Substation",[-122.93439750479493, 40.71806372767593]],
    [ "711645335",[-94.761046914671, 34.03063740447404]],
    [ "King Ranch Substation",[-104.90822944701146, 41.11834983462924]],
    [ "Aepo Substation",[-159.4937359925308, 21.90462896722058]],
    [ "AES",[-159.4939572608859, 21.9050534792192]],
    [ "Maury Substation",[-77.59396233656456, 35.47898387225369]],
    [ "712128338",[-110.94943138471953, 32.1100816690045]],
    [ "712139805",[-106.36668322291926, 31.771691887520184]],
    [ "North Muskegon Substation",[-86.25662741771654, 43.26268823511462]],
    [ "NICOLET PAPER CO",[-88.07036417870978, 44.44922363995939]],
    [ "Opportunity Substation",[-96.70373546051687, 46.83990244847088]],
    [ "712355948",[-77.13903113806491, 38.80796572853675]],
    [ "712561701",[-92.04897822812784, 38.02939325521333]],
    [ "712561702",[-92.05164763501654, 38.02648801057407]],
    [ "Holland Cliffs Switching Station",[-76.6651233440506, 38.61267738986922]],
    [ "Metamora Substation",[-83.31393326810863, 42.94572937799604]],
    [ "Sierra Substation",[-82.50768328039985, 43.170717112738835]],
    [ "713113611",[-83.63130354930601, 31.7588050222626]],
    [ "713117889",[-78.32793868523723, 35.323480821491366]],
    [ "713117890",[-78.260955189032, 35.326661128472]],
    [ "Bird Road Substation",[-71.17745077786176, 42.0523818279336]],
    [ "Snow Vista Substation",[-106.73664736580656, 35.04501898870355]],
    [ "713482066",[-106.21103765528284, 31.824786394353456]],
    [ "Range Camp Sub",[-106.14408833052704, 32.40580924479448]],
    [ "713486401",[-106.28942012426694, 32.39294304403538]],
    [ "Biggs Substation",[-106.33966057772182, 31.86407399547193]],
    [ "713486411",[-106.31550068497347, 31.85898649028022]],
    [ "713486424",[-106.31614112494903, 31.830327025409503]],
    [ "713490459",[-120.49982219578858, 46.581084846368334]],
    [ "713645970",[-121.95070307986528, 37.371955938864126]],
    [ "713652632",[-121.9675160750441, 37.386590455230554]],
    [ "Kaumakani Substation",[-159.61673685, 21.916118400000002]],
    [ "Lawai Substation",[-159.50143805, 21.9207951]],
    [ "Lihue Substation",[-159.3759298771042, 21.9762576784305]],
    [ "Lydgate Substation",[-159.3409085129686, 22.03548943295077]],
    [ "Wainiha Substation",[-159.5558578922062, 22.19652129470781]],
    [ "Ladrino Foods",[-121.41684392485861, 37.756111744403405]],
    [ "714070439",[-111.90736648992036, 40.47913556494972]],
    [ "714073447",[-111.91319703587254, 40.42400642523126]],
    [ "714078353",[-106.084846, 32.8589069627342]],
    [ "714125772",[-83.23735659715398, 42.471053233972206]],
    [ "Waterloo Substation",[-83.51384478883735, 31.573678174142334]],
    [ "714526585",[-84.61644809080566, 38.980614218989395]],
    [ "Jackson Road Substation",[-74.24509014243421, 40.906275304738024]],
    [ "714852819",[-112.03831290765102, 40.5666059499844]],
    [ "714852821",[-112.0459127009805, 40.565104639555194]],
    [ "714889161",[-85.74568119302823, 34.91113787686729]],
    [ "714889164",[-85.70242959999999, 34.94791815]],
    [ "714889165",[-85.71782513764404, 34.961532228475534]],
    [ "Hwy 50 Substation",[-96.14056914015025, 41.12542420703343]],
    [ "715098037",[-81.39032933258332, 35.253116728041206]],
    [ "Athens Utilites Board",[-84.6244453203903, 35.439837698481476]],
    [ "715186394",[-83.52668251609353, 43.28023582126828]],
    [ "715406576",[-92.15637601759933, 38.60259965247801]],
    [ "Jonesboro City Water and Light",[-90.64284070209794, 35.81349292895768]],
    [ "Walden Substation",[-74.19482783382037, 41.55910131573689]],
    [ "Georgia Power",[-84.00936595846396, 34.10719422086978]],
    [ "Georgia Power",[-84.00611569194277, 34.10822912996306]],
    [ "Certainteed Substation",[-83.33200156735587, 33.97777670334326]],
    [ "715622770",[-81.4109189550191, 35.250458618592404]],
    [ "Mound Substation",[-93.662568483933, 44.93764024399102]],
    [ "Electric Power Board of Chattanooga",[-85.31686945000001, 35.1178328]],
    [ "717018856",[-117.77543990552175, 34.057486691961515]],
    [ "Chula Substation",[-83.54757456031524, 31.55690802553735]],
    [ "Edwards Ferry Substation",[-77.50478892745059, 39.1132832475626]],
    [ "717440782",[-100.89082323493183, 46.84359472524097]],
    [ "New Road Substation",[-77.62019789773568, 38.932372371164846]],
    [ "Dominion Energy",[-77.63512663538403, 38.86707648023682]],
    [ "Flatwoods Switching Station",[-87.63010464858763, 33.24523730615849]],
    [ "Buhl Substation",[-87.75144147734859, 33.25983110575997]],
    [ "717590562",[-87.6019111993767, 33.2460921901145]],
    [ "717590563",[-87.60680842804672, 33.19245688049275]],
    [ "Tennessee Valley Authority",[-89.11566363746995, 32.765909633148425]],
    [ "Tennessee Valley Authority",[-89.11558577518608, 32.767272392170064]],
    [ "717602987",[-89.11804275, 32.7572235]],
    [ "717622473",[-85.36800312525541, 41.52656285589614]],
    [ "Bluffton Substation",[-83.88627326499945, 40.89277552169884]],
    [ "Orcas Substation",[-122.94417836411536, 48.62860680289134]],
    [ "Edinboro South Substation",[-80.1103427983883, 41.8486449383613]],
    [ "717797246",[-76.85082195772492, 35.49103649950832]],
    [ "Kaukauna Utilities Combined Locks Substation",[-88.30303150203403, 44.269321885204214]],
    [ "718098483",[-94.7739899190259, 34.04410959343599]],
    [ "Southwest Arkansas Electric Cooperative",[-94.37934726887278, 33.74481026387183]],
    [ "718102838",[-94.72186152499704, 33.836886485856795]],
    [ "718111257",[-94.15070748773971, 33.892730124297444]],
    [ "718221126",[-83.19734826653253, 40.10192075805916]],
    [ "718224489",[-77.55534373868501, 42.30486782832727]],
    [ "FIXME Substation",[-95.72022043585848, 37.88982503133229]],
    [ "Southwestern Electric Power Company",[-94.03573140671172, 33.49011931245263]],
    [ "Choptank Electric",[-75.75279174169565, 38.675815114059645]],
    [ "718424571",[-75.78930847840164, 38.68480334693382]],
    [ "East New Market Substation",[-75.90714455402095, 38.59790825491966]],
    [ "718490833",[-87.88566872496928, 30.544654792740992]],
    [ "Eagle Creek Substation",[-122.35950593944114, 45.357018200109515]],
    [ "North Vernon Substation",[-85.62720011984946, 39.00520177486279]],
    [ "719020387",[-83.23838620724695, 31.74257276907076]],
    [ "719059094",[-112.1161611352622, 33.464818181870314]],
    [ "719411672",[-84.22381193113753, 30.42981857693393]],
    [ "719462329",[-98.74714779985885, 36.058411187667254]],
    [ "Trappe Substation",[-76.09436608601298, 38.694132296242444]],
    [ "Tanyard Substation",[-75.96855897962168, 38.7270765316742]],
    [ "Polar Beverages Substation",[-83.22622570070754, 31.713328729988522]],
    [ "719981179",[-84.20723197823378, 30.189159264672128]],
    [ "719981180",[-84.21042167504929, 30.189022692872587]],
    [ "720101875",[-88.34820685801473, 44.26499362479413]],
    [ "720218496",[-88.08839830363647, 38.74889762266651]],
    [ "Mountain Avenue Substation",[-74.51854008296165, 40.58055123859099]],
    [ "720594147",[-83.35611029389372, 31.756478620405133]],
    [ "720665484",[-90.07708158263543, 36.441842697126255]],
    [ "720665498",[-89.71160227881639, 36.41268788378546]],
    [ "Tiptonville Substation",[-89.46540219999999, 36.3770562]],
    [ "Pacific Gas and Electric Company",[-120.96548866873805, 38.65329930933782]],
    [ "APCI Substation",[-80.21364823403297, 41.53080565876669]],
    [ "720714557",[-91.64320763514469, 39.5268376061183]],
    [ "Enterprise Way Substation",[-90.60968288264738, 41.6113283860819]],
    [ "Union Substation",[-86.17635725903712, 41.6541108370929]],
    [ "Jacksonville Substation",[-84.36373470000001, 38.286465050000004]],
    [ "Holloway Substation",[-84.60473026154654, 37.93681617812427]],
    [ "Headquarters Substation",[-84.11322748410986, 38.359559818307176]],
    [ "Davis Substation",[-84.47056293334613, 37.92470055003035]],
    [ "Crooksville Substation",[-84.20796945, 37.657618]],
    [ "Clay Lick Substation",[-84.85613129132466, 37.902837876261486]],
    [ "Colemansville Substation",[-84.40829887811313, 38.52775772748618]],
    [ "721047660",[-81.08855020921992, 35.06112505836976]],
    [ "721047661",[-81.07217353984139, 35.04862722489336]],
    [ "AEP 3M Substation",[-85.35911767991246, 40.44553095581288]],
    [ "Cherokee Substation",[-83.32388579773524, 35.48202470742443]],
    [ "Rosedale Substation",[-78.91823437423086, 40.33693438205699]],
    [ "Fowler Substation",[-112.22985494075436, 33.47424686405279]],
    [ "Huntsville Utilities",[-86.76034345, 34.648979]],
    [ "721265426",[-86.8340854, 34.6352129]],
    [ "Staunton Substation",[-79.06666715586938, 38.14794740445211]],
    [ "721420296",[-85.55334374999998, 32.548003699999995]],
    [ "721723313",[-79.33757836483875, 37.3084246624221]],
    [ "Waller Substation",[-76.70558004629838, 37.29584856405248]],
    [ "721980293",[-77.60164752902548, 34.4503434846045]],
    [ "Holly Ridge Switching Station",[-77.55669981535301, 34.480087555920164]],
    [ "721980299",[-77.63251119881228, 34.43478392343464]],
    [ "Keenan 2 Wind Farm Subtation",[-99.49058145559424, 36.27654286995673]],
    [ "Oklahoma Gas & Electric",[-99.4803869112241, 36.33444652471645]],
    [ "North Alexandria Substation",[-77.05200388410674, 38.82052226370031]],
    [ "Airport Substation",[-83.87980376310585, 40.884232937976705]],
    [ "722435718",[-86.92993910898794, 38.37637250121269]],
    [ "Central Substatioin",[-86.92659298728188, 38.39312593323885]],
    [ "Antrim Substation",[-85.4050715, 44.90214175]],
    [ "722495983",[-86.9218641, 38.80755984999999]],
    [ "722495997",[-86.68784205070341, 38.51771149339565]],
    [ "722496001",[-86.9151703922797, 38.62823633577301]],
    [ "722498878",[-85.85418766534077, 38.305318104447785]],
    [ "Petersburg Substation",[-87.27727649930954, 38.49943826576774]],
    [ "722532232",[-111.6904881686509, 40.282738345012326]],
    [ "Boise Cascade Substation",[-86.7025767235861, 32.90134149256048]],
    [ "Stella Jones Substation",[-86.90760445000001, 33.06429]],
    [ "West Fraser Substation",[-83.79873475, 31.9629325]],
    [ "722550567",[-77.60667341103303, 35.32035503580499]],
    [ "Hillsboro Substation",[-75.93437494430805, 38.930155845127764]],
    [ "Poplar Spring Substation",[-80.94176815054271, 33.48788369887702]],
    [ "Orangeburg Primary Substation",[-80.88891418468961, 33.45954356887499]],
    [ "722707020",[-76.74424698918669, 37.97318016009914]],
    [ "Azalea Park Substation",[-83.28817762509871, 30.80615349375803]],
    [ "722729259",[-78.07458354999999, 34.2594311]],
    [ "Galesburg Monmouth Boulevard",[-90.39859032279787, 40.93432441507339]],
    [ "Engelhard Substation",[-83.22866644999999, 32.8491091]],
    [ "Centreville Substation",[-87.1432288, 32.9442319]],
    [ "722779369",[-87.08310635809227, 32.97735611110464]],
    [ "Aldrich Substation",[-86.88944120000001, 33.11648645]],
    [ "722782150",[-87.77695265000001, 30.86606315]],
    [ "722938483",[-89.52428782133987, 34.40753363491497]],
    [ "Grande Prairie Wind Farm South Substation",[-98.50225924584421, 42.60196170019882]],
    [ "Grande Prairie Wind Farm Substation",[-98.42091595176738, 42.62651783550271]],
    [ "723324505",[-83.47329466321, 38.206964041645286]],
    [ "East Kentucky Power Cooperative, Inc.",[-83.88279787984709, 38.04080670666256]],
    [ "723324510",[-84.15156728324872, 37.996258104512386]],
    [ "723324527",[-84.18555476196373, 38.02068259614421]],
    [ "723324531",[-84.1838412760734, 38.01337642112692]],
    [ "723505318",[-85.89709935, 41.247115750000006]],
    [ "Airport Substation",[-85.83543497538113, 41.26718470977252]],
    [ "723507345",[-111.73529151077294, 40.28488752515339]],
    [ "West Williamsport Substation",[-77.0489541904196, 41.228719780757274]],
    [ "723738158",[-77.04581905, 41.246209050000004]],
    [ "723814163",[-78.5857405197547, 35.79374254511079]],
    [ "723822487",[-101.55027949418286, 46.50959763117561]],
    [ "East Petersburg Substation",[-76.3410246162214, 40.08885279562479]],
    [ "Leola Substation",[-76.20930264991011, 40.07683588831699]],
    [ "723848441",[-76.34153279931576, 40.07388793169743]],
    [ "723875588",[-76.04406226470059, 41.57095829742868]],
    [ "723891529",[-78.77279746150558, 42.85220516503832]],
    [ "724048021",[-85.99326855001677, 41.62012627656968]],
    [ "Grand Forks Master Substation",[-97.05144971179084, 47.93827216708252]],
    [ "Elm Substation",[-80.78057433633568, 41.276985539645814]],
    [ "Warren Substation",[-92.51678567794973, 44.959666077034285]],
    [ "Tennessee Valley Authority",[-85.96935527810457, 36.95429974130611]],
    [ "724173222",[-85.90359184775318, 36.97990510273425]],
    [ "724173223",[-85.935122519297, 36.97613283635369]],
    [ "724173226",[-86.03092359435679, 36.9849905292595]],
    [ "724188083",[-111.63525031571388, 40.10182350933886]],
    [ "724195901",[-118.15570872663507, 38.53572572584872]],
    [ "Three Lakes Substation",[-92.53357679332998, 45.034616048897725]],
    [ "724416368",[-92.53200096533988, 44.913822982280024]],
    [ "Pine Lake South",[-92.34036841931349, 45.033758317039556]],
    [ "724490256",[-92.88333888181425, 37.328519082521495]],
    [ "724586859",[-101.83969203263746, 46.4156110340474]],
    [ "724593005",[-83.18095652329212, 31.47890263207499]],
    [ "Hooterville",[-89.93643121855123, 43.01018624442922]],
    [ "PETENWELL",[-90.02250630756198, 44.05706077797744]],
    [ "724798108",[-89.9068940820645, 44.15471354047548]],
    [ "724806728",[-105.70851302004498, 48.08891062716531]],
    [ "724806734",[-105.5333189655727, 47.454052825972575]],
    [ "Glory Substation",[-103.61013962893328, 40.14571082690869]],
    [ "Harvest Mile Substation",[-104.70297092182243, 39.63365737363966]],
    [ "Limon Wind Energy Center III Substation",[-103.4156138699811, 39.36098918562744]],
    [ "Woodrow Substation",[-103.61007788039034, 39.988495270967505]],
    [ "South Woodrow Substation",[-103.63038732749676, 39.85665751221147]],
    [ "Last Chance Substation",[-103.63059090593342, 39.73937578702651]],
    [ "Toll Road Substation",[-83.27448231362365, 41.96574318734018]],
    [ "APS Pleasant Substation",[-112.23724039018576, 33.660208030559126]],
    [ "725186838",[-86.28319186619468, 33.1664701011235]],
    [ "725186839",[-86.28290487152401, 33.16591952570399]],
    [ "Sylacauga Utilities Board",[-86.27621805, 33.1678782]],
    [ "Alabama Power",[-86.27704851163901, 33.16788916954699]],
    [ "Sylacauga Substation",[-86.2810533383843, 33.167558270250105]],
    [ "Sylacauga Utilities Board",[-86.25460860000001, 33.17036525]],
    [ "725192869",[-69.9745211, 43.9039159]],
    [ "725194839",[-95.91639920750437, 36.259119525063866]],
    [ "725194842",[-95.91153684973688, 36.25899561985683]],
    [ "725194843",[-95.91176948956343, 36.25807709181744]],
    [ "725198744",[-111.66061679232492, 40.122560128958746]],
    [ "725199113",[-111.65785833883946, 40.147363067596814]],
    [ "725388649",[-106.6191179, 48.190096849999996]],
    [ "725388655",[-106.51125825, 48.1651159]],
    [ "725388656",[-106.51223057145438, 48.16562810528076]],
    [ "725388668",[-111.07394657445953, 47.50501839220287]],
    [ "725388670",[-111.14180379999999, 47.58200665000001]],
    [ "725388683",[-111.55426951355447, 45.87851888273532]],
    [ "725393886",[-108.48592235000002, 45.778760999999996]],
    [ "725393888",[-108.48906836068119, 45.77822423090376]],
    [ "725425496",[-111.82880819226949, 41.852037954107246]],
    [ "725425497",[-112.19601535, 41.89342875]],
    [ "725427991",[-106.73241549999997, 34.61184115]],
    [ "Waterbury-60 Substation",[-72.7490438597641, 44.32345601481436]],
    [ "Coolodge Substation",[-72.66013046803776, 43.42924084375054]],
    [ "Fort Monmouth Substation",[-74.0411606051572, 40.31217965186109]],
    [ "Lumber City Substation",[-82.6768678, 31.92518515]],
    [ "725814054",[-83.22616392937515, 32.21720121940184]],
    [ "725817383",[-87.40911405809136, 41.6371966557509]],
    [ "725820162",[-91.21369953534081, 30.559945071991738]],
    [ "725826794",[-88.02853815, 31.254005100000008]],
    [ "Olin Corp",[-88.0046873, 31.263791750000006]],
    [ "Olin Corp",[-88.00529209999999, 31.263788350000006]],
    [ "725826798",[-88.00910932786746, 31.263105519492843]],
    [ "725837016",[-88.10346193644085, 31.1228732719933]],
    [ "725837020",[-88.02030780832798, 31.233066378500745]],
    [ "725846446",[-88.08000117876492, 42.5328866667692]],
    [ "Pleasant Prairie Substation",[-87.90822221122991, 42.53822857164064]],
    [ "Mt. Clemens Substation",[-82.89544263453003, 42.59800868812453]],
    [ "Asylum TWP",[-76.38832201531999, 41.76571851422174]],
    [ "Tiffany Substation",[-75.82946921533556, 41.853391988918304]],
    [ "Lenox Substation",[-75.71590354359718, 41.665334617081406]],
    [ "726266940",[-96.84204327546436, 45.591835629789706]],
    [ "North East Mississippi Electric Power Association",[-89.55988586389743, 34.388474001133034]],
    [ "Roberts Substation",[-92.53803025, 45.04979835]],
    [ "White Pine Substation",[-92.55744722096412, 45.09707722485226]],
    [ "Redman Substation",[-82.87509138239095, 43.92885043442303]],
    [ "Camelot Lake Substation",[-84.60389900286657, 43.58388952344134]],
    [ "Eight Point Substation",[-85.0035309638171, 43.85600472533211]],
    [ "727332468",[-108.25167093086218, 36.76527486902334]],
    [ "Bull Hill Substation",[-68.16379745, 44.72251705]],
    [ "727581863",[-98.84714710000002, 43.388463550000004]],
    [ "Smartsville Substation",[-121.30304718252327, 39.2087447994741]],
    [ "Milford Substation",[-83.59856478145413, 42.58233710023902]],
    [ "Blanding City Substation",[-109.47301180067466, 37.62523141638356]],
    [ "727892953",[-96.8731068, 48.4538103]],
    [ "Engineered Floors Substation",[-84.99483511677694, 34.65968297849832]],
    [ "727910326",[-85.00400253484267, 34.670265885510226]],
    [ "727910333",[-84.93275147740015, 34.636915269832386]],
    [ "727910347",[-84.9444894072449, 34.69936861018714]],
    [ "Venice Substation",[-83.20998378975875, 42.29389920675542]],
    [ "Montgomery Substation",[-74.65541291147258, 40.39302218905922]],
    [ "728090300",[-77.07294664999999, 35.8411287]],
    [ "City of Owensboro",[-87.08609359202634, 37.76975497915867]],
    [ "Cloverport Substation",[-86.62348513206686, 37.82303970438741]],
    [ "Pratt Industries Substation",[-83.9908747756062, 33.66124427299481]],
    [ "728899889",[-114.4848808, 42.55301150000001]],
    [ "728903406",[-93.17113761289995, 37.248088095382585]],
    [ "728905736",[-114.6303812726935, 42.945882299118594]],
    [ "Valley Creek Substation",[-81.79033132571632, 36.149782276107224]],
    [ "Thomaston #3 Substation",[-84.26647915000001, 32.94656410000001]],
    [ "The Rock Substation",[-84.2515587, 32.9606938]],
    [ "Parlin Substation",[-74.3262047932821, 40.460571103473065]],
    [ "Horse Cave Industrial Substation",[-85.9149797968453, 37.17058511265769]],
    [ "Roundtable Substation",[-77.4667136621364, 39.005236542817286]],
    [ "City of Tallahassee",[-84.20011261880114, 30.51388991531398]],
    [ "Crofton Substation",[-85.20072474999999, 44.69907164999999]],
    [ "Argyle Substation",[-96.82673624999998, 48.33078494999999]],
    [ "Eaton Crest Substation",[-74.06594789202823, 40.29937521392046]],
    [ "Rohwer Substation",[-91.23603123523718, 33.707220781825164]],
    [ "MacArthur Blvd",[-74.15355166280037, 41.077473560066785]],
    [ "Station 22",[-77.65110186446137, 43.12647213898563]],
    [ "FEUS",[-108.09962611084096, 36.7044670299658]],
    [ "Skiffes Creek Substation",[-76.60790177846931, 37.216030437575704]],
    [ "Bowman Substation",[-80.69228021089336, 33.35143518044225]],
    [ "Moon Gulch substation",[-105.20234584009448, 39.863561069353544]],
    [ "Satilla Substation",[-81.88413977097456, 31.57975675711106]],
    [ "North Jesup Substation",[-81.899016, 31.6292066]],
    [ "Tank Road Substation",[-81.93460487562122, 31.634077512642033]],
    [ "730172678",[-82.41218626666911, 31.260807049858933]],
    [ "730176299",[-88.7437237476081, 32.07527521361581]],
    [ "Stonewall Substation",[-88.80100926451269, 32.14472098648643]],
    [ "Moss Substation",[-85.61062050000002, 36.589279700000006]],
    [ "Alba Substation",[-85.04670398949709, 44.974444507963646]],
    [ "730302643",[-97.40071490000001, 34.391245500000004]],
    [ "730302644",[-97.4065695, 34.3957828]],
    [ "City of High Point",[-80.00776596085669, 35.95214485430144]],
    [ "Parkdale Mills Substation",[-83.40212169010668, 34.94281743602535]],
    [ "Multitrade Rabun Gap Substation",[-83.37729267519647, 34.95376848657399]],
    [ "730331475",[-81.66513354763087, 35.09996333187281]],
    [ "Lower Willow Street Substation",[-81.63992004328689, 35.07379810228378]],
    [ "Gaffney City Delivery Substation 1A/1B",[-81.64063179887083, 35.07377005409486]],
    [ "730331483",[-81.555422, 35.1188947]],
    [ "730332233",[-80.48240514114134, 35.62543322851133]],
    [ "730332355",[-80.60582779999999, 35.91957975]],
    [ "Burkhalter Road Substation",[-85.22033035000001, 34.04627515]],
    [ "730441058",[-94.80099639038822, 32.20494339495927]],
    [ "Blue Ridge Energy",[-81.70705474924395, 36.21726481403375]],
    [ "730441819",[-94.77711517976888, 32.222665345440554]],
    [ "Sign Post Substation",[-75.46670015865436, 37.99720334627092]],
    [ "Blue Ridge Energy",[-81.5418182, 36.24529725]],
    [ "730906138",[-85.7493065316611, 39.504978949710015]],
    [ "730906142",[-85.51981509049486, 39.395730479489835]],
    [ "731032781",[-96.1943348946565, 42.47465842484905]],
    [ "731186596",[-96.35862649194333, 42.504148774721756]],
    [ "731194230",[-96.7600485, 32.2924622]],
    [ "731194236",[-96.75512395, 32.29574475]],
    [ "731194240",[-96.67521789412449, 32.318573030139774]],
    [ "Lancaster Mn Substation",[-80.78335892079575, 34.708541825607945]],
    [ "Fletcher Substation",[-84.87002444710093, 45.41609441698851]],
    [ "731216365",[-80.60669200458179, 34.915762663478475]],
    [ "731216366",[-80.60771305557576, 34.916078832011486]],
    [ "731216367",[-80.89383267615999, 34.59929465752038]],
    [ "Fishing Creek Dam Substation",[-80.89273417265288, 34.60018154988121]],
    [ "731216453",[-80.63358592591666, 34.92845690429614]],
    [ "731564925",[-81.69536615, 30.006930400000005]],
    [ "731589298",[-92.54016511126204, 39.7165298011982]],
    [ "731724757",[-84.96126720000001, 34.48514375]],
    [ "731724759",[-84.94495669187056, 34.475265532350576]],
    [ "Calhoun Substation #2",[-84.95825540378956, 34.498258203695954]],
    [ "731746722",[-114.93205519533069, 42.821108174855844]],
    [ "731746726",[-114.89805277495535, 42.84011615821644]],
    [ "Mannington Mills Substation",[-88.10647174999998, 32.68120385]],
    [ "Elk Point Substation",[-96.67366713299351, 42.68557596633029]],
    [ "Burton Substation",[-80.02824643362676, 35.93752242472351]],
    [ "731780861",[-80.29667239605058, 35.76810396698509]],
    [ "731780863",[-80.2783622569149, 35.75680292125547]],
    [ "731780867",[-80.10878086099135, 35.77250714735907]],
    [ "731780868",[-80.10925735975279, 35.76985257602012]],
    [ "731798116",[-82.03703339647133, 34.99812057984214]],
    [ "731806107",[-85.88904645326552, 41.69838889739677]],
    [ "731806982",[-87.32927989999999, 41.59302749999999]],
    [ "Yankton East Substation",[-97.3553708, 42.89145249999999]],
    [ "School Road Substation",[-83.63800044304762, 41.80698428196645]],
    [ "Mission Hill Substation",[-97.31775339218483, 42.923907224869524]],
    [ "Grizzly Substation",[-122.24575674596908, 37.87613664847051]],
    [ "Blue Ridge Energy",[-81.7584979, 36.263917600000006]],
    [ "Georgia Power",[-83.73026635, 34.379535249999996]],
    [ "Osceola Substation",[-90.00681267783791, 35.68383276456201]],
    [ "Entergy Arkansas",[-90.08251875, 35.5992338]],
    [ "City of Maryville Electric Department",[-84.0052599130181, 35.75100448997777]],
    [ "732196340",[-87.98477868443229, 35.99949527695196]],
    [ "Tennessee Valley Authority",[-87.9758418, 36.03064825]],
    [ "Tennessee Valley Authority",[-87.98297419702911, 36.03002483045816]],
    [ "732215580",[-75.63137122912735, 40.57588734493029]],
    [ "Hilltop Switching Station",[-78.90409025505704, 40.320741432024505]],
    [ "Hilltop Substation",[-78.90369580704932, 40.32131601571353]],
    [ "Bon Air Substation",[-78.87185345, 40.3410511]],
    [ "732224486",[-84.3065347855464, 39.288560429991655]],
    [ "732232095",[-83.00591872847697, 36.19408109478102]],
    [ "732232099",[-82.87758170489099, 36.15918186600226]],
    [ "Greeneville Light and Power System",[-82.74511745000001, 36.1967422]],
    [ "Greeneville Industrial Park Substation",[-82.72738482549843, 36.19505327327307]],
    [ "Tennessee Valley Authority",[-82.09032552484467, 36.5237179053635]],
    [ "New Hope Substation",[-75.32863928037463, 38.395837870538095]],
    [ "732794448",[-83.73067910000002, 32.742219850000005]],
    [ "Kumho Tire Substation",[-83.64616737505764, 32.744471888628695]],
    [ "732794455",[-83.6463333294571, 32.743872675030026]],
    [ "732806092",[-78.0489421, 35.15393890000001]],
    [ "FIXME Substation",[-92.58824739703674, 38.635970511811365]],
    [ "California Substation",[-92.58224874790645, 38.63056367596923]],
    [ "732807916",[-92.35946015, 38.5785077]],
    [ "Apache Flats Substation",[-92.31226630794389, 38.57580265742665]],
    [ "733028083",[-114.95979084853704, 35.87174323364111]],
    [ "733033482",[-114.98349395855027, 35.830712353682145]],
    [ "Circle Boulevard",[-123.24692110674712, 44.587470443518626]],
    [ "Oremet Substation",[-123.10124874999998, 44.609734200000005]],
    [ "Van Tyle Substation",[-84.77638250707543, 45.02347896663159]],
    [ "Gaylord Generating Substation",[-84.69075869999999, 44.6051503]],
    [ "Georgia Pacific Substation",[-84.69010205000001, 44.5974516]],
    [ "Miller Brewing Substation",[-84.0914933, 31.591638650000004]],
    [ "733150664",[-111.75688310950324, 40.3310908249175]],
    [ "733150665",[-111.75696506074267, 40.3321798422131]],
    [ "733150671",[-111.76090921949232, 40.33107779492333]],
    [ "Del Mar Substation",[-117.25548269431384, 32.98063555937573]],
    [ "733383253",[-90.03857662013013, 35.185487562263035]],
    [ "Exeter Substation",[-75.8221210045036, 41.32242838450759]],
    [ "Southern California Edison",[-117.87144035452769, 33.81964605407529]],
    [ "Anheuser Busch Substation",[-71.48639560000001, 42.82898414999999]],
    [ "Eagle Substation",[-71.48349892098226, 42.830990732268155]],
    [ "Consumers Energy",[-84.6296687, 42.71129245]],
    [ "733504424",[-122.10563025953884, 37.431045786461766]],
    [ "733525930",[-93.44071709999999, 44.67371205]],
    [ "Lilac Substation",[-117.08588410714394, 33.253326924845695]],
    [ "733781218",[-112.93887679205413, 41.05044952310253]],
    [ "Vint Hill Substation",[-77.59042706345907, 38.73156904279178]],
    [ "734004475",[-112.9189643811809, 43.648400326575576]],
    [ "734035467",[-113.1597762543802, 41.97664221231459]],
    [ "Pharmacy Substation",[-118.91951555233695, 34.192891449792086]],
    [ "Mesa-Mira Loma western transition station",[-117.7742759681892, 33.96999586284845]],
    [ "Mesa-Mira Loma eastern transition station",[-117.7143609121965, 33.98670187000711]],
    [ "Virginia Electric and Power Company",[-76.36767688248084, 36.80767195373439]],
    [ "Sacramento Municipal Utility District",[-121.50656440408129, 38.64892739914138]],
    [ "Georgia Transmission Corporation",[-84.64665213759551, 30.98651002479979]],
    [ "Air Brake",[-75.88808165, 43.98466305]],
    [ "Wedekind Substation",[-89.60831284766394, 37.35108307311003]],
    [ "734418353",[-84.79917143173205, 35.20612016742424]],
    [ "734418361",[-84.79339447287713, 35.304613267088676]],
    [ "White Bluff Substation",[-87.2293229282597, 36.118612066666365]],
    [ "734549774",[-97.39417969999998, 35.42919145]],
    [ "734549775",[-97.37288540441874, 35.414429301593884]],
    [ "Duke Energy",[-87.50785520550401, 38.654601866332094]],
    [ "734697835",[-117.06985494010033, 33.680993030405965]],
    [ "Sacramento Municipal Utility District",[-121.20789685000003, 38.6264297]],
    [ "Reed Substation",[-76.58807286212969, 40.86696267367394]],
    [ "Cherokee / Merck Substation",[-76.64384029481077, 40.96235017917555]],
    [ "734896952",[-76.75197233053527, 40.80590553396326]],
    [ "734907022",[-106.31982789453727, 31.7232651941037]],
    [ "Freeland Substation",[-75.90650736473542, 41.01899895685686]],
    [ "Bear Creek Substation",[-75.7896995831588, 41.20597209426907]],
    [ "Georgetown Substation",[-75.8686648166109, 41.23394402992365]],
    [ "735129348",[-97.3528190251579, 33.03163594034035]],
    [ "735129349",[-97.34809632498991, 33.03282574488148]],
    [ "735129351",[-97.3606186, 32.9996969]],
    [ "Shute Substation",[-122.9381226329407, 45.55799403615877]],
    [ "735191256",[-80.4940410246409, 34.502648270380504]],
    [ "735193180",[-97.79672581395698, 32.782126791294004]],
    [ "Oncor",[-97.7966052099869, 32.78119889802647]],
    [ "735193182",[-97.90927127093639, 32.80305961600307]],
    [ "735193184",[-97.87044715, 32.80650335]],
    [ "735204876",[-111.90473471199759, 40.7658624575901]],
    [ "Consolidated Nuclear Security, LLC",[-84.27721931212855, 35.978297219739915]],
    [ "Bayou George Substation",[-85.53525658529647, 30.247959674770982]],
    [ "736316125",[-91.89965653450504, 43.91313731768729]],
    [ "Vincennes Bayou St. Substation",[-87.52477431555253, 38.663178163298014]],
    [ "Nordic Substation",[-97.06566578637128, 47.90530741179439]],
    [ "Decatur County Industrial Substation",[-84.61886062887358, 30.98587152112599]],
    [ "Southern Power",[-84.62088817505717, 30.986812409769865]],
    [ "Three Notch EMC",[-84.6474588, 30.986504000000004]],
    [ "Georgia Power",[-84.22861945766043, 31.269591875949743]],
    [ "Executive Parkway Substation",[-97.07400867150133, 32.751756979139785]],
    [ "736534990",[-95.57480588633635, 42.72454368560709]],
    [ "Fishbach Substation",[-76.21642603612155, 40.69144722562656]],
    [ "736761851",[-89.54300721012854, 30.242062586273693]],
    [ "Stennis Substation",[-89.42766252483486, 30.37069759283375]],
    [ "Calgon Carbon Substation",[-89.56688493332659, 30.221645049685808]],
    [ "Sterling Power Plant",[-75.60045329260942, 43.080371726296065]],
    [ "Rome Station",[-75.45311591545688, 43.204913331967745]],
    [ "736777629",[-75.43884712499315, 43.20984789372998]],
    [ "Tallbort Substation",[-76.03803919903388, 38.740446097576786]],
    [ "736898063",[-79.32833689314666, 36.59072637456923]],
    [ "Danville Utilities",[-79.31197567281588, 36.579174200903275]],
    [ "736898071",[-79.36475256112963, 36.550363071515186]],
    [ "Sardis Substation",[-81.75833254786927, 32.98283214589699]],
    [ "Finlay Substation",[-83.33676445680959, 42.382613671675166]],
    [ "736989188",[-96.57617401771252, 33.517898287025936]],
    [ "737024086",[-121.95146455066133, 37.4300374533161]],
    [ "Tennessee Valley Authority",[-89.17469134999999, 36.55710165000001]],
    [ "737106902",[-80.48529934999998, 35.64139754999999]],
    [ "Jefferson Substation",[-94.3688344882321, 42.03296087785188]],
    [ "737121507",[-94.45638405000001, 42.04152085]],
    [ "Morris Sub",[-106.74469952805089, 34.78843489352875]],
    [ "Massey Breaker Station",[-75.82257416965088, 39.313095710564944]],
    [ "737201301",[-123.59420355035007, 46.586529548695715]],
    [ "Karma Substation",[-94.23849372328876, 42.00636994713858]],
    [ "Grand Junction Substation",[-94.23879803866365, 42.007492382968934]],
    [ "Russell Road Substation",[-83.95903500150543, 41.99092634950511]],
    [ "737372060",[-121.78718506902426, 37.62843513353873]],
    [ "Tate & Lyle Substation",[-94.308395015582, 42.50834137429916]],
    [ "737426003",[-94.29946875260318, 42.51554775382391]],
    [ "Harvest Avenue Substation",[-94.31279225556862, 42.50966165073923]],
    [ "Tireman Substation",[-83.21547885000001, 42.350874899999994]],
    [ "Elklick Substation",[-77.5071688045067, 38.859349328055515]],
    [ "Nevada Lincoln Hwy Industrial",[-93.51539384074927, 42.02366202058303]],
    [ "Catholic Health Initiatives",[-92.34059413598877, 34.75110597364409]],
    [ "Limerick Tap Substation",[-75.59742178691671, 40.22801948674362]],
    [ "738374989",[-81.57389879107949, 35.29698472480047]],
    [ "738383408",[-79.63554657669964, 35.14933100955904]],
    [ "Port Angeles Light",[-123.46815889678346, 48.12567156750759]],
    [ "F Street Substation",[-123.46983424999999, 48.11567965]],
    [ "Baldwin Substation",[-85.8453541488611, 43.89674851492571]],
    [ "Sacramento Municipal Utility District",[-121.44721631441433, 38.4630311436332]],
    [ "Sharon Hill Substation",[-75.27994711750257, 39.90743871590007]],
    [ "Mifflintown Substation",[-77.39667183521698, 40.56256813075733]],
    [ "Green Park Substation",[-77.30215013694223, 40.379887583513316]],
    [ "Walker Substation",[-77.33722399999999, 40.5675582]],
    [ "Iowa Falls Industrial Substation",[-93.26664141603847, 42.51110122699676]],
    [ "739473208",[-123.0387054255643, 46.82170559370177]],
    [ "739591363",[-80.39905408783814, 33.05626706845617]],
    [ "739644232",[-97.13388901962429, 33.20341292475175]],
    [ "Boston Substation",[-83.7833725653914, 30.80574672610533]],
    [ "Georgia Transmission Corporation",[-83.81440480422279, 30.87186393539292]],
    [ "Eason Substation",[-83.84938125, 30.81341495]],
    [ "Georgia Transmission Corporation",[-83.9136127665514, 30.857457816709214]],
    [ "Entergy Arkansas",[-92.39162785000002, 34.85135255]],
    [ "740407818",[-83.05899255, 34.76183525]],
    [ "740407820",[-83.05916257384125, 34.76038998816513]],
    [ "Walhalla Tie Substation",[-83.0541902737863, 34.7406564585216]],
    [ "740407825",[-82.97776558176247, 34.68553616500273]],
    [ "740407827",[-83.00461515, 34.679838499999995]],
    [ "740407829",[-83.08631121862582, 34.668891412561265]],
    [ "Westminster Substation",[-83.0856804144307, 34.66960918357396]],
    [ "740437209",[-75.80133922723327, 40.26880631163842]],
    [ "Central Allentown Substation",[-75.47817527048552, 40.59929035733159]],
    [ "740573848",[-87.17720039511958, 36.656051803004985]],
    [ "East Valdosta Substation",[-83.25433586893301, 30.846056995258017]],
    [ "Mason Dixon Substation",[-79.3574088450979, 39.723754029537886]],
    [ "740599314",[-122.20985336659699, 47.92889421862181]],
    [ "American Electric Power",[-86.19833149162157, 41.728076920572825]],
    [ "Coast Electric Power Association",[-89.69523431702986, 30.49638213375294]],
    [ "Auburn Substation",[-76.09915824431482, 40.6063559162065]],
    [ "Cresson Substation",[-76.1848467394247, 40.62499892973934]],
    [ "740860740",[-76.38899619687396, 40.55792238394627]],
    [ "Smith Street Substation",[-76.74086266998415, 39.97180545646903]],
    [ "Benton Substation",[-76.3787735566065, 41.21473832575471]],
    [ "740862780",[-75.89489660000001, 41.1442441]],
    [ "740932321",[-95.47884257002767, 42.25481373806352]],
    [ "741025551",[-86.1120616, 40.44158725]],
    [ "741028765",[-86.09915614124293, 40.45800537044249]],
    [ "741028771",[-86.1164098945235, 40.45705746917178]],
    [ "741047017",[-97.06179462660351, 32.99742733657063]],
    [ "741098527",[-82.55454470352976, 35.59765324618156]],
    [ "741110205",[-82.544946503768, 35.47166937055606]],
    [ "MT Cory Substation",[-83.82867133318854, 40.921740374358514]],
    [ "East MT Cory Substation",[-83.80368937017816, 40.93702382091894]],
    [ "Blair Pond Substation",[-71.15748745822188, 42.395520037553744]],
    [ "741340883",[-85.92778707222166, 40.036122527527674]],
    [ "741340887",[-85.35820145749241, 39.91435210145769]],
    [ "741340891",[-85.89256906142994, 39.92170157483667]],
    [ "AMLP Nestle Substation",[-85.73999273217446, 40.03622471533992]],
    [ "Sycolin Substation",[-77.58211788566855, 39.04448246541651]],
    [ "741343005",[-85.69835534999999, 40.08417945]],
    [ "Meadowbrook Substation",[-85.66957599876953, 40.06804020391357]],
    [ "Twenty Third Street Station",[-85.39502236702168, 40.1669053081351]],
    [ "Maroe Substation",[-84.03691856639728, 41.25422367472583]],
    [ "741351579",[-92.28248669999998, 34.799616549999996]],
    [ "Entergy Arkansas",[-92.3890266958311, 34.87976334952921]],
    [ "741422583",[-83.39110403286277, 39.59733795083429]],
    [ "Corn Belt Power Cooperative",[-95.26126009902002, 43.16056634822028]],
    [ "Western Area Power Administration",[-95.26261064739649, 43.160744408313995]],
    [ "741437484",[-95.46790169999998, 43.37831570000001]],
    [ "741437486",[-95.62336769999999, 43.38880234999999]],
    [ "Mcclure Substation",[-83.90224814515652, 41.32756340982655]],
    [ "741500803",[-83.46125302084697, 41.476205578916016]],
    [ "East New Market Substation",[-75.89207629688401, 38.610042418250806]],
    [ "Jacktown Substation",[-76.03814686811651, 38.55200982623491]],
    [ "Corn Belt Power Cooperative",[-94.73191012718956, 43.19066118990165]],
    [ "Dickinson County Substation",[-95.24047318689772, 43.43133869618495]],
    [ "Squash Bend Substation",[-91.60409121263753, 41.75643085047015]],
    [ "Kansas Substation",[-91.63771896236703, 41.734647298749]],
    [ "741749978",[-78.8600588691455, 35.67124554575648]],
    [ "741808116",[-86.11713378946422, 40.279463575209704]],
    [ "Greer Substation",[-81.46134715922835, 40.52137623150433]],
    [ "742234155",[-83.18821594916045, 42.14064182269059]],
    [ "742316765",[-77.95890900000002, 34.27614284999999]],
    [ "742333876",[-77.7544482, 34.333393799999996]],
    [ "Warm Springs Substation",[-79.78417303259548, 38.049435501814116]],
    [ "742341944",[-85.21914283148209, 32.83120318221025]],
    [ "742341955",[-85.3162284309833, 32.660299291754505]],
    [ "742341956",[-85.34008939085122, 32.644744881699644]],
    [ "742341958",[-85.31974105, 32.7156619]],
    [ "742345148",[-85.79317273994488, 32.768711613679486]],
    [ "Auburn",[-85.55852474999999, 32.66431634999999]],
    [ "Georgia Power",[-84.34964071597426, 33.75882610421304]],
    [ "742369967",[-78.20422772797443, 38.93055210273139]],
    [ "Stephenson Substation",[-78.08843191545479, 39.24491437791039]],
    [ "Virginia Electric and Power Company",[-76.39402872494216, 37.66729920731428]],
    [ "Mount Jackson Substation",[-78.6616606084214, 38.72435933945321]],
    [ "742424178",[-122.2074551119854, 47.934711523091906]],
    [ "742744000",[-83.92325098310276, 33.283811860722125]],
    [ "742744001",[-83.9236171114875, 33.28433803117211]],
    [ "Dixie Pipeline Substation",[-83.87480141999401, 33.27959667916958]],
    [ "Pemberton Substation",[-75.63932221700283, 38.35516623012366]],
    [ "742996001",[-87.77914784648571, 34.861921403083535]],
    [ "Remington Combustion Turbine Substation",[-77.76946313851101, 38.543508140772474]],
    [ "743169068",[-79.50858536680786, 36.28972270052462]],
    [ "Products (SE) Pipe Line Corporation",[-79.34747827731346, 36.380558791132735]],
    [ "743193724",[-88.11603546464018, 30.25671757597622]],
    [ "W&T Offshore, Inc.",[-88.13135379186951, 30.40272752506704]],
    [ "Bayly Substation",[-76.09345188265853, 38.55114124229198]],
    [ "BARC Electric Cooperative",[-79.82624508608647, 37.993702890974006]],
    [ "Hillsdale Substation",[-87.5558786, 38.079224950000004]],
    [ "743532124",[-87.4765326, 37.82072765]],
    [ "743532137",[-87.73427080024943, 37.90659707259272]],
    [ "743532141",[-87.50951195, 38.0609835]],
    [ "743532149",[-87.57043588277136, 37.97990626604618]],
    [ "743532159",[-87.59629032460988, 37.98595470699179]],
    [ "Devon Substation",[-87.58465811012819, 37.99094557027049]],
    [ "Pigeon Creek Trans. Substation",[-87.58380812223389, 37.98878254746014]],
    [ "Read St. Substation",[-87.56823838754356, 37.99050855210299]],
    [ "743543064",[-87.39012180658999, 39.73177662579398]],
    [ "743543067",[-87.36232774999999, 39.598959550000004]],
    [ "Ft. Branch Rural Distribution Substation",[-87.57897310000001, 38.2378949]],
    [ "743545119",[-78.55292735, 35.36085435]],
    [ "743545426",[-78.68124810553793, 35.32754188084601]],
    [ "Sylvan Substation",[-81.38834222930339, 28.792514324786357]],
    [ "744174490",[-77.08154084100627, 36.639830532079685]],
    [ "744174519",[-77.1664995825497, 36.61384295288302]],
    [ "Virginia Electric and Power Company",[-77.1669978, 36.614403249999995]],
    [ "Entergy Arkansas",[-92.39081175906406, 34.88565024755428]],
    [ "Entergy Arkansas",[-92.42125993441726, 34.98902638269878]],
    [ "744250070",[-107.61368912033589, 36.80502901773321]],
    [ "Gaco Substation",[-81.15867457667397, 29.00412706193062]],
    [ "Floratam Substation",[-81.09658400451674, 29.015192688231682]],
    [ "744602366",[-83.47357926684542, 34.298993996592955]],
    [ "Commerce Substation #4",[-83.44219777283274, 34.18392749580363]],
    [ "Buhler Substation",[-83.56817106825162, 34.09417879532672]],
    [ "North Jefferson Substation",[-83.57895506242636, 34.13010285596145]],
    [ "North Road Substation",[-72.09908748505482, 43.391482210807936]],
    [ "Cullowhee Ret",[-83.18477716584444, 35.31254544433776]],
    [ "745176481",[-87.74891769228826, 40.177021891132355]],
    [ "Lincoln Electric System",[-96.61582352625653, 40.70518436137437]],
    [ "745318478",[-87.95563270192137, 43.66057559601242]],
    [ "745318479",[-87.97287122129873, 43.73202663326276]],
    [ "745343679",[-89.00942770269066, 43.34018591631486]],
    [ "Erdman",[-87.76565732640123, 43.78931151078505]],
    [ "745445703",[-75.56904044672015, 37.94397734166412]],
    [ "Hallwood Substation",[-75.59617458643861, 37.875506088252436]],
    [ "New Church Subststion",[-75.53964271734579, 37.98862707277307]],
    [ "746286249",[-94.01593163329292, 31.51739500636844]],
    [ "Wylie Hydro Substation",[-81.00801134972873, 35.023934343692176]],
    [ "746628941",[-81.08870581933873, 35.75755012599986]],
    [ "Energy United",[-81.0022355, 35.824095]],
    [ "746628949",[-81.04281195000002, 35.8602239]],
    [ "746628952",[-80.8744436832361, 35.90313802099648]],
    [ "Energy United",[-80.94867979192716, 35.83265312285454]],
    [ "746628957",[-80.7854010195324, 36.255774944831884]],
    [ "746628959",[-80.78529205000001, 36.25968915]],
    [ "Morrison Creek Substation",[-124.13938093034875, 41.92522182876761]],
    [ "Randolph EMC",[-79.87699236659124, 35.426628532056824]],
    [ "PECO",[-75.04623913014854, 40.017387185099274]],
    [ "Calistoga Substation",[-122.57858175, 38.592074999999994]],
    [ "746898455",[-84.48835156233476, 39.08421054521568]],
    [ "Keehn Substation",[-115.16657825831051, 35.968602399217815]],
    [ "Station 60",[-77.37571353159618, 43.21152479758528]],
    [ "Perdue Substation",[-75.65579376049362, 37.741864314725035]],
    [ "Duke Energy",[-81.09778917382951, 28.130131895182792]],
    [ "747377917",[-90.07520270382243, 38.83943081691253]],
    [ "747467233",[-79.19983861484963, 34.815282826338276]],
    [ "747467236",[-79.19811605000001, 34.81455604999999]],
    [ "Fruitland Substation",[-75.62664252601849, 38.31447849723937]],
    [ "747946556",[-82.50283927805363, 35.971188830256146]],
    [ "Georgia Power",[-81.2546704423594, 32.336188917520616]],
    [ "748880843",[-95.21592894999998, 32.1858043]],
    [ "748882244",[-94.90058931780857, 31.832968765370524]],
    [ "748882246",[-94.98956404587875, 31.93887543948651]],
    [ "748893601",[-78.7184583977016, 40.466514659646435]],
    [ "748894626",[-113.74925108608461, 42.561115719261686]],
    [ "Twin Rock Substation",[-78.8620816608224, 40.49368620941382]],
    [ "Lucerne Substation",[-79.15979506581125, 40.556982934718874]],
    [ "749014136",[-97.31338676951957, 32.801209659396356]],
    [ "Cairo Substation",[-84.06125615874258, 40.84680312803785]],
    [ "Weston Substation",[-83.80627549846893, 41.34272826845891]],
    [ "749112429",[-79.95684456600439, 40.88548631701192]],
    [ "749249491",[-112.61677362376332, 33.231405590848]],
    [ "749249493",[-112.66707382507222, 33.20286639328216]],
    [ "Gold Beach",[-124.41644326627126, 42.409521358330245]],
    [ "Preacher Canyon Substation",[-111.18189885832896, 34.26196945117021]],
    [ "749585291",[-115.25497313177422, 36.275353172094654]],
    [ "749602299",[-94.85841253352604, 36.86953363934806]],
    [ "749605810",[-94.75595087495154, 36.59867453954779]],
    [ "749607941",[-95.04044613030669, 36.52756589244156]],
    [ "749607946",[-95.04312345000001, 36.46625595]],
    [ "749607949",[-94.79046435189382, 36.43208015112516]],
    [ "749632586",[-86.85923683602081, 40.38789303119164]],
    [ "749632587",[-86.85680968509187, 40.39162370200565]],
    [ "749632597",[-86.88101809404512, 40.37091047526155]],
    [ "749653870",[-86.84939012529414, 40.41209100576198]],
    [ "749653871",[-86.79497745, 40.3794338]],
    [ "749653877",[-86.85877916684971, 40.40087948581692]],
    [ "749653878",[-86.85856195000001, 40.39711820000001]],
    [ "749663654",[-80.65860990274727, 38.331222713978974]],
    [ "749864741",[-111.35495967513062, 33.26374885732747]],
    [ "749954859",[-107.94775724550666, 36.728504778005544]],
    [ "749954864",[-107.94168098395987, 36.73746547510359]],
    [ "749955056",[-107.75055145732543, 36.49778943173644]],
    [ "749955072",[-107.79327034999999, 36.72746839999999]],
    [ "749955074",[-107.80062126227517, 36.7391814366395]],
    [ "Waynesboro Substation",[-82.01990685, 33.0894337]],
    [ "749979978",[-97.29471666394146, 33.01285718126376]],
    [ "Mazatal Power Substation",[-111.3344701163185, 34.06046741929207]],
    [ "Bettis Substation",[-79.89476141509247, 40.36311928122746]],
    [ "750749957",[-81.6700243339241, 36.20321618116566]],
    [ "750928934",[-121.77792529431773, 36.80683192839965]],
    [ "750960592",[-112.05324066553358, 46.60534682781148]],
    [ "Central City West Substation",[-78.82159533397278, 40.10885613374525]],
    [ "Statler Hill Substation",[-78.86563021643022, 40.12463003285011]],
    [ "Totten Substation",[-83.67011703301651, 41.036130495110115]],
    [ "751360172",[-82.13015032981954, 38.912453971059286]],
    [ "751416540",[-81.66851418030498, 36.13662365579968]],
    [ "Jersey Central Power and Light",[-74.20479844732778, 39.95428266588827]],
    [ "751448978",[-109.64047418199559, 35.737880354417015]],
    [ "751449002",[-112.7552727221499, 35.286998236006]],
    [ "Entergy Louisiana",[-90.6113312, 29.3990191]],
    [ "Royal Oak Substation",[-76.16803128791207, 38.73950115296653]],
    [ "752155446",[-111.55740029348104, 32.86910343758467]],
    [ "753063423",[-116.33739644633974, 43.66334014400269]],
    [ "Corwith Substation",[-84.67899720000001, 45.15833499999999]],
    [ "Newport Substation",[-72.17940627701729, 44.93902075546197]],
    [ "Newport Utilities",[-83.16977292907362, 36.07951891508618]],
    [ "753707454",[-95.46193424579619, 35.23504132259057]],
    [ "753806244",[-89.06015012607872, 41.66705404687934]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.24062309192463, 37.58244171344852]],
    [ "753917336",[-78.52112777819883, 35.67137304298665]],
    [ "Calamus Substation",[-90.75086385952694, 41.82569321011079]],
    [ "754329007",[-90.12159558459238, 41.21514107430793]],
    [ "754329008",[-90.12151102536814, 41.214068741277934]],
    [ "Big Sky Wind LLC Substation",[-89.45639177416976, 41.598905113940944]],
    [ "754366147",[-81.92260275843232, 28.049192356991274]],
    [ "754377963",[-83.57689575000002, 41.70917545]],
    [ "754430028",[-82.10603244059728, 27.928362374631607]],
    [ "754430038",[-81.98335814157502, 27.892130717197784]],
    [ "754435498",[-81.86383209999998, 28.045102850000003]],
    [ "754440032",[-81.18958738025303, 33.52509310063096]],
    [ "754620177",[-96.43796688016978, 33.19336688734118]],
    [ "754620179",[-96.40853726875952, 33.16042038762262]],
    [ "754621637",[-96.35667365734834, 33.029229773846744]],
    [ "Forbes Substation",[-79.99359431786887, 40.43831638164855]],
    [ "754844014",[-85.6153672869051, 30.145031231039397]],
    [ "Kentucky Utilities Company",[-88.8452664, 37.08741365]],
    [ "Kentucky Utilities Company",[-88.82386406643774, 37.08785466670693]],
    [ "Tennessee Valley Authority",[-88.77934980794154, 37.09683043042282]],
    [ "Wickliffe Substation",[-89.08279539129082, 36.973084225874]],
    [ "Wickliffe Substation",[-89.06600178992215, 36.952591687335854]],
    [ "755027897",[-89.0792087, 36.9465087]],
    [ "Georgia Power",[-84.3315398538378, 33.83482375886712]],
    [ "Georgia Power",[-84.28012489091111, 33.87874036851522]],
    [ "Georgia Power",[-84.30353866124491, 33.85846012498417]],
    [ "Georgia Power",[-84.30286869792585, 33.85899057929365]],
    [ "Georgia Power",[-84.27072535249935, 33.886218031776004]],
    [ "Blewett Hydro Substation",[-79.87782868888901, 34.983846061641835]],
    [ "Meyersdale North Substation",[-79.02070153520852, 39.82855508194612]],
    [ "Billings",[-108.53649587784335, 45.766572133783335]],
    [ "755746296",[-66.46870922687562, 18.43846383883276]],
    [ "755753258",[-66.56986102636928, 18.42977255116986]],
    [ "755753262",[-66.56795250536445, 18.430254972378965]],
    [ "755756256",[-66.55579545, 18.424963849999997]],
    [ "755825120",[-77.49077485892957, 37.51388353389669]],
    [ "Davis Creek Substation",[-120.36688870442202, 41.73314063045371]],
    [ "756287472",[-81.64228729999999, 34.76367845000001]],
    [ "Subestación Patillas",[-66.01181870189184, 18.000771017434637]],
    [ "Cedarville Junction Substation",[-120.41385624982495, 41.56422126839955]],
    [ "Cedarville Substation",[-120.18201885299248, 41.53153822591159]],
    [ "756803922",[-86.7530124112516, 34.68966384381477]],
    [ "Georgia Power",[-83.77795777411936, 31.133849026279613]],
    [ "Depot Substation",[-106.78706511979271, 34.82953708407838]],
    [ "142nd St. Substation",[-93.81643944826298, 41.640554450051994]],
    [ "Microsoft Project Alluvion Data Center",[-93.70573320988017, 41.51488447160307]],
    [ "Army Post Substation",[-93.7142918729756, 41.52224110645744]],
    [ "757486683",[-112.93879735797744, 43.56859657474295]],
    [ "757486685",[-112.96161959999999, 43.58900895]],
    [ "Quarryville Substation",[-76.161139587812, 39.88312047971555]],
    [ "757668782",[-80.8646966551013, 35.220049748113205]],
    [ "Colorado Substation",[-83.24654709530559, 42.71162085212198]],
    [ "Orion Substation",[-83.25521089499068, 42.71466684943967]],
    [ "Rosenbaum Substation",[-90.84668687473527, 35.13501205852057]],
    [ "Webster Substation",[-71.67370850996282, 43.45574289386307]],
    [ "Deer Lake Substation",[-84.99750450000002, 45.14412155]],
    [ "East Jordan Substation",[-85.11969955, 45.13931065]],
    [ "Graves Crossing",[-85.06754102501984, 45.039063143045155]],
    [ "Subestación Piel Canela",[-66.36168592881356, 18.069932428708917]],
    [ "Lake City Sub J",[-94.26748977454697, 39.104374857088956]],
    [ "Stanley Substation",[-83.69904234527122, 43.10427888296007]],
    [ "Tuscola Bay Wind LLC",[-83.78392075136557, 43.48306889548354]],
    [ "758136867",[-89.80129651218405, 38.48467789508561]],
    [ "Georgia Power",[-83.8166089033142, 32.44181152585216]],
    [ "758172080",[-78.0291948829366, 35.68897247422417]],
    [ "Houston County Landfill Substation",[-83.55950268589092, 32.39514252476568]],
    [ "Mattamaskeet Substation",[-76.32235134702985, 35.52089115786559]],
    [ "Dominion Energy",[-76.24271782817273, 35.907128457344804]],
    [ "758307825",[-83.05708594311479, 31.027036795122672]],
    [ "758332132",[-83.47568996699866, 41.67436915355455]],
    [ "TAP139489 Substation",[-89.80662872281549, 38.468834080383914]],
    [ "Ashley",[-89.19088166438075, 38.332809469732055]],
    [ "Innovativs Solar Substation",[-79.95011958033494, 34.82664038067614]],
    [ "Rita Sub",[-106.6048996653107, 35.09568591756733]],
    [ "Northwestern Energy",[-112.0046257074507, 46.623577443445484]],
    [ "Jackman Substation",[-83.56909908906867, 41.75100971982605]],
    [ "Elbon Substation",[-101.69795395, 44.2836228]],
    [ "759008881",[-99.54610862494599, 31.258592892108158]],
    [ "759009540",[-81.18485381308751, 33.05049721645334]],
    [ "759052388",[-96.31277530645843, 43.777049759778016]],
    [ "759189683",[-78.58675044773729, 39.93148844229791]],
    [ "Manns Harbour Substation",[-75.76371290596288, 35.885745121682355]],
    [ "759304862",[-94.4532593401597, 31.866235792657996]],
    [ "759309011",[-94.34385011085664, 31.90409095463722]],
    [ "Substation 4",[-76.08946618185591, 38.77210801550418]],
    [ "Bloomfield Substation",[-76.11473150239922, 38.77919067516677]],
    [ "Singer Substation",[-73.1854818694506, 41.16763044177966]],
    [ "Puerto Rico Electric Power Authority",[-66.47322760987956, 18.06839203190721]],
    [ "759421309",[-66.45995334999999, 18.07159985]],
    [ "Puerto Rico Electric Power Authority",[-67.08729803308316, 18.17599515038621]],
    [ "Middle Tennessee Electric Membership Corporation",[-86.89796967228706, 35.79513019004012]],
    [ "MidAmerican Energy",[-90.48224077248864, 41.572198544629344]],
    [ "Kutztown University Substation",[-75.77677678404812, 40.50756269897126]],
    [ "Stone Church Substation",[-85.07803021603694, 34.903642717262535]],
    [ "Los Chavez Sub",[-106.756816, 34.71372935]],
    [ "Miner Substation",[-89.523050719575, 36.905482715636666]],
    [ "759776120",[-89.1743338545246, 37.09173143911416]],
    [ "759877583",[-88.9954497375062, 37.796895999308575]],
    [ "Starkville Electric Department",[-88.8003712, 33.467280099999996]],
    [ "759927931",[-106.76794870000002, 34.611155200000006]],
    [ "759933771",[-95.56318408336263, 32.23594125059476]],
    [ "Electric Power Board of Chattanooga",[-85.30411912737677, 35.043293505732116]],
    [ "759995541",[-96.18138230000001, 45.0155956]],
    [ "760024861",[-93.90707860000002, 45.24210305]],
    [ "St. James Substation",[-87.57281282398175, 38.17095561405123]],
    [ "Alpha Interconnection Station",[-96.40377976371926, 44.35616393162905]],
    [ "760092016",[-93.39025269999999, 32.58409890000001]],
    [ "Georgia Power",[-83.70802289190836, 32.67604431392452]],
    [ "Lexington Electric System",[-88.39899993523801, 35.642379701328366]],
    [ "Isleta Sub",[-106.70830171020383, 34.90394427562148]],
    [ "760915836",[-84.59055101672075, 39.03092939959202]],
    [ "Semitropic Substation",[-119.43753732372873, 35.600815729839745]],
    [ "761054051",[-119.91918559999999, 36.2322862]],
    [ "761054052",[-119.91689833319143, 36.23352533645546]],
    [ "761054053",[-119.90471275, 36.24213914999999]],
    [ "761066023",[-85.09520401637688, 37.06078845221031]],
    [ "Lancaster Switching Station",[-84.5663424872477, 37.62048964692455]],
    [ "761086549",[-84.64854740920259, 37.73828807729639]],
    [ "761086552",[-84.66471250244659, 37.753005004889694]],
    [ "Tennessee Gas Pipeline Company, L.L.C.",[-84.60654103641042, 37.67192304884392]],
    [ "East Kentucky Power Cooperative, Inc.",[-84.56427486771466, 37.61811858310234]],
    [ "Kentucky Utilities Company",[-84.57498254266807, 37.60397668083274]],
    [ "Indian Hospital Sub",[-106.61605945115544, 35.0893397076024]],
    [ "Wild Turkey Substation",[-91.50571329738908, 43.63825486960298]],
    [ "761270282",[-92.6093257, 40.146245]],
    [ "Missoula Electric Cooperative",[-114.0924880358923, 46.894314104418484]],
    [ "Sterling Creek Substation",[-81.30560471653457, 31.91682891924874]],
    [ "Jewell Substation",[-82.76759504263664, 33.30366122460346]],
    [ "Milliken Substation",[-82.50294549058867, 33.529302927952266]],
    [ "761328503",[-82.61517519592496, 33.50514097383278]],
    [ "Sinclair Dam Hydro Substation",[-83.20408046648227, 33.13988910995041]],
    [ "Rappahannock Electric Cooperative",[-77.80149671800113, 38.09108826296652]],
    [ "761439265",[-119.07826526495327, 46.22346946794742]],
    [ "761439271",[-116.19934118336207, 48.721630431604154]],
    [ "761600167",[-84.95167722897367, 34.89586202593932]],
    [ "Brookville Substation",[-79.07220221862957, 41.14069877137239]],
    [ "761849199",[-75.7568248367546, 40.51456608790881]],
    [ "Cherry Todd Electric Cooperative",[-100.65352465000001, 43.32458014999999]],
    [ "761860776",[-82.13930763029853, 28.167566968141948]],
    [ "761867271",[-84.76719151560873, 30.573865332436874]],
    [ "Jasper Substation",[-82.94175643376931, 30.509267775951702]],
    [ "761871879",[-83.17866271542813, 30.51747317619135]],
    [ "Ontario Substation",[-83.45610489570667, 45.05807191341873]],
    [ "761873147",[-90.52931946054831, 41.64446505027057]],
    [ "MidAmerican Energy",[-90.56609320475025, 41.61241300280367]],
    [ "Painesville Substation 2",[-81.22126853338004, 41.74229650989501]],
    [ "Leaside Substation",[-82.69594637068889, 40.765036755648396]],
    [ "Plains Substation",[-84.39093138688736, 32.034989275283486]],
    [ "762094502",[-92.3444449914979, 30.494322014443544]],
    [ "Cameron International Corporation",[-92.26065496086322, 30.71704103094741]],
    [ "762095917",[-92.10287379383057, 30.546179055335575]],
    [ "CLECO",[-92.12971670551755, 30.571579093409483]],
    [ "762095923",[-92.08895552406015, 30.538830839575255]],
    [ "762180663",[-77.42595698091789, 37.52166804809553]],
    [ "Cambridge Substation",[-76.0754705829192, 38.55994348801136]],
    [ "762307686",[-111.03771572226029, 31.760281058731252]],
    [ "Johnson Controls Substation",[-83.78584658309565, 41.606363444418335]],
    [ "762478694",[-86.88906511601857, 32.59141362668091]],
    [ "Norwalk Harbor Substation",[-73.4114290000226, 41.074264234984334]],
    [ "762744764",[-85.70558894300358, 41.67763569824253]],
    [ "762785225",[-70.55955278881929, 44.33017850956467]],
    [ "Union Avenue Substation",[-74.04390870000002, 41.4783995]],
    [ "Central Hudson Gas & Electric",[-74.0445960450473, 41.47870416809601]],
    [ "Rock Tavern Substation (345kV)",[-74.19690470121718, 41.46764829309692]],
    [ "762954895",[-73.99500788661703, 41.96439330159571]],
    [ "763129562",[-122.20625025000001, 37.51318195]],
    [ "763130469",[-122.20594899999999, 37.514266250000006]],
    [ "Bass Creek Substation",[-86.05701580708379, 42.97104499926151]],
    [ "Ebersole Substation",[-83.58113961212752, 41.10386761244175]],
    [ "764006306",[-111.77179600867704, 33.25659477501749]],
    [ "Carville Substation",[-76.00861089323307, 39.044559531473304]],
    [ "764036829",[-77.01771470000001, 40.21743855]],
    [ "764038499",[-77.1773994232127, 40.201998546368024]],
    [ "764041040",[-87.66252795634638, 37.80889047606285]],
    [ "Kossuth Substation",[-94.15656708372157, 43.170103775120666]],
    [ "Corn Belt Power Cooperative",[-94.18950590476729, 42.67502437467611]],
    [ "Parallel Substation",[-95.14567100662174, 39.56618989038178]],
    [ "Amelia Earhart Substation",[-95.11840180499284, 39.55674164813337]],
    [ "Lake Road Substation",[-94.87794254286756, 39.725965233051234]],
    [ "North Zanesville",[-82.03567979682862, 39.99499530522817]],
    [ "764215937",[-111.63551644217145, 40.196086547075055]],
    [ "764221402",[-87.55886291488127, 38.11009917538808]],
    [ "Ripon Ind Park",[-88.82055256513125, 43.85650922501102]],
    [ "764304669",[-104.56865023988043, 38.21190324609071]],
    [ "764450524",[-83.42206534616929, 41.23968914960306]],
    [ "Silicon Substation",[-84.16440890381516, 43.435209331510144]],
    [ "NEEVIN",[-88.50437915961093, 44.19435079103867]],
    [ "764646775",[-81.91839661961652, 34.906701295506984]],
    [ "764676271",[-79.38154256022078, 33.35518752561045]],
    [ "International Paper Substation",[-79.30344095, 33.36898835]],
    [ "764678382",[-83.54435201884922, 38.20175529615705]],
    [ "765137592",[-87.46265275000002, 36.8374492]],
    [ "765137593",[-87.46464850000001, 36.838523650000006]],
    [ "765140354",[-87.38629964035299, 36.80179451664143]],
    [ "Cullman Substation",[-86.86067593802393, 34.20759097320494]],
    [ "765158847",[-86.83031625000001, 34.13629335000001]],
    [ "Arizona Public Service",[-112.56570075, 33.390955149999996]],
    [ "Clayton Substation",[-75.6310715780644, 39.286466099234026]],
    [ "765184800",[-82.22076440000001, 28.507784599999997]],
    [ "Georgia Power",[-85.03938655, 33.003784149999994]],
    [ "765199999",[-85.86518636675883, 38.97216511658492]],
    [ "765203063",[-85.93238645, 38.713623199999994]],
    [ "Diamond Lake Substation",[-85.56754721513923, 41.44617838202346]],
    [ "Bronson Substation",[-85.1943505082479, 41.88033262496591]],
    [ "Newton Substation",[-84.95813205799911, 41.9829071723303]],
    [ "765221200",[-78.94239468615433, 34.91978455136739]],
    [ "765228498",[-81.61556232094098, 35.28553031509023]],
    [ "765228501",[-81.58364205000001, 35.290626950000004]],
    [ "Mooresboro Ret Substation",[-81.69825465869056, 35.29548033152002]],
    [ "765229248",[-81.83130326106584, 35.25730704959581]],
    [ "765254420",[-70.72104734999999, 44.2474044]],
    [ "Bolton Substation",[-83.11836418906621, 39.8991282946565]],
    [ "Grassland Switchyard",[-119.82947869292867, 45.69465722957217]],
    [ "PPL",[-75.5083543030406, 41.40078843357682]],
    [ "North Bever Dam",[-88.82561721034396, 43.487390310094]],
    [ "Schoolcraft Substation",[-85.63230053871203, 42.09200977482913]],
    [ "765554312",[-93.4543488657656, 45.044467354080574]],
    [ "Pulaski Substation",[-75.18333297126709, 40.03216043135971]],
    [ "765766721",[-85.4164515, 41.6698449]],
    [ "765766745",[-85.41172651090034, 41.6363102647485]],
    [ "Guyton Substation",[-81.42433472897771, 32.316764454576195]],
    [ "Arlington Substation",[-83.63380753713697, 40.86271050929449]],
    [ "Arlington Substation",[-83.63326998526907, 40.877578584004155]],
    [ "Wetumpka Substation",[-86.2038438, 32.5351437]],
    [ "766121306",[-67.8519448299652, 46.14168465363833]],
    [ "766121308",[-67.88439174999999, 46.529986400000006]],
    [ "Sprague Substation",[-118.14004223693235, 47.33235946703742]],
    [ "Pemigewassett Substation",[-71.70957776230547, 43.596826568065076]],
    [ "766516615",[-82.54670170942593, 39.08657562727742]],
    [ "766516620",[-82.5434139984709, 39.09355754331619]],
    [ "Leeds Substation",[-70.16726957350173, 44.336088524182685]],
    [ "Hickory Run Energy Substation",[-80.42947179849425, 40.99352020888318]],
    [ "McClelland Substation",[-80.43821375249196, 40.99248152815273]],
    [ "766575326",[-86.3931226315422, 35.80732474375138]],
    [ "Reed City Substation",[-85.50200940995069, 43.87488063107956]],
    [ "766585307",[-86.96874191067478, 34.60604566831537]],
    [ "766590837",[-117.21632795088242, 34.28341161650056]],
    [ "Taxville Substation",[-76.79891587408564, 39.96019823866979]],
    [ "West Gate Substation",[-76.75473125483623, 39.98153352648416]],
    [ "York Incinerator Substation",[-76.71748745649072, 40.00125515298213]],
    [ "Whiteford Substation",[-76.67947358600692, 39.98655739895055]],
    [ "Cat Tractor Substation",[-76.6754707340785, 39.985856931414965]],
    [ "Lovell Substation",[-70.88854978890048, 44.12190365997678]],
    [ "Ludden Lane Substation",[-70.33683412800079, 44.4965174591522]],
    [ "766775434",[-112.00071576720826, 41.29062679943762]],
    [ "Rumford Falls Substation",[-70.54137189909136, 44.54775491690121]],
    [ "766786276",[-66.111925401142, 18.434117856640977]],
    [ "Pearl River Substation",[-74.02454348500574, 41.07022541419965]],
    [ "Hathaway Substation",[-77.75325715480881, 36.04258737323209]],
    [ "766808080",[-79.1720859749365, 35.55018602898951]],
    [ "McLaughlin Substation",[-100.83057569927837, 45.80353565964268]],
    [ "Oncor",[-98.06591379762725, 32.79914792159091]],
    [ "767313700",[-66.58978435, 18.4326609]],
    [ "Eutaw Substation",[-87.86882221897388, 32.89467253936403]],
    [ "767400115",[-87.8716648, 33.0394377]],
    [ "767400118",[-88.00586544999999, 33.047136699999996]],
    [ "Aliceville Substation",[-88.1247486810898, 33.106778152649106]],
    [ "Halsey Substation",[-74.41920967722272, 40.85811964395328]],
    [ "Bustin Substation",[-74.53334585292937, 40.87904476494022]],
    [ "Foundry Street Substation",[-74.13291205757007, 40.72925588568006]],
    [ "767625476",[-110.91294529999999, 32.1740576]],
    [ "767639517",[-117.546124, 34.0973975]],
    [ "TVA",[-85.30111529999999, 34.97857109999999]],
    [ "767683047",[-85.7141604093895, 34.951516256279355]],
    [ "United States Gypsum Company",[-85.7073994, 34.9642755]],
    [ "767683056",[-85.66166905053902, 35.05188428987657]],
    [ "767683059",[-85.70847746685429, 35.002525766378945]],
    [ "767686372",[-85.51967373364171, 35.20871638421722]],
    [ "Watt Substation",[-80.1124533660884, 26.882150125047154]],
    [ "Rayonier Substation",[-83.20744345, 32.220290750000004]],
    [ "767717493",[-83.37136265, 32.6270108]],
    [ "767717495",[-83.43587551423843, 32.60385427356639]],
    [ "767718253",[-82.25663660453026, 34.68570364212997]],
    [ "International Metal Reclamation Company Substation",[-80.2801786341497, 40.839823335501485]],
    [ "Ellwood City Substation",[-80.27825240652265, 40.86309296920572]],
    [ "767770229",[-84.60586176518592, 38.922741317780606]],
    [ "767989077",[-112.510184016445, 46.00635545259296]],
    [ "767989078",[-112.50079262496378, 46.00831974152412]],
    [ "767989456",[-112.79000950000001, 46.03861770000001]],
    [ "Lake Shore Substation",[-86.22062392622573, 42.97148604714839]],
    [ "Whitney Substation",[-86.29976876791373, 33.87582515269395]],
    [ "768284719",[-86.10259932491049, 40.49158099272028]],
    [ "North Lake Geneva",[-88.44472795551171, 42.61428543164046]],
    [ "768586034",[-79.69015383286497, 36.09898810091733]],
    [ "City of High Point",[-79.98855801642432, 35.9634410443]],
    [ "768624175",[-83.31107389560357, 42.1600406405681]],
    [ "768656125",[-78.49928711781826, 36.02357649038626]],
    [ "768656129",[-78.50555696606247, 35.994817604415395]],
    [ "Roxbury Notch Road Substation",[-70.59641571100325, 44.62776217667857]],
    [ "Collinsville Substation",[-85.85828412071481, 34.26629637187694]],
    [ "Painter Substation",[-86.07991148735277, 34.31913632737703]],
    [ "Marshall-DeKalb Electric Cooperative",[-85.99942165073735, 34.32254568370737]],
    [ "Airport Substation",[-106.93842085, 32.26885425]],
    [ "Glendale Substation",[-83.29485743805745, 42.38015495112452]],
    [ "769431772",[-77.43795708576307, 37.4442744322432]],
    [ "CPC Richmond Substation",[-77.42286483491868, 37.511840754562435]],
    [ "769439671",[-77.38546046599686, 37.38174929370599]],
    [ "769446296",[-77.27295714977134, 37.29789731671833]],
    [ "Cogentrix Substation",[-77.27070540000001, 37.292333]],
    [ "Polyester Substation",[-77.28342509999999, 37.2981155]],
    [ "769472522",[-86.86517693614705, 41.71400225342573]],
    [ "American Electric Power",[-86.85347412678935, 41.712554293634106]],
    [ "769482578",[-80.87501898017334, 34.541453359671685]],
    [ "769482580",[-80.85095418986322, 34.71014612724207]],
    [ "769482585",[-80.90188835630633, 34.6976027200627]],
    [ "769482587",[-80.89888829999998, 34.6864622]],
    [ "769482924",[-80.68394815191111, 34.1789498211713]],
    [ "769512782",[-86.90576767538889, 41.682270495276626]],
    [ "Southwestern Electric Power Company",[-94.11280139002075, 36.18167752449348]],
    [ "Ohio Substation",[-86.90308999670918, 41.681784500616075]],
    [ "Puckett Substation",[-89.77372808610161, 32.078903967072556]],
    [ "769793272",[-81.52633491815114, 35.13228884594145]],
    [ "769793274",[-81.49872545000001, 35.12537315000001]],
    [ "769793289",[-81.48395857411919, 35.15846509181313]],
    [ "769793961",[-81.41152115, 35.1708139]],
    [ "Georgia-Pacific Port Hudson LLC",[-91.28001384999999, 30.652733800000004]],
    [ "769797857",[-88.20390134999998, 34.95268384999999]],
    [ "Sunny Hills Substation",[-85.57300667777533, 30.539751207909788]],
    [ "Public Service Company of Oklahoma",[-95.99016057740181, 36.14539201213144]],
    [ "770046126",[-96.0297840379677, 36.13318381192768]],
    [ "770075187",[-81.6303959580993, 35.25094396269135]],
    [ "Ebro Substation",[-85.8704311650058, 30.441188199237313]],
    [ "770080048",[-85.07233588187142, 41.525772338867924]],
    [ "770456448",[-85.08349145000001, 41.067013]],
    [ "770456449",[-85.08239423590668, 41.06598232518124]],
    [ "770517964",[-98.60673526804065, 43.97038792263253]],
    [ "770517965",[-98.60729690963908, 43.969406892725594]],
    [ "Tar Heel Substation",[-78.79590132506432, 34.73087782639455]],
    [ "Yahnundasis Station",[-75.33417580135527, 43.08895684056308]],
    [ "Walesville Station",[-75.34528696416994, 43.12336768344537]],
    [ "Chadwicks Station",[-75.268953062004, 43.03824897802698]],
    [ "770847280",[-87.5356250285031, 38.02250001767649]],
    [ "770877807",[-85.90880497507322, 38.94744575915489]],
    [ "Terre Haute Spriuce Substation",[-87.4066918, 39.473981849999994]],
    [ "Northeast Johnson City Substation",[-82.32975433730901, 36.34054168590665]],
    [ "770910294",[-81.87882067798849, 27.898486392886664]],
    [ "770910295",[-81.88159303366301, 27.900134783048962]],
    [ "770910300",[-81.8266815758226, 27.8716546572421]],
    [ "770910304",[-81.82674422488697, 27.869478042055185]],
    [ "770916255",[-80.24663555000001, 34.48437505]],
    [ "770916256",[-80.24310613235822, 34.483424786732556]],
    [ "770922987",[-81.38286107496221, 27.767550907406722]],
    [ "William Blount Substation",[-84.05005573756262, 35.75412452373654]],
    [ "770925312",[-84.0021770610812, 35.762129855954164]],
    [ "770929085",[-79.3317536791942, 36.094890521406995]],
    [ "770929087",[-79.31816344163136, 36.06937952502481]],
    [ "Southern Natural Gas",[-87.71509030000001, 32.5003102]],
    [ "770966930",[-87.71086316774314, 32.50156642655946]],
    [ "Faunsdale Substation",[-87.59425694999999, 32.4756671]],
    [ "770977150",[-94.06907466661025, 45.50883511672319]],
    [ "Cedarbrook Substation",[-75.1834466480752, 40.07676293019555]],
    [ "Laurens Substation",[-94.83555604274572, 42.83560570273302]],
    [ "771088921",[-95.49689688490886, 43.053656567583836]],
    [ "771088924",[-95.57445712516443, 43.1565969611949]],
    [ "771088926",[-95.61324925, 42.778624449999995]],
    [ "771088930",[-95.58500895, 43.0477409]],
    [ "771088931",[-95.6326121, 43.08659345]],
    [ "Highland Substation",[-95.6875681596506, 43.05683515073981]],
    [ "Graceville Substation",[-85.53628105392097, 30.970587255400932]],
    [ "Westville Substation",[-85.86780251626283, 30.779190805156613]],
    [ "Pine Avenue Substation",[-86.11137865199915, 42.79531482998738]],
    [ "771401972",[-81.44922763967443, 27.88742497507494]],
    [ "771401973",[-81.42219921452221, 27.86441587122049]],
    [ "771501428",[-96.13469253387238, 31.93818248290599]],
    [ "Mesa Rim Substation",[-117.17319491098249, 32.904912380828655]],
    [ "771767185",[-108.3659059, 36.763733550000005]],
    [ "771767189",[-108.26507263062788, 36.72047186598918]],
    [ "771767215",[-107.9856786, 36.59946804999999]],
    [ "771767217",[-107.9859052406178, 36.609430676043715]],
    [ "Hawthorne Station",[-86.49678835366957, 42.07433205548631]],
    [ "771808614",[-75.96301376572262, 41.20777544843733]],
    [ "BOWEN STREET",[-88.5273589070032, 44.039973788915255]],
    [ "Plano Substation",[-88.47595315402793, 41.68593669605037]],
    [ "771994278",[-85.2672362749463, 41.456028104727416]],
    [ "East Terre Haute Substation",[-87.3378780616535, 39.43312768019214]],
    [ "772016758",[-87.73864656520317, 40.769985236341114]],
    [ "772017694",[-87.58385893561359, 40.74622784549676]],
    [ "772045384",[-81.05725715202374, 40.32636424149442]],
    [ "Penns Neck Substation",[-74.6339650429833, 40.33590128250212]],
    [ "Princeton Solar Substation",[-74.63396219846663, 40.33671232098585]],
    [ "772217420",[-74.6271996047246, 40.332992898945754]],
    [ "772275444",[-111.80610657786511, 41.67029033059554]],
    [ "Saco Valley Substation",[-71.08772816644746, 44.00778465794933]],
    [ "Oakville Substation",[-90.04310695201178, 29.79499368682227]],
    [ "772590747",[-114.202124984713, 46.962751221630015]],
    [ "772708316",[-92.26224720467607, 37.96242939857715]],
    [ "772753456",[-83.62729571855506, 41.68738731892421]],
    [ "Crystal Substation",[-86.15676062435875, 44.60457525430529]],
    [ "772823759",[-82.6433195762464, 40.86120101833123]],
    [ "772827598",[-120.8850745971614, 44.29967734359406]],
    [ "Lincoln Substation",[-83.40347305, 44.6563953]],
    [ "Ottoman Substation",[-76.52120728282839, 37.70015290311713]],
    [ "773262531",[-82.06901987874915, 34.939516952817726]],
    [ "Roan Mountain Substation",[-82.05835886891113, 36.193207959523235]],
    [ "Russel Term",[-87.8925981229637, 42.99782782539652]],
    [ "773683234",[-87.6741117249419, 38.34704519541271]],
    [ "773684150",[-85.90126858831115, 39.22738682453555]],
    [ "773684162",[-85.89491639094011, 39.187695147762746]],
    [ "773685595",[-117.29191228810781, 34.07475600749523]],
    [ "Karlin Substation",[-85.73604017490882, 44.56926389554514]],
    [ "Clough Substation",[-75.84724695114157, 39.25231145856243]],
    [ "774748820",[-83.40093370000001, 39.36743185]],
    [ "Central Ferry Substation",[-117.80718323538093, 46.595645607872335]],
    [ "Mt. Bethel Substation",[-75.22182069888954, 40.79780573356688]],
    [ "Thayer Drive Substation",[-119.28905595719355, 46.27687568687498]],
    [ "Red Mountain Substation",[-119.40506654102926, 46.281937093896886]],
    [ "775102983",[-119.45278730000001, 46.260545500000006]],
    [ "Quijotoa Substation",[-112.112395, 32.16133450000001]],
    [ "Danville Substation",[-86.52092443951824, 39.753688101295936]],
    [ "Sylvania Substation",[-87.2414398, 39.91988609999999]],
    [ "Kalkaska Substation",[-85.09923202516127, 44.74346404204657]],
    [ "Hearn Substation",[-112.41219720531821, 33.61384042085252]],
    [ "Henshaw Substation",[-111.8921917670928, 33.27401189767612]],
    [ "775667723",[-105.88321782460528, 37.69090869682113]],
    [ "775766322",[-80.86042680632784, 35.146808310760036]],
    [ "775830232",[-83.71175877081701, 33.2767550939778]],
    [ "Richmond Street Substation",[-88.41616738643471, 44.28491505158484]],
    [ "Catoosa Substation",[-85.17025230996768, 34.96098691646915]],
    [ "Sand Hill Substation",[-84.97741575989569, 33.63661000007992]],
    [ "776034936",[-80.05647014882335, 35.86300973288088]],
    [ "776122451",[-93.28895015, 45.14363485]],
    [ "Canadian Lakes Substation",[-85.30461903373647, 43.55562811063917]],
    [ "Horseshoe Creek Substation",[-85.193015829541, 43.412019836953874]],
    [ "Hinton Substation",[-85.28443492723308, 43.48266987003158]],
    [ "776292775",[-81.83300113234986, 33.61742533376484]],
    [ "Nashville Electric Service",[-86.77987462239872, 36.211990344329244]],
    [ "776326084",[-117.3730077, 33.836904800000006]],
    [ "776326094",[-117.21812813280154, 33.872146051021375]],
    [ "776873238",[-119.313567574591, 46.20106209679865]],
    [ "776890795",[-106.4928175, 35.068963749999995]],
    [ "Lahaina Switching Station",[-156.65950794999998, 20.884846249999995]],
    [ "Moffat Substation",[-105.90879267381742, 37.99137709907039]],
    [ "777392305",[-83.10667386942828, 36.91181423842325]],
    [ "PPL",[-75.85725835217372, 41.24498713266842]],
    [ "Jacksonville Electric Authority",[-81.70793571437864, 30.266521008141037]],
    [ "777542292",[-82.8301355112367, 37.13118043983609]],
    [ "AEP Lusher Avenue Station",[-85.96094895000002, 41.667118949999995]],
    [ "Duke Energy",[-78.39901845827917, 35.6135724481232]],
    [ "777838221",[-85.70034464999999, 41.325116699999995]],
    [ "778116569",[-93.7407106587854, 44.47012474218125]],
    [ "778135251",[-119.85278178147014, 47.0922747471156]],
    [ "778143294",[-106.0951071987525, 35.012245295077314]],
    [ "778253163",[-78.85817264999999, 36.06902305]],
    [ "778348659",[-85.70237986484375, 41.382019968221535]],
    [ "778561712",[-77.85416557170163, 35.78922891375818]],
    [ "Norwood Substation",[-80.13471078634295, 35.231005093380844]],
    [ "778885844",[-88.42976250943066, 44.255743565385814]],
    [ "778979612",[-113.32817445413326, 33.025320935703235]],
    [ "779236063",[-85.99808653903249, 41.695171074954565]],
    [ "779237977",[-106.03764800958108, 37.76319812967375]],
    [ "West 9 Mile Substation",[-87.36773865425994, 30.534454215881855]],
    [ "Dudley Substation",[-95.73509707521768, 44.44294887191455]],
    [ "779576793",[-90.59569032912913, 44.56301360560932]],
    [ "Noblesville Norheast Substation",[-85.98667412351695, 40.05801667709425]],
    [ "780360335",[-85.75185531151429, 41.80530267229214]],
    [ "Diamond Street Major Substation",[-79.90385554046114, 40.858175972594594]],
    [ "Georgia Power",[-84.38997057397272, 33.7852155825122]],
    [ "781190216",[-96.42404944428897, 41.44464237440701]],
    [ "781296280",[-79.90438669115882, 35.36159333040931]],
    [ "781358309",[-75.28568876318823, 43.08765081565511]],
    [ "Page Substation",[-83.65860144064982, 42.578353520005535]],
    [ "Pine Grove Station",[-76.09667486760769, 43.15040462394899]],
    [ "Edwards Substation",[-90.61478778834048, 32.31187552479234]],
    [ "781661355",[-84.81700092964459, 38.1644308611836]],
    [ "69",[-106.10321662349405, 37.74149344571325]],
    [ "Haggerty Substation",[-83.44579724811179, 42.35002051052434]],
    [ "Saguache Substation",[-106.1299760034914, 38.08801975310071]],
    [ "Sargent Substation",[-106.10265195204295, 37.689769111293614]],
    [ "782918424",[-106.07512662072628, 37.69001664283051]],
    [ "Varick Station",[-76.50564688244044, 43.448809717548826]],
    [ "Station 8244",[-76.90099864228755, 43.203209194925265]],
    [ "Station 217",[-76.86835565, 43.211867950000006]],
    [ "Station 215",[-76.87962393116057, 43.22364706319508]],
    [ "783355304",[-81.54178719575818, 35.283735960960165]],
    [ "Midland Substation",[-101.13647425, 44.08007075]],
    [ "Enrico Fermi Generation Substation",[-83.25604165121793, 41.96507479032535]],
    [ "783517092",[-108.42857064494778, 46.27295593158764]],
    [ "783535165",[-124.37957477564471, 47.953800124308714]],
    [ "Fulton Substation",[-83.90992534826802, 41.601450610527046]],
    [ "Clay City Substation",[-87.07272781574969, 39.28497741689481]],
    [ "783767135",[-87.06235160909952, 39.460065574949475]],
    [ "783767212",[-86.9603871749373, 39.13933159484665]],
    [ "Public Service Company of New Mexico",[-106.71518820697497, 35.0160002060799]],
    [ "Wayne Junction Substation",[-75.15550750442497, 40.02599485432897]],
    [ "784074147",[-87.91934787346334, 42.84630567222193]],
    [ "784215970",[-87.86732902313553, 36.83209674482712]],
    [ "784691382",[-84.35850838294446, 30.430073333732015]],
    [ "Tallahassee Airport Solar Substation",[-84.37728595535856, 30.39074213230341]],
    [ "784757112",[-83.51317433662248, 32.32027830907604]],
    [ "784880809",[-96.61016262674299, 33.56744143526812]],
    [ "Waneeta Substation",[-75.11479381777494, 40.00859630701882]],
    [ "785306915",[-83.47510916876945, 32.25640241737346]],
    [ "Los Angeles Department of Water and Power",[-118.35878641152519, 34.10558696398215]],
    [ "785387161",[-75.63483110157999, 40.45619318880381]],
    [ "East Topton Substation",[-75.69691456155448, 40.50569933500127]],
    [ "Baldy Substation",[-75.77363865495786, 40.50354225967308]],
    [ "County Line Substation",[-75.614181333761, 40.34249134256486]],
    [ "Center Substation",[-106.10464502612575, 37.754042962391566]],
    [ "Georgia Transmission Corporation",[-85.0343725713777, 31.29443313405595]],
    [ "Three Notch EMC",[-85.03459386782613, 31.29481189703318]],
    [ "Rosella Sub",[-85.86602119999999, 41.219584799999986]],
    [ "786029309",[-85.81570442137168, 42.03086617037304]],
    [ "786114658",[-101.2084868, 48.237599200000005]],
    [ "Arcade Creek substation",[-121.33619734443495, 38.656029251206384]],
    [ "Oak Hill Substation",[-71.5436260274121, 43.276673139700385]],
    [ "Quarry Substation FPL",[-80.44063028430705, 25.813224017721378]],
    [ "Ashland Substation",[-71.63725850167035, 43.69137977103101]],
    [ "North Woodstock Substation",[-71.67696650747386, 44.011378517120065]],
    [ "Andrew Square Substation",[-71.05864142052215, 42.32921699277528]],
    [ "Richmond Substation",[-75.07404451884743, 39.98643807496519]],
    [ "Atwater Substation",[-85.68058034231612, 42.23380534630279]],
    [ "Greenspire Substation",[-85.62658022527313, 42.1996856607152]],
    [ "787317577",[-75.81057965465968, 40.266902037511656]],
    [ "Birdsboro Substation",[-75.80360947892352, 40.26755730213664]],
    [ "787587300",[-84.06837494354906, 32.35238963676405]],
    [ "Ringing Rocks Substation",[-75.59995228440896, 40.28596206291672]],
    [ "Waverly Substation",[-97.10567268698503, 44.97678893313309]],
    [ "Kentucky Utilities Company",[-83.69411897106903, 36.758002320824744]],
    [ "Ten Mile Lake Substation",[-95.99935673551387, 46.122721534940396]],
    [ "Roseville Switching Station",[-95.8844665, 45.8036354]],
    [ "Roseville Substation",[-95.8842888, 45.802949399999996]],
    [ "Amiret Substation",[-95.75471616581783, 44.311581484571136]],
    [ "High Landing Substation",[-95.80834052491446, 48.06425560870741]],
    [ "Wabasso Substation",[-95.26865167451653, 44.40240289601123]],
    [ "Green Valley 69kV Substation",[-95.66541085720426, 44.4724845589404]],
    [ "N 7th Street Substation",[-95.77822674983796, 44.47172973000328]],
    [ "Moyer Substation",[-95.90135064879827, 45.23957685003634]],
    [ "Holloway Substation",[-95.91427278317231, 45.23958176578119]],
    [ "South Milton Substation",[-76.86088368503842, 41.008355373223964]],
    [ "788588049",[-84.91882659999997, 31.384088350000003]],
    [ "Blakely Substation",[-84.9296272, 31.394326600000003]],
    [ "788593743",[-85.34736535, 31.35021455]],
    [ "Milan Substation",[-95.91889984999999, 45.16704884999999]],
    [ "Taunton-St. Leo Substation",[-96.06330273385322, 44.591788577598976]],
    [ "Minneota E Industrial Substation",[-95.9717146162005, 44.552135409787496]],
    [ "788662194",[-96.28146025022536, 44.711300883325286]],
    [ "Gary, SD Substation",[-96.4493682, 44.791002950000006]],
    [ "788667386",[-86.84313202511908, 34.72162434608646]],
    [ "Piney Creek Substation",[-79.43631224999999, 41.19127525]],
    [ "MidAmerican Energy",[-92.34369213269635, 42.50637884807226]],
    [ "788699507",[-83.78101811998076, 32.09839440573926]],
    [ "788723361",[-80.6700358448078, 36.28585874371105]],
    [ "788723362",[-80.67025372397693, 36.28588194561385]],
    [ "Lynd Substation",[-95.89630485, 44.39905555]],
    [ "Burr Substation",[-96.35952424999999, 44.74500585]],
    [ "DEMCO",[-90.68464285773489, 30.83398036437176]],
    [ "Fluker Substation",[-90.75881190000001, 30.783287050000006]],
    [ "Syre Substation",[-96.2592048, 47.1778925]],
    [ "789086391",[-80.9878322809399, 35.44530817518112]],
    [ "Redwood Electric Cooperative",[-95.26775147287937, 44.34119328970877]],
    [ "Sheridian Substation",[-95.34972465000001, 44.4877507]],
    [ "Crawford Substation",[-84.82662699999999, 43.50984514999999]],
    [ "Winn Substation",[-84.89521888077662, 43.514828083683895]],
    [ "Crossroads Substation",[-76.57996991286839, 39.81637019710554]],
    [ "789658854",[-102.35227797504035, 48.32791765737532]],
    [ "Waverly Switching Station",[-106.0031937977503, 37.386533742058134]],
    [ "PECO",[-75.25602961182973, 39.90940685719718]],
    [ "Discovery Way Substation",[-84.22274150178654, 43.59528669225435]],
    [ "789990612",[-92.2390269000652, 44.092780752944044]],
    [ "Huntsville Utilities",[-86.74823538343486, 34.72477653323496]],
    [ "790612507",[-80.07024206430293, 35.66289068471989]],
    [ "Tabernacle Substation",[-80.01518286732734, 35.75159113457827]],
    [ "790764177",[-80.8754943698971, 37.887188005012284]],
    [ "River Road Substation",[-123.11695885025688, 44.075603577723925]],
    [ "Adams Substation",[-123.10615234633121, 44.056883765803036]],
    [ "791099374",[-82.58767057183724, 34.834873631973046]],
    [ "791116392",[-99.9275975368811, 48.67452495010617]],
    [ "791200913",[-97.04661033369261, 44.84728047769882]],
    [ "791470428",[-80.99362697595816, 34.95707472138683]],
    [ "Brookside Substation",[-75.74283420444416, 41.547511323946]],
    [ "Greenwood Substation",[-78.36136010092493, 40.53209621064135]],
    [ "Kragnes Substation",[-96.74582402507065, 46.977379071562694]],
    [ "Willachoochee Substation",[-83.04433523283562, 31.328069918037293]],
    [ "J.E. Baker Substation",[-76.81687510498743, 39.937758429578885]],
    [ "Bair Substation",[-76.8280935241896, 39.903696487481845]],
    [ "Milroy Substation",[-95.5330495, 44.486266400000005]],
    [ "Yampa Valley Electric",[-107.90835876772019, 40.06703633052128]],
    [ "Russell Substation",[-95.93708592440579, 44.31180336126442]],
    [ "Oro Hondo Substation",[-103.75385653869553, 44.3441842675383]],
    [ "Ross Substation",[-103.76067385992808, 44.34619595795504]],
    [ "Fairton Substation",[-75.2169273959321, 39.40527209080487]],
    [ "Wood Lake Substation",[-95.61430315000001, 44.6447276]],
    [ "Yellow Medicine Substation",[-95.61423199999999, 44.615401549999994]],
    [ "792381080",[-80.88689600559279, 33.448697316124836]],
    [ "Brye Road Substation",[-86.3808943766842, 43.95225790461871]],
    [ "Morris 41.6kV Steel Substation",[-95.91780711702557, 45.59130869603906]],
    [ "Donnelly Substation",[-96.00553580596008, 45.65780047480873]],
    [ "Garvin Substation",[-95.77148845000002, 44.23514720000001]],
    [ "Renner Substation",[-96.77221010815579, 43.61576339025844]],
    [ "Crewe Switching Station",[-78.13177613012503, 37.16564223542431]],
    [ "792906682",[-74.24899243009745, 40.57717904502984]],
    [ "792952540",[-100.52009180006436, 41.423469199506954]],
    [ "792977910",[-80.40324128540246, 33.97041821472611]],
    [ "Hitterdal Substation",[-96.10981042510524, 46.977862603137396]],
    [ "Jersey Central Power and Light",[-75.1067193307854, 40.697525923828124]],
    [ "Danville Utilities",[-79.62072610860116, 36.61949023740553]],
    [ "Shelby Center Substation",[-83.00902605, 42.681783]],
    [ "Page Substation",[-97.57098912229873, 47.15420420500765]],
    [ "Osceola Industrial Substation",[-89.97220025, 35.6820884]],
    [ "793331537",[-86.64596720149775, 40.60342360236519]],
    [ "793359313",[-97.99641994826224, 46.92322027822724]],
    [ "Marble Hill Substation",[-75.19272925893775, 40.710221532503496]],
    [ "Evergy",[-95.40041569497944, 37.90050648203232]],
    [ "793517889",[-78.21036921706465, 34.35049732358266]],
    [ "793517894",[-77.95428170000001, 34.22914445]],
    [ "Cumulus Substation",[-77.46524641406195, 39.010522422703474]],
    [ "Cynthiana Substation",[-84.29705424064674, 38.386846813828626]],
    [ "Minneota Substation",[-95.9913567, 44.56267455]],
    [ "Lamberton Substation",[-95.27007225968725, 44.224703285591566]],
    [ "Tracy Switching Station",[-95.63358456725845, 44.23889378577965]],
    [ "Morristown Substation",[-101.72084180953847, 45.93624367087516]],
    [ "Virginia Hills Substation",[-82.12940674999999, 36.6207996]],
    [ "794163930",[-96.74091964999998, 35.92829945]],
    [ "Union Substation",[-84.99769077026767, 33.838340946182235]],
    [ "794400798",[-96.006237165299, 33.978878474948246]],
    [ "794400799",[-96.00643162785228, 33.983040160828004]],
    [ "794465567",[-102.48681685000001, 47.976352950000006]],
    [ "Mill Road Substation",[-97.06182919999999, 47.9488999]],
    [ "794549205",[-78.20931855776745, 34.32287644224854]],
    [ "Morgan Substation",[-85.18068728791526, 42.36259547496504]],
    [ "Metcalfe Substation",[-83.98913828890863, 30.69969612127282]],
    [ "794895690",[-82.00867878272791, 37.206451857989975]],
    [ "794921057",[-82.52254260000001, 40.79167295000001]],
    [ "Canby Substation",[-96.2608024, 44.7179295]],
    [ "795027865",[-96.54818742708919, 34.55943437089984]],
    [ "795027869",[-96.74420502206009, 35.26387701434934]],
    [ "Reading Anthracite Substation",[-76.21018163699846, 40.71216627572286]],
    [ "Appalachian Power Company",[-82.14924434999999, 37.26758999999999]],
    [ "Hurley Substation",[-82.02124800299103, 37.422278696694164]],
    [ "795052766",[-81.92832709999999, 37.2467353]],
    [ "Statesville City #5 Substation",[-80.78601380005648, 35.750703433332944]],
    [ "795125054",[-80.53237634999999, 35.61513605]],
    [ "Post Cereal Substation",[-85.16270762216449, 42.31169457582375]],
    [ "795255977",[-85.15400309223219, 42.31779395784048]],
    [ "Saint Marys Substation",[-81.54718729088133, 30.73735907181758]],
    [ "795470974",[-79.13026874673359, 36.06856234075909]],
    [ "Appalachian Power Company",[-82.12168622115097, 37.2251699440617]],
    [ "Hasbrouck Heights Substation",[-74.06313876789878, 40.865136316564616]],
    [ "795755569",[-80.47924223396446, 35.07418292167316]],
    [ "Entergy Arkansas",[-92.76635744863034, 34.62618658394637]],
    [ "795951007",[-79.27389444254236, 37.11891132483317]],
    [ "Vance Substation",[-83.08881578284824, 42.474984688368075]],
    [ "Deja Substation",[-85.00389095723344, 43.363965512908216]],
    [ "Grover Substation",[-84.64476435, 43.377888399999996]],
    [ "Consumers Energy",[-84.63775287504164, 43.38250539002089]],
    [ "MidAmerican Energy",[-90.43404818583294, 41.56698632899272]],
    [ "Irish Road Substation",[-83.55762472292825, 43.028388462697556]],
    [ "Consumers Energy",[-85.2341518, 43.201229850000004]],
    [ "796491899",[-97.25945416996964, 36.54798633749821]],
    [ "West Ringgold Substation",[-85.1375093284349, 34.89327493794716]],
    [ "796670328",[-84.46340627888618, 38.27260825605583]],
    [ "Newtown Square Substation",[-75.40031369905455, 39.99025503280118]],
    [ "796847506",[-84.38475773249543, 38.730585361708]],
    [ "Mahanoy City Substation",[-76.14119709999999, 40.81668755]],
    [ "797001085",[-85.19674598970781, 31.08716835128546]],
    [ "Hull Street Substation",[-85.66196617954623, 43.18719569795398]],
    [ "30th & Prairie Substation",[-96.2083927568723, 38.43453330227058]],
    [ "Tyler Substation",[-96.13442549063778, 44.276691250512926]],
    [ "Tyler Substation",[-96.18479288182857, 44.313214814848415]],
    [ "Appalachian Power Company",[-81.31396715, 37.236634]],
    [ "Appalachian Power Company",[-81.78303219593533, 37.192408906601116]],
    [ "Lee Street Substation",[-85.69127562930025, 42.93522239666274]],
    [ "Shenandoah Substation",[-76.20466730076448, 40.825833643405325]],
    [ "Walnut Grove Substation",[-95.5139346, 44.28815865]],
    [ "798610658",[-96.00780266348706, 32.29753832362128]],
    [ "798872983",[-82.3121604975214, 36.910793764443625]],
    [ "Aubil Lake Substation",[-85.55467364381968, 42.71022519922495]],
    [ "798924361",[-80.42534032102529, 35.11767140220618]],
    [ "798924364",[-80.43242769930345, 35.122430966798646]],
    [ "798975106",[-101.22821644247936, 47.5451640106962]],
    [ "Hill Street Station 311",[-74.35348722261877, 43.03704617128733]],
    [ "Central Hudson Gas & Electric",[-73.87781083103867, 41.53430567472872]],
    [ "799003816",[-73.83976860324995, 41.535529073811304]],
    [ "Uptown Substation",[-97.10847478984626, 44.901113235837016]],
    [ "Brodnax Substation",[-78.01100347645902, 36.7343059557857]],
    [ "South Hill Substation",[-78.11691952746193, 36.726235080978384]],
    [ "799096220",[-77.87392619999997, 36.616609999999994]],
    [ "Southside Electric Cooperative",[-77.9938146672297, 36.903226517965976]],
    [ "Brunswick Substation",[-77.95523596559538, 36.80772700319517]],
    [ "Evergy",[-95.40310325501287, 37.90624027335101]],
    [ "Appalachian Power Company",[-82.55014105000001, 36.628389299999995]],
    [ "Warner Substation",[-85.50343615, 42.46419315]],
    [ "Buffalo Flats Substation",[-97.66852813719983, 37.7119419508349]],
    [ "799215426",[-97.759801, 36.4058469]],
    [ "Twilight Substation",[-85.5083232485584, 42.32780344653231]],
    [ "Dearington Substation",[-79.16442713372605, 37.40930535507586]],
    [ "Sabin Substation",[-96.61074732367157, 46.81877287577311]],
    [ "799494459",[-97.85699555, 36.66528155]],
    [ "Appalachian Power Company",[-82.76211055624854, 36.731585392200536]],
    [ "Playas Substation",[-108.56820541793836, 32.03428130295662]],
    [ "Switching yard",[-108.54729703961047, 32.23905787998384]],
    [ "800499874",[-90.71582572640632, 33.7298511939607]],
    [ "Williamson Substation",[-87.64936804999999, 34.8066359]],
    [ "800778421",[-85.18667785000001, 39.285779649999995]],
    [ "Tallapoosa Substation",[-85.29041665070797, 33.7387326053019]],
    [ "Waipio Substation",[-158.0018605305054, 21.426566702963584]],
    [ "Marven Substation",[-74.49956812388957, 39.34008957740965]],
    [ "801402620",[-86.61042574999999, 34.61159695]],
    [ "801419888",[-88.5601767383112, 33.772190252405274]],
    [ "Macho Springs",[-107.49282827378212, 32.53787803775023]],
    [ "801790459",[-112.73089607945, 39.151064139930604]],
    [ "801834085",[-84.01688388257078, 30.40184510193191]],
    [ "Duke Energy",[-85.13379966777164, 39.124257747224995]],
    [ "McGraws Substation",[-81.47116135307509, 37.68252955278952]],
    [ "Toyota Substation",[-83.69637571306768, 42.167515957014906]],
    [ "802288919",[-119.05710567629528, 46.9693290296676]],
    [ "Todd Substation",[-83.90383595410538, 42.404890408385924]],
    [ "802700721",[-82.47338726650077, 36.95178732375809]],
    [ "802701008",[-82.77526818811114, 36.871762373389586]],
    [ "802735544",[-82.43490800000002, 29.773751600000004]],
    [ "802744073",[-82.30635737660793, 29.36214690812185]],
    [ "802749617",[-82.48157534547025, 29.156050575160982]],
    [ "Shaw AFB Substation",[-80.49295201998545, 33.96850542768827]],
    [ "802764583",[-82.13118336162323, 29.156980024868407]],
    [ "802781295",[-112.49760393661985, 33.408220993840466]],
    [ "Talmo Substation",[-83.69873703242403, 34.17982817462098]],
    [ "803071984",[-112.73479289999999, 40.90851670000001]],
    [ "803072003",[-112.73736739106738, 40.91391579966103]],
    [ "803385004",[-86.44944734999999, 38.667928100000005]],
    [ "803399158",[-86.18152478333333, 38.8171542]],
    [ "803419039",[-106.58660530976522, 31.96664291406569]],
    [ "Picante Substation",[-106.31443309055884, 31.88021335182796]],
    [ "803419048",[-106.4038344503024, 31.81921674992675]],
    [ "Stevens Substation",[-85.67252125515121, 42.93955712225593]],
    [ "Yucca Drive Switching Station",[-102.95503355149313, 31.587640119907313]],
    [ "CLINTONVILLE",[-88.73734876559821, 44.63602516751009]],
    [ "Appalachian Power Company",[-81.1295824, 37.096628349999996]],
    [ "803569424",[-87.34017531090937, 33.553004736746416]],
    [ "803767547",[-80.61275477800206, 35.01511309568458]],
    [ "Monroe Tie Substation",[-92.0652088346815, 32.513891370745824]],
    [ "804078557",[-87.30719427606621, 33.51059695557506]],
    [ "804215811",[-82.36422567729048, 40.46516112578349]],
    [ "Osage Substation",[-95.2682415, 46.9197351]],
    [ "Williamston Substation",[-84.27179386962968, 42.68660845097587]],
    [ "City of Radford",[-80.60441763964711, 37.16104492613409]],
    [ "Coronal Energy / Florida Power & Light",[-86.89834783341246, 30.422594651885326]],
    [ "804747883",[-77.61453580096382, 36.466710583085366]],
    [ "City of Tallahassee",[-84.11899758949791, 30.463043298298164]],
    [ "North Branch Substation",[-74.73291317302534, 40.60713469007734]],
    [ "Washington Metropolitan Area Transit Authority",[-77.37679929439956, 38.952315229454854]],
    [ "Washington Metropolitan Area Transit Authority",[-77.38615275475544, 38.952045214536504]],
    [ "Hubbell",[-85.07853639999999, 39.21194625]],
    [ "Tracy Substation",[-95.6244030395845, 44.23501077995529]],
    [ "Independence Substation",[-81.16227933899845, 36.630067175957144]],
    [ "Consumers Energy",[-84.21342527494834, 43.60546865863047]],
    [ "Marble Substation",[-96.33756176316166, 44.6461510691594]],
    [ "Lake Benton Substation",[-96.29310791011967, 44.261273336657034]],
    [ "806579163",[-82.43854796966933, 34.604631906260714]],
    [ "806579164",[-82.43588881163868, 34.59822161141298]],
    [ "806703518",[-80.83944564345136, 35.33866280555169]],
    [ "806703519",[-80.82596804011324, 35.342341500584986]],
    [ "806703528",[-80.76856559561317, 35.32309632670719]],
    [ "806722441",[-80.99145835, 35.334080300000004]],
    [ "Kersey West Swithing Station",[-104.58426617276487, 40.37633938186844]],
    [ "Cave Creek Substation",[-111.94785769783707, 33.82839922578614]],
    [ "Missile Site substation",[-104.02097580232734, 39.6859762005368]],
    [ "807050290",[-79.11270270969325, 33.856837046836596]],
    [ "807248621",[-87.30456348221554, 39.65160786536605]],
    [ "807300508",[-76.6246680943347, 35.53994272679434]],
    [ "807325339",[-92.80068014999999, 43.27010339999999]],
    [ "807327204",[-92.98566989824926, 43.416240942349035]],
    [ "Scotia Substation",[-77.94419645069341, 40.80635640572763]],
    [ "Elgin Substation",[-87.3906351, 34.84645795]],
    [ "New Baltimore Substation",[-82.72793858441122, 42.68654937787505]],
    [ "Canby W Rural Substation",[-96.29756324999998, 44.7181433]],
    [ "807787684",[-84.24183702507582, 43.59799148978715]],
    [ "Edenville Dam Substation",[-84.3748578755395, 43.81207228287077]],
    [ "Canby SE Rural Substation",[-96.24923091639607, 44.688929748406444]],
    [ "Kosciusko Sub",[-85.85582621253127, 41.260746419352934]],
    [ "807923582",[-82.56405633871186, 35.73466411752872]],
    [ "807983883",[-88.45721687490057, 43.76002543821479]],
    [ "808082717",[-106.5192837728086, 31.807068308501062]],
    [ "Appalachian Power Company",[-81.79534095000001, 36.76474300000001]],
    [ "BVU Authority",[-82.09636754679941, 36.64213287582599]],
    [ "BVU Authority",[-82.10435366717378, 36.66048175756366]],
    [ "BVU Authority",[-82.15391439011269, 36.6038350660414]],
    [ "808161632",[-85.17543172837931, 41.14782177214992]],
    [ "Gladwin Substation",[-84.4981238082537, 43.98561523744725]],
    [ "Grout Substation",[-84.50190267803261, 43.98736162689558]],
    [ "808530632",[-79.10077165, 33.947435350000006]],
    [ "Camden Iron and Metal Substation",[-75.12742608419833, 39.92600493050992]],
    [ "808542251",[-75.12423177473329, 39.91665925346131]],
    [ "808548629",[-82.17006847175148, 36.28867925385728]],
    [ "808568522",[-80.68272942488653, 28.483339744185223]],
    [ "Carlex Glass Substation",[-84.26180542502334, 35.61143895597085]],
    [ "Niles Ferry Substation",[-84.22955255, 35.603132099999996]],
    [ "Auburn",[-85.0469795957994, 41.36117760065154]],
    [ "808578051",[-85.04780705818209, 41.3627137043608]],
    [ "808578053",[-85.04448257243664, 41.35257787444079]],
    [ "808639442",[-89.89485442340859, 36.80779742084655]],
    [ "808909813",[-74.05348493822713, 40.16196029447342]],
    [ "Pronghorn Switching Station",[-103.84789082778485, 39.17098104448962]],
    [ "Fairdale Substation",[-81.61910791925544, 40.0112119764278]],
    [ "Georgia Power",[-84.11853656789093, 33.901020295040155]],
    [ "Commonwealth Edison",[-89.13830273587016, 40.047456642465974]],
    [ "St Louis Substation",[-84.60838073806228, 43.41249379718297]],
    [ "Abbeville Substation",[-83.31282999670994, 31.992805659283665]],
    [ "Georgetown Substation",[-96.6056201, 47.078708000000006]],
    [ "809874887",[-104.08343051041084, 39.13531792496257]],
    [ "Shellman Substation",[-84.61391602451934, 31.765657206061842]],
    [ "809992481",[-98.48547100025955, 33.897267810126664]],
    [ "Hendrum Substation",[-96.77534245000001, 47.29524380000001]],
    [ "Eldred Substation",[-96.78111087441172, 47.68117119316286]],
    [ "Flint Energies",[-84.1006097109194, 32.54699593843994]],
    [ "810374954",[-79.53593872003057, 36.10766170480774]],
    [ "Plummer Substation",[-94.46039923216406, 39.20804442774007]],
    [ "Hallmark Substation",[-94.40590684344788, 39.26666263996205]],
    [ "Birmingham Substation",[-94.45833931692947, 39.16310461656569]],
    [ "810471835",[-93.6010453, 40.10449875]],
    [ "Dix Substation",[-83.1934495745875, 42.21635468408437]],
    [ "Lolo",[-114.07518493982008, 46.75913502485433]],
    [ "810618638",[-75.96178717111523, 44.00082298077822]],
    [ "Herrings Station",[-75.6505061953417, 44.02170871726051]],
    [ "Carthage Energy LLC",[-75.62244364625421, 43.98425123057078]],
    [ "810638467",[-75.53487241557417, 35.267080906533245]],
    [ "Cape Hatteras Electric substation",[-75.53383473255397, 35.26730142371252]],
    [ "810638469",[-75.61589131802899, 35.2431638253713]],
    [ "810822435",[-149.4506942722434, 61.300324824858826]],
    [ "810903345",[-89.00385290175115, 42.50508278540385]],
    [ "Shortgrass Switching Station",[-103.2366741387513, 39.10521992792272]],
    [ "West Jefferson Substation",[-87.07543710000003, 33.65603445]],
    [ "Pittsburgh Avenue Substation",[-80.11907679050809, 42.08873997888497]],
    [ "Gulley Substation",[-83.28385422539036, 42.292810857713384]],
    [ "Greenville Primary Substation",[-84.71973923840551, 33.024042342745815]],
    [ "813525522",[-85.10175116690013, 33.78348976518993]],
    [ "813678257",[-111.9111807120854, 40.41550521284014]],
    [ "813810624",[-117.58276207486875, 47.81665899147819]],
    [ "813839760",[-81.5471421585281, 35.90923866818361]],
    [ "813919917",[-87.0729177, 31.099827050000002]],
    [ "813919918",[-87.06880292194614, 31.103139018140322]],
    [ "OREGON",[-89.3765195084062, 42.924788920149894]],
    [ "813924445",[-86.62195055000001, 33.1814409]],
    [ "813924446",[-86.6216129, 33.181746800000006]],
    [ "Armory",[-88.06801626292403, 45.80371942498047]],
    [ "Connorsville Illinois St. Substation",[-85.13951661239236, 39.65124786719535]],
    [ "813951696",[-85.13929412749252, 39.690901079262716]],
    [ "813971775",[-108.27446784330209, 32.768658322015604]],
    [ "Vernon VT Substation",[-72.5162673, 42.78181539999999]],
    [ "Vernon Road Substation",[-72.55102886349604, 42.83765032984237]],
    [ "Old Ferry Road Substation",[-72.54548830947786, 42.89388282780457]],
    [ "Brudies Road Substation",[-72.54899929999998, 42.887060649999995]],
    [ "Cheyenne Ridge West Substation",[-102.35266954436031, 39.02258494310386]],
    [ "Linden 230kv Substation",[-74.21064126324924, 40.621483192569585]],
    [ "Bayway Substation",[-74.2060225396409, 40.644675420904626]],
    [ "Linden 138kv? Substation",[-74.20860456783258, 40.621696262891575]],
    [ "Camp Small Substation",[-76.64773977458799, 39.34959651073911]],
    [ "814644400",[-149.81456147673364, 61.2213753312175]],
    [ "Shell Lake Substation",[-95.45587932505356, 46.97011120896746]],
    [ "815435340",[-77.64042175, 37.110295550000004]],
    [ "815440761",[-77.6755374536622, 36.17421756087569]],
    [ "815440769",[-77.7648662, 35.978386300000004]],
    [ "Ansonia Substation",[-73.0853958103124, 41.347491032297064]],
    [ "Suwannee American Cement Company, LLC",[-82.85150559999998, 29.959329699999998]],
    [ "815522669",[-82.83575135000001, 29.95891575]],
    [ "Cheyenne Ridge East Substation",[-102.24183377023219, 39.00091684448302]],
    [ "815567178",[-83.09294090675283, 30.391053265361062]],
    [ "Suwannee Solar Substation",[-83.17603660000002, 30.37478795]],
    [ "815567210",[-83.0776746, 30.261518950000003]],
    [ "815651722",[-68.32685067936549, 47.13459694406578]],
    [ "815757430",[-102.18491539173185, 39.12753015143223]],
    [ "815792141",[-102.35065133198087, 38.8279894849779]],
    [ "Bowdon Substation",[-85.25134636886257, 33.54331677037923]],
    [ "816546052",[-103.94909319974829, 48.4221787522745]],
    [ "Blue Ridge Energy",[-81.63965429928794, 36.20112138952123]],
    [ "816921387",[-77.65310794999999, 38.7532058]],
    [ "816963082",[-103.31342949049319, 48.85166372500172]],
    [ "816963386",[-102.92835614930938, 48.68681682333315]],
    [ "816963413",[-103.48536044925791, 48.9097948775617]],
    [ "Liberty Substation",[-77.53292882003518, 38.774880150730816]],
    [ "Power Company Road Substation",[-71.2484449884365, 42.62143462756503]],
    [ "817256051",[-118.24403609131132, 33.807493824699755]],
    [ "Midwest Energy & Communications",[-86.12376660000001, 42.2146392]],
    [ "817299669",[-86.28222001049808, 42.25714788912222]],
    [ "Bridgman Substation",[-86.56479926937035, 41.939703324480824]],
    [ "Davis Drive Substation",[-77.41186986442092, 38.98965253721836]],
    [ "817352912",[-83.4117107, 45.07247815]],
    [ "817354269",[-93.23062755000002, 37.206493449999996]],
    [ "817358816",[-93.4241604, 37.158944700000006]],
    [ "New Hope Substation",[-81.25925928551376, 37.93823101364548]],
    [ "Scarbro Substation",[-81.16582369614126, 37.955440071903816]],
    [ "Kincaid Substation",[-81.28799781011557, 38.03267996178832]],
    [ "Georgia Power",[-84.1292969, 33.91149455]],
    [ "817418901",[-93.29961436218669, 43.66606083031911]],
    [ "Hayward Substation",[-93.26273076938335, 43.647539078216305]],
    [ "817502184",[-83.1977493, 40.21357905]],
    [ "817502190",[-82.987662581404, 40.26538529131403]],
    [ "Stonewater Switching Station",[-77.53929772176745, 39.05497223331003]],
    [ "Gant Substation",[-77.53926129652173, 39.054251182141364]],
    [ "Lockridge Substation",[-77.456853529834, 38.99708561959145]],
    [ "Farmwell Substation",[-77.46883774552946, 39.015085358697]],
    [ "Buttermilk Substation",[-77.45725248443615, 39.00761067436257]],
    [ "Bever Creek",[-82.73017201175286, 37.38770902016919]],
    [ "817768633",[-85.70952477948485, 32.43924967512223]],
    [ "Winona Substation",[-111.41559567503906, 35.18780045705483]],
    [ "817949609",[-82.00271814085184, 28.77715171503072]],
    [ "817962306",[-92.72184505002387, 32.52539561643724]],
    [ "Citrus Combined Cycle Substation",[-82.67271087842803, 28.96428204441694]],
    [ "Montrose Substation",[-91.49283407462812, 33.303777458810075]],
    [ "818258961",[-81.16176218166922, 35.63428666735619]],
    [ "Bandywine Substation",[-76.86675059342318, 38.6679593430848]],
    [ "818545966",[-76.48021107276314, 39.22523846922753]],
    [ "818722086",[-111.83010165247259, 39.80782133107436]],
    [ "818728531",[-112.0016054098039, 40.75445235144777]],
    [ "818764947",[-81.99447326600207, 29.08836753200253]],
    [ "Thompson Substation",[-75.52358571333703, 41.87824255599822]],
    [ "818867735",[-85.18494797496481, 41.00887484272404]],
    [ "818876341",[-84.89441179999999, 41.1332245]],
    [ "818876358",[-84.90996715966592, 41.364392429794435]],
    [ "818876363",[-84.87325977685393, 41.31047915225672]],
    [ "818880936",[-84.10808467152748, 41.39528856690989]],
    [ "818880937",[-84.10840651675542, 41.39531174064327]],
    [ "Marias River Electric Cooperative",[-111.86293722754326, 48.73475410579965]],
    [ "818889286",[-85.22887501555685, 41.4403264375245]],
    [ "818889290",[-85.04459002415763, 41.42924404683676]],
    [ "818889296",[-84.8657252245599, 41.42354638942474]],
    [ "818929006",[-80.49037360000001, 35.29816795000001]],
    [ "818929007",[-80.4897429909806, 35.29813467155582]],
    [ "818929019",[-80.5935152172495, 35.29172619699636]],
    [ "818929030",[-80.50108304791307, 35.30955895929246]],
    [ "819054927",[-86.35989459645815, 40.761312568659896]],
    [ "819054937",[-85.45234074166206, 41.14032457528973]],
    [ "819054955",[-85.84603945003533, 40.82500425085729]],
    [ "819054964",[-85.59941299999998, 40.86079155]],
    [ "819054983",[-85.45231308839847, 40.892333796265966]],
    [ "819054997",[-85.21992834999999, 41.00151925]],
    [ "819054999",[-85.177989, 40.959580599999995]],
    [ "819055005",[-85.23452820603221, 41.08856110465185]],
    [ "819055019",[-85.06781877168616, 41.362562275351586]],
    [ "819080639",[-85.00590953396235, 41.67120681723759]],
    [ "819089964",[-74.3232772, 43.071106449999995]],
    [ "Green Garden & West 21st Street Substation",[-80.11022379666869, 42.104204985128696]],
    [ "819114195",[-78.91545450002286, 35.753385483328536]],
    [ "Prairie Star Substation",[-92.61864224326213, 43.64554063556474]],
    [ "819500175",[-117.2584272075951, 34.120929275073586]],
    [ "819500183",[-117.32648055725495, 34.08655370418803]],
    [ "819500187",[-117.33291995839997, 34.022122032881654]],
    [ "819500191",[-117.40015390080535, 34.04922950441422]],
    [ "819577508",[-79.37821296574145, 34.49255063685903]],
    [ "819616590",[-93.29606036038234, 30.224200909480235]],
    [ "Westlake Chemical Corporation",[-93.2819293306587, 30.221483358589587]],
    [ "Westlake Chemical Corporation",[-93.28135112497864, 30.22393934039425]],
    [ "Westlake Chemical Corporation",[-93.29765997498393, 30.22763659593878]],
    [ "819616600",[-93.30271826705815, 30.1910828509269]],
    [ "819623398",[-88.64831102652518, 33.58863702005016]],
    [ "819623400",[-88.64911007057223, 33.59102558920043]],
    [ "819919087",[-78.8730423847788, 38.43654262780721]],
    [ "City of Harrisonburg",[-78.83589000255427, 38.44597580635599]],
    [ "Virginia Electric and Power Company",[-78.88535842370149, 38.3813986568844]],
    [ "Salem Substation",[-83.60245717588613, 42.3895422002947]],
    [ "Mt. Pleasant Substation",[-87.2268479630217, 35.52239033915864]],
    [ "Shenandoah Substation",[-78.6194293204641, 38.49291090858589]],
    [ "819968241",[-103.82903866928291, 48.2710962480687]],
    [ "819971634",[-86.11253165000001, 41.6617821]],
    [ "819981890",[-86.6370809, 36.03153025]],
    [ "819981903",[-86.53057873273723, 35.76177635247529]],
    [ "Lewisburg Board of Public Utilities",[-86.79893725646723, 35.46018581432816]],
    [ "Lewisburg Board of Public Utilities",[-86.79637292082062, 35.46161375534923]],
    [ "819990737",[-87.05544302338267, 35.644849490302995]],
    [ "819991855",[-86.77290355700728, 35.43051656782936]],
    [ "819997500",[-80.64928368254654, 34.94678555127438]],
    [ "820054146",[-92.39008904832478, 43.68763808719926]],
    [ "820104826",[-85.88930606883773, 38.18199427011588]],
    [ "820133817",[-79.44683950366257, 34.42423058837242]],
    [ "820186220",[-104.19318612534094, 48.28852355130309]],
    [ "820202689",[-87.04299793625954, 35.65349750523371]],
    [ "Midway Substation",[-88.27281611972992, 34.724609702603836]],
    [ "Mississippi Silicon LLC",[-88.326147968455, 34.80320295545703]],
    [ "Alcorn County Electric Power Association",[-88.51784580737984, 34.90945867893059]],
    [ "Alcorn County Electric Power Association",[-88.53773082448738, 34.902340609387196]],
    [ "Duck River Electric Membership Corporation",[-86.0179603, 35.44014430000001]],
    [ "820213137",[-86.04703345, 35.38233944999999]],
    [ "820213140",[-86.04842785665392, 35.380262479231995]],
    [ "820213141",[-86.04601155, 35.379740350000006]],
    [ "820213142",[-86.04256539039756, 35.37920207931491]],
    [ "820237512",[-90.6907393920171, 43.14069444425319]],
    [ "820237513",[-90.69149895, 43.14068715000002]],
    [ "820239952",[-90.69723967588298, 33.119753585978565]],
    [ "East Athens Substation",[-83.3524266220024, 33.93075712200239]],
    [ "820362931",[-73.37745743461852, 42.55663256759509]],
    [ "820791575",[-86.69790932349737, 35.611935008050146]],
    [ "Sun Prairie Utilities",[-89.25913588560101, 43.17070292950812]],
    [ "820842428",[-92.64286959670207, 44.627421677880655]],
    [ "Consumers Energy",[-85.68843435, 42.81940529999999]],
    [ "821200586",[-75.41262497953817, 43.21765969973371]],
    [ "City of New Castle",[-75.56039041675561, 39.67216894803048]],
    [ "821245514",[-120.27237218675624, 37.58409442555374]],
    [ "821245515",[-120.12558461794607, 37.58646660571207]],
    [ "821248009",[-91.93515051663358, 44.21350046769354]],
    [ "Stonybrook Substation",[-94.45335419060436, 46.52943201572277]],
    [ "Delmarva Power",[-75.55519605252019, 39.76067224413872]],
    [ "TOKEN CREEK",[-89.29668457612517, 43.19356904427593]],
    [ "North Hanover Substation",[-77.0020212209229, 39.8201664212273]],
    [ "Washington Metropolitan Area Transit Authority",[-77.49071175, 39.003414850000006]],
    [ "Washington Metropolitan Area Transit Authority",[-77.47812778227721, 38.996762461918294]],
    [ "Washington Metropolitan Area Transit Authority",[-77.46517006617887, 38.993053249721434]],
    [ "N06 Wiehle Ave TPSS11",[-77.34142772069355, 38.948896983337924]],
    [ "Washington Metropolitan Area Transit Authority",[-77.4291247, 38.9615677]],
    [ "Bionol Substation",[-78.42939166561246, 41.0304451695623]],
    [ "Allegheny Substation",[-78.87873203637648, 39.96534387369975]],
    [ "821626568",[-77.21656166055197, 40.2029006746539]],
    [ "Mountain Substation",[-77.17542889029056, 40.122609897194096]],
    [ "Millersburg SubstaTION",[-76.94254015, 40.5340614]],
    [ "Station 163",[-78.156202, 42.38131]],
    [ "NIPSCO",[-87.31723037491997, 41.492322743602365]],
    [ "Philipsburg Substation",[-78.2125643686865, 40.90309291715938]],
    [ "American Electric Power",[-99.67462803230254, 28.34639811864363]],
    [ "822485842",[-97.36107657136148, 27.934689175290174]],
    [ "822705475",[-112.04209295035147, 40.50841706466797]],
    [ "Dubuque Seventeenth Street and Pine Substation",[-90.66457815020254, 42.51046114025724]],
    [ "Alliant Energy",[-90.64913305000002, 42.525198950000004]],
    [ "Spanglers Mills Substation",[-76.8993320660321, 40.20415506269494]],
    [ "Noble REMC",[-85.39640125999986, 41.392066379220395]],
    [ "Dannemora",[-73.7220680297711, 44.716405803666824]],
    [ "823119268",[-76.30859594683281, 36.89479083440065]],
    [ "Mill Road Substation",[-80.04503116317775, 42.10990774279208]],
    [ "Knoxville Utilities Board",[-83.94309353749283, 35.94300771856559]],
    [ "West Brookfield Substation",[-73.43104158624986, 41.48283564420729]],
    [ "823258119",[-96.08826432616999, 36.046029389145325]],
    [ "823258124",[-96.06470156334983, 36.02413486183812]],
    [ "823558646",[-81.802561836356, 38.41596274693]],
    [ "823560730",[-79.39560804999999, 34.75460655]],
    [ "Plant Road Substation",[-81.83910081961457, 38.43351975729395]],
    [ "823760821",[-96.57783210000001, 35.9908899]],
    [ "Public Service Company of Oklahoma",[-95.8469678294189, 36.086955551035054]],
    [ "American Electric Power",[-95.82943510836759, 36.08092128878009]],
    [ "823809757",[-96.06680225801348, 35.75509548205445]],
    [ "823816265",[-99.18390045, 35.35171570000001]],
    [ "823849755",[-96.05244957510263, 42.99552449309401]],
    [ "823849759",[-96.05994502507129, 42.98967714395599]],
    [ "823849770",[-96.1854851, 42.7673832]],
    [ "823849771",[-96.1826467, 42.77721019999999]],
    [ "823868952",[-96.26467400000001, 43.17146875]],
    [ "823869336",[-103.67033930318453, 48.268818472548524]],
    [ "Airport Substation",[-122.9426049586412, 44.52632472211462]],
    [ "824008239",[-80.75648349906102, 34.960657529607]],
    [ "824227963",[-120.81863925000002, 36.92427945]],
    [ "824227964",[-120.81909087515685, 36.9252815422405]],
    [ "Georgia Power",[-84.52382672447773, 33.90815135569633]],
    [ "Georgia Power",[-84.5297257932274, 33.93085802440579]],
    [ "Georgia Power",[-84.52786882447077, 33.93111193611625]],
    [ "824283261",[-90.35781872499831, 47.75187334062814]],
    [ "Midway",[-89.47401625458066, 39.04169816892982]],
    [ "824403932",[-94.81636965, 42.5031748]],
    [ "Georgia Power",[-81.21439085668827, 32.08097608157116]],
    [ "Grahamville Substation",[-80.95657223414962, 32.47082535842505]],
    [ "Boone Harrison Substation",[-93.88945062497731, 42.063195192684056]],
    [ "824630517",[-89.0149059671327, 39.65364403386802]],
    [ "824630545",[-89.00898075531606, 38.989735917514835]],
    [ "Mars Hill Substation",[-83.45770309126006, 33.91199359244712]],
    [ "Matamoras Substation",[-74.70929408346323, 41.364976474256395]],
    [ "Pantego Substation",[-76.64732375752632, 35.58576956786325]],
    [ "Pantego Substation",[-76.64777033550094, 35.586370684003896]],
    [ "Ponzer Substation",[-76.47612723291692, 35.579972595857946]],
    [ "825083498",[-76.86397956602049, 35.57351430195459]],
    [ "825083502",[-76.97568976892981, 35.50589076429225]],
    [ "Fairview Energy Center Substation",[-78.85636506527624, 40.412436701666984]],
    [ "825166960",[-76.08984478100805, 40.223018256395626]],
    [ "Atglen Substation",[-75.9539302066725, 39.94995542249448]],
    [ "825166987",[-75.95168451316775, 39.95123976962781]],
    [ "Newlinville Substation",[-75.8298063787241, 39.971551604029436]],
    [ "New Jersey Transit",[-74.57229015120147, 40.7159525938671]],
    [ "Jersey Central Power and Light",[-74.58849873409596, 40.86010103093878]],
    [ "Mendham Substation",[-74.58555869432813, 40.78274700589062]],
    [ "Tabor Switch Point",[-74.47146243494817, 40.84379536807963]],
    [ "Chilcott Substation",[-74.47913014126242, 40.84239237818288]],
    [ "Frontier Substation",[-116.85914143765582, 39.50599094154167]],
    [ "825205638",[-82.53114081052892, 35.57327532000397]],
    [ "825205644",[-81.60800902468077, 35.75816045687833]],
    [ "825205645",[-81.60672895, 35.7573819]],
    [ "825205646",[-81.60727231825435, 35.75744433971462]],
    [ "825205650",[-81.56906793932188, 35.74108281973881]],
    [ "Valdese Weavers",[-81.52982132392223, 35.73705979252746]],
    [ "825213655",[-81.49023525000001, 35.8377142]],
    [ "825213667",[-81.56213245000001, 35.8990426]],
    [ "825270586",[-80.884286777838, 35.38507387228151]],
    [ "825270601",[-80.8951183885648, 35.47565631614983]],
    [ "825270611",[-81.16774254999999, 35.4492104]],
    [ "825270614",[-81.14177004999999, 35.50941759999999]],
    [ "825270615",[-81.32375625, 35.5276999]],
    [ "825270629",[-81.20738123250052, 35.63870700326936]],
    [ "825270631",[-81.21892142326999, 35.66997919471616]],
    [ "825270637",[-81.25540147298662, 35.70986159412828]],
    [ "825270638",[-81.254232375771, 35.71477210755441]],
    [ "825274837",[-76.25293602727531, 35.916638248241874]],
    [ "825328056",[-96.30737361012785, 36.59303578556674]],
    [ "825328058",[-96.30813820256282, 36.59144583549692]],
    [ "Evergy",[-95.41789460884492, 37.77808586969384]],
    [ "825328184",[-94.22490073964036, 38.58658229637784]],
    [ "Holden Gen Substation",[-93.99808094230632, 38.75281770090307]],
    [ "825328253",[-92.0518479238476, 39.72627589884646]],
    [ "825340536",[-90.65298041126597, 31.029078173623905]],
    [ "825415907",[-77.8964213703409, 35.69655042123461]],
    [ "825415923",[-77.82264300390858, 35.86749558068348]],
    [ "825415927",[-79.19668603887023, 34.81233753532532]],
    [ "Fayetteville Public Works",[-78.83075957496983, 35.09712740823103]],
    [ "825415938",[-78.82894216524096, 35.099009020058205]],
    [ "Fayetteville Public Works",[-78.9056831330401, 34.99941740068353]],
    [ "Woodenshoe Substation",[-88.52620945351269, 44.147909451178144]],
    [ "825439665",[-78.22487205, 33.99387215]],
    [ "MidAmerican Energy",[-90.57337469459686, 41.61736302451547]],
    [ "Southwest Arkansas Electric Cooperative",[-94.19903290769103, 33.71433931967202]],
    [ "825458660",[-94.12510940000001, 33.6746154]],
    [ "Southwest Arkansas Electric Cooperative",[-94.05931322984848, 33.684163002666295]],
    [ "825486198",[-77.31883171334707, 37.17900233853877]],
    [ "825697711",[-79.80769190471462, 33.70941781655761]],
    [ "825760722",[-86.86720896968765, 38.22287510619576]],
    [ "825760723",[-86.86767136759826, 38.2229484656387]],
    [ "825883242",[-87.43649444568534, 40.148810819309126]],
    [ "825942569",[-86.88666871151864, 36.540206000604314]],
    [ "Tennessee Valley Authority",[-86.74921243498504, 36.41761677758475]],
    [ "City of Gallatin",[-86.38488987259977, 36.40622895938646]],
    [ "Waynesboro Substation",[-87.69142148831628, 35.33222190696991]],
    [ "Dickson Electric System",[-87.32768238117013, 36.043082144892104]],
    [ "Pleasant View Substation",[-87.02861900619553, 36.393016777002366]],
    [ "Gordonsville Substation",[-85.93916479041206, 36.1662917844924]],
    [ "Lebanon Substation",[-86.3117357444449, 36.16563496820493]],
    [ "825969510",[-86.37107101560395, 36.39567296301324]],
    [ "Tennessee Valley Authority",[-85.96732220000001, 35.1797091]],
    [ "825977030",[-85.93611519999999, 36.1964681]],
    [ "826316343",[-110.65735820616115, 31.672768942833265]],
    [ "826316347",[-110.73799778515824, 31.778392518088353]],
    [ "826340857",[-86.29911081554098, 32.38153103385255]],
    [ "Huger Substation",[-79.80297834999999, 33.102680649999996]],
    [ "Sacramento Municipal Utility District",[-121.37381471913183, 38.38688702945304]],
    [ "827053953",[-112.24453232505498, 33.39217354296876]],
    [ "Marathon Pipe Line LLC",[-89.6462038983435, 34.977939238030345]],
    [ "DAPL-ETCO Operations Management, LLC",[-89.30683569999998, 35.93821689999999]],
    [ "Union City Energy Authority",[-89.10551908067285, 36.46682295181443]],
    [ "Canton Substation",[-98.63294599531046, 36.05679379759564]],
    [ "827129827",[-112.77847600003513, 33.4936651499095]],
    [ "827129833",[-112.95349652513198, 33.49313554313202]],
    [ "827153796",[-86.77444166176676, 40.76056668971896]],
    [ "827153797",[-86.77428693861089, 40.75242457486017]],
    [ "827245188",[-80.1660322742392, 33.67757729282209]],
    [ "827334303",[-84.8412936353362, 32.54143332472021]],
    [ "Flat Rock Substation",[-84.87207264999999, 32.549293999999996]],
    [ "827334323",[-84.90905765742806, 32.485874983087164]],
    [ "827334332",[-84.87026854999999, 32.517118]],
    [ "North Ferrisburg Substation",[-73.25620965, 44.25330305]],
    [ "Bel Aire Substation",[-97.25505216465007, 37.78222177666309]],
    [ "Beech Substation",[-97.20850629546045, 37.69536302881287]],
    [ "827440619",[-88.49392208958972, 36.7721418502366]],
    [ "Mohawk Substation",[-79.72133957784672, 34.502930908098406]],
    [ "Station 167",[-77.82943643925574, 42.79487067418358]],
    [ "827672823",[-91.43548182781439, 39.71000350438249]],
    [ "Schuyler Substation",[-78.69836241933073, 37.788419902683636]],
    [ "827673425",[-78.67864085000001, 37.79176025]],
    [ "827737086",[-75.04616620186336, 39.907578871627145]],
    [ "827739112",[-120.25496854759601, 45.796133390150366]],
    [ "Station 194",[-76.60705700176386, 43.16786408810003]],
    [ "827789100",[-78.89051843993633, 37.6392622837367]],
    [ "827812944",[-106.4174612, 36.253685100000006]],
    [ "North Rockmart Substation",[-85.04660805, 34.01055830000001]],
    [ "Howard Substation",[-111.62120480000002, 33.3436737]],
    [ "827956616",[-76.84358127244502, 38.081152033183216]],
    [ "Georgia Power",[-84.19650914799601, 33.823967757763675]],
    [ "827993746",[-86.2183483913084, 41.62737617693112]],
    [ "Corcoran Substation",[-119.55760402600794, 36.10947097520645]],
    [ "Waukena Substation",[-119.57647656087951, 36.138622653195206]],
    [ "828078066",[-75.96545417413563, 40.9361140535614]],
    [ "828078071",[-76.07954845, 40.9189314]],
    [ "828078075",[-76.05045755, 40.9291053]],
    [ "828078100",[-76.0448719, 40.94929270000001]],
    [ "Mason Substation",[-69.67190257943317, 43.99185371197054]],
    [ "Maine Yankee 115kV Substation",[-69.696837675209, 43.951498185028555]],
    [ "828128751",[-75.60196246869754, 41.4397886857524]],
    [ "Haymarket Substation",[-77.6501687069483, 38.81773744025924]],
    [ "Glenwood Substation",[-80.08117049190467, 42.0990921253357]],
    [ "828212455",[-76.05243835, 40.94784045]],
    [ "Dameron Substation",[-81.33812181449407, 37.832177581591374]],
    [ "828231426",[-81.25332993141197, 37.76766121730678]],
    [ "828231429",[-81.18786319446633, 37.82351381370829]],
    [ "828235067",[-81.62328805, 38.068641500000005]],
    [ "Hemlock Substation",[-75.0538588, 41.337727099999995]],
    [ "828264599",[-85.43952679183533, 40.66789859256184]],
    [ "Burnips Substation",[-85.85428892934404, 42.73134704840518]],
    [ "828285427",[-120.92247522504967, 44.189143691993245]],
    [ "Dorr Corners Substation",[-85.72334857823813, 42.76168789457047]],
    [ "PPL",[-74.92788051961249, 41.37062541330343]],
    [ "Twin Lakes Substation",[-74.92715608961736, 41.371373833286086]],
    [ "828409849",[-96.3028351247114, 34.0123961395951]],
    [ "828415756",[-97.03711532538229, 34.305693196117986]],
    [ "828415759",[-96.54342118643112, 33.42772853015673]],
    [ "828418637",[-96.48114199999999, 33.882397]],
    [ "828420760",[-106.31474954999999, 31.661541749999994]],
    [ "828581046",[-121.01314730746272, 42.387262674902715]],
    [ "Chicago Substation",[-85.83825862513712, 42.88491240925192]],
    [ "Luce Substation",[-84.6831639123535, 43.430217086634855]],
    [ "Turner Substation",[-83.78310066525202, 44.141396367888085]],
    [ "Kaumana Substation",[-155.1362809733933, 19.68417135344635]],
    [ "828900086",[-81.87074785, 34.916317150000005]],
    [ "828900089",[-81.89745917365944, 34.93919827143181]],
    [ "828915886",[-81.92984192352995, 34.92232455452291]],
    [ "828924552",[-82.02342656899486, 35.788822494181936]],
    [ "Old Fort Retail Substation",[-82.1719444194871, 35.633725348302676]],
    [ "WestRock",[-81.98680569999999, 35.6987974]],
    [ "828924568",[-81.96813114999999, 35.654676349999995]],
    [ "828931361",[-82.07859993023857, 35.46184147608257]],
    [ "Station 214",[-77.1754645, 43.23426900000001]],
    [ "Station 209",[-76.99854528505205, 43.26811589609953]],
    [ "Scioto Ridge Substation",[-83.73146738054922, 40.58656317421727]],
    [ "829094590",[-116.01578905544885, 43.02450386136177]],
    [ "Athens Utilities Board",[-84.61668601435257, 35.452432818325676]],
    [ "829419491",[-87.26045986798145, 40.00976488515791]],
    [ "829469207",[-79.81205045000002, 33.988937]],
    [ "White Electric Department",[-96.64648415000002, 44.43068085]],
    [ "829888185",[-116.33319127872082, 43.444196218025866]],
    [ "829895811",[-112.73844831990925, 42.82326953992548]],
    [ "So Cal Edison",[-117.70747697561372, 34.099344546177136]],
    [ "829912278",[-78.15136978030007, 38.938946845228116]],
    [ "829929434",[-78.10772598981515, 38.91537071110356]],
    [ "Georgia Transmission Corporation",[-84.20384410870462, 30.986134576536333]],
    [ "Grady EMC",[-84.20412042765936, 30.986782206487145]],
    [ "830085258",[-88.48371980000002, 38.05614390000001]],
    [ "Danwood Substation",[-79.826678, 34.138694199999996]],
    [ "830257900",[-116.37068289592378, 48.90514689602812]],
    [ "Storrie Lake Sub",[-105.22761306621484, 35.67319273485189]],
    [ "Mechanicsville Substation",[-79.79206879360842, 34.33321853140739]],
    [ "Charleston Park Substation",[-116.11362517077877, 36.20449505308428]],
    [ "Thousandaire Substation",[-115.94993893145623, 36.13245205281107]],
    [ "Farmwood Substation",[-71.5448289110021, 43.277861017890444]],
    [ "Plymouth Substation",[-76.73358643031784, 35.841372126473885]],
    [ "830830749",[-86.15222615000002, 41.684386149999995]],
    [ "Microsoft Project Osmium Data Center",[-93.79291424160107, 41.499194181297135]],
    [ "830933353",[-121.20467257473624, 45.63697180298132]],
    [ "New Wilmington Substation",[-80.32643768186301, 41.12203344776147]],
    [ "South Hertford Substation",[-76.4836693320754, 36.17970368022654]],
    [ "Kailua Substation",[-155.99991785229363, 19.645971968181403]],
    [ "831014919",[-84.36068765684503, 30.36605692905427]],
    [ "Hawaiian Electric Company",[-156.0088953624375, 19.663207369294078]],
    [ "Hawaiian Electric Company",[-156.03258084203136, 19.715919822314223]],
    [ "Lake Harmony Substation",[-75.61369637494458, 41.04955142691262]],
    [ "Southwest Arkansas Electric Cooperative",[-93.81751770433159, 34.08980627947682]],
    [ "831446442",[-93.85384554999999, 34.08562264999999]],
    [ "Southwestern Electric Power Company",[-94.02347914263693, 34.102508674588684]],
    [ "Dierks Substation",[-94.01170806474376, 34.119910252079535]],
    [ "831482903",[-85.71721788619199, 40.73924852537712]],
    [ "Makahoy Substation",[-85.7729302623422, 40.26227252482193]],
    [ "Ohio Oil Substation",[-85.86244275, 40.29125875]],
    [ "Elwood Substation",[-85.84418251652893, 40.27764623747738]],
    [ "Grady EMC",[-84.21790997949445, 30.904900197943455]],
    [ "831740058",[-80.63042440394851, 35.10194368727551]],
    [ "831743248",[-86.5911034149081, 40.24319156455562]],
    [ "831743685",[-86.59049447502446, 40.281865292605644]],
    [ "831974965",[-85.01831725537288, 41.43211595530359]],
    [ "831988667",[-85.11600967468347, 41.363774492479834]],
    [ "832023251",[-85.63043861188704, 41.072970524712666]],
    [ "Mullett Lake Substation",[-84.43299471450523, 45.50304991824782]],
    [ "832044892",[-82.5374052501047, 27.460746720111402]],
    [ "Sparrows Crossroads Substation",[-79.87760995000002, 34.065621300000004]],
    [ "832067360",[-86.92329668051931, 40.03288886281323]],
    [ "832249890",[-87.28388720000001, 39.63227055000001]],
    [ "Mansfield Substation",[-87.1062745340809, 39.63784176734306]],
    [ "832284563",[-85.94685808799117, 40.99881952521546]],
    [ "832305189",[-86.05581155739623, 40.89521948016435]],
    [ "Withlacoochee River Electric",[-82.67887959802528, 28.281370303499198]],
    [ "832351680",[-111.8499362329443, 33.41100093690995]],
    [ "832377383",[-86.50816210443358, 40.675086114961495]],
    [ "Putney Substation",[-72.51220089119599, 42.97130176050964]],
    [ "Michael Avenue Substation",[-72.39408465, 43.2659685]],
    [ "832603996",[-106.79746505551805, 41.475006600593]],
    [ "Duke Energy",[-86.86042992598713, 39.63140671144213]],
    [ "832706822",[-86.80919840542532, 40.08332787650394]],
    [ "832736223",[-86.9788273, 39.97363105911528]],
    [ "832746181",[-108.09831628808303, 32.782139712441804]],
    [ "832746186",[-108.12268741520734, 32.693888292410925]],
    [ "832913148",[-82.82750623335465, 35.889393199032064]],
    [ "832984436",[-88.94824435019252, 38.014624525840375]],
    [ "832991743",[-87.36921693158705, 38.32419316116699]],
    [ "833014808",[-74.780075748663, 41.77405504946547]],
    [ "Terre Haute Water Street Substation",[-87.41849532737804, 39.469005326842684]],
    [ "Burlison Substation",[-89.75927124201698, 35.56440500478761]],
    [ "833077486",[-82.63898293045727, 35.82143456638607]],
    [ "833077492",[-82.55896323442218, 35.83285335500592]],
    [ "Southwest Tennessee Electric Membership Corporation",[-89.78431323058544, 35.444104846810106]],
    [ "833171566",[-89.84898695000001, 35.35042815]],
    [ "833216125",[-89.87630799172737, 35.93578970274087]],
    [ "Arcadia Substation",[-92.92914104823122, 32.55939478126902]],
    [ "833414179",[-109.54543656008394, 47.044217679605545]],
    [ "833487475",[-92.61833759999999, 33.61605525]],
    [ "833507986",[-88.8146175, 35.5542136]],
    [ "833520879",[-89.34215959545519, 36.08091478250307]],
    [ "Marathon Pipe Line LLC",[-89.2169271104119, 36.0893991255956]],
    [ "Clarksville Connected Utilities",[-93.48457248317995, 35.46680258792336]],
    [ "833558586",[-93.77464071459895, 35.40964691243722]],
    [ "Downsville Substation",[-92.44763556195207, 32.60109746905901]],
    [ "Arkansas Valley Electric Cooperative",[-94.2198658, 35.162943150000004]],
    [ "Vienna Substation",[-92.6447884934153, 32.57449630247696]],
    [ "Arkansas Electric Cooperative Corporation",[-90.43754005, 35.80631715]],
    [ "833645307",[-92.05082974948279, 32.451287486962975]],
    [ "Redfront Substation",[-76.58511366501884, 39.95475571961986]],
    [ "Lancaster Air Products Substation",[-76.40184266902997, 40.048897441907805]],
    [ "Entergy Louisiana",[-92.0897034111009, 32.154864778195424]],
    [ "Entergy Louisiana",[-92.25563910000001, 32.5199226]],
    [ "Aragon Substation",[-85.06099047166137, 34.04049645195853]],
    [ "High Hill Substation",[-79.9266563802025, 34.233409803511286]],
    [ "North Warren Substation",[-79.15047372344175, 41.880428611656626]],
    [ "Oak Grove Substation",[-91.4164874055591, 32.855318515597396]],
    [ "833706822",[-91.34336975514547, 32.96273415061785]],
    [ "833711041",[-91.62452025, 32.4789957]],
    [ "833711043",[-91.58496114736488, 32.47948044311387]],
    [ "Mt Rose Substation",[-76.68998089348656, 39.957913343034754]],
    [ "North Harrisburg Substation",[-76.88785359999999, 40.292751100000004]],
    [ "833850048",[-76.88213646912703, 40.27749729507171]],
    [ "PPL",[-76.74819500000001, 40.22184195000001]],
    [ "ES3 Substation",[-76.76104002878067, 40.06110468979451]],
    [ "Entergy Louisiana",[-93.11766039263831, 32.41223440343387]],
    [ "833955724",[-92.98521884999997, 32.28935465]],
    [ "Bay Springs Substation",[-89.26135824715413, 31.968528351901103]],
    [ "834020337",[-89.87488312866788, 31.764525616857753]],
    [ "Cooperative Energy",[-89.8863269910084, 31.880670224788027]],
    [ "Mendenhall Substation",[-89.87436636827202, 31.98075443357344]],
    [ "New Hebron Substation",[-89.97309342491971, 31.730695862152373]],
    [ "Monticello Substation",[-90.13097583607528, 31.577572431283844]],
    [ "Prentiss Substation",[-89.85597954705585, 31.622867073025915]],
    [ "Prentiss Substation",[-89.85779864999999, 31.624416349999997]],
    [ "Oak Vale Substation",[-89.96571320311499, 31.457646492465745]],
    [ "Goss Substation",[-89.88873507669653, 31.363347202793992]],
    [ "Pearl River Valley Electric Power Association",[-89.97887185859564, 31.298284675586387]],
    [ "Foxworth Substation",[-89.87051959979432, 31.22678764585001]],
    [ "Cooperative Energy",[-89.41576797563617, 31.059968542297554]],
    [ "834057998",[-90.1142311749919, 32.369719605088726]],
    [ "834065114",[-90.18988757983381, 32.881296610698904]],
    [ "834079213",[-87.26172426180675, 33.195438310595215]],
    [ "834079214",[-87.26252298594727, 33.1942192328503]],
    [ "Kinzer Substation",[-76.07118606715828, 40.00124940229055]],
    [ "Safe Harbor Substation",[-76.38526908139679, 39.926571016928314]],
    [ "Manistique",[-86.25699663872605, 45.95796497433261]],
    [ "Gaylord Substation",[-84.72252169180237, 45.00460163490036]],
    [ "Alpine Substation",[-84.78270478318188, 45.02764296107495]],
    [ "Boyne City Substation",[-85.00909297529216, 45.214604692837064]],
    [ "834235850",[-76.80008718966934, 38.13748057533838]],
    [ "Sugar Limb Substation",[-84.32433022710357, 35.75407961531389]],
    [ "Lore Substation",[-90.77897652155112, 42.53171609579308]],
    [ "Millers Creek Substation",[-81.23565887384788, 36.18923586914452]],
    [ "Heathcote Substation",[-77.60523022755558, 38.80011605748008]],
    [ "Ameren UE",[-90.29797738383792, 38.67481078118289]],
    [ "Nottingham substation",[-76.03137063039689, 39.76084640424813]],
    [ "West Dothan Substation",[-85.4599341, 31.235269800000005]],
    [ "834737899",[-85.40257752666407, 31.253937981336716]],
    [ "115 KV Switching Substation",[-85.40111785779712, 31.259127215283193]],
    [ "Kosciuko Substation",[-89.600724430673, 33.03073731468055]],
    [ "834792783",[-89.02259118717772, 32.73913633693831]],
    [ "834794154",[-88.81692342958347, 32.74975155599797]],
    [ "834795087",[-88.59327352429457, 32.79037213421291]],
    [ "834803344",[-88.39453637590692, 32.40757400570551]],
    [ "834817314",[-94.33554609958935, 32.158104254681845]],
    [ "834817325",[-94.3626904, 32.18042305]],
    [ "Louisiana Pacific",[-87.72547973483042, 31.856563627963112]],
    [ "834820030",[-86.83210397083377, 33.854989242132895]],
    [ "Sipsey Substation",[-87.07376996860934, 33.819872454861276]],
    [ "Cullman Electric Cooperative",[-86.8075517, 33.96211855]],
    [ "Kinderhook Substation",[-85.00547800000001, 41.82544415]],
    [ "MCEC",[-81.41115193208374, 34.01620915935687]],
    [ "Englewood Substation",[-87.55459376939058, 33.10230313481588]],
    [ "834845586",[-90.40067411260509, 32.36512314265304]],
    [ "Winnie Substation",[-110.95594716586675, 32.25128688992691]],
    [ "834941287",[-93.7800200822476, 31.435535853119415]],
    [ "835162636",[-95.68504418289073, 34.985001655678126]],
    [ "Bristol Tennessee Essential Services",[-82.18803159622172, 36.59372988888211]],
    [ "835369322",[-80.04323816806291, 34.70630954420235]],
    [ "Holmesburg Substation",[-75.02450617776172, 40.03644302735315]],
    [ "Met-Ed",[-76.80796732089684, 40.132937840091735]],
    [ "Duke Energy",[-81.48449284664215, 28.140586234499352]],
    [ "835539855",[-97.512482957088, 34.18676156173227]],
    [ "835541135",[-97.40383549739532, 34.179600372523325]],
    [ "835541137",[-97.33248356422897, 34.172236881468095]],
    [ "835566922",[-80.11465783654387, 34.71501633523347]],
    [ "835566924",[-80.11861706330625, 34.71162773194728]],
    [ "835577060",[-111.99047318889805, 46.56530631502923]],
    [ "835583539",[-84.34324285158813, 40.553253017344]],
    [ "835610084",[-84.41625616934833, 38.04213394199413]],
    [ "Grigsby Chapel Substation",[-84.18163393020475, 35.894362426171185]],
    [ "Middle Street Substation",[-70.21878086761261, 44.10119180004161]],
    [ "835784878",[-83.8341691, 36.0236162]],
    [ "Tennessee Valley Authority",[-82.96063966467412, 36.375266823232934]],
    [ "Knoxville Utilities Board",[-83.83573787026116, 35.94439446283931]],
    [ "835796617",[-82.57616876684384, 36.55125889866646]],
    [ "Domtar Substation",[-82.5710971, 36.546662500000004]],
    [ "Highway 411 Substation",[-84.01996205000002, 35.7132321]],
    [ "Cedar Street Substation",[-80.36648252150094, 40.97698390470914]],
    [ "835906434",[-113.4320004989554, 37.1590846736265]],
    [ "835914711",[-85.02048329966803, 34.981785524328124]],
    [ "835934710",[-97.18570150420216, 48.56396400364616]],
    [ "835935399",[-97.1695628, 48.53627920000001]],
    [ "836028614",[-83.21177245863457, 36.24498299699066]],
    [ "Morristown Utilities Commission",[-83.39839080450216, 36.16845358295282]],
    [ "Morristown Utilities Commission",[-83.40040193535422, 36.15962204838906]],
    [ "East Tennessee Progress Center Substation",[-83.28833048733446, 36.144310637321894]],
    [ "White Pine Substation",[-83.29046997707712, 36.12036299488637]],
    [ "Nitro Substation",[-81.84619459455166, 38.412423561263864]],
    [ "W.D. Chips, L.L.C.",[-93.28572447497328, 31.000594095130616]],
    [ "Packaging Corporation of America",[-93.37368989455778, 30.861764625270595]],
    [ "CLECO",[-93.3671379, 30.860300249999998]],
    [ "836080121",[-93.33919030000001, 32.04065295]],
    [ "836080125",[-93.08639815, 31.810633200000005]],
    [ "836107278",[-84.98640044727435, 34.68344910122166]],
    [ "836110453",[-94.28632625855856, 32.15959951123806]],
    [ "836110467",[-93.82444516079367, 32.37486357993079]],
    [ "Georgia Power",[-84.98142100034309, 34.511905098420726]],
    [ "836129367",[-84.95493608134944, 34.473840293056924]],
    [ "Georgia Power",[-84.70413337843799, 33.78195204357089]],
    [ "Cedar Mountain Substation",[-84.77996650510197, 33.757149763168584]],
    [ "836193108",[-84.8016599689602, 34.05828838620775]],
    [ "836203180",[-96.89334594935964, 33.24533359508497]],
    [ "836236505",[-85.17704515, 34.218767850000006]],
    [ "836236769",[-94.6100175872597, 37.07030343098582]],
    [ "Cedar Hill Substation",[-85.22322686023834, 34.007710624938724]],
    [ "836246050",[-96.17918797545313, 40.87161330662116]],
    [ "Mount Zion Substation",[-85.18112509470764, 33.63103326214736]],
    [ "Walmart Substation",[-85.12275961445738, 33.635880768500016]],
    [ "836484725",[-84.41963931406919, 38.33764210785178]],
    [ "White Springs Substation",[-82.75413363983316, 30.340459344560223]],
    [ "Nutrien",[-82.86433965, 30.453332849999995]],
    [ "Nutrien",[-82.86391587479567, 30.439035591381217]],
    [ "836499693",[-82.7682324543633, 30.43870509328552]],
    [ "836526714",[-106.61002929573286, 35.111450964626584]],
    [ "Tennessee Valley Authority",[-83.56935875822049, 36.03316016599114]],
    [ "836766054",[-79.13253933362498, 37.99527279304308]],
    [ "Stuarts Draft Substation",[-79.0478337529872, 38.02451402403957]],
    [ "836766059",[-79.04879122957108, 38.02440123915886]],
    [ "Humboldt Utilities",[-88.92202290326999, 35.817909825523955]],
    [ "836874853",[-77.50288430711007, 38.8006833734959]],
    [ "Centreville Substation",[-77.39915645464194, 38.8346849661142]],
    [ "836888356",[-82.39696807322808, 38.54885716704542]],
    [ "Sebewa Substation",[-85.01186000723807, 42.8477291716199]],
    [ "836908961",[-86.36337355, 32.2700934]],
    [ "Hyundai Power Transformers Substation",[-86.36639805025992, 32.259821116583645]],
    [ "836908975",[-86.40970729999998, 32.313920499999995]],
    [ "836908977",[-86.43483290000002, 32.3253542]],
    [ "836908979",[-86.4430254, 32.363216650000005]],
    [ "836908993",[-86.80169439999999, 33.42150665]],
    [ "Bluff Park Substation",[-86.84787601997273, 33.419127085108634]],
    [ "836908996",[-86.87860978418227, 33.43406444839475]],
    [ "836910473",[-97.07202782705309, 33.23064535800352]],
    [ "836930788",[-158.1932490804092, 21.456200835834743]],
    [ "West Loch Solar Substation",[-158.01477795000002, 21.340122049999998]],
    [ "McAdory Substation",[-87.01161594088546, 33.383828084719035]],
    [ "Alabama Power",[-86.76095777686416, 33.6033409095973]],
    [ "Pawnee Substation",[-86.7328099, 33.64472085]],
    [ "836940486",[-86.77089315492353, 33.59565292923087]],
    [ "836965762",[-119.19893272477799, 47.13786560752318]],
    [ "836986400",[-88.75592784639642, 37.96958672646099]],
    [ "Drake South Plant Substation",[-104.83259440461713, 38.82268926969206]],
    [ "837075739",[-92.58140085000001, 37.507665200000005]],
    [ "Carroll Electric Cooperative Corporation",[-93.69444121792489, 36.39440253478425]],
    [ "Rudd Substation",[-93.48338878281746, 36.20957973799349]],
    [ "Carroll Electric Cooperative Corporation",[-94.06405427583154, 36.320859241394594]],
    [ "Carroll Electric Cooperative Corporation",[-94.10510280000003, 36.25191110000001]],
    [ "Omaha Substation",[-93.17156063167381, 36.45303615195931]],
    [ "837204446",[-85.74866408931098, 38.41481283245424]],
    [ "837220421",[-101.27523725, 48.17920155]],
    [ "837221191",[-78.91545443348176, 42.988861951769266]],
    [ "837221198",[-78.88992135334554, 42.97673661109338]],
    [ "837230389",[-98.42580839999998, 28.704829150000002]],
    [ "837230390",[-98.41043096488268, 28.72057267593306]],
    [ "837270268",[-82.85541035382029, 36.13021936435673]],
    [ "Moose Lodge Substation",[-85.03149328318263, 33.60242001644049]],
    [ "Dalton Substation",[-96.01881404430114, 46.19856031557294]],
    [ "Harwood Substation",[-96.881223068489, 46.98199869608182]],
    [ "Newnan Primary Substation",[-84.78641228153975, 33.3726339999829]],
    [ "Georgia Power",[-84.38162620691591, 33.23703071714]],
    [ "837460745",[-87.8668442, 30.984560099999996]],
    [ "837468210",[-89.90125674679555, 30.027873063678193]],
    [ "837468229",[-88.12215929079424, 30.73388727621466]],
    [ "Weyerheuser Substation",[-84.19953906669203, 33.08278025073876]],
    [ "Rayonier Substation",[-84.20315290808401, 33.07632167534564]],
    [ "Barnesville #1 Substation",[-84.15298902280489, 33.05556003320142]],
    [ "Mary Lake Substation",[-93.83038525, 45.1381509]],
    [ "Forsyth Substation",[-83.93958506544406, 33.047486824748916]],
    [ "837497394",[-101.36248650000002, 48.125240100000006]],
    [ "Balzer Substation",[-84.52436342007134, 42.5013607238161]],
    [ "Georgia Power",[-83.92559689069694, 33.0326940748311]],
    [ "Georgia Power",[-84.23156763135181, 33.233500343697735]],
    [ "Georgia Power",[-84.279542069327, 33.25933334935621]],
    [ "837616543",[-80.5502484, 33.57420405]],
    [ "837619938",[-87.40199797220657, 39.09766987485254]],
    [ "837660202",[-84.17835720150032, 33.41864353917393]],
    [ "837665138",[-84.1916659, 33.45855590000001]],
    [ "Ellenwood Substation",[-84.30210928244728, 33.60861349981387]],
    [ "Fairview Substation",[-84.22427749336535, 33.60315136422659]],
    [ "837670394",[-80.70008623485778, 39.87878366759884]],
    [ "Georgia Power",[-84.28108764942695, 33.67530342466639]],
    [ "Georgia Power",[-84.32924342709705, 33.70267124272707]],
    [ "Ripon Substation",[-121.14637024492563, 37.755618491439236]],
    [ "McPherson Plant Substation",[-97.68367982338322, 38.36315466233651]],
    [ "837900471",[-93.29587220761826, 37.212164617649826]],
    [ "Weyerhaeuser Substation #1",[-122.96054606770883, 44.05473565252628]],
    [ "Oakway Substation",[-123.07378037761472, 44.067162375149515]],
    [ "Laura Substation",[-123.02934309999999, 44.0640148]],
    [ "Holden Creek Substation",[-122.6972504169946, 44.099586318444075]],
    [ "Coburg Substation",[-123.06299910000001, 44.098567849999995]],
    [ "Municipal Electric Authority of Georgia",[-84.93462615000001, 31.3570635]],
    [ "Georgia Transmission Corporation",[-84.83090645000001, 31.401515150000005]],
    [ "Georgia Power",[-84.76488189999999, 31.765893999999996]],
    [ "837943876",[-84.49932642716439, 31.773369253483864]],
    [ "MEARS CORNERS",[-88.54578691565443, 44.111328386574336]],
    [ "Georgia Power",[-84.2569841129633, 33.826352863427196]],
    [ "Georgia Power",[-84.3340279880991, 33.92746944981182]],
    [ "837999443",[-84.30894044222244, 33.92166743662061]],
    [ "Piston Ring Substation",[-85.70613867625674, 43.155943715108805]],
    [ "838013995",[-84.51081453800194, 33.953014354541835]],
    [ "Georgia Power",[-84.42017922192016, 33.965867291332934]],
    [ "Sacramento Municipal Utility District",[-121.24371469999998, 38.5066874]],
    [ "Sacramento Municipal Utility District",[-121.14707582893674, 38.64483196873391]],
    [ "Energía Buena Vista",[-98.39772857227695, 26.207785911236876]],
    [ "838391181",[-84.708432466345, 34.09500780091662]],
    [ "Carousel Wind Farm Substation",[-102.1666800393223, 39.36005273718273]],
    [ "Minco Substation",[-82.99087636355682, 36.17955577110683]],
    [ "Georgia Power",[-84.80026480288582, 34.17861972722799]],
    [ "838645623",[-84.81215209999999, 34.183996699999994]],
    [ "Georgia Power",[-84.78154265465025, 34.27085216933806]],
    [ "Toyo Tire Substation",[-84.7291879, 34.288538849999995]],
    [ "Talmadge Substation",[-84.58517642648087, 34.42821536258433]],
    [ "838847844",[-84.84909049051808, 34.72443980881806]],
    [ "Dell Rapids Substation",[-96.72759655058296, 43.82254450338265]],
    [ "839041672",[-84.82093373443293, 34.26517482888879]],
    [ "839048871",[-80.29264680929681, 40.92884477487927]],
    [ "Armstrong Substation",[-79.46660007070747, 40.928257981003426]],
    [ "Tyrone North Substation",[-78.2691595891702, 40.668902108672]],
    [ "Eagle Valley Substation",[-78.22240745, 40.7454098]],
    [ "East Pike Substation",[-79.13339652969442, 40.61274216851303]],
    [ "Edgewood Substation",[-79.22068788796182, 40.575622910129674]],
    [ "Union City Substation",[-79.86498575088193, 41.897606682904296]],
    [ "Utica Junction Substation",[-79.91427211549707, 41.46093448079836]],
    [ "Grandview Substation",[-79.66388355270507, 41.46918967060906]],
    [ "Haynie Substation",[-79.5153330976177, 41.291234765468076]],
    [ "Green Valley Substation",[-95.75395476994917, 44.47921972819232]],
    [ "Conklin Park Substation",[-85.66353276965626, 43.432597310112364]],
    [ "Hillman Substation",[-83.74747703570655, 45.056795825035486]],
    [ "839482283",[-80.10860661707335, 39.49003581386214]],
    [ "839493829",[-79.4412153, 39.022250050000004]],
    [ "Dolehard Substation",[-83.71462175993312, 40.791458098213376]],
    [ "839538295",[-85.24335065000001, 31.57159905]],
    [ "Demec NUG",[-75.62453538817662, 39.27873808692338]],
    [ "Smyrna Substation",[-75.6245635264116, 39.28002257523693]],
    [ "Springfield Substation",[-75.34664295565088, 40.49197580578544]],
    [ "Progress Street Substation",[-83.89282464847531, 45.06770754263585]],
    [ "Rolling Meadows Substation",[-80.12851800996303, 42.081030127572895]],
    [ "839712475",[-81.81071120749466, 33.56352547709107]],
    [ "839712482",[-81.24078144254354, 33.57293636924003]],
    [ "Salley Substation",[-81.2967866228776, 33.56612020696313]],
    [ "Mesena Substation",[-82.53963765, 33.45304575]],
    [ "Georgia Power",[-82.3706033, 33.16661215]],
    [ "Kamin Substation",[-82.40909677613625, 33.2742432140286]],
    [ "Southern Natural Gas Substation",[-82.41305615908298, 33.25064709828337]],
    [ "Georgia Kaolin Substation",[-82.4341609185984, 33.25839874520023]],
    [ "Kaolin Mine Substation",[-82.44447587477337, 33.32867154116377]],
    [ "Southern Chips Substation",[-82.79686434345001, 32.96051122591354]],
    [ "839772174",[-86.3614365670649, 41.69112029694403]],
    [ "839878599",[-80.27669429014914, 35.757498625263864]],
    [ "839950612",[-91.19225444256298, 40.98487900195401]],
    [ "Elizabethton Electric Department",[-82.1806700806239, 36.36370597434529]],
    [ "Fort Madison Devils Creek",[-91.43086042551323, 40.58096954306268]],
    [ "Fort Madison East Substation",[-91.29920035176622, 40.63388745716169]],
    [ "Wever Substation",[-91.23693927050022, 40.69505309125979]],
    [ "West Penn Power",[-79.72568263457943, 40.60737624181798]],
    [ "840135683",[-90.64803620549753, 40.46873745208146]],
    [ "Windsor Substation",[-72.40856228732807, 43.489908259069004]],
    [ "J. M. Huber Substation (Reids)",[-83.55748115, 32.70472165]],
    [ "Irving Tissue Substation",[-83.63738382498427, 32.74404555869909]],
    [ "Yoshida Substation",[-83.5398692898779, 32.811391956577594]],
    [ "840326019",[-83.33844416659606, 32.87754484956166]],
    [ "International Paper Substation",[-83.30201448083012, 32.89202545418592]],
    [ "Deepstep Substation",[-83.00907635, 33.016044750000006]],
    [ "Soperton Primary Substation",[-82.59731168329358, 32.36970534759418]],
    [ "Lanzatech Substation",[-82.62307228090775, 32.39994764513464]],
    [ "840331496",[-82.76003393003226, 32.46948176003207]],
    [ "840331498",[-82.83969888258787, 32.50952650315167]],
    [ "Tennille City Substation",[-82.80212292968567, 32.94364171794397]],
    [ "840331503",[-82.80253685, 32.94317959999999]],
    [ "MEAG",[-82.80669644999999, 32.9661681]],
    [ "Montville Substation",[-72.1023257520943, 41.427908566453105]],
    [ "Brownsburg North Substation",[-86.40607052488734, 39.86495474339014]],
    [ "840537385",[-86.49800261682832, 40.040233216505506]],
    [ "840537390",[-86.25035562488435, 39.94025809181879]],
    [ "840537405",[-86.2247309162, 39.81068261526067]],
    [ "840572426",[-114.4999328386701, 39.09913390888944]],
    [ "840572428",[-114.49944537147704, 39.097798942981015]],
    [ "840573939",[-79.01103895000001, 38.129505449999996]],
    [ "840577879",[-78.64934023198253, 38.38397417599802]],
    [ "Edinburg Substation",[-78.53609716658447, 38.834045697639375]],
    [ "Southern Pioneer Electric Company",[-99.32207087472602, 37.57984075806243]],
    [ "Norfolk Station",[-74.99701288218368, 44.80587947797836]],
    [ "Grady EMC",[-83.8327044759715, 30.701603216401455]],
    [ "Consumers Energy",[-85.60665954851389, 42.280449366907014]],
    [ "Chelsea Electric Department",[-84.02997001289448, 42.31908882491055]],
    [ "841483231",[-93.11784229396005, 37.25497948761567]],
    [ "841495545",[-80.26489366469848, 35.80656798525673]],
    [ "841495546",[-80.26593223016943, 35.808108089921]],
    [ "841503429",[-79.91892763425167, 36.11861065366223]],
    [ "841503439",[-79.92781558999593, 36.09036327830318]],
    [ "841513734",[-80.21961321524557, 35.94774412197291]],
    [ "841513759",[-80.2322259, 36.0849223]],
    [ "Mancelona Subsation",[-85.04423309192805, 44.91022022034983]],
    [ "Shooting Star Substation",[-99.44719371096028, 37.519667140380285]],
    [ "Sunflower Electric Power Corporation",[-99.44932000248403, 37.60176027809727]],
    [ "Ragland Substation",[-86.15159290743026, 33.73176511043528]],
    [ "Alabama Power",[-86.15054047475724, 33.73437990218312]],
    [ "841766789",[-86.0515044250634, 33.78445973116235]],
    [ "841766790",[-86.0378415083445, 33.77909242858897]],
    [ "United States Army",[-85.91327299432825, 33.64264380312891]],
    [ "841766819",[-85.9834324398, 33.607904781652344]],
    [ "841766825",[-85.87884017855936, 33.71262471249773]],
    [ "M&H Valve",[-85.84047565101632, 33.67467641268416]],
    [ "Sylacauga Utilities Board",[-86.24692169999999, 33.16848435]],
    [ "East Pell City Substation",[-86.27682363638388, 33.58868253188524]],
    [ "841793910",[-86.24775248501224, 33.596908494527646]],
    [ "Mohawk Industries",[-85.37311954002702, 33.134536966191504]],
    [ "Wellborn Cabinet, Inc.",[-85.82123659325362, 33.25082908615903]],
    [ "Ashland Substation",[-85.89773209778753, 33.28603996537472]],
    [ "841793947",[-86.0570451167252, 33.448552966606314]],
    [ "841793951",[-85.88845320000001, 33.58093595]],
    [ "Colonial Pipeline Company",[-85.82490019430615, 33.5986336041044]],
    [ "841804163",[-86.55885325283154, 32.78658451727549]],
    [ "Tommie Corp Substation",[-86.73226426454846, 32.92827782153528]],
    [ "841901937",[-87.39711894542127, 32.0900515786076]],
    [ "841960770",[-86.98497616017589, 32.31757171926081]],
    [ "841960772",[-86.99107819270559, 32.37237687111504]],
    [ "South Selma Substation",[-87.00389832855372, 32.38059589150126]],
    [ "841960782",[-86.70439393293967, 32.808274166289586]],
    [ "Linden Substation",[-87.78566141779078, 32.293835057537294]],
    [ "841963581",[-87.76392434999998, 32.283162450000006]],
    [ "841968433",[-88.59583276783778, 33.469760032913435]],
    [ "841968437",[-88.55767102595388, 33.43196815872411]],
    [ "841968446",[-88.1194121, 32.678522650000005]],
    [ "841968454",[-87.83110860836481, 32.478800674872325]],
    [ "WestRock",[-87.97433104999999, 32.452847750000004]],
    [ "WestRock",[-87.97197134999999, 32.45295755]],
    [ "841968460",[-87.96012037499688, 32.46095649178279]],
    [ "N-221C",[-122.06377525, 37.415580500000004]],
    [ "N-225",[-122.06310789706535, 37.41674901118372]],
    [ "Grand Ledge Substation",[-84.83653518752068, 42.787966701572785]],
    [ "Georgia Pacific Substation",[-85.325403021662, 34.25359845991907]],
    [ "Georgia Power",[-85.3102293, 34.27185995]],
    [ "Patoutville Substation",[-91.72308954568878, 29.907734816614663]],
    [ "Teche Station Substation",[-91.54332705752823, 29.823456688255146]],
    [ "CLECO",[-91.51915453178444, 29.798682318394714]],
    [ "Wests Mill Substation",[-83.45242657090478, 35.28260248138246]],
    [ "Little Manatee Solar Substation",[-82.41787261468663, 27.68662248194636]],
    [ "842270085",[-80.68389867243104, 34.414482376912446]],
    [ "Pratt Wind Substation",[-98.81213873066426, 37.55829952356607]],
    [ "842292080",[-82.15044155000001, 28.2089482]],
    [ "Ninnescah Substation",[-98.5797473355366, 37.586306863328474]],
    [ "Ascutney Substation",[-72.40754981147532, 43.39544313281934]],
    [ "Abbe Substation",[-84.0663040860551, 44.72593051278828]],
    [ "842619715",[-93.84255058617674, 35.501511099732326]],
    [ "842658908",[-75.5142103, 40.4141339]],
    [ "East Greenville Substation",[-75.51460946320117, 40.412493058887385]],
    [ "Quakertown Substation",[-75.34129992096084, 40.44641099482214]],
    [ "842679674",[-75.47893783745003, 43.77780291748283]],
    [ "842714311",[-74.85022898574569, 43.04028267052968]],
    [ "Inghams Station",[-74.76370099584366, 43.060314511207224]],
    [ "Village of Solvay",[-76.25428546479593, 43.109752878484805]],
    [ "Milton Avenue Station",[-76.28082914631112, 43.05268906447988]],
    [ "842729135",[-76.15479945, 43.0852532]],
    [ "842815044",[-82.13653640387096, 28.775973197639985]],
    [ "842826331",[-82.94615304999999, 34.356528999999995]],
    [ "842826336",[-83.11033440575139, 34.45325741902262]],
    [ "842826360",[-83.06693091675645, 34.66479393962565]],
    [ "842826363",[-83.06008994999999, 34.7084343]],
    [ "842826372",[-82.8076387601178, 35.15282472220651]],
    [ "842843174",[-82.08800015, 28.9014219]],
    [ "842866762",[-82.8437484689462, 35.538094074566665]],
    [ "842866777",[-82.6486156175776, 35.54317742461587]],
    [ "842871786",[-82.08648981858023, 29.010797586053908]],
    [ "842882660",[-82.4351376, 34.477147450000004]],
    [ "842882672",[-82.70775329928385, 34.46173893331056]],
    [ "Sunshine Gateway Solar Energy Center Substation",[-82.77949736424424, 30.288068275179164]],
    [ "Suwannee Springs Substation",[-82.93436438769007, 30.409534024104364]],
    [ "842887009",[-88.26366727012804, 37.776865523691825]],
    [ "842888953",[-83.18089268061782, 30.442666462257314]],
    [ "842888954",[-83.18181961586572, 30.442818874932943]],
    [ "842889036",[-82.56373459999999, 34.150849699999995]],
    [ "842899574",[-72.91856265926451, 43.14546962198605]],
    [ "842899578",[-72.83795834707198, 43.15697139218027]],
    [ "Tillson Substation",[-72.50591740906862, 42.39719469335146]],
    [ "Kingman Wind Substation",[-98.33825149066374, 37.579827480034126]],
    [ "843178794",[-109.86318901585716, 45.395191908363344]],
    [ "843236579",[-96.98225786872781, 30.043468147277096]],
    [ "843264769",[-103.54973810000001, 47.77211104999999]],
    [ "843303530",[-98.76759679999999, 36.649804249999995]],
    [ "Piercefield Regulator Station",[-74.57046245154118, 44.23273026693262]],
    [ "Piercefield Station",[-74.56564452253171, 44.2327159081274]],
    [ "843313155",[-74.98731729187939, 44.21557561093474]],
    [ "843316841",[-86.49006999999999, 36.9282065]],
    [ "843319869",[-86.33835866350238, 36.94821934406632]],
    [ "843319881",[-86.47800044999998, 36.96599595]],
    [ "Florida Power & Light",[-80.48168106496455, 25.638476547349256]],
    [ "Lester Substation",[-84.03883972863456, 31.37861505800315]],
    [ "843628982",[-83.76133050046222, 32.756724226093354]],
    [ "Sulzer Pump",[-122.69749449306201, 45.5447679452228]],
    [ "Bloomfield Substation",[-83.71500865000002, 32.802471600000004]],
    [ "Mill Irons Substation",[-83.66945705818007, 32.815539717272664]],
    [ "Graphic Packaging Substation",[-83.62956489536809, 32.77427918458594]],
    [ "843711316",[-83.7370642297, 32.32889557248787]],
    [ "Findlay Substation",[-83.78481722019984, 32.14433596364657]],
    [ "Unadilla Substation",[-83.74910913261026, 32.243209371262225]],
    [ "843952774",[-80.50450735000001, 35.64576545]],
    [ "843952778",[-80.47602697512735, 35.61355495693975]],
    [ "844037817",[-81.02869094173496, 35.24194797029329]],
    [ "844037819",[-81.02446109307546, 35.2399709190205]],
    [ "844037832",[-81.0186201, 35.2348106]],
    [ "844037833",[-81.01622002398165, 35.23689609345777]],
    [ "844037834",[-81.02295571931315, 35.23837360439522]],
    [ "844037835",[-81.02242649000677, 35.239482120964205]],
    [ "844037836",[-81.03303843629506, 35.248348915878815]],
    [ "844037837",[-81.0297870038187, 35.24744249306278]],
    [ "844044356",[-112.1111402815857, 40.57401717830341]],
    [ "844044362",[-112.04571402536014, 40.566432945375915]],
    [ "844044382",[-112.05920744999999, 40.65367454999999]],
    [ "844044383",[-112.04629195000003, 40.6525633]],
    [ "844059190",[-81.24873957170787, 35.02270827848768]],
    [ "844059198",[-81.11787489086487, 34.99797967527686]],
    [ "844059207",[-81.02193303150663, 35.18542216686721]],
    [ "Electric Power Board of Chattanooga",[-85.24596707783722, 35.106136269874426]],
    [ "844068936",[-85.24122193886575, 35.113138441423104]],
    [ "Electric Power Board of Chattanooga",[-85.22763, 35.0651614]],
    [ "Arvinmeritor, Inc.",[-82.5147509327414, 35.41189494599556]],
    [ "844090135",[-84.94925759507072, 34.761909608242746]],
    [ "Oncor",[-102.32727489317227, 31.941534713631633]],
    [ "844099424",[-84.91753850545771, 34.125242011711194]],
    [ "Fair Bluff Substation",[-79.01751985, 34.314264449999996]],
    [ "844228807",[-84.7872384, 34.15141319999999]],
    [ "844228808",[-84.78963665, 34.150828049999994]],
    [ "844266017",[-97.34350401137938, 32.839161176592846]],
    [ "Williams Potter Substation",[-75.78084466730883, 41.76504946416171]],
    [ "844333843",[-107.7590731733936, 38.24209140248977]],
    [ "Google Substation #2",[-80.04082479325766, 33.06600129032551]],
    [ "844359208",[-115.00579046682546, 36.05552782232471]],
    [ "Stevenson Substation",[-85.8246254926576, 34.871103768056074]],
    [ "Herron Substation",[-95.3190826877509, 36.24339787460355]],
    [ "Igloo Valley Substation",[-95.31580771443828, 36.21922272483939]],
    [ "Grand River Dam Authority",[-95.28280757971578, 36.18305450070755]],
    [ "844386859",[-97.06498813859218, 32.444407352538775]],
    [ "Omaha Public Power District",[-96.15066328971032, 41.13435265031413]],
    [ "844394351",[-96.14600448854794, 41.133943724835916]],
    [ "844400275",[-87.25312469986565, 36.62503790117256]],
    [ "844416155",[-103.22222074269993, 31.313799871305356]],
    [ "844416157",[-103.15366586297549, 31.294432125024088]],
    [ "Chaves Solar Farm Sub",[-104.45337095, 33.45080630000001]],
    [ "Roswell Solar Sub",[-104.44871195837446, 33.44542141819912]],
    [ "844424125",[-103.90491215024855, 31.80802883283422]],
    [ "844424129",[-103.23999213744177, 31.80238842624508]],
    [ "Springdale Substation",[-97.16239679494649, 37.67855122511606]],
    [ "844489467",[-83.42449975706582, 38.95730098822769]],
    [ "Falcon Substation",[-116.49505052016956, 40.81576785347865]],
    [ "Wallaceville Substation",[-85.3003534, 34.92016160000001]],
    [ "844684724",[-82.35435143067546, 27.417937427861435]],
    [ "Harry Street Substation",[-97.21529377417151, 37.66527260301598]],
    [ "844751505",[-84.96555537907201, 34.75886265529825]],
    [ "844894268",[-84.51897602096538, 38.07956584675282]],
    [ "Rich Mountain Electric Cooperative",[-94.2184815, 34.553009349999996]],
    [ "845105531",[-84.75377218615871, 34.827966162054075]],
    [ "845105534",[-84.78637709269806, 34.79081597475436]],
    [ "845128897",[-115.4024712459678, 33.80725813523703]],
    [ "845140276",[-84.82290877719537, 34.764781556466886]],
    [ "Northern Indiana Public Service Company",[-85.75495825, 41.4290431]],
    [ "845179632",[-80.12556667379346, 38.94328916372165]],
    [ "845179634",[-80.15293534999999, 38.8777369]],
    [ "845261539",[-84.23869315, 38.20454175000001]],
    [ "845261541",[-84.24013442730237, 38.206065498131174]],
    [ "South Sylva Retail Substation",[-83.20525316663628, 35.35946773810766]],
    [ "Eastport Substation",[-70.99849721581727, 43.30881811791197]],
    [ "845537849",[-78.75397114641218, 34.53937914593721]],
    [ "845601021",[-88.9180701620629, 39.86622911285181]],
    [ "845601035",[-88.88924733192293, 39.8647117572911]],
    [ "845657535",[-93.54560822466237, 39.782680180274866]],
    [ "845812283",[-80.36523643272199, 41.43767661261234]],
    [ "845830649",[-85.99132262511192, 41.69504249528122]],
    [ "845849095",[-86.29296702491484, 41.655454589907926]],
    [ "845849241",[-93.53992229999999, 39.7902888]],
    [ "AEP Tulip Road Station",[-86.44856951524133, 41.69943946791528]],
    [ "845875728",[-93.53556511934455, 39.78209509870457]],
    [ "Omaha Public Power District",[-96.10141060579345, 41.22061988776192]],
    [ "Willigton Substation",[-82.46598508303417, 33.97556520051605]],
    [ "845944182",[-124.07239397499197, 40.905110695852386]],
    [ "845989873",[-86.08939139869308, 39.582150930725625]],
    [ "845989878",[-86.0662465630674, 39.62538834788155]],
    [ "Public Service Company of Oklahoma",[-95.84262179958782, 35.98771625318291]],
    [ "Southern California Edison",[-117.95739685, 33.88287255]],
    [ "846204544",[-88.55784720623302, 37.996286483438645]],
    [ "846218406",[-84.31543346491013, 35.93407857315734]],
    [ "Oak Ridge National Laboratory",[-84.27914095719134, 35.93540895841252]],
    [ "846218415",[-84.38841377625546, 35.90825878009273]],
    [ "Tennessee Valley Authority",[-84.10867839144808, 36.09351529286879]],
    [ "846227857",[-84.1138681687803, 36.08938749825605]],
    [ "PECO",[-75.41840584766165, 39.82490005351299]],
    [ "Bethabara Substation",[-83.57806147557899, 33.90153302064307]],
    [ "Rossville Substation",[-89.55393455, 35.0429872]],
    [ "Chickasaw Electric Cooperative",[-89.42172845, 35.18469725]],
    [ "Longtown Substation",[-89.48353193812164, 35.334785902691834]],
    [ "846270151",[-115.5637993599668, 32.85615497503396]],
    [ "846369888",[-88.65174673510353, 33.986213568120576]],
    [ "846369890",[-88.7384649080798, 34.01114465713813]],
    [ "846369930",[-89.43960195, 34.80067735]],
    [ "Hickory Valley Substation",[-89.13754524358163, 35.13368452108247]],
    [ "Somerville Substation",[-89.34035329128172, 35.240329997738456]],
    [ "846376737",[-89.29141366234944, 33.85586164344662]],
    [ "City of Tupelo Water & Light Department",[-88.71638691579493, 34.22643693391224]],
    [ "Chestnut Hill Substation",[-75.21807295614884, 40.7109498602981]],
    [ "Rolling Fork Substation",[-90.88414280023436, 32.88806914421463]],
    [ "846413972",[-90.81089415, 32.476360750000005]],
    [ "846413977",[-90.99585045609567, 33.02558333662898]],
    [ "846418606",[-80.63255658460754, 34.89172193159297]],
    [ "846465288",[-86.66298976532782, 33.54421103219688]],
    [ "Georgia Transmission Corporation",[-83.56147299356964, 30.829305180514254]],
    [ "Ladysmith Substation",[-77.51022705789525, 38.0110977118542]],
    [ "Cape Steam Substation",[-70.25475875302152, 43.64268089855007]],
    [ "846596308",[-82.62012317755699, 28.277492442807723]],
    [ "PPL",[-75.48718251906175, 40.5566366569442]],
    [ "Rappahannock Electric Cooperative",[-77.61342082376161, 37.98986914275829]],
    [ "846642414",[-77.36245072984414, 37.837040905641324]],
    [ "Walnut Hill (MWRA) Substation",[-71.5851549450063, 42.31116151809486]],
    [ "Woodside Substation",[-71.63076855405467, 42.33000922508503]],
    [ "Gerrish Substation",[-84.69128945000001, 44.510498250000005]],
    [ "Lake City Substation",[-85.20975319222829, 44.33822112500652]],
    [ "Rauville Substation",[-97.12329147480574, 45.07832039030505]],
    [ "Ruffin Substation",[-80.81107734945843, 32.9706994105038]],
    [ "Bulls Bridge Substation",[-73.4913343808641, 41.65904749836692]],
    [ "847252503",[-88.16699103659077, 38.15802393906353]],
    [ "Elk Mountain Substation",[-75.51722123777728, 41.70417803206307]],
    [ "Lake Benton Substation",[-96.36435966601317, 44.29940032522929]],
    [ "Charlie Interconnect Station",[-96.34298590000002, 44.2842542]],
    [ "Ivanhoe Substation",[-96.2813831035865, 44.43070746458561]],
    [ "Ivanhoe-Wilno Substation",[-96.24970285000002, 44.4670183]],
    [ "847807952",[-82.57702080828254, 36.97496848525456]],
    [ "847817916",[-73.80129920198404, 42.69354051679672]],
    [ "Scottville Substation",[-86.29389325, 43.95272015]],
    [ "847827365",[-82.60491971066843, 38.18998062432734]],
    [ "847827366",[-82.60442645216874, 38.19173879145745]],
    [ "847832411",[-82.59415795, 37.194338300000005]],
    [ "848012640",[-95.6405800190096, 40.36171869148265]],
    [ "848021013",[-114.60523776000979, 35.865519428582985]],
    [ "848044905",[-81.99962468394713, 41.477746707840154]],
    [ "848044913",[-82.05105432493792, 41.49400826665681]],
    [ "Junction City Substation",[-82.29381929429121, 39.70977537908026]],
    [ "Hocking Substation",[-82.39880801517924, 39.520068633222024]],
    [ "Anchor Hocking Substation",[-82.61851027095709, 39.7176496700611]],
    [ "Washington Substation",[-86.44047479436156, 43.944508660777764]],
    [ "French Road Substation",[-80.05865489969244, 42.09213173741154]],
    [ "848515607",[-115.12113638858723, 36.052845944904725]],
    [ "MidAmerican Energy",[-92.35649998994725, 42.54274594858582]],
    [ "Bohemia Substation",[-75.06474904569706, 41.50220151282633]],
    [ "849110263",[-87.2736569, 36.59350930000001]],
    [ "849110266",[-87.2755844, 36.59458205000001]],
    [ "849494455",[-76.16156555777849, 39.71781959250955]],
    [ "849494456",[-76.16268421567264, 39.7182294957177]],
    [ "Appeldorn Substation",[-95.93113222542068, 44.854558106607726]],
    [ "Lisbon Substation",[-95.7462456120389, 44.833818073987764]],
    [ "849599388",[-106.55203893263587, 35.05224235916159]],
    [ "Huntsville Utilities",[-86.62851060000001, 34.687676450000005]],
    [ "849806051",[-81.08244715616296, 34.832514049629076]],
    [ "849806052",[-81.0822518149217, 34.833245532604764]],
    [ "West Fraser Substation",[-82.21673869999998, 31.321917750000004]],
    [ "849816923",[-78.30103899425451, 34.528296015051694]],
    [ "849827270",[-83.66526849714563, 37.4122443080135]],
    [ "Booneville Substation",[-83.68757708392518, 37.48207027843431]],
    [ "Goodfield Substation",[-84.81371485268018, 35.49134325237489]],
    [ "849902406",[-86.00228113559568, 34.65612386982428]],
    [ "849902418",[-85.6404663754338, 34.92152432723311]],
    [ "Cardinal Glass Tomah",[-90.47916892497166, 43.988853991702385]],
    [ "849913942",[-90.42241843257177, 44.029415483983676]],
    [ "849925843",[-103.68208124848783, 31.78916062143644]],
    [ "849925851",[-103.54420905, 31.976030849999997]],
    [ "849938692",[-91.1029307263197, 44.649971194874304]],
    [ "849946984",[-111.94452580880471, 48.16714923941636]],
    [ "La Pine Substation",[-121.45425859440181, 43.66109126211696]],
    [ "850362367",[-87.15615279404324, 39.030488074027325]],
    [ "850694578",[-89.5776849, 43.7785135]],
    [ "850694579",[-89.57769479403382, 43.77916932896147]],
    [ "850740315",[-87.1521744, 39.03869855]],
    [ "Pratt & Whitney Substation",[-70.7254993854373, 43.31082651983336]],
    [ "850873518",[-82.46194332041912, 34.985638378879585]],
    [ "851111461",[-89.48134445000001, 43.8170676]],
    [ "Angel Fire Sub",[-105.28556858038874, 36.399400955549986]],
    [ "CLECO",[-91.35556019233657, 29.69763520808888]],
    [ "CLECO",[-91.19191446540852, 29.69239239835401]],
    [ "851522289",[-91.18225321884871, 29.690577707814253]],
    [ "851561407",[-91.7698796014774, 29.940022308411617]],
    [ "Kearsarge Substation",[-80.0942047605738, 42.080271293410256]],
    [ "851675252",[-90.3723438224863, 32.70786488986086]],
    [ "851675254",[-90.4095178, 32.69181275000001]],
    [ "PPL",[-75.53469763493352, 40.474593376428054]],
    [ "851695825",[-93.74076892508425, 35.49576809426688]],
    [ "Entergy Arkansas",[-93.08931803182894, 34.87375821870879]],
    [ "Entergy Arkansas",[-93.01386183985922, 34.659979529543556]],
    [ "Arglass Substation",[-83.344356, 30.79521410000001]],
    [ "851857773",[-93.9111442, 42.73212685]],
    [ "Leesville Substation",[-81.51302589415688, 33.88089376078634]],
    [ "Scott Substation",[-93.49832507339624, 42.74054976437648]],
    [ "LaBolt Substation",[-96.63847185, 45.07831085000001]],
    [ "851934138",[-83.26990966798361, 43.93840412632501]],
    [ "852121185",[-83.30864962345821, 42.07947390221764]],
    [ "852136295",[-80.73480324031624, 39.81731669624199]],
    [ "CLECO",[-89.98970034999998, 30.396363649999998]],
    [ "852183051",[-88.62710328558208, 32.36032711842087]],
    [ "Mississippi Power",[-88.70675912171852, 32.347489565993016]],
    [ "Magnolia Electric Power",[-90.11454932932133, 31.21240110472557]],
    [ "852412529",[-87.31561874045691, 39.49112079210809]],
    [ "852439451",[-96.98922832496015, 45.65791630457044]],
    [ "Sisseton West Substation",[-97.06089389999998, 45.66038714999999]],
    [ "852445035",[-97.03677987389274, 45.306681545819764]],
    [ "852480565",[-96.8332204, 45.790307999999996]],
    [ "Huntsville Substation",[-93.72289354835793, 36.09859078748938]],
    [ "Carroll Electric Cooperative Corporation",[-93.54955750173262, 36.08956851202075]],
    [ "852540822",[-111.09753747391834, 45.69357403004402]],
    [ "852568739",[-77.95752951430356, 34.277659508302854]],
    [ "Lockhart Power",[-81.45696364999999, 34.780093699999995]],
    [ "853019105",[-83.53409285561916, 43.29847282664576]],
    [ "Carnesville Substation",[-83.2198826, 34.3639317]],
    [ "853061994",[-86.61919199424239, 39.9670304142118]],
    [ "Antwerp Substation",[-84.74702748991847, 41.18023819554315]],
    [ "853102238",[-85.63628903278477, 33.521209765634254]],
    [ "853553979",[-77.48381229290105, 34.692911017547345]],
    [ "Folkstone Substation",[-77.51031217507415, 34.52559565030345]],
    [ "853554355",[-77.45021996273981, 34.75339342675424]],
    [ "Clayton Substation",[-75.0975973926643, 39.66294309858428]],
    [ "United States Steel Corp",[-86.93211825311178, 33.48450398603646]],
    [ "United States Steel Corp",[-86.93160918440019, 33.4787451804233]],
    [ "United States Steel Corp",[-86.93269947330818, 33.483921464465766]],
    [ "854092334",[-86.80927638465882, 39.96726831214968]],
    [ "Moonlight Substation",[-94.85267387205555, 38.88311748938239]],
    [ "854297638",[-85.15243080137073, 38.424609480241166]],
    [ "Eminence Substation",[-85.19642729595579, 38.366553886546754]],
    [ "854319466",[-84.95332071742602, 38.78257093420511]],
    [ "854329436",[-85.32891536689127, 38.205621640143974]],
    [ "854388233",[-85.88510878165604, 38.015018786211485]],
    [ "Esperanza Substation",[-98.66501127906841, 29.800581925395832]],
    [ "Georgia Pacific Substation",[-85.09394392818417, 31.17095129230908]],
    [ "854966444",[-86.41861837529524, 32.462120707748646]],
    [ "Ogden-Martin Nug Substation",[-77.23983519892599, 38.69650400383861]],
    [ "Elm Farm Substation",[-77.32705313275446, 38.660204111578345]],
    [ "Innovation Substation",[-77.51279865201975, 38.754639591743754]],
    [ "Fairfax Substation",[-77.3114665180103, 38.848203089390644]],
    [ "Pioneer Switching Substation",[-77.5118772352246, 38.755278670523495]],
    [ "Grant Substation",[-85.81108301026502, 43.33804106019909]],
    [ "Duke Energy Progress",[-77.28293402154797, 34.77734713854884]],
    [ "Duke Energy Progress",[-78.52593456954794, 35.779755513265044]],
    [ "855439875",[-80.66684138101766, 35.394041755886306]],
    [ "855613606",[-85.27615619999999, 31.261935549999997]],
    [ "Harrisons Mill Substation",[-84.88914700255907, 31.552672987458564]],
    [ "855658465",[-77.86699087072785, 34.251523409875766]],
    [ "Morenci Substation",[-84.21906476714634, 41.720861733951985]],
    [ "Arlington Substation",[-84.72179539947223, 31.43957924441375]],
    [ "Seafood Way Substation",[-71.03276797215338, 42.34825062693565]],
    [ "856100833",[-86.45000450000002, 37.78064695000002]],
    [ "Hayti Substation",[-97.13160542475286, 44.659487107672376]],
    [ "856156057",[-81.6000640581462, 34.49577237350036]],
    [ "Glassboro Substation",[-75.12634868456357, 39.69803228928283]],
    [ "856158504",[-106.49845122060694, 35.057383831895386]],
    [ "856164539",[-84.09803166553108, 37.158703117952086]],
    [ "Zuzax Sub",[-106.33549807114329, 35.10963544628446]],
    [ "Georgia Power",[-84.10846485000002, 31.5003247]],
    [ "State Docks Road Substation",[-85.15035085590812, 31.854807729832228]],
    [ "Flint River Substation",[-84.1378244122767, 31.60358226750869]],
    [ "Georgia Pacific Substation",[-84.06265204999998, 31.564162]],
    [ "856423534",[-84.7142404, 31.331132299999997]],
    [ "TPSS#2 Olney Road",[-77.19656894999999, 38.92286029999999]],
    [ "Becker Substation",[-86.22853584020896, 43.28312777489258]],
    [ "Maxwell North Substation",[-93.4022810395238, 41.90716042978053]],
    [ "Richmond Substation",[-64.71635126815447, 17.748622048845146]],
    [ "Willocks Substation",[-64.77565950942169, 17.716554667863267]],
    [ "856970706",[-88.99122458553126, 42.51266352496064]],
    [ "Beloit Gateway",[-88.96185813846135, 42.52526300387464]],
    [ "Lynn Station",[-84.94018866415966, 40.06276231044241]],
    [ "857143559",[-86.09663452468848, 33.54674787339374]],
    [ "CPC St. Ives Substation",[-86.28647019438247, 33.42087631187883]],
    [ "Logan Martin Substation",[-86.33796216632084, 33.42577698554516]],
    [ "South Anniston Substation",[-85.82868790000002, 33.630499400000005]],
    [ "857150894",[-85.83307447172534, 33.65342464422239]],
    [ "857150896",[-85.83592414999998, 33.65798579999999]],
    [ "Products (SE) Pipe Line Corporation",[-86.8328382190027, 33.29065944827467]],
    [ "East Chelsea Substation",[-86.65184551059068, 33.35130060528339]],
    [ "Airport Substation",[-87.62124234999997, 33.22506629999999]],
    [ "857177746",[-87.15973110720671, 33.208459420350884]],
    [ "857177752",[-86.86672656639865, 33.10014714594476]],
    [ "857177754",[-86.86182187650243, 33.09527973001273]],
    [ "Mohnton Substation",[-75.98066168912185, 40.285318514273165]],
    [ "857195847",[-75.85633373900188, 40.85773291025962]],
    [ "857195849",[-75.87678155000002, 40.855445100000004]],
    [ "Ruskin",[-89.360298689131, 43.106242721330844]],
    [ "857873381",[-96.21176801179115, 29.922138099241536]],
    [ "857881641",[-85.03539605261187, 40.062298678161675]],
    [ "857922639",[-95.30727755097452, 28.98068092656504]],
    [ "Shible Substation",[-96.0313819093904, 45.2393167077572]],
    [ "Akron Substation",[-96.19923595609886, 45.29774447508932]],
    [ "Artichoke Substation",[-96.2191948747482, 45.3984935401926]],
    [ "Fairfield Substation",[-95.97334675, 45.3835782]],
    [ "858381948",[-81.23679499986643, 28.89119528403734]],
    [ "Morgan Substation",[-94.90667755000001, 44.41276369999999]],
    [ "Burrit Street Substation",[-72.798237, 41.66929005]],
    [ "859088590",[-119.25140720783048, 47.115951708414606]],
    [ "859095192",[-86.91788502109104, 40.475886309874106]],
    [ "Hoosier Energy",[-85.8644756000159, 39.201336934918125]],
    [ "Williams Grove Substation",[-77.00996865760453, 40.1751757354896]],
    [ "Cottonwood Substation",[-95.26874029053421, 44.253203224823565]],
    [ "Redwood Substation",[-95.10795350000001, 44.4847248]],
    [ "Highwater Ethanol Substation",[-95.29353506959792, 44.231304075344894]],
    [ "Hoosac Substation",[-72.95039289963897, 42.72167387120767]],
    [ "859725891",[-116.98762459919374, 33.92581398638951]],
    [ "859760355",[-80.63690820536071, 34.966759711397486]],
    [ "Ghent Substation",[-96.04022597440934, 44.51626028941001]],
    [ "859855151",[-111.83595692158212, 33.40932002504871]],
    [ "Echo Substation",[-95.4629604, 44.6437483]],
    [ "Reynolds Substation",[-85.47280129999999, 43.385421199999996]],
    [ "Howard CIty Substation",[-85.5225233253507, 43.39539419183144]],
    [ "Vallers Substation",[-95.74709448464472, 44.61520026768177]],
    [ "Asbury Substation",[-95.5336185, 44.876552350000004]],
    [ "Pierson Substation",[-85.49736058145983, 43.32057724364308]],
    [ "Upton Substation",[-84.69569382562528, 42.74238266462502]],
    [ "860400543",[-91.85215115000001, 32.79360830000001]],
    [ "Carthage Substation",[-92.57163159140194, 34.075104724931386]],
    [ "Georgia Pacific Substation",[-91.97588950000001, 33.14375435000001]],
    [ "Dewey Substation",[-82.6755849112431, 37.76324016518819]],
    [ "City of Owensboro",[-87.05980975394762, 37.77955528487188]],
    [ "860485680",[-92.35597518341618, 33.51734354835454]],
    [ "Georgia Pacific Substation",[-92.36892565000001, 33.766335049999995]],
    [ "860487014",[-112.42543055, 34.65526320000001]],
    [ "860487017",[-112.44042103445686, 34.62984325869755]],
    [ "860655445",[-92.15483492572459, 32.4825040581333]],
    [ "Entergy Louisiana",[-92.72164017496449, 32.21677574325169]],
    [ "Entergy Louisiana",[-92.7168584603801, 32.26754392488519]],
    [ "Weyerhaeuser Company",[-92.87898981205113, 32.541767174123315]],
    [ "Minden Substation",[-93.31211747218983, 32.63624771418853]],
    [ "Claiborne Electric Cooperative",[-93.08656207963548, 32.78081289430662]],
    [ "860660995",[-93.07139115, 32.77624994999999]],
    [ "860662976",[-92.63489816622241, 31.94429959583212]],
    [ "Jen-Weld, Inc.",[-92.647813, 32.035590850000006]],
    [ "860699633",[-92.34082317497878, 31.296685570062305]],
    [ "860717315",[-93.30506824320678, 33.26794757016374]],
    [ "860761215",[-93.29472224999998, 32.6041021]],
    [ "Shelby Substation",[-90.75891026961267, 33.98275625366272]],
    [ "Entergy Arkansas",[-92.61447317495889, 33.20979628984994]],
    [ "Reed Switching Station",[-91.43175650607648, 33.68913867507426]],
    [ "860777776",[-101.12270827500352, 48.02305349050138]],
    [ "860803169",[-92.41886572192543, 31.36000269161217]],
    [ "Kentucky Utilities Company",[-83.97616262623508, 36.72636399185719]],
    [ "860868315",[-83.59479833182249, 36.894111847852635]],
    [ "Kentucky Utilities Company",[-83.82981815686604, 36.882155107247186]],
    [ "Kentucky Utilities Company",[-83.82693730000001, 36.879114449999996]],
    [ "Kentucky Utilities Company",[-83.84715354460938, 36.94027293200488]],
    [ "Paper Tap Substation",[-75.35858934705783, 39.84433733488105]],
    [ "Bergen Point Substation",[-74.1250395936161, 40.65387657318253]],
    [ "861178118",[-84.73440348213651, 37.0321154969693]],
    [ "861178125",[-84.64635325000002, 37.04833685]],
    [ "Fujifilm Substation #1",[-82.06796179999999, 34.244171449999996]],
    [ "861230367",[-82.0627098551185, 34.226003891421726]],
    [ "861320095",[-82.29105274621422, 39.12500430058728]],
    [ "Kentucky Utilities Company",[-84.79425609401156, 37.65818407976043]],
    [ "862361944",[-86.79480262299109, 40.411079232683846]],
    [ "862547548",[-75.54781883116274, 41.47249546257656]],
    [ "Rhodes Lane Switching Station",[-79.72372688850558, 40.16653162862244]],
    [ "Tensaka Westmoreland Substation",[-79.69768095151458, 40.17435014244386]],
    [ "Fort Drum Substation",[-80.79102852007804, 27.636967035587478]],
    [ "862782984",[-76.06967750495983, 41.201881316416674]],
    [ "862789089",[-77.65452938891329, 36.718935664566395]],
    [ "862801075",[-97.73351658313503, 32.3383326438327]],
    [ "862861345",[-106.49427827620804, 34.96529559267019]],
    [ "River View Coal, LLC",[-87.85117709999999, 37.72270629999999]],
    [ "First Lake Substation",[-93.82563826367814, 45.29830254270614]],
    [ "Salem Harbor Substation",[-70.87690843329833, 42.5265787235985]],
    [ "Dougherty County Solar Substation",[-84.05243836367026, 31.50979687119741]],
    [ "River View Coal, LLC",[-87.88932841738111, 37.742211502924675]],
    [ "Mountain Top Substation",[-76.08550033313983, 41.48474116601725]],
    [ "863414365",[-77.85818184156521, 34.37126185431324]],
    [ "863419839",[-93.5830895, 45.15895899999999]],
    [ "Prosperity Substation",[-81.53470134264283, 34.208666654109855]],
    [ "863547911",[-77.794601, 34.8918817]],
    [ "Vogtle 500KV Switchyard",[-81.76959734347683, 33.14500379597531]],
    [ "McIntosh Combined Cycle Facility Substation",[-81.18149039667456, 32.3487288115355]],
    [ "863618760",[-77.85788185, 35.02213545]],
    [ "863618763",[-77.7642451906134, 34.95464814960848]],
    [ "863624125",[-80.64623618150078, 35.119543546645275]],
    [ "863625877",[-78.03233709941397, 35.05705538331355]],
    [ "863662849",[-78.51332439306536, 34.97605075742615]],
    [ "863662850",[-78.51388085819227, 34.9766507804966]],
    [ "REC Park Substation",[-89.02767777903225, 42.48823847854091]],
    [ "Hickory Run Substation",[-75.62558314416859, 40.96923580074736]],
    [ "Tucson Electric Power",[-111.23438594599112, 32.3714600770486]],
    [ "863908306",[-111.28598388588736, 32.37858348651606]],
    [ "863908308",[-111.12600066729765, 32.40138231598698]],
    [ "Peachtree City Substation #2",[-84.59056355, 33.391017999999995]],
    [ "UF Substation #10",[-82.36811802286054, 29.63562532239995]],
    [ "864207228",[-84.71231826006907, 31.298457479333607]],
    [ "864234561",[-105.89634509841255, 42.777721067431685]],
    [ "864234563",[-105.87725514301883, 42.713459575207274]],
    [ "Hackettstown Substation",[-74.83439953536819, 40.853399167592116]],
    [ "Corktown Substation",[-83.06553653525748, 42.32788279789464]],
    [ "Elastimold Substation",[-74.82462839061021, 40.832293614062934]],
    [ "Sikeston Board of Municipal Utilities",[-89.62527516823823, 36.87645594592662]],
    [ "Leonia Substation",[-73.99164769486013, 40.86801746904563]],
    [ "Hardyville Substation",[-76.36773804999999, 37.55174889999999]],
    [ "White Stone Substation",[-76.39811738694328, 37.64864906521997]],
    [ "864993510",[-97.21025325958293, 33.21869332521641]],
    [ "864993512",[-97.21150461732887, 33.214980326046714]],
    [ "864993513",[-97.10757041326758, 33.19768651977004]],
    [ "865012578",[-80.73052843749147, 35.06222696262118]],
    [ "UF Substation #5",[-82.355603, 29.6446609]],
    [ "865180369",[-82.79755331826544, 43.13153733501278]],
    [ "Las Positas Substation",[-121.73341118062676, 37.700593371314156]],
    [ "Moselle Substation",[-89.30154542334387, 31.52888744129144]],
    [ "865199635",[-89.5010202738914, 31.41500564989709]],
    [ "865199643",[-89.48639416016682, 31.397587043628857]],
    [ "865199649",[-89.50177520945813, 31.41842792518742]],
    [ "Highway 42 Substation",[-89.50251635185045, 31.418588055072362]],
    [ "865199656",[-89.31031420000001, 31.28544485]],
    [ "865199657",[-89.31018814790502, 31.28493543213084]],
    [ "865199660",[-89.9465675799485, 31.601134138278034]],
    [ "Florida Power & Light",[-80.5414179, 27.237964750000003]],
    [ "Hawaiian Electric Company",[-155.03065966033023, 19.632016849204117]],
    [ "UF Substation #4",[-82.34316173208008, 29.643684159575663]],
    [ "865564875",[-97.15865798479665, 33.2499231128883]],
    [ "Georgia Power",[-84.60735153244269, 33.41928928198431]],
    [ "865722687",[-110.39026477755581, 39.520608893281725]],
    [ "865722689",[-110.47515573366088, 39.441958104069826]],
    [ "865781219",[-94.7607146658274, 39.339016056271305]],
    [ "Butte Electric Cooperative",[-103.85248931228415, 44.90812057789142]],
    [ "Marine City Substation",[-82.49173862769442, 42.72853337283332]],
    [ "866775797",[-82.8335888, 29.621481100000004]],
    [ "Christine Substation",[-96.80046242472574, 46.54214343968185]],
    [ "Great Bend-Mantador Substation",[-96.88562110000001, 46.15266745]],
    [ "Prairie 345kV Substation",[-97.11331245207255, 47.90611088187513]],
    [ "Prairie Substation",[-97.10802289712537, 47.90681928665763]],
    [ "867180955",[-79.04802515763771, 35.90244044243286]],
    [ "867329069",[-97.24979268752385, 45.863355475312126]],
    [ "Ellendale Substation",[-98.57034805840073, 46.008523774197364]],
    [ "Garden Substation",[-80.75153915119132, 41.23710477127474]],
    [ "Havasu Substation",[-109.34661947265565, 37.46482401417681]],
    [ "867874070",[-88.95359828882617, 37.62089561010473]],
    [ "867942394",[-82.35271276790682, 29.63734208979873]],
    [ "868030728",[-97.07251715483937, 46.441238821708765]],
    [ "Rochelle Substation",[-83.4572497, 31.9504149]],
    [ "Duke Power",[-81.01094004961516, 35.09056028795241]],
    [ "Enon Substation",[-77.32444573637498, 37.33975356909176]],
    [ "Enon Substation",[-77.32331193340138, 37.339625319439115]],
    [ "868988507",[-114.98272065192783, 33.65936197362738]],
    [ "868998925",[-115.00824773473933, 33.66890058224166]],
    [ "Maple Shade Substation",[-74.97101891051993, 39.94007330691194]],
    [ "BELLEVILLE",[-89.52690292518002, 42.85903875484078]],
    [ "869738681",[-114.75784646858035, 33.69177248558558]],
    [ "Public Service Company of Oklahoma",[-95.80676682145561, 36.016949464346546]],
    [ "870322069",[-91.67417719999999, 31.9475917]],
    [ "Entergy Mississippi",[-90.8602541730979, 31.45853734468416]],
    [ "870322099",[-91.40991724999999, 31.519953299999997]],
    [ "870322107",[-91.43399569548023, 31.53082771755071]],
    [ "North American Refractories Substation",[-85.76950427065206, 43.54271500550097]],
    [ "870498920",[-96.66779007459837, 43.48319849633434]],
    [ "870498929",[-96.63915083641788, 43.489018889552334]],
    [ "White Cloud Substation",[-85.74115705607328, 43.55842123311258]],
    [ "870893800",[-109.85221861616048, 35.52562550224451]],
    [ "North Lumberton Substation",[-78.98897723535286, 34.693254059837635]],
    [ "870996104",[-78.9552435, 34.80498579999999]],
    [ "Lumbee River EMC",[-78.9846433, 34.9441209]],
    [ "Hudson Substation",[-84.34396549271048, 41.85457242860812]],
    [ "871585596",[-91.48850202272551, 31.58024992590595]],
    [ "871593275",[-91.24218530949221, 31.925622835780526]],
    [ "871631797",[-106.51598923200392, 35.11096634332548]],
    [ "Jersey Central Power and Light",[-74.4055337399649, 40.68572635235657]],
    [ "New Columbia Substation",[-76.86736955637123, 41.06052097338258]],
    [ "Skylark Substation",[-83.59688114999999, 42.94250720000001]],
    [ "Porter Substation",[-96.16388818340248, 44.6334612427332]],
    [ "872065428",[-78.65660415, 34.48421355]],
    [ "872158168",[-86.8949875165672, 40.42309178646042]],
    [ "872174993",[-100.44356722509829, 45.55900714128046]],
    [ "872217303",[-93.67752068989554, 41.97899980745074]],
    [ "Riverview Substation",[-94.70864872044073, 45.65649532524591]],
    [ "Dakota Junction Substation",[-96.1535023, 48.15240335]],
    [ "Averill Substation",[-96.501401, 46.977851300000005]],
    [ "Peach Ridge Substation",[-85.76940872783032, 43.12044042450119]],
    [ "United States Army",[-85.92935674177183, 33.62676847981115]],
    [ "Jacksonville Substation",[-85.77437148062782, 33.8164435950982]],
    [ "873080605",[-85.74940815, 33.85654495]],
    [ "873083907",[-100.59147141282199, 39.0470665252083]],
    [ "Kent City Substation",[-85.7589771351629, 43.22061158071406]],
    [ "Notre Dame Substation",[-121.79630592526904, 39.73026145789512]],
    [ "Ensley Substation",[-85.62170045839055, 43.33918269888161]],
    [ "Locke Street Substation",[-69.7649591, 44.32404985]],
    [ "Wynne Industrial Substation",[-90.78903112076956, 35.23821066313806]],
    [ "Memphis Light, Gas and Water",[-89.881095, 35.02205185]],
    [ "873137532",[-81.26350244999999, 35.455785649999996]],
    [ "873137555",[-81.21152602700963, 35.60241513435084]],
    [ "873277730",[-82.11597149999997, 34.95288639999999]],
    [ "873277739",[-81.93032869000882, 34.97123518215889]],
    [ "Duke Energy",[-81.89126223066533, 35.02481312442145]],
    [ "873277746",[-81.86029844999999, 35.0399376]],
    [ "873277765",[-81.23284194965171, 35.28050804239541]],
    [ "873277775",[-81.2214183, 35.2716587]],
    [ "873277789",[-81.17858605, 35.39866295]],
    [ "873318384",[-79.34408280000001, 34.7747435]],
    [ "873318388",[-79.33295594706094, 34.80294619766736]],
    [ "American Zinc Recycling Substation",[-81.84604485627796, 35.19692359122086]],
    [ "873324088",[-81.5133146, 35.3091442]],
    [ "873324097",[-81.20998195000001, 35.301926300000005]],
    [ "873339276",[-79.34121385000002, 34.725718650000005]],
    [ "873339285",[-79.16354967731516, 34.65991591235202]],
    [ "Newport Substation",[-83.21055082861656, 35.98825040831735]],
    [ "Hart 88th Ave",[-86.33782756766152, 43.68932826932249]],
    [ "Oceana Substation",[-86.33846330099354, 43.68863424578683]],
    [ "WestRock",[-85.03239516667814, 32.176303156373905]],
    [ "874418277",[-84.42333944999999, 31.759053899999994]],
    [ "Smithville Substation",[-84.25576063407816, 31.904788958487874]],
    [ "874421646",[-85.15323079354691, 31.916680811726145]],
    [ "Georgia Power",[-85.02098081372365, 32.42474687022952]],
    [ "874421662",[-84.98149558188977, 32.43341272386012]],
    [ "Columbus Water Works Substation",[-84.97670429504983, 32.409991167665694]],
    [ "Georgia Power",[-84.98945854999998, 32.2999221]],
    [ "Cleveland Utilities",[-84.88156142462218, 35.13412953565329]],
    [ "Cleveland Substation",[-84.82135172999072, 35.18428409181897]],
    [ "Cleveland Utilities",[-84.85862446079324, 35.16513454042955]],
    [ "Cleveland Utilities",[-84.87611559937599, 35.152669648944475]],
    [ "Cleveland Utilities",[-84.89797803390329, 35.13338181399146]],
    [ "Pittman Corner Substation",[-79.29456496437535, 34.36856610276539]],
    [ "874466950",[-79.12114028346924, 34.508330249383974]],
    [ "874466951",[-79.12211856552788, 34.50917905552391]],
    [ "874476373",[-78.61467750571258, 34.6203732654728]],
    [ "Adams Windtower Substation",[-94.71854270000001, 44.936381649999994]],
    [ "Rothsay Substation",[-96.27865260000002, 46.47150365]],
    [ "874917553",[-106.50003396692637, 35.100607388346745]],
    [ "Arthur Substation",[-85.8862958409149, 43.05372434876163]],
    [ "874958658",[-78.30956719808468, 34.35808756785166]],
    [ "Mayfair Substation",[-83.73405535688818, 43.064404711952]],
    [ "Wythe Substation",[-76.57161554829855, 40.05893996741868]],
    [ "Elizabethtown Substation",[-76.60554691955151, 40.1454112273413]],
    [ "Rheems Substation",[-76.5733948, 40.1336661]],
    [ "Landisville Substation",[-76.42328025, 40.10170564999999]],
    [ "875244221",[-76.03388115, 40.319513500000006]],
    [ "PPL",[-76.1352867, 40.26401084999999]],
    [ "Interchange Substation",[-76.74281045000001, 40.02600955]],
    [ "Donegal Substation",[-76.52002762481422, 40.0896868029488]],
    [ "Alcoa ME Substation",[-76.37440035, 40.29324775]],
    [ "875340103",[-76.31250163598988, 40.36525877200391]],
    [ "Myerstown Substation",[-76.2989592, 40.367514650000004]],
    [ "Kentucky Utilities Company",[-84.59985932839447, 37.0614866924973]],
    [ "875340510",[-84.36694835232215, 37.35396784838518]],
    [ "875340525",[-84.06079563396783, 37.09387376709857]],
    [ "875340527",[-84.0519428, 37.05972505]],
    [ "Pineville",[-83.7580832766386, 36.797802126156704]],
    [ "Appalachian Power Company",[-81.97983359604011, 36.68721568342027]],
    [ "Apple Substation",[-86.10606562686313, 43.23519457322827]],
    [ "West Waynesboro Substation",[-77.59245140278426, 39.757823363717755]],
    [ "Wadmalaw Substation",[-80.17157047800211, 32.665872856819405]],
    [ "Pilot Butte Power Plant",[-108.78639607246052, 43.21889686388891]],
    [ "Georgia Power",[-84.2565391, 33.2496034]],
    [ "Texas Eastern Substation",[-77.6798574534816, 39.89113128782813]],
    [ "City of Harrisonburg",[-78.85689384079875, 38.46378868634934]],
    [ "White Swan Substation",[-120.78709535284537, 46.38943067177979]],
    [ "Commerce Substation",[-112.10916588304744, 33.65983002977992]],
    [ "Patrick's Creek Substation",[-123.86465385898553, 41.881413734958116]],
    [ "White Oak Substation",[-77.35899088377971, 38.29956269834746]],
    [ "877296533",[-96.6377290669868, 45.31957216633006]],
    [ "877354294",[-78.59853297944427, 34.33515989630426]],
    [ "877354296",[-78.52281322586744, 34.339095305287316]],
    [ "877363973",[-118.28881525030532, 34.716154221274124]],
    [ "Tafton Substation",[-75.17973266592382, 41.38831877799449]],
    [ "877617829",[-89.80888657507965, 43.17396084214008]],
    [ "East River Electric Power Cooperative",[-96.58223786249914, 44.544211874979474]],
    [ "877661278",[-81.17286808764506, 35.31436603382264]],
    [ "877661283",[-81.3139085749832, 35.232446381570604]],
    [ "877661293",[-81.88503965074915, 35.01280991670685]],
    [ "Products (SE) Pipe Line Corporation",[-81.87854806954553, 34.92532679688852]],
    [ "877687619",[-105.86911202027659, 37.464883251266976]],
    [ "877854095",[-80.97315265, 34.977066300000004]],
    [ "877854096",[-80.96806483315058, 34.97562459964869]],
    [ "Mendoza Substation",[-108.61683892209781, 35.538115292964]],
    [ "Pittsboro Substation",[-86.44383722627035, 39.86079525550635]],
    [ "Lake Benton Power Partners Bravo",[-96.40365293828059, 44.327097024845315]],
    [ "878028266",[-87.72500598973537, 39.001983029319035]],
    [ "878028267",[-87.72765181628922, 38.99589866641516]],
    [ "878028276",[-87.50883937499069, 39.05895079319594]],
    [ "878028295",[-87.41953083392046, 39.36106922494633]],
    [ "878028311",[-87.39113115117244, 39.53565854746491]],
    [ "878028316",[-87.39101687120947, 39.731792627473496]],
    [ "878028342",[-86.480491903736, 40.052670354354596]],
    [ "878029417",[-88.50689155771383, 38.756556264804594]],
    [ "Burlington Generating Station",[-91.11821415717944, 40.74113177010597]],
    [ "Fort Custer Substation",[-85.27592645558066, 42.34204719385827]],
    [ "Silverbrook Substation",[-75.59480919861434, 39.752442290733995]],
    [ "878184879",[-100.92812720000002, 47.86208920000001]],
    [ "878412002",[-116.1272793249838, 32.62416020433552]],
    [ "Appalachian Electric Cooperative",[-83.54072797225056, 36.03029123934449]],
    [ "Cobbs Creek Substation",[-78.18871714203918, 37.73484475419569]],
    [ "878636642",[-101.28908985000001, 48.02262385000001]],
    [ "Lennon Road Substation",[-83.771263960844, 42.98663977505957]],
    [ "878718636",[-110.96089954965699, 32.02392645171232]],
    [ "Argo Substation",[-86.53523097758581, 33.67941458401485]],
    [ "Kedron Substation",[-84.59199466898487, 33.44260489398825]],
    [ "Bottom's Mill Substation",[-85.64665001525863, 31.50505128480186]],
    [ "878885870",[-113.4852444029509, 37.08065480472897]],
    [ "878912960",[-81.68100203321548, 33.2900801536886]],
    [ "878912965",[-81.64375081709397, 33.290135647144815]],
    [ "Pump Station #3 Substation",[-81.75208155, 33.201805799999995]],
    [ "Shaw Industries Substation",[-81.15870885, 34.0460379]],
    [ "878912987",[-81.6804972286297, 33.28865757122848]],
    [ "878912991",[-81.4757182840118, 33.24893168221781]],
    [ "878912994",[-81.66492419587888, 33.21321803300239]],
    [ "C Reactor Substation",[-81.67729454999998, 33.2517442]],
    [ "Electric Power Board of Chattanooga",[-85.14816017982432, 35.052273766210064]],
    [ "879148252",[-121.95657676173309, 37.38516645497962]],
    [ "Jones-Onslow EMC",[-77.4007833804045, 34.56257217488819]],
    [ "Jones-Onslow EMC",[-77.45003842424248, 34.56315481405813]],
    [ "Folkstone Substation",[-77.58939571456735, 34.57840804142116]],
    [ "Linn Street Substation",[-93.79998715, 45.304398649999996]],
    [ "Alabama Power",[-86.9953321828302, 32.33801210310993]],
    [ "Comer Primary Substation",[-83.11525083965161, 34.066538375479254]],
    [ "Georgia Power",[-83.20277669999999, 34.1022533]],
    [ "Neeseneese Substation",[-83.31896793864178, 34.06638473587378]],
    [ "Harvell Substation",[-77.3720376134585, 37.25651767981672]],
    [ "South Substation",[-95.11162042508028, 44.533208093146236]],
    [ "Pahala Substation",[-155.4732031, 19.19532855]],
    [ "Florida Power & Light",[-81.81462056637024, 26.65136872865216]],
    [ "879473553",[-102.74654175783161, 46.65671790886126]],
    [ "879473558",[-103.07257509525587, 46.65744778262918]],
    [ "Florida Power & Light",[-81.79391285, 27.31674095]],
    [ "Chestnut Substation",[-83.31074409749257, 35.94096918092823]],
    [ "New Market Substation",[-83.58235007184261, 36.09296830079263]],
    [ "879480005",[-82.38527702505158, 27.784716210420097]],
    [ "879480007",[-82.39755194667207, 27.798539377951833]],
    [ "879480010",[-82.24387029434604, 27.776842999216434]],
    [ "Aspen Substation",[-82.25300248578634, 27.77617790653977]],
    [ "Lithia Solar Substation",[-82.17179475538478, 27.757744691815784]],
    [ "879493601",[-85.3747985, 32.62466945]],
    [ "879493603",[-85.34192040000002, 32.60555455]],
    [ "Alabama Power",[-84.99962065303285, 32.45824222132963]],
    [ "879874912",[-80.56656204999999, 37.11741949999999]],
    [ "879931328",[-77.7855998439311, 38.038048811692434]],
    [ "879931334",[-76.96409274771658, 37.892425061486264]],
    [ "Fort Campbell Directorate of Public Works",[-87.4390344718494, 36.64785145687192]],
    [ "CPC Flat Rock Substation",[-77.81999034739077, 37.50670970374883]],
    [ "880346216",[-77.95955644315617, 37.45414832725718]],
    [ "880352534",[-78.42231684665461, 37.83802113160134]],
    [ "Rappahannock Electric Cooperative",[-77.81959440224504, 37.87330413290436]],
    [ "Alberta Substation",[-96.05549425000002, 45.5566971]],
    [ "Rappahannock Electric Cooperative",[-77.26045059069062, 37.79878333592197]],
    [ "880370095",[-77.16454189999999, 37.754669199999995]],
    [ "Clay Center Public Utilities",[-97.12786327411754, 39.374347822119255]],
    [ "880410751",[-98.9287533, 38.422377899999994]],
    [ "Midwest Energy",[-99.36136887484395, 38.93052647653983]],
    [ "Southern California Edison",[-116.92008098272788, 33.73630541599927]],
    [ "880731452",[-98.10198369217741, 45.36960154310824]],
    [ "Fayetteville Public Works",[-78.95571848622136, 35.0601092438709]],
    [ "Shipman Substation",[-78.83696815, 37.7256986]],
    [ "Esmont Substation",[-78.61030923818235, 37.8266130737862]],
    [ "Walton Park Substation",[-79.05704452335667, 37.49477618546026]],
    [ "Monroe Substation",[-79.12364466954, 37.49006906893376]],
    [ "880912736",[-81.86996957663581, 41.29645378487817]],
    [ "Garretson Substation",[-96.5717857717914, 43.69572717951456]],
    [ "881117560",[-96.56779838408337, 43.87675327534927]],
    [ "Fayetteville Public Works",[-78.86102363147222, 35.14846882175005]],
    [ "Dupont Substation",[-77.43846793574882, 37.45320179161243]],
    [ "881174468",[-81.17665967150829, 35.241828330827865]],
    [ "881219463",[-84.63271940138408, 31.369417189104453]],
    [ "881462238",[-103.11473275053014, 48.02469385332976]],
    [ "881462292",[-103.19680593626389, 47.977631978025066]],
    [ "881509149",[-80.88604117512683, 35.71226714285897]],
    [ "Virginia Electric and Power Company",[-76.44413090704245, 37.2601434233441]],
    [ "881631197",[-103.65433460326037, 48.032419375905434]],
    [ "881761757",[-94.81318839822531, 43.81885825020793]],
    [ "881761759",[-94.81533979190303, 43.82064914599827]],
    [ "881761767",[-94.94787165, 43.848452300000005]],
    [ "Mission Valley Power",[-114.11373901481565, 47.601844377629824]],
    [ "881840665",[-81.21251920943573, 36.134271744113775]],
    [ "Silver Lake Substation",[-95.81428831275034, 46.326695669116134]],
    [ "882367100",[-115.40095775012138, 33.800667188477206]],
    [ "882406817",[-102.95632582104683, 48.03473280595176]],
    [ "Idaho Power",[-116.20074040461338, 43.66660882343538]],
    [ "882490300",[-94.15564155932451, 43.718584094156284]],
    [ "882490302",[-94.44854929135661, 43.72393069792389]],
    [ "State Mill Substation",[-97.05519569999998, 47.93806564999999]],
    [ "Cal Young Substation",[-123.0853112257646, 44.08803338238905]],
    [ "882835104",[-88.06787662876279, 40.27891212568991]],
    [ "Colby Substation",[-93.2916488722472, 43.25408716989785]],
    [ "Winnco Substation",[-93.9015946392216, 43.38517625002703]],
    [ "Ledyard Substation",[-94.10453990004689, 43.43107325560574]],
    [ "Chesterfield Substation",[-77.3825592080674, 37.38188535158669]],
    [ "Walthall Substation",[-77.39925274689924, 37.30360335196109]],
    [ "Virginia Electric and Power Company",[-77.4122096443202, 37.232860188042096]],
    [ "883050009",[-77.69054206291968, 36.99927740462001]],
    [ "883050011",[-77.47570965, 37.0907136]],
    [ "883050013",[-77.56613505402349, 37.271596710133785]],
    [ "883102401",[-111.3445772824369, 47.51663322217655]],
    [ "883251252",[-112.658228243042, 43.5944843251879]],
    [ "883251260",[-112.70326449999999, 43.846442950000004]],
    [ "883297212",[-114.35886006633534, 43.254225421992714]],
    [ "883406851",[-116.4733257193345, 43.876113005372225]],
    [ "883689444",[-104.22072839994387, 39.012365012806846]],
    [ "883698585",[-116.57370736342277, 43.59112249353795]],
    [ "883698603",[-116.56274464999997, 43.6081574]],
    [ "Twin Valley Substation",[-75.86348109230119, 40.15009302763348]],
    [ "883809868",[-81.84632399896283, 35.31259343335217]],
    [ "883809870",[-81.91673815825149, 35.3467606516004]],
    [ "Turner Shoals Substation",[-82.18554152691647, 35.33443897009281]],
    [ "883809881",[-82.20231212242162, 35.37709223951677]],
    [ "883813202",[-81.85867530451813, 35.32513682372548]],
    [ "883831523",[-81.27780930886382, 35.28293348551344]],
    [ "883844667",[-81.2437741337445, 35.45193723791227]],
    [ "883844670",[-81.39028699411645, 35.37254591390096]],
    [ "Stillwater",[-114.56651542087702, 48.545840558076954]],
    [ "Tabor Substation",[-96.8698120115786, 48.0069263801241]],
    [ "Boston Square Substation",[-85.6388072996617, 42.93514170565886]],
    [ "National Welders Substation",[-77.29771815000001, 37.3383096]],
    [ "Brickyard Substation",[-77.50791929999998, 38.73394159999999]],
    [ "Winters Branch Substation",[-77.50680777593239, 38.73307449750969]],
    [ "Chaffee Substation",[-85.6470351096815, 42.898895474975724]],
    [ "Shaffer Substation",[-85.58762866235047, 42.90950414619202]],
    [ "884003514",[-84.84229514491, 38.196449631513275]],
    [ "884003515",[-84.84320447741564, 38.19656508260085]],
    [ "Behnke Substation",[-85.04428258867205, 41.92739027339983]],
    [ "TriMet",[-122.58411929378444, 45.584949780664815]],
    [ "884192013",[-69.78679032967159, 44.308424545280765]],
    [ "Ulen Substation",[-96.30119865000002, 47.04915129999999]],
    [ "884220176",[-111.02106358882247, 45.69135123063997]],
    [ "884225121",[-121.7052313120383, 37.68234888405977]],
    [ "Bellota Substation",[-121.0136158908693, 38.01570511243338]],
    [ "884300901",[-97.58195388012089, 31.43776831378991]],
    [ "884303553",[-98.3545034364082, 32.374787081020486]],
    [ "884303554",[-98.35454551683468, 32.374201602702215]],
    [ "884499106",[-85.39823475, 41.80872805]],
    [ "884560947",[-84.29865056147096, 37.754494889096186]],
    [ "Middletown Tap",[-74.42842432502127, 41.421294052449795]],
    [ "884660321",[-74.27654509580566, 41.34213332109028]],
    [ "Wilmot Substation",[-96.86292662385256, 45.412626603828066]],
    [ "884750456",[-97.11744079716668, 45.31192457743345]],
    [ "Station 8210",[-78.07446719999999, 42.2950207]],
    [ "884828831",[-84.38789416670765, 31.306059735271386]],
    [ "Oklee Substation",[-95.85875412503012, 47.84075895898964]],
    [ "Elba Switching Station",[-86.08065198599404, 31.412955507755377]],
    [ "Opp Industrial Substation",[-86.24309624177609, 31.266633125681654]],
    [ "884871351",[-86.48008692986892, 31.40361194601892]],
    [ "884871353",[-86.47867129303414, 31.40207976997169]],
    [ "Gantt Substation",[-86.47670756891068, 31.3985824861835]],
    [ "Perimeter Substation",[-77.50774413534772, 38.95718666478698]],
    [ "Wakeman Substation",[-77.50712306590223, 38.729666619760245]],
    [ "NOVEC Railroad Electric Distribution Center",[-77.53561340995056, 38.77751948411821]],
    [ "Salem Substation",[-85.84919545791644, 42.72760844518682]],
    [ "Georgia Power",[-84.40442384409288, 33.76301295004774]],
    [ "884957559",[-84.74055238897522, 37.81724932393646]],
    [ "884963267",[-84.72105710865115, 38.01253733723032]],
    [ "Goodwin Substation",[-85.64784363367734, 42.664487774489274]],
    [ "884985686",[-84.46031648222916, 38.04867991443354]],
    [ "884990372",[-84.49367771655753, 38.06514930165156]],
    [ "Northside Substation",[-86.49134004999999, 31.325606399999995]],
    [ "Point A Substation",[-86.522124, 31.365338350000002]],
    [ "885300517",[-85.98674509030525, 31.78200605188022]],
    [ "885314894",[-86.48979709179187, 32.463993421038204]],
    [ "885323793",[-84.72509237189033, 38.06100516946362]],
    [ "885416624",[-103.05162251724788, 39.12721671611744]],
    [ "885513920",[-86.84035677910713, 32.30968404045716]],
    [ "885530393",[-87.62540479016191, 31.96592002503661]],
    [ "International Paper Company",[-87.4817336253988, 31.970837737370193]],
    [ "885699448",[-84.4930467269137, 38.007547348553366]],
    [ "Ackley Substation",[-93.05527378737817, 42.56375790904522]],
    [ "Quinn Switching Station",[-93.29972732212285, 42.79525837508318]],
    [ "Killdeer Substation",[-93.29323038376376, 43.100148352548985]],
    [ "Pease Substation",[-121.66101476687602, 39.16992224323737]],
    [ "Sacramento Municipal Utility District",[-121.57734247423889, 38.689494109561096]],
    [ "Cats Eye Substation",[-95.9563230351967, 46.00612017494689]],
    [ "Wendell Substation",[-96.10380348375352, 46.03628771704953]],
    [ "Hancock Substation",[-95.79204729024096, 45.5018605525463]],
    [ "885948297",[-84.25247983887164, 38.02218622203344]],
    [ "Jerry L. Plagge Collector Substation",[-93.41852603260283, 42.775623091820265]],
    [ "Colorado Highlands Wind Substation",[-102.76515671522235, 40.74331394836295]],
    [ "886162018",[-86.44184490595435, 32.46009896653107]],
    [ "886162019",[-86.39623665, 32.4704381]],
    [ "886162022",[-86.4403058505111, 32.441195576563814]],
    [ "886162024",[-86.39738453566824, 32.34346142425936]],
    [ "Dublin Switching Station",[-86.11994903098392, 32.024828002510276]],
    [ "Sumrall Substation",[-89.54718918389547, 31.41780273646586]],
    [ "Georgia Power",[-84.3938236440226, 33.76502193928183]],
    [ "Oakdale Substation",[-71.80277546549974, 42.38569042996687]],
    [ "886463192",[-102.07412394890322, 46.83731710594614]],
    [ "886463193",[-102.07453804622816, 46.83895979803963]],
    [ "886504097",[-96.47036769169041, 32.106178797362055]],
    [ "886504098",[-96.47013335152675, 32.10526071469995]],
    [ "Galchutt Substation",[-96.7355172, 46.38441529999999]],
    [ "Kindred Substation",[-96.94977549999999, 46.630829500000004]],
    [ "Peetz Table Wind Energy Center County Road 76 Substation",[-103.21666862009349, 40.977549386498815]],
    [ "886599251",[-95.97703610854008, 32.27845332346503]],
    [ "886671234",[-87.19797855, 41.17352185000001]],
    [ "Franklin County Wind Farm",[-93.23276243975818, 42.62772725320591]],
    [ "Wellsburg Wind Project",[-92.91700239664657, 42.38266699481123]],
    [ "Westphalia Substation",[-84.75890312245188, 42.93702587916088]],
    [ "Citizens Electric Company of Lewisburg",[-76.90499602421265, 40.96207689346365]],
    [ "Lewisburg Substation",[-76.90505556620849, 40.96270484126288]],
    [ "Trowbridge Substation",[-85.86902619527147, 42.44057532749309]],
    [ "887647687",[-87.99692125525426, 40.76469815080999]],
    [ "Seminary Highway 535 Substation",[-89.48515237235245, 31.580023288761435]],
    [ "887982308",[-82.51807506277476, 28.880865678038113]],
    [ "West Lancaster Substation",[-76.37587033346159, 40.02180281537421]],
    [ "Dundee Substation",[-91.57917229398603, 42.556009611927266]],
    [ "Liberty Substation",[-91.09478005618448, 42.543832273916976]],
    [ "Hickory Creek Substation",[-91.0189954867497, 42.545651112794026]],
    [ "888016147",[-106.598040663181, 31.931347876559318]],
    [ "888021032",[-96.45670437897023, 33.35256339979756]],
    [ "888023955",[-95.86188913165554, 32.53772717870158]],
    [ "Campus Sub",[-87.03814338703646, 41.46597203296727]],
    [ "888264814",[-82.51735599999998, 28.8307779]],
    [ "888264815",[-82.51836557488093, 28.830485340677665]],
    [ "888316353",[-95.56584626682618, 44.822928451185874]],
    [ "888320311",[-88.91038622956036, 40.53113946087445]],
    [ "Wobegon Trail Substation",[-94.69374855757933, 45.663865862037305]],
    [ "Calaveras Substation",[-121.86599894999999, 37.574690600000004]],
    [ "888534023",[-94.91202372512214, 45.76150053841191]],
    [ "888622067",[-86.32520521378191, 31.00585307065624]],
    [ "888622070",[-86.31835623959662, 31.002170551703628]],
    [ "888722278",[-109.6834902432009, 48.55384492320548]],
    [ "888793754",[-110.70501228392592, 44.97868126057685]],
    [ "PPL",[-76.42226843552022, 40.069827426877225]],
    [ "889188468",[-77.00248435, 40.22251715000001]],
    [ "Port Matilda Substation",[-78.04632141929476, 40.79891657732496]],
    [ "Commercial Metals Substation JEA",[-81.756077274689, 30.34698844242126]],
    [ "889336341",[-91.9809067753041, 40.74048019193619]],
    [ "Oakfield Substation",[-68.05196668112056, 46.050638474814605]],
    [ "889360940",[-97.0016936, 45.45635475]],
    [ "889360942",[-97.02078857502119, 45.5879186923767]],
    [ "889360943",[-97.24669987176459, 45.47510557500273]],
    [ "Otter Tail Power Company",[-96.73653289999999, 45.8783649]],
    [ "Tennessee Valley Authority",[-87.48011830000002, 35.77120815]],
    [ "West Freemont Substation",[-83.13840428954234, 41.34453494111921]],
    [ "Elberfeld North Substation",[-87.40608826497966, 38.18080507247867]],
    [ "889403070",[-84.29040484999999, 37.734494649999995]],
    [ "889403071",[-84.28408455886898, 37.74213902830446]],
    [ "Otter Tail Power Company",[-97.29203325, 45.8631138]],
    [ "889425192",[-84.26034007374415, 37.916592915291396]],
    [ "DTE Energy",[-83.37846632975038, 42.72879001122007]],
    [ "889500668",[-81.20521875576411, 39.64673585537174]],
    [ "Sacramento Municipal Utility District",[-121.37931111036957, 38.51941968307688]],
    [ "Twin Brooks Switching Station",[-97.0282504326853, 45.206986478515375]],
    [ "Astoria Switching Station",[-96.5748946598098, 44.58108783111489]],
    [ "Dakota Range Substation",[-97.1038193534454, 45.26512532186722]],
    [ "Indian River Substation",[-80.56322496895531, 27.575269586825783]],
    [ "Bingham Substation",[-69.69064496576422, 45.1445398932236]],
    [ "Deuel County Switching Station",[-96.53965373511666, 44.86456796464938]],
    [ "Roberts County Substation",[-97.02231641409088, 45.77160476881312]],
    [ "889978037",[-118.1787355537777, 38.542046412309084]],
    [ "889987865",[-84.84661544311088, 38.21792287379719]],
    [ "890014845",[-109.69332550020737, 48.53890401544586]],
    [ "Court Substation",[-93.30006929133008, 41.0158777630296]],
    [ "890259951",[-96.92905583150451, 44.99292833141092]],
    [ "890259953",[-96.92125762504264, 45.04363800364991]],
    [ "890259955",[-96.50353004549079, 45.282224922584206]],
    [ "Wolftown Substation",[-78.3314386, 38.34951685000001]],
    [ "O'Brien County Substation",[-95.58168815434298, 43.207827805164484]],
    [ "Upland Prairie Wind Farm",[-95.34951501542434, 43.207532595896225]],
    [ "MidAmerican Energy",[-95.34943045454317, 43.20616470362784]],
    [ "Palo Alto Wind Farm",[-94.61763972146873, 43.19169687118656]],
    [ "890496763",[-82.79196155526368, 34.716951267898004]],
    [ "890496769",[-82.75030825124513, 34.958053016787794]],
    [ "890496770",[-82.75024179999998, 34.95744024999999]],
    [ "890496771",[-82.69159803393363, 34.889291682900485]],
    [ "890496789",[-82.49887017149845, 35.39111025530456]],
    [ "Easter Lake Substation",[-93.5569936576373, 41.548603175099004]],
    [ "890580325",[-94.8497436364686, 39.97363457500191]],
    [ "Cashtown Substation",[-96.44191005944593, 45.29917048626681]],
    [ "890802174",[-76.41089950207687, 43.31333716714891]],
    [ "Lake Ann Substation",[-85.87621168514437, 44.733134667423236]],
    [ "Hawley Municipal Substation",[-96.31788462915591, 46.88118045731824]],
    [ "Hawley Rural Substation",[-96.28222595793571, 46.833684520910815]],
    [ "Lake Park Substation",[-96.17524558074585, 46.83325043671058]],
    [ "Clyde",[-76.8736704375681, 43.08254386524453]],
    [ "Station 192",[-76.82638290000001, 43.2240628]],
    [ "890854968",[-109.71698869680917, 32.81207934756712]],
    [ "890959611",[-85.65239535691859, 37.926321570770746]],
    [ "890959617",[-85.60836444075063, 37.97166452174654]],
    [ "890959618",[-85.60680039486343, 37.97124557275515]],
    [ "Industrial Park Substation",[-94.45757952915703, 41.31661652447898]],
    [ "890979726",[-94.4605076638808, 41.30351242488091]],
    [ "Pickwick Electric Cooperative",[-88.61791307974718, 35.2016169676468]],
    [ "Cherokee Substation",[-87.97206204634558, 34.743926772481444]],
    [ "891032209",[-84.1576130307835, 33.93553254909245]],
    [ "891032215",[-84.15656827056495, 33.93574714274387]],
    [ "Fergus Falls Pipeline Substation",[-96.14194346313758, 46.311055186926296]],
    [ "Fergus Falls N Cleveland Substation",[-96.0733211, 46.3036391]],
    [ "North Baldwinville Substation",[-72.07088210080119, 42.61352696682723]],
    [ "891134193",[-86.78327614999999, 33.40371465]],
    [ "891339161",[-80.37126494630209, 34.98805052748281]],
    [ "Sappi Hinckley Substation",[-69.6462607416908, 44.70344937489468]],
    [ "Crystal Lake Substation",[-71.99651306016206, 42.58618460700312]],
    [ "Kentucky Utilities Company",[-84.84175751794943, 37.77940484176473]],
    [ "East Westminster Substation",[-71.86607983172819, 42.54824281609632]],
    [ "Jersey Central Power and Light",[-74.17805591680764, 39.98891329509506]],
    [ "Kentucky State Hospital Substation",[-84.75813209036318, 37.703161875618534]],
    [ "Kentucky Utilities Company",[-84.8234807830525, 37.63383725240943]],
    [ "891384785",[-84.92995486007908, 38.07050417091182]],
    [ "891392055",[-84.9068820002139, 37.25779196666656]],
    [ "891398638",[-84.96416618518656, 37.21894901473735]],
    [ "891408034",[-93.22817068795898, 43.11304247496168]],
    [ "Weakley County Municipal Electric System",[-88.84540407777985, 36.361955293833724]],
    [ "891561307",[-85.474289603, 37.89733836257228]],
    [ "891561308",[-85.55149860057327, 37.90919284091219]],
    [ "Sikeston Board of Municipal Utilities",[-89.59614706495576, 36.86280762862785]],
    [ "891562918",[-87.47740073459376, 36.847871952703805]],
    [ "Deerfield Substation",[-83.78474209830259, 41.88801266446417]],
    [ "Bredow Substation",[-83.30598369240307, 42.164946925150666]],
    [ "891687196",[-122.18586495236003, 37.42817792666147]],
    [ "891694615",[-115.0213013, 36.11022595]],
    [ "891694617",[-115.04646674476501, 36.088557824997224]],
    [ "891707170",[-85.61450217886903, 38.02688795636715]],
    [ "891735168",[-91.21668457733837, 39.71225928634607]],
    [ "891738580",[-84.53627175632218, 38.15016322057987]],
    [ "891759519",[-95.48785897645551, 44.80189561055638]],
    [ "Holliston Substation",[-71.40092757542052, 42.20661112248598]],
    [ "Saxonville Substation",[-71.38633562981624, 42.32416926240625]],
    [ "Rosewood Substation",[-95.67545774999999, 45.021915299999996]],
    [ "891998352",[-81.5615683038611, 28.31352276609149]],
    [ "Ada Substation",[-96.50004446697562, 47.295892720211896]],
    [ "Ada Substation",[-96.54371280000001, 47.2957715]],
    [ "892082124",[-95.7474402881588, 45.28146113133054]],
    [ "892100352",[-95.28881462469337, 43.805311642142456]],
    [ "Center Street Station 379",[-74.37646858322015, 42.95801413460863]],
    [ "Maynard Substation",[-71.43075359192436, 42.43646001618644]],
    [ "Kentucky Utilities Company",[-84.50939149488653, 38.055571600291636]],
    [ "892134739",[-83.9363504430655, 42.45949482479727]],
    [ "Watson Substation",[-95.87853794975518, 45.018842176259916]],
    [ "892430061",[-78.18346601346174, 38.90590718598577]],
    [ "Woodbine Substation",[-74.02403689999687, 40.299669801719986]],
    [ "892470806",[-102.48193154485607, 48.18171330109779]],
    [ "Endeavor Wind",[-95.4166563834743, 43.4311464250526]],
    [ "Cayler Substation",[-95.24036444919301, 43.34713585529027]],
    [ "Sauk Centre Substation",[-94.9585840179331, 45.72372097503244]],
    [ "892778383",[-94.82332401685834, 45.67313291647384]],
    [ "Millwood Substation",[-94.71575729393531, 45.680197174883354]],
    [ "Lake Leelanau Substation",[-85.70816451153627, 44.988668125126246]],
    [ "Idaho Power",[-116.35360327159871, 43.560668389688644]],
    [ "West St. Cloud Substation",[-94.27560312996901, 45.564778216992444]],
    [ "East Main Street Substation",[-71.59454024164023, 42.288783718278545]],
    [ "Centech Substation",[-71.69101832040812, 42.2550444211118]],
    [ "Meeker Cooperative Light & Power Association",[-94.71760275, 44.9364712]],
    [ "893064883",[-94.56744090000001, 44.964503799999996]],
    [ "Water Plant Substation",[-95.15159775000001, 45.098128100000004]],
    [ "Belknap Substation",[-86.005337955523, 42.68075682022474]],
    [ "893199201",[-84.26767342741299, 37.74280107525303]],
    [ "Kentucky Utilities Company",[-84.37910974719657, 37.90310308841476]],
    [ "Sloan Canyon Switchyard",[-115.01154869597949, 35.83361821984934]],
    [ "893399949",[-88.89988854637384, 39.02029554402448]],
    [ "893455699",[-123.30824321815773, 46.0128842305998]],
    [ "893685124",[-86.35282596609278, 35.8492850330513]],
    [ "Hannah Substation",[-85.63510937518282, 44.59912730433676]],
    [ "Riverside Substation",[-96.08409558144874, 44.90708108572438]],
    [ "MidAmerican Energy",[-96.17610388036933, 42.775451348537146]],
    [ "Little Sioux Substation",[-95.62523641787989, 42.64807143515796]],
    [ "East Kentucky Power Cooperative, Inc.",[-84.91151801650544, 37.321998397837504]],
    [ "Stark Substation",[-91.79501284999999, 41.981811650000004]],
    [ "Lawrence Energy Center",[-95.268922910817, 39.00739518040349]],
    [ "Glaciers Edge Wind Project",[-95.8483676530888, 42.857776712124746]],
    [ "MidAmerican Energy",[-95.84654573602617, 42.85817333816664]],
    [ "Florida Power & Light",[-82.37651888859422, 27.007669779900347]],
    [ "Viley Road",[-84.54935884226643, 38.07668372375106]],
    [ "894414041",[-103.56240544938653, 48.24018685902208]],
    [ "894414073",[-103.17548895795709, 48.363400575164974]],
    [ "Wheelock Substation",[-103.30570466695708, 48.34025845110762]],
    [ "894426862",[-89.2976220594037, 31.525703474760135]],
    [ "894435599",[-82.1716631425531, 34.184533850341666]],
    [ "New Prospect Road Substation",[-74.26747100167238, 40.154816721678074]],
    [ "Glen Lake Substation",[-85.95492959491911, 44.90128600969641]],
    [ "894620359",[-103.36821976011232, 48.18255217733156]],
    [ "894710112",[-103.5381455504541, 48.155816528659045]],
    [ "894760595",[-108.41447999426627, 45.811831988623865]],
    [ "894817936",[-108.41513261988655, 45.79392101005316]],
    [ "Manton Substation",[-85.40426012225188, 44.41410633160064]],
    [ "Howard Substation",[-83.05558936421602, 42.329769927635326]],
    [ "Kino Substation",[-110.94581467520852, 32.191437614233976]],
    [ "895073195",[-81.31244623306051, 37.655785044698625]],
    [ "Chauvez Substation",[-86.42850929300546, 43.91041787640857]],
    [ "William Rengi Substation",[-83.35584205948417, 42.63852117459418]],
    [ "895265935",[-120.21306885000001, 45.896004350000005]],
    [ "895362537",[-110.2242433194316, 42.248970784691856]],
    [ "895363945",[-110.35292051626557, 42.37186698318194]],
    [ "PEARL AVE",[-88.55511774031739, 44.02509195749654]],
    [ "Bean Station Substation",[-83.29376076259773, 36.340263874848645]],
    [ "Liberty Substation",[-79.57654638091287, 35.85045563632314]],
    [ "Terry Ranch Road Substation",[-104.80676431684562, 41.04255319210154]],
    [ "South Cheyenne Substation",[-104.80895287706095, 41.04256306206827]],
    [ "895876580",[-85.28675276483617, 38.19268855131762]],
    [ "Georgia Power",[-83.35680096120612, 33.93918979909429]],
    [ "896019841",[-82.64536425812221, 38.08125412313162]],
    [ "896058298",[-86.90724475830103, 39.559009868979366]],
    [ "Wagner Substation",[-85.12543638395744, 42.05159893615001]],
    [ "896244483",[-115.34274727484609, 35.63344959316372]],
    [ "896259999",[-117.79150084999999, 36.018578649999995]],
    [ "896260000",[-117.7902335138338, 36.00148107514961]],
    [ "896260002",[-117.81017907397214, 36.00599653131258]],
    [ "Aldene Substation",[-74.28553302291417, 40.656354315290116]],
    [ "Public Service Company of Colorado",[-106.16546826353651, 39.43924926205594]],
    [ "896290978",[-114.9071847, 36.4184086]],
    [ "896305607",[-114.532457054754, 34.868670163095246]],
    [ "896330856",[-121.08532678398154, 40.171386269506066]],
    [ "Poor Valley Substation",[-83.20597324295998, 36.342086898396026]],
    [ "Mt. Allen Substation",[-76.97226599999999, 40.176794349999994]],
    [ "896418513",[-81.3541795, 34.217141049999995]],
    [ "896491987",[-118.84405578169456, 34.95498683950756]],
    [ "896500662",[-118.18593185, 35.344909550000004]],
    [ "896500666",[-118.2476732095405, 35.207310980982996]],
    [ "896530960",[-119.00267423853245, 35.454101416650424]],
    [ "Thompson Creek Substation",[-83.25586574612674, 36.22104996801949]],
    [ "896705463",[-123.37489093288114, 42.94678369821008]],
    [ "896778025",[-83.33792187196813, 36.20729092034438]],
    [ "Hartford VT Substation",[-72.31181619806274, 43.68328037065825]],
    [ "897175428",[-110.24112511193503, 31.54748467880314]],
    [ "Milwood Substation",[-120.64199814045993, 40.41003174567752]],
    [ "Pottersville Substation",[-71.14810896468208, 41.73808291487829]],
    [ "Walton Substation",[-81.69796528355315, 41.470835987870394]],
    [ "Florida Power & Light",[-82.35225001766572, 27.60372195753706]],
    [ "Georgia Power",[-81.20821095000001, 32.20886175]],
    [ "897701465",[-79.80369210052426, 35.53201635356733]],
    [ "Consumers Energy",[-85.20475896884747, 42.32303065737173]],
    [ "897752419",[-85.56716869999998, 38.039343200000005]],
    [ "897753621",[-85.51318059576973, 38.05797599488782]],
    [ "897756310",[-85.37188418278747, 38.11350506627244]],
    [ "897759066",[-85.16856415, 38.11630434999999]],
    [ "898205865",[-77.42445592875828, 37.97264379520212]],
    [ "898551278",[-103.95258157623506, 48.600248804394546]],
    [ "898551337",[-103.7075169, 48.92437715]],
    [ "898623186",[-80.62653773810015, 40.008506405761146]],
    [ "898623363",[-102.8089515240941, 48.2350886761708]],
    [ "899193781",[-90.84824301594739, 35.969911196074634]],
    [ "Klinekill",[-73.6200735145812, 42.370637242556825]],
    [ "Morristown Utility Systems",[-83.29212263360904, 36.18678007625392]],
    [ "Southborough Road Substation",[-79.90340648418356, 34.20034802725195]],
    [ "Foster Road Substation",[-91.52518274432178, 41.68661241557757]],
    [ "Midway Substation",[-83.70352867482579, 36.00506562910868]],
    [ "900019532",[-83.79195837464009, 32.07539021682453]],
    [ "Medusa Portland Cement Substation #2",[-83.64169844999999, 32.40537945]],
    [ "Eel Weir Station",[-75.48969532940387, 44.638763302423264]],
    [ "Huevelton Station",[-75.40430267124744, 44.617124640690896]],
    [ "Kentucky Utilities Company",[-84.52483386241522, 37.889705949203645]],
    [ "Kentucky Utilities Company",[-84.5374936814624, 37.85859964589513]],
    [ "Underhill Substation",[-72.94773818513077, 44.5214810948888]],
    [ "Underhill Substation",[-72.94971936459524, 44.54431818356901]],
    [ "Farnum Pike Substation",[-71.53094344605957, 41.90120394404054]],
    [ "Shunpike Substation",[-71.51541145113188, 41.80131892539549]],
    [ "Wert Cranston Substation",[-71.52180679060534, 41.756811741981004]],
    [ "Gap of the Ridge Substation",[-84.77788091806956, 36.9024901954809]],
    [ "901620461",[-80.54863971962062, 28.477091687958005]],
    [ "Clear Creek Substation",[-91.64377597861657, 41.707100924617365]],
    [ "Encino Sub",[-106.85461884487884, 35.35475159582922]],
    [ "901855865",[-82.20428236304784, 34.20115664606554]],
    [ "Woodstown Substation",[-75.31794092950872, 39.636516942756195]],
    [ "902147263",[-84.24167734758612, 38.03065079924115]],
    [ "902147266",[-84.23325392735985, 38.02156386531486]],
    [ "Cambria County Prision Substation",[-78.6971700810091, 40.486507983417404]],
    [ "902160530",[-83.76560484223158, 37.82920780534711]],
    [ "902502090",[-83.54764719999999, 38.1270617]],
    [ "902643935",[-80.7139100867105, 34.98459635662122]],
    [ "902701557",[-91.9379521, 39.1863497]],
    [ "Eversource",[-70.58227370376517, 41.782023552375435]],
    [ "Eversource",[-70.5814330041948, 41.782339350296056]],
    [ "Bourne Transition Station",[-70.55666265120237, 41.76660858728637]],
    [ "902858282",[-87.17207036647459, 39.04465818772199]],
    [ "Nineteen Mile Road Substation",[-85.52664503091073, 43.74371892460166]],
    [ "Merchants Way Substation",[-70.298072937202, 41.6858325360437]],
    [ "West Shore Substation",[-76.94788506485499, 40.189028827459005]],
    [ "Virginia Electric and Power Company",[-77.42761496090972, 37.55276538968869]],
    [ "903236178",[-81.49427765608472, 38.186147611210544]],
    [ "903255197",[-90.8324854997375, 30.332817724728447]],
    [ "Florida Power & Light",[-80.30909925309963, 25.838922055932365]],
    [ "903262920",[-81.50603371629825, 37.94313667540399]],
    [ "903262923",[-81.39505199999999, 37.96163730000001]],
    [ "903262928",[-81.48130858975041, 38.04759342292921]],
    [ "Sundial Substation",[-81.5178614977551, 37.877577898838574]],
    [ "Appalachian Power Company",[-81.45093839124775, 38.06868814676983]],
    [ "Erving Substation",[-72.46261229471288, 42.594247568703516]],
    [ "French King Substation",[-72.4760774123901, 42.59882262554113]],
    [ "Appalachian Power Company",[-81.36124648290978, 37.762649600886846]],
    [ "903860418",[-112.11660260371401, 33.757667010703436]],
    [ "Kentucky Utilities Company",[-84.5732499, 37.89391359999999]],
    [ "903912533",[-79.98918417430095, 35.968550661469806]],
    [ "903981582",[-81.24119094188406, 40.40387115549687]],
    [ "East Dover Substation",[-81.45957144156881, 40.52389309329104]],
    [ "903983674",[-87.91178585036091, 42.67860574865916]],
    [ "Apple Data Center",[-93.91883572758167, 41.62170116735529]],
    [ "904032861",[-80.43399124999999, 33.04311815]],
    [ "904164718",[-84.76797636134528, 37.07026974573478]],
    [ "Station 74",[-77.4203502, 43.218639950000004]],
    [ "Electric Power Board of Chattanooga",[-85.29568619566555, 34.996690437341165]],
    [ "New London Substation",[-72.09297493320712, 41.362870879881655]],
    [ "Electric Power Board of Chattanooga",[-85.32384566990255, 35.022410360638645]],
    [ "Broken Bow Wind Farm Substation",[-99.56001415973589, 41.47191171531682]],
    [ "Broken Bow Wind Farm Phase II Substation",[-99.55183337449114, 41.460685032912124]],
    [ "Hayes Substation",[-94.29946875260318, 42.515547753823896]],
    [ "Pomeroy Wind Farm",[-94.75532541408775, 42.56595850184354]],
    [ "904639435",[-82.17190957399053, 30.340327283525237]],
    [ "Timber Substation",[-82.2430649252932, 30.235696295150586]],
    [ "904647283",[-84.41935395, 41.12157349999999]],
    [ "Jefferson City Substation",[-83.49709093491508, 36.10592180865734]],
    [ "Four Mile Junction Substation",[-79.98429870676493, 42.103588747132854]],
    [ "KU",[-85.24350052366626, 37.55673255249396]],
    [ "904936692",[-106.09563642512101, 35.01351385758987]],
    [ "Georgia Power",[-81.08195912338542, 31.993288782457313]],
    [ "905264211",[-83.0720460725901, 29.393542758390197]],
    [ "905268004",[-81.94248491172937, 27.6161221801968]],
    [ "905272677",[-82.58441324903298, 28.9133321867332]],
    [ "Stokes Electric Substation",[-81.97468679999999, 29.211786599999996]],
    [ "905283432",[-82.2073262, 29.215901250000005]],
    [ "905298405",[-112.12997630343997, 33.92158890435781]],
    [ "905548371",[-84.6114757996218, 41.34015638757604]],
    [ "Power Plant Substation",[-77.37862534168262, 35.61524811904141]],
    [ "905942985",[-80.69119939076833, 38.19432728670625]],
    [ "905944576",[-80.66360205501655, 38.22956928226801]],
    [ "GE River Substation",[-70.9663948188459, 42.44720348653668]],
    [ "Ipswich River Substation",[-71.00474002459731, 42.56157706758801]],
    [ "Laurelton Substation",[-74.13830659270889, 40.08180632686207]],
    [ "Lake County Substation",[-86.03730525888756, 43.98823248903267]],
    [ "Whispering Willow Wind Farm - East",[-93.2319953725097, 42.62872987469441]],
    [ "Victory Substation",[-86.35065400052822, 44.03468716656331]],
    [ "Grand Prairie Substation",[-98.31429285255783, 42.61940314310262]],
    [ "Bristol RI Substation",[-71.26844179296012, 41.694557064813765]],
    [ "Arnold Rec Substation",[-79.08115026141138, 39.85041105501671]],
    [ "Bigby Substation",[-79.08074386180309, 39.84999793613839]],
    [ "906947393",[-96.36106188696101, 44.534324380526435]],
    [ "906947394",[-96.3610464504891, 44.5326566974713]],
    [ "Community Wind North Project Collector Substation",[-96.42003639531966, 44.28234085533736]],
    [ "907372017",[-81.12424365000001, 36.497499149999996]],
    [ "907572653",[-80.25318949933752, 32.84169367726633]],
    [ "Aboite Substation",[-85.2848310353358, 41.04560680816064]],
    [ "907735233",[-79.85629779129121, 36.69052085592156]],
    [ "907782095",[-81.08882990921978, 37.366353299819465]],
    [ "Fairfield Substation",[-79.99005235163317, 35.92400967797134]],
    [ "907808144",[-85.13575368004594, 35.06627248849826]],
    [ "Union Valley Substation",[-84.2286895142341, 35.99723277320995]],
    [ "Morgan County Substation",[-84.54278360000002, 36.09548575]],
    [ "Sunbright Substation",[-84.66426735144216, 36.24985796410988]],
    [ "907808216",[-85.10599318945404, 36.92354224056002]],
    [ "907808218",[-85.11163827227583, 36.93241024428893]],
    [ "907808220",[-85.10581075000002, 37.10275635000001]],
    [ "907845138",[-86.42802245965869, 36.06936955067087]],
    [ "Public Service Company of Colorado",[-105.24024057429352, 39.89084183458977]],
    [ "907851313",[-105.23605175782481, 39.90731524353321]],
    [ "Spring Valley Substation",[-87.62892654180884, 34.65654522475035]],
    [ "Pickwick Electric Cooperative",[-88.5744770031193, 35.14367778424929]],
    [ "Pickwick Electric Cooperative",[-88.57590385024606, 35.1450831847526]],
    [ "Maury City Substation",[-89.21205190377401, 35.82137800253298]],
    [ "907916634",[-79.63661641718767, 39.489271062683486]],
    [ "907916635",[-79.63595718260356, 39.48885262037028]],
    [ "907927570",[-82.32425175799926, 28.85853143094002]],
    [ "907944239",[-115.04354921398881, 36.16923598299059]],
    [ "908007361",[-85.25323027040282, 41.03768495883062]],
    [ "908094338",[-102.86366655000002, 48.3992485]],
    [ "908239251",[-101.01861184959863, 48.821711434650666]],
    [ "908239254",[-101.29900664877668, 48.77088327674477]],
    [ "Elkhorn Ridge Substation",[-97.6648572746423, 42.669558424433006]],
    [ "Maple City Substation",[-85.84344918995583, 44.86661112218897]],
    [ "908887179",[-90.46220001222066, 41.20375645152512]],
    [ "Hancock County Wind Farm",[-93.60592865469104, 43.0742217494162]],
    [ "909005743",[-84.7775337996767, 41.46203433097463]],
    [ "Flat Creek Substation",[-84.54938145230258, 33.35004258298845]],
    [ "Littleton Substation",[-104.99839070526689, 39.56688427334156]],
    [ "Four County EMC",[-78.21429143423565, 34.72612870262687]],
    [ "Eastgate Substation",[-79.52521871762708, 40.29093491884919]],
    [ "909236649",[-88.81633827143018, 37.92957442749533]],
    [ "909604105",[-103.23278260907487, 34.800392094670165]],
    [ "909605407",[-90.33601308250006, 43.308238425770234]],
    [ "909703222",[-81.19923267473317, 35.221258757084634]],
    [ "West Hampden Substation",[-72.46218094550308, 42.068618066046106]],
    [ "Ridgeville Substation",[-84.30504291625213, 41.42815375376857]],
    [ "910153322",[-87.13638215, 39.0411933]],
    [ "910257157",[-87.06059357260204, 41.46360358750507]],
    [ "Solon Big Grove Substation",[-91.51065989895186, 41.805845650144796]],
    [ "Pearl River Valley Electric Power Association",[-89.3871810278071, 31.166077177413314]],
    [ "Gable Street Substation",[-95.35250197339263, 29.76448640416898]],
    [ "Carencro Substation",[-92.0508315, 30.298157699999997]],
    [ "910629163",[-80.36663021695303, 41.4198535845157]],
    [ "Singing River Electric Cooperative",[-88.49675041760052, 30.508018795228388]],
    [ "Brodhead",[-89.38319361899306, 42.61779573166521]],
    [ "Root River",[-87.960793957726, 42.85125362937334]],
    [ "PPL",[-77.19657431598712, 40.238273447126865]],
    [ "53rd & Mund Substation",[-94.83404097656566, 39.03186716003763]],
    [ "911069465",[-78.01646310401723, 35.16811531644641]],
    [ "911069472",[-78.0895076980903, 35.20095658362386]],
    [ "911069474",[-78.0268144126274, 35.25783471959986]],
    [ "911069482",[-78.09026116617183, 35.37239489752567]],
    [ "911069483",[-78.08876922749099, 35.37228544712716]],
    [ "911070946",[-81.44369234376286, 39.77510449934056]],
    [ "911072471",[-81.67393139254033, 39.796599757121704]],
    [ "Iron Range Substation",[-93.30363063440532, 47.23035104172632]],
    [ "911211223",[-89.25186793103076, 31.68150608138144]],
    [ "911211224",[-89.25251030716794, 31.681486619446243]],
    [ "911292635",[-89.39606309999999, 43.38587985000001]],
    [ "911410072",[-78.32274374661158, 34.99279963336995]],
    [ "911503140",[-112.08402648834941, 40.80662353332111]],
    [ "911515072",[-78.00055595971926, 35.35016077866384]],
    [ "911520592",[-77.72160686526534, 35.254813572517676]],
    [ "911520594",[-77.78930517995781, 35.291224705199625]],
    [ "911520595",[-77.81917967868057, 35.309256914927346]],
    [ "911525319",[-80.57880611036106, 35.06071531186364]],
    [ "Veranda Sub",[-106.70157503995407, 35.241133874973194]],
    [ "911687220",[-84.83936029703366, 38.54117730706191]],
    [ "McIvor Substation",[-83.68280569999999, 44.25277895]],
    [ "Georgia Power",[-84.21970077232425, 33.91611104444385]],
    [ "912512587",[-84.66426343565851, 39.019319941899454]],
    [ "City of New Castle",[-75.61392577349699, 39.65362695318935]],
    [ "Bentonville Electrical Utility Department",[-94.20932197453055, 36.36215495605271]],
    [ "912586381",[-77.59360212901349, 35.26566220451241]],
    [ "Merorial Substation",[-72.57570967418606, 42.19557460425342]],
    [ "912604442",[-77.48227660104436, 34.852098339159035]],
    [ "912604446",[-77.59036594882373, 35.057656116902045]],
    [ "912609119",[-112.10706642492781, 41.111468493098435]],
    [ "912681140",[-81.9013113, 34.47268604999999]],
    [ "912698096",[-82.12988576962158, 34.211010843308074]],
    [ "912698113",[-81.95876713454474, 34.53689986269742]],
    [ "912698124",[-82.02929458902803, 34.63262537765048]],
    [ "Ameren",[-90.08181958446184, 38.89762543007647]],
    [ "Harvey Run Substation",[-78.77283281187002, 41.183606152385174]],
    [ "Stanwood Substation",[-85.47639682768765, 43.61259012104399]],
    [ "913602071",[-85.36660005768806, 32.47221299280416]],
    [ "913602074",[-85.421059885132, 32.47744362884095]],
    [ "Elliotsville Substation",[-79.63220523184687, 39.77388675576667]],
    [ "Station 205",[-77.30393375038761, 43.228249963631825]],
    [ "913700442",[-118.01446996303676, 33.88860829332342]],
    [ "913901295",[-95.23255775979686, 36.351290011312784]],
    [ "913901297",[-95.04960411176576, 36.451818926530834]],
    [ "Kentucky Utilities Company",[-83.58044606690537, 37.1642827165051]],
    [ "913988190",[-114.11747125, 47.61399045]],
    [ "914034864",[-98.0000934248788, 34.08544906056457]],
    [ "Arkansas Electric Cooperative Corporation",[-90.73603720000001, 35.33572815]],
    [ "Northwest Hartford Substation",[-72.70473440382462, 41.78290213682451]],
    [ "69",[-106.91681195571266, 37.83810532098278]],
    [ "Motts Farm Substation",[-74.34629716463128, 39.58660919910676]],
    [ "Arkansas Electric Cooperative Corporation",[-90.5764797787006, 35.2906274826407]],
    [ "Viking Lincoln Substation",[-83.41890683418163, 44.67992632538887]],
    [ "Lime Creek Substation",[-93.20394440830711, 43.248089698368325]],
    [ "Oak Grove Substation",[-83.34475827044135, 36.04460570654283]],
    [ "NorthWestern Energy",[-115.30078777956525, 47.58216972751108]],
    [ "Cedar Creek Substation",[-83.22636952626229, 36.27282769752132]],
    [ "Copper Ridge Substation",[-83.26285398283362, 36.24926209913515]],
    [ "Station 132",[-77.36705066834908, 43.22569938152109]],
    [ "Ryno Substation",[-84.1514316262133, 44.64561218444369]],
    [ "Atkinson Mills Substation",[-77.82066675825592, 40.45498336436435]],
    [ "NextEra Energy",[-93.20966793968712, 43.24966985060423]],
    [ "Saint George Substation",[-80.54595294842854, 40.63237922815097]],
    [ "Entergy Arkansas",[-93.16905140000001, 34.578229150000006]],
    [ "Entergy Arkansas",[-93.05449760618104, 34.62276621954028]],
    [ "Bentonville Electrical Utility Department",[-94.14388955000003, 36.3455388]],
    [ "Lewiston Substation",[-84.38005329999999, 44.854019699999995]],
    [ "Ames Street Substation",[-71.01695595911858, 42.101567372527214]],
    [ "Mount Hope Substation",[-81.17571402624864, 37.90516988210715]],
    [ "Washington Metropolitan Area Transit Authority",[-77.49441689098614, 39.00928526061929]],
    [ "Beverly Substation",[-70.88698197404851, 42.54543324616875]],
    [ "915675265",[-77.41924332364901, 34.81969750990893]],
    [ "915840073",[-95.6980379, 33.6343416]],
    [ "Clarkston Substation",[-83.42005782769787, 42.74382487522811]],
    [ "Goshen Substation",[-119.43908222916798, 36.32678788533795]],
    [ "Rutledge Substation",[-83.49830283574347, 36.286967023899884]],
    [ "916534762",[-95.7595891499549, 34.89539984079996]],
    [ "916534795",[-95.78528375, 34.855914]],
    [ "Plywood Substation",[-84.69452411647956, 44.99737389271688]],
    [ "917097537",[-103.1835360952763, 47.84843915092161]],
    [ "FIXME Substation",[-92.7756399487813, 38.15862288936949]],
    [ "917201158",[-115.50134217183867, 33.243108449226845]],
    [ "Pineland Substation",[-81.15030783245741, 32.611856096795776]],
    [ "Hawley Substation",[-75.17950888285799, 41.467794250959585]],
    [ "917475224",[-85.17162479308448, 40.89486187519728]],
    [ "917508061",[-80.63380253534011, 40.53185570547696]],
    [ "917602699",[-103.28945486964977, 47.77859322168146]],
    [ "Georgia Power",[-84.57092552890599, 33.81829705137357]],
    [ "Wendell Depot Substation",[-72.3646096150781, 42.59485215602048]],
    [ "North Bridgeport Substation",[-76.2572711559139, 40.04738782073686]],
    [ "Maple Leaf Substation",[-85.80582035, 41.36223965]],
    [ "918013050",[-85.83913282489735, 41.41404708774397]],
    [ "918013060",[-85.8355059861821, 41.49280831849072]],
    [ "Snow Street Substation",[-72.03180226819377, 42.08273369189601]],
    [ "918034173",[-86.31661403241857, 41.820232168735544]],
    [ "918040188",[-86.79825112988892, 41.595800863416585]],
    [ "918044899",[-85.9209671, 42.20842785]],
    [ "Zephyr Substation",[-83.20881044731692, 42.266717321485416]],
    [ "918413392",[-84.44802697780419, 38.080623967818106]],
    [ "Grand Army Substation",[-71.18427043944824, 41.73323509850375]],
    [ "Moore Substation",[-71.87529700571747, 44.33594874517019]],
    [ "Duke Energy Progress",[-77.29713503750753, 35.51965439616869]],
    [ "918492103",[-77.40281504591574, 35.380305267354345]],
    [ "Sandy Valley Substation",[-115.63111907892959, 36.00873006075014]],
    [ "918731828",[-80.73218185, 34.9147795]],
    [ "918758163",[-79.67047715000001, 39.0916932]],
    [ "918801452",[-98.48922693777479, 36.46301477492742]],
    [ "Hastings Substation",[-85.28430325662066, 42.646667439423354]],
    [ "919025605",[-117.33000274999999, 47.80533819999999]],
    [ "919204096",[-97.10117280000001, 33.19953035]],
    [ "919357486",[-79.0110589458944, 39.64151184029762]],
    [ "919357490",[-79.05530175983309, 39.43539491776072]],
    [ "919373613",[-79.41311517015893, 39.523585763920266]],
    [ "919434461",[-84.61328855, 41.2244388]],
    [ "920130850",[-101.83064796233813, 39.044406398269864]],
    [ "920130853",[-101.74037869568065, 39.047237205673156]],
    [ "Windsor Substation",[-84.91577753101315, 37.12629740207769]],
    [ "920574351",[-117.89912180374749, 33.77822081346428]],
    [ "920574352",[-117.87872501272278, 33.871614182938266]],
    [ "920574353",[-83.14718153947047, 41.111129301685544]],
    [ "920642970",[-96.08129015292592, 36.35180444637265]],
    [ "920883576",[-95.60434900000001, 40.116714400000006]],
    [ "920998203",[-82.16929830026518, 38.65883113903878]],
    [ "North Freemont Substation",[-83.11231620967347, 41.36052730588603]],
    [ "Colony Substation",[-72.81189699529614, 41.49889045573286]],
    [ "North Wallingford Substation",[-72.76220870946716, 41.49183337087809]],
    [ "Crown Battery Substation",[-83.10209004313387, 41.36318396122827]],
    [ "Chowan Substation",[-76.5766382161502, 36.093932298387664]],
    [ "MidAmerican Energy",[-96.39409659999998, 42.490425200000004]],
    [ "Tolna Substation",[-76.63453819107107, 39.76360854022711]],
    [ "921908393",[-96.20971053115419, 35.144299693739576]],
    [ "921908396",[-96.13512589185301, 35.32335080970215]],
    [ "921908399",[-96.03539839999998, 35.2466591]],
    [ "921918603",[-117.8594454503719, 33.75604164051524]],
    [ "Huntsville Utilities",[-86.66801815960228, 34.64458557522746]],
    [ "Huntsville Utilities",[-86.66434454999998, 34.6317]],
    [ "Huntsville Utilities",[-86.65766882442131, 34.6515464084677]],
    [ "922035705",[-80.82327012645126, 35.562325594538656]],
    [ "DTE Energy",[-83.36935337568221, 42.71985230975703]],
    [ "922250111",[-96.37226720449512, 34.884059580904896]],
    [ "922250134",[-96.2790269210069, 34.52818940157369]],
    [ "922250136",[-96.21668865238165, 34.48425413183457]],
    [ "922293271",[-86.42499309131354, 35.85035224472676]],
    [ "922486367",[-90.17704815798805, 34.86050382742069]],
    [ "922541805",[-82.7690530532823, 38.367230473716866]],
    [ "922635508",[-82.73575132048511, 38.38947098351397]],
    [ "Huntsville Utilities",[-86.68081330000001, 34.6925677]],
    [ "Huntsville Utilities",[-86.65148917840281, 34.72367043302478]],
    [ "North Industrial Park Substation",[-83.46060510000001, 45.0998102]],
    [ "922938416",[-82.95987531693939, 39.40399053368409]],
    [ "922938439",[-82.96050485633563, 39.4080343668144]],
    [ "923026773",[-86.49248940498421, 33.592505767893016]],
    [ "923198519",[-87.20908333088387, 39.62257504228746]],
    [ "923226835",[-83.48146709683104, 42.53848665133795]],
    [ "Duke Power",[-80.43952019219961, 35.39810418329051]],
    [ "923580548",[-80.44767571693052, 35.37224090173397]],
    [ "923585515",[-76.36689103155743, 36.42228479961374]],
    [ "923601234",[-117.92346470482097, 34.11393099820993]],
    [ "923615470",[-80.95530357991322, 34.88878165748917]],
    [ "923767038",[-122.06006723361692, 37.418855829696746]],
    [ "Jennersville Substation",[-75.88133264999999, 39.801324]],
    [ "923800106",[-87.8745105, 40.20844410000001]],
    [ "Waterford Station",[-83.39859930182786, 42.68962348912694]],
    [ "923879731",[-80.48727014347777, 35.68010469371757]],
    [ "923884521",[-80.80276297916532, 35.80744828673417]],
    [ "Bardwell Substation",[-89.00632181653154, 36.87795430120516]],
    [ "924421941",[-83.30330579330047, 36.22855753968227]],
    [ "924467754",[-87.60681615, 32.69820475]],
    [ "Dunkirk Substation",[-83.64648603200992, 40.78323414008604]],
    [ "Seaside Heights Substation",[-74.07733633111648, 39.94326848733682]],
    [ "Lakehurst Substation",[-74.30760245488132, 40.01884873210655]],
    [ "Intel Ronler Acres Substation",[-122.90180262529063, 45.54063201577406]],
    [ "Georgia Power",[-84.9329625, 32.437448550000006]],
    [ "Georgia Power",[-84.90367889122668, 32.404733743991706]],
    [ "925592511",[-84.50316771586935, 32.589989875078395]],
    [ "925760465",[-98.39741178508898, 36.761561440941705]],
    [ "925760467",[-98.45030875000002, 36.8628476]],
    [ "925774722",[-79.2329635422348, 42.41589605950094]],
    [ "925871871",[-78.45529263069858, 42.08192560905922]],
    [ "925894641",[-98.2886334949432, 36.8980937385579]],
    [ "925894642",[-98.28982299130189, 36.8976854772144]],
    [ "925894645",[-98.16267702371819, 36.86272161873835]],
    [ "925894656",[-98.04623609124378, 36.86886714830922]],
    [ "925896583",[-82.5913562, 31.857267249999996]],
    [ "925945035",[-81.48262990000002, 31.12819765]],
    [ "926029187",[-83.4839108, 33.563451699999995]],
    [ "926029188",[-83.48411038621752, 33.56302043126719]],
    [ "Madison Substation",[-83.4643509528136, 33.60807378684168]],
    [ "926034303",[-83.14863128416206, 33.5948880184546]],
    [ "Union Point Substation",[-83.04927386855098, 33.60651341119291]],
    [ "926048788",[-119.60466590000001, 45.84923594999999]],
    [ "926094811",[-83.18728235000002, 34.7002941]],
    [ "E. C. Lavender Substation",[-83.28231836605916, 32.909896197888564]],
    [ "926217547",[-98.03120151625922, 36.862585517052594]],
    [ "926217550",[-97.7326802548892, 36.86242705621786]],
    [ "Renfrow Substation",[-97.67228948712852, 36.867459985553104]],
    [ "926217558",[-97.66689676679505, 36.92601217364848]],
    [ "926217559",[-97.40831450028391, 36.81892346644458]],
    [ "926217562",[-97.35772761513367, 36.8265348180077]],
    [ "926217565",[-97.4798402285798, 36.92727379434559]],
    [ "Oklahoma Gas & Electric",[-97.31874565051122, 36.819027450014524]],
    [ "926329461",[-107.68207453222729, 46.71297440937851]],
    [ "Marathon Pipe Line LLC",[-88.90428704656723, 37.1689081827151]],
    [ "Kentucky Utilities Company",[-88.94790311860304, 37.083635333655536]],
    [ "Kentucky Utilities Company",[-88.95303591154607, 36.99046705225328]],
    [ "926752503",[-83.47686404999999, 41.67335105000001]],
    [ "926786612",[-83.45465160549959, 41.67232718671609]],
    [ "Open Sky Substation",[-97.13115025486715, 36.983546140065506]],
    [ "Kay Wind",[-97.13361078756704, 36.98401729779964]],
    [ "926952060",[-97.12205250000001, 36.825852499999996]],
    [ "926952063",[-97.10333148878142, 36.666230439683396]],
    [ "926952067",[-97.08399358732943, 36.686552154908206]],
    [ "926952069",[-97.082142595644, 36.69119746369854]],
    [ "926952072",[-97.06792889026393, 36.66274759938458]],
    [ "926952076",[-97.06778956158485, 36.67549167593901]],
    [ "927147804",[-81.47903325200585, 33.04170608164224]],
    [ "927227499",[-83.51349549742243, 41.69431163274095]],
    [ "927385402",[-77.0741357, 36.2480441]],
    [ "927506142",[-97.10724248727722, 36.717380873467775]],
    [ "927506144",[-97.08874728991131, 36.72146374817886]],
    [ "927506146",[-97.08480370801891, 36.719360419660525]],
    [ "927506151",[-97.09065475426902, 36.738233999597526]],
    [ "927506153",[-97.04902158055913, 36.75237961385927]],
    [ "927506155",[-97.0496229252257, 36.70724184444529]],
    [ "Oklahoma Municipal Power Authority",[-97.04986714112012, 36.69635672165286]],
    [ "927506161",[-97.07719486425154, 36.69740346747153]],
    [ "927506162",[-97.08062709539801, 36.678608699208645]],
    [ "927506174",[-96.98047041126041, 36.463917420138664]],
    [ "927506178",[-97.04490351758125, 36.47875926272269]],
    [ "Clearwater Substation",[-81.88595993563604, 33.500128117924014]],
    [ "Dyersville Substation",[-91.11137320512182, 42.48277954186774]],
    [ "927994189",[-77.47976169149153, 36.50299165838598]],
    [ "927994190",[-77.44723042016611, 36.51233109249319]],
    [ "Holland Substation",[-76.769841422952, 36.67366684411747]],
    [ "927994193",[-76.76963351172657, 36.67309993163242]],
    [ "928043920",[-96.7509712657652, 36.44960341945692]],
    [ "928043930",[-96.67835004987292, 36.68972838033156]],
    [ "Evergreen",[-114.27332084999999, 48.21578144999999]],
    [ "Round Lake Substation",[-84.26376037501694, 42.00865160543418]],
    [ "928305273",[-94.0026171217249, 39.416338717002326]],
    [ "928451782",[-96.65671148655257, 36.70357002212973]],
    [ "928451783",[-96.56886648915821, 36.593847164573404]],
    [ "928451788",[-96.37020715459093, 36.598398793366016]],
    [ "928705040",[-84.79641389999999, 38.183097249999996]],
    [ "928713681",[-96.14733283763017, 36.58152449955798]],
    [ "928713728",[-96.001776098651, 36.74718614372267]],
    [ "928746140",[-117.81822300335891, 34.04134498618614]],
    [ "928849232",[-95.97230139397668, 36.5384310697226]],
    [ "928849241",[-95.9298792541095, 36.53937745905817]],
    [ "928849267",[-95.88372221480867, 36.5391967576168]],
    [ "928891095",[-83.74074370483311, 41.67434489987064]],
    [ "929085442",[-86.49732670124448, 35.9999988562195]],
    [ "Six Flags Substation",[-84.55387985694213, 33.76554963233561]],
    [ "Taylorsville Substation",[-89.39586376067679, 31.822791433011336]],
    [ "929470982",[-92.68518336383299, 37.978479425040724]],
    [ "929664480",[-93.57957183683966, 42.04560426924515]],
    [ "Morristown Utility Systems",[-83.28107781708852, 36.19120714744178]],
    [ "929893667",[-87.25368804999998, 38.8018514]],
    [ "Proctor & Gamble Substation",[-84.1082976240592, 31.55200340988206]],
    [ "Birdsong Substation",[-83.90106684999999, 31.545172449999995]],
    [ "930418928",[-95.83004871150877, 36.23534107695032]],
    [ "Public Service Company of Oklahoma",[-95.82122558374147, 36.17641270346443]],
    [ "930418942",[-95.72107944448851, 36.23465971430633]],
    [ "930418943",[-95.79477712349139, 36.27810589835123]],
    [ "930418947",[-95.78802218357788, 36.22861260396847]],
    [ "930418950",[-95.65117320956422, 36.28470534387317]],
    [ "930418952",[-95.63232334095302, 36.32545593553423]],
    [ "930418970",[-95.54282356207804, 36.38345224023494]],
    [ "930428287",[-86.64874093513068, 40.56537066818728]],
    [ "Linwood Substation",[-84.41716687562902, 39.121175468367795]],
    [ "Georgia Power",[-83.83998571598839, 31.5252280761842]],
    [ "930539502",[-83.81099339518582, 31.522342762271634]],
    [ "930619120",[-83.42667866998937, 31.130258791976065]],
    [ "930761997",[-87.57763390981707, 32.700041374488215]],
    [ "930762007",[-87.40735004482127, 32.68506466849346]],
    [ "Whitemarsh Island Substation",[-81.00120460996045, 32.041263447584065]],
    [ "Bemiss Substation",[-83.24039163236773, 30.932419024719987]],
    [ "Moody AFB Solar Substation",[-83.21972602607484, 30.953467922239675]],
    [ "930776518",[-83.2361421, 31.1849153]],
    [ "930785115",[-83.04045088370478, 31.314726853719424]],
    [ "Maple Ave Station 502",[-74.18508049212895, 42.98490007146256]],
    [ "930849673",[-109.19337680645664, 32.26262546773043]],
    [ "931167952",[-114.01961766940128, 48.34227633755635]],
    [ "931423777",[-95.21598367284655, 36.801113951122815]],
    [ "931604836",[-85.20380451863143, 40.05148050420892]],
    [ "Island Heights Substation",[-74.1385440391638, 39.951415920877565]],
    [ "931659420",[-116.61166297224841, 43.56820609965181]],
    [ "931694026",[-84.10685604372739, 41.39662361717082]],
    [ "Keene Substation",[-96.03895359289565, 38.99410398971282]],
    [ "931728398",[-81.71382555, 30.3510992]],
    [ "931739892",[-111.91108361351264, 33.42833192654926]],
    [ "931877556",[-95.48800536103496, 36.56317333594308]],
    [ "931877557",[-95.38166624352611, 36.51210107182468]],
    [ "931877558",[-95.27460010551681, 36.488277995575935]],
    [ "931877560",[-95.6003424221325, 36.33175156527876]],
    [ "Volvo Substation",[-80.25977045569776, 33.13373558830878]],
    [ "Saint George Substation",[-82.026188153737, 30.52309489716638]],
    [ "Grantley Substation",[-76.73597108921525, 39.94786353317646]],
    [ "Kittrell Substation",[-86.24572784743627, 35.820696517617876]],
    [ "932439114",[-94.8504709512444, 36.88584072485205]],
    [ "932439117",[-94.80616940538341, 36.87169659412458]],
    [ "932439118",[-94.64591703108574, 36.84777496305761]],
    [ "932439119",[-94.87288391469892, 36.86906919561675]],
    [ "932444734",[-81.54073455120074, 30.395200225916156]],
    [ "932730267",[-117.92849189257088, 33.7654099705899]],
    [ "Fernadina Beach Mill Substation",[-81.45411345000001, 30.6805654]],
    [ "Dunham Substation",[-83.8898190590427, 43.11733142493939]],
    [ "933570153",[-94.88335096151555, 36.892300201556395]],
    [ "933570159",[-94.87233981201798, 36.58893058928209]],
    [ "933570161",[-94.85153947285038, 36.57241469879404]],
    [ "933570162",[-94.96968397274995, 36.58381718752123]],
    [ "933570165",[-94.96984125186393, 36.47028124631011]],
    [ "933570167",[-94.86347689366158, 36.48241487305024]],
    [ "Grand River Dam Authority",[-94.71081394223216, 36.6190145209274]],
    [ "Bath Substation",[-84.44722794104752, 42.81340007053798]],
    [ "934860492",[-117.33529704913676, 33.1367542314931]],
    [ "934990491",[-77.3454021, 39.05343055]],
    [ "935001260",[-94.71993722434205, 36.5691539143378]],
    [ "935001262",[-94.77084021989911, 36.53968192489379]],
    [ "935001265",[-94.68360206512119, 36.26280973718857]],
    [ "Grand River Dam Authority",[-94.58139681350156, 36.24850466868734]],
    [ "935001271",[-94.63666308875388, 36.17388421384435]],
    [ "935001273",[-94.78856407702534, 36.20551174730527]],
    [ "935001277",[-94.95887375456654, 36.21151796411762]],
    [ "935052767",[-80.60538766873859, 36.11692635543459]],
    [ "La Jolla Substation",[-117.27535254310239, 32.84010920901521]],
    [ "Elkhorn Substation",[-115.29540467829396, 36.293205259145196]],
    [ "Consumers Energy",[-85.74073679213573, 42.92227436413486]],
    [ "935669323",[-118.02783388205789, 33.850998353836225]],
    [ "Bay Boulevard Substation",[-117.09434193233331, 32.60826454161566]],
    [ "935817344",[-92.4595038, 38.369610249999994]],
    [ "935878017",[-112.69446070000002, 45.613330749999996]],
    [ "Duke Energy Progress",[-79.82607493569299, 35.710021457205016]],
    [ "936365844",[-83.30754450827932, 41.67548293727735]],
    [ "936461246",[-81.79981389999999, 28.062315549999997]],
    [ "936536958",[-82.83519896269843, 41.333028516205054]],
    [ "936564982",[-117.29272227371023, 34.10043342773636]],
    [ "Southern California Edison",[-117.3301978871632, 34.16988647492877]],
    [ "936579277",[-95.14843658221564, 36.14717367326082]],
    [ "936579279",[-95.07799591966108, 36.07374696868319]],
    [ "936579282",[-94.9296926723498, 36.089739052031014]],
    [ "936579285",[-94.95970089165519, 35.959354724849845]],
    [ "936579286",[-95.13336820235423, 36.07151325605987]],
    [ "936579289",[-95.12044848306572, 35.93033128424638]],
    [ "936579292",[-95.11039757053207, 35.89330147702604]],
    [ "Waiinu Substation",[-156.4970333485547, 20.87941285585465]],
    [ "Warroad River Series Compensation Station",[-95.41971335000001, 48.7878069]],
    [ "Plymouth Substation",[-81.55805397534176, 28.689661409368043]],
    [ "Riverside Electrical Substation",[-117.37016006890815, 33.9780153574548]],
    [ "Duke Energy",[-81.35750388246012, 28.649869271302677]],
    [ "937904127",[-81.32420488174674, 28.844915317458266]],
    [ "937951836",[-98.64752410411766, 36.761644403798265]],
    [ "937951841",[-98.77308354681239, 36.740097565949235]],
    [ "DeGrasse Substation",[-98.80783275656196, 36.75713246672053]],
    [ "Ariel Substation",[-83.19176382102921, 42.543697870575755]],
    [ "938453509",[-81.91862590125565, 27.90888393116655]],
    [ "Quacco Road Substation",[-81.27069035260567, 32.077661467005115]],
    [ "East Kentucky Power Cooperative, Inc.",[-84.88972750852601, 37.8962483772376]],
    [ "938592731",[-112.36007537779673, 33.40839849077937]],
    [ "Woodard Station",[-76.19397006711843, 43.12729045005513]],
    [ "938689342",[-80.7747285671531, 33.60415589819825]],
    [ "938831830",[-81.93988060000001, 27.765684450000002]],
    [ "938869616",[-82.00677432461254, 27.66783544288025]],
    [ "938869617",[-82.0242823744313, 27.669661055868364]],
    [ "938869618",[-82.02395594999999, 27.66965565]],
    [ "NTL Substation",[-80.1155182541084, 42.1043412595964]],
    [ "Appalachian Power Company",[-81.45979661771166, 37.728774279162955]],
    [ "Air Liquide",[-88.26560065000001, 42.66862855]],
    [ "Vandolah Plant Substation",[-81.92439780294204, 27.52431921632766]],
    [ "939461917",[-93.17079112511009, 43.16158314320763]],
    [ "FIXME Substation",[-93.32294570112613, 38.204421534135456]],
    [ "Mosaic Substation",[-82.04980175, 27.83052595]],
    [ "Clark Hill Tie Substation",[-82.15616449534858, 34.161711690698304]],
    [ "Hilton Road Substation",[-83.12183419152962, 42.45895858254789]],
    [ "Imlay City Substation",[-83.07480761459274, 43.02311047478076]],
    [ "Romeo Substation",[-83.00691261347858, 42.80238421475214]],
    [ "Richmond Substation",[-82.7748035679679, 42.809125599984355]],
    [ "Gratiot Substation",[-82.59795355770852, 42.86762730070078]],
    [ "Wolfhill Substation",[-83.43471504316844, 42.84357604211022]],
    [ "Pobanz Substation",[-83.31467874172773, 43.82138307314681]],
    [ "940419956",[-83.008810425351, 40.26775605958692]],
    [ "Almont Substation",[-83.035651225422, 42.92144444121184]],
    [ "Euclid Substation",[-83.20784138833409, 42.605779135995]],
    [ "Lordstown Switching Station",[-80.83988002202767, 41.15058136021713]],
    [ "Sacramento Municipal Utility District",[-121.57623012918641, 38.71422716752395]],
    [ "Novi Substation",[-83.47310996763963, 42.47535688425058]],
    [ "Abbott Substation",[-82.89896341760928, 42.51495128433666]],
    [ "Magneto Substation",[-83.42928481570618, 42.49180114865641]],
    [ "Columbia Substation",[-82.53700537511091, 43.07560816983996]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.74142053991096, 37.46217342389908]],
    [ "Division Substation",[-82.6344977997053, 42.81327307016615]],
    [ "North Arkansas Electric Cooperative Corporation",[-91.38408773289066, 36.27964324668997]],
    [ "Hardy North Substation",[-91.4653887651365, 36.315140267940826]],
    [ "Lake Orion Substation",[-83.23699995736085, 42.78771554339202]],
    [ "Oxford Substation",[-83.26378415279218, 42.82633298165988]],
    [ "941191763",[-82.64972100668079, 40.035437006224335]],
    [ "941191764",[-82.65050759429823, 40.03548359854]],
    [ "Valmy Substation",[-117.15280858755807, 40.87859783477323]],
    [ "941457633",[-82.39903618839288, 27.90676022506385]],
    [ "The Mosaic Company",[-82.39140069999999, 27.86458575]],
    [ "The Mosaic Company",[-82.38778922414336, 27.861562602028222]],
    [ "Walnut Substation",[-83.33073576712587, 42.582851977421264]],
    [ "Annchester Substation",[-83.236084224586, 42.44358079497028]],
    [ "Puritan Substation",[-83.19699402750526, 42.40907247764438]],
    [ "Selfridge Substation",[-82.82885696681512, 42.614435641312994]],
    [ "941697174",[-90.13109958371356, 32.46229099779026]],
    [ "Lowell Substation",[-83.0367389, 42.59535885]],
    [ "941812292",[-82.34753828417332, 27.604998724910562]],
    [ "941862166",[-101.04718779999999, 48.08852740000001]],
    [ "North Arkansas Electric Cooperative",[-91.72649915, 36.18103035000001]],
    [ "North Arkansas Electric Cooperative",[-91.61001786078735, 36.21372397860543]],
    [ "North Arkansas Electric Cooperative",[-91.46303839999999, 36.096081950000006]],
    [ "942018298",[-88.99547651673926, 40.88942709960944]],
    [ "North Arkansas Electric Cooperative",[-91.75694285642305, 36.25125270645122]],
    [ "942248995",[-95.45299902485225, 36.53885720392685]],
    [ "Oakwood Substation",[-85.61296066165484, 42.25993842491267]],
    [ "North Arkansas Electric Cooperative",[-91.76657602455364, 36.1866690897387]],
    [ "942444563",[-80.14644295837532, 33.770271733421225]],
    [ "942698705",[-81.24854681570666, 32.112921279624274]],
    [ "942705607",[-81.14761060733214, 32.107243773590916]],
    [ "Duke Energy",[-87.40049747502363, 38.24195139382666]],
    [ "942750856",[-84.27191431767521, 41.09331123444036]],
    [ "942763016",[-82.02546233043996, 40.037110278222684]],
    [ "Drahner Substation",[-83.14159781179683, 42.81415164392845]],
    [ "Sand Hill Substation",[-88.76298754152582, 31.345235527699767]],
    [ "Cooperative Energy",[-88.76345194472975, 31.345036975191558]],
    [ "943037610",[-88.3250972, 44.23649300000001]],
    [ "Consumers Energy",[-84.45073979957525, 42.72472048528143]],
    [ "Goodison Substation",[-83.16336202583794, 42.734821877908814]],
    [ "New Haven Substation",[-82.79930677042735, 42.72827964995494]],
    [ "Armada Substation",[-82.88379435938448, 42.83576156692539]],
    [ "Cass City Substation",[-83.18397732537149, 43.59873175897366]],
    [ "Peck Substation",[-82.82237370747161, 43.258261195092935]],
    [ "Anderson Substation",[-83.95480604999999, 42.629115350000006]],
    [ "Mount Morris Substation",[-83.40512143641779, 43.128665775759046]],
    [ "Pittman Substation",[-75.1135894130101, 39.73712407240846]],
    [ "943673846",[-88.9411632938464, 31.34578902922505]],
    [ "Southern LNG Substation",[-81.00076109770062, 32.086587683187865]],
    [ "Butters Substation",[-85.02265904923065, 41.93087967684854]],
    [ "Florence Substation",[-73.06736881425743, 43.708709974855054]],
    [ "944125923",[-81.28628526499845, 35.09419351487938]],
    [ "944689871",[-102.63866945540515, 45.99856268158628]],
    [ "Consumers Energy",[-85.57528068457823, 42.308369185208264]],
    [ "Hintonville Substation",[-88.91237636064187, 31.25976563308475]],
    [ "945624979",[-111.20167806821944, 45.790044657130835]],
    [ "Caroga 219",[-74.49915511111448, 43.1251514597182]],
    [ "945811082",[-76.6610637317506, 36.966653521510665]],
    [ "946035637",[-82.49826739698445, 40.33862794897979]],
    [ "White Oak Substation",[-78.71387098147372, 34.74701356197298]],
    [ "946166781",[-82.49532064688815, 40.63368240083962]],
    [ "946521051",[-81.61686948009982, 28.40545580576908]],
    [ "947006048",[-101.3738758458124, 48.628357783370305]],
    [ "947022649",[-85.99721220060077, 39.89479855823495]],
    [ "South Lancaster Substation",[-82.56708958700841, 39.690133243698696]],
    [ "Barton Wind Farm",[-93.10346149916327, 43.3869025966207]],
    [ "DTE Energy",[-84.531792593695, 43.21073597341162]],
    [ "948165190",[-84.78443380734694, 43.6834858753679]],
    [ "AEP Montpelier Substation",[-85.2875099498152, 40.55524227645545]],
    [ "Mill Pond Tap Substation",[-70.78628205743081, 43.066585555242526]],
    [ "Virginia Electric and Power Company",[-77.37033568062058, 38.95260591082153]],
    [ "948916849",[-87.18580558459607, 39.83363938939665]],
    [ "Hazlehurst Wood Pellets Substation",[-82.57225521218253, 31.854822029523618]],
    [ "Cedar Substation",[-76.85556079999999, 40.24204805]],
    [ "949114118",[-86.86767790243647, 39.648153484057346]],
    [ "949596608",[-82.71750280063645, 40.267291006890275]],
    [ "949667069",[-81.59790252355566, 31.175784421629995]],
    [ "949752935",[-82.83174914492398, 40.26120302182696]],
    [ "951242092",[-74.76668335, 43.090026099999996]],
    [ "Fairfield Substation",[-86.14443848582731, 39.82005212528476]],
    [ "Lyons",[-76.99171892900645, 43.06046808401969]],
    [ "Monon Trail Substation",[-86.13867002003656, 39.82263945332228]],
    [ "Fitz Forest Products Substation",[-83.20484176057455, 31.70158995594983]],
    [ "951378690",[-83.21037274999999, 31.70730125]],
    [ "Georgia Power",[-83.37277034471794, 33.96225623581431]],
    [ "West Main Substation",[-84.19683206233806, 42.99670427508352]],
    [ "Tucson Electric Power",[-111.25067885000003, 32.4455643]],
    [ "952040071",[-83.00197035015023, 40.09642542375236]],
    [ "952182707",[-81.9173220733624, 29.04074896426578]],
    [ "Summerglen Substation",[-82.15341545, 29.015678099999995]],
    [ "Horizon Substation",[-82.04683588944066, 29.665565079730086]],
    [ "Vienna Primary Substation",[-83.79901136202338, 32.08333422709312]],
    [ "Southern Wood Supply Substation",[-84.12968769999999, 32.33556715]],
    [ "Duke Energy Progress",[-76.7410957332737, 34.82068357276953]],
    [ "Duke Energy Progress",[-76.85413384104314, 34.824710887770536]],
    [ "Hawaiian Electric Company",[-155.35452080000002, 19.59640035]],
    [ "Beaglin Park Substation",[-75.55998273911912, 38.376363264748264]],
    [ "Walston Switch Point Station",[-75.50294036374932, 38.38256226339108]],
    [ "952812570",[-75.24612979361417, 38.37222336839779]],
    [ "952822460",[-75.68641815158799, 38.16042174167481]],
    [ "952822472",[-75.13112489986793, 38.32738089680219]],
    [ "Rockawalkin Substation",[-75.66242007122473, 38.402976988208174]],
    [ "Palmyra",[-77.22390083292882, 43.064254007011684]],
    [ "953205160",[-82.67034383599056, 35.71646795879537]],
    [ "Motts Corner Substation",[-74.15572788592966, 39.91629682468284]],
    [ "Former Chestnut Neck Substation",[-74.46402766488906, 39.5441611431405]],
    [ "Moss Mill Substation",[-74.5014178755468, 39.50466070957088]],
    [ "953608543",[-75.20776098441985, 43.42237596352995]],
    [ "953632552",[-81.17500302774701, 33.6560859487582]],
    [ "953832575",[-111.77264637501042, 33.090179764771115]],
    [ "Rockport Substation",[-83.40228490778902, 45.18609502487778]],
    [ "953889214",[-81.07613046734127, 34.14841733936669]],
    [ "Morrice Substation",[-84.18079799303268, 42.8418040014992]],
    [ "954001406",[-83.76680844453459, 39.93494788759993]],
    [ "Substation 1",[-76.07801075846083, 38.77898867294334]],
    [ "Substation 2",[-76.06917849207612, 38.79499040536837]],
    [ "954082291",[-116.91358930632664, 39.59126164603354]],
    [ "954082316",[-116.91339670314753, 39.587670527086566]],
    [ "954094066",[-83.12753275901413, 40.279507775623614]],
    [ "954094069",[-83.12731734901013, 40.283004099800486]],
    [ "Riverway Substation",[-119.3128056613725, 36.357473691870275]],
    [ "Central Avenue Substation",[-82.02612940882067, 33.470020027617565]],
    [ "954437818",[-82.2980854, 29.1926206]],
    [ "954444519",[-82.04320952495937, 28.800209759337175]],
    [ "954444522",[-82.06422127491341, 28.749832811722907]],
    [ "954445688",[-81.73378683030322, 28.98478188325739]],
    [ "954446479",[-83.12281052480387, 40.629667742673654]],
    [ "Visalia Substation",[-119.27897426378155, 36.32974896821782]],
    [ "954590679",[-83.1565528258337, 40.62231948479832]],
    [ "954770784",[-83.2689891, 43.8338451]],
    [ "West Cambridge Substation",[-76.11090000818346, 38.56683724038682]],
    [ "955053049",[-81.93618127283345, 34.9518101910904]],
    [ "955062652",[-111.94878624092563, 40.66816194264725]],
    [ "Porterville Substation",[-119.0345696838109, 36.06718769870524]],
    [ "Jersey Central Power and Light",[-74.19579125298974, 39.83310806822203]],
    [ "955355783",[-82.59143493236436, 40.82294967046553]],
    [ "955407850",[-81.92811632408873, 34.947587955124455]],
    [ "955408964",[-81.9436629272626, 34.95672784360951]],
    [ "Choctaw Substation",[-85.43217274152347, 31.238156494920098]],
    [ "Riga Substation",[-83.81188015000002, 41.802440600000004]],
    [ "955813327",[-83.1296000321427, 41.04139159513638]],
    [ "M&M Mars Substation",[-84.1822532403161, 31.55178912491977]],
    [ "Berckman Road Substation",[-82.03633204999998, 33.48905385]],
    [ "Reading Substation",[-84.749384, 41.84272825]],
    [ "955934363",[-83.70827351054155, 40.061013969690976]],
    [ "Dixie Power",[-113.52622215000001, 37.0665064]],
    [ "955936288",[-113.59482014999999, 37.07887275]],
    [ "955937268",[-113.54924045000001, 37.0573013]],
    [ "955937341",[-113.6114064065018, 37.013408521296284]],
    [ "955937980",[-113.35952252495164, 37.18554120501478]],
    [ "Sasser Substation",[-84.3463612, 31.723145299999995]],
    [ "956049516",[-84.31066125000001, 31.697033700000002]],
    [ "956049565",[-84.20863423333954, 31.613769507030177]],
    [ "Baker Heights Switching Station",[-84.10992487296599, 31.575780808280804]],
    [ "Baker Heights Substation",[-84.10980823830405, 31.57530847340201]],
    [ "Jersey Central Power and Light",[-74.8989535874275, 40.6047687768827]],
    [ "956353620",[-116.51169841462249, 43.61112604394893]],
    [ "956640101",[-84.10544317815733, 40.70149363956849]],
    [ "Sleepy Hollow Substation",[-72.97343375, 42.8598068]],
    [ "Center Union Substation",[-77.9605886078683, 40.53976532049087]],
    [ "International Paper Substation",[-84.07178406926457, 32.25138408432409]],
    [ "957199485",[-87.12792230457585, 41.63552510011892]],
    [ "957212067",[-85.30462109113003, 40.967546849908366]],
    [ "Lovell Substation",[-84.13601441552849, 35.8914453763479]],
    [ "Georgia Power",[-83.87500365042655, 32.53549830973598]],
    [ "Acuglas Substation",[-85.27415558728177, 43.89775757475742]],
    [ "957687788",[-83.00467342032599, 43.93768845448834]],
    [ "957693830",[-97.16195342648871, 33.22738493526439]],
    [ "958269614",[-84.89931139716187, 32.53806858403624]],
    [ "958269641",[-84.95069430252255, 32.547402451707995]],
    [ "Oliver Dam Substation",[-84.9953116424843, 32.516866678354766]],
    [ "Highlands Dam Substation",[-84.99368001864458, 32.49533681724865]],
    [ "958269656",[-85.0290739, 32.5330542]],
    [ "958340281",[-84.10974109872176, 32.85526660686025]],
    [ "Georgia Power",[-84.65159633315467, 32.878276883461155]],
    [ "Durand - Troup Substation #20",[-84.73736691633226, 32.9185520830187]],
    [ "Georgia Pacific (Durand) Substation",[-84.7790108626812, 32.91396847700693]],
    [ "Georgia Power",[-84.7974699193521, 32.762280443947496]],
    [ "Antioch Substation",[-85.02234686009822, 32.68801598957186]],
    [ "Hannawa",[-74.97296829387288, 44.61936207527484]],
    [ "958356467",[-84.91825682683027, 32.55288559305871]],
    [ "Station 117",[-77.48268201080296, 43.09945729905437]],
    [ "Flag City Substation",[-83.64021660150915, 41.088211702212284]],
    [ "Consumers Energy",[-85.67580652582352, 42.89120590269747]],
    [ "Clay Substation",[-85.67687284163517, 42.86983297461271]],
    [ "United Parcel Substation",[-85.68407322481472, 42.85964233952549]],
    [ "958724729",[-81.81840557367433, 27.56763022501322]],
    [ "958729414",[-111.95565910753906, 40.612923426551916]],
    [ "958983859",[-80.41294576140763, 41.34920302144741]],
    [ "Consumers Energy",[-83.91632184463121, 43.574101979523256]],
    [ "Blue Ridge Energy",[-81.66040052107165, 36.21812975293036]],
    [ "Burkesville Substation",[-85.37604859364953, 36.787286623955936]],
    [ "SC-28 Solar Plant Substation",[-81.2689943320479, 33.34954841901819]],
    [ "WestRock Substation",[-82.84264135752277, 32.503674997655956]],
    [ "960103648",[-95.3819355732285, 35.95356316055112]],
    [ "DTE Walker Substation",[-83.01590986238878, 42.34000386673293]],
    [ "960615311",[-96.21041988942827, 46.718329154159186]],
    [ "Blue Ridge Energy",[-81.65823817226507, 36.205139184781764]],
    [ "Johnstown Station 61",[-74.37584054932495, 43.015217469602]],
    [ "960851058",[-82.55812021539275, 35.83166493109303]],
    [ "Public Service Company of Oklahoma",[-95.88542334487366, 36.053343349967214]],
    [ "Public Service Company of Oklahoma",[-95.919628884035, 36.02649911267548]],
    [ "961071916",[-86.1272490753983, 35.20586538958286]],
    [ "Manalpan Substation",[-74.38264280159548, 40.25509461346042]],
    [ "961101151",[-116.29483097500814, 43.63353139367976]],
    [ "961420479",[-83.16995861166393, 30.12478927651754]],
    [ "961420480",[-83.16988065649862, 30.125360111220832]],
    [ "961439471",[-83.62625935000001, 30.170834699999993]],
    [ "961439476",[-83.54533933822125, 30.061448866699322]],
    [ "961439478",[-83.5936495280635, 30.121746910852607]],
    [ "961439484",[-83.70699976666378, 30.26489030052564]],
    [ "961685798",[-83.93814190750673, 30.411145526081064]],
    [ "961704466",[-83.85568377552882, 30.55242566528834]],
    [ "Fairview Switching Substation",[-86.00020133900287, 42.81902344737991]],
    [ "961758923",[-83.41250385401634, 30.578644107329456]],
    [ "961758928",[-83.28207065987431, 30.472672015512995]],
    [ "961758934",[-83.62311078094893, 30.470186264206404]],
    [ "961758935",[-83.62298204999999, 30.470729549999998]],
    [ "Plainview Substation",[-105.239290871366, 39.884606622592976]],
    [ "962274087",[-91.43044766485141, 44.05703578770938]],
    [ "962274088",[-91.38335006964388, 44.071201487691184]],
    [ "962280795",[-91.43177558571314, 44.027350125239245]],
    [ "962504234",[-76.3028157688323, 43.22725773155881]],
    [ "Phoenix Station",[-76.30127436443725, 43.23008154401015]],
    [ "Univeristy Park Mall",[-86.19534694971915, 41.71674339087017]],
    [ "962622448",[-84.96055207626998, 39.58821535310513]],
    [ "Jamestown Board of Public Utilities",[-79.24905273241122, 42.10138926794717]],
    [ "963019808",[-83.98834885000001, 42.628617950000006]],
    [ "Southwest Arkansas Electric Cooperative",[-93.62132625506742, 33.5057317422259]],
    [ "963245170",[-82.65202469377456, 40.41121947489332]],
    [ "West Athens Substation",[-83.39928580494448, 33.96839267678012]],
    [ "Georgia Power",[-81.15807449365687, 32.15403463262721]],
    [ "963473146",[-111.29174965140592, 47.50224786057294]],
    [ "Wakefield Substation",[-76.16248534987865, 39.77311726864965]],
    [ "963802515",[-81.26400922994398, 33.35402432277664]],
    [ "City of Tallahassee",[-84.17675047515344, 30.540532080598563]],
    [ "963854654",[-84.25887710398897, 30.547388375129106]],
    [ "Bolton Street Substation",[-81.08895020082528, 32.06417996360528]],
    [ "Georgia Power",[-81.03183360000001, 32.082203150000005]],
    [ "964136221",[-83.72339348971221, 40.64293340651313]],
    [ "964187521",[-115.26486918150154, 32.77451251145815]],
    [ "Wilmington Island Substation",[-80.97042541637026, 32.0214381021591]],
    [ "Holston Electric Cooperative",[-83.23231255657795, 36.19721773091918]],
    [ "Omega Substation",[-98.26842816097857, 35.834845779791685]],
    [ "964456064",[-82.18560666440557, 40.788395154795246]],
    [ "Logan Creek Substation",[-122.2629953942232, 39.53951681172161]],
    [ "City of Tallahassee",[-84.29964151284722, 30.454717499741978]],
    [ "Georgia Power",[-83.38511885000001, 33.97380305000001]],
    [ "West Road Substation",[-84.50623756003017, 42.765076031282625]],
    [ "965239678",[-86.18574831662892, 39.78257949977929]],
    [ "Lancaster Junction Substation",[-82.56949125869448, 39.72297195058923]],
    [ "965481613",[-92.73670828983883, 45.07939244472464]],
    [ "Somerset Substation",[-92.6454139084505, 45.15848120807508]],
    [ "Public Service Company of Oklahoma",[-95.95966566591669, 36.14644234152785]],
    [ "Dyersburg Electric System",[-89.38190615, 36.0535018]],
    [ "965778744",[-94.75254577490125, 34.15603099640458]],
    [ "Carbo Ceramics Substation",[-83.13114036506957, 32.856114161706806]],
    [ "Public Service Company of Oklahoma",[-95.97320208654295, 36.22000166772461]],
    [ "966521305",[-83.73539075498303, 33.305337832774995]],
    [ "Cairns Substation",[-82.52243328039968, 40.80483651450674]],
    [ "Vineville Substation",[-83.66333917503894, 32.840575756421636]],
    [ "Lyons Substation",[-84.07028813934588, 41.67137516722099]],
    [ "Public Service Company of Oklahoma",[-95.94782928273335, 36.08800316354658]],
    [ "Knowles Substation",[-92.53678894663913, 45.132178039407464]],
    [ "967067677",[-92.38303992889533, 45.259265193157546]],
    [ "967121142",[-88.95233072188883, 31.890325247929443]],
    [ "Stanton Substation",[-92.50706333147507, 45.158427001592806]],
    [ "Stevenson Substation",[-121.8943316534779, 45.70809759594227]],
    [ "Public Service Company of Oklahoma",[-95.9136715469661, 36.09219612831778]],
    [ "Jonesboro Substation",[-84.3514370249418, 33.52302309336529]],
    [ "Valley Hill Road Substation",[-84.38794551862532, 33.55802580767149]],
    [ "Tara Substation",[-84.42284964999999, 33.527531999999994]],
    [ "Georgia Power",[-84.44533517288838, 33.441697634659405]],
    [ "Georgia Power",[-84.50585843075065, 33.3664962630693]],
    [ "Georgia Power",[-84.53095264999999, 33.38797825]],
    [ "Georgia Power",[-84.31144115016951, 33.279377685212324]],
    [ "Georgia Power",[-84.12061958362989, 33.360713485066256]],
    [ "Georgia Power",[-84.09576955815615, 33.42618937027688]],
    [ "Georgia Power",[-84.06136056399019, 33.45180986893672]],
    [ "Ola Substation",[-84.03043015081259, 33.48201047247855]],
    [ "Georgia Power",[-83.96236813274771, 33.40828482501703]],
    [ "Georgia Power",[-83.97557207947203, 33.38492160188689]],
    [ "Georgia Power",[-84.01158674686926, 33.549268166285295]],
    [ "Georgia Power",[-83.93597163141246, 33.563869126577934]],
    [ "967544581",[-83.90382204761156, 33.58490422389049]],
    [ "967544590",[-83.90354608704519, 33.58532918373274]],
    [ "East Lake Substation",[-84.07282652472315, 33.50348771020357]],
    [ "Lorraine Substation",[-84.12641186762367, 33.59244746550542]],
    [ "Georgia Power",[-84.17930885000001, 33.701589150000004]],
    [ "Georgia Power",[-84.21411184328716, 33.70382809517603]],
    [ "Georgia Power",[-84.23514543342066, 33.73595953243315]],
    [ "Georgia Power",[-84.19717036338282, 33.73156432999986]],
    [ "Georgia Power",[-84.21045632077895, 33.77040984600053]],
    [ "Georgia Power",[-84.29592674985417, 33.81205502775441]],
    [ "Georgia Power",[-84.28161121347459, 33.73919114294559]],
    [ "Georgia Power",[-84.26837691441068, 33.70926843144417]],
    [ "Franklin Substation",[-121.4527309949344, 38.374580496715545]],
    [ "Sand Mountain Electric Cooperative",[-86.02270412082191, 34.42676512582384]],
    [ "968505286",[-84.35134894024644, 33.56352587466279]],
    [ "Mount Pleasant Substation",[-82.9066420758293, 36.17229784142996]],
    [ "Deer Park Substation",[-92.33961014248744, 45.10528524769965]],
    [ "American Transmission Company",[-88.0546612994619, 44.176070940596794]],
    [ "Georgia Power",[-84.5042816938822, 33.55382927334065]],
    [ "Georgia Power",[-84.25266379041672, 33.56888222154581]],
    [ "Oklahoma Gas & Electric",[-97.10442247104253, 34.477890046778334]],
    [ "Lebanon Substation",[-84.79840413607728, 43.09089252732692]],
    [ "Middle Substation",[-74.87699506131982, 39.02721899265677]],
    [ "Public Service Company of Oklahoma",[-95.92612032559657, 36.047090388578944]],
    [ "969120430",[-94.04287724237794, 33.133756992180196]],
    [ "969120436",[-93.96959143009822, 32.98627515886927]],
    [ "969122676",[-93.96505430946364, 32.98055068553913]],
    [ "Henrietta Substation",[-82.26807049700352, 41.319394250485374]],
    [ "969324992",[-92.55807110143527, 44.806291908622875]],
    [ "969326408",[-92.66823465417684, 44.91390013717784]],
    [ "969524427",[-93.98030038890782, 32.30464332308358]],
    [ "Entergy Louisiana",[-91.27440822794581, 30.670196754041292]],
    [ "Geprgia Power",[-84.46444400449839, 33.63034255252284]],
    [ "969681567",[-84.4500153623794, 33.61833506097953]],
    [ "Georgia Power",[-84.44908587739903, 33.61289131494457]],
    [ "969681570",[-84.44887466209815, 33.61257841906857]],
    [ "Georgia Power",[-84.43063189103594, 33.61642877347248]],
    [ "Georgia Power",[-84.4296531, 33.61532585]],
    [ "Georgia Power",[-84.38746834951047, 33.60775666562804]],
    [ "Georgia Power",[-84.39461451437393, 33.654936996783825]],
    [ "Georgia Power",[-84.40704758231716, 33.65318011335332]],
    [ "Georgia Power",[-84.4290103552729, 33.666188752347125]],
    [ "Georgia Power",[-84.43536194708912, 33.667957541626656]],
    [ "Georgia Power",[-84.43235886048892, 33.68809962355147]],
    [ "Georgia Power",[-84.4076078966391, 33.70117699048771]],
    [ "Georgia Power",[-84.4063549242309, 33.735701437945536]],
    [ "QTS Substation #1",[-84.42093237196195, 33.780267042486486]],
    [ "969891468",[-85.68753843044021, 42.172596134823905]],
    [ "969938422",[-78.20052084897723, 36.56522445112101]],
    [ "Riverside Substation",[-83.6808173682116, 32.894351256400284]],
    [ "Colonial Pipeline Substation",[-83.72674065, 32.8819664]],
    [ "Bellevue Substation",[-83.68687877541699, 32.85260859172489]],
    [ "970218643",[-77.70892033867264, 38.81986132904218]],
    [ "PSE&G",[-73.98313397186288, 40.8312037775856]],
    [ "970347146",[-83.8059519346549, 33.064252117852995]],
    [ "970347155",[-83.80616587724917, 33.05620849568777]],
    [ "Consumers Energy",[-85.65831338502947, 42.90822100424945]],
    [ "Percale Substation",[-83.78736785, 33.09151495]],
    [ "Starrsville Substation",[-83.84566210907623, 33.546185857873674]],
    [ "Snow Goose Substation",[-121.7914216060446, 42.16138213566424]],
    [ "Greenville Utilities Commission",[-77.35848064191066, 35.64409928691143]],
    [ "971160730",[-77.03239115, 35.54438650000001]],
    [ "971362792",[-84.36139791721197, 30.271096657567213]],
    [ "971465511",[-111.53727400598572, 40.400118466605704]],
    [ "971465515",[-111.48937197932577, 40.50303115046528]],
    [ "971475355",[-87.70357578812751, 32.66179857513933]],
    [ "971483186",[-82.10317836741709, 41.423131821790754]],
    [ "Halls Crossroads Substation",[-83.9072388923951, 36.08793588349718]],
    [ "San Diego Gas & Electric",[-117.22712185802361, 32.90194900824507]],
    [ "Public Service Company of Oklahoma",[-95.99307891936276, 36.05913287792171]],
    [ "972099262",[-74.47924847685607, 40.52086424328551]],
    [ "Arbors Substation",[-117.54513644267227, 34.10247529558557]],
    [ "972432613",[-82.41836711415506, 28.64831898065012]],
    [ "972438635",[-106.61415611490399, 35.11276752526632]],
    [ "972446606",[-80.8176022615638, 33.50652151648602]],
    [ "972656840",[-83.21197285, 36.249539899999995]],
    [ "972686562",[-88.43098183465607, 42.59250557494107]],
    [ "972940052",[-81.68631422358325, 41.4654033427056]],
    [ "972986788",[-116.66139222497047, 43.647779293134214]],
    [ "Georgia Power",[-84.43337078691256, 33.80993201139892]],
    [ "Georgia Power",[-84.41043494075173, 33.78744121221324]],
    [ "Georgia Power",[-84.39715954646151, 33.785882383893835]],
    [ "Georgia Power",[-84.36768534123121, 33.826984617261225]],
    [ "Georgia Power",[-84.36822085492902, 33.838745754042435]],
    [ "Georgia Power",[-84.38362322411457, 33.856078169306286]],
    [ "Georgia Power",[-84.38078609749932, 33.87648251135421]],
    [ "Georgia Power",[-84.37980772806799, 33.9018148662986]],
    [ "Georgia Power",[-84.3804908921125, 33.923357731147725]],
    [ "Georgia Power",[-84.3888645809465, 33.99988600557916]],
    [ "Flint Energies",[-83.63054967181792, 32.651541215151425]],
    [ "Huntsville Utilities",[-86.66638370000001, 34.65224225]],
    [ "Georgia Power",[-84.50631626705139, 34.11873311618514]],
    [ "Olema Sub",[-122.78667783333331, 38.042113837178555]],
    [ "Bolinas Sub",[-122.70621674582364, 37.941198630644465]],
    [ "Tocaloma Sub",[-122.75989156994954, 38.05486395048083]],
    [ "Las Aromas Substation",[-122.17871890885583, 37.89404329226635]],
    [ "973157222",[-93.61527079146732, 45.62405717923096]],
    [ "Taylor Lane Substation",[-74.13887472890069, 40.40532097517912]],
    [ "973170821",[-106.66962865, 35.016321000000005]],
    [ "973177189",[-114.08744191948207, 36.89262889407764]],
    [ "Public Service Company of Oklahoma",[-95.87604060127435, 36.13397078007659]],
    [ "Georgia Power",[-84.12117296385775, 33.75626901868236]],
    [ "Georgia Power",[-84.10190022057651, 33.71978880449984]],
    [ "Jersey Central Power and Light",[-74.56828515653126, 40.18759211482963]],
    [ "Miller Substation",[-77.9490243510615, 40.630523257396476]],
    [ "Patton Substation",[-78.66242538102142, 40.614485374674324]],
    [ "973888542",[-95.93572660262457, 36.212517433144875]],
    [ "Georgia Power",[-84.1239993, 33.82717015]],
    [ "Georgia Power",[-84.18690688444178, 33.86118401739043]],
    [ "Georgia Power",[-84.20179851283915, 33.897882222261764]],
    [ "Georgia Power",[-84.21934461637817, 33.85156352106739]],
    [ "Georgia Power",[-84.23782, 33.80967485000001]],
    [ "Georgia Power",[-84.2594645, 33.85116855]],
    [ "Georgia Power",[-84.2529261, 33.76619655]],
    [ "974154257",[-85.23758158177307, 41.060864861793]],
    [ "Sylacauga Utilities Board",[-86.25172245996899, 33.18188375102583]],
    [ "974158117",[-95.87540794261884, 36.21278110736851]],
    [ "974368017",[-113.08434382987119, 37.68587135486396]],
    [ "City of Maryville Electric Department",[-83.84607034777792, 35.75159408672508]],
    [ "Townsend Substation",[-83.73878186833322, 35.67809378517918]],
    [ "Newport Utilities",[-83.26901703371311, 35.96796010295973]],
    [ "Jobes Station",[-85.38484525000001, 40.18773345]],
    [ "McCarter Switching Station",[-74.1936174674019, 40.74637637920243]],
    [ "Alber Substation",[-85.22488522523587, 42.30515695627767]],
    [ "Knoxville Utilities Board",[-84.23842020137346, 36.013956097178855]],
    [ "Climax Substation",[-85.33711619999998, 42.272022650000004]],
    [ "974825882",[-93.66932661288676, 42.07764553110174]],
    [ "974845833",[-109.20483096144658, 33.95431287512096]],
    [ "975000054",[-96.01793663896167, 36.132484294877116]],
    [ "Avery Substation",[-75.93501976983077, 41.65226030806687]],
    [ "Georgia Power",[-84.54717706863447, 33.747376985195736]],
    [ "Georgia Power",[-84.58521272950551, 33.722731293726966]],
    [ "Georgia Power",[-84.66630225406487, 33.73940678047197]],
    [ "Georgia Power",[-84.61083128242365, 33.72372479215991]],
    [ "Georgia Power",[-84.5935188470308, 33.76506803726159]],
    [ "Georgia Power",[-84.59445063298793, 33.76470385149252]],
    [ "Georgia Power",[-84.64062262189013, 33.76954635849085]],
    [ "Georgia Power",[-84.59873796190746, 33.70519096386176]],
    [ "Georgia Power",[-84.66463396441027, 33.70802877075502]],
    [ "Georgia Power",[-84.55094782515229, 33.68089451273599]],
    [ "Georgia Power",[-84.51150574854026, 33.68537617020205]],
    [ "UPS Substation",[-84.50699655179983, 33.791686951728316]],
    [ "Georgia Power",[-84.55055421142457, 33.79177453164718]],
    [ "Georgia Power",[-84.57660176605962, 33.858538427080376]],
    [ "975320009",[-87.50848239999998, 41.56625324999999]],
    [ "Georgia Power",[-84.57675108220599, 33.90032116969961]],
    [ "Georgia Power",[-84.5773439665517, 33.900683046921245]],
    [ "Georgia Power",[-84.47553349393127, 33.88098918375827]],
    [ "Georgia Power",[-84.45654136979432, 33.88800989025371]],
    [ "Georgia Power",[-84.55784607026388, 33.919774844387284]],
    [ "Georgia Power",[-84.54044120744274, 33.89491626553]],
    [ "975460651",[-96.02514210130299, 36.13687214751098]],
    [ "975504503",[-81.3622705888946, 33.608963439349914]],
    [ "Cumberland Electric Membership Corporation",[-86.56636382758902, 36.6335450941184]],
    [ "Public Service Company of Oklahoma",[-95.76602101827363, 36.13680620342496]],
    [ "East Newton Substation",[-74.74505668785021, 41.04871406431902]],
    [ "Georgia Power",[-84.5825270636915, 33.48798781880582]],
    [ "Georgia Power",[-84.58523570401067, 33.562621019272534]],
    [ "Owens Corning Substation",[-84.61497378770602, 33.54053306672252]],
    [ "Palmetto Substation",[-84.66188583140034, 33.52411003011768]],
    [ "Georgia Power",[-84.64583186685417, 33.56820264651595]],
    [ "Georgia Power",[-84.64641038568107, 33.56897071764321]],
    [ "Seabrook Solar Switching Station",[-80.74215746352024, 32.5613204140241]],
    [ "Seabrook Solar Substation",[-80.74151877500063, 32.56132379456591]],
    [ "976370946",[-86.01544930838092, 40.047222367471406]],
    [ "976371775",[-86.00472866246554, 40.038737038395915]],
    [ "Jemez Substation",[-106.72144421518969, 35.61841926753305]],
    [ "Public Service Company of Oklahoma",[-95.83849178458132, 36.27915616457266]],
    [ "Pine Ridge Substation",[-102.55654865, 43.02348649999999]],
    [ "Potato Lake Substation",[-95.1088950256196, 47.01571920018991]],
    [ "Mantrap Substation",[-94.99745546249235, 47.00709580654425]],
    [ "Hayes Substation",[-82.72995607112294, 41.37481322018961]],
    [ "977104500",[-82.74798897289372, 41.420831838979524]],
    [ "Missionary Substation",[-89.05656012480843, 32.107124590774156]],
    [ "Georgia Power",[-84.38259131314238, 34.15727798852235]],
    [ "977529380",[-95.88553883651245, 36.69849392041736]],
    [ "977568240",[-77.95281097755502, 35.709891060206864]],
    [ "977568245",[-78.00934250481897, 35.53808338034219]],
    [ "977615282",[-107.92069005371756, 36.803150481264204]],
    [ "Knight Substation",[-120.88769758827682, 45.87771566062707]],
    [ "Illuminating Comapny",[-81.63262972833793, 41.406900360006944]],
    [ "Illuminating Comapny",[-81.63382462549784, 41.41000497096334]],
    [ "Falcon Ridge Substation",[-117.43251803140895, 34.155538821529696]],
    [ "Velarde Substation",[-105.9620058606039, 36.16958144540916]],
    [ "Georgia Power",[-84.75360456086098, 31.85566207596213]],
    [ "Richland Substation",[-84.69140455, 32.086696599999996]],
    [ "Richland Switching Station",[-84.69130284999999, 32.087294150000005]],
    [ "Georgia Power",[-84.9898350505118, 32.30066386684337]],
    [ "Knoxville Utilities Board",[-84.0744845, 35.857160500000006]],
    [ "977992442",[-85.78034927763812, 40.46543959868569]],
    [ "977999391",[-79.05217724999999, 33.54102149999999]],
    [ "978018933",[-83.37821400018925, 32.39150743333717]],
    [ "978035670",[-117.84805823693941, 33.92010241424899]],
    [ "Rossville",[-97.00949045456554, 35.57993736129073]],
    [ "978451645",[-84.16866394210243, 38.00822123052549]],
    [ "978464491",[-84.2864000829653, 37.94766902192945]],
    [ "Reilly Substation",[-86.21736521578346, 39.74309303258269]],
    [ "979440530",[-77.61920573225085, 38.90062658741569]],
    [ "Hayden Bridge Switching Station South",[-122.97226211935025, 44.07085916564387]],
    [ "Georgia Power",[-84.86224962741684, 32.36902136729155]],
    [ "Georgia Power",[-84.89767867595793, 32.365467443689546]],
    [ "Georgia Power",[-84.93606456251216, 32.37121193296474]],
    [ "Georgia Power",[-84.94940861893387, 32.37198755749668]],
    [ "Georgia Power",[-84.95537378341287, 32.35118115627427]],
    [ "Georgia Power",[-84.9819133672671, 32.349654557219445]],
    [ "Georgia Power",[-84.94319437255174, 32.42120578549417]],
    [ "Georgia Power",[-84.96257856580854, 32.44243134740683]],
    [ "Georgia Power",[-84.99126779391852, 32.4805954858832]],
    [ "Georgia Power",[-84.94064731894937, 32.45439770444304]],
    [ "Hodgesville Substation",[-85.39711382650417, 31.189153464856076]],
    [ "Georgia Power",[-84.91334098062207, 32.44056204453844]],
    [ "West Lyons Substation",[-82.34220468613631, 32.200935443559935]],
    [ "Georgia Power",[-84.93612802530288, 32.502682863312884]],
    [ "Georgia Power",[-84.93470428522336, 32.48559261231774]],
    [ "979821417",[-83.13825991116208, 41.442070924944794]],
    [ "979896935",[-80.14394409496722, 34.482272279375344]],
    [ "Scotch Hollow Substation",[-76.46065908579754, 41.74303297987963]],
    [ "980110474",[-96.00994524177516, 36.14121814634478]],
    [ "980394723",[-82.10378658885358, 34.32272061555609]],
    [ "980423245",[-102.7787599255609, 38.101403093179904]],
    [ "Georgia Power",[-84.82134812614628, 32.61345619384326]],
    [ "Georgia Power",[-84.86533867428707, 32.740246286724144]],
    [ "Dixie Pipeline Substation",[-84.73327153242919, 32.776010797885476]],
    [ "980694532",[-78.85423487604625, 36.175320091947164]],
    [ "980726277",[-103.12940185756423, 38.08096535085694]],
    [ "980772803",[-103.19716304567369, 37.99825647539847]],
    [ "Delta Substation",[-123.10285068572423, 44.07312459441237]],
    [ "Consumers Energy",[-83.96904194538853, 41.97017746366642]],
    [ "Wilkins Corner Substation",[-123.10410748192561, 44.18894027108103]],
    [ "Georgia Power",[-85.07959225, 33.575466250000005]],
    [ "Georgia Power",[-85.05696426502331, 33.550441655959766]],
    [ "Grangerwood Substation",[-84.50221305444897, 42.748242338643834]],
    [ "Georgia Power",[-85.11216006326684, 33.56024217546908]],
    [ "Georgia Power",[-85.10905537505081, 33.57492569353989]],
    [ "Jonesville Substation",[-85.2400304442043, 33.56137484941123]],
    [ "Georgia Power",[-85.2615471, 33.67380215]],
    [ "Honda Substation",[-85.2849515823483, 33.69265314306775]],
    [ "Georgia Power",[-85.1866868810757, 33.692415756380925]],
    [ "981622229",[-85.32224164999452, 33.57897271666678]],
    [ "Georgia Power",[-85.05596430368564, 33.6834751163105]],
    [ "Derby Substation",[-72.13821415598697, 44.946466076319915]],
    [ "Consumers Energy",[-85.77492937478132, 42.979823845538235]],
    [ "982326875",[-83.83163493595755, 42.06163150225124]],
    [ "Napoleon Substation",[-90.09936724819586, 29.91684603792903]],
    [ "Hyundai Substation",[-123.18477696775903, 44.03718462935315]],
    [ "Dooly Prison Substation",[-83.719615934145, 32.28150367280057]],
    [ "Meadows",[-88.40183853459145, 44.21617259737492]],
    [ "Baraga Vlg",[-88.54147853356858, 46.75186839633766]],
    [ "983096983",[-81.5261164277995, 33.5123071432546]],
    [ "Winneconne",[-88.71999437398556, 44.10671254063111]],
    [ "983439734",[-81.97151410281369, 35.50939686766343]],
    [ "983439736",[-81.61059565387671, 35.660498990031044]],
    [ "REC Clinton",[-88.89474827501084, 42.52349609007782]],
    [ "983604296",[-80.67555318320268, 27.96762665520281]],
    [ "983641345",[-89.86775927502502, 43.59145209162088]],
    [ "983736535",[-81.35990871239977, 35.20008069028565]],
    [ "983736550",[-81.35771806579616, 35.20110920622325]],
    [ "Burke",[-89.28209727514886, 43.15766450477819]],
    [ "Oshkosh",[-88.53349430006458, 44.01274559978382]],
    [ "Fox Hollow Substation",[-123.15530002178174, 43.95160310973735]],
    [ "Lynx Hollow Substation",[-123.04593829750243, 43.85410193547192]],
    [ "Charlotte Substation",[-94.57318998513146, 39.10585547149389]],
    [ "WE Energies",[-88.41531782089564, 44.273567824890975]],
    [ "Washing Street",[-88.41264650772405, 44.262525475068486]],
    [ "Palooka Substation",[-75.84455075377906, 41.197978146670074]],
    [ "Allen Substation",[-81.01018219996288, 35.188951983294835]],
    [ "984122509",[-111.98552108840813, 43.50310765490594]],
    [ "Freeport Substation",[-85.31282105, 42.76716235]],
    [ "Newberry Vlg",[-85.50498337525745, 46.35203505726854]],
    [ "984691046",[-88.60999527504273, 47.127811644117145]],
    [ "984691047",[-88.60982511087805, 47.123243270627114]],
    [ "Laurel Lakes Substation",[-75.92245062120307, 41.94520071843489]],
    [ "Haskelite Substation",[-85.68937720000001, 42.99676105]],
    [ "Georgia Power",[-84.05327545, 33.973416099999994]],
    [ "Georgia Power",[-84.09537626145111, 33.95840272934271]],
    [ "Georgia Power",[-84.33209291564765, 33.894030934264435]],
    [ "Noti Creek Substation",[-123.40619961668962, 44.019242865530664]],
    [ "Walton Substation",[-123.59073817518339, 44.03340342369358]],
    [ "Georgia Power",[-84.21077419384596, 33.93482830660983]],
    [ "Georgia Power",[-84.15264834999999, 33.930229800000006]],
    [ "Landford Substation",[-84.13287742281972, 33.870467178218775]],
    [ "Georgia Power",[-84.09198332876468, 33.807590058178384]],
    [ "Moon Road Substation",[-84.00001223346929, 33.9302427445335]],
    [ "Vulcan Materials Substation",[-83.88465396162347, 33.880612174873015]],
    [ "Fosters Crossroad Substation",[-83.95556477784515, 33.86176847641247]],
    [ "Lawrenceville Substation #1",[-83.95565997095589, 33.944567007439026]],
    [ "Lawrenceville Substation #2",[-83.99472736201207, 33.94122333795603]],
    [ "Lawrenceville Substation #1",[-84.01987918606686, 33.95814870454666]],
    [ "Collins Hill Substation",[-84.01498166128398, 34.000908481057394]],
    [ "985165806",[-116.48823412489844, 36.53946244411098]],
    [ "Oak Glen Wind Project Substation",[-93.14023799659664, 43.92038735315157]],
    [ "Catchall Substation",[-80.49046784563741, 34.01226292875086]],
    [ "985408210",[-80.53826872846994, 34.03002186036307]],
    [ "985612435",[-82.27437438121378, 34.987841358178926]],
    [ "Cascade Steel Substation",[-123.16311889796486, 45.2298558830087]],
    [ "Harborton Substation",[-122.79710503618634, 45.61432963684829]],
    [ "Boonetown Road Substation",[-75.85893007900435, 40.28470203453627]],
    [ "Manawa Substation",[-88.93048605946056, 44.46802121004854]],
    [ "CWEC IOLA",[-89.1029218282166, 44.54361357909088]],
    [ "Westover South Substation",[-78.69415434999999, 40.729046]],
    [ "Garman Substation",[-78.81899761549177, 40.695432612558]],
    [ "986500882",[-84.47969312497924, 34.69714675915435]],
    [ "986662543",[-96.66827536768358, 35.7093183255961]],
    [ "Ruby Substation",[-122.4563455587237, 45.51591855909701]],
    [ "Tri-County EMC",[-83.35036886467601, 33.15555075451992]],
    [ "Brookwood",[-86.08992460923804, 39.8042369051403]],
    [ "Cyro Drive Substation",[-70.70914516715678, 43.41308648697809]],
    [ "987085766",[-115.2052638183463, 36.001853285179685]],
    [ "Corinth Station 285",[-73.830507, 43.24724679999999]],
    [ "987173161",[-87.02235411026456, 37.985262896370486]],
    [ "Walerga PFE Substation",[-121.3652745766989, 38.73087165990395]],
    [ "Hilltop",[-90.05581638652164, 43.8010113566307]],
    [ "Lick Run Substation",[-79.10593121318638, 39.86349730224366]],
    [ "987558106",[-78.63019102408546, 35.6353329581524]],
    [ "987851194",[-76.06629882787946, 43.09124885605771]],
    [ "Euclid Station",[-76.21757965235442, 43.18293585377053]],
    [ "988012207",[-96.28534730486216, 36.375217370964535]],
    [ "988012209",[-96.2123279, 36.315539750000006]],
    [ "Spangler Substation",[-78.76931046151356, 40.63546809690553]],
    [ "Spirit Lake Substation",[-95.09353655, 46.73918374999999]],
    [ "Bishopville Substation",[-80.22381130479278, 34.20382644522657]],
    [ "Lake Placid Solar Substation",[-81.36199435621961, 27.328414225166387]],
    [ "River Run Subtation",[-91.64981116473032, 41.96827861007735]],
    [ "Cayce Industrial Park Substation",[-81.13485319933325, 33.962185866490344]],
    [ "City of Tallahassee",[-84.31432429949032, 30.3985916841437]],
    [ "988989262",[-84.28687886329863, 30.306000337110902]],
    [ "989103020",[-93.62381492485535, 42.1076085914026]],
    [ "Lovell Substation",[-85.57697630031458, 42.28846063719228]],
    [ "989282985",[-81.0376057293692, 34.18581417426857]],
    [ "Mainesburg Substation",[-76.99603427770506, 41.81348933226482]],
    [ "Sayreville Substation",[-74.3582136749879, 40.470274423628105]],
    [ "990196553",[-81.45594305000002, 35.35811665000001]],
    [ "990196554",[-81.45580735, 35.35070364999999]],
    [ "Knoxville Utilities Board",[-84.09119625070085, 35.87989922555998]],
    [ "Ward Substation",[-77.1011684561361, 41.96367029894449]],
    [ "Cabin Run Substation",[-77.50726189493284, 38.95664641895898]],
    [ "Yardley Ridge Substation",[-77.5190208552708, 38.94992891681153]],
    [ "Evergreen Mills Switching Station",[-77.52682017161082, 38.94468384936387]],
    [ "Nimbus Substation",[-77.46385042002798, 39.012396692597584]],
    [ "990616337",[-117.855101724712, 34.00685259265651]],
    [ "990622721",[-88.08239580028358, 44.45788934938772]],
    [ "990907562",[-78.86196344367436, 40.69953504803589]],
    [ "Baileysville Substation",[-81.66587961875298, 37.58250145926627]],
    [ "Bittersweet Substation",[-93.87755331140471, 41.82127401160485]],
    [ "991006048",[-87.43922464999999, 41.65220605]],
    [ "991089248",[-82.36864215, 35.0611609]],
    [ "991384173",[-88.33226088610175, 44.26616255911831]],
    [ "Darlington",[-90.11371824658237, 42.668626766194954]],
    [ "North Monroe",[-89.61773588279686, 42.66925874506356]],
    [ "Albany",[-89.44404932218195, 42.66963569742738]],
    [ "Bass Creek",[-89.20787200794763, 42.66354680271497]],
    [ "Footville",[-89.20908008901748, 42.6670282915963]],
    [ "Victoria Hy",[-89.20921299607383, 46.69546229572945]],
    [ "SRP Southern Substation",[-111.73919700899307, 33.396158794057364]],
    [ "991840114",[-77.57004175, 35.2952527]],
    [ "SRP Morcom Substation",[-111.63523003316878, 33.21635102009385]],
    [ "Sacramento Municipal Utility District",[-121.26660538065629, 38.61784617850882]],
    [ "MidAmerican Energy",[-93.80737832509661, 41.66119388682896]],
    [ "992064929",[-88.76926125340475, 33.448232124220716]],
    [ "Georgia Power",[-84.72817452696356, 34.16317645381499]],
    [ "Georgia Power",[-84.79385728812218, 34.15834677641904]],
    [ "Georgia Power",[-84.81641647448612, 34.15187135670849]],
    [ "Georgia Power",[-84.82957415, 34.162547149999995]],
    [ "Park Rapids Substation",[-95.05353090781348, 46.91961755187529]],
    [ "Quarry TDC",[-87.65406061582554, 41.84729615660063]],
    [ "992620257",[-94.356743843708, 32.47167038037366]],
    [ "992664599",[-86.52013946306859, 36.92962501408905]],
    [ "992669046",[-86.55193543341181, 36.8626124969379]],
    [ "Portage Substation",[-85.5889630751927, 42.20187115643752]],
    [ "Drager Switching Station",[-94.73496317900106, 42.085179249187284]],
    [ "992943944",[-82.78480831713995, 34.46192150365674]],
    [ "Lakeview Substation",[-92.53284095135383, 36.3725523294623]],
    [ "Victory Substation",[-95.13094837360883, 42.114731529528655]],
    [ "993194227",[-80.63011533627841, 33.06373747723793]],
    [ "993275535",[-80.90249353280663, 35.19640541634391]],
    [ "993325800",[-84.69431298990318, 38.273914173163824]],
    [ "993343019",[-85.6571131920119, 31.234139267630795]],
    [ "Vallee Lane Substation",[-70.4121516036046, 43.519510906240455]],
    [ "Goosefare Substation",[-70.4498143654834, 43.5227890725729]],
    [ "993358406",[-85.72236051078556, 31.323421479582404]],
    [ "993364695",[-97.6561107887193, 32.78733394255423]],
    [ "Gratz Substation",[-76.71466913490472, 40.61498428187141]],
    [ "Byhalia Substation",[-89.69073601967469, 34.861290169781846]],
    [ "Shulls Mills Substation",[-81.74680803155871, 36.173978409876305]],
    [ "993532078",[-81.02993330310605, 33.32334651619026]],
    [ "993532853",[-81.05011734645423, 33.29199788272124]],
    [ "993537908",[-80.5461237, 32.748048100000005]],
    [ "Wagener Substation",[-81.36056593225022, 33.65011188996416]],
    [ "993552077",[-81.52575738345651, 33.57167209272367]],
    [ "993555122",[-86.35321980000002, 40.762573700000004]],
    [ "Forest",[-88.52502225826137, 43.787343972391646]],
    [ "Monona Substation",[-95.76761882347375, 42.209683985918524]],
    [ "Hampton Solar Substation",[-81.13218686980326, 32.88239945028844]],
    [ "Fairfax Substation",[-81.23186039999999, 32.95437549999999]],
    [ "Allendale Biomass Switching Station",[-81.28568007868522, 32.99911823731096]],
    [ "993775966",[-81.35328213545141, 33.2382220186503]],
    [ "993776355",[-81.38541214509024, 33.24409515842455]],
    [ "993776402",[-81.38225035016994, 33.23897521747736]],
    [ "Elgin Substation",[-80.78008885, 34.1802635]],
    [ "Anguin",[-82.7652129975473, 40.06666995874167]],
    [ "993788674",[-82.76562697604295, 40.06055604322896]],
    [ "993984769",[-80.97588743485319, 34.173969389000696]],
    [ "994004877",[-80.72801272946856, 34.217378004529756]],
    [ "994059928",[-80.82714229129742, 34.15027001789795]],
    [ "994068002",[-80.65704303680891, 38.761623232784906]],
    [ "ComEd Elk Grove 138kV Substation",[-87.9636438257869, 42.02641261935452]],
    [ "Radnor Heights Substation",[-77.08257990287932, 38.88587745160344]],
    [ "Consumers Energy",[-85.5534518, 42.269200999999995]],
    [ "994923878",[-82.73493546707276, 39.76098980685995]],
    [ "Biddle Substation",[-83.38425917813707, 42.27700092718007]],
    [ "Emerald Substation",[-85.5479685875757, 42.250258725068655]],
    [ "Burlington North Substation",[-91.11741095253727, 40.84075127750527]],
    [ "995060331",[-82.40769048230369, 35.269880941190245]],
    [ "White Pine Solar Switching Station",[-84.277269831392, 32.49841271555067]],
    [ "White Pine Solar Substation",[-84.26153606570486, 32.50342672505911]],
    [ "Putnam Road Substation",[-72.98659501008937, 42.886337434739836]],
    [ "Midland Power Cooperative",[-93.7175973193825, 42.04875508752434]],
    [ "Kimberly Substation",[-82.21423733230132, 39.42958191038862]],
    [ "Phillips Substation",[-85.57492272788454, 42.26715809470188]],
    [ "995444747",[-82.19532900426086, 39.41470738098053]],
    [ "995463129",[-96.09917288077577, 33.07770733943111]],
    [ "995613935",[-112.00599878289512, 33.031377197757884]],
    [ "995613936",[-111.9820732169418, 33.01455130103218]],
    [ "Albany Green Energy Substation",[-84.10813190000002, 31.554892150000004]],
    [ "995807186",[-84.17548529609175, 31.269830442948464]],
    [ "Southern Oak Solar Energy Substation",[-84.19426297505467, 31.269097853693378]],
    [ "Georgia Transmission Corporation",[-84.43991102046813, 30.950085379943065]],
    [ "Georgia Transmission Corporation",[-84.53379171513394, 30.751329287776635]],
    [ "Georgia Transmission Corporation",[-84.00497182618679, 31.005111586031326]],
    [ "Georgia Power",[-83.95260052210331, 31.1550923816531]],
    [ "Georgia Power",[-83.7831620580044, 31.160100375287517]],
    [ "Georgia Power",[-83.7800148492419, 31.18154725]],
    [ "West Moultrie Substation",[-83.80087172375774, 31.183236055782153]],
    [ "Georgia Power",[-83.73679885806997, 31.10243240936898]],
    [ "Georgia Power",[-83.60677726635808, 31.05743397966978]],
    [ "Georgia Power",[-83.60366446476142, 31.354717177862454]],
    [ "Fort Sanders Substation",[-83.93625634438412, 35.96264694975686]],
    [ "Hunter Substation",[-117.34888636956133, 33.9988853845314]],
    [ "Georgia Transmission Corporation",[-83.9048975556628, 30.951212093585298]],
    [ "Georgia Power",[-83.76779144049063, 30.96039327251123]],
    [ "996001739",[-83.63890200114827, 30.859606136371916]],
    [ "996001740",[-83.6386562657466, 30.85874048235143]],
    [ "Georgia Transmission Corporation",[-83.54358406753744, 30.785317565817795]],
    [ "Mud Creek Substation",[-83.26981923039128, 30.80407240712287]],
    [ "Archer Daniels Midland Substation",[-83.25128232887032, 30.832694019999042]],
    [ "Woodvalley Substation",[-83.31804015652901, 30.858010817870028]],
    [ "Georgia Power",[-84.14784236740658, 31.151280581082315]],
    [ "Georgia Power",[-84.204261275001, 31.23583114255819]],
    [ "Georgia Power",[-84.22152596845766, 31.228915209325606]],
    [ "Georgia Power",[-84.21699883102673, 31.217880191926856]],
    [ "Georgia Power",[-84.15373422963113, 31.131544811351432]],
    [ "Georgia Power",[-84.09138423248127, 31.071577704178683]],
    [ "MidAmerican Energy",[-92.94262103158394, 41.89086316459343]],
    [ "Vienna Substation",[-92.76592440328587, 42.16627414069847]],
    [ "Abbott Substation",[-92.765821388307, 42.16531661766328]],
    [ "Fletcher Substation",[-92.86374962508265, 42.044618207064836]],
    [ "996235567",[-93.25962381826774, 37.10951899143462]],
    [ "North Ave Substation",[-74.17459660433389, 40.66940039135985]],
    [ "996352605",[-97.56383226612402, 35.16146248498981]],
    [ "996352609",[-97.56404483734688, 35.10291064031248]],
    [ "996352613",[-97.65355371081439, 35.06250423611884]],
    [ "996352619",[-97.47891974227264, 35.13914293076414]],
    [ "996499360",[-97.84709543576186, 35.266848475245304]],
    [ "Rix Road Substation",[-85.69513930858228, 42.25613337466379]],
    [ "Caterpillar, Inc.",[-80.11823103952965, 36.06214577381518]],
    [ "996676320",[-98.1048342751953, 35.33463868795556]],
    [ "996723522",[-97.76401990000001, 35.306630500000004]],
    [ "996723544",[-98.13014033851209, 35.48644418012509]],
    [ "Lynchburg Substation",[-80.08954391482122, 34.02418470541917]],
    [ "996734931",[-98.23008691292628, 35.08310902653655]],
    [ "996734933",[-98.23008670519542, 35.08405326574424]],
    [ "997009986",[-87.42509824418518, 39.42517071681011]],
    [ "997062381",[-82.99199790459865, 35.671957846146455]],
    [ "Munson Substation",[-85.64741126761157, 44.76140163184641]],
    [ "997267426",[-98.72680155, 35.0295803]],
    [ "997267434",[-99.00766114005563, 35.079982099222676]],
    [ "997267435",[-99.00761219497437, 35.08062755549474]],
    [ "997267452",[-98.99234905655362, 35.096241659603315]],
    [ "PPL",[-76.08638398260965, 40.318681649922446]],
    [ "Haywood EMC",[-82.87729615, 35.4700181]],
    [ "997328445",[-111.52787443165349, 33.21820995113836]],
    [ "Lick Substation",[-82.61005350034074, 39.044136601056536]],
    [ "997626023",[-80.53070459070804, 33.17345976978654]],
    [ "997775099",[-96.66268850978182, 40.68190262157675]],
    [ "997780795",[-109.13624250080504, 33.84894282743559]],
    [ "997798728",[-88.51442385000001, 44.16555865000001]],
    [ "997804177",[-88.4746329128506, 44.16867151275737]],
    [ "997804181",[-88.47390348732544, 44.16919285]],
    [ "997815601",[-97.49016143147927, 35.47800695565107]],
    [ "997825292",[-80.71518143899772, 33.273683377424334]],
    [ "998038036",[-96.73182503983797, 40.682116772790295]],
    [ "Covington Substation",[-91.80602820168252, 42.07011991000343]],
    [ "Putnam Substation",[-91.59229352359795, 41.95456723847547]],
    [ "Lafayette Substation",[-91.73500597286227, 42.17594016862465]],
    [ "Alliant Energy",[-91.77418, 41.96544305]],
    [ "Coffey Substation",[-91.56057616708475, 42.125138208158106]],
    [ "Coggon Junction Substation",[-91.56940313905264, 42.29576333496945]],
    [ "Alburnett West Substation",[-91.6743657442917, 42.150422526993445]],
    [ "Terrace Substation",[-91.52853862133085, 42.213589075632406]],
    [ "Paris Substation",[-91.52863118884781, 42.24163062510959]],
    [ "Traver Substation",[-91.42661487442352, 41.98124930577469]],
    [ "Troy Mills Substation",[-91.67626847486264, 42.23886035565082]],
    [ "County Home Road Substation",[-91.52021507492752, 42.09299171054202]],
    [ "Elk Substation",[-91.53361332485625, 42.19171635619172]],
    [ "Tharp Switching Station",[-91.68449978604576, 41.864934176305425]],
    [ "Walker Substation",[-91.81175493877151, 42.298904324543805]],
    [ "Linn County REC",[-91.73618531756959, 42.073037484279865]],
    [ "Ely Substation",[-91.57010295, 41.86015605000001]],
    [ "Springville North Substation",[-91.44781975936354, 42.06980132916675]],
    [ "Viola Substation",[-91.42376304999999, 42.092879700000005]],
    [ "Morgan Valley Substation",[-91.81190930493045, 41.903471216468894]],
    [ "Stone City Substation",[-91.3556261, 42.11496204999999]],
    [ "Robins Substation",[-91.67295354760512, 42.09520685734685]],
    [ "Radio Substation",[-91.54709991761149, 42.05792769369217]],
    [ "Palo-Shellsburg Substation",[-91.83414754074057, 42.07894762968093]],
    [ "Deer Run Substation",[-91.69364723308529, 41.952131672065896]],
    [ "Emerald Isle Substation",[-91.6326986384763, 42.017319120319634]],
    [ "998319184",[-84.70906433518144, 41.353590730070195]],
    [ "Orange & Rockland",[-73.94504396216038, 41.04311624632341]],
    [ "Upper Saddle River",[-74.09770570097479, 41.05624664285184]],
    [ "Lovell Substation",[-91.11469092539609, 42.24849685625948]],
    [ "Amber Creamery Substation",[-91.17572071351944, 42.12181707982569]],
    [ "Wyoming South Substation",[-90.99566265887518, 42.040521416841976]],
    [ "Rome Substation",[-91.19041406283306, 41.98276271949042]],
    [ "Sand Springs Substation",[-91.19632558053269, 42.29554625926062]],
    [ "Oxford Mills Substation",[-90.96120223788087, 41.97132683030536]],
    [ "998481077",[-75.47860158644102, 42.275506940549356]],
    [ "Orange & Rockland",[-74.2344026509601, 41.02543911874007]],
    [ "Orange & Rockland",[-73.96528041568625, 41.043754240930085]],
    [ "Monmouth Substation",[-90.87749617857126, 42.05199442594504]],
    [ "Fulton Substation",[-90.71882908697023, 42.16403511940851]],
    [ "Andrew Substation",[-90.60611715, 42.171342149999994]],
    [ "Maquoketa Valley REC",[-90.709066414031, 42.24282933131372]],
    [ "Sale Junction Substation",[-90.67431494021776, 42.31023117637488]],
    [ "Spragueville Substation",[-90.4482666248779, 42.10563100679433]],
    [ "Maquoketa Valley REC",[-90.49065836227015, 42.25760787484677]],
    [ "Delmar Substation",[-90.52979608903931, 41.993086525189014]],
    [ "Pine Island",[-74.45506793448698, 41.28635905314322]],
    [ "Bolt Hill Substation",[-70.76898506046052, 43.116178222670115]],
    [ "Zwingle Substation",[-90.71381421491175, 42.3091701682425]],
    [ "John Deere Substation",[-90.68528341473905, 42.56903819040848]],
    [ "Sherrill Substation",[-90.69755054999999, 42.57178005]],
    [ "Holy Cross Substation",[-91.01463637471072, 42.594796245121465]],
    [ "Rickardsville Substation",[-90.89758398906326, 42.58516327420429]],
    [ "998901609",[-88.48139924187659, 44.20159811472129]],
    [ "998911257",[-88.47938736292703, 44.19307783074035]],
    [ "Georgia Power",[-83.12796332373895, 34.04976654008309]],
    [ "Ernston Substation",[-74.3002788195204, 40.45617619700425]],
    [ "Dorena Substation",[-122.96532169086795, 43.77843869855074]],
    [ "CIPCO",[-90.83651300532807, 42.44782144443315]],
    [ "Maquoketa Valley REC",[-90.73398846074865, 42.404382125103275]],
    [ "999163230",[-81.87064424692122, 41.29681392461318]],
    [ "National Substation",[-91.23675645000002, 42.92653705]],
    [ "Marquette Substation",[-91.21043137775106, 43.02113289506397]],
    [ "Alliant Energy",[-91.4329424, 43.0588108]],
    [ "Millville Substation",[-91.14100391156359, 42.69713822564813]],
    [ "Elk Wind Farm",[-91.3714311618758, 42.58400117822555]],
    [ "Bond Substation",[-91.37147023986903, 42.58352184743006]],
    [ "Ryan REC Substation",[-91.50087085000001, 42.347134399999995]],
    [ "Ryan Substation",[-91.48001701432014, 42.34936907506759]],
    [ "Petersburg Substation",[-91.25269741339585, 42.53676143106748]],
    [ "Hopkinton Substation",[-91.18890795613262, 42.354360621350054]],
    [ "Pfeiler Substation",[-91.19026086332308, 42.455332874907484]],
    [ "Masonville Substation",[-91.57873386241978, 42.481276774992644]],
    [ "Prairie Substation",[-91.51964498937075, 42.46980932022835]],
    [ "Delaware Substation",[-91.34496033662559, 42.45564863102162]],
    [ "999282533",[-98.9326129745436, 35.18913762599144]],
    [ "999306097",[-116.65240437477678, 43.65899329573161]],
    [ "999517332",[-88.47403933817105, 44.19489125939224]],
    [ "MidAmerican Energy",[-92.06523260000002, 42.4830281]],
    [ "999713824",[-84.4144956043446, 30.614424474682007]],
    [ "999739536",[-88.55795095267223, 44.27203451935457]],
    [ "999739547",[-88.86925198295741, 44.25798767622422]],
    [ "Hartman Creek",[-89.1843948823204, 44.35907630397154]],
    [ "Sheridan",[-89.18385013927544, 44.40061051994661]],
    [ "Kingsport Power Company",[-82.54745052211435, 36.55460670547204]],
    [ "Athens Utilities Board",[-84.67472210000001, 35.4747611]],
    [ "Kalamazoo Substation",[-85.62645935244377, 42.11238501346628]],
    [ "1000415196",[-82.27637984213494, 35.0047575003416]],
    [ "1000522072",[-88.07100337192539, 44.4650320416991]],
    [ "1000522078",[-88.08197415133029, 44.45854121967104]],
    [ "1000534302",[-81.87959718775933, 41.400753669753094]],
    [ "1000551542",[-81.87104069504517, 41.406306920692174]],
    [ "1000651986",[-99.02953595207603, 35.27706079952085]],
    [ "1000652010",[-98.99359788789506, 35.2931712249043]],
    [ "OAK ST",[-88.07648883033785, 44.44868105524413]],
    [ "Eagleville Substation",[-120.11837535000001, 41.333577649999995]],
    [ "Steamboat Substation",[-120.14836530994818, 41.44188532515278]],
    [ "1000897733",[-99.0204743, 35.46471214999999]],
    [ "1000931272",[-80.02744915, 36.332711700000004]],
    [ "1000955233",[-106.65457262515831, 35.228207441817084]],
    [ "1000955234",[-106.65456504207584, 35.2276682748426]],
    [ "1000978357",[-114.84206105830533, 47.1431074166635]],
    [ "1001047680",[-134.05224042468288, 58.23007860479973]],
    [ "1001084361",[-81.24569050866852, 32.72498636787818]],
    [ "1001111889",[-77.9684522712633, 38.19666768569067]],
    [ "1001111890",[-77.9916901802739, 38.0985560578915]],
    [ "1001121237",[-82.18934172861275, 34.92436959607068]],
    [ "Gordon's Corner Substation",[-74.30499175180825, 40.31149094078485]],
    [ "Fort Bidwell Substation",[-120.16780320000001, 41.8458254]],
    [ "Lake City Substation",[-120.18193944999999, 41.613529]],
    [ "1001525772",[-120.35910457955637, 42.178122708928754]],
    [ "1001525773",[-120.35823005, 42.17816765]],
    [ "1001525774",[-120.35896094999998, 42.17755595]],
    [ "1001546778",[-120.36577834188975, 42.18915322441297]],
    [ "MidAmerican Energy",[-92.34531267507508, 42.50495939692909]],
    [ "Sayreville Substation",[-74.35841113177088, 40.470513673110574]],
    [ "1002164985",[-92.89799776410447, 43.587527618786]],
    [ "St. Albans Tap Substation",[-73.11914232544584, 44.80698268921318]],
    [ "1002282787",[-81.90635155859133, 37.816533312316054]],
    [ "Rose Hill Substation",[-88.29037522205917, 44.29400067209842]],
    [ "Tobacnoir Street Substation",[-88.2667811150444, 44.28902505538985]],
    [ "Milliken Substation",[-82.55618043014606, 31.538916814872792]],
    [ "Georgia Power",[-82.86485922090574, 31.487960056179194]],
    [ "Georgia Power",[-82.84014494764448, 31.48857180654954]],
    [ "Georgia Power",[-82.84786692625099, 31.505886079458854]],
    [ "Big Creek Substation",[-82.42845405334859, 31.6621556938363]],
    [ "Georgia Power",[-82.47798810142852, 31.542187632931405]],
    [ "Georgia Power",[-82.47740246545492, 31.54239482899297]],
    [ "Spring Creek Substation",[-103.1780019252068, 43.952775857731595]],
    [ "Arnot",[-89.42469779018117, 44.46580922889596]],
    [ "Public Service Company of Oklahoma",[-96.11942355000002, 36.10009875000001]],
    [ "Pawnee",[-96.79948915273165, 36.34991410988677]],
    [ "Elm Street Substation",[-79.1338936307522, 37.40624325147582]],
    [ "Perkins Park Substation",[-79.15551220445845, 37.38732095322871]],
    [ "Pine Grove Substation",[-82.44539599637639, 31.819710632063895]],
    [ "Rayonier Substation",[-82.32244463102361, 31.767829846575133]],
    [ "Gainer Cotton Gin Substation",[-82.25490545000001, 31.617952200000005]],
    [ "Brentwood Substation",[-82.11893755000001, 31.687458499999995]],
    [ "Hatch Site Substation #1",[-82.35296734041655, 31.931682570765954]],
    [ "1003290166",[-111.85528266304512, 41.76459726310003]],
    [ "Stanley Substation",[-82.36123459610086, 31.978786183370545]],
    [ "Kibee Substation",[-82.50899876647652, 32.27073399971264]],
    [ "Georgia Power",[-82.50175199006377, 32.42867372010672]],
    [ "Appalachian Power Company",[-81.95005487791973, 38.44781287289397]],
    [ "Winnebago Substation",[-88.40011136293586, 44.269298344370355]],
    [ "1003810612",[-88.39197178803505, 44.27181272945504]],
    [ "1003810635",[-88.37251066709106, 44.26638524104648]],
    [ "1003810638",[-88.37660362152175, 44.26325091875096]],
    [ "Becco Substation",[-81.81213865000001, 37.785423550000004]],
    [ "1004581778",[-87.47210482495296, 41.464616107605316]],
    [ "1004610937",[-88.3341426779066, 44.277211465745914]],
    [ "1004618883",[-88.4565330751554, 44.20324589567105]],
    [ "1004618885",[-88.45426944818165, 44.2059649558457]],
    [ "1004618889",[-88.45611048822119, 44.20545024078836]],
    [ "1004618892",[-88.45644250000001, 44.20516845]],
    [ "1004710798",[-88.43727571702028, 44.23199128811922]],
    [ "Cargo Substation",[-83.5010558255056, 42.389954254850714]],
    [ "Anita Substation",[-83.55767155452784, 42.395076933869085]],
    [ "Sawyer Lumber",[-87.39434782980578, 46.32903358057948]],
    [ "1005017065",[-118.47958938233694, 37.3346690861895]],
    [ "St Germain",[-89.46960889067167, 45.897018904263824]],
    [ "Woodmin",[-89.7565447714134, 45.90930331426838]],
    [ "1005116098",[-89.52702014855684, 43.558202551015285]],
    [ "1005439780",[-116.41266637224486, 43.720437061723366]],
    [ "NE 54th Ave Substation",[-93.44618489923756, 41.65921850223715]],
    [ "Entergy Arkansas",[-92.68059160000001, 34.88978015]],
    [ "Swainsboro Substation #2",[-82.33415159999998, 32.61363255]],
    [ "Swainsboro Substation",[-82.3194712, 32.592240600000004]],
    [ "Pinetucky Substation",[-82.4482060420074, 32.685683069254715]],
    [ "Kite Substation",[-82.51731081743714, 32.6964229988198]],
    [ "Georgia Power",[-82.59072578749496, 32.711003836614]],
    [ "Georgia Power",[-82.70291975, 32.73591145]],
    [ "Midville Substation",[-82.23283020000001, 32.8291643]],
    [ "Midville Substation #9",[-82.23372247678454, 32.82885099534216]],
    [ "Northeast Emanuel Substation",[-82.24383018509681, 32.783355020773726]],
    [ "Millen Substation",[-81.94828901862853, 32.80832619609796]],
    [ "Alexander Substation",[-81.88113936843898, 33.025110357943774]],
    [ "Mills Road Substation",[-82.00080221335261, 33.103743301057364]],
    [ "Gough City Substation",[-82.17799869537829, 33.09581084557159]],
    [ "Georgia Power",[-82.22612946994295, 33.09797079620906]],
    [ "Georgia Power",[-82.36663734141726, 33.15973898518334]],
    [ "Wrens 46/12 kV Substation",[-82.38411697866708, 33.21730761520865]],
    [ "Wadley Substation",[-82.41614208476895, 32.884702973994436]],
    [ "1006095181",[-102.47174048725432, 31.033707871610265]],
    [ "1006095188",[-102.30951884999999, 31.0136135]],
    [ "Soaptree Switching Station",[-102.39363692490596, 31.0830606071265]],
    [ "Lynx Substation",[-102.39350681981138, 31.07185929572859]],
    [ "Coral Substation",[-103.72265893434667, 31.03750946908647]],
    [ "Cryo Substation",[-103.72069002151105, 31.046801455797777]],
    [ "Sand Lake Switching Station",[-103.46451731061849, 31.510502320169063]],
    [ "Ebenezer Substation",[-82.4820452, 32.97750365]],
    [ "Davidsboro Substation",[-82.60415169188451, 32.98186302023761]],
    [ "1006156501",[-82.59173935365531, 32.9810504730022]],
    [ "Bartow Substation",[-82.46879082266757, 32.885737306089915]],
    [ "1006193633",[-94.9455603264613, 35.871546000724834]],
    [ "Rhinelander Paper",[-89.4188630690031, 45.640101008540476]],
    [ "Grandfather Falls Transmission Substation",[-89.7902553040357, 45.30152045430859]],
    [ "Grandfather Falls Generator Substation",[-89.79137557601658, 45.30145292955921]],
    [ "Lakehead Iron River",[-88.66076115, 46.1268201]],
    [ "Horseshoe Springs Switching Station",[-104.2260972793986, 31.82804484804707]],
    [ "Kyle Ranch Substation",[-103.6516483, 31.93064715]],
    [ "1006279925",[-103.86139132754259, 31.793346290716798]],
    [ "Riverton Switching Station",[-103.86073324021082, 31.806835537024146]],
    [ "Oncor",[-103.8588925254169, 31.86328888959098]],
    [ "Oncor",[-103.86321202259168, 31.86259782781663]],
    [ "Tunstill Substation",[-103.86117604999998, 31.8742393]],
    [ "Owl Hills Substation",[-104.06325972495706, 31.982802544253218]],
    [ "1006279967",[-104.32353862504733, 31.93301940522002]],
    [ "1006279968",[-104.32360826625289, 31.93175303293699]],
    [ "1006279977",[-104.3440119, 31.88476505]],
    [ "1006280001",[-103.98285217291932, 31.8085609250787]],
    [ "3-Mile Draw Substation",[-103.98300762498724, 31.814268495123937]],
    [ "Mentone Substation",[-103.66517903023676, 31.644613192004606]],
    [ "1006401425",[-103.84800672511047, 31.64644240675313]],
    [ "1006401438",[-103.51808147465272, 31.509248705042474]],
    [ "Pecone Substation",[-103.51735905000002, 31.509673650000007]],
    [ "1006401454",[-103.59993178062173, 31.45796429226103]],
    [ "Mcllvain Substation",[-103.61649696506154, 31.50867766811765]],
    [ "1006401463",[-103.70996317504233, 31.904133394038848]],
    [ "Lindley Ranch Substation",[-103.73120763078046, 31.795572005270344]],
    [ "1006401478",[-103.70065939999999, 31.682845649999997]],
    [ "1006401489",[-103.82290954428636, 31.545836324825682]],
    [ "1006401490",[-103.82480299532926, 31.547434416502387]],
    [ "1006401491",[-103.82669992335065, 31.545055585872536]],
    [ "Maverick Draw Substation",[-104.11890249291329, 31.666668674954376]],
    [ "1006404960",[-103.62650825000001, 31.7782306]],
    [ "Quarry Field Switching Station",[-103.63875886566878, 31.782928963995474]],
    [ "Lakehead Rapid River",[-86.97273265, 45.9442475]],
    [ "Gladstone",[-87.0042939094327, 45.84755287180218]],
    [ "Old Mead Road",[-87.07427399297654, 45.81928270278501]],
    [ "Mead Pump",[-87.05969999960642, 45.80245258200498]],
    [ "1006561802",[-102.6994982, 31.64286465]],
    [ "1006561808",[-102.79226302945655, 31.617544660708447]],
    [ "1006561809",[-102.79383225000001, 31.6075186]],
    [ "Wolf Switching Station",[-102.93274687773935, 31.601806085272663]],
    [ "1006561834",[-103.6237872, 31.786792650000002]],
    [ "1006613097",[-103.11308720000001, 31.276645350000006]],
    [ "1006613098",[-103.08868460000002, 31.2690987]],
    [ "Trans-Pecos Substation",[-103.1176339687499, 31.27538055682054]],
    [ "1006613118",[-103.09506007502398, 31.27366399526799]],
    [ "1006613125",[-103.10704138769424, 31.28291952484474]],
    [ "Lotebush Substation",[-103.11710749999999, 31.291603199999997]],
    [ "1006613148",[-103.15792803205657, 31.294420834828323]],
    [ "Pacific Gas and Electric Company",[-121.80434803505733, 37.75208661950746]],
    [ "North Dublin Substation",[-121.85784977593013, 37.744747976150684]],
    [ "Cayetano Substation",[-121.77125433251315, 37.738519643015586]],
    [ "1006822049",[-78.84057626618772, 37.91836512442962]],
    [ "1006822052",[-78.92836789813796, 37.934013143825666]],
    [ "East Dothan Substation",[-85.36328363759807, 31.23463421957001]],
    [ "East Haven Substation",[-85.36717722645565, 31.209115845299948]],
    [ "1006914121",[-103.06607612506099, 31.167624407131324]],
    [ "1006914128",[-103.02614724999998, 31.33087045]],
    [ "1006914142",[-103.06771412147809, 31.352552804026814]],
    [ "1006914143",[-103.07629310562457, 31.343290297428474]],
    [ "1006914147",[-103.0966174384296, 31.31747968084815]],
    [ "1006914156",[-103.09995509097683, 31.298397716602533]],
    [ "1006922785",[-103.27803220858088, 31.515772592597994]],
    [ "1006922790",[-103.17978719922989, 31.55657341693259]],
    [ "1006922798",[-103.1830437333809, 31.522853947936444]],
    [ "1006922799",[-103.18294712021842, 31.539475545469973]],
    [ "1006922805",[-103.12940348561212, 31.5540074307692]],
    [ "1006929070",[-103.16187660369802, 31.422662833421146]],
    [ "1006929077",[-103.16034635801552, 31.417489869097405]],
    [ "1006929080",[-103.28784791062806, 31.37758667831952]],
    [ "1006929084",[-103.32852707451686, 31.35613129247784]],
    [ "Olin Corp. Substation",[-81.94965377120464, 33.34536931900921]],
    [ "1007026782",[-81.93614109690371, 33.43149643718611]],
    [ "Georgia Power",[-81.9681226029357, 33.468644002941105]],
    [ "Turphy Hill Substation",[-81.98929833707656, 33.44813740116348]],
    [ "West Augusta Substation",[-82.04113626036458, 33.452329468194016]],
    [ "1007121367",[-103.67406533399935, 31.36782857506465]],
    [ "1007121385",[-103.68227595, 31.3593737]],
    [ "Texas-New Mexico Power",[-103.32178720000002, 31.645047350000002]],
    [ "Pecos Substation",[-103.49942227411394, 31.427443286189142]],
    [ "1007123840",[-103.44526655974978, 31.24071167477926]],
    [ "1007123845",[-103.44642545964749, 31.275781824927684]],
    [ "Eagle Claw Midstream Substation",[-103.50377554999999, 31.332815700000005]],
    [ "1007173904",[-82.9900615325557, 44.040179751508724]],
    [ "Torrecillas Substation",[-98.84008482473719, 27.619042193378633]],
    [ "Moundville Substation",[-87.55487906911, 32.95210235565909]],
    [ "Highway 589 Substation",[-89.4075374300768, 31.151876884633776]],
    [ "1007524342",[-80.34889471815845, 35.73837210490505]],
    [ "1007582734",[-103.45568814171281, 31.779448224141788]],
    [ "Oncor",[-103.45584977649149, 31.778826947222136]],
    [ "Pence Substation",[-86.76270315000001, 34.448692349999995]],
    [ "QTS Substation #2",[-84.41862044999999, 33.77648375]],
    [ "Sacramento Municipal Utility District",[-121.30660137512261, 38.604967881897785]],
    [ "1007897687",[-86.03276435000001, 34.02835555]],
    [ "Arkadelphia North Substation",[-93.06241272362871, 34.1444886435272]],
    [ "1008133854",[-112.0991191420994, 40.5849715213737]],
    [ "1008133857",[-112.29626530189, 40.51534981245514]],
    [ "1008133885",[-112.12119567841123, 40.71376927984457]],
    [ "Goshen Substation",[-81.20947238673571, 32.24870121447524]],
    [ "Laurel Substation",[-75.22972050184426, 39.44536182704029]],
    [ "1008258684",[-82.53493041255774, 37.481394986683654]],
    [ "1008259600",[-82.56314082517058, 37.47990825133936]],
    [ "1008274118",[-82.64132702875801, 37.55638080750777]],
    [ "1008277213",[-81.9404345, 33.5056555]],
    [ "Beech Street Retail Substation",[-82.46000040920343, 35.32994240898398]],
    [ "West Carroll Substation",[-85.41853365484958, 31.199020475049167]],
    [ "Winterset Substation",[-93.97590735223334, 41.30457092609516]],
    [ "Patterson Substation",[-93.91691370931495, 41.30158897526308]],
    [ "Patterson Substation",[-93.8799068917861, 41.35333052573957]],
    [ "Winterset Pumping Station",[-94.11894698501045, 41.41997697488594]],
    [ "Arbor Hill Substation",[-94.26271299558992, 41.46688344415328]],
    [ "Adams County Substation",[-94.66019829202392, 40.93652178306146]],
    [ "Rolling Hills Substation",[-94.3981261589595, 41.18113711471625]],
    [ "Orient Wind Farm",[-94.39794995029958, 41.18756185755829]],
    [ "1009030346",[-112.05827420000001, 40.784513399999994]],
    [ "Pinto Creek Substation",[-100.56176930000001, 29.350502700000003]],
    [ "1009128164",[-88.6518368596027, 44.34220192916515]],
    [ "Oncor",[-103.10683090981743, 31.775917120669085]],
    [ "1009150323",[-103.39458548000482, 31.817713757601794]],
    [ "Oncor",[-103.43235104954046, 31.778578478214875]],
    [ "1009182666",[-102.96457019418462, 31.841153368392295]],
    [ "1009182668",[-102.91482728803076, 31.859294725947333]],
    [ "1009182703",[-102.9255028298937, 31.80025929321186]],
    [ "Oncor",[-102.86825606599032, 31.841391369962672]],
    [ "Oncor",[-102.5742173, 31.869692000000004]],
    [ "1009208929",[-99.42188615, 31.235506]],
    [ "1009208939",[-100.59873612964685, 31.516555023132913]],
    [ "1009212698",[-101.65776395, 31.7590067]],
    [ "1009212700",[-101.55893547925984, 31.774509357985295]],
    [ "Rosholt CEC",[-89.28645612444436, 44.65689134343083]],
    [ "Groenier",[-89.4213694, 44.6837229]],
    [ "Marion",[-88.87874945, 44.67582945]],
    [ "1009376627",[-88.89521715000001, 44.822685850000006]],
    [ "Aliant Energy",[-88.98193827289137, 44.864318375037065]],
    [ "1009376637",[-88.82748802149867, 44.972579081910666]],
    [ "HD Wind Substation",[-94.61160802349623, 41.58489515830068]],
    [ "1009756259",[-87.59473139999999, 33.4796379]],
    [ "Bankston Substation",[-87.6736332753898, 33.66839058911517]],
    [ "Kingville Junction Substation",[-88.03486440263748, 33.661357499554946]],
    [ "South Vernon Substation",[-88.11555, 33.749320350000005]],
    [ "1009790898",[-122.93732155000001, 48.497537200000004]],
    [ "Persia Substation",[-83.01910104040044, 36.35358557325769]],
    [ "Moselem Substation",[-75.84074232672789, 40.486931226663515]],
    [ "Consumers Energy",[-85.55999915065917, 42.3101360473057]],
    [ "Washington Metropolitan Area Transit Authority",[-77.36239715442242, 38.953585594649]],
    [ "Southton Substation",[-98.4091283533193, 29.313171518334716]],
    [ "Bristol Tennessee Essential Services",[-82.40987746874515, 36.49044624271685]],
    [ "1010361023",[-85.97390365873905, 41.68064941444437]],
    [ "1010372974",[-89.61240979092068, 34.995610363870455]],
    [ "Overland Trail Substation",[-95.79774953089456, 41.19829850841517]],
    [ "Portland Switch Substation",[-86.21565597622227, 30.574105580969523]],
    [ "Bolingbroke Substation",[-83.77561287909514, 32.95099453006457]],
    [ "Twin Pines Substation",[-83.74581980075388, 32.83561726908437]],
    [ "Bass Road Substation",[-83.71334034276205, 32.93750898229702]],
    [ "Georgia Power",[-83.68459891713132, 32.8970499527187]],
    [ "Georgia Power",[-83.63112420171912, 32.844321133016564]],
    [ "Town Creek Substation",[-83.66549829011979, 32.907782274999]],
    [ "Clinton Substation",[-83.55820620106901, 32.99879111664722]],
    [ "Georgia Power",[-83.49493030000001, 32.92921095]],
    [ "Duke Energy",[-98.74550655, 26.523778900000003]],
    [ "Amherst Jct",[-89.31113602204711, 44.47599724348954]],
    [ "Hoover",[-89.52971831855048, 44.50411194352827]],
    [ "1010992050",[-89.57998968640094, 44.48911174298247]],
    [ "MidAmerican Energy",[-95.7921437, 41.263734850000006]],
    [ "Tennessee Valley Authority",[-84.23673169340333, 36.372097951908856]],
    [ "Powell Valley Electric Cooperative",[-84.01639709835727, 36.433052932677896]],
    [ "MidAmerican Energy",[-95.2315906492649, 41.00732702402481]],
    [ "Brooks Substation",[-94.79508693375634, 40.96769266453085]],
    [ "Metomen",[-88.82636579162875, 43.80078172313435]],
    [ "Barland",[-87.88161956563047, 42.93227179744524]],
    [ "Golden Sands",[-89.45103940000001, 44.36537715]],
    [ "ACEC Wildrose",[-89.24477894072216, 44.22373933892631]],
    [ "Wild Rose",[-89.24772471862228, 44.18491394896552]],
    [ "ACEC Wild Rose Pump",[-89.26773316576278, 44.14689315765542]],
    [ "ACEC Wautoma",[-89.28719779455739, 44.104821827547745]],
    [ "1011139646",[-95.93729564940034, 32.47230249668963]],
    [ "1011139648",[-96.0304434171152, 32.4789187167361]],
    [ "1011139650",[-96.11359724240991, 32.437163823224864]],
    [ "Silver Lake (ALTE)",[-89.23405179042688, 44.047435153461514]],
    [ "ACEC Spring Lake",[-89.15802756142213, 44.03030008024238]],
    [ "Red Granite",[-89.11043937476639, 44.03762634064771]],
    [ "Fountain Valley",[-88.98691515131291, 44.10907932562877]],
    [ "River Run",[-88.94619573322103, 43.9911383834509]],
    [ "Berlin",[-88.9344210594076, 43.96070390913521]],
    [ "Fox River",[-88.9498269250124, 43.96629790585479]],
    [ "E. C. Lavender Substation",[-83.11054220000001, 33.0215936]],
    [ "Robins Spring Substation",[-82.87976262667229, 33.00542669085782]],
    [ "Ashbury Substation",[-83.37101512065463, 32.79931706011766]],
    [ "Georgia Power",[-83.38520124598882, 32.72325383060163]],
    [ "Georgia Power",[-83.19976620720101, 32.83842015393548]],
    [ "Georgia Power",[-83.05126121591995, 32.77748960582591]],
    [ "Georgia Power",[-82.93320623361564, 32.58165606636621]],
    [ "1011244035",[-96.07673768762277, 33.00280081317481]],
    [ "1011244036",[-96.0745965003214, 33.004431865976045]],
    [ "1011244940",[-96.0708035976822, 33.00942584112886]],
    [ "Kentucky Utilities Company",[-82.98449925548613, 36.97465503128209]],
    [ "North Arkansas Electric Cooperative",[-92.20420109999999, 36.37659305]],
    [ "Stockwell Substation",[-83.29620531353773, 42.64491646925562]],
    [ "1011533668",[-86.43156733314731, 36.992753302306596]],
    [ "1011568090",[-86.42085324558657, 36.94604383075725]],
    [ "1011581596",[-80.85175209999998, 35.154700250000005]],
    [ "Sunset Lake Substation",[-75.72799134422279, 39.61326282869273]],
    [ "Patterson Switchyard",[-82.13646169214647, 31.393333508610308]],
    [ "Dixons Mill Substation",[-87.77076162666772, 32.067024559101746]],
    [ "1011749387",[-86.55741522755054, 36.79553961406805]],
    [ "1011751667",[-86.57708192827783, 36.74327009975685]],
    [ "Gulfstream Hangar Substation",[-81.20643713982517, 32.120862224887304]],
    [ "Newell Recycling Substation",[-81.17492978091086, 32.10219114243834]],
    [ "Georgia Power Substation",[-81.14633987400296, 32.09612039722686]],
    [ "Georgia Power",[-81.12316753034581, 32.09525763084258]],
    [ "Coleman Substation",[-81.11607696193013, 32.097319771016814]],
    [ "Herty Substation",[-81.14374528278914, 32.11131740143336]],
    [ "Gulfstream 1 Substation",[-81.1966034159555, 32.13845846739729]],
    [ "Gulfstream 3 Substation",[-81.19096534006243, 32.13673722581906]],
    [ "Gulfstream 2 Substation",[-81.1932891607071, 32.13695177408668]],
    [ "1011907519",[-85.29920813012775, 37.084245319334045]],
    [ "1012049856",[-86.57706193834152, 36.77361262502437]],
    [ "1012099803",[-86.56673781151976, 36.72444364669623]],
    [ "1012138307",[-86.5422327, 36.71951265]],
    [ "Silgan Plastics Substation",[-83.71218916937283, 33.76697849601877]],
    [ "Flanbeau Plastics Corp. Substation",[-83.70837154999998, 33.76987465]],
    [ "Georgia Power",[-83.70165655, 33.77427135000001]],
    [ "Harrison Poultry Substation",[-83.7056541, 33.93034365]],
    [ "Georgia Power",[-83.7252087254508, 33.92843395697976]],
    [ "Appalachian Power Company",[-81.00930253167488, 37.94495894364887]],
    [ "1012475195",[-86.51874262695401, 36.713331459432254]],
    [ "Gaines Ferry Substation",[-83.96118523761909, 34.170718682345395]],
    [ "Georgia Power",[-83.998119, 34.1396596]],
    [ "Rock Quarry Substation",[-83.92839700803579, 34.07885391743271]],
    [ "Mall of Georgia Substation",[-83.97007350569133, 34.0650148679978]],
    [ "Ivy Creek Substation",[-83.98950052442842, 34.048330065485594]],
    [ "North AWRF Substation",[-84.01799224617018, 34.05584354179736]],
    [ "Georgia Power",[-84.17092519334125, 34.160323206684765]],
    [ "Georgia Power",[-84.1936086434522, 34.15744787600641]],
    [ "Georgia Power",[-84.25043353733031, 34.158304800450225]],
    [ "Georgia Power",[-84.1921870975253, 34.19665472730146]],
    [ "Georgia Power",[-84.14783174303955, 34.19581437966922]],
    [ "Johns Creek Substation",[-84.17175638729431, 34.051326257840486]],
    [ "Galesburg Substation",[-85.41404002491451, 42.28876539336991]],
    [ "1012933021",[-83.18334618208621, 38.2928557027176]],
    [ "Central Virginia Electric Cooperative",[-78.19783368927946, 37.967656535339565]],
    [ "DTE Energy",[-83.37119049114823, 42.35850301470084]],
    [ "1013187161",[-86.19985177437246, 36.75644205827884]],
    [ "Ottumwa Switching Station",[-92.47990256119934, 40.953331579735675]],
    [ "Paxton Substation",[-71.94541006663869, 42.29143750030885]],
    [ "Woody Substation",[-92.3710137995447, 41.004297304564396]],
    [ "Alliant Energy",[-92.36954616334789, 41.004227580721015]],
    [ "1013205488",[-86.18327046875864, 36.76599230362567]],
    [ "1013239201",[-82.20470169999999, 34.961964650000006]],
    [ "Bear Substation",[-75.66589160731893, 39.659462308152804]],
    [ "1013379918",[-97.12250519655153, 32.15339560792862]],
    [ "Port Calcite Substation",[-83.79196944026324, 45.41013301711585]],
    [ "Rockport Substation",[-83.42451933188899, 45.289412125133765]],
    [ "Public Service Company of Oklahoma",[-95.91781834788391, 36.13898319042575]],
    [ "Public Service Company of Oklahoma",[-95.92042592190741, 36.06655546429675]],
    [ "Entergy Arkansas",[-93.0925413024926, 34.40288591683355]],
    [ "Entergy Arkansas",[-93.17764397545744, 34.45107684292028]],
    [ "Entergy Arkansas",[-93.21049089919003, 34.51356046937118]],
    [ "Clarkridge Substation",[-92.35702848931486, 36.46693452962982]],
    [ "1013633143",[-84.60875219295495, 37.86432048649807]],
    [ "Chandler Substation",[-82.97455303916382, 42.3891297217984]],
    [ "1013816292",[-90.60090800722867, 37.245441426826716]],
    [ "Lucas County Substation",[-93.30420746986461, 41.049455248810894]],
    [ "1013885641",[-86.19076799999999, 36.721567500000006]],
    [ "1013897002",[-87.75013277542234, 43.76873780462076]],
    [ "Beacon Substation",[-92.697898967205, 41.27165049286568]],
    [ "1014034409",[-113.61392432619346, 37.03639812091902]],
    [ "Public Service Company of Oklahoma",[-95.95969769148016, 36.06840945277697]],
    [ "1014155681",[-85.67198960093472, 36.710866958720665]],
    [ "1014449457",[-83.29647409084245, 42.3123372789768]],
    [ "1014452630",[-108.7614337903137, 45.65675023784676]],
    [ "1014497074",[-95.61642418409764, 36.31761927701546]],
    [ "1014503821",[-96.41767468367239, 36.21674856633599]],
    [ "KAMO Power",[-97.07592347451875, 36.20222624265176]],
    [ "Perry",[-97.19492362523383, 36.20227354389179]],
    [ "Central",[-97.05414089680384, 36.11876921670106]],
    [ "Boomer Lake",[-97.06704403627212, 36.14306524591192]],
    [ "Northeast",[-87.62861984331406, 44.131185813094575]],
    [ "1014635317",[-83.19859464806022, 42.18432479991852]],
    [ "Ferguson",[-97.03494258895832, 36.15990856396961]],
    [ "Oklahoma Gas & Electric",[-97.06846060205268, 36.2604938228601]],
    [ "City of Stillwater",[-97.05524197546531, 36.164300500733134]],
    [ "Clinton Substation",[-88.99550765000001, 36.66363635]],
    [ "1014742272",[-81.51232721302398, 37.45190061671207]],
    [ "Branch River Substation",[-87.8795578210592, 44.21557194600454]],
    [ "CIPCO",[-94.34848563905267, 41.11391537495254]],
    [ "Alliant Energy",[-94.0630667039885, 41.10646532109958]],
    [ "Clarke Electric Cooperative",[-93.93731498521893, 40.954543698506605]],
    [ "1014969702",[-87.98349192342397, 43.74655914006348]],
    [ "Plymouth Sub 3",[-87.9207582, 43.760066150000014]],
    [ "Northside",[-87.82063122434677, 43.74182149236561]],
    [ "Adams St",[-87.80889523269168, 43.72775965096712]],
    [ "1014969717",[-87.8079110250979, 43.72720399551116]],
    [ "Bemis",[-87.84019160842213, 43.72784640812528]],
    [ "Cleveland 69",[-96.46924403305596, 36.30538463021967]],
    [ "KAMO Power",[-96.25681649556563, 36.290590224200834]],
    [ "1015052069",[-97.03315052021037, 36.18064680985939]],
    [ "Orlando",[-97.37099496232365, 36.12959674208301]],
    [ "Mulhall",[-97.46088243145888, 36.02966438048699]],
    [ "Meridian",[-97.24771224276262, 35.777323744952525]],
    [ "North Gate",[-87.72871570035689, 43.775406325410515]],
    [ "20th St",[-87.71443943743508, 43.746034158480256]],
    [ "1015072342",[-87.712702474998, 43.71921249562103]],
    [ "Sauk Trail",[-87.73153162492522, 43.7328125408459]],
    [ "Sacramento Municipal Utility District",[-121.10198755000002, 38.494746400000004]],
    [ "Deep River Substation",[-92.40877435836941, 41.570453368525705]],
    [ "Alliant Energy",[-92.40740706170958, 41.57017791094449]],
    [ "MidAmerican Energy",[-92.5633160021085, 41.60963329966366]],
    [ "Glacier Substation",[-88.25507600606522, 43.42602583927595]],
    [ "Auburn",[-88.2396573, 43.55511945]],
    [ "Butternut",[-88.44193719312551, 43.60242701859804]],
    [ "Willow Lawn",[-88.46799332487937, 43.73982534540708]],
    [ "Rienzi",[-88.4171355098288, 43.76319260156542]],
    [ "1015192600",[-71.71798056005397, 44.411187628621626]],
    [ "Gilman Substation",[-71.73351946729224, 44.412389651135]],
    [ "Georgia Power",[-81.38830772304738, 32.14671561053888]],
    [ "City of Skiatook",[-95.95567966830787, 36.36703641501467]],
    [ "1015254685",[-96.0344088157784, 36.40871951562602]],
    [ "1015269563",[-88.46304713621772, 43.77165647407598]],
    [ "1015317267",[-88.45809476602712, 43.78887201721331]],
    [ "Rosendale",[-88.66450727192262, 43.79312062872205]],
    [ "Ripon",[-88.8299521833391, 43.841027735480814]],
    [ "1015333141",[-96.17318419706777, 36.13469343692415]],
    [ "1015333142",[-96.29539780651177, 36.20860074038727]],
    [ "Fairwater",[-88.86384756212144, 43.73634286491064]],
    [ "Brandon",[-88.8047178825163, 43.738496434296174]],
    [ "Mackford Prairie",[-88.95523237489586, 43.70658355462544]],
    [ "1015405334",[-76.33489589186416, 36.46450065168906]],
    [ "Oklahoma Gas & Electric",[-97.01463239599981, 35.970485275139396]],
    [ "1015445696",[-96.71750810098655, 35.76645905745617]],
    [ "Stroud",[-96.71683565078266, 35.76810985742293]],
    [ "Northwest Ripon",[-88.8563398251899, 43.85832539200847]],
    [ "1015448918",[-88.94578170370984, 43.86595914414731]],
    [ "1015448919",[-88.94619262531313, 43.86548819653567]],
    [ "Omro Industrial Park",[-88.7213470250695, 44.03730574511341]],
    [ "Omro",[-88.75003404721568, 44.03661904351514]],
    [ "1015658513",[-95.6970215404323, 36.39396327334493]],
    [ "Knoxville Utilities Board",[-84.27151715555593, 36.009085613513996]],
    [ "Lakehead Delavan",[-88.79997614999999, 42.79841344999999]],
    [ "University",[-88.72936555000001, 42.85585495]],
    [ "1015705326",[-83.0653744187914, 35.131513897917756]],
    [ "Antrim Substation",[-77.7066481039555, 39.778138260367164]],
    [ "1015722294",[-87.11878465676497, 34.706961097738365]],
    [ "1015722298",[-87.11872388703175, 34.70612158672622]],
    [ "Browns Ferry Substation",[-87.1165941551216, 34.70509380653663]],
    [ "Yale",[-96.66744657536059, 36.10135950955181]],
    [ "Russell",[-89.04803334460568, 42.73824295087133]],
    [ "1015722603",[-89.02728727292683, 42.689101416713406]],
    [ "1015726052",[-83.40212727143677, 42.274414487887604]],
    [ "1015732926",[-117.35936253418824, 34.04114513455186]],
    [ "South Effigham Substation",[-81.28165151124959, 32.197061886700375]],
    [ "Ivanhoe Substation",[-81.47620975000001, 32.283372799999995]],
    [ "Abercorn Creek Substation",[-81.1781506, 32.255458450000006]],
    [ "EMD Chemicals Substation",[-81.1712911, 32.20063065]],
    [ "1015961032",[-77.67897688393812, 39.91463289184388]],
    [ "Centennial Park",[-89.46894348734135, 43.184561466075095]],
    [ "North Side",[-89.4502886756863, 43.20605021686429]],
    [ "Lodi",[-89.52762003976801, 43.30935608402685]],
    [ "Okee",[-89.54261817710201, 43.34836292012017]],
    [ "Merrimac",[-89.6299714849323, 43.40986646801789]],
    [ "Neffsville Substation",[-76.28475252935226, 40.10939328833898]],
    [ "Roseville Substation",[-76.28733382325245, 40.086018016564466]],
    [ "Jersey Central Power and Light",[-74.30826327974206, 40.72493595391166]],
    [ "1016029671",[-89.86900101378943, 32.487966168851564]],
    [ "1016237987",[-96.1939611476169, 35.97062439655967]],
    [ "1016237988",[-96.12183200276496, 35.95988466476028]],
    [ "1016416990",[-85.89152854075631, 36.97134484148289]],
    [ "Kaweah 3 Substation",[-118.8356433949997, 36.486072867512455]],
    [ "Haskell Substation",[-83.24552933675223, 42.245660667820346]],
    [ "1016585708",[-76.2160582, 36.318355450000006]],
    [ "1016752396",[-96.00834918356182, 35.979392516852464]],
    [ "Public Service Company of Oklahoma",[-95.98512469217073, 35.62726716798624]],
    [ "1016760381",[-91.04756913968055, 45.49258981903902]],
    [ "1016760385",[-90.55593490959403, 45.55202007545873]],
    [ "Pikes Creek",[-90.86341256275497, 46.80282069215242]],
    [ "Georgia Power",[-83.20859066481937, 34.27020849039562]],
    [ "Georgia Power",[-82.9585455637239, 34.16700973257233]],
    [ "Elberton Substation",[-82.86387459093004, 34.114149117539945]],
    [ "Georgia Power",[-82.84330759999999, 34.0885717]],
    [ "Georgia Power",[-82.90371401666665, 34.1122868]],
    [ "Sweet City Substation",[-82.93179141243978, 34.101750630764705]],
    [ "Broad River Stone Substation",[-82.9790001014969, 34.062283766702]],
    [ "Georgia Power",[-82.98920385000001, 34.04899795]],
    [ "Georgia Power",[-82.98675885, 34.045317100000005]],
    [ "Georgia Power",[-82.9868952113026, 34.03450467496657]],
    [ "Carlton Rural Substation",[-83.0993192, 34.0545089]],
    [ "1016881992",[-91.26810346360682, 46.19834610283391]],
    [ "1016962088",[-96.12313445617048, 36.26560928858068]],
    [ "Knoxville Utilities Board",[-83.85257761466904, 36.126946869302635]],
    [ "1017203847",[-90.3509748001245, 47.78792614999774]],
    [ "1017203848",[-90.10376867456104, 47.80900641032169]],
    [ "1017203851",[-90.1018849277243, 47.80860602567321]],
    [ "1017203852",[-92.1385473340923, 47.60229908131909]],
    [ "1017239845",[-90.35045487510644, 45.68363134271696]],
    [ "Crane Chase Substation",[-90.47109124999999, 45.737164050000004]],
    [ "1017239849",[-90.44483967247402, 45.93541591280665]],
    [ "Jack Frost Substation",[-75.630889316408, 41.087875648952036]],
    [ "Carbon Substation",[-75.60651887307937, 40.90665282569765]],
    [ "Christmans Substation",[-75.63387102028152, 40.94050919789487]],
    [ "Bell's Fork Substation",[-77.3507421926469, 35.56204369596336]],
    [ "Denver Substation",[-82.92232615395737, 42.396766195176994]],
    [ "1017264640",[-84.19265231618553, 40.37235099719278]],
    [ "1017291440",[-96.77008579593175, 35.96752990169486]],
    [ "1017355552",[-90.84774501980979, 42.749998465923966]],
    [ "1017355553",[-90.68168601981556, 42.77004024581531]],
    [ "1017355559",[-90.60751096124535, 42.688854824667956]],
    [ "1017355564",[-90.55346711311739, 42.453957300697205]],
    [ "1017355565",[-90.55509193080793, 42.44330393825591]],
    [ "1017386750",[-88.65446060734871, 42.060015859040824]],
    [ "Roper Industries Substation #2",[-83.48211955065739, 34.21283883506711]],
    [ "Roper Industries Substation #1",[-83.4826228879318, 34.214299757227174]],
    [ "Georgia Power",[-83.41793427278972, 34.133687891951475]],
    [ "Plantation Pipeline Substation",[-83.31800928511035, 34.06641784394229]],
    [ "East Maysville Substation",[-83.54638176496708, 34.24613336750524]],
    [ "Georgia Power",[-83.67185413290248, 34.25202791733897]],
    [ "Eastern Bypass Substation",[-77.33422913628362, 35.62341366444507]],
    [ "1017460906",[-92.34020311414932, 31.44111578916338]],
    [ "Newport Substation",[-91.18134854958528, 41.14559390505144]],
    [ "Bradford",[-88.81013399999999, 42.617123150000005]],
    [ "Georgia Power",[-83.62115211392435, 34.10182953204937]],
    [ "Jefferson Substation",[-83.56961895, 34.11817585]],
    [ "Jefferson Mills Substation",[-83.58213760000001, 34.116400950000006]],
    [ "Tallassee Hydro Project Substation",[-83.49842989999999, 33.9891595]],
    [ "Caterpillar Substation",[-83.51117042663034, 33.94373683628701]],
    [ "Georgia Power",[-83.47618544999997, 33.94195285]],
    [ "Watkinsville Substation",[-83.39224684350783, 33.86401323727354]],
    [ "Statham Substation",[-83.58722383092366, 33.95937651568988]],
    [ "Jefferson Rd Substation",[-83.57948082433767, 33.97779598968623]],
    [ "Georgia Power",[-83.46695442474473, 33.98090548786687]],
    [ "Georgia Power",[-83.39343134999999, 33.98286439999999]],
    [ "Muscatine Substation",[-91.03843083923455, 41.49303818687088]],
    [ "Swan Lake Substation",[-91.65762623472175, 41.76094959178145]],
    [ "Iowa City Enron Substation",[-91.5611655, 41.60026719999999]],
    [ "Sharon Center Substation",[-91.57950090000001, 41.582062549999996]],
    [ "MidAmerican Energy",[-91.56448041083931, 41.6725293871209]],
    [ "MidAmerican Energy",[-92.16878074254846, 41.60746462881525]],
    [ "Columbia Substation",[-89.77519396449001, 31.279264338081685]],
    [ "Mississippi Power",[-89.75156324999999, 31.23621955]],
    [ "CPC Columbia Substation",[-89.91854905000001, 31.403640250000002]],
    [ "1017735535",[-81.87845016534226, 34.9608560084499]],
    [ "Noblesvile Wellington Substation",[-85.993912046973, 40.00068514911227]],
    [ "Climax Substation",[-106.18624098254145, 39.36790220646868]],
    [ "Public Service Company of Colorado",[-106.18192095720882, 39.36850084184841]],
    [ "1018146404",[-90.44759052461784, 45.99567719424277]],
    [ "1018146405",[-90.48783775934423, 46.010331627877655]],
    [ "Saxon Pump",[-90.32852512082283, 46.49884927907595]],
    [ "Minersville",[-90.80021965581197, 46.41146066878953]],
    [ "Ramon Substation",[-106.55862113868235, 37.70509910595007]],
    [ "1018181729",[-92.33869233840595, 45.00904088526728]],
    [ "1018204466",[-85.12882824811345, 36.68025093235259]],
    [ "Weber Lake Substation",[-90.13943676213776, 46.18788121820722]],
    [ "East Kentucky Power Cooperative",[-84.84713005711305, 36.8528331271051]],
    [ "Homestead Street Substation",[-84.8484119105157, 36.838176254632195]],
    [ "East Kentucky Power Cooperative",[-84.8398675, 36.85337345000001]],
    [ "1018346903",[-90.0838381015913, 44.80859419379211]],
    [ "Yampa Valley Electric",[-107.07475684868886, 40.3489847295167]],
    [ "Turtle Creek Wind Farm",[-92.8398081460002, 43.429638556761745]],
    [ "Heartland Divide Collection Substation",[-94.80134152990587, 41.71132772505593]],
    [ "1018394162",[-96.52528760045837, 31.942477839685736]],
    [ "Big Creek Substation",[-93.67660503690489, 41.75776911983918]],
    [ "River Hills Gas Plant",[-93.61971344719115, 41.59101486249716]],
    [ "1018425669",[-84.13037404754289, 40.16098799963099]],
    [ "1018533068",[-95.99745551463322, 36.0102943368345]],
    [ "1018576922",[-84.05537145485297, 40.039588415244204]],
    [ "1018606822",[-83.24728455, 31.716878249999997]],
    [ "1018670796",[-84.05715530892161, 39.90782208926774]],
    [ "Rippey Wind Farm",[-94.23792907417983, 42.00615091891117]],
    [ "Ames Gas Turbines",[-93.58204657158389, 42.02700933530222]],
    [ "Railway Switching Station",[-94.49405074759609, 41.834034156485636]],
    [ "Jamaica Substation",[-94.24096564385974, 41.83400670139078]],
    [ "1018707784",[-103.40278881761806, 47.92415146559615]],
    [ "Connorsville Substation",[-92.09446292472455, 45.139735241993264]],
    [ "1018708524",[-92.19704527680602, 45.06274160452015]],
    [ "1018821435",[-90.69528651068998, 41.459623669303866]],
    [ "Beaver Creek Wind Farm",[-94.11692117842217, 42.10556142286939]],
    [ "Rutland Substation",[-85.31320486667407, 42.64211974284443]],
    [ "Station 255",[-77.69907643067049, 43.05158265783815]],
    [ "George Neal North Substation",[-96.37838322515343, 42.32509934865052]],
    [ "Northwest Iowa Power Cooperative",[-96.25227522200065, 42.33026367217366]],
    [ "MidAmerican Energy",[-96.37118421726663, 42.53556808504185]],
    [ "Brick Center substation",[-104.4525232792071, 39.62292137004413]],
    [ "Clayton Substation",[-92.05427902489345, 45.309247391293745]],
    [ "1018942827",[-102.76585098755056, 33.12516840029892]],
    [ "1018986166",[-80.93541188358887, 34.009671451212]],
    [ "Cedar Falls Utilities",[-92.49373104152254, 42.480100811849624]],
    [ "Electrifarm Power Plant",[-92.4193261561062, 42.440889502022316]],
    [ "MidAmerican Energy",[-92.37816403422984, 42.50528500594953]],
    [ "West Sheffield Substation",[-93.2820644, 42.85486595000001]],
    [ "1019301638",[-95.76552346957465, 35.75183796658257]],
    [ "KAMO Power",[-95.44710039062802, 35.769821011118395]],
    [ "Fifth Avenue Substation",[-89.13990961527149, 30.848830726031885]],
    [ "1019336896",[-90.14368115068649, 46.440976049647496]],
    [ "1019448924",[-83.83304259603239, 39.892593070260034]],
    [ "Oklahoma Gas & Electric",[-97.28198657329175, 36.25395652647861]],
    [ "1019581708",[-91.32912660880264, 45.98834734972863]],
    [ "1019581711",[-91.28281241679183, 45.99324564989998]],
    [ "1019581723",[-91.86740485565305, 45.829407749762346]],
    [ "1019581724",[-91.90404485, 45.81430620000001]],
    [ "1019581725",[-91.90413272272933, 45.813957774788754]],
    [ "1019581732",[-92.09365932391808, 45.81730404559203]],
    [ "1019581736",[-92.17513199999999, 45.816347300000004]],
    [ "1019581740",[-92.25198777010802, 45.82383620479287]],
    [ "1019581741",[-92.20738811196904, 45.93072955980833]],
    [ "Rice Transmission Substation",[-92.37704718885381, 43.36415110083896]],
    [ "Saratoga Wind Farm",[-92.37793805063681, 43.36477685316166]],
    [ "Crane Creek Wind Farm",[-92.37702688640199, 43.365003497488495]],
    [ "1019640572",[-82.25792961600938, 34.9239033552092]],
    [ "1019710001",[-96.80542645464558, 36.34052907905125]],
    [ "1019710006",[-96.79507705057298, 36.3537618814596]],
    [ "1019737921",[-106.49118602478829, 48.03741809512301]],
    [ "1019741876",[-106.51137134999998, 48.161141]],
    [ "1019803172",[-85.11161062437274, 36.754237093004654]],
    [ "1019810163",[-79.43006698083069, 36.08722294786171]],
    [ "1019948510",[-84.44238224087938, 31.781051173113678]],
    [ "Storm Lake Wind Farm",[-95.26051185, 42.6867157]],
    [ "James Substation",[-96.31851023607375, 42.576339419206285]],
    [ "1020324661",[-86.23362390931999, 37.17096252275599]],
    [ "Consumers Energy",[-83.7201541247769, 42.9796642912092]],
    [ "1020474904",[-85.90613884999999, 37.297447]],
    [ "1020532400",[-85.90262351018717, 37.38389955396162]],
    [ "Bonnieville Substation",[-85.90287290944838, 37.38451947999978]],
    [ "1020587221",[-106.52584875000001, 48.41034770000001]],
    [ "Mill C",[-73.61346615, 44.69819805]],
    [ "Tande",[-102.8480301598765, 48.399653746321185]],
    [ "1020655334",[-92.5786975, 44.035970150000004]],
    [ "1020691272",[-85.85557194264305, 42.1683872377092]],
    [ "1020694104",[-85.7893218657552, 42.0406669346393]],
    [ "1020694105",[-85.78709928513865, 42.040522020427915]],
    [ "1020696445",[-87.06452645585561, 41.61134406901133]],
    [ "Fort Gordon Solar Substation",[-82.1362912, 33.38301239999999]],
    [ "Georgia Power",[-82.15819439448418, 33.43893387439088]],
    [ "Dearing Substation",[-82.37946737029776, 33.41893225710237]],
    [ "Iron Hill Substation #15",[-82.42049423119755, 33.40212337515227]],
    [ "Thiele Kaolin Substation",[-82.4296662817199, 33.31550260190547]],
    [ "Thiele Kaolin Substation",[-82.44955028647671, 33.26487667877474]],
    [ "1020789743",[-73.93998213813911, 41.70988207152852]],
    [ "Wheeler Road Substation",[-82.09684410493973, 33.48345107469081]],
    [ "Georgia Power",[-82.11704482820019, 33.532265856263514]],
    [ "1020859247",[-73.93881873218763, 41.710288204068284]],
    [ "Village of Lake Placid",[-73.99826947840883, 44.278307374249934]],
    [ "Milner Substation #7",[-84.17221548175979, 33.12078095636591]],
    [ "Dixie Pipeline Substation",[-84.20554055000001, 33.150449050000006]],
    [ "North Thomaston Substation",[-84.201551, 33.19001084999999]],
    [ "North Zebulon Substation",[-84.34228072735633, 33.11448315686619]],
    [ "Southern Mills Substation",[-84.34254455, 33.07072219999999]],
    [ "Thomaston Mills Substation #2",[-84.34251705, 33.07051849999999]],
    [ "1021011193",[-94.48951546444212, 40.00938601059113]],
    [ "Ketchum Substation",[-94.49167696721999, 39.84044929536292]],
    [ "Concord Substation",[-84.43387171463723, 33.087237763207334]],
    [ "Molena 46/12 Substation",[-84.4898221071304, 33.01210453906137]],
    [ "Thomaston Substation #2 - Southern Mills",[-84.49054324999997, 32.96842434999999]],
    [ "Woodbury Substation",[-84.56884705877924, 32.97047768067468]],
    [ "Greenville Substation",[-84.71853977100092, 33.02515032263553]],
    [ "Mead Cooperation Substation",[-84.72144795, 33.0869271]],
    [ "Lanier Road Substation",[-84.9869857, 32.95828234999999]],
    [ "LaGrange Substation #12",[-85.02988404999999, 33.0305316]],
    [ "Zachary Substation",[-92.59867213835959, 40.151730450501276]],
    [ "1021087611",[-88.87145053848616, 39.71339228012317]],
    [ "Hogansville Substation #2",[-84.91290274065136, 33.168411325000974]],
    [ "Franklin Aluminium Substation",[-84.83256399625346, 33.23734721640692]],
    [ "Rainbow Plastics Substation",[-84.83497775626705, 33.23988363815133]],
    [ "Georgia Power",[-84.78555532007593, 33.37200168377742]],
    [ "Georgia Power",[-84.72717396851833, 33.35558459340346]],
    [ "Georgia Power",[-84.58981563574113, 33.28237071853972]],
    [ "Georgia Power",[-84.64768160442127, 33.19123943277803]],
    [ "W.L. Bonnell Substation #1",[-84.81781471673052, 33.38217009973785]],
    [ "Georgia Power",[-84.7891218, 33.39229845]],
    [ "Georgia Power",[-84.82522016735439, 33.391774653975254]],
    [ "KAMO Power",[-96.53074987476829, 35.85350864576206]],
    [ "1021135032",[-83.15273520023247, 30.5166996256455]],
    [ "Townline Station",[-74.774124584643, 44.456586994975275]],
    [ "Blake",[-74.7533444, 44.50631205]],
    [ "1021291644",[-92.62719698742114, 40.42428828625757]],
    [ "Higley Falls",[-74.93311136048942, 44.53031235195542]],
    [ "1021295326",[-87.5171408156841, 41.57637990042181]],
    [ "1021311103",[-81.5623017984822, 38.24373713366285]],
    [ "1021334845",[-95.23566784651953, 40.440947365421955]],
    [ "1021336983",[-95.35536505, 40.533588550000005]],
    [ "1021524446",[-88.99613325000001, 44.278928]],
    [ "Windsor Transmission Substation",[-91.8541209960595, 42.95122265888848]],
    [ "1021545807",[-88.63924524976254, 43.6482615662693]],
    [ "Koch Oil",[-88.67618234999999, 43.6973504]],
    [ "1021545821",[-88.73064106838952, 43.61589813533293]],
    [ "1021545824",[-88.72998509042608, 43.61899418705662]],
    [ "1021545827",[-88.73456135611566, 43.627484638692394]],
    [ "1021545830",[-88.75466547534282, 43.63072224401418]],
    [ "Bison Substation",[-94.01506634087792, 43.43214487656727]],
    [ "Golden Plains Wind Farm",[-94.01342848220006, 43.432126513284594]],
    [ "1021562643",[-78.51679777540043, 38.03672425823316]],
    [ "1021565668",[-88.87252353474817, 39.7918723931879]],
    [ "1021668852",[-98.03335316990466, 36.145731976059565]],
    [ "1021700176",[-87.15009123506965, 36.82117271724711]],
    [ "Advance Substation",[-85.05817505100973, 45.20158667814478]],
    [ "East Jordan Junction",[-85.07599956162395, 45.13872258018134]],
    [ "Miles Road Substation",[-85.19985304935842, 45.13361093663392]],
    [ "Barnard Substation",[-85.3124853234027, 45.24053771190073]],
    [ "Medusa Substation",[-85.29895201846942, 45.315287607684134]],
    [ "Los Cavos Sub",[-105.71721363673696, 35.09194918647144]],
    [ "1021841652",[-105.64258092007398, 34.693983754401934]],
    [ "1021855839",[-101.6853558249864, 33.04032694435506]],
    [ "1021855841",[-101.68343047623212, 33.150898400016054]],
    [ "1021859379",[-101.60060757472066, 33.303453497230315]],
    [ "1021871869",[-101.87720194189768, 33.62697364520441]],
    [ "1021871870",[-101.87711475009723, 33.62861591768576]],
    [ "1022004787",[-88.177931534709, 40.96786373699076]],
    [ "1022057234",[-90.43823614981949, 39.56935674531285]],
    [ "1022057508",[-90.43121862587431, 39.59331442108078]],
    [ "1022063468",[-90.80434912888265, 39.61895735710735]],
    [ "Pioneer Trail Wind Farm",[-88.02127025830026, 40.46345876154609]],
    [ "Secor Substation",[-85.70190513934274, 44.712107605434106]],
    [ "1022134501",[-96.65546476396514, 35.747432633462786]],
    [ "Hyde Park Substation",[-72.61644159126978, 44.599179725667355]],
    [ "1022302580",[-88.01500335052143, 39.84927615981715]],
    [ "1022433574",[-89.35866573605658, 36.921965824713304]],
    [ "Entergy Arkansas",[-91.9867634921415, 35.01719832473218]],
    [ "1022441233",[-88.53298611118483, 43.6967972201195]],
    [ "Mayville",[-88.55572279296754, 43.501568090127385]],
    [ "Spring Brook",[-88.55296068879784, 43.47906322477331]],
    [ "1022441244",[-88.59569755937548, 43.442874279567185]],
    [ "HUSTISFORD",[-88.5954559037099, 43.34465214321393]],
    [ "1022441253",[-88.65075, 43.4502027]],
    [ "1022441254",[-88.6337559559332, 43.446110824262085]],
    [ "Entergy Arkansas",[-91.96273825434297, 34.93376705944104]],
    [ "Georgia Power",[-84.12408772523442, 33.04488190516168]],
    [ "Georgia Power",[-84.10747516501071, 33.05423232009408]],
    [ "Georgia Power",[-83.97782969060235, 33.054090123733246]],
    [ "1022714431",[-96.35304730578265, 44.445249443702984]],
    [ "Entergy Arkansas",[-91.98279214999998, 34.87609525]],
    [ "DTE Energy",[-83.22766537465654, 42.155601893591545]],
    [ "Entergy Arkansas",[-92.04469305034264, 34.832846532993635]],
    [ "FORT ATKINSON",[-88.86537854102492, 42.94818057234755]],
    [ "CAMBRIDGE",[-89.02175015420332, 42.99333228041377]],
    [ "1022730174",[-89.30106726607492, 42.98497810043953]],
    [ "SUN VALLEY",[-89.44084575, 42.92751885]],
    [ "1022744253",[-77.41337264867687, 38.98874683550217]],
    [ "1022879431",[-97.89630171887924, 35.856353356515534]],
    [ "Georgia Power",[-83.96758684431987, 33.96946813167181]],
    [ "Warner Substation",[-116.67598087693459, 33.247260649754175]],
    [ "Entergy Arkansas",[-92.31637763362846, 34.141950662113295]],
    [ "Island Home Substation",[-83.89060675436997, 35.95635913493238]],
    [ "1023085157",[-97.80179377378937, 45.12890998595863]],
    [ "1023085159",[-97.84711567387566, 45.086029529051196]],
    [ "1023091967",[-97.58415284871721, 35.79079542554037]],
    [ "1023091971",[-97.76395505292372, 35.79057985182704]],
    [ "NEW GLARUS",[-89.62298669999998, 42.803704350000004]],
    [ "IDLE HOUR",[-89.64177232464124, 42.62014790410218]],
    [ "1023096114",[-89.87604574244193, 42.698092689528586]],
    [ "1023096116",[-89.8688695, 42.698937877214036]],
    [ "1023096117",[-89.93077732711487, 42.610363960538535]],
    [ "GRADIOT",[-89.98953583947929, 42.60959619723574]],
    [ "Washington Metropolitan Area Transit Authority",[-77.44908837434912, 38.97358048172217]],
    [ "Washington Metropolitan Area Transit Authority",[-77.45041158552822, 38.97711046645829]],
    [ "Washington Metropolitan Area Transit Authority",[-77.4543861152232, 38.98589223506342]],
    [ "Appalachian Power Company",[-81.8475288146786, 37.39230754513452]],
    [ "1023371033",[-91.1238166239786, 37.63871321071571]],
    [ "Washington Metropolitan Area Transit Authority",[-77.46030004999999, 38.9833565]],
    [ "1023442395",[-84.46032954271946, 39.45039032897098]],
    [ "1023470334",[-99.56048078998163, 44.42890457497048]],
    [ "1023470336",[-99.56052586084304, 44.42693042505178]],
    [ "1023480895",[-117.40920004346232, 34.13541174679615]],
    [ "RED HAWK",[-88.91344227060088, 42.75824978412485]],
    [ "Fulton",[-89.03250314950596, 42.77513526772996]],
    [ "SAUNDERS CREEK",[-89.06589437531626, 42.82583550074197]],
    [ "DANA CORP",[-89.09256458057781, 42.839542725147524]],
    [ "STOUGHTON SOUTH",[-89.21858530016623, 42.90440669007741]],
    [ "BROOKLYN",[-89.3686398, 42.86360154999999]],
    [ "Colonial Pipeline Substation",[-83.23382774074487, 34.09449866629448]],
    [ "WAUNAKEE MUNICIPAL 2",[-89.44772879524736, 43.18773162434161]],
    [ "1023717023",[-93.25150642480448, 41.88850013963548]],
    [ "1023827191",[-91.6596149399919, 44.75532102492157]],
    [ "1023828649",[-92.36517837065686, 45.18006894607505]],
    [ "1024013734",[-89.31116892211872, 43.062713560495766]],
    [ "1024013740",[-89.30098829999997, 43.06495295]],
    [ "1024014059",[-95.56937490003828, 41.89450714672065]],
    [ "1024044051",[-98.76628436914059, 43.920544874247355]],
    [ "Illinois Sub",[-85.82494118446535, 41.569311046323776]],
    [ "PacifiCorp",[-112.0175485570366, 40.26084938204192]],
    [ "1024340312",[-85.03349225, 33.41229775]],
    [ "1024340317",[-85.03149856603028, 33.41245055159223]],
    [ "Northview Substation",[-83.58274243286328, 35.94830426021321]],
    [ "Earl Dean Hicks",[-97.28237088836494, 36.27609203661181]],
    [ "1024402205",[-117.69783326195129, 34.09319884570646]],
    [ "ECU Substation",[-77.36870618748884, 35.59915135175294]],
    [ "Sargent Substation",[-84.86274954999999, 33.425366249999996]],
    [ "Bibb MFG Company Substation",[-84.85667420356657, 33.418918115587516]],
    [ "Whitesburg Substation",[-84.91266795759512, 33.49256598118114]],
    [ "Canyon Road Substation",[-84.93031385000002, 33.506183750000005]],
    [ "1024641775",[-76.42084345, 36.97614875]],
    [ "Georgia Power",[-84.74719199512244, 33.409527504425526]],
    [ "1024684386",[-98.06882588460535, 43.16877021514618]],
    [ "1024684388",[-97.57785134383712, 43.057316549440955]],
    [ "1024684390",[-98.0668367074363, 43.09615552601155]],
    [ "1024710470",[-90.82534858612098, 37.79731816906885]],
    [ "1024712279",[-117.65011407878674, 34.093579863267486]],
    [ "1024712990",[-117.58415636712331, 34.12096601316518]],
    [ "Vulcan Materials Substation",[-84.69579793189656, 33.45335764573393]],
    [ "Martin Marietta Substation",[-84.62085284999999, 33.446939]],
    [ "Dauplainville",[-88.20459623991873, 43.076546729838725]],
    [ "Georgia Power",[-84.63278361620775, 33.522721399275106]],
    [ "Bleyle America Substation",[-84.75236484983057, 33.40457630160072]],
    [ "Louise Substation",[-121.28807307489157, 37.80828664308232]],
    [ "Vierra Substation",[-121.27419180243272, 37.797871062107575]],
    [ "1025005334",[-90.46401773117918, 36.80424234401608]],
    [ "1025008509",[-90.46462615735463, 36.7683078052517]],
    [ "1025009652",[-82.70883786692933, 36.519546791283226]],
    [ "1025010177",[-90.42054331044895, 36.67476957933792]],
    [ "1025020667",[-90.24237488310322, 36.67315016176255]],
    [ "1025038487",[-90.55885069625702, 37.190764735535225]],
    [ "Sharpsburg Substation",[-84.640091391545, 33.34226307527819]],
    [ "McIntosh Trail Substation",[-84.58251566455311, 33.34274011855537]],
    [ "Southern Mills Substation #1 (Senoia)",[-84.5630578177268, 33.30235380311082]],
    [ "Southern Mills Substation #2 (Senoia)",[-84.56107700303083, 33.30193359011781]],
    [ "1025267606",[-91.92890651735138, 36.87893288332884]],
    [ "West Kingsport Substation",[-82.57544358537186, 36.543406820632846]],
    [ "1025334157",[-90.28462239759298, 38.54870634200122]],
    [ "1025359860",[-96.82900658638879, 42.37352323493434]],
    [ "1025359864",[-96.82763105021492, 42.306202745095355]],
    [ "1025396274",[-91.88361031419919, 44.81490196863113]],
    [ "Grand Avenue Substation",[-94.58041187675238, 39.1118926069716]],
    [ "Coloma",[-89.5029721594354, 44.03566172941024]],
    [ "1025723115",[-89.50304249141072, 44.11147984552319]],
    [ "1025723118",[-89.50404797521017, 44.111346592058595]],
    [ "1025723122",[-89.48138711400475, 44.214794824843445]],
    [ "1025723124",[-89.5985964, 44.025430799999995]],
    [ "LINCOLN PUMP STA",[-89.68407033290916, 43.94971071626746]],
    [ "GRAND MARSH",[-89.67778582468326, 43.884355807282546]],
    [ "ACEC BROOKS",[-89.67799020694939, 43.87635281460249]],
    [ "ACEC QUINCY",[-89.93882455617955, 43.871260860652306]],
    [ "Castle Rock",[-89.95429702430107, 43.86549958666367]],
    [ "DPC BUCKHORN",[-89.97128631281227, 43.86216516932087]],
    [ "1025907354",[-112.16061694083702, 41.60343156908207]],
    [ "1025919992",[-97.3418118, 42.1625623]],
    [ "1025919994",[-97.35578097424145, 42.16142650468755]],
    [ "1025919996",[-97.32919604378468, 42.264009598108466]],
    [ "Johnson Transmission Substation",[-72.66834414259141, 44.63718567074169]],
    [ "1025986854",[-80.18201632852234, 35.62299438666578]],
    [ "Oak Grove Substation",[-92.72156736335612, 44.760863093509485]],
    [ "1026002921",[-92.2842921835717, 44.44404141184835]],
    [ "HOUGHTON ROCK",[-89.81346489999999, 43.944642449999996]],
    [ "ACEC DELLWOOD",[-89.95519957437095, 43.98555920714593]],
    [ "1026090067",[-90.07791250000001, 43.9918831]],
    [ "DPC WHISTLING WINGS",[-90.07175491547774, 43.97424513225112]],
    [ "1026090072",[-90.05957825, 44.02493675]],
    [ "Southmont Substation",[-80.2683881144064, 35.722232441660964]],
    [ "Virginia National Guard",[-77.93808037405302, 37.1209565843426]],
    [ "Lunenburg Switching Station",[-78.2542454853734, 36.973214120660955]],
    [ "1026228068",[-97.94012902194697, 42.18166500318841]],
    [ "1026228070",[-97.93612102496007, 42.17740664428194]],
    [ "1026474763",[-84.10994134772642, 36.04374213564792]],
    [ "ATC Platte 69kV Substation",[-89.75966514999999, 43.626367200000004]],
    [ "1026706840",[-80.1940952188886, 35.72588530524892]],
    [ "LPGA Substation",[-81.1165419075574, 29.216425263489853]],
    [ "ACEC GRANT",[-89.64789602474032, 44.304850257533424]],
    [ "Kaweah 2 Substation",[-118.87988341628603, 36.46138049750072]],
    [ "North Fairfax Substation",[-73.02987487048519, 44.75586884757031]],
    [ "Glasgow Substation",[-92.845751949702, 39.22919535000424]],
    [ "Northeast Power Plant",[-94.5602604900355, 39.12211962444178]],
    [ "Georgia Power",[-81.13271802956727, 31.994184094093672]],
    [ "Glenwood Substation",[-82.66682102355847, 32.185687255348405]],
    [ "Alamo Substation",[-82.783778428695, 32.15467660994151]],
    [ "Healing Springs Substation",[-80.18221960888165, 35.62407963199887]],
    [ "Oakdale Substation",[-81.09661911354415, 32.01144547748288]],
    [ "Hunter Field Substation",[-81.12963752165567, 32.0312102590579]],
    [ "Silk Hope Substation",[-81.21505250905581, 32.035422187875156]],
    [ "Gilbertville Substation",[-92.22349509258468, 42.4348266432417]],
    [ "Tybee Substation",[-80.8451632667021, 32.007200931508656]],
    [ "Georgia Pacific Gypsum Substation",[-81.05444669999999, 32.0752195]],
    [ "BASF Substation",[-81.05877838088271, 32.070966743861035]],
    [ "President Street Sewage Substation",[-81.06970930877405, 32.074573328811304]],
    [ "Imperial Sugar Substation",[-81.14643621316263, 32.14476312150697]],
    [ "Pembroke Substation",[-81.63232315753181, 32.1535464459547]],
    [ "Georgia Power",[-81.63299373673729, 32.15289167411882]],
    [ "Black Creek Substation",[-81.55790179477398, 32.20635201724153]],
    [ "I-16 Substation",[-81.85079490711661, 32.29542152566945]],
    [ "Jimps Substation",[-81.83812958905177, 32.387939816783295]],
    [ "Bellville Substation",[-82.00075198694587, 32.16081572284516]],
    [ "Collins Substation",[-82.125782729086, 32.1729542422022]],
    [ "Rayonier Substation",[-82.12442481104398, 32.13010082868644]],
    [ "Stoney Hill Substation",[-82.0315273, 31.988355850000005]],
    [ "1028338439",[-81.90258104999998, 32.16921505]],
    [ "South Glennville Substation",[-81.8861191080725, 31.86644361386562]],
    [ "Loop Road Substation",[-82.36227445, 32.233383200000006]],
    [ "Alston Substation",[-82.4735832663772, 32.07907138279138]],
    [ "Uvalda Substation",[-82.50342014331213, 32.034137869478215]],
    [ "Beasley Timber Substation",[-82.56396133178501, 31.903490901460955]],
    [ "1028420451",[-84.44159886205664, 39.24118430072905]],
    [ "1028424045",[-90.39151095000001, 43.944965749999994]],
    [ "Georgia Power",[-82.21621459846989, 31.260932833334174]],
    [ "Hoboken Substation",[-82.11395886734142, 31.180678083798924]],
    [ "Patterson Substation",[-82.13472019815863, 31.391238633285443]],
    [ "Nahunta Substation",[-81.9715972, 31.216788450000003]],
    [ "Satilla Creek Substation",[-82.00834348342237, 31.494833550639402]],
    [ "Screven Substation",[-81.96954083875849, 31.5599712031115]],
    [ "1028505622",[-81.89909841513789, 31.629955157695214]],
    [ "Rayonier Substation",[-81.84375301094708, 31.65742032911865]],
    [ "Georgia Power",[-81.70108144999998, 31.766045499999997]],
    [ "Traction Power Facility 2",[-121.92080294510788, 37.34607079583614]],
    [ "Fort Stewart Substation",[-81.60989008221479, 31.877904320158112]],
    [ "Ft. Stewart Solar Substation",[-81.5899883816189, 31.894343454244314]],
    [ "Cay Creek Substation",[-81.43594802399853, 31.799176462003096]],
    [ "Riceboro Substation",[-81.44477197506974, 31.744893518412724]],
    [ "Georgia Power",[-81.3596158, 31.775982450000004]],
    [ "Burnt Church Substation",[-81.27180122010331, 31.877671681054718]],
    [ "1028571279",[-116.57253408664536, 43.70335057479314]],
    [ "Traction Power Facility 1",[-122.4048747570598, 37.65655683817654]],
    [ "Georgia Power",[-81.61681597118034, 31.745999813083774]],
    [ "Georgia Power",[-81.61711348804249, 31.792267031203476]],
    [ "Townsend Substation",[-81.63034426666667, 31.560346206256906]],
    [ "Zuta Substation",[-81.58926481126319, 31.318637632181247]],
    [ "Hurtsboro Substation",[-85.42723097899147, 32.23817400743333]],
    [ "1028695951",[-85.36268887819428, 32.214552979838466]],
    [ "Ida County Substation",[-95.49124281324698, 42.37150797225125]],
    [ "Ida Grove Wind Farm",[-95.37964046220813, 42.36398950314849]],
    [ "Irvine Substation",[-92.70403402650999, 41.43753141736654]],
    [ "Prairie Wind Farm",[-92.70297755662394, 41.43740753279214]],
    [ "1028773562",[-92.22861376010455, 43.991524920391726]],
    [ "MidAmerican Energy",[-95.22850295468021, 42.363965840271284]],
    [ "Richland Wind Farm",[-95.22671484298151, 42.36402229697184]],
    [ "West Gardner Gen Substation",[-94.98608136290909, 38.78784146690242]],
    [ "Blue Springs Substation",[-94.27869494685653, 39.08206655603891]],
    [ "Norton Substation",[-93.1347437844898, 39.183865844860634]],
    [ "1029122075",[-119.8187686714964, 36.71828624294464]],
    [ "Levee Substation",[-94.48216595183634, 39.133258927018815]],
    [ "South Waverly Substation",[-93.52127530085303, 39.16185048425597]],
    [ "1029159689",[-89.60677786016933, 44.70888431156604]],
    [ "1029159691",[-89.60717631551807, 44.66823057492032]],
    [ "Northpoint",[-89.5973918, 44.5514291]],
    [ "1029163017",[-88.45847942479611, 44.56497633957173]],
    [ "1029175153",[-88.34245452457208, 44.51613445607631]],
    [ "1029175156",[-88.29135673766301, 44.50070648831913]],
    [ "1029175159",[-88.29057805000001, 44.431487149999995]],
    [ "Entergy Arkansas",[-93.02199514235613, 34.521882708501046]],
    [ "1029177712",[-88.2521107574296, 44.67490970912078]],
    [ "Ashford Substation",[-85.23611480969903, 31.18761352535464]],
    [ "Pageland Substation",[-80.36633062719964, 34.777888362234506]],
    [ "Haleburg Substation",[-85.13865789596316, 31.407967563883798]],
    [ "1030241182",[-88.28412130876785, 44.18803552250847]],
    [ "1030241202",[-88.21926766478566, 44.212452381763114]],
    [ "Hubbard Lake Substation",[-83.52715602559489, 44.727599954537965]],
    [ "Spruce Road Substation",[-83.50237092425034, 44.83054569595816]],
    [ "1030407150",[-83.234636403009, 43.657212817671684]],
    [ "Jersey Central Power and Light",[-74.8600928672759, 40.57030180664827]],
    [ "Sealy Springs Substation",[-85.3099984, 31.075509550000003]],
    [ "1030510524",[-85.33399873516211, 31.42055651536457]],
    [ "Bates Substation",[-85.43502291932995, 44.77344338718218]],
    [ "Ohman Road Substation",[-85.27243780000002, 43.89558430000001]],
    [ "Osceola Substation",[-85.35457917483143, 43.83277870475663]],
    [ "Barryton Substation",[-85.24555075938865, 43.75645973127607]],
    [ "Martiny Substation",[-85.18720061518357, 43.7362227660739]],
    [ "Manistee Substation",[-86.30694805529023, 44.23736934439481]],
    [ "1030580139",[-82.10287704999999, 35.3573546]],
    [ "1030582584",[-103.21805037695876, 47.789588145021966]],
    [ "Ivy Steel Substation",[-81.72318405813131, 30.356187680496916]],
    [ "Durrance Solar Substation",[-82.00279528473797, 27.792010187366813]],
    [ "Subestación Palo Seco",[-66.1488020994345, 18.454338265117926]],
    [ "Subestación Amelia",[-66.11482254999999, 18.432171999999998]],
    [ "1030680373",[-66.11260642623515, 18.432510812147118]],
    [ "1030680375",[-66.12868071666044, 18.439904733322518]],
    [ "Subestación CREA",[-66.17799975420986, 18.411453431498412]],
    [ "Vega Baja Substation",[-66.39141115794818, 18.44599858851601]],
    [ "1030695142",[-66.46584640745384, 18.429506422537298]],
    [ "Hawaiian Electric Company",[-155.67534426603072, 19.056992977184983]],
    [ "1030753943",[-155.56753835198435, 19.068426933573217]],
    [ "Hawaiian Electric Company",[-155.51174936357594, 19.148814704738523]],
    [ "Hawaiian Electric Company",[-155.04586915460908, 19.640237417523995]],
    [ "Milligan 1 Wind Substation",[-97.19527380356307, 40.48589312293073]],
    [ "Tobias Substation",[-97.1915004598698, 40.48613044708013]],
    [ "1030823637",[-107.07837051250324, 45.804528673469946]],
    [ "Hawaiian Electric Company",[-155.1027097224947, 19.84043685203282]],
    [ "Hu Honua Bioenergy Facility Substation",[-155.08851299278956, 19.84274852439648]],
    [ "Wailuku Hydroelectric Substation",[-155.14752008395806, 19.711787318645722]],
    [ "Hawaiian Electric Company",[-155.09209040002932, 19.697534966679072]],
    [ "Keller Substation",[-81.24593748223418, 31.847143954568566]],
    [ "1030860836",[-81.48567675491904, 31.879042069164747]],
    [ "Eulonia Substation",[-81.42820495738763, 31.525808530651204]],
    [ "1030860841",[-81.45646202799693, 31.410484757337255]],
    [ "McManus Switchyard",[-81.54526980232157, 31.21305386002406]],
    [ "Hawaiian Electric Company",[-155.86122663858782, 19.16120827561751]],
    [ "Kealia Substation",[-155.88136232772283, 19.404469897585038]],
    [ "Captain Cook Substation",[-155.9139848996227, 19.491239865245607]],
    [ "Hawaiian Electric Company",[-155.9436071270966, 19.568938954138748]],
    [ "Hawaiian Electric Company",[-155.96196005030882, 19.664757187224417]],
    [ "Honualoa Substation",[-155.96941390844898, 19.61636486631107]],
    [ "KAMO Power",[-93.74869536526607, 37.699309375608706]],
    [ "Mount Union Substation",[-77.88856431763752, 40.39252273265101]],
    [ "1030977828",[-98.40655427519562, 40.28439759095583]],
    [ "1030977832",[-98.33902044463441, 40.27693067786298]],
    [ "Keahole Substation",[-156.0293852405166, 19.732415222147445]],
    [ "Keahole Switchyard",[-156.02737571664687, 19.731704271595767]],
    [ "Hawaiian Electric Company",[-155.84466168308788, 19.804603268576823]],
    [ "Hawaiian Electric Company",[-155.83551846848408, 19.820858235318855]],
    [ "Hawaiian Electric Company",[-155.53249122115304, 19.75806968576375]],
    [ "1031027500",[-77.08217537490545, 36.408843546239524]],
    [ "Goshen Substation",[-86.12134231632812, 31.7268820675419]],
    [ "Hawaiian Electric Company",[-155.6964442343456, 20.024593867928353]],
    [ "Hawaiian Electric Company",[-155.66032659573645, 20.021929332104854]],
    [ "Paaulio Substation",[-155.36447729726962, 20.03774226928918]],
    [ "Laupahoehoe Substation",[-155.2429955, 19.98816485]],
    [ "Hawaiian Electric Company",[-155.14704945489578, 19.918705683414476]],
    [ "Hawaiian Electric Company",[-155.10390510000005, 19.840180200000002]],
    [ "Latta Substation",[-79.41661327404944, 34.33459280624575]],
    [ "Hawaiian Electric Company",[-155.98311968140038, 19.80095640450366]],
    [ "Hawaiian Electric Company",[-155.72904819507355, 20.024493982322806]],
    [ "Kawaihae Substation",[-155.81502625, 20.0251952]],
    [ "Hawaiian Electric Company",[-155.84594636724808, 20.071190353595686]],
    [ "Hawaiian Electric Company",[-155.85359373036349, 20.25494135511669]],
    [ "1031510468",[-91.1616011, 46.846097549999996]],
    [ "1031533804",[-93.8652141414835, 37.71998869471404]],
    [ "Queens Creek Substation",[-77.18851114041729, 34.67553917990635]],
    [ "1032669233",[-87.33333417081411, 30.462804285431957]],
    [ "Mobile Highway Substation",[-87.3043485837247, 30.470673700509394]],
    [ "Sheldon Substation",[-72.98372242561213, 44.90500119359197]],
    [ "East Berkshire Substation",[-72.70797182687836, 44.94351429504028]],
    [ "Richford Substation",[-72.6679427, 44.9868992]],
    [ "Selinsgrove Substation",[-76.84602180533459, 40.81864774282199]],
    [ "Island Pond Substation",[-71.84793059693042, 44.80506401689816]],
    [ "Georgia Power",[-81.49059815927076, 31.15995292015899]],
    [ "Georgia Power",[-81.40137522198934, 31.165546986707003]],
    [ "Georgia Power",[-81.35473585, 31.177925450000007]],
    [ "Georgia Power",[-81.38173856942817, 31.1422927035724]],
    [ "Georgia Power",[-83.93527649221468, 33.99551363790999]],
    [ "John's Manville Substation",[-83.77275138849808, 33.993741775045045]],
    [ "1033094924",[-83.86627951031394, 33.99850112473685]],
    [ "Georgia Power",[-83.87423349980352, 33.99893043687753]],
    [ "Colonial Pipeline Substation - Dacula",[-83.91769919999999, 33.977339150000006]],
    [ "Georgia Power",[-84.11765674377614, 33.94244032096468]],
    [ "North Lawrenceville Substation",[-83.98983579950679, 33.973763439524916]],
    [ "Dolco Packaging Substation",[-83.97216981773731, 33.96999759257723]],
    [ "Battleground Station",[-86.86357331824699, 40.50375661460009]],
    [ "1033110735",[-122.9288481777786, 48.56579647518818]],
    [ "Reid Street Substation",[-83.98627458526006, 33.962418908645716]],
    [ "Battle Creek Substation",[-84.3430254087704, 33.54960127104703]],
    [ "Blackjack Substation",[-87.11516124156698, 30.8489140249989]],
    [ "1033388887",[-106.5451214, 35.011681300000006]],
    [ "1033545938",[-88.93102817996832, 44.32431525686485]],
    [ "1033551261",[-79.76516408278759, 37.02698830194508]],
    [ "AES Clean Energy",[-77.78723913423175, 38.246690477871475]],
    [ "1033634997",[-90.293916103336, 42.371653882186784]],
    [ "1033635003",[-90.2377181, 42.313301949999996]],
    [ "1033635005",[-90.22776262493164, 42.312376062129296]],
    [ "1033635006",[-90.22771323404052, 42.31215883160659]],
    [ "Meriweter Substation",[-83.26088528034285, 33.094895860884655]],
    [ "Vinson Road Substation",[-83.21480472107388, 33.0209065275315]],
    [ "Montgomeryville Substation",[-83.26026418846494, 33.152298921317986]],
    [ "Interfor Substation",[-83.3574179, 33.241349050000004]],
    [ "Jeffersonville Substation",[-72.833708, 44.64375415]],
    [ "Devereux Substation",[-83.07283405000001, 33.22726825]],
    [ "Culverton Substation",[-82.88919925, 33.3021238]],
    [ "Georgia Power",[-82.73677485412338, 33.32972566011424]],
    [ "Stock Island Substation",[-81.7336643658236, 24.563796776469967]],
    [ "South District Wastewater Treatment Substation",[-80.33507463562395, 25.551268824872864]],
    [ "Bentonville Substation",[-93.46121292239842, 38.0779577375306]],
    [ "1034819113",[-84.28194024989791, 34.06282013333823]],
    [ "Wards Corner Substation",[-78.06897741227384, 34.535512735416184]],
    [ "1034862190",[-115.19747529358948, 36.203345409569735]],
    [ "Pratt and Reid Substation",[-72.6026385, 44.5724804]],
    [ "Lasher Road Station 3221",[-73.93024031356765, 42.97719183304619]],
    [ "1035014251",[-85.18918289999999, 31.0557699]],
    [ "Georgia Power",[-84.03105771178413, 34.13093541642379]],
    [ "Wayne Farms Substation",[-83.67237258660784, 34.17928017734393]],
    [ "Georgia Power",[-83.81752928254453, 34.23341870455952]],
    [ "Flat Creek Sewage Treatment Substation",[-83.86966598331168, 34.26599170146317]],
    [ "Georgia Power",[-83.85175588397934, 34.250906279735645]],
    [ "Georgia Power",[-83.84969061042278, 34.25151701882699]],
    [ "1035115026",[-80.35697603782192, 25.83549387560185]],
    [ "1035115027",[-80.35659237466857, 25.835504094284346]],
    [ "Sevier County Electric System",[-83.59071862867442, 35.894969784475954]],
    [ "Minto Substation",[-80.34461621942835, 26.75495278769481]],
    [ "Westlake Substation",[-80.3136109503427, 26.753903879014153]],
    [ "Costa Substation",[-80.34478392523091, 26.766451440194892]],
    [ "Hanson Aggregates Substation",[-83.33786984130393, 33.953971019251675]],
    [ "Georgia Power",[-83.38622357121864, 33.973499843815574]],
    [ "Georgia Power",[-83.38913634999999, 33.972799499999994]],
    [ "Georgia Power",[-83.39031974765314, 33.97184141782885]],
    [ "Winterville Substation",[-83.2795220896694, 33.95532172582968]],
    [ "Georgia Power",[-83.23486816102681, 33.964767729674406]],
    [ "Arnoldsville Substation",[-83.20100198046559, 33.91836854393758]],
    [ "Georgia Power",[-83.1265528, 33.887231400000005]],
    [ "Wolfskin Substation",[-83.22787962075178, 33.85676155981237]],
    [ "Okeelanta Cogeneration Substation",[-80.74672849850592, 26.577721986176833]],
    [ "Ridgeland",[-91.8811419060678, 45.23761707066473]],
    [ "Blue Heron Solar Substation",[-81.13808674948714, 26.695404877144504]],
    [ "Hammock Solar Substation",[-81.32423083927084, 26.69213882004476]],
    [ "Lee County Solid Waste Substation",[-81.76099025609177, 26.631583181612054]],
    [ "Virginia Electric and Power Company",[-79.00567115877418, 38.081941033464645]],
    [ "TECO",[-81.92391976250379, 27.87965207488034]],
    [ "Sweetbay Substation",[-80.47635977504214, 27.055798637165797]],
    [ "Nubbin Substation",[-80.74929475, 27.21158085]],
    [ "Wayburn Substation",[-82.94720096530227, 42.38764713180489]],
    [ "Rockwood Substation",[-79.14936975542176, 39.91148003950223]],
    [ "Williamsburg Substation",[-78.20766532831591, 40.47032858999369]],
    [ "Mcmillan",[-90.17285306413741, 44.68563473150354]],
    [ "1036143452",[-90.18439154389725, 44.6497023906651]],
    [ "1036171320",[-90.49653763099117, 44.89122798322578]],
    [ "1036171330",[-90.40658060000001, 44.90233995]],
    [ "1036219235",[-82.43615905695862, 27.916824374615064]],
    [ "Sneads Substation",[-85.0203132050931, 30.740157170971944]],
    [ "Duke Energy",[-81.55724318200214, 28.243147645837563]],
    [ "1036263659",[-81.47533454356075, 28.108448445387072]],
    [ "1036263660",[-81.5298295834098, 28.03568973325901]],
    [ "1036282560",[-90.73916949525679, 44.944811824788836]],
    [ "1036282563",[-90.79987636085835, 44.94495892122019]],
    [ "1036282567",[-90.86458277444723, 44.945213755593976]],
    [ "1036282568",[-90.950403663592, 44.95359196147687]],
    [ "1036282572",[-90.98426036576052, 44.95082048473976]],
    [ "1036282573",[-91.14725919573955, 44.951584611697314]],
    [ "Amercord Substation",[-82.68267055019413, 31.92559478334359]],
    [ "North Lumber City Substation",[-82.69310896466637, 31.939816096181655]],
    [ "Dixie Electric Power Association",[-89.18436658332939, 31.733854152303966]],
    [ "Cooperative Energy",[-89.18714315, 31.734119000000007]],
    [ "1036413413",[-90.33165150119035, 45.44892487428424]],
    [ "Washington Metropolitan Area Transit Authority",[-77.41174337430091, 38.958742685255864]],
    [ "Georgia Power",[-82.87615059999999, 32.05994645]],
    [ "North McRae Substation",[-82.900700319781, 32.0737070053268]],
    [ "BNSF Substation",[-94.95590195195183, 38.788365610451116]],
    [ "Lickdale Substation",[-76.5113530293449, 40.4445488929807]],
    [ "Dandridge Substation",[-83.42543733806167, 36.02406185970317]],
    [ "1036680637",[-95.45664945, 35.9585146]],
    [ "Grand River Dam Authority",[-95.39904722770679, 35.943926406938935]],
    [ "Vinburn",[-89.22724584035468, 43.24855522494229]],
    [ "Hampden",[-89.23255977496295, 43.311117562526285]],
    [ "Georgia Power",[-83.23571746557164, 30.69002118341285]],
    [ "South Marion Substation",[-79.41326148330509, 34.156551950231574]],
    [ "Curryville Substation",[-78.34620745523229, 40.26492833374172]],
    [ "Dixionville East Substation",[-78.98536935912018, 40.73178378515266]],
    [ "KAMO Power",[-93.28152902454744, 38.116295659770465]],
    [ "1037340024",[-90.29116955972204, 45.30913879266736]],
    [ "Coronet Industries Substation",[-83.84716283268351, 34.265495903228086]],
    [ "McEver Road Substation",[-83.87380125000001, 34.272883199999995]],
    [ "College Square Substation",[-83.89624518309034, 34.23535884902665]],
    [ "Georgia Power",[-83.9193148964203, 34.21097568542885]],
    [ "Wrigleys Substation",[-83.90022293327566, 34.197172149174285]],
    [ "West Gainesville Substation",[-83.8631287276697, 34.30502179194463]],
    [ "Linwood Substation",[-83.84876569088476, 34.3290408298832]],
    [ "Gainesville Primary Substation (#1)",[-83.84020100876211, 34.3402792264488]],
    [ "Oak Street Substation",[-83.83147773423896, 34.300243323959776]],
    [ "Cargill Substation",[-83.81054085, 34.290144]],
    [ "Sundance Products Substation",[-83.81286799999998, 34.29317605]],
    [ "Ralston Purina Mills Substation",[-83.80772079419191, 34.29622421802535]],
    [ "Georgia Power",[-83.82650521456074, 34.28427835821492]],
    [ "Georgia Power",[-83.80929012964434, 34.30107558894805]],
    [ "Gainesville Mills Substation",[-83.79977093279061, 34.30727285220752]],
    [ "Duncan Mill Road Substation",[-83.81601715846618, 34.321346429832914]],
    [ "Gainesville Water Works Substation #2",[-83.83060713357783, 34.335521657135104]],
    [ "Gainesville Water Works Substation #1",[-83.83049482920288, 34.33953143864409]],
    [ "Kubota Substation",[-83.78618656533656, 34.34863776167795]],
    [ "Georgia Power",[-83.79677852758846, 34.3715058930558]],
    [ "Clermont Substation",[-83.78537358474759, 34.47605473206872]],
    [ "Bark Camp Substation",[-83.86552561799542, 34.36522788367722]],
    [ "Leach Road Substation",[-83.9293549, 34.365436450000004]],
    [ "Georgia Power",[-83.99295951354651, 34.29710431761715]],
    [ "Beckjord Substation",[-84.29638335874503, 38.99160754142581]],
    [ "FIXME Substation",[-93.07202477930947, 38.192357358299944]],
    [ "1037833077",[-78.71809391842494, 40.550469214703305]],
    [ "FIXME Substation",[-92.91248920000001, 38.11219095]],
    [ "Paragon Park Substation",[-77.44105145461373, 39.0171870338353]],
    [ "Saint Benedict Substation",[-78.73644972371841, 40.62899679759214]],
    [ "Morristown Utility Systems",[-83.291029034129, 36.18728542125596]],
    [ "1038012205",[-91.42187447735834, 44.866283336840816]],
    [ "Greeneville Light and Power System",[-82.70094022146652, 36.14687830776111]],
    [ "1038118765",[-74.96454327419784, 43.71452634576999]],
    [ "Trio Substation",[-79.72138745002668, 33.487193420617466]],
    [ "1038318663",[-83.18143268496472, 32.209126704284984]],
    [ "Flathead Electric Cooperative",[-114.03208079276212, 48.09479630406157]],
    [ "1038600584",[-80.48539928069282, 33.477691375312105]],
    [ "South Eaton Substation",[-75.21219638337966, 40.67559497413241]],
    [ "Elm Substation",[-77.79293244999998, 38.705403]],
    [ "1038789331",[-80.1277683799341, 33.67735908616262]],
    [ "1038820424",[-83.34005557176872, 42.32319157732159]],
    [ "Hana Substation",[-155.99575308103985, 20.766041966130633]],
    [ "1039138424",[-122.95557207444963, 48.58562656169329]],
    [ "Jersey Central Power and Light",[-75.17081853873216, 40.68694499800655]],
    [ "Half Moon Bay Substation",[-122.43025279503638, 37.46897327748573]],
    [ "Rodeo Substation",[-109.01128027113208, 31.92106292636661]],
    [ "Georgia Power",[-84.5918217113133, 34.14695634110667]],
    [ "Davenport Substation",[-83.9464269747325, 43.43671694487671]],
    [ "Potter Substation",[-83.93755566265143, 43.441900198906175]],
    [ "1039333381",[-93.66696262006691, 44.239843275210774]],
    [ "Maggie Valley Substation",[-83.05428490813561, 35.518507270726886]],
    [ "Bellows Falls Substation",[-72.44125702172077, 43.13322050691079]],
    [ "Sharpsville Substation",[-80.47783339131699, 41.267639054278455]],
    [ "FIXME Substation",[-92.82807375658555, 38.0972687219963]],
    [ "Hiltonia Substation",[-81.66103577688527, 32.88936015715605]],
    [ "Sylvania Substation",[-81.6611148258049, 32.763583136922065]],
    [ "Georgia Power",[-81.64366853334367, 32.748865301567236]],
    [ "Georgia Power",[-81.74020335017231, 32.603579666648464]],
    [ "Dover Substation",[-81.6996929833668, 32.591057249446614]],
    [ "Egypt Substation",[-81.43153126649595, 32.495620982040364]],
    [ "Cooper Tools Substation",[-81.7137724677998, 32.54059815435177]],
    [ "Clito Substation",[-81.7455569478006, 32.514104286641995]],
    [ "Deal Branch Substation",[-81.77158674299928, 32.50455776428221]],
    [ "Brodie Meter Substation",[-81.74920045, 32.48699405]],
    [ "Oliver Road Substation",[-81.75605708981108, 32.45258904586389]],
    [ "Southeast Bulloch Substation",[-81.6716313786752, 32.363771268746305]],
    [ "Brooklet Substation",[-81.6591624906068, 32.37323318096509]],
    [ "Lenox Substation",[-83.4663034169399, 31.27283865015999]],
    [ "1039669318",[-77.5886749577936, 39.82445689632128]],
    [ "FIXME Substation",[-92.81972032904095, 38.11310883595191]],
    [ "Mount Horeb",[-89.73010229922195, 43.001236566942445]],
    [ "Williams Bay",[-88.55258222492405, 42.58707679387323]],
    [ "Brick Church",[-88.63472113864944, 42.540185962688476]],
    [ "1039700997",[-88.63447325, 42.5397069]],
    [ "East Beloit",[-89.00796852043976, 42.5064222895595]],
    [ "1039701014",[-89.00308407496622, 42.55856119216854]],
    [ "Rec Shaw Substation",[-89.05852683687611, 42.472568716885654]],
    [ "1039701035",[-89.07706780027766, 42.53228118465528]],
    [ "Rec Newark",[-89.22844752547782, 42.534641893869505]],
    [ "1039703862",[-89.36556099999999, 42.536689499999994]],
    [ "Spring Grove",[-89.4259692744106, 42.53662395785258]],
    [ "Blacksmith",[-89.54303327464068, 42.56466725786014]],
    [ "1039705078",[-81.41729830970108, 27.430555797935963]],
    [ "Fairbanks Morse Engine",[-89.02876857452216, 42.51524996015585]],
    [ "Coachwhip Substation",[-82.08679826490882, 27.45685407279104]],
    [ "New Hollendale",[-89.95696722953079, 42.865382942753556]],
    [ "Dodgeville",[-90.12275833626802, 42.9633224172844]],
    [ "Walkerville Substation",[-83.47556867838958, 31.439699483582814]],
    [ "Sycamore Substation",[-83.63478777495506, 31.652706910320987]],
    [ "Tifton Substation",[-83.5458323610256, 31.458192575354296]],
    [ "Ty Ty Substation",[-83.65146611276047, 31.466617675137773]],
    [ "Sumner Substation",[-83.7408959, 31.50138695]],
    [ "New Sumner Substation",[-83.74094142247877, 31.50087778321762]],
    [ "Poulan Substation",[-83.7901998034363, 31.510044117054324]],
    [ "Sylvester Primary Substation",[-83.8044473, 31.51157765]],
    [ "Mitchell EMC",[-83.86908447137884, 31.532374293427097]],
    [ "1039766428",[-83.8361337306169, 31.544877579480055]],
    [ "Alimenta Substation",[-83.8097709088377, 31.528745975071]],
    [ "1039766433",[-83.99698555157484, 31.561752623926235]],
    [ "Acree Substation",[-83.99626557514968, 31.562008641076762]],
    [ "Cooper Tire Substation",[-84.05233995, 31.56727875]],
    [ "MEAG",[-84.20144521594075, 31.583233617014795]],
    [ "MEAG",[-84.17446298712532, 31.578997819175814]],
    [ "MEAG",[-84.16233410938409, 31.597210347479663]],
    [ "Pecan City Substation",[-84.05055836873892, 31.50667893261878]],
    [ "Mitchell Substation (115kV)",[-84.1351284755089, 31.443885288596867]],
    [ "National Beef Substation",[-83.79228873204359, 31.194869635069026]],
    [ "Sale City Substation",[-84.02453101061003, 31.262401075586848]],
    [ "Riverside Mills Substation",[-83.80155193154584, 31.17856969979533]],
    [ "Odom Solar Substation",[-83.59317245714836, 31.06805576024916]],
    [ "Remerton Substation",[-83.30440800672041, 30.842793618996836]],
    [ "Langdale Substation",[-83.28337371691661, 30.81367154788525]],
    [ "Clyattville Substation",[-83.30768061761489, 30.695304351930226]],
    [ "Packaging Corporation Substation",[-83.30526691715978, 30.693494656450113]],
    [ "Fargo Substation",[-82.5643469, 30.684709850000004]],
    [ "Banks Creek Substation",[-81.87142430662523, 32.564140679001454]],
    [ "1039925459",[-81.93979612928744, 32.70612643973301]],
    [ "Leesburg Substation",[-84.17342916552974, 31.731060832340784]],
    [ "Tiger",[-88.86419376905472, 42.523675537047126]],
    [ "Clinton (ATLE)",[-88.8655756686847, 42.55322891362105]],
    [ "Scot",[-88.8703610905456, 42.55038911052588]],
    [ "Sharon",[-88.72172777546427, 42.50802570698201]],
    [ "Blaine Street",[-85.37154521727666, 40.17954063696883]],
    [ "Lahaina Substation",[-156.67527276136792, 20.878482606496625]],
    [ "1040134727",[-81.99720153172066, 33.87285346268561]],
    [ "Venice Hill Substation",[-119.18910258190381, 36.41429313644271]],
    [ "Chatham Substation",[-119.29671153846688, 36.41461297346222]],
    [ "MidAmerican Energy",[-93.71528106901071, 41.5148706142634]],
    [ "Knoxville Utilities Board",[-83.92153740941876, 35.960236136905294]],
    [ "Union Crossroads Substation",[-79.98817450176008, 33.80032294446822]],
    [ "1040724643",[-87.00612631139775, 31.879939980323552]],
    [ "Dixie Pipeline Substation",[-84.76334414008409, 32.04200322540749]],
    [ "Substation #3",[-94.94691763653725, 38.82937245591148]],
    [ "Martin Substation",[-85.640229274948, 42.53623259269405]],
    [ "1041178458",[-83.7570727707403, 33.598531994623045]],
    [ "1041315060",[-84.86564252367938, 38.18342580609582]],
    [ "Tichigan",[-88.19948704680955, 42.772114823943184]],
    [ "1041564930",[-116.39055331025828, 43.604964619337025]],
    [ "1041566523",[-85.65327353844816, 40.125098630341746]],
    [ "Thiele Kaolin Substation",[-82.863341, 32.96667315]],
    [ "Georgia Power",[-82.82079795312632, 32.970852282793]],
    [ "Georgia Power",[-82.82169813251646, 32.97008675313506]],
    [ "1041608719",[-82.82238550000001, 32.964676049999994]],
    [ "Oconee Substation",[-82.96548048319515, 32.85294380076485]],
    [ "Georgia Power",[-82.75802715000002, 32.810122899999996]],
    [ "1041608724",[-82.75672364070995, 32.806543876865675]],
    [ "1041608729",[-82.84599921669934, 32.57102051185881]],
    [ "Saluda Substation",[-81.76621901466699, 33.997314531569394]],
    [ "Georgia Power",[-81.95235675785435, 32.41128287229463]],
    [ "1041751341",[-82.03185466196068, 32.40647912542432]],
    [ "Twin City Substation",[-82.14566263972353, 32.57993422029696]],
    [ "ECI Substation",[-82.1161915, 32.573516950000005]],
    [ "1041751349",[-82.31576105491064, 32.59064021165053]],
    [ "Nunez Substation",[-82.34400993902558, 32.53281083047661]],
    [ "Crystal Spring Substation",[-70.83220534999998, 41.67397130000001]],
    [ "1041882941",[-81.97762255000002, 27.66670925]],
    [ "Unadilla Switching Station",[-83.75389272443398, 32.24317627538404]],
    [ "Science Hill Capacitor Station",[-86.29600039539048, 35.824750774263144]],
    [ "1041970202",[-81.74702450000002, 33.5311337]],
    [ "1041989741",[-81.78041467565758, 33.52220200574469]],
    [ "1041994610",[-81.88776104805561, 33.39628477711701]],
    [ "Georgia Power",[-82.46345337912047, 33.811837037823366]],
    [ "Lincolton Substation",[-82.51182287368266, 33.793496440223365]],
    [ "Washington Switching Station",[-82.75123858933588, 33.73238806882434]],
    [ "Georgia Power",[-82.7488919111643, 33.70323482922348]],
    [ "Rayle Substation",[-82.91033712971752, 33.78325896349726]],
    [ "Georgia Power",[-82.8051784, 33.55802985]],
    [ "Ridgecrest Substation",[-81.72658475701071, 33.61159484330948]],
    [ "1042056863",[-81.67629309198121, 33.6378890275741]],
    [ "Aeolus Substation",[-106.378967291444, 42.012139194819696]],
    [ "Anticline Substation",[-108.74477242700681, 41.71177357533173]],
    [ "1042346797",[-81.11386785, 33.731446]],
    [ "Allendale Substation",[-85.9644293555542, 42.97296920939067]],
    [ "Devro Substation",[-80.91679630877601, 33.80996953129359]],
    [ "Georgia Power",[-82.4795191, 33.466951550000005]],
    [ "North Thomson Substation",[-82.49819954175476, 33.50691928564906]],
    [ "Thomson Substation",[-82.4948173538601, 33.46984269581255]],
    [ "1042419972",[-82.43179705, 33.535911199999994]],
    [ "1042419973",[-82.4312991, 33.5357048]],
    [ "East Thomson Substation",[-82.4388394466204, 33.459208474627545]],
    [ "West Thomson Substation",[-82.56601071392147, 33.4933163459138]],
    [ "Martin Marietta Substation",[-82.61827072437107, 33.51051863549636]],
    [ "Dixie Pipeline Substation",[-82.71401034999998, 33.49649605]],
    [ "Crawfordville Substation",[-82.89522372934215, 33.575928596352085]],
    [ "West Crawfordville Substation",[-82.91196969920784, 33.5660134832379]],
    [ "1042495347",[-87.88987955354214, 42.99019036569619]],
    [ "Kenmore Station",[-85.41954956754185, 40.19814212217363]],
    [ "Tiger Bay Substation",[-81.84970724022705, 27.747203460120826]],
    [ "Williams Creek Switching Station",[-104.63044271382918, 38.63020617683804]],
    [ "1043286912",[-104.63730499541005, 38.62962897221997]],
    [ "Fullers Substation",[-86.31081030020248, 31.814982569127157]],
    [ "Legend Substation",[-81.50470443650126, 40.762709809341594]],
    [ "Commonwealth Edison",[-87.82287271527323, 42.379435509132634]],
    [ "1043428366",[-87.83539224587578, 42.33054171300173]],
    [ "Buckhead Point Substation",[-82.56920548470441, 33.92679650586594]],
    [ "Delhi Substation",[-82.67338033386073, 33.91483362511782]],
    [ "Heardmont Substation",[-82.73137451391776, 34.05375595042562]],
    [ "Eagle Granite Substation",[-82.90733472679928, 34.13798479373102]],
    [ "1043453231",[-82.98721985, 33.948366299999996]],
    [ "1043453232",[-82.98637085, 33.95098745]],
    [ "1043453237",[-82.98742135, 33.948011949999994]],
    [ "Plainfield-48 Substation",[-72.44416312910322, 44.28920222826446]],
    [ "Marshfield-6 Substation",[-72.33522622397554, 44.360102393174074]],
    [ "1043638575",[-80.38663447658246, 33.54618204481601]],
    [ "Arlington Substation",[-77.05802431643842, 38.878369927102455]],
    [ "1044268194",[-80.59962761980124, 38.119870371692095]],
    [ "Monongahela Power Company",[-81.02748980000001, 38.5911058]],
    [ "Monongahela Power Company",[-81.522097395969, 39.232641428135956]],
    [ "1044268217",[-81.35517176163927, 39.33687267489814]],
    [ "Bull Shoals Substation",[-92.57626191865346, 36.36360009090457]],
    [ "South Lead Hill Substation",[-92.93185138141092, 36.37760809401483]],
    [ "1044288707",[-93.30506060000002, 36.6039447]],
    [ "1044299900",[-91.39054137503611, 46.775254744365]],
    [ "Buzzard Roost Dam Substation",[-81.90255219075563, 34.168889980033185]],
    [ "1044329268",[-81.93094675, 34.1753545]],
    [ "1044341034",[-91.82510905000001, 46.56157855]],
    [ "1044355540",[-91.78838951492654, 46.56104803186393]],
    [ "1044365221",[-82.18122796927346, 34.20773802733013]],
    [ "1044387899",[-92.77665138935772, 38.05815409647974]],
    [ "1044388964",[-92.51578281716975, 36.664847643246326]],
    [ "1044388972",[-93.00485362445971, 37.12327043472325]],
    [ "1044388977",[-93.05353345000002, 36.99013120000001]],
    [ "1044392469",[-92.75834770139187, 38.02590068567537]],
    [ "1044397281",[-82.1605597951796, 34.14799826563876]],
    [ "1044415375",[-83.916676, 34.19796885]],
    [ "Oglethorpe Power Corporation",[-84.47964395696987, 34.01139658873556]],
    [ "Bells Ferry Road Substation",[-84.54958957507955, 34.085768207914114]],
    [ "Holly Springs Substation",[-84.53482654570533, 34.19524058100469]],
    [ "New Light Church Substation",[-84.47503708233974, 34.17669342546475]],
    [ "Georgia Power",[-84.46917836254339, 34.25627692041279]],
    [ "Cherokee Substation",[-84.49510822542688, 34.29739735655246]],
    [ "1044436292",[-84.42915439674547, 34.29564566789478]],
    [ "Cherokee Water Works Substation",[-84.37845362742566, 34.293378593846285]],
    [ "Pilgrims Pride Substation",[-84.40611661626531, 34.30536465119554]],
    [ "Martin Marietta Substation",[-84.35778984370285, 34.3633722804059]],
    [ "1044436301",[-84.20509721489073, 34.37710828189169]],
    [ "1044487789",[-92.58415325845866, 37.403944429085286]],
    [ "McCormick Substation",[-82.29280376579717, 33.90653606923159]],
    [ "Global Plaza Substation",[-77.43461492176554, 38.99327034093732]],
    [ "Interconnection Substation",[-77.44913871040126, 39.020171346810685]],
    [ "Botkinburg Substation",[-92.52002495430663, 35.69965672573278]],
    [ "Petit Jean Electric Cooperative Corporation",[-92.46055965, 35.554430749999995]],
    [ "Bee Branch Substation",[-92.38598731744435, 35.454396825900254]],
    [ "Entergy Arkansas",[-92.28037958388526, 35.12333175276094]],
    [ "Entergy Arkansas",[-92.28057906610162, 35.12414812221585]],
    [ "Entergy Arkansas",[-92.24747493433405, 34.949044167550944]],
    [ "First Electric Cooperative Cooperation",[-92.21250797513834, 34.94658950820774]],
    [ "Entergy Arkansas",[-92.19642969150713, 34.85803501756987]],
    [ "Damascus Substation",[-92.41403303381888, 35.370459517111215]],
    [ "First Electric Cooperative Cooperation",[-92.10737623436971, 35.43535067492735]],
    [ "First Electric Cooperative Cooperation",[-92.07729657442627, 35.47866161007788]],
    [ "Heber Springs South Substation",[-92.03565886815797, 35.479234975856514]],
    [ "Entergy Arkansas",[-92.0134043720565, 35.49730120589906]],
    [ "Entergy Arkansas",[-91.99543993687638, 35.520607787852846]],
    [ "Entergy Arkansas",[-91.80036630000002, 35.74781645]],
    [ "Entergy Arkansas",[-90.63614455308573, 35.76476865758267]],
    [ "1044633730",[-110.2058327238333, 32.18994601463443]],
    [ "1044816457",[-84.85900466288568, 33.177064122386426]],
    [ "Huntsville Utilities",[-86.70455482896656, 34.83497286184626]],
    [ "1045347622",[-82.88194515, 32.5348594]],
    [ "Georgia Power",[-82.86011422528595, 32.51772245751051]],
    [ "Georgia Power",[-82.840436, 32.52002805]],
    [ "Soperton #2 Switching Station",[-82.66461075, 32.40893075]],
    [ "Soperton Substation #2",[-82.664801913608, 32.40883032157434]],
    [ "Soperton Switchgear",[-82.59751045, 32.37025080000001]],
    [ "1045542346",[-106.54233621011011, 41.85135385988857]],
    [ "1045971017",[-106.36660885928364, 42.00430802802841]],
    [ "Jebco Substation",[-82.67847429999999, 33.40258325]],
    [ "Warrenton Substation",[-82.67084168836233, 33.406447919217115]],
    [ "East Warrenton Substation",[-82.63639408072267, 33.38729869822856]],
    [ "Martin Marietta Substation",[-82.63955834999999, 33.38299]],
    [ "Georgia Pacific Substation",[-82.6443677586746, 33.409285825459996]],
    [ "Timbermen Substation #1",[-82.64687973268705, 33.41794759839878]],
    [ "Timbermen Substation",[-82.63609353796747, 33.45896351870687]],
    [ "Apac Substation",[-82.63970785, 33.47423885]],
    [ "Gibson Substation",[-82.56932670296744, 33.238369251968486]],
    [ "Georgia Power",[-82.36908212382477, 31.202742322107273]],
    [ "Manor Substation",[-82.57625517470109, 31.106519335314736]],
    [ "1046349325",[-106.16175440367334, 42.04229289032096]],
    [ "1046349331",[-106.15915376933975, 42.04256861683051]],
    [ "1046349335",[-106.2264108611619, 42.18031641581161]],
    [ "Beaver Substation",[-93.84614856292623, 36.42264589809952]],
    [ "1046380104",[-93.93969175834182, 36.84557922529989]],
    [ "1046380112",[-93.71705430000002, 37.0646451]],
    [ "1046380114",[-93.33896289711733, 37.16213321969086]],
    [ "1046380119",[-93.33585956582095, 37.16139063524637]],
    [ "Sacramento Municipal Utility District",[-121.39525710529618, 38.39517325249081]],
    [ "1046500291",[-93.71609838533118, 36.76188462789012]],
    [ "1046554684",[-82.83291304247017, 38.70092535230042]],
    [ "Texas Eastern Transmission, LP",[-82.8339330335662, 38.700538698934416]],
    [ "1046683520",[-107.8564781, 43.6102875]],
    [ "1046702412",[-107.97740599535022, 44.02494765259338]],
    [ "1046878843",[-84.55699061832964, 33.82998089229843]],
    [ "Cogdell Substation",[-82.73003045000002, 31.172905750000005]],
    [ "Pearson Substation",[-82.84218911428609, 31.29368234160379]],
    [ "Georgia Power",[-82.84178442075881, 31.122698208461834]],
    [ "North Lakeland Substation",[-83.06068501974823, 31.050704437308703]],
    [ "Vermont Electric Power Company",[-73.35095843789287, 44.69672072500136]],
    [ "Plantation Substation",[-75.9659114655503, 37.2712083072989]],
    [ "1047316638",[-85.40067276504315, 40.16255132829693]],
    [ "Medford Substation",[-85.34203597003533, 40.14858241588853]],
    [ "Clarendon Substation",[-91.29239056128078, 34.69420162554768]],
    [ "Wabbaseka Substation",[-91.7951879, 34.385573300000004]],
    [ "Enterprise Products Operating LLC",[-91.75263342543919, 35.12849530880537]],
    [ "Trumann Substation",[-90.49986165606576, 35.65323084272835]],
    [ "Entergy Arkansas",[-90.41641006848378, 35.51366233419373]],
    [ "Arkansas Electric Cooperative Corporation",[-90.41788643408479, 35.512814116932546]],
    [ "1047443364",[-91.06625383515912, 35.53955656835351]],
    [ "Pecan Street Substation",[-91.26160615032691, 35.6166322806047]],
    [ "Melbourne Substation",[-91.87635376577997, 36.059182774305796]],
    [ "North Arkansas Electric Cooperative",[-92.29930217543976, 36.2988309444765]],
    [ "North Arkansas Electric Cooperative",[-92.30862628668187, 36.345262318987665]],
    [ "North Arkansas Electric Cooperative",[-92.34517469098408, 36.31691942441289]],
    [ "North Arkansas Electric Cooperative",[-92.31908374999998, 36.376255799999996]],
    [ "North Arkansas Electric Cooperative",[-92.37035507602971, 36.373902442300995]],
    [ "Midway Substation",[-92.46091566214822, 36.37749532537883]],
    [ "Mountain Home Substation",[-92.39330086038794, 36.32776081350429]],
    [ "Salem Substation",[-91.82679038117645, 36.36782112332931]],
    [ "1047506360",[-91.89832557266793, 36.63420030023684]],
    [ "1047506363",[-91.91433921306383, 36.81801627533942]],
    [ "Norcross Substation #2 MEAG",[-84.20475470879434, 33.94075941047579]],
    [ "1047650284",[-78.73107185467477, 42.150885707747804]],
    [ "1047656221",[-92.84329296015275, 36.52064482431688]],
    [ "1047656222",[-92.68347252451936, 36.58461740946754]],
    [ "1047656225",[-92.58849706369354, 36.78856764277099]],
    [ "1047656229",[-92.83391485, 36.912637149999995]],
    [ "1047656231",[-92.44168166030926, 36.6099572204289]],
    [ "1047656233",[-92.26347673191952, 36.60494542412787]],
    [ "1047656237",[-91.36901217274107, 37.14077649620658]],
    [ "1047661864",[-92.0746077, 37.9689914]],
    [ "Clay County Electric Cooperative Corporation",[-91.04260403313977, 36.26970873351548]],
    [ "1047691324",[-90.46349940486307, 36.73032542742128]],
    [ "1047691340",[-91.53178942668835, 36.51888192976264]],
    [ "Vonore Substation",[-84.26258718710534, 35.58440723960603]],
    [ "1048422860",[-82.78207149887234, 38.573015205038146]],
    [ "Southwest Arkansas Electric Cooperative",[-93.5976752798072, 33.4289830779777]],
    [ "1049178916",[-84.28656177625956, 35.6571924138737]],
    [ "1049310448",[-90.10776930288225, 42.85816952572266]],
    [ "1049364437",[-82.39580373518086, 28.200521678761206]],
    [ "South Alburgh Substation",[-73.27532287501916, 44.9243612461535]],
    [ "Vermont Electric Power Company",[-73.27362962754648, 44.63725269849393]],
    [ "1049386278",[-82.40001701489282, 28.20068307057708]],
    [ "1049423158",[-84.21962618828768, 31.484262382198803]],
    [ "Flint Substation",[-84.20282099003711, 31.31572342810606]],
    [ "Leary Substation",[-84.53349262201806, 31.520810838312226]],
    [ "Calhoun State Prison Substation",[-84.60986303922566, 31.542387074966214]],
    [ "Edison Substation",[-84.6926413878526, 31.5585028263056]],
    [ "1049423172",[-84.6925317, 31.558220650000003]],
    [ "Edison Substation",[-84.73253344999999, 31.559714849999995]],
    [ "MEAG",[-84.72510313748984, 31.46587967769957]],
    [ "1049423178",[-84.55632438782774, 31.588710662309914]],
    [ "1049470800",[-91.47957106964346, 31.689512667414192]],
    [ "Entergy Louisiana",[-92.2146901476563, 31.922636783677543]],
    [ "1049470809",[-91.58887290680119, 31.619369832208736]],
    [ "1049470818",[-91.82043243176855, 31.616518046360437]],
    [ "1049470819",[-91.82242389923928, 31.617301390144117]],
    [ "1049486550",[-93.04943556062862, 31.726495757906704]],
    [ "1049486551",[-93.04928007766773, 31.72551604063379]],
    [ "Jonesboro Substation",[-92.71377152165526, 32.2426988099559]],
    [ "Entergy Louisiana",[-92.0933612372775, 32.08801682087206]],
    [ "1049598316",[-103.79048417259979, 32.41355599439229]],
    [ "Lands' End Substation",[-90.14451319999999, 42.97486315]],
    [ "SR Arlington, LLC",[-84.83020409795013, 31.402040610254367]],
    [ "1049942449",[-93.62503887355884, 37.47918421978657]],
    [ "Georgia Transmission Corporation",[-84.91809359999999, 31.247388700000002]],
    [ "Bolton-41",[-72.86899214149899, 44.37251471955814]],
    [ "1049991427",[-84.03044396597419, 39.34236226440206]],
    [ "Georgia Power",[-84.76519323882407, 31.766178084431306]],
    [ "Georgia Power",[-84.79601699805382, 31.767858605433975]],
    [ "Georgia Power",[-84.85347565, 31.71595355]],
    [ "Suttons Corner Substation",[-84.84585705, 31.601304649999996]],
    [ "1050115606",[-81.53213835662939, 37.49776101803598]],
    [ "1050115607",[-81.53161880150643, 37.497922110556736]],
    [ "Scrubgrass Substation",[-79.81301147136466, 41.27032489570849]],
    [ "Flow Inn Diesel",[-67.95258078326407, 46.70966520953]],
    [ "Emera Maine",[-67.95246933227565, 46.70900128332433]],
    [ "1050156654",[-80.72941766221896, 35.31328279019947]],
    [ "1050196996",[-83.66140259114029, 32.61759295307818]],
    [ "Southwest Substation #25",[-83.67038511839704, 32.59593364209836]],
    [ "Centerville Substation",[-83.69145225046418, 32.631753428408146]],
    [ "Madera Substation",[-78.43451431301033, 40.82007671962755]],
    [ "1050232868",[-84.17436307472309, 33.97144377103035]],
    [ "Cargill Substation",[-83.9128073, 34.198026150000004]],
    [ "1050434898",[-67.84690762488165, 46.41927995445912]],
    [ "1050434901",[-67.84136269999999, 46.286169300000005]],
    [ "1050522041",[-100.8787036268212, 46.79835050517865]],
    [ "1050522045",[-100.8367873, 46.8068142]],
    [ "1050522052",[-100.81532138828915, 46.880166374809114]],
    [ "1050569675",[-95.13857695, 34.026517]],
    [ "1050569679",[-95.38256065, 34.002443400000004]],
    [ "1050569685",[-95.87404592590018, 34.31182296607475]],
    [ "1050616243",[-83.22334964999997, 34.51366629999999]],
    [ "1050674883",[-82.58032773961163, 38.26460912405539]],
    [ "1050674885",[-82.58018591066735, 38.26918577441681]],
    [ "1050674899",[-82.87415932034706, 37.87502964854162]],
    [ "1050674900",[-82.95788316311837, 37.95872125915773]],
    [ "Crockett Substation",[-83.16456805, 37.955980749999995]],
    [ "1050674908",[-83.28534325052814, 37.964883331351054]],
    [ "1050674909",[-83.27716651391454, 37.896157237142255]],
    [ "Morgan County Switching Station",[-83.29215842255559, 37.938604324460464]],
    [ "1050709441",[-83.90411893802361, 34.19196787689865]],
    [ "Bruce Substation",[-89.35061553731623, 33.98109413048465]],
    [ "Thelma Substation",[-82.76723299923526, 37.82641261895474]],
    [ "Thelma Substation",[-82.76542844241709, 37.82904202567196]],
    [ "1050762784",[-82.72171131942196, 37.35933578499213]],
    [ "1050762785",[-82.70450876035676, 37.25707487913378]],
    [ "1050762788",[-82.69425709114356, 37.197224529201236]],
    [ "1050762789",[-82.66212441914672, 37.163169584531026]],
    [ "1050762792",[-82.54449840000002, 37.1253119]],
    [ "Moss Substation",[-82.35639416588064, 37.15184879406587]],
    [ "Haysi Substation",[-82.30073911090442, 37.20859661969747]],
    [ "Dorton",[-82.56944161133414, 37.23924090660741]],
    [ "1050803078",[-82.53691028654202, 37.345220868015424]],
    [ "Fords Branch",[-82.511350399931, 37.43266433947404]],
    [ "1050803082",[-82.53465793958159, 37.467766863338944]],
    [ "1050803084",[-82.39490580980522, 37.54420371128022]],
    [ "Stone Substation",[-82.26982312493723, 37.59212326172975]],
    [ "Brookfield Substation",[-83.38414313659085, 31.424745144502648]],
    [ "1050838950",[-83.38378929224525, 31.42515497455629]],
    [ "1050838958",[-83.16861991497143, 31.269640654563336]],
    [ "1050838964",[-82.9440212995689, 31.359842865835333]],
    [ "1050874278",[-93.03993772515848, 43.557409142980966]],
    [ "1050889111",[-83.70110403086467, 39.03274493741109]],
    [ "1051015050",[-86.3767100383172, 39.733342475225776]],
    [ "Paramont Contura, LLC",[-82.39155330000001, 37.10282215]],
    [ "1051018044",[-82.63884290775049, 37.217699281804435]],
    [ "1051018047",[-82.80801484931716, 37.35801761655621]],
    [ "1051018049",[-82.93058740917718, 37.3076358889255]],
    [ "1051018050",[-83.04543405757313, 37.228069481595035]],
    [ "Hazard",[-83.1749495357763, 37.24492234414212]],
    [ "1051018052",[-83.25914859755855, 37.18225659672015]],
    [ "1051027536",[-86.41767208058931, 39.695746774289574]],
    [ "Bulan",[-83.16567172581264, 37.302083521594696]],
    [ "1051160588",[-83.21988917489638, 37.31363730748539]],
    [ "1051160591",[-83.23653816559897, 37.290833976244635]],
    [ "1051160592",[-83.2082391, 37.27430045]],
    [ "1051160596",[-83.54376560618485, 37.72773916028214]],
    [ "1051160597",[-83.68770587165142, 37.71054785927244]],
    [ "1051176446",[-83.12491126383658, 37.05004688252304]],
    [ "1051176448",[-83.12602684999999, 37.04738174999999]],
    [ "Leslie",[-83.321228351416, 37.14233368712829]],
    [ "1051176450",[-83.5383026, 36.9680085]],
    [ "1051385487",[-83.13829791800259, 37.20594630172306]],
    [ "1051385488",[-82.84544088459437, 37.17180192394173]],
    [ "1051385493",[-82.94792755251763, 36.96190379740926]],
    [ "1051385497",[-82.91922377321836, 36.964688318023725]],
    [ "1051385498",[-82.78390998549314, 36.953182317208466]],
    [ "1051385500",[-82.80061386831201, 36.94190400500036]],
    [ "1051385504",[-82.62048539999999, 36.942816750000006]],
    [ "1051385505",[-82.60491181668898, 36.94825019981438]],
    [ "Wellfleet Substation",[-70.0176774957283, 41.947297561598546]],
    [ "Rebecca Substation",[-83.48131659802574, 31.811385116769713]],
    [ "1051456769",[-83.239998751599, 31.69955831687507]],
    [ "Modern Dispersions Substation",[-83.25564971904967, 31.68116373026645]],
    [ "Highway 90 Substation",[-83.6945057053635, 31.900116296832433]],
    [ "1051502339",[-83.79119610218707, 31.95326812142036]],
    [ "1051502344",[-83.7674739335609, 31.868505133117292]],
    [ "1051502352",[-83.86632398163722, 31.89003036758862]],
    [ "Spier Falls Station 34",[-73.75279866919281, 43.23507056895927]],
    [ "Oak Hill Substation",[-91.63712619761864, 41.975542267322204]],
    [ "1051700725",[-113.12343551759544, 40.73084038356311]],
    [ "1051700727",[-113.1470156, 40.68435075000001]],
    [ "1051700731",[-113.20117740000002, 40.81153415]],
    [ "1051723372",[-87.92933683503216, 43.3015129750835]],
    [ "1051748624",[-84.45202065939066, 33.65285745974762]],
    [ "1051807383",[-84.20921333249268, 34.258790498542176]],
    [ "Ducktown Substation",[-84.24047372461233, 34.24687968552581]],
    [ "1051807386",[-84.26052855527384, 34.20093812151368]],
    [ "Acworth Water Treatment Substation",[-84.65535915, 34.04675415]],
    [ "Marietta Water Authority Substation",[-84.68749553326424, 34.04624653363441]],
    [ "1051836838",[-84.69216684414465, 34.04553070279252]],
    [ "1051836840",[-84.70159028080478, 34.00454537484907]],
    [ "Powder Springs Substation",[-84.68866469999999, 33.88150304999999]],
    [ "Macland Substation",[-84.65912119954146, 33.877396228440226]],
    [ "Austell Substation",[-84.63870066245495, 33.81357033533154]],
    [ "Caraustar Substation",[-84.64870175000001, 33.8172408]],
    [ "Caraustar Substation #2",[-84.64863480000001, 33.820222150000006]],
    [ "Foxboro Substation",[-84.73330879928723, 33.85841912681372]],
    [ "1051836859",[-84.76667645, 33.87094665]],
    [ "1051836863",[-84.77145760786378, 33.91992587913513]],
    [ "1051836867",[-84.59528733326594, 33.82234869838615]],
    [ "1051878245",[-84.78044645830204, 33.759345420293805]],
    [ "Martin Marietta Substation",[-84.78833273111809, 33.73579289468823]],
    [ "1051878253",[-85.03736772558794, 33.74335209295764]],
    [ "Bremen Switching Station",[-85.14294957835929, 33.707919756365925]],
    [ "West Villa Rica Substation",[-84.95961128008386, 33.74175535634053]],
    [ "Yorkville Substation",[-85.01920361266957, 33.9125974525247]],
    [ "Sand Hill Switching Station",[-84.9769197, 33.6368498]],
    [ "South Villa Rica Substation",[-84.92075165764814, 33.721133324758284]],
    [ "Fairplay Substation",[-84.85625192493778, 33.628984158157884]],
    [ "Fairplay Switching Station",[-84.85679497178667, 33.62892613339309]],
    [ "1051878283",[-84.75442052003355, 33.71260708847744]],
    [ "West Point Dam Substation",[-85.19038987080171, 32.91862350728304]],
    [ "Lee County Switching Station",[-85.31857274942182, 32.577447833524275]],
    [ "Providence Substatioin",[-85.34130936681622, 32.549279783525996]],
    [ "1051944119",[-92.1299971, 43.5597918]],
    [ "1051944122",[-92.23782483067028, 43.45049412609268]],
    [ "1051944125",[-92.38991207495587, 43.54381659413737]],
    [ "1051959020",[-116.05594257688247, 48.091772866870016]],
    [ "1051959022",[-116.05732155, 48.09213515]],
    [ "1051974426",[-85.88717976853708, 32.524711710112946]],
    [ "1051974427",[-85.54315241523639, 32.50635958029467]],
    [ "1051974428",[-85.14710441236582, 32.50008091415095]],
    [ "Terrell Solar Switching Station",[-84.36750563702016, 31.87368462888737]],
    [ "Terrell Solar Substation",[-84.36809791097907, 31.87292575985217]],
    [ "1051983764",[-84.26429081223183, 32.060174025277284]],
    [ "Tolleson Lumber Substation",[-84.49029506691207, 32.03591824832273]],
    [ "Centerpoint Substation",[-84.5544102554862, 31.969442320811073]],
    [ "Preston Substation",[-84.54717135, 32.0700477]],
    [ "1051983786",[-84.16546321366192, 31.6780846724748]],
    [ "Andersonville Substation",[-84.15511687623234, 32.196782041145674]],
    [ "1052001743",[-84.10332412803328, 32.287371895610356]],
    [ "Piney Grove Church Substation",[-84.01494650000001, 32.375244800000004]],
    [ "Charing Substation",[-84.35734878127904, 32.47336419696037]],
    [ "1052001755",[-84.0935006751729, 32.55878977411189]],
    [ "1052001758",[-84.09285369157566, 32.560450862842366]],
    [ "1052036468",[-84.14209515888165, 31.94021253170787]],
    [ "Leslie Substation",[-84.08386920663995, 31.956306083339722]],
    [ "1052036476",[-84.22500910000002, 32.044516400000006]],
    [ "New York Power Authority",[-73.38478595000001, 44.702082149999995]],
    [ "1052083149",[-81.04548017397529, 41.53548903498902]],
    [ "Salt River Substation",[-84.55085554050001, 43.73034533867114]],
    [ "Venango Junction Substation",[-80.12082415533072, 41.772380057293155]],
    [ "1052120453",[-78.7889194, 33.77673875]],
    [ "Squab Hollow Substation",[-78.65432144717965, 41.36820108703099]],
    [ "Butler Solar Substation",[-84.31235330487816, 32.576537480054135]],
    [ "1052137285",[-84.3121914204633, 32.57691815596866]],
    [ "1052162784",[-89.20052707492539, 43.205760260746445]],
    [ "Sun Prairie",[-89.21879569337372, 43.17731372251992]],
    [ "North Lansing Substation",[-84.54865522870253, 42.77952014284689]],
    [ "1052174606",[-88.83434177490726, 40.45016085354342]],
    [ "1052174616",[-87.69654647521098, 40.39568539310166]],
    [ "1052174617",[-87.69640145681993, 40.39442042586535]],
    [ "Ameren",[-88.96203684263637, 40.18525661554346]],
    [ "1052174632",[-88.97433056059327, 40.12588077635244]],
    [ "Entergy Arkansas",[-93.25748648302363, 35.01839615844938]],
    [ "Entergy Arkansas",[-92.96952602026212, 34.53517369153341]],
    [ "Reynolds Consumer Products LLC",[-92.90189450721448, 34.45755644386553]],
    [ "Entergy Arkansas",[-92.89259935000001, 34.42864205]],
    [ "Georgia Pacific Substation",[-93.15073486482298, 33.949228487950364]],
    [ "Dalark Substation",[-92.88968361868484, 34.06035348634311]],
    [ "1052266315",[-95.71693601813544, 41.73323581497153]],
    [ "1052285955",[-80.2757759334016, 33.91565551526105]],
    [ "Rialto Substation",[-117.36829762618616, 34.10130569189735]],
    [ "Ringle Substation",[-83.56811218113582, 43.56000974141702]],
    [ "1052339697",[-91.37188393916462, 43.663285630381786]],
    [ "MiEnergy Cooperative",[-91.48722900307301, 43.58790363741406]],
    [ "1052339707",[-91.51233166134668, 43.591232098318514]],
    [ "1052339711",[-91.62897046034246, 43.56435391133126]],
    [ "1052339714",[-91.62655845979059, 43.56605321100489]],
    [ "1052339716",[-91.7400083505432, 43.60503524738069]],
    [ "1052339719",[-91.93101126420054, 43.595349374551674]],
    [ "Pawpaw Solar Substation",[-84.27370432481526, 32.57027505973007]],
    [ "Geneva Substation",[-84.5507988245089, 32.57983820829666]],
    [ "1052396230",[-84.00768766557586, 32.65804570428708]],
    [ "1052396231",[-84.00800572325342, 32.65810506688177]],
    [ "Roberta Substation",[-84.00859545718568, 32.71723292166881]],
    [ "1052434458",[-82.99320386886762, 34.71214444470228]],
    [ "1052434459",[-83.00573137215609, 34.73124580470303]],
    [ "1052434489",[-82.80425186526593, 34.65680579659335]],
    [ "1052462617",[-85.04369600817363, 31.700611393549703]],
    [ "1052462971",[-88.00911008653706, 44.73163781865335]],
    [ "1052587333",[-84.65680209632352, 32.55455158171763]],
    [ "Buena Vista Substation",[-84.52321615523786, 32.30528667086186]],
    [ "Lumpkin Substation",[-84.78720114999999, 32.05175425]],
    [ "1052611895",[-83.91533437906645, 32.09136996310961]],
    [ "1052611897",[-84.15075701665789, 32.11564339996428]],
    [ "1052611898",[-84.15125194946286, 32.11603281674732]],
    [ "Imerys Substation",[-84.11755060953105, 32.183887021204995]],
    [ "1052611997",[-83.92265393353453, 32.301580306391465]],
    [ "Pinehurst Substation",[-83.76832772921416, 32.1839219257771]],
    [ "1052612003",[-83.63348570000001, 32.16069809999999]],
    [ "1052689687",[-83.73726846685824, 32.46936859926092]],
    [ "1052689694",[-83.81550455, 32.56225575]],
    [ "1052696629",[-83.68908556792869, 32.52939548488228]],
    [ "East Ryegate-85 Substation",[-72.06038255611797, 44.208406672183656]],
    [ "Great Falls Substation",[-71.9996529328645, 44.50039384776851]],
    [ "1052796365",[-91.55234268733706, 43.75400217603312]],
    [ "1052878442",[-94.86867017911192, 42.25265076262368]],
    [ "1052888245",[-88.0402019395902, 44.49125711127927]],
    [ "South Broadway",[-88.04080067062223, 44.49146800100251]],
    [ "Van Buren St",[-87.9974044346699, 44.52289239087532]],
    [ "1052888258",[-88.00555838176656, 44.530552494971225]],
    [ "1052993337",[-84.9619967872074, 33.03892172914734]],
    [ "1053010698",[-84.97878031764755, 32.46380281936292]],
    [ "1053074353",[-84.60771046442711, 32.822220608284006]],
    [ "1053074355",[-85.11905428236447, 33.00088269279616]],
    [ "1053074357",[-85.10007895033314, 33.030560082354185]],
    [ "1053074359",[-85.05731057533747, 33.0253082929005]],
    [ "Tabernackle Substation",[-74.72564122951842, 39.835318520594036]],
    [ "Fayetteville Substation",[-77.5662685751961, 39.90403838799816]],
    [ "1053446045",[-77.64019689807259, 39.98032347871187]],
    [ "Georgia Power",[-81.5187755158475, 30.931116332615016]],
    [ "Waverly Switching Station",[-81.7254003, 31.0973655]],
    [ "Waverly Substation",[-81.72509450806285, 31.097348754284607]],
    [ "Spring Bluff Substation",[-81.62334125927347, 31.10378878075519]],
    [ "Symrise Substation",[-81.55134491580341, 31.108656583973566]],
    [ "Jekyll Island Substation",[-81.42124524999998, 31.0498419]],
    [ "1053709617",[-83.11340494139857, 31.98043805919301]],
    [ "1053709619",[-83.11833015, 32.008379199999986]],
    [ "Ararat Substation",[-83.12510445111404, 32.06290941659191]],
    [ "1053709621",[-83.01830719868497, 31.88996644515981]],
    [ "Medusa Portland Cement Substation #3",[-83.66594604536283, 32.39665213158746]],
    [ "1053709644",[-83.47049448262179, 32.29661850288505]],
    [ "1053788461",[-82.42644623627923, 38.509894625865535]],
    [ "Enosburg Switch Substation",[-72.81403159999999, 44.91246805]],
    [ "1053891375",[-97.25592341259083, 32.63912352818014]],
    [ "Fairfield Glade Substation",[-84.89321389919255, 36.00942428655167]],
    [ "Empire Substation",[-83.27632323487038, 32.344324047676075]],
    [ "Plainfield Substation",[-83.12326416112907, 32.29549427970904]],
    [ "Cadwell Substation",[-83.04529935, 32.3396695]],
    [ "Rentz Substation",[-83.00147265930467, 32.384411167554944]],
    [ "Dexter Substation",[-83.04419874999999, 32.418836150000004]],
    [ "1054037682",[-82.94143072983219, 32.44502572150623]],
    [ "Dirt Road Substation",[-82.92310160946234, 32.52164211068209]],
    [ "Achord Road Substation",[-82.9464835420267, 32.50252859010274]],
    [ "1054037694",[-82.93113348215503, 32.52026888371486]],
    [ "Vinson Medical Center Substation",[-82.94403637433362, 32.53459666438611]],
    [ "Danville Substation",[-83.25928784162394, 32.59884466043382]],
    [ "1054155080",[-83.37016395000002, 32.6269842]],
    [ "1054155091",[-83.09911884536862, 32.45625933426315]],
    [ "Eight Flags Energy Substation",[-81.4701426377415, 30.66127265872399]],
    [ "1054230316",[-81.17179470913574, 32.3573934339382]],
    [ "High Falls HY",[-88.20044746574011, 45.27959955152405]],
    [ "1054295726",[-91.86888685880639, 43.98841072491867]],
    [ "1054295730",[-91.91960464435361, 43.99183497440293]],
    [ "1054295733",[-91.7203258749563, 43.933604809785734]],
    [ "1054295735",[-91.55078650000002, 43.929834]],
    [ "1054295739",[-91.7816672, 43.80208285]],
    [ "1054295742",[-91.7555087856694, 43.81380112239705]],
    [ "1054304309",[-78.4643434538284, 42.19467740406728]],
    [ "1054304649",[-88.05920752467517, 45.78768454592106]],
    [ "Big Quinnesec 61",[-88.04107077821038, 45.789016809437136]],
    [ "Portage",[-88.64717245961994, 47.08107938929075]],
    [ "Fiber Visions Substation",[-83.85227023328538, 33.61029365044452]],
    [ "1054358941",[-83.84378579999999, 33.611798549999996]],
    [ "1054358945",[-83.97448899303384, 33.65408939765018]],
    [ "1054358951",[-83.9971392, 33.6607186]],
    [ "1054358952",[-84.01805936504422, 33.65610968196056]],
    [ "Air Products Substation",[-83.99284501961218, 33.6557435351618]],
    [ "Milstead Substation",[-83.99031749999999, 33.689127]],
    [ "1054358962",[-84.02555208545066, 33.68169796232213]],
    [ "1054358966",[-84.03519115, 33.6771656]],
    [ "Vulcan Materials Substation #2",[-84.07505264999999, 33.7065304]],
    [ "Vulcan Materials Substation #1",[-84.0728856705931, 33.7073053529239]],
    [ "1054358983",[-84.09068279061796, 33.726015228163284]],
    [ "Hanson Aggregates Substation",[-84.09846225, 33.72979]],
    [ "Martin Marietta Substation",[-84.07293262647397, 33.751353608787056]],
    [ "Encore Recycling Substation",[-84.11189, 33.732497300000006]],
    [ "1054358996",[-83.87174881016921, 33.61162985226435]],
    [ "1054359013",[-83.84631926226544, 33.61351084026106]],
    [ "1054359014",[-83.8454658994511, 33.61394561667177]],
    [ "1054359015",[-83.84484008333332, 33.6136448]],
    [ "1054359019",[-83.84348019999999, 33.614116599999996]],
    [ "1054359020",[-83.84227335934932, 33.614273674759886]],
    [ "1054359021",[-83.84154570761963, 33.61430637549325]],
    [ "SRG Global Substation",[-83.83603351859156, 33.6128082647098]],
    [ "1054359026",[-83.82509073414279, 33.61862186264863]],
    [ "1054359034",[-83.8099536274795, 33.619103258352965]],
    [ "1054359038",[-83.75434912862953, 33.61121294158768]],
    [ "1054387425",[-83.71317305, 33.6532613]],
    [ "1054387429",[-83.70266104999999, 33.652302549999995]],
    [ "1054387430",[-83.69083008403608, 33.65347914526442]],
    [ "Goodyear Substation",[-83.70699192170468, 33.6662030042866]],
    [ "CertainTeed Substation",[-83.70752660000001, 33.66969034999999]],
    [ "Social Circle Primary Substation",[-83.70364924207779, 33.681420544721774]],
    [ "1054387445",[-83.7383711953846, 33.55636732868869]],
    [ "1054387447",[-83.73990430370021, 33.48945472745819]],
    [ "Mansfield Substation",[-83.73320144021761, 33.51775593148147]],
    [ "1054387453",[-83.7070524095639, 33.60957472262635]],
    [ "Newton Data Center Substation",[-83.703115470288, 33.60366600370641]],
    [ "Sunoco Substation",[-76.71663039675012, 40.22228592964471]],
    [ "Letort Substation",[-76.4399495, 39.98263364999999]],
    [ "Millwood Substation",[-76.31712373896764, 39.949168442100984]],
    [ "1054512699",[-83.48989656943644, 33.57775015442129]],
    [ "1054512702",[-83.49278433846138, 33.57535705373881]],
    [ "1054512709",[-83.42217038227436, 33.61122974462934]],
    [ "Armstrong-Marietta Substation",[-76.58497090000002, 40.060322150000005]],
    [ "Marietta Substation",[-76.56828005807793, 40.0662030324748]],
    [ "Donerville Substation",[-76.41025499999999, 40.04167734999999]],
    [ "Rohrerstown Substation",[-76.35321471541917, 40.053260616981824]],
    [ "East Elizabethtown Substation",[-76.58075221715015, 40.164098208297744]],
    [ "1054535493",[-76.60844694696551, 40.147145710402114]],
    [ "1054575955",[-85.94109091438405, 41.311883793367684]],
    [ "1054722704",[-85.46533291665605, 41.10521354997903]],
    [ "1054722706",[-85.37410133380789, 41.06216350196638]],
    [ "1054722707",[-85.37393742505802, 41.06294881307133]],
    [ "1054723060",[-83.38973646103082, 42.32224822455517]],
    [ "1054868565",[-83.21973173583193, 33.58098752735706]],
    [ "1054868571",[-83.18413772508633, 33.49762516143687]],
    [ "Lake Oconee Substation",[-83.24745108329904, 33.459529700231954]],
    [ "1054868578",[-83.38951815967673, 33.35418044769571]],
    [ "Dixie Pipeline Substation",[-83.44814575, 33.36308925]],
    [ "1054868582",[-83.38456171671966, 33.323343447175496]],
    [ "1054868583",[-83.39085278102941, 33.31580484618926]],
    [ "Yost Bridge",[-84.93854625, 40.8470668]],
    [ "1055079628",[-85.13622421705755, 40.48074519059876]],
    [ "Olmstead Substation",[-76.75050765499302, 40.19757062332093]],
    [ "Met-Ed",[-76.74028726339901, 40.188094195476395]],
    [ "Swatara Hill Substation",[-76.68799896531164, 40.19658227264213]],
    [ "1055137533",[-83.13958135611253, 33.60183031773898]],
    [ "1055137537",[-83.08533572258322, 33.50935167041784]],
    [ "Facebook Data Center",[-93.52095338357209, 41.66991380208595]],
    [ "1055220490",[-91.90879228856923, 44.10670706374058]],
    [ "1055220492",[-91.7908027407233, 44.045858670567966]],
    [ "1055225395",[-85.81398010409205, 40.575443338660634]],
    [ "U.S. Naval Air Station Substation",[-84.52622674999999, 33.91264425]],
    [ "1055270124",[-84.52230310088825, 33.913344987949046]],
    [ "1055512083",[-84.61840553447333, 34.089571624618536]],
    [ "1055512091",[-84.68190315, 34.116279399999996]],
    [ "Cross Street",[-85.59254627474955, 40.13443595688955]],
    [ "West Logan Substation",[-82.42583191675877, 39.53808333141501]],
    [ "1055698204",[-85.0488439997294, 39.19811316654185]],
    [ "1055737251",[-84.82175352462463, 34.18456125657866]],
    [ "1055759736",[-84.92781043094791, 34.12105619577225]],
    [ "1055759879",[-84.9217009894721, 34.124197309189555]],
    [ "Rockmart Substation",[-85.04313803678369, 34.00136011908539]],
    [ "1055793760",[-85.03591864999997, 34.0018934]],
    [ "1055840903",[-85.20684374999999, 39.497191799999996]],
    [ "1055840914",[-85.32538548245276, 39.80725868457507]],
    [ "1055841781",[-92.01002605, 43.97119515000001]],
    [ "1055851167",[-100.93245587453181, 38.3126957541611]],
    [ "1055851169",[-100.9298553965109, 38.01921121597536]],
    [ "1055969028",[-104.40590639999999, 33.19812335]],
    [ "1055969031",[-104.59430495995258, 33.16039197478864]],
    [ "Geo Speciality Chemicals Substation",[-85.2665035899753, 34.01594297742326]],
    [ "1056086910",[-85.27701132485915, 34.01233309415524]],
    [ "1056086912",[-85.28047985, 34.01163045]],
    [ "1056086915",[-85.2828820251379, 34.01143765898935]],
    [ "Arsenal Tech Substation",[-86.13557159155872, 39.775936575180495]],
    [ "1056134341",[-86.20727953971391, 39.88396584828472]],
    [ "1056134359",[-86.23449452761663, 39.77998026119652]],
    [ "Plantation Pipeline Substation",[-85.10062905000001, 34.1189502]],
    [ "Wax Substation",[-85.10082581317141, 34.11850917507437]],
    [ "Cave Spring Substation",[-85.34041983675336, 34.11289711951392]],
    [ "1056162045",[-85.1545100822331, 34.21780266454822]],
    [ "Bekaert Steel Wire Substation",[-85.17070535608273, 34.2200923386364]],
    [ "1056309841",[-88.72993663663445, 44.38224812512064]],
    [ "1056309862",[-88.72606502988317, 44.53170193812301]],
    [ "1056316729",[-91.94926505923222, 43.77427054118407]],
    [ "1056339033",[-116.02882315992066, 43.03561866230725]],
    [ "1056459112",[-106.33813307278805, 35.36110518273365]],
    [ "Belzoni Substation",[-90.50067360668686, 33.18485852491465]],
    [ "1056522602",[-82.33070869186048, 38.89826681397851]],
    [ "1056524393",[-82.30203040484183, 38.885448388341715]],
    [ "1056912088",[-84.89002827264338, 34.22295344825615]],
    [ "1056912093",[-84.90441348237235, 34.24067700201501]],
    [ "1056912095",[-85.05103353317978, 34.364006342714035]],
    [ "1056912110",[-85.09416904099716, 34.32820761593494]],
    [ "1056912120",[-85.11451706551401, 34.28987439455296]],
    [ "Hookdale",[-89.31970439223315, 38.78592608485074]],
    [ "Greenville",[-89.37252576920729, 38.880768096121585]],
    [ "1057034219",[-82.6251999452143, 38.85024207292121]],
    [ "Marathon Pipe Line LLC",[-89.01987249999999, 38.264134999999996]],
    [ "1057181551",[-89.81285165736038, 39.11467058895995]],
    [ "1057181556",[-90.14189801101233, 38.88396854700283]],
    [ "Adairsville Substation",[-84.94123483693122, 34.36870874403024]],
    [ "1057626018",[-84.95081587069964, 34.69788628153529]],
    [ "1057626035",[-84.94520494999999, 34.732057749999996]],
    [ "1057626036",[-84.9452114, 34.7315402]],
    [ "1057685964",[-84.99743935, 34.782189699999996]],
    [ "1057685968",[-84.98246060534818, 34.78148267533305]],
    [ "1057685971",[-84.96565986643066, 34.78373146689716]],
    [ "1057685972",[-84.95581134105942, 34.79140989603335]],
    [ "1057685976",[-85.09895090566339, 34.720667194939544]],
    [ "LaFayette Switching Station",[-85.27288935799018, 34.70394367876588]],
    [ "LaFayette Substation #3",[-85.28991833752819, 34.677629721850366]],
    [ "Brison Substation",[-85.27724340485871, 34.59360676379972]],
    [ "Trion Substation",[-85.29911540328528, 34.540797151265444]],
    [ "Mount Vernon Mills Substation",[-85.31356294341356, 34.54854710284735]],
    [ "Plantation Pipeline Substation",[-85.19001564999999, 34.47424785]],
    [ "1057686009",[-85.35736140000002, 34.460722249999996]],
    [ "Menlo Substation",[-85.463723161966, 34.485474236444496]],
    [ "1057686020",[-85.39488015, 34.411924750000004]],
    [ "1057686024",[-85.39409998317417, 34.41609834868189]],
    [ "1057686027",[-85.30568627152884, 34.36762459296885]],
    [ "1057712843",[-85.26414753524584, 34.774767318204454]],
    [ "1057713507",[-88.09118360637265, 38.75012485263168]],
    [ "Twin Falls SW STA",[-88.07140985, 45.87267945000001]],
    [ "Liberty Substation",[-119.33209075550037, 36.28311282163925]],
    [ "TPSS#1 Plainfield Street",[-77.18802394260432, 38.907529010991176]],
    [ "1057891210",[-84.92344589321279, 34.6003263415242]],
    [ "1057891228",[-84.8827738583634, 34.83668387862602]],
    [ "1057891233",[-85.00400670847746, 34.88664847547005]],
    [ "Dalton Wastewater Substation",[-84.92983572555924, 34.724678111040944]],
    [ "1057942669",[-84.96303950459976, 34.77444345138312]],
    [ "TVA",[-85.25949183178206, 34.865047493639615]],
    [ "Chapel Street Substation",[-83.55672935738879, 30.77936527557324]],
    [ "1057982410",[-98.91430168819737, 29.95983746637553]],
    [ "1057985324",[-82.51772008506016, 28.19027077495867]],
    [ "Bainbridge Substation",[-84.5668975059746, 30.91248281966983]],
    [ "Georgia Power",[-84.60457236665764, 30.914217700188807]],
    [ "Georgia Transmission Corporation",[-84.6815392323362, 30.90390955600105]],
    [ "Reynoldsville Substation",[-84.77701837878699, 30.876832047885543]],
    [ "Donaldsonville Substation",[-84.8837691492701, 31.042932868210976]],
    [ "Georgia Transmission Corporation",[-84.78064692972724, 31.13355782450818]],
    [ "East Colquitt Substation",[-84.6892197804257, 31.187179866839873]],
    [ "1058042155",[-87.31272423004532, 32.61540001158055]],
    [ "1058042156",[-87.3153146578111, 32.6194326744468]],
    [ "1058053789",[-84.34220634999998, 31.302951749999995]],
    [ "Elmodel Substation",[-84.47292357589004, 31.34526707873778]],
    [ "1058053792",[-84.49622418322733, 31.477712454086344]],
    [ "1058053795",[-84.51205093336839, 31.48237964710087]],
    [ "Damascus Substation",[-84.71460701151442, 31.304113725466507]],
    [ "Alabama Power",[-85.1114488788828, 31.22671886392302]],
    [ "Columbia Substation",[-85.12394669999999, 31.29275925]],
    [ "Ashford Substation",[-85.26100835454179, 31.197171443146377]],
    [ "Cottonwood Substation",[-85.26259572996841, 31.099831084450273]],
    [ "1058072973",[-84.05896449224166, 30.986605929173585]],
    [ "Mineola Substation",[-83.34416185761069, 30.90742926608217]],
    [ "Messer Substation",[-83.40719708946885, 31.09912902781302]],
    [ "1058099530",[-83.42907172953271, 31.137305406069615]],
    [ "1058099534",[-83.4626576858347, 31.148378250316096]],
    [ "Pinova Substation",[-81.48209400907044, 31.16244177762929]],
    [ "1058106852",[-81.35836988705077, 31.231553834124057]],
    [ "Darien Substation",[-81.43215738758171, 31.375347123746057]],
    [ "1058177099",[-82.92529391261363, 31.55364462529922]],
    [ "Denton Substation",[-82.75018095000001, 31.720974900000005]],
    [ "1058177110",[-82.59291113320029, 31.860138697720146]],
    [ "1058177112",[-82.59467598029364, 31.860326994832203]],
    [ "1058177114",[-82.5932114, 31.864961950000005]],
    [ "1058177116",[-82.59564460000001, 31.860329600000004]],
    [ "Johnsville Substation",[-80.80726414137463, 33.129503262646566]],
    [ "Doles Substation",[-83.88480711129912, 31.70503027002426]],
    [ "1058209334",[-89.00770573629039, 38.98849462841681]],
    [ "1058243454",[-84.1081173, 31.63677370000001]],
    [ "Honeybrook Substation",[-75.91472971954265, 40.10233434704607]],
    [ "1058251672",[-84.42313840000001, 31.767843650000003]],
    [ "Bronwood Substation",[-84.36104130934314, 31.822755389434107]],
    [ "1058251684",[-84.44874560000001, 31.781508250000005]],
    [ "Richmond Hill Substation",[-81.31346202210125, 31.94674124944603]],
    [ "1058253998",[-81.1803602, 32.20404995]],
    [ "1058254614",[-83.15154271476727, 32.17047097059527]],
    [ "Tyson Substation",[-84.11345114761184, 32.334031957956356]],
    [ "1058260429",[-83.89849973973094, 32.575124074841696]],
    [ "1058260433",[-84.30002585, 32.66732880000001]],
    [ "Entergy Arkansas",[-91.344409, 33.47852]],
    [ "1058275067",[-91.34407575, 33.477428800000006]],
    [ "1058278362",[-113.60267890173735, 37.63477501729699]],
    [ "1058278363",[-113.60330348595954, 37.63411462490362]],
    [ "1058278365",[-113.62095806434549, 37.620001068630216]],
    [ "1058281174",[-102.86149870444335, 32.30240782999081]],
    [ "1058281176",[-102.87808115645693, 32.27999936026189]],
    [ "1058281178",[-102.84043459999998, 32.28789904999999]],
    [ "1058296725",[-87.65449911827535, 40.105982542398]],
    [ "1058311102",[-77.71362735461466, 36.0048382597215]],
    [ "1058313857",[-100.1670669192805, 32.10195699296916]],
    [ "Twiggs Solar Switching Station",[-83.48745240869515, 32.60985774389594]],
    [ "1058316820",[-95.37174078080116, 33.467660953684835]],
    [ "Columbia Substation",[-85.24447769999999, 42.2985527]],
    [ "Padre Flat Substation",[-120.97592117766665, 37.01861405214431]],
    [ "1058327753",[-102.66925938386545, 32.457304052430096]],
    [ "1058329055",[-83.26837851721416, 32.80657476817784]],
    [ "Twiggs Solar",[-83.48749587452092, 32.60872569348571]],
    [ "1058331223",[-116.4909319, 36.53192275]],
    [ "1058338313",[-82.97896511811562, 33.28777590471823]],
    [ "1058338315",[-84.07979438240957, 33.35783610242257]],
    [ "Clinton 69 Substation",[-93.76166140629982, 38.38865288026559]],
    [ "Clinton 161 Substation",[-93.76084478828487, 38.389171527921285]],
    [ "Clinton 161 Substation",[-93.75953816890103, 38.38858006563294]],
    [ "Central Electric Power Co-op",[-93.3644802433028, 38.26655197311254]],
    [ "FIXME Substation",[-93.29593302725226, 38.205437459986385]],
    [ "Georgetown Substation",[-85.08184084999999, 31.883271100000005]],
    [ "Eufaula Central Substation",[-85.14929079999999, 31.8897502]],
    [ "East Eufala Substation",[-85.13970517423581, 31.891770383952526]],
    [ "1058400735",[-92.33876471505127, 43.71019436783772]],
    [ "1058400739",[-92.14315859509952, 43.73132057572514]],
    [ "1058400745",[-92.08283183287298, 43.666222420361606]],
    [ "CPC Meridian Substation",[-88.73736101600977, 32.40957930249604]],
    [ "40th Street Substation",[-88.7210307897053, 32.39988735350932]],
    [ "Ely Substation",[-119.1542331357855, 46.18733080769932]],
    [ "1058469125",[-84.94642556933579, 32.41521095497998]],
    [ "1058469126",[-84.95610762809949, 32.4678057868846]],
    [ "Aludyne Substation",[-84.96877984954503, 32.52977511686924]],
    [ "West Point Substation",[-85.16590766867579, 32.883442131757285]],
    [ "1058593865",[-103.05730327526068, 34.792733995267]],
    [ "1058593866",[-103.48529469897134, 33.90761530816605]],
    [ "1058593868",[-103.37216511453028, 33.90895530605493]],
    [ "1058593871",[-103.27328306939313, 33.90514281474622]],
    [ "1058593873",[-103.18949059768867, 33.8785316263845]],
    [ "1058593875",[-103.18127906372136, 33.98250772097281]],
    [ "1058631070",[-97.68334464241487, 37.25605692072982]],
    [ "Conway Springs Substation",[-97.66045670000001, 37.4009631]],
    [ "Viola Substation",[-97.67665059784467, 37.33118145746501]],
    [ "BP Wind Energy;Sempra U.S. Gas & Power",[-98.13186623601379, 37.37504575028198]],
    [ "BP Wind Energy;Sempra U.S. Gas & Power",[-98.33063135059426, 37.36843695692717]],
    [ "1058641733",[-80.37993946190025, 25.65740587061632]],
    [ "Tyus Substation",[-85.20230102621565, 33.46917621610643]],
    [ "Bowdon Substation",[-85.25062969999998, 33.53679885]],
    [ "Sewell Creek Energy Substation",[-85.27690607488998, 33.94877801943878]],
    [ "1058657279",[-85.26408796832841, 33.94189924424791]],
    [ "1058657280",[-85.2637444631027, 33.94145897600356]],
    [ "1058657281",[-85.22599445000002, 33.884189799999994]],
    [ "Mountain Electric Cooperative",[-81.80337917748398, 36.43628539452831]],
    [ "Mountain City Substation",[-81.8061314540041, 36.46888897544762]],
    [ "Sherwood Substation",[-94.77439090308404, 42.3399960082002]],
    [ "1058789637",[-106.63651869035947, 35.13757987247554]],
    [ "1058948785",[-81.95021674128031, 33.275047377458584]],
    [ "1058948790",[-81.99213435, 33.391891650000005]],
    [ "1058948791",[-81.99447172170646, 33.46661856491914]],
    [ "1058948795",[-82.11693359640434, 33.567665467082925]],
    [ "1058953576",[-84.2793752368037, 33.215589179209076]],
    [ "1058953583",[-84.2826729, 33.23525625]],
    [ "Bandhead Substation",[-88.93658838377311, 34.26103940112919]],
    [ "Osborn Wind Energy",[-94.49140058100267, 39.84243688310171]],
    [ "1059099062",[-99.06002947573054, 32.33647360320252]],
    [ "1059099064",[-99.16396425920557, 32.30703617492909]],
    [ "Santa Teresa Substation",[-121.79074894495383, 37.238615468460566]],
    [ "1059238277",[-84.36192178119954, 33.60724807482361]],
    [ "1059249713",[-84.4884739477203, 33.65019456320804]],
    [ "Georgia World Congress Substation",[-84.40031486722657, 33.76329559245228]],
    [ "1059249718",[-84.40719689536508, 33.772448108332505]],
    [ "Center Hill Substation",[-84.47398008750447, 33.77870411092455]],
    [ "1059255859",[-84.47835334999999, 33.80229605]],
    [ "Shawnee",[-84.8790037309036, 39.84061753623524]],
    [ "PPL Pipeline Substation",[-84.67419551418614, 33.75944951928571]],
    [ "Vulcan Materials Substation",[-84.66877123955551, 33.772806175610086]],
    [ "Nebo Substation",[-84.83089387831332, 33.83948977513336]],
    [ "1059340450",[-84.43194669147474, 33.911918976011364]],
    [ "Henley",[-84.86113459999997, 39.8225389]],
    [ "1059403255",[-103.16213111678043, 47.3422162683999]],
    [ "1059408823",[-92.59421424311641, 37.96834063624588]],
    [ "1059430523",[-97.47664074999999, 36.401449649999996]],
    [ "1059430526",[-98.42882151230603, 35.479595093254474]],
    [ "1059430528",[-98.27334040510556, 35.42236832660209]],
    [ "1059430530",[-98.13552865, 35.37118155]],
    [ "1059430534",[-98.09300164200678, 35.34991222515822]],
    [ "Blissfield Substation",[-83.86370215000001, 41.82326725]],
    [ "1059438605",[-118.22301765624181, 33.76224626881703]],
    [ "1059442157",[-118.86756317431647, 46.64809122239456]],
    [ "Cartersville Wastewater Treatment Substation",[-84.83058770825504, 34.14119971013655]],
    [ "Colonial Pipeline Substation",[-84.27102845000002, 33.9151142]],
    [ "1059513763",[-84.24748445, 33.91070295]],
    [ "1059513764",[-84.24749260000002, 33.91114155]],
    [ "1059513778",[-84.17629336765356, 33.972095698169944]],
    [ "1059513780",[-84.16921218195618, 33.97662180435166]],
    [ "SA Recycling Substation",[-84.25339388649104, 33.92299193890838]],
    [ "1059613101",[-83.6742036, 34.066910250000014]],
    [ "1059613108",[-84.13173050510473, 34.198886369583995]],
    [ "1059613110",[-84.07425947060688, 34.120376322090905]],
    [ "Oneal Road",[-89.04381915378883, 30.472060968276214]],
    [ "1059629235",[-85.2055018637515, 34.39980583111876]],
    [ "1059629239",[-85.1832450545311, 34.39842810719842]],
    [ "Colonial Pipeline Substation",[-85.13201575000001, 34.38014005]],
    [ "1059646797",[-106.81533527976222, 35.084108105917686]],
    [ "Trenton Substation",[-85.51215713352175, 34.866977514633646]],
    [ "Morganville Substation",[-85.44343792089634, 34.942814901179254]],
    [ "Hudson Wire Substation",[-85.50148564999999, 34.883007]],
    [ "Bull Moose Tube Substation",[-85.50081710000002, 34.8810236]],
    [ "1059715244",[-92.8454905803893, 37.9353937156048]],
    [ "1059932981",[-117.33467147091547, 34.20583323480461]],
    [ "Kensigton Substation",[-85.323656270491, 34.81685975518477]],
    [ "TVA",[-85.28202942259395, 34.970671306407006]],
    [ "TVA",[-85.2898871012029, 34.983139026023196]],
    [ "TVA",[-85.30948086837688, 34.96104370269775]],
    [ "TVA",[-85.32827589088319, 34.98781536832039]],
    [ "TVA",[-85.32800903851695, 35.00261337134143]],
    [ "TVA",[-85.35137820000001, 34.98875920000001]],
    [ "Covenant College Substation",[-85.37755310000001, 34.9617516]],
    [ "Flintstone Substation",[-85.34954483379593, 34.94068336713689]],
    [ "Electric Power Board of Chattanooga",[-85.3170155056588, 35.000259781289486]],
    [ "TVA",[-85.31577885497475, 35.003852080469656]],
    [ "TVA",[-85.31563950000002, 35.02476755]],
    [ "1059977770",[-86.02126775244581, 39.948554832358305]],
    [ "Electra Substation",[-120.66974582626004, 38.331564455018366]],
    [ "Nelson Substation",[-84.37035667015896, 34.382936793006834]],
    [ "Polycor Marble Substation",[-84.36757324999999, 34.411458200000006]],
    [ "1059984095",[-84.34975014548964, 34.432547667023414]],
    [ "1059984096",[-84.33998648335245, 34.43248549483795]],
    [ "1059984103",[-84.07101985640446, 34.53499921651283]],
    [ "Cane Creek Substation",[-84.0034902496477, 34.57188247286713]],
    [ "1059986475",[-84.4199096, 34.467689650000004]],
    [ "1059986485",[-84.52970705954189, 34.53246261757084]],
    [ "1059986487",[-84.39042345954162, 34.643813787500775]],
    [ "Quill Substation",[-84.3899667663286, 34.64359389578564]],
    [ "1059986491",[-84.60341593110772, 34.68695640718396]],
    [ "1059986497",[-84.56438875944347, 34.59215807941055]],
    [ "1059989260",[-87.53333803332993, 32.770671300761634]],
    [ "Murrayville Substation",[-83.89807093098408, 34.412113554880435]],
    [ "1060027916",[-83.85214918442092, 34.43499897452088]],
    [ "1060027919",[-83.91034040001472, 34.52439986634384]],
    [ "1060027923",[-83.99643295, 34.535114750000005]],
    [ "1060027928",[-83.84201987533368, 34.57403500792259]],
    [ "Cleveland Substation",[-83.7730904, 34.5913209]],
    [ "1060027938",[-83.64309303352798, 34.44519010116331]],
    [ "1060027939",[-83.5765443180852, 34.46055435415468]],
    [ "1060040769",[-83.69906828088506, 34.58744059717105]],
    [ "1060040771",[-83.65244677415198, 34.56528415409322]],
    [ "1060040777",[-83.71647504102711, 34.66426736165768]],
    [ "1060040780",[-83.68844961448573, 34.70222552934929]],
    [ "1060040784",[-83.43446655245663, 34.70002236635645]],
    [ "1060045983",[-83.31253388724821, 34.54391436078034]],
    [ "1060045984",[-83.31186946562224, 34.54360665812883]],
    [ "1060045986",[-83.29075425311402, 34.560189916725186]],
    [ "1060045987",[-83.29764636203413, 34.58573464010079]],
    [ "1060045989",[-83.22234419570547, 34.585767181751876]],
    [ "1060050635",[-79.2907754, 42.47322155]],
    [ "1060050646",[-79.34058720000002, 42.4694539]],
    [ "1060050651",[-79.34511289262888, 42.45831580084614]],
    [ "1060119578",[-103.7714468927889, 48.14886887388894]],
    [ "Lemon Cove Substation",[-119.02635462104988, 36.3867383231714]],
    [ "Canon Subsstation",[-83.10667450000001, 34.344563650000005]],
    [ "1060196948",[-82.94534039999999, 34.35265060000001]],
    [ "1060196954",[-82.944624, 34.331759250000005]],
    [ "Nestle Purina Substation",[-82.95443245820516, 34.34019675900796]],
    [ "1060196963",[-82.82112977497027, 34.34980844251541]],
    [ "1060196965",[-82.94157715000001, 34.35760005]],
    [ "1060196970",[-83.09338815546319, 34.398962937281084]],
    [ "1060196972",[-83.1393950886883, 34.43035415027619]],
    [ "1060196981",[-83.16579356873224, 34.507397309385084]],
    [ "1060196985",[-83.2198437, 34.50786159999999]],
    [ "1060200276",[-82.95173146259795, 34.406125519675214]],
    [ "1060204161",[-83.48783155631159, 34.601247240074606]],
    [ "1060204172",[-83.53494646674926, 34.60017155048974]],
    [ "1060204173",[-83.5342043329833, 34.60020354919696]],
    [ "1060204177",[-83.52518968082771, 34.59820163132149]],
    [ "1060204178",[-83.51869357492716, 34.619259408509826]],
    [ "1060204179",[-83.53111798059315, 34.62220410533198]],
    [ "Hollywood Switching Station",[-83.45464385255082, 34.64686221766312]],
    [ "Tugalo Dam Substation",[-83.35198175, 34.71360755]],
    [ "Yonah Dam Substation",[-83.3429237, 34.681115999999996]],
    [ "1060258398",[-99.03903635667831, 26.648925867620306]],
    [ "1060258400",[-97.64591374167617, 27.592019651860312]],
    [ "1060258402",[-97.64229744999999, 26.941485600000004]],
    [ "1060258403",[-95.88801000951585, 28.85504177033447]],
    [ "1060258409",[-97.4961961645111, 26.28823878003896]],
    [ "Ann Street Substation",[-88.2777933112725, 44.26046113723667]],
    [ "Terrora Substation",[-83.40584735424669, 34.75055730656932]],
    [ "1060286427",[-83.5046259, 34.85959685]],
    [ "1060286444",[-83.37416360572139, 34.959651076045404]],
    [ "1060286445",[-83.374773, 34.95757035]],
    [ "1060286447",[-83.41172059681516, 34.8470500679055]],
    [ "Nacoochee Substation",[-83.50101930000001, 34.7555186]],
    [ "Burton Substation",[-83.54061515000001, 34.7932637]],
    [ "Burton Switching Station",[-83.53554348930179, 34.79279992811576]],
    [ "Habersham Dam",[-83.5573300702367, 34.58982804206413]],
    [ "Democrest Substation",[-83.55017309065211, 34.555296020193936]],
    [ "1060323697",[-100.58511258139285, 36.551647514122955]],
    [ "1060323704",[-100.57466796174657, 36.50864419834087]],
    [ "1060323706",[-100.66764509032883, 36.55785779330859]],
    [ "Camp Clark Substation",[-94.2737795703908, 37.780094643487594]],
    [ "1060364767",[-98.52124772124398, 33.53889562142482]],
    [ "1060364769",[-98.56451936645907, 33.5096440751596]],
    [ "1060364771",[-99.5923191233506, 33.370014806142215]],
    [ "1060364773",[-99.62465242509555, 33.344121255664746]],
    [ "1060364775",[-99.51532892952555, 34.20778290326633]],
    [ "Duke Energy",[-81.67613454233248, 35.135226291765925]],
    [ "1060510770",[-99.06534383080027, 46.112767839864475]],
    [ "1060510771",[-99.06520528813124, 46.11161292469851]],
    [ "1060510773",[-102.76625001310742, 48.76867696283713]],
    [ "Cimarron Electric Coop",[-98.31098682110836, 35.69709105807586]],
    [ "1060565159",[-83.9621836292627, 34.87950982926647]],
    [ "1060565167",[-83.80981735226763, 34.96904895512699]],
    [ "Hiwassee Substation",[-83.73938140399666, 34.936917167243706]],
    [ "Chatuge Dam Substation",[-83.79143288231879, 35.01900041581386]],
    [ "Nottely Dam Substation",[-84.08762038864288, 34.95917826601651]],
    [ "1060565193",[-84.1305992442679, 35.02658210327713]],
    [ "Chehaw Substation",[-84.0506935270702, 31.705262054110065]],
    [ "Chehaw Switching Station",[-84.05071256092916, 31.704898023320045]],
    [ "Rainey Street Substation",[-97.73796880105162, 30.256824004547546]],
    [ "Covington Electric System",[-89.63976365103987, 35.57215743368614]],
    [ "1060905437",[-97.56386037945731, 35.509582003204386]],
    [ "1060909773",[-85.92631614826661, 38.29502984539372]],
    [ "1060909782",[-85.81388919999999, 38.2850053]],
    [ "1060913794",[-100.57509018428415, 31.792909720853437]],
    [ "1060913797",[-100.71868257456316, 31.83189035425731]],
    [ "1060913800",[-99.89129532650001, 31.446950553356288]],
    [ "1060913802",[-99.88810773349537, 31.444045966828956]],
    [ "1060913805",[-99.86908749999998, 31.260585099999997]],
    [ "1060913809",[-99.7907321, 31.25268035]],
    [ "1060913813",[-100.62235169284573, 31.048869051740038]],
    [ "Georgia Power",[-85.27837962619343, 33.72964706019749]],
    [ "Georgia Power",[-85.27602830586125, 33.736670167401165]],
    [ "Georgia Power",[-85.2815408286869, 33.736499457056915]],
    [ "1061073284",[-85.29739115000002, 33.7411597]],
    [ "1061093454",[-86.30594404122157, 32.3838442557956]],
    [ "New Ellenton Substation",[-81.70114479979279, 33.39975526771445]],
    [ "1061221159",[-92.49719818337154, 40.30966045857652]],
    [ "1061221161",[-92.50736163172908, 40.42438044883731]],
    [ "1061237593",[-105.36588198499159, 42.96912442494139]],
    [ "1061237595",[-105.4726304148761, 43.0198038953905]],
    [ "1061240080",[-94.17971044104651, 37.68750864207343]],
    [ "1061240479",[-90.54398625489144, 38.681308706390475]],
    [ "Arizona Public Service",[-112.33425800325539, 33.5627102337465]],
    [ "Florida Power & Light",[-81.45325830373395, 30.577427807840476]],
    [ "Fernandina Beach Substation",[-81.5182385523825, 30.609870624039218]],
    [ "1061371624",[-81.63781869430983, 30.37979412401335]],
    [ "1061422985",[-81.67920694951312, 39.585389853556556]],
    [ "Wallingford Substation",[-72.83532895392675, 41.44739235985275]],
    [ "1061535071",[-111.88536992051563, 32.51198798628676]],
    [ "1061535074",[-111.89999651635948, 32.52014134259716]],
    [ "1061535075",[-111.91011080895922, 32.52612085143913]],
    [ "1061535081",[-111.88899960729346, 32.50942228106731]],
    [ "Freeborn Switching Substation",[-93.1884572, 43.510733900000005]],
    [ "1061548187",[-95.85341494097398, 43.789468774176235]],
    [ "1061548188",[-95.85534673582326, 43.78962706753113]],
    [ "1061555018",[-94.32260697368214, 37.49358838665141]],
    [ "1061555019",[-94.32168763065793, 37.49385760878751]],
    [ "Hudson Substation",[-94.70910763043214, 37.38727601378059]],
    [ "1061730413",[-81.41362145068432, 30.389203333436225]],
    [ "Jacksonville Electric Authority",[-81.69440137524647, 30.319085761918956]],
    [ "Reading Wind Substation",[-96.03681226121684, 38.48307713194177]],
    [ "1061825718",[-90.23443980779881, 42.69206862165231]],
    [ "1061825719",[-90.2332100185859, 42.69182316635938]],
    [ "1061886223",[-116.91041004765158, 39.58587484834616]],
    [ "1061901998",[-103.76487084934523, 48.11450664942261]],
    [ "1061902040",[-103.77370140020535, 48.14875359966022]],
    [ "1061930503",[-118.38846270746139, 35.06610085913437]],
    [ "1061930510",[-118.25069912731809, 35.06324214008402]],
    [ "1061930512",[-118.27571844416802, 35.04975756457634]],
    [ "McDowell Substation",[-80.14829145048513, 41.18795472958356]],
    [ "King Farm Substation",[-79.56790353725209, 40.17197264698641]],
    [ "Weston Substation",[-94.90013815076559, 39.427974707334926]],
    [ "ACEC Calamus",[-88.99644875579327, 43.42230180095256]],
    [ "Fountain Prairie",[-89.03754025, 43.37700375]],
    [ "1062226606",[-89.03513498886505, 43.34527558385412]],
    [ "Columbus South",[-89.02469494917484, 43.31638645650951]],
    [ "1062307499",[-88.85720484945425, 43.42900861184059]],
    [ "1062322801",[-81.32983627055826, 39.809194529878305]],
    [ "1062322825",[-81.29104569201043, 39.77150575895289]],
    [ "1062322828",[-81.30421832591071, 39.813294304775596]],
    [ "Pope Lane Substation",[-94.58272801124592, 39.40681531469036]],
    [ "Soldier Creek Wind Substation",[-96.00571285433072, 39.622652715239624]],
    [ "Pritchardville Substation",[-80.96122173535846, 32.2385531917216]],
    [ "1062495969",[-81.02404468620622, 32.172195468872]],
    [ "1062495975",[-80.98577442498612, 32.5274317314002]],
    [ "1062495979",[-81.00685065796688, 32.7042621386396]],
    [ "Highbanks Substation",[-81.32454978770197, 28.91309984653068]],
    [ "1062560779",[-81.32545042483144, 28.91325149365893]],
    [ "1062564183",[-96.63300425968352, 33.30543884275694]],
    [ "1062628766",[-94.33703259194202, 37.31633644421695]],
    [ "Duke Energy",[-80.8026484413783, 34.91415558445109]],
    [ "1063064066",[-88.70893942966752, 43.396667711948915]],
    [ "1063125729",[-112.44284753407646, 33.491162477837804]],
    [ "1063395512",[-84.4887890946873, 38.04279940704336]],
    [ "Sanford Substation",[-84.73417984285622, 35.325410555814116]],
    [ "Osawatomie Power Station",[-94.9022344849479, 38.53207401656225]],
    [ "1063443350",[-114.96998623991935, 35.778042024755656]],
    [ "Ponderosa Substation",[-92.58585605787354, 41.57001602512592]],
    [ "SE Magazine Road Substation",[-93.54247382987955, 41.71671999420184]],
    [ "Center St",[-88.83937664999999, 43.45037584999999]],
    [ "1063611677",[-80.73455872924212, 32.17585685890722]],
    [ "Fox Lake",[-88.90596847836517, 43.54623086838319]],
    [ "Dakota Substation",[-95.12536227753566, 37.97847783181416]],
    [ "Prairie Queen Wind Farm",[-95.22449406137666, 37.976495245907984]],
    [ "Jayhawk Switching Station",[-94.98972946573289, 37.70459836245744]],
    [ "Edwardsville Substation",[-94.80599524561912, 39.05877400760054]],
    [ "1063833285",[-80.73687876710714, 32.238042352438804]],
    [ "Tillman Substation",[-81.10053832175615, 32.44285884294025]],
    [ "1064022697",[-81.03264370733271, 32.333766965071064]],
    [ "Cherry Point Wastewater Treatment Substation",[-80.8705011855456, 32.36549573751852]],
    [ "1064022707",[-80.8865405092864, 32.51720787195403]],
    [ "Nixville Substation",[-81.15073848266637, 32.7429796980769]],
    [ "1064022713",[-81.12944718737144, 32.68250261081022]],
    [ "Substation #1",[-94.8985137251106, 38.81264027271011]],
    [ "Moonlight Substation",[-94.90984469023543, 38.81024473022071]],
    [ "Fountain Substation",[-85.18321938018632, 42.315279162271516]],
    [ "Armourdale Substation",[-94.61894312291686, 39.08635617473343]],
    [ "Gibbs Substation",[-94.69660162943681, 39.06012479550333]],
    [ "Rosedale Substation",[-94.6179971720352, 39.059502692154176]],
    [ "Speaker Substation",[-94.68225705550323, 39.094589800073486]],
    [ "Morris Substation",[-94.75313506601164, 39.05495755812929]],
    [ "Victory West Substation",[-94.76843882544316, 39.13524599508705]],
    [ "1064274409",[-80.75997357740894, 32.602831124501066]],
    [ "Marine Corps Beaufort Substation",[-80.71832646886143, 32.4626701561056]],
    [ "Burton Central Substation",[-80.71925550927547, 32.43837042658096]],
    [ "1064274440",[-80.73838792524892, 32.38996404625836]],
    [ "1064274448",[-80.69661589910149, 32.352086866983335]],
    [ "1064313561",[-82.53588952982602, 35.052400754476324]],
    [ "Goodale Substation",[-85.18394235000002, 42.34163085]],
    [ "Mercer Substation",[-80.24223372797806, 41.23642126423153]],
    [ "Moore St",[-89.7593302726757, 43.461703124860406]],
    [ "Island",[-89.7575221734282, 43.473804641155404]],
    [ "1064477774",[-89.7819526, 43.4582231]],
    [ "Fox Hills",[-89.76485154480193, 43.529659720829166]],
    [ "Rock Springs",[-89.90593727918889, 43.486307287102925]],
    [ "1064477791",[-89.99376113796829, 43.52378672659323]],
    [ "1064477795",[-89.99672474155065, 43.525930666438356]],
    [ "1064477798",[-89.99873277023138, 43.52612897432136]],
    [ "Loganville",[-90.03938274771367, 43.43514443557894]],
    [ "1064496433",[-111.92812105, 33.367766950000004]],
    [ "1064501860",[-84.94802227814964, 30.430322994315194]],
    [ "1064534036",[-89.98719297512598, 43.54679175999551]],
    [ "1064534038",[-89.97046725, 43.563092181455616]],
    [ "1064534045",[-89.81731308682373, 43.58880291585764]],
    [ "1064534046",[-89.79712467347072, 43.59107465781082]],
    [ "1064569758",[-89.79560096972052, 43.626397662126294]],
    [ "Lakehead Vesper",[-89.96170229367323, 44.422827926931674]],
    [ "47th Avenue Substation",[-88.72581057257669, 32.362989111871116]],
    [ "1064708986",[-82.66708431375503, 28.967670718989556]],
    [ "1064736941",[-84.99333955, 36.76822655]],
    [ "1064736944",[-84.98573225, 36.78199455]],
    [ "Huntsville Substation",[-84.51800270324794, 36.413759454193745]],
    [ "1064802530",[-80.691907260139, 32.42988605122133]],
    [ "Port Royal Substation",[-80.68587301432586, 32.397057474930854]],
    [ "1064802535",[-80.6811929, 32.3926829]],
    [ "1064802536",[-80.68027787542364, 32.392842453617895]],
    [ "1064802538",[-80.66663424999999, 32.3933901]],
    [ "South Carolina Electric & Gas",[-80.64551502280362, 32.40527234330423]],
    [ "Frogmore Substation",[-80.57111369601844, 32.399132022280725]],
    [ "South Carolina Electric & Gas",[-80.49557664849712, 32.41267361721506]],
    [ "South Carolina Electric & Gas",[-80.64020929999998, 32.446468100000004]],
    [ "Jamestown Substation",[-84.93515646688918, 36.404676192290275]],
    [ "1064892469",[-104.20401193609034, 48.17526794453743]],
    [ "Jennings Substation",[-83.08224888356355, 30.614982793953175]],
    [ "1064895571",[-82.78221830000003, 30.439691100000005]],
    [ "Nutrien",[-82.7872202, 30.442918699999996]],
    [ "1064895573",[-82.7875464745357, 30.4417209388833]],
    [ "1064895576",[-82.77967165729211, 30.4392709211536]],
    [ "1064895613",[-83.13195347496496, 30.319469485683673]],
    [ "Echo River Solar Sobstation",[-82.85621387539365, 30.292789039190303]],
    [ "Raven Substation",[-82.56928595866427, 30.159111053585995]],
    [ "1064941322",[-88.7415884936433, 32.4470171490464]],
    [ "1064949507",[-81.1755513661823, 32.887973670031165]],
    [ "1064949509",[-81.29178722478042, 32.950370422055876]],
    [ "Allendale Biomass Substation",[-81.28379460895444, 33.00038763220162]],
    [ "1064949532",[-80.87936369347122, 32.99322552897153]],
    [ "1064949533",[-80.88141581777907, 32.993141610474396]],
    [ "1064949535",[-80.9212509616723, 32.908495278868116]],
    [ "1064949540",[-80.81266938145123, 32.89094664735127]],
    [ "1064949543",[-80.5514752121816, 32.82056051049682]],
    [ "South Walterboro Substation",[-80.66212272000935, 32.8904006449603]],
    [ "1065036699",[-80.1545394, 32.7824874]],
    [ "1065036716",[-80.10439323433648, 32.776268676294016]],
    [ "Legareville Substation",[-80.07166559047988, 32.65104087614481]],
    [ "1065036722",[-80.15037623907503, 32.61252958667176]],
    [ "Ada Substation",[-83.88027466107405, 40.768605795322436]],
    [ "La Pointe",[-91.13691422213893, 43.027955244875876]],
    [ "1065327981",[-90.8955299, 43.34276135]],
    [ "1065327987",[-91.22715325714057, 43.55456842385974]],
    [ "1065327994",[-91.18735715000001, 43.811410550000005]],
    [ "Ingalls Substation",[-83.7371099524061, 42.28353712340048]],
    [ "1065368190",[-91.30636215, 44.006283599999996]],
    [ "1065368203",[-91.60813999522273, 44.04161686902328]],
    [ "1065416764",[-80.06079716685576, 32.81073260237055]],
    [ "Hagood Substation",[-79.96220223396507, 32.82685112974164]],
    [ "Hugh K. Leatherman Terminal Substation",[-79.9469778713618, 32.84234645554443]],
    [ "1065459658",[-79.9763341930777, 32.862026780428494]],
    [ "1065459660",[-79.95711085, 32.8542864]],
    [ "1065541567",[-79.8386018839507, 32.8520684163382]],
    [ "1065541584",[-79.75221218513592, 32.88157621525079]],
    [ "1065541605",[-79.85336763066107, 33.00543559521113]],
    [ "1065541637",[-79.9338132248709, 33.02259929263942]],
    [ "1065541644",[-79.929725349127, 32.99918360226402]],
    [ "Nexans High Voltage Cable Substation",[-79.92640405, 32.99409155]],
    [ "Port Park Substation",[-80.00235343609275, 32.903841312456564]],
    [ "FIXME Substation",[-94.71531139082259, 37.44841562732186]],
    [ "Air Liquide Substation",[-79.87583035719999, 33.00534243251852]],
    [ "Williams Gas Turbine Substation",[-79.93045305000001, 33.014920599999996]],
    [ "Nucor Steel Foundry Switching",[-79.88104134300256, 33.005938648671545]],
    [ "Nucor Steel Foundry Switching",[-79.88066081968151, 33.00676725341635]],
    [ "Nucor Steel Foundry Switching",[-79.8812787, 33.0069319]],
    [ "Nucor Steel Foundry Switching",[-79.88628505, 33.002902950000006]],
    [ "1065747004",[-90.97980289618113, 43.891621124985676]],
    [ "1065840509",[-90.91224969618916, 44.59599322753045]],
    [ "1065873896",[-80.30294267625284, 33.082715621985464]],
    [ "1065873899",[-80.34488321848579, 33.08948263915621]],
    [ "1065873900",[-80.34406256867234, 33.09079234011491]],
    [ "1065873913",[-80.38500783475142, 33.066699607029555]],
    [ "1065873919",[-80.65939426244354, 32.997648077726765]],
    [ "1065873925",[-80.32052379928557, 33.1257195779914]],
    [ "1065873936",[-80.13612721552823, 33.07389026353413]],
    [ "1065883443",[-81.03423760190265, 32.88755388315013]],
    [ "1065883446",[-80.62679370596942, 33.153938922906484]],
    [ "1065939222",[-81.12873567787875, 32.884952136975095]],
    [ "1065939228",[-81.11726434279593, 32.87330825182884]],
    [ "1065939229",[-81.08054183543526, 32.843852931563106]],
    [ "Estill Solar Substation",[-81.24522930325402, 32.76522033966495]],
    [ "Estill Substation",[-81.24067973973794, 32.75754595864088]],
    [ "Brunson Substation",[-81.19252039999999, 32.9273062]],
    [ "1065939241",[-81.28054236690366, 32.98536980105063]],
    [ "Virginia Electric and Power Company",[-77.47174555351474, 38.211751739165265]],
    [ "1065976436",[-109.889207331974, 32.054612934995475]],
    [ "1065987956",[-81.29075233126275, 39.7735033579277]],
    [ "1065987963",[-81.2859542704108, 39.76899670826616]],
    [ "Contrail Wind Farm",[-94.93659795535677, 40.57984780105573]],
    [ "Contrail Wind Farm",[-94.93777287910243, 40.5798969954964]],
    [ "Lily Solar Substation",[-81.43171606415316, 33.093287933532935]],
    [ "1066252229",[-103.66781089997399, 48.19834607467957]],
    [ "1066252231",[-103.63303271635874, 48.22599865697881]],
    [ "1066503385",[-103.57738355900864, 48.22609650314941]],
    [ "1066545023",[-81.54146402304215, 39.71385119652522]],
    [ "1066568687",[-103.55574299961822, 48.28605202514935]],
    [ "1066568689",[-103.60293551794982, 48.28881412649642]],
    [ "1066578880",[-84.9370088250835, 39.73363625625215]],
    [ "Wild Plains Substation",[-97.2151763040026, 37.28386997323677]],
    [ "1066582313",[-80.76352638934581, 34.621441318013375]],
    [ "1066582314",[-80.76281216330298, 34.621465778824394]],
    [ "1066636216",[-82.27998849923685, 33.87682112262441]],
    [ "City of Minden",[-93.27347157290818, 32.63236938282993]],
    [ "Mascot Substation",[-119.59289186728763, 36.341904373848145]],
    [ "Ameren",[-90.6503608510917, 40.906799385958784]],
    [ "1066747143",[-81.12833150157068, 39.931643146503546]],
    [ "1066754658",[-91.00947375000001, 40.71701740000001]],
    [ "1066754659",[-91.08063059999999, 40.67779885]],
    [ "1066757882",[-81.12537704163066, 40.00518670527202]],
    [ "1066790765",[-103.36090621239423, 48.08309882490644]],
    [ "1066790768",[-103.38388239385263, 48.153783394058465]],
    [ "1066832613",[-81.49120937066066, 39.67315245331186]],
    [ "1066835009",[-86.14551708725504, 40.03185251713197]],
    [ "1066835690",[-89.36024595606602, 40.78872734418206]],
    [ "1066835697",[-89.4847734836383, 40.694169980292365]],
    [ "SK Battery Substation",[-83.48015489504344, 34.23924563900271]],
    [ "1066858910",[-83.44591035370034, 34.24849390606226]],
    [ "1066862544",[-82.37248578370529, 33.869101744233504]],
    [ "Collinsville Substation",[-88.84522619407264, 32.5000044460855]],
    [ "1066891177",[-81.72101040000001, 28.493073350000003]],
    [ "1066955062",[-104.51366608196675, 48.76500248404412]],
    [ "1066972404",[-109.94133201577702, 34.14528515384609]],
    [ "1066989406",[-84.35854689300837, 37.35157918285096]],
    [ "1066994360",[-89.98463187509114, 40.4641602266186]],
    [ "Commonwealth Edison",[-89.60578000997825, 40.524028078471936]],
    [ "1066999619",[-89.60656245272476, 39.99164180307172]],
    [ "1067011041",[-103.32388753724423, 48.28566103232323]],
    [ "1067038224",[-94.79095483330305, 40.28770603550922]],
    [ "San Francisco Public Utilities Commission",[-122.3904877007366, 37.74477732226685]],
    [ "1067435265",[-84.04450069728914, 30.54359286918208]],
    [ "1067435266",[-84.04473882514424, 30.543185906398374]],
    [ "1067443682",[-91.47076959537497, 38.68903214999469]],
    [ "1067443683",[-91.43901890000001, 38.70158055]],
    [ "1067443687",[-91.37464209999997, 38.66954485]],
    [ "1067606975",[-85.30073249392848, 37.09048502269504]],
    [ "New Lisbon",[-90.17526249999999, 43.881090799999996]],
    [ "Lewisburg Board of Public Utilities",[-86.8338294075201, 35.45441680908346]],
    [ "Saluda Retail Substation",[-82.34747879999999, 35.2480519]],
    [ "1067805317",[-81.97370338136743, 26.623471363938602]],
    [ "1067810754",[-82.5124773, 35.25222055]],
    [ "1068033379",[-110.99630617503976, 32.32171218805369]],
    [ "1068044302",[-110.88735928847063, 32.06417775881655]],
    [ "Devalls Bluff Substation",[-91.46715314174389, 34.79364842385546]],
    [ "Badrock",[-114.15997361463093, 48.350553021204725]],
    [ "Hungry Horse",[-114.06458657774776, 48.386504416625]],
    [ "San Antonito Sub",[-106.35022609167527, 35.16397917478106]],
    [ "1068096904",[-88.67509489235117, 32.47680728357317]],
    [ "1068341503",[-81.7752392579513, 33.44654448347661]],
    [ "A Street Substation",[-88.69809045944444, 32.360216605135015]],
    [ "Silicon Ranch Corporation",[-88.58432871481081, 32.45374885941172]],
    [ "Towanda Substation",[-76.44183519578826, 41.763050862098694]],
    [ "Crossroads Substation",[-89.74370189196921, 30.793365969770388]],
    [ "Collins Pipeline Company",[-89.74158264999998, 30.793818849999994]],
    [ "1068686684",[-84.34252815251318, 30.51204413027528]],
    [ "1068689213",[-84.42115142728248, 30.65094265636519]],
    [ "1068690960",[-84.58142570643405, 30.58044818806081]],
    [ "1068690970",[-84.52598520000002, 30.60852685]],
    [ "1068775849",[-87.37949891646574, 40.620695975055355]],
    [ "Oak Grove Substation",[-119.36713227996594, 36.341562452726734]],
    [ "Newport Utilities",[-83.1610039383093, 35.956659141690565]],
    [ "Nucor Substation",[-93.21950535494477, 38.73093926663028]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.7077507007912, 37.678196884901425]],
    [ "1069174854",[-106.54104956500206, 35.06277677472007]],
    [ "1069174856",[-106.53564370000001, 35.05629535]],
    [ "1069214294",[-81.14004886407518, 33.335666680287396]],
    [ "L Reactor Substation",[-81.62485095308271, 33.21038816188188]],
    [ "C Reactor Substation #2",[-81.67369783317189, 33.248385503857335]],
    [ "1069435565",[-86.42068850734432, 39.482302806790706]],
    [ "1069446543",[-84.03867722991814, 36.050834649850145]],
    [ "1069449484",[-81.8117720751092, 27.917733956480763]],
    [ "1069475218",[-87.88530635000001, 30.6082662]],
    [ "Saint George Switching Station",[-80.59200851632343, 33.199388064660994]],
    [ "Dorchester Biomass Substation",[-80.45461974840123, 33.23958711631804]],
    [ "The Barrows Substation",[-80.06168668792618, 33.13907283250952]],
    [ "1069594372",[-79.96839523103094, 33.220413855603475]],
    [ "Tennessee Gas Pipeline Company, L.L.C.",[-85.39690101129004, 37.41734214284553]],
    [ "Georgetown City Substation",[-79.30073724424747, 33.377929177902956]],
    [ "Georgetown Switching Station",[-79.3001648297183, 33.3784658303743]],
    [ "Liberty Steelworks Substation",[-79.29174458915838, 33.368980325333496]],
    [ "1069637487",[-79.29348765, 33.3644758]],
    [ "International Paper Substation #2",[-79.29985628340917, 33.365663449163705]],
    [ "1069811306",[-81.01756386645287, 33.40578024940686]],
    [ "1069884613",[-87.89496527486172, 30.51665389173693]],
    [ "1069884707",[-87.89501837504945, 30.502252039395916]],
    [ "1069961288",[-79.56350606361606, 33.33299548085389]],
    [ "1069961292",[-79.6850362740581, 33.292333143437844]],
    [ "Russellville Substation",[-79.98975651665239, 33.40273574663391]],
    [ "Spillway Substation",[-80.16245177058788, 33.44861129502]],
    [ "1069970832",[-80.19716183828885, 33.53833978755673]],
    [ "1070098078",[-111.7295366002196, 40.060616090922025]],
    [ "1070098081",[-113.13771856186425, 37.8211881750282]],
    [ "Camden Road Substation",[-78.90272125931985, 35.02097457575742]],
    [ "1070116682",[-82.8629983764418, 34.82926463078422]],
    [ "1070116722",[-82.87386744999999, 34.825369]],
    [ "Pingree Substation",[-83.08843143616458, 42.37512227934973]],
    [ "1070460933",[-98.58965545830425, 33.8622159309379]],
    [ "1070460947",[-98.38631639410336, 35.49379477269456]],
    [ "1070460948",[-97.10832662486726, 33.94360030787224]],
    [ "1070460950",[-98.44525229999998, 35.01358374999999]],
    [ "1070460966",[-96.14502829485447, 33.495117974980516]],
    [ "1070460967",[-96.14572294874581, 33.4949614540999]],
    [ "1070460973",[-96.07538441874472, 33.40429790762194]],
    [ "1070460974",[-96.07553162974249, 33.40484431271212]],
    [ "1070460980",[-97.17951474271366, 33.54961964015137]],
    [ "1070460981",[-97.18014754854686, 33.54972089925531]],
    [ "1070463611",[-89.12308943313798, 42.98397519892577]],
    [ "Griffin Substation",[-87.89681709999998, 38.22959365]],
    [ "Bever Dam 3rd St",[-88.835088, 43.45816494999999]],
    [ "Bever Dam East",[-88.80919737470953, 43.47591899389483]],
    [ "1070623747",[-89.8482633353695, 44.39905172673715]],
    [ "Sacramento Municipal Utility District",[-121.39900785279941, 38.62758743059951]],
    [ "1070736681",[-83.17728172599182, 42.56206077550372]],
    [ "Rincon Substation",[-116.95869026990219, 33.285875757357275]],
    [ "WE Energies",[-88.11288813801724, 43.184665918131586]],
    [ "Allerton",[-87.97908071295423, 42.96318280539301]],
    [ "Balsam",[-88.27885805597231, 42.586107374938685]],
    [ "1070821496",[-89.70086632364395, 40.78330483120067]],
    [ "Georgia Power",[-83.6395071811355, 33.61121854107549]],
    [ "Brodhead South",[-89.37353892887535, 42.605031244480585]],
    [ "Brodhead Central",[-89.37346315823208, 42.61209927497113]],
    [ "Brodhead North",[-89.38042928391728, 42.6192349651648]],
    [ "Orfordville",[-89.2886156730579, 42.63262390868657]],
    [ "Cypress Substation",[-88.2748348591109, 43.88746193529882]],
    [ "1071026594",[-88.34640588935648, 43.66060875375831]],
    [ "Quarton Road Substation",[-83.22393403506045, 42.55895104909031]],
    [ "Birmingham Substation",[-83.21380904188541, 42.54395960985653]],
    [ "WE Energies",[-87.95339307449677, 43.324117543423135]],
    [ "1071111833",[-87.87066157291855, 43.3851587987474]],
    [ "1071257415",[-89.22373060680914, 42.94064933104942]],
    [ "1071257423",[-89.19914419806422, 43.0721211477996]],
    [ "1071257427",[-89.20928065, 43.10772555]],
    [ "Station 118",[-77.63397839943165, 43.059377604872445]],
    [ "1071323494",[-81.08325388264868, 33.16363765128904]],
    [ "1071323497",[-80.98252962060475, 33.218487089416975]],
    [ "1071323503",[-81.24194725000001, 33.3880611]],
    [ "1071323510",[-81.38537721724984, 33.30048487781784]],
    [ "1071323512",[-81.31924103985014, 33.25389002991105]],
    [ "1071323514",[-81.32132801263579, 33.18617058460732]],
    [ "1071323516",[-81.03854267978319, 33.29615036869511]],
    [ "1071340186",[-87.04411856079258, 37.738789775898574]],
    [ "1071378086",[-114.91245107551907, 36.42835447205266]],
    [ "1071425891",[-80.86697684880912, 34.96345401097913]],
    [ "1071426775",[-81.1308666, 33.31595535]],
    [ "1071426779",[-81.14759125, 33.3160968]],
    [ "1071426781",[-81.14714307688585, 33.30776094544075]],
    [ "1071426783",[-81.18504569999999, 33.1868059]],
    [ "1071426785",[-81.20026605000001, 33.134392649999995]],
    [ "1071426786",[-81.20147821638686, 33.10356689941679]],
    [ "1071426787",[-81.20120010079876, 33.102696116388366]],
    [ "1071426791",[-81.2018221173002, 33.10217045277303]],
    [ "Ulmer Substation",[-81.20170641436114, 33.10107495344154]],
    [ "1071426804",[-81.28388608414662, 33.35210967353105]],
    [ "1071426807",[-81.27733626007722, 33.35630507644404]],
    [ "Barnwell City Substation",[-81.36514486097282, 33.24671538149653]],
    [ "1071426813",[-81.38883631883266, 33.241684564459725]],
    [ "Orchids Paper Products Substation",[-81.38998275, 33.255487650000006]],
    [ "1071546642",[-81.18767992331459, 35.103022064937036]],
    [ "1071546643",[-81.20196746853779, 35.10682090306339]],
    [ "1071551958",[-81.0816742939425, 35.13282024004412]],
    [ "1071630306",[-89.04396346114225, 42.578927129799844]],
    [ "1071641390",[-81.41738373750883, 33.39596918331279]],
    [ "1071641392",[-81.40580293498296, 33.388214283530615]],
    [ "Springfield City Substation",[-81.27250425, 33.499912800000004]],
    [ "1071788466",[-95.81410080813608, 36.311543738850915]],
    [ "1071789924",[-95.66164550856284, 36.283121092688596]],
    [ "Boonville",[-75.35782665947286, 43.50955575411556]],
    [ "Ridgewood Substation",[-71.52317788213705, 41.8028202191138]],
    [ "Waters River Substation",[-70.92856390969656, 42.543563080813676]],
    [ "McClung Substation",[-80.71363394623684, 38.052206304533925]],
    [ "1072123532",[-80.67603890355043, 38.13052762981126]],
    [ "1072123533",[-80.9560741260966, 38.047671320791366]],
    [ "Mountain Parks Electric",[-106.33294016010672, 39.87916526147032]],
    [ "Fort Lupton Substation",[-104.77286588862587, 40.10042363256631]],
    [ "1072135245",[-102.46664129999998, 37.38782690000001]],
    [ "Vilas Substation",[-102.46690448271667, 37.389201617156104]],
    [ "Titan Solar Substation",[-104.01786152048523, 39.68727828562665]],
    [ "Liberty Substation",[-83.0487822063595, 42.46295716495999]],
    [ "Howey Substation",[-81.78063211875896, 28.7113181747849]],
    [ "Beverly Hills Substation",[-82.45208646873712, 28.925882284651582]],
    [ "1072444708",[-90.71739322038907, 29.382633556154293]],
    [ "1072544390",[-90.6760237771333, 29.569671176417582]],
    [ "1072868653",[-88.69270497695236, 34.316173391353466]],
    [ "Century Substation",[-117.30662636104077, 34.06005004334725]],
    [ "1073059477",[-80.85083285413009, 35.46677786723547]],
    [ "1073105582",[-119.63090629999999, 35.22648755]],
    [ "Tombigbee Electric Power Association",[-88.713465359286, 34.16583449920803]],
    [ "Humboldt Substation",[-76.07892302122033, 40.92317613415368]],
    [ "1073218986",[-88.70810105569849, 34.1201971067129]],
    [ "1073229402",[-85.18950135, 32.850517700000005]],
    [ "1073230921",[-121.96883842535262, 37.40139256262936]],
    [ "1073230922",[-122.28987108263618, 37.788685746934824]],
    [ "1073230924",[-120.23291768713392, 36.399158148436726]],
    [ "1073230925",[-120.23138206759056, 36.399279436537945]],
    [ "1073230926",[-119.97359654586843, 36.939758695292554]],
    [ "1073230949",[-120.31016149539678, 35.83839862813211]],
    [ "1073230957",[-120.40474757710349, 36.71328634047505]],
    [ "1073230962",[-119.90400282600483, 36.17548389062685]],
    [ "Toolebeck Substation",[-81.66934190216597, 33.53468211678329]],
    [ "1073259476",[-81.65218266912758, 33.54283270517596]],
    [ "Pickwick Electric Cooperative",[-88.24198117389444, 35.01990815794974]],
    [ "1073319507",[-84.00194568491031, 36.51475306731849]],
    [ "Beech Island Wastewater Substation",[-81.91275302186789, 33.47319468443009]],
    [ "1073388024",[-81.89046422099773, 33.4397069443281]],
    [ "1073388038",[-81.9344282774954, 33.4921551669853]],
    [ "1073388050",[-81.96023308232465, 33.49352243413338]],
    [ "1073388052",[-82.03974975000001, 33.56125180000001]],
    [ "1073391402",[-80.70186139408742, 35.39997638254717]],
    [ "1073395122",[-91.6761981215033, 38.329065617298305]],
    [ "1073426829",[-75.91691591618637, 40.99194798509319]],
    [ "1073427916",[-81.94728076098104, 33.516631486931736]],
    [ "1073427937",[-81.82478395896511, 33.57247832680405]],
    [ "1073427940",[-81.83060070129773, 33.575619081105]],
    [ "1073427943",[-81.826880570303, 33.57322797933678]],
    [ "1073427944",[-81.82728766923326, 33.57329620378908]],
    [ "1073427947",[-81.82823917825, 33.57344299466272]],
    [ "1073427948",[-81.83304414172625, 33.57631292390963]],
    [ "1073427949",[-81.83306508711301, 33.574304021420474]],
    [ "1073427950",[-81.83247977869512, 33.57419949721455]],
    [ "1073427956",[-81.83174202853836, 33.57473182095411]],
    [ "1073427958",[-81.83158280948653, 33.57405477708228]],
    [ "1073428002",[-81.82060251159558, 33.57016072700642]],
    [ "1073428021",[-81.75045096495658, 33.57628618896628]],
    [ "Oklahoma Gas & Electric",[-95.39719250407789, 35.72505664733866]],
    [ "Sacramento Municipal Utility District",[-121.37843922031246, 38.608749854669455]],
    [ "Lynch Substation",[-76.0632536609066, 39.29457100307758]],
    [ "1073556053",[-77.6782437656829, 43.11302109693483]],
    [ "1073556055",[-77.67745956722749, 43.11287025151011]],
    [ "1073556058",[-77.68432220000001, 43.1160721]],
    [ "Station 33",[-77.62944240540354, 43.12374575511999]],
    [ "Station 251",[-77.63470780689866, 43.11595786589679]],
    [ "1073597804",[-81.70935671819542, 33.52727828113726]],
    [ "1073597807",[-81.67624191767739, 33.54181865411261]],
    [ "1073597821",[-81.68962486867385, 33.552295057962105]],
    [ "1073597822",[-81.68974495, 33.552060350000005]],
    [ "1073597824",[-81.71630885, 33.568051]],
    [ "W.R. Grace & Co.",[-81.70518056695846, 33.591972101945224]],
    [ "1073597829",[-81.6953687, 33.59194445]],
    [ "Active Minerals International LLC",[-81.70343195, 33.62720209999999]],
    [ "1073597835",[-81.68531145, 33.653616150000005]],
    [ "1073597836",[-81.69353420160142, 33.65681191683734]],
    [ "1073597837",[-81.71245528147092, 33.64745624293149]],
    [ "1073597840",[-81.71589845656516, 33.654162622871205]],
    [ "1073644442",[-95.3558353277506, 35.91589119143705]],
    [ "1073692882",[-115.5358248412321, 32.9556745213943]],
    [ "1073692893",[-115.53569266211134, 33.16866592511118]],
    [ "1073692894",[-115.53713633379459, 33.16862492491169]],
    [ "1073692895",[-115.5381207, 33.16852505]],
    [ "1073692896",[-115.53704165, 33.16158545]],
    [ "City of Harrisonburg",[-78.85708394776653, 38.43971416849384]],
    [ "1073699593",[-82.19035905, 27.556799149999996]],
    [ "1073699594",[-82.05709904999999, 27.59357545]],
    [ "Karson Substation",[-81.76717727727426, 27.325122890212054]],
    [ "Gleam Substation",[-81.76675811769158, 27.324936309083398]],
    [ "Florida Power & Light",[-81.7836925442932, 27.316097395706365]],
    [ "Morrow Substation",[-80.56404512490903, 27.546445144367336]],
    [ "Finca Substation",[-80.56281218562937, 27.59012698669939]],
    [ "1073699618",[-81.10811023698331, 28.15631394198095]],
    [ "1073699621",[-81.04313955912531, 28.502610752970345]],
    [ "1073699625",[-80.78635605000001, 27.629898249999997]],
    [ "Lottsburg Substation",[-76.51358392825549, 37.96332847499773]],
    [ "1073712188",[-119.43552038334485, 39.55596393332128]],
    [ "Sacramento Municipal Utility District",[-121.37559675180378, 38.595342207792214]],
    [ "Clay Center Switching Station",[-97.10660216327447, 39.363425580280314]],
    [ "Avalon Substation",[-76.42365861775751, 37.907585925921566]],
    [ "1073915176",[-80.99980223026533, 35.29299621038759]],
    [ "1074013194",[-79.1066190693824, 34.99644689489906]],
    [ "1074065468",[-78.85422677601086, 43.04858035720824]],
    [ "1074065477",[-78.92963635378509, 43.10167033805341]],
    [ "1074065479",[-78.93062105885608, 43.10402837523149]],
    [ "1074363883",[-95.37111994789711, 35.942726280111]],
    [ "1074366045",[-79.02117756478899, 43.153010797960434]],
    [ "1074366050",[-79.02169767040805, 43.15395597220777]],
    [ "1074396168",[-81.06618345, 35.054753700000006]],
    [ "1074525591",[-85.90286372537115, 40.671669154885436]],
    [ "City of Lexington",[-80.21128121530106, 35.93874902036865]],
    [ "1074595316",[-78.37995250012665, 36.69355822496445]],
    [ "1074646433",[-95.1228672891912, 35.24530807507758]],
    [ "Holly Hill Substation",[-80.42142087649609, 33.32584976386951]],
    [ "Harmar Hill Substation",[-81.48215297111969, 39.42455849200487]],
    [ "GPC <-> SCG&E Compensator Station",[-82.15947835693886, 33.65681982670443]],
    [ "Modoc Substation",[-82.20150427978642, 33.73628840444959]],
    [ "1074904622",[-82.26680207996175, 33.83291782706948]],
    [ "1074904624",[-82.26980781759546, 33.84286529624004]],
    [ "1074904627",[-82.28174930013391, 33.8782193330397]],
    [ "Calhoun Falls Substation",[-82.58872690629849, 34.08762150988114]],
    [ "Georgia Pacific Substation #2",[-82.27664264340541, 33.88817282558811]],
    [ "Georgia Pacific Substation #1",[-82.27788117962739, 33.890039384361735]],
    [ "1074904639",[-82.2805032324323, 33.89454063414362]],
    [ "1074904641",[-82.29963928786314, 33.91295873825134]],
    [ "1074904645",[-82.3265375308488, 33.92857598380706]],
    [ "1074971702",[-96.29448784363396, 35.43131704150159]],
    [ "1074981993",[-93.36227224940984, 38.45066741407729]],
    [ "1075096625",[-95.68331563229397, 35.17355667488517]],
    [ "1075096628",[-95.84300100963158, 35.08700482957541]],
    [ "1075096629",[-95.90066348673322, 35.12419293089208]],
    [ "1075096630",[-95.90079261994826, 35.12550415725027]],
    [ "1075096633",[-95.87565816845, 35.26462621393403]],
    [ "1075179198",[-81.98918272191656, 33.58120258562733]],
    [ "1075179201",[-81.87675226959243, 33.51905076547923]],
    [ "1075179209",[-81.91359401605276, 33.6330246488564]],
    [ "1075179215",[-81.72549634535638, 33.61066521977125]],
    [ "Shaw Substation",[-81.67137060963493, 33.66483614865857]],
    [ "1075179223",[-81.60529332173995, 33.603466809205344]],
    [ "1075218607",[-95.61176585000001, 35.28661879999999]],
    [ "1075230539",[-96.28239894242923, 35.08346056568294]],
    [ "1075230543",[-96.28241092906559, 35.08048418354496]],
    [ "1075230546",[-96.29387066100095, 34.8542832253055]],
    [ "1075256161",[-81.18895596412463, 33.526552632631784]],
    [ "Rappahannock Transition Station",[-76.40834982388327, 37.63767903317074]],
    [ "1075396995",[-80.08561411504856, 34.1927199316122]],
    [ "Tucson Electric Power",[-110.8996219704699, 32.15490552579502]],
    [ "1075449149",[-110.88806681336088, 32.145315875108615]],
    [ "Golf Links Substation",[-110.85402727308222, 32.19379597776518]],
    [ "Electric Power Board of Chattanooga",[-85.11212960000002, 35.22558790000001]],
    [ "Electric Power Board of Chattanooga",[-85.11568034999999, 35.225631]],
    [ "Electric Power Board of Chattanooga",[-85.18861334999998, 35.23720500000001]],
    [ "Elloree Substation",[-80.57972448377633, 33.53238440129107]],
    [ "Leaf River Energy Center LLC",[-89.32547996145557, 31.872583391984712]],
    [ "1075535899",[-95.31696547623693, 34.583370013340044]],
    [ "1075535901",[-95.23925163556297, 34.5833067741022]],
    [ "1075535902",[-94.87735436639893, 34.32279444013679]],
    [ "1075535904",[-94.83550599315612, 34.35956133630532]],
    [ "1075548810",[-80.8848880762447, 33.4716402634725]],
    [ "1075548811",[-80.83842793816062, 33.48540208780778]],
    [ "Bull Street Substation",[-80.87022861773458, 33.49002958560546]],
    [ "1075548842",[-80.86582516626173, 33.48208995176221]],
    [ "1075548845",[-80.84917012737752, 33.48074871493835]],
    [ "Berry Street Substation",[-80.86793463180565, 33.50357355798767]],
    [ "1075548852",[-80.8430744267237, 33.52375609978672]],
    [ "Claflin University Substation",[-80.85153286670963, 33.49931529815598]],
    [ "Bay Street Substation",[-72.0139444528821, 44.41692621502977]],
    [ "Southwest Arkansas Electric Cooperative",[-94.38395405963684, 33.99815236272093]],
    [ "Entergy Arkansas",[-93.4437294, 34.21759905]],
    [ "1075610640",[-93.40389431666073, 34.242977796142604]],
    [ "Entergy Arkansas",[-93.68615457573478, 34.49596304476428]],
    [ "Bismarck Substation",[-93.16872405911825, 34.31404382162867]],
    [ "Cricket Valley Substation",[-73.57874835656604, 41.67662355610472]],
    [ "1075642563",[-80.88398598691866, 33.464181798776124]],
    [ "1075652920",[-81.70428842668555, 28.53635240814124]],
    [ "Entergy Arkansas",[-93.47691212533802, 33.64282368981972]],
    [ "Entergy Arkansas",[-93.59154387406008, 33.66063765941157]],
    [ "Entergy Arkansas",[-93.3699233907294, 33.604828136482226]],
    [ "Entergy Arkansas",[-93.233087675522, 33.25371304150977]],
    [ "1075777822",[-92.62875650721509, 33.259030379839]],
    [ "Lamartine Substation",[-93.28901242531181, 33.384072241738146]],
    [ "Argos Substation",[-80.45358675000001, 33.22409745]],
    [ "DCC Metals Substation",[-80.43867495, 33.284327999999995]],
    [ "Harleyville Substation",[-80.45117690236573, 33.209922172774746]],
    [ "Ridgeville Substation",[-80.30995739505302, 33.100164367463364]],
    [ "Branchville Substation",[-80.82000052317724, 33.248585844338365]],
    [ "Bamberg Substation",[-81.04143485050514, 33.289682883413846]],
    [ "Smoaks Substation",[-80.8163493, 33.089598349999996]],
    [ "1075828641",[-94.2772479652828, 33.071649317837654]],
    [ "1075828642",[-94.27648572378831, 33.07167454513675]],
    [ "1075916965",[-89.03035116148452, 32.60628135524204]],
    [ "1076204554",[-94.88709272781871, 40.559052917127005]],
    [ "Clear Creek Wind",[-94.88886957151041, 40.43306109761623]],
    [ "White Cloud Wind Project",[-94.97119662422524, 40.27935001161189]],
    [ "1076204566",[-94.86449750798197, 40.31558196909576]],
    [ "1076213169",[-95.51398389261115, 40.40496647913066]],
    [ "1076221200",[-94.7830901, 40.2416614]],
    [ "1076221203",[-94.57588070919904, 40.23500562187953]],
    [ "Barnwell Substation",[-87.8696684851713, 30.422497331732053]],
    [ "1076228521",[-87.7590088, 30.384534199999997]],
    [ "1076230187",[-106.4728998121426, 34.41814441480505]],
    [ "Kaweah River Power Authority",[-119.00765075753782, 36.41540404278119]],
    [ "Three Rivers Substation",[-118.88793675672974, 36.453480115876275]],
    [ "Kaweah 1 Substation",[-118.86202529487252, 36.46507800487332]],
    [ "1076438230",[-82.41242566284072, 34.74032466105002]],
    [ "1076460698",[-86.45095940509496, 38.80017359509702]],
    [ "1076554728",[-82.1261739, 34.1261867]],
    [ "1076554730",[-82.22517195, 34.06942385]],
    [ "1076554734",[-82.2253599291161, 34.19541146050338]],
    [ "1076554740",[-82.35942058407997, 34.169097251704265]],
    [ "1076554741",[-82.36152563595834, 34.182608240917716]],
    [ "1076554743",[-82.37501534999998, 34.16963735]],
    [ "1076554744",[-82.36831439189486, 34.166860674082116]],
    [ "1076554746",[-82.38144901309806, 34.17021697409758]],
    [ "1076554747",[-82.3841468218816, 34.17140430953818]],
    [ "1076554749",[-82.38289785, 34.1710475]],
    [ "1076554752",[-82.39789844807068, 34.16478098311221]],
    [ "1076554755",[-82.40190304458947, 34.16809466870487]],
    [ "1076554757",[-82.41508205, 34.163647049999994]],
    [ "1076554758",[-82.41049670575559, 34.16406746670532]],
    [ "1076554760",[-82.40839375, 34.1778664]],
    [ "1076554761",[-82.40630068038054, 34.18342472606335]],
    [ "1076554763",[-82.39275946612057, 34.188380199339576]],
    [ "Lowndesville Substation",[-82.63997861504564, 34.21139318662321]],
    [ "1076554772",[-82.62514405, 34.2154727]],
    [ "1076554774",[-82.42093105000001, 34.130947750000004]],
    [ "1076554777",[-82.56537354895106, 34.12033883248868]],
    [ "Mohawk Substation",[-82.61365217528957, 34.13824854296638]],
    [ "1076554781",[-82.4678917392246, 34.198321938436585]],
    [ "1076554782",[-82.42106210102644, 34.183061016078526]],
    [ "1076664846",[-82.15360665000001, 34.17150155]],
    [ "Carolina Pride Substation",[-82.14567084999999, 34.19095625]],
    [ "1076664857",[-82.13435465518376, 34.19200053624533]],
    [ "1076664859",[-82.08588574158553, 34.21525366861764]],
    [ "1076664869",[-82.15124761669838, 34.16115874979148]],
    [ "Ninety Six Substation",[-82.01487907756909, 34.17561917949013]],
    [ "1076664872",[-82.00620465000002, 34.1857871]],
    [ "1076664876",[-82.14628082487053, 34.16892740809359]],
    [ "1076664878",[-82.1393721, 34.210640850000004]],
    [ "Eaton Corporation Substation",[-82.1231492, 34.217265299999994]],
    [ "1076664885",[-82.12325565, 34.2110194]],
    [ "1076664892",[-82.15328526971767, 34.2193857580597]],
    [ "1076664894",[-82.10526684999999, 34.2368973]],
    [ "1076664903",[-82.1780048150866, 34.24773848259457]],
    [ "Huntsville Utilities",[-86.67408963172379, 34.74832736137399]],
    [ "1076710664",[-86.22353139999998, 36.551669249999996]],
    [ "1076743285",[-81.18446331756265, 33.473824556893575]],
    [ "Fujifilm Substation #2",[-82.0637299602762, 34.25259222326487]],
    [ "Enviva Pellets Substation",[-82.06398978251896, 34.228658767214064]],
    [ "Teijin Carbon Substation",[-82.06911664160397, 34.22917215975438]],
    [ "1076839160",[-81.91142233528862, 34.17209905711955]],
    [ "1076839162",[-81.75748101535953, 34.23633163902143]],
    [ "International Paper Substation",[-81.75529087609416, 34.18745845877898]],
    [ "1076851182",[-89.53664333531898, 31.621473596318154]],
    [ "Dixie Electric Power Association",[-89.23153422489683, 31.412593754590734]],
    [ "West Richton Substation",[-89.0483434, 31.36149895]],
    [ "Dixie Electric Power Association",[-89.19366429042387, 31.3498197257247]],
    [ "1076917663",[-83.16610215853669, 42.549208036687794]],
    [ "1076920991",[-81.78934785, 33.697778199999995]],
    [ "1076920994",[-81.88530304999999, 34.010773650000004]],
    [ "1076920996",[-81.8263126573116, 33.90464351416544]],
    [ "1076920998",[-81.58563631201825, 33.80051033236946]],
    [ "1076969178",[-81.80947433027147, 33.564641425740085]],
    [ "1076969181",[-81.80899753111197, 33.567130541762964]],
    [ "1076969192",[-81.8893344832643, 33.756641199562]],
    [ "Dixie Pipeline Substation",[-81.8843915359966, 33.680892658496724]],
    [ "1076969199",[-81.91368933428517, 33.77438491991766]],
    [ "1076969201",[-81.85276277377507, 33.73706918443767]],
    [ "1076980523",[-81.80778805, 33.82161550000001]],
    [ "1076980537",[-81.6459821453496, 33.847018776515]],
    [ "1076980539",[-81.54339619294556, 33.90731663087685]],
    [ "1076980542",[-81.50386820000001, 33.91508105]],
    [ "1076980543",[-81.4967078, 33.9135241]],
    [ "Oklahoma Gas & Electric",[-94.54000375, 35.504157799999994]],
    [ "1076981244",[-94.54825025907124, 35.49289197506429]],
    [ "1076994574",[-94.96670705, 35.812084750000004]],
    [ "1076994575",[-94.99042423247872, 35.74791451547771]],
    [ "1076994576",[-94.95596817527, 35.92308836224959]],
    [ "1076994578",[-94.94506822612287, 35.908856508941476]],
    [ "1076994583",[-94.89031493772667, 35.92162457340086]],
    [ "1076994587",[-95.01110440569138, 35.901303587199735]],
    [ "1076994589",[-94.97827508270596, 35.91403768352989]],
    [ "1076994592",[-94.97035444168506, 35.89276947326216]],
    [ "1076994596",[-95.0552546, 35.80623705]],
    [ "1076999607",[-96.92961909337374, 36.699280671981946]],
    [ "State Campus Substation",[-73.8079178494405, 42.68622128425974]],
    [ "Mississippi Power",[-88.9549793501874, 32.00188727689452]],
    [ "CPC Paulding Substation",[-89.10186335184936, 32.0287019782759]],
    [ "Waldrup Substation",[-89.10668797525481, 31.96762638910859]],
    [ "1077141167",[-82.55225939999998, 28.365067500000006]],
    [ "1077147000",[-81.74863040570865, 34.00505918181985]],
    [ "1077147003",[-81.36879325, 33.9059183]],
    [ "1077147004",[-81.29386813795327, 33.9311267086409]],
    [ "1077147008",[-81.66792787940713, 34.0881498789378]],
    [ "1077147009",[-81.61217924717728, 34.132095332340654]],
    [ "1077147012",[-81.50210412193272, 34.13810703892329]],
    [ "1077147014",[-81.461931, 34.123066550000004]],
    [ "1077147016",[-81.38674990000001, 34.1283328]],
    [ "1077147018",[-81.54933444303445, 34.2009064195819]],
    [ "1077169860",[-81.19579053785056, 40.68048255373106]],
    [ "1077197832",[-95.73982179888064, 36.334468518755024]],
    [ "Dugas Substation",[-112.1083814373992, 34.4059889819573]],
    [ "1077289448",[-81.13004971064399, 40.63095012475819]],
    [ "Southwestern Electric Power Company",[-94.29539000000001, 34.54104085]],
    [ "Rich Mountain Electric Cooperative",[-94.30187712220341, 34.54875170794247]],
    [ "1077426532",[-94.22416551121698, 34.59013922514763]],
    [ "Rich Mountain Electric Cooperative",[-94.11161953770463, 34.56611997484476]],
    [ "Opal Substation",[-93.9993749, 34.53927204999999]],
    [ "Umpire Substation",[-94.04949885000002, 34.26872355]],
    [ "1077426544",[-93.99854864061112, 34.118612890529825]],
    [ "Southwestern Electric Power Company",[-94.02361307441413, 34.101687058116234]],
    [ "Lockesburg Substation",[-94.17854259999999, 33.989916550000004]],
    [ "Grannis Substation",[-94.30328247447859, 34.24184279502709]],
    [ "Wickes Substation",[-94.34412192765934, 34.28767564048633]],
    [ "Cove Substation",[-94.4066079, 34.45158435]],
    [ "Neeses Substation",[-81.1164091, 33.5351892]],
    [ "1077428653",[-81.11716173131843, 33.45093130425013]],
    [ "1077428655",[-81.07069509016291, 33.74384622175883]],
    [ "1077428669",[-81.09878617152755, 33.67771414129011]],
    [ "1077428670",[-80.77124733410318, 33.66739556854417]],
    [ "Cameron Solar Substation",[-80.71138307436017, 33.57294559219478]],
    [ "1077428686",[-80.57499784886971, 33.52160298331918]],
    [ "Southwest Arkansas Electric Cooperative",[-93.85868760744951, 33.975196295927795]],
    [ "Southwest Arkansas Electric Cooperative",[-93.68643249999998, 34.124953399999995]],
    [ "1077435516",[-93.71473738814342, 34.14822691606908]],
    [ "Entergy Arkansas",[-92.12948423497575, 34.74239698197781]],
    [ "1077462206",[-92.19986675204329, 34.75520619705003]],
    [ "Enterprise Products Operating LLC",[-92.20071810000002, 34.75341335]],
    [ "1077462216",[-92.18879563343216, 34.80051048355932]],
    [ "1077465290",[-91.36288811182736, 35.25958211228042]],
    [ "Arkansas Electric Cooperative Corporation",[-91.36159791765053, 35.25997062293249]],
    [ "Shoffner Substation",[-91.23353838663635, 35.475369474882456]],
    [ "1077506697",[-93.34395857651589, 29.802929112264327]],
    [ "1077506698",[-93.35113167041014, 29.80181827520149]],
    [ "1077529734",[-85.51615552309472, 38.24377945867558]],
    [ "Lombard Substation",[-83.08460579942192, 42.534307113980724]],
    [ "1077558824",[-80.79018179046676, 39.92102096283866]],
    [ "Bob Cooper Substation",[-80.25801153999437, 33.551547577032174]],
    [ "1077677951",[-81.00239359470196, 40.244247317816075]],
    [ "1077699947",[-80.93578238499437, 33.648788716350865]],
    [ "Midlands Solar Substation",[-80.93892930884111, 33.65044324370042]],
    [ "Airport Substation",[-81.10523831844992, 33.95262577797406]],
    [ "1077724186",[-83.1853498983003, 42.532104467267224]],
    [ "1077742225",[-81.0362273118393, 33.87029561876567]],
    [ "1077742227",[-81.0264211, 33.84441755]],
    [ "1077742247",[-81.27454571431551, 33.93995071588591]],
    [ "Cayce Substation",[-81.06371516207788, 33.97285807945839]],
    [ "1077742262",[-81.04055420871103, 33.97828757135817]],
    [ "Weatherly Substation",[-75.8271414179249, 40.94772153417484]],
    [ "Northeast Substation",[-83.0381226673589, 42.449866145332344]],
    [ "1077841768",[-80.81991351206793, 40.02899978117126]],
    [ "Glencoe",[-80.89454401770936, 40.01445256524942]],
    [ "1077841798",[-80.8877941, 40.04511865]],
    [ "Coldstream Substation",[-81.1895690692352, 34.053847197701515]],
    [ "1077869510",[-81.14267606921938, 34.07243509612518]],
    [ "Ninety-Nine Island Hydro Substation",[-81.49239671162269, 35.03197635430243]],
    [ "McGregor Substation",[-90.46773943704642, 42.72995643058701]],
    [ "1078074406",[-80.39260225067937, 33.611080482538235]],
    [ "1078083595",[-83.10779902637448, 42.56519457551168]],
    [ "1078088043",[-97.02973912126382, 36.82455112135209]],
    [ "1078248465",[-80.88212301910511, 33.94072640723531]],
    [ "1078248467",[-80.88423218975946, 33.94164878031009]],
    [ "1078248469",[-80.73753413330894, 33.91454903013229]],
    [ "1078248484",[-80.94306783263704, 33.940183397142775]],
    [ "Columbia Wastewater Treatment Substation",[-81.0149128432842, 33.93991778236206]],
    [ "Columbia Canal Substation",[-81.04994394860823, 33.99768220335544]],
    [ "1078308114",[-81.02598796719208, 34.01632403317988]],
    [ "Murphy Mill Substation",[-85.48130113434023, 31.252159271744752]],
    [ "Jefferson Substation",[-80.3811638140533, 34.66751212229373]],
    [ "1078338232",[-110.9076693, 32.160908899999995]],
    [ "1078344250",[-95.52164536834235, 35.50795742421359]],
    [ "1078345681",[-96.26415876331406, 35.49342924419112]],
    [ "1078487417",[-81.0071495241445, 34.018071796108785]],
    [ "1078487419",[-81.00354112872853, 34.03151899758934]],
    [ "1078487434",[-81.02985967278428, 34.04216948967994]],
    [ "1078487439",[-80.98008940000001, 34.037879100000005]],
    [ "1078487442",[-80.97650768418843, 34.062017554861065]],
    [ "Rosewood Substation",[-80.99324550530453, 33.98574782351104]],
    [ "1078487463",[-81.02818618314936, 33.96759115123496]],
    [ "1078526260",[-85.28809597617169, 31.55472278877055]],
    [ "1078583279",[-80.39961723623881, 33.428272164941184]],
    [ "1078583292",[-80.31087504024289, 33.71186931820625]],
    [ "1078583301",[-79.902137611925, 33.584350606858195]],
    [ "1078583307",[-79.78520121907637, 33.611435355054645]],
    [ "1078583312",[-79.57765391637663, 33.455120698942785]],
    [ "1078583316",[-79.52037724306001, 33.44507109033808]],
    [ "International Paper Substation",[-79.43959556454433, 33.44151341858389]],
    [ "Dunbar Substation",[-79.35869228717537, 33.510203872004745]],
    [ "Rhems Substation",[-79.44421190000001, 33.589741000000004]],
    [ "1078583332",[-79.32246818043365, 33.671501104837816]],
    [ "LaPorte Substation",[-86.72204713416635, 41.61273400945667]],
    [ "1078687218",[-87.7176544249646, 30.392373305864787]],
    [ "Hemingway Substation",[-79.42649457892273, 33.74971106628957]],
    [ "Bucksville Substation",[-79.09599732661272, 33.71855579087429]],
    [ "Pringle Ferry Substation",[-79.29245106643972, 33.42728026437348]],
    [ "1078768269",[-79.21549179999998, 33.44066475]],
    [ "1078768271",[-79.18727521016399, 33.42598995650179]],
    [ "McDowell Shortcut Substation",[-79.03710164050419, 33.57788771759968]],
    [ "Collins Creek Substation",[-79.0500053786883, 33.588104536978626]],
    [ "Queens Harbor Substation",[-78.9953061322484, 33.637494457507884]],
    [ "Azalea Lakes Substation",[-78.9946576940091, 33.658701241930736]],
    [ "1078768317",[-78.97568143367809, 33.620267051187774]],
    [ "1078768320",[-78.94753629124146, 33.66239577682202]],
    [ "1078768322",[-78.95098758964811, 33.68834922182325]],
    [ "Watsons Riverside Substation",[-78.97895739511955, 33.68701321911816]],
    [ "1078802198",[-80.43838028242114, 34.70269073208312]],
    [ "1078802199",[-80.52269591438605, 34.80223405677398]],
    [ "1078802202",[-80.33699549449815, 34.738208228605416]],
    [ "1078813287",[-80.61483055, 34.6218614]],
    [ "1078813294",[-80.58471410727624, 34.55594401998265]],
    [ "1078813295",[-80.58607059715122, 34.55506875716093]],
    [ "1078855164",[-79.09406556297199, 33.71645646409938]],
    [ "1078855173",[-78.91178646743306, 33.70084247341645]],
    [ "1078855177",[-78.87036261844455, 33.71090763708953]],
    [ "1078855180",[-78.85295071980177, 33.730797383477466]],
    [ "1078855182",[-78.89615803154223, 33.71910708551055]],
    [ "River Oaks Substation",[-78.88805716235383, 33.74889313216372]],
    [ "Crescent Beach Substation",[-78.71434346041063, 33.80829374672391]],
    [ "Nixons Crossroads Substation",[-78.67906867614688, 33.85073035559561]],
    [ "Cherry Grove Substation",[-78.62667574837893, 33.84696156710516]],
    [ "1078937360",[-89.42578086678643, 32.67837395185085]],
    [ "1078940991",[-80.96022284306646, 34.524592887587225]],
    [ "1078941004",[-80.89294493953584, 34.56025865581034]],
    [ "1078941755",[-88.56895691760987, 32.32792401757466]],
    [ "1078955885",[-79.0602248869228, 34.13493672418589]],
    [ "1078955887",[-78.97810501093305, 34.165749038467695]],
    [ "1078955904",[-78.89427295, 34.0543073]],
    [ "1078955905",[-79.0614981172245, 34.06874914926344]],
    [ "East Conway Substation",[-79.05106160569895, 33.83035578331093]],
    [ "1078964216",[-79.02581962372255, 33.7814055363945]],
    [ "1079026301",[-81.14206862630192, 34.35324043450846]],
    [ "1079093049",[-81.00881725403083, 40.54569899608111]],
    [ "1079096883",[-92.72517689956852, 37.65680460859035]],
    [ "1079143527",[-90.83624213317721, 38.93759784587779]],
    [ "Georgia Pacific Substation",[-80.23330164867494, 33.79608673313237]],
    [ "1079198773",[-80.36972029816397, 33.86314828398326]],
    [ "1079198815",[-80.35767745000001, 33.97568645]],
    [ "1079221190",[-90.62781849921967, 38.72753059055032]],
    [ "1079254370",[-81.0303624833032, 34.94794571559757]],
    [ "1079315535",[-99.31619754999998, 34.6229265]],
    [ "1079316000",[-99.31539492227641, 34.631046534288714]],
    [ "1079324851",[-99.30722021548094, 34.66629413229891]],
    [ "1079578556",[-98.47417159632725, 34.60783084387573]],
    [ "1079580801",[-96.34781296054595, 33.98301397893442]],
    [ "1079588706",[-95.07610612480595, 34.956878120336334]],
    [ "Fort Garland",[-105.44992822430208, 37.425052841361065]],
    [ "South Substation",[-94.34779095931569, 38.6457624168881]],
    [ "1079783610",[-78.63162710039917, 35.80447510234338]],
    [ "Gibson Substation",[-83.0734379924351, 42.34696170651913]],
    [ "Outer Drive Substation",[-83.14200001750712, 42.43557878418679]],
    [ "Granite Reliable Power Substation",[-71.2923296, 44.703781150000005]],
    [ "Paris Substation",[-71.25447175000002, 44.62778755]],
    [ "Y Substation",[-85.56367323134428, 32.46318889754951]],
    [ "Thompsontown Substation",[-77.2476573886325, 40.562542414083]],
    [ "1080031934",[-95.60901160888086, 37.04581280595658]],
    [ "1080037741",[-94.55085605086433, 37.01032235785653]],
    [ "1080053680",[-88.83946600204611, 31.939003592074485]],
    [ "1080058799",[-88.60327165855408, 31.7712869883826]],
    [ "Georgetown Substation",[-84.96599937788956, 35.32207316430653]],
    [ "Sevier County Electric System",[-83.44434056589796, 35.73540698318677]],
    [ "Willow Beach Substation",[-86.3340039932659, 34.32513218536322]],
    [ "Mueller Co. Substation",[-86.18452194052445, 34.23093360579833]],
    [ "1080419930",[-86.01395565930953, 34.019540682370284]],
    [ "Davis Gap Substation",[-85.74631894916533, 34.41434492818647]],
    [ "Sand Mountain Electric Cooperative",[-85.62063933512849, 34.558969183656494]],
    [ "Goals Coal Company, Inc.",[-81.52136417189924, 37.86529291185205]],
    [ "1080540733",[-81.56847351284986, 37.930737522431016]],
    [ "1080557014",[-79.46322131821138, 33.72838485181894]],
    [ "1080557017",[-79.46178597619222, 33.765739689212104]],
    [ "Pamplico Substation",[-79.55357917732644, 33.99164398079205]],
    [ "1080557023",[-79.53548685, 34.055121199999995]],
    [ "1080557026",[-79.53430065, 34.05244684999999]],
    [ "1080557032",[-79.57866076550455, 34.19898310522284]],
    [ "1080660960",[-87.4172769458375, 41.67887534423204]],
    [ "1080660968",[-87.42630706583132, 41.67913039135363]],
    [ "INDIANA HARBOR E 5 AC STATION",[-87.42095016759832, 41.68438546583722]],
    [ "1080660971",[-87.42008261379618, 41.66559058893982]],
    [ "1080710208",[-79.68294595, 34.2104919]],
    [ "1080710211",[-79.76019236042765, 34.18487757400851]],
    [ "1080710213",[-79.80606956700429, 34.1990650042341]],
    [ "1080710219",[-79.85598726546094, 34.18212185685525]],
    [ "1080710235",[-79.73440568208194, 34.146676803753564]],
    [ "1080710241",[-79.56446737065288, 34.16081494529582]],
    [ "1080710248",[-79.81007474184761, 33.720104607359204]],
    [ "1080710253",[-79.76257290585302, 33.833802179530174]],
    [ "1080830221",[-92.87687649329133, 37.60806230982681]],
    [ "1080830222",[-93.15513961708965, 37.631431110850855]],
    [ "1080833564",[-87.46513843676836, 41.66447974875256]],
    [ "1080833572",[-87.47721440000001, 41.67310570000001]],
    [ "1080833573",[-87.4768626658972, 41.67342900404541]],
    [ "1080833574",[-87.47640204999999, 41.673657999999996]],
    [ "1080833587",[-87.48188657185109, 41.661519036315894]],
    [ "1080849699",[-93.05322702275356, 37.36488692486898]],
    [ "1080850465",[-87.46606922108911, 41.63653658655923]],
    [ "1080850472",[-87.431146800923, 41.62967803703415]],
    [ "1080850473",[-87.43099285, 41.62950565]],
    [ "1080850482",[-87.43085127517585, 41.621440831172606]],
    [ "1080852452",[-93.14646513346351, 37.34050314178941]],
    [ "1080874133",[-79.69916526763234, 33.91227286225514]],
    [ "1080874135",[-79.67209149435807, 33.97981827714134]],
    [ "Evergreen Substation",[-79.64727738925592, 34.05974212639068]],
    [ "1080874139",[-79.42745937146194, 34.005165243721684]],
    [ "1080874144",[-79.409584, 34.157307599999996]],
    [ "1080874147",[-79.4941870200015, 34.2119493913735]],
    [ "1080874149",[-79.68091507964802, 34.26914125871015]],
    [ "1080874152",[-79.75521377634836, 34.24016343279014]],
    [ "1080893159",[-81.95800161037663, 32.14954832045671]],
    [ "Robins AFB Solar Substation",[-83.6173096121229, 32.68192729231501]],
    [ "Cowarts Substation",[-85.30397665, 31.188412699999997]],
    [ "Flint Hill Substation",[-78.10590768178314, 38.75578981597572]],
    [ "1080978834",[-78.18551575910297, 38.92719427061331]],
    [ "1080978835",[-78.18557119853668, 38.926809766961306]],
    [ "Mayesville Substation",[-80.16725832980087, 33.9550673141692]],
    [ "Mayesville Switching Station",[-80.1655226648372, 33.95403329777233]],
    [ "1080984808",[-80.35472045000002, 33.84882255]],
    [ "1080984810",[-80.41121554949802, 33.805702169348855]],
    [ "1080984813",[-80.43618853633284, 33.89189748911736]],
    [ "1080984815",[-80.40872162918241, 33.895631615728476]],
    [ "1080984839",[-80.69069572723023, 34.175165393091284]],
    [ "Marathon Pipe Line LLC",[-90.04018384903128, 33.38281831263824]],
    [ "1081007139",[-87.43396846159523, 41.65826076240202]],
    [ "Sevier County Electric System",[-83.5449627488611, 35.71756603214597]],
    [ "Sharon Grove Substation",[-81.41691006671107, 34.976271766623924]],
    [ "Sharon Grove Switching Station",[-81.41692544529216, 34.97605226288464]],
    [ "Greenville North Substation",[-91.04180606535083, 33.438641357463084]],
    [ "Alcorn County Electric Power Association",[-88.52079349236122, 34.92743793307612]],
    [ "1081285126",[-83.45885075000001, 43.211418550000005]],
    [ "Reloj del Sol Wind Farm Substation",[-99.33889677037308, 27.11033727306547]],
    [ "1081590136",[-79.75937027840745, 33.84608638009429]],
    [ "1081590138",[-79.76245730804851, 33.84742112694098]],
    [ "1081590141",[-79.9078731, 33.8545294]],
    [ "1081590149",[-79.81489267954318, 33.89667651459251]],
    [ "Perkins Crossroads Substation",[-79.82377650640265, 34.102154398890065]],
    [ "Honda Substation",[-79.9193926333144, 34.11218879964701]],
    [ "1081590161",[-80.02186914420001, 34.11918931281116]],
    [ "Timmonsville Substation",[-79.94857216349725, 34.178159412421316]],
    [ "Oakdale Substation#21",[-79.89845572182921, 34.173294336310825]],
    [ "Carroll County Energy Substation",[-81.06276122624075, 40.604243213712515]],
    [ "Priam Substation",[-95.13541446294485, 45.07032426080523]],
    [ "Leffingwell Substation",[-85.59474135970467, 42.970286075203404]],
    [ "Hunters Point Substation",[-122.37693536749688, 37.73687590849048]],
    [ "Leno Substation",[-81.70248196285625, 29.886827878940466]],
    [ "Mill Creek Switching Substation FPL",[-81.53084071214175, 29.991674172987793]],
    [ "Claude Substation",[-82.18937658415068, 30.291134624294013]],
    [ "1081876614",[-107.61618962704594, 35.10213708137849]],
    [ "1081926604",[-81.06095862403025, 40.60453048323403]],
    [ "1081956110",[-112.3600792328607, 34.63219369572603]],
    [ "Wateree Substation",[-80.62406249517834, 33.82624930885845]],
    [ "1082130508",[-79.11674959975568, 33.874670621982325]],
    [ "1082130509",[-79.19705188497385, 34.03089643491676]],
    [ "East Marion Substation",[-79.3494051232818, 34.19432610616359]],
    [ "1082130515",[-79.20865679642242, 34.227934500403414]],
    [ "May Hilltop Substation",[-79.21312845, 34.32450695]],
    [ "Latta Switching Station",[-79.40892303183351, 34.35826448530315]],
    [ "1082130525",[-79.41739285767041, 34.40315252213135]],
    [ "1082130527",[-79.46739511882525, 34.47018169285622]],
    [ "1082144795",[-81.23728646987664, 33.950940848374636]],
    [ "Michelin Tires Substation",[-81.28409598023723, 33.937672494797766]],
    [ "1082144799",[-81.25272550510387, 33.911211850167646]],
    [ "1082167196",[-81.33221965, 34.1341808]],
    [ "1082167217",[-81.54628920093336, 34.281933216430986]],
    [ "Blair Substation",[-81.39278107794911, 34.394810008979526]],
    [ "1082167221",[-81.43824486492369, 34.33171939667405]],
    [ "1082218588",[-95.72759896229336, 34.23262882476571]],
    [ "1082274880",[-81.608785160735, 34.26888349643342]],
    [ "1082274890",[-81.64173019529534, 34.26718418886275]],
    [ "1082274892",[-81.79810206639443, 34.39034504653842]],
    [ "1082274909",[-81.61271829680565, 34.49799974656764]],
    [ "1082274912",[-81.65801389999999, 34.72427664999999]],
    [ "1082274913",[-81.65776825046865, 34.72376153342636]],
    [ "1082274914",[-81.65736323207145, 34.723046734585324]],
    [ "1082274924",[-81.49447259999998, 34.564964399999994]],
    [ "1082274925",[-81.49650984156256, 34.56802753525487]],
    [ "1082274928",[-81.43722060168503, 34.60106763966754]],
    [ "1082274930",[-81.45781483244222, 34.587009305908616]],
    [ "1082311447",[-88.9408437823014, 37.58918393170246]],
    [ "1082311450",[-88.961981656358, 37.620818906297096]],
    [ "1082349875",[-81.64609159999999, 34.76480665]],
    [ "1082349879",[-81.64055252521378, 34.76099000520422]],
    [ "1082349882",[-81.63736, 34.76394495]],
    [ "1082349894",[-81.64426787810115, 34.78329184554816]],
    [ "1082349906",[-81.6442677, 34.80063655]],
    [ "1082349907",[-81.64339141134629, 34.80084982166185]],
    [ "1082349909",[-81.64594114999998, 34.811195049999995]],
    [ "1082349911",[-81.73997322293638, 34.89877434033959]],
    [ "1082349922",[-81.65123752387964, 34.72497133563191]],
    [ "1082349928",[-81.65457742319131, 34.70113818428832]],
    [ "1082349931",[-81.59446115, 34.71828010000001]],
    [ "1082349933",[-81.61983777009759, 34.70603299364592]],
    [ "Reactor #2 Substation",[-81.32168630188526, 34.287741009246076]],
    [ "Fairfield Pumped Storage Substation",[-81.33080520227608, 34.30638256219949]],
    [ "1082410080",[-88.95870361890985, 37.654888173894534]],
    [ "1082441898",[-91.86204087505827, 37.484301162051835]],
    [ "1082442687",[-90.2484320502802, 36.86436993558779]],
    [ "1082552126",[-81.08738248575305, 34.367663817517936]],
    [ "1082552132",[-81.08076600864628, 34.36263437108624]],
    [ "1082552134",[-81.08814165000003, 34.331962399999995]],
    [ "Wailea Substation",[-156.43000620925227, 20.68371307625458]],
    [ "Maui Electric Company",[-156.41376617181314, 20.68196576949962]],
    [ "Pulehu Switching Station",[-156.34516451552406, 20.780072048479926]],
    [ "Kula Park Substation",[-156.35011321493397, 20.786824822655788]],
    [ "Maalaea Substation",[-156.49380619749354, 20.801508829873374]],
    [ "Kula Substation",[-156.30690663175088, 20.755242734452075]],
    [ "Pukalani Substation",[-156.33043610196472, 20.82494686438878]],
    [ "Maui Electric Company",[-156.4629492709793, 20.842272204296055]],
    [ "Maui Electric Company",[-156.49420391358194, 20.893548612062876]],
    [ "Waiehu Substation",[-156.49732348578723, 20.918222568888652]],
    [ "Maui Electric Company",[-156.51214340696086, 20.888126075559185]],
    [ "Paia Mauka Substation",[-156.3822084815145, 20.914361246670115]],
    [ "Spreckelsville Substation",[-156.40450085968712, 20.907060119882885]],
    [ "Maui Electric Company",[-156.47455169234297, 20.862101500249803]],
    [ "Maui Electric Company",[-156.50930981010347, 20.83920272641595]],
    [ "Kaheawa Wind Power II Substation",[-156.54786906613938, 20.81209173924557]],
    [ "1082739295",[-81.63337895000001, 32.557452000000005]],
    [ "1082780726",[-87.48710674999998, 31.58249645]],
    [ "Florida Power & Light",[-85.4015176829683, 30.870018847722733]],
    [ "Florida Power & Light",[-85.40201463674877, 30.870460031625896]],
    [ "1082780743",[-84.6778248, 30.748318000000005]],
    [ "1082780744",[-84.67834980519359, 30.74922276736088]],
    [ "1082780747",[-84.75028328465491, 32.013369032174616]],
    [ "1082780748",[-84.74931351774715, 32.01338690076929]],
    [ "1082780754",[-86.51898055307454, 31.3613342322552]],
    [ "Florida Power & Light",[-87.33951193679557, 30.84509402550848]],
    [ "1082780771",[-87.2243350408488, 30.564389432854572]],
    [ "Crist Switchyard",[-87.2282213022709, 30.56238391679163]],
    [ "1082780777",[-88.49189315, 30.340902]],
    [ "1082816710",[-80.76197286845077, 34.17453075414928]],
    [ "1082816713",[-80.89025139839255, 34.27547969822556]],
    [ "Umatilla Electric Cooperative",[-119.62230092094299, 45.748690459753234]],
    [ "1082859533",[-80.59005046837059, 34.22458634566316]],
    [ "1082859534",[-80.59128052429482, 34.22341783453048]],
    [ "Camden Substation",[-80.59446790813173, 34.247640882395274]],
    [ "1082859537",[-80.59423805, 34.257731650000004]],
    [ "1082859539",[-80.59850760501843, 34.27313904286966]],
    [ "1082859543",[-80.61269921986397, 34.343666556951966]],
    [ "1082859548",[-80.33529095000002, 34.41949315]],
    [ "1083014883",[-86.79208686278989, 38.01668243065358]],
    [ "Watertown Substation",[-84.63993575386884, 42.784015241256796]],
    [ "Whiteman AFT East",[-93.56509482611142, 38.73348842367012]],
    [ "Whiteman AFB West",[-93.576935024089, 38.73431370488316]],
    [ "1083077948",[-94.86058270000002, 40.1278033]],
    [ "FIXME Substation",[-94.32134715571578, 38.61864105486876]],
    [ "1083085285",[-77.36147776382785, 39.84085017230863]],
    [ "1083095040",[-110.89166558722985, 32.04179134871591]],
    [ "1083095064",[-111.10706814431119, 31.87394791434575]],
    [ "1083095065",[-111.10929308937254, 31.872478590653213]],
    [ "1083211015",[-79.82249933883182, 34.90765944689067]],
    [ "1083211020",[-79.86146654155336, 34.715516269474726]],
    [ "Lordstown Energy Center Substation",[-80.8532913138704, 41.149314831457325]],
    [ "Bethel Substation",[-79.9493859232076, 34.27946425699556]],
    [ "1083270504",[-80.12305032752651, 34.34287337561188]],
    [ "1083270515",[-80.43291228423422, 34.35305991628563]],
    [ "1083270519",[-80.03664715000001, 34.524278100000004]],
    [ "Centerfield Cooper Solar Substation",[-80.11836992538177, 34.709481740326574]],
    [ "1083289859",[-112.1008190968387, 33.71477248633668]],
    [ "Pacific Gas and Electric Company",[-119.43874538230355, 35.60177011558373]],
    [ "1083309330",[-83.95219225, 30.511005299999997]],
    [ "1083320190",[-79.19615728845507, 37.44444333758557]],
    [ "1083405337",[-111.7441153400119, 33.218683475097684]],
    [ "Elizabethtown 2 Substation",[-85.87845245000001, 37.711561550000006]],
    [ "1083439738",[-80.0131521662113, 34.67428255473598]],
    [ "Brocks Mill Substation",[-79.99529777763972, 34.75625693974889]],
    [ "1083439744",[-79.78172397051732, 34.74706819495795]],
    [ "1083439746",[-79.64086413920383, 34.61516301085632]],
    [ "Society Hill Substation",[-79.89582816642421, 34.50288508102588]],
    [ "Ralph E. Gandy Substation",[-79.84000493344845, 34.393977450212944]],
    [ "1083439794",[-79.89451070000001, 34.34294665]],
    [ "Marlboro Substation",[-79.71403504978771, 34.55072354449588]],
    [ "Pelton Substation",[-81.36969837866422, 33.760467018291514]],
    [ "Pelion Substation",[-81.26414128168324, 33.798357712251814]],
    [ "1083525997",[-80.9421697134116, 34.02573306375738]],
    [ "1083526006",[-81.7577577668689, 34.36814105174777]],
    [ "Joanna Substation",[-81.82649118769045, 34.406938276764514]],
    [ "1083526008",[-81.826878, 34.40675915]],
    [ "1083526009",[-81.82719820000001, 34.40660285]],
    [ "1083526014",[-81.85565591277408, 34.329923033077655]],
    [ "1083526016",[-81.89213506629626, 34.19830290273099]],
    [ "1083526020",[-81.89918343182278, 34.44806960394438]],
    [ "1083526022",[-81.90721211732063, 34.453461748477345]],
    [ "1083566614",[-82.06610445, 34.410817449999996]],
    [ "1083566617",[-82.12061092072918, 34.26945420633845]],
    [ "1083566623",[-82.0390148546978, 34.524490167151995]],
    [ "1083585041",[-82.1255638521696, 34.6194088663571]],
    [ "1083585042",[-82.1249394374253, 34.619184012815765]],
    [ "1083585046",[-82.1562677575932, 34.645034070839635]],
    [ "1083585048",[-82.15474698679155, 34.639999878307215]],
    [ "1083585050",[-82.15318613272207, 34.52418784898127]],
    [ "1083585052",[-82.27760669999999, 34.525852199999996]],
    [ "1083639408",[-87.13793720406768, 41.63457162507233]],
    [ "Elm Creek 345kV Substation",[-97.54769908994966, 39.50492261780917]],
    [ "Geary County Substation",[-96.78538556714946, 38.975685201235734]],
    [ "Transco Substation",[-82.43224135016416, 34.58003605893532]],
    [ "Pelzer Substation",[-82.45687287946389, 34.645978349773735]],
    [ "1083724043",[-82.4520234762116, 34.71675138643985]],
    [ "1083724047",[-82.47559240000001, 34.609666450000006]],
    [ "1083724048",[-82.47667860000001, 34.61038865000001]],
    [ "1083724051",[-82.4792696, 34.611432900000004]],
    [ "1083724053",[-82.48221862099697, 34.611170107122405]],
    [ "Belton Tie Substation",[-82.49107302543885, 34.53121577476335]],
    [ "Ware Place Substation",[-82.39312549999998, 34.627845750000006]],
    [ "Colonial Pipeline Substation",[-82.48716383593047, 34.552453083654804]],
    [ "1083724069",[-82.47105620876937, 34.54019586893731]],
    [ "Hollidays Bridge Hydro Substation",[-82.37525887095829, 34.52738264504129]],
    [ "Belton Ret Substation",[-82.49613215000001, 34.5332588]],
    [ "1083724076",[-82.49698160490237, 34.53320274525073]],
    [ "1083781503",[-82.48005090000001, 34.516721849999996]],
    [ "1083781505",[-82.46702034981595, 34.50152416666535]],
    [ "1083781509",[-82.42027385, 34.4749206]],
    [ "Honea Path Substation",[-82.39410309496049, 34.45055967813728]],
    [ "Medline Industries Substation",[-82.38848155, 34.43859895]],
    [ "1083781529",[-82.35354925452008, 34.38508072377497]],
    [ "1083781531",[-82.34498149715485, 34.374292611932795]],
    [ "1083830482",[-82.2986765176088, 34.356059597263986]],
    [ "Ware Shoals Substation",[-82.24577023443278, 34.39587953320901]],
    [ "1083830490",[-82.23088293695966, 34.39740477216562]],
    [ "1083830493",[-82.23423545, 34.4040358]],
    [ "Duke Energy",[-82.1987373968106, 34.45467966704363]],
    [ "1083830497",[-82.22208503783476, 34.50832943345619]],
    [ "Jones Substation",[-91.07225423018906, 42.04695127417202]],
    [ "Sacramento Municipal Utility District",[-121.31319899274507, 38.632790581682364]],
    [ "1083866096",[-82.57382807374493, 34.44707245705781]],
    [ "1083866121",[-82.63562431101676, 34.48563241978874]],
    [ "1083866123",[-82.64107499220485, 34.48470377123352]],
    [ "1083866128",[-82.6550812, 34.478362849999996]],
    [ "1083866129",[-82.67939250218484, 34.44318121685025]],
    [ "Towers Road Substation",[-82.651683476068, 34.49045060930176]],
    [ "1083866136",[-82.69336854999999, 34.52998245]],
    [ "1083866140",[-82.74033124999998, 34.55291774999999]],
    [ "1083866145",[-82.75728031665426, 34.51996984891772]],
    [ "1083866158",[-82.68617741492152, 34.325417302872765]],
    [ "1083866160",[-82.67270491956718, 34.31400585461827]],
    [ "1083866161",[-82.57529573047697, 34.259722442255736]],
    [ "1083880983",[-78.21639139393999, 38.94795615726357]],
    [ "Eris Energy Substation",[-95.23791633384718, 37.57486983285651]],
    [ "FIXME Substation",[-95.23831260460082, 37.57494237137178]],
    [ "Wolf Creek Generation Substation",[-95.68395089999999, 38.27457115]],
    [ "Sharpe Generation Substation",[-95.68414111318123, 38.275475642994586]],
    [ "Chanute 3 Substation",[-95.47059723957219, 37.63775793409991]],
    [ "1083905636",[-82.6073614831279, 34.6431858523861]],
    [ "1083905639",[-82.60661627674607, 34.642141747995886]],
    [ "1083909774",[-77.85078156884033, 36.24770656576761]],
    [ "1083911886",[-80.80215475405262, 40.7731166489843]],
    [ "1083913533",[-95.93551976992526, 36.88029445580931]],
    [ "1083915493",[-93.40562270030009, 37.582440535310155]],
    [ "1083973730",[-82.68928490206848, 34.594832067081406]],
    [ "1083973793",[-82.76911212145147, 34.613247643932766]],
    [ "1083973795",[-82.76849459519056, 34.63601898206024]],
    [ "1083973797",[-82.78643904253376, 34.625222369165584]],
    [ "Pendleton Substation",[-82.77720499296436, 34.64645498999191]],
    [ "1083973806",[-82.81378875588607, 34.6738788615916]],
    [ "1083973811",[-82.81564499570648, 34.67228793044935]],
    [ "1084041611",[-97.07530285105811, 33.01419763267216]],
    [ "Marshalltown East Nevada Street Substation",[-92.90373075586393, 42.04392978757467]],
    [ "Parkwest Substation",[-86.81849114443588, 33.513618632133564]],
    [ "Vredenburgh Switching Station",[-87.31561214999999, 31.831222999999998]],
    [ "1084135984",[-87.36501851135831, 31.901005592832295]],
    [ "1084136359",[-87.8840385988138, 46.33655336097251]],
    [ "1084139796",[-81.7807667754815, 35.29415559530708]],
    [ "FIXME Substation",[-95.43083640833967, 37.798760714632806]],
    [ "Evergy",[-95.41201513495177, 37.81987695834466]],
    [ "Kentenia Substation",[-83.40258916869823, 36.799411997928566]],
    [ "1084190699",[-82.86527484999999, 34.686932850000005]],
    [ "1084190703",[-82.88114494999999, 34.69437205]],
    [ "1084190707",[-82.8979997217039, 34.71224501200618]],
    [ "1084190708",[-82.89865427705024, 34.71253440816182]],
    [ "1084190709",[-82.9267218330788, 34.695330628379764]],
    [ "1084190711",[-82.92936490000001, 34.6954752]],
    [ "1084190720",[-82.92965028478929, 34.68442754657986]],
    [ "1084190721",[-82.94026487821729, 34.69378945574383]],
    [ "Seneca City Substation",[-82.95213982274326, 34.687821975209594]],
    [ "1084192189",[-83.57055155985738, 36.782560625676744]],
    [ "1084242009",[-93.01833454204359, 37.38490603094274]],
    [ "1084248774",[-82.95640372193128, 34.65090339288721]],
    [ "1084248777",[-82.98321835, 34.66350214999999]],
    [ "1084248784",[-82.99202625849198, 34.644974276141085]],
    [ "1084248786",[-82.9303592, 34.627023550000004]],
    [ "1084248788",[-83.01528613216936, 34.60072654464703]],
    [ "1084248791",[-82.98219102892965, 34.52239380868688]],
    [ "1084248792",[-83.05221417101417, 34.53440845762202]],
    [ "1084248794",[-82.9142041676156, 34.525519926618344]],
    [ "1084248795",[-82.87184009228118, 34.56481536805739]],
    [ "1084248801",[-83.01518725000001, 34.6756757]],
    [ "1084248803",[-83.0677089815707, 34.66463640526007]],
    [ "1084248816",[-83.06938345, 34.6650949]],
    [ "1084248820",[-83.03519925, 34.66142175]],
    [ "1084248830",[-83.18773995, 34.7003052]],
    [ "1084274127",[-83.07915635717528, 34.69171013094694]],
    [ "1084274140",[-83.03911006905284, 34.766014946220956]],
    [ "1084274142",[-83.04607246122066, 34.77611752618958]],
    [ "1084274146",[-83.04711535062883, 34.791013900072144]],
    [ "1084274147",[-83.01855439999999, 34.82552535]],
    [ "1084274149",[-83.12922802626044, 34.84571019213148]],
    [ "1084274151",[-82.97369802948297, 34.88587521492362]],
    [ "1084274155",[-82.99809139004522, 34.77266322140329]],
    [ "1084274156",[-83.02962775, 34.73808875000001]],
    [ "1084274161",[-82.98735326233458, 34.705553823639335]],
    [ "1084274163",[-82.98309791608118, 34.701422456015365]],
    [ "1084274165",[-82.98009049999999, 34.696241150000006]],
    [ "1084305906",[-82.74365105, 34.736934500000004]],
    [ "1084305909",[-82.58669135734723, 34.81254349151457]],
    [ "1084305913",[-82.58023618210999, 34.800160366225]],
    [ "1084305928",[-82.60890170993927, 34.82538522302887]],
    [ "1084305929",[-82.58443280032633, 34.82797570638147]],
    [ "1084305934",[-82.57355495338577, 34.83193393246885]],
    [ "1084305935",[-82.57339690425084, 34.83153288809006]],
    [ "1084305940",[-82.54644963356706, 34.835782554059165]],
    [ "1084305962",[-82.45656591449625, 34.87268352540448]],
    [ "1084306032",[-82.42238210073425, 34.864534172358255]],
    [ "1084308001",[-82.25601933307347, 34.9344801592062]],
    [ "Diamond Vista Wind",[-97.18694609045214, 38.5666600033339]],
    [ "South Field Substation",[-80.68143289707876, 40.635204161405376]],
    [ "Greys Point Transition Station",[-76.43530785823289, 37.61115921983385]],
    [ "1084333735",[-93.03904952031708, 37.26486482508433]],
    [ "1084336603",[-82.7751436859238, 34.72014086904723]],
    [ "1084336605",[-82.75032906140424, 34.75428562446449]],
    [ "1084336615",[-82.674902632562, 34.7740669972578]],
    [ "1084336617",[-82.6687457468576, 34.776731283637346]],
    [ "1084336618",[-82.6688544942409, 34.77695773432251]],
    [ "1084336629",[-82.66226463690576, 34.79581486710515]],
    [ "1084336630",[-82.66122229999998, 34.796722249999995]],
    [ "1084336633",[-82.66219705, 34.80888409999999]],
    [ "1084336634",[-82.67007129605105, 34.836025481703714]],
    [ "1084336637",[-82.64916645000001, 34.81311485]],
    [ "1084336638",[-82.64670721868609, 34.81406969314722]],
    [ "1084336690",[-82.76612781036822, 34.74696650818013]],
    [ "1084338519",[-94.71415108558666, 32.26038073161307]],
    [ "1084346766",[-83.51603564034636, 36.83982007880018]],
    [ "East Lancaster Substation",[-82.57682863796387, 39.70813710572226]],
    [ "Wears Valley Substation",[-83.64075322627775, 35.72422578191736]],
    [ "1084438812",[-82.37693892068276, 34.7370302086891]],
    [ "1084438814",[-82.3675494, 34.73446865]],
    [ "1084438819",[-82.3582849, 34.735967349999996]],
    [ "1084438826",[-82.36070436139504, 34.7480178717051]],
    [ "1084438827",[-82.29097311617514, 34.756971100092926]],
    [ "1084438852",[-82.27220476193779, 34.81090630823715]],
    [ "1084438853",[-82.27185625238215, 34.81060366688046]],
    [ "1084438916",[-82.40971642821664, 34.851746253406766]],
    [ "1084438922",[-82.4331596267383, 34.857957893343496]],
    [ "1084438931",[-82.42054987473068, 34.827333296137716]],
    [ "1084438932",[-82.41300946759448, 34.830936047566155]],
    [ "1084438934",[-82.4232643750497, 34.82630455630001]],
    [ "1084438937",[-82.43530804813491, 34.81337829334578]],
    [ "1084438958",[-82.42886384861785, 34.808493491213945]],
    [ "1084438959",[-82.42725275, 34.8088205]],
    [ "1084438963",[-82.43844978097925, 34.772820495422174]],
    [ "1084438965",[-82.43276825, 34.76781405]],
    [ "1084438967",[-82.4748319554729, 34.77215104587374]],
    [ "1084439012",[-82.3594991523795, 34.86292782792319]],
    [ "1084462483",[-82.37292518272793, 34.734228734205196]],
    [ "1084462493",[-82.35806059396869, 34.764894339702344]],
    [ "1084462495",[-82.35669677241324, 34.7713207570633]],
    [ "Fork Shoals Substation",[-82.3051156372646, 34.619797215664676]],
    [ "1084462513",[-82.24061983278601, 34.712653302372985]],
    [ "1084462516",[-82.30014441691497, 34.77151814938193]],
    [ "1084462519",[-82.29134455, 34.762152549999996]],
    [ "1084468577",[-86.96614922571689, 31.448587293605794]],
    [ "1084468580",[-86.63585869999999, 31.817756649999996]],
    [ "1084468587",[-86.60478155000001, 31.832652250000006]],
    [ "Fort Deposit Substation",[-86.5599446876445, 31.986487856546912]],
    [ "1084468594",[-86.38572787539462, 32.255400458321816]],
    [ "1084468595",[-86.38547436107743, 32.25538323235758]],
    [ "1084489446",[-85.2173355612754, 31.8736281065186]],
    [ "Straban Substation",[-77.18717806953698, 39.823081036265826]],
    [ "1084525977",[-85.56416688858172, 34.273776151222066]],
    [ "Whorton Substation",[-85.49746025399358, 34.13139097201839]],
    [ "1084525981",[-85.6849643572771, 34.11064537596954]],
    [ "Weiss Substation",[-85.7938817547446, 34.13217589350518]],
    [ "1084525983",[-85.88407645000001, 34.09458495]],
    [ "1084525993",[-85.99565904933651, 34.05562142227861]],
    [ "East Sylva Retail Substation",[-83.21431313781062, 35.376165126377465]],
    [ "Saraland Refinery Substation",[-88.05597000745193, 30.790978238805096]],
    [ "1084679009",[-80.26823214749126, 36.0912945093258]],
    [ "Iron Works Substation",[-84.90374925, 45.07084784999999]],
    [ "1084936003",[-107.92886439664312, 36.89102755798509]],
    [ "New Baltimore Substation",[-78.82526544921116, 39.983119210443775]],
    [ "Dixie Electric Power Association",[-89.2183604833385, 31.876252799060374]],
    [ "1085152064",[-82.22779610791082, 34.92187192028354]],
    [ "Greer Substation",[-82.23452849131397, 34.93750731744014]],
    [ "BMW Substation",[-82.17969538333816, 34.894918669988485]],
    [ "1085152133",[-82.17409339521538, 34.86271487845764]],
    [ "1085152136",[-82.15562466943682, 34.80118683702896]],
    [ "1085152154",[-82.22873090000002, 34.699377500000004]],
    [ "1085152156",[-82.23560189009439, 34.70233861474153]],
    [ "1085152163",[-82.2021898832115, 34.65974124821966]],
    [ "1085152175",[-82.3692351, 34.62966959999999]],
    [ "1085395322",[-110.06321164136757, 35.41504077018451]],
    [ "Union Substation",[-89.52263236289127, 31.978303127128495]],
    [ "1085441811",[-82.4640858200478, 35.29662735631752]],
    [ "1085452450",[-82.4329716771179, 35.35195372679305]],
    [ "1085454093",[-77.30915255, 37.2911489]],
    [ "Willow Street Substation",[-86.06041061074376, 34.67498730725385]],
    [ "Ray Place Road Switching Station",[-82.81977165, 33.468258500000005]],
    [ "1085537042",[-82.6301037670955, 34.832651156792906]],
    [ "1085537047",[-82.60522300000001, 34.888572350000004]],
    [ "1085537049",[-82.59861791764389, 34.900433447403266]],
    [ "1085537050",[-82.68982140448794, 34.88561551599309]],
    [ "1085537055",[-82.7506503, 34.957199849999995]],
    [ "Jocassee Tie Substation",[-82.91572116332615, 34.954127624124816]],
    [ "1085537057",[-82.91455643522913, 34.955730692490945]],
    [ "1085537059",[-82.64183747306666, 34.84287291078869]],
    [ "1085537062",[-82.71253468263649, 34.89391230342815]],
    [ "1085537063",[-82.6861962, 34.89519485]],
    [ "Walnut Substation",[-83.67665018775594, 43.02532610954662]],
    [ "1085595639",[-80.74839146792696, 38.005774466096646]],
    [ "Riverdale Substation",[-84.80643970000001, 43.37795285]],
    [ "1085672976",[-82.51606517595832, 34.98258619964078]],
    [ "1085672979",[-82.56534467781279, 35.02350040613619]],
    [ "1085672980",[-82.56120357800484, 35.02386435429582]],
    [ "1085672983",[-82.53880015481266, 35.0255288516575]],
    [ "1085672984",[-82.50168269501208, 35.01641529643288]],
    [ "1085672986",[-82.4918427269446, 35.025574634424615]],
    [ "1085672989",[-82.41083305, 35.13687989999999]],
    [ "1085672991",[-82.35446785, 35.066943450000004]],
    [ "1085672992",[-82.35408282926096, 35.06697885751025]],
    [ "1085672993",[-82.3087158, 35.102056100000006]],
    [ "1085672995",[-82.44962155000002, 34.96591765000001]],
    [ "1085672997",[-82.44479039999999, 34.923240400000005]],
    [ "1085673004",[-82.46915103942678, 35.07845146334191]],
    [ "1085673005",[-82.62949929999999, 35.18588425]],
    [ "1085726506",[-95.3755327789682, 40.19825212986972]],
    [ "Virginia Electric and Power Company",[-79.017294226283, 37.01089572933403]],
    [ "Consolidated Edison Development Inc.",[-79.01753856767631, 37.011231845080175]],
    [ "1085795210",[-82.27774144410324, 34.91942256734981]],
    [ "1085795211",[-82.27861314249648, 34.919748768285736]],
    [ "1085795213",[-82.33598208333608, 34.90906874963553]],
    [ "1085795216",[-82.35788105000002, 34.9019286]],
    [ "1085795219",[-82.25719570000001, 34.93716885]],
    [ "1085795229",[-82.06858640000002, 34.930700900000005]],
    [ "1085795281",[-82.01880884999999, 34.956660649999996]],
    [ "1085795284",[-82.04155919999998, 34.933494450000005]],
    [ "1085795285",[-82.03980075000001, 34.93066985]],
    [ "1085795287",[-82.07619415524034, 34.94374067262107]],
    [ "1085795290",[-82.08789573461232, 34.937480582567055]],
    [ "1085795292",[-82.11888423291444, 34.93649110215743]],
    [ "1085816960",[-95.30215155708709, 35.793282948105784]],
    [ "1085855458",[-77.18345967928008, 37.24816478858224]],
    [ "Brooklyn REC Substation",[-92.39639546177267, 41.746975269799584]],
    [ "Sock Hill Substation",[-82.01446025546474, 34.85178353824654]],
    [ "1085909151",[-95.96261138396594, 42.015451074710946]],
    [ "1085909152",[-95.8079851015695, 42.015986624948226]],
    [ "1085918955",[-122.67643606751182, 45.65762452515921]],
    [ "1085918978",[-82.6417108970906, 36.97190361673165]],
    [ "1085937871",[-112.36502022127361, 42.798738814892815]],
    [ "1085953265",[-112.31150345338297, 42.15657904956339]],
    [ "1086008777",[-91.62866242953362, 38.01718604300121]],
    [ "FIXME Substation",[-91.44786163553701, 38.8987998656016]],
    [ "1086106125",[-89.91092280847279, 35.90808434778119]],
    [ "1086114993",[-95.32229672445884, 35.76200153217568]],
    [ "1086128071",[-82.0011217903588, 34.85931931657382]],
    [ "1086128081",[-82.00532855000002, 34.94620715]],
    [ "1086128089",[-81.96931674876095, 34.96204578325299]],
    [ "1086128093",[-81.997119, 34.9795602]],
    [ "1086128095",[-81.99601140688776, 34.98254203194167]],
    [ "1086128099",[-82.0316576, 34.99474785]],
    [ "1086128100",[-82.0298264278011, 34.99283269352663]],
    [ "1086128101",[-82.02931231796249, 34.99589550320987]],
    [ "1086128108",[-81.9315251, 34.98694234999999]],
    [ "1086128115",[-81.90348375544353, 35.01568991737305]],
    [ "1086128117",[-81.87544485000002, 34.99994515]],
    [ "1086128120",[-81.81375735851722, 34.97854842085994]],
    [ "1086128122",[-81.78010143157151, 34.914787695848766]],
    [ "1086137792",[-81.6539925, 34.7133807]],
    [ "1086137794",[-81.73199286215578, 34.68552562490122]],
    [ "1086137802",[-81.65420342350846, 34.77867908797844]],
    [ "1086137804",[-81.76067567423682, 34.848825662345874]],
    [ "1086137837",[-81.9327487906986, 34.74575918072882]],
    [ "1086137838",[-81.89058793699319, 34.69029471904984]],
    [ "1086137845",[-82.04410256880684, 34.69928914446324]],
    [ "1086137846",[-82.03155934064004, 34.645723077487354]],
    [ "1086137848",[-81.96107525729138, 34.6488130279493]],
    [ "1086208295",[-82.0400326047985, 34.74487767789853]],
    [ "1086208299",[-82.02770440577802, 34.76652873768516]],
    [ "1086208303",[-82.00403683027379, 34.80626940875848]],
    [ "1086208305",[-82.00393205939139, 34.80895976990733]],
    [ "1086208306",[-81.98502870870625, 34.832328669468176]],
    [ "1086208310",[-81.9618062, 34.8912451]],
    [ "1086208324",[-81.80597514782177, 35.02752818290172]],
    [ "1086208328",[-81.78192473498926, 35.01902027746489]],
    [ "1086208330",[-81.76641741463494, 35.03380018229234]],
    [ "1086232340",[-111.26868159704037, 35.1643646144728]],
    [ "1086255823",[-88.19963285000001, 44.31423409999999]],
    [ "1086260859",[-114.62529602274522, 47.630180848304676]],
    [ "Cleona Substation",[-76.48772986753302, 40.33818054738284]],
    [ "Tennessee Valley Authority",[-84.05080016855449, 35.5447213318665]],
    [ "1086337749",[-81.83342520316192, 34.93630771331463]],
    [ "1086337751",[-81.85339822501585, 34.924315427856435]],
    [ "1086337764",[-82.06658907001791, 35.00761788446004]],
    [ "1086337765",[-82.06582354999999, 35.00857789999999]],
    [ "1086337779",[-81.94028787675923, 35.09748249260119]],
    [ "1086337811",[-81.88615620000002, 35.20853135000001]],
    [ "1086337812",[-81.87092599738547, 35.20931786488129]],
    [ "1086337814",[-81.95940673046802, 35.14029170399092]],
    [ "1086337815",[-82.1196009813656, 35.04963321585541]],
    [ "1086337819",[-82.11030285, 35.0467163]],
    [ "1086337820",[-82.10119399999999, 35.039674500000004]],
    [ "1086337825",[-82.03808692490017, 35.024918207036]],
    [ "1086337828",[-82.10343474999999, 35.043769499999996]],
    [ "1086337830",[-82.10518917812668, 35.04433471481873]],
    [ "1086356896",[-81.65601991559153, 34.86561709197776]],
    [ "1086356898",[-81.66092968058423, 34.86188540410112]],
    [ "1086356901",[-81.63928739999999, 34.874020949999995]],
    [ "Lockhart Power",[-81.74516640000002, 34.91280664999999]],
    [ "Lockhart Power",[-81.71831852505453, 34.94622211297629]],
    [ "Lockhart Power",[-81.69996653065535, 34.983500841117994]],
    [ "Pacolet Mills Substation",[-81.74088355000002, 34.9213911]],
    [ "Lockhart Power",[-81.45626988541204, 34.77935347207614]],
    [ "1086469544",[-81.92192711661926, 34.96069619503117]],
    [ "1086469550",[-81.95625980418355, 34.98938778367889]],
    [ "1086469554",[-81.99474679739609, 35.000701316836306]],
    [ "1086469563",[-81.85802914877306, 35.03438257381142]],
    [ "Duke Energy",[-81.87661324204973, 35.04585720801323]],
    [ "1086469578",[-81.8625971741261, 35.14057710485746]],
    [ "1086469579",[-81.87240804593095, 35.14076388557921]],
    [ "1086469586",[-81.96637052421013, 35.110158006887715]],
    [ "1086469592",[-82.04497908155321, 35.13208229297064]],
    [ "1086469593",[-82.0402228, 35.20517845]],
    [ "Chesnee Substation",[-81.86437478695204, 35.13246382388712]],
    [ "1086469596",[-81.84686265201762, 35.19452697486675]],
    [ "1086503814",[-89.03713874235142, 32.328301853127]],
    [ "1086567537",[-77.98640515335957, 37.29496481339047]],
    [ "Northern Neck Substation",[-76.71179182305637, 37.94839541939588]],
    [ "1086568731",[-76.73938803073419, 34.704492476688884]],
    [ "Larson Substation",[-115.16230011168973, 35.95674538164139]],
    [ "1086803490",[-88.8789794, 31.804960550000008]],
    [ "1086843400",[-79.81323220000002, 33.69724505]],
    [ "1086851906",[-84.37838001617887, 41.27579559715738]],
    [ "1086982457",[-80.88973211585792, 41.090456277397095]],
    [ "1087016022",[-81.6949605601377, 35.05782972246739]],
    [ "1087016023",[-81.688939278375, 35.05445039101182]],
    [ "1087016025",[-81.66628468924654, 35.06803126582485]],
    [ "1087016028",[-81.69728440000002, 35.0547974]],
    [ "1087016030",[-81.68320792940736, 35.0173778355929]],
    [ "1087016032",[-81.67892790000002, 35.01408580000001]],
    [ "1087016034",[-81.63825949004341, 34.994226130198015]],
    [ "1087016035",[-81.50334789848564, 35.039977988677165]],
    [ "1087016062",[-81.70875751926117, 35.05062130134259]],
    [ "1087016064",[-81.61450331562291, 35.098240368805754]],
    [ "1087016070",[-81.6325785, 35.0930424]],
    [ "Broad River Solar Substation",[-81.74554190356504, 35.20393941664151]],
    [ "Broad River Solar Switching Station",[-81.74594524999999, 35.203727]],
    [ "1087016077",[-81.75977855374289, 35.220701436700324]],
    [ "Singing River Electric Cooperative",[-88.76313317270866, 30.411354159971083]],
    [ "1087097119",[-80.95060988354066, 41.01372202558352]],
    [ "1087110343",[-82.57289265000001, 36.93938585000001]],
    [ "1087113189",[-92.05330695077345, 39.69732691526509]],
    [ "1087113194",[-92.45384016727313, 39.76241106001766]],
    [ "1087115376",[-109.5534935248968, 31.363776607494454]],
    [ "1087212094",[-89.40386275, 43.4907015]],
    [ "Paria Substation",[-111.96886970444572, 37.16776356617082]],
    [ "Chadwick Acres Substation",[-77.37310393502918, 34.51933999171074]],
    [ "1087287314",[-81.36853785001641, 35.083014711445095]],
    [ "1087287316",[-81.23073253958624, 35.12051042389489]],
    [ "1087287320",[-81.49881140269453, 35.078988705843514]],
    [ "1087287327",[-81.48173818291448, 35.154737301867875]],
    [ "1087292753",[-103.3713879477643, 32.980874458792634]],
    [ "1087292802",[-102.5303327210576, 32.12046264229997]],
    [ "1087292803",[-102.5287243570273, 32.121222029650475]],
    [ "1087292809",[-102.2290999137223, 30.98010557570491]],
    [ "1087292815",[-102.25672551990924, 30.975590303031407]],
    [ "1087293144",[-88.482733313037, 42.54484088090594]],
    [ "Sheridan Substation",[-78.94285247590938, 40.35267635499746]],
    [ "Hammock Bay Substation",[-86.1592771506754, 30.509616788903568]],
    [ "1087366829",[-96.42336621773894, 32.53507853258644]],
    [ "1087366831",[-96.42230148661487, 32.53396378838805]],
    [ "1087366838",[-97.87869838836347, 30.75216364666549]],
    [ "West Rapid City Substation",[-103.26345900394084, 44.08733566727716]],
    [ "1087396613",[-81.5965693764539, 35.138586111463006]],
    [ "1087396615",[-81.65113420000002, 35.0884306]],
    [ "1087396617",[-81.66540810000001, 35.061593650000006]],
    [ "1087396620",[-81.70518498075786, 35.06617339281168]],
    [ "1087396623",[-81.5273495556646, 35.133640068415104]],
    [ "Blacksburg Ret Substation",[-81.5260669522864, 35.120325410089585]],
    [ "1087396649",[-81.19967290060889, 35.18809887370868]],
    [ "1087396657",[-81.24045992579786, 35.02874500156165]],
    [ "1087396661",[-81.23482910760248, 35.01135203077481]],
    [ "1087396665",[-81.04079327804747, 35.01427916455377]],
    [ "South Beach Substation",[-77.60206578427425, 34.387298736009605]],
    [ "1087477955",[-86.11933734030791, 34.02942242593288]],
    [ "Crestwood Midstream Partners, LP",[-81.17291854186952, 35.0007940265557]],
    [ "1087494368",[-81.13620629717042, 34.96607982593956]],
    [ "1087494371",[-81.13966040390788, 34.72311086818026]],
    [ "1087494373",[-81.1367266054982, 34.73208241836599]],
    [ "1087494387",[-81.005421967798, 34.77402685474764]],
    [ "1087534926",[-80.93272908361445, 34.833102909226575]],
    [ "1087534956",[-81.01204752517053, 34.91032684613377]],
    [ "1087534990",[-81.12170646687537, 35.036810248266484]],
    [ "1087535000",[-81.16406912894358, 35.21125741306387]],
    [ "1087535029",[-81.21221548731036, 35.202400129229076]],
    [ "Kiawah Switching Station",[-80.10902787816983, 32.60110893976397]],
    [ "Tennessee Valley Authority",[-90.14745377322195, 35.06689461175677]],
    [ "1087618897",[-90.15305621073408, 35.062678926570506]],
    [ "1087624712",[-89.5105163368396, 37.65783960321137]],
    [ "1087633967",[-81.12454334937254, 35.11744848367795]],
    [ "1087633969",[-81.0917856886259, 35.12108954440917]],
    [ "1087633980",[-81.03080441191156, 34.947540359706295]],
    [ "1087633984",[-80.9749135, 34.9695598]],
    [ "1087633985",[-80.975507203364, 34.9698315332023]],
    [ "1087633987",[-80.97599121667567, 34.96810500031949]],
    [ "1087645554",[-80.83261670668266, 34.82077039515814]],
    [ "1087645557",[-80.85997694790161, 34.84924756689928]],
    [ "1087645561",[-80.9250971, 34.9972613]],
    [ "1087645565",[-80.85553390266715, 34.94645444730471]],
    [ "1087645568",[-80.83630066171858, 34.91995852779183]],
    [ "1087645571",[-80.82329366202579, 34.8078416327926]],
    [ "1087645573",[-80.84328185000001, 34.756158150000005]],
    [ "1087645575",[-80.83871521666677, 34.74791564973739]],
    [ "1087645577",[-80.82222344148529, 34.731394230374555]],
    [ "1087645584",[-80.80958537067876, 34.72914794191438]],
    [ "1087645592",[-80.82384314999999, 34.721298950000005]],
    [ "1087645596",[-80.84923239233308, 34.71051357672339]],
    [ "1087674199",[-80.7133193, 34.665905650000006]],
    [ "1087674200",[-80.63862741501218, 34.75452258642665]],
    [ "1087702505",[-89.26069548805728, 37.51066861329547]],
    [ "1087702509",[-89.2312331, 37.46940135]],
    [ "1087702512",[-89.23448156636678, 37.46159903365725]],
    [ "1087702522",[-89.24171017743191, 37.76570787662455]],
    [ "1087702523",[-89.23778386249546, 37.76791281460663]],
    [ "1087703971",[-80.77674206230995, 34.710695461516615]],
    [ "1087703982",[-80.53858965616321, 34.412964182312415]],
    [ "Haile Gold Mine Substation",[-80.53132926755787, 34.59841523921398]],
    [ "1087749930",[-80.37788585359607, 34.75323188272779]],
    [ "1087749932",[-80.41620856810644, 34.79635029647211]],
    [ "1087749934",[-80.4250101035946, 34.789076619212345]],
    [ "Kingston Substation",[-75.89711906241678, 41.2683122027247]],
    [ "1087785760",[-90.58816785, 43.183503900000005]],
    [ "1087785769",[-90.43150493671949, 43.18697372593629]],
    [ "1087785770",[-90.33588845000001, 43.1872336]],
    [ "1087788041",[-87.019637638976, 34.62912501374484]],
    [ "1087788047",[-86.87076911083572, 34.949610847499976]],
    [ "1087790426",[-89.88558087903418, 37.73534803395864]],
    [ "1087790427",[-90.04872429372996, 37.94072260192998]],
    [ "1087790429",[-90.41172650516647, 37.87071278090187]],
    [ "Vanderhorst Switching Station",[-80.0711068945395, 32.61518302522007]],
    [ "1087824951",[-79.89681485, 34.6838292]],
    [ "1087824973",[-80.98494284002747, 34.69417873245961]],
    [ "1087824980",[-81.13106153677316, 34.43658742971694]],
    [ "1087824982",[-81.21240155932907, 34.521052456588414]],
    [ "1087824984",[-81.26370207506483, 34.66832641335716]],
    [ "1087824985",[-81.36719203529734, 34.74226319869597]],
    [ "1087830094",[-81.5851019320866, 34.28891378426783]],
    [ "1087866059",[-82.84334070103746, 34.830947112059214]],
    [ "1087866070",[-82.90103653834231, 34.79325875739355]],
    [ "1087866074",[-82.90163401313306, 34.794148073852085]],
    [ "1087866091",[-82.92254086851364, 34.914703331179155]],
    [ "Bad Creek Hydro Substation",[-82.99713472942128, 35.00722728293813]],
    [ "1087945998",[-82.18427224999999, 34.6965381]],
    [ "1087946005",[-82.07427651211925, 35.12847829603042]],
    [ "1087946010",[-82.1320412682646, 35.236557862759625]],
    [ "1087946012",[-82.19126728797664, 35.254532208118235]],
    [ "1087946013",[-82.1868814, 35.254723899999995]],
    [ "1087946016",[-82.18041649087485, 35.264437729763195]],
    [ "1087946020",[-82.16868188849912, 35.29586182739389]],
    [ "1087946023",[-82.19391368985873, 35.165842474893935]],
    [ "1087946025",[-82.22924386245568, 35.199429971556455]],
    [ "Marshall-DeKalb Electric Cooperative",[-86.26634934999998, 34.2748333]],
    [ "1087990868",[-80.9472070509306, 35.007492316823104]],
    [ "1087990872",[-80.89414285918284, 35.085272441183974]],
    [ "1088014138",[-89.10316197197899, 32.81956870538612]],
    [ "Louisville Switching Station",[-89.06762202498291, 33.11531744536722]],
    [ "Adaton Substation",[-88.90316806377372, 33.465734015132924]],
    [ "1088036323",[-87.76674611800199, 30.545299629543955]],
    [ "1088041750",[-89.80954056927328, 43.17258375571955]],
    [ "1088041753",[-89.78100125000002, 43.17648205]],
    [ "West 41st Street Substation",[-81.71431028453591, 41.47396562602742]],
    [ "1088044583",[-82.51570646154374, 35.54061927086712]],
    [ "1088050685",[-112.37202459389245, 33.446273074800985]],
    [ "Arizona Public Service",[-112.37645710000001, 33.44203205]],
    [ "1088137861",[-86.85001986678087, 37.95413974960808]],
    [ "1088203903",[-77.47089416352614, 39.012823623347934]],
    [ "1088300828",[-86.71904754283112, 41.601258974850055]],
    [ "1088318964",[-87.43849927491462, 32.569105442948896]],
    [ "Nashville Electric Service",[-86.83532230267299, 36.14172026029399]],
    [ "Nashville Electric Service",[-86.84510759999999, 36.1256541]],
    [ "Paragould Light & Water Commission",[-90.50956470000001, 36.0260938]],
    [ "Roundhouse Substation",[-105.02661860709235, 41.03980901025476]],
    [ "Portageville",[-78.04683407301873, 42.56721106426756]],
    [ "1088501185",[-85.3049894977966, 40.6208507105233]],
    [ "1088502952",[-87.09856355, 32.618761199999994]],
    [ "1088863770",[-118.10752951437568, 34.95791062548766]],
    [ "1088863777",[-118.15088064999999, 35.026335]],
    [ "1088863779",[-118.14070636280748, 35.02460659333747]],
    [ "1088960833",[-77.59626764417715, 36.69786036072741]],
    [ "Virginia Electric and Power Company",[-77.59546101190291, 36.69752397356682]],
    [ "1089014331",[-81.61649942466269, 35.078776106808384]],
    [ "1089014336",[-81.62727500000001, 35.07685025000001]],
    [ "1089014338",[-81.63201577556082, 35.07903474384888]],
    [ "1089051246",[-91.01922375, 36.01678575]],
    [ "1089052372",[-89.66707848808085, 38.01140467761604]],
    [ "1089181009",[-74.76372914999997, 41.53272454999999]],
    [ "1089181012",[-74.75781116521293, 41.462018381909395]],
    [ "1089181024",[-74.82352576299479, 40.86287899583432]],
    [ "1089351899",[-89.65743675584247, 38.19979292346482]],
    [ "Aster Substation",[-89.5811149946605, 38.21173145679972]],
    [ "1089351911",[-89.65752626579253, 38.27837252526227]],
    [ "1089354349",[-96.6465488, 44.58617829999999]],
    [ "1089354351",[-96.57770793480083, 44.58118853209587]],
    [ "1089355800",[-98.42031990238188, 40.58301846228926]],
    [ "Tennessee Valley Authority",[-87.9054298678566, 34.769245460141015]],
    [ "1089440693",[-90.70054302181425, 37.3547478552814]],
    [ "1089440700",[-90.84045610787875, 37.09318145685347]],
    [ "1089440701",[-90.96393822843584, 37.232238363699366]],
    [ "1089470878",[-80.78338307914944, 41.1899384619609]],
    [ "1089478202",[-95.14402364704748, 43.14452913402744]],
    [ "Entergy Arkansas",[-91.38793655, 34.298994549999996]],
    [ "Almyra Substation",[-91.40837464999998, 34.402619200000004]],
    [ "Stuttgart Solar, LLC",[-91.44195813752812, 34.4349301021577]],
    [ "Entergy Arkansas",[-91.4426422, 34.434776500000005]],
    [ "1089487553",[-74.434278735465, 41.4123265793148]],
    [ "GCVC Substation",[-97.3206923481221, 27.932256289146387]],
    [ "1089582179",[-99.60533112479303, 33.00382125359135]],
    [ "1089582184",[-99.61468335000002, 33.00165559999999]],
    [ "1089608167",[-77.3117117261109, 34.65086072249656]],
    [ "1089613262",[-77.41233960636269, 34.73822772113701]],
    [ "1089687516",[-97.77939429855998, 28.125218093426493]],
    [ "1089687517",[-97.78106366533129, 28.12644185512721]],
    [ "1089687784",[-95.53975073592169, 35.46448843540092]],
    [ "Kossuth Wind Farm",[-94.13341654179969, 42.98674663744076]],
    [ "Station 8316",[-77.97095000000002, 42.578906499999995]],
    [ "Tennessee Valley Authority",[-86.9832898, 37.266717]],
    [ "Meredith Substation",[-86.25549664947127, 37.383781013040306]],
    [ "1089778547",[-93.67772120975465, 41.671660474194425]],
    [ "1089779497",[-85.96614712799895, 37.45583183882429]],
    [ "Kentucky Utilities Company",[-86.02494816954217, 37.60132771279967]],
    [ "1089903674",[-92.880848779368, 37.329210386628226]],
    [ "1089904967",[-87.06351939872617, 37.69751747795719]],
    [ "1089906323",[-87.17510998690697, 37.76872722009913]],
    [ "1089906324",[-87.17468276190661, 37.76739257657208]],
    [ "Hayward Substation",[-80.6658587034089, 27.865634612097832]],
    [ "1089980814",[-74.54290874637209, 41.84345256370628]],
    [ "1089980818",[-74.04713386516721, 41.84759792037882]],
    [ "1089980822",[-75.32697582088053, 43.6139049561801]],
    [ "Steel Dynamics Substation",[-97.44598209456225, 28.056829622223553]],
    [ "American Electric Power",[-97.4384508583222, 28.044256231525942]],
    [ "1090202356",[-95.55747965696891, 35.36472099264579]],
    [ "Interstate Substation",[-80.4472370886548, 27.491490080128557]],
    [ "1090378542",[-96.24293123285732, 37.22783571004828]],
    [ "Brannon Stand Substation",[-85.48742976685507, 31.208328354132302]],
    [ "Huntsville Utilities",[-86.67657316985601, 34.65109955962244]],
    [ "Huntsville Utilities",[-86.66816215, 34.64945345]],
    [ "Huntsville Utilities",[-86.64826749999999, 34.65187025]],
    [ "Huntsville Utilities",[-86.63171912463756, 34.65373999324355]],
    [ "1090771125",[-80.87130357447136, 35.059051693774464]],
    [ "1090771210",[-80.61423274097328, 35.01225982302636]],
    [ "1090771278",[-80.34057771386638, 35.21547698820465]],
    [ "1090778800",[-80.51170092709584, 34.83780810313442]],
    [ "1090852340",[-81.02557450081123, 35.1898723477168]],
    [ "1090852362",[-81.01359466508688, 35.1471906872203]],
    [ "Rich Mountain Retail Substation",[-82.73676930535609, 35.174051357101156]],
    [ "1090885276",[-75.79532483536725, 41.803172226752835]],
    [ "1090889534",[-76.3030945, 36.927630150000006]],
    [ "1090891070",[-76.35099547853488, 36.87029770495395]],
    [ "Harkers Island Station",[-76.56482760000002, 34.69707205]],
    [ "Otway Station",[-76.56007779513604, 34.77758373558933]],
    [ "1090936603",[-76.65534492793932, 34.760388355379064]],
    [ "Kenilworth Substation",[-80.84840735466094, 35.19787714430337]],
    [ "1090963580",[-80.91142598409408, 35.29039616513261]],
    [ "1090963587",[-80.9750495115953, 35.35839803337831]],
    [ "1090963597",[-80.99739059999999, 35.323347]],
    [ "1090963598",[-81.00026064611052, 35.32404553265326]],
    [ "1090963610",[-81.04367455, 35.31585685]],
    [ "1090963614",[-81.01321775571789, 35.285549381986314]],
    [ "1090963615",[-81.0337666, 35.2469936]],
    [ "1090963620",[-81.0260808, 35.2897428]],
    [ "1090963622",[-81.1415172811638, 35.381189504808255]],
    [ "1090963623",[-81.13669216590189, 35.37269103303932]],
    [ "1090963624",[-81.18584630179608, 35.38145621584538]],
    [ "Panguitch Substation",[-112.43685379029168, 37.82552232513812]],
    [ "1090996988",[-80.98321491003736, 35.237568623480875]],
    [ "1090996994",[-80.88751384999999, 35.27905919999999]],
    [ "1090996997",[-80.86427395, 35.29377665]],
    [ "1090996998",[-80.88260382030727, 35.284686362760404]],
    [ "1090996999",[-80.87906873522579, 35.2807335972089]],
    [ "1090997014",[-81.04335075941141, 35.278184470897195]],
    [ "1090997025",[-81.0127162, 35.24026429999999]],
    [ "1091061343",[-96.26764696292291, 34.62571392616503]],
    [ "1091061351",[-95.86532890924363, 34.70282208122534]],
    [ "1091061603",[-86.47491065, 37.7791841]],
    [ "1091082114",[-81.13275366054478, 35.223517933173476]],
    [ "1091082132",[-81.06735757832875, 35.19987625490301]],
    [ "1091082134",[-81.06344808752914, 35.246883285266705]],
    [ "1091082138",[-81.07613935, 35.25991115000001]],
    [ "1091082139",[-81.06212887908886, 35.233367110084124]],
    [ "1091082155",[-81.1995552377796, 35.25821927515732]],
    [ "1091082161",[-81.2158072, 35.28002445]],
    [ "1091082168",[-81.25636373937671, 35.28917487503721]],
    [ "1091082169",[-81.23636470000002, 35.286259400000006]],
    [ "1091082182",[-81.31144473339614, 35.2795065958483]],
    [ "1091082184",[-81.30850670322017, 35.27844785089647]],
    [ "1091082186",[-81.33964976488254, 35.32673438181612]],
    [ "1091082187",[-81.34070745000001, 35.3276736]],
    [ "1091082189",[-81.34063134999998, 35.3252355]],
    [ "1091082192",[-81.36585936782076, 35.32197252618076]],
    [ "1091082195",[-81.3160812594966, 35.34356872125858]],
    [ "1091082199",[-81.36198304092746, 35.38559805885513]],
    [ "1091128477",[-112.36913244482335, 33.4106108757325]],
    [ "International Paper Company",[-88.45963417068153, 33.358809089118516]],
    [ "1091132349",[-96.44224020593366, 34.612165239395004]],
    [ "1091133333",[-112.39291609980003, 33.56774462890089]],
    [ "1091189322",[-81.25116885798626, 35.26942018011153]],
    [ "1091189335",[-81.14150434708691, 35.2781442533902]],
    [ "1091189339",[-81.08758016694176, 35.26997775182128]],
    [ "1091189341",[-81.08891986433737, 35.275106592933845]],
    [ "1091189344",[-81.10414196691094, 35.27082700155202]],
    [ "1091189347",[-81.12281045, 35.27922259999999]],
    [ "1091189360",[-81.15664036861925, 35.26335413241689]],
    [ "1091189368",[-81.1290560396364, 35.289818340959506]],
    [ "1091189371",[-81.12484198442083, 35.29233623222996]],
    [ "1091189374",[-81.09501195, 35.276510599999995]],
    [ "1091189376",[-81.12733204999998, 35.28681305]],
    [ "1091189378",[-81.04018384791412, 35.29766303301325]],
    [ "1091189403",[-81.18451758604533, 35.32341626352755]],
    [ "1091189406",[-81.20400567939592, 35.39978575569923]],
    [ "1091189409",[-81.21701539785826, 35.39551879287447]],
    [ "1091189413",[-81.2269155101307, 35.45466147394971]],
    [ "Brooks Substation",[-83.28976711357892, 42.485974299687044]],
    [ "1091376291",[-80.76781915, 35.301342649999995]],
    [ "1091523789",[-81.61879147177832, 35.323574474545445]],
    [ "1091523791",[-81.59372617568926, 35.318790613655814]],
    [ "1091523793",[-81.61376981963075, 35.314648937365725]],
    [ "1091523802",[-81.54390657462679, 35.28506980774275]],
    [ "1091523807",[-81.56816155, 35.2884173]],
    [ "1091523811",[-81.58460222462284, 35.30797288531829]],
    [ "1091523812",[-81.58325788082928, 35.307660934902245]],
    [ "1091523816",[-81.60195002343926, 35.290620742913546]],
    [ "1091572902",[-81.52194432215825, 35.30377773849078]],
    [ "1091572909",[-81.49911606784798, 35.382834714722065]],
    [ "1091572911",[-81.50099424999999, 35.385442499999996]],
    [ "1091572920",[-81.50436199884292, 35.5160949170177]],
    [ "1091572922",[-81.47275675000002, 35.568316949999996]],
    [ "1091572924",[-81.47607375, 35.637225099999995]],
    [ "1091572927",[-81.53104100710313, 35.66600397458608]],
    [ "1091572929",[-81.4525892828473, 35.66248955156824]],
    [ "1091572932",[-81.34419831959333, 35.54957478963862]],
    [ "1091572934",[-81.68098775, 35.47470685]],
    [ "1091572938",[-81.66453026719593, 35.43123297398141]],
    [ "Lawndale Substation",[-81.56645913822875, 35.41119235069842]],
    [ "1091572940",[-81.48124563105674, 35.42368432044902]],
    [ "1091572949",[-81.50884305983338, 35.4707466834635]],
    [ "1091572950",[-81.42355585807675, 35.49768993014614]],
    [ "1091596628",[-85.76799116536795, 37.318004757685024]],
    [ "1091596631",[-85.89458407930418, 37.531635556927654]],
    [ "Lebanon West Substation",[-85.3173868884862, 37.57469443713622]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.27126410734367, 37.548853037461505]],
    [ "Blue River Substation",[-122.32017383924996, 44.15274931410927]],
    [ "1091654277",[-81.39485190347973, 35.274396417564]],
    [ "1091654293",[-81.3860887135029, 35.37554279115498]],
    [ "1091654294",[-81.38521893033919, 35.37679268460073]],
    [ "1091654295",[-81.38478968302368, 35.37675390054066]],
    [ "Kings Mountain City Substation #1",[-81.33992796517468, 35.24604043069509]],
    [ "1091654302",[-81.34000655007404, 35.24525347274796]],
    [ "1091654304",[-81.34055356943286, 35.246618442892576]],
    [ "1091659827",[-91.32219087689388, 39.915011470530835]],
    [ "1091662596",[-91.63524442064062, 38.34808849116486]],
    [ "1091693766",[-81.12911710302555, 35.195842917336805]],
    [ "1091693767",[-81.08575592566618, 35.168898493728996]],
    [ "1091693769",[-81.12021412144459, 35.24004906993678]],
    [ "1091693772",[-80.97244202450844, 35.36186876722994]],
    [ "1091742568",[-85.44290904999998, 31.15404549999999]],
    [ "Frazier Substation",[-79.75232834283551, 40.09419946519261]],
    [ "1091840624",[-80.74158792474364, 35.23808142724896]],
    [ "1091840631",[-80.74177204902242, 35.20456061597869]],
    [ "1091840657",[-80.86014112859657, 35.224126173094646]],
    [ "1091840666",[-80.69279067262922, 35.31009852383635]],
    [ "1091840668",[-80.63561106689744, 35.23350418070311]],
    [ "1091840695",[-80.37471818954178, 35.30946601761437]],
    [ "1091840698",[-80.53659311010401, 35.21767116614219]],
    [ "1091840699",[-80.52955549999999, 35.21995035]],
    [ "1091840700",[-80.52957177950651, 35.2203228074783]],
    [ "1091865023",[-82.51165759493176, 29.78229493133621]],
    [ "Plum Substation",[-82.29220586748902, 30.006216258604447]],
    [ "Crawford Substation",[-81.9010880905146, 30.51784825978139]],
    [ "1091917980",[-94.4486022, 35.288489750000004]],
    [ "1091924343",[-94.629752963782, 35.11511173111967]],
    [ "1091924345",[-94.65614738315045, 35.11301221650319]],
    [ "Rocket Substation",[-80.67214404376881, 28.527484653878602]],
    [ "Flat Rock",[-75.07411560716697, 44.22166046561795]],
    [ "Cheyenne Sustation",[-95.47172382971615, 39.56698504341557]],
    [ "Kingfisher Substation",[-95.54500471815207, 39.81844950256085]],
    [ "Wathena Substation",[-94.95937462223665, 39.75951391336842]],
    [ "TC Severance Substation",[-95.13559701389705, 39.71900039981723]],
    [ "TC Energy Corporation",[-95.13515519999999, 39.71900115]],
    [ "East Nemaha Substation",[-95.82736237661163, 39.82214107365958]],
    [ "TC Energy Corporation",[-96.05296527918904, 39.868068066653535]],
    [ "Marshall Wind Farm",[-96.37116831539356, 39.8251364244301]],
    [ "1092216039",[-85.81528836572711, 31.711431075905143]],
    [ "Pirolo Substation",[-81.01081618476887, 29.046393646293087]],
    [ "Dothan Distribution Substation",[-85.4365486404994, 31.247630675683403]],
    [ "Chicago Boulevard Substation",[-83.18717127789135, 42.36581662467706]],
    [ "1092257719",[-96.0116076, 41.71146235]],
    [ "Meeksville Substation",[-86.0064750765891, 31.90212990191506]],
    [ "1092273904",[-80.19865290000001, 35.113291]],
    [ "1092306859",[-89.93923623217877, 38.599136631011866]],
    [ "1092413200",[-112.14557289103409, 33.77850863527638]],
    [ "Slocomb Substation",[-85.57961745000001, 31.11260335]],
    [ "1092444959",[-85.51886744999999, 31.132037600000004]],
    [ "Rehobeth Substation",[-85.46474681603969, 31.11043038264067]],
    [ "1092445051",[-79.16923678480289, 34.92997448971823]],
    [ "Williams Sawmill Substation",[-79.1557620135339, 35.01449910532593]],
    [ "Buffalo Springs Substation",[-79.3709204149089, 34.97832218724959]],
    [ "Wagram Substation",[-79.44387475, 34.891945650000004]],
    [ "Scotland Acres Substation",[-79.40023836186857, 34.8171340833665]],
    [ "Dale County Switching Station",[-85.59439352645475, 31.305898330742412]],
    [ "Bay Springs Substation",[-85.52602279999998, 31.192163]],
    [ "CenterPoint Energy",[-87.27970045173194, 38.20055839928581]],
    [ "1092532342",[-79.43017787617613, 34.66439336277314]],
    [ "1092532344",[-79.45005887020561, 34.7640136479013]],
    [ "1092532348",[-79.53681851353139, 34.80357144118902]],
    [ "1092587962",[-76.7316759096443, 34.82366617230904]],
    [ "Knoxville Utilities Board",[-84.23487433142195, 35.99780190274847]],
    [ "Wertzville Substation",[-77.04347083514783, 40.27099102977196]],
    [ "1092672277",[-91.80564315000001, 36.696547100000004]],
    [ "1092719585",[-85.58070135000001, 31.3157668]],
    [ "LaSalle",[-114.23302021542848, 48.31301961768189]],
    [ "West Valley",[-114.39610474512216, 48.24003150879447]],
    [ "Whitefish Substation",[-114.33356756571185, 48.405763423945864]],
    [ "Hepburn Substation",[-77.05489015, 41.2806501]],
    [ "1092824590",[-95.4313231, 29.2436597]],
    [ "1093148920",[-79.55829717507517, 36.66719372198504]],
    [ "1093186809",[-80.23387692687926, 35.290189702836145]],
    [ "1093186819",[-80.21700155104944, 35.33933796691644]],
    [ "Albemarle Substation",[-80.20535774608207, 35.35748483036203]],
    [ "1093186837",[-80.21310395538296, 35.41768717111147]],
    [ "1093186846",[-80.28892331878866, 35.46692496350662]],
    [ "Richfield Substation",[-80.28734326757636, 35.46718947409589]],
    [ "1093186850",[-80.28828155000001, 35.4676176]],
    [ "1093186870",[-80.37765971645331, 35.71276307364974]],
    [ "1093186890",[-80.48479681240774, 35.48616061035182]],
    [ "1093208990",[-80.77754404999999, 35.31047595]],
    [ "Big Mountain",[-114.35591327454108, 48.45360754114077]],
    [ "1093273594",[-88.14417892463597, 44.885986658908344]],
    [ "1093275839",[-88.14715437066718, 44.876476963861386]],
    [ "1093275842",[-88.14474652480631, 44.88114990580131]],
    [ "1093291425",[-113.90629629157723, 33.850990182153396]],
    [ "1093294100",[-80.55255967189926, 35.38001147066121]],
    [ "1093294102",[-80.60308637077316, 35.379032703694335]],
    [ "1093294109",[-80.58953537232674, 35.38625091138567]],
    [ "1093294111",[-80.57716371681812, 35.38613895110599]],
    [ "1093440063",[-88.05365614999998, 44.8571235]],
    [ "1093451419",[-89.58558815172162, 41.2573524503917]],
    [ "1093451424",[-89.5880105748931, 41.27116684458803]],
    [ "1093451425",[-89.58473728945725, 41.23203137986515]],
    [ "1093454134",[-90.78898524963842, 40.611847621509]],
    [ "1093454136",[-90.79120447063782, 40.52961211826162]],
    [ "Bradevelt Substation",[-74.24659710409652, 40.333747735628265]],
    [ "1093494493",[-106.5225059178701, 35.04160801545739]],
    [ "1093557381",[-91.42268974999999, 40.414287699999996]],
    [ "Roquette Substation",[-91.3951091171042, 40.3892959397667]],
    [ "1093616829",[-88.9963616428364, 40.88865998267903]],
    [ "1093618755",[-89.04716330242145, 40.5887370592222]],
    [ "EDP Renewable North America",[-88.70657160382225, 40.71320099354124]],
    [ "Commonwealth Edison",[-88.70607697785859, 40.71442594922758]],
    [ "Invenergy",[-88.73353206174853, 40.67652767055453]],
    [ "1093621332",[-88.44653313563882, 40.96254219408361]],
    [ "1093621334",[-88.44732726957446, 40.961834416401516]],
    [ "Newbern Substation",[-87.53336390985196, 32.60244537486508]],
    [ "1093678450",[-87.56866745, 32.5656677]],
    [ "1093682765",[-87.59242869999999, 32.689433400000006]],
    [ "New Rice County Substation",[-98.34116537972822, 38.43344329096498]],
    [ "1093790500",[-87.33327225, 39.28553994999999]],
    [ "1094111846",[-95.7150814278763, 35.435451173089945]],
    [ "1094324822",[-86.6980367438174, 41.53334561609373]],
    [ "1094339554",[-86.7474805250181, 41.684694893709114]],
    [ "West Woodbourne Substation",[-74.60812611333216, 41.75651651207148]],
    [ "NYSEG",[-74.73672228954139, 41.769669848420754]],
    [ "1094446366",[-95.76113484094763, 29.066538112251834]],
    [ "1094589173",[-92.21469001425497, 34.79327189861098]],
    [ "Napier Field Substation",[-85.45608965151395, 31.313187446881926]],
    [ "1094641547",[-85.59083939999998, 31.109307849999993]],
    [ "Monticello Substation",[-74.68480075198974, 41.643850178120225]],
    [ "1094783438",[-74.73276111633399, 41.64115779712244]],
    [ "1094783440",[-74.73315873749533, 41.64145957168938]],
    [ "Dixon Substation",[-121.82621853981955, 38.445073390663275]],
    [ "Thayer",[-87.31308174477373, 41.17426923623814]],
    [ "1095049906",[-87.05930750744704, 40.67830326876143]],
    [ "Fair Oaks Substation",[-87.27494141652086, 41.07074695009578]],
    [ "1095052153",[-115.53403275989763, 32.759309924806125]],
    [ "1095204219",[-82.37130025409108, 34.44521354285416]],
    [ "1095204222",[-82.2689643, 34.3671803]],
    [ "1095220111",[-85.82914401122851, 31.320863574875446]],
    [ "1095220114",[-85.83603677615199, 31.299795354339008]],
    [ "1095274573",[-86.22529017944379, 38.5936219397519]],
    [ "1095290568",[-81.53998925790474, 37.782597775905536]],
    [ "1095293403",[-87.27854163246217, 40.762764308432935]],
    [ "1095331585",[-105.38255406269487, 34.40997581379748]],
    [ "1095331596",[-105.35330581999109, 34.297848785434304]],
    [ "Western Spirit Switchyard",[-105.66064464266012, 34.630688705375896]],
    [ "1095349285",[-105.65115467518902, 34.61657451905101]],
    [ "1095349296",[-105.70096876728091, 34.83731862367474]],
    [ "1095349331",[-105.49327352578956, 34.39321526575998]],
    [ "1095349357",[-104.58154903332937, 33.963530750036206]],
    [ "Mt. Gilead Substation",[-80.00944591611045, 35.21933049360171]],
    [ "Mount Gilead Industrial Substation",[-79.97640636522549, 35.25339762851102]],
    [ "1095364214",[-80.119849480916, 35.408724855650874]],
    [ "1095364217",[-80.17504066046858, 35.48562427927609]],
    [ "1095364222",[-80.14511146654128, 35.51851754663296]],
    [ "1095364225",[-80.01277479503271, 35.552777907929446]],
    [ "Denton Substation",[-80.12110591288364, 35.6446185650964]],
    [ "Pleasant Hill Substation",[-80.04115123058074, 35.80214440303545]],
    [ "1095371302",[-80.17238860209025, 35.921784382758894]],
    [ "1095371304",[-80.08465120000001, 36.03846145]],
    [ "1095371308",[-80.22591729951888, 35.924020225706776]],
    [ "1095371310",[-80.26264205086757, 35.927729953675026]],
    [ "1095378321",[-91.33952411512965, 37.001355318054365]],
    [ "1095393944",[-80.07754625868571, 35.82416749548146]],
    [ "Duke Energy",[-80.07622269691211, 35.88004201688109]],
    [ "City of Lexington",[-80.24241435734822, 35.8311099102859]],
    [ "1095393980",[-80.26536784651572, 35.80745528600817]],
    [ "Cotton Grove Substation",[-80.25893382385621, 35.77251197862115]],
    [ "1095393996",[-80.4592169, 35.662399650000005]],
    [ "1095393999",[-80.45277110786678, 35.677517529378264]],
    [ "1095394000",[-80.44047335000002, 35.675003700000005]],
    [ "1095434697",[-97.77097006424492, 26.298521430633112]],
    [ "1095440435",[-97.65945414934437, 26.539832509734442]],
    [ "1095449652",[-89.74183594132715, 43.46626812476749]],
    [ "1095461085",[-80.61196117736523, 35.51114946057654]],
    [ "1095461105",[-80.8023723265324, 35.39292101131991]],
    [ "1095461107",[-80.82457440000002, 35.3887535]],
    [ "1095461109",[-80.83239855274125, 35.38335980328964]],
    [ "1095461141",[-80.81570517405932, 35.37027903938128]],
    [ "1095461161",[-80.83843047013394, 35.30750160323054]],
    [ "1095461170",[-80.88882380425304, 35.37818311359579]],
    [ "1095461205",[-80.87366801336272, 35.44779952812076]],
    [ "1095466306",[-95.55742320286983, 33.697983677455156]],
    [ "1095466314",[-95.5060607252978, 33.66601824033922]],
    [ "1095466317",[-95.38361976165233, 33.6412747197594]],
    [ "1095466318",[-95.34240333805447, 33.64295197848435]],
    [ "1095467493",[-95.62648205981726, 33.644144860012325]],
    [ "1095476653",[-81.23049460110647, 35.332572840720616]],
    [ "1095476656",[-81.25749055925513, 35.41260430767405]],
    [ "1095476657",[-81.26463028092468, 35.42699925973584]],
    [ "1095476691",[-81.35864790669906, 35.48129752920373]],
    [ "1095476694",[-81.10586443438861, 35.49758814693767]],
    [ "1095476695",[-81.06152170833397, 35.5120738720704]],
    [ "Orchard Tie Substation",[-81.27636757851953, 35.59767114547263]],
    [ "Hayes Substation",[-85.80290997159302, 31.353511652865205]],
    [ "1095484687",[-85.80703715000001, 31.3320879]],
    [ "Clayhatchee Subatation",[-85.74127429858352, 31.23423869026911]],
    [ "1095484694",[-85.85454719999998, 31.335460099999995]],
    [ "1095484695",[-85.85311574788503, 31.318137430673325]],
    [ "South Enterprise Substation",[-85.8514828, 31.25032195]],
    [ "1095484700",[-85.71672339133166, 31.30011972481923]],
    [ "1095494271",[-80.76338148745197, 35.31899798364675]],
    [ "Gunn Substation",[-72.68519354985109, 42.235962877720425]],
    [ "1095550340",[-81.22269087841677, 35.59868369153553]],
    [ "1095550348",[-81.1860625822945, 35.61279863275604]],
    [ "1095550383",[-81.37984306584302, 35.6370832460711]],
    [ "1095550393",[-81.24957522905537, 35.64493295435872]],
    [ "1095564837",[-81.23242331954515, 35.47599499486559]],
    [ "1095564841",[-81.19563652248742, 35.58124963233631]],
    [ "1095564844",[-81.21668814188214, 35.662976879771534]],
    [ "1095564847",[-81.2193341958758, 35.6660527777924]],
    [ "1095564860",[-81.20972333986086, 35.68245029361083]],
    [ "1095564862",[-81.22000800177508, 35.67196966669856]],
    [ "1095599205",[-81.30888363526053, 35.7276614549978]],
    [ "1095599229",[-81.25268270084507, 35.715805324324755]],
    [ "1095599253",[-81.207853, 35.736682200000004]],
    [ "1095649228",[-85.70108710505674, 31.086373075316235]],
    [ "1095649231",[-85.69109389999998, 31.101371399999998]],
    [ "1095649233",[-85.6950839491362, 31.1047770226175]],
    [ "1095655598",[-81.29413995, 35.712494150000005]],
    [ "1095655603",[-81.30251115, 35.71542405]],
    [ "1095655608",[-81.36486592596268, 35.73050376414663]],
    [ "1095655612",[-81.33926722535378, 35.72946134465612]],
    [ "1095677110",[-81.46893187200924, 35.80655754928796]],
    [ "1095677112",[-81.52666450364693, 35.862514036795645]],
    [ "1095677127",[-81.51941606219108, 35.86727222395571]],
    [ "1095736961",[-97.55666736581362, 28.218273270236928]],
    [ "1095737661",[-97.44471960008833, 28.198990613035573]],
    [ "1095740610",[-97.95334835241725, 28.576356480483234]],
    [ "1095767599",[-89.16526086636752, 37.376677174939914]],
    [ "1095775971",[-110.52211479253495, 41.29498708053958]],
    [ "1095855689",[-81.43219202780243, 35.797177718349054]],
    [ "1095855691",[-81.30610387044163, 35.84178021543321]],
    [ "1095855692",[-81.3755973889825, 35.860682710889435]],
    [ "1095855694",[-81.37441855, 35.86383754999999]],
    [ "1095855695",[-81.42925806004845, 35.77081508391869]],
    [ "1095855700",[-81.48271565694098, 35.785811718777765]],
    [ "Granite Falls Substation",[-81.44583213947563, 35.802741114941504]],
    [ "1095855708",[-81.38349638945309, 35.818381979690095]],
    [ "1095855709",[-81.45576410995406, 35.83258048550847]],
    [ "1095855711",[-81.4832372, 35.8299301]],
    [ "1095855714",[-81.49085109999999, 35.8392078]],
    [ "1095855716",[-81.49553493242014, 35.850597453194354]],
    [ "1095855718",[-81.51694445, 35.87412815]],
    [ "1095887758",[-81.51210823852313, 35.91624326630509]],
    [ "1095887760",[-81.54742054999998, 35.9020222]],
    [ "1095887762",[-81.54059315, 35.932143249999996]],
    [ "1095887766",[-81.54364407216133, 35.92861082241729]],
    [ "1095887767",[-81.54297979898642, 35.92836640896095]],
    [ "1095887768",[-81.5640706328218, 35.98094720442311]],
    [ "1095887774",[-81.55648327461796, 35.8989731568262]],
    [ "1095887775",[-81.55838621434313, 35.89973091841092]],
    [ "1095931892",[-79.44722288407029, 35.142015967482834]],
    [ "1095931895",[-79.34460313000822, 35.241112942612354]],
    [ "1095931900",[-79.45058985497975, 35.54260260048357]],
    [ "1095931903",[-79.57166521429329, 35.4095891711748]],
    [ "Candor Substation",[-79.72405671716125, 35.305131316171]],
    [ "1096084056",[-79.81093974968901, 35.608296456829095]],
    [ "1096084065",[-79.96626772305618, 35.33269698172215]],
    [ "1096249713",[-103.75462127060486, 33.403912093790225]],
    [ "1096430654",[-86.79277105100768, 33.503846945874216]],
    [ "Chadbourn Substation",[-78.8326209379723, 34.307012019548864]],
    [ "1096475520",[-78.90317637430118, 34.392837764281296]],
    [ "White Marsh Substation",[-78.67572336258732, 34.419969895755955]],
    [ "Brunswick EMC",[-78.77037988477856, 34.39575510345448]],
    [ "Whiteville SE Regional Park Substation",[-78.77223097573193, 34.3351337787471]],
    [ "1096475527",[-78.77620068384881, 34.32739160097061]],
    [ "1096475531",[-78.67574206498415, 34.24075740494921]],
    [ "Brunswick EMC",[-78.60254869228972, 34.154902364885864]],
    [ "1096475535",[-78.51951224348149, 34.0578690342394]],
    [ "1096475536",[-78.68883367524224, 34.32638430848019]],
    [ "Brunswick EMC",[-78.4091572472819, 33.92401364618652]],
    [ "1096655684",[-78.44798513840242, 33.90213002373403]],
    [ "1096655687",[-78.50791447509884, 33.91464920563404]],
    [ "1096655689",[-78.49769794999999, 33.896392549999995]],
    [ "1096655690",[-78.55711868643114, 33.905698269148765]],
    [ "Brunswick EMC",[-78.58654247261815, 33.9330602961884]],
    [ "1096655700",[-78.29675820636493, 33.92658839858292]],
    [ "1096680547",[-78.13066231518155, 34.093724940126876]],
    [ "1096680555",[-78.33196049628316, 34.04453563254804]],
    [ "1096692755",[-78.05303802799176, 34.253509813009515]],
    [ "1096692804",[-77.96213783722375, 34.145023823566994]],
    [ "1096692805",[-77.98808926817651, 34.12867407531257]],
    [ "1096796898",[-78.61483404973353, 34.82313426255781]],
    [ "Guyton Substation",[-78.75589513817778, 34.63164913236415]],
    [ "Four County EMC",[-78.81156489287163, 34.566476658192755]],
    [ "Ingold Substation",[-78.3167945146603, 34.83931448415159]],
    [ "Rose Hill Substation",[-78.02991559408702, 34.81617877314577]],
    [ "Murphey Substation",[-77.9415549889354, 34.80539483309825]],
    [ "Four County EMC",[-77.95798032809473, 34.76980003697189]],
    [ "Four County EMC",[-77.7685646345034, 34.827868713862195]],
    [ "Four County EMC",[-78.18850611356214, 35.01132620194362]],
    [ "1096796930",[-78.39277768638809, 34.704991324810315]],
    [ "Plymouth Wind Farm",[-95.93274883868368, 42.76496636992548]],
    [ "Plymouth Wind Farm",[-95.93460398016995, 42.76491745774283]],
    [ "Holliday Creek Solar",[-94.09390816610046, 42.56934621718418]],
    [ "1096923321",[-77.97691298335137, 34.67615313890873]],
    [ "1096923324",[-78.00408348130293, 34.61656346286367]],
    [ "Six Forks Substation",[-77.88843574762382, 34.60047221990692]],
    [ "Four County EMC",[-77.71410703640711, 34.671587068124396]],
    [ "Indiana Michigan Power",[-86.25577465919281, 41.81438753550523]],
    [ "Northwest Iowa Power Cooperative",[-95.1311059806036, 42.008485712085964]],
    [ "1097170329",[-80.97997498831836, 32.62141869688063]],
    [ "1097170331",[-81.12118146752677, 32.367094965514504]],
    [ "Jack Primus Substation",[-79.90448898175678, 32.91937716786978]],
    [ "Deer Run Substation",[-86.63364121086579, 41.518607420483065]],
    [ "Lyons Substation",[-98.18243033435854, 38.345929525000656]],
    [ "Saxman Substation",[-98.19212325553461, 38.28999461708689]],
    [ "1097486475",[-80.37095539720201, 34.197453127368995]],
    [ "1097486476",[-80.29284165179945, 34.205608477202716]],
    [ "Capps Switching Station",[-85.28460657327197, 31.492191273543]],
    [ "1097588158",[-85.30256075000001, 31.40875090000001]],
    [ "Headland Substation",[-85.41507463044464, 31.404279483499103]],
    [ "SRP University Substation",[-111.86124852164002, 33.42157529764993]],
    [ "1097720708",[-81.08043588510498, 35.265590631951596]],
    [ "1097805370",[-82.05447467339735, 33.75081224906069]],
    [ "1097842833",[-85.60055385000001, 31.443902249999997]],
    [ "1097842834",[-85.62704017509512, 31.43373790719627]],
    [ "1097842837",[-85.60134655, 31.3778846]],
    [ "1097865052",[-87.53387468094186, 33.21410385433924]],
    [ "1097883112",[-117.06903894716822, 40.713931106248246]],
    [ "1097883113",[-117.07156136500046, 40.71384603628726]],
    [ "1098144763",[-77.24537855154121, 34.998469085034586]],
    [ "Unifi, Inc.",[-79.69833023643596, 36.35216306785893]],
    [ "CPC Witt Substation",[-79.39627345000001, 36.67875910000001]],
    [ "Colonial Pipeline Company",[-79.10168953347086, 36.9285816277733]],
    [ "Elderberry Substation",[-86.47902526900965, 41.700032073727954]],
    [ "Elderberry Substation",[-86.48026954971469, 41.70003765243759]],
    [ "1098384271",[-87.02731739044974, 41.462274956539225]],
    [ "Cleveland Utilities",[-84.85995865987087, 35.21124011283416]],
    [ "1098611835",[-77.46005007599753, 41.1236536327042]],
    [ "Flemington Substation",[-77.45977385, 41.12527645]],
    [ "1098742170",[-85.79133304999999, 32.85551515000001]],
    [ "1098744259",[-85.82767571186135, 32.72197586674687]],
    [ "1098747858",[-86.05151617490361, 32.69558599400527]],
    [ "1098749103",[-86.14227014999999, 32.63994284999999]],
    [ "1098751999",[-85.9439419278998, 32.67415626237974]],
    [ "1098760460",[-85.61762820000001, 33.25699315000001]],
    [ "Wadley Substation",[-85.55201531174549, 33.126369220101054]],
    [ "Roanoke Substation",[-85.38522060000001, 33.16873975]],
    [ "1098777680",[-85.31019401311057, 33.161850828015055]],
    [ "1098794188",[-85.36495473686506, 33.04745777390184]],
    [ "1098795722",[-93.79641598319851, 37.718379099566704]],
    [ "Stockton Substation",[-93.77049452638754, 37.69508866454292]],
    [ "KAMO Power",[-93.64173563386554, 38.03636297418534]],
    [ "1098795733",[-93.30542358710527, 37.74895346267672]],
    [ "1098795740",[-93.31186352002385, 37.833776806122934]],
    [ "1098796645",[-85.3693912, 33.006145950000004]],
    [ "LaFayette Substation",[-85.38879381186726, 32.89974035760927]],
    [ "1098800893",[-85.39136087023572, 32.87445315927726]],
    [ "1098800895",[-85.39075648149047, 32.87434063397127]],
    [ "Medical District Substation",[-86.576848575794, 34.72246524215792]],
    [ "Huntsville Utilities",[-86.5845146746889, 34.72135101143331]],
    [ "1098890614",[-85.68714263497593, 32.50792195807229]],
    [ "IP&L Substation K",[-94.35865870842343, 39.05228868195222]],
    [ "Albion Road Substation",[-69.50907579962411, 44.574038469084655]],
    [ "1099377845",[-69.61176528612928, 44.582385667011906]],
    [ "Lakewood Substation",[-69.73892552336386, 44.80488362753132]],
    [ "County Road Substation",[-69.67701078103381, 44.57340788208686]],
    [ "1099438317",[-81.02419732256872, 40.45735136015391]],
    [ "Ozarks Electric Cooperative Corporation",[-94.26023756988845, 36.16279075299527]],
    [ "Sand Hills Substation",[-74.55324591584662, 40.402778397771016]],
    [ "1099595747",[-82.74795971295626, 31.719806547491643]],
    [ "1099595748",[-82.74938810389767, 31.720396728506422]],
    [ "1099636774",[-88.54893778310472, 43.980297931720756]],
    [ "Cumberland Peaking Generation Substation",[-74.9662801139934, 39.37608349750404]],
    [ "Dennis Substation",[-74.74083902823496, 39.195128332779454]],
    [ "1099675195",[-87.30698697473069, 40.86627284338191]],
    [ "Oldman Substation",[-75.42538572710237, 39.7674220646765]],
    [ "Geon Substation",[-75.42506144600618, 39.76540539355799]],
    [ "East Geneva Substation",[-85.89217561084519, 31.044379471448096]],
    [ "Geneva East Substation",[-85.8625860923734, 31.033867480229073]],
    [ "1099722390",[-85.83115920000002, 31.03813385]],
    [ "1099729674",[-81.20428123305825, 40.447101310024394]],
    [ "Waynesville Substation",[-81.77547873259012, 31.229987226991497]],
    [ "Eagle Generation",[-75.15622459132882, 39.8719542304404]],
    [ "Robeson LNG Substation",[-79.27871920851771, 34.797017482164996]],
    [ "1099784318",[-87.29350109999999, 40.750850750000005]],
    [ "1099793085",[-77.27177801333409, 34.95884129924321]],
    [ "1099794561",[-108.61902368254138, 45.768710475102516]],
    [ "1099838254",[-82.68733499694606, 29.63606728027713]],
    [ "Powerline Substation",[-82.61430530247384, 28.964801222324052]],
    [ "1099901524",[-82.20330223073569, 29.027040687047382]],
    [ "1099901540",[-82.09517149602512, 29.126288164888706]],
    [ "1099901544",[-82.15956251243173, 29.20469498037021]],
    [ "1099901546",[-82.1779937463132, 29.26753619175331]],
    [ "1099901550",[-82.20440825, 29.290982499999995]],
    [ "Lincoln 3/Clayville Substation",[-75.01825916517974, 39.425909146491215]],
    [ "Lincoln/Clayville Substation",[-75.0190425523776, 39.42511096460709]],
    [ "Kuser Road Substation",[-74.70172081590714, 40.20904218485884]],
    [ "Hamilton Substation",[-74.71886853426591, 40.246223378008246]],
    [ "Texas Ave Substation",[-74.72539126769544, 40.26048585499874]],
    [ "Village Road Substation",[-74.63044010170505, 40.28121871585326]],
    [ "1099919574",[-82.3565887368528, 29.635982046123424]],
    [ "Steer Substation",[-81.83274917777184, 29.615545785116964]],
    [ "Sea Isle Substation",[-74.70050960269474, 39.157575335852165]],
    [ "ReEnergy Stratton Substation",[-70.42480151709799, 45.14073979445296]],
    [ "1099940844",[-91.91557277707498, 45.10365818247531]],
    [ "Knapp",[-91.98626504198769, 44.963525794400205]],
    [ "Tainter",[-91.79279707230076, 44.970823995744404]],
    [ "1099951404",[-91.12748958030217, 45.22352039054771]],
    [ "1099951405",[-91.12713541104327, 45.22302054472343]],
    [ "1099951410",[-90.85680564816745, 45.11886828282791]],
    [ "1099951417",[-91.15265599478819, 45.16482737691642]],
    [ "1099951418",[-91.20420423839997, 45.10330037032156]],
    [ "1099951422",[-91.26989189400211, 45.05044137192326]],
    [ "Evergy",[-94.3996110248081, 39.14490984174367]],
    [ "Sugar Creek Substation",[-94.44593133160406, 39.10835088292338]],
    [ "Marcus Hook Substation",[-75.41590811869567, 39.82103561761334]],
    [ "Lenni Substation",[-75.44273681289427, 39.89410508105052]],
    [ "1099957932",[-87.26635355, 40.73024905]],
    [ "1099961152",[-91.41795396311325, 45.070781469055426]],
    [ "1099963614",[-91.55761127272447, 45.19433249542606]],
    [ "New Auburn Substation",[-91.4389487, 45.199692299999995]],
    [ "1099963956",[-91.51162209159226, 45.120598779129466]],
    [ "1099964364",[-91.71871079999998, 45.05335875000001]],
    [ "1099968130",[-92.04324203570235, 45.36005457625531]],
    [ "1099968135",[-91.59393890808117, 45.24972501566389]],
    [ "1099968138",[-91.59755814455511, 45.25467828477382]],
    [ "1099992753",[-82.4141833353428, 29.48457056814988]],
    [ "1099992754",[-82.3450389813525, 29.24632204983956]],
    [ "1099992757",[-82.26958798898879, 29.259778925036066]],
    [ "1099992759",[-81.74292490818102, 29.370378249178092]],
    [ "1099992760",[-81.05905770275255, 29.270215259766456]],
    [ "1100555012",[-90.20670126312109, 34.83047434176703]],
    [ "Hardwick Substation",[-72.37280914999998, 44.4934017]],
    [ "Citrus Hills Electric Substation",[-82.41437679999999, 28.8986416]],
    [ "Pine Ridge Substation",[-82.46952649999999, 28.920356050000002]],
    [ "1100696350",[-82.36833050164033, 28.847042546987538]],
    [ "1100696359",[-82.57593532286589, 28.86471139431872]],
    [ "1100696360",[-82.58013634999999, 28.8070204]],
    [ "1100696363",[-82.34085134324542, 28.810097810334167]],
    [ "1100696364",[-82.28186304474909, 28.72462787509749]],
    [ "1100696387",[-82.47367072280056, 28.638455041233886]],
    [ "1100696388",[-82.47250394270934, 28.644626712788636]],
    [ "1100696389",[-82.47190392473014, 28.644626237332087]],
    [ "1100696392",[-82.44739204302925, 28.62319947065156]],
    [ "1100696394",[-82.51728189949652, 28.73179263676362]],
    [ "1100696395",[-82.51766598824646, 28.7635369]],
    [ "1100696399",[-82.43554932219081, 28.591786097041396]],
    [ "1100700180",[-82.50370547092751, 28.865890996038146]],
    [ "1100700185",[-82.48948926413117, 28.471640324920692]],
    [ "1100707936",[-87.29604884058199, 40.77230042502782]],
    [ "Omaha Public Power District",[-95.92348535667816, 41.25167879010581]],
    [ "Crimson Oak Grove Resources, LLC",[-87.1709159, 33.467293250000004]],
    [ "American Cement Switching Station",[-82.0216644668244, 28.756699116512912]],
    [ "1101018576",[-82.05065511839915, 28.756461248682182]],
    [ "1101018595",[-81.88910147510157, 28.739913636917848]],
    [ "1101018603",[-81.840821073769, 28.696165590213887]],
    [ "1101018605",[-81.76129584141218, 28.66801802901809]],
    [ "1101018610",[-81.81819168766735, 28.633812038316393]],
    [ "1101018613",[-81.85165736659523, 28.562031359487037]],
    [ "1101018614",[-81.85099304381843, 28.56189917139539]],
    [ "1101018618",[-81.83955617296603, 28.509816558672313]],
    [ "1101018621",[-81.73269508591174, 28.70362026867025]],
    [ "1101045763",[-81.73312552485083, 28.608902559343758]],
    [ "1101045774",[-81.57244125, 28.56462145]],
    [ "1101045783",[-81.74347119148021, 28.371995375150455]],
    [ "1101071086",[-99.64539035, 45.46380190000001]],
    [ "1101189600",[-80.8395664641155, 35.750976775357266]],
    [ "1101191451",[-100.34891030888194, 44.41227727504392]],
    [ "1101204072",[-69.80014051291704, 44.089292528855424]],
    [ "Coopers Mills Road Substation",[-69.5565652978474, 44.29691321472778]],
    [ "Reliance Substation",[-99.6070983751761, 43.88002105396536]],
    [ "1101417556",[-79.65873367692936, 36.11441960822705]],
    [ "1101417581",[-78.97732057272744, 36.3476820852209]],
    [ "Monmouth Substation",[-69.99282475, 44.18881185000001]],
    [ "1101470295",[-93.58495469171419, 44.52916637536943]],
    [ "1101470296",[-93.58594111764788, 44.52937658452274]],
    [ "Waltham Road Substation",[-68.43368506759758, 44.580384666310515]],
    [ "1101488761",[-80.49194331641567, 35.6526587977342]],
    [ "1101488767",[-80.49244327130478, 35.68026431480011]],
    [ "1101488790",[-80.6084742021506, 35.71346422503269]],
    [ "1101488815",[-80.87792118561052, 35.698102478500815]],
    [ "1101488817",[-80.81267998924153, 35.673191080929236]],
    [ "1101488818",[-80.80537042410373, 35.60243590685537]],
    [ "1101488846",[-80.89458895, 35.7738582]],
    [ "1101488848",[-80.90893738316883, 35.777530098746794]],
    [ "1101488850",[-80.91506307489084, 35.786815854092254]],
    [ "1101488851",[-80.90761504880183, 35.78332786670339]],
    [ "1101488853",[-80.91044510060435, 35.783936933267086]],
    [ "1101488855",[-80.91071468723611, 35.76596973618306]],
    [ "1101488858",[-80.99435052340208, 35.771307655954494]],
    [ "1101501242",[-67.39889182916053, 44.627599086209464]],
    [ "Catawba Substation",[-81.07272431813617, 35.70872607299157]],
    [ "1101502398",[-81.09806445, 35.71360315]],
    [ "1101502405",[-80.96852883327247, 35.59407970061096]],
    [ "1101502410",[-81.0775793, 35.887617799999994]],
    [ "1101502415",[-81.15650146841446, 35.91698421042525]],
    [ "1101502418",[-80.94204898631784, 35.879647867928796]],
    [ "1101502421",[-80.81139550533194, 35.911058316891335]],
    [ "1101502422",[-80.81638017135064, 35.90565297917349]],
    [ "1101588819",[-94.9543769247606, 42.41731990638325]],
    [ "1101596691",[-87.37629030788072, 41.57372245109472]],
    [ "1101637319",[-68.16501205349745, 44.72277767447514]],
    [ "1101696249",[-90.64472040000003, 43.59445445]],
    [ "1101696253",[-90.81458705, 43.63861045000001]],
    [ "1101696262",[-90.87932398624996, 43.56245296412348]],
    [ "1101696263",[-90.92099748331317, 43.5875946498526]],
    [ "Liberty Pole DPC Solar",[-90.90796193944686, 43.49405757522369]],
    [ "1101710977",[-90.85401104999998, 43.657341650000006]],
    [ "1101710984",[-91.1483521, 43.47479475]],
    [ "1101710985",[-91.15784542473219, 43.60428564379966]],
    [ "1101723342",[-69.16849023694076, 44.083785595159476]],
    [ "1101743445",[-69.095943, 44.137877950000004]],
    [ "Blocton Substation",[-87.10911610711572, 33.12390122493926]],
    [ "Ehrenfield Jackson Substation",[-78.77611071517444, 40.383396974822865]],
    [ "1101872621",[-110.94679327791975, 32.33785089889392]],
    [ "1101873394",[-80.8278079042678, 35.77918072263692]],
    [ "1101873414",[-80.94269721184838, 35.798164955096105]],
    [ "1101873416",[-80.86725092422567, 35.81329350562787]],
    [ "1101873424",[-80.59110989871003, 35.87540753243469]],
    [ "1101873429",[-80.69639438915421, 35.879096980937696]],
    [ "Mocksville Substation",[-80.54447967918782, 35.861926261693014]],
    [ "Energy United",[-80.60341455000001, 35.94402505]],
    [ "Energy United",[-80.61879960000002, 36.01579465]],
    [ "Energy United",[-80.71621208903504, 35.96641086733335]],
    [ "Energy United",[-80.76106130940265, 36.026144678298714]],
    [ "Energy United",[-80.84183342775319, 36.01877758820549]],
    [ "Energy United",[-80.95739016778195, 35.94984350732801]],
    [ "Energy United",[-80.95654182676391, 36.02173113811633]],
    [ "1101882374",[-82.59773600432689, 31.857083188338233]],
    [ "1101882375",[-82.59650823224929, 31.856731699147783]],
    [ "1101882378",[-82.59694211980428, 31.857971206870406]],
    [ "Chester Substation",[-68.52130071311389, 45.393725320670065]],
    [ "1101933175",[-89.64056306178519, 41.60744624987521]],
    [ "1101933179",[-89.64649284552794, 41.614749199746015]],
    [ "1101933188",[-89.61872586483982, 41.52480774981244]],
    [ "1101935319",[-89.0592174102574, 41.667050971125555]],
    [ "1101936630",[-88.79549189052908, 41.81969593804184]],
    [ "1101936631",[-88.79550151803411, 41.81912386517682]],
    [ "1101952327",[-93.20771622225378, 45.60125565049848]],
    [ "1101952336",[-93.37952423427016, 45.600876832514935]],
    [ "1101952338",[-93.58176572520667, 45.58768874564253]],
    [ "1101952339",[-93.6047095, 45.6028592]],
    [ "1101961563",[-79.1069363053535, 35.28675960722619]],
    [ "1102159030",[-84.09828681206142, 32.22663522546652]],
    [ "1102170498",[-92.34378590668356, 31.45317042898882]],
    [ "Subestación La Rambla",[-66.60169974924483, 18.02366349424294]],
    [ "CLECO",[-92.61579578693964, 31.54173132518587]],
    [ "North Colfax Substation",[-92.71425121684723, 31.528084446606826]],
    [ "Kissimmee Utility Authority",[-81.37585668132176, 28.296680283600672]],
    [ "1102213196",[-92.77403538619038, 31.708889180818137]],
    [ "CLECO",[-92.78969819316265, 30.81719111518794]],
    [ "DeRidder Substation",[-93.24502877996568, 30.839887207421608]],
    [ "Beauregard Electric Cooperative",[-93.24564352300011, 30.839711644459086]],
    [ "1102219562",[-93.01543785, 30.823941249999994]],
    [ "Wheatland Electric Cooperative",[-97.87421486848463, 37.05191921194185]],
    [ "Sunflower Electric Power Corporation",[-97.87540693581367, 37.05166542852641]],
    [ "Ewing Substation",[-74.76696586691989, 40.24530179761493]],
    [ "City of Anthony Kansas",[-98.00299252508651, 37.138354695042956]],
    [ "1102240797",[-97.61948335000001, 37.03988665000001]],
    [ "AE Power Services LLC",[-98.37437277255069, 37.455868877048296]],
    [ "CLECO",[-92.44969138887093, 30.77351287525182]],
    [ "New Llano substation",[-93.28322163065813, 31.106993425166042]],
    [ "North Leesville Substation",[-93.26064655000002, 31.174862600000004]],
    [ "Hicks Substation",[-92.98248796738044, 31.180216966243268]],
    [ "1102346636",[-93.50924840809414, 30.8473598420677]],
    [ "1102346637",[-93.26658362484481, 30.891283693452635]],
    [ "Jay Substation",[-72.43749669999998, 44.94674010000001]],
    [ "1102374690",[-86.76034645, 40.77994965]],
    [ "Grand Prairie Substation",[-92.15399007576279, 30.68166087986087]],
    [ "SLEMCO",[-92.00882677959628, 30.831000271639493]],
    [ "Cimarron Bend Substation #3",[-99.99655357660086, 37.41352497373579]],
    [ "1102427455",[-100.36048460626573, 37.628721101756014]],
    [ "1102427456",[-100.3604801399059, 37.62792897453831]],
    [ "Mentor Substation",[-97.61147781369017, 38.76043108165865]],
    [ "Berg Substation",[-97.60729174681693, 38.775748273860934]],
    [ "Coronado Substation",[-97.69528550604088, 38.58333055168385]],
    [ "Clay Center Junction Substation",[-97.1285149171151, 39.250252152425425]],
    [ "TC Riley Substation",[-97.05088438890682, 39.328416859565294]],
    [ "Holt County Substation",[-98.30215607408651, 42.090242247037956]],
    [ "1102472895",[-98.29460292362359, 42.08827889584197]],
    [ "Spring Hills Mfg. Substation",[-86.96331040821468, 35.741622943900744]],
    [ "1102632328",[-69.96731068152421, 44.31218799363809]],
    [ "Hubbard 1 Wind Farm Substation",[-96.88929247250293, 31.751265088340155]],
    [ "1102726092",[-82.13575655, 34.644164]],
    [ "1102869278",[-85.88215499766422, 37.677284706399945]],
    [ "Fayetteville Public Works",[-78.92843295042445, 35.110737668229284]],
    [ "1103124519",[-78.02209204758992, 33.93082348066334]],
    [ "Sneads Ferry Substation",[-77.40967656810456, 34.53345765402153]],
    [ "Southwest Substation",[-77.48279339999999, 34.7145835]],
    [ "Willis Landing Substation",[-77.20261765521235, 34.66580370042799]],
    [ "Swansboro Substation",[-77.16092452233136, 34.69863963264159]],
    [ "Temples Point Substation",[-76.79798322224795, 34.86893420672003]],
    [ "1103151773",[-76.6716514217398, 34.813601859806674]],
    [ "1103151777",[-76.75142719999998, 34.73198829999999]],
    [ "1103151784",[-76.94109772394097, 34.95319468363312]],
    [ "1103170412",[-77.05569703881966, 35.19632787036783]],
    [ "1103170414",[-76.80672289999998, 35.14789079999999]],
    [ "1103170416",[-76.84298304999999, 35.2982704]],
    [ "Wellcome Substation",[-77.35160332353823, 35.656031232426145]],
    [ "Greenville Utilities Commission",[-77.33364299999998, 35.65250679999999]],
    [ "Eastside Substation",[-77.34783089796284, 35.590513480362866]],
    [ "Simpson Substation",[-77.30293966973278, 35.57823261473422]],
    [ "Evans Substation",[-77.37421311535243, 35.600038522857545]],
    [ "Frog Level Substation",[-77.44513998414482, 35.569467774571635]],
    [ "Hollywood Substation",[-77.3194625269323, 35.530688655557476]],
    [ "Mt. Pleasant Substation",[-77.40659103062916, 35.664310500536736]],
    [ "Winterville Substation",[-77.39768232375866, 35.541167437008596]],
    [ "Greenville Utilities Commission",[-77.39374111947525, 35.55090432628121]],
    [ "Nahunta Substation",[-77.77453714271715, 35.50626387405332]],
    [ "High Lake Substation",[-85.52957112704277, 44.71233597484217]],
    [ "1103346569",[-77.47401195, 38.79455335]],
    [ "1103520705",[-88.39330752637237, 37.04981533733637]],
    [ "1103543940",[-77.71106485703913, 35.21083722984755]],
    [ "1103543987",[-78.15064956250427, 35.57228617517957]],
    [ "Lisbon Substation",[-78.52483601103359, 34.519069338664906]],
    [ "Carvers Substation",[-78.41164214999999, 34.46072185]],
    [ "Lumbee River EMC",[-79.03985215242766, 34.67486248418151]],
    [ "Saint Pauls Substation",[-78.94592109787082, 34.80608098818185]],
    [ "Lumbee River EMC",[-79.0176593981317, 34.83000271683077]],
    [ "Lumbee River EMC",[-79.03374597177748, 35.01051713816982]],
    [ "1103617517",[-79.24493502747075, 34.50854309633251]],
    [ "1103617520",[-79.29699663256442, 34.83851825435447]],
    [ "1103661314",[-81.3349375543757, 35.23114230545355]],
    [ "1103661317",[-81.45249078391944, 35.172654317095414]],
    [ "1103661319",[-81.4288179, 35.17399950000001]],
    [ "1103661332",[-81.3284927522994, 35.21564203194032]],
    [ "1103661334",[-81.35241345, 35.21852620000001]],
    [ "1103661336",[-81.20250134342707, 35.1784910885768]],
    [ "1103661338",[-81.05288924999999, 35.27025089999999]],
    [ "1103661359",[-80.65759060275032, 35.42503170994108]],
    [ "1103661367",[-80.63945016179815, 35.40924484668033]],
    [ "1103661372",[-80.60492829198589, 35.41120773774879]],
    [ "City of Concord",[-80.59291824999998, 35.38561055]],
    [ "City of Concord",[-80.5660320177271, 35.383417627680046]],
    [ "1103661381",[-80.53692649901727, 35.32615111208655]],
    [ "City of Concord",[-80.52746484067207, 35.38953466693714]],
    [ "City of Concord",[-80.51651155, 35.415206500000004]],
    [ "City of Concord",[-80.56125502992215, 35.41496721411704]],
    [ "City of Concord",[-80.60426848290516, 35.443650242548244]],
    [ "1103698721",[-84.01360895606435, 36.14439864757457]],
    [ "CPC Kannapolis Substation",[-80.73619323208561, 35.483907684076584]],
    [ "1103766643",[-80.82790305236982, 35.56422328311686]],
    [ "1103766645",[-80.8325334681627, 35.51826237483958]],
    [ "1103766646",[-80.84486904999999, 35.514558]],
    [ "1103766647",[-80.84811906994727, 35.50459455526203]],
    [ "1103766659",[-80.88013670001574, 35.580368059398566]],
    [ "1103769840",[-70.72477349599205, 44.25567575294502]],
    [ "1103772957",[-70.78734786624457, 44.41259605644072]],
    [ "1103775826",[-77.1270352971588, 34.788649763021375]],
    [ "1103775827",[-77.0871743828644, 34.741456301123215]],
    [ "Railroad Street Substation",[-78.84647664007832, 35.04285045714585]],
    [ "Goodyear Substation",[-78.85854610659803, 35.16922356182575]],
    [ "Fayetteville Public Works",[-78.8432864417578, 34.958604227151916]],
    [ "Starks Substation",[-69.91385625303495, 44.78105961602972]],
    [ "Farmington Substation",[-70.1275007340369, 44.65398275334578]],
    [ "1103981041",[-88.46668022191936, 37.014429593959605]],
    [ "1103981047",[-88.48364578473587, 37.01198786818462]],
    [ "1103981048",[-88.46459141786666, 37.04799978854322]],
    [ "1103981049",[-88.53053442557209, 37.026614456330975]],
    [ "1103981053",[-88.59742254617788, 37.00822718242807]],
    [ "Bordeaux Substation",[-78.9388891436445, 35.028338847016215]],
    [ "Fayetteville Public Works",[-78.92531645190184, 35.065575612959385]],
    [ "Water Works Substation",[-78.89580632511961, 35.06780192374979]],
    [ "Fayetteville Public Works",[-78.96875603537501, 35.02626421078148]],
    [ "Fayetteville Public Works",[-78.94993166941686, 35.03992303620902]],
    [ "Fayetteville Public Works",[-78.99319196927374, 35.04025024667885]],
    [ "1104064709",[-78.96264829590336, 35.25526233666634]],
    [ "1104064711",[-78.93636749719792, 35.22647826744775]],
    [ "Bear Branch Substation",[-79.01792870729349, 35.40903581586746]],
    [ "1104064716",[-79.0494212833528, 35.59099184891406]],
    [ "Kentucky Utilities Company",[-88.116041, 37.321776050000004]],
    [ "Fuquay Wade Nash Substation",[-78.816106945388, 35.61603456872581]],
    [ "1104145463",[-78.5881229899468, 35.81666215245469]],
    [ "Southwestern Electric Power Company",[-94.36124742443512, 35.195037707884204]],
    [ "North Huntington Substation",[-94.27016429999999, 35.08271080000001]],
    [ "Arkansas Electric Cooperative Corporation",[-90.61540312956411, 35.01654844287377]],
    [ "1104360195",[-114.75465374399492, 33.67460837543382]],
    [ "1104360199",[-114.98271037504877, 33.66003970509362]],
    [ "1104474745",[-103.89845525431734, 40.960964178782966]],
    [ "1104519148",[-101.94376318801193, 31.06704513608379]],
    [ "1104529827",[-96.81264802067747, 31.5676613172084]],
    [ "1104529829",[-96.94099960128312, 31.54105725641289]],
    [ "1104531038",[-98.31029914065395, 32.658848525520725]],
    [ "1104543716",[-94.31923986401895, 39.601170275150366]],
    [ "1104543719",[-91.48074316087316, 39.105971159578246]],
    [ "1104559036",[-108.69490337683789, 45.78434634428366]],
    [ "1104559037",[-108.70044862452713, 45.756514800034815]],
    [ "1104802988",[-87.44957333162188, 40.941142052776485]],
    [ "Sedalia Substation",[-93.31244758056907, 38.66833501797456]],
    [ "1104826356",[-93.18598337421182, 38.66949391072045]],
    [ "1104832213",[-106.49035989186338, 31.753575683450865]],
    [ "1104844294",[-108.9371562, 34.12320415000001]],
    [ "1104844295",[-108.93828495729394, 34.12297459856802]],
    [ "Pajarito Substation",[-106.74435495, 35.00340215000001]],
    [ "1104844308",[-105.33220301611348, 34.71629040957464]],
    [ "1104875223",[-80.5763981895269, 35.8345013881162]],
    [ "1104875225",[-80.55815638709547, 35.805616347649014]],
    [ "1104875235",[-80.46313568753564, 35.95378262441215]],
    [ "1104875303",[-80.80325971869964, 36.26603185192763]],
    [ "1104875314",[-80.30885249999999, 36.0394103]],
    [ "1104875335",[-80.24269061465627, 36.07818185845313]],
    [ "1104941606",[-103.79923082252498, 33.01349454627949]],
    [ "1104956177",[-80.28343150210434, 35.80389866936611]],
    [ "1104956181",[-80.29303279232579, 35.790356517453624]],
    [ "1104956186",[-80.28233094977618, 35.80048301559379]],
    [ "1104956190",[-80.24703885337723, 35.81144370147188]],
    [ "1104956193",[-80.30977789065405, 35.763662219403166]],
    [ "1105021895",[-97.9551865810662, 36.05562127759292]],
    [ "1105021896",[-98.12380070267469, 36.28009075511656]],
    [ "1105029787",[-106.39492618625931, 31.759456113875707]],
    [ "1105030083",[-85.05430251836982, 40.05913607918958]],
    [ "1105036478",[-80.5237078991634, 36.309240069887714]],
    [ "1105036480",[-80.55480538455227, 36.220114874855255]],
    [ "1105036483",[-81.09708631738448, 36.24519549828295]],
    [ "1105036485",[-80.95022597724557, 36.22473535436321]],
    [ "1105036486",[-80.9999885642235, 36.29856298125093]],
    [ "1105036487",[-80.91508716572014, 36.3373453025759]],
    [ "1105072211",[-87.94705340623777, 37.90790950699236]],
    [ "1105072223",[-87.92627088950611, 37.90423657794176]],
    [ "1105072226",[-87.92443298446126, 37.90909682794533]],
    [ "1105072227",[-87.92427435, 37.9100017]],
    [ "1105072233",[-87.93014472784003, 37.90668108757711]],
    [ "CenterPoint Energy",[-87.90753492050978, 37.93386576361034]],
    [ "1105075139",[-99.63595927503576, 33.60374779178701]],
    [ "1105075140",[-99.64160665000001, 33.60649665]],
    [ "Murl L. Shaver Substation",[-114.62609792977528, 34.85690762960689]],
    [ "1105228667",[-80.55505677748766, 36.43177781065551]],
    [ "1105228669",[-80.44145015137124, 36.45406254016976]],
    [ "1105228698",[-80.79629636278625, 36.183935982368055]],
    [ "1105234186",[-98.1586381, 36.37678225]],
    [ "1105234189",[-98.59909740054295, 36.50799856681254]],
    [ "Saddle Substation",[-99.88697035857447, 37.64849558161674]],
    [ "Iron Star Substation",[-99.98015081647021, 37.649329399994365]],
    [ "1105285671",[-97.28166105, 34.433184250000004]],
    [ "1105293252",[-108.67408023048735, 45.15749880836787]],
    [ "1105293253",[-108.67306731248864, 45.1579243364827]],
    [ "Neosho Ridge Substation",[-95.36422744707515, 37.39060800867018]],
    [ "Neosho Ridge Wind Farm Substation",[-95.38049882558897, 37.47390160112389]],
    [ "1105321192",[-80.69927315786522, 36.48233559481248]],
    [ "1105321193",[-80.78814428290366, 36.39815830464098]],
    [ "1105321195",[-80.84058523429503, 36.50794290914617]],
    [ "1105321197",[-80.6809031881513, 36.534674077441146]],
    [ "1105321198",[-80.72078507145136, 36.397123029651176]],
    [ "1105321200",[-80.73373661488603, 36.33708986134784]],
    [ "1105321201",[-80.68878215729532, 36.33879867858069]],
    [ "1105393113",[-89.05945457501952, 40.95434285469243]],
    [ "1105393114",[-89.05806421925836, 40.95405914108163]],
    [ "1105398628",[-99.20159464691234, 33.55565614452265]],
    [ "1105398629",[-99.20087694709508, 33.55621759035918]],
    [ "1105403212",[-102.80076809999998, 39.35190895]],
    [ "Crossing Trails Wind Farm",[-102.82230624962087, 39.07967849795836]],
    [ "1105404314",[-97.29181722468039, 33.461921105187166]],
    [ "1105404316",[-97.33036595173151, 33.55077422345121]],
    [ "1105495127",[-94.00589908716238, 37.163250474737815]],
    [ "1105610056",[-85.95815685843796, 31.257319575233392]],
    [ "Basin Substation",[-86.1214335799455, 31.354486793797257]],
    [ "Denton Municipal Electric",[-97.10139052963667, 33.20183961744254]],
    [ "Thrive Fontana Substation",[-117.42931555000003, 34.0735394]],
    [ "Village Substation",[-116.9103791642139, 34.24030883863141]],
    [ "Bear City Substation",[-116.8495889127313, 34.2653894896544]],
    [ "1105877366",[-92.46794744226091, 45.44337919324657]],
    [ "1105938211",[-85.11388028152348, 40.361608014265606]],
    [ "1105938221",[-84.98302119993802, 40.32513683474102]],
    [ "1105940006",[-87.50964243687237, 46.51243552443839]],
    [ "1105940009",[-87.57269405847076, 44.28622402509603]],
    [ "1105940011",[-87.5553279879384, 44.283376397943684]],
    [ "1105940027",[-88.61387533545007, 46.791915826511115]],
    [ "1105941172",[-84.59492546233398, 41.016932157851215]],
    [ "1105946041",[-83.7582648369433, 40.5525969793324]],
    [ "1105968796",[-91.23547988830595, 43.358112342612365]],
    [ "Bill Yoney Substation",[-114.61969639416083, 34.85055624104099]],
    [ "1106039397",[-115.38825380650522, 43.06683096932528]],
    [ "1106081110",[-87.45211722489681, 39.94509745441612]],
    [ "1106081113",[-87.40069414963311, 40.3807993180191]],
    [ "1106081756",[-114.96977782116403, 42.86389023229586]],
    [ "1106091793",[-115.03725472488148, 42.8801568457463]],
    [ "1106091794",[-115.0364169017719, 42.880116149826094]],
    [ "Rugby Substation",[-84.7088236662525, 36.330773614726745]],
    [ "Blue Ridge Energy",[-81.46576181411453, 36.37117061041727]],
    [ "Blue Ridge Energy",[-81.3946268619547, 36.472167376364695]],
    [ "Blue Ridge Energy",[-81.15406028031157, 36.51309050045907]],
    [ "Blue Ridge Energy",[-81.06021972685808, 36.473588200020345]],
    [ "Blue Ridge Energy",[-81.28109326654274, 36.45316545093056]],
    [ "Blue Ridge Energy",[-81.49329961463664, 36.42091674426004]],
    [ "1106268316",[-81.50536535, 36.478716500000004]],
    [ "Blue Ridge Energy",[-81.53934430574145, 36.342367844490354]],
    [ "1106361163",[-111.95078938484635, 47.713111170451405]],
    [ "North Central Foundry Substation",[-96.86324796966885, 38.99708487399997]],
    [ "Anzio Substation",[-96.81220459130671, 39.07042899748672]],
    [ "1106402231",[-110.09245874308893, 46.44234710158261]],
    [ "1106424412",[-109.49637326504967, 45.858115979608044]],
    [ "1106427207",[-109.64976602098919, 45.85543672103846]],
    [ "Sherwood Substation",[-95.79195902831904, 38.99302334812878]],
    [ "Western Area Power Administration",[-103.20759437281302, 44.82660881648393]],
    [ "1106455647",[-86.87614029188067, 40.770968029091684]],
    [ "Corriedale Substation",[-104.96090060346933, 41.10842856954772]],
    [ "West Cheyenne Substation",[-104.95014738885142, 41.108637914822985]],
    [ "1106486301",[-102.94920912009688, 32.38574772911914]],
    [ "1106486800",[-102.62979852575658, 34.04766131568934]],
    [ "1106488370",[-102.07298601274174, 34.786474597357]],
    [ "1106522827",[-92.21483164906083, 30.91629383360505]],
    [ "CLECO",[-92.13414038701299, 30.983371419628458]],
    [ "Yellow Bayou Substation",[-91.84833059949946, 30.99297076429312]],
    [ "Marksville Substation",[-92.08056748954984, 31.095895431287307]],
    [ "1106550697",[-92.34232285538371, 31.403253805943432]],
    [ "1106579000",[-87.46067067523771, 39.342824444117504]],
    [ "1106579001",[-87.4597916747713, 39.3609532345642]],
    [ "North Tomah",[-90.50747595259972, 43.997532948881265]],
    [ "Flare Avenue",[-90.53438288526276, 44.00346402527295]],
    [ "1106592916",[-90.51942987417344, 44.0171692208589]],
    [ "1106611840",[-92.35737113929211, 31.295183120433293]],
    [ "Warrens",[-90.54467615, 44.10862324999999]],
    [ "CLECO",[-92.34146630696436, 31.351565615718478]],
    [ "Camp Douglas",[-90.26468005000002, 43.916374250000004]],
    [ "Boonville Municipal",[-75.3473203161164, 43.4879917811014]],
    [ "1106707572",[-75.3065790617038, 43.618709371370805]],
    [ "1106707574",[-75.3064003, 43.61891435]],
    [ "1106707578",[-75.35987119641817, 43.61658736704083]],
    [ "Taylorville",[-75.32057115389092, 43.92709703050762]],
    [ "Simmonsport Substation",[-91.82397855231024, 30.989335385790206]],
    [ "1106770183",[-91.80200250518995, 30.792391986610575]],
    [ "West Mauston",[-90.0925439248986, 43.80121149532551]],
    [ "Mauston",[-90.07042950225538, 43.79696540604045]],
    [ "1106791597",[-90.39506592897605, 43.93111460260475]],
    [ "1106794193",[-92.02417252508992, 30.66891889336581]],
    [ "1106832142",[-85.68948778146304, 40.24762556689707]],
    [ "1106846148",[-90.42318183931614, 43.773767575275365]],
    [ "1106846149",[-90.4673591825865, 43.830584495542155]],
    [ "1106851002",[-90.2657268, 43.7559801]],
    [ "1106917702",[-90.05553815, 43.73859485]],
    [ "1106959167",[-85.84408494039059, 40.278211936015474]],
    [ "1106986873",[-97.1364095656399, 34.38827291753146]],
    [ "1106986874",[-97.13629002510707, 34.38738634331393]],
    [ "1106989703",[-78.39095157841095, 33.96953496413521]],
    [ "Taylorsville Tie Substation",[-81.16110089459295, 35.91880910804577]],
    [ "1107060652",[-81.16963557020247, 35.923444038612615]],
    [ "Wilkesboro Substation",[-81.16140663338162, 36.14046270849189]],
    [ "1107069017",[-77.89161979886264, 35.198252111712094]],
    [ "1107086300",[-84.92446515077309, 41.36205310519929]],
    [ "1107086311",[-85.04329533040998, 41.2821790033856]],
    [ "1107092633",[-76.9962451087765, 35.539760228147216]],
    [ "1107096945",[-78.26091498410442, 35.292958184131066]],
    [ "1107096946",[-78.263008, 35.32995605]],
    [ "City of Kinston",[-77.61887161380915, 35.271924462467084]],
    [ "City of Kinston",[-77.61079027090857, 35.28765442131717]],
    [ "City of Kinston",[-77.61345418512562, 35.31420947522141]],
    [ "City of Kinston",[-77.55791219696498, 35.23840813083412]],
    [ "Bassett Substation",[-79.99393726236603, 36.75940222124186]],
    [ "1107173755",[-78.4636321455525, 35.964054781293086]],
    [ "1107179426",[-89.89303029677879, 43.71388852272031]],
    [ "Appalachian Power Company",[-79.98935349209133, 36.83013432048691]],
    [ "1107210087",[-86.1950579443095, 39.72498681090034]],
    [ "1107221392",[-93.95640414531023, 35.134733353211324]],
    [ "1107221393",[-93.94660493805769, 35.131389921193744]],
    [ "1107229997",[-90.91734669999998, 43.900424949999994]],
    [ "1107230010",[-90.33619175000001, 43.65705]],
    [ "1107278733",[-102.60988390843592, 33.52807868722365]],
    [ "1107364563",[-91.46574678814318, 44.25319592412923]],
    [ "1107364579",[-91.28859924999999, 43.983946]],
    [ "1107364585",[-91.21074932441921, 43.918783793986314]],
    [ "1107364595",[-91.23377556023837, 43.880842434451964]],
    [ "1107364597",[-91.26328205957297, 43.95829325795788]],
    [ "1107367683",[-95.12737803193653, 35.51148155566107]],
    [ "1107372839",[-91.22249009080664, 44.14868502535633]],
    [ "1107375848",[-79.97442237001982, 36.137262591282955]],
    [ "1107464611",[-90.80717516574961, 43.84890753691304]],
    [ "1107521448",[-90.82044300799318, 44.05077290264365]],
    [ "American Electric Power",[-86.75691643453857, 41.71918077055583]],
    [ "American Electric Power",[-86.69398974999999, 41.71780665]],
    [ "1107584732",[-83.43534414960004, 43.72241089709639]],
    [ "Paris Substation",[-90.12540157552397, 29.999076990843033]],
    [ "1107612363",[-100.032900244759, 31.09620581736681]],
    [ "Slate Creek Wind Substation",[-97.23813231812073, 37.11381076239366]],
    [ "1107643168",[-79.70733634720644, 35.91206163432235]],
    [ "1107643171",[-79.57216981426723, 35.971113928364325]],
    [ "1107643173",[-79.43263180632019, 36.01664556851174]],
    [ "1107643176",[-79.32402580000002, 35.94902585]],
    [ "1107669381",[-90.59207541665697, 42.5878053119031]],
    [ "1107678329",[-79.30101497734412, 36.0919873476412]],
    [ "Airgas USA",[-79.29877815000002, 36.09141790000001]],
    [ "1107678340",[-79.25395513246315, 36.047949203915266]],
    [ "1107678341",[-79.21073932202759, 36.041660584659354]],
    [ "1107703767",[-79.35219430218265, 36.09757146880544]],
    [ "1107703768",[-79.37728063160858, 36.09356924517834]],
    [ "1107703770",[-79.31408940000001, 36.1907499]],
    [ "1107703828",[-79.46541895, 36.11246455]],
    [ "City of High Point",[-79.97445268689079, 35.99500387484445]],
    [ "DPC Platteville",[-90.50455873548816, 42.71334158174174]],
    [ "1107718480",[-75.86324032226648, 42.20146515989327]],
    [ "1107738928",[-101.15543482614476, 31.249500488833924]],
    [ "Hammer Substation",[-80.01894970208538, 35.97869291665829]],
    [ "Commerce Substation",[-79.99814082964882, 35.95628513084846]],
    [ "City of High Point",[-79.95740000381092, 36.019082452130974]],
    [ "1107773443",[-96.76807534782881, 33.26459253745047]],
    [ "International Paper/Hood Ind. Substation",[-89.12633547665358, 30.825788829149623]],
    [ "1107836423",[-97.38052496333381, 32.94728265948657]],
    [ "Rewey Substation",[-90.39778232503971, 42.84461060415313]],
    [ "Belmont Substation",[-90.33690287508634, 42.734697860384614]],
    [ "1107883619",[-87.3323994407566, 37.91614541722307]],
    [ "1107883621",[-87.3324116812154, 37.917769631082514]],
    [ "1107883626",[-87.33361747269547, 37.92558255979792]],
    [ "1107883629",[-87.33768156432396, 37.94482211798398]],
    [ "1107883637",[-87.3293911167092, 37.915838327518664]],
    [ "1107883638",[-87.32907789236444, 37.91647506036232]],
    [ "1107883647",[-86.99847141198788, 37.944139913292574]],
    [ "1107883650",[-86.8732790513272, 38.00281764166208]],
    [ "1107896417",[-80.11529332216591, 36.31869446425758]],
    [ "1107896420",[-80.1648804722846, 36.36518200942104]],
    [ "1107896422",[-80.14869506693961, 36.447760550806336]],
    [ "Danbury Retail Substation",[-80.20161528755926, 36.40606232448287]],
    [ "1107896425",[-80.09895054298123, 36.468811878508724]],
    [ "1107896427",[-80.08238353926754, 36.28089057456639]],
    [ "Pine Hall Brick Company",[-79.99255956998009, 36.376569255258254]],
    [ "Pine Hall Brick Company",[-79.99611650000003, 36.376513949999996]],
    [ "1107896453",[-79.92986160851747, 36.34739967743067]],
    [ "1107896465",[-79.95207823198326, 36.39949850390979]],
    [ "Unifi, Inc.",[-79.99013265, 36.405272100000005]],
    [ "Unifi, Inc.",[-79.99014155000002, 36.40470760000001]],
    [ "Unifi, Inc.",[-79.99013845831436, 36.40422012495111]],
    [ "Unifi, Inc.",[-79.99014002505643, 36.40335610835201]],
    [ "Unifi, Inc.",[-79.99014465, 36.403741399999994]],
    [ "Unifi, Inc.",[-79.99014312505643, 36.402351208352]],
    [ "Unifi, Inc.",[-79.99016172504892, 36.40191105835207]],
    [ "Unifi, Inc.",[-79.99017565, 36.401251499999994]],
    [ "Unifi",[-79.96179349999998, 36.393413349999996]],
    [ "1107896494",[-79.98009953359094, 36.41284995126522]],
    [ "1107896495",[-79.97734709219965, 36.40807517148233]],
    [ "1107896496",[-79.97700329110123, 36.40660152428764]],
    [ "1107896498",[-79.9844178137405, 36.411033326017844]],
    [ "Sturm, Ruger & Co",[-79.95580343225066, 36.401663684117395]],
    [ "1107896505",[-79.99938067424432, 36.302273011583004]],
    [ "1107919886",[-79.9210691621126, 36.43687147773334]],
    [ "1107919888",[-79.90785282773076, 36.460485845633634]],
    [ "Unifi, Inc.",[-79.88862553116229, 36.46923020488908]],
    [ "Unifi, Inc.",[-79.89046993097598, 36.468315103591486]],
    [ "1107919894",[-79.89060194056383, 36.467052331500305]],
    [ "1107919902",[-79.78623269999999, 36.509007]],
    [ "1107919903",[-79.78391855000001, 36.50939355]],
    [ "1107919907",[-79.78567346692792, 36.51116144824249]],
    [ "Mohawk Industries",[-79.76347227961246, 36.48681883469868]],
    [ "Mohawk Industries",[-79.76047575000001, 36.48737835]],
    [ "1107919957",[-79.75856592292614, 36.505193135354155]],
    [ "Signode",[-79.67791545118044, 36.53085841688371]],
    [ "1107919970",[-79.6797644815821, 36.53435326891614]],
    [ "1107919971",[-79.67605764999999, 36.53807125]],
    [ "Bonset America",[-79.73833685624173, 36.16933146119936]],
    [ "Ruffin Retail Substation",[-79.5429477, 36.455623349999996]],
    [ "1107931851",[-79.41616367722453, 36.506832356914025]],
    [ "Proctor & Gamble",[-79.72614412517133, 36.17871995555059]],
    [ "1107931867",[-79.7298599, 36.187986450000004]],
    [ "1107931875",[-79.71171983071015, 36.28951094535031]],
    [ "1107943593",[-95.30585972524702, 35.50837525655419]],
    [ "Cash Post Office",[-90.91203650355818, 35.793094936058516]],
    [ "Marianna Substation",[-90.76797339147313, 34.76271737475136]],
    [ "Entergy Arkansas",[-90.62085103526839, 34.530047735822436]],
    [ "Entergy Arkansas",[-90.59722195999439, 34.51269747704773]],
    [ "1108009288",[-79.65142351658884, 36.38306264958138]],
    [ "1108009291",[-79.66316212346447, 36.36631199395952]],
    [ "1108009296",[-79.66411049031332, 36.362820026586306]],
    [ "1108009316",[-79.65401709054879, 36.31873389696536]],
    [ "Metzler Automotive",[-79.64617678071204, 36.32467778432165]],
    [ "Ball Corporation",[-79.64863861078737, 36.328010816976025]],
    [ "1108009328",[-79.515274, 36.25691125]],
    [ "1108009332",[-79.44129378313622, 36.305513694234506]],
    [ "1108009335",[-79.25607682062312, 36.28090490324264]],
    [ "1108024654",[-95.3531936749195, 35.65903044365726]],
    [ "1108032794",[-95.30412306767698, 35.742818687861714]],
    [ "DPC Shullsburg",[-90.24545947357934, 42.58104930372768]],
    [ "1108043195",[-90.4352628661623, 42.653073025296685]],
    [ "Pioneer Substation",[-90.49521757482425, 42.72629348671267]],
    [ "1108067252",[-95.11498529108836, 35.51862597540474]],
    [ "Asheboro North Substation",[-79.78667624293787, 35.75260767496741]],
    [ "Duke Energy Progress",[-79.78983983989006, 35.709651495430855]],
    [ "Ramseur Substation",[-79.64866091281567, 35.74252566309685]],
    [ "1108112289",[-79.64177635, 35.733751749999996]],
    [ "1108112297",[-79.62444450000001, 35.7910033]],
    [ "Siler City Substation",[-79.475531183173, 35.721060451602696]],
    [ "1108112302",[-79.42673062566512, 35.69878558184451]],
    [ "1108141051",[-106.30646968703124, 32.07099486335149]],
    [ "1108286635",[-87.92214784727952, 37.9139659487766]],
    [ "1108375724",[-111.9980147507701, 40.52143700317721]],
    [ "1108378159",[-101.67138623053083, 33.933560635425]],
    [ "1108429265",[-98.59296904717681, 47.18719114459648]],
    [ "1108432191",[-100.2290319410008, 45.7527935822577]],
    [ "Dover Substation",[-79.71880305676154, 35.444864169826594]],
    [ "1109037530",[-79.81521989686631, 35.75492461044255]],
    [ "1109074121",[-81.7799941824723, 35.255724503348965]],
    [ "1109074125",[-81.7947853697024, 35.272740678303244]],
    [ "1109074163",[-81.8881440726358, 35.28973604457114]],
    [ "1109074166",[-81.85936190115369, 35.32496650682882]],
    [ "1109074170",[-81.88496541240967, 35.34076391275378]],
    [ "1109114304",[-81.92695067199732, 35.43738820530976]],
    [ "1109114310",[-82.20852373399559, 35.31119172281764]],
    [ "1109114316",[-81.84309702512854, 35.6254114041448]],
    [ "1109114317",[-81.7958154250509, 35.671928942171874]],
    [ "1109114321",[-81.75781372973056, 35.655932831904956]],
    [ "1109114323",[-81.81464401191822, 35.690212019960306]],
    [ "1109649985",[-81.99875163180154, 35.730699816215264]],
    [ "1109649989",[-82.02757208093465, 35.78854325417981]],
    [ "1109649991",[-82.0216657641085, 35.795101573750145]],
    [ "Glen Alpine Retail Substation",[-81.77655357175347, 35.72903377961743]],
    [ "1109649997",[-81.85636323147475, 35.714576854138194]],
    [ "1109649999",[-81.79694475201853, 35.701222484401285]],
    [ "1109650001",[-81.79326365970812, 35.709001114004884]],
    [ "1109650005",[-81.72358328114498, 35.829614883791415]],
    [ "1109650018",[-81.5443072876494, 35.76337963033635]],
    [ "1109740749",[-81.53433455000001, 35.740135300000006]],
    [ "Valdese Textiles",[-81.53063430749441, 35.73911563001295]],
    [ "Icard Retail Substation",[-81.4733035865912, 35.72890856912162]],
    [ "Baker Furniture",[-81.44237202736086, 35.71771219422205]],
    [ "1109740765",[-81.55521907542135, 35.73974635663851]],
    [ "1109740766",[-81.7274902196066, 35.72238125701279]],
    [ "Sugar Hill Tie Substation",[-82.0524448121246, 35.67036973748512]],
    [ "Hi Tech Machine Corp",[-82.01799708338966, 35.67816109748206]],
    [ "1109740775",[-82.05154967685546, 35.67068380637453]],
    [ "Crane Resistoflex Company",[-82.0669833398116, 35.683133077037844]],
    [ "Carson Retail Substation",[-82.05990195, 35.691537149999995]],
    [ "Jen-Weld, Inc.",[-82.1031750465852, 35.660967432793974]],
    [ "Columbia Forest Products, Inc.",[-82.10791115420727, 35.660609717350326]],
    [ "Auria Solutions",[-82.16216745, 35.6416841]],
    [ "Auria Solutions",[-82.16425415, 35.6409959]],
    [ "Ethan Allen",[-82.17007793322622, 35.63564395083754]],
    [ "1109883152",[-80.37211786960323, 39.183942745569226]],
    [ "West Milford Substation",[-80.37495157173595, 39.1823831667612]],
    [ "Hanesbrands, Inc.",[-81.89984289586089, 35.350615033204626]],
    [ "Eaton Aeroquip Corp.",[-81.90394991978862, 35.342921365263415]],
    [ "1109923007",[-81.91975055278017, 35.36438636670046]],
    [ "1109923011",[-81.9308210978708, 35.35853631716968]],
    [ "1109923012",[-81.93054531861212, 35.360917374085815]],
    [ "1109923013",[-81.92994909999999, 35.3590821]],
    [ "Cleghorn Substation",[-81.95325210718488, 35.369173863821416]],
    [ "1109923023",[-81.96086678105746, 35.40610744391586]],
    [ "1109923026",[-81.79717474997236, 35.341635254304755]],
    [ "1109923029",[-81.7395729, 35.51691405]],
    [ "1109923031",[-81.9145876738706, 35.351274806418374]],
    [ "Rocky Mountain Power",[-111.9940128109245, 40.316712704865]],
    [ "Lake Lure Retail Substation",[-82.18361395957425, 35.42512077464775]],
    [ "Tryon Retail Substation",[-82.23624003644277, 35.21903239269628]],
    [ "1110085093",[-82.38942093290588, 35.245810722046066]],
    [ "1110085101",[-82.41273684999999, 35.27571725]],
    [ "Kimberley-Clark Corp.",[-82.46804749999998, 35.34640199999999]],
    [ "1110085117",[-82.35883176534023, 35.371177261027995]],
    [ "1110274040",[-82.5514718281394, 35.28920189497194]],
    [ "Brevard Retail Substation",[-82.73733910000001, 35.2157001]],
    [ "1110274072",[-82.89737917779338, 35.15439557928123]],
    [ "Duke Energy",[-82.5563731537658, 35.35207887100819]],
    [ "1110274076",[-82.55317293899309, 35.42491560887776]],
    [ "Upland Substation",[-75.23927679183309, 39.98417456242276]],
    [ "1110401629",[-99.91914729476584, 46.427188304390654]],
    [ "1110401635",[-99.97884025809708, 46.37136529205786]],
    [ "Clyde Generating Substation",[-85.68251576684716, 42.77507368879239]],
    [ "1110404955",[-101.1467343505108, 46.95073766647015]],
    [ "1110404957",[-101.1524670753715, 47.02005262167571]],
    [ "1110406385",[-102.08457707570142, 46.83431239165014]],
    [ "1110435380",[-101.07337024781417, 39.30813424730123]],
    [ "1110435381",[-101.37261393334767, 39.39619581668044]],
    [ "1110435383",[-101.91121572501642, 39.43709320589033]],
    [ "1110462361",[-82.54191252617157, 35.47257488480956]],
    [ "1110462395",[-82.52631566268703, 35.47877340656095]],
    [ "1110462397",[-82.48674241693102, 35.54423773428319]],
    [ "1110462398",[-82.43105292376619, 35.60577435758483]],
    [ "1110462402",[-82.39766864163833, 35.52386093360493]],
    [ "1110462405",[-82.58912590647763, 35.50553528706015]],
    [ "1110462407",[-82.63854726995541, 35.53917758911062]],
    [ "1110462411",[-82.6358457504158, 35.53818113346381]],
    [ "1110514276",[-94.69186348013324, 35.51051821922996]],
    [ "1110514303",[-94.77226435645176, 35.51073282797275]],
    [ "Bakersville Substation",[-82.17004251817615, 36.032673895037746]],
    [ "Lynnville Substation",[-87.01832515921092, 35.3741078771191]],
    [ "Marshall Hydroelectric Step-Up",[-82.71054434999999, 35.7923779]],
    [ "1110590590",[-82.96819364999999, 35.51465134999999]],
    [ "1110590591",[-82.9169216551747, 35.51384021135033]],
    [ "1110596038",[-100.58667452599268, 32.88465620345261]],
    [ "1110596056",[-100.58264781894592, 32.873145037957386]],
    [ "1110607555",[-96.78087453402688, 34.49460351729757]],
    [ "1110607561",[-96.7325924795155, 34.01336867066366]],
    [ "1110607567",[-96.67391614525265, 33.969756982524906]],
    [ "1110607570",[-96.75198685000001, 33.8927093]],
    [ "1110621171",[-103.35051308168671, 32.91449519203953]],
    [ "Lovington Sub",[-103.30186768909945, 32.88502686504754]],
    [ "1110647437",[-85.62823695000002, 31.455035050000006]],
    [ "1110732511",[-94.72850043068685, 35.551957244025786]],
    [ "1110742514",[-97.54545511246234, 34.226295375024584]],
    [ "1110742515",[-97.26551292496313, 34.16803234275297]],
    [ "1110742519",[-97.17292507493934, 34.18234450770972]],
    [ "1110742521",[-97.17719145, 34.188127400000006]],
    [ "1110742525",[-97.10214985105948, 34.208519013244285]],
    [ "1110742530",[-97.07125557493333, 34.302912807849545]],
    [ "1110742535",[-96.97145386460448, 34.511395131669694]],
    [ "1110742543",[-97.11001817687772, 34.44498771661581]],
    [ "1110742545",[-97.0895606751393, 34.17895910761463]],
    [ "1110742549",[-97.14220126832797, 34.115465454870005]],
    [ "1110742554",[-97.28304947515676, 34.12531513761614]],
    [ "1110752830",[-94.56004005, 35.577685450000004]],
    [ "1110776134",[-85.9637492, 31.781782350000004]],
    [ "1110776137",[-85.9628083050998, 31.78969331316567]],
    [ "1110813121",[-97.91576611863391, 34.7989476069005]],
    [ "1110813124",[-97.9571259, 34.82747705]],
    [ "1110902638",[-97.14798934710088, 33.653505524838366]],
    [ "1110902640",[-96.91450605919431, 33.65096842882172]],
    [ "1110902642",[-97.00578267432361, 33.63296854390802]],
    [ "1110902644",[-96.99930173441001, 33.54956430551142]],
    [ "Thornapple Substation",[-85.4939456912494, 42.956233763677616]],
    [ "Consumers Energy",[-85.49500320262736, 42.95679805924018]],
    [ "Swain Tie Substation",[-83.4603544098433, 35.41208706177193]],
    [ "1110962168",[-83.43676163083622, 35.431366804959126]],
    [ "Lake Emory Substation",[-83.37648699876064, 35.21973272512555]],
    [ "1110962185",[-83.39977112315253, 35.2116182856344]],
    [ "1110962186",[-83.40306981414165, 35.171364481430174]],
    [ "1110962188",[-83.39521895, 35.1582691]],
    [ "1110962191",[-83.38909963063267, 35.06199644719803]],
    [ "1110962192",[-83.30473186958166, 35.019493749158315]],
    [ "1110962193",[-83.38312337339154, 35.07009420714099]],
    [ "1110962194",[-83.36085149848792, 35.1969676293913]],
    [ "1110962196",[-83.37315647155788, 35.17636346936319]],
    [ "Jackson Paper Manufacturing",[-83.21630114147389, 35.37641822729318]],
    [ "1111061064",[-96.88335860000001, 33.9843172]],
    [ "1111061065",[-96.9908064495967, 34.00943223476764]],
    [ "1111061068",[-97.42259336526013, 34.02804439639911]],
    [ "1111061070",[-97.60008682184957, 34.158626887785864]],
    [ "1111157199",[-83.1183253684873, 35.13368810766758]],
    [ "1111157202",[-83.21066613754354, 35.061611321670824]],
    [ "1111157213",[-83.1026658859228, 35.25370897573106]],
    [ "1111157216",[-83.0166382932744, 35.21929941020633]],
    [ "1111224457",[-97.5120861, 34.2167152]],
    [ "1111224458",[-97.61565612521156, 34.433369889170955]],
    [ "1111224464",[-97.6938663, 34.57499575]],
    [ "1111321243",[-81.96984676598353, 35.64960296717887]],
    [ "1111321246",[-81.6823207518497, 35.67779961683548]],
    [ "1111321248",[-81.7005967, 35.705746250000004]],
    [ "1111517824",[-97.96435797665157, 34.46482371665685]],
    [ "1111517826",[-97.96686161957425, 34.464092561805984]],
    [ "1111517830",[-97.96242844999999, 34.42031514999999]],
    [ "1111517833",[-97.98181512519443, 34.375992541918436]],
    [ "1111517835",[-98.22459165000002, 34.363963999999996]],
    [ "1111517837",[-98.21257480000001, 34.561681750000005]],
    [ "1111517839",[-98.31287257496399, 34.36851854281156]],
    [ "1111517843",[-98.29647396394722, 34.3652309751012]],
    [ "1111517844",[-98.64763653824491, 34.37016231408772]],
    [ "1111517848",[-98.63380017010834, 34.562304150075896]],
    [ "1111517851",[-98.52801263569553, 34.17419981848333]],
    [ "1111641933",[-81.17644271509754, 35.87980418972396]],
    [ "City of Lexington",[-80.13594321785263, 36.008711398543255]],
    [ "City of Lexington",[-80.32210122325758, 35.88224453965983]],
    [ "City of Lexington",[-80.26434641189532, 35.82981328052299]],
    [ "1111650089",[-97.9277050248823, 34.502524259913855]],
    [ "1111652980",[-80.64022806256445, 36.22621227649658]],
    [ "1111652986",[-79.87298703843153, 36.03526872621676]],
    [ "1111652987",[-79.87378547648362, 36.03544130003234]],
    [ "1111652988",[-79.92556730000001, 36.243963900000004]],
    [ "1111653016",[-79.54666248995085, 36.115849827616486]],
    [ "1111653019",[-79.18807182414683, 35.90246796179856]],
    [ "1111653021",[-79.07624148622611, 35.96795192720475]],
    [ "1111662116",[-85.69354059951894, 33.39589894170571]],
    [ "1111754511",[-78.93358666750429, 36.00605896483523]],
    [ "1111754539",[-79.00053900044698, 36.212277183217196]],
    [ "1111754543",[-78.71714567104168, 35.91852940510714]],
    [ "1111754545",[-78.51725524766529, 35.952338316073636]],
    [ "1111754547",[-78.50583021888534, 35.92520368249194]],
    [ "1111754550",[-78.40732053208038, 35.932951412134216]],
    [ "Novozymes, Inc.",[-78.41140255078983, 36.099299528597015]],
    [ "1111754558",[-78.31820666635868, 36.10226374705907]],
    [ "1111754560",[-78.34930606810245, 36.038152206835115]],
    [ "1111754562",[-78.30459417575487, 36.10241508921369]],
    [ "1111754564",[-78.24948759635905, 36.108627264154265]],
    [ "1111754566",[-78.1696916241197, 36.091446091254376]],
    [ "1111804303",[-78.19336644607604, 35.4991677847004]],
    [ "1111804307",[-78.36613918937816, 35.69303865002824]],
    [ "1111804308",[-78.1418358182796, 35.782723335224404]],
    [ "1111804318",[-78.25646413774649, 35.752617327590286]],
    [ "1111804320",[-78.25387832289779, 35.66360723845587]],
    [ "1111804325",[-77.80416016059274, 35.916169773704866]],
    [ "1111804336",[-77.85739793897899, 35.9846512338568]],
    [ "1111863837",[-100.56061981829393, 33.00771404340612]],
    [ "1111901665",[-99.71974003443599, 35.37715122888522]],
    [ "1111901671",[-98.22731514358462, 35.08112434906878]],
    [ "1112112902",[-99.6700245618952, 33.74393079301936]],
    [ "Prestonburg Substation",[-82.78187626762623, 37.678829581753945]],
    [ "Tallahatchie Valley Electric Power Association",[-89.8092852546194, 34.53993999358697]],
    [ "1112269024",[-97.83447052488266, 34.695375804846506]],
    [ "1112269028",[-97.80542592868089, 34.61176157522816]],
    [ "1112269033",[-97.90065006770963, 34.429548450429756]],
    [ "1112269037",[-97.88736023674439, 34.783783081533244]],
    [ "1112269040",[-98.22463101227427, 34.89888861822747]],
    [ "1112286153",[-99.10989185186816, 26.685656092216856]],
    [ "1112286162",[-99.05175268672791, 26.704046069636483]],
    [ "1112303924",[-97.42672670080378, 33.719659870898035]],
    [ "1112303932",[-97.52413800000001, 33.57675390000001]],
    [ "1112303935",[-97.83438866557115, 33.68467517884294]],
    [ "1112395111",[-86.68763984432, 41.61029321434806]],
    [ "1112488130",[-97.82530684927393, 33.561275217707056]],
    [ "1112493254",[-97.20491694955156, 33.25599681679954]],
    [ "1112505711",[-98.19765765000001, 33.4431426]],
    [ "1112505715",[-98.50981393928767, 33.49665457536998]],
    [ "1112505718",[-98.71562440746935, 33.42212432478745]],
    [ "1112505719",[-98.77684431730205, 33.362893876900394]],
    [ "Bronco Plains Substation",[-103.05015400337177, 39.111282628504604]],
    [ "Rush Creek ll Substation",[-103.23447434267266, 39.10438371708602]],
    [ "1112556048",[-94.63151458310082, 34.03208898356483]],
    [ "1112556059",[-94.6853421270784, 34.13896333345684]],
    [ "1112556501",[-75.69907171329079, 43.91354670265227]],
    [ "1112598602",[-98.48330960840323, 33.79569682241508]],
    [ "1112598605",[-98.47699051399442, 33.84372141869765]],
    [ "Consumers Energy",[-85.70294342999986, 42.94782930728588]],
    [ "1112702467",[-99.34563941226902, 36.18046512405088]],
    [ "1112710059",[-99.67533643296242, 35.45176705026799]],
    [ "1112713391",[-78.96755711248437, 36.10072832160352]],
    [ "1112713395",[-78.31817148826525, 36.47742275542415]],
    [ "1112713399",[-78.09630079263101, 36.30024046251137]],
    [ "1112713404",[-79.08224570000002, 36.47646475]],
    [ "1112713405",[-79.08241751157423, 36.477352308756885]],
    [ "1112713407",[-79.06548587788404, 36.48228662763624]],
    [ "Person Substation",[-79.05053941125652, 36.48105828541728]],
    [ "1112727345",[-95.35236283249692, 34.11579240670438]],
    [ "1112727347",[-95.72753399999999, 34.23792854999999]],
    [ "1112727350",[-96.4973454246425, 34.08570731992773]],
    [ "Central Crossing Substation",[-95.69413213621269, 38.97975575500116]],
    [ "1112763481",[-77.50241816441283, 35.87491854055769]],
    [ "1112763485",[-77.51220229799078, 35.75835640165224]],
    [ "1112763490",[-77.25703625168747, 35.817639721807595]],
    [ "1112763492",[-77.22680719980836, 35.82653922352641]],
    [ "17th & Fairlawn Substation",[-95.74240862905863, 39.03581340036801]],
    [ "Burns Substation",[-96.78849534054378, 38.06228544898167]],
    [ "Consumers Energy",[-85.41780280000002, 42.69020625000001]],
    [ "1112802908",[-77.08274176023127, 36.426093977400654]],
    [ "1112802909",[-77.11274818902024, 36.44152487582586]],
    [ "1112816229",[-98.58689548058442, 33.86044833410465]],
    [ "1112826372",[-97.40988411049031, 36.843028698275624]],
    [ "1112826399",[-97.47065000204543, 36.89694292441656]],
    [ "1113011073",[-78.11431048975547, 36.53709983481624]],
    [ "1113011074",[-78.11484437296753, 36.53666216146]],
    [ "1113011087",[-78.00946878558211, 36.576263418662876]],
    [ "1113011088",[-77.94196308253183, 36.540742855793376]],
    [ "1113011101",[-77.67151367376661, 36.348626740176684]],
    [ "South Justice Branch Substation",[-77.63360251592471, 36.22071081661919]],
    [ "1113011104",[-77.63300902409169, 36.220247500403985]],
    [ "Dawson's Crossroads Substation",[-77.51421300200623, 36.16565593892021]],
    [ "Chestnut Substation",[-77.70111120016298, 36.177650840246045]],
    [ "Hunter Substation",[-97.68292517217219, 36.57481683173085]],
    [ "1113019371",[-97.68317095117477, 36.57608623036841]],
    [ "1113042382",[-97.68656803866374, 36.44775789593386]],
    [ "1113075109",[-77.72554733782734, 36.09415949644894]],
    [ "1113075118",[-77.56008208191933, 35.911726979228554]],
    [ "1113075119",[-77.54597600782742, 35.92332916896761]],
    [ "1113075120",[-77.54586430633177, 35.923025168660985]],
    [ "1113075123",[-77.58220889246728, 35.90677842274927]],
    [ "1113075124",[-77.62188023486948, 35.91178666715311]],
    [ "1113075132",[-77.65845921208984, 35.94899629322066]],
    [ "Mayo-Dunbar Substation",[-77.67234817157154, 35.96392725563392]],
    [ "1113116398",[-97.8706110397901, 35.70437858193628]],
    [ "1113156909",[-77.80373797724307, 35.93694325046334]],
    [ "1113156922",[-76.22613630796123, 36.31281908444511]],
    [ "City of Elizabeth",[-76.23695688183281, 36.29728755571432]],
    [ "City of Elizabeth",[-76.23284156902969, 36.30693701411541]],
    [ "City of Elizabeth",[-76.25503141094072, 36.30975260648086]],
    [ "1113185775",[-98.82853827647999, 35.7074993183145]],
    [ "1113194296",[-114.37614954197518, 35.86473885981387]],
    [ "1113210772",[-77.58004559139721, 38.777364367904276]],
    [ "Rollins Ford Substation",[-77.57924912108845, 38.77793981451952]],
    [ "1113330490",[-89.99539365, 44.187231499999996]],
    [ "1113409939",[-77.43705745196937, 38.49253015210815]],
    [ "Rockingham Substation",[-71.2253092411674, 42.77433452471551]],
    [ "1113503924",[-117.21986371305803, 33.90153216410323]],
    [ "Banner Elk Substation",[-81.88482527633107, 36.161538945551875]],
    [ "Mount Dora Substation",[-81.6431644431325, 28.807545105597796]],
    [ "1113608568",[-81.56431476162552, 28.72698491195993]],
    [ "ReEnergy Livermore Falls Substation",[-70.1616492, 44.431783550000006]],
    [ "1113628894",[-81.26405361012152, 28.785730615378426]],
    [ "1113628912",[-81.18476625, 28.667316999999997]],
    [ "1113672590",[-98.52229041355409, 33.372206275638675]],
    [ "1113672592",[-98.53622969921949, 33.22587376895832]],
    [ "1113672596",[-98.61915811285495, 33.2181093494598]],
    [ "Rio Pinar Substation DUKE",[-81.25390252061958, 28.540828994107937]],
    [ "1113718067",[-81.2524866825098, 28.564299724409782]],
    [ "1113718073",[-81.19406702549956, 28.42769730912992]],
    [ "1113831956",[-93.96988151665856, 44.122865674821576]],
    [ "Twin Buttes 2 Substation",[-102.5466295839052, 37.77537412447053]],
    [ "1114737279",[-89.07165171415826, 34.48588079520561]],
    [ "1114769683",[-103.84331270710608, 39.17061346290805]],
    [ "1114793553",[-112.89425005260745, 42.700686278657656]],
    [ "1114794993",[-112.75388961784886, 42.72036477942551]],
    [ "1114867189",[-81.38991535, 28.669771899999997]],
    [ "1114867242",[-81.39184036045641, 28.423467474638908]],
    [ "1114911716",[-101.95934275688013, 47.97696020354568]],
    [ "1114911719",[-102.21982003173089, 48.328303436679036]],
    [ "1114961159",[-81.32118404893083, 28.650117831241026]],
    [ "1114961184",[-81.46516884255502, 28.447098812631534]],
    [ "Evergy",[-99.68117222725667, 37.85431092256008]],
    [ "North London Substation",[-71.50394534224642, 41.70913773003502]],
    [ "Wickford Junction Substation",[-71.49591873101727, 41.580569373988084]],
    [ "Chase Hill Substation",[-71.76947496884296, 41.41243774975185]],
    [ "Iron Mine Mill Substation",[-71.52564126689074, 41.9681218236189]],
    [ "Cadiz St Substation",[-87.88124815422142, 37.09765520097653]],
    [ "1115409911",[-85.38757585613611, 32.63619155026571]],
    [ "1115409912",[-85.41049932499115, 32.64837289103909]],
    [ "1115409919",[-85.421770955879, 32.62349002503139]],
    [ "1115409920",[-85.42915205000001, 32.632387349999995]],
    [ "1115420182",[-82.14290861171428, 28.302434435498018]],
    [ "1115420192",[-82.30291554060375, 28.280111875057617]],
    [ "1115420198",[-82.33072818719722, 28.211947680660984]],
    [ "1115420220",[-82.46597121725448, 28.197741307955987]],
    [ "1115470330",[-87.94742892068578, 42.50609855758061]],
    [ "1115507575",[-96.6018694759043, 34.0884045311658]],
    [ "1115507579",[-96.32553451331086, 34.113962280845854]],
    [ "1115507580",[-96.4256946, 34.200376]],
    [ "1115507584",[-96.37109894999999, 33.9783985]],
    [ "1115507842",[-96.9535891155243, 40.051936609925484]],
    [ "1115509080",[-97.03878719048627, 34.16783007482591]],
    [ "1115509082",[-97.00184247522618, 34.17103059067379]],
    [ "1115520508",[-96.0245267750457, 34.04571919371569]],
    [ "1115520511",[-96.0247696409713, 34.02666217092411]],
    [ "1115520518",[-95.7825051, 34.02880835]],
    [ "1115520520",[-95.53965584999999, 34.110078699999995]],
    [ "1115520521",[-95.41768455, 33.99033255000001]],
    [ "1115521684",[-94.16035768304288, 33.29100695707271]],
    [ "1115521686",[-94.16079319115806, 33.40177857362601]],
    [ "1115531317",[-90.40307397914341, 39.485268322982854]],
    [ "1115568162",[-101.05176702618776, 37.64141119999999]],
    [ "1115568171",[-101.34480167482887, 37.60495373944517]],
    [ "1115568176",[-101.39969298885903, 37.59160902007503]],
    [ "1115568178",[-101.40226288987338, 37.57541982926265]],
    [ "1115575243",[-97.2144403631136, 42.2302739735008]],
    [ "1115585305",[-85.38977720177012, 32.6400343137101]],
    [ "1115585311",[-85.43855104032802, 32.58627401336982]],
    [ "Knights South Substation",[-82.1541371894844, 28.073966825310723]],
    [ "1115588465",[-82.21862036474246, 28.02562111169335]],
    [ "Tuttle Hill Substation",[-72.00519814793516, 43.074246905536214]],
    [ "1115605393",[-104.24911622199801, 32.81275471520518]],
    [ "New Creek Wind Substation",[-79.1407132354339, 39.2000307155398]],
    [ "1115614494",[-103.99991657925261, 40.95873965082956]],
    [ "Indian Hills Substation",[-95.79757350579006, 39.03632240191524]],
    [ "1115622463",[-85.94857249612207, 31.829027565027346]],
    [ "Roba Substation",[-85.57977225000002, 32.24595965]],
    [ "Whiteville Substation",[-89.13581639995373, 35.322129131304045]],
    [ "1115739097",[-85.56025105, 31.7802519]],
    [ "Colonial Pipeline Company",[-89.49488894796946, 30.73405863331856]],
    [ "1115783394",[-84.68342543307291, 43.43099558096645]],
    [ "Judson Substation",[-85.16336659494632, 31.611822976250078]],
    [ "Consumers Energy",[-84.82664456414663, 43.21074854762246]],
    [ "1115817961",[-102.78679149243959, 46.85401827478341]],
    [ "Capps Substation",[-85.3013858257277, 31.493152290401977]],
    [ "1115831446",[-85.28699278899681, 31.55622352384657]],
    [ "1115831448",[-85.2160227, 31.62423675]],
    [ "Princeton Substation",[-87.89356650610522, 37.121321524392634]],
    [ "Banks Substation",[-85.82055661213205, 31.78614317528228]],
    [ "Monticello Substation",[-85.778979375216, 31.82495086418725]],
    [ "Grant Substation",[-83.06730510937425, 42.41281102926209]],
    [ "Stony Creek Substation",[-78.23948217384226, 42.7376724280308]],
    [ "1115995434",[-98.90383997943118, 46.087931568247775]],
    [ "1115995436",[-98.90314369999997, 46.0894786]],
    [ "1116006207",[-96.16885047146232, 43.42880714491718]],
    [ "1116006212",[-96.17609286822297, 43.3895781147234]],
    [ "1116006216",[-96.26557139391575, 43.878067825316904]],
    [ "1116071699",[-119.37061491455937, 39.67318487174673]],
    [ "1116071702",[-119.36812384031332, 39.67551757653031]],
    [ "1116143952",[-102.89725308756084, 47.90445582360987]],
    [ "1116143965",[-102.79133460909654, 47.92628498317636]],
    [ "Highland Park Substation",[-71.47266772472433, 41.993621639354956]],
    [ "Farnum Substation",[-71.5212724041744, 41.98001828107982]],
    [ "Baker Hill Substation",[-85.31546533766229, 31.753155974909763]],
    [ "1116173741",[-85.68415160575147, 31.38512392538973]],
    [ "Echo Substation",[-85.48142313093692, 31.456457098070604]],
    [ "1116278791",[-102.87586942459416, 47.864856886789376]],
    [ "1116282114",[-102.85765125682181, 47.74893757868151]],
    [ "1116283779",[-102.78418705007334, 47.44118005791146]],
    [ "1116285254",[-102.9601187983388, 47.54058140503134]],
    [ "Hector Switching Station",[-77.66958638525857, 41.87017853683581]],
    [ "Hector Substation",[-77.66934777487647, 41.869625534758065]],
    [ "1116391897",[-103.47504845284493, 47.863619270695814]],
    [ "1116391939",[-103.26342112496603, 47.90076864103986]],
    [ "1116391946",[-103.16790112498047, 48.08286994296388]],
    [ "1116417284",[-85.66604423925033, 31.314318796420682]],
    [ "Onsted Substation",[-84.18768564999999, 42.001425450000006]],
    [ "1116422716",[-101.16865703767355, 48.195034773122345]],
    [ "Elba Substation",[-86.0793803290144, 31.417002608737494]],
    [ "Whitewater Substation",[-86.00147563223192, 31.50660960341148]],
    [ "1116423571",[-99.56000132938395, 48.972098324854656]],
    [ "1116423572",[-99.56223594143023, 48.97236238687236]],
    [ "1116534505",[-103.22537502470333, 47.71502750710085]],
    [ "1116534506",[-103.26035610544861, 47.68714017156415]],
    [ "1116534507",[-103.46480461285525, 47.782636325047335]],
    [ "1116551197",[-84.68747902763984, 41.04109794203558]],
    [ "1116616100",[-87.55428792940832, 38.28892325025552]],
    [ "1116632032",[-86.86864908978545, 40.648933825510156]],
    [ "1116632089",[-86.87370496754983, 40.723850597070104]],
    [ "Opp City Substation",[-86.25783609999999, 31.2863685]],
    [ "Bridges Creek Substation",[-85.92980210767668, 31.31033112648163]],
    [ "1116640460",[-85.91819493662358, 31.37752256693906]],
    [ "1116644706",[-103.6514336760508, 47.97817898735301]],
    [ "1116644707",[-103.8821505322588, 47.906952615409224]],
    [ "1116644709",[-103.98607384765822, 47.80405787765207]],
    [ "1116684495",[-103.07427542588779, 47.35825427407552]],
    [ "1116871527",[-82.51641894034542, 27.865170782832422]],
    [ "1116871530",[-82.51581365166736, 27.911304300308224]],
    [ "TECO",[-82.4791844249342, 27.938928561626025]],
    [ "1116871539",[-82.42154392525542, 27.949241617265987]],
    [ "1116871547",[-82.74951853253444, 27.744519955037592]],
    [ "1116871549",[-82.71521006077123, 27.709246970849776]],
    [ "1116875861",[-82.73752874420856, 27.792862471474916]],
    [ "1116892234",[-102.90143305784262, 48.49122482097693]],
    [ "1116894608",[-87.48702032135438, 40.693921112498124]],
    [ "1116897700",[-102.9629308137603, 48.51821386881282]],
    [ "1116897705",[-102.78834828651014, 48.86475728538021]],
    [ "TECO",[-82.34163312498485, 27.954870792734386]],
    [ "The Mosaic Company",[-82.3903302, 27.860000499999995]],
    [ "1116902068",[-82.4062784, 27.908311599999998]],
    [ "Huntsville Utilities",[-86.75560586993353, 34.62049528214374]],
    [ "1116950697",[-85.86927897502939, 31.359884145612416]],
    [ "1116955222",[-82.30278198133254, 27.846621271837154]],
    [ "1116955241",[-82.434747, 27.735652849999997]],
    [ "1116955248",[-82.38658027716178, 27.733727094165232]],
    [ "1116977568",[-103.48899545915786, 32.811190135090854]],
    [ "1116983942",[-103.50456342311645, 32.7893300693076]],
    [ "1117021904",[-86.66732890399409, 32.59928285661432]],
    [ "1117080334",[-82.03158333427373, 27.88270707525473]],
    [ "1117080342",[-81.91796767024434, 27.89527236339938]],
    [ "1117080343",[-81.90439322532755, 27.898827139617502]],
    [ "TECO",[-81.86754264999999, 27.93042395]],
    [ "1117080367",[-81.91368292517751, 27.8390973540357]],
    [ "1117080368",[-81.91347706676513, 27.837263683435108]],
    [ "1117080370",[-82.04674192492737, 27.82062230527568]],
    [ "1117080397",[-82.09167189265249, 27.64674837497049]],
    [ "1117080402",[-82.0905204, 27.6419498]],
    [ "1117080405",[-82.15202120000001, 27.647200250000004]],
    [ "1117080409",[-82.13052111571555, 27.647872124995555]],
    [ "1117080411",[-82.11070214321393, 27.648228474450132]],
    [ "1117080412",[-82.09165225, 27.64865855]],
    [ "1117080416",[-82.03802670716175, 27.675209881845152]],
    [ "1117080419",[-82.05297382437011, 27.62421271132124]],
    [ "1117080420",[-82.0529769363081, 27.638066531244387]],
    [ "1117080422",[-82.05268202484307, 27.602528060263275]],
    [ "Duke Energy",[-82.0467498543741, 27.601271698592146]],
    [ "1117080433",[-82.04615414821502, 27.661275434669093]],
    [ "1117104330",[-81.32788635539735, 27.78991158231167]],
    [ "1117104334",[-81.54587817495373, 27.60344788924779]],
    [ "1117104338",[-81.62031536531482, 27.57417171390826]],
    [ "1117104342",[-81.77745055, 27.624669899999997]],
    [ "1117104347",[-81.75750409969429, 27.667896536649195]],
    [ "1117104396",[-81.74511502512773, 27.64542929436401]],
    [ "1117104397",[-81.81046529505487, 27.725156067664855]],
    [ "1117104403",[-81.85451099972401, 27.697667609539412]],
    [ "1117104406",[-81.8592132858814, 27.66053918141923]],
    [ "1117104408",[-81.859361511332, 27.645784830221363]],
    [ "1117104410",[-81.915898, 27.631537299999998]],
    [ "1117104413",[-81.94198850000001, 27.631495649999998]],
    [ "1117104415",[-81.94768879597267, 27.62877567521771]],
    [ "1117104417",[-81.80886474123547, 27.756843525032902]],
    [ "Sauk DPC Solar",[-90.3224374, 43.59437105]],
    [ "1117137924",[-81.80600082913844, 27.789389604723628]],
    [ "1117137934",[-81.93989569926707, 27.762451519284898]],
    [ "The Mosaic Company",[-81.93753923055434, 27.764232461824868]],
    [ "1117137939",[-82.01433933035294, 27.668226137215495]],
    [ "1117137962",[-82.05279545879671, 27.59317622559772]],
    [ "1117137963",[-82.05277538260673, 27.59384800456592]],
    [ "1117137966",[-82.14550578157291, 27.58998928606729]],
    [ "1117137967",[-82.16371057983865, 27.587124252950286]],
    [ "1117137969",[-82.17935528303387, 27.61232966654967]],
    [ "1117139178",[-81.74884424168074, 33.13779849802913]],
    [ "1117146558",[-81.93381646680244, 27.583629648744527]],
    [ "1117146561",[-81.95485098219876, 27.577522453670255]],
    [ "1117146562",[-81.98913325000001, 27.564693600000002]],
    [ "1117146564",[-81.94373677509904, 27.58591569249373]],
    [ "1117146565",[-81.9442607, 27.5864552]],
    [ "1117199650",[-82.1457763623542, 27.7120935224799]],
    [ "1117199651",[-82.14112115, 27.71542925]],
    [ "1117199653",[-82.1213630409315, 27.729203425102895]],
    [ "1117199656",[-82.16534200000001, 27.721539750000005]],
    [ "1117199661",[-82.13165814999999, 27.7072126]],
    [ "1117199662",[-82.1174935, 27.6933973]],
    [ "1117199666",[-82.10163200548261, 27.681123323972244]],
    [ "1117199674",[-82.16803245000001, 27.6460238]],
    [ "1117199677",[-82.1495083332717, 27.64981829986298]],
    [ "1117199682",[-82.19314231875015, 27.66078868646255]],
    [ "1117199683",[-81.88884375, 27.572257100000005]],
    [ "1117199685",[-81.96897408372918, 27.614476682927272]],
    [ "Peace River Electric Cooperative",[-82.39049532492616, 27.436115587623302]],
    [ "1117225015",[-82.46826992526964, 27.422406738987632]],
    [ "1117237783",[-82.09259983042446, 27.457511037928754]],
    [ "1117237786",[-81.87425274999998, 27.424637950000005]],
    [ "Florida Power & Light",[-82.43122371385877, 27.104930599967403]],
    [ "1117237829",[-81.7821756809093, 26.694840483775216]],
    [ "1117241832",[-81.46597620053514, 26.430277018283892]],
    [ "1117258248",[-86.9025778372447, 41.537955513863174]],
    [ "Florida Power & Light",[-80.7988891710298, 27.629389335435707]],
    [ "1117260914",[-80.37963553759172, 27.63113437497179]],
    [ "1117260917",[-80.32564009652378, 27.45070599556312]],
    [ "1117260984",[-80.56531843164734, 27.052751746147855]],
    [ "1117260985",[-80.56403390378645, 27.052755000032345]],
    [ "1117392648",[-90.81903582508521, 42.97473144575575]],
    [ "Southern Natural Gas",[-88.286366894121, 32.34054987089057]],
    [ "1117410990",[-88.13274342905173, 32.45352868442572]],
    [ "1117410994",[-88.054121, 32.4528437]],
    [ "1117410999",[-87.85674743433697, 32.489009267557]],
    [ "1117411001",[-87.81449236021712, 32.514646404435595]],
    [ "1117411009",[-87.78319727020228, 32.22488037299948]],
    [ "Alabama Power",[-87.76439885302122, 31.76679592536888]],
    [ "1117432315",[-80.31556956153314, 26.91966993593784]],
    [ "1117432323",[-80.55155669999999, 26.827432899999998]],
    [ "1117432324",[-80.55053094511717, 26.82756992496105]],
    [ "1117454542",[-77.52269176768104, 36.70941360790821]],
    [ "Independence Wind Farm",[-91.56836334269956, 42.428022471626214]],
    [ "1117508940",[-85.8768698457829, 31.642120632494972]],
    [ "Singing River Electric Cooperative",[-88.51382790926641, 30.92847185668182]],
    [ "1117515922",[-88.55442052504942, 30.919740790134053]],
    [ "Cooperative Energy",[-89.75578640012553, 31.62159853297455]],
    [ "Cooperative Energy",[-89.39376001140853, 31.2203371257809]],
    [ "1117586295",[-89.44748647212445, 31.33125970700361]],
    [ "Cooperative Energy",[-89.11758278821522, 31.42947056449999]],
    [ "Cooperative Energy",[-89.16575146596384, 31.367872025769568]],
    [ "1117602523",[-89.16533183288217, 31.367037855550155]],
    [ "1117602525",[-89.10556516006766, 31.579629632821526]],
    [ "1117602528",[-89.17453924976402, 31.436117740474884]],
    [ "Bay Springs Substation",[-89.2627035104488, 31.99036329665643]],
    [ "Wiggins Switching Station",[-89.190374, 30.860040600000005]],
    [ "Big Level Substation",[-89.05123705949833, 30.815053796462298]],
    [ "Richmond Substation",[-75.0979105751135, 40.00195982547626]],
    [ "Kingsford Hts. Substation",[-86.70023084442575, 41.483940818585566]],
    [ "1117698274",[-89.3476549, 31.475630499999998]],
    [ "1117862002",[-77.04939252195855, 38.34375544264405]],
    [ "Pearl River Valley Electric Power Association",[-89.41623806799983, 31.058578175206886]],
    [ "Sharon Switching Station",[-71.17319688585131, 42.14008974257508]],
    [ "1117988165",[-111.06992024784493, 45.72249454462029]],
    [ "1118016676",[-80.26352461969118, 26.034221199189005]],
    [ "1118030492",[-80.19863426880578, 25.790572485881018]],
    [ "1118030494",[-80.44579464307337, 25.513457403994433]],
    [ "Tyson Foods",[-85.31811509999999, 31.805669]],
    [ "Clayton Substation",[-85.45283973864174, 31.883193670451895]],
    [ "South Union Springs Substation",[-85.70877891693884, 32.142201970766095]],
    [ "Midway Substation",[-85.51861451751724, 32.057657822574726]],
    [ "Comer Substation",[-85.39167286294324, 32.022355827368955]],
    [ "1118058976",[-85.12249140858052, 32.00191602904562]],
    [ "1118058982",[-85.06118569906506, 32.14736121668338]],
    [ "Carbo Ceramics Substation",[-85.1605807, 31.877808500000004]],
    [ "Pearl River Valley Electric Power Association",[-89.35373346666667, 31.27596376666667]],
    [ "Pearl River Valley Electric Power Association",[-89.40827257508482, 31.32154409307591]],
    [ "1118069072",[-95.01690056736099, 45.65755676783092]],
    [ "Gilman Substation",[-106.3935435792977, 39.53091577365387]],
    [ "1118139817",[-92.43675968177305, 45.784966565067904]],
    [ "1118139826",[-92.67811518539561, 45.779404459353366]],
    [ "1118139831",[-92.66094542501907, 45.75892394141695]],
    [ "1118170167",[-85.93584511798512, 31.170123504876]],
    [ "1118170169",[-85.63604040000001, 31.16428115]],
    [ "1118170171",[-86.04587254999998, 31.097774049999995]],
    [ "Geneva Substation",[-85.90128008062413, 31.046606076067476]],
    [ "Consumers Energy",[-85.63271172504453, 42.89072249601055]],
    [ "1118184859",[-95.77482862133502, 43.58115377126901]],
    [ "Windstock Windfarm Substation",[-96.07722292542978, 43.97938773164588]],
    [ "Maynard Substation",[-85.74216612352109, 42.9478765563977]],
    [ "1118235576",[-87.4647909653278, 41.418159675044066]],
    [ "1118419696",[-78.81037450000001, 36.13779080000001]],
    [ "Garner Substation",[-86.10832209127906, 31.11240933720256]],
    [ "1118472189",[-96.53795531248977, 44.8643108179789]],
    [ "1118505345",[-86.33652067273437, 31.011740366690944]],
    [ "Virginia Electric and Power Company",[-76.91033216842742, 36.90782507709516]],
    [ "1118795089",[-108.9506893745752, 33.81095189505603]],
    [ "Manomet Substation",[-70.57745042895513, 41.919055489474964]],
    [ "Sacramento Municipal Utility District",[-121.29649249652502, 38.302487914436234]],
    [ "1118814338",[-85.79984869999998, 38.32013334999999]],
    [ "1118977437",[-95.22571256134303, 42.37741761357757]],
    [ "London Hydro Substation",[-81.32069026683072, 38.18287986653462]],
    [ "Bethel Substation",[-92.06313955453328, 42.94873082894776]],
    [ "1119057910",[-92.06201979771232, 42.94997304968034]],
    [ "Pine Level Substation",[-86.06991872486404, 32.029353254771095]],
    [ "Webb Substation",[-85.31299919284997, 31.255337179787855]],
    [ "1119094141",[-85.33656701271242, 31.33488982879701]],
    [ "1119184788",[-95.48329956030157, 31.48642911057809]],
    [ "1119184790",[-95.45270754999999, 31.596732050000004]],
    [ "1119184813",[-85.57771930216053, 30.143697800621975]],
    [ "1119184814",[-85.60413740668375, 30.076128466286846]],
    [ "Sherman Substation",[-72.93114987047164, 42.72895132522539]],
    [ "1119241028",[-86.15884402533104, 32.330962561505885]],
    [ "1119241029",[-86.17133819703452, 32.31472332970824]],
    [ "1119241040",[-86.0941792, 32.332039800000004]],
    [ "1119241041",[-86.12989500470246, 32.30972275641342]],
    [ "1119241047",[-86.00875344999999, 32.29088005]],
    [ "Mochila Substation",[-94.8472194502262, 39.736472929244016]],
    [ "1119264692",[-108.44022200887309, 39.08185394153604]],
    [ "1119269054",[-86.29406510000001, 31.754778650000002]],
    [ "Station E",[-121.47325276287297, 38.58628084454338]],
    [ "1119326329",[-86.2305442, 32.330966599999996]],
    [ "1119326334",[-86.18262302491453, 32.37334279247969]],
    [ "1119326336",[-86.17332301442661, 32.390596996313555]],
    [ "1119326340",[-86.10061638178888, 32.37435598518521]],
    [ "GKN Aerospace, Inc.",[-85.88561263135321, 32.483421954021956]],
    [ "1119326366",[-85.889583936825, 32.53490656482548]],
    [ "Waugh Substation",[-86.04836915999799, 32.36637947342109]],
    [ "1119326372",[-86.27915210178547, 32.386914628012704]],
    [ "1119326376",[-86.25955981796, 32.40874301466821]],
    [ "1119326378",[-86.2397756865581, 32.404004462444824]],
    [ "1119326429",[-86.3060267120266, 32.38074007435529]],
    [ "Lafayette District Substation",[-86.03558742373708, 36.52514930147482]],
    [ "1119415135",[-86.2652103, 32.41373365]],
    [ "1119415163",[-86.30244192508937, 32.41959749256427]],
    [ "1119415172",[-86.20321202529428, 32.439188504984216]],
    [ "1119415178",[-85.9915241248296, 32.54714228981331]],
    [ "1119415180",[-86.01051378170663, 32.63392540500855]],
    [ "1119460622",[-95.81229888742305, 29.32645433129615]],
    [ "1119460623",[-95.81390450557883, 29.327637639123655]],
    [ "1119460624",[-95.77073476604615, 29.35968113257923]],
    [ "1119460625",[-95.76927930112842, 29.35847803333351]],
    [ "1119460626",[-95.73364908708726, 29.393207116007247]],
    [ "MidAmerican Energy",[-94.13165931268418, 42.98685342713418]],
    [ "Saco Substation",[-85.8195390536412, 31.953898784400916]],
    [ "Graceville Substation",[-85.52230706778272, 30.95763557674138]],
    [ "1119663232",[-86.37007303620761, 31.49843878046396]],
    [ "Findley Hill Substation",[-86.24892645, 31.702395149999997]],
    [ "1119663236",[-86.26353622104907, 31.582164146767347]],
    [ "1119663237",[-86.2661439734998, 31.71500359479243]],
    [ "Luverne Substation",[-86.27042041789696, 31.71296290957145]],
    [ "1119717974",[-97.11801533447061, 32.94863698244454]],
    [ "Bates Street Substation",[-71.16816437325004, 41.67991550278432]],
    [ "Gilboa Substation",[-80.91420783625439, 38.30483656713207]],
    [ "1119735616",[-80.99611090929444, 38.303692517829646]],
    [ "1119735622",[-81.29183026255735, 38.20017191774918]],
    [ "1119736631",[-120.1808858597503, 45.60653267364054]],
    [ "Linden Road Switching Station",[-81.22560765563937, 38.706744496414636]],
    [ "1119861130",[-85.8130868270221, 37.16772849332193]],
    [ "Munfordville Substation",[-85.90323534099716, 37.27098202833841]],
    [ "1119889649",[-86.3208867825056, 32.36098721588289]],
    [ "1119889652",[-86.29238578476762, 32.36098243205844]],
    [ "1119889654",[-86.26499835521214, 32.353481344860995]],
    [ "1119889702",[-86.39228642162043, 32.385196478992754]],
    [ "1119889710",[-86.46414276186023, 32.43532723907004]],
    [ "International Paper Substation",[-86.46834661833392, 32.41873067721416]],
    [ "1119889715",[-86.53845724953906, 32.32364641845449]],
    [ "Dunbarton Tap Substation",[-71.5797780447373, 43.064301991747755]],
    [ "1120005785",[-92.34638228478914, 45.29729213331012]],
    [ "1120005787",[-92.38229424024816, 45.30370162281714]],
    [ "1120009232",[-103.60756032633905, 32.82814712296644]],
    [ "1120062989",[-86.44356004373039, 32.301744125833174]],
    [ "1120062990",[-86.60502140000003, 32.2673295]],
    [ "1120062992",[-86.36435276876043, 32.31125195964482]],
    [ "1120063000",[-86.2660702511165, 32.160711652917676]],
    [ "1120063001",[-86.14384918509936, 32.15307386763864]],
    [ "1120063005",[-86.43327547471479, 32.200523292055344]],
    [ "Braggs Substation",[-86.79263342639867, 32.050612563364176]],
    [ "1120063013",[-86.43296609999999, 32.0523993]],
    [ "1120063015",[-86.35470075, 32.055211549999996]],
    [ "Ramer Substation",[-86.22497752254206, 32.02470085552694]],
    [ "Highland Substation",[-86.32004669999998, 31.943470649999995]],
    [ "1120063019",[-86.56576303136235, 31.977343391938206]],
    [ "Linde Substation",[-80.82717010854876, 28.67429544647423]],
    [ "1120071969",[-82.69507344700047, 29.894646932835553]],
    [ "1120071970",[-82.69435678317471, 29.893867454886546]],
    [ "1120081519",[-83.26639382516801, 30.17215241210385]],
    [ "1120081563",[-83.28288446535801, 30.521446017754176]],
    [ "Aucilla Substation",[-83.75614533481074, 30.488293356662165]],
    [ "1120134428",[-85.25454067513444, 29.691741406600777]],
    [ "Dead Lakes Substation",[-85.21396067470074, 30.2365274546851]],
    [ "Edwards Road Substation",[-85.64321173799974, 30.326073605697133]],
    [ "Freeport Substation",[-86.13266712635516, 30.515869753166182]],
    [ "Red Bay Substation",[-85.94425865, 30.620281099999996]],
    [ "PowerSouth Energy Cooperative",[-86.2401632609686, 30.842269424928258]],
    [ "Falgout Canal Substation",[-90.78222106453117, 29.41081855242144]],
    [ "Hector Substation",[-85.90766898507106, 32.11188174900352]],
    [ "Holyoke Substation",[-72.60991641340716, 42.19983624834418]],
    [ "Ingleside Substation",[-72.6466591704937, 42.17077826920584]],
    [ "1120254887",[-111.8493837181978, 33.39419295297328]],
    [ "Wetumpka Sub",[-84.62216210747182, 30.48333432793494]],
    [ "1120298772",[-84.81822510788831, 30.33462627901474]],
    [ "Bascom Substation",[-85.07678475000002, 30.8729055]],
    [ "Malone Substation",[-85.18078793067258, 30.929200005454426]],
    [ "Campvbellton Substation",[-85.39322335170921, 30.956947704043284]],
    [ "1120403641",[-116.46437216355109, 33.877627517639915]],
    [ "1120409135",[-116.75214585, 33.9121001]],
    [ "1120464411",[-80.81493121395549, 33.08411886861912]],
    [ "Pochassic Substation",[-72.8659133202225, 42.116026490848476]],
    [ "GE Tap Substation",[-73.22052100470346, 42.45558614065084]],
    [ "1120484077",[-103.80479241553194, 31.534363590141076]],
    [ "Appalachian Power Company",[-81.38940350868783, 38.599632305795815]],
    [ "Chipley Substation",[-85.52451772710927, 30.794565233333334]],
    [ "Bonifay Substation",[-85.72423543761252, 30.803489272639503]],
    [ "Caryville Substation",[-85.80342737741395, 30.796146064034577]],
    [ "Argyle Substation",[-86.27610106624411, 30.75672885747583]],
    [ "West Berry Substation",[-85.8922681650573, 30.351178681860407]],
    [ "1120682173",[-103.50466083148805, 32.75746983413675]],
    [ "Military Point Substation",[-85.62303320000001, 30.117356049999998]],
    [ "1120702009",[-85.69931532533055, 30.272264262880764]],
    [ "Smith Substation",[-85.69991924773272, 30.269947746836458]],
    [ "1120702011",[-85.70313468833022, 30.271690360658006]],
    [ "Gitts Run Substation",[-76.960443224364, 39.818912031738556]],
    [ "Harrington Street Substation",[-72.03706643270579, 42.242967951983225]],
    [ "Grayton Beach Substation",[-86.16365681823515, 30.340083968256312]],
    [ "Crystal Beach Substation",[-86.43400685000002, 30.38704475]],
    [ "Allentown Substation",[-87.07608339999999, 30.77306705]],
    [ "Bratt Substation",[-87.38361005946635, 30.957495897373242]],
    [ "1120726656",[-114.7982545392325, 36.541052367258665]],
    [ "Auburn Substation",[-86.53750023286823, 30.823552525452488]],
    [ "1120731744",[-86.36447596410378, 31.022660904133613]],
    [ "1120759929",[-80.33473931248697, 40.849704407523994]],
    [ "Koppel Steel Substation",[-80.31715700202926, 40.83371443476318]],
    [ "1120759939",[-80.36800474738183, 40.936954619441266]],
    [ "New Castle Substation",[-80.3675112638287, 40.9379201341669]],
    [ "1120764028",[-103.78456017614714, 32.6162612730163]],
    [ "Laurel Hill Substation",[-86.44560185121425, 30.945377783877174]],
    [ "Paxton Tap Switch",[-86.35465361901697, 30.990786629592716]],
    [ "Paxton Substation",[-86.31029592591686, 30.97025651107353]],
    [ "1120852514",[-87.2437435787244, 31.006298194135447]],
    [ "Grantsville Substation",[-81.09128154569564, 38.93193397953009]],
    [ "1120933531",[-87.26297005, 31.013961899999995]],
    [ "South Flomaton Substation",[-87.26364484999999, 31.0014183]],
    [ "1120946468",[-86.32967667645076, 31.320369439876444]],
    [ "1120946478",[-86.4979156, 31.2295664]],
    [ "Pine Woods Road Substation",[-86.48701361574963, 31.33106992482861]],
    [ "Chembond Substation",[-86.52638407388777, 31.341823642806023]],
    [ "Red Level Substation",[-86.60218335541764, 31.397470824579237]],
    [ "1120957693",[-87.18477032404206, 31.03401147771061]],
    [ "1120957695",[-87.11198359999999, 31.079075399999997]],
    [ "Georgia Pacific",[-87.1070889453132, 31.07694561369673]],
    [ "Georgia Pacific",[-87.11193618768662, 31.078753818916272]],
    [ "1120957743",[-87.06334439999999, 31.09517015]],
    [ "1120957745",[-87.06044413922322, 31.10585122798816]],
    [ "1120957747",[-87.07375876431533, 31.109894968531385]],
    [ "Wind Creek Substation",[-87.48430683763755, 31.099856870817785]],
    [ "Swift Lumber, Inc.",[-87.512281675004, 31.034782189902387]],
    [ "1120957766",[-87.49510787520238, 31.03043839162221]],
    [ "1120957768",[-87.51969634999999, 31.02494475]],
    [ "1120957770",[-87.60464166319676, 30.999151361453528]],
    [ "1120972458",[-76.85221905, 37.10216615]],
    [ "Huxford Substation",[-87.45811587527717, 31.223811257147073]],
    [ "1120987742",[-87.49481158069533, 31.515405466388874]],
    [ "1120987745",[-87.32144265, 31.526859950000006]],
    [ "1120987759",[-87.48384109132918, 31.58253017121362]],
    [ "Congers Substation",[-73.94571653912122, 41.134344080697105]],
    [ "1121044476",[-87.29492162518368, 31.517838342947066]],
    [ "1121044477",[-87.27444084999999, 31.528750350000003]],
    [ "1121044534",[-87.28433615000002, 31.569023300000005]],
    [ "1121044536",[-87.22811041939069, 31.64856334405938]],
    [ "1121044537",[-87.22637685000001, 31.649523999999996]],
    [ "1121044540",[-87.22545645000001, 31.701770700000004]],
    [ "Vredenburgh Substation",[-87.3146767, 31.82779365]],
    [ "1121057302",[-86.63513465000001, 31.833202800000002]],
    [ "Oak Hill Substation",[-87.07160230991771, 31.987691020429995]],
    [ "1121057306",[-87.26904492911511, 32.00670039312382]],
    [ "1121057310",[-87.27729666559468, 31.998129195067023]],
    [ "1121057312",[-87.28580272910732, 31.98820182519509]],
    [ "PowerSouth Energy Cooperative",[-87.29919589740749, 31.983465866653233]],
    [ "Franklin Substation",[-87.41179141036697, 31.727881024392204]],
    [ "1121057318",[-87.31085685669554, 31.998617630723135]],
    [ "1121061384",[-81.92543953256497, 37.17485464956438]],
    [ "1121135930",[-118.3832507800572, 35.1076266614176]],
    [ "Campus Substation",[-83.71090723838311, 42.292850522025375]],
    [ "1121501157",[-76.84574942567875, 37.124969758974125]],
    [ "1121514501",[-85.19370834100279, 31.818027920553515]],
    [ "1121514504",[-85.1473920319734, 31.7069313952893]],
    [ "Shaker Road Substation",[-72.52321044781723, 42.05070313280733]],
    [ "1121675051",[-76.96541350000001, 37.1685972]],
    [ "Hyde Park Substation",[-86.27679969046658, 43.32043542485019]],
    [ "1122021799",[-103.51572801755563, 32.58665601519606]],
    [ "Castleberry Substation",[-87.02705977504408, 31.33305014458123]],
    [ "1122065139",[-87.39913423019277, 31.432721513297537]],
    [ "Shomo Creek Substation",[-87.66266300000001, 31.30640535]],
    [ "Perry's Chapel Substation",[-87.75360458586557, 31.438929115033922]],
    [ "Carlton Substation",[-87.82970835, 31.32716655]],
    [ "Scyrene Substation",[-87.63879169936241, 31.772956729110184]],
    [ "McIntosh Substation",[-88.02744035, 31.2941039]],
    [ "Four Point Substation",[-88.3624314199801, 31.301977638993446]],
    [ "1122190087",[-99.4209322069426, 33.24618149552145]],
    [ "1122192461",[-83.04374653104782, 42.55029910769048]],
    [ "1122502636",[-116.05074650000002, 33.41182775000001]],
    [ "1122510836",[-104.12554485901423, 32.26209364524832]],
    [ "1122510839",[-104.1286059232562, 32.26588221042746]],
    [ "Phantom Substation",[-103.8644860350454, 32.159994134485764]],
    [ "Malaga Bend Sub",[-103.97269275118998, 32.241870086134476]],
    [ "1122513800",[-86.1358066467474, 39.98856837836459]],
    [ "Barre VT Substation",[-72.52248346085867, 44.19435417104582]],
    [ "City of Tupelo Water & Light Department",[-88.76487770179942, 34.27415759995741]],
    [ "1122818208",[-106.65847121700983, 35.23997402929356]],
    [ "1122900036",[-102.63029015849983, 34.0326079251535]],
    [ "1122903288",[-87.2976248, 41.015314800000006]],
    [ "1122906535",[-101.36267280000003, 35.25438716347429]],
    [ "1122906538",[-101.36280713265462, 34.43161789820649]],
    [ "1122906548",[-101.81368784996157, 33.89692934214048]],
    [ "1122906559",[-101.74821222014907, 33.47551295068425]],
    [ "1122906560",[-101.74598713036734, 33.47490132210073]],
    [ "1122931096",[-98.83159536667698, 33.92944479995422]],
    [ "1122931505",[-99.72631769897023, 33.732198337060666]],
    [ "1122955349",[-98.16141324999998, 33.142795899999996]],
    [ "1122955353",[-97.88169100051614, 33.033241368715515]],
    [ "1122955354",[-97.87101066131636, 33.027439258907926]],
    [ "Consumers Energy",[-85.71617989999999, 42.86357094999999]],
    [ "Cottonwood Sub",[-106.65279773262853, 35.198123647947575]],
    [ "1123069500",[-106.81554896566416, 34.616676252534646]],
    [ "1123151825",[-98.52135698659745, 34.59852323582614]],
    [ "1123151831",[-98.50007997494859, 34.59927690693468]],
    [ "1123151836",[-98.43382586378523, 34.59301479999999]],
    [ "1123153766",[-98.66731001521735, 34.609549119959944]],
    [ "1123155861",[-98.42107445977575, 34.62577714985508]],
    [ "1123155864",[-98.38812098187981, 34.60945546189745]],
    [ "1123167771",[-98.48452365389238, 33.897036622909454]],
    [ "1123193425",[-98.38383149099727, 34.98310637485515]],
    [ "1123193427",[-98.29306634502962, 34.88715215499397]],
    [ "1123194217",[-98.39490579335231, 35.204633874951746]],
    [ "1123221614",[-94.05241840864532, 37.268259225056056]],
    [ "1123221998",[-94.51075743609033, 37.39019136874632]],
    [ "Youngs Branch Substation",[-77.57820566304112, 38.79931560297274]],
    [ "East Fairfax Substation",[-72.9312218749368, 44.63662296145387]],
    [ "Ballard Road Substation",[-73.12205017354036, 44.699528859553546]],
    [ "1123611520",[-96.80807471984237, 35.13125739260608]],
    [ "1123611529",[-96.61469262496779, 35.145744160386535]],
    [ "Riverside Substation",[-74.96731484619839, 40.03719416927628]],
    [ "North Troy Substation",[-72.40376160229934, 44.96176252582136]],
    [ "Irasburg CZN Substation",[-72.27848191605514, 44.85159961850641]],
    [ "1123789384",[-91.73579740197832, 37.9894959261261]],
    [ "1124005340",[-92.92314440729406, 37.36841109648785]],
    [ "Hoyt HTI Substation",[-95.71540225875137, 39.27644926772614]],
    [ "Goff Substation",[-95.95728911270031, 39.64686610823397]],
    [ "Carousel Substation",[-94.92361912596462, 39.32913305645633]],
    [ "Norway Substation",[-83.48483705, 42.384750249999996]],
    [ "1124234386",[-83.46849418334075, 42.38249418332842]],
    [ "1124277957",[-93.81915916108466, 37.12331979568985]],
    [ "1124296382",[-73.88424115512105, 43.297505595213046]],
    [ "Tamworth Substation",[-71.21197861955572, 43.846838174527626]],
    [ "Huckins Hill Substation",[-71.65901754622705, 43.78176803878647]],
    [ "1124322979",[-98.76531425, 33.5471826]],
    [ "1124322980",[-98.76539137478284, 33.53871742450865]],
    [ "1124325453",[-98.55106085000001, 33.95779315]],
    [ "1124325457",[-98.49805728774787, 33.94286552473095]],
    [ "1124329770",[-97.49529429124703, 34.97228158932515]],
    [ "1124329773",[-97.55487910019423, 34.892399284075]],
    [ "1124329778",[-97.56357142483007, 34.84058705466176]],
    [ "1124329779",[-97.5809388, 34.79043835]],
    [ "1124329785",[-97.51079215000001, 34.75588385]],
    [ "1124329787",[-97.42329265000001, 34.7046869]],
    [ "1124396558",[-76.58089876783852, 36.799374917338675]],
    [ "Mount Tabor Substation",[-86.86608811295994, 34.44116707567179]],
    [ "1124441552",[-85.96481796941917, 39.127897106436414]],
    [ "1124444747",[-97.59879624999998, 34.820948699999995]],
    [ "1124444748",[-97.68515606545286, 34.82708612520097]],
    [ "1124444749",[-97.6933451202521, 34.75315999997383]],
    [ "1124444751",[-97.60639408995256, 34.757574124883945]],
    [ "1124444752",[-97.66274850691062, 34.82272725604811]],
    [ "1124444756",[-97.65881072256269, 34.844598806652066]],
    [ "1124504609",[-97.48463772506261, 35.27731180540792]],
    [ "1124510334",[-85.89413966767712, 32.523525451481134]],
    [ "1124510337",[-85.94407969999999, 32.41133205]],
    [ "1124510341",[-85.8551208171868, 32.356457689387774]],
    [ "1124515878",[-97.72807311304345, 35.551772080847215]],
    [ "1124515882",[-97.61068086664542, 35.55034752758873]],
    [ "1124515885",[-97.57297836559968, 35.552478861546504]],
    [ "1124573498",[-111.86168278703134, 33.32446092119459]],
    [ "1124575094",[-97.63922275963898, 35.60666877500849]],
    [ "1124575298",[-97.46977936691287, 35.710372216414086]],
    [ "1124650459",[-97.45103837487665, 35.66779859247436]],
    [ "1124650462",[-97.40780343538157, 35.685885068951485]],
    [ "1124650464",[-97.3168115396625, 35.69179652502127]],
    [ "1124650465",[-97.3543281, 35.6522075]],
    [ "1124650467",[-97.31201622334375, 35.60134504029441]],
    [ "1124650469",[-97.40604525000002, 35.559771600000005]],
    [ "1124650476",[-97.46268972730657, 35.57587471989512]],
    [ "1124650478",[-97.4788718402535, 35.63322392521924]],
    [ "1124652232",[-97.52813915537318, 35.556126371499495]],
    [ "1124672072",[-98.67884998855891, 35.5074653131904]],
    [ "1124672081",[-98.6769726934259, 35.52118339788144]],
    [ "1124672805",[-98.11924644999998, 35.77934485]],
    [ "1124672807",[-98.18884470685431, 35.863170024979624]],
    [ "1124699798",[-85.41857997869545, 32.24451655668339]],
    [ "1124797057",[-97.33879308719189, 35.5370839692121]],
    [ "1124801805",[-97.5112323248919, 35.47975004195436]],
    [ "1124817611",[-97.64074746360058, 35.432483466219026]],
    [ "Nolensville Substation",[-86.67540726774247, 35.93954023837752]],
    [ "1124898072",[-103.29555902717256, 32.355982737442986]],
    [ "Arkansas Valley Electric Cooperative",[-94.21739576686974, 35.10310148355536]],
    [ "1124983121",[-97.50954673896851, 35.454866812521566]],
    [ "1124985738",[-98.30744655000001, 35.29108705]],
    [ "1124985740",[-98.64954708548481, 35.5510781249006]],
    [ "1125028069",[-96.64120081200228, 35.94845906924375]],
    [ "1125028075",[-96.7496311831816, 35.92561773348698]],
    [ "1125035031",[-84.69831578852369, 38.052114904903796]],
    [ "1125057624",[-98.82799998476766, 35.62478836781163]],
    [ "1125057628",[-98.52665660501233, 35.77035881634931]],
    [ "FIXME Substation",[-94.62322981082212, 38.345637012432775]],
    [ "La Cygne Generation Substation",[-94.64535475586521, 38.34606901658518]],
    [ "1125083080",[-99.80466481415783, 35.52258438587683]],
    [ "1125086886",[-97.9749558630476, 35.01667177833888]],
    [ "1125086887",[-98.19716153227257, 34.900657560774135]],
    [ "Jayhawk Wind Energy Center",[-94.99051152494043, 37.70448118114043]],
    [ "North Keene Substation",[-72.30016965238696, 42.94391079703599]],
    [ "Pulpit Rock Substation",[-71.2361737266684, 42.93584097653788]],
    [ "V103 Tap Substation",[-71.14587192730598, 42.95456742608447]],
    [ "Peaslee Tap Substation",[-71.14485783541544, 42.9546478110998]],
    [ "Peaslee Substation",[-71.08829504707178, 42.89594498685786]],
    [ "1125298039",[-103.29555629498623, 32.47223181038506]],
    [ "1125299650",[-103.19071524232292, 32.42177712264405]],
    [ "1125299656",[-103.49901978957028, 32.38151108240625]],
    [ "Hunter Field Substation",[-91.71712575446865, 41.92459731117755]],
    [ "Johnson Substation",[-91.53264426318918, 41.573015618056594]],
    [ "Pearl River Valley Electric Power Association",[-89.183906783748, 30.93872571708624]],
    [ "Stillmore Substation",[-89.28173383525173, 30.80019814135057]],
    [ "1125302632",[-89.28169466209113, 30.80087351952902]],
    [ "Singing River Electric Cooperative",[-88.81131231755612, 31.13831740297495]],
    [ "Tasker Farm Substation",[-70.99589059600224, 43.38762366129139]],
    [ "Albia Substation",[-92.79640617999057, 41.02691228913131]],
    [ "Anamosa White Fawn Substation",[-91.26828392576785, 42.12223097733436]],
    [ "Armstrong Substation",[-94.42315800105621, 43.33402493969915]],
    [ "Seippel Road Substation",[-90.78053136027212, 42.4923639612022]],
    [ "Roland Transmission",[-93.44393182644004, 42.12355428189888]],
    [ "Hanlontown Substation",[-93.35979634456531, 43.27711254936031]],
    [ "Manly Substation",[-93.21270635014154, 43.284620847903696]],
    [ "Marshalltown North Substation",[-92.90127800205892, 42.056907207302274]],
    [ "Eagle Substation",[-91.63636654290191, 41.90525226581826]],
    [ "Oakridge Substation",[-91.64640985064445, 41.930398616976355]],
    [ "PMX North Rolling Mill",[-91.69568256399594, 41.92870359680242]],
    [ "PMX South Rolling Mill",[-91.69573609999999, 41.926009150000006]],
    [ "Lisbon North",[-91.40173291994132, 41.930026069533056]],
    [ "Hawkeye Wind Farm",[-92.06314744558186, 42.94913352179415]],
    [ "Oelwein Substation",[-91.91242545042103, 42.67369976415196]],
    [ "Oelwein Hub",[-91.90574667030631, 42.657369852759075]],
    [ "Britt Substation",[-93.80347471938585, 43.08927826547328]],
    [ "Kossuth Substation",[-94.1579538500251, 43.08248255112315]],
    [ "Ledyard Windpower",[-94.1007037, 43.42745809999999]],
    [ "1125619533",[-98.30305399126837, 35.841868117680946]],
    [ "1125619535",[-98.45336947489783, 36.26048890648113]],
    [ "1125621757",[-98.42675908484985, 36.39093947472943]],
    [ "1125666055",[-95.77935892414854, 35.00793822103158]],
    [ "1125668934",[-95.83422336681966, 34.93555999970539]],
    [ "Belmar Substation",[-74.03150338375222, 40.169636244831636]],
    [ "Yarmouth 4 Substation",[-70.15670999017759, 43.75154160133765]],
    [ "Tyler Substation",[-97.43994045016716, 37.68663790746257]],
    [ "1125967181",[-97.56987355141436, 37.67185025175506]],
    [ "Duck River Electric Membership Corporation",[-86.25274449209283, 35.08613833852634]],
    [ "Duck River Electric Membership Corporation",[-86.19751775284062, 35.18234578891987]],
    [ "Tennessee Valley Authority",[-86.2778772, 35.19578765]],
    [ "Kentucky Utilities Company",[-87.90132563749258, 37.24879012809638]],
    [ "1126031858",[-87.89977948543515, 37.24792677977853]],
    [ "Pilot Oak Substation",[-88.71634601598844, 36.54892628349342]],
    [ "1126046589",[-87.04681947807424, 37.774723908895076]],
    [ "1126065002",[-116.51149378632573, 43.55016169305999]],
    [ "Meyers Substation",[-83.16888567426426, 42.39880419165369]],
    [ "1126159712",[-119.31707599538235, 45.90567310638658]],
    [ "1126159713",[-119.3171252909747, 45.90422795633202]],
    [ "1126196114",[-97.64802420000001, 35.89981245]],
    [ "1126200027",[-97.92528102491201, 36.06008330745102]],
    [ "1126200034",[-97.94534588628241, 35.814659450851956]],
    [ "1126200035",[-97.9413578, 35.72624965]],
    [ "1126200038",[-97.92433323660664, 35.668086878099864]],
    [ "Boone Substation",[-93.88877470243781, 42.06348422004339]],
    [ "Bluff Substation",[-91.34848273384075, 40.63806976845784]],
    [ "Messenger Substation",[-91.40752376815465, 40.42131170164978]],
    [ "Independence Wind Substation",[-91.56826644137938, 42.428462832937285]],
    [ "1126379996",[-111.69869968466723, 34.350032996690246]],
    [ "1126379998",[-111.87834897895083, 34.540217626885486]],
    [ "1126384432",[-119.61519869555097, 45.83407101440871]],
    [ "McClellanville Substation",[-79.4674215819644, 33.09783515367006]],
    [ "Scotland Neck Switching Station",[-77.4191487187543, 36.12727061982899]],
    [ "Lynch Substation",[-83.02860336737517, 42.39730951716106]],
    [ "1126591460",[-108.76590482950027, 45.668027492671285]],
    [ "1126738577",[-96.49873069767452, 33.88146006742873]],
    [ "1126766341",[-85.65919981642318, 31.44981664687654]],
    [ "Fordsville Substation",[-86.69377052836865, 37.62814956313045]],
    [ "1126801322",[-86.87664443737971, 37.665388118728146]],
    [ "Challenger Drive Substation",[-70.18654076830167, 44.06920520588267]],
    [ "1126822840",[-85.16918592690183, 32.2876805178555]],
    [ "1126822841",[-85.22592052683807, 32.39680283690408]],
    [ "1126953614",[-87.4583775116994, 39.40339527501343]],
    [ "1127120875",[-111.53970731111603, 47.5653150271193]],
    [ "1127367116",[-90.53263826168438, 39.4622439197766]],
    [ "1127394347",[-96.57280702390874, 33.64198435806283]],
    [ "1127405507",[-96.53214740931548, 33.318201599999995]],
    [ "1127406208",[-96.50146331721547, 33.32303301827007]],
    [ "1127406719",[-96.4911078232202, 33.29432214810303]],
    [ "1127407779",[-96.43862328846818, 33.19661609517224]],
    [ "1127408389",[-96.43904867251598, 33.19332424366822]],
    [ "1127411066",[-96.27477550796323, 33.397719554304736]],
    [ "1127411684",[-96.12008655861008, 33.46617198239913]],
    [ "1127507504",[-113.02090930000001, 37.7643438]],
    [ "City of Salem",[-80.01853078494257, 37.277339379602715]],
    [ "1127509657",[-96.39904097834362, 33.29217001818062]],
    [ "1127558067",[-96.62881964942048, 33.274703322660585]],
    [ "1127569790",[-109.46205655447231, 46.322608139942]],
    [ "1127637650",[-88.57596662484471, 44.438404989633185]],
    [ "Seminole",[-102.67561167490916, 32.782860021598516]],
    [ "1127925612",[-102.6834795248393, 32.754915544522184]],
    [ "1127961079",[-86.87900267559449, 40.03271793647683]],
    [ "1128000031",[-102.78652900000002, 32.7260601]],
    [ "1128000034",[-102.67136565000003, 32.588714350000004]],
    [ "1128002103",[-102.84703742020656, 32.7843478003]],
    [ "1128002104",[-102.8866634599464, 32.783065658382334]],
    [ "1128002107",[-102.95047975670666, 32.786248355228786]],
    [ "1128002116",[-102.95303484229625, 32.776879324941575]],
    [ "1128002120",[-102.95291144999999, 32.77508045]],
    [ "1128002129",[-102.94929027435953, 32.812653095177126]],
    [ "Fairview Substation",[-86.00056469086203, 42.81835925662368]],
    [ "1128047197",[-102.73344972504034, 33.03899046044107]],
    [ "1128047200",[-102.73345921103113, 33.04172542482442]],
    [ "1128047201",[-102.73380222957167, 33.07616889823793]],
    [ "1128047202",[-102.73527788647196, 33.07738342487546]],
    [ "1128047215",[-102.88713534999998, 33.18316285]],
    [ "1128047216",[-102.88821234738126, 33.18211878579252]],
    [ "1128047219",[-102.90453986650044, 33.153024990577805]],
    [ "1128087960",[-101.4727504135483, 32.50250939867794]],
    [ "1128095639",[-90.07933129633776, 39.64553366958995]],
    [ "1128098283",[-90.97871536824927, 39.81774673973537]],
    [ "Ameren",[-90.97683376009812, 39.83125888930693]],
    [ "1128108177",[-102.42247219357276, 34.51658202517965]],
    [ "1128108189",[-102.06903637434309, 34.46719512445741]],
    [ "1128114753",[-85.09505199999998, 32.43860395]],
    [ "Belmont Substation",[-124.20788311008573, 41.77305331831889]],
    [ "1128227891",[-102.07598805, 34.5098867]],
    [ "1128227900",[-101.91966575000001, 34.445026799999994]],
    [ "1128227903",[-101.99253369999998, 34.3699283]],
    [ "1128251418",[-85.4693716, 32.5176207]],
    [ "South Loving Sub",[-104.09998107339747, 32.26933071123621]],
    [ "1128253529",[-104.1220596357569, 32.26795981621954]],
    [ "1128268425",[-102.97911381425709, 32.36355756850587]],
    [ "1128271335",[-102.79471006129246, 32.42257709295549]],
    [ "1128325567",[-85.7833623347795, 32.43570717957518]],
    [ "1128327530",[-102.7930249789795, 32.4217512567501]],
    [ "1128353881",[-85.54208637858933, 32.59149947179988]],
    [ "1128353882",[-85.63623373368918, 32.60232543332249]],
    [ "1128364208",[-100.060632805092, 31.094294184046674]],
    [ "East Substation",[-84.83300633216659, 39.84564975085437]],
    [ "1128704120",[-101.50840501573472, 47.718115583538385]],
    [ "1129148722",[-85.50616459765233, 32.59142552925439]],
    [ "1129148723",[-85.52306965000001, 32.55259334999999]],
    [ "1129148725",[-85.51200819337019, 32.54974036844349]],
    [ "1130699134",[-85.73060840000001, 32.8292637]],
    [ "1130699137",[-85.65618924999998, 32.7920768]],
    [ "1130699140",[-85.5947897, 32.737823000000006]],
    [ "Pulaski Substation",[-80.41321810034913, 41.114777212914404]],
    [ "Taylor Substation",[-89.57572836566771, 34.26436669672727]],
    [ "1130768042",[-101.96254194992218, 30.989320999176964]],
    [ "1130768440",[-101.71697025653287, 30.985628658068503]],
    [ "1130768442",[-101.71680247658696, 30.98773321128404]],
    [ "Athens ME Substation",[-69.65924779502178, 44.9447008401239]],
    [ "1130769450",[-101.35793058227098, 31.171768368399885]],
    [ "1130769452",[-101.4623864805984, 30.968205070604895]],
    [ "1130779897",[-119.30110218424704, 45.85099614598935]],
    [ "Cambell Substation",[-80.08080952057995, 41.1472778081733]],
    [ "1130964725",[-85.81508709999999, 32.558602099999995]],
    [ "1130964732",[-85.67565004999999, 32.553076299999994]],
    [ "1130964735",[-85.7604025272813, 32.58407243768159]],
    [ "1131051857",[-79.45216378626587, 33.37792465384826]],
    [ "1131069168",[-85.14852789210616, 32.66521357376418]],
    [ "1131069169",[-85.1488613751778, 32.664381104939054]],
    [ "1131313521",[-85.40543772535345, 32.68505394619999]],
    [ "1131859341",[-97.83482114186042, 36.404881006242924]],
    [ "1131859348",[-98.17493975677093, 36.55692359884633]],
    [ "1131859351",[-98.1225589543495, 36.53837077155704]],
    [ "1131859354",[-98.00207339999999, 36.6657416]],
    [ "1131956496",[-98.26536136856932, 36.39143275575665]],
    [ "1131977277",[-97.85690923192652, 36.81110578273592]],
    [ "1131977283",[-97.85815703294232, 36.593044651539586]],
    [ "1131977284",[-97.85819146130328, 36.59247511366657]],
    [ "1131977289",[-97.85535528761301, 36.55001486952996]],
    [ "1131977291",[-97.45746876241296, 36.81898218055345]],
    [ "Oklahoma Gas & Electric",[-97.72665254277419, 36.81761281335085]],
    [ "1131986052",[-97.31018424999999, 36.80551645]],
    [ "1131986054",[-97.2853451, 36.79809665]],
    [ "Blackwell Substation",[-97.28264940820169, 36.73914277493994]],
    [ "1131986059",[-97.30676773847892, 36.67359607482812]],
    [ "Fifth & Delaware Substation",[-93.19932223957866, 43.147404824842724]],
    [ "Lehigh Substation",[-93.20953078384325, 43.179235617137415]],
    [ "Nettle Substation",[-93.24664682769033, 43.17644150109201]],
    [ "Northwest Switching Station",[-93.19916690498845, 43.17268462179991]],
    [ "Brooke Substation",[-95.32374807016805, 42.85160599022345]],
    [ "Fox Run Substation",[-95.22093077779998, 42.86512368495063]],
    [ "1132022976",[-87.60257030596645, 32.674504099201506]],
    [ "1132022983",[-87.22218575, 32.458546350000006]],
    [ "1132022986",[-87.30492905163314, 32.63728711644445]],
    [ "Buffalo Center Substation",[-93.94787353742738, 43.38470228055789]],
    [ "1132036965",[-99.41658456235992, 36.18968236068361]],
    [ "1132036970",[-99.58242182349116, 36.160040087822466]],
    [ "Virginia Electric and Power Company",[-77.37049848391646, 37.495802877636166]],
    [ "Mediapolis Substation",[-91.16558415576677, 41.00211820960683]],
    [ "Clinton Second Street Substation",[-90.18786956337325, 41.846142811479105]],
    [ "Clinton South Substation",[-90.19250392523921, 41.83248301065166]],
    [ "Langford Substation",[-89.95171466634781, 32.40192795317861]],
    [ "Equistar Substation",[-90.2928595, 41.80966230000001]],
    [ "Mill Creek Substation",[-90.2386294491731, 41.82501783678443]],
    [ "Van Allen Substation",[-90.25695459819032, 41.82199102804277]],
    [ "Clinton Perrin Substation",[-90.20422544976871, 41.82737646665122]],
    [ "Calmar Substation",[-91.85951250927356, 43.18134427495077]],
    [ "Ossian Substation",[-91.75429434453208, 43.14309303476321]],
    [ "1132190181",[-85.37041023525164, 32.577616474660914]],
    [ "1132190182",[-85.3667364, 32.549171900000005]],
    [ "1132200605",[-95.30041817196826, 33.474685236031235]],
    [ "1132200607",[-95.3444683219538, 33.44728642116864]],
    [ "1132202831",[-93.69475941360832, 30.721171928251614]],
    [ "1132202835",[-93.77792732954948, 30.755598304634663]],
    [ "1132203362",[-95.34985779319179, 33.41507534068203]],
    [ "1132214380",[-94.96110999148176, 32.24894029104598]],
    [ "Flying Cloud Substation",[-95.27317461208824, 43.40085817577682]],
    [ "Flying Cloud Wind Farm",[-95.27325480988651, 43.40111777474356]],
    [ "Lynch Substation",[-95.15395495963845, 43.3429926451775]],
    [ "Columbus Junction Substation",[-91.37996386578654, 41.27033340819345]],
    [ "Cedarcrest Substation",[-91.38054963701117, 41.27166847959401]],
    [ "Centerville South Substation",[-92.84890769087409, 40.718418395121]],
    [ "1132254765",[-96.60048934138091, 34.60909609424824]],
    [ "1132255756",[-95.51629740716038, 35.56988334528937]],
    [ "Graham Substation",[-91.38683906572578, 41.6859666422858]],
    [ "Kalona Substation",[-91.71676700555923, 41.48513047520539]],
    [ "Conrad Substation",[-92.90437486669721, 42.26732031316808]],
    [ "Chariton Substation",[-93.30161951930629, 41.01598798451119]],
    [ "Crane Substation",[-91.67381125346873, 41.30889507743772]],
    [ "Cresco Substation",[-92.12327725, 43.371811799999996]],
    [ "Creston East Substation",[-94.33792055806448, 41.055646575283205]],
    [ "Fairbank Substation",[-92.03040191340841, 42.63981091887997]],
    [ "Rowley Substation",[-91.89004921985612, 42.37880097162392]],
    [ "Alliant Energy",[-91.90387437512825, 42.49744823669348]],
    [ "Wapsi Substation",[-91.90293567923715, 42.497219595445]],
    [ "1132345305",[-85.7306579103147, 32.824737425470495]],
    [ "1132345311",[-85.7939508, 32.858615900000004]],
    [ "Dadeville Substation",[-85.76868181634538, 32.84797759293094]],
    [ "1132445598",[-123.47269486225959, 40.43327942498154]],
    [ "1132445611",[-123.04416398943906, 40.38712519369029]],
    [ "1132496442",[-97.31403010019551, 33.32594738698444]],
    [ "Stoddert Substation",[-78.3375117863796, 37.32421902702744]],
    [ "Panora Substation",[-94.37271545, 41.63728965]],
    [ "White Pole Road Substation",[-94.49176742226781, 41.5178081482296]],
    [ "Grand Junction North Substation",[-94.24153497508642, 42.054654193814535]],
    [ "Grinnell Subtation",[-92.72531293568011, 41.741141375076964]],
    [ "Grinnell South Substation",[-92.72315608998566, 41.68761338915176]],
    [ "Monticello Industrial Substation",[-91.1938756251534, 42.25197811215555]],
    [ "Postville Substation",[-91.57594142508023, 43.08315340903141]],
    [ "ITC",[-93.6191683713101, 42.311612321605764]],
    [ "Marengo Eastern Substation",[-92.05885582488186, 41.800149672073445]],
    [ "Milton Substation",[-92.15432788747506, 40.67303690916077]],
    [ "Osage Junction Substation",[-92.82977931173467, 43.348909598671156]],
    [ "Nichols Substation",[-91.2909793567349, 41.51029919471473]],
    [ "Zenon Substation",[-91.25102331371623, 41.49492423200876]],
    [ "Hendersonville Substation",[-71.06538878461494, 42.39971195594316]],
    [ "Osceola Substation",[-95.54437994109954, 43.40202192497274]],
    [ "Woodburn Junction Substation",[-93.59143763347004, 41.038250223998396]],
    [ "Ringgold Substation",[-94.23567957282017, 40.71856222761003]],
    [ "Mount Ayr Substation",[-94.23712362472257, 40.71789415492793]],
    [ "Rodman Regulating Substation",[-94.52840911509193, 43.02423448191461]],
    [ "Rudd Junction Substation",[-92.80966603615597, 43.1194673221904]],
    [ "1132612815",[-98.66982970407096, 40.27111925778597]],
    [ "Saling Substation",[-93.3259709146669, 40.77084087569737]],
    [ "Sigourney Substation",[-92.20565913950485, 41.338506640926155]],
    [ "Alliant Energy",[-92.20554488152197, 41.33808479971282]],
    [ "St. Ansgar Substation",[-92.91118984392399, 43.371317825610916]],
    [ "St. Ansgar Industrial Substation",[-92.90458048139858, 43.379317077311335]],
    [ "1132624887",[-88.34651949961916, 40.54535781574115]],
    [ "1132627193",[-97.53010008512844, 28.242553490103322]],
    [ "1132632709",[-112.00219360598408, 33.460520238608]],
    [ "1132952626",[-88.52156757468654, 47.18500309158359]],
    [ "1132978719",[-85.56952802506653, 31.04274725858506]],
    [ "Slocomb Substation",[-85.56409560000002, 31.065090499999993]],
    [ "1133061992",[-103.3968337591088, 39.73695102079672]],
    [ "Anton Substation",[-103.17796147365611, 39.74121400417688]],
    [ "1133064239",[-102.97231568392671, 39.6552422458309]],
    [ "1133145385",[-97.33031396911724, 37.76819906714281]],
    [ "1133145393",[-97.3077367, 37.759934400000006]],
    [ "1133145394",[-97.3077500347156, 37.760077363008655]],
    [ "1133297165",[-86.1296987261828, 37.999477239028884]],
    [ "1133297172",[-86.14206922917143, 38.001660337383846]],
    [ "Evergy",[-95.59088951558736, 37.907895875246304]],
    [ "FIXME Substation",[-95.5923658083473, 37.98078982503185]],
    [ "FIXME Substation",[-95.59206082504335, 38.081496393039735]],
    [ "FIXME Substation",[-95.62820338565218, 38.18374621840509]],
    [ "FIXME Substation",[-95.53542782503008, 38.18441144224049]],
    [ "Evergy",[-95.59347589999997, 37.79083839999999]],
    [ "Rumford Mill Substation",[-70.54051929582931, 44.54876336318486]],
    [ "1133441986",[-81.62401625, 34.27446785]],
    [ "Barker Avenue",[-72.0237302214326, 44.41457207250567]],
    [ "1133559976",[-78.79943930000002, 42.99598325]],
    [ "Subestación Humacao Pueblo",[-65.83336508569374, 18.152612048772927]],
    [ "1133620065",[-99.73462555, 38.67212775]],
    [ "1133620070",[-99.11493032452631, 38.745058530576955]],
    [ "1133620071",[-99.18812890000001, 38.82820205]],
    [ "1133620073",[-98.93959606176975, 38.6902105471375]],
    [ "Avenir Substation",[-80.26691533867687, 26.825428980187237]],
    [ "1133921211",[-94.19701615220664, 41.032645185054676]],
    [ "Dysinger Switchyard",[-78.56306917235017, 43.10896190596272]],
    [ "1134034628",[-93.60258545, 42.8390473]],
    [ "1134058744",[-118.42674817385851, 46.89763902475244]],
    [ "1134058746",[-118.56789206541349, 46.94143628890995]],
    [ "1134058752",[-118.83270477480336, 46.955284693737866]],
    [ "1134058756",[-119.05824685798277, 46.94031092894713]],
    [ "Sand Dunes Substation",[-119.27758066323223, 47.07331599864593]],
    [ "1134155514",[-86.15263085868055, 37.98812043563675]],
    [ "1134177745",[-119.5804382194166, 46.914251094439805]],
    [ "1134177747",[-119.58007716541694, 46.91509758221793]],
    [ "1134232247",[-119.3265861, 47.13825575]],
    [ "1134239321",[-119.1532566014907, 46.84135276307787]],
    [ "1134239323",[-119.16664142280243, 46.840043381669034]],
    [ "1134239331",[-119.3649480627222, 46.808939146450186]],
    [ "Coolidge Substation",[-83.1772966656752, 42.3812385349537]],
    [ "1134280616",[-87.54807245, 33.196045149999996]],
    [ "1134280623",[-87.54283002509848, 33.2017024046216]],
    [ "1134280625",[-87.52559885, 33.20251084999999]],
    [ "1134362405",[-87.45203965000002, 33.163343899999994]],
    [ "1134362412",[-87.54293882079324, 33.184109828123574]],
    [ "1134366917",[-86.09429589999999, 37.95057515]],
    [ "Savannah Substation",[-83.10177862560326, 42.42520715681119]],
    [ "1134410402",[-87.5068434185493, 33.233010704164634]],
    [ "1134410408",[-87.48202225000001, 33.23182175]],
    [ "1134645658",[-87.5165805, 33.2108511]],
    [ "1134645659",[-87.5212416776406, 33.216846859198206]],
    [ "1134671297",[-87.5539970680926, 33.2020307393864]],
    [ "North Substation",[-87.54213247502017, 33.22044924046467]],
    [ "North Tuscaloosa Substation",[-87.56723235, 33.211978300000006]],
    [ "1134679317",[-87.56140671414707, 33.17758477437813]],
    [ "1134679322",[-87.56046021018882, 33.16929822518561]],
    [ "1134704312",[-80.65515617101904, 39.30111534554689]],
    [ "1134704314",[-80.68484635253625, 39.277762639631234]],
    [ "Sandlot Substation",[-77.5102126438645, 38.747520268432574]],
    [ "1134943821",[-87.5499157467217, 33.21481008195398]],
    [ "1134943823",[-87.51462285765959, 33.24877207886757]],
    [ "Carey Substation",[-104.93444135893306, 40.57259294009143]],
    [ "1134980249",[-102.53999879999999, 36.06070295]],
    [ "Hawaiian Electric Company",[-155.76309250654222, 19.90186269786644]],
    [ "AES",[-155.76358724681648, 19.902011542612783]],
    [ "1135009086",[-101.63775711454818, 36.64691498163824]],
    [ "Sagebrush Substation",[-104.2793301425933, 43.86315376806159]],
    [ "Jay Substation",[-70.24204804629808, 44.50573015707628]],
    [ "Enfield Substation",[-68.62797469196313, 45.253834819360854]],
    [ "1135338565",[-99.5471474134834, 38.41796458228115]],
    [ "1135338568",[-99.69461013931458, 38.30523832518691]],
    [ "1135338571",[-99.4048506, 38.088418700000005]],
    [ "1135373781",[-94.68047341648222, 41.871705042568095]],
    [ "Lyons Substation",[-74.54846595218027, 40.68324233679642]],
    [ "Hunt Oil Substation",[-87.60963156177453, 33.20070988091623]],
    [ "Kentuck Substation",[-87.5893492396184, 33.22457330779208]],
    [ "1135588239",[-87.05373622499879, 39.02803040758259]],
    [ "Smackover Substation",[-92.73126831175217, 33.357938312382295]],
    [ "Salix Substation",[-78.75624547716507, 40.30708006051357]],
    [ "Voorhees Station",[-75.75217345365839, 43.33402231737441]],
    [ "1135821518",[-93.83934115000001, 38.77195155]],
    [ "1135826292",[-79.03610873650511, 37.42380507022174]],
    [ "Shelbyville Substation",[-85.22666462542982, 38.218739089118536]],
    [ "1135935697",[-97.79023247363146, 36.05132168584912]],
    [ "1135956953",[-111.72496932046452, 40.05235694503316]],
    [ "1135956958",[-111.72930397550911, 40.031572869871084]],
    [ "1135956960",[-111.60476748233383, 40.079826044451565]],
    [ "1135995520",[-87.05093426228918, 37.891897747507485]],
    [ "1135995523",[-87.03692712495776, 38.00360910762647]],
    [ "1136017692",[-95.16473645582046, 41.40461004960796]],
    [ "1136017698",[-95.03178196601256, 41.421311225061345]],
    [ "1136025733",[-86.16590887669078, 37.982016996941915]],
    [ "13th Street Substation",[-86.13756338360365, 39.78461418472489]],
    [ "Western Trail Wind Farm Substation",[-99.05737558411231, 33.84322118652957]],
    [ "Florida Power & Light",[-80.74817965066272, 26.575848128701367]],
    [ "Florida Power & Light",[-80.74757661790267, 26.577584863529285]],
    [ "1136048289",[-99.74639643345068, 36.48816616368126]],
    [ "1136048291",[-99.74763263159177, 36.48576872376147]],
    [ "Ghost Substation",[-81.04216376190777, 26.3837922994418]],
    [ "Northwestern Energy",[-114.15330551239046, 46.23178807302353]],
    [ "Skalkaho",[-114.14435977950733, 46.195280525353624]],
    [ "NorthWestern Energy",[-114.1540380721181, 46.23949732797218]],
    [ "Corvallis",[-114.1051966250505, 46.31251744572443]],
    [ "NorthWestern Energy",[-114.03364825630238, 46.27624479034656]],
    [ "1136588657",[-116.01290560000001, 33.11862825]],
    [ "1136588658",[-116.01050047506439, 33.11918419187977]],
    [ "Adams Substation",[-87.05529141704986, 36.57790216873823]],
    [ "1136666614",[-87.58824094832859, 37.84375634966081]],
    [ "1136850564",[-87.58607198394427, 37.8179641943782]],
    [ "1136867739",[-117.1299571441281, 47.00564264600243]],
    [ "Sono Substation",[-73.42563822558247, 41.09102343362088]],
    [ "Charlos Heights Substation",[-114.17928857870528, 46.12932877391129]],
    [ "South Darby",[-114.17086498581837, 46.01580019475088]],
    [ "Lolo",[-114.08095246251735, 46.744019333605486]],
    [ "Bell Crossing",[-114.13481126093139, 46.44386079988545]],
    [ "Blairstown Substation",[-74.93432544071263, 40.975491395021294]],
    [ "Entergy Louisiana",[-91.54633663242323, 29.825455686705546]],
    [ "1137442306",[-91.4245894135632, 29.726062020274103]],
    [ "1137595329",[-91.09572288449199, 30.254959045044497]],
    [ "Westlake Chemical Corporation",[-91.00939180093195, 30.209362375564602]],
    [ "1137696432",[-96.73095168546283, 34.96438088170538]],
    [ "Kromdyke Substation",[-85.5738479312184, 42.22324509620919]],
    [ "1137754164",[-87.70082412469235, 39.57166959212287]],
    [ "1137823386",[-119.72705433825386, 47.08943332027618]],
    [ "1137823388",[-119.72605799196168, 47.16230134365373]],
    [ "1137823392",[-119.89596212489793, 47.159601060952205]],
    [ "Tennessee Valley Authority",[-86.36475950297273, 36.54944737172357]],
    [ "Enfield Substation",[-72.14396222500162, 43.6450145440927]],
    [ "Greenfield Substation",[-88.81181746647931, 36.15519567313477]],
    [ "1138144087",[-98.47925507949509, 31.562075465203627]],
    [ "Appoline Substation",[-83.1721482253746, 42.43153800587113]],
    [ "1138158079",[-85.07488642501205, 32.49121796172966]],
    [ "1138158082",[-85.0987034, 32.52930105]],
    [ "Phenix City Substation",[-85.01158946172065, 32.478377222417315]],
    [ "1138185928",[-85.03483947478513, 32.47574569342252]],
    [ "Conant Substation",[-83.08048629999998, 42.44291325]],
    [ "1138487997",[-93.27596479805834, 42.658017905111706]],
    [ "Asphaltum Substation",[-86.987800590104, 41.13585310121597]],
    [ "1138989567",[-84.99973453487486, 32.44321236917309]],
    [ "1138989570",[-85.0006533, 32.43109315]],
    [ "1138989572",[-85.03661797919428, 32.49041287900128]],
    [ "1139061688",[-87.54178053489653, 33.15019431888413]],
    [ "1139061690",[-87.53046082720276, 33.15014432756583]],
    [ "Grand Rapids Pumping Substation",[-85.68849904235395, 42.95151605038421]],
    [ "1140859760",[-81.68076950699108, 26.70169075481751]],
    [ "Lisbon Substation",[-72.041300286175, 41.58415138060862]],
    [ "1141839150",[-98.61402596747538, 35.83000905861498]],
    [ "Subestación Santa Isabel Pueblo",[-66.3999731584057, 17.964176900481238]],
    [ "1143761051",[-86.89598508113772, 40.0185584139902]],
    [ "1143761053",[-86.8849474, 40.04645335]],
    [ "1143927738",[-90.0816394021399, 39.64600569781926]],
    [ "1143946436",[-101.63791824051822, 36.51662801287964]],
    [ "1144068252",[-112.9359585359041, 38.50734411865059]],
    [ "1144084871",[-95.27500816955572, 40.60418319895659]],
    [ "1144096700",[-98.54022936982344, 31.427033301228224]],
    [ "1144102239",[-102.31047190447214, 35.19889124604092]],
    [ "1144102241",[-102.27914266761131, 35.1357301843482]],
    [ "1144365748",[-100.33959539862794, 37.87275153481101]],
    [ "1144365749",[-100.33996595560542, 37.875101699681906]],
    [ "1144365750",[-100.33948347505248, 37.870204738523896]],
    [ "1144400917",[-99.3000821583706, 36.52991507305632]],
    [ "1144420082",[-99.6726434047662, 33.74328086315705]],
    [ "1144460029",[-115.54249945000001, 32.803302849999994]],
    [ "1144460035",[-115.54466518472458, 32.80278657704551]],
    [ "Stoneray Switching Substation",[-96.05019602513477, 44.02208087539936]],
    [ "Ridgewind Interconnect Substation",[-96.06539073032964, 44.01895904481557]],
    [ "Tunnel Hill #1 &2 Substation",[-85.83119601728006, 37.729162353228645]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.8096539, 37.72336690000001]],
    [ "1144482433",[-97.35314509239304, 33.70556474780001]],
    [ "1144494360",[-90.13452969342976, 42.66601257069602]],
    [ "1144532036",[-88.64113397096128, 41.120584292986095]],
    [ "1144532037",[-88.63919709125484, 41.12103906760362]],
    [ "Willow Creek Wind Power LLC",[-103.20910842278501, 44.82704436587896]],
    [ "Hartland Substation",[-76.0339923, 40.980476800000005]],
    [ "Canterbury Substation",[-71.92472099313916, 41.73811059042716]],
    [ "1144997363",[-112.21747079405121, 33.553502854842726]],
    [ "1145001393",[-103.24977845, 33.3587852]],
    [ "1145143793",[-114.77362421563684, 33.69101964728918]],
    [ "PPL",[-76.83708376628529, 40.31111664349088]],
    [ "Madison Substation",[-87.34182606073945, 41.60525647228548]],
    [ "Dexter Substation",[-72.62541642428133, 41.922351024335946]],
    [ "1145639778",[-86.92299638171413, 41.69882264811633]],
    [ "1145687530",[-91.69291880679032, 44.55295278152605]],
    [ "1145687531",[-91.6503047249564, 44.56974659591282]],
    [ "National Substion",[-83.13143118330112, 42.6983007754541]],
    [ "Rochester Substation",[-83.13306970000001, 42.67912555000001]],
    [ "1146125091",[-87.35471475782205, 41.591732792686344]],
    [ "1146534154",[-109.36849422535147, 37.89578419005499]],
    [ "Marshall Substation",[-77.07697496586525, 41.536913741718]],
    [ "Smokey Hills Substation",[-102.35253142498007, 39.128284543170466]],
    [ "Joes Substation",[-102.70749916326297, 39.65999429765802]],
    [ "Carleton Road Substation",[-84.66270478359182, 41.966150724948086]],
    [ "1146778390",[-87.40748346286264, 41.59557747475523]],
    [ "Jersey Central Power and Light",[-74.43971994332632, 40.68253943372255]],
    [ "Auburn Heights Substation",[-83.2078196245698, 42.63441209552358]],
    [ "1146830780",[-102.10922532415904, 38.856354356387705]],
    [ "1146841677",[-102.5764954787574, 39.90440472502416]],
    [ "North Abarr Substation",[-102.72696114709474, 40.00231470851399]],
    [ "1146841681",[-102.93587810847481, 40.00214051467325]],
    [ "1146841687",[-102.9521176277387, 40.61357707948874]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.34979041781939, 37.61425919693477]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.51493616928374, 37.56809419543175]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.22815345000001, 37.68943240000001]],
    [ "1147089382",[-76.73373928319704, 38.009704325695886]],
    [ "Dover Substation",[-83.17231484268905, 42.666156166726445]],
    [ "Duke Energy",[-81.95632236859467, 28.776727034431175]],
    [ "Carter Substation",[-83.2400283741726, 42.679031758666824]],
    [ "1147227472",[-85.41690530000001, 37.80911795]],
    [ "1147227718",[-85.44886120104978, 37.80772016622255]],
    [ "Huntington Substation",[-78.01841471307212, 40.489428139092915]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.50363129868923, 37.84700542907827]],
    [ "1147348465",[-83.07489348586854, 42.81579291102207]],
    [ "1147358666",[-83.0649781, 42.786079400000006]],
    [ "1147401980",[-113.66200604999999, 33.77420935]],
    [ "1147417805",[-101.75165433926234, 38.83669997644545]],
    [ "1147417808",[-101.73450182493171, 38.58155809515636]],
    [ "1147417811",[-101.7345039612547, 38.49443012491513]],
    [ "1147425127",[-100.99357250188491, 38.032958698822824]],
    [ "1147430400",[-101.79736220431425, 37.549155473803474]],
    [ "1147430402",[-101.79902770000002, 37.548504750000006]],
    [ "1147430404",[-101.7431506595561, 37.54862365558086]],
    [ "1147437636",[-101.56342937669592, 37.54820252297265]],
    [ "1147473737",[-101.34491946779079, 37.59065181513883]],
    [ "Paragould Light & Water Commission",[-90.4904109, 36.076206]],
    [ "1147496396",[-100.50324998800636, 38.496321025384574]],
    [ "1147496398",[-100.50327497486025, 38.48264650620473]],
    [ "1147497217",[-101.8888359, 37.5057681]],
    [ "1147497218",[-101.77446549999999, 37.33122415]],
    [ "1147499723",[-101.2898136248559, 37.73583168971424]],
    [ "1147500832",[-100.89494329746486, 37.330375412606905]],
    [ "1147500834",[-100.85120027928109, 37.330229309981036]],
    [ "1147663454",[-100.5922735, 39.233959750000004]],
    [ "1147663457",[-100.59158945, 39.32511410000001]],
    [ "1147663462",[-100.5897637251772, 39.40815620432687]],
    [ "1147666706",[-99.05834412502466, 38.08770170640841]],
    [ "Rapid St. Substation",[-83.28793650133127, 42.62687949164145]],
    [ "Bartlett Substation",[-83.30833236052149, 42.62891837298631]],
    [ "Florida Power & Light",[-80.40761677981958, 27.03458974279403]],
    [ "Bluestone Farm Solar, LLC",[-78.4806589, 36.80808210000001]],
    [ "Baldwin Substation",[-83.30898667120913, 42.737285510843954]],
    [ "1148040638",[-100.090570309132, 34.37906007385184]],
    [ "Hennis 1090 Solar Substation",[-80.54847277857417, 27.250927170889117]],
    [ "Rubys Substation",[-112.1716371565759, 37.67598418163991]],
    [ "1148075643",[-76.78457854824742, 35.59829572888801]],
    [ "1148096435",[-96.86047949508848, 35.70780744599504]],
    [ "1148108978",[-111.10791590000001, 34.658110349999994]],
    [ "Schwab Junction Tap",[-72.83901377434327, 41.52845852497482]],
    [ "Culver Substation",[-83.34692662870617, 42.673630587623464]],
    [ "New Substation Boundaries",[-104.78579337920155, 39.08069600476442]],
    [ "Devon Railroad Substation",[-73.10680051805176, 41.207520839729774]],
    [ "Snipes Substation",[-119.66133391900578, 46.302943048446636]],
    [ "Grand Avenue Substatuion",[-72.90881877398495, 41.30746246511526]],
    [ "Ivanhoe Substation",[-83.32449311457276, 42.6143275428975]],
    [ "Price Brook Substation",[-83.01155025989712, 42.7640217196131]],
    [ "1148638463",[-120.87792221810328, 44.275774642477124]],
    [ "1148638464",[-120.86794967934873, 44.282669793553815]],
    [ "1148638477",[-120.88447809292084, 44.26142234294874]],
    [ "1148638478",[-120.88566632158678, 44.26141125381895]],
    [ "Keego Substation",[-83.35291924299108, 42.59235405446272]],
    [ "1148667281",[-83.28425774119904, 42.58076423177719]],
    [ "Pootatick Substation",[-73.11791049911044, 41.27617964425239]],
    [ "1148705143",[-108.21057136008594, 39.877744230308245]],
    [ "Mcbryde Substation",[-108.33096665543984, 39.94997518578839]],
    [ "1148705147",[-108.32117104307807, 39.949852854843215]],
    [ "1148705150",[-108.31947240919416, 39.955911376160884]],
    [ "1148705154",[-108.18592619999998, 39.86449575]],
    [ "1148705156",[-108.46795801557127, 39.92087534858745]],
    [ "1148705158",[-108.50637306541869, 39.9128931381936]],
    [ "1148705161",[-108.2157966749035, 39.81765359775666]],
    [ "Towantic Substation",[-73.12261774818228, 41.48518798160323]],
    [ "1148847220",[-108.71125826469648, 40.1063816993187]],
    [ "Red Mesa Sub",[-109.40764742538454, 37.0139314595094]],
    [ "1148889262",[-109.37352125863238, 37.28211918183732]],
    [ "1148889263",[-109.3728859, 37.28174980000001]],
    [ "White Rock Curve Sub",[-109.29772018013153, 37.20884351119515]],
    [ "Commerce Lake Substation",[-83.48086289789498, 42.58106667609918]],
    [ "1148933453",[-87.30422862277156, 41.59995465404706]],
    [ "Waterbury Substation",[-73.04141702232643, 41.5441628607896]],
    [ "Wykertown SREC Substation",[-74.69732771568897, 41.16844415378545]],
    [ "1149024036",[-91.5093406748772, 43.07530220612957]],
    [ "Commonwealth Edison",[-87.86146432356021, 41.9265812743606]],
    [ "1149304438",[-90.232847860472, 43.19851012522952]],
    [ "Tri-State Generation & Transmission",[-106.24015792764868, 37.66056586005908]],
    [ "1149316310",[-106.09350024840808, 37.545229131977834]],
    [ "Alamosa Solar Substation",[-105.95256938338105, 37.598694525711714]],
    [ "1149323132",[-106.20353534685115, 37.776631600874516]],
    [ "1149417956",[-119.68968529469072, 43.55759819409336]],
    [ "1149444278",[-78.2686332262108, 36.119360886121406]],
    [ "Pontiac City Water & Sewer",[-83.2502427, 42.623317099999994]],
    [ "1149477447",[-118.51396632612804, 34.486637088753966]],
    [ "1149495035",[-84.21747188483901, 34.11247443979477]],
    [ "1149512465",[-87.52306256841034, 41.6216151031482]],
    [ "Florida Power & Light",[-81.43285743764774, 26.47543092093704]],
    [ "Florida Keys Electric Cooperative",[-80.9767332474317, 24.749806133128075]],
    [ "1149638092",[-92.88880660000001, 43.03777289999999]],
    [ "1149656546",[-85.17100982313174, 32.66414125630095]],
    [ "1149656548",[-85.2327603, 32.597307799999996]],
    [ "1149656550",[-85.28831997246934, 32.74458220172623]],
    [ "1149656554",[-85.22613638638002, 32.8211138446549]],
    [ "1149656556",[-85.23016074711215, 32.83594718258183]],
    [ "1149656558",[-85.15199278895777, 32.73833627542804]],
    [ "Wautaga Substation",[-101.54259785, 45.92009455000001]],
    [ "Montana-Dakota Utilities",[-101.3453789, 45.92328739999999]],
    [ "Montana-Dakota Utilities",[-101.80342717425171, 45.823440762494336]],
    [ "East Lemmon Substation",[-102.15222539999999, 45.94008175]],
    [ "West Lemmon Substation",[-102.17131335, 45.94005135]],
    [ "1149728974",[-85.47027666815994, 32.98530387055616]],
    [ "1149728975",[-85.54227525, 32.94901350000001]],
    [ "1149733725",[-85.35722399999999, 32.88351625000001]],
    [ "1149733727",[-85.46787455264517, 32.79881421739514]],
    [ "1149774300",[-83.43202503573856, 42.38172580995299]],
    [ "1149778397",[-103.57750478117927, 32.55830384342043]],
    [ "1149892052",[-93.32874064486919, 42.02207787713665]],
    [ "Alabama Power",[-86.1274482, 32.509731450000004]],
    [ "1149959046",[-87.61157353533714, 31.97760118990085]],
    [ "Kimbrough Substation",[-87.56619028515733, 32.03194129681711]],
    [ "1149959075",[-87.43296763919062, 32.146746617219684]],
    [ "Crumptonia Substation",[-87.29406342671915, 32.25632830833747]],
    [ "Five Points Substation",[-87.23211907611429, 32.24910079265245]],
    [ "Orrville Substation",[-87.22645179893753, 32.31432536677002]],
    [ "West Selma Substation",[-87.07766654626163, 32.3956190828546]],
    [ "Globe Metallurgical Substation #2",[-86.98746393420289, 32.37546525620747]],
    [ "Globe Metallurgical Substation #1",[-86.98726601230372, 32.37611423918262]],
    [ "1149977676",[-85.89171353641174, 32.573973339272456]],
    [ "1150001306",[-86.98884864460872, 32.33081028235229]],
    [ "1150001309",[-86.99969104622285, 32.413054037631355]],
    [ "North Selma Substation",[-87.03566344999999, 32.43698075]],
    [ "1150001325",[-87.01500072164617, 32.446665531010616]],
    [ "Alabama Power",[-86.83088420118011, 32.470642732763956]],
    [ "1150001329",[-86.7554005220596, 32.55720256844856]],
    [ "1150001331",[-86.59745796129219, 32.577048170531555]],
    [ "1150001333",[-86.46387577969001, 32.58286820326077]],
    [ "1150001334",[-86.34145365, 32.61501895]],
    [ "1150001336",[-86.8936879, 32.47892085]],
    [ "1150001339",[-86.92312575000001, 32.661749099999994]],
    [ "West Fraser Substation",[-86.88412116975391, 32.763710166001566]],
    [ "1150001361",[-86.8558925652263, 32.75674522492598]],
    [ "1150001364",[-86.87180468307567, 32.78423112026518]],
    [ "1150001365",[-86.87209994999999, 32.78350115]],
    [ "1150077212",[-78.01975765863588, 38.450148365604655]],
    [ "CenterPoint Energy",[-87.37310240530586, 38.01358389990133]],
    [ "Mead Substation",[-97.32852665113475, 37.692435006539924]],
    [ "Dixie Pipeline Company",[-86.54872049576677, 32.556138420210075]],
    [ "1150241099",[-86.6513665965754, 32.68244137960387]],
    [ "1150241102",[-86.65099574999999, 32.7463802]],
    [ "1150241103",[-86.6250832791607, 32.80331807664942]],
    [ "1150241105",[-86.52842480592747, 32.9510826272522]],
    [ "Lay Dam Substation",[-86.52056258950999, 32.96316589587811]],
    [ "1150241108",[-86.51892183796105, 32.96315785565223]],
    [ "1150241125",[-86.60951387443798, 32.73833439104911]],
    [ "1150241133",[-86.56682158017291, 32.81928752598564]],
    [ "1150241139",[-86.6272493, 32.83758605]],
    [ "Thorsby Substation",[-86.71172083240802, 32.9121193536104]],
    [ "1150241172",[-86.78847191642139, 32.91965876690739]],
    [ "Transcontinental Gas Pipe Line Company, LLC",[-86.72174942524035, 32.6706260570572]],
    [ "Southern Natural Gas",[-86.93040398034599, 32.52722764160555]],
    [ "Lancaster Substation",[-83.29231369391793, 42.50230438861508]],
    [ "Guthrie Sub",[-87.43729565, 41.6441339]],
    [ "Wheelabrator Bridgeport Substation",[-73.2083858327003, 41.16304526503497]],
    [ "Greenwich Substation",[-73.63171524126075, 41.02107692687425]],
    [ "Westfield Substation",[-74.32418415681211, 40.626917636698415]],
    [ "Cropwell Substation",[-86.27321355000001, 33.55692475000001]],
    [ "1150526119",[-89.57676300000001, 38.2074901]],
    [ "International Paper",[-86.87121422088836, 32.4243422574136]],
    [ "1150532010",[-86.86891144999998, 32.416017200000006]],
    [ "Warren Oil Company",[-86.83701840645017, 32.313080235634814]],
    [ "Civic Center Substation",[-87.5678900549147, 37.976259168493655]],
    [ "Mystic 345kV Substation",[-71.06707502591779, 42.393067295211985]],
    [ "Mystic 115kV Substation",[-71.06917373910922, 42.39127550265809]],
    [ "Wheelabrator Saugus Substation",[-70.97941638743977, 42.44693537870568]],
    [ "Browns Substation",[-87.36558307487311, 32.438030657332845]],
    [ "Uniontown Substation",[-87.50678649541865, 32.446977457068535]],
    [ "1150664771",[-87.59557182654902, 32.463657758619824]],
    [ "1150664776",[-87.6615230823514, 32.48984222127962]],
    [ "Dixie Pipeline Company",[-87.76933465, 32.50874090000001]],
    [ "1150664816",[-87.6922003653118, 31.961917354135625]],
    [ "1150713758",[-87.79930292074687, 32.31782110970168]],
    [ "1150713760",[-87.79966759035693, 32.31900032058023]],
    [ "1150713765",[-87.63268479999999, 32.330116800000006]],
    [ "South Demopolis Substation",[-87.80129133248107, 32.48489695822888]],
    [ "1150713769",[-87.78136356859122, 32.10503307452066]],
    [ "1150713772",[-87.89514502469311, 32.01539185841328]],
    [ "1150713773",[-87.91339310000001, 32.08835315]],
    [ "Alabama Power",[-87.76956875815063, 32.06615322406943]],
    [ "1150713778",[-87.7515606, 31.9386967]],
    [ "South Thomasville Substation",[-87.74072025881291, 31.91863942493525]],
    [ "1150713784",[-87.7473897643856, 31.899976724853147]],
    [ "1150713786",[-87.75513915956961, 31.867458845291978]],
    [ "1150713789",[-87.72821429999998, 31.7884199]],
    [ "1150713809",[-87.72639141989526, 31.78879714362944]],
    [ "1150713812",[-87.76443642219866, 31.78053276203301]],
    [ "Grove Hill Substation",[-87.78345875000001, 31.70970115]],
    [ "South Grove Hill Substation",[-87.7802858305446, 31.697363295250064]],
    [ "1150713833",[-87.87522204291861, 31.51094772542664]],
    [ "1150713839",[-87.89597171584886, 31.503633898366232]],
    [ "1150713853",[-87.89780870000001, 31.49249185]],
    [ "1150713854",[-87.89595862349935, 31.495623591118225]],
    [ "1150713864",[-87.91998825, 31.50435885]],
    [ "1150713867",[-87.93084502439078, 31.534165574059458]],
    [ "1150713869",[-87.73410655, 31.90285845]],
    [ "Westervelt Lumber",[-87.73699636912679, 31.842780702619347]],
    [ "1150725548",[-91.40821989999999, 44.414378600000006]],
    [ "1150725551",[-91.8299025, 44.3119753]],
    [ "1150725552",[-91.82996090000002, 44.31230005]],
    [ "1150725566",[-91.47275058493935, 44.26798903196982]],
    [ "1150782808",[-88.0739118425512, 31.725834585372326]],
    [ "1150782809",[-88.0788015332564, 31.731566523900565]],
    [ "1150782813",[-88.12753253281609, 31.754702601755678]],
    [ "1150782817",[-88.32835975574301, 31.779260119344805]],
    [ "1150782818",[-88.33128794042928, 31.786355725961826]],
    [ "1150782820",[-88.31830712135064, 31.86285248797321]],
    [ "1150782822",[-88.31245924462722, 31.875305836184783]],
    [ "1150782829",[-88.27539711700948, 32.02581674741581]],
    [ "1150782832",[-88.23661434565395, 32.09247706717816]],
    [ "Dixie Pipeline Company",[-88.3190443259808, 32.097414065483996]],
    [ "1150782836",[-88.31693083801575, 32.181799215436385]],
    [ "Hunt Crude Oil Supply Company",[-88.46879698836858, 31.930005624028194]],
    [ "ANP Bellingham Substation",[-71.45179077641247, 42.10924057876973]],
    [ "Dunnel Park Substation",[-71.36571996542973, 41.865518226683584]],
    [ "West Street Substation",[-71.29858230514003, 41.95212108359684]],
    [ "ANP Blackstone Substation",[-71.5137387442936, 42.05950718458692]],
    [ "NEA Bellingham Substation",[-71.48369563017614, 42.09178778355671]],
    [ "1150821121",[-91.56823659999999, 44.7458028]],
    [ "1150828946",[-87.29535493769423, 38.04501337486583]],
    [ "1150829143",[-91.1101447401834, 43.73556542508243]],
    [ "1150829147",[-91.04012862444971, 43.69800396013494]],
    [ "Newport Substation",[-71.31728045483725, 41.514923105937484]],
    [ "Fort Campbell Directorate of Public Works",[-87.45554148159113, 36.60118818545115]],
    [ "Fort Campbell Directorate of Public Works",[-87.4545344, 36.60213745]],
    [ "Fort Campbell Directorate of Public Works",[-87.45431470000001, 36.601465250000004]],
    [ "SEMASS Substation",[-70.78757877531154, 41.802953638202645]],
    [ "1150900624",[-85.23468561191004, 40.187159937276355]],
    [ "Centerville Station",[-84.96435605969904, 39.83861457455966]],
    [ "1150948993",[-80.7895204900709, 32.46179980620267]],
    [ "1150954621",[-88.00871413111022, 31.275247470473776]],
    [ "1150954623",[-88.00240389739051, 31.26465646881406]],
    [ "Linde Gas & Equipment, Inc.",[-88.00668154515351, 31.26798562542609]],
    [ "Bay Gas Storage Company, LLC",[-88.0155361078242, 31.25689012482997]],
    [ "Leroy Substation",[-87.9603235178295, 31.505876142516016]],
    [ "1150954647",[-88.19573986135316, 31.090200126250622]],
    [ "Tate & Lyle Sucralose Inc.",[-88.01378094999998, 31.2518593]],
    [ "Virginia Electric & Power Company",[-77.36472520351086, 36.10364749856855]],
    [ "1151020538",[-88.12040425, 30.896314049999997]],
    [ "Chunchula Substation",[-88.1997167, 30.917019099999994]],
    [ "1151020710",[-88.01503504008647, 30.953577975228907]],
    [ "Lockdale Substation",[-83.17904355, 42.59040585]],
    [ "Camden Substation",[-83.33106492219774, 42.64734643429433]],
    [ "1151088910",[-80.13823188173554, 36.284702198507716]],
    [ "Stanford Substation",[-84.67861309472367, 37.52908932512548]],
    [ "Kentucky Utilities Company",[-84.78647405, 37.58613155]],
    [ "Kentucky Utilities Company",[-84.79412846288142, 37.62214756908474]],
    [ "1151100034",[-80.66018514954513, 36.161175226589116]],
    [ "1151100035",[-80.65974238290772, 36.161440283613636]],
    [ "Winton Switching Station",[-86.75026003400546, 34.50305364150976]],
    [ "Morgan City Substation",[-86.56961731140798, 34.46760017408669]],
    [ "US Amines Substation",[-88.01445002532293, 30.986561156296503]],
    [ "Arkema Substation",[-88.02746317515064, 30.980588341346134]],
    [ "1151179859",[-88.02380020000001, 30.96156565]],
    [ "1151179880",[-88.02393154038117, 30.950026820341346]],
    [ "Saraland Substation",[-88.07532320000001, 30.804391449999997]],
    [ "1151179887",[-88.1291280196706, 30.771194388675713]],
    [ "1151179890",[-88.20935040000002, 30.789457449999997]],
    [ "1151179893",[-88.2260466, 30.716210150000002]],
    [ "1151179900",[-88.05781291567615, 30.748437503590882]],
    [ "1151179909",[-88.11639266055357, 30.673311737930973]],
    [ "1151179913",[-88.13575876564268, 30.730667074941298]],
    [ "1151179917",[-88.1563794, 30.621835249999997]],
    [ "1151179921",[-88.13783675, 30.549933149999998]],
    [ "1151179961",[-88.3436480061572, 30.588134280028914]],
    [ "1151179966",[-88.22748580499345, 30.559279667143766]],
    [ "1151207608",[-88.1146317790099, 30.535573442615664]],
    [ "Ineos Substation",[-88.1247285, 30.53143665]],
    [ "1151207613",[-88.12490947471873, 30.528365636515538]],
    [ "1151207620",[-88.1412423, 30.52893795]],
    [ "1151207622",[-88.1335427797515, 30.52579091061049]],
    [ "1151207635",[-88.23558873484637, 30.49493413200151]],
    [ "Grand Bay Substation",[-88.3359862, 30.47815545]],
    [ "Bayou La Batre Substation",[-88.2446513, 30.421434950000002]],
    [ "1151207648",[-88.11945971695823, 30.464746175091722]],
    [ "Coden Substation",[-88.23007826539245, 30.382991267849548]],
    [ "Gulfstream Substation",[-88.18994015, 30.39470475]],
    [ "W&T Offshore, Inc.",[-88.18010469789216, 30.429536668322513]],
    [ "Sidney or Leslie Metering No. 1 Substation",[-82.36260337926329, 37.62312245186446]],
    [ "Hatfield Substation",[-82.34078297462244, 37.65174350295479]],
    [ "Gund Mine Substation",[-82.35014537940778, 37.66310210051688]],
    [ "Borderland Substation",[-82.31689038755641, 37.73011435367655]],
    [ "Williams",[-88.17655420000001, 30.402481350000002]],
    [ "Layland Substation",[-80.96611181929636, 37.89921648634031]],
    [ "1151318544",[-81.05777135, 37.92629039999999]],
    [ "1151321199",[-88.36550113951493, 38.36384692505654]],
    [ "1151322821",[-88.057757295735, 38.36210713613851]],
    [ "1151323559",[-88.16064170000001, 30.65465575]],
    [ "1151323562",[-88.1715799, 30.68997029999999]],
    [ "1151323566",[-88.17393462521369, 30.727125453902826]],
    [ "1151323570",[-88.12507642028177, 30.65449302468848]],
    [ "1151323575",[-88.05310010066366, 30.66733580631251]],
    [ "1151323578",[-88.07296226929891, 30.613581646017686]],
    [ "1151323580",[-88.10648534999999, 30.629904899999996]],
    [ "Odyssey Substation",[-83.09529210000001, 42.619031250000006]],
    [ "1151371023",[-83.04005068236197, 42.609881625760764]],
    [ "1151373181",[-79.25996303189791, 36.811823380340535]],
    [ "1151373898",[-100.62011975, 31.532423999999995]],
    [ "Virginia Electric and Power Company",[-79.26672705, 37.11173635]],
    [ "Pacific Gas and Electric Company",[-122.37662104323823, 37.73401879143011]],
    [ "Pacific Gas and Electric Company",[-122.37989191669327, 37.73752389838281]],
    [ "1151382352",[-103.09708998580037, 36.130432824988965]],
    [ "1151382353",[-103.18502425, 36.447733299999996]],
    [ "Turkey Hill Switching Station",[-87.71596456808949, 30.3611058992031]],
    [ "1151416790",[-87.51152557496901, 30.407802309684204]],
    [ "Fish River Regulating Station",[-87.82237193351146, 30.50136776683721]],
    [ "1151416807",[-87.89427805000001, 30.51645405]],
    [ "1151416808",[-87.90244256775779, 30.480184384596797]],
    [ "Church Street Substation",[-87.90509026570224, 30.519757217537585]],
    [ "Fairhope Avenue Substation",[-87.87456080310035, 30.524379104019616]],
    [ "1151569819",[-87.77664822803912, 30.876871559123273]],
    [ "1151569823",[-87.77956541878892, 30.868598143748958]],
    [ "1151569831",[-87.6168125, 30.994002999999992]],
    [ "1151569834",[-87.78653601439792, 30.720743476553885]],
    [ "1151569839",[-87.75948919999998, 30.5491909]],
    [ "1151569846",[-87.7928509581025, 30.884717169398847]],
    [ "1151597233",[-96.97504211619207, 35.88472514068218]],
    [ "1151597238",[-97.00278448137831, 35.62352737502965]],
    [ "1151602702",[-96.94716718195582, 35.50814648999479]],
    [ "1151602703",[-96.93583086266295, 35.507757719486264]],
    [ "1151603790",[-96.87784081663813, 35.47005638422154]],
    [ "1151603796",[-97.0500408407469, 35.30467926877752]],
    [ "1151605245",[-83.04497622243325, 42.56399837815786]],
    [ "1151618253",[-96.78956224328978, 35.42285702870298]],
    [ "1151618259",[-96.63995162083103, 35.40447286555478]],
    [ "1151618265",[-96.64416692079003, 35.30519826625451]],
    [ "1151618266",[-96.64400488453435, 35.376418125075745]],
    [ "1151643676",[-96.5491415573311, 35.55120757472265]],
    [ "1151644329",[-96.45942452502469, 35.29037031293183]],
    [ "1151644332",[-96.45856007496835, 35.28975236233974]],
    [ "1151644336",[-96.44893512117415, 35.29088025354065]],
    [ "El Sobrante Substation",[-117.44073332046396, 33.85874293048349]],
    [ "1151666224",[-94.96999001006265, 35.87400191321596]],
    [ "Devils Brook Substation",[-74.53195042789189, 40.367972772251065]],
    [ "Pine Street Substation",[-70.92104064596009, 41.62964295901068]],
    [ "Bourne Switching Station",[-70.55907808104527, 41.765844722411344]],
    [ "Millenium Substation",[-72.01529523268368, 42.11334272390018]],
    [ "1152420303",[-83.1274008, 42.5481373]],
    [ "1152444612",[-83.11716037591857, 42.50181185739583]],
    [ "1152489921",[-88.1171659287712, 32.115744593741276]],
    [ "Kenney Substation",[-83.08403444948819, 42.47727037277457]],
    [ "1152562375",[-84.52637450034194, 38.24350270002942]],
    [ "1152567541",[-95.10430442044131, 35.10894667489595]],
    [ "1152567544",[-95.12007397486344, 35.10428229133751]],
    [ "Middle Creek Substation",[-82.88037862415632, 37.6023256918381]],
    [ "Huntington Substation",[-111.08573940871116, 39.383243637600614]],
    [ "Perry Township Substation",[-87.6837455108859, 37.93907026210212]],
    [ "1152980324",[-83.0326373245766, 42.6564057464675]],
    [ "Kiran Solar Substation",[-80.64975861921981, 27.57450668660851]],
    [ "1153009719",[-87.82907325, 32.509853850000006]],
    [ "1153009721",[-87.83553979999999, 32.52086705]],
    [ "1153009724",[-87.92895601063879, 32.45127922400106]],
    [ "Kolassa Substation",[-85.197721, 41.880574249999995]],
    [ "Moccasin Substation",[-81.42908564999999, 29.77848175]],
    [ "1153057739",[-106.68123427086833, 35.02525549700752]],
    [ "Guest Substation",[-85.85777201659545, 34.426689666744664]],
    [ "Cherokee Electric Cooperative",[-85.72423304201722, 34.16225587681008]],
    [ "Ellis Avenue Substation",[-71.1852218561709, 42.2061449200878]],
    [ "1153243331",[-90.74267726650598, 42.82780421664544]],
    [ "Entergy Arkansas",[-91.34417758359187, 34.149146603866065]],
    [ "C&L Electric Cooperative Corporation",[-91.56751586772529, 33.6803209342858]],
    [ "1153294572",[-86.23670226627195, 32.62245297024246]],
    [ "1153294577",[-86.17160373506046, 32.59389809205886]],
    [ "1153294578",[-86.17551885744993, 32.57653251010863]],
    [ "1153294584",[-86.3186444465972, 32.55938119691145]],
    [ "1153294597",[-86.35998363605482, 32.47699824087071]],
    [ "1153294603",[-86.46455323693597, 32.43486507519673]],
    [ "1153294606",[-86.48249940954524, 32.46282187522283]],
    [ "1153294611",[-86.25521372296876, 32.530366107702854]],
    [ "1153294620",[-86.3641431748783, 32.50754304096248]],
    [ "Livingston Substation",[-88.16238828822644, 32.60212666320735]],
    [ "Colonial Pipeline Company",[-88.18572495, 32.705202400000005]],
    [ "York Substation",[-88.27711023847259, 32.50493672878253]],
    [ "1153350622",[-88.30455966902893, 32.49353756302364]],
    [ "1153350624",[-88.34329464999999, 32.4572424]],
    [ "1153350627",[-88.18270895, 32.60666765]],
    [ "1153350628",[-88.18843481937265, 32.61796633895662]],
    [ "1153350635",[-88.11865340000001, 32.6919654]],
    [ "1153350637",[-88.15973366707888, 32.8148189164735]],
    [ "1153350639",[-88.31189073927824, 32.79960192655686]],
    [ "1153350640",[-88.30511208256915, 32.846864754855595]],
    [ "1153375088",[-102.48837875000002, 33.52075120000001]],
    [ "1153379387",[-90.92768326547967, 42.882824812764355]],
    [ "Duke Energy",[-82.72918899999999, 29.880488849999995]],
    [ "Duke Energy",[-82.72807174411682, 29.88068169210568]],
    [ "1153417638",[-88.02083904690122, 32.750623019443864]],
    [ "1153417639",[-88.02095615000002, 32.7503636]],
    [ "South Eutaw Substation",[-87.88765592507801, 32.831228007207145]],
    [ "Eutaw Substation",[-87.8723671, 32.840480549999995]],
    [ "1153417651",[-87.82720603396854, 32.61213242582588]],
    [ "Aliceville Substation",[-88.16379883320586, 33.129488833465594]],
    [ "Buchnan Lumber Substation",[-88.16610758097576, 33.12123038663793]],
    [ "1153417668",[-88.16200434108029, 33.252329814584726]],
    [ "1153417671",[-88.09150994999999, 33.26118875]],
    [ "Westervelt Substation",[-88.24712466804061, 33.07498241346683]],
    [ "1153417676",[-88.26529011667452, 33.058116449787136]],
    [ "1153479299",[-117.36705492161343, 34.6230811564998]],
    [ "First Electric Cooperative",[-91.34303438240197, 34.20963072542817]],
    [ "Elaine Substation",[-90.86729304885546, 34.317149716894626]],
    [ "Marvell Substation",[-90.90138534999998, 34.55682675]],
    [ "Entergy Arkansas",[-90.79405539216324, 34.56237137662428]],
    [ "Arkansas Electric Cooperative Corporation",[-91.31571635990467, 33.98640443033491]],
    [ "Big Sandy Substation",[-87.57605854650338, 33.06275572052572]],
    [ "North Moundville Substation",[-87.60191859999998, 33.016326]],
    [ "1153582541",[-87.69213759959342, 33.086604947544316]],
    [ "Romulus Substation",[-87.74847270791307, 33.15382532414419]],
    [ "Westervelt Substation",[-87.65320854999999, 32.960672949999996]],
    [ "CPL Moundville Substation",[-87.65481741296412, 32.977631680525874]],
    [ "Akron Substation",[-87.70801469750639, 32.879598915648124]],
    [ "PPL Akron Substation",[-87.70870895, 32.87934015]],
    [ "1153582562",[-87.86417578549137, 32.90760101835479]],
    [ "1153582584",[-87.3283826, 33.181594399999994]],
    [ "1153582588",[-87.25400050480316, 33.17097189846585]],
    [ "Pine Grove",[-82.43845338822136, 42.99888680770041]],
    [ "1153595550",[-87.17080696292648, 33.20509162303638]],
    [ "1153617918",[-82.9025911869265, 42.586460926172016]],
    [ "1153620243",[-82.91392767341318, 42.56989249981349]],
    [ "Lauder Substation",[-83.19403135946617, 42.444669044015136]],
    [ "Lambert Substation",[-83.00858595398434, 42.38879080887045]],
    [ "Hedges Substation",[-119.03931570544981, 46.17639105699847]],
    [ "Bison Substation",[-104.78080567450591, 41.064898114815]],
    [ "Archer Substation",[-104.64436375713342, 41.146624608472486]],
    [ "1153769133",[-87.87327471844227, 33.3955540820026]],
    [ "Gordo Substation",[-87.90451460944267, 33.31417117479628]],
    [ "Reform Substation",[-88.0359966663634, 33.39279514929318]],
    [ "Weyerhaeuser Substation",[-88.03000332042605, 33.5713160243889]],
    [ "Millport Substation",[-88.06829462288398, 33.56122569419402]],
    [ "1153861265",[-102.61804922521337, 37.38466740829321]],
    [ "1153861268",[-102.15939150000001, 37.295044850000004]],
    [ "1153878844",[-90.52549415000001, 42.82058645]],
    [ "1153895924",[-82.87178359904091, 42.55557882449071]],
    [ "First Electric Cooperative Cooperation",[-92.21912365185038, 35.61524123330828]],
    [ "Petit Jean Electric Cooperative Corporation",[-92.26889531195516, 35.610616062015424]],
    [ "1153927234",[-92.25417963433296, 35.61332679754889]],
    [ "1153927452",[-91.6427089380735, 36.60979402098618]],
    [ "1153929470",[-91.6859365763102, 36.73818269432068]],
    [ "1153929471",[-91.72030702693277, 36.80757251771483]],
    [ "1153929478",[-91.67059904090394, 36.99034787895124]],
    [ "1153929481",[-91.81132746864327, 36.974875407044884]],
    [ "1153937808",[-112.86897239506426, 32.41775778516344]],
    [ "1154039189",[-82.85336068802268, 42.59381772414341]],
    [ "Sutton Substation",[-82.88261451665944, 42.61308034916228]],
    [ "1154054643",[-82.88428139999998, 42.61087334999999]],
    [ "Plymouth Substation",[-120.84496005750299, 38.48075552906363]],
    [ "1154095799",[-87.13392395, 33.08828465]],
    [ "1154095803",[-86.97029975000001, 33.129769100000004]],
    [ "1154095804",[-86.96485795329393, 33.17831832876257]],
    [ "1154095807",[-86.93932536662267, 33.191765898210605]],
    [ "Maylene Quarry Substation",[-86.85928723185269, 33.184948483634784]],
    [ "Helena Substation (TS)",[-86.83984827515118, 33.29080694176966]],
    [ "1154095827",[-87.22147723329932, 32.93606935036235]],
    [ "Scott Davis Chip",[-87.18663884999998, 32.94730625]],
    [ "1154095831",[-87.18510433423839, 32.97142055462017]],
    [ "1154143693",[-82.9400928336727, 42.53879742536244]],
    [ "North Arkansas Electric Cooperative",[-91.61028829648914, 36.21449338497282]],
    [ "1154160974",[-91.42216445300551, 40.42519151223901]],
    [ "1154160982",[-91.41749085924425, 40.42208107505081]],
    [ "East Kentucky Power Cooperative, Inc.",[-84.93630734019519, 37.96139694180343]],
    [ "1154163764",[-117.4538748, 33.8548237]],
    [ "1154247690",[-113.272371916321, 37.78235132491837]],
    [ "1154247711",[-113.24859915000002, 37.77421615000001]],
    [ "1154270495",[-83.02291126365972, 42.53525326904937]],
    [ "1154303121",[-82.93573686203786, 42.49737761519801]],
    [ "1154319394",[-87.08748096058514, 32.94139841832455]],
    [ "1154319396",[-86.99458660843433, 33.00796307457835]],
    [ "1154319398",[-86.96047084835297, 33.0400276190921]],
    [ "1154319436",[-86.81771225, 33.0948769]],
    [ "Montevalo Plant",[-86.80749977687695, 33.09175259395738]],
    [ "Smith Hydro Substation",[-71.18408258034019, 44.465275348727324]],
    [ "McFarland Substation",[-113.49134177486597, 32.94856394194362]],
    [ "1154404964",[-95.04601126786446, 34.99232320413909]],
    [ "1154404968",[-94.72589169010017, 34.98550312502246]],
    [ "1154404971",[-94.62936605559368, 34.98714829472979]],
    [ "1154404976",[-94.34352587034778, 35.07248728939742]],
    [ "Arkansas Valley Electric Cooperative",[-94.32646682570594, 35.02791683894027]],
    [ "1154519570",[-83.24011207117599, 42.47356739114624]],
    [ "1154529742",[-83.22413327444778, 42.52251354098952]],
    [ "1154540686",[-83.26334837570525, 42.54361909265711]],
    [ "Blair Substation",[-83.1309826102167, 42.52741719828908]],
    [ "Puerto Rico Electric Power Authority",[-66.86368834999999, 18.03536835]],
    [ "1154551519",[-66.86219510000002, 18.03633105]],
    [ "1154577831",[-66.94979255, 18.0428147]],
    [ "Nicolai Substation",[-123.01068292962793, 44.04446365394093]],
    [ "1154590354",[-66.96261526507578, 18.074298865526004]],
    [ "Hickory Substation",[-83.24362892804317, 42.501278965676235]],
    [ "Arkansas Electric Cooperative Cooperation",[-92.92863799361963, 35.03517857441146]],
    [ "1154607885",[-86.68484258193111, 32.98389161507926]],
    [ "1154607890",[-86.67990535000001, 32.97984465]],
    [ "Glidewell Foundry Substation",[-86.73952264999998, 33.0951176]],
    [ "Calera Quarry Substation",[-86.76521443535601, 33.136104381798376]],
    [ "1154607915",[-86.776186741021, 33.21039042517357]],
    [ "1154607927",[-86.78062844881501, 33.21974831775182]],
    [ "1154607929",[-86.7895478188307, 33.21716444576601]],
    [ "1154607931",[-86.79044765, 33.218833000000004]],
    [ "1154607946",[-86.81696897601879, 33.25058341420834]],
    [ "CPC Pelham Substation",[-86.80265640000002, 33.282325900000004]],
    [ "1154607951",[-86.81241617302841, 33.280957056340526]],
    [ "Entergy Arkansas",[-92.05115767738826, 34.96764457669407]],
    [ "Embarcadero Substation",[-122.39381707358923, 37.787391284368105]],
    [ "1154734583",[-83.11780411719697, 42.45660017877088]],
    [ "1154855701",[-86.81428957332412, 33.29207945342746]],
    [ "1154855760",[-86.73983495270242, 33.44555382325738]],
    [ "1154855771",[-86.83593693997305, 33.40133176192129]],
    [ "1154868692",[-93.24938313367608, 38.85509163306157]],
    [ "Plainfield Substation",[-71.92413584295993, 41.664640273473445]],
    [ "West Water Street Substation",[-71.09349404461216, 41.88027910794386]],
    [ "Brayton Point 345kV Substation",[-71.19086909214883, 41.713849229161006]],
    [ "1154898402",[-113.16481800233619, 37.70295488992398]],
    [ "Wachovia Substation",[-86.923424240194, 33.4022974063116]],
    [ "1154908044",[-87.10958054835082, 33.353750240505896]],
    [ "1154908046",[-87.11690420000001, 33.355826300000004]],
    [ "1154908049",[-87.16288549005556, 33.35172304612212]],
    [ "1154908050",[-87.16323001221141, 33.35398762316392]],
    [ "1154908053",[-87.19864944999999, 33.3370789]],
    [ "1154908056",[-87.24001698468987, 33.32833884543787]],
    [ "1154908058",[-87.24143236565683, 33.32661125078383]],
    [ "1154908060",[-87.24244085, 33.32502970000001]],
    [ "Warrior",[-87.33387579305544, 33.328002579726416]],
    [ "Warrior",[-87.30758605, 33.28066315]],
    [ "1154908066",[-87.29527096554283, 33.288048997266706]],
    [ "Crimson Oak Grove Resources, LLC",[-87.11351386920289, 33.447903704452145]],
    [ "1155023016",[-91.89133755048431, 30.005752208728268]],
    [ "Sister Lakes Substation",[-86.16611341153342, 42.07892383005213]],
    [ "Indiana Michigan Power",[-86.14629379151974, 42.11440803842122]],
    [ "Midwest Energy & Communications",[-86.14567836686439, 42.114402474403654]],
    [ "Rothadew Station",[-86.03000022533608, 42.06281955374347]],
    [ "SLEMCO",[-92.27240390573496, 30.19811824635811]],
    [ "SLEMCO",[-92.05710036500452, 30.300072868019218]],
    [ "SLEMCO",[-92.01992993740271, 30.30180078917474]],
    [ "SLEMCO",[-91.84825070345588, 30.17492056639778]],
    [ "1155131728",[-87.26528560000001, 33.39311535000001]],
    [ "1155131729",[-87.26553970000002, 33.39329055]],
    [ "1155131733",[-87.23479104226882, 33.330629044231884]],
    [ "1155131736",[-87.24092232832247, 33.35172129593452]],
    [ "1155131738",[-87.23737567492053, 33.37647034323689]],
    [ "1155131739",[-87.25024769999999, 33.376234350000004]],
    [ "1155131740",[-87.25055036068723, 33.376754775610166]],
    [ "1155131741",[-87.29039963864922, 33.38108602939588]],
    [ "1155131742",[-87.30840685924672, 33.370851475296334]],
    [ "1155131746",[-87.31511045659583, 33.37679758939777]],
    [ "1155131748",[-87.33409872937418, 33.36735585976142]],
    [ "1155131750",[-87.34567826262034, 33.366555501840935]],
    [ "1155131754",[-87.44218432197309, 33.241388158840444]],
    [ "1155131757",[-87.2931494595599, 33.293159270175934]],
    [ "1155131758",[-87.29712412888165, 33.27299370657677]],
    [ "1155131761",[-87.15579463949348, 33.230802833681075]],
    [ "1155131764",[-87.17524410923644, 33.28637752473113]],
    [ "1155131766",[-87.16674895000001, 33.31889695]],
    [ "1155131768",[-87.07602797804175, 33.34822760579737]],
    [ "1155131773",[-87.36151882728952, 33.336473243799276]],
    [ "1155131774",[-87.32049614769045, 33.37629245458719]],
    [ "1155133241",[-91.97920433888177, 30.086482925057272]],
    [ "Entergy Louisiana",[-91.21652116278848, 30.491839762664693]],
    [ "FIXME Substation",[-94.88667708170223, 37.77557148773863]],
    [ "Winner Substation",[-82.10581484908943, 36.39779367855948]],
    [ "Gum Street Substation",[-119.10887927876837, 46.17672511505232]],
    [ "1155341607",[-86.09059997001599, 40.06975193627411]],
    [ "Westfield Northeast Substation",[-86.09098417473867, 40.06932415692683]],
    [ "1155341614",[-86.08008269085138, 40.10696292534003]],
    [ "1155342510",[-86.01460933848796, 40.10155084444418]],
    [ "1155365428",[-87.33895718577833, 33.38867492754854]],
    [ "1155365430",[-87.34497395000001, 33.393533500000004]],
    [ "1155365432",[-87.33587277880922, 33.407256304959354]],
    [ "1155365433",[-87.37444018440968, 33.38105516277732]],
    [ "1155365435",[-87.37658293686538, 33.385186188361665]],
    [ "1155365439",[-87.28313728044796, 33.41990170175149]],
    [ "1155365441",[-87.29022368851187, 33.423874216323874]],
    [ "1155365443",[-87.19990917980601, 33.37848211403869]],
    [ "1155365446",[-87.19954208133201, 33.38221366582442]],
    [ "1155365450",[-87.2001446, 33.40269274999999]],
    [ "1155365452",[-87.20167188069172, 33.40631562020114]],
    [ "1155365453",[-87.23839680796969, 33.41934151796876]],
    [ "1155365454",[-87.2126331516843, 33.372164716903335]],
    [ "1155365455",[-87.21805013824046, 33.3700302427539]],
    [ "1155365457",[-87.26202126608302, 33.45473783193556]],
    [ "1155365461",[-87.27324722316702, 33.47790053924231]],
    [ "1155365465",[-87.27676025757361, 33.484782646227984]],
    [ "1155365467",[-87.3301831713853, 33.53220320444993]],
    [ "1155365480",[-87.09305545000001, 33.5080438]],
    [ "Crimson Oak Grove Resources, LLC",[-87.09686610000001, 33.49265445]],
    [ "Crimson Oak Grove Resources, LLC",[-87.0941874902639, 33.48640077184955]],
    [ "Crimson Oak Grove Resources, LLC",[-87.10088962486266, 33.48048600791651]],
    [ "Crimson Oak Grove Resources, LLC",[-87.13732237506682, 33.451028044669755]],
    [ "Crimson Oak Grove Resources, LLC",[-87.1520777012342, 33.458792466733414]],
    [ "Crimson Oak Grove Resources, LLC",[-87.12601503970039, 33.47482762921491]],
    [ "Crimson Oak Grove Resources, LLC",[-87.1415093829174, 33.48123433369816]],
    [ "1155365498",[-87.1403907, 33.487291299999995]],
    [ "Crimson Oak Grove Resources, LLC",[-87.14155043946103, 33.495175424199]],
    [ "Crimson Oak Grove Resources, LLC",[-87.123758828583, 33.43971273562644]],
    [ "Crimson Oak Grove Resources, LLC",[-87.1233269063311, 33.4399150566513]],
    [ "Crimson Oak Grove Resources, LLC",[-87.10907435000001, 33.437512600000005]],
    [ "Crimson Oak Grove Resources, LLC",[-87.13599515, 33.4338598]],
    [ "1155365513",[-87.1356737, 33.43941605]],
    [ "Crimson Oak Grove Resources, LLC",[-87.13499189999999, 33.439415049999994]],
    [ "Crimson Oak Grove Resources, LLC",[-87.16648210897543, 33.4351500218952]],
    [ "Crimson Oak Grove Resources, LLC",[-87.16388776028522, 33.43550632317026]],
    [ "Crimson Oak Grove Resources, LLC",[-87.15879985, 33.4469387]],
    [ "1155365522",[-87.02137079999999, 33.494091]],
    [ "Crimson Oak Grove Resources, LLC",[-87.01877371179991, 33.48087827506414]],
    [ "Crimson Oak Grove Resources, LLC",[-87.03279109068939, 33.456596677814915]],
    [ "Crimson Oak Grove Resources, LLC",[-87.0328215880894, 33.45436942786013]],
    [ "Crimson Oak Grove Resources, LLC",[-87.05847301287272, 33.45202923173195]],
    [ "Crimson Oak Grove Resources, LLC",[-87.08806958074153, 33.443299314343435]],
    [ "1155365535",[-87.06726296354978, 33.481149418829595]],
    [ "Holcim",[-86.89539775, 33.459231599999995]],
    [ "U.S. Pipe",[-86.96923634999999, 33.41665835]],
    [ "U.S. Pipe",[-86.97133757965446, 33.419495839479616]],
    [ "1155392853",[-86.96274616364869, 33.42520193104776]],
    [ "Bessemer Electric Service",[-86.95310064999998, 33.40750165]],
    [ "Bessemer Electric Service",[-86.96771573313652, 33.39260064373799]],
    [ "1155392879",[-86.97543276533858, 33.39622008613341]],
    [ "1155392881",[-86.96417045742801, 33.42073996810921]],
    [ "Bessemer Electric Service",[-86.9681034, 33.38786435000001]],
    [ "Bessemer Electric Service",[-86.93550475, 33.40734225]],
    [ "Bessemer Electric Service",[-86.9881678400928, 33.372112575355736]],
    [ "1155392909",[-86.99312656060637, 33.375024671689516]],
    [ "1155392919",[-86.9251476899108, 33.34254252524218]],
    [ "Bessemer Electric Service",[-86.93561168281502, 33.350841801054244]],
    [ "Hueytown Substation",[-86.97845868802168, 33.42993971451474]],
    [ "1155392930",[-86.98692163167986, 33.448500032379705]],
    [ "Pleasant Grove Substation",[-86.96133674010481, 33.47978495712114]],
    [ "1155392933",[-86.94932345475033, 33.47530776361478]],
    [ "United States Steel Corp",[-86.93659463648078, 33.48128302959657]],
    [ "United States Steel Corp",[-86.94497015497697, 33.47995480338855]],
    [ "1155438504",[-86.90849253552773, 33.50333608923356]],
    [ "United States Steel Corp",[-86.91994003563718, 33.48772592906205]],
    [ "United States Steel Corp",[-86.93082550000001, 33.47590435]],
    [ "United States Steel Corp",[-86.92513130221377, 33.483407778977615]],
    [ "United States Steel Corp",[-86.93222642879718, 33.48041569349947]],
    [ "United States Steel Corp",[-86.94676282443702, 33.470482043151634]],
    [ "United States Steel Corp",[-86.94783071592897, 33.47019869800905]],
    [ "United States Steel Corp",[-86.94354945000002, 33.47459945]],
    [ "United States Steel Corp",[-86.9416272190272, 33.48212988622077]],
    [ "United States Steel Corp",[-86.9405669885083, 33.48293109444279]],
    [ "United States Steel Corp",[-86.9342351, 33.49000715]],
    [ "United States Steel Corp",[-86.94412564812032, 33.47333241678539]],
    [ "United States Steel Corp",[-86.9514017830102, 33.46111357495305]],
    [ "United States Steel Corp",[-86.94472739217682, 33.4725114081657]],
    [ "1155438595",[-86.96340716832731, 33.514148463944956]],
    [ "1155438597",[-87.01041515000001, 33.5209062]],
    [ "Goodsprings Substation",[-87.22269722303824, 33.657449844709596]],
    [ "1155587767",[-87.57351263785527, 33.32752967577062]],
    [ "1155587768",[-87.61006754259171, 33.35031257842752]],
    [ "1155587770",[-87.44077099265921, 33.40332573072328]],
    [ "1155587772",[-87.41021191570533, 33.44361344258268]],
    [ "Warrior Met Coal Mining, LLC",[-87.39760726268476, 33.42876579030072]],
    [ "1155587781",[-87.34604329999999, 33.544171600000006]],
    [ "Coffeen Street Station",[-75.94842568315038, 43.98935945420717]],
    [ "1155631444",[-91.20610958723772, 44.83579091991803]],
    [ "Delta Energy Center",[-121.84661195722545, 38.017311672344924]],
    [ "Fulton Springs Substation",[-86.80914168444338, 33.61690744024157]],
    [ "1155634307",[-87.19669028465653, 33.64437364943685]],
    [ "1155634308",[-87.20069269275427, 33.64406851306806]],
    [ "Birmingham Water Works",[-87.11874099999999, 33.66160505]],
    [ "Birmingham Water Works",[-87.1212220946498, 33.66996418026323]],
    [ "1155634322",[-87.17911361345239, 33.64299397491229]],
    [ "1155634324",[-86.92740635814992, 33.546170218103164]],
    [ "Birmingham Water Works",[-86.90264845000002, 33.53209365]],
    [ "1155641962",[-96.9156752899233, 32.97450232487443]],
    [ "Lone Tree Substation",[-121.75977564951747, 37.94612680644281]],
    [ "NW Electric Power Cooperative",[-94.31102255989998, 39.535966350429945]],
    [ "Alderwood Substation",[-123.3669253776658, 44.15010937490619]],
    [ "Cheshire Substation",[-123.23045600402274, 44.19279496621997]],
    [ "Fore River Maine Substation",[-70.27670955382979, 43.642864266393154]],
    [ "Stock Island Substation",[-81.73374683589337, 24.562394533286806]],
    [ "Stock Island Substation",[-81.73414687263502, 24.56266325716371]],
    [ "1155824571",[-83.16095541558892, 42.45325590919304]],
    [ "1155847462",[-87.0578612441493, 33.631343141954986]],
    [ "1155847486",[-87.06132910778577, 33.63476153682434]],
    [ "Midtown Substation",[-86.81460778502628, 33.504641497342995]],
    [ "1155887547",[-86.8198787681696, 33.47336009477172]],
    [ "1155887548",[-86.7364999260446, 33.479116934130985]],
    [ "1155923911",[-69.9016730813737, 43.9118163644674]],
    [ "1155923912",[-69.88428208498947, 43.91814016254504]],
    [ "1155935394",[-69.82028038144568, 43.93075636831661]],
    [ "FIXME Substation",[-95.36092111561744, 37.601422625076914]],
    [ "FIXME Substation",[-95.23729850000001, 37.567534450000004]],
    [ "FIXME Substation",[-95.47058449126196, 37.698010275236726]],
    [ "FIXME Substation",[-95.46353362119959, 37.69845373640126]],
    [ "1155941225",[-95.62864177512067, 36.993790056615694]],
    [ "Mallory Road Station",[-76.13903831776196, 43.29664197049304]],
    [ "1156066136",[-83.20151811554379, 42.488717250754654]],
    [ "1156071589",[-83.21097416332567, 42.50316292426426]],
    [ "Oak Park",[-83.18281993615294, 42.46713097537472]],
    [ "Northland Substation",[-83.20165390778716, 42.45567322388945]],
    [ "1156133800",[-86.64736119559488, 33.506106317064585]],
    [ "CMC Steel",[-86.75677015857123, 33.53312225515041]],
    [ "Walnut Hill Substation",[-86.80896766774772, 33.53194619486688]],
    [ "SA Recycling",[-86.78898268075349, 33.55143666289085]],
    [ "Sloss Industries",[-86.79998398299925, 33.563739913101045]],
    [ "Sloss Industries",[-86.80046631184335, 33.56890687984097]],
    [ "1156133937",[-86.85112670000001, 33.5556001]],
    [ "Acipco Substation",[-86.83043637365638, 33.546194540169196]],
    [ "Chemical Substation",[-68.82486427074261, 44.73904656185962]],
    [ "Clifton Switching Station",[-68.5175559613109, 44.78221195688969]],
    [ "Pisgah Mountain Wind Substation",[-68.51915760806376, 44.78189244881899]],
    [ "Robert Substation",[-90.3208641487636, 30.50657637237097]],
    [ "1156180051",[-99.70878100648234, 34.47900172509757]],
    [ "1156180055",[-99.75484737518485, 34.645512912673844]],
    [ "1156180056",[-99.89510957433917, 34.67367918667761]],
    [ "1156180057",[-99.5266469, 34.6520408]],
    [ "1156180059",[-99.56985761007994, 34.652316676920954]],
    [ "1156180416",[-99.19973838947847, 34.09983904050057]],
    [ "1156184997",[-99.42203350000001, 35.030097000000005]],
    [ "1156185003",[-99.23679562519823, 35.03653371133747]],
    [ "1156185005",[-99.4263369390556, 35.2481004750384]],
    [ "1156185011",[-99.39878625760437, 35.364226423706526]],
    [ "1156190792",[-82.62614676428525, 42.67434845894951]],
    [ "Indian Substation",[-83.31227670840865, 42.43801836497718]],
    [ "1156317695",[-83.30906190474933, 42.33366550437066]],
    [ "American Cast Iron Pipe Company",[-86.8343088756017, 33.545746788960265]],
    [ "American Cast Iron Pipe Company",[-86.832374, 33.545689749999994]],
    [ "1156362218",[-77.49135183356653, 38.96507734757771]],
    [ "Sojourner Substation",[-77.4917916817937, 38.96580465138621]],
    [ "Gary Substation",[-83.28381996644703, 42.4420343087827]],
    [ "Emerick Substation",[-83.5952791, 42.232755149999996]],
    [ "Broken Ground Substation",[-71.49418850814642, 43.23177925985966]],
    [ "Florida Power & Light",[-81.72784186702995, 26.85647156630719]],
    [ "1156704608",[-86.46849685000001, 33.24325875000001]],
    [ "Sylacauga Substation",[-86.28158082447885, 33.16714850453611]],
    [ "1156704658",[-86.29698955, 33.065677150000006]],
    [ "Heritage Plastics Inc.",[-86.29138492472053, 33.161901359395266]],
    [ "1156704662",[-86.29625843303882, 33.157480503450934]],
    [ "Silver Run Substation",[-75.62936874968109, 39.456843931350015]],
    [ "1156795622",[-86.17556175104663, 33.111615654745464]],
    [ "Sunny Level Substation",[-85.9325324, 32.975432100000006]],
    [ "Kellyton Substation",[-86.01742206985202, 32.9723624336929]],
    [ "SL Alabama",[-85.96880055, 32.9115144]],
    [ "1156795637",[-85.96539184999999, 32.932667949999995]],
    [ "1156795639",[-85.94730211010089, 32.93535532232072]],
    [ "Resolute Forest Products",[-85.81424693499581, 32.87792449536197]],
    [ "1156795653",[-85.9562079056981, 32.93399492346095]],
    [ "1156795656",[-85.96383116485424, 32.925841480832595]],
    [ "1156795662",[-85.9401869, 32.787325149999994]],
    [ "1156795664",[-86.0530841, 33.06299755]],
    [ "1156795665",[-86.05660373062446, 33.04881814291916]],
    [ "1156795668",[-85.97846240000001, 33.1139547]],
    [ "Alexander City Substation",[-85.97643255155639, 32.948431827519215]],
    [ "Red Boiling Springs Substation",[-85.84657977274453, 36.53941227266651]],
    [ "1157027241",[-85.94546685, 32.9382267]],
    [ "1157027242",[-85.93806255, 32.92587125]],
    [ "Alabama Power",[-85.8507751604696, 32.87940168309914]],
    [ "1157027264",[-86.07351867537531, 32.96096561143939]],
    [ "1157027268",[-86.2047499, 32.8925266]],
    [ "1157027270",[-86.22641768349754, 32.866314166691986]],
    [ "Central Alabama Wood Products LLC",[-86.1028284, 32.852136449999996]],
    [ "1157027276",[-86.01384061056828, 32.90266398249256]],
    [ "1157027277",[-86.01343218051842, 32.90326366314689]],
    [ "1157027288",[-86.01338462484739, 32.89908844404727]],
    [ "1157027289",[-86.01230953444976, 32.90040148467488]],
    [ "1157027290",[-86.01077291664856, 32.90193620045883]],
    [ "1157027291",[-86.01038489999999, 32.902425949999994]],
    [ "Stockdale Substation",[-86.0272702, 33.4282586]],
    [ "1157063311",[-85.93238659133942, 33.31742952243139]],
    [ "1157063315",[-85.96890328302946, 33.53799818379495]],
    [ "1157063317",[-85.95194045752635, 33.53717897072692]],
    [ "1157063325",[-86.12348190000002, 33.411160800000005]],
    [ "Georgia Pacific",[-86.05776662507108, 33.44638615701526]],
    [ "1157063331",[-86.08072550000001, 33.432770749999996]],
    [ "Sylacauga Utilities Board",[-86.29580132512025, 33.168478008431116]],
    [ "1157123643",[-86.26061438501307, 33.19163589681973]],
    [ "Southern Alloy Corporation",[-86.33036355000002, 33.232657350000004]],
    [ "1157123675",[-86.23641725, 33.2111157]],
    [ "Talladega Substation",[-86.16475320090909, 33.35218674774366]],
    [ "West Talladega Substation",[-86.1315258597297, 33.42745847504201]],
    [ "1157123683",[-86.10836286496118, 33.501834381958]],
    [ "1157165691",[-96.06757584313809, 33.387824397167314]],
    [ "1157165705",[-95.63694269428294, 33.51620553035587]],
    [ "1157215359",[-110.09494240000001, 31.747932900000002]],
    [ "Talladega Substation",[-86.14009765038719, 33.410786637228455]],
    [ "1157250004",[-86.10692058645607, 33.43680847901937]],
    [ "1157250006",[-86.09696872550948, 33.44029110646953]],
    [ "Talladega Foundry & Machine Co, Inc.",[-86.08953263152902, 33.44147192705395]],
    [ "1157250010",[-86.11424705, 33.4451266]],
    [ "1157250023",[-86.09652735, 33.45813385]],
    [ "1157250029",[-86.28137082499916, 33.645682292253696]],
    [ "1157250035",[-86.37576514233555, 33.59552756886042]],
    [ "Alabama Power",[-86.50535538473734, 33.552945012446585]],
    [ "Eureka Substation",[-86.17274450700407, 33.54514732863097]],
    [ "Steward's Crossroads Substation",[-86.44656037990403, 33.50182599540556]],
    [ "1157250077",[-86.54133080000001, 33.54126575]],
    [ "Hubbell Power Systems, Inc.",[-86.54855597275447, 33.550836038671676]],
    [ "Vincent Substation",[-86.39862424157079, 33.41298877663001]],
    [ "1157273455",[-86.29838785, 33.425200350000004]],
    [ "Grasmere Substation",[-86.32728953366932, 33.37507643196788]],
    [ "Coosa Pines Substation",[-86.35158838127474, 33.34509708232027]],
    [ "Harpersville Substation",[-86.40764356243035, 33.349759570398604]],
    [ "1157273467",[-86.35603082534672, 33.327659033707846]],
    [ "DTE Energy",[-84.33403446973979, 43.461857002821645]],
    [ "Lake Earl Substation",[-124.1479948745696, 41.85177969414038]],
    [ "1157360961",[-86.5970471, 33.6105017]],
    [ "Moody Substation",[-86.52105186531772, 33.569890830713724]],
    [ "1157360993",[-86.6889008, 33.62051519999999]],
    [ "1157360995",[-86.68799641363003, 33.606112625411605]],
    [ "Ketona Substation",[-86.75616452618893, 33.606675043496146]],
    [ "Sun Valley Substation",[-86.70148943305719, 33.638689101711485]],
    [ "1157361019",[-86.76995889999999, 33.5883002]],
    [ "1157361021",[-86.79399244999999, 33.5710603]],
    [ "1157394877",[-85.9280442, 33.594130500000006]],
    [ "1157394878",[-85.9260066, 33.60290395]],
    [ "Products (SE) Pipe Line Corporation",[-85.90893113379393, 33.56731821782989]],
    [ "1157394882",[-85.8572496, 33.648839949999996]],
    [ "1157394883",[-85.86077373325956, 33.65155871659933]],
    [ "Alabama Power",[-85.83386378951259, 33.67145362509488]],
    [ "Bae Systems, Inc.",[-85.85693858848082, 33.65895163298646]],
    [ "Union Foundry Co.",[-85.85043301570619, 33.667431295282874]],
    [ "Anniston Plating & Metal Finishing, Inc.",[-85.85018235, 33.681008850000005]],
    [ "Blue Mountain Substation",[-85.83851111155609, 33.69151447526129]],
    [ "1157394898",[-85.77781270758625, 33.81521503026927]],
    [ "East Jacksonville Substation",[-85.75069660734994, 33.817081474816526]],
    [ "1157394905",[-85.77007, 33.8235271]],
    [ "1157394907",[-85.77194897197533, 33.82711925096883]],
    [ "1157394909",[-85.75768445290633, 33.8494471627559]],
    [ "Eight Mile Substation",[-82.9705896011779, 42.44937965437137]],
    [ "1157429296",[-83.02941825, 42.47770284999999]],
    [ "1157434646",[-95.2577655249044, 33.23480102962307]],
    [ "Greenbrier Substation",[-85.78795895000002, 33.62592525]],
    [ "1157493032",[-85.82109975, 33.6838901]],
    [ "1157493035",[-85.73559041555615, 33.63728373454703]],
    [ "1157493039",[-85.61339067487242, 33.56470563936523]],
    [ "1157493045",[-85.51558681054419, 33.64907413903614]],
    [ "Colonial Pipeline Company",[-85.51447284200276, 33.64858873043999]],
    [ "Forte Power Systems",[-85.55562367772495, 33.68448023215002]],
    [ "1157493050",[-85.4933006042735, 33.722836217683756]],
    [ "1157493051",[-85.55865486202494, 33.63752798313371]],
    [ "1157493053",[-85.57491460000001, 33.66345110000001]],
    [ "1157493056",[-85.59366865, 33.63769695]],
    [ "Swagg Substation",[-85.54454968677081, 33.367823811628625]],
    [ "1157493059",[-85.46569378017499, 33.43695894513714]],
    [ "Ranburne Substation",[-85.36746369722385, 33.53554359711055]],
    [ "1157535710",[-83.01072301345503, 42.455336769086]],
    [ "Fairmount Substation",[-83.00461382529761, 42.4432889076268]],
    [ "Shores Substation",[-82.91556505681746, 42.46610603545733]],
    [ "1157544308",[-82.9075684586022, 42.47881002456882]],
    [ "1157581077",[-86.59570456572077, 33.150458051482154]],
    [ "Chelsea Substation",[-86.63463409999999, 33.3366307]],
    [ "Alabama Power",[-86.66609216021668, 33.402003324890615]],
    [ "1157665913",[-95.42176511246639, 32.32956059787268]],
    [ "1157758280",[-85.36948724999998, 33.13184675]],
    [ "Rock Stand Substation",[-85.38848632947581, 33.24643537343396]],
    [ "Weodowee Substation",[-85.47820615, 33.29304945]],
    [ "Mellow Valley Substation",[-85.74822510000001, 33.18569995]],
    [ "1157758306",[-85.74758948722577, 33.30601218089087]],
    [ "Lineville Substation",[-85.75854414999999, 33.29640935]],
    [ "1157758309",[-85.71073853833205, 33.33264298058031]],
    [ "Pyriton Substation",[-85.82338141673176, 33.35410180516835]],
    [ "Ashland Substation",[-85.83828095, 33.275291249999995]],
    [ "1157758330",[-85.88958135251247, 33.21093018282127]],
    [ "1157764992",[-90.88428795, 32.88880975]],
    [ "1157765972",[-85.01835085488116, 32.31540605922213]],
    [ "1157765975",[-85.000468, 32.267975750000005]],
    [ "1157765978",[-85.05576438140963, 32.16106337281895]],
    [ "Mid Valley Pipeline Company LLC",[-91.052992, 32.87703450000001]],
    [ "Wilder Hydro Substation",[-72.3037125361546, 43.66845454049036]],
    [ "1157812394",[-94.50478624999998, 39.5218993]],
    [ "1157823085",[-85.98570767506835, 41.3470925557969]],
    [ "Six Mile Substation",[-83.29922453928053, 42.41357906956859]],
    [ "1157931765",[-90.2062288248241, 30.783500986939085]],
    [ "1157931766",[-90.20630526315064, 30.78280038077254]],
    [ "1157936990",[-107.56001683869198, 35.971373462828694]],
    [ "1157940852",[-97.2700924219396, 29.894873315378895]],
    [ "1157940853",[-97.26974948576905, 29.896172671303685]],
    [ "Badger Hollow",[-90.34870549722658, 42.94594580554043]],
    [ "1157963256",[-80.33361005594463, 25.435542796358444]],
    [ "1157981360",[-86.10912460845749, 33.59256932899119]],
    [ "1157981362",[-86.1132509625412, 33.60428602433802]],
    [ "Honda Maunfactoring of Alabama",[-86.14045057517345, 33.6200524561386]],
    [ "Holly Hills Substation",[-86.11800759999998, 33.64103625]],
    [ "National Cement Co. of Alabama, Inc.",[-86.15286763938367, 33.73296487310236]],
    [ "National Cement Co. of Alabama, Inc.",[-86.11425985000002, 33.74035930000001]],
    [ "Inkster Substation",[-83.30928489999998, 42.2852476]],
    [ "1158035145",[-96.05245814174992, 36.927599580130796]],
    [ "Berkshire Power Substation",[-72.64775746322648, 42.04854598488255]],
    [ "1158036982",[-93.6924074894667, 41.034381125047446]],
    [ "1158036989",[-93.84614996251284, 41.19517852400883]],
    [ "Booneville Substation",[-93.92004721496859, 35.13765254501418]],
    [ "1158145600",[-103.80741874999997, 32.6414394]],
    [ "1158204884",[-83.33927157540832, 42.302598358096354]],
    [ "Ragland Clay Products",[-86.15943505788064, 33.737478768447666]],
    [ "1158249788",[-86.23675496809761, 33.78103494709315]],
    [ "1158249792",[-86.25385585, 33.823365333308644]],
    [ "1158249796",[-86.18971143342138, 33.93187005066221]],
    [ "1158249805",[-86.13730331068416, 33.98519011909935]],
    [ "1158249806",[-86.0989126668124, 34.01245109897266]],
    [ "1158249812",[-86.3682417, 33.90141099999999]],
    [ "1158249814",[-86.4266708611386, 33.92166422543947]],
    [ "Assembly Solar Substation",[-83.94189329109741, 43.01846008152617]],
    [ "Leonard Substation",[-85.6711454860729, 42.98554507985649]],
    [ "Stony Brook Substation",[-72.51001914250247, 42.19772447592201]],
    [ "Stony Brook Substation",[-72.51023668455048, 42.19714467854395]],
    [ "1158315503",[-94.23097392479798, 39.39316755893331]],
    [ "1158323505",[-94.33226500508738, 39.34674332779315]],
    [ "1158323507",[-94.36758645, 39.388669349999994]],
    [ "1158323513",[-94.33615893279266, 39.435108133875296]],
    [ "Puget Sound Energy",[-122.69262762306722, 48.21197931012214]],
    [ "1158361966",[-107.27745332548545, 36.32712840224434]],
    [ "Cedar Bend Substation",[-86.04326003984595, 33.899948680453086]],
    [ "1158414752",[-86.02405451025417, 33.92646762513075]],
    [ "Alabama Power",[-86.0710334745784, 33.9449193880167]],
    [ "1158414764",[-86.06779337509573, 33.98482050725553]],
    [ "1158414772",[-86.02205388288161, 33.7886608546168]],
    [ "1158414776",[-85.87222541132027, 33.704496024955446]],
    [ "1158414778",[-85.89481755000001, 33.782526350000005]],
    [ "1158414781",[-85.62867660818922, 33.91779711247911]],
    [ "1158414783",[-85.62117441493974, 33.921455569164316]],
    [ "1158414787",[-85.58599804143914, 33.92270292608627]],
    [ "1158414788",[-85.61030537037372, 33.93303933818476]],
    [ "1158414792",[-85.65968565000001, 33.94770255]],
    [ "1158414793",[-85.71461635554687, 33.95549182587438]],
    [ "1158414795",[-85.8115890188597, 33.982761703618415]],
    [ "1158414797",[-85.86448502430278, 33.9851565337548]],
    [ "1158414800",[-85.91380625857735, 33.92888087491841]],
    [ "1158414801",[-85.97166765962777, 33.85617653570241]],
    [ "1158414803",[-85.9515942, 33.96505015000001]],
    [ "1158414806",[-85.94726481584736, 33.9809171950419]],
    [ "1158414808",[-85.95079793197955, 34.00106857375867]],
    [ "1158439387",[-94.38352021828754, 39.3731605353573]],
    [ "Wilmington Substation",[-72.8952659381698, 42.873959259765705]],
    [ "1158510364",[-85.95695040375453, 33.988632916072824]],
    [ "1158510389",[-85.98781304186366, 34.006924167268366]],
    [ "Goodyear",[-85.97845920378396, 34.01282307505238]],
    [ "1158510401",[-85.98861091602247, 34.0209093487836]],
    [ "1158510403",[-85.99940873964631, 34.01569220806477]],
    [ "1158510405",[-85.98829806754478, 33.995868903050614]],
    [ "1158510411",[-86.03614307535376, 34.01493659458334]],
    [ "1158510427",[-86.08258021562092, 33.988626682280454]],
    [ "1158510429",[-86.0953712, 34.01645835]],
    [ "Camp Silbert Substation",[-86.11702460000001, 33.99216735]],
    [ "1158510432",[-86.0141118622257, 34.00016212283009]],
    [ "1158510434",[-86.00793310000002, 34.01077245]],
    [ "1158510437",[-86.04285935, 33.9780786]],
    [ "1158510440",[-86.1813233333449, 34.12064289992288]],
    [ "Howelton Substation",[-86.20681069568747, 34.0611340747823]],
    [ "1158564355",[-93.48025097102031, 39.68684673597797]],
    [ "1158567487",[-111.68081275852325, 33.50361060642716]],
    [ "1158567705",[-94.53197642484952, 39.353439642410336]],
    [ "1158567978",[-94.43208743461402, 39.7734662954226]],
    [ "Snead Substation",[-86.37586705312391, 34.10446734961432]],
    [ "Brooksville Substation",[-86.47537294999998, 34.1604768]],
    [ "Blountsville Substation",[-86.57114049223043, 34.08604561757671]],
    [ "Blountsville Substation",[-86.58366185, 34.091302999999996]],
    [ "1158623655",[-86.58364678562488, 34.053372226536894]],
    [ "Tyson Foods",[-86.58250080919167, 34.05341177279012]],
    [ "Alabama Power",[-86.62209298335455, 34.067902997862475]],
    [ "West Oneonta Substation",[-86.47362509575373, 33.94310966907248]],
    [ "Cleveland Substation",[-86.57888567086844, 33.98931041270585]],
    [ "Locust Fork Substation",[-86.66025060354677, 33.93109358213788]],
    [ "1158623664",[-86.66004871185666, 33.931933170682086]],
    [ "1158623667",[-86.60610013843377, 33.9149221893102]],
    [ "Alabama Power",[-86.60023931670412, 33.8196820548476]],
    [ "Selfville Substation",[-86.66787355, 33.824413850000006]],
    [ "Trafford Substation",[-86.71374024999999, 33.81700095]],
    [ "Trafford Substation",[-86.71397851098092, 33.81760947531636]],
    [ "1158623680",[-86.44392880000001, 33.97319675000001]],
    [ "Hendrix Substation",[-86.4489717, 34.04007305000001]],
    [ "1158623685",[-86.46439483322926, 33.93556376636635]],
    [ "Horton Substation",[-86.28328826280313, 34.19832157350164]],
    [ "Boaz South Substation",[-86.1565043023665, 34.19149822633778]],
    [ "Whitesboro Substation",[-86.05307930000001, 34.1772556]],
    [ "Albertville Substation",[-86.20012092330096, 34.26754277443498]],
    [ "Marshall-DeKalb Electric Cooperative",[-86.1922111640508, 34.28276428405181]],
    [ "Marshall-DeKalb Electric Cooperative",[-86.14794069999999, 34.297432549999996]],
    [ "Marshall-DeKalb Electric Cooperative",[-85.99589029551541, 34.31697009112645]],
    [ "ICD Alloys & Metals",[-86.23176379598505, 34.311403031489064]],
    [ "Mt. High Substation",[-86.27970388169504, 34.29302533523889]],
    [ "Alabama Power",[-85.8991645166669, 34.05150175003562]],
    [ "1158706499",[-85.91816510045636, 34.151153866589496]],
    [ "Syracuse Substation",[-83.26629960110755, 42.26888644658457]],
    [ "Martinsville Substation",[-74.56886162489305, 40.648162995621966]],
    [ "1158808423",[-82.38632746812382, 27.779984109415388]],
    [ "1158838083",[-93.98341788411022, 39.55387773261327]],
    [ "1158871468",[-94.11230554999999, 39.74589925]],
    [ "1158871471",[-93.85300388645267, 39.77903277523997]],
    [ "1158871473",[-93.95078819151755, 39.929826528027256]],
    [ "1158881853",[-94.33874568917128, 39.54308787471424]],
    [ "1158882104",[-93.98297551443046, 39.99710880165666]],
    [ "Fultondale Substation",[-86.80054508079468, 33.62212490191739]],
    [ "Tennessee Valley Authority",[-86.47008685, 34.317591150000005]],
    [ "Warrenton Substation",[-86.36288814999997, 34.3453784]],
    [ "Happy Home Substation",[-86.31478826956877, 34.317436539300935]],
    [ "Guntersville Electric Board",[-86.29717464519905, 34.34753797834768]],
    [ "Loveless Street Substation",[-86.29866525226193, 34.34840683277735]],
    [ "Alder Springs Substation",[-86.23824691978913, 34.36185985726679]],
    [ "Lattiwood Substation",[-86.28245887418358, 34.272918610570485]],
    [ "Section Substation",[-85.98830442488905, 34.55112940657947]],
    [ "North East College Substation",[-85.91652447638033, 34.550846817536545]],
    [ "Rainsville Industrial Substation",[-85.82562924276718, 34.49526943464165]],
    [ "Sylvania Substation",[-85.77824148450514, 34.52298462393999]],
    [ "Fort Payne Improvement Authority",[-85.7208765876185, 34.438459049651364]],
    [ "Sand Mountain Electric Cooperative",[-85.60006055000001, 34.55193559999999]],
    [ "1158956754",[-93.82999652513278, 40.03990745822493]],
    [ "1158956757",[-93.79300250477748, 40.047201471684055]],
    [ "Nankin Substation",[-83.35306127240705, 42.28148499374882]],
    [ "1158969592",[-85.76141975093114, 34.1859134671494]],
    [ "Centre Substation",[-85.6576671247214, 34.16230244292101]],
    [ "1158969603",[-85.56375799999999, 34.27402]],
    [ "1158991172",[-82.38292634262292, 27.764659982071034]],
    [ "Pisgah Substation",[-85.8236800827569, 34.670404483510175]],
    [ "Rainsville Substation",[-85.85185390814421, 34.506148152233784]],
    [ "Dutton Substation",[-85.9156678248191, 34.62036894161331]],
    [ "Scottsboro Substation",[-86.0173657753906, 34.676395455358495]],
    [ "North Alabama Electric Cooperative",[-86.22476043138397, 34.47667149505759]],
    [ "1159032287",[-93.25893054999999, 40.494810900000004]],
    [ "1159032291",[-93.01022059999998, 40.47617985]],
    [ "1159032292",[-92.8564469578727, 40.477255340880795]],
    [ "1159051048",[-93.34737490022793, 40.19073953732535]],
    [ "1159051050",[-93.32891997507605, 40.20319595649749]],
    [ "Blooming Grove Substation",[-76.94468739787345, 39.795574565344445]],
    [ "1159107790",[-86.3843397362302, 34.478162888274184]],
    [ "Scottsboro Electric Power Board",[-86.07102248176469, 34.60908501091651]],
    [ "Union Grove Substation",[-86.43999923730877, 34.39631764496628]],
    [ "Ryan Creek Substation",[-86.8756580387129, 34.13427951681853]],
    [ "1159130965",[-86.84175932867878, 34.13560613415473]],
    [ "Cullman Electric Cooperative",[-86.83566000021597, 34.14735760080501]],
    [ "Bremen Substation",[-86.9658619, 33.99703355]],
    [ "1159157715",[-92.49431320405455, 39.955312353821924]],
    [ "1159157719",[-92.45288032476594, 39.75964010956843]],
    [ "1159157720",[-92.2677689, 39.757426949999996]],
    [ "1159183203",[-94.12324929533781, 40.1199117730528]],
    [ "1159183206",[-93.959214357012, 40.377133605105946]],
    [ "1159183208",[-93.93954767476097, 40.5584822941416]],
    [ "1159184540",[-94.35015899999999, 40.251043300000006]],
    [ "1159184541",[-94.38259814999999, 40.423698599999994]],
    [ "Helicon Substation",[-87.1393568383419, 34.12833990915354]],
    [ "Constellium",[-87.58639168414409, 34.75854012447147]],
    [ "Colbert Substation",[-87.85140089382782, 34.74339935814907]],
    [ "Constellium",[-87.59165657244499, 34.760841816411414]],
    [ "1159258531",[-94.62312505000001, 40.566538349999995]],
    [ "1159258795",[-93.56176765, 40.40370175]],
    [ "Oncor",[-97.383209463287, 32.35302949200642]],
    [ "1159268300",[-95.12568824999998, 40.6738894]],
    [ "1159268302",[-95.23997751781877, 40.646922793651484]],
    [ "1159268304",[-95.35431441007009, 40.62630872470182]],
    [ "1159278281",[-80.364520838592, 39.265170268993494]],
    [ "Carson Ice",[-121.4617862148145, 38.445405048270445]],
    [ "1159401217",[-84.5744775614532, 37.106197166611764]],
    [ "Ford City Substation",[-87.5302449040312, 34.778987028506975]],
    [ "Wheeler Substation",[-87.38351376421187, 34.79668151097279]],
    [ "1159465159",[-87.30813208774575, 34.73300513041777]],
    [ "Nucor Substation",[-87.08566175850996, 34.63600999826892]],
    [ "Indorama Ventures",[-87.05762360912084, 34.64307761304694]],
    [ "1159473918",[-83.42767300894386, 42.27346162977707]],
    [ "Mountain Home Substation",[-87.11292724419012, 34.607021606610616]],
    [ "Joe Wheeler EMC",[-87.05875411563298, 34.571178920141065]],
    [ "Laceys Spring Substation",[-86.60229313406522, 34.530043800779325]],
    [ "1159651763",[-95.45761782761089, 40.42401595664558]],
    [ "1159651764",[-95.34895786754528, 40.43716999609651]],
    [ "1159651766",[-95.11262465, 40.44470295]],
    [ "1159651768",[-95.03113102455747, 40.34820785797957]],
    [ "1159653456",[-83.40499162383828, 42.273607990294316]],
    [ "1159744919",[-87.02160662151586, 34.627846570199054]],
    [ "Lenox Substation",[-74.59939841788413, 39.49177378978176]],
    [ "1159797017",[-93.93625747515324, 40.378447756505075]],
    [ "MidAmerican Energy",[-93.85976876721088, 41.53426501090715]],
    [ "Florence Utilities",[-87.6381630427637, 34.836376212944245]],
    [ "1159919334",[-87.66785916029872, 34.88138872550457]],
    [ "St. Florian Substation",[-87.61283593860647, 34.88762758646373]],
    [ "Florence Utilities",[-87.54202810672464, 34.9303035474825]],
    [ "Green Hill Substation",[-87.52229826804526, 34.97171054553161]],
    [ "Florence Utilities",[-87.39718601822163, 34.96984197275988]],
    [ "Blackburn Substation",[-87.66948812518267, 34.93889879199528]],
    [ "Cloverdale Substation",[-87.77602818805238, 34.944806766168966]],
    [ "Florence Utilities",[-87.81498977519362, 34.902485058820716]],
    [ "1159994150",[-86.39046473879235, 40.76276592519026]],
    [ "Florida Power & Light",[-81.79943423723022, 26.30252212512901]],
    [ "1160037507",[-87.66782412234492, 34.79529889420569]],
    [ "1160037508",[-87.66917979999998, 34.79513405]],
    [ "1160037509",[-87.66876992920378, 34.79450708477118]],
    [ "Florence Utilities",[-87.68007268191164, 34.79760114063822]],
    [ "Florence Utilities",[-87.67883236452165, 34.799289864970575]],
    [ "Florence Utilities",[-87.70102910000001, 34.8263989]],
    [ "Florence Utilities",[-87.78973454999999, 34.85907935]],
    [ "Florence Utilities",[-87.70097926212607, 34.78446196687728]],
    [ "Florence Utilities",[-87.66640326960827, 34.81810042487343]],
    [ "1160037533",[-87.6690262, 34.824648]],
    [ "1160037536",[-87.66766985, 34.82461635]],
    [ "1160037538",[-87.66750575000002, 34.82723065000001]],
    [ "Florence Utilities",[-87.66695669693468, 34.80089603585335]],
    [ "East Florence Substation",[-87.64536721791937, 34.810629094496214]],
    [ "Eastwood Substation",[-87.62744995, 34.822305549999996]],
    [ "Tennessee Valley Authority",[-87.62732936165412, 34.790619588529786]],
    [ "Florence Utilities",[-87.5834370200713, 34.84516249706271]],
    [ "Florida Power & Light",[-82.25237677460267, 27.59327243913165]],
    [ "1160065730",[-87.37793785979339, 41.602249157621294]],
    [ "1160079384",[-92.34395222464973, 40.00747885947649]],
    [ "1160080081",[-95.92664933382075, 40.175330570455955]],
    [ "1160122928",[-87.62703127543071, 34.787959534602635]],
    [ "1160122931",[-87.62760496648971, 34.785942758184625]],
    [ "1160122934",[-87.67022644761609, 34.7602589493492]],
    [ "1160122935",[-87.67181555763021, 34.76041317876847]],
    [ "Muscle Shoals Electric Board",[-87.67860065115468, 34.731449963082234]],
    [ "City of Sheffield",[-87.74889908438135, 34.70707305982034]],
    [ "Vulcan Materials Company",[-87.80804412047935, 34.72262175934918]],
    [ "Magnum Substation",[-88.07706081826413, 34.766572485394654]],
    [ "1160122980",[-88.17216523491265, 34.81425646358287]],
    [ "1160122984",[-87.63377702472744, 34.76435595827764]],
    [ "1160122985",[-87.63272155748611, 34.71454102436106]],
    [ "1160122986",[-87.6326544, 34.71427284999999]],
    [ "Littleville Substation",[-87.63832478471213, 34.582895524819186]],
    [ "Leighton Substation",[-87.52852384479108, 34.70941349604821]],
    [ "1160172508",[-87.26093446206316, 34.62009451724876]],
    [ "1160172511",[-87.62390963067968, 34.788392124680506]],
    [ "Russellville Substation",[-87.73604895109692, 34.49504919411777]],
    [ "Russellville Electric Board",[-87.68407743437662, 34.46803358247713]],
    [ "Walnut Gate Road Substation",[-87.73332264999999, 34.476283800000004]],
    [ "Belgreen Substation",[-87.90795523469532, 34.483032683917315]],
    [ "1160172558",[-88.4834755075062, 33.966525699949145]],
    [ "3M Substation",[-87.04287162469566, 34.641784452112184]],
    [ "Nichols Aluminium Substation",[-87.0164115942948, 34.61802847433281]],
    [ "Decatur Utilities",[-86.99635406774115, 34.621527194241324]],
    [ "Bunge Substation",[-86.96590895000001, 34.60407155]],
    [ "Decatur Utilities",[-86.96062936672969, 34.6035114487154]],
    [ "Decatur Utilities",[-87.00122828743484, 34.60562072496971]],
    [ "Decatur Utilities",[-86.97466682461574, 34.60544425649447]],
    [ "1160197787",[-86.96161397466174, 34.600026855464236]],
    [ "Air Products & Chemicals, Inc.",[-87.0385828169659, 34.608424925627645]],
    [ "Air Products & Chemicals, Inc.",[-87.03869076271316, 34.60883901922413]],
    [ "Wayne Farms, LLC",[-87.04180443718982, 34.606160325063556]],
    [ "Decatur Utilities",[-87.0215125, 34.58955385]],
    [ "1160197803",[-86.9616277, 34.59910134999999]],
    [ "1160197804",[-86.96180294999998, 34.59706714999999]],
    [ "1160197810",[-86.95442384999998, 34.594484800000004]],
    [ "1160197812",[-86.94512333913964, 34.59430057338332]],
    [ "Decatur Utilities",[-86.99989527555259, 34.57633333678564]],
    [ "Decatur Utilities",[-86.92841565437989, 34.55778205797099]],
    [ "Decatur Utilities",[-87.01796693554655, 34.5793141722027]],
    [ "Decatur Utilities",[-86.9823341332458, 34.527282453450965]],
    [ "1160200466",[-83.29196332261496, 42.10248715640896]],
    [ "1160224096",[-87.04458024999998, 34.6301417]],
    [ "1160224097",[-87.04078134999999, 34.635341049999994]],
    [ "1160224098",[-87.07662412801287, 34.62625474864077]],
    [ "1160224100",[-87.07732186480852, 34.63944083026202]],
    [ "Mazda Toyota Manufacturing, U.S.A., Inc.",[-86.845239459564, 34.68745903989904]],
    [ "Huntsville Utilities",[-86.55135672264356, 34.60153734701893]],
    [ "Colfax Station",[-86.24657486676486, 41.678166747854185]],
    [ "Huntsville Utilities",[-86.73470374060562, 34.66955652498484]],
    [ "1160427541",[-94.72803655000001, 39.99548985]],
    [ "1160438112",[-86.78597056429582, 34.66120222538946]],
    [ "Huntsville Utilities",[-86.7516612189175, 34.566863486082106]],
    [ "1160438139",[-86.7444871249771, 34.664298192696975]],
    [ "Hazel Green Substation",[-86.57207522471121, 34.903028339646255]],
    [ "New Market Substation",[-86.43299816244627, 34.909070543113394]],
    [ "American Electric Power",[-86.27263055, 41.69376675]],
    [ "American Electric Power",[-86.27218914348506, 41.69427159288686]],
    [ "Lick Creek Substation",[-82.99380076691406, 36.19182694836175]],
    [ "1160571759",[-86.9234459, 38.7745936]],
    [ "1160587890",[-95.75342432480096, 40.689269945819134]],
    [ "1160587891",[-95.61510330544237, 40.74338709268437]],
    [ "1160588144",[-95.19147843419022, 40.07965105532107]],
    [ "Evergy",[-95.14514946944495, 40.12967970004481]],
    [ "1160595716",[-75.60353549841908, 41.43552634873256]],
    [ "Huntsville Utilities",[-86.66068494071507, 34.736846624378856]],
    [ "Huntsville Utilities",[-86.65742810000002, 34.71915695]],
    [ "Huntsville Utilities",[-86.63561128573215, 34.73242912504999]],
    [ "Huntsville Utilities",[-86.61361371198942, 34.735695287387934]],
    [ "Huntsville Utilities",[-86.64449383485122, 34.75711863211132]],
    [ "Vulcan Materials Company",[-86.62941877882785, 34.779902144535306]],
    [ "Pulsaki Pike Substation",[-86.61767594431025, 34.79821268331288]],
    [ "1160604327",[-86.53831019999998, 34.7775461]],
    [ "Huntsville Utilities",[-86.70666101954077, 34.699900841444304]],
    [ "Huntsville Utilities",[-86.69940193136637, 34.70035605278073]],
    [ "10th Street Substation",[-86.61325586865532, 34.71352047430595]],
    [ "1160609824",[-117.40495022344044, 33.93183670510256]],
    [ "Vaughn Substation",[-75.57838615821684, 39.05292741356579]],
    [ "1160626051",[-86.69796172417098, 34.73236495509394]],
    [ "Huntsville Utilities",[-86.60717376087315, 34.714088969744104]],
    [ "Wheeler Substation",[-86.595029072701, 34.73883725451734]],
    [ "Huntsville Utilities",[-86.57152724103399, 34.73480907464089]],
    [ "Huntsville Utilities",[-86.57181772111069, 34.78754053275867]],
    [ "Huntsville Utilities",[-86.48983796619757, 34.70200478283338]],
    [ "1160655964",[-86.57264976130712, 34.66440078264363]],
    [ "Huntsville Utilities",[-86.56821907495028, 34.63946505369314]],
    [ "Huntsville Utilities",[-86.56536886065636, 34.58508672454686]],
    [ "Sanmina-Sci Corp.",[-86.56654884315158, 34.59399237449994]],
    [ "1160656021",[-86.55588854999999, 34.5937565]],
    [ "Norris Cylinder Company",[-86.55294407427635, 34.59775220618251]],
    [ "Linde, Inc.",[-86.54372889999998, 34.57408949999999]],
    [ "Huntsville Utilities",[-86.55430236825909, 34.56880207086275]],
    [ "Saint-Gobain",[-86.53181863613193, 34.5562239314971]],
    [ "Huntsville Utilities",[-86.45962365273049, 34.59408157613236]],
    [ "New Hope Substation",[-86.39813264855404, 34.53513923332608]],
    [ "1160664646",[-93.21479499279219, 39.05776067486674]],
    [ "Transcontinental Gas Pipeline Company",[-88.4967337304504, 30.383723472514358]],
    [ "1160693455",[-88.48249629810277, 30.345544157678606]],
    [ "1160720469",[-86.2970297006569, 41.68347986192381]],
    [ "Huntsville Utilities",[-86.45860922969464, 34.75210739898431]],
    [ "Hayes Substation",[-82.96504322461931, 42.43412164162197]],
    [ "Washington-St. Tammany Electric Cooperative",[-89.8303055834379, 30.93770725113467]],
    [ "1160767035",[-89.96062158030759, 30.960294438021034]],
    [ "1160767036",[-90.0967280395925, 30.94728388343149]],
    [ "Washington-St. Tammany Electric Cooperative",[-90.11134886260295, 30.91002962445016]],
    [ "1160784582",[-87.31774409076516, 39.36106336351173]],
    [ "1160784846",[-87.33392570000001, 39.33165995]],
    [ "Green Village Substation",[-74.43665685623566, 40.73898946589286]],
    [ "Jersey Central Power and Light",[-74.35380092765753, 40.77972613022269]],
    [ "Jersey Central Power and Light",[-74.41966663391723, 40.762654679001486]],
    [ "Madison Substation",[-74.41099359536408, 40.754203287001175]],
    [ "1160793355",[-87.13251402197388, 39.52307223474092]],
    [ "1160793972",[-87.17698337487357, 39.51991560511815]],
    [ "Huntsville Utilities",[-86.62832775, 34.690714650000004]],
    [ "Huntsville Utilities",[-86.67484477444827, 34.64455191027573]],
    [ "Livingston Switch Point",[-74.35387395323305, 40.75967339510701]],
    [ "Flash Substation",[-86.63019865028792, 34.83771566480707]],
    [ "PPG Industries Inc",[-86.53127361302978, 34.776394925279625]],
    [ "1160814460",[-86.53223, 34.779674433333334]],
    [ "Deposit Substation",[-86.45464200790525, 34.844647582214684]],
    [ "Gurley Substation",[-86.37693234346168, 34.707448449023275]],
    [ "WestRock",[-85.7895535451753, 34.8651261745637]],
    [ "1160850858",[-110.72048638311139, 41.31653799358098]],
    [ "Google LLC",[-85.74733528871356, 34.915213574969194]],
    [ "Tennessee Alloys Corporation",[-85.701596, 34.94302675]],
    [ "Oden Ridge Substation",[-86.76140971997523, 34.377851173794944]],
    [ "Joe Wheeler EMC",[-86.91542862533359, 34.4175261417001]],
    [ "Danville Substation",[-87.09221581968923, 34.41341524632919]],
    [ "Falkville Substation",[-86.91278325808831, 34.37426895556284]],
    [ "1160881742",[-88.4970959999258, 33.45457093016929]],
    [ "Robinson Substation",[-87.0751278255813, 34.88706734161844]],
    [ "Five Points Substation",[-87.30798407918167, 35.03654454558817]],
    [ "Lexington Substation",[-87.37858586024711, 34.970256533570534]],
    [ "1160930451",[-87.93804694885272, 34.80338534643511]],
    [ "Texas Eastern Transmission, LP",[-87.9122753425926, 34.64919920889164]],
    [ "Red Bay Substation",[-88.10087140644224, 34.44985258552192]],
    [ "Franklin Electric Cooperative",[-88.22252929575177, 34.61630419407918]],
    [ "King George Substation",[-74.52895893631154, 40.65394936312545]],
    [ "Jersey Central Power and Light",[-74.632781899684, 40.62171570888277]],
    [ "Mountain Substation",[-74.5218262, 40.6460167]],
    [ "Dead River Substation",[-74.57024747621091, 40.64971819767015]],
    [ "1160961868",[-117.41559632249408, 33.99926393007366]],
    [ "1160978755",[-110.7806245, 33.005547500000006]],
    [ "1160978756",[-110.78057536542795, 33.00574563535112]],
    [ "1160978763",[-110.71527424999998, 32.88321965]],
    [ "Saddlebrooke Ranch Substation",[-110.94933783712519, 32.60576695043668]],
    [ "1160978811",[-110.75657573480972, 32.61613738200068]],
    [ "1161007139",[-111.3086858, 32.506227700000004]],
    [ "1161013481",[-87.60589562779938, 34.25748011894875]],
    [ "Bear Creek Substation",[-87.6967943, 34.28304935]],
    [ "Ashridge Substation",[-87.46041318585195, 34.228391535355]],
    [ "Double Springs Substation",[-87.41023197344754, 34.14017730886659]],
    [ "1161013494",[-87.62238924999998, 34.1901304]],
    [ "1161013497",[-87.73389086350936, 34.12107791598862]],
    [ "1161013499",[-87.74268343264336, 34.01422405192833]],
    [ "1161013501",[-87.76727514023487, 33.96468757592393]],
    [ "1161013503",[-87.77075586030435, 33.932095127045734]],
    [ "Carbon Hill Substation",[-87.53710195000001, 33.8967892]],
    [ "Carbon Hill Mine Substation",[-87.52601109999999, 33.873992750000006]],
    [ "Nauvoo Substation",[-87.44479645677684, 33.96637326288591]],
    [ "Nauvoo Substation",[-87.47445234999999, 33.9843255]],
    [ "1161024802",[-87.41841672577893, 33.842875964227005]],
    [ "Lynn Substation",[-87.55296425, 34.05302625]],
    [ "1161024809",[-87.39193116486683, 34.06791916823239]],
    [ "Prospect Substation",[-87.39446475956157, 33.92547227519387]],
    [ "1161052508",[-87.07422360000001, 33.81941394999999]],
    [ "Skyline Substation",[-86.92455864256716, 33.82534297960103]],
    [ "1161052513",[-86.8142463751783, 33.882434594644785]],
    [ "Hayden Substation",[-86.7608908, 33.8884813]],
    [ "1161052517",[-86.82402882430908, 33.81955675262586]],
    [ "1161052519",[-86.8202746143135, 33.63801952419063]],
    [ "Sumiton Substation",[-87.06145354329732, 33.75839699055576]],
    [ "1161065721",[-87.2396314859489, 33.87597813136098]],
    [ "Farmstead Substation",[-87.2868508246638, 33.88737361038404]],
    [ "1161065729",[-87.25880188714214, 33.845404422614195]],
    [ "1161065732",[-87.25454700826106, 33.81531592507229]],
    [ "Mar-Jac Poultry AL, LLC",[-87.276034639971, 33.81878117483152]],
    [ "Jasper Substation",[-87.3002805301064, 33.824422408440086]],
    [ "1161065749",[-87.2656614181466, 33.73652944641153]],
    [ "North Cordova Substation",[-87.18371586684887, 33.81682167471369]],
    [ "1161065756",[-87.13454488386611, 33.816334532891325]],
    [ "1161098513",[-83.18738799726088, 42.122033945569015]],
    [ "1161152759",[-87.21529461268462, 33.65539561449269]],
    [ "Parrish Substation",[-87.29373110112797, 33.722301434925996]],
    [ "Oakman Substation",[-87.38949817810577, 33.72235120826834]],
    [ "1161152771",[-87.28624385, 33.6591639]],
    [ "1161152779",[-87.82461816352756, 33.682687380303776]],
    [ "1161152781",[-87.69504706975063, 33.460335792273]],
    [ "1161152783",[-87.70370859447839, 33.38813328277767]],
    [ "1161222396",[-84.61270972577485, 36.96591641122153]],
    [ "Highmore Substation",[-99.42088137514536, 44.528218091662936]],
    [ "Miller Substation",[-99.00328821721024, 44.53755017492618]],
    [ "1161227628",[-98.98434538571844, 44.53211182495095]],
    [ "1161227632",[-98.98046207980089, 44.51639884967908]],
    [ "East River Electric Power Cooperative",[-98.60070987507811, 44.54639084206815]],
    [ "1161246628",[-117.39246763396372, 34.00573298735085]],
    [ "Tampa Electric Company",[-82.28077090684171, 27.733114431302496]],
    [ "1161390365",[-82.03963232532232, 27.926679859580517]],
    [ "Caldwell Susbstation",[-74.2769889842165, 40.836536616866326]],
    [ "Front Street Substation",[-74.40470103026847, 40.64328248040515]],
    [ "Winfield Substation",[-87.81614227742097, 33.92396213814596]],
    [ "1161398739",[-87.82007655, 33.92435570000001]],
    [ "1161398742",[-87.9165945, 33.9599716]],
    [ "1161398744",[-88.02530004926338, 33.92846113334439]],
    [ "Hyster-Yale Group, Inc.",[-88.10488316074854, 33.915473129587895]],
    [ "Sulligent Substation",[-88.12819017407188, 33.89014563915802]],
    [ "1161398759",[-88.16532625000004, 34.03096599999999]],
    [ "Vernon Substation",[-88.10683321022924, 33.75663322460508]],
    [ "1161398763",[-88.03503955, 33.7736639]],
    [ "Belk Substation",[-87.93059372512815, 33.65238374216462]],
    [ "1161398768",[-88.10663377051073, 33.6485817230511]],
    [ "1161398769",[-87.91171424999999, 33.9677367]],
    [ "Hamilton Substation",[-87.98974136184474, 34.13192552384721]],
    [ "1161398774",[-88.04366543244048, 34.12341715083063]],
    [ "1161398776",[-87.89907305360013, 33.96523257350097]],
    [ "NTN-Bower Corporation",[-87.99210847458315, 34.11454219602216]],
    [ "1161443876",[-88.00507806656373, 34.15448948323305]],
    [ "North Hamilton Substation",[-87.95408950000001, 34.17659715]],
    [ "Hodges Substation",[-87.90960930661527, 34.3090553612125]],
    [ "Vina Substation",[-88.07279186890317, 34.37569040393421]],
    [ "Hackleburg Substation",[-87.82217644999999, 34.282117549999995]],
    [ "1161456917",[-85.82825519843423, 33.60100541743652]],
    [ "South Middleburg Substation",[-77.04130616583048, 40.782290908344045]],
    [ "Appalachian Power Company",[-79.35231485000001, 37.13288695]],
    [ "1161524086",[-79.352908867475, 37.132208936555244]],
    [ "Station 109",[-77.47269394350806, 43.18272072682916]],
    [ "Mud Lake Substation",[-85.061914158128, 42.33791141034954]],
    [ "Invenergy",[-85.06172833548081, 42.338885270346424]],
    [ "1161569241",[-95.66386304765909, 29.192044544081618]],
    [ "1161569242",[-95.66394872765125, 29.190760407630332]],
    [ "Bear Creek Solar",[-90.23153734720306, 43.19937388789979]],
    [ "Adamsville Substation",[-86.95581665, 33.601873250000004]],
    [ "Graysville Substation",[-86.95689058850269, 33.62818862392937]],
    [ "1161801800",[-86.99548226301808, 33.61742887953437]],
    [ "1161841834",[-88.61555461672495, 31.137539146822835]],
    [ "Waynesboro Substation",[-88.66108248027945, 31.677141679422533]],
    [ "1161942269",[-103.79691640180526, 32.65210799978986]],
    [ "Williams Substation",[-74.67953739478206, 40.13928579264224]],
    [ "1161944281",[-88.87228598970613, 31.692982825194644]],
    [ "1161944286",[-88.761325, 31.74019365]],
    [ "Denbury Onshore LLC",[-88.84304117497852, 31.7633457433468]],
    [ "MidAmerican Energy",[-95.21009982514389, 42.650795745685826]],
    [ "1162251079",[-83.65412010457985, 42.46165447362423]],
    [ "1162263411",[-85.00087723304067, 32.5550808474144]],
    [ "White Lake Substation",[-83.54962246176584, 42.69146450709313]],
    [ "Teggerdine Substation",[-83.49378544607676, 42.65131163097866]],
    [ "South Street Substation",[-71.40654411669509, 41.81908250811901]],
    [ "Morristown Substation",[-74.46864721543737, 40.80077625223662]],
    [ "Stoneybrook Substation",[-74.42580670706235, 40.833516682591565]],
    [ "Jersey Central Power and Light",[-74.44237646016467, 40.82138701548464]],
    [ "Okner Substation",[-74.35344556947886, 40.80323353122667]],
    [ "Enbridge Energy Substation",[-83.3879243312541, 42.81245044151688]],
    [ "1162670263",[-83.31767096000615, 42.783614547583056]],
    [ "Mount Pleasant Substation",[-74.37008641950166, 40.80544258336973]],
    [ "Florida Power & Light",[-87.33732458779174, 30.918366980324244]],
    [ "1162792934",[-93.11695129448292, 40.20536364939667]],
    [ "1162793497",[-92.1343353167128, 40.26354072502635]],
    [ "1162794463",[-96.46981772292543, 31.897199695711887]],
    [ "1162834448",[-83.90004160774463, 30.149824171943195]],
    [ "Florida Power & Light",[-80.70449322645612, 28.128981014186934]],
    [ "1162861255",[-92.04246650831271, 39.80183552057909]],
    [ "1162878332",[-95.73752839055942, 29.39687540756559]],
    [ "1162884097",[-103.84029096702031, 32.82197549156354]],
    [ "East Sevierville Substation",[-83.54155127791265, 35.86298894502637]],
    [ "Van Hiseville Substation",[-74.33721519808397, 40.10732299623653]],
    [ "New Jersey Transit",[-74.14219049628096, 40.40491880969744]],
    [ "1162904230",[-114.60305834006644, 42.18582718471527]],
    [ "Cheesequake Substation",[-74.30403571506163, 40.43527809979621]],
    [ "Jersey Central Power and Light",[-74.70614497221564, 40.56708802600574]],
    [ "North Bridge Street Substation",[-74.6089639204825, 40.58208785209634]],
    [ "1162950539",[-84.84677554961382, 38.26711012169757]],
    [ "1162960761",[-111.42455909073637, 32.75616719845937]],
    [ "Tewksbury Substation",[-74.77060121435038, 40.71331168784307]],
    [ "Jersey Central Power and Light",[-74.8458919734129, 40.51467336412925]],
    [ "Three Rivers Substation",[-88.55414453113339, 30.58391324688651]],
    [ "Wade Substation",[-88.55916296796254, 30.642810610098227]],
    [ "Big Point Substation",[-88.48641808445592, 30.579463382367003]],
    [ "Forts Lake Substation",[-88.41681235, 30.4933524]],
    [ "Escatawpa Substation",[-88.52222280000001, 30.456207899999995]],
    [ "Helena Substation",[-88.53514779914941, 30.500292667231147]],
    [ "Vancleave Substation",[-88.68597754999999, 30.534397300000002]],
    [ "Orchard Road Substation",[-88.51007941587179, 30.366627545962878]],
    [ "Monaco Lake Substation",[-88.50445122305001, 30.380647232045668]],
    [ "Kreole Substation",[-88.51380696972276, 30.390177264522855]],
    [ "Bayou Cassotte Substation",[-88.52400681448871, 30.36433076924929]],
    [ "1162972929",[-88.5786325749276, 30.35058254460438]],
    [ "Singing River Electric Cooperative",[-88.6159432893454, 30.38599397949581]],
    [ "Singing River Electric Cooperative",[-88.65881796727734, 30.39851919834889]],
    [ "Singing River Electric Cooperative",[-88.72320277919616, 30.383346964647505]],
    [ "Singing River Electric Cooperative",[-88.71179743844276, 30.42423098714417]],
    [ "Martin Bluff Substation",[-88.6399063503202, 30.448273218402882]],
    [ "1163004971",[-88.65053924239835, 30.424904828964728]],
    [ "Singing River Electric Cooperative",[-88.79848081632313, 30.44237691698077]],
    [ "Singing River Electric Cooperative",[-88.846804075329, 30.46380150521941]],
    [ "Sunkist Substation",[-88.95136026786253, 30.435909623798143]],
    [ "Coast Electric Power Association",[-88.93275978553191, 30.43860058585511]],
    [ "29th Street Substation",[-89.09610463436753, 30.37189881755471]],
    [ "Gay Road Substation",[-88.91202448336189, 30.45431411669388]],
    [ "South River Electric Membership Corporation",[-78.58762292931726, 35.043277300811916]],
    [ "Virginia Electric and Power Company",[-79.02837296705954, 36.554654716350186]],
    [ "Dedeaux Road Substation",[-89.06574411219702, 30.450004381156486]],
    [ "Coast Electric Power Association",[-89.1982063300258, 30.344813243222347]],
    [ "Mississippi Power",[-89.2167334113432, 30.33987465685094]],
    [ "Mississippi Power",[-89.39466837004753, 30.411679782200437]],
    [ "1163043561",[-89.36527115686239, 30.402785006672605]],
    [ "Canal Road Substation",[-89.13630146254471, 30.438777074989698]],
    [ "Coast Electric Power Association",[-89.18721040000001, 30.428713]],
    [ "Watts Substation",[-89.2320735833936, 30.460098402445333]],
    [ "Vidalia Substation",[-89.33732527995073, 30.49490212602017]],
    [ "Joppa Substation",[-85.21823389999999, 42.23395445]],
    [ "Waveland Substation",[-89.40498628792847, 30.304736539113154]],
    [ "Turner Street Substation",[-89.36432781895894, 30.306644268941394]],
    [ "DAK Americas Substation",[-89.55550496662745, 30.22568351682553]],
    [ "Wood County Solar",[-89.83143079254218, 44.277573080894]],
    [ "Springfield Road Substation",[-74.30062949199349, 40.69594601071276]],
    [ "Stanley Terrace Substation",[-74.26654910903794, 40.71271988583813]],
    [ "Laurel Substation",[-119.47531623915079, 36.23973642247834]],
    [ "Coast Electric Power Association",[-89.74697493906366, 30.573856247996684]],
    [ "Picayune North Substation",[-89.66786046269553, 30.547691670832247]],
    [ "Coast Electric Power Association",[-89.66772877052567, 30.54821999623418]],
    [ "Rocky Hill Substation",[-89.43655345018915, 30.46354475469144]],
    [ "Necaise Substation",[-89.41230097058325, 30.59347134341786]],
    [ "Coast Electric Power Association",[-89.55394883561976, 30.61355138146967]],
    [ "Carriere Substation",[-89.66165989156974, 30.622831896434036]],
    [ "McNeill Substation",[-89.65940875972466, 30.665164210208626]],
    [ "Derby Substation",[-89.58706306317826, 30.75586936905792]],
    [ "Poplarville Substation",[-89.52738921502959, 30.838066146889833]],
    [ "Collector Substation",[-72.51014415391732, 41.9778618965662]],
    [ "1163630707",[-82.82044509241739, 42.81029777545025]],
    [ "Pearl River Valley Electric Power Association",[-89.45859372488557, 30.96233804170126]],
    [ "Lumberton Substation",[-89.43814386491245, 31.00117922836545]],
    [ "Perkinston Silver Run Road Substation",[-89.15585494999999, 30.761307400000003]],
    [ "Saucier Substation",[-89.15579332533504, 30.620530551179463]],
    [ "1163642627",[-89.15476155, 30.591233300000003]],
    [ "Lizman Substation",[-89.16973227491161, 30.515829042744496]],
    [ "Lyman Substation",[-89.13910491334862, 30.505627757993004]],
    [ "1163659816",[-74.13901724189701, 41.52952902628644]],
    [ "Camp Shelby Substation",[-89.2115117304481, 31.20447123415327]],
    [ "1163665538",[-89.59685195127594, 31.081118566190646]],
    [ "Mississippi Power",[-89.40666185101823, 31.144784835549213]],
    [ "CII Carbon LLC",[-89.3847517738447, 31.181532856709683]],
    [ "TransMontaigne Operating Company L.P.",[-89.40215595000001, 31.190123999999994]],
    [ "Saxon Substation",[-89.8354436546481, 31.125588997437674]],
    [ "Oak Grove Substation",[-89.41518063869839, 31.270836229653437]],
    [ "Consumers Energy",[-85.55335908209945, 42.862624202958266]],
    [ "Sussex/Clark Road Substation",[-74.59557186707366, 41.18773126234407]],
    [ "Hamburg Substation",[-74.57881305519821, 41.153390449765226]],
    [ "Sussex Substation",[-74.6071399771552, 41.203234792239165]],
    [ "Woodruffs Gap Substation",[-74.6539794177384, 41.07758603450342]],
    [ "Branchville Substation",[-74.76389956002573, 41.15093423240441]],
    [ "Jersey Central Power and Light",[-74.78308864033015, 41.299391058771135]],
    [ "1163784631",[-117.45743447007195, 34.00502657060059]],
    [ "1163794668",[-88.64782419052372, 30.778926645059475]],
    [ "1163794669",[-88.64787207500258, 30.779178255248734]],
    [ "Cooperative Energy",[-88.45029122537838, 30.735399074392255]],
    [ "Singing River Electric Cooperative",[-88.60655234999999, 30.928321699999994]],
    [ "Hurdtown Substation",[-74.60025784984266, 40.97347911083907]],
    [ "Sparta Substation",[-74.62648916809216, 41.046375850891245]],
    [ "Brewer Substation",[-88.86246707498078, 31.367882905339812]],
    [ "Dixie Electric Power Association",[-88.67972294097709, 31.5914647814205]],
    [ "Cooperative Energy",[-89.44838320907978, 31.330323027422416]],
    [ "Leaf River Cellulose, LLC",[-89.04690165087275, 31.244722001052278]],
    [ "1163836448",[-89.04058827436266, 31.237443035115156]],
    [ "Plantation Pipe Substation",[-88.8078399, 31.149886299999995]],
    [ "Hintonville Substation",[-88.92125801049617, 31.268000910849857]],
    [ "Dixie Electric Power Association",[-89.25444013122798, 31.376418123444537]],
    [ "Chesterfield Substation",[-82.83786207469497, 42.6705718394853]],
    [ "1163918408",[-89.5183339171264, 31.643432216665015]],
    [ "1163918409",[-89.51686727509872, 31.64112860318707]],
    [ "1163918410",[-89.52032176077769, 31.63519974380778]],
    [ "28th Street Substation",[-89.33169967501637, 31.309670991644055]],
    [ "Dixie Pipeline Company",[-89.26848735, 31.37609024999999]],
    [ "1163918432",[-89.6463171624176, 31.41701333027602]],
    [ "Bassfield Substation",[-89.74027099999999, 31.494867899999996]],
    [ "Needles Substation",[-114.6184591933859, 34.843626772925056]],
    [ "Water Street Substation",[-72.92135645065402, 41.301695494809785]],
    [ "Union Avenue Substation",[-72.92438770407284, 41.300009553061805]],
    [ "1164031651",[-84.96495592118869, 38.17897458207698]],
    [ "Mohawk Substation",[-74.68957189811876, 41.00192066217879]],
    [ "Jersey Central Power and Light",[-74.67785070533647, 40.92619370182235]],
    [ "Hopatcong Substation",[-74.66208199532238, 40.93418389772329]],
    [ "Jersey Central Power and Light",[-74.71288480442331, 40.89302870702493]],
    [ "1164060947",[-111.18783385239323, 32.36182626594104]],
    [ "1164060967",[-111.15040633669544, 32.41141043338725]],
    [ "1164060968",[-111.14940346844462, 32.409055294603135]],
    [ "1164061006",[-111.49868695, 32.388667350000006]],
    [ "NRG-TAP Substation",[-111.28672725, 32.392930050000004]],
    [ "1164203085",[-109.34624039489661, 47.07052838124501]],
    [ "Singing River Electric Cooperative",[-88.74460875069504, 30.638747539303242]],
    [ "Mississippi Power",[-88.74450994463204, 30.639229743525426]],
    [ "Singing River Electric Cooperative",[-88.79614619375931, 30.546108304405543]],
    [ "SG Resources Mississippi LLC",[-88.70276000954975, 31.22521372499826]],
    [ "Middle River Road Substation",[-73.4890110433442, 41.403929380280125]],
    [ "Park Road Substation",[-80.84944521838658, 35.15185548156098]],
    [ "1164332325",[-117.59276375207729, 34.08426290861885]],
    [ "Vernon SREC Substation",[-74.48590136871165, 41.19029399347597]],
    [ "Sussex Rural Electric Cooperative",[-74.45125725146522, 41.18689420855111]],
    [ "Cooperative Energy",[-89.91915562123042, 31.398254805870383]],
    [ "Plantation Pipe Line Company",[-89.91944548108496, 31.398087981254054]],
    [ "Mississippi Hub Substation",[-89.76380228580364, 31.781617918478172]],
    [ "Entergy Mississippi",[-90.03987165, 31.037027149999997]],
    [ "1164464906",[-90.26327964555651, 31.224470067498213]],
    [ "Magnolia Electric Power",[-90.2796039323404, 31.206137746088704]],
    [ "Jayess Substation",[-90.24354656340502, 31.349644288006385]],
    [ "Magnolia Electric Power",[-90.37181160147627, 31.26620681724307]],
    [ "McComb Substation",[-90.42784839159809, 31.2601958726372]],
    [ "Glasdon Substation",[-89.07722403141739, 31.658782113333977]],
    [ "1164505692",[-89.34816609295183, 31.54254222462084]],
    [ "1164505695",[-89.53854951859367, 31.616425352195954]],
    [ "CPC Collins Substation",[-89.50591872545832, 31.654359636856476]],
    [ "1164505707",[-89.77824804343818, 31.429807414821997]],
    [ "1164565909",[-94.43451486331553, 41.877289930916284]],
    [ "1164576046",[-92.02114815, 40.4508741]],
    [ "1164576051",[-91.74813046685541, 40.420914866479414]],
    [ "1164619843",[-89.66574728127623, 31.868739164704134]],
    [ "Hebron Substation",[-89.37045485227262, 31.71128920602276]],
    [ "1164639557",[-91.77886815, 40.24058585]],
    [ "1164639559",[-92.17868393561068, 40.639517174532756]],
    [ "Heidelberg Denbury Substation",[-89.02525025659365, 31.866452655387643]],
    [ "Masonite Corporation",[-89.12971854365772, 31.6790867221563]],
    [ "1164654183",[-89.01784873055199, 31.91321709531921]],
    [ "College Park Substation",[-84.06316788574577, 41.88966616835755]],
    [ "1164674541",[-93.23132653670815, 42.72411778093153]],
    [ "1164690555",[-85.20733648394658, 41.118286731532685]],
    [ "Dixie Electric Power Association",[-88.63798684927752, 31.658827089117842]],
    [ "1164715175",[-118.26461581692065, 47.47730551660533]],
    [ "1164744362",[-74.27862420718675, 40.67548903559256]],
    [ "Doremus Place Substation",[-74.22293795157162, 40.69670451657164]],
    [ "Greenville Substation",[-74.09882088637467, 40.68759309122587]],
    [ "Metuchen High Tension Switching Station",[-74.346205522577, 40.548910214817354]],
    [ "1164748696",[-91.69962310026763, 39.9978066845616]],
    [ "1164748701",[-91.555514, 40.1231092]],
    [ "1164756686",[-89.36923742838069, 40.930456653386905]],
    [ "1164756694",[-89.49695001679234, 40.8019480611244]],
    [ "Western Area Power Administration",[-97.13539953298718, 43.71595788078052]],
    [ "1164775510",[-106.3225418513212, 43.39109800424021]],
    [ "Pinola Substation",[-89.97884634726216, 31.886216436936234]],
    [ "Cooperative Energy",[-89.75620912591359, 31.97125141966128]],
    [ "1164792846",[-89.75532163893536, 31.971675722780006]],
    [ "Jersey Central Power and Light",[-74.85835513804496, 40.91182054754281]],
    [ "Jersey Central Power and Light",[-74.83072592327521, 40.82329508477235]],
    [ "1164809199",[-89.12288395, 32.4645621]],
    [ "1164809200",[-89.12336705, 32.464586499999996]],
    [ "AEP Pettit Avenue",[-85.12812715, 41.038617249999994]],
    [ "1164869746",[-85.14858296178777, 40.9863681141891]],
    [ "1164887153",[-84.26547852473124, 37.60510566192255]],
    [ "1164902443",[-114.43026333392802, 35.82003918372246]],
    [ "1164902445",[-114.42797643200086, 35.81934292583583]],
    [ "1164902841",[-85.17108531562633, 41.07035073938626]],
    [ "Lounsberry SREC Substation",[-74.49465731099808, 41.23198613333333]],
    [ "1164911815",[-88.78656682730258, 32.337265236565244]],
    [ "1164911835",[-88.70933665000001, 31.862047450000006]],
    [ "1164911838",[-88.58768983647946, 31.949802868911497]],
    [ "Dixie Pipeline Company",[-88.5384800051311, 31.91819360270109]],
    [ "Tipton Substation",[-119.30436501550788, 36.051923179199754]],
    [ "Woodville Substation",[-119.17917108525535, 36.08055665716192]],
    [ "Elcans Substation",[-119.39208826936358, 36.34273776248829]],
    [ "Dairymans Substation",[-119.34104684999998, 36.204993449999996]],
    [ "Protein Substation",[-119.33416899999999, 36.18543174999999]],
    [ "Bliss Substation",[-119.20684757357704, 36.16695532506642]],
    [ "Lindsay Substation",[-119.09200930980424, 36.20426436144123]],
    [ "Strathmore Substation",[-119.0577646938787, 36.146020140257235]],
    [ "Lourich Substation",[-119.32925452810146, 36.13137030294947]],
    [ "Octol Substation",[-119.39447735411542, 36.12389500080322]],
    [ "1164967570",[-85.16973254999998, 41.07175384999999]],
    [ "Gregory Road Substation",[-84.72267822067786, 36.82549680415497]],
    [ "1165107168",[-85.4248320055305, 41.373691045680154]],
    [ "1165110405",[-85.42338647304685, 41.373784345770815]],
    [ "1165110729",[-85.5886432383463, 41.45061203364488]],
    [ "1165116021",[-85.0790486195194, 41.063024846351794]],
    [ "AEP Anthony Substation",[-85.11574706686787, 41.06978758515004]],
    [ "1165177561",[-85.08840256812772, 41.07490801554955]],
    [ "1165180162",[-85.1073597464214, 41.08222052371074]],
    [ "Mahoningside Substation",[-80.82894879337087, 41.24481756646511]],
    [ "1165440088",[-85.09538792514279, 41.19378919262881]],
    [ "1165441595",[-85.11259709493488, 41.21419708419682]],
    [ "1165449902",[-88.74587291113644, 32.3239063251956]],
    [ "Blue Ridge Energy",[-81.62049433092837, 36.43305426819975]],
    [ "1165497267",[-84.92165737163748, 41.182453441644874]],
    [ "1165511432",[-85.17863739017454, 40.99168857823622]],
    [ "L'Energia Substation",[-71.31193528387189, 42.631137373406624]],
    [ "1165663712",[-91.71209120781809, 39.656086100523275]],
    [ "1165663715",[-91.73249498709784, 39.652386078136324]],
    [ "1165663720",[-91.63570493228798, 39.44546251860621]],
    [ "AEP Woodland Substation",[-85.19127143880813, 41.177160591862744]],
    [ "AEP Carrol Substation",[-85.29343358937119, 41.18880624023506]],
    [ "Eel River Substation",[-85.2399114745726, 41.20618865424483]],
    [ "Tanner Substation",[-85.94406070701335, 43.11968949529625]],
    [ "Highway 80 East Substation",[-88.61691652712321, 32.394934056287426]],
    [ "Meyer Substation",[-85.83253796961814, 43.06622682173642]],
    [ "1165964349",[-85.1759897, 40.878645350000006]],
    [ "Jersey Central Power and Light",[-74.94320914242122, 40.631001656505134]],
    [ "Clinton Substation",[-74.89316109998047, 40.64058807716097]],
    [ "Lebanon Substation",[-74.83223238103078, 40.63664775116457]],
    [ "Exxon Substation",[-74.8645745926172, 40.64168457378433]],
    [ "Rio Grande Substation",[-74.8805746853578, 39.01706459926427]],
    [ "Swainton Substation",[-74.77940914781749, 39.12924695612207]],
    [ "Lake Avenue Substation",[-74.8208283365871, 38.99565481971321]],
    [ "Union Substation",[-74.94839254587048, 39.378037263736914]],
    [ "1166096135",[-89.30493653101584, 40.54382309674717]],
    [ "1166096142",[-89.39563706270216, 40.54630436925479]],
    [ "Glass",[-84.88125124999999, 39.82594174999999]],
    [ "1166198282",[-89.1224046256821, 32.439424075124656]],
    [ "1166198290",[-89.23900239805185, 32.34525318024593]],
    [ "1166198293",[-89.32917617463882, 32.35006225759908]],
    [ "1166198296",[-89.12422681945496, 32.5748259957217]],
    [ "Harperville Substation",[-89.49010358779014, 32.49205300518149]],
    [ "1166212358",[-89.71028704179894, 32.55961080110539]],
    [ "Wetzel Road Station",[-76.19039093716017, 43.15119949111458]],
    [ "South Millville Substation",[-75.02586748035394, 39.38924942815982]],
    [ "Monsanto Substation",[-75.39811230611483, 39.792547378927715]],
    [ "China Substation",[-74.8786165830132, 40.09337107804749]],
    [ "Lawrence SW Substation",[-74.75559066769978, 40.28110125578549]],
    [ "Tansboro Substation",[-74.93290855425816, 39.75297013033779]],
    [ "Terrace Substation",[-75.0597622113106, 39.77763577285321]],
    [ "B.L. England Generation",[-74.63614766620755, 39.28987752675269]],
    [ "Carlls Corner Peaking Station Substation",[-75.19979518511215, 39.454319201792714]],
    [ "Roadstown Substation",[-75.3227322481555, 39.45798681940834]],
    [ "High Street Substation",[-75.27803861735231, 39.73680945658968]],
    [ "Paulsboro Substation",[-75.25518426014087, 39.829324678789185]],
    [ "Valero Tap Substation",[-75.2950192964636, 39.82693804367687]],
    [ "Valero Substation",[-75.29287158058837, 39.83835234106296]],
    [ "Chambers Co Generation Substation",[-75.48476503798005, 39.6941898779456]],
    [ "1167103287",[-83.37868812560332, 43.82803872790833]],
    [ "1167109874",[-86.7862837, 41.413322449999995]],
    [ "East Hammond Substation",[-85.5303794239256, 44.71218615907415]],
    [ "1167192151",[-111.90394961609933, 39.8258042672526]],
    [ "1167228033",[-90.09989185686574, 32.16731041260087]],
    [ "1167228036",[-90.05949436487464, 32.12745613071679]],
    [ "1167228042",[-90.14003150311275, 32.053219074413086]],
    [ "Georgetown Substation",[-90.12172486018413, 31.877439255831856]],
    [ "1167228047",[-90.21150843923797, 32.23707107052416]],
    [ "1167243150",[-88.08565842511528, 38.78968301076359]],
    [ "1167297825",[-97.57429816785286, 30.412059804630083]],
    [ "1167299875",[-101.08093741922968, 31.161437736379238]],
    [ "Minotola Substation",[-74.94414136036508, 39.50271565324309]],
    [ "Lamb Substation",[-75.15437327196203, 39.72887097753797]],
    [ "Mantua Substation",[-75.17222118463071, 39.781368544763595]],
    [ "Rowan Substation",[-75.12253338124955, 39.706430525426526]],
    [ "Washington Substation",[-75.04670421781321, 39.72615204626137]],
    [ "Terry Substation",[-90.29990389999999, 32.103782949999996]],
    [ "Entergy Mississippi",[-90.36178028423174, 31.871721532509966]],
    [ "1167303062",[-90.4998633857833, 31.81475105345298]],
    [ "Algonac Substation",[-82.53904384403626, 42.618136356953265]],
    [ "1167399067",[-94.81225983870685, 31.58501404202536]],
    [ "1167419935",[-90.4981361079897, 31.606677669617934]],
    [ "Denbury Onshore, LLC",[-90.51751519999999, 31.59218515]],
    [ "1167419943",[-90.5896870392063, 31.643999273556744]],
    [ "Marathon Pipe Line LLC",[-90.59559807499909, 31.64847619281053]],
    [ "Roxie Substation",[-91.06903991651367, 31.49610854954911]],
    [ "Denbury Onshore, LLC",[-91.17428117332273, 31.55456786532179]],
    [ "1167419957",[-91.21631870113272, 31.559331233261556]],
    [ "1167419958",[-91.28651596891699, 31.592350626911415]],
    [ "South Brookhaven Substation",[-90.44833108918816, 31.551665225297402]],
    [ "1167419963",[-90.36747583216464, 31.50998298471342]],
    [ "Denbury Onshore, LLC",[-90.41253770952017, 31.494951420460648]],
    [ "1167419970",[-90.42825430000002, 31.39634765]],
    [ "Denbury Onshore, LLC",[-90.37174517476437, 31.34879128969027]],
    [ "West McComb Substation",[-90.47800226342362, 31.2543719684477]],
    [ "Denbury Onshore, LLC",[-90.54928361287391, 31.316550675366745]],
    [ "1167419980",[-90.5261508284128, 31.269674531461902]],
    [ "Milton Substation",[-76.83212519553682, 40.98111323214958]],
    [ "1167464447",[-102.03261397079727, 32.0030915933725]],
    [ "1167464448",[-102.03188884999999, 32.0033387]],
    [ "Magnolia Electric Power",[-90.42626297204845, 31.21828027348735]],
    [ "1167491097",[-90.44368786659507, 31.18154811576928]],
    [ "CPC McComb Substation",[-90.44675504717893, 31.12097588614335]],
    [ "Kentwood Substation",[-90.50375183595887, 30.93686183622932]],
    [ "Liberty Substation",[-90.77254392284667, 31.163645638083466]],
    [ "Genesis Pipeline USA, L.P.",[-90.77303816625222, 31.165796333210718]],
    [ "Plains Pipeline, L.P.",[-90.77604709494186, 31.164531062216835]],
    [ "Gloster Substation",[-91.01751026430242, 31.2201317505753]],
    [ "Entergy Mississippi",[-91.01910759630678, 31.220092349088745]],
    [ "Centreville Substation",[-91.08842351775192, 31.077453700194173]],
    [ "Woodville Substation",[-91.2802224157531, 31.12088155607457]],
    [ "1167502633",[-91.09236004054897, 31.28397382201761]],
    [ "1167502634",[-91.35979312137074, 31.480132090789827]],
    [ "West Water Valley Substation",[-89.65742927601919, 34.126343822509035]],
    [ "1167526395",[-82.48670036801467, 42.81593801098466]],
    [ "Slat Substation",[-84.89929998545578, 36.81927631721975]],
    [ "1167547862",[-82.44264327580512, 42.95979005775267]],
    [ "1167549805",[-91.40933516211417, 31.519971530528238]],
    [ "1167549806",[-91.41168252935539, 31.515672938378664]],
    [ "1167549808",[-91.41350023862489, 31.54874042444178]],
    [ "1167549809",[-91.36593694263028, 31.599458821361946]],
    [ "1167549838",[-91.0215438019351, 31.849396890651203]],
    [ "1167549841",[-91.12812466581316, 31.865701952350935]],
    [ "1167551474",[-90.36919244506323, 32.70552037844905]],
    [ "Flora Substation",[-90.29362247948355, 32.54512537149934]],
    [ "System Energy Resources, Inc",[-91.04751523318717, 32.006208642663374]],
    [ "Entergy Mississippi",[-90.7918654754844, 32.308856498086286]],
    [ "1167564434",[-90.8470881, 32.3331519]],
    [ "1167564445",[-90.73548608050686, 32.368510451739716]],
    [ "1167564446",[-90.67068197479442, 32.374064209372484]],
    [ "Wisner Substation",[-91.67732966044164, 31.969195880618553]],
    [ "1167579933",[-91.69773458787257, 32.038823075211134]],
    [ "Winnsboro Substation",[-91.69196501657133, 32.1689785502974]],
    [ "1167600946",[-82.45155352434831, 42.9783353917245]],
    [ "1167613873",[-82.43050575000002, 42.989556900000004]],
    [ "1167616114",[-82.44165982983996, 42.98743968005209]],
    [ "Elberon Substation",[-73.99937106358921, 40.263012139882385]],
    [ "West End Substation",[-73.98899536118888, 40.285634357434404]],
    [ "Bath Avenue Substation",[-73.988842849641, 40.29364520264276]],
    [ "Long Branch Substation",[-73.98453768426695, 40.30891046705423]],
    [ "Monmouth Beach Substation",[-73.97597518410349, 40.33590843154163]],
    [ "Sea Bright Substation",[-73.97574548037883, 40.362658727626496]],
    [ "Sandy Hook Substation",[-73.97722834176456, 40.39978582296714]],
    [ "Green Grove Substation",[-74.06083365866948, 40.23213953944792]],
    [ "American Water Substation",[-74.08874376378745, 40.33571196459003]],
    [ "Munitons Depot Substation",[-74.12319034252678, 40.26065148837352]],
    [ "Belford Substation",[-74.088486291742, 40.41563036269875]],
    [ "Depot Substation",[-74.07430840414627, 40.35163277111173]],
    [ "Colts Neck Substation",[-74.17405930821418, 40.28996310991211]],
    [ "Earle Pier Substation",[-74.06779240775928, 40.42728613350415]],
    [ "Clark Street Substation",[-74.20640921207303, 40.42461191480569]],
    [ "Hazlet Substation",[-74.18188412595559, 40.413844753147586]],
    [ "Fairview Substation",[-74.08676439474503, 40.36865583493454]],
    [ "Middletown Substation",[-74.10204020660396, 40.39015071728462]],
    [ "Highlands Substation",[-73.99052581988536, 40.399469153715614]],
    [ "Stone Church Substation",[-74.02788230098729, 40.40132838965537]],
    [ "Atlantic Highlands Substation",[-74.042387841764, 40.410358649105035]],
    [ "Whitesville Substation",[-74.02762996272445, 40.22255532018733]],
    [ "Monmouth Medical Center",[-73.98626859920974, 40.29391953811822]],
    [ "Princeton Substation",[-74.65984152864073, 40.351990282395484]],
    [ "1167671967",[-90.806386237765, 32.377282773751546]],
    [ "Denbury Onshore, LLC",[-90.44273396117508, 32.69428252514472]],
    [ "Yazoo City Municipial Switching Station",[-90.43343876652523, 32.842303342615345]],
    [ "City of Yazoo City",[-90.43306935517487, 32.84244383166783]],
    [ "Public Service Commission of Yazoo City",[-90.42136640000001, 32.84613745]],
    [ "1167671995",[-90.41575012511642, 32.88728145771863]],
    [ "CF Industries Nitrogen, LLC",[-90.3795220641366, 32.9014784532355]],
    [ "CF Industries Nitrogen, LLC",[-90.37941823278197, 32.90356805091572]],
    [ "CF Industries Nitrogen, LLC",[-90.37832314437208, 32.903903731788674]],
    [ "CF Industries Nitrogen, LLC",[-90.37964088174846, 32.899217742419175]],
    [ "Lexington Substation",[-90.10204111241015, 33.139049982194805]],
    [ "1167700524",[-89.96238276249768, 33.20604665592517]],
    [ "1167700527",[-90.01455913338995, 33.27554261671919]],
    [ "1167700528",[-90.01457926179322, 33.27639549786654]],
    [ "Entergy Mississippi",[-90.19116204641483, 33.494245329912744]],
    [ "1167765971",[-82.42605713934996, 42.960183398537716]],
    [ "1167772979",[-90.0995194767828, 32.591758920558696]],
    [ "Entergy Mississippi",[-90.22206955236328, 32.3783451108468]],
    [ "1167773042",[-90.14488124668823, 32.36424205367357]],
    [ "1167775983",[-84.15260285205798, 31.291593445040668]],
    [ "Tampa Electric Company",[-82.2166399000489, 28.397097767808603]],
    [ "1167779880",[-81.95577102371774, 27.80732797062154]],
    [ "1167779881",[-81.95506505934709, 27.807443148323497]],
    [ "1167789077",[-80.65852179114913, 36.288547878811166]],
    [ "Stony Knoll Solar, LLC",[-80.65855099443696, 36.288923379103025]],
    [ "1167796470",[-83.64840360780417, 30.861931253794225]],
    [ "Utica Substation",[-90.6245421471259, 32.12531158277402]],
    [ "1167803289",[-90.62848599845084, 32.048621054368056]],
    [ "1167809536",[-82.59442094740083, 42.91611389813475]],
    [ "1167814609",[-82.74509078813482, 42.98842396816962]],
    [ "1167821312",[-82.47600125000001, 43.03780539999999]],
    [ "1167881419",[-118.18944767908644, 33.74284450442183]],
    [ "Branchport Substation",[-74.01084936580186, 40.30467597517708]],
    [ "Monmouth Park Substation",[-74.01532788468305, 40.305545064432906]],
    [ "1167914296",[-91.53292410776712, 44.781209081346255]],
    [ "1167973784",[-82.50539475864798, 43.11299502118755]],
    [ "1167982723",[-82.68529098833727, 43.191594825847744]],
    [ "1167999405",[-82.81767515, 43.12579244999999]],
    [ "1168074806",[-90.5908563334083, 33.32856637480445]],
    [ "1168074821",[-90.50112756457197, 33.185498674677476]],
    [ "1168074823",[-90.44584192694032, 32.91630165711267]],
    [ "Midnight Substation",[-90.57477533212284, 33.04155180127531]],
    [ "Penngrove Substation",[-122.68113049999998, 38.315534650000004]],
    [ "1168134465",[-90.85836360809594, 33.14153847927469]],
    [ "1168134467",[-90.99497990000002, 33.02521774999999]],
    [ "Entergy Mississippi",[-90.79025755, 32.5120474]],
    [ "1168134569",[-90.80485682988127, 32.47740523405363]],
    [ "Central Electric Power Association",[-89.97349534846562, 32.354653516923115]],
    [ "Fibermark Substation",[-72.54627595726731, 42.88810448552047]],
    [ "Leland Susbstation",[-85.7294421, 44.982248649999995]],
    [ "Northport Substation",[-85.61884492703032, 45.12629572559316]],
    [ "Butler Substation",[-75.03688307539116, 39.440787161194585]],
    [ "Little Silver Substation",[-74.04748190836236, 40.330407104263045]],
    [ "Concordia Electric Cooperative",[-91.78979280921503, 31.617472023606858]],
    [ "1168276887",[-83.41300669373925, 41.91378326738906]],
    [ "1168295991",[-83.5784218244632, 41.91135799532405]],
    [ "1168298938",[-83.5551799899287, 41.94547226391985]],
    [ "NextEra Energy",[-96.40853882243822, 39.681351119742374]],
    [ "1168328267",[-90.73157107563685, 33.439792962067685]],
    [ "Leland Substation",[-90.88885573634496, 33.41546932126969]],
    [ "1168328273",[-90.88745010000001, 33.416177100000006]],
    [ "1168328294",[-91.09408707917905, 33.35558619229675]],
    [ "1168342903",[-122.76412348973591, 38.370024298983566]],
    [ "Westminister Substation",[-72.45550202502986, 43.10103370520959]],
    [ "Rumson Substation",[-74.00021101163956, 40.373626966131305]],
    [ "Jersey Central Power and Light",[-74.03528820847622, 40.35334160025484]],
    [ "Concordia Electric Cooperative",[-91.85525257667213, 31.608750515607316]],
    [ "1168511500",[-76.30156294784429, 36.81617766075436]],
    [ "Gunston Substation",[-82.99962305, 42.41421285]],
    [ "Entergy Mississippi",[-91.03242246899495, 33.37147901584282]],
    [ "Tennessee Gas Pipeline Company, L.L.C.",[-91.05733675036923, 33.3568249763439]],
    [ "1168586401",[-91.00681451670091, 33.32686967494344]],
    [ "Entergy Mississippi",[-90.90536465, 33.2560436]],
    [ "1168586403",[-90.90477903266081, 33.25625896590712]],
    [ "Entergy Mississippi",[-91.03718978631767, 33.405902089584266]],
    [ "Entergy Mississippi",[-91.00614867531901, 33.39953125824249]],
    [ "Entergy Mississippi",[-90.62696776767207, 33.60976224673582]],
    [ "Steiner Substation",[-90.62173513338554, 33.61134239989062]],
    [ "Delta Electric",[-90.74654966835132, 33.58904573528944]],
    [ "1168756074",[-90.32631938934891, 33.48748192237523]],
    [ "1168756095",[-90.3791915552771, 33.64132691857127]],
    [ "1168756099",[-90.47008007408108, 33.59656689777058]],
    [ "1168756101",[-90.41031045260777, 33.56669631446771]],
    [ "Mid Valley Pipeline Company LLC",[-90.26226801322724, 33.6987938871562]],
    [ "Ruleville Substation",[-90.54035194465988, 33.75263232112696]],
    [ "1168798817",[-83.34389490164293, 41.96195511589522]],
    [ "Beech Street Substation",[-71.8169671943097, 42.575705627440364]],
    [ "DTE Energy",[-83.34769129053673, 41.957405903348906]],
    [ "Great Notch Substation",[-74.2018016376819, 40.87530218035763]],
    [ "1169010235",[-83.42221795000002, 42.089315600000006]],
    [ "1169010236",[-83.42240125, 42.08963795]],
    [ "1169027616",[-90.64625819096338, 34.01724307917274]],
    [ "Clarksdale Public Utilities",[-90.61059440722799, 34.20504408811369]],
    [ "Clarksdale Public Utilities",[-90.56732865000001, 34.204865149999996]],
    [ "Clarksdale Public Utilities",[-90.54904151805928, 34.20940334776534]],
    [ "1169029768",[-83.3741989455743, 41.96532316930032]],
    [ "Tunica Substation",[-90.38360943600154, 34.67666695177762]],
    [ "Coldwater Substation",[-89.95277276033814, 34.699410243958724]],
    [ "1169138038",[-83.40849872472889, 42.05046064298493]],
    [ "San Manuel Substation",[-117.2315347098446, 34.152555533208975]],
    [ "4-County Electric Power Association",[-88.86134414022301, 33.41100917509675]],
    [ "Azalea Lane Substation",[-88.82707359253568, 33.43643475573875]],
    [ "Montpelier Substation",[-88.92942230042753, 33.682050883553615]],
    [ "Harbor Beach Substation",[-74.3960412280086, 39.3919345321057]],
    [ "Byhalia Road Substation",[-89.886781459027, 34.85948792501594]],
    [ "Desoto Substation",[-90.06504725732933, 34.97679362372931]],
    [ "Walls Substation",[-90.14712974333207, 34.961619471402685]],
    [ "1169278170",[-121.91266057559214, 37.35411037323121]],
    [ "1169298278",[-88.44558464021078, 33.57977954578555]],
    [ "1169298281",[-88.45062839276295, 33.62193159785983]],
    [ "1169298285",[-88.58565429465826, 33.588536584329376]],
    [ "New Jersey Transit",[-74.20928531479834, 40.80702392000225]],
    [ "Chickasaw Trails Industrial Park Switching Station",[-89.61553548865575, 34.975762225088225]],
    [ "Attica Substation",[-83.16748369999998, 43.039767700000006]],
    [ "Chestnut 1 Substation",[-120.65453752907895, 40.42372006868703]],
    [ "1169512705",[-112.63280146573304, 33.37462035415581]],
    [ "1169529180",[-88.95121853040116, 32.75742878439795]],
    [ "1169529213",[-88.68197318877648, 32.622606688388245]],
    [ "1169529215",[-88.59686450524414, 32.55082386552235]],
    [ "1169529218",[-88.60602699687968, 32.55583779991767]],
    [ "1169529222",[-88.46059764861742, 32.816261192632865]],
    [ "1169538735",[-88.45083257504845, 33.08457829269557]],
    [ "Columbus Substation",[-88.41064596879006, 33.447140170774816]],
    [ "1169538782",[-88.34105380261458, 33.42673830356224]],
    [ "Columbus Light & Water",[-88.41493453782248, 33.51127715376289]],
    [ "Columbus Light & Water",[-88.42871755809952, 33.52850395838578]],
    [ "Columbus Light & Water",[-88.38854686788396, 33.48648503057688]],
    [ "Columbus Light & Water",[-88.43731400098234, 33.48182675005719]],
    [ "1169647947",[-88.95811481284818, 32.79919790815576]],
    [ "1169647949",[-88.91720404838541, 32.98415680349527]],
    [ "1169647955",[-88.95975085, 33.11855505]],
    [ "1169647967",[-88.6344674, 33.36332200000001]],
    [ "1169647968",[-88.76192264632675, 33.371485688924366]],
    [ "Clayton Village Switching Station",[-88.74043966654396, 33.478638733218304]],
    [ "Artesia Switching Station",[-88.61678127519288, 33.4494994935882]],
    [ "Starkville Electric Department",[-88.8357070254893, 33.436064029451224]],
    [ "1169714289",[-109.40360384999998, 37.11569840000001]],
    [ "Mississippi Lignite Mining Company",[-89.22339093225331, 33.38207835491863]],
    [ "Mississippi Lignite Mining Company",[-89.23271239999998, 33.4106806]],
    [ "Dumont Substation",[-73.99626873501488, 40.94209750693121]],
    [ "Englewood Substation",[-73.97047667029142, 40.90015809959674]],
    [ "Bergenfield Substation",[-73.99898044848238, 40.912496410260694]],
    [ "Saddle Brook Substation",[-74.10105117496029, 40.88901288234917]],
    [ "1169738256",[-74.0241920382693, 40.84016303973165]],
    [ "River Road Substation",[-73.99565635760524, 40.795891628523556]],
    [ "Kingsland Substation",[-74.11899556713055, 40.79198205098813]],
    [ "Carlstadt Substation",[-74.06435303124965, 40.81974893834536]],
    [ "Van Winkle Substation",[-74.09895016104218, 40.8285526171245]],
    [ "Passaic Substation",[-74.12034515987882, 40.86252505480392]],
    [ "Kuller Road Substation",[-74.16364765746034, 40.88551164777661]],
    [ "Teaneck Substation",[-74.01278952723904, 40.89439416987721]],
    [ "Spring Valley Substation",[-74.06049513120885, 40.91993207784474]],
    [ "Warren Point Substation",[-74.11658599094318, 40.92954030881062]],
    [ "McLean Boulevard Substation",[-74.14346271216424, 40.92857922239862]],
    [ "Paramus Substation",[-74.07714106391953, 40.96741442782254]],
    [ "Legion PL Substation",[-74.13865737630304, 40.938115685736776]],
    [ "North Paterson Substation",[-74.16038269593328, 40.93115272252576]],
    [ "South Paterson Substation",[-74.15388194820186, 40.89659073031991]],
    [ "Hackensack Substation",[-74.03851156039389, 40.872265382976316]],
    [ "Lodi Substation",[-74.07628145243042, 40.88120825685018]],
    [ "Newport Substation",[-74.04818846139145, 40.73277313641398]],
    [ "Fairmount Substation",[-74.06254716628304, 40.71854085866954]],
    [ "Garfield Avenue Substation",[-74.06780652741513, 40.71429914528925]],
    [ "Totowa Substation",[-74.22696903658486, 40.895937723045186]],
    [ "Huber Engineered Woods LLC",[-84.79661691995766, 35.75268278506176]],
    [ "Entergy Louisiana",[-90.12330966551828, 30.782578185518112]],
    [ "Washington-St. Tammany Electric Cooperative",[-90.12067510000001, 30.781872300000003]],
    [ "East Rutherford Substation",[-74.10695389512387, 40.84139497568152]],
    [ "Hillsdale Substation",[-74.04595699164605, 41.007849184239056]],
    [ "Marion Substation",[-74.07428821561199, 40.744260149458505]],
    [ "Newark Bay Substation",[-74.13088599379299, 40.72035697200874]],
    [ "Clay Street Substation",[-74.16708530770978, 40.75040459465684]],
    [ "Passaic Valley Sewerage Commission Substation",[-74.13172959039441, 40.71181927346299]],
    [ "Newark Energy Center",[-74.12816321904344, 40.70775345178667]],
    [ "Ironbound Substation",[-74.1611060976234, 40.72215539311084]],
    [ "Newark Airport Metering and Regulating Station",[-74.14986914811993, 40.70396408295225]],
    [ "Werner Substation",[-74.28126522967334, 40.490059590150224]],
    [ "Jersey Central Power and Light",[-74.31856182976807, 40.47724250656111]],
    [ "1169800240",[-93.1929086796839, 32.56243289607638]],
    [ "1170345519",[-89.84163129999999, 32.407724699999996]],
    [ "1170345520",[-89.71553938176007, 32.57676176495735]],
    [ "1170345521",[-89.71481672619026, 32.57663080763436]],
    [ "1170367927",[-90.19068316659384, 33.494812351129546]],
    [ "1170367953",[-90.18435131881579, 33.5164663880536]],
    [ "1170368056",[-90.2088314539377, 33.51729020941794]],
    [ "Elliott Substation",[-89.7458403346534, 33.677331989083484]],
    [ "Charleston Substation",[-90.01631362515255, 33.99878556109552]],
    [ "Marathon Pipe Line LLC",[-89.93978195000001, 33.93520815]],
    [ "West Charleston Substation",[-90.07130147856014, 33.98723383755155]],
    [ "1170402777",[-97.49787897780581, 37.70639902544692]],
    [ "1170416567",[-83.15131524999998, 43.1009743]],
    [ "Maben Substation",[-89.08000857158217, 33.56970349335655]],
    [ "1170420658",[-83.07819577058622, 43.31883791444964]],
    [ "1170440885",[-110.8035576414842, 34.682914348486314]],
    [ "1170446478",[-88.58527961323514, 40.29371376909322]],
    [ "Wagner Substation",[-83.12871235692776, 42.342004926791645]],
    [ "1170451500",[-119.4764176462741, 39.519432993024296]],
    [ "1170547322",[-83.3483562922176, 43.33664176716034]],
    [ "Station 112",[-77.66118027803587, 43.22810710399811]],
    [ "Columbiaville Substation",[-83.41006685622625, 43.157806472512306]],
    [ "1170966011",[-88.44984192102669, 33.62298470941523]],
    [ "Water Valley Substation",[-89.63168451682228, 34.1448721682947]],
    [ "Tennessee Gas Pipeline Company, L.L.C.",[-89.78414167502392, 33.908066556366364]],
    [ "1171010316",[-87.48365609999998, 39.4528264]],
    [ "1171015185",[-88.62757848035663, 34.52398515362462]],
    [ "Tonnelle Avenue Substation",[-74.01666945146985, 40.80630101274194]],
    [ "1171095566",[-87.41820148004525, 39.4480196059985]],
    [ "1171255236",[-82.54116845704588, 43.26765878183968]],
    [ "Prairie Substation",[-88.70001044426229, 33.79881697372637]],
    [ "Egypt Substation",[-88.72062918986327, 33.901055679673576]],
    [ "Prairie Substation",[-88.65820787598145, 33.80099721856191]],
    [ "1171354668",[-88.74624637722893, 34.008376898971235]],
    [ "1171354682",[-88.65761666993092, 33.61414162448798]],
    [ "Arizona Public Service",[-112.54664742949, 33.67356721549949]],
    [ "Tuckahoe Substation",[-74.74409805895493, 39.264719895528415]],
    [ "Salem Substation",[-75.46893507846106, 39.57663547646246]],
    [ "1171458039",[-92.49619805913918, 38.08507190014677]],
    [ "1171580066",[-82.6148835, 43.27218005]],
    [ "1171593746",[-82.63738216712159, 43.35295497421594]],
    [ "1171619717",[-82.67078492524107, 43.416080904828526]],
    [ "Jersey Central Power and Light",[-74.51198291454617, 40.111512010356755]],
    [ "Wyckoff Substation",[-74.51937060524305, 40.27395727574902]],
    [ "1171723016",[-82.67623438907314, 43.42302582539712]],
    [ "1171734283",[-82.83064304071117, 43.3332814257581]],
    [ "1171740412",[-82.82325834999999, 43.18759484999999]],
    [ "1171747082",[-82.97854877726543, 43.20750881590468]],
    [ "1171747312",[-82.86128058528831, 43.18172867962848]],
    [ "1171748033",[-82.9863230642218, 43.21134992262423]],
    [ "1171784678",[-82.75508186210841, 43.52574616972267]],
    [ "1171801392",[-82.74763188730857, 43.36542382588934]],
    [ "1171825980",[-82.75862463110082, 43.670610984996095]],
    [ "1171859567",[-83.08503979056856, 43.48730924061359]],
    [ "River Substation",[-75.3060460850288, 39.8420975548621]],
    [ "Public Service Enterprise Group",[-74.73315221625106, 40.18126776666667]],
    [ "Tombigbee Electric Power Association",[-88.69850355366255, 34.16116025666608]],
    [ "Cooper Tire & Rubber Company",[-88.71099864615545, 34.22965293113646]],
    [ "Cooper Tire & Rubber Company",[-88.71057470834604, 34.22911466967912]],
    [ "Beesley Substation",[-74.63867142404905, 39.27902143667788]],
    [ "Franklin Substation",[-75.03188993807133, 39.61663184849775]],
    [ "Avenel Substation",[-74.28952538234, 40.56769509855139]],
    [ "Red Oak A/B Substation",[-74.3470863295021, 40.44921017114198]],
    [ "South River Substation",[-74.34374813509939, 40.43932257405763]],
    [ "Woodbridge Energy Center",[-74.31990889121305, 40.51635167886687]],
    [ "BMS Hopewell Substation",[-74.76744073617336, 40.34743648280377]],
    [ "Monroe County Electric Power Association",[-88.4777910746113, 33.96030749799989]],
    [ "Toyota Boshoku Mississippi, LLC",[-88.52758156500374, 34.2717070752214]],
    [ "Mooreville Substation",[-88.57216216158403, 34.27205174068173]],
    [ "1172221236",[-88.39802888804198, 34.28384931107549]],
    [ "1172221242",[-88.42181103434228, 34.27338913859214]],
    [ "Fairview Substation",[-88.3100822575675, 34.3598785321255]],
    [ "Belmont Substation",[-88.20944317673892, 34.51367378858742]],
    [ "1172264187",[-82.97268415, 43.461458050000005]],
    [ "1172296368",[-83.18778868053077, 43.4611722031206]],
    [ "1172322511",[-104.25982075, 32.45763145000001]],
    [ "1172324782",[-104.2519209, 32.41864915000001]],
    [ "1172508066",[-88.6470055822933, 34.46648858038777]],
    [ "1172508068",[-88.50044427859102, 34.429934449726495]],
    [ "1172508077",[-88.6789555205613, 34.48070920821733]],
    [ "1172508080",[-88.66088248267087, 34.490441302859956]],
    [ "Prentiss County Electric Power Association",[-88.47114084625724, 34.585953015886574]],
    [ "1172508108",[-88.25675990237359, 34.926108853034776]],
    [ "Corinth Substation",[-88.50931149079668, 34.91249648617697]],
    [ "Alcorn County Electric Power Association",[-88.55747081044214, 34.797664825090266]],
    [ "Alcorn County Electric Power Association",[-88.48013786483537, 34.944655935618464]],
    [ "Kimberly Clark Corporation",[-88.45055545935533, 34.951624823210906]],
    [ "Kossuth Substation",[-88.63971922893963, 34.882894121764885]],
    [ "1172613053",[-87.19837136680064, 41.217567775199115]],
    [ "1172613054",[-87.10808539999998, 41.224343250000004]],
    [ "1172636623",[-92.80143788689901, 38.52564311088637]],
    [ "US Silica Substation",[-75.11657556983211, 39.307615767228334]],
    [ "Uniman Substation",[-75.06247517894269, 39.29873426982043]],
    [ "1172652230",[-89.02095035049845, 34.37981561951981]],
    [ "Pontotoc Electric Power Association",[-89.01791588768124, 34.419404725126206]],
    [ "1172652235",[-89.24671084999999, 34.535478749999996]],
    [ "1172652237",[-89.15007025472498, 34.46774259436099]],
    [ "1172652244",[-89.00386135580874, 34.68552647633568]],
    [ "1172652254",[-88.94213570823622, 34.837220483982094]],
    [ "Walnut Substation",[-88.89905997464214, 34.967378298226976]],
    [ "Saulsbury Substation",[-89.06107263279667, 35.051138187139294]],
    [ "1172661995",[-88.9888689009254, 34.532103063920104]],
    [ "Hickory Flats Substation",[-89.18092305321949, 34.62166658458198]],
    [ "1172662014",[-89.1977703, 34.8586992]],
    [ "1172662017",[-89.43630698397126, 34.945728958903764]],
    [ "1172662020",[-89.50982216740417, 34.93697248594121]],
    [ "1172662021",[-89.61680877230037, 34.93951359888927]],
    [ "1172662038",[-89.82332878174543, 34.91782576495443]],
    [ "1172699105",[-82.90903150481165, 43.40404476050778]],
    [ "1172702736",[-83.21341217912578, 43.47049907813445]],
    [ "Entergy Louisiana",[-91.84536100000001, 32.35685315]],
    [ "1172706127",[-91.58724304321518, 32.44372062500078]],
    [ "Denbury Onshore, LLC",[-91.59005051410702, 32.44452203133326]],
    [ "1172708815",[-92.76474451261043, 32.573018691055914]],
    [ "1172715338",[-83.18984964999999, 43.51866925]],
    [ "1172716757",[-83.18584788837852, 43.419133725372326]],
    [ "1172743924",[-95.28672927251671, 32.115021254694035]],
    [ "1172767911",[-89.85634178334001, 34.985626849852096]],
    [ "1172767914",[-89.73231991319864, 34.96835397504651]],
    [ "Moscow Substation",[-89.39876012010635, 35.06299830229687]],
    [ "Cordova Substation",[-89.74550810422775, 35.17468092158712]],
    [ "1172774424",[-96.10756236196957, 32.18071869974089]],
    [ "1172774426",[-96.098361230108, 32.18470395495541]],
    [ "1172774427",[-96.10275144610726, 32.12762464092308]],
    [ "1172786655",[-89.48152562983773, 34.4277375434193]],
    [ "North East Mississippi Electric Power Association",[-89.56003126060668, 34.36761987529081]],
    [ "1172786662",[-89.53317370246813, 34.360272054173436]],
    [ "Vail Mills Station",[-74.2174040783552, 43.04449537347992]],
    [ "FIXME Substation",[-92.66878197401098, 38.644715057929965]],
    [ "Fulton County Landfill",[-74.46994895274838, 43.01092965349964]],
    [ "Wells Station 208",[-74.28554465, 43.3886288]],
    [ "Gilmantown Road 254",[-74.34485804697921, 43.49183030904602]],
    [ "1173075938",[-83.23755902886914, 43.72939513326013]],
    [ "Noxapater Substation",[-89.06235457617785, 33.003854058171946]],
    [ "1173079124",[-89.06998197408178, 33.145857506714506]],
    [ "1173091925",[-88.26977562438077, 33.88293610342009]],
    [ "1173091927",[-88.30393863766056, 33.702568644870354]],
    [ "1173140609",[-83.25124845, 43.266967699999995]],
    [ "1173143233",[-83.31209318294472, 43.18978477520028]],
    [ "1173162674",[-83.42269523322663, 43.35070130189124]],
    [ "1173167529",[-83.50136415432257, 43.35225074675934]],
    [ "1173362271",[-83.60089482677574, 43.450931706607435]],
    [ "1173370409",[-83.44445197793208, 43.45330152562879]],
    [ "1173380178",[-83.40716459916412, 43.482942948132]],
    [ "Mid Valley Pipeline Company LLC",[-89.56569047464349, 34.46258077477686]],
    [ "1173525140",[-83.54317533347829, 43.552820424860656]],
    [ "West Charleston Substation",[-72.05697237799986, 44.898155002442174]],
    [ "Islandview Substation",[-83.01514460331255, 42.35700565155703]],
    [ "1173672106",[-83.4665147162644, 43.64613616706059]],
    [ "1173691655",[-83.4314618, 43.59665459999999]],
    [ "1173695409",[-83.44950317353596, 43.74023062833729]],
    [ "1173695411",[-83.45609624628732, 43.726032080335195]],
    [ "1173700297",[-83.4537860962926, 43.731404376128204]],
    [ "1173700299",[-83.4365933, 43.742090199999986]],
    [ "1173711908",[-82.9793150096607, 43.70912680145742]],
    [ "1173717197",[-83.21893893110244, 43.74322701219008]],
    [ "1173724523",[-82.93839273680184, 43.72086098518082]],
    [ "Pumpkin Center Substation",[-82.33049313408473, 33.487114504829385]],
    [ "1173767012",[-82.97494319097873, 43.56255302731202]],
    [ "1173846216",[-74.35309116065336, 40.71143423874174]],
    [ "Jersey Central Power & Light",[-74.34214527884049, 40.708603448508434]],
    [ "Jersey Central Power and Light",[-74.38163857603082, 40.71621068634112]],
    [ "Jersey Central Power and Light",[-74.38730194987838, 40.70770423053363]],
    [ "Jersey Central Power and Light",[-74.10087063172573, 40.08214628562952]],
    [ "Woodland Substation",[-74.07942587473053, 40.08079970200866]],
    [ "Lanes Mill Substation",[-74.11476978469545, 40.117717833108244]],
    [ "Point Pleasant Substation",[-74.04724944415008, 40.08783521775248]],
    [ "Wheaton Substation",[-75.02781277347964, 39.411416874890264]],
    [ "1173938644",[-84.50598860985652, 32.639031926234836]],
    [ "1173938645",[-84.48742083262022, 32.62007780275361]],
    [ "1173938646",[-84.48307914002645, 32.61838422247611]],
    [ "1173960241",[-81.94726135, 31.6153]],
    [ "1173997495",[-82.7459273, 43.94697475]],
    [ "1174019223",[-73.91456512077146, 43.06114010338907]],
    [ "1174019224",[-73.91593670000002, 43.0615221]],
    [ "1174050069",[-82.85918285000001, 44.03016615000001]],
    [ "1174078824",[-89.74160403185347, 30.267769128258163]],
    [ "1174078832",[-89.79083805620003, 30.249493981814748]],
    [ "1174078845",[-89.81452708663132, 30.304844786459686]],
    [ "1174078854",[-89.83298641307466, 30.301021745508383]],
    [ "1174078856",[-89.94334825, 30.311676949999992]],
    [ "1174078857",[-89.97389595000001, 30.32453555]],
    [ "1174078867",[-90.0458337476259, 30.389090097528555]],
    [ "1174078872",[-90.08132573233644, 30.371058496640938]],
    [ "1174078877",[-90.08381659445837, 30.39642203011334]],
    [ "1174078880",[-89.78241366355546, 30.296160748808067]],
    [ "1174078885",[-89.79284307117794, 30.274627406343605]],
    [ "1174078887",[-89.78002756307761, 30.282888075149838]],
    [ "1174118225",[-82.96459270000003, 43.925772349999995]],
    [ "1174123718",[-82.8424657244383, 43.842269787291535]],
    [ "1174147473",[-88.32917685895833, 41.41344744440457]],
    [ "1174300389",[-107.28522531595078, 36.23490085295548]],
    [ "CLECO",[-89.7438192, 30.31013085]],
    [ "CLECO",[-89.75440135, 30.35970665]],
    [ "CLECO",[-89.76688247160916, 30.233752642036862]],
    [ "CLECO",[-89.78965515350407, 30.211650581767195]],
    [ "Abita Springs Substation",[-90.01478471939338, 30.493536565816648]],
    [ "Hickory Substation",[-89.80204147522, 30.41683545544076]],
    [ "Washington-St. Tammany Electric Cooperative",[-89.9501007747758, 30.59168365723263]],
    [ "Sun Substation",[-89.90648444880804, 30.649788516589165]],
    [ "Cosmo Substation",[-83.26204005, 43.828263850000006]],
    [ "1174459327",[-83.14073144999999, 43.81978260000001]],
    [ "1174460295",[-83.17559581276282, 43.81870758085203]],
    [ "Sodeman Road Station 1301",[-73.89646627995847, 43.06711312816114]],
    [ "TC Rock Substation",[-97.05355913697298, 37.36111546653349]],
    [ "Evergy",[-97.05256292502601, 37.36109443867988]],
    [ "1174477507",[-88.11625631760603, 41.44044011539576]],
    [ "1174477508",[-88.11632994232653, 41.44185502663355]],
    [ "1174477509",[-88.11636778841003, 41.44260034569423]],
    [ "1174477512",[-88.11256050553516, 41.43928174517396]],
    [ "1174477514",[-88.12287285943067, 41.43773599379215]],
    [ "1174477515",[-88.12294873024975, 41.43914838987398]],
    [ "1174506233",[-90.02409686212481, 30.404866888809202]],
    [ "CLECO",[-90.02357453776779, 30.35147555907846]],
    [ "Abita Springs Substation",[-90.04410290000001, 30.483039100000003]],
    [ "CLECO",[-90.08075460000002, 30.453677700000004]],
    [ "Covington City Substation",[-90.09757238264521, 30.47837399791055]],
    [ "CLECO",[-90.11285126720789, 30.466325302238463]],
    [ "CLECO",[-90.16671891711927, 30.43712998373948]],
    [ "Madisonville Substation",[-90.15894912563382, 30.405032063040238]],
    [ "CLECO",[-90.10686683195331, 30.38547284624202]],
    [ "CLECO",[-90.08276378421063, 30.418450932455443]],
    [ "CLECO",[-90.12389135490459, 30.432059624705534]],
    [ "Fairview Substation",[-90.19360408755297, 30.427928978335302]],
    [ "Verdun Substation",[-90.73035017071005, 30.333964677125035]],
    [ "Whitehall Substation",[-90.69868987985572, 30.28959498634377]],
    [ "First Electric Cooperative",[-91.2477097, 34.09079665]],
    [ "1174553461",[-83.41881936747126, 43.783415655829344]],
    [ "Van Buren Street",[-77.08667302673925, 43.04784034506028]],
    [ "Willet Relocation",[-75.92336459100899, 42.46574955888996]],
    [ "Kiamesha",[-74.67382029167935, 41.67082093391491]],
    [ "Green Street",[-76.5708102961718, 42.93299195778519]],
    [ "Raquette Lake",[-74.65476801617257, 43.80878924862214]],
    [ "Raquette Lake",[-74.65352719713476, 43.80936606788393]],
    [ "1174633644",[-90.3783934749335, 30.76328523540331]],
    [ "1174633649",[-90.36675665732753, 30.765748867596862]],
    [ "1174633660",[-90.3653, 30.704857800000003]],
    [ "1174633662",[-90.23598150000001, 30.639755049999998]],
    [ "1174633667",[-90.23436282494482, 30.577734209233025]],
    [ "Folsom Substation",[-90.1911259, 30.6353937]],
    [ "1174633672",[-90.1144896345013, 30.663059263267364]],
    [ "1174633674",[-90.0249544, 30.695549850000003]],
    [ "1174637521",[-85.85568428350423, 41.240718668873576]],
    [ "1174640598",[-84.8682576, 29.744999199999995]],
    [ "1174644630",[-110.51682508285528, 48.509455883843955]],
    [ "Stoney Point Substation",[-90.27839185697923, 30.82062203832361]],
    [ "Washington-St. Tammany Electric Cooperative",[-90.14328204478775, 30.824771235982]],
    [ "1174704132",[-90.2143818248299, 30.92186394249445]],
    [ "Dixie Pipeline Company LLC",[-90.23328295, 30.963833349999998]],
    [ "1174704143",[-90.39288182281368, 30.972567305123025]],
    [ "Bolivar Substation",[-90.39789056009883, 30.866559775242504]],
    [ "CLECO",[-90.12125959627153, 30.48677209011107]],
    [ "CLECO",[-90.13451112607181, 30.47003937373448]],
    [ "Colonial Pipeline Company",[-90.87158583929128, 30.908601228819]],
    [ "Denbury Onshore, LLC",[-90.8884807346276, 30.520709532238268]],
    [ "DEMCO",[-90.88630144008778, 30.587765023512663]],
    [ "DEMCO",[-90.75310405233259, 30.543154616639338]],
    [ "DEMCO",[-90.71303205632407, 30.69561299713257]],
    [ "Amerchol Corporation",[-90.65187474999999, 30.794074949999995]],
    [ "Darlington Substation",[-90.78489630380798, 30.87502876688212]],
    [ "Grangeville Substation",[-90.85709866550496, 30.736351725068083]],
    [ "1174726944",[-90.97289237061037, 30.698289718053122]],
    [ "DEMCO",[-91.03294090006702, 30.765429329315033]],
    [ "1174746406",[-90.82352473330047, 30.34091253260699]],
    [ "1174746410",[-90.87132856844967, 30.287419700323394]],
    [ "DEMCO",[-91.0082525370466, 30.538993181346193]],
    [ "1174757679",[-91.01965893939922, 30.51511988970008]],
    [ "DEMCO",[-91.03268685871312, 30.473188679575312]],
    [ "Adell Compounding, Inc.",[-90.92290637288778, 30.487901584507174]],
    [ "1174775881",[-116.3336943, 43.659893249999996]],
    [ "DEMCO",[-90.94973090641894, 30.58421109250328]],
    [ "DEMCO",[-91.11643393424671, 30.59561266746938]],
    [ "1174824327",[-91.26613091809804, 30.685770830555814]],
    [ "Colonial Pipeline Company",[-91.28387845, 30.710381299999998]],
    [ "Hood Container Substation",[-91.32159719283027, 30.710205100140435]],
    [ "Entergy Louisiana",[-91.33509835424991, 30.75076593220019]],
    [ "Angola Substation",[-91.56720045, 30.939640249999997]],
    [ "DEMCO",[-91.46757779139672, 30.95961191951968]],
    [ "Bains Substation",[-91.37943451501224, 30.828222567545517]],
    [ "Texas Eastern Transmission, LP",[-91.25298554999999, 30.836154]],
    [ "1174886046",[-91.8785597422402, 41.14703339623728]],
    [ "1174889279",[-91.76339816342245, 41.15512127526817]],
    [ "1174889548",[-91.88557018042665, 41.100421349930336]],
    [ "Jackson Energy Authority",[-88.84810586727069, 35.66362188903826]],
    [ "1175190378",[-91.94767134934264, 41.363627977972214]],
    [ "Jersey Central Power and Light",[-74.17974084380828, 40.08152607001086]],
    [ "FulFlex Substation",[-72.55249548358255, 42.88598836845004]],
    [ "South Brattleboro Tap",[-72.5548380320008, 42.837508056179644]],
    [ "Massey Substation",[-75.83885047920867, 39.311606414476735]],
    [ "Reinforce Systems of Ohio Substation",[-80.86442232748364, 41.23709823502333]],
    [ "McGraw Substation",[-83.15397474783057, 42.32987185855206]],
    [ "1175469118",[-92.14210114727388, 41.26804032181246]],
    [ "1175517936",[-112.4471358850229, 33.29439866807914]],
    [ "Station 125",[-77.4403509553733, 43.019346750992895]],
    [ "1175778884",[-109.94344249904432, 48.87689393890674]],
    [ "1175778888",[-110.55406357365702, 48.81249996801959]],
    [ "Seaside Park Substation",[-74.08364988849965, 39.91396656899175]],
    [ "Chambersbrook Substation",[-74.63336155668448, 40.63266907779846]],
    [ "Jersey Central Power and Light",[-74.45842046458762, 40.354931192376156]],
    [ "Jersey Central Power and Light",[-74.46235289561137, 40.35634632505818]],
    [ "Jamesburg Substation",[-74.44922841154325, 40.34588314499496]],
    [ "Jersey Central Power and Light",[-74.4105051432936, 40.38140696784904]],
    [ "Old Bridge Substation",[-74.36849149046061, 40.413047088810835]],
    [ "Jersey Central Power and Light",[-74.32324017764284, 40.402261675873106]],
    [ "Chapin Road Substation",[-74.3389334088524, 40.85807481036822]],
    [ "Chamor Substation",[-74.3329524578469, 40.85664671442454]],
    [ "Edwards Road Substation",[-74.34682575228925, 40.84625220047213]],
    [ "Koch Methanol, LLC",[-90.86146313933565, 29.979915018108823]],
    [ "1176065333",[-87.41276095010713, 41.57413159999246]],
    [ "1176084163",[-87.23250219069733, 41.61748087815846]],
    [ "1176090289",[-74.10083561080535, 40.74527830159559]],
    [ "1176090290",[-74.10146195748753, 40.745390514607614]],
    [ "Shintech Louisiana, LLC",[-91.15684523709469, 30.23860636763222]],
    [ "Thomas Substation",[-91.1767282, 30.562640099999996]],
    [ "Main Line Substation",[-91.16731430227368, 30.545168557854208]],
    [ "1176246555",[-91.13784156449668, 30.54939611845928]],
    [ "1176246557",[-91.16961316514188, 30.58435816737089]],
    [ "Products (SE) Pipe Line Corporation",[-91.1626035, 30.548552699999995]],
    [ "Jersey Central Power and Light",[-74.39765727364487, 40.79263377608893]],
    [ "1176300637",[-74.40049599461433, 40.79773184156614]],
    [ "1176300638",[-74.42777512775591, 40.781628503433545]],
    [ "1176300639",[-74.43726793781117, 40.777630853172354]],
    [ "Convent Substation",[-74.45060055247278, 40.785981112957316]],
    [ "Collinsville Substation",[-74.47394862310502, 40.80867771647529]],
    [ "Morris Plains Substation",[-74.47768181463572, 40.82778299703972]],
    [ "Fox Hill Substation",[-74.44815159233848, 40.87945369010713]],
    [ "1176300644",[-74.453074185569, 40.877727887748115]],
    [ "West Denville Substation",[-74.51645962184982, 40.882793897363406]],
    [ "Rockaway Substation",[-74.50313776943266, 40.90748352787287]],
    [ "Jersey Central Power and Light",[-74.49901550792816, 40.91151019811484]],
    [ "Picatinny Arsenal SREC",[-74.55423354559885, 40.94684352705842]],
    [ "1176318856",[-91.18480279999999, 30.504852849999995]],
    [ "1176318857",[-91.18744602705436, 30.49283324418342]],
    [ "1176318858",[-91.18768861520996, 30.490783748983844]],
    [ "Exxon Mobil Corporation",[-91.17417975832926, 30.50144684665044]],
    [ "Entergy Louisiana",[-90.99485099870766, 30.22689893354127]],
    [ "Linde Inc",[-91.01399684392858, 30.196389464192507]],
    [ "Hexion Inc.",[-91.02076858049396, 30.204051655415743]],
    [ "Nutrien",[-91.05617241569124, 30.222656832018142]],
    [ "1176485885",[-94.40802791393826, 38.0477515205298]],
    [ "1176507749",[-85.8497497321333, 33.663448581121266]],
    [ "Univeristy Substation",[-87.33499558509892, 41.55647992649821]],
    [ "1176510591",[-87.35552553516185, 41.554835376800824]],
    [ "1176528764",[-90.60140902002193, 30.07909969123157]],
    [ "Entergy Louisiana",[-90.67255886047316, 30.074402526278455]],
    [ "1176528771",[-90.46054099271612, 30.036556283224087]],
    [ "1176547302",[-90.39950557084134, 30.006106714019808]],
    [ "1176577544",[-89.90070729164331, 30.030335235331307]],
    [ "1176577545",[-89.9007367332992, 30.029983600204538]],
    [ "1176577548",[-89.90394735923134, 30.027468174420488]],
    [ "1176577563",[-89.93722441050839, 30.011118633758915]],
    [ "Chalmette Refining, L.L.C.",[-89.97191918341056, 29.938557906788223]],
    [ "Carlisle Substation",[-89.97007914861501, 29.69920323625835]],
    [ "Entergy LA Alliance Substation",[-89.98099775789588, 29.674713211930488]],
    [ "Entergy Louisiana",[-89.98064627186932, 29.68219694034157]],
    [ "1176628753",[-94.9198565260653, 31.529602922010433]],
    [ "Jersey Central Power and Light",[-74.4249753507246, 40.68203096606498]],
    [ "Lavallette Substation",[-74.07112676477608, 39.96864258210076]],
    [ "Ocean Beach Substation",[-74.06552984999999, 39.9881988]],
    [ "Canoe Brook Substation",[-74.36236457985738, 40.74405783226797]],
    [ "St. Phillips Substation",[-87.7159488261097, 37.97815675590412]],
    [ "1176757771",[-119.9027410702355, 36.15347403452665]],
    [ "Loop LLC",[-90.25334450456363, 29.470611781363633]],
    [ "Entergy Louisiana",[-90.67958004930547, 29.520254024905793]],
    [ "Terrebonne Parish Consolidated Government",[-90.69244956317506, 29.587126479976824]],
    [ "Terrebonne Parish Consolidated Government",[-90.72106051617031, 29.581786704482834]],
    [ "1176845422",[-90.78280265353526, 29.560714260998484]],
    [ "1176845423",[-90.80664322464621, 29.688397689682297]],
    [ "Derrick Substation",[-91.24300968719854, 30.236252461973148]],
    [ "EnLink Processing Services, LLC",[-91.24356876675816, 30.236523803627758]],
    [ "Union Carbide Corporation",[-90.44291438457624, 29.984729242871534]],
    [ "Union Carbide Corporation",[-90.45124270990735, 29.98944844084356]],
    [ "Occidental Chemical Corporation",[-90.45492416958433, 29.989099561594873]],
    [ "Occidental Chemical Corporation",[-90.45540789999998, 29.9860043]],
    [ "Occidental Chemical Corporation",[-90.45570764999998, 29.984963549999993]],
    [ "Entergy Louisiana",[-91.16158259917445, 30.246365245299003]],
    [ "1176909236",[-91.18524870995205, 30.262329129779726]],
    [ "1176909240",[-91.18532762996637, 30.258015393519813]],
    [ "Boardwalk Storage Company, LLC",[-91.30714298733379, 30.31070366413294]],
    [ "US Department of Energy",[-91.30828121522818, 30.31794297452564]],
    [ "US Department of Energy",[-91.30779283171123, 30.317953891167864]],
    [ "Diamond Plastic Corporation",[-91.27214275000003, 30.312066699999995]],
    [ "1176909257",[-91.25059788360929, 30.31618678295507]],
    [ "1176909260",[-91.25774096976399, 30.27322224552608]],
    [ "1176909262",[-91.25063865000001, 30.32434855]],
    [ "1176909267",[-91.25261384999997, 30.32398095]],
    [ "The Dow Chemical Company",[-91.25579384518227, 30.338708782431176]],
    [ "Muscle Shoals Solar, LLC",[-87.90658658983415, 34.7685743767734]],
    [ "1176915951",[-115.31976492518626, 33.71534978691904]],
    [ "1176915957",[-115.34424113259409, 33.74117311889232]],
    [ "1176937416",[-95.76069678797204, 29.17454861407373]],
    [ "1176937417",[-95.76090547748834, 29.173286071271015]],
    [ "1176962903",[-104.44406107619871, 31.736003019933754]],
    [ "1176962909",[-104.45690849892931, 31.684825531985013]],
    [ "Entergy Louisiana",[-93.43695421957797, 30.280173715310543]],
    [ "Entergy Louisiana",[-93.39945425178212, 30.21263905534536]],
    [ "1176981494",[-91.58952288472614, 30.73508365888293]],
    [ "1176981495",[-91.70222400488673, 30.828757683348556]],
    [ "Nan Ya Plastics Corporation",[-91.65933356895589, 30.822878297345387]],
    [ "1176981500",[-91.3698215393283, 30.54621069045014]],
    [ "Devin Substation",[-91.31220011088391, 30.470141430054447]],
    [ "1176981505",[-91.31196490086825, 30.469303419096356]],
    [ "Sequachee Valley Electric Cooperative",[-85.22899415039014, 35.72975437922708]],
    [ "1177092613",[-91.76518968093563, 30.53779882971269]],
    [ "J.P. Oil Company, LLC",[-91.78830962522845, 30.495464058442188]],
    [ "1177092629",[-92.08652265570207, 30.54086387753589]],
    [ "1177092630",[-91.91460224999999, 30.543945249999997]],
    [ "Plaisance Substation",[-92.14713887815326, 30.627688635183933]],
    [ "Texas Eastern Transmission, LP",[-92.12698493154635, 30.574351495357835]],
    [ "Washington Substation",[-92.0666742300174, 30.603144493653893]],
    [ "1177169980",[-91.97841553837709, 30.727501027912993]],
    [ "1177169981",[-92.03681602546037, 30.78336629310717]],
    [ "CLECO",[-92.21298177515273, 30.867450642704764]],
    [ "Bunkie Substation",[-92.17816825105422, 30.948254993357303]],
    [ "Bunkie Highway 71 Substation",[-92.19696128237067, 30.962793094559185]],
    [ "Hessmer Substation",[-92.11809967006725, 31.051372264834495]],
    [ "Cheneyville Substation",[-92.28333893785768, 31.016499221328413]],
    [ "CLECO",[-92.34029171988203, 31.0355399761868]],
    [ "Cabot Corporation",[-92.25256896643096, 30.748820993207048]],
    [ "CLECO",[-92.06965517561224, 30.57813094260464]],
    [ "CLECO",[-92.08952142330813, 30.555979354322776]],
    [ "Oak Street Substation",[-92.27534701770516, 30.684850410347767]],
    [ "CLECO",[-92.2728302, 30.689729949999997]],
    [ "CLECO",[-92.26448049999999, 30.688714649999994]],
    [ "CLECO",[-92.27445894621286, 30.697176587555496]],
    [ "CLECO",[-92.29112871633279, 30.691623317321348]],
    [ "CLECO",[-92.31066536721752, 30.71810998387436]],
    [ "Pine Prairie Substation",[-92.42284963671163, 30.79980263442261]],
    [ "CLECO",[-92.66114674008938, 30.812002920288663]],
    [ "1177184474",[-80.62804622773567, 33.33670968074766]],
    [ "1177184475",[-80.62863684124108, 33.33657443527989]],
    [ "1177184477",[-80.6969395646667, 33.34527850837712]],
    [ "1177184478",[-80.69648090837569, 33.345484907214725]],
    [ "1177184510",[-80.68252474670138, 33.314328519836124]],
    [ "1177184511",[-80.6822041607434, 33.31465607919999]],
    [ "1177221225",[-92.62267515816235, 30.878762174670047]],
    [ "Pine Prairie Energy Center, LLC",[-92.4421165827095, 30.74928293402603]],
    [ "Marathon Pipe Line LLC",[-93.02670907545526, 30.8413280647969]],
    [ "1177229245",[-92.9942425, 41.11798580000001]],
    [ "Oberlin Substation",[-92.75771711597163, 30.629698145826282]],
    [ "Louisiana Department of Public Safety & Corrections",[-92.79368519999998, 30.5614548]],
    [ "Kinder Casino Substation",[-92.81968311479427, 30.54423468107133]],
    [ "Boise Cascade, LLC",[-92.6763635, 30.7837183]],
    [ "1177260491",[-92.60771508237701, 30.4765946342615]],
    [ "CLECO",[-92.64716185034563, 30.83241481877401]],
    [ "Glenmora Substation",[-92.59837728446873, 30.973914082288648]],
    [ "Forest Hill Substation",[-92.51372176702192, 31.056238593735017]],
    [ "1177280562",[-92.64410329168415, 31.126861958574224]],
    [ "Brown's Corner Sub",[-91.53876810661522, 41.26022747116096]],
    [ "Crescent Midstream, LLC",[-92.0440804729393, 30.40209195479483]],
    [ "Sunset Substation",[-92.05983778632037, 30.412605567106873]],
    [ "1177324908",[-92.082819, 30.518511250000003]],
    [ "Sellers Road Substation",[-92.12618833056493, 30.131801528001148]],
    [ "NW Electric Power Cooperative",[-93.51986333845515, 39.83326415708601]],
    [ "Northern Lights Substation",[-89.55423141671267, 43.012145723659444]],
    [ "Central City Substation",[-87.1285651, 37.29832425]],
    [ "Central City South Substation",[-87.12362914999999, 37.288049650000005]],
    [ "Suttons Bay Substation",[-85.64721165, 44.965360149999995]],
    [ "Marathon Pipe Line LLC",[-90.79930482735412, 30.62681719111326]],
    [ "Marathon Pipe Line LLC",[-90.23781779999999, 32.80648025000001]],
    [ "Entergy Mississippi",[-90.40202335886734, 32.428837280974385]],
    [ "DTE Energy",[-83.24135255749765, 43.8719901248384]],
    [ "Florida Station",[-74.24679694658303, 42.9357095566804]],
    [ "French Mountain Station",[-73.6954167738508, 43.36948745030778]],
    [ "Great Escape Substation",[-73.68487982327485, 43.34972294680026]],
    [ "Monroe Substation",[-74.45628986416843, 40.336439256861965]],
    [ "1177973759",[-91.7810336403029, 38.55404971750266]],
    [ "Comstock Station",[-73.41225047210747, 43.46076383645373]],
    [ "1178024704",[-91.18881375580584, 29.692011968982825]],
    [ "Yokley Road Substation",[-91.5374267186629, 29.815016139382603]],
    [ "CLECO",[-91.50353129003074, 29.793328327609213]],
    [ "CLECO",[-91.50323196666882, 29.784806248665376]],
    [ "Baldwin Substation",[-91.55078904435311, 29.836593882122028]],
    [ "Charenton Substation",[-91.52853962659869, 29.891037360701162]],
    [ "Shell Pipeline Company LP",[-91.65176915, 29.847465400000004]],
    [ "Duboin Substation",[-91.85963534490077, 29.948328511988418]],
    [ "Bayou Warehouse Substation",[-91.79537987718402, 29.821407110191174]],
    [ "Verdunville Substation",[-91.40292836856858, 29.751647736712066]],
    [ "1178108101",[-91.46530463226436, 29.687226642532238]],
    [ "1178108104",[-91.47250760041042, 29.684546866562165]],
    [ "1178108109",[-91.45592895200133, 29.683030618583246]],
    [ "1178108110",[-91.45533222427414, 29.683321859575997]],
    [ "1178108111",[-91.45531397307434, 29.682542187145007]],
    [ "1178108112",[-91.53269086678384, 29.63163295045351]],
    [ "1178108114",[-91.5383025, 29.616773750000004]],
    [ "1178108115",[-91.47039604761082, 29.684709666794532]],
    [ "SLEMCO",[-91.85795521666586, 30.319924900028063]],
    [ "Arnaudville Substation",[-91.94489937727609, 30.410483296525648]],
    [ "Beauregard Electric Cooperative",[-93.04681630000002, 30.671131549999995]],
    [ "CLECO",[-93.2376934175011, 30.5939164413025]],
    [ "DAPL-ETCO Operations Management, LLC",[-93.23820631726643, 30.593862053141617]],
    [ "Beauregard Electric Cooperative",[-93.23796069766493, 30.594762631229123]],
    [ "Trunkline Gas Company, LLC",[-93.22815069999999, 30.595378049999997]],
    [ "Beauregard Electric Cooperative",[-93.23367072009904, 30.415315050154913]],
    [ "1178203371",[-92.18231572067461, 32.49589803726976]],
    [ "Lafayette Substation",[-85.31753052492147, 40.96159708695181]],
    [ "1178310994",[-96.43312820512409, 43.19999094724201]],
    [ "Chestertown Station",[-73.80878323302043, 43.652579556933986]],
    [ "1178437041",[-93.30287799411413, 30.223600014770206]],
    [ "1178437042",[-93.30280354242821, 30.22305545008755]],
    [ "1178457276",[-74.05884809935355, 43.68260700515098]],
    [ "1178487384",[-97.15132154560146, 32.73452420286564]],
    [ "1178489462",[-74.11529429640115, 43.7314331627367]],
    [ "1178489463",[-74.11398230428676, 43.734766785047114]],
    [ "National Grid",[-74.07964208374922, 43.76322069919031]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.72018016714357, 37.82149822562445]],
    [ "Altamaha EMC",[-82.8436956540104, 32.56811106780791]],
    [ "1178542716",[-93.3527250168395, 30.28836163350481]],
    [ "1178542718",[-93.34970491354903, 30.32631540428127]],
    [ "Denbury Gulf Coast Pipelines, LLC",[-93.35212973703383, 30.32651706955277]],
    [ "1178542725",[-93.29296118869345, 30.262457782162077]],
    [ "1178542726",[-93.29348335774864, 30.262194182996414]],
    [ "1178542729",[-93.28322257515657, 30.246256010340336]],
    [ "1178542731",[-93.27543247512801, 30.25159555796296]],
    [ "Maplewood Substation",[-93.31747385, 30.23446405]],
    [ "Hollywood Substation",[-93.34258911231679, 30.22716514910681]],
    [ "Burton Substation",[-93.38980382636068, 30.241441438853972]],
    [ "Dixie Pipeline Company LLC",[-93.36598214583884, 30.265191393223756]],
    [ "1178542749",[-93.55744028422397, 30.16529791479935]],
    [ "1178542754",[-93.30948459502225, 30.251657328787953]],
    [ "1178542755",[-93.29320430573244, 30.24640035369793]],
    [ "Indian Lake Station",[-74.26428564999999, 43.777918549999995]],
    [ "Westlake Chemical Corporation",[-93.28555519999999, 30.2211863]],
    [ "1178561582",[-93.28416400234406, 30.221315270075117]],
    [ "Westlake Chemical Corporation",[-93.280477490466, 30.222226417630665]],
    [ "Westlake Chemical Corporation",[-93.29395117455894, 30.225508547161457]],
    [ "1178561604",[-93.31732995810705, 30.197238375022216]],
    [ "1178561605",[-93.32375875033323, 30.197127197924875]],
    [ "Entergy Louisiana",[-93.33865267518334, 30.21107509293119]],
    [ "Indorama Ventures Olefins LLC",[-93.32590527057624, 30.19403725957907]],
    [ "Westlake Chemical Corporation",[-93.32601392985235, 30.194687131672243]],
    [ "Citgo Substation",[-93.32713579296875, 30.183386046148925]],
    [ "1178561666",[-93.32989570037988, 30.186028772245663]],
    [ "1178561669",[-93.32344582566166, 30.193556467621484]],
    [ "1178599768",[-90.33993705, 38.18092195]],
    [ "1178599771",[-90.23400714681152, 38.52906487217923]],
    [ "1178599772",[-90.232653134444, 38.530421145262004]],
    [ "Henry Street Station",[-73.64426091772874, 43.30483407944482]],
    [ "1178601133",[-73.6402221145646, 43.30535243139142]],
    [ "Catalyst Substation",[-93.35117042202725, 30.15824049975192]],
    [ "Vincent Substation",[-93.28109131064654, 30.15333197498802]],
    [ "Citgo Petroleum Corporation",[-93.34291562498532, 30.17926039156122]],
    [ "Targa Midstream Services LLC",[-93.3493307, 30.159824450000006]],
    [ "W.R. Grace & Co.",[-93.34185314213607, 30.15534357504014]],
    [ "Contank Substation",[-93.33928895000001, 30.1582027]],
    [ "Phillips 66 Partners LP",[-93.33923641498794, 30.159044631844008]],
    [ "W.R. Grace & Co.",[-93.3393005749978, 30.156743758759607]],
    [ "Phillips 66 Partners LP",[-93.33175815816043, 30.15784752454518]],
    [ "Rain CII Carbon LLC",[-93.33824462524656, 30.147159407251973]],
    [ "1178621418",[-93.34822797434957, 30.062792866329296]],
    [ "Hackberry Substation",[-93.35189811842027, 29.991769914471316]],
    [ "Shell Pipeline Company, LP",[-93.40156899236912, 30.123189198285797]],
    [ "Maddox substation",[-103.30200480444113, 32.71354569990642]],
    [ "Johnsons Bayou Substation",[-93.62853890384207, 29.761693859982536]],
    [ "Holly Beach Substation",[-93.46781347409107, 29.770889393879546]],
    [ "Fulton Substation",[-93.29186721851131, 29.787765324788886]],
    [ "US Department of Energy",[-93.4037237872402, 30.001770080651905]],
    [ "1178722227",[-93.39444022510165, 29.994016656497756]],
    [ "Targa Field Services LLC",[-93.15908783450135, 30.27417302568801]],
    [ "1178722241",[-93.00617255655456, 30.258765828894116]],
    [ "1178722244",[-92.91161501934799, 30.33651856300589]],
    [ "Beauregard Electric Cooperative",[-92.8085794, 30.48139305]],
    [ "1178722253",[-92.70490604794512, 30.488323322669004]],
    [ "1178722257",[-92.70598649999998, 30.465018849999996]],
    [ "1178722258",[-92.7411851, 30.33552175]],
    [ "1178722263",[-92.869761213582, 30.49434517859693]],
    [ "Entergy Louisiana",[-92.82701940803675, 30.303645974848205]],
    [ "Colonial Pipeline Company",[-92.82543852484429, 30.304266457275173]],
    [ "1178737281",[-93.37990199999999, 30.19379077795823]],
    [ "1178753516",[-89.93874916947374, 38.534532022444935]],
    [ "1178753523",[-89.89734234546737, 38.6852115149599]],
    [ "1178753541",[-89.93757194373029, 38.71256693589082]],
    [ "1178753544",[-89.93689983585473, 38.683917445390556]],
    [ "1178753545",[-89.93761910999473, 38.682723093431605]],
    [ "1178753553",[-90.04268420783998, 38.73763761275607]],
    [ "1178753557",[-90.03409809342358, 38.83080299711557]],
    [ "1178753559",[-90.03412581451542, 38.8316452982922]],
    [ "1178755503",[-90.0932214, 38.824256500000004]],
    [ "City of Rayne",[-92.27245131327201, 30.234962825116696]],
    [ "CLECO",[-92.42338305000001, 30.485764550000003]],
    [ "CLECO",[-92.44070057513756, 30.501621742774077]],
    [ "CLECO",[-92.52643927518396, 30.488150208016883]],
    [ "CLECO",[-92.41308635000001, 30.495097200000004]],
    [ "CLECO",[-92.42381367490756, 30.500971204670144]],
    [ "CLECO",[-92.4284024086623, 30.55373557481491]],
    [ "Transcontinental Gas Pipe Line Company, LLC",[-92.43132991260873, 30.574945920655644]],
    [ "Mamou Substation",[-92.43065123975698, 30.62681622519871]],
    [ "CLECO",[-92.40703785, 30.641448649999997]],
    [ "CLECO",[-92.39788345, 30.693038750000003]],
    [ "CLECO",[-92.39468319555877, 30.196828571305826]],
    [ "CLECO",[-92.36243126334257, 30.196877544662136]],
    [ "CLECO",[-92.38332315990131, 30.209799268135924]],
    [ "CLECO",[-92.37687928158729, 30.226941052985016]],
    [ "CLECO",[-92.37475190000002, 30.20617275]],
    [ "1179572586",[-92.36825817521529, 30.208651853636248]],
    [ "CLECO",[-92.38953910000001, 30.498253999999996]],
    [ "1179586663",[-90.17490412049557, 38.6588548925062]],
    [ "Burgoyne Avenue Station",[-73.56444643896438, 43.31455358361334]],
    [ "1179700371",[-95.60062787888528, 41.85864122502737]],
    [ "1179701473",[-73.58727145, 42.96649155]],
    [ "1179701475",[-73.58670299999999, 42.96294685]],
    [ "Dominion Renewable Energy",[-78.0396659812895, 38.0148008290259]],
    [ "Virginia Electric and Power Company",[-78.03881973304536, 38.01501594996281]],
    [ "NW Electric Power Cooperative",[-93.54489092829255, 39.83297750262706]],
    [ "1179815776",[-97.81049051190614, 30.584772591662883]],
    [ "1179815778",[-97.7823900074434, 30.544259724414882]],
    [ "Schaghticoke Station",[-73.61313938412638, 42.89905192331649]],
    [ "1179845251",[-92.1323843262179, 37.738351997588545]],
    [ "Puerto Rico Electric Power Authority",[-65.44404590342776, 18.14292752040058]],
    [ "1179886316",[-81.68811265046705, 39.40420569026199]],
    [ "North Cottonport Substation",[-92.04915436481923, 30.99518285618784]],
    [ "South Cottonport Substation",[-92.04880170955202, 30.974093525143186]],
    [ "1179983957",[-89.85229408535915, 38.38303284506043]],
    [ "1179983962",[-89.774020831965, 38.36947409656297]],
    [ "1179983965",[-89.8474322389936, 38.30356492461424]],
    [ "1179983971",[-90.00272473522598, 38.52063230721193]],
    [ "1179983975",[-90.10118576613071, 38.54377326716306]],
    [ "Asbury Park Substation",[-74.01376755877271, 40.21972563155813]],
    [ "1180153979",[-74.03768610022269, 40.210356477762886]],
    [ "CLECO",[-92.08144182269211, 31.108741645141688]],
    [ "CLECO",[-92.06564451651792, 31.125158949205023]],
    [ "Alexandria Utility System",[-92.47608569151593, 31.307105397745403]],
    [ "Sherwood Substation",[-92.48118498475746, 31.416937582034123]],
    [ "Poplar Substation",[-74.04341312616569, 40.26674928749047]],
    [ "Locust Grove Substation",[-74.05426009557637, 40.28515865078055]],
    [ "CLECO",[-92.48006305000001, 31.41673395]],
    [ "1180375333",[-92.41510425000003, 31.375093200000002]],
    [ "1180375357",[-92.41584316050594, 31.369544974552166]],
    [ "The Procter & Gamble Manufacturing Company",[-92.41311090180662, 31.366198479163923]],
    [ "CLECO",[-92.4077756, 31.380404749999993]],
    [ "CLECO",[-92.4046260235287, 31.350924036783315]],
    [ "CLECO",[-92.38224642367743, 31.33562336431119]],
    [ "Ester Field Substation",[-92.29646310000001, 31.378431150000004]],
    [ "CLECO",[-92.27832938476442, 31.24874537291662]],
    [ "Effie Substation",[-92.1653161680971, 31.225206507667412]],
    [ "CLECO",[-92.37353142477959, 31.315829142628782]],
    [ "CLECO",[-92.4180613692684, 31.326803010733048]],
    [ "CLECO",[-92.42014258336428, 31.316325545769082]],
    [ "CLECO",[-92.23500622858903, 31.388548092836256]],
    [ "Deville Substation",[-92.16438070000001, 31.3573919]],
    [ "CLECO",[-92.39699353022205, 31.55221130831308]],
    [ "CLECO",[-92.40355040545262, 31.517742902606248]],
    [ "Bentley Substation",[-92.49502962967831, 31.513973041453436]],
    [ "Webster Street Substation",[-92.43580127930959, 31.322812666412375]],
    [ "CLECO",[-92.43929750537697, 31.323596717688293]],
    [ "Louisiana College Substation",[-92.4282533, 31.324152000000005]],
    [ "Alexandria Utility System",[-92.45017738407307, 31.311229783063318]],
    [ "Alexandria Utility System",[-92.4330067665301, 31.27852954960228]],
    [ "Alexandria Utility System",[-92.44918056879365, 31.2724438198925]],
    [ "Alexandria Utility System",[-92.47083856296527, 31.27321104699375]],
    [ "1180465663",[-92.4711991, 31.272833699999996]],
    [ "CLECO",[-92.43515404999998, 31.34009425]],
    [ "CLECO",[-92.43956181440115, 31.358489264075004]],
    [ "Hornbeck Substation",[-93.38120545726999, 31.3214393125885]],
    [ "Southwestern Electric Power Company",[-93.26815548453492, 31.029813782317333]],
    [ "1180612559",[-93.1598912042277, 31.114916282154876]],
    [ "1180612567",[-93.27392739999999, 31.148288299999994]],
    [ "1180612569",[-93.25959259999999, 31.14673705]],
    [ "1180693815",[-93.26730425, 30.84407945]],
    [ "1180693818",[-93.26336226558819, 30.84715293606402]],
    [ "Roy O. Martin Lumber Company, L.L.C.",[-92.86102748119265, 31.500779671645187]],
    [ "Flatwood Substation",[-92.8529882762362, 31.40850975735883]],
    [ "Paul Grimshaw Substation",[-113.65337449149432, 37.14696458189195]],
    [ "1180905628",[-104.41238235, 32.85758005]],
    [ "1180905644",[-104.39516682520275, 32.79921420866492]],
    [ "Concordia Electric Cooperative",[-92.03336689788792, 31.62467277797926]],
    [ "Concordia Electric Cooperative",[-92.14177461284346, 31.59093189352395]],
    [ "Concordia Electric Cooperative",[-91.85291072503915, 31.628975157250228]],
    [ "Concordia Electric Cooperative",[-91.82496302970688, 31.71862355568379]],
    [ "Concordia Electric Cooperative",[-91.70446421872106, 31.829692341739317]],
    [ "Ball Substation",[-92.41220637530702, 31.418755742849278]],
    [ "Concordia Electric Cooperative",[-91.72519489949092, 31.4663887020285]],
    [ "1180945284",[-91.7805677, 31.37431155]],
    [ "1180945295",[-91.62049813196484, 31.08871369811982]],
    [ "Concordia Electric Cooperative",[-91.5780044309736, 31.625025913018423]],
    [ "Concordia Electric Cooperative",[-91.53579128228999, 31.473341167531505]],
    [ "1180969782",[-91.81366364995831, 32.04707827996555]],
    [ "Linwood Substation",[-83.11382556531213, 42.38059880541544]],
    [ "Swartz Substation",[-91.9962505296785, 32.5725998888321]],
    [ "1180990988",[-87.81559221053207, 37.712697123519355]],
    [ "Cotton Substation",[-92.23611283511724, 32.41169045489647]],
    [ "Cadeville Substation",[-92.33029478727589, 32.43643683072173]],
    [ "1181008427",[-92.08852943427598, 32.49875128752698]],
    [ "1181008438",[-92.09620105093937, 32.52265195389517]],
    [ "VFT Station Substation",[-74.21210845444236, 40.63412327145512]],
    [ "Sewaren 7",[-74.24894718637346, 40.55658648124679]],
    [ "First Street Substation",[-74.19155569557869, 40.64633846827054]],
    [ "Angus Chemical Company",[-92.0800501, 32.68975045]],
    [ "Entergy Louisiana",[-92.21617628603798, 32.53988635907545]],
    [ "Oak Ridge Substation",[-91.78867077101411, 32.575042272827716]],
    [ "DAPL-ETCO Operations Management, LLC",[-91.57615459999998, 32.62194835]],
    [ "Entergy Louisiana",[-91.77075509008769, 32.84334435992954]],
    [ "1181134504",[-91.90540820350499, 32.79859213265965]],
    [ "1181134511",[-91.87030469838437, 32.95953755595656]],
    [ "1181134540",[-91.95117485914828, 33.05910064872048]],
    [ "Entergy Arkansas",[-91.94933415000001, 33.098823700000004]],
    [ "Crossett West Substation",[-91.98326421368701, 33.121898930812115]],
    [ "1181134554",[-92.2417083240529, 32.893304519727515]],
    [ "Entergy Louisiana",[-92.59726974412041, 32.579356994132766]],
    [ "City of Ruston",[-92.63036334747777, 32.56718161644556]],
    [ "City of Ruston",[-92.64347306602662, 32.568357825346666]],
    [ "City of Ruston",[-92.65151621936866, 32.555886055954566]],
    [ "City of Ruston",[-92.66542543364554, 32.53035255533982]],
    [ "City of Ruston",[-92.63014606865488, 32.497185370997634]],
    [ "City of Ruston",[-92.61282892972076, 32.52780456199585]],
    [ "1181226173",[-74.24066120021716, 40.609131367203666]],
    [ "1181226174",[-74.2412681665953, 40.60789272780704]],
    [ "Rahway Substation",[-74.27245537085548, 40.608608032608316]],
    [ "1181226176",[-74.26714169353096, 40.60096390287169]],
    [ "1181226206",[-74.25274953844516, 40.561321025548736]],
    [ "1181226209",[-75.0641538844215, 39.91440736096911]],
    [ "1181226210",[-74.24892718103912, 40.5658715005789]],
    [ "1181226211",[-74.25092824842011, 40.56304760435122]],
    [ "White Horse/Clinton Ave",[-74.71694467071188, 40.195915241281995]],
    [ "Port Murray Substation",[-74.91661654640046, 40.783859948713584]],
    [ "Broadway Substation",[-75.04520500595292, 40.72425151943605]],
    [ "Jersey Central Power and Light",[-75.06959534925605, 40.8415528219396]],
    [ "1181226217",[-75.01578836442809, 40.81731799991296]],
    [ "Pequest Road Substation",[-74.98024711337065, 40.82557212152135]],
    [ "Jersey Central Power and Light",[-75.06838928867579, 40.84423795915182]],
    [ "Jersey Central Power and Light",[-75.06864468570393, 40.8415203339957]],
    [ "Bernice Substation",[-92.68723514644006, 32.815127169561336]],
    [ "Bernice East Substation",[-92.63867062473203, 32.82114150648968]],
    [ "1181268956",[-92.66025348839946, 32.81037536017258]],
    [ "Elizabeth Substation",[-74.21840974256521, 40.66436885325179]],
    [ "Roselle Substation",[-74.25950805457963, 40.64818172016616]],
    [ "Ryze Renewables Las Vegas, LLC",[-115.0613648985791, 36.26518988128128]],
    [ "Enterprise Products Operating, LLC",[-93.06626567522163, 32.29136623930007]],
    [ "1181588521",[-93.27846115828456, 32.276155404951794]],
    [ "Entergy Louisiana",[-92.8601224749122, 32.57354144765988]],
    [ "ETC PennTex LLC",[-92.85938558503167, 32.573538931475866]],
    [ "1181743667",[-93.22508901515359, 32.63388986343574]],
    [ "1181743668",[-93.18936175855437, 32.50082234418894]],
    [ "Claiborne Electric Cooperative",[-93.27924039996341, 32.42534051871777]],
    [ "1181743676",[-93.04491625313268, 32.78663047184569]],
    [ "Claiborne Electric Cooperative",[-92.95693236979214, 32.72644709542768]],
    [ "1181743688",[-93.2861157857823, 32.59655652476084]],
    [ "City of Minden",[-93.27141477522666, 32.617195962155876]],
    [ "1181772560",[-93.46044285, 32.9698316]],
    [ "Entergy Arkansas",[-93.38504284999999, 33.0918953]],
    [ "Coushatta Substation",[-93.34452711315056, 32.019627755631106]],
    [ "Glenwood Substation",[-123.03459659012121, 44.03563122956209]],
    [ "Cozy Lake Substation",[-74.4928942083695, 41.02839061334402]],
    [ "Loreauville Substation",[-91.7353742, 30.06437345]],
    [ "CLECO",[-91.82528850039516, 30.01999211258371]],
    [ "CLECO",[-91.82576782746804, 30.015773958389516]],
    [ "Corinne Street Substation",[-91.83245135, 30.003641150000004]],
    [ "CLECO",[-91.82623684322553, 30.00460308381951]],
    [ "1181938635",[-91.82070239999999, 30.009348300000003]],
    [ "CLECO",[-91.81826065625378, 30.0005649116211]],
    [ "CLECO",[-91.82368056929306, 29.99559916588019]],
    [ "1181938643",[-91.80154866332077, 29.99805204077818]],
    [ "CLECO",[-91.78342928951325, 29.98772957409344]],
    [ "Olivier Substation",[-91.75877068167318, 29.978331395665045]],
    [ "Hubertville Substation",[-91.68170040376788, 29.92536533303836]],
    [ "Bloomfield Switching Station",[-92.10498469303312, 30.303921196809203]],
    [ "1181970457",[-92.15724750069269, 30.300274056215613]],
    [ "Entergy Louisiana",[-93.3385471821908, 30.036991811588507]],
    [ "Cameron LNG, LLC",[-93.33834610919807, 30.036381214593362]],
    [ "Cameron LNG, LLC",[-93.3384768858207, 30.046362829833395]],
    [ "Entergy Louisiana",[-93.3394256907048, 30.04633232523013]],
    [ "1181979250",[-92.71342620000001, 31.401206750000004]],
    [ "Crossroads Substation",[-92.21698132155075, 32.71345959600804]],
    [ "Farmerville Substation",[-92.3790567920163, 32.786996745075]],
    [ "1182094686",[-111.31092408878195, 34.23880082468515]],
    [ "Curtis Substation",[-83.21971543287023, 42.423004075436936]],
    [ "Turner Substation",[-83.14933305000001, 42.416439749999995]],
    [ "West End Substation",[-83.11631093036726, 42.29508453889533]],
    [ "Decatur Substation",[-83.1791894340644, 42.35098762555886]],
    [ "Madison Substation",[-83.0446604773056, 42.33828918903629]],
    [ "CATO Substation",[-83.05739198671262, 42.33532969443881]],
    [ "1182332389",[-94.366138824436, 38.07597160660466]],
    [ "1182341115",[-74.15595109895668, 40.44315631203284]],
    [ "Middlebury Substation 1",[-85.69760379172884, 41.7260680848571]],
    [ "1182440391",[-89.93895581243821, 32.43994957138093]],
    [ "1182486640",[-86.69752576401704, 41.61858661575748]],
    [ "1182513154",[-90.06045592126274, 30.568945112770905]],
    [ "1182513165",[-90.07454139687573, 30.57814658948787]],
    [ "Lincoln Park Substation",[-74.30308345696876, 40.92526942870414]],
    [ "Drew Substation",[-74.39699009591477, 40.91032018014635]],
    [ "Denville Substation",[-74.48333270328402, 40.89256561898523]],
    [ "Jacksonville Substation",[-74.34184251380367, 40.93404977572396]],
    [ "Taylortown Substation",[-74.39948557967514, 40.93276979361212]],
    [ "Davis Switch Point",[-74.46943244597148, 40.843826940150606]],
    [ "Alderney Substation",[-74.4664769818726, 40.8466403561974]],
    [ "1182597227",[-124.39023485999802, 47.94671637721203]],
    [ "Shell Pipeline Company, L.P.",[-92.06917150487064, 29.896451424511255]],
    [ "1182650530",[-92.0684131114211, 29.934296332592492]],
    [ "1182676651",[-93.23508199393751, 38.97820755213412]],
    [ "FIXME Substation",[-94.43603461278722, 38.588798836575236]],
    [ "FIXME Substation",[-94.41837444765989, 38.39612617600084]],
    [ "1182680726",[-93.97306582486917, 38.072791944649374]],
    [ "1182680728",[-93.88330726290107, 37.873766630298896]],
    [ "1182683694",[-92.54663954086044, 38.3746647712336]],
    [ "1182683696",[-92.27973453579835, 38.47412032193972]],
    [ "1182685920",[-92.64991538295605, 37.70123686232013]],
    [ "1182685925",[-92.63328634999999, 37.743269149999996]],
    [ "1182776846",[-94.03255149449505, 37.82812915650126]],
    [ "South Amboy Sub",[-74.28789529115411, 40.490439401158696]],
    [ "Drakestown Substation",[-74.78471525683173, 40.85008035799552]],
    [ "1182803014",[-93.66097987546776, 38.30626844490004]],
    [ "Williams Substation",[-74.31658891093376, 40.44098804583075]],
    [ "1183385252",[-92.822238284174, 37.98989196110528]],
    [ "1183388374",[-92.65070555, 37.701229749999996]],
    [ "1183528614",[-95.39463210217833, 41.98969891680484]],
    [ "1183528619",[-95.48920002434613, 41.93217129617675]],
    [ "1183528623",[-95.42159291783624, 41.77343793448755]],
    [ "1183528626",[-95.42194671699006, 41.66019236652352]],
    [ "Jersey Central Power and Light",[-74.31563656857428, 40.36201219480828]],
    [ "Neptune Substation",[-74.03227961782456, 40.20288366136128]],
    [ "Arcola Substation",[-93.8541062, 37.61470265]],
    [ "AEP South Bend Substation",[-86.20022881820222, 41.69571105875106]],
    [ "1184066763",[-94.60232529843472, 39.32215429147979]],
    [ "1184091351",[-93.7047502, 37.248335]],
    [ "1184091352",[-93.94622813948158, 37.21347267487487]],
    [ "1184091353",[-93.91465718702825, 37.089044174839266]],
    [ "Jersey Central Power and Light",[-74.11847032495297, 40.257951414832576]],
    [ "1184364460",[-74.12333695482288, 40.26045988176636]],
    [ "Altair Switching Station",[-77.55802157176683, 39.06403262419881]],
    [ "Darden Substation",[-86.25258222492661, 41.73309184389044]],
    [ "1184569717",[-86.00854384999998, 34.0070504]],
    [ "1184626806",[-91.12610677633788, 37.63763494186334]],
    [ "1184626808",[-91.13137910753571, 37.6364010165463]],
    [ "1184626813",[-91.12376672480822, 37.605983344114435]],
    [ "1184627516",[-91.60323842552539, 38.078978545234584]],
    [ "1184627517",[-91.5251938, 38.044741]],
    [ "1184667433",[-93.25876935936822, 37.108208459077844]],
    [ "Lincoln Park Substation",[-77.4279168402161, 38.92429600984327]],
    [ "Hayti Substation",[-74.53440953053548, 40.18310954174303]],
    [ "Harts Lane Substation",[-74.40666239650301, 40.44304716470642]],
    [ "1184743628",[-77.15738536093814, 38.918299330347956]],
    [ "1184823223",[-103.60780217469619, 32.98058690318927]],
    [ "Raymore Substation",[-94.45871419241719, 38.78283426685904]],
    [ "1184833876",[-94.08882243743713, 38.78790903079254]],
    [ "1184833878",[-94.06963248002077, 38.741477542766305]],
    [ "1184833881",[-93.98592243248831, 38.71821567508699]],
    [ "1184857986",[-93.69163827390301, 37.47643135960491]],
    [ "1184861058",[-96.27417844326207, 40.712020043955874]],
    [ "1184861060",[-95.98727637505252, 40.75488050308971]],
    [ "1184897783",[-93.00877627537733, 36.588231242244525]],
    [ "1184900156",[-85.70145826326632, 37.95308142799521]],
    [ "Jersey Central Power and Light",[-74.46717947253009, 40.26581997708193]],
    [ "Rosemont Substation",[-74.98321954321399, 40.444641788540146]],
    [ "Jersey Central Power and Light",[-74.98932391403336, 40.51507653501126]],
    [ "1184905261",[-108.5889783600152, 39.87815081740878]],
    [ "1184905263",[-108.66633705794143, 40.152685466570496]],
    [ "1184905265",[-108.72847031922532, 40.167058906924666]],
    [ "Dunn Street Substation",[-86.52775062359149, 39.175600079961484]],
    [ "1185076193",[-82.73128646054306, 43.44675157452153]],
    [ "Mill Grove Substation",[-85.87997427958732, 42.55634674171251]],
    [ "1185196431",[-86.1078747394697, 41.78176781584836]],
    [ "1185196483",[-92.128419755247, 38.17160326719646]],
    [ "1185381250",[-96.73774133072317, 40.83559253469772]],
    [ "Blue Ridge EMC",[-81.4066413654781, 35.99928002522039]],
    [ "1185514135",[-81.99697925527086, 28.754872898184214]],
    [ "CR 672 Substation",[-82.26212324023686, 27.765089397369113]],
    [ "Bruce Substation",[-89.33093074386777, 33.995288949883694]],
    [ "1185958972",[-80.86838093613335, 40.07757711793861]],
    [ "1185960126",[-80.80964876686501, 40.13248409893194]],
    [ "1186198621",[-85.50627916748358, 37.73743032572884]],
    [ "1186198622",[-85.51655946914613, 37.80711634603963]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.44566581959165, 37.81762096333091]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.46732544223039, 37.833558621966915]],
    [ "1186198643",[-85.4029365, 37.94336215]],
    [ "Mannington Mills Substation",[-75.45252768722366, 39.58266948272993]],
    [ "Quinton Substation",[-75.41010756992826, 39.54904080484943]],
    [ "Williamstown Substation",[-75.00006248256577, 39.682593767530285]],
    [ "Henderson Road Substation",[-90.03699523377331, 32.319205100917664]],
    [ "Old Home Manor Substation",[-112.42923728529328, 34.78976153168624]],
    [ "1186514437",[-90.1246593147629, 44.48275355062346]],
    [ "1186515883",[-89.80867937508486, 44.51166329230322]],
    [ "1186518606",[-90.1492322360416, 44.64695612046523]],
    [ "1186579982",[-89.78751016889446, 44.30736109346054]],
    [ "1186579984",[-89.79727575501808, 44.12616548670293]],
    [ "1186922064",[-90.0827902249986, 43.63409634415672]],
    [ "1186949694",[-89.91901851201962, 43.175737330349605]],
    [ "1186949704",[-89.74966440548292, 43.134267357818594]],
    [ "1186949706",[-89.65090131000056, 43.09735847843092]],
    [ "1186950277",[-89.71095006105926, 43.01895942143088]],
    [ "1187057848",[-96.16291764960233, 42.79768110067064]],
    [ "Highland Substation",[-90.34513027526341, 42.99900288449734]],
    [ "1187065349",[-90.4412977111388, 42.950949910064836]],
    [ "1187065353",[-90.705894, 42.84829915]],
    [ "1187065945",[-90.61611690000001, 42.47660605]],
    [ "1187065948",[-90.61007121808885, 42.46998460631182]],
    [ "Chino Valley Substation",[-112.46581501077175, 34.753123878932804]],
    [ "1187291912",[-91.25495432494787, 42.77759530731649]],
    [ "1187291913",[-91.41611213779554, 42.77286472546639]],
    [ "1187291914",[-91.11045237206035, 42.79075003295832]],
    [ "1187291917",[-91.24048282543795, 42.86337790541884]],
    [ "1187301146",[-95.92671948943537, 40.05993496994856]],
    [ "New River Light & Power",[-81.67601256869807, 36.20952211166433]],
    [ "Egg Harbor Substation",[-74.65260792000616, 39.530657305066704]],
    [ "New Bloomfield Substation",[-77.16309466648838, 40.43100314931099]],
    [ "1187506576",[-103.32158188854059, 34.17796987477179]],
    [ "1187506581",[-103.37887550068648, 34.173844584832665]],
    [ "Stratford Substation",[-75.00964362842981, 39.82539607231689]],
    [ "Lindenwold Substation",[-74.97727942761246, 39.82144586176982]],
    [ "Dacosta Substation",[-74.77710313460939, 39.61438480594174]],
    [ "Pleasantville Substation",[-74.5291171253674, 39.396911991049556]],
    [ "1187613094",[-102.42770157516026, 34.319547290901305]],
    [ "1187613096",[-102.42808942520676, 34.36503219218622]],
    [ "1187628750",[-86.06920303052435, 40.38275129365346]],
    [ "1187689399",[-112.37954544896184, 33.72695520726538]],
    [ "1187699245",[-86.11290884229908, 40.482613274032445]],
    [ "1187724085",[-120.60560515000002, 37.87666420000001]],
    [ "Winslow Substation",[-74.86368909295662, 39.66032115643063]],
    [ "1187788591",[-72.91325850997374, 43.12740710937726]],
    [ "1187863003",[-119.69401210058348, 36.87309172520344]],
    [ "1187938952",[-86.20517875768525, 40.60572161844053]],
    [ "1187940125",[-86.16022932456582, 40.4713580335257]],
    [ "1187940278",[-86.16023101721699, 40.46395832476444]],
    [ "1187940279",[-86.160854188466, 40.46652625632646]],
    [ "Peapack Substation",[-74.6616455003435, 40.70480211438008]],
    [ "1188097510",[-85.8742438574179, 40.57856687108062]],
    [ "1188100933",[-86.03538653682146, 40.62182354120159]],
    [ "1188271716",[-119.46999793301238, 35.281335033375974]],
    [ "1188344829",[-86.1597988738589, 40.746386595774986]],
    [ "1188345394",[-92.14540726457139, 44.77609888459607]],
    [ "Xcel Energy",[-92.01111812427996, 44.692813919588396]],
    [ "1188450273",[-86.05627897509709, 40.729371608713926]],
    [ "1188457197",[-86.0915187107509, 40.758431475039416]],
    [ "1188462054",[-86.05418235995818, 40.77593892451546]],
    [ "Rush Creek l Substation",[-103.84887601222498, 39.1692717412335]],
    [ "1188473073",[-85.86694340000001, 40.7968429]],
    [ "1188473645",[-85.8748028, 40.794804400000004]],
    [ "1188520651",[-88.14783495, 38.97001485]],
    [ "1188535614",[-86.13289288125549, 40.671515845433376]],
    [ "1188535842",[-86.14760764987939, 40.672567779583034]],
    [ "1188551114",[-84.30503165778751, 37.572367696655945]],
    [ "Limestone Wind Substation",[-96.62195661831429, 31.853445316903585]],
    [ "1188600268",[-97.01631963946672, 31.863353967361224]],
    [ "1188696296",[-86.21333831238924, 41.068009836398616]],
    [ "1188736535",[-86.01855067944506, 41.02364721281148]],
    [ "1188913159",[-85.76510275808855, 40.9867446593794]],
    [ "1188914834",[-85.76629275043106, 40.99472142587707]],
    [ "1188915965",[-85.78182568130259, 40.99792022480019]],
    [ "1188920779",[-85.78429738545071, 41.00626151530705]],
    [ "1188959733",[-85.78385656093396, 40.94888127475266]],
    [ "1188962208",[-85.68407339999999, 40.9882637]],
    [ "Valero Packing Tap Substation",[-75.25844046360938, 39.839241330316746]],
    [ "1188970526",[-85.59481120000001, 40.929680700000006]],
    [ "1188970527",[-85.50831095974539, 40.9024927145205]],
    [ "1188978110",[-85.4974152391283, 40.87977089142832]],
    [ "1188978111",[-85.49634804655659, 40.88005835628182]],
    [ "1188984315",[-85.73729547509787, 40.83262489513128]],
    [ "1189004819",[-85.4523404, 40.91734785000001]],
    [ "1189005767",[-112.31592676323564, 33.77764186980936]],
    [ "1189011611",[-85.39261930682476, 40.6846003861625]],
    [ "Liberty Center Station",[-85.28470472482465, 40.697456490259924]],
    [ "1189024705",[-85.19575607723283, 40.72776790701396]],
    [ "1189024706",[-85.17326982471273, 40.72893953675367]],
    [ "Wind Farm or ACUA Substation",[-74.44493135625635, 39.38174308324827]],
    [ "Newport Substation",[-75.15497939301618, 39.30828680549301]],
    [ "1189083122",[-74.56099505000002, 40.5839486]],
    [ "Central Substation",[-75.02529900878648, 39.48900493388262]],
    [ "Central North Substation",[-75.02499437936581, 39.4896000148463]],
    [ "Vineland Municipal Electric Utility",[-75.03381920270542, 39.490314707187686]],
    [ "Vineland Municipal Electric Utility",[-75.0333717649261, 39.48886884637325]],
    [ "West Station",[-75.04899045778905, 39.491107765993156]],
    [ "Vineland Municipal Electric Utility",[-75.03763189419183, 39.46039803711436]],
    [ "1189150712",[-85.17309013696506, 40.72941278330681]],
    [ "1189173552",[-85.21714822449556, 40.684218154121524]],
    [ "1189195572",[-84.95830123752799, 40.5706632415169]],
    [ "Evangeline Substation",[-92.58397753510764, 30.257639381791137]],
    [ "1189221381",[-92.51482338431661, 30.074721125995435]],
    [ "1189235159",[-112.72741812501681, 33.747204541340245]],
    [ "1189268151",[-108.29547632999291, 39.83993560056937]],
    [ "1189268153",[-108.29506109999998, 39.84423485]],
    [ "Tennaco Packing Inc Substation",[-75.09836215359174, 39.6665915843206]],
    [ "1189319494",[-87.32071562351295, 38.180977330452016]],
    [ "Elliot Dist. Substation",[-87.47623325792335, 38.12213387067402]],
    [ "Duke Energy",[-87.45625072518692, 38.15057879442758]],
    [ "1189382305",[-85.60592883359074, 41.097265045539686]],
    [ "1189390689",[-85.46554378693622, 41.10434141439552]],
    [ "AEP Richland Substation",[-85.59628385, 41.18356405]],
    [ "Ummel Substation",[-85.45860339630302, 41.2359521625185]],
    [ "AEP Tri-Lakes Substation",[-85.45817859207361, 41.235952932200505]],
    [ "Southwest Substation",[-85.48091961379404, 41.142642913472024]],
    [ "1189433457",[-85.47763597181248, 41.16376328892217]],
    [ "1189435254",[-85.49608119999999, 41.16824114999999]],
    [ "Consumers Energy",[-85.6689866107439, 42.986297425039545]],
    [ "1189682123",[-85.65604646255692, 40.57460704620181]],
    [ "AEP Marion Substation",[-85.65683955886043, 40.5615698806435]],
    [ "1189690625",[-103.77590781406147, 35.81661781389118]],
    [ "Dawkins Branch Substation",[-77.54415859323375, 38.77653310304478]],
    [ "Thunderball Substation",[-77.54080205978848, 39.046735889695796]],
    [ "Northstar Substation",[-77.55366816440298, 38.95180253473774]],
    [ "AEP McClure Substation",[-85.65648379647119, 40.55048897161668]],
    [ "AEP West End Substation",[-85.68220812543441, 40.56427080555826]],
    [ "Facebook Data Center",[-93.5078143224295, 41.67875811446119]],
    [ "AEP Fisher Body Substation",[-85.7023424862259, 40.56117545528794]],
    [ "1189760076",[-85.62182370158651, 40.48945431397047]],
    [ "NW Electric Power Cooperative",[-93.34504607105013, 39.8064651718989]],
    [ "AEP Jonesboro Substation",[-85.62858312507286, 40.48539424192669]],
    [ "Kentucky Utilities Company",[-87.6199055, 37.38160445]],
    [ "AEP Dean Substation",[-85.68094102509401, 40.42203245663589]],
    [ "1189856608",[-85.25737237520428, 40.43569474575649]],
    [ "1189857959",[-85.35926724988501, 40.333333785030206]],
    [ "Pville Substation",[-74.56664606251609, 39.44137895972131]],
    [ "Academy Substation",[-83.73094790283145, 42.285054199457754]],
    [ "Veterans Subtation",[-83.71386756118972, 42.28504515699033]],
    [ "Stein Substation",[-83.29429039470824, 43.763905795671384]],
    [ "1189913630",[-84.97545172625709, 40.44952685110692]],
    [ "1189917725",[-84.96075852462613, 40.462131156992875]],
    [ "1189918723",[-84.95327480908189, 40.51303441958946]],
    [ "1189973797",[-87.01581188780813, 35.46190042309233]],
    [ "1189974852",[-87.01519527192103, 35.20427641291319]],
    [ "Tennessee Valley Authority",[-86.58642348216434, 35.62068859807165]],
    [ "1189977107",[-86.85020813309072, 35.66454673346623]],
    [ "McKinley Substation",[-85.82651753226473, 41.2413602655289]],
    [ "Dubois Transmission Station",[-86.99879218831866, 38.28314655975492]],
    [ "1190005128",[-85.8861151631345, 41.24156667479545]],
    [ "1190009347",[-85.8308684, 41.23564865]],
    [ "Johns Manville Substation",[-74.93925552883613, 39.75880506641697]],
    [ "1190054305",[-85.89225648380888, 41.12301657930915]],
    [ "1190054891",[-85.89660313996372, 41.13091206232516]],
    [ "1190056536",[-85.94776251388284, 41.214829805135416]],
    [ "1190060257",[-86.03998704404324, 41.173710133293824]],
    [ "Arkansas Electric Cooperative Corporation",[-91.02892785000002, 35.25070325]],
    [ "1190104704",[-74.29823811379109, 41.04001968597788]],
    [ "Upton Substation",[-74.54493746682215, 39.939088609670755]],
    [ "New Lisbon Substation",[-74.6556643447044, 39.967392668169374]],
    [ "1190104707",[-74.62243613863365, 40.03235356115129]],
    [ "1190104708",[-74.62362200096499, 40.02584388206043]],
    [ "1190104709",[-74.63561344073293, 39.999194442324374]],
    [ "McGuire Substation",[-74.592128730464, 40.03713182133591]],
    [ "1190175792",[-85.73422679999999, 41.20894129999999]],
    [ "1190178540",[-85.70829365091036, 41.202394782153014]],
    [ "1190179356",[-85.69571930040556, 41.20185753320871]],
    [ "1190183233",[-85.69167001724921, 41.30929635696268]],
    [ "1190194516",[-85.75018949999999, 41.4181278]],
    [ "1190194517",[-85.75366382480877, 41.42054319522401]],
    [ "1190197521",[-85.76145111469451, 41.423132467837114]],
    [ "1190200376",[-87.51075812460724, 46.51213705775685]],
    [ "Warner Road Sub",[-85.71086091334602, 41.423179924720735]],
    [ "Oswego Sub",[-85.79090794520418, 41.321098936426935]],
    [ "1190224861",[-85.85668887650625, 41.292495810045175]],
    [ "1190251236",[-85.85960259682916, 41.43223374639473]],
    [ "1190260885",[-84.10285082126094, 34.27031375158195]],
    [ "Jersey Central Power and Light",[-74.20403490351761, 39.78133534685502]],
    [ "1190407988",[-87.54953266911255, 37.962177525298856]],
    [ "NIPSCO",[-85.82531583509241, 41.54966756028754]],
    [ "Lincolnway",[-85.80417672336162, 41.56542693329688]],
    [ "1190470967",[-85.77017668920895, 41.55240397526012]],
    [ "1190526097",[-115.0852678, 36.023073350000004]],
    [ "1190587775",[-85.8486934394495, 41.5939617702413]],
    [ "Union Avenue Onshore Converter Station (OnCS-DC) (under construction)",[-73.06335734821091, 40.81270520910674]],
    [ "1190620425",[-86.00101855, 41.5347064]],
    [ "1190621727",[-86.01150097478367, 41.5291135530488]],
    [ "1190673729",[-85.81527254713528, 41.71940047794031]],
    [ "1190677612",[-85.78411816069593, 41.73897277503194]],
    [ "1190677613",[-85.78445762578794, 41.73930122965996]],
    [ "1190706317",[-85.92154925838867, 41.68804787075473]],
    [ "1190838783",[-86.01646498197235, 41.669082265038725]],
    [ "McKinstry Substation",[-83.09149126675301, 42.31247429990492]],
    [ "Balfour Substation",[-82.95239919655752, 42.40775352196944]],
    [ "1190900837",[-85.71429565, 41.64976385000001]],
    [ "1190902469",[-85.72104366221558, 41.660996824995856]],
    [ "1190919021",[-85.73566827183107, 41.746369874700406]],
    [ "1190919022",[-85.73465782477768, 41.74634074067434]],
    [ "1190922004",[-85.66577280714918, 41.754827618133795]],
    [ "Phelps",[-77.05657406818689, 42.95911375162753]],
    [ "1191208359",[-85.5984364, 41.611506500000004]],
    [ "1191212098",[-85.55632980000001, 41.65514030000001]],
    [ "1191218192",[-85.57332800000002, 41.6783314]],
    [ "1191221079",[-109.76020663608621, 46.81369882743066]],
    [ "1191222505",[-85.47497382338182, 41.70256095493321]],
    [ "1191225587",[-85.41284716824111, 41.71801297544087]],
    [ "1191240301",[-85.41575734999999, 41.639715149999994]],
    [ "1191254554",[-85.45206631193652, 41.52137611337743]],
    [ "Topeka Sub",[-85.54737696555159, 41.54046096775744]],
    [ "1191262264",[-85.54441719999998, 41.5358283]],
    [ "South Milford Sub",[-85.25262738850722, 41.540686880809695]],
    [ "1191309154",[-85.20257991693087, 41.63485364149125]],
    [ "1191313012",[-111.79540862482293, 47.66942245888708]],
    [ "Grand Electric Cooperative",[-103.64419290771379, 45.80511942495869]],
    [ "1191317195",[-85.21476332489297, 41.722444293440375]],
    [ "1191325589",[-112.42713211704701, 33.217508833633254]],
    [ "1191326293",[-85.17642023081837, 41.72727641285576]],
    [ "1191328035",[-85.05766507488117, 41.72900549197053]],
    [ "1191328714",[-85.1715804378802, 41.69646256962761]],
    [ "1191329163",[-101.26313173739422, 30.90924344266803]],
    [ "1191329506",[-101.46643361701356, 31.799136290994305]],
    [ "1191329509",[-101.29358192054173, 31.73807834798608]],
    [ "1191398651",[-85.14043457489858, 41.634715244116705]],
    [ "1191430018",[-85.00181493952232, 41.6436565213298]],
    [ "1191454806",[-85.17103137529102, 41.53365349370309]],
    [ "1191470739",[-77.52821858333243, 38.94348919381276]],
    [ "1191472834",[-85.03219632507519, 41.54155534363922]],
    [ "East Angola Substation",[-84.9703399623026, 41.621117974609795]],
    [ "1191509985",[-84.92249064999999, 41.7235198]],
    [ "1191509988",[-84.93560448271671, 41.7250460159152]],
    [ "1191510368",[-84.92414360000001, 41.726102049999994]],
    [ "1191513494",[-84.96700054435927, 41.687193742896746]],
    [ "Artesian Substation",[-83.22459073902749, 42.38006106855327]],
    [ "Yampa Valley Electric",[-106.83193129424082, 40.48017585319792]],
    [ "Yampa Valley Electric",[-107.1265663, 40.423271299999996]],
    [ "Yampa Valley Electric",[-107.12458491787166, 40.42517925956681]],
    [ "Explorer Substation",[-83.2284762995456, 42.30028815928244]],
    [ "1191523143",[-108.50652570320065, 38.2137275621029]],
    [ "1191523147",[-108.74136715000003, 37.71049125000001]],
    [ "1191523149",[-108.77435304449047, 37.70742561855031]],
    [ "1191523153",[-108.77305167788025, 37.711417637165916]],
    [ "1191523154",[-108.61017633034686, 37.48607751841531]],
    [ "1191534480",[-92.27031781209509, 29.871853379484914]],
    [ "1191534482",[-92.13926965271166, 29.817358109003447]],
    [ "AEP Kendallville Station",[-85.26646616208306, 41.435034472354126]],
    [ "Fairfield Substation",[-85.1933526249847, 41.48202925424851]],
    [ "AEP Wolf Lake Station",[-85.51458422540995, 41.33960539451969]],
    [ "Hineston Substation",[-92.7515406713831, 31.171829436221365]],
    [ "1191654361",[-85.21156108983266, 41.360999236423886]],
    [ "1191655065",[-85.22831629890703, 41.35901911125689]],
    [ "1191665113",[-85.13227823355038, 41.3516787285278]],
    [ "Cameron Subsation",[-88.06636391792705, 43.106607564828025]],
    [ "1191697121",[-84.90254048306711, 41.38446888363264]],
    [ "Bellaire Substation",[-85.19807779591007, 44.976324904411385]],
    [ "Shanty Creek Substation",[-85.17855765, 44.9569373]],
    [ "Milton Substation",[-85.36823975, 44.9753685]],
    [ "Angell Substation",[-85.43531944999998, 44.83104624999999]],
    [ "O-At-Ka Substation",[-85.53651266244532, 44.74422458064406]],
    [ "1191774818",[-84.80465232816837, 41.25561204967661]],
    [ "1191779837",[-84.88182776254624, 41.42384176928761]],
    [ "1191807746",[-84.82559406324725, 41.52097763089175]],
    [ "1191877585",[-85.09280784477036, 41.344749380390354]],
    [ "1191879100",[-85.08505816645149, 41.35027261866835]],
    [ "CLECO",[-92.9437958, 30.933856199999997]],
    [ "DAPL-ETCO Operations Management, LLC",[-90.68838545718816, 33.63059877520247]],
    [ "1191925407",[-86.14797173946808, 41.65863467933045]],
    [ "1191927913",[-86.15248914053116, 41.652119288369995]],
    [ "1191928909",[-86.1532541835599, 41.66374232451313]],
    [ "Logan Substation",[-86.19604493858054, 41.65133876111181]],
    [ "1191950596",[-90.17804578320961, 35.86608207017714]],
    [ "Holy Cross Electric",[-107.81866190762328, 40.145641126401436]],
    [ "Yampa Valley Electric",[-107.58716590147365, 40.45217022198712]],
    [ "Yampa Valley Electric",[-107.58730319165596, 40.45158877839504]],
    [ "Yampa Valley Electric Association",[-107.55347210488443, 40.48530287937175]],
    [ "Yampa Valley Electric Association",[-107.54334544310952, 40.5104095109356]],
    [ "Yampa Valley Electric Association",[-107.58229415838741, 40.516138999358624]],
    [ "Yampa Valley Electric Association",[-107.50504133766408, 40.51392565018201]],
    [ "Yampa Valley Electric Association",[-107.1220415348266, 40.376052385286194]],
    [ "Yampa Valley Electic",[-107.0969075220081, 40.36907874426424]],
    [ "1192010225",[-107.06065638174974, 40.350651721685374]],
    [ "Yampa Valley Electric",[-107.04970119438119, 40.356370493098886]],
    [ "Yampa Valley Electric",[-107.04963775961934, 40.35671159927262]],
    [ "1192010228",[-107.04728353941032, 40.378377102985226]],
    [ "Yampa Valley Electric",[-107.05539395491033, 40.38601188404215]],
    [ "Yampa Valley Electric",[-107.06418998243755, 40.39030051890417]],
    [ "Yampa Valley Electric",[-106.98526911256887, 40.42012403637076]],
    [ "Yampa Valley Electric",[-106.9238394064885, 40.707538914645355]],
    [ "Mountain Parks Electric",[-105.98231114999999, 40.1085175]],
    [ "Mountain Parks Electric",[-105.90669222571573, 40.143390515407575]],
    [ "Mountain Parks Electric",[-105.8712797, 40.1827104]],
    [ "Public Service Company of Colorado",[-106.1912201528116, 39.43172692261571]],
    [ "Leadville Substation",[-106.2733162300233, 39.23677753451057]],
    [ "Bailey Substation",[-105.45346588535814, 39.43853045447806]],
    [ "Ray Lewis Substation",[-106.12688526248662, 38.712506695667074]],
    [ "No 115",[-105.84815094167118, 38.46139441371185]],
    [ "115",[-105.11909885855547, 38.38691027484216]],
    [ "69",[-105.22665728854187, 38.4644456471955]],
    [ "115",[-105.43638087730113, 38.14553674927527]],
    [ "115",[-105.51384927502119, 38.13253978030694]],
    [ "Mears Junction",[-106.11415323500407, 38.442476847015605]],
    [ "Romeo Substation",[-105.98491974431563, 37.18127027822786]],
    [ "69",[-106.09352249662733, 37.56064516324056]],
    [ "Homelake Substation",[-106.09360789400873, 37.570597101045315]],
    [ "South Fork Substation",[-106.56022380585038, 37.67803699718106]],
    [ "1192120197",[-86.27824926028717, 41.520335770228854]],
    [ "Russ Substation",[-86.18761923380954, 41.679283258766425]],
    [ "Mishawaka Utilites",[-86.18576462757423, 41.69421599662934]],
    [ "1192165620",[-86.12057532528273, 41.68002959225293]],
    [ "1192165622",[-86.12137377509728, 41.676364309196416]],
    [ "1192293042",[-112.21362122472354, 33.55338374152738]],
    [ "Borley Substation",[-86.16547958259642, 41.674312087403784]],
    [ "1192414786",[-86.26138795000001, 41.70938155000001]],
    [ "South River Electric Membership Corporation",[-78.57705118981917, 35.16599629163354]],
    [ "South River Electric Membership Corporation",[-78.48625912840151, 35.07563718988698]],
    [ "South River Electric Membership Corporation",[-78.53881346694662, 34.86563645123139]],
    [ "1192428057",[-78.16380080241933, 35.88640406695013]],
    [ "1192428058",[-78.16411220188512, 35.886733594197494]],
    [ "1192428060",[-78.1549049824737, 35.89118940282428]],
    [ "1192428061",[-78.15519995642617, 35.89149329256415]],
    [ "Debalso Station",[-75.29421756183797, 43.08559793857261]],
    [ "1192479894",[-76.1024568168665, 43.55628904878548]],
    [ "Paloma Station",[-76.50675748897562, 43.44103206211363]],
    [ "Harbison Substation",[-86.45025722032612, 41.70142466983795]],
    [ "Peninsula Substation",[-85.5555458, 44.82050215]],
    [ "Harrietta Substation",[-85.69269015, 44.305846700000004]],
    [ "NICTD South Shore Electric Substation",[-86.50504682963418, 41.70806899589318]],
    [ "1192640896",[-86.45557769999998, 41.6921028]],
    [ "Camillus Station",[-76.30316305, 43.0425448]],
    [ "Entergy Louisiana",[-90.1711940495064, 29.884601118512556]],
    [ "Battle Hill Station",[-75.4110790964718, 44.33791942879067]],
    [ "AEP Vintage Station",[-86.31025168007149, 41.45311122518836]],
    [ "1192729206",[-86.31113061031343, 41.4471631482603]],
    [ "1192734575",[-76.22204265, 42.5724286]],
    [ "Grand Ledge Substation",[-84.74737805000001, 42.75988855000001]],
    [ "1192755330",[-86.42439173823409, 41.53522643061061]],
    [ "Whispering Pines Substation",[-86.50053652508466, 41.534092189747696]],
    [ "Shilo Sub",[-86.40864535000001, 41.4623696]],
    [ "East Walkerton Sub",[-86.47645314186111, 41.46363677418765]],
    [ "Tyner Sub 9",[-86.39662601539499, 41.39044621784574]],
    [ "Entergy Louisiana",[-91.07166263987006, 30.40863861379152]],
    [ "1193011364",[-86.80190655578046, 41.64809727479471]],
    [ "1193026635",[-86.35063861493659, 41.355944268082084]],
    [ "1193029640",[-86.1306738168076, 41.453325307701306]],
    [ "2nd Street Substation",[-86.14187774999999, 41.453548950000005]],
    [ "Third Street Sub",[-86.15581626113989, 41.449163870215045]],
    [ "Bowen Avenue Substation",[-86.15664622953754, 41.44894730295528]],
    [ "Bourbon Sub 6",[-86.13613457508212, 41.3306740578135]],
    [ "Bourbon Sub",[-86.13615609092913, 41.33016402516294]],
    [ "1193039145",[-97.6819418902822, 33.92035415521972]],
    [ "Ironwood Sub",[-86.21372746219457, 41.37722587501928]],
    [ "1193044402",[-86.315936590757, 41.3659006576099]],
    [ "Belleville Substation",[-77.74692032015462, 40.595763502523134]],
    [ "Winfield Substation",[-84.4507097749992, 36.54690928502327]],
    [ "1193123594",[-84.48386788008332, 36.672439229279064]],
    [ "Middlesboro Substation",[-83.7139351783327, 36.61345243485873]],
    [ "Consumers Energy",[-84.68724062500846, 44.60460145334789]],
    [ "1193243736",[-111.82989303191088, 35.24090121481721]],
    [ "1193243785",[-111.82459226181803, 35.22992648398274]],
    [ "1193245621",[-86.24383061261088, 41.2323111121467]],
    [ "1193248591",[-86.22732488781769, 41.15826448633623]],
    [ "1193253716",[-86.42787152503381, 41.2143605420099]],
    [ "Entergy Louisiana",[-93.15846744079953, 30.2229310748808]],
    [ "Knox Junction Sub",[-86.41461102972981, 41.287963658458544]],
    [ "1193319327",[-95.99424130079248, 35.95875819999251]],
    [ "1193400170",[-89.21783630778658, 37.786854156467825]],
    [ "1193400171",[-89.60619903632632, 37.94906572916143]],
    [ "1193400176",[-89.20100190864372, 37.74463599158751]],
    [ "1193400178",[-89.20040542462183, 37.75996825604903]],
    [ "1193401353",[-89.03174701610018, 39.1859541252164]],
    [ "Entergy Lousiana",[-91.63313520000001, 32.2813114]],
    [ "1193413552",[-83.61211443889158, 42.25106058740089]],
    [ "Ypsilanti Substation",[-83.61247182558972, 42.24193592367054]],
    [ "DTE Energy",[-83.60305661798597, 42.23319459390342]],
    [ "DTE Energy",[-83.52310099861154, 42.22071128120204]],
    [ "Belleville Substation",[-83.4841194456983, 42.19660759722691]],
    [ "Ramsey Substation",[-83.9676689378854, 42.059943420592504]],
    [ "1193421909",[-112.04889250989002, 32.90793947490026]],
    [ "Clinton #1 Substation",[-83.97641447598377, 42.068174972602414]],
    [ "1193438464",[-86.62010492496873, 41.30511759283075]],
    [ "Knox Sub",[-86.6240794, 41.2962438]],
    [ "1193440049",[-86.43394351989335, 41.05487724756247]],
    [ "1193442948",[-86.9965309682016, 39.096797685516094]],
    [ "1193485872",[-110.77944363050796, 33.003946697058936]],
    [ "1193485874",[-110.8106133, 33.01199295]],
    [ "1193485876",[-110.92988385191083, 33.088923316801626]],
    [ "1193485877",[-111.352848, 33.031474900000006]],
    [ "1193485902",[-111.52112820405453, 33.00417450386475]],
    [ "1193485944",[-111.61779140437851, 33.00681208361715]],
    [ "1193485947",[-111.73656758498669, 33.07392551797114]],
    [ "1193485954",[-111.77374094999999, 32.86472245]],
    [ "Vista Substation",[-111.73990386902689, 32.93898261339263]],
    [ "Thornton Substation",[-111.77505085742798, 32.86905167487717]],
    [ "1193581545",[-111.66981387966094, 32.87401304721321]],
    [ "1193601557",[-86.3609108759646, 40.75855610884156]],
    [ "1193629889",[-86.43530027469909, 40.73328249151844]],
    [ "1193642619",[-86.20575036832095, 40.83104248544585]],
    [ "1193645348",[-86.40888293080627, 40.89596374595591]],
    [ "1193645349",[-86.40888043842665, 40.89566301016948]],
    [ "1193650235",[-96.06922854073807, 43.00224050839874]],
    [ "Northwest Iowa Power Cooperative",[-96.09663042963885, 43.062994732488974]],
    [ "1193650237",[-96.09660673065079, 42.997285704329904]],
    [ "1193650238",[-96.11530688458592, 43.026902844506516]],
    [ "1193650243",[-96.01725228478655, 42.982172367683006]],
    [ "1193691740",[-110.8629379, 33.42038895]],
    [ "Pinal Substation",[-110.82188006708911, 33.40363393783329]],
    [ "1193691852",[-111.0684436750879, 33.30621364466903]],
    [ "1193691860",[-110.95551171870243, 33.380003974440214]],
    [ "1193691882",[-110.77403821651973, 33.00157203584881]],
    [ "Sells Substation",[-111.91453984458627, 31.934619297646396]],
    [ "1193691914",[-111.94419855000001, 32.519318500000004]],
    [ "1193691919",[-111.94350893649069, 32.52105331710558]],
    [ "1193692585",[-111.95713797523786, 33.0429292573748]],
    [ "1193783601",[-86.58296215, 40.704798000000004]],
    [ "1193837242",[-86.52613009999999, 40.53787774999999]],
    [ "Springboro Station",[-86.77499876901527, 40.5969709903115]],
    [ "1193849811",[-86.52957169999999, 40.51797680000001]],
    [ "1193851105",[-86.5265633749019, 40.55205135393788]],
    [ "1193865572",[-86.50633846043303, 40.64133125421766]],
    [ "1193865851",[-86.70125845, 37.8947505]],
    [ "1193867583",[-86.1079134131006, 37.90677552123403]],
    [ "1193867586",[-86.08611991565121, 37.87677239576814]],
    [ "1193869748",[-86.82551564999999, 40.59178034999999]],
    [ "1193869809",[-85.82849797508909, 41.90513634355547]],
    [ "1193870659",[-85.68312649999999, 41.9176695]],
    [ "1193880678",[-85.66384532477663, 42.00414394165417]],
    [ "Colonial Pipeline Company",[-91.74678847523145, 30.528087258992418]],
    [ "1193992666",[-85.97696573437618, 41.917836422349254]],
    [ "1193992667",[-85.97697795928758, 41.917015860427]],
    [ "1193992678",[-85.63184530000001, 41.9382925]],
    [ "Wheeler St. Station",[-85.63940650463914, 41.952067359968005]],
    [ "1194014499",[-86.77446789999998, 40.75075965]],
    [ "1194019942",[-86.7759947923622, 40.729646324521354]],
    [ "1194032703",[-86.75282137306085, 40.656477786684654]],
    [ "1194032708",[-86.77372310324186, 40.64959471068989]],
    [ "Orchard Substation",[-114.5357074290259, 32.62750607531827]],
    [ "Ridgefield Substation",[-90.83282780341743, 29.76623065775879]],
    [ "1194094870",[-87.08036150000001, 40.761924900000004]],
    [ "1194096029",[-86.9289246265201, 40.75295569262493]],
    [ "1194107685",[-86.7458493750168, 40.77735060639926]],
    [ "1194153416",[-86.59627099999999, 40.759955250000004]],
    [ "1194154859",[-111.93739808514104, 33.355998491280886]],
    [ "1194154943",[-111.91670526688856, 33.42588558464695]],
    [ "Dailey Substation",[-86.08867835000001, 41.88667465]],
    [ "1194159487",[-86.2195828733643, 41.86360251310438]],
    [ "1194159493",[-86.20141539389927, 41.89253176181051]],
    [ "1194263746",[-87.12081137442655, 41.63571488080754]],
    [ "1194263760",[-87.12270969656558, 41.64237467813559]],
    [ "1194263766",[-87.13361032373987, 41.64177212055239]],
    [ "1194263773",[-87.16079022634854, 41.6212270852807]],
    [ "1194282468",[-86.87676044956999, 40.86316327726706]],
    [ "1194291778",[-86.8142626247641, 40.800377754402916]],
    [ "1194305519",[-86.99106434999999, 40.8522628]],
    [ "1194316521",[-86.88236235, 40.95918484999999]],
    [ "1194320747",[-86.90563835844623, 40.9697438753053]],
    [ "1194324937",[-86.77509684999998, 40.97808059999999]],
    [ "1194328203",[-86.89240838736804, 40.98487982489877]],
    [ "1194336430",[-86.89157274816162, 41.078088258470586]],
    [ "1194352588",[-86.98813530000001, 41.1358318]],
    [ "1194502899",[-86.60285225000001, 40.96884845]],
    [ "Lawton Sub",[-86.52432576269993, 41.11355502444303]],
    [ "1194504808",[-86.52469583861581, 41.11353486999027]],
    [ "1194529043",[-87.4765351499742, 41.63173902132577]],
    [ "North Judson Sub",[-86.7709432145125, 41.2148247187546]],
    [ "1194539365",[-84.48128661506806, 37.171499622897066]],
    [ "1194539946",[-86.62013849285742, 41.33707577882577]],
    [ "Perryville Station",[-75.82766405, 43.01158415]],
    [ "Stevensville",[-114.07948733707481, 46.514780318789775]],
    [ "1194623183",[-86.73549397526948, 41.72256715625856]],
    [ "1194623187",[-86.74218921312352, 41.6506112308277]],
    [ "1194635443",[-111.8966391, 39.81761085]],
    [ "1194653685",[-86.1153451236049, 39.62769397672889]],
    [ "1194735307",[-86.55354295, 41.37933395]],
    [ "1194735309",[-86.55761147534074, 41.37543574067492]],
    [ "1194737070",[-86.4448148753395, 41.37468885643987]],
    [ "1194762423",[-86.85327005583251, 41.283061550466556]],
    [ "Washington Substation",[-86.95388362588804, 41.43732783822276]],
    [ "1194887136",[-87.1711169800093, 41.609229360936304]],
    [ "1194887142",[-87.17256990988764, 41.63226742491323]],
    [ "1194904907",[-90.18184451424806, 42.418776631486004]],
    [ "1194993923",[-86.70262453259707, 41.61709082965413]],
    [ "1195000571",[-86.69792640896841, 41.62452489845014]],
    [ "1195003321",[-86.68050955000001, 41.63423215]],
    [ "1195003323",[-86.68038337516816, 41.6322502618056]],
    [ "1195005916",[-86.69536786963366, 41.624432612488185]],
    [ "1195008777",[-86.67338998300797, 41.62489323368923]],
    [ "Nabisco Substation",[-74.36253732453577, 40.816551629378125]],
    [ "1195042743",[-86.66733230660306, 41.5153161192078]],
    [ "1195044594",[-86.64955344999998, 41.50890335]],
    [ "1195136785",[-86.77796350144664, 41.65869606524911]],
    [ "1195215643",[-91.19595055, 44.209133300000005]],
    [ "1195215652",[-91.01838245, 44.16911435]],
    [ "1195252963",[-86.88707393386527, 41.717230430636164]],
    [ "1195264637",[-86.88294029351532, 41.71806142492568]],
    [ "1195274060",[-86.90209519999999, 41.72410525]],
    [ "1195275745",[-86.88622058289177, 41.72429797112808]],
    [ "1195276955",[-90.84262003961274, 43.30698655698477]],
    [ "1195288286",[-86.89019279767638, 41.71753899880115]],
    [ "1195317130",[-92.37703658526227, 32.67022605571388]],
    [ "Kentuky Station",[-86.90842653609162, 41.710652658868945]],
    [ "1195339095",[-86.91924056140229, 41.702470606005896]],
    [ "1195368484",[-86.87401790000003, 41.693497949999994]],
    [ "Calumet Princeton Refining, LLC",[-93.51458519999998, 32.593455649999996]],
    [ "1195526529",[-93.59629803542519, 32.58763168423102]],
    [ "1195587643",[-90.29998994999998, 42.5361134]],
    [ "1195587646",[-90.28712277539286, 42.45170320561083]],
    [ "1195610489",[-86.89721428328504, 41.66124555072591]],
    [ "Kiefer Road Sub",[-86.88397102233155, 41.664218673492186]],
    [ "Freyer Road Sub",[-86.84171990171411, 41.739043253236645]],
    [ "1195793104",[-79.8701883818787, 38.1205840442107]],
    [ "1195919109",[-86.84421035, 41.71344945]],
    [ "1195937764",[-86.85373421035445, 41.67976331061346]],
    [ "1196068263",[-87.0236619752331, 41.47946834367698]],
    [ "1196073688",[-87.00061700000002, 41.47809715000001]],
    [ "1196073689",[-87.00037426434616, 41.47823003156386]],
    [ "1196244575",[-81.53592498860795, 39.9297131395291]],
    [ "1196244582",[-81.53708379290755, 39.936452787289205]],
    [ "Manchester Substation",[-93.08181284295925, 30.157531728696995]],
    [ "Bayou Bridge Pipeline, LLC",[-92.70483995646585, 30.16148277598128]],
    [ "1196391611",[-86.89421825000001, 41.51478665]],
    [ "1196395157",[-86.9046206, 41.529155450000005]],
    [ "1196406113",[-86.97764867844813, 41.42049080001548]],
    [ "1196435588",[-87.02758992491387, 41.372567495012504]],
    [ "1196444001",[-87.03500226332362, 41.3179383690407]],
    [ "1196450788",[-87.05839418348393, 41.31146982472822]],
    [ "1196455024",[-87.00668691066402, 41.31198597493893]],
    [ "1196467502",[-87.1126623424259, 41.31780459867268]],
    [ "Hebron Sub",[-87.2024770574923, 41.3220717494991]],
    [ "1196598831",[-87.19606883418443, 41.398676006755544]],
    [ "1196604037",[-87.2035635, 41.42078390000001]],
    [ "Morgan Substation",[-87.08437508224311, 41.41270508451804]],
    [ "1196800485",[-87.06540330000001, 41.51334655]],
    [ "1196808448",[-87.10052970000001, 41.5352421]],
    [ "1196816877",[-87.05106815000002, 41.55570900000001]],
    [ "1196822051",[-87.06342835, 41.58676625]],
    [ "1196824199",[-87.05609142497704, 41.5932766545547]],
    [ "1196866059",[-87.12790635642993, 41.597394574597125]],
    [ "Pointe Coupee Electric Membership",[-91.56029952985048, 30.550776810728124]],
    [ "1196912848",[-119.60824589143039, 45.85830799756493]],
    [ "1196919498",[-87.16398653465804, 41.57218686778112]],
    [ "1196919506",[-87.16842287513101, 41.55405254431657]],
    [ "Wolf Rd. Sub",[-87.15357712499915, 41.53250999387595]],
    [ "Buckeye Pipeline",[-87.17147600000001, 41.52135355000001]],
    [ "1197057477",[-87.2194404750196, 41.48575279310521]],
    [ "1197065137",[-87.18810792510162, 41.53639214273923]],
    [ "Willowdale Sub",[-87.20209351171569, 41.572076619462635]],
    [ "Woodland Park Sub",[-87.18239733923558, 41.59662312500929]],
    [ "1197173313",[-103.88739288057354, 32.71366886187745]],
    [ "1197173373",[-103.77305392519176, 32.81210080758778]],
    [ "1197173374",[-103.77303737462607, 32.811735334301275]],
    [ "1197212754",[-87.15977171037244, 41.62121193622475]],
    [ "Crocker Sub",[-87.10188051612374, 41.60581052466088]],
    [ "Berkley Substation",[-94.06688817496232, 41.95061229390374]],
    [ "Guthrie County REC",[-94.12570988267098, 41.77657777607492]],
    [ "Guthrie County REC",[-94.25087460150445, 41.77689085712191]],
    [ "Panorama #3 Substation",[-94.38061778273736, 41.717428268860154]],
    [ "MidAmerican Energy",[-95.85959642109601, 43.062170374885376]],
    [ "MidAmerican Energy",[-95.85463900082208, 43.17644426654508]],
    [ "Midland Power Cooperative",[-94.36862333004086, 41.89912412493389]],
    [ "1197252393",[-83.8361179934722, 39.420287482110666]],
    [ "Panora Municipal Electric Utility",[-94.36774942531265, 41.69483035265775]],
    [ "1197253836",[-74.47862744018072, 40.54298812019723]],
    [ "Short Hills Substation",[-74.33567484112237, 40.748111803974744]],
    [ "Mountain View Substation",[-74.26084926526752, 40.907498012823474]],
    [ "Crescent Midstream, LLC",[-91.75338137410213, 29.981473998618203]],
    [ "Breaux Bridge Switching Station",[-91.92309739233508, 30.27231029171446]],
    [ "1197413123",[-87.24029332327757, 41.54974782490147]],
    [ "East Gary Sub",[-87.23608246103323, 41.57395514982331]],
    [ "Central Avenue Substation",[-87.27704760098827, 41.56989695742635]],
    [ "Leelanau Substation",[-85.64298156802128, 45.05438276525337]],
    [ "1197476292",[-87.29743057098392, 41.59138440640336]],
    [ "1197481757",[-87.2805852571397, 41.58632444914387]],
    [ "1197484245",[-87.25337003593013, 41.59788681375265]],
    [ "Gray Road Substation",[-85.69057363109806, 44.77855685002976]],
    [ "East Kentucky Power Cooperative, Inc.",[-84.95023994077226, 38.02464267177449]],
    [ "Concord 2",[-75.51183743228692, 38.60613871899941]],
    [ "Concord Switching Station",[-75.51659395440612, 38.603205203446905]],
    [ "1197551704",[-75.58656485717054, 39.45956606958661]],
    [ "1197551705",[-75.54171151037265, 39.4713038439957]],
    [ "1197551883",[-79.29800432660149, 42.286425313922244]],
    [ "1197551891",[-79.20898548877958, 42.29274017986971]],
    [ "1197553178",[-75.5404098813704, 41.4844117079605]],
    [ "1197555396",[-89.65313518029858, 44.85792611469396]],
    [ "1197560093",[-86.5143954350066, 41.79021911801709]],
    [ "1197562531",[-89.96820418175179, 36.5530626455916]],
    [ "Washington Substatoin",[-86.0097133186456, 42.81453176405981]],
    [ "1197598522",[-114.02664728746116, 35.22333889194693]],
    [ "1197708601",[-87.19397018999882, 36.70216684205366]],
    [ "Mid Valley Pipeline Company LLC",[-87.16020985, 36.73340085]],
    [ "Mid Valley Pipeline Company LLC",[-86.2237475177939, 37.46656650177509]],
    [ "Mid Valley Pipeline Company LLC",[-85.38624512456971, 38.19341110863411]],
    [ "Mid Valley Pipeline Company LLC",[-84.69210173160721, 39.035078846527085]],
    [ "Campstool Substation",[-104.71493901684218, 41.14401808146548]],
    [ "Bates Substation",[-85.44503903470685, 44.77463807962135]],
    [ "Delaware Substation",[-87.33241892933239, 41.57311201852461]],
    [ "Mancelona Substation",[-85.06822396950085, 44.894199432349055]],
    [ "1198037295",[-87.31654947510951, 41.54055144459942]],
    [ "1198046546",[-87.35515340890254, 41.531233975345735]],
    [ "Permian Express Partners LLC",[-92.67127085, 31.374268449999995]],
    [ "1198064332",[-87.37757655939235, 41.5957669835385]],
    [ "1198069465",[-87.38327647725744, 41.60582624090645]],
    [ "1198088381",[-113.80207974828973, 35.18086463117498]],
    [ "1198100566",[-87.37475445000001, 41.56900445]],
    [ "Hardy Susbstation",[-85.62959960473118, 43.486558572853504]],
    [ "White Cloud Substation",[-85.77838439532223, 43.55101297753267]],
    [ "Butterfield Substation",[-85.7860809129338, 43.40597626492915]],
    [ "Brooks Substation",[-85.7971136197748, 43.408784372571155]],
    [ "NuStar Pipeline Operating Partnership L.P.",[-92.14059235, 31.121449]],
    [ "Jackson Corners Substation",[-72.51245953989464, 44.090328476234255]],
    [ "Kennedy Avenue Pumping Station",[-87.46049528371145, 41.60932783298096]],
    [ "Woodmar Sub",[-87.48626974970816, 41.57789076152046]],
    [ "1198442649",[-87.47500459999999, 41.574803700000004]],
    [ "1198476040",[-87.50067355300983, 41.57349477452711]],
    [ "Station 155",[-77.27366456150992, 42.880520578525356]],
    [ "Station 144",[-77.29017046820584, 42.87265634652991]],
    [ "1198484334",[-87.52284843238243, 41.57806641837665]],
    [ "Bailey Substation",[-85.8490783, 43.279720649999994]],
    [ "1198517498",[-87.56018872201818, 38.12267389375287]],
    [ "1198517730",[-87.17276582475148, 38.004228856868096]],
    [ "Pelzer Transmission Station",[-87.28440068347295, 37.989406824713924]],
    [ "1198522663",[-86.72885658681915, 37.45544153968276]],
    [ "1198522667",[-86.52314767546095, 37.432163322965636]],
    [ "1198522672",[-86.29559821571311, 37.484948832284175]],
    [ "Leitchfield East Substation",[-86.2740676, 37.4787695]],
    [ "1198524542",[-86.23832933237036, 37.40271533460124]],
    [ "Bee Spring Substation",[-86.29616715475458, 37.2907185715836]],
    [ "Warren Rural Electric",[-86.27994011195604, 37.24829963588078]],
    [ "Briggs & Stratton Substation",[-85.93398406556778, 43.182893018577026]],
    [ "PECO",[-75.34925166819045, 39.87338609345078]],
    [ "1198628167",[-87.48630030000001, 41.59701955]],
    [ "Pullman Sub",[-87.48134846654563, 41.596355601314116]],
    [ "1198636366",[-87.49722405, 41.59520615]],
    [ "1198637746",[-87.49418371036879, 41.60223073181832]],
    [ "1198641103",[-87.47245090000001, 41.58666805]],
    [ "1198646727",[-87.48052980000001, 41.6076399]],
    [ "Harvey Street Substation",[-85.64226345, 42.97198305]],
    [ "Race Street Substation",[-85.64130954540101, 42.97195708463225]],
    [ "Crahen Substation",[-85.57162723751816, 42.968232968442294]],
    [ "1198786804",[-87.49962422617425, 41.610834722972776]],
    [ "Cedar Springs Substation",[-85.68094263703212, 43.29409540717448]],
    [ "1198802536",[-87.51052772725316, 41.60398598485416]],
    [ "1198804856",[-87.51819023159551, 41.57199920053752]],
    [ "Wolverine Power Supply Cooperative",[-85.5228428385012, 43.39527054701703]],
    [ "Big Prairie Substation",[-85.6432210825552, 43.51157674051275]],
    [ "Evart Products Substation",[-85.26598721890736, 43.897896847156936]],
    [ "1198944498",[-87.4956655589423, 41.62073756479455]],
    [ "1198956621",[-78.49113433174608, 38.058328054133916]],
    [ "Sunfield Substation",[-84.96029651277375, 42.755842469227865]],
    [ "1199331760",[-85.50334910091202, 43.885560476950076]],
    [ "1199386804",[-93.4443794946777, 31.947567653583192]],
    [ "1199386814",[-93.41750295, 31.952268250000003]],
    [ "1199404608",[-78.65457034053243, 38.08095146780705]],
    [ "1199490848",[-87.5180544867014, 41.63057839315791]],
    [ "Hackett Substation",[-93.08797231547771, 30.009770267735284]],
    [ "Egan Hub Storage Substation",[-92.57429730801947, 30.2597822247875]],
    [ "1199534281",[-92.51351670000001, 30.02753155]],
    [ "1199536098",[-87.5132526797526, 41.65841369660907]],
    [ "1199552830",[-87.50742155, 41.66067085]],
    [ "1199592413",[-87.50904329999999, 41.67757195000001]],
    [ "1199592415",[-87.50796587772882, 41.686998929916896]],
    [ "1199599506",[-87.50871179167291, 41.69120271476395]],
    [ "1199599509",[-87.50895163728754, 41.6926522636599]],
    [ "1199599514",[-87.50569595000002, 41.69180655000001]],
    [ "1199616837",[-87.51744090226134, 41.689414794966964]],
    [ "Appleton Substation",[-85.50283771968547, 43.690862610286466]],
    [ "Big Rapids Substation",[-85.46637264010624, 43.69453524343836]],
    [ "1199662857",[-86.32231734006383, 38.86996396910337]],
    [ "1199662860",[-86.44891613940553, 38.87560696331338]],
    [ "Rodney Substation",[-85.32442970381514, 43.68414570214201]],
    [ "Anse Labutte Substation",[-91.94850866861994, 30.266731517584088]],
    [ "Entergy Louisiana",[-91.93335984999999, 30.2903663]],
    [ "Dixie Pipeline Substation",[-91.95186105, 30.312546549999997]],
    [ "Breaux Bridge Substation",[-91.90062024243112, 30.26986220856607]],
    [ "CLECO",[-92.7087154490152, 31.40487196680012]],
    [ "Boyce Substation",[-92.66547136739611, 31.38541677707953]],
    [ "1199691712",[-93.47903571935993, 32.644021558688635]],
    [ "1199691715",[-93.52327019580885, 32.669579392283296]],
    [ "Custer Substation",[-86.25142893011926, 37.7377017128208]],
    [ "Station 43",[-77.55424400884841, 43.1659083365257]],
    [ "1199983771",[-80.619337017843, 39.34058845968154]],
    [ "Grady Substation",[-85.03082068262624, 30.575828791147586]],
    [ "Perales Substation",[-111.63476329999999, 33.32993635]],
    [ "1200014619",[-111.63178210000001, 33.34427165]],
    [ "Prickly Pear Substation",[-111.63364038425988, 33.34392100155395]],
    [ "Scott Substation",[-111.64556262060012, 33.33043662129039]],
    [ "1200014647",[-111.64705389999999, 33.358667749999995]],
    [ "Redwood Substation",[-86.32102753916331, 43.68808510845352]],
    [ "DTM Louisiana Substation",[-93.53086161418875, 31.599479767819478]],
    [ "Pelican Treating Substation",[-93.54486981515709, 31.885892534216033]],
    [ "Entergy Arkansas",[-92.64828457657941, 33.3620113436903]],
    [ "Entergy Louisiana",[-92.89542968207508, 33.50409180537236]],
    [ "Albemarle Corporation",[-93.21632372414093, 33.176749642710725]],
    [ "1200476430",[-86.02135374999999, 37.85331945000001]],
    [ "1200482461",[-86.38149800370901, 38.04306962176017]],
    [ "1200482463",[-86.29657552361307, 38.08561940302447]],
    [ "1200482468",[-86.19316748985322, 37.99335190263841]],
    [ "1200582951",[-85.88744220000001, 38.18557250000001]],
    [ "Entergy Arkansas",[-92.64546845995152, 33.260219977832726]],
    [ "El Dorado Parkers Chapel Substation",[-92.74112433465325, 33.163987582404495]],
    [ "Entergy Arkansas",[-92.66727499999999, 33.1097786]],
    [ "1200627269",[-88.34567584014341, 40.45055890105581]],
    [ "Entergy Arkansas",[-93.32384810949617, 33.175688033885976]],
    [ "Lewisville Substation",[-93.59892861626848, 33.35810782565595]],
    [ "Southwest Arkansas Electric Cooperative",[-93.59984573455664, 33.35815904984534]],
    [ "Bradley Substation",[-93.65293546586867, 33.10329461562972]],
    [ "Southwest Arkansas Electric Cooperative",[-93.51401450057696, 33.155742227474434]],
    [ "Southwest Arkansas Electric Cooperative",[-93.75315523550566, 33.10724396859572]],
    [ "1200638783",[-111.8923825055821, 33.29937782488605]],
    [ "1200638790",[-111.88646112006246, 33.23834269369886]],
    [ "Wolverine Power Cooperative",[-85.42580647502865, 43.83877839146152]],
    [ "Wolverine Power Cooperative",[-85.42495381072118, 43.83803641798262]],
    [ "Evergy",[-94.53640303773051, 39.28152371875221]],
    [ "1200711696",[-108.79192002001383, 48.52841041625464]],
    [ "Wolverine Power Supply Cooperative",[-85.10556708334289, 44.10205470544844]],
    [ "Waldron Substation",[-94.76989027429653, 39.2244517159977]],
    [ "Stoney Corners Substation",[-85.29870234020659, 44.18994526890849]],
    [ "Westwood Substation",[-85.050516473604, 44.81568002340992]],
    [ "Southwestern Electric Power Company",[-93.81534563367161, 33.656086494821764]],
    [ "Southwestern Electric Power Company",[-93.81428018937014, 33.65614357801086]],
    [ "Beirne Substation",[-93.21835735945125, 33.90851248323897]],
    [ "Okolona Substation",[-93.32206828598821, 33.99592252343143]],
    [ "Delight Substation",[-93.48381908573273, 34.032856573124675]],
    [ "Entergy Arkansas",[-92.83014742524725, 33.59507779226317]],
    [ "Entergy Arkansas",[-92.70053910612324, 33.63020220578022]],
    [ "1200860571",[-92.50629387458764, 33.53395740852272]],
    [ "Fremont Substation",[-85.94865722008441, 43.46378701030167]],
    [ "1200899139",[-74.02623083864759, 41.53808892766398]],
    [ "Fremont Digester Substation",[-85.97574130887911, 43.458680023663]],
    [ "Holton Substation",[-86.04035513330682, 43.42418405236289]],
    [ "1200912860",[-92.69786547465034, 33.78396474390964]],
    [ "Enterprise Products Operating LLC",[-92.3623669342892, 33.89922715262999]],
    [ "Kingsland Substation",[-92.31531826667933, 33.87305849852078]],
    [ "Polkton Substation",[-85.94490500761968, 43.11968502218322]],
    [ "Newton Falls",[-74.99326955000001, 44.2124896]],
    [ "1200967789",[-74.33457703837249, 40.49226118913808]],
    [ "Consumers Energy",[-86.20949553720571, 43.21469576638586]],
    [ "Pine Bluff South Substation",[-92.0034356648255, 34.159519559559044]],
    [ "C&L Electric Cooperative Corporation",[-91.98920786814581, 33.93793126500004]],
    [ "C&L Electric Cooperative Corporation",[-91.85280533978406, 33.940203234051886]],
    [ "C&L Electric Cooperative Corporation",[-91.74800628024504, 33.81917259250037]],
    [ "PSE&G",[-74.1908584961669, 40.78071226282819]],
    [ "Branch Brook Substation",[-74.18542907367467, 40.77959346715855]],
    [ "Monticello East Substation",[-91.79514880336338, 33.605188867578455]],
    [ "Wilmar Substation",[-91.92563212479956, 33.61374709097261]],
    [ "Entergy Arkansas",[-92.16238924065398, 33.42943247521914]],
    [ "Entergy Arkansas",[-92.15593584398448, 33.428895367631625]],
    [ "Entergy Arkansas",[-92.12874065, 33.4189201]],
    [ "Hilo Substation",[-92.31089585000001, 33.338091250000005]],
    [ "Entergy Arkansas",[-92.3985712998104, 33.33975908326723]],
    [ "1201022291",[-91.8264677069143, 33.46179752814356]],
    [ "Entergy Arkansas",[-91.92388745, 33.25117300000001]],
    [ "Crossett North Substation",[-91.95822977036694, 33.14201328142536]],
    [ "Hamburg Substation",[-91.79445918270251, 33.21108870634038]],
    [ "Entergy Arkansas",[-91.66588890800507, 33.276054042291406]],
    [ "Ashley-Chicot Electric Cooperative",[-91.4596825060676, 33.21491842497555]],
    [ "Chicot Substation",[-91.2934992606685, 33.21371572464476]],
    [ "Lake Chico Pump Substation",[-91.24116899667882, 33.43203181650553]],
    [ "Dermott Substation",[-91.43573102084544, 33.50684723896378]],
    [ "Pea Ridge Substation",[-91.33701514976124, 33.91975481398651]],
    [ "City of Harrisonville Electric Department",[-94.3667149330035, 38.6365077162602]],
    [ "Central Substation",[-94.34822869291015, 38.658444426500026]],
    [ "North Substation",[-94.3651237738161, 38.66604138562642]],
    [ "1201244708",[-91.90458955134824, 34.21626168287041]],
    [ "1201244711",[-91.9039357983414, 34.21844020775297]],
    [ "Pactiv LLC",[-91.90401184177696, 34.21872846966757]],
    [ "1201244744",[-92.00563658832449, 34.2255417248309]],
    [ "Entergy Arkansas",[-92.01841517610687, 34.226530074652864]],
    [ "Entergy Arkansas",[-91.18831067511935, 34.370409092081545]],
    [ "Stuttgart Ricuskey Substation",[-91.54208520320066, 34.47566499655556]],
    [ "Entergy Arkansas",[-92.14107828635855, 34.42374999207879]],
    [ "1201269743",[-92.07150031968813, 34.26308698587246]],
    [ "Wabbaseka Substation",[-91.82578454147072, 34.36818112482262]],
    [ "First Electric Cooperative",[-91.32273029999999, 34.45161195]],
    [ "First Electric Cooperative",[-91.29657894989256, 34.311706167889106]],
    [ "Entergy Arkansas",[-91.08123817496488, 34.86233903825708]],
    [ "Stuttgart Industrial Substation",[-91.51653407320912, 34.50821691400847]],
    [ "Hazen Substation",[-91.54987377770284, 34.77508282193587]],
    [ "Carlisle Substation",[-91.7253625774634, 34.772991554516594]],
    [ "Entergy Arkansas",[-91.85198136606436, 34.78201599963053]],
    [ "Entergy Arkansas",[-92.1299839868851, 34.765561109985065]],
    [ "First Electric Cooperative",[-91.81075754074071, 34.59667630405328]],
    [ "Elizabethton Electric Department",[-82.20208123173514, 36.324120725949435]],
    [ "L.R. 23RD & Spring Substation",[-92.27782220081612, 34.72603775964505]],
    [ "Entergy Arkansas",[-92.31564866917611, 34.693995511970705]],
    [ "L.R. Alexander Substation",[-92.41051680605271, 34.64166961645125]],
    [ "Entergy Arkansas",[-92.3469724906634, 34.75654416617147]],
    [ "Entergy Arkansas",[-92.42812321593276, 34.70283689582198]],
    [ "Entergy Arkansas",[-92.4975512885598, 34.65077276813706]],
    [ "Entergy Arkansas",[-92.52849949158329, 34.6463228780282]],
    [ "Entergy Arkansas",[-92.61241986980622, 34.63149891259589]],
    [ "First Electric Cooperative",[-92.57976011294771, 34.59547127391414]],
    [ "Entergy Arkansas",[-92.86040381095201, 34.63083090283388]],
    [ "Entergy Arkansas",[-92.93764779840244, 34.66273910764061]],
    [ "Entergy Arkansas",[-93.13805022470044, 34.95445660954292]],
    [ "Entergy Arkansas",[-93.19475979481463, 34.57030158972027]],
    [ "1201710910",[-93.19457709573508, 34.57069155721862]],
    [ "Entergy Arkansas",[-93.16343085, 34.5413927]],
    [ "Entergy Arkansas",[-93.16285570274844, 34.54082505306752]],
    [ "1201763888",[-74.33015171555131, 40.05856711652521]],
    [ "1201766247",[-87.48928043716633, 41.675016923269546]],
    [ "Entergy Arkansas",[-93.06727841918287, 34.456147505891224]],
    [ "Entergy Arkansas",[-93.02466356891955, 34.44469197734407]],
    [ "Valley Street Substation",[-93.04981393607858, 34.50388149663728]],
    [ "1201786222",[-87.49698595, 41.685961500000005]],
    [ "Entergy Arkansas",[-92.964679128558, 34.46341784361315]],
    [ "Union Carbide Substation",[-92.94747619992421, 34.46421926622508]],
    [ "Entergy Arkansas",[-92.9291241255515, 34.460872957769936]],
    [ "Benton South Substation",[-92.58922322624794, 34.54824394398798]],
    [ "Bauxite Substation",[-92.50524825557609, 34.56710818300402]],
    [ "First Electric Cooperative",[-92.48962432536402, 34.58486234906281]],
    [ "Bryant Substation",[-92.4840645018653, 34.592314667006164]],
    [ "Entergy Arkansas",[-92.7764712891117, 34.40978378244151]],
    [ "Entergy Arkansas",[-92.80079771017587, 34.38376827540367]],
    [ "Sheridan Substation",[-92.39655878165836, 34.31524346385293]],
    [ "NuStar Pipeline Operating Partnership L.P.",[-92.20974649062644, 34.303495124772525]],
    [ "Texas Eastern Transmission, LP",[-92.82723650000001, 34.16732895]],
    [ "Amity Substation",[-93.47830734288218, 34.264838675149804]],
    [ "Glenwood Substation",[-93.56143086342239, 34.35512312564874]],
    [ "South Nashville Substation",[-93.86100161453074, 33.92140238119195]],
    [ "1202054658",[-93.71512407722452, 33.75080654325711]],
    [ "Lorin Substation",[-86.21234356453844, 43.21627912832725]],
    [ "Mena Substation",[-94.25472618235618, 34.565872124222984]],
    [ "1202224982",[-94.25521210000001, 34.565587]],
    [ "Consumers Energy",[-86.21941317189658, 43.25063001269564]],
    [ "Southwest Arkansas Electric Cooperative",[-94.37998790963606, 33.74507387600045]],
    [ "1202245517",[-94.41705849774823, 33.6949396841408]],
    [ "Permian Express Partners LLC",[-94.39206615, 33.703515800000005]],
    [ "1202259736",[-94.02461892804425, 34.10398007062233]],
    [ "Southwestern Electric Power Company",[-94.36126861683766, 33.60165323310366]],
    [ "1202259741",[-94.11270117555947, 33.64313589209528]],
    [ "Clearwater Wind West Collection Substation",[-106.37840980566625, 46.81786329784067]],
    [ "Clearwater Wind Autoyard",[-106.59709045342615, 45.926130685508]],
    [ "1202288811",[-91.68603882516551, 42.99319336113094]],
    [ "1202291058",[-90.37484265778846, 45.12655427690118]],
    [ "1202291061",[-90.37650098777688, 45.031618275040756]],
    [ "1202291066",[-90.36889157521979, 45.13967634541457]],
    [ "Entergy Arkansas",[-91.870322785072, 34.90751822520457]],
    [ "1202375489",[-102.3281649619621, 33.84837206962752]],
    [ "1202375490",[-102.32655372518595, 33.80126359429683]],
    [ "1202375491",[-102.44744827469707, 33.78601691559263]],
    [ "1202375494",[-102.51961383624567, 33.787566175019585]],
    [ "1202440430",[-111.0076626, 31.810401449999997]],
    [ "1202440431",[-111.0675583427609, 31.858793719104657]],
    [ "1202440437",[-111.06474124999998, 31.841245800000003]],
    [ "1202440438",[-111.09694262277483, 31.877392071239253]],
    [ "1202440447",[-110.99862362910096, 32.00052804411866]],
    [ "1202440452",[-111.02552637517788, 32.000090811538996]],
    [ "1202440456",[-111.05337168968717, 31.997091187802702]],
    [ "1202440461",[-111.05898229250623, 31.977664543953168]],
    [ "Patriot Substation",[-110.84334665, 32.176421]],
    [ "1202440494",[-110.9997321962412, 31.874338367739153]],
    [ "1202440496",[-110.96085357438196, 31.910499857215328]],
    [ "Landwer Substation",[-86.21487273002094, 43.10449413304689]],
    [ "Beebe Substation",[-91.87204557711082, 35.09389233688885]],
    [ "1202473889",[-91.68758571759298, 35.23785171136131]],
    [ "Lightsource Renewable Energy Asset Management, LLC",[-91.6583815, 35.1635373]],
    [ "Entergy Arkansas",[-91.65897431279501, 35.16440625073647]],
    [ "Monroe Substation",[-91.10179839999999, 34.74256645]],
    [ "Arkansas Electric Cooperative Corporation",[-91.1370872, 34.50161555]],
    [ "Cotton Plant Substation",[-91.27456723345846, 35.004945733210555]],
    [ "1202515918",[-93.07924187787356, 34.068056312225686]],
    [ "Arkansas Electric Cooperative Corporation",[-90.99862542710771, 35.09607199936596]],
    [ "Arkansas Electric Cooperative Corporation",[-90.83668426047721, 35.25371068016411]],
    [ "Arkansas Electric Cooperative Corporation",[-90.9346225430346, 35.252064292868134]],
    [ "Arkansas Electric Cooperative Corporation",[-91.17282639999999, 35.2723492]],
    [ "Arkansas Electric Cooperative Corporation",[-90.74578162519809, 35.268508907935775]],
    [ "Arkansas Electric Cooperative Corporation",[-90.72486366328432, 35.19625996911476]],
    [ "Arkansas Electric Cooperative Corporation",[-90.45354958150243, 35.309262985456314]],
    [ "Mississippi County Electric Cooperative",[-90.27075344164889, 35.62640257513038]],
    [ "Arkansas Electric Cooperative Corporation",[-90.58116060000002, 35.60613965]],
    [ "1202585908",[-74.45023252639123, 40.13984877256586]],
    [ "Medford Substation",[-74.7949497, 39.9019124]],
    [ "Southampton Substation",[-74.74022850749047, 39.91202542588565]],
    [ "Mount Holly Substation",[-74.79151962472103, 39.99550409492332]],
    [ "1202585914",[-75.11731604609778, 39.90984917995767]],
    [ "1202585915",[-75.12608131808504, 39.919611938969986]],
    [ "Camden Co Generation",[-75.1187701115342, 39.91749538997855]],
    [ "Runnemede Substation",[-75.05188329860682, 39.851824122252864]],
    [ "Toney's Brook Substation",[-74.20112421361306, 40.79386205949069]],
    [ "Hesperia Substation",[-86.01915370225775, 43.56677942350484]],
    [ "Station 1",[-77.57048737123677, 43.15797461413294]],
    [ "Station 42",[-77.54773886132368, 43.145572592341885]],
    [ "Fountain Substation",[-86.17005442647356, 44.062135965698296]],
    [ "Arkansas Electric Cooperative Corporation",[-90.5261077, 35.69366455]],
    [ "Arkansas Electric Cooperative Corporation",[-90.74783207471177, 35.846329054576245]],
    [ "Arkansas Electric Cooperative Corporation",[-90.61315501460216, 35.86570752535896]],
    [ "Arkansas Electric Cooperative Corporation",[-90.37756298426218, 35.81845591759931]],
    [ "Arkansas Electric Cooperative Corporation",[-90.46569247817112, 35.75724572682599]],
    [ "Scottville Substation",[-86.28506003000177, 43.9525602925031]],
    [ "Wolf Lake Substation",[-85.86200884126889, 44.01012886210467]],
    [ "1202644978",[-87.46597826300598, 41.66032256664945]],
    [ "Indiana Harbor Sub",[-87.45252384999999, 41.6447006]],
    [ "1202658391",[-87.43763094381146, 41.65117591582488]],
    [ "1202658393",[-87.42029260784298, 41.63931880408525]],
    [ "Station 75",[-77.62100912435898, 43.08235889644219]],
    [ "1202669863",[-104.44215323923682, 31.72112372557445]],
    [ "Interlochen Substation",[-85.76711026602548, 44.59970127767488]],
    [ "Forrest City South Substation",[-90.78222970081416, 34.98608122520393]],
    [ "Entergy Arkansas",[-90.22058314091505, 35.14802117086546]],
    [ "1202782263",[-88.05787197510126, 38.432769731950046]],
    [ "1202782264",[-88.04815666684695, 38.37734872320901]],
    [ "1202809676",[-87.47310320000001, 41.65146345]],
    [ "1202816035",[-87.46177128345424, 41.644744899200596]],
    [ "1202816037",[-87.45990931432324, 41.647536310507704]],
    [ "Mich. Ave. Pumping Station",[-87.45911108978208, 41.6439743169597]],
    [ "1202838060",[-87.47434343312844, 41.64080105551507]],
    [ "1202838292",[-93.40924390610967, 45.24796466408731]],
    [ "1202850495",[-87.46752305000001, 41.62079980000001]],
    [ "Entergy Arkansas",[-90.30850907037782, 35.346017361284964]],
    [ "Big Cypress Solar, LLC",[-90.30987118156432, 35.34547746645309]],
    [ "Parkin Substation",[-90.55781319351294, 35.27059284755714]],
    [ "Entergy Arkansas",[-90.84605992960836, 35.02439084264881]],
    [ "Big River Steel Substation",[-89.94102578931731, 35.63855831841719]],
    [ "Nucor-Yamato Steel Company",[-89.78268045042783, 35.89938254356194]],
    [ "1202969448",[-89.71964797230117, 35.93976579930305]],
    [ "1202969449",[-89.7184531702151, 35.93992631378983]],
    [ "1202986537",[-87.47878173969643, 41.64787017032329]],
    [ "1202988181",[-87.4926595, 41.6471997]],
    [ "1202988502",[-87.47193796615475, 41.647536114817676]],
    [ "1202995601",[-88.24704905, 43.426860350000005]],
    [ "Newport Substation",[-77.1386139644456, 40.46553369955199]],
    [ "Paragould Light & Water Commission",[-90.49150060393953, 36.04626861869458]],
    [ "Paragould Light & Water Commission",[-90.48082668357759, 36.06011007294449]],
    [ "Paragould Light & Water Commission",[-90.47252211597427, 36.07980001402346]],
    [ "Paragould Light & Water Commission",[-90.48400385, 36.0454839]],
    [ "Woodruff Electric Cooperative",[-91.09202215613428, 35.1181509580797]],
    [ "Station 29",[-77.62587058314256, 43.17051454090945]],
    [ "Station 262",[-77.61011619787794, 43.14455969732066]],
    [ "Lepanto Substation",[-90.32165098699407, 35.61274027456314]],
    [ "1203343960",[-87.44690790000001, 41.63185610000001]],
    [ "1203343961",[-87.43330302086005, 41.63191884761096]],
    [ "1203381426",[-114.8701607749036, 35.93575176316756]],
    [ "Bayboro South Substation",[-82.63801021232342, 27.75757251950295]],
    [ "11th Street Substation",[-86.5392446538202, 39.173802817129925]],
    [ "Cadillac Renewable Energy",[-85.43523296404368, 44.26127845386117]],
    [ "Tustin Substation",[-85.44373294999998, 44.1047146]],
    [ "Consumers Energy",[-85.41029708741138, 44.263550200940834]],
    [ "Jonesboro City Water and Light",[-90.6710941909144, 35.84988846914015]],
    [ "Jonesboro City Water and Light",[-90.60943077941519, 35.86453286966506]],
    [ "Jonesboro City Water and Light",[-90.71736595318846, 35.81392968030161]],
    [ "Entergy Arkansas",[-90.38998284745377, 36.14411141764629]],
    [ "1203412396",[-90.50895742468109, 36.14927675478834]],
    [ "Marmaduke Substation",[-90.3742585617386, 36.18622612558769]],
    [ "1203412399",[-90.373313606847, 36.19247953454079]],
    [ "Entergy Arkansas",[-90.2818577188223, 36.3137652723306]],
    [ "Drasco Substation",[-91.92568716792664, 35.59638462378507]],
    [ "First Electric Cooperative Cooperation",[-91.97872925000001, 35.49698670000001]],
    [ "First Electric Cooperative Cooperation",[-92.03314225, 35.5775346]],
    [ "Vilonia Substation",[-92.17098282470681, 35.08999855653108]],
    [ "Entergy Arkansas",[-92.40289756375242, 35.07550701988744]],
    [ "1203482574",[-87.46434285070859, 41.636870623535145]],
    [ "First Electric Cooperative Cooperation",[-92.13969025773751, 34.9739327788258]],
    [ "Arkansas Electric Cooperative Cooperation",[-92.78047884576532, 35.08783454729906]],
    [ "Perryville Substation",[-92.79567873724366, 35.015772682026025]],
    [ "Bigelow Substation",[-92.63196169739716, 35.00290483864759]],
    [ "1203489391",[-92.73771990000003, 35.0925413]],
    [ "Southern Chips, Inc.",[-92.74727808358035, 35.06586623308723]],
    [ "1203489396",[-92.73955068931282, 35.0989086903182]],
    [ "1203499627",[-87.4509628181496, 41.609889479407755]],
    [ "1203499629",[-87.43652503898132, 41.60338347499243]],
    [ "Gibson Substation",[-87.43329552830632, 41.598713442123234]],
    [ "1203504229",[-87.46063285, 41.61629465]],
    [ "1203507430",[-87.45155509352317, 41.626683043385384]],
    [ "Bono Substation",[-92.47506659018325, 35.258805541845696]],
    [ "Entergy Arkansas",[-93.22477134322706, 35.31049956441783]],
    [ "Russellville East Substation",[-93.09757236914987, 35.276886683645316]],
    [ "Russellville Industrial Substation",[-93.0835284, 35.269522650000006]],
    [ "1203543262",[-87.51326638971875, 41.552027509284756]],
    [ "1203544783",[-87.5054923142411, 41.55166832459853]],
    [ "1203572136",[-87.51475116279173, 41.5375461750225]],
    [ "1203586329",[-87.51220732199405, 41.54258496651861]],
    [ "Arkansas Valley Electric Cooperative",[-94.22265531642078, 35.2088913330746]],
    [ "1203775995",[-94.37371400547933, 35.30764482810941]],
    [ "Ridge Rd. Sub",[-87.41349045, 41.5505505]],
    [ "1203812157",[-87.35407902466198, 41.5417532048951]],
    [ "1203814825",[-87.45645771116686, 41.569776324134494]],
    [ "1203822067",[-87.26082735000001, 41.51408865]],
    [ "1203824713",[-87.25809788839528, 41.5298808956944]],
    [ "Woodward Substation",[-85.50547723418906, 44.29598562079424]],
    [ "McBain Substation",[-85.21414771208157, 44.19574813208056]],
    [ "Viking - McBain Substation",[-85.22012555824823, 44.204046122521405]],
    [ "Marion Substation",[-85.14633312597005, 44.106542959030534]],
    [ "Oklahoma Gas & Electric",[-94.56728177497608, 35.24533539224848]],
    [ "Oklahoma Gas & Electric",[-94.61483421714368, 35.246127132816625]],
    [ "Arkansas Valley Electric Cooperative",[-94.27697315957566, 35.855671486495076]],
    [ "1203869192",[-93.72874193991699, 35.28738753511958]],
    [ "1203869195",[-94.10693545, 35.5008163]],
    [ "Arkansas Valley Electric Cooperative",[-94.18539723413535, 35.48389738265895]],
    [ "North Arkansas Electric Cooperative",[-92.4328757592067, 36.242426674670455]],
    [ "North Arkansas Electric Cooperative",[-91.91473896039342, 36.14752861952272]],
    [ "Poplar Bluff Substation",[-90.42594061853053, 36.79185889473488]],
    [ "City of Poplar Bluff",[-90.426140077307, 36.79111812734395]],
    [ "1203991127",[-87.52034062384648, 41.496047348231095]],
    [ "1204009258",[-87.41263942489108, 41.53617764356951]],
    [ "1204013385",[-87.43294465573537, 41.541310023970844]],
    [ "Marathon Pipeline LLC",[-87.40856317441147, 41.50988954635428]],
    [ "Griffith Pump Station",[-87.43855276999, 41.51905554488612]],
    [ "Griffith Sub",[-87.42368591606846, 41.52308366713445]],
    [ "1204045154",[-87.44744305726739, 41.509990525413876]],
    [ "1204045158",[-87.45148976977282, 41.507020274756364]],
    [ "1204045159",[-87.45250397857922, 41.50742828578611]],
    [ "1204045160",[-87.45347661307578, 41.5073555566565]],
    [ "1204046856",[-87.45837042484776, 41.505491796862366]],
    [ "Meadow Lane Sub",[-87.49264351225918, 41.50767647508822]],
    [ "Jersey Central Power and Light",[-74.47382388811631, 40.84598483578592]],
    [ "Kaleva Substation",[-86.01902276101562, 44.36822384436439]],
    [ "1204086322",[-90.96712211418104, 36.28341538132965]],
    [ "1204086323",[-91.00164788308615, 36.373594566515834]],
    [ "Clay County Electric Cooperative Corperation",[-90.93591777530943, 36.24152034340279]],
    [ "Clay County Electric Cooperative Corperation",[-90.93882586255256, 36.285124474394486]],
    [ "Corning Substation",[-90.57437521997582, 36.42058146767613]],
    [ "1204086338",[-90.37235173227815, 36.43502837492404]],
    [ "Entergy Arkansas",[-90.2894615416878, 36.497486874779646]],
    [ "Texas Eastern Substation",[-90.28900809999998, 36.4976131]],
    [ "TE Pipeline Substation",[-90.28901164999999, 36.49736995]],
    [ "Clay County Electric Cooperative Corporation",[-91.09469974585147, 36.35721189718608]],
    [ "1204159389",[-93.91762388151867, 40.42481045507056]],
    [ "1204162693",[-87.46887945, 41.49547359999999]],
    [ "1204172793",[-87.46102115, 41.5034361]],
    [ "1204178465",[-87.46500154746518, 41.4647672250326]],
    [ "1204187870",[-87.49670725, 41.478651899999996]],
    [ "Knoxville Utilities Board",[-84.22418711304508, 36.03657284473362]],
    [ "Richards Gebaur AFB #2 Substation",[-94.54312728107082, 38.82999685740425]],
    [ "Grandview City Substation",[-94.52698837960904, 38.88307858891922]],
    [ "1204342414",[-101.81754255, 47.2236692]],
    [ "Butte Electric Cooperative",[-103.85099927493253, 44.691536337777436]],
    [ "Butte Electric Cooperative",[-103.60492217510827, 44.73478086188916]],
    [ "Boxboard Substation",[-86.28691195543118, 44.213366746362475]],
    [ "Filer City",[-86.28846796195167, 44.2171014260024]],
    [ "Walnut Ridge Substation",[-90.99041597313916, 36.061486098607915]],
    [ "Lynn Substation",[-91.25230732018296, 36.00533150063769]],
    [ "Lindeman Substation",[-86.27248008134121, 44.201476424016775]],
    [ "1204409585",[-96.14132673560097, 41.13321843155082]],
    [ "1204409592",[-96.1536146, 41.13604074999999]],
    [ "150th St & Capehart Rd Substation",[-96.14665654916678, 41.11689648873003]],
    [ "1204414308",[-95.93760245393224, 40.94375733108829]],
    [ "1204417208",[-96.38758522012346, 40.42123610212773]],
    [ "1204417210",[-96.31224980999684, 40.81308166898282]],
    [ "1204417212",[-96.1791840295021, 40.87160580231011]],
    [ "1204417214",[-96.15452925858888, 41.00497783491239]],
    [ "1204435278",[-96.12233262111708, 40.47949457471401]],
    [ "1204486455",[-91.15893768072839, 36.1386917354199]],
    [ "Pangburn Substation",[-91.8248088062718, 35.430349165012835]],
    [ "Entergy Arkansas",[-91.81943031279368, 35.250648125025805]],
    [ "Moorefield Substation",[-91.58513096009506, 35.76966464673842]],
    [ "Fox Farm Substation",[-86.29326176781014, 44.190078493539865]],
    [ "PSE&G",[-74.4031051307954, 40.527167458759436]],
    [ "1204542557",[-74.42982359183311, 40.510276894960974]],
    [ "DRT Substation",[-74.45775977743948, 40.55243817690935]],
    [ "Barclays Substation",[-74.4582964220122, 40.54677265939111]],
    [ "1204560756",[-95.39472112872792, 41.00178295437523]],
    [ "1204560758",[-95.40377519045549, 40.88781512503268]],
    [ "1204560763",[-95.3775504687248, 40.77138176485131]],
    [ "1204563076",[-87.336856330693, 41.50767027498188]],
    [ "1204564106",[-87.36092396390887, 41.51370598819007]],
    [ "Ross Substation",[-87.38497206062748, 41.529562475047335]],
    [ "Consumers Energy",[-86.43998545945212, 43.944509688127816]],
    [ "Consumers Energy",[-86.44020712619239, 43.94278136539789]],
    [ "Consumers Energy",[-86.42343955368436, 43.93964051531982]],
    [ "Oriole Substation",[-86.45407859608791, 43.96750459206653]],
    [ "Consumers Energy",[-86.43627281057631, 43.96468689834547]],
    [ "Calico Rock Substation",[-92.12512681775091, 36.18476178951429]],
    [ "North Arkansas Electric Cooperative",[-92.37476302323168, 36.31396234120426]],
    [ "Monkey Run Substation",[-92.46936221018039, 36.34254432555408]],
    [ "Three Brothers Substation",[-92.4871936171818, 36.48359881776825]],
    [ "Flippin Substation",[-92.60421374754385, 36.29937438660961]],
    [ "Summit Substation",[-92.69015259578214, 36.242641129842134]],
    [ "First Electric Cooperative",[-92.65580217511673, 35.90954889489422]],
    [ "Arkansas Electric Cooperative Corporation",[-92.49223210114313, 35.6147082804916]],
    [ "Entergy Arkansas",[-92.49287606396214, 35.615029387863885]],
    [ "Petit Jean Electric Cooperative Corporation",[-92.32846419635268, 35.648168944898835]],
    [ "Petit Jean Electric Cooperative Corporation",[-92.3036902747879, 35.58967615998934]],
    [ "1204669171",[-80.68443419612181, 39.27269939130785]],
    [ "1204669178",[-80.72604950374047, 39.27968326464631]],
    [ "1204669184",[-80.66652208078048, 39.308586755818816]],
    [ "1204669194",[-80.30393894340834, 39.23926911885778]],
    [ "1204669196",[-80.18677028317748, 39.28574660123226]],
    [ "Station 103",[-77.60367074999999, 43.194788749999994]],
    [ "Carroll Electric Cooperative Corporation",[-93.80949710171005, 36.270173559838874]],
    [ "Carroll Electric Cooperative Corporation",[-93.35711391607934, 36.54017677572289]],
    [ "Carroll Electric Cooperative Corporation",[-93.41743238357765, 36.512171440263565]],
    [ "Carroll Electric Cooperative Corporation",[-93.8274598741632, 36.40430834905548]],
    [ "Energy Arkansas",[-93.58877137420502, 36.449508518660174]],
    [ "Friutpacker Substation",[-86.39671960240523, 43.865321479322574]],
    [ "Bass Lake Substation",[-86.39846936755848, 43.83368841978342]],
    [ "Pentwater Substation",[-86.42870034999999, 43.77557475]],
    [ "Pentwater Wire Substation",[-86.43088968879174, 43.777430663626575]],
    [ "Hart Substation",[-86.37895416524758, 43.70367198146998]],
    [ "Hart Municipal Substation",[-86.37446318091239, 43.70025647727082]],
    [ "City of Hart",[-86.36615039253824, 43.70444198574306]],
    [ "1204791274",[-107.85847568441413, 37.125544367639634]],
    [ "1204791282",[-108.06245242269867, 37.013484011184275]],
    [ "Hart Industrial Substation",[-86.36847210278447, 43.68492840129536]],
    [ "Shelby Substation",[-86.36843338838075, 43.609007611430435]],
    [ "Rothbury Substation",[-86.34962944527715, 43.50665982768986]],
    [ "Carroll Electric Cooperative Corporation",[-94.01708777622041, 36.40724234293956]],
    [ "Carroll Electric Cooperative Corporation",[-94.1329496107311, 36.41737185466645]],
    [ "Bella Vista Substation",[-94.24353205, 36.47188635]],
    [ "Carroll Electric Cooperative Corporation",[-94.30792056435499, 36.387189926246336]],
    [ "Carroll Electric Cooperative Corporation",[-94.33915572545999, 36.37430944560417]],
    [ "1204893301",[-95.35555378178908, 42.00923939155227]],
    [ "1204893306",[-95.42046287983008, 42.15286584049716]],
    [ "1204893310",[-95.33261767842941, 42.002028738391964]],
    [ "1204893316",[-95.44241562486114, 41.63868501244649]],
    [ "1204900112",[-95.59469538690381, 42.00095392478671]],
    [ "1204936106",[-96.02007929111821, 42.00774717473102]],
    [ "1204936112",[-96.09431218216514, 42.02495161524953]],
    [ "Consumers Energy",[-86.34534088375462, 43.43308416491405]],
    [ "1204962490",[-86.3489093557864, 43.43354041181468]],
    [ "Station 90",[-77.49686532890487, 43.232560185945495]],
    [ "Dearborn Machine Substation",[-86.37141767587507, 43.41110288979494]],
    [ "Consumers Energy",[-86.34121615865676, 43.39007131153613]],
    [ "Whitehall Substation",[-86.35050240000001, 43.3995656]],
    [ "Bentonville Electrical Utility Department",[-94.20796778143341, 36.3664908457945]],
    [ "Bentonville Electrical Utility Department",[-94.18848334066487, 36.36785872092321]],
    [ "Bentonville Electrical Utility Department",[-94.1210216845053, 36.35484087511149]],
    [ "Shipe Road Substation",[-94.35452153785926, 36.358202546875624]],
    [ "Centerton Substation",[-94.2763598753308, 36.357600141803246]],
    [ "Benston Substation",[-86.31676563114584, 43.40331789659565]],
    [ "1205032739",[-96.16453594999999, 42.2279224]],
    [ "1205032744",[-96.26798929464655, 42.50474794893784]],
    [ "1205032757",[-96.25277222212956, 42.604447562649284]],
    [ "1205055084",[-95.6044196125648, 42.068260563225216]],
    [ "1205055086",[-95.59521914999999, 42.09481275]],
    [ "1205055169",[-96.1174487166733, 41.998267677754754]],
    [ "1205055421",[-96.08717914999998, 42.0973009]],
    [ "1205069981",[-95.71287077296937, 41.6695599791233]],
    [ "1205069990",[-95.7013189916732, 41.73831487501952]],
    [ "1205069994",[-95.93398970307575, 41.675170825907095]],
    [ "1205084883",[-95.88837490797953, 41.55025994153612]],
    [ "1205103426",[-96.02203297472495, 41.632238044209025]],
    [ "1205103431",[-96.01174824012497, 41.80894832061335]],
    [ "1205103433",[-96.02137415, 41.907405600000004]],
    [ "1205104048",[-95.83249325945216, 41.78679837040551]],
    [ "1205105513",[-95.47932490000001, 41.5491629]],
    [ "1205105527",[-95.38477863366646, 41.3535104669886]],
    [ "1205229869",[-87.5232067, 41.49185585]],
    [ "Lake Hills",[-87.43129681367093, 41.46449471906476]],
    [ "Schererville",[-87.40247207847581, 41.48749247176828]],
    [ "1205250084",[-87.36612707510164, 41.4752024022517]],
    [ "Carroll Electric Cooperative Corporation",[-94.42943667547037, 36.29462884531813]],
    [ "Carroll Electric Cooperative Corporation",[-94.28720959026072, 36.22838709600068]],
    [ "Carroll Electric Cooperative Corporation",[-94.1702857169158, 36.24811795360607]],
    [ "Carroll Electric Cooperative Corporation",[-94.01207383375632, 36.357234917232624]],
    [ "Carroll Electric Cooperative Corporation",[-94.16796809251255, 36.28210776953186]],
    [ "Carroll Electric Cooperative Corporation",[-94.17083383961015, 36.31312396952622]],
    [ "Carroll Electric Cooperative Corporation",[-94.20431406191555, 36.32309247320286]],
    [ "Ozarks Electric Cooperative Corporation",[-94.1919947165615, 36.17636420881618]],
    [ "1205328847",[-87.33085005000001, 41.46655515]],
    [ "1205328849",[-87.33502609436881, 41.45973982763677]],
    [ "1205345176",[-87.3159834419345, 41.465906594014285]],
    [ "1205348948",[-95.38495585930951, 41.30076158684174]],
    [ "1205348950",[-95.4028567718118, 41.19310568546356]],
    [ "1205353370",[-87.27064455, 41.4679056]],
    [ "1205358260",[-95.13273642216862, 41.76031407530719]],
    [ "1205358337",[-95.1948344878765, 40.81441916972748]],
    [ "1205358893",[-87.34969726061436, 41.45171997507771]],
    [ "1205359133",[-87.36971206362576, 41.449816324735195]],
    [ "1205359415",[-95.3280962249564, 41.3461422623134]],
    [ "1205359418",[-95.18339404999999, 41.27432285]],
    [ "1205360629",[-95.20912908140848, 41.77757666405368]],
    [ "1205360632",[-95.01493003552567, 41.89155187476497]],
    [ "1205360633",[-95.07396633620924, 41.91286606881739]],
    [ "1205360637",[-94.89837122572985, 41.935507744096476]],
    [ "1205360638",[-94.87859367214178, 41.93538499609937]],
    [ "1205367511",[-94.87870525000001, 41.92177915]],
    [ "1205367518",[-94.95684025932914, 41.616566137068816]],
    [ "1205367519",[-95.14989907813448, 41.63801194734464]],
    [ "1205367526",[-95.28753697072858, 41.638753075165326]],
    [ "1205367530",[-95.33362307496508, 41.62450079347621]],
    [ "1205367531",[-95.31497050505722, 41.644443871464844]],
    [ "1205367532",[-95.31477207796257, 41.644740564900566]],
    [ "1205454561",[-95.39150302528954, 42.16809095404527]],
    [ "1205454570",[-95.43969705797281, 42.32464207516288]],
    [ "1205459487",[-96.2892124092359, 42.250426674743075]],
    [ "1205459488",[-96.25242159999998, 42.15676899999999]],
    [ "1205459785",[-96.23188139999999, 42.286278100000004]],
    [ "1205472873",[-96.06336595000002, 42.50399699999999]],
    [ "1205472876",[-96.21431174246592, 42.50452922500161]],
    [ "1205472879",[-95.97764125938504, 42.583409175225]],
    [ "1205518570",[-80.74163116033392, 39.81729186093513]],
    [ "1205518574",[-80.81072966819353, 39.85031215026345]],
    [ "1205518578",[-80.79056286661177, 39.85502068030296]],
    [ "Hanover Station",[-87.45177503736144, 41.42054286021452]],
    [ "1205527971",[-94.23716648205513, 36.21034576452854]],
    [ "Goshen Substation",[-94.00282213921734, 36.10733617446048]],
    [ "Ozarks Electric Cooperative Corporation",[-94.00161539034741, 35.971570675654156]],
    [ "Arkansas Electric Cooperative Corporation",[-94.11225119308037, 36.125548029837574]],
    [ "1205583990",[-94.11315705910236, 36.12563689601315]],
    [ "Ozarks Electric Cooperative Corporation",[-94.09037572262032, 36.04603285815181]],
    [ "Palmira Sub",[-87.48840042435215, 41.43242409706341]],
    [ "Cedar Lake Substation",[-87.42125515632374, 41.37869257112582]],
    [ "Court Substation",[-87.36841759117104, 41.39875441839059]],
    [ "1205650843",[-87.35531762826979, 41.40944727518612]],
    [ "1205666570",[-95.94218550866204, 42.45858317079458]],
    [ "1205666573",[-96.01865080000002, 42.342366150000004]],
    [ "1205666576",[-95.87318843140186, 42.382018414226316]],
    [ "1205666578",[-95.81018712499893, 42.34175004686205]],
    [ "1205667780",[-95.4968656, 42.3996626]],
    [ "1205667783",[-95.40773005, 42.47948975]],
    [ "Creston",[-87.4602558135705, 41.333517174975476]],
    [ "1205845885",[-87.46194279999999, 41.37692385]],
    [ "1205858327",[-87.318249, 41.38720475]],
    [ "1205858329",[-87.31753885000002, 41.384203400000004]],
    [ "Lowell Sub",[-87.42030359819634, 41.29602469450799]],
    [ "1205883635",[-87.43773712509085, 41.29117318776836]],
    [ "1205894516",[-87.48594777867326, 41.26193865360464]],
    [ "1205897699",[-87.4484367, 41.18149835]],
    [ "1205903922",[-87.35281479999999, 41.289919299999994]],
    [ "Plainfield Substation",[-74.42365590981484, 40.61676763031669]],
    [ "South Second Street Substation",[-74.44436550036433, 40.60240057271596]],
    [ "Keasbey Substation",[-74.2907409655719, 40.52111871743221]],
    [ "South 5th Street Substation",[-74.1534716742149, 40.74310287540788]],
    [ "1205948581",[-87.23722185102173, 41.17378945590616]],
    [ "DeMotte Substation",[-87.15132960036415, 41.17270248557751]],
    [ "Sutton Substation",[-87.23708501670284, 41.14940022507616]],
    [ "1205985204",[-87.46355810000001, 40.7715046]],
    [ "Burgess BioPower",[-71.1747198, 44.47113864999999]],
    [ "Community Field Substation",[-71.17691367018404, 44.470857457372794]],
    [ "1206021385",[-94.71716806331816, 41.92770146904915]],
    [ "1206021386",[-94.73604777500091, 42.04984780501431]],
    [ "1206024133",[-71.18596352501397, 44.44745598496453]],
    [ "Forest Grove Substation",[-85.87130174478717, 42.833944536311115]],
    [ "1206121063",[-87.15285159999999, 40.75532155]],
    [ "Lincoln Substation",[-94.43100094999998, 35.9595255]],
    [ "Carroll Electric Cooperative",[-94.25200315981448, 36.279959912510506]],
    [ "Great Lakes Hydro America",[-71.19025244868648, 44.3997795461551]],
    [ "1206242203",[-87.20960082853959, 40.92667814620163]],
    [ "1206243649",[-87.16154505000002, 40.9260321]],
    [ "1206246306",[-87.15958726241305, 40.911435274861994]],
    [ "Allendale Substation",[-86.0126794827919, 42.94313126621436]],
    [ "1206279763",[-87.14101127488834, 40.9475546954984]],
    [ "1206279765",[-87.15497679422668, 40.9401242326534]],
    [ "1206281974",[-87.15226815863168, 41.02292897072545]],
    [ "Parr Substation",[-87.15216689999998, 41.02318855]],
    [ "Savidge Substation",[-86.15502210287033, 43.07859362826046]],
    [ "1206301052",[-77.89772244579369, 37.82991731654697]],
    [ "Lake Filtering Substation",[-86.2164225959818, 42.97091532757048]],
    [ "Sloan Substation",[-83.7358769, 43.02627759999999]],
    [ "BAE Systems Ordnance Systems Inc.",[-82.63387075, 36.543269]],
    [ "Moody Substation",[-87.01692562503378, 40.992450716703694]],
    [ "1206371717",[-87.44880484999999, 40.788969]],
    [ "1206377992",[-87.3881929249469, 40.76596415562982]],
    [ "Enterprise Products Operating LLC",[-90.90418436091595, 35.924643475689095]],
    [ "Texas Eastern Transmission, LP",[-90.90401935, 35.92484765]],
    [ "1206437761",[-87.31797743814475, 40.614192930292624]],
    [ "Southwest Arkansas Electric Cooperative",[-93.95499069411153, 33.10554481907182]],
    [ "1206450810",[-94.03929701307544, 33.329749424500875]],
    [ "Boggy Substation",[-93.8883688464365, 33.22556106947259]],
    [ "Southwest Arkansas Electric Cooperative",[-93.94175493252091, 33.42711942483875]],
    [ "1206450819",[-94.08477311773912, 33.5179916345488]],
    [ "1206450821",[-94.0864885, 33.4800593]],
    [ "1206450822",[-94.03723319241256, 33.41426411019449]],
    [ "1206469355",[-94.04192302240125, 33.417479535998524]],
    [ "Southwestern Electric Power Company",[-94.00526992553893, 33.42305874314571]],
    [ "Cooper Tire & Rubber Company",[-94.00358703207957, 33.42111189657282]],
    [ "Cooper Tire & Rubber Company",[-94.00358302572273, 33.41992669517008]],
    [ "Templeton Substation",[-87.2220929144098, 40.518761656088735]],
    [ "1206498546",[-87.34212020752874, 40.521424806491744]],
    [ "Hager Park Substation",[-85.88367901237125, 42.927309758612246]],
    [ "Van Buren Substation",[-85.90190491986503, 42.88025071924452]],
    [ "Ivanrest Substation",[-85.73575568764704, 42.883063205443044]],
    [ "C&L Electric Cooperative Corporation",[-91.34032362386287, 33.812125695072844]],
    [ "Jonesboro City Water and Light",[-90.70843007277347, 35.84499316740545]],
    [ "Jonesboro City Water and Light",[-90.68412137478627, 35.80372920838037]],
    [ "1206560131",[-90.36765467498182, 35.84393114060656]],
    [ "Kramer Substation",[-87.31946634999998, 40.315358749999994]],
    [ "1206601538",[-87.25205905272142, 40.29545058350754]],
    [ "Corn Belt Power Cooperative",[-94.93595156915426, 42.19624347532851]],
    [ "1206605975",[-87.43444027492308, 40.41080965931638]],
    [ "1206611461",[-95.86512267500149, 42.18280090458477]],
    [ "1206611462",[-95.79156782483886, 42.15378165828128]],
    [ "1206611463",[-95.6004284, 42.314008599999994]],
    [ "1206613532",[-87.13150955000002, 40.40831305]],
    [ "1206616427",[-96.30171623736376, 42.627213563577655]],
    [ "1206616433",[-96.05639719216782, 42.6638163752338]],
    [ "1206616441",[-95.97113329614028, 42.81646433036378]],
    [ "1206616442",[-96.0754031749459, 42.866588658762595]],
    [ "1206619883",[-87.15562280546665, 40.56157372906012]],
    [ "Memphis Light, Gas and Water",[-90.09575521280694, 35.04352391035022]],
    [ "Hyosung HICO, Ltd. Company",[-90.10038652696225, 35.07295963912658]],
    [ "1206645169",[-90.13507057446044, 35.08657073991987]],
    [ "1206657706",[-95.76050794393282, 42.677140646498586]],
    [ "1206657718",[-95.61341575000002, 42.6698837]],
    [ "PPL",[-75.54525045, 41.72622085]],
    [ "Station 148",[-77.28856492080648, 42.900547412425595]],
    [ "Richland Substation",[-96.68844910939447, 42.7717373794673]],
    [ "1206730400",[-87.25610579822303, 40.28734456652621]],
    [ "North End-63 Substation",[-72.51835441048713, 44.20563210203834]],
    [ "Station 63",[-77.6752831141869, 43.13621108982738]],
    [ "Unitil",[-71.10532605348106, 42.83131855961935]],
    [ "Unitil",[-71.09278560747723, 42.84269045940959]],
    [ "Unitil",[-71.09765265774321, 42.854025267992]],
    [ "Unitil",[-71.09174143542118, 42.88524916425326]],
    [ "Unitil",[-71.05331334186371, 42.91859938806427]],
    [ "Unitil",[-71.03492904999999, 42.93033085]],
    [ "Unitil",[-71.01796382883764, 42.94009266132255]],
    [ "1206990883",[-89.8936801, 35.030744600000006]],
    [ "1207037335",[-87.1476749, 40.20265225]],
    [ "1207039774",[-87.14958252885825, 40.126964910872275]],
    [ "1207041027",[-87.20144132955673, 40.12774850758071]],
    [ "1207042698",[-87.2438055856246, 40.12088934863614]],
    [ "1207042700",[-87.24634215427925, 40.11855079927415]],
    [ "1207046779",[-87.40054429523893, 40.137558829432464]],
    [ "1207046813",[-87.43283044062488, 40.13476157524826]],
    [ "1207049281",[-87.4333291657048, 40.2502929750728]],
    [ "1207136456",[-92.62390811899253, 42.731499389593296]],
    [ "1207167110",[-87.11204349231434, 40.31637300664246]],
    [ "Taylor Substation",[-86.93414887146676, 40.341219329704685]],
    [ "1207187389",[-87.0911914833483, 40.113815033317735]],
    [ "Memphis Light, Gas and Water",[-89.89190238202586, 35.1577230358939]],
    [ "Memphis Light, Gas and Water",[-89.83709288024598, 35.18932510126825]],
    [ "Chelsea Substation",[-89.94981939880155, 35.17295667170974]],
    [ "William Substation",[-74.32874113134484, 40.822411361517915]],
    [ "Stouts Lane Substation",[-74.56853723687568, 40.38198936015806]],
    [ "Dow Jones Substation",[-74.5867960591009, 40.36828301435745]],
    [ "Ridge Road Substation",[-74.60099550246157, 40.36602063397738]],
    [ "1207232109",[-75.04474762421118, 39.98696353666517]],
    [ "East Riverton Substation",[-75.00691461834651, 40.01600424014798]],
    [ "Constable Hook Substation",[-74.10070236898186, 40.65898829645293]],
    [ "Bayonne Energy Center",[-74.0906158814014, 40.65254236845133]],
    [ "Hamilton Substation",[-74.72797117602438, 40.23578367920799]],
    [ "1207292238",[-87.26193004999999, 39.96773125]],
    [ "Consumers Energy",[-85.69367956058313, 42.94957392452181]],
    [ "1207326390",[-85.66601281237004, 40.06033207198575]],
    [ "Consumers Energy",[-85.7067379088432, 42.937991583530824]],
    [ "Burlingame Substation",[-85.69929594394803, 42.902218825200244]],
    [ "Memphis Light, Gas and Water",[-90.05010690012766, 35.15384382710576]],
    [ "Memphis Light, Gas and Water",[-89.71019576317936, 35.272619394783135]],
    [ "1207554523",[-89.95880635165034, 35.27302918271373]],
    [ "1207570373",[-89.97742737376767, 35.264375657213066]],
    [ "1207570777",[-86.8099625500506, 40.48448257978658]],
    [ "1207578286",[-86.872169, 40.53090824999999]],
    [ "Hillsboro Substation",[-85.97479803521625, 35.40230663077413]],
    [ "Chester Creek Substation",[-88.51469653816488, 35.47245834160051]],
    [ "Steelcase Substation",[-85.63659322225814, 42.89186456281421]],
    [ "1207640748",[-96.29252613854118, 34.59164278085453]],
    [ "1207640750",[-96.47655186737862, 34.62386152890333]],
    [ "Diesel Tech Substation",[-85.55634484356344, 42.87850901179474]],
    [ "1207771062",[-86.79893163494673, 39.91427586794626]],
    [ "1207780392",[-86.80330473830483, 39.851687175155156]],
    [ "1207807971",[-104.5152697497815, 33.321804779794334]],
    [ "Eutawville Substation",[-80.34985820198972, 33.39013758015012]],
    [ "Canadaville Substation",[-89.5932997843337, 35.14535461764282]],
    [ "Grand Junction Substation",[-89.18665721040763, 35.059748675184345]],
    [ "Tippah Electric Power Association",[-88.8961409, 35.0253039]],
    [ "Ramer Substation",[-88.63182643666912, 35.065462355014986]],
    [ "1207841410",[-86.26667573393388, 39.96266433631486]],
    [ "1207841412",[-86.36002076937115, 40.000836140821185]],
    [ "1207871821",[-86.61775922168957, 39.92250241592105]],
    [ "1207876789",[-86.5822447358951, 40.053813568740665]],
    [ "1207882057",[-86.50072950921172, 40.01070005981716]],
    [ "Clarks Hill Substation",[-86.71997662874334, 40.243870960271565]],
    [ "1207893480",[-84.43716295161559, 36.669726325350716]],
    [ "44th Street Substation",[-85.57422557529388, 42.88831900729839]],
    [ "Nye Avenue Substation",[-74.22175720725384, 40.722397429540166]],
    [ "Vauxhall Substation",[-74.25084866337683, 40.69687059174709]],
    [ "Albany Street Substation",[-74.43831857824412, 40.49241730477064]],
    [ "Oak Street Substation",[-74.14017239675249, 40.85809114034841]],
    [ "Van Houten Substation",[-74.14636424961537, 40.857380209335936]],
    [ "BMS Lawrenceville Substation",[-74.70817762501805, 40.32500233552465]],
    [ "Transco Station Lawrence Substation",[-74.73321199752378, 40.337706803319534]],
    [ "Johnson and Johnson Skillman Substation",[-74.71031865200918, 40.42869558165888]],
    [ "Pleasant Street Substation",[-74.2601894631056, 40.62034012599731]],
    [ "Orange Valley Substation",[-74.24624973166779, 40.76439297638308]],
    [ "PSE&G",[-74.26311089826693, 40.742308289732875]],
    [ "Lakeside Substation",[-74.22689165080207, 40.780255214502716]],
    [ "Plauderville Substation",[-74.10320613477866, 40.895402016719764]],
    [ "19th Ave Substation",[-74.20971996666452, 40.73102449491033]],
    [ "Oakland Substation",[-89.50109272308825, 35.228393304213434]],
    [ "Hornsby Substation",[-88.82108806496294, 35.220915017960984]],
    [ "Mid Valley Pipeline Company LLC",[-88.7668152267129, 35.25602662454481]],
    [ "Bolivar Energy Authority",[-88.92621938028658, 35.19019977646604]],
    [ "West Adairsville Switching Station",[-88.41872800068231, 35.252456262346264]],
    [ "1208036693",[-86.54371594929988, 40.28183082999111]],
    [ "1208049150",[-86.50754111341494, 40.268949565795126]],
    [ "1208081499",[-86.60937352509949, 40.41673064128086]],
    [ "Pike Substation",[-86.47485305000001, 40.12604545]],
    [ "Anson North Substation",[-86.36609299005808, 39.97567492513802]],
    [ "North Adairsville Substation",[-88.37323950554405, 35.24574731817279]],
    [ "Pickwick Electric Cooperative",[-88.37378309769403, 35.35770876792482]],
    [ "Pickwick Electric Cooperative",[-88.3736676, 35.357063249999996]],
    [ "Tennessee Valley Authority",[-88.19878162573359, 35.23008758458382]],
    [ "1208130524",[-88.68672200668455, 35.470925217419484]],
    [ "Southwest Tennessee Electric Membership Corporation",[-88.79225939302975, 35.55275071369712]],
    [ "1208134141",[-86.34265044031604, 39.99564098108207]],
    [ "Southwest Tennessee Electric Membership Corporation",[-89.03736937337142, 35.574920042669454]],
    [ "Tennessee Valley Authority",[-88.934267147763, 35.594651007108524]],
    [ "Jackson Energy Authority",[-88.93463678172635, 35.5949029698612]],
    [ "Tennessee Valley Authority",[-88.9047046, 35.6406948]],
    [ "Jackson Energy Authority",[-88.90479455898861, 35.63984752894106]],
    [ "Sand Ridge Substation",[-88.4736465227537, 35.69040445882326]],
    [ "Tennessee Valley Authority",[-88.37945220494426, 35.71971921298153]],
    [ "Lexington Electric System",[-88.3789420822147, 35.71919933714316]],
    [ "Lexington Electric System",[-88.37858249881536, 35.67044796717971]],
    [ "Lexington Electric System",[-88.15402952608704, 35.46546661229445]],
    [ "1208192444",[-92.56304085545632, 40.196425614972846]],
    [ "Holloday Substation",[-88.1590222689202, 35.886634193458505]],
    [ "Meriwether Lewis Electric Cooperative",[-87.96841780662474, 36.02174819888605]],
    [ "Tennessee Valley Authority",[-87.98326926770949, 36.03681458992377]],
    [ "Tennessee Valley Authority",[-87.9851643203707, 36.03687556086291]],
    [ "1208246624",[-88.50897305, 36.15717800000001]],
    [ "Paris Utility Authority",[-88.51259094085083, 36.16290052468888]],
    [ "1208246631",[-88.36182525000001, 36.30200885000001]],
    [ "Paris Utility Authority",[-88.34194670099095, 36.313897874536465]],
    [ "Paris Utility Authority",[-88.30892369425243, 36.279761049581175]],
    [ "Paris Utility Authority",[-88.26268321582516, 36.30900200729208]],
    [ "Paris Utility Authority",[-88.28053981722698, 36.300783765778355]],
    [ "Paris Utility Authority",[-88.29411175242873, 36.31339888617328]],
    [ "Paris Utility Authority",[-88.32277982489252, 36.32548170816071]],
    [ "Paris Utility Authority",[-88.16071720173125, 36.27925346661043]],
    [ "Tennessee Valley Authority",[-88.75925032611838, 35.93133354468751]],
    [ "Trenton Light & Water Department",[-88.9491308621919, 35.977623645457875]],
    [ "Humboldt Utilities",[-88.92980780813001, 35.84569922521714]],
    [ "Southwest Tennessee Electric Membership Corporation",[-88.90750456299301, 35.7218421232967]],
    [ "Gibson Electric Membership Corporation",[-88.81095842486134, 35.81927748847378]],
    [ "Gerdau Ameristeel US Inc.",[-88.80948216204773, 35.72981990877069]],
    [ "Gibson Electric Membership Corporation",[-89.11555368990541, 35.792833497098094]],
    [ "Alamo Substation",[-89.1144271918572, 35.793413257431936]],
    [ "Brohman Substation",[-85.70151505185032, 43.68081775330421]],
    [ "1208385306",[-93.4230632845699, 43.55837972530646]],
    [ "Pierson Substation",[-85.3735142733391, 43.35252244002664]],
    [ "Piedmont Substation",[-103.3812529640594, 44.22418120620444]],
    [ "SR DeSoto I, LLC",[-83.99801071877803, 31.866471006840918]],
    [ "1208438575",[-83.99693429999999, 31.865774100000003]],
    [ "Americus Solar LLC",[-84.07706392281192, 31.92785695752974]],
    [ "Mason Substation",[-89.54985458106508, 35.409568592114375]],
    [ "Halls Substation",[-89.42872445277449, 35.87957163079492]],
    [ "Ripley Substation",[-89.52013532627475, 35.75035305927304]],
    [ "1208483123",[-86.42188889725281, 40.02627600664869]],
    [ "1208484726",[-86.4106506, 40.039845899999996]],
    [ "1208489494",[-86.46440386726555, 40.043391824006484]],
    [ "Tipton 69 kV Substation",[-86.05201944171934, 40.28225162403858]],
    [ "Titan Tire Inc",[-89.05776672450263, 36.45200981109144]],
    [ "1208534471",[-89.17971680523566, 36.546123287406466]],
    [ "1208534473",[-89.21057540919105, 36.559330373821666]],
    [ "1208534477",[-88.97256712272865, 36.38520385448189]],
    [ "Tennessee Valley Authority",[-88.97128022991367, 36.38513040364051]],
    [ "Windfall Substation",[-85.95713289826503, 40.334516925636876]],
    [ "Bradley Substation",[-85.55968843142897, 42.643563561389165]],
    [ "Winters",[-121.95113689174495, 38.517593985540934]],
    [ "Arcadia North Substation",[-86.06958767502714, 40.19803889170385]],
    [ "Arcadia Substation",[-86.06985230000001, 40.161584749999996]],
    [ "1208786617",[-86.07573217173311, 40.10114117473137]],
    [ "1208787092",[-117.05910375408375, 34.14561370265994]],
    [ "1208795149",[-86.13512624889131, 40.10233142966631]],
    [ "Sheridan Substation",[-86.17669529999999, 40.11517550000001]],
    [ "1208814876",[-86.33658509832026, 40.12852183889232]],
    [ "1208826042",[-96.9060197, 42.79709995]],
    [ "1208848882",[-86.36208100000002, 40.19786774999999]],
    [ "Gibson Electric Membership Corporation",[-88.90051231380667, 36.46214913142773]],
    [ "Benton County Electric System",[-88.08872219247948, 36.047506451200064]],
    [ "1208849025",[-88.26141916893695, 36.042875350932114]],
    [ "1208862420",[-86.39335136692453, 40.33096234920064]],
    [ "1208878531",[-86.17387215767738, 40.068380621159626]],
    [ "1208882031",[-86.18301287998028, 40.03232966129686]],
    [ "1208895968",[-86.2007527334974, 39.989073266821855]],
    [ "1208899529",[-86.13546834377357, 39.99250312607872]],
    [ "Jackson Energy Authority",[-88.77723035306646, 35.623952852816345]],
    [ "1209119441",[-88.73904988170341, 35.68720857602076]],
    [ "Jackson Energy Authority",[-88.82498943013482, 35.580609836748884]],
    [ "Jackson Energy Authority",[-88.90067456728528, 35.61481267962425]],
    [ "Jackson Energy Authority",[-88.82901350690865, 35.60698800812432]],
    [ "Jackson Energy Authority",[-88.81100272450792, 35.604391957281244]],
    [ "Jackson Energy Authority",[-88.78790946758544, 35.62481494948886]],
    [ "Jackson Energy Authority",[-88.77567286625262, 35.60332017528128]],
    [ "Jackson Energy Authority",[-88.80232151443246, 35.63693428638124]],
    [ "Jackson Energy Authority",[-88.8285220069219, 35.632653590398846]],
    [ "Jackson Energy Authority",[-88.83144371478461, 35.63039244062483]],
    [ "Jackson Energy Authority",[-88.84132309523056, 35.625374382694744]],
    [ "1209119509",[-88.77638485000001, 35.66142645]],
    [ "Jackson Energy Authority",[-88.83064967539144, 35.6999555627489]],
    [ "Jackson Energy Authority",[-88.85996725, 35.735853299999995]],
    [ "Jackson Energy Authority",[-88.891378, 35.66861415]],
    [ "1209177551",[-88.90907364615158, 35.63989832430302]],
    [ "Bradford Substation",[-88.82167071188448, 36.078588615552775]],
    [ "1209177571",[-89.03173682354867, 36.20363431378548]],
    [ "1209355967",[-86.0162066454562, 40.03046417515449]],
    [ "1209443419",[-98.35760135, 36.762124650000004]],
    [ "1209443625",[-96.37178215000002, 36.4196951]],
    [ "1209444166",[-96.21183009999999, 36.31595395]],
    [ "1209444569",[-96.40690652936952, 36.01220567397051]],
    [ "1209445161",[-95.92590171499937, 41.12005360744168]],
    [ "Upper Beaver Substation",[-112.48173138028467, 38.26813417632066]],
    [ "1209453195",[-112.52291210989355, 36.97135068264503]],
    [ "1209455960",[-116.26999090701507, 33.69918524635099]],
    [ "1209556061",[-85.52808432182049, 40.0252950744899]],
    [ "South Summitville Station",[-85.6534813, 40.29982155]],
    [ "1209613756",[-85.6940041997692, 40.06275946956524]],
    [ "1209745831",[-85.72960962530323, 40.09149922271729]],
    [ "32d Street Station",[-85.66639244999999, 40.0833443]],
    [ "1209768369",[-85.65885193869137, 40.08413032496603]],
    [ "Burnet Avenue Station",[-76.12650634318487, 43.05272717027498]],
    [ "Entergy Arkansas",[-91.23935682555583, 35.65216705436207]],
    [ "1209904079",[-85.67274407081545, 40.10564711591296]],
    [ "1209908527",[-85.69727932710566, 40.097736856245675]],
    [ "1209915630",[-93.27847165, 43.55493565]],
    [ "Tennessee Valley Authority",[-88.36507217711707, 36.27114657015712]],
    [ "Lobelville Substation",[-87.77447490515942, 35.7827672891321]],
    [ "Lawrenceburg Power System",[-87.37841331888067, 35.25660468465466]],
    [ "Loretto Substation",[-87.4620308501435, 35.064573961264635]],
    [ "1210028341",[-87.00756880010007, 41.17300563497808]],
    [ "1210028342",[-87.00618025, 41.1734809]],
    [ "1210030564",[-87.7974520668628, 36.07508565270128]],
    [ "1210030579",[-87.47888025907817, 35.7695671792381]],
    [ "1210030581",[-87.29777944717698, 35.940782694487595]],
    [ "Pinewood Substation",[-87.19485776804375, 35.93644244634297]],
    [ "1210050578",[-85.6812175291436, 40.13716975859862]],
    [ "1210074495",[-85.23334781673515, 40.3352393349876]],
    [ "1210090752",[-87.17040218336217, 35.57625509918345]],
    [ "Mount Pleasant Power System",[-87.18822810587814, 35.556626020476266]],
    [ "Dunn Substation",[-87.3254169704758, 35.19802196267399]],
    [ "Lawrenceburg Power System",[-87.32466334597686, 35.198177575677306]],
    [ "1210090768",[-87.3413615, 35.2033852]],
    [ "Texas Eastern Transmission, LP",[-87.10773696600293, 35.42997612720006]],
    [ "Cocopah Substation",[-114.66604771025288, 32.7052723749778]],
    [ "1210140967",[-86.65339130334839, 35.326438405559934]],
    [ "Duck River Electric Membership Corporation",[-86.09780654715965, 35.226510945617456]],
    [ "Dechert Substation",[-86.09716138042486, 35.22760398720521]],
    [ "Nissan North America, Inc.",[-86.05328124062538, 35.21957202389825]],
    [ "1210215205",[-86.09507104734921, 35.196612479458835]],
    [ "1210215226",[-86.33872715000001, 35.061905100000004]],
    [ "Mann Road Switching Station",[-86.3499508852473, 35.10726330024577]],
    [ "Flintville Substation",[-86.41372249942027, 35.06386142934473]],
    [ "Fayetteville Public Utilities",[-86.56731561159528, 35.1258177762994]],
    [ "Tarpley Substation",[-87.00059153221997, 35.149139053221624]],
    [ "1210262733",[-86.88751391437242, 35.036557675937246]],
    [ "Maurine Substation",[-102.59397827128154, 45.023458041367924]],
    [ "Peermont Substation",[-74.74090267056287, 39.07704239426137]],
    [ "Transition to Stone Harbor/Peermont",[-74.7596401434, 39.054844172333326]],
    [ "Transition to Stone Harbor/Peermont",[-74.76806217911901, 39.05868795015622]],
    [ "Searstown Substation",[-74.56753133181998, 39.40499498142325]],
    [ "1210440459",[-113.2958349, 37.185475600000004]],
    [ "South Milford Substation",[-113.02830546691325, 38.28482697707585]],
    [ "Milford Substation",[-113.01638605559296, 38.38699707802101]],
    [ "Milbourne Substation",[-83.71603957490146, 43.045674743931144]],
    [ "Pasadena Substation",[-83.71642272229082, 43.045909593665]],
    [ "1210477194",[-87.06355593288856, 35.21691895045416]],
    [ "1210477201",[-87.06142871038783, 35.21051041482999]],
    [ "1210477205",[-87.10698316252466, 35.138762726088316]],
    [ "1210477206",[-87.04198927330357, 35.17956730409177]],
    [ "1210498508",[-97.7390816, 44.89219225]],
    [ "Nashville Electric Service",[-86.83768445, 36.1566678]],
    [ "1210571188",[-91.82027846334049, 39.17013039751887]],
    [ "Nashville Electric Service",[-86.76234219999999, 36.146816449999996]],
    [ "Pin Point Substation",[-86.60573426258249, 36.0466117118301]],
    [ "Bethel Substation",[-85.41476397508787, 40.207875886600796]],
    [ "1210627910",[-82.49726035, 42.878199499999994]],
    [ "GMI Substation",[-83.71198836051171, 43.014332903504254]],
    [ "Alto Substation",[-85.38856460000001, 42.85672280000001]],
    [ "Farmland Substation",[-85.13083954927716, 40.178053135638976]],
    [ "Waterman-Grant Line Substation",[-121.35321963370326, 38.390178074924336]],
    [ "1210796840",[-84.86273725075038, 40.186571936045084]],
    [ "1210797756",[-84.83243025, 40.19629055]],
    [ "Shugga Substation",[-84.99201075, 40.1746437]],
    [ "1210840582",[-84.95492164984955, 39.853364332448024]],
    [ "1210846742",[-91.91155333965246, 39.38199698562401]],
    [ "City of Mesa Fraser Substation",[-111.81371834999999, 33.42128915]],
    [ "1210986528",[-85.96283722740844, 37.12085504303569]],
    [ "Electric Power Board of Chattanooga",[-85.20583770000002, 35.175555700000004]],
    [ "Electric Power Board of Chattanooga",[-85.24934649999999, 35.154842949999995]],
    [ "Electric Power Board of Chattanooga",[-85.2370717, 35.128606149999996]],
    [ "Northwest Richmond Substation",[-84.9392061749861, 39.87642719332017]],
    [ "1211003965",[-84.89636487568507, 39.94723769109091]],
    [ "1211026780",[-86.88357696239343, 36.007536076762854]],
    [ "1211026811",[-86.77003693424528, 36.158026475972385]],
    [ "Gallatin Department of Electricity",[-86.49271338611982, 36.360492853828475]],
    [ "Tennessee Valley Authority",[-86.40375322651049, 36.31515386098031]],
    [ "1211067863",[-85.00924402491871, 39.819127941126354]],
    [ "1211074092",[-85.03388529408029, 39.8912854074839]],
    [ "1211085790",[-85.153752, 39.84413835]],
    [ "Hartstown Substation",[-80.37838562828473, 41.547920765302194]],
    [ "3rd & Green Substation",[-76.41612290537624, 40.3415982122159]],
    [ "Grantville Substation",[-76.64713913441973, 40.365305912297615]],
    [ "Turf Club Substation",[-76.65017530894393, 40.400694492038795]],
    [ "1211131338",[-76.56695228884386, 40.42600842151374]],
    [ "Elm Street Substation",[-79.14178756865918, 41.83875367270592]],
    [ "Mayflower Substation",[-111.43324748395622, 40.60247851077962]],
    [ "1211354338",[-85.39002366419281, 39.9321378274597]],
    [ "1211516751",[-116.19865128390828, 33.7187531251895]],
    [ "1211581788",[-85.39701738215594, 39.9291097603099]],
    [ "1211587263",[-85.36658095000001, 39.93324065]],
    [ "1211590988",[-85.35321080741782, 39.93337802493855]],
    [ "Dickson Electric System",[-87.39348183343816, 36.07466588141522]],
    [ "Dickson Electric System",[-87.39284213094052, 36.07506325625243]],
    [ "Charlotte Substation",[-87.34735371062027, 36.17722361647805]],
    [ "Cumberland Furnace Substation",[-87.36706715429193, 36.26247809991462]],
    [ "Alabama Power",[-86.32194826912428, 33.22165819604237]],
    [ "1211640675",[-85.2704683287841, 39.98741337100911]],
    [ "Springport Substation",[-85.39531390867491, 40.02594123867516]],
    [ "1211670655",[-85.78647123458401, 39.77908205011888]],
    [ "1211692550",[-85.68361408198041, 39.68233908392934]],
    [ "1211716384",[-89.30661963240489, 43.797514494539826]],
    [ "1211716386",[-89.30643052467397, 43.88585224622633]],
    [ "1211813562",[-95.67098291961736, 40.145206313381806]],
    [ "FIXME Substation",[-94.61436542522767, 38.340717241953875]],
    [ "1211967480",[-111.9892518914386, 33.21965628976778]],
    [ "Baker Substation",[-94.81470366595163, 37.368526982642656]],
    [ "South Pittsburg Switching Station",[-94.71325249956101, 37.36663666787071]],
    [ "FIXME Substation",[-94.64830611229192, 37.63303995321974]],
    [ "FIXME Substation",[-94.88784517597016, 37.826777173226176]],
    [ "FIXME Substation",[-94.95181687486007, 37.83471359176741]],
    [ "FIXME Substation",[-95.18885398017098, 37.83412136519221]],
    [ "FIXME Substation",[-94.7065746507092, 37.84440400607149]],
    [ "FIXME Substation",[-95.45274807744067, 37.67956369383593]],
    [ "Occidental Chemical Corporation",[-87.97821067938365, 36.03801490630174]],
    [ "Hood Container Corporation",[-87.93750814000691, 36.08413758008318]],
    [ "1211995895",[-87.64681492111043, 36.38622930418206]],
    [ "1211998058",[-84.57411905230983, 37.049732516822296]],
    [ "1212005095",[-87.33060088999385, 36.51319940769732]],
    [ "Tennessee Valley Authority",[-87.22444955977909, 36.31889776334632]],
    [ "Springfield Substation",[-86.87550055673312, 36.50286753070263]],
    [ "Orlinda Substation",[-86.72050228890001, 36.597403053661296]],
    [ "Greenbrier Substation",[-86.79731808172917, 36.42080826809181]],
    [ "1212038689",[-90.78931278290206, 42.48291392512573]],
    [ "1212039840",[-90.9075975082959, 42.60850702042943]],
    [ "1212105827",[-87.85894441824578, 37.694206896324914]],
    [ "1212114805",[-86.87419515000002, 36.66883785]],
    [ "Shady Grove Substation",[-87.17675782824809, 36.48227170486284]],
    [ "1212114809",[-87.2964477204944, 36.526767556375894]],
    [ "Hankook Tire Manufacturing Tennessee, LP",[-87.24912052815009, 36.569958686879055]],
    [ "Cumberland Electric Membership Corporation",[-86.95194657099601, 36.45873493835587]],
    [ "Tennessee Valley Authority",[-87.26681632291624, 36.622707604976455]],
    [ "Google LLC",[-87.26618167991309, 36.623670258019416]],
    [ "1212142454",[-109.35155105510675, 33.035072340445545]],
    [ "Evergy",[-95.4064817610489, 37.90912884373403]],
    [ "FIXME Substation",[-95.69145470000001, 38.283297600000004]],
    [ "FIXME Substation",[-95.46215567347342, 37.69863548055217]],
    [ "Chanute 2 Substation",[-95.45906942062062, 37.69532662906203]],
    [ "1212148780",[-74.63619457556364, 41.153786950580475]],
    [ "Lowell Substation",[-85.37092590392598, 42.929108998396096]],
    [ "1212176710",[-87.3819380785362, 36.59842634450574]],
    [ "Fort Campbell Directorate of Public Works",[-87.45917327981178, 36.62229281153155]],
    [ "Fort Campbell Directorate of Public Works",[-87.47091826332746, 36.65009891613097]],
    [ "Fort Campbell Directorate of Public Works",[-87.48790948718165, 36.66231371396176]],
    [ "Fort Campbell Directorate of Public Works",[-87.4772944075762, 36.66471864515909]],
    [ "Fort Campbell Directorate of Public Works",[-87.44726436140516, 36.64472502064538]],
    [ "Fort Campbell Directorate of Public Works",[-87.44219716374234, 36.6295808701992]],
    [ "1212180411",[-87.30809958243215, 36.59476812658827]],
    [ "1212180414",[-87.30822593888456, 36.59593644842348]],
    [ "Warfleigh Pumping Station",[-86.15668765, 39.870290100000005]],
    [ "1212230513",[-86.1753386, 39.83649260000001]],
    [ "1212246803",[-86.153766, 39.8172932]],
    [ "Castle Substation",[-82.49830008737128, 27.490691380709684]],
    [ "1212359784",[-88.79243546075848, 43.67066932991213]],
    [ "1212363763",[-89.0011601165452, 43.537206116777845]],
    [ "1212363767",[-89.11732849999999, 43.54186655]],
    [ "1212363773",[-89.23971806741785, 43.46338794659738]],
    [ "1212363780",[-89.28706292892186, 43.5354323577036]],
    [ "Evans Milling Substation",[-86.19274088521924, 39.776993875105546]],
    [ "FIXME Substation",[-97.08076154999999, 37.5135106]],
    [ "FIXME Substation",[-97.07739094292862, 37.390817571099]],
    [ "1212386108",[-89.5109560167349, 43.88383936687418]],
    [ "Otsego Substation",[-85.63345244773244, 42.507736250555276]],
    [ "Byron Center Substation",[-85.72332847620383, 42.81604275362915]],
    [ "Petoskey Substation",[-84.88584261235229, 45.36360006491162]],
    [ "Pellston Substation",[-84.87229719896025, 45.59335318515023]],
    [ "1212565920",[-86.488855265684, 35.950814116890065]],
    [ "1212565922",[-86.46159343924116, 35.870111204894755]],
    [ "1212614447",[-86.33170836172746, 39.80616872463183]],
    [ "Bay Harbor Substation",[-85.02704488374026, 45.3598437324002]],
    [ "Dr. Jean Anne Rogers Substation",[-86.34438144996113, 35.77122189894265]],
    [ "Duck River Electric Membership Corporation",[-86.46403201478518, 35.56865546760404]],
    [ "1212674785",[-86.44638987504256, 35.51440824364351]],
    [ "Duck River Electric Membership Corporation",[-86.12999609182145, 35.40137984331266]],
    [ "Caney Fork Electric Cooperative",[-85.80987714730007, 35.69495410115506]],
    [ "1212706823",[-85.82173701538147, 35.93782425341408]],
    [ "1212751024",[-102.32749089391875, 33.304540236638545]],
    [ "1212751035",[-102.0578917248458, 33.49134142499776]],
    [ "1212803066",[-86.17869221993055, 39.69635111116131]],
    [ "1212898232",[-86.18288800054937, 39.79143506942209]],
    [ "1212905581",[-102.57744866721104, 33.268247216091375]],
    [ "Dietz Road Substation",[-84.95333108643732, 45.19474111506437]],
    [ "1212913211",[-102.35691125000001, 33.03597045000001]],
    [ "1212913216",[-102.52669049999999, 33.0512793]],
    [ "1212913223",[-102.33602997495905, 32.97869769459518]],
    [ "Tower Substation",[-84.29438939320939, 45.36250756379036]],
    [ "Black Lake Substation",[-84.26804662476744, 45.40417179322663]],
    [ "1213165206",[-102.61180865, 33.1812336]],
    [ "1213165207",[-102.61107903068223, 33.182200825155824]],
    [ "1213165209",[-102.6032739, 33.05077615]],
    [ "Posen Distribution Substation",[-83.64272363468221, 45.2445345684617]],
    [ "Grand Lake Substation",[-83.5307178095631, 45.334453520182414]],
    [ "Gull Lake Substation",[-85.3958232, 42.4059796]],
    [ "1213289165",[-102.65803402488788, 32.963724990410945]],
    [ "1213289827",[-102.29188027497295, 33.0223234111548]],
    [ "Lakeville Substation",[-75.27121215, 41.43898005]],
    [ "1213397537",[-85.96512884399938, 36.24771674113767]],
    [ "1213397550",[-86.25879897913347, 36.388793686655376]],
    [ "FIXME Substation",[-92.72361705, 38.9789732]],
    [ "City of California Substation #5",[-92.58188697469916, 38.63128974895577]],
    [ "FIXME Substation",[-92.78697199741647, 38.653894415840064]],
    [ "FIXME Substation",[-93.00214914464158, 38.697004832453224]],
    [ "FIXME Substation",[-93.0922963, 38.6826972]],
    [ "Airport Substation",[-83.63997481015828, 45.06318816230101]],
    [ "1213474052",[-123.17240084984185, 48.089272874846856]],
    [ "1213474054",[-123.24838393267034, 48.10471567982053]],
    [ "1213475644",[-123.16906896043992, 48.128127170186275]],
    [ "1213475646",[-123.34764705411169, 48.10347092539135]],
    [ "1213475649",[-123.38853876146732, 48.107060593554365]],
    [ "Airport Distribution Substation",[-83.57849044937457, 45.06150528635865]],
    [ "FIXME Substation",[-91.91927269586955, 39.025148901564364]],
    [ "FIXME Substation",[-91.46058052642158, 38.920595300342235]],
    [ "Duke Energy",[-86.48202896599521, 39.16872889176859]],
    [ "Consumers Energy",[-83.70729109584975, 43.02252154854326]],
    [ "1213743378",[-99.5207641315549, 33.254957734057314]],
    [ "1213743833",[-99.30622439976771, 33.10214738130168]],
    [ "1213743968",[-99.57131834714434, 33.17784361732538]],
    [ "1213743969",[-99.56950830166801, 33.1784095715631]],
    [ "1213744955",[-98.79158196281645, 32.912233725248065]],
    [ "1213744957",[-98.7789805198338, 32.89576584101718]],
    [ "1213744959",[-98.90313259104519, 32.74745816837068]],
    [ "Meta Switching Station",[-86.37183913209107, 36.40858459138467]],
    [ "1213758204",[-86.37084029115788, 36.40865504036074]],
    [ "1213758208",[-86.55832740000001, 36.67624705]],
    [ "1213758322",[-86.42094866890562, 36.37188687748976]],
    [ "Dayton Substation",[-85.02115333138057, 35.51208869568764]],
    [ "1213785716",[-85.01605469493796, 35.497106322439805]],
    [ "North Dayton Primary Substation",[-84.98964059392841, 35.53892887180819]],
    [ "Rockwood Electric Utility",[-84.70314437556765, 35.83413609581785]],
    [ "Rockwood Substation",[-84.67088208306423, 35.87958044727434]],
    [ "Beaver Lake Substation",[-83.76746484362644, 44.88064347983937]],
    [ "Avalon Substation",[-83.94102046645352, 45.05578241487995]],
    [ "Atlanta Distribution Substation",[-84.16526855960016, 45.00767369195051]],
    [ "Canada Creek Substation",[-84.20100908822293, 45.19894600425013]],
    [ "Hillman Power Substation",[-83.8928638703848, 45.06863255203867]],
    [ "Kerridge Substation",[-84.72132339927393, 45.005065950380605]],
    [ "West Crossville Substation",[-85.04710253218362, 35.96054344306332]],
    [ "Volunteer Energy Cooperative",[-85.05912578520524, 35.90796791137992]],
    [ "Fredonia Substation",[-85.04466120000001, 36.014346800000006]],
    [ "Plateau Substation",[-85.14194107813579, 36.05858039392442]],
    [ "1214062899",[-89.78415129214848, 40.60119792496446]],
    [ "Cleveland Substation",[-76.48480499665291, 40.8804691403504]],
    [ "1214066524",[-87.7245119616056, 39.00293822485521]],
    [ "Magee Carpet Substation",[-76.4591357834897, 40.99449971466681]],
    [ "West Bloomsburg Substation",[-76.45761968110743, 40.995320554085325]],
    [ "FIXME Substation",[-93.27322123565132, 38.71733682435673]],
    [ "FIXME Substation",[-93.27488658527508, 38.4645921244577]],
    [ "Warsaw #2 Substation",[-93.36000998757947, 38.24835412456819]],
    [ "FIXME Substation",[-93.01223241692966, 38.14978201656922]],
    [ "FIXME Substation",[-93.93349099999999, 37.40497070000001]],
    [ "Straits Plant Substation",[-84.77392150683059, 45.78601652243496]],
    [ "Mackinaw Substation",[-84.730403768857, 45.77668994381409]],
    [ "Bloomsburg Substation",[-76.46433545467525, 41.00895086757202]],
    [ "Scott Substation",[-76.40956448645899, 41.0235875089918]],
    [ "Products Substation",[-76.35257955000002, 41.02776955]],
    [ "Bercon Substation",[-76.25004968266423, 41.06350260269184]],
    [ "PPL",[-76.44923793728628, 41.105848584104514]],
    [ "Rohrsburg Substation",[-76.41659017741671, 41.13353475820024]],
    [ "Upper Cumberland Electric Membership Corporation",[-85.3652983, 36.2869302]],
    [ "Cheboygan Substation",[-84.47866157916555, 45.63799128483081]],
    [ "Charmin Substation",[-84.47941419250112, 45.63847992474489]],
    [ "Beaugrand Substation",[-84.49223070000001, 45.65182275]],
    [ "Industrial Substation",[-85.23056415931154, 45.33023936390375]],
    [ "Westenbroek Substation",[-85.25723793550686, 45.30181205769298]],
    [ "Black Hills Electric Cooperative",[-103.55782154485715, 43.93346490680887]],
    [ "1214433456",[-89.61949202501712, 43.76500424158084]],
    [ "1214433457",[-89.79686835000001, 43.77493015]],
    [ "1214434894",[-89.42366362443074, 43.48687520627032]],
    [ "Mitchell Road Substation",[-84.91929295, 45.37349210000001]],
    [ "1214440755",[-111.68555928065683, 35.14344174496204]],
    [ "Walloon Substation",[-84.92026254999999, 45.265762249999995]],
    [ "East Jordan Substation",[-85.1211202883832, 45.155702959312706]],
    [ "Boyne Mountain Substation",[-84.93002270000001, 45.1649769]],
    [ "1214530389",[-89.401935710873, 43.60693261949101]],
    [ "1214530390",[-89.4032582, 43.60625695000001]],
    [ "1214530395",[-89.45511993641733, 43.5634864086272]],
    [ "English Avenue Substation",[-86.11322530129068, 39.75961837655677]],
    [ "1214692459",[-90.32195777687735, 44.14506564347238]],
    [ "Central Lake Substation",[-85.27539009734578, 45.107513001105794]],
    [ "Jordan Iron Substation",[-85.12850276441112, 45.15928263650369]],
    [ "1214822438",[-86.06006808170409, 39.79297225621794]],
    [ "1214831655",[-86.12094469158826, 39.792097308362635]],
    [ "Mossy Grove Substation",[-84.52891170000001, 36.06638770000001]],
    [ "Rosedale Substation",[-84.3767269094381, 36.156269964311726]],
    [ "Petros Substation",[-84.44578456027386, 36.09898004238715]],
    [ "Coalfield Substation",[-84.39191834999998, 36.037386549999994]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.89072480639945, 37.683290593976096]],
    [ "1214913748",[-86.04125331680166, 39.805260436471954]],
    [ "1214930434",[-90.62823850000002, 44.567888399999994]],
    [ "1214930437",[-90.48653445000001, 44.5967659]],
    [ "1214930440",[-90.39618180603155, 44.58298317878285]],
    [ "1214931627",[-90.76011022462924, 44.38911065929838]],
    [ "McAlisterville Substation",[-77.26959934255116, 40.625392144407016]],
    [ "1215085468",[-86.0669737129612, 39.71631082671564]],
    [ "1215127545",[-86.18970148526898, 39.73528297477633]],
    [ "Breton Substation",[-85.61336330657124, 42.91190568241829]],
    [ "Calvin Substation",[-85.58047778816642, 42.92752924744602]],
    [ "Doehler Jarvis Substation",[-85.65694256365259, 42.93444951620177]],
    [ "Consumers Energy",[-85.6480205921218, 42.88509783870347]],
    [ "Dewey Substation",[-85.68053411745721, 42.976209777314835]],
    [ "Lamoreaux Substation",[-85.67053898542369, 43.03835244984892]],
    [ "Walker Substation",[-85.75036421876304, 42.98782889157923]],
    [ "Bear Gap Substation",[-76.46759730000001, 40.8421861]],
    [ "1215203220",[-91.14444661166726, 44.625048474842814]],
    [ "1215203222",[-91.20712799999998, 44.5649274]],
    [ "1215203223",[-91.2074716880947, 44.56444437485258]],
    [ "1215203228",[-91.37550355, 44.54492855000001]],
    [ "1215203229",[-91.30633176006292, 44.451624323073744]],
    [ "1215341170",[-86.22143607503659, 39.736189485421534]],
    [ "Black Hills Energy",[-103.71533902701671, 44.37803490415794]],
    [ "1215364692",[-86.19700552036485, 39.70188197811418]],
    [ "Strip Mill Substation",[-86.22353728076874, 39.7334841369806]],
    [ "1215382186",[-86.30040000000001, 39.75329620000001]],
    [ "1215458202",[-86.43088655501421, 39.75697999383782]],
    [ "1215460252",[-86.50007092486719, 39.759329258718644]],
    [ "Johnson Substation",[-86.1039215171294, 43.007398933084296]],
    [ "Blue Water Substation",[-82.48099807379782, 42.77530432019367]],
    [ "Puttygut Substation",[-82.49487754320991, 42.78310414148004]],
    [ "Nunica Substation",[-86.06843528518687, 43.079597226744184]],
    [ "Butte Electric Cooperative",[-103.58171919843285, 44.47963148378671]],
    [ "Blucksberg Substation",[-103.45232155, 44.3508247]],
    [ "Sturgis Substation",[-103.50624962516189, 44.41407453763947]],
    [ "Whitewood Substation",[-103.5584446586689, 44.45663448306347]],
    [ "Southern California Edison",[-117.61857662517703, 33.97012865779193]],
    [ "Rochester Products Substation",[-85.95122895348845, 43.06633087739337]],
    [ "Consumers Energy",[-85.98286154396344, 43.07409145661493]],
    [ "Coopersville Substation",[-85.93967343436154, 43.06381575908153]],
    [ "Ottawa Generating Substation",[-85.95614447930375, 43.04740929983347]],
    [ "Butte Electric Cooperative",[-103.88966320000002, 44.525140050000005]],
    [ "Spearfish Park Substation",[-103.85520474987064, 44.47842943160947]],
    [ "1215483579",[-103.84641156410355, 44.402771124446964]],
    [ "Marne Substation",[-85.81303233200371, 43.031312042366295]],
    [ "Consumers Energy",[-85.71307944221292, 43.00070994267101]],
    [ "Consumers Energy",[-85.70825172640824, 43.000989353958445]],
    [ "Standale Substation",[-85.77109471075835, 42.97356542580173]],
    [ "Cannon Substation",[-85.54567376780118, 43.10893602743658]],
    [ "Plantation Pipe Line Substation",[-84.36488510273166, 35.76604128298606]],
    [ "1215507849",[-84.32535205, 35.7415054]],
    [ "Loudon Substation",[-84.36020792012108, 35.72004381071151]],
    [ "1215507860",[-84.35925734244965, 35.720630712093424]],
    [ "Buck Creek Substation",[-84.45313436322287, 35.8348236424902]],
    [ "Rockwood Electric Utility",[-84.49687900024925, 35.866643178172424]],
    [ "1215507891",[-84.27220045, 35.601609399999994]],
    [ "1215507904",[-84.27149789197854, 35.591405136977365]],
    [ "Niota Substation",[-84.54496390000003, 35.51256770000001]],
    [ "Tenmile Substation",[-84.67905456961634, 35.66332941405672]],
    [ "Loudon Utilities Board",[-84.26527851709878, 35.725066860854085]],
    [ "1215533571",[-84.22780252805393, 35.749369556601735]],
    [ "Falling Water Substation",[-85.22176496042982, 35.20267981898197]],
    [ "1215578255",[-86.36174774450033, 39.79777502474396]],
    [ "1215603862",[-85.32304350000001, 35.037370249999995]],
    [ "Electric Power Board of Chattanooga",[-85.3216669131277, 35.042162784456885]],
    [ "East Ridge Substation",[-85.24880478131269, 34.99832298389185]],
    [ "Electric Power Board of Chattanooga",[-85.25476110000001, 34.99061355]],
    [ "Electric Power Board of Chattanooga",[-85.27152671093323, 34.97732016955372]],
    [ "Electric Power Board of Chattanooga",[-85.26242475421758, 35.00485118143106]],
    [ "Electric Power Board of Chattanooga",[-85.2346780236463, 34.9990287645047]],
    [ "Belvoir Substation",[-85.23874425, 35.00975055000001]],
    [ "Spring Creek Substation",[-85.22051537298648, 34.99162320553737]],
    [ "Electric Power Board of Chattanooga",[-85.20052011012353, 34.991082448196195]],
    [ "Electric Power Board of Chattanooga",[-85.28522514999999, 34.99150945]],
    [ "1215607551",[-86.59493377499585, 39.83420834353746]],
    [ "1215609709",[-86.70161262499938, 39.81291154224658]],
    [ "C. G Stamper Substation",[-86.4288139404953, 39.813797829356346]],
    [ "1215619806",[-86.4852542695842, 39.695761760779895]],
    [ "Brentwood Substation",[-79.98348742308649, 40.36732829160454]],
    [ "1215634208",[-90.6998718112184, 44.7423035211814]],
    [ "1215635755",[-90.43570077494576, 43.185700406671614]],
    [ "Laurelton Substation",[-77.19305918343589, 40.89615197448139]],
    [ "Electric Power Board of Chattanooga",[-85.29429210423497, 35.00209736311333]],
    [ "Electric Power Board of Chattanooga",[-85.28297774999999, 35.00330605]],
    [ "Electric Power Board of Chattanooga",[-85.27102615, 35.01409855]],
    [ "Electric Power Board of Chattanooga",[-85.28759585, 35.012744149999996]],
    [ "Electric Power Board of Chattanooga",[-85.25823955, 35.022359449999996]],
    [ "Electric Power Board of Chattanooga",[-85.25475466304283, 35.01037872358962]],
    [ "1215657223",[-112.37826517464076, 33.44235377188588]],
    [ "1215662320",[-80.1552914, 38.87824510000001]],
    [ "Lake Odessa Substation",[-85.14593622266219, 42.78505580864721]],
    [ "Herbruck Foods Substation",[-85.13612795125611, 42.793523736784636]],
    [ "Marker Lake Substation",[-85.24114131600976, 42.889536280314324]],
    [ "Clarksville Substation",[-85.24155126210455, 42.836122150398936]],
    [ "Woodland Substation",[-85.13597028634491, 42.72579323952916]],
    [ "Consumers Energy",[-85.28040228972594, 42.65291842530591]],
    [ "Consumers Energy",[-85.27553986865865, 42.64024616727136]],
    [ "1215697612",[-103.93727943938097, 32.350022172344715]],
    [ "1215697640",[-103.86065721189523, 32.32274248792158]],
    [ "Electric Power Board of Chattanooga",[-85.17269977693563, 35.10648263491822]],
    [ "1215700348",[-85.19410012633134, 35.07373310109738]],
    [ "Electric Power Board of Chattanooga",[-85.16817194999999, 35.072675950000004]],
    [ "Electric Power Board of Chattanooga",[-85.1461911296085, 35.01099625949264]],
    [ "Ryall Springs Substation",[-85.11563982137405, 35.00484739043717]],
    [ "Electric Power Board of Chattanooga",[-85.09851966872576, 35.04073740468088]],
    [ "Electric Power Board of Chattanooga",[-85.16896563119609, 35.05088415567262]],
    [ "EPB",[-85.19921584184007, 35.065820767606446]],
    [ "1215709439",[-85.24056750111446, 35.109518637850975]],
    [ "Electric Power Board of Chattanooga",[-85.25961911562858, 35.10282044168709]],
    [ "Electric Power Board of Chattanooga",[-85.27008576549882, 35.10916153692244]],
    [ "Midvale Substation",[-85.3118045, 35.08742315]],
    [ "Electric Power Board of Chattanooga",[-85.29600210385325, 35.10658048267627]],
    [ "Electric Power Board of Chattanooga",[-85.28601015496147, 35.1190788313367]],
    [ "Electric Power Board of Chattanooga",[-85.2623084620439, 35.12615573436658]],
    [ "Electric Power Board of Chattanooga",[-85.24129945000001, 35.12330285]],
    [ "Electric Power Board of Chattanooga",[-85.24779610000002, 35.18298555]],
    [ "Electric Power Board of Chattanooga",[-85.27241794999999, 35.1476043]],
    [ "Electric Power Board of Chattanooga",[-85.31558835945711, 35.15999323269499]],
    [ "Colonial Pipeline Substation",[-85.3512309, 35.10068545]],
    [ "Electric Power Board of Chattanooga",[-85.28591190811042, 35.137015930705786]],
    [ "Signal Mountain Cement Substation",[-85.34408155000001, 35.101940750000004]],
    [ "Electric Power Board of Chattanooga",[-85.33256921660558, 35.09042590623935]],
    [ "1215763173",[-122.06039680366602, 37.41648518938058]],
    [ "Electric Power Board of Chattanooga",[-85.33390181114983, 35.05449702679442]],
    [ "Electric Power Board of Chattanooga",[-85.3004951, 35.082246]],
    [ "Electric Power Board of Chattanooga",[-85.28705066161916, 35.08917207618087]],
    [ "Electric Power Board of Chattanooga",[-85.28983885422666, 35.06945926630213]],
    [ "Electric Power Board of Chattanooga",[-85.29372285482735, 35.05139893662549]],
    [ "1215768401",[-85.25460805841415, 35.08702577582354]],
    [ "Electric Power Board of Chattanooga",[-85.27428840341489, 35.052413283511974]],
    [ "Electric Power Board of Chattanooga",[-85.26570290000002, 35.0510823]],
    [ "Electric Power Board of Chattanooga",[-85.25557196493013, 35.054392514929525]],
    [ "Alcoa Station",[-74.89170229587731, 44.961871759641554]],
    [ "Brady Station",[-75.15883885, 44.788509549999986]],
    [ "1215785994",[-75.44168552019661, 44.72550422577439]],
    [ "Corning Station",[-75.31610051141207, 44.56080723529007]],
    [ "Electric Power Board of Chattanooga",[-85.19655211963234, 35.131319765227836]],
    [ "Electric Power Board of Chattanooga",[-85.2044503, 35.1482337]],
    [ "Electric Power Board of Chattanooga",[-85.18055301225938, 35.194444290019156]],
    [ "Electric Power Board of Chattanooga",[-85.1564853588867, 35.27936129296026]],
    [ "Electric Power Board of Chattanooga",[-85.11363865687328, 35.37300618155931]],
    [ "Electric Power Board of Chattanooga",[-85.1456915, 35.21029640000001]],
    [ "Electric Power Board of Chattanooga",[-85.16896505000001, 35.2604517]],
    [ "Electric Power Board of Chattanooga",[-85.22065746104327, 35.21326167627926]],
    [ "Electric Power Board of Chattanooga",[-85.13391200000001, 35.327717549999996]],
    [ "1215832415",[-86.33613997480512, 39.95025329191982]],
    [ "1215849161",[-110.24638811484657, 45.762640219070036]],
    [ "1215849162",[-110.36523748180988, 45.71019552529608]],
    [ "1215849168",[-110.55024388625323, 45.67511197490987]],
    [ "Mantoloking Substation",[-74.0539364936568, 40.027944317443016]],
    [ "Drum Point Substation",[-74.11225076438438, 40.04327660249609]],
    [ "1215856714",[-74.0477173533056, 40.07539268623578]],
    [ "Jersey Central Power and Light",[-74.04680705428255, 40.122857883307695]],
    [ "1215856716",[-74.0443827452262, 40.12571411769594]],
    [ "Jersey Central Power and Light",[-74.0364845661061, 40.14818892757534]],
    [ "Silverton Substation",[-74.14373196659807, 40.02056087486018]],
    [ "Farmingdale Substation",[-74.16890737138598, 40.1896740296142]],
    [ "Jersey Central Power and Light",[-74.12324919759745, 40.19990126975916]],
    [ "Howell Substation",[-74.23320065294108, 40.23155778120094]],
    [ "1215856722",[-74.24639345591326, 40.24201022325293]],
    [ "Jersey Central Power and Light",[-74.25924429251835, 40.249145473562976]],
    [ "Freehold Substation",[-74.2836573563856, 40.26484859387299]],
    [ "Hamilton Substation",[-74.07754686070682, 40.212241121778256]],
    [ "Corlies Ave Substation",[-74.06733736257414, 40.20298777344398]],
    [ "1215856727",[-74.06338882385097, 40.20075702636709]],
    [ "1215856728",[-74.11752159848756, 40.24718458580078]],
    [ "Glendola Substation",[-74.06151696554016, 40.19064159000707]],
    [ "Allenwood Substation",[-74.10466668981866, 40.15066527690152]],
    [ "Brielle Substation",[-74.0700366803473, 40.1163602609149]],
    [ "1215856732",[-74.11436518101632, 40.148055412153624]],
    [ "1215856733",[-74.1128742407461, 40.14719413742059]],
    [ "Jersey Central Power and Light",[-74.161844985793, 39.88705176364058]],
    [ "1215856735",[-74.17846182025687, 39.90943130898328]],
    [ "1215856736",[-74.1791121241962, 39.90676513132842]],
    [ "Pine Beach Substation",[-74.17592087040316, 39.93062496088504]],
    [ "Flint Road Substation",[-74.19535899230992, 39.943657114374545]],
    [ "Ortley Beach Substation",[-74.07740306620319, 39.94995576464152]],
    [ "Jersey Central Power and Light",[-74.21403049591545, 40.01925431054798]],
    [ "1215856743",[-74.23728772458512, 39.98723577283344]],
    [ "Vermont Avenue Substation",[-74.20950789730541, 40.050217496141556]],
    [ "1215856745",[-74.13074122388821, 40.076438115098114]],
    [ "South Lakewood Substation",[-74.2470755072493, 40.071604218636296]],
    [ "1215856747",[-74.69501746025695, 39.983976765323575]],
    [ "1215856748",[-74.62500552278263, 39.9979819153729]],
    [ "1215856749",[-74.62977511836357, 40.008251220457105]],
    [ "1215856750",[-74.61889028526814, 39.98822755901812]],
    [ "1215856751",[-74.60742060485224, 40.043938835076574]],
    [ "1215856752",[-74.55574404858956, 40.054168628317804]],
    [ "Jersey Central Power and Light",[-74.582566720993, 40.06332405390137]],
    [ "1215856754",[-74.5924530613014, 40.06165630788847]],
    [ "1215856755",[-74.56264934510251, 40.19246194620942]],
    [ "Jersey Central Power and Light",[-74.53723710739601, 40.18165557847331]],
    [ "1215856757",[-74.3708026017788, 40.01853475653893]],
    [ "1215856758",[-74.37579781493406, 40.01678717064199]],
    [ "1215856759",[-74.33932222256307, 39.98423149914089]],
    [ "1215856760",[-74.30923909871821, 40.020335198725824]],
    [ "1215856761",[-74.17094805177581, 40.13394515520091]],
    [ "Princeton Road Substation",[-74.56372260935167, 40.2847240631076]],
    [ "1215856763",[-74.56109485835879, 40.28354751103342]],
    [ "1215856764",[-74.5643004596586, 40.28803220686808]],
    [ "1215856765",[-74.54828035939757, 40.27457256494253]],
    [ "Jersey Central Power and Light",[-74.54651980855158, 40.27450581155581]],
    [ "1215856767",[-74.5001330154506, 40.29455098200531]],
    [ "Jersey Central Power and Light",[-74.48749962899008, 40.30638211881096]],
    [ "1215856769",[-74.48356858935152, 40.31232723333333]],
    [ "Jersey Central Power and Light",[-74.32299946161216, 40.24029134043673]],
    [ "1215856771",[-74.31887495200014, 40.238561280714876]],
    [ "Millhurst Substation",[-74.3411923921747, 40.254405574028695]],
    [ "1215856773",[-74.31276257256074, 40.23783348873051]],
    [ "Jersey Central Power and Light",[-74.1554573290464, 40.18952773419489]],
    [ "Twin Rivers Substation",[-74.49979314767073, 40.2628457993874]],
    [ "Jersey Central Power and Light",[-74.44407511299171, 40.25833187529729]],
    [ "1215856777",[-74.2649385623288, 40.25258350309696]],
    [ "1215856779",[-74.07928204399195, 40.043056742098514]],
    [ "1215874581",[-86.23613678595981, 39.869366368688596]],
    [ "Barnard Substation",[-86.71198154999999, 39.848631499999996]],
    [ "Bainbridge Substation",[-86.81005045039356, 39.76465659741552]],
    [ "1215881146",[-111.94363671252324, 43.45295157502691]],
    [ "Custer Substation",[-103.60351166703545, 43.763611001145364]],
    [ "Heritage Lake Substation",[-86.70632351376497, 39.723810695798754]],
    [ "Reno Station",[-86.67011245799358, 39.71208676368586]],
    [ "Duke Energy",[-86.71527987036552, 39.679079082499875]],
    [ "North Kent Substation",[-85.610060887015, 43.0448870482558]],
    [ "1216096499",[-86.8780597749976, 39.674951591994265]],
    [ "Morton Substation",[-86.93528393498993, 39.76271926124844]],
    [ "Russellville Substation",[-86.97902817233876, 39.847679911390486]],
    [ "1216113206",[-86.81447578117103, 39.834394051775064]],
    [ "1216116331",[-86.81941895103895, 39.582146667014115]],
    [ "1216126496",[-86.81657671784217, 39.550159547795694]],
    [ "Ada Co-Gen Substation",[-85.49443938137948, 42.96242797824807]],
    [ "Amway Substation",[-85.48790703859007, 42.96058680201168]],
    [ "Plainfield Substation",[-85.57496612167786, 43.07167572703673]],
    [ "1216146584",[-86.80893169082253, 39.529036070551506]],
    [ "Public Service Enterprise Group",[-74.65840156297273, 40.15303918342385]],
    [ "Mansfield Substation",[-74.74790877233289, 40.10201505379032]],
    [ "Consumers Energy",[-85.70185067242436, 42.92526325224387]],
    [ "1216240767",[-86.86972267462464, 39.61713129745435]],
    [ "Custer Substation",[-103.6377815044652, 43.75285600510592]],
    [ "1216252508",[-87.3717693, 39.78285825]],
    [ "Hillsdale Substation",[-87.40384477041069, 39.81721757862526]],
    [ "Internationl Paper",[-87.42042694125604, 39.90996027924001]],
    [ "1216291495",[-87.39049782488082, 39.73701894262072]],
    [ "1216354399",[-87.12307406607663, 39.59864357528941]],
    [ "Sargent Sand Substation",[-85.75657152390542, 44.32996735572925]],
    [ "1216499472",[-87.47433120000001, 39.593063150000006]],
    [ "1216652522",[-87.45443055139937, 39.47677073307572]],
    [ "Burton Pumping Substation",[-85.77082164917948, 42.928646018816906]],
    [ "Shapeco Substation",[-86.2102446413391, 43.0346549064147]],
    [ "Ferris Street Substation",[-86.18571500193038, 43.007844612224126]],
    [ "Consumers Energy",[-86.15327426695899, 43.11378356292174]],
    [ "Agnew Substation",[-86.18285216122966, 42.971893799105935]],
    [ "Delta Energy Park Substation",[-84.6592010588851, 42.69100091716702]],
    [ "Terre Haute Central Substation",[-87.4103607750703, 39.490560758861655]],
    [ "Harlem Substation",[-86.0794168919379, 42.86900802518226]],
    [ "Consumers Energy",[-86.20096794280924, 42.91378077835368]],
    [ "Pigeon Lake Substation",[-86.1851157, 42.891614849999996]],
    [ "Ventura Substation",[-86.19367466274315, 42.85462812464844]],
    [ "Buchanan Substation",[-86.1966249742629, 42.840282657450615]],
    [ "Ottawa Beach Substation",[-86.19682406245947, 42.803464124194946]],
    [ "Tunnel Park Substation",[-86.2057384092414, 42.798377644539215]],
    [ "Station 64",[-77.72629088549466, 43.13786797858794]],
    [ "Logistic Substation",[-85.98517449119079, 42.814101898240246]],
    [ "Leprino Foods Substation",[-85.9041322216082, 42.97708549899448]],
    [ "Grand Valley Substation",[-85.88892358950224, 42.97145951274407]],
    [ "Station 114",[-77.69148745, 43.143305850000004]],
    [ "1217081300",[-87.35905138032678, 39.493381517268354]],
    [ "1217089144",[-87.36680343804163, 39.50687202787756]],
    [ "1217102758",[-87.29494520000002, 39.49906765]],
    [ "29th St. Substation",[-87.3739249, 39.462049549999996]],
    [ "1217166479",[-87.39804969972363, 39.4435651742031]],
    [ "1217208886",[-87.36044253722147, 39.47926097534583]],
    [ "Station 417",[-77.66917277177785, 43.14591131203176]],
    [ "Brooks Industrial Substation",[-84.9660684073663, 42.23686647671336]],
    [ "Consumers Energy",[-84.96517588938345, 42.23693028829014]],
    [ "Stone Hill Substation",[-84.75510486879162, 42.28253823397997]],
    [ "1217216359",[-84.75548801062388, 42.28178742447871]],
    [ "City of Marshall Electric Department",[-84.97164047127686, 42.265155652868415]],
    [ "Hornsby Substation",[-97.61384096238878, 30.231970055942508]],
    [ "Tesla Battery Substation",[-97.61583517231205, 30.231405809681917]],
    [ "1217346543",[-87.36935008779726, 39.41225982497617]],
    [ "1217356498",[-90.84683885, 44.1808301]],
    [ "1217373231",[-87.51798825, 39.2741793]],
    [ "Holcombe Substation",[-91.11066158550155, 45.22411794641417]],
    [ "1217397844",[-91.0486262118828, 45.36466782450634]],
    [ "Farmersburg Substation",[-87.37882605000001, 39.274047200000005]],
    [ "1217403594",[-91.08256166395708, 45.46293687461984]],
    [ "Station 137",[-77.6194053714586, 43.16259642170257]],
    [ "Station 23",[-77.61589900874661, 43.15940458622711]],
    [ "1217405008",[-90.69903365032009, 45.03082028923169]],
    [ "1217405009",[-90.67375011189088, 45.03085061487238]],
    [ "Consumers Energy",[-86.18216905157094, 43.07749774690721]],
    [ "Hayes Street Substation",[-86.21542491206311, 43.02651552431506]],
    [ "1217447512",[-87.18704054687137, 39.46970091620839]],
    [ "Leslie Industrial Substation",[-84.42148397498526, 42.4442096549243]],
    [ "Leslie Substation",[-84.4373007, 42.449573349999994]],
    [ "Grimes Road Substation",[-84.24273162602255, 42.51209661083225]],
    [ "1217462424",[-84.23958719999999, 42.50971799999999]],
    [ "1217462425",[-84.23963570000001, 42.5103857]],
    [ "1217462426",[-84.23864975000001, 42.5088866]],
    [ "Consumers Energy",[-84.40565576214702, 42.252022897457714]],
    [ "Kipp Road Substation",[-84.47268492508186, 42.57359649725399]],
    [ "Harper Road Substation",[-84.54403305003437, 42.61416639596641]],
    [ "Consumers Energy",[-84.54384620770631, 42.613780424944714]],
    [ "Hogsback Substation",[-84.50915068461515, 42.636207536027705]],
    [ "Consumers Energy",[-84.47187075000001, 42.6044969]],
    [ "Stable Substation",[-84.80257405976276, 42.28965502529936]],
    [ "1217541073",[-87.10757398204616, 39.53292674430917]],
    [ "1217564683",[-87.10613258497408, 39.48241242550016]],
    [ "1217593878",[-74.42525675579108, 40.31240066190476]],
    [ "1217593879",[-74.48093138268325, 40.31707634453426]],
    [ "Jersey Central Power and Light",[-74.47593684604935, 40.33645858599025]],
    [ "Jersey Central Power and Light",[-74.41446296986585, 40.40401946761021]],
    [ "1217593882",[-74.33739151931378, 40.42661692738651]],
    [ "Browntown Substation",[-74.30803362960066, 40.40240552888346]],
    [ "Jernees Mill Substation",[-74.34818968867236, 40.434915415386676]],
    [ "1217593885",[-74.34491606316273, 40.433209530389924]],
    [ "1217593886",[-74.33480035516868, 40.449617926983414]],
    [ "1217593887",[-74.33447601666786, 40.4500712853513]],
    [ "1217593888",[-74.33315297164224, 40.45035875878033]],
    [ "1217593889",[-74.33182002755164, 40.451185742567645]],
    [ "1217593890",[-74.32628622910376, 40.456212154010835]],
    [ "1217593891",[-74.32260946061128, 40.455416133111974]],
    [ "1217593892",[-74.330775408803, 40.456276252191884]],
    [ "1217593893",[-74.33081805831311, 40.45666032115434]],
    [ "1217593894",[-74.31239880797345, 40.49145582352901]],
    [ "1217593895",[-74.24476044587429, 40.44458645453932]],
    [ "Jersey Central Power and Light",[-74.28170612598142, 40.47113114541535]],
    [ "Laurence Harbor Substation",[-74.24004934541965, 40.450756601862146]],
    [ "1217593898",[-74.18800495125006, 40.34933071751943]],
    [ "Crawfords Corner Substation",[-74.1766053130294, 40.379154204499386]],
    [ "1217593900",[-74.13484888313108, 40.39989322670051]],
    [ "Pearl Harbor Substation",[-74.08536452187249, 40.29412092380433]],
    [ "Camp Woods Switch Point",[-74.08125149990659, 40.293190825297664]],
    [ "1217593903",[-74.08437399035601, 40.298762735537345]],
    [ "1217593904",[-74.08932932898789, 40.26160510906405]],
    [ "1217593905",[-74.08643026004292, 40.26377098668007]],
    [ "Avon Substation",[-74.02450865705241, 40.18741564784089]],
    [ "Canyon Switching Station",[-76.21916097099574, 41.70031133937966]],
    [ "Canyon Substation",[-76.21567936437353, 41.70457882557998]],
    [ "Wilmore Dam Substation",[-78.68957506459722, 40.409139457681626]],
    [ "Lily Substation",[-78.62435024815274, 40.432262968566505]],
    [ "Bloomington South East Substation",[-86.48001442501976, 39.14126185691753]],
    [ "1217606243",[-87.15526225942011, 39.404634820410614]],
    [ "1217612202",[-92.45554272554278, 39.71204069336887]],
    [ "Clay City Substation",[-87.07310726130345, 39.27002596227438]],
    [ "1217620888",[-112.06199225951597, 43.54772888432068]],
    [ "1217622097",[-112.09952551315251, 43.469150517720664]],
    [ "1217622098",[-112.06843406349901, 43.4400389189313]],
    [ "1217626784",[-90.27812985, 45.062348500000006]],
    [ "1217626787",[-90.34272887567148, 45.12393590316782]],
    [ "1217626789",[-90.34372208141804, 45.13504800531269]],
    [ "1217626792",[-90.35387336665013, 45.14901283331888]],
    [ "1217626795",[-90.37455529409112, 45.163078221573]],
    [ "Webster Substation",[-97.33074421045363, 37.695902434224635]],
    [ "Alabama Power",[-86.26590928095595, 32.32881930123279]],
    [ "1217767258",[-75.40719165204717, 42.087149417641704]],
    [ "1217767259",[-75.5218104704893, 42.20718893581481]],
    [ "1217769020",[-74.9952526524472, 42.25431488086311]],
    [ "1217769021",[-75.0011552602418, 42.25932992927278]],
    [ "1217811119",[-86.97850768276764, 39.1149194474]],
    [ "Carp Substation",[-86.76122785152425, 39.415867272665515]],
    [ "1217908661",[-86.76812102778197, 39.340626457653705]],
    [ "1217911215",[-119.43801746307751, 39.495102362425975]],
    [ "1217911298",[-86.65781920164169, 39.252646322223235]],
    [ "Google Data Center",[-119.43290868486187, 39.4979395174597]],
    [ "1217916168",[-91.06753160000001, 43.064887299999995]],
    [ "Otter Creek Substation",[-96.28751502888018, 37.696268623038556]],
    [ "Harrison Substation",[-85.0479418362844, 35.191943938882]],
    [ "Riceville Substation",[-84.68563616736738, 35.385360955893596]],
    [ "McDonald Substation",[-84.99011385043515, 35.096703288538734]],
    [ "1217964907",[-84.94643930196942, 35.30898493826863]],
    [ "Hopewell Substation",[-84.90818369617898, 35.25158166670732]],
    [ "1217964926",[-84.83745879593732, 35.151826182403276]],
    [ "Cleveland Utilities",[-84.85393749563055, 35.12194641823482]],
    [ "1218024306",[-86.73864857368882, 39.19127301123115]],
    [ "1218063972",[-86.48319448342502, 39.57843115456319]],
    [ "1218070444",[-112.04780672508717, 40.76180065516613]],
    [ "1218070445",[-112.04824224999999, 40.7617924]],
    [ "Cleveland Utilities",[-84.90561876747354, 35.15230905340031]],
    [ "Cleveland Utilities",[-84.87726906842532, 35.17381358846309]],
    [ "Cleveland Utilities",[-84.86888504383245, 35.198123864204966]],
    [ "Cleveland Utilities",[-84.8446177908193, 35.204135042940486]],
    [ "1218077315",[-84.51713915384921, 35.32956319622872]],
    [ "1218113285",[-84.51819896117762, 35.37098143056303]],
    [ "Charleston Substation",[-84.77379197079823, 35.28167586242592]],
    [ "Olin Substation",[-84.78010078543694, 35.305585119460545]],
    [ "1218113332",[-84.76123296664028, 35.30725968503721]],
    [ "Nelson Stader Substation",[-86.41902453273153, 39.56434826602936]],
    [ "Brooklyn Nirth Substation",[-86.35516584999999, 39.5440484]],
    [ "Duke Energy",[-86.3775195005976, 39.52571994748706]],
    [ "Weisenburg Substation",[-75.71536132072966, 40.59232499654327]],
    [ "Lynnville Substation",[-75.75410716062248, 40.64785357165019]],
    [ "1218144202",[-75.7789845864293, 40.52294931250703]],
    [ "Raintree Substation",[-76.7654713107095, 40.02969332314548]],
    [ "Prospect Substation",[-76.59442448881687, 39.96771704029895]],
    [ "West Hellam Substation",[-76.62499078710758, 39.995095555784125]],
    [ "Glades Substation",[-76.6920063640246, 40.01163365444293]],
    [ "Wheatstone Substation",[-78.72462687439983, 41.24141152005603]],
    [ "Bern Church Substation",[-76.02232395707513, 40.404518182201926]],
    [ "Frystown Substation",[-76.3468675927448, 40.44917152534507]],
    [ "West Lebanon Substation",[-76.43988083683523, 40.34137005312833]],
    [ "5th and Greeen Substation",[-76.4040141133646, 40.34184074786723]],
    [ "Met-Ed",[-76.55922299097874, 40.32492940230987]],
    [ "Campbelltown Substation",[-76.58780745012594, 40.29033802125744]],
    [ "Hershey Medical Center",[-76.66917749234419, 40.2628835332318]],
    [ "South Hershey Substation",[-76.66740488339858, 40.262983513988836]],
    [ "Springwood Substation",[-76.66527164912044, 39.933342104706085]],
    [ "Queen Street Substation",[-76.68707186237346, 39.93583352881416]],
    [ "Hokes Substation",[-76.77377804920867, 39.939171366725056]],
    [ "Martinsville Substation",[-86.4302122853689, 39.430396368280796]],
    [ "Duke Energy",[-86.40474806438681, 39.4336209312851]],
    [ "1218271660",[-86.42732367520505, 39.40542685386326]],
    [ "1218317594",[-86.55692507539477, 39.353852890951465]],
    [ "Paragon Substation",[-86.56394109385434, 39.392356797638435]],
    [ "1218322614",[-112.94418512493104, 41.96593864531885]],
    [ "1218322626",[-113.14358922349152, 41.83816574091908]],
    [ "Duke Energy",[-86.2397945247638, 39.38254269465582]],
    [ "Samaria Substation",[-86.17887373111353, 39.39751033591118]],
    [ "1218380563",[-86.00972434999998, 39.44029075]],
    [ "Salem Substation",[-85.84052600158488, 42.760923592715486]],
    [ "Consumers Energy",[-85.84082691730221, 42.760900122198215]],
    [ "Bentheim Substation",[-85.93560029219421, 42.71006640421564]],
    [ "1218507872",[-96.41152807482479, 42.99639319135492]],
    [ "1218507875",[-96.48338258123067, 42.992873390225284]],
    [ "1218507882",[-96.34152978568238, 42.99670502499877]],
    [ "1218507884",[-96.3316495855252, 43.0625063683673]],
    [ "1218511256",[-86.00823277458571, 39.49362159375307]],
    [ "Norwood Hollow Substation",[-81.85042875777083, 36.13377044319358]],
    [ "1218525666",[-86.08870636687661, 39.55694663710261]],
    [ "Argyle Substation",[-103.65703115000001, 43.52524845]],
    [ "1218549423",[-83.97570137614936, 35.774288371749044]],
    [ "Chilhowee Substation",[-84.10397286712501, 35.56024195627284]],
    [ "Harrod Substation",[-86.15768206364234, 39.52076832480323]],
    [ "1218566540",[-86.17740558900638, 39.573656940198006]],
    [ "Kinder",[-86.21048985, 39.5177076]],
    [ "Willard Green Substation",[-85.99062025469054, 39.582093632125044]],
    [ "Clark Township Substation",[-85.9894169399559, 39.58187771181995]],
    [ "1218592718",[-86.09939078582583, 39.60745452549331]],
    [ "Lauschtown 500 kV switchgear",[-76.01501594255252, 40.21744496952243]],
    [ "Montgomery Substation",[-76.85949434524085, 41.17876141654302]],
    [ "Virginia Park Substation",[-86.17156012636543, 42.7539565482399]],
    [ "New Richmond Substation",[-86.12582084902903, 42.65165690445485]],
    [ "Blue Star Substation",[-86.17763900070126, 42.58438601734104]],
    [ "Fennville Substation",[-86.10505254082994, 42.59222688476678]],
    [ "1218670680",[-95.97745870700099, 43.05602732505472]],
    [ "1218761571",[-95.64422615000001, 43.171290549999995]],
    [ "1218767451",[-96.09594425158085, 43.0049004704242]],
    [ "1218772931",[-96.26352010875071, 42.96707231480086]],
    [ "1218772934",[-96.28256559087822, 42.894750229606856]],
    [ "Edgemont City Substation",[-103.82342479479888, 43.30268448428416]],
    [ "Black Hills Power",[-103.80969025, 43.30437805]],
    [ "Graniteville-35 Substation",[-72.4831891036489, 44.148428763930475]],
    [ "City of Maryville Electric Department",[-83.94648422514774, 35.774916164104475]],
    [ "1218851798",[-83.83676596845602, 35.80723099460014]],
    [ "1218854194",[-96.29923465, 43.20385225]],
    [ "Inwood Substation",[-96.44730766746801, 43.31687484298765]],
    [ "MidAmerican Energy",[-96.43265134672075, 43.13446792358464]],
    [ "Cardiff Station",[-76.13746012959284, 42.89038394646399]],
    [ "Bradford Substation",[-86.14906704750382, 42.529639465754755]],
    [ "Lords Hill Station",[-76.22087718565427, 42.90977767091902]],
    [ "1218889636",[-75.98753529999999, 43.0040325]],
    [ "1218890363",[-76.07164993466571, 43.00402461440984]],
    [ "1218890365",[-76.0729716333538, 43.003471049937964]],
    [ "1218907639",[-96.19652392515388, 43.09829850842295]],
    [ "1218907644",[-96.23465406206834, 43.07058789787624]],
    [ "1218908406",[-96.18649363258352, 43.16491176590419]],
    [ "1218908408",[-96.15795250828272, 43.1715103749669]],
    [ "1218908415",[-95.999505, 43.171903599999986]],
    [ "1218908419",[-96.0014748, 43.34284444999999]],
    [ "1218908420",[-96.23542305755804, 43.214631079118]],
    [ "1218908481",[-96.23394571835375, 43.0878575578709]],
    [ "1218908751",[-96.19449327512224, 43.03931870827565]],
    [ "1218910293",[-96.05978431906433, 43.15660161317128]],
    [ "1218910377",[-96.34445129426834, 43.21465882496571]],
    [ "Casco Substation",[-86.23096595992067, 42.50233899068674]],
    [ "1218914846",[-96.40323075865139, 42.59071107517857]],
    [ "1218914848",[-96.49538407571028, 42.538944496420484]],
    [ "Pullman Substation",[-86.08679379492676, 42.4836913448461]],
    [ "1218917768",[-86.0845183110599, 42.47182958221789]],
    [ "Pelican Lake Substation",[-96.13109565939811, 46.65885597287033]],
    [ "Volunteer Substation",[-83.81573994843143, 36.12217333012257]],
    [ "1218971819",[-104.02902082503293, 32.82141901320248]],
    [ "Tennessee Valley Authority",[-84.15445982309711, 36.0199683909973]],
    [ "Anderson Substation",[-84.05867483192746, 36.19015522285306]],
    [ "1218988545",[-96.23363637507668, 42.75019484245892]],
    [ "1218988546",[-96.35023527489928, 42.83677400415051]],
    [ "1218989091",[-96.37073802496595, 42.66298594107161]],
    [ "1218989092",[-96.46869205, 42.749904199999996]],
    [ "1218990841",[-95.85965412245946, 42.89474087525592]],
    [ "1218995831",[-95.27956082479582, 42.51788799395971]],
    [ "Dorwin Station",[-76.14857810000001, 42.983691949999994]],
    [ "St. Paul Substation",[-85.63305016109764, 39.43085133753428]],
    [ "Consolidated Nuclear Security, LLC",[-84.24958812502256, 35.987034015234144]],
    [ "Consolidated Nuclear Security, LLC",[-84.25161415, 35.986295999999996]],
    [ "Consolidated Nuclear Security, LLC",[-84.25521778590753, 35.98476928318654]],
    [ "Consolidated Nuclear Security, LLC",[-84.25702305995237, 35.98402046783816]],
    [ "Consolidated Nuclear Security, LLC",[-84.25850289999998, 35.98481985]],
    [ "Consolidated Nuclear Security, LLC",[-84.26071731817655, 35.98364169666304]],
    [ "Consolidated Nuclear Security, LLC",[-84.24709225000002, 35.98766010000001]],
    [ "Consolidated Nuclear Security, LLC",[-84.24711319999999, 35.988114800000005]],
    [ "Consolidated Nuclear Security, LLC",[-84.26320621796218, 35.98255764685976]],
    [ "Consolidated Nuclear Security, LLC",[-84.26382140000001, 35.9782501]],
    [ "Oak Ridge National Laboratory",[-84.30223369451201, 35.951287618101325]],
    [ "Knoxville Utilities Board",[-84.24003484503595, 35.87216697250406]],
    [ "Kimberley Clark Substation",[-84.32814648747858, 35.76633340635796]],
    [ "Swan Creek Substation",[-85.97466184108552, 42.484339834476145]],
    [ "1219074779",[-84.52686785359235, 35.96095334337871]],
    [ "Spicebush Substation",[-86.12248084883186, 42.41976186493164]],
    [ "Breedsville Substation",[-86.07228249192715, 42.36106670153584]],
    [ "Perrigo Substation",[-85.8294622267672, 42.52564453984083]],
    [ "Bittersweet Substation",[-85.75691197938121, 42.46635599891112]],
    [ "King Street Substation",[-72.65284971957625, 44.15053205518945]],
    [ "Green Bush Switch Station",[-75.6784470805621, 37.752527379297035]],
    [ "Perdue Delivery Point Substation",[-75.65997178959893, 37.74616163653986]],
    [ "Parksley Substation",[-75.6548015425215, 37.781175735545304]],
    [ "Crisfield Substation",[-75.83822285808678, 37.99412636126945]],
    [ "Kingston Substation",[-75.73927493884216, 38.06121305488895]],
    [ "Otsego Substation",[-85.69903709457955, 42.4639443003349]],
    [ "Otsego Paper Mill Substation",[-85.69396312405725, 42.46379344153173]],
    [ "1219257913",[-95.31137701554911, 32.351092011239224]],
    [ "1219257914",[-95.33792778063437, 32.39022606838515]],
    [ "Walnut Grove Substation",[-83.47850813095422, 35.878471887014435]],
    [ "Jones Cove Substation",[-83.40401069963663, 35.848681432960056]],
    [ "Carthage Substation",[-85.54641854965666, 39.742128685261015]],
    [ "1219298708",[-85.42232267485686, 39.7001251055921]],
    [ "Kingsport Power Company",[-82.5861555833646, 36.471021349302234]],
    [ "1219308415",[-85.44076678852693, 39.64329157516311]],
    [ "1219308416",[-85.44269775, 39.642997900000005]],
    [ "1219308417",[-85.44227717460896, 39.644428888149704]],
    [ "Duke Energy",[-85.40715691431416, 39.614079120086785]],
    [ "1219313940",[-95.23514317491006, 42.312421856296325]],
    [ "1219315977",[-95.24933800000001, 42.69804879999999]],
    [ "1219318800",[-95.21934100000001, 42.85090855000001]],
    [ "1219318815",[-95.24098717488023, 43.024741555966806]],
    [ "Pioneer Substation",[-85.52439312492145, 39.62740814449762]],
    [ "Speedwell Substation",[-83.88395218461127, 36.45730314245438]],
    [ "Merson Substation",[-85.86848305000002, 42.434864149999996]],
    [ "Wilmott Substation",[-85.69510758382918, 42.44795408294768]],
    [ "Lamokin Substation",[-75.37605830266564, 39.8429352439121]],
    [ "Jersey Central Power and Light",[-74.62753303527644, 40.86718236177115]],
    [ "Morton Substation",[-75.33677869481886, 39.90713076364525]],
    [ "Harrisburg Substation",[-85.2234867546819, 39.69453310999832]],
    [ "1219398338",[-95.11145825423657, 43.334823012929874]],
    [ "1219398342",[-95.0128703753232, 43.32821464426609]],
    [ "1219398346",[-95.10990159256116, 43.36017442477566]],
    [ "Davis Substation",[-96.82577057519313, 43.257379258290804]],
    [ "1219400274",[-95.34215103733962, 32.387760744666295]],
    [ "1219402074",[-85.13638777725387, 39.63274346595087]],
    [ "Plainwell Substation",[-85.63787429776023, 42.446693355609426]],
    [ "Byrne Dairy",[-76.05751863298673, 43.08411511831939]],
    [ "Sumner-Cowley Electric Cooperative",[-96.95155158175876, 37.36001572499067]],
    [ "Floral Substation",[-96.91621087746765, 37.333222986345476]],
    [ "1219418302",[-96.91620916589522, 37.33306092569524]],
    [ "Consumers Energy",[-85.62672743417032, 42.4405219195825]],
    [ "Consumers Energy",[-85.64748846241338, 42.42250964764701]],
    [ "Delton Substation",[-85.40977028473705, 42.503721421210976]],
    [ "Powell Valley Electric Cooperative",[-83.01463255782721, 36.69713591983112]],
    [ "Pattonsville Substation",[-82.87097479999998, 36.6933523]],
    [ "1219515551",[-85.07198630710097, 39.70012632524948]],
    [ "1219519066",[-85.09191431058052, 39.60133379951855]],
    [ "1219566263",[-84.95610091803587, 39.57211397248823]],
    [ "1219579031",[-84.90855233896554, 39.58204251711939]],
    [ "1219580732",[-79.187153719495, 37.46248315328137]],
    [ "1219585786",[-81.54563194296703, 37.370503308416794]],
    [ "Extra Energy, Inc.",[-81.49349550000001, 37.38385995000001]],
    [ "Bluefield Substation",[-81.23876385719949, 37.26410259248892]],
    [ "Hoosier Energy",[-84.91078649148042, 39.41686432459428]],
    [ "1219627509",[-85.07424449103956, 39.49723847485454]],
    [ "Huckleberry Substation",[-85.66707023162637, 42.76395105913925]],
    [ "1219661772",[-79.95102760000002, 36.73697390000001]],
    [ "Moline Substation",[-85.66401460113458, 42.74035738223523]],
    [ "Wayland Substation",[-85.64769246424136, 42.6718891965027]],
    [ "Hopkins Substation",[-85.75294002486912, 42.62384549236766]],
    [ "Sophia Switching Station",[-81.24116633509423, 37.70714855908268]],
    [ "Glen White Substation",[-81.28601700447024, 37.73824540525369]],
    [ "Winterhaven Substation",[-114.63347966609832, 32.73887778339447]],
    [ "1219770431",[-85.27004696642696, 39.49080713473845]],
    [ "Kingston Substation",[-85.2855072294979, 39.38175151972029]],
    [ "AGC Flat Glass North America, Inc.",[-82.77654268050293, 36.49551118300468]],
    [ "1219779163",[-82.73830571175722, 36.52137382839347]],
    [ "1219796415",[-85.18483897552666, 39.28807610286533]],
    [ "Hawks Substation",[-75.11207807040475, 40.62741157062869]],
    [ "1219843506",[-78.78678030399382, 42.98142900348912]],
    [ "1219873439",[-83.61224322510408, 36.07606687550121]],
    [ "1219891244",[-85.50675334999998, 39.338575]],
    [ "1219895986",[-85.33914568868312, 39.383181471112366]],
    [ "PSE&G",[-74.5061867689465, 40.391327941079794]],
    [ "1219904560",[-82.39556819560397, 36.9638984446922]],
    [ "Consumers Energy",[-85.5415884817648, 42.90038143194636]],
    [ "Birchwood Substation",[-85.53919419184012, 42.93999948335078]],
    [ "Wyoming Park Substation",[-85.72681763039895, 42.92001581913148]],
    [ "Duke Energy Florida, LLC",[-82.82195378126127, 29.974282095944837]],
    [ "Duke Energy Florida, LLC",[-82.82112817445964, 29.973847770877473]],
    [ "Duke Energy",[-85.50497755913146, 30.158699195885763]],
    [ "Duke Energy",[-85.50382939289734, 30.158533078964243]],
    [ "Duke Energy Florida, LLC",[-82.84739125953618, 29.497526824606123]],
    [ "Florida Power & Light",[-80.67773396878103, 27.241805413969505]],
    [ "Florida Power & Light",[-86.21034278193795, 30.87491044079183]],
    [ "Melvin Substation",[-85.28291420269726, 30.44853409442468]],
    [ "Florida Power & Light",[-80.54548836194672, 27.28735032511025]],
    [ "Mayo Substation",[-85.27025055986105, 30.390846220581583]],
    [ "Piedmont Substation",[-84.75012195595124, 30.67545252779586]],
    [ "Florida Power & Light",[-81.70242620883513, 29.88643027936814]],
    [ "Dellwood Substation",[-85.07704781030074, 30.757006529826864]],
    [ "Rooster Substation",[-86.94512447979022, 30.65040923885545]],
    [ "Florida Power & Light",[-80.79901842986888, 27.629898164989932]],
    [ "Youngstown Substation",[-85.44738993157925, 30.41362839175713]],
    [ "Reeves Substation",[-85.4492915793906, 30.40568461023027]],
    [ "Baltic Substation",[-81.78602989284217, 29.768388239584255]],
    [ "1220033041",[-82.7304569148024, 34.0519372681183]],
    [ "Pine Gate Renewables",[-82.73091175084, 34.05146071653358]],
    [ "1220044774",[-86.59475632039245, 31.01866130681359]],
    [ "Morrisville Substation",[-74.77735146210773, 40.20119498703185]],
    [ "Newfoundland Substation",[-75.32096700179495, 41.31983002328084]],
    [ "Newport Utilities",[-83.22278957267973, 35.891764189431534]],
    [ "Parrottsville Substation",[-83.0943819445152, 36.0127622696651]],
    [ "1220107309",[-85.88168567509513, 39.211735942721944]],
    [ "Edgely Substation",[-74.83988999744585, 40.118830135797865]],
    [ "1220125452",[-85.86695306893921, 39.22398515788759]],
    [ "Berryville Substation",[-77.99025656884093, 39.143325204231125]],
    [ "Thatcher Substation",[-74.57928703867617, 40.901183220633854]],
    [ "1220158854",[-82.87374695000003, 43.9287785]],
    [ "Kent Airport Substation",[-85.54484221090642, 42.882997924470814]],
    [ "1220247417",[-86.0340174, 39.14384295]],
    [ "1220252345",[-85.98537114999998, 39.1050172]],
    [ "1220260937",[-85.9484796000333, 39.13484452717552]],
    [ "1220260938",[-85.948745073503, 39.144888121350746]],
    [ "1220269425",[-85.85077933463947, 39.10696716697709]],
    [ "1220274985",[-85.84316089395122, 39.021934670728335]],
    [ "Elizabethtown Substation",[-85.7804382, 39.14331355]],
    [ "1220295182",[-86.21918594752763, 39.205167655691945]],
    [ "Station 8132",[-77.397669913554, 42.82014868087524]],
    [ "Station 143",[-77.34121241142572, 42.76505037474244]],
    [ "1220373647",[-86.57855529776977, 39.156613908956764]],
    [ "1220373688",[-77.72571315, 38.1510565]],
    [ "1220379488",[-83.03112524999999, 36.21771090000001]],
    [ "1220379489",[-82.97884877371999, 36.18122793123364]],
    [ "Albany Substation",[-82.90336555970362, 36.24324382849534]],
    [ "Greeneville Light and Power System",[-82.76984621471706, 36.10773832237675]],
    [ "Greeneville Light and Power System",[-82.81270919430484, 36.16639355980714]],
    [ "Greeneville Light and Power System",[-82.84269961235701, 36.17316482861591]],
    [ "Greeneville Light and Power System",[-82.8100531, 36.178743149999995]],
    [ "1220380292",[-86.55015531185622, 39.151311716887136]],
    [ "1220380294",[-86.54452242496042, 39.14973930626558]],
    [ "1220403188",[-89.48939285841377, 43.55628923762342]],
    [ "Aldrich Substation",[-83.69547864610341, 43.008448197927294]],
    [ "Consumers Energy",[-85.70969009765717, 42.92288458818457]],
    [ "1220414556",[-74.09804200884929, 40.73616921259376]],
    [ "1220517415",[-86.64429377406246, 39.137292808816305]],
    [ "Solsberry",[-86.74048114999107, 39.09773968993329]],
    [ "1220537638",[-86.94088002625487, 39.02106937016444]],
    [ "Station G",[-121.49682215988003, 38.58450819119532]],
    [ "Mid City Substation",[-121.4645604629498, 38.56346543858201]],
    [ "1220579826",[-82.79707326733124, 36.18439073353894]],
    [ "Greeneville Light and Power System",[-82.79586886741264, 36.186646652420805]],
    [ "Greeneville Light and Power System",[-82.79127795030544, 36.19087061511051]],
    [ "1220579848",[-82.74517581885614, 36.196154634648494]],
    [ "1220579849",[-82.7449349558767, 36.19620907022289]],
    [ "Greeneville Light and Power System",[-82.72971708437137, 36.26421235228651]],
    [ "Greeneville Light and Power System",[-82.8077801642881, 36.18377728401869]],
    [ "1220597913",[-87.06260732500375, 39.032460312004815]],
    [ "1220608100",[-87.17135874942757, 39.08671790550635]],
    [ "1220621395",[-82.58733232424196, 36.17921188768149]],
    [ "230 kV Switchgear",[-74.01604775351578, 40.833278312598694]],
    [ "345 kV Switchgear",[-74.01438727774702, 40.83308428558794]],
    [ "1220662371",[-103.98640932460589, 32.81058403647417]],
    [ "1220669028",[-93.62054070107497, 37.48847160639818]],
    [ "Central Electric Power Co-Op",[-94.09158129999999, 38.9282726]],
    [ "Central Electric Power Co-Op",[-94.08728581731101, 38.99641256259822]],
    [ "Stockyard Substation",[-82.58154460133828, 36.23259934186875]],
    [ "Johnson City Energy Authority",[-82.47228336266681, 36.34934468674723]],
    [ "1220951858",[-82.48220004099352, 36.39993718689412]],
    [ "Johnson City Energy Authority",[-82.45044462381236, 36.43493482021608]],
    [ "Johnson City Energy Authority",[-82.40936775616298, 36.38800541198151]],
    [ "Johnson City Energy Authority",[-82.38937163616299, 36.36059262804918]],
    [ "Johnson City Energy Authority",[-82.40010308780906, 36.343585508237275]],
    [ "Johnson City Energy Authority",[-82.44297756678375, 36.30084480519464]],
    [ "1220973850",[-87.13359442474429, 38.994018044495334]],
    [ "1220977708",[-87.14749136670105, 39.024028125098155]],
    [ "Kyle Hill Substation",[-82.57228358392354, 36.586872311714515]],
    [ "Lovedale Substation",[-82.56545592394292, 36.55731789653235]],
    [ "Kingsport Power Company",[-82.53407217884929, 36.53909603287966]],
    [ "1220980072",[-82.53920665, 36.52880424999999]],
    [ "1220983459",[-87.18746423217529, 38.90816636162204]],
    [ "1220987055",[-87.2401002, 38.92925040000001]],
    [ "1220987056",[-87.24055443534625, 38.93001566940495]],
    [ "1220994944",[-88.65186832560309, 42.78381487488719]],
    [ "1221023733",[-87.27360241639687, 38.96326684695462]],
    [ "1221045440",[-87.28801904999997, 38.9953387]],
    [ "1221045443",[-87.30990195000003, 39.0112811]],
    [ "1221052854",[-87.29840957500188, 38.96088694163065]],
    [ "Kingsport Power Company",[-82.49565500090962, 36.5211488174054]],
    [ "Cumberland Substation",[-82.55909755759176, 36.543767489851795]],
    [ "1221075975",[-82.54737431653844, 36.52938739972945]],
    [ "1221106723",[-87.79232446175467, 38.40169151001347]],
    [ "1221113346",[-88.03809084941457, 38.32815669295909]],
    [ "Arsenal to Logans Ferry",[-79.90488904825087, 40.473005924722614]],
    [ "Green Energy Resources Substation",[-79.93153670364937, 39.891899331375384]],
    [ "Newark Airport Substation",[-74.19159234437906, 40.68185930349106]],
    [ "Holston Valley Substation",[-82.07114877231426, 36.565720882356075]],
    [ "Tennessee Valley Authority",[-82.13749310478268, 36.552042115706634]],
    [ "Bristol Tennessee Essential Services",[-82.14735726338209, 36.58388983010809]],
    [ "Bristol Tennessee Essential Services",[-82.21351388364019, 36.556784305737835]],
    [ "Bristol Tennessee Essential Services",[-82.26650204005736, 36.5246096728716]],
    [ "Bristol Tennessee Essential Services",[-82.20902975723214, 36.49044256681794]],
    [ "Johnson City Energy Authority",[-82.31351745, 36.35661835]],
    [ "Tennessee Valley Authority",[-82.2504591, 36.3480208]],
    [ "Elizabethton Electric Department",[-82.222556143262, 36.35534129640406]],
    [ "Elizabethton Substation",[-82.20989336101107, 36.3588218925542]],
    [ "Tennessee Valley Authority",[-82.12595822320498, 36.34191331645274]],
    [ "Doe Substation",[-81.88679225, 36.4450984]],
    [ "Bristol Tennessee Essential Services",[-82.27076127152004, 36.56132457393062]],
    [ "Bristol Tennessee Essential Services",[-82.23098499522771, 36.584109966594134]],
    [ "Johnson City Energy Authority",[-82.37125503197778, 36.334503874433906]],
    [ "Johnson City Energy Authority",[-82.33904486756306, 36.33238289748856]],
    [ "1221240016",[-84.95144114823397, 31.546782833103162]],
    [ "SR Clay, LLC",[-84.95087871359728, 31.5461355314795]],
    [ "1221243195",[-86.04368982196517, 35.38067296874025]],
    [ "1221272036",[-87.4049447, 39.11100695]],
    [ "Tennessee Valley Authority",[-86.91035784649964, 35.701859257169616]],
    [ "1221292581",[-90.57709331433011, 44.744845625047446]],
    [ "1221292585",[-90.45476269999999, 44.7416998]],
    [ "Scott City Substation",[-87.39955624161533, 39.22670217467235]],
    [ "1221327831",[-111.34749029511603, 45.277864970641325]],
    [ "1221352453",[-87.35408878312803, 39.09209088352866]],
    [ "Elnora Substation",[-87.07861538069602, 38.8718470871137]],
    [ "David Station",[-75.47386352033523, 44.69524806326099]],
    [ "Oaktown Substation",[-87.41101985, 38.89477735]],
    [ "1221381698",[-87.37128242123279, 38.974011105504154]],
    [ "1221388811",[-87.50876825957393, 39.01590116606091]],
    [ "1221401234",[-86.36002932717265, 35.86941824325464]],
    [ "1221401236",[-86.4002966280218, 35.911582228855956]],
    [ "1221401239",[-86.40796331581319, 36.13659134457926]],
    [ "1221412864",[-112.74406452384468, 45.18107789836547]],
    [ "1221412867",[-112.68256298925458, 45.137869425001526]],
    [ "1221412870",[-112.64132761992103, 45.305223674909854]],
    [ "1221412872",[-112.55016987063783, 45.242341265029445]],
    [ "1221412874",[-112.47852595, 45.30542915]],
    [ "1221412875",[-112.326372, 45.3587514]],
    [ "1221414040",[-113.01579518837463, 45.17723667376011]],
    [ "1221414041",[-113.01643468994958, 45.17750685837146]],
    [ "1221418606",[-111.0303670602001, 45.663330616413916]],
    [ "1221420101",[-110.75995880132214, 45.32347222731517]],
    [ "1221420249",[-87.29728730000001, 38.859618649999994]],
    [ "1221421863",[-87.31528405000002, 38.83051965000001]],
    [ "1221429517",[-111.59427720276673, 45.9472170170712]],
    [ "Consumers Energy",[-85.66967971498015, 42.93646047530845]],
    [ "Nicktown Substation",[-78.82830726547537, 40.62931098768336]],
    [ "Moss Creek Substation",[-78.81184861243713, 40.65044529895385]],
    [ "Ashville Substation",[-78.55753952081155, 40.55203531517261]],
    [ "Teakettle Substation",[-78.84791641982764, 40.59858056752009]],
    [ "Revloc Substation",[-78.76928884912928, 40.49598459648918]],
    [ "Bethleham #31 Substation",[-78.8260354969761, 40.453472583779785]],
    [ "Loretto Substation",[-78.62558885799382, 40.49727979237493]],
    [ "Sankertown Substation",[-78.58925406488476, 40.46755833978222]],
    [ "Penelec",[-78.86912293041647, 40.75781057624243]],
    [ "1221454284",[-78.92065921503847, 40.55294447293328]],
    [ "1221454285",[-78.70522670596738, 40.61999548366071]],
    [ "1221454286",[-78.57371402988991, 40.60907436556407]],
    [ "1221454287",[-78.86025760239433, 40.5616353847342]],
    [ "1221454288",[-78.68960809376485, 40.47143514550066]],
    [ "1221454289",[-78.69739799467722, 40.463156098663234]],
    [ "Bethleham Mine 33 Substation",[-78.69660845885707, 40.461485792316495]],
    [ "Ebensburg Substation",[-78.74767779978816, 40.45547758465513]],
    [ "1221454292",[-78.71436243798257, 40.4512527166209]],
    [ "1221454293",[-78.715254119911, 40.44977116464526]],
    [ "Jackson Road Substation",[-78.81738366460138, 40.42938177503096]],
    [ "Birmingham Substation",[-78.22207224786673, 40.63733237900673]],
    [ "Pemberton Substation",[-78.17365230561148, 40.61029085176309]],
    [ "ABW Tap Substation",[-78.0529354290371, 40.53096551559748]],
    [ "Bellewood North Substation",[-78.33290866531489, 40.60358781673409]],
    [ "1221454301",[-77.99075094894783, 40.58590983346212]],
    [ "1221454302",[-78.20034840912554, 40.475825079013454]],
    [ "1221454303",[-78.01754162390942, 40.48404490223944]],
    [ "1221454304",[-77.92778836768856, 40.40830554247967]],
    [ "1221454305",[-77.93595211352515, 40.40827239369206]],
    [ "Mapleton Substation",[-77.9350702836774, 40.39416604094955]],
    [ "Raystown Substation",[-78.00306044300271, 40.432843473582956]],
    [ "Pinery Ridge Substation",[-78.04631711877119, 40.454740168541946]],
    [ "McConnellstown Substation",[-78.07245934982723, 40.460524142128556]],
    [ "Veterans Hospital Substation",[-78.39727735754174, 40.49076408298953]],
    [ "Pleasant Valley Substation",[-78.39678364476205, 40.48626794973788]],
    [ "Twentieth Street Substation",[-78.40539347367748, 40.507370516966]],
    [ "Twelfth Avenue Substation",[-78.40892728047262, 40.5126024098276]],
    [ "Hydracon Substation",[-78.41850876286195, 40.48303075951308]],
    [ "Cresson Mine Substation",[-78.60322696345233, 40.442496303261905]],
    [ "Gallitzin Substation",[-78.55336286214802, 40.47502022331859]],
    [ "South Fork Substation",[-78.79639098722677, 40.36376119778976]],
    [ "1221454318",[-78.81055965368581, 40.40789802090441]],
    [ "Bethingham-Gillen Substation",[-78.83301911339927, 40.422163609200744]],
    [ "Declez Substation",[-117.48815705251053, 34.07792369530849]],
    [ "1221535755",[-87.41186328315425, 38.74140020173738]],
    [ "1221551838",[-87.38683403870134, 38.798960524640805]],
    [ "1221555389",[-87.44321226596662, 38.7372147486449]],
    [ "1221557275",[-87.42003211902721, 38.85519256506822]],
    [ "1221562576",[-87.4095835, 38.6491257]],
    [ "1221564381",[-91.54598878764494, 44.82555208051489]],
    [ "Palmyra Township Substation",[-87.34639945, 38.641844799999994]],
    [ "1221580273",[-87.52531084700557, 38.52431188838393]],
    [ "Decker Substation",[-87.60440645, 38.50640645000001]],
    [ "Ninth Street Substation",[-85.68264083822447, 42.979708121117284]],
    [ "1221603481",[-85.54522097145409, 35.01553111669581]],
    [ "1221621883",[-87.31077977025176, 38.59298595521647]],
    [ "1221623940",[-87.29505302635913, 38.65898369220495]],
    [ "1221634047",[-87.52741299646222, 38.672376261410676]],
    [ "Consumers Energy",[-85.68616844149906, 42.99992428017856]],
    [ "1221659222",[-73.84772541398927, 41.745322584205496]],
    [ "1221661573",[-111.50428392510388, 45.77298535883503]],
    [ "Knickerbocker Substation",[-73.73742320765011, 42.49438813893849]],
    [ "1221782907",[-87.54118375971599, 38.669774524157276]],
    [ "Princetown Substation",[-74.10216354922578, 42.84010044435178]],
    [ "1221819858",[-75.24616210999994, 43.145717468119756]],
    [ "1221820599",[-87.52845718407042, 38.6837927247326]],
    [ "1221827829",[-87.52325926811423, 38.68957671538029]],
    [ "1221835752",[-87.51714009999999, 38.69213475]],
    [ "Duke Energy",[-87.50407681841291, 38.68959494550698]],
    [ "Stolle Road Substation",[-78.58001293276047, 42.836771920988106]],
    [ "Bedford Substation",[-80.46535720725598, 41.067749454428096]],
    [ "1221896951",[-80.51174853285075, 41.214537441625936]],
    [ "Hermitage Substation",[-80.44250017474539, 41.23609164968268]],
    [ "Hickory Substation",[-80.46204488088492, 41.23302230800816]],
    [ "Silver Street Substation",[-80.50604906751056, 41.234988578625355]],
    [ "Sharon Coating Substation",[-80.5046630387823, 41.24693036035825]],
    [ "1221896956",[-80.51058461855209, 41.242664351804635]],
    [ "1221896973",[-80.35217069575926, 40.98614530464746]],
    [ "1221896974",[-80.3503931392689, 40.99069403697964]],
    [ "Ray Street Substation",[-80.33092877377557, 40.9985421746314]],
    [ "Walmo Substation",[-80.34845492455801, 41.05183259363013]],
    [ "1221896977",[-80.31732167939084, 40.9895830163078]],
    [ "1221896978",[-80.35364278055454, 41.010169674213046]],
    [ "PA Department of Corrections",[-80.22614451436108, 41.20237534062164]],
    [ "1221896984",[-80.51428878375802, 41.52096807635086]],
    [ "1221896985",[-80.44043208373958, 41.49242576888052]],
    [ "1221896986",[-80.37053217160513, 41.41718755825534]],
    [ "Hadley Substation",[-80.2814063126473, 41.417636258501716]],
    [ "1221896988",[-80.3545839774255, 40.65876526780037]],
    [ "Hooper Springs Substation",[-111.59821083243992, 42.71290547460584]],
    [ "1221901756",[-112.23524013549202, 41.26875226832667]],
    [ "1221903562",[-111.27033971852455, 42.96500531974052]],
    [ "Volunteer Energy Cooperative",[-85.20026633926221, 36.04545636042999]],
    [ "1221937564",[-85.0042944521349, 36.24559865429484]],
    [ "1222008336",[-87.22245924758171, 38.59087482222099]],
    [ "1222116672",[-86.91670559247264, 38.675201697956695]],
    [ "Indiana Municipal Power Agency",[-87.15088065892822, 38.65847213330614]],
    [ "1222121321",[-86.93357329999999, 38.64347845]],
    [ "1222129899",[-86.62302437972784, 39.235463515698406]],
    [ "Rockford Substation",[-85.564098535288, 43.12518907517738]],
    [ "1222183557",[-83.83608785000001, 35.94165905]],
    [ "1222250478",[-86.89337947722676, 38.807870949115994]],
    [ "1222257522",[-86.82379248387433, 38.85776194804511]],
    [ "1222257523",[-86.8465903964069, 38.86959416214344]],
    [ "1222260176",[-86.64755626826626, 38.826932055467836]],
    [ "1222267709",[-86.75106829990808, 38.662513310465066]],
    [ "1222351115",[-84.12455164824388, 36.3857081757161]],
    [ "1222351119",[-84.26004197271077, 36.34959803309495]],
    [ "1222351120",[-84.39582061707151, 36.38014284364811]],
    [ "1222368973",[-111.1234504053373, 43.566530500783884]],
    [ "1222368976",[-111.12166041393421, 43.60843219259482]],
    [ "1222368980",[-111.11637476380052, 43.72244479819288]],
    [ "1222368982",[-111.33937349609496, 43.9907168442312]],
    [ "1222369340",[-80.58835623792616, 40.06543432714428]],
    [ "1222371685",[-111.3347555821022, 44.08438342505916]],
    [ "Cowan Lake Substation",[-85.44967742051433, 43.108231174465296]],
    [ "Ratigan Substation",[-85.43415016813321, 43.04398182816236]],
    [ "Bella Vista Substation",[-85.53061964876757, 43.10225255665022]],
    [ "Cannonsburg Substation",[-85.49644417995543, 43.06492401318559]],
    [ "Harvard Lake Substation",[-85.41731676615736, 43.184114282437164]],
    [ "Evergy",[-94.78526474989397, 39.88763902645761]],
    [ "1222390956",[-94.78475901226003, 39.887640096899204]],
    [ "1222390961",[-94.86899720921762, 40.0395359496773]],
    [ "1222513886",[-86.48235324122699, 38.8785220258935]],
    [ "1222515732",[-86.48627279082473, 38.88244915975049]],
    [ "1222577341",[-110.82264463877044, 43.59057311947431]],
    [ "1222577362",[-110.72873649475116, 43.32058648537469]],
    [ "1222577365",[-110.77853490000001, 43.27379355]],
    [ "1222614291",[-113.29137496877382, 46.32433184356587]],
    [ "1222616056",[-86.44770090000002, 38.7546447]],
    [ "1222619134",[-80.36348193727024, 40.97651777208976]],
    [ "Three Rivers Aluminum Substation",[-80.1075195921777, 40.70649983772279]],
    [ "Richard Substation",[-80.05292468763017, 40.62919233952687]],
    [ "Callery Substation",[-80.03734437130223, 40.74797152280656]],
    [ "Evans City Substation",[-80.05508641750895, 40.763470310889076]],
    [ "1222619286",[-86.46158065891107, 38.710531090337135]],
    [ "1222624009",[-86.512389, 38.79670575]],
    [ "1222639469",[-87.89948341853683, 34.74156781637365]],
    [ "1222640262",[-86.4138135334205, 38.89314368323974]],
    [ "1222719441",[-86.67043931821452, 36.45644250139646]],
    [ "1222745265",[-110.71890539999998, 45.32958929999999]],
    [ "1222745270",[-110.61473826039342, 45.511171925001534]],
    [ "1222746927",[-86.08155537468423, 38.932598651681495]],
    [ "1222747067",[-110.77399135684217, 45.32077067050293]],
    [ "1222747069",[-110.89747979999999, 45.2035583]],
    [ "Cromby 138 kV Substation",[-75.52941880748915, 40.152961155276934]],
    [ "1222756388",[-85.84503905643531, 39.01188877497172]],
    [ "1222766885",[-85.87497955440739, 38.96225910308132]],
    [ "1222770016",[-85.87955434537498, 38.941933635463364]],
    [ "1222865852",[-86.0565679903041, 38.86620513020688]],
    [ "1222871137",[-93.5752760250779, 44.446163061270965]],
    [ "1222871995",[-93.58649832519939, 44.548762346421945]],
    [ "1222872000",[-93.56346196715658, 44.638490992554914]],
    [ "1222872503",[-93.42181156985369, 44.522370462827894]],
    [ "1222872507",[-93.36274944999998, 44.433046250000004]],
    [ "1222873228",[-93.53038514314709, 44.56923802662982]],
    [ "1222985868",[-85.54807553918936, 38.912264175763156]],
    [ "1222990207",[-85.7226505280966, 38.99944936696146]],
    [ "1223000375",[-85.40814885, 39.1258924]],
    [ "Hoosier Energy",[-85.62365256904623, 39.036890031199455]],
    [ "Rawson Standard Oil",[-83.79108981663882, 40.94452075301734]],
    [ "West Findlay Substation",[-83.72790075584474, 40.99345540397409]],
    [ "Shawtown Substation",[-83.87137279754188, 41.109541408983965]],
    [ "Ottawa Substation",[-84.06423072255352, 41.024157603647495]],
    [ "Boutwell Substation",[-83.93998500045544, 40.87791358268346]],
    [ "1223050197",[-94.63289323849166, 41.86261367519361]],
    [ "1223053890",[-94.55087650000002, 41.9647151]],
    [ "1223053894",[-94.55104825, 42.0211358]],
    [ "1223053897",[-94.4759801, 42.0776528]],
    [ "Guthrie County REC",[-94.50293345, 41.652321549999996]],
    [ "Alliant Energy",[-94.5065737951717, 41.67792517518955]],
    [ "1223079195",[-94.6861164251536, 41.63143129406225]],
    [ "1223079199",[-94.72539848765655, 41.73231482519869]],
    [ "1223079200",[-94.79665722492776, 41.5404968575392]],
    [ "1223319392",[-78.38104297410685, 38.21025694800524]],
    [ "Wilbur Substation",[-86.48831698825913, 39.518053124874385]],
    [ "1223341541",[-94.76576574999999, 41.443857550000004]],
    [ "1223342360",[-94.6521314848252, 41.50540212512393]],
    [ "Hoosier Energy",[-85.34720687512282, 39.26906370542469]],
    [ "Hoosier Energy",[-85.26413455175322, 39.0460818455612]],
    [ "1223513251",[-85.18384878743176, 38.875827625192116]],
    [ "1223556978",[-78.41925248296295, 38.250554066239665]],
    [ "1223615969",[-120.05543028676185, 36.92337185707121]],
    [ "Summit Substation",[-75.69198154025236, 41.43709801319881]],
    [ "Rappahannock Electric Cooperative",[-77.39529987575554, 38.17286072560288]],
    [ "Hoosier Energy",[-84.89496293946806, 39.25255176913496]],
    [ "1223919255",[-84.83855023329747, 39.1306525991133]],
    [ "Hamlin Substation",[-117.44980474492576, 34.60480222443949]],
    [ "1223958930",[-76.53363574999999, 37.363698299999996]],
    [ "1224668670",[-104.602682, 38.239910650000006]],
    [ "Chapel Street Substation",[-75.74900463570333, 39.68834402798641]],
    [ "Moreau-Grand Electric Cooperative",[-101.2384889251499, 45.008496844585345]],
    [ "Moreau-Grand Electric Cooperative",[-101.21918384130599, 45.00843347710433]],
    [ "Rappahannock Electric Cooperative",[-77.2030266331346, 38.165052976157895]],
    [ "Mexico Bottoms Substation",[-84.79135073391984, 38.87179183257947]],
    [ "1224920163",[-111.22133599979595, 47.51734427783836]],
    [ "1224998344",[-111.26115657035076, 47.521718846977386]],
    [ "1225007583",[-111.1488083103396, 47.553539769942105]],
    [ "1225007584",[-111.06085060749326, 47.58194618072188]],
    [ "1225008192",[-85.40650775000002, 38.7758549]],
    [ "Duke Energy",[-85.4097862, 38.785733]],
    [ "1225015417",[-85.4135781250404, 38.83354589373735]],
    [ "1225016911",[-112.48340682785566, 46.03809516087954]],
    [ "1225016914",[-112.49332859999998, 46.03076669999999]],
    [ "1225016916",[-112.50968377222291, 46.0286823446105]],
    [ "1225033236",[-111.33875968415012, 47.451157567421966]],
    [ "Indian Creek Substation",[-94.6223989518828, 38.93049127309715]],
    [ "Belfry Substation",[-82.26675711248689, 37.625974301067096]],
    [ "Sideny Coal Substation",[-82.38030865741656, 37.66438783932778]],
    [ "New Camp Substation",[-82.29023293410815, 37.662911412753225]],
    [ "Sidney or Leslie Metering No. 1 Substation",[-82.359696563317, 37.62514497240783]],
    [ "1225126377",[-82.6215350491995, 37.75327098233634]],
    [ "East Prestonburg Substation",[-82.75025321779646, 37.67252668458923]],
    [ "1225198577",[-85.39075014490295, 38.73683952057706]],
    [ "Hanover Substation",[-85.46768458712543, 38.71757362522186]],
    [ "1225220481",[-111.58734829891358, 47.018393966814884]],
    [ "Duke Energy",[-85.65596662938182, 38.73642744493974]],
    [ "Consumers Energy",[-85.22474342964426, 43.09955933827588]],
    [ "1225340155",[-111.87066709908203, 46.672396286806546]],
    [ "Consumers Energy",[-85.24453398793072, 43.18252100392876]],
    [ "New Frankfort Junction Substation",[-85.73845411508552, 38.719948068096464]],
    [ "New Frankfort Substation",[-85.73863427241375, 38.73973646908189]],
    [ "Austin Substation",[-85.80804251658857, 38.744440819628565]],
    [ "Duke Energy",[-85.81603498265399, 38.757234044959084]],
    [ "1225463664",[-85.84329101783706, 38.79759387843959]],
    [ "Dudleytown Substation",[-85.84904605074071, 38.84436796868757]],
    [ "Chestnut Ridge Substation",[-85.86381164140273, 38.91015970123374]],
    [ "1225478573",[-85.79793629999999, 38.70096040000001]],
    [ "Little York Substation",[-85.85532242557215, 38.69973918959147]],
    [ "1225484957",[-85.77555210656426, 38.70010792475254]],
    [ "Tatlock Sub Electric Substation",[-85.77186970000001, 38.68073890000001]],
    [ "Lake Rd. Sub Electric Substation",[-85.77343092481111, 38.6707689390997]],
    [ "South Main Sub Electric Substation",[-85.7703762218136, 38.66392957458773]],
    [ "1225493620",[-74.6060971046771, 40.00404053515503]],
    [ "Henryville Substation",[-85.76791339348662, 38.541890397293535]],
    [ "Reeves Substation",[-85.6770304, 38.5998529]],
    [ "1225531448",[-85.7581077, 38.49121525]],
    [ "1225544163",[-111.99304383153134, 46.47992521781425]],
    [ "1225547333",[-112.25117687179588, 46.271645783349044]],
    [ "1225556106",[-112.11754449211101, 46.2381539057705]],
    [ "1225564686",[-112.67646601187677, 45.87145637487532]],
    [ "1225564690",[-112.78755275, 45.764683299999994]],
    [ "1225567026",[-112.79445959769727, 45.761927180093]],
    [ "Greenville Substation",[-85.25354930023498, 43.18358266855673]],
    [ "Blue Ridge EMC",[-81.42024413501935, 36.08765180632533]],
    [ "Eastman Chemical Company",[-82.5441669018732, 36.50976003224697]],
    [ "1225602783",[-82.545690764426, 36.51064896866901]],
    [ "Eastman Chemical Company",[-82.54576400200831, 36.51092675548016]],
    [ "Duke Energy",[-85.7344391138666, 38.38307728443552]],
    [ "Moore Substation",[-74.91530782200428, 40.32537928497611]],
    [ "Jersey Central Power and Light",[-74.91508455, 40.32516245]],
    [ "1225743466",[-87.45601870897383, 36.721285384758126]],
    [ "Alexauken Substation",[-74.9119963, 40.402326249999994]],
    [ "Buckeye Partners Substation",[-74.86456399708204, 40.48498100951126]],
    [ "1225775295",[-82.62716452669858, 38.47409120150575]],
    [ "Bethany Substation",[-85.70089555, 38.4285764]],
    [ "Charlestown Substation",[-85.66076372726593, 38.43850895344573]],
    [ "Ridgeview Substation",[-100.81215880647902, 45.08146067494409]],
    [ "Consumers Energy",[-83.66888903550885, 43.05759089416762]],
    [ "Duke Energy",[-85.71120526847118, 38.296786969420296]],
    [ "Jeffersonville Kentucky Avenue Substation",[-85.74373208042184, 38.27501135413558]],
    [ "1225931859",[-85.75097013956676, 38.277962433107625]],
    [ "Neshanic Substation",[-74.74045088834427, 40.50650407153988]],
    [ "Lipton Substation",[-74.84215339864657, 40.53581832154442]],
    [ "Duke Energy",[-85.74390561705442, 38.342751097557446]],
    [ "1226030901",[-85.82209596473841, 38.36163557501679]],
    [ "1226035548",[-111.17956083042588, 45.77443767767526]],
    [ "1226037628",[-111.47615669999999, 45.94666004999999]],
    [ "Trufant Substation",[-85.3363729267008, 43.29459651031769]],
    [ "Ocean City Substation",[-74.57967364970874, 39.2781648273747]],
    [ "Georgetown Substation",[-85.9758195639177, 38.31025322912325]],
    [ "1226334253",[-82.10365116678985, 36.663293317696066]],
    [ "1226334254",[-82.10407248783827, 36.663803812079436]],
    [ "Appalachian Power Company",[-81.89112437379046, 36.69188358874682]],
    [ "Remus Substation",[-85.16478252476296, 43.59676414715429]],
    [ "1226359083",[-80.04742646208842, 37.30141902161477]],
    [ "Edmore Substation",[-85.04722138639028, 43.40661652635005]],
    [ "Gilson Substation",[-85.04732781566013, 43.406353341003154]],
    [ "Stanton Substation",[-85.07358869858965, 43.29036861844906]],
    [ "Tamarack Substation",[-85.28391445147605, 43.436798099514064]],
    [ "1226443524",[-111.97794832036938, 33.45585296262191]],
    [ "1226470606",[-85.98396054002387, 38.27137442511832]],
    [ "Ramsey Substation",[-86.17071072523429, 38.32512954149598]],
    [ "1226574808",[-77.8035922, 38.58243775]],
    [ "Appalachian Power Company",[-82.22727654289287, 36.84329626703951]],
    [ "Gate City Substation",[-82.56792236369995, 36.643794973327935]],
    [ "1226593500",[-86.3833466933825, 38.37104478091115]],
    [ "Mahan Substation",[-86.36402382954483, 38.55420364171384]],
    [ "Fadem Road Substation",[-74.3143005461801, 40.682467720773296]],
    [ "1226602764",[-86.3364727590807, 38.65933107473002]],
    [ "Indian Trail Substation",[-86.44577672296003, 38.557438115695106]],
    [ "Duke Energy",[-86.46151095, 38.57145925]],
    [ "1226614124",[-86.4400958, 38.62892119999999]],
    [ "Duke Energy",[-86.44504407239351, 38.64407024387574]],
    [ "1226621534",[-95.4219955897202, 32.49003985815931]],
    [ "1226624532",[-86.59033065000001, 38.66435959999999]],
    [ "Lang Substation",[-96.06376855558132, 38.44304647598326]],
    [ "Blain Substation",[-77.49047804438223, 40.3480528258388]],
    [ "Consumers Energy",[-85.5797032750186, 42.31114015815384]],
    [ "Mosel Substation",[-85.57978997545743, 42.31846984324898]],
    [ "Buffalo Substation",[-103.54665141963432, 45.56146104018101]],
    [ "Southeast Electric Cooperative",[-104.0726320084855, 45.4327824790958]],
    [ "1226641718",[-120.92967139073144, 44.22312413855482]],
    [ "Barilla Pasta",[-77.74705166365673, 42.92411736886011]],
    [ "National Grid",[-76.19434487586341, 43.13137125522812]],
    [ "Begole Substatoin",[-84.64544634970058, 43.41383147387945]],
    [ "Shepherd Substation",[-84.68696810894616, 43.52850417070362]],
    [ "Lisbon Station",[-75.32164985928141, 44.72503431481455]],
    [ "Station 246",[-77.81147282427408, 42.78560290650932]],
    [ "1226660214",[-82.53878195, 36.94625510000001]],
    [ "1226660217",[-82.55731397516564, 36.96586754144993]],
    [ "Lipps Substation",[-82.64814284030095, 37.006512522044396]],
    [ "1226660229",[-82.6504447, 37.01037869999999]],
    [ "1226660242",[-83.51712347568166, 36.8400970097512]],
    [ "1226660247",[-83.87294871038743, 36.83918152070564]],
    [ "Cumberland Substation",[-82.96847755196488, 36.970439337255186]],
    [ "1226671502",[-83.0026593041512, 36.96533283264832]],
    [ "Kentucky Utilities Company",[-83.02302433677059, 36.97124025614083]],
    [ "1226671506",[-83.09411679096239, 36.94423672190749]],
    [ "1226671508",[-83.08978143310387, 36.94076419420437]],
    [ "1226676996",[-103.98485080075739, 32.951560163406285]],
    [ "1226685690",[-82.70806688104548, 36.93303425499694]],
    [ "1226685696",[-82.7524813167478, 36.88560230527079]],
    [ "1226685706",[-82.78344647517113, 36.90359809498165]],
    [ "Holmes Mill Substation",[-83.01039802980479, 36.875224761035504]],
    [ "1226685716",[-82.96595176587445, 36.868677843948916]],
    [ "1226685718",[-83.03094843242522, 36.836127122411796]],
    [ "1226685729",[-83.0374448218171, 36.76849178567056]],
    [ "1226685731",[-83.0310031, 36.76135585]],
    [ "1226693040",[-83.11056405638087, 36.72612986724738]],
    [ "1226693046",[-83.33445043133712, 36.77276238870107]],
    [ "1226693048",[-83.31936332164233, 36.80977911098393]],
    [ "1226693058",[-83.36611250000001, 36.70870549999999]],
    [ "1226693060",[-83.38249536544174, 36.665039056186046]],
    [ "1226693063",[-83.37203614391221, 36.845126908129934]],
    [ "1226693073",[-83.41553510738838, 36.728526232253195]],
    [ "Dubois Substation",[-86.78825114949028, 38.42107556262288]],
    [ "1226723857",[-83.58361734386959, 36.796059615813384]],
    [ "1226723859",[-83.66456889793396, 36.79624978335591]],
    [ "1226723864",[-83.73220139120312, 36.66766982674796]],
    [ "1226723871",[-83.6924773, 36.6672051]],
    [ "Tower Substation",[-86.34137791525141, 38.23565176124455]],
    [ "1226735049",[-86.13362026206872, 38.25033012856052]],
    [ "Ramsey Substation",[-86.17143201294402, 38.31774117514803]],
    [ "Fremont Substation",[-82.39646644589264, 37.12982639973548]],
    [ "1226752518",[-86.12435133031036, 38.233886605313955]],
    [ "1226752519",[-86.11613892538163, 38.21766544545647]],
    [ "64th Street Substation",[-97.24367947349661, 37.65067174636652]],
    [ "Minneha Substation",[-97.24399682503055, 37.69224674434213]],
    [ "47th & Webb Substation",[-97.22685387518344, 37.59975091235114]],
    [ "1226863084",[-111.51837729560457, 41.06399915196609]],
    [ "Mossman Substation",[-97.30102835238058, 37.69982625088534]],
    [ "Innovate Substation",[-97.28960078725598, 37.7159239484369]],
    [ "1226867439",[-83.58064095000002, 37.92049895]],
    [ "Burna Substation",[-88.36192300110677, 37.24582572383858]],
    [ "Breckenridge Substation",[-84.46963058081076, 43.40577394053705]],
    [ "Tall Grass Substation",[-97.01585796683194, 37.75376592165399]],
    [ "Park City Substation",[-97.30719280979989, 37.789365170432056]],
    [ "1226890510",[-82.18286763049004, 36.984298186321574]],
    [ "1226890511",[-82.18281278997324, 36.98376527363071]],
    [ "1226890512",[-82.18275358161033, 36.98333954796771]],
    [ "Buchanan Minerals, LLC",[-82.01617335, 37.1674256]],
    [ "1226890517",[-82.03271209137776, 37.17672804443791]],
    [ "Buchanan Minerals, LLC",[-81.99505218006296, 37.17534440727542]],
    [ "Buchanan Minerals, LLC",[-81.98603326807765, 37.160899580401164]],
    [ "Buchanan Minerals, LLC",[-81.98353244999998, 37.157064]],
    [ "Buchanan Minerals, LLC",[-81.9748019, 37.17088645]],
    [ "Buchanan Minerals, LLC",[-81.95770301622841, 37.16440124557269]],
    [ "1226890533",[-81.95494569999998, 37.17251805]],
    [ "1226890534",[-81.95521351552324, 37.172776324998296]],
    [ "Appalachian Power Company",[-81.78505295685953, 37.463163722273414]],
    [ "Appalachian Power Company",[-81.71957978415578, 37.52203862229242]],
    [ "Jewell Coal and Coke Company, Inc.",[-82.03229621680632, 37.23925579691229]],
    [ "Appalachian Power Company",[-81.98431860090078, 37.27936642031937]],
    [ "Looney Creek Substation",[-82.09428974941524, 37.31556298991853]],
    [ "1226890565",[-82.0635627, 37.327928699999994]],
    [ "1226891359",[-103.79668585408163, 32.987743753485354]],
    [ "1226891361",[-103.79732991855727, 32.98741438403155]],
    [ "Dogwood Substation",[-86.10193671994355, 38.14232208852088]],
    [ "Mauckport Substation",[-86.18846606610697, 38.0482430250801]],
    [ "1226956362",[-85.96794762505574, 38.1276002048563]],
    [ "1226972259",[-82.34195716413787, 37.024051570889576]],
    [ "Paramont Contura, LLC",[-82.38832008338665, 37.097336367576276]],
    [ "Paramont Contura, LLC",[-82.37114133108676, 37.05969287065016]],
    [ "North Substation",[-86.92827595119243, 38.41616970585333]],
    [ "Glendale Substation",[-87.01535310073311, 38.55389055444242]],
    [ "1226996368",[-91.34384570808926, 40.74020094933055]],
    [ "1226998877",[-91.44063634816432, 40.85533783128194]],
    [ "Appalachian Power Company",[-82.4859245615329, 37.13869641651387]],
    [ "1227020302",[-82.58192675290083, 37.136590856924585]],
    [ "1227020303",[-81.96106568538227, 37.175481262794825]],
    [ "1227020308",[-81.87258689999999, 37.120383399999994]],
    [ "Appalachian Power Company",[-81.87022398602303, 37.116338805344434]],
    [ "1227026470",[-81.83376830201315, 37.21848756843823]],
    [ "1227026471",[-81.80186282499798, 37.235422193549944]],
    [ "1227026472",[-81.7756594668907, 37.22820484428708]],
    [ "1227043194",[-114.21964533664426, 35.069343950226404]],
    [ "1227046519",[-91.55113416243468, 40.972078290426744]],
    [ "1227046758",[-91.52472121029273, 40.95937327944153]],
    [ "Bridgeton Substation",[-75.09606959254403, 40.54417532533598]],
    [ "Raubsville Substation",[-75.19521903815959, 40.626196879251175]],
    [ "West Portal Substation",[-75.04420443544227, 40.66326208977167]],
    [ "Jersey Central Power and Light",[-75.18542232442323, 40.68574951084781]],
    [ "Crawford Substation",[-84.78641840113076, 43.557405736366285]],
    [ "Mission Substation",[-84.76439905, 43.56906965]],
    [ "Central Michigan University Substation",[-84.7791483827101, 43.59065459504043]],
    [ "Fordyce Substation",[-84.77873550324016, 43.61050383749675]],
    [ "1227147494",[-87.01643201568928, 38.42928200147698]],
    [ "Huntingburg Substation",[-87.00309946534937, 38.30178922308995]],
    [ "1227162816",[-86.95263466127011, 38.29841804219758]],
    [ "Patoka Valley Substation",[-86.97886125000002, 38.32014145000001]],
    [ "1227173766",[-86.87056903951833, 38.30497147771975]],
    [ "Hoosier Energy",[-86.87999674999999, 38.234138449999996]],
    [ "New Haven Substation",[-86.89044556266361, 38.18980078047343]],
    [ "St. Henry Transmission Station",[-86.92406688714796, 38.22085745373753]],
    [ "CenterPoint Energy",[-86.87044732999209, 38.17120338082594]],
    [ "1227196824",[-86.92384924927175, 38.349196512580576]],
    [ "City of Jasper Municipal Electric Utilities",[-86.95117341768791, 38.37909942867275]],
    [ "1227262388",[-91.7614196500459, 41.024102053279876]],
    [ "Jersey Central Power and Light",[-74.99304685968342, 40.63583448103005]],
    [ "Jersey Central Power and Light",[-74.8314061, 40.65149425]],
    [ "Virginia Electric and Power Company",[-79.30676170805295, 37.87047601952676]],
    [ "1227357234",[-87.35110524999999, 38.46999035]],
    [ "1227360850",[-87.39195118222071, 38.48544871662248]],
    [ "1227371628",[-87.24029177902962, 38.35024828293578]],
    [ "CenterPoint Energy Delivery",[-87.15157533258193, 38.304051316211556]],
    [ "Duke Energy",[-87.28010197488899, 38.230846587693755]],
    [ "Duke Energy",[-87.26175595, 38.24491869999999]],
    [ "1227386136",[-87.2832948, 38.24422520000001]],
    [ "1227386138",[-87.27856075, 38.251030500000006]],
    [ "North Winchester Substation",[-78.15551987243448, 39.197936760766105]],
    [ "Faraday Substation",[-81.66633318369757, 37.20775095936425]],
    [ "Bearwallow Substation",[-81.72776317262799, 37.2395799507809]],
    [ "1227433473",[-87.43247598775687, 38.335107919906534]],
    [ "1227433474",[-87.4319036796542, 38.33497169670047]],
    [ "Bay City Electric Light & Power",[-83.88814958033025, 43.57601255072481]],
    [ "Rural Retreat Substation",[-81.25309802530737, 36.89012514701445]],
    [ "Jersey Central Power and Light",[-74.96992384778432, 40.756708532470505]],
    [ "1227467653",[-87.49132487305576, 38.45516080502089]],
    [ "Francisco",[-87.48310659999999, 38.36264864999999]],
    [ "Princeton Substation",[-87.51941751222553, 38.413744975073264]],
    [ "1227473017",[-87.69299955372446, 38.38472704896646]],
    [ "Owensville Substation",[-87.67824581246992, 38.31926602494036]],
    [ "1227475377",[-87.6945151, 38.30746495]],
    [ "1227478006",[-87.56970796814565, 38.33952647160523]],
    [ "1227478489",[-87.3907239748558, 38.308913958900376]],
    [ "1227485760",[-87.57832651944652, 38.31169696538689]],
    [ "1227499234",[-91.44808188746731, 40.703660810068165]],
    [ "1227512951",[-74.7877925923035, 40.8917598172778]],
    [ "1227584905",[-87.70128882489153, 38.30635913761798]],
    [ "Poseyville Substation",[-87.78509258748957, 38.227857919463965]],
    [ "1227588803",[-87.78457787529304, 38.22785054504919]],
    [ "Duke Energy",[-87.69360965, 38.26711505]],
    [ "Duke Energy",[-87.78061895, 38.19098720000001]],
    [ "1227627081",[-87.33561577064545, 38.22513834106594]],
    [ "1227665138",[-75.11062840064635, 40.7996261071942]],
    [ "1227666735",[-86.77411557002088, 37.95431503232887]],
    [ "1227679740",[-86.72151089949764, 37.98778466594519]],
    [ "1227688081",[-86.87227987456025, 38.04784374072209]],
    [ "1227690722",[-86.90242864999999, 38.12294235]],
    [ "1227691853",[-86.90417533372873, 38.04290164789013]],
    [ "1227706596",[-91.56593269433732, 40.70491133823896]],
    [ "Byllesby Substation",[-80.93531695325775, 36.784528650305255]],
    [ "Appalachian Power Company",[-80.89270156767374, 36.694601144518]],
    [ "Woolwine Substation",[-80.26734291938294, 36.77128418508756]],
    [ "Appalachian Power Company",[-80.02717165527001, 36.780701130962505]],
    [ "Appalachian Power Company",[-79.89912155, 36.5490921]],
    [ "1227781474",[-79.45959061482932, 36.547307459043445]],
    [ "1227781485",[-79.3746004795634, 36.54565617501488]],
    [ "1227781486",[-79.37288985, 36.5456659]],
    [ "1227781488",[-79.35280142260524, 36.54440334587663]],
    [ "1227783070",[-86.94213967944225, 38.11883763266264]],
    [ "Dale Substation",[-86.98807057512731, 38.1682862916976]],
    [ "Newtonville Substation",[-86.95281123967395, 38.002656632046765]],
    [ "Chesney Substation",[-87.06928432689439, 38.019025595769136]],
    [ "1227817707",[-87.1191018, 37.9126933]],
    [ "1227863687",[-115.7781093644399, 36.06768177493519]],
    [ "Degonia Substation",[-87.22280305, 38.041976749999996]],
    [ "1227896544",[-114.49024616572883, 34.78413200628824]],
    [ "Hemenway Substation",[-87.15164319477124, 38.20414290671625]],
    [ "Southern California Edison",[-118.82145006151711, 36.12662382070524]],
    [ "1227921720",[-91.7762181251205, 40.76876413279681]],
    [ "Weidman Substation",[-84.90888035018344, 43.6830756198331]],
    [ "Industrial Substation",[-74.5393978844854, 40.72638966716781]],
    [ "1228040037",[-87.4685237, 38.08731799999999]],
    [ "Vigo Substation",[-87.34955166987889, 38.09238638800658]],
    [ "1228081857",[-79.91478136477782, 36.70590366977965]],
    [ "Appalachian Power Company",[-79.89588484693084, 36.66252650818351]],
    [ "Appalachian Power Company",[-79.86982407033719, 36.69258292993722]],
    [ "1228081901",[-79.60632996878216, 36.5706395551653]],
    [ "1228081925",[-79.39760284033535, 36.631639711837785]],
    [ "1228081928",[-79.41592672770231, 36.669338508160045]],
    [ "1228081930",[-79.51491661223179, 36.72178286478]],
    [ "1228107443",[-87.39075434053393, 37.94723122134935]],
    [ "1228113232",[-87.3861595909815, 37.98740887508011]],
    [ "Appalachian Power Company",[-79.39816968693151, 36.59604205212741]],
    [ "1228197237",[-79.38804329241066, 36.587949406011965]],
    [ "1228197239",[-79.43919566954507, 36.56510584445158]],
    [ "Danville Utilities",[-79.4126484383462, 36.568737544984934]],
    [ "1228197249",[-80.44790537505473, 36.66694875007682]],
    [ "Dominion Renewable Energy",[-79.48122235000001, 36.89881335]],
    [ "Appalachian Power Company",[-79.48074984876594, 36.89826177398498]],
    [ "Broadview Substation",[-87.38860712945487, 37.97302110237642]],
    [ "Grimm Road Substation",[-87.432811546954, 37.9667430775984]],
    [ "1228249434",[-74.40419074556706, 40.796879094607306]],
    [ "Bell Labs Substation",[-74.40765189924163, 40.81796163297205]],
    [ "Star Ledger Substation",[-74.33897409999999, 40.8544369]],
    [ "St. Wendell Substation",[-87.59734002592103, 38.098327694522254]],
    [ "Mohr Road Substation",[-87.59908967339183, 38.0509932294038]],
    [ "1228294514",[-80.54822465000001, 37.127820500000006]],
    [ "CenterPoint Energy",[-87.56606547557271, 38.02516224061848]],
    [ "Folz Rd. Substation",[-87.60575800505467, 38.02634896308011]],
    [ "County Line Substation",[-87.69847853574493, 38.02018327018275]],
    [ "Troy Hills Substation",[-74.39725414793139, 40.864382767850024]],
    [ "Parsippany Substation",[-74.4221477466204, 40.87548797981149]],
    [ "Boonton Substation",[-74.41115156566423, 40.902048378657575]],
    [ "1228311724",[-91.42442089460988, 40.58434569740504]],
    [ "Casino Substation",[-84.71760012520092, 43.60341850820793]],
    [ "Two Bridges Sewar Substation",[-74.27453335000001, 40.90650815]],
    [ "Riverdale Quarry",[-74.3096916128796, 40.99482287271594]],
    [ "45th Street Substation",[-97.50847771241419, 37.76475187858634]],
    [ "Maize Substation",[-97.50809692322377, 37.76484025365466]],
    [ "Sparks Substation",[-84.34050443972157, 43.61262910998907]],
    [ "CenterPoint Energy",[-87.54183719999999, 38.0399838]],
    [ "Ramapo Water Substation",[-74.2796570211625, 40.99256464433394]],
    [ "1228344730",[-74.28747920832352, 41.00812342543769]],
    [ "City of Moundridge",[-97.51257949126943, 38.19272167489741]],
    [ "Passaic Stone Substation",[-74.30365187411299, 41.00671098528817]],
    [ "1228347807",[-74.29343119125429, 41.04475881920031]],
    [ "Jade Substation",[-97.18662006017932, 38.35421367055804]],
    [ "Ithaca Substation",[-84.6105408560832, 43.290295335588155]],
    [ "Siegfried Substation",[-75.51422511848895, 40.71243427394592]],
    [ "Smythe Substation",[-87.4874509897719, 37.99548628359285]],
    [ "CenterPoint Energy",[-87.49196017608168, 37.976233856488584]],
    [ "Fairlawn Substation",[-87.5351497137768, 37.94862285375832]],
    [ "1228497429",[-75.01744531366683, 40.82998179951428]],
    [ "Eastland Dist. Substation",[-87.498577, 37.9812796]],
    [ "CenterPoint Energy",[-87.5209149936741, 37.98667228478271]],
    [ "1228522684",[-87.56523795, 37.99918395]],
    [ "Ashley Substation",[-84.47854090890159, 43.18905655552116]],
    [ "1228540824",[-75.0709916803542, 41.03464388638293]],
    [ "Middleton Substation",[-84.70666191127809, 43.18557546502088]],
    [ "Plymouth Substation",[-87.55178305546525, 37.99108123652582]],
    [ "Carson City Substation",[-84.84691886870564, 43.18614224894232]],
    [ "Appalachian Power Company",[-80.17459803331339, 37.26610405077389]],
    [ "Mulberry Substation",[-87.56558705806566, 37.9676341486807]],
    [ "1228706138",[-89.89174731480726, 34.9355916747374]],
    [ "North Blacksburg Substation",[-80.38085689697712, 37.27700031474106]],
    [ "Appalachian Power Company",[-80.26060595, 37.2530174]],
    [ "Catawba Substation",[-80.02648077734315, 37.331932208479486]],
    [ "1228726631",[-80.02617874892894, 37.33160547220463]],
    [ "City of Salem",[-80.04328875587774, 37.294012442762806]],
    [ "1228726646",[-80.03858065537405, 37.27689432902421]],
    [ "1228726651",[-80.03065629390521, 37.27986615145066]],
    [ "CenterPoint Energy",[-87.55353132831003, 37.98131132510452]],
    [ "1228733079",[-79.90412296190117, 37.275274575145865]],
    [ "Ingle Station",[-87.57617933287301, 37.97281813783771]],
    [ "1228751622",[-87.6018261048771, 37.974587299084355]],
    [ "1228754383",[-91.02655493976027, 40.89639688924684]],
    [ "1228754385",[-91.03033476619937, 40.96441835675274]],
    [ "1228755161",[-91.03561832634678, 41.06548879361156]],
    [ "Whitlock Substation",[-74.57330350126807, 40.89858975738423]],
    [ "Dover Substation",[-74.56448987112687, 40.888738368686546]],
    [ "Morris Substation",[-74.5490362, 40.8741669]],
    [ "1228766002",[-91.03943816766197, 41.09104432070475]],
    [ "Yukon Substation",[-81.70614595977695, 37.3235321847774]],
    [ "Crystal Substation",[-84.91265883937321, 43.25655750511691]],
    [ "1228769431",[-74.49597389859434, 40.915531766960804]],
    [ "1228769432",[-74.49464142177273, 40.92588589713793]],
    [ "1228769444",[-74.53676684869308, 40.93561765445497]],
    [ "Map/SLI=Substation Abandoned? Rockaway Townsquare Substation",[-74.55435916718147, 40.9035779255449]],
    [ "East Dover Substation",[-74.54385634489987, 40.89528320128814]],
    [ "Fleetwood Substation",[-74.52503919442535, 40.91048668877483]],
    [ "Blackmer Substation",[-84.87381708439717, 43.29210854616574]],
    [ "Tolna Generator Substation",[-76.63546645, 39.76091064999999]],
    [ "Johnson Controls Substation",[-76.65483173572042, 39.77214430740811]],
    [ "1228810362",[-79.905958164185, 37.444393380326794]],
    [ "Town of Bedford",[-79.54147228585677, 37.33934256383802]],
    [ "Town of Bedford",[-79.51234264220086, 37.33345585864168]],
    [ "1228810371",[-79.46506732164642, 37.45994981376944]],
    [ "Appalachian Power Company",[-79.39792699160427, 37.54106836390724]],
    [ "1228836404",[-78.92625625844398, 37.430280383433306]],
    [ "1228836406",[-78.9933256725098, 37.330650793302645]],
    [ "1228836411",[-79.05956695, 37.404304700000004]],
    [ "1228870167",[-79.3509220263502, 36.8422870863979]],
    [ "Virginia Electric and Power Company",[-79.36028234461844, 36.93070316232716]],
    [ "Whitehorn Solar, LLC",[-79.35963782726174, 36.930479481604465]],
    [ "Dominion Energy Inc.",[-79.19457800099877, 36.9422263041446]],
    [ "Virginia Electric and Power Company",[-79.19411256387853, 36.94230086824971]],
    [ "Virginia Electric and Power Company",[-79.291932912207, 37.078875829935804]],
    [ "Virginia Electric and Power Company",[-79.05933922468995, 37.16645885795622]],
    [ "Virginia Electric and Power Company",[-79.2530575747335, 37.05423356978427]],
    [ "Tekoppel Substation",[-87.62360624254296, 37.98110134153709]],
    [ "1228933804",[-87.68193765712094, 37.960531425019674]],
    [ "1228939026",[-112.1964691661845, 41.87945074458105]],
    [ "Palisades Generation Substation",[-86.31472609531174, 42.32255160490738]],
    [ "1229072427",[-78.78259860000001, 37.5069986]],
    [ "1229072434",[-78.50216504999999, 37.795244700000005]],
    [ "Blue Mountain Substation",[-75.47682708780572, 40.794162138583665]],
    [ "1229140004",[-112.70781704421705, 33.47962440216319]],
    [ "1229157185",[-84.51591379999999, 37.25773785]],
    [ "CenterPoint Energy",[-87.88084819614357, 37.93085575993719]],
    [ "1229187012",[-91.3907593183911, 40.92924217536159]],
    [ "1229193787",[-91.16242071568917, 40.94287288662026]],
    [ "1229199390",[-91.17330456913, 40.877074163405155]],
    [ "1229199392",[-91.21349627643093, 40.86189120215834]],
    [ "East Kentucky Power Cooperative, Inc.",[-84.32111387096415, 37.507725908325156]],
    [ "1229206021",[-91.43840307193373, 41.137067826271526]],
    [ "8th Street Substation",[-75.47307762441018, 40.59949368901102]],
    [ "1229266108",[-78.50576653485538, 37.71644356158565]],
    [ "Cushaw Substation",[-79.38046653448173, 37.592872930033806]],
    [ "1229266119",[-79.61056819091196, 37.58371848756093]],
    [ "Buchanan Substation",[-79.67868762747364, 37.53515311178402]],
    [ "Buena Vista Substation",[-79.35674994291436, 37.73217992023033]],
    [ "BARC Electric Cooperative",[-79.5114812, 37.9712596]],
    [ "1229441034",[-80.24130497296564, 37.75177628353702]],
    [ "1229443489",[-87.93299915, 37.9063971]],
    [ "1229458891",[-87.8468447, 38.15604955]],
    [ "Wadesville Substation",[-87.78572227464608, 38.074149801981186]],
    [ "Craigsville Substation",[-79.38484797849496, 38.08284445829175]],
    [ "Shenandoah Valley Electric Cooperative, Inc.",[-79.21650555494172, 38.13778492983339]],
    [ "Virginia Electric and Power Company",[-79.39321958686281, 37.909725794077495]],
    [ "Virginia Electric and Power Company",[-78.28976688396885, 37.73232025053872]],
    [ "Virginia Electric and Power Company",[-78.89657901739854, 38.3475706707678]],
    [ "City of Harrisonburg",[-78.89798083008897, 38.40094480042628]],
    [ "City of Harrisonburg",[-78.86441572984612, 38.4680979708071]],
    [ "1229674470",[-105.08666517497504, 40.38149564163057]],
    [ "Molson Coors Beverage Company USA LLC",[-78.67276626186589, 38.3581564223019]],
    [ "1229732163",[-75.5350439354641, 40.52010251799498]],
    [ "1229741623",[-109.97532375, 33.822399100000005]],
    [ "1229751179",[-84.32741466134107, 37.78365109884144]],
    [ "Kentucky Utilities Company",[-84.39413506809025, 37.83704992288063]],
    [ "1229776653",[-86.71585848208203, 38.1369999831655]],
    [ "1229806597",[-117.45272677498747, 33.962133193097515]],
    [ "1229883853",[-77.9570370695606, 39.39011020369748]],
    [ "1229895491",[-78.1950710292423, 39.13021662909633]],
    [ "1229895492",[-78.19521808499127, 39.13031307813628]],
    [ "1229895494",[-78.18512231435686, 39.140830319647115]],
    [ "1229895501",[-78.17551459191716, 39.16290856301882]],
    [ "Hayfield Substation",[-78.29255385459706, 39.231420982021916]],
    [ "1229895507",[-78.33935209999999, 39.249417449999996]],
    [ "1229895513",[-78.13980779206192, 39.207049065834]],
    [ "1229955422",[-78.17243314189511, 38.998662578997795]],
    [ "1229955426",[-78.17362033807636, 38.98204408103883]],
    [ "Kentucky Utilities Company",[-84.66729336531742, 37.54328627267763]],
    [ "1230005839",[-96.46282723428668, 41.42725295415876]],
    [ "1230006667",[-96.49225429698042, 41.45955454533099]],
    [ "Consumers Energy",[-84.54888699232535, 43.022021708224756]],
    [ "Consumers Energy",[-84.52960939350706, 43.00929782338555]],
    [ "St Johns Substation",[-84.55138124682894, 43.00430450289766]],
    [ "Consumers Energy",[-84.5726603140584, 43.00264531658753]],
    [ "1230073585",[-78.14992644462373, 38.94182496737749]],
    [ "1230073589",[-77.8724161190533, 39.12097600158934]],
    [ "1230090519",[-98.02327366615663, 35.02840580257667]],
    [ "Page Substation",[-78.4521457969366, 38.66957405053522]],
    [ "Stanley Substation",[-78.52821735232367, 38.58134602672832]],
    [ "Pyah Substation",[-74.35634779908091, 40.91711955815079]],
    [ "Jersey Central Power and Light",[-74.33700228306736, 41.00222286130995]],
    [ "Jersey Central Power and Light",[-74.33757596459162, 41.00204931585381]],
    [ "Jersey Central Power and Light",[-74.33833031860522, 41.001904657795194]],
    [ "Changebridge Substation",[-74.3672654264247, 40.89146788161687]],
    [ "Jersey City Water Substation",[-74.3926742, 40.892533500000006]],
    [ "Green Bank Substation",[-74.39157733928266, 40.8950655026335]],
    [ "NJT Dover Substation",[-74.55001485093565, 40.88316430147598]],
    [ "New Jersey Transit",[-74.48418799195824, 40.88404615121576]],
    [ "Dickerson Substation",[-74.54897057065574, 40.88347276268395]],
    [ "Jersey Central Power and Light",[-74.50400721013646, 40.77251487090403]],
    [ "1230151674",[-74.47293412265125, 40.84064635160034]],
    [ "Sandoz Substation",[-74.38788716141195, 40.80824160058282]],
    [ "Whitney Substation",[-74.46908597244777, 40.77943184550622]],
    [ "1230164609",[-78.85172652614102, 37.362106962222036]],
    [ "1230164616",[-78.8119174, 37.1877881]],
    [ "1230230423",[-114.88047267614948, 36.232131124207335]],
    [ "1230230426",[-114.8793556309994, 36.22504201311407]],
    [ "1230337700",[-82.03422249065713, 35.36599516772716]],
    [ "Virginia Electric and Power Company",[-78.58122929850427, 37.0165051288771]],
    [ "1230382718",[-78.27957745167775, 37.23160964298098]],
    [ "Virginia Electric and Power Company",[-78.18537884076504, 37.18754916594658]],
    [ "Virginia Electric and Power Company",[-78.14687481841136, 37.19139216068736]],
    [ "Products (SE) Pipe Line Corporation",[-78.14368880000002, 37.10365515]],
    [ "Victoria Substation",[-78.22122496099026, 36.98694571363535]],
    [ "Nutbush Substation",[-78.28229236633088, 37.044410971847064]],
    [ "Dominion Energy Inc.",[-78.45079099943071, 36.82054966663518]],
    [ "Virginia Electric and Power Company",[-78.45045742950329, 36.820188368557204]],
    [ "American Bumper Substation",[-85.03016212430356, 42.988385070026446]],
    [ "Consumers Energy",[-85.0736546442519, 42.980669001583884]],
    [ "Palo Substation",[-84.99600688283358, 43.06107235456105]],
    [ "Orleans Substation",[-85.14272755291411, 43.07595479680975]],
    [ "1230499396",[-110.7279417854176, 47.81528610006148]],
    [ "1230501857",[-110.95655029669379, 47.77814148288719]],
    [ "Beaverton Substation",[-84.4827607901828, 43.88407652053084]],
    [ "Morton Substation",[-75.33202302849061, 39.907299797341224]],
    [ "PECO",[-75.33523013327351, 39.90580490055155]],
    [ "Angora Substation",[-75.23623633602273, 39.9453346063902]],
    [ "PECO",[-75.2588459783977, 39.91209499818097]],
    [ "Lyons Substation",[-84.94696491723232, 42.983006975767275]],
    [ "Webber Dam Substation",[-84.90154266603551, 42.95226892108037]],
    [ "Clyde Road Substation",[-85.02901327722698, 42.951475433130774]],
    [ "David Substation",[-84.88063724383694, 42.92685378609611]],
    [ "1230855847",[-78.36340058315096, 36.69266460156741]],
    [ "Virginia Electric and Power Company",[-78.36268737610325, 36.69197440038614]],
    [ "Virginia Electric and Power Company",[-78.35172347942132, 36.683555605710545]],
    [ "Virginia Electric and Power Company",[-78.35815593418396, 36.66225851746295]],
    [ "1230855855",[-78.35977921168374, 36.66292689933072]],
    [ "Virginia Electric and Power Company",[-78.54249572807727, 36.613593683513756]],
    [ "PECO",[-75.33177017169432, 39.859631111069]],
    [ "Virginia Electric and Power Company",[-78.83986258685842, 36.799083863836834]],
    [ "Sunnybrook Farm Solar, LLC",[-78.83916915021224, 36.79933126479514]],
    [ "Products (SE) Pipe Line Corporation",[-78.73518244999998, 36.738134599999995]],
    [ "1230933309",[-79.02760537836215, 36.55461507132487]],
    [ "Rocky Mountain Power",[-111.80060075950308, 39.980742155225286]],
    [ "1230958562",[-111.72215397728178, 40.337777554899965]],
    [ "1230960282",[-111.57986646671242, 40.07270434985098]],
    [ "1230960687",[-111.61329777497401, 40.100834543893285]],
    [ "1230973503",[-111.59313195000001, 40.16144105]],
    [ "1230974869",[-111.6573320248528, 40.10921260524543]],
    [ "1230982258",[-111.61878955884312, 40.17784229640724]],
    [ "1230982261",[-111.61855551356606, 40.17629477404795]],
    [ "1230984548",[-111.59738556149847, 39.55066305012367]],
    [ "1230984554",[-112.199000684722, 39.56298009297626]],
    [ "TRW Substation",[-84.9093964, 42.881436086461406]],
    [ "Portland Substation",[-84.89507146531038, 42.86867097916397]],
    [ "Saville Substation",[-75.34595270545942, 39.85630945328831]],
    [ "PECO",[-75.1179732, 40.01003605]],
    [ "Crescentville Substation",[-75.10632136558284, 40.035300750476196]],
    [ "1231162679",[-77.70110542484268, 36.76422165077917]],
    [ "1231165434",[-73.97182728095204, 41.47929453095971]],
    [ "1231175137",[-110.49549718248387, 47.93569875185165]],
    [ "Virginia Electric and Power Company",[-77.53020141429451, 36.69473038056608]],
    [ "1231184679",[-77.50528849634458, 36.73716726683521]],
    [ "Dominion Energy Inc.",[-77.56535218777184, 36.636606174775146]],
    [ "Virginia Electric and Power Company",[-77.56468626370888, 36.63672751216767]],
    [ "Dominion Energy Inc.",[-77.56534418254776, 36.598853234147725]],
    [ "1231184709",[-77.57765382083137, 36.60774929226158]],
    [ "Dominion Renewable Energy",[-77.63893084914939, 36.60216799071896]],
    [ "Virginia Electric and Power Company",[-77.63846955656996, 36.60205946408959]],
    [ "Pleasant Hill Substation",[-77.52903965000002, 36.55110735]],
    [ "1231184720",[-77.60048673250091, 36.5197245760703]],
    [ "1231184722",[-77.54141757133684, 36.459835960073974]],
    [ "1231184723",[-77.54070862260826, 36.46004439648279]],
    [ "1231184724",[-77.47906264402458, 36.50257588895836]],
    [ "Woodlyn Substation",[-75.34398824297098, 39.879172938996945]],
    [ "Clay Substation",[-75.82625125465607, 39.76304432543735]],
    [ "Cochranville Substation",[-75.93370603514182, 39.889932904831966]],
    [ "Cromby Substation",[-75.52972426743817, 40.15059539842367]],
    [ "1231277228",[-111.69127815370098, 40.09800763359329]],
    [ "1231356366",[-110.1148474129693, 48.17734485450103]],
    [ "Tennessee Valley Authority",[-89.17730928494903, 36.56802742303848]],
    [ "Virginia Electric and Power Company",[-77.32744586318057, 37.242126109503545]],
    [ "Virginia Electric and Power Company",[-77.24047901702315, 37.481522601202016]],
    [ "1231446995",[-77.23967741604424, 37.48181613561353]],
    [ "Virginia Electric and Power Company",[-77.09660688310039, 37.240294520109636]],
    [ "Dominion Renewable Energy",[-77.09641011598741, 37.240963283191505]],
    [ "Virginia Electric and Power Company",[-76.91683437236433, 37.15932078843036]],
    [ "Dominion Energy Inc.",[-76.9172738157569, 37.15895265448296]],
    [ "Dominion Energy Inc.",[-76.91698531645113, 37.15870263788181]],
    [ "AES Distributed Energy",[-77.15595422855732, 37.427319554381874]],
    [ "1231561882",[-111.66337199637489, 40.26382804459605]],
    [ "1231561892",[-111.68778607376804, 40.23776557013044]],
    [ "Disputana Substation",[-77.22520473104798, 37.11028769450494]],
    [ "1231658238",[-78.6267725, 38.4828003]],
    [ "Virginia Electric and Power Company",[-76.99549207276829, 36.652487231163214]],
    [ "City of Franklin",[-76.92235597532093, 36.68035634742699]],
    [ "1231700350",[-76.91033976528948, 36.673243286155724]],
    [ "1231700356",[-77.3601017090732, 36.53563601512481]],
    [ "Virginia Electric and Power Company",[-76.49433712556069, 36.27749709993565]],
    [ "Avangrid Renewables LLC",[-76.4934626582803, 36.277877174850836]],
    [ "Albemarle Beach Solar, LLC",[-76.62018294494054, 35.92638170834181]],
    [ "Virginia Electric and Power Company",[-76.25097911159017, 36.69991332434113]],
    [ "1231731762",[-111.69838059999998, 40.128504199999995]],
    [ "1231731768",[-111.75389331779031, 40.04088923463585]],
    [ "Dominion Renewable Energy",[-76.17196909583205, 36.69721881879576]],
    [ "Virginia Electric and Power Company",[-76.17130353717346, 36.697074629112116]],
    [ "Mohawk Substation",[-97.63784675526898, 38.404574694377885]],
    [ "1231767239",[-112.4795522505834, 33.420128061390685]],
    [ "Met-Ed",[-76.71120821933684, 40.12353542262764]],
    [ "Loomis Substation",[-84.5632841471566, 42.921592178358736]],
    [ "DeWitt Substation",[-84.56669567618458, 42.838097488004536]],
    [ "1231843780",[-113.03861944012235, 33.02508022512032]],
    [ "1231918340",[-77.21767795930938, 37.96347435650171]],
    [ "1231939196",[-76.57822788773159, 37.16457054511774]],
    [ "Virginia Electric and Power Company",[-76.46434713166741, 37.09338968305188]],
    [ "Virginia Electric and Power Company",[-76.57537941792492, 37.20680813061661]],
    [ "Seaford Substation",[-76.47678566985813, 37.17417121076192]],
    [ "Met-Ed Hosensack Substation",[-75.5052816945084, 40.454376792051825]],
    [ "PPL Hosensack Substation",[-75.5032005973864, 40.45573241375142]],
    [ "1232024782",[-91.90955187342264, 40.97612535888337]],
    [ "1232039236",[-76.88194326947544, 40.27639279444387]],
    [ "Rutherford Substation",[-76.78871909409396, 40.27314179919322]],
    [ "Linglestown Substation",[-76.7677714101504, 40.350431049219196]],
    [ "Devonshire Substation",[-76.78878139937139, 40.307295923684514]],
    [ "1232047537",[-112.72515503605091, 32.92685568123139]],
    [ "1232047538",[-112.83265237404049, 33.348748802963236]],
    [ "1232047562",[-112.67636626460883, 33.14478110770947]],
    [ "Franconia Substation",[-75.34313935644323, 40.29674288386708]],
    [ "Hatfield Packing Substation",[-75.32651435000001, 40.26762780000001]],
    [ "Standard Pressed Steel Substation",[-75.30384839999998, 40.298304099999996]],
    [ "Blooming Glen Substation",[-75.25474705, 40.374125899999996]],
    [ "Upper Hanover Substation",[-75.48480841910379, 40.39777182305305]],
    [ "Perkasie Boro Substation",[-75.3083817480449, 40.37978781640593]],
    [ "Ridge Road Substation",[-75.30761699599482, 40.38019638277914]],
    [ "Traumbauersville Substation",[-75.35963011443827, 40.40635289717367]],
    [ "Virginia Electric and Power Company",[-76.64841226164728, 37.259578619723015]],
    [ "1232306891",[-113.51020980000001, 32.9419289]],
    [ "1232309379",[-75.60300595, 40.569589750000006]],
    [ "1232317680",[-112.17411430000001, 33.779932099999996]],
    [ "Promenade Substation",[-83.02298313250047, 42.386598245092195]],
    [ "Arizona Public Service",[-112.306206087186, 33.56955158536555]],
    [ "Hatfield Substation",[-112.28068044999999, 33.70759345]],
    [ "1232764544",[-77.91915103346538, 37.970584298650586]],
    [ "1232800575",[-91.93854856627951, 40.81351395221908]],
    [ "1232804680",[-92.06934144976955, 40.83108845003557]],
    [ "AEP College Corner Substation",[-84.81715063558251, 39.64023027398608]],
    [ "1232976317",[-84.85499643138401, 39.350293474792785]],
    [ "1232976319",[-84.84905318497135, 39.35036564167661]],
    [ "1233206837",[-91.95387467857552, 40.67468103703125]],
    [ "1233271985",[-78.59271966660879, 37.5509372357505]],
    [ "Red Arrow Substation",[-83.66490728431663, 42.982551265822266]],
    [ "1233317132",[-83.72118900582143, 42.97772190402702]],
    [ "1233416549",[-92.18765979337537, 40.6933196393209]],
    [ "Borealis Infrastructure",[-84.22132551000307, 43.586165200380556]],
    [ "1233527787",[-111.72643591181449, 40.30229613053247]],
    [ "1233530807",[-111.63371532422113, 40.19821014062258]],
    [ "1233532906",[-111.73046290466473, 40.098715753504436]],
    [ "1233532909",[-111.8106679351708, 40.00501418297003]],
    [ "Consumers Energy",[-83.71065691522318, 43.009602101529254]],
    [ "Asylum Substation",[-83.70278232865085, 43.01204936187641]],
    [ "Harriet Substation",[-83.69007282462765, 43.03298689389732]],
    [ "Wood Street Substation",[-83.69712445, 43.0297565]],
    [ "1233712386",[-112.63754940000001, 35.05283435]],
    [ "1233712438",[-113.25205443449089, 34.579585521029536]],
    [ "1233712463",[-112.42980626416937, 34.71840436483884]],
    [ "1233712501",[-112.27171083695406, 34.452785251961124]],
    [ "1233712507",[-112.42725549217286, 34.56802265343996]],
    [ "1233712565",[-112.66893995000001, 34.365529]],
    [ "1233712626",[-112.83684109575258, 33.30523389211472]],
    [ "Lansing Board of Water and Light",[-84.55829019755582, 42.718044371972645]],
    [ "Lansing Board of Water and Light",[-84.55700642549444, 42.718031583763796]],
    [ "Lansing Board of Water and Light",[-84.55739546957868, 42.717970526137535]],
    [ "Consumers Energy",[-83.64651306898598, 43.02689611162886]],
    [ "Leith Street Substation",[-83.65502097487722, 43.04246655500115]],
    [ "Court Street Substation",[-83.64773231033362, 43.02165167469543]],
    [ "Kearsley Substation",[-83.6208292835319, 43.05150282552101]],
    [ "1233840218",[-92.3790201842346, 40.71974167857226]],
    [ "1233858034",[-114.56320430000001, 35.0191776]],
    [ "1233858056",[-114.07045047082565, 35.13312175938774]],
    [ "1233858087",[-114.1029089, 35.208116350000005]],
    [ "1233860044",[-92.42037676972126, 40.72618397732631]],
    [ "Calkins Substation",[-83.77269428523944, 43.0150490384734]],
    [ "1233872095",[-92.49415595519454, 40.69357085780069]],
    [ "Squire Hill Substation",[-83.76747875000002, 43.033192250000006]],
    [ "Consumers Energy",[-83.76813994999999, 43.03685629999999]],
    [ "1233879581",[-74.12929193691897, 40.10518019746051]],
    [ "1233886618",[-108.4795504406369, 36.687429399434045]],
    [ "1233905892",[-110.59275606461559, 41.690393072485044]],
    [ "1233912636",[-111.05804698206236, 41.06309599452916]],
    [ "1233912639",[-111.03153683139705, 41.063151502759766]],
    [ "1233912640",[-111.0362824406281, 41.06192435979004]],
    [ "1233912643",[-111.03838802179447, 41.06656763498705]],
    [ "Peacock Substation",[-84.39390653010918, 42.776480245649005]],
    [ "Perry Substation",[-84.21494931918194, 42.82848350865512]],
    [ "Edgewood Substation",[-84.42886343122699, 43.30621565204391]],
    [ "Christmans Substation",[-75.6341982, 40.9407713]],
    [ "Merrill Substation",[-84.33181035417763, 43.41110836745985]],
    [ "Silver Springs Station",[-78.06937128962832, 42.662487101853074]],
    [ "Iva Road Substation",[-84.26876912628228, 43.41459081397109]],
    [ "Hemlock Substation",[-84.23471357838146, 43.4108176236872]],
    [ "1234006674",[-77.39852338465396, 37.641910707732286]],
    [ "1234006729",[-77.93920682871148, 37.57956918624644]],
    [ "Powhatan Substation",[-77.9384717398899, 37.57902662395003]],
    [ "Dixie Substation",[-83.69485541138499, 43.0759426700232]],
    [ "Wager Substation",[-83.68718812454985, 43.057363242126044]],
    [ "Virginia Electric and Power Company",[-78.26383198276731, 38.10404164794769]],
    [ "Central Virginia Electric Cooperative",[-78.26333731754181, 38.10377470278827]],
    [ "Mt. Morris Substation",[-83.69822478178848, 43.121134004592385]],
    [ "Clio Substation",[-83.73688883476797, 43.1777748321107]],
    [ "Iron Street Substation",[-83.64660517438882, 42.97990384379084]],
    [ "Judd Road Substation",[-83.69201385870727, 42.967149320808474]],
    [ "1234169205",[-115.53836411226203, 32.76720873039022]],
    [ "1234169237",[-115.54940106421304, 32.79577895848922]],
    [ "1234169326",[-115.03112671924876, 32.706205160624556]],
    [ "1234169329",[-115.12631194166985, 32.70605488893401]],
    [ "1234169372",[-114.73505936409158, 33.58710738539259]],
    [ "1234169373",[-114.814623, 33.57334815]],
    [ "Waldrip Substation",[-114.6186113849777, 32.61769228909621]],
    [ "Alcalde Substation",[-106.06240851728755, 36.07375655798793]],
    [ "1234352849",[-76.99837523502659, 38.184133264647755]],
    [ "Oak Grove Substation",[-76.99899697923114, 38.18463588892876]],
    [ "Montrose Substation",[-76.83841244999999, 38.094188100000004]],
    [ "1234453778",[-114.94257605349773, 32.71117177291471]],
    [ "1234453780",[-114.98411347515012, 33.05358345691646]],
    [ "1234453817",[-114.70559590993837, 32.66858562491504]],
    [ "1234453862",[-114.58793835634273, 32.47995048641683]],
    [ "Sanguinetti Substation",[-114.5307255748598, 32.69240034371204]],
    [ "Yuma Palms Temp Substation",[-114.59643955000001, 32.69828605000001]],
    [ "Quechan Substation",[-114.62082188871891, 32.70257019488293]],
    [ "1234453906",[-114.65369327518926, 32.728325637229105]],
    [ "Mittry Substation",[-114.51300124999999, 32.737055600000005]],
    [ "1234483710",[-114.51288890942031, 32.73614467468639]],
    [ "Tripoli Substation",[-92.25301803898618, 42.80855864064735]],
    [ "1234496560",[-111.82963838999487, 40.751905586387934]],
    [ "Keokuk Geode Substation",[-91.42488933013631, 40.4171927746002]],
    [ "1234572802",[-76.56312918809085, 37.864066759796195]],
    [ "1234572837",[-76.70193935940821, 37.54342607743876]],
    [ "1234572840",[-76.81324601978416, 37.55283543106634]],
    [ "1234572842",[-76.80383548161895, 37.53920992179404]],
    [ "1234572843",[-76.86230347135482, 37.49002253678514]],
    [ "Hayes Substation",[-76.49491385171751, 37.27935240768681]],
    [ "Atlas Substation",[-83.53349045, 42.93564045000001]],
    [ "Grand Blanc Substation",[-83.63721963863269, 42.934194524717626]],
    [ "Newark Substation",[-83.59304895, 42.865392699999994]],
    [ "Linden Substation",[-83.78074059999999, 42.816666000000005]],
    [ "Gouldsboro Substation",[-75.43518839043104, 41.2516709660222]],
    [ "PPL",[-75.3787322, 41.27352955]],
    [ "1234732568",[-75.21850169085275, 41.36174497879884]],
    [ "Madisonville Substation",[-75.47932444152433, 41.354926736616676]],
    [ "Moscow Substation",[-75.52343106609482, 41.348176225241126]],
    [ "Consumers Energy",[-83.72488296812593, 42.79311582463344]],
    [ "Steel Drive Substation",[-83.72549531187207, 42.79321890543516]],
    [ "Holly Substation",[-83.63029453425924, 42.792074798328095]],
    [ "Fish Lake Substation",[-83.64838366094493, 42.804915320254636]],
    [ "Hogan Road Substation",[-83.80321101071434, 42.8312792782159]],
    [ "Varden Substation",[-75.39686008349284, 41.488414381630015]],
    [ "Hamlin Substation",[-75.38204341628254, 41.40260367732964]],
    [ "PPL",[-75.25589588159184, 41.512893692998176]],
    [ "1234784937",[-74.59229784775997, 41.18914046128611]],
    [ "1234784938",[-74.57997861683941, 41.19277737311474]],
    [ "Wallenpaupack Substation",[-75.13126111684404, 41.46781976232997]],
    [ "Kimbles Substation",[-75.14568331537312, 41.49094183204396]],
    [ "1234785833",[-75.06393329999999, 41.50184544999999]],
    [ "1234785834",[-75.06423295946155, 41.50156778196352]],
    [ "Indian Orchard Substation",[-75.20835147829744, 41.558853358676195]],
    [ "West Damascus Substation",[-75.17987007095445, 41.70083946374318]],
    [ "City of Eaton Rapids Electric Department",[-84.66015311313983, 42.50541309228958]],
    [ "Consumers Energy",[-84.652082639898, 42.50058424120828]],
    [ "City of Owensboro",[-87.13454029837534, 37.74965012807144]],
    [ "1234834733",[-81.40165327604407, 33.89956741094064]],
    [ "Allora Solar, LLC",[-81.40180192936099, 33.90007433863043]],
    [ "JSD Pinson PV-1, LLC",[-82.05293885679836, 34.73075622486816]],
    [ "1234861334",[-82.05294397638008, 34.73108970663231]],
    [ "1234879747",[-80.69231085118145, 37.09201817743688]],
    [ "1234879768",[-79.38401005, 36.642275999999995]],
    [ "1234879771",[-79.88626002726296, 36.98511858487589]],
    [ "Jermyn Substation",[-75.54677090366536, 41.51441016638571]],
    [ "Swartz Creek Substation",[-83.82853572489222, 42.95589199235504]],
    [ "Hill Road Substatoin",[-83.77053141154047, 42.93979352458784]],
    [ "Consumers Energy",[-83.79667996430294, 42.97736943562314]],
    [ "Montrose Substation",[-83.89519309668754, 43.17736665990648]],
    [ "Edela Substation",[-75.6526617350676, 41.521332120466646]],
    [ "1234944862",[-75.79761361641302, 41.57719864904677]],
    [ "McKinley Substation",[-83.86508101231108, 43.191026470347005]],
    [ "PPL",[-75.65572321930635, 41.46491856955693]],
    [ "Suburban Substation",[-75.64879621648443, 41.41726007257027]],
    [ "1234992863",[-75.66555490007318, 41.40438059995635]],
    [ "1234993140",[-110.33874893912203, 40.21445937544138]],
    [ "1235025722",[-76.29907065429873, 36.874389723214634]],
    [ "1235025732",[-76.54421812959137, 37.73738198618006]],
    [ "Robley Substation",[-76.57830945, 37.851249800000005]],
    [ "1235025735",[-76.59334407623552, 37.948827278340545]],
    [ "1235025744",[-76.65047677056933, 38.09638438919193]],
    [ "1235025746",[-76.50636064081985, 37.893698087695114]],
    [ "1235026779",[-75.71143295, 41.4804611]],
    [ "1235026800",[-75.7471710994659, 41.347705633448236]],
    [ "1235055854",[-77.84211542856698, 38.7123484890096]],
    [ "Avoca Substation",[-75.73363788222709, 41.34278191871545]],
    [ "1235083537",[-75.77613897715113, 41.28581819212042]],
    [ "1235083538",[-75.7754929, 41.28578695000001]],
    [ "1235143858",[-76.88663910000001, 38.1002928]],
    [ "1235143862",[-77.60682582075484, 38.20143862265599]],
    [ "1235151286",[-79.92216026717014, 37.952275254158195]],
    [ "Atherton Substation",[-83.67975062463279, 42.98858494336673]],
    [ "Jennings Gap Substation",[-79.18837941376346, 38.270035666751106]],
    [ "1235216286",[-79.03192084785691, 38.267573567703984]],
    [ "1235216288",[-78.623671906347, 38.39974376608261]],
    [ "1235227278",[-77.07384873857507, 38.76408522027626]],
    [ "City of Manassas - (VA)",[-77.51374718418015, 38.73135547408625]],
    [ "1235247731",[-77.51662285000002, 38.773277400000005]],
    [ "Belsay Substation",[-83.5964101425287, 43.01127615012873]],
    [ "Washington Metropolitan Area Transit Authority",[-77.31650472038612, 38.947259148134684]],
    [ "N94 TPSS9 Hunter Mill Road",[-77.30561440156059, 38.94874647841606]],
    [ "Washington Metropolitan Area Transit Authority",[-77.2803244, 38.94155260000001]],
    [ "Gilkey Creek Substation",[-83.59918682572338, 42.99036125777522]],
    [ "Corry East Substation",[-79.58238935380503, 41.929681854989845]],
    [ "Cheyenne Substation",[-84.01070261948198, 43.44813442135964]],
    [ "Consumers Energy",[-83.66908995, 43.085433300000005]],
    [ "1235362550",[-92.0891366718552, 41.00902041852918]],
    [ "1235498681",[-111.66734539579798, 47.71964512516833]],
    [ "New Lothrop Substation",[-83.96785962460477, 43.11581784380907]],
    [ "1235635553",[-92.08372654999998, 40.9141043]],
    [ "1235653947",[-84.61308501680944, 37.08075488218258]],
    [ "1235730069",[-111.89977019080355, 40.89048015221213]],
    [ "1235756161",[-108.7638039, 35.831372]],
    [ "1235756167",[-108.98340961431099, 35.61593277405782]],
    [ "1235756193",[-111.03153965000001, 35.11718260000001]],
    [ "1235756194",[-109.61945906668828, 34.48115289939124]],
    [ "1235756197",[-109.38371065, 34.49696805]],
    [ "1235756208",[-112.16038354999999, 34.71005505000001]],
    [ "1235756215",[-112.06461761275212, 34.7603394791163]],
    [ "1235756220",[-112.08380363374707, 34.778454660421005]],
    [ "1235756279",[-111.63164495890668, 35.18822195977094]],
    [ "1235756351",[-110.86452773798507, 35.083388075296874]],
    [ "1235756367",[-110.32415495399935, 34.64048230495008]],
    [ "1235756435",[-109.27574374507712, 34.578622317099295]],
    [ "1235756475",[-109.41126567512502, 34.203337495856495]],
    [ "1235756481",[-109.69453234134696, 34.25797623712435]],
    [ "1235756509",[-109.90412995, 34.118368200000006]],
    [ "1235756554",[-110.01416625, 34.252694399999996]],
    [ "1235756586",[-110.3257779, 34.49838905]],
    [ "1235756587",[-110.33394316136821, 34.504259959311995]],
    [ "1235756594",[-110.13388913644984, 34.79798572556047]],
    [ "Stevens Substation",[-108.83759815099113, 33.70146993345336]],
    [ "1235756654",[-108.89541466675176, 33.756390049886335]],
    [ "1236086572",[-98.36914055459773, 34.52450387615733]],
    [ "Hospital Substation",[-83.44992768065806, 45.079524612586056]],
    [ "1236132540",[-83.45910700000002, 43.211161100000005]],
    [ "Geneseeville Substation",[-83.61655838424063, 43.11710802537133]],
    [ "East Kentucky Power Cooperative, Inc.",[-84.66390065747942, 37.43622452252868]],
    [ "Pegasus Wind Farm Substation",[-83.47424422952568, 43.531487879847106]],
    [ "Consumers Energy",[-83.67194697520364, 43.060054453823994]],
    [ "1236725878",[-107.56180256481767, 35.970590396834524]],
    [ "1236749152",[-120.11976419334336, 36.145621601293364]],
    [ "Nashville Substation",[-85.09317471806307, 42.611857331933344]],
    [ "Chester Substation",[-84.91437753088351, 42.59753292191563]],
    [ "Ulmer Substation",[-83.78623225, 43.244476899999995]],
    [ "Frankenmuth Substation",[-83.73968174999997, 43.338566050000004]],
    [ "Bridgeport Substation",[-83.88408449426323, 43.36020904757893]],
    [ "1237047829",[-97.35981183582707, 32.20227010902985]],
    [ "Consumers Energy",[-83.93144001507613, 43.412918382004605]],
    [ "South Washington Substation",[-83.94957998562413, 43.41800760915907]],
    [ "Consumers Energy",[-83.95606093125504, 43.412177343977554]],
    [ "Consumers Energy",[-83.9571886, 43.419902]],
    [ "Bristol Substation",[-83.9520443670809, 43.42328396543091]],
    [ "1237114555",[-83.91686017674871, 43.41228195486165]],
    [ "Morley Substation",[-83.87331730000001, 43.4139599]],
    [ "Consumers Energy",[-83.90846436728194, 43.39200748403816]],
    [ "Janes Substation",[-83.91192202948187, 43.42533818830682]],
    [ "Findley Substation",[-83.9060387302302, 43.4551035070866]],
    [ "Eddy Substation",[-83.91011713429093, 43.44385866753778]],
    [ "Carrollton Substation",[-83.92905635000001, 43.4566844]],
    [ "State Street Substation",[-83.99193202964008, 43.437558719964706]],
    [ "Consumers Energy",[-83.97751755851078, 43.39747122476871]],
    [ "1237368049",[-75.88997372435728, 41.12847918967174]],
    [ "Wright Substation",[-75.88523066854601, 41.138653317138036]],
    [ "Burrows Substation",[-83.99104567502054, 43.40814904081461]],
    [ "Seidel Substation",[-84.01562435752959, 43.422260670777796]],
    [ "Shields Substation",[-84.05230492482126, 43.39323714233809]],
    [ "Teft Road Substation",[-84.13196159628336, 43.358763017556]],
    [ "1237398504",[-112.43105352720008, 41.6461199839435]],
    [ "Freeland Substation",[-84.11082610000001, 43.526982]],
    [ "Springport Substation",[-84.69635294999999, 42.37772029999999]],
    [ "Halls Lake Substation",[-84.76161932749956, 42.30599166725954]],
    [ "Rockford Substation",[-93.74745254856565, 45.11120629961929]],
    [ "Winsor Substation",[-83.29621216307925, 43.763360103970655]],
    [ "Winsor Substation",[-83.29621873998097, 43.763785301586786]],
    [ "DTE Energy",[-83.23802585003553, 43.8264056238645]],
    [ "Lockwood Substation",[-84.12487707497485, 43.18152190571187]],
    [ "Chesaning Substation",[-84.12274482519058, 43.18133934564347]],
    [ "McKeighan Substation",[-84.12641742008303, 43.20202652459847]],
    [ "St Charles Substation",[-84.13836354989944, 43.29686006666699]],
    [ "Flushing Park Substation",[-83.86727817439181, 43.07151794303465]],
    [ "Flushing Substation",[-83.8593285, 43.06655195]],
    [ "Boman Substation",[-83.8332636044559, 43.06763228808572]],
    [ "Webster Substation",[-83.77406576663924, 43.097212066697445]],
    [ "Consumers Energy",[-84.14725228110612, 42.98477406688434]],
    [ "1237566553",[-116.3553004460204, 33.887848637327984]],
    [ "Consumers Energy",[-84.19321365, 42.99497024999999]],
    [ "Oliver Substation",[-84.1899653, 43.00300775]],
    [ "Consumers Energy",[-84.20912097511285, 42.995749338786645]],
    [ "Durand Substation",[-83.99799190000002, 42.91037015]],
    [ "Newburg Substation",[-84.06119475000001, 42.91364215000001]],
    [ "Lehring Substation",[-83.95495013786358, 42.83150972588489]],
    [ "New Haven Substation",[-84.15482520997581, 43.0857598741348]],
    [ "Chapin Substation",[-84.30557239999999, 43.17678654999999]],
    [ "Ovid Substation",[-84.3768942, 42.999990200000006]],
    [ "1237810792",[-83.81609812263234, 42.63008629044088]],
    [ "White Haven Substation",[-75.77893892546389, 41.04464799608156]],
    [ "1237832468",[-75.9812239876316, 40.9044927218443]],
    [ "1237832474",[-75.97269934999998, 40.902803549999994]],
    [ "NEPCO Substation",[-75.99350927987166, 40.87309009012898]],
    [ "Macon Substation",[-98.85708582821502, 40.268693467823766]],
    [ "1237841796",[-76.02232150085352, 40.96729053299991]],
    [ "Valmont Substation",[-76.01028330536118, 40.97078774978282]],
    [ "Harleigh Substation",[-75.97629682793706, 40.97967554616366]],
    [ "1237854411",[-76.04705602683342, 40.94871194537618]],
    [ "1237860466",[-83.86371880372617, 42.52899029804811]],
    [ "Susquehanna T21",[-76.14705212453674, 41.09308847888624]],
    [ "Susquehanna T21",[-76.14747672518831, 41.09248154037992]],
    [ "PPL",[-76.14669839100091, 41.0909579816058]],
    [ "PPL",[-76.14702841817916, 41.09154265294035]],
    [ "Whitmore Lake Substation",[-83.75911074999999, 42.418044450000004]],
    [ "1237901167",[-98.78750148456578, 37.81311582279644]],
    [ "1237904794",[-98.48382520250118, 37.68214582481295]],
    [ "1237904797",[-98.46689875667182, 37.68478034776461]],
    [ "Wheatland Electric Cooperative",[-98.08057144186691, 37.45853223883474]],
    [ "1237911091",[-83.79740095, 42.4475978]],
    [ "1237929402",[-99.4050599647004, 37.98568508179912]],
    [ "Wilder Substation",[-84.9199724361998, 42.23192389151391]],
    [ "East Danville Substation",[-76.56745947096601, 40.96166048978701]],
    [ "Danville Substation",[-76.61003114005456, 40.957502089891186]],
    [ "Foster Wheeler Substation",[-76.45263636805065, 40.81103029609803]],
    [ "1237960041",[-98.82054948128392, 38.32957975525627]],
    [ "Wheatland Electric Cooperative",[-98.7637903230265, 38.35483501452899]],
    [ "1237960046",[-98.81195827497673, 38.405598004782725]],
    [ "Michigan One Substation",[-82.91335745746792, 43.72288043128025]],
    [ "DTE Energy",[-82.78328746014417, 43.850912363902594]],
    [ "DTE Energy",[-82.78327232421796, 43.850576186121614]],
    [ "Mowery Substation",[-76.40377038076525, 40.756168071324886]],
    [ "1238132829",[-82.49208637583095, 35.45654204457833]],
    [ "Conoco Substation",[-104.948089519548, 39.80120721282631]],
    [ "1238154178",[-83.98576459582189, 42.625701375441636]],
    [ "1238158168",[-84.07509959999999, 42.65779514999999]],
    [ "1238169291",[-84.0349042, 42.560689100000005]],
    [ "1238200958",[-114.44051970432028, 43.33934517724406]],
    [ "1238200959",[-114.32793609245267, 43.542767629981036]],
    [ "1238200962",[-114.30972807240592, 43.523619622336255]],
    [ "Fountain Springs Substation",[-76.31475051575693, 40.76725117174973]],
    [ "Prince Substation",[-76.30884806563955, 40.04689094908442]],
    [ "1238231697",[-76.26248071925052, 40.04851663422123]],
    [ "Stockbridge Substation",[-84.17615715, 42.4493106]],
    [ "Gregory Substation",[-84.08849837537947, 42.446417191054515]],
    [ "Burch Road Substation",[-84.21197565, 42.24871215]],
    [ "Sharon Hollow Substatoin",[-84.0886749899793, 42.13052057241391]],
    [ "1238492543",[-76.22979347322324, 40.8211005467345]],
    [ "1238492554",[-76.17270100649503, 40.823388531760244]],
    [ "Tecumseh Substation",[-83.94315395, 41.99908395]],
    [ "Lenawee Stamping Substation",[-83.9196419, 41.99869789999999]],
    [ "Michigan Center Substation",[-84.32506842524798, 42.23186335552737]],
    [ "Consumers Energy",[-84.34965325, 42.232600149999996]],
    [ "Consumers Energy",[-84.3532179, 42.08286265]],
    [ "West Clark Lake Substation",[-84.34712319125885, 42.12123732538169]],
    [ "1238713181",[-92.41663802224474, 40.750344458601695]],
    [ "1238713665",[-92.43904144999999, 40.7989096]],
    [ "Lindell Substation",[-115.2153786, 36.1440258]],
    [ "1238729486",[-92.26398087649035, 40.84324388002559]],
    [ "1238742819",[-92.2451047825921, 40.734016793056995]],
    [ "1238744290",[-76.12819085, 40.81771815]],
    [ "Allison Substation",[-105.08964573674461, 39.6351878022219]],
    [ "500 kV switchgear",[-76.8289838538282, 40.835217914393716]],
    [ "1238765783",[-75.8746614673164, 40.85469024536761]],
    [ "1238843270",[-75.98587596339904, 40.73243042653704]],
    [ "Panther Creek Hill Road Substation",[-75.9896724, 40.54596885000001]],
    [ "Carroll Substation",[-84.43044555, 42.257062600000005]],
    [ "Morrell Substation",[-84.43642664999999, 42.240584049999995]],
    [ "Consumers Energy",[-84.38574536237125, 42.22835457380898]],
    [ "Aluminum Substation",[-76.18916187595042, 40.6302198567602]],
    [ "North Adams Substation",[-84.51576214028265, 41.97116681732839]],
    [ "1238980165",[-84.61730172458206, 41.908331443026746]],
    [ "Oak Hill Substation",[-76.2550226040747, 40.70574100492432]],
    [ "Primrose Substation",[-76.24866377747088, 40.6808657392626]],
    [ "1239001574",[-76.45030732998029, 40.61866805340005]],
    [ "Williamstown Substation",[-76.59176122457659, 40.57907864053778]],
    [ "Commonwealth Landfill Substation",[-76.42160062242692, 40.64745096666667]],
    [ "Ash Road Substation",[-84.75407454488331, 42.028803176780684]],
    [ "Balcom Substation",[-84.75050944999998, 41.8974894]],
    [ "Camden Substation",[-84.76780500000001, 41.7815299]],
    [ "Frontier Substation",[-84.59176231388072, 41.78207504632649]],
    [ "Waldron Substation",[-84.41596317537751, 41.728162305913784]],
    [ "Pittsford Substation",[-84.47402300000002, 41.8545332]],
    [ "Haley Road Substation",[-84.23598147958361, 41.81850702559724]],
    [ "Manitou Beach Substation",[-84.31065955, 41.97196545]],
    [ "Rollin Substation",[-84.30570636491656, 41.92783386815019]],
    [ "Lykens Substation",[-76.69528857536353, 40.571675594269614]],
    [ "Elizabethville Substation",[-76.8147188781114, 40.5753922542278]],
    [ "Halifax Substation",[-76.92542566714219, 40.461197250746785]],
    [ "Meiserville Substation",[-76.94489475797971, 40.64591425613724]],
    [ "230 kV Switchgear",[-76.82847352941306, 40.83640596660113]],
    [ "Hummels Wharf Substation",[-76.82873480151251, 40.83816716648509]],
    [ "Amasteel Substation",[-84.02777514999998, 41.88485125]],
    [ "Consumers Energy",[-84.04123804999999, 41.89048905]],
    [ "Consumers Energy",[-84.04067826723859, 41.89049562497362]],
    [ "Sand Creek Substation",[-84.07621880195354, 41.88929055458319]],
    [ "Maumee Substation",[-84.03969084194878, 41.900425161254]],
    [ "Woodstock Substation",[-84.2868953, 42.0108289]],
    [ "Stauffer Substation",[-83.95445855, 41.94554585]],
    [ "Dalmatia Substation",[-76.88521862162419, 40.65243878895854]],
    [ "Hunter Substation",[-76.73198405, 40.77204609999999]],
    [ "Gowen City Substation",[-76.49639241778674, 40.7430185128285]],
    [ "Semrec Metering Substation",[-83.9650649758921, 41.94673190564188]],
    [ "Tecumseh Substation",[-83.97574106758891, 41.98477189517506]],
    [ "Palmyra Substation",[-83.96302198690482, 41.885639975583295]],
    [ "Fairfield Substation",[-84.08099227414964, 41.82339784303704]],
    [ "Palmyra Substation",[-83.94146777532167, 41.8565626068237]],
    [ "Lambertville Substation",[-83.63229625811712, 41.761821552981495]],
    [ "Sterns Road Substation",[-83.5280762751982, 41.750263858254954]],
    [ "Western Area Power Administration",[-102.99208033028202, 41.16265925567967]],
    [ "1239501392",[-102.73324645383647, 34.211894222124336]],
    [ "Temperance Substation",[-83.5695072428654, 41.78849819976447]],
    [ "Goose Lake Substation",[-120.58595376557373, 41.487950982667506]],
    [ "1239531512",[-76.61164335, 40.96002910000001]],
    [ "Geisinger Medical Center Substation",[-76.60320599426099, 40.97337506701171]],
    [ "Point Substation",[-76.81645295873705, 40.90114642213723]],
    [ "Muck Valley Substation",[-121.17883527481601, 41.09134150952421]],
    [ "Big Valley Lumber Company Substation",[-121.13762059999998, 41.132813850000005]],
    [ "1239557256",[-121.11431915, 41.13233680000001]],
    [ "LaSalle Substation",[-83.45346475523233, 41.86868319227149]],
    [ "Dunbar Substation",[-83.40891896648992, 41.89803532283143]],
    [ "Jeffs Road Substation",[-83.66865715, 41.748867999999995]],
    [ "City of Coldwater Board of Public Utilities",[-85.02392212485374, 41.92053694169178]],
    [ "Burr Oak Substation",[-85.31185294205216, 41.845477125196155]],
    [ "1239680158",[-112.14101509999998, 36.0557693]],
    [ "1239680160",[-112.13675326014662, 35.97088895141554]],
    [ "1239680169",[-112.1310045, 35.84486744999999]],
    [ "1239680172",[-112.14771782808987, 35.59620579074845]],
    [ "1239680175",[-112.16469219999999, 35.526588800000006]],
    [ "1239680181",[-112.12018211054324, 35.262707725329925]],
    [ "1239680185",[-111.95196363998419, 35.26706447379007]],
    [ "1239680196",[-112.06166115, 35.27357945]],
    [ "1239680233",[-110.13127214999999, 34.5123963]],
    [ "Viking Substation",[-76.8141924025032, 40.91726761686551]],
    [ "Allenwood Substation",[-76.97694239999998, 41.123187400000006]],
    [ "Kelly Substation",[-76.8860848826797, 40.99413062842153]],
    [ "Orrtanna Substation",[-77.35080571785156, 39.844166566496284]],
    [ "Orrtanna Substation",[-77.3510073373492, 39.84449067209589]],
    [ "American Home Products Substation",[-76.85673142602278, 41.01026345401337]],
    [ "1239734500",[-76.86425064253699, 41.060332977508715]],
    [ "Madeline Substation",[-120.50347283306182, 40.96087208342637]],
    [ "1239737162",[-120.50531876550681, 41.23044477434687]],
    [ "Likely Substation",[-120.53959239363142, 41.369902084498406]],
    [ "1239737165",[-120.6991843640157, 41.42187668137349]],
    [ "Watson Substation",[-76.8580052934233, 41.09796157082412]],
    [ "Kentucky Utilities Company",[-84.75450923489156, 37.64232811106128]],
    [ "Plastic-Vac Substation",[-76.90906032118895, 41.17662828885836]],
    [ "Wire Rope Substation",[-77.01195048105235, 41.235059974124695]],
    [ "Linden Substation",[-77.09017975, 41.231522000000005]],
    [ "Tyrone Substation",[-77.13076650914977, 39.94491864636436]],
    [ "1240020399",[-91.33218263766081, 41.18604364426463]],
    [ "Atlantic Refining Substation",[-76.95056424920641, 41.23598526814298]],
    [ "Mill Creek Substation",[-76.82945847470756, 41.309998661173545]],
    [ "Fairfield Substation",[-76.85214113709118, 41.241256920829954]],
    [ "Faxon Substation",[-76.98029983848075, 41.252660234326314]],
    [ "Elsie Substation",[-84.39129768555966, 43.090742583388945]],
    [ "Batteese Substation",[-84.32384160418174, 42.3870679258255]],
    [ "1240071738",[-92.22138943743906, 36.76951007445276]],
    [ "Woolrich Substation",[-77.3627560618762, 41.17241386326816]],
    [ "Pennfield Substation",[-85.10304020000001, 42.373092850000006]],
    [ "CDF Jimmy Creek Substation",[-104.66962310869626, 38.70665647602189]],
    [ "Level Park Substation",[-85.26133372385651, 42.3560566022324]],
    [ "Bedford Substation",[-85.24057218594164, 42.3989960312187]],
    [ "Jersey Shore Steel Substation",[-77.30374499660223, 41.180930633018804]],
    [ "Consumers Energy",[-85.26499235, 42.34437405]],
    [ "Consumers Energy",[-85.26564351548583, 42.34205403301245]],
    [ "Consumers Energy",[-85.2856268095568, 42.33047723894086]],
    [ "Goguac Substation",[-85.1998797, 42.2978289]],
    [ "1240334032",[-83.40357816062757, 43.11677027359368]],
    [ "69 kV switchgear",[-77.43384623136859, 41.1208987346458]],
    [ "Chelsea Electric Department",[-84.02395424523561, 42.31420138841233]],
    [ "Renovo Substation",[-77.75923054286577, 41.32882399130831]],
    [ "Grass Lake Substation",[-84.21405704427184, 42.247295473227226]],
    [ "Cranbury Substation",[-74.50549919748286, 40.34359269411689]],
    [ "Olivet Substation",[-84.92475864476556, 42.452524633299674]],
    [ "Consumers Energy",[-84.20504337472471, 43.609590925318464]],
    [ "1240481948",[-74.298733326277, 41.76461557388543]],
    [ "1240481955",[-74.2288937, 41.784555100000006]],
    [ "1240499803",[-74.41080471970054, 41.725884056618646]],
    [ "1240499806",[-74.4959651, 41.73999495]],
    [ "Loganton Substation",[-77.28668036224786, 41.0366537401462]],
    [ "Sturgeon Substation",[-84.26507187972405, 43.6402920046251]],
    [ "Letts Road Substation",[-84.21811006550621, 43.66973057516432]],
    [ "Ingersoll Substation",[-84.2712497, 43.496146499999995]],
    [ "Thornton Substation",[-84.38919179999999, 43.66940530000001]],
    [ "Mifflinburg Substation",[-77.04511210000001, 40.91101960000001]],
    [ "Limestone Substation",[-77.04688738689947, 40.8911227542294]],
    [ "1240667606",[-77.17462013653982, 40.752597779441565]],
    [ "Beavertown Substation",[-77.18381167275548, 40.74982094326796]],
    [ "Penns Substation",[-76.9066542, 40.805163699999994]],
    [ "1240694824",[-122.82393541944975, 46.97553033742265]],
    [ "1240697974",[-121.89216744999999, 38.0320138]],
    [ "1240704364",[-121.87755274999999, 38.028058200000004]],
    [ "Pacific Gas and Electric Company",[-121.86940210714403, 38.030375407147105]],
    [ "Curtis Substation",[-84.4893050168838, 43.79977247524146]],
    [ "Robinson Substation",[-84.49067448884246, 43.738328524850246]],
    [ "Bradford Substation",[-84.47067515, 43.553484450000006]],
    [ "Richfield Substation",[-77.10206792050128, 40.688230451130764]],
    [ "Jasper Substation",[-84.56891636054934, 43.48807632484522]],
    [ "Auburn Substation",[-84.06690461695445, 43.60672568364519]],
    [ "Bay City Electric Light & Power",[-83.91320786535628, 43.57342775027257]],
    [ "Salzburg Substation",[-83.91100368606683, 43.5764743686831]],
    [ "Prestolite Substation",[-83.91233158163011, 43.572913209684216]],
    [ "Saginaw St. Substation",[-83.89036635764636, 43.59391862264448]],
    [ "Consumers Energy",[-83.89119312702874, 43.59241459258376]],
    [ "Consumers Energy",[-83.88019034262842, 43.60705498289622]],
    [ "Consumers Energy",[-83.89979298689963, 43.59565918102093]],
    [ "Derry Substation",[-76.67574675000002, 41.04355575]],
    [ "Bay City Electric Light & Power",[-83.86763995607707, 43.61106124748782]],
    [ "Consumers Energy",[-83.86837675742137, 43.61051012468866]],
    [ "Bay City Electric Light & Power",[-83.86772364987932, 43.610551452469906]],
    [ "Essexville Substation",[-83.85181802508815, 43.60914124259929]],
    [ "Bay City Electric Light & Power",[-83.86726254999999, 43.5869989]],
    [ "Benvenue Substation",[-77.02433811471487, 40.41229212024589]],
    [ "PPL",[-77.16292891757976, 40.3427952486872]],
    [ "Shermans Dale Substation",[-77.16399725, 40.320661550000004]],
    [ "1240980193",[-122.86204101001503, 46.083518220508005]],
    [ "Water St Substation",[-83.89894080576923, 43.57624579625929]],
    [ "Harrison St. Substation",[-83.90122815000001, 43.5622077]],
    [ "Lewis Street Substation",[-83.86970330918315, 43.62095182543508]],
    [ "Patterson Substation",[-83.87565490644057, 43.622709353904376]],
    [ "Sydney Street Substation",[-83.88939314999999, 43.61220995]],
    [ "Consumers Energy",[-83.8975945119911, 43.60029022513372]],
    [ "Huron Substation",[-83.93720249006307, 43.61779522492359]],
    [ "Kawkawlin Substation",[-83.94209377662027, 43.653517207210676]],
    [ "1241132604",[-83.98585952898897, 43.628973680701634]],
    [ "Town Line Substation",[-84.0095922116788, 43.652861362632905]],
    [ "Whitefeather Substation",[-83.94892984999998, 43.8996954]],
    [ "1241192123",[-119.48097891303485, 39.51444496927634]],
    [ "Newville Substation",[-77.3905114581559, 40.166890773509024]],
    [ "1241209216",[-77.2195413071343, 40.201277983926325]],
    [ "1241209218",[-77.22338863574781, 40.200518094576054]],
    [ "Mount Rock Substation",[-77.3081623789024, 40.162664854954]],
    [ "1241238559",[-93.6553968185685, 41.2484617185685]],
    [ "Consumers Energy",[-83.87115332569584, 43.6258499448798]],
    [ "Bay City Electric Light & Power",[-83.89700327006747, 43.66178271168371]],
    [ "1241356820",[-95.40066109093858, 32.16378202690461]],
    [ "1241378885",[-94.87345322514703, 41.38891940647237]],
    [ "1241385973",[-77.1689067659035, 40.20908121384469]],
    [ "Brogan Substation",[-85.27996790446387, 42.57390397842497]],
    [ "Fine Lake Substation",[-85.27839861049289, 42.47812021911569]],
    [ "1241456991",[-76.95890293204718, 40.22508695391632]],
    [ "1241456992",[-76.95291505, 40.2275469]],
    [ "Augusta Substation",[-85.34986698437439, 42.33561442891887]],
    [ "Ridgeview Substation",[-85.4615844167707, 42.291096478199115]],
    [ "1241478701",[-91.20777628845583, 44.92906392462457]],
    [ "Hamden Substation",[-76.9976378434348, 40.24149987434947]],
    [ "1241482273",[-91.2591337750557, 44.93043470550691]],
    [ "1241494294",[-76.72742536675898, 40.25312724507953]],
    [ "Air Brake Substation",[-85.43790095, 42.286803449999994]],
    [ "Worthington Substation",[-84.36586452237594, 42.19321277784789]],
    [ "1241541292",[-96.56016294057392, 40.88610731599848]],
    [ "Comstock Substation",[-85.51130414975631, 42.28891619984098]],
    [ "1241649980",[-88.48279315831425, 44.19702069727429]],
    [ "Eastwood Substation",[-85.543069, 42.30888825]],
    [ "Consumers Energy",[-85.57786056300088, 42.29110644104616]],
    [ "1241723734",[-97.15796714302263, 33.68171821833834]],
    [ "Ravine Substation",[-85.60520133454953, 42.30734356818247]],
    [ "Stadium Substation",[-85.59950610911449, 42.28823134132947]],
    [ "1241780782",[-95.74309896326538, 38.16769687530198]],
    [ "Palmer Substation",[-85.55073292858114, 42.270183781000846]],
    [ "Celery Substation",[-85.49818997482348, 42.260672244222974]],
    [ "East Hanover Substation",[-76.97728553852747, 39.808013516772796]],
    [ "Consumers Energy",[-85.54725362959584, 42.24896090490878]],
    [ "Travis Substation",[-85.55582510127292, 42.34520208307514]],
    [ "Richland Substation",[-85.44012987455366, 42.37599659189071]],
    [ "Cooper Substation",[-85.590643167004, 42.376825866266195]],
    [ "Oshtemo Substation",[-85.70641701806898, 42.29514943496899]],
    [ "Viscksburg Pumping Substation",[-85.4891357632992, 42.17604923202085]],
    [ "Alamo Substation",[-85.7461735, 42.35168254999999]],
    [ "1242090375",[-85.76323354071657, 42.14122821964521]],
    [ "Frosty Station",[-85.76379728235499, 42.141235316302826]],
    [ "Mattawan Substation",[-85.77164836774992, 42.21480566530289]],
    [ "Beck Road Substation",[-83.73930599121056, 41.76075164276613]],
    [ "Dana Substation",[-83.74443786469546, 41.73479026867209]],
    [ "1242106305",[-76.48156508951155, 40.03381515949328]],
    [ "1242122369",[-76.48180865675029, 40.02533746418512]],
    [ "Mendon Substation",[-85.45531330415389, 42.00935506543033]],
    [ "Wakeshma Substation",[-85.35284652503398, 42.10080434341562]],
    [ "Centreville Substation",[-85.52472686688292, 41.926814633523236]],
    [ "PPL",[-76.33262433310104, 40.13544725410647]],
    [ "Lititz Substation",[-76.32826202380062, 40.15857855947747]],
    [ "Warwick Substation",[-76.27259570000001, 40.16848290000001]],
    [ "1242232189",[-85.42578107122992, 41.77387457737545]],
    [ "Central Substation",[-85.42507691937121, 41.799096649489215]],
    [ "1242266414",[-85.64724343838897, 41.79226102503782]],
    [ "Florence Road Substation",[-85.65280710982614, 41.83802257970249]],
    [ "1242272822",[-85.65352522525326, 41.836416798078886]],
    [ "White Pigeon Substation",[-85.66122540629989, 41.80886994997026]],
    [ "Lincoln Substation",[-76.20729584563239, 40.20052661502529]],
    [ "North Manheim Substation",[-76.38003269999999, 40.17538245]],
    [ "Midwestern Energy and Communications",[-85.76069634117884, 41.780602525155565]],
    [ "1242300526",[-95.14660872388538, 43.32573330475443]],
    [ "1242330009",[-85.79990194999999, 41.8063802]],
    [ "Stone Lake Substation",[-86.0117014862576, 41.90302215869981]],
    [ "1242367266",[-86.07807106431328, 41.88182143147664]],
    [ "1242373780",[-92.23924253901822, 43.09822341703404]],
    [ "Lavino Substation",[-76.19397391966712, 40.35291604306202]],
    [ "Robesonia Substation",[-76.14081793994913, 40.351060606654315]],
    [ "Shillington Substation",[-75.97900076666666, 40.30769605485483]],
    [ "1242484837",[-122.3629840941506, 37.81375016098151]],
    [ "1242516738",[-86.10259571429836, 41.98737981803473]],
    [ "1242534297",[-86.09891001158299, 41.99464148040563]],
    [ "1242541515",[-86.09962649759072, 41.99046293425852]],
    [ "Poplar St. Substation",[-86.11898332492531, 41.988537444074055]],
    [ "Mason Substation",[-85.91554185246295, 41.80251882705106]],
    [ "Barret Substation",[-86.15632655214004, 41.956380384603236]],
    [ "1242614654",[-86.10639489017778, 42.05189674839343]],
    [ "1242661854",[-85.02261266215831, 41.93047529127554]],
    [ "1242661855",[-85.0210191749104, 41.92667977130293]],
    [ "1242661856",[-84.95912579032962, 41.98280089511104]],
    [ "Wyomissing Substation",[-75.96440536886323, 40.33608319503686]],
    [ "State Hill Substation",[-76.00686927636005, 40.340554894609646]],
    [ "1242697583",[-75.96805946068696, 40.33783940779756]],
    [ "Reamstown Substation",[-76.12858360106758, 40.22347987461323]],
    [ "Cocalico Substation",[-76.17136306869907, 40.18783335504503]],
    [ "Consumers Energy",[-83.52810590605188, 41.75071620575967]],
    [ "Treasure Island Switchyard",[-122.36792722409923, 37.82753959870168]],
    [ "1242888658",[-77.63516823859244, 37.446828198124045]],
    [ "Niles Board of Public Works",[-86.2569831917463, 41.81433037495363]],
    [ "Niles Board of Public Works",[-86.24654823154701, 41.83896300360605]],
    [ "1242961466",[-86.17558245849955, 41.80962871339711]],
    [ "Brecknock Substation",[-75.98298482151755, 40.16844333414786]],
    [ "1242996923",[-86.36033590000001, 41.82097615]],
    [ "1243011890",[-76.22931605199811, 39.88243445665931]],
    [ "1243011904",[-76.22524435, 39.74461025]],
    [ "Trenton Channel Gen Substation",[-83.18269482377656, 42.122733165289425]],
    [ "Boxer Station",[-86.33245316712038, 41.944088963229824]],
    [ "1243071150",[-86.291529, 41.98739855000001]],
    [ "Mt. Nebo Substation",[-76.31206761749979, 39.88416046445784]],
    [ "Strasburg Substation",[-76.20742321555703, 39.997557611791805]],
    [ "Knowles Substation",[-84.47885468314675, 41.93557106186506]],
    [ "1243108156",[-84.47808416671717, 41.935442975013665]],
    [ "1243193729",[-86.33077109999999, 41.94373330000001]],
    [ "Oronko Station",[-86.37805408331583, 41.95021330587009]],
    [ "Stevensville Substation",[-86.52021935000002, 42.01547229999999]],
    [ "Lakeside Substation",[-86.66415762016665, 41.84989108956138]],
    [ "Pletcher Substation",[-86.48900385010423, 41.88322961308208]],
    [ "1243284083",[-86.51146574826535, 42.05000658344934]],
    [ "1243404736",[-67.02722142326972, 18.074616641367463]],
    [ "1243404740",[-67.02847415000001, 18.07633015]],
    [ "1243404749",[-67.05285652929777, 18.042161794771772]],
    [ "Puerto Rico Electric Power Authority",[-67.05065759746736, 18.007201054582787]],
    [ "Puerto Rico Electric Power Authority",[-67.18512580834606, 17.981012377164394]],
    [ "Puerto Rico Electric Power Authority",[-67.15363377528644, 18.077056707907772]],
    [ "Puerto Rico Electric Power Authority",[-67.15615932150419, 18.077239244366293]],
    [ "1243404773",[-67.15774506954052, 18.079259893067054]],
    [ "1243404775",[-67.15479929232357, 18.09112772702722]],
    [ "Puerto Rico Electric Power Authority",[-67.14973666889374, 18.089706515204725]],
    [ "1243404790",[-67.1596433, 18.077462599999997]],
    [ "Puerto Rico Electric Power Authority",[-66.90256485, 17.982568500000003]],
    [ "Puerto Rico Electric Power Authority",[-66.91003422615918, 17.974323040219083]],
    [ "Puerto Rico Electric Power Authority",[-66.86831284021949, 18.02964656812062]],
    [ "Puerto Rico Electric Power Authority",[-67.02902384192038, 18.182415478214736]],
    [ "1243424920",[-66.98500365, 18.18601245]],
    [ "1243424921",[-66.9851464, 18.18635515]],
    [ "1243435174",[-86.43639791661121, 42.0390508528211]],
    [ "1243462007",[-86.47716172689337, 42.087874786985026]],
    [ "1243467747",[-86.41268459999999, 42.07476655000001]],
    [ "Pearl Street Station",[-86.45099299001441, 42.09411575335318]],
    [ "1243499420",[-86.47540912578579, 42.12357019435874]],
    [ "1243502030",[-86.43900876389569, 42.14541127513807]],
    [ "1243507873",[-86.38539964332337, 42.183055975177]],
    [ "Puerto Rico Electric Power Authority",[-66.61738804173123, 17.996405274431712]],
    [ "1243518848",[-66.61968545, 17.9962613]],
    [ "1243518857",[-66.68518775152282, 17.98470718291866]],
    [ "1243518859",[-66.68243465702689, 17.991134424854707]],
    [ "1243518866",[-66.68924318002779, 17.979553156306093]],
    [ "Puerto Rico Electric Power Authority",[-66.71815969267004, 17.99508708335719]],
    [ "Puerto Rico Electric Power Authority",[-66.72610025, 17.996806049999996]],
    [ "1243518873",[-66.73138385, 17.99228925]],
    [ "1243518875",[-66.7408392, 18.005533249999996]],
    [ "1243518877",[-66.75159441195804, 18.001737820983166]],
    [ "1243518885",[-66.64000653685224, 17.995287220645903]],
    [ "1243518887",[-66.6430187, 17.99767365]],
    [ "1243518889",[-66.64245982715518, 17.99892383992283]],
    [ "Puerto Rico Electric Power Authority",[-66.64470915088208, 17.9909967670806]],
    [ "Puerto Rico Electric Power Authority",[-66.64716616747653, 17.99006904592319]],
    [ "1243518895",[-66.64809989993645, 17.99056183330031]],
    [ "1243518897",[-66.65055863180865, 17.989738454999827]],
    [ "1243555963",[-66.59413539729256, 18.02575103287579]],
    [ "Puerto Rico Electric Power Authority",[-66.5843978242731, 18.00488660856871]],
    [ "1243555985",[-66.5844112715858, 18.007413858614868]],
    [ "1243555987",[-66.58363685, 18.0086741]],
    [ "1243555989",[-66.58345018072953, 18.009008825243857]],
    [ "1243555992",[-66.5848744, 18.01116515]],
    [ "1243555994",[-66.58202602728397, 18.01293664229057]],
    [ "1243555996",[-66.58267009406505, 18.011151597463865]],
    [ "1243555998",[-66.58215478828615, 18.013845557574314]],
    [ "1243556000",[-66.58045596984269, 18.007656505392433]],
    [ "1243556004",[-66.57251684268694, 18.008166973051548]],
    [ "Puerto Rico Electric Power Authority",[-66.53902145, 18.00119485]],
    [ "1243556025",[-66.57434552753546, 18.008453888827002]],
    [ "1243556035",[-66.56422994999998, 18.0158812]],
    [ "1243556036",[-66.57541090000001, 18.0211676]],
    [ "M.A.E. Substation",[-83.4219705991673, 41.87664885382591]],
    [ "Kinnickinnic (New) Substation",[-92.53827892504745, 44.98851704290084]],
    [ "1243641513",[-66.59357915000001, 18.005700949999998]],
    [ "1243641527",[-66.55032279999999, 18.033016649999997]],
    [ "1243641528",[-66.54668835000001, 18.037481800000002]],
    [ "1243641531",[-66.55197270000001, 18.05758235]],
    [ "1243641534",[-66.50766621515328, 18.045652631894264]],
    [ "1243641535",[-66.50570199999999, 18.048744849999995]],
    [ "1243641537",[-66.50269274062488, 18.04456367239159]],
    [ "1243641543",[-66.5026991276106, 18.04590829466194]],
    [ "1243641545",[-66.50177397763504, 18.047410883999095]],
    [ "Puerto Rico Electric Power Authority",[-66.49267599968253, 18.045800016677592]],
    [ "1243641550",[-66.50423875000001, 18.040071549999997]],
    [ "1243641554",[-66.50899672385646, 18.05707254084416]],
    [ "1243652133",[-66.55111957261346, 18.060439555051424]],
    [ "1243652135",[-66.49143610000002, 18.0717201]],
    [ "1243652137",[-66.4841116, 18.08188455]],
    [ "1243652141",[-66.49767446818676, 18.12715164232526]],
    [ "Puerto Rico Electric Power Authority",[-66.64336711681116, 18.296362848707663]],
    [ "Puerto Rico Electric Power Authority",[-66.47377380456143, 18.327449074431055]],
    [ "1243672989",[-66.83885815, 18.29033505]],
    [ "Puerto Rico Electric Power Authority",[-66.37612719100282, 18.190362330435736]],
    [ "Puerto Rico Electric Power Authority",[-66.28154253895607, 18.243164970158745]],
    [ "1243699490",[-86.26802679999999, 42.2958471]],
    [ "South Haven Station",[-86.27889725681824, 42.38179472805479]],
    [ "1243728022",[-85.92097306847016, 42.20888578562834]],
    [ "1243798062",[-66.42179625, 17.964066749999997]],
    [ "1243798064",[-66.40396411467695, 17.959533504574125]],
    [ "1243798076",[-66.40400282671833, 17.95894174183247]],
    [ "1243798077",[-66.40517830000002, 17.9576327]],
    [ "1243798078",[-66.40377267361576, 17.957509357248174]],
    [ "1243798079",[-66.40220602658806, 17.95874129355912]],
    [ "1243798080",[-66.40208189999998, 17.959617849999994]],
    [ "1243798081",[-66.39854194206399, 17.964162974787826]],
    [ "1243798082",[-66.39718726784368, 17.96359871545951]],
    [ "1243798083",[-66.39298070000001, 18.008892349999996]],
    [ "1243798086",[-66.39343777714689, 18.010189685457625]],
    [ "1243798088",[-66.38265707661817, 18.012852339692667]],
    [ "1243798090",[-66.38138035, 18.0169833]],
    [ "1243798094",[-66.37976580284285, 18.015536017413382]],
    [ "1243798097",[-66.36716925, 18.066989300000003]],
    [ "Puerto Rico Electric Power Authority",[-66.36832235, 18.0672639]],
    [ "1243798101",[-66.36205509532093, 18.06831198395253]],
    [ "1243798102",[-66.33112565, 18.08061925]],
    [ "1243798103",[-66.33097702735272, 18.081477663262667]],
    [ "Puerto Rico Electric Power Authority",[-66.28558453980897, 18.13081077525241]],
    [ "Puerto Rico Electric Power Authority",[-66.25920587833721, 18.14063233985872]],
    [ "1243798108",[-66.26041975000001, 18.13700145]],
    [ "Puerto Rico Electric Power Authority",[-66.32990852519326, 17.979215158685637]],
    [ "Humboldt Substation",[-97.0707164963863, 43.63047049049154]],
    [ "Ervin Substation",[-83.9415637435243, 41.989137283360435]],
    [ "1244213586",[-119.67420607043161, 36.77806336411037]],
    [ "Scotch Hollow Switching Station",[-76.4641546326506, 41.74646744900478]],
    [ "Standish Substation",[-83.96407565000001, 43.98001169999999]],
    [ "Wakpala Substation",[-100.505304177943, 45.660918924924104]],
    [ "Bessinger Substation",[-83.85063390522052, 44.04678160375677]],
    [ "Crew Products Substation",[-83.693603, 44.05066550000001]],
    [ "Dale Road Substation",[-84.5059336147716, 43.85769107473964]],
    [ "DTE Energy",[-83.13019810045849, 42.28716329190447]],
    [ "Oberlin Substation",[-84.5264638892179, 44.07306602548047]],
    [ "College Substation",[-84.46524537870904, 42.690114299012386]],
    [ "College Substation",[-84.46521020736114, 42.68978267735283]],
    [ "Deer Lake Substation",[-84.76877626467963, 44.04016962466535]],
    [ "Larch Generating",[-84.81582263050679, 43.995864124605276]],
    [ "Harrison Substation",[-84.80533305, 44.022519900000006]],
    [ "Magnus Substation",[-84.75266025, 43.8876677]],
    [ "Mannsiding Substation",[-84.88841139999998, 43.95397590000001]],
    [ "Clare MFG Substation",[-84.78329057535541, 43.82111995533544]],
    [ "Hancock Substation",[-84.59972478958147, 44.481996354407144]],
    [ "1245157428",[-75.25008792127522, 39.837622874736496]],
    [ "1245157429",[-75.25721508482404, 39.84682192823266]],
    [ "1245157430",[-75.2519337921303, 39.83244303774594]],
    [ "St Helen Substation",[-84.41099347485056, 44.42389679376993]],
    [ "Fairview Capacitor Bank",[-84.2281469, 44.42048555]],
    [ "West Branch Substation",[-84.23944647540083, 44.277361653970985]],
    [ "Ranger Lake Substation",[-83.87877996132163, 44.418875079731464]],
    [ "Webb Road Substation",[-83.80451559999999, 44.39147045]],
    [ "1245374166",[-66.29992974999999, 17.9724796]],
    [ "Puerto Rico Electric Power Authority",[-66.29320210000002, 17.9753664]],
    [ "Puerto Rico Electric Power Authority",[-66.25708708671277, 17.967517379953886]],
    [ "1245374174",[-66.25914094197613, 17.968087324422108]],
    [ "1245374197",[-66.25722585886561, 17.97253207516846]],
    [ "Puerto Rico Electric Power Authority",[-66.26497420000001, 18.00310575]],
    [ "Puerto Rico Electric Power Authority",[-66.24079324297121, 18.03735722548213]],
    [ "1245374202",[-66.23883864236063, 17.965418725565367]],
    [ "1245374205",[-66.23147655, 17.972344950000004]],
    [ "Puerto Rico Electric Power Authority",[-66.22354064537348, 17.95788993160156]],
    [ "Puerto Rico Electric Power Authority",[-66.21674989929174, 17.970944405494475]],
    [ "1245374214",[-66.21635870775343, 17.972875275206146]],
    [ "1245374217",[-66.2196921, 17.981214]],
    [ "1245374219",[-66.2156557606583, 17.989768676249962]],
    [ "1245374221",[-66.16713986759625, 17.96039764671507]],
    [ "1245374233",[-66.15036415, 17.966699600000002]],
    [ "1245374234",[-66.14587901240169, 17.963440955148293]],
    [ "1245374236",[-66.15188954999999, 17.98039615]],
    [ "1245374237",[-66.13297056518736, 17.9617865454765]],
    [ "Blair Road Substation",[-83.55082504276544, 44.237967718522555]],
    [ "Sherman Substation",[-83.51326131391203, 44.38287092469283]],
    [ "Greenbush Substation",[-83.3421103871795, 44.61257617497994]],
    [ "Grayling Substation",[-84.71259586666685, 44.65881055000377]],
    [ "Subestación Humacao",[-65.82671229345004, 18.137020525741224]],
    [ "1245603877",[-65.82299893767163, 18.135943369535706]],
    [ "Southwest Substation",[-83.6127685, 45.034877800000004]],
    [ "Hubbard Lake Substation",[-83.58676879999999, 44.9406472]],
    [ "Ossineke Substation",[-83.43775141406363, 44.924410146582034]],
    [ "Puerto Rico Electric Power Authority",[-66.16674517405198, 18.103283661331744]],
    [ "1245633795",[-66.16034258130611, 18.10733210531185]],
    [ "1245633798",[-66.15863240537847, 18.10834838537588]],
    [ "1245633802",[-66.0974103, 18.162271649999997]],
    [ "1245633804",[-66.0967078, 18.165453]],
    [ "Puerto Rico Electric Power Authority",[-66.11975938801379, 18.195387131454044]],
    [ "1245633812",[-66.1264133, 18.19789075]],
    [ "1245633815",[-66.09505374155886, 17.981247722402763]],
    [ "1245633816",[-66.0961128, 17.980558300000002]],
    [ "Puerto Rico Electric Power Authority",[-66.0929609, 17.9785837]],
    [ "1245633820",[-66.09447566780449, 17.972684565690784]],
    [ "1245633822",[-66.11143724999998, 17.9647086]],
    [ "1245633824",[-66.11415722274866, 17.97486705864795]],
    [ "1245633825",[-66.06416193115162, 17.979884378827443]],
    [ "1245633829",[-66.05719652471541, 17.97557630871492]],
    [ "1245633831",[-66.01086703238231, 18.001456353432975]],
    [ "Puerto Rico Electric Power Authority",[-65.90686528147761, 18.004286162469974]],
    [ "M-32 Substation",[-83.48181263152104, 45.06550166959932]],
    [ "1245663691",[-73.71562497707107, 42.331771199249054]],
    [ "1245673761",[-73.76067645, 42.240291850000006]],
    [ "Alpena Power Company",[-83.42474045, 45.06502635]],
    [ "Babbitt Substation",[-82.74126443141095, 40.07397049633458]],
    [ "1245826295",[-82.76782026585482, 40.0567056672487]],
    [ "1245829346",[-82.68653407402692, 39.72587980734223]],
    [ "1245829347",[-82.69189928881114, 39.72583892386714]],
    [ "1245829348",[-82.69215761856114, 39.72699106480478]],
    [ "Norway Substation",[-83.51835801259199, 45.102291044375555]],
    [ "Cyprus Switching Station",[-82.99104817064148, 39.85583917511404]],
    [ "Caine Substation",[-85.15823940488588, 42.312142569899]],
    [ "Cheney Limestone Substation",[-85.03669884845104, 42.43409449815761]],
    [ "Certainteed Substation",[-84.38981241951366, 42.242746235109806]],
    [ "Consumers Energy",[-84.39497692154126, 42.240780301303886]],
    [ "Consumers Energy",[-84.39134797378716, 42.235360667365086]],
    [ "1245948122",[-98.41433854460715, 41.026259199838194]],
    [ "Seneca Substation",[-84.22481059838984, 41.79220562489355]],
    [ "1245960929",[-117.74699586779789, 33.87142342474353]],
    [ "Alma Products Substation",[-84.63200289816648, 43.38751851175658]],
    [ "1246024377",[-65.88089195985998, 18.046704125792868]],
    [ "1246024380",[-65.8254165, 18.138227650000005]],
    [ "1246024384",[-65.8220451872835, 18.14068656980824]],
    [ "Puerto Rico Electric Power Authority",[-65.81048755000002, 18.142314]],
    [ "1246024390",[-65.80733524487368, 18.140541231477194]],
    [ "1246024399",[-65.79838121963562, 18.14856800257805]],
    [ "1246024400",[-65.79817116997701, 18.15158440412417]],
    [ "1246024403",[-65.81294163136931, 18.14459584474987]],
    [ "1246024405",[-65.81410694999998, 18.14570485]],
    [ "1246024414",[-65.83503739184556, 18.146594175509254]],
    [ "1246024416",[-65.83505227445617, 18.144216240872794]],
    [ "1246024418",[-65.83130835, 18.140137649999996]],
    [ "1246024420",[-65.8287626, 18.1390976]],
    [ "1246024423",[-65.82671167044728, 18.140086126273136]],
    [ "1246024426",[-65.79511425611835, 18.14771556979879]],
    [ "1246024428",[-65.79030279999999, 18.1448624]],
    [ "1246024431",[-65.79114847122838, 18.131785456042344]],
    [ "1246024434",[-65.78847350000001, 18.15127925]],
    [ "1246024435",[-65.78844576098257, 18.15087337869071]],
    [ "1246024436",[-65.78888270887936, 18.150377375962233]],
    [ "1246024439",[-65.79105504254703, 18.150553874712937]],
    [ "1246024441",[-65.7895529605961, 18.154378077028145]],
    [ "Puerto Rico Electric Power Authority",[-65.75530959976862, 18.161274837227978]],
    [ "1246024449",[-65.72851609235124, 18.210398623813248]],
    [ "Puerto Rico Electric Power Authority",[-65.73286433518615, 18.207221410163186]],
    [ "1246024453",[-65.72496945692423, 18.19896663424356]],
    [ "1246024455",[-65.69780860326489, 18.184540232243265]],
    [ "Puerto Rico Electric Power Authority",[-65.52095852469793, 18.122507587734084]],
    [ "1246024460",[-65.30253011867995, 18.304703337203946]],
    [ "1246162865",[-65.63918285899727, 18.282877927164925]],
    [ "1246162868",[-65.64130631564366, 18.333111035253875]],
    [ "1246162870",[-65.63942745, 18.332142400000002]],
    [ "1246162872",[-65.64034980000001, 18.3361935]],
    [ "1246162876",[-65.64712324999998, 18.32955055]],
    [ "Tennessee Valley Authority",[-88.97875963628141, 36.63448427129017]],
    [ "1246252823",[-88.86091943899251, 36.80007278855401]],
    [ "1246252834",[-88.98324383771786, 36.64705203195019]],
    [ "Barlow Substation",[-89.04307227736527, 37.05821565794829]],
    [ "1246287260",[-88.77750331022425, 37.14527711938881]],
    [ "Paducah Power System",[-88.60630925274813, 37.081767367928734]],
    [ "Paducah Power System",[-88.65132520077363, 37.0494424332159]],
    [ "Paducah Power System",[-88.63395061695631, 37.06927001797596]],
    [ "Paducah Power System",[-88.73460939696403, 37.062376278241246]],
    [ "Paducah Power System",[-88.74897236117647, 37.129415129592545]],
    [ "1246372406",[-88.43742785944654, 36.852608494823315]],
    [ "Tennessee Valley Authority",[-88.64883993128122, 36.78811468169324]],
    [ "1246444143",[-76.55387258036504, 40.31510495677134]],
    [ "Bavarian Substation",[-83.7327187229199, 43.318264515828524]],
    [ "Fredericksburg Substation",[-76.44252223395816, 40.42941249889455]],
    [ "1246764005",[-76.4110356193171, 40.44372349741858]],
    [ "Sedalia Substation",[-88.60519092451652, 36.632978282158035]],
    [ "1246808746",[-88.32500973125428, 36.63382684634253]],
    [ "Tennessee Valley Authority",[-88.11650047645773, 36.94655617083823]],
    [ "Tennessee Valley Authority",[-87.92537785000002, 36.9071061]],
    [ "Cerulean Substation",[-87.69843266424617, 36.96086721330817]],
    [ "1246850177",[-87.53001190895817, 36.89263239374435]],
    [ "1246850194",[-87.66367239241298, 36.755221309658715]],
    [ "1246850201",[-87.50243272724148, 36.868550062915645]],
    [ "1246870641",[-87.44159992521944, 36.8253592068049]],
    [ "Broad Street Substation",[-76.41848445, 40.32766865]],
    [ "North Cornwall Substation",[-76.4101505, 40.299834399999995]],
    [ "Ethel Springs Substation",[-79.31364085221631, 40.33252683503996]],
    [ "Rehrersburg Substation",[-76.27410794999999, 40.441932949999995]],
    [ "1247039825",[-92.59092997851351, 42.3116750795712]],
    [ "Stouchsburg Substation",[-76.24347055799065, 40.38253417953069]],
    [ "Wood Street Substation",[-76.73732665348658, 40.19106418334354]],
    [ "1247476562",[-76.72852368440759, 40.20573093556599]],
    [ "1247477700",[-76.6437188, 40.071138749999996]],
    [ "1247477701",[-76.64166545000002, 40.07050900000001]],
    [ "Glenside Substation",[-75.95322676611862, 40.350021511334425]],
    [ "1247708855",[-87.90261891495315, 37.10914187048937]],
    [ "1247708857",[-86.9489012, 36.96157234999999]],
    [ "1247708875",[-86.93532435747919, 36.94283046085998]],
    [ "1247708884",[-87.1239093778308, 37.04420265719971]],
    [ "Sutter Substation",[-121.69619626332519, 39.05177051698951]],
    [ "City of Owensboro",[-87.12328099999999, 37.737516]],
    [ "Post Substation",[-121.56888091447478, 38.56751108642871]],
    [ "1247952984",[-99.76067807515162, 39.051884243530615]],
    [ "1247952985",[-99.87158558585412, 39.05212791881281]],
    [ "1247962716",[-75.9403131386276, 40.35276125722574]],
    [ "Carpenter Tech Substation",[-75.9402114356284, 40.36174633717494]],
    [ "1247962728",[-75.93874728281064, 40.36477462815719]],
    [ "1248239678",[-82.66618899214257, 37.849017761885335]],
    [ "Royal Green Substation",[-75.93159381452095, 40.41545227948849]],
    [ "1248654572",[-94.72099220049661, 33.43305611095085]],
    [ "1248696126",[-75.95806465632248, 40.45084834274011]],
    [ "Leesport Substation",[-75.97363808899546, 40.45649700562177]],
    [ "1248704260",[-96.43814287533684, 33.19496984204569]],
    [ "1248907665",[-115.56588295, 33.1783856]],
    [ "1248907680",[-115.5731218400965, 33.204935810804656]],
    [ "1248907698",[-115.4664236291996, 33.08320290350382]],
    [ "1248907704",[-115.71740896675884, 32.734475366575396]],
    [ "1248907713",[-115.78028865000002, 32.77174765]],
    [ "1248907714",[-115.7814487249198, 32.77162276163389]],
    [ "1248907780",[-115.43487041513845, 33.19345539533125]],
    [ "1248907781",[-116.24290488897385, 33.69957293854637]],
    [ "1248907820",[-116.23224421645796, 33.70928183313618]],
    [ "1248907832",[-116.23416283838951, 33.731413899856456]],
    [ "1248907994",[-116.57972070536593, 33.92174727142739]],
    [ "1248908255",[-113.91964399930903, 33.96202636691355]],
    [ "1248908297",[-113.17936845776623, 33.944369233342236]],
    [ "Sagebrush Substation",[-102.86932616188223, 39.53487465885879]],
    [ "Montgomery Substation",[-74.22561239469694, 41.525414052749575]],
    [ "Manchester Substation",[-84.03672002876148, 42.14599207178667]],
    [ "1248985420",[-115.78896677561795, 32.82669264125425]],
    [ "1248985456",[-115.37308002831804, 32.67543132692589]],
    [ "1248985464",[-115.39206205, 32.673528149999996]],
    [ "1248985498",[-115.43632767355153, 32.67003121574026]],
    [ "1248985512",[-115.53456821667379, 32.713407824978596]],
    [ "1248985517",[-115.53852815594485, 32.715261575179]],
    [ "1248985522",[-115.53458171606037, 32.71477754461767]],
    [ "1248985524",[-115.53467341729095, 32.71435004351071]],
    [ "1248985545",[-115.51015037483552, 33.12654215342211]],
    [ "1248985563",[-115.54293578494068, 32.986974166065124]],
    [ "1248985569",[-115.54285982491247, 33.01395390410982]],
    [ "1248985582",[-115.53416384760057, 32.97030751355936]],
    [ "1248985590",[-115.53464405811573, 32.968410446386756]],
    [ "1248985615",[-115.56078703789758, 32.963036206465816]],
    [ "1248985632",[-115.51391109999999, 32.9061003]],
    [ "1248985633",[-115.51285696285, 32.90330933090639]],
    [ "1248985641",[-115.51026497491651, 32.82017330430079]],
    [ "1248985661",[-115.38803506992271, 32.812396026865336]],
    [ "1248985692",[-115.5175244494462, 32.714468188783954]],
    [ "1248985701",[-115.56536693296889, 32.7636296250615]],
    [ "1248985710",[-115.5791692283694, 32.7996247210218]],
    [ "1248985723",[-115.74346338231526, 32.8806136453861]],
    [ "1248985741",[-115.96987392393586, 33.285279075043405]],
    [ "1248985753",[-116.11320225544347, 33.52496127475937]],
    [ "1248995758",[-108.30830792844228, 32.62652388741917]],
    [ "1249112348",[-93.48098449636666, 42.908618311296145]],
    [ "1249258363",[-92.31640552500066, 39.120451142601226]],
    [ "Marathon Pipe Line LLC",[-85.14584562908219, 37.92028119400066]],
    [ "Tripp Road Substation",[-84.51455842195878, 41.78024445856466]],
    [ "Scipio Substation",[-84.63908469271146, 42.05799712414475]],
    [ "1249384420",[-115.26332267336998, 32.77522727467257]],
    [ "Tennessee Substation",[-117.1112667708024, 34.02718239687581]],
    [ "Redlands Substation",[-117.17669420475166, 34.06023854178601]],
    [ "Mentone Substation",[-117.12074707504294, 34.063276794774325]],
    [ "1249384513",[-117.07747750012135, 34.07420452254561]],
    [ "1249384523",[-117.04750837483351, 34.074385194705535]],
    [ "1249384688",[-115.25734315989288, 32.816504624986166]],
    [ "1249384689",[-115.25684293974872, 32.81650497501359]],
    [ "1249384698",[-115.24876298277158, 32.78660217166484]],
    [ "1249384699",[-115.24840695, 32.78657425]],
    [ "Altn Cmt Substation",[-75.89430710262376, 40.4728865845269]],
    [ "1249587508",[-75.76488180660198, 40.47482749036522]],
    [ "Brooklyn Substation",[-84.24403424299452, 42.11017030880069]],
    [ "Napoleon Substation",[-84.24972579043919, 42.161083563238456]],
    [ "1249793654",[-117.79785393158373, 36.036774290275005]],
    [ "1249793977",[-117.28548597632515, 34.24277237813219]],
    [ "Cabot Supermetals Substation",[-75.61458019999999, 40.34366874999999]],
    [ "Middle Creek Substation",[-75.59323251687024, 40.314024805570114]],
    [ "Met-Ed",[-75.6462377963921, 40.32846001263223]],
    [ "1249989911",[-75.78676951878441, 40.38298040800098]],
    [ "Carsonia Substation",[-75.87178279716477, 40.33462394075274]],
    [ "1250034333",[-83.18540061931768, 42.54571197488245]],
    [ "Pacific Gas and Electric Company",[-121.86974786145034, 37.5868956615146]],
    [ "1250094831",[-75.91144348024815, 40.37889875722103]],
    [ "Lucent Substation",[-75.91160446098404, 40.37398850271776]],
    [ "Spring Valley Substation",[-75.91553000441994, 40.377087188876]],
    [ "1250094843",[-75.91712025427253, 40.37246751666991]],
    [ "Muhlenberg Substation",[-75.930656708477, 40.36967696015056]],
    [ "1250117745",[-117.33235140893478, 33.971895017788206]],
    [ "Met-Ed",[-75.92260368451005, 40.3446546813257]],
    [ "Perry Center Substation",[-78.02495932150264, 42.74660497749333]],
    [ "Painted Sky Substation",[-75.88379025, 40.301086500000004]],
    [ "Lorane Substation",[-75.85535483690757, 40.287825979265655]],
    [ "Pioneer Crossing Substation",[-75.81726066967754, 40.27511928009104]],
    [ "Pine Lane Substation",[-75.73131925, 40.29081995000001]],
    [ "Adamstown Substation",[-76.03263594019755, 40.25328391060306]],
    [ "1250958076",[-95.44950807580933, 30.36904710675035]],
    [ "1250973259",[-95.54172691307306, 30.6766811808792]],
    [ "Rocky Creek substation",[-95.71958291425965, 30.757218984132024]],
    [ "Everett Substation",[-85.73785666544941, 43.55679643229088]],
    [ "Farmview Substation",[-75.44255783153598, 38.882146836779995]],
    [ "1251330678",[-98.89906047711187, 33.10080810437068]],
    [ "1251345158",[-110.71670445411509, 34.64156658054288]],
    [ "1251429513",[-86.53243441532517, 34.32002077508965]],
    [ "Babcock Substation",[-85.18015278537703, 41.99936326210557]],
    [ "Union City Electric Department",[-85.13120486431453, 42.06531153075392]],
    [ "1251477603",[-77.3903300453949, 39.79180701745371]],
    [ "Consumers Energy",[-85.00202404138203, 42.05163808660394]],
    [ "Girard Substation",[-85.00513420238453, 42.02452127459195]],
    [ "1251611905",[-76.76956638602738, 39.94695847150715]],
    [ "1251611914",[-76.74204439423477, 39.95098449878202]],
    [ "McKnights Gap Substation",[-75.88911601901184, 40.36675324543636]],
    [ "PECO",[-75.531925120364, 40.15318775519803]],
    [ "1251809919",[-75.69186049999998, 40.097933749999996]],
    [ "1251831054",[-119.63107655466746, 35.22735200910577]],
    [ "Goshen Substation",[-75.53484698591357, 39.976090384036475]],
    [ "1251839015",[-88.6143009, 46.79269865]],
    [ "1252006982",[-113.28793709999998, 37.79628205000001]],
    [ "1252006985",[-113.25905658910054, 37.773805814860914]],
    [ "1252006986",[-113.25810617140233, 37.77348804459718]],
    [ "1252006998",[-113.1488517942617, 37.728174470026104]],
    [ "1252008864",[-113.69823199103855, 37.70701909832078]],
    [ "1252014989",[-113.65839850000002, 37.6114674]],
    [ "1252042619",[-80.5853744193846, 33.22852031641297]],
    [ "Colon Substation",[-85.32752376212734, 41.95541950541596]],
    [ "Glen Oaks Substation",[-85.49883191513861, 41.89400241912328]],
    [ "Scotts Substation",[-85.41148384051944, 42.19371401477619]],
    [ "1252216461",[-117.30484050521294, 35.0023143251249]],
    [ "1252216478",[-118.58996064841826, 37.54582056567638]],
    [ "1252451466",[-94.33730109999999, 41.4620048]],
    [ "1252517793",[-75.13115789316217, 40.85194638690691]],
    [ "Met-Ed",[-75.20666987873578, 40.8623485268141]],
    [ "1252874447",[-94.18566339975558, 42.730728272841965]],
    [ "Roscommon Substation",[-84.60124792534522, 44.48642511014686]],
    [ "Hotchkiss Road Substation",[-83.9846602071402, 43.56704327526553]],
    [ "1253007198",[-106.13170078521539, 31.51737733920734]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.90590738349127, 37.79900485076126]],
    [ "1253020401",[-86.70858403581377, 37.20830113011429]],
    [ "1253080019",[-86.72323401336463, 36.869104828827716]],
    [ "1253311252",[-89.73867591385824, 43.298617024986854]],
    [ "Craft Hill Substation",[-72.29623128223571, 43.63787798222998]],
    [ "Monroe Substation",[-72.0565865, 44.26169545]],
    [ "Station 212",[-77.05608177057013, 43.23600790874982]],
    [ "1253434575",[-114.61821825627973, 34.85115857503153]],
    [ "1253434588",[-114.57960516851367, 34.880255335588345]],
    [ "1253434599",[-114.56216239999999, 34.8675245]],
    [ "1253434600",[-114.59647460000001, 34.9247126]],
    [ "1253434612",[-114.61719835000001, 35.10739465]],
    [ "1253434615",[-114.59385966908926, 35.09818685195479]],
    [ "West Wilmington Substation",[-75.57783107592431, 39.75173092620592]],
    [ "1253493146",[-110.84155733236368, 32.1890097315447]],
    [ "Cottonwood Substation",[-110.99079923337972, 32.178934631521535]],
    [ "1253668540",[-88.3882125655294, 37.12223122114744]],
    [ "1253668542",[-88.25753126357101, 37.19746486804034]],
    [ "Joy Substation",[-88.38555441705974, 37.356663359265276]],
    [ "North Princeton Substation",[-87.97352035597831, 37.16777956743821]],
    [ "Kentucky Utilities Company",[-87.51880274723372, 37.27450198766492]],
    [ "Nortonville Substation",[-87.45578619999999, 37.191548749999995]],
    [ "Kentucky Utilities Company",[-87.47977540000001, 37.20268995]],
    [ "Kentucky Utilities Company",[-87.4847303600935, 37.12565998370767]],
    [ "Kentucky Utilities Company",[-87.49109750000001, 37.05915174999999]],
    [ "Saint Charles Substation",[-87.57050770832137, 37.201043819289886]],
    [ "1253744864",[-87.66061018241115, 37.140481551983434]],
    [ "Kentucky Utilities Company",[-87.68656556415714, 37.16906168497728]],
    [ "1253744874",[-87.6716999, 37.2410006]],
    [ "1253744875",[-87.71206289037136, 37.19515897533965]],
    [ "Kentucky Utilities Company",[-88.0392165831892, 37.173803698858165]],
    [ "Kentucky Utilities Company",[-88.05234847353249, 37.21082550713978]],
    [ "1253744892",[-88.1216784351953, 37.215204731238686]],
    [ "Kentucky Utilities Company",[-88.0774663, 37.328858950000004]],
    [ "1253848223",[-114.81404680000001, 35.97584835]],
    [ "1253848242",[-115.08217772492007, 36.292706957893714]],
    [ "1253848383",[-115.12750565539173, 36.12939923478654]],
    [ "1253848570",[-115.04870366189101, 36.08580164538908]],
    [ "Google Data Center",[-115.0079737249225, 36.057808156885265]],
    [ "1253848703",[-114.98927689568258, 36.041080981662574]],
    [ "1253848709",[-114.94146502500817, 36.03216118081129]],
    [ "1253848768",[-114.8129295905136, 36.0218994198378]],
    [ "1253848785",[-114.80863413463535, 36.035373225792235]],
    [ "1253848812",[-114.8299185, 36.0014313]],
    [ "1253848822",[-114.74370565774205, 36.01703437877654]],
    [ "1253848835",[-114.17472159999997, 35.05413014999999]],
    [ "1253848848",[-114.14863584999999, 35.360936349999996]],
    [ "1253848852",[-114.15130070065308, 35.3696768659061]],
    [ "1253848857",[-114.26998490284385, 35.41014922010175]],
    [ "1253848880",[-114.73543764999998, 36.01225325]],
    [ "1253848906",[-114.78122945, 36.020355]],
    [ "1253848928",[-114.93523004999999, 35.484112700000004]],
    [ "1253848930",[-114.93527066887236, 35.48290341578801]],
    [ "1253848935",[-114.93549385076852, 35.45957915068812]],
    [ "1253848937",[-114.83644253861048, 35.29491270696735]],
    [ "1253848939",[-114.57810461400993, 35.15178484784493]],
    [ "1253848964",[-114.6774042129354, 35.03279638413796]],
    [ "SR Perry, LLC",[-83.76223514835937, 32.39139411651857]],
    [ "Georgia Power Company",[-83.76284943333155, 32.39203980014671]],
    [ "PECO",[-75.3394253677556, 39.85712529843237]],
    [ "1254160726",[-84.48565692549734, 36.807776256342876]],
    [ "Kentucky Utilities Company",[-87.54023243941704, 37.35368597193496]],
    [ "Kentucky Utilities Company",[-87.54394217459343, 37.35702671326522]],
    [ "Kentucky Utilities Company",[-87.50009655946423, 37.343426505123006]],
    [ "Kentucky Utilities Company",[-87.49105636770318, 37.34109290536373]],
    [ "Kentucky Utilities Company",[-87.48027051500976, 37.348959224146085]],
    [ "Kentucky Utilities Company",[-87.48414765, 37.381118949999994]],
    [ "Kentucky Utilities Company",[-87.49085329676673, 37.320711717696916]],
    [ "Warrior Coal, LLC",[-87.58973742955109, 37.33061455693558]],
    [ "Warrior Coal, LLC",[-87.58124371448045, 37.34495047523485]],
    [ "Warrior Coal, LLC",[-87.57892397951748, 37.348014226997364]],
    [ "Warrior Coal, LLC",[-87.57985928659268, 37.35370937452863]],
    [ "Warrior Coal, LLC",[-87.57279639065581, 37.39284467277017]],
    [ "Warrior Coal, LLC",[-87.53564998664876, 37.3996233016923]],
    [ "Warrior Coal, LLC",[-87.61537709999998, 37.38146535]],
    [ "Warrior Coal, LLC",[-87.63270353996087, 37.40441042066943]],
    [ "1254161866",[-87.5535721388784, 37.357982119676855]],
    [ "1254189330",[-75.49819097467011, 39.187293037511]],
    [ "1254189331",[-75.50052671816141, 39.18704658472044]],
    [ "1254209080",[-116.35638593033234, 36.82062840577241]],
    [ "1254209099",[-116.400102553357, 36.537286000485935]],
    [ "1254209373",[-115.08365424999998, 36.114281250000005]],
    [ "1254220249",[-91.6745303251793, 43.34625844461316]],
    [ "1254229746",[-90.17500480000001, 42.8603356]],
    [ "Cleveland Public Power",[-81.64311904562749, 41.53255136537284]],
    [ "Cleveland Public Power",[-81.64097086574178, 41.533234571824075]],
    [ "1254358938",[-88.12062101338478, 37.174186722470516]],
    [ "1254358948",[-87.93701886342883, 37.64909939726763]],
    [ "1254358949",[-87.9370850301157, 37.64881396782908]],
    [ "1254358955",[-88.006016, 37.695064900000006]],
    [ "1254358957",[-87.97085685380173, 37.691926266953416]],
    [ "River View Coal, LLC",[-87.89632914999999, 37.746014849999995]],
    [ "River View Coal, LLC",[-87.9442331012095, 37.759581659486514]],
    [ "Uniontown Substation",[-87.92735758474572, 37.763136907575124]],
    [ "1254359050",[-87.72111336691925, 37.541646249103906]],
    [ "1254433671",[-92.82603518908799, 40.89275393911325]],
    [ "1254435973",[-115.12168445, 36.231812899999994]],
    [ "1254436062",[-115.13423282592925, 36.15959553476372]],
    [ "1254436100",[-114.92089324024677, 36.343524736487765]],
    [ "1254436103",[-114.91114295, 36.359136]],
    [ "1254436130",[-114.92923413271998, 36.34710048399154]],
    [ "1254436201",[-114.96108548127152, 36.42022989233574]],
    [ "1254436203",[-114.96837555, 36.3881584]],
    [ "1254436204",[-114.96712120334816, 36.38792813143176]],
    [ "1254436205",[-114.97193488028958, 36.355454945042915]],
    [ "1254436207",[-114.9878657430786, 36.31374664643775]],
    [ "1254436294",[-115.16576425502652, 36.143564930358394]],
    [ "1254436301",[-115.14919285922528, 36.14071566229956]],
    [ "Dycusburg Substation",[-88.17811203332687, 37.16209839982398]],
    [ "Kentucky Utilities Company",[-88.22513155, 37.297041099999994]],
    [ "Kalamazoo Substation",[-85.49484943357835, 42.28166936117828]],
    [ "1254538357",[-87.88828575, 37.66661055]],
    [ "Wheatcroft Substation",[-87.8486113706446, 37.48044222398426]],
    [ "1254538361",[-87.98419271607602, 37.55522468194614]],
    [ "1254538371",[-88.03463547611966, 37.55490920597325]],
    [ "Kentucky Utilities Company",[-87.95037609896845, 37.66426890081055]],
    [ "Clay Substation",[-87.82288589999999, 37.47412405]],
    [ "Webster County Coal LLC",[-87.77388463898266, 37.45508178191181]],
    [ "Webster County Coal LLC",[-87.77497100000001, 37.454390399999994]],
    [ "1254538409",[-87.72172276212923, 37.49525742375543]],
    [ "Webster County Coal LLC",[-87.68869200000002, 37.4254454]],
    [ "Sebree Mining, LLC",[-87.47769694262948, 37.584123417778365]],
    [ "Sebree Mining, LLC",[-87.47648510581413, 37.585431032059994]],
    [ "1254575115",[-87.27247513673738, 37.42056223324281]],
    [ "1254593234",[-87.53258817012637, 37.651528904393]],
    [ "1254593237",[-87.58749602087151, 37.80673270117494]],
    [ "1254593241",[-87.45779403124791, 37.85791161264721]],
    [ "Kentucky Utilities Company",[-87.72326730322322, 37.71864313307024]],
    [ "1254593258",[-87.62149371234402, 37.810767255345084]],
    [ "1254646805",[-87.77955727508788, 37.718254283820244]],
    [ "Corydon Substation",[-87.71545004137822, 37.74226857305942]],
    [ "1254646811",[-87.5051562, 37.816528250000005]],
    [ "Poole Substation",[-87.64048712685953, 37.64022724369051]],
    [ "1254646845",[-87.47771868359254, 37.577046897784]],
    [ "1254646846",[-87.44563485, 37.556879499999994]],
    [ "Onton Substation",[-87.44101388303928, 37.55713395276216]],
    [ "Ashbyburg Substation",[-87.36640945689922, 37.537686031348024]],
    [ "1254646851",[-87.26227006873587, 37.535327496861264]],
    [ "Kentucky Utilities Company",[-87.25037804999998, 37.527800850000006]],
    [ "1254646855",[-87.1440375, 37.45968069999999]],
    [ "1254646856",[-87.13663061101461, 37.48753157590551]],
    [ "1254646858",[-87.13961048007747, 37.44480829419473]],
    [ "Kendall Substation",[-85.62619644992999, 42.29341947167522]],
    [ "1255115414",[-74.72774203417146, 40.23575192378879]],
    [ "1255331310",[-79.05949639118889, 40.38313338687367]],
    [ "1255422716",[-83.78515563846165, 37.22813406990766]],
    [ "1255471970",[-115.18630635563542, 36.14289017880812]],
    [ "1255472012",[-115.25001883892615, 36.15762932202716]],
    [ "1255472243",[-115.24183853899368, 36.083824737259164]],
    [ "Cooper Substation",[-78.9292549416415, 40.35217738914733]],
    [ "1255876875",[-114.83588540000001, 35.9690966]],
    [ "1255876923",[-114.9287166409347, 36.0669948139057]],
    [ "1255876942",[-114.95642583467296, 36.07351807648883]],
    [ "1255876990",[-115.05568537224791, 36.02751174539067]],
    [ "Paradise Substation",[-121.61887614190036, 39.76064269424026]],
    [ "1256390167",[-124.07315220000001, 40.89881655]],
    [ "1256498257",[-87.17112289813424, 37.22513298324478]],
    [ "1256498263",[-87.2757335, 37.24139975000001]],
    [ "1256498265",[-87.12085284126938, 37.24117102024056]],
    [ "1256498269",[-87.0808714579295, 37.24983420398524]],
    [ "1256498270",[-87.05423212341148, 37.213098694892295]],
    [ "1256498272",[-87.05586107546858, 37.178528907910824]],
    [ "1256498274",[-87.03567748609657, 37.171507573686156]],
    [ "1256498283",[-87.05106900431505, 37.29490823377925]],
    [ "1256498284",[-87.0539794, 37.2964541]],
    [ "1256498291",[-87.00486585000002, 37.32172915]],
    [ "1256498292",[-87.0424076941128, 37.340771071896874]],
    [ "1256498294",[-87.09863022937762, 37.35667685444118]],
    [ "1256498297",[-87.09368563786221, 37.42236357402745]],
    [ "1256498298",[-86.96712204140513, 37.33704976377862]],
    [ "1256498301",[-86.95064613947285, 37.35954757030347]],
    [ "1256498305",[-86.92726705, 37.39226385]],
    [ "Beaver Sam Substation",[-86.88665977214858, 37.40303079351647]],
    [ "Beaver Dam North Substation",[-86.88557696840617, 37.41973276668889]],
    [ "Hartford Substation",[-86.91115625785592, 37.44677188882499]],
    [ "1256523995",[-87.11099113912553, 37.315752224752956]],
    [ "1256524001",[-87.22013631778204, 37.27860439354729]],
    [ "1256524009",[-87.44804235000001, 37.32020965]],
    [ "1256524014",[-87.41503655000002, 37.309061500000006]],
    [ "1256524021",[-87.24158419999999, 37.35623759999999]],
    [ "1256586461",[-84.70668353233013, 38.209284404823705]],
    [ "1256684363",[-120.2016422, 36.92393124999999]],
    [ "Naamans Substation",[-75.44040352023767, 39.809423326553386]],
    [ "Keller Magnolia substation",[-97.29701875000002, 32.93957915]],
    [ "1256877278",[-88.25568508677223, 42.538927818986274]],
    [ "1256877281",[-88.27927972290726, 42.52459343227831]],
    [ "1256877284",[-88.3240521111121, 42.51610710975337]],
    [ "1256881132",[-88.41309251491352, 42.578902501672374]],
    [ "1256881137",[-88.55688190000002, 42.525311]],
    [ "1256913881",[-89.12989525000002, 42.64921935]],
    [ "1256915772",[-89.04165413961461, 42.583355001360566]],
    [ "1256915773",[-89.03954445000001, 42.5814205]],
    [ "1256915774",[-89.03954272526495, 42.58175444619594]],
    [ "1256915775",[-89.03954506824516, 42.5821671252664]],
    [ "1256940918",[-92.80652330002192, 41.002948174467356]],
    [ "Entergy Louisiana",[-89.93045028783254, 29.94762029872344]],
    [ "1256980967",[-95.54001600717494, 32.52622902481666]],
    [ "Glendale Substation",[-85.57368444178356, 42.326503351461504]],
    [ "Consumers Energy",[-85.55043386867054, 42.288959179385934]],
    [ "1257062583",[-94.33950004121824, 40.81249508741652]],
    [ "1257062585",[-94.33890220747104, 40.85501899268041]],
    [ "1257147815",[-74.70270052842226, 40.45018588230428]],
    [ "Pacific Gas and Electric Company",[-121.8133088870545, 39.7121600430181]],
    [ "Jones Substation",[-75.61260432095506, 39.258036506404146]],
    [ "1258395457",[-84.15696480452276, 36.72218079550675]],
    [ "1258402301",[-84.60162151924142, 37.04482928530204]],
    [ "1258411679",[-84.67286546672462, 37.06075251278245]],
    [ "Tucker Substation",[-83.57032581837011, 42.791001467313855]],
    [ "1258541459",[-87.39894494401955, 37.61373498609227]],
    [ "Utica Substation",[-87.10032137595925, 37.606760638200946]],
    [ "Livia Substation",[-87.1095520552391, 37.56153540364349]],
    [ "1258541479",[-86.92782905000001, 37.47377825]],
    [ "1258541480",[-86.9555065, 37.40249779999999]],
    [ "Centertown Substation",[-86.98514926411976, 37.41439272272112]],
    [ "1258623960",[-86.77545869377532, 37.765645423406376]],
    [ "1258623965",[-86.76720826643322, 37.89715905930902]],
    [ "1258623976",[-86.7940421, 37.96163699999999]],
    [ "1258702593",[-84.61972749426272, 33.72882086443499]],
    [ "1258702601",[-84.5952365338068, 33.76383356488203]],
    [ "Georgia Power Company",[-84.43086803337438, 33.77695496549613]],
    [ "Georgia Power",[-84.431027241501, 33.779029782589575]],
    [ "1258790764",[-91.22595418092789, 29.68163984436028]],
    [ "1258915824",[-75.7521242617604, 39.39368461842512]],
    [ "Long Lake Substation",[-83.72991700259402, 42.85800253439071]],
    [ "1258924288",[-86.22383132523734, 32.54496469050633]],
    [ "Bayou Bridge Pipeline, LLC",[-91.80929259905743, 30.10257360260165]],
    [ "1259091756",[-112.21695239548487, 41.94620635244508]],
    [ "1259168924",[-121.90263564781705, 38.02888020126644]],
    [ "McCandlish Substation",[-83.57436504525097, 42.91345730076579]],
    [ "Heartland Divide II Wind",[-94.87997941248248, 41.79599072089893]],
    [ "1259327096",[-87.32541109946148, 37.69966584745617]],
    [ "1259327097",[-87.2525396, 37.81194935]],
    [ "1259327103",[-87.18550947892311, 37.746440968233074]],
    [ "1259327107",[-87.13120384645038, 37.7185891940577]],
    [ "Wellsville Substation",[-80.73311608886937, 40.652645974654625]],
    [ "Great Pathfinder Wind",[-93.82965266972636, 42.180155805445224]],
    [ "Orange & Rockland",[-74.66548375542551, 41.388459187989]],
    [ "Port Jervis Substation",[-74.69535562377867, 41.37853854755294]],
    [ "1259497189",[-84.3641912508065, 33.42919632323671]],
    [ "Frytown Substation",[-91.71408694092528, 41.56871918706345]],
    [ "1259542485",[-94.12664937670469, 41.35937329615027]],
    [ "Mason City MacNider Industrial Substation",[-93.21694153795163, 43.10815575148501]],
    [ "Newhall Substation",[-92.02743620561812, 41.986439573257826]],
    [ "MidAmerican Energy",[-95.25844347514366, 42.652102056427736]],
    [ "Obsidian Substation",[-94.55275657091582, 42.03606681862659]],
    [ "Osceola Yaholi Substation",[-93.78307249982244, 41.03150752830315]],
    [ "Tiffin Crossroads Substation",[-91.68509787549613, 41.7082759412345]],
    [ "Williamsburg West Substation",[-92.06501514141227, 41.67418521135734]],
    [ "Sunflower Wind Farm Substation",[-97.05039631738327, 38.22512171094399]],
    [ "Gilman Substation",[-92.78565338599554, 41.90572841432191]],
    [ "Ferguson Substation",[-92.85850811877245, 41.90453446894509]],
    [ "Marshalltown REC Substation",[-92.8525979773645, 42.02920858866326]],
    [ "Laurel Substation",[-92.91714125, 41.93460765]],
    [ "Springbrook Substation",[-84.18303246262329, 42.907862494635026]],
    [ "Wheelerwood Substation",[-93.3587237814108, 43.24953552489116]],
    [ "Ralston Substation",[-94.64794359988382, 42.045328149984364]],
    [ "1259575216",[-94.64211302579629, 42.048830827117165]],
    [ "Waterville Substation",[-91.2627909857309, 43.23907302982887]],
    [ "Consumers Energy",[-84.14277974485141, 42.97961783104315]],
    [ "Patty Jewett Substation",[-104.79460981735726, 38.85784239862736]],
    [ "1259637380",[-86.98591320430083, 37.737144704153074]],
    [ "1259637391",[-87.01240170264985, 37.75975756077545]],
    [ "1259637398",[-86.9702801360043, 37.86149922827548]],
    [ "Lewisport Substation",[-86.89499066971077, 37.92183759346057]],
    [ "1259682500",[-87.14961850386841, 37.78395977238522]],
    [ "1259682505",[-87.12983613599893, 37.77462126829215]],
    [ "1259682510",[-87.09195516987603, 37.776687164753106]],
    [ "City of Owensboro",[-87.08787990862791, 37.75111819696851]],
    [ "1259725183",[-92.97131041393853, 45.687797221962484]],
    [ "Beaver Dam Substation",[-86.87870920103967, 37.367666111525196]],
    [ "Walker Linn Buchanan Substation",[-91.76116312691828, 42.29788492106798]],
    [ "Prestage Substation",[-93.91890207811701, 42.59081821514133]],
    [ "Midland Power Cooperative",[-94.26225450919678, 42.194937124948375]],
    [ "Adair REC Substation",[-94.60570710145159, 41.56208275007682]],
    [ "Dekalb Substation",[-93.81958352484901, 42.03649881364393]],
    [ "Station 87",[-77.71863386658254, 43.10501672451931]],
    [ "Midland Power Cooperative",[-94.06795902491864, 42.339283057059134]],
    [ "Mid-American Pipeline Substation",[-91.4093946884245, 41.61669862498981]],
    [ "1259779933",[-80.28618818818055, 33.143670710528646]],
    [ "1259791537",[-86.83426221694039, 37.35380094294026]],
    [ "1259791539",[-86.80041199768304, 37.34666426764124]],
    [ "1259791559",[-86.39598554302383, 37.44609528156905]],
    [ "Venice Substation",[-83.93513628905647, 42.98079851663055]],
    [ "Consumers Energy",[-83.97958399377576, 42.98191759914713]],
    [ "Station 51",[-77.54395425690221, 43.22874511114345]],
    [ "1261358986",[-88.05227715, 44.48304835]],
    [ "1261842995",[-86.22628651475496, 37.11074812425895]],
    [ "1261843003",[-86.23336041552666, 37.04540208481166]],
    [ "Park City Substation",[-86.05427302071332, 37.088359962064054]],
    [ "Station 126",[-77.68793328424614, 43.189578116876795]],
    [ "Station 86",[-77.68022402526623, 43.17351639017483]],
    [ "Delair Substation",[-75.05197389621286, 39.980732860677534]],
    [ "Philadelphia Road Substation",[-76.56417049866788, 39.297713277965656]],
    [ "Perryman Generation Substation",[-76.21474767713391, 39.44135693396364]],
    [ "Baltimore Gas and Electric",[-76.17167245892439, 39.489954068881204]],
    [ "Bethesda Substation",[-77.1002787122883, 38.98897816461199]],
    [ "Station 412",[-77.64992906521528, 43.19838737285256]],
    [ "Station 95",[-77.6296539810571, 43.17905106723578]],
    [ "1262402257",[-85.09110727508384, 31.24474400515574]],
    [ "1262402258",[-85.09032508431855, 31.244563082400987]],
    [ "Rankin Substation",[-83.7286510454993, 42.91413973411476]],
    [ "Consumers Energy",[-83.72530923247159, 42.909157663634126]],
    [ "Consumers Energy",[-83.72530312426561, 42.90852363442718]],
    [ "Cheltenham Substation",[-76.827507914197, 38.70189310433794]],
    [ "Lums Pond Substation",[-75.72321591401969, 39.57102041930475]],
    [ "Carter Substation",[-82.05695291538001, 30.057364477423338]],
    [ "Rineyville Substation",[-85.9171073856043, 37.77022316337722]],
    [ "1262943224",[-86.29028696566071, 37.512839277077774]],
    [ "Clarkson Substation",[-86.22519670000001, 37.49219665]],
    [ "1262943230",[-86.05176408173473, 37.58225940542439]],
    [ "Vine Grove Substation",[-85.98074336769402, 37.811045541937695]],
    [ "1262962439",[-86.05135269999998, 37.0235821]],
    [ "1262962450",[-85.95469589632924, 37.001825766974285]],
    [ "Beers Substation",[-83.81527578198568, 42.91446910575302]],
    [ "Station 96",[-77.55361011993325, 43.18865557808346]],
    [ "1263421199",[-85.89040636534135, 37.07432740629944]],
    [ "1263421206",[-85.93268954038898, 36.98983924189054]],
    [ "1263421207",[-85.91620784999999, 37.000147649999995]],
    [ "1263421222",[-85.92457440167492, 36.88651003763768]],
    [ "1263421240",[-85.94666609999159, 37.00949036666381]],
    [ "1263421242",[-85.93987542506429, 37.00624093712385]],
    [ "1263421244",[-85.93620573188635, 37.00369509607199]],
    [ "1263437064",[-85.8984834905135, 36.915989285311994]],
    [ "1263437071",[-86.31055405317775, 37.034845579853986]],
    [ "1263437084",[-86.54164467187105, 36.99572404170071]],
    [ "1263437089",[-86.85112541737819, 36.90025819867258]],
    [ "1263449759",[-86.8915118991578, 36.84864360738289]],
    [ "Tennessee Valley Authority",[-86.90379224621243, 36.85820126957369]],
    [ "1263449788",[-86.43946468566696, 36.891467673961294]],
    [ "1263449795",[-86.56503530736592, 36.788573581813026]],
    [ "Station 55",[-77.50087100521444, 43.19662307154208]],
    [ "Station 92",[-77.52514695842956, 43.218753251639264]],
    [ "Station 18",[-77.64560195362634, 43.15666771489304]],
    [ "Station 39",[-77.62563628215183, 43.22735600422228]],
    [ "Station 45",[-77.42991065682583, 43.20370563305233]],
    [ "Station 76",[-77.52160641251048, 43.09215124767905]],
    [ "High Banks Wind Substation",[-97.5107345235618, 39.85744229940666]],
    [ "High Banks Wind Substation",[-97.44882949773938, 39.78520108083549]],
    [ "Station 88",[-77.5958691452706, 43.24883477904613]],
    [ "Station 91",[-77.54846936255765, 43.11352977023697]],
    [ "DOT West Wharton Substation",[-74.59828373846882, 40.90621840681532]],
    [ "Elm Street Substation",[-74.65753558132641, 40.34150152071802]],
    [ "PSE&G",[-75.17506109830626, 39.822602760195494]],
    [ "PSE&G",[-75.19975900760186, 39.81663911951844]],
    [ "Public Service Enterprise Group",[-74.22792181624794, 40.90605584839022]],
    [ "1263572642",[-89.42987911216, 45.14884552557924]],
    [ "Station 97",[-77.60778500926271, 43.225514953133604]],
    [ "Station 101",[-77.6206332, 43.145539]],
    [ "Station 110",[-77.58611850317769, 43.05995996922485]],
    [ "Station 115",[-77.51010102999881, 42.99692727763574]],
    [ "1263591176",[-102.96938075007013, 39.18516171945778]],
    [ "1263600980",[-101.47960447011782, 36.364360020641136]],
    [ "1263600986",[-101.47669734307703, 36.46787772492946]],
    [ "Station 142",[-77.24769147215648, 42.88733795511551]],
    [ "Station 145",[-77.42728248625039, 42.89139518501876]],
    [ "Station 146",[-77.40329803777449, 42.756046627956096]],
    [ "Tri-County Tennessee Gas Substation",[-77.99998780188795, 41.8517033285273]],
    [ "Station 149",[-77.34980313298381, 42.96480746916229]],
    [ "1263610594",[-111.61076678670747, 33.35670332502367]],
    [ "1263612310",[-88.72621326544808, 41.886333799731915]],
    [ "Meta",[-88.72664168420995, 41.88733905009165]],
    [ "1263735671",[-90.35703325, 44.68718285]],
    [ "1263935763",[-90.50636010000001, 44.73445395]],
    [ "1263935772",[-90.23843715, 44.80022949999999]],
    [ "1263935774",[-90.2777070751878, 44.87298470790255]],
    [ "1263938178",[-91.20862505, 44.322151799999986]],
    [ "1263942432",[-90.0540787374185, 42.71129882493104]],
    [ "New Washington Substation",[-74.14804610415604, 40.80500779338745]],
    [ "1263945737",[-90.5368819887752, 43.03358112542618]],
    [ "1263945738",[-90.62547766177208, 42.97320292506704]],
    [ "1263952138",[-90.65873468747742, 44.91556056950825]],
    [ "1263954883",[-90.78306534999999, 45.256143]],
    [ "1263960827",[-86.33323775926722, 32.37964827517756]],
    [ "1264200824",[-120.92220938759479, 36.940441375177315]],
    [ "1264342140",[-92.19516977481281, 44.540151343794484]],
    [ "1264343761",[-91.2081854601895, 45.004539474839774]],
    [ "1264343765",[-91.04550501230023, 45.031413374910606]],
    [ "1264355158",[-92.23886466252095, 46.01945607650512]],
    [ "1264355161",[-92.31153403001379, 46.01271072271715]],
    [ "Cassell Junction Co-op Substation",[-81.66121802383607, 40.015278857107454]],
    [ "1264497365",[-91.12875275745718, 44.35413893139351]],
    [ "1264659993",[-92.59009099999999, 45.64231009999999]],
    [ "1264664809",[-91.65116188371515, 44.900084275002015]],
    [ "1264664810",[-91.5042378251964, 44.94467894434602]],
    [ "1264670616",[-91.1351976276375, 43.064226054404934]],
    [ "1264671488",[-90.95511810963015, 43.288835054355026]],
    [ "1264676564",[-91.954121, 44.45162295000001]],
    [ "1264676570",[-92.00957264131087, 44.50551627503234]],
    [ "1264680484",[-92.53610545000001, 45.946871449999996]],
    [ "1264684043",[-120.89729701667879, 44.30692286049342]],
    [ "1264694006",[-74.22847977209683, 40.89179007685539]],
    [ "1264749512",[-103.09309929912385, 32.71178115413201]],
    [ "1264749536",[-103.14895549710194, 32.67734492138336]],
    [ "1264749539",[-103.16078505028429, 32.6791134171218]],
    [ "1264774265",[-94.76495635, 42.16622259999999]],
    [ "1264801324",[-94.47535937559108, 42.123499306308645]],
    [ "1264815095",[-94.2411722, 41.891745650000004]],
    [ "Alliant Energy",[-94.24739469234646, 42.167677524789184]],
    [ "Mazie Substation",[-82.97250570614156, 38.02654812088738]],
    [ "Elliott Co Prison Substation",[-83.07438568667027, 38.13580136799801]],
    [ "Radcliff Substation",[-85.94603313968594, 37.84645542356127]],
    [ "Smithersville #1&2 Substation",[-85.90427635345849, 37.75268067784114]],
    [ "Rineyville Substation",[-86.01381297505094, 37.77411994294122]],
    [ "Radcliff Substation",[-85.97149862852856, 37.83446134639614]],
    [ "Denny Substation",[-84.6584502580143, 36.81267592034835]],
    [ "1265012588",[-84.65906701287703, 36.81265998217631]],
    [ "Denny Substation",[-84.65919795035549, 36.8123776332686]],
    [ "1265017572",[-93.04106025, 45.1968922]],
    [ "1265018759",[-93.26027103454761, 45.486031726217426]],
    [ "1265018760",[-93.2245158252933, 45.443628691515464]],
    [ "Fortieth Street Substation",[-74.13754800087699, 40.904725267158824]],
    [ "1265112963",[-93.09927519999998, 45.3742593]],
    [ "1265112966",[-93.22469122477001, 45.39899704387321]],
    [ "1265112969",[-93.24677368694803, 45.31916756170153]],
    [ "Arkwright 115 kV Substation",[-79.2980280872804, 42.28640614445257]],
    [ "Bay City Electric Light & Power",[-83.90888314646025, 43.66247561305156]],
    [ "Rosemore Substation",[-121.04309999782858, 37.64244243063165]],
    [ "1265283829",[-86.45704549999999, 36.94307005]],
    [ "1265283834",[-86.39923295452883, 36.9771173835426]],
    [ "1265283845",[-86.49370599999999, 36.9549797]],
    [ "1265283846",[-86.48842680514585, 36.94764298190014]],
    [ "1265309765",[-86.35695289605657, 36.879593487040644]],
    [ "Penn Mar Substation",[-79.31737698683196, 39.74310445210184]],
    [ "North Washington Substation",[-79.59091887354934, 40.5503528230219]],
    [ "Kiski Valley Substation",[-79.62957121461733, 40.62978417543626]],
    [ "1265330044",[-120.86621559688167, 44.282862399932874]],
    [ "1265343220",[-93.23337095, 45.2411797]],
    [ "1265343225",[-93.2361909370999, 45.288368119286176]],
    [ "1265343231",[-93.34115828475063, 45.28474517472424]],
    [ "Energy Park Substation",[-93.43974654999998, 45.2306238]],
    [ "1265390873",[-93.5026233, 45.24846475000001]],
    [ "1265391212",[-91.52531679776091, 44.795387183349085]],
    [ "1265393215",[-91.47095531870714, 44.74958840002498]],
    [ "1265396511",[-77.24347115267096, 37.48183318435332]],
    [ "1265500841",[-91.37232867504534, 44.78860349207111]],
    [ "69 kV switchgear",[-74.01613782613514, 40.83456780512288]],
    [ "1265620261",[-77.134626, 42.9558136]],
    [ "Station 428",[-77.29941430442868, 42.901327464340866]],
    [ "1265632793",[-91.77624660000001, 44.69858245]],
    [ "1265635402",[-91.74300806626856, 45.48764186436212]],
    [ "1265635403",[-91.74239724496819, 45.487584159868966]],
    [ "1265638401",[-91.68474742515568, 45.40765235565279]],
    [ "1265638403",[-91.62417376632973, 45.40781911695753]],
    [ "1265638406",[-91.58129814999998, 45.3205485]],
    [ "1265638410",[-91.60790061529072, 45.25711346782876]],
    [ "1265662818",[-91.84038167510566, 45.40245655970521]],
    [ "1265662820",[-91.84627871223807, 45.40227799454194]],
    [ "1265662821",[-91.76654696244898, 45.304542069808036]],
    [ "Angus Substation",[-91.60609280000001, 45.63788514999999]],
    [ "1265684009",[-91.86735225, 45.5678753]],
    [ "1265684012",[-91.87021641873284, 45.69665238640016]],
    [ "1265684016",[-92.05237997714407, 45.53013882507664]],
    [ "1265684020",[-92.05308770233896, 45.40827624926149]],
    [ "1265689501",[-92.1443382493941, 45.38585778149169]],
    [ "1265689503",[-92.14154333475715, 45.39069372517389]],
    [ "1265689507",[-92.17591161679998, 45.33848895684566]],
    [ "1265689510",[-92.27833186252968, 45.251755819363176]],
    [ "1265700390",[-119.77296452491662, 39.56480389349088]],
    [ "1265797473",[-91.57044959231398, 44.65464054924345]],
    [ "1265797474",[-91.45215804999998, 44.683757250000006]],
    [ "1265797477",[-91.45170636110913, 44.66998643011697]],
    [ "1265800278",[-91.94485904999999, 46.173256699999996]],
    [ "1265800281",[-92.1539066168166, 46.21763916651217]],
    [ "1265811557",[-77.28076225000002, 42.84524455000002]],
    [ "1265823027",[-93.90290945000001, 41.820368450000004]],
    [ "Station 777",[-77.29857839999998, 42.906017999999996]],
    [ "1265930090",[-109.9187062709709, 31.391116472469214]],
    [ "1265930158",[-109.76290963417723, 32.02121106743646]],
    [ "Chiricahua Substation",[-109.69479163651857, 31.88411443467579]],
    [ "1265930171",[-109.6993939, 31.371495950000003]],
    [ "McNeal Substation",[-109.69796462496558, 31.52604050945463]],
    [ "McNeal Substation",[-109.69842990709145, 31.52640493448042]],
    [ "1265930182",[-109.69866926619453, 31.55355848069708]],
    [ "1265930183",[-109.89268433120576, 32.06230790478209]],
    [ "1265932559",[-90.70803664999998, 43.1360468]],
    [ "Station 179",[-78.15199684743277, 42.425303016326346]],
    [ "69 kV Switchgear",[-74.06958602715635, 40.898826297234216]],
    [ "Vienna Substation",[-83.84833286244256, 43.176248287682455]],
    [ "1266010221",[-122.3193117, 37.5648812]],
    [ "Ingram Creeek Substation",[-121.25933627295228, 37.53232176760158]],
    [ "1266301199",[-92.97166415669514, 45.80538641521142]],
    [ "1266317162",[-120.27393962114405, 37.18500156571714]],
    [ "1266332240",[-75.77034976466354, 41.73563425250854]],
    [ "1266335517",[-92.74219532478642, 46.12899784592505]],
    [ "1266335521",[-92.99161092553973, 46.04682595661691]],
    [ "1266335524",[-92.9491394931608, 46.19673487884937]],
    [ "1266335528",[-92.94638707494467, 46.31825124613919]],
    [ "City of Moose Lake",[-92.75621703891255, 46.43591127955918]],
    [ "1266335537",[-92.76009297489237, 46.45426284583695]],
    [ "1266335538",[-92.71966038764968, 46.417728337579995]],
    [ "1266341045",[-93.73374269011774, 46.40519412060323]],
    [ "1266341048",[-93.7306682251604, 46.431748359531944]],
    [ "1266341049",[-93.49294969999998, 46.23370075]],
    [ "1266341762",[-109.47582009999998, 32.332321549999996]],
    [ "1266341777",[-109.89260196229178, 32.3407978458087]],
    [ "1266341800",[-110.12985795000002, 31.777466750000002]],
    [ "1266346739",[-93.17257128689084, 45.73001647505621]],
    [ "1266346745",[-93.28749149000578, 45.90399962969735]],
    [ "65 Substation",[-93.28750179900923, 45.87752144690558]],
    [ "Power Plant Substation",[-93.29490625000001, 45.8770972]],
    [ "1266346753",[-93.41062383207414, 45.83127312829439]],
    [ "1266485406",[-92.9794844393264, 45.51076291592019]],
    [ "1266488261",[-93.50138903865155, 45.37765649421126]],
    [ "1266488264",[-93.44589987497213, 45.44189061186593]],
    [ "1266488268",[-93.36635041698611, 45.39759127683094]],
    [ "1266497391",[-93.59279244999999, 45.55377969999999]],
    [ "1266497393",[-93.58816200545603, 45.565159155154824]],
    [ "1266497396",[-93.5874697, 45.56911974999999]],
    [ "1266497398",[-93.59174981672261, 45.51994439759187]],
    [ "1266500272",[-93.89292666284041, 45.48716262506383]],
    [ "1266500275",[-93.98860444999998, 45.3698455]],
    [ "1266586949",[-121.31729853978885, 37.786261935690014]],
    [ "Schulte Switching Station",[-121.48996518880129, 37.71039381844732]],
    [ "1266661319",[-93.7703776569027, 46.18411990884469]],
    [ "1266664536",[-93.91627046698245, 46.2164123663496]],
    [ "1266664994",[-93.65825849487875, 46.06985151161391]],
    [ "1266665393",[-93.945234157772, 45.780455829275716]],
    [ "1266742955",[-82.70737779948226, 29.723534581706982]],
    [ "Bell Ridge Solar, LLC",[-82.70906037476969, 29.72373200388294]],
    [ "1266920903",[-122.59659491211931, 48.307530569570815]],
    [ "Castile Municipal Electric Substation",[-78.06298818542446, 42.62687823171572]],
    [ "Station 184",[-77.98809173128598, 42.57681689482799]],
    [ "1266968859",[-95.4287508255175, 29.228165595711374]],
    [ "Station 182",[-77.91505650494712, 42.676025015626074]],
    [ "Livingston Correctional Station",[-77.8275357525912, 42.68319836287701]],
    [ "1267280545",[-119.7029043631736, 37.72164244245285]],
    [ "Field Road Substation",[-83.7649955190367, 43.18508858742979]],
    [ "Croswell Substation",[-84.59540595, 43.4152828]],
    [ "Groveland Station",[-77.76603027106056, 42.663760935946286]],
    [ "Conesus Lake Station",[-77.71284462803527, 42.714284004114035]],
    [ "Lakeville Station",[-77.71559311211243, 42.83436832748376]],
    [ "Geneseo Station",[-77.7530703855417, 42.79043352516605]],
    [ "Livonia Station",[-77.67026329204103, 42.82064552107987]],
    [ "Hemlock Station",[-77.60863274782676, 42.79403937512398]],
    [ "Richmond Station",[-77.53297989901775, 42.78980328527657]],
    [ "Otisville Substation",[-83.53437502680559, 43.16415481872307]],
    [ "Henderson Pumping Substation",[-83.4825808, 43.0598286]],
    [ "Kraft Foods",[-77.75442054338048, 42.90682975346433]],
    [ "1267688734",[-93.82386357532032, 45.69893665481382]],
    [ "1267688745",[-93.99729643608005, 45.69763431144521]],
    [ "1267688749",[-94.13279122480837, 45.68365245569029]],
    [ "1267700815",[-93.72934595154983, 45.281011895345046]],
    [ "1267725147",[-87.3385615619953, 33.17057037557644]],
    [ "National Grid",[-77.6135109126993, 42.9056077400897]],
    [ "1267758067",[-95.07965298144181, 45.80237848603294]],
    [ "Caledonia Station",[-77.85715206738342, 42.98983674836206]],
    [ "1267790483",[-96.24688883904663, 45.065298686563324]],
    [ "1267790489",[-96.19406210000001, 45.010049550000005]],
    [ "1267790492",[-96.39386965, 45.1539601]],
    [ "1267790494",[-96.35310369999999, 44.90641055]],
    [ "1267790506",[-96.5618765, 44.847951349999995]],
    [ "1267822965",[-98.55643876573781, 45.46769282315946]],
    [ "1267822968",[-98.7855107670035, 45.504224344832664]],
    [ "1267822978",[-98.78634488854182, 45.53188327487037]],
    [ "1267822979",[-98.57709587499856, 45.532051108297374]],
    [ "1267899812",[-94.88451474837994, 44.53708890594461]],
    [ "1267899828",[-94.41216815000001, 44.4416242]],
    [ "1267899831",[-94.39272360000001, 44.44178620000001]],
    [ "1267899841",[-94.33293135129743, 44.542411226250216]],
    [ "1267928474",[-92.13963862474205, 38.32774340607541]],
    [ "Avon Station",[-77.73698935655364, 42.90948211959287]],
    [ "1268060097",[-110.47887035, 33.30298505]],
    [ "1268060116",[-109.11294536379162, 32.70968747493608]],
    [ "1268060146",[-109.83913531199481, 32.875199924715766]],
    [ "1268060153",[-109.77595412511839, 32.85196820675337]],
    [ "1268060154",[-109.75301329999998, 32.88359945]],
    [ "1268060157",[-109.6601300833845, 32.904997700224804]],
    [ "1268060159",[-109.6080241155738, 32.94855073170994]],
    [ "1268060161",[-109.60645774576133, 32.92834831928483]],
    [ "1268060164",[-109.59745860000001, 32.94375525]],
    [ "1268060176",[-109.63329225000001, 32.91886975]],
    [ "1268060177",[-109.66902696254505, 32.96632067946422]],
    [ "1268060187",[-109.68326646161101, 32.95066531507261]],
    [ "1268060194",[-109.69869387496884, 32.960561294393344]],
    [ "1268060201",[-109.70473685712906, 32.930297920273965]],
    [ "1268060208",[-109.70945858175583, 32.927782134354814]],
    [ "1268060218",[-109.70150885, 32.93192754999999]],
    [ "Reeds Gap Switching Station",[-77.62281469511868, 40.44244752955768]],
    [ "Reeds Gap Substation",[-77.6112765526336, 40.43553538778781]],
    [ "Hill Valley Substation",[-77.8918674232547, 40.36880278545664]],
    [ "Ralphton Substation",[-79.03527446194495, 40.12021530943216]],
    [ "Trade City Switching Station",[-79.11266499216174, 40.87137520121362]],
    [ "Nocatee Substation JEA",[-81.47860792157897, 30.108076310312892]],
    [ "Virgil Substation",[-98.33662781636828, 44.29847712493336]],
    [ "Huron Substation",[-98.33708627474128, 44.399926345705126]],
    [ "Cavour Substation",[-98.03450947096209, 44.29659682487904]],
    [ "Yale Substation",[-98.0530754570453, 44.54454577519498]],
    [ "East River Electric Power Cooperative",[-98.65962815549821, 44.35597392489885]],
    [ "East River Electric Power Cooperative",[-98.98872997535574, 44.780090003105926]],
    [ "East River Electric Power Cooperative",[-97.63294212209748, 44.427228075074254]],
    [ "1268248620",[-97.39166037493837, 44.397836459421335]],
    [ "1268248621",[-97.39132140767889, 44.3978338750913]],
    [ "1268264324",[-96.90928152497376, 44.15344531052493]],
    [ "1268264332",[-96.72834701128794, 44.007593681177134]],
    [ "1268264336",[-96.54870502489257, 44.15338420843466]],
    [ "1268264341",[-96.50812540000001, 44.2964407]],
    [ "1268264342",[-96.81975306499662, 43.983391701402574]],
    [ "1268264343",[-96.95504524885985, 43.97641832904425]],
    [ "1268264344",[-97.06765047849348, 44.035596391831234]],
    [ "1268492255",[-96.86857795766448, 44.47138707471275]],
    [ "1268505658",[-96.90734781612207, 44.32275352476301]],
    [ "1268505661",[-96.96963292524198, 44.35506334175313]],
    [ "1268505666",[-97.13437153109967, 44.366556263630606]],
    [ "1268505671",[-97.11905860840523, 44.50047204145748]],
    [ "1268505679",[-96.9035202, 44.57445224999999]],
    [ "Ottertail Power Co",[-97.21607739266918, 44.578481924747365]],
    [ "1268524987",[-96.94659495640963, 44.6599884748602]],
    [ "1268545704",[-110.98237503849124, 33.15877099110257]],
    [ "East River Electric Power Cooperative",[-97.91652465, 44.8046937]],
    [ "East River Electric Power Cooperative",[-98.15972550000001, 44.74781875]],
    [ "East River Electric Power Cooperative",[-98.40180290000002, 44.86482995]],
    [ "1268550070",[-98.14926720716254, 44.89398397539561]],
    [ "Tulare Substation",[-98.58412042521307, 44.73546903972012]],
    [ "1268552360",[-97.39252155, 44.89147884999999]],
    [ "1268552361",[-97.65633221647083, 44.899282124706616]],
    [ "1268552364",[-97.47197894999998, 44.89094709999999]],
    [ "1268552367",[-97.53507316142525, 44.89119052510861]],
    [ "1268552370",[-97.73918872495203, 44.90585610813608]],
    [ "1268597808",[-102.8014422, 33.02284434999999]],
    [ "1268609263",[-102.82872583707393, 33.02650127504331]],
    [ "1268631490",[-98.10556624632231, 44.893293095944976]],
    [ "1268631492",[-98.3016323846319, 44.8943171822167]],
    [ "1268854259",[-98.3303865, 45.05475965]],
    [ "1268854265",[-98.17563325, 45.3271826]],
    [ "1268854279",[-98.59799831606465, 45.3011843672235]],
    [ "1268875786",[-98.7871004, 45.4456484]],
    [ "1268921201",[-99.00805304999999, 45.46266179999999]],
    [ "1268921203",[-98.98834298281457, 45.46237632517544]],
    [ "1268921205",[-99.02109168426637, 45.15717617504483]],
    [ "1268921208",[-99.3090411, 45.04274315]],
    [ "1268921209",[-98.84267041757427, 45.5632108343115]],
    [ "1268921214",[-98.88952283706143, 45.78013342517945]],
    [ "1268921216",[-98.59992550000001, 45.7941725]],
    [ "1268921218",[-98.43005879882895, 45.79340358429613]],
    [ "Pacetti Substation FPL",[-81.45253887902501, 29.98000425364216]],
    [ "1269038421",[-97.07014775738767, 43.98054737503875]],
    [ "1269038423",[-97.09909429627112, 43.993722917216544]],
    [ "1269038427",[-96.9283181748535, 43.90590529664275]],
    [ "1269038429",[-96.94057814156194, 43.78987177508324]],
    [ "Leicester Station",[-77.90079994999999, 42.76698705]],
    [ "Stanton Ave",[-77.99194616190613, 42.72311851120435]],
    [ "1269255087",[-96.67185652497749, 43.74003354104527]],
    [ "1269255091",[-96.81078142514816, 43.71056760479097]],
    [ "1269255093",[-96.93118189434827, 43.7107106213712]],
    [ "1269258768",[-97.11013185, 44.0179986]],
    [ "1269258772",[-97.13107396681485, 44.05060397513145]],
    [ "1269306980",[-91.07439330269933, 39.614186065959665]],
    [ "1269310071",[-90.60620887013472, 39.02265836720233]],
    [ "1270045246",[-110.24571664999999, 48.43720174999999]],
    [ "1270045302",[-110.08446436113442, 48.55252442482547]],
    [ "1270047849",[-97.24033977538377, 44.25425378955655]],
    [ "South Wadley Substation",[-82.4075909798225, 32.85755546481721]],
    [ "1270246683",[-97.18868055, 43.9347414]],
    [ "1270247161",[-97.4712995559514, 44.065827674800126]],
    [ "1270247162",[-97.5307931, 44.02228967118936]],
    [ "1270251064",[-119.97525401623997, 40.077443491374176]],
    [ "East River Electric Power Cooperative",[-97.70683320000002, 43.69479955000001]],
    [ "Plano Substation",[-97.90812232495777, 43.80399560866177]],
    [ "East River Electric Power Cooperative",[-98.01624961689375, 43.659036116421106]],
    [ "Plankinton Substation",[-98.52651715, 43.70196765]],
    [ "East River Electric Power Cooperative",[-98.71430417988391, 43.60016542490284]],
    [ "East River Electric Power Cooperative",[-98.92347899088, 43.41315412512875]],
    [ "Chamberlain Substation",[-99.3110657, 43.687395349999996]],
    [ "Pukwana Substation",[-99.15288229999999, 43.743946650000005]],
    [ "Kimball Substation",[-98.8562707750205, 43.75439139182352]],
    [ "White Lake Substation",[-98.71500742555453, 43.724480609298226]],
    [ "Plankinton Substation",[-98.42498518032448, 43.70194534999409]],
    [ "1270284471",[-114.76423567504617, 36.4640460455586]],
    [ "East River Electric Power Cooperative",[-98.91948144176281, 43.297755124845786]],
    [ "Letcher Substation",[-98.15263792500153, 43.865245891643646]],
    [ "Spencer Substation",[-97.58826679305322, 43.715851875034495]],
    [ "Montrose Substation",[-97.1887510056733, 43.70295507487105]],
    [ "Sand Creek Substation",[-98.15190782510255, 44.08321975692206]],
    [ "East River Electric Power Cooperative",[-98.551754, 44.0523854]],
    [ "1270292176",[-98.57189127474743, 44.09015434506405]],
    [ "1270295340",[-97.79045135310201, 43.966351043812054]],
    [ "1270329973",[-90.97313210745602, 39.69740637497299]],
    [ "1270329976",[-90.97302553724334, 39.71991252417311]],
    [ "Wagner Substation",[-98.34811885, 43.11127455]],
    [ "East River Electric Power Cooperative",[-97.89160346512116, 43.003223425198414]],
    [ "Springfield Substation",[-97.89231225, 42.875773149999986]],
    [ "1270368647",[-91.0468220613099, 39.730715620241405]],
    [ "1270413339",[-97.7971272558721, 45.067226967991644]],
    [ "1270432647",[-91.04137730334186, 39.7008481276542]],
    [ "1270441267",[-107.62948785, 36.86375675]],
    [ "Warsaw Station",[-78.13016869419151, 42.73315632498921]],
    [ "Commodore Substation",[-89.34951646788653, 38.115254999300156]],
    [ "1270538239",[-91.58041020005064, 39.48132806740629]],
    [ "1270541455",[-116.57193124999998, 33.93113974999999]],
    [ "1270613031",[-84.46463247834613, 36.716881111053866]],
    [ "1270613032",[-84.46468696189807, 36.71740357372995]],
    [ "1270613051",[-84.4601399401684, 36.67678912062163]],
    [ "Styx Substation",[-84.64147796486476, 43.20977018936889]],
    [ "Consumers Energy",[-84.64257661664068, 43.209736450483796]],
    [ "1270899176",[-85.11439951924613, 37.05619339540059]],
    [ "1270899179",[-84.62501778651507, 37.05055527996716]],
    [ "1270899180",[-84.59437388319841, 36.98518636365556]],
    [ "1270899182",[-84.59662286739183, 37.05181439673576]],
    [ "1270899184",[-84.63210687081676, 37.13080110922024]],
    [ "1270899186",[-84.58734109999999, 37.138261099999994]],
    [ "1270899204",[-84.6282864787334, 37.021506852497936]],
    [ "1270921050",[-80.66310081687641, 33.91574235002562]],
    [ "Eastover Solar, LLC",[-80.66218810468509, 33.915574838094756]],
    [ "1270927166",[-79.09579975, 33.7220212]],
    [ "1270976650",[-89.3940609331825, 31.226567333484738]],
    [ "Cubico USA, LLC",[-90.05679202488633, 33.51802675858113]],
    [ "Entergy Mississippi",[-90.05693910000001, 33.51718265]],
    [ "Station 8301",[-78.09038784939217, 42.54167782326537]],
    [ "Station 170",[-78.08286845, 42.50391715]],
    [ "1271035394",[-78.06540649999998, 42.5045766]],
    [ "1271035395",[-78.0679677996334, 42.50193178316319]],
    [ "Station 171",[-78.11054925000002, 42.465741550000004]],
    [ "Consumers Energy",[-83.91638112605312, 43.92150663367929]],
    [ "Duquite Substation",[-83.94488450685384, 43.97582263506365]],
    [ "Station 247",[-78.23950563601406, 42.38820802494489]],
    [ "1271218709",[-85.3389288657579, 37.06432607619742]],
    [ "1271218726",[-85.27659245572735, 37.10764516384996]],
    [ "1271218728",[-85.32531676752313, 37.19757054404261]],
    [ "1271218730",[-85.05825674999998, 37.10719879999999]],
    [ "1271218732",[-84.99054391131526, 37.072219025583635]],
    [ "1271218747",[-85.04609227731888, 37.26801321399455]],
    [ "Station 216",[-77.08005233633826, 43.240858176012296]],
    [ "Station 195",[-77.02359522511068, 43.22296801473276]],
    [ "Station 175",[-78.12095282506812, 42.34033084421434]],
    [ "Avista",[-116.85020664165684, 47.73657196069299]],
    [ "Howland Road Substation",[-121.27653252350116, 37.80878244513837]],
    [ "Pacific Gas and Electric Company",[-121.28894761787765, 37.94711828981508]],
    [ "Station 8327",[-78.07573775, 42.29581769999999]],
    [ "Village of Angelica",[-78.024037387463, 42.30377788603822]],
    [ "1271302023",[-78.01299006344914, 42.28610767839924]],
    [ "Rochester Gas & Electric",[-78.05933098432428, 42.25507054715064]],
    [ "Station 176",[-78.04096115475524, 42.22339350571486]],
    [ "Station 174",[-78.138004974844, 42.209625742923855]],
    [ "Station 173",[-78.17222254080706, 42.06423549017069]],
    [ "Thomas Substation",[-84.1164584593529, 43.430950961031016]],
    [ "Kochville Substation",[-83.98387969571979, 43.50834798471082]],
    [ "Riverbank Switching Station",[-120.91225272620414, 37.85642767562848]],
    [ "Kifer Receiving Station",[-121.95106374672191, 37.37611934086072]],
    [ "1272209778",[-84.05036985000001, 36.964149899999995]],
    [ "1272212207",[-84.19368593408069, 37.46695414650822]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.15111169180958, 37.33035183998669]],
    [ "East Kentucky Power Cooperative, Inc.",[-84.95374131694503, 37.47104206207504]],
    [ "Mount Olive Substation",[-84.76764556598212, 37.28009613300429]],
    [ "East Kentucky Power Cooperative, Inc.",[-84.62200290918163, 37.52431998725162]],
    [ "East Kentucky Power Cooperative, Inc.",[-84.57503106942008, 37.59397850574916]],
    [ "SR Turkey Creek, LLC",[-84.57518624409805, 37.59348787879454]],
    [ "1272429593",[-90.81112410341659, 43.745251760388406]],
    [ "1272429596",[-90.85548945000001, 43.76643419999999]],
    [ "1272429597",[-90.80543207499029, 43.732380044014626]],
    [ "1272429600",[-90.76984874275422, 43.740444472355286]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.52913125, 37.18566425]],
    [ "Summersville Substation",[-85.53692010000002, 37.33078675]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.28879653144637, 37.654484141562484]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.17488095011457, 37.747722643783725]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.17476315372551, 37.748063774406226]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.24232827044449, 37.5933341056873]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.24708261554566, 37.57286201779815]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.24710380966798, 37.56534251747971]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.33182456699117, 37.346810498551264]],
    [ "1272432567",[-85.31787477719305, 37.33547336475968]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.35058719999999, 37.34060935]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.36062001989347, 37.37546140674483]],
    [ "Knight Substation",[-83.79961219631741, 43.58559132624213]],
    [ "1272434280",[-90.59893342624581, 43.10008969345254]],
    [ "McGraw Substation",[-83.88244951610818, 43.55680895206725]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.71486778488584, 37.58056789392303]],
    [ "1272501780",[-85.86204437784303, 37.592120009830374]],
    [ "Vertrees Substation",[-86.12813880855603, 37.689170715763744]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.9004059162263, 37.69447691700564]],
    [ "Younger Creek Substation",[-85.72068641959302, 37.7578985898494]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.95123668520394, 37.80815490500322]],
    [ "1272510730",[-88.76219375, 38.0291357]],
    [ "1272510733",[-88.76800205555904, 38.02912047474492]],
    [ "1272518196",[-85.71351495, 38.0382306]],
    [ "1272518198",[-85.71110211504174, 38.04963977454117]],
    [ "1272518202",[-85.72747760950061, 37.994742119485224]],
    [ "1272576703",[-89.52548839762105, 37.47926758239135]],
    [ "1272576706",[-89.50834453595256, 37.48719871742555]],
    [ "Hockessin Substation",[-75.68897575775893, 39.79010863506378]],
    [ "Fredericktown Substation",[-90.28733954875119, 37.58396144100273]],
    [ "1272825887",[-83.89926265107601, 36.926032473121765]],
    [ "Riverbank Substation",[-120.90782324846765, 37.76916594088781]],
    [ "1273360484",[-86.4287826073696, 37.759872364591416]],
    [ "1273360485",[-86.0733816005754, 37.84252661677086]],
    [ "1273403479",[-85.82879282030596, 37.35651076768507]],
    [ "1273403487",[-85.62990168690621, 37.737795219298405]],
    [ "1273403488",[-85.65978875, 37.775840349999996]],
    [ "1273403490",[-85.71651102334954, 37.86374772848263]],
    [ "1273403494",[-85.87780149113892, 37.68265887540287]],
    [ "1273403496",[-85.84911088744623, 37.70339369265055]],
    [ "1273403498",[-85.7471379433818, 37.57279157732115]],
    [ "1273555481",[-83.84800089999999, 36.737172900000004]],
    [ "1273559624",[-122.09332393439564, 37.317839078501876]],
    [ "1273559628",[-122.0916279820598, 37.31637439801236]],
    [ "1273559631",[-122.0927437449099, 37.315208885157006]],
    [ "Soledad Substation",[-121.33268803984357, 36.43004996743821]],
    [ "1273559839",[-121.67932235577386, 36.690257623701456]],
    [ "Orange River No.3 Substation",[-81.59603555472725, 26.31835758718158]],
    [ "Golden Gate Substation",[-81.68954439740224, 26.20392892607666]],
    [ "1273822157",[-83.78351425, 36.840554100000006]],
    [ "1273954631",[-84.11346638209582, 40.535059296142485]],
    [ "Avon Substation",[-97.99917372500153, 43.08181780746442]],
    [ "East River Electric Power Cooperative",[-97.0829688, 43.4168858]],
    [ "East River Electric Power Cooperative",[-97.13988730000001, 43.4006287]],
    [ "1274206834",[-96.9443020910465, 43.51529855939628]],
    [ "Dolton Substation",[-97.41830140000002, 43.500192]],
    [ "East River Electric Power Cooperative",[-97.24110169193574, 43.401647274874726]],
    [ "Hurley Substation",[-97.073130258455, 43.285731525041236]],
    [ "Viborg Substation",[-97.08116793913707, 43.19974156607454]],
    [ "East River Electric Power Cooperative",[-97.70651291667447, 43.572086375114594]],
    [ "Turkey Ridge Substation",[-97.3395615251687, 43.28539460913097]],
    [ "East River Electric Power Cooperative",[-97.49989255, 43.298901]],
    [ "Tripp Substation",[-97.79623961406185, 43.29934248910903]],
    [ "1274240080",[-97.49525631454149, 42.973118631557334]],
    [ "East River Electric Power Cooperative",[-97.4759282367893, 42.94491257502711]],
    [ "NAPA Junction",[-97.47588907333571, 42.94088519982163]],
    [ "Airport Substation",[-122.31584422346918, 40.51934810327587]],
    [ "Shasta Substation",[-122.42119251046451, 40.71510922125714]],
    [ "Tabor Substation",[-97.67518262905983, 42.951239725003006]],
    [ "East River Electric Power Cooperative",[-97.63454412493503, 42.89825371021508]],
    [ "Gavins Point Substation",[-97.4863651, 42.87639740000001]],
    [ "Utica Substation",[-97.49818119999999, 43.081708250000005]],
    [ "Irene Substation",[-97.13134256587495, 43.08375366746715]],
    [ "Volin Substation",[-97.14058319914953, 42.96802577367681]],
    [ "Meckling Substation",[-97.04292580809484, 42.852209074905815]],
    [ "East River Electric Power Cooperative",[-96.86569183351699, 42.90956697500218]],
    [ "East River Electric Power Cooperative",[-96.62620020000001, 42.63387195]],
    [ "Jefferson Substation",[-96.5660516341723, 42.56980842502763]],
    [ "1274403566",[-96.96725634147451, 43.119499575156446]],
    [ "East River Electric Power Cooperative",[-96.84478965, 43.171202050000005]],
    [ "East River Electric Power Cooperative",[-96.82605471337833, 43.08418233546906]],
    [ "East River Electric Power Cooperative",[-96.60749634999999, 42.981933950000005]],
    [ "Union Creek Substation",[-96.70642472494127, 42.87008114589002]],
    [ "1274407295",[-96.56051602456446, 42.82837592983838]],
    [ "1274408015",[-96.89560312491425, 43.35932044609639]],
    [ "Alcester Substation",[-96.6089876251292, 43.08411704572746]],
    [ "1274482083",[-121.94195527691647, 37.432688955679694]],
    [ "1274488654",[-101.33043131000359, 48.190020020314044]],
    [ "1274520172",[-121.95725367232907, 37.385277328193325]],
    [ "1274609358",[-94.03804011493924, 31.95940053255507]],
    [ "1274610531",[-94.12916903472266, 31.5761789969678]],
    [ "1274612504",[-86.7889582728362, 33.44739519768437]],
    [ "1274635452",[-89.40339745411079, 35.417158134516164]],
    [ "MidAmerican Energy",[-93.91706534152135, 41.571690458929424]],
    [ "ITC",[-92.32583291397987, 43.14002649200999]],
    [ "Arsenel Substation",[-83.0394343, 42.501878]],
    [ "1274695690",[-122.12493053199861, 37.41047216387865]],
    [ "1274744584",[-77.38206346512193, 43.081417832753615]],
    [ "1274744585",[-77.38167020901751, 43.081301525452346]],
    [ "Evergy",[-96.37043652508375, 39.82460368501919]],
    [ "1274779096",[-121.94593943405465, 38.0309295539758]],
    [ "1274779114",[-121.78633144027593, 38.0128480726609]],
    [ "1275089825",[-77.22251235645173, 43.06845412827643]],
    [ "1275089826",[-77.22475560000001, 43.06979755000001]],
    [ "1275138717",[-75.95751083658718, 39.17723578504944]],
    [ "1275220793",[-119.33599421470657, 46.34202287483037]],
    [ "Weaverville Substation",[-122.92486251260695, 40.702281826803556]],
    [ "1275887055",[-119.45259165981155, 36.615375863730286]],
    [ "1275887089",[-119.37615542613842, 36.60458006975449]],
    [ "1275887092",[-119.5192076211516, 37.25383504350095]],
    [ "1275887096",[-119.49746822334922, 37.20346147021117]],
    [ "1275887100",[-119.49686718501451, 37.20357092113399]],
    [ "1275887102",[-119.5045134929648, 37.15129775494375]],
    [ "1275887109",[-119.39334249395192, 36.77060272475184]],
    [ "1275887138",[-119.67726580091133, 36.75885896732931]],
    [ "1275887163",[-119.868183956778, 36.811967330527]],
    [ "1275887173",[-119.76430196174519, 36.71958416558504]],
    [ "1275887188",[-119.88314876645632, 36.705615674900535]],
    [ "1275887189",[-119.88109688166615, 36.703665774972976]],
    [ "1275887243",[-120.46641579729167, 36.85057820103376]],
    [ "1275887285",[-120.42205394695273, 36.72104322853933]],
    [ "1275887287",[-120.42181950000001, 36.7192747]],
    [ "1275887293",[-120.45781095798517, 36.72066430225713]],
    [ "1275887311",[-120.25380529545882, 36.792801628695216]],
    [ "1275887313",[-120.31953827723227, 36.83620579732636]],
    [ "1275887322",[-120.33873005176693, 36.860806333909565]],
    [ "1275887326",[-120.32808403323745, 36.867005150263495]],
    [ "1275887338",[-120.31698385022604, 37.055149182578475]],
    [ "1275887341",[-120.31202705523266, 37.12022327900672]],
    [ "1275887344",[-119.84119944332785, 37.6648391939979]],
    [ "1275887399",[-119.82468173845265, 36.87956509179329]],
    [ "1276009818",[-86.1240884, 38.0050921]],
    [ "1276009839",[-85.91932834999999, 38.00852085]],
    [ "Louisville Gas and Electric",[-85.65710625021252, 38.1699554989515]],
    [ "1276058579",[-85.73801429999999, 38.143180300000004]],
    [ "1276177347",[-85.37325596578992, 38.02691964678783]],
    [ "East Kentucky Power Cooperative, Inc.",[-84.8479259822869, 37.6684178037004]],
    [ "East Kentucky Power Cooperative, Inc.",[-84.94259886226055, 37.65678628939207]],
    [ "1276205597",[-85.07327272437287, 37.70845770543502]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.29787676643274, 37.785228198546186]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.36162697640121, 37.79701574193264]],
    [ "East Kentucky Power Cooperative, Inc.",[-84.70555740714151, 37.70361583156489]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.04424791016565, 37.975133192202826]],
    [ "Martell Substation",[-120.79677965517511, 38.36912325563631]],
    [ "Station 218",[-76.77511476666666, 43.1589305740502]],
    [ "Rochester Gas & Electric",[-76.80265080970747, 43.215028920249324]],
    [ "Station 181",[-76.80383955584273, 43.22243022393265]],
    [ "1276265446",[-84.12475139513961, 39.58032046371475]],
    [ "1276265448",[-84.22249117695215, 39.586916342256174]],
    [ "Station 189",[-76.7211483196632, 43.24164355150457]],
    [ "Delmarva Power",[-75.69697337172292, 39.74211969284235]],
    [ "Presho Substation",[-100.04626884999999, 43.90971425]],
    [ "Station 210",[-77.06696574522309, 43.24099442147726]],
    [ "1276597831",[-84.84693794999998, 38.0479695]],
    [ "1276597832",[-84.84759201593974, 38.0479478050579]],
    [ "1276669170",[-105.20016873728129, 40.0199972443467]],
    [ "Burlington Substation",[-74.8769168790643, 40.07775149826762]],
    [ "Burlington Substation",[-74.87551909576679, 40.075826639610355]],
    [ "East Kentucky Power Cooperative, Inc.",[-85.27355349486982, 37.92218761626307]],
    [ "1276720510",[-84.75421231816556, 38.04520523555285]],
    [ "1276720546",[-84.80870660394378, 38.17713138154247]],
    [ "1276769998",[-84.54888391504697, 38.19470477073371]],
    [ "1276770000",[-84.56208687441483, 38.20815778917541]],
    [ "1277524931",[-77.02120265000002, 43.206423400000006]],
    [ "1277524934",[-77.060376388143, 43.23951771443027]],
    [ "Station 208",[-77.14406603200904, 43.2380154847655]],
    [ "Station 202",[-77.2027696762527, 43.23402415556301]],
    [ "1277631890",[-97.46293511040575, 30.546695127525958]],
    [ "1277653348",[-84.7247406249505, 31.463524438213447]],
    [ "1277708635",[-103.96228586709837, 41.793926469360244]],
    [ "North Shore Substation",[-102.56653035995164, 48.20956103454811]],
    [ "1277854084",[-83.30649135000002, 39.54775085]],
    [ "1277854097",[-83.7654000609879, 39.41853150142723]],
    [ "1277854673",[-83.06538959200424, 39.502963012796116]],
    [ "1277854675",[-83.06450850873446, 39.50334597260019]],
    [ "1277903733",[-98.43635622415177, 35.84072507191457]],
    [ "Kingfisher SW Substation",[-97.95080811770231, 35.79802041267751]],
    [ "Southwestern Electric Power Company",[-93.74110107970577, 32.70912384945567]],
    [ "Tennessee Valley Authority",[-86.98720540099849, 37.26504075817818]],
    [ "Tennessee Valley Authority",[-86.98643442971293, 37.26706988247013]],
    [ "Cordelia Substation",[-122.11239621491657, 38.21590983025475]],
    [ "Station 193",[-77.18626944999998, 43.1484214]],
    [ "Station 198",[-76.64490194999999, 43.25175790000001]],
    [ "1278469687",[-77.49958338551006, 43.130362301551386]],
    [ "Kentucky Utilities Company",[-84.66789355892533, 38.00685489909361]],
    [ "Kentucky Utilities Company",[-84.48273905038747, 38.05699117490018]],
    [ "1278740521",[-84.38510136358406, 38.12372008404034]],
    [ "Kentucky Utilities Company",[-84.26351686146322, 38.18835178620013]],
    [ "Kentucky Utilities Company",[-84.77395048537228, 37.63899561918411]],
    [ "Kentucky Utilities Company",[-84.80004463875166, 37.63570847468557]],
    [ "Kentucky Utilities Company",[-84.8743276, 37.650605649999996]],
    [ "Kentucky Utilities Company",[-84.8439059694853, 37.76450270312413]],
    [ "Kentucky Utilities Company",[-84.8477078, 37.7801069]],
    [ "Lancaster Substation",[-84.57313620000001, 37.61902559999999]],
    [ "Kentucky Utilities Company",[-84.64743623534397, 37.340974331969356]],
    [ "Kentucky Utilities Company",[-84.65370613234958, 37.318929713058665]],
    [ "Kentucky Utilities Company",[-84.63504336608561, 37.257199710285654]],
    [ "1278886215",[-84.62109402278604, 37.109967394415705]],
    [ "Kentucky Utilities Company",[-84.61767904015687, 37.11027107236061]],
    [ "Kentucky Utilities Company",[-84.58754316518184, 37.099843828363156]],
    [ "1278886220",[-84.6191097761103, 37.10421264558739]],
    [ "Kentucky Utilities Company",[-84.60972073994658, 37.10058359103933]],
    [ "Kentucky Utilities Company",[-84.6101853209732, 37.079506168153124]],
    [ "Consumers Energy",[-83.98724912947362, 43.56202333700637]],
    [ "East Kentucky Power Cooperative, Inc.",[-84.2170398148403, 36.87032046943037]],
    [ "Williamsburg Switching Station",[-84.13011852399575, 36.77415246168663]],
    [ "Williamsburg South Substation",[-84.15565145000001, 36.7376534]],
    [ "1278994343",[-84.08580587432446, 36.93337751758943]],
    [ "Kentucky Utilities Company",[-84.07458156144585, 36.95163695774587]],
    [ "1278994351",[-84.06112245, 37.035673499999994]],
    [ "1279185320",[-83.87785181995311, 36.85921818991655]],
    [ "1279185321",[-83.87759085, 36.860311700000004]],
    [ "Kentucky Utilities Company",[-83.93737600934607, 37.08264272198639]],
    [ "Kentucky Utilities Company",[-83.78159203262884, 37.14835129440867]],
    [ "1279185356",[-83.74358318334515, 37.116825449942446]],
    [ "1279185358",[-83.68928526473557, 37.08592678867142]],
    [ "Kentucky Utilities Company",[-83.66527758860298, 37.11118501602592]],
    [ "Kentucky Utilities Company",[-83.65458698508382, 37.27370477377826]],
    [ "UC Davis Substation",[-121.75222134925261, 38.52862295697083]],
    [ "Jersey Central Power and Light",[-74.98245312623617, 40.766279141192555]],
    [ "Jersey Central Power and Light",[-74.95771965519756, 40.76067516815398]],
    [ "Jersey Central Power and Light",[-74.93503460319494, 40.76076760858993]],
    [ "Jersey Central Power and Light",[-74.88705436226306, 40.81378769935647]],
    [ "Jersey Central Power and Light",[-75.15295167866213, 40.6169597231988]],
    [ "Jersey Central Power and Light",[-75.06558419544365, 40.838312431033636]],
    [ "Jersey Central Power and Light",[-75.06045741345739, 40.72633282669784]],
    [ "Jersey Central Power and Light",[-75.10373344318985, 40.70427369448861]],
    [ "Jersey Central Power and Light",[-74.70155955167102, 40.564977141008605]],
    [ "Frenchtown Solar Substation",[-75.01928791327819, 40.48426787752734]],
    [ "Jersey Central Power and Light",[-74.9464606900621, 40.52140043964458]],
    [ "Jersey Central Power and Light",[-74.85695458927722, 40.48717153137208]],
    [ "Jersey Central Power and Light",[-74.85659047417089, 40.46121979327517]],
    [ "Jersey Central Power and Light",[-74.87086349604506, 40.49051851151793]],
    [ "Jersey Central Power and Light",[-74.86143242775033, 40.45426930299467]],
    [ "Jersey Central Power and Light",[-74.84390877733748, 40.52538724406364]],
    [ "Jersey Central Power and Light",[-74.85697543757834, 40.55336728557644]],
    [ "Jersey Central Power and Light",[-75.0124997822685, 40.52248385035375]],
    [ "Jersey Central Power and Light",[-74.9767707705049, 40.51420506445799]],
    [ "1279615340",[-88.83373572203418, 40.174662443659635]],
    [ "1279615343",[-88.83626425178119, 40.172807233378215]],
    [ "1279790430",[-83.51420165633643, 34.32973123859428]],
    [ "Burney Substation",[-121.6710880318723, 40.88794975622727]],
    [ "1280011744",[-121.39422314999997, 40.845918049999995]],
    [ "Lost Creek 2 Substation",[-121.4483431441852, 40.80143532923239]],
    [ "1280052890",[-77.17525395000001, 43.237859150000006]],
    [ "Bogard Substation",[-121.09159104090374, 40.588040483967134]],
    [ "Halls Flat Substation",[-121.27797109999997, 40.74486855000001]],
    [ "Pacific Gas and Electric Company",[-121.7309648277066, 38.581373975998766]],
    [ "1280463764",[-117.20145660000001, 34.2344119]],
    [ "1280463868",[-117.31447916344364, 34.05889272251932]],
    [ "1280463882",[-117.36081452248762, 34.04202064013013]],
    [ "Sacramento Municipal Utility District",[-121.42219952027061, 38.61273010290441]],
    [ "Sacramento Municipal Utility District",[-121.42018668343447, 38.584606935189136]],
    [ "Sacramento Municipal Utility District",[-121.33244466506952, 38.66824758838152]],
    [ "1280654588",[-83.03766371721989, 42.452487274413166]],
    [ "Sacramento Municipal Utility District",[-121.32204996487667, 38.55532908216187]],
    [ "Sacramento Municipal Utility District",[-121.28953943104734, 38.57807449361496]],
    [ "Redwood Substation",[-124.16346785502894, 41.76081203324651]],
    [ "North Crest Substation",[-124.19914911438335, 41.76604938165356]],
    [ "Smith River Substation",[-124.14059313906886, 41.88541311403174]],
    [ "1280862978",[-95.05292065769211, 30.149977974689545]],
    [ "1280862993",[-95.09547950366246, 30.160929607334563]],
    [ "Sacramento Municipal Utility District",[-121.42383651631975, 38.554221905485235]],
    [ "Sacramento Municipal Utility District",[-121.42371379855139, 38.554093286101704]],
    [ "Sacramento Municipal Utility District",[-121.4084985817134, 38.57209563712671]],
    [ "Sacramento Municipal Utility District",[-121.42394700360781, 38.601288444567906]],
    [ "Sacramento Municipal Utility District",[-121.42749384093504, 38.60579891305024]],
    [ "Sacramento Municipal Utility District",[-121.45630253833068, 38.60835068042562]],
    [ "Sacramento Municipal Utility District",[-121.43958702995575, 38.61934823600465]],
    [ "Sacramento Municipal Utility District",[-121.42624276529276, 38.62235288333398]],
    [ "1280991280",[-97.44963778907868, 30.544816636622215]],
    [ "Miller Redwood Substation",[-124.09743784999999, 41.73290389999999]],
    [ "Gasquet Substation",[-123.96673556425561, 41.84821117820166]],
    [ "Sacramento Municipal Utility District",[-121.51944317167732, 38.65407480925756]],
    [ "1281244984",[-84.26994014145394, 36.961338584575124]],
    [ "1281244989",[-84.05432481239484, 36.90012084396148]],
    [ "1281245002",[-84.10487360391392, 37.068313167140296]],
    [ "1281245012",[-84.35272328291313, 37.356539242123965]],
    [ "East Kentucky Power Cooperative, Inc.",[-84.40127346084846, 37.404460679050985]],
    [ "East Kentucky Power Cooperative, Inc.",[-84.34584356303294, 37.51232200973769]],
    [ "East Kentucky Power Cooperative, Inc.",[-84.09453090364474, 37.48115159117872]],
    [ "East Kentucky Power Cooperative, Inc.",[-84.0051421396405, 37.42868983462427]],
    [ "Sacramento Municipal Utility District",[-121.47591495986794, 38.64188238980151]],
    [ "Sacramento Municipal Utility District",[-121.47457486377166, 38.62323765404432]],
    [ "Sacramento Municipal Utility District",[-121.39974452250252, 38.61264898235806]],
    [ "Sacramento Municipal Utility District",[-121.4039013392409, 38.61084622838692]],
    [ "Sacramento Municipal Utility District",[-121.38604773505442, 38.60473258503197]],
    [ "Sacramento Municipal Utility District",[-121.50561920210198, 38.684640354573915]],
    [ "Sacramento Municipal Utility District",[-121.36322097432671, 38.63143740655215]],
    [ "Sacramento Municipal Utility District",[-121.36410768023377, 38.61846846848667]],
    [ "Sacramento Municipal Utility District",[-121.36406415167248, 38.6068039200374]],
    [ "Sacramento Municipal Utility District",[-121.34153182049475, 38.591575523452796]],
    [ "Sacramento Municipal Utility District",[-121.40577521720468, 38.62063985591209]],
    [ "Sacramento Municipal Utility District",[-121.38053911613888, 38.61619879952455]],
    [ "Sacramento Municipal Utility District",[-121.38077225961044, 38.61326886435252]],
    [ "Southern Pioneer Electric Company",[-98.9199252, 37.3896766]],
    [ "Henry St. Substation",[-83.90001655957407, 43.595187896227486]],
    [ "1282142357",[-84.40604235345593, 37.403304132841704]],
    [ "1282142361",[-84.45388638535508, 37.23274926872227]],
    [ "1282142370",[-84.4788683695814, 37.16024925833731]],
    [ "Crab Orchard Substation",[-84.51061321885842, 37.47097559699981]],
    [ "1282186498",[-82.0363363010384, 37.65560315276976]],
    [ "1282256491",[-117.3251466618386, 33.90162833039308]],
    [ "1282256500",[-117.43536297437475, 33.91562396580711]],
    [ "1282256525",[-117.42751004139426, 33.96082849432089]],
    [ "1282256589",[-117.2433549657679, 33.94724290095984]],
    [ "1282256645",[-117.2901178670989, 34.142262351388574]],
    [ "1282342981",[-117.10574355447012, 34.098526234634114]],
    [ "1282342984",[-117.1335080559181, 34.079803958204565]],
    [ "1282342992",[-117.18891174999999, 34.07802565]],
    [ "Sacramento Municipal Utility District",[-121.3370654673994, 38.67963537726895]],
    [ "Sacramento Municipal Utility District",[-121.31556017242997, 38.67090999413035]],
    [ "Sacramento Municipal Utility District",[-121.28116794190058, 38.68206324478775]],
    [ "1282588311",[-87.52810706646073, 39.21106078505076]],
    [ "1282590962",[-83.81090097157745, 33.62068177966428]],
    [ "1282590997",[-83.66962419281774, 33.60169406802829]],
    [ "1282590998",[-83.67013283998827, 33.6006582205598]],
    [ "Sacramento Municipal Utility District",[-121.3853676352239, 38.64593871811159]],
    [ "Sacramento Municipal Utility District",[-121.34662857926058, 38.606311688670644]],
    [ "1282643600",[-93.3591696379228, 42.95152977452742]],
    [ "1282643720",[-94.36466767497443, 42.5157559451085]],
    [ "1282644002",[-93.58710287502336, 43.10521320613482]],
    [ "1282648932",[-103.70307985008704, 35.89212428095162]],
    [ "Animas Substation",[-108.83167827792998, 31.96809412710522]],
    [ "Sacramento Municipal Utility District",[-121.51325280250188, 38.63024237565877]],
    [ "Sacramento Municipal Utility District",[-121.53915868751628, 38.6425270451382]],
    [ "Sacramento Municipal Utility District",[-121.49830788396729, 38.62011347845605]],
    [ "Sacramento Municipal Utility District",[-121.49105747216132, 38.60912208843188]],
    [ "Sacramento Municipal Utility District",[-121.41139248614508, 38.647416692755556]],
    [ "Sacramento Municipal Utility District",[-121.41097539095759, 38.64695021947943]],
    [ "Sacramento Municipal Utility District",[-121.4076739146728, 38.64252268085379]],
    [ "Evergy",[-99.73640664799646, 37.85400279356221]],
    [ "1282985949",[-121.01719516947254, 44.305625259374565]],
    [ "1282999122",[-98.83060829990306, 38.419331094395005]],
    [ "1282999128",[-99.05115115779483, 38.39148007483326]],
    [ "Sacramento Municipal Utility District",[-121.32658126816578, 38.70365279663481]],
    [ "Sacramento Municipal Utility District",[-121.346598318827, 38.71456236927824]],
    [ "Sacramento Municipal Utility District",[-121.43772092716264, 38.50839030290393]],
    [ "Sacramento Municipal Utility District",[-121.40973399540604, 38.5088619238201]],
    [ "1283066168",[-95.7496107540042, 38.19317243047706]],
    [ "1283066171",[-95.75481767490652, 38.1931695047682]],
    [ "1283079094",[-79.24781981829831, 34.6362169702538]],
    [ "1283100951",[-107.7728059250851, 32.27387096418587]],
    [ "Sacramento Municipal Utility District",[-121.38722407949184, 38.678274402533106]],
    [ "Sacramento Municipal Utility District",[-121.39243650646317, 38.67844828198353]],
    [ "North Greensburg Substation",[-79.55597033304281, 40.334425505700715]],
    [ "Sacramento Municipal Utility District",[-121.36413163529464, 38.697191242215695]],
    [ "Sacramento Municipal Utility District",[-121.32932379020895, 38.62105441451365]],
    [ "Sacramento Municipal Utility District",[-121.32883664448919, 38.639375450013304]],
    [ "Sacramento Municipal Utility District",[-121.30786512962003, 38.650079277960074]],
    [ "Sacramento Municipal Utility District",[-121.29080634299807, 38.692735589547844]],
    [ "1283495818",[-117.13401395, 33.825685150000005]],
    [ "1283495855",[-117.21236752296115, 33.829142979312586]],
    [ "1283657517",[-92.90500457505149, 41.70647480592927]],
    [ "1283657524",[-93.21271619999997, 41.671407499999994]],
    [ "Sacramento Municipal Utility District",[-121.30810397226098, 38.68817696872313]],
    [ "Sacramento Municipal Utility District",[-121.27081211309365, 38.70823763550284]],
    [ "Sacramento Municipal Utility District",[-121.29944458567114, 38.70549479314888]],
    [ "Sacramento Municipal Utility District",[-121.46280246290108, 38.710180835229465]],
    [ "Sacramento Municipal Utility District",[-121.45033564001301, 38.6599934729018]],
    [ "Sacramento Municipal Utility District",[-121.40222606948763, 38.58119609216823]],
    [ "Sacramento Municipal Utility District",[-121.29088461493174, 38.66541257555388]],
    [ "Sacramento Municipal Utility District",[-121.41025337252007, 38.60133769122112]],
    [ "Sacramento Municipal Utility District",[-121.24419502249462, 38.70831453947801]],
    [ "Sacramento Municipal Utility District",[-121.22606337605066, 38.652040238931235]],
    [ "1283857383",[-117.25539750995439, 33.58454444344237]],
    [ "Kaiser Substation",[-117.46663255, 33.904563550000006]],
    [ "1284221929",[-84.26594337309653, 37.696020285758046]],
    [ "1284221935",[-84.30266675, 37.595269449999996]],
    [ "1284221951",[-84.20586299462002, 37.71527709992969]],
    [ "1284221960",[-84.26742482927699, 37.70590307682899]],
    [ "1284221963",[-84.0487753169288, 37.70342756572711]],
    [ "1284298191",[-117.39222304593333, 33.95754141288405]],
    [ "1284379146",[-84.0071755, 37.7220057]],
    [ "Dark Hollow Substation",[-83.99173058958748, 37.69728281517376]],
    [ "Irvine Substation",[-83.96925252857933, 37.69639071412613]],
    [ "Millers Creek Substation",[-83.85718259999999, 37.669885]],
    [ "1284379159",[-83.76433241149034, 37.62728607388864]],
    [ "East Kentucky Power Cooperative, Inc.",[-83.94230055000001, 37.3247972]],
    [ "1284379172",[-84.09713648118833, 37.29132561142977]],
    [ "1284379177",[-83.5037143544387, 37.54707112090731]],
    [ "Water Street Substation",[-83.89733180559833, 43.58085395115487]],
    [ "Karn Unit #3 and #4 345kV Substation",[-83.83940887981315, 43.6435823653645]],
    [ "Karn Unit #3 and #4 138kV Substation",[-83.83956877805853, 43.64420735822863]],
    [ "Karn Unit #1 and #2 Substation",[-83.83930292723343, 43.64481707454378]],
    [ "1284460709",[-116.33509046590319, 33.757485249231266]],
    [ "1284460715",[-116.50515630051177, 33.84611280300968]],
    [ "1284460749",[-116.44991586908495, 33.791951899192085]],
    [ "1284460823",[-116.28674946797963, 33.714190692129534]],
    [ "1284460829",[-116.29433929060612, 33.68198534718478]],
    [ "1284460830",[-116.26503624999997, 33.6717327]],
    [ "1284485132",[-116.16340748790702, 33.74431732491258]],
    [ "1284506461",[-115.68876280522905, 33.384956382284194]],
    [ "1284506464",[-115.9216261513118, 33.52322091596024]],
    [ "1284506467",[-115.9749845249355, 33.55071516181809]],
    [ "1284506472",[-116.06064387723407, 33.5557820699062]],
    [ "1284506483",[-115.61537689842667, 33.16435450211148]],
    [ "1284506485",[-115.61772100681392, 33.16236444984131]],
    [ "1284506487",[-115.60430725, 33.178056999999995]],
    [ "1284506490",[-115.64680080000002, 33.157139550000004]],
    [ "1284506495",[-115.63998937846362, 33.15772405870479]],
    [ "1284506496",[-115.63961771089619, 33.15371563433723]],
    [ "1284506509",[-115.50054284160915, 33.140785703046156]],
    [ "1284513773",[-103.94138290000001, 32.48734845]],
    [ "1284513776",[-103.86078747412864, 32.557722046905006]],
    [ "Golden Substation",[-84.18702734173206, 43.60154017090329]],
    [ "Eversource",[-71.67168359231714, 43.45558211947161]],
    [ "Eversource",[-71.67278946728705, 43.45579849103376]],
    [ "1284578255",[-82.59196508566546, 38.33741280975596]],
    [ "Steamboat Landing",[-74.54017329999999, 43.8342398]],
    [ "1284695230",[-90.78485014150108, 39.64914620402338]],
    [ "1284852151",[-83.71902674381137, 37.57995087152094]],
    [ "1284852152",[-83.6924602920168, 37.58220822521577]],
    [ "1284852159",[-83.74083133768079, 37.805013720281295]],
    [ "East Kentucky Power Cooperative, Inc.",[-84.00517064781971, 37.79803849704198]],
    [ "1284852202",[-83.77248935326425, 38.01621788030676]],
    [ "1284852205",[-83.4692227163327, 37.85284978810722]],
    [ "1284871329",[-83.54301480000001, 38.207389899999995]],
    [ "1284871338",[-84.17848509999999, 37.99878685]],
    [ "1284871342",[-84.22830318380716, 37.94712714891327]],
    [ "1284871345",[-84.27040188692452, 37.90194691427916]],
    [ "1284871350",[-84.26841141537278, 38.05104074948805]],
    [ "Sacramento Municipal Utility District",[-121.33616734650974, 38.613421186033484]],
    [ "Sacramento Municipal Utility District",[-121.20313110825413, 38.66825127499916]],
    [ "Sacramento Municipal Utility District",[-121.20732341143575, 38.69301605820992]],
    [ "Sacramento Municipal Utility District",[-121.23142686390374, 38.679742750420836]],
    [ "Sacramento Municipal Utility District",[-121.2392032671871, 38.693544774331706]],
    [ "Sacramento Municipal Utility District",[-121.2416121840512, 38.66395235618392]],
    [ "Sacramento Municipal Utility District",[-121.25986851288658, 38.65265599634899]],
    [ "Sacramento Municipal Utility District",[-121.36281194757791, 38.70587744297858]],
    [ "Sacramento Municipal Utility District",[-121.45645532817939, 38.69037388597735]],
    [ "Sacramento Municipal Utility District",[-121.26331656645199, 38.679053188150874]],
    [ "Sacramento Municipal Utility District",[-121.26484419460114, 38.671419088010325]],
    [ "Sacramento Municipal Utility District",[-121.27621397401654, 38.64519834498861]],
    [ "Sacramento Municipal Utility District",[-121.15178176677077, 38.68714485758761]],
    [ "Sacramento Municipal Utility District",[-121.15935495316191, 38.696032587034296]],
    [ "Sacramento Municipal Utility District",[-121.1321236345484, 38.66582557146819]],
    [ "Sacramento Municipal Utility District",[-121.15015650203438, 38.6723824425914]],
    [ "Sacramento Municipal Utility District",[-121.160806275883, 38.64303430332893]],
    [ "Sacramento Municipal Utility District",[-121.10720282510687, 38.65930454651138]],
    [ "Sacramento Municipal Utility District",[-121.1008078799311, 38.63445842968978]],
    [ "Sacramento Municipal Utility District",[-121.18647685010578, 38.58291450878193]],
    [ "Sacramento Municipal Utility District",[-121.21199277560865, 38.605424210276006]],
    [ "Sacramento Municipal Utility District",[-121.21251978157856, 38.586063949575575]],
    [ "Sacramento Municipal Utility District",[-121.125766189073, 38.68982662724132]],
    [ "Sacramento Municipal Utility District",[-121.19373251297701, 38.70140454119611]],
    [ "Fuller Substation",[-104.62982455320977, 38.93665287127657]],
    [ "Sacramento Municipal Utility District",[-121.2657206054126, 38.57662573506279]],
    [ "Sacramento Municipal Utility District",[-121.33227236956945, 38.54378100399973]],
    [ "Sacramento Municipal Utility District",[-121.38115203416326, 38.54680468769226]],
    [ "Sacramento Municipal Utility District",[-121.37386177380816, 38.55435856216658]],
    [ "Sacramento Municipal Utility District",[-121.4098859081478, 38.537092649293655]],
    [ "Sacramento Municipal Utility District",[-121.51352955040196, 38.52288737018719]],
    [ "Sacramento Municipal Utility District",[-121.51446924994399, 38.51940422969204]],
    [ "Sacramento Municipal Utility District",[-121.47670619611685, 38.52460260638436]],
    [ "Sacramento Municipal Utility District",[-121.51743243174096, 38.503248849048404]],
    [ "1285811219",[-104.6322984401332, 38.63376565691469]],
    [ "Sacramento Municipal Utility District",[-121.30773701797129, 38.58611070591533]],
    [ "Sacramento Municipal Utility District",[-121.15689538749528, 38.49620971269895]],
    [ "Eagle Bay Station",[-74.81235069951941, 43.76895317999375]],
    [ "Sacramento Municipal Utility District",[-121.45620990415264, 38.524421826518946]],
    [ "Sacramento Municipal Utility District",[-121.42865056501313, 38.52557788906497]],
    [ "Old Forge Station",[-74.9799867837075, 43.70351914874669]],
    [ "1286444315",[-104.11866641697266, 32.500854068287886]],
    [ "White Lake Station",[-75.14225020395999, 43.543052701607735]],
    [ "1286463857",[-79.82600940823754, 39.69550666390326]],
    [ "1286539068",[-84.07838795622473, 38.10810227419297]],
    [ "1286539069",[-84.09010364999999, 38.19154605000001]],
    [ "1286539091",[-83.98543422378472, 38.04446316742682]],
    [ "1286539094",[-83.95094853379665, 38.01263211065614]],
    [ "1286539100",[-83.9465784558135, 38.04914909376746]],
    [ "1286539103",[-83.93567336889154, 38.04792236069146]],
    [ "1286539114",[-83.92512838170308, 38.082160525996464]],
    [ "1286539116",[-83.92618096160845, 38.07211748803502]],
    [ "1286539117",[-83.9014801701817, 38.08030856979316]],
    [ "1286539121",[-83.5812309712844, 38.131300864909456]],
    [ "1286539127",[-83.53320365522005, 38.14332021833308]],
    [ "1286539130",[-83.4400889627227, 38.16786191754684]],
    [ "1286539132",[-83.432773665347, 38.18054632997496]],
    [ "1286539133",[-83.43050872228686, 38.184285034714144]],
    [ "Columbia Gas Transmission, LLC",[-81.31127303696124, 38.49626897991481]],
    [ "1286646194",[-81.03618645634018, 37.36174648172887]],
    [ "1286672598",[-102.49779378868107, 34.29235772474974]],
    [ "1286672599",[-103.33075028753039, 35.1033954446871]],
    [ "1286672601",[-103.33080073963806, 35.08460637485699]],
    [ "1286672603",[-103.33759007533841, 34.82190929633813]],
    [ "1286672618",[-103.2657048751548, 34.141834494254034]],
    [ "1286672619",[-103.26557111261957, 34.14216662491161]],
    [ "1286672625",[-103.52895029999999, 34.17072805]],
    [ "1286672653",[-102.82838562476022, 34.30127390798536]],
    [ "1286672659",[-102.74596345, 34.23964685]],
    [ "1286672665",[-102.7410752, 34.2574833]],
    [ "1286672676",[-102.90826365000001, 34.2159244]],
    [ "1286672752",[-102.89778372513364, 34.288097695493576]],
    [ "Alder Creek Station",[-75.22567926544707, 43.42108213687465]],
    [ "1286907256",[-75.32585854999999, 43.545301650000006]],
    [ "Port Leyden Station",[-75.35087930553324, 43.578279766496635]],
    [ "Durazno Substation",[-106.43586106856068, 31.774790651365333]],
    [ "1286925969",[-106.40758185852471, 31.772092019310477]],
    [ "Rio Grande Substation",[-106.54707975561003, 31.805570469669618]],
    [ "1286926095",[-106.44526049673208, 31.861010004889504]],
    [ "1286926125",[-106.43492211063956, 31.963115124602453]],
    [ "1286926177",[-106.39598528989015, 31.75890136305751]],
    [ "1286926203",[-106.362005187762, 31.783894808313903]],
    [ "1286926358",[-106.42930669023157, 31.985751875218895]],
    [ "1286926417",[-107.76038207229256, 32.2739550168199]],
    [ "1286926422",[-107.7611463906925, 32.27702247732293]],
    [ "Moongate Substation",[-106.6498905750276, 32.4325381927548]],
    [ "1287149315",[-104.81945863058296, 30.984239904866985]],
    [ "1287149324",[-105.35032626623757, 31.180358981934525]],
    [ "1287149326",[-105.36292770920666, 31.17675826759918]],
    [ "1287149330",[-106.0301112, 31.40896105]],
    [ "1287149338",[-106.25534606214745, 31.583699502560897]],
    [ "1287149341",[-106.15550625984164, 31.510168153151692]],
    [ "1287149348",[-106.29898355000002, 31.641995799999993]],
    [ "1287149368",[-106.24998511221797, 31.672632844562628]],
    [ "1287149379",[-106.19808907507026, 31.685005457726223]],
    [ "1287149383",[-106.21708265000001, 31.728515899999998]],
    [ "1287149420",[-106.46934875000001, 31.7649616]],
    [ "1287206895",[-108.08214997488668, 32.846694354155645]],
    [ "1287206919",[-108.24954025000001, 32.80910095000001]],
    [ "1287206977",[-107.15545479313744, 32.663698119062765]],
    [ "1287206981",[-106.58349627529739, 31.96562118260757]],
    [ "1287206985",[-106.58509228675977, 31.966903037922197]],
    [ "1287207013",[-106.28573210276251, 31.61795947889107]],
    [ "1287207018",[-106.30565309575964, 31.68277347845758]],
    [ "1287255216",[-106.56559655328459, 31.849388578521083]],
    [ "Sacramento Municipal Utility District",[-121.39879136459669, 38.529992782213014]],
    [ "Sacramento Municipal Utility District",[-121.50120834333957, 38.468160751352485]],
    [ "Sacramento Municipal Utility District",[-121.31571092946469, 38.500975035808786]],
    [ "Collinsville Station",[-75.3844843118297, 43.611889477759064]],
    [ "1287554937",[-106.59510526958479, 35.17649553747403]],
    [ "1287558038",[-106.64344135889264, 35.0923176751461]],
    [ "1287558120",[-106.59518072509098, 35.05161175845988]],
    [ "1287558121",[-106.59518260783919, 35.05144592482188]],
    [ "1287558125",[-106.5914914588885, 35.05003600528473]],
    [ "1287558135",[-106.39274285, 35.0723083]],
    [ "1287558269",[-106.60323775000002, 35.1726197]],
    [ "1287558379",[-106.44527393941226, 34.97446662521526]],
    [ "1287558384",[-106.45999640000001, 34.947357499999995]],
    [ "1287558387",[-106.46355970011189, 34.961407635432614]],
    [ "1287558390",[-106.5346803340926, 34.98247752114376]],
    [ "1287558454",[-106.64491913388147, 35.04995898287947]],
    [ "1287565688",[-106.66129795000002, 34.9911503]],
    [ "1287565689",[-106.58677882506714, 35.110504395358745]],
    [ "1287565695",[-106.56615223588126, 35.10958091388828]],
    [ "1287620527",[-103.2487840537174, 33.242730293723646]],
    [ "1287620528",[-103.24929498628254, 33.24239774258428]],
    [ "Simpsonville Substation",[-85.34597561145125, 38.22230353979846]],
    [ "Eastwood Substation",[-85.44282100000001, 38.236437]],
    [ "1287640807",[-85.42809266674593, 38.25912665332713]],
    [ "1287640808",[-85.42636718703586, 38.28307392318727]],
    [ "1287640813",[-85.46910831367298, 38.320502759948766]],
    [ "1287640827",[-85.45768353919028, 38.23377686854723]],
    [ "1287640831",[-85.29005812841825, 38.40402992251002]],
    [ "Campbellsville Substation",[-85.18429832755123, 38.52137661903541]],
    [ "1287640849",[-85.18534464999999, 38.5304016]],
    [ "1287640852",[-85.19476, 38.56812295]],
    [ "1287640855",[-85.30523226320899, 38.60225569089398]],
    [ "1287640856",[-85.30570687450465, 38.601969363064164]],
    [ "1287640858",[-85.37935824038695, 38.71017278485632]],
    [ "1287722985",[-103.05894048019829, 33.30055958601066]],
    [ "1287815357",[-84.8971256228848, 38.15617826518678]],
    [ "1287815361",[-84.89565231006291, 38.181315415348784]],
    [ "1287815366",[-84.87414093878905, 38.18441339802221]],
    [ "1287815371",[-85.04419022748293, 38.33860913487795]],
    [ "Sacramento Municipal Utility District",[-121.39155880738888, 38.48079277494435]],
    [ "Sacramento Municipal Utility District",[-121.371473220036, 38.47818097220994]],
    [ "Taylorville",[-75.32185284284292, 43.92720776821106]],
    [ "Belfort",[-75.33242057707314, 43.92735180615338]],
    [ "Effley Falls",[-75.27782085, 43.92256204999999]],
    [ "PMC Organometallix",[-85.14281799415363, 38.68437086550302]],
    [ "1288060733",[-84.9668517289294, 38.77096005584603]],
    [ "1288060736",[-84.8970683, 38.77463825]],
    [ "1288060738",[-84.89837064185409, 38.68364779975605]],
    [ "Sacramento Municipal Utility District",[-121.39444004653006, 38.4920847856092]],
    [ "Sacramento Municipal Utility District",[-121.3352840868257, 38.485642814216554]],
    [ "1288658068",[-75.20113541250144, 43.90882947783326]],
    [ "Sunday Creek Station",[-75.13595696723333, 43.87162552008087]],
    [ "High Falls",[-75.37518605000001, 43.92434505000001]],
    [ "Ford Mill Substation",[-74.76755787753119, 40.16326283741962]],
    [ "Carthage Station",[-75.60927566911417, 43.97625187379865]],
    [ "Cleveland Street Substation",[-103.23157697486032, 44.06116794607387]],
    [ "Rockerville Substation",[-103.33783359939133, 43.96851932540541]],
    [ "1289046506",[-103.2472709356761, 33.14101979664441]],
    [ "1289046509",[-103.16289483529249, 33.14105495819004]],
    [ "1289063330",[-103.2397013229716, 33.01035134192795]],
    [ "Sacramento Municipal Utility District",[-121.36412014717335, 38.577443011402295]],
    [ "1289181509",[-114.73399206291916, 42.60843766919166]],
    [ "1289196217",[-114.5189201, 42.71806815]],
    [ "1289230799",[-103.0626634748075, 33.066690857921785]],
    [ "Colony Station",[-75.1998938235734, 44.27155995785921]],
    [ "1289402760",[-113.66590901235514, 42.80822567873994]],
    [ "1289653826",[-112.84423353581957, 42.9517617314178]],
    [ "1289664340",[-112.35994824603021, 43.17647559573931]],
    [ "Adams Substation",[-84.57223540996392, 38.20961826810551]],
    [ "1289726481",[-84.53502846409675, 38.269528496472006]],
    [ "1289726496",[-84.31314980664621, 38.39128949551889]],
    [ "1289726506",[-84.25036089025014, 38.206359503803135]],
    [ "1289726508",[-84.25715602330587, 38.20307841057962]],
    [ "Sacramento Municipal Utility District",[-121.44721412312059, 38.46303214606564]],
    [ "1290089378",[-84.11434547243772, 38.35951621401806]],
    [ "1290089384",[-83.99774915525882, 38.459318729189995]],
    [ "Star Lake",[-74.9920346, 44.16734775000001]],
    [ "PSE&G",[-75.11137644482037, 39.94491577693179]],
    [ "1290338437",[-91.56296923932844, 42.02112446970926]],
    [ "Fine Station",[-75.13292929999999, 44.24993625]],
    [ "South Edwards",[-75.19570648815936, 44.26756106928324]],
    [ "National Grid",[-75.24633608339042, 44.33053980008562]],
    [ "Mine Road Station",[-75.26455994999999, 44.33083854999999]],
    [ "Talcville",[-75.30827504999999, 44.308080350000004]],
    [ "Emeryville",[-75.3662827331467, 44.29636235056371]],
    [ "Hollow Dam",[-75.33577276905322, 44.29684859701408]],
    [ "Balmat Station",[-75.39778063757515, 44.252269936772784]],
    [ "Fowler",[-75.42534717537792, 44.30424700288917]],
    [ "1290639809",[-75.40804273252412, 44.263508612079065]],
    [ "1290639811",[-75.39834099840097, 44.25707095317062]],
    [ "North Gouverneur Station",[-75.47729578528357, 44.3446568158261]],
    [ "Dekalb Station",[-75.24242613262685, 44.49381800312113]],
    [ "Evergy",[-97.42187869176551, 37.70813184827232]],
    [ "American Transmission Company",[-90.92693058115567, 42.754863928780956]],
    [ "Cassville Solar Farm",[-90.92755162874325, 42.75441517670611]],
    [ "1290787650",[-90.70197556539193, 42.71843995768237]],
    [ "1290793300",[-89.36933717491283, 42.666465055610104]],
    [ "Pyrites",[-75.18660238493196, 44.51947750329409]],
    [ "North Rock Solar",[-89.10488447429158, 42.81740544400543]],
    [ "Crawfish River Solar",[-88.86291781931082, 43.01111202189032]],
    [ "Sacramento Municipal Utility District",[-121.24246531526751, 38.35419990439122]],
    [ "Sacramento Municipal Utility District",[-121.4599396250905, 38.448190921285665]],
    [ "Sacramento Municipal Utility District",[-121.46043828398676, 38.44836826067716]],
    [ "Sacramento Municipal Utility District",[-121.44876238799812, 38.42169717888226]],
    [ "Sacramento Municipal Utility District",[-121.4579153507629, 38.43016492872269]],
    [ "Sacramento Municipal Utility District",[-121.51590493070691, 38.27719852626643]],
    [ "Sacramento Municipal Utility District",[-121.51760918608278, 38.299520520518236]],
    [ "Sacramento Municipal Utility District",[-121.51034200572668, 38.36791667158401]],
    [ "Sacramento Municipal Utility District",[-121.44536374961565, 38.3214344383076]],
    [ "1291941306",[-103.06493630000001, 33.01003125]],
    [ "Woodside",[-114.154525726868, 46.32488177506321]],
    [ "Ravalli Electric Cooperative",[-114.067879, 46.559351199999995]],
    [ "Sacramento Municipal Utility District",[-121.48529449404413, 38.64601166300693]],
    [ "McVeytown Substation",[-77.76336477192139, 40.48302775412622]],
    [ "Strodes Mills Substation",[-77.70012281953349, 40.53184371361597]],
    [ "Lewistown Industrial Park Substation",[-77.61972610016677, 40.57655838994817]],
    [ "Fowler Substation",[-78.11323709140322, 40.756521313231346]],
    [ "Vail Substation",[-78.2178033626588, 40.69983890126074]],
    [ "1292596228",[-84.88686798873233, 38.20424251312055]],
    [ "1292596237",[-84.79473491944336, 38.18482126036431]],
    [ "1292596239",[-85.28144298933921, 38.19720196723246]],
    [ "1292596241",[-85.2820447933555, 38.206840365210795]],
    [ "1292616316",[-84.78946935181325, 38.50106011853095]],
    [ "1292773720",[-119.48675689573403, 39.52333498179753]],
    [ "1292897238",[-77.55822525850306, 39.06474272618169]],
    [ "Trappe Rock Substation",[-77.54458889979888, 39.05193991224623]],
    [ "1292956193",[-111.67836832441651, 33.35663330564987]],
    [ "1292960898",[-95.92584425435307, 41.26028625223505]],
    [ "Sacramento Municipal Utility District",[-121.25700768742324, 38.40196234928346]],
    [ "Sacramento Municipal Utility District",[-121.17631354092465, 38.466990021746575]],
    [ "Sacramento Municipal Utility District",[-121.18841347300265, 38.44277385890328]],
    [ "Sacramento Municipal Utility District",[-121.35048025037588, 38.4530719296844]],
    [ "Sacramento Municipal Utility District",[-121.38393440706835, 38.46040751899955]],
    [ "Sacramento Municipal Utility District",[-121.40450409532716, 38.44036866244667]],
    [ "Sacramento Municipal Utility District",[-121.4310196806472, 38.4940681686927]],
    [ "Sacramento Municipal Utility District",[-121.36994732356138, 38.42277868632942]],
    [ "Sacramento Municipal Utility District",[-121.43605030839589, 38.4353869692459]],
    [ "Sacramento Municipal Utility District",[-121.41832205557085, 38.39511442388357]],
    [ "1293371416",[-84.83578808749158, 39.008067272723736]],
    [ "Sacramento Municipal Utility District",[-121.2830596834711, 38.27497188174959]],
    [ "Sacramento Municipal Utility District",[-121.31460612540275, 38.29123310175266]],
    [ "Sacramento Municipal Utility District",[-121.16899059078997, 38.33524237612574]],
    [ "Sacramento Municipal Utility District",[-121.30474680344824, 38.26402485446154]],
    [ "Sacramento Municipal Utility District",[-121.30165734149674, 38.25457182328443]],
    [ "Sacramento Municipal Utility District",[-121.3127477336639, 38.27144715319922]],
    [ "Sacramento Municipal Utility District",[-121.38108988172844, 38.365020231493034]],
    [ "Sacramento Municipal Utility District",[-121.40883580285018, 38.35016393846375]],
    [ "Sacramento Municipal Utility District",[-121.40846572240918, 38.35018855552286]],
    [ "Sacramento Municipal Utility District",[-121.42067524134002, 38.31091489626728]],
    [ "Sacramento Municipal Utility District",[-121.18244983379422, 38.31188273807342]],
    [ "Stark",[-74.76090654999999, 44.455055800000004]],
    [ "Opal Substation",[-77.78889228189581, 38.60643887085693]],
    [ "1293748892",[-84.70021592499896, 39.0505686063024]],
    [ "1293748908",[-84.59103905288252, 38.64512227945878]],
    [ "Tupper Lake Municipal Substation",[-74.46130717939123, 44.23516486088711]],
    [ "Gilpin Bay Station",[-74.34827119365117, 44.28259006683184]],
    [ "Mission Valley Power",[-114.20331689165656, 47.71874997087596]],
    [ "Mission Valley Power",[-114.11716347146795, 47.529047257585994]],
    [ "Mission Valley Power",[-114.09769373440253, 47.33417916700141]],
    [ "Sacramento Municipal Utility District",[-121.34534618482155, 38.63088790715328]],
    [ "Sacramento Municipal Utility District",[-121.34533210633822, 38.55499337117216]],
    [ "Sacramento Municipal Utility District",[-121.40911323299022, 38.47545361618061]],
    [ "ITC",[-90.23894172083276, 41.80486685524902]],
    [ "1293974518",[-90.29121604999999, 41.806347249999995]],
    [ "1294583589",[-84.61681168865464, 39.057848124876415]],
    [ "1294583596",[-84.56883978187264, 39.055230850129874]],
    [ "1294583598",[-84.6076463619718, 39.02530549859202]],
    [ "1294583609",[-84.5054951999884, 39.03516044777341]],
    [ "1294583614",[-84.65127281846576, 39.000928055984055]],
    [ "1294595229",[-84.60668391829489, 38.920363155391364]],
    [ "1294595235",[-84.48804910273097, 39.012196947647524]],
    [ "Columbia Falls",[-114.19811594155979, 48.36930419429124]],
    [ "Flathead Electric Cooperative",[-114.32990903526037, 48.225312717777626]],
    [ "West Glacier",[-113.98428580714052, 48.49437844601288]],
    [ "Lake Blaine",[-114.10249673101687, 48.22523151385903]],
    [ "Flathead Electric Cooperative",[-114.10740962612233, 48.17919350181857]],
    [ "Lake Clear Station",[-74.2324578717841, 44.36779210541188]],
    [ "Gabriels Station",[-74.18468169999998, 44.43179034999999]],
    [ "1294681485",[-103.06140785251688, 33.18246387626743]],
    [ "1294684695",[-103.05957719136602, 33.183116748756895]],
    [ "1294858608",[-117.52643925, 34.10372005000001]],
    [ "1294858614",[-117.53057319999999, 34.10103615]],
    [ "1294858617",[-117.53134249994315, 34.09293057753759]],
    [ "1294858621",[-117.533308550075, 34.090448248015825]],
    [ "1294858626",[-117.56663714274713, 34.09131724112375]],
    [ "1294858671",[-117.52903315975547, 34.06298097621699]],
    [ "1294858680",[-117.52184362182079, 34.066658995237724]],
    [ "1294858690",[-117.50079520847306, 34.07697212147671]],
    [ "1294858709",[-117.5059929582387, 34.08283405070693]],
    [ "City of Colton Electric Utility",[-117.32241318747255, 34.06366705594213]],
    [ "1294858826",[-117.37673357497121, 34.02305410465989]],
    [ "Bloomingdale Station",[-74.08552707468944, 44.40283806382281]],
    [ "1294893482",[-117.77388545, 34.05949]],
    [ "1294918510",[-84.47655486745015, 39.10860320390894]],
    [ "1294918517",[-84.4928065, 39.06371630000001]],
    [ "1294918518",[-84.51552033849104, 39.07569075758958]],
    [ "1294934864",[-84.83910225607386, 38.54947867726333]],
    [ "1294934871",[-83.74204764735433, 38.641042440253386]],
    [ "Connexus Energy",[-93.47155217523937, 45.16747235677394]],
    [ "1295105094",[-117.35392759999999, 34.136512849999995]],
    [ "Muscoy Substation",[-117.33902704999998, 34.15718625]],
    [ "Mt. Vernon Substation",[-117.31036585671377, 34.12068656205827]],
    [ "1295105181",[-117.41438677502573, 34.12665765801499]],
    [ "1295105201",[-117.49347459062726, 34.07992092940795]],
    [ "1295105207",[-117.49274630441124, 34.08384510451325]],
    [ "1295105227",[-117.52497692230556, 34.04850879626514]],
    [ "1295105244",[-117.56833932625344, 34.04409000681926]],
    [ "1295204944",[-83.6708894589183, 38.611569377540214]],
    [ "1295204946",[-83.669397691365, 38.62067547903936]],
    [ "1295204956",[-83.51532554419393, 38.465004057260586]],
    [ "Hilda Substation",[-83.50948189310047, 38.24252223145311]],
    [ "1295204973",[-83.29633754999999, 37.911805799999996]],
    [ "Loon Lake Station",[-74.05760406903721, 44.54796324560838]],
    [ "Merrillsville Station",[-74.01587916664225, 44.52168499983093]],
    [ "Franklin Falls Station",[-73.97272462853513, 44.43690824110011]],
    [ "1295390402",[-110.74629657593727, 44.89465368883225]],
    [ "Silver Lake Station",[-73.86484046896226, 44.523110005122895]],
    [ "Black Brook",[-73.74301860492169, 44.45987520800548]],
    [ "Ausable Forks Station",[-73.68711510324098, 44.452577639769785]],
    [ "Riverview Station",[-73.88096967999834, 44.58798107563774]],
    [ "Potomac Edison",[-77.56036487507497, 39.35499407658343]],
    [ "1295566505",[-117.2935712, 33.930731349999995]],
    [ "Outlaw P.T.",[-117.28470563954554, 33.92353447448243]],
    [ "1295566528",[-117.2796693, 33.89239915000001]],
    [ "1295566529",[-117.27800969999998, 33.88958499999999]],
    [ "1295566533",[-117.29380910000002, 33.879909299999994]],
    [ "1295566579",[-117.2444518584825, 33.784447663521576]],
    [ "1295566584",[-117.22803831289106, 33.77169517501942]],
    [ "1295566618",[-117.18306518132825, 33.835668338274395]],
    [ "1295566625",[-117.22947782510826, 33.855871942300716]],
    [ "1295566626",[-117.23126434164345, 33.8558829748885]],
    [ "1295566672",[-117.60100969999999, 33.88738865]],
    [ "1295566673",[-117.57767905000001, 33.887068799999994]],
    [ "1295566690",[-117.32634805025721, 33.858882637358775]],
    [ "1295566721",[-117.51035776799922, 33.82076479599419]],
    [ "1295566726",[-117.50685207737503, 33.821503290306715]],
    [ "1295566728",[-117.49719695641123, 33.83391062477224]],
    [ "1295566778",[-117.51052689270331, 33.84900660779467]],
    [ "Retreat P.T.",[-117.50996545000002, 33.8042966]],
    [ "Fighter P.T.",[-117.51787435458766, 33.818448255758376]],
    [ "Temescal P.T.",[-117.51515278393131, 33.82890903174076]],
    [ "Stroh P.T.",[-117.52171134750175, 33.84006792482081]],
    [ "1295566800",[-117.39448579999998, 34.017774499999994]],
    [ "Sacramento Municipal Utility District",[-121.47998177263014, 38.70486971887015]],
    [ "Sacramento Municipal Utility District",[-121.39112456728421, 38.55390846049474]],
    [ "Sacramento Municipal Utility District",[-121.44711721379878, 38.624819200677415]],
    [ "Sacramento Municipal Utility District",[-121.29757875741724, 38.43396650860407]],
    [ "Sacramento Municipal Utility District",[-121.41833651484215, 38.41919308509358]],
    [ "Sacramento Municipal Utility District",[-121.44964693240483, 38.40696633524711]],
    [ "Sacramento Municipal Utility District",[-121.4426314790129, 38.47542411494501]],
    [ "Sacramento Municipal Utility District",[-121.45258601432306, 38.49379484054629]],
    [ "Sacramento Municipal Utility District",[-121.46659854529732, 38.48308315721413]],
    [ "Sacramento Municipal Utility District",[-121.47981074002587, 38.49107669418713]],
    [ "1295849737",[-121.69394054076733, 48.650165772421005]],
    [ "1296019477",[-103.24965751682046, 33.49764558901467]],
    [ "Richmond Substation",[-120.66092505745297, 40.41236993630981]],
    [ "Five Mile Substation",[-120.73830815010972, 40.41451032458709]],
    [ "Honey Lake Substation",[-120.26484922493856, 40.368267142875055]],
    [ "Lambert Lane Substation",[-120.39976999999999, 40.36255615]],
    [ "Johnstonville Substation",[-120.57456723280313, 40.38191438637102]],
    [ "1296516909",[-118.19045051673312, 33.746149959814474]],
    [ "1296516920",[-118.1902253019017, 33.74121486649791]],
    [ "1296516933",[-118.22857869999999, 33.742275299999996]],
    [ "1296516999",[-118.21532609999998, 33.7773684]],
    [ "1296517141",[-118.14060098372013, 33.83038310712406]],
    [ "1296517160",[-118.18207305, 33.7591909]],
    [ "1296517161",[-118.15931095901064, 33.752416095761845]],
    [ "1296517162",[-118.1621140350526, 33.741047320240256]],
    [ "1296517163",[-118.13889703295452, 33.740272693211296]],
    [ "1296517299",[-118.02162860000001, 33.673695650000006]],
    [ "1296517300",[-118.02127474207524, 33.67352843990009]],
    [ "1296517408",[-117.94260119880151, 33.687200566080364]],
    [ "1296517409",[-117.94488045, 33.689700800000004]],
    [ "1296517473",[-117.86856050154186, 33.726888575551946]],
    [ "1296517580",[-117.88734955042322, 33.878949243199614]],
    [ "1296517588",[-117.86220149999998, 33.8577667]],
    [ "1296517614",[-117.92053368199252, 33.714528629029346]],
    [ "1296518070",[-117.84907012187078, 33.84756376660492]],
    [ "1296518111",[-117.78815767130818, 33.88879970030878]],
    [ "1296518122",[-117.82010171978118, 33.910491752551906]],
    [ "1296518130",[-117.82438681448573, 33.91453677835369]],
    [ "1296518251",[-117.93190795000002, 34.1118165]],
    [ "Chateaugay",[-74.11135613600926, 44.92443489849942]],
    [ "Huson",[-114.3392853254475, 47.03355377073366]],
    [ "1297283294",[-114.8919222397358, 47.1973575260563]],
    [ "1297283295",[-115.4009936225664, 47.38428376457023]],
    [ "1297283297",[-115.50948324999999, 47.40766075]],
    [ "1297358014",[-119.37026775000001, 45.90725809999999]],
    [ "1297358019",[-119.431631231306, 45.90601743620001]],
    [ "1297358022",[-119.56090321491092, 45.84804336824645]],
    [ "1297358027",[-119.4188468616671, 45.85369216950852]],
    [ "1297358036",[-119.26783285861728, 45.84867911861168]],
    [ "1297358049",[-119.10951991644058, 45.915446101493046]],
    [ "Moira Station",[-74.53891601460444, 44.8241015850211]],
    [ "North Bangor",[-74.40328537412572, 44.8499762946386]],
    [ "1297472643",[-119.35142781064555, 45.72692251377968]],
    [ "1297475855",[-113.03316590456762, 45.15273531033884]],
    [ "1297475856",[-113.64899011510641, 45.01285458231177]],
    [ "1297475857",[-113.65056096720612, 45.01275619287423]],
    [ "North Lawrence",[-74.67618571440572, 44.796872382177405]],
    [ "1297514364",[-119.1359486, 46.30040105]],
    [ "1297589637",[-113.4598568081233, 45.570839884728606]],
    [ "1297589639",[-113.6144294661346, 44.85061404877943]],
    [ "Idaho Power",[-113.88536696239528, 45.183645405565635]],
    [ "1297589642",[-114.34012370742938, 45.11553703381299]],
    [ "1297589643",[-114.23399495848714, 45.09283105228008]],
    [ "Idaho Power",[-113.66924806677216, 45.0336370497837]],
    [ "Idaho Power",[-114.13269417310175, 45.214713265979604]],
    [ "Florence",[-114.07987753362886, 46.62990923178841]],
    [ "Brasher Station",[-74.7825772927901, 44.81708654674074]],
    [ "Westville Station",[-74.39423721636943, 44.939040084313135]],
    [ "Fort Covington Station",[-74.4936962184039, 44.98372249127134]],
    [ "Bombay Station",[-74.57525337323891, 44.93894431440202]],
    [ "North Bombay Station",[-74.62802590000001, 44.944103950000006]],
    [ "Saint Regis Station",[-74.66392409999999, 44.97138975]],
    [ "1297728041",[-83.3727332430548, 37.4828487783758]],
    [ "Chavies Substation",[-83.36179380250962, 37.34481737483342]],
    [ "1297732096",[-84.15186464249646, 36.73913433017088]],
    [ "1297732103",[-83.6017262252386, 36.90978972719741]],
    [ "1297738171",[-119.3994081174291, 46.30141422210271]],
    [ "1297741831",[-83.13043548666997, 38.312050918715435]],
    [ "1297741833",[-82.97613136213454, 38.290749376934656]],
    [ "1297741835",[-82.91244635982686, 38.28296306389316]],
    [ "1297741854",[-82.71763373768987, 38.44758311503835]],
    [ "1297741859",[-82.68529004347401, 38.51456401778176]],
    [ "1297741860",[-82.7219025, 38.546338999999996]],
    [ "1297741862",[-82.7472561288382, 38.54484056745175]],
    [ "1297741864",[-82.74672824142394, 38.547658322049266]],
    [ "1297741867",[-82.78895413900545, 38.57774714185621]],
    [ "1297775409",[-82.6625894680508, 38.451202685836904]],
    [ "1297775416",[-82.61100517175494, 38.44666620768295]],
    [ "1297775417",[-82.62742193093452, 38.47626139278842]],
    [ "1297775420",[-82.63203236668866, 38.47820752245567]],
    [ "1297775423",[-82.64605900000001, 38.482858]],
    [ "1297775425",[-82.6689641236576, 38.4954814940649]],
    [ "Prospect Substation",[-78.91985136829919, 40.33225617583892]],
    [ "1297788663",[-115.25404766215365, 47.57755677655599]],
    [ "Flathead Electric Cooperative",[-115.53945819149047, 48.3843601673338]],
    [ "1297788666",[-115.90581804713845, 48.24696519083499]],
    [ "1297788670",[-115.89491399999999, 48.2793035]],
    [ "1297788671",[-115.86266020000001, 48.3090915]],
    [ "Flathead Electric Cooperative",[-114.28932008659164, 48.22972857482011]],
    [ "Camas",[-114.64864136211376, 47.48695597490908]],
    [ "1298069261",[-74.99466422767766, 44.71491976523126]],
    [ "Bill Durfee Substation",[-104.39465535000001, 44.322166149999994]],
    [ "1298247105",[-115.74553122111853, 47.964387286126474]],
    [ "1298254027",[-111.92307479082073, 46.54304253345506]],
    [ "1298595098",[-82.5939249514753, 38.34487188355217]],
    [ "1298595099",[-82.59327486718121, 38.34438888119498]],
    [ "1298595106",[-82.57656254068286, 38.2686033681915]],
    [ "1299138565",[-111.51151469999999, 32.87364255]],
    [ "1299145655",[-111.30049356118153, 45.743762761216104]],
    [ "1299145658",[-111.32902831621757, 45.85589205406412]],
    [ "South End-37 Substation",[-72.49965859186703, 44.19036700998205]],
    [ "1299417615",[-116.90966631840529, 39.58546859273944]],
    [ "1299530232",[-96.84000995520807, 37.83133522147301]],
    [ "1299535739",[-95.38251132485384, 28.95557597176367]],
    [ "1299535740",[-95.38244430855866, 28.954244097350664]],
    [ "Morristown Station",[-75.64066611674907, 44.57750794988774]],
    [ "Hammond Station",[-75.69218986801707, 44.44965920445464]],
    [ "1299804571",[-113.02068665066439, 38.49068180413926]],
    [ "1299806343",[-113.54614681855662, 37.05847247309274]],
    [ "1299806347",[-113.52195717693527, 37.083545179759696]],
    [ "1299869711",[-88.27624365, 30.7824648]],
    [ "1299888615",[-112.09943952467094, 45.86783151333822]],
    [ "1299888616",[-112.08686633708136, 45.868709572645905]],
    [ "1299888618",[-111.77011882671151, 45.796217290863474]],
    [ "1299888621",[-111.63810577754884, 45.040861806867305]],
    [ "1299891886",[-110.95770540087231, 45.663281582059426]],
    [ "1299891888",[-110.79595035000001, 45.66518905000001]],
    [ "1299891889",[-110.87456974448027, 45.23401006863822]],
    [ "1299891890",[-110.78830776601187, 45.10023112006245]],
    [ "1299893306",[-99.03577122895416, 40.72625151837047]],
    [ "1299893307",[-99.0380803622057, 40.72778780996189]],
    [ "1299903180",[-110.83572237598842, 44.45397988347211]],
    [ "1299903181",[-110.56905102121402, 44.40888789225304]],
    [ "1299903183",[-110.61861801741982, 45.90772247026297]],
    [ "1299903184",[-110.66563088594181, 45.992488407761215]],
    [ "1299903186",[-110.51129151551218, 45.68853381127594]],
    [ "1299903188",[-110.24370758283932, 45.76802869897747]],
    [ "1299903189",[-110.08578213579409, 45.501509901905656]],
    [ "1299903191",[-110.08616237760067, 45.504779835379374]],
    [ "1299903192",[-109.9573441834846, 45.83609934931518]],
    [ "1299912618",[-109.78254193460849, 45.76347055472956]],
    [ "1299912620",[-109.86790895628137, 45.386926317036675]],
    [ "1299912632",[-109.23592049999999, 45.6320015]],
    [ "1299912633",[-109.05059914518758, 45.59614758226883]],
    [ "1299912635",[-108.97857492156758, 45.61946764088399]],
    [ "1299912637",[-108.92232958652578, 45.6322617843641]],
    [ "1299919114",[-108.76030694999999, 45.65753815]],
    [ "1299919123",[-108.48688849259567, 45.77824610573683]],
    [ "1299919132",[-108.42839025, 45.810844249999995]],
    [ "1299919138",[-108.446015274835, 45.803107487270914]],
    [ "1299919144",[-108.73213732365143, 45.67570355361152]],
    [ "1299924969",[-108.4693461, 45.8033776]],
    [ "1300367250",[-113.47266442860733, 47.160720364384545]],
    [ "1300367252",[-113.29191250000001, 47.1068603]],
    [ "1300367254",[-113.09508977898405, 46.981824003487326]],
    [ "1300367256",[-113.02139815884387, 46.86688353590704]],
    [ "1300367258",[-113.4948015, 47.190724599999996]],
    [ "1300376733",[-96.67242515000001, 32.43586645]],
    [ "1300414623",[-108.8221620405855, 45.65806642458506]],
    [ "1300634204",[-114.08854789308383, 42.43139967485513]],
    [ "1300634690",[-114.61248666187554, 42.19504260011476]],
    [ "Broadmoor Substation",[-104.85246338515476, 38.79299724672295]],
    [ "1300658455",[-108.8776011366405, 45.30821445292328]],
    [ "1300658457",[-108.81361625, 45.564808899999996]],
    [ "1300658459",[-108.8141816466706, 45.592167816976335]],
    [ "1300658461",[-108.86246905474403, 45.49093922834425]],
    [ "1300658462",[-108.90241697528323, 45.463728162655165]],
    [ "1300658464",[-108.91835367975611, 45.39199474521305]],
    [ "1300658472",[-108.96518845, 45.156879700000005]],
    [ "1300663143",[-108.92432145000001, 45.296666099999996]],
    [ "1300663146",[-109.0881860923077, 45.22054602499478]],
    [ "1300663147",[-109.16525937695164, 45.20644090405516]],
    [ "1300663149",[-109.1442695, 45.2090988]],
    [ "1300663151",[-108.70937314999999, 45.23426694999999]],
    [ "1300765155",[-96.65176112104085, 32.98326779456543]],
    [ "Florida Power & Light",[-80.45344505000001, 25.435788650000003]],
    [ "Berwind Substation",[-81.65298761500983, 37.25856109836952]],
    [ "Elk Creek Substation",[-81.82444471805864, 37.68276054925625]],
    [ "1300970715",[-81.82524460189028, 37.68323537743477]],
    [ "1300970718",[-81.9600552752493, 37.56111507695762]],
    [ "1300987503",[-81.94642956754622, 37.790574360187996]],
    [ "Columbia Gas Transmission, LLC",[-82.03563693795505, 37.65520121133528]],
    [ "1300987516",[-81.841705, 37.90569855]],
    [ "1300987518",[-81.8703758, 38.10691825000001]],
    [ "1300987520",[-81.86610857475607, 38.093325326992264]],
    [ "1301021954",[-112.56942851056269, 33.24083965631944]],
    [ "1301073770",[-82.0851549, 37.7544184]],
    [ "WPP LLC",[-81.61042205000001, 37.589530550000006]],
    [ "Appalachian Power Company",[-81.61028094211846, 37.58893477722474]],
    [ "1301073787",[-81.34124915259336, 37.6375197981976]],
    [ "Mabscott Substation",[-81.22764214367514, 37.76983533240737]],
    [ "1301133319",[-84.1870399560403, 34.03502078599946]],
    [ "Consumers Energy",[-84.86005911368679, 43.83966807733001]],
    [ "1301147709",[-81.48931225000001, 38.1308352]],
    [ "1301147714",[-81.5446517135292, 37.631509566986296]],
    [ "Appalachian Power Company",[-81.66150718541982, 37.681165332533936]],
    [ "Oceana Substation",[-81.64805085, 37.7002669]],
    [ "Appalachian Power Company",[-81.5952045979068, 37.802709533057396]],
    [ "Appalachian Power Company",[-81.72375849999999, 37.79628185]],
    [ "Latrobe Substation",[-81.7612298649881, 37.79412078534008]],
    [ "1301147731",[-81.8470085, 37.819282650000005]],
    [ "1301147732",[-81.62658013140837, 37.84701846544018]],
    [ "1301147736",[-81.54772061991619, 37.81847370775006]],
    [ "1301147737",[-81.53518006162133, 37.88538182001096]],
    [ "Appalachian Power Company",[-81.59067976457357, 37.802526163205975]],
    [ "1301408958",[-92.09529674999999, 42.850233100000004]],
    [ "1301612129",[-87.60033233328646, 45.099516138837004]],
    [ "1301654225",[-77.55111491096986, 38.945682254364144]],
    [ "1301654226",[-77.55116177817182, 38.94637119438783]],
    [ "Sun River Electric Cooperative",[-111.83876025295628, 47.58626975067364]],
    [ "1301676560",[-111.98784656428833, 47.61250925204647]],
    [ "1301676562",[-111.98782874999999, 47.620050549999995]],
    [ "1301676564",[-112.09665034999999, 47.60510804999999]],
    [ "1301676566",[-112.06719848353595, 47.598444851409276]],
    [ "1301676570",[-111.70993881211552, 47.84988887574381]],
    [ "South Peak",[-110.6796632297101, 47.27948887548608]],
    [ "1301872322",[-110.60182360850358, 47.33036341925049]],
    [ "1301872323",[-110.49652420000001, 47.26315075]],
    [ "1301872325",[-110.36201912450574, 47.246664593310086]],
    [ "1301872326",[-110.21190711236956, 47.15207717535055]],
    [ "1301872327",[-110.21158455, 47.15204454999999]],
    [ "1301872334",[-110.22179031141675, 47.13519610210071]],
    [ "Simmons Substation",[-84.1864910471707, 44.259660399823964]],
    [ "Rose City Substation",[-84.11667035329255, 44.417763797648604]],
    [ "1301886002",[-110.0520250246542, 47.08378373870677]],
    [ "1301886005",[-109.7987927, 47.06972525000001]],
    [ "1301886009",[-109.54570215000003, 47.0406053]],
    [ "1301891019",[-110.0944434566043, 47.036942036764]],
    [ "1301891021",[-109.6970829133193, 46.97877286491027]],
    [ "1301891024",[-109.7651502, 46.881443149999996]],
    [ "1301891040",[-109.76662861460547, 46.81358622478901]],
    [ "1301891049",[-109.7661654400523, 46.67200772496122]],
    [ "1301891052",[-109.44635843027237, 47.13243679573318]],
    [ "1301907136",[-108.81089986245787, 47.350645474662166]],
    [ "1301915814",[-108.56279043477119, 46.44006841734495]],
    [ "1301915819",[-108.56208690000001, 46.44036045]],
    [ "1301915823",[-108.38251650000001, 46.4835892]],
    [ "1301915824",[-108.08900080000002, 46.51591915]],
    [ "1301915826",[-107.92336015000001, 46.51858875]],
    [ "1301915828",[-107.87018528757687, 46.59631934388373]],
    [ "1301915829",[-108.30388786021082, 46.591734770266754]],
    [ "1302330146",[-96.55997628093739, 32.34715416737169]],
    [ "Packard Substation",[-80.79573784170681, 41.27490324747029]],
    [ "Consumers Energy",[-83.57123444110263, 44.470504224792805]],
    [ "Wheatland Substation",[-121.41855212427214, 39.01301386492564]],
    [ "1302748790",[-76.54695341779649, 38.991206993894025]],
    [ "Keota Substation",[-104.22708497142217, 40.742952268306176]],
    [ "1302771132",[-95.32211432492419, 36.2465486564144]],
    [ "1302774821",[-97.06899133417532, 32.440883075493204]],
    [ "1302774827",[-97.06403995535314, 32.442485768298866]],
    [ "1302777335",[-97.04448031959772, 32.46048266006306]],
    [ "1302777336",[-97.04522903602387, 32.46047441219582]],
    [ "1302788522",[-82.99250556026473, 39.8524020748539]],
    [ "1302800231",[-108.15502199999999, 46.62375294999999]],
    [ "1302800233",[-108.48794391397922, 46.33752974909067]],
    [ "1302800235",[-108.42796612736268, 46.276324736061994]],
    [ "1302800236",[-108.39235707993645, 46.279220745154284]],
    [ "1302800242",[-110.90506790000002, 46.535403650000006]],
    [ "Tundra Switching Station",[-104.41315442784213, 38.34372435267609]],
    [ "NextEra Energy",[-104.41009747325819, 38.344075935684906]],
    [ "1302803774",[-110.90034127497266, 46.5445177944908]],
    [ "1302803776",[-108.88252086285236, 46.19838212497287]],
    [ "1302803779",[-108.93181890850832, 46.29215812388054]],
    [ "1302803780",[-109.03585263314754, 46.291703198900784]],
    [ "1302803781",[-109.15157830000001, 46.29213575000001]],
    [ "1302803782",[-109.25928080949832, 46.301865072591625]],
    [ "1302803783",[-109.3200749, 46.2997202]],
    [ "1302803785",[-109.38413115, 46.3151851]],
    [ "1302803787",[-108.92680980997329, 46.204606825161285]],
    [ "1302807696",[-108.8740841, 46.09889784999999]],
    [ "1302807697",[-111.96233084121185, 48.14894604500325]],
    [ "1302807699",[-112.17926358187908, 47.80876558205809]],
    [ "1302807701",[-112.02545813791886, 47.618987824809125]],
    [ "1302807702",[-112.33918281558255, 47.581451424853924]],
    [ "1302807704",[-112.38212005, 47.4800977]],
    [ "1302868170",[-121.54351846331537, 45.74318456232727]],
    [ "Coal Mountain Substation",[-81.71957233917601, 37.68197037803404]],
    [ "Goals Coal Company, Inc.",[-81.5549144714207, 37.89823102171891]],
    [ "Appalachian Power Company",[-81.5552255382787, 37.89805454985276]],
    [ "1302929135",[-81.52293219999999, 37.8777959]],
    [ "1302929143",[-81.42769679295368, 37.90728296500568]],
    [ "1302929146",[-81.40302695, 37.90818805]],
    [ "1302929150",[-81.57318719999999, 38.00032345]],
    [ "1302929152",[-81.56572868298127, 38.01256519923678]],
    [ "Appalachian Power Company",[-81.56085156721934, 37.97034150814636]],
    [ "1302929154",[-81.5610407594823, 37.97001703207625]],
    [ "1302929157",[-81.65454337584204, 37.95056765611437]],
    [ "1302929159",[-81.65377777582027, 37.95105859168572]],
    [ "Gypsum Substation",[-83.71714955, 44.210333350000006]],
    [ "1303001751",[-111.11216589999998, 47.65481519999999]],
    [ "1303001754",[-110.01242962235001, 48.3176249202225]],
    [ "1303001756",[-109.91573083539407, 48.39885922155243]],
    [ "1303113296",[-81.3319869, 37.82226884999999]],
    [ "1303113302",[-81.32308956789043, 37.68512935242912]],
    [ "1303113303",[-81.36906535, 37.677396800000004]],
    [ "1303113307",[-81.28532655000001, 37.740121249999994]],
    [ "1303113308",[-81.28531315000002, 37.7402657]],
    [ "1303113317",[-81.19222174956826, 37.656057524338806]],
    [ "1303113319",[-81.27379534999999, 37.62538585]],
    [ "1303113323",[-81.22901078030574, 37.71207090462563]],
    [ "1303113326",[-81.18030506702424, 37.77248832240031]],
    [ "Prince Substation",[-81.07470130736861, 37.85566120489087]],
    [ "1303140748",[-81.331216005912, 37.99062677879274]],
    [ "Ronda Substation",[-81.4469276, 38.1723059]],
    [ "1303140767",[-81.26647001141839, 38.05619652984118]],
    [ "1303140768",[-81.26461672329873, 38.057101820955886]],
    [ "1303140770",[-81.33452270475384, 38.05107688591587]],
    [ "1303170746",[-110.30517782498403, 47.97334059450507]],
    [ "1303170748",[-110.56901077484738, 48.04425894486521]],
    [ "Glacier Electric Cooperative",[-113.19498415978266, 48.4519140674861]],
    [ "Meriwether Regulator",[-112.76463955000001, 48.604921399999995]],
    [ "Glacier Electric Cooperative",[-112.8044918563319, 48.94342165485626]],
    [ "1303183199",[-112.31482309999998, 48.62425090000001]],
    [ "Glacier Electric Cooperative",[-112.3605835919888, 48.50557606772644]],
    [ "1303183205",[-112.54463295, 48.32237715000001]],
    [ "Glacier Electric Cooperative",[-112.36447796566691, 48.75446936758648]],
    [ "Glacier Electric Cooperative",[-112.2770706213296, 48.61020637503741]],
    [ "Shelby",[-111.86881104185349, 48.51149660980192]],
    [ "Marias River Electric Cooperative",[-111.60083015000001, 48.29190985]],
    [ "Marias River Electric Cooperative",[-111.34156371014602, 48.552991779718994]],
    [ "Sun River Electric Cooperative",[-111.75226571768592, 48.13093126548551]],
    [ "Sun River Electric Cooperative",[-112.0484748, 47.927314949999996]],
    [ "Fort Shaw",[-111.81608431511577, 47.507813398096374]],
    [ "Oak Hill Substation",[-81.12992923200201, 37.9893035019574]],
    [ "Appalachian Power Company",[-81.0191401932194, 38.037409083301434]],
    [ "Appalachian Power Company",[-81.7079760432311, 37.97248503770936]],
    [ "1303283532",[-81.74447376752748, 38.01692084890327]],
    [ "1303283533",[-81.74405092383668, 38.01666619513046]],
    [ "1303283539",[-81.7210779972943, 37.74000763317775]],
    [ "1303283540",[-81.72143005000001, 37.739872500000004]],
    [ "1303283543",[-81.93770814999999, 37.84239205]],
    [ "1303589965",[-121.23505275497884, 46.0158925120716]],
    [ "1303605199",[-119.00532528082564, 46.663444117722314]],
    [ "Koonsville Substation",[-76.15947528078331, 41.16688480637454]],
    [ "Colorado Springs Utilities",[-104.81146395563964, 39.0209243883806]],
    [ "Colorado Springs Utilities",[-104.83783390946411, 38.96820006202366]],
    [ "Green Mountain Substation",[-104.99654378850126, 38.92274290387967]],
    [ "Colorado Springs Utilities",[-104.84683235048453, 38.917299342528544]],
    [ "Colorado Springs Utilities",[-104.8592575132978, 38.89987578611665]],
    [ "Colorado Springs Utilities",[-104.79794372206364, 38.84121993220754]],
    [ "Colorado Springs Utilities",[-104.86506869448814, 38.8320233660716]],
    [ "Colorado Springs Utilities",[-104.81319371484507, 38.74683284266295]],
    [ "Colorado Springs Utilities",[-104.8458686568058, 38.744078953246465]],
    [ "Peterson Field Substation",[-104.70197751328826, 38.83816022748104]],
    [ "Glenview Substation",[-75.93833930437424, 41.33174478608503]],
    [ "UGI",[-75.9892613946064, 41.37437524581652]],
    [ "Dallas Substation",[-75.96730013633845, 41.34071094346366]],
    [ "Huntsville Substation",[-75.98823604732769, 41.33339124040395]],
    [ "1303997655",[-119.51892236938654, 46.301148931840906]],
    [ "Hurricane Substation",[-82.00977720463956, 38.4401680738978]],
    [ "Tawas Substation",[-83.50641106696848, 44.27902877494863]],
    [ "Noble Substation",[-83.576921260923, 44.132592929960296]],
    [ "Au Gres Substation",[-83.66607428533446, 44.052234518256476]],
    [ "Arenac Substation",[-83.8001104637819, 44.11218166869263]],
    [ "1304303555",[-73.97899368947166, 41.20444280153568]],
    [ "1304303561",[-73.98043342570298, 41.256820759292154]],
    [ "Orange & Rockland",[-73.99186927220131, 41.24855053578687]],
    [ "1304317096",[-74.19281263713334, 41.397805840743366]],
    [ "1304351608",[-74.19256694167893, 41.67891876848032]],
    [ "1304636561",[-76.34784508634472, 41.26305171804271]],
    [ "Idaho Power",[-114.44471279206901, 42.5452759689245]],
    [ "1304756925",[-110.88532840000002, 48.25710505]],
    [ "1304756926",[-110.95356577316738, 48.513956691500795]],
    [ "1304756928",[-110.69003122982464, 48.55344762557966]],
    [ "1304756929",[-110.55355494999999, 48.55356635]],
    [ "1304756930",[-110.42147806222158, 48.552696074945985]],
    [ "1304756932",[-110.08530992480253, 48.566467707509226]],
    [ "1304756936",[-109.65000120008784, 48.55049263189959]],
    [ "1304756938",[-109.40333817184418, 48.589691694357285]],
    [ "Woodbury Transition Yard",[-74.1216302325668, 41.31761726786934]],
    [ "1304763556",[-109.2861550252403, 48.742870794451036]],
    [ "1304763557",[-109.22924689999999, 48.59587019999999]],
    [ "1304763558",[-109.00717531171874, 48.57971272768299]],
    [ "1304763564",[-108.54243787479582, 48.722669844447765]],
    [ "1304763565",[-108.2520979, 48.3975298]],
    [ "1304768508",[-107.11607193119235, 48.401666491072284]],
    [ "1304768509",[-107.08148389232011, 48.39047806835558]],
    [ "1304768510",[-106.82294668303861, 48.305501701847895]],
    [ "1304768524",[-106.36613073808111, 48.13549966795794]],
    [ "1305101834",[-73.95350531667972, 41.566677454057945]],
    [ "1305101836",[-73.95730979999999, 41.563441350000005]],
    [ "1305101837",[-73.95356225, 41.56650904999999]],
    [ "1305127745",[-116.55769706276801, 48.960157696760454]],
    [ "1305127752",[-116.54886875781693, 48.33229417336377]],
    [ "Sandpoint Substation",[-116.6252557157181, 48.25275668482201]],
    [ "1305127771",[-116.62420966345277, 48.25273043110163]],
    [ "1305127779",[-116.61186823106652, 48.35612621265363]],
    [ "1305127781",[-116.18715754987717, 48.15239241035803]],
    [ "Bronco Substation",[-85.65019111239197, 42.26059990523303]],
    [ "1305255871",[-74.02492482719538, 41.071008561444714]],
    [ "1305327132",[-74.00638988403938, 41.184739981482394]],
    [ "1305335115",[-74.32548255, 41.130801]],
    [ "1305398364",[-87.99774026254723, 44.807892425848124]],
    [ "1305425760",[-88.4751546, 44.16261504999999]],
    [ "1305436771",[-82.74767575, 42.76401965]],
    [ "1305436773",[-82.7461970184637, 42.76654332442639]],
    [ "1305451668",[-110.97359090000002, 33.1258149]],
    [ "1305451681",[-110.98018007226524, 33.155745669086905]],
    [ "Ameren",[-94.39806271048394, 39.24085532493582]],
    [ "Independence Water Substation",[-94.40036541631586, 39.158931487546084]],
    [ "1305478095",[-94.41413138023462, 39.14868256617282]],
    [ "Cement City Substation",[-94.41703180256727, 39.14385532507801]],
    [ "1305484684",[-94.39446463856781, 39.28738733763773]],
    [ "1305506381",[-82.53449660062209, 38.36907348566565]],
    [ "1305506385",[-82.53472674701672, 38.3680680456388]],
    [ "1305506386",[-82.53490523183942, 38.36750612360901]],
    [ "1305506387",[-82.53593733751534, 38.367461972916125]],
    [ "1305506394",[-82.32042448890617, 38.402792224461315]],
    [ "1305506399",[-82.25962756533447, 38.40297905090559]],
    [ "1305506403",[-82.125618103137, 38.36209159078625]],
    [ "1305511560",[-116.8003230508379, 47.70998568206531]],
    [ "1305581006",[-74.7828103284592, 41.571036109891196]],
    [ "1305593736",[-110.29911659413433, 31.981425208163834]],
    [ "NYSEG",[-74.39029337248427, 41.70752722379255]],
    [ "Griffin Wheel Substation",[-94.74190052135684, 39.08083029909662]],
    [ "1305677858",[-82.19653312439233, 38.257080209800336]],
    [ "Sand Springs Capacitor Station",[-120.85263823706389, 43.72039554367707]],
    [ "Bonneville Power Administration",[-120.8551881478504, 43.72042567531213]],
    [ "1306272628",[-73.91637532048553, 41.52896499149728]],
    [ "1306272652",[-73.9127821118541, 41.62810371110092]],
    [ "1306272653",[-73.91241990573276, 41.629143516808625]],
    [ "1306272654",[-73.9419436111929, 41.61871057906117]],
    [ "1306274513",[-73.81422413401866, 41.6644933190842]],
    [ "Murner Substation",[-84.70211436698166, 45.02955372514139]],
    [ "Livingston Peakers Substation",[-84.73070254624326, 45.029982528457246]],
    [ "1306514877",[-81.61166652259202, 38.22125002707865]],
    [ "1306514878",[-81.6111537040047, 38.22130496714652]],
    [ "1306514880",[-81.69860860000001, 38.2038086]],
    [ "1306679996",[-80.65681614402025, 38.04504317102778]],
    [ "1306703738",[-96.60870703717575, 33.06083272922236]],
    [ "1306864688",[-84.86755754098326, 41.42334552506506]],
    [ "1306865704",[-84.03413377612539, 41.02287291234989]],
    [ "1306973831",[-103.6116019684699, 33.21372209293628]],
    [ "Columbia Gas Transmission, LLC",[-81.32163367197518, 38.486760483909116]],
    [ "Columbia Gas Transmission, LLC",[-81.32258798089316, 38.48700304369618]],
    [ "Monongahela Power Company",[-80.4155704, 39.1436446]],
    [ "1307008916",[-80.94359052287747, 33.927769015198415]],
    [ "Alpine Generating #2",[-84.82777308237286, 45.06407107461454]],
    [ "Alpine Generating #1",[-84.8277743691404, 45.0637125751151]],
    [ "Oden Substation",[-84.87862935853764, 45.43616385841779]],
    [ "1307369577",[-112.07951279999999, 34.40462235]],
    [ "1307371554",[-103.61102871435997, 33.352375685495424]],
    [ "1307371741",[-81.90694087384009, 38.91567774238752]],
    [ "1307371743",[-82.08367339719933, 38.96727691962614]],
    [ "Four Mile Substation",[-83.50205460943785, 45.09408547011078]],
    [ "Sound Transit",[-122.42106591960736, 47.240387114494524]],
    [ "Sprindle Switching Station",[-104.9032016750151, 40.09443955203132]],
    [ "Consumers Energy",[-85.81996240289406, 44.36316722531325]],
    [ "Guthrie County REC",[-94.56101165, 41.74578864999999]],
    [ "Guthrie County REC",[-94.5179896859787, 41.69579366864092]],
    [ "Guthrie County REC",[-94.3710210239475, 41.62070710615588]],
    [ "Diamondhead Substation",[-94.26499475, 41.5610992]],
    [ "Alliant Energy",[-94.22699021092372, 41.59334344629725]],
    [ "1308492028",[-94.3172561114899, 41.50432552509331]],
    [ "1308621558",[-94.32775409999999, 41.496339199999994]],
    [ "1308671797",[-94.44356056215443, 41.34520627524946]],
    [ "1308681508",[-94.4700848249419, 41.229624840647226]],
    [ "1308683229",[-94.56708107855458, 41.337946856356545]],
    [ "1308689182",[-94.74904582495583, 41.374312644167844]],
    [ "1308702152",[-103.61159714982837, 33.12796428664336]],
    [ "1308716501",[-94.72002163694803, 41.23010610277225]],
    [ "1308932805",[-96.37228234543976, 32.0300568529873]],
    [ "West Water Substation",[-109.48926835, 37.55130095]],
    [ "Bluff Substation",[-109.5592792, 37.2890151]],
    [ "1309504379",[-109.2047631571897, 37.261039853122256]],
    [ "1309504382",[-109.20559592237286, 37.26085497960673]],
    [ "1309504383",[-109.20605291905693, 37.2605621025782]],
    [ "1309504384",[-109.26794369413548, 37.28708017224769]],
    [ "1310633901",[-78.58787726262288, 39.92982228522613]],
    [ "Avery Substation",[-104.93699215538734, 40.54274200533788]],
    [ "1310815519",[-103.74832868695148, 33.213645463198056]],
    [ "Angostura Substation",[-103.39298394999997, 43.34672025]],
    [ "Greenbacker Renewable Energy Corporation",[-103.34458451522852, 43.157263917930166]],
    [ "Fall River Substation",[-103.34501757249728, 43.15808270047402]],
    [ "Radio Drive Substation",[-103.25850583078763, 44.023610254342465]],
    [ "Black Hills Power",[-103.31949007500045, 44.03422150586313]],
    [ "Forty Fourth Street Substation",[-103.28960544166469, 44.072793558695494]],
    [ "Big Bend Substation",[-103.41183342594853, 44.066970559417705]],
    [ "Provo Substation",[-103.8373939604073, 43.191856125187215]],
    [ "Black Hills Electric Cooperative",[-103.66110423842721, 43.49754102328358]],
    [ "Gateway Substation",[-105.04017555354551, 40.33363901635081]],
    [ "Hot Springs Substation",[-103.47721415936668, 43.434026376679995]],
    [ "1310961555",[-110.72801916581973, 39.583008281966165]],
    [ "1310961560",[-110.72169591888326, 39.56021704892471]],
    [ "1310969500",[-110.12193002324521, 42.48320791240068]],
    [ "1311093601",[-110.42526977386386, 42.500536634780126]],
    [ "1311095511",[-112.05739702057113, 43.32750404701569]],
    [ "1311101956",[-109.126986572683, 41.53613865672392]],
    [ "1311105234",[-103.43674540824799, 43.34430527815842]],
    [ "1311105244",[-103.40711140697037, 43.399469581332696]],
    [ "1311135661",[-107.0705195202, 42.73581965460931]],
    [ "1311137009",[-108.39138856673046, 36.79253066660072]],
    [ "1311142936",[-107.01047290916289, 42.73531882469618]],
    [ "1311147299",[-108.88349348866195, 44.70664556904064]],
    [ "1311155233",[-107.66042090898688, 37.139348866057226]],
    [ "1311155238",[-107.62440803270034, 37.07532429481976]],
    [ "1311155240",[-107.67918868670421, 37.15921277814935]],
    [ "1311155257",[-107.56632509076556, 37.21818955921685]],
    [ "1311155259",[-107.07374037181748, 37.296565806248786]],
    [ "Pringle Substation",[-103.5940262869603, 43.60923050267302]],
    [ "1311225880",[-103.60873549678982, 43.76051433411548]],
    [ "1311375083",[-88.87809219990696, 37.231012894376505]],
    [ "East Meade Substation",[-103.19585282495116, 44.065738053622816]],
    [ "East North Street Substation",[-103.21043145, 44.08697385]],
    [ "Anamosa Substation",[-103.21993376321439, 44.0964903326795]],
    [ "Moon Meadow Substation",[-103.29798670000001, 44.0097534]],
    [ "1311652724",[-108.6042386250004, 37.311812792893576]],
    [ "1311652726",[-108.69458731085798, 37.20804558293456]],
    [ "1311654263",[-108.14620826147664, 36.92862767236123]],
    [ "1311810570",[-103.27138099398394, 44.08817981538528]],
    [ "1311810571",[-103.27216105, 44.0882541]],
    [ "1311810572",[-103.27000355, 44.0897751]],
    [ "East Meade Substation",[-103.2847200748065, 44.085503039622914]],
    [ "Boomerang Substation",[-104.82460272798781, 40.399889601755696]],
    [ "Boulder Canyon Substation",[-103.60383454999999, 44.3981123]],
    [ "Windy Flats Substation",[-103.64884015, 44.27126919999999]],
    [ "1312132538",[-108.41045556556014, 36.79448022490784]],
    [ "Anadarko Substation",[-104.74947164879525, 40.25833163956214]],
    [ "Florida Power & Light",[-80.42911082868473, 25.640867038465547]],
    [ "Florida Power & Light",[-80.42454930481851, 25.64101724123559]],
    [ "Florida Power & Light",[-80.52187537570435, 25.534362308213638]],
    [ "Florida Power & Light",[-80.39972272212799, 25.67676311830382]],
    [ "South Dakota Science and Technology Authority",[-103.75117947172551, 44.352758196628905]],
    [ "Rushmore Forest Products, LLC",[-103.52255381579276, 43.94519241735986]],
    [ "Hill City Substation",[-103.56322055357494, 43.93110579266334]],
    [ "1312298092",[-108.29690194219279, 38.114094886396785]],
    [ "1312301917",[-108.00909994999999, 37.9375529]],
    [ "1312301925",[-107.90358739366428, 37.88672051171402]],
    [ "1312301930",[-108.19196384809491, 38.033154133259906]],
    [ "1312328265",[-107.75725854999999, 38.23930695]],
    [ "Box Elder Substation",[-104.5270748070114, 40.30544465288023]],
    [ "Florida Power & Light",[-80.37310117796821, 25.526615971177684]],
    [ "1312445066",[-107.98680950169597, 36.71821079104244]],
    [ "1312449118",[-107.6255897214411, 36.79312150360397]],
    [ "1312463207",[-105.01583514999999, 38.385882499999994]],
    [ "LaCreek Electric Association",[-102.16922944256223, 43.18772147476159]],
    [ "LaCreek Electric Association",[-101.91297157874229, 43.201704574566854]],
    [ "LaSalle Substation",[-104.70727532891867, 40.34864491235477]],
    [ "LaCreek Electric Association",[-102.32644158730953, 43.18780722526436]],
    [ "LaCreek Electric Association",[-101.66205205494586, 43.505129208411155]],
    [ "1312499390",[-101.3551694, 43.46155204999999]],
    [ "Evans Substation",[-104.70605357490761, 40.391696995462226]],
    [ "Florida Power & Light",[-80.34272319927122, 25.76652835502005]],
    [ "Western Area Power Administration",[-104.78548591851063, 40.648105190332494]],
    [ "1312527046",[-104.7842310616449, 40.64825894955957]],
    [ "Spearfish City Substation",[-103.86515680017402, 44.493542614326216]],
    [ "1312575817",[-103.8875554648722, 44.4994054751126]],
    [ "1312638861",[-103.88285549999999, 44.49794934999999]],
    [ "1312638862",[-103.88305746835461, 44.49947782596067]],
    [ "1312638863",[-103.88974505, 44.5012698]],
    [ "1312659459",[-117.35795011501386, 47.95916043192697]],
    [ "1312674288",[-114.04060554565488, 43.293951531974635]],
    [ "1312674301",[-114.41034085932132, 42.930863098973795]],
    [ "1312674303",[-114.44338330000001, 42.82564745]],
    [ "1312674308",[-114.38518308272913, 42.54612145290765]],
    [ "Burton Hill Substation",[-72.21447274476589, 44.75599180433316]],
    [ "Barton Electric Department;Orleans Electric Department",[-72.16286998206715, 44.79613994698141]],
    [ "Rainbow Substation",[-72.20072395230844, 44.812018700738726]],
    [ "Ethan Allen Manufacturing Substation",[-72.20259239772712, 44.80850440983911]],
    [ "Ethan Allen Manufacturing Substation",[-72.20415034999999, 44.80678534999999]],
    [ "Ethan Allen Manufacturing Substation",[-72.20325165777382, 44.805418339751334]],
    [ "1312711480",[-113.74398844023194, 42.48206668464324]],
    [ "1312711482",[-113.68734023980376, 42.60649417913743]],
    [ "1312711485",[-113.22266066669896, 42.5901641228476]],
    [ "1312711487",[-113.25487633288806, 42.415048375001355]],
    [ "1312711488",[-113.04292752498108, 42.79089855984291]],
    [ "1312713869",[-113.66713792533974, 42.72125705454163]],
    [ "1312713874",[-113.62782225306279, 42.64754422908293]],
    [ "1312716198",[-116.53839723640093, 43.596450470989296]],
    [ "1312719668",[-105.87038660857436, 40.182382694522225]],
    [ "Mullica Hill Substation",[-75.22773489502013, 39.72868346403873]],
    [ "1312876755",[-91.83026369444124, 39.141824905666]],
    [ "1312898959",[-75.75987322890931, 44.0303227127256]],
    [ "Portland Pipe Substation",[-72.03970164685775, 44.685829085248365]],
    [ "1312930775",[-91.64859079958893, 39.16086920987791]],
    [ "Enosburg Substation",[-72.80884033523739, 44.902101088621336]],
    [ "Newell Substation",[-103.36707075, 44.67698455000001]],
    [ "Butte Electric Cooperative",[-103.24603342442153, 44.51726596138364]],
    [ "1313102068",[-91.43705160028462, 39.20197384835929]],
    [ "Swanton Substation",[-73.11253704633437, 44.919677862981196]],
    [ "Rock Tenn Substation",[-72.97734202398263, 44.90894885453184]],
    [ "Sheldon Springs Substation",[-72.98177779494199, 44.90998582629178]],
    [ "Rock Tenn Substation",[-72.97680775969421, 44.9102158421701]],
    [ "Belvidere Substation",[-72.6232777, 44.76955110000001]],
    [ "1313125467",[-75.80104497088114, 44.06126209745244]],
    [ "Middle Road Station",[-75.82961592841325, 43.938474831820635]],
    [ "Montgomery Substation",[-72.60992934064292, 44.86593582611626]],
    [ "North Hyde Park Substation",[-72.6075844315567, 44.67771874681631]],
    [ "Johnson Back-up Substation",[-72.67022060000001, 44.6394976]],
    [ "Johnson Substation",[-72.69743939454638, 44.62299083506808]],
    [ "Cambridge Substation",[-72.81287090000001, 44.64080595]],
    [ "Madonna Substation",[-72.78910730709896, 44.585474680745676]],
    [ "Pleasant Valley Substation",[-72.86684734737013, 44.59575362648451]],
    [ "Fairfax 12 Substation",[-72.98058957003212, 44.65176092043204]],
    [ "Fairfax Station Substation",[-72.99105006657075, 44.651445098587985]],
    [ "PECO",[-75.02683666956044, 40.36638574710349]],
    [ "Gardenville Substation",[-75.09155486702257, 40.40306985159039]],
    [ "PECO",[-75.06705490000002, 40.3899224]],
    [ "Jersey Central Power and Light",[-74.95792859999999, 40.3892157]],
    [ "Ben and Jerrys Substation",[-73.10021963126422, 44.7966240725198]],
    [ "North Elm Street Substation",[-73.08883089894633, 44.82011788167022]],
    [ "North St. Albans Substation",[-73.06450152156353, 44.82629930429651]],
    [ "East St. Albans Substation",[-73.06759975596125, 44.80409722353986]],
    [ "Ivy City Substation",[-76.98266515341024, 38.91840033087801]],
    [ "Myers Tap Switching Station",[-104.69424074987819, 41.16680906820164]],
    [ "East Business Park Substation",[-104.69325019802254, 41.14755458797637]],
    [ "Georgia Substation",[-73.120731, 44.712257199999996]],
    [ "Wyeth Substation",[-73.09445992808988, 44.69369339467311]],
    [ "Clark Falls Substation",[-73.11507686622706, 44.64041415410166]],
    [ "West Milton Substation",[-73.16288624999999, 44.63735409999999]],
    [ "Peterson Substation",[-73.1625323, 44.638158450000006]],
    [ "National Grid",[-71.56988853400684, 41.1750448672703]],
    [ "Dillon's Corner",[-71.48310687110403, 41.4336899952]],
    [ "Block Island Power Company",[-71.57111774683025, 41.17557223662806]],
    [ "Peacedale",[-71.51404944326661, 41.46950843532505]],
    [ "Westford Substation",[-73.03168075519949, 44.63379869968393]],
    [ "Substation 1",[-72.61185151997088, 44.577170173122774]],
    [ "Substation 5",[-72.58628235000002, 44.5772498]],
    [ "Substation 7",[-72.53029802874237, 44.62461274593052]],
    [ "Marion Substation",[-89.73534645596726, 31.019032865078884]],
    [ "Grand Electric Cooperative",[-102.59396942498353, 44.72030266119652]],
    [ "Grand Electric Cooperative",[-102.90894970000001, 45.73256715]],
    [ "1313881930",[-91.55914556474222, 40.42309991360337]],
    [ "Decker Substation",[-106.8260945924667, 45.02696656150223]],
    [ "New Haven Station",[-76.31475160572236, 43.474776618136595]],
    [ "1314038637",[-116.2910152896301, 43.580736070309584]],
    [ "1314068932",[-116.26801809999999, 43.77893405000001]],
    [ "Gilbert Mills Station",[-76.2486750758938, 43.30597569050324]],
    [ "1314234296",[-116.92925305000001, 44.05745195000001]],
    [ "1314234297",[-116.77213994745576, 44.00418428439894]],
    [ "1314260145",[-116.39470138974674, 43.53517502265022]],
    [ "1314260152",[-116.33371441354588, 43.46082148103185]],
    [ "1314270049",[-117.30849686586669, 44.37677929699266]],
    [ "1314270498",[-117.42236429164211, 44.5417060888696]],
    [ "Passwater Substation",[-93.80042683064477, 42.44980313673178]],
    [ "Whitaker Station",[-76.4031324, 43.3351491]],
    [ "Kissimmee Utility Authority",[-81.47448299195716, 28.321523259276745]],
    [ "Sacramento Municipal Utility District",[-121.35736011943528, 38.654536357289594]],
    [ "1315431463",[-73.79290612331161, 41.75477773554928]],
    [ "1315569940",[-115.2933648, 42.95541499999999]],
    [ "1315628594",[-115.95679207391544, 42.29586764498585]],
    [ "1315628597",[-116.10389702188735, 42.199339040206645]],
    [ "West River Electric Association",[-103.13170942502838, 44.05186965547121]],
    [ "West River Electric Association",[-103.15442819618612, 44.09625949227268]],
    [ "1315814128",[-114.23090450181606, 42.56172257193411]],
    [ "Moonshot Solar, LLC",[-89.50798773422305, 30.431654174971314]],
    [ "Mississippi Power",[-89.50784733263603, 30.4310014255142]],
    [ "Cane Creek Switching Station",[-88.88654891787151, 31.980958590739974]],
    [ "Cane Creek Solar, LLC",[-88.8870941824828, 31.981289900903484]],
    [ "1315982579",[-89.01906749998527, 30.53029353429854]],
    [ "1316034080",[-101.95518302514209, 34.734214461928005]],
    [ "Issler Substation",[-81.6521730400611, 41.40173623500904]],
    [ "1316538418",[-97.36384299136652, 33.647802758967316]],
    [ "1316538427",[-97.52608160785421, 33.689497173615194]],
    [ "1316549112",[-96.62652214133482, 33.25595822659943]],
    [ "1316549984",[-95.90570406912927, 33.59845991001543]],
    [ "Furlong Substation",[-81.75607276178097, 41.42246723054006]],
    [ "Kirk Substation",[-81.52355711750776, 41.362123224137555]],
    [ "Liquid Air Substation",[-83.79709077603637, 41.60877800694535]],
    [ "Medical College Substation",[-83.6118927435596, 41.61946076799327]],
    [ "Malinta Substation",[-84.02595512509207, 41.32656390495644]],
    [ "Cloverdale Substation",[-81.53911584893612, 40.76829812078538]],
    [ "1317031848",[-89.73482276104721, 43.263504495138704]],
    [ "1317031851",[-89.72968798600851, 43.290609428878334]],
    [ "1317031853",[-89.72957645, 43.281678]],
    [ "East End Substation",[-80.54786857341948, 40.63105447853752]],
    [ "Saint Clair Avenue Substation",[-80.5740499988423, 40.627387982326816]],
    [ "Calcutta Substation",[-80.57502617681362, 40.67060347619184]],
    [ "Glenmoor Substation",[-80.61417068933116, 40.66010795413038]],
    [ "Timber Road Substation",[-84.75806120453339, 41.0182053746831]],
    [ "Memorial Drive Substation",[-82.6127338717196, 39.725696061858535]],
    [ "Geneva Substation",[-82.43111957206627, 39.672812583504886]],
    [ "Good Hope Switching Station",[-82.55353231924185, 39.58165974844241]],
    [ "Beatty Substation",[-83.11858091817204, 39.86231706980514]],
    [ "Britton Switching Station",[-83.1318767789953, 40.05871864260502]],
    [ "Vadata Incorporated Substation",[-83.13233417432707, 40.05863074519697]],
    [ "Royal Building Products Substation",[-82.95368893100338, 39.92623326531889]],
    [ "ITC Manufacturing Substation",[-82.97251918361795, 39.92827070086865]],
    [ "Columbus Auto Shredding Substation",[-82.93873650108216, 39.9226257425696]],
    [ "1317116755",[-97.0760444748157, 37.11350469029249]],
    [ "1317116758",[-97.07663382485423, 37.18692430714714]],
    [ "1317116761",[-97.02614756049358, 37.16831417498954]],
    [ "1317116762",[-96.91468497495721, 37.09194581137053]],
    [ "1317116765",[-96.89575578358229, 37.092137433102]],
    [ "1317171698",[-97.34955555624997, 37.29002803529055]],
    [ "1317171699",[-97.34844562511569, 37.290139290239395]],
    [ "1317171701",[-97.38467973226057, 37.30442277545038]],
    [ "1317174006",[-96.6229158443888, 37.08561825889157]],
    [ "1317174008",[-96.50309862501791, 37.11732759121125]],
    [ "1317251380",[-114.79091686218125, 42.923582075060544]],
    [ "Collamer Crossing Station",[-76.04356249547457, 43.106065355903986]],
    [ "Delano Substation",[-93.78657360289526, 45.03539140792419]],
    [ "1317277409",[-114.0924668556083, 42.60529112960504]],
    [ "1317277410",[-114.03675766379867, 42.52679379004396]],
    [ "1317278931",[-114.0573346, 42.56175505]],
    [ "Bridgeport Station",[-75.9678655321025, 43.14599098471627]],
    [ "1317293636",[-113.76004229701272, 42.553382177662726]],
    [ "1317293639",[-113.78385727536579, 42.547912960708835]],
    [ "1317293642",[-113.81286735, 42.53421437137465]],
    [ "1317315346",[-95.7784789833155, 32.58859594929294]],
    [ "1317325803",[-93.58440302313562, 45.087947389925105]],
    [ "Corcoran Substation",[-93.54337244999999, 45.08740709999999]],
    [ "Corcoran II Substation",[-93.5417504540206, 45.088415421749936]],
    [ "1317376505",[-95.87553881718466, 37.20395963173874]],
    [ "1317376513",[-95.91188175, 37.2849561]],
    [ "1317376517",[-96.2084464212504, 37.123290142321274]],
    [ "1317376520",[-95.92668680034771, 37.04786744774264]],
    [ "1317406243",[-96.69951840564349, 33.61500423241144]],
    [ "Wright-Hennepin Cooperative Electric Association",[-93.5906942763086, 45.05584970969173]],
    [ "1317418502",[-113.40160452488576, 42.41581425285446]],
    [ "City of Sherrill",[-75.59796155823497, 43.07859994568931]],
    [ "Buckeye Substation",[-81.87934152108562, 41.17051486929163]],
    [ "West Lorain Substation",[-82.26553156725582, 41.430090977498374]],
    [ "Freedom Substation",[-81.76670274698725, 41.4848246286407]],
    [ "Garfield Substaiton",[-81.75769894265025, 41.46514944495225]],
    [ "Ibex Substation",[-81.61679283270233, 41.5347547315803]],
    [ "LTV East Substation",[-81.67608790789049, 41.453665860904906]],
    [ "1317478157",[-75.33806288650571, 43.10972204729213]],
    [ "Hodenpyl Dam Substation",[-85.82018312479646, 44.36275444389547]],
    [ "Substation 3",[-72.61636578844299, 44.55517808609236]],
    [ "Substation 2",[-72.60297613100543, 44.56180264482981]],
    [ "Stowe Electric Department",[-72.7423141, 44.49165130000001]],
    [ "Wolcott Substation",[-72.44459488082654, 44.53649488779852]],
    [ "South Walden Substation",[-72.29026346480518, 44.47143353100061]],
    [ "West Danville Substation",[-72.20456750000001, 44.4051693]],
    [ "West Danville-15 Substation",[-72.188578422698, 44.404991326831244]],
    [ "Fairbanks Substation",[-71.97530834821039, 44.428086990547534]],
    [ "St. Johnsbury Center Substation",[-72.00478457787622, 44.46541384633878]],
    [ "Hill Street Substation",[-71.99513716630508, 44.53329617865946]],
    [ "Industrial Park Substation",[-72.01211073661953, 44.49732138220476]],
    [ "Pudding Hill Substation",[-72.01522956548234, 44.55006419597555]],
    [ "Burke Mountain Substation",[-71.91712944999999, 44.59043844999999]],
    [ "East Montpelier Susbtation",[-72.48734590395503, 44.27317613095231]],
    [ "West River Electric Association",[-102.22751467499923, 44.08198784149882]],
    [ "Barre-26 Substation",[-72.50714697225622, 44.197793992696795]],
    [ "1318238557",[-75.26363997480004, 43.11203928723849]],
    [ "Rock of Ages-82 Substation",[-72.49027446567823, 44.15638423698627]],
    [ "Wetmore & Morse-58 Substation",[-72.4770382997039, 44.15473787782896]],
    [ "Websterville-61 Substation",[-72.4657765786552, 44.16165934385253]],
    [ "Mt. Knox Substation",[-72.3042436, 44.16740165]],
    [ "L67 Substation",[-96.93238809671409, 48.57019751782027]],
    [ "L3R Substation",[-96.93242546742081, 48.56942320033489]],
    [ "1318463950",[-96.90895367305849, 48.717398303304705]],
    [ "1318463966",[-96.9085923644713, 48.74573893166217]],
    [ "Legare-83 Substation",[-72.16963817002217, 44.20477391418345]],
    [ "Mcindoes Falls Substation",[-72.0605147563016, 44.25975474348952]],
    [ "Mcindoes Falls Substation",[-72.06084725413292, 44.259390717720024]],
    [ "Cleveland Public Power",[-81.6254460704993, 41.46243096087047]],
    [ "Cleveland Public Power",[-81.62575437298737, 41.46241116713454]],
    [ "1318653351",[-96.79978630835355, 32.53751117491423]],
    [ "1318653352",[-96.7998310303145, 32.53861721118774]],
    [ "Stephen Substation",[-96.8687595749132, 48.452586546378825]],
    [ "Watkins Road Station",[-75.0568862298921, 43.06325065361022]],
    [ "Village of Ilion",[-75.04147208073374, 43.01992212990271]],
    [ "Salisbury Station",[-74.845132680958, 43.065631530148664]],
    [ "1318922786",[-76.6604861, 41.05616625]],
    [ "1318925180",[-123.61953305805163, 46.5762160922975]],
    [ "1318997586",[-76.44973867385534, 40.80334433942861]],
    [ "1319015830",[-75.75502356971074, 43.33771711192634]],
    [ "1319113997",[-91.53028753378486, 42.57072913070919]],
    [ "1319124478",[-94.97335452457153, 42.69772900635407]],
    [ "1319124483",[-94.83601803769474, 42.70345593062525]],
    [ "1319124489",[-94.85046425000002, 42.84890275]],
    [ "1319124492",[-94.85456335127681, 42.84890938945862]],
    [ "1319124495",[-94.95389197505634, 42.836026841895475]],
    [ "1319124502",[-95.11203237473218, 42.86530949391689]],
    [ "Cleveland Public Power",[-81.69140934992201, 41.451813598901055]],
    [ "Air Products Substation",[-81.67939417007479, 41.47360132826899]],
    [ "Illuminating Comapny",[-81.68482952624676, 41.49109819003511]],
    [ "Horizon Substation",[-81.68820948675094, 41.49384700953882]],
    [ "Ridge Road Substation",[-81.73202075976047, 41.456494461421]],
    [ "Cleveland Public Power",[-81.73145350422519, 41.45697122931522]],
    [ "Industrial Substation",[-93.27598497980605, 45.88095687285882]],
    [ "1319238610",[-111.88612449457789, 33.235932904747756]],
    [ "1319321650",[-112.46685633395558, 42.895367023374796]],
    [ "Staheli Substation",[-113.50540364144216, 37.12927753573984]],
    [ "1319359044",[-112.57348726839369, 43.11063315005452]],
    [ "1319359046",[-112.59004318248947, 43.271265664518765]],
    [ "Riverton-62 Substation",[-72.63336942301315, 44.200423063483264]],
    [ "Norwich University Substation",[-72.66463945000001, 44.1390345]],
    [ "Moretown Substation",[-72.71977799008715, 44.276392165579125]],
    [ "Mountainview-27 Substation",[-72.5874984245114, 44.25465355643466]],
    [ "Berlin-5 Substation",[-72.60340649999999, 44.2505029]],
    [ "Middlesex Dam 2 Substation",[-72.68412653403082, 44.29222506690505]],
    [ "Little River-22 Substation",[-72.770345430052, 44.3803086943255]],
    [ "1319707419",[-97.38647415143912, 32.90284392848225]],
    [ "1319739872",[-98.90800845, 36.34819405]],
    [ "Waterbury Center-47 Substation",[-72.7268906, 44.37296145]],
    [ "Richmond Substation",[-73.00384394999999, 44.42445535]],
    [ "Sandhill Road-33 Substation",[-73.05063125000001, 44.482597500000004]],
    [ "Cleveland Hopkins Airport Substation",[-81.84603444179585, 41.39810261141501]],
    [ "Illuminating Comapny",[-81.85329184817124, 41.39527869637525]],
    [ "Illuminating Comapny",[-81.85301418579628, 41.395382981603454]],
    [ "1320211825",[-93.42371374449219, 41.109984321462036]],
    [ "1320212486",[-93.60720750236197, 41.35697982884809]],
    [ "1320212492",[-93.54363591900976, 41.36928288736171]],
    [ "1320213047",[-94.01298586198997, 41.26560570793569]],
    [ "1320218208",[-94.01236070773194, 41.33706403434084]],
    [ "Aristech Chemical Substation",[-80.08234462302914, 40.49545219027967]],
    [ "LaCreek Electric Association",[-101.70223218790332, 43.11842687563452]],
    [ "1321412609",[-94.93885573423155, 42.77744883251001]],
    [ "1321412612",[-94.65435767923924, 42.71742890746839]],
    [ "1321412619",[-94.62877565, 42.849933750000005]],
    [ "1321412623",[-94.62998806173495, 42.93742587498235]],
    [ "1321412630",[-94.44537925, 42.9610522]],
    [ "1321412631",[-94.56021022500165, 42.89235949334124]],
    [ "1321412640",[-94.4623669891079, 42.74740162506903]],
    [ "1321412643",[-94.44347143810668, 42.74660897506622]],
    [ "1321412647",[-94.36498533724728, 42.703007169243484]],
    [ "1321412654",[-94.52120438986788, 42.52586928764748]],
    [ "1321413080",[-95.17145064760187, 42.865929662333]],
    [ "1321413084",[-95.13131269974909, 42.82230685018467]],
    [ "1321414763",[-94.15880667521535, 42.760841694158614]],
    [ "1321414768",[-94.16128861121823, 42.98089672454201]],
    [ "1321453609",[-80.33942540743207, 40.67095958057716]],
    [ "1321453610",[-80.336501059527, 40.670569839533954]],
    [ "1321453611",[-80.3208808, 40.7128817]],
    [ "Florida Power & Light",[-81.79246011763597, 26.151220745643293]],
    [ "1321507357",[-80.44898920413785, 40.63246972922397]],
    [ "1321638430",[-112.43515698146001, 41.64326216173147]],
    [ "1321644142",[-95.0516131636103, 42.31321968088851]],
    [ "1321644147",[-95.00016618523944, 42.4233828599349]],
    [ "1321644154",[-94.9543088, 42.5175502]],
    [ "1321645324",[-95.14797542491884, 42.283244293775574]],
    [ "Koppel Steel Substation",[-80.2297825068289, 40.608828168309174]],
    [ "Gringo Substation",[-80.26475241250034, 40.568017168678146]],
    [ "LaCreek Electric Association",[-101.5412102, 43.5774644]],
    [ "1321695539",[-92.3766859, 43.26204499999999]],
    [ "1321695541",[-92.35787085493686, 43.184371752290495]],
    [ "1321695545",[-92.35829755000002, 43.16875235]],
    [ "1321695546",[-92.35805801286291, 43.16897258074952]],
    [ "1321734959",[-93.28157709999999, 42.95072265]],
    [ "1321735386",[-93.37146469999999, 42.759848049999995]],
    [ "1321735805",[-94.08816813816209, 43.16901892514833]],
    [ "1321736555",[-93.60999865, 42.86304900000001]],
    [ "1321739762",[-111.94098655, 41.013122]],
    [ "Sacramento Municipal Utility District",[-121.47253721892999, 38.65686451621036]],
    [ "LaCreek Electric Association",[-101.72064123247903, 43.505899725155366]],
    [ "Duquesne Light",[-80.27239231072603, 40.48850374827073]],
    [ "Duquesne Light",[-80.27040716185424, 40.48592932722126]],
    [ "Florida Power & Light",[-81.74194846192688, 26.09380008232766]],
    [ "1322750193",[-94.134799988484, 45.969666324994165]],
    [ "Mount Nebo Substation",[-80.08639003578779, 40.53491244497954]],
    [ "Florida Power & Light",[-81.9813895118063, 27.33424386582546]],
    [ "Elisha Substation",[-95.14904423590012, 47.01760715998075]],
    [ "Blueberry Substation",[-95.13860261008082, 46.7367802358742]],
    [ "Straight River Substation",[-95.15098068829951, 46.81978922543934]],
    [ "Pipeline Substation",[-95.1492908507239, 46.819616784985655]],
    [ "Raintree Substation",[-82.11039124354168, 27.025989689860793]],
    [ "1323036168",[-76.21688914974945, 42.58579806673222]],
    [ "Starr Road Station",[-76.19894681675325, 42.583445046645096]],
    [ "1323036178",[-76.1575788716723, 42.596347165792565]],
    [ "1323036179",[-76.15786994999999, 42.59539005]],
    [ "1323053500",[-95.01216509999999, 46.83719745]],
    [ "Twin Lakes Substation",[-95.01710014108292, 46.776515813786446]],
    [ "Red Eye Substation",[-95.0808130472314, 46.6696620850548]],
    [ "Wapebo Substation",[-94.2796802, 46.91696845]],
    [ "1323090126",[-94.95250933691739, 46.950447024407104]],
    [ "1323090128",[-94.73746389162179, 47.00172857929913]],
    [ "1323093024",[-94.58841787896372, 47.0857536306524]],
    [ "TECO",[-82.34565330777008, 27.958824165167464]],
    [ "1323295946",[-76.13565019479553, 42.58559391318255]],
    [ "McGraw Station",[-76.10262403325741, 42.59306970151133]],
    [ "Cuyler Station",[-75.95963161213616, 42.73875370905613]],
    [ "1323304694",[-79.78948361393319, 40.53756634171915]],
    [ "Trent Substation",[-85.87624473236855, 43.255899449728204]],
    [ "1323416306",[-92.11919878791733, 44.186152375030105]],
    [ "1323416315",[-92.24802523797584, 44.13020422534313]],
    [ "1323421490",[-92.47086393183879, 43.848554975824854]],
    [ "1323421496",[-92.73373535000002, 43.385938749999994]],
    [ "1323421499",[-92.73277527498163, 43.2772994541638]],
    [ "1323427760",[-92.55464170934219, 43.349139928663824]],
    [ "1323427765",[-92.59456927478874, 43.320878955994054]],
    [ "Miller Street Station",[-76.18470917109845, 42.61243938386402]],
    [ "Fisher Avenue Station",[-76.18805403576111, 42.61662465614244]],
    [ "Homer Station",[-76.17621363926028, 42.63684041573405]],
    [ "National Grid",[-76.15085115000001, 42.625756]],
    [ "Lorings Station",[-76.15022981549401, 42.6271183515407]],
    [ "1323440163",[-91.90910187493404, 43.45719984396696]],
    [ "1323440166",[-91.75788178901949, 43.42186572485418]],
    [ "1323442974",[-76.21410585000001, 42.584696599999994]],
    [ "1323442975",[-76.2334689210414, 42.55816911822253]],
    [ "1323442976",[-76.23450429999998, 42.55969235]],
    [ "1323444041",[-92.08073639999998, 43.37280365]],
    [ "1323444043",[-92.09517949819545, 43.24171525062585]],
    [ "1323444048",[-92.09137767493525, 43.14129449316267]],
    [ "1323444050",[-92.21963912452823, 43.25476175521933]],
    [ "Ballina Station",[-75.84058396982753, 42.908422443562614]],
    [ "Pine River Substation",[-95.34033223561757, 47.036280831899866]],
    [ "Pleasant Lake Substation",[-94.46158912537317, 46.93650682692006]],
    [ "TECO",[-82.36375888649764, 27.954298090329058]],
    [ "Rathbun Station",[-75.85259459284046, 42.9932062537859]],
    [ "Ridge Road Station",[-75.86979858176544, 42.99277199344383]],
    [ "West Penn Power",[-79.73570467633608, 40.61303499701591]],
    [ "1323525369",[-79.72500309924858, 40.60769230903197]],
    [ "1323525370",[-79.72826285718297, 40.60697970559303]],
    [ "1323525371",[-79.72793092259485, 40.6107393817824]],
    [ "Leaf River Substation",[-95.09246781356178, 46.51461857239958]],
    [ "1323645149",[-91.40422090645608, 43.33761770022003]],
    [ "1323647178",[-91.17497439999998, 43.02385685]],
    [ "1323648961",[-91.47245184999998, 42.8713826]],
    [ "1323656895",[-112.57713118687813, 40.70172927436015]],
    [ "Saxonburg 2 Substation",[-79.7881896477409, 40.760025661007354]],
    [ "1323683238",[-113.00493692427784, 40.76321855488049]],
    [ "1323688179",[-112.7130659420179, 40.86994237890631]],
    [ "1323689671",[-112.65301466859668, 40.74062622471159]],
    [ "1323697441",[-112.2875204859507, 40.62417533122232]],
    [ "1323714755",[-112.18622780000001, 40.72663215]],
    [ "1323725573",[-76.06426550001898, 43.0001198166425]],
    [ "Lake Eunice Substation",[-95.95852076993384, 46.719950127201045]],
    [ "1323948784",[-96.08661889236475, 46.57635610731545]],
    [ "Erhard Substation",[-96.08825286321702, 46.50024267510124]],
    [ "Zephyr Wind LLC",[-95.79377469059536, 43.71826500506028]],
    [ "1323988220",[-91.96127709441163, 37.318711321323185]],
    [ "1323991297",[-92.13772760000002, 37.77570245]],
    [ "1323991302",[-92.13800093308268, 37.748661357122224]],
    [ "1323991305",[-92.10603417969786, 37.762380903936005]],
    [ "1323991773",[-91.95470299515524, 38.07235468500868]],
    [ "1323993307",[-92.21070761851516, 38.58821260695147]],
    [ "Maine Substation",[-95.81737159571048, 46.39723672124941]],
    [ "Otter Tail Power Company",[-95.31964755, 46.155324099999994]],
    [ "Port Angeles Light",[-123.4593959, 48.1120873]],
    [ "College Substation",[-123.41600012062176, 48.10151999182284]],
    [ "1324248097",[-92.44189943911417, 39.44286637471981]],
    [ "AT&T",[-76.11052200489283, 42.84512133230434]],
    [ "Palmer Creek Substation",[-95.55109743278204, 44.82573647955159]],
    [ "1324384782",[-96.73913062487031, 48.13643665629158]],
    [ "Oklahoma Gas & Electric",[-97.10408907729094, 36.11948862279219]],
    [ "Sentinel Heights Station",[-76.11556645, 42.9518938]],
    [ "Castle Rock Substation",[-93.15353393878151, 44.54411872542989]],
    [ "1324888731",[-76.11456383627555, 43.01213687364714]],
    [ "1324892392",[-77.83478932018677, 39.26319819734061]],
    [ "1324892393",[-78.74533285294262, 39.59300221173618]],
    [ "1324897255",[-91.7443262, 43.23405875]],
    [ "1324898793",[-91.50665592495996, 43.248007756040444]],
    [ "1324990939",[-92.20469865075576, 43.06731122313754]],
    [ "1324990949",[-92.3217716114417, 43.077360669799134]],
    [ "1324990969",[-92.38278350000002, 43.15486915000001]],
    [ "Duke Energy",[-82.51563863142289, 28.62523001521311]],
    [ "Duke Energy",[-82.60134237158627, 28.405523959158888]],
    [ "1325531322",[-91.9825809251128, 42.96535240608286]],
    [ "1325533120",[-92.28783243633201, 42.964806775931145]],
    [ "1325533125",[-92.1811486, 42.87690075]],
    [ "1325533126",[-92.1208885, 42.858598]],
    [ "1325534416",[-92.45643461184379, 42.98049337525018]],
    [ "1325854031",[-91.74602078952935, 42.91608382501716]],
    [ "1325864373",[-91.96324727487631, 42.8616703058678]],
    [ "1325946778",[-92.52033795840985, 42.81809678886917]],
    [ "1325946782",[-92.46932223799611, 42.735522519056104]],
    [ "1326006378",[-92.61410844999999, 42.73764805000001]],
    [ "1326006380",[-92.61415835863687, 42.73128365591612]],
    [ "1326048655",[-96.19100776806974, 40.36590881489928]],
    [ "1326051206",[-95.96847088248214, 40.174739925707]],
    [ "1326117511",[-76.27070066280001, 43.05292757515016]],
    [ "Westvale Station",[-76.22422535000001, 43.048791099999995]],
    [ "West Penn Power",[-79.81426086475663, 40.55136784724389]],
    [ "Rocky Mountain Power",[-111.85519607649496, 40.63449602437921]],
    [ "St. Francis Substation",[-100.89877601097257, 43.12787365617531]],
    [ "1326302433",[-91.42297181795533, 40.431023796900945]],
    [ "1326306422",[-91.4796952629775, 39.31954199073881]],
    [ "1326341219",[-76.29506325, 43.041363800000006]],
    [ "Marcellus",[-76.33455503133418, 42.9920573939769]],
    [ "1326351929",[-91.8007385, 42.84569270000001]],
    [ "1326353527",[-92.32999522469309, 41.315450689223326]],
    [ "Georgia Power",[-84.44617833190827, 30.856105403529078]],
    [ "Washington County Solar, LLC",[-84.44546801355183, 30.85497239994881]],
    [ "TECO",[-81.99334074808434, 27.7521708175164]],
    [ "Duke Energy",[-82.67436796992955, 29.017120731466104]],
    [ "1326386137",[-111.89333985312643, 40.68674363566362]],
    [ "1327391025",[-76.23560260318976, 43.0718665957069]],
    [ "Stiles Station",[-76.27355461353096, 43.11650522389575]],
    [ "National Grid",[-76.27459509699294, 43.10928054871956]],
    [ "1327391037",[-76.29998982347256, 43.136486097182875]],
    [ "Baldwinsville",[-76.33291272291851, 43.157652546222074]],
    [ "1327406971",[-92.22993823977043, 39.289893393453866]],
    [ "1327406974",[-92.42448301781779, 39.12886358499079]],
    [ "Hastings Substation",[-92.8942170956183, 44.69976167464319]],
    [ "Fay Street Station",[-76.40504721762593, 43.31308014352795]],
    [ "Third Street Station",[-76.41575045, 43.306143899999995]],
    [ "Fairdale Station",[-76.54790199677413, 43.32543887363431]],
    [ "1327713284",[-92.2963238, 41.39415350000001]],
    [ "1327713630",[-92.12261525, 41.36662104999999]],
    [ "1327859692",[-104.4733898749773, 32.839405657017906]],
    [ "1327859694",[-104.43068615, 32.83264615]],
    [ "1327869335",[-104.3903485248853, 32.84796755870242]],
    [ "1327869336",[-104.39083374999998, 32.8476833]],
    [ "1327869337",[-104.39348663584683, 32.8497416250899]],
    [ "1327869338",[-104.39389722481394, 32.849497704806]],
    [ "1327890293",[-96.99695448013146, 36.08799453181886]],
    [ "Wescott Substation",[-93.09922852952394, 44.799863120650514]],
    [ "Lebanon Hills Substation",[-93.12027003363629, 44.78914882240647]],
    [ "Steele-Waseca Cooperative Electric",[-93.28525281891703, 44.33397686347098]],
    [ "1327976638",[-76.42776930763017, 43.317156968750496]],
    [ "East Fulton Station",[-76.40013738395358, 43.32956068502945]],
    [ "1328016972",[-76.42506252741306, 43.3501355128072]],
    [ "1328016973",[-76.42485309999999, 43.35424025000001]],
    [ "High Dam",[-76.49695533064623, 43.44329956895722]],
    [ "1328140643",[-91.31594775, 39.41835604999999]],
    [ "WestRock CP LLC",[-84.1412841666794, 30.86264441186007]],
    [ "Constantia Station",[-76.00101951567969, 43.25095970674318]],
    [ "West Cleveland Station",[-75.93928628905616, 43.244022292036995]],
    [ "Cleveland Station",[-75.88842217688916, 43.238097695136865]],
    [ "West Monroe Station",[-76.06840165, 43.27772445]],
    [ "1328281159",[-111.86860125172969, 40.645813416053215]],
    [ "1328403721",[-111.9711653388536, 40.58432159693663]],
    [ "Central Square Station",[-76.13752514724693, 43.29606750954867]],
    [ "Brewerton Station",[-76.14309757645302, 43.23607790556347]],
    [ "1328404555",[-76.11742435, 43.182314250000005]],
    [ "1328421958",[-92.43043075000001, 41.8883013]],
    [ "1328422324",[-92.05199705, 41.518114849999996]],
    [ "1328454043",[-111.89589886959027, 40.456896600720675]],
    [ "1328454045",[-111.87801774984074, 40.452135255524496]],
    [ "1328467648",[-112.04387760684756, 40.57187511358392]],
    [ "1328471262",[-76.190446, 43.124281249999996]],
    [ "1328473483",[-94.53479681573229, 46.78071697462946]],
    [ "Minnesota Power",[-94.49775194081575, 46.82059562480451]],
    [ "1328484260",[-103.12694281113409, 32.75501229615786]],
    [ "1328526292",[-97.33089166095168, 32.100019716906885]],
    [ "1328567376",[-92.55256629443072, 42.26045467461378]],
    [ "1328567377",[-92.55201907490934, 42.26026900571051]],
    [ "Sand Road Station",[-76.14162678588237, 43.10918347609766]],
    [ "1328570695",[-76.14803314450957, 43.08669688299977]],
    [ "1328621195",[-111.43677045786018, 40.49645620525491]],
    [ "1328632373",[-111.42734676305284, 40.58855442287023]],
    [ "1328639726",[-111.3678989609676, 40.7522981158458]],
    [ "1328639730",[-111.39906106074228, 40.91252831905821]],
    [ "1328685158",[-92.78680122496425, 42.388168504408036]],
    [ "1328685161",[-92.77190275, 42.36315485]],
    [ "1328687288",[-92.89889712507316, 42.514292494312286]],
    [ "1328687290",[-92.89984959228475, 42.58476582487783]],
    [ "1328687293",[-92.89894939999999, 42.6293212]],
    [ "1328687296",[-92.88929012497779, 42.68606345696204]],
    [ "1328693075",[-92.9663646750532, 42.68556545575428]],
    [ "1328693078",[-92.97061899387033, 42.74457615295651]],
    [ "1328695522",[-92.6422874323822, 42.64270357503269]],
    [ "1328695524",[-92.61391496294172, 42.72979413082577]],
    [ "1328696426",[-93.02226135000001, 42.382274900000006]],
    [ "Municipal Electric Authority of Georgia",[-83.9915060999593, 30.856704686434917]],
    [ "1329244754",[-76.20243581433793, 43.13610728178127]],
    [ "1329244755",[-76.20445872590714, 43.13584745827265]],
    [ "1329244761",[-76.0988359, 43.0730881]],
    [ "1329612042",[-92.99930277508047, 42.02182725637246]],
    [ "1330098722",[-94.8576607, 40.41731155]],
    [ "Rock City Station",[-74.86705332497606, 43.031650761543915]],
    [ "1330147470",[-74.96803227916729, 43.03372505527098]],
    [ "1330158692",[-94.10981641679139, 40.78216036654098]],
    [ "1330158702",[-93.93917467495609, 40.8007085942991]],
    [ "1330284816",[-111.62131204895529, 40.18999078135504]],
    [ "1330309593",[-94.0914524592175, 40.85556752041172]],
    [ "1330310013",[-93.914419975084, 40.82094784158574]],
    [ "1330310329",[-94.28081051464983, 40.71152082081074]],
    [ "Frankfort Station",[-75.06148845, 43.037408649999996]],
    [ "1330311343",[-94.35539346401292, 41.117435118778495]],
    [ "1330311345",[-94.415039441098, 41.222669775353644]],
    [ "1330311348",[-94.26020685000002, 41.0525123]],
    [ "1330311585",[-94.22917578444216, 41.048863576415975]],
    [ "1330312145",[-94.60435960000001, 41.09348615]],
    [ "1330312146",[-94.87239095000001, 41.08660145000001]],
    [ "1330476844",[-75.08220921719541, 43.044855574901305]],
    [ "1330476876",[-75.1930082813796, 43.0984774745606]],
    [ "1330494036",[-93.22056718974605, 43.16511517474352]],
    [ "1330512819",[-75.25090191798603, 42.97774264067355]],
    [ "1330515298",[-110.75465451263273, 39.64534249920141]],
    [ "1330519224",[-110.39161466710098, 39.54652356640631]],
    [ "1330519228",[-110.40875761782881, 39.351800707727456]],
    [ "1330519231",[-110.34726260000001, 39.42616725000001]],
    [ "Joseph",[-117.23144800855587, 45.34887611961498]],
    [ "Nashwauk Public Utiilites",[-93.16631901403488, 47.381843090456435]],
    [ "1330762822",[-93.62533929661299, 41.71785270229623]],
    [ "1330774349",[-75.17863065, 43.079706]],
    [ "1330774350",[-75.18105134999999, 43.08512155]],
    [ "Conkling Station",[-75.2264147956362, 43.08931297928091]],
    [ "Pleasant Station",[-75.25080512864494, 43.08731935614065]],
    [ "Arnold Station",[-75.26778880813542, 43.089495155151496]],
    [ "1330892861",[-94.73580812479734, 40.986965059160156]],
    [ "1330892862",[-94.7654159, 40.9795507]],
    [ "1330892866",[-94.71954165, 40.9214532]],
    [ "1330892873",[-95.0237960693096, 40.98726523724502]],
    [ "Laporte Substation",[-95.13597493213263, 47.20988232711369]],
    [ "1331173594",[-94.98527397764796, 41.15374130548583]],
    [ "1331176092",[-94.55879664999999, 40.880303850000004]],
    [ "1331426937",[-94.18824466248698, 43.33433133046523]],
    [ "1331481579",[-93.57579032436946, 39.79623474357863]],
    [ "1331481584",[-93.55910118658373, 39.77863096903204]],
    [ "1331481589",[-93.5533015173425, 39.79741077477903]],
    [ "1331481591",[-93.55406267472121, 39.80294589511354]],
    [ "1331730055",[-96.51760007521167, 48.5805812538825]],
    [ "Kandiyohi Cooperative Electric Power Association",[-95.04268336486076, 44.92041751277955]],
    [ "Gregory Substation",[-99.4302951996848, 43.21307133604642]],
    [ "1332520771",[-92.44754362424707, 41.0232812700835]],
    [ "1332522725",[-92.5631385751173, 41.02059859035372]],
    [ "1332522726",[-92.70205174699771, 40.99337186870125]],
    [ "1332530321",[-91.97474352589707, 44.62995357537351]],
    [ "1332534253",[-92.18072907494883, 42.774104856080534]],
    [ "1332535350",[-92.10083355, 42.7152198]],
    [ "1332535526",[-110.38723940021848, 40.21416532560213]],
    [ "1332537236",[-109.4668159, 40.4011726]],
    [ "1332611877",[-92.4163277351762, 43.184201425068125]],
    [ "1332611880",[-92.67851531020943, 43.16925702987539]],
    [ "1332655485",[-109.51064813707164, 40.138153325313375]],
    [ "1332667014",[-109.41933658500541, 40.03588387493563]],
    [ "1332677852",[-109.42109076570418, 40.57273552113104]],
    [ "Public Service Enterprise Group",[-74.47125673407515, 40.47224167474056]],
    [ "1332753873",[-108.22741414999999, 40.083050899999996]],
    [ "1333043542",[-92.9970417322818, 40.68107008451878]],
    [ "1333043545",[-93.10653066403334, 40.71733632481324]],
    [ "1333043548",[-93.21252163084311, 40.71724576214737]],
    [ "1333043551",[-93.317771330905, 40.84104061639416]],
    [ "1333043557",[-93.39323037483179, 40.94084269433844]],
    [ "1333078534",[-93.36468097919638, 40.75625432079554]],
    [ "1333212368",[-93.4989494215243, 40.797551789494165]],
    [ "1333212369",[-93.49820910000001, 40.7032863]],
    [ "1333222844",[-74.71207118881121, 40.555579276616015]],
    [ "1333371488",[-93.93938077506472, 40.65304679453724]],
    [ "1333593671",[-93.93408415908209, 40.62298350279344]],
    [ "1333593672",[-93.96337142160475, 40.728543642527214]],
    [ "Watertown Substation",[-93.83906194999999, 44.9593205]],
    [ "1334392096",[-92.5004461149558, 39.74970954726969]],
    [ "1334598856",[-95.12273789629187, 43.29854688672072]],
    [ "1334598858",[-95.22863561494361, 43.328282831842884]],
    [ "1334638408",[-110.67571913442399, 41.412519382368465]],
    [ "Arrowhead Substation 345/230 kV",[-92.29397442913707, 46.77157030813031]],
    [ "1334899034",[-95.28945349400374, 41.15221720132349]],
    [ "1334905991",[-95.36894086121305, 40.33715122544516]],
    [ "1334905995",[-95.38739195000001, 40.43709590000001]],
    [ "1334951664",[-111.90342525103172, 43.626996154415615]],
    [ "1335824950",[-111.91147104999999, 32.80791995]],
    [ "1336339307",[-94.97483135, 39.99143275]],
    [ "1336668919",[-74.62445900498632, 40.39479492950654]],
    [ "Hollydale Substation",[-93.50541186024806, 45.02675962971438]],
    [ "East River Electric Power Cooperative",[-98.45217600663258, 43.86387162478774]],
    [ "Mount Vernon Substation",[-98.26545741527632, 43.707982036706326]],
    [ "1337157235",[-95.90784611862598, 37.02762613596861]],
    [ "1337278814",[-95.67498095468238, 32.61698571059111]],
    [ "1337278816",[-95.70393305003334, 32.65511250156336]],
    [ "1337278823",[-95.58230882354319, 32.43078185082521]],
    [ "1337278831",[-95.37134736936224, 32.4344561611446]],
    [ "1337284395",[-95.84785397509543, 32.328764446780276]],
    [ "1337284399",[-95.72285585813782, 32.47247889272756]],
    [ "1337284404",[-95.72139615, 32.471834799999996]],
    [ "1337284405",[-95.72569224282873, 32.472407957668466]],
    [ "1337286542",[-95.59415189958223, 32.246261228283586]],
    [ "1337286544",[-95.65094000377569, 32.17293944421327]],
    [ "1337286546",[-95.52430174680224, 32.10345473772441]],
    [ "1337286550",[-95.39556387761748, 32.0505138588529]],
    [ "1337286554",[-95.39455951591377, 32.126866150804446]],
    [ "1337286556",[-95.51409220663412, 31.821517440261893]],
    [ "1337286942",[-96.21282219840403, 31.69539492152526]],
    [ "1337286944",[-96.21414774492119, 31.71123758381896]],
    [ "1337286947",[-96.18072079762275, 31.710103683927716]],
    [ "1337287723",[-96.40299980322324, 31.770123566478517]],
    [ "1337287725",[-96.3952833, 31.777542699999994]],
    [ "1337287729",[-96.46867790191763, 31.781170264239567]],
    [ "1337287731",[-96.42732051591202, 31.925844430805594]],
    [ "1337288126",[-96.31254334243992, 32.54003719133277]],
    [ "1337288957",[-96.35003626666666, 31.915651976682046]],
    [ "1337288962",[-96.28106145479396, 32.03897124211817]],
    [ "1337288964",[-96.20615753890878, 32.04127459595196]],
    [ "1337290721",[-96.35770910797554, 32.26139596579257]],
    [ "1337292649",[-96.70062218917708, 32.23318187814899]],
    [ "1337292650",[-96.69992304467453, 32.23264898883858]],
    [ "1337313465",[-112.26175848881356, 38.510759225062024]],
    [ "1337313467",[-112.22685172458685, 38.44721939440071]],
    [ "1337313511",[-111.99821235, 38.84198295]],
    [ "1337313516",[-112.0734308750701, 38.769752258127134]],
    [ "1337313521",[-112.10898225401444, 38.70329970708378]],
    [ "1337313546",[-112.22724651218586, 38.23787002467231]],
    [ "Mineral Products Substation",[-112.2489301604076, 38.37984621703205]],
    [ "1337313557",[-112.25030342482562, 38.16434864336279]],
    [ "Kaibab Substation",[-112.44955881342732, 37.82544418909184]],
    [ "Spry Substation",[-112.45093065701035, 37.82676097495598]],
    [ "East Valley Substation",[-112.0269964670059, 37.632661498142866]],
    [ "1337313690",[-112.51248905, 36.935350099999994]],
    [ "Ranchos Substation",[-112.54138865000002, 37.040016400000006]],
    [ "Henrieville Substation",[-111.92960513945168, 37.591258223982614]],
    [ "1337372622",[-95.85729458951297, 32.486447450033864]],
    [ "1337453010",[-96.77042073641115, 32.55883983662101]],
    [ "1337599490",[-112.82967367359365, 43.54351155597904]],
    [ "1337599492",[-112.66378922547611, 43.59270547251579]],
    [ "1337621558",[-113.37266677504302, 37.14084339457474]],
    [ "1337621635",[-113.35839340000001, 37.185594699999996]],
    [ "1337621640",[-113.39118096173304, 37.21023311295057]],
    [ "1337621645",[-113.42346515168212, 37.165465282778584]],
    [ "1337621673",[-113.43795932064414, 37.15487793024281]],
    [ "1337621720",[-113.56345151276452, 37.03109316060172]],
    [ "1337621744",[-113.58657552999125, 37.05201865286633]],
    [ "1337621753",[-113.62289295330771, 37.04307959091119]],
    [ "1337621754",[-113.62692634999999, 37.042394900000005]],
    [ "1337621783",[-113.63968346560199, 37.130903998681546]],
    [ "Public Service Enterprise Group",[-74.65792425493225, 40.25495339573321]],
    [ "1337873344",[-114.76120648148031, 36.49294893429974]],
    [ "1337873428",[-114.22735255015775, 36.73999235157779]],
    [ "1337873454",[-114.78503925, 36.76537265]],
    [ "1337997357",[-96.98224700693785, 32.18349633867916]],
    [ "1337997365",[-96.89309265542907, 32.18695942713552]],
    [ "1338135200",[-97.06180023258386, 31.952866155948364]],
    [ "1338507985",[-96.39183729999998, 33.509297450000005]],
    [ "1338507987",[-96.32745737442195, 33.42940060672885]],
    [ "1338531922",[-96.72230631341073, 33.00169501259151]],
    [ "1338532285",[-96.76261001354298, 32.92021258215113]],
    [ "1338532385",[-96.7022870474193, 33.01365098341416]],
    [ "1338533651",[-96.84890461144381, 33.75293083447661]],
    [ "1338534336",[-97.07896765159832, 33.68100621912812]],
    [ "1338534339",[-97.04199729191454, 33.612569983748635]],
    [ "Thermo Substation",[-113.19634617561766, 38.16060887987091]],
    [ "1338543112",[-113.1301076, 38.4841378]],
    [ "Lower Beaver Substation",[-112.52010516686956, 38.2598708991971]],
    [ "Garkane Energy Cooperative",[-113.0048093083857, 37.002949278322795]],
    [ "1338543259",[-113.10971305685845, 37.08293616117023]],
    [ "1338620074",[-97.2109305872715, 33.213330513259535]],
    [ "1338620077",[-97.21084442522086, 33.217183840345065]],
    [ "1338650870",[-97.07135748044368, 33.229054306763096]],
    [ "1338943681",[-97.32981758803263, 33.64019091346837]],
    [ "1338977931",[-96.00394429178655, 35.668463496323945]],
    [ "1339058551",[-97.04752906215829, 33.494608275107026]],
    [ "1339059222",[-97.18287681332016, 33.48678515314424]],
    [ "1339067165",[-96.24353878187704, 33.38320093009167]],
    [ "1339067168",[-96.36148700000003, 33.16057055]],
    [ "1339072053",[-96.2492721852977, 33.56425175055231]],
    [ "1339072060",[-96.25827938145268, 33.55466809630948]],
    [ "1339075294",[-96.35055341368573, 32.916574592553026]],
    [ "1339075299",[-96.2534887654173, 32.91406608412326]],
    [ "1339075301",[-96.11928516750827, 32.933653718417425]],
    [ "1339075308",[-96.07531300743386, 33.004497229648756]],
    [ "1339076592",[-96.31105589719276, 32.90076501628898]],
    [ "1339083773",[-97.67552593354714, 32.9629597240559]],
    [ "1339092290",[-98.00268202443763, 33.096838926129465]],
    [ "1339092294",[-97.86062797427645, 32.9206649208537]],
    [ "1339092296",[-97.92650201994599, 32.92007975104459]],
    [ "1339092297",[-98.02853493871392, 32.92038197503357]],
    [ "1339108197",[-97.49633332331904, 33.129294932975235]],
    [ "1339151981",[-98.28804706484259, 34.50102681819098]],
    [ "1339154855",[-96.4551260494299, 33.829908645166626]],
    [ "1339154856",[-96.45516539171962, 33.830669024776235]],
    [ "1339154857",[-96.45447311175536, 33.82989452511927]],
    [ "1339154859",[-96.33621045345592, 33.81622022185594]],
    [ "1339154862",[-96.25375407510705, 33.80865938873289]],
    [ "1339156743",[-97.99574683350878, 34.01623847616733]],
    [ "1339156745",[-98.04745217729365, 34.270662938964314]],
    [ "1339156831",[-101.9053717408021, 32.242002229275656]],
    [ "1339157772",[-96.40476127830613, 32.77220589750835]],
    [ "1339160531",[-96.87825523400112, 37.84251302495212]],
    [ "1339160536",[-96.86126132560638, 37.842848475313566]],
    [ "1339241796",[-97.70563143919028, 32.88796411044742]],
    [ "1339241801",[-97.72264336720039, 32.95938941014651]],
    [ "Rest Lake Substation",[-89.89007331155673, 46.14264163911767]],
    [ "Presque Isle Substation",[-89.72915292006503, 46.24947774418387]],
    [ "1339361035",[-95.93870158895135, 33.63524287472411]],
    [ "1339361036",[-95.9389542201773, 33.63632697754995]],
    [ "1339361040",[-95.95061144068707, 33.70278656083249]],
    [ "1339361401",[-111.56601971645894, 32.85221042372262]],
    [ "River Point Substation",[-93.22536097505078, 43.92195725809937]],
    [ "River Point Substation #8",[-93.22551658132176, 43.921290386182065]],
    [ "1339960725",[-75.25854751667094, 39.72376799798652]],
    [ "Connexus Energy",[-93.30683771047723, 45.21969277429342]],
    [ "Golf Interconnect",[-96.10378700227533, 44.09437998098449]],
    [ "1340670700",[-116.27297809079722, 43.468967461654344]],
    [ "1340675112",[-116.38238983580547, 44.94966973351479]],
    [ "1340675114",[-116.26945977292598, 44.96293971266513]],
    [ "1340751604",[-93.76820880459417, 31.248276720828436]],
    [ "1340751607",[-94.35091369477956, 31.519357031526617]],
    [ "1340751612",[-94.4115540242122, 31.642304656409834]],
    [ "1340871087",[-95.8610741595414, 28.8349440241605]],
    [ "1340872584",[-96.10808545890788, 29.120118643861385]],
    [ "1340872590",[-96.14280587276878, 29.15889851300494]],
    [ "1340872592",[-96.14989095288985, 29.155953032780875]],
    [ "1340872594",[-96.14885843519532, 29.157280462204984]],
    [ "1340873336",[-95.4463756033511, 29.16805584636604]],
    [ "Kennebec Substation",[-99.86026848300824, 43.9087813663207]],
    [ "Vivian Substation",[-100.29155995704014, 43.92998547546582]],
    [ "Draper Substation",[-100.53709789999999, 43.92798255]],
    [ "Murdo Substation",[-100.70616758869636, 43.89366952507614]],
    [ "Belvidere Substation",[-101.27178978513774, 43.83817962586495]],
    [ "Kadoka Substation",[-101.50812698922623, 43.84080887480552]],
    [ "West Central Electric Cooperative",[-101.66042185000002, 43.9240801]],
    [ "Phillip Substation",[-101.6666159548423, 44.03798997916681]],
    [ "North Phillip Substation",[-101.66233388678314, 44.04885721924571]],
    [ "1340903410",[-89.54280104879848, 37.66854759460767]],
    [ "1341010984",[-94.23821029666554, 31.935703928293044]],
    [ "1341015235",[-94.19084827705872, 32.36670088073406]],
    [ "1341015237",[-94.14278453977953, 32.13052025801767]],
    [ "1341015240",[-94.17099834896929, 32.30633466641853]],
    [ "1341015533",[-94.22113610629543, 32.61030386407601]],
    [ "1341041573",[-96.91233947275275, 32.66139513969276]],
    [ "1341041575",[-96.86158055, 32.66153330000001]],
    [ "1341075894",[-106.19725984673565, 46.81754438405715]],
    [ "1341140024",[-101.22938966285884, 37.14062245534956]],
    [ "1341140040",[-101.24749721323856, 37.14246351907622]],
    [ "1341140041",[-101.24981256185477, 37.14283640928242]],
    [ "1341153306",[-113.04211243511233, 43.502282731977274]],
    [ "Black Mountain Substation",[-111.09067585762986, 32.16844415756733]],
    [ "1341412577",[-99.87197155271758, 36.27796447935665]],
    [ "1341416907",[-99.47192464342628, 36.436854446346395]],
    [ "1341419765",[-96.2514698, 35.30434645]],
    [ "1341419768",[-96.24720290623063, 35.24710002316549]],
    [ "Consumers Energy",[-85.14399925175346, 42.33745658237515]],
    [ "1341979489",[-111.18649368029662, 32.423962846187294]],
    [ "Adonis Substation",[-111.19233303638418, 32.4763670744878]],
    [ "1341979551",[-111.23692483228557, 32.38037192408924]],
    [ "1342285642",[-98.21442287391349, 31.74980344377577]],
    [ "1342286231",[-99.10757459029179, 32.404483688790165]],
    [ "1342548518",[-95.5713636803925, 31.626779304776246]],
    [ "1342600835",[-77.6469831563307, 36.47977137042476]],
    [ "1342698806",[-95.0958888745709, 35.58715200991346]],
    [ "1342698807",[-95.0943543085542, 35.614664758583636]],
    [ "1342700026",[-96.8521619312449, 37.824532825149035]],
    [ "1342706659",[-103.92731948160943, 31.79181125588083]],
    [ "1342708163",[-106.30665544996188, 32.068492374182235]],
    [ "1342720929",[-76.67130945000001, 37.156370200000005]],
    [ "1342727183",[-111.24309086669905, 36.116826801128305]],
    [ "1342727190",[-111.40150582484577, 35.97665620422758]],
    [ "1342727198",[-111.57247167108667, 35.400840964883095]],
    [ "1342727200",[-111.50983284999998, 35.66685115]],
    [ "1342727201",[-111.45743842931934, 35.763626343622924]],
    [ "1342736665",[-78.49372371973372, 42.26591467888553]],
    [ "1342736670",[-78.64212570535358, 42.25909705332969]],
    [ "1342757554",[-112.74400683900528, 45.2356317964157]],
    [ "Mexican Hat Substation",[-109.8827668087246, 37.1322754394424]],
    [ "Nuclear Substation",[-109.50338645, 37.537532549999995]],
    [ "1342766698",[-109.2942663432375, 37.21930090976255]],
    [ "1342779596",[-112.52477490907057, 45.93023882913266]],
    [ "1342983929",[-107.97741187925223, 36.69711128935773]],
    [ "1342983938",[-108.1796455220021, 36.760427360969665]],
    [ "1342984011",[-108.12095617473611, 36.484208265208956]],
    [ "1342984013",[-108.12071074999999, 36.488132650000004]],
    [ "Amber",[-97.8586203971101, 35.14485435439657]],
    [ "1343193974",[-95.86637215991864, 31.813858466885442]],
    [ "1343193975",[-95.81757905151979, 31.92145089511012]],
    [ "1343918485",[-103.94466862224652, 32.41455044240851]],
    [ "1343918506",[-104.41204432485364, 32.92965225365994]],
    [ "1343918507",[-104.55036479999998, 32.944492849999996]],
    [ "1343918509",[-104.46039460000001, 32.67040195]],
    [ "1343918511",[-104.3955689694226, 32.84010547391271]],
    [ "1343918513",[-104.39529639516104, 32.84452829007936]],
    [ "1343918531",[-104.41166738703359, 32.74023233108577]],
    [ "1343918535",[-104.4129300248427, 32.83617589297618]],
    [ "1344477844",[-104.72333750006553, 39.8046795674157]],
    [ "West Yard Substation",[-75.57031535818186, 39.72863089431971]],
    [ "1344590153",[-103.39450639027108, 32.90743252493109]],
    [ "1344685160",[-102.88876920000001, 33.0077503]],
    [ "1344685161",[-102.97444365000001, 33.007671]],
    [ "1344685166",[-102.87597256152635, 33.0027543264226]],
    [ "1344685188",[-102.96094039371616, 32.99533062498287]],
    [ "1344685216",[-103.04859400513482, 32.93060277496239]],
    [ "1344685218",[-103.01429390000001, 32.8738151]],
    [ "1344801475",[-102.45935564999999, 42.65797725000001]],
    [ "1344826240",[-108.59432933820008, 45.8580508801288]],
    [ "Rimrock Substation",[-108.49869046506964, 45.799606676582606]],
    [ "1344833737",[-103.18020645933774, 32.82853306199019]],
    [ "1344864998",[-84.71911711750677, 41.18719627750141]],
    [ "1344865003",[-84.55140390945041, 41.28522837511659]],
    [ "1344865005",[-84.40011435464056, 41.235863767338095]],
    [ "Latty co-op Substation",[-84.59216147200152, 41.062487881864335]],
    [ "1344907253",[-102.91484229999999, 32.71863349999999]],
    [ "1344907281",[-102.85604286018578, 32.95493882498667]],
    [ "1344907282",[-102.81840012601985, 32.98785454597192]],
    [ "1344907286",[-102.8468325250616, 32.98100719581395]],
    [ "1344907290",[-102.82052945, 32.94360595]],
    [ "1345168456",[-84.7248920807152, 41.092357864022745]],
    [ "1345266254",[-102.76659104999999, 33.022821949999994]],
    [ "1345266296",[-102.5336126, 32.9634729]],
    [ "1345266303",[-102.69018215, 32.964529500000005]],
    [ "1345335666",[-103.0036512392871, 33.17431292517301]],
    [ "1346106731",[-102.29099263341668, 33.1958429749385]],
    [ "1346106733",[-102.28302020775456, 33.1804823054414]],
    [ "1346106734",[-102.33656017481088, 33.123650461901875]],
    [ "1346106830",[-111.29960248241072, 32.55184887790992]],
    [ "1346106855",[-111.30038569319935, 32.551916324959365]],
    [ "1346171651",[-83.66337084243877, 41.40717014283597]],
    [ "1346212652",[-102.27915707504155, 32.91577059561837]],
    [ "1346212656",[-102.2447846398596, 32.856733271157275]],
    [ "1346212658",[-102.24569080000002, 32.85657955]],
    [ "1346212669",[-102.28021433206567, 32.85857386001551]],
    [ "1346212672",[-102.2953795750643, 32.839081403895634]],
    [ "1346212674",[-102.27899319999999, 32.9582075]],
    [ "1346212676",[-102.36537549999998, 32.8565494]],
    [ "1346304215",[-99.70529773434514, 33.59028488473962]],
    [ "1346307285",[-97.28458605582489, 32.64375519270619]],
    [ "1346322459",[-102.32650776905845, 33.34139301320416]],
    [ "1346322461",[-102.1853153, 33.38401545000001]],
    [ "1346322463",[-102.32734053174096, 33.38439265303676]],
    [ "1346322481",[-102.05002859999999, 33.32526595]],
    [ "1346322483",[-102.20563317519617, 33.19524061130175]],
    [ "1346322487",[-102.12240726995495, 32.91200563790114]],
    [ "1346322489",[-102.12676439999998, 32.8100084]],
    [ "Okefenoke Rural Electric Membership Corporation",[-81.68751840050129, 30.763778723221066]],
    [ "Georgia Power",[-81.68209707795842, 30.841222591306778]],
    [ "1346644394",[-81.67947104583445, 30.840911390822868]],
    [ "1346758866",[-84.00694015246575, 41.443816717796025]],
    [ "1346765030",[-102.50253312443463, 33.59113315766983]],
    [ "1346765078",[-102.35194424200141, 33.57177842486424]],
    [ "1346765082",[-102.41098545000001, 33.5103139]],
    [ "1346765101",[-102.34920077539991, 33.46555634593334]],
    [ "1346765103",[-102.4454525, 33.4075504]],
    [ "1346874114",[-102.48821277465193, 33.48749690429115]],
    [ "1346874135",[-102.6127082, 33.44943965]],
    [ "1346874137",[-102.5241828, 33.447471050000004]],
    [ "1346874139",[-102.4612407572772, 33.406783025422726]],
    [ "1346936810",[-84.36553011165766, 41.2856433081507]],
    [ "1346988663",[-102.32734075, 33.75036945]],
    [ "1346988665",[-102.33152810551876, 33.73907777528469]],
    [ "1346988670",[-102.33745957552324, 33.70811670632406]],
    [ "Empire Substation",[-111.6381453920177, 32.6745288239593]],
    [ "1347182538",[-81.51958487663926, 27.653064136134184]],
    [ "1347190123",[-110.59228233918849, 32.642978045166046]],
    [ "1347203046",[-96.53374618937109, 44.390016229861565]],
    [ "1347231198",[-84.39948982179455, 41.0197566266635]],
    [ "1347231199",[-84.27272485019705, 41.092260386524075]],
    [ "1347231207",[-84.1765971119864, 40.88137048040206]],
    [ "Monserate",[-117.1122868047718, 33.355906079842285]],
    [ "1347456630",[-86.01870518088916, 36.52680168579244]],
    [ "1347615449",[-84.91819353396328, 31.247192625267573]],
    [ "Tierra Blanca Substation",[-102.36249552649657, 34.81624664091823]],
    [ "1347689116",[-102.33969342438502, 34.835549095827574]],
    [ "1347689122",[-101.93780317339252, 34.99785121203616]],
    [ "1347705802",[-102.42431130990764, 34.83627342520487]],
    [ "1347712084",[-100.1380500767819, 35.442480836157316]],
    [ "Southwest Vernon Substation",[-99.29526817060622, 34.117238146436776]],
    [ "1347796181",[-96.80986769008616, 33.197389650563814]],
    [ "1347799313",[-91.41104565605849, 42.52389552869153]],
    [ "1347824321",[-97.33747979757261, 27.680141457059406]],
    [ "1347830397",[-95.34974263200526, 42.92026141700382]],
    [ "1347831012",[-95.36868119999998, 42.63464655]],
    [ "1347832200",[-95.14461178651295, 42.633153918901016]],
    [ "1347843193",[-102.16277985, 32.44875655]],
    [ "1347843194",[-102.16355392785586, 32.44994471344003]],
    [ "1347843201",[-102.14271323164257, 32.376973737971255]],
    [ "1347850700",[-102.18050366177103, 32.17640683441842]],
    [ "1347850705",[-102.16394059999999, 32.145250600000004]],
    [ "1347850707",[-102.16303966643227, 32.14459304140634]],
    [ "1347896089",[-80.68774295824272, 40.0340136223211]],
    [ "1347896117",[-80.58784985887952, 40.12187081873078]],
    [ "1347902252",[-102.24839219384401, 32.03604772541204]],
    [ "Midland East Substation",[-102.05164926686045, 32.02038296322424]],
    [ "1348151608",[-99.10748508867609, 38.559391674899096]],
    [ "1348204007",[-85.09836516068462, 31.27774932544007]],
    [ "1348406655",[-102.0251575223421, 32.00825913672939]],
    [ "1348406658",[-102.02618118783671, 32.01166637683738]],
    [ "1348406665",[-101.99847335674197, 31.914666121267246]],
    [ "1348407422",[-102.01431609066307, 31.95325043898019]],
    [ "1348407428",[-102.01126652033028, 31.939739840040026]],
    [ "Former Ocean View Substation",[-74.7346417240658, 39.176275560703495]],
    [ "1348579036",[-103.61754260340885, 34.98445251257414]],
    [ "1348583047",[-117.96605688191664, 46.32909325315312]],
    [ "1348637003",[-95.1202623, 43.14873125]],
    [ "1348637006",[-95.0519317421665, 43.083113976967354]],
    [ "1348637010",[-95.14134585797129, 43.12430267579513]],
    [ "1348698877",[-95.19587978716626, 43.14513887572828]],
    [ "1348698878",[-95.1978748, 43.14910679999999]],
    [ "1348698879",[-95.19752247248005, 43.148959105532384]],
    [ "1348704059",[-95.32357943152712, 43.451955191980076]],
    [ "1348704061",[-95.64410006659155, 43.40403781674303]],
    [ "1348704065",[-95.65804851939046, 43.40417798733409]],
    [ "1348704067",[-95.77357955, 43.573019599999995]],
    [ "1348742604",[-93.59521907519168, 41.647805354541]],
    [ "Kirley Substation",[-101.33730437254886, 44.530745175113786]],
    [ "Cherry Creek Substation",[-101.49104539505996, 44.60415403315944]],
    [ "Takini Substation",[-101.84271895, 44.64640715000001]],
    [ "Dupree Substation",[-101.5890157923864, 45.04946175619787]],
    [ "Isabel Substation",[-101.41887262267147, 45.3997095248916]],
    [ "Timber Lake Substation",[-101.08944322480804, 45.44305854141482]],
    [ "Little Eagle Substation",[-100.80919417713935, 45.67548239238884]],
    [ "Trail City Substation",[-100.74169377565593, 45.472924674877675]],
    [ "Mason Public Utility District #3",[-123.08923789338746, 47.1427381105384]],
    [ "PPL",[-76.45970714999999, 41.013232149999986]],
    [ "Glen Brook Substation",[-76.20909445503212, 41.105841849990206]],
    [ "1350437811",[-95.13555570286827, 29.71232189205973]],
    [ "1350503758",[-99.26844385509769, 27.628730890748447]],
    [ "1350505623",[-99.40086461077809, 27.11026626506648]],
    [ "1350547490",[-100.83199693154206, 32.530692992212934]],
    [ "1350547496",[-100.83199647342241, 32.529764746856486]],
    [ "1350750886",[-101.80339077075094, 31.519815142153224]],
    [ "1350767226",[-102.1185979, 31.825133400000002]],
    [ "1350767228",[-102.11854367919183, 31.824425906228562]],
    [ "1350767232",[-102.19125608835796, 31.83329490049211]],
    [ "1350767234",[-102.32354042063565, 31.856678095679833]],
    [ "Milltown Electrical Substation",[-74.43514333078811, 40.45318155551212]],
    [ "1351094007",[-74.55333761093767, 40.51534422958168]],
    [ "Mason Public Utility District",[-123.26936621918043, 47.23362094885177]],
    [ "Mason Public Utility District",[-123.07015182447009, 47.24760104226256]],
    [ "Mason Public Utility District",[-123.09327895986448, 47.33563888113821]],
    [ "1351845840",[-110.36646274908291, 41.72155637006021]],
    [ "Shaddick Substation",[-83.15675295478474, 42.34017605214158]],
    [ "Parkston Substation",[-98.03384832545979, 43.38464881004059]],
    [ "Hillside Substation",[-98.22962500297025, 43.41342860920153]],
    [ "1352358854",[-120.34169316368876, 36.42934501457693]],
    [ "1352413490",[-97.35707783889637, 30.416040640789024]],
    [ "1352413493",[-97.35634805398647, 30.414807756304057]],
    [ "1352413497",[-97.3527807033531, 30.46948641877702]],
    [ "1352416603",[-97.46317572833085, 30.54541819469751]],
    [ "1352421448",[-97.18093651211478, 31.511467413333634]],
    [ "1352421453",[-97.18209845302734, 31.510178133038227]],
    [ "1352529349",[-92.8106358332916, 43.279406075002605]],
    [ "1352529354",[-92.8796179131515, 43.25466562270549]],
    [ "NJ Transit Morrisville Switching Substation",[-74.78632707037427, 40.19583733093037]],
    [ "1352537092",[-93.23999137486052, 43.16666445621261]],
    [ "1352537106",[-93.27590454287596, 43.13751041038015]],
    [ "1352576333",[-93.77654925160311, 42.10585168379814]],
    [ "1352579856",[-93.59319422219575, 42.071286777604634]],
    [ "1352594683",[-93.62563434728857, 42.05745146282567]],
    [ "1352735503",[-97.35804574244386, 31.973712853729268]],
    [ "1352735509",[-97.315367890755, 32.226982162660775]],
    [ "1352738313",[-97.2919108, 32.28340775000001]],
    [ "1352738316",[-97.30195771758756, 32.286462024248145]],
    [ "1352752444",[-122.51554144999999, 47.15610935]],
    [ "1352808062",[-97.37385571995509, 32.15330311209187]],
    [ "Puget Sound Energy",[-122.90251624999999, 47.0140947]],
    [ "Hamtramck Substation",[-83.04607652073277, 42.385608161863374]],
    [ "1353124301",[-123.2708613, 47.05436860000001]],
    [ "1353154405",[-123.7977482, 46.96940155]],
    [ "1353154626",[-124.0825097251328, 46.7650491459121]],
    [ "1353185369",[-123.88157362969729, 47.00324720227967]],
    [ "1353185372",[-123.80830555833175, 47.11681976341332]],
    [ "1353185375",[-123.91973625623531, 47.02477901788323]],
    [ "1353235537",[-123.91631251597015, 47.26914179904941]],
    [ "1353235538",[-123.87646383948814, 47.44876144018975]],
    [ "1353274359",[-94.41743746050543, 42.31099587489507]],
    [ "1353274361",[-94.39778512510294, 42.31087295540976]],
    [ "1353274362",[-94.53372882481706, 42.34660169362781]],
    [ "1353374222",[-124.07279738493722, 47.10928523070967]],
    [ "1353374224",[-124.20823627547544, 47.236747607184945]],
    [ "Port Angeles Light",[-123.44110998725495, 48.120319771200016]],
    [ "Thunder Hawk Substation",[-101.97502562473636, 45.9342658567242]],
    [ "Liberty Substation",[-123.41671842865765, 48.1027150945152]],
    [ "Ferndale Substation",[-83.14431633553802, 42.46013411815754]],
    [ "Southfield Substation",[-83.31794894090434, 42.48654936211388]],
    [ "Angola Substation",[-83.2598360096183, 42.47930617451298]],
    [ "Ford Engineering Center",[-83.2318609579659, 42.29795831822966]],
    [ "Aurora County Wind, LLC",[-98.76408172502349, 43.73137974503769]],
    [ "NorthWestern Energy",[-98.76346770846779, 43.73126967816348]],
    [ "NorthWestern Energy",[-98.91531238369464, 43.73098355010472]],
    [ "Brule County Wind, LLC",[-98.91588679594665, 43.731110322202206]],
    [ "NorthWestern Energy",[-98.9585061284753, 43.74954912469463]],
    [ "Gramer Substation",[-82.81630227942642, 42.78205530199221]],
    [ "East River Electric Power Cooperative",[-96.94972712266816, 42.829645724807634]],
    [ "1354181386",[-92.94718615, 43.0512704]],
    [ "1354181530",[-92.92684843928095, 42.92233497501907]],
    [ "1354183857",[-93.39819035477984, 42.80574529778314]],
    [ "1354183859",[-93.43942597511622, 42.746201393880774]],
    [ "1354183865",[-93.71441737569216, 42.7971452564691]],
    [ "1354254194",[-97.27135482517602, 43.43708115742766]],
    [ "East River Electric Power Cooperative",[-97.23933908625355, 43.5729703310811]],
    [ "1354284638",[-111.96900980641566, 33.44004096785408]],
    [ "Saginaw Switching Station",[-97.32427536978705, 32.82179105373443]],
    [ "1354294355",[-97.16183311059278, 32.75700937008185]],
    [ "Salem Substation",[-97.37878784999998, 43.71654804999999]],
    [ "1354299305",[-97.09651453134849, 32.818905495861614]],
    [ "1354300696",[-94.97312311412819, 43.414339815089775]],
    [ "1354300699",[-94.96183736608675, 43.43093073279813]],
    [ "1354311495",[-97.33453161720296, 32.761360199132014]],
    [ "1354396349",[-98.1548779662133, 44.421332875362026]],
    [ "Willow Lake Substation",[-97.71601559999999, 44.65969495]],
    [ "East River Electric Power Cooperative",[-97.35050709106383, 44.65977507522554]],
    [ "1354470954",[-97.41103146238703, 33.03909141945653]],
    [ "1354524054",[-97.46940074680474, 32.90927333559294]],
    [ "1354524056",[-97.46789314015736, 32.908232140715356]],
    [ "1354536089",[-96.9172524, 32.97165575000001]],
    [ "Polecat Creek Substation",[-101.4822138048998, 31.994815834914952]],
    [ "Thompson Substation",-86.3224202],
    [ "Bonneville Power Administration",-113.5969727],
    [ "Bonneville Power Administration",-113.5977564],
    [ "Farragut Substation",-73.9826677],
    [ "Farragut Substation",-73.9841304],
    [ "892919235",-81.4658271],
    [ "City of Siloam Springs Electric Department",-94.5583854],
    [ "1114995825",-81.407914],
    [ "5839390517",[-122.3648136, 40.6806955]],
    [ "6050249353",[-122.4036381, 40.6242603]],
    [ "K06TP1 Fisher Ave TPSS",[-77.1777406, 38.8984521]],
    [ "N92TBS1 Baldwin Drive",[-77.1888304, 38.913763]],
    [ "N03 Greensboro TPSS5",[-77.2332343, 38.9203374]],
    [ "TPSS#3 -McLean",[-77.2107742, 38.9242285]],
    [ "TPSS#3 - McLean",[-77.2062734, 38.9268822]],
    [ "6222881956",[-122.4024836, 40.6242431]],
    [ "6401838706",[-122.362328, 40.6554845]],
    [ "6401838708",[-122.363438, 40.6558105]],
    [ "6401838717",[-122.36504, 40.655318]],
    [ "6401882568",[-122.364732, 40.6568052]],
    [ "6401882573",[-122.363915, 40.657301]],
    [ "6401882581",[-122.364198, 40.6584042]],
    [ "6401930904",[-122.368314, 40.6597686]],
    [ "6401930917",[-122.368579, 40.6584847]],
    [ "6401946112",[-122.367991, 40.6577649]],
    [ "6594065587",[-122.368787, 40.6560619]],
    [ "6594065589",[-122.36743, 40.6551692]],
    [ "6694493444",[-122.392786, 40.5962601]],
    [ "6694493445",[-122.393026, 40.5962899]],
    [ "6694493447",[-122.393724, 40.5964986]],
    [ "6694493449",[-122.394446, 40.5966859]],
    [ "6694493452",[-122.394981, 40.5968339]],
    [ "6694493453",[-122.3952708, 40.5968995]],
    [ "6694493455",[-122.3959821, 40.5969387]],
    [ "6694594683",[-122.4000812, 40.5966711]],
    [ "6698150691",[-122.4062593, 40.5943909]],
    [ "6698164000",[-122.4095628, 40.5961671]],
    [ "6698164018",[-122.4084947, 40.5963849]],
    [ "6698164034",[-122.4065471, 40.5952621]],
    [ "6698164037",[-122.404709, 40.5978867]],
    [ "6700528717",[-122.3859909, 40.5777829]],
    [ "6821741635",[-122.4040986, 40.5959228]],
    [ "6848968689",[-122.364852, 40.5684237]],
    [ "6872661099",[-122.387999, 40.5881383]],
    [ "6894396426",[-122.3578782, 40.6000113]],
    [ "6894847491",[-122.3577465, 40.5779663]],
    [ "6894847493",[-122.3576375, 40.5808361]],
    [ "6894847494",[-122.3574474, 40.5807551]],
    [ "6894931719",[-122.3829835, 40.6218875]],
    [ "6894931725",[-122.385549, 40.6243078]],
    [ "6894931727",[-122.3840698, 40.6244817]],
    [ "6913884260",[-122.3720172, 40.5765797]],
    [ "6913884262",[-122.3726964, 40.5754398]],
    [ "Redding Electric Utility",[-122.3743356, 40.574511]],
    [ "6913884267",[-122.3731889, 40.5738887]],
    [ "6986316438",[-122.4025103, 40.5965097]],
    [ "6986316440",[-122.4033685, 40.5979295]],
    [ "6986324505",[-122.4103537, 40.596571]],
    [ "6988493635",[-122.4035075, 40.5972097]],
    [ "7003626976",[-122.3553622, 40.5716018]],
    [ "7071826254",[-122.379476, 40.5736689]],
    [ "7079012203",[-122.401259, 40.5860761]],
    [ "7083325273",[-122.315276, 40.5364831]],
    [ "7083511981",[-122.317775, 40.5397482]],
    [ "7083578443",[-122.31727, 40.5404639]],
    [ "7085522219",[-122.318073, 40.5428993]],
    [ "7085593136",[-122.315458, 40.5443276]],
    [ "7144159921",[-122.4158837, 40.5777875]],
    [ "7144159942",[-122.4155696, 40.5803936]],
    [ "7144159943",[-122.4143895, 40.5829859]],
    [ "7144626168",[-122.4111216, 40.5947624]],
    [ "7157553649",[-122.3487814, 40.5956644]],
    [ "7157586632",[-122.3478858, 40.5931432]],
    [ "7157586645",[-122.3468159, 40.5926257]],
    [ "7157586646",[-122.3459757, 40.5922994]],
    [ "7157586647",[-122.3452693, 40.5918447]],
    [ "7189073161",[-122.325768, 40.557385]],
    [ "7189073163",[-122.323934, 40.5582569]],
    [ "7189073166",[-122.326693, 40.557192]],
    [ "7189073171",[-122.328775, 40.5573199]],
    [ "7189195283",[-122.332616, 40.557291]],
    [ "7189203102",[-122.334832, 40.5537061]],
    [ "7244282896",[-122.324993, 40.5583704]],
    [ "7244282913",[-122.332632, 40.5584394]],
    [ "7290057531",[-122.354259, 40.5856467]],
    [ "7311201687",[-122.3520886, 40.5755598]],
    [ "7321426889",[-122.3576716, 40.58025]],
    [ "7342373019",[-122.3429088, 40.5926564]],
    [ "7342373020",[-122.3425248, 40.5920662]],
    [ "7342384662",[-122.3462858, 40.5931716]],
    [ "7342384664",[-122.3471421, 40.5936265]],
    [ "7342384666",[-122.3478453, 40.5941377]],
    [ "7342384675",[-122.3488041, 40.5939351]],
    [ "7342384679",[-122.3488601, 40.5945644]],
    [ "7356800936",[-122.3506649, 40.571391]],
    [ "7359976775",[-122.3512096, 40.5732061]],
    [ "7359976776",[-122.3512847, 40.5731954]],
    [ "7359984991",[-122.3497872, 40.5713448]],
    [ "7360022232",[-122.3551784, 40.5778873]],
    [ "7360022233",[-122.356773, 40.5783305]],
    [ "Marshall Municipal Utilities",[-95.7659726, 44.4421215]],
    [ "Marshall Municipal Utilities",[-95.7656178, 44.4392938]],
    [ "Marshall Municipal Utilities",[-95.7659995, 44.4432502]],
    [ "Marshall Municipal Utilities",[-95.7946531, 44.4494995]],
    [ "Marshall Municipal Utilities",[-95.7930413, 44.4506894]],
    [ "Marshall Municipal Utilities",[-95.7923806, 44.4502657]],
    [ "Marshall Municipal Utilities",[-95.7660175, 44.4467972]],
    [ "Marshall Municipal Utilities",[-95.7660154, 44.4497067]],
    [ "Marshall Municipal Utilities",[-95.8067895, 44.4503829]],
    [ "Marshall Municipal Utilities",[-95.7857568, 44.442765]],
    [ "Marshall Municipal Utilities",[-95.7589591, 44.4516619]],
    [ "Marshall Municipal Utilities",[-95.8069742, 44.456553]],
    [ "Marshall Municipal Utilities",[-95.8068828, 44.4532681]],
    [ "Marshall Municipal Utilities",[-95.7623178, 44.4516559]],
    [ "Marshall Municipal Utilities",[-95.8063149, 44.4432399]],
    [ "Marshall Municipal Utilities",[-95.8062662, 44.4432395]],
    [ "Marshall Municipal Utilities",[-95.8163672, 44.4428772]],
    [ "Marshall Municipal Utilities",[-95.8163694, 44.4386663]],
    [ "Marshall Municipal Utilities",[-95.8163612, 44.4304428]],
    [ "Marshall Municipal Utilities",[-95.8063702, 44.4295938]],
    [ "Marshall Municipal Utilities",[-95.7655867, 44.4406622]],
    [ "Marshall Municipal Utilities",[-95.7814312, 44.4699686]],
    [ "Marshall Municipal Utilities",[-95.7854067, 44.4649497]],
    [ "Marshall Municipal Utilities",[-95.7864343, 44.4636298]],
    [ "Marshall Municipal Utilities",[-95.7877792, 44.4619431]],
    [ "Marshall Municipal Utilities",[-95.7888124, 44.4606799]],
    [ "Marshall Municipal Utilities",[-95.7827688, 44.4402293]],
    [ "Marshall Municipal Utilities",[-95.7899185, 44.4594407]],
    [ "Marshall Municipal Utilities",[-95.7921007, 44.4579023]],
    [ "Marshall Municipal Utilities",[-95.794899, 44.4523944]],
    [ "Marshall Municipal Utilities",[-95.7761142, 44.4513074]],
    [ "Marshall Municipal Utilities",[-95.7760612, 44.4513099]],
    [ "Marshall Municipal Utilities",[-95.7657043, 44.4359482]],
    [ "Marshall Municipal Utilities",[-95.7656792, 44.4334884]],
    [ "Marshall Municipal Utilities",[-95.765641, 44.4306292]],
    [ "Marshall Municipal Utilities",[-95.7545062, 44.4484007]],
    [ "Marshall Municipal Utilities",[-95.7990067, 44.4707687]],
    [ "Marshall Municipal Utilities",[-95.7962206, 44.4680644]],
    [ "8089877500",[-122.3508426, 40.5972736]],
    [ "8100434043",[-122.35471, 40.5928463]],
    [ "8100434046",[-122.3522904, 40.5927079]],
    [ "Marshall Municipal Utilities",[-95.8071453, 44.4588473]],
    [ "Marshall Municipal Utilities",[-95.7828846, 44.4595818]],
    [ "Marshall Municipal Utilities",[-95.7931254, 44.4546836]],
    [ "Marshall Municipal Utilities",[-95.7898057, 44.4649318]],
    [ "Marshall Municipal Utilities",[-95.800327, 44.4705272]],
    [ "Marshall Municipal Utilities",[-95.7759752, 44.4348475]],
    [ "Marshall Municipal Utilities",[-95.8030519, 44.4432165]],
    [ "Marshall Municipal Utilities",[-95.804439, 44.4432407]],
    [ "Marshall Municipal Utilities",[-95.7662432, 44.4516491]],
    [ "Marshall Municipal Utilities",[-95.7567401, 44.4483841]],
    [ "Marshall Municipal Utilities",[-95.7587777, 44.449602]],
    [ "Marshall Municipal Utilities",[-95.7498159, 44.4508386]],
    [ "Marshall Municipal Utilities",[-95.7533485, 44.4508202]],
    [ "Marshall Municipal Utilities",[-95.7740666, 44.4513067]],
    [ "Marshall Municipal Utilities",[-95.802038, 44.4431892]],
    [ "Marshall Municipal Utilities",[-95.8167278, 44.439178]],
    [ "Marshall Municipal Utilities",[-95.7864743, 44.4596323]],
    [ "Marshall Municipal Utilities",[-95.794922, 44.4649124]],
    [ "Marshall Municipal Utilities",[-95.7910117, 44.4712867]],
    [ "Marshall Municipal Utilities",[-95.7510465, 44.450825]],
    [ "Marshall Municipal Utilities",[-95.7713372, 44.4576565]],
    [ "Marshall Municipal Utilities",[-95.7693716, 44.4576614]],
    [ "Marshall Municipal Utilities",[-95.7720408, 44.4513164]],
    [ "Marshall Municipal Utilities",[-95.7660011, 44.4479945]],
    [ "Marshall Municipal Utilities",[-95.7770029, 44.4352822]],
    [ "Marshall Municipal Utilities",[-95.8007351, 44.463179]],
    [ "Marshall Municipal Utilities",[-95.8017528, 44.4665526]],
    [ "Brookings Muncipal Utilities",[-96.7684353, 44.3001181]],
    [ "Brookings Muncipal Utilities",[-96.7683699, 44.3071368]],
    [ "Brookings Muncipal Utilities",[-96.7684246, 44.3096926]],
    [ "8155893303",[-95.8047494, 44.4254208]],
    [ "8155939061",[-95.8178593, 44.3300597]],
    [ "Brookings Muncipal Utilities",[-96.7996612, 44.3064677]],
    [ "Brookings Muncipal Utilities",[-96.8035141, 44.3072826]],
    [ "Brookings Muncipal Utilities",[-96.8064195, 44.3076601]],
    [ "Brookings Muncipal Utilities",[-96.8088858, 44.3171648]],
    [ "Brookings Muncipal Utilities",[-96.8088098, 44.3233068]],
    [ "8262595311",[-122.3419373, 40.5920747]],
    [ "8280201515",[-122.370667, 40.5761853]],
    [ "8307509300",[-122.36806, 40.6568142]],
    [ "8307509305",[-122.366199, 40.6576253]],
    [ "8307673544",[-122.363444, 40.6567326]],
    [ "8307673548",[-122.365085, 40.6592338]],
    [ "8307888222",[-122.362618, 40.6576631]],
    [ "8322689929",[-122.3983822, 40.5852264]],
    [ "Redding Electric Utility",[-122.3963882, 40.5839896]],
    [ "8322906641",[-122.3983215, 40.5867525]],
    [ "8322906642",[-122.3978945, 40.5865151]],
    [ "8359188329",[-122.3488678, 40.5859324]],
    [ "Redding Electric Utility",[-122.372827, 40.5737022]],
    [ "8401375687",[-122.3743085, 40.5771135]],
    [ "8770725770",[-122.3525162, 40.5899356]],
    [ "8770725772",[-122.3519136, 40.5894196]],
    [ "8770726658",[-122.3564008, 40.5985688]],
    [ "8790892681",[-122.3869722, 40.5739553]],
    [ "8810953934",[-122.3586175, 40.5912097]],
    [ "8811022606",[-122.365166, 40.6560421]],
    [ "8811022607",[-122.366264, 40.6557627]],
    [ "8811022613",[-122.367269, 40.6602779]],
    [ "8811132632",[-122.366336, 40.6585088]],
    [ "8820484248",[-122.3835128, 40.5725104]],
    [ "8826227040",[-122.3805917, 40.5750062]],
    [ "8826227042",[-122.3801784, 40.5749083]],
    [ "8826227046",[-122.3809191, 40.5742893]],
    [ "8826227048",[-122.379748, 40.576249]],
    [ "8826384762",[-122.384972, 40.5997032]],
    [ "8844901261",[-122.3577369, 40.5716387]],
    [ "8844901299",[-122.3566276, 40.5777889]],
    [ "Redding Electric Utility",[-122.3545952, 40.5825394]],
    [ "Redding Electric Utility",[-122.3545963, 40.5825633]],
    [ "8848120463",[-122.3543225, 40.5780023]],
    [ "8848120464",[-122.3546411, 40.5783122]],
    [ "8848120466",[-122.3571258, 40.579731]],
    [ "8848120469",[-122.3718599, 40.5741747]],
    [ "8848120470",[-122.3729461, 40.574391]],
    [ "8848120474",[-122.3783, 40.5733534]],
    [ "8848120513",[-122.3781068, 40.5741164]],
    [ "8848138918",[-122.3868417, 40.573082]],
    [ "8863778780",[-122.3548637, 40.5761326]],
    [ "8863778785",[-122.3457709, 40.5886426]],
    [ "8863828379",[-122.3788104, 40.6091702]],
    [ "8863862600",[-122.3848775, 40.5841851]],
    [ "8863968445",[-122.3888185, 40.586661]],
    [ "Distributing Station 31",[-118.283028, 34.0341613]],
    [ "9662501205",[-83.2775653, 31.7225098]],
    [ "9667366078",[-84.2400925, 32.0065699]],
    [ "9667572589",[-84.107343, 32.2542049]],
    [ "9667572775",[-84.0754656, 32.4050697]],
    [ "9667949275",[-84.2292448, 32.0371443]],
    [ "9674353815",[-83.7334539, 32.4515265]],
    [ "9689407777",[-83.9971992, 33.6594156]],
    [ "9689407778",[-83.9971619, 33.6593887]],
    [ "Pactiv Substation",[-84.0368745, 33.6762754]],
    [ "9689407955",[-84.0422841, 33.6760653]],
    [ "Martin Marietta Substation",[-83.8887848, 33.6346711]],
    [ "9689408362",[-83.8445377, 33.6122307]],
    [ "9689408421",[-83.8349529, 33.6132485]],
    [ "9689408422",[-83.8349017, 33.6132888]],
    [ "9689408430",[-83.8343522, 33.6119625]],
    [ "9689408431",[-83.8343277, 33.6119257]],
    [ "9689616502",[-83.7027861, 33.6540699]],
    [ "9689616503",[-83.7020747, 33.654122]],
    [ "9689616504",[-83.7020747, 33.654077]],
    [ "9689616505",[-83.7009022, 33.6539822]],
    [ "9689616510",[-83.6976977, 33.653634]],
    [ "9689616511",[-83.6987023, 33.6537217]],
    [ "9689622019",[-83.6938188, 33.6534634]],
    [ "9689622020",[-83.6938217, 33.6535321]],
    [ "9689622021",[-83.6947124, 33.6535914]],
    [ "9689622022",[-83.6947238, 33.653544]],
    [ "9689622029",[-83.6966643, 33.6535787]],
    [ "9689622030",[-83.6967334, 33.6535915]],
    [ "9689622031",[-83.6989986, 33.6537449]],
    [ "9689622032",[-83.7003923, 33.6539398]],
    [ "Vulcan Materials Substation",[-83.0702805, 33.5382323]],
    [ "9701307443",[-85.04137, 34.0241451]],
    [ "9701307444",[-85.0414188, 34.0241234]],
    [ "9701307445",[-85.0414955, 34.0241104]],
    [ "9701307516",[-85.0477138, 34.0171261]],
    [ "9701307517",[-85.0477585, 34.0170969]],
    [ "9701307518",[-85.0477914, 34.0170598]],
    [ "9703986249",[-85.2794905, 34.0132805]],
    [ "9703986250",[-85.2794888, 34.0133305]],
    [ "9703986259",[-85.2813164, 34.0141702]],
    [ "9703986263",[-85.2813146, 34.0152545]],
    [ "9703986264",[-85.2813146, 34.0152143]],
    [ "9703986265",[-85.2813146, 34.0151689]],
    [ "9704725623",[-85.1769105, 34.2071033]],
    [ "9704725627",[-85.1759527, 34.2056099]],
    [ "9704725641",[-85.18215, 34.2218634]],
    [ "9706809992",[-84.17258, 33.0519488]],
    [ "9706853970",[-84.9663597, 34.5116032]],
    [ "9711998210",[-84.796337, 34.2203454]],
    [ "9711998211",[-84.7970205, 34.2193486]],
    [ "9711998212",[-84.7938268, 34.2188522]],
    [ "9712008656",[-84.7831878, 34.2455432]],
    [ "9718111434",[-84.9663792, 34.7289566]],
    [ "9718111435",[-84.9660825, 34.7288977]],
    [ "9718111436",[-84.9660807, 34.7289562]],
    [ "9718111437",[-84.9660866, 34.7290482]],
    [ "9718111438",[-84.9660809, 34.7290024]],
    [ "9718111492",[-84.9454923, 34.7304981]],
    [ "9718111493",[-84.9454923, 34.7304531]],
    [ "9718111505",[-84.9456088, 34.7349503]],
    [ "9718111506",[-84.9456101, 34.7349908]],
    [ "9718111507",[-84.9456101, 34.7350383]],
    [ "9718111508",[-84.9456077, 34.7350777]],
    [ "9718111510",[-84.9452541, 34.7333973]],
    [ "9718111511",[-84.9452555, 34.7334513]],
    [ "9718111512",[-84.945257, 34.733503]],
    [ "9718634144",[-85.392041, 34.4119321]],
    [ "9721954227",[-84.1817687, 31.2809919]],
    [ "9721954228",[-84.1817809, 31.280955]],
    [ "9721954229",[-84.1817969, 31.2809156]],
    [ "9724159839",[-84.2634926, 31.8972598]],
    [ "9730283167",[-84.2959356, 33.2358874]],
    [ "9730283172",[-84.2882057, 33.2280565]],
    [ "9730283182",[-84.283595, 33.2315887]],
    [ "9738685322",[-84.3263894, 34.4207865]],
    [ "9738685323",[-84.3268156, 34.4216309]],
    [ "9738685326",[-84.3285547, 34.4215447]],
    [ "9738707409",[-84.4003045, 34.4673132]],
    [ "9738707832",[-84.4867235, 34.6831946]],
    [ "9740731922",[-83.1041414, 34.4203241]],
    [ "9740731946",[-83.087021, 34.4538387]],
    [ "9740732112",[-82.9398556, 34.329314]],
    [ "9740732153",[-82.9685157, 34.3265054]],
    [ "9740732552",[-83.0965657, 34.4147396]],
    [ "9749115225",[-85.2736971, 33.7306397]],
    [ "9749115226",[-85.2725786, 33.732239]],
    [ "9749115227",[-85.2725627, 33.7322061]],
    [ "9749115229",[-85.2793577, 33.7349631]],
    [ "9753245230",[-122.316604, 40.5451785]],
    [ "9758556556",[-122.32131, 40.5499507]],
    [ "9849260336",[-83.711805, 42.2928519]],
    [ "9919465727",[-81.6452058, 34.7629431]],
    [ "10005478561",[-122.334509, 40.5366735]],
    [ "10297384376",[-122.3870008, 40.5790785]],
    [ "Redding Electric Utility",[-122.3338125, 40.593068]],
    [ "Redding Electric Utility",[-122.3348466, 40.5942373]],
    [ "Redding Electric Utility",[-122.3346316, 40.5930822]],
    [ "10573462305",[-122.34056, 40.5877563]],
    [ "Marshall Municipal Utilities",[-95.7817968, 44.4393954]],
    [ "Marshall Municipal Utilities",[-95.7809947, 44.438711]],
    [ "Marshall Municipal Utilities",[-95.7798112, 44.4377053]],
    [ "Marshall Municipal Utilities",[-95.7790808, 44.4370682]],
    [ "Marshall Municipal Utilities",[-95.7776224, 44.4358134]],
    [ "Marshall Municipal Utilities",[-95.7861948, 44.4357182]],
    [ "Marshall Municipal Utilities",[-95.7779774, 44.4366967]],
    [ "10759691407",[-85.7284367, 32.825175]],
    [ "10759691408",[-85.7245634, 32.8275316]],
    [ "10909366190",[-89.7705592, 30.2829717]],
    [ "10909366609",[-89.8295283, 30.3083573]],
    [ "10909366616",[-89.8287066, 30.3059119]],
    [ "10909366624",[-89.82746, 30.3024622]],
    [ "10909366810",[-89.8444264, 30.2723067]],
    [ "10909367233",[-90.0321703, 30.3780234]],
    [ "10911912615",[-89.6937798, 30.4584]],
    [ "10911912647",[-89.7543511, 30.3178877]],
    [ "10913753517",[-89.9645381, 30.4065852]],
    [ "CLECO",[-90.1839177, 30.4693606]],
    [ "CLECO",[-90.1847174, 30.4774283]],
    [ "10915550811",[-90.116022, 30.5127602]],
    [ "10936376366",[-92.0321678, 30.5819159]],
    [ "Tennessee Gas Pipeline Company, L.L.C.",[-92.8753984, 30.4356471]],
    [ "10943884641",[-91.5238435, 29.8037764]],
    [ "10943887256",[-91.4991936, 29.7911954]],
    [ "Enterprise Gas Processing, LLC",[-91.4458901, 29.7344542]],
    [ "Trunkline Gas Company, LLC",[-91.4539792, 29.7350827]],
    [ "10944133503",[-91.4730933, 29.6873305]],
    [ "10951766690",[-92.3778307, 30.3221911]],
    [ "10951767209",[-92.5302702, 30.4592833]],
    [ "10951767210",[-92.5303341, 30.4592833]],
    [ "10958886432",[-92.058137, 31.1052759]],
    [ "10961348192",[-92.4106805, 31.1397099]],
    [ "10962953720",[-92.4251556, 31.3758591]],
    [ "ANR Pipeline Company",[-92.2116755, 31.5279405]],
    [ "10963679406",[-92.4337221, 31.329913]],
    [ "Antoine Substation",[-93.4236117, 34.0371367]],
    [ "11216165022",[-92.8560913, 45.3933668]],
    [ "Marshall Municipal Utilities",[-95.7556276, 44.4577825]],
    [ "Marshall Municipal Utilities",[-95.7554504, 44.4647281]],
    [ "Marshall Municipal Utilities",[-95.7554797, 44.470611]],
    [ "11405400783",[-78.1850896, 39.1359156]],
    [ "11407063329",[-78.2923968, 38.9978007]],
    [ "11752704922",[-103.1238449, 48.5041966]],
    [ "Kissinger Junction Tap Point",[-79.5814818, 41.0377262]],
    [ "Franklin Tap Point",[-80.1035884, 41.5841225]],
    [ "Elm Street Tap Point",[-79.1424065, 41.8237376]],
    [ "Hillclay Junction Tap Point",[-78.8260286, 40.3047199]],
    [ "11906721644",[-90.5392106, 33.7524741]],
    [ "Peck Substation",[-101.8360271, 31.7848768]],
    [ "5th Street Substation",[-93.2710806, 44.9791849]],
    [ "12294347837",[-96.0787047, 44.0228827]],
    [ "12294347850",[-96.1149879, 44.0227582]],
    [ "12294347859",[-96.1187467, 44.022766]],
    [ "12294347868",[-96.0646024, 44.0358392]],
    [ "Hope Substation",[-94.1887779, 42.6745646]],
    [ "Tholen Interconnection Station",[-96.1246839, 44.115585]],
    [ "Boeve Interconnect Substation",[-96.0845181, 44.0515819]],
    [ "McBeth Interconnection Station",[-96.0918468, 44.0806957]],
    [ "JJN Wind Farm Interconnect Station",[-96.3918895, 44.2836663]],
    [ "12410145403",[-96.3929631, 44.2836529]],
    [ "12425973105",[-96.343511, 44.2837767]]
];
